(function () {
    'use strict';

    angular
        .module('bluebookApp', [
            'ngStorage',
            // 'tmh.dynamicLocale',
            // 'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'ds.objectDiff',
            'udt',
            'datatables',
            'datatables.factory',
            'datatables.bootstrap',
            'datatables.colreorder',
            'datatables.columnfilter',

            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            // 'ui.grid',
            // 'ui.grid.autoResize',
            // 'ui.grid.selection',
            // 'ui.grid.exporter',
            'ui.checkbox',
            'ncy-angular-breadcrumb',
            'ui.toggle',
            'ui.select',
            'angularMoment',
            'nzToggle',
            'ng-pros.directive.autocomplete',
            'ngSanitize',
            'ui.mask',
            'rmDatepicker',
            'chart.js',
            'nvd3',
            'ngIdle',
            'ngAnimate',
            // 'ngToast', //Remove later
            'toastr',
            // 'ngLodash',
            'fancyboxplus',
            'angularBootstrapFileinput',
            'validation', 'validation.rule', 'app.validation.rule',
            'daterangepicker',
            'dndLists',
            'angular-toArrayFilter',
            'ui.pagination',
            'dialogs.main',
            'dialogs.default-translations',
            'uiCropper',
            'duScroll',
            'ods-lib',
            'mgo-angular-wizard',
            'ui.calendar',
            'xeditable',
            'rm2Datepicker',
            'datatables.buttons',
            'angularUtils.directives.dirPagination',
            // 'ngQuill',
            'credit-cards',
            'ui.validate',
            'angularResizable'
        ])
        .config(['$validationProvider', '$uibTooltipProvider', 'toastrConfig', 'cfpLoadingBarProvider',
            function ($validationProvider, $uibTooltipProvider, toastrConfig, cfpLoadingBarProvider) {
        // .config(['$validationProvider', '$uibTooltipProvider', 'toastrConfig', 'cfpLoadingBarProvider', 'ngQuillConfigProvider',
        //     function ($validationProvider, $uibTooltipProvider, toastrConfig, cfpLoadingBarProvider, ngQuillConfigProvider) {
                $uibTooltipProvider.options({appendToBody: true});
                // cfpLoadingBarProvider.includeBar = false;
                // cfpLoadingBarProvider.spinnerTemplate = '<div class="spinner-layer"><div class="spinner-rings"></div></div>';
                //---------- Toast config ---------------------------
                angular.extend(toastrConfig, {
                    allowHtml: true,
                    closeButton: true,
                    closeHtml: '<button>&times;</button>',
                    extendedTimeOut: 1000,
                    autoDismiss: false,
                    maxOpened: 5,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    messageClass: 'toast-message',
                    onHidden: null,
                    onShown: null,
                    onTap: null,
                    progressBar: true,
                    tapToDismiss: true,
                    newestOnTop: true,
                    positionClass: 'toast-bottom-right',
                    timeOut: 5000,
                    titleClass: 'toast-title',
                    toastClass: 'toast'
                });
                // Quill Config
                // ngQuillConfigProvider.set({
                //    modules: {
                //        toolbar: [
                //            [{ 'font': [] }],
                //            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                //            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                //            // ['blockquote'],
                //            [{ 'align': [] }],
                //            // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                //            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                //            [{ 'script': 'sub' }, { 'script': 'super' }],     // superscript/subscript
                //            [{ 'indent': '-1' }, { 'indent': '+1' }],         // outdent/indent
                //            //[{ 'direction': 'rtl' }],                         // text direction
                //
                //            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                //
                //            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                //
                //            //['clean'],                                         // remove formatting button
                //            //['link', 'image', 'video']                         // link and image, video
                //            ['link']                         // link and image, video
                //        ]
                //    },
                //     placeholder: 'Insert your text here...',
                //     scrollContainer: '.ql-editor'
                // });

                //----------- Validators config ---------------------------
                /**
                 * Setup a default messages
                 */
                var defaultMsgs = {
                    required: {
                        error: 'This field is required.',
                        success: ''
                    }
                };

                $validationProvider.setDefaultMsg(defaultMsgs);

                angular.extend($validationProvider, {
                    validCallback: function (element) {
                        //$(element).closest('div.form-group').find('label.has-error').hide();
                        $(element).parents('.form-group:first').removeClass('has-error');
                    },
                    invalidCallback: function (element) {
                        //Add has-error to the first form group
                        $(element).parents('.form-group:first').addClass('has-error');
                    },
                    resetCallback: function (element) {
                        //Add has-error to the first form group
                        $(element).parents('.form-group:first').removeClass('has-error');
                    }

                });

                $validationProvider.setErrorHTML(function (msg) {
                    return '<p class="control-label pull-left has-error">' + msg + '</p>';
                });
                $validationProvider.showSuccessMessage = false;
                //-------------------------------------------------------

            }])
        .run(run);

    run.$inject = ['stateHandler', '$rootScope', 'ProfileService', 'ROLES', 'SystemService', 'DYMO', 'EmployeeMenu', '$window'];

    function run(stateHandler, $rootScope, ProfileService, ROLES, SystemService, DYMO, EmployeeMenu, $window) {
        stateHandler.initialize();

        $rootScope.inputDateFormat = "MM/dd/yyyy";
        $rootScope.inputDateTimeFormat = "MM/dd/yyyy hh:mm";
        $rootScope.inputDateTimeFormatA = "MM/dd/yyyy hh:mm a";
        $rootScope.amDateFormat = "MM/DD/YYYY hh:mm A";
        $rootScope.dateFormat = "MM/DD/YYYY";
        $rootScope.timeFormat = "hh:mm";
        $rootScope.timeFormatA = "hh:mm a";

        $rootScope.ROLES = ROLES;

        // clipboard assistant
        $rootScope.showAssitant = false;
        $rootScope.assistantList = [];

        // new chart
        $rootScope.showNewChart = false;

        //Get running profile
        ProfileService.getProfileInfo().then(function (response) {
            $rootScope.inProduction = response.inProduction;
            // vm.swaggerEnabled = response.swaggerEnabled;
        });

        SystemService.appData().$promise.then(function (response) {
            $rootScope.appData = response;

            setInterval(checkVersion, 300000);
        });

        $rootScope.employeeMenu = {
            menu: {
                careCoordination: {name: 'Care Coordination', value: true},
                diagnoses: {name: 'Diagnoses', value: true},
                careTeam: {name: 'Care Team', value: true},
                allergies: {name: 'Allergies', value: true},
                diet: {name: 'Diet', value: true},
                insurance: {name: 'Insurance', value: true},
                contacts: {name: 'Contacts', value: true},
                cReviews: {name: 'Concurrent Reviews', value: true},
                patientMeds: {name: 'Medications', value: true},
                orders: {name: 'Orders', value: true},
                //mars: {name: 'MARs', value: true},
                evaluation: {name: 'Care & Delivery', value: true},
                vitals: {name: 'Vitals', value: true},
                glucose: {name: 'Glucose', value: true},
                weight: {name: 'Weight', value: true},
                gSessions: {name: 'Group Sessions', value: true},
                eLabs: {name: 'ELabs', value: true},
                notes: {name: 'Notes', value: true},
                drugs: {name: 'Drugs & Alcohol', value: true},
                verificationBenefits: {name: 'Verification of Benefits', value: true},
                files: {name: 'Files', value: true}
            }
        };

        DYMO.loadPrinters();

        function checkVersion() {
            SystemService.appData().$promise.then(function (response) {
                if (response.version != $rootScope.appData.version || response.build != $rootScope.appData.build) {
                    $window.location.reload();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'},
            'checkBrowser': {
                url: 'api/users/check-browser/:browserUuid', method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return {result: data};
                }
            },
            'sendSmsCode': {
                url: 'api/users/send-sms-code/:browserUuid', method: 'GET'
            },
            'verifyCode': {
                url: 'api/users/verify-code/', method: 'POST'
            },
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('AdminLTEService', AdminLTEService);

    function AdminLTEService() {

        var service = {
            registerTreeActions : registerTreeActions,
            registerPushMenuActions: registerPushMenuActions,
            registerBoxWidget: registerBoxWidget,
            registerControlSidebar: registerControlSidebar,
            registerICheckWidget: registerICheckWidget,
            layoutFix: layoutFix
        };

        return service;

        function registerTreeActions(menu) {

            $.AdminLTE.tree(menu);
        }

        function registerPushMenuActions(toggleBtn) {

            $.AdminLTE.pushMenu.activate(toggleBtn);
        }

        function registerBoxWidget() {

            $.AdminLTE.boxWidget.activate();
        }

        function registerControlSidebar() {

            $.AdminLTE.controlSidebar.activate();
        }

        function registerICheckWidget() {

            //iCheck for checkbox and radio inputs
            $('input[type="checkbox"].minimal, input[type="radio"].minimal').iCheck({
                checkboxClass: 'icheckbox_minimal-blue',
                radioClass: 'iradio_minimal-blue'
            });
            //Red color scheme for iCheck
            $('input[type="checkbox"].minimal-red, input[type="radio"].minimal-red').iCheck({
                checkboxClass: 'icheckbox_minimal-red',
                radioClass: 'iradio_minimal-red'
            });
            //Flat red color scheme for iCheck
            $('input[type="checkbox"].flat-red, input[type="radio"].flat-red').iCheck({
                checkboxClass: 'icheckbox_flat-green',
                radioClass: 'iradio_flat-green'
            });
        }

        function layoutFix() {
            $.AdminLTE.layout.activate();
        }
    }
})();

/**
 * Created by PpTMUnited on 5/15/2017.
 */
(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SystemService', SystemService);

    SystemService.$inject = ['$resource'];

    function SystemService($resource) {
        var resourceUrl = 'system/:id';

        return $resource(resourceUrl, {}, {
            'appData': {url: 'api/app-data', method: 'GET'},
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PdfPrint', PdfPrint);

    PdfPrint.$inject = ['moment', '$rootScope'];

    function PdfPrint(moment, $rootScope) {

        var service = {
            groupSessionPatient: groupSessionPatient
        };

        return service;

        function groupSessionPatient(data, chart) {
            var dd = {
                content: [
                    {text: 'Group Session Details', style: 'header', margin: 5},
                    {text: 'Basic Information: ', style: 'subheader', margin: 5},

                    {text: 'Patient: ', bold: true, margin: 5},
                    {text: chart.lastName + ', ' + chart.firstName + (chart.middleName ? " " + chart.middleName[0] : '') , margin: 5},

                    {text: 'DOB: ', bold: true, margin: 5},
                    {text: moment(chart.dateBirth).format($rootScope.dateFormat) , margin: 5},

                    {text: 'MRN: ', bold: true, margin: 5},
                    {text: chart.mrNo , margin: 5},

                    {text: 'Title: ', bold: true, margin: 5},
                    {text: data.title?data.title:'-', margin: 5},

                    {
                        columns: [
                            [
                                {text: 'Date Started: ', bold: true, margin: 5},
                                {
                                    columns: [
                                        {text: data.startDate?moment(data.startDate).format("MM/DD/YYYY"):'-', margin: 5}
                                    ]
                                }
                            ],
                            [
                                {text: 'Start Time: ', bold: true, margin: 5},
                                {
                                    columns: [
                                        {text: data.start?moment(data.start).format("HH:mm"):'-', margin: 5}
                                    ]
                                }
                            ],
                            [
                                {text: 'End Time: ', bold: true, margin: 5},
                                {
                                    columns: [
                                        {text: data.stop?moment(data.stop).format("HH:mm"):'-', margin: 5}
                                    ]
                                }
                            ]
                        ]
                    },

                    {text: 'Description: ', bold: true, margin: 5},
                    {text: data.description?data.description:'-', margin: 5},

                    {text: data.note?'Note: ':'', bold: true, margin: 5},
                    {text: data.note?data.note:'', margin: 5}


                    // {
                    //     columns: [
                    //         [
                    //             {text: 'Session Type: ', bold: true, margin: 5},
                    //             {
                    //                 columns: [
                    //                     {text: data.sessionType?data.sessionType.name:'-', margin: 5}
                    //                 ]
                    //             }
                    //         ],
                    //         [
                    //             {text: 'Date Started: ', bold: true, margin: 5},
                    //             {
                    //                 columns: [
                    //                     {text: data.startDate?moment(data.startDate).format("MM/DD/YYYY"):'-', margin: 5}
                    //                 ]
                    //             }
                    //         ]
                    //     ]
                    // },
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            var signature = [
                {text: 'Signatures', style: 'subheader'},
                {
                    columns: [
                        data.leaderSignature?([{
                            image: data.leaderSignature.signature,
                            width: 200
                        },
                            'Leader: ',
                            {text: data.leader.firstName +' '+ data.leader.lastName},
                            'Date: ',
                            {text: moment(data.leaderSignature.createdDate).format("MM/DD/YYYY HH:mm")}
                        ]):{},
                        data.reviewerSignature?([{
                            image: data.reviewerSignature.signature,
                            width: 200
                        },
                            'Reviewer: ',
                            {text: data.reviewer?(data.reviewer.firstName +' '+ data.reviewer.lastName):''},
                            'Date: ',
                            {text: moment(data.reviewerSignature.createdDate).format("MM/DD/YYYY HH:mm")}
                        ]):{}
                    ]
                }];

            /* Don't remove, maybe the bosses pee and change their minds*/

            // var employees = [
            //     {text: 'Employees', style: 'subheader'},
            //     {
            //         style: 'tableExample',
            //         table: {
            //             body: []
            //         }
            //     }];
            // employees[1].table.body.push(['First Name', 'Last Name', 'Phone Number', 'Email']);
            // data.employees.forEach(function (item) {
            //     if(item) {
            //         var element = [
            //             {text: item.firstName?item.firstName:'-'},
            //             {text: item.lastName?item.lastName:'-'},
            //             {text: item.mobile?item.mobile:'-'},
            //             {text: item.email?item.email:'-'}
            //         ];
            //         employees[1].table.body.push(element);
            //     }
            // });
            // dd.content.push(employees);
            dd.content.push(signature);

            return dd;
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/26/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('PopupService', PopupService);

    PopupService.$inject = ['$uibModal', 'CoreService'];

    function PopupService($uibModal, CoreService) {

        var service = {
            showCreatePatientPopup: showCreatePatientPopup,
            showPatientMedicationsDetailsPopup: showPatientMedicationsDetailsPopup,
            showPatientOrderDetailsPopup: showPatientOrderDetailsPopup,
            showDiagnosesEditPopup: showDiagnosesEditPopup,
            showDiagnosesAddPopup: showDiagnosesAddPopup,
            showSignaturePopup: showSignaturePopup,
            showPatientMedicationDiscontinueWizardPopup: showPatientMedicationDiscontinueWizardPopup,
            showContactAddressPickupPopup: showContactAddressPickupPopup,
            showPatientSignaturePopup: showPatientSignaturePopup,
            showNotingPopup: showNotingPopup,
            showPatientMedicationPopup: showPatientMedicationPopup,
            showEvaluationPatientMedicationPopup: showEvaluationPatientMedicationPopup,
            showGlucosePopup: showGlucosePopup,
            showContactPopup: showContactPopup,
            showDiagnosesDiscontinuePopup: showDiagnosesDiscontinuePopup,
            showLabRequisitionDetailPopup: showLabRequisitionDetailPopup,
            showCropImageChartPopup: showCropImageChartPopup,
            showCropImageFrontInsurancePopup: showCropImageFrontInsurancePopup,
            showCropImageBackInsurancePopup: showCropImageBackInsurancePopup,
            showCropImageLicensePopup: showCropImageLicensePopup,
            checkSigPlusExtLiteExtension: checkSigPlusExtLiteExtension,
            showSelectChartPopup: showSelectChartPopup,
            showSelectLaboratoryPopup: showSelectLaboratoryPopup,
            showSelectFacilityLabPopup: showSelectFacilityLabPopup,
            showPatientResultDet: showPatientResultDet,
            showDeleteConfirmation: showDeleteConfirmation
        };

        return service;

        function showCreatePatientPopup(copyChart, copyFacility) {
            return $uibModal.open({
                templateUrl: 'app/entities/chart/create/chart-create-dialog.html',
                controller: 'ChartCreateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            oneTimeOnly: false,
                            sobrietyDate: null,
                            phone: null,
                            altPhone: null,
                            email: null,
                            address: null,
                            addressTwo: null,
                            city: null,
                            zip: null,
                            livingArrangement: null,
                            referrerRequired: null,
                            admissionDate: new Date(),
                            dischargeDate: null,
                            employees: null,
                            repName: null,
                            facility: copyFacility ? copyFacility : CoreService.getCurrentFacility(),
                            status: 'WAITING',
                            occupancy: null,
                            employer: null,
                            employerPhone: null,
                            referrerRequiredContact: false,
                            dateFirstContact: null,
                            firstContactName: null,
                            firstContactRelationship: null,
                            firstContactPhone: null,
                            wayLiving: null,
                            typePaymentMethods: null,
                            patientLicenseOriginalId: null,
                            patientLicenseId: null,
                            pictureRefId: null,
                            pictureRefOriginalId: null,
                            firstName: null,
                            middleName: null,
                            lastName: null,
                            preferredName: null,
                            gender: null,
                            race: null,
                            social: null,
                            dateBirth: null,
                            patient: {},
                            typeEthnicity: null,
                            allowReadmit: true,
                            readmitReason: null,
                            defaultPharmacy: null
                        };
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return copyFacility ? copyFacility : CoreService.getCurrentFacility();
                    }],
                    filter: function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dob: null,
                            social: null,
                            preferredName: null,
                            middleName: null
                        };
                    },
                    copyChart: copyChart,
                }
            });
        }

        function showPatientMedicationsDetailsPopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication/detail/patient-medication-dialog.html',
                controller: 'PatientMedicationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientMedication: ['PatientMedication', function (PatientMedication) {
                        return PatientMedication.get({id: id}).$promise;
                    }],
                    signAuthorities: ['BusinessCredential', 'BUSINESS_ROLES', 'CoreService', function (BusinessCredential, BUSINESS_ROLES, CoreService) {
                        return BusinessCredential.getCredentialByRole({
                            businessRole: BUSINESS_ROLES.PHYSICIAN, id: CoreService.getCurrentFacility().id
                        }).$promise;
                    }]
                }
            });
        }

        function showPatientOrderDetailsPopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-order/detail/patient-order-detail.html',
                controller: 'PatientOrderChartDetailController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientOrder: ['$stateParams', 'PatientOrder', function ($stateParams, PatientOrder) {
                        return PatientOrder.get({id: id}).$promise;
                    }]
                }
            });
        }

        function showDiagnosesEditPopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/diagnoses/update/diagnoses-dialog.html',
                controller: 'DiagnosesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Diagnoses', function (Diagnoses) {
                        return Diagnoses.get({id: id}).$promise;
                    }]
                }
            });
        }

        function showDiagnosesAddPopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/diagnoses/create/diagnoses-create-dialog.html',
                controller: 'DiagnosesCreateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: id}).$promise;
                    }],
                    entity: {
                        comment: null,
                        endDate: null,
                        startDate: null,
                        chart: null
                    }
                }
            });
        }

        function showSignaturePopup() {
            return $uibModal.open({
                templateUrl: 'app/components/udt/signature/signature-dialog.html',
                controller: 'SignatureDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            });
        }

        function showPatientMedicationDiscontinueWizardPopup() {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication/chart/discontinue/patient-medication-discontinue-wizard-dialog.html',
                controller: 'PatientMedicationDiscontinueWizardController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.PHYSICIAN
                        }).$promise;
                    }]
                }
            });
        }

        function showContactAddressPickupPopup() {
            return $uibModal.open({
                templateUrl: 'app/entities/contact-address/pickup/contact-address-pickup-dialog.html',
                controller: 'ContactAddressPickupDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
            });
        }

        function showPatientSignaturePopup(chart) {
            return $uibModal.open({
                templateUrl: 'app/components/udt/signature/signature-patient-dialog.html',
                controller: 'SignaturePatientDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            });
        }

        function showNotingPopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication/mars/noting/list/noting-dialog.html',
                controller: 'NotingController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    filter: ['CoreService', function (CoreService) {

                        return {
                            orderBy: null,
                            facilityId: CoreService.getCurrentFacility().id,
                            chartId: id ? id : null
                        }
                    }]
                }
            });
        }

        function showPatientMedicationPopup(chart, admissionMedications, patientMedicationId) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication/create/patient-medication-chart2-dialog.html',
                controller: 'PatientMedicationChart2DialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart,
                    admissionMedications: {ids: admissionMedications},
                    patientMedication: ['PatientMedication', function (PatientMedication) {
                        if (patientMedicationId) {
                            return PatientMedication.get({id: patientMedicationId}).$promise;
                        } else {
                            return null;
                        }

                    }],
                    evaluation: null,
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.PHYSICIAN
                        }).$promise;
                    }]
                }
            });
        }

        function showEvaluationPatientMedicationPopup(evaluation) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication/create/patient-medication-chart2-dialog.html',
                controller: 'PatientMedicationChart2DialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: evaluation.chart,
                    admissionMedications: null,
                    patientMedication: null,
                    evaluation: evaluation,
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.PHYSICIAN
                        }).$promise;
                    }]
                }
            });
        }

        function showGlucosePopup(chart) {
            return $uibModal.open({
                templateUrl: 'app/entities/glucose/update/glucose-dialog.html',
                controller: 'GlucoseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            id: null,
                            chart: chart,
                            date: new Date()
                        }
                    }
                }
            });
        }

        function showContactPopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/contacts/update/contacts-dialog.html',
                controller: 'ContactsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Contacts', function (Contacts) {
                        return Contacts.get({id: id}).$promise;
                    }]
                }
            })
        }

        function showDiagnosesDiscontinuePopup(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/diagnoses/discontinue/diagnoses-discontinue-dialog.html',
                controller: 'DiagnosesDiscontinueDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Diagnoses', function (Diagnoses) {
                        return Diagnoses.get({id: id}).$promise;
                    }]
                }
            });
        }

        function showLabRequisitionDetailPopup(patientOrderId, barcode, date) {

            return $uibModal.open({
                templateUrl: 'app/entities/patient-order/lab-requisition/detail/lab-requisition-detail.html',
                controller: 'LabRequisitionDetailController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientOrder: ['PatientOrder', function (PatientOrder) {

                        return patientOrderId ? PatientOrder.get({id: patientOrderId}).$promise :
                            PatientOrder.getByBarcode({barcode: barcode}).$promise;
                    }],
                    barcode: {
                        barcode: barcode,
                        date: date
                    }
                    // chart: ['Chart', function (Chart) {
                    //     return Chart.get({id: chartId}).$promise;
                    // }],
                    // values: {
                    //     facilityId: vm.facility.id,
                    //     chartId: chartId,
                    //     date: vm.date,
                    //     physicianId: physicianId,
                    //     barcode: barcode == "null" ? null : barcode,
                    //     itemStatus: itemStatus
                    // },
                    // date: [function () {
                    //     return vm.date;
                    // }],
                    // barcode: [function () {
                    //     return barcode;
                    // }],
                    // insurances: ['Insurance', function (Insurance) {
                    //     return Insurance.findAllByChart({id: chartId});
                    // }]
                }
            });
        }

        function showCropImagePopup(image, defaultImage, cropType) {

            return $uibModal.open({
                templateUrl: 'app/components/udt/udt-crop-image/udt-crop-image-dialog.html',
                controller: 'UdtCropImageDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    image: image ? image : {image: ""},
                    defaultImage: defaultImage,
                    cropType: function () {
                        return cropType;
                    }
                }
            });
        }

        function showCropImageChartPopup(image) {
            var imageDefault = null;
            var cropType = "square";

            return showCropImagePopup(image, imageDefault, cropType);
        }

        function showCropImageLicensePopup(image) {
            var imageDefault = null;
            var cropType = "rectangle";

            return showCropImagePopup(image, imageDefault, cropType);
        }

        function showCropImageFrontInsurancePopup(image) {
            var imageDefault = CoreService.insuranceFrontPictureDefault();
            var cropType = "rectangle";

            return showCropImagePopup(image, imageDefault, cropType);
        }

        function showCropImageBackInsurancePopup(image) {
            var imageDefault = CoreService.insuranceBackPictureDefault();
            var cropType = "rectangle";

            return showCropImagePopup(image, imageDefault, cropType);
        }

        function checkSigPlusExtLiteExtension() {

            return document.documentElement.getAttribute('SigPlusExtLiteExtension-installed');
        }

        function showSelectChartPopup() {
            return $uibModal.open({
                templateUrl: 'app/entities/chart/select-chart/select-chart-dialog.html',
                controller: 'SelectChartDialogController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
            });
        }

        function showSelectLaboratoryPopup() {
            return $uibModal.open({
                templateUrl: 'app/entities/laboratory/select/select-laboratory-dialog.html',
                controller: 'SelectLaboratoryDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
            })
        }

        function showSelectFacilityLabPopup() {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-lab/select/select-facility-lab-dialog.html',
                controller: 'SelectFacilityLabDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
            })
        }

        function showPatientResultDet(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-result-det/detail/patient-result-det.html',
                controller: 'PatientResultDetController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientResult: ['PatientResult', function (PatientResult) {
                        return PatientResult.get({id: id}).$promise;
                    }],
                    signature: ['PatientResult', function (PatientResult) {
                        return PatientResult.getSignature({id: id}).$promise
                    }],
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.SIGN_PATIENT_RESULT
                        }).$promise;
                    }]
                }
            });
        }

        function showDeleteConfirmation(entity) {
            return $uibModal.open({
                templateUrl: 'app/components/delete-entity-dialog/delete-entity-dialog.html',
                controller: 'DeleteEntityController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: {name: entity}
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('DYMO', DYMO);

    DYMO.$inject = ['Base64', 'moment'];

    function DYMO(Base64, moment) {
        var service = {
            loadPrinters: loadPrinters,
            printPatientOrderLabel: printPatientOrderLabel,
            testPatientLabel: testPatientLabel,
            printPatientBarcodes: printPatientBarcodes,
            setTemplate: setTemplate
       };

        return service;

        var printersSelect = '';
        var orderTemplate;

        function loadPrinters() {
            var printers = dymo.label.framework.getLabelWriterPrinters();
            if (printers.length == 0) {
                // alert("No DYMO printers are installed. Install DYMO printers.");
                return false;
            }

            for (var i = 0; i < printers.length; i++) {
                var printer = printers[i];

                var printerName = printer.name;
                printersSelect = printerName;
            }

            return true;
        }

        function printPatientOrderLabel(data) {
            orderTemplate.setObjectText('barcode', data.barcode);
            orderTemplate.setObjectText('name', data.name);
            orderTemplate.setObjectText('dob', moment(data.dob).format("MM/DD/YYYY"));
            orderTemplate.setObjectText('collectedDate', moment(data.collectedDate).format("MM/DD/YYYY"));
            orderTemplate.setObjectText('account', data.account ? data.account : "");
            if (data.tube) {
                orderTemplate.setObjectText('tube', data.tube);
                orderTemplate.setObjectText('tube_label', "Tube:");
            } else {
                orderTemplate.setObjectText('tube', "");
                orderTemplate.setObjectText('tube_label', "");
            }

            orderTemplate.print(printersSelect);
        }

        function testPatientLabel() {
            var template = orderTemplate;

            template.setObjectText('barcode', 'P000001');
            template.setObjectText('name', 'Jhon Doe');
            template.setObjectText('dob', moment(new Date()).format("MM/DD/YYYY"));
            template.setObjectText('collectedDate', moment(new Date()).format("MM/DD/YYYY"));
            template.setObjectText('tube', 'Some tube name');
            template.setObjectText('account', 'DXX001');

            template.print(printersSelect);
        }

        function printPatientBarcodes(result) {
            for (var l = 0; l < result.length; l++) {
                printPatientOrderLabel({
                    barcode: result[l].barcode,
                    name: result[l].patientName,
                    dob: result[l].dob,
                    collectedDate: result[l].date,
                    tube: result[l].tube,
                    account: result[l].account
                });
            }
        }

        function setTemplate(label) {
            if (label) {
                orderTemplate = dymo.label.framework.openLabelXml(label);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('DymoLabel', DymoLabel);

    DymoLabel.$inject = ['$resource', 'DYMO'];

    function DymoLabel($resource, DYMO) {
        var resourceUrl = 'api/DymoLabels/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                url: 'content/dymo/label.label',
                header: {'Content-Type': 'application/xml; charset=UTF-8'},
                transformResponse: function (data) {
                    if (data) {
                        DYMO.setTemplate(data);

                        return {
                            label: data
                        };
                    }

                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('DataTablesService', DataTablesService);

    DataTablesService.$inject = [];

    function DataTablesService() {

        var service = {
            toggleAll: toggleAll,
            toggleOne: toggleOne,
            getSelectedIds: getSelectedIds,
            setUniqueIds: setUniqueIds
        };

        return service;

        function toggleAll(selected, selectAll) {
            for (var id in selected) {
                if (selected.hasOwnProperty(id)) {
                    selected[id] = selectAll;
                }
            }
            getSelectedIds(selected)
        }

        function toggleOne(selected, selectAll) {
            for (var id in selected) {
                if (selected.hasOwnProperty(id)) {
                    if (!selected[id]) {
                        selectAll = false;
                        return;
                    }
                }
            }
            selectAll = true;
        }

        function getSelectedIds(selected) {
            var ids = [];

            for (var id in selected) {
                if (selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }

        function setUniqueIds(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].id = i;
            }

            return data;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CoreService', CoreService);

    CoreService.$inject = ['$state', '$cookies', '$sessionStorage', 'Base64', 'moment', '$rootScope', 'DataUtils',
        '$q', '$document', 'EmployeeMenu'];

    function CoreService($state, $cookies, $sessionStorage, Base64, moment, $rootScope, DataUtils,
                         $q, $document, EmployeeMenu) {


        var facilityField = {
            HIV: {
                SOBRIETY_DATE: false,
                BED: false,
                MARKETER: false,
                ADMISSION_REP: false
            }
        }

        var service = {
            byId: byId,
            isActive: isActive,
            isDischarge: isDischarge,
            sortListName: sortListName,
            isWaiting: isWaiting,
            actualFacility: actualFacility,
            redirectSearch: redirectSearch,
            redirectPatientDetails: redirectPatientDetails,
            patientAge: patientAge,
            greaterValue: greaterValue,
            toggle: toggle,
            setCurrentEmployee: setCurrentEmployee,
            getCurrentEmployee: getCurrentEmployee,
            getAvatar: getAvatar,
            setCurrentFacility: setCurrentFacility,
            getCurrentFacility: getCurrentFacility,
            getDays: getDays,
            setUnassignedBeds: setUnassignedBeds,
            getUnassignedBeds: getUnassignedBeds,
            parseToTime: parseToTime,
            parseToDate: parseToDate,
            parseToDateTime: parseToDateTime,
            getSelectedChart: getSelectedChart,
            setSelectedChart: setSelectedChart,
            setCorporation: setCorporation,
            getCorporation: getCorporation,
            countDatesBetween: countDatesBetween,
            attachment: attachment,
            splitByBackSlash: splitByBackSlash,
            generateUUID: generateUUID,
            getUUID: getUUID,
            // saveValidateCode: saveValidateCode,
            removeUUID: removeUUID,
            toLocalDate: toLocalDate,
            togglePanel: togglePanel,
            showPanel: showPanel,
            getEmployeeMenu: getEmployeeMenu,
            getFrequency: getFrequency,
            patientPictureDefault: patientPictureDefault,
            insuranceFrontPictureDefault: insuranceFrontPictureDefault,
            insuranceBackPictureDefault: insuranceBackPictureDefault,
            scrollToPosition: scrollToPosition,
            getEvaluationStatusClass: getEvaluationStatusClass,
            getEvaluationStatusLabelClass: getEvaluationStatusLabelClass,
            scheduleTakes: scheduleTakes,
            changeSchedule: changeSchedule,
            getPatientMedicationFilterStatus: getPatientMedicationFilterStatus,
            clearSession: clearSession,
            setStorage: setStorage,
            getStorage: getStorage,
            initBedSheetFilter: initBedSheetFilter,
            readBedSheetFromLocalStore: readBedSheetFromLocalStore,
            getFilterByFacility: getFilterByFacility,
            getGenericDelStatusFilter: getGenericDelStatusFilter,
            getFilterByCorporation: getFilterByCorporation,
            getFilterByCurrentCorporationAndType: getFilterByCurrentCorporationAndType,
            getFilterByCurrentCorporation: getFilterByCurrentCorporation,
            getChartFilter: getChartFilter,
            setChartFilter: setChartFilter,
            readCampaignOutreachFromLocalStore: readCampaignOutreachFromLocalStore,
            initCampaignOutreachFilter: initCampaignOutreachFilter,
            getHeightInchesToFeetInches: getHeightInchesToFeetInches,
            initCalendarFilter: initCalendarFilter,
            readCalendarFilterFromLocalStore: readCalendarFilterFromLocalStore,
            enableByFacilityType: enableByFacilityType,
            currentEmployeeHaveAnyCredential: currentEmployeeHaveAnyCredential,
            bytesToSize: bytesToSize
        };

        return service;

        function getStorage(attr) {
            return $sessionStorage[attr];
        }

        function setStorage(attr, value) {
            $sessionStorage[attr] = value;
        }

        function byId(id, list) {
            var i = 0;
            var finded = false;
            var value;
            while (!finded && i < list.length) {
                if (list[i].id == id) {
                    value = list[i];
                    finded = true;
                }
            }
            return value;
        }

        function isActive(data) {
            if (data) {
                try {
                    var value = data.status.toUpperCase();
                    if (value == 'ACT')
                        return true;
                    else
                        return false;
                } catch (e) {
                    console.log(e);
                }

            }
            return false;
        }

        function greaterValue(a, b) {
            if (a && b) {
                if (a >= b) {
                    return a
                } else if (a < b) {
                    return b;
                }
            } else
                return a;
        }

        function actualFacility(data) {
            if (data) {
                if (parseInt(localStorage.getItem('facid')) == data)
                    return true;
                else
                    return false;

            }
            return false;
        }

        function toggle(item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
            } else {
                list.push(item);
            }
        }

        function isDischarge(data) {
            var actualDate = moment(new Date()).format('YYYY-MM-DD');
            if (data > actualDate)
                return false
            else
                return true
        }

        function isWaiting(data) {
            if (data == 'yes')
                return true
            else
                return false
        }

        function patientAge(dateString) {
            var today = new Date();
            var birthDate = new Date(dateString);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        }

        function countDatesBetween(toDate, fromDate) {
            var magicNumber = (1000 * 60 * 60 * 24);
            if (toDate && fromDate) {
                var dayDiff = Math.floor((toDate - fromDate) / magicNumber);
                if (angular.isNumber(dayDiff)) {
                    return dayDiff + 1;
                }
            }
        }

        function redirectSearch() {
            $state.go('search')
        }

        function redirectPatientDetails(data) {
            if (data) {
                localStorage.setItem('patId', data.chart.patientId);
                localStorage.setItem('chart', data.chart.id);
                localStorage.setItem('bed', data.chart.bedId);
            }
            $state.go('patient-details');
        }

        function sortListName(data) {
            data.sort(function (a, b) {
                var key1 = a.name;
                var key2 = b.name;

                if (key1 < key2) {
                    return -1;
                } else if (key1 == key2) {
                    return 0;
                } else {
                    return 1;
                }
            });
        }

        /**
         * Set a employee to the session storage
         * @param employee
         */
        function setCurrentEmployee(currentEmployee) {
            if (currentEmployee) {
                $sessionStorage.currentEmployee = Base64.encode(JSON.stringify(currentEmployee));
            }
        }

        /**
         * Get current employee logged from the session storage
         */
        function getCurrentEmployee() {
            if ($sessionStorage.currentEmployee)
                return JSON.parse(Base64.decode($sessionStorage.currentEmployee));
            else
                return null
        }

        /**
         * Get random avatar by gender
         */
        function getAvatar(gender) {

            var maleAvatar = [
                'content/adminLTE/img/avatar.png',
                'content/adminLTE/img/avatar4.png',
                'content/adminLTE/img/avatar5.png'
            ];

            var femaleAvatar = [
                'content/adminLTE/img/avatar2.png',
                'content/adminLTE/img/avatar3.png'
            ];

            var ramdom = 0;
            if (gender == 'MALE') {
                ramdom = Math.floor((Math.random() * 3));
                return maleAvatar[ramdom];
            } else {
                ramdom = Math.floor((Math.random() * 2));
                return femaleAvatar[ramdom];
            }
        }

        /**
         * Set a facility to the session storage
         * @param facility
         */
        function setCurrentFacility(facility) {
            if (facility) {
                $sessionStorage.selectedFacility = Base64.encode(JSON.stringify(facility));
                $rootScope.$broadcast('bluebookApp:setCurrentFacility', facility);
            } else {
                $sessionStorage.selectedFacility = null;
            }
        }

        /**
         * Get current facility from the session storage
         */
        function getCurrentFacility() {
            if ($sessionStorage.selectedFacility) {
                return JSON.parse(Base64.decode($sessionStorage.selectedFacility));
            } else {
                return null;
            }
        }

        /**
         * Set a corporation to the session storage
         * @param corporation
         */
        function setCorporation(corporation) {
            if (corporation) {
                $sessionStorage.selectedCorporation = Base64.encode(JSON.stringify(corporation));
            } else {
                $sessionStorage.selectedCorporation = null;
            }
        }

        /**
         * Get the corporation from the session storage
         */
        function getCorporation() {
            if ($sessionStorage.selectedCorporation) {
                return JSON.parse(Base64.decode($sessionStorage.selectedCorporation));
            } else {
                return null;
            }
        }

        /**
         * Set a chart to the session storage
         * @param chart
         */
        function setSelectedChart(chart) {
            if (chart) {
                $sessionStorage.selectedChart = Base64.encode(JSON.stringify(chart));
            }
        }

        /**
         * Get selected chart from session storage
         */
        function getSelectedChart() {
            if ($sessionStorage.selectedChart)
                return JSON.parse(Base64.decode($sessionStorage.selectedChart));
            else
                return null;
        }

        /**
         * Set a unassigned beds to the session storage
         * @param beds
         */
        function setUnassignedBeds(beds) {
            if (beds) {
                $sessionStorage.unassignedBeds = Base64.encode(JSON.stringify(beds));
            }
        }

        /**
         * Get current unassigned from the session storage
         */
        function getUnassignedBeds() {
            return JSON.parse(Base64.decode($sessionStorage.unassignedBeds));
        }

        function getDays() {
            return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
        }

        function parseToTime(data) {
            return moment(data).format('hh:mm:ss a');
        }

        function parseToDate(data) {
            return moment(data).format('MM/DD/YYYY');
        }

        function parseToDateTime(data) {

            if (data) {
                return moment(toLocalDate(data)).format('MM/DD/YYYY hh:mm a');
            } else {
                return 'N/A';
            }
        }

        function toLocalDate(data) {
            if (data) {
                var dateUtc = moment.utc(data);
                var localDate = moment(dateUtc).local();
                return localDate;
            } else {
                return data;
            }
        }

        function attachment($file, data) {
            return $q(function (resolve, reject) {
                if ($file && $file.$error === 'pattern') {
                    reject($file.$error);
                }
                if ($file) {
                    DataUtils.toBase64($file, function (base64Data) {
                        data.file = base64Data;
                        data.fileContentType = $file.type;
                        data.name = $file.name;
                        data.size = bytesToSize($file.size);
                        resolve(data);
                    });
                }
            });
        }

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return 'n/a';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            if (i == 0) return bytes + ' ' + sizes[i];
            return (bytes / Math.pow(1024, i)).toFixed(3) + ' ' + sizes[i];
        }

        function splitByBackSlash(value) {
            return value.split('/');

        }

        function generateUUID() {
            var d = new Date().getTime();
            if (window.performance && typeof window.performance.now === "function") {
                d += performance.now();
                ; //use high-precision timer if available
            }
            var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        }

        function getUUID() {
            var employee = getCurrentEmployee();

            var browserUuid = $cookies.get('browserUuid' + employee.id);

            if (!browserUuid) {
                browserUuid = generateUUID();

                var d = new Date();
                d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));

                $cookies.put('browserUuid' + employee.id, browserUuid, {expires: d.toUTCString()});
            }

            return browserUuid;
        }

        function removeUUID() {
            var employee = getCurrentEmployee();
            $cookies.remove('browserUuid' + employee.id);
        }

        function togglePanel(att) {
            $rootScope.employeeMenu.menu[att].value = !$rootScope.employeeMenu.menu[att].value;
            $rootScope.employeeMenu.employee = getCurrentEmployee();
            EmployeeMenu.update($rootScope.employeeMenu);
        }

        function showPanel(att) {
            $rootScope.employeeMenu.menu[att].value = true;
            $rootScope.employeeMenu.employee = getCurrentEmployee();
            EmployeeMenu.update($rootScope.employeeMenu);
        }

        function getEmployeeMenu() {

            return $rootScope.employeeMenu;
        }

        function getFrequency(value) {
            switch (value) {
                case "1":
                    return "Every hour";
                case "2":
                    return "Every 2 hour";
                case "3":
                    return "Every 3 hour";
                case "4":
                    return "Every 4 hour";
                case "6":
                    return "Every 6 hour";
                case "8":
                    return "Every 8 hour";
                case "AM":
                    return "Once a day (AM)";
                case "HS":
                    return "Once a day (HS)";
                case "BID":
                    return "Two time a day schedule (BID)";
                case "TID":
                    return "Three times a day schedule (TID)";
                case "QID":
                    return "Four times a day schedule (QID)";
                case "SID":
                    return "Six times a day schedule";
                case "0":
                    return "Once";
            }
        }

        function patientPictureDefault() {
            return {
                picture: 'data:image/jpeg;base64,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'
            };
        }

        function insuranceFrontPictureDefault() {
            return {
                picture: 'data:image/svg+xml;base64,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'
            };
        }

        function insuranceBackPictureDefault() {
            return {
                picture: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNTAiIGhlaWdodD0iMjQwIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHBhdGggZD0iTTAgMGgzNTB2MjQwSDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iOC45OTQiIHN0cm9rZS1taXRlcmxpbWl0PSIzIiBkPSJNMTMuNjk4IDQuNWgzMjIuNjA0YzUuMzUyIDAgOS42OTggNC4zNDYgOS42OTggOS42OTh2MjExLjYwNGMwIDUuMzUyLTQuMzQ2IDkuNjk4LTkuNjk4IDkuNjk4SDEzLjY5OEM4LjM0NiAyMzUuNSA0IDIzMS4xNTQgNCAyMjUuODAyVjE0LjE5OEM0IDguODQ2IDguMzQ2IDQuNSAxMy42OTggNC41eiIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIi8+PHBhdGggZD0iTTIzMSAxODIuNXYzMGg0LjEzNnYtMzBIMjMxem04LjI3MyAwdjMwaDYuMjA0di0zMGgtNi4yMDR6bTEwLjM0MSAwdjMwaDE2LjU0NXYtMzBoLTE2LjU0NXptMjAuNjgxIDB2MzBoNC4xMzd2LTMwaC00LjEzN3ptOC4yNzMgMHYzMGg2LjIwNXYtMzBoLTYuMjA1em0xMC4zNDEgMHYzMGg0LjEzNnYtMzBoLTQuMTM2em04LjI3MyAwdjMwaDguMjczdi0zMGgtOC4yNzN6bTEyLjQwOSAwdjMwaDQuMTM2di0zMGgtNC4xMzZ6bTguMjczIDB2MzBIMzIydi0zMGgtNC4xMzZ6TTggMzIuNWgzMzV2MzdIOHoiLz48cGF0aCBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iOCIgc3Ryb2tlLW1pdGVybGltaXQ9IjMiIGQ9Ik0xNTUgODkuNWgxNjdNMTg3IDExNS41aDEzNU0xNTUgMTQxLjVoMTY3IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiLz48L2c+PC9zdmc+'
            };
        }

        function scrollToPosition(element, offset, duration) {
            var target = angular.element(document.getElementById(element));

            $document.scrollToElement(target, offset, duration);
        }

        function getEvaluationStatusClass(status) {
            switch (status) {
                case 'Pending':
                    return 'blue light';
                case 'InReview':
                    return 'yellow';
                case 'Revoked':
                    return 'blue';
                case 'Expired':
                    return 'purple';
                case 'Late':
                    return 'red';
                case 'Finalized':
                    return 'green';
                case 'Amended':
                    return 'gray light';
            }
        }

        //TODO Add style for expired status.
        function getEvaluationStatusLabelClass(status) {
            switch (status) {
                case 'Pending':
                    return 'label label-info';
                case 'InReview':
                    return 'label label-warning';
                case 'Revoked':
                    return 'label label-primary';
                case 'Expired':
                    return 'purple';
                case 'Late':
                    return 'label label-danger';
                case 'Finalized':
                    return 'label label-success';
                case 'Amended':
                    return 'label label-default';
            }
        }

        function changeSchedule(admissionMedication) {
            admissionMedication.schedules = [];
            admissionMedication.takes = [];
            admissionMedication.endDate = null;

            if (admissionMedication.frequency.id != 'AS_NEEDED') {
                admissionMedication.minimumAsNeeded = null;
            }

            if (!admissionMedication.durationDays || !admissionMedication.startDate || !admissionMedication.frequency) {
                admissionMedication.showSchedule = false;

                return;
            }

            switch (admissionMedication.frequency.id) {
                case 'EVERY_H':
                case 'EVERY_2H':
                case 'EVERY_3H':
                case 'EVERY_4H':
                case 'EVERY_6H':
                case 'EVERY_8H':
                case 'EVERY_12H':
                case 'EVERY_24H':
                case 'EVERY_48H':
                case 'EVERY_WEEK':
                case 'EVERY_TWO_WEEKS':
                case 'EVERY_MONTH': {
                    admissionMedication.showSchedule = false;
                    admissionMedication.endDate = angular.copy(admissionMedication.startDate);
                    admissionMedication.endDate.setDate(admissionMedication.endDate.getDate() + admissionMedication.durationDays - 1);
                    admissionMedication.endDate.setHours(23);
                    admissionMedication.endDate.setMinutes(59);

                    var day = angular.copy(admissionMedication.startDate);
                    var hours = parseInt(admissionMedication.frequency.hours);

                    while (admissionMedication.endDate > day) {
                        var date = new Date(day.getFullYear(), day.getMonth(), day.getDate(), day.getHours(), day.getMinutes(), 0);

                        admissionMedication.takes.push({
                            collectedDate: angular.copy(date),
                            scheduleDate: angular.copy(date),
                            canceled: false,
                            collected: false,
                            medicationTakeStatus: 'SCHEDULED'
                        });

                        day.setHours(day.getHours() + hours);
                    }

                    updatePatientActionEndDate(admissionMedication);

                    break;
                }
                case 'ONE_AM': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 1, 0, 9);

                    break;
                }
                case 'ONE_HS': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 1, 0, 21);

                    break;
                }
                case 'BID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 2, 12, 9);
                    break;
                }
                case 'TID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 3, 6, 9);

                    break;
                }
                case 'QID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 4, 3, 9);

                    break;
                }
                case 'SID': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 6, 4, 2);

                    break;
                }
                case 'ONCE': {
                    admissionMedication.showSchedule = false;
                    scheduleTakesIntervals(admissionMedication, 1, 0, 9);

                    break;
                }
                case 'AS_NEEDED': {

                }
            }
        }

        function scheduleTakesIntervals(admissionMedication, count, hours, firstHour) {
            var today = new Date();
            var first = new Date(today.getFullYear(), today.getMonth(), today.getDate(), firstHour, 0, 0);

            for (var i = 0; i < count; i++) {
                admissionMedication.schedules.push({
                    xorder: i,
                    date: angular.copy(first)
                });

                first.setHours(first.getHours() + hours);
            }

            scheduleTakes(admissionMedication);
        }

        function scheduleTakes(admissionMedication) {
            admissionMedication.takes = [];
            var day = angular.copy(admissionMedication.startDate);

            for (var i = 0; i < admissionMedication.durationDays; i++) {
                var date = day;

                for (var j = 0; j < admissionMedication.schedules.length; j++) {
                    date.setHours(admissionMedication.schedules[j].date.getHours());
                    date.setMinutes(admissionMedication.schedules[j].date.getMinutes());
                    date.setSeconds(0);

                    admissionMedication.takes.push({
                        collectedDate: angular.copy(date),
                        scheduleDate: angular.copy(date),
                        canceled: false,
                        collected: false
                    });
                }
            }

            updatePatientActionEndDate(admissionMedication);
        }

        function updatePatientActionEndDate(admissionMedication) {
            if (admissionMedication.takes && admissionMedication.takes.length > 0) {
                admissionMedication.endDate = admissionMedication.takes[admissionMedication.takes.length - 1].collectedDate;
            }
        }

        function getPatientMedicationFilterStatus() {
            return {
                CURRENT: 'CURRENT',
                ADMINISTER: 'ADMINISTER',
                TODAY: 'TODAY',
                MISSED: 'MISSED',
                PATIENT_REFUSE: 'PATIENT_REFUSE'
            };
        }

        /**
         * Clear the session storage
         */
        function clearSession() {
            $sessionStorage.$reset();
        }

        function setStorage(attr, value) {
            $sessionStorage[attr] = value;
        }

        function getStorage(attr) {
            return $sessionStorage[attr];
        }

        function initBedSheetFilter() {

            return {
                buildingId: null,
                gender: null,
                searchQuery: null
            }
        }

        function initCampaignOutreachFilter() {

            return {
                campaignId: null,
                page: 1,
                searchQuery: null,
                totalItems: 0
            }
        }

        function readBedSheetFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = getStorage('filterBedSheet') == null ? initBedSheetFilter() : getStorage('filterBedSheet');
            }

            var filter = {
                buildingId: filterLS.buildingId,
                gender: filterLS.gender,
                searchQuery: filterLS.searchQuery
            }

            return filter;
        }

        function readCampaignOutreachFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = getStorage('filterCampaignOutreach') == null ? initCampaignOutreachFilter() : getStorage('filterCampaignOutreach');
            }

            var filter = {
                campaignId: filterLS.campaignId,
                page: filterLS.page,
                searchQuery: filterLS.searchQuery,
                totalItems: filterLS.totalItems
            }

            return filter;
        }

        function getFilterByFacility(facility) {
            return {id: facility.id};
        }

        function getGenericDelStatusFilter() {
            return {
                query: {
                    bool: {
                        must: [{term: {delStatus: false}}]
                    }
                }
            }
        }

        function getFilterByCorporation(corporation) {
            return {
                query: {
                    bool: {
                        must: [
                            {term: {delStatus: false}},
                            {
                                bool: {
                                    should: [
                                        {"term": {"corporationId": corporation.id}},
                                        {"term": {"corporation.id": corporation.id}}
                                    ]
                                }
                            }
                        ]
                    }
                }
            }
        }

        function getFilterByCurrentCorporationAndType(type) {
            var corporation = getCorporation();

            return {id: corporation.id, relationalType: type};
        }

        function getFilterByCurrentCorporation() {
            var corporation = getCorporation();

            return {id: corporation.id};
        }

        function setChartFilter(filter) {
            $sessionStorage.chartFilter = filter;
        }

        function getChartFilter() {
            return $sessionStorage.chartFilter;
        }

        function getHeightInchesToFeetInches(height) {
            return Math.floor(height / 12) + "' - " + height % 12 + "''";
        }

        function initCalendarFilter() {
            return {
                employeesSelection: [],
                buildingSelection: [],
                groupSessionStatusesSelect: [],
                searchQuery: "",
                toggleSidebar: 0,
                start: null,
                end: null
            }
        }

        function readCalendarFilterFromLocalStore(filterLS) {
            if (filterLS == undefined) {
                filterLS = CoreService.getStorage('filterCalendar');
            }
            var toggleSidebar = (filterLS.employeesSelection.length > 0 || filterLS.buildingSelection.length > 0 || filterLS.groupSessionStatusesSelect.length > 0 || filterLS.searchQuery != "") ? 1 : 0;

            var filter = {
                employeesSelection: filterLS.employeesSelection,
                buildingSelection: filterLS.buildingSelection,
                groupSessionStatusesSelect: filterLS.groupSessionStatusesSelect,
                searchQuery: filterLS.searchQuery,
                toggleSidebar: toggleSidebar,
                start: new Date(filterLS.start),
                end: new Date(filterLS.end)
            }

            return filter;
        }

        function enableByFacilityType(facility, field) {
            if (facility.facilityType && facilityField[facility.facilityType]) {

                return facilityField[facility.facilityType][field];
            }

            return true;
        }

        function currentEmployeeHaveAnyCredential(credentials) {
            return _.intersection(getCurrentEmployee().credentials,
                _.map(credentials, function (credential) {
                    return credential.name;
                })
            ).length > 0;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            if (_identity.authorities.indexOf('ROLE_SYSTEM_ADMIN') !== -1) {
                return true;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && (_id.authorities.indexOf('ROLE_SYSTEM_ADMIN') !== -1 || _id.authorities.indexOf(authority) !== -1);
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal', 'ROLES'];

    function hasAnyAuthority(Principal, ROLES) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities) || Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM_ADMIN]);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Auth', Auth);

    Auth.$inject = ['User', '$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider',
        'Account', 'CoreService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish',
        'ROLES', '$http', 'AuthItem'];

    function Auth(User, $rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider,
                  Account, CoreService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish,
                  ROLES, $http, AuthItem) {

        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            loadResourceAccess: loadResourceAccess,
            loadActionAccess: loadActionAccess,
            loadActionsAccess: loadActionsAccess,
            resourceAuthorize: resourceAuthorize,
            actionAuthorize: actionAuthorize,
            checkActionAuthorization: checkActionAuthorization,
            hasActionAuthorization: hasActionAuthorization
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force) {
            var authReturn = Principal.identity(force).then(checkBrowser);

            return authReturn;

            function checkBrowser() {
                var isAuthenticated = Principal.isAuthenticated();

                if(force && !isAuthenticated){
                    stowStateAndSendSignin();
                }

                if (isAuthenticated) {
                    Principal.hasAuthority(ROLES.ROLE_SYSTEM_ADMIN).then(checkRoleAdmin);
                } else {
                    authThen();
                }
            }

            function checkRoleAdmin(response) {
                if (response) {
                    authThen();
                } else {
                    var fromCookie = CoreService.getUUID();

                    User.checkBrowser({browserUuid: fromCookie}).$promise.then(checkBrowserThen);
                }
            }

            function checkBrowserThen(response) {
                var employee = CoreService.getCurrentEmployee();

                if (response.result) {
                    // console.log("line 86");
                    if (employee.signed === true) {
                        // console.log("is signed" );
                        // console.log(employee);
                        authThen();
                    } else {
                        // console.log("go to consent" );
                        $state.go('consent');
                    }
                } else {
                    // console.log("line 95");
                    if ($rootScope.toState.name !== 'security-code') {
                        $state.go('security-check');
                    }
                }
            }

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated &&
                    $rootScope.toState.parent === 'account' &&
                    ($rootScope.toState.name === 'login' ||
                        $rootScope.toState.name === 'register' ||
                        $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities &&
                    $rootScope.toState.data.authorities.length > 0 &&
                    !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    } else {
                        stowStateAndSendSignin();
                    }
                }
            }

            function stowStateAndSendSignin(){
                // user is not authenticated. stow the state they wanted before you
                // send them to the login service, so you can return them when you're done
                storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                // now, send them to the signin state so they can log in
                $state.go('login');
            }
        }

        function changePassword(newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen(data) {
                Principal.identity(true).then(function () {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            return $sessionStorage.previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            $sessionStorage.previousState = {"name": previousStateName, "params": previousStateParams};
        }

        function loadResourceAccess(resource, corporation) {

            return $http({
                method: 'GET',
                url: '/api/authorization/' + resource + '/resource/' + corporation.id
            });
        }

        function loadActionAccess(action) {
            var corporation = CoreService.getCorporation();

            return $http({
                method: 'GET',
                url: '/api/authorization/' + action + '/action/' + corporation.id
            });
        }

        function loadActionsAccess(actions) {
            var corporation = CoreService.getCorporation();

            return AuthItem.loadActions({
                    stringList: actions,
                    id: corporation.id
            });
        }

        function resourceAuthorize(action, access) {
            if (access && access.actions && access.actions[action] && access.actions[action].roles) {
                access.actions[action].roles.push(ROLES.ROLE_SYSTEM_ADMIN);

                return access.actions[action].roles.join();
            } else {
                return [ROLES.ROLE_SYSTEM_ADMIN].join();
            }
        }

        function actionAuthorize(action, access) {
            if (access && access.action && access.roles && access.action === action) {
                access.roles.push(ROLES.ROLE_SYSTEM_ADMIN);

                return access.roles.join();
            } else {
                return [ROLES.ROLE_SYSTEM_ADMIN].join();
            }
        }

        function checkActionAuthorization(action, access) {
            if (!Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM_ADMIN])) {
                if (!access[action] || !Principal.hasAnyAuthority(access[action].roles)) {
                    $state.go('accessdenied');

                    return false;
                }
            }

            return true;
        }

        function hasActionAuthorization(action, access) {
            if (!Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM_ADMIN])) {
                if (!access[action] || !Principal.hasAnyAuthority(access[action].roles)) {

                    return false;
                }
            }

            return true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            $localStorage.$reset();
            $sessionStorage.$reset();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sign', {
                abstract: true,
                parent: '',
                url: '/sign',
                ncyBreadcrumb: {
                    label: 'Sign',
                    parent: 'login'
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/sign/sign.html',
                        controller: 'SignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            // .state('sign.consent', {
            //     parent: 'sign',
            //     url: '/consent',
            //     ncyBreadcrumb: {
            //         label: 'Consent',
            //         parent: 'app'
            //     },
            //     data: {
            //         authorities: ['ROLE_USER']
            //     },
            //     views: {
            //         '': {
            //             templateUrl: 'app/sign/consent.html'
            //         }
            //     },
            //     resolve: {}
            // })
            .state('sign.signature', {
                parent: 'sign',
                url: '/signature',
                ncyBreadcrumb: {
                    label: 'Signature',
                    parent: 'sign.consent'
                },
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    '': {
                        templateUrl: 'app/sign/signature.html'
                    }
                },
                resolve: {}
            })

    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('SignService', SignService);

    SignService.$inject = ['$uibModal'];

    function SignService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SignController', SignController);

    SignController.$inject = ['JSignature', 'CoreService', '$state', '$rootScope', 'Employee'];

    function SignController(JSignature, CoreService, $state, $rootScope, Employee) {
        var vm = this;

        $rootScope.background = '';
        vm.step = 0;
        vm.signature = {signature : ""};

        //We check if the employee has signed we redirect to the previous state
        vm.employee = CoreService.getCurrentEmployee();

        // if (vm.employee.signed) {
        //     if (!CoreService.getCurrentEmployee().signed) {
        //         CoreService.setCurrentEmployee(employee);
        //     }
        //
        //     $state.go("home");
        // }

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        }

        vm.save = save;
        vm.next = next;

        function save() {
            vm.isSaving = true;
            Employee.replaceSignature({signature: vm.signature.signature}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;

            if (result && result.signed) {
                CoreService.setCurrentEmployee(result);

                $state.go("home");
            }
        }

        function onSaveError() {
            vm.isSaving = false;
            vm.isError = false;
        }

        function next() {
            if (vm.step == 0) {
                vm.step++;
            } else {
                save();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SecurityCodeController', SecurityCodeController);

    SecurityCodeController.$inject = ['CoreService', '$state', 'User', 'toastr', '$cookies'];//, 'previousState'

    function SecurityCodeController(CoreService, $state, User, toastr, $cookies) {
        var vm = this;

        vm.rememberMe = true;
        vm.toastr = toastr;
        vm.$cookies = $cookies;
        vm.code = null;
        vm.rememberMe = true;
        vm.employee = CoreService.getCurrentEmployee();
        vm.phoneNumberMasked = maskPhone(vm.employee.mobile);

        vm.verify = verify;

        function verify() {
            vm.isSaving = true;

            User.verifyCode({code: vm.code, browserUuid: CoreService.getUUID(), rememberMe: vm.rememberMe}, onSuccess, onError);

            function onSuccess(data) {
                if (data.value == true) {
                    if (!vm.rememberMe) {
                        CoreService.removeUUID();
                    }

                    if (vm.employee && !vm.employee.signed) {
                        $state.go('consent');
                    } else {
                        $state.go('home');
                    }
                } else {
                    toastr.error('Error checking code, try again');
                }

                vm.isSaving = false;
            }

            function onError(error) {
                vm.isSaving = false;
                $state.go('security-check');
                toastr.error('Error verifying code, try again')
            }
        }

        function maskPhone (number) {
            return '(***) ***-' + number.slice(-4);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SecurityCheckController', SecurityCheckController);

    SecurityCheckController.$inject = ['CoreService', '$state', 'User', 'toastr', '$cookies'];

    function SecurityCheckController(CoreService, $state, User, toastr, $cookies) {
        var vm = this;

        vm.rememberMe = true;
        vm.toastr = toastr;
        vm.$cookies = $cookies;
        vm.employee = CoreService.getCurrentEmployee();
        vm.phoneNumberMasked = maskPhone(vm.employee.mobile);

        vm.sendCode = sendCode;

        function sendCode() {
            var fromCookie = CoreService.getUUID();

            User.sendSmsCode({browserUuid: fromCookie}, function (data) {
                $state.go('security-code');
            }, function (error) {
                toastr.error('Error sending code, try later');
            });
        }

        function maskPhone (number) {
            return '(***) ***-' + number.slice(-4);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider.state('login', {
            url: '/login',
            templateUrl: 'app/login/login.html',
            controller: 'LoginController',
            controllerAs: 'vm',
            data: {
                authorities: []
            },
            resolve: {}
        }).state('consent', {
            url: '/consent',
            templateUrl: 'app/login/consent2.html',
            controller: 'SignController',
            controllerAs: 'vm',
            data: {
                authorities: []
            },
            resolve: {
                // employee: ['Employee', function (Employee) {
                //     return Employee.employeeAccount().$promise;
                // }]
            }
        }).state('collect-signature', {
            // parent: 'login',
            url: '/collect-signature',
            controller: 'SignController',
            controllerAs: 'vm',
            data: {
                authorities: []
            },
            templateUrl: 'app/login/signature.html',
            resolve: {}
        }).state('security-check', {
            url: '/security-check',
            controller: 'SecurityCheckController',
            controllerAs: 'vm',
            data: {
                authorities: []
            },
            templateUrl: 'app/login/security-check.html',
            resolve: {}
        }).state('security-code', {
            url: '/security-code',
            controller: 'SecurityCodeController',
            controllerAs: 'vm',
            data: {
                authorities: []
            },
            templateUrl: 'app/login/security-code.html',
            resolve: {}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'APP',
        'CoreService', 'User', 'toastr', '$cookies', 'Employee', '$sce'];

    function LoginController($rootScope, $state, $timeout, Auth, APP,
                             CoreService, User, toastr, $cookies, Employee, $sce) {
        var vm = this;
        $rootScope.background = 'background: url(content/images/wallpaper.jpg) no-repeat center center / cover;';

        vm.toastr = toastr;
        vm.$cookies = $cookies;
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.username = null;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.alerts = [];
        vm.addAlert = addAlert;
        vm.closeAlert = closeAlert;
        vm.isCapsLockOn = isCapsLockOn;
        vm.popoverHtml = $sce.trustAsHtml('<span class="popover-text">The username can contain any <strong class="success">letter</strong> or <strong class="success">digit</strong> and the specials characters <strong class="warning">.</strong> or <strong class="warning">_</strong>. Must not exceed <strong class="danger">40</strong> characters long.</span>');

        vm.appName = APP.APP_NAME;
        vm.appSuffixName = APP.APP_SUFFIX_NAME;

        function addAlert(message) {
            if (vm.alerts.length > 0) {
                vm.alerts = []
            }
            vm.alerts.push({type: 'danger', msg: message})
        }

        function closeAlert(index) {
            vm.alerts.splice(index, 1)
        }

        function isCapsLockOn() {

        }

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login(event) {
            vm.isSaving = true;
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                Employee.employeeAccount(function (data) {
                     CoreService.setCurrentEmployee(data);

                    vm.authenticationError = false;

                    $rootScope.$broadcast('authenticationSuccess');

                    // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                    // since login is succesful, go to stored previousState and clear previousState
                    if (Auth.getPreviousState()) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }

                    $state.go('home');
                }, function () {
                    vm.authenticationError = false;
                    if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                        $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                        $state.go('login');
                    }

                    $rootScope.$broadcast('authenticationSuccess');

                    // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                    // since login is succesful, go to stored previousState and clear previousState
                    if (Auth.getPreviousState()) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    }
                    $state.go('home');
                });


            }).catch(function (result) {
                vm.authenticationError = true;

                vm.username = "";
                vm.password = "";

                vm.addAlert(result.data.AuthenticationException);
                angular.element('#username').focus();
                vm.isSaving = false;
            });
        }

        function register() {
            $state.go('register');
        }

        function requestResetPassword() {
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SidebarController', SidebarController);

    SidebarController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'previousState',
        'LoginService', 'Facility', 'CoreService', 'ACTIONS', 'employee', 'ROLES', 'Corporation', 'RESOURCES',
        'EmployeeMenu'];

    function SidebarController($rootScope, $scope, $state, Auth, Principal, ProfileService, previousState,
                               LoginService, Facility, CoreService, ACTIONS, employee, ROLES, Corporation, RESOURCES,
                               EmployeeMenu) {

        var vm = this;

        $rootScope.background = '';

        vm.isNavbarCollapsed = true;
        vm.isControlbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.$state = $state;
        vm.employee = employee;
        vm.corporations = [];
        vm.facilities = [];
        vm.sideBarItems = [];
        vm.loading = true;
        vm.access = [];
        vm.currentFacility = CoreService.getCurrentFacility();
        vm.showSidebarForms = false;

        EmployeeMenu.get();

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.changeFacility = changeFacility;
        vm.deployFacilities = deployFacilities;
        vm.showSidebarItem = showSidebarItem;
        vm.selectCorporation = selectCorporation;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        function initMenu(access) {
            vm.sideBarItems = [];

            if (vm.currentFacility) {
                vm.sideBarItems.push(...[
                    {
                        id: 'home',
                        open: 'menu-open',
                        displayName: 'Dashboard',
                        icon: 'fa fa-dashboard',
                        state: !vm.currentFacility ? 'hidden' : '',
                        style: 'display: block;',
                        url: 'dashboard',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_DASHBOARD, access), /*All Access*/
                        items: [],
                    },
                    // {
                    //     id: 'home',
                    //     open: 'menu-open',
                    //     displayName: 'BHT Dashboard',
                    //     icon: 'fa fa-dashboard',
                    //     state: !vm.currentFacility ? 'hidden' : '',
                    //     style: 'display: block;',
                    //     url: 'bht-dashboard',
                    //     access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_DASHBOARD, access), /*All Access*/
                    //     items: [],
                    // },
                    {
                        id: 'all-patient',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Patients',
                        url: 'charts',
                        icon: 'fa fa-users',
                        style: 'display: none;',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_PATIENT, access),
                        items: [],
                        function: clearChartFilter
                    },
                    {
                        id: 'blue-alerts',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Blue Alerts',
                        url: 'blue-alerts',
                        icon: 'fa fa-bell',
                        style: 'display: none;',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_PATIENT, access),
                        items: [],
                        function: clearChartFilter
                    },
                    {
                        id: 'bedSheet',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Bed Sheets',
                        icon: 'fa fa-bed',
                        style: 'display: none;',
                        url: 'bed-sheet',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_BED_SHEET, access),
                        items: [],
                        function: clearBedSheetFilter
                    },
                    {
                        id: 'incident-report',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Incident Reports',
                        icon: 'fa fa-file',
                        style: 'display: none;',
                        url: 'incident-report',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS, access),
                        items: []
                    },
                    {
                        id: 'telehealth',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Telehealth',
                        icon: 'fa fa-video-camera',
                        style: 'display: none;',
                        url: 'telehealth',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TELEHEALTH, access),
                        items: []
                    },
                    {
                        id: 'outreach-campaign',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Outreach Campaigns',
                        icon: 'fa fa-tasks',
                        style: 'display: none;',
                        url: 'outreach-campaign',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_OUTREACH_CAMPAIGNS, access),
                        items: [],
                        function: clearCampaignOutreachFilter
                    },
                    {
                        id: 'groupSession',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Group Sessions',
                        icon: 'fa fa-calendar',
                        style: 'display: none;',
                        url: 'group-session',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_GROUP_SESSIONS, access),
                        items: []
                    },
                    {
                        id: 'medicalNursing',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Medical & Nursing',
                        icon: 'fa fa-user-md',
                        style: 'display: none;',
                        url: null,
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_MEDICAL_NURSING, access),
                        items: [
                            {
                                state: '',
                                displayName: 'Lab Requisitions',
                                url: 'lab-requisition',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_MEDICAL_NURSING_LAB_REQUISITIONS, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Lab Results',
                                url: 'patient-result',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_MEDICAL_NURSING_LAB_RESULTS, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Sent Lab Results',
                                url: 'sent-lab-result',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Fax Logs',
                                url: 'patient-medication-fax-log',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_MEDICAL_NURSING_FAX, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'MARs/MORs',
                                url: 'patient-medication-mars',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_MEDICAL_NURSING_MARS, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Physician Review',
                                url: 'physician-review',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_MEDICAL_NURSING_PHYSICIAN_REVIEW, access),
                                enable: vm.currentFacility != null
                            }
                        ]
                    },
                    {
                        id: 'shift',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Shifts',
                        url: 'shift',
                        icon: 'fa fa-clock-o',
                        style: 'display: none;',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_SHIFT, access),
                        items: []
                    },
                    {
                        id: 'contacts',
                        open: '',
                        displayName: 'Contacts',
                        icon: 'fa fa-phone',
                        state: !vm.currentFacility ? 'hidden' : '',
                        style: 'display: none;',
                        url: 'contacts-facility',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY, access),
                        items: []
                    },
                    {
                        id: 'report',
                        state: '',
                        open: '',
                        displayName: 'Reports',
                        url: 'reports',
                        icon: 'fa fa-file-text-o',
                        style: 'display: none;',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_REPORTS, access),
                        items: []
                    },
                    {
                        id: 'facility-billing',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Facility Billing',
                        url: 'facility-billing',
                        icon: 'fa fa-dollar',
                        style: 'display: none;',
                        access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                        items: [
                            {
                                state: '',
                                displayName: 'Billing',
                                url: 'facility-billing',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Billing Config',
                                url: 'facility-billing-config',
                                icon: 'fa fa-circle-o',
                                access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                                enable: vm.currentFacility != null
                            },
                        ]
                    },
                    {
                        id: 'audit',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Billing Audit',
                        url: 'audit',
                        icon: 'fa fa-dollar',
                        style: 'display: none;',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_AUDIT, access),
                        items: []
                    },
                    {
                        id: 'pdf-chart-report',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Storage',
                        url: 'pdf-chart-report',
                        icon: 'fa fa-pie-chart',
                        style: 'display: none;',
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_REPORTS, access),
                        items: []
                    },
                    {
                        id: 'templates',
                        state: !vm.currentFacility ? 'hidden' : '',
                        open: '',
                        displayName: 'Templates',
                        icon: 'fa fa-file-pdf-o',
                        style: 'display: none;',
                        url: null,
                        access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES, access),
                        items: [
                            {
                                state: '',
                                displayName: 'Care & Delivery',
                                url: 'evaluation-template',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Care & Delivery Audit',
                                url: 'evaluation-audit',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_EVALUATION_AUDIT, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Care & Delivery MARs/MORs',
                                url: 'evaluation-template-mars-mors',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Group Session Form Tpl',
                                url: 'group-session-form-tpl',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Group Sessions',
                                url: 'group-session-template',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Assistant',
                                url: 'assistant',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_ASSISTANT, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Care Coordination',
                                url: 'care-coordination-template',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_COORDINATION, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Protocol',
                                url: 'protocol',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Building',
                                url: 'building',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_BUILDING, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Room',
                                url: 'room',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_ROOM, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Bed',
                                url: 'bed',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_BED, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Incident Report Note Template',
                                url: 'incident-report-note-template',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_INCIDENT_REPORT_NOTE_TEMPLATE, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Campaign',
                                url: 'campaign',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CAMPAIGN, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Facesheet',
                                url: 'facesheet-tpl',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Facesheet Section',
                                url: 'facesheet-section',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Track',
                                url: 'track',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_TRACK, access),
                                enable: vm.currentFacility != null
                            },
                            {
                                state: '',
                                displayName: 'Pharmacy',
                                url: 'facility-pharmacy',
                                icon: 'fa fa-circle-o',
                                access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY, access),
                                enable: vm.currentFacility != null
                            },
                        ]
                    },
                    // {
                    //     id: 'crm',
                    //     state: '',
                    //     open: '',
                    //     displayName: 'CRM',
                    //     url: null,
                    //     icon: 'fa fa-cog',
                    //     style: 'display: none;',
                    //     access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                    //     items: [
                    //         {
                    //             state: '',
                    //             displayName: 'Opportunity',
                    //             url: 'crm-opportunity',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY, access),
                    //             enable: true
                    //         },
                    //         {
                    //             state: '',
                    //             displayName: 'Campaign',
                    //             url: 'crm-campaign',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN, access),
                    //             enable: true
                    //         },
                    //         {
                    //             state: '',
                    //             displayName: 'Opportunity Status',
                    //             url: 'crm-opportunity-status',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS, access),
                    //             enable: true
                    //         },
                    //         {
                    //             state: '',
                    //             displayName: 'Outbound Referral Status',
                    //             url: 'crm-outbound-referral-status',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access),
                    //             enable: true
                    //         },
                    //         {
                    //             state: '',
                    //             displayName: 'Referral Source',
                    //             url: 'crm-referral-source',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access),
                    //             enable: vm.currentFacility != null
                    //         },
                    //         {
                    //             state: '',
                    //             displayName: 'Referral Source Contacts',
                    //             url: 'crm-referral-contact',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access),
                    //             enable: true
                    //         },
                    //         {
                    //             state: '',
                    //             displayName: 'Tags',
                    //             url: 'crm-tag',
                    //             icon: 'fa fa-circle-o',
                    //             access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access),
                    //             enable: true
                    //         }
                    //     ]
                    // },
                ]);
            }

            if (vm.currentFacility && vm.currentFacility.facilityType === 'HIV') {
                vm.sideBarItems.push({
                    id: '304B-program-eligibility',
                    open: '',
                    displayName: '304B Program Eligibility',
                    icon: 'fa fa-cog',
                    style: 'display: none;',
                    url: null,
                    access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_304B_PROGRAM_ELIGIBILITY, access),
                    items: [
                        {
                            state: '',
                            displayName: 'Corporation Program Eligibility',
                            url: 'prog-elig-corp',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access),
                            enable: vm.currentFacility.facilityType === 'HIV'
                        },
                        {
                            state: '',
                            displayName: 'Facility Program Eligibility',
                            url: 'prog-elig-facility',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access),
                            enable: vm.currentFacility.facilityType === 'HIV'
                        },
                        {
                            state: '',
                            displayName: 'Medication Program Eligibility',
                            url: 'prog-medication',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access),
                            enable: vm.currentFacility.facilityType === 'HIV'
                        },
                        {
                            state: '',
                            displayName: 'Bin',
                            url: 'bin',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_BIN, access.data),
                            enable: vm.currentFacility.facilityType === 'HIV'
                        },
                        {
                            state: '',
                            displayName: 'Employee Program Eligibility',
                            url: 'prog-elig-employee',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY, access),
                            enable: vm.currentFacility.facilityType === 'HIV'
                        }
                    ]
                })
            }

            getLaboratoriesMenu(access);

            getConfig(access);

            if (vm.currentFacility && vm.currentFacility.facilityType === 'COVID_RC') {
                getCovidMenu(access);
            }

            getAdminMenu(access);

            getRcopiaConfig(access);

            sortSubMenus();

            return vm.sideBarItems;
        }

        $rootScope.$on('$stateChangeSuccess', function () {
            selectMenuItem($state.current.name);
        });

        init();

        function init() {
            getAdminMenu();

            Corporation.query(function (result) {
                if (result) {
                    vm.corporations = result;

                    if (vm.corporations.length == 1) {
                        vm.corporation = vm.corporations[0];

                        selectCorporation();
                    } else {
                        var storedCorporation = CoreService.getCorporation();

                        if (storedCorporation) {
                            //Check if the current corporation is in the list
                            var current = $.grep(vm.corporations, function (corporation, i) {
                                return corporation.id == storedCorporation.id;
                            })[0];

                            //user last facility access
                            if (current) {
                                //update current corporation
                                vm.corporation = current;

                                selectCorporation();

                            } else {
                                CoreService.setCorporation(null);
                            }
                        }
                    }
                }
            });
        }

        $rootScope.$on('$stateChangeSuccess', function () {
            selectMenuItem($state.current.name);
        });

        selectMenuItem($state.current.name);

        function selectMenuItem(url) {
            var lessChild = null;
            var parent = null;
            var child = null;
            for (var i = 0; i < vm.sideBarItems.length; i++) {
                for (var j = 0; j < vm.sideBarItems[i].items.length; j++) {
                    if (vm.sideBarItems[i].items[j].items == null) {
                        if (vm.sideBarItems[i].items[j].url == url) {
                            parent = i;
                            child = j;
                        } else {
                            vm.sideBarItems[i].open = '';
                            vm.sideBarItems[i].style = 'display: none;';
                            vm.sideBarItems[i].state = '';
                            vm.sideBarItems[i].items[j].state = '';
                            vm.sideBarItems[i].items[j].icon = "fa fa-circle-o";
                            vm.sideBarItems[i].items[j].active = '';
                        }
                    } else {
                        for (var k = 0; k < vm.sideBarItems[i].items[j].items.length; k++) {
                            if (vm.sideBarItems[i].items[j].items[k].url == url) {
                                parent = i;
                                child = j;
                                lessChild = k;
                            } else {
                                vm.sideBarItems[i].open = '';
                                vm.sideBarItems[i].style = 'display: none;';
                                vm.sideBarItems[i].state = '';
                                vm.sideBarItems[i].items[j].open = '';
                                vm.sideBarItems[i].items[j].style = 'display: none;';
                                vm.sideBarItems[i].items[j].state = '';
                                vm.sideBarItems[i].items[j].items[k].state = '';
                                vm.sideBarItems[i].items[j].items[k].icon = "fa fa-circle-o";
                                vm.sideBarItems[i].items[j].items[k].active = '';
                            }
                        }
                    }
                }
            }

            if (parent != null && child != null) {
                if (lessChild == null) {
                    vm.sideBarItems[parent].open = 'menu-open';
                    vm.sideBarItems[parent].style = 'display: block;';
                    vm.sideBarItems[parent].state = 'active';

                    vm.sideBarItems[parent].items[child].state = 'active';
                    vm.sideBarItems[parent].items[child].icon = "fa fa-dot-circle-o";
                    vm.sideBarItems[parent].items[child].active = 'active';
                } else {
                    vm.sideBarItems[parent].open = 'menu-open';
                    vm.sideBarItems[parent].style = 'display: block;';
                    vm.sideBarItems[parent].state = 'active';

                    vm.sideBarItems[parent].items[child].open = 'menu-open';
                    vm.sideBarItems[parent].items[child].style = "display: block;";
                    vm.sideBarItems[parent].items[child].state = 'active';

                    vm.sideBarItems[parent].items[child].items[lessChild].state = 'active';
                    vm.sideBarItems[parent].items[child].items[lessChild].icon = "fa fa-dot-circle-o";
                    vm.sideBarItems[parent].items[child].items[lessChild].active = 'active';
                }
            }
        }

        function showSidebarItem() {
            angular.element('.treeview > a').each(function () {
                var t = $(this);
                if (t.hasClass('hidden')) {
                    t.parent().addClass('hidden-item');
                } else {
                    t.parent().addClass('visible-item');
                }
            });
        }

        $rootScope.$on('bluebookApp:updateFacilities', function (event, result) {
            for (var i = 0; i < vm.facilities.length && vm.facilities[i].id != result.id; i++) ;
            if (i == vm.facilities.length) {
                vm.facilities.push(result);
            } else {
                vm.facilities[i] = result;
            }
        });

        $rootScope.$on('bluebookApp:deleteFacilities', function (event, result) {
            for (var i = 0; i < vm.facilities.length && vm.facilities[i].id != result; i++) ;
            vm.facilities.splice(i, 1);
        });

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function deployFacilities(result) {
            vm.facilities = result;
            var force = false;

            if (vm.facilities.length > 0) {
                vm.currentFacility = CoreService.getCurrentFacility();

                if (vm.currentFacility) {
                    //Check if the current facility is in the list
                    var current = $.grep(vm.facilities, function (facility, i) {
                        return facility.id == vm.currentFacility.id;
                    })[0];

                    //user lost facility access
                    if (current) {
                        //update current facility
                        vm.currentFacility = current;

                        initMenu(vm.access);
                    } else {
                        vm.currentFacility = result[0];
                        force = true;

                        initMenu(vm.access);
                    }
                } else {
                    force = true;
                    vm.currentFacility = result[0];

                    initMenu(vm.access);
                }

                CoreService.setCurrentFacility(vm.currentFacility);

                if (previousState.name === 'login' || force) {
                    if ($state.current.name === 'dashboard') {
                        $state.go('.', {}, {reload: true});
                    } else {
                        $state.go('dashboard');
                    }
                }
            } else {
                vm.currentFacility = null;
                CoreService.setCurrentFacility(null);

                $state.go('dashboard-empty');

                initMenu(vm.access);
            }
        }

        function changeFacility() {
            CoreService.setCurrentFacility(vm.currentFacility);

            initMenu(vm.access);
            if ($state.current.name == 'dashboard') {
                $state.reload('dashboard');
            } else {
                $state.go('dashboard');
            }
        }

        function sortSubMenus() {
            _.forEach(vm.sideBarItems, function (parentItem) {
                if (parentItem.items && parentItem.items.length > 0) {
                    parentItem.items = _.sortBy(parentItem.items, 'displayName');
                }
            });
        }

        vm.clearChartFilter = clearChartFilter;
        vm.clearBedSheetFilter = clearBedSheetFilter;

        function clearChartFilter() {
            CoreService.setChartFilter(null);
        }

        function clearBedSheetFilter() {
            CoreService.setStorage('filterBedSheet', CoreService.initBedSheetFilter());
        }

        function clearCampaignOutreachFilter() {
            CoreService.setStorage('filterCampaignOutreach', CoreService.initCampaignOutreachFilter());
        }

        function selectCorporation() {
            CoreService.setCorporation(vm.corporation);
            vm.sideBarItems = [];

            $rootScope.$broadcast('bluebookApp:selectCorporation');

            Auth.loadResourceAccess(RESOURCES.RESOURCE_MAIN_MENU, vm.corporation).then(function (access) {
                vm.access = access.data;

                Facility.byCorporation({id: vm.corporation.id}, function (result) {
                    deployFacilities(result);
                });
            });
        }

        function getConfig(access) {
            vm.sideBarItems.push(
                {
                    id: 'config',
                    state: '',
                    open: '',
                    displayName: 'Configuration',
                    url: null,
                    icon: 'fa fa-cog',
                    style: 'display: none;',
                    access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG, access),
                    enable: true,
                    items: [
                        {
                            state: '',
                            displayName: 'Via',
                            url: 'via',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_VIA, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Business Credential',
                            url: 'business-credential',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Race',
                            url: 'type-race',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Discharge Type',
                            url: 'type-discharge-type',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Marital Status',
                            url: 'type-marital-status',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Roles',
                            url: 'role',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Insurance Audit Config',
                            url: 'insurance-billing-config',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Insurance Types',
                            url: 'insurance-type',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_TYPE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Insurance Relation',
                            url: 'insurance-relation',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Doses Form',
                            url: 'dose-form',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_DOSE_FORM, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Employee',
                            url: 'employee',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Concurrent Review Frequency',
                            url: 'concurrent-review-frequency',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Severity',
                            url: 'severity',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_SEVERITY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Reaction',
                            url: 'reaction',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_REACTION, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Allergen',
                            url: 'allergen',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_ALLERGEN, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Acuity',
                            url: 'acuity',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_ACUITY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Type of Check',
                            url: 'type-check',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Contact Facility Type',
                            url: 'type-contact-facility-type',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Ethnicity Types',
                            url: 'type-ethnicity',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Session Type',
                            url: 'session-type',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_GROUP_SESSION_FREQUENCY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Level Of Care',
                            url: 'type-level-care',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Patient Process',
                            url: 'type-patient-process',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Shift Type',
                            url: 'shift-type',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Rationale',
                            url: 'rationale',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_RATIONALE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Route',
                            url: 'route',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_ROUTE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Protocol Group',
                            url: 'protocol-group',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Contact Address',
                            url: 'contact-address',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Patient Medication Missed Reason',
                            url: 'patient-medication-take-missed-reason',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_PATIENT_MEDICATION_MISSED, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Incident Type',
                            url: 'incident-type',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Incident Department',
                            url: 'incident-department',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Payment Methods',
                            url: 'type-payment-methods',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Patient Contact Types',
                            url: 'type-patient-contact-types',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Insurance Level',
                            url: 'insurance-level',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Patient Contacts Relationship Types',
                            url: 'type-patient-contacts-relationship',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Speciality Types',
                            url: 'type-speciality',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Food Diets',
                            url: 'type-food-diets',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Glucose Intervention',
                            url: 'glucose-intervention',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Greeting',
                            url: 'greeting',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_GREETING, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Messages History',
                            url: 'message-history',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_MESSAGE_HISTORY, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'VerifyTX Schedule',
                            url: 'verifytx-schedule',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Chart Blocked',
                            icon: 'fa fa-circle-o',
                            url: 'chart-blocked',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_CHART_BLOCKED, access),
                            enable: true
                        },
                        // {
                        //     state: '',
                        //     displayName: 'Appointment Types',
                        //     url: 'appointment-type',
                        //     icon: 'fa fa-circle-o',
                        //     access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access),
                        //     enable: vm.currentFacility != null
                        // },
                        // {
                        //     state: '',
                        //     displayName: 'Blocked Time Reasons',
                        //     url: 'blocked-time-reason',
                        //     icon: 'fa fa-circle-o',
                        //     access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access),
                        //     enable: vm.currentFacility != null
                        // },
                        {
                            state: '',
                            displayName: 'Auto Fax',
                            url: 'auto-fax',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_AUTO_FAX, access),
                            enable: vm.currentFacility != null
                        },
                        // {
                        //     state: '',
                        //     displayName: 'Inst Claim Conf',
                        //     url: 'inst-claim-conf',
                        //     icon: 'fa fa-circle-o',
                        //     access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access),
                        //     enable: vm.currentFacility != null
                        // },
                        {
                            state: '',
                            displayName: 'Facility Icd10s',
                            url: 'facility-icd-10',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_ICD10, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Medications',
                            url: 'medication',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATIONS, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Incident Severity',
                            url: 'incident-severity',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY, access),
                            enable: true
                        },
                        //  jhipster-needle-sidebar
                    ]
                }
            );
        }

        function getAdminMenu(access) {
            vm.sideBarItems.push(
                {
                    id: 'config-admins',
                    state: '',
                    open: '',
                    displayName: 'Configuration Admins',
                    url: null,
                    icon: 'fa fa-cog',
                    style: 'display: none;',
                    access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                    enable: true,
                    items: [
                        {
                            state: '',
                            displayName: 'Supervisors',
                            url: 'employee-system',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Corporation',
                            url: 'corporation',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Facility',
                            url: 'facility',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: CoreService.getCorporation()
                        },
                        {
                            state: '',
                            displayName: 'Init Values',
                            url: 'init-value',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Documo',
                            url: 'documo',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Resources',
                            url: 'resource',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Fax Number',
                            url: 'fax-number',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Facility Phone Number',
                            url: 'facility-phone-number',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Reconnect Care Credential',
                            url: 'reconnect-care-credential',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'VerifyTX Credential',
                            url: 'verifytx-credential',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Billing Schedule',
                            url: 'billing-schedule',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Global message',
                            url: 'global-message',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Chart Export',
                            url: 'chart-export',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Pharmacy',
                            url: 'pharmacy',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        }
                    ]
                }
            );
        }

        function getLaboratoriesMenu(access) {
            vm.sideBarItems.push(
                {
                    id: 'laboratories',
                    displayName: 'Laboratories',
                    icon: 'fa fa-cog',
                    access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                    enable: true,
                    items: [
                        {
                            state: '',
                            displayName: 'Laboratory',
                            url: 'laboratory',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Lab Integration',
                            url: 'facility-lab',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Lab Compendium',
                            url: 'lab-compendium',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Tubes',
                            url: 'tube',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Specimens',
                            url: 'specimen',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Compendium Report Group',
                            url: 'compendium-report-group',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Lab Compendium Restriction',
                            url: 'lab-compendium-restriction',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Lab Requisition Consents',
                            url: 'lab-requisition-consent',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Send Lab Compendium',
                            url: 'send-lab-compendium',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Abnormal Alert',
                            url: 'abnormal-alert',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Processed Patient Orders',
                            url: 'processed-scheduler-item',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Processed Patient Results',
                            url: 'processed-patient-result',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Lab Logs',
                            url: 'lab-log',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                    ]
                }
            )
        }

        function getCovidMenu(access) {
            vm.sideBarItems.push(
                {
                    id: 'covid',
                    displayName: 'COVID RC',
                    icon: 'fa fa-cog',
                    access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG, access),
                    enable: true,
                    items: [
                        {
                            state: '',
                            displayName: 'Ports',
                            url: 'port',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_PORT, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Vessels',
                            url: 'vessel',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_VESSEL, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'RC Upload',
                            url: 'rc-upload',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_RC_UPLOAD_CHART, access),
                            enable: vm.currentFacility != null
                        },
                        {
                            state: '',
                            displayName: 'Covid Physician',
                            url: 'covid-physician',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Covid Icd 10',
                            url: 'covid-icd-10',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Covid Question',
                            url: 'covid-question',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_QUESTION, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Covid Facility',
                            url: 'covid-facility',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Covid Lab Integration',
                            url: 'covid-facility-lab',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Covid Lab Compendium',
                            url: 'covid-lab-compendium',
                            icon: 'fa fa-circle-o',
                            access: Auth.resourceAuthorize(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access),
                            enable: true
                        }
                    ]
                }
            )
        }

        function getRcopiaConfig(access) {
            vm.sideBarItems.push(
                {
                    id: 'config',
                    state: '',
                    open: '',
                    displayName: 'Rcopia',
                    url: null,
                    icon: 'fa fa-cog',
                    style: 'display: none;',
                    access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                    enable: true,
                    items: [
                        {
                            state: '',
                            displayName: 'Practice Info',
                            url: 'rcopia-practice-info',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Accounts',
                            url: 'rcopia-account',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Allergy Groups',
                            url: 'rcopia-allergy-group',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'SSO Logs',
                            url: 'rcopia-sso-log',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'SSO Url Logs',
                            url: 'rcopia-sso-url-log',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Last Update Dates',
                            url: 'rcopia-last-update-date',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'APIs',
                            url: 'rcopia-apis',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN].join(),
                            enable: true
                        },
                        {
                            state: '',
                            displayName: 'Drugs',
                            url: 'rcopia-drug',
                            icon: 'fa fa-circle-o',
                            access: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM].join(),
                            enable: true
                        }
                    ]
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        alert(222);
        console.log('ddddddddddddddddddddddddddddddddddddddddddddddddddddddddddd')

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            alert(  vm.isNavbarCollapsed );
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            alert('asss');

            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

/**
 * Created by hermeslm on 10/2/16.
 */

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MainController', MainController);

    MainController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService',
        'LoginService', 'AdminLTEService'];

    function MainController ($scope, $state, Auth, Principal, ProfileService, LoginService, AdminLTEService) {
        var vm = this;

        vm.toggleBtn = '[data-toggle="offcanvas"]';

        vm.account = null;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

/**
 * Created by hermeslm on 10/2/16.
 */

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('HeaderController', HeaderController);

    HeaderController.$inject = ['$scope', '$state', 'Auth', 'Principal', 'ProfileService', '$uibModalStack', 'LoginService', 'employee',
        'APP', 'Employee', 'CoreService', 'Idle', '$uibModal', 'IDLE', '$rootScope', 'Notifications',
        'ParseLinks', 'AlertService', 'toastr', 'Chart', 'CrmOpportunity', 'showNewChart',
        '$window', 'Rcopia', '$interval', 'RcopiaUtils'];

    function HeaderController($scope, $state, Auth, Principal, ProfileService, $uibModalStack, LoginService, employee,
                              APP, Employee, CoreService, Idle, $uibModal, IDLE, $rootScope, Notifications,
                              ParseLinks, AlertService, toastr, Chart, CrmOpportunity, showNewChart,
                              $window, Rcopia, $interval, RcopiaUtils) {

        var vm = this;

        vm.itemsPerPage = 20;

        vm.appName = APP.APP_NAME;

        vm.appSuffixName = APP.APP_SUFFIX_NAME;
        vm.appShortName = APP.APP_SHORT_NAME;
        vm.toggleBtn = '[data-toggle="offcanvas"]';
        vm.checkFacility = null;
        vm.account = null;
        vm.employeeAccount = null;
        vm.countNoViewedMessages = 0;
        vm.employeeId = CoreService.getCurrentEmployee().userId;

        vm.isNavbarCollapsed = true;
        vm.searchKeyword = '';
        vm.option = 'charts';
        $rootScope.showNewChart = showNewChart.value;
        vm.showNewChart = $rootScope.showNewChart;
        vm.isSmallDevice = $window.outerWidth < 1150;

        vm.employee = employee;
        vm.rcopiaNotifications = [];
        vm.rcopiaTotalNotifications = 0;
        vm.corporation = CoreService.getCorporation();
        vm.interval = $interval(getNotificationCount, 60000);

        //Functions
        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.employeeFullName = employeeFullName;
        vm.roleTypeEmployee = roleTypeEmployee;
        vm.openChart = openChart;
        vm.changePassModal = changePassModal;
        vm.replaceSignatureModal = replaceSignatureModal;
        vm.showFeaturePreview = showFeaturePreview;
        vm.getNotificationCount = getNotificationCount;
        vm.rcopiaPopup = rcopiaPopup;
        vm.getNotificationLabel = getNotificationLabel;
        vm.findValue = findValue;

        function changePassModal() {
            $uibModal.open({
                templateUrl: 'app/account/password/password-dialog.html',
                controller: 'PasswordChangeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {
                // $state.reload();
            }, function (result) {
            });
        }

        function replaceSignatureModal() {
            $uibModal.open({
                templateUrl: 'app/account/signature/signature-dialog.html',
                controller: 'SignatureChangeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {
            }, function (result) {
            });
        }

        vm.globalfilter = globalFilter;

        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.facilities = [];
        vm.currentFacility = null;

        vm.$state = $state;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        getNotificationCount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function employeeFullName() {
            if (vm.account)
                return vm.account.firstName + ' ' + vm.account.lastName;
            else
                return 'System';
        }

        function roleTypeEmployee() {
            if (vm.employee) {
                return vm.employee.typeEmployee ? vm.employee.typeEmployee.name : 'Super Admin';
            }
        }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            CoreService.clearSession();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        // function getEmployee() {
        //     Employee.employeeAccount().$promise.then(function (employee) {
        //             vm.employee = employee;
        //             // vm.employee.avatar = CoreService.getAvatar(employee.gender);
        //             CoreService.setCurrentEmployee(vm.employee);
        //             // $rootScope.$broadcast('employeeGotten');
        //         }, function (reason) {
        //             console.log('Failed getting employee: ' + reason.statusText);
        //         }
        //     );
        // }

        vm.countdown = IDLE.timeout;

        closeModals();

        function closeModals() {
            if (vm.warning) {
                vm.warning.close();
                vm.warning = null;
            }
        }

        var openedModal;

        $rootScope.$on('IdleStart', function () {
            closeModals();

            openedModal = $uibModalStack.getTop();

            vm.warning = $uibModal.open({
                templateUrl: 'warning-dialog.html',
                windowTopClass: 'modal-danger'
            });
        });

        $rootScope.$on('IdleEnd', function () {
            closeModals();

            vm.countdown = IDLE.timeout;
        });

        $rootScope.$on('IdleTimeout', function () {
            closeModals();

            if (openedModal) {
                $uibModalStack.dismiss(openedModal.key);
            }

            logout();
        });

        Idle.watch();


        //////////////NOTIFICATIONS/////////////


        vm.notifications = [];
        vm.notificationsCount = 0;
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.saveViewed = saveViewed;
        vm.notificationsNewCount = 0;
        vm.notificationsByCreatedDateCount = 0;

        //loadAllByCreatedDate();


        if (CoreService.getCurrentEmployee().id !== null) {
            loadAllByViewed();

            loadAll();
        }

        function loadAllByCreatedDate() {

            var fromDate = new Date();

            Notifications.findAllByCreatedDate({
                createdDate: fromDate,
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.notificationsByCreatedDateCount = data.length;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAllByViewed() {
            Notifications.findAllByViewed({
                viewed: false,
                employeeId: CoreService.getCurrentEmployee().id
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.notificationsNewCount = data.length;
                refreshScope();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAll() {
            if (CoreService.getCurrentEmployee().id !== null) {
                Notifications.findAll({
                    employeeId: CoreService.getCurrentEmployee().id,
                    page: vm.page,
                    size: 15
                }, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.notifications.push(data[i]);
                    refreshScope();
                }
                vm.notificationsCount = vm.notifications.length;
                refreshScope();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset() {
            vm.page = 0;
            vm.notifications = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear() {
            vm.notifications = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function saveViewed(notification) {
            vm.isSaving = true;

            $state.go(notification.state, {}, {reload: false});
            if ((notification.id !== null) && (notification.viewed == false)) {
                notification.viewed = true;
                notification.employee = CoreService.getCurrentEmployee();
                Notifications.update(notification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            //$scope.$emit('bluebookApp:notificationsUpdate', result);
            vm.isSaving = false;
            vm.notifications = [];
            vm.page = 0;
            loadAllByViewed();
            loadAll();
            //$state.reload();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.notifications = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

        //Refresh scope UI
        function refreshScope() {
            //if (!$scope.$$phase) {
            $scope.$applyAsync();
            //}
        }

        function globalFilter(searchQuery) {
            if (searchQuery && searchQuery != '') {

                var filter = {};
                filter.searchQuery = searchQuery;
                filter.facilityId = null;
                filter.corporationId = null;
                filter.page = 0;
                filter.size = vm.itemsPerPage;

                vm.charts = [];
                vm.opportunities = [];

                switch (vm.option) {
                    case 'all' :
                        filterCharts(filter);
                        filterCrmOpportunities(filter);

                        break;
                    case 'charts' :
                        filterCharts(filter);

                        break;
                    case 'opportunities' :
                        filterCrmOpportunities(filter);

                        break;
                }
            }
        }

        function filterCharts(filter) {
            vm.facility = CoreService.getCurrentFacility();

            if (vm.facility) {
                filter.facilityId = vm.facility.id;
                Chart.fullFilter(filter, function (result) {
                    vm.charts = result;
                });
            }
        }

        function filterCrmOpportunities(filter) {
            vm.corporation = CoreService.getCorporation();

            if (vm.corporation) {
                filter.corporationId = vm.corporation.id;
                CrmOpportunity.findAllByFilter(filter, function (result) {
                    vm.opportunities = result;
                });
            }
        }

        function openChart(id) {
            vm.searchQuery = null;
            vm.charts = [];
            $state.go('chart', {id: id});
        }

        function showFeaturePreview() {
            $uibModal.open({
                templateUrl: 'app/entities/employee-new-chart/new-chart-preview-dialog.html',
                controller: 'NewChartPreviewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            });
        }

        $rootScope.$watch('showNewChart', function (newVal) {
            if (newVal) {
                vm.showNewChart = newVal;
            }
        })

        var unsubscribe = $rootScope.$on('bluebookApp:selectCorporation', function (event, result) {
            vm.getNotificationCount();
        });

        $scope.$on('$destroy', unsubscribe);
        $scope.$on('$destroy', function () {
            $interval.cancel(vm.interval);
        });

        function getNotificationCount() {
            vm.corporation = CoreService.getCorporation();

            if (vm.corporation && vm.corporation.rcopiaIntegration) {
                Rcopia.getNotificationCount({corporationId: vm.corporation.id}, function (result) {
                    vm.rcopiaNotifications = result;

                    vm.rcopiaTotalNotifications = _.sum(_.map(vm.rcopiaNotifications, 'number'));
                });
            }
        }

        function rcopiaPopup(type) {
            var startupScreen = '';

            switch (type) {
                //Refills and RxChange requests can be accessed by launching to the Message screen
                // (startup_screen = message in the SSO request).
                case 'refill':
                case 'rxchange':
                    startupScreen = "message";
                    break;
                //Pending prescriptions and prescriptions needing signing can be accessed by launching to the Report screen
                // (startup_screen = report in the SSO request).
                case 'rx_pending':
                case 'rx_need_signing':
                    startupScreen = "report";
                    break;
            }

            RcopiaUtils.launchRcopiaPopup(startupScreen, 'limpMode');
        }

        function getNotificationLabel(type) {
            switch (type) {
                //Prescription Report
                case 'rx_pending':
                    return 'Rx Pending';
                case 'rx_need_signing':
                    return 'Rx Sent - Not Signed'

                //Pharmacy Message
                case 'rxchange':
                    return 'Rx Change Requests'
                case 'refill':
                    return 'Rx Renewals Awaiting';
            }
        }

        function findValue(type) {
            var notification = _.find(vm.rcopiaNotifications, ['type', type]);
            return notification ? notification.number : 0;
        }
    }
})();


/**
 * Created by hermeslm on 10/2/16.
 */

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['AdminLTEService', '$timeout', '$rootScope'];

    function FooterController(AdminLTEService, $timeout, $rootScope) {

        var vm = this;

        $rootScope.$on('$viewContentLoading',
            function (event, viewConfig) {
                // Access to all the view config properties.
                // and one special property 'targetView'
                // viewConfig.targetView
                $timeout(function () {
                    $timeout(function () {
                        AdminLTEService.layoutFix();
                    }, 0);
                }, 0);
            });

    }
})();


(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            })
            .state('maintenance', {
                parent: 'app',
                url: '/maintenance',
                ncyBreadcrumb: {
                    label: 'Maintenance'
                },
                data: {
                    authorities: [],
                    pageTitle: 'Under Construction'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/construction.html',
                        controller: 'ConstructionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'maintenance',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConstructionController', ConstructionController);

    ConstructionController.$inject = ['previousState'];

    function ConstructionController (previousState) {
        var vm = this;
        vm.previousState = previousState.name;

    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ControlBarController', ControlBarController);

    ControlBarController.$inject = ['$rootScope', '$scope', '$state', 'Auth', 'Principal',
        'ProfileService', 'LoginService', 'AdminLTEService', 'CoreService'];

    function ControlBarController($rootScope, $scope, $state, Auth, Principal, ProfileService,
                                  LoginService, AdminLTEService, CoreService) {
        var vm = this;
        vm.isControlbarCollapsed = true;
        AdminLTEService.registerControlSidebar();

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });
    }
})();


/**
 * Created by hmendez on 07/05/2015.
 */
(function () {
    'use strict';

    angular.module('bluebookApp').factory('BBEventDataFactory', BBEventDataFactory);

    BBEventDataFactory.$inject = [];

    function BBEventDataFactory() {

        var observers = [];
        var data = {};

        var registerObserver = function (channels, observer) {
            observer.channels = channels;
            observers.push(observer);
        }

        var notifyObservers = function (channel, data) {
            for (var index = 0; index < observers.length; ++index) {
                if (observers[index].channels.indexOf(channel) != -1) {
                    observers[index].notify(data);
                }
            }
        }

        var setData = function (channel, data) {
            data.channel = channel;
            this.data = data;
            notifyObservers(channel, data);
        }

        var getData = function () {
            return this.data;
        }

        return {
            registerObserver: registerObserver,
            setData: setData,
            getData: getData
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            ncyBreadcrumb: {
                label: 'Home'
            },
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                dashboard: function () {
                    return {
                        unsignedOrdersByDoctor: 0,
                        unsignedOrders: 0,
                        unassignedLabResult: 0,
                        unsignedForms: 0,
                        unsignedEvaluations: 0,
                        concurrentReviews: 0,
                        freeMaleBeds: 0,
                        freeFemaleBeds: 0
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'LoginService', '$state', 'CoreService'];

    function HomeController($scope, LoginService, $state, CoreService) {
        var vm = this;

        //vm.facility = CoreService.getCurrentFacility();
        // vm.employee = CoreService.getCurrentEmployee();
        //
        //if (vm.facility) {
       $state.go("dashboard");
        //}
        // else {
        //     setTimeout(function () {
        //         $state.go("dashboard");
        //     }, 2000);
        // }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DatePickerDialogController', DatePickerDialogController);

    DatePickerDialogController.$inject = ['date', '$uibModalInstance'];

    function DatePickerDialogController (date, $uibModalInstance) {
        var vm = this;

        vm.date = date;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.openCalendar = openCalendar;
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.accept = function () {
            $uibModalInstance.close({date: vm.date});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('WeightDialogController', WeightDialogController);

    WeightDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Weight', 'DateUtils'];

    function WeightDialogController ($timeout, $scope, $uibModalInstance, entity, Weight, DateUtils) {
        var vm = this;

        vm.weight = entity;
        vm.clear = clear;
        vm.save = save;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        vm.height = {feet: null, inches: null};

        if (vm.weight.id && !isNaN(vm.weight.height)) {
            vm.height = {feet: Math.floor(vm.weight.height / 12) , inches: vm.weight.height % 12};
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            vm.weight.height = vm.height.feet * 12 + vm.height.inches;

            vm.weight.bmi = (vm.weight.weight / ( vm.weight.height * vm.weight.height)) * 703;

            if (vm.weight.id !== null) {
                Weight.update(vm.weight, onSaveSuccess, onSaveError);
            } else {
                Weight.save(vm.weight, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:weightUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Weight', Weight);

    Weight.$inject = ['$resource', 'DateUtils'];

    function Weight ($resource, DateUtils) {
        var resourceUrl =  'api/weights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                        data.weight = parseFloat(data.weight);
                        data.height = parseFloat(data.height);
                    }
                    return data;
                }
            },
            'byChart': { url: 'api/weights/by-chart/', method: 'GET', isArray: true },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('WeightController', WeightController);

    WeightController.$inject = ['$compile', '$scope', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter',
        'Weight', '$rootScope', 'GUIUtils', '$uibModal', 'chart', '$uibModalInstance', 'CoreService',
        'ConfirmationService', '$uibModalStack'];

    function WeightController($compile, $scope, $q, DTColumnBuilder, DTOptionsBuilder, $filter, Weight,
                              $rootScope, GUIUtils, $uibModal, chart, $uibModalInstance, CoreService,
                              ConfirmationService, $uibModalStack) {
        var vm = this;
        vm.clear = clear;

        vm.chart = chart;
        vm.weights = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.clear = clear;
        vm.search = search;
        vm.edit = edit;
        vm.del = del;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Weight.byChart(
                {
                    chartId: vm.chart.id,
                    page: vm.page - 1,
                    size: vm.itemsPerPage
                }, function (result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.weights = result;
                    defer.resolve(vm.weights);
                });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notVisible().renderWith(function (data, type, full) {
                return data ? moment(data.date).format("YYYYMMDD") : "";
            }),
            DTColumnBuilder.newColumn('date').withTitle('Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn('weight').withTitle('Weight').renderWith(function (data, type, full) {
                return data ? _.ceil(data, 2) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Height').renderWith(function (data, type, full) {
                return CoreService.getHeightInchesToFeetInches(data.height);
            }),
            DTColumnBuilder.newColumn('bmi').withTitle('BMI').renderWith(function (data, type, full) {
                return data ? _.ceil(data, 2) : "";
            }),
            DTColumnBuilder.newColumn('createdBy').withTitle('Created By'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.chart.status) {
                stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function edit(id) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/weight/update/weight-dialog.html',
                controller: 'WeightDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['Weight', function (Weight) {
                        return Weight.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Weight').result.then(function () {
                Weight.delete({id: id}, function () {
                    search();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('WeightChartController', WeightChartController);

    WeightChartController.$inject = ['chart', 'Weight', 'CoreService', '$uibModal', '$scope', '$rootScope', 'access', 'ACTIONS', 'Auth'];

    function WeightChartController(chart, Weight, CoreService, $uibModal, $scope, $rootScope, access, ACTIONS, Auth) {
        var vm = this;
        vm.chart = chart;

        vm.selectGraphData = selectGraphData;
        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.history = history;
        vm.getHeightInchesToFeetInches = getHeightInchesToFeetInches;

        vm.dataW = [];

        vm.weightData = {
            values: [],
            key: 'Weight',
            color: '#ffffff'
        };

        vm.bmiData = {
            values: [],
            key: 'BMI',
            color: '#ffffff'
        };

        vm.optionsW = {
            chart: {
                type: 'lineChart',
                showLegend: false,
                height: 340,
                margin : {
                    top: 20,
                    right: 50,
                    bottom: 100,
                    left: 50
                },
                x: function(d){ return d.x; },
                y: function(d){ return d.y; },
                useInteractiveGuideline: true,
                xAxis: {
                    tickFormat: function (d) {
                        return d3.time.format('%m/%d/%y-%H:%M')(new Date(d));
                    },
                    showMaxMin: false,
                    rotateLabels:(-70)
                },
                yAxis: {
                    tickFormat: function(d){
                        return d3.format('.02f')(d);
                    },
                    showMaxMin: false
                }
            }
        };

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_WEIGHT_VIEW, access)) {
                return;
            }

            Weight.byChart({chartId: chart.id, page: 0, size: 10}, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');

                if (vm.totalItems > 0) {
                    vm.weight = result[0];
                    vm.weight.bmi = _.ceil(result[0].bmi, 2)
                }

                for (var i = result.length - 1; i >= 0; i--) {
                    vm.weightData.values.push({x: new Date(result[i].date).getTime(), y: parseFloat(result[i].value)});
                    vm.bmiData.values.push({x: new Date(result[i].date).getTime(), y: parseFloat(result[i].value)});
                }

                vm.selectGraphData('weight');
            });
        }

        function selectGraphData(value) {
            switch (value) {
                case 'weight' : {
                    vm.dataW = [];
                    vm.dataW.push(vm.weightData);

                    break;
                }
                case 'bmi' : {
                    vm.dataW = [];
                    vm.dataW.push(vm.bmiData);

                    break;
                }
            }
        }

        function toggleItem() {
            CoreService.togglePanel('weight');
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/weight/update/weight-dialog.html',
                controller: 'WeightDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            id: null,
                            chart: chart,
                            date: new Date()
                        };
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/weight/history/weight.html',
                controller: 'WeightController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function getHeightInchesToFeetInches(height) {

            return CoreService.getHeightInchesToFeetInches(height);
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartWeightHistory', function (event, result) {
            history();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VitalsDialogController', VitalsDialogController);

    VitalsDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Vitals', 'CoreService'];

    function VitalsDialogController ($timeout, $scope,  $uibModalInstance, entity, Vitals, CoreService) {
        var vm = this;
        vm.vitals = entity;
        vm.facility = CoreService.getCurrentFacility();

        vm.datePickerOpenStatus = {};
        vm.form = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            var date = moment.tz(moment(vm.vitals.date).format('YYYY-MM-DDTHH:mm:00'), vm.facility.timeZone).format();
            var vitals = angular.copy(vm.vitals);
            vitals.date = date;

            if (vm.vitals.id !== null) {
                Vitals.update(vitals, onSaveSuccess, onSaveError);
            } else {
                Vitals.save(vitals, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:vitalsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Vitals', Vitals);

    Vitals.$inject = ['$resource', 'DateUtils', 'CoreService'];

    function Vitals($resource, DateUtils, CoreService) {
        var resourceUrl = 'api/vitals/:id';
        var facility = CoreService.getCurrentFacility();

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        data.date = new Date(DateUtils.convertDateTimeFromServer(data.date)
                            .toLocaleString("en-US", {timeZone: facility.timeZone}));

                        data.bpSystolic = parseFloat(data.bpSystolic);
                        data.bpDiastolic = parseFloat(data.bpDiastolic);
                        data.temperature = parseFloat(data.temperature);
                        data.pulse = parseFloat(data.pulse);
                        data.respiration = parseFloat(data.respiration);
                        data.o2Saturation = parseFloat(data.o2Saturation);
                    }
                    return data;
                }
            },
            'findAllByChart': {url: 'api/vitals/by-chart/:id', method: 'GET', isArray: true},
            'update': {method: 'PUT'},
            'findLastByChart': {
                url: 'api/vitals/last/by-chart/:id', method: 'GET', transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        data.date = new Date(DateUtils.convertDateTimeFromServer(data.date)
                            .toLocaleString("en-US", {timeZone: facility.timeZone}));
                    }
                    return data;
                }
            },
            'findLastBp': {url: "api/vitals/last/bp/by-chart/:id/size/:size", method: 'GET', isArray: true},
            'findLastTemp': {url: "api/vitals/last/temp/by-chart/:id/size/:size", method: 'GET', isArray: true},
            'findLastRespiration': {
                url: "api/vitals/last/respiration/by-chart/:id/size/:size",
                method: 'GET',
                isArray: true
            },
            'findLastPulse': {url: "api/vitals/last/pulse/by-chart/:id/size/:size", method: 'GET', isArray: true},
            'findLastO2': {url: "api/vitals/last/o2/by-chart/:id/size/:size", method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VitalsController', VitalsController);

    VitalsController.$inject = ['$uibModalInstance', 'chart', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$compile',
        '$scope', '$rootScope', '$uibModal', 'CoreService', 'Vitals', 'ConfirmationService',
        '$uibModalStack'];

    function VitalsController($uibModalInstance, chart, $q, DTColumnBuilder, DTOptionsBuilder, $compile,
                              $scope, $rootScope, $uibModal, CoreService, Vitals, ConfirmationService,
                              $uibModalStack) {
        var vm = this;

        vm.vitals = [];
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.dtInstance = {};
        vm.chart = chart;
        vm.facility = CoreService.getCurrentFacility();

        vm.clear = clear;
        vm.search = search;
        vm.edit = edit;
        vm.del = del;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Vitals.findAllByChart(
                {
                    id: vm.chart.id,
                    page: vm.page - 1,
                    size: vm.itemsPerPage
                }, function (result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.vitals = result;
                    defer.resolve(vm.vitals);
                });

            return defer.promise;

        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notVisible().renderWith(function (data, type, full) {
                return data ? moment(data.date).format("YYYYMMDD") : "";
            }),
            DTColumnBuilder.newColumn('date').withTitle('Date').renderWith(function (data, type, full) {
                // new Date(DateUtils.convertDateTimeFromServer(data.date)
                //     .toLocaleString("en-US", {timeZone: facility.timeZone}));

                return data ? moment(new Date(data)
                    .toLocaleString("en-US", {timeZone: vm.facility.timeZone})).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Blood Presure').renderWith(function (data, type, full) {
                return data.bpSystolic && data.bpDiastolic ? data.bpSystolic + " / " + data.bpDiastolic : " - ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Temperature').renderWith(function (data, type, full) {
                return data.temperature ? data.temperature : " - ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Pulse').renderWith(function (data, type, full) {
                return data.pulse ? data.pulse : " - ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Respiration').renderWith(function (data, type, full) {
                return data.respiration ? data.respiration : " - ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('O<sup>2</sup> Saturation').renderWith(function (data, type, full) {
                return data.o2Saturation ? data.o2Saturation : " - ";
            }),
            DTColumnBuilder.newColumn('createdBy').withTitle('Created by'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function edit(id) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/vitals/update/vitals-dialog.html',
                controller: 'VitalsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['Vitals', function (Vitals) {
                        return Vitals.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Vitals').result.then(function () {
                Vitals.delete({id: id}, function () {
                    search();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VitalsChartController', VitalsChartController);

    VitalsChartController.$inject = ['chart', 'Vitals', 'CoreService', '$uibModal', '$scope', '$rootScope', 'access',
        'ACTIONS', 'Auth'];

    function VitalsChartController(chart, Vitals, CoreService, $uibModal, $scope, $rootScope, access,
                                   ACTIONS, Auth) {
        var vm = this;
        vm.chart = chart;

        vm.selectGraphData = selectGraphData;
        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.history = history;

        vm.dataVitals = [];

        vm.systolicData = {
            values: [],
            key: 'Systolic',
            color: '#ffffff'
        };

        vm.diastolicData = {
            values: [],
            key: 'Diastolic',
            color: '#ffffff'
        };

        vm.tempData = {
            values: [],
            key: 'Temperature',
            color: '#ffffff'
        };

        vm.pulseData = {
            values: [],
            key: 'Pulse',
            color: '#ffffff'
        };

        vm.respirationData = {
            values: [],
            key: 'Respiration',
            color: '#ffffff'
        };

        vm.o2Data = {
            values: [],
            key: 'O2 Saturation',
            color: '#ffffff'
        };

        vm.optionsVitals = {
            chart: {
                type: 'lineChart',
                showLegend: false,
                height: 340,
                margin: {
                    top: 20,
                    right: 50,
                    bottom: 100,
                    left: 50
                },
                x: function (d) {
                    return d.x;
                },
                y: function (d) {
                    return d.y;
                },
                useInteractiveGuideline: true,
                xAxis: {
                    tickFormat: function (d) {
                        return d3.time.format('%m/%d/%y-%H:%M')(new Date(d));
                    },
                    showMaxMin: false,
                    rotateLabels:(-70)
                },
                yAxis: {
                    tickFormat: function (d) {
                        return d3.format('.02f')(d);
                    },
                    showMaxMin: false
                }
            }
        };

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_VITALS_VIEW, access)) {
                return;
            }

            vm.vitals = Vitals.findLastByChart({id: chart.id}, function(result) {
                if (result) {
                    vm.isVitalsDayOld = moment(new Date()).diff(moment(result.date), 'hours', true) > 24;
                }
            });

            Vitals.findLastBp({id: chart.id, size: 10}, function (data) {
                for (var i = data.length - 1; i >= 0; i--) {
                    vm.systolicData.values.push({x: new Date(data[i].date).getTime(), y: parseFloat(data[i].value1)});
                    vm.diastolicData.values.push({x: new Date(data[i].date).getTime(), y: parseFloat(data[i].value2)});
                }

                vm.selectGraphData('blood');
            });

            Vitals.findLastTemp({id: chart.id, size: 10}, function (data) {
                deployList(vm.tempData, data);
            });

            Vitals.findLastRespiration({id: chart.id, size: 10}, function (data) {
                deployList(vm.respirationData, data);
            });

            Vitals.findLastPulse({id: chart.id, size: 10}, function (data) {
                deployList(vm.pulseData, data);
            });

            Vitals.findLastO2({id: chart.id, size: 10}, function (data) {
                deployList(vm.o2Data, data);
            });
        }

        function selectGraphData(value) {
            switch (value) {
                case 'blood' : {
                    vm.dataVitals = [];
                    vm.dataVitals.push(vm.systolicData);
                    vm.dataVitals.push(vm.diastolicData);

                    break;
                }
                case 'temp' : {
                    vm.dataVitals = [];
                    vm.dataVitals.push(vm.tempData);

                    break;
                }
                case 'pulse' : {
                    vm.dataVitals = [];
                    vm.dataVitals.push(vm.pulseData);

                    break;
                }
                case 'respiration' : {
                    vm.dataVitals = [];
                    vm.dataVitals.push(vm.respirationData);
                    break;
                }
                case 'o2' : {
                    vm.dataVitals = [];
                    vm.dataVitals.push(vm.o2Data);
                    break;
                }
            }
        }

        function deployList(list, data) {
            for (var i = data.length - 1; i >= 0; i--) {
                list.values.push({x: new Date(data[i].date).getTime(), y: parseFloat(data[i].value1)});
            }
        }

        function toggleItem() {
            CoreService.togglePanel('vitals');
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/vitals/update/vitals-dialog.html',
                controller: 'VitalsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            status: null,
                            id: null,
                            chart: chart,
                            date: new Date()
                        };
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/vitals/history/vitals.html',
                controller: 'VitalsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartVitalsHistory', function (event, result) {
           history();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('via', {
                parent: 'entity',
                url: '/via',
                data: {
                    authorities: [],
                    pageTitle: 'Vias'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/via/list/via.html',
                        controller: 'ViaController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Via'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_VIA];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_VIA, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ViaDialogController', ViaDialogController);

    ViaDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Via'];

    function ViaDialogController ($timeout, $scope, $uibModalInstance, entity, Via) {
        var vm = this;

        vm.via = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.via.id !== null) {
                Via.update(vm.via, onSaveSuccess, onSaveError);
            } else {
                Via.save(vm.via, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:viaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Via', Via);

    Via.$inject = ['$resource'];

    function Via ($resource) {
        var resourceUrl =  'api/vias/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/vias/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ViaController', ViaController);

    ViaController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Via', '$uibModal', 'ConfirmationService',
        '$q'];

    function ViaController(GenericEntityDatatableService, CoreService, Via, $uibModal, ConfirmationService,
                           $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Via',
            newButtonTitle: 'New Via',
            entityClassHumanized: 'Via',
            entityStateName: 'via',
            service: Via,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Via',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/via/update/via-dialog.html',
                controller: 'ViaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/via/update/via-dialog.html',
                controller: 'ViaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Via', function (Via) {
                        return Via.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Via').result.then(function () {
                    Via.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('vessel', {
                parent: 'entity',
                url: '/vessel',
                data: {
                    authorities: [],
                    pageTitle: 'Vessels'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/vessel/list/vessel.html',
                        controller: 'VesselController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_VESSEL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_VESSEL, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VesselDialogController', VesselDialogController);

    VesselDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Vessel'];

    function VesselDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Vessel) {
        var vm = this;

        vm.vessel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.vessel.id !== null) {
                Vessel.update(vm.vessel, onSaveSuccess, onSaveError);
            } else {
                Vessel.save(vm.vessel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:vesselUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Vessel', Vessel);

    Vessel.$inject = ['$resource'];

    function Vessel ($resource) {
        var resourceUrl =  'api/vessels/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/vessels/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VesselController', VesselController);

    VesselController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Vessel', '$uibModal', 'ConfirmationService',
        '$q'];

    function VesselController(GenericEntityDatatableService, CoreService, Vessel, $uibModal, ConfirmationService,
                              $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Vessel',
            newButtonTitle: 'New Vessel',
            entityClassHumanized: 'Vessel',
            entityStateName: 'vessel',
            service: Vessel,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Vessel',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/vessel/update/vessel-dialog.html',
                controller: 'VesselDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/vessel/update/vessel-dialog.html',
                controller: 'VesselDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Vessel', function (Vessel) {
                        return Vessel.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Vessel').result.then(function () {
                    Vessel.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('verifytx-schedule', {
                parent: 'entity',
                url: '/verifytx-schedule',
                data: {
                    authorities: [],
                    pageTitle: 'VerifytxSchedules'
                },
                ncyBreadcrumb: {
                    label: 'VerifyTX Schedule'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/verifytx-schedule/list/verifytx-schedule.html',
                        controller: 'VerifytxScheduleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE, access);
                }]
            })
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxScheduleDialogController', VerifytxScheduleDialogController);

    VerifytxScheduleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'VerifytxSchedule', 'GUIUtils', 'Employee'];

    function VerifytxScheduleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                               VerifytxSchedule, GUIUtils, Employee) {
        var vm = this;

        vm.verifytxSchedule = entity;
        vm.days = GUIUtils.getDays();
        vm.schedule = GUIUtils.weekCodeStringToDays(vm.verifytxSchedule.schedule);

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.verifytxSchedule.schedule = GUIUtils.daysToWeekCodeString(vm.schedule);

            vm.isSaving = true;
            if (vm.verifytxSchedule.id !== null) {
                VerifytxSchedule.update(vm.verifytxSchedule, onSaveSuccess, onSaveError);
            } else {
                VerifytxSchedule.save(vm.verifytxSchedule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:verifytxScheduleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.verifytxSchedule.corporation.id};

                Employee.findAllByCorporation(filter, function (result) {
                    vm.employees = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('VerifytxSchedule', VerifytxSchedule);

    VerifytxSchedule.$inject = ['$resource'];

    function VerifytxSchedule ($resource) {
        var resourceUrl =  'api/verifytx-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByCorporation': {url: 'api/verifytx-schedules/corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxScheduleController', VerifytxScheduleController);

    VerifytxScheduleController.$inject = ['GenericEntityDatatableService', 'CoreService', 'VerifytxSchedule', '$q', '$uibModal',
        'GUIUtils', 'Verifytx', 'toastr', 'Principal', 'ROLES', 'ConfirmationService'];

    function VerifytxScheduleController(GenericEntityDatatableService, CoreService, VerifytxSchedule, $q,
                                        $uibModal, GUIUtils, Verifytx, toastr, Principal, ROLES, ConfirmationService) {
        var vm = this;

        vm.totalItems = 0;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'VerifyTX Schedule',
            newAction: false,
            entityClassHumanized: 'VerifyTX Schedule',
            entityStateName: 'verifytx-schedule',
            service: VerifytxSchedule,
            serviceMethod: 'getAllByCorporation',
            params: params,
            columns: [
                {
                    name: null,
                    title: 'Schedule',
                    render: function (data) {
                        return GUIUtils.weekCodeStringToDays(data.schedule);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New VerifyTX Schedule',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0;
                            }
                        })
                    ]
                },
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSendAction(), {
                            name: 'Send verifyTX emails',
                            action: function () {
                                sendVobsByEmail();
                            },
                            ngIf: function () {
                                return Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN]);
                            }
                        })
                    ]
                }
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/verifytx-schedule/update/verifytx-schedule-dialog.html',
                    controller: 'VerifytxScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                id: null,
                                schedule: '0000000',
                                corporation: CoreService.getCorporation()
                            };
                        }]
                    }
                }).result.then(function () {
                    toastr.success('VerifyTX Schedule was saved', 'Success');

                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/verifytx-schedule/update/verifytx-schedule-dialog.html',
                    controller: 'VerifytxScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['VerifytxSchedule', function (VerifytxSchedule) {
                            return VerifytxSchedule.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    toastr.success('VerifyTX Schedule was saved', 'Success');

                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Verifytx Schedule').result.then(function () {
                    VerifytxSchedule.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function sendVobsByEmail() {
            Verifytx.sendVobsByEmail({facilityId: CoreService.getCurrentFacility().id});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('verifytx-credential', {
                parent: 'entity',
                url: '/verifytx-credential',
                data: {
                    authorities: [],
                    pageTitle: 'VerifytxCredentials'
                },
                ncyBreadcrumb: {
                    label: 'VerifyTX Credential'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/verifytx-credential/list/verifytx-credential.html',
                        controller: 'VerifytxCredentialController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxCredentialDialogController', VerifytxCredentialDialogController);

    VerifytxCredentialDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VerifytxCredential'];

    function VerifytxCredentialDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VerifytxCredential) {
        var vm = this;

        vm.verifytxCredential = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.verifytxCredential.id !== null) {
                VerifytxCredential.update(vm.verifytxCredential, onSaveSuccess, onSaveError);
            } else {
                VerifytxCredential.save(vm.verifytxCredential, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:verifytxCredentialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('VerifytxCredential', VerifytxCredential);

    VerifytxCredential.$inject = ['$resource'];

    function VerifytxCredential ($resource) {
        var resourceUrl =  'api/verifytx-credentials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByCorporation': {url: 'api/verifytx-credentials/corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxCredentialController', VerifytxCredentialController);

    VerifytxCredentialController.$inject = ['GenericEntityDatatableService', 'CoreService', 'VerifytxCredential', '$q',
        '$uibModal', 'toastr', 'ConfirmationService'];

    function VerifytxCredentialController (GenericEntityDatatableService, CoreService, VerifytxCredential, $q,
                                           $uibModal, toastr, ConfirmationService) {
        var vm = this;

        vm.totalItems = 0;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'VerifyTX Credential',
            newAction: false,
            entityClassHumanized: 'VerifyTX Credential',
            entityStateName: 'verifytx-credential',
            service: VerifytxCredential,
            serviceMethod: 'getAllByCorporation',
            params: params,
            columns: [
                {
                    name: 'clientId',
                    title: 'Client Id',
                },
                {
                    name: 'clientSecret',
                    title: 'Client Secret',
                },
                {
                    name: 'username',
                    title: 'Username',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New VerifyTX Credential',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0;
                            }
                        })
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/verifytx-credential/update/verifytx-credential-dialog.html',
                    controller: 'VerifytxCredentialDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                id: null,
                                clientId: null,
                                clientSecret: null,
                                username: null,
                                password: null,
                                corporation: CoreService.getCorporation()
                            };
                        }]
                    }
                }).result.then(function () {
                    toastr.success('VerifyTX Credential was saved', 'Success');

                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/verifytx-credential/update/verifytx-credential-dialog.html',
                    controller: 'VerifytxCredentialDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['VerifytxCredential', function (VerifytxCredential) {
                            return VerifytxCredential.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    toastr.success('VerifyTX Credential was saved', 'Success');

                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('VerifytxCredential').result.then(function () {
                    VerifytxCredential.delete({id: id}, function () {
                        toastr.success('VerifyTX Credential was deleted', 'Success');

                        resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Verifytx', Verifytx);

    Verifytx.$inject = ['$resource'];

    function Verifytx ($resource) {
        var resourceUrl =  'api/verifytx';

        return $resource(resourceUrl, {}, {
            'getByChart': {url: 'api/verifytx/vob-by-chart/:id', method: 'GET'},
            'getFacilities': {url: 'api/verifytx/facilities/:corporationId', method: 'GET'},
            'getPayers': {url: 'api/verifytx/payers/:corporationId/:payer', method: 'GET'},
            'new': {url: 'api/verifytx/vob/new', method: 'POST'},
            'verify': {url: 'api/verifytx/vob/verify', method: 'POST'},
            'filter': {url: 'api/verifytx/filter', method: 'GET', isArray: true},
            'sendVobsByEmail': {url: 'api/verifytx/send-vobs-by-email/:facilityId', method: 'GET', isArray: false}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxNewDialogController', VerifytxNewDialogController);

    VerifytxNewDialogController.$inject = ['$uibModalInstance', 'Verifytx', 'CoreService', 'chartId', 'toastr'];

    function VerifytxNewDialogController($uibModalInstance, Verifytx, CoreService, chartId, toastr) {
        var vm = this;

        vm.clear = clear;
        vm.getPayers = getPayers;
        vm.newVerifytx = newVerifytx;

        Verifytx.getFacilities({corporationId: CoreService.getCorporation().id}, function (result) {
            vm.facilities = result.verifytxDTOs;

            if (result.fails && result.fails.length > 0) {
                toastr.error(_.join(result.fails, ","));
            }
        });

        function getPayers(payer) {
            if (payer && payer.length > 2) {
                Verifytx.getPayers({corporationId: CoreService.getCorporation().id, payer: payer}, function (result) {
                    vm.payers = result.verifytxDTOs;

                    if (result.fails && result.fails.length > 0) {
                        toastr.error(_.join(result.fails, ","));
                    }
                })
            }
        }

        function clear() {
            $uibModalInstance.dismiss(null);
        }

        function newVerifytx() {
            vm.isSaving = true;
            Verifytx.new({
                chartId: chartId,
                facilityId: vm.facility.id,
                payerId: vm.payer.id
            }, function (result) {
                vm.isSaving = false;

                if (result.fails && result.fails.length > 0) {
                    toastr.error(_.join(result.fails, ","));
                } else {
                    toastr.success('Verification of Benefits has been done');
                    $uibModalInstance.close(result);
                }

            }, function (error) {
                vm.isSaving = false;
                $uibModalInstance.dismiss(error);
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxController', VerifytxController);

    VerifytxController.$inject = ['CoreService', '$uibModal', 'Verifytx', 'chart', 'Insurance', 'toastr', '$rootScope',
        '$scope', 'access', 'ACTIONS', 'Auth'];

    function VerifytxController(CoreService, $uibModal, Verifytx, chart, Insurance, toastr, $rootScope,
                                $scope, access, ACTIONS, Auth) {
        var vm = this;

        vm.toggleItem = toggleItem;
        vm.showHistory = showHistory;
        vm.newVerify = newVerify;
        vm.verify = verify;

        init();

        function init() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW, access)) {
                return;
            }

            if (chart.primary) {
                vm.isApplicable = true;
                Verifytx.getByChart({id: chart.id}, function (result) {
                    vm.verifytxVob = result;
                    showInformation(result);
                }, function (error) {
                    vm.verifytxVob = null;
                })
            } else {
                vm.isApplicable = false;
            }
        }

        function toggleItem() {
            CoreService.togglePanel('verificationBenefits');
            setTimeout(function () {
                $window.dispatchEvent(new Event('resize'));
            });
        }

        function showHistory() {
            $uibModal.open({
                templateUrl: 'app/entities/verifytx/chart/history/old/verifytx-history-dialog.html',
                controller: 'VerifytxHistoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    verifytxVobId: vm.verifytxVob.id
                }
            }).result.then(function () {

            }, function () {
            });
        }

        function newVerify() {
            $uibModal.open({
                templateUrl: 'app/entities/verifytx/create/verifytx-new-dialog.html',
                controller: 'VerifytxNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {chartId: chart.id}
            }).result.then(function (result) {
                if (result.vobs && result.vobs.length > 0) {
                    vm.verifytxVob = result.vobs[0];

                    showInformation(vm.verifytxVob);
                }
            }, function (error) {
                if (error !== null) {
                    toastr.error(error.data.message);
                }
            });
        }

        function verify() {
            vm.isSaving = true;
            Verifytx.verify({
                chartId: chart.id
            }, function (result) {
                vm.isSaving = false;

                if (result.vobs && result.vobs.length > 0) {
                    vm.verifytxVob = result.vobs[0];

                    showInformation(vm.verifytxVob);
                    toastr.success('Verification of Benefits has been done')
                }

                if (result.fails && result.fails.length > 0) {
                    toastr.error(_.join(result.fails, ","));
                }

            }, function (error) {
                vm.isSaving = false;
                toastr.error(error.data.message)
            })
        }

        function showInformation(verifytxVob) {
            vm.chartDataOutDeductibles = [
                {
                    key: verifytxVob.outNetwork.deductibleAmountName,
                    y: verifytxVob.outNetwork.deductibleCalendarYear !== 0.0 ?
                        (verifytxVob.outNetwork.deductibleYearToDate === null ?
                            (verifytxVob.outNetwork.deductibleCalendarYear !== null && verifytxVob.outNetwork.deductibleRemaining !== null ? verifytxVob.outNetwork.deductibleCalendarYear - verifytxVob.outNetwork.deductibleRemaining : 1)
                            : verifytxVob.outNetwork.deductibleYearToDate)
                        : 1
                },
                {
                    key: verifytxVob.outNetwork.deductibleRemainingName,
                    y: verifytxVob.outNetwork.deductibleCalendarYear !== 0.0 ?
                        (verifytxVob.outNetwork.deductibleRemaining === null ?
                            (verifytxVob.outNetwork.deductibleCalendarYear !== null && verifytxVob.outNetwork.deductibleYearToDate !== null ? verifytxVob.outNetwork.deductibleCalendarYear - verifytxVob.outNetwork.deductibleYearToDate : null)
                            : verifytxVob.outNetwork.deductibleRemaining)
                        : 0
                }
            ];

            vm.chartDataOutPocket = [
                {
                    key: verifytxVob.outNetwork.outPocketAmountName,
                    y: verifytxVob.outNetwork.outPocketCalendarYear !== 0.0 ?
                        (verifytxVob.outNetwork.outPocketYearToDate === null ?
                            (verifytxVob.outNetwork.outPocketCalendarYear !== null && verifytxVob.outNetwork.outPocketRemaining !== null ? verifytxVob.outNetwork.outPocketCalendarYear - verifytxVob.outNetwork.outPocketRemaining : 1)
                            : verifytxVob.outNetwork.outPocketYearToDate)
                        : 1
                },
                {
                    key: verifytxVob.outNetwork.outPocketRemainingName,
                    y: verifytxVob.outNetwork.outPocketCalendarYear !== 0.0 ?
                        (verifytxVob.outNetwork.outPocketRemaining === null ?
                            (verifytxVob.outNetwork.outPocketCalendarYear !== null && verifytxVob.outNetwork.outPocketYearToDate !== null ? verifytxVob.outNetwork.outPocketCalendarYear - verifytxVob.outNetwork.outPocketYearToDate : null)
                            : verifytxVob.outNetwork.outPocketRemaining)
                        : 0
                }
            ];

            vm.chartDataInDeductibles = [
                {
                    key: verifytxVob.inNetwork.deductibleAmountName,
                    y: verifytxVob.inNetwork.deductibleCalendarYear !== 0.0 ?
                        (verifytxVob.inNetwork.deductibleYearToDate === null ?
                            (verifytxVob.inNetwork.deductibleCalendarYear !== null && verifytxVob.inNetwork.deductibleRemaining !== null ? verifytxVob.inNetwork.deductibleCalendarYear - verifytxVob.inNetwork.deductibleRemaining : 1)
                            : verifytxVob.inNetwork.deductibleYearToDate)
                        : 1
                },
                {
                    key: verifytxVob.inNetwork.deductibleRemainingName,
                    y: verifytxVob.inNetwork.deductibleCalendarYear !== 0.0 ?
                        (verifytxVob.inNetwork.deductibleRemaining === null ?
                            (verifytxVob.inNetwork.deductibleCalendarYear !== null && verifytxVob.inNetwork.deductibleYearToDate !== null ? verifytxVob.inNetwork.deductibleCalendarYear - verifytxVob.inNetwork.deductibleYearToDate : null)
                            : verifytxVob.inNetwork.deductibleRemaining)
                        : 0
                }
            ];

            vm.chartDataInPocket = [
                {
                    key: verifytxVob.inNetwork.outPocketAmountName,
                    y: verifytxVob.inNetwork.outPocketCalendarYear !== 0.0 ?
                        (verifytxVob.inNetwork.outPocketYearToDate === null ?
                            (verifytxVob.inNetwork.outPocketCalendarYear !== null && verifytxVob.inNetwork.outPocketRemaining !== null ? verifytxVob.inNetwork.outPocketCalendarYear - verifytxVob.inNetwork.outPocketRemaining : 1)
                            : verifytxVob.inNetwork.outPocketYearToDate)
                        : 1
                },
                {
                    key: verifytxVob.inNetwork.outPocketRemainingName,
                    y: verifytxVob.inNetwork.outPocketCalendarYear !== 0.0 ?
                        (verifytxVob.inNetwork.outPocketRemaining === null ?
                            (verifytxVob.inNetwork.outPocketCalendarYear !== null && verifytxVob.inNetwork.outPocketYearToDate !== null ? verifytxVob.inNetwork.outPocketCalendarYear - verifytxVob.inNetwork.outPocketYearToDate : null)
                            : verifytxVob.inNetwork.outPocketRemaining)
                        : 0
                }
            ];
        }

        vm.chartOptsOutDeductibles = {
            chart: {
                type: 'pieChart',
                height: 200,
                x: function (d) {
                    return d.key;
                },
                y: function (d) {
                    return d.y;
                },
                showLabels: false,
                duration: 5,
                legend: {
                    margin: {
                        top: 5,
                        right: 5,
                        bottom: 5,
                        left: 5
                    },
                    rightAlign: false
                },
                legendPosition: 'right',
                tooltip: {
                    enabled: false
                },
                color: ['#c7d8ef', '#4798ca']
            }
        };

        vm.chartOptsOutPocket = {
            chart: {
                type: 'pieChart',
                height: 200,
                x: function (d) {
                    return d.key;
                },
                y: function (d) {
                    return d.y;
                },
                showLabels: false,
                duration: 5,
                legend: {
                    margin: {
                        top: 5,
                        right: 5,
                        bottom: 5,
                        left: 5
                    },
                    rightAlign: false
                },
                legendPosition: 'right',
                tooltip: {
                    enabled: false
                },
                color: ['#c7d8ef', '#4798ca']
            }
        };

        vm.chartOptsInDeductibles = {
            chart: {
                type: 'pieChart',
                height: 200,
                x: function (d) {
                    return d.key;
                },
                y: function (d) {
                    return d.y;
                },
                showLabels: false,
                duration: 5,
                legend: {
                    margin: {
                        top: 5,
                        right: 5,
                        bottom: 5,
                        left: 5
                    },
                    rightAlign: false
                },
                legendPosition: 'right',
                tooltip: {
                    enabled: false
                },
                color: ['#c7d8ef', '#4798ca']
            }
        };

        vm.chartOptsInPocket = {
            chart: {
                type: 'pieChart',
                height: 200,
                x: function (d) {
                    return d.key;
                },
                y: function (d) {
                    return d.y;
                },
                showLabels: false,
                duration: 5,
                legend: {
                    margin: {
                        top: 5,
                        right: 5,
                        bottom: 5,
                        left: 5
                    },
                    rightAlign: false
                },
                legendPosition: 'right',
                tooltip: {
                    enabled: false
                },
                color: ['#c7d8ef', '#4798ca']
            }
        };

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailVerify', function (event, result) {
            if (vm.isApplicable) {
                vm.verifytxVob ? verify() : newVerify();
            } else {
                toastr.error("The patient is not applicable");
            }
        });

        $scope.$on('$destroy', unsubscribe);

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailVerifyTxHistory', function (event, result) {

            if (vm.verifytxVob) {
                $uibModal.open({
                    templateUrl: 'app/entities/verifytx/chart/history/new/verifytx-history-dialog.html',
                    controller: 'VerifytxHistoryNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles modal-bottom',
                    resolve: {
                        verifytxVobId: vm.verifytxVob.id
                    }
                }).result.then(function () {

                }, function () {
                });
            } else {
                toastr.error("The patient does not have verifications");
            }
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function (){
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxHistoryDialogController', VerifytxHistoryDialogController);

    VerifytxHistoryDialogController.$inject = ['$uibModalInstance', '$compile', '$q', '$scope', '$rootScope', 'Verifytx', 'verifytxVobId',
                                                'DTOptionsBuilder','DTColumnBuilder', 'GUIUtils'];

    function VerifytxHistoryDialogController($uibModalInstance, $compile, $q, $scope, $rootScope, Verifytx, verifytxVobId,
                                                 DTOptionsBuilder, DTColumnBuilder, GUIUtils) {
        var vm = this;

        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.dtInstance = {};

        vm.clear = clear;
        vm.transition = transition;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            Verifytx.filter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.verifytxHistories = result;
                defer.resolve(result);
            })

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[3, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('coverage').withTitle('Coverage').notSortable(),
            DTColumnBuilder.newColumn('insuranceCompany').withTitle('Insurance Company').notSortable(),
            DTColumnBuilder.newColumn('reference').withTitle('Reference').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('Request Date').notSortable().renderWith(function (data, type, full) {
                return moment(data.createdDate).format($rootScope.amDateFormat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Failed').notSortable().renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.failed);
            }),
            DTColumnBuilder.newColumn('failedMessage').withTitle('Message').notSortable()
        ];

        function clear() {
            $uibModalInstance.close();
        }

        function transition() {
            vm.dtInstance.reloadData();
        }

        function search() {
            vm.page = 1;

            transition();
        }

        function getFilter() {
            var filter = {};

            filter.verifytxVobId = verifytxVobId;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter;
        }
    }
})();

(function (){
    'use strict';

    angular
        .module('bluebookApp')
        .controller('VerifytxHistoryNewDialogController', VerifytxHistoryNewDialogController);

    VerifytxHistoryNewDialogController.$inject = ['$uibModalInstance', '$compile', '$q', '$scope', '$rootScope', 'Verifytx', 'verifytxVobId',
                                                'DTOptionsBuilder','DTColumnBuilder', 'GUIUtils'];

    function VerifytxHistoryNewDialogController($uibModalInstance, $compile, $q, $scope, $rootScope, Verifytx, verifytxVobId,
                                                 DTOptionsBuilder, DTColumnBuilder, GUIUtils) {
        var vm = this;

        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.dtInstance = {};

        vm.clear = clear;
        vm.transition = transition;
        vm.search = search;

        loadAll();

        function loadAll() {
            Verifytx.filter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.verifytxHistories = result;
            });
        }

        function clear() {
            $uibModalInstance.close();
        }

        function transition() {
            loadAll();
        }

        function search() {
            vm.page = 1;

            transition();
        }

        function getFilter() {
            var filter = {};

            filter.verifytxVobId = verifytxVobId;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('blue-alerts', {
                parent: 'entity',
                url: '/blue-alerts',
                data: {
                    authorities: [],
                    pageTitle: 'Blue Alerts'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/urgent-issues/alert/urgent-issue-alerts.html',
                        controller: 'UrgentIssueAlertController',
                        controllerAs: 'vm'
                    }
                },
                // resolve: {
                //     access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                //         var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE];
                //         return Auth.loadActionsAccess(actions).$promise;
                //     }]
                // },
                // onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                //     Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE, access);
                // }]
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('UrgentIssues', UrgentIssues);

    UrgentIssues.$inject = ['$resource'];

    function UrgentIssues($resource) {
        var resourceUrl = 'api/urgent-issues/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byChart': {url: 'api/urgent-issues/by-chart/:id', method: 'GET', isArray: true},
            'update': {method: 'PUT'},
            'countByChartIds': {url: 'api/urgent-issues/count-by-chart-ids/:chartIds', method: 'GET', isArray: true},
            'check': {url: 'api/urgent-issues/check', method: 'PUT'},
            'filter': {url: 'api/urgent-issues/filter', method: 'GET', isArray: true},
            'getAllEmployeeByUrgentIssue': {
                url: 'api/urgent-issues/employees/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesUnknownController', UrgentIssuesUnknownController);

    UrgentIssuesUnknownController.$inject = ['$uibModalInstance', 'UrgentIssues', '$stateParams', 'CoreService',
        '$scope', 'chart'];

    function UrgentIssuesUnknownController($uibModalInstance, UrgentIssues, $stateParams, CoreService,
                                           $scope, chart) {

        var vm = this;

        vm.clear = clear;
        vm.check = check;

        loadAll();

        function loadAll() {
            UrgentIssues.filter({chartId: chart.id, unknown: true, page: 0, size: 100}, function (result, headers) {
                var totalItems = headers('X-Total-Count');

                if (totalItems === 0) {
                    clear();
                }

                vm.urgentIssues = result;
            });
        }

        function check(urgentIssue) {
            UrgentIssues.check({id: urgentIssue.id}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            loadAll();
            $scope.$emit('bluebookApp:urgentIssuesUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function clear () {
            $uibModalInstance.dismiss(null);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesDialogController', UrgentIssuesDialogController);

    UrgentIssuesDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'UrgentIssues', 'CoreService', '$stateParams',
        'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$compile', 'entity', '$uibModal'];

    function UrgentIssuesDialogController($timeout, $scope, $uibModalInstance, UrgentIssues, CoreService, $stateParams,
                                          DTOptionsBuilder, DTColumnBuilder, $q, $compile, entity, $uibModal) {
        var vm = this;

        vm.employee = CoreService.getCurrentEmployee();
        vm.facility = CoreService.getCurrentFacility();
        vm.employees = [];
        vm.saveUrgentIssue = false;
        vm.showDetails = false;
        vm.urgentIssues = entity;
        vm.selected = {};
        vm.allUrgentIssues = [];
        vm.detailsData = [];
        vm.dtInstance = {};
        vm.chart = vm.urgentIssues.chart;

        vm.clear = clear;
        vm.details = details;
        vm.clearDescription = clearDescription;
        vm.save = save;
        vm.check = check;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        init();

        function init() {
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();

                UrgentIssues.byChart({id: $stateParams.id}, function (result) {
                    vm.allUrgentIssues = result;
                    defer.resolve(result);
                });

                return defer.promise;
            }).withPaginationType('full_numbers')
                .withBootstrap()
                .withDOM('tp')
                .withLanguage({
                    "paginate": {
                        "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                        "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                        "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                    }
                })
                .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
                .withOption('headerCallback', function (header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                }).withOption('createdRow', function (row, data, dataIndex) {
                    if (!data.checked) {
                        //here i add a custom class to checked issue
                        angular.element(row).addClass('highlighted')
                    }
                });

            vm.dtColumns = [
                DTColumnBuilder
                    .newColumn(null)
                    .withTitle('')
                    .withOption('class', 'first-col')
                    .notSortable()
                    .renderWith(function (data, type, full, meta) {
                        return '<span class="row-count">' + (meta.row + 1) + '</span>';
                    }),
                DTColumnBuilder
                    .newColumn('description')
                    .withTitle('Description')
                    .withOption('class', 'description-text')
                    .notSortable(),
                DTColumnBuilder
                    .newColumn(null)
                    .withTitle('Actions')
                    .withOption('class', 'last-col')
                    .notSortable()
                    .renderWith(actionsHtml)
            ];
        }

        function loadAll() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            UrgentIssues.save(vm.urgentIssues, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            loadAll();

            clearDescription();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function actionsHtml(data, type, full, meta) {
            var btn = '<a class="btn-details" ng-click="vm.details(' + data.id + ')" title="See Details">' +
                '<i class="fa fa-list-alt" aria-hidden="true"></i></a>';

            if (!data.checked) {
                btn += '<br><input type="checkbox" name="selectIssue" ng-model="vm.selected[' + data.id + ']"' +
                    ' ng-click="vm.check(' + data.id + ')" title="Check Issue">';
            }

            return btn;
        }

        function check(id) {
            UrgentIssues.check({id: id}, function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function details(id) {
            vm.showDetails = !vm.showDetails;
            vm.employees = [];
            UrgentIssues.getAllEmployeeByUrgentIssue({id: id}, function (result) {
                vm.employees = result;
            });
        }

        function clearDescription() {
            vm.urgentIssues.description = '';
            vm.saveUrgentIssue = !vm.saveUrgentIssue;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesDialogControllerNew', UrgentIssuesDialogControllerNew);

    UrgentIssuesDialogControllerNew.$inject = [ '$scope', '$uibModalInstance', 'UrgentIssues', 'CoreService', 'entity' ];

    function UrgentIssuesDialogControllerNew ( $scope, $uibModalInstance, UrgentIssues, CoreService,entity) {
        var vm = this;
        vm.urgentIssues = entity;

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.urgentIssues.id !== null) {
                UrgentIssues.update(vm.urgentIssues, onSaveSuccess, onSaveError);
            } else {
                UrgentIssues.save(vm.urgentIssues, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:careCoordinationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesController', UrgentIssuesController);

    UrgentIssuesController.$inject = ['$scope', 'UrgentIssues', 'CoreService', 'chart', '$uibModal', 'ConfirmationService'];

    function UrgentIssuesController($scope, UrgentIssues, CoreService, chart, $uibModal, ConfirmationService) {
        var vm = this;

        vm.urgentIssues = [];
        vm.urgentIssue = {};
        vm.dtInstance = {};
        vm.employee = CoreService.getCurrentEmployee();

        vm.check = check;
        vm.add = add;
        vm.details = details;
        vm.del = del;
        vm.edit = edit;

        loadAll();

        function loadAll() {
            UrgentIssues.byChart({id: chart.id}, function (result) {
                vm.urgentIssues = result;
            });
        }

        function check(urgentIssue) {
            UrgentIssues.check({id: urgentIssue.id}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            loadAll();
            $scope.$emit('bluebookApp:urgentIssuesUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/urgent-issues/chart/new/update/urgent-issues-dialog.html',
                controller: 'UrgentIssuesDialogControllerNew',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            status: null,
                            id: null,
                            chart: chart,
                            employee: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/urgent-issues/chart/new/update/urgent-issues-dialog.html',
                controller: 'UrgentIssuesDialogControllerNew',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: UrgentIssues.get({id: id}).$promise
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function details(id) {
            $uibModal.open({
                templateUrl: 'app/entities/urgent-issues/chart/new/detail/urgent-issues-detail.html',
                controller: 'UrgentIssuesDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: [function () {
                        return UrgentIssues.get({id: id}).$promise;
                    }]
                }
            });
        }

        function del(id) {
            ConfirmationService.showDelete('BlueAlert').result.then(function () {
                UrgentIssues.delete({id: id}, function () {
                    loadAll();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesHistoryDialogController', UrgentIssuesHistoryDialogController);

    UrgentIssuesHistoryDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'UrgentIssues', 'chart',
        'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$compile'];

    function UrgentIssuesHistoryDialogController($timeout, $scope, $uibModalInstance, UrgentIssues, chart,
                                          DTOptionsBuilder, DTColumnBuilder, $q, $compile) {
        var vm = this;

        vm.employees = [];
        vm.showDetails = false;
        vm.dtInstance = {};

        vm.clear = clear;
        vm.details = details;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        init();

        function init() {
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();

                UrgentIssues.byChart({id: chart.id}, function (result) {
                    vm.allUrgentIssues = result;
                    defer.resolve(result);
                });

                return defer.promise;
            }).withPaginationType('full_numbers')
                .withBootstrap()
                .withDOM('tp')
                .withLanguage({
                    "paginate": {
                        "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                        "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                        "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                        "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                    }
                })
                .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
                .withOption('createdRow', function (row, data, dataIndex) {
                    if (!data.checked) {
                        //here i add a custom class to checked issue
                        angular.element(row).addClass('highlighted')
                    }
                });

            vm.dtColumns = [
                DTColumnBuilder
                    .newColumn(null)
                    .withTitle('')
                    .withOption('class', 'first-col')
                    .notSortable()
                    .renderWith(function (data, type, full, meta) {
                        return '<span class="row-count">' + (meta.row + 1) + '</span>';
                    }),
                DTColumnBuilder
                    .newColumn('description')
                    .withTitle('Description')
                    .withOption('class', 'description-text')
                    .notSortable(),
                DTColumnBuilder
                    .newColumn(null)
                    .withTitle('Actions')
                    .withOption('class', 'last-col')
                    .notSortable()
                    .renderWith(actionsHtml)
            ];
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function actionsHtml(data, type, full, meta) {
            var btn = '<a class="btn-details" ng-click="vm.details(' + data.id + ')" title="See Details">' +
                '<i class="fa fa-list-alt" aria-hidden="true"></i></a>';

            return btn;
        }

        function details(id) {
            vm.showDetails = !vm.showDetails;
            vm.employees = [];

            UrgentIssues.getAllEmployeeByUrgentIssue({id: id}, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssuesDetailController', UrgentIssuesDetailController);

    UrgentIssuesDetailController.$inject = ['entity', '$uibModalInstance', 'UrgentIssues', 'DTOptionsBuilder',
        '$q', '$compile', '$scope', 'DTColumnBuilder'];

    function UrgentIssuesDetailController(entity, $uibModalInstance, UrgentIssues, DTOptionsBuilder,
                                          $q, $compile, $scope, DTColumnBuilder) {
        var vm = this;

        vm.urgentIssues = entity;
        vm.employees = [];

        vm.clear = clear;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            UrgentIssues.getAllEmployeeByUrgentIssue({id: entity.id}, function (result) {
                vm.employees = result;

                defer.resolve(result);
            });

            return defer.promise;
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("First Name").notSortable().renderWith(function (data, type, full, meta) {
                return data.firstName;
            }),
            DTColumnBuilder.newColumn(null).withTitle("Last Name").notSortable().renderWith(function (data, type, full, meta) {
                return data.lastName;
            }),
            DTColumnBuilder.newColumn(null).withTitle("Phone").notSortable().renderWith(function (data, type, full, meta) {
                return data.mobile ? data.mobile : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle("Email").notSortable().renderWith(function (data, type, full, meta) {
                return data.email ? data.email : "";
            })
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UrgentIssueAlertController', UrgentIssueAlertController);

    UrgentIssueAlertController.$inject = ['$scope', '$state', '$q', '$filter', 'CoreService', 'UrgentIssues'];

    function UrgentIssueAlertController($scope, $state, $q, $filter, CoreService, UrgentIssues) {
        var vm = this;

        vm.title = 'Urgent Issue Alert';
        vm.entityClassHumanized = 'Urgent Issue Alert';
        vm.urgentIssues = [];
        vm.searchQuery = "";

        vm.search = search;

        init();

        function init() {
            UrgentIssues.filter({
                facilityId: CoreService.getCurrentFacility().id,
                searchQuery: vm.searchQuery
            }, function (urgentIssues) {
                vm.urgentIssues = _.chain(urgentIssues)
                    .groupBy("chart.id")
                    .map(function (urgentIssues, chartId) {
                        return {
                            chart: urgentIssues[0].chart,
                            chartId: chartId,
                            urgentIssues: urgentIssues
                        };
                    })
                    .orderBy("fullName")
                    .value();
            });
        }

        function search() {
            init();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeSpecialityDialogController', TypeSpecialityDialogController);

    TypeSpecialityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeSpeciality', 'Chart'];

    function TypeSpecialityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeSpeciality, Chart) {
        var vm = this;

        vm.typeSpecialitys = entity;
        vm.clear = clear;
        vm.save = save;
        // vm.charts = Chart.query();
        vm.charts = [];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeSpecialitys.id !== null) {
                TypeSpeciality.update(vm.typeSpecialitys, onSaveSuccess, onSaveError);
            } else {
                TypeSpeciality.save(vm.typeSpecialitys, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeSpecialitysUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-speciality', {
                parent: 'entity',
                url: '/type-speciality',
                data: {
                    authorities: [],
                    pageTitle: 'TypeSpeciality'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-speciality/list/type-speciality.html',
                        controller: 'TypeSpecialityController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Type Speciality'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeSpeciality', TypeSpeciality);

    TypeSpeciality.$inject = ['$resource'];

    function TypeSpeciality ($resource) {
        var resourceUrl =  'api/type-speciality/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/type-speciality/by-corporation/:id', method: 'GET', isArray: true}

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeSpecialityController', TypeSpecialityController);

    TypeSpecialityController.$inject = ['GenericEntityDatatableService', 'CoreService', 'TypeSpeciality',
        '$q', '$uibModal', 'ConfirmationService'];

    function TypeSpecialityController(GenericEntityDatatableService, CoreService, TypeSpeciality,
                                      $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Speciality Types',
            newButtonTitle: 'New Speciality',
            entityClassHumanized: 'Speciality Types',
            entityStateName: 'type-speciality',
            service: TypeSpeciality,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Speciality',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-speciality/update/type-speciality-dialog.html',
                controller: 'TypeSpecialityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            description: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-speciality/update/type-speciality-dialog.html',
                controller: 'TypeSpecialityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeSpeciality', function (TypeSpeciality) {
                        return TypeSpeciality.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Speciality').result.then(function () {
                    TypeSpeciality.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeRaceDialogController', TypeRaceDialogController);

    TypeRaceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeRace', 'CoreService'];

    function TypeRaceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeRace, CoreService) {
        var vm = this;

        vm.typeRace = entity;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeRace.id !== null) {
                TypeRace.update(vm.typeRace, onSaveSuccess, onSaveError);
            } else {
                TypeRace.save(vm.typeRace, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeRaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-race', {
                parent: 'entity',
                url: '/type-race',
                data: {
                    authorities: [],
                    pageTitle: 'TypeRaces'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-race/list/type-race.html',
                        controller: 'TypeRaceController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Race Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_RACE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeRace', TypeRace);

    TypeRace.$inject = ['$resource'];

    function TypeRace ($resource) {
        var resourceUrl =  'api/type-races/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/type-races/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeRaceController', TypeRaceController);

    TypeRaceController.$inject = ['GenericEntityDatatableService', 'TypeRace', 'CoreService', '$q', '$uibModal',
        'ConfirmationService'];

    function TypeRaceController(GenericEntityDatatableService, TypeRace, CoreService, $q, $uibModal,
                                ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Race',
            newButtonTitle: 'New Race',
            entityClassHumanized: 'TypeRace',
            entityStateName: 'type-race',
            service: TypeRace,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'code',
                    title: 'Code',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Race',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-race/update/type-race-dialog.html',
                controller: 'TypeRaceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-race/update/type-race-dialog.html',
                controller: 'TypeRaceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeRace', function (TypeRace) {
                        return TypeRace.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Race').result.then(function () {
                    TypeRace.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePaymentMethodsDialogController', TypePaymentMethodsDialogController);

    TypePaymentMethodsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypePaymentMethods'];

    function TypePaymentMethodsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypePaymentMethods) {
        var vm = this;

        vm.typePaymentMethods = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typePaymentMethods.id !== null) {
                TypePaymentMethods.update(vm.typePaymentMethods, onSaveSuccess, onSaveError);
            } else {
                TypePaymentMethods.save(vm.typePaymentMethods, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typePaymentMethodsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-payment-methods', {
                parent: 'entity',
                url: '/type-payment-methods',
                data: {
                    authorities: [],
                    pageTitle: 'TypePaymentMethods'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-payment-methods/list/type-payment-methods.html',
                        controller: 'TypePaymentMethodsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypePaymentMethods', TypePaymentMethods);

    TypePaymentMethods.$inject = ['$resource'];

    function TypePaymentMethods ($resource) {
        var resourceUrl =  'api/type-payment-methods/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFacility': {url: 'api/type-payment-methods/by-facility/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePaymentMethodsController', TypePaymentMethodsController);

    TypePaymentMethodsController.$inject = ['TypePaymentMethods', 'GUIUtils', 'CoreService',
        'GenericEntityDatatableService', '$q', '$uibModal', 'ConfirmationService'];

    function TypePaymentMethodsController(TypePaymentMethods, GUIUtils, CoreService,
                                          GenericEntityDatatableService, $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Payment Methods',
            newButtonTitle: 'New Payment Method',
            entityClassHumanized: 'Payment Methods',
            entityStateName: 'type-payment-methods',
            service: TypePaymentMethods,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'category',
                    title: 'Category',
                    render: function (data) {
                        return data.category === 'No' ? 'No Insurance' : 'Insurance'
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Payment Method',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-payment-methods/update/type-payment-methods-dialog.html',
                controller: 'TypePaymentMethodsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            status: null,
                            category: null,
                            facility: CoreService.getCurrentFacility(),
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-payment-methods/update/type-payment-methods-dialog.html',
                controller: 'TypePaymentMethodsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePaymentMethods', function (TypePaymentMethods) {
                        return TypePaymentMethods.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Payment Method').result.then(function () {
                    TypePaymentMethods.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientProcessDialogController', TypePatientProcessDialogController);

    TypePatientProcessDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypePatientProcess',
        'CoreService'];

    function TypePatientProcessDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypePatientProcess,
                                                 CoreService) {
        var vm = this;

        vm.typePatientProcess = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typePatientProcess.id !== null) {
                TypePatientProcess.update(vm.typePatientProcess, onSaveSuccess, onSaveError);
            } else {
                TypePatientProcess.save(vm.typePatientProcess, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typePatientProcessUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-patient-process', {
                parent: 'entity',
                url: '/type-patient-process',
                data: {
                    authorities: [],
                    pageTitle: 'TypePatientProcesses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-patient-process/list/type-patient-process.html',
                        controller: 'TypePatientProcessController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypePatientProcess', TypePatientProcess);

    TypePatientProcess.$inject = ['$resource'];

    function TypePatientProcess ($resource) {
        var resourceUrl =  'api/type-patient-processes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFacility': {url: 'api/type-patient-processes/by-facility/:id', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientProcessController', TypePatientProcessController);

    TypePatientProcessController.$inject = ['TypePatientProcess', 'CoreService', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService'];

    function TypePatientProcessController(TypePatientProcess, CoreService, GenericEntityDatatableService, $q,
                                          $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'type-patient-process'

        vm.descriptor = {
            title: 'Patient Process',
            entityClassHumanized: 'Patient Process',
            entityStateName: entityStateName,
            service: TypePatientProcess,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'xrder',
                    title: 'Order'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Patient Process',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-process/update/type-patient-process-dialog.html',
                controller: 'TypePatientProcessDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ["CoreService", function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-process/update/type-patient-process-dialog.html',
                controller: 'TypePatientProcessDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePatientProcess', function (TypePatientProcess) {
                        return TypePatientProcess.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Patient Process').result.then(function () {
                    TypePatientProcess.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientContactsRelationshipDialogController', TypePatientContactsRelationshipDialogController);

    TypePatientContactsRelationshipDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypePatientContactsRelationship'];

    function TypePatientContactsRelationshipDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypePatientContactsRelationship) {
        var vm = this;

        vm.typePatientContactsRelationship = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typePatientContactsRelationship.id !== null) {
                TypePatientContactsRelationship.update(vm.typePatientContactsRelationship, onSaveSuccess, onSaveError);
            } else {
                TypePatientContactsRelationship.save(vm.typePatientContactsRelationship, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typePatientContactsRelationshipUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-patient-contacts-relationship', {
                parent: 'entity',
                url: '/type-patient-contacts-relationship',
                data: {
                    authorities: [],
                    pageTitle: 'TypePatientContactsRelationships'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-patient-contacts-relationship/list/type-patient-contacts-relationships.html',
                        controller: 'TypePatientContactsRelationshipController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Patient Contacts Relationship Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypePatientContactsRelationship', TypePatientContactsRelationship);

    TypePatientContactsRelationship.$inject = ['$resource'];

    function TypePatientContactsRelationship ($resource) {
        var resourceUrl =  'api/type-patient-contacts-relationships/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-patient-contacts-relationships/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientContactsRelationshipController', TypePatientContactsRelationshipController);

    TypePatientContactsRelationshipController.$inject = ['TypePatientContactsRelationship', 'CoreService',
        'GenericEntityDatatableService', '$q', '$uibModal', 'ConfirmationService'];

    function TypePatientContactsRelationshipController(TypePatientContactsRelationship, CoreService,
                                                       GenericEntityDatatableService, $q, $uibModal, ConfirmationService) {

        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()

        var entityStateName = 'type-patient-contacts-relationship'

        vm.descriptor = {
            title: 'Patient Contacts Relationships',
            newButtonTitle: 'New Relationships',
            entityClassHumanized: 'Patient Contacts Relationships',
            entityStateName: entityStateName,
            service: TypePatientContactsRelationship,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Relationships',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contacts-relationship/update/type-patient-contacts-relationship-dialog.html',
                controller: 'TypePatientContactsRelationshipDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contacts-relationship/update/type-patient-contacts-relationship-dialog.html',
                controller: 'TypePatientContactsRelationshipDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePatientContactsRelationship', function (TypePatientContactsRelationship) {
                        return TypePatientContactsRelationship.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Relationships').result.then(function () {
                    TypePatientContactsRelationship.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientContactTypesDialogController', TypePatientContactTypesDialogController);

    TypePatientContactTypesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypePatientContactTypes'];

    function TypePatientContactTypesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypePatientContactTypes) {
        var vm = this;

        vm.typePatientContactTypes = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typePatientContactTypes.id !== null) {
                TypePatientContactTypes.update(vm.typePatientContactTypes, onSaveSuccess, onSaveError);
            } else {
                TypePatientContactTypes.save(vm.typePatientContactTypes, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typePatientContactTypesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-patient-contact-types', {
                parent: 'entity',
                url: '/type-patient-contact-types',
                data: {
                    authorities: [],
                    pageTitle: 'TypePatientContactTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-patient-contact-types/list/type-patient-contact-types.html',
                        controller: 'TypePatientContactTypesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypePatientContactTypes', TypePatientContactTypes);

    TypePatientContactTypes.$inject = ['$resource'];

    function TypePatientContactTypes ($resource) {
        var resourceUrl =  'api/type-patient-contact-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/type-patient-contact-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypePatientContactTypesController', TypePatientContactTypesController);

    TypePatientContactTypesController.$inject = ['TypePatientContactTypes', 'GenericEntityDatatableService',
        'CoreService', '$q', '$uibModal', 'ConfirmationService'];

    function TypePatientContactTypesController(TypePatientContactTypes, GenericEntityDatatableService,
                                               CoreService, $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Patient Contact Types',
            newButtonTitle: 'Patient Contact Type',
            entityClassHumanized: 'Patient Contact Types',
            entityStateName: 'type-patient-contact-types',
            service: TypePatientContactTypes,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Audit Config',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contact-types/update/type-patient-contact-types-dialog.html',
                controller: 'TypePatientContactTypesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-patient-contact-types/update/type-patient-contact-types-dialog.html',
                controller: 'TypePatientContactTypesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypePatientContactTypes', function (TypePatientContactTypes) {
                        return TypePatientContactTypes.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Patient Contact Types').result.then(function () {
                    TypePatientContactTypes.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeMaritalStatusDialogController', TypeMaritalStatusDialogController);

    TypeMaritalStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeMaritalStatus'];

    function TypeMaritalStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeMaritalStatus) {
        var vm = this;

        vm.typeMaritalStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeMaritalStatus.id !== null) {
                TypeMaritalStatus.update(vm.typeMaritalStatus, onSaveSuccess, onSaveError);
            } else {
                TypeMaritalStatus.save(vm.typeMaritalStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeMaritalStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-marital-status', {
                parent: 'entity',
                url: '/type-marital-status',
                data: {
                    authorities: [],
                    pageTitle: 'TypeMaritalStatuses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-marital-status/list/type-marital-status.html',
                        controller: 'TypeMaritalStatusController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Marital Status Type'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeMaritalStatus', TypeMaritalStatus);

    TypeMaritalStatus.$inject = ['$resource'];

    function TypeMaritalStatus ($resource) {
        var resourceUrl =  'api/type-marital-statuses/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-marital-statuses/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeMaritalStatusController', TypeMaritalStatusController);

    TypeMaritalStatusController.$inject = ['GenericEntityDatatableService', 'TypeMaritalStatus', 'CoreService', '$q',
        '$uibModal', 'ConfirmationService'];

    function TypeMaritalStatusController(GenericEntityDatatableService, TypeMaritalStatus, CoreService, $q,
                                         $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Marital Status',
            newButtonTitle: 'New Marital Status',
            entityClassHumanized: 'Marital Status',
            entityStateName: 'type-marital-status',
            service: TypeMaritalStatus,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Marital Status',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-marital-status/update/type-marital-status-dialog.html',
                controller: 'TypeMaritalStatusDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-marital-status/update/type-marital-status-dialog.html',
                controller: 'TypeMaritalStatusDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeMaritalStatus', function (TypeMaritalStatus) {
                        return TypeMaritalStatus.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Marital Status').result.then(function () {
                    TypeMaritalStatus.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeLevelCareDialogController', TypeLevelCareDialogController);

    TypeLevelCareDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeLevelCare'];

    function TypeLevelCareDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeLevelCare) {
        var vm = this;

        vm.typeLevelCare = entity;

        if (!vm.typeLevelCare.color) {
            vm.typeLevelCare.color = "#FFFFFF"
        }

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeLevelCare.id !== null) {
                TypeLevelCare.update(vm.typeLevelCare, onSaveSuccess, onSaveError);
            } else {
                TypeLevelCare.save(vm.typeLevelCare, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeLevelCareUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-level-care', {
                parent: 'entity',
                url: '/type-level-care',
                data: {
                    authorities: [],
                    pageTitle: 'TypeLevelCares'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-level-care/list/type-level-care.html',
                        controller: 'TypeLevelCareController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeLevelCare', TypeLevelCare);

    TypeLevelCare.$inject = ['$resource'];

    function TypeLevelCare ($resource) {
        var resourceUrl =  'api/type-level-cares/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'forms': {url: 'api/type-level-cares/forms/:facId/:lcId', method: 'GET', isArray: true},
            'update': { method:'PUT' },
            'filter': {url: 'api/type-level-cares/filter', method: 'GET', isArray: true},
            'findAllByFacility': {url: 'api/type-level-cares/by-facility/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeLevelCareController', TypeLevelCareController);

    TypeLevelCareController.$inject = ['GenericEntityDatatableService', 'TypeLevelCare', 'CoreService', '$q',
        '$uibModal', 'ConfirmationService'];

    function TypeLevelCareController(GenericEntityDatatableService, TypeLevelCare, CoreService, $q,
                                     $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Level of Care',
            newButtonTitle: 'New Level of Care',
            entityClassHumanized: 'Level of Care',
            entityStateName: 'type-level-care',
            service: TypeLevelCare,
            serviceMethod: 'findAllByFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Color',
                    render: function (data) {
                        return '<div style="background-color:' + data.color + '">' +
                            (data.color ? data.color : '') +
                            '</div>';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Level of Care',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-level-care/update/type-level-care-dialog.html',
                controller: 'TypeLevelCareDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-level-care/update/type-level-care-dialog.html',
                controller: 'TypeLevelCareDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeLevelCare', function (TypeLevelCare) {
                        return TypeLevelCare.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Level of Care').result.then(function () {
                    TypeLevelCare.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeLevelCareHistoryController', TypeLevelCareHistoryController);

    TypeLevelCareHistoryController.$inject = ['TypeLevelCare', '$state', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', 'Chart', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope',
        '$timeout', '$uibModalInstance', '$rootScope'];

    function TypeLevelCareHistoryController(TypeLevelCare, $state, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart, Chart,
                                          $q, GUIUtils, $filter, CoreService, $compile, $scope,
                                          $timeout, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            TypeLevelCare.filter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[1, 'desc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn("startDate").withTitle('Start Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn("endDate").withTitle('End Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Level of Care').renderWith(function (data, type, full) {
                return data.typeLevelCare ? data.typeLevelCare.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Employee').renderWith(function (data, type, full) {
                return data.employee.firstName + " " + data.employee.lastName;
            })
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeLevelCareHistoryNewController', TypeLevelCareHistoryNewController);

    TypeLevelCareHistoryNewController.$inject = ['TypeLevelCare', '$state', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', 'Chart', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope',
        '$timeout', '$uibModalInstance', '$rootScope'];

    function TypeLevelCareHistoryNewController(TypeLevelCare, $state, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart, Chart,
                                          $q, GUIUtils, $filter, CoreService, $compile, $scope,
                                          $timeout, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.selected = {};
        vm.selectAll = false;
        vm.levelCares = [];

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;

        loadAll();

        function loadAll() {
            TypeLevelCare.filter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.levelCares = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function reload() {
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeFoodDietsDialogController', TypeFoodDietsDialogController);

    TypeFoodDietsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeFoodDiets'];

    function TypeFoodDietsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeFoodDiets) {
        var vm = this;

        vm.typeFoodDiets = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeFoodDiets.id !== null) {
                TypeFoodDiets.update(vm.typeFoodDiets, onSaveSuccess, onSaveError);
            } else {
                TypeFoodDiets.save(vm.typeFoodDiets, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeFoodDietsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-food-diets', {
                parent: 'entity',
                url: '/type-food-diets',
                data: {
                    authorities: [],
                    pageTitle: 'TypeFoodDiets'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-food-diets/list/type-food-diets.html',
                        controller: 'TypeFoodDietsController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Food Diet'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeFoodDiets', TypeFoodDiets);

    TypeFoodDiets.$inject = ['$resource'];

    function TypeFoodDiets ($resource) {
        var resourceUrl =  'api/type-food-diets/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/type-food-diets/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeFoodDietsController', TypeFoodDietsController);

    TypeFoodDietsController.$inject = ['GenericEntityDatatableService', 'CoreService', 'TypeFoodDiets', '$uibModal',
        'ConfirmationService', '$q'];

    function TypeFoodDietsController(GenericEntityDatatableService, CoreService, TypeFoodDiets, $uibModal,
                                     ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Food Diets',
            newButtonTitle: 'New Food Diet',
            entityClassHumanized: 'Food Diets',
            entityStateName: 'type-food-diets',
            service: TypeFoodDiets,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Food Diet',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-food-diets/update/type-food-diets-dialog.html',
                controller: 'TypeFoodDietsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-food-diets/update/type-food-diets-dialog.html',
                controller: 'TypeFoodDietsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeFoodDiets', function (TypeFoodDiets) {
                        return TypeFoodDiets.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('TypeFoodDiets').result.then(function () {
                    TypeFoodDiets.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeEthnicityDialogController', TypeEthnicityDialogController);

    TypeEthnicityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeEthnicity'];

    function TypeEthnicityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeEthnicity) {
        var vm = this;

        vm.typeEthnicity = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeEthnicity.id !== null) {
                TypeEthnicity.update(vm.typeEthnicity, onSaveSuccess, onSaveError);
            } else {
                TypeEthnicity.save(vm.typeEthnicity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeEthnicityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-ethnicity', {
                parent: 'entity',
                url: '/type-ethnicity',
                data: {
                    authorities: [],
                    pageTitle: 'TypeEthnicities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-ethnicity/list/type-ethnicity.html',
                        controller: 'TypeEthnicityController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Ethnicity Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeEthnicity', TypeEthnicity);

    TypeEthnicity.$inject = ['$resource'];

    function TypeEthnicity ($resource) {
        var resourceUrl =  'api/type-ethnicities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-ethnicities/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeEthnicityController', TypeEthnicityController);

    TypeEthnicityController.$inject = ['GenericEntityDatatableService', 'TypeEthnicity', 'CoreService', '$uibModal',
        'ConfirmationService', '$q'];

    function TypeEthnicityController(GenericEntityDatatableService, TypeEthnicity, CoreService, $uibModal,
                                     ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Ethnicity Types',
            newButtonTitle: 'New Ethnicity Type',
            entityClassHumanized: 'Ethnicity Type',
            entityStateName: 'type-ethnicity',
            service: TypeEthnicity,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'code',
                    title: 'Code',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Ethnicity Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ]
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-ethnicity/update/type-ethnicity-dialog.html',
                controller: 'TypeEthnicityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-ethnicity/update/type-ethnicity-dialog.html',
                controller: 'TypeEthnicityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeEthnicity', function (TypeEthnicity) {
                        return TypeEthnicity.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Ethnicity Type').result.then(function () {
                    TypeEthnicity.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeDischargeTypeDialogController', TypeDischargeTypeDialogController);

    TypeDischargeTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeDischargeType'];

    function TypeDischargeTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeDischargeType) {
        var vm = this;

        vm.typeDischargeType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeDischargeType.id !== null) {
                TypeDischargeType.update(vm.typeDischargeType, onSaveSuccess, onSaveError);
            } else {
                TypeDischargeType.save(vm.typeDischargeType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeDischargeTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-discharge-type', {
                parent: 'entity',
                url: '/type-discharge-type',
                data: {
                    authorities: [],
                    pageTitle: 'TypeDischargeTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-discharge-type/list/type-discharge-type.html',
                        controller: 'TypeDischargeTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeDischargeType', TypeDischargeType);

    TypeDischargeType.$inject = ['$resource'];

    function TypeDischargeType ($resource) {
        var resourceUrl =  'api/type-discharge-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-discharge-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeDischargeTypeController', TypeDischargeTypeController);

    TypeDischargeTypeController.$inject = ['GenericEntityDatatableService', 'TypeDischargeType', 'CoreService',
        '$uibModal', 'ConfirmationService', '$q'];

    function TypeDischargeTypeController(GenericEntityDatatableService, TypeDischargeType, CoreService,
                                         $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Discharge Type',
            newButtonTitle: 'New Discharge Type',
            entityClassHumanized: 'Discharge Type',
            entityStateName: 'type-discharge-type',
            service: TypeDischargeType,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('acuity'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('acuity'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Discharge Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-discharge-type/update/type-discharge-type-dialog.html',
                controller: 'TypeDischargeTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            corporation: CoreService.getCorporation(),
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-discharge-type/update/type-discharge-type-dialog.html',
                controller: 'TypeDischargeTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeDischargeType', function (TypeDischargeType) {
                        return TypeDischargeType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Discharge Type').result.then(function () {
                    TypeDischargeType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeContactFacilityTypeDialogController', TypeContactFacilityTypeDialogController);

    TypeContactFacilityTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeContactFacilityType'];

    function TypeContactFacilityTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeContactFacilityType) {
        var vm = this;

        vm.typeContactFacilityType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeContactFacilityType.id !== null) {
                TypeContactFacilityType.update(vm.typeContactFacilityType, onSaveSuccess, onSaveError);
            } else {
                TypeContactFacilityType.save(vm.typeContactFacilityType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeContactFacilityTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-contact-facility-type', {
                parent: 'entity',
                url: '/type-contact-facility-type',
                data: {
                    authorities: [],
                    pageTitle: 'TypeContactFacilityTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-contact-facility-type/list/type-contact-facility-type.html',
                        controller: 'TypeContactFacilityTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Contact Facility Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeContactFacilityType', TypeContactFacilityType);

    TypeContactFacilityType.$inject = ['$resource'];

    function TypeContactFacilityType ($resource) {
        var resourceUrl =  'api/type-contact-facility-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-contact-facility-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeContactFacilityTypeController', TypeContactFacilityTypeController);

    TypeContactFacilityTypeController.$inject = ['TypeContactFacilityType', 'CoreService',
        'GenericEntityDatatableService', '$uibModal', 'ConfirmationService', '$q'];

    function TypeContactFacilityTypeController(TypeContactFacilityType, CoreService,
                                               GenericEntityDatatableService, $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        var entityStateName = 'type-contact-facility-type';

        vm.descriptor = {
            title: 'Contact Facility Type',
            entityClassHumanized: 'Contact Facility Type',
            entityStateName: entityStateName,
            service: TypeContactFacilityType,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Contact Facility',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-contact-facility-type/update/type-contact-facility-type-dialog.html',
                controller: 'TypeContactFacilityTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-contact-facility-type/update/type-contact-facility-type-dialog.html',
                controller: 'TypeContactFacilityTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeContactFacilityType', function (TypeContactFacilityType) {
                        return TypeContactFacilityType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Contact Facility Type').result.then(function () {
                    TypeContactFacilityType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeCheckDialogController', TypeCheckDialogController);

    TypeCheckDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TypeCheck'];

    function TypeCheckDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TypeCheck) {
        var vm = this;

        vm.typeCheck = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.typeCheck.id !== null) {
                TypeCheck.update(vm.typeCheck, onSaveSuccess, onSaveError);
            } else {
                TypeCheck.save(vm.typeCheck, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:typeCheckUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-check', {
                parent: 'entity',
                url: '/type-check',
                data: {
                    authorities: [],
                    pageTitle: 'TypeChecks'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-check/list/type-check.html',
                        controller: 'TypeCheckController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TypeCheck', TypeCheck);

    TypeCheck.$inject = ['$resource'];

    function TypeCheck ($resource) {
        var resourceUrl =  'api/type-checks/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/type-checks/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TypeCheckController', TypeCheckController);

    TypeCheckController.$inject = ['GenericEntityDatatableService', 'CoreService', 'TypeCheck', '$q', '$uibModal',
        'ConfirmationService'];

    function TypeCheckController(GenericEntityDatatableService, CoreService, TypeCheck, $q, $uibModal,
                                 ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Type of Check',
            newButtonTitle: 'New Type of Check',
            entityClassHumanized: 'Type of Check',
            entityStateName: 'type-check',
            service: TypeCheck,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Type of Check',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/type-check/update/type-check-dialog.html',
                controller: 'TypeCheckDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/type-check/update/type-check-dialog.html',
                controller: 'TypeCheckDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TypeCheck', function (TypeCheck) {
                        return TypeCheck.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Type of Check').result.then(function () {
                    TypeCheck.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('TubeDialogController', TubeDialogController);

    TubeDialogController.$inject = ['Tube', 'entity', '$timeout', '$uibModalInstance', '$scope'];

    function TubeDialogController(Tube, entity, $timeout, $uibModalInstance, $scope) {
        var vm = this;

        vm.tube = entity;

        vm.clear = clear;
        vm.save = save;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tube.id !== null) {
                Tube.update(vm.tube, onSaveSuccess, onSaveError);
            } else {
                Tube.save(vm.tube, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:tubeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tube', {
                parent: 'entity',
                url: '/tube',
                data: {
                    authorities: [],
                    pageTitle: 'Tube'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tube/list/tube.html',
                        controller: 'TubeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Tube', Tube);

    Tube.$inject = ['$resource'];

    function Tube ($resource) {
        var resourceUrl =  'api/tubes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByLaboratory': { url: 'api/tubes/by-laboratory', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TubeController', TubeController);

    TubeController.$inject = ['Tube', '$q', 'Laboratory', '$uibModal', 'GUIUtils', 'CoreService',
        'GenericEntityDatatableService', 'PopupService', 'ConfirmationService'];

    function TubeController(Tube, $q, Laboratory, $uibModal, GUIUtils, CoreService,
                            GenericEntityDatatableService, PopupService, ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        vm.descriptor = {
            title: 'Tubes',
            newAction: false,
            entityClassHumanized: 'Tubes',
            entityStateName: 'tube',
            service: Tube ,
            serviceMethod: 'findAllByLaboratory',
            pagination: 'remote',
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('specimen'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('specimen'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Tube',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectLaboratoryPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = result;

                                        vm.laboratory = result;
                                        vm.descriptor.title = 'Tubes - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/tube/update/tube-dialog.html',
                    controller: 'TubeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                laboratory: vm.laboratory
                            };
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/tube/update/tube-dialog.html',
                    controller: 'TubeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: Tube.get({id: id}).$promise
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Tube').result.then(function () {
                    Tube.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TrackDialogController', TrackDialogController);

    TrackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Track', 'Facility', 'GroupSessionTemplate', 'CoreService'];

    function TrackDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                    Track, Facility, GroupSessionTemplate, CoreService ) {
        var vm = this;

        vm.track = entity;
        vm.groupSessionTemplates = GroupSessionTemplate.byFacility({id: CoreService.getCurrentFacility().id});
        vm.isSaving = false;

        vm.clear = clear;
        vm.save = save;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if (vm.track.id !== null) {
                Track.update(vm.track, onSaveSuccess, onSaveError);
            } else {
                Track.save(vm.track, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:trackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('track', {
                parent: 'entity',
                url: '/track',
                data: {
                    authorities: [],
                    pageTitle: 'Tracks'
                },
                ncyBreadcrumb: {
                    label: 'Tracks'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/track/list/track.html',
                        controller: 'TrackController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: function () {
                        return {
                            name: null,
                            description: null
                        };
                    },
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_TRACK];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_TRACK, access);
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Track', Track);

    Track.$inject = ['$resource'];

    function Track ($resource) {
        var resourceUrl =  'api/tracks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/tracks/filter', method: 'GET', isArray: true},
            'findAllByChart': {url: 'api/tracks/by-chart', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TrackController', TrackController);

    TrackController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Track', 'GUIUtils', '$uibModal',
        'ConfirmationService', '$q'];

    function TrackController(GenericEntityDatatableService, CoreService, Track, GUIUtils, $uibModal,
                             ConfirmationService, $q) {

        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Tracks',
            newButtonTitle: 'New Track',
            entityClassHumanized: 'Track',
            entityStateName: 'track',
            service: Track,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    name: null,
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enabled);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Track',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/track/update/track-dialog.html',
                controller: 'TrackDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            description: null,
                            enabled: true,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }],
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/track/update/track-dialog.html',
                controller: 'TrackDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Track', function (Track) {
                        return Track.get({id: id}).$promise;
                    }],
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Track').result.then(function () {
                    Track.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TrackHistoryController', TrackHistoryController);

    TrackHistoryController.$inject = ['Track', '$state', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', 'Chart', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope',
        '$timeout', '$uibModalInstance', '$rootScope'];

    function TrackHistoryController(Track, $state, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart, Chart,
                                          $q, GUIUtils, $filter, CoreService, $compile, $scope,
                                          $timeout, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Track.findAllByChart(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[1, 'desc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn("startDate").withTitle('Start Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn("endDate").withTitle('End Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Track').renderWith(function (data, type, full) {
                return data.track ? data.track.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Employee').renderWith(function (data, type, full) {
                return data.employee.firstName + " " + data.employee.lastName;
            })
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TrackHistoryNewController', TrackHistoryNewController);

    TrackHistoryNewController.$inject = ['Track', '$state', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', 'Chart', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope',
        '$timeout', '$uibModalInstance', '$rootScope'];

    function TrackHistoryNewController(Track, $state, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart, Chart,
                                          $q, GUIUtils, $filter, CoreService, $compile, $scope,
                                          $timeout, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.selected = {};
        vm.selectAll = false;
        vm.tracks = [];

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;

        loadAll();

        function loadAll() {
            Track.findAllByChart(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.tracks = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function reload() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('telehealth', {
                parent: 'entity',
                url: '/telehealth',
                data: {
                    authorities: [],
                    pageTitle: 'Telehealth'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/telehealth/list/telehealth-meeting.html',
                        controller: 'TelehealthMeetingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id,
                            status: 'SCHEDULED',
                            topic: null,
                            twilioRoomName: null,
                            hostId: null,
                            startDate: null,
                            endDate: null,
                            duration: null
                        };
                    },
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TELEHEALTH];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TELEHEALTH, access);
                }]
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TelehealthMeeting', TelehealthMeeting);

    TelehealthMeeting.$inject = ['$resource', 'DateUtils'];

    function TelehealthMeeting ($resource, DateUtils) {
        var resourceUrl =  'api/telehealth-meetings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.telehealthMeetingRecurrence.endDate = DateUtils.convertLocalDateFromServer(data.telehealthMeetingRecurrence.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'saveAll': {url: 'api/telehealth-meetings/save-all', method: 'POST', isArray: false},
            'delete': {url: 'api/telehealth-meetings/:id', method: 'DELETE', isArray: false},
            'findAllByFilter': {url: 'api/telehealth-meetings/filter', method: 'GET', isArray: true},
            'startMeeting': {url: 'api/telehealth-meetings/start', method: 'GET', isArray: false},
            'endMeeting': {url: 'api/telehealth-meetings/end', method: 'GET', isArray: false},
            'getParticipants': {url: 'api/telehealth-meetings/participants', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TelehealthMeetingController', TelehealthMeetingController);

    TelehealthMeetingController.$inject = ['$q', 'TelehealthMeeting', '$uibModal', '$rootScope', 'Employee',
        'CoreService', 'toastr', '$window', 'GenericEntityDatatableService', 'ConfirmationService'];

    function TelehealthMeetingController($q, TelehealthMeeting, $uibModal, $rootScope, Employee,
                                         CoreService, toastr, $window, GenericEntityDatatableService, ConfirmationService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Telehealth Meetings',
            entityClassHumanized: 'Telehealth',
            entityStateName: 'telehealth',
            service: TelehealthMeeting,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [{key: 'aaSorting', value: [[3, 'asc']]}],
            columns: [
                {
                    name: 'twilioRoomName',
                    title: 'Id',
                },
                {
                    name: 'topic',
                    title: 'Topic',
                },
                {
                    name: null,
                    title: 'Host',
                    render: function (data) {
                        return data.employeeLastName + ', ' + data.employeeFirstName;
                    }
                },
                {
                    name: null,
                    title: 'Start Date',
                    render: function (data) {
                        return moment(data.startDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Scheduled Date',
                    render: function (data) {
                        return moment(data.startDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'End Date',
                    render: function (data) {
                        return moment(data.endDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Duration',
                    render: function (data) {
                        return data.duration + ' min';
                    }
                },
                {
                    name: null,
                    title: 'Participants',
                    render: function (data) {
                        return data.participants;
                    }
                },
            ],
            updateColumns: function (dtColumns, filter) {
                switch (filter.status) {
                    case 'SCHEDULED' : {
                        dtColumns[1].withOption("bVisible", true);
                        dtColumns[2].withOption("bVisible", true);
                        dtColumns[3].notVisible();
                        dtColumns[4].withOption("bVisible", true);
                        dtColumns[5].notVisible();
                        dtColumns[6].notVisible();
                        dtColumns[7].notVisible();
                        break;
                    }
                    case 'IN_PROGRESS' : {
                        dtColumns[1].withOption("bVisible", true);
                        dtColumns[2].withOption("bVisible", true);
                        dtColumns[3].withOption("bVisible", true);
                        dtColumns[4].notVisible();
                        dtColumns[5].notVisible();
                        dtColumns[6].notVisible();
                        dtColumns[7].notVisible();
                        break;
                    }
                    case 'COMPLETED' : {
                        dtColumns[1].withOption("bVisible", true);
                        dtColumns[2].withOption("bVisible", true);
                        dtColumns[3].withOption("bVisible", true);
                        dtColumns[4].notVisible();
                        dtColumns[5].withOption("bVisible", true);
                        dtColumns[6].withOption("bVisible", true);
                        dtColumns[7].withOption("bVisible", true);
                        break;
                    }
                }
            },
            rowActions: [
                {
                    name: 'Start Meeting',
                    action: function (data) {
                        return start(data);
                    },
                    aClass: 'dd-link green',
                    iClass: 'fa fa-play',
                    ngIf: function (data, filter) {
                        return filter.status === 'SCHEDULED' && data.hostId === CoreService.getCurrentEmployee().id;
                    }
                },
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return choose(data.id);
                    },
                    ngIf: function (data, filter) {
                        return filter.status === 'SCHEDULED' && data.frequency !== 'NONE' && data.frequency !== 'CUSTOM';
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    },
                    ngIf: function (data, filter) {
                        return filter.status === 'SCHEDULED' && (data.frequency === 'NONE' || data.frequency === 'CUSTOM');
                    }
                }),
                {
                    name: 'Join Meeting',
                    action: function (data) {
                        join(data.id);
                    },
                    aClass: 'dd-link green',
                    iClass: 'fa fa-mail-forward',
                    ngIf: function (data, filter) {
                        return filter.status === 'IN_PROGRESS';
                    },
                    reload: false
                },
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        detail(data.id);
                    },
                    ngIf: function (data, filter) {
                        return filter.status === 'IN_PROGRESS' || filter.status === 'COMPLETED';
                    },
                    reload: false
                }),
                {
                    name: 'Copy Invitation',
                    action: function (data) {
                        invitation(data.id);
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-copy',
                    ngIf: function (data, filter) {
                        return filter.status === 'SCHEDULED' || filter.status === 'IN_PROGRESS';
                    },
                    reload: false
                },
                {
                    name: 'End Meeting',
                    action: function (data) {
                        return end(data);
                    },
                    aClass: 'dd-link red',
                    iClass: 'fa fa-stop',
                    ngIf: function (data, filter) {
                        return filter.status === 'IN_PROGRESS';
                    }
                },
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    },
                    ngIf: function (data, filter) {
                        return filter.status === 'SCHEDULED';
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'Schedule',
                            iClass: 'fa fa-calendar',
                            ngClass: function (filter) {
                                return filter.status === 'SCHEDULED' ? ['active'] : [];
                            },
                            action: function (filter) {
                                filter.status = 'SCHEDULED';
                            }
                        },
                        {
                            name: 'Live Meetings',
                            iClass: 'fa fa-play',
                            ngClass: function (filter) {
                                return filter.status === 'IN_PROGRESS' ? ['active'] : [];
                            },
                            action: function (filter) {
                                filter.status = 'IN_PROGRESS';
                            }
                        },
                        {
                            name: 'Past Meetings',
                            iClass: 'fa fa-thumbs-up',
                            ngClass: function (filter) {
                                return filter.status === 'COMPLETED' ? ['active'] : [];
                            },
                            action: function (filter, selected) {
                                filter.status = 'COMPLETED';
                            }
                        }
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        {
                            ngClass: function () {
                                return ['bg-green']
                            },
                            iClass: 'fa fa-plus-circle',
                            action: function (filter) {
                                return add();
                            }
                        },
                    ]
                }
            ],
            filters: [
                {
                    name: 'status',
                    visible: false,
                    defaultValue: function () {
                        return 'SCHEDULED';
                    }
                },
                {
                    name: 'twilioRoomName',
                    type: 'string',
                    placeholder: 'Id...',
                    visible: true
                },
                {
                    name: 'topic',
                    type: 'string',
                    placeholder: 'Topic...',
                    visible: true
                },
                {
                    name: 'hostId',
                    read: function (filter) {
                        return filter.hostId ? filter.hostId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        Employee.findAllByFilter(
                            {
                                page: 0,
                                size: 10,
                                facilityId: CoreService.getCurrentFacility().id,
                                query: search,
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select host...',
                    type: 'select',
                    visible: true,
                },
                {
                    name: 'duration',
                    placeholder: 'Duration...',
                    type: 'number',
                    visible: true
                },
                {
                    name: 'startDate',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'endDate',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
            ],
        }

        function add() {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/telehealth/create/telehealth-meeting-dialog.html',
                    controller: 'TelehealthMeetingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                id: null,
                                topic: null,
                                description: null,
                                startDate: new Date(),
                                timeZone: null,
                                duration: 1,
                                password: null,
                                telehealthMeetingRecurrence: {
                                    frequency: 'NONE',
                                    repeat: 1,
                                    end: 'RECURRENCE',
                                    endDate: null,
                                    id: null,
                                    weekDays: '0000000',
                                    facility: CoreService.getCurrentFacility()
                                },
                                host: null,
                                facility: CoreService.getCurrentFacility()
                            };
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function choose(id) {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/telehealth/choose/telehealth-meeting-choose-edit-dialog.html',
                    controller: 'TelehealthMeetingChooseEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {}
                }).result.then(function (result) {
                    if (result === 'meeting') {
                        resolve(edit(id));
                    } else if (result === 'allMeetings') {
                        resolve(editMeetingAndRecurrence(id));
                    }
                }, function () {
                    toastr.error('Something went wrong', 'Error');

                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/telehealth/edit/telehealth-meeting-edit-dialog.html',
                    controller: 'TelehealthMeetingEditController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['TelehealthMeeting', function (TelehealthMeeting) {
                            return TelehealthMeeting.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function (result) {
                    if (result) {
                        toastr.success('Meeting was saved', 'Success');
                    }
                    resolve();
                }, function () {
                    toastr.error('Something went wrong', 'Error');
                    resolve();
                });
            });

        }

        function editMeetingAndRecurrence(id) {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/telehealth/create/telehealth-meeting-dialog.html',
                    controller: 'TelehealthMeetingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['TelehealthMeeting', function (TelehealthMeeting) {
                            return TelehealthMeeting.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function (result) {
                    if (result) {
                        toastr.success('Meetings were saved', 'Success');
                    }

                    resolve();
                }, function () {
                    toastr.error('Something went wrong', 'Error');
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Telehealth Meeting').result.then(function () {
                    TelehealthMeeting.delete({id: id}, function (result) {
                        if (result) {
                            toastr.success('Meeting was deleted', 'Success');
                        }

                        resolve();
                    }, function () {
                        toastr.success('Something went wrong', 'Error');
                        resolve();
                    })
                })
            });
        }

        function detail(id) {
            $uibModal.open({
                templateUrl: 'app/entities/telehealth/detail/telehealth-meeting-detail-dialog.html',
                controller: 'TelehealthMeetingDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TelehealthMeeting', function (TelehealthMeeting) {
                        return TelehealthMeeting.get({id: id}).$promise;
                    }]
                }
            });
        }

        function join(telehealthMeeting) {
            var endpoint = ($window.origin).includes('localhost') ? 'http://localhost:3000/meeting/' : 'https://twvideo.bluebookehr.com/meeting/';
            var origin = ($window.origin).includes('localhost') ? 'localhost' : ($window.origin).substr(8);
            var url = endpoint + telehealthMeeting.twilioRoomName + '/' + origin;

            if (telehealthMeeting.hostId === CoreService.getCurrentEmployee().id) {
                url = url + '?username=' + telehealthMeeting.employeeFirstName + ' ' + telehealthMeeting.employeeLastName + '&password=' + telehealthMeeting.password;
            }

            $window.open(url, '_blank');
        }

        function start(telehealthMeeting) {
            return $q(function (resolve, reject) {
                var endpoint = ($window.origin).includes('localhost') ? 'http://localhost:3000/meeting/' : 'https://twvideo.bluebookehr.com/meeting/';
                var origin = ($window.origin).includes('localhost') ? 'localhost' : ($window.origin).substr(8);
                var url = endpoint + telehealthMeeting.twilioRoomName + '/' + origin;

                TelehealthMeeting.startMeeting({twilioRoomName: telehealthMeeting.twilioRoomName}, function (result) {
                    if (result.isValid) {
                        $window.open(url + '?username=' + result.telehealthMeeting.host.firstName + ' ' + result.telehealthMeeting.host.lastName + '&password=' + result.telehealthMeeting.password, '_blank');
                    } else {
                        toastr.error('Something went wrong: ' + result.error, 'Error');
                    }

                    resolve();
                });
            })
        }

        function end(id) {
            return $q(function (resolve, reject) {
                var twilioRoomName = _.filter(vm.telehealthMeetings, ['id', id])[0].twilioRoomName;

                TelehealthMeeting.endMeeting({twilioRoomName: twilioRoomName},
                    function (result) {
                        if (!result.isValid) {
                            toastr.error('Something went wrong: ' + result.error, 'Error');
                        }

                        resolve();
                    }, function () {
                        resolve();
                    });
            });
        }

        function invitation(id) {
            $uibModal.open({
                templateUrl: 'app/entities/telehealth/invitation/telehealth-meeting-invitation-dialog.html',
                controller: 'TelehealthMeetingInvitationController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['TelehealthMeeting', function (TelehealthMeeting) {
                        return TelehealthMeeting.get({id: id}).$promise;
                    }]
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TelehealthMeetingInvitationController', TelehealthMeetingInvitationController);

    TelehealthMeetingInvitationController.$inject = ['$uibModalInstance', 'entity', '$rootScope', '$window'];

    function TelehealthMeetingInvitationController($uibModalInstance, entity, $rootScope, $window) {
        var vm = this;

        vm.telehealthMeeting = entity;
        var endpoint = ($window.origin).includes('localhost') ? 'http://localhost:3000/meeting/' : 'https://twvideo.bluebookehr.com/meeting/';
        var origin = ($window.origin).includes('localhost') ? 'localhost' : ($window.origin).substr(8);

        vm.invitation = vm.telehealthMeeting.status === 'SCHEDULED' ? ('\n' +
            vm.telehealthMeeting.host.firstName + ' ' + vm.telehealthMeeting.host.lastName + ' is inviting you to a scheduled meeting.\n' +
            '\n' +
            'Topic: ' + vm.telehealthMeeting.topic + '\n' +
            'Time: ' + moment(vm.telehealthMeeting.startDate).format($rootScope.amDateFormat) + ' ' + vm.telehealthMeeting.timeZone + '\n' +
            '\n' +
            'Join Meeting\n' +
            endpoint + vm.telehealthMeeting.twilioRoomName + '/' + origin + '\n' +
            '\n' +
            (vm.telehealthMeeting.password ? 'Password: ' + vm.telehealthMeeting.password : '')) :
            ('\n' +
                vm.telehealthMeeting.host.firstName + ' ' + vm.telehealthMeeting.host.lastName + ' is inviting you to a live meeting.\n' +
                '\n' +
                'Topic: ' + vm.telehealthMeeting.topic + '\n' +
                '\n' +
                'Join Meeting\n' +
                endpoint + vm.telehealthMeeting.twilioRoomName+ '/' + origin + '\n' +
                '\n' +
                (vm.telehealthMeeting.password ? 'Password: ' + vm.telehealthMeeting.password : ''));

        vm.clear = clear;
        vm.copy = copy;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function copy() {
            document.querySelector("#textarea_field").select();
            document.execCommand('copy');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TelehealthMeetingEditController', TelehealthMeetingEditController);

    TelehealthMeetingEditController.$inject = ['$scope', '$uibModalInstance', 'entity', 'TelehealthMeeting', 'Employee',
        'CoreService', 'GUIUtils', 'Facility'];

    function TelehealthMeetingEditController($scope, $uibModalInstance, entity, TelehealthMeeting, Employee,
                                             CoreService, GUIUtils, Facility) {
        var vm = this;

        vm.telehealthMeeting = entity;
        vm.showPassword = false;
        vm.customRecurrences = [];
        vm.datePickerOpenStatus = {};
        vm.datePickerOptions = {
            startDateTime: {minDate: new Date()}
        };
        vm.customDatePicked = new Date(moment(vm.telehealthMeeting.startDate).add(1, 'minutes'));
        Facility.getAvailableZoneIds(function (result) {
            vm.timeZones = _.map(result, function (timeZone) {
                return timeZone.zoneId + ' ' + timeZone.offset;
            });
        });

        vm.save = save;
        vm.cancel = cancel;
        vm.getEmployees = getEmployees;
        vm.openCalendar = openCalendar;

        function save() {
            vm.isSaving = true;

            var telehealthMeeting = {
                id: vm.telehealthMeeting.id,
                status: 'SCHEDULED',
                twilioRoomName: vm.telehealthMeeting.twilioRoomName,
                startDate: new Date(vm.telehealthMeeting.startDate),
                endDate: new Date(moment(vm.telehealthMeeting.startDate).add(vm.telehealthMeeting.duration, 'minutes')),
                duration: vm.telehealthMeeting.duration,
                topic: vm.telehealthMeeting.topic,
                description: vm.telehealthMeeting.description,
                timeZone: vm.telehealthMeeting.timeZone,
                password: vm.telehealthMeeting.password,
                host: vm.telehealthMeeting.host,
                facility: vm.telehealthMeeting.facility,
                telehealthMeetingRecurrence: {
                    id: (vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === 'NONE' ? vm.telehealthMeeting.telehealthMeetingRecurrence.id : null ),
                    frequency: 'NONE',
                    endRecurrenceRepeat: null,
                    endDate: null,
                    weekDays: null,
                    facility: vm.telehealthMeeting.facility
                }
            };

            TelehealthMeeting.update(telehealthMeeting, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            $uibModalInstance.dismiss(true);
            vm.isSaving = false;
        }

        function cancel() {
            $uibModalInstance.close(false);
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TelehealthMeetingDetailController', TelehealthMeetingDetailController);

    TelehealthMeetingDetailController.$inject = ['$uibModalInstance', 'entity', '$filter', 'TelehealthMeeting', 'CoreService', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$rootScope'];

    function TelehealthMeetingDetailController($uibModalInstance, entity, $filter, TelehealthMeeting, CoreService, $q, DTColumnBuilder,
                                               DTOptionsBuilder, $rootScope) {
        var vm = this;

        vm.telehealthMeeting = entity;
        vm.dtInstance = {};

        vm.close = close;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                TelehealthMeeting.getParticipants({
                    id: vm.telehealthMeeting.id,
                    facilityId: CoreService.getCurrentFacility().id
                }, function (result) {
                    vm.participants = result;
                    vm.telehealthMeeting.participants = result.length;
                    defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.participants, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('tp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(5)

        vm.dtColumns = [
            DTColumnBuilder.newColumn('identity').withTitle('Participant'),
            DTColumnBuilder.newColumn(null).withTitle('Join Time').notSortable().renderWith(function (data, type, full) {
                return moment(data.startDate).format($rootScope.amDateFormat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Time').notSortable().renderWith(function (data, type, full) {
                return data.endDate ? (moment(data.endDate).format($rootScope.amDateFormat)) : '-';
            })
        ];

        function close() {
            $uibModalInstance.close();
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})
();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TelehealthMeetingDialogController', TelehealthMeetingDialogController);

    TelehealthMeetingDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'TelehealthMeeting', 'Employee',
        'CoreService', 'GUIUtils', 'Facility'];

    function TelehealthMeetingDialogController($scope, $uibModalInstance, entity, TelehealthMeeting, Employee,
                                               CoreService, GUIUtils, Facility) {
        var vm = this;

        vm.telehealthMeeting = entity;
        vm.showPassword = false;
        vm.customRecurrences = [];
        vm.datePickerOpenStatus = {};
        vm.datePickerOptions = {
            startDateTime: {minDate: new Date()},
            customDateTime: {minDate: new Date(moment(vm.telehealthMeeting.startDate).add(1, 'minutes'))},
            recurrenceEndDate: {minDate: new Date(moment(vm.telehealthMeeting.startDate).add(1, 'days'))}
        };
        vm.customDatePicked = new Date(moment(vm.telehealthMeeting.startDate).add(1, 'minutes'));
        vm.days = GUIUtils.getDays();
        vm.weekDays = GUIUtils.weekCodeStringToDays(vm.telehealthMeeting.telehealthMeetingRecurrence.weekDays);
        Facility.getAvailableZoneIds(function (result) {
            vm.timeZones = _.map(result, function (timeZone) {
                return timeZone.zoneId + ' ' + timeZone.offset;
            });
        });

        vm.save = save;
        vm.cancel = cancel;
        vm.getEmployees = getEmployees;
        vm.openCalendar = openCalendar;
        vm.addCustomDate = addCustomDate;
        vm.deleteCustomDate = deleteCustomDate;
        vm.startDateChanged = startDateChanged;
        vm.recurrenceChanged = recurrenceChanged;

        function save() {
            vm.isSaving = true;
            vm.telehealthMeeting.telehealthMeetingRecurrence.end === 'RECURRENCE' ? vm.telehealthMeeting.telehealthMeetingRecurrence.endDate = null : vm.telehealthMeeting.telehealthMeetingRecurrence.repeat = null;

            switch (vm.telehealthMeeting.telehealthMeetingRecurrence.frequency) {
                case 'NONE' :
                case 'CUSTOM' : {
                    vm.telehealthMeeting.telehealthMeetingRecurrence.weekDays = null;
                    vm.telehealthMeeting.telehealthMeetingRecurrence.end = null;
                    vm.telehealthMeeting.telehealthMeetingRecurrence.repeat = null;
                    break;
                }
                case 'DAILY' :
                case 'MONTHLY' : {
                    vm.telehealthMeeting.telehealthMeetingRecurrence.weekDays = null;
                    break;
                }
                case 'WEEKLY' : {
                    vm.telehealthMeeting.telehealthMeetingRecurrence.weekDays = GUIUtils.daysToWeekCodeString(vm.weekDays);
                }
            }

            TelehealthMeeting.saveAll(getTelehealthMeetingUploadProj(), onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            $uibModalInstance.close(true);
            vm.isSaving = false;
        }

        function onSaveError() {
            $uibModalInstance.dismiss('cancel');
            vm.isSaving = false;
        }

        function cancel() {
            $uibModalInstance.close(false);
        }

        function addCustomDate(date) {
            vm.customRecurrences.push(date);
            vm.customDatePicked = new Date(moment(vm.telehealthMeeting.startDate).add(1, 'minutes'));
        }

        function deleteCustomDate(index) {
            vm.customRecurrences.splice(index, 1);
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function startDateChanged() {
            vm.customDatePicked = new Date(moment(vm.telehealthMeeting.startDate));
            vm.datePickerOptions.customDateTime = {minDate: new Date(moment(vm.telehealthMeeting.startDate).add(1, 'minutes'))};

            switch (vm.telehealthMeeting.telehealthMeetingRecurrence.frequency) {
                case 'DAILY' : {
                    recurrenceChanged('days')
                    break;
                }
                case 'WEEKLY' : {
                    recurrenceChanged('weeks')
                    break;
                }
                case 'MONTHLY' : {
                    recurrenceChanged('months')
                    break;
                }
            }
        }

        function getTelehealthMeetingUploadProj() {
            var telehealthMeetingUploadProj = {
                facilityId: CoreService.getCurrentFacility().id,
                telehealthMeetingRecurrence: vm.telehealthMeeting.telehealthMeetingRecurrence,
                telehealthMeetings: []
            }

            addTelehealthMeeting(telehealthMeetingUploadProj, vm.telehealthMeeting.startDate);

            switch (vm.telehealthMeeting.telehealthMeetingRecurrence.frequency) {
                case 'DAILY' : {
                    for (var i = 1; i <= getRepeat('days'); i++) {
                        var auxDate = moment(vm.telehealthMeeting.startDate).add(i, 'days').toDate();

                        addTelehealthMeeting(telehealthMeetingUploadProj, auxDate);
                    }
                    break;
                }
                case 'WEEKLY' : {
                    var aux = [1, 7, 6, 5, 4, 3, 2];
                    var currentDay = moment(vm.telehealthMeeting.startDate).day();
                    var nextMonday = moment(vm.telehealthMeeting.startDate).add(aux[currentDay], 'days').toDate();

                    for (var i = 0; i < 7; i++) {
                        if (vm.telehealthMeeting.telehealthMeetingRecurrence.weekDays.charAt(i) === '1') {
                            var pivotDate = new Date(moment(nextMonday).add(i, 'days').toDate());
                            for (var j = 0; j < getRepeat('weeks'); j++) {
                                var auxDate = moment(pivotDate).add(j, 'weeks').toDate();

                                addTelehealthMeeting(telehealthMeetingUploadProj, auxDate);
                            }
                        }
                    }
                    break;
                }
                case 'MONTHLY' : {
                    for (var i = 1; i <= getRepeat('months'); i++) {
                        var auxDate = moment(vm.telehealthMeeting.startDate).add(i, 'months').toDate();

                        addTelehealthMeeting(telehealthMeetingUploadProj, auxDate);
                    }
                    break;
                }
                case 'CUSTOM' : {
                    _.forEach(vm.customRecurrences, function (customRecurrence) {

                        addTelehealthMeeting(telehealthMeetingUploadProj, customRecurrence);
                    })
                    break;
                }
            }

            return telehealthMeetingUploadProj;
        }

        function addTelehealthMeeting(telehealthMeetingUploadProj, date) {

            telehealthMeetingUploadProj.telehealthMeetings.push({
                status: 'SCHEDULED',
                twilioRoomId: null,
                startDate: new Date(date),
                endDate: new Date(moment(date).add(vm.telehealthMeeting.duration, 'minutes')),
                duration: vm.telehealthMeeting.duration,
                topic: vm.telehealthMeeting.topic,
                description: vm.telehealthMeeting.description,
                timeZone: vm.telehealthMeeting.timeZone,
                password: vm.telehealthMeeting.password,
                host: vm.telehealthMeeting.host,
                facility: vm.telehealthMeeting.facility
            })
        }

        function getRepeat(interval) {

            return vm.telehealthMeeting.telehealthMeetingRecurrence.end === 'RECURRENCE' ?
                vm.telehealthMeeting.telehealthMeetingRecurrence.repeat :
                moment(vm.telehealthMeeting.telehealthMeetingRecurrence.endDate).diff(moment(vm.telehealthMeeting.startDate), interval);
        }

        function recurrenceChanged(interval) {
            var aux = new Date(vm.telehealthMeeting.startDate);
            vm.telehealthMeeting.telehealthMeetingRecurrence.endDate = new Date(moment(aux).add(1, interval));
            vm.datePickerOptions.recurrenceEndDate = {minDate: new Date(moment(aux).add(1, interval))};
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('TelehealthMeetingChooseEditController',TelehealthMeetingChooseEditController);

    TelehealthMeetingChooseEditController.$inject = ['$uibModalInstance'];

    function TelehealthMeetingChooseEditController($uibModalInstance) {
        var vm = this;

        vm.value = 'meeting';

        vm.clear = clear;
        vm.edit = edit;

        function clear () {
            $uibModalInstance.close(false);
        }

        function edit () {
            $uibModalInstance.close(vm.value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDialogController', SuperBillDialogController);

    SuperBillDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SuperBill', 'Evaluation', 'Employee', 'InsuranceCarrier', 'InsuranceType', 'InsuranceLevel', 'InsuranceRelation', 'CountryState', 'Chart'];

    function SuperBillDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SuperBill, Evaluation, Employee, InsuranceCarrier, InsuranceType, InsuranceLevel, InsuranceRelation, CountryState, Chart) {
        var vm = this;

        vm.superbill = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.evaluations = Evaluation.query();
        vm.employees = Employee.query();
        vm.insurancecarriers = InsuranceCarrier.query();
        vm.insurancetypes = InsuranceType.query();
        vm.insurancelevels = InsuranceLevel.query();
        vm.insurancerelations = InsuranceRelation.query();
        vm.countrystates = CountryState.query();
        vm.charts = Chart.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.superbill.id !== null) {
                SuperBill.update(vm.superbill, onSaveSuccess, onSaveError);
            } else {
                SuperBill.save(vm.superbill, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:superBillUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateOfService = false;
        vm.datePickerOpenStatus.billDate = false;
        vm.datePickerOpenStatus.insuranceDob = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDetailController', SuperBillDetailController);

    SuperBillDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SuperBill', 'Evaluation', 'Employee', 'InsuranceCarrier', 'InsuranceType', 'InsuranceLevel', 'InsuranceRelation', 'CountryState', 'Chart'];

    function SuperBillDetailController($scope, $rootScope, $stateParams, previousState, entity, SuperBill, Evaluation, Employee, InsuranceCarrier, InsuranceType, InsuranceLevel, InsuranceRelation, CountryState, Chart) {
        var vm = this;

        vm.superBill = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:superBillUpdate', function(event, result) {
            vm.superBill = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDeleteController',SuperBillDeleteController);

    SuperBillDeleteController.$inject = ['$uibModalInstance', 'entity', 'SuperBill'];

    function SuperBillDeleteController($uibModalInstance, entity, SuperBill) {
        var vm = this;

        vm.superBill = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SuperBill.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('super-bill', {
            parent: 'entity',
            url: '/super-bill',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SuperBills'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/superbill/super-bills.html',
                    controller: 'SuperBillController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('super-bill-detail', {
            parent: 'entity',
            url: '/super-bill/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SuperBill'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/superbill/super-bill-detail.html',
                    controller: 'SuperBillDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SuperBill', function($stateParams, SuperBill) {
                    return SuperBill.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'superBill',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('super-bill-detail.edit', {
            parent: 'super-bill-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/superbill/super-bill-dialog.html',
                    controller: 'SuperBillDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SuperBill', function(SuperBill) {
                            return SuperBill.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('super-bill.new', {
            parent: 'super-bill',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/superbill/super-bill-dialog.html',
                    controller: 'SuperBillDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dateOfService: null,
                                billDate: null,
                                status: null,
                                comment: null,
                                amountPaid: null,
                                balance: null,
                                providerFirstName: null,
                                providerLastName: null,
                                providerNpi: null,
                                placeOfSvc: null,
                                priorAuthorizationNumber: null,
                                otherProvider: null,
                                insuranceAddress: null,
                                insuranceAddress2: null,
                                insuranceZipCode: null,
                                insuranceCity: null,
                                insurancePolicyNumber: null,
                                insuranceGroupNumber: null,
                                insuranceGroupName: null,
                                insurancePlanNumber: null,
                                insuranceLastName: null,
                                insuranceFirstName: null,
                                insuranceMiddleInitial: null,
                                insuranceDob: null,
                                insuranceGender: null,
                                insurancePhone: null,
                                insuranceEmployer: null,
                                insuranceOrder: null,
                                insuranceSocialSecurity: null,
                                insurancePreCertPhone: null,
                                insuranceCountryStateId: null,
                                insuranceFrontPictureId: null,
                                insuranceFrontPictureOriginalId: null,
                                insuranceBackPictureId: null,
                                insuranceBackPictureOriginalId: null,
                                insuranceRxBin: null,
                                insurancePcn: null,
                                insuranceMemberId: null,
                                n: null,
                                nn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('super-bill', null, { reload: 'super-bill' });
                }, function() {
                    $state.go('super-bill');
                });
            }]
        })
        .state('super-bill.edit', {
            parent: 'super-bill',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/superbill/super-bill-dialog.html',
                    controller: 'SuperBillDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SuperBill', function(SuperBill) {
                            return SuperBill.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('super-bill', null, { reload: 'super-bill' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('super-bill.delete', {
            parent: 'super-bill',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/superbill/super-bill-delete-dialog.html',
                    controller: 'SuperBillDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SuperBill', function(SuperBill) {
                            return SuperBill.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('super-bill', null, { reload: 'super-bill' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('SuperBillSearch', SuperBillSearch);

    SuperBillSearch.$inject = ['$resource'];

    function SuperBillSearch($resource) {
        var resourceUrl =  'api/_search/super-bills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBill2Controller', SuperBill2Controller);

    SuperBill2Controller.$inject = ['$scope', '$state', 'SuperBill', 'SuperBillSearch'];

    function SuperBill2Controller ($scope, $state, SuperBill, SuperBillSearch) {
        var vm = this;

        vm.superbills = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Superbill.query(function(result) {
                vm.superbills = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            SuperbillSearch.query({query: vm.searchQuery}, function(result) {
                vm.superbills = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDiagnosisDialogController', SuperBillDiagnosisDialogController);

    SuperBillDiagnosisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SuperBillDiagnosis', 'SuperBill', 'Diagnoses', 'Acuity', 'Icd10Search', 'CoreService', 'Chart'];

    function SuperBillDiagnosisDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, SuperBillDiagnosis, SuperBill, Diagnoses, Acuity, Icd10Search, CoreService, Chart) {
        var vm = this;

        vm.superBillDiagnosis = entity;
        vm.chart = Chart.get({id:vm.superBillDiagnosis.superBill.chartId})
        vm.showDelete = false;
        vm.acuity = Acuity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.icd10 = [];
        vm.icd10Tmp = [];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};

        vm.save = save;
        vm.clear = clear;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;
        vm.getIcd10 = getIcd10;
        vm.confirmDelete = confirmDelete;

        init();

        function init() {
            if (vm.superBillDiagnosis.id) {
                vm.icd10Tmp = [vm.superBillDiagnosis.icd10];
            }
        }

        function getIcd10(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.superBillDiagnosis.endDate;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.superBillDiagnosis.startDate;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.close('dismiss');
        }

        function save() {
            vm.isSaving = true;

            if (vm.superBillDiagnosis.id) {
                SuperBillDiagnosis.update(vm.superBillDiagnosis, onSaveSuccess, onSaveError);
            } else {
                vm.superBillDiagnosis.icd10S = vm.icd10Tmp;
                SuperBillDiagnosis.create(vm.superBillDiagnosis, onSaveSuccess, onSaveError)
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function confirmDelete () {
            SuperBillDiagnosis.delete({id: vm.superBillDiagnosis.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SuperBillDiagnosis', SuperBillDiagnosis);

    SuperBillDiagnosis.$inject = ['$resource', 'DateUtils'];

    function SuperBillDiagnosis ($resource, DateUtils) {
        var resourceUrl =  'api/super-bill-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'create': {url: 'api/super-bill-diagnoses/create',  method:'POST'},
            'findAllBySuperBill': {method: 'GET', url: 'api/super-bill-diagnoses/by-super-bill/:id', isArray: true },
            'reorder': { method: 'POST', url: 'api/super-bill-diagnoses/reorder', isArray: false }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDiagnosisController', SuperBillDiagnosisController);

    SuperBillDiagnosisController.$inject = ['$scope', '$state', 'SuperBillDiagnosis', '$uibModal', 'entity'];

    function SuperBillDiagnosisController($scope, $state, SuperBillDiagnosis, $uibModal, entity) {
        var vm = this;

        vm.superBill = entity;
        vm.superBillDiagnoses = [];

        vm.loadAll = loadAll;
        vm.onDragEnd = onDragEnd;
        vm.add = add;
        vm.edit = edit;

        loadAll();

        function loadAll() {
            SuperBillDiagnosis.findAllBySuperBill({id: vm.superBill.id}, function (result) {
                vm.superBillDiagnoses = result;
            });
        }

        function onDragEnd(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].xorder !== i + 1) {
                    list[i].xorder = i + 1;
                    SuperBillDiagnosis.reorder({id: list[i].id, xorder: list[i].xorder})

                } else {
                    list[i].xorder = i + 1;
                }
            }
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/super-bill-diagnosis/super-bill-diagnoses-dialog.html',
                controller: 'SuperBillDiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            comment: null,
                            id: null,
                            endDate: null,
                            startDate: null,
                            superBill:  vm.superBill
                        }
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/super-bill-diagnosis/super-bill-diagnoses-dialog.html',
                controller: 'SuperBillDiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['SuperBillDiagnosis', function (SuperBillDiagnosis) {
                        return SuperBillDiagnosis.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillViewController', SuperBillViewController);

    SuperBillViewController.$inject = ['entity', 'Chart', 'Procedure', 'ProcedureDiagnosis', 'ProcedureModifier',
        'dialogs', 'CptSearch', '$uibModal', 'Diagnoses', 'Icd10Search', 'ModifierSearch',
        'ProClaimConf', 'SuperBill', '$state', 'SuperBillDiagnosis'];

    function SuperBillViewController(entity, Chart, Procedure, ProcedureDiagnosis, ProcedureModifier,
                                     $dialogs, CptSearch, $uibModal, Diagnoses, Icd10Search, ModifierSearch,
                                     ProClaimConf, SuperBill, $state, SuperBillDiagnosis) {
        var vm = this;

        vm.superBill = entity;
        vm.chart = null;
        vm.procedures = [];
        vm.cpts = [];
        vm.superBillDiagnoses = [];
        vm.tpl = 'app/entities/procedure/tpl/procedure-form-professional.html';
        vm.isProfessional = true;

        vm.removeProcedureModifier = removeProcedureModifier;
        vm.clone = clone;
        vm.onDragEnd = onDragEnd;
        vm.removeProcedureDiagnoses = removeProcedureDiagnoses;
        vm.removeCpt = removeCpt;
        vm.changeProcedure = changeProcedure;
        vm.getCpts = getCpts;
        vm.editProvider = editProvider;
        vm.addProcedure = addProcedure;
        vm.editProcedure = editProcedure;
        vm.addProcedure = addProcedure;
        vm.delProcedure = delProcedure;

        vm.icd10Selected = [];
        vm.icd10SearchQuery = '';
        vm.modifierSearchQuery = '';
        vm.modifierSelected = [];
        vm.lastsIcd10ByFacility = [];
        vm.lastsModifiersByFacility = [];
        vm.onSelectIcd10 = onSelectIcd10;
        vm.renderIcd10 = renderIcd10;
        vm.getIcd10Options = getIcd10Options;
        vm.getIcd10FrequentlyOptions = getIcd10FrequentlyOptions;
        vm.onSelectModifier = onSelectModifier;
        vm.renderModifier = renderModifier;
        vm.getModifierOptions = getModifierOptions;
        vm.getModifierFrequentlyOptions = getModifierFrequentlyOptions;
        vm.save = save;

        vm.icd10TabsConf = [
            {
                name: 'Search Results',
                icon: 'fa fa-list',
                func: getIcd10Options,
                options: []
            },
            {
                name: 'Frequently added',
                icon: 'fa fa-clock-o',
                func: getIcd10FrequentlyOptions,
                options: []
            }
        ];

        vm.modifierTabsConf = [
            {
                name: 'Search Results',
                icon: 'fa fa-list',
                func: getModifierOptions,
                options: []
            },
            {
                name: 'Frequently added',
                icon: 'fa fa-clock-o',
                func: getModifierFrequentlyOptions,
                options: []
            }
        ];

        init();

        function init() {
            Chart.get({id: vm.superBill.chartId}, function (result) {
                vm.chart = result;
            });

            if (vm.superBill.billingType !== 'PROFESSIONAL') {
                vm.tpl = 'app/entities/procedure/tpl/procedure-form-institutional.html';
                vm.isProfessional = false;
            }

            Procedure.getProcedures({id: vm.superBill.id}, function (result) {
                vm.procedures = result;

                _.forEach(vm.procedures, function (procedure) {
                    ProcedureDiagnosis.findAllByProcedure({id: procedure.id}, function (procedureDiagnosis) {
                        procedure.diagnoses = procedureDiagnosis;
                    });

                    ProcedureModifier.findAllByProcedure({id: procedure.id}, function (procedureModifier) {
                        procedure.modifiers = procedureModifier;
                    })
                })
            });
        }

        function clone(index) {
            var newProcedure = angular.copy(vm.procedures[index]);
            newProcedure.id = null;
            newProcedure.diagnoses.forEach(function (el) {
                el.id = null;
            });
            newProcedure.modifiers.forEach(function (el) {
                el.id = null;
            });
            vm.procedures.push(newProcedure);
        }

        function onDragEnd(list) {
            for (var i = 0; i < list.length; i++) {
                list[i].xorder = i + 1;
            }
        }

        function removeProcedureModifier(modifierList, indexModifier) {
            var dialog = $dialogs.confirm('Please Confirm', 'Are you sure you want to remove this Procedure Modifier?', {size: 'md'});
            dialog.result.then(function () {
                _.pullAt(modifierList, indexModifier);
            });
        }

        function removeProcedureDiagnoses(diagnosesList, indexDiagnoses) {
            var dialog = $dialogs.confirm('Please Confirm', 'Are you sure you want to remove this Procedure Diagnose?', {size: 'md'});
            dialog.result.then(function () {
                _.pullAt(diagnosesList, indexDiagnoses);
            });
        }

        function getCpts(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.cpts = CptSearch.query({query: query});
            }
        }

        function changeProcedure(index, cpt) {
            if (cpt) {
                vm.procedures[index].cpt = cpt;
            }
        }

        function removeCpt(procedureIndex) {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to remove this Cpt?', {size: 'md'});
            dlg.result.then(function () {
                vm.procedures[procedureIndex].cpt = null;
                vm.cpts.selected = undefined;
            });
        }

        function editProvider() {
            $uibModal.open({
                templateUrl: 'app/entities/super-bill/super-bill-provider-dialog.html',
                controller: 'SuperBillProviderDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: vm.superBill
                }
            }).result.then(function () {
            }, function () {
            });
        }

        function onSelectIcd10(prod) {
            _.forEach(vm.icd10Selected[prod.id], function (icd10) {
                if (!_.find(prod.diagnoses, function (o) {
                    return o.icd10.id === icd10.id;
                })) {
                    prod.diagnoses.push({
                        id: null,
                        icd10: icd10,
                        xorder: prod.diagnoses.length + 1
                    })
                }
            });
        }

        function renderIcd10(element) {
            if (element) {
                return '<strong>' + element['code'] + '</strong> -' + element['description'];
            }
        }

        function getIcd10Options(searchQuery, tab) {
            if (searchQuery && searchQuery.length > 2 && searchQuery !== vm.icd10SearchQuery) {
                Icd10Search.query({query: searchQuery}, function (result) {
                    tab.options = result;
                    vm.icd10SearchQuery = searchQuery;
                });
            }
        }

        function getIcd10FrequentlyOptions(searchQuery, tab) {
            if (!vm.lastsIcd10ByFacility.length > 0) {
                Diagnoses.lastsIcd10UsedByFacility({facilityId: vm.chart.facilityId}, function (icd10s) {
                    vm.lastsIcd10ByFacility = icd10s;
                    tab.options = icd10s;
                });
            }
        }

        function onSelectModifier(prod) {
            _.forEach(vm.modifierSelected[prod.id], function (modifier) {
                if (!_.find(prod.modifiers, function (o) {
                    return o.modifier.id === modifier.id;
                })) {
                    prod.modifiers.push({
                        id: null,
                        modifier: modifier,
                        xorder: prod.modifiers.length + 1
                    })
                }
            });
        }

        function renderModifier(element) {
            if (element) {
                return '<strong>' + element['code'] + '</strong> -' + element['shortDesc'];
            }
        }

        function getModifierOptions(searchQuery, tab) {
            if (searchQuery && searchQuery.length > 0 && searchQuery !== vm.modifierSearchQuery) {
                searchQuery = _.lowerCase(searchQuery);
                ModifierSearch.query({query: searchQuery}, function (result) {
                    tab.options = result;
                    vm.modifierSearchQuery = searchQuery;
                });
            }
        }

        function getModifierFrequentlyOptions(searchQuery, tab) {
            if (!vm.lastsModifiersByFacility.length > 0) {
                ProClaimConf.lastsModifiersUsedByFacility({facilityId: vm.chart.facilityId}, function (modifiers) {
                    vm.lastsModifiersByFacility = modifiers;
                    tab.options = modifiers;
                });
            }
        }

        function save() {
            vm.isSaving = true;
            var procedures = []

            vm.procedures.forEach(function (procedure) {
                procedures.push({
                    'procedure': procedure,
                    'diagnoses': procedure.diagnoses,
                    'modifiers': procedure.modifiers
                });
            });

            SuperBill.update({
                superBill: vm.superBill,
                procedures: procedures
            }, onSaveSuccess, onSaveError)
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go("chart-new", {id: result.chartId});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function addProcedure() {
            $uibModal.open({
                templateUrl: vm.tpl,
                controller: 'ProcedureDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    superBill: vm.superBill,
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result.then(function () {
                init();
            });
        }

        function editProcedure(id) {
            $uibModal.open({
                templateUrl: vm.tpl,
                controller: 'ProcedureDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    superBill: vm.superBill,
                    entity: ['Procedure', function (Procedure) {
                        return Procedure.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                init();
            });
        }

        function delProcedure(id) {
            $uibModal.open({
                templateUrl: 'app/entities/procedure/procedure-delete-dialog.html',
                controller: 'ProcedureDeleteController',
                controllerAs: 'vm',
                size: 'md',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Procedure', function (Procedure) {
                        return Procedure.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                init();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillProviderDialogController', SuperBillProviderDialogController);

    SuperBillProviderDialogController.$inject = ['$uibModalInstance', 'CoreService', 'Employee', 'entity', 'DateUtils',
        'Facility'];

    function SuperBillProviderDialogController($uibModalInstance, CoreService, Employee, entity, DateUtils,
                                               Facility) {
        var vm = this;

        vm.superBill = entity;
        vm.employees = Employee.byActive({id: CoreService.getCorporation().id});

        vm.clear = clear;
        vm.renderingProviderChange = renderingProviderChange;
        vm.billingProviderChange = billingProviderChange;
        vm.openCalendar = openCalendar;

        if (typeof vm.superBill.startDate === 'string') {
            vm.superBill.startDate = DateUtils.convertLocalDateFromServer(vm.superBill.startDate);
            vm.superBill.endDate = DateUtils.convertLocalDateFromServer(vm.superBill.endDate);
        }

        vm.endDateOptions = {};
        vm.startDateOptions = {};

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        Facility.getAllPlaceOfServices(function (result) {
            vm.placeOfService = result;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function renderingProviderChange(employee) {
            vm.superBill.providerNpi = employee.npiNumber;
        }

        function billingProviderChange(employee) {
            vm.superBill.billingProviderNpi = employee.npiNumber;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDialogController', SuperBillDialogController);

    SuperBillDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'SuperBill', 'chart'];

    function SuperBillDialogController ($timeout, $scope, $stateParams, $uibModalInstance,
                                         SuperBill, chart) {
        var vm = this;

        vm.filter = {
            start: new Date(),
            end: new Date(),
            chartId: chart.id
        };
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.end = false;
        vm.endOptions = {};
        vm.startOptions = {};

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            SuperBill.createInstitutional(vm.filter, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:superBillUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('super-bill-view', {
                parent: 'entity',
                url: '/super-bill-view/{id}',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'Super Bill View'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/super-bill/super-bill-view.html',
                        controller: 'SuperBillViewController',
                        controllerAs: 'vm'
                    },
                    'diagnoses@super-bill-view': {
                        templateUrl: 'app/entities/super-bill-diagnosis/super-bill-diagnoses.html',
                        controller: 'SuperBillDiagnosisController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    entity: ['SuperBill', '$stateParams', function(SuperBill, $stateParams) {
                        return SuperBill.get({id : $stateParams.id}).$promise;
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_SUPER_BILL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_SUPER_BILL, access);
                }]
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SuperBill', SuperBill);

    SuperBill.$inject = ['$resource', 'DateUtils'];

    function SuperBill ($resource, DateUtils) {
        var resourceUrl =  'api/super-bills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfService = DateUtils.convertLocalDateFromServer(data.dateOfService);
                        data.billDate = DateUtils.convertLocalDateFromServer(data.billDate);
                        data.insuranceDob = DateUtils.convertLocalDateFromServer(data.insuranceDob);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfService = DateUtils.convertLocalDateToServer(copy.dateOfService);
                    copy.billDate = DateUtils.convertLocalDateToServer(copy.billDate);
                    copy.insuranceDob = DateUtils.convertLocalDateToServer(copy.insuranceDob);
                    return angular.toJson(copy);
                }
            },
            'byChart': {
                url: 'api/super-bills/by-chart/:id',
                method: 'GET',
                isArray: true
            },
            'update': {method: 'POST', url: 'api/super-bills/update'},
            'createInstitutional': {url: 'api/super-bills/create-institutional', method: 'POST'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillController', SuperBillController);

    SuperBillController.$inject = ['$state', '$uibModal', 'SuperBill', 'chart', '$scope', '$rootScope', 'Procedure',
        'TAB', 'params', 'access'];

    function SuperBillController($state, $uibModal, SuperBill, chart, $scope, $rootScope, Procedure,
                                 TAB, params, access) {
        var vm = this;

        vm.chart = chart;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.SUPER_BILL);
        vm.superBills = [];
        vm.access = access;

        vm.add = add;

        loadAll();

        function loadAll() {
            if (!vm.active) {
                return;
            }

            SuperBill.byChart({id: chart.id, page: vm.page - 1, size: vm.itemsPerPage}, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.superBills = result;

                _.forEach(vm.superBills, function (superBill) {
                    Procedure.getCpts({id: superBill.id}, function (cpts) {
                        superBill.cpts = _.join(cpts, ', ');
                    })
                })
            });
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result == TAB.SUPER_BILL) {
                vm.active = true;
                loadAll();
            }
        });

        $scope.$on('$destroy', unsubscribe);

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/super-bill/super-bill-dialog.html',
                controller: 'SuperBillDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.chart
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

    }
})();

'use strict';

angular
    .module('bluebookApp')
    .directive('searchSelect', searchSelect);

searchSelect.$inject = [];
function searchSelect() {

    return {
        restrict: 'E',
        templateUrl: 'app/entities/super-bill/search-select/search-select.html',
        scope: {
            name: '@',
            placeholder: '@',
            tabsConf: '=',
            ngModel: '=',
            compareProperty: '=?',
            ngDisabled: '=?',
            ngRequired: '=?',
            onSelect: '&',
            render: '&?'
        },
        link: linkFunc

    };

    /* private helper methods*/

    function linkFunc($scope) {

        $scope.getOptions = getOptions;
        $scope.getSelectTitleValue = getSelectTitleValue;
        $scope.onSelectFn = onSelectFn;

        init();

        function init() {
            $scope.ngModel = [];
            $scope.tabs = angular.copy($scope.tabsConf);
            $scope.searchQuery = '';
            $scope.currentElement = null;
            $scope.currentIndex = null;
            $scope.searchQuery = '';
            $scope.selected = {
                value : null
            };
            $scope.ngDisabled = !!$scope.ngDisabled;
            $scope.ngRequired = !!$scope.ngRequired;
            $scope.isOpen = false;
        }

        function getSelectTitleValue(element) {
            if (element && element.constructor !== Array) {
                if($scope.render){
                    return $scope.render()(element);
                }else {
                    return element;
                }
            }
        }

        function unsetAll(obj, val) {
            _.forEach(Object.keys(obj), function (k) {
                obj[k] = val;
            });
        }

        function onSelectFn() {
            if ($scope.onSelect) {
                $scope.onSelect();
                unsetAll($scope.selected.value, false);
                $scope.ngModel = [];
            } else {
                console.log('You must to define onSelect() function.');
            }
        }

        function  getOptions(element) {
            $scope.currentElement = element;
            if(element && element.func){
                element.func($scope.searchQuery, element);
            }
        }

        $scope.check = function(value, checked) {
            if($scope.compareProperty){
                var idx = _.findIndex($scope.ngModel, function(o) { return o[$scope.compareProperty]=== value[$scope.compareProperty]; });
            } else {
                var idx = $scope.ngModel.indexOf(value);
            }
             //
            if (idx >= 0 && !checked) {
                $scope.ngModel.splice(idx, 1);
            }
            if (idx < 0 && checked) {
                $scope.ngModel.push(value);
            }
        };

        $scope.$watch('searchQuery', function () {
            getOptions($scope.currentElement);
        }, true);

    }
}

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('SpecimenDialogController', SpecimenDialogController);

    SpecimenDialogController.$inject = ['Specimen', 'entity', '$timeout', '$uibModalInstance', '$scope'];

    function SpecimenDialogController(Specimen, entity, $timeout, $uibModalInstance, $scope) {
        var vm = this;

        vm.specimen = entity;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.specimen.id !== null) {
                Specimen.update(vm.specimen, onSaveSuccess, onSaveError);
            } else {
                Specimen.save(vm.specimen, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:specimenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('specimen', {
                parent: 'entity',
                url: '/specimen',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Specimen'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/specimen/list/specimen.html',
                        controller: 'SpecimenController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Specimen', Specimen);

    Specimen.$inject = ['$resource'];

    function Specimen ($resource) {
        var resourceUrl =  'api/specimens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByLaboratory': { url: 'api/specimens/laboratory', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SpecimenController', SpecimenController);

    SpecimenController.$inject = ['GUIUtils', '$q', 'Specimen', 'Laboratory', '$uibModal', 'CoreService',
        'GenericEntityDatatableService', 'PopupService', 'ConfirmationService'];

    function SpecimenController(GUIUtils, $q, Specimen, Laboratory, $uibModal, CoreService,
                                GenericEntityDatatableService, PopupService, ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        vm.descriptor = {
            title: 'Specimens',
            newAction: false,
            entityClassHumanized: 'Specimens',
            entityStateName: 'specimens',
            service: Specimen,
            serviceMethod: 'findAllByLaboratory',
            pagination: 'remote',
            params: {},
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('specimen'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('specimen'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Specimen',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectLaboratoryPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = result;

                                        vm.laboratory = result;
                                        vm.descriptor.title = 'Specimens - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/specimen/update/specimen-dialog.html',
                    controller: 'SpecimenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                laboratory: vm.laboratory
                            };
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/specimen/update/specimen-dialog.html',
                    controller: 'SpecimenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['Specimen', function (Specimen) {
                            return Specimen.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDeleteConfirmation('Specimen').result.then(function () {
                    Specimen.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftTypeDialogController', ShiftTypeDialogController);

    ShiftTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ShiftType'];

    function ShiftTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ShiftType) {
        var vm = this;

        vm.shiftType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.shiftType.id !== null) {
                ShiftType.update(vm.shiftType, onSaveSuccess, onSaveError);
            } else {
                ShiftType.save(vm.shiftType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:shiftTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('shift-type', {
                parent: 'entity',
                url: '/shift-type',
                data: {
                    authorities: [],
                    pageTitle: 'ShiftTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shift-type/list/shift-type.html',
                        controller: 'ShiftTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Shift Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ShiftType', ShiftType);

    ShiftType.$inject = ['$resource'];

    function ShiftType ($resource) {
        var resourceUrl =  'api/shift-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/shift-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftTypeController', ShiftTypeController);

    ShiftTypeController.$inject = ['GenericEntityDatatableService', 'CoreService', 'ShiftType', '$uibModal',
        'ConfirmationService', '$q'];

    function ShiftTypeController(GenericEntityDatatableService, CoreService, ShiftType, $uibModal,
                                 ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Shift Type',
            newButtonTitle: 'New Shift Type',
            entityClassHumanized: 'Shift Type',
            entityStateName: 'shift-type',
            service: ShiftType,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Shift Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/shift-type/update/shift-type-dialog.html',
                controller: 'ShiftTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/shift-type/update/shift-type-dialog.html',
                controller: 'ShiftTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ShiftType', function (ShiftType) {
                        return ShiftType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Shift Type').result.then(function () {
                    ShiftType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ShiftNote', ShiftNote);

    ShiftNote.$inject = ['$resource'];

    function ShiftNote ($resource) {
        var resourceUrl =  'api/shift-notes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ShiftChart', ShiftChart);

    ShiftChart.$inject = ['$resource'];

    function ShiftChart ($resource) {
        var resourceUrl =  'api/shift-charts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT', ignoreLoadingBar: true },
            'pageableByFindAllShiftCharts': { url: 'api/shift-charts/shiftId/:id',
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(data) {
                        data = angular.fromJson(data);
                        var result = [];
                        data.forEach(function (element) {
                            element[0].shift = element[1];
                            result.push(element[0]);
                        });
                        return result;
                    }
                }
                },
            'findOneById': { url: 'api//shift-charts/custom/:id', method: 'GET',ignoreLoadingBar: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftDialogController', ShiftDialogController);

    ShiftDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Shift',
        'Building', 'TypeLevelCare', 'ShiftType', 'Employee', 'ShiftChart', 'Chart', 'ShiftNote',
        'CoreService', 'toastr'];

    function ShiftDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Shift,
                                   Building, TypeLevelCare, ShiftType, Employee, ShiftChart, Chart, ShiftNote,
                                   CoreService, toastr) {
        var vm = this;


        vm.entity = entity;
        vm.facility = CoreService.getCurrentFacility();
        vm.shift = vm.entity;
        vm.originalEntity = angular.copy(vm.entity);
        vm.datePickerOpenStatus = {};
        vm.shiftChartPatients = [];
        vm.loadedPatientsByShift = [];
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };
        vm.newPatients = [];
        vm.newPatientsConverted = [];
        vm.addedPatients = [];
        vm.isShiftEmployee = false;
        vm.isShiftReviewer = false;
        vm.visibilityToggleTable = false;
        vm.shiftEmployeeSignature = '';
        vm.shiftEmployeeSignaturePin = null;
        vm.shiftReviewerSignature = '';
        vm.shiftReviewerSignaturePin = '';
        vm.customNote = "";
        vm.startTime = vm.shift.startTime;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.buildings = Building.byFacility({id: CoreService.getCurrentFacility().id});
        vm.typelevelcares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.shifttypes = ShiftType.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.corporation = CoreService.getCorporation();
        vm.employees = getEmployees();
        vm.employee = CoreService.getCurrentEmployee();
        vm.facilityId = vm.facility.id;
        vm.ids = [];

        //Functions

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.saveClose = saveClose;
        vm.loadPatientDetails = loadPatientDetails;
        vm.addPatients = addPatients;
        vm.present = present;
        vm.patientsForm = patientsForm;
        vm.listCreation = listCreation;
        vm.isPinCorrect = isPinCorrect;
        vm.editNote = editNote;
        vm.checkEditableNotes = checkEditableNotes;
        vm.getEditableNotes = getEditableNotes;
        vm.showLastEditableNote = showLastEditableNote;
        vm.cancelNewNote = cancelNewNote;
        vm.crudNote = crudNote;
        vm.addNotesToPatients = addNotesToPatients;
        vm.loadPage = loadPage;
        vm.saveChangedNote = saveChangedNote;
        vm.switchingBack = switchingBack;
        vm.newNoteCreation = newNoteCreation;
        vm.deletePatient = deletePatient;
        vm.deleteNote = deleteNote;
        vm.saveReviewers = saveReviewers;
        vm.closeAllNotes = closeAllNotes;
        vm.load = load;
        vm.removeFromReviewers = removeFromReviewers;
        vm.getEmployees = getEmployees;

        isCurrentEmployee();
        isCurrentReviewer();
        validatingCurrentUser();
        loadPatientDetails();

        function checkEditableNotes(item) {
            var editableNotes = 0;

            if (item && item.shiftNotes) {
                item.shiftNotes.forEach(function (note) {
                    if (!note.delStatus) {
                        editableNotes++;
                    }
                });
            }

            return editableNotes > 0
        }

        function getEditableNotes(item) {
            var editableNotes = 0;
            item.shiftNotes.forEach(function (note) {
                if (!note.delStatus) {
                    editableNotes++;
                }
            });
            return editableNotes
        }

        function showLastEditableNote(item) {
            var lastNote = [];
            for (var i = 0; i < item.shiftNotes.length; i++) {
                if (!item.shiftNotes[i].delStatus) {
                    lastNote.push(item.shiftNotes[i].note)
                }
            }
            return lastNote[0];
        }

        function cancelNewNote(item) {
            item.addCustomNote = true;
            item.closeCustomNote = false;
            item.editVisibility = false;
        }


        function validatingCurrentUser() {
            if (vm.shift.shiftEmployeeSignature) {
                vm.savedWithSign = true;
            } else {
                vm.savedWithSign = false;
            }

            if (vm.isShiftEmployee && !vm.isShiftReviewer) {
                vm.showPages = true;
            } else if (vm.isShiftEmployee === false && vm.isShiftReviewer) {
                vm.showPages = false;
            }
        }

        //Validation to remove reviewer if same as shiftEmployee sign
        function removeFromReviewers() {
            if (vm.shift.shiftEmployee && vm.reviewers) {
                var removeIndex = vm.reviewers.map(function (item) {
                    return item.id;
                }).indexOf(vm.shift.shiftEmployee.id);
                vm.reviewers.splice(removeIndex, 1);
            }
        }


        //function to retrieve all employees with appropriate credentials
        var request = {credentials: ['LCSW', 'LMHC', 'CAP']};
        vm.reviewers = vm.employees;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            if (vm.shift.id) {
                $scope.$emit('bluebookApp:shiftUpdate', vm.shift);
                $uibModalInstance.close(vm.shift);
            } else {
                $uibModalInstance.dismiss('cancel');
            }
        }

        //SAVING AND UPDATING SHIFT

        function save() {
            vm.visibilityToggleTable = false;
            vm.isSaving = true;
            if (vm.shift.id) {
                load();
                listCreation();
                vm.savedDate = vm.shift.dateCreated;
                if (angular.equals(vm.shift.building, vm.originalEntity.building) &&
                    angular.equals(vm.shift.description, vm.originalEntity.description) &&
                    angular.equals(vm.shift.dateCreated, vm.originalEntity.dateCreated) &&
                    angular.equals(vm.shift.startTime, vm.originalEntity.startTime) &&
                    angular.equals(vm.shift.endTime, vm.originalEntity.endTime) &&
                    angular.equals(vm.shift.shiftType, vm.originalEntity.shiftType) &&
                    angular.equals(vm.shift.typeLevelCares, vm.originalEntity.typeLevelCares) &&
                    angular.equals(vm.shift.employees, vm.originalEntity.employees) &&
                    angular.equals(vm.shift.shiftEmployeeSignature, vm.originalEntity.shiftEmployeeSignature) &&
                    angular.equals(vm.shift.shiftReviewerSignature, vm.originalEntity.shiftReviewerSignature) &&
                    angular.equals(vm.shift.shiftReviewers, vm.originalEntity.shiftReviewers)) {
                    vm.isSaving = false;
                } else {
                    vm.shift.lastModifiedEmployee = vm.employee;
                    Shift.update(vm.shift, onSaveSuccess, onSaveError);
                    vm.originalEntity = angular.copy(vm.shift);
                    toastr.success('The shift was updated', 'Success');
                }

                loadExistingShiftChartToView();
            } else {
                vm.savedDate = vm.shift.dateCreated;
                vm.shift.status = "Pending";
                vm.shift.lastModifiedEmployee = vm.employee;
                Shift.save(vm.shift, onSaveSuccess, onSaveError);
                toastr.success('A new shift is created', 'Success');
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('bluebookApp:shiftUpdate', result);
            if (vm.shift.shiftReviewerSignature) {
                $uibModalInstance.close(result);
            }

            vm.shift = result;
            vm.entity = angular.copy(vm.shift);
            vm.shift.dateCreated = vm.savedDate;
            loadPatientDetails();
            vm.isSaving = false;
            isCurrentEmployee();
            isCurrentReviewer();
            if (vm.isShiftEmployee && !vm.isShiftReviewer) {
                vm.showPages = true;
            } else if (vm.isShiftEmployee === false && vm.isShiftReviewer) {
                vm.showPages = false;
            }
            vm.addedPatients = [];

            vm.originalEntity = angular.copy(vm.shift);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        // Date picker options
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }


        //Functions to check if current Employee is a reviewer and/or a shiftEmployee

        function isCurrentReviewer() {

            if (vm.shift.shiftReviewers) {
                vm.shift.shiftReviewers.forEach(function (item) {
                    if (item.id === vm.employee.id) {
                        vm.isShiftReviewer = true;
                        vm.reviewer = item;
                    }
                })
            }
        }

        function isCurrentEmployee() {
            if (vm.shift.id) {
                vm.isShiftEmployee = false;
                vm.isShiftReviewer = false;
                vm.showPages = false;
                vm.shift.employees.forEach(function (item) {
                    if (item.id == vm.employee.id) {
                        vm.isShiftEmployee = true;
                        vm.showPages = false;
                    }
                })
            }
        }

        //Function to Load SIGNATURES into variables used in HTML and assign Employee

        function load() {
            if (vm.shift.shiftEmployeeSignature && !vm.shiftEmployeeSignature) {
                vm.shiftEmployeeSignature = vm.shift.shiftEmployeeSignature.signature;
                vm.shiftEmployeeSignatureAgree = true;
            }
            if (vm.shift.shiftReviewerSignature) {
                vm.shiftReviewerSignature = vm.shift.shiftReviewerSignature.signature;
            }
            if (vm.shift.shiftEmployeeSignature) {
                if (vm.shift.shiftEmployeeSignature.signature === "Ignored field" && vm.shiftEmployeeSignature) {
                    vm.shift.shiftEmployeeSignature.signature = vm.shiftEmployeeSignature;
                }
            }
            if (!vm.shift.shiftEmployee && !vm.shift.shiftEmployeeSignature && vm.isShiftEmployee && !vm.isSaving) {
                vm.shift.shiftEmployee = vm.employee;
            } else if (vm.shift.shiftEmployee && !vm.shift.shiftEmployeeSignature && vm.isShiftEmployee && vm.isSaving) {
                vm.shift.shiftEmployee = null;
            }
        }

        //FUNCTION TO SAVE SIGNATURES

        function isPinCorrect() {
            if (vm.shiftEmployeeSignaturePin && !vm.shiftReviewerSignaturePin && !vm.shiftReviewerSignature) {
                Employee.employeeIsValidPin({pin: vm.shiftEmployeeSignaturePin}, function (result) {
                    if (result.value) {
                        vm.shift.shiftEmployeeSignature = vm.employee.signature;
                        vm.savedWithSign = true;
                    } else {
                        toastr.error('The pin was Incorrect', 'Error');
                        vm.shiftEmployeeSignaturePin = false;
                    }
                }).$promise.then(function (data) {
                    onSignatureSave();
                });
            } else if (vm.shiftEmployeeSignature && !vm.shiftReviewerSignaturePin && !vm.shiftReviewerSignature) {
                Shift.sign(
                    {
                        shiftId: vm.shift.id,
                        type: "EMPLOYEE",
                        signature: vm.shiftEmployeeSignature
                    }).$promise.then(function (data) {
                    vm.shift.shiftEmployeeSignature = data.shiftEmployeeSignature;
                    vm.shiftEmployeeSignature = data.shiftEmployeeSignature.signature;
                    vm.shift.shiftEmployee = data.shiftEmployee;
                });

                vm.savedWithSign = true;
            } else if (vm.shiftReviewerSignaturePin && vm.shiftEmployeeSignature) {
                Employee.employeeIsValidPin({pin: vm.shiftReviewerSignaturePin}, function (result) {
                    if (result.value) {
                        vm.shift.shiftReviewerSignature = vm.employee.signature;
                        vm.savedWithSign = true;
                    } else {
                        toastr.error('The pin was Incorrect', 'Error');
                        vm.shiftReviewerSignaturePin = false;
                    }
                }).$promise.then(function (data) {
                    onSignatureSave();
                });
            } else if (vm.shiftReviewerSignature && vm.shiftEmployeeSignature) {
                Shift.sign(
                    {
                        shiftId: vm.shift.id,
                        type: "REVIEWER",
                        signature: vm.shiftReviewerSignature
                    }).$promise.then(function (data) {
                    vm.shift.shiftReviewerSignature = data.shiftReviewerSignature;
                    vm.shiftReviewerSignature = data.shiftReviewerSignature.signature;
                    $scope.$emit('bluebookApp:shiftUpdate', data);
                    $uibModalInstance.close(data);

                });
                vm.savedWithSign = true;
            }
        }

        function onSignatureSave() {
            if (vm.shiftEmployeeSignaturePin && !vm.shiftReviewerSignaturePin) {
                Shift.sign(
                    {
                        shiftId: vm.shift.id,
                        type: "EMPLOYEE",
                        signature: vm.employee.signature.signature
                    }).$promise.then(function (data) {
                    vm.shift.shiftEmployeeSignature = data.shiftEmployeeSignature;
                    vm.shiftEmployeeSignature = data.shiftEmployeeSignature.signature;
                    vm.shift.shiftEmployee = data.shiftEmployee;
                });
            } else if (vm.shiftReviewerSignaturePin && !vm.shiftEmployeeSignaturePin) {
                Shift.sign(
                    {
                        shiftId: vm.shift.id,
                        type: "REVIEWER",
                        signature: vm.employee.signature.signature
                    }).$promise.then(function (data) {
                    vm.shift.shiftReviewerSignature = data.shiftReviewerSignature;
                    vm.shiftReviewerSignature = data.shiftReviewerSignature.signature;
                    $scope.$emit('bluebookApp:shiftUpdate', data);
                    $uibModalInstance.close(data);

                });
            }

        }


        //FUNCTION TO CLOSE ON SAVING

        function saveClose() {
            if (vm.shift.id) {
                vm.shift.lastModifiedEmployee = vm.employee;
                Shift.update(vm.shift, onSaveSuccessClose, onSaveErrorClose);
            } else {
                vm.shift.status = 'Pending';
                vm.shift.lastModifiedEmployee = vm.employee;
                Shift.save(vm.shift, onSaveSuccessClose, onSaveErrorClose);
            }
        }

        function onSaveSuccessClose(result1) {
            $scope.$emit('bluebookApp:shiftUpdate', result1);
            $uibModalInstance.close(result1);
        }

        function onSaveErrorClose(result) {
            vm.isSaving = false;
        }


        //ALL NOTE RELATED FUNCTIONS

        function deleteNote(item) {
            if (item) {
                ShiftNote.delete(item, onUpdateSuccess, onSaveError);
                toastr.success('Note deleted', 'Success');
            }
        }

        function crudNote(item) {
            if (item) {
                vm.addPatient = false;
                vm.currentChart = [];
                vm.thisChartNotes = [];
                vm.currentChart = item;
                vm.thisChartNotes = item.shiftNotes;
                vm.visibilityToggleTable = true;
                vm.thisChartNotes.forEach(function (value) {
                    value.editVisibility = false;
                })
            }
        }

        function newNoteCreation(item) {
            vm.addPatient = false;
            if (!vm.savedWithSign) {
                if (item.addCustomNote && !item.closeCustomNote) {
                    item.addCustomNote = false;
                    item.closeCustomNote = true;
                    item.note = "";
                } else if (!item.addCustomNote && item.closeCustomNote) {
                    if (item.note) {
                        vm.convertedNote = {
                            shiftChart: null,
                            note: item.note
                        };
                        item.shiftNotes.push(vm.convertedNote);
                        ShiftChart.update(item, onUpdateSuccess, onSaveError);
                        toastr.success('Note added', 'Success');
                    }
                    item.addCustomNote = true;
                    item.closeCustomNote = false;
                }
            }
        }

        function editNote(item) {
            if (item.note) {
                item.editVisibility = true;
            }
        }

        function addNotesToPatients() {
            if (vm.customNote) {
                vm.convertedNote = {
                    shiftChart: null,
                    note: vm.customNote
                };
                vm.currentChart.shift = vm.originalEntity;
                vm.currentChart.shiftNotes.push(vm.convertedNote);
                ShiftChart.update(vm.currentChart, onUpdateSuccess, onSaveError);
                toastr.success('Note added', 'Success');
                vm.thisChartNotes = [];
                vm.customNote = "";
            }
        }

        function saveChangedNote(item) {
            item.editVisibility = false;
            vm.currentChart.shiftNotes.forEach(function (value) {
                if (value.id === item.id) {
                    value.note = item.note;
                }
            });
            vm.currentChart.shift = vm.originalEntity;
            ShiftChart.update(vm.currentChart, onUpdateSuccess, onSaveError);
            toastr.success('Note Updated', 'Success');
            vm.thisChartNotes = [];
        }

        function switchingBack() {
            vm.visibilityToggleTable = false;
            loadPatientDetails();
        }

        function closeAllNotes() {
            if (vm.shift.id) {
                if (vm.shiftChartPatients) {
                    vm.shiftChartPatients.forEach(function (value) {
                        if (value.closeCustomNote) {
                            value.closeCustomNote = false;
                            value.addCustomNote = true;
                        }
                    })
                }
            }

        }

        // ALL PATIENT RELATED FUNCTIONS

        function loadPage() {
            loadPatientDetails();
        }

        function deletePatient(item) {
            if (item) {
                vm.addPatient = false;
                vm.addedPatients = [];
                ShiftChart.delete({id: item.id}, onPatientDeleteSuccess, onSaveError);
            }
        }

        function onPatientDeleteSuccess(result) {
            toastr.success('Patient deleted from shift', 'Success');
            loadPatientDetails();
        }

        //Function to add patients to chart

        function addPatients() {
            if (vm.addedPatients.length) {
                vm.addedPatients.forEach(function (item) {
                    vm.shiftChartPatients.push(item);
                });
                vm.addPatient = !vm.addPatient;
                vm.newPatients = [];
                listCreation();
                Shift.update(vm.shift, onSaveSuccess, onSaveError);
                toastr.success('Patients added to shift', 'Success');
            }
        }

        //Load already added patients from shift chart by shift Id

        function loadPatientDetails() {
            if (vm.shift.id) {
                ShiftChart.pageableByFindAllShiftCharts({
                    id: vm.shift.id,
                    page: vm.page - 1,
                    size: vm.itemsPerPage
                }, function (result, headers) {
                    if (result) {
                        vm.totalItems = headers('X-Total-Count');
                        vm.shift.shiftCharts = result;
                        vm.loadedPatientsByShift = result;
                        if (vm.loadedPatientsByShift.length > 0) {
                            vm.loadedPatientsByShift.forEach(function (value) {
                                value.addCustomNote = true;
                                value.closeCustomNote = false;
                                if (value.shiftNotes && value.shiftNotes.length > 0) {
                                    value.shiftNotes.sort(function (a, b) {
                                        return new Date(b.createdDate) - new Date(a.createdDate);
                                    });
                                }
                            })
                        } else {
                            vm.shiftChartPatients = [];
                        }
                    }
                }).$promise.then(function (data) {
                    loadExistingShiftChartToView();
                });
            }
        }

        //Function to add shifts charts to save json
        function listCreation() {
            if (vm.shift.id) {
                vm.shift.shiftCharts = vm.shiftChartPatients;
            }
        }

        function loadExistingShiftChartToView() {
            if (vm.loadedPatientsByShift.length !== 0) {
                vm.shiftChartPatients = [];
                vm.shiftChartPatients = vm.loadedPatientsByShift;
            }
        }

        // Function to get all current patients and add to newPatients
        function patientsForm() {
            vm.addPatient = !vm.addPatient;
            vm.newPatientsConverted = [];
            vm.newPatients = [];

            Chart.notInShift({shiftId: vm.shift.id}, function (result) {
                if (result) {
                    vm.newPatients = result;
                }
                vm.newPatients.forEach(function (value) {
                    vm.patient = {
                        chart: value,
                        shift: null,
                        headCount: false
                    };
                    vm.newPatientsConverted.push(vm.patient);
                });
            })
        }

        function present(item) {
            vm.shiftChart = item;
            vm.shiftChart.shiftNotes = [];
            ShiftChart.update(vm.shiftChart, onPresentUpdateSuccess, onSaveError);
            toastr.success('Patient updated', 'Success');
        }

        function onPresentUpdateSuccess() {
            loadPatientDetails();
        }

        function onUpdateSuccess(result) {
            if (vm.currentChart) {
                ShiftChart.findOneById({id: vm.currentChart.id}, function (result1) {
                    if (result1) {
                        vm.currentChart = result1;
                        vm.thisChartNotes = vm.currentChart.shiftNotes;
                    }
                });
                vm.lastItemNo = vm.currentChart.shiftNotes.length;
            }
            loadPatientDetails();
        }

        //Function saving Reviewers

        function saveReviewers() {
            Shift.update(vm.shift, onSaveSuccess, onSaveError);
            toastr.success('Reviewers assigned', 'Success');
            vm.originalEntity = angular.copy(vm.shift);
            $scope.$emit('bluebookApp:shiftUpdate', vm.shift);
            $uibModalInstance.close(vm.shift);
        }

        function getEmployees(query) {
            var filter = {page: 0, size: 20, query: query, facilityId: CoreService.getCurrentFacility().id};

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('shift', {
                parent: 'entity',
                url: '/shift',
                data: {
                    authorities: [],
                    pageTitle: 'Shifts'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shift/list/shift.html',
                        controller: 'ShiftController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_SHIFT];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_SHIFT, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Shift', Shift);

    Shift.$inject = ['$resource', 'DateUtils'];

    function Shift ($resource, DateUtils) {
        var resourceUrl =  'api/shifts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateCreated = DateUtils.convertDateTimeFromServer(data.dateCreated);
                        data.startTime = DateUtils.convertDateTimeFromServer(data.startTime);
                        data.endTime = DateUtils.convertDateTimeFromServer(data.endTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'sign': {url: 'api/shifts/sign', method: 'PUT'},
            'findAllByFilter': {url: 'api/shifts/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftController', ShiftController);

    ShiftController.$inject = ['$state', 'Shift', 'GenericEntityDatatableService', 'GUIUtils', 'CoreService',
        '$rootScope', 'ConfirmationService', '$q', '$uibModal'];

    function ShiftController($state, Shift, GenericEntityDatatableService, GUIUtils, CoreService,
                             $rootScope, ConfirmationService, $q, $uibModal) {

        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Shifts',
            entityClassHumanized: 'Shifts',
            entityStateName: 'shift',
            service: Shift,
            serviceMethod: 'findAllByFilter',
            params: params,
            newAction: false,
            pagination: 'remote',
            newButtonTitle: 'New Shift',
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    title: 'Date Created',
                    render: function (data) {
                        return moment(data.dateCreated).format($rootScope.dateFormat);
                    }
                },
                {
                    title: 'Last Modified By',
                    render: function (data) {
                        return data ? (data.lastModifiedEmployee.firstName + " " + data.lastModifiedEmployee.lastName) : '-';
                    },
                },
                {
                    title: 'Status',
                    render: function (data) {
                        return GUIUtils.shiftStatus(data.status);
                    },
                },
                {
                    title: 'Start Time',
                    render: function (data) {
                        return data.startTime ? moment(data.startTime).format($rootScope.timeFormatA) : ' - '
                    }
                },
                {
                    title: 'End Time',
                    render: function (data) {
                        return data.endTime ? moment(data.endTime).format($rootScope.timeFormatA) : ' - '
                    }
                },
                {
                    name: 'building',
                    title: 'Building',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        return detail(data.id);
                    },
                    ngIf: function (data) {
                        return data.status === 'Finalized'
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction('shift'), {
                    ngIf: function (data) {
                        return data.status === 'Pending' || data.status === 'Review'
                    },
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('shift'), {
                    ngIf: function (data) {
                        return data.status === 'Pending' || data.status === 'Review'
                    },
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'Pending',
                            iClass: 'fa fa-thumbs-down',
                            ngClass: function (filter) {
                                return filter.status === 'Pending' ?
                                    ['active', 'label-danger'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.status = 'Pending';
                            }
                        },
                        {
                            name: 'Finalized',
                            iClass: 'fa fa-thumbs-up',
                            ngClass: function (filter) {
                                return filter.status === 'Finalized' ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.status = 'Finalized';
                            }
                        },
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Shift',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'status',
                    visible: false,
                    defaultValue: function () {
                        return 'Pending';
                    },
                    read: function (filter) {
                        if (filter.status === 'Finalized') {
                            return ['Finalized'];
                        } else {
                            return ['Pending', 'Review'];
                        }
                    }
                }
            ]
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/shift/update/shift-dialog.html',
                controller: 'ShiftDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            description: null,
                            dateCreated: null,
                            status: null,
                            startTime: null,
                            endTime: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/shift/update/shift-dialog.html',
                controller: 'ShiftDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Shift', function (Shift) {
                        return Shift.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function detail(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/shift/detail/shift-detail.html',
                controller: 'ShiftDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Shift', function (Shift) {
                        return Shift.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Shift').result.then(function () {
                    Shift.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ShiftDetailController', ShiftDetailController);

    ShiftDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity','Shift', 'Building', 'ShiftType',
        'Employee', 'ShiftChart', '$uibModalInstance'];

    function ShiftDetailController($scope, $rootScope, $stateParams, entity, Shift, Building, ShiftType,
                                   Employee, ShiftChart, $uibModalInstance) {

        var vm = this;

        vm.clear = clear;

        vm.entity = entity;
        vm.shift = entity;
        vm.totalItems = null;
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.loadPage =loadPage;

        loadShiftCharts();

        function loadShiftCharts() {
            vm.shift.shiftCharts = [];
            ShiftChart.pageableByFindAllShiftCharts({
                id: vm.shift.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (result, headers) {
                if (result) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.shift.shiftCharts = result;
                }
            }).$promise.then(function (data) {

            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel')
        }

        function loadPage() {
            loadShiftCharts();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SeverityDialogController', SeverityDialogController);

    SeverityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Severity'];

    function SeverityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Severity) {
        var vm = this;

        vm.severity = entity;
        //vm.reaction = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.severity.id !== null) {
                Severity.update(vm.severity, onSaveSuccess, onSaveError);
            } else {
                Severity.save(vm.severity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:severityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('severity', {
                parent: 'entity',
                url: '/severity',
                data: {
                    authorities: [],
                    pageTitle: 'Severities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/severity/list/severity.html',
                        controller: 'SeverityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_SEVERITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_SEVERITY, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Severity', Severity);

    Severity.$inject = ['$resource'];

    function Severity ($resource) {
        var resourceUrl =  'api/severities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': { url: 'api/severities/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SeverityController', SeverityController);

    SeverityController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Severity'];

    function SeverityController(GenericEntityDatatableService, CoreService, Severity) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Severity',
            newButtonTitle: 'New Severity',
            entityClassHumanized: 'Severity',
            entityStateName: 'severity',
            service: Severity,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'ctConceptID',
                    title: 'SNOMED-CT Concept ID',
                }
            ]
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SessionTypeDialogController', SessionTypeDialogController);

    SessionTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SessionType'];

    function SessionTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SessionType) {
        var vm = this;

        vm.sessionType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sessionType.id !== null) {
                SessionType.update(vm.sessionType, onSaveSuccess, onSaveError);
            } else {
                SessionType.save(vm.sessionType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:sessionTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('session-type', {
                parent: 'entity',
                url: '/session-type',
                data: {
                    authorities: [],
                    pageTitle: 'SessionTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/session-type/list/session-type.html',
                        controller: 'SessionTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Session Type'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_SESSION_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_SESSION_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SessionType', SessionType);

    SessionType.$inject = ['$resource'];

    function SessionType ($resource) {
        var resourceUrl =  'api/session-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/session-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SessionTypeController', SessionTypeController);

    SessionTypeController.$inject = ['GenericEntityDatatableService', 'CoreService', 'SessionType', '$q', '$uibModal',
        'ConfirmationService'];

    function SessionTypeController (GenericEntityDatatableService, CoreService, SessionType, $q, $uibModal,
                                    ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Session Type',
            newButtonTitle: 'New Session Type',
            entityClassHumanized: 'Session Type',
            entityStateName: 'session-type',
            service: SessionType,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Session Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/session-type/update/session-type-dialog.html',
                controller: 'SessionTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/session-type/update/session-type-dialog.html',
                controller: 'SessionTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['SessionType', function (SessionType) {
                        return SessionType.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Session Type').result.then(function () {
                    SessionType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SendLabCompendiumDialogController', SendLabCompendiumDialogController);

    SendLabCompendiumDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'SendLabCompendium', 'LabCompendium', 'FacilityLab'];

    function SendLabCompendiumDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                               SendLabCompendium, LabCompendium, FacilityLab) {
        var vm = this;

        vm.sendLabCompendium = entity;

        vm.labCompendiums = [];
        vm.page = 1;

        vm.clear = clear;
        vm.save = save;
        vm.getLabCompendium = getLabCompendium;
        vm.changeLaboratory = changeLaboratory;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.sendLabCompendium.id !== null) {
                SendLabCompendium.update(vm.sendLabCompendium, onSaveSuccess, onSaveError);
            } else {
                SendLabCompendium.save(vm.sendLabCompendium, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:sendLabCompendiumUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getLabCompendium(query) {
            LabCompendium.filter({
                laboratoryId: vm.sendLabCompendium.laboratory.id,
                searchQuery: query,
                page: vm.page - 1,
                size: 40,
                sort: 'code,asc',
                facilityId: vm.sendLabCompendium.facility.id
            }, function (result) {
                vm.labCompendiums = result;
            });
        }

        function changeLaboratory() {
            vm.labcompendiums = [];
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SendLabCompendium', SendLabCompendium);

    SendLabCompendium.$inject = ['$resource'];

    function SendLabCompendium ($resource) {
        var resourceUrl =  'api/send-lab-compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': { url: 'api/send-lab-compendiums/filter', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('send-lab-compendium', {
            parent: 'entity',
            url: '/send-lab-compendium',
            data: {
                authorities: [],
                pageTitle: 'SendLabCompendiums'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/send-lab-compendium/list/send-lab-compendium.html',
                    controller: 'SendLabCompendiumController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
            }]
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SendLabCompendiumController', SendLabCompendiumController);

    SendLabCompendiumController.$inject = ['SendLabCompendium', 'CoreService', '$q', 'GenericEntityDatatableService',
        'PopupService', '$uibModal', 'ConfirmationService'];

    function SendLabCompendiumController(SendLabCompendium, CoreService, $q, GenericEntityDatatableService,
                                         PopupService, $uibModal, ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Send Lab Compendiums',
            newAction: false,
            entityClassHumanized: 'Send Lab Compendiums',
            entityStateName: 'send-lab-compendium',
            service: SendLabCompendium,
            serviceMethod: 'filter',
            pagination: 'remote',
            params: params,
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'code',
                    title: 'Test Code',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('send-lab-compendium'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Send LabCompendium',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectFacilityLabPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = {id: result.labId, name: result.name};

                                        vm.laboratory = {id: result.labId, name: result.name};
                                        vm.descriptor.title = 'Send Lab Compendium - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/send-lab-compendium/update/send-lab-compendium-dialog.html',
                    controller: 'SendLabCompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                id: null,
                                facility: CoreService.getCurrentFacility(),
                                laboratory: vm.laboratory
                            };
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDeleteConfirmation('Lab Compendium').result.then(function () {
                    SendLabCompendium.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SampleController', SampleController);

    SampleController.$inject = ['$scope', '$state', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$filter', '$compile', 'GUIUtils', '$uibModal'];

    function SampleController($scope, $state, $q, DTColumnBuilder,
                              DTOptionsBuilder, $filter, $compile, GUIUtils, $uibModal) {
        var vm = this;

        vm.title = "Sample Title";
        vm.entityStateName = 'Sample Page';
        vm.dummy = [];
        vm.dtInstance = {};
        vm.selected = {};
        vm.searchQuery = "";

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.search = search;
        vm.getSelectedIds = getSelectedIds;
        vm.modal = modal;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                vm.dummy = dummy();
                defer.resolve(vm.dummy);
            } else {
                defer.resolve($filter('filter')(vm.dummy, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[0, 'desc'], [1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('id').withTitle('ID'),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Date').renderWith(function (data, type, full) {
                return data.date ? moment(data.date).format($scope.displayDateformat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Link to State').renderWith(function (data, type, full) {
                return data.link ? toStateLink(data) : '';
            }),
            DTColumnBuilder.newColumn('').withTitle('Colors').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(yesNoHtml),
            DTColumnBuilder.newColumn('').withTitle('Actions').withOption('class', 'col').withOption('width', '175px').notSortable()
                .renderWith(actionsHtml)
        ];

        function yesNoHtml(data, type, full, meta) {
            if (full.status == true) {
                return GUIUtils.getStatusTemplate('TRUE', 'danger');
            } else if (full.status == false){
                return GUIUtils.getStatusTemplate('FALSE', 'success');
            } else {
                return GUIUtils.getStatusTemplate('UNDEFINED', 'warning');
            }
        }

        function actionsHtml(data, type, full, meta) {
            return '<a class="dt-btn warning" ng-click="vm.modal(' + full.id + ')" uib-tooltip="View Details"><i class="fa fa-file-text" aria-hidden="true"></i></a>';
        }

        function toStateLink(row) {
            // return '<a ui-sref="' + "dashboard({barcode:'" + row.barcode + "'})" + '">' + row.barcode + '</a>';
            return '<a ui-sref="home">go to dashboard</a>';
        }

        function dummy() {
            return [
                {id: 1, name: 'Animal.com', status: true, date: new Date(), link: 'dashboard'},
                {id: 2, name: 'LaSombra.com', status: false, date: new Date(), link: null},
                {id: 3, name: 'PepeElGlobero.com', status: null, date: null, link: 'dashboard'},
                {id: 4, name: 'LordOfTheRing.com', status: true, date: new Date(), link: 'dashboard'}
            ]
        }

        function modal() {
            $uibModal.open({
                templateUrl: 'app/entities/sample/sample-dialog.html',
                controller: 'SampleDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function () {
                //apply
            }, function (result) {
                //cancel
            });
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function getSelectedIds() {
            var ids = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SampleDialogController', SampleDialogController);

    SampleDialogController.$inject = ['$uibModalInstance'];

    function SampleDialogController($uibModalInstance) {
        var vm = this;

        vm.title = "Sample Title Detail";

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('sample', {
                parent: 'entity',
                url: '/sample',
                data: {
                    authorities: [
                        ROLES.ROLE_ADMIN,
                        ROLES.ROLE_PROGRAM_DIRECTOR,
                        ROLES.ROLE_CASE_MANAGER,
                        ROLES.ROLE_DIRECTOR_NURSE,
                        ROLES.ROLE_REGISTER_NURSE,
                        ROLES.ROLE_LICENSE_PRACTITIONER_NURSE,
                        ROLES.ROLE_PRIMARY_THERAPIST,
                        ROLES.ROLE_OTHER_THERAPIST,
                        ROLES.ROLE_BHT,
                        ROLES.ROLE_CLINICAL_DIRECTOR,
                        ROLES.ROLE_PHYSICIAN_ASSISTANCE
                    ],
                    pageTitle: 'Sample'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sample-files/sample-table-view.html',
                        controller: 'SampleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RptMetadata', RptMetadata);

    RptMetadata.$inject = ['$resource'];

    function RptMetadata($resource) {
        var resourceUrl = 'api/rpt-metadata/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'queryDiff': {url: 'api/rpt-metadata/diff/:id', method: 'GET', isArray: true},
            'queryDiffResultLevelMessage': {url: 'api/rpt-metadata/result-level-message', method: 'GET', isArray: true},
            'getByIntCode': {
                url: 'api/rpt-metadata/by-intcode/:intCode',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RouteDialogController', RouteDialogController);

    RouteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Route'];

    function RouteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Route) {
        var vm = this;

        vm.route = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.route.id !== null) {
                Route.update(vm.route, onSaveSuccess, onSaveError);
            } else {
                Route.save(vm.route, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:routeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Route', Route);

    Route.$inject = ['$resource'];

    function Route ($resource) {
        var resourceUrl =  'api/routes/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByMedication': {method: 'GET', isArray: true, url: 'api/routes/by-medication/:id'},
            'findAllByCorporation': { url: 'api/routes/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('route', {
                parent: 'entity',
                url: '/route',
                data: {
                    authorities: [],
                    pageTitle: 'Routes'
                },
                ncyBreadcrumb: {
                    label: 'Routes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/route/list/route.html',
                        controller: 'RouteController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ROUTE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ROUTE, access);
                }]
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RouteController', RouteController);

    RouteController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Route', '$q', '$uibModal',
        'ConfirmationService'];

    function RouteController(GenericEntityDatatableService, CoreService, Route, $q, $uibModal,
                             ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Routes',
            newButtonTitle: 'New Route',
            entityClassHumanized: 'Route',
            entityStateName: 'route',
            service: Route,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Route',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/route/update/route-dialog.html',
                controller: 'RouteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/route/update/route-dialog.html',
                controller: 'RouteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Route', function (Route) {
                        return Route.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Route').result.then(function () {
                    Route.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RoomDialogController', RoomDialogController);

    RoomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Room', 'Building', 'Bed',
        'Facility', 'CoreService', 'GUIUtils'];

    function RoomDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Room, Building, Bed,
                                   Facility, CoreService, GUIUtils) {
        var vm = this;

        vm.room = entity;
        vm.clear = clear;
        vm.save = save;
        vm.buildings = Building.byFacility({id: CoreService.getCurrentFacility().id});
        vm.gender = GUIUtils.getGender();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.room.id !== null) {
                Room.update(vm.room, onSaveSuccess, onSaveError);
            } else {
                Room.save(vm.room, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:roomUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Room', Room);

    Room.$inject = ['$resource'];

    function Room ($resource) {
        var resourceUrl =  'api/rooms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byfacility': {url: 'api/rooms/by-facility/:id', method: 'GET', isArray: true},
            'byBuilding': {url: 'api/rooms/by-building/:id', method: 'GET', isArray: true},
            'update': { method:'PUT'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('room', {
                parent: 'entity',
                url: '/room',
                data: {
                    authorities: [],
                    pageTitle: 'Rooms'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/room/list/room.html',
                        controller: 'RoomController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ROOM];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ROOM, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RoomController', RoomController);

    RoomController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Room', '$uibModal', 'ConfirmationService',
        '$q'];

    function RoomController (GenericEntityDatatableService, CoreService, Room, $uibModal, ConfirmationService,
                             $q) {
        var vm = this;

        var params = CoreService.getFilterByFacility(CoreService.getCurrentFacility());

        vm.descriptor = {
            title: 'Rooms',
            newButtonTitle: 'New Room',
            entityClassHumanized: 'Room',
            entityStateName: 'room',
            service: Room,
            serviceMethod: 'byfacility',
            params: params,
            newAction: false,
            columns: [
               {
                    name: 'name',
                    title: 'Name',
               },
               {
                    name: null,
                    title: 'Building',
                    render: function(data) {
                       return data != null ? data.building.name : " ";
                    }
               },
               {
                    name: 'sex',
                    title: 'Gender',
               }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Room',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/room/update/room-dialog.html',
                controller: 'RoomDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            sex: null,
                            notes: null,
                            facility: CoreService.getCurrentFacility(),
                            id: null
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/room/update/room-dialog.html',
                controller: 'RoomDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Room', function (Room) {
                        return Room.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Room').result.then(function () {
                    Room.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RevCodeSearch', RevCodeSearch);

    RevCodeSearch.$inject = ['$resource'];

    function RevCodeSearch($resource) {
        var resourceUrl =  'api/_search/rev-codes';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, ignoreLoadingBar: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteDialogController', ReportExecuteDialogController);

    ReportExecuteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReportExecute', 'Report', 'ReportCondition'];

    function ReportExecuteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReportExecute, Report, ReportCondition) {
        var vm = this;

        vm.reportExecute = entity;
        vm.clear = clear;
        vm.save = save;
        vm.reports = Report.query();
        vm.reportconditions = ReportCondition.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reportExecute.id !== null) {
                ReportExecute.update(vm.reportExecute, onSaveSuccess, onSaveError);
            } else {
                ReportExecute.save(vm.reportExecute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:reportExecuteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteDetailController', ReportExecuteDetailController);

    ReportExecuteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReportExecute', 'Report', 'ReportCondition'];

    function ReportExecuteDetailController($scope, $rootScope, $stateParams, previousState, entity, ReportExecute, Report, ReportCondition) {
        var vm = this;

        vm.reportExecute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:reportExecuteUpdate', function(event, result) {
            vm.reportExecute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteDeleteController',ReportExecuteDeleteController);

    ReportExecuteDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReportExecute'];

    function ReportExecuteDeleteController($uibModalInstance, entity, ReportExecute) {
        var vm = this;

        vm.reportExecute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReportExecute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('report-execute', {
            parent: 'entity',
            url: '/report-execute',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ReportExecutes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report-execute/report-executes.html',
                    controller: 'ReportExecuteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('report-execute-detail', {
            parent: 'entity',
            url: '/report-execute/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ReportExecute'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/report-execute/report-execute-detail.html',
                    controller: 'ReportExecuteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReportExecute', function($stateParams, ReportExecute) {
                    return ReportExecute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'report-execute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('report-execute-detail.edit', {
            parent: 'report-execute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReportExecute', function(ReportExecute) {
                            return ReportExecute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('report-execute.new', {
            parent: 'report-execute',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                reportField: null,
                                reportCondition: null,
                                reportValue: null,
                                reportValue2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('report-execute', null, { reload: 'report-execute' });
                }, function() {
                    $state.go('report-execute');
                });
            }]
        })
        .state('report-execute.edit', {
            parent: 'report-execute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReportExecute', function(ReportExecute) {
                            return ReportExecute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('report-execute', null, { reload: 'report-execute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('report-execute.delete', {
            parent: 'report-execute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/report-execute/report-execute-delete-dialog.html',
                    controller: 'ReportExecuteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReportExecute', function(ReportExecute) {
                            return ReportExecute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('report-execute', null, { reload: 'report-execute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ReportExecute', ReportExecute);

    ReportExecute.$inject = ['$resource'];

    function ReportExecute ($resource) {
        var resourceUrl =  'api/report-executes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ReportExecuteSearch', ReportExecuteSearch);

    ReportExecuteSearch.$inject = ['$resource'];

    function ReportExecuteSearch($resource) {
        var resourceUrl =  'api/_search/report-executes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteController', ReportExecuteController);

    ReportExecuteController.$inject = ['$scope', '$state', 'ReportExecute', 'ReportExecuteSearch'];

    function ReportExecuteController ($scope, $state, ReportExecute, ReportExecuteSearch) {
        var vm = this;

        vm.reportExecutes = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ReportExecute.query(function(result) {
                vm.reportExecutes = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ReportExecuteSearch.query({query: vm.searchQuery}, function(result) {
                vm.reportExecutes = result;
            });
        }    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportEditDialogController', ReportEditDialogController);

    ReportEditDialogController.$inject = ['$uibModalInstance', 'entity', 'Report', 'CoreService', 'DateUtils',
        'GUIUtils', 'Employee', '$q'];

    function ReportEditDialogController($uibModalInstance, entity, Report, CoreService, DateUtils,
                                        GUIUtils, Employee, $q) {
        var vm = this;

        vm.report = entity
        vm.options = [];
        vm.optionsRequired = [];
        vm.form = {};
        vm.conditions = [];
        vm.reportCategories = [];
        vm.conditionValues = [];
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = {};
        vm.datePickerOpenStatus.date2 = {};
        vm.datePickerOpenStatus.datetime = {};
        vm.datePickerOpenStatus.datetime2 = {};
        vm.days = GUIUtils.getDays();
        vm.schedule = GUIUtils.weekCodeStringToDays(vm.report.schedule);
        vm.reportCategories = Report.getAllReportCategory();
        vm.columns = [
            {name: "Options", items: [], dragging: false},
            {name: "Selected", items: [], dragging: false}
        ];
        vm.requiredFields = [];
        vm.fields = [];

        vm.onDrop = onDrop;
        vm.onMoved = onMoved;
        vm.onDragStart = onDragStart;
        vm.nextToConditions = nextToConditions;
        vm.closeWizard = closeWizard;
        vm.finishedWizard = finishedWizard;
        vm.getSelectedItemsIncluding = getSelectedItemsIncluding;
        vm.initializeValuesByFieldType = initializeValuesByFieldType;
        vm.getValuesByFieldType = getValuesByFieldType;
        vm.addCondition = addCondition;
        vm.removeCondition = removeCondition;
        vm.openCalendar = openCalendar;
        vm.initDatePicker = initDatePicker;
        vm.getEmployees = getEmployees;
        vm.getReportFields = getReportFields;
        vm.searchValuesByService = searchValuesByService;
        vm.getCategoryLabel = getCategoryLabel;
        vm.filterFields = filterFields;
        vm.getFieldName = getFieldName;
        vm.getFieldId = getFieldId;

        init();

        function init() {
            if (vm.report.id) {
                vm.conditions = vm.report.reportConditions;

                vm.columns[1].items = _.map(vm.report.reportColumns, 'reportField');

                var promise1 = Report.getAllReportFieldsByCategory({category: vm.report.category.id}).$promise;
                var promise2 = Report.getAllReportFieldsRequiredByCategory({category: vm.report.category.id}).$promise;

                $q.all([promise1, promise2]).then(function (results) {
                    results[0] = _.map(results[0], function (field) {
                        field.required = false;

                        return field;
                    })

                    vm.columns[0].items = results[0];
                    vm.fields = angular.copy(results[0]);
                    vm.options = angular.copy(vm.fields);

                    vm.requiredFields = _.map(results[1], function (field) {
                        field.required = true;

                        return field;
                    })

                    vm.options = vm.options.concat(vm.requiredFields);

                    _.forEach(vm.conditions, function (condition, index) {
                        if (!filterFields(condition.reportField)) {
                            condition.reportField.required = true
                        }

                        initializeValuesByFieldType(condition, index);
                    })
                }, function (error) {
                    console.error(error);
                })
            }
        }

        function getReportFields() {
            vm.columns[0].items = [];
            vm.columns[1].items = [];
            vm.conditions = [];
            vm.requiredFields = [];
            vm.fields = [];
            vm.options = [];

            var promise1 = Report.getAllReportFieldsByCategory({category: vm.report.category.id}).$promise;
            var promise2 = Report.getAllReportFieldsRequiredByCategory({category: vm.report.category.id}).$promise;

            $q.all([promise1, promise2]).then(function (results) {
                results[0] = _.map(results[0], function (field) {
                    field.required = false;

                    return field;
                })

                vm.columns[0].items = results[0];
                vm.fields = angular.copy(results[0]);
                vm.options = angular.copy(vm.fields);

                vm.requiredFields = _.map(results[1], function (field) {
                    field.required = true;

                    return field;
                })

                vm.options = vm.options.concat(vm.requiredFields);

                _.forEach(vm.requiredFields, function (required) {
                    addCondition(required);
                })
            }, function (error) {
                console.error(error);
            })
        }

        function getSelectedItemsIncluding(list, item) {
            item.selected = true;
            return list.items.filter(function (item) {
                return item.selected;
            });
        }

        function onDragStart(list, event) {
            list.dragging = true;
            if (event.dataTransfer.setDragImage) {
                var img = new Image();
                img.src = 'content/images/copy-icon.png';
                event.dataTransfer.setDragImage(img, 0, 0);
            }
        }

        function onDrop(list, items, index) {
            angular.forEach(items, function (item) {
                item.selected = false;
            });
            list.items = list.items.slice(0, index)
                .concat(items)
                .concat(list.items.slice(index));
            return true;
        }

        function onMoved(list) {
            list.items = list.items.filter(function (item) {
                return !item.selected;
            });
        }

        function save() {
            vm.isSaving = true;

            var report = angular.copy(vm.report);

            report.reportColumns = getColumns();
            report.reportConditions = _.forEach(angular.copy(vm.conditions), function (condition) {
                condition.id = null;

                switch (condition.reportField.type) {
                    case 'VALUE':
                    case 'ENUM':
                    case 'VALUE_SEARCH': {
                        condition.reportValue = condition.reportValueObject.id;

                        break;
                    }
                    case 'DATE': {
                        condition.reportValue = condition.reportValue ? moment(condition.reportValue).format("YYYY-MM-DD") : null;
                        condition.reportValue2 = condition.reportValue2 ? moment(condition.reportValue2).format("YYYY-MM-DD") : null;
                    }
                }
            });
            report.schedule = GUIUtils.daysToWeekCodeString(vm.schedule);

            if (report.id !== null) {
                Report.update(report, onSaveSuccess, onSaveError);
            } else {
                Report.save(report, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess() {
            vm.isSaving = false;
            $uibModalInstance.close();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function nextToConditions() {
            // vm.options = _.filter(vm.columns[1].items, function (item) {
            //     return item.type !== 'NONE';
            // });

            // _.remove(vm.conditions, function (condition) {
            //     return _.findIndex(vm.options, function (option) {
            //         return condition.reportField.id === option.id;
            //     }) === -1;
            // });

            // _.forEach(vm.conditions, function (item, index) {
            //     initializeValuesByFieldType(item, index);
            // });
        }

        function getColumns() {
            var columns = [];

            _.map(vm.columns[1].items, function (item, key) {
                return columns.push({
                    reportField: item,
                    xorder: key
                });
            })

            return columns;
        }

        function addCondition(reportField, required) {
            vm.conditions.push({
                id: null,
                reportField: reportField ? reportField : null,
                reportCondition: null,
                reportValue: null,
                reportValueObject: null,
                required: required
            })
        }

        function removeCondition(index, item) {
            vm.conditions.splice(index, 1);

            if (item.reportField && item.reportField.type && (item.reportField.type === 'DATE' || item.reportField.type === 'DATETIME')) {
                vm.datePickerOpenStatus.date = {};
                vm.datePickerOpenStatus.datetime = {};

                _.forEach(vm.conditions, function (value, key) {
                    if (value.reportField.type === 'DATE' || value.reportField.type === 'DATETIME') {
                        initDatePicker(value.reportField.type.toLocaleLowerCase(), key);
                    }
                })
            }
        }

        function getValuesByFieldType(item, index) {
            item.reportValue = null;
            item.reportValue2 = null;
            item.reportValueObject = null;
            item.reportCondition = null;
            item.lock = false;

            initializeValuesByFieldType(item, index);
        }

        function initializeValuesByFieldType(item, index) {

            switch (item.reportField.type) {
                case 'VALUE': {
                    if (!vm.conditionValues[item.reportField.id]) {
                        Report.getValuesByService({
                            facilityId: CoreService.getCurrentFacility().id,
                            value: item.reportField.id
                        }, function (result) {
                            vm.conditionValues[item.reportField.id] = result;
                            var index = _.findIndex(vm.conditionValues[item.reportField.id], function (conditionValue) {
                                return item.reportValue === conditionValue.id.toString();
                            })

                            item.reportValueObject = vm.conditionValues[item.reportField.id][index];
                        })
                    }
                    break;
                }
                case 'ENUM': {
                    if (!vm.conditionValues[item.reportField.id]) {
                        Report.getValuesByEnum({
                            value: item.reportField.id
                        }, function (result) {
                            vm.conditionValues[item.reportField.id] = _.map(result, function (item) {
                                return {'id': item, 'value': item};
                            });
                            var index = _.findIndex(vm.conditionValues[item.reportField.id], function (conditionValue) {
                                return item.reportValue === conditionValue.id.toString();
                            })

                            item.reportValueObject = vm.conditionValues[item.reportField.id][index];
                        });
                    }
                    break;
                }
                case 'DATE': {
                    item.reportValue = item.reportValue ? moment(item.reportValue).toDate() : null;
                    item.reportValue2 = item.reportValue2 ? moment(item.reportValue2).toDate() : null;

                    initDatePicker(item.reportField.type.toLocaleLowerCase(), index);
                    break;
                }
                case 'DATETIME': {
                    item.reportValue = item.reportValue ? moment(item.reportValue).toDate(): null;
                    item.reportValue2 = item.reportValue2 ? moment(item.reportValue2).toDate() : null;

                    initDatePicker(item.reportField.type.toLocaleLowerCase(), index);
                    break;
                }
                case 'VALUE_SEARCH': {
                    if (vm.report.id === null) {
                        vm.conditionValues[item.reportField.id] = [];
                        vm.conditionValues[item.reportField.id][index] = [];
                    } else if (!vm.conditionValues[item.reportField.id]) {
                        Report.searchValuesByService(
                            {
                                facilityId: CoreService.getCurrentFacility().id,
                                value: item.reportField.id,
                                query: null,
                                id: Number(item.reportValue)
                            }, function (result) {
                                if (!vm.conditionValues[item.reportField.id]) {
                                    vm.conditionValues[item.reportField.id] = [];
                                }

                                vm.conditionValues[item.reportField.id][index] = result;
                                item.reportValueObject = vm.conditionValues[item.reportField.id][index][0];
                            }
                        )
                    }
                    break;
                }
            }
        }

        function finishedWizard() {
            save();
        }

        function closeWizard() {
            $uibModalInstance.dismiss();
        }

        function openCalendar(date, id) {
            vm.datePickerOpenStatus[date][id] = true;
        }

        function initDatePicker(date, index) {
            vm.datePickerOpenStatus[date][index] = false;
        }

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function searchValuesByService(item, index, query) {
            if (query.length > 3) {

                Report.searchValuesByService(
                    {
                        facilityId: CoreService.getCurrentFacility().id,
                        value: item.reportField.id,
                        query: query,
                        id: null
                    }, function (result) {
                        vm.conditionValues[item.reportField.id][index] = result;
                    }
                )
            }
        }

        function getCategoryLabel(category) {
            return category.charAt(0) + category.replaceAll('_', ' ').slice(1).toLocaleLowerCase();
        }

        function filterFields(reportField) {
            var ids = _.map(vm.requiredFields, 'id')

            return reportField && !_.includes(ids, reportField.id);
        }

        function getFieldName(index) {
            return 'reportValue' + index;
        }

        function getFieldId(index) {
            return 'field_reportValue' + index;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Report', Report);

    Report.$inject = ['$resource'];

    function Report($resource) {
        var resourceUrl = 'api/reports/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByFilter': {url: 'api/reports/filter', method: 'GET', isArray: true},
            'getAllReportCategory': {url: 'api/reports/report-categories', method: 'GET', isArray: true},
            'getAllReportFieldsByCategory': {url: 'api/reports/report-fields-by-category/:category', method: 'GET', isArray: true},
            'getAllReportFieldsRequiredByCategory': {url: 'api/reports/report-fields-required-by-category/:category', method: 'GET', isArray: true},
            'getValuesByService': {
                url: 'api/reports/report-condition-service/:facilityId/value/:value',
                method: 'GET',
                isArray: true
            },
            'searchValuesByService': {
                url: 'api/reports/report-condition-service-search/:facilityId/value/:value',
                method: 'GET',
                isArray: true
            },
            'getValuesByEnum': {url: 'api/reports/report-condition-enum/:value', method: 'GET', isArray: true},
            'getReportConditions': {url: 'api/reports/report-conditions/:reportId', method: 'GET', isArray: true}
        });
    }
})
();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('reports', {
                parent: 'entity',
                url: '/reports',
                data: {
                    authorities: [ROLES.ROLE_USER],
                    pageTitle: 'Reports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/report/list/report.html',
                        controller: 'ReportController',
                        controllerAs: 'vm'
                    }
                },
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportController', ReportController);

    ReportController.$inject = ['$q', '$uibModal', '$rootScope', 'Report', 'CoreService', 'GUIUtils', 'toastr',
        'PendingReport', 'GenericEntityDatatableService', 'ConfirmationService'];

    function ReportController($q, $uibModal, $rootScope, Report, CoreService, GUIUtils, toastr,
                              PendingReport, GenericEntityDatatableService, ConfirmationService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            employeeId: CoreService.getCurrentEmployee().id,
            sort: 'name,asc'
        };

        vm.descriptor = {
            title: 'Reports',
            newAction: false,
            entityClassHumanized: 'report',
            entityStateName: 'report',
            service: Report,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'enable',
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enable);
                    }
                },
                {
                    name: null,
                    title: "Category",
                    render: function (data) {
                        return data.category.id.charAt(0) + data.category.id.replaceAll('_', ' ').slice(1).toLocaleLowerCase();
                    }
                },
                {
                    name: null,
                    title: "Created By",
                    render: function (data) {
                        return data.employee.lastName + ', ' + data.employee.firstName;
                    }
                },
                {
                    name: null,
                    title: 'Last Activity',
                    render: function (data) {
                        return data.lastActivityDate ? moment(data.lastActivityDate).format($rootScope.amDateFormat) : '-';
                    }
                },
                {
                    name: null,
                    title: 'Only Mine',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.onlyMine);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getPlayAction(), {
                    name: 'Execute',
                    ngIf: function (data) {
                        return data.enable;
                    },
                    action: function (data) {
                        execute(data.id);
                    },
                    reload: false
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Report',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                },
            ]
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/update/report-edit-dialog.html',
                    controller: 'ReportEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                facility: CoreService.getCurrentFacility(),
                                id: null,
                                name: null,
                                enable: true,
                                onlyMine: false,
                                description: null,
                                status: 'DRAFT',
                                category: null,
                                lastActivityDate: null,
                                employee: CoreService.getCurrentEmployee(),
                                reportColumns: [],
                                reportConditions: []
                            };
                        }]
                    }
                }).result.then(function () {
                    toastr.success('Report was saved', 'Success');

                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/update/report-edit-dialog.html',
                    controller: 'ReportEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'xl',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: Report.get({id: id}).$promise
                    }
                }).result.then(function () {
                    toastr.success('Report was saved', 'Success');

                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Report').result.then(function () {
                    Report.delete({id: id}, function () {
                        toastr.success('Report was deleted', 'Success');

                        return resolve();
                    });
                })
            });
        }

        function execute(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/report/execute/report-execute-dialog.html',
                    controller: 'ReportExecuteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: Report.get({id: id}).$promise
                    }
                });
            });

            // PendingReport.save({
            //     reportId: id,
            //     facilityId: CoreService.getCurrentFacility().id
            // }, function (result) {
            //     toastr.success('Your report "' + result.report.name + '" is been generated please go to storage to download it');
            // }, function () {
            //     toastr.error("We couldn't generate the report.");
            // });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReportExecuteDialogController', ReportExecuteDialogController);

    ReportExecuteDialogController.$inject = ['$uibModalInstance', 'entity', 'Report', 'CoreService', 'DateUtils',
        'GUIUtils', 'Employee', 'ReportExecute', 'toastr'];

    function ReportExecuteDialogController($uibModalInstance, entity, Report, CoreService, DateUtils,
                                           GUIUtils, Employee, ReportExecute, toastr) {
        var vm = this;

        vm.report = entity
        vm.form = {};
        vm.conditions = [];
        vm.reportCategories = [];
        vm.conditionValues = [];
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = {};
        vm.datePickerOpenStatus.date2 = {};
        vm.datePickerOpenStatus.datetime = {};

        vm.initializeValuesByFieldType = initializeValuesByFieldType;
        vm.getValuesByFieldType = getValuesByFieldType;
        vm.openCalendar = openCalendar;
        vm.initDatePicker = initDatePicker;
        vm.getEmployees = getEmployees;
        vm.searchValuesByService = searchValuesByService;
        vm.getCategoryLabel = getCategoryLabel;
        vm.save = save;
        vm.clear = clear;
        vm.getFieldName = getFieldName;
        vm.getFieldId = getFieldId;

        init();

        function init() {
            Report.getReportConditions({reportId: vm.report.id}, function (conditions) {
                if (conditions.length === 0) {
                    var reportExecute = {
                        report: {id: vm.report.id}
                    }

                    execute(reportExecute);
                } else {
                    vm.conditions = conditions;

                    _.forEach(vm.conditions, function (item, index) {
                        initializeValuesByFieldType(item, index);
                    });
                }
            });
        }

        function save() {
            vm.isSaving = true;

            var conditions = _.map(vm.conditions, function (condition) {
                var cnd = {
                    reportField: condition.reportField.id,
                    reportCondition: condition.reportCondition,
                    reportValue: condition.reportValue,
                    reportValue2: condition.reportValue2,
                    reportConditionRef: {id: condition.id}
                }

                switch (condition.reportField.type) {
                    case 'VALUE':
                    case 'ENUM':
                    case 'VALUE_SEARCH': {
                        cnd.reportValue = condition.reportValueObject.id;

                        break;
                    }
                    case 'DATE': {
                        cnd.reportValue = condition.reportValue ? moment(condition.reportValue).format("YYYY-MM-DD") : null;
                        cnd.reportValue2 = condition.reportValue2 ? moment(condition.reportValue2).format("YYYY-MM-DD") : null;
                    }
                }

                return cnd;
            });

            var reportExecute = {
                report: {id: vm.report.id},
                reportExecute: conditions
            }

            execute(reportExecute);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;

            toastr.success('Your report "' + vm.report.name + '" is been generated please go to storage to download it');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getValuesByFieldType(item, index) {
            // item.reportValue = ''
            // item.reportCondition = null;

            initializeValuesByFieldType(item, index);
        }

        function initializeValuesByFieldType(item, index) {

            switch (item.reportField.type) {
                case 'VALUE': {
                    if (!vm.conditionValues[item.reportField.id]) {
                        Report.getValuesByService({
                            facilityId: CoreService.getCurrentFacility().id,
                            value: item.reportField.id
                        }, function (result) {
                            vm.conditionValues[item.reportField.id] = result;
                            var index = _.findIndex(vm.conditionValues[item.reportField.id], function (conditionValue) {
                                return item.reportValue === conditionValue.id.toString();
                            })

                            item.reportValueObject = vm.conditionValues[item.reportField.id][index];
                        })
                    }
                    break;
                }
                case 'ENUM': {
                    if (!vm.conditionValues[item.reportField.id]) {
                        Report.getValuesByEnum({
                            value: item.reportField.id
                        }, function (result) {
                            vm.conditionValues[item.reportField.id] = _.map(result, function (item) {
                                return {'id': item, 'value': item};
                            });
                            var index = _.findIndex(vm.conditionValues[item.reportField.id], function (conditionValue) {
                                return item.reportValue === conditionValue.id.toString();
                            })

                            item.reportValueObject = vm.conditionValues[item.reportField.id][index];
                        });
                    }
                    break;
                }
                case 'DATE': {
                    item.reportValue = item.reportValue ? moment(item.reportValue).toDate() : null;
                    item.reportValue2 = item.reportValue2 ? moment(item.reportValue2).toDate() : null;

                    initDatePicker(item.reportField.type.toLocaleLowerCase(), index);
                    break;
                }
                case 'DATETIME': {
                    item.reportValue = moment(item.reportValue).toDate();
                    item.reportValue2 = item.reportValue2 ? moment(item.reportValue2).toDate() : null;

                    initDatePicker(item.reportField.type.toLocaleLowerCase(), index);
                    break;
                }
                case 'VALUE_SEARCH': {
                    if (vm.report.id === null) {
                        vm.conditionValues[item.reportField.id] = [];
                        vm.conditionValues[item.reportField.id][index] = [];
                    } else if (!vm.conditionValues[item.reportField.id]) {
                        Report.searchValuesByService(
                            {
                                facilityId: CoreService.getCurrentFacility().id,
                                value: item.reportField.id,
                                query: null,
                                id: Number(item.reportValue)
                            }, function (result) {
                                if (!vm.conditionValues[item.reportField.id]) {
                                    vm.conditionValues[item.reportField.id] = [];
                                }

                                vm.conditionValues[item.reportField.id][index] = result;
                                item.reportValueObject = vm.conditionValues[item.reportField.id][index][0];
                            }
                        )
                    }
                    break;
                }
            }
        }

        function openCalendar(date, id) {
            vm.datePickerOpenStatus[date][id] = true;
        }

        function initDatePicker(date, index) {
            vm.datePickerOpenStatus[date][index] = false;
        }

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function searchValuesByService(item, index, query) {
            if (query.length > 3) {

                Report.searchValuesByService(
                    {
                        facilityId: CoreService.getCurrentFacility().id,
                        value: item.reportField.id,
                        query: query,
                        id: null
                    }, function (result) {
                        vm.conditionValues[item.reportField.id][index] = result;
                    }
                )
            }
        }

        function getCategoryLabel(category) {
            return category.charAt(0) + category.replaceAll('_', ' ').slice(1).toLocaleLowerCase();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFieldName(index) {
            return 'reportValue' + index;
        }

        function getFieldId(index) {
            return 'field_reportValue' + index;
        }

        function execute(reportExecute) {
            ReportExecute.save(reportExecute, onSaveSuccess, onSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RelationalDialogController', RelationalDialogController);

    RelationalDialogController.$inject = ['$scope', 'entity', 'Relational', '$uibModalInstance', '$timeout', 'CoreService'];

    function RelationalDialogController($scope, entity, Relational, $uibModalInstance, $timeout, CoreService) {
        var vm = this;

        vm.relational = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.relational.id !== null) {
                Relational.update(vm.relational, onSaveSuccess, onSaveError);
            } else {
                Relational.save(vm.relational, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:specimenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Relational', Relational);

    Relational.$inject = ['$resource'];

    function Relational ($resource) {
        var resourceUrl =  'api/relationals/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': { url: 'api/relationals/filter', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RelationalSelectDialogController', RelationalSelectDialogController);

    RelationalSelectDialogController.$inject = ['$scope', 'Relational', '$uibModalInstance', '$timeout',
        'CoreService', '$q', 'DTOptionsBuilder', 'DTColumnBuilder', 'GUIUtils',
        '$compile', 'DataTablesService', 'selectedRelationals', 'RATIONALE_TYPE'];

    function RelationalSelectDialogController($scope, Relational, $uibModalInstance, $timeout,
                                              CoreService, $q, DTOptionsBuilder, DTColumnBuilder, GUIUtils,
                                              $compile, DataTablesService, selectedRelationals, RATIONALE_TYPE) {
        var vm = this;

        vm.relationals = [];
        vm.dtInstance = {};
        vm.selected = {};

        vm.clear = clear;
        vm.save = save;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Relational.findAllByFilter(getFilterByCorporationAndType(), function (result, headers) {
                vm.relationals = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [0, 'asc'])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().renderWith(function (data, type, full, meta) {
                if (_.find(selectedRelationals, function (o) {
                    return o.id === full.id;
                })) {
                    vm.selected[full.id] = true;
                } else {
                    vm.selected[full.id] = false;
                }

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            $uibModalInstance.close(vm.getSelectedIds(vm.selected));
        }

        function getFilterByCorporationAndType() {
            var filter = {};

            filter.corporationId = CoreService.getCorporation().id;
            filter.relationalType = RATIONALE_TYPE.LABORATORY;

            return filter
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rationale', {
                parent: 'entity',
                url: '/rationale',
                data: {
                    authorities: [],
                    pageTitle: 'Rationale'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/relational/list/relational.html',
                        controller: 'RelationalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_RATIONALE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_RATIONALE, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RelationalController', RelationalController);

    RelationalController.$inject = ['GenericEntityDatatableService', 'Relational', 'CoreService', '$q', '$uibModal',
        'ConfirmationService'];

    function RelationalController(GenericEntityDatatableService, Relational, CoreService, $q, $uibModal,
                                  ConfirmationService) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Rationale',
            newButtonTitle: 'New Rationale',
            entityClassHumanized: 'Rationale',
            entityStateName: 'rationale',
            service: Relational,
            serviceMethod: 'findAllByFilter',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'relationalType',
                    title: 'Relational Type'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Rationale',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/relational/update/relational-dialog.html',
                controller: 'RelationalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/relational/update/relational-dialog.html',
                controller: 'RelationalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Relational', function (Relational) {
                        return Relational.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Rationale').result.then(function () {
                    Relational.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReconnectCareCredentialDialogController', ReconnectCareCredentialDialogController);

    ReconnectCareCredentialDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ReconnectCareCredential'];

    function ReconnectCareCredentialDialogController ($timeout, $scope, $uibModalInstance, entity, ReconnectCareCredential) {
        var vm = this;

        vm.reconnectCareCredential = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reconnectCareCredential.id !== null) {
                ReconnectCareCredential.update(vm.reconnectCareCredential, onSaveSuccess, onSaveError);
            } else {
                ReconnectCareCredential.save(vm.reconnectCareCredential, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:reconnectCareCredentialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ReconnectCareCredential', ReconnectCareCredential);

    ReconnectCareCredential.$inject = ['$resource'];

    function ReconnectCareCredential ($resource) {
        var resourceUrl =  'api/reconnect-care-credentials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFacility': {url: 'api/reconnect-care-credentials/facility/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
        .state('reconnect-care-credential', {
            parent: 'entity',
            url: '/reconnect-care-credential',
            data: {
                authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                pageTitle: 'ReconnectCareCredentials'
            },
            ncyBreadcrumb: {
                label: 'Reconnect Care Credential'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reconnect-care-credential/list/reconnect-care-credential.html',
                    controller: 'ReconnectCareCredentialController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReconnectCareCredentialController', ReconnectCareCredentialController);

    ReconnectCareCredentialController.$inject = ['GenericEntityDatatableService', 'ReconnectCareCredential',
        'CoreService', '$q', '$uibModal', 'ConfirmationService'];

    function ReconnectCareCredentialController(GenericEntityDatatableService, ReconnectCareCredential,
                                               CoreService, $q, $uibModal, ConfirmationService) {
        var vm = this;

        vm.totalItems = 0;
        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Reconnect Care Credential',
            entityClassHumanized: 'Reconnect Care Credential',
            entityStateName: 'reconnect-care-credential',
            service: ReconnectCareCredential,
            serviceMethod: 'getAllByFacility',
            newAction: false,
            params: params,
            columns: [
                {
                    name: 'username',
                    title: 'Username'
                },
                {
                    name: 'password',
                    title: 'Password'
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Reconnect Care Credential',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0
                            }
                        }),
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/reconnect-care-credential/update/reconnect-care-credential-dialog.html',
                    controller: 'ReconnectCareCredentialDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                id: null,
                                clientId: null,
                                clientSecret: null,
                                username: null,
                                password: null,
                                facility: CoreService.getCurrentFacility()
                            };
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/reconnect-care-credential/update/reconnect-care-credential-dialog.html',
                    controller: 'ReconnectCareCredentialDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['ReconnectCareCredential', function (ReconnectCareCredential) {
                            return ReconnectCareCredential.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('ReconnectCare Credential').result.then(function () {
                    ReconnectCareCredential.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReactionDialogController', ReactionDialogController);

    ReactionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Reaction'];

    function ReactionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Reaction) {
        var vm = this;

        vm.reaction = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reaction.id !== null) {
                Reaction.update(vm.reaction, onSaveSuccess, onSaveError);
            } else {
                Reaction.save(vm.reaction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:reactionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Reaction', Reaction);

    Reaction.$inject = ['$resource'];

    function Reaction ($resource) {
        var resourceUrl =  'api/reactions/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/reactions/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reaction', {
                parent: 'entity',
                url: '/reaction',
                data: {
                    authorities: [],
                    pageTitle: 'Reactions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reaction/list/reaction.html',
                        controller: 'ReactionController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Reactions'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_REACTION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_REACTION, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReactionController', ReactionController);

    ReactionController.$inject = ['GenericEntityDatatableService', 'Reaction', 'CoreService', '$q', '$uibModal',
        'ConfirmationService'];

    function ReactionController(GenericEntityDatatableService, Reaction, CoreService, $q, $uibModal,
                                ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Reaction',
            newButtonTitle: 'New Reaction',
            entityClassHumanized: 'Reaction',
            entityStateName: 'reaction',
            service: Reaction,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Reaction',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/reaction/update/reaction-dialog.html',
                controller: 'ReactionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/reaction/update/reaction-dialog.html',
                controller: 'ReactionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Reaction', function (Reaction) {
                        return Reaction.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Reaction').result.then(function () {
                    Reaction.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSsoUrlLogDetailController', RcopiaSsoUrlLogDetailController);

    RcopiaSsoUrlLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', '$uibModalInstance'];

    function RcopiaSsoUrlLogDetailController($scope, $rootScope, $stateParams, entity, $uibModalInstance) {
        var vm = this;

        vm.entity = entity;

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaSsoUrlLog', RcopiaSsoUrlLog);

    RcopiaSsoUrlLog.$inject = ['$resource', 'DataUtils'];

    function RcopiaSsoUrlLog ($resource, DataUtils) {
        var resourceUrl =  'api/rcopia-sso-url-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/rcopia-sso-url-logs/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'url': {
                url: 'api/rcopia-sso-url-logs/url/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'urlStr': {
                url: 'api/rcopia-sso-url-logs/url/str/:id',
                method: 'GET',
                transformResponse: function (data) {
                    return {data: data};
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-sso-url-log', {
                parent: 'entity',
                url: '/rcopia-sso-url-log',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaSsoUrlLogs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-sso-url-log/list/rcopia-sso-url-logs.html',
                        controller: 'RcopiaSsoUrlLogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSsoUrlLogController', RcopiaSsoUrlLogController);

    RcopiaSsoUrlLogController.$inject = ['$scope', '$state', 'RcopiaSsoUrlLog', 'CoreService', '$uibModal', 'Chart',
        'GenericEntityDatatableService', '$rootScope', 'Corporation', 'GUIUtils'];

    function RcopiaSsoUrlLogController($scope, $state, RcopiaSsoUrlLog, CoreService, $uibModal, Chart,
                                       GenericEntityDatatableService, $rootScope, Corporation, GUIUtils) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id,
        }

        vm.descriptor = {
            title: 'Rcopia SSO Url Logs',
            entityClassHumanized: 'Rcopia SSO Url Logs',
            entityStateName: 'rcopia-sso-url-log',
            service: RcopiaSsoUrlLog,
            serviceMethod: 'query',
            params: params,
            pagination: 'remote',
            newAction: false,
            // options: [
            //     {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            // ],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'limpMode',
                    title: 'Limp Mode',
                    render: function (entity) {
                        return GUIUtils.colorHtmlYesNo(entity.limpMode);
                    }
                },
                {
                    name: 'employee',
                    title: 'Employee',
                    render: function(data) {
                        return data.employee.lastName + ', ' + data.employee.firstName;
                    }
                },
                {
                    name: 'chartId',
                    title: 'Chart',
                    render: function (entity) {
                        return entity.chart ?
                            entity.chart.firstName + " " +
                            (entity.chart.middleName ? entity.chart.middleName + ' ' : '') +
                            entity.chart.lastName : ""
                    }
                },
                {
                    name: 'mrno',
                    title: 'MrNo',
                    render: function (entity) {
                        return entity.chart ? entity.chart.mrNo : ""
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
                {
                    name: 'createdDate',
                    title: 'Date',
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.amDateFormat) : '-';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    name: 'View Url',
                    action: function (data) {
                        return viewUrl(data.id);
                    }
                }),
                {
                    name: 'Download Url',
                    action: function (data) {
                        RcopiaSsoUrlLog.url({id: data.id})
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-file-text-o'
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'rcopiaId',
                    placeholder: 'RcopiaID...',
                    type: 'string',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'start',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.start ? moment(filter.start).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
                {
                    name: 'end',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.end ? moment(filter.end).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
                {
                    name: 'corporationId',
                    read: function (filter) {
                        return filter.corporationId ? filter.corporationId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        Corporation.query(function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    defaultValue: function () {
                        return CoreService.getCorporation();
                    },
                    placeholder: 'Corporation ...',
                    type: 'select',
                },
            ]
        }

        function viewUrl(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-sso-url-log/url/rcopia-sso-url-log-detail.html',
                controller: 'RcopiaSsoUrlLogDetailController',
                controllerAs: 'vm',
                backdrop: true,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaSsoUrlLog', function (RcopiaSsoUrlLog) {
                        return RcopiaSsoUrlLog.urlStr({id: id}).$promise;
                    }]
                }
            }).result;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaSsoLog', RcopiaSsoLog);

    RcopiaSsoLog.$inject = ['$resource', 'DataUtils'];

    function RcopiaSsoLog ($resource, DataUtils) {
        var resourceUrl =  'api/rcopia-sso-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/rcopia-sso-logs/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'payload': {
                url: 'api/rcopia-sso-logs/payload/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'payloadStr': {
                url: 'api/rcopia-sso-logs/payload/str/:id',
                method: 'GET',
                transformResponse: function (data) {
                    return {data: data};
                }
            },
            'response': {
                url: 'api/rcopia-sso-logs/response/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'responseStr': {
                url: 'api/rcopia-sso-logs/response/str/:id',
                method: 'GET',
                transformResponse: function (data) {
                    return {data: data};
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-sso-log', {
                parent: 'entity',
                url: '/rcopia-sso-log',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaSsoLogs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-sso-log/list/rcopia-sso-logs.html',
                        controller: 'RcopiaSsoLogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('rcopia-sso-log-detail', {
                parent: 'entity',
                url: '/rcopia-sso-log/{id}',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaSsoLog'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html',
                        controller: 'RcopiaSsoLogDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'RcopiaSsoLog', function ($stateParams, RcopiaSsoLog) {
                        return RcopiaSsoLog.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'rcopia-sso-log',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSsoLogController', RcopiaSsoLogController);

    RcopiaSsoLogController.$inject = ['$scope', '$state', 'RcopiaSsoLog', 'CoreService', 'Chart', 'Corporation',
        'GenericEntityDatatableService', '$rootScope', 'GUIUtils', '$uibModal'];

    function RcopiaSsoLogController($scope, $state, RcopiaSsoLog, CoreService, Chart, Corporation,
                                    GenericEntityDatatableService, $rootScope, GUIUtils, $uibModal) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id,
        }

        vm.descriptor = {
            title: 'Rcopia SSO Logs',
            entityClassHumanized: 'Rcopia SSO Logs',
            entityStateName: 'rcopia-sso-log',
            service: RcopiaSsoLog,
            serviceMethod: 'query',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'api',
                    title: 'API',
                },
                {
                    title: 'Payload',
                    name: 'payload',
                    render: function (data) {
                        if (data.payload) {
                            return data.payloadSize ? CoreService.bytesToSize(data.payloadSize) : "";
                        } else {
                            return GUIUtils.getStatusTemplate("No", 'danger');
                        }
                    }
                },
                {
                    title: 'Response',
                    name: 'response',
                    render: function (data) {
                        if (data.response) {
                            return data.responseSize ? CoreService.bytesToSize(data.responseSize) : "";
                        } else {
                            return GUIUtils.getStatusTemplate("No", 'danger');
                        }
                    }
                },
                {
                    name: 'responseStatus',
                    title: 'Response Status',
                    render: function (data) {
                        if (data.responseStatus) {
                            if (data.responseStatus == 'error') {
                                return GUIUtils.getStatusTemplate(data.responseStatus, 'danger');
                            } else {
                                return GUIUtils.getStatusTemplate(data.responseStatus, 'success');
                            }
                        } else {
                            return "";
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        if (data.status == 'error') {
                            return GUIUtils.getStatusTemplate(data.status, 'danger');
                        } else {
                            return GUIUtils.getStatusTemplate(data.status, 'success');
                        }
                    }
                },
                {
                    name: 'number',
                    title: 'Number',
                },
                {
                    name: 'entityError',
                    title: 'Errors',
                },
                {
                    name: 'message',
                    title: 'Message',
                },
                {
                    name: 'chartId',
                    title: 'Chart',
                    render: function (entity) {
                        return entity.chart ?
                            entity.chart.firstName + " " +
                            (entity.chart.middleName ? entity.chart.middleName + ' ' : '') +
                            entity.chart.lastName : ""
                    }
                },
                {
                    name: 'mrno',
                    title: 'MrNo',
                    render: function (entity) {
                        return entity.chart ? entity.chart.mrNo : ""
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
                {
                    name: 'createdDate',
                    title: 'Date',
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.amDateFormat) : '-';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    name: 'View Payload',
                    action: function (data) {
                        return viewXmlPayload(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    name: 'View Response',
                    action: function (data) {
                        return viewXmlResponse(data.id);
                    }
                }),
                {
                    name: 'Download Payload',
                    action: function (data) {
                        RcopiaSsoLog.payload({id: data.id})
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-file-text-o',
                    ngIf: function (data) {
                        return data.payload;
                    }
                },
                {
                    name: 'Download Response',
                    action: function (data) {
                        RcopiaSsoLog.response({id: data.id});
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-file-text-o',
                    ngIf: function (data) {
                        return data.responseSize;
                    }
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'api',
                    placeholder: 'API...',
                    type: 'select',
                    values: [
                        'update_allergy',
                        'update_allergy_group',
                        'update_patient',
                        'update_medication',
                        'update_notification',
                        'get_notification_count',
                        'update_prescription',
                        'update_rxchange',
                        'update_prescription_events',
                        'update_rxfill',

                        'send_patient',
                        'send_problem',
                        'send_allergy'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'number',
                    placeholder: 'Number...',
                    type: 'number'
                },
                {
                    name: 'responseStatus',
                    placeholder: 'Response Status...',
                    type: 'select',
                    values: [
                        'ok', 'error'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: [
                        'ok', 'error'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'rcopiaId',
                    placeholder: 'RcopiaID...',
                    type: 'string',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'start',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.start ? moment(filter.start).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
                {
                    name: 'end',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.end ? moment(filter.end).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
                {
                    name: 'corporationId',
                    read: function (filter) {
                        return filter.corporationId ? filter.corporationId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        Corporation.query(function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    defaultValue: function () {
                        return CoreService.getCorporation();
                    },
                    placeholder: 'Corporation ...',
                    type: 'select',
                },
            ]
        }

        function viewXmlPayload(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html',
                controller: 'RcopiaSsoLogDetailController',
                controllerAs: 'vm',
                backdrop: true,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaSsoLog', function (RcopiaSsoLog) {
                        return RcopiaSsoLog.payloadStr({id: id}).$promise;
                    }],
                    data: {
                        title: "View Payload"
                    }
                }
            }).result;
        }

        function viewXmlResponse(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html',
                controller: 'RcopiaSsoLogDetailController',
                controllerAs: 'vm',
                backdrop: true,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaSsoLog', function (RcopiaSsoLog) {
                        return RcopiaSsoLog.responseStr({id: id}).$promise;
                    }],
                    data: {
                        title: "View Response"
                    }
                }
            }).result;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSsoLogDetailController', RcopiaSsoLogDetailController);

    RcopiaSsoLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', '$uibModalInstance',
        'data'];

    function RcopiaSsoLogDetailController($scope, $rootScope, $stateParams, entity, $uibModalInstance,
                                          data) {
        var vm = this;
        vm.data = data;

        vm.clear = clear;

        init();

        function init() {
            vm.beautifiedXmlText = new XmlBeautify().beautify(entity.data,
                {
                    indent: "",  //indent pattern like white spaces
                    useSelfClosingElement: true //true:use self-closing element when empty element.
                });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSsoLogChartController', RcopiaSsoLogChartController);

    RcopiaSsoLogChartController.$inject = ['$scope', '$state', 'RcopiaSsoLog', 'CoreService', 'Chart', 'Corporation',
        'GenericEntityDatatableService', '$rootScope', 'GUIUtils', '$uibModal', 'chart'];

    function RcopiaSsoLogChartController($scope, $state, RcopiaSsoLog, CoreService, Chart, Corporation,
                                    GenericEntityDatatableService, $rootScope, GUIUtils, $uibModal, chart) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id,
            chartId: chart.id
        }

        vm.descriptor = {
            entityClassHumanized: 'Rcopia SSO Logs',
            entityStateName: 'rcopia-sso-log',
            service: RcopiaSsoLog,
            serviceMethod: 'query',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'api',
                    title: 'API',
                },
                {
                    title: 'Payload',
                    name: 'payload',
                    render: function (data) {
                        if (data.payload) {
                            return data.payloadSize ? CoreService.bytesToSize(data.payloadSize) : "";
                        } else {
                            return GUIUtils.getStatusTemplate("No", 'danger');
                        }
                    }
                },
                {
                    title: 'Response',
                    name: 'response',
                    render: function (data) {
                        if (data.response) {
                            return data.responseSize ? CoreService.bytesToSize(data.responseSize) : "";
                        } else {
                            return GUIUtils.getStatusTemplate("No", 'danger');
                        }
                    }
                },
                {
                    name: 'responseStatus',
                    title: 'Response Status',
                    render: function (data) {
                        if (data.responseStatus) {
                            if (data.responseStatus == 'error') {
                                return GUIUtils.getStatusTemplate(data.responseStatus, 'danger');
                            } else {
                                return GUIUtils.getStatusTemplate(data.responseStatus, 'success');
                            }
                        } else {
                            return "";
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        if (data.status == 'error') {
                            return GUIUtils.getStatusTemplate(data.status, 'danger');
                        } else {
                            return GUIUtils.getStatusTemplate(data.status, 'success');
                        }
                    }
                },
                {
                    name: 'number',
                    title: 'Number',
                },
                {
                    name: 'entityError',
                    title: 'Errors',
                },
                {
                    name: 'message',
                    title: 'Message',
                },
                {
                    name: 'chartId',
                    title: 'Chart',
                    render: function (entity) {
                        return entity.chart ?
                            entity.chart.firstName + " " +
                            (entity.chart.middleName ? entity.chart.middleName + ' ' : '') +
                            entity.chart.lastName : ""
                    }
                },
                {
                    name: 'mrno',
                    title: 'MrNo',
                    render: function (entity) {
                        return entity.chart ? entity.chart.mrNo : ""
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
                {
                    name: 'createdDate',
                    title: 'Date',
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.amDateFormat) : '-';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    name: 'View Payload',
                    action: function (data) {
                        return viewXmlPayload(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    name: 'View Response',
                    action: function (data) {
                        return viewXmlResponse(data.id);
                    }
                }),
                {
                    name: 'Download Payload',
                    action: function (data) {
                        RcopiaSsoLog.payload({id: data.id})
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-file-text-o',
                    ngIf: function (data) {
                        return data.payload;
                    }
                },
                {
                    name: 'Download Response',
                    action: function (data) {
                        RcopiaSsoLog.response({id: data.id});
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-file-text-o',
                    ngIf: function (data) {
                        return data.responseSize;
                    }
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'api',
                    placeholder: 'API...',
                    type: 'select',
                    values: [
                        'update_allergy',
                        'update_allergy_group',
                        'update_patient',
                        'update_medication',
                        'update_notification',
                        'get_notification_count',
                        'update_prescription',
                        'update_rxchange',
                        'update_prescription_events',
                        'update_rxfill',

                        'send_patient',
                        'send_problem',
                        'send_allergy'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'number',
                    placeholder: 'Number...',
                    type: 'number'
                },
                {
                    name: 'responseStatus',
                    placeholder: 'Response Status...',
                    type: 'select',
                    values: [
                        'ok', 'error'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: [
                        'ok', 'error'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'rcopiaId',
                    placeholder: 'RcopiaID...',
                    type: 'string',
                },
                {
                    name: 'start',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.start ? moment(filter.start).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
                {
                    name: 'end',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.end ? moment(filter.end).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                }
            ]
        }

        function viewXmlPayload(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html',
                controller: 'RcopiaSsoLogDetailController',
                controllerAs: 'vm',
                backdrop: true,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaSsoLog', function (RcopiaSsoLog) {
                        return RcopiaSsoLog.payloadStr({id: id}).$promise;
                    }],
                    data: {
                        title: "View Payload"
                    }
                }
            }).result;
        }

        function viewXmlResponse(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html',
                controller: 'RcopiaSsoLogDetailController',
                controllerAs: 'vm',
                backdrop: true,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaSsoLog', function (RcopiaSsoLog) {
                        return RcopiaSsoLog.responseStr({id: id}).$promise;
                    }],
                    data: {
                        title: "View Response"
                    }
                }
            }).result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedDialogController', RcopiaSnomedDialogController);

    RcopiaSnomedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RcopiaSnomed'];

    function RcopiaSnomedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RcopiaSnomed) {
        var vm = this;

        vm.rcopiaSnomed = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaSnomed.id !== null) {
                RcopiaSnomed.update(vm.rcopiaSnomed, onSaveSuccess, onSaveError);
            } else {
                RcopiaSnomed.save(vm.rcopiaSnomed, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaSnomedUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedDetailController', RcopiaSnomedDetailController);

    RcopiaSnomedDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RcopiaSnomed'];

    function RcopiaSnomedDetailController($scope, $rootScope, $stateParams, previousState, entity, RcopiaSnomed) {
        var vm = this;

        vm.rcopiaSnomed = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:rcopiaSnomedUpdate', function(event, result) {
            vm.rcopiaSnomed = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedDeleteController',RcopiaSnomedDeleteController);

    RcopiaSnomedDeleteController.$inject = ['$uibModalInstance', 'entity', 'RcopiaSnomed'];

    function RcopiaSnomedDeleteController($uibModalInstance, entity, RcopiaSnomed) {
        var vm = this;

        vm.rcopiaSnomed = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RcopiaSnomed.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rcopia-snomed', {
            parent: 'entity',
            url: '/rcopia-snomed',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaSnomeds'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomeds.html',
                    controller: 'RcopiaSnomedController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rcopia-snomed-detail', {
            parent: 'entity',
            url: '/rcopia-snomed/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaSnomed'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-detail.html',
                    controller: 'RcopiaSnomedDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RcopiaSnomed', function($stateParams, RcopiaSnomed) {
                    return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rcopia-snomed',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rcopia-snomed-detail.edit', {
            parent: 'rcopia-snomed-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-dialog.html',
                    controller: 'RcopiaSnomedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaSnomed', function(RcopiaSnomed) {
                            return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-snomed.new', {
            parent: 'rcopia-snomed',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-dialog.html',
                    controller: 'RcopiaSnomedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                ctConceptID: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rcopia-snomed', null, { reload: 'rcopia-snomed' });
                }, function() {
                    $state.go('rcopia-snomed');
                });
            }]
        })
        .state('rcopia-snomed.edit', {
            parent: 'rcopia-snomed',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-dialog.html',
                    controller: 'RcopiaSnomedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaSnomed', function(RcopiaSnomed) {
                            return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-snomed', null, { reload: 'rcopia-snomed' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-snomed.delete', {
            parent: 'rcopia-snomed',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-snomed/rcopia-snomed-delete-dialog.html',
                    controller: 'RcopiaSnomedDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RcopiaSnomed', function(RcopiaSnomed) {
                            return RcopiaSnomed.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-snomed', null, { reload: 'rcopia-snomed' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaSnomed', RcopiaSnomed);

    RcopiaSnomed.$inject = ['$resource'];

    function RcopiaSnomed ($resource) {
        var resourceUrl =  'api/rcopia-snomeds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RcopiaSnomedSearch', RcopiaSnomedSearch);

    RcopiaSnomedSearch.$inject = ['$resource'];

    function RcopiaSnomedSearch($resource) {
        var resourceUrl =  'api/_search/rcopia-snomeds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaSnomedController', RcopiaSnomedController);

    RcopiaSnomedController.$inject = ['$scope', '$state', 'RcopiaSnomed', 'RcopiaSnomedSearch'];

    function RcopiaSnomedController ($scope, $state, RcopiaSnomed, RcopiaSnomedSearch) {
        var vm = this;

        vm.rcopiaSnomeds = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            RcopiaSnomed.query(function(result) {
                vm.rcopiaSnomeds = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RcopiaSnomedSearch.query({query: vm.searchQuery}, function(result) {
                vm.rcopiaSnomeds = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaPrescription', RcopiaPrescription);

    RcopiaPrescription.$inject = ['$resource'];

    function RcopiaPrescription ($resource) {
        var resourceUrl =  'api/rcopia-prescriptions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/rcopia-prescriptions/filter', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        // _.forEach(data, function (pm) {
                        //     if (pm.startDate) {
                        //         pm.startDate = new Date(DateUtils.convertDateTimeFromServer(pm.startDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.endDate) {
                        //         pm.endDate = new Date(DateUtils.convertDateTimeFromServer(pm.endDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.createdDate) {
                        //         pm.createdDate = new Date(DateUtils.convertDateTimeFromServer(pm.createdDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.discontinueDate) {
                        //         pm.discontinueDate = new Date(DateUtils.convertDateTimeFromServer(pm.discontinueDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.signedDate) {
                        //         pm.signedDate = new Date(DateUtils.convertDateTimeFromServer(pm.signedDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.faxedToCreatedDate) {
                        //         pm.faxedToCreatedDate = new Date(DateUtils.convertDateTimeFromServer(pm.faxedToCreatedDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        // });
                    }

                    return data;
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaPrescriptionController', RcopiaPrescriptionController);

    RcopiaPrescriptionController.$inject = ['$scope', '$state', 'RcopiaPrescription', 'Auth', 'ACTIONS', 'access',
        'TAB', 'params', 'chart', 'ParseLinks', '$rootScope', 'DataTablesService', 'AlertService',
        'RcopiaUtils', '$uibModal', '$uibModalStack', 'RcopiaApi', 'PendingPdfChartReport',
        'REPORT_TYPE', 'toastr'];

    function RcopiaPrescriptionController($scope, $state, RcopiaPrescription, Auth, ACTIONS, access,
                                          TAB, params, chart, ParseLinks, $rootScope, DataTablesService, AlertService,
                                          RcopiaUtils, $uibModal, $uibModalStack, RcopiaApi, PendingPdfChartReport,
                                          REPORT_TYPE, toastr
    ) {
        var vm = this;

        vm.chart = chart;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.patientMedications = [];
        vm.rcopiaMedications = [];
        vm.selected = {};
        vm.selectAll = false;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.RCOPIA_PRESCRIPTION);
        vm.access = access;
        vm.lastTab = null;
        vm.filter = {
            status: 'PENDING'
        }

        vm.transition = transition;
        vm.search = search;
        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.getDaysSupply = getDaysSupply;
        vm.dirToPharmacy = dirToPharmacy;
        vm.doNotFillBefore = doNotFillBefore;
        vm.view = view;
        vm.history = history;
        vm.loadAll = loadAll;
        vm.launchRcopia = launchRcopia;
        vm.print = print;

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_MEDICATION_VIEW, access) || !vm.active) {
                return;
            }

            RcopiaPrescription.findAllByFilter({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                status: vm.filter.status
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientMedications = data;

                // initSelected();
            }

            function onError(error) {
                AlertService.error(error.data);
            }
        }

        function reload() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }

        function search() {
            vm.page = 1;
            transition();
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result === TAB.RCOPIA_PRESCRIPTION) {
                vm.active = true;
                loadAll();
            } else if (vm.lastTab != null && result === TAB.RCOPIA_PRESCRIPTION && vm.lastTab !== TAB.RCOPIA_PRESCRIPTION) {
                loadAll();
            }

            vm.lastTab = result;
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:RcopiaUpdatePatient', function (event, result) {
            reload();
        });

        $scope.$on('$destroy', unsubscribe);

        function getDirections(rcopiaPrescription) {
            return RcopiaUtils.getDirections(rcopiaPrescription, true);
        }

        function getQuantity(rcopiaPrescription) {
            return RcopiaUtils.getQuantity(rcopiaPrescription, true);
        }

        function getRefills(rcopiaPrescription) {
            return RcopiaUtils.getRefills(rcopiaPrescription, true);
        }

        function getDaysSupply(rcopiaPrescription) {
            return RcopiaUtils.getDaysSupply(rcopiaPrescription);
        }

        function dirToPharmacy(rcopiaPrescription) {
            return RcopiaUtils.dirToPharmacy(rcopiaPrescription);
        }

        function doNotFillBefore(rcopiaPrescription) {
            return RcopiaUtils.doNotFillBefore(rcopiaPrescription);
        }

        function view(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-prescription/detail/rcopia-prescription-detail.html',
                controller: 'RcopiaPrescriptionDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    rcopiaPrescription: ['RcopiaPrescription', function (RcopiaPrescription) {
                        return RcopiaPrescription.get({id: id}).$promise;
                    }],
                    signAuthorities: ['BusinessCredential', 'BUSINESS_ROLES', 'CoreService', function (BusinessCredential, BUSINESS_ROLES, CoreService) {
                        return BusinessCredential.getCredentialByRole({
                            businessRole: BUSINESS_ROLES.PHYSICIAN, id: CoreService.getCurrentFacility().id
                        }).$promise;
                    }],
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: vm.chart.id}).$promise;
                    }],
                }
            });
        }

        function history() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/rcopia-prescription/history/rcopia-prescription-history.html',
                controller: 'RcopiaPrescriptionHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom-table-fix',
                animation: false,
                size: 'xl',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function launchRcopia() {
            RcopiaUtils.launchRcopiaPopup(
                'manage_medications',
                'patientMode',
                vm.chart.id
            ).result.then(function () {
                RcopiaApi.executeByChart({
                    api: 'updatePrescription',
                    chartId: vm.chart.id
                }, function (result) {
                    $rootScope.$broadcast("bluebookApp:RcopiaUpdatePatient");
                })
            })
        }

        function print(id) {
            PendingPdfChartReport.save({
                chart: {id: vm.chart.id},
                objectId: id,
                name: "" + id,
                reportType: REPORT_TYPE.RCOPIA_PRESCRIPTION
            }, onPrintSuccess, onPrintError);
        }

        function onPrintSuccess(result) {
            toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
        }

        function onPrintError() {
            toastr.error("We couldn't generate the report.");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaPrescriptionHistoryController', RcopiaPrescriptionHistoryController);

    RcopiaPrescriptionHistoryController.$inject = ['RcopiaPrescription', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', '$uibModalInstance', '$timeout', 'ParseLinks',
        'PopupService', '$uibModalStack', 'RcopiaUtils'];

    function RcopiaPrescriptionHistoryController(RcopiaPrescription, DTOptionsBuilder, DTColumnBuilder,
                                                 DataTablesService, chart, $uibModalInstance, $timeout, ParseLinks,
                                                 PopupService, $uibModalStack, RcopiaUtils) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.patientMedications = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.getDaysSupply = getDaysSupply;
        vm.dirToPharmacy = dirToPharmacy;
        vm.doNotFillBefore = doNotFillBefore;

        loadAll();

        function loadAll() {
            RcopiaPrescription.findAllByFilter({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                pending: false
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientMedications = data;
            }

            function onError(error) {
                AlertService.error(error.data);
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }

        function getDirections(rcopiaPrescription) {
            return RcopiaUtils.getDirections(rcopiaPrescription, true);
        }

        function getQuantity(rcopiaPrescription) {
            return RcopiaUtils.getQuantity(rcopiaPrescription, true);
        }

        function getRefills(rcopiaPrescription) {
            return RcopiaUtils.getRefills(rcopiaPrescription, true);
        }

        function getDaysSupply(rcopiaPrescription) {
            return RcopiaUtils.getDaysSupply(rcopiaPrescription);
        }

        function dirToPharmacy(rcopiaPrescription) {
            return RcopiaUtils.dirToPharmacy(rcopiaPrescription);
        }

        function doNotFillBefore(rcopiaPrescription) {
            return RcopiaUtils.doNotFillBefore(rcopiaPrescription);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaPrescriptionDetailController', RcopiaPrescriptionDetailController);

    RcopiaPrescriptionDetailController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'Via', 'CoreService',
        'Route', 'rcopiaPrescription', 'PatientMedication', 'signAuthorities',
        'Allergies', 'RcopiaUtils', 'chart'];

    function RcopiaPrescriptionDetailController($timeout, $scope, $uibModalInstance, Via, CoreService,
                                                Route, rcopiaPrescription, PatientMedication, signAuthorities,
                                                Allergies, RcopiaUtils, chart) {
        var vm = this;

        vm.rcopiaPrescription = rcopiaPrescription;
        vm.chart = chart;

        vm.allergiesStr = "";
        vm.rationaleStr = "";

        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.getDaysSupply = getDaysSupply;
        vm.dirToPharmacy = dirToPharmacy;
        vm.doNotFillBefore = doNotFillBefore;

        init();

        function init() {
        }

        vm.clear = clear;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getDirections(rcopiaPrescription) {
            return RcopiaUtils.getDirections(rcopiaPrescription);
        }

        function getQuantity(rcopiaPrescription) {
            return RcopiaUtils.getQuantity(rcopiaPrescription);
        }

        function getRefills(rcopiaPrescription) {
            return RcopiaUtils.getRefills(rcopiaPrescription);
        }

        function getDaysSupply(rcopiaPrescription) {
            return RcopiaUtils.getDaysSupply(rcopiaPrescription);
        }

        function dirToPharmacy(rcopiaPrescription) {
            return RcopiaUtils.dirToPharmacy(rcopiaPrescription);
        }

        function doNotFillBefore(rcopiaPrescription) {
            return RcopiaUtils.doNotFillBefore(rcopiaPrescription);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaPracticeInfoDialogController', RcopiaPracticeInfoDialogController);

    RcopiaPracticeInfoDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'RcopiaPracticeInfo'];

    function RcopiaPracticeInfoDialogController ($timeout, $scope, $uibModalInstance, entity, RcopiaPracticeInfo) {
        var vm = this;

        vm.rcopiaPracticeInfo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaPracticeInfo.id !== null) {
                RcopiaPracticeInfo.update(vm.rcopiaPracticeInfo, onSaveSuccess, onSaveError);
            } else {
                RcopiaPracticeInfo.save(vm.rcopiaPracticeInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:RcopiaPracticeInfosUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaPracticeInfo', RcopiaPracticeInfo);

    RcopiaPracticeInfo.$inject = ['$resource'];

    function RcopiaPracticeInfo ($resource) {
        var resourceUrl =  'api/rcopia-practice-infos/:id';

        return $resource(resourceUrl, {}, {
            'filter': { url: "api/rcopia-practice-infos/filter", method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-practice-info', {
                parent: 'entity',
                url: '/rcopia-practice-info',
                ncyBreadcrumb: {
                    label: 'RcopiaPracticeInfo',
                    parent: 'entity'
                },
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'RcopiaPracticeInfos'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-practice-info/list/rcopia-practice-info.html',
                        controller: 'RcopiaPracticeInfoController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaPracticeInfoController', RcopiaPracticeInfoController);

    RcopiaPracticeInfoController.$inject = ['GenericEntityDatatableService', 'RcopiaPracticeInfo', 'CoreService', '$q',
        '$uibModal', 'ConfirmationService'];

    function RcopiaPracticeInfoController(GenericEntityDatatableService, RcopiaPracticeInfo, CoreService, $q,
                                       $uibModal, ConfirmationService) {
        var vm = this;

        vm.totalItems = 0;

        var params = {
            corporationId: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Rcopia Practice Info',
            newButtonTitle: 'New Rcopia Practice Info',
            entityClassHumanized: 'Rcopia Practice Info',
            entityStateName: 'rcopia-practice-info',
            service: RcopiaPracticeInfo,
            serviceMethod: 'filter',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'username',
                    title: 'Username'
                },
                {
                    name: 'region',
                    title: 'Region'
                },
                {
                    name: 'vendorUsername',
                    title: 'Vendor Username'
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Rcopia Practice Info',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0;
                            }
                        })
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-practice-info/update/rcopia-practice-info-dialog.html',
                controller: 'RcopiaPracticeInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            name: null,
                            username: null,
                            region: null,
                            corporation: CoreService.getCorporation(),
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-practice-info/update/rcopia-practice-info-dialog.html',
                controller: 'RcopiaPracticeInfoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaPracticeInfo', function (RcopiaPracticeInfo) {
                        return RcopiaPracticeInfo.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('RcopiaPracticeInfo').result.then(function () {
                    RcopiaPracticeInfo.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaMedication', RcopiaMedication);

    RcopiaMedication.$inject = ['$resource'];

    function RcopiaMedication ($resource) {
        var resourceUrl =  'api/rcopia-medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/rcopia-medications/filter', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        // _.forEach(data, function (pm) {
                        //     if (pm.startDate) {
                        //         pm.startDate = new Date(DateUtils.convertDateTimeFromServer(pm.startDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.endDate) {
                        //         pm.endDate = new Date(DateUtils.convertDateTimeFromServer(pm.endDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.createdDate) {
                        //         pm.createdDate = new Date(DateUtils.convertDateTimeFromServer(pm.createdDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.discontinueDate) {
                        //         pm.discontinueDate = new Date(DateUtils.convertDateTimeFromServer(pm.discontinueDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.signedDate) {
                        //         pm.signedDate = new Date(DateUtils.convertDateTimeFromServer(pm.signedDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        //
                        //     if (pm.faxedToCreatedDate) {
                        //         pm.faxedToCreatedDate = new Date(DateUtils.convertDateTimeFromServer(pm.faxedToCreatedDate)
                        //             .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        //     }
                        // });
                    }

                    return data;
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaMedicationController', RcopiaMedicationController);

    RcopiaMedicationController.$inject = ['$scope', '$state', 'RcopiaMedication', 'Auth', 'ACTIONS', 'access', 'TAB',
        'params', 'chart', 'ParseLinks', '$rootScope', 'DataTablesService', 'AlertService',
        'RcopiaUtils', '$uibModalStack', '$uibModal', 'RcopiaApi', 'PendingPdfChartReport',
        'REPORT_TYPE', 'toastr'];

    function RcopiaMedicationController($scope, $state, RcopiaMedication, Auth, ACTIONS, access, TAB,
                                        params, chart, ParseLinks, $rootScope, DataTablesService, AlertService,
                                        RcopiaUtils, $uibModalStack, $uibModal, RcopiaApi, PendingPdfChartReport,
                                        REPORT_TYPE, toastr) {
        var vm = this;

        vm.chart = chart;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.patientMedications = [];
        vm.rcopiaMedications = [];
        vm.selected = {};
        vm.selectAll = false;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.RCOPIA_MEDICATION);
        vm.access = access;
        vm.lastTab = null;
        vm.filter = {
            status: 'active'
        }

        vm.transition = transition;
        vm.search = search;
        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.history = history;
        vm.loadAll = loadAll;
        vm.launchRcopia = launchRcopia;
        vm.view = view;
        vm.print = print;
        vm.createTakes = createTakes;

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_MEDICATION_VIEW, access) || !vm.active) {
                return;
            }

            RcopiaMedication.findAllByFilter({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                active: vm.filter.status === 'active'
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientMedications = data;

                // initSelected();
            }

            function onError(error) {
                AlertService.error(error.data);
            }
        }

        function reload() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }

        function search() {
            vm.page = 1;
            transition();
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result === TAB.RCOPIA_MEDICATION) {
                vm.active = true;
                loadAll();
            } else if (vm.lastTab != null && result === TAB.RCOPIA_MEDICATION && vm.lastTab !== TAB.RCOPIA_MEDICATION) {
                loadAll();
            }

            vm.lastTab = result;
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:RcopiaUpdatePatient', function (event, result) {
            reload();
        });

        $scope.$on('$destroy', unsubscribe);

        function getDirections(rcopiaPrescription) {
            return RcopiaUtils.getDirections(rcopiaPrescription, true);
        }

        function getQuantity(rcopiaPrescription) {
            return RcopiaUtils.getQuantity(rcopiaPrescription, true);
        }

        function getRefills(rcopiaPrescription) {
            return RcopiaUtils.getRefills(rcopiaPrescription, true);
        }

        function history() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/rcopia-medication/history/rcopia-medication-history.html',
                controller: 'RcopiaMedicationHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom-table-fix',
                animation: false,
                size: 'xl',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function launchRcopia() {
            RcopiaUtils.launchRcopiaPopup(
                'manage_medications',
                'patientMode',
                vm.chart.id
            ).result.then(function () {
                RcopiaApi.executeByChart({
                    api: 'updateMedication',
                    chartId: vm.chart.id
                }, function (result) {
                    $rootScope.$broadcast("bluebookApp:RcopiaUpdatePatient");
                })
            })
        }

        function view(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-medication/detail/rcopia-medication-detail.html',
                controller: 'RcopiaMedicationDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    rcopiaMedication: ['RcopiaMedication', function (RcopiaMedication) {
                        return RcopiaMedication.get({id: id}).$promise;
                    }],
                    signAuthorities: ['BusinessCredential', 'BUSINESS_ROLES', 'CoreService', function (BusinessCredential, BUSINESS_ROLES, CoreService) {
                        return BusinessCredential.getCredentialByRole({
                            businessRole: BUSINESS_ROLES.PHYSICIAN, id: CoreService.getCurrentFacility().id
                        }).$promise;
                    }],
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: vm.chart.id}).$promise;
                    }],
                }
            });
        }

        function print(id) {
            PendingPdfChartReport.save({
                chart: {id: vm.chart.id},
                objectId: id,
                name: "" + id,
                reportType: REPORT_TYPE.RCOPIA_MEDICATION
            }, onPrintSuccess, onPrintError);
        }

        function onPrintSuccess(result) {
            toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
        }

        function onPrintError() {
            toastr.error("We couldn't generate the report.");
        }

        function createTakes(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-medication/create-takes/rcopia-medication-create-takes-dialog.html',
                controller: 'RcopiaMedicationDetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    rcopiaMedication: ['RcopiaMedication', function (RcopiaMedication) {
                        return RcopiaMedication.get({id: id}).$promise;
                    }],
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: vm.chart.id}).$promise;
                    }],
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaMedicationHistoryController', RcopiaMedicationHistoryController);

    RcopiaMedicationHistoryController.$inject = ['RcopiaMedication', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', '$uibModalInstance', '$timeout', 'ParseLinks',
        'PopupService', '$uibModalStack', 'RcopiaUtils'];

    function RcopiaMedicationHistoryController(RcopiaMedication, DTOptionsBuilder, DTColumnBuilder,
                                                 DataTablesService, chart, $uibModalInstance, $timeout, ParseLinks,
                                                 PopupService, $uibModalStack, RcopiaUtils) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.patientMedications = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.getDaysSupply = getDaysSupply;
        vm.dirToPharmacy = dirToPharmacy;
        vm.doNotFillBefore = doNotFillBefore;

        loadAll();

        function loadAll() {
            RcopiaMedication.findAllByFilter({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                active: false
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientMedications = data;
            }

            function onError(error) {
                AlertService.error(error.data);
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }

        function getDirections(rcopiaPrescription) {
            return RcopiaUtils.getDirections(rcopiaPrescription, true);
        }

        function getQuantity(rcopiaPrescription) {
            return RcopiaUtils.getQuantity(rcopiaPrescription, true);
        }

        function getRefills(rcopiaPrescription) {
            return RcopiaUtils.getRefills(rcopiaPrescription, true);
        }

        function getDaysSupply(rcopiaPrescription) {
            return RcopiaUtils.getDaysSupply(rcopiaPrescription);
        }

        function dirToPharmacy(rcopiaPrescription) {
            return RcopiaUtils.dirToPharmacy(rcopiaPrescription);
        }

        function doNotFillBefore(rcopiaPrescription) {
            return RcopiaUtils.doNotFillBefore(rcopiaPrescription);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaMedicationDetailController', RcopiaMedicationDetailController);

    RcopiaMedicationDetailController.$inject = ['$scope', '$rootScope', 'rcopiaMedication', 'RcopiaMedication', 'Chart',
        'Employee', 'Pharmacy', 'RcopiaUtils', '$uibModalInstance', 'chart'];

    function RcopiaMedicationDetailController($scope, $rootScope, rcopiaMedication, RcopiaMedication, Chart,
                                              Employee, Pharmacy, RcopiaUtils, $uibModalInstance, chart) {
        var vm = this;

        vm.rcopiaMedication = rcopiaMedication;
        vm.chart = chart;

        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.getDaysSupply = getDaysSupply;
        vm.dirToPharmacy = dirToPharmacy;
        vm.doNotFillBefore = doNotFillBefore;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getDirections(rcopiaMedication) {
            return RcopiaUtils.getDirections(rcopiaMedication);
        }

        function getQuantity(rcopiaMedication) {
            return RcopiaUtils.getQuantity(rcopiaMedication);
        }

        function getRefills(rcopiaMedication) {
            return RcopiaUtils.getRefills(rcopiaMedication);
        }

        function getDaysSupply(rcopiaMedication) {
            return RcopiaUtils.getDaysSupply(rcopiaMedication);
        }

        function dirToPharmacy(rcopiaMedication) {
            return RcopiaUtils.dirToPharmacy(rcopiaMedication);
        }

        function doNotFillBefore(rcopiaMedication) {
            return RcopiaUtils.doNotFillBefore(rcopiaMedication);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaMedicationCreateTakesController', RcopiaMedicationCreateTakesController);

    RcopiaMedicationCreateTakesController.$inject = ['$scope', '$rootScope', 'rcopiaMedication', 'RcopiaMedication', 'Chart',
        'Employee', 'Pharmacy', 'RcopiaUtils', '$uibModalInstance', 'chart'];

    function RcopiaMedicationCreateTakesController($scope, $rootScope, rcopiaMedication, RcopiaMedication, Chart,
                                              Employee, Pharmacy, RcopiaUtils, $uibModalInstance, chart) {
        var vm = this;

        vm.rcopiaMedication = rcopiaMedication;
        vm.chart = chart;

        vm.getDirections = getDirections;
        vm.getQuantity = getQuantity;
        vm.getRefills = getRefills;
        vm.getDaysSupply = getDaysSupply;
        vm.dirToPharmacy = dirToPharmacy;
        vm.doNotFillBefore = doNotFillBefore;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getDirections(rcopiaMedication) {
            return RcopiaUtils.getDirections(rcopiaMedication);
        }

        function getQuantity(rcopiaMedication) {
            return RcopiaUtils.getQuantity(rcopiaMedication);
        }

        function getRefills(rcopiaMedication) {
            return RcopiaUtils.getRefills(rcopiaMedication);
        }

        function getDaysSupply(rcopiaMedication) {
            return RcopiaUtils.getDaysSupply(rcopiaMedication);
        }

        function dirToPharmacy(rcopiaMedication) {
            return RcopiaUtils.dirToPharmacy(rcopiaMedication);
        }

        function doNotFillBefore(rcopiaMedication) {
            return RcopiaUtils.doNotFillBefore(rcopiaMedication);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaLastUpdateDateDialogController', RcopiaLastUpdateDateDialogController);

    RcopiaLastUpdateDateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'RcopiaLastUpdateDate'];

    function RcopiaLastUpdateDateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                   RcopiaLastUpdateDate) {
        var vm = this;

        vm.rcopiaLastUpdateDate = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaLastUpdateDate.id !== null) {
                RcopiaLastUpdateDate.update(vm.rcopiaLastUpdateDate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaLastUpdateDateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaLastUpdateDate', RcopiaLastUpdateDate);

    RcopiaLastUpdateDate.$inject = ['$resource'];

    function RcopiaLastUpdateDate ($resource) {
        var resourceUrl =  'api/rcopia-last-update-dates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/rcopia-last-update-dates/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-last-update-date', {
                parent: 'entity',
                url: '/rcopia-last-update-date',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaLastUpdateDates'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-last-update-date/list/rcopia-last-update-dates.html',
                        controller: 'RcopiaLastUpdateDateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('rcopia-last-update-date-detail', {
                parent: 'entity',
                url: '/rcopia-last-update-date/{id}',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'RcopiaLastUpdateDate'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-last-update-date/detail/rcopia-last-update-date-detail.html',
                        controller: 'RcopiaLastUpdateDateDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'RcopiaLastUpdateDate', function ($stateParams, RcopiaLastUpdateDate) {
                        return RcopiaLastUpdateDate.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'rcopia-last-update-date',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaLastUpdateDateController', RcopiaLastUpdateDateController);

    RcopiaLastUpdateDateController.$inject = ['$scope', '$state', 'RcopiaLastUpdateDate', 'CoreService', 'Corporation',
        'GenericEntityDatatableService', 'ConfirmationService', '$q', 'Chart',
        '$rootScope', '$uibModal'];

    function RcopiaLastUpdateDateController($scope, $state, RcopiaLastUpdateDate, CoreService, Corporation,
                                            GenericEntityDatatableService, ConfirmationService, $q, Chart,
                                            $rootScope, $uibModal) {
        var vm = this;

        var params = {
            // corporationId: CoreService.getCorporation().id,
        }

        vm.descriptor = {
            title: 'Rcopia Last Update Date',
            entityClassHumanized: 'Rcopia Last Update Date',
            entityStateName: 'rcopia-last-update-date',
            service: RcopiaLastUpdateDate,
            serviceMethod: 'query',
            params: params,
            pagination: 'remote',
            newAction: false,
            // options: [
            //     {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            // ],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'api',
                    title: 'API',
                },
                {
                    title: 'Last Update Date',
                    name: 'lastUpdateDate',
                },
                {
                    title: 'RcopiaID',
                    name: 'rcopiaID'
                },
                {
                    name: 'chartId',
                    title: 'Chart',
                    render: function (entity) {
                        return entity.chart ?
                            entity.chart.firstName + " " +
                            (entity.chart.middleName ? entity.chart.middleName + ' ' : '') +
                            entity.chart.lastName : ""
                    }
                },
                {
                    name: 'mrno',
                    title: 'MrNo',
                    render: function (entity) {
                        return entity.chart ? entity.chart.mrNo : ""
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'api',
                    placeholder: 'API...',
                    type: 'select',
                    values: [
                        'update_allergy',
                        'update_allergy_group',
                        'update_patient',
                        'update_medication',
                        'update_notification',
                        'get_notification_count',
                        'update_prescription',
                        'update_rxchange',
                        'update_prescription_events',
                        'update_rxfill',

                        'send_patient',
                        'send_problem',
                        'send_allergy'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
                {
                    name: 'rcopiaId',
                    placeholder: 'RcopiaID...',
                    type: 'string',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'corporationId',
                    read: function (filter) {
                        return filter.corporationId ? filter.corporationId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        Corporation.query(function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    defaultValue: function () {
                        return CoreService.getCorporation();
                    },
                    placeholder: 'Corporation ...',
                    type: 'select',
                },
                {
                    name: 'start',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.start ? moment(filter.start).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
                {
                    name: 'end',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.end ? moment(filter.end).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
            ]
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('RcopiaLastUpdateDate').result.then(function () {
                    RcopiaLastUpdateDate.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-last-update-date/update/rcopia-last-update-dialog.html',
                controller: 'RcopiaLastUpdateDateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaLastUpdateDate', function (RcopiaLastUpdateDate) {
                        return RcopiaLastUpdateDate.get({id: id}).$promise;
                    }]
                }
            }).result;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionDialogController', RcopiaInstructionDialogController);

    RcopiaInstructionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RcopiaInstruction', 'RcopiaDose'];

    function RcopiaInstructionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RcopiaInstruction, RcopiaDose) {
        var vm = this;

        vm.rcopiaInstruction = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rcopiadoses = RcopiaDose.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaInstruction.id !== null) {
                RcopiaInstruction.update(vm.rcopiaInstruction, onSaveSuccess, onSaveError);
            } else {
                RcopiaInstruction.save(vm.rcopiaInstruction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaInstructionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionDetailController', RcopiaInstructionDetailController);

    RcopiaInstructionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RcopiaInstruction', 'RcopiaDose'];

    function RcopiaInstructionDetailController($scope, $rootScope, $stateParams, previousState, entity, RcopiaInstruction, RcopiaDose) {
        var vm = this;

        vm.rcopiaInstruction = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:rcopiaInstructionUpdate', function(event, result) {
            vm.rcopiaInstruction = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionDeleteController',RcopiaInstructionDeleteController);

    RcopiaInstructionDeleteController.$inject = ['$uibModalInstance', 'entity', 'RcopiaInstruction'];

    function RcopiaInstructionDeleteController($uibModalInstance, entity, RcopiaInstruction) {
        var vm = this;

        vm.rcopiaInstruction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RcopiaInstruction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rcopia-instruction', {
            parent: 'entity',
            url: '/rcopia-instruction',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaInstructions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instructions.html',
                    controller: 'RcopiaInstructionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rcopia-instruction-detail', {
            parent: 'entity',
            url: '/rcopia-instruction/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaInstruction'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-detail.html',
                    controller: 'RcopiaInstructionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RcopiaInstruction', function($stateParams, RcopiaInstruction) {
                    return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rcopia-instruction',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rcopia-instruction-detail.edit', {
            parent: 'rcopia-instruction-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-dialog.html',
                    controller: 'RcopiaInstructionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaInstruction', function(RcopiaInstruction) {
                            return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-instruction.new', {
            parent: 'rcopia-instruction',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-dialog.html',
                    controller: 'RcopiaInstructionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                clinicalInstruction: null,
                                sequence: null,
                                action: null,
                                dose: null,
                                doseUnit: null,
                                route: null,
                                doseTiming: null,
                                asNeeded: null,
                                y: null,
                                doseOther: null,
                                doseDuration: null,
                                doseDurationUnit: null,
                                conjunction: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rcopia-instruction', null, { reload: 'rcopia-instruction' });
                }, function() {
                    $state.go('rcopia-instruction');
                });
            }]
        })
        .state('rcopia-instruction.edit', {
            parent: 'rcopia-instruction',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-dialog.html',
                    controller: 'RcopiaInstructionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaInstruction', function(RcopiaInstruction) {
                            return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-instruction', null, { reload: 'rcopia-instruction' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-instruction.delete', {
            parent: 'rcopia-instruction',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-instruction/rcopia-instruction-delete-dialog.html',
                    controller: 'RcopiaInstructionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RcopiaInstruction', function(RcopiaInstruction) {
                            return RcopiaInstruction.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-instruction', null, { reload: 'rcopia-instruction' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaInstruction', RcopiaInstruction);

    RcopiaInstruction.$inject = ['$resource'];

    function RcopiaInstruction ($resource) {
        var resourceUrl =  'api/rcopia-instructions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RcopiaInstructionSearch', RcopiaInstructionSearch);

    RcopiaInstructionSearch.$inject = ['$resource'];

    function RcopiaInstructionSearch($resource) {
        var resourceUrl =  'api/_search/rcopia-instructions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaInstructionController', RcopiaInstructionController);

    RcopiaInstructionController.$inject = ['$scope', '$state', 'RcopiaInstruction', 'RcopiaInstructionSearch'];

    function RcopiaInstructionController ($scope, $state, RcopiaInstruction, RcopiaInstructionSearch) {
        var vm = this;

        vm.rcopiaInstructions = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            RcopiaInstruction.query(function(result) {
                vm.rcopiaInstructions = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RcopiaInstructionSearch.query({query: vm.searchQuery}, function(result) {
                vm.rcopiaInstructions = result;
            });
        }    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaDrug', RcopiaDrug);

    RcopiaDrug.$inject = ['$resource'];

    function RcopiaDrug ($resource) {
        var resourceUrl =  'api/rcopia-drugs/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'findAllByFilter': {url: 'api/rcopia-drugs/filter', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-drug', {
                parent: 'entity',
                url: '/rcopia-drug',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Rcopia - Drugs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-drug/list/rcopia-drug.html',
                        controller: 'RcopiaDrugController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDrugController', RcopiaDrugController);

    RcopiaDrugController.$inject = ['GenericEntityDatatableService', '$scope', '$state', 'RcopiaDrug'];

    function RcopiaDrugController (GenericEntityDatatableService, $scope, $state, RcopiaDrug) {
        var vm = this;

        vm.descriptor = {
            title: 'Rcopia Drugs',
            entityClassHumanized: 'Rcopia Drugs',
            entityStateName: 'rcopia-drug',
            service: RcopiaDrug,
            serviceMethod: 'findAllByFilter',
            pagination: 'remote',
            options: [
                {key: 'aaSorting', value: [[0, 'rcopiaId']]}
            ],
            newAction: false,
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            columns: [
                {
                    name: 'rcopiaId',
                    title: 'Rcopia ID',
                },
                {
                    name: 'ndcid',
                    title: 'Ndcid',
                },
                {
                    name: 'firstDataBankMedID',
                    title: 'First Data Bank Med ID',
                },
                {
                    name: 'rxnormID',
                    title: 'Rxnorm ID',
                },
                {
                    name: 'brandName',
                    title: 'Brand Name',
                },
                {
                    name: 'genericName',
                    title: 'Generic Name',
                },
                {
                    name: 'form',
                    title: 'Form',
                },
                {
                    name: 'strength',
                    title: 'Strength',
                },
                {
                    name: 'schedule',
                    title: 'Schedule',
                },
                {
                    name: 'supply',
                    title: 'Supply',
                },
                {
                    name: 'compound',
                    title: 'Compound',
                }
            ]
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageDialogController', RcopiaDosageDialogController);

    RcopiaDosageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RcopiaDosage', 'RcopiaInstruction'];

    function RcopiaDosageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RcopiaDosage, RcopiaInstruction) {
        var vm = this;

        vm.rcopiaDosage = entity;
        vm.clear = clear;
        vm.save = save;
        vm.rcopiainstructions = RcopiaInstruction.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaDosage.id !== null) {
                RcopiaDosage.update(vm.rcopiaDosage, onSaveSuccess, onSaveError);
            } else {
                RcopiaDosage.save(vm.rcopiaDosage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaDosageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageDetailController', RcopiaDosageDetailController);

    RcopiaDosageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RcopiaDosage', 'RcopiaInstruction'];

    function RcopiaDosageDetailController($scope, $rootScope, $stateParams, previousState, entity, RcopiaDosage, RcopiaInstruction) {
        var vm = this;

        vm.rcopiaDosage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:rcopiaDosageUpdate', function(event, result) {
            vm.rcopiaDosage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageDeleteController',RcopiaDosageDeleteController);

    RcopiaDosageDeleteController.$inject = ['$uibModalInstance', 'entity', 'RcopiaDosage'];

    function RcopiaDosageDeleteController($uibModalInstance, entity, RcopiaDosage) {
        var vm = this;

        vm.rcopiaDosage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RcopiaDosage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rcopia-dosage', {
            parent: 'entity',
            url: '/rcopia-dosage',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaDosages'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosages.html',
                    controller: 'RcopiaDosageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rcopia-dosage-detail', {
            parent: 'entity',
            url: '/rcopia-dosage/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcopiaDosage'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-detail.html',
                    controller: 'RcopiaDosageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RcopiaDosage', function($stateParams, RcopiaDosage) {
                    return RcopiaDosage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rcopia-dosage',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rcopia-dosage-detail.edit', {
            parent: 'rcopia-dosage-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-dialog.html',
                    controller: 'RcopiaDosageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaDosage', function(RcopiaDosage) {
                            return RcopiaDosage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-dosage.new', {
            parent: 'rcopia-dosage',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-dialog.html',
                    controller: 'RcopiaDosageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dosageText: null,
                                patientNotes: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rcopia-dosage', null, { reload: 'rcopia-dosage' });
                }, function() {
                    $state.go('rcopia-dosage');
                });
            }]
        })
        .state('rcopia-dosage.edit', {
            parent: 'rcopia-dosage',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-dialog.html',
                    controller: 'RcopiaDosageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RcopiaDosage', function(RcopiaDosage) {
                            return RcopiaDosage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-dosage', null, { reload: 'rcopia-dosage' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rcopia-dosage.delete', {
            parent: 'rcopia-dosage',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rcopia-dosage/rcopia-dosage-delete-dialog.html',
                    controller: 'RcopiaDosageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RcopiaDosage', function(RcopiaDosage) {
                            return RcopiaDosage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rcopia-dosage', null, { reload: 'rcopia-dosage' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaDosage', RcopiaDosage);

    RcopiaDosage.$inject = ['$resource'];

    function RcopiaDosage ($resource) {
        var resourceUrl =  'api/rcopia-dosages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('RcopiaDosageSearch', RcopiaDosageSearch);

    RcopiaDosageSearch.$inject = ['$resource'];

    function RcopiaDosageSearch($resource) {
        var resourceUrl =  'api/_search/rcopia-dosages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaDosageController', RcopiaDosageController);

    RcopiaDosageController.$inject = ['$scope', '$state', 'RcopiaDosage', 'RcopiaDosageSearch'];

    function RcopiaDosageController ($scope, $state, RcopiaDosage, RcopiaDosageSearch) {
        var vm = this;

        vm.rcopiaDosages = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            RcopiaDosage.query(function(result) {
                vm.rcopiaDosages = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RcopiaDosageSearch.query({query: vm.searchQuery}, function(result) {
                vm.rcopiaDosages = result;
            });
        }    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaApi', RcopiaApi);

    RcopiaApi.$inject = ['$resource'];

    function RcopiaApi($resource) {
        var resourceUrl = 'api/rcopia-apis';

        return $resource(resourceUrl, {}, {
            'apis': {
                url: 'api/rcopia-apis/apis',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        var id = 0;

                        return _.map(data, function (api) {
                            return {id: id++, api: api}
                        })
                    }
                    return data;
                }
            },
            'execute': {url: 'api/rcopia-apis/execute/:api/:corporationId', method: 'GET', isArray: true},
            'executeByChart': {url: 'api/rcopia-apis/execute/chart/:api/:chartId', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-apis', {
                parent: 'entity',
                url: '/rcopia-apis',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Rcopia APIs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-ap-i/list/rcopia-ap-i.html',
                        controller: 'RcopiaApiController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaApiController', RcopiaApiController);

    RcopiaApiController.$inject = ['$scope', 'CoreService', 'RcopiaApi', 'GenericEntityDatatableService', '$q',
        'ConfirmationService'];

    function RcopiaApiController($scope, CoreService, RcopiaApi, GenericEntityDatatableService, $q,
                                 ConfirmationService) {
        var vm = this;

        vm.descriptor = {
            title: 'Rcopia APIs',
            entityClassHumanized: 'Rcopia APIs',
            entityStateName: 'rcopia',
            service: RcopiaApi,
            serviceMethod: 'apis',
            newAction: false,
            columns: [
                {
                    name: 'api',
                    title: 'Api',
                }
            ],
            enableSearch: false,
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getPlayAction(), {
                    name : 'Execute',
                    action: function (data) {
                        return execute(data);
                    }
                }),
            ],
        }

        function execute(data) {
            return $q(function (resolve) {
                ConfirmationService.open({
                    title: 'Restore Employee',
                    // message: 'This action will <strong>restore</strong> a deleted employee. Are you sure you want to <strong>restore</strong> this Employee?',
                    message: 'Execute api <strong>' + data.api + '</strong>',
                    actions: [
                        {
                            name: 'Execute',
                            color: 'btn btn-success',
                            icon: 'fa fa-check-circle',
                            value: 'SUCCESS'
                        },
                        {
                            name: 'Cancel',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                }).result.then(function () {
                    RcopiaApi.execute({api: data.api, corporationId: CoreService.getCorporation().id}, function () {
                        resolve();
                    });
                });
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaAllergyGroup', RcopiaAllergyGroup);

    RcopiaAllergyGroup.$inject = ['$resource'];

    function RcopiaAllergyGroup ($resource) {
        var resourceUrl =  'api/rcopia-allergy-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/rcopia-allergy-groups'},
            'filter': { method: 'GET', isArray: true, url: 'api/rcopia-allergy-groups/filter/:name'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'sync': { method: 'GET', url: 'api/rcopia-allergy-groups/sync' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rcopia-allergy-group', {
                parent: 'entity',
                url: '/rcopia-allergy-group',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN'],
                    pageTitle: 'RcopiaAllergyGroups'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-allergy-group/list/rcopia-allergy-groups.html',
                        controller: 'RcopiaAllergyGroupController',
                        controllerAs: 'vm'
                    }
                },
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaAllergyGroupController', RcopiaAllergyGroupController);

    RcopiaAllergyGroupController.$inject = ['$scope', '$state', 'RcopiaAllergyGroup', 'GenericEntityDatatableService'];

    function RcopiaAllergyGroupController($scope, $state, RcopiaAllergyGroup, GenericEntityDatatableService) {
        var vm = this;

        vm.descriptor = {
            title: 'Rcopia Allergy Groups',
            entityClassHumanized: 'Rcopia Accounts',
            entityStateName: 'rcopia-account',
            service: RcopiaAllergyGroup,
            serviceMethod: 'query',
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'id',
                    title: 'id'
                },
                {
                    name: 'rcopiaId',
                    title: 'Rcopia Id',
                },
                {
                    name: 'externalId',
                    title: 'External Id',
                },
                {
                    name: 'firstDataBankGroupId',
                    title: 'First Data Bank Group Id',
                },
                {
                    name: 'isSpecific',
                    title: 'Is Specific',
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'fdbSpecificGroupId',
                    title: 'Fdb Specific Group Id',
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: 'Sync',
                            action: function () {
                                return sync();
                            }
                        })
                    ]
                }
            ],
        }

        function sync() {
            RcopiaAllergyGroup.sync();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaAccountDialogController', RcopiaAccountDialogController);

    RcopiaAccountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'RcopiaAccount', 'CoreService', 'Employee'];

    function RcopiaAccountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                            RcopiaAccount, CoreService, Employee) {
        var vm = this;

        vm.rcopiaAccount = entity;
        vm.employees = [];
        vm.accountTypes = [
            'ANY',

            'CHIROPRACTOR',

            'DENTIST',

            'NURSE_PRACTITIONER',

            'PART_TIME_PHYSICIAN',

            'PHYSICIAN',

            'PHYSICIAN_ASSISTANT',

            'RESIDENT',

            'STAFF',

            'VENDOR'
        ];

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rcopiaAccount.id !== null) {
                RcopiaAccount.update(vm.rcopiaAccount, onSaveSuccess, onSaveError);
            } else {
                RcopiaAccount.save(vm.rcopiaAccount, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:rcopiaAccountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            var filter = {page: 0, size: 20, query: query, corporationId: CoreService.getCorporation().id};

            Employee.findAllWithoutRcopiaAccount(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaAccount', RcopiaAccount);

    RcopiaAccount.$inject = ['$resource'];

    function RcopiaAccount($resource) {
        var resourceUrl = 'api/rcopia-accounts/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByCorporation': {url: 'api/rcopia-accounts/by-corporation/:id', method: 'GET', isArray: true},
            'rcopiaToken': {url: 'api/rcopia-accounts/rcopia-token/:chartId/:startupScreen', method: 'GET'},
            'rcopiaLimpToken': {url: 'api/rcopia-accounts/rcopia-limp-token/:corporationId/:startupScreen', method: 'GET'},
            'account': {
                url: 'api/rcopia-accounts/account/by-corporation/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-account', {
                parent: 'entity',
                url: '/rcopia-account',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Rcopia - Accounts'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-account/list/rcopia-account.html',
                        controller: 'RcopiaAccountController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaAccountController', RcopiaAccountController);

    RcopiaAccountController.$inject = ['GenericEntityDatatableService', 'CoreService', 'RcopiaAccount', '$uibModal',
        '$q', 'ConfirmationService'];

    function RcopiaAccountController(GenericEntityDatatableService, CoreService, RcopiaAccount, $uibModal,
                              $q, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Rcopia Accounts',
            newButtonTitle: 'New Account',
            entityClassHumanized: 'Rcopia Accounts',
            entityStateName: 'rcopia-account',
            service: RcopiaAccount,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'login',
                    title: 'Employee',
                    render: function (entity) {
                        return entity.employee.firstName + " " + entity.employee.lastName;
                    }
                },
                {
                    name: 'username',
                    title: 'Username',
                },
                {
                    name: 'externalId',
                    title: 'ExternalId',
                },
                {
                    name: 'rcopiaAccountType',
                    title: 'Account Type',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Rcopia Account',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-account/update/rcopia-account-dialog.html',
                controller: 'RcopiaAccountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            username: null,
                            password: null,
                            signaturePassword: null,
                            externalId: null,
                            rcopiaAccountType: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia-account/update/rcopia-account-dialog.html',
                controller: 'RcopiaAccountDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['RcopiaAccount', function (RcopiaAccount) {
                        return RcopiaAccount.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('RcopiaAccount').result.then(function () {
                    RcopiaAccount.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcopiaUtils', RcopiaUtils);

    RcopiaUtils.$inject = ['$uibModal'];

    function RcopiaUtils($uibModal) {

        var service = {
            getDirections: getDirections,
            getQuantity: getQuantity,
            getRefills: getRefills,
            getDaysSupply: getDaysSupply,
            dirToPharmacy: dirToPharmacy,
            doNotFillBefore: doNotFillBefore,
            launchRcopiaPopup: launchRcopiaPopup
        };

        return service;

        function getDirections(rcopiaPrescription, clear) {
            return _.join(_.map(rcopiaPrescription.sig.dosage.instructions, function (instruction) {
                return getDirections2(instruction, clear);
            }), " ");
        }

        function getDirections2(rcopiaPrescription, clear) {
            if (clear) {
                return clearString(rcopiaPrescription.action) + " " +
                    clearString(rcopiaPrescription.dose) + " " +
                    clearString(rcopiaPrescription.doseUnit) + " " +
                    clearString(rcopiaPrescription.route) + " " +
                    clearString(rcopiaPrescription.doseTiming) + " " +
                    (clearString(rcopiaPrescription.doseOther) + " ") +
                    (clearString(rcopiaPrescription.patientNotes));
            } else {
                return clearString(rcopiaPrescription.action) + " " +
                    (rcopiaPrescription.dose ?
                        ("**" + rcopiaPrescription.dose + "** " + "(" + numberToWords.toWords(rcopiaPrescription.dose) + ") ") : "") +
                    clearString(rcopiaPrescription.doseUnit) + " " +
                    clearString(rcopiaPrescription.route) + " " +
                    clearString(rcopiaPrescription.doseTiming) + " " +
                    (clearString(rcopiaPrescription.doseOther) + " ") +
                    (clearString(rcopiaPrescription.patientNotes));
            }
        }

        function getQuantity(rcopiaPrescription, clear) {
            if (clear) {
                return clearString(rcopiaPrescription.sig.quantity) + " " + clearString(rcopiaPrescription.sig.quantityUnit);
            } else {
                return (rcopiaPrescription.sig.quantity ? ("**" + rcopiaPrescription.sig.quantity + "** " + "(" + numberToWords.toWords(rcopiaPrescription.sig.quantity) + ") ") : "") +
                    clearString(rcopiaPrescription.sig.quantityUnit);
            }
        }

        function getRefills(rcopiaPrescription, clear) {
            if (clear) {
                return rcopiaPrescription.sig.refills === '0' || rcopiaPrescription.sig.refills === 0 ? 'none' : rcopiaPrescription.sig.refills;
            } else {
                return (rcopiaPrescription.sig.refills === '0' || rcopiaPrescription.sig.refills === 0 ? 'none' : "**" + rcopiaPrescription.sig.refills + "**" + " (" + numberToWords.toWords(rcopiaPrescription.sig.refills) + ")");
            }
        }

        function getDaysSupply(rcopiaPrescription) {
            return rcopiaPrescription.sig.duration ? (rcopiaPrescription.sig.duration + " days") : "";
        }

        function dirToPharmacy(rcopiaPrescription) {
            return rcopiaPrescription.sig.otherNotes ? (rcopiaPrescription.sig.otherNotes) : "";
        }

        function doNotFillBefore(rcopiaPrescription) {
            return clearString(rcopiaPrescription.sig.effectiveDate);
        }

        function clearString(value) {
            return value ? value : "";
        }

        function launchRcopiaPopup(startupScreen, mode, chartId) {
            return $uibModal.open({
                templateUrl: 'app/entities/rcopia/popup/rcopia-popup.html',
                controller: 'RcopiaPopupController',
                controllerAs: 'vm',
                backdrop: true,
                keyboard: false,
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    options: {
                        startupScreen: startupScreen,
                        mode: mode,
                        chartId: chartId
                    }
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Rcopia', Rcopia);

    Rcopia.$inject = ['$resource'];

    function Rcopia ($resource) {
        var resourceUrl =  'api/rcopia';

        return $resource(resourceUrl, {}, {
            'sendPatient': {
                url: 'api/rcopia/send-patient/:id',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'updatePatient': {url: 'api/rcopia/update-patient/:id', method: 'GET', isArray: true},
            'getNotificationCount': {url: 'api/rcopia/get-notification-count/:corporationId', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaPopupController', RcopiaPopupController);

    RcopiaPopupController.$inject = ['CoreService', 'RcopiaAccount', '$sce', 'options', '$uibModalInstance'];

    function RcopiaPopupController(CoreService, RcopiaAccount, $sce, options, $uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        init();

        function init() {
            if (options.mode === 'limpMode') {
                RcopiaAccount.rcopiaLimpToken(
                    {
                        corporationId: CoreService.getCorporation().id,
                        startupScreen: options.startupScreen
                    },
                    function (token) {
                        vm.rcopiaToken = $sce.trustAsResourceUrl(token.value);
                    });
            } else {
                RcopiaAccount.rcopiaToken(
                    {
                        corporationId: CoreService.getCorporation().id,
                        startupScreen: options.startupScreen,
                        chartId: options.chartId
                    },
                    function (token) {
                        vm.rcopiaToken = $sce.trustAsResourceUrl(token.value);
                    });
            }
        }

        function clear() {
            $uibModalInstance.close({});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcopiaChartController', RcopiaChartController);

    RcopiaChartController.$inject = ['$sce', 'chart', 'RcopiaAccount', 'CoreService', '$rootScope', 'access',
        '$document', '$scope', 'rcopiaAccount', '$state', 'Rcopia', 'toastr', 'TAB'];

    function RcopiaChartController($sce, chart, RcopiaAccount, CoreService, $rootScope, access,
                              $document, $scope, rcopiaAccount, $state, Rcopia, toastr, TAB) {
        var vm = this;

        vm.chart = chart;
        vm.access = access;
        vm.rcopiaAccount = rcopiaAccount;
        vm.corporation = CoreService.getCorporation();
        vm.loading = false;

        vm.transfer = transfer;

        function transfer() {
            vm.loading = true;

            Rcopia.sendPatient({id: chart.id}, function (result) {
                if (result.length === 0) {
                    $state.go('chart', {id: vm.chart.id, tabId: "" + TAB.BASIC_INFORMATION}, {reload: 'resource'});
                } else {
                    toastr.error(result[0].text, {'time-out': 10000});
                }

                vm.loading = false;
            }, function () {
                vm.loading = false;
                toastr.error('Something went wrong', 'Error');
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcUploadDialogController', RcUploadDialogController);

    RcUploadDialogController.$inject = ['CoreService', '$uibModal', '$uibModalInstance', 'DataUtils', 'toastr', 'RcUpload'];

    function RcUploadDialogController(CoreService, $uibModal, $uibModalInstance, DataUtils, toastr, RcUpload) {

        var vm = this;

        vm.facility = CoreService.getCurrentFacility();
        vm.fileDTO = {
            facilityId: vm.facility.id,
            files: []
        };
        vm.file = null;
        vm.date = null;
        vm.isSaving = false;
        vm.datePickerOpenStatus = false;

        vm.attachFile = attachFile;
        vm.clear = clear;
        vm.attach = attach;
        vm.openCalendar = openCalendar;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function attachFile(files) {
            vm.file = null;

            var bigFiles = _.remove(files, function (item) {

                return parseInt(item.size) > 16000000;
            });

            vm.file = files[0];

            for (var i = 0; i < bigFiles.length; i++) {
                toastr.error(bigFiles[i].name + ' file is too big. The maximum size is 16MB')
            }
        }

        function attach() {
            vm.isSaving = true;

            vm.fileDTO.files = [];

            DataUtils.toBase64ToFileObject(vm.file, function (result) {
                vm.fileDTO.files.push(result);
                vm.fileDTO.collectedDate = moment(vm.date).format("YYYY-MM-DD");

                RcUpload.save(vm.fileDTO, onSaveSuccess, onSaveError);
            });
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar() {
            vm.datePickerOpenStatus = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rc-upload', {
            parent: 'entity',
            url: '/rc-upload',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'RcUploads'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rc-upload/rc-uploads.html',
                    controller: 'RcUploadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rc-upload.new', {
            parent: 'rc-upload',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rc-upload/rc-upload-dialog.html',
                    controller: 'RcUploadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles'
                }).result.then(function() {
                    $state.go('rc-upload', null, { reload: 'rc-upload' });
                }, function() {
                    $state.go('rc-upload');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('RcUpload', RcUpload);

    RcUpload.$inject = ['$resource', 'DateUtils'];

    function RcUpload($resource, DateUtils) {
        var resourceUrl = 'api/rc-uploads/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFacility': {url: 'api/rc-uploads/by-facility/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.collectedDate = DateUtils.convertLocalDateFromServer(data.collectedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RcUploadController', RcUploadController);

    RcUploadController.$inject = ['$scope', '$state', 'RcUpload', '$rootScope',
        'DTOptionsBuilder', 'DTColumnBuilder', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile'];

    function RcUploadController($scope, $state, RcUpload, $rootScope,
                                DTOptionsBuilder, DTColumnBuilder, $q, GUIUtils, $filter, CoreService, $compile) {
        var vm = this;

        vm.title = 'Uploads';
        vm.entityClassHumanized = 'Upload';
        vm.entityStateName = 'rc-upload';

        vm.rcUploads = [];
        vm.dtInstance = {};

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            RcUpload.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                vm.rcUploads = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('fileName').withTitle('File').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('Date Created').notSortable().renderWith(function (data, type) {
                return data.collectedDate ? moment(data.collectedDate).format($rootScope.dateFormat) : ' - ';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').notSortable().renderWith(function (data, type, full) {
                return getStatusStyle(data.rcUploadStatus);
            }),
        ];

        function search() {
            vm.dtInstance.reloadData();
        }

        function getStatusStyle(status) {

            switch (status) {
                case 'PENDING': {
                    return GUIUtils.getStatusTemplate(status, "primary")
                }
                case 'ERROR': {
                    return GUIUtils.getStatusTemplate(status, "danger")
                }
                case 'COMPLETED': {
                    return GUIUtils.getStatusTemplate(status, "success")
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProtocolGroupDialogController', ProtocolGroupDialogController);

    ProtocolGroupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProtocolGroup'];

    function ProtocolGroupDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProtocolGroup) {
        var vm = this;

        vm.protocolGroup = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.protocolGroup.id !== null) {
                ProtocolGroup.update(vm.protocolGroup, onSaveSuccess, onSaveError);
            } else {
                ProtocolGroup.save(vm.protocolGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:protocolGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProtocolGroup', ProtocolGroup);

    ProtocolGroup.$inject = ['$resource'];

    function ProtocolGroup ($resource) {
        var resourceUrl =  'api/protocol-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/protocol-groups/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('protocol-group', {
                parent: 'entity',
                url: '/protocol-group',
                data: {
                    authorities: [],
                    pageTitle: 'ProtocolGroups'
                },
                ncyBreadcrumb: {
                    label: 'ProtocolGroup'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/protocol-group/list/protocol-group.html',
                        controller: 'ProtocolGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProtocolGroupController', ProtocolGroupController);

    ProtocolGroupController.$inject = ['GenericEntityDatatableService', 'ProtocolGroup', 'CoreService',
        '$q', '$uibModal', 'ConfirmationService'];

    function ProtocolGroupController(GenericEntityDatatableService, ProtocolGroup, CoreService,
                                     $q, $uibModal, ConfirmationService) {

        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Protocol Group',
            newButtonTitle: 'New Protocol Group',
            entityClassHumanized: 'Protocol Group',
            entityStateName: 'protocol-group',
            service: ProtocolGroup,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Protocol Group',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/protocol-group/update/protocol-group-dialog.html',
                controller: 'ProtocolGroupDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/protocol-group/update/protocol-group-dialog.html',
                controller: 'ProtocolGroupDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ProtocolGroup', function(ProtocolGroup) {
                        return ProtocolGroup.get({id : id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Protocol Group').result.then(function () {
                    ProtocolGroup.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProtocolNewDialogController', ProtocolNewDialogController);

    ProtocolNewDialogController.$inject = ['$uibModalInstance', 'protocol', 'MedicationSearch', 'Route', 'PatientMedication',
        'CoreService', 'Relational', 'DoseForm', 'Protocol', '$scope', 'ProtocolGroup',
        'RATIONALE_TYPE'];

    function ProtocolNewDialogController($uibModalInstance, protocol, MedicationSearch, Route, PatientMedication,
                                         CoreService, Relational, DoseForm, Protocol, $scope, ProtocolGroup,
                                         RATIONALE_TYPE) {
        var vm = this;

        vm.protocol = protocol;
        vm.relationals = Relational.findAllByFilter(getFilterByCorporationAndType());
        vm.doseForms = DoseForm.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.routes = Route.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.frequencies = PatientMedication.getAllMedicationFrequency();
        vm.protocolGroup = ProtocolGroup.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

        vm.clear = clear;
        vm.getMedications = getMedications;
        vm.save = save;
        vm.addDay = addDay;
        vm.changeCategory = changeCategory;
        vm.changeFrequency = changeFrequency;
        vm.deleteDay = deleteDay;

        init();

        function init() {
            _.sortBy(vm.protocol.protocolFrequencies, 'xorder');
        }

        function save() {
            vm.isSaving = true;

            var data = angular.copy(vm.protocol);

            _.forEach(data.protocolFrequencies, function (frequency) {
                _.forEach(frequency.schedules, function (schedule) {
                    schedule.date = moment(schedule.date).format('YYYY-MM-DDTHH:mm:00');
                });
            });

            if (vm.protocol.id !== null) {
                Protocol.update(data, onSaveSuccess, onSaveError);
            } else {
                Protocol.save(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:protocolUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getMedications(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);
                vm.medications = MedicationSearch.query({
                    query: query
                });
            }
        }

        function addDay() {
            vm.protocol.protocolFrequencies.push({
                frequency: null,
                xorder: vm.protocol.protocolFrequencies.length,
                isCollapsed: false
            });

            vm.protocol.durationDays = vm.protocol.protocolFrequencies.length;
        }

        function changeCategory() {
            vm.protocol.protocolFrequencies = [];

            switch (vm.protocol.type) {
                case 'AS_NEEDED':
                case 'CONSISTENT_DOSE': {
                    addDay();

                    break;
                }
                case 'TAPER': {
                    addDay();
                    vm.protocol.durationDays = vm.protocol.protocolFrequencies.length;

                    break;
                }
            }
        }

        function changeFrequency(frequency) {
            frequency.schedules = [];
            frequency.hideDay = false;

            switch (frequency.frequency.id) {
                case 'EVERY_H':
                case 'EVERY_2H':
                case 'EVERY_3H':
                case 'EVERY_4H':
                case 'EVERY_6H':
                case 'EVERY_8H':
                case 'EVERY_12H':
                case 'EVERY_24H':
                case 'EVERY_48H':
                case 'EVERY_WEEK':
                case 'EVERY_TWO_WEEKS':
                case 'EVERY_MONTH': {
                    frequency.hideDay = true;
                    scheduleTakesIntervals(frequency, 1, 0, 1);

                    break;
                }
                case 'ONE_AM': {
                    scheduleTakesIntervals(frequency, 1, 0, 9);

                    break;
                }
                case 'ONE_HS': {
                    scheduleTakesIntervals(frequency, 1, 0, 21);

                    break;
                }
                case 'BID': {
                    scheduleTakesIntervals(frequency, 2, 12, 9);

                    break;
                }
                case 'TID': {
                    scheduleTakesIntervals(frequency, 3, 6, 9);

                    break;
                }
                case 'QID': {
                    scheduleTakesIntervals(frequency, 4, 3, 9);

                    break;
                }
                case 'SID': {
                    scheduleTakesIntervals(frequency, 6, 4, 2);

                    break;
                }
                case 'ONCE': {
                    scheduleTakesIntervals(frequency, 1, 0, 15);

                    break;
                }
                case 'STAT': {
                    frequency.schedules.push({
                        xorder: 0,
                        strength: null,
                        date: moment().startOf('minute').toDate()
                    });

                    break;
                }
            }
        }

        function scheduleTakesIntervals(frequency, count, hours, firstHour) {
            var first = moment().startOf('hour').toDate();
            first.setHours(firstHour);

            for (var i = 0; i < count; i++) {
                frequency.schedules.push({
                    xorder: i,
                    date: angular.copy(first),
                    strength: null
                });

                first.setHours(first.getHours() + hours);
            }
        }

        function deleteDay(index) {
            vm.protocol.protocolFrequencies.splice(index, 1);

            _.forEach(vm.protocol.protocolFrequencies, function (frequency, index) {
                frequency.xorder = index;
            })
        }

        function getFilterByCorporationAndType() {
            var filter = {};

            filter.corporationId = CoreService.getCorporation().id;
            filter.relationalType = RATIONALE_TYPE.MEDICATION;

            return filter
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Protocol', Protocol);

    Protocol.$inject = ['$resource'];

    function Protocol($resource) {
        var resourceUrl = 'api/protocols/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        data.protocolFrequencies = _.sortBy(data.protocolFrequencies, 'xorder');

                        _.forEach(data.protocolFrequencies, function (frequency) {

                            frequency.schedules = _.sortBy(frequency.schedules, 'xorder');

                            _.forEach(frequency.schedules, function (schedule) {
                                schedule.date = moment(schedule.date).toDate();
                            });

                            frequency.hideDay = false;

                            switch (frequency.frequency.id) {
                                case 'EVERY_H':
                                case 'EVERY_2H':
                                case 'EVERY_3H':
                                case 'EVERY_4H':
                                case 'EVERY_6H':
                                case 'EVERY_8H':
                                case 'EVERY_12H':
                                case 'EVERY_24H':
                                case 'EVERY_48H':
                                case 'EVERY_WEEK':
                                case 'EVERY_TWO_WEEKS':
                                case 'EVERY_MONTH': {
                                    frequency.hideDay = true;

                                    break;
                                }
                            }
                        })
                    }

                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByFilter': {url: 'api/protocols/filter', method: 'GET', isArray: true},
            'clone': {url: 'api/protocols/clone/:id', method: 'GET'},
            'findAll': {
                url: 'api/protocols/find-all', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        _.forEach(data, function (protocol) {
                            protocol.protocolFrequencies = _.sortBy(protocol.protocolFrequencies, 'xorder');

                            _.forEach(protocol.protocolFrequencies, function (frequency) {
                                frequency.schedules = _.sortBy(frequency.schedules, 'xorder');

                                _.forEach(frequency.schedules, function (schedule) {
                                    schedule.date = moment(schedule.date).toDate();
                                })

                                frequency.hideDay = false;

                                switch (frequency.frequency.id) {
                                    case 'EVERY_H':
                                    case 'EVERY_2H':
                                    case 'EVERY_3H':
                                    case 'EVERY_4H':
                                    case 'EVERY_6H':
                                    case 'EVERY_8H':
                                    case 'EVERY_12H':
                                    case 'EVERY_24H':
                                    case 'EVERY_48H':
                                    case 'EVERY_WEEK':
                                    case 'EVERY_TWO_WEEKS':
                                    case 'EVERY_MONTH': {
                                        frequency.hideDay = true;

                                        break;
                                    }
                                }
                            })
                        });
                    }

                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('protocol', {
                parent: 'entity',
                url: '/protocol',
                data: {
                    authorities: [],
                    pageTitle: 'Protocols'
                },
                ncyBreadcrumb: {
                    label: 'Protocols'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/protocol/list/protocol.html',
                        controller: 'ProtocolController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE, access);
                }]
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProtocolController', ProtocolController);

    ProtocolController.$inject = ['GenericEntityDatatableService', '$uibModal', '$q', 'Protocol',
                                   'CoreService', 'GUIUtils', 'toastr', 'ConfirmationService'];

    function ProtocolController(GenericEntityDatatableService, $uibModal, $q, Protocol,
                                CoreService, GUIUtils, toastr, ConfirmationService) {
        var vm = this;


        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Protocols',
            entityClassHumanized: 'Protocols',
            entityStateName: 'protocol',
            service: Protocol,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'type',
                    title: 'Type',
                },
                {
                    name: 'protocolGroupName',
                    title: 'Group',
                },
                {
                    name: 'durationDays',
                    title: 'Duration Days',
                },
                {
                    name: 'refills',
                    title: 'Refills',
                },
                {
                    name: 'dispense',
                    title: 'Dispense',
                },
                {
                    name: 'medicationName',
                    title: 'Medication',
                },
                {
                    name: 'routeName',
                    title: 'Route',
                },
                {
                    name: 'doseFormName',
                    title: 'Dose Form',
                },
                {
                    name: null,
                    title: 'Enable',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enable);
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getCloneAction(), {
                    action: function (data) {
                        return clone(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Protocol',
                            action: function () {
                                return add();
                            }
                        }),
                    ],
                },
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/protocol/update/protocol-dialog.html',
                    controller: 'ProtocolNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        protocol: ['CoreService', function (CoreService) {

                            return {
                                name: null,
                                enable: true,
                                type: null,
                                durationDays: null,
                                refills: null,
                                dispense: null,
                                instructions: null,
                                facility: CoreService.getCurrentFacility(),
                                medication: null,
                                route: null,
                                doseForm: null,
                                relationals: [],
                                protocolFrequencies: [],
                            };
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/protocol/update/protocol-dialog.html',
                    controller: 'ProtocolNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        protocol: ['Protocol', function (Protocol) {
                            return Protocol.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function clone(id) {
            return $q(function (resolve) {
                ConfirmationService.open({
                    title: 'Clone Protocol',
                    message: 'This action is will <strong>clone</strong> this Protocol. Are you sure you want to <strong>clone</strong> this Protocol?',
                    actions: [
                        {
                            name: 'Clone',
                            color: 'btn btn-success',
                            icon: 'fa fa-times-circle-o',
                            value: 'SUCCESS'
                        },
                        {
                            name: 'Cancel',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                }).result.then(function () {
                    Protocol.clone({id: id}, function (result) {
                        toastr.success("Protocol have been cloned");
                        resolve();
                    }, function () {
                        toastr.error("Error cloning the protocol");
                        resolve();
                    });
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Protocol').result.then(function () {
                    Protocol.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgMedicationDialogController', ProgMedicationDialogController);

    ProgMedicationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgMedication', 'Corporation', 'MedicationSearch'];

    function ProgMedicationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgMedication, Corporation, MedicationSearch) {
        var vm = this;

        vm.progMedication = entity;
        vm.medications = [];

        vm.clear = clear;
        vm.save = save;
        vm.getMedications = getMedications;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.progMedication.id !== null) {
                ProgMedication.update(vm.progMedication, onSaveSuccess, onSaveError);
            } else {
                ProgMedication.save(vm.progMedication, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:progMedicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getMedications(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);
                vm.medications = MedicationSearch.query({
                    query: query
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgMedicationDeleteController',ProgMedicationDeleteController);

    ProgMedicationDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgMedication'];

    function ProgMedicationDeleteController($uibModalInstance, entity, ProgMedication) {
        var vm = this;

        vm.progMedication = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgMedication.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-medication', {
            parent: 'entity',
            url: '/prog-medication',
            data: {
                authorities: [],
                pageTitle: 'ProgMedications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-medication/prog-medications.html',
                    controller: 'ProgMedicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access);
            }]
        })
        .state('prog-medication.new', {
            parent: 'prog-medication',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-medication/prog-medication-dialog.html',
                        controller: 'ProgMedicationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-medication', null, {reload: 'prog-medication'});
                    }, function () {
                        $state.go('prog-medication');
                    });
                }
            }]
        })
        .state('prog-medication.edit', {
            parent: 'prog-medication',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-medication/prog-medication-dialog.html',
                        controller: 'ProgMedicationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['ProgMedication', function (ProgMedication) {
                                return ProgMedication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-medication', null, {reload: 'prog-medication'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-medication.delete', {
            parent: 'prog-medication',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-medication/prog-medication-delete-dialog.html',
                        controller: 'ProgMedicationDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['ProgMedication', function (ProgMedication) {
                                return ProgMedication.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-medication', null, {reload: 'prog-medication'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgMedication', ProgMedication);

    ProgMedication.$inject = ['$resource'];

    function ProgMedication ($resource) {
        var resourceUrl =  'api/prog-medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/prog-medications/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProgMedicationSearch', ProgMedicationSearch);

    ProgMedicationSearch.$inject = ['$resource'];

    function ProgMedicationSearch($resource) {
        var resourceUrl =  'api/_search/prog-medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgMedicationController', ProgMedicationController);

    ProgMedicationController.$inject = ['$scope', '$state', 'ProgMedication', 'CoreService',
        'DTColumnBuilder', 'DTOptionsBuilder', '$q', '$compile', '$filter'];

    function ProgMedicationController ($scope, $state, ProgMedication, CoreService,
                                       DTColumnBuilder, DTOptionsBuilder, $q, $compile, $filter ) {
        var vm = this;

        vm.progMedications = [];
        vm.dtInstance = {};
        vm.title = 'Program Eligibility Medication';
        vm.entityClassHumanized = 'Program Eligibility Medication';
        vm.entityStateName = 'prog-medication';
        vm.corporation = CoreService.getCorporation();
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();

            if (!vm.searchQuery || vm.searchQuery == '') {
                ProgMedication.findAllByFilter({
                    corporationId: vm.corporation.id
                }, function (result) {
                    vm.progMedications = result;
                    defer.resolve(vm.progMedications);
                });
            }else {
                defer.resolve($filter('filter')(vm.progMedications, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [0, 'asc'])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Medication').renderWith(function (data, type, full) {
                return data.medication == null ? " " : data.medication.name;
            }),

            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligFacilityDialogController', ProgEligFacilityDialogController);

    ProgEligFacilityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgEligFacility'];

    function ProgEligFacilityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgEligFacility) {
        var vm = this;

        vm.progEligFacility = entity;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};
        vm.openCalendar = openCalendar;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.progEligFacility.id !== null) {
                ProgEligFacility.update(vm.progEligFacility, onSaveSuccess, onSaveError);
            } else {
                ProgEligFacility.save(vm.progEligFacility, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:progEligFacilityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.progEligFacility.startDate;
        }

        function validateStartDate(){
            vm.startDateOptions.maxDate = vm.progEligFacility.endDate;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligFacilityDeleteController',ProgEligFacilityDeleteController);

    ProgEligFacilityDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgEligFacility'];

    function ProgEligFacilityDeleteController($uibModalInstance, entity, ProgEligFacility) {
        var vm = this;

        vm.progEligFacility = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgEligFacility.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-elig-facility', {
            parent: 'entity',
            url: '/prog-elig-facility',
            data: {
                authorities: [],
                pageTitle: 'ProgEligFacilities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-elig-facility/prog-elig-facilities.html',
                    controller: 'ProgEligFacilityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access);
                }]
            }
        })
        .state('prog-elig-facility.new', {
            parent: 'prog-elig-facility',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-facility/prog-elig-facility-dialog.html',
                        controller: 'ProgEligFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    id: null,
                                    facility: CoreService.getCurrentFacility()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-facility', null, {reload: 'prog-elig-facility'});
                    }, function () {
                        $state.go('prog-elig-facility');
                    });
                }
            }]
        })
        .state('prog-elig-facility.edit', {
            parent: 'prog-elig-facility',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-facility/prog-elig-facility-dialog.html',
                        controller: 'ProgEligFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['ProgEligFacility', function (ProgEligFacility) {
                                return ProgEligFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-facility', null, {reload: 'prog-elig-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-elig-facility.delete', {
            parent: 'prog-elig-facility',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-facility/prog-elig-facility-delete-dialog.html',
                        controller: 'ProgEligFacilityDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['ProgEligFacility', function (ProgEligFacility) {
                                return ProgEligFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-facility', null, {reload: 'prog-elig-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgEligFacility', ProgEligFacility);

    ProgEligFacility.$inject = ['$resource', 'DateUtils'];

    function ProgEligFacility ($resource, DateUtils) {
        var resourceUrl =  'api/prog-elig-facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method:'PUT'
            },
           'findAllByFilter': {
                url: 'api/prog-elig-facilities/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligFacilityController', ProgEligFacilityController);

    ProgEligFacilityController.$inject = ['$scope', '$state', 'ProgEligFacility', 'CoreService', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$q', '$compile'];

    function ProgEligFacilityController ($scope, $state, ProgEligFacility, CoreService, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $q, $compile) {
        var vm = this;

        vm.progEligFacilities = [];
        vm.dtInstance = {};
        vm.title = 'Facility Program Eligibility';
        vm.entityClassHumanized = 'Facility Program Eligibility';
        vm.entityStateName = 'prog-elig-facility';
        vm.facility = CoreService.getCurrentFacility();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            ProgEligFacility.findAllByFilter({
                facilityId: vm.facility.id,
                searchQuery: vm.searchQuery,
            }, function (result) {
                vm.progEligFacilities = result;
                defer.resolve(vm.progEligFacilities);
            });
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligEmployeeDialogController', ProgEligEmployeeDialogController);

    ProgEligEmployeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgEligEmployee', 'Employee', 'CoreService'];

    function ProgEligEmployeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgEligEmployee, Employee, CoreService) {
        var vm = this;

        vm.progEligEmployee = entity;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};
        vm.openCalendar = openCalendar;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.getEmployee = getEmployee;
        vm.corporation = CoreService.getCorporation();

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.progEligEmployee.id !== null) {
                ProgEligEmployee.update(vm.progEligEmployee, onSaveSuccess, onSaveError);
            } else {
                ProgEligEmployee.save(vm.progEligEmployee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:progEligEmployeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.progEligEmployee.startDate;
        }

        function validateStartDate(){
            vm.startDateOptions.maxDate = vm.progEligEmployee.endDate;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getEmployee(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.corporation.id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligEmployeeDeleteController',ProgEligEmployeeDeleteController);

    ProgEligEmployeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgEligEmployee'];

    function ProgEligEmployeeDeleteController($uibModalInstance, entity, ProgEligEmployee) {
        var vm = this;

        vm.progEligEmployee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgEligEmployee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-elig-employee', {
            parent: 'entity',
            url: '/prog-elig-employee',
            data: {
                authorities: [],
                pageTitle: 'ProgEligEmployees'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-elig-employee/prog-elig-employees.html',
                    controller: 'ProgEligEmployeeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY, access);
            }]
        })
        .state('prog-elig-employee.new', {
            parent: 'prog-elig-employee',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-employee/prog-elig-employee-dialog.html',
                        controller: 'ProgEligEmployeeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    employee: null,
                                    corporation: CoreService.getCorporation(),
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-employee', null, {reload: 'prog-elig-employee'});
                    }, function () {
                        $state.go('prog-elig-employee');
                    });
                }
            }]
        })
        .state('prog-elig-employee.edit', {
            parent: 'prog-elig-employee',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-employee/prog-elig-employee-dialog.html',
                        controller: 'ProgEligEmployeeDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['ProgEligEmployee', function (ProgEligEmployee) {
                                return ProgEligEmployee.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-employee', null, {reload: 'prog-elig-employee'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-elig-employee.delete', {
            parent: 'prog-elig-employee',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-employee/prog-elig-employee-delete-dialog.html',
                        controller: 'ProgEligEmployeeDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['ProgEligEmployee', function (ProgEligEmployee) {
                                return ProgEligEmployee.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-employee', null, {reload: 'prog-elig-employee'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgEligEmployee', ProgEligEmployee);

    ProgEligEmployee.$inject = ['$resource', 'DateUtils'];

    function ProgEligEmployee ($resource, DateUtils) {
        var resourceUrl =  'api/prog-elig-employees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/prog-elig-employees/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                },
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligEmployeeController', ProgEligEmployeeController);

    ProgEligEmployeeController.$inject = ['$scope', '$state', 'ProgEligEmployee', 'CoreService', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$q', '$compile'];

    function ProgEligEmployeeController ($scope, $state, ProgEligEmployee, CoreService, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $q, $compile) {
        var vm = this;

        vm.progEligEmployees = [];
        vm.dtInstance = {};
        vm.title = 'Employee Program Eligibility';
        vm.entityClassHumanized = 'Employee Program Eligibility';
        vm.entityStateName = 'prog-elig-employee';
        vm.corporation = CoreService.getCorporation();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            ProgEligEmployee.findAllByFilter({
                corporationId: vm.corporation.id,
                searchQuery: vm.searchQuery,
            }, function (result) {
                vm.progEligEmployees = result;
                defer.resolve(vm.progEligEmployees);
            });
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Employee').renderWith(function (data, type, full) {
                return data.employee.firstName + ' ' + data.employee.lastName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligCorpDialogController', ProgEligCorpDialogController);

    ProgEligCorpDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProgEligCorp', 'Corporation'];

    function ProgEligCorpDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProgEligCorp, Corporation) {
        var vm = this;

        vm.progEligCorp = entity;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};
        vm.openCalendar = openCalendar;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.progEligCorp.id !== null) {
                ProgEligCorp.update(vm.progEligCorp, onSaveSuccess, onSaveError);
            } else {
                ProgEligCorp.save(vm.progEligCorp, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:progEligCorpUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.progEligCorp.startDate;
        }

        function validateStartDate(){
            vm.startDateOptions.maxDate = vm.progEligCorp.endDate;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligCorpDeleteController',ProgEligCorpDeleteController);

    ProgEligCorpDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProgEligCorp'];

    function ProgEligCorpDeleteController($uibModalInstance, entity, ProgEligCorp) {
        var vm = this;

        vm.progEligCorp = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProgEligCorp.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('prog-elig-corp', {
            parent: 'entity',
            url: '/prog-elig-corp',
            data: {
                authorities: [],
                pageTitle: 'ProgEligCorps'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/prog-elig-corp/prog-elig-corps.html',
                    controller: 'ProgEligCorpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access);
            }]
        })
        .state('prog-elig-corp.new', {
            parent: 'prog-elig-corp',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-corp/prog-elig-corp-dialog.html',
                        controller: 'ProgEligCorpDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-corp', null, {reload: 'prog-elig-corp'});
                    }, function () {
                        $state.go('prog-elig-corp');
                    });
                }
            }]
        })
        .state('prog-elig-corp.edit', {
            parent: 'prog-elig-corp',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-corp/prog-elig-corp-dialog.html',
                        controller: 'ProgEligCorpDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['ProgEligCorp', function (ProgEligCorp) {
                                return ProgEligCorp.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-corp', null, {reload: 'prog-elig-corp'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('prog-elig-corp.delete', {
            parent: 'prog-elig-corp',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/prog-elig-corp/prog-elig-corp-delete-dialog.html',
                        controller: 'ProgEligCorpDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['ProgEligCorp', function (ProgEligCorp) {
                                return ProgEligCorp.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('prog-elig-corp', null, {reload: 'prog-elig-corp'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProgEligCorp', ProgEligCorp);

    ProgEligCorp.$inject = ['$resource', 'DateUtils'];

    function ProgEligCorp ($resource, DateUtils) {
        var resourceUrl =  'api/prog-elig-corps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
           'findAllByFilter': {
                url: 'api/prog-elig-corps/filter',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                },
                isArray: true
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProgEligCorpController', ProgEligCorpController);

    ProgEligCorpController.$inject = ['$scope', '$state', 'ProgEligCorp', 'CoreService', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$q', '$compile'];

    function ProgEligCorpController ($scope, $state, ProgEligCorp, CoreService, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $q, $compile) {
        var vm = this;

        vm.progEligCorps = [];
        vm.dtInstance = {};
        vm.title = 'Corporation Program Eligibility';
        vm.entityClassHumanized = 'Corporation Program Eligibility';
        vm.entityStateName = 'prog-elig-corp';
        vm.corporation = CoreService.getCorporation();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            ProgEligCorp.findAllByFilter({
                corporationId: vm.corporation.id,
                searchQuery: vm.searchQuery,
            }, function (result) {
                vm.progEligCorps = result;
                defer.resolve(vm.progEligCorps);
            });
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('End Date').renderWith(function (data, type, full) {
                return moment(data.endDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }










})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcessedSchedulerItem', ProcessedSchedulerItem);

    ProcessedSchedulerItem.$inject = ['$resource', 'DataUtils'];

    function ProcessedSchedulerItem ($resource, DataUtils) {
        var resourceUrl =  'api/processed-scheduler-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'findAllByFilter': {url: 'api/processed-scheduler-items/filter', method: 'GET', isArray: true},
            'savePendingPatientOrder': {url: 'api/processed-scheduler-items/pending-patient-order', method: 'POST'},
            'download': {
                url: 'api/processed-scheduler-items/download/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('processed-scheduler-item', {
                parent: 'entity',
                url: '/processed-scheduler-item',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Processed Patient Orders'
                },
                ncyBreadcrumb: {
                    label: 'Processed Scheduler Item'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/processed-scheduler-item/list/processed-scheduler-item.html',
                        controller: 'ProcessedSchedulerItemController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcessedSchedulerItemController', ProcessedSchedulerItemController);

    ProcessedSchedulerItemController.$inject = ['ProcessedSchedulerItem', 'CoreService',
        'GenericEntityDatatableService', 'Chart', 'Corporation', 'toastr', '$rootScope'];

    function ProcessedSchedulerItemController(ProcessedSchedulerItem, CoreService,
                                              GenericEntityDatatableService, Chart, Corporation, toastr, $rootScope) {
        var vm = this;

        var params = {
        }

        var entityStateName = 'processed-scheduler-item'

        vm.descriptor = {
            title: 'Processed Patient Orders',
            entityClassHumanized: 'ProcessedSchedulerItem',
            entityStateName: entityStateName,
            service: ProcessedSchedulerItem,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'barcode',
                    title: 'Barcode'
                },
                {
                    name: 'chartId',
                    title: 'Chart',
                    render: function (entity) {
                        return entity.chart ?
                            entity.chart.firstName + " " +
                            (entity.chart.middleName ? entity.chart.middleName + ' ' : '') +
                            entity.chart.lastName : ""
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo',
                    render: function (entity) {
                        return entity.chart ? entity.chart.mrNo : ''
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
                {
                    title: 'Patient Order',
                    name: 'patientOrder',
                    render: function (entity) {
                        return entity.patientOrder ? entity.patientOrder.id : ""
                    }
                },
                {
                    name: 'logStatus',
                    title: 'Log Status',
                    render: function (data) {
                        if (data.logStatus === 'FAIL') {
                            return "<small class='label label-danger'>" + data.logStatus + "</small>";
                        } else {
                            return data.logStatus;
                        }
                    }
                },
                {
                    name: 'createdDate',
                    title: 'Created Date',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
                {
                    name: 'filePath',
                    title: 'File'
                },
                {
                    name: 'errorMessage',
                    title: 'Error Message'
                },
                {
                    name: 'txStatus',
                    title: 'Tx Status'
                },
                {
                    name: 'txAttempts',
                    title: 'Tx Attempts'
                },
                {
                    name: 'lastAttempt',
                    title: 'Last Attempt',
                    render: function (data) {
                        return moment(data.lastAttempt).format($rootScope.amDateFormat);
                    }
                },
                {
                    name: 'txErrorMessage',
                    title: 'Tx Error Message'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getCloneAction(), {
                    name: 'Download HL7 file',
                    action: function (data) {
                        download(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                    name: 'Add to pendingPatientOrder again',
                    action: function (data) {
                        return addPendingPatientOrder(data.barcode);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'barcode',
                    placeholder: 'Barcode...',
                    type: 'string'
                },
                {
                    name: 'corporationId',
                    read: function (filter) {
                        return filter.corporationId ? filter.corporationId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        Corporation.query(function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Corporation ...',
                    type: 'select',
                },
                {
                    name: 'logStatus',
                    placeholder: 'Log Status...',
                    type: 'select',
                    values: [
                        'SUCCESS', 'FAIL', 'FILE_ERROR'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
            ]
        }

        function addPendingPatientOrder(barcode) {
            ProcessedSchedulerItem.savePendingPatientOrder({groupNumberId: barcode})
            toastr.success('The ProcessedSchedulerItem was added to Pending Patient Order', 'Success');
        }

        function download(id) {
            ProcessedSchedulerItem.download({id: id});
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcessedPatientResult', ProcessedPatientResult);

    ProcessedPatientResult.$inject = ['$resource', 'DataUtils'];

    function ProcessedPatientResult ($resource, DataUtils) {
        var resourceUrl =  'api/processed-patient-results/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/processed-patient-results/filter'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'download': {
                url: 'api/processed-patient-results/download/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('processed-patient-result', {
                parent: 'entity',
                url: '/processed-patient-result',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Processed Patient Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/processed-patient-result/list/processed-patient-result.html',
                        controller: 'ProcessedPatientResultController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcessedPatientResultController', ProcessedPatientResultController);

    ProcessedPatientResultController.$inject = ['GenericEntityDatatableService', 'CoreService', '$rootScope',
        'ProcessedPatientResult', 'GUIUtils', 'Corporation', 'PatientResult',
        'Laboratory'];

    function ProcessedPatientResultController(GenericEntityDatatableService, CoreService, $rootScope,
                                              ProcessedPatientResult, GUIUtils, Corporation, PatientResult,
                                              Laboratory) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id,
        }

        vm.descriptor = {
            title: 'Processed Patient Results',
            newButtonTitle: 'New Processed Patient Result',
            entityClassHumanized: 'Processed Patient Results',
            entityStateName: 'processed-patient-result',
            service: ProcessedPatientResult,
            serviceMethod: 'query',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'barcode',
                    title: 'Barcode'
                },
                {
                    name: 'chartId',
                    title: 'Chart',
                    render: function (entity) {
                        return entity.chart ?
                            entity.chart.firstName + " " +
                            (entity.chart.middleName ? entity.chart.middleName + ' ' : '') +
                            entity.chart.lastName : ""
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo',
                    render: function (entity) {
                        return entity.chart ? entity.chart.mrNo : ''
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
                {
                    name: 'patientResultId',
                    title: 'Patient Result',
                },
                {
                    name: 'patientOrderId',
                    title: 'Patient Order',
                },
                {
                    name: 'logStatus',
                    title: 'Log Status',
                    render: function (data) {
                        if (data.logStatus === 'SUCCESS') {
                            return data.logStatus;
                        } else {
                            return "<small class='label label-danger'>" + data.logStatus + "</small>";
                        }
                    }
                },
                {
                    name: 'originalFileName',
                    title: 'File',
                },
                {
                    name: 'createdDate',
                    title: 'Created Date',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getCloneAction(), {
                    name: 'Download HL7 file',
                    action: function (data) {
                        download(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    name: 'Download Embedded PDF',
                    action: function (data) {
                        downloadEmbedded(data);
                    },
                })
            ],
            filters: [
                {
                    name: 'barcode',
                    placeholder: 'Barcode...',
                    type: 'string'
                },
                {
                    name: 'corporationId',
                    read: function (filter) {
                        return filter.corporationId ? filter.corporationId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        Corporation.query(function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Corporation ...',
                    type: 'select',
                },
                {
                    name: 'logStatus',
                    placeholder: 'Log Status...',
                    type: 'select',
                    values: [
                        'SUCCESS', 'FAIL', 'FILE_ERROR'
                    ],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ]
        }

        function download(id) {
            ProcessedPatientResult.download({id: id});
        }

        function downloadEmbedded(data) {
            PatientResult.getAllInOneRangePdf({ids: [data.patientResultId]});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureModifierDialogController', ProcedureModifierDialogController);

    ProcedureModifierDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProcedureModifier', 'Procedure', 'Modifier'];

    function ProcedureModifierDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProcedureModifier, Procedure, Modifier) {
        var vm = this;

        vm.procedureModifier = entity;
        vm.clear = clear;
        vm.save = save;
        vm.procedures = Procedure.query();
        vm.modifiers = Modifier.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.procedureModifier.id !== null) {
                ProcedureModifier.update(vm.procedureModifier, onSaveSuccess, onSaveError);
            } else {
                ProcedureModifier.save(vm.procedureModifier, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:procedureModifierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureModifierDetailController', ProcedureModifierDetailController);

    ProcedureModifierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProcedureModifier', 'Procedure', 'Modifier'];

    function ProcedureModifierDetailController($scope, $rootScope, $stateParams, previousState, entity, ProcedureModifier, Procedure, Modifier) {
        var vm = this;

        vm.procedureModifier = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:procedureModifierUpdate', function(event, result) {
            vm.procedureModifier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureModifierDeleteController',ProcedureModifierDeleteController);

    ProcedureModifierDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProcedureModifier'];

    function ProcedureModifierDeleteController($uibModalInstance, entity, ProcedureModifier) {
        var vm = this;

        vm.procedureModifier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProcedureModifier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('procedure-modifier', {
            parent: 'entity',
            url: '/procedure-modifier',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ProcedureModifiers'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/procedure-modifier/procedure-modifiers.html',
                    controller: 'ProcedureModifierController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('procedure-modifier-detail', {
            parent: 'entity',
            url: '/procedure-modifier/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ProcedureModifier'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/procedure-modifier/procedure-modifier-detail.html',
                    controller: 'ProcedureModifierDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ProcedureModifier', function($stateParams, ProcedureModifier) {
                    return ProcedureModifier.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'procedure-modifier',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('procedure-modifier-detail.edit', {
            parent: 'procedure-modifier-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-modifier/procedure-modifier-dialog.html',
                    controller: 'ProcedureModifierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProcedureModifier', function(ProcedureModifier) {
                            return ProcedureModifier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('procedure-modifier.new', {
            parent: 'procedure-modifier',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-modifier/procedure-modifier-dialog.html',
                    controller: 'ProcedureModifierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('procedure-modifier', null, { reload: 'procedure-modifier' });
                }, function() {
                    $state.go('procedure-modifier');
                });
            }]
        })
        .state('procedure-modifier.edit', {
            parent: 'procedure-modifier',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-modifier/procedure-modifier-dialog.html',
                    controller: 'ProcedureModifierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProcedureModifier', function(ProcedureModifier) {
                            return ProcedureModifier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('procedure-modifier', null, { reload: 'procedure-modifier' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('procedure-modifier.delete', {
            parent: 'procedure-modifier',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-modifier/procedure-modifier-delete-dialog.html',
                    controller: 'ProcedureModifierDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProcedureModifier', function(ProcedureModifier) {
                            return ProcedureModifier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('procedure-modifier', null, { reload: 'procedure-modifier' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcedureModifier', ProcedureModifier);

    ProcedureModifier.$inject = ['$resource'];

    function ProcedureModifier ($resource) {
        var resourceUrl =  'api/procedure-modifiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByProcedure': {
                url: 'api/procedure-modifiers/procedure/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProcedureModifierSearch', ProcedureModifierSearch);

    ProcedureModifierSearch.$inject = ['$resource'];

    function ProcedureModifierSearch($resource) {
        var resourceUrl =  'api/_search/procedure-modifiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureModifierController', ProcedureModifierController);

    ProcedureModifierController.$inject = ['$scope', '$state', 'ProcedureModifier', 'ProcedureModifierSearch'];

    function ProcedureModifierController ($scope, $state, ProcedureModifier, ProcedureModifierSearch) {
        var vm = this;

        vm.procedureModifiers = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            ProcedureModifier.query(function(result) {
                vm.procedureModifiers = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            ProcedureModifierSearch.query({query: vm.searchQuery}, function(result) {
                vm.procedureModifiers = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDiagnosisDialogController', ProcedureDiagnosisDialogController);

    ProcedureDiagnosisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProcedureDiagnosis', 'Procedure', 'Icd10'];

    function ProcedureDiagnosisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProcedureDiagnosis, Procedure, Icd10) {
        var vm = this;

        vm.procedureDiagnosis = entity;
        vm.clear = clear;
        vm.save = save;
        vm.procedures = Procedure.query();
        vm.icd10s = Icd10.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.procedureDiagnosis.id !== null) {
                ProcedureDiagnosis.update(vm.procedureDiagnosis, onSaveSuccess, onSaveError);
            } else {
                ProcedureDiagnosis.save(vm.procedureDiagnosis, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:procedureDiagnosisUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDiagnosisDetailController', ProcedureDiagnosisDetailController);

    ProcedureDiagnosisDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProcedureDiagnosis', 'Procedure', 'Icd10'];

    function ProcedureDiagnosisDetailController($scope, $rootScope, $stateParams, previousState, entity, ProcedureDiagnosis, Procedure, Icd10) {
        var vm = this;

        vm.procedureDiagnosis = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:procedureDiagnosisUpdate', function(event, result) {
            vm.procedureDiagnosis = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDiagnosisDeleteController',ProcedureDiagnosisDeleteController);

    ProcedureDiagnosisDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProcedureDiagnosis'];

    function ProcedureDiagnosisDeleteController($uibModalInstance, entity, ProcedureDiagnosis) {
        var vm = this;

        vm.procedureDiagnosis = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProcedureDiagnosis.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('procedure-diagnosis', {
            parent: 'entity',
            url: '/procedure-diagnosis?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ProcedureDiagnoses'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnoses.html',
                    controller: 'ProcedureDiagnosisController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('procedure-diagnosis-detail', {
            parent: 'entity',
            url: '/procedure-diagnosis/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ProcedureDiagnosis'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-detail.html',
                    controller: 'ProcedureDiagnosisDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ProcedureDiagnosis', function($stateParams, ProcedureDiagnosis) {
                    return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'procedure-diagnosis',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('procedure-diagnosis-detail.edit', {
            parent: 'procedure-diagnosis-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html',
                    controller: 'ProcedureDiagnosisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProcedureDiagnosis', function(ProcedureDiagnosis) {
                            return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('procedure-diagnosis.new', {
            parent: 'procedure-diagnosis',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html',
                    controller: 'ProcedureDiagnosisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rank: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('procedure-diagnosis', null, { reload: 'procedure-diagnosis' });
                }, function() {
                    $state.go('procedure-diagnosis');
                });
            }]
        })
        .state('procedure-diagnosis.edit', {
            parent: 'procedure-diagnosis',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html',
                    controller: 'ProcedureDiagnosisDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProcedureDiagnosis', function(ProcedureDiagnosis) {
                            return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('procedure-diagnosis', null, { reload: 'procedure-diagnosis' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('procedure-diagnosis.delete', {
            parent: 'procedure-diagnosis',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/procedure-diagnosis/procedure-diagnosis-delete-dialog.html',
                    controller: 'ProcedureDiagnosisDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProcedureDiagnosis', function(ProcedureDiagnosis) {
                            return ProcedureDiagnosis.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('procedure-diagnosis', null, { reload: 'procedure-diagnosis' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProcedureDiagnosis', ProcedureDiagnosis);

    ProcedureDiagnosis.$inject = ['$resource'];

    function ProcedureDiagnosis($resource) {
        var resourceUrl = 'api/procedure-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByProcedure': {
                url: 'api/procedure-diagnoses/procedure/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ProcedureDiagnosisSearch', ProcedureDiagnosisSearch);

    ProcedureDiagnosisSearch.$inject = ['$resource'];

    function ProcedureDiagnosisSearch($resource) {
        var resourceUrl =  'api/_search/procedure-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDiagnosisController', ProcedureDiagnosisController);

    ProcedureDiagnosisController.$inject = ['$scope', '$state', 'ProcedureDiagnosis', 'ProcedureDiagnosisSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function ProcedureDiagnosisController ($scope, $state, ProcedureDiagnosis, ProcedureDiagnosisSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProcedureDiagnosisSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                ProcedureDiagnosis.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.procedureDiagnoses = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDialogController', ProcedureDialogController);

    ProcedureDialogController.$inject = ['$scope','$uibModalInstance', 'CoreService', 'Employee', 'entity', 'DateUtils',
        'Facility', 'CptSearch', 'dialogs', 'Procedure', 'ProcedureDiagnosis', 'ProcedureModifier', 'Diagnoses',
        'Icd10Search', 'ModifierSearch', 'Chart', 'ProClaimConf', 'SuperBill', 'RevCodeSearch', 'superBill'];

    function ProcedureDialogController($scope, $uibModalInstance, CoreService, Employee, entity, DateUtils,
                                       Facility, CptSearch, $dialogs, Procedure, ProcedureDiagnosis, ProcedureModifier,
                                       Diagnoses, Icd10Search, ModifierSearch, Chart, ProClaimConf, SuperBill, RevCodeSearch, superBill) {
        var vm = this;

        vm.procedure = entity;
        vm.superBill = superBill;
        vm.chart = null;
        vm.employees = Employee.byActive({id: CoreService.getCorporation().id});
        vm.icd10Selected = [];
        vm.icd10SearchQuery = '';
        vm.modifierSearchQuery = '';
        vm.modifierSelected = [];
        vm.lastsIcd10ByFacility = [];
        vm.lastsModifiersByFacility = [];
        vm.diagnoses = [];
        vm.modifiers = [];
        vm.showDeleteModifiers = false;
        vm.indexModifier = null;
        vm.indexDiagnose = null;
        vm.revCodes = [];

        vm.getCpts = getCpts;
        vm.selectCpt = selectCpt;
        vm.removeProcedureModifier = removeProcedureModifier;
        vm.removeProcedureDiagnoses = removeProcedureDiagnoses;
        vm.getCpts = getCpts;
        vm.renderIcd10 = renderIcd10;
        vm.getIcd10Options = getIcd10Options;
        vm.getIcd10FrequentlyOptions = getIcd10FrequentlyOptions;
        vm.onSelectModifier = onSelectModifier;
        vm.onSelectIcd10 = onSelectIcd10;
        vm.renderModifier = renderModifier;
        vm.getModifierOptions = getModifierOptions;
        vm.getModifierFrequentlyOptions = getModifierFrequentlyOptions;
        vm.onDragEnd = onDragEnd;
        vm.confirmDeleteModifier = confirmDeleteModifier;
        vm.confirmDeleteDiagnose = confirmDeleteDiagnose;
        vm.getRevCode = getRevCode;
        vm.selectRevCode = selectRevCode;
        vm.removeCpt = removeCpt;

        vm.save = save;
        vm.clear = clear;

        init();

        function init() {
            Chart.get({id: vm.superBill.chartId}, function (result) {
                vm.chart = result;
            });

            if(vm.procedure.id) {
                if (vm.superBill.billingType !== 'PROFESSIONAL') {
                    vm.revCode = vm.procedure.revCode;
                } else {
                    ProcedureDiagnosis.findAllByProcedure({id: vm.procedure.id}, function (procedureDiagnosis) {
                        vm.diagnoses = procedureDiagnosis;
                    });
                }
                ProcedureModifier.findAllByProcedure({id: vm.procedure.id}, function (procedureModifier) {
                    vm.modifiers = procedureModifier;
                });
            }
        }

        vm.icd10TabsConf = [
            {
                name: 'Search Results',
                icon: 'fa fa-list',
                func: getIcd10Options,
                options: []
            },
            {
                name: 'Frequently added',
                icon: 'fa fa-clock-o',
                func: getIcd10FrequentlyOptions,
                options: []
            }
        ];

        vm.modifierTabsConf = [
            {
                name: 'Search Results',
                icon: 'fa fa-list',
                func: getModifierOptions,
                options: []
            },
            {
                name: 'Frequently added',
                icon: 'fa fa-clock-o',
                func: getModifierFrequentlyOptions,
                options: []
            }
        ];

        function getCpts(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.cpts = CptSearch.query({query: query});
            }
        }

        function selectCpt(cpt) {
            vm.procedure.cpt = cpt;
        }

        function getRevCode(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.revCodes = RevCodeSearch.query({query: query});
            }
        }

        function selectRevCode(revCode) {
                vm.procedure.revCode = revCode;
        }

        function removeProcedureModifier(indexModifier) {
            vm.showDeleteModifiers = true;
            vm.indexModifier = indexModifier;
        }

        function confirmDeleteModifier(){
            if(vm.indexModifier!=null) {
                _.pullAt(vm.modifiers, vm.indexModifier);
                vm.showDeleteModifiers = false;
            }
        }

        function removeProcedureDiagnoses(indexDiagnoses) {
            vm.showDeleteDiagnose = true;
            vm.indexDiagnose = indexDiagnoses;
        }

        function confirmDeleteDiagnose(){
            if(vm.indexDiagnose!=null) {
                _.pullAt(vm.diagnoses, vm.indexDiagnose);
                vm.showDeleteDiagnose = false;
            }
        }

        function onSelectIcd10() {
            _.forEach(vm.icd10Selected, function (icd10) {
                if (!_.find(vm.diagnoses, function (o) {
                    return o.icd10.id === icd10.id;
                })) {
                    vm.diagnoses.push({
                        id: null,
                        icd10: icd10,
                        xorder: vm.diagnoses.length + 1
                    })
                }
            });
        }


        function onSelectModifier() {
            _.forEach(vm.modifierSelected, function (modifier) {
                if (!_.find(vm.modifiers, function (o) {
                    return o.modifier.id === modifier.id;
                })) {
                    vm.modifiers.push({
                        id: null,
                        modifier: modifier,
                        xorder: vm.modifiers.length + 1
                    })
                }
            });
        }

        function renderIcd10(element) {
            if (element) {
                return '<strong>' + element['code'] + '</strong> -' + element['description'];
            }
        }

        function getIcd10Options(searchQuery, tab) {
            if (searchQuery && searchQuery.length > 2 && searchQuery !== vm.icd10SearchQuery) {
                Icd10Search.query({query: searchQuery}, function (result) {
                    tab.options = result;
                    vm.icd10SearchQuery = searchQuery;
                });
            }
        }

        function getIcd10FrequentlyOptions(searchQuery, tab) {
            if (!vm.lastsIcd10ByFacility.length > 0) {
                Diagnoses.lastsIcd10UsedByFacility({facilityId: vm.chart.facilityId}, function (icd10s) {
                    vm.lastsIcd10ByFacility = icd10s;
                    tab.options = icd10s;
                });
            }
        }

        function renderModifier(element) {
            if (element) {
                return '<strong>' + element['code'] + '</strong> -' + element['shortDesc'];
            }
        }

        function getModifierOptions(searchQuery, tab) {
            if (searchQuery && searchQuery.length > 0 && searchQuery !== vm.modifierSearchQuery) {
                searchQuery = _.lowerCase(searchQuery);
                ModifierSearch.query({query: searchQuery}, function (result) {
                    tab.options = result;
                    vm.modifierSearchQuery = searchQuery;
                });
            }
        }

        function getModifierFrequentlyOptions(searchQuery, tab) {
            if (!vm.lastsModifiersByFacility.length > 0) {
                ProClaimConf.lastsModifiersUsedByFacility({facilityId: vm.chart.facilityId}, function (modifiers) {
                    vm.lastsModifiersByFacility = modifiers;
                    tab.options = modifiers;
                });
            }
        }
        function removeCpt() {
            vm.procedure.cpt = null;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function onDragEnd(list) {
            for (var i = 0; i < list.length; i++) {
                list[i].xorder = i + 1;
            }
        }

        function save () {
            vm.isSaving = true;

            if (!vm.procedure.id) {
                vm.procedure.superBill = vm.superBill;
            }

            if (vm.superBill.billingType !== 'PROFESSIONAL') {
                vm.procedure.unit = 'UNITS';
            }

            var procedure = {
                'procedure': vm.procedure,
                'diagnoses': vm.diagnoses,
                'modifiers': vm.modifiers
            };
            Procedure.updateProcedure(procedure, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:procedureUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

     }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProcedureDeleteController',ProcedureDeleteController);

    ProcedureDeleteController.$inject = ['$uibModalInstance', 'entity', 'Procedure'];

    function ProcedureDeleteController($uibModalInstance, entity, Procedure) {
        var vm = this;

        vm.procedure = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Procedure.deleteProcedure({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Procedure', Procedure);

    Procedure.$inject = ['$resource'];

    function Procedure ($resource) {
        var resourceUrl =  'api/procedures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getProcedures': {
                url: 'api/procedures/super-bill/:id',
                method: 'GET',
                isArray: true
            },
            'getCpts': {
                url: 'api/procedures/cpts/:id',
                method: 'GET',
                isArray: true
            },
            'updateProcedure': {method: 'POST', url: 'api/procedures/update-procedure'},
            'deleteProcedure': {method: 'DELETE', url: 'api/procedures/delete-procedure/:id'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProClaimConfDialogController', ProClaimConfDialogController);

    ProClaimConfDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'ProClaimConf', 'InsuranceCarrier', 'InsuranceCarrierSearch', 'TypeLevelCare', 'CoreService',
        'CptSearch', 'ModifierSearch'];

    function ProClaimConfDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                          ProClaimConf, InsuranceCarrier, InsuranceCarrierSearch,
                                          TypeLevelCare, CoreService, CptSearch, ModifierSearch) {
        var vm = this;

        vm.title = 'Professional Claim Configuration';
        vm.evaluationTemplate = entity.evaluationTemplate;
        vm.facility = entity.facility;
        vm.proClaimConfs = [entity];
        vm.insuranceCarriers = entity && entity.insuranceCarriers ? angular.copy(entity.insuranceCarriers) : [];
        vm.cpts = [];
        vm.typelevelcares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));

        vm.clear = clear;
        vm.save = save;
        vm.addConf = addConf;
        vm.deleteProClaimConf = deleteProClaimConf;
        vm.deleteProCptConf = deleteProCptConf;
        vm.addCpt = addCpt;
        vm.getInsuranceCarriers = getInsuranceCarriers;
        vm.getCpts = getCpts;
        vm.getModifiers = getModifiers;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.proClaimConfs.length == 1 && vm.proClaimConfs[0].id !== null) {
                ProClaimConf.update(vm.proClaimConfs[0], onSaveSuccess, onSaveError);
            } else {
                addNewProClaimConf();
            }
        }

        function addNewProClaimConf() {
            var proClaimConfProj = {
                proClaimConfs: [],
                facilityId: vm.facility.id,
                evaluationTemplateId: vm.evaluationTemplate.id
            };

            _.forEach(vm.proClaimConfs, function (proClaimConf, index) {
                var proClaimConfTmp = angular.copy(proClaimConf);

                var pcc = {
                    xorder: index,
                    minTime: proClaimConfTmp.minTime,
                    maxTime: proClaimConfTmp.maxTime,
                    isDefault: proClaimConfTmp.isDefault,
                    insuranceCarriers: proClaimConfTmp.insuranceCarriers,
                    levelOfCares: proClaimConfTmp.levelOfCares,
                    rate: proClaimConfTmp.rate,
                    quantity: proClaimConfTmp.quantity,
                    unit: proClaimConfTmp.unit,
                    proCptConfs: proClaimConfTmp.proCptConfs,
                };

                proClaimConfProj.proClaimConfs.push(pcc);
            });

            ProClaimConf.create(proClaimConfProj, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function addConf() {
            vm.proClaimConfs.push({
                collapsed: false,
                isDefault: false,
                proCptConfs: [{}]
            })
        }

        function addCpt(proClaimConf) {
            proClaimConf.proCptConfs.push({});
        }

        function deleteProClaimConf(index) {
            vm.proClaimConfs.splice(index, 1);
        }

        function deleteProCptConf(proClaimConf, index) {
            proClaimConf.proCptConfs.splice(index, 1);
        }

        function getInsuranceCarriers(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);

                vm.insuranceCarriers = InsuranceCarrierSearch.query({
                    query: query
                });
            }
        }

        function getCpts(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.cpts = CptSearch.query({query: query});
            }
        }

        function getModifiers(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.modifiers = ModifierSearch.query({query: query});
            }
        }
   }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProClaimConfDeleteController',ProClaimConfDeleteController);

    ProClaimConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProClaimConf'];

    function ProClaimConfDeleteController($uibModalInstance, entity, ProClaimConf) {
        var vm = this;

        vm.proClaimConf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProClaimConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pro-claim-conf', {
            parent: 'entity',
            url: '/pro-claim-conf',
            data: {
                authorities: [],
                pageTitle: 'ProClaimConfs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pro-claim-conf/pro-claim-confs.html',
                    controller: 'ProClaimConfController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access);
            }]
        })
        .state('pro-claim-conf.new', {
            parent: 'pro-claim-conf',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-dialog.html',
                        controller: 'ProClaimConfDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    minTime: null,
                                    maxTime: null,
                                    isDefault: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('pro-claim-conf', null, {reload: 'pro-claim-conf'});
                    }, function () {
                        $state.go('pro-claim-conf');
                    });
                }
            }]
        })
        .state('pro-claim-conf.edit', {
            parent: 'pro-claim-conf',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-dialog.html',
                        controller: 'ProClaimConfDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['ProClaimConf', function (ProClaimConf) {
                                return ProClaimConf.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('pro-claim-conf', null, {reload: 'pro-claim-conf'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('pro-claim-conf.delete', {
            parent: 'pro-claim-conf',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-delete-dialog.html',
                        controller: 'ProClaimConfDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ProClaimConf', function (ProClaimConf) {
                                return ProClaimConf.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('pro-claim-conf', null, {reload: 'pro-claim-conf'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ProClaimConf', ProClaimConf);

    ProClaimConf.$inject = ['$resource'];

    function ProClaimConf ($resource) {
        var resourceUrl =  'api/pro-claim-confs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'create': {url: 'api/pro-claim-confs/create', method: 'POST', isArray: false},
            'filter': {url: 'api/pro-claim-confs/filter', method: 'GET', isArray: true},
            'lastsModifiersUsedByFacility': {url: 'api/diagnoses/lasts-modifiers-used-by-facility', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ProClaimConfController', ProClaimConfController);

    ProClaimConfController.$inject = ['DTOptionsBuilder', '$state', 'ProClaimConf', 'DTColumnBuilder', 'GUIUtils', '$q', '$filter',
        'CoreService', '$compile', '$scope', 'entity', '$uibModal'];

    function ProClaimConfController (DTOptionsBuilder, $state, ProClaimConf, DTColumnBuilder, GUIUtils, $q, $filter,
                                      CoreService, $compile, $scope, entity, $uibModal ) {
        var vm = this;

        vm.proClaimConfs = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.title = 'Pro Claim Confs';
        vm.entityClassHumanized = 'Pro Claim Confs';
        vm.entityStateName = 'pro-claim-conf';
        vm.facility = CoreService.getCurrentFacility();

        vm.evaluationTemplate = entity;

        vm.search = search;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            ProClaimConf.filter({
                facilityId: vm.facility.id,
                evaluationTemplateId: vm.evaluationTemplate.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.proClaimConfs = result;
                defer.resolve(vm.proClaimConfs);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Insurances').renderWith(function (data, type, full) {
                var row = "";

                _.forEach(full.insuranceCarriers, function(carrier) {
                    row += row.length == 0 ? carrier.name : ", " + carrier.name;
                });

                return row;
            }),
            DTColumnBuilder.newColumn('minTime').withTitle('Min Time'),
            DTColumnBuilder.newColumn('maxTime').withTitle('Max Time'),
            DTColumnBuilder
                .newColumn('isDefault')
                .withTitle('Default')
                .renderWith(function (data, type, full) {
                    return GUIUtils.colorHtmlYesNo(data);
                }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ng-click="vm.edit(' + data.id + ')">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ng-click="vm.del(' + data.id + ')">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-dialog.html',
                controller: 'ProClaimConfDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: {
                        id: null,
                        isDefault: false,
                        proCptConfs: [{}],
                        facility: vm.facility,
                        evaluationTemplate: vm.evaluationTemplate
                    }
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            }, function (result) {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-dialog.html',
                controller: 'ProClaimConfDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ProClaimConf', function (ProClaimConf) {
                        return ProClaimConf.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }

        function del(id) {
            $uibModal.open({
                templateUrl: 'app/entities/pro-claim-conf/pro-claim-conf-delete-dialog.html',
                controller: 'ProClaimConfDeleteController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ProClaimConf', function (ProClaimConf) {
                        return ProClaimConf.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PRDetEmployeeCommentDialogController', PRDetEmployeeCommentDialogController);

    PRDetEmployeeCommentDialogController.$inject = ['$scope', '$uibModalInstance', 'prDetEmployeeComment', 'PRDetEmployeeComment', 'toastr'];

    function PRDetEmployeeCommentDialogController($scope, $uibModalInstance, prDetEmployeeComment, PRDetEmployeeComment, toastr) {
        var vm = this;

        vm.prDetEmployeeComment = prDetEmployeeComment;
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            PRDetEmployeeComment.save(vm.prDetEmployeeComment, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success('Employee comment successfully created');
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PRDetEmployeeComment', PRDetEmployeeComment);

    PRDetEmployeeComment.$inject = ['$resource'];

    function PRDetEmployeeComment($resource) {
        var resourceUrl = 'api/pr-det-employee-comments/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PortDialogController', PortDialogController);

    PortDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Port'];

    function PortDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Port) {
        var vm = this;

        vm.port = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.port.id !== null) {
                Port.update(vm.port, onSaveSuccess, onSaveError);
            } else {
                Port.save(vm.port, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:portUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Port', Port);

    Port.$inject = ['$resource'];

    function Port ($resource) {
        var resourceUrl =  'api/ports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/ports/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('port', {
                parent: 'entity',
                url: '/port',
                data: {
                    authorities: [],
                    pageTitle: 'Ports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/port/list/port.html',
                        controller: 'PortController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_PORT];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_PORT, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PortController', PortController);

    PortController.$inject = ['GenericEntityDatatableService', 'Port', 'CoreService', 'ConfirmationService', '$q', '$uibModal'];

    function PortController(GenericEntityDatatableService, Port, CoreService, ConfirmationService, $q, $uibModal) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Ports',
            newButtonTitle: 'New Port',
            entityClassHumanized: 'Ports',
            entityStateName: 'port',
            service: Port,
            serviceMethod: 'findAllByCorporation',
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'xorder',
                    title: 'Order',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Port',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/port/update/port-dialog.html',
                controller: 'PortDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            xorder: null,
                            id: null,
                            corporation: CoreService.getCorporation(),
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/port/update/port-dialog.html',
                controller: 'PortDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['Port', function (Port) {
                        return Port.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Port').result.then(function () {
                    Port.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('physician-review', {
                parent: 'entity',
                url: '/physician-review',
                data: {
                    authorities: [],
                    pageTitle: 'Physician Review'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/physician-review/list/physician-review.html',
                        controller: 'PhysicianReviewController',
                        controllerAs: 'vm'
                    },
                    'medications@physician-review': {
                        templateUrl: 'app/entities/physician-review/medications/physician-review-medications.html',
                        controller: 'PhysicianReviewMedicationsController',
                        controllerAs: 'vm'
                    },
                    'lab-orders@physician-review': {
                        templateUrl: 'app/entities/physician-review/lab-orders/physician-review-lab-orders.html',
                        controller: 'PhysicianReviewLabOrdersController',
                        controllerAs: 'vm',
                        resolve: {
                            filter: function () {
                                return {
                                    mrNo: null,
                                    chartSelected: null,
                                    dob: null,
                                    searchQuery: null
                                };
                            }
                        }

                    },
                    'e-labs@physician-review': {
                        templateUrl: 'app/entities/physician-review/e-labs/physician-review-e-labs.html',
                        controller: 'PhysicianReviewELabsController',
                        controllerAs: 'vm',
                        resolve: {
                            signPatientResultCredentials: ['BusinessCredential', 'CoreService', 'BUSINESS_ROLES',
                                function (BusinessCredential, CoreService, BUSINESS_ROLES) {
                                    return BusinessCredential.getCredentialByRole({
                                        businessRole: BUSINESS_ROLES.SIGN_PATIENT_RESULT,
                                        id: CoreService.getCurrentFacility().id
                                    }).$promise;
                                }],
                        }
                    },
                    'diagnoses@physician-review': {
                        templateUrl: 'app/entities/physician-review/diagnoses/physician-review-diagnoses.html',
                        controller: 'PhysicianReviewDiagnosesController',
                        controllerAs: 'vm',
                        resolve: {
                            signDiagnosesCredentials: ['BusinessCredential', 'CoreService', 'BUSINESS_ROLES',
                                function (BusinessCredential, CoreService, BUSINESS_ROLES) {
                                    return BusinessCredential.getCredentialByRole({
                                        businessRole: BUSINESS_ROLES.SIGN_DIAGNOSES,
                                        id: CoreService.getCurrentFacility().id
                                    }).$promise;
                                }],
                        }
                    }
                },
                resolve: {
                    physicianCredentials: ['BusinessCredential', 'CoreService', 'BUSINESS_ROLES',
                        function (BusinessCredential, CoreService, BUSINESS_ROLES) {
                            return BusinessCredential.getCredentialByRole({
                                businessRole: BUSINESS_ROLES.PHYSICIAN,
                                id: CoreService.getCurrentFacility().id
                            }).$promise;
                        }],
                },
            });
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewMedicationsController', PhysicianReviewMedicationsController);

    PhysicianReviewMedicationsController.$inject = ['$q', 'PatientMedication', 'CoreService', 'PopupService', 'toastr',
        '$rootScope', 'Chart', 'MedicationSearch', 'TypeLevelCare',
        'physicianCredentials', 'GenericEntityDatatableService'];

    function PhysicianReviewMedicationsController($q, PatientMedication, CoreService, PopupService, toastr,
                                                  $rootScope, Chart, MedicationSearch, TypeLevelCare,
                                                  physicianCredentials, GenericEntityDatatableService) {
        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Medications',
            entityClassHumanized: 'Medications',
            entityStateName: 'medications',
            service: PatientMedication,
            serviceMethod: 'findAllPhysicianReview',
            params: params,
            pagination: 'remote',
            newAction: false,
            withSelectionColumn: true,
            isVisibleSelectionColumn: function () {
                return CoreService.currentEmployeeHaveAnyCredential(physicianCredentials);
            },
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'patientName',
                    title: 'Name',
                    options: [{key: 'width', value: '170px'}],
                    render: function (data) {
                        return data.lastName + ', ' + data.firstName;
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo'
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'medicationName',
                    title: 'Medication'
                },
                {
                    name: 'medicationStatus',
                    title: 'Status'
                },
                {
                    name: 'startDate',
                    title: 'Start Date',
                    render: function (data) {
                        return moment(data.startDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'endDate',
                    title: 'End Date',
                    render: function (data) {
                        return moment(data.endDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Entered By',
                    render: function (data) {
                        return data.lastNameEmployee + " " + data.firstNameEmployee;
                    }
                },
                {
                    name: null,
                    title: 'Signed By',
                    render: function (data) {
                        return data.physicianFirstName + " " + data.physicianLastName;
                    }
                },
                {
                    name: 'type',
                    title: 'Type'
                },
                {
                    name: null,
                    title: 'Discontinue By',
                    render: function (data) {
                        return data.firstNameDiscontinueBy ? (data.firstNameDiscontinueBy + " " + data.lastNameDiscontinueBy) : "";
                    }
                },
                {
                    name: null,
                    title: 'Discontinue Date',
                    render: function (data) {
                        return data.discontinueDate ? moment(data.discontinueDate).format("MM/DD/YYYY") : "";
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        return vm.viewDetails(data.id);
                    },
                }),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.signPatientMedications(selected);
                                }
                            },
                            ngIf: function () {
                                return CoreService.currentEmployeeHaveAnyCredential(physicianCredentials);
                            },
                        }),
                    ]
                },
            ],
            filters: [
                {
                    name: 'medication',
                    read: function (filter) {
                        return filter.medication ? filter.medication.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        MedicationSearch.query({query: search}, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select medication ...',
                    type: 'select',
                    visible: true,
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'status',
                    placeholder: 'Medication Status...',
                    type: 'select',
                    values: ['CANCELED', 'FINISHED', 'SCHEDULED', 'DISCONTINUED'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
                {
                    name: 'mrNo',
                    // title: 'Barcode',
                    placeholder: 'MrNo...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'medicationFrequency',
                    read: function (filter) {
                        return filter.medicationFrequency ? filter.medicationFrequency.id : null;
                    },
                    values: PatientMedication.getAllMedicationFrequency(),
                    getDisplayValue: function (entity) {
                        return entity ? entity.description : "";
                    },
                    placeholder: 'Select Frequency...',
                    type: 'select',
                    visible: true
                },
            ]
        }

        vm.viewDetails = viewDetails;
        vm.signPatientMedications = signPatientMedications;

        function viewDetails(id) {
            return $q(function (resolve, reject) {
                PopupService.showPatientMedicationsDetailsPopup(id).result.then(function (data) {
                    resolve();
                })
            })
        }

        function signPatientMedications(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve, reject) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    PatientMedication.signMany({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids,
                        facilityId: vm.facility.id
                    }, function (result) {
                        if (result) {
                            toastr.success("The Patient Medication was signed successfully.");
                        } else {
                            toastr.error('Some patient Medications could not be signed.');
                        }

                        resolve();
                    }, function () {
                        toastr.error('Some patient Medications could not be signed.');
                        resolve();
                    });
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewController', PhysicianReviewController);

    PhysicianReviewController.$inject = ['$scope'];

    function PhysicianReviewController($scope) {
        var vm = this;

        vm.title = 'Physician Reviews';
        vm.entityClassHumanized = 'Physician Review';
        vm.entityStateName = 'physician-review';

        vm.emitReload = emitReload;

        function emitReload(tab) {
            $scope.$emit('bluebookApp:physicianReviews' + tab);
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewLabOrdersController', PhysicianReviewLabOrdersController);

    PhysicianReviewLabOrdersController.$inject = ['moment', '$q', 'PatientOrder', 'CoreService', 'PopupService',
        'toastr', '$rootScope', 'Chart', 'physicianCredentials',
        'GenericEntityDatatableService'];

    function PhysicianReviewLabOrdersController(moment, $q, PatientOrder, CoreService, PopupService,
                                                toastr, $rootScope, Chart, physicianCredentials,
                                                GenericEntityDatatableService) {
        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Lab Orders',
            entityClassHumanized: 'Lab Orders',
            service: PatientOrder,
            serviceMethod: 'findAllPhysicianReview',
            params: params,
            pagination: 'remote',
            newAction: false,
            withSelectionColumn: true,
            isVisibleSelectionColumn: function () {
                return CoreService.currentEmployeeHaveAnyCredential(physicianCredentials);
            },
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Name',
                    options: [{key: 'width', value: '170px'}],
                    render: function (data) {
                        return data.lastName + ', ' + data.firstName;
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo'
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'orderStatus',
                    title: 'Status',
                },
                {
                    name: 'startDate',
                    title: 'Start Date',
                    render: function (data) {
                        return moment(data.startDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'endDate',
                    title: 'End Date',
                    render: function (data) {
                        return moment(data.endDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Entered By',
                    render: function (data) {
                        return data.lastNameEmployee + " " + data.firstNameEmployee;
                    }
                },
                {
                    name: null,
                    title: 'Signed By',
                    render: function (data) {
                        return data.firstNameSignedBy + " " + data.lastNameSignedBy;
                    }
                },
                {
                    name: null,
                    title: 'Discontinue By',
                    render: function (data) {
                        return data.firstNameDiscontinueBy ? (data.firstNameDiscontinueBy + " " + data.lastNameDiscontinueBy) : "";
                    }
                },
                {
                    name: null,
                    title: 'Discontinue Date',
                    render: function (data) {
                        return data.discontinueDate ? moment(data.discontinueDate).format("MM/DD/YYYY") : "";
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        vm.showPatientOrderDetailsPopup(data.id);
                    },
                }),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-green']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.signPatientOrder(selected);
                                }
                            },
                            ngIf: function () {
                                return CoreService.currentEmployeeHaveAnyCredential(physicianCredentials);
                            },
                        }),
                    ]
                },
            ],
            filters: [
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true,
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
                },
                {
                    name: 'mrNo',
                    // title: 'Barcode',
                    placeholder: 'MrNo...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                }
            ]
        }

        vm.showPatientOrderDetailsPopup = showPatientOrderDetailsPopup;
        vm.signPatientOrder = signPatientOrder;

        function showPatientOrderDetailsPopup(id) {
            PopupService.showPatientOrderDetailsPopup(id);
        }

        function signPatientOrder(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve, reject) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    PatientOrder.sign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids,
                        facilityId: vm.facility.id
                    }, function (result) {
                        if (result) {
                            toastr.success("The Patient Result was signed successfully.");
                        } else {
                            toastr.error('Some patient results could not be signed.');
                        }

                        resolve();
                    }, function () {
                        toastr.error('Some patient results could not be signed.');

                        resolve();
                    });
                });
            });
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewELabsController', PhysicianReviewELabsController);

    PhysicianReviewELabsController.$inject = ['moment', 'GUIUtils', '$q', 'PatientResult', 'CoreService',
        'PopupService', 'toastr', '$rootScope', 'signPatientResultCredentials',
        'GenericEntityDatatableService'];

    function PhysicianReviewELabsController(moment, GUIUtils, $q, PatientResult, CoreService,
                                            PopupService, toastr, $rootScope, signPatientResultCredentials,
                                            GenericEntityDatatableService) {
        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'E Labs',
            entityClassHumanized: 'Patient Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'getAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            withSelectionColumn: true,
            isVisibleSelectionColumn: function () {
                return CoreService.currentEmployeeHaveAnyCredential(signPatientResultCredentials);
            },
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Received Date',
                    render: function (data) {
                        return moment(data.lastModifiedDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Alert',
                    options: [
                        {key: 'width', value: '175px'}
                    ],
                    render: function (data) {
                        if (data.abnormalRange) {
                            return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
                        } else {
                            return GUIUtils.getStatusTemplate('NORMAL', 'success');
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        if (data.status == 'PARTIAL') {
                            return GUIUtils.getStatusTemplate(data.status, 'warning');
                        } else {
                            return GUIUtils.getStatusTemplate(data.status, 'primary');
                        }
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        vm.details(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    action: function (data) {
                        vm.printRangePDFs(data.id);
                    },
                })
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-green']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.signPatientResult(selected);
                                }
                            },
                            ngIf: function () {
                                return CoreService.currentEmployeeHaveAnyCredential(signPatientResultCredentials);
                            },
                        }),
                    ]
                },
            ],
            filters: [
                {
                    name: 'status',
                    visible: false,
                    defaultValue: function () {
                        return 'FINAL'
                    }
                },
                {
                    name: 'assigned',
                    visible: false,
                    defaultValue: function () {
                        return true
                    }
                },
                {
                    name: 'signed',
                    visible: false,
                    defaultValue: function () {
                        return false;
                    }
                },
                {
                    name: 'patientName',
                    // title: 'Patient Name',
                    placeholder: 'Patient Name...',
                    type: 'string',
                    visible: true,
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'accessionNumber',
                    // title: 'Barcode',
                    placeholder: 'Barcode...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'startDate',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },

                    visible: true
                },
                {
                    name: 'endDate',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
            ]
        }

        vm.printRangePDFs = printRangePDFs;
        vm.signPatientResult = signPatientResult;

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            }
            if (ids.length > 0) {
                PatientResult.getAllInOneRangePdf({ids: ids});
            }
        }

        function signPatientResult(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve, reject) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    PatientResult.sign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids,
                        facilityId: vm.facility.id
                    }, function (result) {
                        if (result) {
                            toastr.success("The Patient Result was signed successfully.");
                        } else {
                            toastr.error('Some patient results could not be signed.');
                        }

                        resolve();
                    }, function () {
                        toastr.error('Some patient results could not be signed.');
                        resolve();
                    });
                });
            });
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewDiagnosesController', PhysicianReviewDiagnosesController);

    PhysicianReviewDiagnosesController.$inject = ['moment', 'toastr', '$q', 'Diagnoses', 'CoreService', 'PopupService',
        '$rootScope', 'Chart', 'signDiagnosesCredentials', 'GenericEntityDatatableService'];

    function PhysicianReviewDiagnosesController(moment, toastr, $q, Diagnoses, CoreService, PopupService,
                                                $rootScope, Chart, signDiagnosesCredentials, GenericEntityDatatableService) {
        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Diagnoses',
            service: Diagnoses,
            serviceMethod: 'findAllPhysicianReview',
            params: params,
            pagination: 'remote',
            newAction: false,
            withSelectionColumn: true,
            isVisibleSelectionColumn: function () {
                return CoreService.currentEmployeeHaveAnyCredential(signDiagnosesCredentials);
            },
            options: [
                {key: 'aaSorting', value: [[2, 'desc'], [4, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Name',
                    options: [{key: 'width', value: '170px'}],
                    render: function (data) {
                        return data.lastName + ', ' + data.firstName;
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo'
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'rank',
                    title: 'Rank'
                },
                {
                    title: 'Code',
                    render: function (data) {
                        return data && data.icd10 ? data.icd10.code : '';
                    }
                },
                {
                    title: 'Description',
                    render: function (data) {
                        return data && data.icd10 ? data.icd10.description : '';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        vm.viewDetails(data.id);
                    },
                }),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.signDiagnoses(selected);
                                }
                            },
                            ngIf: function () {
                                return CoreService.currentEmployeeHaveAnyCredential(signDiagnosesCredentials);
                            },
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: vm.facility.id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'mrNo',
                    // title: 'Barcode',
                    placeholder: 'MrNo...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'rank',
                    placeholder: 'Rank...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'code',
                    placeholder: 'Code...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'description',
                    placeholder: 'Description...',
                    type: 'string',
                    visible: true
                }
            ]
        }

        vm.viewDetails = viewDetails;
        vm.signDiagnoses = signDiagnoses;

        function viewDetails(id) {
            PopupService.showDiagnosesEditPopup(id);
        }

        function signDiagnoses(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve, reject) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    Diagnoses.sign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids,
                        facilityId: vm.facility.id
                    }, function (result) {
                        if (result) {
                            toastr.success("The Patient Result was signed successfully.");
                        } else {
                            toastr.error('Some patient results could not be signed.');
                        }

                        resolve();
                    }, function () {
                        toastr.error('Some patient results could not be signed.');
                        resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PharmacyDialogController', PharmacyDialogController);

    PharmacyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Pharmacy'];

    function PharmacyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Pharmacy) {
        var vm = this;

        vm.pharmacy = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.pharmacy.id !== null) {
                Pharmacy.update(vm.pharmacy, onSaveSuccess, onSaveError);
            } else {
                Pharmacy.save(vm.pharmacy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:pharmacyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Pharmacy', Pharmacy);

    Pharmacy.$inject = ['$resource'];

    function Pharmacy ($resource) {
        var resourceUrl =  'api/pharmacy/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/pharmacy/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('pharmacy', {
                parent: 'entity',
                url: '/pharmacy',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Pharmacy'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pharmacy/list/pharmacy.html',
                        controller: 'PharmacyController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PharmacyController', PharmacyController);

    PharmacyController.$inject = ['GenericEntityDatatableService', 'Pharmacy', '$uibModal',
        'ConfirmationService', 'toastr', '$q'];

    function PharmacyController(GenericEntityDatatableService, Pharmacy, $uibModal,
                                ConfirmationService, toastr, $q) {
        var vm = this;

        vm.descriptor = {
            title: 'Pharmacy',
            newButtonTitle: 'New Pharmacy',
            entityClassHumanized: 'Pharmacy',
            entityStateName: 'pharmacy',
            service: Pharmacy,
            serviceMethod: 'findAllByFilter',
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'city',
                    title: 'City',
                },
                {
                    name: 'state',
                    title: 'State',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Pharmacy',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharmacy/update/pharmacy-dialog.html',
                    controller: 'PharmacyDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: [function () {
                            return {
                                id: null,
                                rcopiaID: null,
                                rcopiaMasterID: null,
                                deleted: null,
                                ncpdpid: null,
                                npi: null,
                                name: null,
                                address1: null,
                                address2: null,
                                crossStreet: null,
                                city: null,
                                state: null,
                                zip: null,
                                phone: null,
                                fax: null,
                                is24Hour: null,
                                level3: null,
                                electronic: null,
                                mailOrder: null,
                                retail: null,
                                longTermCare: null,
                                specialty: null,
                                canReceiveControlledSubstance: null,
                                scriptVersion: null,
                                inHouseDispensing: null,
                                compounding: null,
                                durableMedicalEquipment: null,
                                kiosk: null
                            };
                        }]
                    }
                }).result.then(function () {
                    toastr.success('Pharmacy was saved', 'Success');

                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharmacy/update/pharmacy-dialog.html',
                    controller: 'PharmacyDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['Pharmacy', function (Pharmacy) {
                            return Pharmacy.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    toastr.success('Pharmacy was saved', 'Success');

                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Pharmacy').result.then(function () {
                    Pharmacy.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PendingReport', PendingReport);

    PendingReport.$inject = ['$resource'];

    function PendingReport ($resource) {
        var resourceUrl =  'api/pending-reports/:id';

        return $resource(resourceUrl, {}, {
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PendingPdfChartReport', PendingPdfChartReport);

    PendingPdfChartReport.$inject = ['$resource', 'DateUtils'];

    function PendingPdfChartReport ($resource, DateUtils) {
        var resourceUrl =  'api/pending-pdf-chart-reports/:id';

        return $resource(resourceUrl, {}, {
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PdfChartReport', PdfChartReport);

    PdfChartReport.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function PdfChartReport($resource, DateUtils, DataUtils) {
        var resourceUrl = 'api/pdf-chart-reports/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateTimeRequested = DateUtils.convertDateTimeFromServer(data.dateTimeRequested);
                    }
                    return data;
                }
            },
            'getPdfChartReport': {url: 'api/pdf-chart-reports', method: 'GET', isArray: true},
            'getPdfChartReportSelected': {url: 'api/pdf-chart-reports-selected/:listId', method: 'GET', isArray: true},
            'deletePdfChartReport': {url: 'api/pdf-chart-reports-delete/:listId', method: 'GET', isArray: true},
            'download': {
                url: 'api/pdf-chart-reports/download/:id',
                responseType: 'arraybuffer',
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'downloadPdfObject': {
                url: 'api/pdf-chart-reports/download/:id',
                method: 'GET',
                isArray: false
            },
            'filter': {url: 'api/pdf-chart-reports/filter', method: 'GET', isArray: true},
            'renew': {url: 'api/pdf-chart-reports/renew/:id', method: 'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pdf-chart-report', {
            parent: 'entity',
            url: '/pdf-chart-report',
            data: {
                authorities: [],
                pageTitle: 'PdfChartReports'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pdf-chart-report/list/pdf-chart-report.html',
                    controller: 'PdfChartReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_REPORTS];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_REPORTS, access);
            }]
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PdfChartReportController', PdfChartReportController);

    PdfChartReportController.$inject = ['PdfChartReport', '$uibModal', '$q', 'GUIUtils', 'CoreService', '$rootScope',
        'GenericEntityDatatableService', 'ConfirmationService', 'toastr'];

    function PdfChartReportController(PdfChartReport, $uibModal, $q, GUIUtils, CoreService, $rootScope,
                                      GenericEntityDatatableService, ConfirmationService, toastr) {

        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Storage',
            newAction: false,
            entityClassHumanized: 'report',
            entityStateName: 'report',
            service: PdfChartReport,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            withSelectionColumn: true,
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: "Requested By",
                    render: function (data) {
                        return data.employee.firstName + ' ' + data.employee.lastName;
                    }
                },
                {
                    name: null,
                    title: "Requested Date",
                    render: function (data) {
                        return moment(data.dateTimeRequested).format($rootScope.amDateFormat);
                    }
                },
                {
                    name: null,
                    title: 'Completed At',
                    render: function (data) {
                        return data.completedAt ? moment(data.completedAt).format($rootScope.amDateFormat) : "";
                    }
                },
                {
                    name: null,
                    title: 'Status',
                    render: function (data) {
                        return data.pdfChartReportStatus ? getStatusStyle(data.pdfChartReportStatus) : "FAIL";
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDownloadAction(), {
                    action: function (data) {
                        downloadSelectedReportsDialog([data]);
                    },
                    reload: false,
                    ngIf: function (data) {
                        return data.pdfChartReportStatus === "COMPLETED";
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                    name: "New Report",
                    action: function (data) {
                        return newReport(data.id);
                    },
                    ngIf: function (data) {
                        return (data.chartId != null && data.facesheetTplId != null) || data.reportId != null
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getDownloadAction(), {
                            name: "Download Selected",
                            action: function (filter, selected) {
                                downloadSelectedReportsDialog(selected);
                            },
                            reload: false,
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: ['COMPLETED', 'FAIL'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                }
            ]
        }

        function downloadSelectedReportsDialog(selected) {
            _.forEach(selected, function (item) {
                $uibModal.open({
                    templateUrl: 'app/entities/pdf-chart-report/download/pdf-chart-report-download-dialog.html',
                    controller: 'PdfChartReportDownloadController',
                    controllerAs: 'vm',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['PdfChartReport', function (PdfChartReport) {
                            return PdfChartReport.get({id: item.id}).$promise;
                        }]
                    }
                });
            })
        }

        function getStatusStyle(status) {

            switch (status) {
                case 'PENDING': {
                    return GUIUtils.getStatusTemplate(status, "primary")
                }
                case 'STARTED': {
                    return GUIUtils.getStatusTemplate(status, "warning")
                }
                case 'FAIL': {
                    return GUIUtils.getStatusTemplate(status, "danger")
                }
                case 'COMPLETED': {
                    return GUIUtils.getStatusTemplate(status, "success")
                }
            }
        }

        function newReport(id) {
            return $q(function (resolve) {
                ConfirmationService.open({
                    title: 'Renew Chart Report',
                    message: 'Are you sure you want to <strong>renew</strong> this Report?',
                    actions: [
                        {
                            name: 'Renew',
                            color: 'btn btn-success',
                            icon: 'fa fa-times-circle-o',
                            value: 'SUCCESS'
                        },
                        {
                            name: 'Cancel',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                }).result.then(function () {
                    PdfChartReport.renew({id: id}, function (result) {
                        toastr.success('Your report is been generated please go to storage to download it');
                        resolve();
                    }, function () {
                        toastr.error("We couldn't generate the report.");
                        resolve();
                    });
                });
            });
        }
    }
})();

/**
 * Created by srodriguez on 4/06/18.
 */

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PdfChartReportDownloadController', PdfChartReportDownloadController);

    PdfChartReportDownloadController.$inject = ['$uibModalInstance', 'entity', 'PdfChartReport', 'OdsParamType', 'CoreService'];

    function PdfChartReportDownloadController($uibModalInstance, entity, PdfChartReport, OdsParamType, CoreService) {
        var vm = this;

        vm.pdfChartReport = entity;
        vm.pdf = {};
        vm.pdfBase64 = "";
        vm.employeeName = "Printed by: " + CoreService.getCurrentEmployee().firstName + " " + CoreService.getCurrentEmployee().lastName;

        vm.listPdfChartReportsSelected = [];
        vm.listPdfChartReportsSelectedDownload = [];

        vm.countDownloadedReports = 0;

        vm.clear = clear;

        if (entity != null) {
            if (vm.pdfChartReport.json) {
                PdfChartReport.downloadPdfObject({id: vm.pdfChartReport.id}, function (data, headers) {
                    vm.pdf = data;
                    data.footer = pdfFooterWithFilters(data);
                    pdfMake.createPdf(data).download(vm.pdfChartReport.name);
                    clear();
                });
            } else {
                PdfChartReport.download({id: vm.pdfChartReport.id}, function () {
                    clear();
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function pdfFooterWithFilters(report) {

            if (report.content.length > 0) {

                var filters = '';
                for (var i = 0; i < report.content.length; i++) {
                    var hideParam = report.content[i].hideInFooter !== undefined ?
                        report.content[i].hideInFooter : false;
                    if (!hideParam) {
                        switch (report.content[i].type) {
                            case OdsParamType.DATE:
                                filters += report.content[i].title + ': ' +
                                    OdsDateUtils.formatter(report.content[i].value, 'MM/dd/yyyy') + '\n';
                                break;
                            case OdsParamType.NUMBER:
                                filters += report.content[i].title + ': ' + report.content[i].value + '\n';
                                break;
                            default:
                                filters += report.content[i].title + ': ' + report.content[i].value + '\n';
                                break;
                        }
                    }
                }

                return function (currentPage, pageCount) {

                    var result;
                    if (report.footerLogo) {
                        result = {
                            columns: [
                                {
                                    text: filters,
                                    margin: [20, 0],
                                    fontSize: 8
                                },
                                {
                                    image: report.footerLogo,
                                    fit: [100, 100],
                                    margin: [0, 0, 0, 0]
                                },
                                {
                                    text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                                        'Page ' + currentPage.toString() + ' of ' + pageCount,
                                    alignment: 'right',
                                    margin: [0, 0, 20, 0],
                                    fontSize: 8
                                }
                            ]
                        }
                    } else {
                        result = {
                            columns: [
                                {
                                    text: "",//filters,
                                    margin: [20, 0],
                                    fontSize: 8
                                },
                                {
                                    text: vm.employeeName,//filters,
                                    margin: [20, 0],
                                    fontSize: 8,
                                    alignment: 'center'
                                },
                                {
                                    text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                                        'Page ' + currentPage.toString() + ' of ' + pageCount,
                                    alignment: 'right',
                                    margin: [0, 0, 20, 0],
                                    fontSize: 8
                                }
                            ]
                        }
                    }
                    return result;
                };
            } else {
                return function (currentPage, pageCount) {
                    return {
                        columns: [
                            {
                                text: 'No Filters',
                                margin: [20, 0],
                                fontSize: 8
                            },
                            {
                                text: 'Date: ' + moment().format('MM/DD/YYYY hh:mm') + '\n' +
                                    'Page ' + currentPage.toString() + ' of ' + pageCount,
                                alignment: 'right',
                                margin: [0, 0, 20, 0],
                                fontSize: 8
                            }
                        ]
                    };
                };
            }

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientResultDet', PatientResultDet);

    PatientResultDet.$inject = ['$resource'];

    function PatientResultDet ($resource) {
        var resourceUrl =  'api/patient-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getAllResultsDetByResult': {url: 'api/patient-result-dets/by-result/:id', method: 'GET', isArray: true},
            'getComments': {url: 'api/patient-result-dets/comments/:id', method: 'GET', isArray: true},
            'getEmployeeComments': {url: 'api/patient-result-dets/emp-comments/:id', method: 'GET', isArray: true},
            'acknowledge': {url: 'api/patient-result-dets/acknowledge', method: 'POST'},
            'acknowledgeAbnormal': {url: 'api/patient-result-dets/acknowledge-abnormal', method: 'POST'},
            'get6M': {url: 'api/patient-result-dets/6M/:detailId', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultDetController', PatientResultDetController);

    PatientResultDetController.$inject = ['patientResult', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils',
        '$filter', '$uibModalInstance', 'CoreService', 'PatientOrder', '$compile', '$scope',
        'PatientResultDet', 'PatientResult', 'signature', 'itHasCredentials'];

    function PatientResultDetController(patientResult, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils,
                                        $filter, $uibModalInstance, CoreService, PatientOrder, $compile, $scope,
                                        PatientResultDet, PatientResult, signature, itHasCredentials) {

        var vm = this;

        vm.itHasCredentials = itHasCredentials.value;
        vm.pdf = {};
        vm.dtInstance = {};
        vm.patientResultDets = [];
        vm.credentials = "";
        vm.chart = patientResult.chart;
        vm.patientResult = patientResult;
        vm.defaultImage = CoreService.patientPictureDefault().picture;
        //TODO refractor
        patientResult.accessionNumber != null ?
            PatientOrder.getByBarcode({barcode: patientResult.accessionNumber}, function (patientOrder) {
                vm.physician = patientOrder.signedBy;
            }) : null;

        vm.patientResultSignature = signature ? signature : patientResult.patientResultSignature;

        vm.pin = "";
        vm.agree = false;
        vm.signature = "";
        vm.activateSign = false;
        vm.currentEmployee = CoreService.getCurrentEmployee();
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.groups = [];
        vm.groupsAll = {name: 'All', value: true};
        vm.levels = {
            all: true,
            abnormals: true,
            criticals: true,
            L: true,
            LL: true,
            N: true,
            H: true,
            HH: true
        };

        vm.clear = clear;
        vm.search = search;
        vm.toggleFilters = toggleFilters;

        vm.dtColumns = [
            DTColumnBuilder.newColumn('testCode').withTitle('Test Code'),
            DTColumnBuilder.newColumn('testName').withTitle('Test'),
            DTColumnBuilder.newColumn('rGroup').withOption('width', '250px').withTitle('Group').notVisible(),
            DTColumnBuilder.newColumn(null).withTitle('Result').renderWith(function (data, type, full) {
                if (full.result != null) {
                    if (full.activeRange) {
                        return decorateResult(full.rangeStatus, full.result);
                    } else {
                        return decorateResult(full.status, full.result);
                    }
                }
            }),
            DTColumnBuilder.newColumn(null).withTitle('Ranges').renderWith(function (data, type, full) {
                if (full.activeRange) {
                    return full.range ? full.range : full.cutOff;
                } else {
                    return full.cutOff;
                }
            }),
            DTColumnBuilder.newColumn('units').withTitle('Units'),
        ];

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.patientResultDets.length == 0) {
                PatientResultDet.getAllResultsDetByResult({id: vm.patientResult.id}, function (result) {
                    vm.patientResultDets = result;

                    var groupsIndex = {};

                    vm.patientResultDets.forEach(function (detail) {
                        if (groupsIndex[detail.rGroup] == undefined) {
                            groupsIndex[detail.rGroup] = detail.rGroup;
                            vm.groups.push({name: detail.rGroup, value: true});
                        }
                    });

                    defer.resolve(vm.patientResultDets);
                });
            } else {
                //groupsNames actives
                var groupsNames = _.map(_.filter(vm.groups, {'value': true}), function (group) {
                    return group.name;
                });

                //status actives
                var levelsIn = [];
                //status inactives
                var levelsOut = [];

                _.forOwn(vm.levels, function (value, key) {
                    if (['L', 'LL', 'N', 'H', 'HH'].indexOf(key) != -1) {
                        if (value) {
                            levelsIn.push(key);
                        } else {
                            levelsOut.push(key)
                        }
                    }
                });

                var resultsDets = _.filter(vm.patientResultDets, function (det) {
                    var status = det.activeRange ? det.rangeStatus : det.status;

                    return groupsNames.indexOf(det.rGroup) != -1 &&
                        //check if appear a value different of L, LL, N, H, HH like A
                        (levelsIn.indexOf(status) != -1 || levelsOut.indexOf(status) == -1);
                });

                defer.resolve($filter('filter')(resultsDets, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [[2, 'asc'], [0, 'asc']])
            .withOption('fnDrawCallback', function (oSettings) {
                var api = this.api();
                var rows = api.rows({page: 'current'}).nodes();
                var last = null;
                api.column(2, {page: 'current'}).data().each(function (group, i) {
                    if (last !== group) {
                        $(rows).eq(i).before(
                            '<tr class="group"><td colspan="6"><strong>' + group + '</strong></td></tr>'
                        );
                        last = group;
                    }
                });
            })
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });


        function search() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function decorateResult(status, result) {
            switch (status) {
                case 'N': {
                    return result;
                }
                case 'L':
                case 'H': {
                    return GUIUtils.getStatusTemplate(result + ' ' + status, 'primary');
                }
                case 'LL':
                case 'HH': {
                    return GUIUtils.getStatusTemplate(result + ' ' + status, 'danger');
                }
                default :
                    return result;
            }
        }

        function toggleFilters() {
            angular.element('.filters-wrapper').slideToggle()
        }

        vm.groupsCheck = groupsCheck;
        vm.groupCheckAll = groupCheckAll;
        vm.levelAll = levelAll;
        vm.abnormals = abnormals;
        vm.criticals = criticals;
        vm.normal = normal;
        vm.notNormal = notNormal;

        function levelAll() {
            for (var key in vm.levels) {
                vm.levels[key] = vm.levels.all;
            }

            search();
        }

        function abnormals() {
            if (vm.levels.abnormals) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                        case 'L':
                        case 'H':
                            vm.levels[key] = true;
                            break;
                        default:
                            vm.levels[key] = false;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'all':
                        case 'criticals':
                        case 'L':
                        case 'H':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function criticals() {
            if (vm.levels.criticals) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'criticals':
                        case 'LL':
                        case 'HH':
                            vm.levels[key] = true;
                            break;
                        default:
                            vm.levels[key] = false;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'all':
                        case 'abnormals':
                        case 'LL':
                        case 'HH':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function normal() {
            if (vm.levels.N) {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                        case 'criticals':
                            vm.levels[key] = false;
                            break;
                        case 'all':
                            vm.levels[key] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && vm.levels.N;
                            break;
                    }
                }
            } else {
                for (var key in vm.levels) {
                    switch (key) {
                        case 'abnormals':
                            vm.levels[key] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH;
                            break;
                        case 'criticals':
                            vm.levels[key] = !vm.levels.L && vm.levels.LL && !vm.levels.H && vm.levels.HH;
                            break;
                        case 'all':
                            vm.levels[key] = false;
                            break;
                    }
                }
            }

            search();
        }

        function notNormal() {
            vm.levels['abnormals'] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && !vm.levels.N;
            vm.levels['criticals'] = !vm.levels.L && vm.levels.LL && !vm.levels.h && vm.levels.hh && !vm.levels.N;
            vm.levels['all'] = vm.levels.L && vm.levels.LL && vm.levels.H && vm.levels.HH && vm.levels.N;

            search();
        }

        function groupsCheck() {
            var all = true;

            vm.groups.forEach(function (group) {
                all = all && group.value;
            });

            vm.groupsAll.value = all;

            search();
        }

        function groupCheckAll() {
            vm.groups.forEach(function (group) {
                group.value = vm.groupsAll.value;
            });

            search();
        }

        if (!patientResult.signed) {
            credentialsPermits();
        }

        function credentialsPermits() {
            if (vm.itHasCredentials) {
                vm.patientResult.signedBy = vm.currentEmployee;
            }
        }

        vm.physicianCredentials = physicianCredentials;

        function physicianCredentials() {
            var credentials = '';
            if (vm.patientResult.signedBy) {
                for (var i = 0; i < vm.patientResult.signedBy.credentials.length; i++) {
                    credentials += vm.patientResult.signedBy.credentials[i] + " "
                }
            }
            return credentials
        }

        vm.save = save;

        function save() {
            vm.isSaving = true;

            var result = {
                ids: [vm.patientResult.id],
                pin: vm.pin,
                signature: vm.signature
            }

            PatientResult.sign(result, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultsUnassignedController', PatientResultsUnassignedController);

    PatientResultsUnassignedController.$inject = ['$uibModal', 'CoreService', 'PatientResult', '$q', 'GUIUtils',
        '$rootScope', 'toastr', 'DataTablesService', 'GenericEntityDatatableService',
        'PopupService', 'ConfirmationService'];

    function PatientResultsUnassignedController($uibModal, CoreService, PatientResult, $q, GUIUtils,
                                                $rootScope, toastr, DataTablesService, GenericEntityDatatableService,
                                                PopupService, ConfirmationService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Unassigned Lab Results',
            entityClassHumanized: 'Patient Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'unassigned',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            withSelectionColumn: true,
            disableSelectionColumn: function (filter) {
                return filter.assigned !== false;
            },
            disableAllSelectionColumn: function (filter) {
                return filter.assigned !== false;
            },
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Received Date',
                    render: function (data) {
                        return moment(data.lastModifiedDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Alert',
                    options: [
                        {key: 'width', value: '175px'}
                    ],
                    render: function (data) {
                        if (data.abnormalRange) {
                            return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
                        } else {
                            return GUIUtils.getStatusTemplate('NORMAL', 'success');
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        var assignedStatus = data.assigned ? {label: 'Assigned', template: 'success'}
                            : {label: 'Unassigned', template: 'danger'};

                        return GUIUtils.getStatusTemplate(assignedStatus.label, assignedStatus.template);
                    }
                },
                {
                    name: null,
                    title: 'Assigned',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.chartId ? true : false);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        details(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Chart to Assign Results',
                            disabledOnEmpty: true,
                            action: function (filter, selected) {
                                return selectChart(selected)
                            }
                        })
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All Results',
                            iClass: 'fa fa-flask',
                            ngClass: function (filter) {
                                return filter.assigned === null ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.assigned = null;
                            }
                        },
                        {
                            name: 'Unassigned',
                            iClass: 'fa fa-circle-o',
                            ngClass: function (filter) {
                                return filter.assigned === false ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.assigned = false;
                            }
                        },
                        {
                            name: 'History',
                            iClass: 'fa fa-spinner',
                            ngClass: function (filter) {
                                return filter.assigned === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                filter.assigned = true;
                            }
                        }
                    ],
                }
            ],
            filters: [
                {
                    name: 'assigned',
                    visible: false,
                    defaultValue: function () {
                        return false;
                    }
                }
            ]
        }

        function details(id) {
            PopupService.showPatientResultDet(id);
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Unassigned Result').result.then(function () {
                    PatientResult.deleteUnassigned({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function selectChart(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve) {
                PopupService.showSelectChartPopup().result.then(function (chartId) {
                    PatientResult.assign({
                        ids: ids, chartId: chartId
                    }, function (result) {
                        if (result.length > 0) {
                            toastr.error('Assign operation fail');
                        } else {
                            toastr.success('Assign operation successfully');
                        }

                        resolve();
                    }, function () {
                        toastr.error('Assign operation fail');
                        resolve();
                    });
                });
            })
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientResult', PatientResult);

    PatientResult.$inject = ['$resource', 'DateUtils', 'DataUtils', 'Utils'];

    function PatientResult ($resource, DateUtils, DataUtils, Utils) {
        var resourceUrl =  'api/patient-results/:id';

        function transformCountResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                data = {value: data};
            }
            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                        data.collectionData = DateUtils.convertLocalDateFromServer(data.collectionData);
                        data.reviewedOn = DateUtils.convertLocalDateFromServer(data.reviewedOn);
                        if (data.signedBy != null) {
                            data.signedBy.credentials = Utils.objectRoleToArray(data.signedBy.credentials);
                        }
                    }
                    return data;
                }
            },
            'unassigned': {url : 'api/patient-results/unassigned', method: 'GET', isArray: true},
            'assign': {
                url: 'api/patient-results/assign', method: 'POST', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'deleteUnassigned': {url: 'api/patient-result/delete-unassigned', method: 'POST'},
            'getAllInOneRangePdf': {
                url: 'api/patient-results/get-all-in-one-range-pdf',
                method: 'POST',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'saveResultReviewSignature': {url: "api/patient-results/save-sign", method: 'POST'},
            'getSignature': {url: 'api/patient-results/signature/:id', method: 'GET'},
            'countPartial': {url: 'api/patient-results/count-partial/:id', method: 'GET',
                transformResponse: transformCountResponse},
            'countAbnormal': {url: 'api/patient-results/count-abnormal-result/:id', method: 'GET',
                transformResponse: transformCountResponse},
            'countCritical': {url: 'api/patient-results/count-critical/:id', method: 'GET',
                transformResponse: transformCountResponse
            },
            'countUnassigned': {url: 'api/patient-results/count-unassigned/:id', method: 'GET',
                transformResponse: transformCountResponse
            },
            'pending': {url: 'api/patient-results/pending/:id', method: 'GET', isArray: true},
            'deletePending': {url: 'api/patient-result/delete-pending', method: 'POST'},
            'critical': {url: 'api/patient-results/critical', method: 'GET', isArray: true},
            'abnormal': {url: 'api/patient-results/abnormal', method: 'GET', isArray: true},
            'sign': {url: 'api/patient-results/sign', method: 'POST'},
            'getAllByFilter': {url: 'api/patient-results/filter', method: 'GET', isArray: true},
            'add': {url : 'api/patient-results/add', method: 'POST'},
            'resendAll': {url: 'api/patient-results/resend-all', method: 'POST', isArray: false},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SentLabResultController', SentLabResultController);

    SentLabResultController.$inject = ['$q', 'CoreService', 'PatientResult', '$uibModal', '$rootScope', 'PopupService',
        'GenericEntityDatatableService'];

    function SentLabResultController($q, CoreService, PatientResult, $uibModal, $rootScope, PopupService,
                                     GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Sent Lab Results',
            entityClassHumanized: 'Patient Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'getAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: "smsStatus",
                    title: 'Status SMS',
                },
                {
                    name: "smsStatus",
                    title: 'Status SMS',
                },
                {
                    name: "callStatus",
                    title: 'Status CALL',
                },
                {
                    name: "emailStatus",
                    title: 'Status EMAIL',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        vm.details(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    action: function (data) {
                        vm.printRangePDFs(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getSendAction(), {
                    name: 'Resend ALL',
                    action: function (data) {
                        return vm.resendAll(data.id);
                    },
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All Results',
                            iClass: 'fa fa-flask',
                            ngClass: function (filter) {
                                return filter.abnormalRange == null ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = null;
                            }
                        },
                        {
                            name: 'Abnormal',
                            iClass: 'fa fa-thumbs-down',
                            ngClass: function (filter) {
                                return filter.abnormalRange ?
                                    ['active', 'label-danger'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = true;
                            }
                        },
                        {
                            name: 'Normal',
                            iClass: 'fa fa-thumbs-up',
                            ngClass: function (filter) {
                                return filter.abnormalRange === false ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                filter.abnormalRange = false;
                            }
                        }
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        {
                            title: '',
                            iClass: 'fa fa-calendar',
                            ngClass: function (filter) {
                                return isCurrentMonth(filter.startDate, filter.endDate) ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                if (isCurrentMonth(filter.startDate, filter.endDate)) {
                                    var endDate = new Date();
                                    var startDate = new Date();
                                    startDate.setDate(endDate.getDate() - 30);

                                    filter.startDate = startDate;
                                    filter.endDate = endDate;
                                } else {
                                    filter.startDate = getCurrentMonthStartDay();
                                    filter.endDate = getCurrentMonthEndDay();
                                }
                            }
                        }
                    ]
                }
            ],
            filters: [
                {
                    name: 'abnormalRange',
                    visible: false
                },
                {
                    name: 'patientName',
                    // title: 'Patient Name',
                    placeholder: 'Patient Name...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'accessionNumber',
                    // title: 'Barcode',
                    placeholder: 'Barcode...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: ['PARTIAL', 'FINAL'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
                {
                    name: 'startDate',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        var startDate = new Date();
                        startDate.setDate(startDate.getDate() - 30);

                        return startDate;
                    },
                    visible: true
                },
                {
                    name: 'endDate',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
            ]
        }

        vm.printRangePDFs = printRangePDFs;
        vm.resendAll = resendAll;
        vm.details = details;

        function resendAll(id) {
            return $q(function (resolve, reject) {
                PatientResult.resendAll({id: id}, function (patientResult) {
                    resolve();
                });
            });
        }

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            } else {
                ids = getSelectedIds();
            }

            if (ids.length > 0) {
                PatientResult.getAllInOneRangePdf({ids: ids});
            }
        }

        function details(id) {
            PopupService.showPatientResultDet(id);
        }

        function getCurrentMonthStartDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
        }

        function getCurrentMonthEndDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
        }

        function isCurrentMonth(startDate, endDate) {

            return moment(startDate).format("MM/DD/YYYY") === moment(getCurrentMonthStartDay()).format("MM/DD/YYYY") &&
                moment(endDate).format("MM/DD/YYYY") === moment(getCurrentMonthEndDay()).format("MM/DD/YYYY");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('patient-result', {
                parent: 'entity',
                url: '/patient-result',
                data: {
                    authorities: [
                        ROLES.ROLE_USER
                    ],
                    pageTitle: 'Patient Results'
                },
                ncyBreadcrumb: {
                    label: 'Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/list/patient-result.html',
                        controller: 'PatientResultController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('sent-lab-result', {
                parent: 'entity',
                url: '/sent-lab-result',
                data: {
                    authorities: [
                        ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN
                    ],
                    pageTitle: 'Sent Lab Results'
                },
                ncyBreadcrumb: {
                    label: 'Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/sent-lab/sent-lab-result.html',
                        controller: 'SentLabResultController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('unassigned-results', {
                parent: 'entity',
                url: '/unassigned-results',
                data: {
                    authorities: [],
                    pageTitle: 'Unassigned Results'
                },
                ncyBreadcrumb: {
                    label: 'Unassigned Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/unassigned/patient-result-unassigned.html',
                        controller: 'PatientResultsUnassignedController',
                        controllerAs: 'vm'
                    }
                },
            })
            .state('partial-result', {
                parent: 'entity',
                url: '/partial-results',
                data: {
                    authorities: [],
                    pageTitle: 'Partial Results'
                },
                ncyBreadcrumb: {
                    label: 'Partial Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/partial/patient-result-partial.html',
                        controller: 'PatientResultPartialController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('critical-result', {
                parent: 'entity',
                url: '/critical-results',
                data: {
                    authorities: [],
                    pageTitle: 'Critical Results'
                },
                ncyBreadcrumb: {
                    label: 'Critical Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/critical/list/patient-result-critical.html',
                        controller: 'PatientResultCriticalController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('abnormal-result', {
                parent: 'entity',
                url: '/abnormal-results',
                data: {
                    authorities: [],
                    pageTitle: 'Abnormal Results'
                },
                ncyBreadcrumb: {
                    label: 'Abnormal Results'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-result/abnormal/patient-result-abnormal.html',
                        controller: 'PatientResultAbnormalController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultPartialController', PatientResultPartialController);

    PatientResultPartialController.$inject = ['GUIUtils', '$q', 'PatientResult', '$uibModal', 'CoreService',
        '$rootScope', 'GenericEntityDatatableService', 'PopupService'];

    function PatientResultPartialController(GUIUtils, $q, PatientResult, $uibModal, CoreService,
                                            $rootScope, GenericEntityDatatableService, PopupService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            status: 'PARTIAL'
        }

        vm.descriptor = {
            title: 'Partial Lab Results',
            entityClassHumanized: 'Patient Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'getAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Received Date',
                    render: function (data) {
                        return moment(data.lastModifiedDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Alert',
                    options: [
                        {key: 'width', value: '175px'}
                    ],
                    render: function (data) {
                        if (data.abnormalRange) {
                            return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
                        } else {
                            return GUIUtils.getStatusTemplate('NORMAL', 'success');
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        if (data.status == 'PARTIAL') {
                            return GUIUtils.getStatusTemplate(data.status, 'warning');
                        } else {
                            return GUIUtils.getStatusTemplate(data.status, 'primary');
                        }
                    }
                },
                {
                    name: null,
                    title: 'Assigned',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.chartId ? true : false);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        details(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    action: function (data) {
                        printRangePDFs(data.id);
                    },
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All Results',
                            iClass: 'fa fa-flask',
                            ngClass: function (filter) {
                                return filter.abnormalRange == null ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = null;
                            }
                        },
                        {
                            name: 'Abnormal',
                            iClass: 'fa fa-thumbs-down',
                            ngClass: function (filter) {
                                return filter.abnormalRange ?
                                    ['active', 'label-danger'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = true;
                            }
                        },
                        {
                            name: 'Normal',
                            iClass: 'fa fa-thumbs-up',
                            ngClass: function (filter) {
                                return filter.abnormalRange === false ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                filter.abnormalRange = false;
                            }
                        }
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        {
                            title: 'Current Month',
                            iClass: 'fa fa-calendar',
                            ngClass: function (filter) {
                                return isCurrentMonth(filter.startDate, filter.endDate) ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                if (isCurrentMonth(filter.startDate, filter.endDate)) {
                                    var endDate = new Date();
                                    var startDate = new Date();
                                    startDate.setDate(endDate.getDate() - 30);

                                    filter.startDate = startDate;
                                    filter.endDate = endDate;
                                } else {
                                    filter.startDate = getCurrentMonthStartDay();
                                    filter.endDate = getCurrentMonthEndDay();
                                }
                            },
                        }
                    ]
                }
            ],
            filters: [
                {
                    name: 'abnormalRange',
                    visible: false
                },
                {
                    name: 'patientName',
                    // title: 'Patient Name',
                    placeholder: 'Patient Name...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'accessionNumber',
                    // title: 'Barcode',
                    placeholder: 'Barcode...',
                    type: 'string',
                    visible: true,
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
                },
                {
                    name: 'startDate',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'endDate',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
            ]
        }

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            } else {
                ids = getSelectedIds();
            }

            if (ids.length > 0) {
                PatientResult.getAllInOneRangePdf({ids: ids});
            }
        }

        function details(id) {
            PopupService.showPatientResultDet(id);
        }

        function getCurrentMonthStartDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
        }

        function getCurrentMonthEndDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
        }

        function isCurrentMonth(startDate, endDate) {

            return moment(startDate).format("MM/DD/YYYY") === moment(getCurrentMonthStartDay()).format("MM/DD/YYYY") &&
                moment(endDate).format("MM/DD/YYYY") === moment(getCurrentMonthEndDay()).format("MM/DD/YYYY");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultController', PatientResultController);

    PatientResultController.$inject = ['GUIUtils', '$q', 'PatientResult', '$uibModal', 'CoreService', '$rootScope',
        'GenericEntityDatatableService', 'PopupService'];

    function PatientResultController(GUIUtils, $q, PatientResult, $uibModal, CoreService, $rootScope,
                                     GenericEntityDatatableService, PopupService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            abnormalRange: null
        }

        vm.descriptor = {
            title: 'Lab Results',
            entityClassHumanized: 'Patient Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'getAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Received Date',
                    render: function (data) {
                        return moment(data.lastModifiedDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Alert',
                    options: [
                        {key: 'width', value: '175px'}
                    ],
                    render: function (data) {
                        if (data.abnormalRange) {
                            return GUIUtils.getStatusTemplate('ABNORMAL', 'danger');
                        } else {
                            return GUIUtils.getStatusTemplate('NORMAL', 'success');
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        if (data.status == 'PARTIAL') {
                            return GUIUtils.getStatusTemplate(data.status, 'warning');
                        } else {
                            return GUIUtils.getStatusTemplate(data.status, 'primary');
                        }
                    }
                },
                {
                    name: null,
                    title: 'Assigned',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.chartId ? true : false);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        details(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    action: function (data) {
                        printRangePDFs(data.id);
                    },
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All Results',
                            iClass: 'fa fa-flask',
                            ngClass: function (filter) {
                                return filter.abnormalRange == null ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = null;
                            }
                        },
                        {
                            name: 'Abnormal',
                            iClass: 'fa fa-thumbs-down',
                            ngClass: function (filter) {
                                return filter.abnormalRange ?
                                    ['active', 'label-danger'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.abnormalRange = true;
                            }
                        },
                        {
                            name: 'Normal',
                            iClass: 'fa fa-thumbs-up',
                            ngClass: function (filter) {
                                return filter.abnormalRange === false ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                filter.abnormalRange = false;
                            }
                        }
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        {
                            title: 'Current Month',
                            iClass: 'fa fa-calendar',
                            ngClass: function (filter) {
                                return isCurrentMonth(filter.startDate, filter.endDate) ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                if (isCurrentMonth(filter.startDate, filter.endDate)) {
                                    var endDate = new Date();
                                    var startDate = new Date();
                                    startDate.setDate(endDate.getDate() - 30);

                                    filter.startDate = startDate;
                                    filter.endDate = endDate;
                                } else {
                                    filter.startDate = getCurrentMonthStartDay();
                                    filter.endDate = getCurrentMonthEndDay();
                                }
                            }
                        }
                    ]
                }
            ],
            filters: [
                {
                    name: 'abnormalRange',
                    visible: false
                },
                {
                    name: 'patientName',
                    // title: 'Patient Name',
                    placeholder: 'Patient Name...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'accessionNumber',
                    // title: 'Barcode',
                    placeholder: 'Barcode...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: ['PARTIAL', 'FINAL'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
                {
                    name: 'startDate',
                    // title: 'Start Date',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        var startDate = new Date();
                        startDate.setDate(startDate.getDate() - 30);

                        return startDate;
                    },
                    visible: true
                },
                {
                    name: 'endDate',
                    // title: 'End Date',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date();
                    },
                    visible: true
                },
            ]
        }

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            } else {
                ids = getSelectedIds();
            }

            if (ids.length > 0) {
                PatientResult.getAllInOneRangePdf({ids: ids});
            }
        }

        function details(id) {
            PopupService.showPatientResultDet(id);
        }

        function getCurrentMonthStartDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth(), 1);
        }

        function getCurrentMonthEndDay() {
            var nowDate = new Date();

            return new Date(nowDate.getFullYear(), nowDate.getMonth() + 1, 0);
        }

        function isCurrentMonth(startDate, endDate) {

            return moment(startDate).format("MM/DD/YYYY") === moment(getCurrentMonthStartDay()).format("MM/DD/YYYY") &&
                moment(endDate).format("MM/DD/YYYY") === moment(getCurrentMonthEndDay()).format("MM/DD/YYYY");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultCriticalController', PatientResultCriticalController);

    PatientResultCriticalController.$inject = ['CoreService', 'PatientResult', '$q', 'PatientResultDet', '$rootScope',
        '$uibModal', 'GUIUtils', 'DataTablesService', 'GenericEntityDatatableService'];

    function PatientResultCriticalController(CoreService, PatientResult, $q, PatientResultDet, $rootScope,
                                             $uibModal, GUIUtils, DataTablesService, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Critical Lab Results',
            entityClassHumanized: 'Critical Lab Results',
            entityStateName: 'patient-result',
            service: PatientResult,
            serviceMethod: 'critical',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'id',
            withSelectionColumn: true,
            disableSelectionColumn: function (filter) {
                return filter.acknowledge !== false;
            },
            disableAllSelectionColumn: function (filter) {
                return filter.acknowledge !== false;
            },
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'patientName',
                    title: 'Patient Name',
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Barcode',
                    render: function (data) {
                        return data.accessionNumber ? data.accessionNumber : '';
                    }
                },
                {
                    name: null,
                    title: 'Collection Date',
                    render: function (data) {
                        return moment(data.collectionDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: 'Received Date',
                    render: function (data) {
                        return moment(data.lastModifiedDate).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'testName',
                    title: 'Test Name'
                },
                {
                    name: 'testCode',
                    title: 'Test Code'
                },
                {
                    name: null,
                    title: 'Result',
                    render: function (data) {
                        return GUIUtils.getStatusTemplate(data.result + ' ' + data.status, 'danger');
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        if (data.isAcknowledge) {
                            return GUIUtils.getStatusTemplate("Acknowledge", 'success');
                        } else {
                            return GUIUtils.getStatusTemplate("Unacknowledged", 'danger');
                        }
                    }
                },
                {
                    name: null,
                    title: 'Assigned',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.chartId ? true : false);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        return modalCriticalResultDetails(data);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getGraphAction(), {
                    action: function (data) {
                        modalCriticalResultChart(data);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getCommentAction(), {
                    name: 'Add Comment',
                    action: function (data) {
                        modalCriticalResultCreateDetEmployeeComment(data.id);
                    },
                }),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Acknowledge Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-green']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return acknowledge(selected);
                                }
                            },
                            ngIf: function (filter) {
                                return filter.acknowledge === false;
                            }
                        }),
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All Results',
                            iClass: 'fa fa-flask',
                            ngClass: function (filter) {
                                return filter.acknowledge === null ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.acknowledge = null;
                            }
                        },
                        {
                            name: 'Acknowledge',
                            iClass: 'fa fa-spinner',
                            ngClass: function (filter) {
                                return filter.acknowledge ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.acknowledge = true;
                            }
                        },
                        {
                            name: 'Unacknowledged',
                            iClass: 'fa fa-circle-o',
                            ngClass: function (filter) {
                                return filter.acknowledge === false ?
                                    ['active', 'bg-red'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                filter.acknowledge = false;
                            }
                        }
                    ],
                },
            ],
            filters: [
                {
                    name: 'acknowledge',
                    visible: false,
                    defaultValue: function () {
                        return false;
                    }
                }
            ]
        }

        function acknowledge(selected) {
            var criticalResults = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve) {
                PatientResultDet.acknowledge({ids: criticalResults}, function () {
                    resolve();
                });
            });
        }

        function modalCriticalResultDetails(data) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-result/critical/detail/patient-result-critical-dialog.html',
                    controller: 'PatientResultCriticalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        result: data
                    }
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function modalCriticalResultChart(data) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-result/dashboard/critical/chart/patient-result-critical-chart-dialog.html',
                controller: 'PatientResultCriticalChartDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    result: data
                }
            });
        }

        function modalCriticalResultCreateDetEmployeeComment(id) {
            $uibModal.open({
                templateUrl: 'app/entities/pr-det-employee-comment/update/pr-det-employee-comment-dialog.html',
                controller: 'PRDetEmployeeCommentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    prDetEmployeeComment: {
                        comment: null,
                        patientResultDetId: id,
                        employeeId: null,
                        id: null
                    }
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultCriticalDialogController', PatientResultCriticalDialogController);

    PatientResultCriticalDialogController.$inject = ['$uibModalInstance', 'result', 'PatientResultDet'];

    function PatientResultCriticalDialogController($uibModalInstance, result, PatientResultDet) {
        var vm = this;

        vm.criticalResult = result;
        vm.comments = PatientResultDet.getComments({id: result.id});
        vm.testResult =  result.result + ' (' + result.status + ')';
        vm.acknowledgeBy = result.name + ' ' + result.lastName;

        vm.clear = clear;
        vm.acknowledge = acknowledge;

        PatientResultDet.getEmployeeComments({id: result.id}, function (comments) {
            vm.prDetEmployeeComments = comments;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function acknowledge() {
            PatientResultDet.acknowledge({ids: [result.id]}, function () {
                $uibModalInstance.close('success')
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultCriticalChartDialogController', PatientResultCriticalChartDialogController);

    PatientResultCriticalChartDialogController.$inject = ['$uibModalInstance', 'result', 'PatientResult', 'moment', 'PatientResultDet'];

    function PatientResultCriticalChartDialogController($uibModalInstance, result, PatientResult, moment, PatientResultDet) {
        var vm = this;

        vm.criticalResult = result;
        vm.testResult = result.result + ' (' + result.status + ')';
        vm.acknowledgeBy = result.name + ' ' + result.lastName;

        vm.clear = clear;
        vm.getResults = getResults;
        vm.acknowledge = acknowledge;

        getResults();

        function getResults() {
            PatientResultDet.get6M({detailId: result.id}, function (results) {
                _.forEach(results, function (result) {
                    vm.labels.push(moment(result.date).format('MM/DD/YYYY'));
                    vm.data[0].push(result.result);
                    var style = getPointStyle(result);
                    vm.colors[0].pointBackgroundColor.push(style.pointBackgroundColor);
                    vm.colors[0].pointRadius.push(style.pointRadius)
                });
            });
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function acknowledge() {
            PatientResultDet.acknowledge({ids: [result.id]}, function () {
                $uibModalInstance.close(true);
            }, function () {
            })
        };

        vm.labels = [];
        vm.series = ['Results'];
        vm.data = [
            []
        ];
        vm.datasetOverride = [{yAxisID: 'y-axis-1'}, {yAxisID: 'y-axis-2'}];
        vm.options = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left'
                    }
                ]
            }
        };
        vm.colors = [{
            fillColor: "rgba(151,187,205,0.2)",
            strokeColor: "rgba(151,187,205,1)",
            pointColor: "rgba(151,187,205,1)",
            pointStrokeColor: "#fff",
            pointHighlightFill: "#fff",
            pointHighlightStroke: "rgba(151,187,205,1)",
            pointBackgroundColor: [],
            pointRadius: []
        }];

        function getPointStyle(result) {
            switch (result.status) {
                case 'LL':
                case 'HH':
                    return {pointBackgroundColor: 'red', pointRadius: 12};
                case 'L':
                case 'H':
                    return {pointBackgroundColor: 'blue', pointRadius: 10};
                default :
                    return {pointBackgroundColor: 'green', pointRadius: 6};
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ELabsController', ELabsController);

    ELabsController.$inject = ['$uibModal', 'PatientResult', 'chart', 'ParseLinks', 'AlertService','CoreService', 'Auth',
        'PopupService', '$rootScope', '$state', '$scope', 'access', 'LabCompendium', 'ACTIONS', 'params', 'TAB'];

    function ELabsController($uibModal, PatientResult, chart, ParseLinks, AlertService, CoreService, Auth,
                             PopupService, $rootScope, $state, $scope, access, LabCompendium, ACTIONS, params, TAB) {
        var vm = this;
        vm.page = 1;
        vm.result = [];
        vm.itemsPerPage = 10;
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.E_LAB);
        vm.chart = chart;
        vm.access = access;
        vm.toggleAllRows = false;

        vm.details = details;
        vm.toggleItem = toggleItem;
        vm.transition = transition;
        vm.requisition = requisition;
        vm.printRangePDFs = printRangePDFs;
        vm.search = search;
        vm.toggleRow = toggleRow;
        vm.toggleAllRow = toggleAllRow;

        function toggleItem() {
            CoreService.togglePanel('eLabs');
        }

        function details(id) {
            PopupService.showPatientResultDet(id).result.then(function () {
                loadAll();
            });
        }

        function requisition(item) {
            PopupService.showLabRequisitionDetailPopup(null, item.accessionNumber, null);
        }

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_ELABS_VIEW, access) || !vm.active) {
                return;
            }

            PatientResult.getAllByFilter({
                chartId: chart.id,
                facilityId: chart.facility.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.result = data;

                if(vm.toggleAllRows){
                    for (var i = 0; i < vm.result.length; i++) {
                        vm.result[i].active = vm.toggleAllRows;

                        if (vm.result[i].id && vm.result[i].active && !vm.result[i].codes){
                            getTestCodesByBarcode(vm.result[i]);
                        }
                    }
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function printRangePDFs(id) {
            var ids;

            if (id) {
                ids = [id];
            }

            if (ids.length > 0) {
                PatientResult.getAllInOneRangePdf({ids: ids});
            }
        }

        function search() {
            vm.page = 1;
            transition();
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result == TAB.E_LAB) {
                vm.active = true;
                loadAll();
            }
        });

        $scope.$on('$destroy', unsubscribe);

        function toggleAllRow() {
            vm.toggleAllRows = !vm.toggleAllRows;
            for (var i = 0; i < vm.result.length; i++) {
                vm.result[i].active = vm.toggleAllRows;

                if (vm.result[i].id && vm.result[i].active && !vm.result[i].codes){
                    getTestCodesByBarcode(vm.result[i]);
                }
            }
        }

        function toggleRow(item) {
            item.active = !item.active;

            if (item.active) {
                getTestCodesByBarcode(item);
            }
        }

        function getTestCodesByBarcode(item){
            if(item.accessionNumber) {
                LabCompendium.findAllByBarcode({barcode: item.accessionNumber}, function (result) {
                    if (result.length > 0) {
                        item.codes =
                            _.join(
                                _.map(result, function (item) {
                                    return item.code;
                                }), ', ');
                    }
                })
            }
        }
    }
})();

(function () {
        'use strict';

        angular
            .module('bluebookApp')
            .controller('PatientResultAbnormalController', PatientResultAbnormalController);

        PatientResultAbnormalController.$inject = ['CoreService', 'PatientResult', '$q', 'PatientResultDet', 'moment',
            '$rootScope', '$uibModal', 'GUIUtils', 'DataTablesService', 'GenericEntityDatatableService', 'PopupService'];

        function PatientResultAbnormalController(CoreService, PatientResult, $q, PatientResultDet, moment,
                                                 $rootScope, $uibModal, GUIUtils, DataTablesService,
                                                 GenericEntityDatatableService, PopupService) {
            var vm = this;

            var params = {
                facilityId: CoreService.getCurrentFacility().id,
            }

            vm.descriptor = {
                title: 'Abnormal Lab Results',
                entityClassHumanized: 'Abnormal Lab Results',
                entityStateName: 'patient-result',
                service: PatientResult,
                serviceMethod: 'abnormal',
                params: params,
                pagination: 'remote',
                newAction: false,
                options: [
                    {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
                ],
                selectionColumn: 'id',
                withSelectionColumn: true,
                disableSelectionColumn: function (filter) {
                    return filter.acknowledge !== false;
                },
                disableAllSelectionColumn: function (filter) {
                    return filter.acknowledge !== false;
                },
                columns: [
                    {
                        name: 'id',
                        title: 'ID',
                    },
                    {
                        name: 'patientName',
                        title: 'Patient Name',
                    },
                    {
                        name: 'dob',
                        title: 'DOB',
                        render: function (data) {
                            return moment(data.dob).format("MM/DD/YYYY");
                        }
                    },
                    {
                        name: null,
                        title: 'Barcode',
                        render: function (data) {
                            return data.accessionNumber ? data.accessionNumber : '';
                        }
                    },
                    {
                        name: null,
                        title: 'Collection Date',
                        render: function (data) {
                            return moment(data.collectionDate).format("MM/DD/YYYY");
                        }
                    },
                    {
                        name: null,
                        title: 'Received Date',
                        render: function (data) {
                            return moment(data.lastModifiedDate).format("MM/DD/YYYY");
                        }
                    },
                    {
                        name: 'testName',
                        title: 'Test Name'
                    },
                    {
                        name: 'testCode',
                        title: 'Test Code'
                    },
                    {
                        name: null,
                        title: 'Result',
                        render: function (data) {
                            return GUIUtils.getStatusTemplate(data.result + ' ' + data.status, 'danger');
                        }
                    },
                    {
                        name: 'status',
                        title: 'Status',
                        render: function (data) {
                            if (data.ackAbnormal) {
                                return GUIUtils.getStatusTemplate("Acknowledge", 'success');
                            } else {
                                return GUIUtils.getStatusTemplate("Unacknowledged", 'danger');
                            }
                        }
                    },
                    {
                        name: null,
                        title: 'Assigned',
                        render: function (data) {
                            return GUIUtils.colorHtmlYesNo(data.chartId ? true : false);
                        }
                    }
                ],
                rowActions: [
                    angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                        action: function (data) {
                            details(data.patientResultId);
                        },
                    }),
                    angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                        action: function (data) {
                            printRangePDFs(data.patientResultId);
                        },
                    })
                ],
                leftActions: [
                    {
                        type: 'group',
                        buttons: [
                            angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                                name: 'Acknowledge Selected',
                                disabledOnEmpty: true,
                                ngClass: function () {
                                    return ['bg-green']
                                },
                                action: function (filter, selected) {
                                    if (selected.length > 0) {
                                        return acknowledge(selected);
                                    }
                                },
                                ngIf: function (filter) {
                                    return filter.acknowledge === false;
                                }
                            }),
                        ]
                    },
                ],
                actions: [
                    {
                        type: 'group',
                        buttons: [
                            {
                                name: 'All Results',
                                iClass: 'fa fa-flask',
                                ngClass: function (filter) {
                                    return filter.acknowledge === null ?
                                        ['active', 'bg-green'] :
                                        [];
                                },
                                action: function (filter) {
                                    filter.acknowledge = null;
                                }
                            },
                            {
                                name: 'Acknowledge',
                                iClass: 'fa fa-spinner',
                                ngClass: function (filter) {
                                    return filter.acknowledge ?
                                        ['active', 'bg-green'] :
                                        [];
                                },
                                action: function (filter) {
                                    filter.acknowledge = true;
                                }
                            },
                            {
                                name: 'Unacknowledged',
                                iClass: 'fa fa-circle-o',
                                ngClass: function (filter) {
                                    return filter.acknowledge === false ?
                                        ['active', 'bg-red'] :
                                        [];
                                },
                                action: function (filter, selected) {
                                    filter.acknowledge = false;
                                }
                            }
                        ],
                    },
                ],
                filters: [
                    {
                        name: 'acknowledge',
                        visible: false,
                        defaultValue: function () {
                            return false;
                        }
                    }
                ]
            }

            function acknowledge(selected) {
                var abnormalResults = _.map(selected, function (item) {
                    return item.id;
                });

                return $q(function (resolve) {
                    PatientResultDet.acknowledgeAbnormal({ids: abnormalResults}, function () {
                        resolve();
                    });
                });
            }

            function printRangePDFs(id) {
                var ids;

                if (id) {
                    ids = [id];
                } else {
                    ids = getSelectedIds();
                }

                if (ids.length > 0) {
                    PatientResult.getAllInOneRangePdf({ids: ids});
                }
            }

            function details(id) {
                PopupService.showPatientResultDet(id);
            }
        }
    }
)();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientOrderTest', PatientOrderTest);

    PatientOrderTest.$inject = ['$resource', 'DateUtils'];

    function PatientOrderTest ($resource, DateUtils) {
        var resourceUrl =  'api/patient-order-tests/:id';

        return $resource(resourceUrl, {}, {
            'findAllPatientOrderTestByPatientOrder': { 'url': 'api/patient-order-tests/by-patient-order-id/:id', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientOrderItem', PatientOrderItem);

    PatientOrderItem.$inject = ['$resource', 'DateUtils'];

    function PatientOrderItem ($resource, DateUtils) {
        var resourceUrl =  'api/patient-order-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { url: 'api/all-order-items/', method: 'GET', isArray: true},
            'getOrderItemsCollected': { url: 'api/order-items-collected/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.collectedDate = DateUtils.convertLocalDateFromServer(data.collectedDate);
                        data.scheduleDate = DateUtils.convertLocalDateFromServer(data.scheduleDate);
                        data.sentDate = DateUtils.convertLocalDateFromServer(data.sentDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    copy.scheduleDate = DateUtils.convertLocalDateToServer(copy.scheduleDate);
                    copy.sentDate = DateUtils.convertLocalDateToServer(copy.sentDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.collectedDate = DateUtils.convertLocalDateToServer(copy.collectedDate);
                    copy.scheduleDate = DateUtils.convertLocalDateToServer(copy.scheduleDate);
                    copy.sentDate = DateUtils.convertLocalDateToServer(copy.sentDate);
                    return angular.toJson(copy);
                }
            },
            'cancel': { url: 'api/patient-order-items/cancel/:id', method: 'GET'},
            'findAllPatientOrderItemByPatientOrderTest': { 'url': 'api/patient-order-items/by-patient-order-test-id/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientOrder', PatientOrder);

    PatientOrder.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function PatientOrder($resource, DateUtils, DataUtils) {
        var resourceUrl = 'api/patient-orders/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByBarcode': {
                method: 'GET',
                url: 'api/patient-orders/by-barcode/:barcode'
            },
            'update': {method: 'PUT'},
            'create': {url: "api/patient-orders/create", method: 'POST', isArray: true},
            'findAllByChart': {'url': "api/patient-orders/by-chart", method: 'GET', isArray: true},
            'getOrderAsNeeded': {
                url: 'api/patient-orders/patient-order-as-needed/by-facility', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(copy);
                }
            },
            'pdfBarcodeLabels': {
                url: 'api/patient-orders/pdf-barcode-labels', method: 'POST', responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'getBarcodeLabels': {url: 'api/patient-orders/get-barcode-labels', method: 'POST', isArray: true},
            'getOrderByFacilityIdDateChartIdBarcodePhysician': {
                url: 'api/patient-orders/by-facility-date-chart-physician', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);

                    return angular.toJson(copy);
                }
            },
            'createRequisitionWithOrderAsNeeded': {
                url: 'api/patient-orders/create-requisition-as-needed/by-order-date', method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.date = DateUtils.convertLocalDateToServer(data.date);
                    return angular.toJson(copy);
                }
            },
            'filter': {'url': 'api/patient-orders/filter', method: 'GET', isArray: true},
            'changeDrawDay': {url: 'api/patient-orders/change-draw-day', method: 'POST', isArray: true},
            'getPDFManifest': {
                url: 'api/patient-orders/get-manifest-pdf', method: 'POST', responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'savePendingSignature': {url: "api/patient-orders/save-sign", method: 'POST'},
            'saveDiscontinuePatientOrder': {url: "api/patient-orders/save-discontinue-sign", method: 'POST'},
            'markDates': {
                url: "api/patient-orders/mark-dates", method: 'POST', isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    if (copy.date) {
                        copy.date = DateUtils.convertLocalDateToServer(copy.date);
                    }
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i] = {date: data[i].date, class: data[i].sent ? 'markSentClass' : 'markNotSentClass'};
                        }
                    }
                    return data;
                }
            },
            'getAllOrderFrequency': {'url': "api/patient-orders/order-frequency", method: 'GET', isArray: true},
            'getPDFLabRequisition': {
                url: 'api/patient-orders/get-lab-requisition-pdf/:barcode', method: 'GET', responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'findAllPhysicianReview': {url: 'api/patient-orders/physician-review', method: 'GET', isArray: true},
            'sign': {url: 'api/patient-orders/sign', method: 'POST'},
            'patientOrderChartCreate': {
                url: "api/patient-orders/chart/create", method: 'POST',
                isArray: true
            },
            'printAndManifest': {url: 'api/patient-orders/print-and-manifest', method: 'POST', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-requisition', {
                parent: 'entity',
                url: '/lab-requisition',
                data: {
                    authorities: [],
                    pageTitle: 'Requisitions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-order/lab-requisition/list/lab-requisition.html',
                        controller: 'LabRequisitionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id,
                            date: null,
                            itemStatus: null,
                            firstName: null,
                            lastName: null,
                            dob: null,
                            barcode: null,
                            laboratory: null,
                            start: null,
                            end: null
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [
                            ACTIONS.ACTION_ADD_PATIENT_ORDER_LAB_REQUISITION
                        ];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabRequisitionController', LabRequisitionController);

    LabRequisitionController.$inject = ['$q', 'GUIUtils', 'PatientOrder', 'DYMO', 'CoreService', 'dialogs', '$uibModal',
        'DateUtils', '$rootScope', 'PopupService', 'access', 'ACTIONS', 'LabRequisitionSignature',
        'Chart', 'toastr', 'Principal', 'GenericEntityDatatableService'];

    function LabRequisitionController($q, GUIUtils, PatientOrder, DYMO, CoreService, dialogs, $uibModal,
                                      DateUtils, $rootScope, PopupService, access, ACTIONS, LabRequisitionSignature,
                                      Chart, toastr, Principal, GenericEntityDatatableService) {

        var vm = this;

        vm.rmConfig = {
            mondayStart: false,
            initState: "month", /* decade || year || month */
            maxState: "decade",
            minState: "month",
            decadeSize: 12,
            monthSize: 42, /* "auto" || fixed nr. (35 or 42) */
            min: new Date("2016-01-01"),
            max: null,
            format: "yyyy-MM-dd",
            markDates: function (date) {
                return PatientOrder.markDates({facilityId: CoreService.getCurrentFacility().id, date: date})
            },
            redraw: 'bluebookApp:redrawPatientOrderCalendar'
        }

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Lab Requisitions',
            entityClassHumanized: 'Requisition',
            entityStateName: 'requisition',
            service: PatientOrder,
            serviceMethod: 'filter',
            params: params,
            // pagination: 'local',
            newAction: false,
            options: [{key: 'aaSorting', value: [[0, 'asc']]}],
            localSearch: false,
            withSelectionColumn: true,
            selectionColumn: 'patientOrderId',
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + (data.middleName == null ? " " : " " + data.middleName + " ") + data.lastName;
                    }
                },
                {
                    name: 'patientOrderId',
                    title: 'Order',
                },
                {
                    name: 'dateBirth',
                    title: 'D.O.B',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'barcode',
                    title: 'Barcode',
                    render: function (data) {
                        return data.barcode ? GUIUtils.getStatusTemplate(data.barcode.toString(), 'primary') : null;
                    }
                },
                {
                    name: 'laboratory',
                    title: 'Laboratory',
                    render: function (data) {
                        if (data.laboratoryName) {
                            return data.laboratoryName && data.laboratoryName.length > 20 ? data.laboratoryName.substr(0, 20) + "..." : data.laboratoryName;
                        } else {
                            return "-";
                        }
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                    render: function (data) {
                        return data.itemStatus ? GUIUtils.colorHtmlStatusRequisition(data.itemStatus) : null;
                    }
                },
                {
                    name: null,
                    title: 'Signed',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.signed ? true : false);
                    }
                }
            ],
            rowActions: [
                // GenericEntityDatatableService.getEditAction('acuity'),
                // GenericEntityDatatableService.getDeleteAction('acuity')
                {
                    name: 'Sign',
                    action: function (data) {
                        return vm.addSignature(data.chartId, data.barcode);
                    },
                    aClass: 'dd-link green',
                    iClass: 'fa fa-edit',
                    ngIf: function (data) {
                        return !data.signatureId && data.barcode;
                    }
                },
                {
                    name: 'Requisition PDF',
                    aClass: 'dd-link orange',
                    iClass: 'fa fa-file-pdf-o',
                    ngIf: function (data) {
                        return data.barcode;
                    },
                    action: function (data) {
                        PatientOrder.getPDFLabRequisition({barcode: data.barcode});
                    }
                },
                {
                    name: 'Details',
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-file-text',
                    action: function (data) {
                        PopupService.showLabRequisitionDetailPopup(data.patientOrderId, data.barcode, data.scheduleDate);
                    }
                },
                {
                    name: 'Add Results',
                    aClass: 'dd-link red',
                    iClass: 'fa fa-barcode',
                    ngIf: function (data) {
                        return data.barcode && !data.patientResultId;
                    },
                    action: function (data) {
                        return vm.addPatientResult(data.barcode);
                    }
                },
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Requisition',
                            disabledOnEmpty: false,
                            action: function () {
                                return vm.create();
                            }
                        })
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'Add Order',
                            ngIf: function () {
                                var accessAddPatientOrder = access[ACTIONS.ACTION_ADD_PATIENT_ORDER_LAB_REQUISITION].roles;

                                return Principal.hasAnyAuthority(accessAddPatientOrder);
                            },
                            action: function () {
                                return vm.addLabOrder();
                            }
                        })
                    ]
                }
            ],
            actions: [
                {
                    type: 'split',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getPrintAction(), {
                            disabledOnEmpty: true,
                            ngClass: function (filter) {
                                return ['bg-green'];
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.printLabels(selected)
                                }
                            },
                        }),
                        angular.extend({}, GenericEntityDatatableService.getPrintAction(), {
                            name: 'Print in DYMO Printer',
                            disabledOnEmpty: true,
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.printDYMOLabels(selected)
                                }
                            }
                        })
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getHourGlassAction(), {
                            name: 'Manifest',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['label-primary']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.manifest(selected)
                                }
                            }
                        }),
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCalendarAction(), {
                            name: 'Change Date',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['label-warning']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return vm.changeDrawDate(selected)
                                }
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'firstName',
                    type: 'string',
                    placeholder: 'First Name',
                    visible: true
                },
                {
                    name: 'lastName',
                    type: 'string',
                    placeholder: 'Last Name',
                    visible: true
                },
                {
                    name: 'dob',
                    placeholder: 'D.O.B...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'barcode',
                    // title: 'Barcode',
                    placeholder: 'Barcode...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: GUIUtils.getItemStatus(),
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
                {
                    name: 'laboratory',
                    // title: 'Barcode',
                    placeholder: 'Laboratory...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'date',
                    type: 'rm2-datepicker',
                    format: $rootScope.inputDateFormat,
                    rmConfig: vm.rmConfig,
                    read: function (filter) {
                        return filter.date ? moment(filter.date).format("YYYY-MM-DD") : null;
                    },
                    defaultValue: function () {
                        return new Date()
                    },
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                    visible: true
                }
            ],
            filterCallback: function (filter) {
                vm.date = filter.date;
            }
        }

        vm.date = new Date();
        vm.itemStatus = GUIUtils.getItemStatus();
        vm.facility = CoreService.getCurrentFacility();

        vm.detail = detail;
        vm.create = create;
        vm.manifest = manifest;
        vm.printLabels = printLabels;
        vm.changeDrawDate = changeDrawDate;
        vm.labRequisitionPDF = labRequisitionPDF;
        vm.getSelectedBarcodes = getSelectedBarcodes;
        vm.printDYMOLabels = printDYMOLabels;
        vm.addLabOrder = addLabOrder;
        vm.addPatientResult = addPatientResult;
        vm.addSignature = addSignature;

        function getSelectedBarcodes2(selected) {
            return _.map(selected, function (item) {
                return {
                    chartId: item.chartId,
                    date: DateUtils.convertLocalDateToServer(item.scheduleDate),
                    patientOrderId: item.patientOrderId,
                    barcode: item.barcode,
                    itemStatus: item.itemStatus
                }
            });
        }

        function create() {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-order/lab-requisition/create/lab-requisition-dialog.html',
                controller: 'LabRequisitionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    date: [function () {
                        return vm.date;
                    }]
                }
            }).result;
        }

        function changeDrawDate(selected) {
            return $q(function (resolve) {
                var dlg = dialogs.confirm('Please Confirm', 'Are you sure you want to change the draw day? Items with results data will not be changed', {size: 'md'});

                dlg.result.then(function (btn) {
                    $uibModal.open({
                        templateUrl: 'app/entities/window-picker/date-picker-dialog.html',
                        controller: 'DatePickerDialogController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            date: new Date()
                        }
                    }).result.then(function (result) {
                        var values = _.map(getSelectedBarcodes2(selected), function (value) {
                            value.newDate = DateUtils.convertLocalDateToServer(result.date);

                            return value;
                        });

                        values = _.filter(values, function (value) {
                            return value.itemStatus === 'SCHEDULED' || value.itemStatus === 'PRINTED';
                        });

                        if (values.length > 0) {
                            PatientOrder.changeDrawDay({drawDays: values}, function (result) {
                                $rootScope.$broadcast('bluebookApp:redrawPatientOrderCalendar');
                                resolve();
                            }, function () {
                                alert("Error change draw days orders");
                                resolve();
                            });
                        }
                    });
                })
            })
        }

        function printLabels(selected) {
            var values = getSelectedBarcodes2(selected);

            if (values.length > 0) {
                return $q(function (resolve, reject) {
                    PatientOrder.pdfBarcodeLabels({
                        facilityId: vm.facility.id,
                        printBarcode: values
                    }, function () {
                        resolve();
                    });
                });
            }
        }

        function printDYMOLabels(selected) {
            var values = getSelectedBarcodes2(selected);

            if (values.length > 0) {
                return $q(function (resolve, reject) {
                    PatientOrder.getBarcodeLabels({
                        facilityId: vm.facility.id,
                        printBarcode: values
                    }, function (result) {
                        _.forEach(result, function (label) {
                            DYMO.printPatientOrderLabel({
                                barcode: label.barcode,
                                name: label.firstName + (label.middleName ? label.middleName + " " : " ") + label.lastName,
                                dob: label.dateBirth,
                                collectedDate: label.scheduleDate,
                                tube: label.tube,
                                account: label.accountNo
                            })
                        });

                        resolve();
                    });
                });
            }
        }

        function getSelectedBarcodes() {
            var values = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var index = _.findIndex(vm.orders, function (order) {
                        return order.patientOrderId == parseInt(id);
                    });
                    values.push({
                        chartId: vm.orders[index].chartId,
                        date: DateUtils.convertLocalDateToServer(vm.orders[index].scheduleDate),
                        patientOrderId: vm.orders[index].patientOrderId,
                        barcode: vm.orders[index].barcode,
                        itemStatus: vm.orders[index].itemStatus
                    });
                }
            }

            return values;
        }

        function manifest(selected) {
            var values = _.map(getSelectedBarcodes2(selected), function (value) {
                return value.barcode;
            });

            return $q(function (resolve, reject) {
                PatientOrder.getPDFManifest({facilityId: vm.facility.id, barcodes: values}, function () {
                    resolve();
                });
            });
        }

        function labRequisitionPDF(barcode) {
            PatientOrder.getPDFLabRequisition({barcode: barcode});
        }

        function detail(patientOrderId, barcode, date) {
            PopupService.showLabRequisitionDetailPopup(patientOrderId, barcode, date);
        }

        function addLabOrder() {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-order/lab-requisition/create-order/lab-order-create-dialog.html',
                controller: 'LabOrderCreateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    filter: function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dob: null,
                            social: null,
                            preferredName: null,
                            middleName: null
                        };
                    },
                    chart: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            oneTimeOnly: false,
                            sobrietyDate: null,
                            phone: null,
                            altPhone: null,
                            email: null,
                            address: null,
                            addressTwo: null,
                            city: null,
                            zip: null,
                            livingArrangement: null,
                            referrerRequired: null,
                            admissionDate: new Date(),
                            dischargeDate: null,
                            dischargeTo: 'N/A',
                            employees: null,
                            repName: null,
                            facility: CoreService.getCurrentFacility(),
                            status: 'WAITING',
                            occupancy: null,
                            employer: null,
                            employerPhone: null,
                            referrerRequiredContact: false,
                            dateFirstContact: null,
                            firstContactName: null,
                            firstContactRelationship: null,
                            firstContactPhone: null,
                            typePaymentMethods: null,
                            patientLicenseOriginalId: null,
                            patientLicenseId: null,
                            pictureRefId: null,
                            pictureRefOriginalId: null,
                            patient: {
                                firstName: null,
                                middleName: null,
                                lastName: null,
                                preferredName: null,
                                gender: null,
                                race: null,
                                social: null,
                                dateBirth: null
                            },
                            typeEthnicity: null,
                            allowReadmit: true,
                            readmitReason: null
                        };
                    }],
                    patientOrder: {
                        id: null,
                        chart: null,
                        signatureDate: null,
                        signed: false,
                        via: null,
                        signedBy: null,
                        discontinueBy: null,
                        discontinueCause: null,
                        staringDate: null,
                        endDate: null,
                        orderType: null,
                        icd10Code: null,
                        patientOrderTests: [],
                        patientOrderSignature: null
                    },
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.PHYSICIAN
                        }).$promise;
                    }]
                }
            }).result;
        }

        function addPatientResult(barcode) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-order/lab-requisition/add-result/add-lab-requisition-result-dialog.html',
                controller: 'AddLabRequisitionResultDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    data: {barcode: barcode},
                    patientOrder: ['PatientOrder', function (PatientOrder) {
                        return PatientOrder.getByBarcode({barcode: barcode}).$promise;
                    }]
                }
            }).result;
        }

        function addSignature(chartId, barcode) {
            return $q(function (resolve, reject) {
                Chart.get({id: chartId}, function (chart) {
                    if (PopupService.checkSigPlusExtLiteExtension()) {
                        startSign(barcode, resolve);
                    } else {
                        PopupService.showPatientSignaturePopup(chart).result.then(function (signature) {
                            LabRequisitionSignature.save({
                                barcode: barcode,
                                signature: signature
                            }, function () {
                                resolve();
                            }, function () {
                                resolve();
                            });
                        });
                    }
                })
            });
        }

        function startSign(barcode, resolve) {
            var message = {
                "firstName": "",
                "lastName": "",
                "eMail": "",
                "location": "",
                "imageFormat": 1,
                "imageX": 500,
                "imageY": 100,
                "imageTransparency": false,
                "imageScaling": false,
                "maxUpScalePercent": 0.0,
                "rawDataFormat": "ENC",
                "minSigPoints": 25
            };

            var SignResponseEventListener = function (event) {
                var str = event.target.getAttribute("msgAttribute");
                var objResponse = JSON.parse(str);
                var obj = null;

                if (typeof (objResponse) === 'string') {
                    obj = JSON.parse(objResponse);
                } else {
                    obj = JSON.parse(JSON.stringify(objResponse));
                }

                if (obj.errorMsg != null && obj.errorMsg != "" && obj.errorMsg != "undefined") {
                    toastr.error(obj.errorMsg);

                    resolve();
                } else {
                    if (obj.isSigned) {
                        LabRequisitionSignature.save({
                            barcode: barcode,
                            signature: {signature: "data:image/jpg;base64," + obj.imageData}
                        }, function () {
                            resolve();
                        }, function () {
                            resolve();
                        });
                    }
                }

                top.document.removeEventListener('SignResponse', SignResponseEventListener, false);
            }

            top.document.addEventListener('SignResponse', SignResponseEventListener, false);

            var messageData = JSON.stringify(message);
            var element = document.createElement("MyExtensionDataElement");
            element.setAttribute("messageAttribute", messageData);
            document.documentElement.appendChild(element);
            var evt = document.createEvent("Events");
            evt.initEvent("SignStartEvent", true, false);
            element.dispatchEvent(evt);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabRequisitionDetailController', LabRequisitionDetailController);

    LabRequisitionDetailController.$inject = ['$uibModalInstance', 'CoreService', 'DTColumnBuilder', 'DTOptionsBuilder',
        '$q', 'PatientOrder', 'AlertService', 'LabCompendium', 'patientOrder',
        'Chart', 'Insurance', 'barcode'];

    function LabRequisitionDetailController($uibModalInstance, CoreService, DTColumnBuilder, DTOptionsBuilder,
                                            $q, PatientOrder, AlertService, LabCompendium, patientOrder,
                                            Chart, Insurance, barcode) {
        var vm = this;
        vm.date = null;
        vm.chart = null;
        vm.primary = null;
        vm.dtInstance = {};

        vm.clear = clear;

        init();

        function init() {
            Chart.get({id: patientOrder.chartId}, function (chart) {
                vm.chart = chart;

                if (vm.chart.primary) {
                    Insurance.get({id: vm.chart.primary.id}, function (insurance) {
                        vm.primary = insurance;
                    });
                }
            });

            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();

                if (barcode.barcode && barcode.barcode.length > 0) {
                    LabCompendium.findAllByBarcode({barcode: barcode.barcode}, onSuccess, onError);
                } else {
                    LabCompendium.findAllByPatientOrder({id: patientOrder.id, date: barcode.date}, onSuccess, onError);
                }

                function onSuccess(data) {
                    defer.resolve(data);
                }

                function onError(error) {
                    AlertService.error(error.data.message);
                }

                return defer.promise;
            }).withPaginationType('full_numbers').withBootstrap().withDOM('tp').withDisplayLength(5).withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            });

            vm.dtColumns = [
                DTColumnBuilder.newColumn('code').withTitle('Test'),
                DTColumnBuilder.newColumn('description').withTitle('Description')
            ];

            vm.dtInstance1 = {};

            vm.dtOptions1 = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();

                defer.resolve([patientOrder]);

                return defer.promise;
            }).withPaginationType('full_numbers').withBootstrap().withDOM('tp').withDisplayLength(3).withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            });

            vm.dtColumns1 = [
                DTColumnBuilder.newColumn('id').withTitle('# Order'),
                DTColumnBuilder.newColumn('orderType').withTitle('Order Type'),
                DTColumnBuilder.newColumn(null).withTitle('Via').renderWith(function (data, type, full) {
                    return data.via ? data.via.name : "";
                }),
                DTColumnBuilder.newColumn(null).withTitle('Order Type').renderWith(function (data, type, full) {
                    return data.signedBy.firstName + " " + data.signedBy.lastName;
                })
            ];
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('LabOrderCreateDialogController', LabOrderCreateDialogController);

    LabOrderCreateDialogController.$inject = ['$uibModal', '$uibModalInstance', 'filter', 'chart', 'patientOrder', 'DateUtils', 'Chart', 'facility', 'ParseLinks',
        'WizardHandler', 'TypePaymentMethods', 'CountryState', 'GUIUtils', 'CoreService',
        'InsuranceCarrierSearch', 'InsuranceRelation', 'InsuranceType', 'Via',
        'Relational', 'FacilityLab', 'BUSINESS_ROLES', 'Icd10Search',
        'PatientOrder', 'LabCompendium', 'Diagnoses', 'Employee', 'Insurance', 'TypeRace',
        'TypeEthnicity', 'DYMO', '$scope', 'RATIONALE_TYPE', 'itHasCredentials', 'toastr'];

    function LabOrderCreateDialogController($uibModal, $uibModalInstance, filter, chart, patientOrder, DateUtils, Chart, facility, ParseLinks,
                                            WizardHandler, TypePaymentMethods, CountryState, GUIUtils, CoreService,
                                            InsuranceCarrierSearch, InsuranceRelation, InsuranceType, Via,
                                            Relational, FacilityLab, BUSINESS_ROLES, Icd10Search,
                                            PatientOrder, LabCompendium, Diagnoses, Employee, Insurance, TypeRace,
                                            TypeEthnicity, DYMO, $scope, RATIONALE_TYPE, itHasCredentials, toastr) {

        var vm = this;
        vm.chart = chart;
        vm.charts = [];
        vm.filter = filter;
        vm.facility = facility;
        vm.showChartList = false;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateBirth = false;
        vm.datePickerOpenStatus.insuranceDob = false;
        vm.chartSelected = false;
        vm.labOrderTitle = 'Lab Order';
        vm.getStaredTitle = 'Get Started';

        vm.page = 1;
        vm.itemsPerPage = 5;

        vm.patientOrder = patientOrder;
        vm.activeIcd10 = [];

        vm.patientOrderTest = {
            id: null,
            staringDate: null,
            endDate: null,
            icd10s: angular.copy(vm.activeIcd10),
            labCompendium: null,
            orderFrequency: null
        };

        vm.pin = "";
        vm.icd10s = [];
        vm.agree = false;
        vm.signature = "";
        vm.diagnoses = angular.copy(vm.activeIcd10);
        vm.employees = [];
        vm.hideTest = false;
        vm.frequency = null;
        vm.credentials = [];
        vm.via = Via.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.today = new Date();
        vm.labCompendiums = [];
        vm.activateSign = false;
        vm.itHasCredentials = itHasCredentials.value;
        vm.testCodes = [];
        vm.currentEmployee = CoreService.getCurrentEmployee();
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.endDateOptions = {};
        vm.staringDateOptions = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.staringDate = false;

        vm.relationals = Relational.findAllByFilter(getFilterByCorporationAndType());
        vm.laboratories = [];

        FacilityLab.filter({facilityId: vm.facility.id, page: 0, size: 1000, enabled: true}, function (result) {
            vm.facilityLabs = result;
        });

        vm.staringDateOptions = {
            minDate: new Date()
        };

        vm.cancel = cancel;
        vm.save = save;
        vm.search = search;
        vm.clearFilter = clearFilter;
        vm.getChartsPage = getChartsPage;
        vm.filterNextStep = filterNextStep;
        vm.activateLeftArrow = activateLeftArrow;
        vm.addSecondaryInsurance = addSecondaryInsurance;
        vm.clearPrimaryInsurance = clearPrimaryInsurance;
        vm.removeSecondaryInsurance = removeSecondaryInsurance;
        vm.setValidationClass = setValidationClass;
        vm.disableInsuranceSteps = disableInsuranceSteps;
        vm.getInsuranceCarrier = getInsuranceCarrier;
        vm.openCalendar = openCalendar;
        vm.isLastStep = isLastStep;

        vm.generateTest = generateTest;
        vm.getDiagnoses = getDiagnoses;
        vm.validateEndDate = validateEndDate;
        vm.changeOrderType = changeOrderType;
        vm.getLabCompendium = getLabCompendium;
        vm.changeLaboratory = changeLaboratory;
        vm.removeRelational = removeRelational;
        vm.selectRelational = selectRelational;
        vm.getEmployees = getEmployees;

        credentialsPermits();

        function loadDiagnosesByChart() {
            if (vm.chart.id) {
                vm.activeIcd10 = [];
                vm.patientOrder.patientOrderTests = [];
                Diagnoses.findAllActiveDiagnosesByChartId({id: vm.chart.id}, function (diagnoses) {
                    _.forEach(diagnoses, function (element) {
                        vm.activeIcd10.push(element.icd10);

                        vm.patientOrderTest.icd10s = angular.copy(vm.activeIcd10);
                    })
                });
            }
        }

        $scope.$watch('vm.chartSelected', function () {
            if (vm.chartSelected === true) {
                var steps = WizardHandler.wizard('createLabOrderWizard').getEnabledSteps();
                _.forEach(steps, function (step) {
                    if (step.title === vm.getStaredTitle) {
                        step.completed = true;
                        loadDiagnosesByChart()
                    }
                });
                WizardHandler.wizard('createLabOrderWizard').goTo(vm.labOrderTitle);
            }
        });

        $scope.$on('wizard:stepChanged', function (event, args) {
            if (args.index === 0) {
                vm.chartSelected = false;
            }
        });

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            getFilter();
        }

        function checkVoidParam(param) {
            if (!param || param === '') {
                param = null;
            }
        }

        function clearFilter() {
            vm.filter.firstName = null;
            vm.filter.lastName = null;
            vm.filter.dob = null;
            vm.filter.social = null;
            vm.filter.preferredName = null;
            vm.filter.middleName = null;
        }

        function getChartsPage(value) {
            if (value === 0) {
                vm.page++;
                getFilter();
            } else {
                vm.page--;
                getFilter();
            }
        }

        function getFilter() {
            var filter = angular.copy(vm.filter);

            filter.statuses = ['CURRENT'];
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.facilityId = vm.facility.id;

            if (filter.dob) {
                filter.dob = DateUtils.convertLocalDateToServer(filter.dob);
            } else {
                checkVoidParam(filter.dob);
            }

            checkVoidParam(filter.firstName);
            checkVoidParam(filter.middleName);
            checkVoidParam(filter.lastName);
            checkVoidParam(filter.preferredName);
            checkVoidParam(filter.social);

            Chart.filterLastClosedOrArchive(filter, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.charts = data;
                vm.showChartList = true;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function filterNextStep(item) {
            if (item == null) {
                vm.chart = chart;
                vm.disabledInsuranceSteps = true;
                vm.primaryInsurance = null;
                vm.secondaryInsurance = null;

                disableInsuranceSteps();
                WizardHandler.wizard('createLabOrderWizard').next();
            } else {
                Chart.get({id: item.id}, function (result) {
                    vm.chart = result;
                    vm.chartSelected = true;

                    if (vm.chart.primary) {
                        Insurance.get({id: vm.chart.primary.id}, function (insurance) {
                            insurance.id = null;

                            vm.primaryInsurance = insurance;
                        })
                    }

                    if (vm.chart.secondary) {
                        Insurance.get({id: vm.chart.secondary.id}, function (insurance) {
                            insurance.id = null;

                            vm.secondaryInsurance = insurance;
                        })
                    }

                    disableInsuranceSteps();
                })
            }

            vm.gender = GUIUtils.getGender();
            vm.states = CountryState.query();
            vm.race = TypeRace.byCorporation(CoreService.getFilterByCurrentCorporation());
            vm.ethnicity = TypeEthnicity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
            TypePaymentMethods.byFacility(CoreService.getFilterByFacility(vm.facility), function (result) {
                vm.paymentMethod = result;
            });
            vm.insuranceCarriers = [];
            vm.insuranceTypes = InsuranceType.byCorporation(CoreService.getFilterByCurrentCorporation());
            vm.insuranceRelations = InsuranceRelation.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        }

        function activateLeftArrow() {
            return vm.totalItems / vm.itemsPerPage > vm.page
        }

        function addSecondaryInsurance() {
            vm.secondaryInsurance = {};
        }

        function clearPrimaryInsurance() {
            vm.primaryInsurance = null;
            vm.primaryInsurance = vm.secondaryInsurance;
            vm.secondaryInsurance = null;
        }

        function removeSecondaryInsurance() {
            WizardHandler.wizard('createLabOrderWizard').previous();

            vm.secondaryInsurance = null;
        }

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function save() {
            vm.isSaving = true;

            if (vm.primaryInsurance) {
                vm.primaryInsurance.insuranceOrder = 1;
            }

            if (vm.secondaryInsurance) {
                vm.secondaryInsurance.insuranceOrder = 2;
            }

            var chart = angular.copy(vm.chart);
            chart.primary = vm.primaryInsurance;
            chart.secondary = vm.secondaryInsurance;

            var req = angular.extend({}, vm.patientOrder, {
                pin: vm.pin,
                signature: vm.signature,
                chart: chart
            });

            _.forEach(req.patientOrderTests, function (result) {
                result.staringDate = moment(result.staringDate).format('YYYY-MM-DD');
                result.endDate = moment(result.staringDate).format('YYYY-MM-DD');
            });

            if (req.patientOrderTests.length > 0) {
                PatientOrder.patientOrderChartCreate(req, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            PatientOrder.printAndManifest({
                facilityId: vm.facility.id,
                printBarcode:
                    _.map(result, function (printAndManifestDTO) {
                        return {
                            chartId: printAndManifestDTO.chartId,
                            patientOrderId: printAndManifestDTO.patientOrderId,
                            barcode: printAndManifestDTO.barcode
                        };
                    })
            }, function (data) {
                if (DYMO.loadPrinters()) {
                    _.forEach(data, function (label) {
                        DYMO.printPatientOrderLabel({
                            barcode: label.barcode,
                            name: label.firstName + (label.middleName ? label.middleName + " " : " ") + label.lastName,
                            dob: label.dateBirth,
                            collectedDate: label.scheduleDate,
                            tube: label.tube,
                            account: label.accountNo
                        });
                    });
                } else {
                    toastr.error('No DYMO printers are installed. Install DYMO printers.');
                }
                $uibModalInstance.close(true);
            }, function () {
                vm.isSaving = false;
            });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function disableInsuranceSteps() {
            vm.disabledInsuranceSteps = vm.chart.typePaymentMethods == null || vm.chart.typePaymentMethods.category !== 'Insurance';

            if (vm.disabledInsuranceSteps) {
                vm.primaryInsurance = null;
                vm.secondaryInsurance = null;
            }
        }

        function getInsuranceCarrier(query) {
            if (query) {
                if (query.length > 2) {
                    query = _.lowerCase(query);
                    InsuranceCarrierSearch.query({
                        query: query
                    }, function (result) {
                        if (result.length == 0) {
                            vm.carriers = [carrierTagTransform(query)];
                        } else {
                            vm.carriers = result;
                        }
                    });
                }
            }

        }

        function carrierTagTransform(newTag) {
            return {
                id: null,
                acctno: newTag,
                name: newTag
            };
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function isLastStep() {
            return WizardHandler.wizard('createLabOrderWizard').totalStepCount() === WizardHandler.wizard('createLabOrderWizard').currentStepNumber();
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.patientOrderTest.staringDate
        }

        function credentialsPermits() {
            if (vm.itHasCredentials) {
                vm.employees = [vm.currentEmployee];
                vm.patientOrder.signedBy = vm.currentEmployee;
                vm.patientOrder.signed = true;
            } else {
                vm.getEmployees();
            }
        }

        function getDiagnoses(query) {
            if (query && query.length > 1) {
                Icd10Search.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }

        function generateTest() {
            vm.labCompendiums.forEach(function (element) {
                var testTemp = {
                    id: null,
                    labCompendium: element,
                    icd10s: vm.patientOrderTest.icd10s,
                    labCompendiumName: element.description,
                    staringDate: vm.patientOrderTest.staringDate,
                    relationals: angular.copy(vm.patientOrderTest.relationals),
                    orderFrequency: vm.patientOrderTest.orderFrequency,
                    endDate: vm.patientOrderTest.endDate ? vm.patientOrderTest.endDate : vm.patientOrderTest.staringDate
                };
                vm.patientOrder.patientOrderTests.push(testTemp);
            });

            clearTest();
        }

        function clearTest() {
            vm.labCompendiums = [];
            vm.patientOrderTest.id = null;
            //vm.patientOrderTest.icd10s = vm.activeIcd10;
            vm.patientOrderTest.labCompendium = null;
        }

        function changeOrderType() {
            PatientOrder.getAllOrderFrequency(function (results) {
                if (results) {
                    if (vm.patientOrder.orderType === 'ONE_TIME')
                        vm.orderFrequencies = _.filter(results, function (result) {
                            return result.id === 'ONCE';
                        });
                    else vm.orderFrequencies = results;
                }
            });
        }

        function getLabCompendium(query) {
            if (vm.patientOrder.facilityLab) {
                LabCompendium.filter({
                    laboratoryId: vm.patientOrder.facilityLab.labId,
                    searchQuery: query,
                    page: vm.page - 1,
                    size: 40,
                    sort: 'code,asc',
                    facilityId: vm.facility.id
                }, function (result, headers) {
                    vm.testCodes = result;
                });
            }
        }

        function changeLaboratory() {
            vm.patientOrder.patientOrderTests = [];
            vm.testCodes = [];
            vm.labCompendiums = [];

            vm.getLabCompendium();
        }

        function removeRelational(relationals, index) {
            relationals.splice(index, 1);
        }

        function selectRelational(patientOrderTest) {
            $uibModal.open({
                templateUrl: 'app/entities/relational/select/relational-select-dialog.html',
                controller: 'RelationalSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl ',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    selectedRelationals: function () {
                        return patientOrderTest.relationals;
                    }
                }
            }).result.then(function (result) {
                patientOrderTest.relationals = _.filter(vm.relationals, function (relational) {
                    return _.find(result, function (id) {
                        return id === relational.id.toString();
                    });
                });
            });
        }

        function getFilterByCorporationAndType() {
            var filter = {};

            filter.corporationId = CoreService.getCorporation().id;
            filter.relationalType = RATIONALE_TYPE.LABORATORY;

            return filter;
        }

        function getEmployees(query) {
            if (vm.itHasCredentials) {
                return;
            }

            var filter = {
                page: 0,
                size: 200000,
                query: query,
                facilityId: CoreService.getCurrentFacility().id,
                businessRole: BUSINESS_ROLES.PHYSICIAN
            };

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabRequisitionDialogController', LabRequisitionDialogController);

    LabRequisitionDialogController.$inject = ['$uibModalInstance', 'DTColumnBuilder', 'DTOptionsBuilder',
        'PatientOrder', '$q', 'CoreService', '$compile', '$scope', 'GUIUtils', 'date',
        'DataTablesService'];

    function LabRequisitionDialogController($uibModalInstance, DTColumnBuilder, DTOptionsBuilder,
                                            PatientOrder, $q, CoreService, $compile, $scope, GUIUtils, date,
                                            DataTablesService) {
        var vm = this;
        vm.date = date;
        vm.orders = [];
        vm.ordersAsNeeded = [];
        vm.isSaving = false;
        vm.facility = CoreService.getCurrentFacility();
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.clear = clear;
        vm.create = create;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        vm.dtInstance = {};
        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            PatientOrder.getOrderAsNeeded({facilityId: vm.facility.id, date: vm.date}, function (result) {
                vm.ordersAsNeeded = result;
                defer.resolve(result);

                vm.selected = {};
                vm.selectAll = false;
            });
            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            }).withDisplayLength(10).withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]]);

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('id').withTitle('Order #'),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').renderWith(function (data, type, full) {
                return data.chart.lastName + ', '  + data.chart.firstName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').renderWith(function (data, type, full) {
                return moment(data.startDate).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(data.signed);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order Type').renderWith(function (data, type, full) {
                return data.orderType;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.orderStatus;
            })
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function create() {
            vm.isSaving = true;
            var ids = vm.getSelectedIds(vm.selected);

            if (ids.length > 0) {
                PatientOrder.createRequisitionWithOrderAsNeeded({ids: ids, date: vm.date}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AddLabRequisitionResultDialogController', AddLabRequisitionResultDialogController);

    AddLabRequisitionResultDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'data', 'PatientResult', 'LabCompendium', 'patientOrder'];

    function AddLabRequisitionResultDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                                     data, PatientResult, LabCompendium, patientOrder) {
        var vm = this;

        vm.data = data;
        vm.results = [];
        vm.abnormal = false;
        vm.patientOrder = patientOrder;

        vm.clear = clear;
        vm.save = save;
        vm.addOther = addOther;
        vm.remove = remove;
        vm.getLabCompendium = getLabCompendium;

        LabCompendium.findAllByBarcode({barcode: data.barcode}, function (result) {
            vm.labCompendiums = result;

            _.forEach(result, function (labCompendium) {
                vm.results.push({labCompendium: labCompendium, abnormal: false, disabled: true})
            })
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            var patientResultDets = _.map(vm.results, function(result) {
                return {
                    testCode: result.labCompendium.code,
                    abnormal: result.abnormal,
                    result: result.result
                }
            });

            PatientResult.add({accessionNumber: data.barcode, resultDets: patientResultDets}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function addOther() {
            vm.results.push({});
        }

        function remove(index) {
            vm.results.splice(index, 1);
        }

        function getLabCompendium(query) {
            if (query && query.length > 1) {
                LabCompendium.filter({
                    laboratoryId: vm.patientOrder.facilityLab.laboratoryId ,
                    searchQuery: query,
                    page: 0,
                    size: 40,
                    sort: 'code,asc',
                    facilityId: vm.patientOrder.chart.facilityId
                }, function (result) {
                    vm.labCompendiums = result;
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientOrderDiscontinueController', PatientOrderDiscontinueController);

    PatientOrderDiscontinueController.$inject = ['$uibModalInstance', 'patientOrder', 'PatientOrder', 'CoreService',
        'Employee', 'Via', 'BUSINESS_ROLES', 'itHasCredentials'];

    function PatientOrderDiscontinueController($uibModalInstance, patientOrder, PatientOrder, CoreService,
                                               Employee, Via, BUSINESS_ROLES, itHasCredentials) {
        var vm = this;

        vm.pin = "";
        vm.agree = false;
        vm.signature = "";
        vm.via = Via.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.itHasCredentials = itHasCredentials.value;
        vm.patientOrder = patientOrder;
        vm.currentEmployee = CoreService.getCurrentEmployee();
        vm.patientOrder.discontinueBy = vm.currentEmployee;
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.save = save;
        vm.clear = clear;
        vm.getEmployees = getEmployees;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        credentialsPermits();

        function credentialsPermits() {
            if (vm.itHasCredentials) {
                vm.employees = [vm.currentEmployee];
                vm.patientOrder.discontinueByPhysician = vm.currentEmployee;
            } else {
                vm.getEmployees();
            }
        }

        function save() {
            vm.isSaving = true;

            if (vm.signature != "" || vm.pin != "") {
                vm.patientOrder.discontinueSignature = vm.signature ? {'signature': vm.signature} : null;
                vm.patientOrder.discontinueSignatureDate = new Date();
            }

            var req = {
                patientOrder: vm.patientOrder,
                pin: vm.pin,
                signature: vm.signature
            }

            PatientOrder.saveDiscontinuePatientOrder(req, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (vm.itHasCredentials) {
                return;
            }

            var filter = {
                page: 0,
                size: 20,
                query: query,
                facilityId: CoreService.getCurrentFacility().id,
                businessRole: BUSINESS_ROLES.PHYSICIAN
            };

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientOrderChartDetailController', PatientOrderChartDetailController);

    PatientOrderChartDetailController.$inject = ['$uibModalInstance', 'ParseLinks', 'patientOrder', 'PatientOrderTest', '$uibModal', 'PatientOrderItem',
        'PatientOrder', 'CoreService', 'AlertService'];

    function PatientOrderChartDetailController($uibModalInstance, ParseLinks, patientOrder, PatientOrderTest, $uibModal, PatientOrderItem,
                                               PatientOrder, CoreService, AlertService) {

        var vm = this;

        vm.icd10s = [];
        vm.sing = false;
        vm.testCode = "";

        vm.relationals = [];
        vm.credentials = "";
        vm.activeBotton = false;
        vm.activateSign = false;
        vm.testDescription = "";
        vm.selectedTetsId = null;
        vm.patientOrderItems = [];

        vm.pin = "";
        vm.agree = false;
        vm.signature = "";
        vm.patientOrder = patientOrder;
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.pageTest = 1;
        vm.pageItem = 1;
        vm.itemsPerPage = 10;
        vm.testsPerPage = 5;

        vm.selectOptionVia = [patientOrder.via ? patientOrder.via.name : ""];
        vm.physician = vm.patientOrder.signedBy.firstName + " " + vm.patientOrder.signedBy.lastName;
        vm.selectOptionPhysician = [vm.patientOrder.signedBy.firstName + " " + vm.patientOrder.signedBy.lastName];
        vm.selectOptionViaDiscontinued = vm.patientOrder.discontinueVia ? [vm.patientOrder.discontinueVia.name] : null;
        vm.discontinueByPhysician = vm.patientOrder.discontinueByPhysician ? vm.patientOrder.discontinueByPhysician.firstName + " " + vm.patientOrder.discontinueByPhysician.lastName : null;
        vm.selectOptionDiscontinueByPhysician = vm.patientOrder.discontinueByPhysician ? [vm.patientOrder.discontinueByPhysician.firstName + " " + vm.patientOrder.discontinueByPhysician.lastName] : null;

        vm.del = del;
        vm.save = save;
        vm.clear = clear;
        vm.loadItems = loadItems;
        vm.transitionTest = transitionTest;
        vm.transitionItem = transitionItem;

        loadAllTest();

        function loadAllTest() {
            PatientOrderTest.findAllPatientOrderTestByPatientOrder({
                id: vm.patientOrder.id,
                page: vm.pageTest - 1,
                size: vm.testsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalTests = headers('X-Total-Count');
                vm.queryCount = vm.totalTests;
                vm.patientOrderTests = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadAllItem() {
            PatientOrderItem.findAllPatientOrderItemByPatientOrderTest({
                id: vm.selectedTetsId,
                page: vm.pageItem - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientOrderItems = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transitionTest() {
            loadAllTest();
        }

        function transitionItem() {
            loadAllItem();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function loadItems(id) {
            vm.patientOrderTests.find(function (element) {
                if (element.id == id) {
                    vm.icd10s = element.icd10s;
                    vm.relationals = element.relationals;
                    vm.testCode = element.labCompendium.code;
                    vm.testDescription = element.labCompendiumName;
                    vm.selectedTetsId = id;
                    loadAllItem();
                }
            });
        }

        function del() {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order/patient-order-delete-dialog.html',
                controller: 'PatientOrderDeleteController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientOrder: vm.patientOrder
                }
            }).result.then(function () {
            }, function () {
            });
        }

        function save() {
            vm.isSaving = true;

            var req = {
                patientOrder: vm.patientOrder,
                pin: vm.pin,
                signature: vm.signature
            }

            PatientOrder.savePendingSignature(req, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        credentialsPermits();
        function credentialsPermits() {
            if (vm.patientOrder.signedBy.id == CoreService.getCurrentEmployee().id) {
                return vm.itHasCredentials = true;
            } else return vm.itHasCredentials = false;
        }

        physicianCredentials();
        function physicianCredentials() {
            for (var i =0; i < vm.patientOrder.signedBy.credentials.length; i++) {
                vm.credentials += vm.patientOrder.signedBy.credentials[i].name + " "
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientOrderDialogController', PatientOrderDialogController);

    PatientOrderDialogController.$inject = ['$uibModalInstance', 'Icd10Search', 'Diagnoses', 'patientOrder',
        'Via', 'Employee', 'CoreService', 'PatientOrder', 'LabCompendium', 'Relational',
        'BusinessCredential', 'BUSINESS_ROLES', 'FacilityLab', '$uibModal', 'RATIONALE_TYPE', 'itHasCredentials'];

    function PatientOrderDialogController($uibModalInstance, Icd10Search, Diagnoses, patientOrder,
                                          Via, Employee, CoreService, PatientOrder, LabCompendium, Relational,
                                          BusinessCredential, BUSINESS_ROLES, FacilityLab, $uibModal, RATIONALE_TYPE,
                                          itHasCredentials) {

        var vm = this;
        vm.patientOrder = patientOrder;
        vm.activeIcd10 = [];

        vm.patientOrderTest = {
            id: null,
            staringDate: null,
            endDate: null,
            icd10s: angular.copy(vm.activeIcd10),
            labCompendium: null,
            orderFrequency: null
        }

        Diagnoses.findAllActiveDiagnosesByChartId({id: vm.patientOrder.chart.id}, function (diagnoses) {
            _.forEach(diagnoses, function (element) {
                var idx = _.findIndex(vm.activeIcd10, function (o) {
                    return o.id === element.icd10.id;
                });

                if (idx == -1) {
                    vm.activeIcd10.push(element.icd10);

                    vm.patientOrderTest.icd10s = angular.copy(vm.activeIcd10);
                }
            })
        });

        vm.facility = CoreService.getCurrentFacility();

        vm.pin = "";
        vm.icd10s = [];
        vm.agree = false;
        vm.signature = "";
        vm.diagnoses = angular.copy(vm.activeIcd10);
        vm.employees = [];
        vm.hideTest = false;
        vm.frequency = null;
        vm.credentials = [];
        vm.via = Via.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.today = new Date();
        vm.labCompendiums = [];
        vm.activateSign = false;
        vm.itHasCredentials = itHasCredentials.value;
        vm.testCodes = [];
        vm.currentEmployee = CoreService.getCurrentEmployee();
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.endDateOptions = {};
        vm.staringDateOptions = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.staringDate = false;

        vm.relationals = Relational.findAllByFilter(getFilterByCorporationAndType());
        vm.laboratories = [];

        FacilityLab.filter({facilityId: vm.patientOrder.chart.facility.id, page: 0, size: 1000, enabled: true}, function (result) {
            vm.facilityLabs = result;
        });

        vm.staringDateOptions = {
            // customClass: getDayClass,
            minDate: new Date(),
        }

        vm.endDateOptions = {
            // customClass: getDayClass1,
            minDate: new Date(),
        }

        var days = !vm.patientOrder.chart.drawDays || vm.patientOrder.chart.drawDays == '0000000' ? vm.facility.pDrawDays : vm.patientOrder.chart.drawDays;

        vm.save = save;
        vm.clear = clear;
        vm.generateTest = generateTest;
        vm.openCalendar = openCalendar;
        vm.getDiagnoses = getDiagnoses;
        vm.validateEndDate = validateEndDate;
        vm.changeOrderType = changeOrderType;
        vm.getLabCompendium = getLabCompendium;
        vm.changeLaboratory = changeLaboratory;
        vm.removeRelational = removeRelational;
        vm.selectRelational = selectRelational;
        vm.getEmployees = getEmployees;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDayClass(date) {
            if (date.mode === 'day') {
                if (disabled) {
                    return 'highlight-current-date';
                }
                return '';
            }
        }

        function getDayClass1(date) {
            if (date.mode === 'day') {
                if (vm.patientOrderTest.staringDate > date.date) {
                    return 'highlight-current-date';
                }
                return '';
            }
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.patientOrderTest.staringDate
        }

        credentialsPermits();

        function credentialsPermits() {
            if (vm.itHasCredentials) {
                vm.employees = [vm.currentEmployee];
                vm.patientOrder.signedBy = vm.currentEmployee;
                vm.patientOrder.signed = true;
            } else {
                vm.getEmployees();
            }
        }

        function getDiagnoses(query) {
            if (query && query.length > 1) {
                Icd10Search.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function generateTest() {
            vm.labCompendiums.forEach(function (element) {
                var testTemp = {
                    id: null,
                    labCompendium: element,
                    icd10s: vm.patientOrderTest.icd10s,
                    labCompendiumName: element.description,
                    staringDate: vm.patientOrderTest.staringDate,
                    relationals: angular.copy(vm.patientOrderTest.relationals),
                    orderFrequency: vm.patientOrderTest.orderFrequency,
                    endDate: vm.patientOrderTest.endDate ? vm.patientOrderTest.endDate : vm.patientOrderTest.staringDate
                };
                vm.patientOrder.patientOrderTests.push(testTemp);
            });

            clearTest();
        }

        function clearTest() {
            vm.labCompendiums = [];
            vm.patientOrderTest = {
                id: null,
                icd10s: vm.activeIcd10,
                endDate: null,
                staringDate: vm.patientOrder.orderType === 'ONE_TIME' ? new Date() : null,
                labCompendium: null,
                orderFrequency: vm.patientOrder.orderType === 'ONE_TIME' ? (vm.orderFrequencies.length === 0 ? null : vm.orderFrequencies[0]) : null
            }
        }

        function save() {
            vm.isSaving = true;

            var req = angular.extend({}, vm.patientOrder, {
                chartIds: [vm.patientOrder.chart.id],
                pin: vm.pin,
                signature: vm.signature
            });

            _.forEach(req.patientOrderTests, function (result) {
                result.staringDate = moment(result.staringDate).format('YYYY-MM-DD');
                result.endDate = result.endDate ? moment(result.endDate).format('YYYY-MM-DD') : moment(result.staringDate).format('YYYY-MM-DD');
            });

            //TODO remove
            if (req.patientOrderTests.length > 0) {
                PatientOrder.create(req, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function changeOrderType() {
            PatientOrder.getAllOrderFrequency(function (results) {
                if (results) {
                    if (vm.patientOrder.orderType === 'ONE_TIME') {
                        vm.orderFrequencies = _.filter(results, function (result) {
                            return result.id === 'ONCE';
                        });
                        vm.patientOrderTest.orderFrequency = vm.orderFrequencies.length === 0 ? null : vm.orderFrequencies[0];
                        vm.patientOrderTest.staringDate = new Date();
                    } else {
                        vm.orderFrequencies = results;
                    }
                }
            });
        }

        function getLabCompendium(query) {
            if (vm.patientOrder.facilityLab) {
                LabCompendium.filter({
                    laboratoryId: vm.patientOrder.facilityLab.labId,
                    searchQuery: query,
                    page: vm.page - 1,
                    size: 20,
                    sort: 'code,asc',
                    facilityId: vm.facility.id
                }, function (result) {
                    vm.testCodes = result;
                });
            }
        }

        function changeLaboratory() {
            vm.patientOrder.patientOrderTests = [];
            vm.testCodes = [];
            vm.labCompendiums = [];

            vm.getLabCompendium();
        }

        function removeRelational(relationals, index) {
            relationals.splice(index, 1);
        }

        function selectRelational(patientOrderTest) {
            $uibModal.open({
                templateUrl: 'app/entities/relational/select/relational-select-dialog.html',
                controller: 'RelationalSelectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl ',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    selectedRelationals: function () {
                        return patientOrderTest.relationals;
                    }
                }
            }).result.then(function (result) {
                patientOrderTest.relationals = _.filter(vm.relationals, function (relational) {
                    return _.find(result, function (id) {
                        return id === relational.id.toString();
                    });
                });
            });
        }

        function getFilterByCorporationAndType() {
            var filter = {};

            filter.corporationId = CoreService.getCorporation().id;
            filter.relationalType = RATIONALE_TYPE.LABORATORY;

            return filter
        }

        function getEmployees(query) {
            if (vm.itHasCredentials) {
                return;
            }

            var filter = {
                page: 0,
                size: 200000,
                query: query,
                facilityId: CoreService.getCurrentFacility().id,
                businessRole: BUSINESS_ROLES.PHYSICIAN
            };

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientOrderChartController', PatientOrderChartController);

    PatientOrderChartController.$inject = ['chart', '$uibModal', 'PatientOrder', 'ParseLinks', 'AlertService', 'Auth',
        'CoreService', 'PopupService', '$rootScope', '$state', '$scope', 'access', 'ACTIONS',
        'TAB', 'params'];

    function PatientOrderChartController(chart, $uibModal, PatientOrder, ParseLinks, AlertService, Auth,
                                         CoreService, PopupService, $rootScope, $state, $scope, access, ACTIONS,
                                         TAB, params) {
        var vm = this;
        vm.chart = chart;

        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.labCompendium = [];
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.LAB_ORDERS);
        vm.chart = chart;
        vm.access = access;
        vm.patientOrder = [];
        vm.accessCreate = access[ACTIONS.ACTION_ADD_PATIENT_ORDER_CREATE] ? access[ACTIONS.ACTION_ADD_PATIENT_ORDER_CREATE].roles.join() : null;

        vm.add = add;
        vm.del = del;
        vm.detail = detail;
        vm.transition = transition;
        vm.toggleItem = toggleItem;
        vm.search = search;

        function toggleItem() {
            CoreService.togglePanel('orders');
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order/create/patient-order-dialog.html',
                controller: 'PatientOrderDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientOrder: {
                        id: null,
                        chart: chart,
                        signatureDate: null,
                        signed: false,
                        via: null,
                        signedBy: null,
                        discontinueBy: null,
                        discontinueCause: null,
                        staringDate: null,
                        endDate: null,
                        orderType: null,
                        icd10Code: null,
                        patientOrderTests: [],
                        patientOrderSignature: null
                    },
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.PHYSICIAN
                        }).$promise;
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function detail(id) {
            PopupService.showPatientOrderDetailsPopup(id).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function del(id) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order/discontinue/patient-order-discontinue-dialog.html',
                controller: 'PatientOrderDiscontinueController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    patientOrder: ['$stateParams', 'PatientOrder', function ($stateParams, PatientOrder) {
                        return PatientOrder.get({id: id}).$promise;
                    }],
                    itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                        return Employee.checkBusinessRole({
                            facilityId: CoreService.getCurrentFacility().id,
                            businessRole: BUSINESS_ROLES.PHYSICIAN
                        }).$promise;
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW, access) || !vm.active) {
                return;
            }

            PatientOrder.findAllByChart({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientOrder = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        $rootScope.$on('bluebookApp:chartOrdersLabOrders', function (event, result) {
            loadAll();
        });

        function search() {
            vm.page = 1;
            transition();
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result == TAB.LAB_ORDERS) {
                vm.active = true;
                loadAll();
            }
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedicationTakeReaction', PatientMedicationTakeReaction);

    PatientMedicationTakeReaction.$inject = ['$resource', 'CoreService', 'DateUtils'];

    function PatientMedicationTakeReaction($resource, CoreService, DateUtils) {
        var resourceUrl = 'api/patient-medication-take-reactions/:id';
        var facility = CoreService.getCurrentFacility();

        return $resource(resourceUrl, {}, {
            'findAllByTake': {
                url: 'api/patient-medication-take-reactions/by-take/:id',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        _.forEach(data, function (reaction) {
                            reaction.createdDate = new Date(DateUtils.convertDateTimeFromServer(reaction.createdDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        });
                    }

                    return data;
                }
            },
            'addFirstDoseSideEffect': {
                url: 'api/patient-medication-take-reactions/add-first-dose-side-effect',
                method: 'POST',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationTakeMissedReasonDialogController', PatientMedicationTakeMissedReasonDialogController);

    PatientMedicationTakeMissedReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PatientMedicationTakeMissedReason'];

    function PatientMedicationTakeMissedReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PatientMedicationTakeMissedReason) {
        var vm = this;

        vm.patientMedicationTakeMissedReason = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.patientMedicationTakeMissedReason.id !== null) {
                PatientMedicationTakeMissedReason.update(vm.patientMedicationTakeMissedReason, onSaveSuccess, onSaveError);
            } else {
                PatientMedicationTakeMissedReason.save(vm.patientMedicationTakeMissedReason, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:patientMedicationTakeMissedReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedicationTakeMissedReason', PatientMedicationTakeMissedReason);

    PatientMedicationTakeMissedReason.$inject = ['$resource'];

    function PatientMedicationTakeMissedReason ($resource) {
        var resourceUrl =  'api/patient-medication-take-missed-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/patient-medication-take-missed-reasons/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-medication-take-missed-reason', {
            parent: 'entity',
            url: '/patient-medication-take-missed-reason',
            data: {
                authorities: [],
                pageTitle: 'PatientMedicationTakeMissedReasons'
            },
            ncyBreadcrumb: {
                label: 'Patient Medication Take Missed Reason'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-medication-take-missed-reason/list/patient-medication-take-missed-reason.html',
                    controller: 'PatientMedicationTakeMissedReasonController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationTakeMissedReasonController', PatientMedicationTakeMissedReasonController);

    PatientMedicationTakeMissedReasonController.$inject = ['PatientMedicationTakeMissedReason', 'CoreService',
        'GenericEntityDatatableService', '$q', '$uibModal',
        'ConfirmationService'];

    function PatientMedicationTakeMissedReasonController (PatientMedicationTakeMissedReason, CoreService,
                                                          GenericEntityDatatableService, $q, $uibModal,
                                                          ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()

        var entityStateName = 'patient-medication-take-missed-reason'

        vm.descriptor = {
            title: 'Patient Medication Missed Reason',
            newButtonTitle: 'New Missed Reason',
            entityClassHumanized: 'Patient Medication Missed Reason',
            entityStateName: entityStateName,
            service: PatientMedicationTakeMissedReason,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Missed Reason',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication-take-missed-reason/update/patient-medication-take-missed-reason-dialog.html',
                controller: 'PatientMedicationTakeMissedReasonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity:['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication-take-missed-reason/patient-medication-take-missed-reason-dialog.html',
                controller: 'PatientMedicationTakeMissedReasonDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['PatientMedicationTakeMissedReason', function(PatientMedicationTakeMissedReason) {
                        return PatientMedicationTakeMissedReason.get({id : id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Missed Reason').result.then(function () {
                    PatientMedicationTakeMissedReason.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedicationTakeComment', PatientMedicationTakeComment);

    PatientMedicationTakeComment.$inject = ['$resource', 'CoreService', 'DateUtils'];

    function PatientMedicationTakeComment($resource, CoreService, DateUtils) {
        var resourceUrl = 'api/patient-medication-take-comments/:id';
        var facility = CoreService.getCurrentFacility();

        return $resource(resourceUrl, {}, {
            'findAllByTake': {
                url: 'api/patient-medication-take-comments/by-take/:id',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        _.forEach(data, function(comment) {
                            comment.createdDate = new Date(DateUtils.convertDateTimeFromServer(comment.createdDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        });
                    }

                    return data;
                }
            },
            'addComment': {url: 'api/patient-medication-take-comments/add-comment', method: 'POST', isArray: true}
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedicationTake', PatientMedicationTake);

    PatientMedicationTake.$inject = ['$resource', 'DateUtils', 'CoreService'];

    function PatientMedicationTake($resource, DateUtils, CoreService) {
        var resourceUrl = 'api/patient-medication-takes/:id';
        var facility = CoreService.getCurrentFacility();

        return $resource(resourceUrl, {}, {
            'changeStatus': {url: 'api/patient-medication-takes/change-status', method: 'POST', isArray: true},
            'signTakeByPatient': {
                url: 'api/patient-medication-takes/sign-take-by-patient',
                method: 'POST',
                isArray: true
            },
            'signTakeByEmployee': {
                url: 'api/patient-medication-takes/sign-take-by-employee',
                method: 'POST',
                isArray: true
            },
            'findAllByPatientMedication': {
                url: 'api/patient-medication-takes/patient-medication/:id',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        _.forEach(data, function (take) {
                            take.scheduleDate = new Date(DateUtils.convertDateTimeFromServer(take.scheduleDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        })
                    }

                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedicationFaxLog', PatientMedicationFaxLog);

    PatientMedicationFaxLog.$inject = ['$resource', 'DataUtils'];

    function PatientMedicationFaxLog ($resource, DataUtils) {
        var resourceUrl =  'api/patient-medication-fax-logs/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'filter': {method: 'GET', isArray: true, url: 'api/patient-medication-fax-logs/filter'},
            'download': {
                url: 'api/patient-medication-fax-logs/download/:id',
                responseType: 'arraybuffer',
                method: 'GET',
                isArray: false,
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('patient-medication-fax-log', {
            parent: 'entity',
            url: '/patient-medication-fax-log',
            data: {
                authorities: [],
                pageTitle: 'Fax Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/patient-medication-fax-log/list/patient-medication-fax-logs.html',
                    controller: 'PatientMedicationFaxLogController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationFaxLogController', PatientMedicationFaxLogController);

    PatientMedicationFaxLogController.$inject = ['PatientMedicationFaxLog', 'CoreService', '$rootScope',
        'GenericEntityDatatableService'];

    function PatientMedicationFaxLogController(PatientMedicationFaxLog, CoreService, $rootScope,
                                               GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Fax Logs',
            entityClassHumanized: 'Fax Logs',
            entityStateName: 'ppatient-medication-fax-log',
            service: PatientMedicationFaxLog,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                // {key: 'aaSorting', value: [[1, 'desc']]}
            ],
            selectionColumn: 'id',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Patient',
                    render: function (data) {
                        return data.firstName + " " + data.lastName + " [ " + data.mrNo + " ]";
                    }
                },
                {
                    name: "objectName",
                    title: "Object"
                },
                {
                    name: "faxType",
                    title: 'Fax Type',
                },
                {
                    name: null,
                    title: 'Employee',
                    render: function (data) {
                        return data.employeeFirstName + " " + data.employeeLastName;
                    }
                },
                {
                    name: "name",
                    title: 'Fax To'
                },
                {
                    name: "fax",
                    title: 'Fax Number'
                },
                {
                    name: null,
                    title: 'Send Date',
                    render: function (data) {
                        return data.sentDate ? moment(data.sentDate).format($rootScope.amDateFormat) : ''
                    }
                },
                {
                    name: "status",
                    title: 'Api Status'
                },
                {
                    name: 'status',
                    title: 'Status',
                },
                {
                    name: null,
                    title: 'Created Date',
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.amDateFormat) : ''
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewPdfAction(), {
                    action: function (data) {
                        vm.download(data.id);
                    },
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
        }

        vm.download = download;

        function download(id) {
            PatientMedicationFaxLog.download({id: id});
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('PatientMedication', PatientMedication);

    PatientMedication.$inject = ['$resource', 'DateUtils', 'DataUtils', 'CoreService'];

    function PatientMedication($resource, DateUtils, DataUtils, CoreService) {
        var resourceUrl = 'api/patient-medications/:id';
        var facility = CoreService.getCurrentFacility();

        function transformCountResponse(data) {
            if (data) {
                return {count: data};
            }
            return {count: 0};
        }

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        if (data.startDate) {
                            data.startDate = new Date(DateUtils.convertDateTimeFromServer(data.startDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.endDate) {
                            data.endDate = new Date(DateUtils.convertDateTimeFromServer(data.endDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.createdDate) {
                            data.createdDate = new Date(DateUtils.convertDateTimeFromServer(data.createdDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.discontinueDate) {
                            data.discontinueDate = new Date(DateUtils.convertDateTimeFromServer(data.discontinueDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.signedDate) {
                            data.signedDate = new Date(DateUtils.convertDateTimeFromServer(data.signedDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.faxedTo) {
                            data.faxedTo.createdDate = new Date(DateUtils.convertDateTimeFromServer(data.faxedTo.createdDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.signature) {
                            data.signature.createdDate = new Date(DateUtils.convertDateTimeFromServer(data.signature.createdDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.discontinueSignature) {
                            data.discontinueSignature.createdDate = new Date(DateUtils.convertDateTimeFromServer(data.discontinueSignature.createdDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.discontinueDate) {
                            data.discontinueDate = new Date(DateUtils.convertDateTimeFromServer(data.discontinueDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if(data.frequencies){
                            _.forEach(data.frequencies, function (frequency) {
                                if(frequency.schedules){
                                    _.forEach(frequency.schedules, function (schedule) {
                                        schedule.date = new Date(DateUtils.convertDateTimeFromServer(schedule.date)
                                            .toLocaleString("en-US", {timeZone: facility.timeZone}));
                                    });
                                }
                            });
                        }
                    }

                    return data;
                }
            },
            'findAllByFilter': {
                url: 'api/patient-medications/filter', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        _.forEach(data, function (pm) {
                            if (pm.startDate) {
                                pm.startDate = new Date(DateUtils.convertDateTimeFromServer(pm.startDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (pm.endDate) {
                                pm.endDate = new Date(DateUtils.convertDateTimeFromServer(pm.endDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (pm.createdDate) {
                                pm.createdDate = new Date(DateUtils.convertDateTimeFromServer(pm.createdDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (pm.discontinueDate) {
                                pm.discontinueDate = new Date(DateUtils.convertDateTimeFromServer(pm.discontinueDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (pm.signedDate) {
                                pm.signedDate = new Date(DateUtils.convertDateTimeFromServer(pm.signedDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (pm.faxedToCreatedDate) {
                                pm.faxedToCreatedDate = new Date(DateUtils.convertDateTimeFromServer(pm.faxedToCreatedDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }
                        });
                    }

                    return data;
                }
            },
            'unsigned': {url: "api/patient-medications/unsigned/:id", method: 'GET', isArray: true},
            'all-unsigned': {url: "api/patient-medications/unsigned/all/:id", method: 'GET', isArray: true},
            'sign': {
                url: 'api/patient-medications/sign', method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.signatureDate = DateUtils.convertLocalDateFromServer(data.signatureDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                    }
                    return data;
                }
            },
            'patientMedicationByTake': {url: 'api/patient-medication-by-take/:id', method: 'GET'},
            'patientMedicationById': {url: 'api/patient-medication/generate-pres-pdf/:id', method: 'GET'},
            'discontinue2': {url: 'api/patient-medications/discontinue2', method: 'POST'},
            'create': {url: 'api/patient-medications/create', method: 'POST', isArray: false},
            'fax': {url: 'api/patient-medications/fax', method: 'POST', isArray: true},
            'getAllMedicationFrequency': {
                'url': "api/patient-medications/medication-frequency",
                method: 'GET',
                isArray: true
            },
            'note': {
                url: "api/patient-medications/note", method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.notedBy = DateUtils.convertLocalDateToServer(copy.notedDate);

                    return angular.toJson(copy);
                }
            },
            'marsAsNeeded': {url: 'api/patient-medications/mars/as-needed/by-facility', method: 'GET', isArray: true},
            'signObserved': {
                url: 'api/patient-medication-takes/sign-observed', method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.signatureDate = DateUtils.convertLocalDateFromServer(data.signatureDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                    }
                    return data;
                }
            },
            'noting': {'url': 'api/patient-medications/noting', method: 'GET', isArray: true},
            'findAllPhysicianReview': {url: 'api/patient-medications/physician-review', method: 'GET', isArray: true},
            'signMany': {url: 'api/patient-medications/sign-many', method: 'POST'},
            'mars': {url: 'api/patient-medications/mars', method: 'GET', isArray: true},
            'marsTakes': {
                url: 'api/patient-medications/mars/takes',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        _.forEach(data, function (take) {
                            if (take.scheduleDate) {
                                take.scheduleDate = new Date(DateUtils.convertDateTimeFromServer(take.scheduleDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (take.administerDate) {
                                take.administerDate = new Date(DateUtils.convertDateTimeFromServer(take.administerDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }

                            if (take.lastScheduleDate) {
                                take.lastScheduleDate = new Date(DateUtils.convertDateTimeFromServer(take.lastScheduleDate)
                                    .toLocaleString("en-US", {timeZone: facility.timeZone}));
                            }
                        });
                    }

                    return data;
                }
            },
            'match': {url: 'api/patient-medications/match/:id', method: 'GET', isArray: true},
            'addAsNeeded': {url: 'api/patient-medications/add-as-needed', method: 'POST', isArray: true},
            'findAllFrequencies': {url: 'api/patient-medications/frequencies/:id', method: 'GET', isArray: true},
            'countByChartAndNotedIsFalse': {
                url: 'api/patient-medications/count-all-by-noted-false/:id',
                method: 'GET',
                isArray: false,
                transformResponse: transformCountResponse
            },
            'changeOnlyChart': {url: 'api/patient-medications/change-only-in-chart', method: 'PUT'},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('patient-medication-mars', {
                parent: 'entity',
                url: '/pm-mars',
                data: {
                    authorities: [],
                    pageTitle: 'MARs-MORs'
                },
                ncyBreadcrumb: {
                    label: 'MARs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/patient-medication/mars/list/patient-medication-mars-new.html',
                        controller: 'PatientMedicationMarsNewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        // var startDate = new Date();
                        // startDate.setHours(startDate.getHours() - 2);
                        //
                        // var endDate = new Date();
                        // endDate.setHours(endDate.getHours() + 3);

                        return {
                            patientId: null,
                            dob: null,
                            levelOfCare: null,
                            medication: null,
                            frequency: null,
                            physician: null,
                            // startDate: startDate,
                            // endDate: endDate,
                            facilityId: CoreService.getCurrentFacility().id,
                            filterStatus: CoreService.getPatientMedicationFilterStatus().CURRENT,
                            page: 1,
                            size: 10,
                            searchQuery: null
                        };
                    }]
                }
            })
            .state('patient-medication-admission', {
                parent: 'entity',
                url: '/medications-admission',
                data: {
                    authorities: [ROLES.ROLE_USER],
                    pageTitle: 'Admission Medications'
                },
                ncyBreadcrumb: {
                    label: 'Admission Medications'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/medications/medications-admission.html',
                        controller: 'PatientMedicationsAdmissionController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationMarsSystemMissDialogController', PatientMedicationMarsSystemMissDialogController);

    PatientMedicationMarsSystemMissDialogController.$inject = ['$uibModalInstance', 'take', 'takes',
        'PatientMedicationTake', 'chart', 'CoreService'];

    function PatientMedicationMarsSystemMissDialogController($uibModalInstance, take, takes,
                                                             PatientMedicationTake, chart, CoreService) {
        var vm = this;

        vm.title = "Comment on late med";
        vm.take = take;
        vm.takes = takes;
        vm.chart = chart;
        vm.systemMissReason = take == null ? null : take.systemMissReason;
        vm.facility = CoreService.getCurrentFacility();

        vm.addReason = addReason;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addReason() {
            vm.isSaving = true;

            PatientMedicationTake.changeStatus({
                status: vm.takes.status,
                takes: vm.takes.ids,
                systemMissReason: vm.systemMissReason,
                facilityId: vm.facility.id
            }, function (result) {
                vm.isSaving = false;
                $uibModalInstance.close();
            }, function () {
                vm.isSaving = false;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationMarsSignDialogController', PatientMedicationMarsSignDialogController);

    PatientMedicationMarsSignDialogController.$inject = ['take', 'takes', 'chart', '$uibModalInstance',
        'PatientMedicationTakeComment', 'toastr', 'ParseLinks', 'AlertService',
        'PatientMedicationTake', 'CoreService', 'WizardHandler'];

    function PatientMedicationMarsSignDialogController(take, takes, chart, $uibModalInstance,
                                                       PatientMedicationTakeComment, toastr, ParseLinks, AlertService,
                                                       PatientMedicationTake, CoreService, WizardHandler) {
        var vm = this;

        vm.takes = takes;
        vm.take = take;
        vm.chart = chart;

        vm.title = "Sign Medication";

        vm.isPatientSigned = false;
        vm.isEmployeeSigned = false;
        vm.odsPatientSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.odsEmployeeSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.employeeSignatureAgree = false;
        vm.patientSignatureAgree = false;
        vm.employee = CoreService.getCurrentEmployee();
        vm.facility = CoreService.getCurrentFacility();

        vm.status = {
            SCHEDULED: 'SCHEDULED',
            SYSTEM_MISS: 'SYSTEM_MISS',
            HOLD: 'HOLD',
            ADMINISTERED: 'ADMINISTERED',
            OBSERVED: 'OBSERVED',
            MISSED: 'MISSED'
        }

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        }

        vm.patientSignature = "";
        vm.employeeSignature = "";

        vm.clear = clear;
        vm.signTakeByPatient = signTakeByPatient;
        vm.signTakeByEmployee = signTakeByEmployee;

        init();

        function init() {
            if (takes.ids.length > 1) {
                vm.isPatientSigned = false;
                vm.isEmployeeSigned = false;
            } else {
                // vm.isPatientSigned = take != null && take.patientSignatureId != null;
                // vm.isEmployeeSigned = take != null && take.observedSignatureId != null;

                vm.isPatientSigned = take.patientSignatureId != null;
                vm.isEmployeeSigned = take.observedSignatureId != null || take.missedSignatureId != null;

                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    toastr.info('No signature required');

                    $uibModalInstance.close();
                }
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function signTakeByPatient() {
            PatientMedicationTake.signTakeByPatient({
                takes: takes.ids,
                patientSignature: vm.patientSignature,
                facilityId: vm.facility.id
            }, function (result) {
                vm.take = result;
                vm.isPatientSigned = true;

                toastr.success('Patient Sign Successfully');
                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationObservedWizard').next();
                }
            }, function () {
                toastr.error('Error signing medication');
            });
        }

        function signTakeByEmployee() {
            PatientMedicationTake.signTakeByEmployee({
                takes: takes.ids,
                employeeSignature: vm.employeeSignature,
                facilityId: vm.facility.id
            }, function (result) {
                vm.take = result;
                vm.isEmployeeSigned = true;

                toastr.success('Employee Sign Successfully');
                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationObservedWizard').previous();
                }
            }, function () {
                toastr.error('Error signing medication');
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NotingController', NotingController);

    NotingController.$inject = ['$uibModal', 'DTColumnBuilder', '$compile', '$scope', '$q', '$rootScope',
        'DTOptionsBuilder', '$filter', 'filter', 'CoreService', 'PatientMedication',
        'Medication', 'BusinessCredential', 'BUSINESS_ROLES', 'Employee', 'GUIUtils', 'DataTablesService',
        'toastr', 'DateUtils', 'MedicationSearch', 'PopupService', '$uibModalInstance',
        'ConfirmationService'];

    function NotingController($uibModal, DTColumnBuilder, $compile, $scope, $q, $rootScope,
                              DTOptionsBuilder, $filter, filter, CoreService, PatientMedication,
                              Medication, BusinessCredential, BUSINESS_ROLES, Employee, GUIUtils, DataTablesService,
                              toastr, DateUtils, MedicationSearch, PopupService, $uibModalInstance,
                              ConfirmationService) {
        var vm = this;

        vm.title = 'Noting';
        vm.entityClassHumanized = 'Noting';
        vm.filterTpl = angular.copy(filter);
        vm.filter = filter;
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.dtInstance = {};
        vm.selected = {};
        vm.selectAll = false;
        vm.patientMedications = [];
        vm.itHasCredentials = false;
        vm.medications = [];

        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;

        vm.search = search;
        vm.reload = reload;
        vm.updateStatusNoted = updateStatusNoted;
        vm.openConfirmationModal = openConfirmationModal;
        vm.clear = clear;
        vm.close = close;
        vm.fax = fax;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            PatientMedication.noting(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems

                vm.patientMedications = result;
                defer.resolve(vm.patientMedications);
            });

            vm.selected = {};
            vm.selectAll = false;

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withOption("bPaginate", false)
            .withOption('order', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;
                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').notSortable().renderWith(function (data, type, full) {
                return data.patientLastName + ", " + data.patientFirstName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Date Birth').notSortable().renderWith(function (data, type, full) {
                return moment(data.dob).format($rootScope.dateFormat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('MrNo').renderWith(function (data, type, full) {
                return data.mrNo;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Medication').notSortable().renderWith(function (data, type, full) {
                return data.medicationName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Start Date').notSortable().renderWith(function (data, type, full) {
                return moment(data.startDate).format("MM/DD/YYYY");
            }),
            DTColumnBuilder.newColumn('durationDays').withTitle('Duration Days').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('Route').notSortable().renderWith(function (data, type, full) {
                return data.routeName;
            }),
            DTColumnBuilder.newColumn('doseFormName').withTitle('Dose Form').notSortable(),
            DTColumnBuilder.newColumn('type').withTitle('Type').notSortable()

        ];

        init();

        function init() {
            BusinessCredential.getCredentialByRole({
                businessRole: BUSINESS_ROLES.NURSE,
                id: vm.filter.facilityId
            }, function (result) {
                vm.credentials = result;

                vm.itHasCredentials = _.intersection(CoreService.getCurrentEmployee().credentials,
                    _.map(vm.credentials, function (credential) {
                        return credential.name;
                    })
                ).length > 0;

                if (vm.itHasCredentials) {
                    vm.currentEmployee = CoreService.getCurrentEmployee();
                }
            });
        }

        function search() {
            vm.page = 1;

            reload();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            vm.searchQuery = null;
            vm.filter.chartId = null;

            vm.page = 1;

            reload();
        }

        function updateStatusNoted() {
            vm.isSaving = true;

            PatientMedication.note({
                ids: vm.getSelectedIds(vm.selected),
                facilityId: vm.filter.facilityId
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.dtInstance.reloadData();

            if (result) {
                toastr.success("The medications was noted");
            } else {
                toastr.error("Some medications weren't noted");
            }
        }

        function onSaveError() {
            alert("Error noted");
            vm.isSaving = false;
        }

        function openConfirmationModal() {
            var nurse = CoreService.getCurrentEmployee();

            ConfirmationService.open({
                title: 'Confirm',
                message: `I, <strong>${nurse.firstName} ${nurse.lastName}</strong> have noted and reviewed the selected order.`,
                actions: [
                    {
                        name: 'Noting',
                        color: 'btn btn-success',
                        icon: 'fa fa-check-circle',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Close',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }).result.then(function () {
                vm.updateStatusNoted()
            });
        }

        function getFilter() {
            var filter = angular.copy(vm.filter);
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter;
        }

        function close() {
            $uibModalInstance.dismiss('cancel');
        }

        function fax() {
            PopupService.showContactAddressPickupPopup().result.then(function (result) {
                PatientMedication.fax({
                    ids: vm.getSelectedIds(vm.selected),
                    moreIds: result.ids
                }, function () {
                    toastr.success("Fax in queue");
                }, function () {
                    _.forEach(result, function (contactAddress) {
                        toastr.error('Error sending fax to ' + (contactAddress.name ? contactAddress.name : "") + " Fax: " + contactAddress.fax + ". Try again later.");
                    })
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationMarsMissedDialogController', PatientMedicationMarsMissedDialogController);

    PatientMedicationMarsMissedDialogController.$inject = ['take', 'takes', 'chart', '$uibModalInstance',
        'PatientMedicationTakeComment', 'toastr', 'ParseLinks', 'AlertService', 'PatientMedicationTake',
        'PatientMedicationTakeMissedReason', 'CoreService',
        'WizardHandler'];

    function PatientMedicationMarsMissedDialogController(take, takes, chart, $uibModalInstance,
                                                         PatientMedicationTakeComment, toastr, ParseLinks, AlertService,
                                                         PatientMedicationTake,
                                                         PatientMedicationTakeMissedReason, CoreService,
                                                         WizardHandler) {
        var vm = this;

        vm.takes = takes;
        vm.take = take;
        vm.chart = chart;

        vm.title = "Missed Medication";

        vm.isPatientSigned = false;
        vm.isEmployeeSigned = false;
        vm.showReasons = true;
        vm.odsPatientSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.odsEmployeeSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.employeeSignatureAgree = false;
        vm.patientSignatureAgree = false;
        vm.employee = CoreService.getCurrentEmployee();
        vm.facility = CoreService.getCurrentFacility();

        vm.missedReasons = take == null ? null : take.missedReasons;

        vm.status = {
            SCHEDULED: 'SCHEDULED',
            SYSTEM_MISS: 'SYSTEM_MISS',
            HOLD: 'HOLD',
            ADMINISTERED: 'ADMINISTERED',
            OBSERVED: 'OBSERVED',
            MISSED: 'MISSED'
        };

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.patientSignature = "";
        vm.employeeSignature = "";

        vm.reasons = PatientMedicationTakeMissedReason.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

        vm.clear = clear;
        vm.addReasons = addReasons;
        vm.signTakeByPatient = signTakeByPatient;
        vm.signTakeByEmployee = signTakeByEmployee;

        init();

        function init() {
            if (takes.ids.length > 1) {
                vm.showReasons = true;
                vm.isPatientSigned = false;
                vm.isEmployeeSigned = false;
            } else {
                vm.showReasons = true;
                vm.isPatientSigned = take.patientSignatureId != null;
                vm.isEmployeeSigned = take.missedSignatureId != null;
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addReasons() {
            vm.isSaving = true;
            PatientMedicationTake.changeStatus({
                status: takes.status,
                takes: takes.ids,
                missedReasons: vm.missedReasons,
                facilityId: vm.facility.id
            }, function (result) {
                vm.showReasons = false;
                vm.isSaving = false;

                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationMissWizard').next();
                }
            });
        }

        function signTakeByPatient() {
            PatientMedicationTake.signTakeByPatient({
                takes: takes.ids,
                patientSignature: vm.patientSignature,
                facilityId: vm.facility.id
            }, function (result) {
                vm.take = result;
                vm.isPatientSigned = true;

                toastr.success('Patient Sign Successfully');
                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationMissWizard').next();
                }
            }, function () {
                toastr.error('Error signing medication');
            });
        }

        function signTakeByEmployee() {
            PatientMedicationTake.signTakeByEmployee({
                takes: takes.ids,
                employeeSignature: vm.employeeSignature,
                facilityId: vm.facility.id
            }, function (result) {
                vm.take = result;
                vm.isEmployeeSigned = true;

                toastr.success('Employee Sign Successfully');
                if (vm.isPatientSigned && vm.isEmployeeSigned) {
                    clear();
                } else {
                    WizardHandler.wizard('patientMedicationMissWizard').previous();
                }
            }, function () {
                toastr.error('Error signing medication');
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationMarsNewController', PatientMedicationMarsNewController);

    PatientMedicationMarsNewController.$inject = ['PopupService', 'filter', 'PatientMedication', 'CoreService', 'Chart',
        'Vitals', 'Glucose', 'Evaluation', '$uibModal', 'DataTablesService', 'toastr',
        'PatientMedicationTake', 'BusinessCredential', 'BUSINESS_ROLES', "Allergies",
        '$state', 'PendingPdfChartReport', 'REPORT_TYPE', 'UrgentIssues',
        'ConfirmationService', '$q'];

    function PatientMedicationMarsNewController(PopupService, filter, PatientMedication, CoreService, Chart,
                                                Vitals, Glucose, Evaluation, $uibModal, DataTablesService, toastr,
                                                PatientMedicationTake, BusinessCredential, BUSINESS_ROLES, Allergies,
                                                $state, PendingPdfChartReport, REPORT_TYPE, UrgentIssues,
                                                ConfirmationService, $q) {
        var vm = this;

        vm.title = 'MARs';
        vm.searchQuery = "";
        vm.filter = filter;
        vm.charts = [];
        vm.filterStatus = CoreService.getPatientMedicationFilterStatus();
        vm.itemsPerPage = 10;
        vm.takesPerPage = 10;
        vm.itHasNotingCredentials = false;
        vm.facility = CoreService.getCurrentFacility();

        vm.radioModel = '';
        vm.status = {
            SCHEDULED: 'SCHEDULED',
            SYSTEM_MISS: 'SYSTEM_MISS',
            HOLD: 'HOLD',
            ADMINISTERED: 'ADMINISTERED',
            OBSERVED: 'OBSERVED',
            MISSED: 'MISSED',
            PATIENT_REFUSE: 'PATIENT_REFUSE'
        };

        vm.changeFilter = changeFilter;
        vm.clear = clear;
        vm.getMedications = getMedications;
        vm.isToday = isToday;
        vm.loadAll = loadAll;

        vm.showFilter = showFilter;
        vm.toggleRow = toggleRow;
        vm.getTakeStatusClass = getTakeStatusClass;
        vm.getEvaluationStatusClass = getEvaluationStatusClass;
        vm.addAsNeeded = addAsNeeded;
        vm.administer = administer;
        vm.firstDoseSideEffect = firstDoseSideEffect;
        vm.addComment = addComment;
        vm.sign = sign;
        vm.getTakeAsNeededAvailableClass = getTakeAsNeededAvailableClass;
        vm.getTakes = getTakes;
        vm.getAsNeededTakes = getAsNeededTakes;
        vm.showGlucosePopup = showGlucosePopup;
        vm.openChart = openChart;
        vm.showMissingReasons = showMissingReasons;
        vm.getMissingReasons = getMissingReasons;
        vm.print = print;

        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        //evaluations functions
        vm.amended = amended;
        vm.assignEvaluation = assignEvaluation;
        vm.del = del;
        vm.view = view;
        vm.openNotingDialog = openNotingDialog;
        vm.openPatientRefuseConfirmDialog = openPatientRefuseConfirmDialog;

        init();

        function init() {
            BusinessCredential.getCredentialByRole({
                businessRole: BUSINESS_ROLES.NURSE,
                id: vm.facility.id
            }, function (result) {
                vm.credentials = result;

                vm.itHasNotingCredentials = _.intersection(CoreService.getCurrentEmployee().credentials,
                    _.map(vm.credentials, function (credential) {
                        return credential.name;
                    })
                ).length > 0;
            });
        }

        loadAll();

        function loadAll() {
            PatientMedication.mars(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.charts = result;


                var chartIds = _.map(vm.charts, 'id');

                if (chartIds.length > 0) {
                    UrgentIssues.countByChartIds({chartIds: chartIds}, function (dataChartIdCountUI) {
                        _.forEach(dataChartIdCountUI, function (item) {
                            var chartProj_ = _.find(vm.charts, function (chartProj) {
                                return chartProj.id == item.chartId;
                            });

                            if (chartProj_) {
                                chartProj_.urgentIssues = item.count;
                            }
                        });
                    });
                }
                _.forEach(vm.charts, function (chart) {
                    chart.takesTotalItems = 0;
                    chart.takesAsNeededTotalItems = 0;
                    chart.takesPage = 1;
                    chart.takesAsNeededPage = 1;
                    chart.pendingNoting = 0;
                });
            });
        }

        function showFilter() {
            angular.element('#filter_as_needed').toggleClass('active');
            if (angular.element('#filter_as_needed').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('#filter_as_needed').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('#filter_as_needed').slideUp();
            }
        }

        function changeFilter(att, value) {
            vm.filter.page = 1;

            vm.charts = [];

            if (att) {
                vm.filter[att] = value;
            }

            loadAll();
        }

        function clear() {
            vm.page = 1;
            vm.searchQuery = null;

            loadAll();
        }

        function getMedications(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);
                vm.medications = MedicationSearch.query({
                    query: query
                });
            }
        }

        function toggleRow(chartProj) {
            chartProj.active = !chartProj.active;
            chartProj.takesPage = 1;
            chartProj.takesAsNeededPage = 1;

            chartProj.pendingNoting = PatientMedication.countByChartAndNotedIsFalse({"id": chartProj.id})

            if (chartProj.active) {
                Chart.get({id: chartProj.id}, function (chart) {
                    chartProj.chart = chart;
                })

                Allergies.findAllByChartAndStatus({id: chartProj.id, status: true}, function (allergies) {
                    if (allergies.length > 0) {
                        chartProj.allergies =
                            _.join(
                                _.map(allergies, function (allergy) {
                                    return allergy.name;
                                }), ', ');
                    }
                });

                chartProj.vitals = Vitals.findLastByChart({id: chartProj.id});
                chartProj.glucose = Glucose.findLastByChart({id: chartProj.id});
                chartProj.takes = [];
                chartProj.asNeeded = [];

                getEvaluations(chartProj);

                getEvaluationsMeasurement(chartProj)

                getTakes(chartProj);

                if (vm.filter.filterStatus == vm.filterStatus.CURRENT) {
                    getAsNeededTakes(chartProj);
                }
            }
        }

        function getTakes(chartProj) {
            PatientMedication.marsTakes({
                chartId: chartProj.id,
                filterStatus: vm.filter.filterStatus,
                facilityId: vm.filter.facilityId,
                size: vm.takesPerPage,
                page: chartProj.takesPage - 1
            }, function (takes, headers) {
                chartProj.takesTotalItems = headers('X-Total-Count');

                chartProj.takes = takes;
                chartProj.selected = {};
                chartProj.selectAll = false;
            });
        }

        function getAsNeededTakes(chartProj) {
            PatientMedication.marsTakes({
                chartId: chartProj.id,
                filterStatus: "AS_NEEDED",
                facilityId: vm.filter.facilityId,
                size: vm.takesPerPage,
                page: chartProj.takesAsNeededPage - 1
            }, function (takes, headers) {
                chartProj.takesAsNeededTotalItems = headers('X-Total-Count');

                chartProj.asNeeded = _.map(takes, function (data) {
                    if (data.lastScheduleDate) {
                        var newDate = moment(data.lastScheduleDate).toDate();
                        newDate.setHours(newDate.getHours() + data.frequency.hours);

                        data.untilDate = newDate;
                        data.available = newDate <= new Date();
                    } else {
                        data.untilDate = new Date();
                        data.available = true;
                    }

                    return data;
                });

                chartProj.selectedAsNeeded = {};
                chartProj.selectAllAsNeeded = false;
            });
        }

        function getEvaluations(chartProj) {
            chartProj.evaluations = [];
            chartProj.evaluations = Evaluation.findAllChartAndMars({id: chartProj.id})
        }

        function getEvaluationsMeasurement(chartProj) {
            chartProj.measurements = [];
            chartProj.measurements = Evaluation.findAllLastMeasurementsByChart({
                chartId: chartProj.id,
                facilityId: vm.facility.id
            });
        }

        function getFilter() {
            var filter = angular.copy(vm.filter);

            filter.page -= 1;
            filter.medication = filter.medication ? filter.medication.id : null;
            filter.searchQuery = vm.searchQuery;

            return filter;
        }

        function isToday(dateStr) {
            if (dateStr) {
                var date = new Date(dateStr);
                var today = new Date();

                return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
            }

            return false;
        }

        function getTakeStatusClass(take) {
            switch (take.medicationTakeStatus) {
                case 'SCHEDULED' :
                    return 'label-success';
                case 'HOLD':
                    return 'label-danger';
                case 'OBSERVED': {
                    if (take.patientSignatureId && take.observedSignatureId) {
                        return 'label-success';
                    } else if (!take.patientSignatureId && !take.observedSignatureId) {
                        return 'label-danger';
                    } else {
                        return 'label-warning';
                    }
                }
                case 'ADMINISTERED':
                    return 'label-primary';
                case 'MISSED': {
                    if (take.patientSignatureId && take.missedSignatureId) {
                        return 'label-success';
                    } else if (!take.patientSignatureId && !take.missedSignatureId) {
                        return 'label-danger';
                    } else {
                        return 'label-warning';
                    }
                }
                case 'SYSTEM_MISS':
                    return 'label-warning';

                case 'PATIENT_REFUSE':
                    return 'label-danger';
            }

            return "";
        }

        function getTakeAsNeededAvailableClass(take) {
            return take.untilDate < new Date() ? 'label-success' : 'label-danger';
        }

        function getEvaluationStatusClass(evaluation) {
            return CoreService.getEvaluationStatusClass(evaluation.status);
        }

        function assignEvaluation(chartProj) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-template/mars-assign/evaluation-template-mars-assign-dialog.html',
                controller: 'EvaluationTemplateMarsAssignDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chartProj.chart
                }
            }).result.then(function () {
                getEvaluations(chartProj);
            }, function (result) {
                getEvaluations(chartProj);
            });
        }

        function amended(chartProj, evaluation) {
            Evaluation.amended({id: evaluation.id}, function () {
                getEvaluations(chartProj);
            });
        }

        function del(chartProj, evaluation) {
            ConfirmationService.showDelete('Evaluation').result.then(function () {
                Evaluation.delete({id: evaluation.id}, function () {
                    getEvaluations(chartProj);
                }, function (result) {
                    getEvaluations(chartProj);
                });
            })
        }

        function addAsNeeded(chartProj, status) {
            var ids = vm.getSelectedIds(chartProj.selectedAsNeeded);
            vm.isSaving = true;

            PatientMedication.addAsNeeded({ids: ids, takeStatus: status}, function (result) {
                vm.isSaving = false;

                if (result.length > 0) {
                    if (status == vm.status.ADMINISTERED) {
                        toastr.success('The medications has been administered');
                    }
                    if (status == vm.status.OBSERVED) {
                        toastr.success('The medications has been observed');
                        openSigDialog(chartProj, status, result)
                    }
                } else {
                    if (status == vm.status.ADMINISTERED) {
                        toastr.error("Some medications weren't administered");
                    }
                    if (status == vm.status.OBSERVED) {
                        toastr.error("Some medications weren't observed");
                    }
                }

                chartProj.active = false;
                toggleRow(chartProj);
            }, function () {
                vm.isSaving = false;
            });
        }

        function administer(chartProj, status) {
            var takes = vm.getSelectedIds(chartProj.selected);

            switch (status) {
                case vm.status.MISSED: {
                    takes = _.filter(takes, function (take) {
                        var takeObj = _.filter(chartProj.takes, function (item) {
                            return "" + item.takeId == take;
                        })[0];

                        if (takeObj.medicationTakeStatus == vm.status.MISSED) {
                            chartProj.selected[take] = false;
                        }

                        return chartProj.selected[take];
                    });

                    if (takes.length > 0) {
                        if (vm.filter.filterStatus == vm.filterStatus.MISSED) {
                            openSystemMissDialog(chartProj, status, takes).result.then(function () {
                                openMissWizard(chartProj, status, takes);
                            });
                        } else {
                            openMissWizard(chartProj, status, takes);
                        }
                    } else {
                        toastr.info('All selected medications are missed');
                    }

                    break;
                }
                case vm.status.OBSERVED: {
                    takes = _.filter(takes, function (take) {
                        var takeObj = _.filter(chartProj.takes, function (item) {
                            return "" + item.takeId == take;
                        })[0];

                        if (takeObj.medicationTakeStatus != vm.status.SCHEDULED && takeObj.medicationTakeStatus != vm.status.SYSTEM_MISS) {
                            chartProj.selected[take] = false;
                        }

                        return chartProj.selected[take];
                    });

                    if (takes.length > 0) {
                        if (vm.filter.filterStatus == vm.filterStatus.MISSED) {
                            openSystemMissDialog(chartProj, status, takes).result.then(function () {
                                PatientMedicationTake.changeStatus({
                                    status: status,
                                    takes: takes,
                                    facilityId: vm.facility.id
                                }, function (result) {
                                    chartProj.active = false;
                                    toggleRow(chartProj);

                                    openSigDialog(chartProj, status, takes);
                                });
                            });
                        } else {
                            PatientMedicationTake.changeStatus({
                                status: status,
                                takes: takes,
                                facilityId: vm.facility.id
                            }, function (result) {
                                chartProj.active = false;
                                toggleRow(chartProj);

                                openSigDialog(chartProj, status, takes);
                            });
                        }
                    } else {
                        toastr.info('All selected medications are invalid for Observe');
                    }

                    break;
                }
                case vm.status.HOLD: {
                    takes = _.filter(takes, function (take) {
                        var takeObj = _.filter(chartProj.takes, function (item) {
                            return "" + item.takeId == take;
                        })[0];

                        if (takeObj.medicationTakeStatus != vm.status.SCHEDULED) {
                            chartProj.selected[take] = false;
                        }

                        return chartProj.selected[take];
                    });

                    if (takes.length > 0) {
                        PatientMedicationTake.changeStatus({
                            status: status,
                            takes: takes,
                            facilityId: vm.facility.id
                        }, function (result) {
                            chartProj.active = false;
                            toggleRow(chartProj);
                        });
                    } else {
                        toastr.info('All selected medications are invalid for Hold');
                    }

                    break;
                }
                case vm.status.ADMINISTERED: {
                    takes = _.filter(takes, function (take) {
                        var takeObj = _.filter(chartProj.takes, function (item) {
                            return "" + item.takeId == take;
                        })[0];

                        if (takeObj.medicationTakeStatus != vm.status.SCHEDULED &&
                            takeObj.medicationTakeStatus != vm.status.HOLD &&
                            takeObj.medicationTakeStatus != vm.status.SYSTEM_MISS) {
                            chartProj.selected[take] = false;
                        }

                        return chartProj.selected[take];
                    });

                    if (takes.length > 0) {
                        if (vm.filter.filterStatus == vm.filterStatus.MISSED) {
                            openSystemMissDialog(chartProj, status, takes).result.then(function () {
                                PatientMedicationTake.changeStatus({
                                    status: status,
                                    takes: takes,
                                    facilityId: vm.facility.id
                                }, function (result) {
                                    chartProj.active = false;
                                    toggleRow(chartProj);
                                });
                            });
                        } else {
                            PatientMedicationTake.changeStatus({
                                status: status,
                                takes: takes,
                                facilityId: vm.facility.id
                            }, function (result) {
                                chartProj.active = false;
                                toggleRow(chartProj);
                            });
                        }
                    } else {
                        toastr.info('All selected medications are invalid for Administer');
                    }

                    break;
                }
                case vm.status.PATIENT_REFUSE: {
                    takes = _.filter(takes, function (take) {
                        var takeObj = _.filter(chartProj.takes, function (item) {
                            return "" + item.takeId == take;
                        })[0];

                        if (takeObj.medicationTakeStatus != vm.status.SCHEDULED &&
                            takeObj.medicationTakeStatus != vm.status.HOLD) {
                            chartProj.selected[take] = false;
                        }

                        return chartProj.selected[take];
                    });

                    if (takes.length > 0) {
                        openPatientRefuseConfirmDialog(chartProj, status, takes).then(function () {
                            chartProj.active = false;
                            toggleRow(chartProj);
                        });

                    } else {
                        toastr.info('All selected medications are invalid for Refuse');
                    }

                    break;
                }
            }
        }

        function firstDoseSideEffect(chartProj) {
            var takes = vm.getSelectedIds(chartProj.selected);

            $uibModal.open({
                templateUrl: 'app/entities/patient-medication/mars/first-dose-side-effect/first-dose-side-effect.dialog.html',
                controller: 'FirstDoseSideEffectDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    takes: {
                        ids: takes
                    },
                    chart: chartProj.chart
                }
            }).result.then(function () {
                chartProj.active = false;
                toggleRow(chartProj);
            }, function (result) {
                chartProj.active = false;
                toggleRow(chartProj);
            });
        }

        function addComment(chartProj) {
            var takes = vm.getSelectedIds(chartProj.selected);

            takes = _.filter(takes, function (take) {
                var takeObj = _.filter(chartProj.takes, function (item) {
                    return "" + item.takeId == take;
                })[0];

                if (takeObj.medicationTakeStatus != vm.status.ADMINISTERED &&
                    takeObj.medicationTakeStatus != vm.status.OBSERVED &&
                    takeObj.medicationTakeStatus != vm.status.SYSTEM_MISS &&
                    takeObj.medicationTakeStatus != vm.status.MISSED &&
                    takeObj.medicationTakeStatus != vm.status.PATIENT_REFUSE) {

                    chartProj.selected[take] = false;
                }

                return chartProj.selected[take];
            });

            if (takes.length > 0) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-medication/mars/comment/patient-medication-mars-comment-dialog.html',
                    controller: 'PatientMedicationMarsCommentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        takes: {
                            ids: takes
                        },
                        chart: chartProj.chart
                    }
                }).result.then(function () {
                    chartProj.active = false;
                    toggleRow(chartProj);
                }, function (result) {
                    chartProj.active = false;
                    toggleRow(chartProj);
                });
            } else {
                toastr.info('All selected medications do not require comments');
            }
        }

        function sign(chartProj) {
            var takes = vm.getSelectedIds(chartProj.selected);

            takes = _.filter(takes, function (take) {
                var takeObj = _.filter(chartProj.takes, function (item) {
                    return "" + item.takeId == take;
                })[0];

                if (takeObj.medicationTakeStatus != vm.status.MISSED && takeObj.medicationTakeStatus != vm.status.OBSERVED) {
                    chartProj.selected[take] = false;
                }

                return chartProj.selected[take];
            });

            if (takes.length > 0) {
                $uibModal.open({
                    templateUrl: 'app/entities/patient-medication/mars/sign/patient-medication-mars-sign-wizard-dialog.html',
                    controller: 'PatientMedicationMarsSignDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        takes: {
                            ids: takes,
                            status: null
                        },
                        chart: chartProj.chart,
                        take: ['PatientMedicationTake', function (PatientMedicationTake) {
                            if (takes.length == 1) {

                                return PatientMedicationTake.get({id: takes[0]}).$promise;
                            } else {

                                return null;
                            }
                        }]
                    }
                }).result.then(function () {
                    chartProj.active = false;
                    toggleRow(chartProj);
                }, function (result) {
                    chartProj.active = false;
                    toggleRow(chartProj);
                });
            } else {
                toastr.info('All selected medications do not require signatures');
            }
        }

        function openSystemMissDialog(chartProj, status, takes) {
            return $uibModal.open({
                templateUrl: 'app/entities/patient-medication/mars/system-miss/patient-medication-mars-system-miss-reason-dialog.html',
                controller: 'PatientMedicationMarsSystemMissDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    takes: {
                        ids: takes,
                        status: vm.status.SYSTEM_MISS
                    },
                    chart: chartProj.chart,
                    take: ['PatientMedicationTake', function (PatientMedicationTake) {
                        return takes.length > 1 ? null : PatientMedicationTake.get({id: takes[0]}).$promise;
                    }]
                }
            })
        }

        function openMissWizard(chartProj, status, takes) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-medication/mars/missed/patient-medication-mars-missed-wizard-dialog.html',
                controller: 'PatientMedicationMarsMissedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    takes: {
                        ids: takes,
                        status: status
                    },
                    chart: chartProj.chart,
                    take: ['PatientMedicationTake', function (PatientMedicationTake) {
                        return takes.length > 1 ? null : PatientMedicationTake.get({id: takes[0]}).$promise;
                    }]
                }
            }).result.then(function () {
                chartProj.active = false;
                toggleRow(chartProj);
            }, function (result) {
                chartProj.active = false;
                toggleRow(chartProj);
            });
        }

        function openSigDialog(chartProj, status, takes) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-medication/mars/sign/patient-medication-mars-sign-wizard-dialog.html',
                controller: 'PatientMedicationMarsSignDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    takes: {
                        ids: takes,
                        status: status
                    },
                    chart: chartProj.chart,
                    take: ['PatientMedicationTake', function (PatientMedicationTake) {
                        if (takes.length == 1) {

                            return PatientMedicationTake.get({id: takes[0]}).$promise;
                        } else {

                            return null;
                        }
                    }]
                }
            });
        }

        function view(id) {
            PopupService.showPatientMedicationsDetailsPopup(id);
        }

        function getMissingReasons(take) {
            if (!take.missedReasons) {
                ConfirmationService.open({
                    title: 'Missed Reason',
                    message: take.missedReasons,
                    actions: [
                        {
                            name: 'Close',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                });
            } else {
                PatientMedicationTake.get({id: take.takeId}, function (result) {
                    take.missedReasons = _.join(
                        _.map(result.missedReasons, function (missedReason) {
                            return missedReason.name;
                        }), ', ');

                    return ConfirmationService.open({
                        title: 'Missed Reason',
                        message: take.missedReasons,
                        actions: [
                            {
                                name: 'Close',
                                color: 'btn btn-danger',
                                icon: 'fa fa-ban',
                                value: 'CANCEL'
                            }
                        ]
                    });
                });
            }
        }

        function showMissingReasons(take) {
            if (!take.missedReasons) {
                PatientMedicationTake.get({id: take.takeId}, function (result) {
                    take.missedReasons = _.join(
                        _.map(result.missedReasons, function (missedReason) {
                            return missedReason.name;
                        }), ', ');
                });
            }
        }

        function openNotingDialog(chartProj) {
            if (vm.itHasNotingCredentials) {
                PopupService.showNotingPopup(chartProj ? chartProj.id : null).result.then(function () {
                    if (chartProj) {
                        chartProj.active = false;
                        toggleRow(chartProj);
                    }

                    loadAll();
                }, function () {
                    if (chartProj) {
                        chartProj.active = false;
                        toggleRow(chartProj);
                    }
                    loadAll();
                });
            }
        }

        function showGlucosePopup(chartProj) {
            PopupService.showGlucosePopup(chartProj.chart).result.then(function () {
                chartProj.glucose = Glucose.findLastByChart({id: chartProj.id});
            });
        }

        function openChart(chartId) {
            if (chartId != null) {
                $state.go('chart', {id: chartId})
            }
        }

        function print(id, chart) {
            PendingPdfChartReport.save({
                chart: {id: chart.id},
                objectId: id,
                name: "" + id,
                reportType: REPORT_TYPE.PATIENT_MEDICATION
            }, onPrintSuccess, onPrintError);
        }

        function onPrintSuccess(result) {
            toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
        }

        function onPrintError() {
            toastr.error("We couldn't generate the report.");
        }

        function openPatientRefuseConfirmDialog(chartProj, status, takes) {
            return $q(function(resolve) {
                ConfirmationService.open({
                    title: 'Patient Refuse',
                    message: 'This action will <strong>refused</strong> the Medications. Are you sure you want to <strong>refused</strong> these Medications?',
                    actions: [
                        {
                            name: 'Refuse',
                            color: 'btn btn-success',
                            icon: 'fa fa-check-circle',
                            value: 'SUCCESS'
                        },
                        {
                            name: 'Close',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                }).result.then(function () {
                    PatientMedicationTake.changeStatus({
                        status: status,
                        takes: takes,
                        facilityId: CoreService.getCurrentFacility().id
                    }, function (result) {
                        resolve();
                    });
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FirstDoseSideEffectDialogController', FirstDoseSideEffectDialogController);

    FirstDoseSideEffectDialogController.$inject = ['$uibModalInstance', 'ParseLinks', 'takes', 'toastr',
        'PatientMedicationTakeReaction', 'AlertService', 'CoreService'];

    function FirstDoseSideEffectDialogController($uibModalInstance, ParseLinks, takes, toastr,
                                                 PatientMedicationTakeReaction, AlertService, CoreService) {
        var vm = this;

        vm.title = "First Dose/Side effect";

        vm.page = 1;
        vm.itemsPerPage = 6;
        vm.reactions = [];
        vm.takes = takes;
        vm.message = null;
        vm.facility = CoreService.getCurrentFacility();

        vm.clear = clear;
        vm.transition = transition;
        vm.add = add;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        loadAll();

        function loadAll() {
            if (vm.takes.ids.length == 1) {
                PatientMedicationTakeReaction.findAllByTake({
                        id: takes.ids[0],
                        page: vm.page - 1,
                        size: vm.itemsPerPage
                    },

                    function (data, headers) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                        vm.reactions = data;
                    },

                    function (error) {
                        AlertService.error(error.data.message);
                    });
            }
        }

        function transition() {
            loadAll();
        }

        function add() {
            vm.isSaving = true;
            PatientMedicationTakeReaction.addFirstDoseSideEffect({
                ids: takes.ids,
                message: vm.message,
                facilityId: vm.facility.id
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (result.length > 0) {
                toastr.error('Error Adding First Dose Side Effect, please try again later');
            } else {
                toastr.success('The First Dose Side Effect was added successful');
            }

            if (vm.takes.ids.length == 1) {
                vm.message = null;

                transition();
            } else {
                clear();
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationMarsCommentDialogController', PatientMedicationMarsCommentDialogController);

    PatientMedicationMarsCommentDialogController.$inject = ['$uibModalInstance', 'PatientMedicationTakeComment',
        'ParseLinks', 'AlertService', 'takes', 'toastr', 'chart', 'CoreService'];

    function PatientMedicationMarsCommentDialogController($uibModalInstance, PatientMedicationTakeComment,
                                                          ParseLinks, AlertService, takes, toastr, chart, CoreService) {
        var vm = this;

        vm.title = "Comments";

        vm.page = 1;
        vm.itemsPerPage = 6;
        vm.comments = [];
        vm.takes = takes;
        vm.message = null;
        vm.chart = chart;
        vm.facility = CoreService.getCurrentFacility();

        vm.clear = clear;
        vm.transition = transition;
        vm.addComment = addComment;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        loadAll();

        function loadAll() {
            if (vm.takes.ids.length == 1) {
                PatientMedicationTakeComment.findAllByTake({
                        id: takes.ids[0],
                        page: vm.page - 1,
                        size: vm.itemsPerPage
                    },

                    function (data, headers) {
                        vm.links = ParseLinks.parse(headers('link'));
                        vm.totalItems = headers('X-Total-Count');
                        vm.queryCount = vm.totalItems;
                        vm.comments = data;
                    },

                    function (error) {
                        AlertService.error(error.data.message);
                    });
            }
        }

        function transition() {
            loadAll();
        }

        function addComment() {
            vm.isSaving = true;
            PatientMedicationTakeComment.addComment({
                ids: takes.ids,
                message: vm.message,
                facilityId: vm.facility.id,
                chart: vm.chart
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            if (result.length > 0) {
                toastr.error('Error Adding Comment, please try again later');
            } else {
                toastr.success('The Comment was added successful');
            }

            if (vm.takes.ids.length == 1) {
                vm.message = null;

                transition();
            } else {
                clear();
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationDialogController', PatientMedicationDialogController);

    PatientMedicationDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'Via', 'CoreService',
        'Route', 'patientMedication', 'PatientMedication', 'signAuthorities',
        'Allergies', 'PatientMedicationTake'];

    function PatientMedicationDialogController($timeout, $scope, $uibModalInstance, Via, CoreService,
                                               Route, patientMedication, PatientMedication, signAuthorities,
                                               Allergies, PatientMedicationTake) {
        var vm = this;

        vm.currentEmployee = CoreService.getCurrentEmployee();
        vm.patientMedication = patientMedication;
        vm.chart = patientMedication.chart;

        vm.allergiesStr = "";
        vm.rationaleStr = "";
        vm.frequencies = [];
        vm.takes = [];

        vm.isEnabledToSign = false;
        vm.signature = "";
        vm.signatureDiscontinue = "";

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.odsSignatureNameId = "" + odsSignatureNameId();
        vm.odsDiscontinueSignatureNameId = "" + odsSignatureNameId();

        vm.isEnabledToSign = _.intersection(vm.currentEmployee.credentials,
            _.map(signAuthorities, function (credential) {
                return credential.name;
            })
        ).length > 0;

        init();

        function init() {
            PatientMedication.findAllFrequencies({id: vm.patientMedication.id}, function (data) {
                vm.frequencies = _.sortBy(data, 'xorder');

                _.forEach(vm.frequencies, function (frequency) {
                    frequency.schedules = _.sortBy(frequency.schedules, 'xorder');

                    frequency.hideDay = false;

                    switch (frequency.frequency.id) {
                        case 'EVERY_H':
                        case 'EVERY_2H':
                        case 'EVERY_3H':
                        case 'EVERY_4H':
                        case 'EVERY_6H':
                        case 'EVERY_8H':
                        case 'EVERY_12H':
                        case 'EVERY_24H':
                        case 'EVERY_48H':
                        case 'EVERY_WEEK':
                        case 'EVERY_TWO_WEEKS':
                        case 'EVERY_MONTH': {
                            frequency.hideDay = true;

                            break;
                        }
                    }
                });
            });

            if (vm.patientMedication.relational.length > 0) {
                vm.rationaleStr =
                    _.join(
                        _.map(vm.patientMedication.relational, function (relational) {
                            return relational.name;
                        }), ', ');
            }

            PatientMedicationTake.findAllByPatientMedication({id: vm.patientMedication.id}, function (data) {
                vm.takes = data;
            })
        }

        vm.clear = clear;
        vm.physicianSign = physicianSign;
        vm.discontinueSign = discontinueSign;
        vm.checkDiscontinueAccess = checkDiscontinueAccess;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function physicianSign() {
            vm.isSaving = true;

            PatientMedication.sign({
                id: vm.patientMedication.id,
                signature: vm.signature,
                pin: vm.pin
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            vm.patientMedication = result;

            $uibModalInstance.close();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function discontinueSign() {
            vm.isSaving = true;

            var patientMedicationProj = {
                ids: [vm.patientMedication.id],
                signature: vm.signatureDiscontinue,
                pin: vm.pin
            };

            PatientMedication.discontinue2(patientMedicationProj, onSaveSuccess, onSaveError);
        }

        function checkDiscontinueAccess() {
            return vm.patientMedication.medicationStatus === 'DISCONTINUED' &&
                (vm.patientMedication.discontinueSignature != null ||
                    (vm.isEnabledToSign && vm.patientMedication.discontinueSignature == null && (vm.patientMedication.discontinueByPhysician.id == vm.currentEmployee.id)));
        }

        function odsSignatureNameId() {
            return Math.floor((Math.random() * 100) + 1);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationChart2DialogController', PatientMedicationChart2DialogController);

    PatientMedicationChart2DialogController.$inject = ['$uibModalInstance', 'chart', 'CoreService',
        'Protocol', 'DataTablesService', 'MedicationSearch', 'Relational',
        'Route', 'DoseForm', 'Via', 'Employee',
        'BusinessCredential', 'BUSINESS_ROLES', 'PatientMedication',
        'admissionMedications', 'AdmissionMedication', 'patientMedication',
        'RATIONALE_TYPE', 'evaluation', 'itHasCredentials'];

    function PatientMedicationChart2DialogController($uibModalInstance, chart, CoreService,
                                                     Protocol, DataTablesService, MedicationSearch, Relational,
                                                     Route, DoseForm, Via, Employee,
                                                     BusinessCredential, BUSINESS_ROLES, PatientMedication,
                                                     admissionMedications, AdmissionMedication, patientMedication,
                                                     RATIONALE_TYPE, evaluation, itHasCredentials) {
        var vm = this;

        vm.itHasCredentials = itHasCredentials.value;
        vm.chart = chart;
        vm.admissionMedications = admissionMedications;
        vm.page = 1;
        vm.itemsPerPage = 25;
        vm.protocolType = 'ALL';
        vm.selected = {};
        vm.selectAll = false;
        vm.pmedications = [];
        vm.relationals = Relational.findAllByFilter(getFilterByCorporationAndType());
        vm.doseForms = DoseForm.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.routes = Route.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.frequencies = PatientMedication.getAllMedicationFrequency();
        vm.vias = Via.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.via = null;
        vm.physician = null;
        vm.facility = CoreService.getCurrentFacility();
        vm.isEnabledToSign = false;
        vm.employee = CoreService.getCurrentEmployee();
        vm.matches = {};
        vm.employeeSignature = '';
        vm.employeeSignaturePin = null;
        vm.signatureOpts = getSignatureOptions();
        vm.odsSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.patientMedication = patientMedication;

        vm.clear = clear;
        vm.getProtocols = getProtocols;
        vm.changeProtocolType = changeProtocolType;
        vm.deployProtocols = deployProtocols;
        vm.getMedications = getMedications;
        vm.deleteMedication = deleteMedication;
        vm.deleteDay = deleteDay;
        vm.addDay = addDay;
        vm.changeFrequency = changeFrequency;
        vm.add = add;
        vm.changeCategory = changeCategory;
        vm.save = save;
        vm.checkAll = checkAll;
        vm.unCheckAll = unCheckAll;
        vm.getEmployees = getEmployees;

        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        init();

        function init() {
            if (vm.itHasCredentials) {
                // vm.isEnabledToSig = vm.itHasCredentials;
                vm.physician = vm.employee;
                vm.employees = [vm.employee];
            } else {
                vm.getEmployees();
            }

            PatientMedication.match({id: vm.chart.id}, function (medications) {
                _.forEach(medications, function (medication) {
                    vm.matches[medication.id] = true;
                })
            });

            if (admissionMedications && admissionMedications.ids && admissionMedications.ids.length > 0) {
                getAdmissionMedications();
            } else {
                getProtocols();
            }

            if (vm.patientMedication) {
                var pM = angular.copy(vm.patientMedication);
                var auxFrequencies = [];

                if (pM.frequencies) {
                    _.forEach(pM.frequencies, function (frequency) {
                        var auxFrequency = angular.copy(frequency);

                        auxFrequency.id = null;
                        auxFrequency.hideDay = false;

                        switch (auxFrequency.frequency.id) {
                            case 'EVERY_H':
                            case 'EVERY_2H':
                            case 'EVERY_3H':
                            case 'EVERY_4H':
                            case 'EVERY_6H':
                            case 'EVERY_8H':
                            case 'EVERY_12H':
                            case 'EVERY_24H':
                            case 'EVERY_48H':
                            case 'EVERY_WEEK':
                            case 'EVERY_TWO_WEEKS':
                            case 'EVERY_MONTH': {
                                auxFrequency.hideDay = true;

                                break;
                            }
                        }

                        if (auxFrequency.schedules) {
                            _.forEach(auxFrequency.schedules, function (schedule) {
                                schedule.id = null;
                            });
                        }

                        auxFrequencies.push(auxFrequency);
                    });
                }

                var pMedication = {
                    medication: pM.medication,
                    route: pM.route,
                    doseForm: pM.doseForm,
                    refills: pM.refills,
                    dispense: pM.dispense,
                    relational: pM.relational,
                    type: pM.type,
                    durationDays: pM.durationDays,
                    instruction: pM.instruction,
                    collapsed: false,
                    startDate: new Date(),
                    frequencies: auxFrequencies,
                    onlyInChart: pM.onlyInChart,
                    fromPatientMedicationId: vm.patientMedication.medicationStatus == 'SCHEDULED' ? vm.patientMedication.id : null
                }

                vm.pmedications.push(pMedication);

                vm.physician = vm.patientMedication.signedBy;
                vm.via = vm.patientMedication.via;
            }
        }

        function save() {
            vm.isSaving = true;

            var patientMedicationProj = {
                patientMedications: [],
                chartId: vm.chart.id,
                chart: chart,
                signature: vm.employeeSignature,
                pin: vm.employeeSignaturePin,
                physician: vm.physician,
                evaluation: evaluation,
                via: vm.via
            };

            _.forEach(vm.pmedications, function (pMedication) {
                var patientMedication = angular.copy(pMedication);

                _.forEach(patientMedication.frequencies, function (frequency) {
                    _.forEach(frequency.schedules, function (schedule) {
                        schedule.date = moment(schedule.date).format('YYYY-MM-DDTHH:mm:00');
                    });
                });

                var pm = {
                    id: null,
                    chart: null,
                    via: vm.via,
                    startDate: moment.tz(moment(patientMedication.startDate).format('YYYY-MM-DDTHH:mm:00'), vm.facility.timeZone).format(),
                    endDate: patientMedication.endDate,
                    route: patientMedication.route,
                    instruction: patientMedication.instruction,
                    durationDays: patientMedication.durationDays,
                    doseForm: patientMedication.doseForm,
                    medication: patientMedication.medication,
                    relational: patientMedication.relational,
                    noted: false,
                    refills: patientMedication.refills,
                    dispense: patientMedication.dispense,
                    type: patientMedication.type,
                    protocolId: patientMedication.protocolId,
                    frequencies: patientMedication.frequencies,
                    admissionMedication: patientMedication.admissionMedication,
                    onlyInChart: patientMedication.onlyInChart,
                    fromPatientMedicationId: patientMedication.fromPatientMedicationId
                };

                patientMedicationProj.patientMedications.push(pm);
            });

            PatientMedication.create(patientMedicationProj, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.finishedWizard = finishedWizard;
        vm.cancelledWizard = cancelledWizard;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function finishedWizard() {

        }

        function cancelledWizard() {

        }

        function getFilter() {
            var filter = {};

            filter.facilityId = CoreService.getCurrentFacility().id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;
            filter.active = true;
            filter.type = vm.protocolType === 'ALL' ? null : vm.protocolType;

            return filter
        }

        function getProtocols() {
            Protocol.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.protocols = result;

                _.forEach(vm.protocols, function (protocol) {
                    if (vm.selected[protocol.id] === undefined) {
                        vm.selected[protocol.id] = false;
                    }
                })
            });
        }

        function changeProtocolType() {
            vm.page = 1;
            getProtocols();
        }

        function deployProtocols() {
            vm.getSelectedIds = DataTablesService.getSelectedIds(vm.selected);

            if (vm.getSelectedIds.length > 0) {
                Protocol.findAll({
                    ids: vm.getSelectedIds,
                    facilityId: CoreService.getCurrentFacility().id
                }, function (protocols) {
                    vm.pmedications = _.map(protocols, function (protocol) {

                        return medicationFromProtocol(protocol);
                    });
                });
            }
        }

        function medicationFromProtocol(protocol) {
            var medication = angular.copy(protocol);
            medication.refills = protocol.refills;
            medication.dispense = protocol.dispense;
            medication.collapsed = true;
            medication.startDate = new Date();
            medication.protocolId = protocol.id;
            medication.id = null;
            medication.relational = protocol.relationals;
            medication.instruction = protocol.instructions;
            medication.onlyInChart = false;
            medication.frequencies = _.map(protocol.protocolFrequencies, function (frequency) {

                return {
                    id: null,
                    xorder: frequency.xorder,
                    frequency: frequency.frequency,
                    hideDay: frequency.hideDay,
                    schedules: _.map(frequency.schedules, function (schedule) {

                        return {
                            id: null,
                            strength: schedule.strength,
                            quantity: schedule.quantity,
                            xorder: schedule.xorder,
                            date: schedule.date
                        };
                    })
                }
            });

            return medication;
        }

        function medicationFromAdmissionMedication(admissionMedication) {
            var medication = {};
            medication.onlyInChart = false;
            medication.admissionMedication = admissionMedication;
            medication.collapsed = true;
            medication.medication = admissionMedication.medication;
            medication.route = admissionMedication.route;
            medication.doseForm = admissionMedication.doseForm;
            medication.durationDays = admissionMedication.durationDays;
            medication.startDate = new Date();
            medication.protocolId = null;
            medication.id = null;
            medication.relational = admissionMedication.relationals;
            medication.instruction = admissionMedication.instructions;
            medication.type = admissionMedication.asNeeded ? 'AS_NEEDED' : 'CONSISTENT_DOSE';
            medication.frequencies = _.map(admissionMedication.admissionFrequencies, function (frequency) {

                return {
                    id: null,
                    xorder: frequency.xorder,
                    frequency: frequency.frequency,
                    hideDay: frequency.hideDay,
                    schedules: _.map(frequency.schedules, function (schedule) {

                        return {
                            id: null,
                            strength: schedule.strength,
                            quantity: schedule.quantity,
                            xorder: schedule.xorder,
                            date: schedule.date
                        };
                    })
                }
            });

            return medication;
        }

        function getMedications(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);
                vm.medications = MedicationSearch.query({
                    query: query
                });
            }
        }

        function deleteMedication(index) {
            vm.pmedications.splice(index, 1);
        }

        function deleteDay(pmedication, index) {
            pmedication.frequencies.splice(index, 1);

            _.forEach(pmedication.frequencies, function (frequency, index) {
                frequency.xorder = index;
            })
        }

        function addDay(pmedication, index) {
            var frequency = {
                frequency: null,
                xorder: null
            }

            pmedication.frequencies.splice(index == null ? pmedication.frequencies.length : index, 0, frequency);
            pmedication.frequencies.forEach(function (freq, i) {
                freq.xorder = i;
            });
        }

        function changeFrequency(frequency) {
            frequency.schedules = [];
            frequency.hideDay = false;

            switch (frequency.frequency.id) {
                case 'EVERY_H':
                case 'EVERY_2H':
                case 'EVERY_3H':
                case 'EVERY_4H':
                case 'EVERY_6H':
                case 'EVERY_8H':
                case 'EVERY_12H':
                case 'EVERY_24H':
                case 'EVERY_48H':
                case 'EVERY_WEEK':
                case 'EVERY_TWO_WEEKS':
                case 'EVERY_MONTH': {
                    frequency.hideDay = true;
                    scheduleTakesIntervals(frequency, 1, 0, 1);

                    break;
                }
                case 'ONE_AM': {
                    scheduleTakesIntervals(frequency, 1, 0, 9);

                    break;
                }
                case 'ONE_HS': {
                    scheduleTakesIntervals(frequency, 1, 0, 21);

                    break;
                }
                case 'BID': {
                    scheduleTakesIntervals(frequency, 2, 12, 9);

                    break;
                }
                case 'TID': {
                    scheduleTakesIntervals(frequency, 3, 6, 9);

                    break;
                }
                case 'QID': {
                    scheduleTakesIntervals(frequency, 4, 3, 9);

                    break;
                }
                case 'SID': {
                    scheduleTakesIntervals(frequency, 6, 4, 2);

                    break;
                }
                case 'ONCE': {
                    scheduleTakesIntervals(frequency, 1, 0, 15);

                    break;
                }
                case 'STAT': {
                    frequency.schedules.push({
                        xorder: 0,
                        strength: null,
                        date: new Date(moment(new Date()).format('YYYY-MM-DDTHH:mm:00'))
                    });

                    break;
                }
            }
        }

        function scheduleTakesIntervals(frequency, count, hours, firstHour) {
            var first = moment().startOf('hour').toDate();
            first.setHours(firstHour);

            for (var i = 0; i < count; i++) {
                frequency.schedules.push({
                    xorder: i,
                    date: angular.copy(first),
                    strength: null
                });

                first.setHours(first.getHours() + hours);
            }
        }

        function add() {
            vm.pmedications.push({
                collapsed: false,
                startDate: new Date(),
                frequencies: [],
                onlyInChart: false
            })
        }

        function changeCategory(pmedication) {
            pmedication.frequencies = [];

            switch (pmedication.type) {
                case 'AS_NEEDED':
                case 'CONSISTENT_DOSE': {
                    addDay(pmedication);
                    pmedication.durationDays = null;

                    break;
                }
                case 'TAPER': {
                    addDay(pmedication);
                    pmedication.durationDays = pmedication.frequencies.length;

                    break;
                }
            }
        }

        function getSignatureOptions() {

            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }

        function checkAll() {
            _.forEach(vm.protocols, function (protocol) {
                vm.selected[protocol.id] = true;
            })
        }

        function unCheckAll() {
            _.forEach(vm.protocols, function (protocol) {
                vm.selected[protocol.id] = false;
            })
        }

        function getAdmissionMedications() {
            _.forEach(admissionMedications.ids, function (id) {
                AdmissionMedication.get({id: id}, function (admissionMedication) {
                    vm.pmedications.push(medicationFromAdmissionMedication(admissionMedication));
                })
            })
        }

        function getFilterByCorporationAndType() {
            var filter = {};

            filter.corporationId = CoreService.getCorporation().id;
            filter.relationalType = RATIONALE_TYPE.MEDICATION;

            return filter
        }

        function getEmployees(query) {
            if (vm.itHasCredentials) {
                return;
            }

            var filter = {
                page: 0,
                size: 200000,
                query: query,
                facilityId: CoreService.getCurrentFacility().id,
                businessRole: BUSINESS_ROLES.PHYSICIAN
            };

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationChart2Controller', PatientMedicationChart2Controller);

    PatientMedicationChart2Controller.$inject = ['CoreService', '$uibModal', 'chart', 'PatientMedication',
        'AlertService', 'ParseLinks', 'PopupService', 'DataTablesService', 'toastr',
        '$rootScope', '$state', '$scope', 'access', 'discontinued', '$uibModalStack',
        'ACTIONS', 'TAB', 'params', 'Auth', 'PendingPdfChartReport', 'REPORT_TYPE'];

    function PatientMedicationChart2Controller(CoreService, $uibModal, chart, PatientMedication,
                                               AlertService, ParseLinks, PopupService, DataTablesService, toastr,
                                               $rootScope, $state, $scope, access, discontinued, $uibModalStack,
                                               ACTIONS, TAB, params, Auth, PendingPdfChartReport, REPORT_TYPE) {
        var vm = this;

        vm.chart = chart;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.patientMedications = [];
        vm.selected = {};
        vm.selectAll = false;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.MEDICATIONS);
        vm.chart = chart;
        vm.access = access;

        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.transition = transition;
        vm.view = view;
        vm.fax = fax;
        vm.discontinue = discontinue;
        vm.search = search;
        vm.history = history;
        vm.print = print;
        vm.edit = edit;
        vm.changeOnlyChart = changeOnlyChart;

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_MEDICATION_VIEW, access) || !vm.active) {
                return;
            }

            PatientMedication.findAllByFilter({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                discontinued: discontinued
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientMedications = data;

                initSelected();
            }

            function onError(error) {
                AlertService.error(error.data);
            }
        }

        function toggleItem() {
            CoreService.togglePanel('patientMeds');
        }

        function add() {
            PopupService.showPatientMedicationPopup(chart).result.then(function () {
                reload();
            }, function () {

            });
        }

        function reload() {
            vm.page = 1;
            loadAll();
        }

        function view(id) {
            PopupService.showPatientMedicationsDetailsPopup(id).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function print(id) {
            PendingPdfChartReport.save({
                chart: {id: vm.chart.id},
                objectId: id,
                name: "" + id,
                reportType: REPORT_TYPE.PATIENT_MEDICATION
            }, onPrintSuccess, onPrintError);
        }

        function onPrintSuccess(result) {
            toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
        }

        function onPrintError() {
            toastr.error("We couldn't generate the report.");
        }

        function fax(id) {
            PopupService.showContactAddressPickupPopup().result.then(function (result) {
                PatientMedication.fax({
                    ids: (id ? [id] : vm.getSelectedIds(vm.selected)),
                    moreIds: result.ids
                }, function () {
                    toastr.success("Fax in queue");
                }, function () {
                    _.forEach(result, function (contactAddress) {
                        toastr.error('Error sending fax to ' + (contactAddress.name ? contactAddress.name : "") + " Fax: " + contactAddress.fax + ". Try again later.");
                    })
                });
            });
        }

        function discontinue(id) {
            PopupService.showPatientMedicationDiscontinueWizardPopup().result.then(function (data) {
                PatientMedication.discontinue2({
                    signature: data.employeeSignature,
                    pin: data.employeeSignaturePin,
                    ids: (id ? [id] : vm.getSelectedIds(vm.selected)),
                    chartId: vm.chart.id,
                    discontinueVia: data.discontinueVia,
                    discontinueCause: data.discontinueCause,
                    physician: data.discontinueByPhysician,
                    facilityId: vm.chart.facility.id
                }, function (result) {
                    loadAll();

                    if (result) {
                        toastr.success("The Patient Medication was discontinued.");
                    } else {
                        toastr.error('The Patient Medication wasn\'t discontinued.');
                    }
                }, function () {
                    toastr.error('The Patient Medication wasn\'t discontinued.');
                });
            });
        }

        function transition() {
            loadAll();
        }

        function initSelected() {
            _.forEach(vm.patientMedications, function (patientMedication) {
                vm.selected[patientMedication.id] = false;
                vm.selectAll = false;
            })
        }

        function search() {
            vm.page = 1;
            transition();
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result == TAB.MEDICATIONS) {
                vm.active = true;
                loadAll();
            }
        });

        $scope.$on('$destroy', unsubscribe);

        function history() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/patient-medication/chart/history/patient-medication-history.html',
                controller: 'PatientMedicationHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom-xl',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function edit(patientMedicationId) {
            PopupService.showPatientMedicationPopup(vm.chart, null, patientMedicationId).result.then(function (data) {
                loadAll();
            });
        }

        function changeOnlyChart(id) {
            PatientMedication.changeOnlyChart(id,
                function () {
                    loadAll();
                    toastr.success("The Only In Chart was changed.");
                }, function () {
                    toastr.error("The Only In Chart wasn\'t changed.");
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationHistoryNewController', PatientMedicationHistoryNewController);

    PatientMedicationHistoryNewController.$inject = ['PatientMedication', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                             'chart', '$uibModalInstance', '$timeout', 'ParseLinks', 'PopupService', '$uibModalStack',
                                                '$state'];

    function PatientMedicationHistoryNewController(PatientMedication, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                           chart, $uibModalInstance, $timeout, ParseLinks, PopupService, $uibModalStack,
                                                   $state) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.patientMedications = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.addMedicationFromHistory = addMedicationFromHistory;

        loadAll();

        function loadAll() {
            PatientMedication.findAllByFilter({
                chartId: chart.id,
                searchQuery: vm.searchQuery,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                discontinued: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.patientMedications = data;
            }

            function onError(error) {
                AlertService.error(error.data);
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }

        function addMedicationFromHistory(patientMedicationId) {
            $uibModalStack.dismissAll();

            PopupService.showPatientMedicationPopup(chart, null, patientMedicationId).result.then(function () {
                $state.reload();
            }, function () {

            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientMedicationDiscontinueWizardController', PatientMedicationDiscontinueWizardController);

    PatientMedicationDiscontinueWizardController.$inject = ['$uibModalInstance', 'CoreService', 'Employee', 'Via',
        'BusinessCredential', 'BUSINESS_ROLES', 'itHasCredentials'];

    function PatientMedicationDiscontinueWizardController($uibModalInstance, CoreService, Employee, Via,
                                                          BusinessCredential, BUSINESS_ROLES, itHasCredentials) {
        var vm = this;

        vm.pin = "";
        vm.agree = false;
        vm.signature = "";
        vm.vias = Via.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.itHasCredentials = itHasCredentials.value;
        vm.discontinueVia = null;
        vm.discontinueCause = null;
        vm.discontinueByPhysician = null;
        vm.facility = CoreService.getCurrentFacility();
        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        vm.odsSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.employee = CoreService.getCurrentEmployee();

        vm.clear = clear;
        vm.discontinue = discontinue;
        vm.getEmployees = getEmployees;

        credentialsPermits();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function discontinue() {
            vm.isSaving = true;

            $uibModalInstance.close({
                employeeSignature: vm.signature,
                employeeSignaturePin: vm.pin,
                discontinueVia: vm.discontinueVia,
                discontinueCause: vm.discontinueCause,
                discontinueByPhysician: vm.discontinueByPhysician
            });
        }

        function credentialsPermits() {
            if (vm.itHasCredentials) {
                vm.employees = [vm.employee];
                vm.discontinueByPhysician = vm.employee;
            } else {
                vm.getEmployees();
            }
        }

        function getEmployees(query) {
            if (vm.itHasCredentials) {
                return;
            }

            var filter = {
                page: 0,
                size: 200000,
                query: query,
                facilityId: CoreService.getCurrentFacility().id,
                businessRole: BUSINESS_ROLES.PHYSICIAN
            };

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NotificationsDialogController', NotificationsDialogController);

    NotificationsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$state', '$uibModalInstance', 'entity', 'Notifications', 'Employee', 'CoreService'];

    function NotificationsDialogController ($timeout, $scope, $stateParams, $state, $uibModalInstance, entity, Notifications, Employee, CoreService) {
        var vm = this;

        vm.state = $state.current.name;
        vm.notifications = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.corporation = CoreService.getCorporation();
        vm.employees = Employee.byActive({id: vm.corporation.id});

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.notifications.id !== null) {
                Notifications.update(vm.notifications, onSaveSuccess, onSaveError);
            } else {
                vm.notifications.state = $state.current.name;
                vm.notifications.employee = CoreService.getCurrentEmployee();
                Notifications.save(vm.notifications, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:notificationsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.reviewedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NotificationsDetailController', NotificationsDetailController);

    NotificationsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Notifications', 'Employee'];

    function NotificationsDetailController($scope, $rootScope, $stateParams, previousState, entity, Notifications, Employee) {
        var vm = this;

        vm.notifications = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:notificationsUpdate', function(event, result) {
            vm.notifications = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NotificationsDeleteController',NotificationsDeleteController);

    NotificationsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Notifications'];

    function NotificationsDeleteController($uibModalInstance, entity, Notifications) {
        var vm = this;

        vm.notifications = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Notifications.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notifications', {
            parent: 'entity',
            url: '/notifications',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notifications'
            },
            ncyBreadcrumb: {
                label: 'Notifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notifications/notifications.html',
                    controller: 'NotificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('notifications-detail', {
            parent: 'entity',
            url: '/notifications/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notifications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notifications/notifications-detail.html',
                    controller: 'NotificationsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Notifications', function($stateParams, Notifications) {
                    return Notifications.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notifications',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('notifications-detail.edit', {
            parent: 'notifications-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-dialog.html',
                    controller: 'NotificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notifications', function(Notifications) {
                            return Notifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notifications.new', {
            parent: 'notifications',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-dialog.html',
                    controller: 'NotificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                title: null,
                                description: null,
                                priorityLevel: null,
                                viewed: false,
                                reviewedDate: null,
                                state: null,
                                stateParams: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function () {
                    $state.go('notifications', null, {reload: true});
                    CoreService.scrollToPosition('care-coordination', 80, 100);
                }, function () {
                    $state.go('notifications');
                });
            }]
        })
        .state('notifications.edit', {
            parent: 'notifications',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-dialog.html',
                    controller: 'NotificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notifications', function(Notifications) {
                            return Notifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notifications', null, { reload: 'notifications' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notifications.delete', {
            parent: 'notifications',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notifications/notifications-delete-dialog.html',
                    controller: 'NotificationsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Notifications', function(Notifications) {
                            return Notifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notifications', null, { reload: 'notifications' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Notifications', Notifications);

    Notifications.$inject = ['$resource', 'DateUtils'];

    function Notifications ($resource, DateUtils) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reviewedDate = DateUtils.convertDateTimeFromServer(data.reviewedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAll': {url: 'api/notifications/by-employee/:employeeId', method: 'GET', isArray: true, ignoreLoadingBar: true},
            'findAllByViewed': {url: 'api/notifications/by-viewed/:viewed', method: 'GET', isArray: true},
            'findAllByCreatedDate': {url: 'api/notifications/by-createdDate/:createdDate', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NotificationsController', NotificationsController);

    NotificationsController.$inject = ['$scope', '$state', 'Notifications', 'ParseLinks', 'AlertService', 'CoreService'];

    function NotificationsController ($scope, $state, Notifications, ParseLinks, AlertService, CoreService) {
        var vm = this;

        vm.title = 'Notificacions';

        vm.notifications = [];
        vm.notificationsCount = 0;
        vm.loadPage = loadPage;
        vm.page = 0;
        vm.links = {
            last: 0
        };
        vm.predicate = 'id';
        vm.reset = reset;
        vm.reverse = true;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.search = search;
        vm.saveViewed = saveViewed;

        if (CoreService.getCurrentEmployee().id !== null) {
            loadAll();
        }

        //createNotification("YEAHHHH", "DIGIT", "HIGH");

        function createNotification(title, description, priorityLevel) {
            var notification = {};
            notification.title = title;
            notification.description = description;
            notification.priorityLevel = priorityLevel;
            notification.viewed = false;
            notification.reviewedDate = new Date();
            notification.employee = CoreService.getCurrentEmployee();
            notification.state = $state.current.name;
            notification.stateParams = $state.params;

            Notifications.save(notification, onSaveSuccessCreateNotification, onSaveErrorCreateNotification);
        }

        function onSaveSuccessCreateNotification (result) {
            $scope.$emit('bluebookApp:notificationUpdate', result);
            $state.go('chart', {'#': 'notification'}, {reload: true});
            vm.isSaving = false;
        }

        function onSaveErrorCreateNotification () {
            vm.isSaving = false;
        }

        function loadAll () {

            Notifications.findAll({
                employeeId: -1,
                page: vm.page,
                size: 15,
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.notifications.push(data[i]);
                }
                vm.notificationsCount = vm.notifications.length;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function reset () {
            vm.page = 0;
            vm.notifications = [];
            loadAll();
        }

        function loadPage(page) {
            vm.page = page;
            loadAll();
        }

        function clear () {
            vm.notifications = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.searchQuery = null;
            vm.currentSearch = null;
            vm.loadAll();
        }

        function saveViewed (notification) {
            vm.isSaving = true;
            if ((notification.id !== null) && (notification.viewed == false)) {
                notification.viewed = true;
                Notifications.update(notification, onSaveSuccess, onSaveError);
                $state.reload();
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:notificationsUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.notifications = [];
            vm.links = {
                last: 0
            };
            vm.page = 0;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.loadAll();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ModifierSearch', ModifierSearch);

    ModifierSearch.$inject = ['$resource'];

    function ModifierSearch($resource) {
        var resourceUrl =  'api/_search/modifiers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('MessageHistoryChart', MessageHistoryChart);

    MessageHistoryChart.$inject = ['$resource'];

    function MessageHistoryChart ($resource) {
        var resourceUrl =  'api/message-history-charts/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllByFilter': { method: 'GET', url: "api/message-histories-charts/by-messages-history/filter", isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('MessageHistory', MessageHistory);

    MessageHistory.$inject = ['$resource'];

    function MessageHistory ($resource) {
        var resourceUrl =  'api/message-histories/:id';

        return $resource(resourceUrl, {}, {
            'filter': {
                url: 'api/message-histories/filter',
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('message-history', {
                parent: 'entity',
                url: '/message-history',
                data: {
                    authorities: [],
                    pageTitle: 'MessageHistories'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/message-history/list/message-history.html',
                        controller: 'MessageHistoryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id,
                            employee: null,
                            phoneNumber: null,
                            date: null
                        };
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MessageHistoryController', MessageHistoryController);

    MessageHistoryController.$inject = ['$scope', '$state', 'MessageHistory', 'CoreService', 'DTOptionsBuilder',
        'DTColumnBuilder', '$uibModal', '$q', '$compile', 'Employee', 'filter',
        '$rootScope', 'DateUtils', 'GenericEntityDatatableService'];

    function MessageHistoryController($scope, $state, MessageHistory, CoreService, DTOptionsBuilder,
                                      DTColumnBuilder, $uibModal, $q, $compile, Employee, filter,
                                      $rootScope, DateUtils, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            abnormalRange: null
        }

        vm.descriptor = {
            title: 'Message History',
            entityClassHumanized: 'Message History',
            entityStateName: 'message-history',
            service: MessageHistory,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            newAction: false,
            selectionColumn: 'id',
            columns: [
                {
                    title: 'Employee',
                    render: function(data) {
                        return data.employee.lastName + ', ' + data.employee.firstName;
                    }
                },
                {
                    title: 'Facility Phone Number',
                    render: function(data) {
                        return data.facilityPhoneNumber.phoneNumber;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
                {

                    title: 'Failed',
                    render: function (data) {
                        return data.failed ? data.failed : '0';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        detailMessagesHistory(data.id);
                    },
                }),
            ],
            filters: [
                {
                    name: 'employeeId',
                    read: function (filter) {
                        return filter.employeeId ? filter.employeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        Employee.findAllByFilter(
                            {
                                page: 0,
                                size: 10,
                                facilityId: CoreService.getCurrentFacility().id,
                                query: search,
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select Employee...',
                    type: 'select',
                    visible: true,
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12'
                },
                {
                    name: 'phoneNumber',
                    placeholder: 'Facility Phone Number...',
                    type: 'string',
                    visible: true
                },
                {
                    name: 'date',
                    placeholder: 'Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                }
            ]
        }

        function detailMessagesHistory(id) {
            $uibModal.open({
                templateUrl: 'app/entities/message-history/detail/message-history-detail.html',
                controller: 'MessageHistoryDetailController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['MessageHistory', function (MessageHistory) {
                        return MessageHistory.get({id: id}).$promise;
                    }]
                }
            });
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MessageHistoryDetailController', MessageHistoryDetailController);

    MessageHistoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', '$uibModalInstance',
        'MessageHistoryChart', 'DTOptionsBuilder', 'DTColumnBuilder', '$q',
        '$compile', 'GUIUtils', 'Campaign', 'toastr'];

    function MessageHistoryDetailController($scope, $rootScope, $stateParams, entity, $uibModalInstance,
                                            MessageHistoryChart, DTOptionsBuilder, DTColumnBuilder, $q,
                                            $compile, GUIUtils, Campaign, toastr) {
        var vm = this;

        vm.messageHistory = entity;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.dtInstance = {};

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.resendMessage = resendMessage;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            MessageHistoryChart.getAllByFilter(getFilter(),
                function (result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.messageHistoryCharts = result;
                    defer.resolve(vm.messageHistoryCharts);
                });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Message').notSortable().renderWith(function (data, type, full) {
                return data.message;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient').notSortable().renderWith(function (data, type, full) {
                return data.patientLastName + ', ' + data.patientFirstName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('To Phone Number').notSortable().renderWith(function (data, type, full) {
                return data.phoneNumber;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Sent').notSortable().renderWith(function (data, type, full) {
                return GUIUtils.colorHtmlYesNo(!data.twilioApiExceptionId);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {

            return '<div class="btn-group dd-buttons" uib-dropdown>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link blue" ' +
                'ng-click="vm.resendMessage(' + data.id + ')">' +
                '<i class="fa fa-send" aria-hidden="true"></i>Resend' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function getFilter() {
            var filter = {};

            filter.messageHistoryId = vm.messageHistory.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;

            transition();
        }

        function transition() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function resendMessage(id) {
            Campaign.resendMessage({id: id}).$promise.then(function (result) {
                transition();
                result.value ? toastr.success('Message have been sent successfully') : toastr.error('Message have not been sent');
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MedicationDialogController', MedicationDialogController);

    MedicationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Medication'];

    function MedicationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                         Medication) {
        var vm = this;

        vm.medication = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            Medication.save(vm.medication, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:medicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Medication', Medication);

    Medication.$inject = ['$resource'];

    function Medication ($resource) {
        var resourceUrl =  'api/medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': { method: 'POST' },
            'findAllByFilter': {url: 'api/medications/filter', method: 'GET', isArray: true},
            'frequencies': { method: 'GET', url: "api/medications/frequencies", isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('MedicationSearch', MedicationSearch);

    MedicationSearch.$inject = ['$resource'];

    function MedicationSearch($resource) {
        var resourceUrl =  'api/_search/medications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medication', {
            parent: 'entity',
            url: '/medication',
            data: {
                authorities: [],
                pageTitle: 'Medications'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medication/list/medication.html',
                    controller: 'MedicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATIONS];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_MEDICATIONS, access);
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MedicationController', MedicationController);

    MedicationController.$inject = ['$rootScope', 'Medication', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService']

    function MedicationController($rootScope, Medication, GenericEntityDatatableService, $q,
                                  $uibModal, ConfirmationService) {
        var vm = this;

        var entityStateName = 'medication'

        vm.descriptor = {
            title: 'Medications',
            newButtonTitle: 'New Medication',
            entityClassHumanized: 'Medication',
            entityStateName: entityStateName,
            service: Medication,
            serviceMethod: 'findAllByFilter',
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'createdBy',
                    title: 'Created By'
                },
                {
                    title: 'Created Date',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Medication',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/medication/update/medication-dialog.html',
                controller: 'MedicationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Medication').result.then(function () {
                    Medication.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LaboratoryLogo', LaboratoryLogo);

    LaboratoryLogo.$inject = ['$resource'];

    function LaboratoryLogo ($resource) {
        var resourceUrl =  'api/laboratory-logos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LaboratoryDialogController', LaboratoryDialogController);

    LaboratoryDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Laboratory', 'CountryState'];

    function LaboratoryDialogController ($timeout, $scope, $uibModalInstance, entity, Laboratory, CountryState) {
        var vm = this;

        vm.laboratory = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countryState = CountryState.query();
        vm.hl7Versions = ['v2_3', 'v2_7'];


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.laboratory.id !== null) {
                Laboratory.update(vm.laboratory, onSaveSuccess, onSaveError);
            } else {
                Laboratory.save(vm.laboratory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:laboratoriesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Laboratory', Laboratory);

    Laboratory.$inject = ['$resource'];

    function Laboratory ($resource) {
        var resourceUrl =  'api/laboratories/:id';

        return $resource(resourceUrl, {}, {
            'filter': { url: "api/laboratories/filter", method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllWithoutRequestByFacility': {url: 'api/laboratories/find-all-without-request-by-facility/:id', method: 'GET', isArray: true},
            'findAllWithoutConsent': {url: 'api/laboratories/find-all-without-consent/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SelectLaboratoryDialogController', SelectLaboratoryDialogController);

    SelectLaboratoryDialogController.$inject = ['$uibModalInstance', 'DTOptionsBuilder', 'DTColumnBuilder', '$q',
        '$compile', '$scope', 'CoreService', 'Laboratory', 'GUIUtils'];

    function SelectLaboratoryDialogController($uibModalInstance, DTOptionsBuilder, DTColumnBuilder, $q,
                                              $compile, $scope, CoreService, Laboratory, GUIUtils) {
        var vm = this;

        vm.laboratory = null;
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.checkLaboratory = checkLaboratory;
        vm.selectLaboratory = selectLaboratory;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Laboratory.filter({
                page: 0,
                corporationId: CoreService.getCorporation().id
            }, function (laboratories) {
                vm.laboratories = laboratories;

                defer.resolve(vm.laboratories);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function (data, type, full, meta) {
                return '<input type="radio" name="laboratory" ng-click="vm.checkLaboratory(' + data.id + ')">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Name').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('Active').notSortable().renderWith(function (data, type, full, meta) {
                return GUIUtils.colorHtmlYesNo(data.active);
            }),
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            vm.laboratory = null;

            transition();
        }

        function transition() {
            vm.dtInstance.reloadData();
        }

        function checkLaboratory(id) {
            vm.laboratory = _.find(vm.laboratories, {id: id})
        }

        function selectLaboratory() {
            $uibModalInstance.close(vm.laboratory);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LaboratoryLogoDialogController', LaboratoryLogoDialogController);

    LaboratoryLogoDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity',
        'LaboratoryLogo', 'DataUtils', 'toastr'];

    function LaboratoryLogoDialogController($timeout, $scope, $uibModalInstance, entity,
                                            LaboratoryLogo, DataUtils, toastr) {
        var vm = this;

        vm.laboratory = entity;
        vm.file = {};
        vm.image = null;

        vm.clear = clear;
        vm.save = save;
        vm.handleFileSelect = handleFileSelect;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.laboratory.id !== null && vm.image !== null) {
                LaboratoryLogo.save({
                    laboratoryId: vm.laboratory.id,
                    uuid: vm.image
                }, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            toastr.success("Logo added successfully");
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            toastr.error("Error adding logo");
            vm.isSaving = false;
        }

        function handleFileSelect(evt, file) {
            if (file) {
                DataUtils.toBase64(file, function (base64Data) {
                    $scope.$apply(function () {
                        vm.image = base64Data;
                        vm.file = file;
                    });
                });
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LaboratoryController', LaboratoryController);

    LaboratoryController.$inject = ['GenericEntityDatatableService', 'Laboratory', 'CoreService', '$q', '$uibModal',
        'GUIUtils', 'ConfirmationService'];

    function LaboratoryController(GenericEntityDatatableService, Laboratory, CoreService, $q, $uibModal,
                                  GUIUtils, ConfirmationService) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Laboratories',
            newButtonTitle: 'New Laboratory',
            entityClassHumanized: 'Laboratory',
            entityStateName: 'laboratory',
            service: Laboratory,
            serviceMethod: 'filter',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'nameToPrint',
                    title: 'Name To Print'
                },
                {
                    title: 'Active',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.active);
                    }
                },
                {
                    title: 'is Dev',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.isDev);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.addLogoAction(), {
                    name: "Add Logo",
                    action: function (data) {
                        return addLogoLaboratory(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Laboratory',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/laboratory/update/laboratory-dialog.html',
                controller: 'LaboratoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            address_1: null,
                            address_2: null,
                            zip: null,
                            city: null,
                            signedOrderRequired: false,
                            fax: null,
                            email: null,
                            phone: null,
                            countryState: null,
                            corporation: CoreService.getCorporation(),
                            sftpHost: "sftp.bluebookehr.com",
                            sftpPassword: null,
                            path: 'www/',
                            ordersPath: 'orders/',
                            resultsPath: 'results/',
                            active: true,
                            clia: null,
                            note: null,
                            nameToPrint: null,
                            hl7Version: null,
                            isDev: false
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/laboratory/update/laboratory-dialog.html',
                controller: 'LaboratoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Laboratory', function (Laboratory) {
                        return Laboratory.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Laboratory').result.then(function () {
                    Laboratory.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function addLogoLaboratory(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/laboratory/logo/laboratory-logo-dialog.html',
                    controller: 'LaboratoryLogoDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['Laboratory', function (Laboratory) {
                            return Laboratory.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('laboratory', {
                parent: 'entity',
                url: '/laboratory',
                ncyBreadcrumb: {
                    label: 'Laboratory',
                    parent: 'entity'
                },
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Laboratories'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/laboratory/list/laboratory.html',
                        controller: 'LaboratoryController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabRequisitionSignature', LabRequisitionSignature);

    LabRequisitionSignature.$inject = ['$resource'];

    function LabRequisitionSignature ($resource) {
        var resourceUrl =  'api/lab-requisition-signatures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabRequisitionConsentDialogController', LabRequisitionConsentDialogController);

    LabRequisitionConsentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'LabRequisitionConsent', 'Laboratory', 'CoreService'];

    function LabRequisitionConsentDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                   LabRequisitionConsent, Laboratory, CoreService) {
        var vm = this;

        vm.labRequisitionConsent = entity;
        vm.clear = clear;
        vm.save = save;
        vm.laboratories = vm.labRequisitionConsent.id ?
            [vm.labRequisitionConsent.laboratory] :
            Laboratory.findAllWithoutConsent(CoreService.getFilterByCurrentCorporation());

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.labRequisitionConsent.id !== null) {
                LabRequisitionConsent.update(vm.labRequisitionConsent, onSaveSuccess, onSaveError);
            } else {
                LabRequisitionConsent.save(vm.labRequisitionConsent, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:labRequisitionConsentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabRequisitionConsent', LabRequisitionConsent);

    LabRequisitionConsent.$inject = ['$resource'];

    function LabRequisitionConsent ($resource) {
        var resourceUrl =  'api/lab-requisition-consents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/lab-requisition-consents/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabRequisitionConsentController', LabRequisitionConsentController);

    LabRequisitionConsentController.$inject = ['$scope', '$state', 'LabRequisitionConsent', 'CoreService',
        'GenericEntityDatatableService', '$uibModal', 'ConfirmationService', '$q'];

    function LabRequisitionConsentController($scope, $state, LabRequisitionConsent, CoreService,
                                             GenericEntityDatatableService, $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Lab Requisition Consents',
            newButtonTitle: 'New Lab Requisition Consent',
            entityClassHumanized: 'Lab Requisition Consents',
            entityStateName: 'lab-requisition-consent',
            service: LabRequisitionConsent,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'laboratory',
                    title: 'Laboratory',
                },
                {
                    name: 'consentTitle',
                    title: 'Consent Title',
                },
                {
                    name: 'consent',
                    title: 'Consent',
                },
                {
                    name: 'notice',
                    title: 'Notice',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Consent',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/lab-requisition-consent/update/lab-requisition-consent-dialog.html',
                controller: 'LabRequisitionConsentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            consentTitle: null,
                            consent: null,
                            notice: null,
                            id: null
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/lab-requisition-consent/update/lab-requisition-consent-dialog.html',
                controller: 'LabRequisitionConsentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    entity: ['LabRequisitionConsent', function (LabRequisitionConsent) {
                        return LabRequisitionConsent.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Lab Requisition Consent').result.then(function () {
                    LabRequisitionConsent.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-requisition-consent', {
                parent: 'entity',
                url: '/lab-requisition-consent',
                data: {
                    pageTitle: 'Lab Requisition Consents'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-requisition-consent/list/lab-requisition-consent.html',
                        controller: 'LabRequisitionConsentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-log', {
                parent: 'entity',
                url: '/lab-log',
                data: {
                    authorities: ['ROLE_SYSTEM', 'ROLE_SYSTEM_ADMIN'],
                    pageTitle: 'LabLogs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-log/lab-logs.html',
                        controller: 'LabLogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabLog', LabLog);

    LabLog.$inject = ['$resource'];

    function LabLog ($resource) {
        var resourceUrl =  'api/lab-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabLogController', LabLogController);

    LabLogController.$inject = ['$scope', '$state', 'LabLog', 'CoreService', 'GenericEntityDatatableService',
        '$rootScope'];

    function LabLogController($scope, $state, LabLog, CoreService, GenericEntityDatatableService,
                              $rootScope) {
        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id,
        }

        vm.descriptor = {
            title: 'Lab logs',
            entityClassHumanized: 'Lab logs',
            entityStateName: 'lab-log',
            service: LabLog,
            serviceMethod: 'query',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    title: 'Laboratory',
                    render: function (entity) {
                        return entity.laboratory.name;
                    }
                },
                {
                    title: 'Corporation',
                    name: 'corporation',
                    render: function (entity) {
                        return entity.corporation ? entity.corporation.name : ""
                    }
                },
                {
                    name: 'errorMessage',
                    title: 'Error Message'
                },
                {
                    name: 'createdDate',
                    title: 'Created Date',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
            ],
            filters: [

            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabCompendiumRestrictionDialogController', LabCompendiumRestrictionDialogController);

    LabCompendiumRestrictionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'LabCompendiumRestriction', 'LabCompendium', 'CoreService'];

    function LabCompendiumRestrictionDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                                      entity, LabCompendiumRestriction, LabCompendium, CoreService) {
        var vm = this;

        vm.labCompendiumRestriction = entity;
        vm.facility = CoreService.getCurrentFacility();

        vm.clear = clear;
        vm.save = save;
        vm.getLabCompendium = getLabCompendium;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.labCompendiumRestriction.id !== null) {
                LabCompendiumRestriction.update(vm.labCompendiumRestriction, onSaveSuccess, onSaveError);
            } else {
                LabCompendiumRestriction.save(vm.labCompendiumRestriction, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:labCompendiumRestrictionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getLabCompendium(query) {
            LabCompendium.filter({
                laboratoryId: vm.labCompendiumRestriction.laboratory.id,
                searchQuery: query,
                page: 0,
                size: 40,
                sort: 'code,asc'
            }, function (result) {
                vm.labCompendiums = result;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabCompendiumRestriction', LabCompendiumRestriction);

    LabCompendiumRestriction.$inject = ['$resource'];

    function LabCompendiumRestriction ($resource) {
        var resourceUrl =  'api/lab-compendium-restrictions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/lab-compendium-restrictions/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabCompendiumRestrictionController', LabCompendiumRestrictionController);

    LabCompendiumRestrictionController.$inject = ['$q', 'GUIUtils', 'CoreService', 'LabCompendiumRestriction',
        'GenericEntityDatatableService', 'PopupService', '$uibModal',
        'ConfirmationService']

    function LabCompendiumRestrictionController($q, GUIUtils, CoreService, LabCompendiumRestriction,
                                                GenericEntityDatatableService, PopupService, $uibModal,
                                                ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Lab Compendium Restrictions',
            newAction: false,
            entityClassHumanized: 'Lab Compendium Restrictions',
            entityStateName: 'lab-compendium-restrictions',
            service: LabCompendiumRestriction,
            serviceMethod: 'filter',
            pagination: 'remote',
            params: params,
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'code',
                    title: 'Test Code',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('send-lab-compendium'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New LabCompendium Restriction',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectFacilityLabPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = {id: result.labId, name: result.name};

                                        vm.laboratory = {id: result.labId, name: result.name};
                                        vm.descriptor.title = 'Lab Compendium Restriction - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/lab-compendium-restriction/update/lab-compendium-restriction-dialog.html',
                controller: 'LabCompendiumRestrictionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            facility: CoreService.getCurrentFacility(),
                            laboratory: vm.laboratory
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Lab Compendium Restriction').result.then(function () {
                    LabCompendiumRestriction.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('lab-compendium-restriction', {
                parent: 'entity',
                url: '/lab-compendium-restriction',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM'],
                    pageTitle: 'LabCompendiumRestrictions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-compendium-restriction/list/lab-compendium-restriction.html',
                        controller: 'LabCompendiumRestrictionController',
                        controllerAs: 'vm'
                    }
                },
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabCompendiumCommentController', LabCompendiumCommentController);

    LabCompendiumCommentController.$inject = ['$uibModalInstance', 'entity', 'LabCompendium', 'CoreService', 'Facility',
        'LabCompendiumComment', '$scope'];

    function LabCompendiumCommentController($uibModalInstance, entity, LabCompendium, CoreService, Facility,
                                            LabCompendiumComment, $scope) {
        var vm = this;

        vm.labCompendiumComment = entity;

        Facility.getAll(function (facilities) {
            vm.facilities = facilities;
        });

        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.labCompendiumComment.id !== null) {
                LabCompendiumComment.update(vm.labCompendiumComment, onSaveSuccess, onSaveError);
            } else {
                LabCompendiumComment.save(vm.labCompendiumComment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:labCompendiumCommentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabCompendiumComment', LabCompendiumComment);

    LabCompendiumComment.$inject = ['$resource'];

    function LabCompendiumComment ($resource) {
        var resourceUrl =  'api/lab-compendium-comments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findByLabCompendium': {url: 'api/lab-compendium-comments/by-lab-compendium/:labCompendiumId', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabCompendiumCommentsController', LabCompendiumCommentsController);

    LabCompendiumCommentsController.$inject = ['$compile', '$scope', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter',
        '$uibModalInstance', 'labCompendiumId', 'LabCompendiumComment', '$rootScope', '$uibModal'];

    function LabCompendiumCommentsController($compile, $scope, $q, DTColumnBuilder, DTOptionsBuilder, $filter,
                                             $uibModalInstance, labCompendiumId, LabCompendiumComment, $rootScope, $uibModal) {
        var vm = this;

        vm.labCompendiumComments = [];
        vm.dtInstance = {};

        vm.edit = edit;
        vm.del = del;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            LabCompendiumComment.findByLabCompendium({labCompendiumId: labCompendiumId}, function (result) {
                vm.labCompendiumComments = result;
                defer.resolve(vm.labCompendiumComments);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('ID').renderWith(function (data, type, full) {
                return data ? data.id : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Comment').renderWith(function (data, type, full) {
                return data ? data.comment.substring(0, 75) + "..." : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Facility').renderWith(function (data, type, full) {
                return data ? data.name : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/lab-compendium-comment/update/lab-compendium-comment-dialog.html',
                controller: 'LabCompendiumCommentController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['LabCompendiumComment', function (LabCompendiumComment) {
                        return LabCompendiumComment.get({id: id}).$promise
                    }]
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            });
        }

        function del(id) {
            $uibModal.open({
                templateUrl: 'app/entities/glucose/glucose-delete-dialog.html',
                controller: 'GlucoseDeleteController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['Glucose', function (Glucose) {
                        return Glucose.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabCompendiumDialogController', LabCompendiumDialogController);

    LabCompendiumDialogController.$inject = ['Tube', '$uibModalInstance', 'entity', 'LabCompendium',
        'CompendiumReportGroup', 'Specimen', 'RptMetadata', 'Laboratory'];

    function LabCompendiumDialogController (Tube, $uibModalInstance, entity, LabCompendium,
                                            CompendiumReportGroup, Specimen, RptMetadata, Laboratory) {
        var vm = this;

        vm.rptMetadatas = [];
        vm.tubes = Tube.findAllByLaboratory({laboratoryId: entity.laboratory.id, page: 0, size: 10000});
        vm.labCompendium = entity;
        vm.specimens = Specimen.findAllByLaboratory({laboratoryId: entity.laboratory.id, page: 0, size: 10000});
        vm.laboratories = [entity.laboratory];
        vm.rptMetadatas = RptMetadata.query();
        vm.compendiumReportGroups = CompendiumReportGroup.findAllByLaboratory({laboratoryId: entity.laboratory.id, page: 0, size: 10000});

        vm.save = save;
        vm.clear = clear;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.labCompendium.id !== null) {
                LabCompendium.update(vm.labCompendium, onSaveSuccess, onSaveError);
            } else {
                LabCompendium.save(vm.labCompendium, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabCompendium', LabCompendium);

    LabCompendium.$inject = ['$resource', 'DateUtils'];

    function LabCompendium($resource, DateUtils) {
        var resourceUrl = 'api/lab-compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByBarcode': {url: 'api/lab-compendiums/by-barcode/:barcode', method: 'GET', isArray: true},
            'findAllByPatientOrder': {
                url: 'api/lab-compendiums/by-patient-order/:id/:date', method: 'GET', isArray: true
            },
            'filter': {url: 'api/lab-compendiums/by-laboratory/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LabCompendiumController', LabCompendiumController);

    LabCompendiumController.$inject = ['LabCompendium', '$state', 'DTOptionsBuilder', 'DTColumnBuilder', '$q',
        'GUIUtils', '$filter', '$compile', '$scope', 'Laboratory', 'ConfirmationService',
        '$uibModal', 'CoreService', 'GenericEntityDatatableService', 'PopupService'];

    function LabCompendiumController(LabCompendium, $state, DTOptionsBuilder, DTColumnBuilder, $q,
                                     GUIUtils, $filter, $compile, $scope, Laboratory, ConfirmationService,
                                     $uibModal, CoreService, GenericEntityDatatableService, PopupService) {
        var vm = this;

        vm.laboratory = null;

        vm.descriptor = {
            title: 'Lab Compendiums',
            newAction: false,
            entityClassHumanized: 'Lab Compendiums',
            entityStateName: 'lab-compendium',
            service: LabCompendium,
            serviceMethod: 'filter',
            pagination: 'remote',
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Code',
                    render: function (data) {
                        return data.code ? data.code : "";
                    }
                },
                {
                    title: 'Internal Code',
                    render: function (data) {
                        return data.intCode ? data.intCode : "";
                    }
                },
                {
                    title: 'Description',
                    render: function (data) {
                        return data.description ? data.description : "";
                    }
                },
                {
                    title: 'Abbr',
                    render: function (data) {
                        return data.abbr ? data.abbr : "";
                    }
                },
                {
                    title: 'Units',
                    render: function (data) {
                        return data.units ? data.units : "";
                    }
                },
                {
                    title: 'Cut Off',
                    render: function (data) {
                        return data.cutOff ? data.cutOff : "";
                    }
                },
                {
                    title: 'W Group',
                    render: function (data) {
                        return data.wGroup ? data.wGroup : "";
                    }
                },
                {
                    title: 'Rep Group',
                    render: function (data) {
                        return data.compendiumReportGroup ? data.compendiumReportGroup.name : "";
                    }
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('lab-compendium'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('lab-compendium'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getCommentAction(), {
                    action: function (data) {
                        return comment(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getAddCommentAction(), {
                    name: 'Add Comment',
                    action: function (data) {
                        return addComment(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Lab Compendium',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectLaboratoryPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = result;

                                        vm.laboratory = result;
                                        vm.descriptor.title = 'Lab Compendiums - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-compendium/update/lab-compendium-dialog.html',
                    controller: 'LabCompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                laboratory: vm.laboratory
                            };
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-compendium/update/lab-compendium-dialog.html',
                    controller: 'LabCompendiumDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['LabCompendium', function (LabCompendium) {
                            return LabCompendium.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Lab Compendium').result.then(function () {
                    LabCompendium.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function addComment(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-compendium-comment/update/lab-compendium-comment-dialog.html',
                    controller: 'LabCompendiumCommentController',
                    controllerAs: 'vm',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: {
                            id: null,
                            labCompendium: {id: id},
                            comment: null,
                            facility: null
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function comment(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/lab-compendium-comment/list/lab-compendium-comments.html',
                    controller: 'LabCompendiumCommentsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        labCompendiumId: id
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('lab-compendium', {
                parent: 'entity',
                url: '/lab-compendium',
                data: {
                    authorities: [ROLES.ROLE_USER],
                    pageTitle: 'Lab Compendium'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/lab-compendium/list/lab-compendium.html',
                        controller: 'LabCompendiumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceTypeDialogController', InsuranceTypeDialogController);

    InsuranceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceType', 'Insurance', 'Corporation'];

    function InsuranceTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceType, Insurance, Corporation) {
        var vm = this;

        vm.insuranceType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceType.id !== null) {
                InsuranceType.update(vm.insuranceType, onSaveSuccess, onSaveError);
            } else {
                InsuranceType.save(vm.insuranceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:insuranceTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceType', InsuranceType);

    InsuranceType.$inject = ['$resource'];

    function InsuranceType ($resource) {
        var resourceUrl =  'api/insurance-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': { url: 'api/insurance-types/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceTypeController', InsuranceTypeController);

    InsuranceTypeController.$inject = ['InsuranceType', 'CoreService', 'GenericEntityDatatableService',
        '$q', '$uibModal', 'ConfirmationService'];

    function InsuranceTypeController(InsuranceType, CoreService, GenericEntityDatatableService,
                                     $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()
        var entityStateName = 'insurance-type'

        vm.descriptor = {
            title: 'Insurance Types',
            entityClassHumanized: 'Insurance Types',
            newButtonTitle: 'New Insurance Type',
            entityStateName: entityStateName,
            service: InsuranceType,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-type/update/insurance-type-dialog.html',
                controller: 'InsuranceTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-type/update/insurance-type-dialog.html',
                controller: 'InsuranceTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceType', function (InsuranceType) {
                        return InsuranceType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Type').result.then(function () {
                    InsuranceType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-type', {
                parent: 'entity',
                url: '/insurance-type',
                data: {
                    authorities: [],
                    pageTitle: 'InsuranceTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-type/list/insurance-type.html',
                        controller: 'InsuranceTypeController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Insurance Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceRelationDialogController', InsuranceRelationDialogController);

    InsuranceRelationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceRelation', 'Insurance', 'Corporation'];

    function InsuranceRelationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceRelation, Insurance, Corporation) {
        var vm = this;

        vm.insuranceRelation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceRelation.id !== null) {
                InsuranceRelation.update(vm.insuranceRelation, onSaveSuccess, onSaveError);
            } else {
                InsuranceRelation.save(vm.insuranceRelation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:insuranceRelationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceRelation', InsuranceRelation);

    InsuranceRelation.$inject = ['$resource'];

    function InsuranceRelation ($resource) {
        var resourceUrl =  'api/insurance-relations/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/insurance-relations/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceRelationController', InsuranceRelationController);

    InsuranceRelationController.$inject = ['InsuranceRelation', 'CoreService', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService'];

    function InsuranceRelationController (InsuranceRelation, CoreService, GenericEntityDatatableService, $q,
                                          $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation()

        vm.descriptor = {
            title: 'Insurance Relation',
            entityClassHumanized: 'Insurance Relation',
            entityStateName: 'insurance-relation',
            service: InsuranceRelation,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            newButtonTitle: 'New Insurance Relation',
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Relation',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-relation/update/insurance-relation-dialog.html',
                controller: 'InsuranceRelationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-relation/update/insurance-relation-dialog.html',
                controller: 'InsuranceRelationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceRelation', function (InsuranceRelation) {
                        return InsuranceRelation.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Relation').result.then(function () {
                    InsuranceRelation.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-relation', {
                parent: 'entity',
                url: '/insurance-relation',
                data: {
                    authorities: [],
                    pageTitle: 'Insurance Relations'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-relation/list/insurance-relation.html',
                        controller: 'InsuranceRelationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsurancePicture', InsurancePicture);

    InsurancePicture.$inject = ['$resource'];

    function InsurancePicture ($resource) {
        var resourceUrl =  'api/insurance-pictures/:id';

        return $resource(resourceUrl, {}, {
            'upload': {url: 'api/insurance-pictures/upload', method: 'POST'},
            'getOriginalBase64ByInsurance': {url: 'api/insurance-pictures/get-original-base-64/by-insurance/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        var result = {image: data};
                    }

                    return result;
                }}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceLevelDialogController', InsuranceLevelDialogController);

    InsuranceLevelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceLevel'];

    function InsuranceLevelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceLevel) {
        var vm = this;

        vm.insuranceLevel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceLevel.id !== null) {
                InsuranceLevel.update(vm.insuranceLevel, onSaveSuccess, onSaveError);
            } else {
                InsuranceLevel.save(vm.insuranceLevel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:insuranceLevelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceLevel', InsuranceLevel);

    InsuranceLevel.$inject = ['$resource'];

    function InsuranceLevel ($resource) {
        var resourceUrl =  'api/insurance-levels/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': { url: 'api/insurance-levels/by-corporation/:id', method: 'GET', isArray: true }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceLevelController', InsuranceLevelController);

    InsuranceLevelController.$inject = ['InsuranceLevel', 'CoreService', 'GenericEntityDatatableService', '$q',
        '$uibModal', 'ConfirmationService'];

    function InsuranceLevelController(InsuranceLevel, CoreService, GenericEntityDatatableService, $q,
                                      $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Insurance Level',
            entityClassHumanized: 'Insurance Level',
            entityStateName: 'insurance-level',
            service: InsuranceLevel,
            serviceMethod: 'findAllByCorporation',
            newButtonTitle: 'New Insurance Level',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Level',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-level/update/insurance-level-dialog.html',
                controller: 'InsuranceLevelDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-level/update/insurance-level-dialog.html',
                controller: 'InsuranceLevelDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceLevel', function (InsuranceLevel) {
                        return InsuranceLevel.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Level').result.then(function () {
                    InsuranceLevel.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-level', {
                parent: 'entity',
                url: '/insurance-level',
                data: {
                    authorities: [],
                    pageTitle: 'InsuranceLevels'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-level/list/insurance-level.html',
                        controller: 'InsuranceLevelController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceCarrierDialogController', InsuranceCarrierDialogController);

    InsuranceCarrierDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InsuranceCarrier'];

    function InsuranceCarrierDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InsuranceCarrier) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceCarrier.id !== null) {
                InsuranceCarrier.update(vm.insuranceCarrier, onSaveSuccess, onSaveError);
            } else {
                InsuranceCarrier.save(vm.insuranceCarrier, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:insuranceCarrierUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceCarrierDetailController', InsuranceCarrierDetailController);

    InsuranceCarrierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InsuranceCarrier', 'Insurance'];

    function InsuranceCarrierDetailController($scope, $rootScope, $stateParams, previousState, entity, InsuranceCarrier, Insurance) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:insuranceCarrierUpdate', function(event, result) {
            vm.insuranceCarrier = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceCarrierDeleteController',InsuranceCarrierDeleteController);

    InsuranceCarrierDeleteController.$inject = ['$uibModalInstance', 'entity', 'InsuranceCarrier'];

    function InsuranceCarrierDeleteController($uibModalInstance, entity, InsuranceCarrier) {
        var vm = this;

        vm.insuranceCarrier = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InsuranceCarrier.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('insurance-carrier', {
            parent: 'entity',
            url: '/insurance-carrier',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InsuranceCarriers'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-carrier/insurance-carriers.html',
                    controller: 'InsuranceCarrierController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('insurance-carrier-detail', {
            parent: 'entity',
            url: '/insurance-carrier/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'InsuranceCarrier'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-detail.html',
                    controller: 'InsuranceCarrierDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'InsuranceCarrier', function($stateParams, InsuranceCarrier) {
                    return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'insurance-carrier',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('insurance-carrier-detail.edit', {
            parent: 'insurance-carrier-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-dialog.html',
                    controller: 'InsuranceCarrierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceCarrier', function(InsuranceCarrier) {
                            return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-carrier.new', {
            parent: 'insurance-carrier',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-dialog.html',
                    controller: 'InsuranceCarrierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                acctno: null,
                                name: null,
                                address: null,
                                address2: null,
                                city: null,
                                state: null,
                                zip: null,
                                phone: null,
                                iType: null,
                                etin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('insurance-carrier', null, { reload: 'insurance-carrier' });
                }, function() {
                    $state.go('insurance-carrier');
                });
            }]
        })
        .state('insurance-carrier.edit', {
            parent: 'insurance-carrier',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-dialog.html',
                    controller: 'InsuranceCarrierDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InsuranceCarrier', function(InsuranceCarrier) {
                            return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-carrier', null, { reload: 'insurance-carrier' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('insurance-carrier.delete', {
            parent: 'insurance-carrier',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance-carrier/insurance-carrier-delete-dialog.html',
                    controller: 'InsuranceCarrierDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InsuranceCarrier', function(InsuranceCarrier) {
                            return InsuranceCarrier.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('insurance-carrier', null, { reload: 'insurance-carrier' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceCarrier', InsuranceCarrier);

    InsuranceCarrier.$inject = ['$resource'];

    function InsuranceCarrier ($resource) {
        var resourceUrl =  'api/insurance-carriers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('InsuranceCarrierSearch', InsuranceCarrierSearch);

    InsuranceCarrierSearch.$inject = ['$resource'];

    function InsuranceCarrierSearch($resource) {
        var resourceUrl =  'api/_search/insurance-carriers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceCarrierController', InsuranceCarrierController);

    InsuranceCarrierController.$inject = ['$scope', '$state', 'InsuranceCarrier', 'InsuranceCarrierSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', '$compile'];

    function InsuranceCarrierController ($scope, $state, InsuranceCarrier, InsuranceCarrierSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, $compile ) {
        var vm = this;
        vm.title = 'Insurance Carriers';
        vm.insuranceCarriers = [];
        vm.search = search;
        vm.loadAll = loadAll;
        vm.dtInstance = {};


        loadAll();

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                  InsuranceCarrier.query(function(result) {
                  vm.insuranceCarriers = result;
                  defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.insuranceCarriers, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip')/*.withOption('scrollX', '100%')*/
        .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
        $compile(nRow)($scope);
        });

        vm.dtColumns = [
              DTColumnBuilder.newColumn('acctno').withTitle('Acctno'),
              DTColumnBuilder.newColumn('name').withTitle('Name'),
              DTColumnBuilder.newColumn('address').withTitle('Address'),
              DTColumnBuilder.newColumn('address2').withTitle('Address2'),
              DTColumnBuilder.newColumn('city').withTitle('City'),
              //DTColumnBuilder.newColumn('state').withTitle('State'),
              //DTColumnBuilder.newColumn('zip').withTitle('Zip'),
              //DTColumnBuilder.newColumn('phone').withTitle('Phone'),
              //DTColumnBuilder.newColumn('iType').withTitle('IType'),
              //DTColumnBuilder.newColumn('etin').withTitle('Etin'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                           .renderWith(actionsHtml)
        ];

        function loadAll() {
            InsuranceCarrier.query(function(result) {
                vm.insuranceCarriers = result;
                vm.searchQuery = null;
            });
        }

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
        vm.dtInstance.reloadData();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceBillingConfigDialogController', InsuranceBillingConfigDialogController);

    InsuranceBillingConfigDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity',
        'InsuranceBillingConfig', 'InsuranceCarrierSearch', 'TypeLevelCare',
        'CoreService'];

    function InsuranceBillingConfigDialogController ($timeout, $scope, $uibModalInstance, entity,
                                                     InsuranceBillingConfig, InsuranceCarrierSearch, TypeLevelCare,
                                                     CoreService) {
        var vm = this;

        vm.insuranceBillingConfig = entity;
        vm.facility = CoreService.getCurrentFacility();
        vm.typelevelcares = TypeLevelCare.findAllByFacility(
            CoreService.getFilterByFacility(CoreService.getCurrentFacility()));

        vm.getInsuranceCarriers = getInsuranceCarriers
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.insuranceBillingConfig.id !== null) {
                InsuranceBillingConfig.update(vm.insuranceBillingConfig, onSaveSuccess, onSaveError);
            } else {
                InsuranceBillingConfig.save(vm.insuranceBillingConfig, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:insuranceBillingConfigUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getInsuranceCarriers(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);

                vm.insuranceCarriers = InsuranceCarrierSearch.query({
                    query: query
                });
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceBillingConfig', InsuranceBillingConfig);

    InsuranceBillingConfig.$inject = ['$resource'];

    function InsuranceBillingConfig($resource) {
        var resourceUrl = 'api/insurance-billing-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'byFacility': {method: 'GET', url: 'api/insurance-billing-configs/by-facility'},
            'filter': {url:'api/insurance-billing-configs/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceBillingConfigController', InsuranceBillingConfigController);

    InsuranceBillingConfigController.$inject = ['InsuranceBillingConfig', 'CoreService', 'GenericEntityDatatableService',
        '$q', '$uibModal', 'ConfirmationService'];

    function InsuranceBillingConfigController(InsuranceBillingConfig, CoreService, GenericEntityDatatableService,
                                              $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'insurance-billing-config'

        vm.descriptor = {
            title: 'Insurance Audit Config',
            entityClassHumanized: 'Insurance Audit Config',
            entityStateName: entityStateName,
            service: InsuranceBillingConfig,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            newButtonTitle: 'New Insurance Audit Config',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'hours',
                    title: 'Hours'
                },
                {
                    title: 'Insurances',
                    render: function (data) {
                        var row = "";

                        _.forEach(data.insuranceCarriers, function (carrier) {
                            row += row.length === 0 ? carrier.name : ", " + carrier.name;
                        });

                        return row;
                    }
                },
                {
                    title: 'LOC',
                    render: function (data) {
                        var row = "";

                        _.forEach(data.typeLevelCares, function (level) {
                            row += row.length === 0 ? level.name : ", " + level.name;
                        });

                        return row;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Insurance Audit Config',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-billing-config/update/insurance-billing-config-dialog.html',
                controller: 'InsuranceBillingConfigDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            hours: null,
                            frequency: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-billing-config/update/insurance-billing-config-dialog.html',
                controller: 'InsuranceBillingConfigDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceBillingConfig', function (InsuranceBillingConfig) {
                        return InsuranceBillingConfig.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Insurance Audit Config').result.then(function () {
                    InsuranceBillingConfig.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('insurance-billing-config', {
                parent: 'entity',
                url: '/insurance-billing-config',
                data: {
                    authorities: [],
                    pageTitle: 'InsuranceBillingConfigs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/insurance-billing-config/list/insurance-billing-config.html',
                        controller: 'InsuranceBillingConfigController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG, access);
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InsuranceBackPicture', InsuranceBackPicture);

    InsuranceBackPicture.$inject = ['$resource'];

    function InsuranceBackPicture ($resource) {
        var resourceUrl =  'api/insurance-back-pictures/:id';

        return $resource(resourceUrl, {}, {
            'upload': {url: 'api/insurance-back-pictures/upload', method: 'POST'},
            'getOriginalBase64ByInsurance': {url: 'api/insurance-back-pictures/get-original-base-64/by-insurance/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        var result = {image: data};
                    }

                    return result;
                }}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceDialogController', InsuranceDialogController);

    InsuranceDialogController.$inject = ['InsuranceCarrier', 'InsuranceType', 'InsuranceLevel', 'InsuranceRelation', 'chart',
        'CountryState', 'InsuranceCarrierSearch', '$uibModalInstance', 'entity', 'Insurance', 'DataUtils', 'fancyboxService', '$state', 'GUIUtils', 'CoreService'];

    function InsuranceDialogController(InsuranceCarrier, InsuranceType, InsuranceLevel, InsuranceRelation, chart,
                                       CountryState, InsuranceCarrierSearch, $uibModalInstance, entity, Insurance, DataUtils, fancyboxService, $state, GUIUtils, CoreService) {
        var vm = this;

        vm.insurance = entity;
        vm.chart = chart;
        vm.patient = vm.chart.patient;
        vm.gender = GUIUtils.getGender();
        vm.showDelete = false;
        //Functions
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.getInsuranceCarrier = getInsuranceCarrier;
        vm.openInsuranceCalendar = openInsuranceCalendar;
        vm.carrierTagTransform = carrierTagTransform;
        vm.confirmDelete = confirmDelete;

        //Variables
        vm.insuranceCarriers = [];
        vm.insuranceTypes = InsuranceType.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.insuranceLevels = InsuranceLevel.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.insuranceRelations = InsuranceRelation.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.datePickerOpenStatus = {};
        vm.carriers = [];
        vm.form = {};
        vm.states = CountryState.query();
        vm.currentState = $state.current.name;
        vm.datePickerOpenStatus = {};

        vm.datePickerOpenStatus.insuranceDob = [false, false];

        function openInsuranceCalendar(index) {
            vm.datePickerOpenStatus.insuranceDob[index] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.insurance.chart = chart;

            if (vm.insurance.id !== null) {
                Insurance.update(vm.insurance, onSaveSuccess, onSaveError);
            } else {
                Insurance.save(vm.insurance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getInsuranceCarrier(query) {
            if (query) {
                if (query.length > 2) {
                    InsuranceCarrierSearch.query({
                        query: query
                    }, function (result) {
                        if (result.length == 0) {
                            vm.carriers = [carrierTagTransform(query)];
                        } else {
                            vm.carriers = result;
                        }
                    });
                }
            }
        }

        function carrierTagTransform(newTag) {
            return {
                id: null,
                acctno: newTag,
                name: newTag
            };
        }

        function confirmDelete() {
            Insurance.delete({id: vm.insurance.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Insurance', Insurance);

    Insurance.$inject = ['$resource', 'DateUtils'];

    function Insurance($resource, DateUtils) {
        var resourceUrl = 'api/insurances/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'findAllByChart': {
                url: 'api/insurances/by-chart/:id', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    var copy = angular.fromJson(data);

                    if (copy && copy.length > 0) {
                        copy.forEach(function (insurance) {
                            insurance.frontPicture = insurance.frontPicture ? insurance.frontPicture : {};
                            insurance.frontPictureOriginal = insurance.frontPictureOriginal ? insurance.frontPictureOriginal : {};
                            insurance.backPicture = insurance.backPicture ? insurance.backPicture : {};
                            insurance.backPictureOriginal = insurance.backPictureOriginal ? insurance.backPictureOriginal : {};
                        });
                    }

                    return copy;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InsuranceController', InsuranceController);

    InsuranceController.$inject = ['chart', 'Insurance', 'CoreService', '$uibModal', '$state',
        'InsurancePicture', 'InsuranceBackPicture', 'PopupService', 'access', 'ACTIONS', 'Auth'];

    function InsuranceController(chart, Insurance, CoreService, $uibModal, $state,
                                 InsurancePicture, InsuranceBackPicture, PopupService, access, ACTIONS, Auth) {
        var vm = this;

        vm.chart = chart;
        vm.genericCardImageBack = CoreService.insuranceBackPictureDefault();

        vm.primary = null;
        vm.secondary = null;

        vm.add = add;
        vm.edit = edit;
        vm.toggleItem = toggleItem;
        vm.editFrontImageInsurance = editFrontImageInsurance;
        vm.editBackImageInsurance = editBackImageInsurance;

        function toggleItem() {
            CoreService.togglePanel('insurance');
        }

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_INSURANCE_VIEW, access)) {
                return;
            }

            vm.primary = chart.primary ? Insurance.get({id: chart.primary.id}) : null;
            vm.secondary = chart.secondary ? Insurance.get({id: chart.secondary.id}) : null;
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/insurance/update/insurance-dialog.html',
                controller: 'InsuranceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'xl',
                resolve: {
                    entity: function () {
                        return {
                            address: null,
                            address2: null,
                            zipCode: null,
                            city: null,
                            policyNumber: null,
                            groupNumber: null,
                            groupName: null,
                            planNumber: null,
                            lastName: null,
                            firstName: null,
                            middleInitial: null,
                            dob: null,
                            gender: null,
                            phone: null,
                            employer: null,
                            insuranceOrder: 1,
                            id: null,
                            chart: chart
                        };
                    },
                    chart: chart
                }
            }).result.then(function () {
                CoreService.showPanel('cReviews');
                $state.reload();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/insurance/update/insurance-dialog.html',
                controller: 'InsuranceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'xl',
                resolve: {
                    entity: ['Insurance', function (Insurance) {
                        return Insurance.get({id: id}).$promise;
                    }],
                    chart: chart
                }
            }).result.then(function () {
                $state.reload();
            }, function () {
            });
        }

        function editFrontImageInsurance(id) {
            InsurancePicture.getOriginalBase64ByInsurance({id: id}, function (result) {
                openCropFrontImageInsurancePopup(result, id);
            }, function () {
                openCropFrontImageInsurancePopup(null, id);
            });
        }

        function editBackImageInsurance(id) {
            InsuranceBackPicture.getOriginalBase64ByInsurance({id: id}, function (result) {
                openCropBackImageInsurancePopup(result, id);
            }, function () {
                openCropBackImageInsurancePopup(null, id);
            });
        }

        function openCropFrontImageInsurancePopup(result, id) {
            PopupService.showCropImageFrontInsurancePopup(result).result.then(function (error) {
            }, function (data) {
                if (data) {
                    InsurancePicture.upload({
                        insuranceId: id,
                        cropped: data.cropped,
                        image: data.image
                    }, function () {
                        $state.reload();
                    });
                }
            });
        }

        function openCropBackImageInsurancePopup(result, id) {
            PopupService.showCropImageBackInsurancePopup(result).result.then(function (error) {
            }, function (data) {
                if (data) {
                    InsuranceBackPicture.upload({
                        insuranceId: id,
                        cropped: data.cropped,
                        image: data.image
                    }, function () {
                        $state.reload();
                    });
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InstClaimConfDialogController', InstClaimConfDialogController);

    InstClaimConfDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'InstClaimConf', 'InsuranceCarrierSearch', 'TypeLevelCare',
        'Facility', 'CoreService', 'CptSearch',
        'ModifierSearch', 'RevCodeSearch'];

    function InstClaimConfDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                           entity, InstClaimConf, InsuranceCarrierSearch, TypeLevelCare,
                                           Facility, CoreService, CptSearch,
                                           ModifierSearch, RevCodeSearch) {
        var vm = this;

        vm.instClaimConfs = [entity];
        vm.facility = CoreService.getCurrentFacility();
        vm.typelevelcares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.insuranceCarriers = entity && entity.insuranceCarriers ? angular.copy(entity.insuranceCarriers) : [];
        vm.revCodes = [];
        vm.cpts = [];

        vm.save = save;
        vm.addConf = addConf;
        vm.clear = clear;
        vm.deleteInstClaimConf = deleteInstClaimConf;
        vm.deleteInstCptConf = deleteInstCptConf;
        vm.getInsuranceCarriers = getInsuranceCarriers;
        vm.addCpt = addCpt;
        vm.getCpts = getCpts;
        vm.getModifiers = getModifiers;
        vm.getRevCodes = getRevCodes;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.instClaimConfs.length == 1 && vm.instClaimConfs[0].id !== null) {
                InstClaimConf.update(vm.instClaimConfs[0], onSaveSuccess, onSaveError);
            } else {
                addNewInstClaimConf();
            }
        }

        function addNewInstClaimConf() {
            var instClaimConfUploadProj = {
                instClaimConfs: [],
                facilityId: vm.facility.id
            };

            _.forEach(vm.instClaimConfs, function (instClaimConf, index) {
                var instClaimConf = angular.copy(instClaimConf);

                var icc = {
                    xorder: index,
                    minTime: instClaimConf.minTime,
                    maxTime: instClaimConf.maxTime,
                    isDefault: instClaimConf.isDefault,
                    insuranceCarriers: instClaimConf.insuranceCarriers,
                    instCptConfs: instClaimConf.instCptConfs,
                    levelOfCares: instClaimConf.levelOfCares
                };

                instClaimConfUploadProj.instClaimConfs.push(icc);
            });

            InstClaimConf.save(instClaimConfUploadProj, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function addConf() {
            vm.insuranceCarriers = null;
            vm.instClaimConfs.push({
                collapsed: false,
                facility: vm.facility,
                isDefault: false,
                instCptConfs: [{}]
            })
        }

        function addCpt(instClaimConf) {
            instClaimConf.instCptConfs.push({});
        }

        function deleteInstClaimConf(index) {
            vm.instClaimConfs.splice(index, 1);
        }

        function deleteInstCptConf(instClaimConf, index) {
            instClaimConf.instCptConfs.splice(index, 1);
        }

        function getInsuranceCarriers(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);

                vm.insuranceCarriers = InsuranceCarrierSearch.query({
                    query: query
                });
            }
        }

        function getCpts(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.cpts = CptSearch.query({query: query});
            }
        }

        function getRevCodes(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.revCodes = RevCodeSearch.query({page: 0, query: query});
            }
        }

        function getModifiers(query) {
            if (query && query.length > 0) {
                query = _.lowerCase(query);

                vm.modifiers = ModifierSearch.query({query: query});
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InstClaimConfDeleteController',InstClaimConfDeleteController);

    InstClaimConfDeleteController.$inject = ['$uibModalInstance', 'entity', 'InstClaimConf'];

    function InstClaimConfDeleteController($uibModalInstance, entity, InstClaimConf) {
        var vm = this;

        vm.instClaimConf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InstClaimConf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('inst-claim-conf', {
                parent: 'entity',
                url: '/inst-claim-conf',
                data: {
                    authorities: [],
                    pageTitle: 'InstClaimConfs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/inst-claim-conf/inst-claim-confs.html',
                        controller: 'InstClaimConfController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access);
                }]
            })
            .state('inst-claim-conf.new', {
                parent: 'inst-claim-conf',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/inst-claim-conf/inst-claim-conf-dialog.html',
                            controller: 'InstClaimConfDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    var facility = CoreService.getCurrentFacility();

                                    return {
                                        minTime: null,
                                        maxTime: null,
                                        isDefault: false,
                                        rate: null,
                                        quantity: null,
                                        unit: null,
                                        id: null,
                                        facility: facility,
                                        instCptConfs: [{}]
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('inst-claim-conf', null, {reload: 'inst-claim-conf'});
                        }, function () {
                            $state.go('inst-claim-conf');
                        });
                    }
                }]
            })
            .state('inst-claim-conf.edit', {
                parent: 'inst-claim-conf',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/inst-claim-conf/inst-claim-conf-dialog.html',
                            controller: 'InstClaimConfDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['InstClaimConf', function (InstClaimConf) {
                                    return InstClaimConf.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('inst-claim-conf', null, {reload: 'inst-claim-conf'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('inst-claim-conf.delete', {
                parent: 'inst-claim-conf',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/inst-claim-conf/inst-claim-conf-delete-dialog.html',
                            controller: 'InstClaimConfDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['InstClaimConf', function (InstClaimConf) {
                                    return InstClaimConf.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('inst-claim-conf', null, {reload: 'inst-claim-conf'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InstClaimConf', InstClaimConf);

    InstClaimConf.$inject = ['$resource'];

    function InstClaimConf ($resource) {
        var resourceUrl =  'api/inst-claim-confs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT'},
            'filter': {url: 'api/inst-claim-confs/filter', method: 'GET', isArray: true},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InstClaimConfController', InstClaimConfController);

    InstClaimConfController.$inject = ['GenericEntityDatatableService', 'CoreService', 'InstClaimConf', 'GUIUtils'];

    function InstClaimConfController (GenericEntityDatatableService, CoreService, InstClaimConf, GUIUtils) {
        var vm = this;

        var params = { facilityId: CoreService.getCurrentFacility().id };

        vm.descriptor = {
            title: 'Inst Claim Conf',
            newButtonTitle: 'New Inst Claim Conf',
            entityClassHumanized: 'Inst Claim Conf',
            entityStateName: 'inst-claim-conf',
            service: InstClaimConf,
            serviceMethod: 'filter',
            params: params,
            pagination: 'remote',
            columns: [
                {
                    name: null,
                    title: 'Insurances',
                    render: function (data, type, full) {
                        var row = "";

                        _.forEach(full.insuranceCarriers, function(carrier) {
                            row += row.length === 0 ? carrier.name : ", " + carrier.name;
                        });

                        return row;
                    }
                },
                {
                    name: null,
                    title: 'Level Of Care',
                    render: function (data, type, full) {
                        var row = "";

                        _.forEach(full.levelOfCares, function(level) {
                            row += row.length === 0 ? level.name : ", " + level.name;
                        });

                        return row;
                    }
                },
                {
                    name: 'minTime',
                    title: 'Min Time',
                },
                {
                    name: 'maxTime',
                    title: 'Max Time',
                },
                {
                    name: null,
                    title: 'Default',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.isDefault);
                    }
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('inst-claim-conf'),
                GenericEntityDatatableService.getDeleteAction('inst-claim-conf')
            ],
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InitValueDialogController', InitValueDialogController);

    InitValueDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InitValue'];

    function InitValueDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InitValue) {
        var vm = this;

        vm.initValue = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.initValue.id !== null) {
                InitValue.update(vm.initValue, onSaveSuccess, onSaveError);
            } else {
                InitValue.save(vm.initValue, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:initValueUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('InitValue', InitValue);

    InitValue.$inject = ['$resource'];

    function InitValue ($resource) {
        var resourceUrl =  'api/init-values/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFilter': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'loadEntitiesByType': { method: 'GET', url: 'api/init-values/entities-by-type', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('InitValueController', InitValueController);

    InitValueController.$inject = ['InitValue','$q', 'GUIUtils', '$uibModal', 'GenericEntityDatatableService',
        'ConfirmationService'];

    function InitValueController(InitValue,  $q, GUIUtils, $uibModal, GenericEntityDatatableService,
                                 ConfirmationService) {
        var vm = this;

        vm.type = 'CORPORATION';

        vm.descriptor = {
            title: 'Init Values',
            newButtonTitle: "New Init Value",
            entityClassHumanized: 'Init Values',
            entityStateName: 'init-value',
            service: InitValue,
            serviceMethod: 'findAllByFilter',
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'entity',
                    title: 'Entity'
                },
                {
                    name: 'type',
                    title: 'Type',
                },
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'Corporation',
                            ngClass: function (filter) {
                                return filter.type === 'CORPORATION'?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.type = 'CORPORATION';
                                filter.entity = null;
                            }
                        },
                        {
                            name: 'Facility',
                            ngClass: function (filter) {
                                return filter.type === 'FACILITY' ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.type = 'FACILITY';
                                filter.entity = null;
                            }
                        }
                    ],
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Init Value',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'type',
                    defaultValue: function () {
                        return 'CORPORATION';
                    },
                    visible: false
                },
                {
                    name: 'entity',
                    values: InitValue.loadEntitiesByType({type: 'CORPORATION'}),
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    getValue: function (entity) {
                        return entity;
                    },
                    placeholder: 'Entity...',
                    type: 'select',
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
            ],
            filterCallback: function (filter) {
                vm.entity = filter.entity;
                vm.type = filter.type;
                vm.descriptor.filters[1].values = InitValue.loadEntitiesByType({type: filter.type});
            }
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/init-value/update/init-value-dialog.html',
                controller: 'InitValueDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            entity: vm.entity,
                            type: vm.type,
                            id: null
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/init-value/update/init-value-dialog.html',
                controller: 'InitValueDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['InitValue', function (InitValue) {
                        return InitValue.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('InitValue').result.then(function () {
                    InitValue.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('init-value', {
                parent: 'entity',
                url: '/init-value',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Init Values'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/init-value/list/init-value.html',
                        controller: 'InitValueController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentTypeDialogController', IncidentTypeDialogController);

    IncidentTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncidentType', 'CoreService'];

    function IncidentTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncidentType, CoreService) {
        var vm = this;

        vm.incidentType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incidentType.id !== null) {
                IncidentType.update(vm.incidentType, onSaveSuccess, onSaveError);
            } else {
                IncidentType.save(vm.incidentType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:incidentTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentType', IncidentType);

    IncidentType.$inject = ['$resource'];

    function IncidentType ($resource) {
        var resourceUrl =  'api/incident-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/incident-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentTypeController', IncidentTypeController);

    IncidentTypeController.$inject = ['GenericEntityDatatableService', 'CoreService', 'IncidentType', '$q', '$uibModal',
        'ConfirmationService'];

    function IncidentTypeController(GenericEntityDatatableService, CoreService, IncidentType, $q, $uibModal,
                                    ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Incident Type',
            newButtonTitle: 'New Incident Type',
            entityClassHumanized: 'Incident Types',
            entityStateName: 'incident-type',
            service: IncidentType,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Incident Type',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-type/update/incident-type-dialog.html',
                controller: 'IncidentTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-type/update/incident-type-dialog.html',
                controller: 'IncidentTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['IncidentType', function (IncidentType) {
                        return IncidentType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Incident Type').result.then(function () {
                    IncidentType.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('incident-type', {
                parent: 'entity',
                url: '/incident-type',
                data: {
                    authorities: [],
                    pageTitle: 'IncidentTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-type/list/incident-type.html',
                        controller: 'IncidentTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentSeverityDialogController', IncidentSeverityDialogController);

    IncidentSeverityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncidentSeverity', 'Corporation'];

    function IncidentSeverityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncidentSeverity, Corporation) {
        var vm = this;

        vm.incidentSeverity = entity;
        vm.clear = clear;
        vm.save = save;
        vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incidentSeverity.id !== null) {
                IncidentSeverity.update(vm.incidentSeverity, onSaveSuccess, onSaveError);
            } else {
                IncidentSeverity.save(vm.incidentSeverity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:incidentSeverityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentSeverity', IncidentSeverity);

    IncidentSeverity.$inject = ['$resource'];

    function IncidentSeverity ($resource) {
        var resourceUrl =  'api/incident-severities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/incident-severities/by-corporation/:id', method: 'GET', isArray: true}

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentSeverityController', IncidentSeverityController);

    IncidentSeverityController.$inject = ['GenericEntityDatatableService', 'CoreService', 'IncidentSeverity',
        '$q', '$uibModal', 'ConfirmationService'];

    function IncidentSeverityController(GenericEntityDatatableService, CoreService, IncidentSeverity,
                                        $q, $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Incident Severity',
            newButtonTitle: 'New Incident Severity',
            entityClassHumanized: 'Incident Severity',
            entityStateName: 'incident-severity',
            service: IncidentSeverity,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Incident Severity',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-severity/update/incident-severity-dialog.html',
                controller: 'IncidentSeverityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/insurance-type/insurance-type-dialog.html',
                controller: 'InsuranceTypeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['InsuranceType', function (InsuranceType) {
                        return InsuranceType.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Incident Severity').result.then(function () {
                    IncidentSeverity.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incident-severity', {
            parent: 'entity',
            url: '/incident-severity',
            data: {
                authorities: [],
                pageTitle: 'IncidentSeverities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incident-severity/list/incident-severity.html',
                    controller: 'IncidentSeverityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY, access);
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportNoteTemplateEditController', IncidentReportNoteTemplateEditController);

    IncidentReportNoteTemplateEditController.$inject = ['entity', '$rootScope', 'OdsFormService',
        'IncidentReportNoteTemplate', '$state', 'IncidentType', 'CoreService'];

    function IncidentReportNoteTemplateEditController(entity, $rootScope, OdsFormService,
                                                      IncidentReportNoteTemplate, $state, IncidentType, CoreService) {
        var vm = this;

        vm.incidentReportTemplate = entity;
        vm.title = 'Incident Report Note Template';
        vm.form = {};

        //init schema if null
        vm.incidentReportTemplate.jsonTemplate = !vm.incidentReportTemplate.jsonTemplate ?
            OdsFormService.newSchema() : vm.incidentReportTemplate.jsonTemplate;

        //Show debug var if it's running in development profile.
        vm.debugMode = !$rootScope.inProduction ? true : false;

        vm.incidentTypes = IncidentType.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

        vm.save = save;
        vm.updateTitle = updateTitle;

        function save() {
            if (vm.incidentReportTemplate.id)
                IncidentReportNoteTemplate.update(vm.incidentReportTemplate, onSaveSuccess, onSaveError);
            else
                IncidentReportNoteTemplate.save(vm.incidentReportTemplate, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            $state.go('incident-report-note-template', {}, {reload: true}); //second parameter is for $stateParams
        }

        function onSaveError(error) {
        }

        function updateTitle() {
            vm.incidentReportTemplate.jsonTemplate.label = angular.copy(vm.incidentReportTemplate.name);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentReportNoteTemplate', IncidentReportNoteTemplate);

    IncidentReportNoteTemplate.$inject = ['$resource'];

    function IncidentReportNoteTemplate ($resource) {
        var resourceUrl =  'api/incident-report-note-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].jsonTemplate = angular.fromJson(data[i].jsonTemplate);
                        }
                    }

                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.jsonTemplate = angular.fromJson(data.jsonTemplate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'getAllByFacility': {url: 'api/incident-report-note-templates/facility/:id', method: 'GET', isArray: true},
            'clone': {url: 'api/incident-report-note-templates/clone/:id', method: 'GET'},
            'findAllByFilter': {url: 'api/incident-report-note-templates/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportNoteTemplateController', IncidentReportNoteTemplateController);

    IncidentReportNoteTemplateController.$inject = ['GenericEntityDatatableService', 'CoreService',
        'IncidentReportNoteTemplate', 'GUIUtils', '$uibModal', '$q',
        'ConfirmationService'];

    function IncidentReportNoteTemplateController(GenericEntityDatatableService, CoreService,
                                                  IncidentReportNoteTemplate, GUIUtils, $uibModal, $q,
                                                  ConfirmationService) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Incident Report Note Templates',
            newButtonTitle: 'New Incident Report Note Templates',
            entityClassHumanized: 'Incident Report Note Templates',
            entityStateName: 'incident-report-note-template',
            service: IncidentReportNoteTemplate,
            serviceMethod: 'getAllByFacility',
            params: params,
            pagination: 'remote',
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enabled);
                    }
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('incident-report-note-template'),
                angular.extend({}, GenericEntityDatatableService.getCloneAction(), {
                    action: function (data) {
                        return clone(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
        }

        function clone(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-report-note-template/clone/incident-report-note-template-clone-dialog.html',
                controller: 'IncidentReportNoteTemplateCloneController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['IncidentReportNoteTemplate', function (IncidentReportNoteTemplate) {
                        return IncidentReportNoteTemplate.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Note Template').result.then(function () {
                    IncidentReportNoteTemplate.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('incident-report-note-template', {
                parent: 'entity',
                url: '/incident-report-note-template',
                data: {
                    authorities: [ROLES.ROLE_USER],
                    pageTitle: 'IncidentReportNoteTemplates'
                },
                ncyBreadcrumb: {
                    label: 'Incident Report Note Templates',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report-note-template/list/incident-report-note-template.html',
                        controller: 'IncidentReportNoteTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('incident-report-note-template.new', {
                parent: 'incident-report-note-template',
                url: '/new',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report-note-template/update/incident-report-note-template-edit.html',
                        controller: 'IncidentReportNoteTemplateEditController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'New Incident Report Note Template',
                    parent: 'incident-report-note-template'
                },
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            name: null,
                            enabled: true,
                            jsonTemplate: null,
                            id: null,
                            incidentTypes: []
                        };
                    }]
                }
            })
            .state('incident-report-note-template.edit', {
                parent: 'incident-report-note-template',
                url: '/{id}/edit',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                ncyBreadcrumb: {
                    label: 'Edit Incident Report Note Template',
                    parent: 'incident-report-note-template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report-note-template/update/incident-report-note-template-edit.html',
                        controller: 'IncidentReportNoteTemplateEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['IncidentReportNoteTemplate', '$stateParams', function (IncidentReportNoteTemplate, $stateParams) {
                        return IncidentReportNoteTemplate.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportNoteTemplateCloneController',IncidentReportNoteTemplateCloneController);

    IncidentReportNoteTemplateCloneController.$inject = ['$uibModalInstance', 'entity', 'IncidentReportNoteTemplate'];

    function IncidentReportNoteTemplateCloneController($uibModalInstance, entity, IncidentReportNoteTemplate) {
        var vm = this;

        vm.incidentReportTemplate = entity;
        vm.clear = clear;
        vm.confirmClone = confirmClone;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmClone (id) {
            IncidentReportNoteTemplate.clone({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportNoteTemplateAssignDialogController', IncidentReportNoteTemplateAssignDialogController);

    IncidentReportNoteTemplateAssignDialogController.$inject = ['$timeout', '$uibModalInstance', 'toastr',
        'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$compile',
        '$scope', 'IncidentReportNoteTemplate', 'CoreService',
        'IncidentReportNote', 'IncidentReport', 'DataTablesService',
        'incidentReport'];

    function IncidentReportNoteTemplateAssignDialogController($timeout, $uibModalInstance, toastr,
                                                              DTOptionsBuilder, DTColumnBuilder, $q, $filter, $compile,
                                                              $scope, IncidentReportNoteTemplate, CoreService,
                                                              IncidentReportNote, IncidentReport, DataTablesService,
                                                              incidentReport) {

        var vm = this;

        vm.incidentReport = incidentReport;
        vm.assign = [];
        vm.dtInstance = {};
        vm.reload = false;
        vm.selected = {};
        vm.selectAll = false;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.assign = assign;
        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            IncidentReportNoteTemplate.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.incidentReportNoteTemplates = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withDOM('t').withDisplayLength(vm.itemsPerPage).withOption('order', [1, 'asc'])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Template Name')
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function assign() {
            IncidentReportNote.create({
                incidentReport: vm.incidentReport,
                incidentReportNotes: _.map(DataTablesService.getSelectedIds(vm.selected), function (id) {
                    return parseInt(id)
                })
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess() {
            $uibModalInstance.close();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function search() {
            vm.page = 1;

            transition();
        }

        function getFilter() {
            return {
                page: vm.page - 1,
                size: vm.itemsPerPage,
                incidentTypes: _.map(vm.incidentReport.incidentTypes, 'id'),
                enabled: true,
                facilityId: vm.incidentReport.facility.id,
                searchQuery: vm.searchQuery
            }
        }

        function transition() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportNoteDialogController', IncidentReportNoteDialogController);

    IncidentReportNoteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'IncidentReportNote', 'toastr', 'jsonTemplate'];

    function IncidentReportNoteDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                IncidentReportNote, toastr, jsonTemplate) {
        var vm = this;

        vm.incidentReportNote = entity;
        // vm.originalTemplate = angular.copy(vm.incidentReportNote.jsonTemplate);
        vm.jsonTemplate = jsonTemplate;
        vm.intervalId = null;

        vm.clear = clear;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        init();

        function init() {
            $timeout(function () {
                vm.watcher = $scope.$watch('vm.jsonTemplate', function (newValue, oldValue, scope) {
                    if (oldValue !== newValue) {
                        if (vm.lastUpdate) {
                            clearInterval(vm.intervalId);
                            vm.intervalId = setInterval(autoSave, 1500);
                        } else {
                            vm.lastUpdate = new Date();
                            vm.intervalId = setInterval(autoSave, 1500);
                        }
                    }
                }, true);
            }, 1000);
        }

        function clear() {
            $uibModalInstance.dismiss('dismiss');
        }

        function autoSave() {
            var intervalId = angular.copy(vm.intervalId);

            vm.lastUpdate = null;
            vm.intervalId = null;

            vm.isSaving = true;

            IncidentReportNote.autoSave({incidentReportNote: vm.incidentReportNote, jsonTemplate: vm.jsonTemplate}, function (data) {
                toastr.success("Auto save data");

                vm.isSaving = false;
            }, function () {
                toastr.error("Failure auto save data");

                vm.isSaving = false;
            });

            clearInterval(intervalId);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentReportNote', IncidentReportNote);

    IncidentReportNote.$inject = ['$resource', 'OdsFormService'];

    function IncidentReportNote($resource, OdsFormService) {
        var resourceUrl = 'api/incident-report-notes/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.jsonTemplate = null
                    }
                    return data;
                }
            },
            'autoSave': {
                url: 'api/incident-report-notes/auto-save',
                method: 'POST',
                ignoreLoadingBar: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);

                    return angular.toJson(copy);
                }
            },
            'getAllByIncidentReport': {
                url: 'api/incident-report-notes/by-incident-report/:id',
                method: 'GET',
                isArray: true
            },
            'create': {url: 'api/incident-report-notes/create', method: 'POST', isArray: true},
            'getJsonTemplate': {
                url: 'api/incident-report-notes/get-json-template/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        // data = angular.fromJson(data);
                        data = OdsFormService.convertFormSchemaFromServer(data);
                        // data = angular.fromJson(data);
                    }

                    return data;
                },
            },
            'sign': {method: 'POST', url: 'api/incident-report-notes/sign'},
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportNoteDetailController', IncidentReportNoteDetailController);

    IncidentReportNoteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', '$uibModalInstance',
        'jsonTemplate'];

    function IncidentReportNoteDetailController($scope, $rootScope, $stateParams, entity, $uibModalInstance,
                                                jsonTemplate) {
        var vm = this;

        vm.incidentReportNote = entity;
        vm.jsonTemplate = jsonTemplate;

        vm.clear = clear;

        function clear() {
            $uibModalInstance.close('dismiss');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportEditController', IncidentReportEditController);

    IncidentReportEditController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'IncidentReport',
        'Building', 'IncidentType', 'Chart', 'Facility', 'CoreService', 'Employee',
        '$state', '$uibModal', 'DTColumnBuilder', 'TypeLevelCare', 'DTOptionsBuilder',
        'GUIUtils', '$q', '$compile', 'IncidentReportNote', 'toastr', 'PopupService',
        'IncidentDepartment', 'IncidentSeverity', 'INCIDENT_REPORT_STATUS',
        '$rootScope', 'ConfirmationService'];

    function IncidentReportEditController($timeout, $scope, $stateParams, entity, IncidentReport,
                                          Building, IncidentType, Chart, Facility, CoreService, Employee,
                                          $state, $uibModal, DTColumnBuilder, TypeLevelCare, DTOptionsBuilder,
                                          GUIUtils, $q, $compile, IncidentReportNote, toastr, PopupService,
                                          IncidentDepartment, IncidentSeverity, INCIDENT_REPORT_STATUS,
                                          $rootScope, ConfirmationService) {
        var vm = this;

        vm.title = 'Incident Report';
        vm.entityClassHumanized = 'Incident Report';
        vm.entityStateName = 'incident-report';
        vm.assignReviewers = [];
        vm.notifiedSupervisors = [];
        vm.onDutySupervisors = [];
        vm.charts = [];
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;
        vm.changes = false;
        vm.dtInstance = {};
        vm.employees = [];
        vm.incidentReport = entity;
        vm.facility = CoreService.getCurrentFacility();
        vm.incidentReportOriginal = angular.copy(entity);
        vm.incidentReportNotes = [];
        vm.incidentTypes = IncidentType.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.incidentDepartments = IncidentDepartment.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.incidentSeverities = IncidentSeverity.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.staffInvolves = [];
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.originalIncidentReport = angular.copy(vm.incidentReport);
        vm.isSaving = false;
        vm.buildings = Building.byFacility({id: vm.incidentReport.facility.id});
        vm.corporation = CoreService.getCorporation();
        vm.typeLevelCares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.employee = CoreService.getCurrentEmployee();
        vm.incidentReportSignatures = vm.incidentReport.id ? IncidentReport.getSignatures({id: vm.incidentReport.id}) : [];

        vm.addIncidentReportNotes = addIncidentReportNotes;
        vm.deleteIncidentReportNote = deleteIncidentReportNote;
        vm.viewIncidentReportNote = viewIncidentReportNote;
        vm.editIncidentReportNote = editIncidentReportNote;
        vm.getAssignReviewers = getAssignReviewers;
        vm.getNotifiedSupervisors = getNotifiedSupervisors;
        vm.getOnDutySupervisors = getOnDutySupervisors;
        vm.getCharts = getCharts;
        vm.getEmployees = getEmployees;
        vm.openCalendar = openCalendar;
        vm.openSingDialog = openSingDialog;
        vm.save = save;
        vm.search = search;
        vm.alreadySigned = alreadySigned;
        vm.signIncidentReportNote = signIncidentReportNote;
        vm.canAddIncidentReportNote = canAddIncidentReportNote;
        vm.allowSign = allowSign;
        vm.canSave = canSave;
        vm.allIncidentReportNotesSigned = allIncidentReportNotesSigned;
        vm.isFullIncidentReportNotes = isFullIncidentReportNotes;
        vm.isEmployeeWithoutIncidentReportNote = isEmployeeWithoutIncidentReportNote;
        vm.isAssignReviewer = isAssignReviewer;
        vm.isFinalized = isFinalized;
        vm.isFullIncidentReportNotesbyAssignedReviewers = isFullIncidentReportNotesbyAssignedReviewers;
        vm.isFullIncidentReportNotesbyEmployees = isFullIncidentReportNotesbyEmployees;

        init();

        function init() {
            vm.watcher =
                $scope.$watch('vm.incidentReport', function (newValue, oldValue, scope) {
                    vm.changes = !angular.equals(vm.incidentReport, vm.incidentReportOriginal);
                }, true);

            $scope.$on('$destroy', function () {
                if (vm.watcher) {
                    vm.watcher();
                }
            });

            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                if (vm.incidentReport.id) {
                    IncidentReportNote.getAllByIncidentReport({
                        id: vm.incidentReport.id,
                        page: vm.page - 1,
                        size: vm.itemsPerPage,
                        facilityId: CoreService.getCurrentFacility().id
                    }, function (result, headers) {
                        vm.totalItems = headers('X-Total-Count');
                        vm.incidentReportNotes = result;
                        defer.resolve(vm.incidentReportNotes);
                    });
                } else {
                    defer.resolve(vm.incidentReportNotes);
                }
                return defer.promise;
            }).withBootstrap()
                .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[0, 'desc']])
                .withOption('headerCallback', function (header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $compile(nRow)($scope);
                    });

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle('Employee Name').notSortable().renderWith(function (data, type, full) {
                    return data.employee.lastName + ', ' + data.employee.firstName;
                }),
                DTColumnBuilder.newColumn(null).withTitle('Date').notSortable().renderWith(function (data, type, full) {
                    return moment(data.createdDate).format($rootScope.amDateFormat);
                }),
                DTColumnBuilder.newColumn(null).withTitle('Note Name').notSortable().renderWith(function (data, type, full) {
                    return data.name;
                }),
                DTColumnBuilder.newColumn(null).withTitle('Signed').renderWith(function (data, type, full) {
                    return GUIUtils.colorHtmlYesNo(data.signed);
                }),
                DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable().renderWith(actionsHtml)
            ];

            $timeout(function () {
                angular.element('.form-group:eq(1)>input').focus();
            });
        }

        function save() {
            vm.isSaving = true;
            if (vm.incidentReport.id !== null) {
                IncidentReport.update(vm.incidentReport, function () {
                    $state.reload();
                }, onSaveError);
            } else {
                IncidentReport.save(vm.incidentReport, function (result) {
                    $state.go('incident-report.edit', {id: result.id});
                }, onSaveError);
            }
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }

        function isEmployee() {
            return (_.find(vm.incidentReport.employees, ['id', CoreService.getCurrentEmployee().id])) ? true : false;
        }

        function isAssignReviewer() {
            return (_.find(vm.incidentReport.assignReviewers, ['id', CoreService.getCurrentEmployee().id])) ? true : false;
        }

        function alreadySigned() {
            return (_.find(vm.incidentReportSignatures, ['employee.id', CoreService.getCurrentEmployee().id])) ? true : false;
        }

        function addIncidentReportNotes() {
            $uibModal.open({
                templateUrl: 'app/entities/incident-report-note-template/assign/incident-report-note-template-assign-dialog.html',
                controller: 'IncidentReportNoteTemplateAssignDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    incidentReport: vm.incidentReport
                }
            }).result.then(function (result) {
                reload();
            });
        }

        function deleteIncidentReportNote(id) {
            ConfirmationService.showDelete('Incident Report Note').result.then(function () {
                IncidentReportNote.delete({id: id}, function () {
                    vm.dtInstance.reloadData();
                    toastr.success("Auto save data");
                });
            })
        }

        function editIncidentReportNote(id) {
            $uibModal.open({
                templateUrl: 'app/entities/incident-report-note/update/incident-report-note-dialog.html',
                controller: 'IncidentReportNoteDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: IncidentReportNote.get({id: id}).$promise,
                    jsonTemplate: IncidentReportNote.getJsonTemplate({id: id}).$promise
                }
            });
        }

        function viewIncidentReportNote(id) {
            $uibModal.open({
                templateUrl: 'app/entities/incident-report-note/detail/incident-report-note-detail.html',
                controller: 'IncidentReportNoteDetailController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['IncidentReportNote', function (IncidentReportNote) {
                        return IncidentReportNote.get({id: id}).$promise;
                    }],
                    jsonTemplate: IncidentReportNote.getJsonTemplate({id: id}).$promise
                }
            }).result.then(function () {

            }, function (result) {
            });
        }

        function onSingSuccess() {
            IncidentReport.get({id: vm.incidentReport.id}, function (incidentReport) {
                vm.incidentReport = incidentReport;
                IncidentReport.getSignatures({id: vm.incidentReport.id}, function (incidentReportSignatures) {
                    vm.incidentReportSignatures = incidentReportSignatures;
                });

                if (vm.incidentReport.status == 'FINALIZED') {
                    $state.go('incident-report.detail', {id: vm.incidentReport.id});
                }
            });
        }

        function openSingDialog() {
            PopupService.showSignaturePopup().result.then(function (data) {
                IncidentReport.sign({
                    incidentReport: vm.incidentReport,
                    signature: data.employeeSignature,
                    pin: data.employeeSignaturePin
                }, onSingSuccess, onSaveError);
            });
        }

        function actionsHtml(data, type, full, meta) {

            var action =
                '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +

                '<li  role="menuitem">' +
                '<a href="" class="dd-link blue" ng-click="vm.viewIncidentReportNote(' + data.id + ')">' +
                '<i class="fa fa-eye" aria-hidden="true"></i>View' +
                '</a>' +
                '</li>';

            if (allowModifyIncidentReportNote(data) && !data.signed) {
                action +=
                    '<li role="menuitem">' +
                    '<a href="" class="dd-link green" ng-click="vm.signIncidentReportNote(' + data.id + ')">' +
                    '<i class="fa fa-pencil" aria-hidden="true"></i>Sign' +
                    '</a>' +
                    '</li>';
            }

            if (allowModifyIncidentReportNote(data)) {
                action +=
                    '<li role="menuitem">' +
                    '<a href="" class="dd-link orange" ng-click="vm.editIncidentReportNote(' + data.id + ')">' +
                    '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                    '</a>' +
                    '</li>' +

                    '<li role="menuitem">' +
                    '<a href="" class="dd-link red" ng-click="vm.deleteIncidentReportNote(' + data.id + ')">' +
                    '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                    '</a>' +
                    '</li>'
            }

            action +=
                '</ul>' +
                '</div>';

            return action;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getAssignReviewers(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.assignReviewers = result;
                });
            }
        }

        function getNotifiedSupervisors(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.notifiedSupervisors = result;
                });
            }
        }

        function getOnDutySupervisors(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.onDutySupervisors = result;
                });
            }
        }

        function getCharts(query) {
            if (query && query.length > 3) {
                var filter = {};

                filter.page = 0;
                filter.size = 20;
                filter.facilityId = vm.incidentReport.facility.id;
                filter.searchQuery = query;
                filter.statuses = ['CURRENT'];

                vm.charts = Chart.fullFilter(filter);
            }
        }

        function allowModifyIncidentReportNote(incidentReportNote) {

            return vm.incidentReport.status == INCIDENT_REPORT_STATUS.PENDING &&
                vm.employee.id == incidentReportNote.employee.id;
        }

        function signIncidentReportNote(id) {
            PopupService.showSignaturePopup().result.then(function (data) {
                IncidentReportNote.sign({
                    signature: data.employeeSignature,
                    pin: data.employeeSignaturePin,
                    incidentReportNote: {id: id}
                }, function (result) {
                    if (result) {
                        toastr.success("The Incident Report Note was signed successfully.");
                    } else {
                        toastr.error("The Incident Report Note wasn't signed.");
                    }
                    $state.reload();
                }, function () {
                    toastr.error("The Incident Report Note wasn't signed.");
                    $state.reload();
                });
            });
        }

        function allowSign() {
            if (!vm.incidentReport.id || !isAssignReviewer()) {

                return false;
            }

            switch (vm.incidentReport.status) {
                case INCIDENT_REPORT_STATUS.PENDING:

                    return isFullIncidentReportNotes() && allIncidentReportNotesSigned();
                case INCIDENT_REPORT_STATUS.INREVIEW:

                    return !alreadySigned();
                case INCIDENT_REPORT_STATUS.FINALIZED:

                    return false;
            }
        }

        function isFullIncidentReportNotesbyAssignedReviewers() {
            var employeeFromNotes = _.map(vm.incidentReportNotes, function (incidentReportNote) {

                return incidentReportNote.employee.id;
            });

            return _.filter(vm.incidentReport.assignReviewers, function (employee) {

                return employeeFromNotes.indexOf(employee.id) == -1;
            }).length == 0;
        }

        function isFullIncidentReportNotesbyEmployees() {
            var employeeFromNotes = _.map(vm.incidentReportNotes, function (incidentReportNote) {

                return incidentReportNote.employee.id;
            });

            return _.filter(vm.incidentReport.employees, function (employee) {

                return employeeFromNotes.indexOf(employee.id) == -1;
            }).length == 0;
        }

        function isFullIncidentReportNotes() {
            var employeeFromNotes = _.map(vm.incidentReportNotes, function (incidentReportNote) {

                return incidentReportNote.employee.id;
            });

            var employees = vm.incidentReport.employees;

            _.forEach(vm.incidentReport.assignReviewers, function (employee) {
                if (employees.indexOf(employee) != -1) {
                    employees.push(employee);
                }
            })

            return _.filter(employees, function (employee) {

                return employeeFromNotes.indexOf(employee.id) == -1;
            }).length == 0;
        }

        function allIncidentReportNotesSigned() {
            return _.filter(vm.incidentReportNotes, function (incidentReportNote) {

                return !incidentReportNote.signed;
            }).length == 0;
        }

        function canAddIncidentReportNote() {
            if (!vm.incidentReport.id) {

                return false;
            }

            switch (vm.incidentReport.status) {
                case INCIDENT_REPORT_STATUS.PENDING: {

                    return isEmployee() || isAssignReviewer();
                }
                case INCIDENT_REPORT_STATUS.INREVIEW: {

                    return isAssignReviewer() && !alreadySigned();
                }
                case INCIDENT_REPORT_STATUS.FINALIZED:

                    return false;
            }

            return false;
        }

        function canSave() {
            if (!vm.incidentReport.id) {

                return true;
            }

            switch (vm.incidentReport.status) {
                case INCIDENT_REPORT_STATUS.PENDING: {

                    return isAssignReviewer();
                }
                case INCIDENT_REPORT_STATUS.INREVIEW: {

                    return isAssignReviewer() && !alreadySigned();
                }
                case INCIDENT_REPORT_STATUS.FINALIZED:

                    return false;
            }

            return false;
        }

        function isEmployeeWithoutIncidentReportNote(employee) {

            return _.map(vm.incidentReportNotes, function (incidentReportNote){
                return incidentReportNote.employee.id;
            }).indexOf(employee.id) == -1;
        }

        function isFinalized() {
            return vm.incidentReport.status == INCIDENT_REPORT_STATUS.FINALIZED;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentReport', IncidentReport);

    IncidentReport.$inject = ['$resource', 'DateUtils'];

    function IncidentReport ($resource, DateUtils) {
        var resourceUrl =  'api/incident-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'autoSave': {url: 'api/incident-reports/auto-save', method: 'POST', ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'sign': { method: 'POST', url: 'api/incident-reports/sign'},
            'getSignatures': { url: 'api/incident-reports/signatures/:id', method: 'GET', isArray: true},
            'findAllByFilter': {url: 'api/incident-reports/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportController', IncidentReportController);

    IncidentReportController.$inject = ['$state', 'IncidentReport', 'CoreService', '$rootScope', 'ConfirmationService',
        'GenericEntityDatatableService', '$q', 'GUIUtils', '$uibModal',
        'Employee', 'Chart', 'IncidentType', 'DateUtils', 'toastr', 'IncidentDepartment',
        'INCIDENT_REPORT_STATUS', 'PendingPdfChartReport', 'REPORT_TYPE'];

    function IncidentReportController($state, IncidentReport, CoreService, $rootScope, ConfirmationService,
                                      GenericEntityDatatableService, $q, GUIUtils, $uibModal,
                                      Employee, Chart, IncidentType, DateUtils, toastr, IncidentDepartment,
                                      INCIDENT_REPORT_STATUS, PendingPdfChartReport, REPORT_TYPE) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Incident Reports',
            newButtonTitle: "New Incident Report",
            entityClassHumanized: 'Incident Reports',
            entityStateName: 'incident-report',
            service: IncidentReport,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: true,
            options: [{key: 'aaSorting', value: [[0, 'desc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'Incident Number',
                },
                {
                    name: null,
                    title: 'Date',
                    render: function (data) {
                        return moment(data.date).format("MM/DD/YYYY");
                    }
                },
                {
                    name: null,
                    title: "Assign Reviewers",
                    render: function (data) {
                        var assignRev = "";
                        if (data.assignReviewers.length > 0) {
                            _.forEach(data.assignReviewers, function (value) {
                                assignRev = assignRev + (value.firstName + " " + value.lastName) + ", ";
                            })
                            assignRev = assignRev.substring(0, (assignRev.length) - 2);
                        }
                        return assignRev;
                    }
                },
                {
                    name: null,
                    title: "Incident Types",
                    render: function (data) {
                        var incidentType = "";
                        if (data.incidentTypes.length > 0) {
                            _.forEach(data.incidentTypes, function (value) {
                                incidentType = incidentType + (value.name) + ", ";
                            });
                            incidentType = incidentType.substring(0, (incidentType.length) - 2);
                        }
                        return incidentType;
                    }
                },
                {
                    name: null,
                    title: "Incident Departments",
                    render: function (data) {
                        var incidentDepartment = "";
                        if (data.incidentDepartments.length > 0) {
                            _.forEach(data.incidentDepartments, function (value) {
                                incidentDepartment = incidentDepartment + (value.name) + ", ";
                            });
                            incidentDepartment = incidentDepartment.substring(0, (incidentDepartment.length) - 2);
                        }
                        return incidentDepartment;
                    }
                },
                {
                    name: null,
                    title: "Status",
                    render: function (data) {
                        return statusHtml(data);
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(), {
                    action: function (data) {
                        return $state.go($state.current.name + '.detail', {id: data.id});
                    },
                    reload: false
                }),

                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        $state.go('incident-report.edit', {id: data.id});
                    },
                    ngIf: function (data, filter) {
                        return data.status !== INCIDENT_REPORT_STATUS.FINALIZED;
                    },
                    reload: false
                }),

                angular.extend({}, GenericEntityDatatableService.getPrintAction(), {
                    action: function (data) {
                        print(data.id);
                    },
                    reload: false
                }),

                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    },
                }),
            ],
            filters: [
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Patient involve...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'incidentTypeId',
                    read: function (filter) {
                        return filter.incidentTypeId ? filter.incidentTypeId.id : null;
                    },
                    values: IncidentType.findAllByCorporation(CoreService.getFilterByCurrentCorporation()),
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    placeholder: 'Incident Type...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'date',
                    placeholder: 'Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.date ? moment(filter.date).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'employeeId',
                    read: function (filter) {
                        return filter.employeeId ? filter.employeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        Employee.findAllByFilter(
                            {
                                page: 0,
                                size: 10,
                                facilityId: params.facilityId,
                                query: search,
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Assign reviewer...',
                    type: 'select',
                    visible: true,
                },
                {
                    name: 'createdByEmployeeId',
                    read: function (filter) {
                        return filter.createdByEmployeeId ? filter.createdByEmployeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        Employee.findAllByFilter(
                            {
                                page: 0,
                                size: 10,
                                facilityId: params.facilityId,
                                query: search,
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Employee...',
                    type: 'select',
                    visible: true,
                },
                {
                    name: "status",
                    values: ['PENDING', 'INREVIEW', 'FINALIZED'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    placeholder: 'Status...',
                    type: 'select',
                    visible: true,
                },
                {
                    name: 'incidentDepartmentId',
                    read: function (filter) {
                        return filter.incidentDepartmentId ? filter.incidentDepartmentId.id : null;
                    },
                    values: IncidentDepartment.findAllByCorporation(CoreService.getFilterByCurrentCorporation()),
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    placeholder: 'Incident department...',
                    type: 'select',
                    visible: true,
                },
            ],
        }

        function statusHtml(data) {
            var classType = '';

            switch (data.status) {
                case 'PENDING':
                    classType = 'label-info';
                    break;
                case 'FINALIZED':
                    classType = 'label-success';
                    break;
                case 'INREVIEW':
                    classType = 'label-warning';
                    break;
            }
            return '<span class="label ' + classType + '">' + data.status + '</span>'
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('IncidentReport').result.then(function () {
                    IncidentReport.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function print(id) {
            PendingPdfChartReport.save({
                objectId: id,
                reportType: REPORT_TYPE.INCIDENT_REPORT,
                name: "Incident report " + id
            }, function (result) {
                toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
            }, function () {
                toastr.error("We couldn't generate the report.");
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('incident-report', {
                parent: 'entity',
                url: '/incident-report',
                data: {
                    authorities: [],
                    pageTitle: 'IncidentReports'
                },
                ncyBreadcrumb: {
                    label: 'Incident Reports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report/list/incident-report.html',
                        controller: 'IncidentReportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS, access);
                }]
            })
            .state('incident-report.new', {
                parent: 'incident-report',
                url: '/new',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'New Incident Report',
                    parent: 'incident-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report/update/incident-report-edit.html',
                        controller: 'IncidentReportEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    entity: ['INCIDENT_REPORT_STATUS', 'CoreService', function (INCIDENT_REPORT_STATUS, CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            id: null,
                            date: new Date(),
                            patientInvolves: [],
                            typeLevelCare: null,
                            incidentDepartments: [],
                            assignReviewers: [],
                            incidentTypes: [],
                            incidentSeverity: null,
                            injury: false,
                            reachClient: false,
                            location: null,
                            buildings: [],
                            employees: [],
                            onDutySupervisors: [],
                            notified: false,
                            notifiedSupervisors: [],
                            status: INCIDENT_REPORT_STATUS.PENDING
                        };
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS, access);
                }]
            })
            .state('incident-report.edit', {
                parent: 'incident-report',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'Edit Incident Report',
                    parent: 'incident-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report/update/incident-report-edit.html',
                        controller: 'IncidentReportEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    entity: ['IncidentReport', '$stateParams', function (IncidentReport, $stateParams) {
                        return IncidentReport.get({id: $stateParams.id}).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', 'entity', '$state', 'INCIDENT_REPORT_STATUS',
                    function (Auth, ACTIONS, access, entity, $state, INCIDENT_REPORT_STATUS) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS, access);

                        if (entity.status === INCIDENT_REPORT_STATUS.FINALIZED) {
                            $state.go('incident-report.detail', {id: entity.id});
                        }
                    }]
            })
            .state('incident-report.detail', {
                parent: 'incident-report',
                url: '/{id}/view',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'Detail Incident Report',
                    parent: 'incident-report'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/incident-report/update/incident-report-edit.html',
                        controller: 'IncidentReportEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    entity: ['IncidentReport', '$stateParams', function (IncidentReport, $stateParams) {
                        return IncidentReport.get({id: $stateParams.id}).$promise;
                    }],
                    disable: [function () {
                        return true;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_INCIDENT_REPORTS, access);
                }]
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentDepartmentDialogController', IncidentDepartmentDialogController);

    IncidentDepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncidentDepartment', 'Corporation', 'IncidentReport'];

    function IncidentDepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncidentDepartment, Corporation, IncidentReport) {
        var vm = this;

        vm.incidentDepartment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incidentDepartment.id !== null) {
                IncidentDepartment.update(vm.incidentDepartment, onSaveSuccess, onSaveError);
            } else {
                IncidentDepartment.save(vm.incidentDepartment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:incidentDepartmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentDepartment', IncidentDepartment);

    IncidentDepartment.$inject = ['$resource'];

    function IncidentDepartment ($resource) {
        var resourceUrl =  'api/incident-departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/incident-departments/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentDepartmentController', IncidentDepartmentController);

    IncidentDepartmentController.$inject = ['GenericEntityDatatableService', 'CoreService', 'IncidentDepartment', '$q',
        '$uibModal', 'ConfirmationService'];

    function IncidentDepartmentController(GenericEntityDatatableService, CoreService, IncidentDepartment, $q,
                                          $uibModal, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Incident Department',
            newButtonTitle: 'New Incident Department',
            entityClassHumanized: 'Incident Department',
            entityStateName: 'incident-department',
            service: IncidentDepartment,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Incident Department',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-department/update/incident-department-dialog.html',
                controller: 'IncidentDepartmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/incident-department/update/incident-department-dialog.html',
                controller: 'IncidentDepartmentDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['IncidentDepartment', function (IncidentDepartment) {
                        return IncidentDepartment.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Incident Department').result.then(function () {
                    IncidentDepartment.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incident-department', {
            parent: 'entity',
            url: '/incident-department',
            data: {
                authorities: [],
                pageTitle: 'IncidentDepartments'
            },
            ncyBreadcrumb: {
                label: 'IncidentDepartment'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incident-department/list/incident-department.html',
                    controller: 'IncidentDepartmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT, access);
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Icd10Search', Icd10Search);

    Icd10Search.$inject = ['$resource'];

    function Icd10Search($resource) {
        var resourceUrl =  'api/_search/icd-10-s/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, ignoreLoadingBar: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosisDialogController', DiagnosisDialogController);

    DiagnosisDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity'];

    function DiagnosisDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity) {
        var vm = this;

        vm.diagnoses = entity.icd10s;
        vm.clear = clear;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionTemplateDialogController', GroupSessionTemplateDialogController);

    GroupSessionTemplateDialogController.$inject = ['$scope', '$uibModalInstance', 'entity',
        'GroupSessionTemplate', 'Facility', 'Building', 'Employee',
        'SessionType', '$rootScope', 'GUIUtils', 'CoreService',
        'GroupSessionFormTpl', 'filter'];

    function GroupSessionTemplateDialogController($scope, $uibModalInstance, entity,
                                                  GroupSessionTemplate, Facility, Building, Employee,
                                                  SessionType, $rootScope, GUIUtils, CoreService,
                                                  GroupSessionFormTpl, filter) {
        var vm = this;

        vm.groupSessionTemplate = entity;
        vm.datePickerOpenStatus = {};
        vm.isSaving = false;
        vm.buildings = Building.byFacility({id: vm.groupSessionTemplate.facility.id});
        vm.employees = vm.groupSessionTemplate.employees;
        vm.corporation = CoreService.getCorporation();

        vm.days = GUIUtils.getDays();
        vm.timeFormat = $rootScope.timeFormat;
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.stop = false;
        vm.filter = filter;

        vm.sessionTypes = SessionType.byCorporation(CoreService.getFilterByCurrentCorporation());

        if (vm.groupSessionTemplate.daysWeek)
            vm.daysWeek = GUIUtils.weekCodeStringToDays(vm.groupSessionTemplate.daysWeek);

        vm.groupSessionFormTpls = [];

        vm.getEmployees = getEmployees;
        vm.getReviewers = getReviewers;
        vm.getGroupSessionFormTpls = getGroupSessionFormTpls;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save() {
            vm.isSaving = true;

            if (vm.daysWeek) {
                vm.groupSessionTemplate.daysWeek = GUIUtils.daysToWeekCodeString(vm.daysWeek);
            }

            if (vm.groupSessionTemplate.id !== null) {
                GroupSessionTemplate.update(vm.groupSessionTemplate, onSaveSuccess, onSaveError);
            } else {
                GroupSessionTemplate.save(vm.groupSessionTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:groupSessionTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getReviewers(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.reviewers = result;
                });
            }
        }

        function getGroupSessionFormTpls(query) {
            if (query && query.length > 3) {
                GroupSessionFormTpl.filter({
                    page: 0,
                    size: 20,
                    facilityId: vm.groupSessionTemplate.facility.id,
                    searchQuery: query
                }, function (result) {
                    vm.groupSessionFormTpls = result;
                });
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GroupSessionTemplate', GroupSessionTemplate);

    GroupSessionTemplate.$inject = ['$resource', 'DateUtils', 'GUIUtils', 'moment'];

    function GroupSessionTemplate($resource, DateUtils, GUIUtils, moment) {
        var resourceUrl = 'api/group-session-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.stop = DateUtils.convertDateTimeFromServer(data.stop);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'schedule': {
                url: 'api/group-sessions-template/schedule', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        var result = [];

                        _.forEach(data, function (item) {
                            item.date = DateUtils.convertLocalDateFromServer(item.date);

                            _.forEach(item.templates, function (template) {
                                template.start = DateUtils.convertDateTimeFromServer(template.start);

                                var dateStart = new Date(angular.copy(item.date));
                                if (template.start) {
                                    dateStart.setHours(template.start.getHours());
                                    dateStart.setMinutes(template.start.getMinutes());
                                }
                                template.status = (moment(dateStart).isBefore(new Date(), 'day')) ? 'DISABLED' : 'PENDING';

                                var event = {
                                    title: template.title + " (" + template.id + ")",
                                    start: dateStart,
                                    color: GUIUtils.groupSessionStatusColor(template.status ? template.status : 'PENDING'),
                                    template: template
                                };

                                result.push(event);
                            });

                            _.forEach(item.groupSessions, function (groupSession) {
                                var event = {
                                    title: groupSession.title + " (" + groupSession.id + ")",
                                    start: groupSession.start ? DateUtils.convertDateTimeFromServer(groupSession.start) : DateUtils.convertDateTimeFromServer(groupSession.startDate),
                                    color: GUIUtils.groupSessionStatusColor(groupSession.status ? groupSession.status : 'PENDING'),
                                    groupSession: groupSession
                                };

                                result.push(event);
                            });
                        });

                        return result;
                    }

                    return null;
                }
            },
            'filter': {url: 'api/group-sessions-template/filter', method: 'GET', isArray: true},
            'byFacility': {url: 'api/group-sessions-template/by-facility/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionTemplateController', GroupSessionTemplateController);

    GroupSessionTemplateController.$inject = ['$rootScope', 'GroupSessionTemplate', 'CoreService', 'GUIUtils',
        'GenericEntityDatatableService', 'ConfirmationService', '$q', '$uibModal'];

    function GroupSessionTemplateController($rootScope, GroupSessionTemplate, CoreService, GUIUtils,
                                            GenericEntityDatatableService, ConfirmationService, $q, $uibModal) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Group Sessions',
            entityClassHumanized: 'Group Sessions',
            entityStateName: 'group-session-template',
            service: GroupSessionTemplate,
            serviceMethod: 'filter',
            newButtonTitle: 'New Group Session',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'title',
                    title: 'Title'
                },
                {
                    name: 'daysWeek',
                    title: 'Days of Week',
                    render: function (daysWeek) {
                        return daysWeek ? GUIUtils.expandWeekCodeString(daysWeek, ',') : "-";
                    }
                },
                {
                    name: 'start',
                    title: 'Start Time',
                    render: function (start) {
                        return start ? moment(start).format($rootScope.timeFormatA) : "-";
                    }
                },
                {
                    name: 'stop',
                    title: 'End Time',
                    render: function (stop) {
                        return stop ? moment(stop).format($rootScope.timeFormatA) : "-";
                    }
                },
                {
                    name: 'enabled',
                    title: 'Enabled',
                    render: function (enabled) {
                        return GUIUtils.colorHtmlYesNo(!!enabled);
                    }
                },
                {
                    name: 'billable',
                    title: 'Billable',
                    render: function (billable) {
                        return GUIUtils.colorHtmlYesNo(!!billable);
                    }
                }

            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Group Session',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/group-session-template/update/group-session-template-dialog.html',
                controller: 'GroupSessionTemplateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            title: null,
                            description: null,
                            start: null,
                            stop: null,
                            ageBegin: null,
                            ageEnd: null,
                            enabled: true,
                            billable: false,
                            daysWeek: null,
                            id: null
                        };
                    }],
                    filter: ['CoreService', function (CoreService) {
                        var facility = CoreService.getCurrentFacility();
                        return {
                            facilityId: facility.id
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/group-session-template/update/group-session-template-dialog.html',
                controller: 'GroupSessionTemplateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['GroupSessionTemplate', function (GroupSessionTemplate) {
                        return GroupSessionTemplate.get({id: id}).$promise;
                    }],
                    filter: ['CoreService', function (CoreService) {
                        var facility = CoreService.getCurrentFacility();
                        return {
                            facilityId: facility.id
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('GroupSession Template').result.then(function () {
                    GroupSessionTemplate.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group-session-template', {
                parent: 'entity',
                url: '/group-session-template',
                data: {
                    authorities: [],
                    pageTitle: 'GroupSessionTemplates'
                },
                ncyBreadcrumb: {
                    label: 'Group Sessions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session-template/list/group-session-template.html',
                        controller: 'GroupSessionTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access);
                    }]
                }
            })
            .state('group-session-template.new', {
                parent: 'group-session-template',
                url: '/new',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'New Template'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/group-session-template/update/group-session-template-dialog.html',
                            controller: 'GroupSessionTemplateDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        facility: CoreService.getCurrentFacility(),
                                        title: null,
                                        description: null,
                                        start: null,
                                        stop: null,
                                        ageBegin: null,
                                        ageEnd: null,
                                        enabled: true,
                                        billable: false,
                                        daysWeek: null,
                                        id: null
                                    };
                                }],
                                filter: ['CoreService', function (CoreService) {
                                    var facility = CoreService.getCurrentFacility();
                                    return {
                                        facilityId: facility.id
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('group-session-template', null, {reload: 'group-session-template'});
                        }, function () {
                            $state.go('group-session-template');
                        });
                    }
                }]
            })
            .state('group-session-template.edit', {
                parent: 'group-session-template',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'Edit Template'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/group-session-template/update/group-session-template-dialog.html',
                            controller: 'GroupSessionTemplateDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['GroupSessionTemplate', function (GroupSessionTemplate) {
                                    return GroupSessionTemplate.get({id: $stateParams.id}).$promise;
                                }],
                                filter: ['CoreService', function (CoreService) {
                                    var facility = CoreService.getCurrentFacility();
                                    return {
                                        facilityId: facility.id
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('group-session-template', null, {reload: 'group-session-template'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('group-session-template.delete', {
                parent: 'group-session-template',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/group-session-template/group-session-template-delete-dialog.html',
                            controller: 'GroupSessionTemplateDeleteController',
                            controllerAs: 'vm',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['GroupSessionTemplate', function (GroupSessionTemplate) {
                                    return GroupSessionTemplate.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('group-session-template', null, {reload: 'group-session-template'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionFormTplEditController', GroupSessionFormTplEditController);

    GroupSessionFormTplEditController.$inject = ['entity', '$rootScope', 'GroupSessionFormTpl', 'OdsFormService', '$state'];

    function GroupSessionFormTplEditController ( entity, $rootScope, GroupSessionFormTpl, OdsFormService, $state) {
        var vm = this;

        vm.title = 'Group Session Form Tpls';

        vm.groupSessionFormTpl = entity;
        vm.save = save;
        vm.updateTitle = updateTitle;

        vm.groupSessionFormTpl.jsonTemplate = !vm.groupSessionFormTpl.jsonTemplate ?
            OdsFormService.newSchema() : vm.groupSessionFormTpl.jsonTemplate;

        vm.debugMode = !$rootScope.inProduction ? true : false;

        function save () {
            vm.isSaving = true;
            if (vm.groupSessionFormTpl.id !== null) {
                GroupSessionFormTpl.update(vm.groupSessionFormTpl, onSaveSuccess, onSaveError);
            } else {
                GroupSessionFormTpl.save(vm.groupSessionFormTpl, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $state.go('group-session-form-tpl', {}, {reload: true});
        }

        function onSaveError(error) {
            console.log('Problem saving this element' + error);
        }
        function updateTitle() {
            vm.groupSessionFormTpl.jsonTemplate.label = angular.copy(vm.groupSessionFormTpl.name);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GroupSessionFormTpl', GroupSessionFormTpl);

    GroupSessionFormTpl.$inject = ['$resource'];

    function GroupSessionFormTpl ($resource) {
        var resourceUrl =  'api/group-session-form-tpls/:id';

        return $resource(resourceUrl, {}, {
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.jsonTemplate = angular.fromJson(data.jsonTemplate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'filter': {url: 'api/group-session-form-tpl/filter', method: 'GET', isArray: true},
            'clone': {url: 'api/group-session-form-tpl/clone/:id', method: 'GET'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionFormTplController', GroupSessionFormTplController);

    GroupSessionFormTplController.$inject = ['GroupSessionFormTpl', 'CoreService', 'GenericEntityDatatableService',
        'ConfirmationService', '$q', '$uibModal'];

    function GroupSessionFormTplController(GroupSessionFormTpl, CoreService, GenericEntityDatatableService,
                                           ConfirmationService, $q, $uibModal) {

        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Group Session Forms',
            entityClassHumanized: 'Group Session Forms',
            entityStateName: 'group-session-form-tpl',
            service: GroupSessionFormTpl,
            serviceMethod: 'filter',
            newButtonTitle: 'New Group Session Form',
            params: params,
            pagination: 'remote',
            newAction: true,
            options: [{key: 'aaSorting', value: [[0, 'desc']]}],
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'description',
                    title: 'description'
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('group-session-form-tpl'),
                angular.extend({}, GenericEntityDatatableService.getCloneAction(), {
                    action: function (data) {
                        return clone(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
        }

        function clone(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/group-session-form-tpl/clone/group-session-form-tpl-clone-dialog.html',
                controller: 'GroupSessionFormTplCloneController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['GroupSessionFormTpl', function (GroupSessionFormTpl) {
                        return GroupSessionFormTpl.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('GroupSession Form Tpl').result.then(function () {
                    GroupSessionFormTpl.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('group-session-form-tpl', {
                parent: 'entity',
                url: '/group-session-form-tpl',
                data: {
                    authorities: [],
                    pageTitle: 'GroupSessionFormTpls'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session-form-tpl/list/group-session-form-tpl.html',
                        controller: 'GroupSessionFormTplController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL, access);
                }]
            })
            .state('group-session-form-tpl.new', {
                parent: 'group-session-form-tpl',
                url: '/new',
                data: {
                    authorities: []
                },
                ncyBreadcrumb: {
                    label: 'New Group Session Form',
                    parent: 'group-session-form-tpl'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session-form-tpl/update/group-session-form-tpl-edit.html',
                        controller: 'GroupSessionFormTplEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            name: null,
                            description: null,
                            jsonTemplate: null,
                            id: null
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL, access);
                }]
            })
            .state('group-session-form-tpl.edit', {
                parent: 'group-session-form-tpl',
                url: '/{id}/edit',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                ncyBreadcrumb: {
                    label: 'Edit Group Session Form',
                    parent: 'group-session-form-tpl'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session-form-tpl/update/group-session-form-tpl-edit.html',
                        controller: 'GroupSessionFormTplEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['GroupSessionFormTpl', '$stateParams', function (GroupSessionFormTpl, $stateParams) {
                        return GroupSessionFormTpl.get({id: $stateParams.id}).$promise;
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionFormTplCloneController',GroupSessionFormTplCloneController);

    GroupSessionFormTplCloneController.$inject = ['$uibModalInstance', 'entity', 'GroupSessionFormTpl'];

    function GroupSessionFormTplCloneController($uibModalInstance, entity, GroupSessionFormTpl) {
        var vm = this;

        vm.evaluationTemplate = entity;
        vm.clear = clear;
        vm.confirmClone = confirmClone;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmClone (id) {
            GroupSessionFormTpl.clone({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GroupSessionDetails', GroupSessionDetails);

    GroupSessionDetails.$inject = ['$resource', 'DateUtils', 'OdsFormService'];

    function GroupSessionDetails($resource, DateUtils, OdsFormService) {
        var resourceUrl = 'api/group-session-details/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.stop = DateUtils.convertDateTimeFromServer(data.stop);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                ignoreLoadingBar: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    return angular.toJson(copy);
                }
            },
            'autoSave': {
                method: 'PUT',
                url: 'api/group-session-details/auto-save',
                ignoreLoadingBar: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);

                    return angular.toJson(copy);
                }
            },
            'pageableDetails': {
                url: 'api/group-session-details/group-session/:id',
                method: 'GET',
                ignoreLoadingBar: true,
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        var result = [];
                        data.forEach(function (element) {
                            element[0].groupSession = element[1];
                            element[0].start = DateUtils.convertDateTimeFromServer(element[0].start);
                            element[0].stop = DateUtils.convertDateTimeFromServer(element[0].stop);
                            result.push(element[0]);
                        });
                        return result;
                    }
                }
            },
            'getAllGroupSessionDetails': {
                url: 'api/group-session-details/list/group-session/:id',
                method: 'GET',
                ignoreLoadingBar: true,
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        var result = [];
                        if (data.length > 0) {
                            data.forEach(function (element) {
                                element[0].groupSession = element[1];
                                element[0].start = DateUtils.convertDateTimeFromServer(element[0].start);
                                element[0].stop = DateUtils.convertDateTimeFromServer(element[0].stop);
                                result.push(element[0]);

                            });
                        }
                        return result;
                    }
                }
            },
            'findAllByGroupSessionAndGroupSessionTemplate': {
                url: 'api/group-session-details/by-group-session/:id',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);

                    return _.map(data, function (item) {
                        item.start = DateUtils.convertDateTimeFromServer(item.start);
                        item.stop = DateUtils.convertDateTimeFromServer(item.stop);

                        return item;
                    });
                }
            },
            'addToGroupSession': {url: 'api/group-session-details/add-to-group-session', method: 'POST'},
            'findAllByFilter': { url: 'api/group-session-details/filter', method: 'GET', isArray: true},
            'getJsonTemplate': {
                url: 'api/group-session-details/get-json-template/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = OdsFormService.convertFormSchemaFromServer(data);
                    }

                    return data;
                },
            },

            'getHistory': {
                url: 'api/group-session-details-histories/history/:id',
                method: 'GET',
                ignoreLoadingBar: true,
                isArray: true
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionDetailsDialogController', GroupSessionDetailsDialogController);

    GroupSessionDetailsDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'toastr',
        'GroupSessionDetails', 'entity', 'GroupSession', '$interval'];

    function GroupSessionDetailsDialogController($timeout, $scope, $uibModalInstance, toastr,
                                                 GroupSessionDetails, entity, GroupSession, $interval) {
        var vm = this;

        vm.groupSessionDetails = entity;
        vm.groupSession = null;
        vm.chart = vm.groupSessionDetails.chart;
        vm.jsonTemplate = null

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.start = false;
        vm.datePickerOpenStatus.stop = false;
        vm.watchers = [];
        vm.datePickerOpenStatus = {};

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        init();

        function init() {
            GroupSessionDetails.getJsonTemplate({id: vm.groupSessionDetails.id}, function (jsonTemplate) {
                vm.jsonTemplate = jsonTemplate;

                $timeout(function () {
                    vm.watcher =
                        $scope.$watch('vm.jsonTemplate', function (newValue, oldValue, scope) {
                            if (oldValue !== newValue) {
                                if (!vm.autoSaveId) {
                                    vm.interval = $interval(autoSave, 1500);
                                }

                                vm.lastUpdate = new Date();
                                vm.autoSaveId = Math.random();
                            }
                        }, true);
                }, 2000);
            });

            GroupSession.get({id: vm.groupSessionDetails.groupSessionId}, function (result) {
                vm.groupSession = result;

                if (vm.groupSession.leaderId) {
                    GroupSession.getSignature({id: vm.groupSession.id, type: 'STAFF'}, function (data) {
                        vm.leaderSignature = data ? data : null;
                    });
                }

                if (vm.groupSession.reviewerId) {
                    GroupSession.getSignature({id: vm.groupSession.id, type: 'REVIEW'}, function (data) {
                        vm.reviewerSignature = data ? data : null;
                    });
                }
            });
        }

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.formatDate = formatDate;
        vm.formatDateNew = formatDateNew;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function formatDate(date) {
            return moment(date).format('lll');
        }

        function formatDateNew(date) {
            return moment(date).format("hh:mm a");
        }

        function autoSave() {
            if (vm.isSaving || !vm.autoSaveId) {

                return;
            }

            if (vm.savedId === vm.autoSaveId) {
                vm.autoSaveId = null;
                vm.savedId = null;

                $interval.cancel(vm.interval);

                return;
            }

            var now = new Date();

            if (((now.getTime() - vm.lastUpdate.getTime()) / 1000) < 1.5) {

                return;
            }

            vm.isSaving = true;
            vm.savedId = angular.copy(vm.autoSaveId);

            var jsonTemplate = angular.copy(vm.jsonTemplate);

            GroupSessionDetails.autoSave({
                groupSessionDetails: vm.groupSessionDetails,
                jsonTemplate: jsonTemplate
            }, function () {
                vm.isSaving = false;

                toastr.success("Saved " + vm.groupSession.title + ' - ' +
                    vm.groupSessionDetails.chart.firstName + ' ' +
                    vm.groupSessionDetails.chart.lastName + ' ' + vm.groupSessionDetails.chart.mrNo);
            }, function () {
                vm.isSaving = false;

                toastr.error("Error saving " + vm.groupSession.title + ' - ' +
                    vm.groupSessionDetails.chart.firstName + ' ' +
                    vm.groupSessionDetails.chart.lastName + ' ' + vm.groupSessionDetails.chart.mrNo);
            });
        }

        $scope.$on('$destroy', function () {
            if (vm.watcher) {
                vm.watcher();
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionDetailsController', GroupSessionDetailsController);

    GroupSessionDetailsController.$inject = ['chart', 'GroupSessionDetails', '$uibModal', 'GroupSession', 'PdfPrint',
        'PendingPdfChartReport', 'toastr', '$rootScope', '$state', '$scope', 'access',
        'REPORT_TYPE', 'ACTIONS', 'params', 'TAB', 'Auth', '$uibModalStack'];

    function GroupSessionDetailsController(chart, GroupSessionDetails, $uibModal, GroupSession, PdfPrint,
                                           PendingPdfChartReport, toastr, $rootScope, $state, $scope, access,
                                           REPORT_TYPE, ACTIONS, params, TAB, Auth, $uibModalStack) {
        var vm = this;

        vm.chart = chart;

        vm.page = 1;
        vm.itemsPerPage = 20;
        vm.title = 'Group Session Details';
        vm.entityClassHumanized = 'Group Session Details';
        vm.entityStateName = 'group-session-details';
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.GROUP_SESSION);
        vm.chart = chart;
        vm.access = access;
        vm.toggleAllRows = false;

        vm.groupSessionDetails = [];

        vm.view = view;
        vm.loadAll = loadAll;
        vm.print = print;
        vm.statusClass = statusClass;
        vm.toggleRow = toggleRow;
        vm.toggleAllRow = toggleAllRow;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.audit = audit;

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW, access) || !vm.active) {
                return;
            }

            GroupSessionDetails.findAllByFilter(getFilter(),
                function (result, headers) {
                    if (result) {
                        vm.groupSessionDetails = result;
                        vm.totalItems = headers('X-Total-Count');

                        if (vm.toggleAllRows) {
                            for (var i = 0; i < vm.groupSessionDetails.length; i++) {
                                vm.groupSessionDetails[i].active = vm.toggleAllRows;

                                if (vm.groupSessionDetails[i].id && vm.groupSessionDetails[i].active) {
                                    getJsonTemplate(vm.groupSessionDetails[i]);
                                }
                            }
                        }
                    }
                });
        }

        function view(item) {
            $uibModal.open({
                templateUrl: 'app/entities/group-session-details/detail/group-session-details-dialog.html',
                controller: 'GroupSessionDetailsDialogController',
                windowTopClass: 'custom-dialog-styles',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: GroupSessionDetails.get({id: item.id}).$promise
                }
            }).result.then(function () {
                vm.loadAll();
            }, function () {
                vm.loadAll();
            });
        }

        function statusClass(data) {
            switch (data) {
                case 'REVIEW': {
                    return 'review';
                }
                case 'COMPLETE': {
                    return 'complete';
                }
                case 'STARTED': {
                    return 'started'
                }
            }
        }

        function print(groupSessionDetails) {
            vm.isPrinting = true;

            PendingPdfChartReport.save({
                chart: vm.chart,
                objectId: groupSessionDetails.id,
                name: "" + groupSessionDetails.id,
                reportType: REPORT_TYPE.GROUP_SESSION_DETAIL
            }, onPrintSuccess, onPrintError);

            function onPrintSuccess(result) {
                vm.isPrinting = false;

                toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
            }

            function onPrintError() {
                vm.isPrinting = false;
                toastr.error("We couldn't generate the report.");
            }
        }

        function toggleAllRow() {
            vm.toggleAllRows = !vm.toggleAllRows;
            for (var i = 0; i < vm.groupSessionDetails.length; i++) {
                vm.groupSessionDetails[i].active = vm.toggleAllRows;

                if (vm.groupSessionDetails[i].id && vm.groupSessionDetails[i].active && !vm.groupSessionDetails[i].json) {
                    getJsonTemplate(vm.groupSessionDetails[i]);
                }
            }

        }

        function toggleRow(item) {
            item.active = !item.active;

            if (item.active) {
                getJsonTemplate(item);
            }
        }

        function getJsonTemplate(item) {
            GroupSessionDetails.getJsonTemplate({id: item.id}, function (jsonTemplate) {
                item.jsonTemplate = jsonTemplate;
            });
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result == TAB.GROUP_SESSION) {
                vm.active = true;
                loadAll();
            }
        });

        $scope.$on('$destroy', unsubscribe);

        function search() {
            vm.page = 1;
            loadAll();
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function audit(groupSession) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/group-session/history-audit/group-session-history-audit.html',
                controller: 'GroupSessionHistoryAuditController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    groupSession: groupSession
                }
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GroupSession', GroupSession);

    GroupSession.$inject = ['$resource', 'DateUtils', 'OdsFormService'];

    function GroupSession($resource, DateUtils, OdsFormService) {
        var resourceUrl = 'api/group-sessions/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.stop = DateUtils.convertDateTimeFromServer(data.stop);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        // data.leaderSignature = data.leaderSignature?data.leaderSignature:{signature: ''};
                        // data.reviewerSignature = data.reviewerSignature?data.reviewerSignature:{signature: ''};
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.start = DateUtils.convertDateTimeFromServer(data.start);
                        data.stop = DateUtils.convertDateTimeFromServer(data.stop);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        // data.leaderSignature = data.leaderSignature?data.leaderSignature:{signature: ''};
                        // data.reviewerSignature = data.reviewerSignature?data.reviewerSignature:{signature: ''};
                    }
                    return data;
                }
            },
            'sign': {url: 'api/group-sessions/sign', method: 'PUT'},
            'getSignature': {
                method: 'GET', url: 'api/group-sessions/get-signature/:id/:type', transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }

                    return data;
                }
            },
            'leaderSign': {
                method: 'POST', url: 'api/group-sessions/leader-sign',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }

                    return data;
                }
            },
            'reviewerSign': {
                method: 'POST', url: 'api/group-sessions/reviewer-sign',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }

                    return data;
                }
            },
            'getJsonTemplate': {
                url: 'api/group-sessions/get-json-template/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        // data = angular.fromJson(data);
                        data = OdsFormService.convertFormSchemaFromServer(data);
                        // data = angular.fromJson(data);
                    }

                    return data;
                },
            },
            'masterSignature': {
                url: 'api/group-sessions/master-signature',
                method: 'POST',
                ignoreLoadingBar: true
            },
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionInitController', GroupSessionInitController);

    GroupSessionInitController.$inject = ['$uibModal', 'entity', 'GroupSession', 'SessionType', 'CoreService', 'Employee',
        '$scope', '$state', 'startDate', '$uibModalInstance', 'BUSINESS_ROLES'];

    function GroupSessionInitController($uibModal, entity, GroupSession, SessionType, CoreService, Employee,
                                         $scope, $state, startDate, $uibModalInstance, BUSINESS_ROLES) {
        var vm = this;

        vm.groupSessionTemplate = entity;

        vm.title = 'Sessions Event';

        vm.employees = vm.groupSessionTemplate.employees;
        vm.sessionTypes = SessionType.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.startDate = startDate;
        vm.corporation = CoreService.getCorporation();

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.getReviewers = getReviewers;

        init();

        function init() {
            if (vm.groupSessionTemplate) {
                vm.groupSession = {};
                vm.groupSession.id = null;
                vm.groupSession.title = vm.groupSessionTemplate.title;
                vm.groupSession.start = getJoinDate(vm.startDate, vm.groupSessionTemplate.start);
                vm.groupSession.stop = getJoinDate(vm.startDate, vm.groupSessionTemplate.stop);
                vm.groupSession.billable = vm.groupSessionTemplate.billable;
                vm.groupSession.ageBegin = vm.groupSessionTemplate.ageBegin;
                vm.groupSession.ageEnd = vm.groupSessionTemplate.ageEnd;
                vm.groupSession.sessionType = vm.groupSessionTemplate.sessionType;
                vm.groupSession.employees = vm.groupSessionTemplate.employees;
                vm.groupSession.reviewer = vm.groupSessionTemplate.reviewer;
                vm.groupSession.description = vm.groupSessionTemplate.description;
                vm.groupSession.facility = vm.groupSessionTemplate.facility;
                vm.groupSession.daysWeek = vm.groupSessionTemplate.daysWeek;
                vm.groupSession.startDate = vm.startDate ? vm.startDate : new Date();
                vm.groupSession.status2 = 'STARTED';
                vm.groupSession.enabled = true;
                vm.groupSession.groupSessionTemplate = vm.groupSessionTemplate;
            }

            if (vm.groupSession && vm.groupSession.start) {
                vm.groupSession.start = moment(vm.groupSession.start).format('YYYY-MM-DDTHH:mm:00');
                vm.groupSession.start = moment(vm.groupSession.start).toDate();
            }

            if (vm.groupSession && vm.groupSession.stop) {
                vm.groupSession.stop = moment(vm.groupSession.stop).format('YYYY-MM-DDTHH:mm:00');
                vm.groupSession.stop = moment(vm.groupSession.stop).toDate();
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.groupSession.id == null) {
                GroupSession.save(vm.groupSession, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:groupSession', result);
            vm.isSaving = false;
            $uibModalInstance.dismiss('cancel');
            $state.go('group-session-edit', {id: result.id});
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getReviewers(query) {
            if (query && query.length > 3) {
                var filter = {
                    page: 0,
                    size: 10,
                    query: query,
                    facilityId: CoreService.getCurrentFacility().id,
                    businessRole: BUSINESS_ROLES.GROUP_SESSION_REVIWER
                };

                Employee.findAllByFilter(filter, function (result) {
                    vm.reviewers = result;
                });
            }
        }

        function getJoinDate(gsDate, timeDate) {
            return new Date(
                moment(gsDate).format('YYYY-MM-DD') + 'T' +
                moment(timeDate).format('HH:mm:00')
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionHistoryAuditController', GroupSessionHistoryAuditController);

    GroupSessionHistoryAuditController.$inject = ['GroupSessionDetails', '$uibModalInstance', '$timeout', 'groupSession'];

    function GroupSessionHistoryAuditController(GroupSessionDetails, $uibModalInstance, $timeout, groupSession) {
        var vm = this;
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.groupSessionsDetailsHistory = [];
        vm.groupSession = groupSession;

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        loadAll();

        function loadAll() {
            GroupSessionDetails.getHistory({
                id: groupSession.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.groupSessionsDetailsHistory = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('group-session', {
                parent: 'entity',
                url: '/group-session',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Sessions'
                },
                ncyBreadcrumb: {
                    label: 'Sessions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session/calendar/group-sessions.html',
                        controller: 'GroupSessionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filterRes: ['$stateParams', 'CoreService', function ($stateParams, CoreService) {
                        var filterCalendar = CoreService.getStorage('filterCalendar');

                        if (filterCalendar == undefined) {
                            return CoreService.initCalendarFilter();
                        } else {
                            return CoreService.readCalendarFilterFromLocalStore(filterCalendar);
                        }

                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_GROUP_SESSIONS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_GROUP_SESSIONS, access);
                }]
            })
            .state('group-session-edit', {
                parent: 'entity',
                url: '/group-session/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Sessions'
                },
                ncyBreadcrumb: {
                    label: 'Sessions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/group-session/edit/group-session-edit.html',
                        controller: 'GroupSessionEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'GroupSession', function($stateParams, GroupSession) {
                        return GroupSession.get({id : $stateParams.id}).$promise;
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_GROUP_SESSIONS, ACTIONS.ACTION_MASTER_EDIT_GROUP_SESSION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_GROUP_SESSIONS, access);
                }]
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionEditController', GroupSessionEditController);

    GroupSessionEditController.$inject = ['$uibModal', 'entity', 'GroupSession', 'SessionType', 'CoreService',
        'Employee', '$scope', '$state', 'GroupSessionDetails', 'Chart', 'Building', '$timeout',
        'PopupService', 'BUSINESS_ROLES', 'toastr', 'OdsFormService', '$rootScope', 'Assistant',
        'access', 'ACTIONS'];

    function GroupSessionEditController($uibModal, entity, GroupSession, SessionType, CoreService,
                                        Employee, $scope, $state, GroupSessionDetails, Chart, Building, $timeout,
                                        PopupService, BUSINESS_ROLES, toastr, OdsFormService, $rootScope, Assistant,
                                        access, ACTIONS) {
        var vm = this;

        vm.groupSession = entity;
        vm.employees = vm.groupSession.employees;
        vm.reviewers = [];
        vm.charts = [];
        vm.selectedCharts = [];
        vm.groupSessionDetails = [];
        vm.updates = {};
        vm.leaderSignature = null;
        vm.reviewerSignature = null;
        vm.allowSign = false;
        vm.allowReview = false;
        vm.watchers = [];

        vm.sessionTypes = SessionType.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.corporation = CoreService.getCorporation();
        vm.buildings = Building.byFacility({id: vm.groupSession.facilityId});
        vm.employee = CoreService.getCurrentEmployee();

        $rootScope.assistantList = Assistant.findAllBySection({
            section: 'GROUP_SESSION',
            facility: vm.groupSession.facilityId
        });
        $rootScope.showAssitant = true;
        vm.edit = access[ACTIONS.ACTION_MASTER_EDIT_GROUP_SESSION] ? access[ACTIONS.ACTION_MASTER_EDIT_GROUP_SESSION].roles.join() : null;

        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.getReviewers = getReviewers;
        vm.getCharts = getCharts;
        vm.addCharts = addCharts;
        vm.leaderSign = leaderSign;
        vm.reviewerSign = reviewerSign;
        vm.editSignature = editSignature;

        init();

        function init() {
            vm.employees = vm.groupSession.employees;
            if (vm.groupSession.reviewer) {
                vm.reviewers.push(vm.groupSession.reviewer);
            }

            vm.updates = {};
            vm.leaderSignature = null;
            vm.reviewerSignature = null;
            vm.allowSign = allowSign();
            vm.allowReview = allowReview();

            if (vm.groupSession && vm.groupSession.start) {
                vm.groupSession.start = moment(vm.groupSession.start).format('YYYY-MM-DDTHH:mm:00');
                vm.groupSession.start = moment(vm.groupSession.start).toDate();
            }

            if (vm.groupSession && vm.groupSession.stop) {
                vm.groupSession.stop = moment(vm.groupSession.stop).format('YYYY-MM-DDTHH:mm:00');
                vm.groupSession.stop = moment(vm.groupSession.stop).toDate();
            }

            if (vm.groupSession.leaderSignatureId) {
                initLeaderSignature();
            }

            if (vm.groupSession.reviewerSignatureId) {
                initReviewerSignature()
            }

            getGroupSessionDetail();
            getCharts();
        }

        function initLeaderSignature() {
            GroupSession.getSignature({id: vm.groupSession.id, type: 'STAFF'}, function (data) {
                vm.leaderSignature = data;
            });
        }

        function initReviewerSignature() {
            GroupSession.getSignature({id: vm.groupSession.id, type: 'REVIEW'}, function (data) {
                vm.reviewerSignature = data;
            });
        }

        function getGroupSessionDetail() {
            vm.groupSessionDetails = [];

            GroupSessionDetails.findAllByGroupSessionAndGroupSessionTemplate({id: vm.groupSession.id}, function (result) {
                vm.groupSessionDetails = result;
            });
        }

        function save() {
            vm.isSaving = true;
            if (vm.groupSession.id !== null) {
                GroupSession.update(vm.groupSession, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:groupSession', result);
            vm.isSaving = false;
            vm.groupSession = result;

            init();
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: vm.groupSession.facilityId};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getReviewers(query) {
            if (query && query.length > 3) {
                var filter = {
                    page: 0,
                    size: 10,
                    query: query,
                    facilityId: CoreService.getCurrentFacility().id,
                    businessRole: BUSINESS_ROLES.GROUP_SESSION_REVIWER
                };

                Employee.findAllByFilter(filter, function (result) {
                    vm.reviewers = result;
                });
            }
        }

        function getCharts() {
            vm.charts = [];
            // vm.selectedCharts = [];
            Chart.findAllNotInGroupSession({
                buildingId: vm.building ? vm.building.id : null,
                facilityId: vm.groupSession.facilityId,
                groupSessionId: vm.groupSession.id
            }, function (result) {
                vm.charts = result;
            })
        }

        function addCharts() {
            var charts = angular.copy(vm.selectedCharts);

            _.forEach(charts, function (chart) {
                GroupSessionDetails.addToGroupSession({
                    chart: chart,
                    groupSession: {id: vm.groupSession.id, start: vm.groupSession.start, stop: vm.groupSession.stop}
                }, function () {
                    getGroupSessionDetail();
                    vm.selectedCharts = [];
                })
            });
        }

        function leaderSign() {
            PopupService.showSignaturePopup().result.then(function (data) {
                GroupSession.leaderSign({
                    signature: data.employeeSignature,
                    pin: data.employeeSignaturePin,
                    id: vm.groupSession.id
                }, function (result) {
                    if (result) {
                        vm.groupSession = result;
                        init();
                    }
                }, function () {
                });
            });
        }

        function reviewerSign() {
            PopupService.showSignaturePopup().result.then(function (data) {
                GroupSession.reviewerSign({
                    signature: data.employeeSignature,
                    pin: data.employeeSignaturePin,
                    id: vm.groupSession.id
                }, function (result) {
                    if (result) {
                        vm.groupSession = result;
                        init();
                    }
                }, function () {
                });
            });
        }

        function allowSign() {

            return _.findIndex(vm.groupSession.employees, {'id': vm.employee.id}) >= 0;
        }

        function allowReview() {

            return vm.groupSession.reviewer && vm.groupSession.reviewer.id == vm.employee.id;
        }

        $scope.$on('$destroy', function () {
            _.forEach(vm.watchers, function (watcher) {
                if (watcher) {
                    watcher();
                }
            })
        });

        function editSignature(signature) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/edit-signature/evaluation-edit-signature.html',
                controller: 'EvaluationEditSignatureDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: signature
                }
            }).result.then(function (result) {
                GroupSession.masterSignature({groupSessionId: vm.groupSession.id, id: result.id, endDate: result.createdDate}, function (data) {
                    if (data) {
                        toastr.success("Signature date changed successful");

                        // init();
                        $state.reload();
                    }
                }, function () {
                    toastr.error("Failure to change the signature date");
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GroupSessionController', GroupSessionController);

    GroupSessionController.$inject = ['$uibModal', 'CoreService', 'Building', 'GroupSessionTemplate', '$state',
        'Employee', 'filterRes', 'access'];

    function GroupSessionController($uibModal, CoreService, Building, GroupSessionTemplate, $state,
                                    Employee, filterRes, access) {
        var vm = this;

        vm.filterRes = filterRes;
        vm.toggleSidebar = vm.filterRes.toggleSidebar;

        vm.title = 'Sessions';
        vm.building = null;
        vm.buildings = Building.byFacility({id: CoreService.getCurrentFacility().id});
        vm.corporation = CoreService.getCorporation();
        vm.eventSources = [];
        vm.employees = [];
        vm.employeesSelection = [];
        vm.employee = null;
        vm.groupSessionStatusesSelect = [];
        vm.groupSessionStatuses = [
            {value: 'STARTED', label: 'Started', nameClass: 'event-type started'},
            {value: 'PENDING', label: 'Pending', nameClass: 'event-type pending'},
            {value: 'REVIEW', label: 'Needs Review', nameClass: 'event-type needs-review'},
            {value: 'COMPLETE', label: 'Complete', nameClass: 'event-type complete'},
            {value: 'DISABLED', label: 'No longer Available', nameClass: 'event-type not-available'}
        ];

        vm.calendarConfig = {
            calendar: {
                defaultView: 'month',
                editable: false,
                selectable: true,
                contentHeight: 'auto',
                header: {
                    left: 'month,agendaWeek,agendaDay',
                    center: 'title',
                    right: 'today prevYear,prev,next,nextYear'
                },
                timeFormat: 'h:mm a',
                weekNumbers: true,
                defaultDate: vm.filterRes.end ? vm.filterRes.end - 1296000000 : new Date(),
                /*
                * - dayClick event --> https://fullcalendar.io/docs/v3/dayClick
                * - date : holds a Moment for the clicked day. If an all-day area has been clicked, the moment will be ambiguously-timed. If a slot in the agendaWeek or agendaDay views has been clicked, date will have the slot’s time.
                * - jsEvent : holds the jQuery event with low-level information such as click coordinates.
                * - view : is set to the current View Object.
                * - Viw Object --> https://fullcalendar.io/docs/v3/view-object
                * */
                // dayClick: function (date, jsEvent, view) {
                //     $uibModal.open({
                //         templateUrl: 'app/entities/group-sessions-v2/group-session-new-session-dialog.html',
                //         controller: 'GroupSessionNewSessionDialog',
                //         controllerAs: 'vm',
                //         size: 'lg',
                //         windowTopClass: 'custom-dialog-styles',
                //         resolve: {}
                //     }).result.then(function (result) {
                //
                //     }, function () {
                //
                //     });
                // },
                eventClick: eventClickCallback
            }
        };
        vm.access = access;

        vm.toggleSelection = toggleSelection;
        vm.toggleStatusSelection = toggleStatusSelection;
        vm.getEmployees = getEmployees;
        vm.addEmployee = addEmployee;
        vm.delEmployee = delEmployee;
        vm.reloadCalendar = reloadCalendar;
        vm.eventsF = eventsF;
        vm.checkedBuilding = checkedBuilding;
        vm.checkedStatus = checkedStatus;

        function addEmployee() {
            if (vm.employee != null) {
                vm.filterRes.employeesSelection.push(vm.employee);
            }

            vm.employee = null;
            vm.employees = null;

            reloadCalendar();
        }

        function delEmployee(employee) {
            var idx = vm.filterRes.employeesSelection.indexOf(employee);
            vm.filterRes.employeesSelection.splice(idx, 1);

            reloadCalendar();
        }

        function checkedBuilding(item) {
            var idx = vm.filterRes.buildingSelection.indexOf(item);
            if (idx > -1) {
                return true;
            } else {
                return false;
            }
        }

        function checkedStatus(item) {
            var idx = vm.filterRes.groupSessionStatusesSelect.indexOf(item);
            if (idx > -1) {
                return true;
            } else {
                return false;
            }
        }

        function toggleSelection(item) {
            var idx = vm.filterRes.buildingSelection.indexOf(item);
            if (idx > -1) {
                vm.filterRes.buildingSelection.splice(idx, 1);
            } else {
                vm.filterRes.buildingSelection.push(item);
            }

            reloadCalendar();
        }

        function toggleStatusSelection(item) {
            var idx = vm.filterRes.groupSessionStatusesSelect.indexOf(item);
            if (idx > -1) {
                vm.filterRes.groupSessionStatusesSelect.splice(idx, 1);
            } else {
                vm.filterRes.groupSessionStatusesSelect.push(item);
            }

            reloadCalendar();
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function reloadCalendar() {
            CoreService.setStorage('filterCalendar', vm.filterRes);
            $('#groupSessionsCalendar').fullCalendar('refetchEvents');
        }

        function eventsF(start, end, timezone, callback) {
            vm.filterRes.start = start;
            vm.filterRes.end = end;
            CoreService.setStorage('filterCalendar', vm.filterRes);

            GroupSessionTemplate.schedule({
                    start: start.toDate(),
                    end: end.toDate(),
                    facilityId: CoreService.getCurrentFacility().id,
                    buildings: vm.filterRes.buildingSelection ? vm.filterRes.buildingSelection : null,
                    employees: vm.filterRes.employeesSelection ? _.map(vm.filterRes.employeesSelection, 'id') : null,
                    searchQuery: vm.filterRes.searchQuery ? vm.filterRes.searchQuery : null,
                    groupSessionStatuses: vm.filterRes.groupSessionStatusesSelect ? vm.filterRes.groupSessionStatusesSelect : null
                },
                function (data) {
                    callback(data);
                });
        }

        vm.eventSources = [vm.eventsF];

        function eventClickCallback(calEvent, jsEvent, view) {
            if (calEvent.template) {
                // $state.go('group-session-init', {id: calEvent.template.id, startDate: calEvent.start._d});
                initGroupSession(calEvent.template.id, calEvent.start._d);
            } else if (calEvent.groupSession) {
                $state.go('group-session-edit', {id: calEvent.groupSession.id});
            }
            // if (calEvent.template) {
            //     $state.go('event-wizard', {groupSessionTemplate: calEvent.template.id, calEvent: calEvent});
            // }
            // if (calEvent.groupSession) {
            //     // if (calEvent.groupSession.status !== 'COMPLETE') {
            //     $state.go('event-wizard', {groupSession: calEvent.groupSession.id, calEvent: calEvent});
            //     // } else {
            //     //     $state.go('group-session-view', {groupSession: calEvent.groupSession.id});
            //     // }
            // }
        }

        function initGroupSession(templateId, startDate) {
            $uibModal.open({
                templateUrl: 'app/entities/group-session/init/group-session-init.html',
                controller: 'GroupSessionInitController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['GroupSessionTemplate', function (GroupSessionTemplate) {
                        return GroupSessionTemplate.get({id: templateId}).$promise;
                    }],
                    startDate: startDate
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GreetingDialogController', GreetingDialogController);

    GreetingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Greeting', 'Facility'];

    function GreetingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Greeting, Facility) {
        var vm = this;

        vm.greeting = entity;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.greeting.id !== null) {
                Greeting.update(vm.greeting, onSaveSuccess, onSaveError);
            } else {
                Greeting.save(vm.greeting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:greetingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Greeting', Greeting);

    Greeting.$inject = ['$resource'];

    function Greeting ($resource) {
        var resourceUrl =  'api/greetings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFilter': {url: 'api/greetings/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GreetingController', GreetingController);

    GreetingController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Greeting', '$q', '$uibModal',
        'toastr', 'ConfirmationService'];

    function GreetingController(GenericEntityDatatableService, CoreService, Greeting, $q, $uibModal,
                                toastr, ConfirmationService) {
        var vm = this;

        var params = {facilityId: CoreService.getCurrentFacility().id};

        vm.descriptor = {
            title: 'Greeting',
            newButtonTitle: 'New Greeting',
            entityClassHumanized: 'Greeting',
            entityStateName: 'greeting',
            service: Greeting,
            serviceMethod: 'byFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Greeting',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/greeting/update/greeting-dialog.html',
                controller: 'GreetingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/greeting/update/greeting-dialog.html',
                    controller: 'GreetingDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['Greeting', function (Greeting) {
                            return Greeting.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Greeting').result.then(function () {
                    Greeting.delete({id: id}, function () {
                        toastr.success('Greeting was deleted', 'Success');

                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('greeting', {
                parent: 'entity',
                url: '/greeting',
                data: {
                    authorities: [],
                    pageTitle: 'Greetings'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/greeting/list/greeting.html',
                        controller: 'GreetingController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlucoseInterventionDialogController', GlucoseInterventionDialogController);

    GlucoseInterventionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GlucoseIntervention'];

    function GlucoseInterventionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GlucoseIntervention) {
        var vm = this;

        vm.glucoseIntervention = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.glucoseIntervention.id !== null) {
                GlucoseIntervention.update(vm.glucoseIntervention, onSaveSuccess, onSaveError);
            } else {
                GlucoseIntervention.save(vm.glucoseIntervention, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:glucoseInterventionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GlucoseIntervention', GlucoseIntervention);

    GlucoseIntervention.$inject = ['$resource'];

    function GlucoseIntervention ($resource) {
        var resourceUrl =  'api/glucose-interventions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/glucose-interventions/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlucoseInterventionController', GlucoseInterventionController);

    GlucoseInterventionController.$inject = ['GenericEntityDatatableService', 'CoreService', 'GlucoseIntervention',
        '$uibModal', 'ConfirmationService', '$q'];

    function GlucoseInterventionController(GenericEntityDatatableService, CoreService, GlucoseIntervention,
                                           $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Glucose Intervention',
            newButtonTitle: 'New Glucose Intervention',
            entityClassHumanized: 'Glucose Intervention',
            entityStateName: 'glucose-intervention',
            service: GlucoseIntervention,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Glucose Intervention',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/glucose-intervention/update/glucose-intervention-dialog.html',
                controller: 'GlucoseInterventionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/glucose-intervention/update/glucose-intervention-dialog.html',
                controller: 'GlucoseInterventionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['GlucoseIntervention', function (GlucoseIntervention) {
                        return GlucoseIntervention.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Glucose Intervention').result.then(function () {
                    GlucoseIntervention.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('glucose-intervention', {
                parent: 'entity',
                url: '/glucose-intervention',
                data: {
                    authorities: [],
                    pageTitle: 'GlucoseInterventions'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/glucose-intervention/list/glucose-interventions.html',
                        controller: 'GlucoseInterventionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlucoseDialogController', GlucoseDialogController);

    GlucoseDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Glucose',
        'GlucoseIntervention', 'TypeCheck', 'CoreService'];

    function GlucoseDialogController ($timeout, $scope, $uibModalInstance, entity, Glucose,
                                      GlucoseIntervention, TypeCheck, CoreService) {
        var vm = this;

        vm.glucose = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.glucoseinterventions = GlucoseIntervention.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.corporation = CoreService.getCorporation();
        vm.typeCheck = TypeCheck.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.glucose.id !== null) {
                Glucose.update(vm.glucose, onSaveSuccess, onSaveError);
            } else {
                Glucose.save(vm.glucose, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:glucoseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Glucose', Glucose);

    Glucose.$inject = ['$resource', 'DateUtils', 'CoreService'];

    function Glucose($resource, DateUtils, CoreService) {
        var resourceUrl = 'api/glucoses/:id';
        var facility = CoreService.getCurrentFacility();

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        data.date = new Date(DateUtils.convertDateTimeFromServer(data.date)
                            .toLocaleString("en-US", {timeZone: facility.timeZone}));
                    }
                    return data;
                }
            },
            'findAllByChart': {url: 'api/glucoses/by-chart/:id', method: 'GET', isArray: true},
            'update': {method: 'PUT'},
            'findLastByChart': {
                url: 'api/glucoses/last/by-chart/:id', method: 'GET', transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        data.date = new Date(DateUtils.convertDateTimeFromServer(data.date)
                            .toLocaleString("en-US", {timeZone: facility.timeZone}));
                    }

                    return data;
                }
            },
            'findAllByChartPageable': {url: 'api/glucoses/last/by-chart/:id/size/:size', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlucoseHistoryController', GlucoseHistoryController);

    GlucoseHistoryController.$inject = ['$compile', '$scope', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', '$filter',
        '$uibModalInstance', 'chart', 'Glucose', '$rootScope', '$uibModal', 'ConfirmationService',
        '$uibModalStack'];

    function GlucoseHistoryController($compile, $scope, $q, DTColumnBuilder, DTOptionsBuilder, $filter,
                                      $uibModalInstance, chart, Glucose, $rootScope, $uibModal, ConfirmationService,
                                      $uibModalStack) {
        var vm = this;

        vm.glucoses = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.chart = chart;

        vm.search = search;
        vm.edit = edit;
        vm.del = del;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Glucose.findAllByChart(
                {
                    id: vm.chart.id,
                    page: vm.page - 1,
                    size: vm.itemsPerPage
                }, function (result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.glucoses = result;
                    defer.resolve(vm.glucoses);
                });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notVisible().renderWith(function (data, type, full) {
                return data ? moment(data.date).format("YYYYMMDD") : "";
            }),
            DTColumnBuilder.newColumn('date').withTitle('Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn('reading').withTitle('Reading'),
            DTColumnBuilder.newColumn(null).withTitle('Type of Check').renderWith(function (data, type, full) {
                return data.typeCheck ? data.typeCheck.name : '-';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Interventions').renderWith(function (data, type, full) {
                return data.glucoseInterventions ? _.map(data.glucoseInterventions, 'name').join(', ') : '-';
            }),
            DTColumnBuilder.newColumn('notes').withTitle('Notes').withOption('width', '250px'),
            DTColumnBuilder.newColumn('createdBy').withTitle('Created By'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        }


        function search() {
            vm.dtInstance.reloadData();
        }

        function edit(id) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/glucose/update/glucose-dialog.html',
                controller: 'GlucoseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['Glucose', function (Glucose) {
                        return Glucose.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Glucose').result.then(function () {
                Glucose.delete({id: id}, function () {
                    search();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlucoseChartController', GlucoseChartController);

    GlucoseChartController.$inject = ['chart', 'Glucose', 'CoreService', '$uibModal', 'PopupService', '$scope',
        '$rootScope', 'access', 'ACTIONS', 'Auth'];

    function GlucoseChartController(chart, Glucose, CoreService, $uibModal, PopupService, $scope,
                                    $rootScope, access, ACTIONS, Auth) {
        var vm = this;
        vm.chart = chart;

        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.history = history;

        vm.dataGlu = [{
            values: [],
            key: 'Glucose',
            color: '#ffffff'
        }];

        vm.optionsGlu = {
            chart: {
                type: 'lineChart',
                showLegend: false,
                height: 340,
                margin: {
                    top: 20,
                    right: 50,
                    bottom: 100,
                    left: 50
                },
                x: function (d) {
                    return d.x;
                },
                y: function (d) {
                    return d.y;
                },
                useInteractiveGuideline: true,
                xAxis: {
                    tickFormat: function (d) {
                        return d3.time.format('%m/%d/%y-%H:%M')(new Date(d));
                    },
                    showMaxMin: false,
                    rotateLabels: (-70)
                },
                yAxis: {
                    tickFormat: function (d) {
                        return d3.format('.02f')(d);
                    },
                    showMaxMin: false,
                }
            }
        };

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW, access)) {
                return;
            }

            Glucose.findLastByChart({id: chart.id}, function (results) {
                vm.glucose = results;
                vm.glucoseInterventions = _.map(results.glucoseInterventions, function (glucoseIntervention) {
                    return glucoseIntervention.name;
                }).join(',');
            });

            Glucose.findAllByChartPageable({id: chart.id, size: 10}, function (data) {
                for (var i = data.length - 1; i >= 0; i--) {
                    vm.dataGlu[0].values.push({x: new Date(data[i].date).getTime(), y: parseFloat(data[i].reading)});
                }
            });
        }

        function toggleItem() {
            CoreService.togglePanel('glucose');
        }

        function add() {
            PopupService.showGlucosePopup(chart).result.then(function () {
                loadAll();
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/glucose/history/glucose-history.html',
                controller: 'GlucoseHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartGlucoseHistory', function (event, result) {
            history();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GlobalMessageViewed', GlobalMessageViewed);

    GlobalMessageViewed.$inject = ['$resource'];

    function GlobalMessageViewed ($resource) {
        var resourceUrl =  'api/global-message-vieweds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlobalMessageDialogController', GlobalMessageDialogController);

    GlobalMessageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'GlobalMessage', 'Employee', 'Corporation'];

    function GlobalMessageDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                           GlobalMessage, Employee, Corporation) {
        var vm = this;

        vm.globalMessage = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.corporations = Corporation.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.globalMessage.id !== null) {
                GlobalMessage.update(vm.globalMessage, onSaveSuccess, onSaveError);
            } else {
                GlobalMessage.save(vm.globalMessage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:globalMessageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GlobalMessage', GlobalMessage);

    GlobalMessage.$inject = ['$resource', 'DateUtils'];

    function GlobalMessage($resource, DateUtils) {
        var resourceUrl = 'api/global-messages/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'byCorporation': {url: 'api/global-messages/by-corporation/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlobalMessageNotificationController', GlobalMessageNotificationController);

    GlobalMessageNotificationController.$inject = ['GlobalMessage', 'GlobalMessageViewed', 'CoreService', '$interval',
        'Principal'];

    function GlobalMessageNotificationController(GlobalMessage, GlobalMessageViewed, CoreService, $interval,
                                                 Principal) {
        var vm = this;

        vm.globalMessages = [];
        vm.close = close;
        vm.init = init;

        Principal.identity().then(function (account) {
            $interval(init, 30000);
        });

        function init() {
            var corporation = CoreService.getCorporation();

            if (corporation) {
                GlobalMessage.byCorporation({id: corporation.id}, function (result) {
                    vm.globalMessages = result;
                })
            }
        }

        function close(id) {
            GlobalMessageViewed.save({globalMessage: {id: id}}, function () {
                init();
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlobalMessageController', GlobalMessageController);

    GlobalMessageController.$inject = ['$scope', '$state', 'GlobalMessage', 'GenericEntityDatatableService',
        '$uibModal', 'CoreService', 'ConfirmationService', '$q', 'GUIUtils', '$rootScope'];

    function GlobalMessageController($scope, $state, GlobalMessage, GenericEntityDatatableService,
                                     $uibModal, CoreService, ConfirmationService, $q, GUIUtils, $rootScope) {
        var vm = this;

        vm.descriptor = {
            title: 'Global Message',
            newButtonTitle: 'New Global Message',
            entityClassHumanized: 'GlobalMessage',
            entityStateName: 'global-message',
            service: GlobalMessage,
            serviceMethod: 'query',
            params: {
                active: true
            },
            newAction: false,
            columns: [
                {
                    name: "id",
                    title: "Id"
                },
                {
                    name: 'title',
                    title: 'Title',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    name: 'comment',
                    title: 'Comment',
                },
                {
                    title: 'Priority',
                    render: function (data) {
                        return "<div class=\'alert alert-" + data.priority.toLowerCase() + "\'></div>";
                    }
                },
                {
                    name: 'startDate',
                    title: 'Start Date',
                    render: function (data) {
                        return data.startDate ? moment(data.startDate).format($rootScope.amDateFormat) : '-';
                    }
                },
                {
                    name: 'endDate',
                    title: 'End Date',
                    render: function (data) {
                        return data.endDate ? moment(data.endDate).format($rootScope.amDateFormat) : '-';
                    }
                },
                {
                    name: null,
                    title: 'Active',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.active);
                    }
                },
                {
                    name: null,
                    title: 'Closeable',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.closeable);
                    }
                },
                {
                    name: 'employee',
                    title: 'Employee',
                    render: function (data) {
                        return data.employee === null ? " " : data.employee.lastName + ", " + data.employee.firstName;
                    }
                },
                {
                    name: 'corporation',
                    title: 'Corporation',
                    render: function (data) {
                        return data.corporation === null ? " " : data.corporation.name;
                    }
                },
                {
                    name: 'createdDate',
                    title: 'Created Date',
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.amDateFormat) : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('global-message'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('global-message'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Global Message',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'startDate',
                    placeholder: 'Start Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.startDate ? moment(filter.startDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: 'endDate',
                    placeholder: 'End Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.endDate ? moment(filter.endDate).format("YYYY-MM-DD") : null;
                    },
                    visible: true
                },
                {
                    name: "active",
                    values: ['ACTIVE', 'INACTIVE'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    read: function (filter) {
                        switch (filter.active) {
                            case 'ACTIVE':
                                return true;
                            case 'INACTIVE':
                                return false;
                            default:
                                return null;
                        }
                    },
                    defaultValue: function () {
                        return 'ACTIVE';
                    },
                    placeholder: 'Status...',
                    type: 'select',
                    visible: true,
                },
            ]
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/global-message/update/global-message-dialog.html',
                controller: 'GlobalMessageDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            title: null,
                            description: null,
                            comment: null,
                            startDate: null,
                            endDate: null,
                            attachment: null,
                            priority: null,
                            id: null,
                            active: true,
                            closeable: true
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/global-message/update/global-message-dialog.html',
                controller: 'GlobalMessageDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['GlobalMessage', function (GlobalMessage) {
                        return GlobalMessage.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Global Message').result.then(function () {
                    GlobalMessage.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('global-message', {
                parent: 'entity',
                url: '/global-message',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'GlobalMessages'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/global-message/list/global-messages.html',
                        controller: 'GlobalMessageController',
                        controllerAs: 'vm'
                    }
                },
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FaxNumber', FaxNumber);

    FaxNumber.$inject = ['$resource'];

    function FaxNumber ($resource) {
        var resourceUrl =  'api/fax-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFilter': {url: 'api/fax-numbers/filter', method: 'GET', isArray: true},
            'orderFaxNumbers': {url: 'api/fax-numbers/order-fax-numbers', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FaxNumberDialogController', FaxNumberDialogController);

    FaxNumberDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'FacilityPhoneNumber', 'FaxNumber', 'DTColumnBuilder', 'DTOptionsBuilder', '$q',
        'CountryState', 'DataTablesService', '$compile'];

    function FaxNumberDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                       FacilityPhoneNumber, FaxNumber, DTColumnBuilder, DTOptionsBuilder, $q,
                                       CountryState, DataTablesService, $compile) {
        var vm = this;

        vm.dtInstance = {};
        vm.faxNumber = {};
        vm.phoneNumbers = [];
        vm.countryState = CountryState.query();
        vm.selected = {};
        vm.selectAll = false;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.setUniqueIds = DataTablesService.setUniqueIds;

        vm.clear = clear;
        vm.orderPhoneNumber = orderPhoneNumber;
        vm.getAvailablePhoneNumbers = getAvailablePhoneNumbers;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function orderPhoneNumber() {
            vm.isSaving = true;

            var ids = _.map(vm.getSelectedIds(vm.selected), function (id) {
                return parseInt(id);
            });

            var phoneNumbers =
                _.map(
                    _.filter(vm.phoneNumbers, function (faxNumber) {
                        return ids.indexOf(faxNumber.id) != -1;
                    }), function (faxNumber) {
                        return faxNumber.phoneNumber;
                    });

            FaxNumber.orderFaxNumbers(getFilterOrderNumber(phoneNumbers), function () {
                $uibModalInstance.close();
            }, function () {
                vm.isSaving = false;
            });
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            defer.resolve(vm.phoneNumbers);
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        })
            .withDisplayLength(5)
            .withOption('lengthMenu', [[5, 15, 25, 50, -1], [5, 15, 25, 50, "All"]])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });


        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("").withOption('width', '25px').notSortable()
                .renderWith(function (data, type, full, meta) {
                    vm.selected[full.id] = false;

                    return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
                }),
            DTColumnBuilder.newColumn(null).withTitle('Phone Number').renderWith(function (data, type, full) {
                return data.phoneNumber;
            }),
            DTColumnBuilder.newColumn(null).withTitle('State').renderWith(function (data, type, full) {
                return data.region ? data.region : "-";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Postal Code').renderWith(function (data, type, full) {
                return data.postalCode ? data.postalCode : "-";
            }),
        ];

        function getFilter() {
            var filter = {};

            filter.pattern = vm.faxNumber.pattern;
            filter.areaCode = vm.faxNumber.areaCode;
            filter.state = vm.faxNumber.state;

            return filter
        }

        function getFilterOrderNumber(phoneNumbers) {
            var filter = {};

            filter.phoneNumbers = phoneNumbers;

            return filter
        }

        function getAvailablePhoneNumbers() {
            FacilityPhoneNumber.getAvailablePhoneNumbers(getFilter(), function (result) {
                vm.phoneNumbers = vm.setUniqueIds(result);
                transition();
            });
        }

        function transition() {
            vm.dtInstance.reloadData();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FaxNumberController', FaxNumberController);

    FaxNumberController.$inject = ['GenericEntityDatatableService', 'FaxNumber', '$q', '$uibModal',
        'ConfirmationService'];

    function FaxNumberController(GenericEntityDatatableService, FaxNumber, $q, $uibModal,
                                 ConfirmationService) {
        var vm = this;

        vm.descriptor = {
            title: 'FaxNumber',
            entityClassHumanized: 'FaxNumber',
            entityStateName: 'fax-number',
            service: FaxNumber,
            serviceMethod: 'byFilter',
            newAction: false,
            params: {},
            pagination: 'remote',
            columns: [
                {
                    name: 'phoneNumber',
                    title: 'Phone Number',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'Order Fax Number',
                            action: function () {
                                return order();
                            }
                        }),
                    ],
                },
            ],
        }

        function order() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/fax-number/order/fax-number-dialog.html',
                    controller: 'FaxNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {}
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Fax Number').result.then(function () {
                    FaxNumber.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('fax-number', {
                parent: 'entity',
                url: '/fax-number',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FaxNumbers'
                },
                ncyBreadcrumb: {
                    label: 'Facility Phone Numbers',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/fax-number/list/fax-number.html',
                        controller: 'FaxNumberController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityPhoneNumber', FacilityPhoneNumber);

    FacilityPhoneNumber.$inject = ['$resource'];

    function FacilityPhoneNumber ($resource) {
        var resourceUrl =  'api/facility-phone-numbers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFilter': {url: 'api/facility-phone-numbers/filter', method: 'GET', isArray: true},
            'getAvailablePhoneNumbers': {url: 'api/facility-phone-numbers/phone-numbers/filter', method: 'GET', isArray: true},
            'orderPhoneNumbers': {url: 'api/facility-phone-numbers/order-phone-numbers', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityPhoneNumberDialogController', FacilityPhoneNumberDialogController);

    FacilityPhoneNumberDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'FacilityPhoneNumber', 'DTColumnBuilder', 'DTOptionsBuilder', '$q',
        'CountryState', 'DataTablesService', '$compile',
        'CoreService'];

    function FacilityPhoneNumberDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                                 FacilityPhoneNumber, DTColumnBuilder, DTOptionsBuilder, $q,
                                                 CountryState, DataTablesService, $compile, CoreService) {
        var vm = this;

        vm.dtInstance = {};
        vm.phoneNumber = {};
        vm.facilityPhoneNumbers = [];
        vm.countryState = CountryState.query();
        vm.selected = {};
        vm.selectAll = false;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.setUniqueIds = DataTablesService.setUniqueIds;

        vm.clear = clear;
        vm.orderPhoneNumber = orderPhoneNumber;
        vm.getAvailablePhoneNumbers = getAvailablePhoneNumbers;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function orderPhoneNumber() {
            vm.isSaving = true;

            var ids = _.map(vm.getSelectedIds(vm.selected), function (id) {
                    return parseInt(id);
            });

            var phoneNumbers =
                _.map(
                    _.filter(vm.facilityPhoneNumbers, function (facilityPhoneNumber) {
                        return ids.indexOf(facilityPhoneNumber.id) != -1;
                    }), function (facilityPhoneNumber) {
                        return facilityPhoneNumber.phoneNumber;
                    });

            FacilityPhoneNumber.orderPhoneNumbers(getFilterOrderNumber(phoneNumbers), function () {
                $uibModalInstance.close();
            }, function () {
                vm.isSaving = false;
            });
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            defer.resolve(vm.facilityPhoneNumbers);
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        })
            .withDisplayLength(5)
            .withOption('lengthMenu', [[5, 15, 25, 50, -1], [5, 15, 25, 50, "All"]])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });


        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle("").withOption('width', '25px').notSortable()
                .renderWith(function (data, type, full, meta) {
                    vm.selected[full.id] = false;

                    return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
                }),
            DTColumnBuilder.newColumn(null).withTitle('Phone Number').renderWith(function (data, type, full) {
                return data.phoneNumber;
            }),
            DTColumnBuilder.newColumn(null).withTitle('State').renderWith(function (data, type, full) {
                return data.region ? data.region : "-";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Postal Code').renderWith(function (data, type, full) {
                return data.postalCode ? data.postalCode : "-";
            }),
        ];

        function getFilter() {
            var filter = {};

            filter.pattern = vm.phoneNumber.pattern;
            filter.areaCode = vm.phoneNumber.areaCode;
            filter.state = vm.phoneNumber.state;

            return filter
        }

        function getFilterOrderNumber(phoneNumbers) {
            var filter = {};

            filter.phoneNumbers = phoneNumbers;
            filter.facilityId = CoreService.getCurrentFacility().id;

            return filter
        }

        function getAvailablePhoneNumbers() {
            FacilityPhoneNumber.getAvailablePhoneNumbers(getFilter(), function (result) {
                vm.facilityPhoneNumbers = vm.setUniqueIds(result);
                transition();
            });
        }

        function transition() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityPhoneNumberController', FacilityPhoneNumberController);

    FacilityPhoneNumberController.$inject = ['GenericEntityDatatableService', 'CoreService', 'FacilityPhoneNumber',
        '$uibModal', '$q', 'toastr', 'ConfirmationService'];

    function FacilityPhoneNumberController(GenericEntityDatatableService, CoreService, FacilityPhoneNumber,
                                           $uibModal, $q, toastr, ConfirmationService) {
        var vm = this;

        var params = {facilityId: CoreService.getCurrentFacility().id};

        vm.descriptor = {
            title: 'Facility Phone Numbers',
            newAction: false,
            entityClassHumanized: 'Facility Phone Numbers',
            entityStateName: 'facility-phone-number',
            service: FacilityPhoneNumber,
            serviceMethod: 'byFilter',
            params: params,
            pagination: 'remote',
            columns: [
                {
                    name: 'phoneNumber',
                    title: 'Phone Number',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'Order Phone Number',
                            action: function () {
                                return order();
                            }
                        })
                    ]
                },
            ]
        }

        function order() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility-phone-number/order/facility-phone-number-dialog.html',
                    controller: 'FacilityPhoneNumberDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {}
                }).result.then(function () {
                    toastr.success('Phone Number was saved', 'Success');

                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Phone Number').result.then(function () {
                    FacilityPhoneNumber.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility-phone-number', {
                parent: 'entity',
                url: '/facility-phone-number',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FacilityPhoneNumbers'
                },
                ncyBreadcrumb: {
                    label: 'Facility Phone Numbers',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility-phone-number/list/facility-phone-number.html',
                        controller: 'FacilityPhoneNumberController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityPharmacyDialogController', FacilityPharmacyDialogController);

    FacilityPharmacyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacilityPharmacy', 'Pharmacy'];

    function FacilityPharmacyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacilityPharmacy, Pharmacy) {
        var vm = this;

        vm.facilityPharmacy = entity;
        vm.pharmacy = vm.facilityPharmacy.id == null ? getPharmacy() : [vm.facilityPharmacy.pharmacy];

        vm.clear = clear;
        vm.save = save;
        vm.getPharmacy = getPharmacy;


        function getPharmacy(query) {
            if (query && query.length > 2) {
                Pharmacy.findAllByFilter({searchQuery: query}, function (result) {
                    vm.pharmacy = result;
                });
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityPharmacy.id !== null) {
                FacilityPharmacy.update(vm.facilityPharmacy, onSaveSuccess, onSaveError);
            } else {
                FacilityPharmacy.save(vm.facilityPharmacy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityPharmacyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityPharmacy', FacilityPharmacy);

    FacilityPharmacy.$inject = ['$resource'];

    function FacilityPharmacy ($resource) {
        var resourceUrl =  'api/facility-pharmacy/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/facility-pharmacy/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityPharmacyController', FacilityPharmacyController);

    FacilityPharmacyController.$inject = ['FacilityPharmacy', 'CoreService', 'GenericEntityDatatableService', '$uibModal',
        'ConfirmationService', '$q'];

    function FacilityPharmacyController(FacilityPharmacy, CoreService, GenericEntityDatatableService, $uibModal,
                                     ConfirmationService, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'facility-pharmacy'

        vm.descriptor = {
            title: 'Facility Pharmacy',
            entityClassHumanized: 'Facility Pharmacy',
            newButtonTitle: 'Add Pharmacy',
            entityStateName: entityStateName,
            service: FacilityPharmacy,
            serviceMethod: 'findAllByFilter',
            params: params,
            newAction: false,
            columns: [
                {
                    title: 'Name',
                    render: function (data) {
                        return data.pharmacy.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Pharmacy',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-pharmacy/update/facility-pharmacy-dialog.html',
                controller: 'FacilityPharmacyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            pharmacy: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Facility Pharmacy').result.then(function () {
                    FacilityPharmacy.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('facility-pharmacy', {
            parent: 'entity',
            url: '/facility-pharmacy',
            data: {
                authorities: [],
                pageTitle: 'FacilityPharmacy'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/facility-pharmacy/list/facility-pharmacy.html',
                    controller: 'FacilityPharmacyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY, access);
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityLabDialogController', FacilityLabDialogController);

    FacilityLabDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'FacilityLab'];

    function FacilityLabDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                          FacilityLab) {
        var vm = this;

        vm.facilityLab = entity;
        vm.laboratories = [entity.laboratory];
        vm.employess = [entity.laboratory];
        vm.requestedBy = [entity.requestedBy];
        vm.accountExist = null;
        vm.hl7Versions = ['v2_3', 'v2_7'];

        vm.pattern = "[a-zA-Z0-9_\-]+";

        vm.clear = clear;
        vm.save = save;
        vm.searchAccount = searchAccount;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityLab.id !== null) {
                FacilityLab.update(vm.facilityLab, onSaveSuccess, onSaveError);
            } else {
                FacilityLab.save(vm.facilityLab, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityLabUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function searchAccount(query) {
            if (query && query.length > 0) {
                FacilityLab.existAccount({account: query, laboratoryId: entity.laboratory.id}, function (result) {
                    vm.accountExist = result.value != null && result.value !== vm.facilityLab.id;
                });
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityLab', FacilityLab);

    FacilityLab.$inject = ['$resource'];

    function FacilityLab($resource) {
        var resourceUrl = 'api/facility-labs/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'create': {method: 'POST', isArray: true},
            'filter': {url: 'api/facility-labs/filter', method: 'GET', isArray: true},
            'existAccount': {
                url: 'api/facility-labs/exist-account/:account/:laboratoryId', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data = {value: data};
                    }

                    return data;
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SelectFacilityLabDialogController', SelectFacilityLabDialogController);

    SelectFacilityLabDialogController.$inject = ['$uibModalInstance', 'DTOptionsBuilder', 'DTColumnBuilder', '$q',
        '$compile', '$scope', 'CoreService', 'FacilityLab', 'GUIUtils'];

    function SelectFacilityLabDialogController($uibModalInstance, DTOptionsBuilder, DTColumnBuilder, $q,
                                              $compile, $scope, CoreService, FacilityLab, GUIUtils) {
        var vm = this;

        vm.laboratory = null;
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.checkLaboratory = checkLaboratory;
        vm.selectLaboratory = selectLaboratory;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            FacilityLab.filter({
                page: 0,
                size: 100000,
                facilityId: CoreService.getCurrentFacility().id
            }, function (facilityLabs) {
                vm.laboratories = facilityLabs;

                defer.resolve(vm.laboratories);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function (data, type, full, meta) {
                return '<input type="radio" name="laboratory" ng-click="vm.checkLaboratory(' + data.id + ')">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Name').notSortable(),
            DTColumnBuilder.newColumn('account').withTitle('Account').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('Enabled').notSortable().renderWith(function (data, type, full, meta) {
                return GUIUtils.colorHtmlYesNo(data.enabled);
            }),
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            vm.laboratory = null;

            transition();
        }

        function transition() {
            vm.dtInstance.reloadData();
        }

        function checkLaboratory(id) {
            vm.laboratory = _.find(vm.laboratories, {id: id})
        }

        function selectLaboratory() {
            $uibModalInstance.close(vm.laboratory);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityLabController', FacilityLabController);

    FacilityLabController.$inject = ['FacilityLab', 'GUIUtils', 'CoreService', 'GenericEntityDatatableService',
        'ConfirmationService', '$q', '$uibModal'];

    function FacilityLabController (FacilityLab, GUIUtils, CoreService, GenericEntityDatatableService,
                                    ConfirmationService, $q, $uibModal) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'facility-lab'

        vm.descriptor = {
            title: 'Lab Integration',
            entityClassHumanized: 'Request',
            entityStateName: entityStateName,
            service: FacilityLab,
            serviceMethod: 'filter',
            params: params,
            newButtonTitle: 'Request',
            pagination: 'remote',
            options: [{key: 'order', value: [[1, 'asc']]}],
            newAction: false,
            columns: [
                {
                    name: 'account',
                    title: 'Account'
                },
                {
                    name: 'hl7Version',
                    title: 'HL7 Version'
                },
                {
                    name: 'statement',
                    title: 'Statement'
                },
                {
                    name: 'enabled',
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enabled);
                    }
                },
                {
                    name: 'name',
                    title: 'Laboratory'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Request',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-lab/create/facility-lab-new-dialog.html',
                controller: 'FacilityLabNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-lab/update/facility-lab-dialog.html',
                controller: 'FacilityLabDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['FacilityLab', function (FacilityLab) {
                        return FacilityLab.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Lab Integration').result.then(function () {
                    FacilityLab.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility-lab', {
                parent: 'entity',
                url: '/facility-lab',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FacilityLabs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility-lab/list/facility-lab.html',
                        controller: 'FacilityLabController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityLabNewDialogController', FacilityLabNewDialogController);

    FacilityLabNewDialogController.$inject = ['$scope', '$uibModalInstance', 'FacilityLab', 'Facility', 'Laboratory',
        'CoreService'];

    function FacilityLabNewDialogController($scope, $uibModalInstance, FacilityLab, Facility, Laboratory,
                                            CoreService) {
        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        vm.laboratories = Laboratory.findAllWithoutRequestByFacility({
            id: vm.facility.id
        });
        vm.laboratoriesSelected = [];

        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            FacilityLab.create({
                laboratories: vm.laboratoriesSelected,
                facility: {id: vm.facility.id}
            }, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:facilityLabUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityIcd10DialogController', FacilityIcd10DialogController);

    FacilityIcd10DialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacilityIcd10', 'Icd10Search'];

    function FacilityIcd10DialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacilityIcd10, Icd10Search) {
        var vm = this;

        vm.facilityIcd10 = entity;
        vm.icd10 = vm.facilityIcd10.id == null ? getIcd10() : [vm.facilityIcd10.icd10];

        vm.clear = clear;
        vm.save = save;
        vm.getIcd10 = getIcd10;


        function getIcd10(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityIcd10.id !== null) {
                FacilityIcd10.update(vm.facilityIcd10, onSaveSuccess, onSaveError);
            } else {
                FacilityIcd10.save(vm.facilityIcd10, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityIcd10Update', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityIcd10', FacilityIcd10);

    FacilityIcd10.$inject = ['$resource'];

    function FacilityIcd10 ($resource) {
        var resourceUrl =  'api/facility-icd-10-s/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/facility-icd-10-s/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityIcd10Controller', FacilityIcd10Controller);

    FacilityIcd10Controller.$inject = ['FacilityIcd10', 'CoreService', 'GenericEntityDatatableService', '$uibModal',
        'ConfirmationService', '$q'];

    function FacilityIcd10Controller(FacilityIcd10, CoreService, GenericEntityDatatableService, $uibModal,
                                     ConfirmationService, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'facility-icd-10'

        vm.descriptor = {
            title: 'Facility Icd10s',
            entityClassHumanized: 'Facility Icd10s',
            newButtonTitle: 'Add Icd10',
            entityStateName: entityStateName,
            service: FacilityIcd10,
            serviceMethod: 'findAllByFilter',
            params: params,
            newAction: false,
            columns: [
                {
                    title: 'Name',
                    render: function (data) {
                        return data.icd10.code;
                    }
                },
                {
                    title: 'Description',
                    render: function (data) {
                        return data.icd10.description;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Icd10',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-icd-10/update/facility-icd-10-dialog.html',
                controller: 'FacilityIcd10DialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            icd10: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-icd-10/update/facility-icd-10-dialog.html',
                controller: 'FacilityIcd10DialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['FacilityIcd10', function (FacilityIcd10) {
                        return FacilityIcd10.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Facility Icd10').result.then(function () {
                    FacilityIcd10.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('facility-icd-10', {
            parent: 'entity',
            url: '/facility-icd-10',
            data: {
                authorities: [],
                pageTitle: 'FacilityIcd10S'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/facility-icd-10/list/facility-icd-10.html',
                    controller: 'FacilityIcd10Controller',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_ICD10];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_FACILITY_ICD10, access);
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityBillingConfigDialogController', FacilityBillingConfigDialogController);

    FacilityBillingConfigDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacilityBillingConfig', 'Facility'];

    function FacilityBillingConfigDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacilityBillingConfig, Facility) {
        var vm = this;

        vm.facilityBillingConfig = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facilities = Facility.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityBillingConfig.id !== null) {
                FacilityBillingConfig.update(vm.facilityBillingConfig, onSaveSuccess, onSaveError);
            } else {
                FacilityBillingConfig.save(vm.facilityBillingConfig, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityBillingConfigUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityBillingConfig', FacilityBillingConfig);

    FacilityBillingConfig.$inject = ['$resource'];

    function FacilityBillingConfig ($resource) {
        var resourceUrl =  'api/facility-billing-configs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFacility': {url: 'api/facility-billing-configs', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityBillingConfigController', FacilityBillingConfigController);

    FacilityBillingConfigController.$inject = ['$scope', '$state', 'FacilityBillingConfig', '$compile',
        'DTOptionsBuilder', 'DTColumnBuilder', '$q', 'CoreService', '$uibModal',
        'GenericEntityDatatableService', 'ConfirmationService'];

    function FacilityBillingConfigController($scope, $state, FacilityBillingConfig, $compile,
                                             DTOptionsBuilder, DTColumnBuilder, $q, CoreService, $uibModal,
                                             GenericEntityDatatableService, ConfirmationService) {
        var vm = this;

        vm.totalItems = 0;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Facility Billing Config',
            entityClassHumanized: 'Facility Billing Config',
            entityStateName: 'facility-billing-config',
            service: FacilityBillingConfig,
            serviceMethod: 'getAllByFacility',
            newAction: false,
            params: params,
            enableSearch: false,
            columns: [
                {
                    name: null,
                    title: 'Price',
                    render: function (data) {
                        return '$ ' + data.price;
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Config',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0
                            }
                        }),
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-billing-config/update/facility-billing-config-dialog.html',
                controller: 'FacilityBillingConfigDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            price: 0,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-billing-config/update/facility-billing-config-dialog.html',
                controller: 'FacilityBillingConfigDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['FacilityBillingConfig', function (FacilityBillingConfig) {
                        return FacilityBillingConfig.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Facility Billing Config').result.then(function () {
                    FacilityBillingConfig.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility-billing-config', {
                parent: 'entity',
                url: '/facility-billing-config',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FacilityBillingConfigs'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility-billing-config/list/facility-billing-config.html',
                        controller: 'FacilityBillingConfigController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityBillingDialogController', FacilityBillingDialogController);

    FacilityBillingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacilityBilling', 'Facility'];

    function FacilityBillingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacilityBilling, Facility) {
        var vm = this;

        vm.facilityBilling = entity;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facilityBilling.id !== null) {
                FacilityBilling.update(vm.facilityBilling, onSaveSuccess, onSaveError);
            } else {
                FacilityBilling.save(vm.facilityBilling, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facilityBillingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacilityBilling', FacilityBilling);

    FacilityBilling.$inject = ['$resource', 'DateUtils'];

    function FacilityBilling ($resource, DateUtils) {
        var resourceUrl =  'api/facility-billings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': {method:'PUT'},
            'filter': {url: 'api/facility-billings/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityBillingController', FacilityBillingController);

    FacilityBillingController.$inject = ['$scope', '$state', 'FacilityBilling', 'DTOptionsBuilder', '$q', '$uibModal',
        'DTColumnBuilder', 'CoreService', '$rootScope', 'GUIUtils', 'DataTablesService',
        'GenericEntityDatatableService', 'ConfirmationService'];

    function FacilityBillingController($scope, $state, FacilityBilling, DTOptionsBuilder, $q, $uibModal,
                                       DTColumnBuilder, CoreService, $rootScope, GUIUtils, DataTablesService,
                                       GenericEntityDatatableService, ConfirmationService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Facility Billings',
            entityClassHumanized: 'Facility Billings',
            newButtonTitle: 'New Invoice',
            service: FacilityBilling,
            serviceMethod: 'filter',
            pagination: 'remote',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'Invoice #'
                },
                {
                    title: 'Date',
                    render: function (data) {
                        return moment(data.date).format('MMM YYYY');
                    }
                },
                {
                    title: "Requested Date",
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
                {
                    title: 'Patients',
                    name: "patients"
                },
                {
                    title: 'Total',
                    render: function (data) {
                        return '$ ' + data.total;
                    }
                },
                {
                    title: "Status",
                    render: function (data) {
                        return data.status ? getStatusStyle(data.status) : "FAIL";
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Invoice',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facility-billing/update/facility-billing-dialog.html',
                controller: 'FacilityBillingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            status: 'PENDING',
                            date: null,
                            patients: 0,
                            total: 0,
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Billing').result.then(function () {
                    FacilityBilling.delete({id: id}, function () {
                        resolve()
                    });
                })
            })
        }

        function getStatusStyle(status) {
            switch (status) {
                case 'PENDING': {
                    return GUIUtils.getStatusTemplate(status, "primary")
                }
                case 'NO_PRICE': {
                    return GUIUtils.getStatusTemplate(status, "danger")
                }
                case 'COMPLETED': {
                    return GUIUtils.getStatusTemplate(status, "success")
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
        .state('facility-billing', {
            parent: 'entity',
            url: '/facility-billing',
            data: {
                authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                pageTitle: 'FacilityBillings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/facility-billing/list/facility-billing.html',
                    controller: 'FacilityBillingController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('facility-billing.new', {
            parent: 'facility-billing',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility-billing/facility-billing-dialog.html',
                    controller: 'FacilityBillingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowTopClass: 'custom-dialog-styles',
                    size: 'md',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                facility: CoreService.getCurrentFacility(),
                                status: 'PENDING',
                                date: null,
                                patients: 0,
                                total: 0,
                                id: null
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('facility-billing', null, { reload: 'facility-billing' });
                }, function() {
                    $state.go('facility-billing');
                });
            }]
        })
        .state('facility-billing.delete', {
            parent: 'facility-billing',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/facility-billing/facility-billing-delete-dialog.html',
                    controller: 'FacilityBillingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FacilityBilling', function(FacilityBilling) {
                            return FacilityBilling.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('facility-billing', null, { reload: 'facility-billing' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityDialogController', FacilityDialogController);

    FacilityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Facility',
        'ContactsFacility', 'Corporation', 'CoreService', '$rootScope', 'CountryState',
        '$sessionStorage', 'Pharmacy', 'FacilityPharmacy'];

    function FacilityDialogController($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Facility,
                                      ContactsFacility, Corporation, CoreService, $rootScope, CountryState,
                                      $sessionStorage, Pharmacy, FacilityPharmacy) {
        var vm = this;
        vm.form = {};
        vm.facility = entity;

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.states = CountryState.query();
        vm.corporations = Corporation.query();
        Facility.getAvailableZoneIds(function (result) {
            vm.timeZones = result;
            vm.zoneId = _.filter(vm.timeZones, {zoneId: vm.facility.timeZone})[0];
        });
        vm.infoTab = $sessionStorage.facilityTab ? $sessionStorage.facilityTab.infoTab : 0;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.annualReview = false;
        vm.accountExist = false;
        Facility.getAllPlaceOfServices(function (result) {
            vm.placeOfService = result;
        });
        vm.pharmacy = vm.facility.id == null ? getPharmacies() : [vm.facility.defaultPharmacy];

        vm.keepTab = keepTab;
        vm.clear = clear;
        vm.save = save;
        vm.getPharmacies = getPharmacies;

        function getPharmacies(query) {
            if (query && query.length > 2) {
                Pharmacy.findAllByFilter({searchQuery: query}, function (result) {
                    vm.pharmacy = [];
                    vm.pharmacy = result;
                });
            } else {
                FacilityPharmacy.findAllByFilter({facilityId: vm.facility.id}, function (result) {
                    vm.pharmacy = [];
                    result.forEach((fP => {
                        vm.pharmacy.push(fP.pharmacy)
                    }))
                });
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.facility) {
                vm.facility.timeZone = vm.zoneId.zoneId;
            }

            Facility.update(vm.facility, onSaveSuccess, onSaveError);
        }

        function keepTab(index) {
            $sessionStorage.facilityTab = {infoTab: index};
            vm.infoTab = index;
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:facilityUpdate', result);
            $rootScope.$broadcast('bluebookApp:updateFacilities', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Facility', Facility);

    Facility.$inject = ['$resource', 'DateUtils'];

    function Facility ($resource, DateUtils) {
        var resourceUrl =  'api/facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.annualReview = DateUtils.convertDateTimeFromServer(data.annualReview);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.annualReview = DateUtils.convertLocalDateToServer(copy.annualReview);
                    return angular.toJson(copy);
                }
            },
            'byCorporation': {url: 'api/facilities/corporation/:id', method: 'GET', isArray: true},
            'getAvailableZoneIds': {url: 'api/facilities/get-available-zone-ids', method: 'GET', isArray: true},
            'getAll': {url: 'api/facilities', method: 'GET', isArray: true},
            'getAllPlaceOfServices': {url: 'api/facilities/place-of-service', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityController', FacilityController);

    FacilityController.$inject = ['Facility', 'CoreService', 'GenericEntityDatatableService', '$uibModal',
        'ConfirmationService', '$q', '$state'];

    function FacilityController(Facility, CoreService, GenericEntityDatatableService, $uibModal,
                                ConfirmationService, $q, $state) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        var entityStateName = 'facility'

        vm.descriptor = {
            title: 'Facilities',
            entityClassHumanized: 'Facility',
            newButtonTitle: 'New Facility',
            entityStateName: entityStateName,
            service: Facility,
            serviceMethod: 'byCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Facility',
                            action: function () {
                                add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/facility/create/facility-wizard-dialog.html',
                controller: 'FacilityWizardDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            street: null,
                            street_two: null,
                            city: null,
                            state: null,
                            zip: null,
                            county: null,
                            phone: null,
                            fax: null,
                            website: null,
                            logo: null,
                            id: null,
                            corporation: CoreService.getCorporation(),
                            timeZone: null,
                            sendResults: false,
                            reconnectCare: false,
                            autoSignMedication: false,
                            autoSignPatientOrder: false,
                            defaultPharmacy: null
                        };
                    }
                }
            }).result.then(function () {
                $state.reload();
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/facility/update/facility-dialog.html',
                controller: 'FacilityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Facility', function (Facility) {
                        return Facility.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                $state.reload();
            })
        }

        function del(id) {
            ConfirmationService.showDelete('Facility').result.then(function () {
                Facility.delete({id: id}, function () {
                    $state.reload();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility', {
                parent: 'entity',
                url: '/facility',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Facilities'
                },
                ncyBreadcrumb: {
                    label: 'Facility'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility/list/facility.html',
                        controller: 'FacilityController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacilityWizardDialogController', FacilityWizardDialogController);

    FacilityWizardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Corporation', 'InitValue', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile',
        '$q', 'DataTablesService', 'DataUtils', 'Facility', 'ContactsFacility', 'CoreService',
        '$rootScope', 'CountryState', '$sessionStorage', 'Pharmacy'];

    function FacilityWizardDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                            Corporation, InitValue, DTOptionsBuilder, DTColumnBuilder, $compile,
                                            $q, DataTablesService, DataUtils, Facility, ContactsFacility, CoreService,
                                            $rootScope, CountryState, $sessionStorage, Pharmacy) {
        var vm = this;

        vm.facility = entity;
        vm.states = CountryState.query();
        Facility.getAvailableZoneIds(function (result) {
            vm.timeZones = result;
            vm.zoneId = _.filter(vm.timeZones, {zoneId: vm.facility.timeZone})[0];
        });
        vm.infoTab = $sessionStorage.facilityTab ? $sessionStorage.facilityTab.infoTab : 0;

        vm.entities = InitValue.loadEntitiesByType({type: 'FACILITY'});
        vm.index = -1;
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 1000000;
        vm.selected = {};
        vm.selectAll = false;
        vm.facilityPharmacies = []
        vm.pharmacy = vm.facility.id == null ? getPharmacy() : [vm.facility.defaultPharmacy];

        Facility.getAllPlaceOfServices(function (result) {
            vm.placeOfService = result;
        });

        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.entityValues = [];

        init();

        vm.keepTab = keepTab;
        vm.clear = clear;
        vm.save = save;
        vm.loadEntity = loadEntity;
        vm.searchAccount = searchAccount;
        vm.getPharmacy = getPharmacy;

        function getPharmacy(query) {
            if (query && query.length > 2) {
                Pharmacy.findAllByFilter({searchQuery: query}, function (result) {
                    vm.pharmacy = result;
                });
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.facility) {
                vm.facility.timeZone = vm.zoneId.zoneId;
            }

            var mapToReturn = {};
            _.forEach(vm.entityValues, function (value) {
                mapToReturn[value.name] = value.selectedValues;
            });

            vm.facility.entities = mapToReturn;

            Facility.save(vm.facility, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:facilityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function init() {
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();

                vm.selected = {};
                vm.selectAll = false;

                if (vm.index >= 0) {
                    InitValue.findAllByFilter(getFilter(), function (result, headers) {
                        vm.totalItems = headers('X-Total-Count');
                        vm.initValues = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve([]);
                }

                return defer.promise;
            }).withBootstrap()
                .withDOM('ltp')
                .withOption("bLengthChange", false)
                .withOption("bPaginate", false)
                .withOption('headerCallback', function (header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $compile(nRow)($scope);
                    });

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                    vm.selected[full.id] = false;
                    var column = '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-change="vm.toggleOne()">';
                    _.forOwn(vm.entityValues, function (value, key) {
                        if (vm.entityValues[key].name === vm.entities[vm.index]) {
                            if (value.selectedValues.length > 0) {
                                _.forEach(value.selectedValues, function (value) {
                                    if (data.id.toString() === value) {
                                        vm.selected[data.id] = true;
                                        column = '<input type="checkbox" ng-checked="true" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
                                    }
                                });
                            }
                        }
                    });

                    return column;
                }),
                DTColumnBuilder.newColumn('name').withTitle('Name')
            ];

        }

        function loadEntity(index) {
            getSelected();

            vm.index = index;
            vm.dtInstance.reloadData();

        }

        function getFilter() {
            var filter = {};

            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.sort = "name";
            filter.type = 'FACILITY';
            filter.entity = vm.entities[vm.index];

            return filter;
        }

        function getSelected() {

            var selectedValues = [];
            if (_.size(vm.selected) > 0) {
                _.forOwn(vm.selected, function (value, key) {
                    if (value) {
                        selectedValues.push(key);
                    }
                });
            }
            if (_.isEmpty(vm.entityValues) && !_.isEmpty(selectedValues)) {
                vm.entityValues.push({'name': vm.entities[vm.index], 'selectedValues': selectedValues});
            }
            if (!_.isEmpty(vm.entityValues) && !_.isEmpty(selectedValues)) {
                var aux = _.find(vm.entityValues, ['name', vm.entities[vm.index]]);
                if (aux) {
                    aux.selectedValues = selectedValues;
                } else {
                    vm.entityValues.push({'name': vm.entities[vm.index], 'selectedValues': selectedValues});
                }
            } else {
                _.forOwn(vm.entityValues, function (value, key) {
                    if (vm.entityValues[key].name === vm.entities[vm.index]) {
                        _.remove(vm.entityValues, vm.entityValues[key]);
                    }
                });
            }
        }

        function keepTab(index) {
            $sessionStorage.facilityTab = {infoTab: index};
            vm.infoTab = index;
        }

        function searchAccount(query) {
            if (query && query.length > 2) {
                Facility.existAccount({account: query}, function (result) {
                    vm.accountExist = result.value != null && result.value !== vm.facility.id;
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacesheetTplDialogController', FacesheetTplDialogController);

    FacesheetTplDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'FacesheetTpl', 'Facility', 'FacesheetSection', 'EvaluationTemplate',
        '$state', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', 'GUIUtils', '$filter',
        'DataTablesService', '$compile', 'CoreService'];

    function FacesheetTplDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                          entity, FacesheetTpl, Facility, FacesheetSection, EvaluationTemplate,
                                          $state, DTOptionsBuilder, DTColumnBuilder, $q, GUIUtils, $filter,
                                          DataTablesService, $compile, CoreService) {
        var vm = this;

        vm.facesheetTpl = entity;

        vm.groupSessionStatuses = FacesheetTpl.allGroupSessionStatus();
        vm.evaluationStatuses = FacesheetTpl.allEvaluationStatus();
        vm.facesheetSections = [];
        vm.evaluationTemplates = [];
        vm.dtInstanceFacesheetSections = {};
        vm.dtInstanceEvaluationTemplates = {};
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.selectedFacesheetSections = {};
        vm.selectedEvaluationTemplates = {};
        vm.selectAllFacesheetSections = false;
        vm.selectAllEvaluationTemplates = false;

        var titleHtmlSections = '<input type="checkbox" ng-model="vm.selectAllFacesheetSections" ng-change="vm.toggleAll(vm.selectedFacesheetSections, vm.selectAllFacesheetSections)">';
        var titleHtmlTemplates = '<input type="checkbox" ng-model="vm.selectAllEvaluationTemplates" ng-change="vm.toggleAll(vm.selectedEvaluationTemplates, vm.selectAllEvaluationTemplates)">';

        vm.clear = clear;
        vm.save = save;
        vm.search = search;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        init();

        function init() {
            vm.dtOptionsFacesheetSections = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                FacesheetSection.getAllByFacility({id: CoreService.getCurrentFacility().id}, function (result, headers) {
                    vm.facesheetSections = result;
                    defer.resolve(result);
                });
                return defer.promise;
            }).withBootstrap()
                .withDOM('ltp')
                .withOption("bPaginate", false)
                .withOption('headerCallback', function (header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        _.forEach(vm.facesheetTpl.sections, function (section) {
                            vm.selectedFacesheetSections[section.id] = true;
                        });
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withOption('fnRowCallback',
                    function (nRow) {
                        $compile(nRow)($scope);
                    });

            vm.dtColumnsFacesheetSections = [
                DTColumnBuilder.newColumn(null).withTitle(titleHtmlSections).notSortable().renderWith(function (data, type, full, meta) {
                    if (vm.selectedFacesheetSections[full.id] === undefined) {
                        vm.selectedFacesheetSections[full.id] = false;
                    }
                    return '<input type="checkbox" ng-model="vm.selectedFacesheetSections[' + data.id + ']" ng-click="vm.toggleOne(vm.selectedFacesheetSections, vm.selectAllFacesheetSections)">';
                }),
                DTColumnBuilder.newColumn('title').withTitle('Title'),
                DTColumnBuilder.newColumn('facesheetSectionType').withTitle('Facesheet Section Type')
            ];

            vm.dtOptionsEvaluationTemplates = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                if (!vm.searchQuery || vm.searchQuery == '') {
                    EvaluationTemplate.findAllByFacility({id: CoreService.getCurrentFacility().id}, function (result, headers) {
                        vm.evaluationTemplates = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve($filter('filter')(vm.evaluationTemplates, vm.searchQuery, undefined));
                }
                return defer.promise;
            }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
                .withDisplayLength(15)
                .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
                .withOption('aaSorting', [[1, 'asc'], [0, 'asc']])
                .withOption('headerCallback', function (header) {
                    if (!vm.headerCompiled1) {
                        vm.headerCompiled1 = true;
                        _.forEach(vm.facesheetTpl.evaluationTemplates, function (section) {
                            vm.selectedEvaluationTemplates[section.id] = true;
                        });
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withOption('fnRowCallback',
                    function (nRow) {
                        $compile(nRow)($scope);
                    });

            vm.dtColumnsEvaluationTemplates = [
                DTColumnBuilder.newColumn(null).withTitle(titleHtmlTemplates).notSortable().renderWith(function (data, type, full, meta) {
                    if (vm.selectedEvaluationTemplates[full.id] === undefined) {
                        vm.selectedEvaluationTemplates[full.id] = false;
                    }
                    return '<input type="checkbox" ng-model="vm.selectedEvaluationTemplates[' + data.id + ']" ng-click="vm.toggleOne(vm.selectedEvaluationTemplates, vm.selectAllEvaluationTemplates)">';
                }),
                DTColumnBuilder
                    .newColumn('name')
                    .withOption('class', 'names-col')
                    .withTitle('Name')
                    .notSortable(),
                DTColumnBuilder
                    .newColumn('enabled')
                    .withTitle('Enabled')
                    .notSortable()
                    .renderWith(function (data, type, full) {
                        return GUIUtils.colorHtmlYesNo(data);
                    }),
                DTColumnBuilder
                    .newColumn('delStatus')
                    .withTitle('Deleted')
                    .notSortable()
                    .renderWith(function (data, type, full) {
                        return GUIUtils.colorHtmlYesNo(data);
                    })
            ];
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            var idsSections = vm.getSelectedIds(vm.selectedFacesheetSections);
            var idsTemplates = vm.getSelectedIds(vm.selectedEvaluationTemplates);

            vm.facesheetTpl.sections = _.filter(vm.facesheetSections, function (section) {
                return idsSections.indexOf("" + section.id) != -1;
            });

            vm.facesheetTpl.evaluationTemplates = _.filter(vm.evaluationTemplates, function (template) {
                return idsTemplates.indexOf("" + template.id) != -1;
            });

            if (vm.facesheetTpl.id !== null) {
                FacesheetTpl.update(vm.facesheetTpl, onSaveSuccess, onSaveError);
            } else {
                FacesheetTpl.save(vm.facesheetTpl, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:facesheetTplUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function search() {
            vm.dtInstanceEvaluationTemplates.reloadData();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacesheetTpl', FacesheetTpl);

    FacesheetTpl.$inject = ['$resource'];

    function FacesheetTpl($resource) {
        var resourceUrl = 'api/facesheet-tpls/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.groupSessionStatuses) {
                            data.groupSessionStatuses = objectToArray(data.groupSessionStatuses);
                        }
                        if (data.evaluationStatuses) {
                            data.evaluationStatuses = objectToArray(data.evaluationStatuses);
                        }
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'allGroupSessionStatus': {url: 'api/facesheet-tpls/groupSessionStatus', method: 'GET', isArray: true},
            'allEvaluationStatus': {url: 'api/facesheet-tpls/evaluationStatus', method: 'GET', isArray: true},
            'filter': {url: 'api/facesheet-tpls/filter', method: 'GET', isArray: true}
        });

        function objectToArray(inArray) {
            var toArray = [];

            for (var i = 0; i < inArray.length; i++) {
                toArray.push(inArray[i].status);
            }

            return toArray;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacesheetTplController', FacesheetTplController);

    FacesheetTplController.$inject = ['GenericEntityDatatableService', 'CoreService', 'FacesheetTpl', 'GUIUtils',
        '$uibModal', 'ConfirmationService', '$q'];

    function FacesheetTplController(GenericEntityDatatableService, CoreService, FacesheetTpl, GUIUtils,
                                    $uibModal, ConfirmationService, $q) {

        var vm = this;

        var params = {facilityId: CoreService.getCurrentFacility().id};

        vm.descriptor = {
            title: 'Facesheets',
            newButtonTitle: 'New Facesheet',
            entityClassHumanized: 'Facesheets',
            entityStateName: 'facesheet-tpl',
            service: FacesheetTpl,
            serviceMethod: 'filter',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'name',
                    title: 'Name',

                },
                {
                    name: null,
                    title: 'Enable',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enable);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Facesheet',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facesheet-tpl/update/facesheet-tpl-dialog.html',
                controller: 'FacesheetTplDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            groupSessionStatuses: null,
                            evaluationStatuses: null,
                            facility: CoreService.getCurrentFacility(),
                            name: null,
                            enable: true,
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/facesheet-tpl/update/facesheet-tpl-dialog.html',
                controller: 'FacesheetTplDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['FacesheetTpl', function (FacesheetTpl) {
                        return FacesheetTpl.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Facesheet').result.then(function () {
                    FacesheetTpl.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('facesheet-tpl', {
                parent: 'entity',
                url: '/facesheet-tpl',
                data: {
                    authorities: [],
                    pageTitle: 'FacesheetTpls'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facesheet-tpl/list/facesheet-tpl.html',
                        controller: 'FacesheetTplController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacesheetTplReportController', FacesheetTplReportController);

    FacesheetTplReportController.$inject = ['FacesheetTpl', '$state', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', 'Chart', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope',
        '$timeout', '$uibModalInstance', 'toastr', 'PendingPdfChartReport', 'REPORT_TYPE'];

    function FacesheetTplReportController(FacesheetTpl, $state, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart, Chart,
                                          $q, GUIUtils, $filter, CoreService, $compile, $scope,
                                          $timeout, $uibModalInstance, toastr, PendingPdfChartReport, REPORT_TYPE) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.facility = CoreService.getCurrentFacility();

        vm.selected = {};
        vm.selectAll = false;
        vm.startDate = null;
        vm.endDate = null;
        vm.startDateOptions = {};
        vm.endDateOptions = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.form = {};

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;
        vm.openCalendar = openCalendar;
        vm.validateStartDate = validateStartDate;
        vm.validateEndDate = validateEndDate;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            FacesheetTpl.filter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.facesheetTpls = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[1, 'desc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).renderWith(function (data) {

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }).withOption('width', '50px').notSortable(),
            DTColumnBuilder.newColumn('name').withOption('class', 'names-col').withTitle('Name')
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.facilityId = vm.facility.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;
            filter.enable = true;

            return filter
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }

        function print() {
            if (vm.getSelectedIds(vm.selected).length > 0) {
                vm.isPrinting = true;
                _.forEach(vm.getSelectedIds(vm.selected), function (id) {
                    PendingPdfChartReport.save({
                        chart: chart,
                        facesheetTpl: _.filter(vm.facesheetTpls, function (facesheetTpl) {
                            return "" + facesheetTpl.id == id;
                        })[0],
                        facility: vm.facility,
                        name: "report name",
                        reportType: REPORT_TYPE.FACESHEET,
                        startDate: vm.startDate,
                        endDate: vm.endDate
                    }, onPrintSuccess, onPrintError);
                });
            }

            function onPrintSuccess(result) {
                vm.isPrinting = false;
                $uibModalInstance.close(true);

                toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
            }

            function onPrintError() {
                vm.isPrinting = false;
                toastr.error("We couldn't generate the report.");
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.endDate;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.startDate;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacesheetSectionDialogController', FacesheetSectionDialogController);

    FacesheetSectionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FacesheetSection'];

    function FacesheetSectionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FacesheetSection) {
        var vm = this;

        vm.facesheetSection = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.facesheetSection.id !== null) {
                FacesheetSection.update(vm.facesheetSection, onSaveSuccess, onSaveError);
            } else {
                FacesheetSection.save(vm.facesheetSection, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:facesheetSectionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('FacesheetSection', FacesheetSection);

    FacesheetSection.$inject = ['$resource'];

    function FacesheetSection ($resource) {
        var resourceUrl =  'api/facesheet-sections/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFacility': {url: 'api/facesheet-sections/facility/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('FacesheetSectionController', FacesheetSectionController);

    FacesheetSectionController.$inject = ['GenericEntityDatatableService', 'CoreService', 'FacesheetSection',
        '$uibModal', 'ConfirmationService', '$q'];

    function FacesheetSectionController(GenericEntityDatatableService, CoreService, FacesheetSection,
                                        $uibModal, ConfirmationService, $q) {

        var vm = this;

        var params = CoreService.getFilterByFacility(CoreService.getCurrentFacility());

        vm.descriptor = {
            title: 'Facesheet Sections',
            newButtonTitle: 'New Facesheet Section',
            entityClassHumanized: 'Facesheet Sections',
            entityStateName: 'facesheet-section',
            service: FacesheetSection,
            serviceMethod: 'getAllByFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'title',
                    title: 'Title',
                },
                {
                    name: 'facesheetSectionType',
                    title: 'Facesheet Section Type',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Facesheet Sections',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/facesheet-section/update/facesheet-section-dialog.html',
                controller: 'FacesheetSectionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            title: null,
                            facesheetSectionType: null,
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/facesheet-section/update/facesheet-section-dialog.html',
                controller: 'FacesheetSectionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['FacesheetSection', function (FacesheetSection) {
                        return FacesheetSection.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Facesheet Section').result.then(function () {
                    FacesheetSection.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('facesheet-section', {
                parent: 'entity',
                url: '/facesheet-section',
                data: {
                    authorities: [],
                    pageTitle: 'FacesheetSections'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facesheet-section/list/facesheet-section.html',
                        controller: 'FacesheetSectionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationWeightDialogController', EvaluationWeightDialogController);

    EvaluationWeightDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EvaluationWeight', 'Evaluation', 'Weight'];

    function EvaluationWeightDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, EvaluationWeight, Evaluation, Weight) {
        var vm = this;

        vm.evaluationWeight = entity;
        vm.weight = vm.evaluationWeight.weight;

        vm.height = {feet: null, inches: null};
        vm.datePickerOpenStatus = {};

        if (vm.weight.id && !isNaN(vm.weight.height)) {
            vm.height = {feet: Math.floor(vm.weight.height / 12), inches: vm.weight.height % 12};
        }

        vm.openCalendar = openCalendar;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            vm.weight.height = vm.height.feet * 12 + vm.height.inches;

            vm.weight.bmi = (vm.weight.weight / (vm.weight.height * vm.weight.height)) * 703;

            vm.evaluationWeight.weight = vm.weight;

            if (vm.evaluationWeight.id !== null) {
                EvaluationWeight.update(vm.evaluationWeight, onSaveSuccess, onSaveError);
            } else {
                EvaluationWeight.save(vm.evaluationWeight, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:evaluationWeightUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationWeight', EvaluationWeight);

    EvaluationWeight.$inject = ['$resource'];

    function EvaluationWeight ($resource) {
        var resourceUrl =  'api/evaluation-weights/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-weights/by-evaluation/:id', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationWeightController', EvaluationWeightController);

    EvaluationWeightController.$inject = ['$scope', '$state', 'EvaluationWeight', 'entity', '$uibModal', 'CoreService'];

    function EvaluationWeightController($scope, $state, EvaluationWeight, entity, $uibModal, CoreService) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationWeight = null;

        vm.loadAll = loadAll;
        vm.add = add;
        vm.history = history;
        vm.getHeightInchesToFeetInches = getHeightInchesToFeetInches;

        loadAll();

        function loadAll() {
            if (!vm.evaluation.weight) {
                return;
            }

            EvaluationWeight.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                if (result.length > 0) {
                    vm.evaluationWeight = result[0];
                    vm.evaluationWeight.bmi = _.ceil(vm.evaluationWeight.bmi, 2)
                }
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/weight/update/weight-dialog.html',
                controller: 'EvaluationWeightDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            evaluation: {id: vm.evaluation.id},
                            weight: {
                                name: null,
                                id: null,
                                chart: vm.evaluation.chart
                            }
                        };
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/weight/history/weight.html',
                controller: 'WeightController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.evaluation.chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function getHeightInchesToFeetInches(height) {

            return CoreService.getHeightInchesToFeetInches(height);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationVitalDialogController', EvaluationVitalDialogController);

    EvaluationVitalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'EvaluationVital', 'CoreService'];

    function EvaluationVitalDialogController ($timeout, $scope, $stateParams, $uibModalInstance,
                                              entity, EvaluationVital, CoreService) {
        var vm = this;

        vm.evaluationVital = entity;
        vm.vitals = angular.copy(vm.evaluationVital.vital);
        vm.facility = CoreService.getCurrentFacility();

        vm.datePickerOpenStatus = {};
        vm.form = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            var date = moment.tz(moment(vm.vitals.date).format('YYYY-MM-DDTHH:mm:00'), vm.facility.timeZone).format();
            var vitals = angular.copy(vm.vitals);
            vitals.date = date;

            vm.evaluationVital.vital = vitals;

            if (vm.evaluationVital.id !== null) {
                EvaluationVital.update(vm.evaluationVital, onSaveSuccess, onSaveError);
            } else {
                EvaluationVital.save(vm.evaluationVital, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationVital', EvaluationVital);

    EvaluationVital.$inject = ['$resource'];

    function EvaluationVital($resource) {
        var resourceUrl = 'api/evaluation-vitals/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-vitals/by-evaluation/:id', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationVitalController', EvaluationVitalController);

    EvaluationVitalController.$inject = ['$scope', '$state', 'EvaluationVital', 'entity', '$uibModal', 'Vitals'];

    function EvaluationVitalController($scope, $state, EvaluationVital, entity, $uibModal, Vitals) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationVitals = null;
        vm.lastVitals = null;

        vm.loadAll = loadAll;
        vm.add = add;
        vm.history = history;

        loadAll();

        function loadAll() {
            if (!vm.evaluation.vital) {
                return;
            }

            vm.lastVitals = null;

            EvaluationVital.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                if (result.length > 0) {
                    vm.evaluationVitals = result[0];
                } else {
                    Vitals.findLastByChart({id: vm.evaluation.chart.id}, function (result) {
                        if (result) {
                            if (moment(new Date()).diff(moment(result.date), 'hours', true) > 24) {
                                vm.lastVitals = result;
                            }
                        }
                    });
                }
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/vitals/update/vitals-dialog.html',
                controller: 'EvaluationVitalDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            evaluation: {id: vm.evaluation.id},
                            vital: {
                                name: null,
                                status: null,
                                id: null,
                                chart: vm.evaluation.chart
                            }
                        }
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/vitals/history/vitals.html',
                controller: 'VitalsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.evaluation.chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationToken', EvaluationToken);

    EvaluationToken.$inject = ['$resource'];

    function EvaluationToken ($resource) {
        var resourceUrl =  'api/evaluation-tokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateMarsMorsDialogController', EvaluationTemplateMarsMorsDialogController);

    EvaluationTemplateMarsMorsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EvaluationTemplateMarsMors', 'EvaluationTemplate', 'CoreService'];

    function EvaluationTemplateMarsMorsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EvaluationTemplateMarsMors, EvaluationTemplate, CoreService) {
        var vm = this;

        vm.evaluationTemplateMarsMors = entity;
        vm.evaluationTemplates = [];
        vm.facility = CoreService.getCurrentFacility();
        vm.clear = clear;
        vm.save = save;
        vm.getEvaluationTemplates = getEvaluationTemplates;

        function getEvaluationTemplates(query) {
            if (query) {
                var filter = {page: 0, size: 10, searchQuery: query, facilityId: vm.facility.id, enabled: true};

                EvaluationTemplate.findAllByFilter(filter, function (result) {
                    vm.evaluationTemplates = result;
                });
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.evaluationTemplateMarsMors.id !== null) {
                EvaluationTemplateMarsMors.update(vm.evaluationTemplateMarsMors, onSaveSuccess, onSaveError);
            } else {
                EvaluationTemplateMarsMors.save(vm.evaluationTemplateMarsMors, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:evaluationTemplateMarsMorsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationTemplateMarsMors', EvaluationTemplateMarsMors);

    EvaluationTemplateMarsMors.$inject = ['$resource'];

    function EvaluationTemplateMarsMors ($resource) {
        var resourceUrl =  'api/evaluation-template-mars-mors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'byFacility': {method: 'GET', url: 'api/evaluation-template-mars-mors/by-facility/:id', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateMarsMorsController', EvaluationTemplateMarsMorsController);

    EvaluationTemplateMarsMorsController.$inject = ['GenericEntityDatatableService', 'CoreService',
        'ConfirmationService', 'EvaluationTemplateMarsMors', '$q', '$uibModal'];

    function EvaluationTemplateMarsMorsController(GenericEntityDatatableService, CoreService,
                                                  ConfirmationService, EvaluationTemplateMarsMors, $q, $uibModal) {

        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Care & Delivery Mars/Mors',
            newButtonTitle: 'New Care & Delivery Mars/Mors',
            entityClassHumanized: 'Care & Delivery Mars/Mors',
            entityStateName: 'evaluation-template-mars-mors',
            service: EvaluationTemplateMarsMors,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: null,
                    title: 'Evaluation Template',
                    render: function (data) {
                        return data.evaluationTemplate ? data.evaluationTemplate.name : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Care & Delivery MARs/MORs',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/evaluation-template-mars-mors/update/evaluation-template-mars-mors-dialog.html',
                controller: 'EvaluationTemplateMarsMorsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            evaluationTemplate: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Care & Delivery MARs/MORs').result.then(function () {
                    EvaluationTemplateMarsMors.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('evaluation-template-mars-mors', {
                parent: 'entity',
                url: '/evaluation-template-mars-mors',
                data: {
                    authorities: [],
                    pageTitle: 'EvaluationTemplateMarsMors'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation-template-mars-mors/list/evaluation-template-mars-mors.html',
                        controller: 'EvaluationTemplateMarsMorsController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Care & Delivery MARs/MORs'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS];

                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateFileDialogController', EvaluationTemplateFileDialogController);

    EvaluationTemplateFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'EvaluationTemplateFile',  'DataUtils'];

    function EvaluationTemplateFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, EvaluationTemplateFile, DataUtils) {
        var vm = this;

        vm.evaluationTemplateFile = entity;

        vm.clear = clear;
        vm.attachFile = attachFile;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:evaluationTemplateFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function attachFile (files) {
            var attachFiles = [];
            var bigFiles = _.remove(files, function (item) {

                return parseInt(item.size) > 16000000;
            });
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                DataUtils.toBase64ToFileObject(file, function (result) {
                    result.ownerId = parseInt(vm.evaluationTemplateFile.evaluationTemplate.id);
                    attachFiles.push(result);
                    if (attachFiles.length == files.length) {
                        attach(attachFiles);
                    }
                });
            }
            for (var i = 0; i < bigFiles.length; i++) {
                toastr.error(bigFiles[i].name + ' file is too big. The maximum size is 16MB')
            }
        }

        function attach(result) {
            EvaluationTemplateFile.attachFiles({evaluationTemplate : {id: vm.evaluationTemplateFile.evaluationTemplate.id}, files: result}, onSaveSuccess, onSaveError);
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationTemplateFile', EvaluationTemplateFile);

    EvaluationTemplateFile.$inject = ['$resource', 'DataUtils'];

    function EvaluationTemplateFile ($resource, DataUtils) {
        var resourceUrl =  'api/evaluation-template-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluationTemplate': {url: 'api/evaluation-template-files/by-evaluation-template', method: 'GET', isArray: true},
            'attachFiles': {url: 'api/evaluation-template-files/attach-files', method: 'POST', isArray: true},
            'download': {
                url: 'api/evaluation-template-files/get-file/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateFileController', EvaluationTemplateFileController);

    EvaluationTemplateFileController.$inject = ['entity', 'EvaluationTemplateFile', '$state', 'DTOptionsBuilder',
        'DTColumnBuilder', '$q', 'GUIUtils', 'CoreService', '$compile', '$scope', '$uibModal',
        'ConfirmationService'];

    function EvaluationTemplateFileController (entity, EvaluationTemplateFile, $state, DTOptionsBuilder,
                                               DTColumnBuilder, $q, GUIUtils, CoreService, $compile, $scope, $uibModal,
                                               ConfirmationService) {
        var vm = this;

        vm.evaluationTemplate = entity;
        vm.evaluationTemplateFile = [];
        vm.title = 'Evaluation Template File';
        vm.entityClassHumanized = 'Evaluation Template File';
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.add = add;
        vm.del = del;
        vm.getFileAttached = getFileAttached;

        vm.reload = reload;
        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            EvaluationTemplateFile.findAllByEvaluationTemplate({
                evaluationId: vm.evaluationTemplate.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            },  function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.evaluationTemplateFile = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', false)
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Name').renderWith(function (data, type, full) {
                return data.file.name + " ["  + data.file.name + "]";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '20px').withOption('class', 'actions-col').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta){
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ng-click="vm.getFileAttached(' + data.id + ')">' +
                '<i class="fa fa-list-alt" aria-hidden="true"></i>See details' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ng-click="vm.del(' + data.id + ')">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }
        function search() {
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-template-file/update/evaluation-template-file-dialog.html',
                controller: 'EvaluationTemplateFileDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function () {
                        return {
                            id: null,
                            evaluationTemplate: vm.evaluationTemplate,
                            file: null
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                reload();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Evaluation Template File').result.then(function () {
                EvaluationTemplateFile.delete({id: id}, function () {
                    vm.page = 1;
                    reload();
                });
            })
        }

        function getFileAttached(id) {
            EvaluationTemplateFile.download({id: id});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateEditController', EvaluationTemplateEditController);

    EvaluationTemplateEditController.$inject = ['entity', '$rootScope', 'OdsFormService',
        'EvaluationTemplate', 'TypePatientProcess', 'Employee', '$state',
        'suggestions', 'CoreService', 'TypeLevelCare'];

    function EvaluationTemplateEditController(entity, $rootScope, OdsFormService,
                                              EvaluationTemplate, TypePatientProcess, Employee, $state,
                                              suggestions, CoreService, TypeLevelCare) {
        var vm = this;

        vm.evaluationTemplate = entity;
        vm.title = 'Care & Delivery Template';

        //init schema if null
        vm.evaluationTemplate.jsonTemplate = !vm.evaluationTemplate.jsonTemplate ?
            OdsFormService.newSchema() : vm.evaluationTemplate.jsonTemplate;

        function iterateObjectRecursive(obj, callback) {
            _.forOwn(obj, function(value, key) {
                if (_.isObject(value)) {
                    iterateObjectRecursive(value, callback);
                } else {
                    callback(value, key, obj);
                }
            });
        }

        iterateObjectRecursive(vm.evaluationTemplate.jsonTemplate, function(value, key, obj) {
            if (key === 'popoverProps' && value) {
                obj['popoverProps'] = false;
            }
        });

        //Show debug var if it's running in development profile.
        // vm.debugMode = !$rootScope.inProduction ? true : false;
        vm.debugMode = true;

        vm.credentials = Employee.credentials();
        vm.typePatientProcesses = TypePatientProcess.byFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.levelCares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.readmissionBasedOn = EvaluationTemplate.readmissionBasedOn();

        //We load this from server using /ckeditor-suggestions rest service.
        vm.formCKEditorConfig = {
            ckeditor: {
                suggestions: suggestions
            }
        };
        vm.form = {};

        vm.save = save;
        vm.patientSignatureChange = patientSignatureChange;
        vm.staffSignatureChange = staffSignatureChange;
        vm.staffReviewSignatureChange = staffReviewSignatureChange;
        vm.updateTitle = updateTitle;

        function save() {
            vm.isSaving = true;
            if (vm.evaluationTemplate.id) {
                EvaluationTemplate.update(vm.evaluationTemplate, onSaveSuccess, onSaveError);
            } else {
                EvaluationTemplate.save(vm.evaluationTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $state.go('evaluation-template');
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function patientSignatureChange() {
            if (!vm.evaluationTemplate.requiredPatientSignature) {
                vm.evaluationTemplate.requiredGuarantorSignature = false;
            }
        }

        function staffSignatureChange() {
            if (!vm.evaluationTemplate.forceStaffSignature) {
                vm.evaluationTemplate.forceStaffReviewSignature = false;
                vm.evaluationTemplate.staffReviewSignatureCredentials = [];
                vm.evaluationTemplate.staffSignatureCredentials = [];
            }
        }

        function staffReviewSignatureChange() {
            if (!vm.evaluationTemplate.forceStaffReviewSignature) {
                vm.evaluationTemplate.staffReviewSignatureCredentials = [];
            }
        }

        function updateTitle() {
            vm.evaluationTemplate.jsonTemplate.label = angular.copy(vm.evaluationTemplate.name);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationTemplate', EvaluationTemplate);

    EvaluationTemplate.$inject = ['$resource'];

    function EvaluationTemplate($resource) {
        var resourceUrl = 'api/evaluation-templates/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].jsonTemplate = angular.fromJson(data[i].jsonTemplate);
                        }
                    }

                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.jsonTemplate = angular.fromJson(data.jsonTemplate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);
                    return angular.toJson(copy);
                }
            },
            'findAllByFilter': {url: 'api/evaluation-templates/filter', method: 'GET', isArray: true},
            'findAllByFacility': {url: 'api/evaluation-templates/by-facility/:id', method: 'GET', isArray: true},
            'levelCare': {url: 'api/evaluation-templates/level-care/:ppId/:facId/:lcId', method: 'GET', isArray: true},
            'readmissionBasedOn': {url: 'api/evaluation-templates/readmission-based-on', method: 'GET', isArray: true},
            'findAllByPatientProcess': {url: 'api/evaluation-templates/by-chart/:id/patient-process/:process', method: 'GET', isArray: true},
            'findAllByRelease': {url: 'api/evaluation-templates/by-chart/:id', method: 'GET', isArray: true},
            'findAll': {url: 'api/evaluation-templates/', method: 'GET', isArray: true },
            'ckeditorSuggestions': {url: 'api/evaluation-templates/ckeditor-suggestions', method: 'GET', isArray: true},
            'clone': {url: 'api/evaluation-templates/clone/:id', method: 'GET'},
            'cloneToFacility': {url: 'api/evaluation-templates/clone/:id/facility/:facilityId', method: 'GET'},
            'findAllByMars': {url: 'api/evaluation-templates/by-chart/mars/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateMarsAssignDialogController', EvaluationTemplateMarsAssignDialogController);

    EvaluationTemplateMarsAssignDialogController.$inject = ['$timeout', 'chart', '$uibModalInstance', 'EvaluationTemplate', 'Evaluation',
        'toastr', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$compile', '$scope'];

    function EvaluationTemplateMarsAssignDialogController($timeout, chart, $uibModalInstance, EvaluationTemplate, Evaluation,
                                                          toastr, DTOptionsBuilder, DTColumnBuilder, $q, $filter, $compile, $scope) {
        var vm = this;
        vm.chart = chart;

        vm.urgentIssues = [];
        vm.urgentIssue = {};
        vm.dtInstance = {};
        vm.reload = false;

        vm.clear = clear;
        vm.assign = assign;

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                EvaluationTemplate.findAllByMars({
                    id: chart.id
                }, function (result) {
                    vm.evaluationTemplate = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.evaluationTemplate, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Template Name'),
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function assign() {
            var assign = {};
            assign.ids = [];
            assign.chart = chart;

            _.forEach(vm.selected, function (value, key) {
                if (value) {
                    assign.ids.push(key);
                }
            });

            if (assign.ids.length > 0) {
                vm.isSaving = true;
                save(assign);
            }
        }

        function save(assign) {
            Evaluation.assign(assign, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                $uibModalInstance.close(true);
                toastr.success("Care & Delivery Add to the Chart");
            }

            function onSaveError() {
                vm.isSaving = false;
            }
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateController', EvaluationTemplateController);

    EvaluationTemplateController.$inject = ['EvaluationTemplate', 'GUIUtils', 'CoreService', '$uibModal',
        'ConfirmationService', '$rootScope', 'GenericEntityDatatableService', 'Principal',
        'ROLES', '$q'];

    function EvaluationTemplateController(EvaluationTemplate, GUIUtils, CoreService, $uibModal,
                                          ConfirmationService, $rootScope, GenericEntityDatatableService, Principal,
                                          ROLES, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Care & Delivery Templates',
            newButtonTitle: 'New Care & Delivery Template',
            entityClassHumanized: 'Care & Delivery Templates',
            entityStateName: 'evaluation-template',
            service: EvaluationTemplate,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: true,
            options: [{key: 'aaSorting', value: [[1, 'desc']]}],
            withSelectionColumn: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'createdDate',
                    title: 'Created Date',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
                {
                    name: 'createdBy',
                    title: 'Created By'
                },
                {
                    name: 'enabled',
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(!!data.enabled);
                    }
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('evaluation-template'),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(),
                    {
                        action: function (data) {
                            return del(data.id);
                        },
                        reload: true
                    }),
                {
                    name: 'Clone',
                    action: function (data) {
                        return cloneEvaluationTemplate(data.id);
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-clone',
                    reload: true
                },
                {
                    name: 'Clone to Facility',
                    action: function (data) {
                        return cloneEvaluationTemplateToFacility(data.id);
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-clone',
                    ngIf: function () {
                        return Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN]);
                    },
                    reload: true
                },
            ]
        }

        function cloneEvaluationTemplate(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/evaluation-template/clone/evaluation-template-clone-dialog.html',
                    controller: 'EvaluationTemplateCloneController',
                    controllerAs: 'vm',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['EvaluationTemplate', function (EvaluationTemplate) {
                            return EvaluationTemplate.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function cloneEvaluationTemplateToFacility(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/evaluation-template/clone-to-facility/evaluation-template-clone-to-facility-dialog.html',
                    controller: 'EvaluationTemplateCloneToFacilityController',
                    controllerAs: 'vm',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['EvaluationTemplate', function (EvaluationTemplate) {
                            return EvaluationTemplate.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('EvaluationTemplate').result.then(function () {
                    EvaluationTemplate.delete({id: id}, function () {
                        return resolve();
                    });
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('evaluation-template', {
                parent: 'entity',
                url: '/evaluation-template',
                data: {
                    authorities: [ROLES.ROLE_USER],
                    pageTitle: 'EvaluationTemplates'
                },
                ncyBreadcrumb: {
                    label: 'Evaluations'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation-template/list/evaluation-template.html',
                        controller: 'EvaluationTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY, access);
                }]
            })
            .state('evaluation-template.new', {
                parent: 'evaluation-template',
                url: '/new',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                ncyBreadcrumb: {
                    label: 'New Evaluation',
                    parent: 'evaluation-template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation-template/update/evaluation-template-edit.html',
                        controller: 'EvaluationTemplateEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            name: null,
                            enabled: true,
                            patientSignature: false,
                            onlyOne: false,
                            billable: false,
                            forceStaffSignature: false,
                            forceStaffReviewSignature: false,
                            staffSignatureAuthority: [],
                            staffReviewSignatureAuthorities: [],
                            loadAutomatic: false,
                            jsonTemplate: null,
                            id: null,
                            requiredFilledByDays: null,
                            validForDays: null,
                            readmissionDays: null,
                            allowRevocation: false,
                            addemdums: false,
                            typePatientProcess: [],
                            readmissionBasedOn: null,
                            requiredGuarantorSignature: false,
                            requiredPatientSignature: false,
                            release: false,
                            summary: null,
                            mars: false,
                            consent: false,
                            attachments: false,
                            vital: false,
                            suggestedMinutes: null,
                            diets: false,
                            diagnosis: false,
                            glucose: false,
                            allergies: false,
                            weight: false,
                            medications: false,
                            stdAudit: false,
                            landscape: false,
                            addTitle: ""
                        };
                    }],
                    suggestions: ['EvaluationTemplate', function (EvaluationTemplate) {

                        return EvaluationTemplate.ckeditorSuggestions().$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY, access);
                }]
            })
            .state('evaluation-template.edit', {
                parent: 'evaluation-template',
                url: '/{id}/edit',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                ncyBreadcrumb: {
                    label: 'Edit Evaluation',
                    parent: 'evaluation-template'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation-template/update/evaluation-template-edit.html',
                        controller: 'EvaluationTemplateEditController',
                        controllerAs: 'vm'
                    },
                    'files@evaluation-template.edit': {
                        templateUrl: 'app/entities/evaluation-template-file/list/evaluation-template-file.html',
                        controller: 'EvaluationTemplateFileController',
                        controllerAs: 'vm'
                    },
                    'pro-claim-conf@evaluation-template.edit': {
                        templateUrl: 'app/entities/pro-claim-conf/pro-claim-confs.html',
                        controller: 'ProClaimConfController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    entity: ['EvaluationTemplate', '$stateParams', function (EvaluationTemplate, $stateParams) {
                        return EvaluationTemplate.get({id: $stateParams.id}).$promise;
                    }],
                    suggestions: ['EvaluationTemplate', function (EvaluationTemplate) {

                        return EvaluationTemplate.ckeditorSuggestions().$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateContactAssignDialogController', EvaluationTemplateContactAssignDialogController);

    EvaluationTemplateContactAssignDialogController.$inject = ['$timeout', 'chart', 'contact', '$uibModalInstance', 'EvaluationTemplate', 'Evaluation',
        'toastr', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter',
        '$compile', '$scope', 'DataTablesService'];

    function EvaluationTemplateContactAssignDialogController($timeout, chart, contact, $uibModalInstance, EvaluationTemplate, Evaluation,
                                                             toastr, DTOptionsBuilder, DTColumnBuilder, $q, $filter,
                                                             $compile, $scope, DataTablesService) {
        var vm = this;

        vm.chart = chart;
        vm.contact = contact;

        vm.typePatientProcess = {
            name: ""
        }

        vm.urgentIssues = [];
        vm.urgentIssue = {};
        vm.dtInstance = {};
        vm.reload = false;

        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.assign = assign;

        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            if (vm.chart.typeLevelCare != null) {
                var defer = $q.defer();
                if (!vm.searchQuery || vm.searchQuery == '') {
                    EvaluationTemplate.findAllByRelease({
                        id: chart.id
                    }, function (result) {
                        vm.evaluationTemplate = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve($filter('filter')(vm.evaluationTemplate, vm.searchQuery, undefined));
                }

                return defer.promise;
            }
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Template Name')
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function assign() {
            var assign = {
                chart: chart,
                contacts: contact,
                ids: vm.getSelectedIds(vm.selected)
            }

            if (assign.ids.length > 0) {
                vm.isSaving = true;

                save(assign);
            }
        }

        function save(assign) {
            Evaluation.assign(assign, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                $uibModalInstance.close(true);
                toastr.success("Care & Delivery Add to the Chart");
            }

            function onSaveError() {
                vm.isSaving = false;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateCloneToFacilityController',EvaluationTemplateCloneToFacilityController);

    EvaluationTemplateCloneToFacilityController.$inject = ['$uibModalInstance', 'entity', 'EvaluationTemplate', 'Facility'];

    function EvaluationTemplateCloneToFacilityController($uibModalInstance, entity, EvaluationTemplate, Facility) {
        var vm = this;

        vm.evaluationTemplate = entity;
        vm.showDelete = false;

        vm.clear = clear;
        vm.confirmClone = confirmClone;

        Facility.getAll(function (result) {
            vm.facilities = result;
        })

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmClone () {
            EvaluationTemplate.cloneToFacility({id: vm.evaluationTemplate.id, facilityId: vm.selectedFacility.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateCloneController',EvaluationTemplateCloneController);

    EvaluationTemplateCloneController.$inject = ['$uibModalInstance', 'entity', 'EvaluationTemplate'];

    function EvaluationTemplateCloneController($uibModalInstance, entity, EvaluationTemplate) {
        var vm = this;

        vm.evaluationTemplate = entity;
        vm.clear = clear;
        vm.confirmClone = confirmClone;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmClone (id) {
            EvaluationTemplate.clone({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateAssignDialogController', EvaluationTemplateAssignDialogController);

    EvaluationTemplateAssignDialogController.$inject = ['$timeout', 'typePatientProcess', 'chart', '$uibModalInstance', 'EvaluationTemplate', 'Evaluation',
        'toastr', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$compile', '$scope', 'DataTablesService'];

    function EvaluationTemplateAssignDialogController($timeout, typePatientProcess, chart, $uibModalInstance, EvaluationTemplate, Evaluation,
                                                      toastr, DTOptionsBuilder, DTColumnBuilder, $q, $filter, $compile, $scope, DataTablesService) {
        var vm = this;
        vm.chart = chart;

        vm.typePatientProcess = typePatientProcess;
        vm.urgentIssues = [];
        vm.urgentIssue = {};
        vm.dtInstance = {};
        vm.reload = false;

        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.assign = assign;

        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            if (vm.chart.typeLevelCare != null) {
                var defer = $q.defer();
                if (!vm.searchQuery || vm.searchQuery == '') {
                    EvaluationTemplate.findAllByPatientProcess({
                        id: chart.id,
                        process: typePatientProcess.id
                    }, function (result) {
                        vm.evaluationTemplate = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve($filter('filter')(vm.evaluationTemplate, vm.searchQuery, undefined));
                }

                return defer.promise;
            }
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Template Name'),
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function assign() {
            var assign = {
                chart: chart,
                ids: vm.getSelectedIds(vm.selected)
            }

            if (assign.ids.length > 0) {
                vm.isSaving = true;

                save(assign);
            }
        }

        function save(assign) {
            Evaluation.assign(assign, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                $uibModalInstance.close(true);
                toastr.success("Care & Delivery Add to the Chart");
            }

            function onSaveError() {
                vm.isSaving = false;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationTemplateAssignNewDialogController', EvaluationTemplateAssignNewDialogController);

    EvaluationTemplateAssignNewDialogController.$inject = ['$timeout', 'typePatientProcess', 'chart',
        '$uibModalInstance', 'EvaluationTemplate', 'Evaluation',
        'toastr', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter',
        '$compile', '$scope', 'DataTablesService'];

    function EvaluationTemplateAssignNewDialogController($timeout, typePatientProcess, chart,
                                                         $uibModalInstance, EvaluationTemplate, Evaluation,
                                                         toastr, DTOptionsBuilder, DTColumnBuilder, $q, $filter,
                                                         $compile, $scope, DataTablesService) {
        var vm = this;
        vm.chart = chart;

        vm.typePatientProcess = typePatientProcess;
        vm.dtInstance = {};

        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.assign = assign;
        vm.search = search;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            if (vm.chart.typeLevelCare != null) {
                if (!vm.searchQuery || vm.searchQuery == '') {
                    EvaluationTemplate.findAllByPatientProcess({
                        id: chart.id,
                        process: typePatientProcess.id
                    }, function (result) {
                        vm.evaluationTemplate = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve($filter('filter')(vm.evaluationTemplate, vm.searchQuery, undefined));
                }
            }

            return defer.promise;
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Template Name'),
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function assign() {
            var assign = {
                chart: chart,
                ids: vm.getSelectedIds(vm.selected)
            }

            if (assign.ids.length > 0) {
                vm.isSaving = true;

                save(assign);
            }
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function save(assign) {
            Evaluation.assign(assign, onSaveSuccess, onSaveError);

            function onSaveSuccess(result) {
                $uibModalInstance.close(true);
                toastr.success("Care & Delivery Add to the Chart");
            }

            function onSaveError() {
                vm.isSaving = false;
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationMedication', EvaluationMedication);

    EvaluationMedication.$inject = ['$resource'];

    function EvaluationMedication ($resource) {
        var resourceUrl =  'api/evaluation-medications/:id';

        return $resource(resourceUrl, {}, {
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-medications/by-evaluation/:id', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationMedicationController', EvaluationMedicationController);

    EvaluationMedicationController.$inject = ['$scope', '$state', 'EvaluationMedication', 'entity', 'PopupService'];

    function EvaluationMedicationController($scope, $state, EvaluationMedication, entity, PopupService) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationMedications = [];

        vm.loadAll = loadAll;
        vm.add = add;

        loadAll();

        function loadAll() {
            if (!vm.evaluation.medications) {

                return;
            }

            EvaluationMedication.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationMedications = result;
            });
        }

        function add() {
            PopupService.showEvaluationPatientMedicationPopup(vm.evaluation).result.then(function () {
                loadAll();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationGlucoseDialogController', EvaluationGlucoseDialogController);

    EvaluationGlucoseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'EvaluationGlucose', 'GlucoseIntervention', 'TypeCheck', 'CoreService'];

    function EvaluationGlucoseDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                               EvaluationGlucose, GlucoseIntervention, TypeCheck, CoreService) {
        var vm = this;

        vm.evaluationGlucose = entity;
        vm.glucose = angular.copy(vm.evaluationGlucose.glucose);
        vm.glucoseinterventions = GlucoseIntervention.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.corporation = CoreService.getCorporation();
        vm.typeCheck = TypeCheck.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

        vm.datePickerOpenStatus = {};
        vm.form = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            vm.evaluationGlucose.glucose = vm.glucose;

            if (vm.evaluationGlucose.id !== null) {
                EvaluationGlucose.update(vm.evaluationGlucose, onSaveSuccess, onSaveError);
            } else {
                EvaluationGlucose.save(vm.evaluationGlucose, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:evaluationGlucoseUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationGlucose', EvaluationGlucose);

    EvaluationGlucose.$inject = ['$resource'];

    function EvaluationGlucose ($resource) {
        var resourceUrl =  'api/evaluation-glucoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-glucoses/by-evaluation/:id', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationGlucoseController', EvaluationGlucoseController);

    EvaluationGlucoseController.$inject = ['$scope', '$state', 'EvaluationGlucose', 'entity', '$uibModal'];

    function EvaluationGlucoseController($scope, $state, EvaluationGlucose, entity, $uibModal) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationGlucose = null;

        vm.loadAll = loadAll;
        vm.add = add;
        vm.history = history;

        loadAll();

        function loadAll() {
            if (!vm.evaluation.glucose) {
                return;
            }

            EvaluationGlucose.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                if (result.length > 0) {
                    vm.evaluationGlucose = result[0];
                    vm.glucoseInterventions = _.map(vm.evaluationGlucose.glucoseInterventions, function (glucoseIntervention) {
                        return glucoseIntervention.name;
                    }).join(', ');
                }
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/glucose/update/glucose-dialog.html',
                controller: 'EvaluationGlucoseDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            evaluation: {id: vm.evaluation.id},
                            glucose: {
                                name: null,
                                id: null,
                                chart: vm.evaluation.chart
                            }
                        }
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/glucose/history/glucose-history.html',
                controller: 'GlucoseHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.evaluation.chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationFile', EvaluationFile);

    EvaluationFile.$inject = ['$resource', 'DataUtils'];

    function EvaluationFile ($resource, DataUtils) {
        var resourceUrl =  'api/evaluation-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-files/by-evaluation/:id', isArray: true},
            'attachFiles': {url: 'api/evaluation-files/attach-files', method: 'POST', isArray: true},
            'download': {
                url: 'api/evaluation-files/get-file/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDietDialogController', EvaluationDietDialogController);

    EvaluationDietDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity',
        'EvaluationDiet', 'Evaluation', 'Diet', 'TypeFoodDiets', 'CoreService'];

    function EvaluationDietDialogController($timeout, $scope, $uibModalInstance, entity,
                                            EvaluationDiet, Evaluation, Diet, TypeFoodDiets, CoreService) {
        var vm = this;

        vm.evaluationDiet = entity;
        vm.diet = vm.evaluationDiet.diet;
        vm.chart = vm.diet.chart;
        vm.typeFoodDiets = TypeFoodDiets.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.form = {};

        vm.clear = clear;
        vm.save = save;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};

        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.evaluationDiet.id !== null) {
                EvaluationDiet.update(vm.evaluationDiet, onSaveSuccess, onSaveError);
            } else {
                EvaluationDiet.save(vm.evaluationDiet, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:evaluationDietUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.diet.startDate;
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.diet.endDate;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationDiet', EvaluationDiet);

    EvaluationDiet.$inject = ['$resource'];

    function EvaluationDiet ($resource) {
        var resourceUrl =  'api/evaluation-diets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-diets/by-evaluation/:id', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDietController', EvaluationDietController);

    EvaluationDietController.$inject = ['$scope', '$state', 'EvaluationDiet', 'entity', '$uibModal', 'Diet',
        '$uibModalStack'];

    function EvaluationDietController($scope, $state, EvaluationDiet, entity, $uibModal, Diet,
                                      $uibModalStack) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationDiets = [];

        vm.loadAll = loadAll;
        vm.add = add;
        vm.edit = edit;
        vm.history = history;

        loadAll();

        function loadAll() {
            EvaluationDiet.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationDiets = result;
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/diet/update/diet-dialog.html',
                controller: 'EvaluationDietDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            evaluation: {id: vm.evaluation.id},
                            diet: {
                                description: null,
                                id: null,
                                endDate: null,
                                startDate: null,
                                chart: vm.evaluation.chart
                            }
                        }
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function edit(evaluationDiet) {
            $uibModal.open({
                templateUrl: 'app/entities/diet/update/diet-dialog.html',
                controller: 'DietDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Diet', function (Diet) {
                        return Diet.get({id: evaluationDiet.dietId}).$promise;
                    }]
                }
            }).result.then(function (result) {
                Diet.findAllByChart({chartId: vm.evaluation.chartId, active: true}, function (dietsActive) {
                    if (result.id && !_.find(dietsActive, {id: result.id})) {
                        EvaluationDiet.delete({id: evaluationDiet.id}, function () {
                            loadAll();
                        })
                    } else {
                        loadAll();
                    }
                });
            }, function () {
                loadAll();
            });
        }

        function history() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/diet/history/diet-history.html',
                controller: 'DietHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.evaluation.chart
                }
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDietsHistoryController', EvaluationDietsHistoryController);

    EvaluationDietsHistoryController.$inject = ['$uibModalInstance', 'Diet', 'chart'];

    function EvaluationDietsHistoryController($uibModalInstance, Diet, chart) {
        var vm = this;

        vm.dietsInactive = [];
        vm.dietsInactive = Diet.findAllByChart({chartId: chart.id, page: 0, size: 100});

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDiagnosisDialogController', EvaluationDiagnosisDialogController);

    EvaluationDiagnosisDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity',
        'EvaluationDiagnosis', 'Evaluation', 'Diagnoses', 'Icd10Search', 'evaluation'];

    function EvaluationDiagnosisDialogController($timeout, $scope, $uibModalInstance, entity,
                                                 EvaluationDiagnosis, Evaluation, Diagnoses, Icd10Search, evaluation) {
        var vm = this;

        vm.save = save;
        vm.clear = clear;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;
        vm.getIcd10 = getIcd10;

        init();

        function init() {
            vm.evaluationDiagnosis = {
                evaluation: evaluation
            }

            vm.diagnoses = entity;
            vm.icd10 = [];

            vm.datePickerOpenStatus = {
                startDate: false,
                endDate: false
            };
            vm.endDateOptions = {};
            vm.startDateOptions = {};
        }

        function getIcd10(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.diagnoses.endDate;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.diagnoses.startDate;
            vm.endDateOptions.maxDate = new Date();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.close('dismiss');
        }

        function save() {
            vm.isSaving = true;

            vm.evaluationDiagnosis.diagnosisDTO = vm.diagnoses;

            EvaluationDiagnosis.save(vm.evaluationDiagnosis, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationDiagnosis', EvaluationDiagnosis);

    EvaluationDiagnosis.$inject = ['$resource'];

    function EvaluationDiagnosis ($resource) {
        var resourceUrl =  'api/evaluation-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-diagnoses/by-evaluation/:id', isArray: true },
            'reorder': { method: 'POST', url: 'api/evaluation-diagnoses/reorder', isArray: false }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDiagnosisController', EvaluationDiagnosisController);

    EvaluationDiagnosisController.$inject = ['$scope', '$state', 'EvaluationDiagnosis', '$uibModal', 'entity',
        'PopupService', 'Diagnoses'];

    function EvaluationDiagnosisController($scope, $state, EvaluationDiagnosis, $uibModal, entity,
                                           PopupService, Diagnoses) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationDiagnoses = [];

        vm.loadAll = loadAll;
        vm.add = add;
        vm.history = history;
        vm.edit = edit;

        loadAll();

        function loadAll() {
            if (!vm.evaluation.diagnosis) {
                return;
            }

            EvaluationDiagnosis.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationDiagnoses = result;
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/diagnoses/create/diagnoses-create-dialog.html',
                controller: 'EvaluationDiagnosisDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    evaluation: {id: vm.evaluation.id},

                    entity: {
                        comment: null,
                        endDate: null,
                        startDate: null,
                        chart: null
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-diagnosis/history/evaluation-diagnoses-history.html',
                controller: 'EvaluationDiagnosesHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.evaluation.chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function edit(evaluationDiagnosis) {
            PopupService.showDiagnosesEditPopup(evaluationDiagnosis.diagnosesId).result.then(function (result) {
                Diagnoses.findAllActiveDiagnosesByChartId({id: vm.evaluation.chartId}, function (diagnosisActive) {
                    if (result.id && !_.find(diagnosisActive, {id: result.id})) {
                        EvaluationDiagnosis.delete({id: evaluationDiagnosis.id}, function () {
                            loadAll();
                        })
                    } else {
                        loadAll();
                    }
                });
            });
        }

        vm.onDragEnd = onDragEnd;

        function onDragEnd(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].xorder !== i + 1) {
                    list[i].xorder = i + 1;
                    EvaluationDiagnosis.reorder({id: list[i].id, xorder: list[i].xorder})

                } else {
                    list[i].xorder = i + 1;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDiagnosesHistoryController', EvaluationDiagnosesHistoryController);

    EvaluationDiagnosesHistoryController.$inject = ['$uibModalInstance', 'Diagnoses', 'chart'];

    function EvaluationDiagnosesHistoryController($uibModalInstance, Diagnoses, chart) {
        var vm = this;

        vm.diagnosesInactive = [];
        vm.diagnosesInactive = Diagnoses.findAllInactiveDiagnosesByChart({id: chart.id});

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationCommentsDialogController', EvaluationCommentsDialogController);

    EvaluationCommentsDialogController.$inject = ['$scope', '$uibModalInstance','entity', 'EvaluationComment'];

    function EvaluationCommentsDialogController( $scope, $uibModalInstance, entity, EvaluationComment ) {

        var vm = this;

        vm.comments = entity;

        vm.save = save;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.close('dismiss');
        }

        function save() {
            vm.isSaving = true;

            if (vm.comments.id) {
                EvaluationComment.update(vm.comments, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:diagnosesUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();


(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationComment', EvaluationComment);

    EvaluationComment.$inject = ['$resource'];

    function EvaluationComment($resource) {
        var resourceUrl = 'api/evaluation-comments/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }

                    return data;
                }
            },
            'update': {method: 'PUT'},
            'addComment': {url: 'api/evaluation-comments/add-comment', method: 'POST', isArray: false},
            'findAllByEvaluation': {
                url: 'api/evaluation-comments/by-evaluation/:id', method: 'GET', isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationCommentController', EvaluationCommentController);

    EvaluationCommentController.$inject = ['$uibModal', 'entity', 'AlertService', 'EvaluationComment', 'toastr',
        'ConfirmationService'];

    function EvaluationCommentController($uibModal, entity, AlertService, EvaluationComment, toastr,
                                         ConfirmationService) {
        var vm = this;

        vm.evaluation = entity;
        vm.comments = [];
        vm.comment = null;

        vm.page = 1;
        vm.itemsPerPage = 6;

        vm.add = add;
        vm.transition = transition;
        vm.edit = edit;
        vm.del = del;

        loadAll();

        function loadAll() {
            EvaluationComment.findAllByEvaluation(getFilter(),
                function (data, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.queryCount = vm.totalItems;
                    vm.comments = data;
                },

                function (error) {
                    AlertService.error(error.data.message);
                });
        }

        function transition() {
            loadAll();
        }

        function search() {
            vm.page = 1;

            loadAll();
        }

        function getFilter() {
            var filter = {
                id: vm.evaluation.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }

            return filter;
        }

        function add() {
            vm.isSaving = true;
            EvaluationComment.save({
                evaluation: {id: vm.evaluation.id},
                chart: {id: vm.evaluation.chart.id},
                comment: vm.comment
            }, function (result) {
                toastr.success('The Comment was added successful');
                vm.comment = null;
                search();
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-comment/update/evaluation-comment-dialog.html',
                controller: 'EvaluationCommentsDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['EvaluationComment', function (EvaluationComment) {
                        return EvaluationComment.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Comment').result.then(function () {
                EvaluationComment.delete({id: id}, function () {
                    search();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationAuditDialogController', EvaluationAuditDialogController);

    EvaluationAuditDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'EvaluationAudit', 'CoreService', 'EvaluationTemplate'];

    function EvaluationAuditDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                             EvaluationAudit, CoreService, EvaluationTemplate) {
        var vm = this;

        vm.evaluationAudit = entity;
        vm.evaluationAuditTemplates = [];
        vm.form = {};

        vm.clear = clear;
        vm.save = save;
        vm.getEvaluationTemplates = getEvaluationTemplates;
        vm.add = add;
        vm.del = del;

        init();

        function init() {
            if (vm.evaluationAudit.id) {
                EvaluationAudit.findAllByEvaluationAudit({id: vm.evaluationAudit.id}, function (result) {

                    _.forEach(result, function (resultTemplate) {
                        var evaluationAuditTemplate = _.find(vm.evaluationAuditTemplates, function (evaluationAuditTemplate) {

                            return evaluationAuditTemplate.quantity == resultTemplate.quantity;
                        });

                        if (evaluationAuditTemplate) {
                            evaluationAuditTemplate.evaluationTemplates.push(
                                {id: resultTemplate.id, name: resultTemplate.name}
                            );
                        } else {
                            vm.evaluationAuditTemplates.push({
                                evaluationTemplates: [{id: resultTemplate.id, name: resultTemplate.name}],
                                quantity: resultTemplate.quantity
                            });
                        }
                    })
                });
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.evaluationAudit.id !== null) {
                var evaluationAudit = createDto();

                EvaluationAudit.update(evaluationAudit, onSaveSuccess, onSaveError);
            } else {
                var evaluationAudit = createDto();

                EvaluationAudit.save(evaluationAudit, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:evaluationAuditUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getFilter(query) {
            var filter = {};

            filter.facilityId = CoreService.getCurrentFacility().id;
            filter.page = 0;
            filter.size = 100000;
            filter.searchQuery = query;
            filter.enabled = true;

            return filter
        }

        function getEvaluationTemplates(query) {
            EvaluationTemplate.findAllByFilter(getFilter(query), function (result) {
                vm.evaluationTemplates = result;
            });
        }

        function add() {
            vm.evaluationAuditTemplates.push({evaluationTemplates: [], quantity: 1});
        }

        function del(index) {
            if (vm.evaluationAuditTemplates.length > 1) {
                vm.evaluationAuditTemplates.splice(index, 1);
            }
        }

        function createDto() {
            var _evaluationAuditTemplates = [];

            _.forEach(vm.evaluationAuditTemplates, function (evaluationAuditTemplate) {
                _.forEach(evaluationAuditTemplate.evaluationTemplates, function (evaluationTemplate) {

                    var temp = _.find(_evaluationAuditTemplates, function (_evaluationAuditTemplate) {
                        return _evaluationAuditTemplate.evaluationTemplate.id === evaluationTemplate.id;
                    });

                    if (temp) {
                        temp.quantity += evaluationAuditTemplate.quantity
                    } else {
                        _evaluationAuditTemplates.push({
                            quantity: evaluationAuditTemplate.quantity,
                            evaluationTemplate: evaluationTemplate
                        });
                    }
                })
            })

            var _evaluationAudit = angular.copy(vm.evaluationAudit);
            _evaluationAudit.evaluationAuditTemplates = _evaluationAuditTemplates;

            return _evaluationAudit;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationAudit', EvaluationAudit);

    EvaluationAudit.$inject = ['$resource'];

    function EvaluationAudit($resource) {
        var resourceUrl = 'api/evaluation-audits/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByFilter': {url: 'api/evaluation-audits/filter', method: 'GET', isArray: true},
            'findAllByEvaluationAudit': {
                url: 'api/evaluation-audits/evaluation-audit-templates/by-evaluation-audit/:id',
                method: 'GET', isArray: true
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationAuditController', EvaluationAuditController);

    EvaluationAuditController.$inject = ['EvaluationAudit', 'CoreService', '$rootScope', 'ConfirmationService',
        '$uibModal', 'GenericEntityDatatableService', '$q'];

    function EvaluationAuditController(EvaluationAudit, CoreService, $rootScope, ConfirmationService,
                                       $uibModal, GenericEntityDatatableService, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Care & Delivery Audits',
            entityClassHumanized: 'Care & Delivery Audits',
            entityStateName: 'evaluation-audit',
            service: EvaluationAudit,
            serviceMethod: 'findAllByFilter',
            newButtonTitle: 'New Care & Delivery Audit',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [{key: 'aaSorting', value: [[0, 'desc']]}],
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'createdDate',
                    title: 'Created Date',
                    render: function (data) {
                        return moment(data.createdDate).format($rootScope.amDateFormat);
                    }
                },
                {
                    name: 'createdBy',
                    title: 'Created By'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Care & Delivery Audit',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/evaluation-audit/update/evaluation-audit-dialog.html',
                controller: 'EvaluationAuditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            facility: CoreService.getCurrentFacility(),
                            evaluationAuditTemplates: [
                                {
                                    evaluationTemplates: [],
                                    quantity: 1
                                }
                            ]
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/evaluation-audit/update/evaluation-audit-dialog.html',
                controller: 'EvaluationAuditDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['EvaluationAudit', function (EvaluationAudit) {
                        return EvaluationAudit.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Care & Delivery Audit').result.then(function () {
                    EvaluationAudit.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('evaluation-audit', {
            parent: 'entity',
            url: '/evaluation-audit',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'EvaluationAudits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/evaluation-audit/list/evaluation-audit.html',
                    controller: 'EvaluationAuditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_EVALUATION_AUDIT];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_EVALUATION_AUDIT, access);
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationAllergyDialogController', EvaluationAllergyDialogController);

    EvaluationAllergyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'EvaluationAllergy', 'CoreService', 'GUIUtils', 'Allergen', 'Reaction',
        'Severity'];

    function EvaluationAllergyDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                               EvaluationAllergy, CoreService, GUIUtils, Allergen, Reaction,
                                               Severity) {
        var vm = this;

        vm.evaluationAllergy = entity;
        vm.allergies = vm.evaluationAllergy.allergy;

        vm.chart = entity.evaluation.chart;
        vm.onset = GUIUtils.getOnset();
        vm.severities = Severity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.allergen = Allergen.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.reaction = Reaction.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.form = {};

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.reactionDate = false;

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;

        vm.currentDate = {
            maxDate: new Date()
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.evaluationAllergy.id !== null) {
                EvaluationAllergy.update(vm.evaluationAllergy, onSaveSuccess, onSaveError);
            } else {
                EvaluationAllergy.save(vm.evaluationAllergy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EvaluationAllergy', EvaluationAllergy);

    EvaluationAllergy.$inject = ['$resource'];

    function EvaluationAllergy ($resource) {
        var resourceUrl =  'api/evaluation-allergies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByEvaluation': {method: 'GET', url: 'api/evaluation-allergies/by-evaluation/:id', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationAllergyController', EvaluationAllergyController);

    EvaluationAllergyController.$inject = ['$scope', '$state', 'EvaluationAllergy', 'entity', '$uibModal'];

    function EvaluationAllergyController ($scope, $state, EvaluationAllergy, entity, $uibModal) {
        var vm = this;

        vm.evaluation = entity;
        vm.evaluationAllergies = [];

        vm.loadAll = loadAll;
        vm.add = add;
        vm.edit = edit;
        vm.history = history;

        loadAll();

        function loadAll() {
            if (!vm.evaluation.allergies) {
                return;
            }
            EvaluationAllergy.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationAllergies = result;
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/allergies/update/allergies-dialog.html',
                controller: 'EvaluationAllergyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            evaluation: {id: vm.evaluation.id},
                            allergy: {
                                name: null,
                                reaction: null,
                                treatment: null,
                                id: null,
                                active: true,
                                chart: vm.evaluation.chart
                            }
                        }
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function edit(evaluationAllergy) {
            $uibModal.open({
                templateUrl: 'app/entities/allergies/update/allergies-dialog.html',
                controller: 'AllergiesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Allergies', function (Allergies) {
                        return Allergies.get({id: evaluationAllergy.allergyId}).$promise;
                    }]
                }
            }).result.then(function (result) {
                if (result.id && !result.active) {
                    EvaluationAllergy.delete({id: evaluationAllergy.id}, function () {
                        loadAll();
                    });
                } else {
                    loadAll();
                }
            }, function () {
                loadAll();
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-allergy/history/evaluation-allergies-history.html',
                controller: 'EvaluationAllergiesHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.evaluation.chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationAllergiesHistoryController', EvaluationAllergiesHistoryController);

    EvaluationAllergiesHistoryController.$inject = ['$uibModalInstance', 'Allergies', 'chart'];

    function EvaluationAllergiesHistoryController($uibModalInstance, Allergies, chart) {
        var vm = this;

        vm.allergiesInactive = [];
        Allergies.findAllByChartAndStatus({id: chart.id, status: false}, function (result) {
            vm.allergiesInactive = result;

            _.forEach(vm.allergiesInactive, function (allergy) {
                allergy.reaction = _.map(allergy.reactions, function (reaction) {

                    return reaction.name;
                }).join(', ');
            });
        });

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationEditController', EvaluationEditController);

    EvaluationEditController.$inject = ['entity', 'jsonTemplate', 'Evaluation', 'Chart', '$timeout', '$scope', 'toastr', 'tokens',
        'PopupService', 'Contacts', '$uibModal', 'CoreService', '$rootScope', 'Assistant',
        'PendingPdfChartReport', '$state', 'params', '$window', 'REPORT_TYPE', 'TAB', 'access', 'ACTIONS',
        '$interval', 'ConfirmationService', 'TypeLevelCare'];

    function EvaluationEditController(entity, jsonTemplate, Evaluation, Chart, $timeout, $scope, toastr, tokens,
                                      PopupService, Contacts, $uibModal, CoreService, $rootScope, Assistant,
                                      PendingPdfChartReport, $state, params, $window, REPORT_TYPE, TAB, access, ACTIONS,
                                      $interval, ConfirmationService, TypeLevelCare) {
        var vm = this;

        vm.evaluation = entity;
        vm.jsonTemplate = jsonTemplate;
        vm.chart = vm.evaluation.chart;
        vm.contact = vm.evaluation.contact;

        vm.params = params;
        vm.dateDiff = "";
        vm.enablePatientSignature = false;
        vm.enableGuarantorSignature = false;
        vm.enableStaffSignature = false;
        vm.enableStaffReviewerSignature = false
        vm.enableRevokeSignature = false;
        vm.compareEvaluation = null;
        vm.compareTokens = null;
        vm.compareWith = null;

        vm.guarantorSignatureButtonStyle = "";
        vm.staffSignatureButtonStyle = "";
        vm.staffReviewSignatureButtonStyle = "";

        vm.employee = CoreService.getCurrentEmployee();
        vm.evaluations = [];
        vm.signType = null;

        init();

        $rootScope.assistantList = Assistant.findAllBySection({
            section: 'CARE_DELIVERY',
            facility: vm.chart.facility.id
        });
        $rootScope.showAssitant = true;
        vm.openStepSelector = false;
        vm.sideBySide = false;
        vm.sideForm = false;
        vm.type = {
            PATIENT: 'patient',
            GUARANTOR: 'guarantor',
            STAFF: 'staff',
            STAFF_REVIEW: 'staff_review',
            REVOKE: 'revoke'
        }

        vm.accessCareCoordinationView = access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW] ?
            access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW].roles.join() : null;

        vm.TAB = TAB;
        vm.interval = null;
        vm.typeLevelCare = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));

        vm.toggleSideBySide = toggleSideBySide;
        vm.editContact = editContact;
        vm.showBillingDatesPopup = showBillingDatesPopup;
        vm.showDateOfServicePopup = showDateOfServicePopup;
        vm.showChartSignPopup = showChartSignPopup;
        vm.showGuarantorSignPopup = showGuarantorSignPopup;
        vm.showStaffSignPopup = showStaffSignPopup;
        vm.showStaffReviewSignPopup = showStaffReviewSignPopup;
        vm.showChartRevokeSignPopup = showChartRevokeSignPopup;
        vm.search = search;
        vm.compare = compare;
        vm.print = print;
        vm.restart = restart;
        vm.getHumanTitle = getHumanTitle;
        vm.getCredentials = getCredentials;
        vm.autoSaveLoc = autoSaveLoc;

        function init() {
            $window.scrollTo(0, 0);

            switch (vm.evaluation.status) {
                case "Finalized": {
                    if (vm.params.processId) {
                        Evaluation.noSignedPendingOrLate({
                            evaluationId: vm.evaluation.id, typePatientProcessId: vm.params.processId
                        }).$promise.then(function (data) {
                            if (data && data.id) {
                                $state.go('care-delivery', {id: data.id, processId: vm.params.processId});
                            } else {
                                $state.go("care-delivery-view", {id: vm.evaluation.id});
                            }
                        });
                    } else {
                        $state.go("care-delivery-view", {id: vm.evaluation.id});
                    }

                    break;
                }
                case "Revoked":
                case "Expired":
                case "Amended": {
                    $state.go("care-delivery-view", {id: vm.evaluation.id});

                    return;
                }
            }

            if (vm.watcher) {
                vm.watcher();
            }

            getDateDiff();

            vm.enablePatientSignature = isEnablePatientSignature();
            vm.enableGuarantorSignature = isEnableGuarantorSignature();
            vm.enableStaffSignature = isEnableStaffSignature();
            vm.enableStaffReviewerSignature = isEnableStaffReviewerSignature();

            vm.guarantorSignatureButtonStyle = getGuarantorSignatureButtonStyle();
            vm.staffSignatureButtonStyle = getStaffSignatureButtonStyle();
            vm.staffReviewSignatureButtonStyle = getStaffReviewSignatureButtonStyle();

            vm.formCKEditorTokensConfig = {
                ckeditor: {
                    tokens: tokens
                }
            };

            Chart.get({id: vm.evaluation.chartId}, function (chart) {
                vm.chart = chart;
            });

            if (vm.evaluation.contact) {
                Contacts.get({id: vm.evaluation.contact.id}, function (result) {
                    vm.contact = result;
                })
            }

            $timeout(function () {
                vm.watcher = $scope.$watch('vm.jsonTemplate', function (newValue, oldValue, scope) {
                    if (oldValue !== newValue) {
                        if (!vm.autoSaveId) {
                            vm.interval = $interval(autoSave, 1500);
                        }

                        vm.lastUpdate = new Date();
                        vm.autoSaveId = Math.random();
                    }
                }, true);
            }, 1000);
        }

        function autoSave() {
            if (vm.isSaving || !vm.autoSaveId) {

                return;
            }

            if (vm.savedId === vm.autoSaveId) {
                vm.autoSaveId = null;
                vm.savedId = null;

                $interval.cancel(vm.interval);

                return;
            }

            var now = new Date();

            if (((now.getTime() - vm.lastUpdate.getTime()) / 1000) < 1.5) {

                return;
            }

            vm.isSaving = true;
            vm.savedId = angular.copy(vm.autoSaveId);

            var jsonTemplate = angular.copy(vm.jsonTemplate);

            if (vm.evaluation.status == 'Pending' || vm.evaluation.status == 'Late') {
                vm.evaluation.measurements = getMeasurements(jsonTemplate);
            }

            if (vm.evaluation.addTitle) {
                vm.evaluation.title = vm.evaluation.addTitle;
                vm.evaluation.title = getTitle(vm.evaluation, jsonTemplate);
            }

            Evaluation.autoSave({evaluation: vm.evaluation, jsonTemplate: jsonTemplate}, function (data) {
                toastr.success("Saved: " + getHumanTitle());

                vm.isSaving = false;
                getDateDiff();
            }, function () {
                toastr.error("Error saving: " + getHumanTitle());

                vm.isSaving = false;
                getDateDiff();
            });
        }

        function toggleSideBySide() {
            vm.sideBySide = !vm.sideBySide;
            $rootScope.showAssitant = !vm.sideBySide;

            if (vm.sideBySide) {
                vm.searchQuery = vm.evaluation.name;
                vm.search();
            }
        }

        function getMeasurements(jsonTemplate) {
            var countByTables = [];

            _.forEach(jsonTemplate.layout, function (layout) {
                _.forEach(layout.rows, function (row) {
                    _.forEach(row.cols, function (col) {
                        _.filter(col.fields, {'type': "table", 'totals': true})
                            .forEach(function (table) {
                                var count = 0;
                                var colWithTotal = [];
                                //row
                                for (var i = 0; i < table.matrix.length; i++) {
                                    //column
                                    for (var j = 0; j < table.matrix[i].length; j++) {
                                        if (table.matrix[i][j].total == true || colWithTotal.indexOf(j) != -1) {
                                            if (table.matrix[i][j].total == true) {
                                                colWithTotal.push(j);
                                            }

                                            _.forEach(table.matrix[i][j].fields, function (field) {
                                                switch (field.type) {
                                                    case 'select': {
                                                        if (field.value != null && !isNaN(field.value[field.valueField])) {
                                                            count += parseInt(field.value[field.valueField]);
                                                        }

                                                        break;
                                                    }
                                                    case 'number':
                                                    case 'radio':
                                                    case 'text': {
                                                        if (field.value != null && !isNaN(field.value)) {
                                                            count += parseInt(field.value);
                                                        }

                                                        break;
                                                    }
                                                }
                                            })
                                        }
                                    }
                                }

                                countByTables.push(count);
                            })
                    });
                });
            });

            var measurements = _.mean(countByTables);

            return isNaN(measurements) ? null : measurements;
        }

        function getTitle(evaluation, jsonTemplate) {

            var tokes = getTokens(evaluation.addTitle);

            if (tokes.length == 0) {

                return;
            }

            _.forEach(jsonTemplate.layout, function (layout) {
                _.forEach(layout.rows, function (row) {
                    _.forEach(row.cols, function (col) {
                        _.forEach(col.fields, function (field) {
                            if (field.type == 'table') {
                                for (var i = 0; i < field.matrix.length; i++) {
                                    for (var j = 0; j < field.matrix[i].length; j++) {
                                        _.forEach(field.matrix[i][j].fields, function (_field) {
                                            if (tokes.indexOf(_field.name) != -1 && _field.value) {
                                                replaceField(_field, evaluation);
                                            }
                                        });
                                    }
                                }
                            } else {
                                if (tokes.indexOf(field.name) != -1 && field.value) {
                                    replaceField(field, evaluation);
                                }
                            }
                        });
                    });
                });
            });

            return evaluation.title;
        }

        function getTokens(addTitle) {
            var results = [], re = /{([^}]+)}/g, text;

            while (text = re.exec(addTitle)) {
                results.push(text[1]);
            }

            return results;
        }

        function replaceField(field, evaluation) {
            switch (field.type) {
                case 'select': {
                    evaluation.title = evaluation.title.replace("{" + field.name + "}", field.value.name);

                    break;
                }
                case 'text': {
                    evaluation.title = evaluation.title.replace("{" + field.name + "}", field.value);

                    break;
                }
                default: {
                    evaluation.title = evaluation.title.replace("{" + field.name + "}", "NOT IMPLEMENTED");
                }
            }
        }

        function editContact(id) {
            PopupService.showContactPopup(id).result.then(function (result) {
                vm.contact = result;
            }, function () {
            });
        }

        function getDateDiff() {
            if (vm.evaluation.billable && vm.evaluation.startBilling && vm.evaluation.endBilling) {
                var startD = moment(vm.evaluation.startBilling);
                var endD = moment(vm.evaluation.endBilling);

                vm.dateDiff = endD.diff(startD, 'minutes');
            }
        }

        function showBillingDatesPopup() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/billing-dates/evaluation-billing-dates.html',
                controller: 'EvaluationBillingDatesDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: vm.evaluation
                }
            }).result.then(function (result) {
                vm.evaluation.startBilling = result.startBilling;
                vm.evaluation.endBilling = result.endBilling;

                vm.isSaving = true;
                Evaluation.autoSaveDates({evaluation: vm.evaluation}, function (data) {
                    getDateDiff();
                    toastr.success("Saved: " + getHumanTitle());
                    vm.isSaving = false;
                }, function () {
                    toastr.error("Error saving: " + getHumanTitle());
                    vm.isSaving = false;
                });
            });
        }

        function autoSaveLoc() {
            vm.isSaving = true;
            Evaluation.autoSaveLoc({evaluation: vm.evaluation}, function (data) {
                toastr.success("Saved: " + getHumanTitle());
                vm.isSaving = false;
            }, function () {
                toastr.error("Error saving: " + getHumanTitle());
                vm.isSaving = false;
            });
        }

        function showDateOfServicePopup() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/day-of-service/evaluation-day-of-service.html',
                controller: 'EvaluationDayOfServiceDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: vm.evaluation
                }
            }).result.then(function (result) {
                vm.evaluation.dayOfService = result.dayOfService;

                vm.isSaving = true;
                Evaluation.autoSaveDates({evaluation: vm.evaluation}, function (data) {
                    toastr.success("Saved: " + getHumanTitle());
                    vm.isSaving = false;
                }, function () {
                    toastr.error("Error saving: " + getHumanTitle());
                    vm.isSaving = false;
                });
            });
        }

        function isEnablePatientSignature() {
            return vm.evaluation.requiredPatientSignature && vm.evaluation.chartSignatureId == null;
        }

        function isEnableGuarantorSignature() {
            return vm.evaluation.chartSignatureId;
        }

        function isEnableStaffSignature() {
            vm.haveStaffCredential = vm.evaluation.staffSignatureCredentials == null ||
                vm.evaluation.staffSignatureCredentials.length === 0 ||
                _.intersection(vm.employee.credentials, vm.evaluation.staffSignatureCredentials).length > 0;

            return vm.haveStaffCredential;
        }

        function isEnableStaffReviewerSignature() {
            vm.haveStaffReviewCredential = vm.evaluation.staffReviewSignatureCredentials == null ||
                vm.evaluation.staffReviewSignatureCredentials.length === 0 ||
                _.intersection(vm.employee.credentials, vm.evaluation.staffReviewSignatureCredentials).length > 0;

            return vm.haveStaffReviewCredential;
        }

        function getGuarantorSignatureButtonStyle() {
            if (isEnableGuarantorSignature()) {
                return "fa fa-pencil-square-o";
            } else {
                return "fa fa-ban";
            }
        }

        function getStaffSignatureButtonStyle() {
            if (isEnableStaffSignature()) {
                return "fa fa-pencil-square-o";
            } else {
                return "fa fa-ban";
            }
        }

        function getStaffReviewSignatureButtonStyle() {
            if (isEnableStaffReviewerSignature()) {
                return "fa fa-pencil-square-o";
            } else {
                return "fa fa-ban";
            }
        }

        function signPatient(signature) {
            Evaluation.chartSign({ids: [vm.evaluation.id], signature: signature}, function (result) {
                $state.reload();
            });
        }

        function signRevoke(signature) {
            Evaluation.revoke({ids: [vm.evaluation.id], signature: signature}, function (result) {
                $state.reload();
            });
        }

        function signStaff(signature, pin) {
            Evaluation.staffSign({
                ids: [vm.evaluation.id], signature: signature, pin: pin
            }, function () {
                $state.reload();
            }, function () {
                toastr.error("Error signing Care & Delivery form");
            });
        }

        function signStaffReviewer(signature, pin) {
            Evaluation.staffReviewSign({
                ids: [vm.evaluation.id], signature: signature, pin: pin
            }, function () {
                $state.reload();
            }, function () {
                toastr.error("Error signing Care & Delivery form");
            });
        }

        function showChartSignPopup() {
            if (PopupService.checkSigPlusExtLiteExtension()) {
                startSign(vm.type.PATIENT);
            } else {
                PopupService.showPatientSignaturePopup(vm.chart).result.then(function (data) {
                    signPatient(data);
                });
            }
        }

        function showChartRevokeSignPopup() {
            if (PopupService.checkSigPlusExtLiteExtension()) {
                startSign(vm.type.REVOKE);
            } else {
                PopupService.showPatientSignaturePopup(vm.chart).result.then(function (data) {
                    signRevoke(data)
                });
            }
        }

        function showGuarantorSignPopup() {
            return $uibModal.open({
                templateUrl: 'app/components/udt/signature/signature-contact-dialog.html',
                controller: 'SignatureGuarantorDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    evaluation: vm.evaluation
                }
            }).result.then(function (data) {
                Evaluation.guarantorSign({
                    id: vm.evaluation.id,
                    signature: data.signature,
                    guarantor: data.guarantor
                }, function () {
                    $state.reload();
                });
            });
        }

        function showStaffSignPopup() {
            if (PopupService.checkSigPlusExtLiteExtension()) {
                startSign(vm.type.STAFF);
            } else {
                PopupService.showSignaturePopup().result.then(function (data) {
                    signStaff(data.employeeSignature, data.employeeSignaturePin);
                });
            }
        }

        function showStaffReviewSignPopup() {
            if (PopupService.checkSigPlusExtLiteExtension()) {
                startSign(vm.type.STAFF_REVIEW);
            } else {
                PopupService.showSignaturePopup().result.then(function (data) {
                    signStaffReviewer(data.employeeSignature, data.employeeSignaturePin);
                });
            }
        }

        function search() {
            if (vm.searchQuery && vm.searchQuery.length > 3)
                Evaluation.findAllByFilter({
                    chartId: vm.evaluation.chart.id,
                    facilityId: vm.evaluation.chart.facility.id,
                    searchQuery: vm.searchQuery,
                    page: 0,
                    size: 20
                }, function (result) {
                    vm.compareWith = null;
                    vm.evaluations = result;
                })
        }

        function compare() {
            if (vm.compareWith) {
                Evaluation.get({id: vm.compareWith}, function (result) {
                    vm.compareEvaluation = result;

                    Evaluation.getEvaluationTokensValues({id: vm.compareWith}, function (result) {
                        vm.compareTokens = result;

                        vm.sideBySide = false;
                        vm.sideForm = true;
                    });

                    Evaluation.getJsonTemplate({id: vm.compareWith}, function (result) {
                        vm.compareJsonTemplate = result;
                    })
                });
            }
        }

        function print() {
            vm.isPrinting = true;

            PendingPdfChartReport.save({
                chart: vm.chart,
                objectId: vm.evaluation.id,
                name: vm.evaluation.name,
                reportType: REPORT_TYPE.EVALUATION
            }, onPrintSuccess, onPrintError);

            function onPrintSuccess(result) {
                vm.isPrinting = false;

                toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
            }

            function onPrintError() {
                vm.isPrinting = false;
                toastr.error("We couldn't generate the report.");
            }
        }

        $scope.$on('$destroy', function () {
            if (vm.watcher) {
                vm.watcher();
            }

            $rootScope.showAssitant = false;
        });

        function startSign(type) {
            var message = {
                "firstName": "",
                "lastName": "",
                "eMail": "",
                "location": "",
                "imageFormat": 1,
                "imageX": 500,
                "imageY": 100,
                "imageTransparency": false,
                "imageScaling": false,
                "maxUpScalePercent": 0.0,
                "rawDataFormat": "ENC",
                "minSigPoints": 25
            };

            vm.signType = type;

            top.document.addEventListener('SignResponse', SignResponse, false);
            var messageData = JSON.stringify(message);
            var element = document.createElement("MyExtensionDataElement");
            element.setAttribute("messageAttribute", messageData);
            document.documentElement.appendChild(element);
            var evt = document.createEvent("Events");
            evt.initEvent("SignStartEvent", true, false);
            element.dispatchEvent(evt);
        }

        function SignResponse(event) {
            var str = event.target.getAttribute("msgAttribute");
            var objResponse = JSON.parse(str);
            var obj = null;

            if (typeof (objResponse) === 'string') {
                obj = JSON.parse(objResponse);
            } else {
                obj = JSON.parse(JSON.stringify(objResponse));
            }

            if (obj.errorMsg != null && obj.errorMsg != "" && obj.errorMsg != "undefined") {
                toastr.error(obj.errorMsg);
            } else {
                if (obj.isSigned) {
                    switch (vm.signType) {
                        case vm.type.PATIENT : {
                            signPatient("data:image/jpg;base64," + obj.imageData);

                            break;
                        }
                        case vm.type.STAFF: {
                            signStaff("data:image/jpg;base64," + obj.imageData, null);

                            break;
                        }
                        case vm.type.STAFF_REVIEW: {
                            signStaffReviewer("data:image/jpg;base64," + obj.imageData, null);

                            break;
                        }
                    }
                }
            }

            top.document.removeEventListener('SignResponse', SignResponse, false);
        }

        function restart() {
            ConfirmationService.open({
                title: 'Restore Employee',
                message: 'Are you sure you want to <strong class="text-uppercase">restart</strong> this Evaluation?',
                actions: [
                    {
                        name: 'Restart',
                        color: 'btn btn-success',
                        icon: 'fa fa-times-circle-o',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Cancel',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }).result.then(function () {
                Evaluation.restart({id: vm.evaluation.id}, function () {
                    $state.reload();
                });
            });
        }

        function getHumanTitle() {
            return vm.evaluation.name + (vm.evaluation.title ? vm.evaluation.title : "");
        }

        function getCredentials(credentials) {
            return credentials === null || credentials.length === 0 ? 'Does not require any credentials' : _.join(credentials, ", ");
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Evaluation', Evaluation);

    Evaluation.$inject = ['$resource', 'Utils', 'OdsFormService', 'DateUtils', 'CoreService'];

    function Evaluation($resource, Utils, OdsFormService, DateUtils, CoreService) {
        var resourceUrl = 'api/evaluations/:id';
        var facility = CoreService.getCurrentFacility();

        function transformResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                //TODO fix in the library
                data.staffSignatureCredentials = Utils.objectRoleToArray(data.staffSignatureCredentials);
                data.staffReviewSignatureCredentials = Utils.objectRoleToArray(data.staffReviewSignatureCredentials);

                if (data.billable) {
                    if (data.startBilling) {
                        data.startBilling = new Date(DateUtils.convertDateTimeFromServer(data.startBilling)
                            .toLocaleString("en-US", {timeZone: facility.timeZone}));
                    }

                    if (data.endBilling) {
                        data.endBilling = new Date(DateUtils.convertDateTimeFromServer(data.endBilling)
                            .toLocaleString("en-US", {timeZone: facility.timeZone}));
                    }
                } else {
                    if (data.dayOfService) {
                        data.dayOfService = new Date(DateUtils.convertLocalDateFromServer(data.dayOfService));
                    }
                }

                if (data.vitals && data.vitals.date) {
                    data.vitals.date = DateUtils.convertDateTimeFromServer(data.vitals.date);
                }
            }

            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {method: 'GET', transformResponse: transformResponse},
            'start': {method: 'GET', url: 'api/evaluations/start/:id', transformResponse: transformResponse},
            'findAllByChartAndPatientProcess': {
                url: 'api/evaluations/by-chart',
                method: 'GET',
                isArray: true
            },
            'findAllLastMeasurementsByChart': {
                url: 'api/evaluations/mars-mors-measurements-by-chart',
                method: 'GET',
                isArray: true
            },
            'findAllByChartAndContact': {
                url: 'api/evaluations/by-chart/:id/contact/:contact',
                method: 'GET',
                isArray: true
            },
            'assign': {url: 'api/evaluations/assign', method: 'POST'},
            'next': {
                method: 'POST', url: 'api/evaluations/next',
                transformResponse: transformResponse,
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    return angular.toJson(copy);
                }
            },
            'hasNext': {
                method: 'POST', url: 'api/evaluations/has-next',
                transformResponse: function (data) {
                    return {result: angular.fromJson(data)};
                },
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    return angular.toJson(copy);
                }
            },
            'previous': {
                method: 'POST', url: 'api/evaluations/previous',
                transformResponse: transformResponse,
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    return angular.toJson(copy);
                }
            },
            'noSignedPendingOrLate': {
                method: 'GET', url: 'api/evaluations/pending-late/:evaluationId/:typePatientProcessId',
                transformResponse: transformResponse
            },
            'hasPrevious': {
                method: 'POST', url: 'api/evaluations/has-previous',
                transformResponse: function (data) {
                    return {result: angular.fromJson(data)};
                },
                transformRequest: function (data) {
                    var copy = angular.copy(data);

                    return angular.toJson(copy);
                }
            },
            'chartSign': {method: 'POST', url: 'api/evaluations/chart-sign', isArray: true},
            'guarantorSign': {
                method: 'POST', url: 'api/evaluations/guarantor-sign',
                transformResponse: transformResponse
            },
            'staffSign': {method: 'POST', url: 'api/evaluations/staff-sign', isArray: true},
            'staffReviewSign': {method: 'POST', url: 'api/evaluations/staff-review-sign', isArray: true},
            'autoSaveLoc': {
                url: 'api/evaluations/auto-save-loc',
                method: 'POST',
                ignoreLoadingBar: true,
                transformResponse: transformResponse
            },
            'autoSaveDates': {
                url: 'api/evaluations/auto-save-dates',
                method: 'POST',
                ignoreLoadingBar: true,
                transformResponse: transformResponse
            },
            'autoSave': {
                url: 'api/evaluations/auto-save',
                method: 'POST',
                ignoreLoadingBar: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);

                    return angular.toJson(copy);
                },
                transformResponse: transformResponse
            },
            'amended': {url: 'api/evaluations/amended/:id', method: 'GET'},
            'review': {url: 'api/evaluations/review/:id', method: 'GET'},
            'revoke': {method: 'POST', url: 'api/evaluations/revoke', isArray: true},
            'getEvaluationTokensValues': {
                url: 'api/evaluations/token-values/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'updateCredentials': {url: 'api/evaluations/update-credentials', method: 'POST'},
            'deleteEmpties': {
                url: 'api/evaluations/delete-empty',
                method: 'POST'
            },
            'findAllByFilter': {
                url: 'api/evaluations/find-all-by-filter',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].createdDate = DateUtils.convertDateTimeFromServer(data[i].createdDate);
                        }
                    }
                    return data;
                }
            },
            'findAllPendingByStaffFilter': {
                url: 'api/evaluations/find-all-pending-by-staff-filter',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            data[i].createdDate = DateUtils.convertDateTimeFromServer(data[i].createdDate);
                        }
                    }
                    return data;
                }
            },
            'assignAutomaticsEvaluationsByPatientProcess': {
                url: 'api/evaluations/assign-automatics-evaluations-by-patient-process/:chartId/:typePatientProcessId',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = {count: angular.fromJson(data)};
                    }
                    return data;
                }
            },
            'masterAutoSave': {
                url: 'api/evaluations/master-auto-save',
                method: 'POST',
                ignoreLoadingBar: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.jsonTemplate = angular.toJson(copy.jsonTemplate);

                    return angular.toJson(copy);
                },
                transformResponse: transformResponse
            },
            'masterSignature': {
                url: 'api/evaluations/master-signature',
                method: 'POST',
                ignoreLoadingBar: true
            },
            'findAllChartAndMars': {
                url: 'api/evaluations/by-chart/mars/:id', method: 'GET', isArray: true
            },
            'findAllPendingByIdAndPatientProcess': {
                url: 'api/evaluations/pendings-by-id-patient-process',
                method: 'GET',
                isArray: true
            },
            'assignConsentToContacts': {
                url: 'api/evaluations/assign-consent-to-contacts',
                method: 'POST',
                isArray: true
            },
            'fax': {
                url: 'api/evaluations/fax',
                method: 'POST',
            },
            'getJsonTemplate': {
                url: 'api/evaluations/get-json-template/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = OdsFormService.convertFormSchemaFromServer(data);
                    }

                    return data;
                },
            },
            'retrieve': {url: 'api/evaluations/retrieve/:id', method: 'GET'},
            'restart': {url: 'api/evaluations/restart/:id', method: 'GET'},
            'getHistory': {
                url: 'api/evaluation-histories/history/:id',
                method: 'GET',
                isArray: true
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationMasterEditController', EvaluationMasterEditController);

    EvaluationMasterEditController.$inject = ['entity', 'jsonTemplate', 'Evaluation', 'Chart', '$timeout', '$scope', 'toastr', 'tokens',
        'PopupService', 'Contacts', '$uibModal', 'CoreService', '$rootScope', 'Assistant',
        'PendingPdfChartReport', '$state', 'params', '$window', 'REPORT_TYPE', 'TAB', '$interval'];

    function EvaluationMasterEditController(entity, jsonTemplate, Evaluation, Chart, $timeout, $scope, toastr, tokens,
                                      PopupService, Contacts, $uibModal, CoreService, $rootScope, Assistant,
                                      PendingPdfChartReport, $state, params, $window, REPORT_TYPE, TAB, $interval) {
        var vm = this;

        vm.evaluation = entity;
        vm.jsonTemplate = jsonTemplate;
        vm.chart = vm.evaluation.chart;
        vm.contact = vm.evaluation.contact;

        vm.params = params;
        vm.dateDiff = "";
        vm.compareEvaluation = null;
        vm.compareTokens = null;
        vm.compareWith = null;

        vm.guarantorSignatureButtonStyle = "";
        vm.staffSignatureButtonStyle = "";
        vm.staffReviewSignatureButtonStyle = "";

        vm.employee = CoreService.getCurrentEmployee();
        vm.evaluations = [];

        init();

        $rootScope.assistantList = Assistant.findAllBySection({
            section: 'CARE_DELIVERY',
            facility: vm.chart.facility.id
        });
        $rootScope.showAssitant = true;
        vm.openStepSelector = false;
        vm.sideBySide = false;
        vm.sideForm = false;

        vm.TAB = TAB;

        vm.toggleSideBySide = toggleSideBySide;
        vm.editContact = editContact;
        vm.showBillingDatesPopup = showBillingDatesPopup;
        vm.showDateOfServicePopup = showDateOfServicePopup;
        vm.search = search;
        vm.compare = compare;
        vm.print = print;
        vm.editSignature = editSignature;

        function init() {
            $window.scrollTo(0, 0);

            if (vm.watcher) {
                vm.watcher();
            }

            getDateDiff();

            vm.formCKEditorTokensConfig = {
                ckeditor: {
                    tokens: tokens
                }
            };

            Chart.get({id: vm.evaluation.chartId}, function (chart) {
                vm.chart = chart;
            });

            if (vm.evaluation.contact) {
                Contacts.get({id: vm.evaluation.contact.id}, function (result) {
                    vm.contact = result;
                })
            }

            $timeout(function () {
                vm.watcher = $scope.$watch('vm.jsonTemplate', function (newValue, oldValue, scope) {
                    if (oldValue !== newValue) {
                        if (!vm.autoSaveId) {
                            vm.interval = $interval(autoSave, 1500);
                        }

                        vm.lastUpdate = new Date();
                        vm.autoSaveId = Math.random();
                    }
                }, true);
            }, 1000);
        }

        function autoSave() {
            if (vm.isSaving || !vm.autoSaveId) {

                return;
            }

            if (vm.savedId === vm.autoSaveId) {
                vm.autoSaveId = null;
                vm.savedId = null;

                $interval.cancel(vm.interval);

                return;
            }

            var now = new Date();

            if (((now.getTime() - vm.lastUpdate.getTime()) / 1000) < 1.5) {

                return;
            }

            vm.isSaving = true;
            vm.savedId = angular.copy(vm.autoSaveId);

            var jsonTemplate = angular.copy(vm.jsonTemplate);

            if (vm.evaluation.status == 'Pending' || vm.evaluation.status == 'Late') {
                vm.evaluation.measurements = getMeasurements(jsonTemplate);
            }

            if (vm.evaluation.addTitle) {
                vm.evaluation.title = vm.evaluation.addTitle;
                vm.evaluation.title = getTitle(vm.evaluation, jsonTemplate);
            }

            Evaluation.masterAutoSave({evaluation: vm.evaluation, jsonTemplate: jsonTemplate}, function (data) {
                toastr.success("Saved: " + getHumanTitle());

                vm.isSaving = false;
                getDateDiff();
            }, function () {
                toastr.error("Error saving: " + getHumanTitle());

                vm.isSaving = false;
                getDateDiff();
            });
        }

        function toggleSideBySide() {
            vm.sideBySide = !vm.sideBySide;
            $rootScope.showAssitant = !vm.sideBySide;

            if (vm.sideBySide) {
                vm.searchQuery = vm.evaluation.name;
                vm.search();
            }
        }

        function getMeasurements(jsonTemplate) {
            var countByTables = [];

            _.forEach(jsonTemplate.layout, function (layout) {
                _.forEach(layout.rows, function (row) {
                    _.forEach(row.cols, function (col) {
                        _.filter(col.fields, {'type': "table", 'totals': true})
                            .forEach(function (table) {
                                var count = 0;
                                var colWithTotal = [];
                                //row
                                for (var i = 0; i < table.matrix.length; i++) {
                                    //column
                                    for (var j = 0; j < table.matrix[i].length; j++) {
                                        if (table.matrix[i][j].total == true || colWithTotal.indexOf(j) != -1) {
                                            if (table.matrix[i][j].total == true) {
                                                colWithTotal.push(j);
                                            }

                                            _.forEach(table.matrix[i][j].fields, function (field) {
                                                switch (field.type) {
                                                    case 'select': {
                                                        if (field.value != null && !isNaN(field.value[field.valueField])) {
                                                            count += parseInt(field.value[field.valueField]);
                                                        }

                                                        break;
                                                    }
                                                    case 'number':
                                                    case 'radio':
                                                    case 'text': {
                                                        if (field.value != null && !isNaN(field.value)) {
                                                            count += parseInt(field.value);
                                                        }

                                                        break;
                                                    }
                                                }
                                            })
                                        }
                                    }
                                }

                                countByTables.push(count);
                            })
                    });
                });
            });

            var measurements = _.mean(countByTables);

            return isNaN(measurements) ? null : measurements;
        }

        function getTitle(evaluation, jsonTemplate) {

            var tokes = getTokens(evaluation.addTitle);

            if (tokes.length == 0) {

                return;
            }

            _.forEach(jsonTemplate.layout, function (layout) {
                _.forEach(layout.rows, function (row) {
                    _.forEach(row.cols, function (col) {
                        _.forEach(col.fields, function (field) {
                            if (field.type == 'table') {
                                for (var i = 0; i < field.matrix.length; i++) {
                                    for (var j = 0; j < field.matrix[i].length; j++) {
                                        _.forEach(field.matrix[i][j].fields, function (_field) {
                                            if (tokes.indexOf(_field.name) != -1 && _field.value) {
                                                replaceField(_field, evaluation);
                                            }
                                        });
                                    }
                                }
                            } else {
                                if (tokes.indexOf(field.name) != -1 && field.value) {
                                    replaceField(field, evaluation);
                                }
                            }
                        });
                    });
                });
            });

            return evaluation.title;
        }

        function getTokens(addTitle) {
            var results = [], re = /{([^}]+)}/g, text;

            while (text = re.exec(addTitle)) {
                results.push(text[1]);
            }

            return results;
        }

        function replaceField(field, evaluation) {
            switch (field.type) {
                case 'select': {
                    evaluation.title = evaluation.title.replace("{" + field.name + "}", field.value.name);

                    break;
                }
                case 'text': {
                    evaluation.title = evaluation.title.replace("{" + field.name + "}", field.value);

                    break;
                }
                default: {
                    evaluation.title = evaluation.title.replace("{" + field.name + "}", "NOT IMPLEMENTED");
                }
            }
        }

        function editContact(id) {
            PopupService.showContactPopup(id).result.then(function (result) {
                vm.contact = result;
            }, function () {
            });
        }

        function getDateDiff() {
            if (vm.evaluation.billable && vm.evaluation.startBilling && vm.evaluation.endBilling) {
                var startD = moment(vm.evaluation.startBilling);
                var endD = moment(vm.evaluation.endBilling);

                vm.dateDiff = endD.diff(startD, 'minutes');
            }
        }

        function showBillingDatesPopup() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/billing-dates/evaluation-billing-dates.html',
                controller: 'EvaluationBillingDatesDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: vm.evaluation
                }
            }).result.then(function (result) {
                vm.evaluation.startBilling = result.startBilling;
                vm.evaluation.endBilling = result.endBilling;

                vm.isSaving = true;
                Evaluation.autoSaveDates({evaluation: vm.evaluation}, function (data) {
                    getDateDiff();
                    toastr.success("Saved: " + getHumanTitle());
                    vm.isSaving = false;
                }, function () {
                    toastr.error("Error saving: " + getHumanTitle());
                    vm.isSaving = false;
                });
            });
        }

        function showDateOfServicePopup() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/day-of-service/evaluation-day-of-service.html',
                controller: 'EvaluationDayOfServiceDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: vm.evaluation
                }
            }).result.then(function (result) {
                vm.evaluation.dayOfService = result.dayOfService;

                vm.isSaving = true;
                Evaluation.autoSaveDates({evaluation: vm.evaluation}, function (data) {
                    toastr.success("Saved: " + getHumanTitle());
                    vm.isSaving = false;
                }, function () {
                    toastr.error("Error saving: " + getHumanTitle());
                    vm.isSaving = false;
                });
            });
        }

        function search() {
            if (vm.searchQuery && vm.searchQuery.length > 3)
                Evaluation.findAllByFilter({
                    chartId: vm.evaluation.chart.id,
                    facilityId: vm.evaluation.chart.facility.id,
                    searchQuery: vm.searchQuery,
                    page: 0,
                    size: 20
                }, function (result) {
                    vm.compareWith = null;
                    vm.evaluations = result;
                })
        }

        function compare() {
            if (vm.compareWith) {
                Evaluation.get({id: vm.compareWith}, function (result) {
                    vm.compareEvaluation = result;

                    Evaluation.getEvaluationTokensValues({id: vm.compareWith}, function (result) {
                        vm.compareTokens = result;

                        vm.sideBySide = false;
                        vm.sideForm = true;
                    });

                    Evaluation.getJsonTemplate({id: vm.compareWith}, function (result) {
                        vm.compareJsonTemplate = result;
                    })
                });
            }
        }

        function print() {
            vm.isPrinting = true;

            PendingPdfChartReport.save({
                chart: vm.chart,
                objectId: vm.evaluation.id,
                name: vm.evaluation.name,
                reportType: REPORT_TYPE.EVALUATION
            }, onPrintSuccess, onPrintError);

            function onPrintSuccess(result) {
                vm.isPrinting = false;

                toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
            }

            function onPrintError() {
                vm.isPrinting = false;
                toastr.error("We couldn't generate the report.");
            }
        }

        $scope.$on('$destroy', function () {
            if (vm.watcher) {
                vm.watcher();
            }

            $rootScope.showAssitant = false;
        });

        function editSignature(signature) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/edit-signature/evaluation-edit-signature.html',
                controller: 'EvaluationEditSignatureDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: signature
                }
            }).result.then(function (result) {
                Evaluation.masterSignature({evaluationId: vm.evaluation.id, id: result.id, endDate: result.createdDate}, function (data) {
                    if (data) {
                        toastr.success("Signature date changed successful");

                        // init();
                        $state.reload();
                    }
                }, function () {
                    toastr.error("Failure to change the signature date");
                });
            });
        }

        function getHumanTitle() {
            return vm.evaluation.name + (vm.evaluation.title ? vm.evaluation.title : "");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationMaintenanceController', EvaluationMaintenanceController);

    EvaluationMaintenanceController.$inject = ['CoreService', 'EvaluationTemplate', '$compile', 'DTOptionsBuilder', '$q', '$scope', '$filter',
        'DTColumnBuilder', 'GUIUtils', 'Evaluation'];

    function EvaluationMaintenanceController(CoreService, EvaluationTemplate, $compile, DTOptionsBuilder, $q, $scope, $filter,
                                             DTColumnBuilder, GUIUtils, Evaluation) {
        var vm = this;

        vm.openCalendar = openCalendar;
        vm.title = 'Evaluation Maintenance';

        vm.evaluationTemplates = [];
        vm.dtInstance = {};
        vm.filter = {
            startDate: new Date(2016, 7, 7),
            endDate: new Date(),
            updateStatus: true,
            facilityId: CoreService.getCurrentFacility().id,
            evaluationTemplates: []
        };
        vm.isWorking = false;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};

        vm.selected = {};
        vm.selectAll = false;
        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.updateCredentials = updateCredentials;
        vm.search = search;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                EvaluationTemplate.findAllByFacility({id: CoreService.getCurrentFacility().id}, function (result) {
                    vm.evaluationTemplates = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.evaluationTemplates, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withOption('aaSorting', [])
            .withDisplayLength(10)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder
                .newColumn('name')
                .withOption('class', 'names-col')
                .withTitle('Name'),
            DTColumnBuilder
                .newColumn('enabled')
                .withTitle('Enabled')
                .renderWith(function (data, type, full) {
                    return GUIUtils.colorHtmlYesNo(data);
                }),
            DTColumnBuilder
                .newColumn('requiredPatientSignature')
                .withTitle('Patient Signature')
                .renderWith(function (data, type, full) {
                    return GUIUtils.colorHtmlYesNo(data);
                }),
            DTColumnBuilder
                .newColumn('onlyOne')
                .withTitle('Only One')
                .renderWith(function (data, type, full) {
                    return GUIUtils.colorHtmlYesNo(data);
                }),
            DTColumnBuilder
                .newColumn('billable')
                .withTitle('Billable')
                .renderWith(function (data, type, full) {
                    return GUIUtils.colorHtmlYesNo(data);
                })
        ];

        function updateCredentials() {
            vm.isWorking = true;
            vm.filter.evaluationTemplates = getSelectedIds();

            Evaluation.updateCredentials(vm.filter, function (result) {
                vm.isWorking = false;
            });
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }
            vm.selectAll = true;
        }

        function getSelectedIds() {
            var ids = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    ids.push(id);
                }
            }

            return ids;
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationHistoryAuditController', EvaluationHistoryAuditController);

    EvaluationHistoryAuditController.$inject = ['Evaluation', '$uibModalInstance', '$timeout', 'evaluation'];

    function EvaluationHistoryAuditController(Evaluation, $uibModalInstance, $timeout, evaluation) {
        var vm = this;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.evaluationsHistory = [];
        vm.evaluation = evaluation;

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            Evaluation.getHistory({
                id: vm.evaluation.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.evaluationsHistory = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationHistoryNewController', EvaluationHistoryNewController);

    EvaluationHistoryNewController.$inject = ['Evaluation', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                             'chart', '$uibModalInstance', '$timeout', 'process'];

    function EvaluationHistoryNewController(Evaluation, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                           chart, $uibModalInstance, $timeout, process) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.evaluationsHistory = [];
        vm.process = process;

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.retrieve = retrieve;

        loadAll();

        function loadAll() {
            Evaluation.findAllByChartAndPatientProcess({
                chartId: chart.id,
                processId:  vm.process.id,
                searchQuery: vm.searchQuery,
                page:  vm.page - 1,
                size: vm.itemsPerPage,
                deleted: true
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.evaluationsHistory = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }

        function retrieve(id) {
            Evaluation.retrieve({id: id}, function () {
                loadAll();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('care-delivery', {
                parent: 'entity',
                url: '/care-delivery?id&processId',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                params: {
                    id: null,
                    processId: null
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/update/evaluation-edit.html',
                        controller: 'EvaluationEditController',
                        controllerAs: 'vm'
                    },
                    'diagnoses@care-delivery': {
                        templateUrl: 'app/entities/evaluation-diagnosis/list/evaluation-diagnosis.html',
                        controller: 'EvaluationDiagnosisController',
                        controllerAs: 'vm'
                    },
                    'allergies@care-delivery': {
                        templateUrl: 'app/entities/evaluation-allergy/list/evaluation-allergy.html',
                        controller: 'EvaluationAllergyController',
                        controllerAs: 'vm'
                    },
                    'diets@care-delivery': {
                        templateUrl: 'app/entities/evaluation-diet/list/evaluation-diets.html',
                        controller: 'EvaluationDietController',
                        controllerAs: 'vm'
                    },
                    'vitals@care-delivery': {
                        templateUrl: 'app/entities/evaluation-vital/list/evaluation-vital.html',
                        controller: 'EvaluationVitalController',
                        controllerAs: 'vm'
                    },
                    'glucose@care-delivery': {
                        templateUrl: 'app/entities/evaluation-glucose/list/evaluation-glucoses.html',
                        controller: 'EvaluationGlucoseController',
                        controllerAs: 'vm'
                    },
                    'weight@care-delivery': {
                        templateUrl: 'app/entities/evaluation-weight/list/evaluation-weights.html',
                        controller: 'EvaluationWeightController',
                        controllerAs: 'vm'
                    },
                    'comments@care-delivery': {
                        templateUrl: 'app/entities/evaluation-comment/list/evaluation-comment.html',
                        controller: 'EvaluationCommentController',
                        controllerAs: 'vm'
                    },
                    'medications@care-delivery': {
                        templateUrl: 'app/entities/evaluation-medication/list/evaluation-medications.html',
                        controller: 'EvaluationMedicationController',
                        controllerAs: 'vm'
                    },
                    'chart-urgent-issue@care-delivery': {
                        templateUrl: 'app/entities/urgent-issues/chart/new/list/urgent-issues.html',
                        controller: 'UrgentIssuesController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    entity: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.start({id: $stateParams.id}).$promise;
                    }],
                    jsonTemplate: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.getJsonTemplate({id: $stateParams.id}).$promise;
                    }],
                    tokens: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.getEvaluationTokensValues({id: $stateParams.id}).$promise;
                    }],
                    params: ['$location', '$stateParams', function ($location, $stateParams) {
                        return {
                            processId: $stateParams.processId,
                            processPage: $stateParams.processPage
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [
                            ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW
                        ];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    chart: ['$stateParams', 'Chart', function ($stateParams, Chart) {
                        return Chart.byEvaluation({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('care-delivery-view', {
                parent: 'entity',
                url: '/care-delivery-view/{id}',
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/detail/evaluation-view.html',
                        controller: 'EvaluationViewController',
                        controllerAs: 'vm'
                    },
                    'comments@care-delivery-view': {
                        templateUrl: 'app/entities/evaluation-comment/list/evaluation-comment.html',
                        controller: 'EvaluationCommentController',
                        controllerAs: 'vm'
                    },
                    'medications@care-delivery-view': {
                        templateUrl: 'app/entities/evaluation-medication/list/evaluation-medications-view.html',
                        controller: 'EvaluationMedicationController',
                        controllerAs: 'vm'
                    },
                    'chart-urgent-issue@care-delivery-view': {
                        templateUrl: 'app/entities/urgent-issues/chart/new/list/urgent-issues.html',
                        controller: 'UrgentIssuesController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    entity: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.get({id: $stateParams.id}).$promise;
                    }],
                    jsonTemplate: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.getJsonTemplate({id: $stateParams.id}).$promise;
                    }],
                    tokens: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.getEvaluationTokensValues({id: $stateParams.id}).$promise;
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [
                            ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW
                        ];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    chart: ['$stateParams', 'Chart', function ($stateParams, Chart) {
                        return Chart.byEvaluation({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('evaluation-maintenance', {
                parent: 'entity',
                url: '/evaluation-maintenance',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN', 'ROLE_SYSTEM']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/maintenance/evaluation-maintenance.html',
                        controller: 'EvaluationMaintenanceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
            .state('master-edit', {
                parent: 'entity',
                url: '/master-edit?id&processId',
                data: {},
                params: {
                    id: null,
                    processId: null
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/master/evaluation-master.html',
                        controller: 'EvaluationMasterEditController',
                        controllerAs: 'vm'
                    },
                    'diagnoses@master-edit': {
                        templateUrl: 'app/entities/evaluation-diagnosis/list/evaluation-diagnosis.html',
                        controller: 'EvaluationDiagnosisController',
                        controllerAs: 'vm'
                    },
                    'allergies@master-edit': {
                        templateUrl: 'app/entities/evaluation-allergy/list/evaluation-allergy.html',
                        controller: 'EvaluationAllergyController',
                        controllerAs: 'vm'
                    },
                    'diets@master-edit': {
                        templateUrl: 'app/entities/evaluation-diet/list/evaluation-diets.html',
                        controller: 'EvaluationDietController',
                        controllerAs: 'vm'
                    },
                    'vitals@master-edit': {
                        templateUrl: 'app/entities/evaluation-vital/list/evaluation-vital.html',
                        controller: 'EvaluationVitalController',
                        controllerAs: 'vm'
                    },
                    'glucose@master-edit': {
                        templateUrl: 'app/entities/evaluation-glucose/list/evaluation-glucoses.html',
                        controller: 'EvaluationGlucoseController',
                        controllerAs: 'vm'
                    },
                    'weight@master-edit': {
                        templateUrl: 'app/entities/evaluation-weight/list/evaluation-weights.html',
                        controller: 'EvaluationWeightController',
                        controllerAs: 'vm'
                    },
                    'comments@master-edit': {
                        templateUrl: 'app/entities/evaluation-comment/list/evaluation-comment.html',
                        controller: 'EvaluationCommentController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MASTER_EDIT];

                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    entity: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.get({id: $stateParams.id}).$promise;
                    }],
                    jsonTemplate: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.getJsonTemplate({id: $stateParams.id}).$promise;
                    }],
                    tokens: ['$stateParams', 'Evaluation', function ($stateParams, Evaluation) {
                        return Evaluation.getEvaluationTokensValues({id: $stateParams.id}).$promise;
                    }],
                    params: ['$location', '$stateParams', function ($location, $stateParams) {
                        return {
                            processId: $stateParams.processId,
                            processPage: $stateParams.processPage
                        };
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MASTER_EDIT, access);
                }]
            })
            .state('consent-boost', {
                parent: 'entity',
                url: '/consent-boost?chartId&processId',
                data: {
                    authorities: [],
                    pageTitle: 'Consent Boost'
                },
                ncyBreadcrumb: {
                    parent: 'chart',
                    label: 'Consent Boost'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/consent-boost/list/consent-boost.html',
                        controller: 'ConsentBoostController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    chart: null,
                    chartId: null,
                    process: null,
                    processId: null
                },
                resolve: {
                    chart: ['$stateParams', 'Chart', function ($stateParams, Chart) {
                        if ($stateParams.chart == null) {

                            return Chart.get({id: $stateParams.chartId}).$promise;
                        } else {

                            return $stateParams.chart;
                        }
                    }],
                    process: ['$stateParams', 'TypePatientProcess', function ($stateParams, TypePatientProcess) {
                        if ($stateParams.chart == null) {

                            return TypePatientProcess.get({id: $stateParams.processId}).$promise;
                        } else {

                            return $stateParams.process;
                        }
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationEditSignatureDialogController', EvaluationEditSignatureDialogController);

    EvaluationEditSignatureDialogController.$inject = ['$timeout', '$uibModalInstance', 'entity'];

    function EvaluationEditSignatureDialogController ($timeout, $uibModalInstance, entity) {
        var vm = this;

        vm.signature = angular.copy(entity);

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dayOfService = false;

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            $uibModalInstance.close(vm.signature);
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationViewController', EvaluationViewController);

    EvaluationViewController.$inject = ['entity', 'jsonTemplate', 'tokens', 'Evaluation', 'Chart', 'EvaluationComment', '$timeout', '$scope',
        'toastr', '$uibModal', 'AlertService', 'EvaluationDiagnosis', 'EvaluationAllergy',
        'EvaluationDiet', 'EvaluationGlucose', 'EvaluationVital', 'EvaluationWeight',
        'PendingPdfChartReport', 'PopupService', 'CoreService', 'Contacts', '$state', '$window',
        'EvaluationTemplateFile', 'REPORT_TYPE', 'TAB', 'access', 'ACTIONS'];

    function EvaluationViewController(entity, jsonTemplate, tokens, Evaluation, Chart, EvaluationComment, $timeout,
                                      $scope, toastr, $uibModal, AlertService, EvaluationDiagnosis, EvaluationAllergy,
                                      EvaluationDiet, EvaluationGlucose, EvaluationVital, EvaluationWeight,
                                      PendingPdfChartReport, PopupService, CoreService, Contacts, $state, $window,
                                      EvaluationTemplateFile, REPORT_TYPE, TAB, access, ACTIONS) {
        var vm = this;

        vm.evaluation = entity;
        vm.jsonTemplate = jsonTemplate;
        vm.chart = vm.evaluation.chart;
        vm.contact = vm.evaluation.contact;
        vm.evaluationDiagnoses = [];
        vm.evaluationAllergies = [];
        vm.evaluationDiets = [];
        vm.evaluationVitals = [];
        vm.evaluationGlucose = [];
        vm.evaluationWeight = null;
        vm.evaluationTemplateFiles = [];

        vm.TAB = TAB;

        vm.accessCareCoordinationView = access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW] ?
            access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW].roles.join() : null;

        vm.print = print;
        vm.fax = fax;
        vm.showChartRevokeSignPopup = showChartRevokeSignPopup;
        vm.getHeightInchesToFeetInches = getHeightInchesToFeetInches;
        vm.toggleSideBySide = toggleSideBySide;
        vm.togglePdfExport = togglePdfExport;
        vm.search = search;
        vm.open = open;
        vm.getEvaluationFiles = getEvaluationFiles;
        vm.exportPdf = exportPdf;

        init();

        function init() {
            $window.scrollTo(0, 0);

            getDateDiff();

            Chart.get({id: vm.evaluation.chartId}, function (chart) {
                vm.chart = chart;
            });

            if (vm.evaluation.contact) {
                Contacts.get({id: vm.evaluation.contact.id}, function (result) {
                    vm.contact = result;
                })
            }

            EvaluationDiagnosis.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationDiagnoses = result;
            });

            EvaluationAllergy.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationAllergies = result;
            });

            EvaluationDiet.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                vm.evaluationDiets = result;
            });

            EvaluationVital.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                if (result.length > 0) {
                    vm.evaluationVitals = result[0];
                }
            });

            EvaluationGlucose.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                if (result.length > 0) {
                    vm.evaluationGlucose = result[0];
                    vm.glucoseInterventions = _.map(vm.evaluationGlucose.glucoseInterventions, function (glucoseIntervention) {
                        return glucoseIntervention.name;
                    }).join(', ');
                }
            });

            EvaluationWeight.findAllByEvaluation({id: vm.evaluation.id}, function (result) {
                if (result.length > 0) {
                    vm.evaluationWeight = result[0];
                    vm.evaluationWeight.bmi = _.ceil(vm.evaluationWeight.bmi, 2)
                }
            });

            // if (vm.evaluation.chartSignatureId) {
            //     Evaluation.getSignature({id: vm.evaluation.id, type: 'CHART'}, function (data) {
            //         vm.chartSignature = data;
            //     });
            // }
            //
            // if (vm.evaluation.guarantorSignatureId) {
            //     Evaluation.getSignature({id: vm.evaluation.id, type: 'GUARANTOR'}, function (data) {
            //         vm.guarantorSignature = data;
            //     });
            // }
            //
            // if (vm.evaluation.staffSignatureId) {
            //     Evaluation.getSignature({id: vm.evaluation.id, type: 'STAFF'}, function (data) {
            //         vm.staffSignature = data;
            //     });
            // }
            //
            // if (vm.evaluation.staffReviewSignatureId) {
            //     Evaluation.getSignature({id: vm.evaluation.id, type: 'REVIEW'}, function (data) {
            //         vm.staffReviewSignature = data;
            //     });
            // }
            //
            // if (vm.evaluation.revokeChartSignatureId) {
            //     Evaluation.getSignature({id: vm.evaluation.id, type: 'REVOKE'}, function (data) {
            //         vm.revokeChartSignature = data;
            //     });
            // }

            vm.formCKEditorTokensConfig = {
                ckeditor: {
                    tokens: tokens
                }
            };
        }

        function getDateDiff() {
            if (vm.evaluation.billable && vm.evaluation.startBilling && vm.evaluation.endBilling) {
                var startD = moment(vm.evaluation.startBilling);
                var endD = moment(vm.evaluation.endBilling);

                vm.dateDiff = endD.diff(startD, 'minutes');
            }
        }

        function print() {
            vm.isPrinting = true;

            PendingPdfChartReport.save({
                chart: vm.chart,
                objectId: vm.evaluation.id,
                name: vm.evaluation.name,
                reportType: REPORT_TYPE.EVALUATION
            }, onPrintSuccess, onPrintError);
        }

        function showChartRevokeSignPopup() {
            if (PopupService.checkSigPlusExtLiteExtension()) {
                startSign();
            } else {
                PopupService.showPatientSignaturePopup(vm.chart).result.then(function (data) {
                    signRevoke(data)
                });
            }
        }

        function signRevoke(signature) {
            Evaluation.revoke({ids: [vm.evaluation.id], signature: signature}, function (result) {
                $state.reload();
            })
        }

        function getHeightInchesToFeetInches(height) {

            return CoreService.getHeightInchesToFeetInches(height);
        }

        function fax() {
            PopupService.showContactAddressPickupPopup().result.then(function (result) {
                Evaluation.fax({
                    id: vm.evaluation.id, moreIds: result.ids
                }, function () {
                    toastr.success("Fax in queue");
                }, function () {
                    _.forEach(result, function (contactAddress) {
                        toastr.error('Error sending fax to ' + (contactAddress.name ? contactAddress.name : "") + " Fax: " + contactAddress.fax + ". Try again later.");
                    })
                });
            });
        }

        function toggleSideBySide() {
            vm.sideBySide = !vm.sideBySide;
            vm.pdfExport = false;

            if (vm.sideBySide) {
                vm.searchQuery = vm.evaluation.name;
                vm.search();
            }
        }

        function togglePdfExport() {
            vm.pdfExport = !vm.pdfExport;
            vm.sideBySide = false;

            if (vm.pdfExport) {
                getEvaluationFiles();
            }
        }

        function search() {
            vm.compareWith = null;
            Evaluation.findAllByFilter({
                chartId: vm.evaluation.chart.id,
                facilityId: vm.evaluation.chart.facility.id,
                searchQuery: vm.searchQuery,
                status: 'Finalized',
                page: 0,
                size: 20
            }, function (result) {
                vm.compareWith = null;
                vm.evaluations = result;
            })
        }

        function getEvaluationFiles() {
            vm.pdfExportId = null;
            EvaluationTemplateFile.findAllByEvaluationTemplate({
                evaluationId: vm.evaluation.evaluationTemplateId,
                searchQuery: vm.fileSearchQuery,
                page: 0,
                size: 100
            }, function (result, headers) {
                vm.evaluationTemplateFiles = result;
            });
        }

        function exportPdf() {
            vm.isPrinting = true;

            PendingPdfChartReport.save({
                chart: vm.chart,
                objectId: vm.evaluation.id,
                evaluationTemplateFileId: vm.pdfExportId,
                reportType: REPORT_TYPE.EVALUATION_TEMPLATE_FILE,
                name: vm.evaluation.name
            }, onPrintSuccess, onPrintError);
        }

        function onPrintSuccess(result) {
            vm.isPrinting = false;
            vm.pdfExportId = null;
            vm.compareWith = null;

            toastr.success('Your report "' + result.name + '" is been generated please go to storage to download it');
        }

        function onPrintError() {
            vm.isPrinting = false;
            toastr.error("We couldn't generate the report.");
        }

        function open() {
            $state.go("care-delivery-view", {id: vm.compareWith});
        }

        function startSign() {
            var message = {
                "firstName": "",
                "lastName": "",
                "eMail": "",
                "location": "",
                "imageFormat": 1,
                "imageX": 500,
                "imageY": 100,
                "imageTransparency": false,
                "imageScaling": false,
                "maxUpScalePercent": 0.0,
                "rawDataFormat": "ENC",
                "minSigPoints": 25
            };

            top.document.addEventListener('SignResponse', SignResponse, false);
            var messageData = JSON.stringify(message);
            var element = document.createElement("MyExtensionDataElement");
            element.setAttribute("messageAttribute", messageData);
            document.documentElement.appendChild(element);
            var evt = document.createEvent("Events");
            evt.initEvent("SignStartEvent", true, false);
            element.dispatchEvent(evt);
        }

        function SignResponse(event) {
            var str = event.target.getAttribute("msgAttribute");
            var objResponse = JSON.parse(str);
            var obj = null;

            if (typeof (objResponse) === 'string') {
                obj = JSON.parse(objResponse);
            } else {
                obj = JSON.parse(JSON.stringify(objResponse));
            }

            if (obj.errorMsg != null && obj.errorMsg != "" && obj.errorMsg != "undefined") {
                toastr.error(obj.errorMsg);
            } else {
                if (obj.isSigned) {
                    signRevoke("data:image/jpg;base64," + obj.imageData);
                }
            }

            top.document.removeEventListener('SignResponse', SignResponse, false);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationDayOfServiceDialogController', EvaluationDayOfServiceDialogController);

    EvaluationDayOfServiceDialogController.$inject = ['$timeout', '$uibModalInstance', 'entity'];

    function EvaluationDayOfServiceDialogController ($timeout, $uibModalInstance, entity) {
        var vm = this;

        vm.evaluation = angular.copy(entity);

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dayOfService = false;

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            $uibModalInstance.close(vm.evaluation);
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PendingByStaffController', PendingByStaffController);

    PendingByStaffController.$inject = ['$state', 'Evaluation', 'GUIUtils', '$q', 'Employee', 'CoreService',
        'TypeLevelCare', '$uibModal', 'DateUtils', '$rootScope', 'Chart', 'PopupService',
        'GenericEntityDatatableService', 'ConfirmationService'];

    function PendingByStaffController($state, Evaluation, GUIUtils, $q, Employee, CoreService,
                                      TypeLevelCare, $uibModal, DateUtils, $rootScope, Chart, PopupService,
                                      GenericEntityDatatableService, ConfirmationService) {
        var vm = this;

        vm.all = false;
        vm.mine = true;
        vm.credentials = CoreService.getCurrentEmployee().credentials;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Pending Care and Delivery by Staff',
            entityClassHumanized: 'Pending Care and Delivery by Staff',
            entityStateName: 'evaluation',
            service: Evaluation,
            serviceMethod: 'findAllPendingByStaffFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[1, 'asc']]}
            ],
            selectionColumn: 'id',
            withSelectionColumn: true,
            disableSelectionColumn: function (filter) {
                return !vm.mine;
            },
            disableAllSelectionColumn: function (filter) {
                return !vm.mine;
            },
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + " " + data.lastName;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    options: [{key: 'width', value: '130px'}],
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: 'width', value: '130px'}],
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    name: 'name',
                    title: "Care and Delivery"
                },
                {
                    name: null,
                    title: "Status",
                    render: function (data) {
                        return '<span class="' + CoreService.getEvaluationStatusLabelClass(data.status) + '">' + data.status + '</span>';
                    }
                },
                {
                    title: 'Created Date',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.dateFormat) : "";
                    }
                },
                {
                    title: 'Created By',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdByEmployee ? data.createdByEmployee.firstName + " " + data.createdByEmployee.lastName : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getInfoAction(), {
                    name: 'See Credentials',
                    action: function (data) {
                        listCredentials(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        $state.go('care-delivery', {id: data.id});
                    },
                })
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-green']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return signEvaluations(selected);
                                }
                            },
                            ngIf: function (filter) {
                                return vm.mine;
                            }
                        }),
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All',
                            iClass: 'fa fa-users',
                            ngClass: function (filter) {
                                return vm.all === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.all = true;
                                vm.mine = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'My Care & Delivery',
                            iClass: 'fa fa-user',
                            ngClass: function (filter) {
                                return vm.mine === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.mine = true;
                                vm.all = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'Other Care & Delivery',
                            iClass: 'fa fa-object-ungroup',
                            ngClass: function (filter) {
                                return vm.others === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                vm.others = true;
                                vm.all = false;
                                vm.mine = false;
                            }
                        }
                    ],
                },
            ],
            filters: [
                {
                    name: 'staffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.others) {
                            return null;
                        }

                        if (vm.mine) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'excludeStaffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.mine) {
                            return null;
                        }

                        if (vm.others) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'name',
                    type: 'string',
                    placeholder: 'Care & Delivery Name...',
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                },
                {
                    name: 'mrno',
                    type: 'string',
                    placeholder: 'Mr Number',
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'createdDate',
                    // title: 'Day of Birth',
                    placeholder: 'Created date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.createdDate ? moment(filter.createdDate).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'createdByEmployeeId',
                    read: function (filter) {
                        return filter.createdByEmployeeId ? filter.createdByEmployeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {page: 0, size: 10, query: search, facilityId: CoreService.getCurrentFacility().id};

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select Employee ...',
                    type: 'select',
                },
            ]
        }

        function listCredentials(id) {
            Evaluation.get({id: id}, function (result) {
                ConfirmationService.showCredentials(result.staffSignatureCredentials);
            })
        }

        function signEvaluations(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    Evaluation.staffSign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids
                    }, function () {
                        resolve();
                    });
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReviewController', ReviewController);

    ReviewController.$inject = ['$state', 'Evaluation', 'GUIUtils', '$q', 'Employee', 'CoreService', 'TypeLevelCare',
        '$uibModal', '$rootScope', 'Chart', 'PopupService', 'GenericEntityDatatableService',
        'ConfirmationService'];

    function ReviewController($state, Evaluation, GUIUtils, $q, Employee, CoreService, TypeLevelCare,
                              $uibModal, $rootScope, Chart, PopupService, GenericEntityDatatableService,
                              ConfirmationService) {
        var vm = this;

        vm.all = false;
        vm.mine = true;
        vm.credentials = CoreService.getCurrentEmployee().credentials;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            empty: null,
            status: 'InReview',
            forceStaffReviewSignature: true
        }

        vm.descriptor = {
            title: 'Care & Delivery Pending Review',
            entityClassHumanized: 'Care & Delivery Pending Review',
            entityStateName: 'evaluation',
            service: Evaluation,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[2, 'asc']]}
            ],
            selectionColumn: 'id',
            withSelectionColumn: true,
            disableSelectionColumn: function (filter) {
                return !vm.mine;
            },
            disableAllSelectionColumn: function (filter) {
                return !vm.mine;
            },
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + " " + data.lastName;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    options: [{key: 'width', value: '130px'}],
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: 'width', value: '130px'}],
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    name: 'name',
                    title: "Care and Delivery"
                },
                {
                    name: null,
                    title: "Status",
                    render: function (data) {
                        return '<span class="' + CoreService.getEvaluationStatusLabelClass(data.status) + '">' + data.status + '</span>';
                    }
                },
                {
                    title: 'Created Date',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.dateFormat) : "";
                    }
                },
                {
                    title: 'Created By',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdByEmployee ? data.createdByEmployee.firstName + " " + data.createdByEmployee.lastName : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getInfoAction(), {
                    name: 'See Credentials',
                    action: function (data) {
                        listCredentials(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        $state.go('care-delivery', {id: data.id});
                    },
                })
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-green']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return signEvaluations(selected);
                                }
                            },
                            ngIf: function (filter) {
                                return vm.mine;
                            }
                        }),
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All',
                            iClass: 'fa fa-users',
                            ngClass: function (filter) {
                                return vm.all === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.all = true;
                                vm.mine = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'My Care & Delivery',
                            iClass: 'fa fa-user',
                            ngClass: function (filter) {
                                return vm.mine === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.mine = true;
                                vm.all = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'Other Care & Delivery',
                            iClass: 'fa fa-object-ungroup',
                            ngClass: function (filter) {
                                return vm.others === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                vm.others = true;
                                vm.all = false;
                                vm.mine = false;
                            }
                        }
                    ],
                },
            ],
            filters: [
                {
                    name: 'staffReviewCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.others) {
                            return null;
                        }

                        if (vm.mine) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'excludeStaffReviewCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.mine) {
                            return null;
                        }

                        if (vm.others) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'name',
                    type: 'string',
                    placeholder: 'Care & Delivery Name...',
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                },
                {
                    name: 'mrno',
                    type: 'string',
                    placeholder: 'Mr Number',
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'createdDate',
                    // title: 'Day of Birth',
                    placeholder: 'Created date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.createdDate ? moment(filter.createdDate).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'createdByEmployeeId',
                    read: function (filter) {
                        return filter.createdByEmployeeId ? filter.createdByEmployeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {page: 0, size: 10, query: search, facilityId: CoreService.getCurrentFacility().id};

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select Employee ...',
                    type: 'select',
                },
            ]
        }

        function listCredentials(id) {
            Evaluation.get({id: id}, function (result) {
                ConfirmationService.showCredentials(result.staffReviewSignatureCredentials);
            })
        }

        function signEvaluations(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    Evaluation.staffReviewSign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids
                    }, function () {
                        resolve();
                    });
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PendingByPatientController', PendingByPatientController);

    PendingByPatientController.$inject = ['$state', 'Evaluation', 'GUIUtils', '$q', 'Employee', 'CoreService',
        'TypeLevelCare', '$uibModal', '$rootScope', 'Chart', 'GenericEntityDatatableService'];

    function PendingByPatientController($state, Evaluation, GUIUtils, $q, Employee, CoreService,
                                        TypeLevelCare, $uibModal, $rootScope, Chart, GenericEntityDatatableService) {

        var vm = this;

        vm.credentials = CoreService.getCurrentEmployee().credentials;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            requiredPatientSignature: true,
            existPatientSignature: false,
            empty: false,
            status: 'Pending'
        }

        vm.descriptor = {
            title: 'Unsigned Care and Delivery by Patients',
            entityClassHumanized: 'Unsigned Care and Delivery by Patients',
            entityStateName: 'evaluation',
            service: Evaluation,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[1, 'asc']]}
            ],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + " " + data.lastName;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    options: [{key: 'width', value: '130px'}],
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: 'width', value: '130px'}],
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    name: 'name',
                    title: "Care and Delivery"
                },
                {
                    name: null,
                    title: "Status",
                    render: function (data) {
                        return '<span class="' + CoreService.getEvaluationStatusLabelClass(data.status) + '">' + data.status + '</span>';
                    }
                },
                {
                    title: 'Created Date',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.dateFormat) : "";
                    }
                },
                {
                    title: 'Created By',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdByEmployee ? data.createdByEmployee.firstName + " " + data.createdByEmployee.lastName : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        $state.go('care-delivery', {id: data.id});
                    },
                })
            ],
            filters: [
                {
                    name: 'staffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.others) {
                            return null;
                        }

                        if (vm.mine) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'excludeStaffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.mine) {
                            return null;
                        }

                        if (vm.others) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'name',
                    type: 'string',
                    placeholder: 'Care & Delivery Name...',
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                },
                {
                    name: 'mrno',
                    type: 'string',
                    placeholder: 'Mr Number',
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'createdDate',
                    // title: 'Day of Birth',
                    placeholder: 'Created date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.createdDate ? moment(filter.createdDate).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'createdByEmployeeId',
                    read: function (filter) {
                        return filter.createdByEmployeeId ? filter.createdByEmployeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {page: 0, size: 10, query: search, facilityId: CoreService.getCurrentFacility().id};

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select Employee ...',
                    type: 'select',
                },
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LateController', LateController);

    LateController.$inject = ['$state', 'Evaluation', 'GUIUtils', '$q', 'Employee', 'CoreService', 'TypeLevelCare',
        '$uibModal', 'DataTablesService', 'DateUtils', '$rootScope', 'Chart', 'PopupService',
        'GenericEntityDatatableService', 'ConfirmationService']

    function LateController($state, Evaluation, GUIUtils, $q, Employee, CoreService, TypeLevelCare,
                            $uibModal, DataTablesService, DateUtils, $rootScope, Chart, PopupService,
                            GenericEntityDatatableService, ConfirmationService) {
        var vm = this;

        vm.all = false;
        vm.mine = true;
        vm.credentials = CoreService.getCurrentEmployee().credentials;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            empty: false,
            status: 'Late',
            requiredPatientSignature: false
        }

        vm.descriptor = {
            title: 'Late Care & Delivery',
            entityClassHumanized: 'Late Care & Delivery',
            entityStateName: 'evaluation',
            service: Evaluation,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[1, 'asc']]}
            ],
            selectionColumn: 'id',
            withSelectionColumn: true,
            disableSelectionColumn: function (filter) {
                return !vm.mine;
            },
            disableAllSelectionColumn: function (filter) {
                return !vm.mine;
            },
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + " " + data.lastName;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    options: [{key: 'width', value: '130px'}],
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: 'width', value: '130px'}],
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    name: 'name',
                    title: "Care and Delivery"
                },
                {
                    name: null,
                    title: "Status",
                    render: function (data) {
                        return '<span class="' + CoreService.getEvaluationStatusLabelClass(data.status) + '">' + data.status + '</span>';
                    }
                },
                {
                    title: 'Created Date',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.dateFormat) : "";
                    }
                },
                {
                    title: 'Created By',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdByEmployee ? data.createdByEmployee.firstName + " " + data.createdByEmployee.lastName : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getInfoAction(), {
                    name: 'See Credentials',
                    action: function (data) {
                        listCredentials(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        $state.go('care-delivery', {id: data.id});
                    },
                })
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSignAction(), {
                            name: 'Sign Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-green']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    return signEvaluations(selected);
                                }
                            },
                            ngIf: function (filter) {
                                return vm.mine;
                            }
                        }),
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All',
                            iClass: 'fa fa-users',
                            ngClass: function (filter) {
                                return vm.all === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.all = true;
                                vm.mine = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'My Care & Delivery',
                            iClass: 'fa fa-user',
                            ngClass: function (filter) {
                                return vm.mine === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.mine = true;
                                vm.all = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'Other Care & Delivery',
                            iClass: 'fa fa-object-ungroup',
                            ngClass: function (filter) {
                                return vm.others === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                vm.others = true;
                                vm.all = false;
                                vm.mine = false;
                            }
                        }
                    ],
                },
            ],
            filters: [
                {
                    name: 'staffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.others) {
                            return null;
                        }

                        if (vm.mine) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'excludeStaffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.mine) {
                            return null;
                        }

                        if (vm.others) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'name',
                    type: 'string',
                    placeholder: 'Care & Delivery Name...',
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                },
                {
                    name: 'mrno',
                    type: 'string',
                    placeholder: 'Mr Number',
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'createdDate',
                    // title: 'Day of Birth',
                    placeholder: 'Created date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.createdDate ? moment(filter.createdDate).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'createdByEmployeeId',
                    read: function (filter) {
                        return filter.createdByEmployeeId ? filter.createdByEmployeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {page: 0, size: 10, query: search, facilityId: CoreService.getCurrentFacility().id};

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select Employee ...',
                    type: 'select',
                },
            ]
        }

        function listCredentials(id) {
            Evaluation.get({id: id}, function (result) {
                ConfirmationService.showCredentials(result.staffSignatureCredentials);
            })
        }

        function signEvaluations(selected) {
            var ids = _.map(selected, function (item) {
                return item.id;
            });

            return $q(function (resolve) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    Evaluation.staffSign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: ids
                    }, function () {
                        resolve();
                    });
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EmptyController', EmptyController);

    EmptyController.$inject = ['$state', 'Evaluation', 'GUIUtils', '$q', 'Employee', 'CoreService', '$uibModal',
        'DataTablesService', 'DateUtils', '$rootScope', 'TypeLevelCare', 'ConfirmationService', 'Chart',
        'GenericEntityDatatableService', 'toastr'];

    function EmptyController($state, Evaluation, GUIUtils, $q, Employee, CoreService, $uibModal,
                             DataTablesService, DateUtils, $rootScope, TypeLevelCare, ConfirmationService, Chart,
                             GenericEntityDatatableService, toastr) {
        var vm = this;

        vm.all = false;
        vm.mine = true;
        vm.credentials = CoreService.getCurrentEmployee().credentials;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            empty: true,
            status: ['Pending', 'Late'],
        }

        vm.descriptor = {
            title: 'Empty Care & Delivery',
            entityClassHumanized: 'Empty Care & Delivery',
            entityStateName: 'evaluation',
            service: Evaluation,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[1, 'asc']]}
            ],
            selectionColumn: 'id',
            withSelectionColumn: true,
            disableSelectionColumn: function (filter) {
                return !vm.mine;
            },
            disableAllSelectionColumn: function (filter) {
                return !vm.mine;
            },
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + " " + data.lastName;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    options: [{key: 'width', value: '130px'}],
                    render: function (data) {
                        return moment(data.dob).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: 'width', value: '130px'}],
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    name: 'name',
                    title: "Care and Delivery"
                },
                {
                    name: null,
                    title: "Status",
                    render: function (data) {
                        return '<span class="' + CoreService.getEvaluationStatusLabelClass(data.status) + '">' + data.status + '</span>';
                    }
                },
                {
                    title: 'Created Date',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdDate ? moment(data.createdDate).format($rootScope.dateFormat) : "";
                    }
                },
                {
                    title: 'Created By',
                    options: [{key: 'width', value: '200px'}],
                    render: function (data) {
                        return data.createdByEmployee ? data.createdByEmployee.firstName + " " + data.createdByEmployee.lastName : '-';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getInfoAction(), {
                    name: 'See Credentials',
                    action: function (data) {
                        listCredentials(data.id);
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        $state.go('care-delivery', {id: data.id});
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return deleteEmpties([data.id]);
                    },
                })
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                            name: 'Delete Selected',
                            disabledOnEmpty: true,
                            ngClass: function () {
                                return ['bg-red']
                            },
                            action: function (filter, selected) {
                                if (selected.length > 0) {
                                    var ids = _.map(selected, function (item) {
                                        return item.id;
                                    });

                                    return deleteEmpties(ids);
                                }
                            },
                            ngIf: function (filter) {
                                return vm.mine;
                            }
                        }),
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All',
                            iClass: 'fa fa-users',
                            ngClass: function (filter) {
                                return vm.all === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.all = true;
                                vm.mine = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'My Care & Delivery',
                            iClass: 'fa fa-user',
                            ngClass: function (filter) {
                                return vm.mine === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.mine = true;
                                vm.all = false;
                                vm.others = false;
                            }
                        },
                        {
                            name: 'Other Care & Delivery',
                            iClass: 'fa fa-object-ungroup',
                            ngClass: function (filter) {
                                return vm.others === true ?
                                    ['active', 'bg-green'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                vm.others = true;
                                vm.all = false;
                                vm.mine = false;
                            }
                        }
                    ],
                },
            ],
            filters: [
                {
                    name: 'staffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.others) {
                            return null;
                        }

                        if (vm.mine) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'excludeStaffCredentials',
                    visible: false,
                    read: function (filter) {
                        if (vm.all || vm.mine) {
                            return null;
                        }

                        if (vm.others) {
                            return vm.credentials;
                        }
                    }
                },
                {
                    name: 'name',
                    type: 'string',
                    placeholder: 'Care & Delivery Name...',
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                },
                {
                    name: 'mrno',
                    type: 'string',
                    placeholder: 'Mr Number',
                },
                {
                    name: 'dob',
                    // title: 'Day of Birth',
                    placeholder: 'Day of Birth...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.dob ? moment(filter.dob).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'createdDate',
                    // title: 'Day of Birth',
                    placeholder: 'Created date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    read: function (filter) {
                        return filter.createdDate ? moment(filter.createdDate).format("YYYY-MM-DD") : null;
                    },
                },
                {
                    name: 'typeLevelCare',
                    read: function (filter) {
                        return filter.typeLevelCare ? filter.typeLevelCare.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'createdByEmployeeId',
                    read: function (filter) {
                        return filter.createdByEmployeeId ? filter.createdByEmployeeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {
                            page: 0,
                            size: 10,
                            query: search,
                            facilityId: CoreService.getCurrentFacility().id
                        };

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select Employee ...',
                    type: 'select',
                },
            ]
        }

        function deleteEmpties(selected) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Empty Care & Delivery(s)').result.then(function () {
                    Evaluation.deleteEmpties({ids: selected},
                        function () {
                            toastr.success("The Empty Care and Delivery was deleted successfully.");
                            resolve();
                        }, function () {
                            if (selected.length > 1) {
                                toastr.success("The selected Empty Care and Delivery have been deleted.");
                            } else {
                                toastr.error("The selected Empty Care and Delivery did not was deleted, see info.");
                            }

                            resolve()
                        });
                })
            });
        }

        function listCredentials(id) {
            Evaluation.get({id: id}, function (result) {
                ConfirmationService.showCredentials(result.staffSignatureCredentials);
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('pending-by-staff', {
                parent: 'entity',
                url: '/pending-by-staff',
                ncyBreadcrumb: {
                    label: 'Unsigned Care and Delivery'
                },
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/dashboard/staff/pending-by-staff.html',
                        controller: 'PendingByStaffController',
                        controllerAs: 'vm'
                    }
                },
            })
            .state('pending-by-staff-review', {
                parent: 'entity',
                url: '/pending-by-staff-review',
                ncyBreadcrumb: {
                    label: 'Pending Care and Delivery by Staff Review'
                },
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/dashboard/review/review.html',
                        controller: 'ReviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function () {
                        return {
                            page: 1,
                            itemsPerPage: 25
                            // ,
                            // sort: $stateParams.sort,
                            // predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            // ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    filter: function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dateBirth: null,
                            status: null,
                            createDate: null,
                            noted: false,
                            orderBy: null,
                            levelCare: null
                        };
                    },
                    employee: ['Employee', function (Employee) {
                        return Employee.employeeAccount().$promise;
                    }]
                }
            })
            .state('empty', {
                parent: 'entity',
                url: '/empty',
                ncyBreadcrumb: {
                    label: 'Empties Care and Delivery'
                },
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/dashboard/empty/empty.html',
                        controller: 'EmptyController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function () {
                        return {
                            page: 0,
                            itemsPerPage: 18
                            // ,
                            // sort: $stateParams.sort,
                            // predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            // ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    filter: function () {
                        return {
                            firstName: null,
                            lastName: null,
                            dateBirth: null,
                            status: null,
                            createDate: null,
                            orderBy: null,
                            levelCare: null
                        };
                    },
                    employee: ['Employee', function (Employee) {
                        return Employee.employeeAccount().$promise;
                    }]
                }
            })
            .state('pending-by-patient', {
                parent: 'entity',
                url: '/pending-by-patients',
                ncyBreadcrumb: {
                    label: 'Pending Care and Delivery by Patients'
                },
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/dashboard/patient/pending-by-patient.html',
                        controller: 'PendingByPatientController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: function () {
                        return {
                            name: null,
                            patientName: null,
                            dob: null,
                            createdDate: null,
                            typeLevelCare: null
                        };
                    },
                    employee: ['Employee', function (Employee) {
                        return Employee.employeeAccount().$promise;
                    }]
                }
            })
            .state('late', {
                parent: 'entity',
                url: '/late',
                ncyBreadcrumb: {
                    label: 'Late Care and Delivery'
                },
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/evaluation/dashboard/late/late.html',
                        controller: 'LateController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConsentBoostController', ConsentBoostController);

    ConsentBoostController.$inject = ['$uibModal', 'PopupService', 'toastr', 'Evaluation', 'chart', 'process',
        'DataTablesService', '$window', '$uibModalStack', 'TAB'];

    function ConsentBoostController($uibModal, PopupService, toastr, Evaluation, chart, process,
                                    DataTablesService, $window, $uibModalStack, TAB) {
        var vm = this;

        vm.title = 'Consent Boost';

        vm.evaluations = [];
        vm.chart = chart;
        vm.process = process;
        vm.selected = {};
        vm.selectAll = false;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.TAB = TAB;

        vm.openModalSignature = openModalSignature;
        vm.openModalAttachments = openModalAttachments;
        vm.openModalGenerateNew = openModalGenerateNew;
        vm.transition = transition;
        vm.search = search;
        vm.generateConsent = generateConsent;

        loadAll();

        function loadAll() {
            $window.scrollTo(0, 0);

            Evaluation.findAllPendingByIdAndPatientProcess(getFilter(), function (result) {
                vm.evaluations = result;

                initSelected();
            })
        }

        function signPatient(signature) {
            Evaluation.chartSign({
                ids: DataTablesService.getSelectedIds(vm.selected),
                signature: signature
            }, function () {
                transition();
                vm.selectAll = false;
            })
        }

        function openModalSignature() {
            if (PopupService.checkSigPlusExtLiteExtension()) {
                startSign();
            } else {
                PopupService.showPatientSignaturePopup(vm.chart).result.then(function (data) {
                    signPatient(data);
                });
            }
        }

        function openModalAttachments(evaluationId) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/consent-boost/attachment/consent-boost-attachment-dialog.html',
                controller: 'ConsentBoostAttachmentDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    evaluationId: evaluationId
                }
            });
        }

        function openModalGenerateNew() {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation/consent-boost/generate/consent-boost-new-dialog.html',
                controller: 'ConsentBoostNewDialogController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    process: vm.process,
                    chart: vm.chart
                }
            }).result.then(function () {
                transition();
                toastr.success("Consent have been generated");
            }, function () {
                toastr.error("Consent have not been generated");
            });
        }

        function generateConsent() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/evaluation/consent-boost/generate-consent/consent-boost-generate-consent-dialog.html',
                controller: 'ConsentBoostGenerateConsentDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    chart: chart,
                    process: vm.process
                }
            }).result.then(function () {
                transition();
                toastr.success("Consent have been generated");
            }, function () {
                toastr.error("Consent have not been generated");
            });
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.processId = vm.process.id;
            filter.searchQuery = vm.searchQuery;

            return filter;
        }

        function transition() {
            Evaluation.findAllPendingByIdAndPatientProcess(getFilter(), function (result) {
                vm.evaluations = result;
                initSelected();
            });
        }

        function search() {
            transition();
        }

        function initSelected() {
            vm.select = {};
            _.forEach(vm.evaluations, function (evaluation) {
                vm.selected[evaluation.id] = false;
                vm.selectAll = false;
            })
        }

        function startSign() {
            var message = {
                "firstName": "",
                "lastName": "",
                "eMail": "",
                "location": "",
                "imageFormat": 1,
                "imageX": 500,
                "imageY": 100,
                "imageTransparency": false,
                "imageScaling": false,
                "maxUpScalePercent": 0.0,
                "rawDataFormat": "ENC",
                "minSigPoints": 25
            };

            top.document.addEventListener('SignResponse', SignResponse, false);
            var messageData = JSON.stringify(message);
            var element = document.createElement("MyExtensionDataElement");
            element.setAttribute("messageAttribute", messageData);
            document.documentElement.appendChild(element);
            var evt = document.createEvent("Events");
            evt.initEvent("SignStartEvent", true, false);
            element.dispatchEvent(evt);
        }

        function SignResponse(event) {
            var str = event.target.getAttribute("msgAttribute");
            var objResponse = JSON.parse(str);
            var obj = null;

            if (typeof (objResponse) === 'string') {
                obj = JSON.parse(objResponse);
            } else {
                obj = JSON.parse(JSON.stringify(objResponse));
            }

            if (obj.errorMsg != null && obj.errorMsg != "" && obj.errorMsg != "undefined") {
                toastr.error(obj.errorMsg);
            } else {
                if (obj.isSigned) {
                    signPatient("data:image/jpg;base64," + obj.imageData);
                }
            }

            top.document.removeEventListener('SignResponse', SignResponse, false);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConsentBoostGenerateConsentDialogController', ConsentBoostGenerateConsentDialogController);

    ConsentBoostGenerateConsentDialogController.$inject = ['$uibModalInstance', 'chart', 'Evaluation', 'DataTablesService',
        'DTOptionsBuilder', '$q', 'Contacts', '$filter', '$compile', 'DTColumnBuilder', '$scope', 'process'];

    function ConsentBoostGenerateConsentDialogController($uibModalInstance, chart, Evaluation, DataTablesService,
                                                     DTOptionsBuilder, $q, Contacts, $filter, $compile, DTColumnBuilder,
                                                     $scope, process) {
        var vm = this;

        vm.chart = chart;
        vm.dtInstance = {};

        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.assign = assign;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;

        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Contacts.filter({chartId: chart.id, page: 0, size: 1000, searchQuery: vm.searchQuery}, function (result) {
                defer.resolve(result);
            });

            return defer.promise;
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';
            }),
            DTColumnBuilder.newColumn('fullName').withTitle('Contact Name'),
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function assign() {
            Evaluation.assignConsentToContacts({
                ids: vm.getSelectedIds(vm.selected),
                id: process.id,
                chart: vm.chart
            }, function () {
                $uibModalInstance.close('close');
            })
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConsentBoostAttachmentDialogController', ConsentBoostAttachmentDialogController);

    ConsentBoostAttachmentDialogController.$inject = ['$uibModalInstance', 'evaluationId'];

    function ConsentBoostAttachmentDialogController($uibModalInstance, evaluationId) {
        var vm = this;

        vm.clear = clear;
        vm.evaluationId = evaluationId

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationController', EvaluationController);

    EvaluationController.$inject = ['$uibModal', 'TypePatientProcess', 'CoreService', 'facility', 'Evaluation',
        'chart', 'AlertService', 'toastr', '$state', 'ConfirmationService', 'Auth',
        'params', '$location', 'access', 'ACTIONS', '$rootScope', '$scope', '$uibModalStack', 'TAB'];

    function EvaluationController($uibModal, TypePatientProcess, CoreService, facility, Evaluation,
                                  chart, AlertService, toastr, $state, ConfirmationService, Auth,
                                  params, $location, access, ACTIONS, $rootScope, $scope, $uibModalStack, TAB) {
        var vm = this;

        vm.itemsPerPage = 15;
        vm.patientProcesses = [];
        vm.activeTab = 0;
        vm.chart = chart;
        vm.active = ($state.current.name !== 'chart-new') || (params != null && parseInt(params.tabId) == TAB.EVALUATION);
        vm.access = access;

        vm.masterEdit = access[ACTIONS.ACTION_MASTER_EDIT] ? access[ACTIONS.ACTION_MASTER_EDIT].roles.join() : null;
        vm.accessDeleteCareDelivery = access[ACTIONS.ACTION_DELETE_CARE_DELIVERY] ? access[ACTIONS.ACTION_DELETE_CARE_DELIVERY].roles.join() : null;

        vm.toggleItem = toggleItem;
        vm.transition = transition;
        vm.amended = amended;
        vm.getStatusClass = getStatusClass;
        vm.select = select;
        vm.assign = assign;
        vm.del = del;
        vm.edit = edit;
        vm.loadCareAndDelivery = loadCareAndDelivery;
        vm.openConsentBoost = openConsentBoost;
        vm.search = search;
        vm.assignNew = assignNew;
        vm.generateConsent = generateConsent;
        vm.detail = detail;
        vm.history = history;
        vm.review = review;
        vm.audit = audit;

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_EVALUATION_VIEW, access) || !vm.active) {
                return;
            }

            TypePatientProcess.byFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (data) {
                vm.patientProcesses = _.sortBy(data, ["xrder", "name"]);

                _.forEach(vm.patientProcesses, function (process, key) {
                    process.page = 1;
                    process.loaded = false;
                });

                if (vm.patientProcesses.length > 0) {
                    if (!params || !params.processId) {
                        transition(vm.patientProcesses[0]);
                    } else {
                        var index = _.findIndex(vm.patientProcesses, function (patientProcess) {
                            return patientProcess.id == parseInt(params.processId);
                        });

                        if (index >= 0) {
                            vm.patientProcesses[index].page = params && params.processPage ? parseInt(params.processPage) : 1;
                            //the dual binding of this var trigger the load event :)
                            vm.activeTab = index;
                        }
                    }
                }
            });
        }

        function loadCareAndDelivery(process) {
            Evaluation.assignAutomaticsEvaluationsByPatientProcess({
                chartId: vm.chart.id,
                typePatientProcessId: process.id
            }, function (data) {
                if (data.count > 0) {
                    toastr.success('Care and Delivery automatics have been assigned');
                } else {
                    toastr.warning('There is no Care & Delivery to preload under this patient process');
                }

                process.page = 1;
                transition(process);

            }, function () {
                toastr.error('Care and Delivery automatics can not be assigned');

                process.page = 1;
                transition(process);
            });
        }

        function toggleItem() {
            CoreService.togglePanel('evaluation');
        }

        function transition(process) {
            $location.search('processId', process.id);
            $location.search('processPage', process.page);

            Evaluation.findAllByChartAndPatientProcess({
                chartId: chart.id,
                processId: process.id,
                searchQuery: vm.searchQuery,
                page: process.page - 1,
                size: vm.itemsPerPage,
                deleted: false
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                process.totalItems = headers('X-Total-Count');
                process.evaluations = data;
                process.loaded = true;

                _.forEach(process.evaluations, function (evaluation, key) {
                    evaluation.signed =
                        evaluation.chartSignatureId != null ||
                        evaluation.guarantorSignatureId != null ||
                        evaluation.staffSignatureId != null ||
                        evaluation.staffReviewSignatureId != null;
                });
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function getStatusClass(evaluation) {
            return CoreService.getEvaluationStatusClass(evaluation.status);
        }

        function select(process) {
            transition(process);
        }

        function assign(process) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-template/assign-chart/old/evaluation-template-assign-dialog.html',
                controller: 'EvaluationTemplateAssignDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    typePatientProcess: process,
                    chart: chart
                }
            }).result.then(function () {
                process.page = 1;
                transition(process);
            }, function (result) {
            });
        }

        function del(process, evaluation) {
            ConfirmationService.showDelete('Evaluation').result.then(function () {
                Evaluation.delete({id: evaluation.id}, function () {
                    transition(process);
                });
            })
        }

        function amended(process, evaluation) {
            ConfirmationService.open({
                title: 'Confirm amended operation',
                message: 'Are you sure you want to <strong>AMENDED</strong> this Evaluation?',
                actions: [
                    {
                        name: 'Amended',
                        color: 'btn btn-success',
                        icon: 'fa fa-check-circle',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Cancel',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }).result.then(function () {
                Evaluation.amended({id: evaluation.id}, function () {
                    transition(process);
                })
            });
        }

        function openConsentBoost(process) {
            $state.go('consent-boost', {
                chart: vm.chart,
                process: process,
                chartId: vm.chart.id,
                processId: process.id
            });
        }

        function edit(process, evaluation) {
            $state.go('care-delivery', {id: evaluation.id, processId: process.id});
        }

        function detail(process, evaluation) {
            $state.go('care-delivery-view', {id: evaluation.id, processId: process.id});
        }

        function search(process) {
            process.page = 1;
            transition(process);
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailActiveTab', function (event, result) {
            if (!vm.active && result == TAB.EVALUATION) {
                vm.active = true;
                loadAll();
            }
        });

        $scope.$on('$destroy', unsubscribe);

        function assignNew(process) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/evaluation-template/assign-chart/new/evaluation-template-assign-new-dialog.html',
                controller: 'EvaluationTemplateAssignNewDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    typePatientProcess: process,
                    chart: chart
                }
            }).result.then(function () {
                process.page = 1;
                transition(process);
            }, function (result) {
            });
        }

        function generateConsent(process) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/evaluation/consent-boost/generate-consent/consent-boost-generate-consent-dialog.html',
                controller: 'ConsentBoostGenerateConsentDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    chart: chart,
                    process: process
                }
            }).result.then(function () {
                process.page = 1;
                transition(process);
                $rootScope.$broadcast('bluebookApp:loadContacts');
            }, function (result) {
            });
        }

        function history(process) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/evaluation/history/evaluation-history.html',
                controller: 'EvaluationHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart,
                    process: process
                }
            }).result.then(function () {
                transition(process);
            }, function () {
                transition(process);
            })
        }

        function audit(evaluation) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/evaluation/history-audit/evaluation-history-audit.html',
                controller: 'EvaluationHistoryAuditController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    evaluation: evaluation
                }
            });
        }

        function review(process, evaluation) {
            ConfirmationService.open({
                title: 'Confirm review operation',
                message: 'Are you sure you want to <strong>REVIEW</strong> this Evaluation?',
                actions: [
                    {
                        name: 'Review',
                        color: 'btn btn-success',
                        icon: 'fa fa-times-circle-o',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Cancel',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }).result.then(function () {
                Evaluation.review({id: evaluation.id}, function () {
                    transition(process);
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EvaluationBillingDatesDialogController', EvaluationBillingDatesDialogController);

    EvaluationBillingDatesDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity'];

    function EvaluationBillingDatesDialogController ($timeout, $scope, $uibModalInstance, entity) {
        var vm = this;

        vm.evaluation = angular.copy(entity);

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startBilling = false;
        vm.datePickerOpenStatus.endBilling = false;

        vm.endDateOptions = {};
        vm.startDateOptions = {};

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.getDateDiff = getDateDiff;
        vm.changeStartDate = changeStartDate;
        vm.changeEndDate = changeEndDate;
        vm.calEndDate = calEndDate;

        init();

        function init() {
            getDateDiff();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            $uibModalInstance.close(vm.evaluation);
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function changeStartDate() {
            if (vm.evaluation.startBilling) {
                vm.endDateOptions.minDate = vm.evaluation.startBilling;

                if (vm.dateDiff > 0) {
                    calEndDate();
                } else if (vm.evaluation.endBilling) {
                    if (vm.evaluation.startBilling > vm.evaluation.endBilling) {
                        vm.evaluation.endBilling = null;
                        vm.dateDiff = null;
                    } else {
                        getDateDiff();
                    }
                }
            } else {
                vm.endDateOptions.minDate = null;
                vm.dateDiff = null;
            }
        }

        function changeEndDate() {
            vm.getDateDiff();
        }

        function getDateDiff() {
            if (vm.evaluation.billable && vm.evaluation.startBilling && vm.evaluation.endBilling) {
                var startD = moment(vm.evaluation.startBilling);
                var endD = moment(vm.evaluation.endBilling);

                vm.dateDiff = endD.diff(startD, 'minutes');
            }
        }

        function calEndDate() {
            if (vm.dateDiff > 0) {
                vm.dateDiff = vm.dateDiff >= 0 ? vm.dateDiff : 0;
                var billingEndDate = moment(vm.evaluation.startBilling)
                    .add(vm.dateDiff, 'minutes')
                    .format("MM/DD/YYYY hh:mm A");
                vm.evaluation.endBilling = new Date(billingEndDate);
            } else {
                vm.evaluation.endBilling = null;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app',
            ncyBreadcrumb: {
                label: 'Entity',
                parent: 'app'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('NewChartPreviewController', NewChartPreviewController);

    NewChartPreviewController.$inject = ['$uibModalInstance', '$rootScope', 'EmployeeNewChart', '$state'];

    function NewChartPreviewController($uibModalInstance, $rootScope, EmployeeNewChart, $state) {
        var vm = this;

        vm.clear = clear;
        vm.change = change;

        function clear() {
            $uibModalInstance.close();
        }

        function change() {
            EmployeeNewChart.save({showNewChart: !$rootScope.showNewChart}, function () {
                $rootScope.showNewChart = !$rootScope.showNewChart;
                if ($state.current.name === 'chart-new' || $state.current.name === 'chart-old') {
                    $state.go('chart', {id: $state.params.id});
                }
            })
            $uibModalInstance.close();
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EmployeeNewChart', EmployeeNewChart);

    EmployeeNewChart.$inject = ['$resource'];

    function EmployeeNewChart($resource) {
        var resourceUrl = 'api/employee-new-charts/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'getShowNewChart': {
                method: 'GET', url: 'api/employee-new-charts/show-new-chart', isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data = {value: data};
                    }

                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('EmployeeMenu', EmployeeMenu);

    EmployeeMenu.$inject = ['$resource', '$rootScope'];

    function EmployeeMenu($resource, $rootScope) {
        var resourceUrl = 'api/employee-menus';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.menu = angular.fromJson(data.jsonData);

                        $rootScope.employeeMenu = data;
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = {};

                    copy.id = data.id;
                    copy.employee = data.employee;
                    copy.jsonData = angular.toJson(data.menu);

                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.menu = angular.fromJson(data.jsonData);
                    }

                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EmployeeSystemDialogController', EmployeeSystemDialogController);

    EmployeeSystemDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Employee',
        'CoreService', 'Facility', 'ROLES', 'GUIUtils', 'AuthItem', 'AUTH_ITEM_TYPE', 'Corporation'];

    function EmployeeSystemDialogController($timeout, $scope, $uibModalInstance, entity, Employee,
                                      CoreService, Facility, ROLES, GUIUtils, AuthItem, AUTH_ITEM_TYPE, Corporation) {
        var vm = this;

        vm.employee = entity;
        vm.authorities = [];
        vm.userExist = false;
        vm.emailExist = false;
        vm.gender = GUIUtils.getGender();
        vm.credentials = Employee.credentials();
        vm.ips = angular.copy(vm.employee.employeeInetAddresses);
        vm.signatureOpts = getSignatureOptions();
        vm.odsSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.employeeSignature = '';

        vm.clear = clear;
        vm.save = save;
        vm.searchUser = searchUser;
        vm.searchEmail = searchEmail;
        vm.ipTagTransform = ipTagTransform;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.employee.signature = vm.employeeSignature;

            if (vm.employee.id !== null) {
                Employee.updateSystem(vm.employee, onSaveSuccess, onSaveError);
            } else {
                Employee.createSystem(vm.employee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:employeeUpdate', result);
            $uibModalInstance.close(result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function searchUser(query) {
            if (query && query.length > 2) {
                Employee.existUserName({query: query}, function (result) {

                    vm.userExist = result.value;
                });
            }
        }

        function searchEmail(query) {
            if (query && query.length > 2) {
                Employee.existEmail({query: query}, function (result) {

                    vm.emailExist = result.value;
                });
            }
        }

        function ipTagTransform(newTag) {
            var item = {
                id: null,
                value: newTag,
            };

            return item;
        }

        function getSignatureOptions() {

            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EmployeeDialogController', EmployeeDialogController);

    EmployeeDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Employee',
        'CoreService', 'Facility', 'ROLES', 'GUIUtils', 'AuthItem', 'AUTH_ITEM_TYPE', 'Corporation'];

    function EmployeeDialogController($timeout, $scope, $uibModalInstance, entity, Employee,
                                      CoreService, Facility, ROLES, GUIUtils, AuthItem, AUTH_ITEM_TYPE, Corporation) {
        var vm = this;

        vm.employee = entity;
        vm.authorities = [];
        vm.userExist = false;
        vm.emailExist = false;
        vm.gender = GUIUtils.getGender();
        vm.credentials = Employee.credentials();
        vm.ips = angular.copy(vm.employee.employeeInetAddresses);
        vm.signatureOpts = getSignatureOptions();
        vm.odsSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.employeeSignature = '';

        vm.clear = clear;
        vm.save = save;
        vm.searchUser = searchUser;
        vm.searchEmail = searchEmail;
        vm.ipTagTransform = ipTagTransform;

        init();

        function init() {
            vm.facilities = Facility.byCorporation({id: vm.employee.corporation.id});

            vm.authorities = AuthItem.queryByType({
                type: AUTH_ITEM_TYPE.TYPE_ROLE,
                id: vm.employee.corporation.id,
                exclude: [ROLES.ROLE_SYSTEM]
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.employee.signature = vm.employeeSignature;

            if (vm.employee.id !== null) {
                Employee.update(vm.employee, onSaveSuccess, onSaveError);
            } else {
                Employee.save(vm.employee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:employeeUpdate', result);
            $uibModalInstance.close(result);

            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function searchUser(query) {
            if (query && query.length > 2) {
                Employee.existUserName({query: query}, function (result) {

                    vm.userExist = result.value;
                });
            }
        }

        function searchEmail(query) {
            if (query && query.length > 2) {
                Employee.existEmail({query: query}, function (result) {

                    vm.emailExist = result.value;
                });
            }
        }

        function ipTagTransform(newTag) {
            var item = {
                id: null,
                value: newTag,
            };

            return item;
        }

        function getSignatureOptions() {

            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EmployeeSystemController', EmployeeSystemController);

    EmployeeSystemController.$inject = ['GenericEntityDatatableService', 'Employee', 'GUIUtils', 'CoreService',
        '$uibModal', 'ConfirmationService', '$q'];

    function EmployeeSystemController(GenericEntityDatatableService, Employee, GUIUtils, CoreService,
                                      $uibModal, ConfirmationService, $q) {

        var vm = this;

        vm.descriptor = {
            title: 'Supervisors',
            newButtonTitle: 'New Employee',
            entityClassHumanized: 'Employee',
            entityStateName: 'employee',
            service: Employee,
            serviceMethod: 'findAllByFilterSystem',
            params: {},
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: null,
                    title: 'Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    }
                },
                {
                    name: 'login',
                    title: 'Login',
                },
                {
                    name: null,
                    title: 'Email',
                    render: function (data) {
                        return data.email ? data.email : '-';
                    }
                },
                {
                    name: null,
                    title: 'Mobile',
                    render: function (data) {
                        return data.mobile ? data.mobile : '-';
                    }
                },
                {
                    name: null,
                    title: 'NPI',
                    render: function (data) {
                        return data.npiNumber ? data.npiNumber : '-';
                    }
                },
                {
                    name: null,
                    title: 'DEA',
                    render: function (data) {
                        return data.deaNumber ? data.deaNumber : '-';
                    }
                },
                {
                    name: null,
                    title: 'Activated',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.activated);
                    }
                },
                {
                    name: null,
                    title: 'Deleted',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.delStatus);
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    },
                    ngIf: function (data) {
                        return !data.delStatus;
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getRestoreAction(), {
                    name: "Restore",
                    action: function (data) {
                        return restore(data.id);
                    },
                    ngIf: function (data) {
                        return data.delStatus;
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Supervisor',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'query',
                    type: 'string',
                    visible: false,
                    read: function (filter) {
                        return filter.searchQuery;
                    }
                }
            ]
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/employee/update-system/employee-dialog.html',
                controller: 'EmployeeSystemDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            email: null,
                            mobile: null,
                            npiNumber: null,
                            deaNumber: null,
                            delStatus: false,
                            firstName: null,
                            lastName: null,
                            user: {activated: true},
                            id: null,
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/employee/update-system/employee-dialog.html',
                controller: 'EmployeeSystemDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Employee', function (Employee) {
                        return Employee.get({id: id}).$promise;
                    }],
                    authorities: ['AuthItem', 'AUTH_ITEM_TYPE', 'CoreService', function (AuthItem, AUTH_ITEM_TYPE, CoreService) {
                        var corporation = CoreService.getCorporation();

                        return AuthItem.queryByType({type: AUTH_ITEM_TYPE.TYPE_ROLE, id: corporation.id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Employee').result.then(function () {
                    Employee.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function restore(id) {
            return $q(function (resolve) {
                ConfirmationService.open({
                    title: 'Restore Employee',
                    message: 'This action will <strong>restore</strong> a deleted employee. Are you sure you want to <strong>restore</strong> this Employee?',
                    actions: [
                        {
                            name: 'Restore',
                            color: 'btn btn-success',
                            icon: 'fa fa-check-circle',
                            value: 'SUCCESS'
                        },
                        {
                            name: 'Cancel',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                }).result.then(function () {
                    Employee.restore(id, function () {
                        resolve();
                    });
                });
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Employee', Employee);

    Employee.$inject = ['$resource', 'Utils'];

    function Employee($resource, Utils) {
        var resourceUrl = 'api/employees/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fullName = data.firstName + ' ' + data.lastName;
                        if (data.credentials) {
                            data.credentials = Utils.objectRoleToArray(data.credentials);
                        }
                    }
                    return data;
                }
            },
            'employeeAccount': {
                url: 'api/employeeAccount', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fullName = data.firstName + ' ' + data.lastName;
                        if (data.credentials) {
                            data.credentials = Utils.objectRoleToArray(data.credentials);
                        }
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'createSystem': {url: 'api/employees/system', method: 'POST'},
            'updateSystem': {url: 'api/employees/system', method: 'PUT'},
            'employeeIsValidPin': {
                url: 'api/employees/is-valid-pin/:pin', method: 'GET'
            },
            'credentials': {url: 'api/employees/credentials', method: 'GET', isArray: true},
            'findAllByFilter': {
                url: 'api/employees/find-all-by-filter',
                method: 'GET',
                isArray: true
            },
            'findAllByCorporation': {
                url: 'api/employees/by-corporation',
                method: 'GET',
                isArray: true
            },
            'findAllByFilterAdmin': {
                url: 'api/employees/admin',
                method: 'GET',
                isArray: true
            },
            'findAllByFilterSystem': {
                url: 'api/employees/system',
                method: 'GET',
                isArray: true
            },
            'existUserName': {
                url: 'api/employees/exist/user', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data = {value: data};
                    }

                    return data;
                }
            },
            'existEmail': {
                url: 'api/employees/exist/email', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data = {value: data};
                    }

                    return data;
                }
            },
            'findAllWithoutChartBlocked': {url: 'api/employees/without-chart-blocked', method: 'GET', isArray: true},
            'findAllWithoutRcopiaAccount': {url: 'api/employees/without-rcopia-account', method: 'GET', isArray: true},
            'restore': {url: 'api/employees/restore', method: 'PUT'},
            'checkBusinessRole': {
                url: 'api/employees/check-business-role/:facilityId/:businessRole', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data = {value: data};
                    }

                    return data;
                }
            },
            'replaceSignature': {
                url: 'api/employees/replace-signature', method: 'POST'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EmployeeController', EmployeeController);

    EmployeeController.$inject = ['GenericEntityDatatableService', 'Employee', 'GUIUtils', 'CoreService', 'ROLES',
        'Principal', '$uibModal', '$q', 'ConfirmationService'];

    function EmployeeController(GenericEntityDatatableService, Employee, GUIUtils, CoreService, ROLES,
                                Principal, $uibModal , $q, ConfirmationService) {
        var vm = this;

        vm.isAdmin = Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN]);

        var params = {
            corporationId: CoreService.getCorporation().id,
        }

        vm.descriptor = {
            title: 'Employees',
            newButtonTitle: 'New Employee',
            entityClassHumanized: 'Employee',
            entityStateName: 'employee',
            service: Employee,
            serviceMethod: 'findAllByFilterAdmin',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: null,
                    title: 'Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    }
                },
                {
                    title: 'Login',
                    render: function (data) {
                        return data.login;
                    }
                },
                {
                    name: null,
                    title: 'Email',
                    render: function (data) {
                        return data.email ? data.email : '-';
                    }
                },
                {
                    name: null,
                    title: 'Mobile',
                    render: function (data) {
                        return data.mobile ? data.mobile : '-';
                    }
                },
                {
                    name: null,
                    title: 'NPI',
                    render: function (data) {
                        return data.npiNumber ? data.npiNumber : '-';
                    }
                },
                {
                    name: null,
                    title: 'DEA',
                    render: function (data) {
                        return data.deaNumber ? data.deaNumber : '-';
                    }
                },
                {
                    name: null,
                    title: 'Activated',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.activated);
                    }
                },
                {
                    name: null,
                    title: 'Deleted',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.delStatus);
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('acuity'), {
                    action: function (data) {
                        return del(data.id);
                    },
                    ngIf: function (data) {
                        return !data.delStatus;
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getRestoreAction(), {
                    name: "Restore",
                    action: function (data) {
                        return restore(data.id);
                    },
                    ngIf: function (data) {
                        return data.delStatus && vm.isAdmin;
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Employee',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'query',
                    type: 'string',
                    visible: false,
                    read: function (filter) {
                        return filter.searchQuery;
                    }
                }
            ]
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/employee/update/employee-dialog.html',
                controller: 'EmployeeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            email: null,
                            mobile: null,
                            npiNumber: null,
                            deaNumber: null,
                            delStatus: false,
                            firstName: null,
                            lastName: null,
                            user: {activated: true},
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/employee/update/employee-dialog.html',
                controller: 'EmployeeDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Employee', function (Employee) {
                        return Employee.get({id: id}).$promise;
                    }],
                    authorities: ['AuthItem', 'AUTH_ITEM_TYPE', 'CoreService', function (AuthItem, AUTH_ITEM_TYPE, CoreService) {
                        var corporation = CoreService.getCorporation();

                        return AuthItem.queryByType({type: AUTH_ITEM_TYPE.TYPE_ROLE, id: corporation.id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Employee').result.then(function () {
                    Employee.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function restore(id) {
            return $q(function (resolve) {
                ConfirmationService.open({
                    title: 'Restore Employee',
                    message: 'This action will <strong>restore</strong> a deleted employee. Are you sure you want to <strong>restore</strong> this Employee?',
                    actions: [
                        {
                            name: 'Restore',
                            color: 'btn btn-success',
                            icon: 'fa fa-check-circle',
                            value: 'SUCCESS'
                        },
                        {
                            name: 'Cancel',
                            color: 'btn btn-danger',
                            icon: 'fa fa-ban',
                            value: 'CANCEL'
                        }
                    ]
                }).result.then(function () {
                    Employee.restore(id, function () {
                        resolve();
                    });
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('employee', {
                parent: 'entity',
                url: '/employee',
                data: {
                    authorities: [],
                    pageTitle: 'Employees'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/employee/list/employee.html',
                        controller: 'EmployeeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    employee: ['Employee', function (Employee) {
                        return Employee.employeeAccount().$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_EMPLOYEE, access);
                }]
            })
            .state('employee-system', {
                parent: 'entity',
                url: '/employee-system',
                data: {
                    authorities: ['ROLE_SYSTEM_ADMIN'],
                    pageTitle: 'Supervisors'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/employee/system/employee-system.html',
                        controller: 'EmployeeSystemController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DrugDialogController', DrugDialogController);

    DrugDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Drug'];

    function DrugDialogController ($timeout, $scope, $uibModalInstance, entity, Drug) {
        var vm = this;

        vm.drug = entity;
        vm.datePickerOpenStatus = {};

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;

        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        vm.dateOptions = {
            maxDate: new Date() + 1
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.drug.id !== null) {
                Drug.update(vm.drug, onSaveSuccess, onSaveError);
            } else {
                Drug.save(vm.drug, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:drugUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Drug', Drug);

    Drug.$inject = ['$resource', 'DateUtils'];

    function Drug ($resource, DateUtils) {
        var resourceUrl =  'api/drugs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                        data.time = DateUtils.convertDateTimeFromServer(data.time);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findLastByChart': {url: 'api/drug/last/by-chart/:id', method: 'GET'},
            'findAllByChart': {url: 'api/drug/by-chart/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DrugHistoryController', DrugHistoryController);

    DrugHistoryController.$inject = ['$uibModalInstance', 'chart', 'Drug', '$q', 'DTColumnBuilder', 'DTOptionsBuilder',
        '$compile', '$scope', '$rootScope', '$uibModal', 'ConfirmationService', '$uibModalStack'];

    function DrugHistoryController($uibModalInstance, chart, Drug, $q, DTColumnBuilder, DTOptionsBuilder,
                                   $compile, $scope, $rootScope, $uibModal, ConfirmationService, $uibModalStack) {
        var vm = this;

        vm.drugs = [];
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.dtInstance = {};
        vm.chart = chart;

        vm.clear = clear;
        vm.search = search;
        vm.edit = edit;
        vm.del = del;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Drug.findAllByChart(
                {
                    id: vm.chart.id,
                    page: vm.page - 1,
                    size: vm.itemsPerPage
                }, function (result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.drugs = result;
                    defer.resolve(vm.drugs);
                });
            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notVisible().renderWith(function (data, type, full) {
                return data ? moment(data.date).format("YYYYMMDD") : "";
            }),
            DTColumnBuilder.newColumn('date').withTitle('Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barbiturate').renderWith(function (data, type, full) {
                return resolveValueField(data.barbiturate);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Amphetamine').renderWith(function (data, type, full) {
                return resolveValueField(data.amphetamine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Methadone').renderWith(function (data, type, full) {
                return resolveValueField(data.methadone);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Opiates').renderWith(function (data, type, full) {
                return resolveValueField(data.opiates);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tetrahydrocannabinol').renderWith(function (data, type, full) {
                return resolveValueField(data.tetrahydrocannabinol);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Phencyclidine').renderWith(function (data, type, full) {
                return resolveValueField(data.phencyclidine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Benzodiazepine').renderWith(function (data, type, full) {
                return resolveValueField(data.benzodiazepine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Oxycodone').renderWith(function (data, type, full) {
                return resolveValueField(data.oxycodone);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Methamphetamine').renderWith(function (data, type, full) {
                return resolveValueField(data.methamphetamine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tricyclic Antidepressants').renderWith(function (data, type, full) {
                return resolveValueField(data.tricyclicAntidepressants);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Buprenorphine').renderWith(function (data, type, full) {
                return resolveValueField(data.buprenorphine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Cocaine').renderWith(function (data, type, full) {
                return resolveValueField(data.cocaine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Morphine').renderWith(function (data, type, full) {
                return resolveValueField(data.morphine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Methylenedioxymethamphetamine').renderWith(function (data, type, full) {
                return resolveValueField(data.methylenedioxymethamphetamine);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Alcohol').renderWith(function (data, type, full) {
                return resolveValueField(data.etg);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Fentanyl').renderWith(function (data, type, full) {
                return resolveValueField(data.fyl);
            }),
            DTColumnBuilder.newColumn(null).withTitle('K2').renderWith(function (data, type, full) {
                return resolveValueField(data.k2);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Ketamine').renderWith(function (data, type, full) {
                return resolveValueField(data.ket);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Kratom').renderWith(function (data, type, full) {
                return resolveValueField(data.kra);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Tramadol').renderWith(function (data, type, full) {
                return resolveValueField(data.tml);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Description').renderWith(function (data, type, full) {
                return data.description ? data.description : "-";
            }),
            DTColumnBuilder.newColumn('createdBy').withTitle('Created by'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                '   <i class="fa fa-trash"></i></a>';

            return stButtons;
        }


        function search() {
            vm.dtInstance.reloadData();
        }

        function resolveValueField(value) {
            return value == 1 ? 'Positive' : value == -1 ? 'Negative' : 'N/A'
        }

        function edit(id) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/drug/update/drug-dialog.html',
                controller: 'DrugDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Drug', function (Drug) {
                        return Drug.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Drug').result.then(function () {
                Drug.delete({id: id}, function () {
                    search();
                });
            });
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DrugChartController', DrugChartController);

    DrugChartController.$inject = ['chart', 'Drug', 'CoreService', '$uibModal', '$scope', 'Alcohol', 'access', 'ACTIONS', '$window', '$rootScope', 'Auth'];

    function DrugChartController(chart, Drug, CoreService, $uibModal, $scope, Alcohol, access, ACTIONS, $window, $rootScope, Auth) {
        var vm = this;

        vm.chart = chart;
        vm.accessAlcoholView = access[ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW] ? access[ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW].roles.join() : null;
        vm.accessDrugsView = access[ACTIONS.ACTION_PATIENT_DRUGS_VIEW] ? access[ACTIONS.ACTION_PATIENT_DRUGS_VIEW].roles.join() : null;
        vm.activeTab = vm.accessAlcoholView ? 0 : 1;

        vm.keepActiveTab = keepActiveTab;
        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.history = history;
        vm.getAlcoholGraphOpt = getAlcoholGraphOpt;
        vm.getDrugsGraphOpt = getDrugsGraphOpt;

        vm.dataDrug = [];
        vm.dataAlcohol = [];

        vm.valueData = {
            values: [],
            key: 'value',
            color: '#000000'
        };

        var unsubscribe = $rootScope.$on('bluebookApp:alcoholUpdate', function(event, result) {
            getAlcoholData();
        });

        var unsubscribe = $rootScope.$on('bluebookApp:drugUpdate', function(event, result) {
            getDrugData();
        });

        function toggleItem() {
            CoreService.togglePanel('drugs');
        }

        function keepActiveTab(index) {
            vm.activeTab = index;
        }

        loadAll();

        function loadAll() {
            getAlcoholData();
            getDrugData();
        }

        function getAlcoholData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW, access)) {
                return;
            }

            Alcohol.byChart({chartId: vm.chart.id, page: 0, size: 10}, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                if (vm.totalItems > 0) {
                    vm.alcohol = result[0];
                }

                vm.dataAlcohol = [];

                vm.valueData = {
                    values: [],
                    key: 'value',
                    color: '#000000'
                };

                for (var i = result.length - 1; i >= 0; i--) {
                    vm.valueData.values.push({x: new Date(result[i].date).getTime(), y: parseFloat(result[i].value)});
                }

                vm.dataAlcohol.push(vm.valueData);
            });
        }

        function getDrugData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_DRUGS_VIEW, access)) {
                return;
            }

            Drug.findLastByChart({id: chart.id}, function (data) {
                if (data != null) {
                    vm.drug = data;
                    vm.dataDrug = [];

                    vm.dataDrug = {values: []};
                    if (data.barbiturate) {
                        vm.dataDrug.values.push({label: "BAR", value: data.barbiturate});
                    }

                    if (data.amphetamine) {
                        vm.dataDrug.values.push({label: "AMP", value: data.amphetamine});
                    }

                    if (data.methadone) {
                        vm.dataDrug.values.push({label: "MTD", value: data.methadone});
                    }

                    if (data.opiates) {
                        vm.dataDrug.values.push({label: "OPI", value: data.opiates});
                    }

                    if (data.tetrahydrocannabinol) {
                        vm.dataDrug.values.push({label: "THC", value: data.tetrahydrocannabinol});
                    }

                    if (data.phencyclidine) {
                        vm.dataDrug.values.push({label: "PCP", value: data.phencyclidine});
                    }

                    if (data.benzodiazepine) {
                        vm.dataDrug.values.push({label: "BZO", value: data.benzodiazepine});
                    }

                    if (data.oxycodone) {
                        vm.dataDrug.values.push({label: "OXY", value: data.oxycodone});
                    }

                    if (data.methamphetamine) {
                        vm.dataDrug.values.push({label: "MET", value: data.methamphetamine});
                    }

                    if (data.tricyclicAntidepressants) {
                        vm.dataDrug.values.push({label: "TCA", value: data.tricyclicAntidepressants});
                    }

                    if (data.buprenorphine) {
                        vm.dataDrug.values.push({label: "BUP", value: data.buprenorphine});
                    }

                    if (data.cocaine) {
                        vm.dataDrug.values.push({label: "COC", value: data.cocaine});
                    }

                    if (data.morphine) {
                        vm.dataDrug.values.push({label: "MOP", value: data.morphine});
                    }

                    if (data.methylenedioxymethamphetamine) {
                        vm.dataDrug.values.push({label: "MDMA", value: data.methylenedioxymethamphetamine});
                    }

                    vm.dataDrug = [vm.dataDrug];
                }
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/drug/update/drug-dialog.html',
                controller: 'DrugDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            id: null,
                            chart: chart,
                            barbiturate: 0,
                            amphetamine: 0,
                            methadone: 0,
                            opiates: 0,
                            tetrahydrocannabinol: 0,
                            phencyclidine: 0,
                            benzodiazepine: 0,
                            oxycodone: 0,
                            methamphetamine: 0,
                            tricyclicAntidepressants: 0,
                            buprenorphine: 0,
                            cocaine: 0,
                            morphine: 0,
                            methylenedioxymethamphetamine: 0,
                            etg: 0,
                            fyl: 0,
                            k2: 0,
                            ket: 0,
                            kra: 0,
                            tml: 0,
                            date: new Date()
                        };
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/drug/history/drug-history.html',
                controller: 'DrugHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        getAlcoholGraphOpt();

        function getAlcoholGraphOpt() {
            vm.alcoholGraphOpt = {
                chart: {
                    type: 'lineChart',
                    showLegend: false,
                    height: 240,
                    showXAxis: false,
                    margin: {
                        top: 20,
                        right: 50,
                        bottom: 100,
                        left: 50
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis: {
                        tickFormat: function (d) {
                            return d3.time.format('%m/%d/%y-%H:%M')(new Date(d));
                        },
                        rotateLabels: (-70)
                    },
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('.02f')(d);
                        },
                        showMaxMin: false
                    }
                }
            };
        }

        getDrugsGraphOpt();

        function getDrugsGraphOpt() {
            vm.drugsGraphOpt = {
                chart: {
                    type: 'discreteBarChart',
                    showLegend: false,
                    showYAxis: false,
                    showValues: false,
                    height: 340,
                    forceY: 1,
                    margin: {
                        top: 20,
                        right: 50,
                        bottom: 100,
                        left: 30
                    },
                    x: function (d) {
                        return d.label;
                    },
                    y: function (d) {
                        return d.value;
                    },

                    useInteractiveGuideline: true,
                    xAxis: {
                        rotateLabels: (-70)
                    },
                    yAxis: {
                        axisLabel: 'Result',
                        showMaxMin: false
                    }
                }
            };
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDrugsHistory', function (event, result) {
            history();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DoseFormDialogController', DoseFormDialogController);

    DoseFormDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DoseForm'];

    function DoseFormDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DoseForm) {
        var vm = this;

        vm.doseForm = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.doseForm.id !== null) {
                DoseForm.update(vm.doseForm, onSaveSuccess, onSaveError);
            } else {
                DoseForm.save(vm.doseForm, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:doseFormUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('DoseForm', DoseForm);

    DoseForm.$inject = ['$resource'];

    function DoseForm ($resource) {
        var resourceUrl =  'api/dose-forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByMedication': {method: 'GET', isArray: true, url: 'api/dose-forms/by-medication/:id'},
            'findAllByCorporation': {url: 'api/dose-forms/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DoseFormController', DoseFormController);

    DoseFormController.$inject = ['GenericEntityDatatableService', 'DoseForm', 'CoreService', '$uibModal',
        'ConfirmationService', '$q'];

    function DoseFormController(GenericEntityDatatableService, DoseForm, CoreService, $uibModal,
                                ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Dose Form',
            newButtonTitle: 'New Dose Form',
            entityClassHumanized: 'Dose Form',
            entityStateName: 'dose-form',
            service: DoseForm,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Dose Form',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/dose-form/update/dose-form-dialog.html',
                controller: 'DoseFormDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/dose-form/update/dose-form-dialog.html',
                controller: 'DoseFormDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['DoseForm', function (DoseForm) {
                        return DoseForm.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('DoseForm').result.then(function () {
                    DoseForm.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('dose-form', {
                parent: 'entity',
                url: '/dose-form',
                data: {
                    authorities: [],
                    pageTitle: 'DoseForms'
                },
                ncyBreadcrumb: {
                    label: 'Dose Forms'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/dose-form/list/dose-form.html',
                        controller: 'DoseFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_DOSE_FORM];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_DOSE_FORM, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DocumoDialogController', DocumoDialogController);

    DocumoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Documo'];

    function DocumoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Documo) {
        var vm = this;

        vm.documo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documo.id !== null) {
                Documo.update(vm.documo, onSaveSuccess, onSaveError);
            } else {
                Documo.save(vm.documo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:documoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Documo', Documo);

    Documo.$inject = ['$resource'];

    function Documo ($resource) {
        var resourceUrl =  'api/documos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "findAllDocumos":{url: 'api/documos', method: 'GET', isArray: true},
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DocumoController', DocumoController);

    DocumoController.$inject = ['$scope', '$state', 'Documo', '$q', 'ConfirmationService', '$uibModal',
        'GenericEntityDatatableService'];

    function DocumoController ($scope, $state, Documo, $q, ConfirmationService, $uibModal,
                               GenericEntityDatatableService) {
        var vm = this;

        vm.descriptor = {
            title: 'Documo',
            newButtonTitle: 'New Documo',
            entityClassHumanized: 'Documo',
            entityStateName: 'documo',
            service: Documo,
            serviceMethod: 'findAllDocumos',
            newAction: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            enableSearch: false,
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Documo',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0
                            },
                        })
                    ]
                }
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/documo/update/documo-dialog.html',
                controller: 'DocumoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            token: null,
                            api: null,
                            faxNumber: null,
                            id: null
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/documo/update/documo-dialog.html',
                controller: 'DocumoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Documo', function (Documo) {
                        return Documo.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Documo').result.then(function () {
                    Documo.delete({id: id}, function () {
                        resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('documo', {
                parent: 'entity',
                url: '/documo',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Documos'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/documo/list/documo.html',
                        controller: 'DocumoController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DietDialogController', DietDialogController);

    DietDialogController.$inject = ['$timeout', '$scope', 'entity', '$uibModalInstance', 'Diet',
        'TypeFoodDiets', 'CoreService'];

    function DietDialogController($timeout, $scope, entity, $uibModalInstance, Diet,
                                  TypeFoodDiets, CoreService) {
        var vm = this;

        vm.diet = entity;
        vm.chart = vm.diet.chart;
        vm.typeFoodDiets = TypeFoodDiets.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.form = {};
        vm.showDelete = false;

        vm.clear = clear;
        vm.save = save;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};

        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;
        vm.confirmDelete = confirmDelete;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.diet.id !== null) {
                Diet.update(vm.diet, onSaveSuccess, onSaveError);
            } else {
                Diet.save(vm.diet, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:dietUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.diet.startDate;
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.diet.endDate;
        }

        function confirmDelete () {
            Diet.delete({id: vm.diet.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Diet', Diet);

    Diet.$inject = ['$resource', 'DateUtils'];

    function Diet ($resource, DateUtils) {
        var resourceUrl =  'api/diets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT'},
            "findAllByChart":{url: 'api/diets/by-chart', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DietHistoryNewController', DietHistoryNewController);

    DietHistoryNewController.$inject = ['Diet', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService', 'chart',
                                        '$timeout', '$uibModalInstance'];

    function DietHistoryNewController(Diet, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart,
                                      $timeout, $uibModalInstance) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.diets = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            Diet.findAllByChart(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.diets = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DietFoodMemoController', DietFoodMemoController);

    DietFoodMemoController.$inject = ['$uibModalInstance', 'chart', 'Allergies', 'Diet'];

    function DietFoodMemoController($uibModalInstance, chart, Allergies, Diet) {
        var vm = this;
        vm.clear = clear;
        vm.chartImage = chart.pictureRef.picture;
        vm.name = chart.lastName + " " + chart.firstName;
        vm.mrNumber = chart.mrNo;

        var dd = {
            content: [],
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                    alignment: 'justify'
                },
                subheader: {
                    fontSize: 15,
                    bold: true
                },
                quote: {
                    italics: true
                },
                small: {
                    fontSize: 8
                },
                tableExample: {
                    margin: [0, 5, 0, 15]
                },

                tableHeader: {
                    bold: true,
                    fontSize: 13,
                    color: 'black'
                }
            }
        }

        var header = {
            text: 'Food Memo',
            style: 'header'
        };
        var information = {
            text: 'Patient special dietary',
            style: 'subheader',
            alignment: 'center'
        };
        var personalInfo = {
            style: 'tableExample',
            table: {
                headerRows: 1,
                body: [[{text: 'Name: ', style: 'tableHeader'}, vm.name],
                    [{text: 'MR Number: ', style: 'tableHeader'}, vm.mrNumber]]
            }, layout: 'noBorders'
        };
        var image = {image: vm.chartImage, alignment: 'center', width: 450, height: 450};

        var foodAllergies = {
            style: 'tableExample',
            table: {
                headerRows: 1,
                widths: ['*'],
                body: []
            },
            alignment: 'center',
            layout: 'headerLineOnly'
        };

        var activeDiets = {
            style: 'tableExample',
            table: {
                headerRows: 1,
                widths: ['*'],
                body: []
            },
            alignment: 'center',
            layout: 'headerLineOnly'
        };

        dd.content.push(header);
        dd.content.push(information);
        dd.content.push(personalInfo);
        dd.content.push(image);

        loadL();

        function loadL() {
            Allergies.findAllAllergiesByChart({id: chart.id, allergenType: 'Food'}, function (result) {
                vm.allergies = result;
                foodAllergies.table.body.push([{text: 'Food Allergies', style: 'tableHeader'}]);
                for (var i = 0; i < vm.allergies.length; i++) {
                    foodAllergies.table.body.push([{text: vm.allergies[i].name}]);
                }
                if (vm.allergies.length) {
                    dd.content.push(foodAllergies);
                }

                Diet.findAllByChart({id: chart.id, active: true}, function (result) {
                    vm.diets = result;
                    activeDiets.table.body.push([{text: 'Diets', style: 'tableHeader'}]);
                    for (var i = 0; i < vm.diets.length; i++) {
                        activeDiets.table.body.push([{text: vm.diets[i].typeFoodDiets.name}]);
                    }
                    if (vm.diets.length) {
                        dd.content.push(activeDiets);
                    }
                    vm.pdf = pdfMake.createPdf(dd);

                    vm.pdf.getBase64(function (output) {
                        vm.pdfBase64 = 'data:application/pdf;base64,' + output;
                    });

                });

            });
        }


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DietController', DietController);

    DietController.$inject = ['chart', 'Diet', 'CoreService', '$sessionStorage', '$uibModal', 'access', 'ACTIONS',
        'Auth', 'ConfirmationService'];

    function DietController(chart, Diet, CoreService, $sessionStorage, $uibModal, access, ACTIONS,
                            Auth, ConfirmationService) {
        var vm = this;

        vm.chart = chart;
        vm.currentDate = new Date();
        vm.activeTab = $sessionStorage.activePatientTabDiets ? $sessionStorage.activePatientTabDiets.activeTab : 0;
        vm.name = chart.lastName + " " + chart.firstName;
        vm.mrNumber = chart.mrNo;

        vm.toggleItem = toggleItem;
        vm.keepActiveTab = keepActiveTab;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;

        loadData();

        function loadData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_DIETS_VIEW, access)) {

                return;
            }

            vm.dietsActive = Diet.findAllByChart({chartId: chart.id, page: 0, size: 100, active: true});
            vm.dietsInactive = Diet.findAllByChart({chartId: chart.id, page: 0, size: 100, active: false});
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/diet/update/diet-dialog.html',
                controller: 'DietDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            id: null,
                            endDate: null,
                            startDate: null,
                            chart: chart
                        };
                    }
                }
            }).result.then(function () {
                loadData()
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/diet/update/diet-dialog.html',
                controller: 'DietDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Diet', function (Diet) {
                        return Diet.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadData()
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Diet').result.then(function () {
                Diet.delete({id: id}, function () {
                    loadData();
                });
            })
        }

        function toggleItem() {
            CoreService.togglePanel('diet');
        }

        function keepActiveTab(index) {
            $sessionStorage.activePatientTabDiets = {activeTab: index};
            vm.activeTab = index;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosesDialogController', DiagnosesDialogController);

    DiagnosesDialogController.$inject = ['$timeout', '$scope', 'BUSINESS_ROLES', 'BusinessCredential', '$uibModalInstance',
        'CoreService', 'entity', 'Diagnoses', 'toastr', 'Acuity', 'Icd10Search'];

    function DiagnosesDialogController($timeout, $scope, BUSINESS_ROLES, BusinessCredential, $uibModalInstance,
                                       CoreService, entity, Diagnoses, toastr, Acuity, Icd10Search) {

        var vm = this;

        vm.diagnoses = entity;
        vm.icd10 = [];
        vm.showDelete = false;

        vm.save = save;
        vm.clear = clear;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;
        vm.getIcd10 = getIcd10;
        vm.confirmDelete = confirmDelete;

        init();

        function init() {
            vm.datePickerOpenStatus = {
                startDate: false,
                endDate: false
            }

            vm.endDateOptions = {
                maxDate: new Date()
            }

            vm.startDateOptions = {}
        }

        function getIcd10(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.diagnoses.endDate;

            if (vm.diagnoses.endDate) {
                vm.diagnoses.endDate.setMilliseconds(0);
                vm.diagnoses.endDate.setSeconds(0);
            }
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.diagnoses.startDate;
            vm.endDateOptions.maxDate = new Date();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            Diagnoses.update(vm.diagnoses, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:diagnosesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function confirmDelete() {
            Diagnoses.delete({id: vm.diagnoses.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();


(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Diagnoses', Diagnoses);

    Diagnoses.$inject = ['$resource','DateUtils'];

    function Diagnoses ($resource, DateUtils) {
        var resourceUrl =  'api/diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'create': {url: 'api/diagnoses/create',  method:'POST'},
            'findAllByChart': {url: 'api/diagnoses/by-chart/:id', method: 'GET', isArray: true},
            'findAllInactiveDiagnosesByChart': {url: 'api/diagnoses/inactive/by-chart/:id', method: 'GET', isArray: true},
            'findAllActiveDiagnosesByChartId': {url: 'api/diagnoses/active/by-chart/:id', method: 'GET', isArray: true},
            'findAllInactiveDiagnosesByChartWithSignature': {url: 'api/diagnoses/inactive/by-chart-with-signature/:id', method: 'GET', isArray: true},
            'findAllActiveDiagnosesByChartWithSignature': {url: 'api/diagnoses/active/by-chart-with-signature/:id', method: 'GET', isArray: true},
            'findAllPhysicianReview': {url: 'api/diagnoses/physician-review', method: 'GET', isArray: true},
            'lastsIcd10UsedByFacility': {url: 'api/diagnoses/lasts-icd10-used-by-facility', method: 'GET', isArray: true},
            'sign': {url: 'api/diagnoses/sign', method: 'POST'},
            'discontinue': {url: 'api/diagnoses/discontinue', method: 'POST'},
            'reorder': { method: 'POST', url: 'api/diagnoses/reorder', isArray: false }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosesHistoryNewController', DiagnosesHistoryNewController);

    DiagnosesHistoryNewController.$inject = ['Diagnoses', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                             'chart', '$uibModalInstance', '$timeout'];

    function DiagnosesHistoryNewController(Diagnoses, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                           chart, $uibModalInstance, $timeout) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.diagnoses = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            Diagnoses.findAllByChart(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.diagnoses = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosesDiscontinueDialogController', DiagnosesDiscontinueDialogController);

    DiagnosesDiscontinueDialogController.$inject = ['$uibModalInstance', 'CoreService', 'entity'];

    function DiagnosesDiscontinueDialogController($uibModalInstance, CoreService, entity) {

        var vm = this;

        vm.diagnoses = entity;
        vm.diagnoses.endDate = "";

        vm.employeeSignature = '';
        vm.employeeSignaturePin = null;
        vm.signatureOpts = getSignatureOptions();
        vm.employee = CoreService.getCurrentEmployee();

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.endDateOptions.minDate = vm.diagnoses.startDate;

        vm.clear = clear;
        vm.discontinue = discontinue;

        vm.openCalendar = openCalendar;

        function getSignatureOptions() {
            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function discontinue() {
            $uibModalInstance.close({
                employeeSignature: vm.employeeSignature,
                employeeSignaturePin: vm.employeeSignaturePin,
                endDate: vm.diagnoses.endDate
            });
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosesCreateDialogController', DiagnosesCreateDialogController);

    DiagnosesCreateDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Diagnoses',
        'Icd10Search', 'chart'];

    function DiagnosesCreateDialogController($timeout, $scope, $uibModalInstance, entity, Diagnoses,
                                             Icd10Search, chart) {
        var vm = this;

        vm.save = save;
        vm.clear = clear;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;
        vm.getIcd10 = getIcd10;

        init();

        function init() {
            vm.icd10 = [];

            vm.datePickerOpenStatus = {
                startDate: false,
                endDate: false
            }

            vm.endDateOptions = {
                maxDate: new Date()
            }

            vm.startDateOptions = {}

            vm.chart = chart;

            vm.diagnoses = entity;
            vm.diagnoses.chart = chart;
        }

        function getIcd10(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.diagnoses.endDate;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.diagnoses.startDate;
            vm.endDateOptions.maxDate = new Date();
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.close('dismiss');
        }

        function save() {
            vm.isSaving = true;

            Diagnoses.create(vm.diagnoses, onSaveSuccess, onSaveError)
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:diagnosesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DiagnosesController', DiagnosesController);

    DiagnosesController.$inject = ['chart', 'Diagnoses', 'BusinessCredential', 'CoreService', '$sessionStorage',
        '$uibModal', 'Employee', 'PopupService', 'BUSINESS_ROLES', 'toastr', 'ChartPicture', 'access',
        'ACTIONS', 'Auth', 'ConfirmationService', '$rootScope'];

    function DiagnosesController(chart, Diagnoses, BusinessCredential, CoreService, $sessionStorage,
                                 $uibModal, Employee, PopupService, BUSINESS_ROLES, toastr, ChartPicture, access,
                                 ACTIONS, Auth, ConfirmationService, $rootScope) {
        var vm = this;

        vm.chart = chart;

        vm.activeTab = $sessionStorage.activePatientTabDiagnoses ? $sessionStorage.activePatientTabDiagnoses.activeTab : 0;
        vm.name = chart.lastName + " " + chart.firstName;
        vm.mrNumber = chart.mrNo;

        vm.employee = CoreService.getCurrentEmployee();
        vm.facility = CoreService.getCurrentFacility();

        vm.toggleItem = toggleItem;
        vm.loadDiagnoses = loadDiagnoses;
        vm.add = add;
        vm.del = del;
        vm.edit = edit;
        vm.keepActiveTab = keepActiveTab;
        vm.discontinue = discontinue;
        vm.onDragEnd = onDragEnd;

        init();

        loadData();

        function init() {
            BusinessCredential.getCredentialByRole({
                businessRole: BUSINESS_ROLES.DISCONTINUE_DIAGNOSES,
                id: vm.facility.id
            }, function (result) {
                vm.credentials = result;

                vm.itHasCredentials = _.intersection(vm.employee.credentials,
                    _.map(vm.credentials, function (credential) {
                        return credential.name;
                    })
                ).length > 0;
            });
        }

        function toggleItem() {
            CoreService.togglePanel('diagnoses');
        }

        function keepActiveTab(index) {
            $sessionStorage.activePatientTabDiagnoses = {activeTab: index};
            vm.activeTab = index;
        }

        function loadData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW, access)) {

                return;
            }

            vm.diagnosesActive = [];
            vm.diagnosesInactive = [];

            Diagnoses.findAllActiveDiagnosesByChartId({id: chart.id}, function (result) {
                vm.diagnosesActive = result;
            })


            Diagnoses.findAllInactiveDiagnosesByChart({id: chart.id}, function (result) {
                vm.diagnosesInactive = result;
            });
        }

        function loadDiagnoses() {
            var dd = {
                pageOrientation: 'landscape',
                content: [
                    {
                        text: 'Diagnoses',
                        style: 'header',
                        alignment: 'center'
                    },
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15],
                        fontSize: 11,
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 12,
                        color: 'black'
                    }
                }
            };


            var headerActive = {
                text: 'Active Diagnoses:',
                fontSize: 12,
                bold: true,
                margin: [0, 20, 0, 8]
            };

            var activeDiagnoses = {
                style: 'tableExample',
                table: {
                    widths: [120, 65, 40, 60, 60, 60, 60, 70, '*'],
                    headerRows: 1,
                    body: [
                        [
                            {text: 'Diagnoses', style: 'tableHeader'},
                            {text: 'Rank', style: 'tableHeader'},
                            {text: 'Acuity', style: 'tableHeader'},
                            {text: 'Start date', style: 'tableHeader'},
                            {text: 'End Date', style: 'tableHeader'},
                            {text: 'Comment', style: 'tableHeader'},
                            {text: 'Signed By', style: 'tableHeader'},
                            {text: 'Signed Date', style: 'tableHeader'},
                            {text: 'Signature', style: 'tableHeader'}
                        ]
                    ]
                },
                layout: 'lightHorizontalLines'
            };

            var headerInactive = {
                text: 'Inactive Diagnoses:',
                fontSize: 12, bold: true,
                margin: [0, 20, 0, 8]
            };

            var inactiveDiagnoses = {
                style: 'tableExample',
                table: {
                    widths: [120, 65, 40, 60, 60, 60, 60, 70, '*'],
                    headerRows: 1,
                    body: [
                        [
                            {text: 'Diagnoses', style: 'tableHeader'},
                            {text: 'Rank', style: 'tableHeader'},
                            {text: 'Acuity', style: 'tableHeader'},
                            {text: 'Start date', style: 'tableHeader'},
                            {text: 'End Date', style: 'tableHeader'},
                            {text: 'Comment', style: 'tableHeader'},
                            {text: 'Signed By', style: 'tableHeader'},
                            {text: 'Signed Date', style: 'tableHeader'},
                            {text: 'Signature', style: 'tableHeader'}
                        ]
                    ]
                },
                layout: 'lightHorizontalLines'
            };

            Diagnoses.findAllActiveDiagnosesByChartWithSignature({id: chart.id}, function (result) {
                if (result.length) {
                    result.forEach(function (element) {
                        var starDate = (element.startDate) ? moment(element.startDate).format("MM/DD/YYYY") : {
                            text: '-',
                            alignment: 'center'
                        };
                        var endDate = (element.endDate) ? moment(element.endDate).format("MM/DD/YYYY") : {
                            text: '-',
                            alignment: 'center'
                        };
                        var icd = element.icd10.code + " " + element.icd10.description;

                        var signedBy = "";
                        var image = "";
                        var signedDate = "";

                        if (element.signed) {
                            signedBy = element.signedBy.lastName + ", " + element.signedBy.firstName;
                            image = {image: element.signature.signature, width: 100};
                            signedDate = (element.signedDate) ? moment(element.signedDate).format("MM/DD/YYYY") : {
                                text: '-',
                                alignment: 'center'
                            };
                        }

                        activeDiagnoses.table.body.push([
                            icd,
                            element.rank,
                            element.acuity.name,
                            starDate,
                            endDate,
                            element.comment,
                            signedBy,
                            signedDate,
                            image
                        ]);
                    });
                    dd.content.push(headerActive);
                    dd.content.push(activeDiagnoses);
                }
                Diagnoses.findAllInactiveDiagnosesByChartWithSignature({id: chart.id}, function (result) {
                    if (result.length) {
                        result.forEach(function (element) {
                            var starDate = (element.startDate) ? moment(element.startDate).format("MM/DD/YYYY") : {
                                text: '-',
                                alignment: 'center'
                            };
                            var endDate = (element.endDate) ? moment(element.endDate).format("MM/DD/YYYY") : {
                                text: '-',
                                alignment: 'center'
                            };

                            var signedBy = "";
                            var image = "";
                            var signedDate = "";

                            if (element.signed) {
                                signedBy = element.signedBy.lastName + ", " + element.signedBy.firstName;
                                image = {image: element.signature.signature, width: 100};
                                signedDate = (element.signedDate) ? moment(element.signedDate).format("MM/DD/YYYY") : {
                                    text: '-',
                                    alignment: 'center'
                                };
                            }

                            var icd = element.icd10.code + " " + element.icd10.description;
                            inactiveDiagnoses.table.body.push([
                                icd,
                                element.rank,
                                element.acuity.name,
                                starDate,
                                endDate,
                                element.comment,
                                signedBy,
                                signedDate,
                                image
                            ]);
                        });
                        dd.content.push(headerInactive);
                        dd.content.push(inactiveDiagnoses);
                    }

                    ChartPicture.getCroppedImageByChart({id: chart.id}, function (result) {
                        vm.chartImage = result.image;

                        dd.content.push(getTableHeader(vm.chartImage));

                        vm.pdf = pdfMake.createPdf(dd);
                        vm.pdf.print();
                    }, function () {
                        vm.chartImage = CoreService.patientPictureDefault().picture;

                        dd.content.push(getTableHeader(vm.chartImage));

                        vm.pdf = pdfMake.createPdf(dd);
                        vm.pdf.print();
                    });
                });
            });
        }

        function add() {
            PopupService.showDiagnosesAddPopup(chart.id).result.then(function () {
                loadData();

                $rootScope.$broadcast('bluebookApp:RcopiaReload', 'manage_problems');
            }, function () {
                loadData();
            });
        }

        function edit(id) {
            PopupService.showDiagnosesEditPopup(id).result.then(function () {
                loadData()

                $rootScope.$broadcast('bluebookApp:RcopiaReload', 'manage_problems');
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Diagnoses').result.then(function () {
                Diagnoses.delete({id: id}, function () {
                    loadData();

                    $rootScope.$broadcast('bluebookApp:RcopiaReload', 'manage_problems');
                });
            })
        }

        function getTableHeader(chartImage) {
            return {
                style: 'tableExample',
                table: {
                    widths: ['auto', '*', '*'],
                    headerRows: 1,
                    body: [
                        [
                            [{text: 'Name:', style: 'tableHeader'}, {
                                text: 'Mr number:',
                                style: 'tableHeader'
                            }, {text: 'Age:', style: 'tableHeader'}],
                            [{text: vm.name, alignment: 'left'}, {
                                text: vm.mrNumber,
                                alignment: 'left'
                            }, {text: '28', alignment: 'left'}],
                            {
                                image: chartImage,
                                width: 150,
                                height: 150,
                                alignment: 'right'
                            }
                        ],
                    ]
                },
                layout: 'noBorders'
            };
        }

        function discontinue(id) {
            PopupService.showDiagnosesDiscontinuePopup(id).result.then(function (data) {
                Diagnoses.discontinue({
                    signature: data.employeeSignature,
                    pin: data.employeeSignaturePin,
                    endDate: data.endDate,
                    facilityId: vm.facility.id,
                    id: id
                }, function (result) {
                    loadData();
                    if (result) {
                        toastr.success("The Diagnoses was discontinued successfully.");
                    } else {
                        toastr.error('The Diagnoses could not be discontinued.');
                    }
                }, function () {
                    toastr.error('The Diagnoses could not be discontinued.');
                });
            }, function () {
                // reload();
            });
        }

        function onDragEnd(list) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].xorder !== i + 1) {
                    list[i].xorder = i + 1;
                    Diagnoses.reorder({id: list[i].id, xorder: list[i].xorder})

                } else {
                    list[i].xorder = i + 1;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTaskDialogController', CrmTaskDialogController);

    CrmTaskDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'CrmTask', 'Employee', 'CoreService'];

    function CrmTaskDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                     entity, CrmTask, Employee, CoreService) {
        var vm = this;

        vm.crmTask = entity;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dueDate = false;
        vm.datePickerOpenStatus.reminder = false;
        vm.corporation = CoreService.getCorporation();

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.editorCreated = editorCreated;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.crmTask.id !== null) {
                CrmTask.update(vm.crmTask, onSaveSuccess, onSaveError);
            } else {
                CrmTask.save(vm.crmTask, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:crmTaskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.corporation.id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function editorCreated(editor, htmlText) {
            editor.root.innerHTML = htmlText;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTaskDeleteController',CrmTaskDeleteController);

    CrmTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmTask'];

    function CrmTaskDeleteController($uibModalInstance, entity, CrmTask) {
        var vm = this;

        vm.crmTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmTask.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmTask', CrmTask);

    CrmTask.$inject = ['$resource', 'DateUtils'];

    function CrmTask ($resource, DateUtils) {
        var resourceUrl =  'api/crm-tasks/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dueDate = DateUtils.convertDateTimeFromServer(data.dueDate);
                        data.reminder = DateUtils.convertDateTimeFromServer(data.reminder);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-tasks/filter', method: 'GET', isArray: true},
            'pin': {url: 'api/crm-tasks/pin', method: 'POST'},
            'completed': {url: 'api/crm-tasks/completed', method: 'POST'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTaskController', CrmTaskController);

    CrmTaskController.$inject = ['CrmTask', 'AlertService', 'entity', '$uibModal', 'CoreService', '$sce'];

    function CrmTaskController(CrmTask, AlertService, entity, $uibModal, CoreService, $sce) {
        var vm = this;

        vm.crmOpportunity = entity;
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.crmTasks = [];
        vm.pinCrmTasks = [];
        vm.groupedCrmTasks = [];
        vm.employee = CoreService.getCurrentEmployee();

        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.isOwner = isOwner;
        vm.pin = pin;
        vm.completed = completed;
        vm.getUnpin = getUnpin;
        vm.trustAsHtml = trustAsHtml;

        loadAll();

        function loadAll() {
            CrmTask.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                pin: true,
                unpaged: true
            }, function (data, headers) {
                vm.pinCrmTasks = data;
            }, onError);

            getUnpin();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-task/crm-task-dialog.html',
                controller: 'CrmTaskDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            completed: false,
                            description: null,
                            dueDate: new Date(),
                            reminder: new Date(),
                            pin: false,
                            id: null,
                            crmOpportunity: vm.crmOpportunity,
                            assignedTo: null,
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/crm-task/crm-task-dialog.html',
                controller: 'CrmTaskDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmTask', function (CrmTask) {
                        return CrmTask.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function del(id) {
            CrmTask.delete({id: id}, function () {
                loadAll();
            });
        }

        function isOwner(task) {
            return vm.employee.id == task.employee.id;
        }

        function pin(task) {
            CrmTask.pin(task, function () {
                loadAll();
            })
        }

        function completed(task) {
            CrmTask.completed(task, function () {
                loadAll();
            })
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getUnpin() {
            CrmTask.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                pin: false,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.crmTasks = data;

            }, onError);
        }

        function trustAsHtml(task) {
            return $sce.trustAsHtml(task);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTagDialogController', CrmTagDialogController);

    CrmTagDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmTag'];

    function CrmTagDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmTag) {
        var vm = this;

        vm.crmTag = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmTag.id !== null) {
                CrmTag.update(vm.crmTag, onSaveSuccess, onSaveError);
            } else {
                CrmTag.save(vm.crmTag, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmTagUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTagDeleteController',CrmTagDeleteController);

    CrmTagDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmTag'];

    function CrmTagDeleteController($uibModalInstance, entity, CrmTag) {
        var vm = this;

        vm.crmTag = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmTag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('crm-tag', {
            parent: 'entity',
            url: '/crm-tag',
            data: {
                authorities: [],
                pageTitle: 'CrmTags'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/crm-tag/crm-tags.html',
                    controller: 'CrmTagController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access);
            }]
        })
        .state('crm-tag.new', {
            parent: 'crm-tag',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal,  Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-tag/crm-tag-dialog.html',
                        controller: 'CrmTagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CoreService', function (CoreService) {
                                return {
                                    name: null,
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-tag', null, {reload: 'crm-tag'});
                    }, function () {
                        $state.go('crm-tag');
                    });
                }
            }]
        })
        .state('crm-tag.edit', {
            parent: 'crm-tag',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access' ,function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-tag/crm-tag-dialog.html',
                        controller: 'CrmTagDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CrmTag', function (CrmTag) {
                                return CrmTag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-tag', null, {reload: 'crm-tag'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('crm-tag.delete', {
            parent: 'crm-tag',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_TAG, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-tag/crm-tag-delete-dialog.html',
                        controller: 'CrmTagDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CrmTag', function (CrmTag) {
                                return CrmTag.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-tag', null, {reload: 'crm-tag'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmTag', CrmTag);

    CrmTag.$inject = ['$resource'];

    function CrmTag ($resource) {
        var resourceUrl =  'api/crm-tags/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCrmOpportunity': {url: 'api/crm-tags/by-crm-opportunity/:id', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmTagSearch', CrmTagSearch);

    CrmTagSearch.$inject = ['$resource'];

    function CrmTagSearch($resource) {
        var resourceUrl =  'api/_search/crm-tags/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmTagController', CrmTagController);

    CrmTagController.$inject = ['$scope', '$state', '$q', '$filter', 'CrmTag', 'CrmTagSearch', 'CoreService', 'DTColumnBuilder',
        'DTOptionsBuilder', '$compile'];

    function CrmTagController($scope, $state, $q, $filter, CrmTag, CrmTagSearch, CoreService, DTColumnBuilder,
                              DTOptionsBuilder, $compile) {
        var vm = this;

        vm.crmTags = [];
        vm.dtInstance = {};

        vm.title = 'Crm Tags';
        vm.entityClassHumanized = 'Crm Tags';
        vm.entityStateName = 'crm-tag';

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery === '') {
                CrmTagSearch.query(CoreService.getFilterByCurrentCorporation(), function (result, headers) {
                    vm.crmTags = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.crmTags, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [0, 'asc'])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceTypeDialogController', CrmReferralSourceTypeDialogController);

    CrmReferralSourceTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmReferralSourceType', 'Corporation'];

    function CrmReferralSourceTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmReferralSourceType, Corporation) {
        var vm = this;

        vm.crmReferralSourceType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmReferralSourceType.id !== null) {
                CrmReferralSourceType.update(vm.crmReferralSourceType, onSaveSuccess, onSaveError);
            } else {
                CrmReferralSourceType.save(vm.crmReferralSourceType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmReferralSourceTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceTypeDeleteController',CrmReferralSourceTypeDeleteController);

    CrmReferralSourceTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmReferralSourceType'];

    function CrmReferralSourceTypeDeleteController($uibModalInstance, entity, CrmReferralSourceType) {
        var vm = this;

        vm.crmReferralSourceType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmReferralSourceType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('crm-referral-source-type', {
            parent: 'entity',
            url: '/crm-referral-source-type',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CrmReferralSourceTypes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/crm-referral-source-type/crm-referral-source-types.html',
                    controller: 'CrmReferralSourceTypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('crm-referral-source-type.new', {
            parent: 'crm-referral-source-type',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/crm-referral-source-type/crm-referral-source-type-dialog.html',
                    controller: 'CrmReferralSourceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: [ 'CoreService', function (CoreService) {
                            return {
                                name: null,
                                id: null,
                                corporation: CoreService.getCorporation()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('crm-referral-source-type', null, { reload: 'crm-referral-source-type' });
                }, function() {
                    $state.go('crm-referral-source-type');
                });
            }]
        })
        .state('crm-referral-source-type.edit', {
            parent: 'crm-referral-source-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/crm-referral-source-type/crm-referral-source-type-dialog.html',
                    controller: 'CrmReferralSourceTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CrmReferralSourceType', function(CrmReferralSourceType) {
                            return CrmReferralSourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('crm-referral-source-type', null, { reload: 'crm-referral-source-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('crm-referral-source-type.delete', {
            parent: 'crm-referral-source-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/crm-referral-source-type/crm-referral-source-type-delete-dialog.html',
                    controller: 'CrmReferralSourceTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CrmReferralSourceType', function(CrmReferralSourceType) {
                            return CrmReferralSourceType.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('crm-referral-source-type', null, { reload: 'crm-referral-source-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmReferralSourceType', CrmReferralSourceType);

    CrmReferralSourceType.$inject = ['$resource'];

    function CrmReferralSourceType ($resource) {
        var resourceUrl =  'api/crm-referral-source-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmReferralSourceTypeSearch', CrmReferralSourceTypeSearch);

    CrmReferralSourceTypeSearch.$inject = ['$resource'];

    function CrmReferralSourceTypeSearch($resource) {
        var resourceUrl =  'api/_search/crm-referral-source-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceTypeController', CrmReferralSourceTypeController);

    CrmReferralSourceTypeController.$inject = ['$scope', '$state', 'CrmReferralSourceType', 'CrmReferralSourceTypeSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$compile', '$filter', 'CoreService'];

    function CrmReferralSourceTypeController ($scope, $state, CrmReferralSourceType, CrmReferralSourceTypeSearch, $q, DTColumnBuilder,
                                              DTOptionsBuilder, $compile, $filter, CoreService) {
        var vm = this;

        vm.crmReferralSourceTypes = [];
        vm.dtInstance = {};

        vm.title = 'Crm Referral Source Types';
        vm.entityClassHumanized = 'Crm Referral Source Types';
        vm.entityStateName = 'crm-referral-source-type';

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery === '') {
                CrmReferralSourceTypeSearch.query(CoreService.getFilterByCurrentCorporation(), function (result, headers) {
                    vm.crmReferralSourceTypes = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.crmReferralSourceTypes, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [[1, 'asc'], [0, 'asc']])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceDialogController', CrmReferralSourceDialogController);

    CrmReferralSourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'CrmReferralSource', 'CountryState', 'Employee', 'CrmReferralSourceType', 'Corporation',
        'CrmReferralSourceTypeSearch', 'CoreService', 'TypeLevelCare'];

    function CrmReferralSourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmReferralSource,
                                                CountryState, Employee, CrmReferralSourceType, Corporation,
                                                CrmReferralSourceTypeSearch, CoreService, TypeLevelCare) {
        var vm = this;

        vm.crmReferralSource = entity;
        vm.facility = CoreService.getCurrentFacility();
        vm.countrystates = CountryState.query();
        vm.crmreferralsourcetypes = CrmReferralSourceTypeSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.typelevelcares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmReferralSource.id !== null) {
                CrmReferralSource.update(vm.crmReferralSource, onSaveSuccess, onSaveError);
            } else {
                CrmReferralSource.save(vm.crmReferralSource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmReferralSourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.corporation.id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceDetailController', CrmReferralSourceDetailController);

    CrmReferralSourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CrmReferralSource', 'CountryState', 'Employee', 'CrmReferralSourceType', 'Corporation', 'TypeLevelCare'];

    function CrmReferralSourceDetailController($scope, $rootScope, $stateParams, previousState, entity, CrmReferralSource, CountryState, Employee, CrmReferralSourceType, Corporation, TypeLevelCare) {
        var vm = this;

        vm.crmReferralSource = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:crmReferralSourceUpdate', function(event, result) {
            vm.crmReferralSource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceDeleteController',CrmReferralSourceDeleteController);

    CrmReferralSourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmReferralSource'];

    function CrmReferralSourceDeleteController($uibModalInstance, entity, CrmReferralSource) {
        var vm = this;

        vm.crmReferralSource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmReferralSource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-referral-source', {
                parent: 'entity',
                url: '/crm-referral-source',
                data: {
                    authorities: [],
                    pageTitle: 'CrmReferralSources'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-referral-source/crm-referral-sources.html',
                        controller: 'CrmReferralSourceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access);
                }]

            })
            .state('crm-referral-source-detail.edit', {
                parent: 'crm-referral-source-detail',
                url: '/detail/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-dialog.html',
                            controller: 'CrmReferralSourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralSource', function (CrmReferralSource) {
                                    return CrmReferralSource.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('^', {}, {reload: false});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-referral-source.new', {
                parent: 'crm-referral-source',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-dialog.html',
                            controller: 'CrmReferralSourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        description: null,
                                        website: null,
                                        preferred: null,
                                        inNetwork: null,
                                        address1: null,
                                        address2: null,
                                        zipCode: null,
                                        primaryContact: null,
                                        phone: null,
                                        status: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-source', null, {reload: 'crm-referral-source'});
                        }, function () {
                            $state.go('crm-referral-source');
                        });
                    }
                }]
            })
            .state('crm-referral-source.edit', {
                parent: 'crm-referral-source',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-dialog.html',
                            controller: 'CrmReferralSourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralSource', function (CrmReferralSource) {
                                    return CrmReferralSource.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-source', null, {reload: 'crm-referral-source'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-referral-source.delete', {
                parent: 'crm-referral-source',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-source/crm-referral-source-delete-dialog.html',
                            controller: 'CrmReferralSourceDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralSource', function (CrmReferralSource) {
                                    return CrmReferralSource.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-source', null, {reload: 'crm-referral-source'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmReferralSource', CrmReferralSource);

    CrmReferralSource.$inject = ['$resource'];

    function CrmReferralSource ($resource) {
        var resourceUrl =  'api/crm-referral-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmReferralSourceSearch', CrmReferralSourceSearch);

    CrmReferralSourceSearch.$inject = ['$resource'];

    function CrmReferralSourceSearch($resource) {
        var resourceUrl =  'api/_search/crm-referral-sources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralSourceController', CrmReferralSourceController);

    CrmReferralSourceController.$inject = ['$scope', '$state', 'CrmReferralSource', 'CrmReferralSourceSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$compile', '$filter', 'CoreService'];

    function CrmReferralSourceController ($scope, $state, CrmReferralSource, CrmReferralSourceSearch,  $q, DTColumnBuilder,
                                          DTOptionsBuilder, $compile, $filter, CoreService) {
        var vm = this;

        vm.crmReferralSources = [];
        vm.dtInstance = {};

        vm.title = 'Crm Referral Source';
        vm.entityClassHumanized = 'Crm Referral Source';
        vm.entityStateName = 'crm-referral-source';

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery === '') {
                CrmReferralSourceSearch.query(CoreService.getFilterByCurrentCorporation(), function (result, headers) {
                    vm.crmReferralSources = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.crmReferralSources, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [[1, 'asc'], [0, 'asc']])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('website').withTitle('Website'),
            DTColumnBuilder.newColumn('phone').withTitle('Phone'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralContactDialogController', CrmReferralContactDialogController);

    CrmReferralContactDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'CrmReferralContact', 'Corporation', 'CrmReferralSourceSearch', 'CoreService'];

    function CrmReferralContactDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmReferralContact,
                                                 Corporation, CrmReferralSourceSearch, CoreService) {
        var vm = this;

        vm.crmReferralContact = entity;
        vm.crmreferralsources = CrmReferralSourceSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmReferralContact.id !== null) {
                CrmReferralContact.update(vm.crmReferralContact, onSaveSuccess, onSaveError);
            } else {
                CrmReferralContact.save(vm.crmReferralContact, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmReferralContactUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralContactDeleteController',CrmReferralContactDeleteController);

    CrmReferralContactDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmReferralContact'];

    function CrmReferralContactDeleteController($uibModalInstance, entity, CrmReferralContact) {
        var vm = this;

        vm.crmReferralContact = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmReferralContact.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-referral-contact', {
                parent: 'entity',
                url: '/crm-referral-contact',
                data: {
                    authorities: [],
                    pageTitle: 'CrmReferralContact'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-referral-contact/crm-referral-contact.html',
                        controller: 'CrmReferralContactController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT, access);
                }]
            })
            .state('crm-referral-contact.new', {
                parent: 'crm-referral-contact',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-contact/crm-referral-contact-dialog.html',
                            controller: 'CrmReferralContactDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        firstName: null,
                                        lastName: null,
                                        dob: null,
                                        department: null,
                                        phone: null,
                                        mobile: null,
                                        fax: null,
                                        email: null,
                                        note: null,
                                        status: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-contact', null, {reload: 'crm-referral-contact'});
                        }, function () {
                            $state.go('crm-referral-contact');
                        });
                    }
                }]
            })
            .state('crm-referral-contact.edit', {
                parent: 'crm-referral-contact',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-contact/crm-referral-contact-dialog.html',
                            controller: 'CrmReferralContactDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralContact', function (CrmReferralContact) {
                                    return CrmReferralContact.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-contact', null, {reload: 'crm-referral-contact'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-referral-contact.delete', {
                parent: 'crm-referral-contact',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-referral-contact/crm-referral-contact-delete-dialog.html',
                            controller: 'CrmReferralContactDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmReferralContact', function (CrmReferralContact) {
                                    return CrmReferralContact.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-referral-contact', null, {reload: 'crm-referral-contact'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmReferralContact', CrmReferralContact);

    CrmReferralContact.$inject = ['$resource', 'DateUtils'];

    function CrmReferralContact ($resource, DateUtils) {
        var resourceUrl =  'api/crm-referral-contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob= DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }

            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-referral-contacts/filter', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmReferralContactSearch', CrmReferralContactSearch);

    CrmReferralContactSearch.$inject = ['$resource'];

    function CrmReferralContactSearch($resource) {
        var resourceUrl =  'api/_search/crm-referral-contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmReferralContactController', CrmReferralContactController);

    CrmReferralContactController.$inject = ['$scope', '$state', 'CrmReferralContact', 'CrmReferralContactSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', '$compile', '$filter', 'CoreService'];

    function CrmReferralContactController ($scope, $state, CrmReferralContact, CrmReferralContactSearch,  $q, DTColumnBuilder,
                                          DTOptionsBuilder, $compile, $filter, CoreService) {
        var vm = this;

        vm.crmReferralContacts = [];
        vm.dtInstance = {};

        vm.title = 'Crm Referral Contact';
        vm.entityClassHumanized = 'Crm Referral Contact';
        vm.entityStateName = 'crm-referral-contact';

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery === '') {
                CrmReferralContactSearch.query(CoreService.getFilterByCurrentCorporation(), function (result, headers) {
                    vm.crmReferralContacts = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.crmReferralContacts, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('aaSorting', [[1, 'asc'], [0, 'asc']])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });;

        vm.dtColumns = [
            DTColumnBuilder.newColumn('firstName').withTitle('Name'),
            DTColumnBuilder.newColumn('lastName').withTitle('LastName'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusDialogController', CrmOutboundReferralStatusDialogController);

    CrmOutboundReferralStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmOutboundReferralStatus', 'Corporation'];

    function CrmOutboundReferralStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmOutboundReferralStatus, Corporation) {
        var vm = this;

        vm.crmOutboundReferralStatus = entity;
        vm.clear = clear;
        vm.save = save;
        vm.corporations = Corporation.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmOutboundReferralStatus.id !== null) {
                CrmOutboundReferralStatus.update(vm.crmOutboundReferralStatus, onSaveSuccess, onSaveError);
            } else {
                CrmOutboundReferralStatus.save(vm.crmOutboundReferralStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmOutboundReferralStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusDetailController', CrmOutboundReferralStatusDetailController);

    CrmOutboundReferralStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CrmOutboundReferralStatus', 'Corporation'];

    function CrmOutboundReferralStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, CrmOutboundReferralStatus, Corporation) {
        var vm = this;

        vm.crmOutboundReferralStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:crmOutboundReferralStatusUpdate', function(event, result) {
            vm.crmOutboundReferralStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusDeleteController',CrmOutboundReferralStatusDeleteController);

    CrmOutboundReferralStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmOutboundReferralStatus'];

    function CrmOutboundReferralStatusDeleteController($uibModalInstance, entity, CrmOutboundReferralStatus) {
        var vm = this;

        vm.crmOutboundReferralStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmOutboundReferralStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-outbound-referral-status', {
                parent: 'entity',
                url: '/crm-outbound-referral-status',
                data: {
                    authorities: [],
                    pageTitle: 'CrmOutboundReferralStatuses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-statuses.html',
                        controller: 'CrmOutboundReferralStatusController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access);
                }]

            })
            .state('crm-outbound-referral-status.new', {
                parent: 'crm-outbound-referral-status',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-status-dialog.html',
                            controller: 'CrmOutboundReferralStatusDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral-status', null, {reload: 'crm-outbound-referral-status'});
                        }, function () {
                            $state.go('crm-outbound-referral-status');
                        });
                    }
                }]
            })
            .state('crm-outbound-referral-status.edit', {
                parent: 'crm-outbound-referral-status',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-status-dialog.html',
                            controller: 'CrmOutboundReferralStatusDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOutboundReferralStatus', function (CrmOutboundReferralStatus) {
                                    return CrmOutboundReferralStatus.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral-status', null, {reload: 'crm-outbound-referral-status'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-outbound-referral-status.delete', {
                parent: 'crm-outbound-referral-status',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral-status/crm-outbound-referral-status-delete-dialog.html',
                            controller: 'CrmOutboundReferralStatusDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOutboundReferralStatus', function (CrmOutboundReferralStatus) {
                                    return CrmOutboundReferralStatus.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral-status', null, {reload: 'crm-outbound-referral-status'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmOutboundReferralStatus', CrmOutboundReferralStatus);

    CrmOutboundReferralStatus.$inject = ['$resource'];

    function CrmOutboundReferralStatus ($resource) {
        var resourceUrl =  'api/crm-outbound-referral-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmOutboundReferralStatusSearch', CrmOutboundReferralStatusSearch);

    CrmOutboundReferralStatusSearch.$inject = ['$resource'];

    function CrmOutboundReferralStatusSearch($resource) {
        var resourceUrl =  'api/_search/crm-outbound-referral-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralStatusController', CrmOutboundReferralStatusController);

    CrmOutboundReferralStatusController.$inject = ['$scope', '$state', 'CrmOutboundReferralStatus',
        'CrmOutboundReferralStatusSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', 'CoreService', '$compile'];

    function CrmOutboundReferralStatusController($scope, $state, CrmOutboundReferralStatus,
                                                 CrmOutboundReferralStatusSearch, $q, DTColumnBuilder,
                                                 DTOptionsBuilder, GUIUtils, $filter, CoreService, $compile) {
        var vm = this;

        vm.crmOutboundReferralStatuses = [];
        vm.dtInstance = {};

        vm.title = 'Crm Outbound Referral Status';
        vm.entityClassHumanized = 'Crm Outbound Referral Status';
        vm.entityStateName = 'crm-outbound-referral-status';

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery === '') {
                CrmOutboundReferralStatusSearch.query(CoreService.getFilterByCurrentCorporation(), function (result, headers) {
                    vm.crmOutboundReferralStatuses = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.crmOutboundReferralStatuses, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {

            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOutboundReferralDialogController', CrmOutboundReferralDialogController);

    CrmOutboundReferralDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'CrmOutboundReferral', 'Employee', 'CrmOutboundReferralStatusSearch',
        'CrmReferralSourceTypeSearch', 'CoreService', 'CrmReferralSourceSearch',
        'CrmReferralContact'];

    function CrmOutboundReferralDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                 CrmOutboundReferral, Employee, CrmOutboundReferralStatusSearch,
                                                 CrmReferralSourceTypeSearch, CoreService, CrmReferralSourceSearch,
                                                 CrmReferralContact) {
        var vm = this;

        vm.crmOutboundReferral = entity;
        vm.datePickerOpenStatus = {};

        vm.crmreferralsourcetypes = CrmReferralSourceTypeSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.employees = [];
        vm.crmOutboundReferralStatuses = CrmOutboundReferralStatusSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.crmReferralSources = CrmReferralSourceSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.corporation = CoreService.getCorporation();
        vm.referralsTo = null;

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.openCalendar = openCalendar;
        vm.getCrmReferralContacts = getCrmReferralContacts;
        vm.changeCrmReferralSource = changeCrmReferralSource;

        vm.getCrmReferralContacts();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.crmOutboundReferral.id !== null) {
                CrmOutboundReferral.update(vm.crmOutboundReferral, onSaveSuccess, onSaveError);
            } else {
                CrmOutboundReferral.save(vm.crmOutboundReferral, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:crmOutboundReferralUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.doa = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.corporation.id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getCrmReferralContacts(query) {
            if (vm.crmOutboundReferral.crmReferralSource) {
                CrmReferralContact.findAllByFilter({
                    page: 0,
                    size: 25,
                    crmReferralSourceId: vm.crmOutboundReferral.crmReferralSource.id,
                    corporationId: vm.corporation.id,
                    searchQuery: query
                }, function (result) {
                    vm.referralsTo = result;
                });
            }
        }

        function changeCrmReferralSource() {
            vm.referralsTo = [];
            vm.crmOutboundReferral.crmReferralContact = null;
            getCrmReferralContacts();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-outbound-referral.new', {
                parent: 'crm-outbound-referral',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral/crm-outbound-referral-dialog.html',
                            controller: 'CrmOutboundReferralDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        doa: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral', null, {reload: 'crm-outbound-referral'});
                        }, function () {
                            $state.go('crm-outbound-referral');
                        });
                    }
                }]
            })
            .state('crm-outbound-referral.edit', {
                parent: 'crm-outbound-referral',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-outbound-referral/crm-outbound-referral-dialog.html',
                            controller: 'CrmOutboundReferralDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOutboundReferral', function (CrmOutboundReferral) {
                                    return CrmOutboundReferral.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-outbound-referral', null, {reload: 'crm-outbound-referral'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmOutboundReferral', CrmOutboundReferral);

    CrmOutboundReferral.$inject = ['$resource', 'DateUtils'];

    function CrmOutboundReferral($resource, DateUtils) {
        var resourceUrl = 'api/crm-outbound-referrals/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.doa = DateUtils.convertDateTimeFromServer(data.doa);
                    }

                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findByOpportunity': {
                url: 'api/crm-outbound-referrals/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.doa = DateUtils.convertDateTimeFromServer(data.doa);
                    }

                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityStatusDialogController', CrmOpportunityStatusDialogController);

    CrmOpportunityStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmOpportunityStatus'];

    function CrmOpportunityStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmOpportunityStatus) {
        var vm = this;

        vm.crmOpportunityStatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmOpportunityStatus.id !== null) {
                CrmOpportunityStatus.update(vm.crmOpportunityStatus, onSaveSuccess, onSaveError);
            } else {
                CrmOpportunityStatus.save(vm.crmOpportunityStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmOpportunityStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityStatusDeleteController',CrmOpportunityStatusDeleteController);

    CrmOpportunityStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmOpportunityStatus'];

    function CrmOpportunityStatusDeleteController($uibModalInstance, entity, CrmOpportunityStatus) {
        var vm = this;

        vm.crmOpportunityStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmOpportunityStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('crm-opportunity-status', {
                parent: 'entity',
                url: '/crm-opportunity-status',
                data: {
                    authorities: [],
                    pageTitle: 'CrmOpportunityStatus'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-opportunity-status/crm-opportunity-status.html',
                        controller: 'CrmOpportunityStatusController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Crm Opportunity Status'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS, access);
                }]
            })
            .state('crm-opportunity-status.new', {
                parent: 'crm-opportunity-status',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-opportunity-status/crm-opportunity-status-dialog.html',
                            controller: 'CrmOpportunityStatusDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        xorder: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-opportunity-status', null, {reload: 'crm-opportunity-status'});
                        }, function () {
                            $state.go('crm-opportunity-status');
                        });
                    }
                }]
            })
            .state('crm-opportunity-status.edit', {
                parent: 'crm-opportunity-status',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-opportunity-status/crm-opportunity-status-dialog.html',
                            controller: 'CrmOpportunityStatusDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOpportunityStatus', function (CrmOpportunityStatus) {
                                    return CrmOpportunityStatus.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-opportunity-status', null, {reload: 'crm-opportunity-status'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('crm-opportunity-status.delete', {
                parent: 'crm-opportunity-status',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/crm-opportunity-status/crm-opportunity-status-delete-dialog.html',
                            controller: 'CrmOpportunityStatusDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CrmOpportunityStatus', function (CrmOpportunityStatus) {
                                    return CrmOpportunityStatus.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('crm-opportunity-status', null, {reload: 'crm-opportunity-status'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmOpportunityStatus', CrmOpportunityStatus);

    CrmOpportunityStatus.$inject = ['$resource'];

    function CrmOpportunityStatus ($resource) {
        var resourceUrl =  'api/crm-opportunity-status/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmOpportunityStatusSearch', CrmOpportunityStatusSearch);

    CrmOpportunityStatusSearch.$inject = ['$resource'];

    function CrmOpportunityStatusSearch($resource) {
        var resourceUrl =  'api/_search/crm-opportunity-status/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityStatusController', CrmOpportunityStatusController);

    CrmOpportunityStatusController.$inject = ['$scope', '$state', 'CrmOpportunityStatusSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', '$compile', '$filter', 'CoreService'];

    function CrmOpportunityStatusController($scope, $state, CrmOpportunityStatusSearch, $q, DTColumnBuilder, DTOptionsBuilder, $compile, $filter, CoreService) {
        var vm = this;

        vm.title = 'Crm Opportunity Status';
        vm.entityClassHumanized = 'Crm Opportunity Status';
        vm.entityStateName = 'crm-opportunity-status';

        vm.crmOpportunityStatus = [];
        vm.search = search;
        vm.dtInstance = {};

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                CrmOpportunityStatusSearch.query(CoreService.getFilterByCurrentCorporation(), function(result) {
                    vm.crmOpportunityStatus = result;
                    defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.crmOpportunityStatus, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });;

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('xorder').withTitle('Order'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityPrivatePayDialogController', CrmOpportunityPrivatePayDialogController);

    CrmOpportunityPrivatePayDialogController.$inject = ['$uibModalInstance'];

    function CrmOpportunityPrivatePayDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function (){
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityOutboundReferralController', CrmOpportunityOutboundReferralController);

    CrmOpportunityOutboundReferralController.$inject = ['$uibModalInstance'];

    function CrmOpportunityOutboundReferralController($uibModalInstance) {
        var vm = this;

        vm.title = 'Outbound Referral';
        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateOfAdmission = false;
        vm.dateOfBirthOptions = {
            maxDate: new Date(),
            minDate: new Date(1900, 1, 1)
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityNewDialogController', CrmOpportunityNewDialogController);

    CrmOpportunityNewDialogController.$inject = ['$uibModalInstance', 'entity', 'CoreService', 'CountryState', 'GUIUtils', 'TypeMaritalStatus', 'TypeRace',
        'TypeEthnicity', 'Employee', 'TypeLevelCare', 'TypePaymentMethods', 'FacilitySearch', 'CrmOpportunityStatusSearch',
        'CrmCampaign', 'CrmOpportunity', '$scope', 'CrmReferralSourceSearch'];

    function CrmOpportunityNewDialogController($uibModalInstance, entity, CoreService, CountryState, GUIUtils, TypeMaritalStatus, TypeRace,
                                               TypeEthnicity, Employee, TypeLevelCare, TypePaymentMethods, FacilitySearch, CrmOpportunityStatusSearch,
                                               CrmCampaign, CrmOpportunity, $scope, CrmReferralSourceSearch) {
        var vm = this;
        vm.opportunity = entity;

        vm.facility = CoreService.getCurrentFacility();
        vm.states = CountryState.query();
        vm.gender = GUIUtils.getGender();
        vm.maritalStatus = TypeMaritalStatus.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.race = TypeRace.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.ethnicity = TypeEthnicity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.marketer = Employee.findAllByFilter({page: 0, size: 20, facilityId: CoreService.getCurrentFacility().id});
        vm.typeLevelCare = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.paymentMethod = TypePaymentMethods.byFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.facilities = Facility.byCorporation({id: CoreService.getFilterByCurrentCorporation().id});
        vm.status = CrmOpportunityStatusSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.referrals = CrmReferralSourceSearch.query(CoreService.getFilterByCurrentCorporation());

        vm.getCrmCampaign = getCrmCampaign;

        getCrmCampaign();

        function getCrmCampaign(searchQuery) {
            CrmCampaign.filter(getCrmCampaignFilter(searchQuery), function (result) {
                vm.crmCampaigns = result;
            });
        }

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;
        vm.datePickerOpenStatus.admissionDate = false;
        vm.datePickerOpenStatus.contactDate = false;
        vm.admissionDate = {};
        vm.contactDate = {};
        vm.bodOptions = {
            maxDate: new Date(),
            minDate: new Date(1900, 1, 1)
        };

        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.clear = clear;
        vm.openCalendar = openCalendar;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel')
        }

        function getEmployees(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.opportunity.corporation.id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getCrmCampaignFilter(searchQuery) {
            var filter = {};
            filter.corporationId = CoreService.getCorporation().id;
            filter.searchQuery = searchQuery;
            filter.size = 25;
            filter.page = 0;

            return filter
        }

        function save() {
            vm.isSaving = true;
            if (vm.opportunity.id !== null) {
                CrmOpportunity.update(vm.opportunity, onSaveSuccess, onSaveError);
            } else {
                CrmOpportunity.save(vm.opportunity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:crmOpportunityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityDetailController', CrmOpportunityDetailController);

    CrmOpportunityDetailController.$inject = ['$uibModal', 'entity', '$state', 'CrmOutboundReferral'];

    function CrmOpportunityDetailController($uibModal, entity, $state, CrmOutboundReferral) {
        var vm = this;

        vm.crmOpportunity = entity;
        vm.crmOutboundReferral = {};
        vm.floatingMenuStatus = false;
        vm.toggleFloatingMenu = toggleFloatingMenu;

        init();

        function init() {
            vm.title = 'Opportunity Details';
            vm.confirmDelete = false;

            vm.address = vm.crmOpportunity.address ? vm.crmOpportunity.address : "";
            vm.address += vm.crmOpportunity.address2 ? " " + vm.crmOpportunity.address2 : "";
            vm.address += vm.crmOpportunity.city ? ", " + vm.crmOpportunity.city : "";
            vm.address += vm.crmOpportunity.state ? ", " + vm.crmOpportunity.state.stateCode : "";
            vm.address += vm.crmOpportunity.zipCode ? " " + vm.crmOpportunity.zipCode : "";

            vm.crmOutboundReferral = CrmOutboundReferral.findByOpportunity({id: vm.crmOpportunity.id});
        }

        vm.openModalOutboundReferral = openModalOutboundReferral;
        vm.openModalOpportunityPrivatePay = openModalOpportunityPrivatePay;
        vm.openModalDelete = openModalDelete;
        vm.openModalNewNote = openModalNewNote;
        vm.openModalNewTask = openModalNewTask;
        vm.openModalEmailLog = openModalEmailLog;
        vm.openModalCallLog = openModalCallLog;
        vm.openModalTravel = openModalTravel;
        vm.openModalPaymentPlan = openModalPaymentPlan;
        vm.openModalEditOpportunity = openModalEditOpportunity;

        function openModalOutboundReferral() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-outbound-referral/crm-outbound-referral-dialog.html',
                controller: 'CrmOutboundReferralDialogController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmOutboundReferral', 'CoreService', function (CrmOutboundReferral, CoreService) {
                        return vm.crmOutboundReferral.id ?
                            CrmOutboundReferral.findByOpportunity({id: vm.crmOpportunity.id}) : {
                                name: null,
                                id: null,
                                doa: null,
                                corporation: CoreService.getCorporation(),
                                crmReferralSource: null,
                                crmReferralContact: null,
                                marketer: null,
                                status: null,
                                crmOpportunity: vm.crmOpportunity
                            };
                    }]
                }
            }).result.then(function () {
                vm.crmOutboundReferral = CrmOutboundReferral.findByOpportunity({id: vm.crmOpportunity.id});
            }, function () {
            });
        }

        function toggleFloatingMenu($event) {
            var btn = angular.element($event.currentTarget);

            vm.floatingMenuStatus = !vm.floatingMenuStatus;
            btn.next().slideToggle();
        }

        function openModalOpportunityPrivatePay() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-opportunity/crm-opportunity-private-pay-dialog.html',
                controller: 'CrmOpportunityPrivatePayDialogController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalDelete() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/delete-activity-dialog.html',
                controller: 'ActivitiesDeleteDialogController',
                controllerAs: 'vm',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalNewNote() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/new-note-dialog.html',
                controller: 'ActivitiesNewNoteDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalNewTask() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/new-task-dialog.html',
                controller: 'ActivitiesNewTaskDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalEmailLog() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/log-email-dialog.html',
                controller: 'ActivitiesLogEmailDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalCallLog() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/log-calls-dialog.html',
                controller: 'ActivitiesLogEmailDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalTravel() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/travel-dialog.html',
                controller: 'ActivitiesNewTravelDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalPaymentPlan() {
            $uibModal.open({
                templateUrl: 'app/entities/opportunities/activities/payment-plan-dialog.html',
                controller: 'ActivitiesPaymentPlanDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function openModalEditOpportunity() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-opportunity/crm-opportunity-new-dialog.html',
                controller: 'CrmOpportunityNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmOpportunity', function (CrmOpportunity) {
                        return CrmOpportunity.get({id: vm.crmOpportunity.id}).$promise;
                    }]
                }
            }).result.then(function () {
                $state.reload();
            }, function () {
            });
        }


        /*### - Google Charts Stuff - ###*/

        google.load('visualization', '1', {packages: ['controls', 'corechart']});
        google.setOnLoadCallback(drawChart);

        var dash,chart,data, control;

        vm.rangeStart = new Date('May 1, 2016');
        vm.rangeEnd = new Date('October 1, 2016');

        vm.updateGChart = updateGChart;

        function drawChart() {
            data = new google.visualization.DataTable();


            data.addColumn({type:'date', label:'Date'});
            data.addColumn({type:'timeofday', label:'Info'});
            data.addColumn({type:'string', role:'annotation'});
            data.addColumn({type:'string', role:'annotationText'});
            data.addColumn({type:'timeofday', label:'Document'});
            data.addColumn({type:'string', role:'annotation'});
            data.addColumn({type:'string', role:'annotationText'});
            data.addColumn({type:'timeofday', label:'Task'});
            data.addColumn({type:'string', role:'annotation'});
            data.addColumn({type:'string', role:'annotationText'});

            data.addRow([new Date(2016, 1,23), [10, 30, 0], 'Info','Admission Date Set',[7, 45, 0],'Document','Pre-Admission Docs',[9, 0, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 2,11), null,null,null,null,null,null,[9, 30, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 3,12), [8, 30, 0], 'Info','Admission Date Set',[16, 45, 0],'Document','Pre-Admission Assessment',[9, 0, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 4,2), [10, 0, 0], 'Info','Admission Date Set',[11, 0, 0],'Document','Pre-Admission Docs',[15, 0, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 5,3), [7, 30, 0], 'Info','Admission Date Set',[14, 30, 0],'Document','Pre-Admission Assessment',[17, 30, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 6,4), [11, 50, 0], 'Info','Admission Date Set',[9, 30, 0],'Document','Pre-Admission Docs',[8, 10, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 7,6), [9, 20, 0], 'Info','Admission Date Set',[14, 50, 0],'Document','Pre-Admission Assessment',[16, 30, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 8,9), [13, 0, 0], 'Info','Admission Date Set',[10, 30, 0],'Document','Pre-Admission Docs',[7, 30, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 9,22), [14, 20, 0], 'Info','Admission Date Set',[11, 10, 0],'Document','Pre-Admission Assessment',[14, 30, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 10,21), [9, 0, 0], 'Info','Admission Date Set',[14, 0, 0],'Document','Pre-Admission Docs',[8, 0, 0], 'Task','Task Assigned' ]);
            data.addRow([new Date(2016, 11,30), [10, 20, 0], 'Info','Admission Date Set',[8, 50, 0],'Document','Pre-Admission Assessment',[16, 30, 0], 'Task','Task Assigned' ]);

            dash = new google.visualization.Dashboard(document.getElementById('dashboard'));

            chart = new google.visualization.ChartWrapper({
                chartType: 'ScatterChart',
                containerId: 'chart_div',
                options: {
                    height: 400,
                    legend: {
                        position: 'top',
                        alignment: 'end',
                        textStyle: {
                            fontSize: 10,
                            bold: true
                        }
                    },
                    pointShape: 'square',
                    chartArea: {
                        left: 50,
                        top: 40,
                        width: '90%',
                        height: '85%'
                    },
                    explorer: {
                        actions: ['dragToZoom', 'rightClickToReset'],
                        axis: 'horizontal',
                        keepInBounds: true
                    },
                    pointSize: 15,
                    annotations: {
                        boxStyle: {
                            stroke: '#aaa',
                            strokeWidth: 1,
                            rx: 4,
                            ry: 4
                        },
                        textStyle: {
                            fontSize: 10,
                            bold: true
                        },
                        style: 'point'
                    },
                    tooltip: {
                        trigger: 'selection',
                        isHtml: true
                    },
                    vAxis: {
                        gridlines: {
                            count: 15
                        },
                        textStyle: {
                            fontSize: 10
                        }
                    },
                    hAxis: {
                        textStyle: {
                            fontSize: 10
                        }
                    }
                }
            });

            control = new google.visualization.ControlWrapper({
                controlType: 'ChartRangeFilter',
                containerId: 'control_div',
                options: {
                    filterColumnIndex: 0,
                    ui: {
                        chartType: 'ScatterChart',
                        backgroundColor: '#999',
                        chartOptions: {
                            height:50,
                            annotations: {
                                textStyle: {
                                    fontSize: 9,
                                    opacity: 0
                                }
                            },
                            backgroundColor: '#F3F8FD',
                            chartArea: {
                                width: '90%',
                                backgroundColor: '#ffffff'
                            },
                            pointSize: 5,
                            hAxis: {
                                textStyle: {
                                    fontSize: 10
                                }
                            }
                        },
                        minRangeSize: 6480000000 //milliseconds
                    }
                },
                state: {
                    range: {
                        start: vm.rangeStart,
                        end: vm.rangeEnd
                    }
                }
            });

            // Must wait for the ready event in order to
            // request the chart and subscribe to 'onmouseover'.
            google.visualization.events.addListener(chart, 'ready', onReady);

            dash.bind([control], [chart]);

            dash.draw(data);

            function onReady() {
                google.visualization.events.addListener(chart.getChart(), 'select', usefulHandler);

                chart.getChart().setAction({
                    id: 'tooltipAction1',
                    text: 'See Details 1',
                    action: function() {
                        alert('Tooltip Action 1!');
                    }
                });
                chart.getChart().setAction({
                    id: 'tooltipAction2',
                    text: 'See Details 2',
                    action: function() {
                        alert('Tooltip Action 2!');
                    }
                });
            }

            // Select Event Handler
            function usefulHandler() {

            }
        }

        function updateGChart() {
            control.setState({range:{start: vm.rangeStart, end: vm.rangeEnd}});
            control.draw()
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('crm-opportunity', {
                parent: 'entity',
                url: '/crm-opportunity',
                data: {
                    authorities: [],
                    pageTitle: 'Opportunities'
                },
                ncyBreadcrumb: {
                    label: 'Opportunities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-opportunity/crm-opportunity.html',
                        controller: 'CrmOpportunityController',
                        controllerAs: 'vm'
                    },
                    'opportunity@crm-opportunity': {
                        templateUrl: 'app/entities/crm-opportunity/crm-opportunities.html',
                        controller: 'CrmOpportunitiesController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return {
                            searchQuery: null,
                            corporationId: CoreService.getCorporation().id
                        };
                    }]
                }
            })
            .state('crm-opportunity-detail', {
                parent: 'crm-opportunity',
                url: '/{id}/detail',
                data: {
                    authorities: [],
                    pageTitle: 'Crm Opportunity Detail'
                },
                ncyBreadcrumb: {
                    label: 'Opportunities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/crm-opportunity/crm-opportunity-detail.html',
                        controller: 'CrmOpportunityDetailController',
                        controllerAs: 'vm'
                    },
                    'notes@crm-opportunity-detail': {
                        templateUrl: 'app/entities/crm-note/crm-notes.html',
                        controller: 'CrmNoteController',
                        controllerAs: 'vm'
                    },
                    'calls@crm-opportunity-detail': {
                        templateUrl: 'app/entities/crm-call/crm-calls.html',
                        controller: 'CrmCallController',
                        controllerAs: 'vm'
                    },
                    'tasks@crm-opportunity-detail': {
                        templateUrl: 'app/entities/crm-task/crm-tasks.html',
                        controller: 'CrmTaskController',
                        controllerAs: 'vm'
                    },
                    'emails@crm-opportunity-detail': {
                        templateUrl: 'app/entities/crm-email/crm-emails.html',
                        controller: 'CrmEmailController',
                        controllerAs: 'vm'
                    },
                    'insurance@crm-opportunity-detail': {
                        templateUrl: 'app/entities/crm-insurance/crm-insurances.html',
                        controller: 'CrmInsuranceController',
                        controllerAs: 'vm'
                    },
                    'crm-activity@crm-opportunity-detail': {
                        templateUrl: 'app/entities/crm-activity/crm-activities.html',
                        controller: 'CrmActivityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['CrmOpportunity', '$stateParams', function(CrmOpportunity, $stateParams) {
                        return CrmOpportunity.get({id : $stateParams.id}).$promise;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmOpportunity', CrmOpportunity);

    CrmOpportunity.$inject = ['$resource', 'DateUtils'];

    function CrmOpportunity($resource, DateUtils) {
        var resourceUrl = 'api/crm-opportunities/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        data.dob = DateUtils.convertDateTimeFromServer(data.dob);
                        data.contactDate = DateUtils.convertDateTimeFromServer(data.contactDate);
                        data.admissionDate = DateUtils.convertDateTimeFromServer(data.admissionDate);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByFilter': {
                url: 'api/crm-opportunities/filter',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        _.forEach(data, function (item) {
                            item.name = renderName(item.firstName, item.lastName);
                            item.marketerName = renderName(item.marketerFirstName, item.marketerLastName);
                        })
                    }

                    function renderName(firstName, lastName) {
                        return (firstName ? firstName : '') + ' ' + (lastName ? lastName : '');
                    }

                    return data;
                }
            },
            'crmOpportunityMarketers': {
                url: 'api/crm-opportunities/marketers/corporation/:id',
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        _.forEach(data, function (item) {
                            item.fullName = item.firstName + ' ' + item.lastName;
                        })
                    }
                    return data;
                }
            },
            'getAllOpportunities': {
                url: 'api/crm-opportunities/by-account/:id',
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        _.forEach(data, function (item) {
                            item.fullName = item.firstName + ' ' + item.lastName;
                        })
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunityController', CrmOpportunityController);

    CrmOpportunityController.$inject = ['$uibModal', '$state', 'filter', 'CrmOpportunity', 'CoreService', '$rootScope',
        'CrmNote', 'AlertService', '$sce', 'CrmTask', 'CrmEmail', 'CrmCall', '$scope', '$timeout',
        'CrmActivity', 'CrmAccount', 'GUIUtils', 'CrmOpportunityStatusSearch', 'CrmTagSearch',
        'CrmTag'];

    function CrmOpportunityController($uibModal, $state, filter, CrmOpportunity, CoreService, $rootScope,
                                      CrmNote, AlertService, $sce, CrmTask, CrmEmail, CrmCall, $scope, $timeout,
                                      CrmActivity, CrmAccount, GUIUtils, CrmOpportunityStatusSearch, CrmTagSearch,
                                      CrmTag) {
        var vm = this;

        vm.title = 'Opportunities';
        vm.layoutToggle = 'LIST';

        vm.marketers = [];
        vm.crmOpportunities = [];
        vm.openCrmOpportunities = [];
        vm.crmOpportunitiesProjs = [];
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.filter = filter;
        vm.filterTpl = angular.copy(filter);
        vm.quantity = 5;
        vm.activeTab = 0;
        vm.floatingMenuStatus = false;
        vm.employee = CoreService.getCurrentEmployee();
        vm.openPopover = 0;
        vm.corporation = CoreService.getCorporation();
        vm.pictureDefault = CoreService.patientPictureDefault();

        vm.accounts = [];

        vm.gender = GUIUtils.getGender();
        vm.status = CrmOpportunityStatusSearch.query(CoreService.getFilterByCurrentCorporation());
        vm.crmTags = [];

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;
        vm.bodOptions = {
            maxDate: new Date(),
            minDate: new Date(1900, 1, 1)
        };

        CrmTagSearch.query(CoreService.getFilterByCurrentCorporation(), function (result) {
            vm.crmTags = result;
        });

        vm.toggleFloatingMenu = toggleFloatingMenu;
        vm.toggleActive = toggleActive;
        vm.goToDetails = goToDetails;
        vm.search = search;
        vm.clear = clear;
        vm.findAllByFilter = findAllByFilter;
        vm.transition = transition;
        vm.trustAsHtml = trustAsHtml;
        vm.isOwner = isOwner;
        vm.pinCrmNote = pinCrmNote;
        vm.addCrmNote = addCrmNote;
        vm.addCrmTask = addCrmTask;
        vm.addCrmCall = addCrmCall;
        vm.addCrmEmail = addCrmEmail;
        vm.pinCrmTask = pinCrmTask;
        vm.pinCrmCall = pinCrmCall;
        vm.pinCrmEmail = pinCrmEmail;
        vm.completedCrmTask = completedCrmTask;
        vm.replace = replace;
        vm.removeTab = removeTab;
        // vm.saveNewCrmOpportunity = saveNewCrmOpportunity;
        vm.openModalPaymentPlan = openModalPaymentPlan;
        vm.findAllByCrmAccountId = findAllByCrmAccountId;
        vm.updateGChart = updateGChart;
        vm.filterCrmAccounts = filterCrmAccounts;
        vm.selectAccount = selectAccount;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.getTabName = getTabName;
        vm.format = format;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        init();

        function init() {
            google.load('visualization', '1', {packages: ['controls', 'corechart']});

            CrmOpportunity.crmOpportunityMarketers({
                id: CoreService.getCorporation().id
            }, function (result) {
                vm.marketers = result;
                _.forEach(vm.marketers, function (item) {
                    item.avatar = CoreService.getAvatar(item.gender);
                    item.selected = false;
                });
            });

            findAllByFilter();
        }

        function findAllByFilter() {
            CrmOpportunity.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.crmOpportunities = result;
            });
        }

        function findAllByCrmAccountId(crmAccountId, index) {
            CrmOpportunity.getAllOpportunities({id: crmAccountId}, function (result) {
                vm.crmOpportunitiesProjs[index] = result;
            });
        }

        function search() {
            vm.page = 1;
            vm.findAllByFilter();
        }

        function clear() {
            vm.filter = angular.copy(vm.filterTpl);
            vm.searchQuery = null;
            vm.page = 1;

            vm.findAllByFilter();
        }

        function getFilter() {
            vm.marketersSelected = _.filter(vm.marketers, function (section) {
                return section.selected === true;
            });

            var filter = angular.copy(vm.filter);

            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;
            if (vm.marketersSelected.length > 0) {
                filter.employeesIds = _.map(vm.marketersSelected, function (marketerSelected) {

                    return marketerSelected.id;
                });
            }

            return filter
        }

        // for drag and drop layout
        vm.draglists = {"A": [], "B": [], "C": [], "D": [], "E": [], "F": [], "G": []};
        vm.selected = null;

        // Generate initial model
        for (var i = 1; i <= 3; ++i) {
            vm.draglists.A.push({label: "Item A" + i});
            vm.draglists.B.push({label: "Item B" + i});
            vm.draglists.C.push({label: "Item C" + i});
            vm.draglists.D.push({label: "Item D" + i});
            vm.draglists.E.push({label: "Item E" + i});
            vm.draglists.F.push({label: "Item F" + i});
            vm.draglists.G.push({label: "Item G" + i});
        }

        function transition() {
            vm.findAllByFilter();
        }

        function goToDetails(id) {
            $state.go('crm-opportunity-detail', {id: id});
        }

        function toggleActive($event, item) {
            var elem = angular.element($event.currentTarget);
            elem.toggleClass('active');
            item.selected = !item.selected;
            transition();
        }

        function toggleFloatingMenu($event) {
            var btn = angular.element($event.currentTarget);

            vm.floatingMenuStatus = !vm.floatingMenuStatus;

            btn.next().slideToggle();
        }

        function save(data) {
            CrmOpportunity.save(data.crmOpportunity, function (result) {
                vm.openCrmOpportunities.splice(vm.activeTab - 1, 1);
                vm.openCrmOpportunities = angular.copy(vm.openCrmOpportunities);

                findAllByFilter();
                $scope.$emit('bluebookApp:displayCrmOpportunity', result.id);
            });
        }

        $rootScope.$on('bluebookApp:createCrmOpportunity', function (event) {
            var data = {
                pictureRef: CoreService.patientPictureDefault(),
                pictureRefOriginal: CoreService.patientPictureDefault(),
                crmOpportunity: {
                    id: null,
                    crmAccount: {
                        id: null,
                        lastName: null,
                        firstName: null,
                        corporation: CoreService.getCorporation()
                    },
                    corporation: CoreService.getCorporation(),
                    status: null
                },
                notes: {
                    crmNotes: [],
                    page: 1,
                    size: 10,
                    totalItems: 0
                },
                tasks: {
                    crmTasks: [],
                    page: 1,
                    size: 10,
                    totalItems: 0
                },
                calls: {
                    crmCalls: [],
                    page: 1,
                    size: 10,
                    totalItems: 0
                },
                emails: {
                    crmEmails: [],
                    page: 1,
                    size: 10,
                    totalItems: 0
                },
                activities: {
                    startDate: moment(new Date).subtract(1, 'month').toDate(),
                    endDate: new Date(),
                    crmActivities: []
                },
                crmAccount: null
            };

            vm.openCrmOpportunities.push(data);
            activeLastTab();
        });

        $rootScope.$on('bluebookApp:displayCrmOpportunity', function (event, id) {
            var index = _.findIndex(vm.openCrmOpportunities, function (data) {
                return data.crmOpportunity.id == id;
            });
            if (index == -1) {
                CrmOpportunity.get({id: id}, function (crmOpportunity) {
                    var data = {
                        //pictureRef: crmOpportunity.pictureRefId ? Picture.get({id: crmOpportunity.pictureRefId}) : CoreService.patientPictureDefault(),
                        //pictureRefOriginal: crmOpportunity.pictureRefOriginalId ? Picture.get({id: crmOpportunity.pictureRefOriginalId}) : CoreService.patientPictureDefault(),
                        pictureRef: CoreService.patientPictureDefault(),
                        pictureRefOriginal: CoreService.patientPictureDefault(),
                        crmOpportunity: crmOpportunity,
                        notes: {
                            crmNotes: [],
                            page: 1,
                            size: 10,
                            totalItems: 0
                        },
                        tasks: {
                            crmTasks: [],
                            page: 1,
                            size: 10,
                            totalItems: 0
                        },
                        calls: {
                            crmCalls: [],
                            page: 1,
                            size: 10,
                            totalItems: 0
                        },
                        emails: {
                            crmEmails: [],
                            page: 1,
                            size: 10,
                            totalItems: 0
                        },
                        activities: {
                            startDate: moment(new Date).subtract(1, 'month').toDate(),
                            endDate: new Date(),
                            crmActivities: []
                        },
                        tags: CrmTag.findAllByCrmOpportunity({id: id})
                    };

                    vm.openCrmOpportunities.push(data);
                    activeLastTab();

                    getNotes(data);
                    getTasks(data);
                    getEmails(data);
                    getCalls(data);
                    getActivities(data);

                    CrmOpportunity.getAllOpportunities({id: crmOpportunity.crmAccount.id}, function (result) {
                        data.crmOpportunities = result;
                    });
                })
            } else {
                vm.activeTab = index + 1;
            }
        });

        function isOwner(data) {
            return vm.employee.id == data.employee.id;
        }

        function getNotes(data) {
            if (data == null) {
                data = vm.openCrmOpportunities[vm.activeTab - 1];
            }

            CrmNote.findAllByFilter({
                crmOpportunityId: data.crmOpportunity.id,
                corporationId: data.crmOpportunity.corporation.id,
                page: data.notes.page - 1,
                size: data.notes.size
            }, function (result, headers) {
                data.notes.totalItems = headers('X-Total-Count');
                data.notes.crmNotes = result;
            }, onError);
        }

        function getTasks(data) {
            if (data == null) {
                data = vm.openCrmOpportunities[vm.activeTab - 1];
            }

            CrmTask.findAllByFilter({
                crmOpportunityId: data.crmOpportunity.id,
                corporationId: data.crmOpportunity.corporation.id,
                page: data.tasks.page - 1,
                size: data.tasks.size
            }, function (result, headers) {
                data.tasks.totalItems = headers('X-Total-Count');
                data.tasks.crmTasks = result;
            }, onError);
        }

        function getEmails(data) {
            if (data == null) {
                data = vm.openCrmOpportunities[vm.activeTab - 1];
            }

            CrmEmail.findAllByFilter({
                crmOpportunityId: data.crmOpportunity.id,
                corporationId: data.crmOpportunity.corporation.id,
                page: data.emails.page - 1,
                size: data.tasks.size
            }, function (result, headers) {
                data.emails.totalItems = headers('X-Total-Count');
                data.emails.crmEmails = result;
            }, onError);
        }

        function getCalls(data) {
            if (data == null) {
                data = vm.openCrmOpportunities[vm.activeTab - 1];
            }

            CrmCall.findAllByFilter({
                crmOpportunityId: data.crmOpportunity.id,
                corporationId: data.crmOpportunity.corporation.id,
                page: data.calls.page - 1,
                size: data.calls.size
            }, function (result, headers) {
                data.calls.totalItems = headers('X-Total-Count');
                data.calls.crmCalls = result;
            }, onError);
        }

        function getActivities(data) {
            CrmActivity.findAllByFilter({
                corporationId: data.crmOpportunity.corporationId,
                crmOpportunityId: data.crmOpportunity.id
            }, function (result) {
                data.activities.crmActivities = result;

                $timeout(function () {
                    google.setOnLoadCallback(drawChart(data));
                }, 2000);
            });
        }

        function trustAsHtml(note) {
            return $sce.trustAsHtml(note);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function addCrmNote() {
            var data = vm.openCrmOpportunities[vm.activeTab - 1];

            $uibModal.open({
                templateUrl: 'app/entities/crm-note/crm-note-dialog.html',
                controller: 'CrmNoteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            note: null,
                            pin: false,
                            id: null,
                            crmOpportunity: data.crmOpportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                data.notes.page = 1;
                getNotes(data);
            }, function () {
            });
        }

        function pinCrmNote(note) {
            CrmNote.pin(note, function () {
                getNotes();
            })
        }

        function addCrmTask() {
            var data = vm.openCrmOpportunities[vm.activeTab - 1];

            $uibModal.open({
                templateUrl: 'app/entities/crm-task/crm-task-dialog.html',
                controller: 'CrmTaskDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            completed: false,
                            description: null,
                            dueDate: new Date(),
                            reminder: new Date(),
                            pin: false,
                            id: null,
                            crmOpportunity: data.crmOpportunity,
                            assignedTo: null,
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                data.tasks.page = 1;
                getTasks(data);
            }, function () {
            });
        }

        function pinCrmTask(task) {
            CrmTask.pin(task, function () {
                getTasks();
            })
        }

        function addCrmCall() {
            var data = vm.openCrmOpportunities[vm.activeTab - 1];

            $uibModal.open({
                templateUrl: 'app/entities/crm-call/crm-call-dialog.html',
                controller: 'CrmCallDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            description: null,
                            pin: false,
                            id: null,
                            crmOpportunity: data.crmOpportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                data.calls.page = 1;
                getCalls(data);
            }, function () {
            });
        }

        function pinCrmCall(call) {
            CrmCall.pin(call, function () {
                getCalls();
            })
        }

        function addCrmEmail() {
            var data = vm.openCrmOpportunities[vm.activeTab - 1];

            $uibModal.open({
                templateUrl: 'app/entities/crm-email/crm-email-dialog.html',
                controller: 'CrmEmailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            date: new Date(),
                            description: null,
                            pin: false,
                            id: null,
                            crmOpportunity: data.crmOpportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                data.emails.page = 1;
                getEmails(data);
            }, function () {
            });
        }

        function pinCrmEmail(email) {
            CrmEmail.pin(email, function () {
                getEmails();
            })
        }

        function completedCrmTask(task) {
            CrmTask.completed(task, function () {
                getTasks();
            })
        }

        function replace(str) {

            return str ? str.replace(/_/g, " ") : "";
        }

        function removeTab(index, event) {
            event.preventDefault();
            vm.openCrmOpportunities.splice(index, 1);
            vm.openCrmOpportunities = angular.copy(vm.openCrmOpportunities);

            activeLastTab();
        }

        function openModalPaymentPlan() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-opportunity/activities/payment-plan-dialog.html',
                controller: 'ActivitiesPaymentPlanDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {}
            }).result.then(function () {

            }, function () {
            });
        }

        function drawChart(crmOpportunity) {
            crmOpportunity.data = new google.visualization.DataTable();

            crmOpportunity.data.addColumn({type: 'date', label: 'Date'});
            crmOpportunity.data.addColumn({type: 'timeofday', label: 'Info'});
            crmOpportunity.data.addColumn({type: 'string', role: 'annotation'});
            // crmOpportunity.data.addColumn({type: 'string', role: 'annotationText'});
            // crmOpportunity.data.addColumn({type: 'timeofday', label: 'Document'});
            // crmOpportunity.data.addColumn({type: 'string', role: 'annotation'});
            // crmOpportunity.data.addColumn({type: 'string', role: 'annotationText'});
            // crmOpportunity.data.addColumn({type: 'timeofday', label: 'Task'});
            // crmOpportunity.data.addColumn({type: 'string', role: 'annotation'});
            // crmOpportunity.data.addColumn({type: 'string', role: 'annotationText'});

            _.forEach(getCrmActivityGCData(crmOpportunity), function (row) {
                crmOpportunity.data.addRow(row);
            });

            // crmOpportunity.data.addRow([new Date(2016, 1, 23), [10, 30, 0], 'Info', 'Admission Date Set', [7, 45, 0], 'Document', 'Pre-Admission Docs', [9, 0, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 2, 11), null, null, null, null, null, null, [9, 30, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 3, 12), [8, 30, 0], 'Info', 'Admission Date Set', [16, 45, 0], 'Document', 'Pre-Admission Assessment', [9, 0, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 4, 2), [10, 0, 0], 'Info', 'Admission Date Set', [11, 0, 0], 'Document', 'Pre-Admission Docs', [15, 0, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 5, 3), [7, 30, 0], 'Info', 'Admission Date Set', [14, 30, 0], 'Document', 'Pre-Admission Assessment', [17, 30, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 6, 4), [11, 50, 0], 'Info', 'Admission Date Set', [9, 30, 0], 'Document', 'Pre-Admission Docs', [8, 10, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 7, 6), [9, 20, 0], 'Info', 'Admission Date Set', [14, 50, 0], 'Document', 'Pre-Admission Assessment', [16, 30, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 8, 9), [13, 0, 0], 'Info', 'Admission Date Set', [10, 30, 0], 'Document', 'Pre-Admission Docs', [7, 30, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 9, 22), [14, 20, 0], 'Info', 'Admission Date Set', [11, 10, 0], 'Document', 'Pre-Admission Assessment', [14, 30, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 10, 21), [9, 0, 0], 'Info', 'Admission Date Set', [14, 0, 0], 'Document', 'Pre-Admission Docs', [8, 0, 0], 'Task', 'Task Assigned']);
            // crmOpportunity.data.addRow([new Date(2016, 11, 30), [10, 20, 0], 'Info', 'Admission Date Set', [8, 50, 0], 'Document', 'Pre-Admission Assessment', [16, 30, 0], 'Task', 'Task Assigned']);

            crmOpportunity.dash = new google.visualization.Dashboard(document.getElementById('dashboard_div' + crmOpportunity.crmOpportunity.id));

            crmOpportunity.chart = new google.visualization.ChartWrapper({
                chartType: 'ScatterChart',
                containerId: 'chart_div' + crmOpportunity.crmOpportunity.id,
                options: {
                    height: 400,
                    legend: {
                        position: 'top',
                        alignment: 'end',
                        textStyle: {
                            fontSize: 10,
                            bold: true
                        }
                    },
                    pointShape: 'square',
                    chartArea: {
                        left: 50,
                        top: 40,
                        width: '90%',
                        height: '85%'
                    },
                    explorer: {
                        actions: ['dragToZoom', 'rightClickToReset'],
                        axis: 'horizontal',
                        keepInBounds: true
                    },
                    pointSize: 15,
                    annotations: {
                        boxStyle: {
                            stroke: '#aaa',
                            strokeWidth: 1,
                            rx: 4,
                            ry: 4
                        },
                        textStyle: {
                            fontSize: 10,
                            bold: true
                        },
                        style: 'point'
                    },
                    tooltip: {
                        trigger: 'selection',
                        isHtml: true
                    },
                    vAxis: {
                        gridlines: {
                            count: 15
                        },
                        textStyle: {
                            fontSize: 10
                        }
                    },
                    hAxis: {
                        textStyle: {
                            fontSize: 10
                        }
                    }
                }
            });

            crmOpportunity.control = new google.visualization.ControlWrapper({
                controlType: 'ChartRangeFilter',
                containerId: 'control_div' + crmOpportunity.crmOpportunity.id,
                options: {
                    filterColumnIndex: 0,
                    ui: {
                        chartType: 'ScatterChart',
                        backgroundColor: '#999',
                        chartOptions: {
                            height: 50,
                            annotations: {
                                textStyle: {
                                    fontSize: 9,
                                    opacity: 0
                                }
                            },
                            backgroundColor: '#F3F8FD',
                            chartArea: {
                                width: '90%',
                                backgroundColor: '#ffffff'
                            },
                            pointSize: 5,
                            hAxis: {
                                textStyle: {
                                    fontSize: 10
                                }
                            }
                        },
                        minRangeSize: 6480000000 //milliseconds
                    }
                },
                state: {
                    range: {
                        start: crmOpportunity.activities.startDate,
                        end: crmOpportunity.activities.endDate
                    }
                }
            });

            // Must wait for the ready event in order to
            // request the chart and subscribe to 'onmouseover'.
            google.visualization.events.addListener(crmOpportunity.chart, 'ready', onReady);

            crmOpportunity.dash.bind([crmOpportunity.control], [crmOpportunity.chart]);

            crmOpportunity.dash.draw(crmOpportunity.data);

            function onReady() {
                google.visualization.events.addListener(crmOpportunity.chart.getChart(), 'select', usefulHandler);

                crmOpportunity.chart.getChart().setAction({
                    id: 'tooltipAction1',
                    text: 'See Details 1',
                    action: function () {
                        alert('Tooltip Action 1!');
                    }
                });
                crmOpportunity.chart.getChart().setAction({
                    id: 'tooltipAction2',
                    text: 'See Details 2',
                    action: function () {
                        alert('Tooltip Action 2!');
                    }
                });
            }

            // Select Event Handler
            function usefulHandler() {

            }
        }

        function updateGChart(crmOpportunity) {
            crmOpportunity.control.setState({
                range: {
                    start: crmOpportunity.activities.startDate,
                    end: crmOpportunity.activities.endDate
                }
            });
            crmOpportunity.control.draw();
        }

        function getCrmActivityAnnotation(crmActivity) {
            if (crmActivity.crmNote) {

                return 'Note';
            } else if (crmActivity.crmCall) {

                return 'Call';
            } else if (crmActivity.crmEmail) {

                return 'Email';
            } else if (crmActivity.crmTask) {

                return 'Task';
            }
        }

        function getCrmActivityGCData(crmOpportunity) {

            return _.map(crmOpportunity.activities.crmActivities, function (crmActivity) {

                return [
                    moment(crmActivity.createdDate).toDate(),
                    [
                        parseInt(moment(crmActivity.createdDate).format("HH")),
                        parseInt(moment(crmActivity.createdDate).format("mm")),
                        parseInt(moment(crmActivity.createdDate).format("ss"))
                    ],
                    getCrmActivityAnnotation(crmActivity)
                ];
            })
        }

        function filterCrmAccounts(searchQuery) {
            if (searchQuery) {
                var filter = {
                    searchQuery: searchQuery,
                    page: 0,
                    size: 20,
                    corporationId: vm.corporation.id
                };
                CrmAccount.findAllByFilter(filter, function (result) {
                    vm.accounts = result;
                });
            }
        }

        function selectAccount(data, accountSelected) {
            data.crmOpportunity.crmAccount = accountSelected;
        }

        function getTabName(data) {
            if (data.crmOpportunity.crmAccount && data.crmOpportunity.id) {

                return data.crmOpportunity.crmAccount.lastName + ", " + data.crmOpportunity.crmAccount.firstName +
                    (data.crmOpportunity.crmAccount.middleInitial ? " " + data.crmOpportunity.crmAccount.middleInitial : "");
            } else {

                return "New Opportunity";
            }
        }

        function format(date) {

            return moment(date).format($rootScope.dateFormat)
        }

        function activeLastTab() {
            $timeout(function () {
                vm.activeTab = vm.openCrmOpportunities.length;
            }, 200);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmOpportunitiesController', CrmOpportunitiesController);

    CrmOpportunitiesController.$inject = ['$uibModal', '$state', 'filter', 'CrmOpportunity', 'CoreService', '$scope'];

    function CrmOpportunitiesController($uibModal, $state, filter, CrmOpportunity, CoreService, $scope) {
        var vm = this;

        vm.title = 'Opportunities';
        vm.layoutToggle = 'LIST';

        vm.marketers = [];
        vm.crmOpportunities = [];
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.filter = filter;
        vm.filterTpl = angular.copy(filter);
        vm.quantity = 5;

        vm.toggleFilters = toggleFilters;
        vm.toggleFloatingMenu = toggleFloatingMenu;
        vm.toggleActive = toggleActive;
        vm.openModalNewOpportunity = openModalNewOpportunity;
        vm.goToDetails = goToDetails;
        vm.search = search;
        vm.clear = clear;
        vm.findAllByFilter = findAllByFilter;
        vm.transition = transition;
        vm.displayCrmOpportunity = displayCrmOpportunity;
        vm.createCrmOpportunity = createCrmOpportunity;
        vm.calculateAge = calculateAge;
        vm.getEmployees = getEmployees;

        vm.employeeList = [
            {name: 'Raimel Santos', pic: 'content/images/avatar.png'},
            {name: 'Maykel Wong', pic: 'content/images/avatar.png'},
            {name: 'Jesus Rodriguez', pic: 'content/images/avatar.png'},
            {name: 'Alexander Modesto', pic: 'content/images/avatar.png'}
        ];

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, corporationId: vm.corporation.id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function toggleFilters($event) {
            var toggle =angular.element($event.currentTarget);
            toggle.next().slideToggle();
        }

        init();

        function init() {
            CrmOpportunity.crmOpportunityMarketers({
                id: CoreService.getCorporation().id
            }, function (result) {
                vm.marketers = result;
                _.forEach(vm.marketers, function (item) {
                    item.avatar = CoreService.getAvatar(item.gender);
                    item.selected = false;
                });
            });

            findAllByFilter();
        }

        function findAllByFilter() {
            CrmOpportunity.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.crmOpportunities = result;
            });
        }

        function search() {
            vm.page = 1;
            vm.findAllByFilter();
        }

        function clear() {
            vm.filter = angular.copy(vm.filterTpl);
            vm.searchQuery = null;
            vm.page = 1;

            vm.findAllByFilter();
        }

        function getFilter() {
            vm.marketersSelected = _.filter(vm.marketers, function (section) {
                return section.selected === true;
            });

            var filter = angular.copy(vm.filter);

            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;
            if (vm.marketersSelected.length > 0) {
                filter.employeesIds = _.map(vm.marketersSelected, function (marketerSelected) {

                    return marketerSelected.id;
                });
            }

            return filter
        }

        // for drag and drop layout
        vm.draglists = {"A": [], "B": [], "C": [], "D": [], "E": [], "F": [], "G": []};
        vm.selected = null;

        // Generate initial model
        for (var i = 1; i <= 3; ++i) {
            vm.draglists.A.push({label: "Item A" + i});
            vm.draglists.B.push({label: "Item B" + i});
            vm.draglists.C.push({label: "Item C" + i});
            vm.draglists.D.push({label: "Item D" + i});
            vm.draglists.E.push({label: "Item E" + i});
            vm.draglists.F.push({label: "Item F" + i});
            vm.draglists.G.push({label: "Item G" + i});
        }

        function transition() {
            vm.findAllByFilter();
        }

        function goToDetails(id) {
            $state.go('crm-opportunity-detail', {id: id});
        }

        function openModalNewOpportunity() {
            vm.currentEmployee = CoreService.getCurrentEmployee();
            $uibModal.open({
                templateUrl: 'app/entities/crm-opportunity/crm-opportunity-new-dialog.html',
                controller: 'CrmOpportunityNewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                            firstName: null,
                            middleName: null,
                            lastName: null,
                            preferredName: null,
                            dob: null,
                            ssn: null,
                            sex: null,
                            admissionDate: null,
                            contactName: null,
                            contactRelationship: null,
                            contactDate: null,
                            address: null,
                            address2: null,
                            city: null,
                            zipCode: null,
                            phone: null,
                            altPhone: null,
                            email: null,
                            occupation: null,
                            employer: null,
                            facility: null,
                            levelCare: null,
                            status: null,
                            campaign: null,
                            paymentMethod: null,
                            state: null,
                            maritalStatus: null,
                            race: null,
                            ethnicity: null,
                            referral: null,
                            marketer: null,
                            assignee: null,
                            corporation: vm.currentEmployee.corporation
                        };
                    }
                }
            }).result.then(function () {
                findAllByFilter();
            }, function () {
            });
        }

        function toggleActive($event, item) {
            var elem = angular.element($event.currentTarget);
            elem.toggleClass('active');
            item.selected = !item.selected;
            transition();
        }

        function displayCrmOpportunity(id) {
            $scope.$emit('bluebookApp:displayCrmOpportunity', id);
        }

        function createCrmOpportunity() {
            $scope.$emit('bluebookApp:createCrmOpportunity', null);
        }

        function toggleFloatingMenu($event) {
            var btn = angular.element($event.currentTarget);
            vm.floatingMenuStatus = !vm.floatingMenuStatus;
            btn.next().slideToggle();
        }

        function calculateAge(dob) {

            return moment().diff(dob, 'years');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivitiesNewTravelDialogController', ActivitiesNewTravelDialogController);

    ActivitiesNewTravelDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesNewTravelDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDeparting = false;
        vm.datePickerOpenStatus.dateArriving = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivitiesPaymentPlanDialogController', ActivitiesPaymentPlanDialogController);

    ActivitiesPaymentPlanDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesPaymentPlanDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivitiesNewTaskDialogController', ActivitiesNewTaskDialogController);

    ActivitiesNewTaskDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesNewTaskDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateDueDateTask = false;
        vm.datePickerOpenStatus.dateReminder = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller( 'ActivitiesNewNoteDialogController', ActivitiesNewNoteDialogController);

    ActivitiesNewNoteDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesNewNoteDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivitiesLogEmailDialogController', ActivitiesLogEmailDialogController);

    ActivitiesLogEmailDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesLogEmailDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateLogEmail = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivitiesLogCallsDialogController', ActivitiesLogCallsDialogController);

    ActivitiesLogCallsDialogController.$inject = ['$uibModalInstance'];

    function ActivitiesLogCallsDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;

        vm.openCalendar = openCalendar;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateLogCall = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmNoteDialogController', CrmNoteDialogController);

    CrmNoteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmNote'];

    function CrmNoteDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmNote) {
        var vm = this;

        vm.crmNote = entity;

        vm.clear = clear;
        vm.save = save;
        vm.setValidationClass = setValidationClass;
        vm.editorCreated = editorCreated;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.crmNote.id !== null) {
                CrmNote.update(vm.crmNote, onSaveSuccess, onSaveError);
            } else {
                CrmNote.save(vm.crmNote, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:crmNoteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function editorCreated(editor, htmlText) {
            editor.root.innerHTML = htmlText;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmNoteDeleteController',CrmNoteDeleteController);

    CrmNoteDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmNote'];

    function CrmNoteDeleteController($uibModalInstance, entity, CrmNote) {
        var vm = this;

        vm.crmNote = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmNote.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmNote', CrmNote);

    CrmNote.$inject = ['$resource'];

    function CrmNote ($resource) {
        var resourceUrl =  'api/crm-notes/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-notes/filter', method: 'GET', isArray: true},
            'pin': {url: 'api/crm-notes/pin', method: 'POST'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmNoteController', CrmNoteController);

    CrmNoteController.$inject = ['CrmNote', 'AlertService', 'entity', '$uibModal', 'CoreService', '$sce'];

    function CrmNoteController(CrmNote, AlertService, entity, $uibModal, CoreService, $sce) {
        var vm = this;

        vm.crmOpportunity = entity;
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.crmNotes = [];
        vm.pinCrmNotes = [];
        vm.groupedCrmNotes = [];
        vm.employee = CoreService.getCurrentEmployee();

        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.isOwner = isOwner;
        vm.pin = pin;
        vm.getUnpin = getUnpin;
        vm.trustAsHtml = trustAsHtml;

        loadAll();

        function loadAll() {
            CrmNote.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                pin: true,
                unpaged: true
            }, function (data, headers) {
                vm.pinCrmNotes = data;
            }, onError);

            getUnpin();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-note/crm-note-dialog.html',
                controller: 'CrmNoteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            note: null,
                            pin: false,
                            id: null,
                            crmOpportunity: vm.crmOpportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/crm-note/crm-note-dialog.html',
                controller: 'CrmNoteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmNote', function (CrmNote) {
                        return CrmNote.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function del(id) {
            CrmNote.delete({id: id}, function () {
                loadAll();
            });
        }

        function isOwner(note) {
            return vm.employee.id == note.employee.id;
        }

        function pin(note) {
            CrmNote.pin(note, function () {
                loadAll();
            })
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getUnpin() {
            CrmNote.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                pin: false,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.crmNotes = data;
            }, onError);
        }

        function trustAsHtml(note) {
            return $sce.trustAsHtml(note);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmInsuranceDialogController', CrmInsuranceDialogController);

    CrmInsuranceDialogController.$inject = ['$uibModalInstance', 'InsuranceCarrierSearch', 'InsuranceRelation', 'CountryState',
                                            'CrmInsurance', 'entity', 'CoreService'];

    function CrmInsuranceDialogController($uibModalInstance, InsuranceCarrierSearch, InsuranceRelation, CountryState,
                                          CrmInsurance, entity, CoreService) {
        var vm = this;

        vm.crmInsurance = entity;
        vm.insuranceRelations = InsuranceRelation.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.states = CountryState.query();
        vm.carriers = [];


        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.getInsuranceCarrier = getInsuranceCarrier;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dob = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save() {
            vm.isSaving = true;
            if (vm.crmInsurance.id !== null) {
                CrmInsurance.update(vm.crmInsurance, onSaveSuccess, onSaveError);
            } else {
                CrmInsurance.save(vm.crmInsurance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


        function getInsuranceCarrier(query) {
            if (query){
                vm.carriers = [carrierTagTransform(query)];
                if (query.length > 2) {
                    query = _.lowerCase(query);
                    InsuranceCarrierSearch.query({
                        query: query
                    }, function (result) {
                        vm.carriers = _.concat(vm.carriers, result);
                    });
                }
            }
        }

        function carrierTagTransform(newTag) {
            return {
                id: null,
                acctno: newTag,
                name: newTag
            };
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmInsurance', CrmInsurance);

    CrmInsurance.$inject = ['$resource', 'DateUtils'];

    function CrmInsurance ($resource, DateUtils) {
        var resourceUrl =  'api/crm-insurances/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'findOneByFilter': {url: 'api/crm-insurances/filter', method: 'POST', isArray: false}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmInsuranceController', CrmInsuranceController);

    CrmInsuranceController.$inject = ['$scope', '$state', '$uibModal', 'CrmInsurance', 'entity', 'AlertService'];

    function CrmInsuranceController ($scope, $state, $uibModal, CrmInsurance, entity, AlertService) {
        var vm = this;

        vm.crmOpportunity = entity;
        vm.page = 1;
        vm.itemsPerPage = 6;
        vm.crmPrimaryInsurance = null;
        vm.crmSecondaryInsurance = null;

        vm.add = add;
        vm.edit = edit;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll () {
            CrmInsurance.findOneByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                insuranceOrder: 'PRIMARY'
            }, function (data) {
                vm.crmPrimaryInsurance = data;
            }, onError);

            CrmInsurance.findOneByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                insuranceOrder: 'SECONDARY'
            }, function (data) {
                vm.crmSecondaryInsurance = data;
            }, onError);

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function add(order) {

            $uibModal.open({
                templateUrl: 'app/entities/crm-insurance/crm-insurance-dialog.html',
                controller: 'CrmInsuranceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            policyNumber: null,
                            groupNumber: null,
                            preCertPhone: null,
                            address: null,
                            address2: null,
                            zipCode: null,
                            city: null,
                            name: null,
                            dob: null,
                            phone: null,
                            socialSecurity: null,
                            insuranceOrder: order,
                            countryState: null,
                            id: null,
                            crmOpportunity: vm.crmOpportunity,
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/crm-insurance/crm-insurance-dialog.html',
                controller: 'CrmInsuranceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmInsurance', function (CrmInsurance) {
                        return CrmInsurance.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmEmailDialogController', CrmEmailDialogController);

    CrmEmailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmEmail'];

    function CrmEmailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmEmail) {
        var vm = this;

        vm.crmEmail = entity;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.date = false;

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.editorCreated = editorCreated;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmEmail.id !== null) {
                CrmEmail.update(vm.crmEmail, onSaveSuccess, onSaveError);
            } else {
                CrmEmail.save(vm.crmEmail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmEmailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function editorCreated(editor, htmlText) {
            editor.root.innerHTML = htmlText;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmEmailDeleteController',CrmEmailDeleteController);

    CrmEmailDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmEmail'];

    function CrmEmailDeleteController($uibModalInstance, entity, CrmEmail) {
        var vm = this;

        vm.crmEmail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmEmail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmEmail', CrmEmail);

    CrmEmail.$inject = ['$resource', 'DateUtils'];

    function CrmEmail ($resource, DateUtils) {
        var resourceUrl =  'api/crm-emails/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-emails/filter', method: 'GET', isArray: true},
            'pin': {url: 'api/crm-emails/pin', method: 'POST'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmEmailController', CrmEmailController);

    CrmEmailController.$inject = ['CrmEmail', 'AlertService', 'entity', '$uibModal', 'CoreService', '$sce'];

    function CrmEmailController (CrmEmail, AlertService, entity, $uibModal, CoreService, $sce) {
        var vm = this;

        vm.opportunity = entity;
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.crmEmails = [];
        vm.pinCrmEmails = [];
        vm.groupedCrmEmails = [];
        vm.employee = CoreService.getCurrentEmployee();

        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.isOwner = isOwner;
        vm.pin = pin;
        vm.getUnpin = getUnpin;
        vm.trustAsHtml = trustAsHtml;

        loadAll();

        function loadAll () {
            CrmEmail.findAllByFilter({
                opportunityId: vm.opportunity.id,
                corporationId: vm.opportunity.corporation.id,
                pin: true,
                unpaged: true
            }, function (data, headers) {
                vm.pinCrmEmails = data;
            }, onError);

            getUnpin();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-email/crm-email-dialog.html',
                controller: 'CrmEmailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            date: new Date(),
                            description: null,
                            pin: false,
                            id: null,
                            opportunity: vm.opportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/crm-email/crm-email-dialog.html',
                controller: 'CrmEmailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmEmail', function (CrmEmail) {
                        return CrmEmail.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function del(id) {
            CrmEmail.delete({id: id}, function () {
                loadAll();
            });
        }

        function isOwner(email) {
            return vm.employee.id == email.employee.id;
        }

        function pin(email) {
            CrmEmail.pin(email, function () {
                loadAll();
            })
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getUnpin() {
            CrmEmail.findAllByFilter({
                opportunityId: vm.opportunity.id,
                corporationId: vm.opportunity.corporation.id,
                pin: false,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.crmEmails = data;
            }, onError);
        }

        function trustAsHtml(email) {
            return $sce.trustAsHtml(email);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCampaignDialogController', CrmCampaignDialogController);

    CrmCampaignDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmCampaign'];

    function CrmCampaignDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmCampaign) {
        var vm = this;

        vm.crmCampaign = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmCampaign.id !== null) {
                CrmCampaign.update(vm.crmCampaign, onSaveSuccess, onSaveError);
            } else {
                CrmCampaign.save(vm.crmCampaign, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmCampaignUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCampaignDeleteController',CrmCampaignDeleteController);

    CrmCampaignDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmCampaign'];

    function CrmCampaignDeleteController($uibModalInstance, entity, CrmCampaign) {
        var vm = this;

        vm.crmCampaign = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmCampaign.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('crm-campaign', {
            parent: 'entity',
            url: '/crm-campaign',
            data: {
                authorities: [],
                pageTitle: 'CrmCampaign'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/crm-campaign/crm-campaign.html',
                    controller: 'CrmCampaignController',
                    controllerAs: 'vm'
                }
            },
            ncyBreadcrumb: {
                label: 'Crm Campaign'
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN, access);
            }]
        })
        .state('crm-campaign.new', {
            parent: 'crm-campaign',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-campaign/crm-campaign-dialog.html',
                        controller: 'CrmCampaignDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CoreService', function (CoreService) {
                                return {
                                    name: null,
                                    id: null,
                                    corporation: CoreService.getCorporation()
                                };
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-campaign', null, {reload: 'crm-campaign'});
                    }, function () {
                        $state.go('crm-campaign');
                    });
                }
            }]
        })
        .state('crm-campaign.edit', {
            parent: 'crm-campaign',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-campaign/crm-campaign-dialog.html',
                        controller: 'CrmCampaignDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CrmCampaign', function (CrmCampaign) {
                                return CrmCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-campaign', null, {reload: 'crm-campaign'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('crm-campaign.delete', {
            parent: 'crm-campaign',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/crm-campaign/crm-campaign-delete-dialog.html',
                        controller: 'CrmCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: ['CrmCampaign', function (CrmCampaign) {
                                return CrmCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('crm-campaign', null, {reload: 'crm-campaign'});
                    }, function () {
                        $state.go('^');
                    })
                }
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmCampaign', CrmCampaign);

    CrmCampaign.$inject = ['$resource'];

    function CrmCampaign ($resource) {
        var resourceUrl =  'api/crm-campaigns/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/crm-campaigns/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCampaignController', CrmCampaignController);

    CrmCampaignController.$inject = ['$scope', '$state', 'CrmCampaign', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', 'CoreService', '$compile'];

    function CrmCampaignController($scope, $state, CrmCampaign, $q, DTColumnBuilder,
                                   DTOptionsBuilder, GUIUtils, $filter, CoreService, $compile) {
        var vm = this;

        vm.crmCampaign = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.corporation = CoreService.getCorporation();

        vm.title = 'Crm Campaign';
        vm.entityClassHumanized = 'Crm Campaign';
        vm.entityStateName = 'crm-campaign';

        vm.search = search;
        vm.reload = reload;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            CrmCampaign.filter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.crmCampaign = result;
                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {

            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.page = 1;
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var filter = {};

            filter.corporationId = vm.corporation.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCallDialogController', CrmCallDialogController);

    CrmCallDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CrmCall'];

    function CrmCallDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, CrmCall) {
        var vm = this;

        vm.crmCall = entity;

        vm.clear = clear;
        vm.save = save;
        vm.setValidationClass = setValidationClass;
        vm.openCalendar = openCalendar;
        vm.editorCreated = editorCreated;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateCall = false;
        vm.DateOptions = {};

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.crmCall.id !== null) {
                CrmCall.update(vm.crmCall, onSaveSuccess, onSaveError);
            } else {
                CrmCall.save(vm.crmCall, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:crmCallUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function editorCreated(editor, htmlText) {
            editor.root.innerHTML = htmlText;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCallDeleteController',CrmNoteDeleteController);

    CrmNoteDeleteController.$inject = ['$uibModalInstance', 'entity', 'CrmCall'];

    function CrmNoteDeleteController($uibModalInstance, entity, CrmCall) {
        var vm = this;

        vm.crmCall = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CrmCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmCall', CrmCall);

    CrmCall.$inject = ['$resource','DateUtils'];

    function CrmCall ($resource, DateUtils) {
        var resourceUrl =  'api/crm-calls/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-calls/filter', method: 'GET', isArray: true},
            'pin': {url: 'api/crm-calls/pin', method: 'POST'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmCallController', CrmCallController);

    CrmCallController.$inject = ['CrmCall', 'AlertService', 'entity', '$uibModal', 'CoreService', '$sce'];

    function CrmCallController(CrmCall, AlertService, entity, $uibModal, CoreService, $sce) {
        var vm = this;

        vm.crmOpportunity = entity;
        vm.page = 1;
        vm.itemsPerPage = 5;
        vm.crmCalls = [];
        vm.pinCrmCalls = [];
        vm.groupedCrmCalls = [];
        vm.employee = CoreService.getCurrentEmployee();

        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.isOwner = isOwner;
        vm.pin = pin;
        vm.replace = replace;
        vm.getUnpin = getUnpin;
        vm.trustAsHtml = trustAsHtml;

        loadAll();

        function loadAll() {
            CrmCall.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                pin: true,
                unpaged: true
            }, function (data, headers) {
                vm.pinCrmCalls = data;
            }, onError);

            getUnpin();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/crm-call/crm-call-dialog.html',
                controller: 'CrmCallDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            description: null,
                            pin: false,
                            id: null,
                            crmOpportunity: vm.crmOpportunity,
                            employee: CoreService.getCurrentEmployee(),
                            corporation: CoreService.getCorporation()
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/crm-call/crm-call-dialog.html',
                controller: 'CrmCallDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CrmCall', function (CrmCall) {
                        return CrmCall.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function () {
            });
        }

        function del(id) {
            CrmCall.delete({id: id}, function () {
                loadAll();
            });
        }

        function isOwner(call) {

            return vm.employee.id == call.employee.id;
        }

        function pin(call) {
            CrmCall.pin(call, function () {
                loadAll();
            })
        }

        function replace(str) {

            return str ? str.replace(/_/g,  " ") : "";
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function getUnpin() {
            CrmCall.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id,
                pin: false,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, function (data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.crmCalls = data;
            }, onError);
        }

        function trustAsHtml(call) {
            return $sce.trustAsHtml(call);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmActivityDialogController', CrmActivityDialogController);

    CrmActivityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'CrmActivity', 'CrmNote', 'CrmCall', 'CrmEmail', 'CrmTask', 'Corporation', 'CrmOpportunity'];

    function CrmActivityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, CrmActivity, CrmNote, CrmCall, CrmEmail, CrmTask, Corporation, CrmOpportunity) {
        var vm = this;

        vm.crmActivity = entity;
        vm.clear = clear;
        vm.save = save;
        vm.crmnotes = CrmNote.query({filter: 'crmactivity-is-null'});
        $q.all([vm.crmActivity.$promise, vm.crmnotes.$promise]).then(function() {
            if (!vm.crmActivity.crmNote || !vm.crmActivity.crmNote.id) {
                return $q.reject();
            }
            return CrmNote.get({id : vm.crmActivity.crmNote.id}).$promise;
        }).then(function(crmNote) {
            vm.crmnotes.push(crmNote);
        });
        vm.crmcalls = CrmCall.query({filter: 'crmactivity-is-null'});
        $q.all([vm.crmActivity.$promise, vm.crmcalls.$promise]).then(function() {
            if (!vm.crmActivity.crmCall || !vm.crmActivity.crmCall.id) {
                return $q.reject();
            }
            return CrmCall.get({id : vm.crmActivity.crmCall.id}).$promise;
        }).then(function(crmCall) {
            vm.crmcalls.push(crmCall);
        });
        vm.crmemails = CrmEmail.query({filter: 'crmactivity-is-null'});
        $q.all([vm.crmActivity.$promise, vm.crmemails.$promise]).then(function() {
            if (!vm.crmActivity.crmEmail || !vm.crmActivity.crmEmail.id) {
                return $q.reject();
            }
            return CrmEmail.get({id : vm.crmActivity.crmEmail.id}).$promise;
        }).then(function(crmEmail) {
            vm.crmemails.push(crmEmail);
        });
        vm.crmtasks = CrmTask.query({filter: 'crmactivity-is-null'});
        $q.all([vm.crmActivity.$promise, vm.crmtasks.$promise]).then(function() {
            if (!vm.crmActivity.crmTask || !vm.crmActivity.crmTask.id) {
                return $q.reject();
            }
            return CrmTask.get({id : vm.crmActivity.crmTask.id}).$promise;
        }).then(function(crmTask) {
            vm.crmtasks.push(crmTask);
        });
        vm.corporations = Corporation.query();
        vm.crmopportunities = CrmOpportunity.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.crmActivity.id !== null) {
                CrmActivity.update(vm.crmActivity, onSaveSuccess, onSaveError);
            } else {
                CrmActivity.save(vm.crmActivity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:crmActivityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmActivity', CrmActivity);

    CrmActivity.$inject = ['$resource'];

    function CrmActivity ($resource) {
        var resourceUrl =  'api/crm-activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/crm-activities/filter', method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CrmActivityController', CrmActivityController);

    CrmActivityController.$inject = ['CrmActivity', 'entity', 'AlertService'];

    function CrmActivityController(CrmActivity, entity, AlertService) {

        var vm = this;

        vm.crmOpportunity = entity;
        vm.crmActivities = [];
        vm.groupedCrmActivities = [];

        loadAll();

        function loadAll() {
            CrmActivity.findAllByFilter({
                crmOpportunityId: vm.crmOpportunity.id,
                corporationId: vm.crmOpportunity.corporation.id
            }, function (data) {
                vm.crmActivities = data;

                vm.groupedCrmActivities = _.groupBy(vm.crmActivities, function (crmActivity) {
                    return "<strong>" + moment(crmActivity.createdDate).format("MMMM") + "</strong> " +
                        "<span>[" + moment(crmActivity.createdDate).format("YYYY") + "]</span>";
                });
            }, onError);

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CrmAccount', CrmAccount);

    CrmAccount.$inject = ['$resource','DateUtils'];

    function CrmAccount ($resource, DateUtils) {
        var resourceUrl =  'api/crm-accounts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/crm-accounts/filter',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        _.forEach(data, function (item) {
                            item.dob = DateUtils.convertDateTimeFromServer(item.dob);
                        })

                    }
                    return data;
                }
            },
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CptSearch', CptSearch);

    CptSearch.$inject = ['$resource'];

    function CptSearch($resource) {
        var resourceUrl =  'api/_search/cpts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidQuestionDialogController', CovidQuestionDialogController);

    CovidQuestionDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'CovidQuestion', 'CoreService', 'Icd10Search'];

    function CovidQuestionDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                            CovidQuestion, CoreService, Icd10Search) {
        var vm = this;

        vm.covidQuestion = entity;

        vm.clear = clear;
        vm.save = save;
        vm.getDiagnoses = getDiagnoses;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.covidQuestion.id !== null) {
                CovidQuestion.update(vm.covidQuestion, onSaveSuccess, onSaveError);
            } else {
                CovidQuestion.save(vm.covidQuestion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:covidQuestionUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getDiagnoses(query) {
            if (query && query.length > 1) {
                Icd10Search.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidQuestionDeleteController',CovidQuestionDeleteController);

    CovidQuestionDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidQuestion'];

    function CovidQuestionDeleteController($uibModalInstance, entity, CovidQuestion) {
        var vm = this;

        vm.covidQuestion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidQuestion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-question', {
            parent: 'entity',
            url: '/covid-question',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CovidQuestions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-question/covid-questions.html',
                    controller: 'CovidQuestionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('covid-question.new', {
            parent: 'covid-question',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-question/covid-question-dialog.html',
                    controller: 'CovidQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                name: null,
                                enable: null,
                                xorder: null,
                                id: null,
                                facility :CoreService.getCurrentFacility()
                            };
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-question', null, { reload: 'covid-question' });
                }, function() {
                    $state.go('covid-question');
                });
            }]
        })
        .state('covid-question.edit', {
            parent: 'covid-question',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-question/covid-question-dialog.html',
                    controller: 'CovidQuestionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CovidQuestion', function(CovidQuestion) {
                            return CovidQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-question', null, { reload: 'covid-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('covid-question.delete', {
            parent: 'covid-question',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-question/covid-question-delete-dialog.html',
                    controller: 'CovidQuestionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CovidQuestion', function(CovidQuestion) {
                            return CovidQuestion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-question', null, { reload: 'covid-question' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidQuestion', CovidQuestion);

    CovidQuestion.$inject = ['$resource'];

    function CovidQuestion ($resource) {
        var resourceUrl =  'api/covid-questions/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFacility': {url: 'api/covid-questions/by-facility/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidQuestionController', CovidQuestionController);

    CovidQuestionController.$inject = ['GenericEntityDatatableService', 'CovidQuestion', 'CoreService', 'GUIUtils'];

    function CovidQuestionController (GenericEntityDatatableService, CovidQuestion, CoreService, GUIUtils) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Covid Questions',
            newButtonTitle: 'New Covid Question',
            entityClassHumanized: 'Covid Questions',
            entityStateName: 'covid-question',
            service: CovidQuestion,
            serviceMethod: 'findAllByFacility',
            params: params,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Enable',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.enable);
                    }
                },
                {
                    name: 'xorder',
                    title: 'Order',
                },
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('covid-question'),
                GenericEntityDatatableService.getDeleteAction('covid-question')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidPhysicianDialogController', CovidPhysicianDialogController);

    CovidPhysicianDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'CovidPhysician', 'Facility', 'Employee', 'CoreService', 'BUSINESS_ROLES',
        'itHasCredentials'];

    function CovidPhysicianDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                            CovidPhysician, Facility, Employee, CoreService, BUSINESS_ROLES,
                                            itHasCredentials) {
        var vm = this;

        vm.covidPhysician = entity;
        vm.itHasCredentials = itHasCredentials.value;
        vm.employees = [];
        vm.credentials = [];
        vm.currentEmployee = CoreService.getCurrentEmployee();

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;

        credentialsPermits();

        function credentialsPermits() {
            if (vm.itHasCredentials) {
                vm.employees = [vm.currentEmployee];
                vm.covidPhysician.physician = vm.currentEmployee;
            } else {
                vm.getEmployees();
            }
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.covidPhysician.id !== null) {
                CovidPhysician.update(vm.covidPhysician, onSaveSuccess, onSaveError);
            } else {
                CovidPhysician.save(vm.covidPhysician, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:covidPhysicianUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (vm.itHasCredentials) {
                return;
            }

            var filter = {
                page: 0,
                size: 20,
                query: query,
                facilityId: CoreService.getCurrentFacility().id,
                businessRole: BUSINESS_ROLES.PHYSICIAN
            };

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidPhysicianDeleteController',CovidPhysicianDeleteController);

    CovidPhysicianDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidPhysician'];

    function CovidPhysicianDeleteController($uibModalInstance, entity, CovidPhysician) {
        var vm = this;

        vm.covidPhysician = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidPhysician.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('covid-physician', {
                parent: 'entity',
                url: '/covid-physician',
                data: {
                    authorities: [],
                    pageTitle: 'CovidPhysicians'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/covid-physician/covid-physicians.html',
                        controller: 'CovidPhysicianController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN, access);
                    }]
                }
            })
            .state('covid-physician.new', {
                parent: 'covid-physician',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-physician/covid-physician-dialog.html',
                            controller: 'CovidPhysicianDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: function () {
                                    return {
                                        id: null,
                                        facility: CoreService.getCurrentFacility(),
                                        physician: null
                                    };
                                },
                                itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                                    return Employee.checkBusinessRole({
                                        facilityId: CoreService.getCurrentFacility().id,
                                        businessRole: BUSINESS_ROLES.PHYSICIAN
                                    }).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-physician', null, {reload: 'covid-physician'});
                        }, function () {
                            $state.go('covid-physician');
                        });
                    }
                }]
            })
            .state('covid-physician.edit', {
                parent: 'covid-physician',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-physician/covid-physician-dialog.html',
                            controller: 'CovidPhysicianDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['CovidPhysician', function (CovidPhysician) {
                                    return CovidPhysician.get({id: $stateParams.id}).$promise;
                                }],
                                itHasCredentials: ['Employee', 'CoreService', 'BUSINESS_ROLES', function (Employee, CoreService, BUSINESS_ROLES) {
                                    return Employee.checkBusinessRole({
                                        facilityId: CoreService.getCurrentFacility().id,
                                        businessRole: BUSINESS_ROLES.PHYSICIAN
                                    }).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-physician', null, {reload: 'covid-physician'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('covid-physician.delete', {
                parent: 'covid-physician',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-physician/covid-physician-delete-dialog.html',
                            controller: 'CovidPhysicianDeleteController',
                            controllerAs: 'vm',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['CovidPhysician', function (CovidPhysician) {
                                    return CovidPhysician.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-physician', null, {reload: 'covid-physician'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidPhysician', CovidPhysician);

    CovidPhysician.$inject = ['$resource'];

    function CovidPhysician ($resource) {
        var resourceUrl =  'api/covid-physicians/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/covid-physicians/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidPhysicianController', CovidPhysicianController);

    CovidPhysicianController.$inject = ['GenericEntityDatatableService', 'CovidPhysician', 'CoreService', '$state'];

    function CovidPhysicianController (GenericEntityDatatableService, CovidPhysician, CoreService, $state) {
        var vm = this;

        vm.totalItems = 0;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Covid Physician',
            newButtonTitle: 'New Covid Physician',
            entityClassHumanized: 'Covid Physician',
            entityStateName: 'covid-physician',
            service: CovidPhysician,
            serviceMethod: 'findAllByFilter',
            newAction: false,
            params: params,
            columns: [
                {
                    name: null,
                    title: 'Physician',
                    render: function (data) {
                       return data.physician.firstName + ' ' + data.physician.lastName;
                    }
                },
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('covid-physician'),
                GenericEntityDatatableService.getDeleteAction('covid-physician')
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Covid Physician',
                            action: function () {
                                $state.go('covid-physician.new');
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0
                            }
                        }),
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidLabCompendiumDialogController', CovidLabCompendiumDialogController);

    CovidLabCompendiumDialogController.$inject = ['$timeout', '$scope', 'CovidFacilityLab', '$uibModalInstance', 'entity',
        'CovidLabCompendium', 'LabCompendium', 'CoreService'];

    function CovidLabCompendiumDialogController($timeout, $scope, CovidFacilityLab, $uibModalInstance, entity,
                                                CovidLabCompendium, LabCompendium, CoreService) {
        var vm = this;

        vm.covidLabCompendium = entity;
        vm.labCompendiums = [];
        vm.facility = CoreService.getCurrentFacility();
        vm.covidFacilityLab = null;

        vm.clear = clear;
        vm.save = save;
        vm.getLabCompendium = getLabCompendium;

        CovidFacilityLab.findAllByFacility({id: vm.covidLabCompendium.facility.id}, function (result) {
            if (result.length > 0) {
                vm.covidFacilityLab = result[0];

                vm.getLabCompendium();
            }
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.covidLabCompendium.id !== null) {
                CovidLabCompendium.update(vm.covidLabCompendium, onSaveSuccess, onSaveError);
            } else {
                CovidLabCompendium.save(vm.covidLabCompendium, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:covidLabCompendiumUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getLabCompendium(query) {
            if (vm.covidFacilityLab) {
                LabCompendium.filter({
                    laboratoryId: vm.covidFacilityLab.facilityLab.laboratoryId,
                    searchQuery: query,
                    page: vm.page - 1,
                    size: 40,
                    sort: 'code,asc',
                    facilityId: vm.covidLabCompendium.facility.id
                }, function (result) {
                    vm.labCompendiums = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidLabCompendiumDeleteController',CovidLabCompendiumDeleteController);

    CovidLabCompendiumDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidLabCompendium'];

    function CovidLabCompendiumDeleteController($uibModalInstance, entity, CovidLabCompendium) {
        var vm = this;

        vm.covidLabCompendium = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidLabCompendium.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('covid-lab-compendium', {
                parent: 'entity',
                url: '/covid-lab-compendium?page&sort&search',
                data: {
                    authorities: [],
                    pageTitle: 'CovidLabCompendiums'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendiums.html',
                        controller: 'CovidLabCompendiumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                        Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access);
                    }]
                }
            })
            .state('covid-lab-compendium.new', {
                parent: 'covid-lab-compendium',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendium-dialog.html',
                            controller: 'CovidLabCompendiumDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: function () {
                                    return {
                                        id: null,
                                        facility: CoreService.getCurrentFacility(),
                                        labCompendium: null
                                    };
                                }
                            }
                        }).result.then(function () {
                            $state.go('covid-lab-compendium', null, {reload: 'covid-lab-compendium'});
                        }, function () {
                            $state.go('covid-lab-compendium');
                        });
                    }
                }]
            })
            .state('covid-lab-compendium.edit', {
                parent: 'covid-lab-compendium',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendium-dialog.html',
                            controller: 'CovidLabCompendiumDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['CovidLabCompendium', function (CovidLabCompendium) {
                                    return CovidLabCompendium.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-lab-compendium', null, {reload: 'covid-lab-compendium'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('covid-lab-compendium.delete', {
                parent: 'covid-lab-compendium',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/covid-lab-compendium/covid-lab-compendium-delete-dialog.html',
                            controller: 'CovidLabCompendiumDeleteController',
                            controllerAs: 'vm',
                            windowTopClass: 'custom-dialog-styles',
                            size: 'md',
                            resolve: {
                                entity: ['CovidLabCompendium', function (CovidLabCompendium) {
                                    return CovidLabCompendium.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('covid-lab-compendium', null, {reload: 'covid-lab-compendium'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidLabCompendium', CovidLabCompendium);

    CovidLabCompendium.$inject = ['$resource'];

    function CovidLabCompendium ($resource) {
        var resourceUrl =  'api/covid-lab-compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFacility': {
                url: 'api/covid-lab-compendiums/by-facility/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidLabCompendiumController', CovidLabCompendiumController);

    CovidLabCompendiumController.$inject = ['GenericEntityDatatableService', 'CovidLabCompendium', 'CoreService'];

    function CovidLabCompendiumController (GenericEntityDatatableService, CovidLabCompendium, CoreService) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Covid Lab Compendium',
            newButtonTitle: 'New Covid Lab Compendium',
            entityClassHumanized: 'Covid Lab Compendium',
            entityStateName: 'covid-lab-compendium',
            service: CovidLabCompendium,
            serviceMethod: 'findAllByFacility',
            params: params,
            columns: [
                {
                    name: null,
                    title: 'Code',
                    render: function (data) {
                        return data.labCompendium.code;
                    }
                },
                {
                    name: null,
                    title: 'Description',
                    render: function (data) {
                        return data.labCompendium.description;
                    }
                },
                {
                    name: null,
                    title: 'Laboratory Name',
                    render: function (data) {
                        return data.labCompendium.laboratory.name;
                    }
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction('covid-lab-compendium'),
                GenericEntityDatatableService.getDeleteAction('covid-lab-compendium')
            ],
        }

    }
})();


(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualDialogController', CovidIndividualDialogController);

    CovidIndividualDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CovidIndividual', 'CovidSignature'];

    function CovidIndividualDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CovidIndividual, CovidSignature) {
        var vm = this;

        vm.covidIndividual = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.covidsignatures = CovidSignature.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.covidIndividual.id !== null) {
                CovidIndividual.update(vm.covidIndividual, onSaveSuccess, onSaveError);
            } else {
                CovidIndividual.save(vm.covidIndividual, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:covidIndividualUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dob = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualDetailController', CovidIndividualDetailController);

    CovidIndividualDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CovidIndividual', 'CovidSignature'];

    function CovidIndividualDetailController($scope, $rootScope, $stateParams, previousState, entity, CovidIndividual, CovidSignature) {
        var vm = this;

        vm.covidIndividual = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:covidIndividualUpdate', function(event, result) {
            vm.covidIndividual = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualDeleteController',CovidIndividualDeleteController);

    CovidIndividualDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidIndividual'];

    function CovidIndividualDeleteController($uibModalInstance, entity, CovidIndividual) {
        var vm = this;

        vm.covidIndividual = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidIndividual.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-individual', {
            parent: 'entity',
            url: '/covid-individual',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CovidIndividuals'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-individual/covid-individuals.html',
                    controller: 'CovidIndividualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('covid-individual-detail', {
            parent: 'entity',
            url: '/covid-individual/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'CovidIndividual'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-individual/covid-individual-detail.html',
                    controller: 'CovidIndividualDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'CovidIndividual', function($stateParams, CovidIndividual) {
                    return CovidIndividual.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'covid-individual',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('covid-individual-detail.edit', {
            parent: 'covid-individual-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-dialog.html',
                    controller: 'CovidIndividualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CovidIndividual', function(CovidIndividual) {
                            return CovidIndividual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('covid-individual.new', {
            parent: 'covid-individual',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-dialog.html',
                    controller: 'CovidIndividualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                dob: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('covid-individual', null, { reload: 'covid-individual' });
                }, function() {
                    $state.go('covid-individual');
                });
            }]
        })
        .state('covid-individual.edit', {
            parent: 'covid-individual',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-dialog.html',
                    controller: 'CovidIndividualDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CovidIndividual', function(CovidIndividual) {
                            return CovidIndividual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-individual', null, { reload: 'covid-individual' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('covid-individual.delete', {
            parent: 'covid-individual',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/covid-individual/covid-individual-delete-dialog.html',
                    controller: 'CovidIndividualDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CovidIndividual', function(CovidIndividual) {
                            return CovidIndividual.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('covid-individual', null, { reload: 'covid-individual' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidIndividual', CovidIndividual);

    CovidIndividual.$inject = ['$resource', 'DateUtils'];

    function CovidIndividual ($resource, DateUtils) {
        var resourceUrl =  'api/covid-individuals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dob = DateUtils.convertLocalDateFromServer(data.dob);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dob = DateUtils.convertLocalDateToServer(copy.dob);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CovidIndividualSearch', CovidIndividualSearch);

    CovidIndividualSearch.$inject = ['$resource'];

    function CovidIndividualSearch($resource) {
        var resourceUrl =  'api/_search/covid-individuals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIndividualController', CovidIndividualController);

    CovidIndividualController.$inject = ['$scope', '$state', 'CovidIndividual', 'CovidIndividualSearch'];

    function CovidIndividualController ($scope, $state, CovidIndividual, CovidIndividualSearch) {
        var vm = this;

        vm.covidIndividuals = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            CovidIndividual.query(function(result) {
                vm.covidIndividuals = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            CovidIndividualSearch.query({query: vm.searchQuery}, function(result) {
                vm.covidIndividuals = result;
            });
        }    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIcd10DialogController', CovidIcd10DialogController);

    CovidIcd10DialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CovidIcd10', 'Icd10Search'];

    function CovidIcd10DialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CovidIcd10, Icd10Search) {
        var vm = this;

        vm.covidIcd10 = entity;
        vm.icd10 = vm.covidIcd10.id == null ? getIcd10() : [vm.covidIcd10.icd10];

        vm.clear = clear;
        vm.save = save;
        vm.getIcd10 = getIcd10;


        function getIcd10(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.covidIcd10.id !== null) {
                CovidIcd10.update(vm.covidIcd10, onSaveSuccess, onSaveError);
            } else {
                CovidIcd10.save(vm.covidIcd10, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:covidIcd10Update', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIcd10DeleteController',CovidIcd10DeleteController);

    CovidIcd10DeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidIcd10'];

    function CovidIcd10DeleteController($uibModalInstance, entity, CovidIcd10) {
        var vm = this;

        vm.covidIcd10 = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidIcd10.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-icd-10', {
            parent: 'entity',
            url: '/covid-icd-10',
            data: {
                authorities: [],
                pageTitle: 'CovidIcd10S'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-icd-10/covid-icd-10-s.html',
                    controller: 'CovidIcd10Controller',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access);
                }]
            }
        })
        .state('covid-icd-10.new', {
            parent: 'covid-icd-10',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-icd-10/covid-icd-10-dialog.html',
                        controller: 'CovidIcd10DialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    icd10: null,
                                    facility: CoreService.getCurrentFacility()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('covid-icd-10', null, {reload: 'covid-icd-10'});
                    }, function () {
                        $state.go('covid-icd-10');
                    });
                }
            }]
        })
        .state('covid-icd-10.edit', {
            parent: 'covid-icd-10',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
              if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access)) {
                  $uibModal.open({
                      templateUrl: 'app/entities/covid-icd-10/covid-icd-10-dialog.html',
                      controller: 'CovidIcd10DialogController',
                      controllerAs: 'vm',
                      backdrop: 'static',
                      windowTopClass: 'custom-dialog-styles',
                      size: 'lg',
                      resolve: {
                          entity: ['CovidIcd10', function (CovidIcd10) {
                              return CovidIcd10.get({id: $stateParams.id}).$promise;
                          }]
                      }
                  }).result.then(function () {
                      $state.go('covid-icd-10', null, {reload: 'covid-icd-10'});
                  }, function () {
                      $state.go('^');
                  });
              }
            }]
        })
        .state('covid-icd-10.delete', {
            parent: 'covid-icd-10',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
              if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_ICD10, access)) {
                  $uibModal.open({
                      templateUrl: 'app/entities/covid-icd-10/covid-icd-10-delete-dialog.html',
                      controller: 'CovidIcd10DeleteController',
                      controllerAs: 'vm',
                      windowTopClass: 'custom-dialog-styles',
                      size: 'md',
                      resolve: {
                          entity: ['CovidIcd10', function (CovidIcd10) {
                              return CovidIcd10.get({id: $stateParams.id}).$promise;
                          }]
                      }
                  }).result.then(function () {
                      $state.go('covid-icd-10', null, {reload: 'covid-icd-10'});
                  }, function () {
                      $state.go('^');
                  });
              }
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidIcd10', CovidIcd10);

    CovidIcd10.$inject = ['$resource'];

    function CovidIcd10 ($resource) {
        var resourceUrl =  'api/covid-icd-10-s/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/covid-icd-10-s/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidIcd10Controller', CovidIcd10Controller);

    CovidIcd10Controller.$inject = ['CovidIcd10', 'CoreService', 'GenericEntityDatatableService'];

    function CovidIcd10Controller (CovidIcd10, CoreService, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'covid-icd-10'

        vm.descriptor = {
            title: 'Covid Icd10',
            newButtonTitle: 'New Covid Icd10',
            entityClassHumanized: 'Covid Icd10',
            entityStateName: entityStateName,
            service: CovidIcd10,
            serviceMethod: 'findAllByFilter',
            params,
            columns: [
                {
                    title: 'Icd 10',
                    render: function (data) {
                        return data.icd10.code;
                    }
                },
                {
                    title: 'Description',
                    render: function (data) {
                        return data.icd10.description;
                    }
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction(entityStateName),
                GenericEntityDatatableService.getDeleteAction(entityStateName),
            ]
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityLabDialogController', CovidFacilityLabDialogController);

    CovidFacilityLabDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CovidFacilityLab', 'CoreService', 'Facility', 'FacilityLab'];

    function CovidFacilityLabDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CovidFacilityLab, CoreService, Facility, FacilityLab) {
        var vm = this;

        vm.covidFacilityLab = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facility = CoreService.getCurrentFacility();
        vm.facilitylabs = [];

        FacilityLab.filter({facilityId: vm.facility.id, page: 0, size: 1000}, function (result) {
            vm.facilitylabs = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.covidFacilityLab.id !== null) {
                CovidFacilityLab.update(vm.covidFacilityLab, onSaveSuccess, onSaveError);
            } else {
                CovidFacilityLab.save(vm.covidFacilityLab, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:covidFacilityLabUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityLabDeleteController',CovidFacilityLabDeleteController);

    CovidFacilityLabDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidFacilityLab'];

    function CovidFacilityLabDeleteController($uibModalInstance, entity, CovidFacilityLab) {
        var vm = this;

        vm.covidFacilityLab = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidFacilityLab.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-facility-lab', {
            parent: 'entity',
            url: '/covid-facility-lab?page&sort&search',
            data: {
                authorities: [],
                pageTitle: 'CovidFacilityLabs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-facility-lab/covid-facility-labs.html',
                    controller: 'CovidFacilityLabController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access);
                }]
            }
        })
        .state('covid-facility-lab.new', {
            parent: 'covid-facility-lab',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility-lab/covid-facility-lab-dialog.html',
                        controller: 'CovidFacilityLabDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: function () {
                                return {
                                    id: null,
                                    facility: CoreService.getCurrentFacility(),
                                    facilityLab: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('covid-facility-lab', null, {reload: 'covid-facility-lab'});
                    }, function () {
                        $state.go('covid-facility-lab');
                    });
                }
            }]
        })
        .state('covid-facility-lab.edit', {
            parent: 'covid-facility-lab',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility-lab/covid-facility-lab-dialog.html',
                        controller: 'CovidFacilityLabDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['CovidFacilityLab', function (CovidFacilityLab) {
                                return CovidFacilityLab.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility-lab', null, {reload: 'covid-facility-lab'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('covid-facility-lab.delete', {
            parent: 'covid-facility-lab',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility-lab/covid-facility-lab-delete-dialog.html',
                        controller: 'CovidFacilityLabDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['CovidFacilityLab', function (CovidFacilityLab) {
                                return CovidFacilityLab.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility-lab', null, {reload: 'covid-facility-lab'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidFacilityLab', CovidFacilityLab);

    CovidFacilityLab.$inject = ['$resource'];

    function CovidFacilityLab ($resource) {
        var resourceUrl =  'api/covid-facility-labs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFacility': {
                url: 'api/covid-facility-lab/by-facility/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityLabController', CovidFacilityLabController);

    CovidFacilityLabController.$inject = ['$state', 'CovidFacilityLab', 'CoreService', 'GenericEntityDatatableService'];

    function CovidFacilityLabController ($state, CovidFacilityLab, CoreService, GenericEntityDatatableService) {
        var vm = this;

        vm.totalItems = 0;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'covid-facility-lab'

        vm.descriptor = {
            title: 'Covid Lab Integration',
            entityClassHumanized: 'Covid Lab Integration',
            entityStateName: entityStateName,
            service: CovidFacilityLab,
            serviceMethod: 'findAllByFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    title: 'Laboratory',
                    render: function (data) {
                        return data.facilityLab.laboratory.name;
                    }
                },
                {
                    title: 'Facility Lab Account',
                    render: function (data) {
                        return data.facilityLab.account;
                    }
                }
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction(entityStateName),
                GenericEntityDatatableService.getDeleteAction(entityStateName),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Covid FacilityLab',
                            action: function () {
                                $state.go(entityStateName + '.new');
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0;
                            }
                        }),
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityDialogController', CovidFacilityDialogController);

    CovidFacilityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'CovidFacility', 'Facility', 'DataUtils', 'CoreService', 'LabCompendium', 'CovidFacilityLab'];

    function CovidFacilityDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                           CovidFacility, Facility, DataUtils, CoreService, LabCompendium,
                                           CovidFacilityLab) {
        var vm = this;

        vm.covidFacility = entity;
        vm.facilityLogo = null;
        vm.pharmacyLogo = null;
        vm.facility = CoreService.getCurrentFacility();
        vm.labCompendiums = [];
        vm.covidFacilityLab = null;

        vm.clear = clear;
        vm.save = save;
        vm.handleFileSelect = handleFileSelect;
        vm.getLabCompendium = getLabCompendium;
        vm.handleFileSelectPharmacy = handleFileSelectPharmacy;

        init();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function init() {
            CovidFacilityLab.findAllByFacility({id: vm.facility.id}, function (result) {
                vm.flag = result.length > 0;

                vm.covidFacilityLab = result.length > 0 ? result[0] : null;
            });
        }

        function save() {
            vm.isSaving = true;

            var model = {
                covidFacility: vm.covidFacility,
                facilityLogo: vm.facilityLogo,
                pharmacyLogo: vm.pharmacyLogo
            };

            if (vm.covidFacility.id !== null) {
                CovidFacility.update(model, onSaveSuccess, onSaveError);
            } else {
                CovidFacility.save(model, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:covidFacilityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function handleFileSelect(evt, file) {
            if (file) {
                DataUtils.toBase64(file, function (base64Data) {
                    $scope.$apply(function () {
                        vm.facilityLogo = base64Data;
                    });
                });
            }
        }

        function handleFileSelectPharmacy(evt, file) {
            if (file) {
                DataUtils.toBase64(file, function (base64Data) {
                    $scope.$apply(function () {
                        vm.pharmacyLogo = base64Data;
                    });
                });
            }
        }

        function getLabCompendium(query) {
            if (vm.covidFacilityLab && query && query.length > 1) {
                LabCompendium.filter({
                    laboratoryId: vm.covidFacilityLab.facilityLab.laboratoryId,
                    searchQuery: query,
                    page: vm.page - 1,
                    size: 40,
                    sort: 'code,asc',
                    facilityId: vm.facility.id
                }, function (result) {
                    vm.labCompendiums = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityDeleteController',CovidFacilityDeleteController);

    CovidFacilityDeleteController.$inject = ['$uibModalInstance', 'entity', 'CovidFacility'];

    function CovidFacilityDeleteController($uibModalInstance, entity, CovidFacility) {
        var vm = this;

        vm.covidFacility = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CovidFacility.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('covid-facility', {
            parent: 'entity',
            url: '/covid-facility',
            data: {
                authorities: [],
                pageTitle: 'CovidFacilities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/covid-facility/covid-facilities.html',
                    controller: 'CovidFacilityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }],
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access);
                }]
            }
        })
        .state('covid-facility.new', {
            parent: 'covid-facility',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'CoreService', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, CoreService, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility/covid-facility-dialog.html',
                        controller: 'CovidFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    id: null,
                                    facility: CoreService.getCurrentFacility()
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('covid-facility', null, {reload: 'covid-facility'});
                    }, function () {
                        $state.go('covid-facility');
                    });
                }
            }]
        })
        .state('covid-facility.edit', {
            parent: 'covid-facility',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility/covid-facility-dialog.html',
                        controller: 'CovidFacilityDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'lg',
                        resolve: {
                            entity: ['CovidFacility', function (CovidFacility) {
                                return CovidFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility', null, {reload: 'covid-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        })
        .state('covid-facility.delete', {
            parent: 'covid-facility',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_COVID_FACILITY, access)) {
                    $uibModal.open({
                        templateUrl: 'app/entities/covid-facility/covid-facility-delete-dialog.html',
                        controller: 'CovidFacilityDeleteController',
                        controllerAs: 'vm',
                        windowTopClass: 'custom-dialog-styles',
                        size: 'md',
                        resolve: {
                            entity: ['CovidFacility', function (CovidFacility) {
                                return CovidFacility.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('covid-facility', null, {reload: 'covid-facility'});
                    }, function () {
                        $state.go('^');
                    });
                }
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CovidFacility', CovidFacility);

    CovidFacility.$inject = ['$resource'];

    function CovidFacility ($resource) {
        var resourceUrl =  'api/covid-facilities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {
                url: 'api/covid-facilities/filter',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityController', CovidFacilityController);

    CovidFacilityController.$inject = ['CovidFacility', 'CoreService', 'CovidFacilityLab', '$state',
                                       'GenericEntityDatatableService', 'GUIUtils'];

    function CovidFacilityController (CovidFacility, CoreService, CovidFacilityLab, $state,
                                      GenericEntityDatatableService, GUIUtils) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'covid-facility'

        CovidFacilityLab.findAllByFacility({id: CoreService.getCurrentFacility().id}, function (result) {
            if (result.length > 0) {
                vm.covidFacilityLab = result[0];
            } else {
                vm.descriptor.title = 'Covid Facility (Missing Covid FacilityLab!)';
            }
        });

        vm.descriptor = {
            title: 'Covid Facility',
            entityClassHumanized: 'Covid Facility',
            entityStateName: entityStateName,
            service: CovidFacility,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'logo',
                    title: 'Logo',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(!!data.logo);
                    }
                }
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Covid Facility',
                            action: function () {
                                $state.go('covid-facility.new');
                            },
                            disabled: function (filter) {
                                return !vm.covidFacilityLab;
                            }
                        }),
                    ]
                },
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction(entityStateName),
                GenericEntityDatatableService.getDeleteAction(entityStateName),
            ]
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CountryState', CountryState);

    CountryState.$inject = ['$resource'];

    function CountryState ($resource) {
        var resourceUrl =  'api/country-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CorporationDialogController', CorporationDialogController);

    CorporationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Corporation'];

    function CorporationDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                         Corporation) {
        var vm = this;

        vm.corporation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            Corporation.update(vm.corporation, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:corporationUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError() {
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Corporation', Corporation);

    Corporation.$inject = ['$resource'];

    function Corporation($resource) {
        var resourceUrl = 'api/corporations/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'init': {
                method: 'POST', url: 'api/corporations/init',
                transformResponse: function (data) {
                    return {result : data};
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CorporationController', CorporationController);

    CorporationController.$inject = ['Corporation', 'GenericEntityDatatableService', '$uibModal', 'ConfirmationService',
        '$q', 'GUIUtils', '$state'];

    function CorporationController(Corporation, GenericEntityDatatableService, $uibModal, ConfirmationService,
                                   $q, GUIUtils, $state) {
        var vm = this;

        var entityStateName = 'corporation';

        vm.descriptor = {
            title: 'Corporations',
            entityClassHumanized: 'Corporation',
            entityStateName: entityStateName,
            newButtonTitle: 'New Corporation',
            service: Corporation,
            serviceMethod: 'query',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    title: 'Active',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.active);
                    }
                },
                {
                    title: 'RCopia Integration',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.rcopiaIntegration);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Corporation',
                            action: function () {
                                add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/corporation/create/corporation-wizard-dialog.html',
                controller: 'CorporationWizardDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            id: null,
                            active: true
                        };
                    }
                }
            }).result.then(function () {
                $state.reload();
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/corporation/update/corporation-dialog.html',
                controller: 'CorporationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Corporation', function (Corporation) {
                        return Corporation.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                $state.reload();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Corporation').result.then(function () {
                Corporation.delete({id: id}, function () {
                    $state.reload();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CorporationWizardDialogController', CorporationWizardDialogController);

    CorporationWizardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Corporation', 'InitValue', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile',
        '$q', 'DataTablesService'];

    function CorporationWizardDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                               Corporation, InitValue, DTOptionsBuilder, DTColumnBuilder, $compile,
                                               $q, DataTablesService) {
        var vm = this;

        vm.corporation = entity;
        vm.entities = InitValue.loadEntitiesByType({type: 'CORPORATION'});
        vm.index = -1;
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 1000000;
        vm.selected = {};
        vm.selectAll = false;

        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';

        vm.entityValues = [];

        init();

        vm.clear = clear;
        vm.save = save;
        vm.loadEntity = loadEntity;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.corporation.id !== null) {
                Corporation.update(vm.corporation, onSaveSuccess, onSaveError);
            } else {
                var mapToReturn = {};
                _.forEach(vm.entityValues, function (value) {
                    mapToReturn[value.name] = value.selectedValues;
                });

                Corporation.save({corporation: vm.corporation, entities: mapToReturn}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:corporationUpdate', result);
            $uibModalInstance.close(result);
        }

        function onSaveError() {
        }

        function init() {
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();

                vm.selected = {};
                vm.selectAll = false;

                if (vm.index >= 0) {
                    InitValue.findAllByFilter(getFilter(), function (result, headers) {
                        vm.totalItems = headers('X-Total-Count');
                        vm.initValues = result;
                        defer.resolve(result);
                    });
                } else {
                    defer.resolve([]);
                }

                return defer.promise;
            }).withBootstrap()
                .withDOM('ltp')
                .withOption("bLengthChange", false)
                .withOption("bPaginate", false)
                .withOption('headerCallback', function (header) {
                    if (!vm.headerCompiled) {
                        vm.headerCompiled = true;
                        $compile(angular.element(header).contents())($scope);
                    }
                })
                .withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $compile(nRow)($scope);
                    });

            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                    vm.selected[full.id] = false;
                    var column = '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-change="vm.toggleOne()">';
                    _.forOwn(vm.entityValues, function (value, key) {
                        if (vm.entityValues[key].name === vm.entities[vm.index]) {
                            if (value.selectedValues.length > 0) {
                                _.forEach(value.selectedValues, function (value) {
                                    if (data.id.toString() === value) {
                                        vm.selected[data.id] = true;
                                        column = '<input type="checkbox" ng-checked="true" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
                                    }
                                });
                            }
                        }
                    });

                    return column;
                }),
                DTColumnBuilder.newColumn('name').withTitle('Name')
            ];
        }

        function loadEntity(index) {
            //implement this
            getSelected();
            vm.index = index;

            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var filter = {};

            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.sort = "name";
            filter.type = 'CORPORATION';
            filter.entity = vm.entities[vm.index];

            return filter;
        }

        function getSelected() {
            var selectedValues = [];
            if (_.size(vm.selected) > 0) {
                _.forOwn(vm.selected, function (value, key) {
                    if (value) {
                        selectedValues.push(key);
                    }
                });
            }
            if (_.isEmpty(vm.entityValues) && !_.isEmpty(selectedValues)) {
                vm.entityValues.push({'name': vm.entities[vm.index], 'selectedValues': selectedValues});
            }
            if (!_.isEmpty(vm.entityValues) && !_.isEmpty(selectedValues)) {
                var aux = _.find(vm.entityValues, ['name', vm.entities[vm.index]]);
                if (aux) {
                    aux.selectedValues = selectedValues;
                } else {
                    vm.entityValues.push({'name': vm.entities[vm.index], 'selectedValues': selectedValues});
                }
            } else {
                _.forOwn(vm.entityValues, function (value, key) {
                    if (vm.entityValues[key].name === vm.entities[vm.index]) {
                        _.remove(vm.entityValues, vm.entityValues[key]);
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('corporation', {
                parent: 'entity',
                url: '/corporation',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'Corporations'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/corporation/list/corporation.html',
                        controller: 'CorporationController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactsFacilityDialogController', ContactsFacilityDialogController);

    ContactsFacilityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'ContactsFacility', 'TypeContactFacilityType', 'CountryState',
        'CoreService'];

    function ContactsFacilityDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                              entity, ContactsFacility, TypeContactFacilityType, CountryState,
                                              CoreService) {
        var vm = this;

        vm.contactsFacility = entity;
        vm.clear = clear;
        vm.save = save;
        vm.typecontactfacilitytypes = TypeContactFacilityType.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.countrystates = CountryState.query();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.contactsFacility.id !== null) {
                ContactsFacility.update(vm.contactsFacility, onSaveSuccess, onSaveError);
            } else {
                ContactsFacility.save(vm.contactsFacility, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:contactsFacilityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ContactsFacility', ContactsFacility);

    ContactsFacility.$inject = ['$resource'];

    function ContactsFacility ($resource) {
        var resourceUrl =  'api/contacts-facilities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {'url': 'api/contacts-facilities/filter', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactsFacilityController', ContactsFacilityController);

    ContactsFacilityController.$inject = ['ContactsFacility', 'CoreService', 'GenericEntityDatatableService',
        '$uibModal', 'ConfirmationService', '$q'];

    function ContactsFacilityController(ContactsFacility, CoreService, GenericEntityDatatableService,
                                        $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Contacts',
            newButtonTitle: 'New Contact',
            entityClassHumanized: 'Contact Facility',
            entityStateName: 'contacts-facility',
            service: ContactsFacility,
            serviceMethod: 'filter',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Contact Type',
                    render: function (data) {
                        return data ? data.name : '-';
                    }
                },
                {
                    name: 'cellphone',
                    title: 'Phone'
                },
                {
                    name: 'fax',
                    title: 'Fax'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Contact',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/contacts-facility/update/contacts-facility-dialog.html',
                controller: 'ContactsFacilityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            countryState: null,
                            typeContactFacilityType: null,
                            id: null
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/contacts-facility/update/contacts-facility-dialog.html',
                controller: 'ContactsFacilityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ContactsFacility', function (ContactsFacility) {
                        return ContactsFacility.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Contact').result.then(function () {
                    ContactsFacility.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('contacts-facility', {
                parent: 'entity',
                url: '/contacts-facility',
                data: {
                    authorities: [],
                    pageTitle: 'ContactsFacilities'
                },
                ncyBreadcrumb: {
                    label: 'Contacts Facility'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contacts-facility/list/contacts-facility.html',
                        controller: 'ContactsFacilityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id
                        }
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactsDialogController', ContactsDialogController);

    ContactsDialogController.$inject = ['$timeout', '$scope', 'TypePatientContactTypes', '$uibModalInstance',
        'Contacts', 'entity', 'TypePatientContactsRelationship', 'CountryState', 'CoreService'];

    function ContactsDialogController($timeout, $scope, TypePatientContactTypes, $uibModalInstance,
                                      Contacts, entity, TypePatientContactsRelationship, CountryState, CoreService) {
        var vm = this;

        vm.entity = entity;
        vm.chart = entity.chart;
        vm.typeContacts = TypePatientContactTypes.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.typeRelationships = TypePatientContactsRelationship.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.form = {};
        vm.states = CountryState.query();
        vm.showDelete = false;

        vm.clear = clear;
        vm.save = save;
        vm.confirmDelete = confirmDelete;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.entity.id !== null) {
                Contacts.update(vm.entity, onSaveSuccess, onSaveError);
            } else {
                Contacts.save(vm.entity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:contactsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function confirmDelete () {
            Contacts.delete({id: vm.entity.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Contacts', Contacts);

    Contacts.$inject = ['$resource'];

    function Contacts ($resource) {
        var resourceUrl =  'api/contacts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'guarantor': { url: 'api/contacts/guarantor/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'filter': {url: 'api/contacts/by-chart/filter', method: 'GET', isArray: true},
            'findAllGuarantors': { url: 'api/contacts/guarantor/all/:id', method: 'GET', isArray: true},
            'findAllByFacility': { url: 'api/contacts/by-facility/filter', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactsController', ContactsController);

    ContactsController.$inject = ['chart', 'Contacts', 'CoreService', 'ParseLinks', 'AlertService', '$uibModal',
        'Evaluation', 'PopupService', '$rootScope', '$scope', 'access', 'ACTIONS', 'Auth',
        'ConfirmationService'];

    function ContactsController(chart, Contacts, CoreService, ParseLinks, AlertService, $uibModal,
                                Evaluation, PopupService, $rootScope, $scope, access, ACTIONS, Auth,
                                ConfirmationService) {
        var vm = this;
        vm.chart = chart;

        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.evaluationPage = 1;
        vm.evaluationPerPage = 10;
        vm.released = null;
        vm.contactSelected = null;

        vm.toggleItem = toggleItem;
        vm.transition = transition;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.assign = assign;
        vm.closeEvaluationPanel = closeEvaluationPanel;
        vm.loadAllByContact = loadAllByContact;
        vm.evaluationDel = evaluationDel;
        vm.evaluationAmended = evaluationAmended;
        vm.evaluationTransition = evaluationTransition;
        vm.openEvaluationPanel = openEvaluationPanel;

        function toggleItem() {
            CoreService.togglePanel('contacts');
        }

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CONTACTS_VIEW, access)) {

                return;
            }

            Contacts.filter({
                chartId: chart.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.contacts = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/contacts/update/contacts-dialog.html',
                controller: 'ContactsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            phone: null,
                            email: null,
                            address: null,
                            notes: null,
                            city: null,
                            state: null,
                            zip: null,
                            supportSystem: null,
                            fullName: null,
                            altPhone: null,
                            addressTwo: null,
                            id: null,
                            guarantor: false,
                            chart: chart
                        };
                    },
                    guarantor: ['Contacts', function (Contacts) {
                        return Contacts.guarantor({id: chart.id}).$promise;
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll()
            }, function () {
            });
        }

        function edit(id) {
            PopupService.showContactPopup(id).result.then(function (result) {
                vm.page = 1;
                loadAll()
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Contacts').result.then(function () {
                Contacts.delete({id: id}, function () {
                    vm.page = 1;
                    loadAll()
                });
            })
        }

        function assign(contactId) {
            $uibModal.open({
                templateUrl: 'app/entities/evaluation-template/contact-assign/evaluation-template-contact-assign-dialog.html',
                controller: 'EvaluationTemplateContactAssignDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    chart: chart,
                    contact: ['Contacts', function (Contacts) {
                        return Contacts.get({id: contactId}).$promise;
                    }]
                }
            }).result.then(function () {
                if (vm.contactSelected) {
                    loadAllByContact(contactId);
                }
            });
        }

        function openEvaluationPanel(contactId) {
            vm.evaluationPage = 1;
            vm.contactSelected = contactId;

            loadAllByContact();
        }

        function closeEvaluationPanel() {
            vm.contactSelected = null;
            vm.evaluationPage = 1;
            vm.evaluationTotalItems = 0;
            vm.evaluations = [];
        }

        function evaluationTransition() {
            loadAllByContact();
        }

        function loadAllByContact() {
            Evaluation.findAllByChartAndContact({
                id: chart.id,
                contact: vm.contactSelected,
                page: vm.evaluationPage - 1,
                size: vm.evaluationPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.evaluations = data;
                vm.evaluationTotalItems = headers('X-Total-Count');
            }

            function onError(error) {
                vm.evaluationTotalItems = 0;
                AlertService.error(error.data.message);
            }
        }

        function evaluationDel(evaluation) {
            ConfirmationService.showDelete('Evaluation').result.then(function () {
                Evaluation.delete({id: evaluation.id}, function () {
                    evaluationTransition();
                });
            })
        }

        function evaluationAmended(id) {
            Evaluation.amended({id: id}, function (evaluation) {
                vm.evaluationTransition();
            })
        }

        var unsubscribe = $rootScope.$on('bluebookApp:loadContacts', function (event, result) {
            loadAll();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactAddressDialogController', ContactAddressDialogController);

    ContactAddressDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContactAddress', 'CountryState'];

    function ContactAddressDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ContactAddress, CountryState) {
        var vm = this;

        vm.contactAddress = entity;
        vm.clear = clear;
        vm.save = save;
        vm.countrystates = CountryState.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if (vm.contactAddress.id !== null) {
                ContactAddress.update(vm.contactAddress, onSaveSuccess, onSaveError);
            } else {
                ContactAddress.save(vm.contactAddress, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:contactAddressUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ContactAddress', ContactAddress);

    ContactAddress.$inject = ['$resource'];

    function ContactAddress ($resource) {
        var resourceUrl =  'api/contact-addresses/:id';

        return $resource(resourceUrl, {}, {
            'findAllByFacility': {
                url: 'api/contact-addresses/by-facility',
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT'},
            'faxeable': {url: 'api/contact-addresses/faxeable/:id', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactAddressPickupDialogController', ContactAddressPickupDialogController);

    ContactAddressPickupDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        '$compile', 'DTColumnBuilder', 'DTOptionsBuilder', '$q', 'ContactAddress', 'CoreService'];

    function ContactAddressPickupDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                                  $compile, DTColumnBuilder, DTOptionsBuilder, $q, ContactAddress, CoreService) {
        var vm = this;

        vm.selected = {};
        vm.selectAll = false;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll()">';
        vm.contactAddresses = [];
        vm.dtInstance = {};
        vm.facility = CoreService.getCurrentFacility();

        vm.toggleAll = toggleAll;
        vm.toggleOne = toggleOne;
        vm.clear = clear;
        vm.select = select;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                ContactAddress.faxeable({id: vm.facility.id}, function (result) {
                    vm.contactAddresses = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.contactAddresses, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        }).withPaginationType('full_numbers').withBootstrap().withDOM('tip').withOption('aaSorting', [[1, 'asc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;

                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne()">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn('phone').withTitle('Phone'),
            DTColumnBuilder.newColumn('fax').withTitle('Fax'),
        ];

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function toggleAll() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    vm.selected[id] = vm.selectAll;
                }
            }
        }

        function toggleOne() {
            for (var id in vm.selected) {
                if (vm.selected.hasOwnProperty(id)) {
                    if (!vm.selected[id]) {
                        vm.selectAll = false;
                        return;
                    }
                }
            }

            vm.selectAll = true;
        }

        function select() {
            var ids = [];

            _.forEach(vm.selected, function (value, key) {
                if (value) {
                    ids.push(parseInt(key));
                }
            })

            $uibModalInstance.close({ids: ids});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ContactAddressController', ContactAddressController);

    ContactAddressController.$inject = ['ContactAddress', 'CoreService', 'GenericEntityDatatableService', '$uibModal',
        'ConfirmationService', '$q'];

    function ContactAddressController(ContactAddress, CoreService, GenericEntityDatatableService, $uibModal,
                                      ConfirmationService, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        var entityStateName = 'contact-address'

        vm.descriptor = {
            title: 'Contact Address',
            entityClassHumanized: 'Contact Address',
            entityStateName: entityStateName,
            service: ContactAddress,
            serviceMethod: 'findAllByFacility',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'company',
                    title: 'Company'
                },
                {
                    name: 'phone',
                    title: 'Phone'
                },
                {
                    name: 'fax',
                    title: 'Fax'
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('acuity'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('acuity'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Contact Address',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/contact-address/update/contact-address-dialog.html',
                controller: 'ContactAddressDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            company: null,
                            alias: null,
                            address: null,
                            address2: null,
                            city: null,
                            zipCode: null,
                            phone: null,
                            fax: null,
                            website: null,
                            note: null,
                            email: null,
                            cellphone: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/contact-address/update/contact-address-dialog.html',
                controller: 'ContactAddressDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ContactAddress', function (ContactAddress) {
                        return ContactAddress.get({id: id}).$promise;
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Contact Address').result.then(function () {
                    ContactAddress.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('contact-address', {
                parent: 'entity',
                url: '/contact-address',
                data: {
                    authorities: [],
                    pageTitle: 'ContactAddresses'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/contact-address/list/contact-address.html',
                        controller: 'ContactAddressController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewsDialogController', ConcurrentReviewsDialogController);

    ConcurrentReviewsDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ConcurrentReviewFrequency', 'GUIUtils',
        'ConcurrentReviews', 'chart', 'TypeLevelCare', 'Insurance', 'CoreService'];

    function ConcurrentReviewsDialogController ($timeout, $scope, $uibModalInstance, entity, ConcurrentReviewFrequency, GUIUtils,
                                                ConcurrentReviews, chart, TypeLevelCare, Insurance, CoreService) {
        var vm = this;

        vm.concurrentReviews = entity;
        vm.chart = chart;
        vm.datePickerOpenStatus = {};
        vm.showDelete = false;
        vm.startOptions = {
        };

        vm.endOptions = {
            minDate: vm.concurrentReviews.startDate
        };
        vm.typeLevelCares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));

        Insurance.get({id: vm.chart.primary.id}, function (primary) {
            vm.concurrentReviews.insurance = {id: primary.id, insuranceCarrier: primary.insuranceCarrier};
        })

        vm.frequencies = ConcurrentReviewFrequency.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.updateDays = updateDays;
        vm.changeStartDate = changeStartDate;
        vm.changeEndDate = changeEndDate;
        vm.confirmDelete = confirmDelete;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if(vm.concurrentReviews.insurance) {
                vm.concurrentReviews.insurance = {
                    id: vm.concurrentReviews.insurance.id,
                    insuranceCarrier: vm.concurrentReviews.insurance.insuranceCarrier
                };
            }
            if(vm.concurrentReviews.id !== null) {
                ConcurrentReviews.update(vm.concurrentReviews, onSaveSuccess, onSaveError);
            } else {
                ConcurrentReviews.save(vm.concurrentReviews, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:concurrentReviewsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.authorizationDate = false;
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.datePickerOpenStatus.nextReviewDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function updateDays() {
            if (!vm.concurrentReviews.startDate || !vm.concurrentReviews.endDate ||
                !vm.concurrentReviews.concurrentReviewFrequency || !vm.concurrentReviews.concurrentReviewFrequency.days) {
                return;
            }

            var stepDay = angular.copy(vm.concurrentReviews.startDate);
            var c = 0;
            var frequency = GUIUtils.weekStringJavaToJS(vm.concurrentReviews.concurrentReviewFrequency.days);

            while (stepDay <= vm.concurrentReviews.endDate) {
                if (frequency[stepDay.getDay()] == '1') {
                    c++;
                }

                stepDay.setDate(stepDay.getDate() + 1);
            }

            vm.concurrentReviews.numberDates = c;
        }

        function changeStartDate() {
            vm.endOptions.minDate = vm.concurrentReviews.startDate;
            if (vm.concurrentReviews.startDate > vm.concurrentReviews.endDate) {
                vm.concurrentReviews.endDate = null;
            }

            updateDays();
        }

        function changeEndDate() {
            vm.startOptions.maxDate = vm.concurrentReviews.endDate;
            if (vm.concurrentReviews.startDate > vm.concurrentReviews.endDate) {
                vm.concurrentReviews.startDate = null;
            }

            updateDays();
        }

        function confirmDelete () {
            ConcurrentReviews.delete({id: vm.concurrentReviews.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ConcurrentReviews', ConcurrentReviews);

    ConcurrentReviews.$inject = ['$resource', 'DateUtils'];

    function ConcurrentReviews($resource, DateUtils) {
        var resourceUrl = 'api/concurrent-reviews/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.authorizationDate = DateUtils.convertDateTimeFromServer(data.authorizationDate);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                        data.nextReviewDate = DateUtils.convertDateTimeFromServer(data.nextReviewDate);

                        if (data.employee) {
                            data.employeeName = data.employee.firstName + ' ' + data.employee.lastName;
                        }
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'findAllByChart': {url: 'api/concurrent-reviews/by-chart', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewsController', ConcurrentReviewsController);

    ConcurrentReviewsController.$inject = ['Chart', '$q', 'CoreService', 'GUIUtils', '$uibModal', 'toastr',
        '$rootScope', 'GenericEntityDatatableService'];

    function ConcurrentReviewsController(Chart, $q, CoreService, GUIUtils, $uibModal, toastr,
                                         $rootScope, GenericEntityDatatableService) {

        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Concurrent Reviews',
            entityClassHumanized: 'Concurrent Reviews',
            entityStateName: 'concurrent-reviews',
            service: Chart,
            serviceMethod: 'withoutConcurrentReview',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[5, 'desc'], [2, 'asc']]}
            ],
            selectionColumn: 'chartId',
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + " " + data.lastName;
                    }
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY");
                    }
                },
                {
                    name: 'mrNo',
                    title: "Mr Number"
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.levelOfCare == null ? " " : data.levelOfCare;
                    }
                },
                {
                    name: null,
                    title: "Insurance Carrier",
                    render: function (data) {
                        return data.insuranceName;
                    }
                },
                {
                    name: "insurancePolicyNumber",
                    title: "Insurance Policy"
                },
                {
                    name: null,
                    title: "Last Date",
                    render: function (data) {
                        return data.expiringDate == null ? "" : moment(data.expiringDate).format($rootScope.dateFormat);
                    }
                },
                {
                    name: "authNum",
                    title: 'Auth Number',
                },
                {
                    name: null,
                    title: "Next Review Date",
                    render: function (data) {
                        return data.nextReviewDate == null ? "" : moment(data.nextReviewDate).format($rootScope.dateFormat);
                    }
                },
                {
                    name: null,
                    title: "LCD",
                    render: function (data) {
                        if (data.lcd) {
                            return '<span class="label label-success">YES</span>';
                        } else {
                            return '<span class="label label-danger">NO</span>';
                        }
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.chartId});
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                    name: "New Concurrent Review",
                    action: function (data) {
                        return add(data);
                    },
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'Without Reviews',
                            iClass: 'fa fa-ambulance',
                            ngClass: function (filter) {
                                return vm.descriptor.serviceMethod === "withoutConcurrentReview" ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.descriptor.serviceMethod = "withoutConcurrentReview";
                            }
                        },
                        {
                            name: 'Expired Reviews',
                            iClass: 'fa fa-id-card',
                            ngClass: function (filter) {
                                return vm.descriptor.serviceMethod === "expiredConcurrentReview" ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.descriptor.serviceMethod = "expiredConcurrentReview";
                            },
                        },
                        {
                            name: 'Expiring Reviews',
                            iClass: 'fa fa-user-md',
                            ngClass: function (filter) {
                                return vm.descriptor.serviceMethod === "expiringConcurrentReview" ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                vm.descriptor.serviceMethod = "expiringConcurrentReview";
                            }
                        }
                    ],
                },
            ],
        }

        function add(data) {
            return $q(function (resolve) {
                if (data.primaryId) {
                    $uibModal.open({
                        templateUrl: 'app/entities/concurrent-reviews/update/concurrent-reviews-dialog.html',
                        controller: 'ConcurrentReviewsDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {
                            entity: function () {
                                return {
                                    authorizationDate: null,
                                    numberDates: 0,
                                    frequency: null,
                                    typeLevelCare: null,
                                    startDate: null,
                                    endDate: null,
                                    authorizationNumber: null,
                                    nextReviewDate: null,
                                    insuranceCompany: null,
                                    notes: null,
                                    id: null,
                                    chart: {
                                        id: data.chartId
                                    }
                                }
                            },
                            chart: Chart.get({id: data.chartId}).$promise
                        }
                    }).result.then(function () {
                        resolve();
                    });
                } else {
                    toastr.error("The patient does not have any insurance.");
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('concurrent-reviews', {
                parent: 'entity',
                url: '/concurrent-reviews',
                ncyBreadcrumb: {
                    label: 'Concurrent Reviews'
                },
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/concurrent-reviews/dashboard/concurrent-reviews.html',
                        controller: 'ConcurrentReviewsController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewsChartController', ConcurrentReviewsChartController);

    ConcurrentReviewsChartController.$inject = ['chart', 'CoreService', 'AlertService', 'toastr', '$uibModal', 'ConcurrentReviews',
        'access', 'ACTIONS', 'Auth', 'ConfirmationService'];

    function ConcurrentReviewsChartController(chart, CoreService, AlertService, toastr, $uibModal, ConcurrentReviews,
                                              access, ACTIONS, Auth, ConfirmationService) {
        var vm = this;

        vm.chart = chart;

        vm.pageActive = 1;
        vm.pageInactive = 1;
        vm.itemsPerPage = 3;

        vm.toggleItem = toggleItem;
        vm.transitionActive = transitionActive;
        vm.transitionInactive = transitionInactive;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;

        loadAllActive();
        loadAllInactive();

        function loadAllActive() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW, access)) {

                return;
            }

            var filter = {
                id: chart.id,
                active: true,
                page: vm.pageActive - 1,
                size: 3
            }

            ConcurrentReviews.findAllByChart(filter, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItemsActive = headers('X-Total-Count');
                vm.queryCount = vm.totalItemsActive;
                vm.concurrentReviewsActive = data;
            }, function (error) {
                AlertService.error(error.data.message);
            });
        }

        function loadAllInactive() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW, access)) {

                return;
            }

            var filter = {
                id: chart.id,
                active: false,
                page: vm.pageInactive - 1,
                size: 3
            }

            ConcurrentReviews.findAllByChart(filter, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItemsInactive = headers('X-Total-Count');
                vm.queryCount = vm.totalItemsActive;
                vm.concurrentReviewsInactive = data;
            }, function (error) {
                AlertService.error(error.data.message);
            });
        }

        function transitionActive() {
            loadAllActive();
        }

        function transitionInactive() {
            loadAllInactive();
        }

        function add() {
            if (vm.chart.primary) {
                $uibModal.open({
                    templateUrl: 'app/entities/concurrent-reviews/update/concurrent-reviews-dialog.html',
                    controller: 'ConcurrentReviewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                authorizationDate: null,
                                numberDates: 0,
                                frequency: null,
                                typeLevelCare: null,
                                startDate: null,
                                endDate: null,
                                authorizationNumber: null,
                                nextReviewDate: null,
                                insuranceCompany: null,
                                notes: null,
                                id: null,
                                chart: {
                                    id: chart.id
                                }
                            }
                        },
                        chart: chart
                    }
                }).result.then(function () {
                    vm.pageActive = 1;
                    vm.pageInactive = 1;
                    loadAllActive();
                    loadAllInactive();
                }, function () {
                });
            } else {
                toastr.error("The patient does not have any insurance.");
            }
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/concurrent-reviews/update/concurrent-reviews-dialog.html',
                controller: 'ConcurrentReviewsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ConcurrentReviews', function (ConcurrentReviews) {
                        return ConcurrentReviews.get({id: id}).$promise;
                    }],
                    chart: chart
                }
            }).result.then(function () {
                loadAllActive();
                loadAllInactive();
            }, function () {
                loadAllActive();
                loadAllInactive();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Concurrent Reviews').result.then(function () {
                ConcurrentReviews.delete({id: id}, function () {
                    vm.pageActive = 1;
                    vm.pageInactive = 1;
                    loadAllActive();
                    loadAllInactive();
                }, function () {
                    loadAllActive();
                    loadAllInactive();
                });
            })
        }

        function toggleItem() {
            CoreService.togglePanel('cReviews');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewsChartNewController', ConcurrentReviewsChartNewController);

    ConcurrentReviewsChartNewController.$inject = ['chart', 'CoreService', 'AlertService', 'toastr', '$uibModal',
        'ConcurrentReviews', '$rootScope', '$scope', 'access', 'ACTIONS', 'Auth'];

    function ConcurrentReviewsChartNewController(chart, CoreService, AlertService, toastr, $uibModal,
                                                 ConcurrentReviews, $rootScope, $scope, access, ACTIONS, Auth) {
        var vm = this;

        vm.chart = chart;

        vm.page = 1;
        vm.itemsPerPage = 3;

        vm.transition = transition;
        vm.edit = edit;

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW, access)) {
                return;
            }

            var filter = {
                id: chart.id,
                active: null,
                page: vm.page - 1,
                size: 3
            };

            ConcurrentReviews.findAllByChart(filter, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.concurrentReviews = data;
            }, function (error) {
                AlertService.error(error.data.message);
            });
        }

        function transition() {
            loadAll();
        }

        function add() {
            if (vm.chart.primary) {
                $uibModal.open({
                    templateUrl: 'app/entities/concurrent-reviews/update/concurrent-reviews-dialog.html',
                    controller: 'ConcurrentReviewsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                authorizationDate: null,
                                numberDates: 0,
                                frequency: null,
                                typeLevelCare: null,
                                startDate: null,
                                endDate: null,
                                authorizationNumber: null,
                                nextReviewDate: null,
                                insuranceCompany: null,
                                notes: null,
                                id: null,
                                chart: {
                                    id: chart.id
                                },
                                status: null
                            }
                        },
                        chart: chart
                    }
                }).result.then(function () {
                    vm.page = 1;
                    loadAll();
                }, function () {
                });
            } else {
                toastr.error("The patient does not have any insurance.");
            }
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/concurrent-reviews/update/concurrent-reviews-dialog.html',
                controller: 'ConcurrentReviewsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ConcurrentReviews', function (ConcurrentReviews) {
                        return ConcurrentReviews.get({id: id}).$promise;
                    }],
                    chart: chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartDetailAddConcurrentReview', function (event, result) {
            add();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewFrequencyDialogController', ConcurrentReviewFrequencyDialogController);

    ConcurrentReviewFrequencyDialogController.$inject = ['$timeout', '$scope', 'GUIUtils', '$uibModalInstance', 'entity', 'ConcurrentReviewFrequency', 'ConcurrentReviews'];

    function ConcurrentReviewFrequencyDialogController ($timeout, $scope, GUIUtils, $uibModalInstance, entity, ConcurrentReviewFrequency, ConcurrentReviews) {
        var vm = this;

        vm.concurrentReviewFrequency = entity;
        if (vm.concurrentReviewFrequency.id)
            vm.concurrentReviewFrequency.days2 = GUIUtils.weekCodeStringToDays(vm.concurrentReviewFrequency.days);

        vm.days = GUIUtils.getDays();

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.concurrentReviewFrequency.days = GUIUtils.daysToWeekCodeString(vm.concurrentReviewFrequency.days2);

            if (vm.concurrentReviewFrequency.id !== null) {
                ConcurrentReviewFrequency.update(vm.concurrentReviewFrequency, onSaveSuccess, onSaveError);
            } else {
                ConcurrentReviewFrequency.save(vm.concurrentReviewFrequency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:concurrentReviewFrequencyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ConcurrentReviewFrequency', ConcurrentReviewFrequency);

    ConcurrentReviewFrequency.$inject = ['$resource'];

    function ConcurrentReviewFrequency ($resource) {
        var resourceUrl =  'api/concurrent-review-frequencies/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/concurrent-review-frequencies/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewFrequencyController', ConcurrentReviewFrequencyController);

    ConcurrentReviewFrequencyController.$inject = ['ConcurrentReviewFrequency', 'GUIUtils', 'CoreService',
        'GenericEntityDatatableService', '$uibModal', 'ConfirmationService', '$q'];

    function ConcurrentReviewFrequencyController(ConcurrentReviewFrequency, GUIUtils, CoreService,
                                                 GenericEntityDatatableService, $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Concurrent Review Frequencies',
            entityClassHumanized: 'Concurrent Review Frequencies',
            entityStateName: 'concurrent-review-frequency',
            service: ConcurrentReviewFrequency,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            options: [{key: 'aaSorting', value: [[1, 'asc'], [0, 'asc']]}],
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'days',
                    title: 'Frequency',
                    render: function (data) {
                        return GUIUtils.weekCodeStringToDays(data.days);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Frequency',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
           return $uibModal.open({
                templateUrl: 'app/entities/concurrent-review-frequency/update/concurrent-review-frequency-dialog.html',
                controller: 'ConcurrentReviewFrequencyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            days: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/concurrent-review-frequency/update/concurrent-review-frequency-dialog.html',
                controller: 'ConcurrentReviewFrequencyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ConcurrentReviewFrequency', function (ConcurrentReviewFrequency) {
                        return ConcurrentReviewFrequency.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Concurrent Review Frequency').result.then(function () {
                    ConcurrentReviewFrequency.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('concurrent-review-frequency', {
            parent: 'entity',
            url: '/concurrent-review-frequency',
            data: {
                authorities: [],
                pageTitle: 'ConcurrentReviewFrequencies'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/concurrent-review-frequency/list/concurrent-review-frequency.html',
                    controller: 'ConcurrentReviewFrequencyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY, access);
            }]
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('CompendiumReportGroupDialogController', CompendiumReportGroupDialogController);

    CompendiumReportGroupDialogController.$inject = ['CompendiumReportGroup', 'entity', '$uibModalInstance', '$timeout', '$scope'];

    function CompendiumReportGroupDialogController(CompendiumReportGroup, entity, $uibModalInstance, $timeout, $scope) {
        var vm = this;

        vm.reportGroup = entity;

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reportGroup.id !== null) {
                CompendiumReportGroup.update(vm.reportGroup, onSaveSuccess, onSaveError);
            } else {
                CompendiumReportGroup.save(vm.reportGroup, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:compendiumReportGroupUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    };
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CompendiumReportGroup', CompendiumReportGroup);

    CompendiumReportGroup.$inject = ['$resource'];

    function CompendiumReportGroup ($resource) {
        var resourceUrl =  'api/compendium-report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByLaboratory': {url: 'api/compendium-report-groups/laboratory', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CompendiumReportGroupController', CompendiumReportGroupController);

    CompendiumReportGroupController.$inject = ['CompendiumReportGroup', 'GUIUtils', '$q', 'Laboratory', '$uibModal',
        'CoreService', 'GenericEntityDatatableService', 'PopupService',
        'ConfirmationService'];

    function CompendiumReportGroupController(CompendiumReportGroup, GUIUtils, $q, Laboratory, $uibModal,
                                             CoreService, GenericEntityDatatableService, PopupService,
                                             ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        vm.descriptor = {
            title: 'Compendium Report Groups',
            newAction: false,
            entityClassHumanized: 'Compendium Report Groups',
            entityStateName: 'compendium-report-group',
            service: CompendiumReportGroup,
            serviceMethod: 'findAllByLaboratory',
            pagination: 'remote',
            params: {},
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('compendium-report-group'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('compendium-report-group'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Compendium Report Group',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectLaboratoryPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = result;

                                        vm.laboratory = result;
                                        vm.descriptor.title = 'Compendium Report Group - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/update/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null,
                                laboratory: vm.laboratory
                            };
                        },
                    }
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/compendium-report-group/update/compendium-report-group-dialog.html',
                    controller: 'CompendiumReportGroupDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CompendiumReportGroup', function (CompendiumReportGroup) {
                            return CompendiumReportGroup.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            });
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Compendium Report Group').result.then(function () {
                    CompendiumReportGroup.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('compendium-report-group', {
                parent: 'entity',
                url: '/compendium-report-group',
                data: {
                    authorities: [],
                    pageTitle: 'Compendium Report Group'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/compendium-report-group/list/compendium-report-group.html',
                        controller: 'CompendiumReportGroupController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartStatusHistoryDialogController', ChartStatusHistoryDialogController);

    ChartStatusHistoryDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ChartStatusHistory', 'chart', '$state'];

    function ChartStatusHistoryDialogController($timeout, $scope, $uibModalInstance, entity, ChartStatusHistory, chart, $state) {
        var vm = this;

        vm.chartStatusHistory = entity;
        vm.chartStatusHistory.chart = chart;
        vm.date = new Date();
        vm.current = false;

        vm.clear = clear;
        vm.save = save;
        vm.getTitle = getTitle;
        vm.changeCloseDate = changeCloseDate;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.chartStatusHistory.id == null) {
                beforeSave();
                ChartStatusHistory.save(vm.chartStatusHistory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:chartStatusHistoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getTitle(status) {
            switch (status) {
                case 'CURRENT': {
                    return 'Current';
                }
                case 'ARCHIVE': {
                    return 'Archive';
                }
                case 'REOPEN': {
                    return 'Reopen'
                }
                case 'CLOSED': {
                    return 'Closed'
                }
            }
        }

        function changeCloseDate() {
            if (vm.current) {
                vm.dischargeDate = angular.copy(vm.date);
            } else {
                vm.dischargeDate = angular.copy(vm.chartStatusHistory.chart.dischargeDate);
            }
        }

        function beforeSave() {
            switch (vm.chartStatusHistory.status) {
                case 'REOPEN': {
                    vm.chartStatusHistory.date = angular.copy(vm.date);
                    break;
                }
                case 'CLOSED': {
                    if (!vm.chartStatusHistory.chart.dischargeDate || vm.chartStatusHistory.chart.dischargeDate >= vm.date) {
                        vm.chartStatusHistory.date = angular.copy(vm.date);
                    } else if (vm.current) {
                        vm.chartStatusHistory.date = angular.copy(vm.date);
                    } else {
                        vm.chartStatusHistory.date = angular.copy(vm.chartStatusHistory.chart.dischargeDate);
                    }
                    break;
                }
                case 'CURRENT': {
                    vm.chartStatusHistory.date = angular.copy(vm.date);
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartStatusHistory', ChartStatusHistory);

    ChartStatusHistory.$inject = ['$resource', 'DateUtils'];

    function ChartStatusHistory ($resource, DateUtils) {
        var resourceUrl =  'api/chart-status-histories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartPictureLicense', ChartPictureLicense);

    ChartPictureLicense.$inject = ['$resource'];

    function ChartPictureLicense ($resource) {
        var resourceUrl =  'api/chart-picture-licenses/:id';

        return $resource(resourceUrl, {}, {
            'create': {url: 'api/chart-pictures-license/create', method: 'POST'},
            'getOriginalBase64ByChart': {url: 'api/chart-pictures-license/get-original-base-64/by-chart/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        var result = {image: data};
                    }

                    return result;
                }},
            'getCroppedImageByChart': {url: 'api/chart-pictures-license/get-cropped-image/by-chart/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        var result = {image: data};
                    }

                    return result;
                }},
            'getOneByChart': {url: 'api/chart-pictures-license/by-chart/:id', method: 'GET'}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartPicture', ChartPicture);

    ChartPicture.$inject = ['$resource'];

    function ChartPicture ($resource) {
        var resourceUrl =  'api/chart-pictures/:id';

        return $resource(resourceUrl, {}, {
            'create': {url: 'api/chart-pictures/create', method: 'POST'},
            'getOriginalBase64ByChart': {url: 'api/chart-pictures/get-original-base-64/by-chart/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        var result = {image: data};
                    }

                    return result;
                }},
            'getCroppedImageByChart': {url: 'api/chart-pictures/get-cropped-image/by-chart/:id', method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        var result = {image: data};
                    }

                    return result;
                }}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartNoteDialogController', ChartNoteDialogController);

    ChartNoteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChartNote', 'Employee', 'Chart'];

    function ChartNoteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChartNote, Employee, Chart) {
        var vm = this;

        vm.chartNote = entity;
        vm.chart = entity.chart;
        vm.showDelete = false;

        vm.clear = clear;
        vm.save = save;
        vm.setValidationClass = setValidationClass;
        vm.confirmDelete = confirmDelete;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.chartNote.id !== null) {
                ChartNote.update(vm.chartNote, onSaveSuccess, onSaveError);
            } else {
                ChartNote.save(vm.chartNote, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:chartNoteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function confirmDelete () {
            ChartNote.delete({id: vm.chartNote.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartNote', ChartNote);

    ChartNote.$inject = ['$resource', 'DateUtils'];

    function ChartNote ($resource, DateUtils) {
        var resourceUrl =  'api/chart-notes/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByChart': {url: 'api/chart-notes/by-chart/:id', method: 'GET', isArray: true},
            'findAllByChartInactive': {url: 'api/chart-notes/by-chart/:id/inactive', method: 'GET', isArray: true},
            'findAllByFilter' : {url: 'api/chart-notes/by-chart', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartNoteHistoryNewController', ChartNoteHistoryNewController);

    ChartNoteHistoryNewController.$inject = ['ChartNote', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', '$timeout', '$uibModalInstance'];

    function ChartNoteHistoryNewController(ChartNote, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart,
                                          $timeout, $uibModalInstance) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.notes = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            ChartNote.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.notes = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartNoteController', ChartNoteController);

    ChartNoteController.$inject = ['chart', 'ChartNote', 'CoreService', 'ParseLinks', 'AlertService', '$uibModal',
        '$state', 'ACTIONS', 'access', 'Auth', 'ConfirmationService'];

    function ChartNoteController(chart, ChartNote, CoreService, ParseLinks, AlertService, $uibModal,
                                 $state, ACTIONS, access, Auth, ConfirmationService) {
        var vm = this;
        vm.chart = chart;

        vm.page = 1;
        vm.pageActive = 1;
        vm.pageInactive = 1;
        vm.itemsPerPage = 3;

        vm.toggleItem = toggleItem;
        vm.transitionActive = transitionActive;
        vm.transitionInactive = transitionInactive;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;

        loadAllActive();
        loadAllInactive();

        function loadAllActive() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW, access)) {

                return;
            }

            var filter = {
                id: chart.id,
                active: true,
                page: vm.pageActive - 1,
                size: ($state.current.name === 'chart-new') ? 1000 : 3
            };

            ChartNote.findAllByChart(filter, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItemsActive = headers('X-Total-Count');
                vm.queryCount = vm.totalItemsActive;
                vm.chartNotesActive = data;
            }, function (error) {
                AlertService.error(error.data.message);
            });
        }

        function loadAllInactive() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW, access)) {
                return;
            }

            var filter = {
                id: chart.id,
                active: false,
                page: vm.pageInactive - 1,
                size: 3
            };

            ChartNote.findAllByChartInactive(filter, function (data, headers) {
                // vm.links = ParseLinks.parse(headers('link'));
                vm.totalItemsInactive = headers('X-Total-Count');
                vm.queryCount = vm.totalItemsInactive;
                vm.chartNotesInactive = data;
            }, function (error) {
                AlertService.error(error.data.message);
            });
        }

        function transitionActive() {
            loadAllActive();
        }

        function transitionInactive() {
            loadAllInactive();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/chart-note/update/chart-note-dialog.html',
                controller: 'ChartNoteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            note: null,
                            date: null,
                            id: null,
                            chart: chart,
                            employee: CoreService.getCurrentEmployee()
                        }
                    }]
                }
            }).result.then(function () {
                vm.pageActive = 1;
                vm.pageInactive = 1;
                loadAllActive();
                loadAllInactive();
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/chart-note/update/chart-note-dialog.html',
                controller: 'ChartNoteDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ChartNote', function (ChartNote) {
                        return ChartNote.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAllActive();
                loadAllInactive();
            }, function () {
                loadAllActive();
                loadAllInactive();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Note').result.then(function () {
                ChartNote.delete({id: id}, function () {
                    loadAllActive();
                    loadAllInactive();
                });
            })
        }

        function toggleItem() {
            CoreService.togglePanel('notes');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartFileDialogController', ChartFileDialogController);

    ChartFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ChartFile', 'Chart',
                                        '$state', '$sessionStorage', 'CoreService', 'toastr', 'DataUtils'];

    function ChartFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ChartFile, Chart, $state,
                                        $sessionStorage, CoreService, toastr, DataUtils) {
        var vm = this;

        vm.chartFile = entity;

        vm.clear = clear;
        vm.attachFile = attachFile;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:chartFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function attachFile (files) {
            var attachFiles = [];
            var bigFiles = _.remove(files, function (item) {

                return parseInt(item.size) > 16000000;
            });
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                DataUtils.toBase64ToFileObject(file, function (result) {
                    result.ownerId = parseInt(vm.chartFile.chart.id);
                    attachFiles.push(result);
                    if (attachFiles.length == files.length) {
                        attach(attachFiles);
                    }
                });
            }
            for (var i = 0; i < bigFiles.length; i++) {
                toastr.error(bigFiles[i].name + ' file is too big. The maximum size is 16MB')
            }
        }

        function attach(result) {
            ChartFile.attachFiles({chart : {id: vm.chartFile.chart.id}, files: result}, onSaveSuccess, onSaveError);
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartFile', ChartFile);

    ChartFile.$inject = ['$resource', 'DataUtils'];

    function ChartFile ($resource, DataUtils) {
        var resourceUrl =  'api/chart-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByChart': {url: 'api/chart-files/by-chart/:id', method: 'GET', isArray: true},
            'attachFiles': {url: 'api/chart-files/attach-files', method: 'POST', isArray: true},
            'download': {
                url: 'api/chart-files/get-file/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartFileController', ChartFileController);

    ChartFileController.$inject = ['chart', 'ChartFile', 'ParseLinks', 'CoreService', 'AlertService', '$uibModal',
        'ACTIONS', 'access', 'Auth', 'ConfirmationService'];

    function ChartFileController(chart, ChartFile, ParseLinks, CoreService, AlertService, $uibModal,
                                 ACTIONS, access, Auth, ConfirmationService) {
        var vm = this;
        vm.chart = chart;

        vm.page = 1;
        vm.itemsPerPage = 100;

        vm.toggleItem = toggleItem;
        vm.transition = transition;
        vm.add = add;
        vm.del = del;
        vm.getFileAttached = getFileAttached;

        function toggleItem() {
            CoreService.togglePanel('files');
        }

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_FILE_VIEW, access)) {

                return;
            }

            ChartFile.findAllByChart({
                id: chart.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.chartFile = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/chart-file/update/chart-file-dialog.html',
                controller: 'ChartFileDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function () {
                        return {
                            id: null,
                            chart: chart,
                            file: null
                        }
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('File').result.then(function () {
                ChartFile.delete({id: id}, function () {
                    vm.page = 1;
                    loadAll();
                });
            })
        }

        function getFileAttached(chartFile) {
            ChartFile.download({id: chartFile.id});
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartExportFile', ChartExportFile);

    ChartExportFile.$inject = ['$resource'];

    function ChartExportFile ($resource) {
        var resourceUrl =  'api/chart-export-files/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true, url: 'api/chart-export-files'},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartExportFileController', ChartExportFileController);

    ChartExportFileController.$inject = ['$scope', '$state', 'ChartExportFile', 'entity'];

    function ChartExportFileController($scope, $state, ChartExportFile, entity) {
        var vm = this;

        vm.entity = entity;

        var params = {
            sort: 'id,desc',
            size: 10,
            chartExportId: entity.id
        };

        vm.descriptor = {
            title: 'Chart Export Files - ' + entity.id,
            newButtonTitle: 'New Export',
            entityClassHumanized: 'Chart Export',
            entityStateName: 'chart-export',
            service: ChartExportFile,
            serviceMethod: 'query',
            params: params,
            newAction: false,
            pagination: 'remote',
            enableSearch: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                // {
                //     name: 'name',
                //     title: 'Name',
                // },
                {
                    name: 'chartId',
                    title: 'Chart ID',
                    render: function (entity) {
                        return entity.chart.id;
                    }
                },
                {
                    name: 'firstName',
                    title: 'First Name',
                    render: function (entity) {
                        return entity.chart.firstName;
                    }
                },
                {
                    name: 'lastName',
                    title: 'Last Name',
                    render: function (entity) {
                        return entity.chart.lastName;
                    }
                },
                {
                    name: 'mrNo',
                    title: 'mrNo',
                    render: function (entity) {
                        return entity.chart.mrNo;
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                },
                {
                    name: 'fileSize',
                    title: 'File Size',
                },
                {
                    name: 'file',
                    title: 'file',
                },
                // {
                //     name: 'charts',
                //     title: 'Charts',
                // },
                // {
                //     name: 'progress',
                //     title: 'Progress',
                // },
                // {
                //     name: 'fails',
                //     title: 'Fails',
                // },

                // {
                //     name: 'facesheetTpl.id',
                //     title: 'Facesheet ID',
                //     render: function (entity) {
                //         return entity.facesheetTpl.id;
                //     }
                // },
                // {
                //     name: 'facesheetTpl.name',
                //     title: 'Facesheet',
                //     render: function (entity) {
                //         return entity.facesheetTpl.name;
                //     }
                // }
            ],
            filters: [
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: ['COMPLETED', 'FAILED'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chart-export-file', {
                parent: 'entity',
                url: '/chart-export-file/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'ChartExportFiles'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart-export-file/list/chart-export-files.html',
                        controller: 'ChartExportFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['ChartExport', '$stateParams', function (ChartExport, $stateParams) {
                        return ChartExport.get({id: $stateParams.id}).$promise;
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartExportDialogController', ChartExportDialogController);

    ChartExportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'CoreService',
        'entity', 'ChartExport', 'Employee', 'FacesheetTpl', 'Corporation', 'Facility'];

    function ChartExportDialogController($timeout, $scope, $stateParams, $uibModalInstance, CoreService,
                                         entity, ChartExport, Employee, FacesheetTpl, Corporation, Facility) {
        var vm = this;

        vm.chartExport = entity;
        vm.facesheetTpls = [];
        vm.facilities = [];
        vm.corporation = null;
        vm.facility = null;
        vm.corporations = Corporation.query();

        vm.clear = clear;
        vm.save = save;
        vm.onCorporationSelect = onCorporationSelect;
        vm.onFacilitySelect = onFacilitySelect;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.chartExport.id !== null) {
                ChartExport.update(vm.chartExport, onSaveSuccess, onSaveError);
            } else {
                ChartExport.save(vm.chartExport, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:chartExportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function onCorporationSelect() {
            vm.facesheetTpls = [];
            vm.facility = null;

            Facility.byCorporation({id: vm.corporation.id}, function (result) {
                vm.facilities = result;
            });
        }

        function onFacilitySelect() {
            vm.facesheetTpls = [];

            if (vm.facility && vm.facility.id) {
                var filter = {
                    facilityId: vm.facility.id,
                    page: 0,
                    size: 100000,
                    enabled: true
                };

                FacesheetTpl.filter(filter, function (result) {
                    vm.facesheetTpls = result;
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('chart-export', {
                parent: 'entity',
                url: '/chart-export',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'ChartExports'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart-export/chart-exports.html',
                        controller: 'ChartExportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            })
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartExport', ChartExport);

    ChartExport.$inject = ['$resource'];

    function ChartExport ($resource) {
        var resourceUrl =  'api/chart-exports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'cancel': { method:'PUT', url: 'api/chart-exports/cancel' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartExportController', ChartExportController);

    ChartExportController.$inject = ['$scope', 'ChartExport', 'GenericEntityDatatableService', 'CoreService',
        '$uibModal', '$q', 'ConfirmationService', '$state'];

    function ChartExportController($scope, ChartExport, GenericEntityDatatableService, CoreService,
                                   $uibModal, $q, ConfirmationService, $state) {
        var vm = this;

        var params = {
            sort: 'id,desc',
            size: 10
        };

        vm.descriptor = {
            title: 'Chart Export',
            newButtonTitle: 'New Export',
            entityClassHumanized: 'Chart Export',
            entityStateName: 'chart-export',
            service: ChartExport,
            serviceMethod: 'query',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'status',
                    title: 'Status',
                },
                {
                    name: 'charts',
                    title: 'Charts',
                },
                {
                    name: 'progress',
                    title: 'Progress',
                },
                {
                    name: 'completed',
                    title: 'Completed',
                    render: function (entity) {
                        return entity.progress - entity.fails;
                    }
                },
                {
                    name: 'fails',
                    title: 'Fails',
                },
                {
                    name: 'facility.name',
                    title: 'Facility',
                    render: function (entity) {
                        return entity.facility.name;
                    }
                },
                {
                    name: 'facesheetTpl.id',
                    title: 'Facesheet ID',
                    render: function (entity) {
                        return entity.facesheetTpl.id;
                    }
                },
                {
                    name: 'facesheetTpl.name',
                    title: 'Facesheet',
                    render: function (entity) {
                        return entity.facesheetTpl.name;
                    }
                }
            ],
            rowActions: [
                {
                    name: 'View',
                    action: function (data) {
                        return view(data.id);
                    },
                    aClass: 'dd-link blue',
                    iClass: 'fa fa-eye',
                },
                {
                    name: 'Stop',
                    action: function (data) {
                        return cancel(data.id);
                    },
                    aClass: 'dd-link red',
                    iClass: 'fa fa-trash-o',
                    ngIf: function (entity) {
                        return entity.status === 'PENDING' ||
                        entity.status === 'STARTED';
                    },
                }
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Export',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getRefreshAction(), {
                            name: null,
                            action: function () {
                            }
                        })
                    ]
                },
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/chart-export/chart-export-dialog.html',
                controller: 'ChartExportDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Acuity').result.then(function () {
                    ChartExport.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function cancel(id) {
            var config = {
                title: 'Cancel Chart Export',
                message:
                    `Are you sure you want to <strong>STOP</strong> this Chart Export ${id}?`,
                icon: {},
                leftAction: null,
                actions: [
                    {
                        name: 'Stop',
                        color: 'btn btn-success',
                        icon: 'fa fa-trash',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Cancel',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }

            return $q(function (resolve) {
                ConfirmationService.open(config).result.then(function () {
                    ChartExport.cancel({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function view(id) {
            $state.go('chart-export-file', {id: id});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartCareTeamDialogController', ChartCareTeamDialogController);

    ChartCareTeamDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'ChartCareTeam', 'entity',
        'TypeSpeciality', 'Employee', 'CoreService'];

    function ChartCareTeamDialogController($timeout, $scope, $uibModalInstance, ChartCareTeam, entity,
                                           TypeSpeciality, Employee, CoreService) {
        var vm = this;

        vm.charCareTeam = entity;
        vm.chart = entity.chart;
        vm.typeSpecialities = TypeSpeciality.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.careEmployees = [];
        vm.form = {};

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;
        vm.endDateOptions = {};
        vm.startDateOptions = {};
        vm.corporation = CoreService.getCorporation();
        vm.showDelete = false;

        vm.getCareTeamEmployee = getCareTeamEmployee;
        vm.clear = clear;
        vm.save = save;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.openCalendar = openCalendar;
        vm.confirmDelete = confirmDelete;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function getCareTeamEmployee(query) {
            if (query && query.length > 3) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.careEmployees = result;
                });
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.charCareTeam.id !== null) {
                ChartCareTeam.update(vm.charCareTeam, onSaveSuccess, onSaveError);
            } else {
                ChartCareTeam.save(vm.charCareTeam, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:charCareTeamUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.charCareTeam.startDate;
        }

        function validateStartDate(){
            vm.startDateOptions.maxDate = vm.charCareTeam.endDate;
        }

        function confirmDelete () {
            ChartCareTeam.delete({id: vm.charCareTeam.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartCareTeam', ChartCareTeam);

    ChartCareTeam.$inject = ['$resource', 'DateUtils'];

    function ChartCareTeam ($resource, DateUtils) {
        var resourceUrl =  'api/chart-care-team/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAllByFilter': {url: 'api/chart-care-team/filter', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartCareTeamHistoryNewController', ChartCareTeamHistoryNewController);

    ChartCareTeamHistoryNewController.$inject = ['ChartCareTeam', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                                'chart', '$timeout', '$uibModalInstance', '$rootScope'];

    function ChartCareTeamHistoryNewController(ChartCareTeam, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                               chart, $timeout, $uibModalInstance) {
        var vm = this;
        vm.chart = chart;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.careTeams = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            ChartCareTeam.getAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.careTeams = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartCareTeamController', ChartCareTeamController);

    ChartCareTeamController.$inject = ['chart', 'ChartCareTeam', 'CoreService', '$sessionStorage', '$uibModal',
        'access', 'ACTIONS', 'Auth', 'ConfirmationService'];

    function ChartCareTeamController(chart, ChartCareTeam, CoreService, $sessionStorage, $uibModal,
                                     access, ACTIONS, Auth, ConfirmationService) {
        var vm = this;

        vm.chart = chart;
        vm.careTeamsActive = [];
        vm.careTeamsInactive = [];

        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;

        function toggleItem() {
            CoreService.togglePanel('careTeam');
        }

        vm.activeTab = $sessionStorage.activePatientTabCareTeam ? $sessionStorage.activePatientTabCareTeam.activeTab : 0;

        vm.keepActiveTab = function (index) {
            $sessionStorage.activePatientTabCareTeam = {activeTab: index};
            vm.activeTab = index;
        }

        loadData();

        function loadData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW, access)) {
                return;
            }

            ChartCareTeam.getAllByFilter({
                chartId: vm.chart.id,
                active: true,
                page: 0,
                size: 100
            }, function (result, headers) {
                vm.careTeamsActive = result;
            });

            ChartCareTeam.getAllByFilter({
                chartId: vm.chart.id,
                active: false,
                page: 0,
                size: 100
            }, function (result, headers) {
                vm.careTeamsInactive = result;
            });
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/chart-care-team/update/chart-care-team-dialog.html',
                controller: 'ChartCareTeamDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {
                            allergen: null,
                            allergen_type: null,
                            reaction: null,
                            treatment: null,
                            status: null,
                            id: null,
                            endDate: null,
                            startDate: null,
                            chart: chart
                        };
                    }
                }
            }).result.then(function () {
                loadData()
            }, function () {
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/chart-care-team/update/chart-care-team-dialog.html',
                controller: 'ChartCareTeamDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['ChartCareTeam', function (ChartCareTeam) {
                        return ChartCareTeam.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadData();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Care Team').result.then(function () {
                ChartCareTeam.delete({id: id}, function () {
                    loadData();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartBlockedDialogController', ChartBlockedDialogController);

    ChartBlockedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'ChartBlocked', 'Employee', 'Chart', 'Corporation', 'facility', 'CoreService'];

    function ChartBlockedDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                          ChartBlocked, Employee, Chart, Corporation, facility, CoreService) {
        var vm = this;

        vm.chartBlocked = entity;
        vm.corporation = CoreService.getCorporation();

        vm.employees = vm.chartBlocked.id == null ? [] : [vm.chartBlocked.employee];

        vm.clear = clear;
        vm.save = save;
        vm.getCharts = getCharts;
        vm.getEmployees = getEmployees;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getCharts(query) {
            if (query && query.length > 3) {
                var filter = {};

                filter.page = 0;
                filter.size = 20;
                filter.corporationId = vm.corporation.id;
                filter.searchQuery = query;

                Chart.byCorporation(filter, onSuccess, onError);
            }

            function onSuccess(data, headers) {
                vm.charts = data;
            }

            function onError(error) {
            }
        }

        function save() {
            vm.isSaving = true;
            if (vm.chartBlocked.id !== null) {
                ChartBlocked.update(vm.chartBlocked, onSaveSuccess, onSaveError);
            } else {
                ChartBlocked.save(vm.chartBlocked, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:chartBlockedUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (vm.chartBlocked.id) {
                return;
            }

            var filter = {page: 0, size: 20, query: query, corporationId: vm.corporation.id};

            Employee.findAllWithoutChartBlocked(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ChartBlocked', ChartBlocked);

    ChartBlocked.$inject = ['$resource'];

    function ChartBlocked ($resource) {
        var resourceUrl =  'api/chart-blockeds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: 'api/chart-blockeds/filter', method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(function (item) {
                            item.fullName = item.firstName + ' ' + item.lastName;
                        })
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartBlockedController', ChartBlockedController);

    ChartBlockedController.$inject = ['GenericEntityDatatableService', 'ChartBlocked', '$q',
        '$uibModal', 'CoreService', 'ConfirmationService'];

    function ChartBlockedController(GenericEntityDatatableService, ChartBlocked, $q,
                                    $uibModal, CoreService, ConfirmationService) {

        var vm = this;

        var params = {
            corporationId: CoreService.getCorporation().id
        }

        vm.descriptor = {
            title: 'Charts Blocked',
            newButtonTitle: 'New Chart Blocked',
            entityClassHumanized: 'Charts Blocked',
            entityStateName: 'chart-blocked',
            service: ChartBlocked,
            serviceMethod: 'findAllByFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'fullName',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New ChartBlocked',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/chart-blocked/update/chart-blocked-dialog.html',
                controller: 'ChartBlockedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }]
                }
            }).result
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/chart-blocked/update/chart-blocked-dialog.html',
                controller: 'ChartBlockedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    entity: ['ChartBlocked', function (ChartBlocked) {
                        return ChartBlocked.get({id: id}).$promise;
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }]
                }
            }).result
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('ChartBlocked').result.then(function () {
                    ChartBlocked.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chart-blocked', {
                parent: 'entity',
                url: '/chart-blocked',
                data: {
                    authorities: [],
                    pageTitle: 'ChartBlockeds'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart-blocked/list/chart-blocked.html',
                        controller: 'ChartBlockedController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_CHART_BLOCKED];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_CHART_BLOCKED, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartDialogController', ChartDialogController);

    ChartDialogController.$inject = ['$uibModalInstance', 'chart', 'Chart', 'CoreService', 'CountryState', 'TypeLevelCare', 'Bed',
        'TypePaymentMethods', 'TypeMaritalStatus', 'TypeRace', 'TypeEthnicity', 'GUIUtils',
        'ContactsFacility', 'TypeDischargeType', '$state', 'DataUtils', 'fancyboxService', 'Employee',
        'Track', 'Vessel', 'Port', 'Principal', 'ROLES', 'Pharmacy', 'FacilityPharmacy'];

    function ChartDialogController($uibModalInstance, chart, Chart, CoreService, CountryState, TypeLevelCare, Bed,
                                   TypePaymentMethods, TypeMaritalStatus, TypeRace, TypeEthnicity, GUIUtils,
                                   ContactsFacility, TypeDischargeType, $state, DataUtils, fancyboxService, Employee,
                                   Track, Vessel, Port, Principal, ROLES, Pharmacy, FacilityPharmacy) {
        var vm = this;

        vm.clear = clear;
        vm.clearReadmitReason = clearReadmitReason;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.getContactsFacility = getContactsFacility;
        vm.setValidationClass = setValidationClass;
        vm.imageDetail = imageDetail;
        vm.changePictureStatus = changePictureStatus;
        vm.attachFile = attachFile;
        vm.filterTracks = filterTracks;
        vm.checkField = checkField;
        vm.getMarketers = getMarketers;
        vm.getAdmissionReps = getAdmissionReps;
        vm.getPharmacies = getPharmacies;

        angular.copy(chart, vm.chart = {});
        vm.facility = CoreService.getCurrentFacility();
        vm.states = CountryState.query();
        vm.gender = GUIUtils.getGender();
        vm.maritalStatus = TypeMaritalStatus.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.race = TypeRace.byCorporation(CoreService.getFilterByCurrentCorporation());
        vm.typeDischargeType = TypeDischargeType.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.ethnicity = TypeEthnicity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.paymentMethod = TypePaymentMethods.byFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.typeLevelCare = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.vessels = Vessel.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.ports = Port.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.allowEditBasicInfo = false;
        vm.pharmacies = getPharmacies();

        Chart.countAllByChart({id: chart.id}, function (result) {
            vm.allowEditBasicInfo = result.value <= 1 || Principal.hasAnyAuthority([ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN]);
        });

        if (vm.chart.bed != null) {
            vm.beds = Bed.findAllActiveIncludeChartBed({gender: null, id: vm.facility.id, idBed: vm.chart.bed.id});
        } else {
            vm.beds = Bed.findAllActive({gender: null, id: vm.facility.id});
        }

        vm.form = {};

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.dateBirth = false;
        vm.datePickerOpenStatus.sobrietyDate = false;
        vm.datePickerOpenStatus.admissionDate = false;
        vm.datePickerOpenStatus.dischargeDate = false;
        vm.datePickerOpenStatus.insuranceDob = false;
        vm.datePickerOpenStatus.dateFirstContact = false;
        vm.datePickerOpenStatus.insuranceDob = [false, false];

        vm.dischargeDateOptions = {
            // minDate: vm.chart.admissionDate ? vm.chart.admissionDate: null
        };

        vm.getMarketers();
        vm.getAdmissionReps();

        function getPharmacies(query) {
            if (query && query.length > 2) {
                Pharmacy.findAllByFilter({searchQuery: query}, function (result) {
                    vm.pharmacies = [];
                    vm.pharmacies = result;
                });
            } else {
                FacilityPharmacy.findAllByFilter({facilityId: CoreService.getCurrentFacility().id}, function (result) {
                    vm.pharmacies = [];
                    result.forEach((fP => {
                        vm.pharmacies.push(fP.pharmacy)
                    }))
                });
            }
        }

        function getContactsFacility(query) {
            var filter = {page: 0, size: 10, searchQuery: query, facilityId: vm.facility.id};

            return ContactsFacility.filter(filter).$promise;
        }

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function clearReadmitReason() {
            vm.chart.readmitReason = null;
        }

        function save() {
            vm.isSaving = true;
            if (vm.chart.id !== null) {
                Chart.update(vm.chart, onSaveSuccess, onSaveError);
            } else {
                Chart.save(vm.chart, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
        }

        function imageDetail(picture, name) {
            fancyboxService.fancyboxPlus()({
                'href': 'data:' + picture.pictureContentType + ';base64,' + picture.picture,
                'title': name,
                'transitionIn': 'elastic',
                'transitionOut': 'elastic'
            });
        }

        function changePictureStatus(chart) {
            chart.patientLicense.delStatus = true;
        }

        function attachFile(file, chart) {
            var fileEncode = {};
            if (file) {
                DataUtils.toBase64(file, function (base64Data) {
                    fileEncode.picture = base64Data;
                    fileEncode.pictureContentType = file.type;
                    if (chart.patientLicense && chart.patientLicense.id) {
                        chart.patientLicense = angular.extend({}, chart.patientLicense, fileEncode);
                    } else {
                        chart.patientLicense = fileEncode;
                    }
                });
            }
        }

        function filterTracks(searchQuery) {
            if (searchQuery != null) {
                var filter = {
                    page: 0,
                    size: 1000,
                    facilityId: vm.facility.id,
                    searchQuery: vm.searchQuery,
                    enabled: true
                };

                Track.filter(filter, function (result) {
                    vm.tracks = result;
                });
            }
        }

        function checkField(field) {
            return CoreService.enableByFacilityType(vm.chart.facility, field);
        }

        function getMarketers(query) {
            var filter = {page: 0, size: 20, query: query, facilityId: CoreService.getCurrentFacility().id};

            Employee.findAllByFilter(filter, function (result) {
                vm.marketer = result;
            });
        }

        function getAdmissionReps(query) {
            var filter = {page: 0, size: 20, query: query, facilityId: CoreService.getCurrentFacility().id};

            Employee.findAllByFilter(filter, function (result) {
                vm.admissionReps = result;
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Chart', Chart);

    Chart.$inject = ['$resource', 'DateUtils', 'DataUtils'];

    function Chart($resource, DateUtils, DataUtils) {
        var resourceUrl = 'api/charts/:id';

        function transformCountResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                data = {value: data};
            }
            return data;
        }

        function transformChartResponse(data) {
            if (data) {
                data = angular.fromJson(data);
                data.admissionDate = DateUtils.convertDateTimeFromServer(data.admissionDate);
                data.dischargeDate = DateUtils.convertDateTimeFromServer(data.dischargeDate);
                data.dischargeTime = DateUtils.convertDateTimeFromServer(data.dischargeTime);
                data.dateFirstContact = DateUtils.convertDateTimeFromServer(data.dateFirstContact);
                data.sobrietyDate = DateUtils.convertDateTimeFromServer(data.sobrietyDate);
                data.sailingDate = DateUtils.convertDateTimeFromServer(data.sailingDate);
                // data.phone = parseInt(data.phone);
                // data.altPhone = parseInt(data.altPhone);

                if (data.insurances) {
                    for (var i = 0; i < data.insurances.length; i++) {
                        data.insurances[i].dob = DateUtils.convertLocalDateFromServer(data.insurances[i].dob);
                    }
                }

                data.dateBirth = DateUtils.convertLocalDateFromServer(data.dateBirth);
                data.fullName = data.lastName + ', ' + data.firstName + ' ' + (data.middleName ? data.middleName : '');
            }
            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: transformChartResponse
            },
            'update': {method: 'PUT'},
            'previousCharts': {'url': 'api/charts/previous/:id', method: 'GET', isArray: true},
            'countByFacilities': {'url': 'api/charts/count-by-facilities', method: 'GET', isArray: true},
            'notInShift': {url: 'api/charts/not-in-shift/:shiftId', method: 'GET', isArray: true},
            'countTypeLevelOfCare': {url: 'api/charts/count-type-level-care/:id', method: 'GET', isArray: true},
            'withoutDiagnosis': {url: 'api/charts/without-diagnosis', method: 'GET', isArray: true},
            'withoutInsurance': {url: 'api/charts/without-insurance', method: 'GET', isArray: true},
            'withoutCareTeam': {url: 'api/charts/without-care-team', method: 'GET', isArray: true},
            'countDischargeType': {url: 'api/charts/count-discharge-type/:id', method: 'GET', isArray: true},
            'countChartsWithMarketers': {url: 'api/charts/count-charts-marketer/:id', method: 'GET', isArray: true},
            'countReferrers': {url: 'api/charts/count-referrers/:id', method: 'GET', isArray: true},
            'countCaseLoad': {url: 'api/charts/count-case-load/:id', method: 'GET', isArray: true},
            'withoutConcurrentReview': {url: 'api/charts/without-concurrent-reviews/:id', method: 'GET', isArray: true},
            'expiredConcurrentReview': {url: 'api/charts/expired-concurrent-reviews/:id', method: 'GET', isArray: true},
            'expiringConcurrentReview': {
                url: 'api/charts/expiring-concurrent-reviews/:id',
                method: 'GET',
                isArray: true
            },
            'filterLastClosedOrArchive': {
                'url': 'api/charts/filter-last-closed-or-archive',
                method: 'GET',
                isArray: true
            },
            'getCurrentCensusPdf': {
                url: 'api/charts/pdf-current-census/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'getAllPayers': {url: 'api/charts/payer/:id', method: 'GET', isArray: true},
            'getAllChartsPayerNoInsurance': {url: 'api/charts/payer-no-insurance/filter', method: 'GET', isArray: true},
            'getAllChartsPayerInsurancePrimary': {
                url: 'api/charts/payer-insurance-primary/filter',
                method: 'GET',
                isArray: true
            },
            'getAllChartsPayerInsuranceNoPrimary': {
                url: 'api/charts/payer-insurance-no-primary/filter',
                method: 'GET',
                isArray: true
            },
            'create': {method: 'POST', url: 'api/charts/create'},
            'countAllByChart': {
                url: 'api/charts/count-all-by-chart/:id',
                method: 'GET',
                isArray: false,
                transformResponse: transformCountResponse
            },
            'getFacesheetTplPdf': {
                url: 'api/charts/pdf-facesheet-tpl/:chartId/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'getBedsheetPdf': {
                url: 'api/charts/pdf-bedsheet/:id',
                method: 'GET',
                responseType: 'arraybuffer',
                transformResponse: function (data, headers) {
                    DataUtils.downloadFile(data, headers);
                }
            },
            'getAllByCampaign': {url: 'api/charts/by-campaign/filter', method: 'GET', isArray: true},
            'getAllReferrerChartByFilter': {url: 'api/charts/referrer/filter', method: 'GET', isArray: true},
            'discharging': {'url': 'api/charts/discharging', method: 'GET', isArray: true},
            'incoming': {'url': 'api/charts/incoming', method: 'GET', isArray: true},
            'fullFilter': {'url': 'api/charts/full-filter', method: 'GET', isArray: true},
            'chartsDischarge': {'url': 'api/charts/charts-discharge', method: 'GET', isArray: true},
            'marketer': {'url': 'api/charts/by-marketer', method: 'GET', isArray: true},
            'byCorporation': {url: 'api/charts/by-corporation', method: 'GET', isArray: true},
            'dischargeDateHistory': {url: 'api/charts/discharge-date-history', method: 'GET', isArray: true},
            'copy': {url: 'api/charts/copy', method: 'POST'},
            'findAllNotInGroupSession': {url: 'api/charts/not-in-group-session', method: 'GET', isArray: true},
            'byEvaluation': {
                url: 'api/charts/by-evaluation/:id',
                method: 'GET',
                transformResponse: transformChartResponse
            },
            'aveLengthOfStay': {
                url: 'api/charts/count-ave-length/:id',
                method: 'GET',
                transformResponse: transformCountResponse
            },
            'uploadRc': {url: 'api/charts/upload-rc', method: 'POST', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SelectChartDialogController', SelectChartDialogController);

    SelectChartDialogController.$inject = ['$uibModalInstance', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter',
        '$compile', '$scope', 'CoreService', 'DataTablesService', 'Chart'];

    function SelectChartDialogController($uibModalInstance, DTOptionsBuilder, DTColumnBuilder, $q, $filter,
                                         $compile, $scope, CoreService, DataTablesService, Chart) {
        var vm = this;

        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.selectChart = selectChart;
        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.setChartId = setChartId;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Chart.fullFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.charts = result;

                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[1, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function (data, type, full, meta) {
                return '<input type="radio" name="chart_' + data.id + '" ng-click="vm.setChartId(' + data.id + ')">';
            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').notSortable().renderWith(function (data, type, full) {
                return data.lastName + ", " + data.firstName + ' ' + (data.middleInitial ? data.middleInitial : "");
            }),
            DTColumnBuilder.newColumn('mrNo').withTitle('MrNo').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('D. Birth').renderWith(function (data, type, full) {
                return moment(data.dateBirth).format("MM/DD/YYYY");
            }),
        ];

        function getFilter() {
            var filter = {};
            filter.searchQuery = vm.searchQuery;
            filter.statuses = ['CURRENT', 'ARCHIVE'];
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;
            filter.facilityId = CoreService.getCurrentFacility().id;

            return filter;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            vm.chartId = null;

            transition();
        }

        function transition() {
            vm.dtInstance.reloadData();
        }

        function selectChart() {
            $uibModalInstance.close(vm.chartId);
        }

        function setChartId(id) {
            vm.chartId = id;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartPreviewDialogController', ChartPreviewDialogController);

    ChartPreviewDialogController.$inject = ['$uibModalInstance', 'chart', 'Chart'];

    function ChartPreviewDialogController($uibModalInstance, chart, Chart) {
        var vm = this;

        vm.chart = chart;

        vm.clear = clear;
        vm.checkChartState = checkChartState;
        vm.goToChart = goToChart;

        vm.charts = Chart.previousCharts({id: chart.id});

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        /**
         * Check chart state (ARCHIVE|CURRENT|WAITING)
         * @param chart
         * @returns {string}
         */
        function checkChartState(chart) {
            var state = '';
            if (moment().isAfter(moment(chart.dischargeDate).endOf('day'))) {
                state = 'ARCHIVE';
            }
            if (moment().isBefore(moment(chart.dischargeDate).endOf('day'))) {
                state = 'CURRENT';
            }
            if (chart.waitingRoom) {
                state = 'WAITING';
            }
            return state;
        }

        function goToChart(id) {
            $uibModalInstance.close(id);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartController', ChartController);

    ChartController.$inject = ['facility', 'Chart', 'filter', 'AlertService', '$stateParams',
        'ParseLinks', '$q', 'DateUtils', 'CoreService', 'TypeLevelCare', 'ACTIONS', 'access', 'PopupService',
        '$localStorage', 'UrgentIssues', '$state'];

    function ChartController(facility, Chart, filter, AlertService, $stateParams,
                             ParseLinks, $q, DateUtils, CoreService, TypeLevelCare, ACTIONS, access, PopupService,
                             $localStorage, UrgentIssues, $state) {

        var vm = this;

        vm.access = access[ACTIONS.ACTION_PATIENT_NEW].roles.join();
        vm.facility = facility;
        vm.filter = filter;
        vm.charts = [];
        // vm.page = 1;
        vm.showFilter = false;
        vm.toggleLayout = $stateParams.levelCare != null || $localStorage.chartToggleLayout || false;
        vm.typeLevelCares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.title = 'Patients';
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.admissionDateFrom = false;
        vm.datePickerOpenStatus.admissionDateTo = false;
        vm.datePickerOpenStatus.dischargeDateFrom = false;
        vm.datePickerOpenStatus.dischargeDateTo = false;
        vm.itemsPerPage = 30;
        angular.element('.filter-box').hide();
        vm.filtersDropdown = false;
        vm.sorted = "Patient First Name";
        vm.sortDirection = "Ascending";
        vm.urgentIssues = {};

        vm.transition = transition;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.treatmentDays = treatmentDays;
        vm.showFilters = showFilters;
        vm.filterState = filterState;
        vm.popoverFilterEnable = popoverFilterEnable;
        vm.openCalendar = openCalendar;
        vm.searchByFilter = searchByFilter;
        vm.showCreatePatientPopup = showCreatePatientPopup;
        vm.getCurrentCensusPdf = getCurrentCensusPdf;
        vm.changeToggleLayoutState = changeToggleLayoutState;

        function getFilter() {
            var filter = {};

            filter.page = vm.filter.page - 1;
            filter.size = vm.itemsPerPage;
            filter.typeLevelCareId = vm.filter.typeLevelCare != null ? vm.filter.typeLevelCare.id : null;
            filter.facilityId = vm.filter.facilityId;
            filter.status = vm.filter.status;
            filter.statuses = vm.filter.statuses;
            filter.firstName = vm.filter.firstName;
            filter.lastName = vm.filter.lastName;
            filter.mrNo = vm.filter.mrNo;
            filter.dischargeDateFrom = vm.filter.dischargeDateFrom;
            filter.dischargeDateTo = vm.filter.dischargeDateTo;
            filter.admissionDateFrom = vm.filter.admissionDateFrom;
            filter.admissionDateTo = vm.filter.admissionDateTo;
            filter.searchQuery = vm.filter.searchQuery;
            filter.sort = vm.filter.sort;
            filter.direction = vm.filter.direction;
            filter.externalId = vm.filter.externalId;

            checkVoidParam(filter.sort);
            checkVoidParam(filter.dischargeDateFrom);
            checkVoidParam(filter.dischargeDateTo);
            checkVoidParam(filter.admissionDateFrom);
            checkVoidParam(filter.admissionDateTo);
            checkVoidParam(filter.searchQuery);

            CoreService.setChartFilter(vm.filter);

            return filter;
        }

        loadAll();

        function loadAll() {
            Chart.fullFilter(getFilter(), onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.charts = [];
                vm.charts = data;

                _.forEach(vm.charts, function (chart) {
                    return chart.urgentIssues = 0;
                })

                UrgentIssues.countByChartIds({
                    chartIds: _.map(vm.charts, function (chart) {
                            return chart.id;
                        })
                }, function (result) {
                    _.forEach(result, function (uissues) {
                        _.find(vm.charts, ['id', uissues.chartId]).urgentIssues = uissues.count;
                    })
                })
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function treatmentDays(dateString) {
            var date = moment(dateString),
                currentDate = moment();
            return currentDate.diff(date, 'days');
        }

        function showFilters() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        function searchByFilter() {
            loadAll();
            switch (vm.filter.sort) {
                case "firstName":
                    vm.sorted = "Patient First Name";
                    break;
                case "lastName":
                    vm.sorted = "Patient Last Name";
                    break;
                case "admissionDate":
                    vm.sorted = "Admission Date";
                    break;
                case "typeLevelCare.name":
                    vm.sorted = "Level Of Care";
                    break;
                case "referrer":
                    vm.sorted = "Referral Source";
                    break;
                case "dischargeDate":
                    vm.sorted = "Discharge Date";
                    break;
                case "primary.insuranceCarrier.name":
                    vm.sorted = "Insurance Carrier";
                    break;
            }
            switch (vm.filter.direction) {
                case "ASC":
                    vm.sortDirection = "Ascending";
                    break;
                case "DESC":
                    vm.sortDirection = "Descending";
                    break;

            }
        }

        function clear() {
            vm.filter.page = 1;
            vm.filter.firstName = null;
            vm.filter.lastName = null;
            vm.filter.mrNo = null;
            vm.filter.dischargeDateFrom = null;
            vm.filter.dischargeDateTo = null;
            vm.filter.admissionDateFrom = null;
            vm.filter.admissionDateTo = null;
            vm.filter.typeLevelCare = null;
            vm.filter.sort = "firstName";
            vm.filter.direction = "ASC";
            vm.filter.externalId = null;
            vm.sorted = "Patient First Name";
            vm.sortDirection = "Ascending";

            loadAll();
        }

        function filterState(status) {
            vm.filter.status = status;
            vm.filter.page = 1;

            switch (status) {
                case 'CURRENT':
                case 'WAITING': {
                    vm.filter.statuses = status;

                    break;
                }
                case 'ARCHIVE': {
                    vm.filter.statuses = ['ARCHIVE', 'CLOSED'];

                    break;
                }
                default: {
                    vm.filter.statuses = null;
                }
            }

            loadAll();
        }

        function popoverFilterEnable() {
            vm.showFilter = !vm.showFilter;
        }

        function checkVoidParam(param) {
            if (!param || param === '') {
                param = null;
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function showCreatePatientPopup() {
            PopupService.showCreatePatientPopup().result.then(function (result) {
                $state.go("chart", {id: result.id});
            });
        }

        function getCurrentCensusPdf() {
            Chart.getCurrentCensusPdf({id: vm.facility.id});
        }

        function changeToggleLayoutState() {
            vm.toggleLayout = !vm.toggleLayout;
            $localStorage.chartToggleLayout = vm.toggleLayout;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartDischargeDateHistoryController', ChartDischargeDateHistoryController);

    ChartDischargeDateHistoryController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService', 'chart',
        'Chart', '$q', '$compile', '$scope', '$timeout', '$uibModalInstance', '$rootScope'];

    function ChartDischargeDateHistoryController(DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart,
                                                 Chart, $q, $compile, $scope, $timeout, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.selected = {};
        vm.selectAll = false;

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Chart.dischargeDateHistory(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                defer.resolve(result);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            // .withOption('aaSorting', [[0, 'desc']])
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn("dischargeDate").withTitle('Discharge Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Employee').renderWith(function (data, type, full) {
                return data.employee.firstName + " " + data.employee.lastName;
            })
        ];

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.dtInstance.reloadData();
        }

        function reload() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartDischargeDateHistoryNewController', ChartDischargeDateHistoryNewController);

    ChartDischargeDateHistoryNewController.$inject = ['TypeLevelCare', '$state', 'DTOptionsBuilder', 'DTColumnBuilder',
        'DataTablesService', 'chart', 'Chart', '$q', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope',
        '$timeout', '$uibModalInstance', '$rootScope'];

    function ChartDischargeDateHistoryNewController(TypeLevelCare, $state, DTOptionsBuilder, DTColumnBuilder, DataTablesService, chart, Chart,
                                          $q, GUIUtils, $filter, CoreService, $compile, $scope,
                                          $timeout, $uibModalInstance, $rootScope) {
        var vm = this;
        vm.chart = chart;

        vm.facesheetTpls = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.selected = {};
        vm.selectAll = false;
        vm.dischargeDates = [];

        vm.clear = clear;
        vm.print = print;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.search = search;
        vm.reload = reload;

        loadAll();

        function loadAll() {
            Chart.dischargeDateHistory(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');

                vm.dischargeDates = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function reload() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartDetailController', ChartDetailController);

    ChartDetailController.$inject = ['fancyboxService', 'CoreService', 'chart', '$state', 'Chart',
        'UrgentIssues', '$timeout', '$stateParams', '$document', 'Diet', 'Allergies', 'anchor',
        'previousState', '$scope', '$window', '$uibModal', 'facility', 'Auth',
        'ACTIONS', 'access', '$location', '$anchorScroll', 'AlertService', 'toastr', 'Evaluation',
        'PopupService', '$rootScope', 'ChartPicture', 'ChartPictureLicense'];

    function ChartDetailController(fancyboxService, CoreService, chart, $state, Chart,
                                   UrgentIssues, $timeout, $stateParams, $document, Diet, Allergies, anchor,
                                   previousState, $scope, $window, $uibModal, facility, Auth,
                                   ACTIONS, access, $location, $anchorScroll, AlertService, toastr, Evaluation,
                                   PopupService, $rootScope, ChartPicture, ChartPictureLicense) {

        var vm = this;

        vm.chart = chart;
        vm.title = 'Patient Details';

        vm.accessCloseChart = access[ACTIONS.ACTION_PATIENT_CLOSE_CHART] ? access[ACTIONS.ACTION_PATIENT_CLOSE_CHART].roles.join() : null;
        vm.accessEditId = access[ACTIONS.ACTION_PATIENT_EDIT_ID] ? access[ACTIONS.ACTION_PATIENT_EDIT_ID].roles.join() : null;
        vm.accessEditInfo = access[ACTIONS.ACTION_PATIENT_EDIT_INFO] ? access[ACTIONS.ACTION_PATIENT_EDIT_INFO].roles.join() : null;
        vm.accessInsuranceView = access[ACTIONS.ACTION_PATIENT_INSURANCE_VIEW] ? access[ACTIONS.ACTION_PATIENT_INSURANCE_VIEW].roles.join() : null;
        vm.accessContactsView = access[ACTIONS.ACTION_PATIENT_CONTACTS_VIEW] ? access[ACTIONS.ACTION_PATIENT_CONTACTS_VIEW].roles.join() : null;
        vm.accessCareTeamView = access[ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW] ? access[ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW].roles.join() : null;
        vm.accessCareCoordinationView = access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW] ? access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW].roles.join() : null;
        vm.accessAllergiesView = access[ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW] ? access[ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW].roles.join() : null;
        vm.accessDietsView = access[ACTIONS.ACTION_PATIENT_DIETS_VIEW] ? access[ACTIONS.ACTION_PATIENT_DIETS_VIEW].roles.join() : null;
        vm.accessVitalsView = access[ACTIONS.ACTION_PATIENT_VITALS_VIEW] ? access[ACTIONS.ACTION_PATIENT_VITALS_VIEW].roles.join() : null;
        vm.accessGlucoseView = access[ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW] ? access[ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW].roles.join() : null;
        vm.accessWeightView = access[ACTIONS.ACTION_PATIENT_WEIGHT_VIEW] ? access[ACTIONS.ACTION_PATIENT_WEIGHT_VIEW].roles.join() : null;
        vm.accessAlcoholView = access[ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW] ? access[ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW].roles.join() : null;
        vm.accessDrugsView = access[ACTIONS.ACTION_PATIENT_DRUGS_VIEW] ? access[ACTIONS.ACTION_PATIENT_DRUGS_VIEW].roles.join() : null;
        vm.accessAlcoholAndDrugsView = vm.accessAlcoholView || vm.accessDrugsView ? _.uniq(vm.accessAlcoholView.split(',').concat(vm.accessDrugsView.split(','))).join() : null;
        vm.accessFileView = access[ACTIONS.ACTION_PATIENT_FILE_VIEW] ? access[ACTIONS.ACTION_PATIENT_FILE_VIEW].roles.join() : null;
        vm.accessChartNoteView = access[ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW] ? access[ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW].roles.join() : null;
        vm.accessConcurrentReviewView = access[ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW] ? access[ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW].roles.join() : null;
        vm.accessVerifytxView = access[ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW] ? access[ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW].roles.join() : null;
        vm.accessDiagnosesView = access[ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW] ? access[ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW].roles.join() : null;
        vm.accessLabOrdersView = access[ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW] ? access[ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW].roles.join() : null;
        vm.accessELabsView = access[ACTIONS.ACTION_PATIENT_ELABS_VIEW] ? access[ACTIONS.ACTION_PATIENT_ELABS_VIEW].roles.join() : null;
        vm.accessGroupSessionView = access[ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW] ? access[ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW].roles.join() : null;
        vm.accessEvaluationView = access[ACTIONS.ACTION_PATIENT_EVALUATION_VIEW] ? access[ACTIONS.ACTION_PATIENT_EVALUATION_VIEW].roles.join() : null;
        vm.accessMedicationView = access[ACTIONS.ACTION_PATIENT_MEDICATION_VIEW] ? access[ACTIONS.ACTION_PATIENT_MEDICATION_VIEW].roles.join() : null;
        vm.accessDeleteCareDelivery = access[ACTIONS.ACTION_DELETE_CARE_DELIVERY] ? access[ACTIONS.ACTION_DELETE_CARE_DELIVERY].roles.join() : null;

        vm.previousState = previousState;
        vm.unknownUrgentIssue = [];
        vm.urgentIssues = UrgentIssues.byChart({id: $stateParams.id});
        vm.menu = $rootScope.employeeMenu.menu;

        ChartPicture.getCroppedImageByChart({id: chart.id}, function (result) {
            vm.pictureRef = result.image;
        }, function () {
            vm.pictureRef = CoreService.patientPictureDefault().picture;
        });

        // UrgentIssues.unknown({id: chart.id}, function (result) {
        //     if (result && result.length > 0) {
        //         showUnknownIssuesPopup(result);
        //     }
        // });

        UrgentIssues.filter({chartId: chart.id, unknown: true, page: 0, size: 100}, function (result, headers) {
            var totalItems = headers('X-Total-Count');

            if (totalItems > 0) {
                showUnknownIssuesPopup(result);
            }
        });

        ChartPictureLicense.getOneByChart({id: vm.chart.id}, function (result) {
            vm.chartPictureLicense = result;
        });

        vm.imageDetail = imageDetail;
        vm.toggleItem = toggleItem;
        vm.goToItem = goToItem;
        vm.editInfo = editInfo;
        vm.executePrint = loadAllAllergies;
        vm.openReport = openReport;
        vm.showPreviousCharts = showPreviousCharts;
        vm.showBlueAlertPopup = showBlueAlertPopup;
        vm.showFacesheetTpl = showFacesheetTpl;
        vm.showLevelCareHistory = showLevelCareHistory;
        vm.showDischargeDateHistory = showDischargeDateHistory;
        vm.showTrackHistory = showTrackHistory;
        vm.copyChart = copyChart;
        vm.editImage = editImage;
        vm.viewImageLicense = viewImageLicense;
        vm.editImageLicense = editImageLicense;
        vm.openChangeStatusChart = openChangeStatusChart;
        vm.checkField = checkField;

        vm.actionAuth = Auth.rolesActionAuth;

        //Scroll to Top on view loaded
        $scope.$on('$viewContentLoaded', function () {
            if (anchor) {
                $location.hash(anchor);
                $anchorScroll();
            } else {
                $window.scrollTo(0, 0);
            }
        });

        function imageDetail(picture, title) {
            if (picture) {
                fancyboxService.fancyboxPlus()({
                    'href': picture.picture,
                    'title': title,
                    'transitionIn': 'fade',
                    'transitionOut': 'elastic'
                });
            }
        }

        function toggleItem(attr) {
            CoreService.togglePanel(attr);
        }

        function goToItem(attr) {
            var target = angular.element(document.getElementById(attr));
            CoreService.showPanel(attr);
            $document.scrollToElement(target, 80, 400);
        }

        function loadAllAllergies() {
            var dd = {
                content: [],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        alignment: 'justify'
                    },
                    subheader: {
                        fontSize: 15,
                        bold: true
                    },
                    quote: {
                        italics: true
                    },
                    small: {
                        fontSize: 8
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };
            var header = {
                text: 'Food Memo',
                style: 'header'
            };
            var information = {
                text: 'Patient special dietary',
                style: 'subheader',
                alignment: 'center'
            };
            var personalInfo = {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    body: [[{
                        text: 'Name: ',
                        style: 'tableHeader'
                    }, vm.chart.lastName + ", " + vm.chart.firstName],
                        [{text: 'MR Number: ', style: 'tableHeader'}, vm.chart.mrNo]]
                }, layout: 'noBorders'
            };
            var image = {image: vm.pictureRef, alignment: 'center', width: 450, height: 450};
            var foodAllergies = {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: ['*'],
                    body: []
                },
                alignment: 'center',
                layout: 'noBorders'
            };
            var activeDiets = {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: ['*'],
                    body: []
                },
                alignment: 'center',
                layout: 'noBorders'
            };
            dd.content.push(header);
            dd.content.push(information);
            dd.content.push(personalInfo);
            dd.content.push(image);

            Allergies.findAllAllergiesByChart({id: chart.id, allergenType: 'Food'}, function (result) {
                vm.allergies = result;
                foodAllergies.table.body.push([{
                    text: 'Food Allergies',
                    style: 'tableHeader',
                    decoration: 'underline'
                }]);
                for (var i = 0; i < vm.allergies.length; i++) {
                    foodAllergies.table.body.push([{text: vm.allergies[i].name}]);
                }
                if (vm.allergies.length) {
                    dd.content.push(foodAllergies);
                }

                Diet.findAllByChart({chartId: chart.id, active: true}, function (result) {
                    vm.diets = result;
                    activeDiets.table.body.push([{text: 'Diets', style: 'tableHeader', decoration: 'underline'}]);
                    for (var i = 0; i < vm.diets.length; i++) {
                        activeDiets.table.body.push([{text: vm.diets[i].typeFoodDiets.name}]);
                    }
                    if (vm.diets.length) {
                        dd.content.push(activeDiets);
                    }
                    if (vm.diets.length || vm.allergies.length) {
                        vm.pdf = pdfMake.createPdf(dd);
                        vm.pdf.print();
                    } else
                        alert("this patient does not have diet");
                });
            });
        }

        function editInfo(id) {
            $uibModal.open({
                templateUrl: 'app/entities/chart/update/chart-dialog.html',
                controller: 'ChartDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                $state.reload();
            }, function (result) {
            });
        }

        function openReport() {
            $uibModal.open({
                templateUrl: 'app/reports/report-dialog-chart.html',
                controller: 'ReportDialogChartController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
            });
        }

        function showPreviousCharts() {
            $uibModal.open({
                templateUrl: 'app/entities/chart/preview/chart-preview-dialog.html',
                controller: 'ChartPreviewDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            }).result.then(function (id) {
                $state.go('chart', {id: id}, {reload: true});
            });
        }

        function showFacesheetTpl() {
            $uibModal.open({
                templateUrl: 'app/entities/facesheet-tpl/chart-report/old/facesheet-tpl-report.html',
                controller: 'FacesheetTplReportController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            });
        }

        function showUnknownIssuesPopup() {
            $uibModal.open({
                templateUrl: 'app/entities/urgent-issues/chart/old/unknown/urgent-issue-unknown.html',
                controller: 'UrgentIssuesUnknownController',
                controllerAs: 'vm',
                windowTopClass: 'custom-dialog-styles with-icon',
                size: 'lg',
                resolve: {
                    chart: chart
                }
            });
        }

        function showBlueAlertPopup() {
            $uibModal.open({
                templateUrl: 'app/entities/urgent-issues/chart/old/list/urgent-issues-dialog.html',
                controller: 'UrgentIssuesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            description: null,
                            status: null,
                            id: null,
                            chart: chart,
                            employees: [],
                            facility: CoreService.getCurrentFacility()
                        };
                    }
                }
            })
        }

        function showLevelCareHistory() {
            $uibModal.open({
                templateUrl: 'app/entities/type-level-care/chart/old/type-level-care-history.html',
                controller: 'TypeLevelCareHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showDischargeDateHistory() {
            $uibModal.open({
                templateUrl: 'app/entities/chart/discharge-date-history/old/chart-discharge-date-history.html',
                controller: 'ChartDischargeDateHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showTrackHistory() {
            $uibModal.open({
                templateUrl: 'app/entities/track/chart/old/track-history.html',
                controller: 'TrackHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function copyChart() {
            $uibModal.open({
                templateUrl: 'app/entities/chart/copy/chart-copy-dialog.html',
                controller: 'ChartCopyController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    chart: vm.chart
                }
            }).result.then(function (facility) {
                PopupService.showCreatePatientPopup(vm.chart, facility).result.then(function (result) {
                    CoreService.setCurrentFacility(facility);
                    $state.transitionTo('chart', {id: result.id}, {
                        location: true,
                        inherit: true,
                        notify: true,
                        reload: true
                    });
                });
            });
        }

        function editImage() {
            ChartPicture.getOriginalBase64ByChart({id: vm.chart.id}, function (result) {
                openCropImagePopup(result);
            }, function () {
                openCropImagePopup(null);
            });
        }

        function openCropImagePopup(result){
            PopupService.showCropImageChartPopup(result).result.then(function (error) {
            }, function (data) {
                if (data) {
                    ChartPicture.create({
                        chartId: vm.chart.id,
                        cropped: data.cropped,
                        image: data.image
                    }, function () {
                        $state.reload();
                    });
                }
            });
        }

        function viewImageLicense() {
            ChartPictureLicense.getCroppedImageByChart({id: vm.chart.id}, function (picture) {
                if (picture) {
                    fancyboxService.fancyboxPlus()({
                        'href': picture.image,
                        'title': 'License Picture',
                        'transitionIn': 'fade',
                        'transitionOut': 'elastic'
                    });
                }
            })
        }

        function editImageLicense() {
            ChartPictureLicense.getOriginalBase64ByChart({id: vm.chart.id}, function (result) {
                openCropImageLicensePopup(result);
            }, function () {
                openCropImageLicensePopup(null);
            });
        }

        function openCropImageLicensePopup(result) {
            PopupService.showCropImageLicensePopup(result).result.then(function (error) {
            }, function (data) {
                if (data) {
                    ChartPictureLicense.create({
                        chartId: vm.chart.id,
                        cropped: data.cropped,
                        image: data.image
                    }, function () {
                        $state.reload();
                    });
                }
            });
        }

        function openChangeStatusChart(status){
            $uibModal.open({
                templateUrl: 'app/entities/chart-status-history/chart-status-history-dialog.html',
                controller: 'ChartStatusHistoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                animation: false,
                resolve: {
                    entity: function () {
                        return {
                            status: status,
                            description: null,
                            date: null,
                            id: null
                        };
                    },
                    chart: vm.chart
                }
            }).result.then(function () {
                $state.reload();
            })
        }

        function checkField(field) {
            return CoreService.enableByFacilityType(vm.chart.facility, field);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartDetailsController', ChartDetailsController);

    ChartDetailsController.$inject = ['$state', '$window', '$uibModal', 'toastr', 'CoreService',
        'fancyboxService', 'chart', 'Allergies', 'Diet', 'ACTIONS', 'access', 'Chart', '$rootScope',
        '$scope', 'Insurance', '$uibModalStack', 'PopupService', 'ChartPicture', 'ChartPictureLicense',
        '$location', 'params', 'TAB', 'ConfirmationService', 'Rcopia', 'RcopiaAccount', 'rcopiaAccount'];

    function ChartDetailsController($state, $window, $uibModal, toastr, CoreService,
                                    fancyboxService, chart, Allergies, Diet, ACTIONS, access, Chart, $rootScope,
                                    $scope, Insurance, $uibModalStack, PopupService, ChartPicture, ChartPictureLicense,
                                    $location, params, TAB, ConfirmationService, Rcopia, RcopiaAccount, rcopiaAccount) {
        var vm = this;

        vm.title = 'Patient Details';
        vm.floatingMenuStatus = false;
        vm.chart = chart;
        vm.chart.age = moment().diff(vm.chart.dateBirth, 'years');
        vm.chartSelected = {
            id: vm.chart.id
        };

        vm.access = access;
        vm.accessEditId = access[ACTIONS.ACTION_PATIENT_EDIT_ID] ? access[ACTIONS.ACTION_PATIENT_EDIT_ID].roles.join() : null;
        vm.accessEditInfo = access[ACTIONS.ACTION_PATIENT_EDIT_INFO] ? access[ACTIONS.ACTION_PATIENT_EDIT_INFO].roles.join() : null;
        vm.accessInsuranceView = access[ACTIONS.ACTION_PATIENT_INSURANCE_VIEW] ? access[ACTIONS.ACTION_PATIENT_INSURANCE_VIEW].roles.join() : null;
        vm.accessContactsView = access[ACTIONS.ACTION_PATIENT_CONTACTS_VIEW] ? access[ACTIONS.ACTION_PATIENT_CONTACTS_VIEW].roles.join() : null;
        vm.accessCareTeamView = access[ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW] ? access[ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW].roles.join() : null;
        vm.accessCareCoordinationView = access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW] ? access[ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW].roles.join() : null;
        vm.accessAllergiesView = access[ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW] ? access[ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW].roles.join() : null;
        vm.accessDietsView = access[ACTIONS.ACTION_PATIENT_DIETS_VIEW] ? access[ACTIONS.ACTION_PATIENT_DIETS_VIEW].roles.join() : null;
        vm.accessVitalsView = access[ACTIONS.ACTION_PATIENT_VITALS_VIEW] ? access[ACTIONS.ACTION_PATIENT_VITALS_VIEW].roles.join() : null;
        vm.accessGlucoseView = access[ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW] ? access[ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW].roles.join() : null;
        vm.accessWeightView = access[ACTIONS.ACTION_PATIENT_WEIGHT_VIEW] ? access[ACTIONS.ACTION_PATIENT_WEIGHT_VIEW].roles.join() : null;
        vm.accessAlcoholView = access[ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW] ? access[ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW].roles.join() : null;
        vm.accessDrugsView = access[ACTIONS.ACTION_PATIENT_DRUGS_VIEW] ? access[ACTIONS.ACTION_PATIENT_DRUGS_VIEW].roles.join() : null;
        vm.accessFileView = access[ACTIONS.ACTION_PATIENT_FILE_VIEW] ? access[ACTIONS.ACTION_PATIENT_FILE_VIEW].roles.join() : null;
        vm.accessChartNoteView = access[ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW] ? access[ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW].roles.join() : null;
        vm.accessConcurrentReviewView = access[ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW] ? access[ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW].roles.join() : null;
        vm.accessVerifytxView = access[ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW] ? access[ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW].roles.join() : null;
        vm.accessLevelCareHistory = access[ACTIONS.ACTION_PATIENT_CHART_LEVEL_CARE_HISTORY] ? access[ACTIONS.ACTION_PATIENT_CHART_LEVEL_CARE_HISTORY].roles.join() : null;
        vm.accessDischargeHistory = access[ACTIONS.ACTION_PATIENT_CHART_DISCHARGE_HISTORY] ? access[ACTIONS.ACTION_PATIENT_CHART_DISCHARGE_HISTORY].roles.join() : null;
        vm.accessTrackHistory = access[ACTIONS.ACTION_PATIENT_CHART_TRACK_HISTORY] ? access[ACTIONS.ACTION_PATIENT_CHART_TRACK_HISTORY].roles.join() : null;
        vm.accessDiagnosesView = access[ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW] ? access[ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW].roles.join() : null;
        vm.accessLabOrdersView = access[ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW] ? access[ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW].roles.join() : null;
        vm.accessELabsView = access[ACTIONS.ACTION_PATIENT_ELABS_VIEW] ? access[ACTIONS.ACTION_PATIENT_ELABS_VIEW].roles.join() : null;
        vm.accessGroupSessionView = access[ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW] ? access[ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW].roles.join() : null;
        vm.accessEvaluationView = access[ACTIONS.ACTION_PATIENT_EVALUATION_VIEW] ? access[ACTIONS.ACTION_PATIENT_EVALUATION_VIEW].roles.join() : null;
        vm.accessMedicationView = access[ACTIONS.ACTION_PATIENT_MEDICATION_VIEW] ? access[ACTIONS.ACTION_PATIENT_MEDICATION_VIEW].roles.join() : null;
        vm.active = 0;

        if (params.tabId) {
            if (parseInt(params.tabId) === TAB.RCOPIA) {
                vm.activeTab = vm.chart.rcopiaId ? TAB.BASIC_INFORMATION : parseInt(params.tabId);
            } else {
                vm.activeTab = parseInt(params.tabId);
            }
        } else {
            vm.activeTab = TAB.BASIC_INFORMATION;
        }

        // vm.activeTab = params.tabId ? parseInt(params.tabId) : TAB.BASIC_INFORMATION;
        vm.TAB = TAB;
        vm.corporation = CoreService.getCorporation();
        vm.rcopiaAccount = rcopiaAccount;

        vm.edit = edit;
        vm.changedChart = changedChart;
        vm.select = select;
        vm.addConcurrentReview = addConcurrentReview;
        vm.showLevelCareHistory = showLevelCareHistory;
        vm.showTrackHistory = showTrackHistory;
        vm.showDischargeDateHistory = showDischargeDateHistory;
        vm.showVerifyTxHistory = showVerifyTxHistory;
        vm.showConcurrentReviewHistory = showConcurrentReviewHistory;
        vm.verify = verify;
        vm.showVitalsHistory = showVitalsHistory;
        vm.showGlucoseHistory = showGlucoseHistory;
        vm.showWeightHistory = showWeightHistory;
        vm.showAlcoholHistory = showAlcoholHistory;
        vm.showDrugsHistory = showDrugsHistory;
        vm.showDiagnosesHistory = showDiagnosesHistory;
        vm.showAllergiesHistory = showAllergiesHistory;
        vm.showCareTeamHistory = showCareTeamHistory;
        vm.showDietsHistory = showDietsHistory;
        vm.showNotesHistory = showNotesHistory;
        vm.editImage = editImage;
        vm.editImageLicense = editImageLicense;
        vm.viewImageLicense = viewImageLicense;
        vm.checkField = checkField;
        vm.reload = reload;

        function changedChart() {
            $state.go('chart-new', {id: vm.chartSelected.id});
        }

        Chart.previousCharts({id: vm.chart.id}, function (result) {
            var orderedResult = _.orderBy(result, function (item) {
                return moment(item.admissionDate)
            }, ['desc'])
            vm.previousCharts = _.map(orderedResult, function (item) {
                return {
                    id: item.id,
                    field: item.mrNo + ' - ' + (moment(item.admissionDate).format($rootScope.amDateFormat))
                }
            })
        });

        ChartPictureLicense.getOneByChart({id: vm.chart.id}, function (result) {
            vm.chartPictureLicense = result;
        });

        function viewImageLicense() {
            ChartPictureLicense.getCroppedImageByChart({id: vm.chart.id}, function (picture) {
                if (picture) {
                    fancyboxService.fancyboxPlus()({
                        'href': picture.image,
                        'title': 'License Picture',
                        'transitionIn': 'fade',
                        'transitionOut': 'elastic'
                    });
                }
            })
        }

        function editImage() {
            ChartPicture.getOriginalBase64ByChart({id: vm.chart.id}, function (result) {
                openCropImagePopup(result);
            }, function () {
                openCropImagePopup(null);
            });
        }

        function editImageLicense() {
            ChartPictureLicense.getOriginalBase64ByChart({id: vm.chart.id}, function (result) {
                openCropImageLicensePopup(result);
            }, function () {
                openCropImageLicensePopup(null);
            });
        }

        function openCropImagePopup(result) {
            PopupService.showCropImageChartPopup(result).result.then(function (error) {
            }, function (data) {
                if (data) {
                    ChartPicture.create({
                        chartId: vm.chart.id,
                        cropped: data.cropped,
                        image: data.image
                    }, function () {
                        $state.reload();
                    });
                }
            });
        }

        function openCropImageLicensePopup(result) {
            PopupService.showCropImageLicensePopup(result).result.then(function (error) {
            }, function (data) {
                if (data) {
                    ChartPictureLicense.create({
                        chartId: vm.chart.id,
                        cropped: data.cropped,
                        image: data.image
                    }, function () {
                        $state.reload();
                    });
                }
            });
        }

        function edit() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/chart/update/chart-dialog.html',
                controller: 'ChartDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: chart.id}).$promise;
                    }]
                }
            }).result.then(function () {
                $state.reload();
            });
        }

        function select(index) {
            $uibModalStack.dismissAll();

            $rootScope.$broadcast('bluebookApp:chartDetailActiveTab', index);

            $location.search('tabId', index);
        }

        function addConcurrentReview() {
            $uibModalStack.dismissAll();

            $rootScope.$broadcast('bluebookApp:chartDetailAddConcurrentReview');
        }

        function verify() {
            $uibModalStack.dismissAll();

            $rootScope.$broadcast('bluebookApp:chartDetailVerify');
        }

        function showLevelCareHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/type-level-care/chart/new/type-level-care-history.html',
                controller: 'TypeLevelCareHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showTrackHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/track/chart/new/track-history.html',
                controller: 'TrackHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showDischargeDateHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/chart/discharge-date-history/new/chart-discharge-date-history-new.html',
                controller: 'ChartDischargeDateHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showVerifyTxHistory() {
            $uibModalStack.dismissAll();

            $rootScope.$broadcast('bluebookApp:chartDetailVerifyTxHistory');
        }

        function showConcurrentReviewHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/concurrent-reviews/chart-new/concurrent-reviews-history.html',
                controller: 'ConcurrentReviewsHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showCareTeamHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/chart-care-team/history/chart-care-team-history.html',
                controller: 'ChartCareTeamHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showDietsHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/diet/history/diet-history.html',
                controller: 'DietHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showNotesHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/chart-note/history/chart-note-history.html',
                controller: 'ChartNoteHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showVitalsHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/vitals/history/vitals.html',
                controller: 'VitalsController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles modal-bottom-xl',
                animation: false,
                resolve: {
                    chart: chart
                }
            });
        }

        function showGlucoseHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/glucose/history/glucose-history.html',
                controller: 'GlucoseHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles modal-bottom-xl',
                animation: false,
                resolve: {
                    chart: chart
                }
            });
        }

        function showWeightHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/weight/history/weight.html',
                controller: 'WeightController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles modal-bottom-xl',
                animation: false,
                resolve: {
                    chart: chart
                }
            });
        }

        function showAlcoholHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/alcohol/history/alcohol.html',
                controller: 'AlcoholController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles modal-bottom-xl',
                animation: false,
                resolve: {
                    chart: chart
                }
            });
        }

        function showDrugsHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/drug/history/drug-history.html',
                controller: 'DrugHistoryController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom-xl',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showDiagnosesHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/diagnoses/history/diagnoses-history.html',
                controller: 'DiagnosesHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        function showAllergiesHistory() {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/allergies/history/allergies-history.html',
                controller: 'AllergiesHistoryNewController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        }

        var unsubscribe = $rootScope.$on('bluebookApp:closeChart', function (event, result) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/chart-status-history/chart-new/chart-status-histories-dialog-close-new.html',
                controller: 'ChartStatusHistoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    entity: function () {
                        return {
                            status: 'CLOSED',
                            description: null,
                            date: null,
                            id: null
                        };
                    },
                    chart: vm.chart
                }
            }).result.then(function () {
                $state.reload();
            })
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:setToCurrent', function (event, result) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/chart-status-history/chart-new/chart-status-histories-dialog-current-new.html',
                controller: 'ChartStatusHistoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    entity: function () {
                        return {
                            status: 'CURRENT',
                            description: null,
                            date: null,
                            id: null
                        };
                    },
                    chart: vm.chart
                }
            }).result.then(function () {
                $state.reload();
            })
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:reopenChart', function (event, result) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/chart-status-history/chart-new/chart-status-histories-dialog-reopen-new.html',
                controller: 'ChartStatusHistoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    entity: function () {
                        return {
                            status: 'REOPEN',
                            description: null,
                            date: null,
                            id: null
                        };
                    },
                    chart: vm.chart
                }
            }).result.then(function () {
                $state.reload();
            })
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:copyChart', function (event, result) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/chart/copy/chart-copy-dialog.html',
                controller: 'ChartCopyController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'md',
                resolve: {
                    chart: vm.chart
                }
            }).result.then(function (facility) {
                PopupService.showCreatePatientPopup(vm.chart, facility).result.then(function (result) {
                    CoreService.setCurrentFacility(facility);
                    $state.transitionTo('chart', {id: result.id}, {
                        location: true,
                        inherit: true,
                        notify: true,
                        reload: true
                    });
                });
            });
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:chartExport', function (event, result) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/facesheet-tpl/chart-report/new/facesheet-tpl-report.html',
                controller: 'FacesheetTplReportController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'lg',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                resolve: {
                    chart: vm.chart
                }
            });
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:foodMemo', function (event, result) {
            $uibModalStack.dismissAll();
            ChartPicture.getCroppedImageByChart({id: chart.id}, function (result) {
                createFoodMemo(result.image);
            }, function () {
                createFoodMemo(CoreService.patientPictureDefault().picture);
            });

        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:blueAlerts', function (event, result) {
            $uibModalStack.dismissAll();
            $uibModal.open({
                templateUrl: 'app/entities/urgent-issues/chart/new/history/urgent-issues-history-dialog.html',
                controller: 'UrgentIssuesHistoryDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles modal-bottom',
                animation: false,
                size: 'lg',
                resolve: {
                    chart: vm.chart
                }
            })
        });

        $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:deleteChart', function (event, result) {
            $uibModalStack.dismissAll();
            del();
        });

        $scope.$on('$destroy', unsubscribe);

        // unsubscribe = $rootScope.$on('bluebookApp:RcopiaUpdatePatient', function (event, result) {
        //     $uibModalStack.dismissAll();
        //
        //     Rcopia.updatePatient({id: chart.id}, function () {
        //         $state.reload();
        //     }, function () {
        //         toastr.error('Something went wrong', 'Error');
        //     });
        // });

        // $scope.$on('$destroy', unsubscribe);
        //
        // unsubscribe = $rootScope.$on('bluebookApp:RcopiaUpdatePatient', function (event, result) {
        //     $uibModalStack.dismissAll();
        //
        //     Rcopia.updatePatient({id: chart.id}, function () {
        //         $state.reload();
        //     }, function () {
        //         toastr.error('Something went wrong', 'Error');
        //     });
        // });

        // $scope.$on('$destroy', unsubscribe);

        unsubscribe = $rootScope.$on('bluebookApp:RcopiaUpdatePatient', function (event, result) {
            reload();
        });

        $scope.$on('$destroy', unsubscribe);

        function checkField(field) {
            return CoreService.enableByFacilityType(vm.chart.facility, field);
        }

        function createFoodMemo(pictureRef) {
            var dd = {
                content: [
                    {text: 'Food Memo', style: 'header', margin: [ 0, 0, 0, 10 ], alignment: 'center'},
                    {text: 'Patient special dietary', style: 'subheader', margin: [ 0, 0, 0, 20 ], alignment: 'center'},
                    {
                        style: 'tableExample',
                        table: {
                            columnGap: 10,
                            heights: 40,
                            body: [
                                [
                                    {image: pictureRef, alignment: 'center', width: 150, height: 150},
                                    [
                                        [
                                            {
                                                text: 'Name: ',
                                                style: 'tableHeader',
                                                margin: [ 5, 0, 5, 10 ]
                                            },
                                            {
                                                text: vm.chart.lastName + ", " + vm.chart.firstName,
                                                margin: [ 5, 0, 5, 10 ]
                                            }
                                        ],
                                        [
                                            [
                                                {
                                                    text: 'MR Number: ',
                                                    style: 'tableHeader',
                                                    margin: [ 5, 0, 5, 10 ]
                                                },
                                                {
                                                    text: vm.chart.mrNo,
                                                    margin: [ 5, 0, 5, 10 ]
                                                }
                                            ]
                                        ]
                                    ],
                                ]
                            ]
                        }, layout: 'noBorders'
                    }
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        alignment: 'justify'
                    },
                    subheader: {
                        fontSize: 15,
                        bold: true
                    },
                    small: {
                        fontSize: 8
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black',
                        padding: 25
                    }
                }
            };

            var foodAllergies = {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: ['*'],
                    body: []
                },
                // alignment: 'center',
                layout: 'noBorders'
            }

            var activeDiets = {
                style: 'tableExample',
                table: {
                    headerRows: 1,
                    widths: ['*'],
                    body: []
                },
                // alignment: 'center',
                layout: 'noBorders'
            }

            Allergies.findAllAllergiesByChart({id: chart.id, allergenType: 'Food'}, function (result) {
                vm.allergies = result;
                foodAllergies.table.body.push([{
                    text: 'Food Allergies',
                    style: 'tableHeader',
                    decoration: 'underline'
                }]);
                for (var i = 0; i < vm.allergies.length; i++) {
                    foodAllergies.table.body.push([{text: vm.allergies[i].name}]);
                }
                if (vm.allergies.length) {
                    dd.content.push(foodAllergies);
                }

                Diet.findAllByChart({chartId: chart.id, active: true}, function (result) {
                    vm.diets = result;
                    activeDiets.table.body.push([{text: 'Diets', style: 'tableHeader', decoration: 'underline'}]);
                    for (var i = 0; i < vm.diets.length; i++) {
                        activeDiets.table.body.push([{text: vm.diets[i].typeFoodDiets.name}]);
                    }
                    if (vm.diets.length) {
                        dd.content.push(activeDiets);
                    }
                    if (vm.diets.length || vm.allergies.length) {
                        vm.pdf = pdfMake.createPdf(dd);
                        vm.pdf.print();
                    } else
                        alert("this patient does not have diet");
                });
            });
        }

        function del() {
            ConfirmationService.showDelete('Chart').result.then(function () {
                Chart.delete({id: vm.chart.id}, function () {
                    $state.go('charts');
                });
            })
        }

        function reload() {
            return Chart.get({id: vm.chart.id}, function (chart) {
                vm.chart = chart;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartsReferrerController', ChartsReferrerController);

    ChartsReferrerController.$inject = ['CoreService', 'Employee', '$state', 'Chart', '$rootScope', '$stateParams',
        'GenericEntityDatatableService', 'TypeLevelCare'];

    function ChartsReferrerController(CoreService, Employee, $state, Chart, $rootScope, $stateParams,
                                      GenericEntityDatatableService, TypeLevelCare) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Patient By Referral',
            entityClassHumanized: 'Patient By Referral',
            entityStateName: 'charts',
            service: Chart,
            serviceMethod: "fullFilter",
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[0, 'desc']]}
            ],
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    },
                    options: [{key: "width", value: "200px"}]
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY")
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: "width", value: "130px"}]
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return moment(data.admissionDate).format("MM/DD/YYYY");
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: 'Treatment Days',
                    render: function (data) {
                        return status == "ARCHIVE" || status == "CLOSED" ?
                            moment(data.dischargeDate).diff(moment(data.admissionDate), 'days') :
                            moment(new Date()).diff(moment(data.admissionDate), 'days');
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    title: 'Referral',
                    placeholder: 'Referral Source...',
                    render: function (data) {
                        return data.referrer ? data.referrer : "-"
                    }
                },
                {
                    name: null,
                    title: 'Outreach',
                    render: function (data) {
                        return data.marketerFirstName != null ? data.marketerLastName + ", " + data.marketerFirstName : " ";
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.id});
                    },
                })
            ],
            filters: [
                {
                    name: 'statuses',
                    defaultValue: function () {
                        return 'CURRENT';
                    },
                    visible: false
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: "marketerId",
                    read: function (filter) {
                        return filter.marketerId ? filter.marketerId.id : null;
                    },
                    values: [],
                    placeholder: 'Select outreach...',
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {
                            page: 0,
                            size: 20,
                            query: search,
                            facilityId: CoreService.getCurrentFacility().id
                        };

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    type: 'select',
                },
                {
                    name: 'typeLevelCareId',
                    read: function (filter) {
                        return filter.typeLevelCareId ? filter.typeLevelCareId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'referrer',
                    type: 'string',
                    defaultValue: function () {
                        return $stateParams.referrer != null ? $stateParams.referrer : null
                    }
                },
                {
                    name: 'admissionDateFrom',
                    // title: 'Day of Birth',
                    placeholder: 'From Admission Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                },
                {
                    name: 'admissionDateTo',
                    // title: 'Day of Birth',
                    placeholder: 'To Admission Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                }
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All',
                            iClass: 'fa fa-users',
                            ngClass: function (filter) {
                                return filter.status === null ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.status = null;
                            }
                        },
                        {
                            name: 'Current',
                            iClass: 'fa fa-dashboard',
                            ngClass: function (filter) {
                                return filter.status === 'CURRENT' ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.status = 'CURRENT';
                            },
                        },
                        {
                            name: 'Archive',
                            iClass: 'fa fa-archive',
                            ngClass: function (filter) {
                                return filter.status === 'ARCHIVE' ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.status = 'ARCHIVE';
                            },
                        }
                    ]
                }
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartsPayerController', ChartsPayerController);

    ChartsPayerController.$inject = ['Chart', 'CoreService', '$state', 'insCarrier', 'typePay', 'TypeLevelCare',
        '$rootScope', 'GenericEntityDatatableService'];

    function ChartsPayerController(Chart, CoreService, $state, insCarrier, typePay, TypeLevelCare,
                                   $rootScope, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        function getServiceMethod() {
            if (insCarrier != null) {
                return 'getAllChartsPayerInsurancePrimary'
            } else if (typePay != null) {
                return 'getAllChartsPayerNoInsurance'
            } else {
                return 'getAllChartsPayerInsuranceNoPrimary'
            }
        }

        vm.descriptor = {
            title: 'Payer Mix',
            entityClassHumanized: 'Payer Mix',
            entityStateName: 'charts',
            service: Chart,
            serviceMethod: getServiceMethod(),
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[0, 'desc']]}
            ],
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    },
                    options: [{key: "width", value: "200px"}]
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY")
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: "width", value: "130px"}]
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return moment(data.admissionDate).format("MM/DD/YYYY");
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    name: null,
                    title: "Insurance Carrier",
                    render: function (data) {
                        return data.primary == null ? " " : data.primary.insuranceCarrier.name;
                    }
                },
                {
                    name: null,
                    title: "Policy Number",
                    render: function (data) {
                        return data.primary == null ? " " : data.primary.policyNumber;
                    }
                },
                {
                    title: 'Referral',
                    render: function (data) {
                        return data.referrer ? data.referrer : "-";
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.id});
                    },
                })
            ],
            filters: [
                {
                    name: 'insCarrier',
                    visible: false,
                    read: function (){
                        return insCarrier ? insCarrier.id : null
                    }
                },
                {
                    name: 'typePay',
                    visible: false,
                    read: function () {
                        return typePay ? typePay.id: null;
                    }
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: 'typeLevelOfCareId',
                    read: function (filter) {
                        return filter.typeLevelOfCareId ? filter.typeLevelOfCareId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'startDate',
                    // title: 'Day of Birth',
                    placeholder: 'From Discharge Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                },
                {
                    name: 'endDate',
                    // title: 'Day of Birth',
                    placeholder: 'To Discharge Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                }
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartsMarketerController', ChartsMarketerController);

    ChartsMarketerController.$inject = ['$uibModal', '$q', 'CoreService', 'Employee', 'GUIUtils', '$state', 'marketer',
        '$rootScope', 'Chart', 'GenericEntityDatatableService', 'TypeLevelCare'];

    function ChartsMarketerController($uibModal, $q, CoreService, Employee, GUIUtils, $state, marketer,
                                      $rootScope, Chart, GenericEntityDatatableService, TypeLevelCare) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Patient by Outreach',
            entityClassHumanized: 'Patient by Outreach',
            entityStateName: 'charts',
            service: Chart,
            serviceMethod: "marketer",
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[0, 'desc']]}
            ],
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    },
                    options: [{key: "width", value: "200px"}]
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY")
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: "width", value: "130px"}]
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return moment(data.admissionDate).format("MM/DD/YYYY");
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: 'Treatment Days',
                    render: function (data) {
                        return status === "ARCHIVE" || status === "CLOSED" ?
                            moment(data.dischargeDate).diff(moment(data.admissionDate), 'days') :
                            moment(new Date()).diff(moment(data.admissionDate), 'days');
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    title: 'Referral',
                    render: function (data) {
                        return data.referrer ? data.referrer : '-'
                    }
                },
                {
                    name: null,
                    title: 'Outreach',
                    render: function (data) {
                        return data.marketer === null ? " " : data.marketer.lastName + ", " + data.marketer.firstName;
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.id});
                    },
                })
            ],
            filters: [
                {
                    name: 'statuses',
                    defaultValue: function () {
                        return 'CURRENT';
                    },
                    visible: false,
                    read: function (filter) {
                        if (filter.statuses === null) {
                            return ['CURRENT', 'ARCHIVE', 'CLOSED'];
                        } else if (filter.statuses === 'ARCHIVE') {
                            return ['ARCHIVE', 'CLOSED'];
                        } else return filter.statuses
                    }
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: "marketerId",
                    read: function (filter) {
                        return filter.marketerId ? filter.marketerId.id : null;
                    },
                    values: [],
                    placeholder: 'Select outreach...',
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {page: 0, size: 20, query: search, facilityId: CoreService.getCurrentFacility().id};

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    type: 'select',
                    defaultValue: function () {
                        return marketer;
                    }
                },
                {
                    name: 'typeLevelOfCareId',
                    read: function (filter) {
                        return filter.typeLevelOfCareId ? filter.typeLevelOfCareId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'referrer',
                    type: 'string',
                    placeholder: 'Referral Source...',
                },
                {
                    name: 'fromAdmissionDate',
                    // title: 'Day of Birth',
                    placeholder: 'From Admission Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                },
                {
                    name: 'toAdmissionDate',
                    // title: 'Day of Birth',
                    placeholder: 'To Admission Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                }
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'All',
                            iClass: 'fa fa-users',
                            ngClass: function (filter) {
                                return filter.statuses === null ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.statuses = null;
                            }
                        },
                        {
                            name: 'Current',
                            iClass: 'fa fa-dashboard',
                            ngClass: function (filter) {
                                return filter.statuses === 'CURRENT' ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.statuses = 'CURRENT';
                            },
                        },
                        {
                            name: 'Archive',
                            iClass: 'fa fa-archive',
                            ngClass: function (filter) {
                                return filter.statuses === 'ARCHIVE' ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                filter.statuses = 'ARCHIVE';
                            },
                        }
                    ]
                }
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartsDischargeController', ChartsDischargeController);

    ChartsDischargeController.$inject = ['CoreService', 'TypeDischargeType', '$state', 'dischargeType', '$rootScope',
        'Chart', 'GenericEntityDatatableService'];

    function ChartsDischargeController(CoreService, TypeDischargeType, $state, dischargeType, $rootScope,
                                       Chart, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Charts Discharge',
            entityClassHumanized: 'Charts Discharge',
            entityStateName: 'charts',
            service: Chart,
            serviceMethod: 'chartsDischarge',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[0, 'desc']]}
            ],
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    },
                    options: [{key: "width", value: "220px"}]
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY")
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: "width", value: "130px"}]
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return moment(data.admissionDate).format("MM/DD/YYYY");
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: 'Discharge Date',
                    render: function (data) {
                        return data.dischargeDate != null ? moment(data.dischargeDate).format($rootScope.dateFormat) : " ";
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: 'Discharge',
                    render: function (data) {
                        return data.typeDischargeType == null ? "" : data.typeDischargeType.name;
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: 'Treatment Days',
                    render: function (data) {
                        return moment(data.dischargeDate).diff(moment(data.admissionDate), 'days');
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    },
                    options: [{key: "width", value: "220px"}]
                },
                {
                    title: 'Referral',
                    options: [{key: "width", value: "220px"}],
                    render: function (data) {
                        return data.referrer ? data.referrer : "-"
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.id});
                    },
                }),
            ],
            filters: [
                {
                    name: 'typeDischargeId',
                    read: function (filter) {
                        return filter.typeDischargeId ? filter.typeDischargeId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeDischargeType.findAllByCorporation(CoreService.getFilterByCurrentCorporation(), function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    placeholder: 'Select discharge type...',
                    type: 'select',
                    defaultValue: function () {
                        return dischargeType;
                    },
                    ngClass: 'col-xs-12 col-sm-12 col-md-12 col-lg-12',
                },
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                },
                {
                    name: 'referrer',
                    type: 'string',
                    placeholder: 'Referral...',
                },
                {
                    name: 'dischargeDateFrom',
                    // title: 'Day of Birth',
                    placeholder: 'To Discharge Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true,
                    defaultValue: function () {
                        var now = new Date();
                        now.setDate(now.getDate() - 30);

                        return now;
                    }
                },
                {
                    name: 'dischargeDateTo',
                    // title: 'Day of Birth',
                    placeholder: 'From Discharge Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true,
                    defaultValue: function () {
                        return new Date();
                    }
                }
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartsCaseLoadController', ChartsCaseLoadController);

    ChartsCaseLoadController.$inject = ['$uibModal', 'ChartCareTeam', '$scope', '$q', 'facility', 'CoreService',
        'Employee', '$state', 'employee', 'Chart', '$rootScope', 'GenericEntityDatatableService',
        'TypeLevelCare'];

    function ChartsCaseLoadController($uibModal, ChartCareTeam, $scope, $q, facility, CoreService,
                                      Employee, $state, employee, Chart, $rootScope, GenericEntityDatatableService,
                                      TypeLevelCare) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
            chartStatus: 'CURRENT'
        }

        vm.descriptor = {
            title: 'Patient by Care Team',
            entityClassHumanized: 'Patient by Care Team',
            entityStateName: 'charts',
            service: ChartCareTeam,
            serviceMethod: "getAllByFilter",
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[0, 'desc']]}
            ],
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return  data.chart.firstName + (data.middleInitial ? " " + data.middleInitial : " ") + data.chart.lastName;
                    },
                    options: [{key: "width", value: "200px"}]
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.chart.dateBirth).format("MM/DD/YYYY")
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: 'chart.mrNo',
                    title: "Mr Number",
                    options: [{key: "width", value: "130px"}],
                    render: function (data) {
                        return data.chart.mrNo;
                    },
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return data.chart.admissionDate ? moment(data.chart.admissionDate).format("MM/DD/YYYY") : "";
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: 'Treatment Days',
                    render: function (data) {
                        return status == "ARCHIVE" || status == "CLOSED" ?
                            moment(data.chart.dischargeDate).diff(moment(data.chart.admissionDate), 'days') :
                            moment(new Date()).diff(moment(data.chart.admissionDate), 'days');
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.chart.typeLevelCare == null ? " " : data.chart.typeLevelCare.name;
                    }
                },
                {
                    title: 'Referral',
                    render: function (data) {
                        return data.chart.referrer ? data.chart.referrer : "-";
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.chart.id});
                    },
                })
            ],
            filters: [
                {
                    name: 'chartId',
                    read: function (filter) {
                        return filter.chartId ? filter.chartId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    getSmallDisplayValue: function (entity) {
                        return '<strong>DOB: </strong>' + moment(entity.dateBirth).format("MM/DD/YYYY") + ' <strong>MrNo:</strong> ' + entity.mrNo;
                    },
                    refresh: function (search, values) {
                        Chart.fullFilter(
                            {
                                page: 0,
                                size: 20,
                                facilityId: CoreService.getCurrentFacility().id,
                                searchQuery: search,
                                statuses: ['CURRENT', 'ARCHIVE']
                            }, function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Select patient ...',
                    type: 'select',
                    visible: true
                },
                {
                    name: "employeeId",
                    read: function (filter) {
                        return filter.employeeId ? filter.employeeId.id : null;
                    },
                    values: [],
                    placeholder: 'Select employee...',
                    getDisplayValue: function (entity) {
                        return entity ? entity.firstName + ' ' + entity.lastName : "";
                    },
                    refresh: function (search, values) {
                        var filter = {page: 0, size: 20, query: search, facilityId: CoreService.getCurrentFacility().id};

                        Employee.findAllByFilter(filter, function (result) {
                            values.length = 0;
                            values.push(...result);
                        });
                    },
                    type: 'select',
                    defaultValue: function () {
                        return employee;
                    }
                },
                {
                    name: 'typeLevelOfCareId',
                    read: function (filter) {
                        return filter.typeLevelOfCareId ? filter.typeLevelOfCareId.id : null;
                    },
                    values: [],
                    getDisplayValue: function (entity) {
                        return entity ? entity.name : "";
                    },
                    refresh: function (search, values) {
                        TypeLevelCare.findAllByFacility(
                            CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                                values.length = 0;
                                values.push(...result);
                            });
                    },
                    placeholder: 'Level of Care ...',
                    type: 'select',
                },
                {
                    name: 'referral',
                    type: 'string',
                    placeholder: 'Referral Source...',
                },
                {
                    name: 'fromAdmissionDate',
                    // title: 'Day of Birth',
                    placeholder: 'From Admission Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                },
                {
                    name: 'toAdmissionDate',
                    // title: 'Day of Birth',
                    placeholder: 'To Admission Date...',
                    type: 'date',
                    format: $rootScope.inputDateFormat,
                    visible: true
                }
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartReviewController', ChartReviewController);

    ChartReviewController.$inject = ['facility', 'Chart', '$q', '$scope', 'CoreService', 'GUIUtils', '$state',
        '$uibModal', 'GenericEntityDatatableService'];

    function ChartReviewController(facility, Chart, $q, $scope, CoreService, GUIUtils, $state,
                                   $uibModal, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id,
        }

        vm.descriptor = {
            title: 'Chart Review - Diagnosis',
            entityClassHumanized: 'Chart Review - Diagnosis',
            entityStateName: 'charts-review',
            service: Chart,
            serviceMethod: 'withoutDiagnosis',
            params: params,
            pagination: 'remote',
            newAction: false,
            options: [
                {key: 'aaSorting', value: [[0, 'desc']]}
            ],
            columns: [
                {
                    name: 'patientName',
                    title: 'Patient Name',
                    render: function (data) {
                        return data.firstName + ' ' + data.lastName;
                    },
                    options: [{key: "width", value: "200px"}]
                },
                {
                    name: 'dob',
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dateBirth).format("MM/DD/YYYY")
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: 'mrNo',
                    title: "Mr Number",
                    options: [{key: "width", value: "130px"}]
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return moment(data.admissionDate).format("MM/DD/YYYY");
                    },
                    options: [{key: "width", value: "120px"}]
                },
                {
                    name: null,
                    title: "LOC",
                    render: function (data) {
                        return data.typeLevelCare == null ? " " : data.typeLevelCare.name;
                    }
                },
                {
                    title: 'Referral',
                    render: function (data) {
                        return data.referrer ? data.referrer : "-";
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getViewChartAction(), {
                    action: function (data) {
                        $state.go('chart', {id: data.id});
                    },
                }),
                angular.extend({}, GenericEntityDatatableService.getCareTeamAction(), {
                    name: "New Care Team Member",
                    action: function (data) {
                        return addCareTeam(data.id);
                    },
                    ngIf: function () {
                        return vm.descriptor.serviceMethod === 'withoutCareTeam';
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getInsuranceAction(), {
                    name: "New Insurance",
                    action: function (data) {
                        return addInsurance(data.id);
                    },
                    ngIf: function () {
                        return vm.descriptor.serviceMethod === 'withoutInsurance';
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDiagnosisAction(), {
                    name: "New Diagnoses",
                    action: function (data) {
                        return addDiagnosis(data.id);
                    },
                    ngIf: function () {
                        return vm.descriptor.serviceMethod === 'withoutDiagnosis';
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        {
                            name: 'Diagnosis',
                            iClass: 'fa fa-ambulance',
                            ngClass: function (filter) {
                                return vm.descriptor.serviceMethod === "withoutDiagnosis" ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.descriptor.title = 'Chart Review - Diagnosis';
                                vm.descriptor.serviceMethod = "withoutDiagnosis";
                            }
                        },
                        {
                            name: 'Insurance',
                            iClass: 'fa fa-id-card',
                            ngClass: function (filter) {
                                return vm.descriptor.serviceMethod === "withoutInsurance" ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter) {
                                vm.descriptor.title = 'Chart Review - Insurance';
                                vm.descriptor.serviceMethod = "withoutInsurance";
                            },
                        },
                        {
                            name: 'Care Team',
                            iClass: 'fa fa-user-md',
                            ngClass: function (filter) {
                                return vm.descriptor.serviceMethod === "withoutCareTeam" ?
                                    ['active', 'label-success'] :
                                    [];
                            },
                            action: function (filter, selected) {
                                vm.descriptor.title = 'Chart Review - Care Team'
                                vm.descriptor.serviceMethod = "withoutCareTeam";
                            }
                        }
                    ],
                },
            ],
        }

        function addCareTeam(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/chart-care-team/chart-care-team-dialog.html',
                    controller: 'ChartCareTeamDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowTopClass: 'custom-dialog-styles',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                allergen: null,
                                allergen_type: null,
                                reaction: null,
                                treatment: null,
                                status: null,
                                id: null,
                                endDate: null,
                                startDate: null,
                                chart: Chart.get({id: id})
                            };
                        }
                    }
                }).result.then(function () {
                    resolve();
                })
            })
        }

        function addInsurance(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/insurance/update/insurance-dialog.html',
                    controller: 'InsuranceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowTopClass: 'custom-dialog-styles',
                    size: 'xl',
                    resolve: {
                        entity: function () {
                            return {
                                address: null,
                                address2: null,
                                zipCode: null,
                                city: null,
                                policyNumber: null,
                                groupNumber: null,
                                groupName: null,
                                planNumber: null,
                                lastName: null,
                                firstName: null,
                                middleInitial: null,
                                dob: null,
                                gender: null,
                                phone: null,
                                employer: null,
                                insuranceOrder: 1,
                                id: null,
                                chart: Chart.get({id: id})
                            };
                        },
                        chart: Chart.get({id: id}).$promise
                    }
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function addDiagnosis(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/diagnoses/update/diagnoses-dialog.html',
                    controller: 'DiagnosesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: function () {
                            return {
                                comment: null,
                                id: null,
                                endDate: null,
                                startDate: null,
                                chart: Chart.get({id: id})
                            };
                        }
                    }
                }).result.then(function () {
                    resolve();
                })
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('ChartCreateDialogController', ChartCreateDialogController);

    ChartCreateDialogController.$inject = ['$uibModalInstance', 'facility', 'chart', 'ParseLinks',
        'CoreService', 'CountryState', 'filter', 'DateUtils', 'Insurance', 'TypeLevelCare', 'Bed',
        'TypePaymentMethods', 'TypeMaritalStatus', 'TypeRace', 'TypeEthnicity', 'GUIUtils',
        'ContactsFacility', 'TypeDischargeType', 'WizardHandler', 'InsuranceCarrier',
        'InsuranceType', 'InsuranceRelation', 'InsuranceCarrierSearch', 'AlertService', 'Chart',
        'Employee', '$state', 'Track', 'copyChart', 'InsurancePicture', 'InsuranceBackPicture',
        'ChartPictureLicense', 'ChartPicture', 'Pharmacy', 'FacilityPharmacy'];

    function ChartCreateDialogController($uibModalInstance, facility, chart, ParseLinks, CoreService,
                                         CountryState, filter, DateUtils, Insurance, TypeLevelCare, Bed,
                                         TypePaymentMethods, TypeMaritalStatus, TypeRace, TypeEthnicity, GUIUtils,
                                         ContactsFacility, TypeDischargeType, WizardHandler, InsuranceCarrier,
                                         InsuranceType, InsuranceRelation, InsuranceCarrierSearch, AlertService, Chart,
                                         Employee, $state, Track, copyChart, InsurancePicture, InsuranceBackPicture,
                                         ChartPictureLicense, ChartPicture, Pharmacy, FacilityPharmacy) {

        var vm = this;

        vm.loadBeds = loadBeds;
        vm.getContactsFacility = getContactsFacility;
        vm.getInsuranceCarrier = getInsuranceCarrier;
        vm.finishedWizard = finishedWizard;
        vm.cancelledWizard = cancelledWizard;
        vm.cancel = cancel;
        vm.save = save;
        vm.isLastStep = isLastStep;
        vm.openCalendar = openCalendar;
        vm.getFilter = getFilter;
        vm.searchByFilter = searchByFilter;
        vm.clearFilter = clearFilter;
        vm.next = next;
        vm.activateLeftArrow = activateLeftArrow;
        vm.activateStep = activateStep;
        vm.loadChart = loadChart;
        vm.disableWizard = disableWizard;
        vm.clearPrimaryInsurance = clearPrimaryInsurance;
        vm.removeSecondaryInsurance = removeSecondaryInsurance;
        vm.addSecondaryInsurance = addSecondaryInsurance;
        vm.setValidationClass = setValidationClass;
        vm.carrierTagTransform = carrierTagTransform;
        vm.filterTracks = filterTracks;
        vm.checkField = checkField;
        vm.getMarketers = getMarketers;
        vm.getAdmissionReps = getAdmissionReps;
        vm.getPharmacies = getPharmacies;

        init();

        function init() {
            vm.data = null;
            vm.copyChart = copyChart;
            vm.typeLevelCare = [];
            vm.paymentMethod = [];

            vm.facility = facility;
            vm.filter = filter;
            vm.filterTpl = angular.copy(filter);

            vm.corporation = CoreService.getCorporation();

            vm.page = 1;
            vm.charts = [];
            vm.countChartsByFacilities = [];
            vm.itemsPerPage = 5;

            vm.patientPictureDefault = CoreService.patientPictureDefault();
            vm.genericCardImageFront = CoreService.insuranceFrontPictureDefault();
            vm.genericCardImageBack = CoreService.insuranceBackPictureDefault();

            vm.carriers = [];

            vm.datePickerOpenStatus = {
                admissionDate: false,
                dateBirth: false
            }
            vm.admissionDate = {};
            vm.birthDateOptions = {
                maxDate: new Date(),
                minDate: new Date(1900, 1, 1)
            };

            vm.disabled = true;
            vm.showChartList = false;
            vm.allowEditBasicInfo = true;

            vm.getMarketers();
            vm.getAdmissionReps();

            TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                vm.typeLevelCare = result;

                if (copyChart && copyChart.typeLevelCare) {
                    var typeLevelCare = _.filter(vm.typeLevelCare, {name: copyChart.typeLevelCare.name});
                    vm.chart.typeLevelCare = typeLevelCare && typeLevelCare.length > 0 ? typeLevelCare[0] : null;
                }
            });
            vm.gender = GUIUtils.getGender();
            vm.race = TypeRace.byCorporation(CoreService.getFilterByCurrentCorporation());
            vm.ethnicity = TypeEthnicity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
            vm.maritalStatus = TypeMaritalStatus.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
            TypePaymentMethods.byFacility(CoreService.getFilterByFacility(vm.facility), function (result) {
                vm.paymentMethod = result;

                if (copyChart && copyChart.typePaymentMethods) {
                    var paymentMethod = _.filter(vm.paymentMethod, {name: copyChart.typePaymentMethods.name});
                    vm.chart.typePaymentMethods = paymentMethod && paymentMethod.length > 0 ? paymentMethod[0] : null;
                }
            });
            vm.insuranceCarriers = [];
            vm.insuranceTypes = InsuranceType.byCorporation(CoreService.getFilterByCurrentCorporation());
            vm.insuranceRelations = InsuranceRelation.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
            vm.states = CountryState.query();
            vm.typeDischargeType = TypeDischargeType.findAllByCorporation(CoreService.getFilterByCurrentCorporation());

            if (copyChart) {
                loadChart(copyChart.id);
            }
            vm.pharmacies = getPharmacies();

        }

        function loadChart(id) {
            vm.chart = {
                allowReadmit: true,
                admissionDate: new Date(),
                status: 'WAITING',
                facility: facility
            }

            vm.allowEditBasicInfo = true;

            if (id) {
                Chart.get({id: id}, function (data) {
                    vm.data = data;
                    vm.allowEditBasicInfo = false;
                    vm.disabled = data.typePaymentMethods == null || data.typePaymentMethods.category !== 'Insurance';

                    vm.chart.firstName = data.firstName;
                    vm.chart.lastName = data.lastName;
                    vm.chart.middleName = data.middleName;
                    vm.chart.preferredName = data.preferredName;
                    vm.chart.sex = data.sex;
                    vm.chart.typeRace = data.typeRace;
                    vm.chart.social = data.social;
                    vm.chart.dateBirth = data.dateBirth;
                    vm.chart.sobrietyDate = data.sobrietyDate;
                    vm.chart.firstContactName = data.firstContactName;
                    vm.chart.firstContactPhone = data.firstContactPhone;
                    vm.chart.firstContactRelationship = data.firstContactRelationship;
                    vm.chart.typeLevelCare = data.typeLevelCare;
                    vm.chart.dateFirstContact = data.dateFirstContact;
                    vm.chart.dateBirth = data.dateBirth;
                    vm.chart.oneTimeOnly = data.oneTimeOnly;
                    vm.chart.externalId = data.externalId;
                    vm.chart.address = data.address;
                    vm.chart.addressTwo = data.addressTwo;
                    vm.chart.city = data.city;
                    vm.chart.countryState = data.countryState;
                    vm.chart.zip = data.zip;
                    vm.chart.phone = data.phone;
                    vm.chart.altPhone = data.altPhone;
                    vm.chart.email = data.email;
                    vm.chart.typePaymentMethods = data.typePaymentMethods;
                    vm.chart.typeEthnicity = data.typeEthnicity;
                    vm.chart.typeMaritalStatus = data.typeMaritalStatus;
                    vm.chart.referrer = data.referrer;
                    vm.chart.dischargeDate = null;
                    vm.chart.dischargeTo = null;
                    vm.chart.typeDischargeType = null;
                    vm.chart.occupancy = data.occupancy;
                    vm.chart.employer = data.employer;
                    vm.chart.refererRequireContact = data.refererRequireContact;
                    vm.chart.sobriety = data.sobriety;
                    vm.chart.employerPhone = data.employerPhone;
                    vm.chart.patientId = copyChart ? null : data.patientId;
                    vm.chart.defaultPharmacy = copyChart ? null : data.defaultPharmacy;

                    loadPictures(data);

                    loadInsurances(data);

                    loadBeds();
                }, function (error) {
                    AlertService.error(error.data.message);
                });
            }
        }

        function getPharmacies(query) {
            if (query && query.length > 2) {
                Pharmacy.findAllByFilter({searchQuery: query}, function (result) {
                    vm.pharmacies = result;
                });
            } else {
                FacilityPharmacy.findAllByFilter({facilityId: CoreService.getCurrentFacility().id}, function (result) {
                    vm.pharmacies = [];
                        result.forEach((fP => {
                            vm.pharmacies.push(fP.pharmacy)
                        }))
                });
            }
        }

        function save() {
            vm.isSaving = true;

            if (vm.chart.primary) {
                vm.chart.primary.insuranceOrder = 1;
            }

            if (vm.chart.secondary) {
                vm.chart.secondary.insuranceOrder = 2;
            }

            Chart.create(vm.chart,
                function (result) {
                    $uibModalInstance.close(result);
                }, function () {
                    vm.isSaving = false;
                });
        }

        function disableWizard() {
            vm.disabled = vm.chart.typePaymentMethods == null || vm.chart.typePaymentMethods.category !== 'Insurance';

            if (vm.disabled) {
                vm.chart.primary = null;
                vm.chart.secondary = null;
            }

            return vm.disabled;
        }

        function loadBeds() {
            Bed.findAllActive({gender: vm.chart.sex, id: vm.facility.id}, function (result) {
                if (result) {
                    vm.beds = result;
                }
            });
        }

        function getContactsFacility(query) {
            var filter = {page: 0, size: 10, searchQuery: query, facilityId: vm.facility.id};

            return ContactsFacility.filter(filter).$promise;
        }

        function getInsuranceCarrier(query) {
            if (query) {
                if (query.length > 2) {
                    query = _.lowerCase(query);
                    InsuranceCarrierSearch.query({
                        query: query
                    }, function (result) {
                        if (result.length == 0) {
                            vm.carriers = [carrierTagTransform(query)];
                        } else {
                            vm.carriers = result;
                        }
                    });
                }
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function finishedWizard() {

        }

        function cancelledWizard() {

        }

        function isLastStep() {
            var totalSteps = WizardHandler.wizard('createChartWizard').totalStepCount(),
                currentStep = WizardHandler.wizard('createChartWizard').currentStepNumber();
            return totalSteps == currentStep;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function searchByFilter() {
            vm.page = 1;
            vm.getFilter();
            countByFilter();
        }

        function countByFilter() {
            var filter = angular.copy(vm.filter);

            vm.countFilterStr = "";

            if ((!filter.firstName || filter.firstName === '') &&
                (!filter.middleName || filter.middleName === '') &&
                (!filter.lastName || filter.lastName === '') &&
                (!filter.preferredName || filter.preferredName === '') &&
                (!filter.social || filter.social === '') &&
                (!filter.dob || filter.dob === '')) {
                return;
            }

            filter.statuses = ['CURRENT', 'ARCHIVE', 'CLOSED'];
            filter.corporationId = vm.corporation.id;

            vm.showChartList = true;

            if (filter.dob) {
                filter.dob = DateUtils.convertLocalDateToServer(filter.dob);
            } else {
                checkVoidParam(filter.dob);
            }

            checkVoidParam(filter.firstName);
            checkVoidParam(filter.middleName);
            checkVoidParam(filter.lastName);
            checkVoidParam(filter.preferredName);
            checkVoidParam(filter.social);

            Chart.countByFacilities(filter, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.countChartsByFacilities = data;
                var total = 0;
                if (vm.countChartsByFacilities.length > 0) {
                    vm.countFilterStr +=
                        _.join(
                            _.map(vm.countChartsByFacilities, function (counter) {
                                total += counter.count;
                                return counter.count + " in " + counter.name;
                            }), ', ');
                    vm.countFilterStr = "Found " + total + " patients matching this criteria (" + vm.countFilterStr;
                    vm.countFilterStr += "). Please see the list below for the once in this facility.";
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clearFilter() {
            vm.filter = angular.copy(vm.filterTpl);
        }

        function getFilter() {
            var filter = angular.copy(vm.filter);

            filter.statuses = ['ARCHIVE', 'CLOSED'];
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.facilityId = vm.facility.id;

            vm.showChartList = true;

            if (filter.dob) {
                filter.dob = DateUtils.convertLocalDateToServer(filter.dob);
            } else {
                checkVoidParam(filter.dob);
            }

            checkVoidParam(filter.firstName);
            checkVoidParam(filter.middleName);
            checkVoidParam(filter.lastName);
            checkVoidParam(filter.preferredName);
            checkVoidParam(filter.social);

            Chart.filterLastClosedOrArchive(filter, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.charts = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function checkVoidParam(param) {
            if (!param || param === '') {
                param = null;
            }
        }

        function activateStep(item) {
            if (item == null) {
                loadChart();
                WizardHandler.wizard('createChartWizard').next();
            } else if (!item.allowReadmit) {
                WizardHandler.wizard('createChartWizard').cancel();
            } else {
                vm.loadChart(item.id);
                WizardHandler.wizard('createChartWizard').next();
            }
        }

        function next(value) {
            if (value == 0) {
                vm.page++;
                vm.getFilter();
            } else {
                vm.page--;
                vm.getFilter();
            }
        }

        function activateLeftArrow() {
            return vm.totalItems / vm.itemsPerPage > vm.page
        }

        function loadInsurancePrimaryPictures(insuranceId) {
            InsurancePicture.getOriginalBase64ByInsurance({id: insuranceId}, function (result) {
                vm.chart.primaryInsuranceFrontPictureOriginal = result.image;
            });

            InsuranceBackPicture.getOriginalBase64ByInsurance({id: insuranceId}, function (result) {
                vm.chart.primaryInsuranceBackPictureOriginal = result.image;
            });
        }

        function loadInsuranceSecondaryPictures(insuranceId) {
            InsurancePicture.getOriginalBase64ByInsurance({id: insuranceId}, function (result) {
                vm.chart.secondaryInsuranceFrontPictureOriginal = result.image;
            });

            InsuranceBackPicture.getOriginalBase64ByInsurance({id: insuranceId}, function (result) {
                vm.chart.secondaryInsuranceBackPictureOriginal = result.image;
            });
        }

        function clearPrimaryInsurance() {
            vm.chart.primary = null

            vm.chart.primary = vm.chart.secondary;

            vm.chart.primaryInsuranceFrontPicture = vm.chart.secondaryInsuranceFrontPicture;
            vm.chart.primaryInsuranceFrontPictureOriginal = vm.chart.secondaryInsuranceFrontPictureOriginal;
            vm.chart.primaryInsuranceBackPicture = vm.chart.secondaryInsuranceBackPicture;
            vm.chart.primaryInsuranceBackPictureOriginal = vm.chart.secondaryInsuranceBackPictureOriginal;

            vm.chart.secondary = null;
            vm.chart.secondaryInsuranceFrontPicture = null;
            vm.chart.secondaryInsuranceFrontPictureOriginal = null;
            vm.chart.secondaryInsuranceBackPicture = null;
            vm.chart.secondaryInsuranceBackPictureOriginal = null;

            clearPictures();
        }

        function removeSecondaryInsurance() {
            WizardHandler.wizard('createChartWizard').previous();

            vm.chart.secondary = null;

            vm.chart.secondaryInsuranceFrontPicture = null;
            vm.chart.secondaryInsuranceFrontPictureOriginal = null;
            vm.chart.secondaryInsuranceBackPicture = null;
            vm.chart.secondaryInsuranceBackPictureOriginal = null;

            clearPictures();
        }

        function addSecondaryInsurance() {
            vm.chart.secondary = {
                insuranceOrder: 2
            };
        }

        function clearPictures() {
            if (vm.chart.primary == null) {
                vm.chart.primaryInsuranceFrontPicture = null;
                vm.chart.primaryInsuranceFrontPictureOriginal = null;
                vm.chart.primaryInsuranceBackPicture = null;
                vm.chart.primaryInsuranceBackPictureOriginal = null;
            }

            if (vm.chart.secondary == null) {
                vm.chart.secondaryInsuranceFrontPicture = null;
                vm.chart.secondaryInsuranceFrontPictureOriginal = null;
                vm.chart.secondaryInsuranceBackPicture = null;
                vm.chart.secondaryInsuranceBackPictureOriginal = null;
            }
        }

        function setValidationClass(elem) {
            if (elem.$invalid) {
                return 'has-error'
            } else if (elem.$touched || elem.$dirty) {
                return 'has-success'
            } else {
                return ''
            }
        }

        function carrierTagTransform(newTag) {
            return {
                id: null,
                acctno: newTag,
                name: newTag
            };
        }

        function filterTracks(searchQuery) {
            if (searchQuery != null) {
                var filter = {
                    page: 0,
                    size: 20,
                    facilityId: vm.facility.id,
                    searchQuery: vm.searchQuery,
                    enabled: true
                };

                Track.filter(filter, function (result) {
                    vm.tracks = result;
                });
            }
        }

        function loadPictures(chart) {
            ChartPictureLicense.getOriginalBase64ByChart({id: chart.id}, function (result) {
                vm.chart.patientLicenseOriginal = result.image;
            });

            ChartPicture.getOriginalBase64ByChart({id: chart.id}, function (result) {
                vm.chart.pictureRefOriginal = result.image;
            });
        }

        function loadInsurances(chart) {
            if (chart.primary) {
                Insurance.get({id: chart.primary.id}, function (insurance) {
                    var insuranceId = insurance.id;

                    insurance.id = null;

                    vm.chart.primary = insurance;
                    loadInsurancePrimaryPictures(insuranceId);
                });
            }

            if (chart.secondary) {
                Insurance.get({id: chart.secondary.id}, function (insurance) {
                    var insuranceId = insurance.id;

                    insurance.id = null;

                    vm.chart.secondary = insurance;
                    loadInsuranceSecondaryPictures(insuranceId);
                });
            }
        }

        function checkField(field) {
            return CoreService.enableByFacilityType(vm.facility, field);
        }

        function getMarketers(query) {
            var filter = {page: 0, size: 20, query: query, facilityId: CoreService.getCurrentFacility().id};

            Employee.findAllByFilter(filter, function (result) {
                vm.marketer = result;
            });
        }

        function getAdmissionReps(query) {
            var filter = {page: 0, size: 20, query: query, facilityId: CoreService.getCurrentFacility().id};

            Employee.findAllByFilter(filter, function (result) {
                vm.admissionReps = result;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartCopyController', ChartCopyController);

    ChartCopyController.$inject = ['$uibModalInstance', 'Facility', 'CoreService'];

    function ChartCopyController($uibModalInstance, Facility, CoreService) {
        var vm = this;

        vm.currentFacility = CoreService.getCurrentFacility();

        Facility.byCorporation({id: CoreService.getCorporation().id}, function (facilities) {
            vm.facilities = _.filter(facilities, function (facility) {

                return facility.id !== vm.currentFacility.id;
            });
        });

        vm.clear = clear;
        vm.copy = copy;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function copy() {
            $uibModalInstance.close(vm.facility);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('charts', {
                parent: 'entity',
                url: '/charts?page&sort&search',
                data: {
                    authorities: [],
                    pageTitle: 'Patients Chart'
                },
                ncyBreadcrumb: {
                    label: 'Charts'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/list/chart.html',
                        controller: 'ChartController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    levelCare: null,
                },
                resolve: {
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    filter: ['facility', '$stateParams', 'CoreService', 'DateUtils', function (facility, $stateParams, CoreService, DateUtils) {
                        var filter = CoreService.getChartFilter();

                        if (filter == null || filter.facilityId != facility.id || $stateParams.levelCare != null) {
                            CoreService.setChartFilter(null);

                            return {
                                facilityId: facility.id,
                                status: 'CURRENT',
                                firstName: null,
                                lastName: null,
                                mrNo: null,
                                dischargeDateFrom: null,
                                dischargeDateTo: null,
                                admissionDateFrom: null,
                                admissionDateTo: null,
                                searchQuery: null,
                                typeLevelCare: $stateParams.levelCare != null ? $stateParams.levelCare : null,
                                sort: "firstName",
                                direction: "ASC",
                                statuses: 'CURRENT',
                                page: 1
                            };
                        } else {
                            filter.dischargeDateFrom = filter.dischargeDateFrom ? DateUtils.convertDateTimeFromServer(filter.dischargeDateFrom) : null;
                            filter.dischargeDateTo = filter.dischargeDateTo ? DateUtils.convertDateTimeFromServer(filter.dischargeDateTo) : null;
                            filter.admissionDateFrom = filter.admissionDateFrom ? DateUtils.convertDateTimeFromServer(filter.admissionDateFrom) : null;
                            filter.admissionDateTo = filter.admissionDateTo ? DateUtils.convertDateTimeFromServer(filter.admissionDateTo) : null;

                            return filter;
                        }
                    }],

                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_PATIENT_LIST, ACTIONS.ACTION_PATIENT_NEW];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_PATIENT_LIST, access);
                }]
            })
            .state('chart', {
                parent: 'entity',
                url: '/chart-r/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'Patient Detail'
                },
                ncyBreadcrumb: {
                    label: 'Patient Details'
                },
                params: {
                    typePatientProcess: null,
                    anchor: null,
                    processId: null,
                    processPage: null,
                    tabId: null
                },
                onEnter: ['$state', '$stateParams', '$rootScope', function ($state, $stateParams, $rootScope) {
                    if ($rootScope.showNewChart) {
                        $state.go('chart-new', {
                            id: $stateParams.id,
                            processId: $stateParams.processId,
                            processPage: $stateParams.processPage,
                            tabId: $stateParams.tabId
                        });
                    } else {
                        $state.go('chart-old', {id: $stateParams.id});
                    }
                }]
            })
            .state('chart-old', {
                parent: 'entity',
                url: '/chart-old/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'Patient Detail'
                },
                ncyBreadcrumb: {
                    label: 'Patient Details'
                },
                params: {
                    typePatientProcess: null,
                    anchor: null
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/detail/old/chart-detail.html',
                        controller: 'ChartDetailController',
                        controllerAs: 'vm'
                    },
                    'diagnoses@chart-old': {
                        templateUrl: 'app/entities/diagnoses/chart/old/diagnoses.html',
                        controller: 'DiagnosesController',
                        controllerAs: 'vm'
                    },
                    'care-team@chart-old': {
                        templateUrl: 'app/entities/chart-care-team/chart/old/chart-care-team.html',
                        controller: 'ChartCareTeamController',
                        controllerAs: 'vm'
                    },
                    'allergies@chart-old': {
                        templateUrl: 'app/entities/allergies/chart/old/allergies.html',
                        controller: 'AllergiesController',
                        controllerAs: 'vm'
                    },
                    'diet@chart-old': {
                        templateUrl: 'app/entities/diet/chart/old/diet.html',
                        controller: 'DietController',
                        controllerAs: 'vm'
                    },
                    'insurances@chart-old': {
                        templateUrl: 'app/entities/insurance/chart/old/insurance.html',
                        controller: 'InsuranceController',
                        controllerAs: 'vm'
                    },
                    'contacts@chart-old': {
                        templateUrl: 'app/entities/contacts/chart/old/contacts.html',
                        controller: 'ContactsController',
                        controllerAs: 'vm'
                    },
                    'patient-medications@chart-old': {
                        templateUrl: 'app/entities/patient-medication/chart/list/old/patient-medication-chart2.html',
                        controller: 'PatientMedicationChart2Controller',
                        controllerAs: 'vm'
                    },
                    'care-coordination@chart-old': {
                        templateUrl: 'app/entities/care-coordination/chart/old/care-coordination.html',
                        controller: 'CareCoordinationController',
                        controllerAs: 'vm'
                    },
                    /*app/entities/care-coordination
                        Don'T erase this comments until Lindoro gets his way around this
                    */
                    'lab-orders@chart-old': {
                        templateUrl: 'app/entities/patient-order/chart/old/patient-order.html',
                        controller: 'PatientOrderChartController',
                        controllerAs: 'vm'
                    },
                    'e-labs@chart-old': {
                        templateUrl: 'app/entities/patient-result/chart/e-labs/old/e-labs.html',
                        controller: 'ELabsController',
                        controllerAs: 'vm'
                    },
                    // 'actions@chart': {
                    //     templateUrl: 'app/entities/patient-action/chart/patient-actions.html',
                    //     controller: 'PatientActionChartController',
                    //     controllerAs: 'vm'
                    // },
                    // 'mars@chart': {
                    //     templateUrl: 'app/entities/mars/mars.html',
                    //     controller: 'MarsController',
                    //     controllerAs: 'vm'
                    // },
                    // 'schedule@chart': {
                    //     templateUrl: 'app/entities/mars/schedule.html',
                    //     controller: 'ScheduleController',
                    //     controllerAs: 'vm'
                    // },
                    // 'prn@chart': {
                    //     templateUrl: 'app/entities/mars/prn-action.html',
                    //     controller: 'PrnController',
                    //     controllerAs: 'vm'
                    // },
                    'evaluation@chart-old': {
                        templateUrl: 'app/entities/evaluation/chart/old/evaluation.html',
                        controller: 'EvaluationController',
                        controllerAs: 'vm'
                    },
                    'concurrent@chart-old': {
                        templateUrl: 'app/entities/concurrent-reviews/chart/old/concurrent-reviews.html',
                        controller: 'ConcurrentReviewsChartController',
                        controllerAs: 'vm'
                    },
                    'vitals@chart-old': {
                        templateUrl: 'app/entities/vitals/chart/old/vitals.html',
                        controller: 'VitalsChartController',
                        controllerAs: 'vm'
                    },
                    'glucose@chart-old': {
                        templateUrl: 'app/entities/glucose/chart/old/glucose.html',
                        controller: 'GlucoseChartController',
                        controllerAs: 'vm'
                    },
                    'weight@chart-old': {
                        templateUrl: 'app/entities/weight/chart/old/weight.html',
                        controller: 'WeightChartController',
                        controllerAs: 'vm'
                    },
                    'alcohol@chart-old': {
                        templateUrl: 'app/entities/alcohol/chart/old/alcohol.html',
                        controller: 'AlcoholChartController',
                        controllerAs: 'vm'
                    },
                    'drug@chart-old': {
                        templateUrl: 'app/entities/drug/chart/old/drug.html',
                        controller: 'DrugChartController',
                        controllerAs: 'vm'
                    },
                    'gSessionsDetails@chart-old': {
                        templateUrl: 'app/entities/group-session-details/chart/old/group-session-details.html',
                        controller: 'GroupSessionDetailsController',
                        controllerAs: 'vm'
                    },
                    'notes@chart-old': {
                        templateUrl: 'app/entities/chart-note/chart/old/chart-note.html',
                        controller: 'ChartNoteController',
                        controllerAs: 'vm'
                    },
                    'verifytx@chart-old': {
                        templateUrl: 'app/entities/verifytx/chart/list/old/verifytx.html',
                        controller: 'VerifytxController',
                        controllerAs: 'vm'
                    },
                    'files@chart-old': {
                        templateUrl: 'app/entities/chart-file/chart/old/chart-file.html',
                        controller: 'ChartFileController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    chart: ['$stateParams', 'Chart', function ($stateParams, Chart) {
                        return Chart.get({id: $stateParams.id}).$promise;
                    }],
                    employeeMenu: ['EmployeeMenu', 'employee', 'CoreService', function (EmployeeMenu, employee, CoreService) {
                        var menu = CoreService.getEmployeeMenu();

                        return menu ? menu : EmployeeMenu.get({id: employee.id});
                    }],
                    previousState: ["$state", function ($state) {
                        return {
                            name: $state.current.name || 'reaction',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }],
                    typePatientProcess: ['$stateParams', function ($stateParams) {
                        return $stateParams.typePatientProcess;
                    }],
                    anchor: ['$stateParams', function ($stateParams) {
                        return $stateParams.anchor;
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    params: ['$location', '$stateParams', function ($location, $stateParams) {
                        var paramsUrl = $location.search();

                        return {
                            processId: paramsUrl && paramsUrl.processId ? paramsUrl.processId : $stateParams.typePatientProcess,
                            processPage: paramsUrl && paramsUrl.processPage ? paramsUrl.processPage : $stateParams.processPage,
                            tabId: paramsUrl && paramsUrl.tabId ? paramsUrl.tabId : $stateParams.tabId
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [
                            ACTIONS.ACTION_PATIENT_CLOSE_CHART,
                            ACTIONS.ACTION_PATIENT_EDIT_ID,
                            ACTIONS.ACTION_PATIENT_EDIT_INFO,
                            ACTIONS.ACTION_MASTER_EDIT,
                            ACTIONS.ACTION_PATIENT_INSURANCE_VIEW,
                            ACTIONS.ACTION_PATIENT_CONTACTS_VIEW,
                            ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW,
                            ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW,
                            ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW,
                            ACTIONS.ACTION_PATIENT_DIETS_VIEW,
                            ACTIONS.ACTION_PATIENT_VITALS_VIEW,
                            ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW,
                            ACTIONS.ACTION_PATIENT_WEIGHT_VIEW,
                            ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW,
                            ACTIONS.ACTION_PATIENT_DRUGS_VIEW,
                            ACTIONS.ACTION_PATIENT_FILE_VIEW,
                            ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW,
                            ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW,
                            ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW,
                            ACTIONS.ACTION_PATIENT_CHART_LEVEL_CARE_HISTORY,
                            ACTIONS.ACTION_PATIENT_CHART_DISCHARGE_HISTORY,
                            ACTIONS.ACTION_PATIENT_CHART_TRACK_HISTORY,
                            ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW,
                            ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW,
                            ACTIONS.ACTION_PATIENT_ELABS_VIEW,
                            ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW,
                            ACTIONS.ACTION_PATIENT_EVALUATION_VIEW,
                            ACTIONS.ACTION_PATIENT_MEDICATION_VIEW,
                            ACTIONS.ACTION_ADD_PATIENT_ORDER_CREATE,
                            ACTIONS.ACTION_DELETE_CARE_DELIVERY
                        ];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    rcopiaAccount: ['RcopiaAccount', 'CoreService', function (RcopiaAccount, CoreService) {
                        return RcopiaAccount.account({id: CoreService.getCorporation().id}).$promise;
                    }],
                    discontinued: [function () {
                        return null;
                    }]
                }
            })
            .state('chart-new', {
                parent: 'entity',
                url: '/chart-new/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'Patient Details'
                },
                params: {
                    typePatientProcess: null,
                    processId: null,
                    processPage: null,
                    tabId: null
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/detail/new/chart-detail.html',
                        controller: 'ChartDetailsController',
                        controllerAs: 'vm'
                    },
                    'chart-diagnoses@chart-new': {
                        templateUrl: 'app/entities/diagnoses/chart/new/diagnoses.html',
                        controller: 'DiagnosesController',
                        controllerAs: 'vm'
                    },
                    'chart-allergies@chart-new': {
                        templateUrl: 'app/entities/allergies/chart/new/allergies.html',
                        controller: 'AllergiesController',
                        controllerAs: 'vm'
                    },
                    'chart-diets@chart-new': {
                        templateUrl: 'app/entities/diet/chart/new/diet.html',
                        controller: 'DietController',
                        controllerAs: 'vm'
                    },
                    'chart-vitals@chart-new': {
                        templateUrl: 'app/entities/vitals/chart/new/vitals.html',
                        controller: 'VitalsChartController',
                        controllerAs: 'vm'
                    },
                    'chart-glucose@chart-new': {
                        templateUrl: 'app/entities/glucose/chart/new/glucose.html',
                        controller: 'GlucoseChartController',
                        controllerAs: 'vm'
                    },
                    'chart-weight@chart-new': {
                        templateUrl: 'app/entities/weight/chart/new/weight.html',
                        controller: 'WeightChartController',
                        controllerAs: 'vm'
                    },
                    'chart-alcohol@chart-new': {
                        templateUrl: 'app/entities/alcohol/chart/new/alcohol.html',
                        controller: 'AlcoholChartController',
                        controllerAs: 'vm'
                    },
                    'chart-drug@chart-new': {
                        templateUrl: 'app/entities/drug/chart/new/drug.html',
                        controller: 'DrugChartController',
                        controllerAs: 'vm'
                    },
                    'chart-care-team@chart-new': {
                        templateUrl: 'app/entities/chart-care-team/chart/new/chart-care-team.html',
                        controller: 'ChartCareTeamController',
                        controllerAs: 'vm'
                    },
                    'chart-care-coordination@chart-new': {
                        templateUrl: 'app/entities/care-coordination/chart/new/care-coordination.html',
                        controller: 'CareCoordinationController',
                        controllerAs: 'vm'
                    },
                    'chart-urgent-issue@chart-new': {
                        templateUrl: 'app/entities/urgent-issues/chart/new/list/urgent-issues.html',
                        controller: 'UrgentIssuesController',
                        controllerAs: 'vm'
                    },
                    'chart-notes@chart-new': {
                        templateUrl: 'app/entities/chart-note/chart/new/chart-note.html',
                        controller: 'ChartNoteController',
                        controllerAs: 'vm'
                    },
                    'chart-files@chart-new': {
                        templateUrl: 'app/entities/chart-file/chart/new/chart-file.html',
                        controller: 'ChartFileController',
                        controllerAs: 'vm'
                    },
                    'chart-lab-orders@chart-new': {
                        templateUrl: 'app/entities/patient-order/chart/new/patient-order.html',
                        controller: 'PatientOrderChartController',
                        controllerAs: 'vm'
                    },
                    'chart-e-labs@chart-new': {
                        templateUrl: 'app/entities/patient-result/chart/e-labs/new/e-labs.html',
                        controller: 'ELabsController',
                        controllerAs: 'vm'
                    },
                    'chart-patient-medications@chart-new': {
                        templateUrl: 'app/entities/patient-medication/chart/list/new/patient-medication-chart2.html',
                        controller: 'PatientMedicationChart2Controller',
                        controllerAs: 'vm'
                    },
                    'chart-group-sessions@chart-new': {
                        templateUrl: 'app/entities/group-session-details/chart/new/group-session-details.html',
                        controller: 'GroupSessionDetailsController',
                        controllerAs: 'vm'
                    },
                    'chart-evaluation@chart-new': {
                        templateUrl: 'app/entities/evaluation/chart/new/evaluation.html',
                        controller: 'EvaluationController',
                        controllerAs: 'vm'
                    },
                    'chart-insurance@chart-new': {
                        templateUrl: 'app/entities/insurance/chart/new/insurance.html',
                        controller: 'InsuranceController',
                        controllerAs: 'vm'
                    },
                    'chart-contacts@chart-new': {
                        templateUrl: 'app/entities/contacts/chart/new/contacts.html',
                        controller: 'ContactsController',
                        controllerAs: 'vm'
                    },
                    'chart-concurrent-reviews@chart-new': {
                        templateUrl: 'app/entities/concurrent-reviews/chart/new/concurrent-reviews-new.html',
                        controller: 'ConcurrentReviewsChartNewController',
                        controllerAs: 'vm'
                    },
                    'chart-verifytx@chart-new': {
                        templateUrl: 'app/entities/verifytx/chart/list/new/verifytx.html',
                        controller: 'VerifytxController',
                        controllerAs: 'vm'
                    },
                    'chart-super-bill@chart-new': {
                        templateUrl: 'app/entities/super-bill/super-bill.html',
                        controller: 'SuperBillController',
                        controllerAs: 'vm'
                    },
                    'rcopia@chart-new': {
                        templateUrl: 'app/entities/rcopia/chart/new/rcopia-chart.html',
                        controller: 'RcopiaChartController',
                        controllerAs: 'vm'
                    },
                    'chart-patient-rcopia-prescription@chart-new': {
                        templateUrl: 'app/entities/rcopia-prescription/list/rcopia-prescriptions.html',
                        controller: 'RcopiaPrescriptionController',
                        controllerAs: 'vm'
                    },
                    'chart-patient-rcopia-medications@chart-new': {
                        templateUrl: 'app/entities/rcopia-medication/list/rcopia-medications.html',
                        controller: 'RcopiaMedicationController',
                        controllerAs: 'vm'
                    },
                    'rcopia-sso-logs@chart-new': {
                        templateUrl: 'app/entities/rcopia-sso-log/chart/rcopia-sso-log-chart.html',
                        controller: 'RcopiaSsoLogChartController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    chart: ['$stateParams', 'Chart', function ($stateParams, Chart) {
                        return Chart.get({id: $stateParams.id}).$promise;
                    }],
                    anchor: ['$stateParams', function ($stateParams) {
                        return $stateParams.anchor;
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    params: ['$location', '$stateParams', function ($location, $stateParams) {
                        var paramsUrl = $location.search();

                        return {
                            processId: paramsUrl && paramsUrl.processId ? paramsUrl.processId : $stateParams.typePatientProcess,
                            processPage: paramsUrl && paramsUrl.processPage ? paramsUrl.processPage : $stateParams.processPage,
                            tabId: paramsUrl && paramsUrl.tabId ? paramsUrl.tabId : $stateParams.tabId
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [
                            ACTIONS.ACTION_PATIENT_CLOSE_CHART,
                            ACTIONS.ACTION_PATIENT_EDIT_ID,
                            ACTIONS.ACTION_PATIENT_EDIT_INFO,
                            ACTIONS.ACTION_MASTER_EDIT,
                            ACTIONS.ACTION_PATIENT_INSURANCE_VIEW,
                            ACTIONS.ACTION_PATIENT_CONTACTS_VIEW,
                            ACTIONS.ACTION_PATIENT_CARE_TEAM_VIEW,
                            ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW,
                            ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW,
                            ACTIONS.ACTION_PATIENT_DIETS_VIEW,
                            ACTIONS.ACTION_PATIENT_VITALS_VIEW,
                            ACTIONS.ACTION_PATIENT_GLUCOSE_VIEW,
                            ACTIONS.ACTION_PATIENT_WEIGHT_VIEW,
                            ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW,
                            ACTIONS.ACTION_PATIENT_DRUGS_VIEW,
                            ACTIONS.ACTION_PATIENT_FILE_VIEW,
                            ACTIONS.ACTION_PATIENT_CHART_NOTE_VIEW,
                            ACTIONS.ACTION_PATIENT_CONCURRENT_REVIEW_VIEW,
                            ACTIONS.ACTION_PATIENT_VERIFYTX_VIEW,
                            ACTIONS.ACTION_PATIENT_CHART_LEVEL_CARE_HISTORY,
                            ACTIONS.ACTION_PATIENT_CHART_DISCHARGE_HISTORY,
                            ACTIONS.ACTION_PATIENT_CHART_TRACK_HISTORY,
                            ACTIONS.ACTION_PATIENT_DIAGNOSES_VIEW,
                            ACTIONS.ACTION_PATIENT_LAB_ORDERS_VIEW,
                            ACTIONS.ACTION_PATIENT_ELABS_VIEW,
                            ACTIONS.ACTION_PATIENT_GROUP_SESSION_VIEW,
                            ACTIONS.ACTION_PATIENT_EVALUATION_VIEW,
                            ACTIONS.ACTION_PATIENT_MEDICATION_VIEW,
                            ACTIONS.ACTION_ADD_PATIENT_ORDER_CREATE,
                            ACTIONS.ACTION_DELETE_CARE_DELIVERY
                        ];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    rcopiaAccount: ['RcopiaAccount', 'CoreService', function (RcopiaAccount, CoreService) {
                        return RcopiaAccount.account({id: CoreService.getCorporation().id}).$promise;
                    }],
                    discontinued: [function () {
                        return false;
                    }]
                }
            })
            .state('charts-review', {
                parent: 'entity',
                url: '/charts-review',
                data: {
                    authorities: [],
                    pageTitle: 'Chart Review'
                },
                ncyBreadcrumb: {
                    label: 'Chart Review'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/chart-review.html',
                        controller: 'ChartReviewController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: 0,
                            itemsPerPage: 18,
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    filter: ['facility', function (facility) {
                        return {
                            facilityId: facility.id,
                            status: 'CURRENT',
                            firstName: null,
                            lastName: null,
                            mrNo: null,
                            dischargeDateFrom: null,
                            dischargeDateTo: null,
                            admissionDateFrom: null,
                            admissionDateTo: null,
                            searchQuery: null
                        };
                    }]
                }
            })
            .state('charts-discharge', {
                parent: 'entity',
                url: '/charts-discharge?dischargeType',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Discharge'
                },
                ncyBreadcrumb: {
                    label: 'Charts Discharge'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-discharge.html',
                        controller: 'ChartsDischargeController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    dischargeType: null
                },
                resolve: {
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    filterCharts: [function () {
                        return {
                            typeDischarge: null,
                            fromDischargeDate: null,
                            toDischargeDate: null,
                            referral: null,
                            chartSelected: null
                        }
                    }],
                    dischargeType: ['TypeDischargeType', '$stateParams', function (TypeDischargeType, $stateParams) {
                        return $stateParams.dischargeType ? TypeDischargeType.get({id: $stateParams.dischargeType}).$promise : null;
                    }]
                }
            })
            .state('charts-marketer', {
                parent: 'entity',
                url: '/charts-marketer?marketer',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Outreach'
                },
                ncyBreadcrumb: {
                    label: 'Charts Outreach'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-marketer.html',
                        controller: 'ChartsMarketerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    marketer: null
                },
                resolve: {
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    filterCharts: [function () {
                        return {
                            marketer: null,
                            fromAdmissionDate: null,
                            toAdmissionDate: null,
                            referral: null,
                            status: "CURRENT",
                            chartSelected: null
                        }
                    }],
                    marketer: ['Employee', '$stateParams', function (Employee, $stateParams) {
                        return $stateParams.marketer ? Employee.get({id: $stateParams.marketer}).$promise : null;
                    }]
                }
            })
            .state('charts-referrer', {
                parent: 'entity',
                url: '/charts-referrer?referrer',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Referrer'
                },
                ncyBreadcrumb: {
                    label: 'Charts Referrer'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-referrer.html',
                        controller: 'ChartsReferrerController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    referrer: null
                },
            })
            .state('charts-caseload', {
                parent: 'entity',
                url: '/charts-caseload?employee',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Care Team'
                },
                ncyBreadcrumb: {
                    label: 'Charts Care Team'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-caseload.html',
                        controller: 'ChartsCaseLoadController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    id: null
                },
                resolve: {
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    filterCharts: ['$stateParams', function ($stateParams) {
                        return {
                            employeeId: $stateParams.employee,
                            toAdmissionDate: null,
                            fromAdmissionDate: null,
                            referral: null,
                            chartSelected: null
                        }
                    }],
                    employee: ['Employee', '$stateParams', function (Employee, $stateParams) {
                        return $stateParams.employee ? Employee.get({id: $stateParams.employee}).$promise : null;
                    }]
                }
            })
            .state('charts-payer-mix-no', {
                parent: 'entity',
                url: '/charts-payer-mix-no/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Payer'
                },
                ncyBreadcrumb: {
                    label: 'Charts Payer'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-payer-mix.html',
                        controller: 'ChartsPayerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    insCarrier: [function () {
                        return null;
                    }],
                    typePay: ['$stateParams', 'TypePaymentMethods', function ($stateParams, TypePaymentMethods) {
                        return TypePaymentMethods.get({id: $stateParams.id}).$promise;
                    }],
                }
            })
            .state('charts-payer-mix-ins', {
                parent: 'entity',
                url: '/charts-payer-mix-ins/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Payer'
                },
                ncyBreadcrumb: {
                    label: 'Charts Payer'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-payer-mix.html',
                        controller: 'ChartsPayerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    typePay: [function () {
                        return null;
                    }],
                    insCarrier: ['$stateParams', 'InsuranceCarrier', function ($stateParams, InsuranceCarrier) {
                        return InsuranceCarrier.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('charts-payer-mix-no-ins', {
                parent: 'entity',
                url: '/charts-payer-mix-no-ins/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'Charts Payer'
                },
                ncyBreadcrumb: {
                    label: 'Charts Payer'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chart/dashboard/charts-payer-mix.html',
                        controller: 'ChartsPayerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    typePay: [function () {
                        return null;
                    }],
                    insCarrier: [function () {
                        return null;
                    }]
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CareCoordinationTemplateDialogController', CareCoordinationTemplateDialogController);

    CareCoordinationTemplateDialogController.$inject = ['$timeout', '$scope', '$stateParams',
        '$uibModalInstance', 'entity', 'CareCoordinationTemplate',
        'Employee', 'Icd10Search', 'CoreService'];

    function CareCoordinationTemplateDialogController ($timeout, $scope, $stateParams,
                                                       $uibModalInstance, entity, CareCoordinationTemplate,
                                                       Employee, Icd10Search, CoreService) {
        var vm = this;

        vm.careCoordinationTemplate = entity;

        vm.icd10S = [];
        vm.employees = [];
        vm.corporation = CoreService.getCorporation();

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.getIcd10S = getIcd10S;

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        function getIcd10S(query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10S = result;
                });
            }
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.careCoordinationTemplate.id !== null) {
                CareCoordinationTemplate.update(vm.careCoordinationTemplate, onSaveSuccess, onSaveError);
            } else {
                CareCoordinationTemplate.save(vm.careCoordinationTemplate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:careCoordinationTemplateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CareCoordinationTemplate', CareCoordinationTemplate);

    CareCoordinationTemplate.$inject = ['$resource'];

    function CareCoordinationTemplate ($resource) {
        var resourceUrl =  'api/care-coordination-templates/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByFilter': {url: "api/care-coordination-templates/filter", method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CareCoordinationTemplateController', CareCoordinationTemplateController);

    CareCoordinationTemplateController.$inject = ['GenericEntityDatatableService', 'CoreService',
        'CareCoordinationTemplate', 'GUIUtils', '$uibModal', 'ConfirmationService',
        '$q'];

    function CareCoordinationTemplateController(GenericEntityDatatableService, CoreService,
                                                CareCoordinationTemplate, GUIUtils, $uibModal, ConfirmationService,
                                                $q) {
        var vm = this;

        var params = {facilityId: CoreService.getCurrentFacility().id};

        vm.descriptor = {
            title: 'Care Coordination Templates',
            newButtonTitle: 'New Care Coordination Template',
            entityClassHumanized: 'Care Coordination Templates',
            entityStateName: 'care-coordination-template',
            service: CareCoordinationTemplate,
            serviceMethod: 'findAllByFilter',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'title',
                    title: 'Title',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
                {
                    name: 'days',
                    title: 'Days',
                },
                {
                    name: 'notes',
                    title: 'Notes',
                },
                {
                    name: null,
                    title: 'Enabled',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.active);
                    }
                },
                {
                    name: 'typeAction',
                    title: 'Type Action',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Care Coordination Template',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/care-coordination-template/update/care-coordination-template-dialog.html',
                controller: 'CareCoordinationTemplateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            title: null,
                            description: null,
                            days: null,
                            notes: null,
                            active: false,
                            typeAction: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/care-coordination-template/update/care-coordination-template-dialog.html',
                controller: 'CareCoordinationTemplateDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CareCoordinationTemplate', function (CareCoordinationTemplate) {
                        return CareCoordinationTemplate.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Care Coordination Template').result.then(function () {
                    CareCoordinationTemplate.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('care-coordination-template', {
                parent: 'entity',
                url: '/care-coordination-template',
                data: {
                    authorities: [],
                    pageTitle: 'CareCoordinationTemplates'
                },
                ncyBreadcrumb: {
                    label: 'Care Coordination Templates'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/care-coordination-template/list/care-coordination-template.html',
                        controller: 'CareCoordinationTemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_COORDINATION];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CARE_COORDINATION, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CareCoordinationDialogController', CareCoordinationDialogController);

    CareCoordinationDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', '$uibModalInstance',
        'entity', 'CareCoordination', 'Employee', 'Icd10Search', 'CoreService', 'Notifications'];

    function CareCoordinationDialogController($timeout, $scope, $state, $stateParams, $uibModalInstance,
                                              entity, CareCoordination, Employee, Icd10Search, CoreService, Notifications) {
        var vm = this;

        vm.careCoordination = entity;
        vm.corporation = CoreService.getCorporation();
        vm.employees = [];
        vm.icd10 = [];
        vm.icd10Tmp = [];
        vm.employeeTmp = [];
        vm.showDelete = false;
        vm.chart = entity.chart;

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;
        vm.confirmDelete = confirmDelete;

        function createNotification(title, description, priorityLevel, stateName) {
            var notification = {};
            notification.title = title;
            notification.description = description;
            notification.priorityLevel = priorityLevel;
            notification.viewed = false;
            notification.reviewedDate = new Date();
            notification.employee = CoreService.getCurrentEmployee();
            notification.state = stateName;
            notification.stateParams = angular.toJson($state.params).toString().replace(/["]/g, '');

            Notifications.save(notification, onSaveSuccessCreateNotification, onSaveErrorCreateNotification);
        }

        function onSaveSuccessCreateNotification(result) {
            $scope.$emit('bluebookApp:notificationUpdate', result);
            $state.go('chart', {'#': 'notification'}, {reload: true});
            vm.isSaving = false;
        }

        function onSaveErrorCreateNotification() {
            vm.isSaving = false;
        }

        if (vm.careCoordination.id) {
            vm.employeeTmp = [vm.careCoordination.employees][0];
            vm.icd10Tmp = [vm.careCoordination.icd10S][0];
        }

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, facilityId: CoreService.getCurrentFacility().id};

                Employee.findAllByFilter(filter, function (result) {
                    vm.employees = result;
                });
            }
        }

        vm.getIcd10 = function (query) {
            if (query && query.length > 2) {
                Icd10Search.query({query: query}, function (result) {
                    vm.icd10 = result;
                });
            }
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.careCoordination.id !== null) {
                vm.careCoordination.icd10S = vm.icd10Tmp;
                vm.careCoordination.employees = vm.employeeTmp;
                CareCoordination.update(vm.careCoordination, onSaveSuccess, onSaveError);
            } else {
                vm.careCoordination.icd10S = vm.icd10Tmp;
                vm.careCoordination.employees = vm.employeeTmp;
                CareCoordination.save(vm.careCoordination, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:careCoordinationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function confirmDelete () {
            CareCoordination.delete({id: vm.careCoordination.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('CareCoordination', CareCoordination);

    CareCoordination.$inject = ['$resource'];

    function CareCoordination ($resource) {
        var resourceUrl =  'api/care-coordinations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllWithEagerRelationshipsByChart': {url: 'api/care-coordinations/by-chart/:chartId', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CareCoordinationController', CareCoordinationController);

    CareCoordinationController.$inject = ['$scope', '$state', '$filter', 'CareCoordination', 'chart', 'CoreService',
        'AlertService', 'DateUtils', '$sessionStorage', 'Employee', '$uibModal', 'access', 'ACTIONS',
        'Auth', 'ConfirmationService'];

    function CareCoordinationController($scope, $state, $filter, CareCoordination, chart, CoreService,
                                        AlertService, DateUtils, $sessionStorage, Employee, $uibModal, access, ACTIONS,
                                        Auth, ConfirmationService) {
        var vm = this;

        vm.chart = chart;
        vm.careCoordinations = [];
        vm.page = 1;
        vm.itemsPerPage = 7;

        vm.saveExcecuted = saveExcecuted;
        vm.transition = transition;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.plusDays = plusDays;
        vm.toggleItem = toggleItem;

        function toggleItem() {
            CoreService.togglePanel('careCoordination');
        }

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_CARE_COORDINATION_VIEW, access)) {
                return;
            }

            CareCoordination.findAllWithEagerRelationshipsByChart({
                chartId: chart.id,
                page: vm.page - 1,
                size: vm.itemsPerPage
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.careCoordinations = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function saveExcecuted(careCoordination) {
            vm.isSaving = true;
            if (careCoordination.id !== null) {
                CareCoordination.get({id: careCoordination.id}, function (result) {
                    if (result) {
                        result.excecuted = careCoordination.excecuted;
                        CareCoordination.update(result, function () {
                            transition();
                            vm.isSaving = false;
                        }, function () {
                            vm.isSaving = false;
                        });
                    }
                });
            }
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/care-coordination/update/care-coordination-dialog.html',
                controller: 'CareCoordinationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            employeeOne: null,
                            dateAndTime: null,
                            id: null,
                            active: true,
                            chart: chart
                        };
                    }
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/care-coordination/update/care-coordination-dialog.html',
                controller: 'CareCoordinationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CareCoordination', function (CareCoordination) {
                        return CareCoordination.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                vm.page = 1;
                loadAll();
            });
        }

        function del(id) {
            ConfirmationService.showDelete('CareCoordination').result.then(function () {
                CareCoordination.delete({id: id}, function () {
                    vm.page = 1;
                    loadAll();
                });
            })
        }

        function plusDays(careCoordination) {
            var result = new Date(careCoordination.createdDate);
            result.setDate(result.getDate() + careCoordination.days);

            return result;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CampaignDialogController', CampaignDialogController);

    CampaignDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'Campaign', 'InsuranceCarrierSearch', 'TypePaymentMethods', 'EvaluationTemplate', 'CoreService', 'GUIUtils'];

    function CampaignDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                      Campaign, InsuranceCarrierSearch, TypePaymentMethods, EvaluationTemplate, CoreService, GUIUtils) {
        var vm = this;

        vm.campaign = entity;
        vm.typePaymentMethods = TypePaymentMethods.byFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.gender = GUIUtils.getGender();
        vm.policyNumberName = null;
        vm.campaignChartStatus = [{id: '', chartStatus: "CURRENT"},
            {id: '', chartStatus: "CLOSED"},
            {id: '', chartStatus: "WAITING"},
            {id: '', chartStatus: "ARCHIVE"}];
        vm.campaignEvaluationStatus = _.map(GUIUtils.getEvaluationStatus(), function (campaignEvaluationStatus) {
            return{id:'', evaluationStatus: campaignEvaluationStatus}
        });

        vm.clear = clear;
        vm.save = save;
        vm.getInsuranceCarriers = getInsuranceCarriers;
        vm.getEvaluationTemplates = getEvaluationTemplates;
        vm.setPolicyNumber = setPolicyNumber;
        vm.checkCampaignChartStatus = checkCampaignChartStatus
        vm.checkCampaignEvaluationStatus = checkCampaignEvaluationStatus

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            if (vm.campaign.id !== null) {
                Campaign.update(vm.campaign, onSaveSuccess, onSaveError);
            } else {
                Campaign.save(vm.campaign, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:campaignUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getFilter(query) {
            var filter = {};

            filter.facilityId = CoreService.getCurrentFacility().id;
            filter.page = 0;
            filter.size = 10;
            filter.searchQuery = query;

            return filter
        }

        function checkCampaignChartStatus() {
            vm.campaign.campaignChartStatus = _.uniqBy(vm.campaign.campaignChartStatus, 'chartStatus')
        }

        function checkCampaignEvaluationStatus() {
            vm.campaign.campaignEvaluationStatus = _.uniqBy(vm.campaign.campaignEvaluationStatus, 'evaluationStatus')
        }

        function getInsuranceCarriers(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);

                vm.insuranceCarriers = InsuranceCarrierSearch.query({
                    query: query
                });
            }
        }

        function getEvaluationTemplates(query) {
            if (query && query.length > 3) {
                EvaluationTemplate.findAllByFilter(getFilter(query), function (result) {
                    vm.evaluationTemplates = result;
                })
            }
        }

        function setPolicyNumber(query) {
            vm.campaign.campaignPolicyNumbers.push({'id': "", 'policyNumber': query});
            vm.policyNumberName = null;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Campaign', Campaign);

    Campaign.$inject = ['$resource'];

    function Campaign ($resource) {
        var resourceUrl =  'api/campaigns/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byFilter': {url: 'api/campaigns/filter', method: 'GET', isArray: true},
            'sendMessage': {url: 'api/campaigns/message', method: 'GET', isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }},
            'resendMessage': { method: 'GET', url: "api/campaigns/resend-message", isArray: false,
                transformResponse: function (data) {
                    if (data === 'true') {
                        return {value: true};
                    }
                    return {value: false};
                }}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('OutReachCampaignSelectCampaignDialogController', OutReachCampaignSelectCampaignDialogController);

    OutReachCampaignSelectCampaignDialogController.$inject = ['$uibModalInstance', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$compile', '$scope', 'CoreService', 'filter', 'DataTablesService', 'Campaign', '$state'];

    function OutReachCampaignSelectCampaignDialogController($uibModalInstance, DTOptionsBuilder, DTColumnBuilder, $q, $filter, $compile, $scope, CoreService, filter, DataTablesService, Campaign, $state) {
        var vm = this;

        vm.dtInstance = {};
        vm.filter = filter;
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.selectCampaign = selectCampaign;
        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;
        vm.getCampaignId = getCampaignId;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Campaign.byFilter(getFilter(),
                function (result, headers) {
                    vm.totalItems = headers('X-Total-Count');
                    vm.campaigns = result;
                    defer.resolve(result);
                });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false).withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notSortable().renderWith(function (data, type, full, meta) {
                return '<input type="radio" name="campaignSelected" ng-click="vm.getCampaignId(' + data.id + ')">';
            }),
            DTColumnBuilder.newColumn('name').withTitle('Name').notSortable(),
            DTColumnBuilder.newColumn(null).withTitle('Gender').notSortable().renderWith(function (data, type, full) {
                return data.gender ? data.gender : '';
            })
        ];

        function getFilter() {
            var filter = {};

            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;
            filter.facilityId = vm.filter.facilityId;

            return filter;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function search() {
            vm.page = 1;
            vm.campaignId = '';

            transition();
        }

        function transition() {
            vm.dtInstance.reloadData();
        }

        function selectCampaign() {
            $uibModalInstance.close(_.find(vm.campaigns, {id: vm.campaignId}));
        }

        function getCampaignId(id) {
            vm.campaignId = id;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('OutreachCampaignController', OutreachCampaignController);

    OutreachCampaignController.$inject = ['$scope', '$state', '$q', '$compile', 'Chart', 'CoreService', '$rootScope',
        '$uibModal', 'DataTablesService', 'GenericEntityDatatableService'];

    function OutreachCampaignController($scope, $state, $q, $compile, Chart, CoreService, $rootScope,
                                        $uibModal, DataTablesService, GenericEntityDatatableService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Outreach Campaigns',
            entityClassHumanized: 'Outreach Campaigns',
            entityStateName: 'outreach-campaign',
            service: Chart,
            serviceMethod: 'getAllByCampaign',
            params: params,
            pagination: 'remote',
            options: [{key: 'aaSorting', value: [[0, 'desc']]}],
            newAction: false,
            withSelectionColumn: true,
            columns: [
                {
                    name: null,
                    title: 'Patient',
                    render: function (data) {
                        return data.patientLastName + ", " + data.patientFirstName;
                    }
                },
                {
                    name: null,
                    title: 'DOB',
                    render: function (data) {
                        return moment(data.dob).format($rootScope.dateFormat);
                    }
                },
                {
                    name: 'mrNo',
                    title: 'MrNo'
                },
                {
                    name: null,
                    title: 'Admission Date',
                    render: function (data) {
                        return data.admissionDate ? moment(data.admissionDate).format($rootScope.dateFormat) : '-';
                    }
                },
                {
                    name: null,
                    title: 'Phone Number',
                    render: function (data) {
                        return data.phone ? data.phone : '-';
                    }
                },
                {
                    name: null,
                    title: 'Insurance Carrier',
                    render: function (data) {
                        return data.insuranceCarrier ? data.insuranceCarrier : '-';
                    }
                },
                {
                    name: null,
                    title: 'Policy Number',
                    render: function (data) {
                        return data.phone ? data.phone : '-';
                    }
                },
                {
                    name: null,
                    title: 'Outreach',
                    render: function (data) {
                        return (data.marketerLastName && data.marketerFirstName) ? data.marketerLastName + ", " + data.marketerFirstName : '-';
                    }
                },
                {
                    name: null,
                    title: 'Discharge Type',
                    render: function (data) {
                        return data.dischargeType ? data.dischargeType : '-';
                    }
                },
                {
                    name: null,
                    title: 'Payment Method',
                    render: function (data) {
                        return data.typePaymentMethods ? data.typePaymentMethods : '-';
                    }
                },
                {
                    name: null,
                    title: 'Discharge To',
                    render: function (data) {
                        return data.dischargeTo ? data.dischargeTo : '-';
                    }
                },
                {
                    name: null,
                    title: 'Referrer',
                    render: function (data) {
                        return data.referrer ? data.referrer : '-';
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDetailsAction(),
                    {
                        action: function (data) {
                            $state.go('chart', {id: data.id});
                        },
                        reload: false
                    }
                ),
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Campaign',
                            action: function (filter) {
                                return selectCampaign(filter)
                            }
                        })
                    ]
                },
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSendAction(), {
                            name: 'Send Campaign',
                            disabledOnEmpty: true,
                            action: function (filter, selected) {
                                return openDialogSendMessage(selected, false)
                            }
                        })
                    ]
                },
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getSendAction(), {
                            name: 'Send Campaign To All ',
                            action: function (filter, selected) {
                                return sendCampaignToAll(selected)
                            },
                            disabled: function (filter) {
                                return filter.campaignId == null;
                            }
                        })
                    ]
                },
            ],
            filters: [
                {
                    name: 'campaignId',
                    visible: false
                }
            ],
            filterCallback: function (filter) {
                vm.filter = filter;
            }
        }

        vm.transition = transition;

        function transition() {
            if (vm.dtInstance.reloadData) {
                CoreService.setStorage('filterCampaignOutreach', vm.filter);
                vm.dtInstance.reloadData();
            }
        }

        function selectCampaign(filter) {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/campaign/outreach-campaign/outreach-campaign-select-campaign-dialog.html',
                    controller: 'OutReachCampaignSelectCampaignDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'lg',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        filter: function () {
                            return {
                                facilityId: CoreService.getCurrentFacility().id,
                            };
                        }
                    }
                }).result.then(function (result) {
                    filter.campaignId = result.id;

                    vm.descriptor.title = "Outreach Campaigns - " + result.name;

                    resolve();
                });
            })
        }

        function sendCampaignToAll() {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/campaign/outreach-campaign/message-all-check-dialog.html',
                    controller: 'MessageAllCheckController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        totalCharts: function () {
                            return vm.filter.totalItems;
                        }
                    }
                }).result.then(function () {
                    openDialogSendMessage([], true).then(function () {
                        resolve();
                    });
                });
            })
        }

        function openDialogSendMessage(selected, all) {
            return $q(function (resolve, reject) {
                $uibModal.open({
                    templateUrl: 'app/entities/campaign/outreach-campaign/message-campaign-dialog.html',
                    controller: 'MessageCampaignDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        chartIds: function () {
                            return _.map(selected, function (item) {
                                return item.id;
                            });
                        },
                        campaignId: function () {
                            return vm.filter.campaignId;
                        },
                        all: function () {
                            return all;
                        }
                    }
                }).result.then(function () {
                    resolve();
                }, function () {
                    resolve();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MessageCampaignDialogController', MessageCampaignDialogController);

    MessageCampaignDialogController.$inject = ['$uibModalInstance', 'Greeting', 'CoreService', 'FacilityPhoneNumber',
        'chartIds', 'Campaign', 'toastr', 'campaignId', 'all'];

    function MessageCampaignDialogController($uibModalInstance, Greeting, CoreService, FacilityPhoneNumber,
                                             chartIds, Campaign, toastr, campaignId, all) {
        var vm = this;

        vm.message = {};
        vm.message.greeting = {}
        vm.greetings = Greeting.byFilter({facilityId: CoreService.getCurrentFacility().id});
        vm.facilitiesPhoneNumbers = FacilityPhoneNumber.byFilter({facilityId: CoreService.getCurrentFacility().id});

        vm.clear = clear;
        vm.sendMessage = sendMessage;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function sendMessage() {
            vm.isSaving = true;

            Campaign.sendMessage({
                chartIds: chartIds,
                facilityPhoneNumberId: vm.message.facilityPhoneNumber.id,
                greetingId: vm.message.greeting.id,
                message: vm.message.message,
                campaignId: campaignId,
                all: all
            }, function (data) {
                if (data.value == 0) {
                    toastr.success('Messages have been sent successfully');
                } else if (data.value == chartIds.length) {
                    toastr.error('Messages have not been sent');
                } else {
                    toastr.info(data.value + ' messages have not been sent');
                }
                $uibModalInstance.close();
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MessageAllCheckController', MessageAllCheckController);

    MessageAllCheckController.$inject = ['$uibModalInstance', 'totalCharts'];

    function MessageAllCheckController($uibModalInstance, totalCharts) {
        var vm = this;

        vm.totalCharts = totalCharts;

        vm.clear = clear;
        vm.confirmSend = confirmSend;

        function confirmSend() {
            $uibModalInstance.close(true);
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CampaignController', CampaignController);

    CampaignController.$inject = ['GenericEntityDatatableService', 'Campaign', 'CoreService', '$uibModal', '$q',
        'toastr', 'GUIUtils', 'ConfirmationService'];

    function CampaignController(GenericEntityDatatableService, Campaign, CoreService, $uibModal, $q,
                                toastr, GUIUtils, ConfirmationService) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Campaigns',
            newButtonTitle: 'New Campaign',
            entityClassHumanized: 'Campaigns',
            entityStateName: 'campaign',
            service: Campaign,
            serviceMethod: 'byFilter',
            params: params,
            pagination: 'remote',
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Enable',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.active);
                    }
                },
                {
                    name: 'gender',
                    title: 'Gender',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Campaign',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/campaign/update/campaign-dialog.html',
                controller: 'CampaignDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'lg',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            facility: CoreService.getCurrentFacility(),
                            name: null,
                            active: true,
                            dischargeRangeStart: null,
                            dischargeRangeEnd: null,
                            ageRangeStart: null,
                            ageRangeEnd: null,
                            gender: null,
                            insuranceCarriers: [],
                            typePaymentMethods: [],
                            evaluationTemplates: [],
                            campaignPolicyNumbers: [],
                            campaignChartStatus: [],
                            campaignEvaluationStatus: []
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/campaign/update/campaign-dialog.html',
                controller: 'CampaignDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Campaign', function (Campaign) {
                        return Campaign.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Campaign').result.then(function () {
                    Campaign.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('campaign', {
                parent: 'entity',
                url: '/campaign',
                data: {
                    authorities: [],
                    pageTitle: 'Campaigns'
                },
                ncyBreadcrumb: {
                    label: 'Campaigns'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/campaign/list/campaign.html',
                        controller: 'CampaignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CAMPAIGN];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_CAMPAIGN, access);
                }]
            })
            .state('outreach-campaign', {
                parent: 'entity',
                url: '/outreach-campaign',
                data: {
                    authorities: [],
                    pageTitle: 'OutreachCampaign'
                },
                ncyBreadcrumb: {
                    label: 'Outreach Campaigns',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/campaign/outreach-campaign/outreach-campaign.html',
                        controller: 'OutreachCampaignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return CoreService.readCampaignOutreachFromLocalStore();
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_OUTREACH_CAMPAIGNS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_OUTREACH_CAMPAIGNS, access);
                }]
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BusinessCredentialDialogController', BusinessCredentialDialogController);

    BusinessCredentialDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'BusinessCredential', 'Employee', 'CoreService'];

    function BusinessCredentialDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                                 BusinessCredential, Employee, CoreService) {
        var vm = this;

        vm.businessCredential = entity;
        vm.credentials = Employee.credentials();
        vm.roles = [];

        BusinessCredential.getAvailableBusinessRoles({id: CoreService.getCurrentFacility().id}, function (result) {
            vm.roles = result;

            if (vm.businessCredential.id) {
                vm.roles.push(vm.businessCredential.businessRole);
            }
        });

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.businessCredential.id !== null) {
                BusinessCredential.update(vm.businessCredential, onSaveSuccess, onSaveError);
            } else {
                BusinessCredential.save(vm.businessCredential, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:businessCredentialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('BusinessCredential', BusinessCredential);

    BusinessCredential.$inject = ['$resource', 'Utils'];

    function BusinessCredential($resource, Utils) {
        var resourceUrl = 'api/business-credentials/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    if (data.credentials) {
                        data.credentials = Utils.objectRoleToArray(data.credentials);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'byFacility': {method: 'GET', url: 'api/business-credentials/by-facility/:id', isArray: true},
            'getBusinessRoles': {method: 'GET', url: 'api/business-credentials/get-business-roles', isArray: true},
            'getCredentialByRole': {method: 'GET', url: 'api/business-credentials/get-by-role/:businessRole/:id', isArray: true},
            'getAvailableBusinessRoles': {method: 'GET', url: 'api/business-credentials/get-available-business-roles/:id', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BusinessCredentialController', BusinessCredentialController);

    BusinessCredentialController.$inject = ['GenericEntityDatatableService', 'BusinessCredential', 'CoreService',
        '$uibModal', '$q', 'ConfirmationService'];

    function BusinessCredentialController(GenericEntityDatatableService, BusinessCredential, CoreService,
                                          $uibModal, $q, ConfirmationService) {

        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        };

        vm.descriptor = {
            title: 'Business Credential',
            newButtonTitle: 'New Business Credential',
            entityClassHumanized: 'Business Credential',
            entityStateName: 'business-credential',
            service: BusinessCredential,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'businessRole',
                    title: 'Business Role',
                },
                {
                    name: null,
                    title: 'Credentials',
                    render: function (data) {
                        return _.map(data.credentials, 'name').join(', ');
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('business-credential'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('business-credential'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Business Credential',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/business-credential/update/business-credential-dialog.html',
                controller: 'BusinessCredentialDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            role: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/business-credential/update/business-credential-dialog.html',
                controller: 'BusinessCredentialDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['BusinessCredential', function (BusinessCredential) {
                        return BusinessCredential.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Business Credential').result.then(function () {
                    BusinessCredential.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('business-credential', {
                parent: 'entity',
                url: '/business-credential',
                data: {
                    authorities: [],
                    pageTitle: 'BusinessCredentials'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/business-credential/list/business-credential.html',
                        controller: 'BusinessCredentialController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Business Credentials'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL];

                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BuildingDialogController', BuildingDialogController);

    BuildingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Building', 'Facility',
        'Room', 'CoreService'];

    function BuildingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Building, Facility,
                                       Room, CoreService ) {
        var vm = this;

        vm.building = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.building.id !== null) {
                Building.update(vm.building, onSaveSuccess, onSaveError);
            } else {
                Building.save(vm.building, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:buildingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Building', Building);

    Building.$inject = ['$resource'];

    function Building ($resource) {
        var resourceUrl =  'api/buildings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byFacility': {url: 'api/buildings/by-facility/:id', method: 'GET', isArray: true},
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BuildingController', BuildingController);

    BuildingController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Building', '$uibModal',
        'ConfirmationService', '$q'];

    function BuildingController(GenericEntityDatatableService, CoreService, Building, $uibModal,
                                ConfirmationService, $q) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Buildings',
            newButtonTitle: 'New Building',
            entityClassHumanized: 'Buildings',
            entityStateName: 'building',
            service: Building,
            serviceMethod: 'byFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Building',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/building/update/building-dialog.html',
                controller: 'BuildingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/building/update/building-dialog.html',
                controller: 'BuildingDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Building', function (Building) {
                        return Building.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Building').result.then(function () {
                    Building.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('building', {
                parent: 'entity',
                url: '/building',
                data: {
                    authorities: [],
                    pageTitle: 'Buildings'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/building/list/building.html',
                        controller: 'BuildingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BUILDING];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BUILDING, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BlockedTimeReasonDialogController', BlockedTimeReasonDialogController);

    BlockedTimeReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BlockedTimeReason', 'Facility'];

    function BlockedTimeReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BlockedTimeReason, Facility) {
        var vm = this;

        vm.blockedTimeReason = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facilities = Facility.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.blockedTimeReason.id !== null) {
                BlockedTimeReason.update(vm.blockedTimeReason, onSaveSuccess, onSaveError);
            } else {
                BlockedTimeReason.save(vm.blockedTimeReason, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:blockedTimeReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BlockedTimeReasonDeleteController',BlockedTimeReasonDeleteController);

    BlockedTimeReasonDeleteController.$inject = ['$uibModalInstance', 'entity', 'BlockedTimeReason'];

    function BlockedTimeReasonDeleteController($uibModalInstance, entity, BlockedTimeReason) {
        var vm = this;

        vm.blockedTimeReason = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BlockedTimeReason.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('blocked-time-reason', {
                parent: 'entity',
                url: '/blocked-time-reason',
                data: {
                    authorities: [],
                    pageTitle: 'BlockedTimeReasons'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/blocked-time-reason/blocked-time-reasons.html',
                        controller: 'BlockedTimeReasonController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access);
                }]
            })
            .state('blocked-time-reason.new', {
                parent: 'blocked-time-reason',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/blocked-time-reason/blocked-time-reason-dialog.html',
                            controller: 'BlockedTimeReasonDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        facility: CoreService.getCurrentFacility()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('blocked-time-reason', null, {reload: 'blocked-time-reason'});
                        }, function () {
                            $state.go('blocked-time-reason');
                        });
                    }
                }]
            })
            .state('blocked-time-reason.edit', {
                parent: 'blocked-time-reason',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/blocked-time-reason/blocked-time-reason-dialog.html',
                            controller: 'BlockedTimeReasonDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['BlockedTimeReason', function (BlockedTimeReason) {
                                    return BlockedTimeReason.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('blocked-time-reason', null, {reload: 'blocked-time-reason'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('blocked-time-reason.delete', {
                parent: 'blocked-time-reason',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/blocked-time-reason/blocked-time-reason-delete-dialog.html',
                            controller: 'BlockedTimeReasonDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['BlockedTimeReason', function (BlockedTimeReason) {
                                    return BlockedTimeReason.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('blocked-time-reason', null, {reload: 'blocked-time-reason'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('BlockedTimeReason', BlockedTimeReason);

    BlockedTimeReason.$inject = ['$resource'];

    function BlockedTimeReason ($resource) {
        var resourceUrl =  'api/blocked-time-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('BlockedTimeReasonSearch', BlockedTimeReasonSearch);

    BlockedTimeReasonSearch.$inject = ['$resource'];

    function BlockedTimeReasonSearch($resource) {
        var resourceUrl =  'api/_search/blocked-time-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BlockedTimeReasonController', BlockedTimeReasonController);

    BlockedTimeReasonController.$inject = ['$scope', '$state', 'BlockedTimeReason', 'BlockedTimeReasonSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', 'CoreService', '$compile'];

    function BlockedTimeReasonController ($scope, $state, BlockedTimeReason, BlockedTimeReasonSearch, $q, DTColumnBuilder,
                                          DTOptionsBuilder, GUIUtils, $filter, CoreService, $compile) {
        var vm = this;

        vm.entityClassHumanized = 'Blocked Time Reasons';
        vm.entityStateName = 'blocked-time-reason';
        vm.blockedTimeReasons = [];
        vm.dtInstance = {};

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                BlockedTimeReasonSearch.query(CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                    vm.blockedTimeReasons = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.blockedTimeReasons, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BinDialogController', BinDialogController);

    BinDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Bin'];

    function BinDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Bin) {
        var vm = this;

        vm.bin = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.bin.id !== null) {
                Bin.update(vm.bin, onSaveSuccess, onSaveError);
            } else {
                Bin.save(vm.bin, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:binUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BinDeleteController',BinDeleteController);

    BinDeleteController.$inject = ['$uibModalInstance', 'entity', 'Bin'];

    function BinDeleteController($uibModalInstance, entity, Bin) {
        var vm = this;

        vm.bin = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Bin.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bin', {
                parent: 'entity',
                url: '/bin',
                data: {
                    authorities: [],
                    pageTitle: 'Bins'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bin/bins.html',
                        controller: 'BinController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Bin'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BIN];
                        return Auth.loadActionsAccess(actions);
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BIN, access);
                }]
            })
            .state('bin.new', {
                parent: 'bin',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BIN, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/bin/bin-dialog.html',
                            controller: 'BinDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('bin', null, {reload: 'bin'});
                        }, function () {
                            $state.go('bin');
                        });
                    }
                }]
            })
            .state('bin.edit', {
                parent: 'bin',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BIN, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/bin/bin-dialog.html',
                            controller: 'BinDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['Bin', function (Bin) {
                                    return Bin.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('bin', null, {reload: 'bin'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('bin.delete', {
                parent: 'bin',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BIN, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/bin/bin-delete-dialog.html',
                            controller: 'BinDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['Bin', function (Bin) {
                                    return Bin.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('bin', null, {reload: 'bin'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Bin', Bin);

    Bin.$inject = ['$resource'];

    function Bin ($resource) {
        var resourceUrl =  'api/bins/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('BinSearch', BinSearch);

    BinSearch.$inject = ['$resource'];

    function BinSearch($resource) {
        var resourceUrl =  'api/_search/bins/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BinController', BinController);

    BinController.$inject = ['$state', 'BinSearch', '$q', 'DTColumnBuilder' , 'DTOptionsBuilder', 'GUIUtils', '$filter', 'CoreService', '$compile', '$scope'];

    function BinController ($state, BinSearch, $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter, CoreService, $compile, $scope ) {
        var vm = this;

        vm.bins = [];
        vm.dtInstance = {};
        vm.title = 'Bin';
        vm.entityClassHumanized = 'Bin';
        vm.entityStateName = 'bin';
        vm.corporation = CoreService.getCorporation();

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                BinSearch.query(CoreService.getFilterByCurrentCorporation(), function (result, headers) {
                    vm.bins = result;
                    defer.resolve(result);
                });
            }else {
                defer.resolve($filter('filter')(vm.bins, vm.searchQuery, undefined));
            }
            return defer.promise;
        }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
            "paginate": {
                "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
            }
        })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback', function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
    })();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BillingScheduleDialogController', BillingScheduleDialogController);

    BillingScheduleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'BillingSchedule', 'Employee', 'CoreService'];

    function BillingScheduleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity,
        BillingSchedule, Employee, CoreService) {
        var vm = this;

        vm.billingSchedule = entity;

        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.billingSchedule.id !== null) {
                BillingSchedule.update(vm.billingSchedule, onSaveSuccess, onSaveError);
            } else {
                BillingSchedule.save(vm.billingSchedule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:billingScheduleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function getEmployees(query) {
            if (query) {
                var filter = {page: 0, size: 10, query: query, corporationId: CoreService.getCorporation().id};

                Employee.findAllByCorporation(filter, function (result) {
                    vm.employees = result;
                });
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('BillingSchedule', BillingSchedule);

    BillingSchedule.$inject = ['$resource'];

    function BillingSchedule ($resource) {
        var resourceUrl =  'api/billing-schedules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BillingScheduleController', BillingScheduleController);

    BillingScheduleController.$inject = ['GenericEntityDatatableService', 'BillingSchedule', '$q', '$uibModal',
        'toastr', 'ConfirmationService'];

    function BillingScheduleController(GenericEntityDatatableService, BillingSchedule, $q,
                                        $uibModal, toastr, ConfirmationService) {
        var vm = this;

        vm.totalItems = 0;

        vm.descriptor = {
            title: 'Billing Schedule',
            newAction: false,
            entityClassHumanized: 'Billing Schedule',
            entityStateName: 'billing-schedule',
            service: BillingSchedule,
            serviceMethod: 'query',
            columns: [
                {
                    name: 'emails',
                    title: 'emails'
                },
                {
                    name: null,
                    title: 'Users',
                    render: function (data) {
                        var userList = [];
                        data.employees.forEach(function(item){
                           userList.push(item.user.login);
                        })
                        return userList.join(", ");
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Billing Schedule',
                            action: function () {
                                return add();
                            },
                            ngIf: function (filter) {
                                return vm.totalItems === 0;
                            }
                        })
                    ]
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-schedule/update/billing-schedule-dialog.html',
                    controller: 'BillingScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: [function () {
                            return {
                                id: null
                            };
                        }]
                    }
                }).result.then(function () {
                    toastr.success('Billing Schedule was saved', 'Success');

                    resolve();
                });
            })
        }

        function edit(id) {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/billing-schedule/update/billing-schedule-dialog.html',
                    controller: 'BillingScheduleDialogController',
                    controllerAs: 'vm',
                    backdrop: false,
                    keyboard: false,
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['BillingSchedule', function (BillingSchedule) {
                            return BillingSchedule.get({id: id}).$promise;
                        }]
                    }
                }).result.then(function () {
                    toastr.success('Billing Schedule was saved', 'Success');

                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Billing Schedule').result.then(function () {
                    BillingSchedule.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('billing-schedule', {
                parent: 'entity',
                url: '/billing-schedule',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'BillingSchedule'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/billing-schedule/list/billing-schedule.html',
                        controller: 'BillingScheduleController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedDialogController', BedDialogController);

    BedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Bed', 'Room', 'CoreService'];

    function BedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Bed, Room, CoreService) {
        var vm = this;

        vm.bed = entity;
        vm.facility = CoreService.getCurrentFacility();
        vm.rooms = Room.byfacility({id: vm.facility.id});
        vm.status = ['ACTIVE','MAINTENANCE','CLEANING','INACTIVE'];

        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save () {
            vm.isSaving = true;
            if (vm.bed.id !== null) {
                Bed.update(vm.bed, onSaveSuccess, onSaveError);
            } else {
                Bed.save(vm.bed, onSaveSuccess, onSaveError);
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:bedUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Bed', Bed);

    Bed.$inject = ['$resource'];

    function Bed ($resource) {
        var resourceUrl =  'api/beds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllByFacility': {url: 'api/beds/facility/:id', method: 'GET', isArray: true},
            'getWithChart': {url: 'api/beds-chart/:id', method: 'GET'},
            'findAllActive': {url: 'api/beds/find-all-active/:id', method: 'GET', isArray: true},
            'byBuilding': {url: 'api/beds/building/:id', method: 'GET', isArray: true},
            'getBedsByIds': {url:'api/beds/ids', method: 'POST', isArray: true},
            'update': {method:'PUT'},
            'findAllActiveIncludeChartBed': {url: 'api/beds/find-all-active/:id/:idBed', method: 'GET', isArray: true},
            'sheetFilter': {'url': 'api/beds/sheet/filter', method: 'GET', isArray: true},
            'changeStatus': {url: 'api/beds/sheet/change-status', method: 'POST', isArray: false},
            'findAllEmptyAndActive': {url: 'api/beds/find-all-empty-and-active/:id' , method: 'GET', isArray: true},
            'assignToChart': {url: 'api/beds/assign-to-chart', method: 'POST', isArray: false},
            'remove': {url: 'api/beds/remove', method: 'POST'},
            'countAllEmptyAndActive': {
                url: 'api/beds/count-all-empty-and-active/:id', method: 'GET', isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countAllOccupiedAndActive': {
                url: 'api/beds/count-all-occupied-and-active/:id', method: 'GET', isArray: false,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedController', BedController);

    BedController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Bed', '$uibModal', 'ConfirmationService', '$q'];

    function BedController(GenericEntityDatatableService, CoreService, Bed, $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Beds',
            newButtonTitle: 'New Bed',
            entityClassHumanized: 'Beds',
            entityStateName: 'bed',
            service: Bed,
            serviceMethod: 'getAllByFacility',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Room',
                    render: function (data) {
                        return data.room.name + " [" + data.room.sex + "]";
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Bed',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/bed/upload/bed-dialog.html',
                controller: 'BedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            notes: null,
                            status: null,
                            actualChart: null,
                            facility: CoreService.getCurrentFacility(),
                            id: null
                        };
                    }
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/bed/upload/bed-dialog.html',
                controller: 'BedDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Bed', function (Bed) {
                        return Bed.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Bed').result.then(function () {
                    Bed.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedSheetStatusDialogController', BedSheetStatusDialogController);

    BedSheetStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'Bed', 'CoreService', 'bed', 'toastr'];

    function BedSheetStatusDialogController($timeout, $scope, $stateParams, $uibModalInstance, Bed, CoreService, bed, toastr) {
        var vm = this;

        vm.status = ['ACTIVE', 'CLEANING', 'MAINTENANCE'];
        vm.bed = bed;
        vm.bedStatus = vm.bed.status;

        vm.clear = clear;
        vm.save = save;

        function save() {
            if (vm.bedStatus !== vm.bed.status) {

                Bed.changeStatus({
                    bedId: vm.bed.id,
                    bedStatus: vm.bedStatus
                }, function (bed) {
                    if (bed != null) {
                        toastr.success('Status bed changed successfully');
                    } else {
                        toastr.error('Status bed changed fail');
                    }
                    $uibModalInstance.close();
                });
            } else {
                vm.clear()
            }

        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedSheetAssignDialogController', BedSheetAssignDialogController);

    BedSheetAssignDialogController.$inject = ['$uibModal', '$compile', '$scope', 'moment', 'Chart', 'DateUtils',
        'CoreService', '$q', 'DTColumnBuilder', 'DTOptionsBuilder', 'GUIUtils', '$filter',
        '$rootScope', 'toastr', 'DataTablesService', 'bed', '$uibModalInstance', 'Bed'];

    function BedSheetAssignDialogController($uibModal, $compile, $scope, moment, Chart, DateUtils, CoreService,
                                            $q, DTColumnBuilder, DTOptionsBuilder, GUIUtils, $filter,
                                            $rootScope, toastr, DataTablesService, bed, $uibModalInstance, Bed) {
        var vm = this;

        vm.dtInstance = {};
        vm.title = "Charts Assign Bed";
        vm.facility = CoreService.getCurrentFacility();
        vm.charts = [];
        vm.disableTitle = false;
        vm.bed = bed;
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.search = search;
        vm.assign = assign;
        vm.clear = clear;
        vm.transition = transition;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            Chart.fullFilter(getFilter(), function (result, headers) {
                vm.charts = result;
                vm.totalItems = headers('X-Total-Count');
                defer.resolve(result);
            });

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withOption('aaSorting', [])
            .withDOM('ltp').withOption("bLengthChange", false).withOption("bPaginate", false)
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                })
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').notSortable().renderWith(function (data, type, full) {
                return data.lastName + ", " + data.firstName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Date Birth').notSortable().renderWith(function (data, type, full) {
                return moment(data.dateBirth).format($rootScope.dateFormat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Mr Number').notSortable().renderWith(function (data, type, full) {
                return data.mrNo;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Admission Date').notSortable().renderWith(function (data, type, full) {
                return moment(data.admissionDate).format($rootScope.dateFormat);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Discharge Date').notSortable().renderWith(function (data, type, full) {
                return data.dischargeDate != null ? moment(data.dischargeDate).format($rootScope.dateFormat) : " ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Referral Source').notSortable().renderWith(function (data, type, full) {
                return data.referrer ? data.referrer : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').notSortable().renderWith(actionsHtml)

        ];

        function actionsHtml(data, type, full, meta) {

            return '<div class="btn-group dd-buttons" uib-dropdown>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ng-click="vm.assign(' + data.id + ')">' +
                '<i class="fa fa-bed" aria-hidden="true"></i> Assign Bed' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.page = 1;
            vm.dtInstance.reloadData();
        }

        function getFilter() {
            var filter = {};

            filter.facilityId = vm.facility.id;
            filter.searchQuery = vm.searchQuery;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.noBed = true;
            filter.statuses = 'CURRENT';

            return filter;
        }

        function assign(idChart) {
            Bed.assignToChart({
                chartId: idChart,
                bedId: vm.bed.id
            }, function () {
                toastr.success('Assign operation successfully');
                $uibModalInstance.close();
            }, function (error) {
                toastr.error('Assign operation fail');
                $uibModalInstance.close();
            });
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function transition() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedSheetController', BedSheetController);

    BedSheetController.$inject = ['$scope', '$state', '$q', '$filter', 'CoreService', 'Building', 'Bed', 'filter',
        '$log', '$uibModal', 'Chart', 'dialogs'];

    function BedSheetController($scope, $state, $q, $filter, CoreService, Building, Bed, filter,
                                $log, $uibModal, Chart, $dialogs) {
        var vm = this;

        vm.title = 'Bed Sheet';
        vm.entityClassHumanized = 'Bed Sheet';
        vm.filter = filter;
        vm.building = null;
        vm.bedsFilter = {};
        vm.countAllEmpty = 0;
        vm.countAllOccupied = 0;

        vm.search = search;
        vm.openChart = openChart;
        vm.assignBed = assignBed;
        vm.filterGender = filterGender;
        vm.changeStatusBed = changeStatusBed;
        vm.updateCurrentBuilding = updateCurrentBuilding;
        vm.getBedSheetPdf = getBedSheetPdf;
        vm.remove = remove;

        loadBuildings();

        function loadBuildings() {
            Building.byFacility({id: CoreService.getCurrentFacility().id}, function (buildings) {
                vm.buildings = buildings;

                if (vm.buildings != null) {
                    if (vm.filter.buildingId != null) {
                        vm.building = _.find(buildings, function (building) {
                            return building.id === vm.filter.buildingId;
                        });
                    } else {
                        vm.building = buildings[0];
                        vm.filter.buildingId = vm.building.id;
                    }
                    loadBeds();
                }
            })
        }

        function updateCurrentBuilding() {
            vm.filter.buildingId = vm.building.id;
            CoreService.setStorage('filterBedSheet', vm.filter);
            loadBeds();
        }

        function loadBeds() {
            Bed.sheetFilter(vm.filter, function (result) {
                result = addFullName(result);
                vm.beds = result;
                vm.bedsFilter = vm.beds;

                if (!vm.filter.searchQuery || vm.filter.searchQuery === '') {
                    vm.rooms = groupByRooms(result);
                } else {
                    vm.rooms = groupByRooms($filter('filter')(vm.bedsFilter, vm.filter.searchQuery, undefined))
                }
            });
            Bed.countAllEmptyAndActive({id: CoreService.getCurrentFacility().id}, function (data) {
                if (data.value) {
                    vm.countAllEmpty = data.value;
                }
            });
            Bed.countAllOccupiedAndActive({id: CoreService.getCurrentFacility().id}, function (data) {
                if (data.value) {
                    vm.countAllOccupied = data.value;
                }
            });
        }

        function filterGender(gender) {
            vm.filter.gender = gender;
            CoreService.setStorage('filterBedSheet', vm.filter);
            vm.initial = true;
            loadBeds();
        }

        function search() {
            CoreService.setStorage('filterBedSheet', vm.filter);

            if (vm.filter.searchQuery && vm.filter.searchQuery !== '') {
                vm.rooms = groupByRooms($filter('filter')(vm.bedsFilter, vm.filter.searchQuery, undefined))
            }
        }

        function groupByRooms(result) {
            return _.chain(result)
                .groupBy("roomName")
                .map(function (beds, roomName) {
                    return {beds: beds, roomName: roomName};
                })
                .value();
        }

        function addFullName(result) {
            return _.forEach(result, function (data) {
                data.fullName = data.firstName + " " + data.lastName;
            });
        }

        function openChart(chartId) {
            if (chartId != null) {
                $state.go('chart', {id: chartId})
            }
        }

        function assignBed(id) {
            $uibModal.open({
                templateUrl: 'app/entities/bed/bed-sheet/bed-sheet-assign.html',
                controller: 'BedSheetAssignDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    bed: ['Bed', function (Bed) {
                        return Bed.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadBeds();
            }, function () {
                loadBeds();
            });
        }

        function changeStatusBed(id) {
            $uibModal.open({
                templateUrl: 'app/entities/bed/bed-sheet/bed-sheet-status.html',
                controller: 'BedSheetStatusDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    bed: ['Bed', function (Bed) {
                        return Bed.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadBeds();
            }, function () {
                loadBeds();
            });
        }

        function getBedSheetPdf() {
            Chart.getBedsheetPdf({id: vm.building.id});
        }

        function remove(chartId) {
            var dlg = $dialogs.confirm('Please Confirm', 'Are you sure you want to remove this Bed?', {size: 'md'});
            dlg.result.then(function (btn) {
                Bed.remove({id: chartId}, function () {
                    loadBeds();
                }, function () {
                    loadBeds();
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('bed', {
                parent: 'entity',
                url: '/bed',
                data: {
                    authorities: [],
                    pageTitle: 'Beds'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bed/list/bed.html',
                        controller: 'BedController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BED];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BED, access);
                }]
            })
            .state('bed-sheet', {
                parent: 'entity',
                url: '/bed-sheet',
                data: {
                    authorities: [],
                    pageTitle: 'Bed Sheet'
                },
                ncyBreadcrumb: {
                    label: 'Bed Sheet'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bed/bed-sheet/bed-sheet.html',
                        controller: 'BedSheetController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    filter: ['CoreService', function (CoreService) {
                        return CoreService.readBedSheetFromLocalStore();
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_BED_SHEET];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_BED_SHEET, access);
                }]
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AutoFaxDialogController', AutoFaxDialogController);

    AutoFaxDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'AutoFax', 'ContactAddress', 'CoreService'];

    function AutoFaxDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                     AutoFax, ContactAddress, CoreService) {
        var vm = this;

        vm.autoFax = entity;
        vm.clear = clear;
        vm.save = save;
        vm.contactAddresses = ContactAddress.faxeable({id: CoreService.getCurrentFacility().id});

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.autoFax.id !== null) {
                AutoFax.update(vm.autoFax, onSaveSuccess, onSaveError);
            } else {
                AutoFax.save(vm.autoFax, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:autoFaxUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('AutoFax', AutoFax);

    AutoFax.$inject = ['$resource'];

    function AutoFax ($resource) {
        var resourceUrl =  'api/auto-faxes/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByFacility': {url: 'api/auto-faxes/facility/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AutoFaxController', AutoFaxController);

    AutoFaxController.$inject = ['GenericEntityDatatableService', 'AutoFax', 'CoreService', '$q', '$uibModal'];

    function AutoFaxController(GenericEntityDatatableService, AutoFax, CoreService, $q, $uibModal) {
        var vm = this;

        vm.totalItems = 0;

        var params = {
            id: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'AutoFax',
            entityClassHumanized: 'AutoFax',
            entityStateName: 'auto-fax',
            service: AutoFax,
            serviceMethod: 'getByFacility',
            newAction: false,
            params: params,
            columns: [
                {
                    name: null,
                    title: 'Contact Address',
                    render: function (data) {
                        return data ? data.contactAddress.name : '';
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return editAutoFaxes(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return deleteAutoFaxes(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Auto Fax',
                            ngIf: function (filter) {
                                return vm.totalItems === 0
                            },
                            action: function () {
                                return newAutoFaxes();
                            }
                        }),
                    ],
                },
            ],
            filterCallback: function (filter) {
                vm.totalItems = filter.totalItems;
            }
        }

        function newAutoFaxes() {
            return $uibModal.open({
                templateUrl: 'app/entities/auto-fax/update/auto-fax-dialog.html',
                controller: 'AutoFaxDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function editAutoFaxes(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/auto-fax/update/auto-fax-dialog.html',
                controller: 'AutoFaxDialogController',
                controllerAs: 'vm',
                backdrop: false,
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['AutoFax', function (AutoFax) {
                        return AutoFax.get({id: id}).$promise;
                    }]
                }
            }).result;
        }


        function deleteAutoFaxes(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('AutoFax').result.then(function () {
                    AutoFax.delete({id: id}, function () {
                        resolve();
                    });
                })
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('auto-fax', {
                parent: 'entity',
                url: '/auto-fax',
                data: {
                    pageTitle: 'AutoFaxes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/auto-fax/list/auto-fax.html',
                        controller: 'AutoFaxController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_AUTO_FAX];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_AUTO_FAX, access);
                }]
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RoleDialogController', RoleDialogController);

    RoleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'AuthItem', 'AUTH_ITEM_TYPE', '$filter', 'CoreService'];

    function RoleDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                  AuthItem, AUTH_ITEM_TYPE, $filter, CoreService) {

        var vm = this;

        vm.authItem = entity;
        vm.children = angular.copy(vm.authItem.children);
        vm.roleFilterText = '';
        vm.resourceFilterText = '';
        vm.actionFilterText = '';
        vm.selectedAllRoles = false;
        vm.selectedAllResources = false;
        vm.selectedAllActions = false;
        vm.rolesLoaded = false;
        vm.resourcesLoaded = false;
        vm.actionsLoaded = false;
        vm.corporation = CoreService.getCorporation();
        vm.allRoles = getAllRoles();
        vm.allResources = getAllResources();
        vm.allActions = getAllActions();
        vm.showRoles = true;

        vm.clear = clear;
        vm.save = save;
        vm.roleFilter = roleFilter;
        vm.resourceFilter = resourceFilter;
        vm.actionFilter = actionFilter;
        vm.selectRole = selectRole;
        vm.selectAllRoles = selectAllRoles;
        vm.selectResource = selectResource;
        vm.selectAllResources = selectAllResources;
        vm.selectAction = selectAction;
        vm.selectAllActions = selectAllActions;
        vm.blacklist = blacklist;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function roleFilter() {
            vm.filteredRoles = $filter('filter')(vm.allRoles, vm.roleFilterText, undefined);
        }

        function resourceFilter() {
            vm.filteredResources = $filter('filter')(vm.allResources, vm.resourceFilterText, undefined);
        }

        function actionFilter() {
            vm.filteredActions = $filter('filter')(vm.allActions, vm.actionFilterText, undefined);
        }

        function selectAuthItemRecursive(authItem, authItems) {

            if (authItem.children && authItem.children.length > 0) {
                for (var i = 0; i < authItem.children.length; i++) {
                    var index = _.findIndex(authItems, function (item) {
                        return item.id === authItem.children[i].child.id;
                    });
                    if (index !== -1) {
                        authItems[index].checked = true;
                    }
                    selectAuthItemRecursive(authItem.children[i].child, authItems);
                }
            } else {
                var index = _.findIndex(authItems, function (item) {
                    return item.id === authItem.id;
                });
                if (index !== -1) {
                    authItems[index].checked = true;
                }
            }
        }

        function resetModel(authItem, status) {

            //We search if exist and remove it.
            var index = _.findIndex(vm.children, function (item) {
                return item.child.id === authItem.id;
            });
            if (index !== -1) {
                vm.children.splice(index, 1);
            }
            //If th status is true
            if (status) {
                var authItemChild = {
                    id: null,
                    parent: null,
                    child: authItem
                };
                vm.children.push(authItemChild);
            }
        }

        function updateModel(authItem, status) {

            resetModel(authItem, status);
            //We search avery child and remove it in case this exists.
            AuthItem.get({id: authItem.id}, function (res) {
                _.forEach(res.children, function (child) {
                    var i = _.findIndex(vm.children, function (item) {
                        return item.child.id === child.child.id;
                    });
                    if (i !== -1) {
                        vm.children.splice(i, 1);
                    }
                });
            });
        }

        function getAllRoles() {

            return AuthItem.queryByType({
                type: AUTH_ITEM_TYPE.TYPE_ROLE,
                id: vm.corporation.id
            }, function (result) {
                //we set all roles the first time and filter the editing role to avoid infinite loop.
                if (vm.authItem.id) {
                    vm.filteredRoles = _.filter(result, function (role) {
                        return vm.authItem.id !== role.id &&
                            (
                                role.children == null ||
                                !_.some(role.children,function (credentialChild) {
                                    return credentialChild.child != null && credentialChild.child.id === vm.authItem.id;
                                })
                            )
                    });

                    // vm.filteredRoles = $filter('filter')(result, {id: vm.authItem.id}, function (actual, expected) {
                    //     return actual !== expected;
                    // });
                } else {
                    vm.filteredRoles = result;
                }
                // vm.children.push(vm.filteredRoles);
                selectAuthItemRecursive(vm.authItem, vm.filteredRoles);

                vm.showRoles = _.some(vm.filteredRoles, function(item) {
                    return item.checked && item.name !== 'ROLE_USER';
                })
            });
        }

        function getAllResources() {

            return AuthItem.queryByType({
                type: AUTH_ITEM_TYPE.TYPE_RESOURCE,
                id: vm.corporation.id
            }, function (result) {
                //we set all resources the first time.
                vm.filteredResources = result;
                // vm.children.push(vm.filteredResources);
                selectAuthItemRecursive(vm.authItem, vm.filteredResources);
            });
        }

        function getAllActions() {

            return AuthItem.queryByType({
                type: AUTH_ITEM_TYPE.TYPE_ACTION,
                id: vm.corporation.id
            }, function (result) {
                //we set all actions the first time.
                vm.filteredActions = result;
                // vm.children.push(vm.filteredActions);
                selectAuthItemRecursive(vm.authItem, vm.filteredActions);
            });
        }

        function selectRole(role) {

            toggleRole(role);
            for (var i = 0; i < vm.filteredRoles.length; i++) {
                if (!vm.filteredRoles[i].checked) {
                    vm.selectedAllRoles = false;
                    return;
                }
            }
            vm.selectedAllRoles = true;
        }

        function selectAllRoles() {

            for (var i = 0; i < vm.filteredRoles.length; i++) {
                vm.filteredRoles[i].checked = vm.selectedAllRoles;
                toggleRole(vm.filteredRoles[i]);
            }
        }

        function toggleRole(role) {

            updateModel(role, role.checked);
            AuthItem.get({id: role.id}, function (rol) {
                _.forEach(rol.children, function (child) {
                    var index = _.findIndex(vm.filteredResources, function (item) {
                        return item.id === child.child.id;
                    });
                    if(index !== -1){
                        vm.filteredResources[index].checked = role.checked;
                        toggleResource(vm.filteredResources[index]);
                    }
                });
            });
        }

        function selectResource(resource) {

            toggleResource(resource);
            for (var i = 0; i < vm.filteredResources.length; i++) {
                if (!vm.filteredResources[i].checked) {
                    vm.selectedAllResources = false;
                    return;
                }
            }
            vm.selectedAllResources = true;
        }

        function selectAllResources() {

            for (var i = 0; i < vm.filteredResources.length; i++) {
                vm.filteredResources[i].checked = vm.selectedAllResources;
                toggleResource(vm.filteredResources[i])
            }
        }

        function toggleResource(resource) {

            updateModel(resource, resource.checked);
            AuthItem.get({id: resource.id}, function (res) {
                _.forEach(res.children, function (child) {
                    var index = _.findIndex(vm.filteredActions, function (item) {
                        return item.id === child.child.id;
                    });
                    vm.filteredActions[index].checked = resource.checked;
                });
            });
        }

        function selectAction(action) {

            resetModel(action, action.checked);
            for (var i = 0; i < vm.filteredActions.length; i++) {
                if (!vm.filteredActions[i].checked) {
                    vm.selectedAllActions = false;
                    return;
                }
            }
            vm.selectedAllActions = true;
        }

        function selectAllActions() {

            for (var i = 0; i < vm.filteredActions.length; i++) {
                vm.filteredActions[i].checked = vm.selectedAllActions;
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.authItem.type = AUTH_ITEM_TYPE.TYPE_ROLE;
            vm.authItem.children = vm.children;
            if (vm.authItem.id !== null) {
                AuthItem.update(vm.authItem, onSaveSuccess, onSaveError);
            } else {
                AuthItem.save(vm.authItem, onSaveSuccess, onSaveError);
            }
            // vm.authItem.children = [];
            // //Loop through roles.
            // _.forEach(vm.filteredRoles, function (role) {
            //     if (role.checked) {
            //         var authItemChild = {
            //             id: null,
            //             parent: null,//vm.authItem,
            //             child: role
            //         };
            //         vm.authItem.children.push(authItemChild);
            //     }
            // });
            // //Loop through resource.
            // _.forEach(vm.filteredResources, function (resource) {
            //     if (resource.checked) {
            //         var authItemChild = {
            //             id: null,
            //             parent: null,//vm.authItem,
            //             child: resource
            //         };
            //         vm.authItem.children.push(authItemChild);
            //     }
            // });
            // //Loop through left actions.
            // _.forEach(vm.filteredActions, function (action) {
            //     if (action.checked) {
            //         var authItemChild = {
            //             id: null,
            //             parent: null,//vm.authItem,
            //             child: action
            //         };
            //         vm.authItem.children.push(authItemChild);
            //     }
            // });
            // //Ready entity for saving
            // if (vm.authItem.id !== null) {
            //     AuthItem.update(vm.authItem, onSaveSuccess, onSaveError);
            // } else {
            //     AuthItem.save(vm.authItem, onSaveSuccess, onSaveError);
            // }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:authItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function blacklist(name) {
            var ROLE_EXIST = _.filter(vm.allRoles, {name: name});

            return ROLE_EXIST.length == 0;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('role', {
                parent: 'entity',
                url: '/role?page&sort&search',
                ncyBreadcrumb: {
                    label: 'Roles'
                },
                data: {
                    authorities: [],
                    pageTitle: 'Roles'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/auth-item/roles.html',
                        controller: 'AuthItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    entityType: ['AUTH_ITEM_TYPE', function (AUTH_ITEM_TYPE) {
                        return {
                            title: 'Roles',
                            entityClassHumanized: 'Role',
                            entityStateName: 'role',
                            type: AUTH_ITEM_TYPE.TYPE_ROLE
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access);
                }]
            })
            .state('role.new', {
                parent: 'role',
                url: '/new',
                ncyBreadcrumb: {
                    label: 'New Role'
                },
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/role-dialog.html',
                            controller: 'RoleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'xl',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        id: null,
                                        name: null,
                                        type: null,
                                        description: null,
                                        data: null,
                                        children: [],
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('role', null, {reload: 'role'});
                        }, function () {
                            $state.go('role');
                        });
                    }
                }]
            })
            .state('role.edit', {
                parent: 'role',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    label: 'Edit Role'
                },
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/role-dialog.html',
                            controller: 'RoleDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'xl',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AuthItem', function (AuthItem) {
                                    return AuthItem.getRole({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('role', null, {reload: 'role'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('role.delete', {
                parent: 'role',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/auth-item-delete-dialog.html',
                            controller: 'AuthItemDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AuthItem', function (AuthItem) {
                                    return AuthItem.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('role', null, {reload: 'role'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ResourceDialogController', ResourceDialogController);

    ResourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity',
        'AuthItem', 'AUTH_ITEM_TYPE', 'CoreService', '$filter'];

    function ResourceDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity,
                                      AuthItem, AUTH_ITEM_TYPE, CoreService, $filter) {
        var vm = this;

        vm.authItem = entity;
        vm.children = angular.copy(vm.authItem.children);
        vm.authItemChildren = [];
        vm.facility = CoreService.getCurrentFacility();
        vm.actionFilterText = '';
        vm.selectedAllActions = false;
        vm.actionsLoaded = false;
        vm.corporation = CoreService.getCorporation();
        vm.allActions = getAllActions();

        vm.clear = clear;
        vm.save = save;
        vm.actionFilter = actionFilter;
        vm.selectAllActions = selectAllActions;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function actionFilter() {
            vm.filteredActions = $filter('filter')(vm.allActions, vm.actionFilterText, undefined);
        }

        function selectAllActions() {
            for (var i = 0; i < vm.filteredActions.length; i++) {
                vm.filteredActions[i].checked = vm.selectedAllActions;
            }
        }

        function getAllActions() {

            return AuthItem.queryByType({
                type: AUTH_ITEM_TYPE.TYPE_ACTION,
                id: vm.corporation.id
            }, function (result) {
                //we set all actions the first time.
                vm.filteredActions = result;
                selectAuthItems(vm.authItem, vm.filteredActions);
            });
        }

        function selectAuthItems(authItem, authItems) {
            if (authItem.children && authItem.children.length > 0) {
                for (var i = 0; i < authItem.children.length; i++) {
                    var index = _.findIndex(authItems, function (item) {
                        return item.id === authItem.children[i].child.id;
                    });

                    authItems[index].checked = index !== -1;
                }
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            vm.authItem.type = AUTH_ITEM_TYPE.TYPE_RESOURCE;
            var children =
                _.filter(vm.filteredActions, function (action) {
                    return action.checked;
                });

            vm.authItem.children = _.map(children, function (action) {
                return {
                    id: null,
                    parent: null,
                    child: action
                };
            });

            if (vm.authItem.id !== null) {
                AuthItem.update(vm.authItem, onSaveSuccess, onSaveError);
            } else {
                AuthItem.save(vm.authItem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:authItemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('resource', {
                parent: 'entity',
                url: '/resource?page&sort&search',
                ncyBreadcrumb: {
                    label: 'Resources'
                },
                data: {
                    authorities: [],
                    pageTitle: 'Resources'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/auth-item/resources.html',
                        controller: 'AuthItemController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    entityType: ['AUTH_ITEM_TYPE', function (AUTH_ITEM_TYPE) {
                        return {
                            title: 'Resources',
                            entityClassHumanized: 'Resource',
                            entityStateName: 'resource',
                            type: AUTH_ITEM_TYPE.TYPE_RESOURCE
                        };
                    }],
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access);
                }]
            })
            .state('resource.new', {
                parent: 'resource',
                url: '/new',
                ncyBreadcrumb: {
                    label: 'New Resource'
                },
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/resource-dialog.html',
                            controller: 'ResourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'xl',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        type: null,
                                        description: null,
                                        data: null,
                                        id: null,
                                        children: [],
                                        corporation: CoreService.getCorporation()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('resource', null, {reload: 'resource'});
                        }, function () {
                            $state.go('resource');
                        });
                    }
                }]
            })
            .state('resource.edit', {
                parent: 'resource',
                url: '/{id}/edit',
                ncyBreadcrumb: {
                    label: 'Edit Resource'
                },
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/resource-dialog.html',
                            controller: 'ResourceDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'xl',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AuthItem', function (AuthItem) {
                                    return AuthItem.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('resource', null, {reload: 'resource'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('resource.delete', {
                parent: 'resource',
                url: '/{id}/delete',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM]
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/auth-item/auth-item-delete-dialog.html',
                            controller: 'AuthItemDeleteController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AuthItem', function (AuthItem) {
                                    return AuthItem.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('resource', null, {reload: 'resource'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuthItemDeleteController',AuthItemDeleteController);

    AuthItemDeleteController.$inject = ['$uibModalInstance', 'entity', 'AuthItem'];

    function AuthItemDeleteController($uibModalInstance, entity, AuthItem) {
        var vm = this;

        vm.authItem = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AuthItem.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('AuthItem', AuthItem);

    AuthItem.$inject = ['$resource'];

    function AuthItem ($resource) {
        var resourceUrl =  'api/auth-items/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRole': {
                url: 'api/auth-items/role/:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'queryByType': {
                url: 'api/auth-items/type/:type/:id',
                method: 'GET',
                isArray: true
            },
            'loadActions': {
                url: '/api/authorization/actions',
                method: 'POST',
                isArray: false
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuthItemController', AuthItemController);

    AuthItemController.$inject = ['AuthItem', 'entityType', 'ACTIONS', 'CoreService', 'AUTH_ITEM_TYPE',
        'ROLES', 'GenericEntityDatatableService'];

    function AuthItemController(AuthItem, entityType, ACTIONS, CoreService, AUTH_ITEM_TYPE,
                                ROLES, GenericEntityDatatableService) {
        var vm = this;

        vm.employee = CoreService.getCurrentEmployee();
        vm.isSystemAdmin = _.filter(vm.employee.authorities, {name: ROLES.ROLE_SYSTEM_ADMIN}).length > 0;

        var params = {
            type: entityType.type,
            id: CoreService.getCorporation().id,
            exclude: entityType.type === AUTH_ITEM_TYPE.TYPE_ROLE && vm.isSystemAdmin ? null : [ROLES.ROLE_USER, ROLES.ROLE_SYSTEM],
        };

        vm.descriptor = {
            title: entityType.entityClassHumanized,
            newButtonTitle: 'New ' + entityType.entityClassHumanized,
            entityClassHumanized: entityType.entityClassHumanized,
            entityStateName: entityType.entityStateName,
            service: AuthItem,
            serviceMethod: 'queryByType',
            params: params,
            newAction: entityType.type === AUTH_ITEM_TYPE.TYPE_ROLE,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: 'description',
                    title: 'Description',
                },
            ],
            rowActions: [
                GenericEntityDatatableService.getEditAction(entityType.entityStateName),
                GenericEntityDatatableService.getDeleteAction(entityType.entityStateName)
            ],
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuditController', AuditController);

    AuditController.$inject = ['CoreService', 'InsuranceBillingConfig', '$filter', '$uibModal', 'TypeLevelCare',
        'Chart', 'InsuranceCarrier', 'AlertService', 'ParseLinks'];

    function AuditController(CoreService, InsuranceBillingConfig, $filter, $uibModal, TypeLevelCare,
                             Chart, InsuranceCarrier, AlertService, ParseLinks) {
        var vm = this;

        vm.charts = [];

        vm.itemsPerPage = 10;
        vm.page = 1;

        vm.title = 'Billing Audit';
        vm.entityClassHumanized = 'Audit';
        vm.entityStateName = 'audit';

        vm.filteredCharts = [];
        vm.audits = [];
        vm._audits = [];
        vm.dates = [];
        vm.facility = CoreService.getCurrentFacility();
        vm.startDateOptions = {};
        vm.endDateOptions = {};
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.firstDate = false;
        vm.datePickerOpenStatus.lastDate = false;
        vm.typeLevelCares = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));
        vm.carriers = [];
        vm.charts = [];
        vm.searchQuery = "";

        vm.filter = {
            facilityId: CoreService.getCurrentFacility().id,
            weekly: false,
            show: 'all'
        };

        vm.openDetails = openDetails;
        vm.showFilters = showFilters;
        vm.openCalendar = openCalendar;
        vm.validateEndDate = validateEndDate;
        vm.validateStartDate = validateStartDate;
        vm.exist = exist;
        vm.loadAll = loadAll;
        vm.splitTime = splitTime;
        vm.filterByHours = filterByHours;
        vm.search = search;
        vm.getInsuranceCarrier = getInsuranceCarrier;
        vm.getCharts = getCharts;
        vm.clear = clear;
        vm.loadCharts = loadCharts;

        angular.element('.filter-box').hide();

        function loadCharts() {
            Chart.fullFilter({
                statuses: 'CURRENT',
                facilityId: CoreService.getCurrentFacility().id,
                page: vm.page - 1,
                size: vm.itemsPerPage,
                sort: 'lastName',
                direction: 'ASC'
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.charts = [];
                vm.charts = data;

                loadAll();
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function openDetails(date, audit) {
            $uibModal.open({
                templateUrl: 'app/entities/audit/detail/audit-dialog.html',
                controller: 'AuditDetailsDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    data: {
                        audit: audit,
                        date: date
                    },
                    chart: Chart.get({id: audit.chart}).$promise
                }
            });
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validateStartDate() {
            vm.startDateOptions.maxDate = vm.lastDate;
        }

        function validateEndDate() {
            vm.endDateOptions.minDate = vm.firstDate;
        }

        function showFilters() {
            angular.element('.filter-box').toggleClass('active');

            if (angular.element('.filter-box').hasClass('active')) {
                angular.element('.toggle-filters').addClass('open');
                angular.element('.filter-box').slideDown();
            } else {
                angular.element('.toggle-filters').removeClass('open');
                angular.element('.filter-box').slideUp();
            }
        }

        function exist(date, billingTableByPatient) {
            return _.filter(billingTableByPatient.dates, {date: date}).length > 0;
            // return true;
        }

        function loadAll() {
            vm.isLoading = true;
            vm.audits = [];
            vm.dates = [];

            var filter = angular.copy(vm.filter);
            filter.startDate = vm.filter.startDate ? moment(vm.filter.startDate).format("YYYY-MM-DD") : null;
            filter.endDate = vm.filter.endDate ? moment(vm.filter.endDate).format("YYYY-MM-DD") : null;

            filter.charts = _.map(filter.charts, function(chart) {
                return chart.id
            });

            // filter.charts = filter.charts.length === 0 ? vm.charts : filter.charts;

            InsuranceBillingConfig.byFacility(filter, function (result) {
                vm.audits = [];
                vm.dates = result.dates;

                _.forEach(result.billingTableByPatient, function (byPatient) {
                    //init dates by chart
                    var p = {
                        chart: byPatient.chart,
                        patient: byPatient.patient,
                        mrNo: byPatient.mrNo,
                        dates: []
                    };

                    _.forEach(byPatient.dates, function (date) {
                        p[date.date] = date;
                        p.dates.push(date.date);
                    });

                    vm.audits.push(p);
                });

                vm._audits = angular.copy(vm.audits);
                vm._dates = angular.copy(result.dates);

                vm.isLoading = false;
            }, function () {
                vm.isLoading = false;
            });
        }

        function splitTime(inSeconds) {
            if (inSeconds) {
                var result = moment.duration(Number(inSeconds), 'seconds').days();
                result = result == 0 ? "" : result + ' d ';
                result += moment.duration(Number(inSeconds), 'seconds').hours() + '.' + moment.duration(Number(inSeconds), 'seconds').minutes();

                return result;
            }

            return 0;
        }

        function filterByHours(detail) {
            switch (vm.filter.show) {
                case 'over' :
                    return detail && detail.exceededHours > 0;
                case 'short' :
                    return detail && detail.availableHours > 0;
                case 'all':
                    return true;
            }

            return true;
        }

        function search() {
            if (!vm.searchQuery || vm.searchQuery === '') {
                vm.audits = angular.copy(vm._audits);
                vm.dates = angular.copy(vm._dates);
            } else {
                vm.audits = $filter('filter')(vm._audits, vm.searchQuery, undefined);
                vm.dates = extractDates(vm.audits);
            }

            vm.page = 1;

            // if (vm.filter.charts.length === 0) {
            //     loadCharts()
            // } else {
                loadAll();
            // }
        }

        function extractDates(audits) {
            var dates = [];

            _.forEach(audits, function (audit) {
                dates = _.union(audit.dates, dates);
            });

            return dates.sort();
        }

        function getInsuranceCarrier(query) {
            if (query && query.length > 2) {
                query = _.lowerCase(query);

                vm.carriers = InsuranceCarrier.query({
                    query: query
                });
            }
        }

        function getCharts(query) {
            var filter = {};

            filter.page = 0;
            filter.size = 20;
            filter.facilityId = vm.facility.id;
            filter.searchQuery = query;
            filter.statuses = ['CURRENT', 'ARCHIVE'];

            Chart.fullFilter(filter, function (result) {
                vm.filteredCharts = result
            });
        }

        function clear() {
            vm.filter = {
                facilityId: CoreService.getCurrentFacility().id,
                startDate: null,
                endDate: null,
                weekly: true,
                show: 'all',
                charts: []
            }

            vm.page = 1

            // loadCharts();
        }

        vm.week = week;

        function week() {
            vm.filter.weekly = true;

            loadAll();
        }

        vm.month = month;

        function month() {
            vm.filter.weekly = false;

            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuditDetailsDialogController', AuditDetailsDialogController);

    AuditDetailsDialogController.$inject = ['$uibModalInstance', 'data', 'CoreService', 'Chart', 'chart', 'GUIUtils'];

    function AuditDetailsDialogController($uibModalInstance, data, CoreService, Chart, chart, GUIUtils) {
        var vm = this;

        vm.clear = clear;

        vm.audit = data.audit[data.date];
        vm.page = 0;
        vm.itemsPerPage = 5;
        vm.dtInstance = {};
        vm.details = [];
        vm.chart = chart;
        vm.date = data.date;
        vm.getHumanHours = getHumanHours;
        vm.insurance = "";

        vm.colorHtmlYesNo = colorHtmlYesNo;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
        vm.cds = [];
        vm.gss = [];
        vm.cdsCounter = {};
        vm.gssCounter = {};
        vm.levels = "";

        _.forEach(vm.audit.details, function (detail) {
            _.forEach(detail.careDeliveryStatuses, function (care) {
                addRow(care, vm.cdsCounter, vm.cds);
            });
            _.forEach(detail.groupSessionDetailStatuses, function (group) {
                addRow(group, vm.gssCounter, vm.gss);
            });

            if (detail.insuranceCarrier) {
                vm.insurance += (vm.insurance.length > 0 ? "," : "") + detail.insuranceCarrier;
            }

            vm.levels += vm.levels.length == 0 ? detail.typeLevelCare : ("," + detail.typeLevelCare);
        });

        _.forEach(vm.audit.nobillableCd, function (care) {
            addRow(care, vm.cdsCounter, vm.cds);
        });
        _.forEach(vm.audit.nobillableGs, function (group) {
            addRow(group, vm.gssCounter, vm.gss);
        });

        function count(counter, obj) {
            if (counter[obj.status]) {
                counter[obj.status] += obj.hours;
            } else {
                counter[obj.status] = obj.hours;
            }
        }

        function getHumanHours(inSeconds) {
            if (inSeconds) {
                var result = moment.duration(Number(inSeconds), 'seconds').days();
                result = result == 0 ? "" : result + ' d ';

                var h = moment.duration(Number(inSeconds), 'seconds').hours() + '.' + moment.duration(Number(inSeconds), 'seconds').minutes();

                result += h > 0 ? h : "";

                return result;
            }

            return 0;
        }

        function addRow(row, counter, rows) {
            row["_hours"] = getHumanHours(row.hours);
            count(counter, row);
            rows.push(row);
        }

        function colorHtmlYesNo(data) {
            return GUIUtils.colorHtmlYesNo(data);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('audit', {
                parent: 'entity',
                url: '/audit',
                data: {
                    authorities: [],
                    pageTitle: 'Audit'
                },
                ncyBreadcrumb: {
                    label: 'Audit'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/audit/list/audit.html',
                        controller: 'AuditController',
                        controllerAs: 'vm'
                    }
                },
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AssistantDialogController', AssistantDialogController);

    AssistantDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Assistant'];

    function AssistantDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Assistant) {
        var vm = this;

        vm.assistant = entity;
        vm.clear = clear;
        vm.save = save;
        vm.sections = Assistant.sections();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assistant.id !== null) {
                Assistant.update(vm.assistant, onSaveSuccess, onSaveError);
            } else {
                Assistant.save(vm.assistant, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:assistantUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Assistant', Assistant);

    Assistant.$inject = ['$resource', 'Utils'];

    function Assistant ($resource, Utils) {
        var resourceUrl =  'api/assistants/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        if (data.sections) {
                            data.sections = Utils.objectRoleToArray(data.sections);
                        }
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'sections': {url: 'api/assistants/sections', method: 'GET', isArray: true},
            'findAllBySection': {url: 'api/assistants/by-sections/:section/facility/:facility', method: 'GET', isArray: true},
            'search': {url: 'api/assistants/search', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AssistantController', AssistantController);

    AssistantController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Assistant', 'GUIUtils', '$uibModal',
        'ConfirmationService', '$q'];

    function AssistantController(GenericEntityDatatableService, CoreService, Assistant, GUIUtils, $uibModal,
                                 ConfirmationService, $q) {
        var vm = this;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Assistants',
            newButtonTitle: 'New Assistant',
            entityClassHumanized: 'Assistants',
            entityStateName: 'assistant',
            service: Assistant,
            serviceMethod: 'search',
            params: params,
            newAction: false,
            pagination: 'remote',
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                },
                {
                    name: null,
                    title: 'Active',
                    render: function (data) {
                        return GUIUtils.colorHtmlYesNo(data.active);
                    }
                },
                {
                    name: null,
                    title: 'Sections',
                    render: function (data) {
                        return _.map(data.sections, 'name').join(',');
                    }
                },
                {
                    name: 'note',
                    title: 'Note',
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Assistant',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/assistant/update/assistant-dialog.html',
                controller: 'AssistantDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            note: null,
                            active: true,
                            id: null,
                            facility: CoreService.getCurrentFacility()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/assistant/update/assistant-dialog.html',
                controller: 'AssistantDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Assistant', function (Assistant) {
                        return Assistant.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Assistant').result.then(function () {
                    Assistant.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('assistant', {
                parent: 'entity',
                url: '/assistant',
                data: {
                    authorities: [],
                    pageTitle: 'Assistants'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/assistant/list/assistant.html',
                        controller: 'AssistantController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Assistant'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_ASSISTANT];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_ASSISTANT, access);
                }]
            });
    }
})();

(function (){
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('appointments', {
                parent: 'entity',
                url: '/appointments',
                data: {
                    authorities: [],
                    pageTitle: 'Appointments'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/appointments/appointments.html',
                        controller: 'AppointmentsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                }
            })
            .state('appointment-encounter', {
                parent: 'entity',
                url: '/appointment-encounter',
                data: {
                    authorities: [],
                    pageTitle: 'Appointments Encounter'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/appointment-encounter/appointment-encounter.html',
                        controller: 'AppointmentEncounterController',
                        controllerAs: 'vm'
                    },
                    'super-bill@appointment-encounter': {
                        templateUrl: 'app/entities/super-bill/super-bill.html',
                        controller: 'SuperBillController',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentsNewDialogController', AppointmentsNewDialogController);

    AppointmentsNewDialogController.$inject = ['$uibModalInstance'];

    function AppointmentsNewDialogController($uibModalInstance) {
        var vm = this;

        vm.clear = clear;
        vm.addCustomDate = addCustomDate;
        vm.deleteCustomDate = deleteCustomDate;

        vm.datePicked = null;
        vm.customRecurrences = [];

        vm.calendarOpts = {
            showWeeks: true
        };

        vm.calendarOptsCustom = {
            showWeeks: true
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function addCustomDate(date) {
            if (vm.datePicked) {
                vm.customRecurrences.push(date);
                vm.datePicked = null;
            }
        }

        function deleteCustomDate(index) {
            vm.customRecurrences.splice(index, 1);
        }
    }
})();

(function (){
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentsController', AppointmentsController);

    AppointmentsController.$inject = ['$uibModal'];

    function AppointmentsController($uibModal) {
        var vm = this;

        vm.title = 'Appointments';
        vm.createAppointment = createAppointment;

        vm.appointmentFilters = {
            inLobby: 0,
            inRoom: 0,
            canceled: 0,
            noShow: 0,
            seen: 0,
            pendingArrival: 0
        };


        vm.calendarConfig = {
            calendar: {
                defaultView: 'agendaWeek',
                height: 700,
                minTime: '07:00:00',
                maxTime: '18:00:00',
                editable: true,
                selectable: true,
                contentHeight: 'auto',
                header: {
                    left: 'title',
                    // center: 'title',
                    right: 'prev,today,next agendaWeek,agendaDay list'
                },
                timeFormat: 'h:mm a',
                weekNumbers: true,
                businessHours: [
                    {
                        dow: [1, 2, 3, 4, 5],
                        start: '08:00',
                        end: '17:00'
                    }
                ],
                events: [
                    {
                        title: 'Albert Einstein',
                        start: '2019-11-18T10:00:55.008',
                        end: '2019-11-19T04:00:55.008',
                        className: 'in-room',
                        description: 'This a cool event!',
                        status: 'In Room',
                        type: 'Wellness Exam'
                    },
                    {
                        title: 'Rene Descartes',
                        start: '2019-11-19T09:00:55-0400',
                        end: '2019-11-19T12:00:55-0400',
                        className: 'in-lobby',
                        description: 'Lorem Ipsum Dollor sit amet',
                        status: 'In Lobby',
                        type: 'Lorem Ipsum'
                    },
                    {
                        title: 'Smith Vatherman',
                        start: '2019-11-23T07:00:00-0400',
                        end: '2019-11-23T10:00:00-0400',
                        className: 'cancelled',
                        description: 'Lorem Ipsum Dollor',
                        status: 'Cancelled',
                        type: 'Drugs Exam'
                    },
                    {
                        title: 'Michelle Carmant',
                        start: '2019-11-22T09:07:00-0400',
                        end: '2019-11-22T10:15:00-0400',
                        className: 'no-show',
                        description: 'Hippotoxotas assimilant',
                        status: 'No Show',
                        type: 'Meeting'
                    },
                    {
                        title: 'Amelie Toulousse',
                        start: '2019-11-21T06:00:00-0400',
                        end: '2019-11-21T08:45:00-0400',
                        className: 'seen',
                        description: 'Messors tolerare',
                        status: 'Seen',
                        type: 'Wellness Exam'
                    },
                    {
                        title: 'Charlotte de Witte',
                        start: '2019-11-22T09:07:00-0400',
                        end: '2019-11-22T10:15:00-0400',
                        className: 'pending-arrival',
                        description: 'Elevatuss credere.',
                        status: 'Pending Arrival',
                        type: 'Meeting'
                    }
                ],
                eventRender: function(eventObj, $elem) {
                    $elem
                        .find('.fc-time')
                        .append("<strong class='fc-event-status'>[" + eventObj.status + "]</strong>");
                    $elem
                        .find('.fc-title')
                        .append("<strong class='fc-event-status'> [" + eventObj.type + "]</strong>");
                    $elem
                        .find('.fc-content')
                        .append("<div class='fc-desc'>" + eventObj.description + "</div>");
                },
                /*
                * - dayClick event --> https://fullcalendar.io/docs/v3/dayClick
                * - date : holds a Moment for the clicked day. If an all-day area has been clicked, the moment will be ambiguously-timed. If a slot in the agendaWeek or agendaDay views has been clicked, date will have the slot’s time.
                * - jsEvent : holds the jQuery event with low-level information such as click coordinates.
                * - view : is set to the current View Object.
                * - Viw Object --> https://fullcalendar.io/docs/v3/view-object
                * */
                dayClick: function(date, jsEvent, view) {
                    $uibModal.open({
                        templateUrl: 'app/entities/appointments/appointments-new-dialog.html',
                        controller: 'AppointmentsNewDialogController',
                        controllerAs: 'vm',
                        size: 'lg',
                        windowTopClass: 'custom-dialog-styles',
                        resolve: {

                        }
                    }).result.then(function(result) {

                    }, function () {

                    });
                }
            }
        };

        function createAppointment() {
            $uibModal.open({
                templateUrl: 'app/entities/appointments/appointments-new-dialog.html',
                controller: 'AppointmentsNewDialogController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {

                }
            }).result.then(function(result) {

            }, function () {

            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentTypeDialogController', AppointmentTypeDialogController);

    AppointmentTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AppointmentType'];

    function AppointmentTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AppointmentType) {
        var vm = this;

        vm.appointmentType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appointmentType.id !== null) {
                AppointmentType.update(vm.appointmentType, onSaveSuccess, onSaveError);
            } else {
                AppointmentType.save(vm.appointmentType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:appointmentTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentTypeDeleteController',AppointmentTypeDeleteController);

    AppointmentTypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppointmentType'];

    function AppointmentTypeDeleteController($uibModalInstance, entity, AppointmentType) {
        var vm = this;

        vm.appointmentType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppointmentType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('appointment-type', {
                parent: 'entity',
                url: '/appointment-type',
                data: {
                    authorities: [],
                    pageTitle: 'AppointmentTypes'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/appointment-type/appointment-types.html',
                        controller: 'AppointmentTypeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access);
                }]
            })
            .state('appointment-type.new', {
                parent: 'appointment-type',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/appointment-type/appointment-type-dialog.html',
                            controller: 'AppointmentTypeDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        facility: CoreService.getCurrentFacility()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('appointment-type', null, {reload: 'appointment-type'});
                        }, function () {
                            $state.go('appointment-type');
                        });
                    }
                }]
            })
            .state('appointment-type.edit', {
                parent: 'appointment-type',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/appointment-type/appointment-type-dialog.html',
                            controller: 'AppointmentTypeDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AppointmentType', function (AppointmentType) {
                                    return AppointmentType.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('appointment-type', null, {reload: 'appointment-type'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('appointment-type.delete', {
                parent: 'appointment-type',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/appointment-type/appointment-type-delete-dialog.html',
                            controller: 'AppointmentTypeDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['AppointmentType', function (AppointmentType) {
                                    return AppointmentType.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('appointment-type', null, {reload: 'appointment-type'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('AppointmentType', AppointmentType);

    AppointmentType.$inject = ['$resource'];

    function AppointmentType ($resource) {
        var resourceUrl =  'api/appointment-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('AppointmentTypeSearch', AppointmentTypeSearch);

    AppointmentTypeSearch.$inject = ['$resource'];

    function AppointmentTypeSearch($resource) {
        var resourceUrl =  'api/_search/appointment-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentTypeController', AppointmentTypeController);

    AppointmentTypeController.$inject = ['$scope', '$state', 'AppointmentType', 'AppointmentTypeSearch', '$q', 'DTColumnBuilder',
        'DTOptionsBuilder', 'GUIUtils', '$filter', 'CoreService', '$compile'];

    function AppointmentTypeController ($scope, $state, AppointmentType, AppointmentTypeSearch, $q, DTColumnBuilder,
                                        DTOptionsBuilder, GUIUtils, $filter, CoreService, $compile) {
        var vm = this;

        vm.entityClassHumanized = 'Appointment Types';
        vm.entityStateName = 'appointment-type';
        vm.appointmentTypes = [];
        vm.dtInstance = {};

        vm.search = search;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();
            if (!vm.searchQuery || vm.searchQuery == '') {
                AppointmentTypeSearch.query(CoreService.getFilterByFacility(CoreService.getCurrentFacility()), function (result) {
                    vm.appointmentTypes = result;
                    defer.resolve(result);
                });
            } else {
                defer.resolve($filter('filter')(vm.appointmentTypes, vm.searchQuery, undefined));
            }

            return defer.promise;
        }).withPaginationType('full_numbers')
            .withBootstrap()
            .withDOM('ltp')
            .withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            })
            .withDisplayLength(15)
            .withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]])
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn('name').withTitle('Name'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                '<button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                '<i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                '</button>' +
                '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link orange" ' +
                'ui-sref="' + $state.current.name + '.edit({id:' + data.id + '})">' +
                '<i class="fa fa-edit" aria-hidden="true"></i>Edit' +
                '</a>' +
                '</li>' +
                '<li role="menuitem">' +
                '<a href="" class="dd-link red" ' +
                'ui-sref="' + $state.current.name + '.delete({id:' + data.id + '})">' +
                '<i class="fa fa-trash-o" aria-hidden="true"></i>Delete' +
                '</a>' +
                '</li>' +
                '</ul>' +
                '</div>';
        }

        function search() {
            vm.dtInstance.reloadData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AppointmentEncounterController', AppointmentEncounterController);

    AppointmentEncounterController.$inject = [];

    function AppointmentEncounterController() {
        var vm = this;

        vm.sideBySide = false;
        vm.sideForm = false;
        vm.formIdentical = false;
        vm.openStepSelector = false;

        vm.openSideBySide = openSideBySide;
        vm.toggleStepSelector = toggleStepSelector;
        vm.toggleSideBySide = toggleSideBySide;

        function toggleStepSelector() {
            vm.sideBySide =  false;
            if (vm.openStepSelector) {
                vm.openStepSelector = !vm.openStepSelector;
            } else vm.openStepSelector = true;
        }

        function toggleSideBySide() {
            vm.openStepSelector = false;
            if (vm.sideBySide) {
                vm.sideBySide = !vm.sideBySide;
            } else vm.sideBySide = true;
        }

        function openSideBySide() {
            vm.sideBySide =  false;
            vm.openStepSelector = false;
            vm.sideForm = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergiesDialogController', AllergiesDialogController);

    AllergiesDialogController.$inject = ['entity', '$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'Allergies', 'GUIUtils', 'Reaction', 'Allergen', 'CoreService', 'Severity',
        'RcopiaAllergyGroup'];

    function AllergiesDialogController(entity, $timeout, $scope, $stateParams, $uibModalInstance,
                                       Allergies, GUIUtils, Reaction, Allergen, CoreService, Severity,
                                       RcopiaAllergyGroup) {
        var vm = this;

        vm.allergies = entity;
        vm.chart = entity.chart;
        vm.onset = GUIUtils.getOnset();
        vm.severities = Severity.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.allergen = Allergen.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.reaction = Reaction.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.rcopiaAllergyGroups = [];
        vm.form = {};
        vm.showDelete = false;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.reactionDate = false;

        vm.clear = clear;
        vm.save = save;
        vm.openCalendar = openCalendar;
        vm.confirmDelete = confirmDelete;
        vm.getRcopiaAllergyGroups = getRcopiaAllergyGroups;

        vm.currentDate = {
            maxDate: new Date()
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.allergies.id !== null) {
                Allergies.update(vm.allergies, onSaveSuccess, onSaveError);
            } else {
                Allergies.save(vm.allergies, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function confirmDelete() {
            Allergies.delete({id: vm.allergies.id},
                function () {
                    $uibModalInstance.close(true);
                });
        }

        function getRcopiaAllergyGroups(query) {
            if (query) {
                RcopiaAllergyGroup.filter({name: query}, function (result) {
                    vm.rcopiaAllergyGroups = result;
                });
            } else {
                vm.rcopiaAllergyGroups = [];
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergiesHistoryNewController', AllergiesHistoryNewController);

    AllergiesHistoryNewController.$inject = ['Allergies', 'DTOptionsBuilder', 'DTColumnBuilder', 'DataTablesService',
                                            'chart', '$timeout', '$uibModalInstance'];

    function AllergiesHistoryNewController(Allergies, DTOptionsBuilder, DTColumnBuilder, DataTablesService,
                                           chart, $timeout, $uibModalInstance) {
        var vm = this;
        vm.chart = chart;
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.allergies = [];

        vm.clear = clear;
        vm.search = search;
        vm.transition = transition;

        loadAll();

        function loadAll() {
            Allergies.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.allergies = result;
            });
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getFilter() {
            var filter = {};

            filter.chartId = vm.chart.id;
            filter.active = false;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function search() {
            vm.page = 1;
            loadAll();
        }

        function transition() {
            loadAll();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergiesController', AllergiesController);


    AllergiesController.$inject = ['chart', 'Allergies', 'CoreService', '$sessionStorage', '$uibModal', 'access',
        'ACTIONS', 'Auth', 'ConfirmationService', '$rootScope', 'RcopiaUtils', 'RcopiaApi',
        'rcopiaAccount', '$scope'];

    function AllergiesController(chart, Allergies, CoreService, $sessionStorage, $uibModal, access,
                                 ACTIONS, Auth, ConfirmationService, $rootScope, RcopiaUtils, RcopiaApi,
                                 rcopiaAccount, $scope) {
        var vm = this;
        vm.chart = chart;
        vm.rcopiaAccount = rcopiaAccount;
        vm.corporation = CoreService.getCorporation();

        vm.activeTab = $sessionStorage.activePatientTabAllergies ? $sessionStorage.activePatientTabAllergies.activeTab : 0;
        vm.name = "  ";//chart.patient.lastName + " " + chart.patient.firstName;
        vm.mrNumber = chart.mrNo;

        vm.toggleItem = toggleItem;
        vm.add = add;
        vm.edit = edit;
        vm.del = del;
        vm.keepActiveTab = keepActiveTab;
        vm.trim = trim;
        vm.severity = severity;
        vm.launchRcopia = launchRcopia;

        function toggleItem() {
            CoreService.togglePanel('allergies');
        }

        function keepActiveTab(index) {
            $sessionStorage.activePatientTabAllergies = {activeTab: index};
            vm.activeTab = index;
        }

        loadData();

        function loadData() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_ALLERGIES_VIEW, access)) {

                return;
            }

            vm.allergies = Allergies.findAllByChart({id: chart.id});
        }

        var unsubscribe = $rootScope.$on('bluebookApp:RcopiaUpdatePatient', function (event, result) {
            loadData();
        });

        $scope.$on('$destroy', unsubscribe);

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/allergies/update/allergies-dialog.html',
                controller: 'AllergiesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            reaction: null,
                            treatment: null,
                            id: null,
                            active: false,
                            chart: chart
                        };
                    }
                }
            }).result.then(function () {
                loadData()

                $rootScope.$broadcast('bluebookApp:RcopiaReload', 'manage_allergies');
            });
        }

        function edit(id) {
            $uibModal.open({
                templateUrl: 'app/entities/allergies/update/allergies-dialog.html',
                controller: 'AllergiesDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Allergies', function (Allergies) {
                        return Allergies.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadData()

                $rootScope.$broadcast('bluebookApp:RcopiaReload', 'manage_allergies');
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Allergies').result.then(function () {
                Allergies.delete({id: id}, function () {
                    loadData()

                    $rootScope.$broadcast('bluebookApp:RcopiaReload', 'manage_allergies');
                });
            })
        }

        function trim(name) {
            return name ? name.trim() : "";
        }

        function severity(allergy) {
            var severity = allergy.severity ? allergy.severity.name : "";
            var reactions = _.join(_.map(allergy.reactions, function (reaction) { return reaction.name; }), ", ");

            var sr = "";

            if (severity && reactions) {
                sr = "(" + severity + ": " + reactions + ")";
            } else if (severity || reactions){
                sr = "(" + severity + reactions  + ")";
            }

            return sr;
        }

        function launchRcopia() {
            RcopiaUtils.launchRcopiaPopup(
                'manage_allergies',
                'patientMode',
                vm.chart.id
            ).result.then(function () {
                RcopiaApi.executeByChart({
                    api: 'updateAllergy',
                    chartId: vm.chart.id
                }, function (result) {
                    $rootScope.$broadcast("bluebookApp:RcopiaUpdatePatient");
                })
            })
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Allergies', Allergies);

    Allergies.$inject = ['$resource', 'DateUtils'];

    function Allergies ($resource, DateUtils) {
        var resourceUrl =  'api/allergies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reactionDate = DateUtils.convertDateTimeFromServer(data.reactionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByChart': {url: 'api/allergies/by-chart/:id', method: 'GET', isArray: true},
            'findAllByChartAndStatus': {url: 'api/allergies/by-chart/:id/:status', method: 'GET', isArray: true},
            'findAllAllergiesByChart': {url: 'api/allergies/by-allergen/:id/:allergenType', method: 'GET', isArray: true},
            'findAllByFilter': {url: 'api/allergies/by-chart', method: 'GET', isArray: true},
        });
    }
})();



(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergenDialogController', AllergenDialogController);

    AllergenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Allergen'];

    function AllergenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Allergen) {
        var vm = this;

        vm.allergen = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.allergen.id !== null) {
                Allergen.update(vm.allergen, onSaveSuccess, onSaveError);
            } else {
                Allergen.save(vm.allergen, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:allergenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Allergen', Allergen);

    Allergen.$inject = ['$resource'];

    function Allergen ($resource) {
        var resourceUrl =  'api/allergens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/allergens/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AllergenController', AllergenController);

    AllergenController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Allergen', '$uibModal',
        'ConfirmationService', '$q'];

    function AllergenController(GenericEntityDatatableService, CoreService, Allergen, $uibModal,
                                ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Allergen',
            newButtonTitle: 'New Allergen',
            entityClassHumanized: 'Allergen',
            entityStateName: 'allergen',
            service: Allergen,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction('allergen'), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('allergen'), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Allergen',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/allergen/update/allergen-dialog.html',
                controller: 'AllergenDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/allergen/update/allergen-dialog.html',
                controller: 'AllergenDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Allergen', function (Allergen) {
                        return Allergen.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Allergen').result.then(function () {
                    Allergen.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('allergen', {
                parent: 'entity',
                url: '/allergen',
                data: {
                    authorities: [],
                    pageTitle: 'Allergens'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/allergen/list/allergen.html',
                        controller: 'AllergenController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ALLERGEN];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ALLERGEN, access);
                }]
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AlcoholDialogController', AlcoholDialogController);

    AlcoholDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'Alcohol'];

    function AlcoholDialogController ($timeout, $scope, $uibModalInstance, entity, Alcohol) {
        var vm = this;

        vm.alcohol = entity;
        vm.alcohol.date = new Date();
        vm.clear = clear;
        vm.save = save;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.alcohol.id !== null) {
                Alcohol.update(vm.alcohol, onSaveSuccess, onSaveError);
            } else {
                Alcohol.save(vm.alcohol, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:alcoholUpdate', result);
            $scope.$emit('bluebookApp:drugUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        $scope.dateOptions = {

            maxDate: new Date()+1
        }


        vm.datePickerOpenStatus.date = false;
        vm.datePickerOpenStatus.time = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AlcoholController', AlcoholController);

    AlcoholController.$inject = ['$uibModalInstance', 'Alcohol', 'chart', '$q', 'DTColumnBuilder', 'DTOptionsBuilder',
        '$compile', '$scope', '$rootScope', '$uibModal', 'ConfirmationService', '$uibModalStack'];

    function AlcoholController($uibModalInstance, Alcohol, chart, $q, DTColumnBuilder, DTOptionsBuilder,
                               $compile, $scope, $rootScope, $uibModal, ConfirmationService, $uibModalStack) {
        var vm = this;

        vm.chart = chart;
        vm.alcohol = [];
        vm.dtInstance = {};
        vm.page = 1;
        vm.itemsPerPage = 10;

        vm.clear = clear;
        vm.search = search;
        vm.edit = edit;
        vm.del = del;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            Alcohol.byChart({chartId: vm.chart.id, page: vm.page - 1, size: vm.itemsPerPage}, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.alcohol = result;
                defer.resolve(vm.alcohol);
            });

            return defer.promise;
        }).withBootstrap()
            .withDOM('ltp')
            .withOption("bLengthChange", false)
            .withOption("bPaginate", false)
            .withOption('aaSorting', [[0, 'desc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            })
            .withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $compile(nRow)($scope);
                });

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle('').notVisible().renderWith(function (data, type, full) {
                return data ? moment(data.date).format("YYYYMMDD") : "";
            }),
            DTColumnBuilder.newColumn('date').withTitle('Date').renderWith(function (data, type, full) {
                return data ? moment(data).format($rootScope.amDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Value').renderWith(function (data, type, full) {
                return data.value ? data.value : " - ";
            }),
            DTColumnBuilder.newColumn(null).withTitle('Notes').renderWith(function (data, type, full) {
                return data.description ? data.description : " - ";
            }),
            DTColumnBuilder.newColumn('createdBy').withTitle('Created By'),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable()
                .renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';

            stButtons += '<a class="dt-btn warning" ng-click="vm.edit(' + data.id + ')">' +
                '   <i class="fa fa-edit"></i></a>&nbsp;';

            if (vm.chart.status) {
                stButtons += '<a class="dt-btn danger" ng-click="vm.del(' + data.id + ')">' +
                    '   <i class="fa fa-trash"></i></a>';
            }

            return stButtons;
        }


        function search() {
            vm.dtInstance.reloadData();
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function edit(id) {
            $uibModalStack.dismissAll();

            $uibModal.open({
                templateUrl: 'app/entities/alcohol/update/alcohol-dialog.html',
                controller: 'AlcoholDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    entity: ['Alcohol', function (Alcohol) {
                        return Alcohol.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                search();
            }, function () {
            });
        }

        function del(id) {
            ConfirmationService.showDelete('Alcohol').result.then(function () {
                Alcohol.delete({id: id}, function () {
                    search();
                });
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AlcoholChartController', AlcoholChartController);

    AlcoholChartController.$inject = ['chart', 'Alcohol', '$uibModal', 'access', 'ACTIONS', '$rootScope', '$scope', 'Auth'];

    function AlcoholChartController(chart, Alcohol, $uibModal, access, ACTIONS, $rootScope, $scope, Auth) {
        var vm = this;
        vm.chart = chart;

        vm.add = add;
        vm.history = history;
        vm.loadAll = loadAll;

        vm.getAlcoholGraphOpt = getAlcoholGraphOpt;
        vm.dataAlcohol = [];

        loadAll();

        function loadAll() {
            if (!Auth.hasActionAuthorization(ACTIONS.ACTION_PATIENT_ALCOHOL_VIEW, access)) {
                return;
            }

            Alcohol.byChart({chartId: chart.id, page: 0, size: 1}, function (result, headers) {
                if (headers('X-Total-Count') > 0) {
                    vm.alcohol = result[0];
                }
            });

            getAlcoholData();
        }

        function add() {
            $uibModal.open({
                templateUrl: 'app/entities/alcohol/update/alcohol-dialog.html',
                controller: 'AlcoholDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: function () {
                        return {
                            name: null,
                            status: null,
                            id: null,
                            chart: chart,
                            date: new Date()
                        };
                    }
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        function history() {
            $uibModal.open({
                templateUrl: 'app/entities/alcohol/history/alcohol.html',
                controller: 'AlcoholController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: chart
                }
            }).result.then(function () {
                loadAll();
            }, function () {
                loadAll();
            });
        }

        getAlcoholGraphOpt();

        function getAlcoholGraphOpt() {
            vm.alcoholGraphOpt = {
                chart: {
                    type: 'lineChart',
                    showLegend: false,
                    height: 340,
                    showXAxis: false,
                    margin: {
                        top: 20,
                        right: 50,
                        bottom: 100,
                        left: 50
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis: {
                        tickFormat: function (d) {
                            return d3.time.format('%m/%d/%y-%H:%M')(new Date(d));
                        },
                        rotateLabels: (-70)
                    },
                    yAxis: {
                        tickFormat: function (d) {
                            return d3.format('.02f')(d);
                        },
                        showMaxMin: false
                    }
                }
            };
        }

        function getAlcoholData() {
            Alcohol.byChart({chartId: vm.chart.id, page: 0, size: 10}, function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                if (vm.totalItems > 0) {
                    vm.alcohol = result[0];
                }

                vm.dataAlcohol = [];

                vm.valueData = {
                    values: [],
                    key: 'value',
                    color: '#000000'
                };

                for (var i = result.length - 1; i >= 0; i--) {
                    vm.valueData.values.push({x: new Date(result[i].date).getTime(), y: parseFloat(result[i].value)});
                }

                vm.dataAlcohol.push(vm.valueData);
            });
        }

        var unsubscribe = $rootScope.$on('bluebookApp:chartAlcoholHistory', function (event, result) {
            history();
        });

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Alcohol', Alcohol);

    Alcohol.$inject = ['$resource', 'DateUtils'];

    function Alcohol ($resource, DateUtils) {
        var resourceUrl =  'api/alcohol/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byChart': {url: 'api/alcohol/by-chart/', method: 'GET', isArray: true},
            'findLastByChartId': {url: 'api/alcohol/last/by-chart/:id', method: 'GET'},
            'findLastByChartById': {url: "api/alcohol/last/by-chart-id/:id/size/:size", method: 'GET', isArray: true},
            'findAllByChart': {url: "api/alcohol/by-chart-id/:id", method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AdmissionMedicationDialogController', AdmissionMedicationDialogController);

    AdmissionMedicationDialogController.$inject = ['$uibModalInstance', 'chart', 'PatientMedication', 'CoreService', 'Route',
        'DoseForm', 'Relational', 'MedicationSearch', 'admissionMedication',
        'GUIUtils', 'Employee', 'AdmissionMedication', '$scope', 'RATIONALE_TYPE'];

    function AdmissionMedicationDialogController($uibModalInstance, chart, PatientMedication, CoreService, Route,
                                                 DoseForm, Relational, MedicationSearch, admissionMedication,
                                                 GUIUtils, Employee, AdmissionMedication, $scope, RATIONALE_TYPE) {
        var vm = this;

        vm.admissionMedication = admissionMedication;
        vm.chart = chart;
        vm.matches = {};
        vm.routes = Route.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.doseForms = DoseForm.findAllByCorporation(CoreService.getFilterByCurrentCorporation());
        vm.relationals = Relational.findAllByFilter(getFilterByCorporationAndType());
        vm.admissionMedicationActions = GUIUtils.getAdmissionMedicationAction();
        vm.frequencies = PatientMedication.getAllMedicationFrequency();
        vm.facility = CoreService.getCurrentFacility();
        vm.matches = {};
        vm.scheduleStrength = null;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.expirationDate = false;

        vm.openCalendar = openCalendar;
        vm.getMedications = getMedications;
        vm.changeFrequency = changeFrequency;
        vm.clear = clear;
        vm.save = save;
        vm.getEmployees = getEmployees;

        init();

        function init() {
            vm.scheduleStrength = vm.admissionMedication.id ? vm.admissionMedication.admissionFrequencies[0].schedules[0].strength : null;
            vm.getEmployees();

            PatientMedication.match({id: vm.chart.id}, function (medications) {
                _.forEach(medications, function (medication) {
                    vm.matches[medication.id] = true;
                })
            });
        }

        vm.currentDate = {
            minDate: new Date()
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getMedications(query) {
            if (query && query.length > 3) {
                query = _.lowerCase(query);
                vm.medications = MedicationSearch.query({
                    query: query
                });
            }
        }

        function changeFrequency(frequency) {
            frequency.schedules = [];
            frequency.hideDay = false;

            switch (frequency.frequency.id) {
                case 'EVERY_H':
                case 'EVERY_2H':
                case 'EVERY_3H':
                case 'EVERY_4H':
                case 'EVERY_6H':
                case 'EVERY_8H':
                case 'EVERY_12H':
                case 'EVERY_24H':
                case 'EVERY_48H':
                case 'EVERY_WEEK':
                case 'EVERY_TWO_WEEKS':
                case 'EVERY_MONTH': {
                    frequency.hideDay = true;
                    scheduleTakesIntervals(frequency, 1, 0, 1);

                    break;
                }
                case 'ONE_AM': {
                    scheduleTakesIntervals(frequency, 1, 0, 9);

                    break;
                }
                case 'ONE_HS': {
                    scheduleTakesIntervals(frequency, 1, 0, 21);

                    break;
                }
                case 'BID': {
                    scheduleTakesIntervals(frequency, 2, 12, 9);

                    break;
                }
                case 'TID': {
                    scheduleTakesIntervals(frequency, 3, 6, 9);

                    break;
                }
                case 'QID': {
                    scheduleTakesIntervals(frequency, 4, 3, 9);

                    break;
                }
                case 'SID': {
                    scheduleTakesIntervals(frequency, 6, 4, 2);

                    break;
                }
                case 'ONCE': {
                    scheduleTakesIntervals(frequency, 1, 0, 15);

                    break;
                }
                case 'STAT': {
                    frequency.schedules.push({
                        xorder: 0,
                        strength: null,
                        date: moment().startOf('minute').toDate()
                    });

                    break;
                }
            }
        }

        function scheduleTakesIntervals(frequency, count, hours, firstHour) {
            var first = moment().startOf('hour').toDate();
            first.setHours(firstHour);

            for (var i = 0; i < count; i++) {
                frequency.schedules.push({
                    xorder: i,
                    date: angular.copy(first),
                    strength: null,
                    quantity: 0
                });

                first.setHours(first.getHours() + hours);
            }
        }

        function save() {
            vm.isSaving = true;

            var data = angular.copy(vm.admissionMedication);
            data.lastDate = moment.tz(moment(data.lastDate).format('YYYY-MM-DDTHH:mm:00'), vm.facility.timeZone).format();
            data.expirationDate = moment.tz(moment(data.expirationDate).format('YYYY-MM-DD'), vm.facility.timeZone).format();

            _.forEach(data.admissionFrequencies, function (frequency) {
                _.forEach(frequency.schedules, function (schedule) {
                    schedule.date = moment(schedule.date).format('YYYY-MM-DDTHH:mm:00');
                    schedule.strength = vm.scheduleStrength;
                });
            });

            if (vm.admissionMedication.id !== null) {
                AdmissionMedication.update(data, onSaveSuccess, onSaveError);
            } else {
                AdmissionMedication.save(data, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:admissionMedicationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getFilterByCorporationAndType() {
            var filter = {};

            filter.corporationId = CoreService.getCorporation().id;
            filter.relationalType = RATIONALE_TYPE.MEDICATION;

            return filter
        }

        function getEmployees(query) {
            var filter = {page: 0, size: 20, query: query, facilityId: CoreService.getCurrentFacility().id};

            Employee.findAllByFilter(filter, function (result) {
                vm.employees = result;
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('AdmissionMedication', AdmissionMedication);

    AdmissionMedication.$inject = ['$resource', 'DateUtils', 'CoreService'];

    function AdmissionMedication($resource, DateUtils, CoreService) {
        var resourceUrl = 'api/admission-medications/:id';
        var facility = CoreService.getCurrentFacility();

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);

                        if (data.lastDate) {
                            data.lastDate = new Date(DateUtils.convertDateTimeFromServer(data.lastDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        if (data.expirationDate) {
                            data.expirationDate = new Date(DateUtils.convertDateTimeFromServer(data.expirationDate)
                                .toLocaleString("en-US", {timeZone: facility.timeZone}));
                        }

                        data.admissionFrequencies = _.sortBy(data.admissionFrequencies, 'xorder');

                        _.forEach(data.admissionFrequencies, function (frequency) {

                            frequency.schedules = _.sortBy(frequency.schedules, 'xorder');

                            _.forEach(frequency.schedules, function (schedule) {
                                schedule.date = moment(schedule.date).toDate();
                            });

                            frequency.hideDay = false;

                            switch (frequency.frequency.id) {
                                case 'EVERY_H':
                                case 'EVERY_2H':
                                case 'EVERY_3H':
                                case 'EVERY_4H':
                                case 'EVERY_6H':
                                case 'EVERY_8H':
                                case 'EVERY_12H':
                                case 'EVERY_24H':
                                case 'EVERY_48H':
                                case 'EVERY_WEEK':
                                case 'EVERY_TWO_WEEKS':
                                case 'EVERY_MONTH': {
                                    frequency.hideDay = true;

                                    break;
                                }
                            }
                        })
                    }

                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertDateTimeFromServer(copy.startDate);
                    return angular.toJson(copy);
                }
            },
            'save': {method: 'POST'},
            'findAllByFilter': {
                url: 'api/admission-medications/filter',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.forEach(function (item) {
                            item.loggedFullName = renderName(item.loggedFirstName, item.loggedLastName);
                            item.verifyFullName = renderName(item.verifyFirstName, item.verifyLastName);
                            item.witnessFullName = renderName(item.witnessFirstName, item.witnessLastName);
                        })
                    }

                    function renderName(firstName, lastName) {
                        return (firstName ? firstName : '') + ' ' + (lastName ? lastName : '');
                    }

                    return data;
                }
            },
            'verify': {
                method: 'POST',
                url: 'api/admission-medications/verify',
                isArray: true
            },
            'sign': {
                method: 'POST',
                url: 'api/admission-medications/sign'
            },
            'findAllFrequencies': {url: 'api/admission-medications/frequencies/:id', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AdmissionMedicationController', AdmissionMedicationController);

    AdmissionMedicationController.$inject = ['$uibModal', '$compile', '$scope', 'PopupService', 'chart',
        'DataTablesService', 'AdmissionMedication', 'DTOptionsBuilder', 'DTColumnBuilder',
        '$q', 'filter', 'CoreService', 'toastr', 'TAB', 'ConfirmationService'];

    function AdmissionMedicationController($uibModal, $compile, $scope, PopupService, chart,
                                           DataTablesService, AdmissionMedication, DTOptionsBuilder, DTColumnBuilder,
                                           $q, filter, CoreService, toastr, TAB, ConfirmationService) {
        var vm = this;

        vm.title = "Admission Medications";
        vm.chart = chart;

        vm.admissionMedications = [];
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.dtInstance = {};
        vm.selected = {};
        vm.selectAll = false;
        vm.filter = filter;
        vm.filterTpl = angular.copy(filter);
        vm.facility = CoreService.getCurrentFacility();
        vm.employee = CoreService.getCurrentEmployee();
        vm.TAB = TAB;

        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.getSelectedIds = DataTablesService.getSelectedIds;
        vm.isSelected = isSelected;
        vm.search = search;
        vm.clear = clear;
        vm.transition = transition;
        vm.findAllByFilter = findAllByFilter;
        vm.sign = sign;
        vm.openModalAddMedication = openModalAddMedication;
        vm.openModalEditMedication = openModalEditMedication;
        vm.del = del;
        vm.verify = verify;
        vm.openModalVerify = openModalVerify;
        vm.view = view;

        init();

        function init() {
            findAllByFilter();
        }

        function findAllByFilter() {
            AdmissionMedication.findAllByFilter(getFilter(), function (result, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.admissionMedications = result;

                _.forEach(vm.admissionMedications, function (admissionMedication) {
                    vm.selected[admissionMedication.id] = false;
                });
            });
        }

        function search() {
            vm.page = 1;
            vm.findAllByFilter();
        }

        function clear() {
            vm.filter = angular.copy(vm.filterTpl);
            vm.searchQuery = null;
            vm.page = 1;

            vm.findAllByFilter();
        }

        function transition() {
            vm.findAllByFilter();
        }

        function getFilter() {
            var filter = angular.copy(vm.filter);

            filter.chartId = vm.chart.id;
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.searchQuery = vm.searchQuery;

            return filter
        }

        function isSelected() {
            return vm.getSelectedIds(vm.selected).length > 0;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Admission Medication').result.then(function () {
                    AdmissionMedication.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }

        function openModalAddMedication() {
            $uibModal.open({
                templateUrl: 'app/entities/admission-medication/update/admission-medication-dialog.html',
                controller: 'AdmissionMedicationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.chart,
                    admissionMedication: {
                        id: null,
                        admissionMedicationAction: null,
                        asNeeded: false,
                        durationDays: null,
                        rxNumber: null,
                        lastDate: new Date(),
                        originalPrescriber: null,
                        amount: null,
                        instructions: null,
                        expirationDate: new Date(),
                        chart: vm.chart,
                        medication: null,
                        route: null,
                        doseForm: null,
                        witness: null,
                        verified: false,
                        relationals: [],
                        admissionFrequencies: [{
                            frequency: null,
                            xorder: 0,
                            isCollapsed: false
                        }],
                        signed: false,
                        collapsed: false
                    }
                }
            }).result.then(function () {
                transition();
            }, function () {

            });
        }

        function openModalEditMedication(id) {
            $uibModal.open({
                templateUrl: 'app/entities/admission-medication/update/admission-medication-dialog.html',
                controller: 'AdmissionMedicationDialogController',
                controllerAs: 'vm',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    chart: vm.chart,
                    admissionMedication: ['AdmissionMedication', function (AdmissionMedication) {

                        return AdmissionMedication.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                findAllByFilter();
            }, function () {
                findAllByFilter();
            });
        }

        function openModalVerify(id) {
            ConfirmationService.open({
                title: 'Confirm Verify Operation',
                message: 'Are you sure you want to <strong>Verify</strong> this <strong>Medication</strong>?',
                actions: [
                    {
                        name: 'Verify',
                        color: 'btn btn-success',
                        icon: 'fa fa-check-circle',
                        value: 'SUCCESS'
                    },
                    {
                        name: 'Cancel',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            }).result.then(function () {
                verify(id);
            });
        }

        function verify(id) {
            var ids = [];

            if (id) {
                ids = ["" + id];
            } else {
                ids = vm.getSelectedIds(vm.selected);
            }

            var admissionMedications = _.filter(vm.admissionMedications, function (admissionMedication) {
                return ids.indexOf("" + admissionMedication.id) != -1 && !admissionMedication.verified;
            });

            if (admissionMedications.length > 0) {
                AdmissionMedication.verify({
                    ids: _.map(admissionMedications, function (admissionMedication) {

                        return admissionMedication.id;
                    }),
                    facilityId: vm.facility.id,
                    employee: vm.employee
                }, function (result) {
                    if (result.length > 0) {
                        verifyAndAddMedication(result);
                    } else {
                        findAllByFilter();
                    }
                })
            }
        }

        function verifyAndAddMedication(result) {
            PopupService.showPatientMedicationPopup(vm.chart, result).result.then(function (data) {
                findAllByFilter();
            });
        }

        function sign(id) {
            var ids = [];

            if (id) {
                ids = ["" + id];
            } else {
                ids = vm.getSelectedIds(vm.selected);
            }

            var admissionMedications = _.filter(vm.admissionMedications, function (admissionMedication) {
                return ids.indexOf("" + admissionMedication.id) != -1 && admissionMedication.verified;
            });

            if (admissionMedications.length > 0) {
                PopupService.showSignaturePopup().result.then(function (data) {
                    AdmissionMedication.sign({
                        signature: data.employeeSignature,
                        pin: data.employeeSignaturePin,
                        ids: _.map(admissionMedications, function (admissionMedication) {

                            return admissionMedication.id;
                        }),
                        facilityId: vm.facility.id
                    }, function (result) {
                        findAllByFilter();
                        if (result) {
                            toastr.success("The Admission Medication was signed successfully.");
                        } else {
                            toastr.error("The Admission Medication wasn't signed.");
                        }
                    }, function () {
                        toastr.error("The Admission Medication wasn't signed.");
                    });
                }, function () {
                    // reload();
                });
            }
        }

        function view(id) {
            $uibModal.open({
                templateUrl: 'app/entities/admission-medication/detail/admission-medication-detail.html',
                controller: 'AdmissionMedicationDetailController',
                controllerAs: 'vm',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    admissionMedication: ['AdmissionMedication', function (AdmissionMedication) {
                        return AdmissionMedication.get({id: id}).$promise;
                    }]
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AdmissionMedicationDetailController', AdmissionMedicationDetailController);

    AdmissionMedicationDetailController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'Via', 'CoreService',
        'Route', 'admissionMedication', 'AdmissionMedication'];

    function AdmissionMedicationDetailController($timeout, $scope, $uibModalInstance, Via, CoreService,
                                               Route, admissionMedication, AdmissionMedication) {
        var vm = this;

        vm.admissionMedication = admissionMedication;
        vm.chart = admissionMedication.chart;

        vm.allergiesStr = "";
        vm.rationaleStr = "";
        vm.frequencies = [];

        init();

        function init() {
            AdmissionMedication.findAllFrequencies({id: vm.admissionMedication.id}, function (data) {
                vm.frequencies = _.sortBy(data, 'xorder');

                _.forEach(vm.frequencies, function (frequency) {
                    frequency.schedules = _.sortBy(frequency.schedules, 'xorder');

                    frequency.hideDay = false;

                    switch (frequency.frequency.id) {
                        case 'EVERY_H':
                        case 'EVERY_2H':
                        case 'EVERY_3H':
                        case 'EVERY_4H':
                        case 'EVERY_6H':
                        case 'EVERY_8H':
                        case 'EVERY_12H':
                        case 'EVERY_24H':
                        case 'EVERY_48H':
                        case 'EVERY_WEEK':
                        case 'EVERY_TWO_WEEKS':
                        case 'EVERY_MONTH': {
                            frequency.hideDay = true;

                            break;
                        }
                    }
                });
            });

            if (vm.admissionMedication.relationals.length > 0) {
                vm.rationaleStr =
                    _.join(
                        _.map(vm.admissionMedication.relationals, function (relational) {
                            return relational.name;
                        }), ', ');
            }
        }

        vm.clear = clear;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('admission-medication', {
                parent: 'entity',
                url: '/admission-medication/:id',
                data: {
                    authorities: [],
                    pageTitle: 'AdmissionMedications'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/admission-medication/list/admission-medication.html',
                        controller: 'AdmissionMedicationController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    chart: ['Chart', '$stateParams', function (Chart, $stateParams) {

                        return Chart.get({id: $stateParams.id}).$promise;
                    }],
                    filter: function () {
                        return {
                            searchQuery: null,
                            chart: null
                        };
                    }
                }
            })
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AcuityDialogController', AcuityDialogController);

    AcuityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Acuity'];

    function AcuityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Acuity) {
        var vm = this;

        vm.acuity = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.acuity.id !== null) {
                Acuity.update(vm.acuity, onSaveSuccess, onSaveError);
            } else {
                Acuity.save(vm.acuity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:acuityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Acuity', Acuity);

    Acuity.$inject = ['$resource'];

    function Acuity ($resource) {
        var resourceUrl =  'api/acuities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/acuities/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AcuityController', AcuityController);

    AcuityController.$inject = ['GenericEntityDatatableService', 'CoreService', 'Acuity', '$uibModal',
        '$q', 'ConfirmationService'];

    function AcuityController(GenericEntityDatatableService, CoreService, Acuity, $uibModal,
                              $q, ConfirmationService) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Acuities',
            newButtonTitle: 'New Acuity',
            entityClassHumanized: 'Acuities',
            entityStateName: 'acuity',
            service: Acuity,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            columns: [
                {
                    name: 'name',
                    title: 'Name',
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Acuity',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
            return $uibModal.open({
                templateUrl: 'app/entities/acuity/update/acuity-dialog.html',
                controller: 'AcuityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/acuity/update/acuity-dialog.html',
                controller: 'AcuityDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['Acuity', function (Acuity) {
                        return Acuity.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Acuity').result.then(function () {
                    Acuity.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('acuity', {
                parent: 'entity',
                url: '/acuity',
                data: {
                    authorities: [],
                    pageTitle: 'Acuities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/acuity/list/acuity.html',
                        controller: 'AcuityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_ACUITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_ACUITY, access);
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AbnormalAlertDialogController', AbnormalAlertDialogController);

    AbnormalAlertDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'AbnormalAlert',
        'LabCompendium', 'CoreService'];

    function AbnormalAlertDialogController($timeout, $scope, $uibModalInstance, entity, AbnormalAlert,
                                           LabCompendium, CoreService) {
        var vm = this;

        vm.abnormalAlert = entity;
        vm.testCodes = [];
        vm.facility = CoreService.getCurrentFacility();
        vm.labCompendiums = [];

        vm.getLabCompendium = getLabCompendium;
        vm.changeLaboratory = changeLaboratory;
        vm.clear = clear;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.abnormalAlert.id !== null) {
                AbnormalAlert.update(vm.abnormalAlert, onSaveSuccess, onSaveError);
            } else {
                vm.ids = [];
                vm.labCompendiums.forEach(function (element) {
                    vm.ids.push(element.id);
                });
                AbnormalAlert.saveAll({ids: vm.ids, facilityId: vm.facility.id}, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('bluebookApp:abnormalAlertUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getLabCompendium(query) {
            if (query && query.length > 1) {
                LabCompendium.filter({
                    laboratoryId: vm.abnormalAlert.laboratory.id,
                    searchQuery: query,
                    page: vm.page - 1,
                    size: 40,
                    sort: 'code,asc',
                    facilityId: vm.facility.id
                }, function (result, headers) {
                    vm.testCodes = result;
                });
            }
        }

        function changeLaboratory() {
            vm.testCodes = [];
            vm.labCompendiums = [];
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('AbnormalAlert', AbnormalAlert);

    AbnormalAlert.$inject = ['$resource'];

    function AbnormalAlert ($resource) {
        var resourceUrl =  'api/abnormal-alerts/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'saveAll': {url: 'api/abnormal-alerts/save-all', method: 'POST', isArray: true},
            'filter': {url: 'api/abnormal-alerts/filter', method: 'GET', isArray: true},
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AbnormalAlertController', AbnormalAlertController);

    AbnormalAlertController.$inject = ['GenericEntityDatatableService', 'CoreService', 'AbnormalAlert', 'PopupService',
        '$q', '$uibModal', 'ConfirmationService'];

    function AbnormalAlertController(GenericEntityDatatableService, CoreService, AbnormalAlert, PopupService,
                                     $q, $uibModal, ConfirmationService) {
        var vm = this;

        vm.laboratory = null;

        var params = {
            facilityId: CoreService.getCurrentFacility().id
        }

        vm.descriptor = {
            title: 'Abnormal Alerts',
            newAction: false,
            entityClassHumanized: 'abnormal-alert',
            entityStateName: 'abnormal-alert',
            service: AbnormalAlert,
            serviceMethod: 'filter',
            pagination: 'remote',
            params: params,
            options: [{key: 'aaSorting', value: [[1, 'asc']]}],
            columns: [
                {
                    name: 'id',
                    title: 'ID',
                },
                {
                    name: null,
                    title: 'Test Code',
                    render: function (data) {
                        return data.labCompendium == null ? " " : data.labCompendium.code;
                    }
                },
                {
                    name: null,
                    title: 'Description',
                    render: function (data) {
                        return data.labCompendium == null ? " " : data.labCompendium.description;
                    }
                },
                {
                    title: 'Laboratory',
                    render: function () {
                        return vm.laboratory.name;
                    }
                },
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getDeleteAction('abnormal-alert'), {
                    action: function (data) {
                        return del(data.id);
                    }
                })
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Abnormal Alert',
                            action: function () {
                                return add();
                            },
                            disabled: function () {
                                return vm.laboratory === null;
                            }
                        })
                    ]
                }
            ],
            leftActions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getCheckAction(), {
                            name: 'Select Laboratory',
                            action: function (filter) {
                                return $q(function (resolve) {
                                    PopupService.showSelectFacilityLabPopup(filter).result.then(function (result) {
                                        filter.laboratoryId = {id: result.labId, name: result.name};

                                        vm.laboratory = {id: result.labId, name: result.name};
                                        vm.descriptor.title = 'Abnormal Alerts - ' + vm.laboratory.name

                                        resolve();
                                    });
                                })
                            }
                        })
                    ]
                }
            ],
            filters: [
                {
                    name: 'laboratoryId',
                    visible: false,
                    read: function (filter) {
                        return filter.laboratoryId ? filter.laboratoryId.id : null;
                    }
                }
            ],
        }

        function add() {
            return $q(function (resolve) {
                $uibModal.open({
                    templateUrl: 'app/entities/abnormal-alert/update/abnormal-alert-dialog.html',
                    controller: 'AbnormalAlertDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    windowTopClass: 'custom-dialog-styles',
                    resolve: {
                        entity: ['CoreService', function (CoreService) {
                            return {
                                id: null,
                                facility: CoreService.getCurrentFacility(),
                                laboratory: vm.laboratory
                            };
                        }]
                    }
                }).result.then(function () {
                    resolve();
                });
            })
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Abnormal Alert').result.then(function () {
                    AbnormalAlert.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('abnormal-alert', {
            parent: 'entity',
            url: '/abnormal-alert',
            data: {
                authorities: [],
                pageTitle: 'AbnormalAlerts'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/abnormal-alert/list/abnormal-alert.html',
                    controller: 'AbnormalAlertController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_LABORATORY, access);
            }]
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('DashboardService', DashboardService);

    DashboardService.$inject = ['$resource'];

    function DashboardService($resource) {
        var resourceUrl = 'api/evaluations/:id';

        function transformCountResponse(data) {
            if (data) {
                return {count: data};
            }
            return {count: 0};
        }

        return $resource(resourceUrl, {}, {
            'countWithoutDiagnosis': {
                url: 'api/charts/count-without-diagnosis/:id', method: 'GET', isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countWithoutInsurance': {
                url: 'api/charts/count-without-insurance/:id', method: 'GET', isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countWithoutCareTeam': {
                url: 'api/charts/count-without-care-team/:id', method: 'GET', isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countWithoutConcurrentReview': {url: 'api/charts/count-without-concurrent/:id', method: 'GET', isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countExpiredConcurrentReview': {url: 'api/charts/count-expired-concurrent/:id', method: 'GET', isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countExpiringConcurrentReview': {url: 'api/charts/count-expiring-concurrent/:id', method: 'GET', isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data) {
                        return {value: data};
                    }
                    return {value: 0};
                }
            },
            'countAllByFilter': {url: 'api/evaluations/count-all-by-filter', method: 'GET',  isArray: false,
                ignoreLoadingBar: true,
                transformResponse: transformCountResponse
            },
            'countAllPendingByStaffFilter': {url: 'api/evaluations/count-all-pending-by-staff-filter', method: 'GET',  isArray: false,
                ignoreLoadingBar: true,
                transformResponse: transformCountResponse
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('UnassignedResultsTopBoxController', UnassignedResultsTopBoxController);

    UnassignedResultsTopBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder',
        'PatientResult', 'CoreService'];

    function UnassignedResultsTopBoxController(facility, $scope, $state, $q, DTColumnBuilder,
                                               PatientResult, CoreService) {
        var vm = this;
        vm.unassigned = 0;
        vm.facility = CoreService.getCurrentFacility();

        vm.unassigned = PatientResult.countUnassigned({id: vm.facility.id});
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('StayBoxController', StayBoxController);

    StayBoxController.$inject = ['Chart', 'CoreService'];

    function StayBoxController(Chart, CoreService) {

        var vm = this;

        vm.count = 0;
        vm.facility = CoreService.getCurrentFacility();

        Chart.aveLengthOfStay({
            id: vm.facility.id,
        }, function (data) {
            if (data.value) {
                vm.count = data.value;
            }
        });
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ReferralSourceBoxController', ReferralSourceBoxController);

    ReferralSourceBoxController.$inject = ['facility', '$scope', '$state', 'CoreService', 'Chart'];

    function ReferralSourceBoxController(facility, $scope, $state, CoreService, Chart) {
        var vm = this;

        vm.countReferrers = null;
        vm.count = 0;

        vm.openCharts = openCharts;
        loadData();


        function loadData() {
            vm.countReferrers = Chart.countReferrers({id: CoreService.getCurrentFacility().id}, function (result) {
                _.forEach(result, function (el) {
                    vm.count += el.count;
                });
            });
        }

        function openCharts(referrer) {
            $state.go('charts-referrer', {referrer: referrer});
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/24/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PrintRequisitionBoxController', PrintRequisitionBoxController);

    PrintRequisitionBoxController.$inject = ['facility', 'PatientOrder', 'filter', 'DateUtils', 'CoreService',
        '$uibModal', 'AlertService', 'DYMO', 'DataTablesService', 'DTOptionsBuilder',
        'DTColumnBuilder', '$compile', '$q', 'GUIUtils', '$scope', 'PopupService', 'Chart',
        'LabRequisitionSignature', 'toastr'];

    function PrintRequisitionBoxController(facility, PatientOrder, filter, DateUtils, CoreService,
                                           $uibModal, AlertService, DYMO, DataTablesService, DTOptionsBuilder,
                                           DTColumnBuilder, $compile, $q, GUIUtils, $scope, PopupService, Chart,
                                           LabRequisitionSignature, toastr) {
        var vm = this;

        vm.facility = facility;
        vm.page = 1;
        vm.itemsPerPage = 2;
        vm.queryCount = 0;
        vm.orders = [];
        vm.barcodes = [];
        vm.filter = filter;
        vm.dtInstance = {};
        vm.date = new Date();
        vm.labRequisitions = [];
        vm.selected = {};
        vm.selectAll = false;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.selectedDate = false;
        var titleHtml = '<input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)">';
        vm.barcode = null;

        vm.create = create;
        vm.manifest = manifest;
        vm.printLabels = printLabels;
        vm.searchByQuery = searchByQuery;
        vm.labRequisitionPDF = labRequisitionPDF;
        vm.getSelectedBarcodes = getSelectedBarcodes;
        vm.openCalendar = openCalendar;
        vm.printDYMOLabels = printDYMOLabels;
        vm.toggleOne = DataTablesService.toggleOne;
        vm.toggleAll = DataTablesService.toggleAll;
        vm.detail = detail;
        vm.addSignature = addSignature;

        vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
            var defer = $q.defer();

            var newFilter = angular.copy(vm.filter);
            newFilter.date = moment(vm.date).format('YYYY-MM-DD');
            PatientOrder.filter(newFilter, onSuccess, onError);

            function onSuccess(data) {
                vm.labRequisitions = data;
                defer.resolve(data);
                vm.orders = setUniqueIds(data);
                vm.selected = {};
                vm.selectAll = false;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }

            return defer.promise;
        }).withBootstrap().withDOM('tip')
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withOption('aaSorting', [[1, 'asc']])
            .withOption('headerCallback', function (header) {
                if (!vm.headerCompiled) {
                    vm.headerCompiled = true;
                    $compile(angular.element(header).contents())($scope);
                }
            }).withPaginationType('full_numbers').withBootstrap().withDOM('ltp').withLanguage({
                "paginate": {
                    "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                    "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                    "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                    "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                }
            }).withDisplayLength(15).withOption('lengthMenu', [[10, 15, 25, 50, -1], [10, 15, 25, 50, "All"]]);

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).withTitle(titleHtml).withOption('width', '25px').notSortable().renderWith(function (data, type, full, meta) {
                vm.selected[full.id] = false;
                return '<input type="checkbox" ng-model="vm.selected[' + data.id + ']" ng-click="vm.toggleOne(vm.selected, vm.selectAll)">';

            }),
            DTColumnBuilder.newColumn(null).withTitle('Patient Name').renderWith(function (data, type, full) {
                return data.firstName + (data.middleName == null ? " " : " " + data.middleName + " ") + data.lastName;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Order').renderWith(function (data, type, full) {
                return data.patientOrderId;
            }),
            DTColumnBuilder.newColumn(null).withTitle('D.O.B').renderWith(function (data, type, full) {
                return moment(data.dateBirth).format('MM/DD/YYYY');
            }),
            DTColumnBuilder.newColumn(null).withTitle('Barcode').renderWith(function (data, type, full) {
                return data.barcode ? GUIUtils.getStatusTemplate(data.barcode.toString(), 'primary') : null;
            }),
            DTColumnBuilder.newColumn(null).withTitle('Laboratory').renderWith(function (data, type, full) {
                return getLaboratoryName(data.laboratoryName);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Status').renderWith(function (data, type, full) {
                return data.itemStatus ? GUIUtils.colorHtmlStatusRequisition(data.itemStatus) : null;
            }),
            DTColumnBuilder.newColumn('signed').withTitle('Signed').renderWith(function (data) {
                return GUIUtils.colorHtmlYesNo(data);
            }),
            DTColumnBuilder.newColumn(null).withTitle('Actions').withOption('width', '155px').notSortable().renderWith(actionsHtml)
        ];

        function actionsHtml(data, type, full, meta) {
            var stButtons = '';
            if (!data.signatureId && data.barcode) {
                stButtons += '<a class="dt-btn danger" ng-click="vm.addSignature(' + data.chartId + ", " + "'" + data.barcode + "'" + ')">' + ' ' +
                    '  <i class="fa fa-edit"></i></a>&nbsp;';
            }
            if (data.barcode) {
                stButtons += '<a class="dt-btn danger" ng-click="vm.labRequisitionPDF(' + "'" + data.barcode + "'" + ')">' + ' ' +
                    '  <i class="fa fa-file-pdf-o"></i></a>&nbsp;';
            }
            stButtons += '<a class="info-btn" ng-click="vm.detail(' + data.patientOrderId + "," +
                (data.barcode ? "'" + data.barcode + "'," : "null,") +
                "'" + data.scheduleDate + "'" + ')">' +
                '  <i class="fa fa-eye"></i></a>&nbsp;';

            return stButtons;
        }

        function setUniqueIds(data) {
            for (var i = 0; i < data.length; i++) {
                data[i].id = data[i].patientOrderId;
            }

            return data;
        }

        function labRequisitionPDF(barcode) {
            PatientOrder.getPDFLabRequisition({barcode: barcode});
        }

        function printLabels() {
            var values = getSelectedBarcodes();

            if (values.length > 0) {
                PatientOrder.pdfBarcodeLabels({facilityId: vm.facility.id, printBarcode: values}, function (result) {
                    vm.dtInstance.reloadData();
                });
            }
        }

        function printDYMOLabels() {
            var values = getSelectedBarcodes();

            if (values.length > 0) {
                PatientOrder.getBarcodeLabels({facilityId: vm.facility.id, printBarcode: values}, function (result) {
                    if (DYMO.loadPrinters()) {
                        _.forEach(result, function (label) {
                            DYMO.printPatientOrderLabel({
                                barcode: label.barcode,
                                name: label.firstName + (label.middleName ? label.middleName + " " : " ") + label.lastName,
                                dob: label.dateBirth,
                                collectedDate: label.scheduleDate,
                                tube: label.tube,
                                account: label.accountNo
                            })
                        });

                        vm.dtInstance.reloadData();
                    } else {
                        toastr.error('No DYMO printers are installed. Install DYMO printers.');
                    }
                });
            }
        }

        function getSelectedBarcodes() {
            var values = [];
            for (var id in vm.selected) {
                if (vm.selected[id]) {
                    var index = _.findIndex(vm.orders, function (order) {
                        return order.patientOrderId == parseInt(id);
                    });
                    values.push({
                        chartId: vm.orders[index].chartId,
                        date: DateUtils.convertLocalDateToServer(vm.orders[index].scheduleDate),
                        patientOrderId: vm.orders[index].patientOrderId,
                        barcode: vm.orders[index].barcode

                    });
                }
            }

            return values;
        }

        function manifest() {
            var values = _.map(getSelectedBarcodes(), function (value) {
                return value.barcode;
            });

            PatientOrder.getPDFManifest({
                facilityId: vm.facility.id,
                barcodes: values
            }, function (result) {
                vm.dtInstance.reloadData();
            }, function (result) {
                vm.dtInstance.reloadData();
            });

            vm.selected = {};
        }

        function create() {
            $uibModal.open({
                templateUrl: 'app/entities/patient-order/lab-requisition/create/lab-requisition-dialog.html',
                controller: 'LabRequisitionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    date: [function () {
                        return vm.date;
                    }]
                }
            }).result.then(function () {
                vm.dtInstance.reloadData();
            }, function () {
                vm.dtInstance.reloadData();
            });
        }

        function searchByQuery() {
            vm.dtInstance.reloadData();
        }

        function getLaboratoryName(data) {
            if (data && data.length > 0) {
                return data && data.length > 20 ? data.substr(0, 20) + "..." : data;
            } else {
                return "-";
            }
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function detail(patientOrderId, barcode, date) {
            PopupService.showLabRequisitionDetailPopup(patientOrderId, barcode, date);
        }

        function addSignature(chartId, barcode) {
            Chart.get({id: chartId}, function (chart) {
                if (PopupService.checkSigPlusExtLiteExtension()) {
                    startSign(barcode);
                } else {
                    PopupService.showPatientSignaturePopup(chart).result.then(function (signature) {
                        LabRequisitionSignature.save({
                            barcode: barcode,
                            signature: signature
                        }, onSaveSuccess, onSaveError);
                    });
                }
            })
        }

        function onSaveSuccess (result) {
            vm.dtInstance.reloadData();
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.dtInstance.reloadData();
            vm.isSaving = false;
        }

        function startSign(barcode) {
            vm.barcode = barcode;

            var message = {
                "firstName": "",
                "lastName": "",
                "eMail": "",
                "location": "",
                "imageFormat": 1,
                "imageX": 500,
                "imageY": 100,
                "imageTransparency": false,
                "imageScaling": false,
                "maxUpScalePercent": 0.0,
                "rawDataFormat": "ENC",
                "minSigPoints": 25
            };

            top.document.addEventListener('SignResponse', SignResponse, false);
            var messageData = JSON.stringify(message);
            var element = document.createElement("MyExtensionDataElement");
            element.setAttribute("messageAttribute", messageData);
            document.documentElement.appendChild(element);
            var evt = document.createEvent("Events");
            evt.initEvent("SignStartEvent", true, false);
            element.dispatchEvent(evt);
        }

        function SignResponse(event) {
            var str = event.target.getAttribute("msgAttribute");
            var objResponse = JSON.parse(str);
            var obj = null;

            if (typeof (objResponse) === 'string') {
                obj = JSON.parse(objResponse);
            } else {
                obj = JSON.parse(JSON.stringify(objResponse));
            }

            if (obj.errorMsg != null && obj.errorMsg != "" && obj.errorMsg != "undefined") {
                toastr.error(obj.errorMsg);
            } else {
                if (obj.isSigned) {
                    LabRequisitionSignature.save({
                        barcode: vm.barcode,
                        signature: {signature: "data:image/jpg;base64," + obj.imageData}
                    }, onSaveSuccess, onSaveError);
                }
            }

            top.document.removeEventListener('SignResponse', SignResponse, false);
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PhysicianReviewBoxController', PhysicianReviewBoxController);

    PhysicianReviewBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function PhysicianReviewBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.critical = 0;

        // vm.abnormal = PatientResult.countAbnormal({id: facility.id});
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PendingRequisitionsTopBoxController', PendingRequisitionsTopBoxController);

    PendingRequisitionsTopBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function PendingRequisitionsTopBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.pending = 0;

        vm.pending = PatientResult.countPartial({id: facility.id});
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PendingByStaffReviewBoxController', PendingByStaffReviewBoxController);

    PendingByStaffReviewBoxController.$inject = ['DashboardService', 'CoreService'];

    function PendingByStaffReviewBoxController(DashboardService, CoreService) {

        var vm = this;

        vm.count = 0;
        vm.facility = CoreService.getCurrentFacility();

        DashboardService.countAllByFilter({
            facilityId: vm.facility.id,
            status: "InReview",
            empty: null,
            forceStaffReviewSignature: true,
            existStaffReviewSignature: false
        }, function (data) {
            if (data.count) {
                vm.count = data.count;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PendingByStaffBoxController', PendingByStaffBoxController);

    PendingByStaffBoxController.$inject = ['DashboardService', 'CoreService'];

    function PendingByStaffBoxController(DashboardService, CoreService) {

        var vm = this;

        vm.count = 0;
        vm.facility = CoreService.getCurrentFacility();

        DashboardService.countAllPendingByStaffFilter({
            facilityId: vm.facility.id
        }, function (data) {
            if (data.count) {
                vm.count = data.count;
            }
        });
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PendingByPatientBoxController', PendingByPatientBoxController);

    PendingByPatientBoxController.$inject = ['DashboardService', 'CoreService'];

    function PendingByPatientBoxController(DashboardService, CoreService) {

        var vm = this;

        vm.facility = CoreService.getCurrentFacility();
        vm.count = 0;

        DashboardService.countAllByFilter({
            facilityId: vm.facility.id,
            status: "Pending",
            empty: false,
            requiredPatientSignature: true,
            existPatientSignature: false
        }, function (data) {
            if (data.count) {
                vm.count = data.count;
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PayerMixBoxController', PayerMixBoxController);

    PayerMixBoxController.$inject = ['$state', 'Chart', 'CoreService'];

    function PayerMixBoxController($state, Chart, CoreService) {
        var vm = this;

        vm.payers = null;
        vm.count = 0;

        vm.openCharts = openCharts;
        vm.payerAdjust = payerAdjust;

        loadData();

        function loadData() {
            vm.payers = Chart.getAllPayers({id: CoreService.getCurrentFacility().id}, function (result) {
                _.forEach(result, function (el) {
                    vm.count += el.count;
                    if (el.insuranceCarrier == null && el.typePayment != null) {
                        el.name = _.upperCase(el.typePayment.name);
                    } else if (el.insuranceCarrier != null && el.typePayment == null) {
                        el.name = el.insuranceCarrier.name;
                    } else {
                        el.name = "UNKNOWN";
                    }
                })
            });
        }

        function openCharts(item) {
            if (item.insuranceCarrier != null && item.typePayment == null) {
                $state.go('charts-payer-mix-ins', {id: item.insuranceCarrier.id});
            } else if (item.insuranceCarrier == null && item.typePayment != null) {
                $state.go('charts-payer-mix-no', {id: item.typePayment.id});
            } else {
                $state.go('charts-payer-mix-no-ins', {id: null});
            }
        }

        function payerAdjust(data) {
            return data && data.length > 0 ? (data && data.length > 35 ? data.substr(0, 35) + " ..." : data) : "-";
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PartialResultsTopBoxController', PartialResultsTopBoxController);

    PartialResultsTopBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function PartialResultsTopBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.partial = 0;

        vm.partial = PatientResult.countPartial({id: facility.id});
    }
})();

/**
 * Created by jesusrodriguez on 2/24/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MarsMorsBoxController', MarsMorsBoxController);

    MarsMorsBoxController.$inject = ['ParseLinks', 'PatientMedication', 'CoreService', 'TypeLevelCare', '$uibModal', 'filter', 'Medication', 'facility',
        'PatientMedicationTake', 'toastr'];

    function MarsMorsBoxController(ParseLinks, PatientMedication, CoreService, TypeLevelCare, $uibModal, filter, Medication, facility,
                                   PatientMedicationTake, toastr) {
        var vm = this;

        vm.title = "MARs";
        vm.entityStateName = 'MARs';
        vm.dtInstance = {};
        vm.selected = {};
        vm.searchQuery = "";
        vm.filter = filter;
        vm.takes = [];
        vm.itemsPerPage = 10;
        vm.page = 1;
        vm.facility = facility;
        vm.date = new Date();
        vm.totalItems = 0;

        vm.datePickerOpenStatus = {dob: false};
        vm.physicians = [];
        vm.filterStatus = "CURRENT";
        vm.status = {
            SCHEDULED: 'SCHEDULED',
            SYSTEM_MISS: 'SYSTEM_MISS',
            HOLD: 'HOLD',
            ADMINISTERED: 'ADMINISTERED',
            OBSERVED: 'OBSERVED',
            MISSED: 'MISSED'
        };

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.openAsNeededModal = openAsNeededModal;
        vm.administer = administer;
        vm.observe = observe;
        vm.miss = miss;
        vm.openMissModel = openMissModel;
        vm.hold = hold;

        loadAll();

        function loadAll() {
            var filter = angular.copy(vm.filter);
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            var now = new Date();
            now.setDate(now.getDate() -1);
            filter.startDate = vm.date;
            filter.endDate = vm.date;
            filter.filterStatus= vm.filterStatus;
            filter.pending= true;

            PatientMedication.marsByFacility(filter, function (result, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.takes = result;

            });

        }

        function transition() {
            loadAll();
        }

        function openAsNeededModal() {
            $uibModal.open({
                templateUrl: 'app/entities/patient-medication/patient-medication-mars-as-needed-dialog.html',
                controller: 'PatientMedicationMarsAsNeededDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    filter: {
                        facilityId: CoreService.getCurrentFacility().id,
                        page: 1,
                        size: 10
                    }
                }
            }).result.then(function () {
                //apply
            }, function (result) {
                //cancel
            });
        }

        function administer(id) {
            PatientMedicationTake.changeStatus({status: vm.status.ADMINISTERED, take: {id: id}}, function (result) {
                if (result.medicationTakeStatus == vm.status.ADMINISTERED) {
                    loadAll();
                    toastr.success('The medications has been administered');
                } else {toastr.error('Some medications not has been administered');}
            });
        }

        function observe(id) {
            PatientMedicationTake.changeStatus({status: vm.status.OBSERVED, take: {id: id}}, function (result) {
                if (result.medicationTakeStatus == vm.status.OBSERVED) {
                    loadAll();
                    toastr.success('The medications has been observed');
                }else {toastr.error('Some medications not has been observed');}
            });
        }

        function miss(id, chartId) {
            vm.openMissModel(id, chartId);
        }

        function openMissModel(id, chartId) {
            $uibModal.open({
                templateUrl: 'app/entities/patient-medication/patient-medication-mars-miss-wizard-dialog.html',
                controller: 'PatientMedicationMarsMissWizardDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    status: vm.status,
                    take: ['PatientMedicationTake', function (PatientMedicationTake) {
                        return PatientMedicationTake.get({id: id}).$promise;
                    }],
                    entity: function () {
                        return {
                            name: null,
                            id: null,
                            patientMedicationTake: {id: id}
                        };
                    },
                    chart: ['Chart', function (Chart) {
                        return Chart.get({id: chartId}).$promise;
                    }]
                }
            }).result.then(function () {
                loadAll();
            }, function (result) {
                //cancel
            });
        }

        function hold(id) {
            PatientMedicationTake.changeStatus({status: vm.status.HOLD, take: {id: id}}, function (result) {
                if (result.medicationTakeStatus == vm.status.HOLD) {
                    loadAll();
                }
            });
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('MarketersBoxController', MarketersBoxController);

    MarketersBoxController.$inject = ['$scope', '$state', 'CoreService', 'Chart'];

    function MarketersBoxController($scope, $state, CoreService, Chart) {
        var vm = this;

        vm.countChartsMarketers = null;
        vm.count = 0;

        loadData();
        vm.openCharts = openCharts;

        function loadData() {
            vm.countChartsMarketers = Chart.countChartsWithMarketers({id: CoreService.getCurrentFacility().id}, function (result) {
                _.forEach(result, function (el) {
                    vm.count += el.count;
                });
            });
        }

        function openCharts(employee){
            $state.go('charts-marketer', {marketer: employee.id});
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LevelCareBoxController', LevelCareBoxController);

    LevelCareBoxController.$inject = ['$scope', '$state', 'CoreService', 'Chart'];

    function LevelCareBoxController($scope, $state, CoreService, Chart) {
        var vm = this;

        vm.countLevelOfCare = null;
        vm.count = 0;

        vm.openCharts = openCharts;
        loadData();

        function loadData() {
            vm.countLevelOfCare = Chart.countTypeLevelOfCare({id: CoreService.getCurrentFacility().id}, function (result) {
                _.forEach(result, function (el) {
                    vm.count += el.count;
                });
            });
        }

        function openCharts(levelCare) {
            $state.go('charts', {levelCare: levelCare});
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .controller('LateCareDeliveryBoxController', LateCareDeliveryBoxController);

    LateCareDeliveryBoxController.$inject = ['DashboardService', 'CoreService'];

    function LateCareDeliveryBoxController(DashboardService, CoreService) {

        var vm = this;

        vm.facility = CoreService.getCurrentFacility();

        vm.total = 0;
        vm.countClosed = 0;
        vm.countArchive = 0;
        vm.countCurrent = 0;
        vm.percentClosed = 0;
        vm.percentArchive = 0;
        vm.percentCurrent = 0;

        DashboardService.countAllByFilter({
            facilityId: vm.facility.id,
            status: "Late",
            requiredPatientSignature: false,
            empty: false
        }, function (result) {
            vm.total = result.count ? result.count : 0;

            if (vm.total > 0) {
                DashboardService.countAllByFilter({
                    facilityId: vm.facility.id,
                    chartStatus: 'CLOSED',
                    status: "Late",
                    requiredPatientSignature: false,
                    empty: false
                }, function (result) {
                    vm.countClosed = result.count ? result.count : 0;
                    vm.percentClosed = (parseInt(vm.countClosed) * 100 / parseInt(vm.total));
                    vm.percentClosed = vm.percentClosed.toFixed(2);
                });

                DashboardService.countAllByFilter({
                    facilityId: vm.facility.id,
                    chartStatus: 'ARCHIVE',
                    status: "Late",
                    requiredPatientSignature: false,
                    empty: false
                }, function (result) {
                    vm.countArchive = result.count ? result.count : 0;
                    vm.percentArchive = (parseInt(vm.countArchive) * 100 / parseInt(vm.total));
                    vm.percentArchive = vm.percentArchive.toFixed(2);
                });

                DashboardService.countAllByFilter({
                    facilityId: vm.facility.id,
                    chartStatus: 'CURRENT',
                    status: "Late",
                    requiredPatientSignature: false,
                    empty: false
                }, function (result) {
                    vm.countCurrent = result.count ? result.count : 0;
                    vm.percentCurrent = (parseInt(vm.countCurrent) * 100 / parseInt(vm.total));
                    vm.percentCurrent = vm.percentCurrent.toFixed(2);
                });
            }
        });
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncomingPatientsBoxController', IncomingPatientsBoxController);

    IncomingPatientsBoxController.$inject = ['PopupService', 'facility', 'Chart', '$state', 'AlertService'];

    function IncomingPatientsBoxController(PopupService, facility, Chart, $state, AlertService) {
        var vm = this;

        vm.filter = {};
        vm.charts = [];
        vm.facility = facility;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.queryCount = 0;

        vm.loadAll = loadAll;
        vm.showCreatePatientPopup = showCreatePatientPopup;
        vm.transition = transition;
        vm.openChart = openChart;
        vm.levelCare = levelCare;
        vm.referral = referral;
        vm.searchByQuery = searchByQuery;

        function showCreatePatientPopup() {
            PopupService.showCreatePatientPopup().result.then(function () {
                loadAll();
            });
        }

        loadAll();

        function loadAll() {
            Chart.incoming(getFilter(), onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.charts = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function getFilter() {
            var filter = {};
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.facilityId = vm.facility.id;
            filter.searchQuery = vm.searchQuery;

            return filter;
        }

        function searchByQuery() {
            vm.page = 1;
            vm.filter.status = null;
            vm.transition();
        }

        function openChart(chartId) {
            $state.go('chart', {id: chartId});
        }

        function levelCare(data) {
            if (data && data.length > 0) {
                return data && data.length > 15 ? data.substr(0, 15) + "..." : data;
            } else {
                return "-";
            }
        }

        function referral(data) {
            if (data && data.length > 0) {
                return data && data.length > 15 ? data.substr(0, 15) + "..." : data;
            } else {
                return "-";
            }
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentReportBoxController', IncidentReportBoxController);

    IncidentReportBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function IncidentReportBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.critical = 0;

        // vm.abnormal = PatientResult.countAbnormal({id: facility.id});
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EmptyCareDeliveryBoxController', EmptyCareDeliveryBoxController);

    EmptyCareDeliveryBoxController.$inject = ['DashboardService', 'CoreService'];

    function EmptyCareDeliveryBoxController(DashboardService, CoreService) {

        var vm = this;

        vm.count = 0;
        vm.facility = CoreService.getCurrentFacility();

        DashboardService.countAllByFilter({
            facilityId: vm.facility.id,
            empty: true,
            status: ['Pending', 'Late']
        }, function (data) {
            if (data.count) {
                vm.count = data.count;
            }
        });
    }
})();

/**
 * Created by jesusrodriguez on 2/24/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DischargingPatientsBoxController', DischargingPatientsBoxController);

    DischargingPatientsBoxController.$inject = ['facility', 'Chart', '$state', 'AlertService'];

    function DischargingPatientsBoxController(facility, Chart, $state, AlertService) {
        var vm = this;

        vm.filter = {};
        vm.charts = [];
        vm.facility = facility;
        vm.page = 1;
        vm.itemsPerPage = 10;
        vm.queryCount = 0;

        vm.loadAll = loadAll;
        vm.transition = transition;
        vm.dischargeTo = dischargeTo;
        vm.referral = referral;
        vm.openChart = openChart;
        vm.searchByQuery = searchByQuery;

        loadAll();

        function loadAll() {
            Chart.discharging(getFilter(), onSuccess, onError);

            function onSuccess(data, headers) {
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.charts = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadAll();
        }

        function getFilter() {
            var filter = {};
            filter.page = vm.page - 1;
            filter.size = vm.itemsPerPage;
            filter.facilityId = vm.facility.id;
            filter.searchQuery = vm.searchQuery;
            filter.sort = ["dischargeDate,asc", "firstName,asc"];

            return filter;
        }

        function searchByQuery() {
            vm.page = 1;
            vm.filter.status = null;
            vm.transition();
        }

        function openChart(chartId) {
            $state.go('chart', {id: chartId});
        }


        function dischargeTo(data) {
            if (data && data.length > 0) {
                return data && data.length > 15 ? data.substr(0, 15) + "..." : data;
            } else {
                return "-";
            }
        }

        function referral(data) {
            if (data && data.length > 0) {
                return data && data.length > 15 ? data.substr(0, 15) + "..." : data;
            } else {
                return "-";
            }
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DischargeTypeBoxController', DischargeTypeBoxController);

    DischargeTypeBoxController.$inject = ['facility', '$scope', '$state', 'CoreService', 'Chart'];

    function DischargeTypeBoxController(facility, $scope, $state, CoreService, Chart) {

        var vm = this;
        vm.dischargeType = null;
        vm.count = 0;
        vm.openCharts = openCharts;

        vm.dischargeTypeAdjust = dischargeTypeAdjust;
        loadData();

        function loadData() {
            vm.dischargeType = Chart.countDischargeType({id: CoreService.getCurrentFacility().id}, function (result) {
                _.forEach(result, function (el) {
                    vm.count += el.count;
                });
            });
        }

        function dischargeTypeAdjust(data) {
            return data && data.length > 0 ? (data && data.length > 35 ? data.substr(0, 35) + " ..." : data) : "-";
        }

        function openCharts(typeDischargeType) {
            $state.go('charts-discharge', {dischargeType: typeDischargeType ? typeDischargeType.id : null});
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CriticalResultsTopBoxController', CriticalResultsTopBoxController);

    CriticalResultsTopBoxController.$inject = ['facility', 'PatientResult', '$uibModal','openModalCritical','CoreService'];

    function CriticalResultsTopBoxController(facility, PatientResult, $uibModal, openModalCritical, CoreService) {
        var vm = this;
        vm.critical = 0;
        vm.openModalCritical = openModalCritical;
        vm.modalCriticalResults = modalCriticalResults;

        PatientResult.countCritical({id: facility.id}, function (result) {
            vm.critical = result;

            if (result.value > 0 && vm.openModalCritical == undefined ) {
                modalCriticalResults(vm.critical);
                CoreService.setStorage('openModalCritical', true);
            }
        });

        function modalCriticalResults(critical) {
            $uibModal.open({
                templateUrl: 'app/dashboard2/layout/critical-results/alert/patient-result-critical-alert-dialog.html',
                controller: 'PatientResultCriticalAlertDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    critical: critical
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PatientResultCriticalAlertDialogController', PatientResultCriticalAlertDialogController);

    PatientResultCriticalAlertDialogController.$inject = ['$uibModalInstance', 'critical'];

    function PatientResultCriticalAlertDialogController($uibModalInstance, critical) {
        var vm = this;

        vm.clear = clear;
        vm.critical = critical;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewsBoxController', ConcurrentReviewsBoxController);

    ConcurrentReviewsBoxController.$inject = ['DashboardService', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult', 'CoreService'];

    function ConcurrentReviewsBoxController(DashboardService, $scope, $state, $q, DTColumnBuilder, PatientResult, CoreService) {

        var vm = this;
        vm.total = 0;
        vm.countWithout = 0;
        vm.countExpired = 0;
        vm.countExpiring = 0;
        vm.percentWithout = 0;
        vm.percentExpired = 0;
        vm.percentExpiring = 0;
        vm.facility = CoreService.getCurrentFacility();

        countWithoutConcurrent();
        countExpiredConcurrent();
        countExpiringConcurrent();

        function countWithoutConcurrent () {
            DashboardService.countWithoutConcurrentReview({id:vm.facility.id}, function(data) {
                if (data.value) {
                    vm.countWithout = data.value;
                    total();
                }
            });
        }

        function countExpiredConcurrent () {
            DashboardService.countExpiredConcurrentReview({id:vm.facility.id}, function(data) {
                if (data.value) {
                    vm.countExpired = data.value;
                    total();
                }
            });
        }

        function countExpiringConcurrent () {
            DashboardService.countExpiringConcurrentReview({id:vm.facility.id}, function(data) {
                if (data.value) {
                    vm.countExpiring = data.value;
                    total();
                }
            });
        }

        function total () {
            vm.total = parseInt(vm.countWithout) + parseInt(vm.countExpired) + parseInt(vm.countExpiring);
            vm.percentWithout = (parseInt(vm.countWithout) * 100 / parseInt(vm.total));
            vm.percentWithout= vm.percentWithout.toFixed(2);
            vm.percentExpired = parseInt(vm.countExpired) * 100 / parseInt(vm.total);
            vm.percentExpired = vm.percentExpired.toFixed(2);
            vm.percentExpiring = parseInt(vm.countExpiring) * 100 / parseInt(vm.total);
            vm.percentExpiring = vm.percentExpiring.toFixed(2);
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartReviewBoxController', ChartReviewBoxController);

    ChartReviewBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult', 'DashboardService', 'CoreService'];

    function ChartReviewBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult, DashboardService, CoreService) {
        var vm = this;
        vm.total = 0;
        vm.countDiagnosis = 0;
        vm.percentDiagnosis = 0;
        vm.countInsurance = 0;
        vm.percentInsurance = 0;
        vm.countCareTeam = 0;
        vm.percentCareTeam = 0;
        vm.facility = CoreService.getCurrentFacility();

        countDiagnosis();
        countInsurance();
        countCareTeam();

        function countDiagnosis () {
            DashboardService.countWithoutDiagnosis({id:vm.facility.id}, function(data) {
                if (data.value) {
                    vm.countDiagnosis = data.value;
                    total();
                }
            });
        }

        function countInsurance () {
            DashboardService.countWithoutInsurance({id:vm.facility.id}, function(data) {
                if (data.value) {
                    vm.countInsurance = data.value;
                    total();
                }
            });
        }

        function countCareTeam () {
            DashboardService.countWithoutCareTeam({id:vm.facility.id}, function(data) {
                if (data.value) {
                    vm.countCareTeam = data.value;
                    total();
                }
            });
        }

        function total () {
            vm.total = parseInt(vm.countDiagnosis) + parseInt(vm.countInsurance) + parseInt(vm.countCareTeam);
            vm.percentDiagnosis = (parseInt(vm.countDiagnosis) * 100 / parseInt(vm.total));
            vm.percentDiagnosis= vm.percentDiagnosis.toFixed(2);
            vm.percentInsurance = parseInt(vm.countInsurance) * 100 / parseInt(vm.total);
            vm.percentInsurance = vm.percentInsurance.toFixed(2);
            vm.percentCareTeam = parseInt(vm.countCareTeam) * 100 / parseInt(vm.total);
            vm.percentCareTeam = vm.percentCareTeam.toFixed(2);
        }

    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CaseLoadBoxController', CaseLoadBoxController);

    CaseLoadBoxController.$inject = ['facility', '$scope', '$state', 'CoreService', 'Chart'];

    function CaseLoadBoxController(facility, $scope, $state, CoreService, Chart) {
        var vm = this;

        vm.countCaseLoad = null;
        vm.count = 0;

        vm.openCharts = openCharts;
        loadData();

        function loadData() {
            vm.countCaseLoad = Chart.countCaseLoad({id: CoreService.getCurrentFacility().id}, function (result) {
                _.forEach(result, function (el) {
                    vm.count += el.count;
                });
            });
        }
        function openCharts(employee){
            $state.go('charts-caseload', {employee: employee.id});
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/23/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BedBoxController', BedBoxController);

    BedBoxController.$inject = ['$scope', '$state', 'Bed', 'CoreService', '$uibModal'];

    function BedBoxController($scope, $state, Bed, CoreService, $uibModal) {
        var vm = this;

        vm.beds = null;
        vm.count = 0;

        vm.assignBed = assignBed;
        loadData();

        function loadData() {
            vm.beds = Bed.findAllEmptyAndActive({id: CoreService.getCurrentFacility().id}, function (result) {
                vm.count = result.length;
            });
        }

        function assignBed(id) {
            $uibModal.open({
                templateUrl: 'app/entities/bed/bed-sheet/bed-sheet-assign.html',
                controller: 'BedSheetAssignDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'xl',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    bed: ['Bed', function (Bed) {
                        return Bed.get({id: id}).$promise;
                    }]
                }
            }).result.then(function () {
                loadData()
            }, function () {
                loadData()
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AbnormalResultsTopBoxController', AbnormalResultsTopBoxController);

    AbnormalResultsTopBoxController.$inject = ['facility', '$scope', '$state', '$q', 'DTColumnBuilder', 'PatientResult'];

    function AbnormalResultsTopBoxController(facility, $scope, $state, $q, DTColumnBuilder, PatientResult) {
        var vm = this;
        vm.abnormal = 0;

        vm.abnormal = PatientResult.countAbnormal({id: facility.id});
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('dashboard', {
                parent: 'app',
                url: '/dashboard',
                ncyBreadcrumb: {
                    label: 'Dashboard',
                    parent: 'app'
                },
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/dashboard2/dashboard.html',
                        controller: 'Dashboard2Controller',
                        controllerAs: 'vm'
                    },
                    'pending-by-staff@dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-by-staff/pending-by-staff-box.html',
                        controller: 'PendingByStaffBoxController',
                        controllerAs: 'vm'
                    },
                    'concurrent-reviews@dashboard': {
                        templateUrl: 'app/dashboard2/layout/concurrent-reviews/concurrent-reviews-box.html',
                        controller: 'ConcurrentReviewsBoxController',
                        controllerAs: 'vm'
                    },
                    'pending-by-staff-review@dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-by-staff-review/pending-by-staff-review-box.html',
                        controller: 'PendingByStaffReviewBoxController',
                        controllerAs: 'vm'
                    },
                    'unassigned-results@dashboard': {
                        templateUrl: 'app/dashboard2/layout/unassigned-results/unassigned-results-top-box.html',
                        controller: 'UnassignedResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'partial-result@dashboard': {
                        templateUrl: 'app/dashboard2/layout/partial-results/partial-results-top-box.html',
                        controller: 'PartialResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'abnormal-result@dashboard': {
                        templateUrl: 'app/dashboard2/layout/abnormal-result/abnormal-results-top-box.html',
                        controller: 'AbnormalResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'pending-requisition@dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-requisition/pending-requisition-top-box.html',
                        controller: 'PendingRequisitionsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'critical-results@dashboard': {
                        templateUrl: 'app/dashboard2/layout/critical-results/box/critical-results-top-box.html',
                        controller: 'CriticalResultsTopBoxController',
                        controllerAs: 'vm'
                    },
                    'late-care-delivery@dashboard': {
                        templateUrl: 'app/dashboard2/layout/late-care-delivery/late-care-delivery-box.html',
                        controller: 'LateCareDeliveryBoxController',
                        controllerAs: 'vm'
                    },
                    'stay@dashboard': {
                        templateUrl: 'app/dashboard2/layout/stay/stay-box.html',
                        controller: 'StayBoxController',
                        controllerAs: 'vm'
                    },
                    'pending-by-patients@dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-by-patient/pending-by-patient-box.html',
                        controller: 'PendingByPatientBoxController',
                        controllerAs: 'vm'
                    },
                    'empty-care-delivery-patient@dashboard': {
                        templateUrl: 'app/dashboard2/layout/empty-care-delivery/empty-care-delivery-box.html',
                        controller: 'EmptyCareDeliveryBoxController',
                        controllerAs: 'vm'
                    },
                    'physician-review@dashboard': {
                        templateUrl: 'app/dashboard2/layout/physician-review/physician-review-box.html',
                        controller: 'PhysicianReviewBoxController',
                        controllerAs: 'vm'
                    },
                    'chart-review@dashboard': {
                        templateUrl: 'app/dashboard2/layout/chart-review/chart-review-box.html',
                        controller: 'ChartReviewBoxController',
                        controllerAs: 'vm'
                    },
                    'payer-mix@dashboard': {
                        templateUrl: 'app/dashboard2/layout/payer-mix/payer-mix-box.html',
                        controller: 'PayerMixBoxController',
                        controllerAs: 'vm'
                    },
                    'discharge-type@dashboard': {
                        templateUrl: 'app/dashboard2/layout/discharge-type/discharge-type-box.html',
                        controller: 'DischargeTypeBoxController',
                        controllerAs: 'vm'
                    },
                    'incident-report@dashboard': {
                        templateUrl: 'app/dashboard2/layout/incident-report/incident-report-box.html',
                        controller: 'IncidentReportBoxController',
                        controllerAs: 'vm'
                    },
                    'level-care@dashboard': {
                        templateUrl: 'app/dashboard2/layout/level-care/level-care-box.html',
                        controller: 'LevelCareBoxController',
                        controllerAs: 'vm'
                    },
                    'marketers@dashboard': {
                        templateUrl: 'app/dashboard2/layout/marketers/marketers-box.html',
                        controller: 'MarketersBoxController',
                        controllerAs: 'vm'
                    },
                    'referral-source@dashboard': {
                        templateUrl: 'app/dashboard2/layout/referral-source/referral-source-box.html',
                        controller: 'ReferralSourceBoxController',
                        controllerAs: 'vm'
                    },
                    'case-load@dashboard': {
                        templateUrl: 'app/dashboard2/layout/case-load/case-load-box.html',
                        controller: 'CaseLoadBoxController',
                        controllerAs: 'vm'
                    },
                    'beds@dashboard': {
                        templateUrl: 'app/dashboard2/layout/bed/bed-box.html',
                        controller: 'BedBoxController',
                        controllerAs: 'vm'
                    },
                    'incoming-patients@dashboard': {
                        templateUrl: 'app/dashboard2/layout/incoming-patients/incoming-patients-box.html',
                        controller: 'IncomingPatientsBoxController',
                        controllerAs: 'vm'
                    },
                    'discharging-patients@dashboard': {
                        templateUrl: 'app/dashboard2/layout/discharging-patients/discharging-patinets-box.html',
                        controller: 'DischargingPatientsBoxController',
                        controllerAs: 'vm'
                    },
                    // 'mars-mors@dashboard': {
                    //     templateUrl: 'app/dashboard2/layout/mars-mors-box.html',
                    //     controller: 'MarsMorsBoxController',
                    //     controllerAs: 'vm'
                    // },
                    'print-requisition@dashboard': {
                        templateUrl: 'app/dashboard2/layout/print-requisition/print-requisition-box.html',
                        controller: 'PrintRequisitionBoxController',
                        controllerAs: 'vm'
                    }
                },
                onEnter: ['Auth', 'ACTIONS', 'access', '$state', function (Auth, ACTIONS, access, $state) {
                    if (!Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_DASHBOARD, access)) {
                        $state.go("dashboard-empty");
                    }
                }],
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_DASHBOARD];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    openModalCritical: ['CoreService', function (CoreService) {
                        return CoreService.getStorage('openModalCritical');
                    }],
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id,
                            date: null,
                            itemStatus: null,
                            firstName: null,
                            lastName: null,
                            dob: null,
                            barcode: null,
                            laboratory: null,
                            start: null,
                            end: null
                        };
                    }]
                }
            })
            .state('bht-dashboard', {
                parent: 'app',
                url: '/bht-dashboard',
                ncyBreadcrumb: {
                    label: 'Dashboard',
                    parent: 'app'
                },
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/dashboard2/bht/bht-dashboard.html',
                        controller: 'BHTDashboardController',
                        controllerAs: 'vm'
                    },
                    'pending-by-staff@bht-dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-by-staff/pending-by-staff-box.html',
                        controller: 'PendingByStaffBoxController',
                        controllerAs: 'vm'
                    },
                    'pending-by-staff-review@bht-dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-by-staff-review/pending-by-staff-review-box.html',
                        controller: 'PendingByStaffReviewBoxController',
                        controllerAs: 'vm'
                    },
                    'pending-by-patients@bht-dashboard': {
                        templateUrl: 'app/dashboard2/layout/pending-by-patient/pending-by-patient-box.html',
                        controller: 'PendingByPatientBoxController',
                        controllerAs: 'vm'
                    },
                    'empty-care-delivery-patient@bht-dashboard': {
                        templateUrl: 'app/dashboard2/layout/empty-care-delivery/empty-care-delivery-box.html',
                        controller: 'EmptyCareDeliveryBoxController',
                        controllerAs: 'vm'
                    },
                    'print-requisition@bht-dashboard': {
                        templateUrl: 'app/dashboard2/layout/print-requisition/print-requisition-box.html',
                        controller: 'PrintRequisitionBoxController',
                        controllerAs: 'vm'
                    }
                },
                onEnter: ['Auth', 'ACTIONS', 'access', '$state', function (Auth, ACTIONS, access, $state) {
                    if (!Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_DASHBOARD, access)) {
                        $state.go("dashboard-empty");
                    }
                }],
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_DASHBOARD];
                        return Auth.loadActionsAccess(actions).$promise;
                    }],
                    facility: ['CoreService', function (CoreService) {
                        return CoreService.getCurrentFacility();
                    }],
                    openModalCritical: ['CoreService', function (CoreService) {
                        return CoreService.getStorage('openModalCritical');
                    }],
                    filter: ['CoreService', function (CoreService) {
                        return {
                            facilityId: CoreService.getCurrentFacility().id,
                            date: null,
                            itemStatus: null,
                            firstName: null,
                            lastName: null,
                            dob: null,
                            barcode: null,
                            laboratory: null,
                            start: null,
                            end: null
                        };
                    }]
                }
            })
            .state('dashboard-empty', {
                parent: 'app',
                url: '/dashboard-empty',
                ncyBreadcrumb: {
                    label: 'Dashboard',
                    parent: 'app'
                },
                data: {
                    authorities: [ROLES.ROLE_USER]
                },
                views: {
                    'content@': {
                        templateUrl: 'app/dashboard2/empty/dashboard-empty.html',
                        controller: function () {

                        },
                        controllerAs: 'vm'
                    },
                },
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('Dashboard2Controller', DashboardController);

    DashboardController.$inject = ['CoreService', '$state'];

    function DashboardController(CoreService, $state) {
        var vm = this;

        if (CoreService.getCurrentFacility() == null) {
            $state.go('home');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('BHTDashboardController', BHTDashboardController);

    BHTDashboardController.$inject = ['CoreService', '$state'];

    function BHTDashboardController(CoreService, $state) {
        var vm = this;

        if (CoreService.getCurrentFacility() == null) {
            $state.go('home');
        }
    }
})();

(function () {
    'use strict';
    angular.module('app.validation.rule', ['validation'])
        .config(['$validationProvider',
            function ($validationProvider) {
                //Set validation html error
                $validationProvider.setErrorHTML(function (msg) {
                    //console.log(msg)
                    return "<p class=\"pull-left has-error\">" + msg + "</p>";
                });
                $validationProvider.showSuccessMessage = false;

                // Setup `ip` validation
                var expression = {
                    ip: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                };

                var validMsg = {
                    ip: {
                        error: 'This isn\'t ip address',
                        success: 'It\'s ip'
                    }
                };

                $validationProvider.setExpression(expression) // set expression
                    .setDefaultMsg(validMsg); // set valid message

                // Setup `regexp` validation
                $validationProvider
                    .setExpression({
                        regexp: function (value, scope, element, attrs) {
                            if (scope.hasOwnProperty('validatorIf') && !scope.validatorIf) {
                                return true;
                            }
                            //console.log(attrs)
                            if (!attrs.regexp) {
                                return true;
                            }
                            var regExp = new RegExp(attrs.regexp, "m");
                            return (element.val()) ? regExp.test(element.val()) : true;
                        }
                    })
                    .setDefaultMsg({
                        regexp: {
                            error: 'This should be a valid expression'
                        }
                    });

                // Setup `dateGTN` validation (Date Greater Than Now)
                $validationProvider
                    .setExpression({
                        dateGTN: function (value, scope, element, attrs) {
                            if (scope.hasOwnProperty('validatorIf') && !scope.validatorIf) {
                                return true;
                            }
                            var validatorFormat = (attrs.validatorFormat) ? attrs.validatorFormat : 'MM/DD/YYYY';
                            var dateMoment = moment(value, validatorFormat);
                            return (dateMoment.isValid() && dateMoment.isAfter(moment()));
                        }
                    })
                    .setDefaultMsg({
                        dateGTN: {
                            error: 'The date should be a valid date after now'
                        }
                    });

                // Setup `requiredIf` validation
                $validationProvider
                    .setExpression({
                        requiredIf: function (value, scope, element, attrs) {
                            if (!scope.validatorIf) {
                                return true;
                            }
                            return !!value;
                        }
                    })
                    .setDefaultMsg({
                        requiredIf: {
                            error: 'This field is required.'
                        }
                    });


                // Setup `requiredSignature` validation
                $validationProvider
                    .setExpression({
                        requiredSignature: function (value, scope, element, attrs) {
                            return !!value;
                        }
                    })
                    .setDefaultMsg({
                        requiredSignature: {
                            error: 'The signature is required.'
                        }
                    });
            }
        ]);

}).call(this);

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('scroll', function () {
            return {
                link: function(scope, element, attrs) {
                    element.bind('scroll', function() {
                        //do something here
                    })
                }
            }
        })
})();

(function(){
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ModalUtils', ModalUtils);

    ModalUtils.$inject = ['$filter'];

    function ModalUtils($filter) {

        var service = {
            getDefaultFormOptions: getDefaultFormOptions
        };

        return service;

        function getDefaultFormOptions(template, controller, entity) {
            return {
                templateUrl: template,
                controller: controller,
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: entity
                }
            }
        }

    }

})();

'use strict';

angular.module('bluebookApp')

/**
 * @ngdoc directive
 * @name loadMask
 * @author Alien Fernandez Fuentes <alien@kruger.com.ec>
 * @version 1.0.0
 *
 * @description Directive load mask application
 *
 */
    .directive('loadMask', loadMaskDirective)

    /**
     * @ngdoc provider
     * @name loadMask
     * @author Alien Fernandez Fuentes <alien@kruger.com.ec>
     * @version 1.0.0
     *
     * @description Provider load mask application
     *
     */
    .provider('loadMask', LoadMaskProvider);

/**
 * Load mask directive
 * @returns {{restrict: string, replace: boolean, template: string, link: Function}}
 */
function loadMaskDirective() {
    return {
        restrict: 'E',
        replace: true,
        template: '<div data-role="loadMask" class="load-mask">' +
        '<div class="load-mask-panel col-xs-12"><div class="loading-wrapper"><p class="loading-center">' +
        '       <i class="fa fa-spinner fa-pulse"></i> <span data-role="message"></span></p>' +
        '   </div>' +
        '</div></div>',
        link: function ($scope, element, $attrs, ngModel) {
            var elRender = ($attrs.el) ? $attrs.el : 'body';
            var message = ($attrs.message) ? $attrs.message : 'Espere por favor...';
            if ($attrs.id) {
                element.find('div[data-role="loadMask"]').attr('id', $attrs.id);
            }
            element.find('span[data-role="message"]').html(message);
            element.prependTo(elRender);
        }
    };
}

/**
 * Load mask provider
 * @constructor
 */
function LoadMaskProvider() {

    var defaultAppendEl = "body";
    var allExecPromises = null;
    // visible = false;

    /**
     * Set default append element
     * @param el
     */
    this.setDefaultAppendEl = function (el) {
        defaultAppendEl = el;
    };

    /**
     * Factory provider
     * @returns {{show: show, hide: hide, create: create}}
     */
    this.$get = ['$document', '$compile', '$rootScope', '$q', function ($document, $compile, $rootScope, $q) {
        return {
            show: show,
            hide: hide,
            create: create,
            setPromises: setPromises
        }

        /**
         * Show loading mask
         * @param selector
         */
        function show(selector) {
            // $rootScope.visibleMessages[selector] = true;
            if (angular.element(selector)) {
                angular.element(selector).show();
            }
        }

        /**
         * Hide loading mask
         * @param selector
         */
        function hide(selector) {
            // delete $rootScope.visibleMessages[selector];
            if (angular.element(selector)) {
                angular.element(selector).hide();
            }
        }

        /**
         * Create loading mask
         * @param id
         * @param message
         * @param appendEl
         * @param promises
         */
        function create(id, message, appendEl, promises) {
            appendEl = appendEl || defaultAppendEl;
            var selector = "#" + id;
            var template = angular.element('<load-mask id="' + id + '" el="' + appendEl + '" message="' + message + '" style="display: none"></load-mask>');
            var loadMaskExist = $document.find(selector);
            //Check exist mask in DOM
            if (!loadMaskExist.length) {
                $document.find(appendEl).prepend($compile(template)($rootScope));
            }
            //Check finally promise if apply and hide mask
            if (promises) {
                allExecPromises = promises;
                allPromises(allExecPromises).finally(function () {
                    hide(selector);
                });
            }
        }

        /**
         * Set promises
         * @param promises
         * @returns {*}
         */
        function setPromises(promises) {
            allExecPromises = promises;
        }

        /**
         * Check all promise is executed
         * @param promises
         * @returns {*}
         */
        function allPromises(promises) {
            if (_.isArray(promises)) {
                return $q.all(promises);
            }
            return promises;
        }
    }]
}

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('bluebookApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .filter('empty', empty);

    function empty() {
        return emptyFilter;

        function emptyFilter(value, field, mask) {
            if ( mask == undefined) {
                mask = "-";
            }

            return value ? (field == undefined ? value : value[field]) : mask;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat,
            convertDateTimeFromServerM:convertDateTimeFromServerM,
            getAge: getAge
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertDateTimeFromServerM (date){
            if (date) {

                if(date.indexOf('Z')<0){
                    date = date + 'Z';
                }
                return new Date(date);      //return moment(date + 'Z');
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }

        function getAge(dateBirth) {
            return (dateBirth) ? moment().diff(moment(dateBirth), 'years') : 0;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .value('DatePickerRangeOptions', {
            applyClass: 'btn btn-success',
            timePicker: true,
            timePickerIncrement: 30,
            locale: {
                format: "MM/dd/yyyy hh:mm a",
                separator: "  to  "
            },
            ranges: {
                'Today': [moment().startOf('day'), moment().endOf('day')],
                'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64,
            toBase64ToFileObject: toBase64ToFileObject,
            downloadFile: downloadFile
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }

        function toBase64ToFileObject(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb({
                    file: base64Data,
                    fileContentType: file.type,
                    name: file.name,
                    size: bytesToSize(file.size)
                });
            };
        }

        function downloadFile(data, headers) {
            if (data && headers) {
                var contentType = headers('Content-Type');
                var contentDisp = headers('Content-Disposition');
                if (contentDisp) {
                    var index = (contentDisp) ? contentDisp.indexOf('filename="') : -1;

                    var filename = "filename";

                    if (index != -1) {
                        var i = index + 10;
                        while (contentDisp[i] != '"') {
                            i++;
                        }

                        filename = contentDisp.substring(index + 10, i);
                    }

                    var file = new Blob([data], {type: contentType});
                    var fileURL = URL.createObjectURL(file);

                    switch (contentType) {
                        case "image/png":
                        case "image/jpeg":
                        case "application/pdf": {
                            var myWindow = $window.open(fileURL);
                            setTimeout(function () {
                                myWindow.document.title = filename;
                            }, 2000);

                            myWindow.onload = function () {
                                setTimeout(function () {
                                    $(myWindow.document).find('title').replaceWith('<title>' + filename + '</title>');
                                }, 500);
                            };

                            break;
                        }
                        case "application/csv" : {
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.download = filename;
                            fileLink.click();

                            break;
                        }
                        default: {
                            var fileLink = document.createElement('a');
                            fileLink.href = fileURL;
                            fileLink.download = filename;
                            fileLink.click();
                        }
                    }
                }
            }
        }

        function bytesToSize(bytes) {
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return 'n/a';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            if (i == 0) return bytes + ' ' + sizes[i];
            return (bytes / Math.pow(1024, i)).toFixed(3) + ' ' + sizes[i];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('bluebookApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
  angular
    .module('validation.rule', ['validation'])
    .config(['$validationProvider', function($validationProvider) {
      var expression = {
        required: function(value) {
          return !!value;
        },
        url: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
        email: /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/,
        number: /^\d+$/,
        minlength: function(value, scope, element, attrs, param) {
          return value && value.length >= param;
        },
        maxlength: function(value, scope, element, attrs, param) {
          return !value || value.length <= param;
        }
      };

      var defaultMsg = {
        required: {
          error: 'This should be Required!!',
          success: 'It\'s Required'
        },
        url: {
          error: 'This should be Url',
          success: 'It\'s Url'
        },
        email: {
          error: 'This should be Email',
          success: 'It\'s Email'
        },
        number: {
          error: 'This should be Number',
          success: 'It\'s Number'
        },
        minlength: {
          error: 'This should be longer',
          success: 'Long enough!'
        },
        maxlength: {
          error: 'This should be shorter',
          success: 'Short enough!'
        }
      };
      $validationProvider.setExpression(expression).setDefaultMsg(defaultMsg);
    }]);
}).call(this);

(function() {
    'use strict';

    angular
        .module('udt', [])
        .factory('GUIUtils', GUIUtils);

    function GUIUtils () {

        var statusTypes = ['default', 'danger', 'primary', 'success', 'info', 'warning'];

        var service = {
            getActionsTemplate: getActionsTemplate,
            getStatusTemplate: getStatusTemplate,
            expandWeekCodeString: expandWeekCodeString,
            mailto: mailto,
            objectToArray: objectToArray,
            objectToArrayByKey: objectToArrayByKey,
            objectsToArrayByKey: objectsToArrayByKey,
            getDays: getDays,
            daysToWeekCodeString: daysToWeekCodeString,
            weekCodeStringToDays: weekCodeStringToDays,
            getMonths: getMonths,
            monthsCodeStringToMonths: monthsCodeStringToMonths,
            monthsToMonthCodeString: monthsToMonthCodeString,
            icd10CodeToListNames: icd10CodeToListNames,
            getGender: getGender,
            getMaritalStatus: getMaritalStatus,
            getRace: getRace,
            getEthnicity: getEthnicity,
            resetUserPicture: resetUserPicture,
            getDefaultUserPicture: getDefaultUserPicture,
            getDefaultUserPictureContentType: getDefaultUserPictureContentType,
            colorHtmlYesNo: colorHtmlYesNo,
            colorHtmlStatus: colorHtmlStatus,
            getOnset: getOnset,
            weekStringJavaToJS: weekStringJavaToJS,
            groupSessionStatusColor: groupSessionStatusColor,
            getAvailavility: getAvailavility,
            getColorHtmlAvailability : colorHtmlAvailability,
            shiftStatus : shiftStatus,
            getDaysAsObject: getDaysAsObject,
            getOrderStatus: getOrderStatus,
            colorHtmlStatusRequisition: colorHtmlStatusRequisition,
            getItemStatus: getItemStatus,
            getEvaluationStatus: getEvaluationStatus,
            getAdmissionMedicationAction: getAdmissionMedicationAction
        };

        return service;

        /**
         * Return a Action Template for grid bootstrap based
         * @param data
         * @param entity
         * @param buttons
         * @returns {string}
         */
        function getActionsTemplate (data, entity, buttons) {
            var stButtons = '';
            for (var i = 0, len = buttons.length; i < len; i++) {
                switch(buttons[i]) {
                  case 'view': {
                      stButtons += '<a class="dt-btn primary" title="See Details" ui-sref="' + entity + '-detail({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '">' +
                          '<i class="fa fa-eye" aria-hidden="true"></i></a>';
                      break;
                  }
                    case 'update': {
                        stButtons += '<a class="dt-btn warning" title="Edit" ui-sref="' + entity + '.edit({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '/edit">' +
                            '<i class="fa fa-edit" aria-hidden="true"></i></a>';
                        break;
                    }
                    case 'delete': {
                        stButtons += '<a class="dt-btn danger" title="Delete" ui-sref="' + entity + '.delete({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/delete">' +
                            '<i class="fa fa-trash" aria-hidden="true"></i></a>';
                        break;
                    }
                    case 'download': {
                        if (data.status) {
                            stButtons += '<a class="dt-btn primary" title="Download" ui-sref="' + entity + '.download({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/download">' +
                                '<i class="fa fa-download" aria-hidden="true" style="color: green"></i></a>';
                        } else {
                            stButtons += '<a class="dt-btn primary" title="Download">' +
                                '<i class="fa fa-download" aria-hidden="true" style="opacity: 0.6; color: red"></i></a>';
                        }
                        break;
                    }
                    case 'all' : {
                        stButtons += '<a class="dt-btn primary" ui-sref="' + entity + '-detail({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '">' +
                            '<i class="fa fa-eye" aria-hidden="true"></i></a>';
                        stButtons += '<a class="dt-btn warning" ui-sref="' + entity + '.edit({id:' + data.id + '})" href="#/' + entity + '/' + data.id + '/edit">' +
                            '<i class="fa fa-edit" aria-hidden="true"></i></a>';
                        stButtons += '<a class="dt-btn danger" title="Delete" ui-sref="' + entity + '.delete({id:' + data.id + '})"  href="#/' + entity + '/' + data.id + '/delete">' +
                            '<i class="fa fa-trash" aria-hidden="true"></i></a>';
                        break;
                    }
                }
            }

            return stButtons;
        }

        /**
         * Return a Status Template for grid bootstrap based
         * @param label
         * @param type
         * @returns {string}
         */
        function getStatusTemplate(label, type) {

            var index = statusTypes.indexOf(type);
            if (index != -1) {
                return '<small class="label label-' + statusTypes[index] + '">' + label + '</small>';
            } else {
                return '<small class="label label-' + statusTypes[0] + '">' + label + '</small>';
            }
        }

        /**
         * Expand a week code String '0000000' to human days week
         * @param weekCode binary String length 7 Ex 0100101 ==> MON,THU,SAT
         * @param separator
         */
        function expandWeekCodeString(weekCode, separator) {
            var days = '';
            for (var i = 0; i < weekCode.length; i++) {
                if (weekCode[i] != '0') {
                    if ((days.length > 0) && (i > 0)) {
                        days += separator;
                    }
                    switch (i) {
                        case 0:
                            days += 'MON';
                            break;
                        case 1:
                            days += 'TUE';
                            break;
                        case 2:
                            days += 'WED';
                            break;
                        case 3:
                            days += 'THU';
                            break;
                        case 4:
                            days += 'FRI';
                            break;
                        case 5:
                            days += 'SAT';
                            break;
                        case 6:
                            days += 'SUN';
                            break;
                    }
                } else{
                    if ((i == weekCode.length -1) && days == '') {
                        days += '-';
                    }
                }
            }

            return days;
        }

        function getDays() {
            return ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
        }

        function weekCodeStringToDays(weekCode) {
            if (!weekCode) {
                weekCode = '0000000';
            }

            var days = [];
            for (var i = 0; i < weekCode.length; i++) {
                if (weekCode.charAt(i) == '1') {
                    switch (i) {
                        case 0:
                            days.push('MON');
                            break;
                        case 1:
                            days.push('TUE');
                            break;
                        case 2:
                            days.push('WED');
                            break;
                        case 3:
                            days.push('THU');
                            break;
                        case 4:
                            days.push('FRI');
                            break;
                        case 5:
                            days.push('SAT');
                            break;
                        case 6:
                            days.push('SUN');
                            break;
                    }
                }
            }

            return days;
        }

        function daysToWeekCodeString(days) {
            var code = '0000000';

            if (days) {
                code = code.split("");

                for (var i = 0; i < days.length; i++) {
                    switch (days[i]) {

                        case 'MON':
                            code[0] = '1';
                            break;
                        case 'TUE':
                            code[1] = '1';
                            break;
                        case 'WED':
                            code[2] = '1';
                            break;
                        case 'THU':
                            code[3] = '1';
                            break;
                        case 'FRI':
                            code[4] = '1';
                            break;
                        case 'SAT':
                            code[5] = '1';
                            break;
                        case 'SUN':
                            code[6] = '1';
                            break;
                    }
                }

                return code.join("");
            }

            return code;
        }

        function getMonths() {
            return ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        }

        function monthsCodeStringToMonths(monthCode) {
            var days = [];
            for (var i = 0; i < monthCode.length; i++) {
                if (monthCode.charAt(i) == '1') {
                    switch (i) {
                        case 0:
                            days.push('JAN');
                            break;
                        case 1:
                            days.push('FEB');
                            break;
                        case 2:
                            days.push('MAR');
                            break;
                        case 3:
                            days.push('APR');
                            break;
                        case 4:
                            days.push('MAY');
                            break;
                        case 5:
                            days.push('JUN');
                            break;
                        case 6:
                            days.push('JUL');
                            break;
                        case 7:
                            days.push('AUG');
                            break;
                        case 8:
                            days.push('SEP');
                            break;
                        case 9:
                            days.push('OCT');
                            break;
                        case 10:
                            days.push('NOV');
                            break;
                        case 11:
                            days.push('DEC');
                            break;
                    }
                }
            }

            return days;
        }

        function monthsToMonthCodeString(months) {
            var code = '000000000000';

            if (months) {
                code = code.split("");

                for (var i = 0; i < months.length; i++) {
                    switch (months[i]) {
                        case 'JAN':
                            code[0] = '1';
                            break;
                        case 'FEB':
                            code[1] = '1';
                            break;
                        case 'MAR':
                            code[2] = '1';
                            break;
                        case 'APR':
                            code[3] = '1';
                            break;
                        case 'MAY':
                            code[4] = '1';
                            break;
                        case 'JUN':
                            code[5] = '1';
                            break;
                        case 'JUL':
                            code[6] = '1';
                            break;
                        case 'AUG':
                            code[7] = '1';
                            break;
                        case 'SEP':
                            code[8] = '1';
                            break;
                        case 'OCT':
                            code[9] = '1';
                            break;
                        case 'NOV':
                            code[10] = '1';
                            break;
                        case 'DEC':
                            code[11] = '1';
                            break;
                    }
                }

                return code.join("");
            }

            return code;
        }

        /**
         * Returns a URL for a mailto-link
         * @param  {String} recepient    - Recepient email address
         * @param  {Object} opts         - Options to construct the URL
         * @param  {String} opts.cc      - Cc recepient email address (optional)
         * @param  {String} opts.bcc     - Bcc recepient email address (optional)
         * @param  {String} opts.subject - Email subject (optional)
         * @param  {String} opts.body    - Email body (optional). Separate lines with the newline character (\n)
         * @return {String}              - Returns the URL to put into the href-attribute of a mailto link
         */
        function mailto(recepient, opts) {
            var link = '<a href="mailto:';
            link += recepient;//window.encodeURIComponent(recepient);
            var params = [];
            angular.forEach(opts, function (value, key) {
                params.push(key.toLowerCase() + "=" + window.encodeURIComponent(value));
            });
            if (params.length > 0) {
                link += "?" + params.join("&");
            }
            link += '">' + recepient + '</a>';
            return link;
        }

        /**
         * Return object fields as array
         * @param object
         */
        function objectToArray(object) {

            var toArray = [];
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    toArray.push(object[key]);
                }
            }
            return toArray;
        }

        /**
         * Return object fields as array
         * @param object
         */
        function objectToArrayByKey(object, key) {

            var toArray = [];
            if (object.hasOwnProperty(key)) {
                toArray.push(object[key]);
            }
            return toArray;
        }

        /**
         * Return object fields as array
         * @param object
         */
        function objectsToArrayByKey(objects, key) {

            var toArray = [];
            objects.forEach(function (elem) {
                toArray.push(objectToArrayByKey(elem, key));
            });

            return toArray;
        }

        function icd10CodeToListNames(data) {
            var codes = '';
            for(var i=0; i < data.length; i++){
                if(codes.length > 0 && i > 0){
                    codes += ', ';
                }
                codes += data[i].code;
            }
            // data[i].icd10SCodes = codes;
            return codes;
        }

        function getGender() {
            return ['MALE', 'FEMALE', 'ANDROGYNE', 'ANDROGYNOUS', 'AGENDER', 'BIGENDER', 'CIS', 'CISGENDER','CIS_FEMALE',
                'CIS_MALE', 'GENDER_NEUTRAL', 'GENDERQUEER', 'FEMALE_TO_MALE', 'MALE_TO_FEMALE','NON_BINARY', 'PANGENDER',
                'POLYGENDER', 'TWO_SPIRIT', 'THIRD_GENDER', 'TRANSGENDER', 'TRANSSEXUAL', 'OTHER', 'UNKNOWN'];
        }

        function getAdmissionMedicationAction() {
            return ['CONTINUE_ON_ADMISSION', 'DESTROY', 'STORE'];
        }

        function getOnset() {
            return ['Childhood', 'Adulthood', 'Unknown'];
        }

        function getMaritalStatus() {
            return ['Single', 'Divorced', 'Married'];
        }

        function getRace() {
            return ['White', 'Black', 'Mestizo'];
        }

        function getEthnicity() {
            return ['Anglo', 'Afro-American', 'Hispanic-Latin', 'Asian']
        }

        function getAvailavility() {
            return ['OCCUPIED', 'AVAILABLE'];
        }

        function getDefaultUserPicture() {
            return "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";
        }

        function getDefaultUserPictureContentType() {
            return "image/jpeg";
        }

        function resetUserPicture(data){
            data.picture = getDefaultUserPicture();
            data.pictureContentType = getDefaultUserPictureContentType();
        }

        function colorHtmlYesNo(value){
            if (value) {
                return getStatusTemplate('Yes', 'success');
            } else {
                return getStatusTemplate('No', 'danger');
            }
        }

        function colorHtmlAvailability(value){
            if (value == 'AVAILABLE') {
                return getStatusTemplate(value, 'success');
            } else {
                return getStatusTemplate(value, 'danger');
            }
        }

        function getEvaluationStatus() {
            return ['Pending', 'InReview', 'Revoked', 'Expired', 'Late', 'Finalized', 'Amended'];
        }

        function colorHtmlStatus(value) {
            if(value){
                switch(value) {
                    case 'Pending':
                        return getStatusTemplate(value, 'danger');
                    case 'InProcess':
                        return getStatusTemplate(value, 'warning');
                    case 'PendingReview':
                        return getStatusTemplate(value, 'warning');
                    case 'Finalized':
                        return getStatusTemplate(value, 'success');
                    case 'Completed':
                        return getStatusTemplate(value, 'success');
                    case 'Revoked':
                        return getStatusTemplate(value, 'danger');
                    default :
                        return getStatusTemplate(value, 'info');
                }
            }
        }

        function weekStringJavaToJS(week) {
            var jsWeek = '';

            // jsWeek[0] = week[7];
            jsWeek += week[6];
            for (var i = 0; i < week.length - 1; i++) {
                // jsWeek[i] = week[i - 1];
                jsWeek += week[i];
            }

            return jsWeek;
        }

        function groupSessionStatusColor(status) {
            if (status) {
                switch (status) {
                    case 'PENDING':
                        return '#00c0ef';
                    case 'STARTED' :
                        return '#0073b7';
                    case 'REVIEW' :
                        return '#f39c12';
                    case 'COMPLETE':
                        return '#00a65a';
                    case 'DISABLED':
                        return '#dd4b39';
                    default:
                        return '#00c0ef'
                }
            }
        }

        function shiftStatus(value) {
            if(value){
                switch(value) {
                    case 'Pending':
                        return getStatusTemplate(value, 'danger');
                    case 'Review':
                        return getStatusTemplate(value, 'warning');
                    case 'Finalized':
                        return getStatusTemplate(value, 'success');
                    default :
                        return getStatusTemplate(value, 'info');
                }
            }
        }

        function getOrderStatus() {
            return ['CANCELED', 'FINISHED', 'SCHEDULED', 'GENERATED'];
        }

        function getDaysAsObject() {
            return [{
                id: 1,
                name: 'MON'
            }, {
                id: 2,
                name: 'TUE'
            }, {
                id: 3,
                name: 'WED'
            }, {
                id: 4,
                name: 'THU'
            }, {
                id: 5,
                name: 'FRI'
            }, {
                id: 6,
                name: 'SAT'
            }, {
                id: 7,
                name: 'SUN'
            }];
        }

        function colorHtmlStatusRequisition(value) {
            if (value.toString()) {
                switch (value) {
                    case 'PRINTED':
                        return getStatusTemplate(value, 'success');
                    case 'SCHEDULED':
                        return getStatusTemplate(value, 'warning');
                    case 'MANIFESTED':
                        return getStatusTemplate(value, 'primary');
                }
            }
        }

        function getItemStatus() {
            return ['SCHEDULED', 'PRINTED', 'MANIFESTED'];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .factory('Utils', Utils);

    function Utils() {

        var service = {
            objectToArray: objectToArray,
            arrayToString: arrayToString,
            objectRoleToArray: objectRoleToArray,
        };

        return service;

        /**
         * Return object fields as array.
         *
         * @param object
         */
        function objectToArray(object) {

            var toArray = [];
            for (var key in object) {
                if (object.hasOwnProperty(key)) {
                    toArray.push(object[key]);
                }
            }
            return toArray;
        }

        /**
         * Return a string comma separated of array elements.
         *
         * @param Array
         * @return String comma separated or empty string
         */
        function arrayToString(inArray) {

            var toString = '';
            for (var i = 0; i < inArray.length; i++) {
                if (i === 0) {
                    toString = inArray[i];
                } else {
                    toString += ',' + inArray[i];
                }
            }
            return toString;
        }

        /**
         * Return a array of Roles as simple strings.
         *
         * [{
         *      name: 'ROLE1'
         * },{
         *      name: 'ROLE2'
         * }]
         *
         * @param Array of Roles as Objects
         * @return Array of Roles as String
         *
         * ['ROLE1', 'ROLE2']
         */
        function objectRoleToArray(inArray) {

            var toArray = [];

            if (inArray) {
                for (var i = 0; i < inArray.length; i++) {
                    toArray.push(inArray[i].name);
                }
            }

            return toArray;
        }
    }
})();

(function () {
    'use strict';

    angular.module('bluebookApp')
        .directive('udtXeditable', udtXeditable);

    udtXeditable.$inject = ['$uibModal'];

    function udtXeditable($uibModal) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-xeditable/udt-xeditable.html',
            scope: {//all this scope value defined, are attr for the directive. There use are explained below
                itemList: '=',//list of items
                onSave: '&', // function to execute after of
            },
            link: linkFunc
        };

        return directive;
        function linkFunc($scope) {

            $scope.checkName = function(data, id) {
                if (id === 2 && data !== 'awesome') {
                    return "Username 2 should be `awesome`";
                }
            };
                //save item
            $scope.saveItem = function(data, id) {
                //vm.user not updated yet
                angular.extend(data, {id: id});
                $scope.itemList.find(function (element) {
                    if (element.id  == id)
                        element.name = data.name;
                })
                return $scope.itemList;
            };

            // remove item
            $scope.removeItem = function(index) {
                $scope.itemList.splice(index, 1);
            };

            // add item
            $scope.addItem = function() {
                $scope.inserted = {
                    id: $scope.itemList.length+1,
                    name: ''
                    //status: null,
                    // group: null
                };
                $scope.itemList.push($scope.inserted);
            };
        }
    }
})();


/**
 * Created by Tech Support on 12/28/2017.
 */
(function () {
    'use strict';

    var TEMPLATE = '<div class="png-time form-control" ng-click="focus()" >' +
        '<input type="text" name="hour" class="hour" maxlength="2" ng-model="hour" ng-disabled="present"/>' +
        '<span>:</span>' +
        '<input type="text" name="minute" class="minute" maxlength="2" ng-model="minute" ng-disabled="present"/>' +
        '<input type="text" name="mode" class="mode" maxlength="2" ng-model="mode" ng-show="timeMode !== 24" ng-disabled="present"/>' +
        '</div>';

    angular.module('bluebookApp')
        .directive('timeInput', TimeInputDirective);

    TimeInputDirective.$inject = [];

    function TimeInputDirective() {
        return {
            restrict: 'E',
            replace: true,
            template: TEMPLATE,
            scope: {
                model: '=',
                timeMode: '=',
                modelItem: '=',
                change: '&onChange',
                present: '='
            },
            link: timepickerLinkFn
        };

        function timepickerLinkFn(scope, element, attr) {
            var hourInput, minuteInput, modeInput,
                hourInputEl, minuteInputEl, modeInputEl,
                hourInputCtrl, minuteInputCtrl, modeInputCtrl,
                currentFocusEl,
                keyCount = 2;

            //default time mode to 12h
            var timeMode = scope.timeMode = scope.timeMode !== 24 ? 12 : 24;

            scope.modelItemClone = {};
            angular.copy(scope.modelItem, scope.modelItemClone);

            // scope.present = scope.model?false:true;

            function hourInputParser(value) {
                var hour = parseInt(value);

                if (isNaN(hour)) {
                    hourInputCtrl.$viewValue = '00';
                    hourInputCtrl.$render();
                    hourInput.select();
                    return hourInputCtrl.$viewValue;
                }

                // Some logic If we're in military time and the user wants to input 00
                if (timeMode === 24 && hour === 0) {
                    // Check for '10' input
                    if (parseInt(hourInputCtrl.$modelValue) === 0) {
                        hourInputCtrl.$viewValue = '00';
                        hourInputCtrl.$commitViewValue();
                        hourInputCtrl.$render();
                        minuteInput.focus();
                        minuteInput.select();
                        return hourInputCtrl.$viewValue;
                    }
                }

                //if user meant to type 10, 11 or 12 for standard or 10 - 23 for military
                var squashTime = false;
                if (timeMode === 24) {
                    if (parseInt(hourInputCtrl.$modelValue) === 2 && hour < 4) {
                        squashTime = true;
                    } else if (parseInt(hourInputCtrl.$modelValue) < 2 && hour < 10) {
                        squashTime = true;
                    }
                } else {
                    if (parseInt(hourInputCtrl.$modelValue) < 2 && hour < 3) {
                        squashTime = true;
                    }
                }
                if (squashTime) {
                    hourInputCtrl.$viewValue = parseInt(hourInputCtrl.$modelValue) + '' + hour;
                    hourInputCtrl.$commitViewValue();
                    hourInputCtrl.$render();
                    minuteInput.focus();
                    minuteInput.select();
                    return hourInputCtrl.$viewValue;
                }

                if (hour < 10 && value.length === 1) {
                    hourInputCtrl.$viewValue = '0' + value;
                    hourInputCtrl.$commitViewValue();
                    hourInputCtrl.$render();
                }

                if (hour > (timeMode === 24 ? 2 : 1)) {
                    minuteInput.focus();
                    minuteInput.select();
                } else {
                    hourInput.select();
                }

                return hourInputCtrl.$viewValue;
            }

            function minuteInputParser(value) {
                var minute = parseInt(value);

                if (isNaN(minute)) {
                    minuteInputCtrl.$viewValue = '00';
                    minuteInputCtrl.$render();
                    minuteInput.select();
                    return minuteInputCtrl.$viewValue;
                }

                if (parseInt(minuteInputCtrl.$modelValue) < 6 && minute < 10) {
                    minuteInputCtrl.$viewValue = parseInt(minuteInputCtrl.$modelValue) + '' + minute;
                    minuteInputCtrl.$commitViewValue();
                    minuteInputCtrl.$render();
                    if (timeMode === 12) {
                        modeInput.focus();
                        modeInput.select();
                    }
                    minuteInput.select();
                    return minuteInputCtrl.$viewValue;
                }

                if (minute < 10 && value.length === 1) {
                    minuteInputCtrl.$viewValue = '0' + value;
                    minuteInputCtrl.$commitViewValue();
                    minuteInputCtrl.$render();
                }

                if (parseInt(value) > 5 && timeMode === 12) {
                    modeInput.focus();
                    modeInput.select();
                } else {
                    minuteInput.focus();
                    minuteInput.select();
                }

                return minuteInputCtrl.$viewValue;
            }

            function modeInputParser(value) {
                //if user has typed 'a', or has typed 'm' with 'AM' showing
                if ((value.toLowerCase().indexOf('a') >= 0) || (value.toLowerCase() === 'm' && modeInputCtrl.$modelValue === 'AM')) {
                    modeInputCtrl.$viewValue = 'AM';
                } else {
                    modeInputCtrl.$viewValue = 'PM';
                }
                modeInputCtrl.$commitViewValue();
                modeInputCtrl.$render();

                modeInput.select();

                return modeInputCtrl.$viewValue;
            }

            function resetKeyCount() {
                keyCount = 2;
            }

            function inputBlurHandler() {
                element.removeClass('time-focus');

                if (currentFocusEl === this) {// jshint ignore:line
                    currentFocusEl = null;
                }
            }

            function inputFocusHandler() {
                element.addClass('time-focus');
                currentFocusEl = this;// jshint ignore:line
            }

            function modelWatcher(dt) {
                if (!dt) {
                    scope.hour = '--';
                    scope.minute = '--';
                    scope.mode = '--';
                    return;
                }

                if (angular.isString(dt)) {
                    dt = new Date(dt);
                }

                if (angular.isDate(dt)) {
                    var tempHour = dt.getHours();
                    scope.minute = dt.getMinutes();

                    if (timeMode === 12) {
                        if (tempHour > 11) {
                            scope.hour = tempHour === 12 ? tempHour : tempHour - 12;
                            scope.mode = 'PM';
                        } else {
                            scope.hour = tempHour === 0 ? 12 : tempHour;
                            scope.mode = 'AM';
                        }
                    } else {
                        scope.hour = tempHour === 0 ? 0 : tempHour; // Default to 00 for military time
                    }
                    if (scope.hour < 10) {
                        scope.hour = '0' + scope.hour;
                    }
                    if (scope.minute < 10) {
                        scope.minute = '0' + scope.minute;
                    }
                }
            }

            angular.forEach(element.find('input'), function (input) {
                if (input.name === 'hour') {
                    hourInput = input;
                    hourInputEl = angular.element(input);
                    hourInputCtrl = hourInputEl.controller('ngModel');
                } else if (input.name === 'minute') {
                    minuteInput = input;
                    minuteInputEl = angular.element(input);
                    minuteInputCtrl = minuteInputEl.controller('ngModel');
                } else if (input.name === 'mode') {
                    modeInput = input;
                    modeInputEl = angular.element(input);
                    modeInputCtrl = modeInputEl.controller('ngModel');
                }
            });

            scope.$watch('model', modelWatcher);

            scope.$watch('timeMode', function (value) {
                timeMode = value;
                modelWatcher(scope.model);
            });

            scope.$watch(function () {
                    var hour = parseInt(scope.hour);
                    var minute = parseInt(scope.minute);

                    if (isNaN(hour) || isNaN(minute)) {
                        return null;
                    }

                    if (timeMode === 12) {
                        if (scope.mode === 'AM') {
                            return (hour === 12 ? 0 : hour) + ':' + minute;
                        } else {
                            return (hour === 12 ? hour : hour + 12) + ':' + minute;
                        }
                    } else {
                        return hour + ':' + minute;
                    }
                },
                function inputWatcher(value) {
                    if (!value) {
                        return;
                    }

                    var dateParts = value.split(':');

                    if (!scope.model) {
                        scope.model = new Date();
                    }

                    if(scope.modelItem) {

                        scope.model.setHours(dateParts[0]);
                        scope.model.setMinutes(dateParts[1]);
                        scope.model.setSeconds(0);
                        if (scope.modelItem.start >= scope.modelItem.stop) {
                            scope.modelItem.stop.setHours(scope.modelItem.start.getHours()+1, scope.modelItem.start.getMinutes());
                        }

                        // scope.present = false;

                        if (!angular.equals(scope.modelItem, scope.modelItemClone)) {
                            scope.change();
                        }
                    }
                });

            scope.focus = function elementFocus() {
                if (document.activeElement !== minuteInput && document.activeElement !== modeInput) {
                    hourInput.focus();
                    hourInput.select();
                }
            };

            hourInputCtrl.$parsers.unshift(hourInputParser);
            minuteInputCtrl.$parsers.unshift(minuteInputParser);
            modeInputCtrl.$parsers.unshift(modeInputParser);

            hourInputEl.on('focus', resetKeyCount);
            minuteInputEl.on('focus', resetKeyCount);
            hourInputEl.on('focus', inputFocusHandler);
            minuteInputEl.on('focus', inputFocusHandler);
            modeInputEl.on('focus', inputFocusHandler);

            hourInputEl.on('blur', inputBlurHandler);
            minuteInputEl.on('blur', inputBlurHandler);
            modeInputEl.on('blur', inputBlurHandler);

            hourInputEl.on('keydown', function (evt) {
                keyCount--;

                switch (evt.keyCode) {
                    case 37: //left key
                        evt.preventDefault();
                        evt.stopPropagation();
                        break;
                    case 38://up key
                    case 40://down key
                        evt.preventDefault();
                        evt.stopPropagation();
                        break;
                    case 39: //right key
                        evt.preventDefault();
                        evt.stopPropagation();
                        minuteInput.focus();
                        minuteInput.select();
                        break;
                }
            });
            minuteInputEl.on('keydown', function (evt) {
                keyCount--;

                switch (evt.keyCode) {
                    case 37: //left key
                        evt.preventDefault();
                        evt.stopPropagation();
                        hourInput.focus();
                        hourInput.select();
                        break;
                    case 38://up key
                    case 40://down key
                        evt.preventDefault();
                        evt.stopPropagation();
                        break;
                    case 39: //right key
                        evt.preventDefault();
                        evt.stopPropagation();
                        modeInput.focus();
                        modeInput.select();
                        break;
                }
            });
            modeInputEl.on('keydown', function (evt) {
                keyCount--;

                switch (evt.keyCode) {
                    case 37: //left key
                        evt.preventDefault();
                        evt.stopPropagation();
                        minuteInput.focus();
                        minuteInput.select();
                        break;
                    case 38://up key
                    case 40://down key
                        evt.preventDefault();
                        evt.stopPropagation();
                        break;
                    case 39: //right key
                        evt.preventDefault();
                        evt.stopPropagation();
                        break;
                }
            });

            hourInputEl.on('click', function () {
                hourInput.select();
                //safari
                hourInput.setSelectionRange(0, 2)
            });
            minuteInputEl.on('click', function () {
                minuteInput.select();
                //safari
                minuteInput.setSelectionRange(0, 2)
            });
            modeInputEl.on('click', function () {
                modeInput.select();
                //safari
                modeInput.setSelectionRange(0, 2)
            });

            scope.$on('$destroy', function () {
                hourInputEl.off('click');
                hourInputEl.off('focus');
                hourInputEl.off('keydown');
                hourInputEl.off('blur');
                minuteInputEl.off('click');
                minuteInputEl.off('focus');
                minuteInputEl.off('keydown');
                minuteInputEl.off('blur');
                modeInputEl.off('blur');
                modeInputEl.off('click');
                modeInputEl.off('keydown');
                modeInputEl.off('blur');
            });
        }
    }
})();

/**
 * Created by PpTMUnited on 5/23/2017.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('udtMenuOptionsBottom', MenuOptionsBottom);

    MenuOptionsBottom.$inject = ['$rootScope', 'ACTIONS', 'CoreService'];

    function MenuOptionsBottom($rootScope, ACTIONS, CoreService) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-menu-options-bottom/udt-menu-options-bottom.html',
            scope: {
                chart: '=',
                access: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc($scope) {
            $scope.corporation = CoreService.getCorporation();
            $scope.accessCloseChart = $scope.access[ACTIONS.ACTION_PATIENT_CLOSE_CHART] ? $scope.access[ACTIONS.ACTION_PATIENT_CLOSE_CHART].roles.join() : null;
            $scope.chartStatus = $scope.chart.status;

            $scope.sendEvent = function(alert) {
                var event = 'bluebookApp:'+alert;
                $rootScope.$broadcast(event);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('loaderWidget', loaderWidget);

    loaderWidget.$inject = [];

    function loaderWidget() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-loader/loader.html'
        }
    }
})();

/**
 * Created by PpTMUnited on 2/21/2017.
 */
(function () {
    'use strict';

    angular
        .module('udt')
        .controller('ImageDialogController', ImageDialogController);

    ImageDialogController.$inject = ['$timeout', '$uibModalInstance', 'DataUtils', '$scope', 'GUIUtils', 'image', 'typeImage'];

    function ImageDialogController($timeout, $uibModalInstance, DataUtils, $scope, GUIUtils, image, typeImage) {
        var vm = this;

        vm.image = {};
        vm.image.picture = image;
        vm.image.pictureContentType = typeImage
        vm.imageTmp = {};
        angular.copy(vm.image, vm.imageTmp);
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss(null);
            angular.copy(vm.imageTmp, vm.image);
        }

        function save () {
            $uibModalInstance.dismiss(vm.image);
        }

        vm.setPicture = function ($file, image) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        image.picture = base64Data;
                        image.pictureContentType = $file.type;
                    });
                });
            }
        };

        vm.resetUserPicture = function () {
            GUIUtils.resetUserPicture(vm.image);
        };

        var _video = null,
            patData = null;

        vm.patOpts = {x: 0, y: 0, w: 25, h: 25};

        // Setup a channel to receive a video property
        // with a reference to the video element
        // See the HTML binding in main.html
        vm.channel = {};

        vm.webcamError = false;
        vm.onError = function (err) {
            $scope.$apply(
                function() {
                    $scope.webcamError = err;
                }
            );
        };

        vm.onSuccess = function () {
            // The video element contains the captured camera data
            _video = vm.channel.video;
            $scope.$apply(function() {
                vm.patOpts.w = _video.width;
                vm.patOpts.h = _video.height;
                //$scope.showDemos = true;
            });
        };

        vm.onStream = function (stream) {
            // You could do something manually with the stream.
        };

        vm.makeSnapshot = function() {
            if (_video) {
                var patCanvas = document.querySelector('#snapshot');
                if (!patCanvas) return;

                patCanvas.width = _video.width;
                patCanvas.height = _video.height;
                var ctxPat = patCanvas.getContext('2d');

                var idata = getVideoData(vm.patOpts.x, vm.patOpts.y, vm.patOpts.w, vm.patOpts.h);
                ctxPat.putImageData(idata, 0, 0);

                sendSnapshotToServer(patCanvas.toDataURL().split("base64,")[1]);

                patData = idata;
            }
        };

        /**
         * Redirect the browser to the URL given.
         * Used to download the image by passing a dataURL string
         */
        vm.downloadSnapshot = function downloadSnapshot(dataURL) {
            window.location.href = dataURL;
        };

        var getVideoData = function getVideoData(x, y, w, h) {
            var hiddenCanvas = document.createElement('canvas');
            hiddenCanvas.width = _video.width;
            hiddenCanvas.height = _video.height;
            var ctx = hiddenCanvas.getContext('2d');
            ctx.drawImage(_video, 0, 0, _video.width, _video.height);
            return ctx.getImageData(x, y, w, h);
        };

        /**
         * This function could be used to send the image data
         * to a backend server that expects base64 encoded images.
         *
         * In this example, we simply store it in the scope for display.
         */
        var sendSnapshotToServer = function sendSnapshotToServer(imgBase64) {
            vm.image.picture = imgBase64;
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('udtImage', Image);

    Image.$inject = ['$uibModal', '$state', 'Chart'];

    function Image($uibModal, $state, Chart) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-image/udt-img.html',
            scope: { //all this scope value defined, are attr for the directive. Can be used like is explained below
                image: '=', //modal field for the image value
                typeImage: '=', //modal field form the image type
                size: '@', //size for the modal, can be: sm or lg[e.g: modalSize="sm"]. This attr modified the size of the modal
                class: '@', //form for the image component. Can be square or circle[e.g: class="img-circle/img-square"]
                service: '=',
                ngModel: '=' //modal object(entity) to resolve
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc($scope, element) {
            $scope.openModal = function (element) {
                $uibModal.open({
                    templateUrl: 'app/components/udt/udt-image/udt-img-dialog.html',
                    controller: 'ImageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: $scope.size,
                    resolve: {
                        image: function () {
                            return $scope.image;
                        },
                        typeImage: function () {
                            return $scope.typeImage;
                        }
                    }
                }).result.then(function (result) {}, function (result) {
                    if(result){
                        $scope.ngModel.picture = value.picture;
                        $scope.ngModel.pictureContentType = value.pictureContentType;
                        $scope.image = result.picture;
                        $scope.typeImage = result.pictureContentType;
                    }
                });
            };

            function updateValue(value) {

                // switch ($scope.service) {
                //     case 'Chart': {
                //         $scope.ngModel.picture = value.picture;
                //         $scope.ngModel.pictureContentType = value.pictureContentType;
                //
                //
                //         var picture = $scope.ngModel.pictureRef ? $scope.ngModel.pictureRef: {};
                //         picture.picture = value.picture;
                //         picture.pictureContentType = value.pictureContentType;
                //         picture.ownerId = $scope.ngModel.id;
                //
                //         $scope.ngModel.pictureRef = picture;
                //
                //         Chart.updatePictureVO(picture, onSaveSuccess, onSaveError);
                //         break;
                //     }
                //     case 'Patient': {
                //         return Patient;
                //         break;
                //     }
                // }
            }

            var onSaveSuccess = function (result) {
                console.log(result);
            };

            var onSaveError = function (error) {
                console.log("Error:" + error);
            };
        }
    }
})();

/**
 * Created by PpTMUnited on 5/23/2017.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('udtGroupSessionDetail', UdtGroupSessionDetail);

    UdtGroupSessionDetail.$inject = ['GroupSessionDetails', 'toastr', '$interval', 'CoreService', 'TypeLevelCare'];

    function UdtGroupSessionDetail(GroupSessionDetails, toastr, $interval, CoreService, TypeLevelCare) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-group-session-detail/udt-group-session-detail.html',
            scope: {
                groupSessionDetails: '=',
                groupSession: '=',
            },
            link: linkFunc
        };

        return directive;

        function linkFunc($scope) {
            $scope.typeLevelCare = TypeLevelCare.findAllByFacility(CoreService.getFilterByFacility(CoreService.getCurrentFacility()));

            GroupSessionDetails.getJsonTemplate({id: $scope.groupSessionDetails.id}, function (jsonTemplate) {
                $scope.json = jsonTemplate;

                $scope.watcherJson =
                    $scope.$watch('json', function (newValue, oldValue, scope) {
                        if (oldValue !== newValue) {
                            if (!$scope.autoSaveJsonId) {
                                $scope.intervalJson = $interval($scope.autoSaveJson, 1500);
                            }

                            $scope.lastUpdateJson = new Date();
                            $scope.autoSaveJsonId = Math.random();
                        }
                    }, true);
            });

            $scope.watcher =
                $scope.$watch('groupSessionDetails', function (newValue, oldValue, scope) {
                    if (oldValue !== newValue) {
                        if (!$scope.autoSaveId) {
                            $scope.interval = $interval($scope.autoSave, 1500);
                        }

                        $scope.lastUpdate = new Date();
                        $scope.autoSaveId = Math.random();
                    }
                }, true);

            $scope.groupSessionDetails = $scope.groupSessionDetails ? $scope.groupSessionDetails : null;
            $scope.update = null;
            $scope.json = null;
            $scope.isSaving = false;
            $scope.isSavingJson = false;
            $scope.autoSaveId = null;
            $scope.autoSaveJsonId = null;
            $scope.savedId = null;
            $scope.savedJsonId = null;
            $scope.interval = null;
            $scope.intervalJson = null;

            $scope.changePresentStatus = function () {
                $scope.groupSessionDetails.present = !$scope.groupSessionDetails.present;
            }

            $scope.autoSaveJson = function () {
                if ($scope.isSavingJson || !$scope.autoSaveJsonId) {

                    return;
                }

                if ($scope.savedJsonId === $scope.autoSaveJsonId) {
                    $scope.autoSaveJsonId = null;
                    $scope.savedJsonId = null;

                    $interval.cancel($scope.intervalJson);

                    return;
                }

                var now = new Date();

                if (((now.getTime() - $scope.lastUpdateJson.getTime()) / 1000) < 1.5) {

                    return;
                }

                $scope.isSavingJson = true;
                $scope.savedJsonId = angular.copy($scope.autoSaveJsonId);

                var groupSessionDetails = angular.copy($scope.groupSessionDetails);
                var json = $scope.json

                GroupSessionDetails.autoSave({
                    groupSessionDetails: groupSessionDetails,
                    jsonTemplate: json
                }, function (data) {
                    $scope.isSavingJson = false;

                    toastr.success("Saved " + $scope.groupSession.title + ' - ' +
                        $scope.groupSessionDetails.chart.firstName + ' ' +
                        $scope.groupSessionDetails.chart.lastName + ' ' + $scope.groupSessionDetails.chart.mrNo);
                }, function () {
                    $scope.isSavingJson = false;

                    toastr.error("Error saving " + $scope.groupSession.title + ' - ' +
                        $scope.groupSessionDetails.chart.firstName + ' ' +
                        $scope.groupSessionDetails.chart.lastName + ' ' + $scope.groupSessionDetails.chart.mrNo);
                });
            }

            $scope.autoSave = function () {
                if ($scope.isSaving || !$scope.autoSaveId) {

                    return;
                }

                if ($scope.savedId === $scope.autoSaveId) {
                    $scope.autoSaveId = null;
                    $scope.savedId = null;

                    $interval.cancel($scope.interval);

                    return;
                }

                var now = new Date();

                if (((now.getTime() - $scope.lastUpdate.getTime()) / 1000) < 1.5) {

                    return;
                }

                $scope.isSaving = true;
                $scope.savedId = angular.copy($scope.autoSaveId);

                var groupSessionDetails = angular.copy($scope.groupSessionDetails);

                GroupSessionDetails.update(groupSessionDetails, function (data) {
                    $scope.isSaving = false;

                    toastr.success("Saved " + $scope.groupSession.title + ' - ' +
                        $scope.groupSessionDetails.chart.firstName + ' ' +
                        $scope.groupSessionDetails.chart.lastName + ' ' + $scope.groupSessionDetails.chart.mrNo);
                }, function () {
                    $scope.isSaving = false;

                    toastr.error("Error saving " + $scope.groupSession.title + ' - ' +
                        $scope.groupSessionDetails.chart.firstName + ' ' +
                        $scope.groupSessionDetails.chart.lastName + ' ' + $scope.groupSessionDetails.chart.mrNo);
                });
            }

            $scope.$on('$destroy', function () {
                if ($scope.watcher) {
                    $scope.watcher();
                }

                if ($scope.watcherJson) {
                    $scope.watcherJson();
                }
            });
        }
    }
})();

/**
 * Created by PpTMUnited on 2/21/2017.
 */
(function () {
    'use strict';

    angular
        .module('udt')
        .controller('UdtCropImageDialogController', UdtCropImageDialogController);

    UdtCropImageDialogController.$inject = ['$scope', '$uibModalInstance', 'CoreService', 'image', 'defaultImage', 'cropType'];

    function UdtCropImageDialogController($scope, $uibModalInstance, CoreService, image, defaultImage, cropType) {

        var vm = this;

        vm.croppedImage = "";
        vm.image = image.image;
        vm.defaultImage = defaultImage ? defaultImage.picture : null;
        vm.cropType = cropType ? cropType : null;

        vm.save = save;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss(null);
        }

        function save() {
            var result = {
                cropped: vm.croppedImage,
                image: vm.image
            };

            $uibModalInstance.dismiss(result);
        }
    }
})();


(function () {
    'use strict';

    angular.module('bluebookApp')
        .directive('udtCropImage', udtCropImage);

    udtCropImage.$inject = ['CoreService'];

    function udtCropImage(CoreService) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-crop-image/udt-crop-image.html',
            scope: {//all this scope value defined, are attr for the directive. There use are explained below
                areaType: '@',//form for the image component. Can be square or circle
                resultImageSize: '@', //size of the crop image
                image: '=',//modal field for the original image
                croppedImage: '=', //cropped image
                defaultImage: '@'//avatar
            },
            link: linkFunc
        };
        return directive;

        function linkFunc($scope, element) {
            $scope.resultImageSize = $scope.resultImageSize ? Number($scope.resultImageSize) : 300;
            $scope.areaType = $scope.areaType ? $scope.areaType : 'square';
            $scope.defaultImageModel = $scope.defaultImage ? $scope.defaultImage : CoreService.patientPictureDefault().picture;
            $scope.image =  $scope.image ?  $scope.image : null;

            $scope.handleFileSelect = function (evt, file) {
                $scope.file = file;
                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.image = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            };
        }
    }
})();


/**
 * Created by Mwong on 08/21/2019.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('udtChartHeader', ChartHeader);

    ChartHeader.$inject = ['Allergies'];

    function ChartHeader(Allergies) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-chart-header/udt-chart-header.html',
            scope: {
                chart: '=',
                sidebarLayout: '=?',
                showAllergies: '=?',
                other: '='
            },
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, element) {
            $scope.allergies = [];
            $scope.allergiesStr = "";
            $scope.fullName = $scope.chart.fullName ? $scope.chart.fullName :
                $scope.chart.lastName + ', ' + $scope.chart.firstName + ' ' + ($scope.chart.middleName ? $scope.chart.middleName : '');

            $scope.showAllergies = angular.isDefined($scope.showAllergies) ? $scope.showAllergies : false;
            if ($scope.showAllergies) {
                Allergies.findAllByChartAndStatus({id: $scope.chart.id, status: true}, function (allergies) {
                    if (allergies.length > 0) {
                        $scope.allergiesStr =
                            _.join(
                                _.map(allergies, function (allergy) {
                                    return allergy.name ? allergy.name : allergy.rcopiaAllergyGroup.name;
                                }), ', ');
                    }
                });
            }
        }
    }
})();

/**
 * Created by PpTMUnited on 5/23/2017.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('udtAttachEvaluationFile', Attach);

    Attach.$inject = ['$state', '$sessionStorage', 'CoreService', 'toastr', 'DataUtils',
        'EvaluationFile'];

    function Attach($state, $sessionStorage, CoreService, toastr, DataUtils,
                    EvaluationFile) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/udt-attach-evaluation-file/udt-attach-evaluation-file.html',
            scope: {
                evaluationId: '@',
            },
            link: linkFunc
        };

        return directive;

        function linkFunc($scope) {
            $scope.employeeId = CoreService.getCurrentEmployee().id;
            $scope.showMessageConfirmDelete = false;

            getFiles();

            function getFiles() {
                EvaluationFile.findAllByEvaluation({id: $scope.evaluationId},
                    function (result) {
                        $scope.files = result;
                    });
            }

            $scope.attachFile = function (files) {
                var attachFiles = [];
                var bigFiles = _.remove(files, function (item) {

                    return parseInt(item.size) > 16000000;
                });
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    DataUtils.toBase64ToFileObject(file, function (result) {
                        result.ownerId = parseInt($scope.evaluationId);
                        attachFiles.push(result);
                        if (attachFiles.length == files.length) {
                            attach(attachFiles);
                        }
                    });
                }
                for (var i = 0; i < bigFiles.length; i++) {
                    toastr.error(bigFiles[i].name + ' file is too big. The maximum size is 16MB')
                }
            }

            function attach(result) {
                EvaluationFile.attachFiles({evaluation : {id: $scope.evaluationId}, files: result}, successResult, errorResult);
            }

            $scope.deleteFile = function (fileId) {
                EvaluationFile.delete({id: fileId},
                    function success(data) {
                        getFiles();
                        $scope.showMessageConfirmDelete = false;
                    }, function error(error) {
                        $scope.showMessageConfirmDelete = false;
                    });
            };

            $scope.getFileAttached = function (id) {
                EvaluationFile.download({id: id});
            };

            $scope.getIcon = function(type) {
                switch (type) {
                    case 'application/pdf': return 'fa-file-pdf-o';
                    case 'text/plain': return 'fa-file-text-o';
                    default: return 'fa-file-o';
                }
            };

            function successResult(result) {
                getFiles();
            }

            function errorResult(error) {
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('ssnFormat', function() {
            //this 3 capture groups: the first has 3 digits, the second has 2 digits, the third has 4 digits.
            var ssnFormat = /^(\d{3})?(\d{2})(\d{4})$/;

            return function(ssn) {
                var parsed = ssnFormat.exec(ssn);

                return (!parsed) ? ssn : ((parsed[1]) ? parsed[1] + '-' : '') + parsed[2] + '-' + parsed[3];
           }
        });
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SignaturePatientDialogController', SignaturePatientDialogController);

    SignaturePatientDialogController.$inject = ['$uibModalInstance', 'chart'];

    function SignaturePatientDialogController($uibModalInstance, chart) {

        var vm = this;

        vm.signatureOpts = getSignatureOptions();
        vm.chart = chart;
        vm.odsSignatureNameId = Math.floor((Math.random() * 100) + 1);

        vm.clear = clear;
        vm.sign = sign;

        function getSignatureOptions() {

            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function sign() {
            $uibModalInstance.close(vm.patientSignature);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SignatureDialogController', SignatureDialogController);

    SignatureDialogController.$inject = ['$uibModalInstance', 'CoreService'];

    function SignatureDialogController($uibModalInstance, CoreService) {

        var vm = this;

        vm.employeeSignature = '';
        vm.employeeSignaturePin = null;
        vm.signatureOpts = getSignatureOptions();
        vm.employee = CoreService.getCurrentEmployee();

        vm.clear = clear;
        vm.sign = sign;

        function getSignatureOptions() {

            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function sign() {
            $uibModalInstance.close({employeeSignature: vm.employeeSignature, employeeSignaturePin: vm.employeeSignaturePin});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SignatureGuarantorDialogController', SignatureGuarantorDialogController);

    SignatureGuarantorDialogController.$inject = ['$uibModalInstance', 'evaluation', 'Contacts'];

    function SignatureGuarantorDialogController($uibModalInstance, evaluation, Contacts) {
        var vm = this;

        vm.evaluation = evaluation;
        vm.guarantor = null;
        vm.signatureOpts = getSignatureOptions();
        vm.odsGuarantorSignatureNameId = Math.floor((Math.random() * 100) + 1);
        vm.guarantorSignature = "";

        vm.guarantors = Contacts.findAllGuarantors({id: vm.evaluation.chartId});

        vm.clear = clear;
        vm.sign = sign;

        function getSignatureOptions() {

            return {
                width: 620,
                height: 250,
                cssClass: 'signature-canvas',
                color: '#00008B',
                'background-color': '#fff'
            };
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function sign() {
            $uibModalInstance.close({signature: vm.guarantorSignature, guarantor: vm.guarantor});
        }
    }
})();

/**
 * Created by PpTMUnited on 2/21/2017.
 */
(function () {
    'use strict';

    angular
        .module('udt')
        .controller('SignFormController', SignFormController);

    SignFormController.$inject = [ '$uibModalInstance', 'DATA', '$scope', 'JSignature', 'ChartToForm', 'form', 'type', 'Base64', 'html', 'guarantor', '$stateParams' ];

    function SignFormController( $uibModalInstance, DATA, $scope, JSignature, ChartToForm, form, type, Base64, html, guarantor, $stateParams ) {
        var vm = this;

        //Functions
        vm.clear = clear;
        vm.save = save;


        //Variable
        vm.signForm = form;
        // vm.jsonData = JSON.parse(form.jsonData);
        vm.guarantor = guarantor;
        vm.signatories = [];


        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        loadAll();
        function loadAll() {
            if (type == 'approve') {
                if (!vm.signForm.signaturePatient && vm.signForm.patientSignatureRequired) {
                    vm.signForm.signatory = vm.signForm.signatory?vm.signForm.signatory:DATA.SIGNATORIES.PATIENT;
                    vm.signatories.push(DATA.SIGNATORIES.PATIENT);
                }
                if (!vm.signForm.signatureGuarantor && vm.signForm.guarantorSignatureRequired && vm.guarantor.id) {
                    vm.signForm.signatory = vm.signForm.signatory?vm.signForm.signatory:DATA.SIGNATORIES.GUARANTOR;
                    vm.signatories.push(DATA.SIGNATORIES.GUARANTOR);
                }

            }
            if (type == 'revoke') {
                if (!vm.signForm.revocationPatient && vm.signForm.patientSignatureRequired) {
                    vm.signForm.signatory = vm.signForm.signatory?vm.signForm.signatory:DATA.SIGNATORIES.PATIENT;
                    vm.signatories.push(DATA.SIGNATORIES.PATIENT);
                }
                if (!vm.signForm.revocationGuarantor && vm.signForm.guarantorSignatureRequired && vm.guarantor.id) {
                    vm.signForm.signatory = vm.signForm.signatory?vm.signForm.signatory:DATA.SIGNATORIES.GUARANTOR;
                    vm.signatories.push(DATA.SIGNATORIES.GUARANTOR);
                }

            }

        }

        function save() {

            if (!JSignature.getData(JSignature.exportTypes.NATIVE).length) {
                alert("Please sign and then press finish!!!");
            } else {
                var sign = JSignature.getData(JSignature.exportTypes.IMAGE_PNG_BASE64);
                var splitSign = [];
                if (type == 'approve'){
                    if(vm.signForm.signatory == DATA.SIGNATORIES.PATIENT){
                        vm.signForm.signaturePatient = {};
                        splitSign = sign.split(",", sign.length);
                        vm.signForm.signaturePatient.signature = splitSign[1];
                        vm.signForm.signaturePatient.signatureContentType = 'image/png';
                    }else{
                        vm.signForm.signatureGuarantor = {};
                        splitSign = sign.split(",", sign.length);
                        vm.signForm.signatureGuarantor.signature = splitSign[1];
                        vm.signForm.signatureGuarantor.signatureContentType = 'image/png';
                    }
                }else{
                    if (type == 'revoke') {
                        if(vm.signForm.signatory == DATA.SIGNATORIES.PATIENT){
                            vm.signForm.revocationPatient = {};
                            splitSign = sign.split(",", sign.length);
                            vm.signForm.revocationPatient.signature = splitSign[1];
                            vm.signForm.revocationPatient.signatureContentType = 'image/png';
                        }else{
                            vm.signForm.revocationGuarantor = {};
                            splitSign = sign.split(",", sign.length);
                            vm.signForm.revocationGuarantor.signature = splitSign[1];
                            vm.signForm.revocationGuarantor.signatureContentType = 'image/png';
                        }
                    }
                }
                if (!vm.signForm.htmlData)
                    vm.signForm.htmlData =  html;
                vm.signForm.chart = $stateParams.id;
                vm.signForm.guarantor = '';
                ChartToForm.saveSign(vm.signForm, onSaveSuccess, onSaveError);
            }
        }

        var onSaveSuccess = function (result) {
            $uibModalInstance.dismiss(result);
        };

        var onSaveError = function (error) {
            clear();
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('searchIcd10', searchIcd10);

    searchIcd10.$inject = ['Chart', 'Diagnoses', 'CoreService', 'FacilityIcd10'];

    function searchIcd10(Chart, Diagnoses, CoreService, FacilityIcd10) {

        return {
            restrict: 'E',
            templateUrl: 'app/components/udt/search-icd10/search-icd10.html',
            scope: {
                chart: '=',
                ngModel: '='
            },
            link: linkFunc
        };

        /* private helper methods*/

        function linkFunc($scope, element) {
            // init();

            function init() {
                $scope.ngModel = $scope.ngModel ? $scope.ngModel : [];
                $scope.activeIcd10 = [];
                $scope.facilityIcd10 = [];
                $scope.isOpen = false;
                $scope.selected = {};

                if ($scope.chart) {
                    Diagnoses.findAllActiveDiagnosesByChartId({id: $scope.chart}, function (result) {
                        _.forEach(result, function (element) {
                            var idx = _.findIndex($scope.activeIcd10, function (o) {
                                return o.id === element.icd10.id;
                            });

                            if (idx == -1) {
                                $scope.activeIcd10.push(element.icd10);
                            }
                        });
                    });
                }

                FacilityIcd10.findAllByFilter({facilityId: CoreService.getCurrentFacility().id}, function (result) {
                    _.forEach(result, function (element) {
                        var idx = _.findIndex($scope.facilityIcd10, function (o) {
                            return o.id === element.id;
                        });

                        if (idx == -1) {
                            $scope.facilityIcd10.push(element.icd10);
                        }
                    });
                });

                if ($scope.ngModel.length === 0) {
                    $scope.selected = {};
                } else {
                    $scope.selected = {};
                    _.forEach($scope.ngModel, function (element) {
                        $scope.selected[element.id] = true;
                    });
                }

                $(document).bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                        .find(event.target)
                        .length > 0;

                    if (isClickedElementChildOfPopup) {
                        return;
                    }

                    $scope.isOpen = false;
                    $scope.$apply();
                });
            }

            $scope.check = function (value, checked) {
                var idx = _.findIndex($scope.ngModel, function (o) {
                    return o.id === value.id;
                });

                if (checked && idx < 0) {
                    $scope.ngModel.push(value);
                } else if (!checked && idx >= 0) {
                    $scope.ngModel.splice(idx, 1);
                }
            };

            $scope.$watch('isOpen', function () {
                if ($scope.isOpen) {
                    init();
                }
            }, true);
        }
    }
})();

/*!
 * RM-DATEPICKER v1.0.0
 * http://rubymage.com
 *
 * Copyright 2015 Sergiu Ghenciu, RUBYMAGE
 * Released under the MIT license
 * https://github.com/RUBYMAGE/angular-datepicker/blob/master/LICENSE
 */

(function () {
    'use strict';

    var Module = angular.module('rm2Datepicker', []);

    Module.constant('rm2DatepickerConfig', {
        mondayStart: false,
        initState: "month",
        maxState: "decade",
        minState: "month",
        toggleState: true,

        decadeSize: 12,
        monthSize: 42, /* "auto" || fixed nr. (35 or 42) */

        min: null,
        max: null,
        format: "yyyy-MM-dd",
        markDates: null,
        redraw: null
    });

    Module.directive("rm2Datepicker", ['rm2DatepickerConfig', '$compile', '$filter', '$document', 'DateUtils', '$rootScope',
        function (rm2DatepickerConfig, $compile, $filter, $document, DateUtils, $rootScope) {

            var link = function (scope, element, attrs, ngModel) {
                scope.marks = [];
                var conf = angular.copy(rm2DatepickerConfig);

                if (scope.rmConfig) {
                    for (var prop in conf)
                        if (conf.hasOwnProperty(prop))
                            if (scope.rmConfig[prop] != undefined) conf[prop] = scope.rmConfig[prop];
                }
                if (conf.min) conf.min.setHours(0, 0, 0, 0);
                if (conf.max) conf.max.setHours(23, 59, 59, 999);

                var isInput = element[0].tagName.toUpperCase() == "INPUT";
                var isReached = {
                    min: false,
                    max: false
                };
                var daysInMonth = function (year, month) {
                    return new Date(year, month + 1, 0).getDate();
                };
                var adjustDate = function (date) {
                    var date = parseInt(date, 10);
                    if (!isNaN(date)) {
                        var max = daysInMonth(scope.j.getFullYear(), scope.j.getMonth());
                        if (date < 1) date = 1;
                        if (date > max) date = max;
                        scope.j.setDate(date);
                    }
                };
                var gen = {
                    decade: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = oDate.getMonth(),
                            d = oDate.getDate(),
                            max,
                            i = 0,
                            n = conf.decadeSize || 12; // count of years in decade
                        var aDecade = new Array(n);

                        Y = Math.floor(Y / n) * n; // begin year of current decade

                        for (; i < n; Y++, i++) {
                            max = daysInMonth(Y, m);
                            if (d > max) d = max;
                            aDecade[i] = new Date(Y, m, d, 3, 0, 1, 0);
                        }
                        return aDecade;
                    },
                    year: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = 0,
                            d = oDate.getDate(),
                            max;
                        var aYear = [];
                        for (; m < 12; m++) {
                            max = daysInMonth(Y, m);
                            if (d > max) d = max;
                            aYear.push(new Date(Y, m, d, 3, 0, 1, 0));
                        }
                        return aYear;
                    },
                    month: function (oDate) {
                        var Y = oDate.getFullYear(),
                            m = oDate.getMonth(),
                            startDate = new Date(Y, m, 1, 3, 0, 1, 0),
                            n;
                        var startPos = startDate.getDay() || 7;
                        if (scope.mondayStart) startPos = startPos - 1 || 7;

                        if (conf.monthSize == "auto")
                            n = ( startPos + daysInMonth(Y, m) < 35 ) ? 35 : 42;
                        else
                            n = conf.monthSize;

                        startDate.setDate(-startPos + 1);
                        return gen.dates(startDate, n);
                    },
                    dates: function (startDate, n) {
                        var aDates = new Array(n),
                            current = new Date(startDate),
                            i = 0;
                        while (i < n) {
                            aDates[i++] = new Date(current);
                            current.setDate(current.getDate() + 1);
                        }
                        return aDates;
                    }
                };
                var refresh = function (state) {
                    conf.markDates(scope.j).$promise.then(function (result) {
                        scope.marks = result;

                        state = state || scope.state;
                        scope.aDates = gen[state](scope.j);

                        if (conf.min) {
                            isReached.min = scope.aDates[0] < conf.min;
                        }
                        if (conf.max) {
                            var oDate = scope.aDates[scope.aDates.length - 1];
                            isReached.max = oDate > conf.max;
                        }
                    });

                };
                var init = function () {
                    return refresh();
                };

                //TODO: optimize this method
                var isBefore = function (oDate1, oDate2) {
                    if (scope.state == "decade")
                        return oDate1.getFullYear() < oDate2.getFullYear();

                    if (scope.state == "year") {
                        if (oDate1.getFullYear() == oDate2.getFullYear())
                            return oDate1.getMonth() < oDate2.getMonth();
                        else
                            return oDate1.getFullYear() < oDate2.getFullYear();
                    }

                    return oDate1 < oDate2;
                };
                scope.isOff = function (oDate) {
                    if (!conf.min && !conf.max)
                        return false;
                    if (conf.min && isBefore(oDate, conf.min))
                        return true;
                    if (conf.max && isBefore(conf.max, oDate))
                        return true;
                };
                scope.isActive = {
                    year: function (oDate) {
                        return oDate.getFullYear() == scope.j.getFullYear();
                    },
                    month: function (oDate) {
                        return oDate.getMonth() == scope.j.getMonth();
                    },
                    date: function (oDate) {
                        return oDate.getDate() == scope.j.getDate();
                    }
                };
                scope.isToday = function (oDate) {
                    return scope.isActive.date(oDate)
                        && scope.isActive.month(oDate)
                        && scope.isActive.year(oDate);
                };

                scope.go = function (oDate) {
                    if (scope.isOff(oDate)) return;

                    if (isInput && scope.state == conf.minState && scope.isActive.month(oDate)) {
                        scope.show = false;
                        overlay.css("display", "none");
                    }

                    var m = scope.j.getMonth();
                    var y = scope.j.getYear();

                    scope.j = new Date(oDate);
                    if (conf.toggleState) scope.toggleState(1);

                    if (m != scope.j.getMonth() && y != scope.j.getYear()) {
                        refresh();
                    }
                };
                scope.now = function () {
                    var m = scope.j.getMonth();

                    scope.j = new Date();

                    refresh();
                };
                scope.next = function (delta) {
                    delta = delta || 1;

                    if (delta > 0) {
                        if (isReached.max) return;
                    }
                    else {
                        if (isReached.min) return;
                    }

                    var Y = scope.j.getFullYear(),
                        m = scope.j.getMonth(),
                        d = scope.j.getDate();

                    switch (scope.state) {
                        case "decade":
                            delta = delta * scope.aDates.length;
                        case "year":
                            scope.j.setFullYear(Y + delta, m, 15);
                            adjustDate(d);
                            break;
                        case "month":
                            scope.j.setMonth(m + delta, 15);
                            adjustDate(d);
                            break;
                        case "week" :
                            scope.j.setDate(d + (delta * 7));
                            break;
                    }

                    refresh();
                };
                scope.prev = function (delta) {
                    return scope.next(-delta || -1);
                };
                scope.toggleState = function (direction) {
                    direction = direction || 1;

                    if (scope.state == conf.maxState && direction == -1 ||
                        scope.state == conf.minState && direction == 1) {
                        return;
                    }
                    scope.state = scope.aStates[scope.aStates.indexOf(scope.state) + direction];
                    refresh();
                };

                scope.mondayStart = conf.mondayStart;
                scope.aWeekDay = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
                if (scope.mondayStart) scope.aWeekDay.push(scope.aWeekDay.shift());

                scope.aStates = ["decade", "year", "month"];
                scope.state = conf.initState;

                //TODO: this(together with rmInclude directive below) is a quick implementation, maybe there is a better idea
                scope.activeDateTpl = {
                    decade: "{{aDates[0].getFullYear()}} - {{aDates[aDates.length-1].getFullYear()}}",
                    year: "{{j.getFullYear()}}",
                    month: "{{j | date: 'MMMM yyyy'}}",
                    week: "{{ j | date: 'd MMMM yyyy' }}"
                };

                init(); // generate initial state

                var offset = function (objElement) {
                    var x = 0, y = 0;

                    if (objElement.offsetParent) {
                        do {
                            x += objElement.offsetLeft;
                            y += objElement.offsetTop;
                        } while (objElement = objElement.offsetParent);
                    }
                    return {top: y, left: x};
                };
                var togglePicker = function (toggle) {
                    overlay.css("display", toggle ? "block" : "none");
                    scope.show = toggle;
                    scope.$apply();
                };
                var adjustPos = function (el) {
                    var scrollX = window.scrollX,
                        scrollY = window.scrollY,
                        innerWidth = window.innerWidth,
                        innerHeight = window.innerHeight;

                    if (window.innerWidth < 481)
                        return {top: scrollY, left: 0};

                    var pos = offset(el),
                        marginBottom = scrollY + innerHeight - pos.top - el.clientHeight,
                        marginRight = scrollX + innerWidth - pos.left - el.clientWidth;

                    if (marginBottom < 0) pos.top += marginBottom;
                    if (pos.top < scrollY) pos.top = scrollY;
                    if (marginRight < 0) pos.left += marginRight;
                    if (pos.left < 0) pos.left = 0;

                    return pos;
                };

                if (isInput) {
                    scope.show = false;

                    ngModel.$parsers.push(function (sDate) {
                        return new Date(sDate);
                    });
                    ngModel.$formatters.push(function (oDate) {
                        return $filter('date')(oDate, conf.format);
                    });

                    element.after($compile(TEMPLATE)(scope));

                    var calendar = element.next();
                    var overlay = angular.element('<div class="rm-overlay" style="display:none"></div>');
                    overlay.on('click', function () {
                        togglePicker(false);
                    });
                    $document.find('body').eq(0).append(overlay);

                    element.on('click', function () {

                        if (window.innerWidth < 481) element[0].blur();
                        var pos = offset(element[0]);
                        pos.top += element[0].offsetHeight + 1;

                        scope.style = {top: pos.top + "px", left: pos.left + "px"};
                        togglePicker(true);
                        pos = adjustPos(calendar[0]);
                        scope.style = {top: pos.top + "px", left: pos.left + "px"};
                        scope.$apply();
                    });

                    $document.on('keydown', function (e) {
                        if ([9, 13, 27].indexOf(e.keyCode) >= 0) togglePicker(false);
                    });
                }
                else {
                    scope.show = true;
                    element.append($compile(TEMPLATE)(scope));
                }
                ;

                scope.checkMark = function (oDate) {
                    var _mark = $.grep(scope.marks, function (mark, i) {
                        return mark.date == DateUtils.convertLocalDateToServer(oDate);
                    });

                    if (_mark == null || _mark.length == 0) {
                        return '';
                    }

                    return _mark[0].class;
                }

                $rootScope.$on(conf.redraw, function (event, result) {
                    scope.marks = conf.markDates(scope.j);

                    refresh();
                });
            };

            //TODO: template may need optimization :)
            var TEMPLATE =
                '<div class="rm-datepicker" ng-class="{mondayStart: mondayStart}" ng-show="show" ng-style="style">' +
                '<div class="nav">' +
                '<a><i class="fa fa-angle-left"></i></a>' +
                '<a class="back waves-effect" ng-click="toggleState(-1)" rm-include="activeDateTpl[state]"></a>' +
                '<a class="adjacent waves-effect" ng-click="prev()"><i class="fa fa-angle-up"></i></a>' +
                '<a class="adjacent waves-effect" ng-click="next()"><i class="fa fa-angle-down"></i></a>' +
                '<a class="today waves-effect" ng-click="now()">Today</a>' +
                '</div>' +
                '<div class="body" ng-include="\'rm-\' + state + \'.html\'"></div>' +
                '</div>' +

                '<script type="text/ng-template" id="rm-decade.html">' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="{j: isActive[\'year\'](oDate), off: isOff(oDate)}">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate | date: \'yyyy\'}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>' +

                '<script type="text/ng-template" id="rm-year.html">' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="{j: isActive[\'month\'](oDate), off: isOff(oDate)}">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate | date: \'MMM\'}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>' +

                '<script type="text/ng-template" id="rm-month.html">' +
                '<div class="day sunSat" ng-if="state == \'month\'">' +
                '<a ng-repeat="day in aWeekDay">{{day}}</a>' +
                '</div>' +
                '<div class="ng-class: state; square date">' +
                '<div ng-repeat="oDate in aDates" ng-class="[{j: isActive[\'date\'](oDate), off: isOff(oDate), out: !isActive[\'month\'](oDate)}, checkMark(oDate)]">' +
                '<a ng-click="go(oDate)" class="waves-effect"><span>{{oDate.getDate()}}</span></a>' +
                '</div>' +
                '</div>' +
                '</script>';

            return {
                require: 'ngModel',
                scope: {
                    j: '=ngModel', /* active date */
                    rmConfig: "="
                },
                link: link
            }
        }]);

    Module.directive('rmInclude', ['$compile', function ($compile) {

        var link = function (scope, element, attrs) {
            scope.$watch(
                function (scope) {
                    return scope.$eval(attrs.rmInclude);
                }
                , function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
        };

        return {
            restrict: "A",
            link: link
        };
    }]);
}());

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('propsFilter', propsFilter);

    /**
     * AngularJS default filter with the following expression:
     * "person in people | filter: {name: $select.search, age: $select.search}"
     * performs an AND between 'name: $select.search' and 'age: $select.search'.
     * We want to perform an OR.
     */
    function propsFilter() {
        return function (items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop] != null && item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                            itemMatches = true;
                            break;
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('phone', phone);

    function phone() {
        return function (phone) {
            if (!phone) {
                return '';
            }

            var value = phone.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return phone;
            }

            var country, city, number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return phone;
            }

            if (country == 1) {
                country = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (country + " (" + city + ") " + number).trim();
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('patientName', patientName);

    function patientName() {
        return patientNameFilter;

        function patientNameFilter(value) {
            return value == null ? "" :
                value.lastName + ", " + value.firstName + (value.middleInitial ? " " + value.middleInitial : "");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('ngSrcSign', ngSrcSign);

    ngSrcSign.$inject = ['$timeout', '$http', 'AuthServerProvider', '$sanitize'];

    function ngSrcSign($timeout, $http, AuthServerProvider, $sanitize) {
        var directive = {
            restrict: 'A',
            link: link
        }

        return directive;

        function link($scope, element, attrs) {
            function revokeObjectURL() {
                if ($scope.objectURL) {
                    URL.revokeObjectURL($scope.objectURL);
                }
            }

            $scope.$on('$destroy', function () {
                revokeObjectURL();
            });

            attrs.$set('src', 'data:image/png;base64,' + '');

            if (attrs.ngSrcSign) {
                //request file data from server, attaching auth header and token
                var requestConfig = {
                    responseType: 'arraybuffer',
                    method: 'Get',
                    headers: {'Authorization': 'Bearer ' + AuthServerProvider.getToken()},
                    url: '/api/signatures/get-file' + '/' + attrs.ngSrcSign,
                    cache: 'false',
                    transformResponse: function (response, headers) {

                        var blob = new Blob(
                            [ response ],
                            { type: headers('Content-Type')}
                        );

                        $scope.objectURL = window.URL.createObjectURL(blob);

                        return $scope.objectURL
                    }
                };

                $http(requestConfig)
                    .success(function (data) {
                        attrs.$set('src', $sanitize(data));
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('ngSrcEvaluationAuth', ngSrcEvaluationAuth);

    ngSrcEvaluationAuth.$inject = ['$timeout', '$http', 'AuthServerProvider', 'GUIUtils', '$sanitize'];

    function ngSrcEvaluationAuth($timeout, $http, AuthServerProvider, GUIUtils, $sanitize) {
        var directive = {
            restrict: 'A',
            link: link
        }

        return directive;

        function link($scope, element, attrs) {
            function revokeObjectURL() {
                if ($scope.objectURL) {
                    URL.revokeObjectURL($scope.objectURL);
                }
            }

            $scope.$on('$destroy', function () {
                revokeObjectURL();
            });

            attrs.$set('src', 'data:image/png;base64,' + GUIUtils.getDefaultUserPicture());

            if (attrs.ngSrcEvaluationAuth) {
                //request file data from server, attaching auth header and token
                var requestConfig = {
                    responseType: 'arraybuffer',
                    method: 'Get',
                    headers: {'Authorization': 'Bearer ' + AuthServerProvider.getToken()},
                    url: '/api/evaluation-files/get-file-preview' + '/' + attrs.ngSrcEvaluationAuth,
                    cache: 'false',
                    transformResponse: function (response, headers) {
                        var blob = new Blob(
                            [ response ],
                            { type: headers('Content-Type')}
                        );

                        $scope.objectURL = window.URL.createObjectURL(blob);

                        return $scope.objectURL
                    }
                };

                $http(requestConfig)
                    .success(function (data) {
                        attrs.$set('src', $sanitize(data));
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('ngSrcAuthInsuranceFront', ngSrcAuthInsuranceFront);

    ngSrcAuthInsuranceFront.$inject = ['$timeout', '$http', 'AuthServerProvider', 'CoreService', '$sanitize'];

    function ngSrcAuthInsuranceFront($timeout, $http, AuthServerProvider, CoreService, $sanitize) {
        var directive = {
            restrict: 'A',
            link: link
        }

        return directive;

        function link($scope, element, attrs) {
            function revokeObjectURL() {
                if ($scope.objectURL) {
                    URL.revokeObjectURL($scope.objectURL);
                }
            }

            $scope.$on('$destroy', function () {
                revokeObjectURL();
            });

            attrs.$set('src', CoreService.insuranceFrontPictureDefault().picture);

            if (attrs.ngSrcAuthInsuranceFront) {
                //request file data from server, attaching auth header and token
                var requestConfig = {
                    responseType: 'arraybuffer',
                    method: 'Get',
                    headers: {'Authorization': 'Bearer ' + AuthServerProvider.getToken()},
                    url: '/api/insurance-pictures/get-thumbnail' + '/' + attrs.ngSrcAuthInsuranceFront,
                    cache: 'false',
                    transformResponse: function (response, headers) {
                        var blob = new Blob(
                            [ response ],
                            { type: headers('Content-Type')}
                        );

                        $scope.objectURL = window.URL.createObjectURL(blob);

                        return $scope.objectURL
                    }
                };

                $http(requestConfig)
                    .success(function (data) {
                        attrs.$set('src', $sanitize(data));
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('ngSrcAuthInsuranceBack', ngSrcAuthInsuranceBack);

    ngSrcAuthInsuranceBack.$inject = ['$timeout', '$http', 'AuthServerProvider', 'CoreService', '$sanitize'];

    function ngSrcAuthInsuranceBack($timeout, $http, AuthServerProvider, CoreService, $sanitize) {
        var directive = {
            restrict: 'A',
            link: link
        }

        return directive;

        function link($scope, element, attrs) {
            function revokeObjectURL() {
                if ($scope.objectURL) {
                    URL.revokeObjectURL($scope.objectURL);
                }
            }

            $scope.$on('$destroy', function () {
                revokeObjectURL();
            });

            attrs.$set('src', CoreService.insuranceBackPictureDefault().picture);

            if (attrs.ngSrcAuthInsuranceBack) {
                //request file data from server, attaching auth header and token
                var requestConfig = {
                    responseType: 'arraybuffer',
                    method: 'Get',
                    headers: {'Authorization': 'Bearer ' + AuthServerProvider.getToken()},
                    url: '/api/insurance-back-pictures/get-thumbnail' + '/' + attrs.ngSrcAuthInsuranceBack,
                    cache: 'false',
                    transformResponse: function (response, headers) {
                        var blob = new Blob(
                            [ response ],
                            { type: headers('Content-Type')}
                        );

                        $scope.objectURL = window.URL.createObjectURL(blob);

                        return $scope.objectURL
                    }
                };

                $http(requestConfig)
                    .success(function (data) {
                        attrs.$set('src', $sanitize(data));
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('ngSrcAuth', ngSrcAuth);

    ngSrcAuth.$inject = ['$timeout', '$http', 'AuthServerProvider', 'GUIUtils', '$sanitize'];

    function ngSrcAuth($timeout, $http, AuthServerProvider, GUIUtils, $sanitize) {
        var directive = {
            restrict: 'A',
            link: link
        }

        return directive;

        function link($scope, element, attrs) {
            function revokeObjectURL() {
                if ($scope.objectURL) {
                    URL.revokeObjectURL($scope.objectURL);
                }
            }

            $scope.$on('$destroy', function () {
                revokeObjectURL();
            });

            attrs.$set('src', 'data:image/png;base64,' + GUIUtils.getDefaultUserPicture());

            var chart = angular.fromJson(attrs.ngSrcAuth);

            if (chart && chart.pictureRefId) {
                //request file data from server, attaching auth header and token
                var requestConfig = {
                    responseType: 'arraybuffer',
                    method: 'Get',
                    headers: {'Authorization': 'Bearer ' + AuthServerProvider.getToken()},
                    url: '/api/chart-pictures/get-thumbnail' + '/' + chart.id,
                    cache: 'false',
                    transformResponse: function (response, headers) {
                        var blob = new Blob(
                            [response],
                            {type: headers('Content-Type')}
                        );

                        $scope.objectURL = window.URL.createObjectURL(blob);

                        return $scope.objectURL;
                    }
                };

                $http(requestConfig)
                    .success(function (data) {
                        attrs.$set('src', $sanitize(data));
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .factory('JSignature', JSignature);
    JSignature.$inject = ['$q']
    function JSignature($q) {

        var apinamespace = 'jSignature';

        var exportTypes = {
            DEFAULT: 'default',
            NATIVE: 'native',
            IMAGE: 'image',
            BASE30: 'base30',
            IMAGE_SIGNATURE_BASE30: 'image/jsignature;base30',
            SVG: 'svg',
            SVG_XML: 'image/svg+xml',
            SVG_BASE64: 'svgbase64',
            IMAGE_SVG_XML_BASE64: 'image/svg+xml;base64'
        }

        var importTypes = {
            NATIVE: 'native',
            IMAGE: 'image',
            IMAGE_PNG_BASE64: 'image/png;base64',
            IMAGE_JPEG_BASE64: 'image/jpeg;base64',
            IMAGE_JPG_BASE64: 'image/jpg;base64'
        }

        var object = {
            initialized: false,
            options: {
                width: null,
                height: null,
                color: null,
                'background-color': null,
                lineWidth: null,
                cssclass: null,
                UndoButton: false
            },
            element: null,
            scope: null,
        };

        var service = {
            getObject: getObject,
            exportTypes: exportTypes,
            importTypes: importTypes,
            initialize: initialize,
            reset: reset,
            getData: getData,
            // setData: setData,
            disable: disable,
            enable: enable
        };

        return service;

        function initialize(scope, options) {
            var defer = $q.defer();
            object.initialized = false;
            object.scope = scope;

            if (!object.initialized) {
                var selectorId = scope.jSignatureId ? '#' + scope.jSignatureId : '#jSignature';
                object.element = $(selectorId);
                object.initialized = true;
                object.element.jSignature(options);
                defer.resolve(object.element);
            }
            return defer.promise;
        }

        function reset() {
            var defer = $q.defer();
            defer.resolve(object.element.jSignature('reset'));
            return defer.promise;
        }

        function getData(type) {
            // console.log('getData!!!');
            return object.element.jSignature('getData', type);
        }

        function getDataAsSVG() {
            // console.log('getData!!!');
            // var datapair = object.element.jSignature('getData', 'base30');
            var svg = object.element.jSignature('getData', 'svg');
            return svg;
        }

        function getDataAsBase30() {
            // console.log('getData!!!');
            // var datapair = object.element.jSignature('getData', 'base30');
            var svg = object.element.jSignature('getData', 'svg');
            return svg;
        };

        function setData(sig) {
            // console.log('setData!!!');
            // console.log(sig);
            object.element.jSignature('setData', 'data:' + sig.join(','));
        };

        function disable() {
            // console.log('Disable!!!');
            object.element.jSignature('disable');
        };

        function enable() {
            // console.log('Enable!!!');
            object.element.jSignature('enable');
        };

        function undo() {
            var eventName = apinamespace + '.undo'
            object.element.jSignature('events');
        };

        function getObject() {
            // $('#signature').on('change', function(e){
            //     var undef
            //     if ($(e.target).jSignature('getData','native').length) {
            //         $tools.find('input').prop('disabled', false)
            //     } else {
            //         $tools.find('input').prop('disabled', true)
            //     }
            //
            // })
            return object.element;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('jSignature', jSignature);

    jSignature.$inject = ['$timeout', 'JSignature'];

    function jSignature($timeout, JSignature) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/udt/j-signature.html',
            scope: {
                sig: '=',
                ngModel: '=',
                validators: '@',
                messageContainer: '@',
                width: '@',
                height: '@',
                color: '@',
                bgColor: '@',
                lineWidth: '@',
                cssclass: '@',
                undo: '@',
                save: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc($scope, $element) {
            //Setting and ID
            $scope.jSignatureId = 'jSignatureId-' + new Date().valueOf();
            var options = {
                width: $scope.width,
                height: $scope.height,
                color: $scope.color || '#00008B',
                'background-color': $scope.bgColor || '#EEEEEE',
                lineWidth: $scope.lineWidth,
                cssClass: $scope.cssClass,
                UndoButton: $scope.undo
            };

            $scope.bindSignature = function () {
                if ($scope && $scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
                    $scope.ngModel = (JSignature.getData(JSignature.exportTypes.NATIVE).length) ? JSignature.getData(JSignature.exportTypes.IMAGE_PNG_BASE64) : undefined;
                    $scope.$apply();
                }
            }

            $timeout(function () {
                JSignature.initialize($scope, options)
                    .then(function (el) {
                        el.on('change', function (e) {
                            $scope.bindSignature();
                        })
                    });
            }, 20);

            $scope.reset = function () {
                JSignature.reset()
                    .then(function (result) {
                        $scope.ngModel = undefined;
                    });
            };


        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('employeeName', employeeName);

    function employeeName() {
        return employeeNameFilter;

        function employeeNameFilter(value) {

            return value == null ? "-" :
                value.lastName + ", " + value.firstName;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .directive('compareTo', compareTo);

    function compareTo() {

        var directive = {
            require: 'ngModel',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, elem, attrs, ctrl) {
            var firstPassword = '#' + attrs.compareTo;
            elem.add(firstPassword).on('keyup', function () {
                scope.$apply(function () {
                    // console.info(elem.val() === $(firstPassword).val());
                    ctrl.$setValidity('notmatch', elem.val() === $(firstPassword).val());
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('clearEnum', clearEnum);

    function clearEnum() {
        return clearEnumFilter;

        function clearEnumFilter(value) {

            return value == null ? "" : value.replace('_', ' ');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('udt')
        .filter('ccNumberFormat', function() {
            //this slice the number in 4 groups of 4 digits
            var ccFormat = /^(\d{4})?(\d{4})?(\d{4})?(\d{4})$/;

            return function(ccNumber) {
                var parsed = ccFormat.exec(ccNumber);

                return (!parsed) ? ccNumber : ((parsed[1]) ? parsed[1] + ' ' : '') + parsed[2] + ' ' + parsed[3] + ' ' + parsed[4];
            }
        });
})();

angular.module('ui.pagination', [])

    .directive('pagination', function () {
        return {
            restrict: 'E',
            scope: {
                lastPage: '=',
                currentPage: '=',
                onSelectPage: '&'
            },
            templateUrl: 'app/components/pagination/pagination.html',
            replace: true,
            link: function (scope) {
                scope.$watch('lastPage', function (value) {
                    scope.pages = [];
                    for (var i = 1; i <= value; i++) {
                        scope.pages.push(i);
                    }
                    if (scope.currentPage > value) {
                        scope.selectPage(value);
                    }
                });
                scope.noPrevious = function () {
                    return scope.currentPage === 1;
                };
                scope.noNext = function () {
                    return scope.currentPage === scope.lastPage;
                };
                scope.isActive = function (page) {
                    return scope.currentPage === page;
                };

                scope.selectPage = function (page) {
                    if (!scope.isActive(page)) {
                        scope.currentPage = page;
                        scope.onSelectPage({page: page});
                    }
                };

                scope.selectPrevious = function () {
                    if (!scope.noPrevious()) {
                        scope.selectPage(scope.currentPage - 1);
                    }
                };
                scope.selectNext = function () {
                    if (!scope.noNext()) {
                        scope.selectPage(scope.currentPage + 1);
                    }
                };
            }
        };
    });

/**
 * Created by alien on 7/13/17.
 */

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('headerDatatable', headerDatatable);

    function headerDatatable() {
        var directive = {
            restrict: 'EA',
            transclude: true,
            templateUrl: 'app/components/header-datatable/header-datatable.tpl.html',
            // controllerAs: 'ctrl',
            bindings: {
                entity: '@',

            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel, transclude) {
            // el.append(transclude());
            // console.log("ctrl", scope);
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('GenericEntityDatatableService', GenericEntityDatatableService);

    GenericEntityDatatableService.$inject = ['$state'];

    function GenericEntityDatatableService($state) {

        var service = {
            getNewAction: getNewAction,
            getDetailsAction: getDetailsAction,
            getEditAction: getEditAction,
            getDeleteAction: getDeleteAction,
            getPrintAction: getPrintAction,
            getViewPdfAction: getViewPdfAction,
            getSendAction: getSendAction,
            getPlayAction: getPlayAction,
            getDownloadAction: getDownloadAction,
            getRefreshAction: getRefreshAction,
            getSignAction: getSignAction,
            getHourGlassAction: getHourGlassAction,
            getCalendarAction: getCalendarAction,
            getCloneAction: getCloneAction,
            getCommentAction: getCommentAction,
            getAddCommentAction: getAddCommentAction,
            getGraphAction: getGraphAction,
            getCheckAction: getCheckAction,
            getViewChartAction: getViewChartAction,
            getInfoAction: getInfoAction,
            getDiagnosisAction: getDiagnosisAction,
            getInsuranceAction: getInsuranceAction,
            getCareTeamAction: getCareTeamAction,
            getRestoreAction: getRestoreAction,
            addLogoAction: addLogoAction
        };

        return service;

        function getNewAction() {

            return {
                aClass: 'dd-link green',
                iClass: 'fa fa-plus-circle',
                ngClass: function() { return ['bg-green'] }
            }
        }

        function getDetailsAction(entity) {

            return {
                name: 'View Details',
                action: function (data) {
                    $state.go(entity + '.details', {id: data.id});
                },
                aClass: 'dd-link blue',
                iClass: 'fa fa-file-text-o'
            }
        }

        function getEditAction(entity) {

            return {
                name: 'Edit',
                action: function (data) {
                    $state.go(entity + '.edit', {id: data.id});
                },
                aClass: 'dd-link orange',
                iClass: 'fa fa-edit'
            }
        }

        function getDeleteAction(entity) {

            return {
                name: 'Delete',
                action: function (data) {
                    $state.go(entity + '.delete', {id: data.id});
                },
                aClass: 'dd-link red',
                iClass: 'fa fa-trash-o'
            }
        }

        function getPrintAction() {

            return {
                name: 'Print',
                aClass: 'dd-link green',
                iClass: 'fa fa-print',
            }
        }

        function getViewPdfAction() {

            return {
                name: 'View Pdf',
                aClass: 'dd-link red',
                iClass: 'fa fa-file-pdf-o',
            }
        }

        function getSendAction() {

            return {
                name: 'Send',
                aClass: 'dd-link blue',
                iClass: 'fa fa-paper-plane'
            }
        }

        function getPlayAction() {

            return {
                name: 'Play',
                aClass: 'dd-link green',
                iClass: 'fa fa-play'
            }
        }

        function getDownloadAction() {

            return {
                name: 'Download',
                aClass: 'dd-link green',
                iClass: 'fa fa-download'
            }
        }

        function getRefreshAction() {

            return {
                name: 'Refresh',
                aClass: 'dd-link green',
                iClass: 'fa fa-refresh',
                ngClass: function() { return ['bg-white'] }
            }
        }

        function getSignAction() {

            return {
                name: 'Sign',
                aClass: 'dd-link green',
                iClass: 'fa fa-pencil',
                ngClass: function() { return ['bg-green'] }
            }
        }

        function getHourGlassAction() {

            return {
                aClass: 'dd-link white',
                iClass: 'fa fa-hourglass-2',
            }
        }

        function getCalendarAction() {

            return {
                aClass: 'dd-link white',
                iClass: 'fa fa-calendar',
            }
        }

        function getCloneAction(entity) {

            return {
                name: 'Clone',
                action: function (data) {
                    $state.go(entity + '.clone', {id: data.id});
                },
                aClass: 'dd-link blue',
                iClass: 'fa fa-clone'
            }
        }

        function getCommentAction(entity) {

            return {
                name: 'Comment',
                aClass: 'dd-link green',
                iClass: 'fa fa-comments-o'
            }
        }

        function getAddCommentAction(entity) {

            return {
                name: 'Comment',
                aClass: 'dd-link green',
                iClass: 'fa fa-comment-o'
            }
        }

        function getGraphAction(entity) {

            return {
                name: 'Graph',
                aClass: 'dd-link red',
                iClass: 'fa fa-bar-chart'
            }
        }

        function getCheckAction(entity) {

            return {
                name: 'Check',
                aClass: 'dd-link white',
                iClass: 'fa fa-check-circle'
            }
        }

        function getViewChartAction(entity) {

            return {
                name: 'View Chart',
                aClass: 'dd-link gray',
                iClass: 'fa fa-user'
            }
        }

        function getInfoAction(entity) {

            return {
                name: 'View Info',
                aClass: 'dd-link blue',
                iClass: 'fa fa-info-circle'
            }
        }

        function getDiagnosisAction(entity) {

            return {
                name: 'Diagnosis',
                aClass: 'dd-link green',
                iClass: 'fa fa-ambulance'
            }
        }

        function getInsuranceAction(entity) {

            return {
                name: 'Insurance',
                aClass: 'dd-link green',
                iClass: 'fa fa-id-card'
            }
        }

        function getCareTeamAction(entity) {

            return {
                name: 'Care Team',
                aClass: 'dd-link green',
                iClass: 'fa fa-user-md'
            }
        }

        function getRestoreAction(entity) {

            return {
                name: 'Restore',
                aClass: 'dd-link green',
                iClass: 'fa fa-check-circle'
            }
        }

        function addLogoAction(entity) {

            return {
                name: 'New Logo',
                aClass: 'dd-link green',
                iClass: 'fa fa-plus'
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('genericEntityDatatable', GenericEntityDatatable);

    GenericEntityDatatable.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$compile', '$filter'];

    function GenericEntityDatatable(DTOptionsBuilder, DTColumnBuilder, $q, $compile, $filter) {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/generic-entity-datatable/generic-entity-datatable.tpl.html',
            scope: {
                descriptor: '<'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc($scope, element, attrs, ngModel, transclude) {
            $scope.dtInstanceCallback = function (instance) {
                $scope.dtInstance = instance;
            }

            $scope.get = function (sSource, aoData, fnCallback, oSettings) {
                $scope.selectAll = false;
                $scope.selected = {};

                var draw = aoData[0].value;
                // var order = aoData[2].value;
                var start = aoData[3].value;
                var length = aoData[4].value;
                // var params = {
                //     start: start,
                //     limit: length,
                // }

                $scope.itemsPerPage = length;
                $scope.page = (start / length) + 1;

                var filter = angular.copy($scope.params);
                filter.page = start / length;
                filter.size = length;

                filter = $scope.getFilter(filter);

                $scope.descriptor.service[$scope.descriptor.serviceMethod](filter, function (result, headers) {
                    $scope.totalItems = headers('X-Total-Count') ? headers('X-Total-Count') : result.length;

                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': []
                    };
                    if (result) {
                        records = {
                            'draw': draw,
                            'recordsTotal': $scope.totalItems,
                            'recordsFiltered': $scope.totalItems,
                            'data': result
                        };
                    }
                    $scope.dtInstance.total = $scope.totalItems;
                    $scope.values = result;

                    fnCallback(records);

                    if ($scope.descriptor.filterCallback) {
                        $scope.descriptor.filterCallback(angular.extend({}, filter, {totalItems: $scope.totalItems}));
                    }
                });
            }

            $scope.rowCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $compile(nRow)($scope);
            }

            $scope.getLocalOptions = function () {
                return DTOptionsBuilder
                    .fromFnPromise(function () {
                        var defer = $q.defer();

                        if (!$scope.localSearch || !$scope.filter.searchQuery || $scope.filter.searchQuery === '') {
                            var filter = angular.copy($scope.params);
                            filter = $scope.getFilter(filter);

                            $scope.descriptor.service[$scope.descriptor.serviceMethod](filter, function (result) {
                                $scope.values = result;
                                $scope.totalItems = result.length;

                                defer.resolve(result);

                                if ($scope.descriptor.filterCallback) {
                                    $scope.descriptor.filterCallback(angular.extend({}, filter, {totalItems: $scope.values.length}));
                                }
                            });
                        } else {
                            defer.resolve($filter('filter')($scope.values, $scope.filter.searchQuery, undefined));
                        }

                        return defer.promise;
                    })
                    .withPaginationType('full_numbers')
                    .withBootstrap()
                    .withOption('paging', true)// required
                    .withOption("bPaginate", true)
                    .withOption('lengthMenu', [[5, 10, 15, 25], [5, 10, 15, 25]])
                    .withDisplayLength($scope.itemsPerPage)
                    .withLanguage({
                        "paginate": {
                            "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                            "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                            "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                            "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                        }
                    })
                    .withDOM('ltip')
                    // .withOption('aaSorting', [[2, 'desc'], [4, 'asc']])
                    .withOption('headerCallback', function (header) {
                        if (!$scope.headerCompiled) {
                            $scope.headerCompiled = true;
                            $compile(angular.element(header).contents())($scope);
                        }
                    })
                    .withOption('createdRow', function (row) {
                        $compile(angular.element(row).contents())($scope);
                    });
            }

            $scope.getRemoteOptions = function () {
                return DTOptionsBuilder
                    .newOptions()
                    .withPaginationType('full_numbers')
                    .withBootstrap()
                    .withFnServerData($scope.get)
                    .withDataProp('data')// parameter name of list use in getLeads Fuction
                    .withOption('processing', true) // required
                    .withOption('serverSide', true)// required
                    .withOption('paging', true)// required
                    .withOption("bPaginate", true)
                    .withOption('lengthMenu', [[5, 10, 15, 25], [5, 10, 15, 25]])
                    .withDisplayLength($scope.itemsPerPage)
                    .withLanguage({
                        "paginate": {
                            "first": '<i class="fa fa-angle-double-left" aria-hidden="true"></i>',
                            "previous": '<i class="fa fa-arrow-circle-left" aria-hidden="true"></i>',
                            "last": '<i class="fa fa-angle-double-right" aria-hidden="true"></i>',
                            "next": '<i class="fa fa-arrow-circle-right" aria-hidden="true"></i>'
                        }
                    })
                    .withDOM('ltip')
                    .withOption('headerCallback', function (header) {
                        if (!$scope.headerCompiled) {
                            $scope.headerCompiled = true;
                            $compile(angular.element(header).contents())($scope);
                        }
                    })
                    .withOption('createdRow', function (row) {
                        $compile(angular.element(row).contents())($scope);
                    });
            }

            $scope.getDtColumns = function () {
                var dtColumns = [];

                if ($scope.withSelectionColumn) {
                    var dtColumn = DTColumnBuilder
                        .newColumn(null)
                        .withTitle('<input type="checkbox" ' +
                            'ng-model="selectAll" ' +
                            'ng-change="toggleAll()" ' +
                            'ng-disabled="descriptor.disableAllSelectionColumn && descriptor.disableAllSelectionColumn(filter)">')

                        .withOption('width', '25px')
                        .notSortable()
                        .renderWith(function (data, type, full, meta) {
                            if ($scope.selected[full[$scope.selectionColumn]] === undefined) {
                                $scope.selected[full[$scope.selectionColumn]] = false;
                            }

                            return '<input type="checkbox" ' +
                                'ng-model="selected[' + data[$scope.selectionColumn] + ']" ' +
                                'ng-click="toggleOne()" ' +
                                'ng-disabled="descriptor.disableSelectionColumn && descriptor.disableSelectionColumn(filter)">';
                        });

                    if ($scope.descriptor.isVisibleSelectionColumn && !$scope.descriptor.isVisibleSelectionColumn($scope.filter)) {
                        dtColumn = dtColumn.notVisible();
                    }

                    dtColumns.push(
                        dtColumn
                    );
                }

                dtColumns.push(...
                    _.map($scope.descriptor.columns, function (column) {
                        var dtColumn;
                        if (column.render === undefined) {

                            dtColumn = DTColumnBuilder.newColumn(column.name).withTitle(column.title).notSortable()
                                .renderWith(function (data, type, full) {
                                    return !full || full[column.name] == null ? "" : full[column.name];
                                });
                        } else {

                            dtColumn = DTColumnBuilder.newColumn(null).withTitle(column.title).notSortable().renderWith(column.render);
                        }

                        if (column.isVisible && !column.isVisible()) {
                            dtColumn = dtColumn.notVisible();
                        }

                        _.forEach(column.options, function (option) {
                            dtColumn = dtColumn.withOption(option.key, option.value);
                        });

                        return dtColumn;
                    })
                );

                return dtColumns;
            }

            $scope.updateDtColumns = function () {
                if ($scope.descriptor.updateColumns) {
                    $scope.descriptor.updateColumns($scope.dtColumns, $scope.filter);
                }
            }

            $scope.getDtColumnRowActions = function () {
                if ($scope.descriptor.rowActions && $scope.descriptor.rowActions.length > 0) {
                    _.forEach($scope.descriptor.rowActions, function (action, i) {
                        action.index = i;
                    });

                    return [
                        DTColumnBuilder
                            .newColumn(null).withTitle('Actions')
                            .withOption('width', '50px')
                            .notSortable()
                            .renderWith(function (data, type, full, meta) {
                                return '<div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body>' +
                                    '   <button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle>' +
                                    '       <i class="fa fa-ellipsis-v" aria-hidden="true"></i>' +
                                    '   </button>' +
                                    '<ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu>' +
                                    _.join(
                                        _.map(
                                            _.filter($scope.descriptor.rowActions, function (action) {
                                                return action.ngIf === undefined || action.ngIf(data, $scope.filter);
                                            }),
                                            function (action) {
                                                return '' +
                                                    '<li role="menuitem">' +
                                                    '   <a href="" class="' + action.aClass + '" ng-click="executeRowAction(' + action.index + ', ' + data[$scope.selectionColumn] + ')">' +
                                                    '       <i class="' + action.iClass + '" aria-hidden="true"></i>' + action.name +
                                                    '   </a>' +
                                                    '</li>'
                                            }), "") +
                                    '</ul>' +
                                    '</div>';
                            })
                    ]
                }

                return [];
            }

            $scope.getDtOptions = function () {
                $scope.pagination = !$scope.descriptor.pagination || $scope.descriptor.pagination === 'local' ? 'local' : 'remote';

                var dtOptions = $scope.pagination === 'local' ? $scope.getLocalOptions() : $scope.getRemoteOptions();

                _.forEach($scope.descriptor.options, function (option) {
                    dtOptions = dtOptions.withOption(option.key, option.value);
                })

                return dtOptions;
            }

            $scope.executeRowAction = function (index, id) {
                var action = _.find($scope.descriptor.rowActions, ['index', index]);
                var isPromise = action.action(_.find($scope.values, [$scope.selectionColumn, id]));

                if (isPromise == null) {
                    if (action.reload) {
                        $scope.search();
                    }
                } else {
                    isPromise.then(
                        function () {
                            $scope.search();
                        },
                        function () {
                            $scope.search();
                        }
                    );
                }
            }

            $scope.search = function () {
                $scope.page = 1;
                $scope.selectAll = false;
                $scope.selected = {};

                if ($scope.pagination === 'local') {
                    $scope.dtInstance.reloadData();
                } else {
                    $scope.dtInstance.DataTable.page($scope.page - 1).draw('page');
                }
            }

            $scope.clearFilter = function () {
                $scope.filter = $scope.initFilter();
                $scope._filter = angular.copy($scope.filter);

                $scope.search();
            }

            $scope.executeAction = function (action) {
                var isPromise = action.action($scope.filter, $scope.getSelected());

                if (isPromise == null) {
                    if (action.reload !== false) {
                        $scope.updateDtColumns();
                        $scope.search();
                    }
                } else {
                    isPromise.then(
                        function () {
                            $scope.updateDtColumns();
                            $scope.search();
                        },
                        function () {
                            $scope.updateDtColumns();
                            $scope.search();
                        }
                    );
                }
            }

            $scope.initFilter = function () {
                var filter = {
                    searchQuery: ""
                };

                _.forEach($scope.filterDescriptors, function (filterDescriptor) {
                    if (filterDescriptor.defaultValue) {
                        filter[filterDescriptor.name] = filterDescriptor.defaultValue();
                    } else {
                        filter[filterDescriptor.name] = null;
                    }
                })

                return filter;
            }

            $scope.getFilter = function (filter) {
                filter.searchQuery = $scope.filter.searchQuery;

                _.forEach($scope.filterDescriptors, function (filterDescriptor) {
                    if (filterDescriptor.read) {
                        filter[filterDescriptor.name] = filterDescriptor.read($scope.filter);
                    } else {
                        filter[filterDescriptor.name] = $scope.filter[filterDescriptor.name];
                    }
                });

                return filter;
            }

            $scope.toggleAll = function () {
                for (var id in $scope.selected) {
                    if ($scope.selected.hasOwnProperty(id)) {
                        $scope.selected[id] = $scope.selectAll;
                    }
                }
            }

            $scope.toggleOne = function () {
                for (var id in $scope.selected) {
                    if ($scope.selected.hasOwnProperty(id)) {
                        if (!$scope.selected[id]) {
                            $scope.selectAll = false;
                            return;
                        }
                    }
                }
                $scope.selectAll = true;
            }

            $scope.getSelected = function () {
                var ids = [];
                for (var id in $scope.selected) {
                    if ($scope.selected[id]) {
                        ids.push(id);
                    }
                }

                return _.filter($scope.values, function (value) {
                    return ids.indexOf("" + value[$scope.selectionColumn]) !== -1;
                })
            }

            $scope.isSelected = function () {
                for (var id in $scope.selected) {
                    if ($scope.selected[id]) {
                        return true;
                    }
                }

                return false;
            }

            $scope.openCalendar = function (dateField) {
                $scope.datePickerOpenStatus[dateField] = true;
            }

            $scope.isFilterActive = function () {
                return !angular.equals($scope.filter, $scope._filter);
            }

            $scope.init = function () {
                $scope.datePickerOpenStatus = {};
                $scope.filter = {};
                $scope.itemsPerPage = 10;
                $scope.totalItems = 0;
                $scope.dtInstance = {};
                $scope.page = 1;
                $scope.values = [];
                $scope.selected = {};
                $scope.selectAll = false;
                $scope.filtersDropdown = false;

                $scope.localSearch = $scope.descriptor.localSearch || $scope.descriptor.localSearch === undefined;
                $scope.enableSearch = $scope.descriptor.enableSearch || $scope.descriptor.enableSearch === undefined;
                $scope.params = $scope.descriptor.params ? $scope.descriptor.params : {};
                $scope.newAction = $scope.descriptor.newAction === undefined || $scope.descriptor.newAction;
                $scope.filterDescriptors = $scope.descriptor.filters ? $scope.descriptor.filters : [];
                $scope.visibleFilterDescriptors = $scope.getVisibleFilters();
                $scope.withSelectionColumn = $scope.descriptor.withSelectionColumn !== undefined && $scope.descriptor.withSelectionColumn;
                $scope.selectionColumn = $scope.descriptor.selectionColumn ? $scope.descriptor.selectionColumn : 'id';

                $scope.filter = $scope.initFilter();
                $scope._filter = angular.copy($scope.filter);

                $scope.dtOptions = $scope.getDtOptions();
                $scope.dtColumns = $scope.getDtColumns();
                $scope.dtColumns.push(...$scope.getDtColumnRowActions());

                $scope.updateDtColumns();
            }

            $scope.getVisibleFilters = function () {
                return _.filter($scope.filterDescriptors, function (item) {
                    return item.visible !== false;
                });
            }

            $scope.init();

            $scope.getRmDatePicker = function () {
                return _.find($scope.visibleFilterDescriptors, ['type', 'rm2-datepicker']);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('DeleteEntityController',DeleteEntityController);

    DeleteEntityController.$inject = ['$uibModalInstance', 'entity'];

    function DeleteEntityController($uibModalInstance, entity) {
        var vm = this;

        vm.entity = entity.name;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            $uibModalInstance.close();
        }
    }
})();

/**
 * Created by jesusrodriguez on 2/26/19.
 */
(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ConfirmationService', ConfirmationService);

    ConfirmationService.$inject = ['$uibModal'];

    function ConfirmationService($uibModal) {
        var _defaultConfig = {
            title: '',
            message: '',
            icon: {},
            leftAction: null,
            // leftAction: {
            //     name: 'Info',
            //     color: 'btn btn-warning',
            //     icon: 'fa fa-info',
            //     value: 'INFO'
            // },
            actions: [
                {
                    name: 'Delete',
                    color: 'btn btn-success',
                    icon: 'fa fa-trash',
                    value: 'SUCCESS'
                },
                {
                    name: 'Cancel',
                    color: 'btn btn-danger',
                    icon: 'fa fa-ban',
                    value: 'CANCEL'
                }
            ]
        }

        var service = {
            showDelete: showDelete,
            showCredentials: showCredentials,
            open: open
        };

        return service;

        function showDelete(entity) {
            var config = angular.extend({}, _defaultConfig, {
                title: 'Delete ' + entity,
                message:
                    `This action is <strong>final</strong> and will <strong>remove</strong>
                        this ${entity} from the database. Are you sure you want to <strong>delete</strong> this ${entity}?`,
            })

            return open(config);
        }

        function showCredentials(credentials) {
            var config = angular.extend({}, _defaultConfig, {
                title: 'Care and Delivery Credentials',
                message:
                    `<div class="row">
                        <div class="col-lg-12" style="font-size: 18px;">` +
                    (credentials === null || credentials.length === 0 ?
                            `<ul class="list-inline" style="padding-left: 0;">
                                    <li style="margin-bottom: 5px">
                                        <span class="label label-info">Does not require any credentials</span>
                                    </li>
                                </ul>`
                            :
                            `<ul class="list-inline" style="padding-left: 0;">` +
                            _.join(
                                _.map(credentials, function (credential) {
                                    return `<li style="margin-bottom: 5px">
                                                <span class="label label-warning">${credential}</span>
                                            </li>`
                                }), " ") +
                            `</ul>`
                    ) +
                    `    </div>
                    </div>`,
                actions: [
                    {
                        name: 'Close',
                        color: 'btn btn-danger',
                        icon: 'fa fa-ban',
                        value: 'CANCEL'
                    }
                ]
            })

            return open(config);
        }

        function open(config) {
            return $uibModal.open({
                templateUrl: 'app/components/confirmation/confirmation.html',
                controller: 'ConfirmationDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: false,
                size: 'md',
                windowTopClass: 'custom-dialog-styles thanos-z-index',
                resolve: {
                    config: config
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConfirmationDialogController', ConfirmationDialogController);

    ConfirmationDialogController.$inject = ['$uibModalInstance', 'config'];

    function ConfirmationDialogController($uibModalInstance, config) {
        var vm = this;

        vm.config = config;

        vm.clear = clear;
        vm.close = close;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function close(value) {
            $uibModalInstance.close(value);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('assistantClipboard', assistantClipboard);

    assistantClipboard.$inject = [];

    function assistantClipboard() {
        return {
            restrict: 'E',
            templateUrl: 'app/components/assistant/assistant-clipboard.html',
            scope: {
                model: '=ngModel'
            },
            link: linkFunc
        };

        function linkFunc($scope) {
            $scope.query = "";

            $scope.copy = function (item) {
                if (window.clipboardData && window.clipboardData.setData) {
                    // IE specific code path to prevent textarea being shown while dialog is visible.
                    return clipboardData.setData("Text", item.note);

                } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                    var textarea = document.createElement("textarea");
                    textarea.textContent = item.note;
                    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                    document.body.appendChild(textarea);
                    textarea.select();
                    try {
                        return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                    } catch (ex) {
                        console.warn("Copy to clipboard failed.", ex);
                        return false;
                    } finally {
                        document.body.removeChild(textarea);
                    }
                }
            };

            angular.element('#clipboard-toggle').on('click', function() {
                if (angular.element('#clipboard-toggle').hasClass('open')) {
                    angular.element('#clipboard-toggle').removeClass('open');
                    angular.element('#clipboard-toggle + .clipboard-content').slideUp('fast')
                } else {
                    angular.element('#clipboard-toggle').addClass('open');
                    angular.element('#clipboard-toggle + .clipboard-content').slideDown('fast')
                }
            })
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('bluebookApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('bluebookApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-bluebookApp-error');
                var entityKey = httpResponse.headers('X-bluebookApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('bluebookApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-bluebookApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-bluebookApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('bluebookApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                var Auth = $injector.get('Auth');
                if (Principal.isAuthenticated()) {
                    Auth.authorize(true);
                } else {
                    Auth.logout();
                    var $state = $injector.get('$state');
                    $state.go('login');
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'bluebook' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';
    angular
        .module('bluebookApp')
        .constant('AUTH_ITEM_TYPE', {
            'TYPE_ROLE': 1,
            'TYPE_RESOURCE': 2,
            'TYPE_ACTION': 3
        })
        .constant('ROLES', {
            'ROLE_USER': 'ROLE_USER',
            'ROLE_ADMIN': 'ROLE_ADMIN',
            'ROLE_SYSTEM_ADMIN': 'ROLE_SYSTEM_ADMIN',
            'ROLE_SYSTEM': 'ROLE_SYSTEM'
        })
        .constant('RESOURCES', {
            'RESOURCE_MAIN_MENU': 'RESOURCE_MAIN_MENU'
        })
        .constant('ACTIONS', {
            'ACTION_MAIN_MENU_DASHBOARD': 'ACTION_MAIN_MENU_DASHBOARD',
            'ACTION_MAIN_MENU_PATIENT': 'ACTION_MAIN_MENU_PATIENT',
            'ACTION_MAIN_MENU_GROUP_SESSIONS': 'ACTION_MAIN_MENU_GROUP_SESSIONS',
            'ACTION_MAIN_MENU_BED_SHEET': 'ACTION_MAIN_MENU_BED_SHEET',
            'ACTION_MAIN_MENU_INCIDENT_REPORTS': 'ACTION_MAIN_MENU_INCIDENT_REPORTS',
            'ACTION_MAIN_MENU_OUTREACH_CAMPAIGNS': 'ACTION_MAIN_MENU_OUTREACH_CAMPAIGNS',
            'ACTION_MAIN_MENU_TELEHEALTH': 'ACTION_MAIN_MENU_TELEHEALTH',
            //Nursing submenus.
            'ACTION_MAIN_MENU_MEDICAL_NURSING': 'ACTION_MAIN_MENU_MEDICAL_NURSING',
            'ACTION_MAIN_MENU_MEDICAL_NURSING_FAX': 'ACTION_MAIN_MENU_MEDICAL_NURSING_FAX',
            'ACTION_MAIN_MENU_MEDICAL_NURSING_LAB_REQUISITIONS': 'ACTION_MAIN_MENU_MEDICAL_NURSING_LAB_REQUISITIONS',
            'ACTION_MAIN_MENU_MEDICAL_NURSING_LAB_RESULTS': 'ACTION_MAIN_MENU_MEDICAL_NURSING_LAB_RESULTS',
            'ACTION_MAIN_MENU_MEDICAL_NURSING_MARS': 'ACTION_MAIN_MENU_MEDICAL_NURSING_MARS',
            'ACTION_MAIN_MENU_MEDICAL_NURSING_NOTING': 'ACTION_MAIN_MENU_MEDICAL_NURSING_NOTING',
            'ACTION_MAIN_MENU_MEDICAL_NURSING_PHYSICIAN_REVIEW': 'ACTION_MAIN_MENU_MEDICAL_NURSING_PHYSICIAN_REVIEW',

            'ACTION_MAIN_MENU_SHIFT': 'ACTION_MAIN_MENU_SHIFT',
            'ACTION_MAIN_MENU_CONTACTS': 'ACTION_MAIN_MENU_CONTACTS',
            'ACTION_MAIN_MENU_AUDIT': 'ACTION_MAIN_MENU_AUDIT',
            'ACTION_MAIN_MENU_REPORTS': 'ACTION_MAIN_MENU_REPORTS',
            //Templates submenus.
            'ACTION_MAIN_MENU_TEMPLATES': 'ACTION_MAIN_MENU_TEMPLATES',
            'ACTION_MAIN_MENU_TEMPLATES_ASSISTANT': 'ACTION_MAIN_MENU_TEMPLATES_ASSISTANT',
            'ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY': 'ACTION_MAIN_MENU_TEMPLATES_CARE_AND_DELIVERY',
            'ACTION_MAIN_MENU_TEMPLATES_CARE_COORDINATION': 'ACTION_MAIN_MENU_TEMPLATES_CARE_COORDINATION',
            'ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS': 'ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS',
            'ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL': 'ACTION_MAIN_MENU_TEMPLATES_GROUP_SESSIONS_FORM_TPL',
            'ACTION_MAIN_MENU_TEMPLATES_OCCUPANCY': 'ACTION_MAIN_MENU_TEMPLATES_OCCUPANCY',
            'ACTION_MAIN_MENU_TEMPLATES_REPORTS_TEMPLATES': 'ACTION_MAIN_MENU_TEMPLATES_REPORTS_TEMPLATES',
            'ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE': 'ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE',
            'ACTION_MAIN_MENU_TEMPLATES_INCIDENT_REPORT_NOTE_TEMPLATE': 'ACTION_MAIN_MENU_TEMPLATES_INCIDENT_REPORT_NOTE_TEMPLATE',
            'ACTION_MAIN_MENU_TEMPLATES_CAMPAIGN': 'ACTION_MAIN_MENU_TEMPLATES_CAMPAIGN',
            'ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE': 'ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE',
            'ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION': 'ACTION_MAIN_MENU_TEMPLATES_FACESHEET_SECTION',
            'ACTION_MAIN_MENU_TEMPLATES_TRACK': 'ACTION_MAIN_MENU_TEMPLATES_TRACK',
            'ACTION_MAIN_MENU_TEMPLATES_EVALUATION_AUDIT': 'ACTION_MAIN_MENU_TEMPLATES_EVALUATION_AUDIT',
            //Config submenus.
            'ACTION_MAIN_MENU_CONFIG': 'ACTION_MAIN_MENU_CONFIG',
            'ACTION_MAIN_MENU_CONFIG_ACTIONS': 'ACTION_MAIN_MENU_CONFIG_ACTIONS',
            'ACTION_MAIN_MENU_CONFIG_ACUITY': 'ACTION_MAIN_MENU_CONFIG_ACUITY',
            'ACTION_MAIN_MENU_CONFIG_ALLERGEN': 'ACTION_MAIN_MENU_CONFIG_ALLERGEN',
            'ACTION_MAIN_MENU_CONFIG_BED': 'ACTION_MAIN_MENU_CONFIG_BED',
            'ACTION_MAIN_MENU_CONFIG_BUILDING': 'ACTION_MAIN_MENU_CONFIG_BUILDING',
            'ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL': 'ACTION_MAIN_MENU_CONFIG_BUSINESS_CREDENTIAL',
            'ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY': 'ACTION_MAIN_MENU_CONFIG_CONCURRENT_REVIEW_FREQUENCY',
            'ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS': 'ACTION_MAIN_MENU_CONFIG_CONTACT_ADDRESS',
            'ACTION_MAIN_MENU_CONFIG_EMPLOYEE': 'ACTION_MAIN_MENU_CONFIG_EMPLOYEE',
            'ACTION_MAIN_MENU_CONFIG_GROUP_SESSION_FREQUENCY': 'ACTION_MAIN_MENU_CONFIG_GROUP_SESSION_FREQUENCY',
            'ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG': 'ACTION_MAIN_MENU_CONFIG_INSURANCE_AUDIT_CONFIG',
            'ACTION_MAIN_MENU_CONFIG_INSURANCE_TYPE': 'ACTION_MAIN_MENU_CONFIG_INSURANCE_TYPE',
            'ACTION_MAIN_MENU_CONFIG_LABORATORY': 'ACTION_MAIN_MENU_CONFIG_LABORATORY',
            'ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE': 'ACTION_MAIN_MENU_CONFIG_LEVEL_OF_CARE',
            'ACTION_MAIN_MENU_CONFIG_MEDICATIONS': 'ACTION_MAIN_MENU_CONFIG_MEDICATIONS',
            'ACTION_MAIN_MENU_CONFIG_PATIENT_MEDICATION_MISSED': 'ACTION_MAIN_MENU_CONFIG_PATIENT_MEDICATION_MISSED',
            'ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS': 'ACTION_MAIN_MENU_CONFIG_PATIENT_PROCESS',
            'ACTION_MAIN_MENU_CONFIG_RATIONALE': 'ACTION_MAIN_MENU_CONFIG_RATIONALE',
            'ACTION_MAIN_MENU_CONFIG_REACTION': 'ACTION_MAIN_MENU_CONFIG_REACTION',
            'ACTION_MAIN_MENU_CONFIG_REPORT_CATEGORY': 'ACTION_MAIN_MENU_CONFIG_REPORT_CATEGORY',
            'ACTION_MAIN_MENU_CONFIG_RESOURCES': 'ACTION_MAIN_MENU_CONFIG_RESOURCES',
            'ACTION_MAIN_MENU_CONFIG_ROLES': 'ACTION_MAIN_MENU_CONFIG_ROLES',
            'ACTION_MAIN_MENU_CONFIG_ROOM': 'ACTION_MAIN_MENU_CONFIG_ROOM',
            'ACTION_MAIN_MENU_CONFIG_SERVICE_PROVIDER': 'ACTION_MAIN_MENU_CONFIG_SERVICE_PROVIDER',
            'ACTION_MAIN_MENU_CONFIG_SESSION_TYPE': 'ACTION_MAIN_MENU_CONFIG_SESSION_TYPE',
            'ACTION_MAIN_MENU_CONFIG_SEVERITY': 'ACTION_MAIN_MENU_CONFIG_SEVERITY',
            'ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE': 'ACTION_MAIN_MENU_CONFIG_SHIFT_TYPE',
            'ACTION_MAIN_MENU_CONFIG_SOURCE_MEDICATION': 'ACTION_MAIN_MENU_CONFIG_SOURCE_MEDICATION',
            'ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK': 'ACTION_MAIN_MENU_CONFIG_TYPE_OF_CHECK',
            'ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY': 'ACTION_MAIN_MENU_CONFIG_TYPE_OF_ETHNICITY',
            'ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE': 'ACTION_MAIN_MENU_CONFIG_INCIDENT_TYPE',
            'ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS': 'ACTION_MAIN_MENU_CONFIG_TYPE_PAYMENT_METHODS',
            'ACTION_MAIN_MENU_CONFIG_TYPE_RACE': 'ACTION_MAIN_MENU_CONFIG_TYPE_RACE',
            'ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE': 'ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACT_TYPE',
            'ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL': 'ACTION_MAIN_MENU_CONFIG_INSURANCE_LEVEL',
            'ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG': 'ACTION_MAIN_MENU_CONFIG_INSURANCE_RELATION_CONFIG',
            'ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE': 'ACTION_MAIN_MENU_CONFIG_TYPE_DISCHARGE_TYPE',
            'ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_PROPERTY_CONDITION': 'ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_PROPERTY_CONDITION',
            'ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE': 'ACTION_MAIN_MENU_CONFIG_TYPE_CONTACT_FACILITY_TYPE',
            'ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP': 'ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP',
            'ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY': 'ACTION_MAIN_MENU_CONFIG_TYPE_SPECIALITY',
            'ACTION_MAIN_MENU_CONFIG_VIA': 'ACTION_MAIN_MENU_CONFIG_VIA',
            'ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS': 'ACTION_MAIN_MENU_CONFIG_TYPE_MARITAL_STATUS',
            'ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS':'ACTION_MAIN_MENU_CONFIG_TYPE_FOOD_DIETS',
            'ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION':'ACTION_MAIN_MENU_CONFIG_GLUCOSE_INTERVENTION',
            'ACTION_MAIN_MENU_CONFIG_FACILITY_PHONE_NUMBER':'ACTION_MAIN_MENU_CONFIG_FACILITY_PHONE_NUMBER',
            'ACTION_MAIN_MENU_CONFIG_GREETING': 'ACTION_MAIN_MENU_CONFIG_GREETING',
            'ACTION_MAIN_MENU_CONFIG_MESSAGE_HISTORY':'ACTION_MAIN_MENU_CONFIG_MESSAGE_HISTORY',
            'ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE': 'ACTION_MAIN_MENU_CONFIG_VERIFYTX_SCHEDULE',
            'ACTION_MAIN_MENU_CONFIG_FAX_NUMBER':'ACTION_MAIN_MENU_CONFIG_FAX_NUMBER',
            'ACTION_MAIN_MENU_CONFIG_ROUTE':'ACTION_MAIN_MENU_CONFIG_ROUTE',
            'ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY': 'ACTION_MAIN_MENU_CONFIG_CONTACTS_FACILITY',
            'ACTION_MAIN_MENU_CONFIG_DOSE_FORM': 'ACTION_MAIN_MENU_CONFIG_DOSE_FORM',
            'ACTION_MAIN_MENU_CONFIG_CHART_BLOCKED': 'ACTION_MAIN_MENU_CONFIG_CHART_BLOCKED',
            'ACTION_MAIN_MENU_CONFIG_AUTO_FAX': 'ACTION_MAIN_MENU_CONFIG_AUTO_FAX',
            'ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE': 'ACTION_MAIN_MENU_CONFIG_APPOINTMENT_TYPE',
            'ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON': 'ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON',
            'ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN': 'ACTION_MAIN_MENU_CONFIG_COVID_PHYSICIAN',
            'ACTION_MAIN_MENU_CONFIG_COVID_ICD10': 'ACTION_MAIN_MENU_CONFIG_COVID_ICD10',
            'ACTION_MAIN_MENU_CONFIG_COVID_QUESTION': 'ACTION_MAIN_MENU_CONFIG_COVID_QUESTION',
            'ACTION_MAIN_MENU_CONFIG_COVID_FACILITY': 'ACTION_MAIN_MENU_CONFIG_COVID_FACILITY',
            'ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB': 'ACTION_MAIN_MENU_CONFIG_COVID_FACILITY_LAB',
            'ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM': 'ACTION_MAIN_MENU_CONFIG_COVID_LAB_COMPENDIUM',
            'ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP':'ACTION_MAIN_MENU_CONFIG_PROTOCOL_GROUP',
            'ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT':'ACTION_MAIN_MENU_CONFIG_INCIDENT_DEPARTMENT',
            'ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY': 'ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY',
            'ACTION_MAIN_MENU_CONFIG_PORT': 'ACTION_MAIN_MENU_CONFIG_PORT',
            'ACTION_MAIN_MENU_CONFIG_VESSEL': 'ACTION_MAIN_MENU_CONFIG_VESSEL',
            'ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS': 'ACTION_MAIN_MENU_CONFIG_EVALUATION_TEMPLATE_MARS_MORS',
            //  jhipster-needle-actions-constants
            //Crm.
            'ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN': 'ACTION_MAIN_MENU_CONFIG_CRM_CAMPAIGN',
            'ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS': 'ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY_STATUS',
            'ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT': 'ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_CONTACT',
            'ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY': 'ACTION_MAIN_MENU_CONFIG_CRM_OPPORTUNITY',
            'ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL': 'ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL',
            'ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS': 'ACTION_MAIN_MENU_CONFIG_CRM_OUTBOUND_REFERRAL_STATUS',
            'ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE': 'ACTION_MAIN_MENU_CONFIG_CRM_REFERRAL_SOURCE',
            'ACTION_MAIN_MENU_CONFIG_CRM_TAG': 'ACTION_MAIN_MENU_CONFIG_CRM_TAG',
            'ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF': 'ACTION_MAIN_MENU_CONFIG_INST_CLAIM_CONF',
            'ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF': 'ACTION_MAIN_MENU_CONFIG_PRO_CLAIM_CONF',

            'ACTION_PATIENT_LIST': 'ACTION_PATIENT_LIST',
            'ACTION_PATIENT_NEW': 'ACTION_PATIENT_NEW',
            'ACTION_PATIENT_CLOSE_CHART': 'ACTION_PATIENT_CLOSE_CHART',
            'ACTION_PATIENT_EDIT_ID': 'ACTION_PATIENT_EDIT_ID',
            'ACTION_PATIENT_EDIT_INFO': 'ACTION_PATIENT_EDIT_INFO',
            'ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS': 'ACTION_MANAGE_ROLE_RESOURCE_AND_ACTIONS',
            'ACTION_MASTER_EDIT': 'ACTION_MASTER_EDIT',
            'ACTION_MASTER_EDIT_GROUP_SESSION': 'ACTION_MASTER_EDIT_GROUP_SESSION',
            'ACTION_PATIENT_INSURANCE_VIEW': 'ACTION_PATIENT_INSURANCE_VIEW',
            'ACTION_PATIENT_CONTACTS_VIEW': 'ACTION_PATIENT_CONTACTS_VIEW',
            'ACTION_PATIENT_CARE_TEAM_VIEW': 'ACTION_PATIENT_CARE_TEAM_VIEW',
            'ACTION_PATIENT_CARE_COORDINATION_VIEW': 'ACTION_PATIENT_CARE_COORDINATION_VIEW',
            'ACTION_PATIENT_ALLERGIES_VIEW': 'ACTION_PATIENT_ALLERGIES_VIEW',
            'ACTION_PATIENT_DIETS_VIEW': 'ACTION_PATIENT_DIETS_VIEW',
            'ACTION_PATIENT_VITALS_VIEW': 'ACTION_PATIENT_VITALS_VIEW',
            'ACTION_PATIENT_GLUCOSE_VIEW': 'ACTION_PATIENT_GLUCOSE_VIEW',
            'ACTION_PATIENT_WEIGHT_VIEW': 'ACTION_PATIENT_WEIGHT_VIEW',
            'ACTION_PATIENT_ALCOHOL_VIEW': 'ACTION_PATIENT_ALCOHOL_VIEW',
            'ACTION_PATIENT_DRUGS_VIEW': 'ACTION_PATIENT_DRUGS_VIEW',
            'ACTION_PATIENT_FILE_VIEW': 'ACTION_PATIENT_FILE_VIEW',
            'ACTION_PATIENT_CHART_NOTE_VIEW': 'ACTION_PATIENT_CHART_NOTE_VIEW',
            'ACTION_PATIENT_CONCURRENT_REVIEW_VIEW': 'ACTION_PATIENT_CONCURRENT_REVIEW_VIEW',
            'ACTION_PATIENT_VERIFYTX_VIEW': 'ACTION_PATIENT_VERIFYTX_VIEW',
            'ACTION_PATIENT_CHART_LEVEL_CARE_HISTORY': 'ACTION_PATIENT_CHART_LEVEL_CARE_HISTORY',
            'ACTION_PATIENT_CHART_DISCHARGE_HISTORY': 'ACTION_PATIENT_CHART_DISCHARGE_HISTORY',
            'ACTION_PATIENT_CHART_TRACK_HISTORY': 'ACTION_PATIENT_CHART_TRACK_HISTORY',
            'ACTION_PATIENT_DIAGNOSES_VIEW': 'ACTION_PATIENT_DIAGNOSES_VIEW',
            'ACTION_PATIENT_LAB_ORDERS_VIEW': 'ACTION_PATIENT_LAB_ORDERS_VIEW',
            'ACTION_PATIENT_ELABS_VIEW': 'ACTION_PATIENT_ELABS_VIEW',
            'ACTION_PATIENT_GROUP_SESSION_VIEW': 'ACTION_PATIENT_GROUP_SESSION_VIEW',
            'ACTION_PATIENT_EVALUATION_VIEW': 'ACTION_PATIENT_EVALUATION_VIEW',
            'ACTION_PATIENT_MEDICATION_VIEW': 'ACTION_PATIENT_MEDICATION_VIEW',

            'ACTION_ADD_PATIENT_ORDER_LAB_REQUISITION': 'ACTION_ADD_PATIENT_ORDER_LAB_REQUISITION',
            'ACTION_MAIN_MENU_SUPER_BILL': 'ACTION_MAIN_MENU_SUPER_BILL',
            'ACTION_MAIN_MENU_304B_PROGRAM_ELIGIBILITY': 'ACTION_MAIN_MENU_304B_PROGRAM_ELIGIBILITY',
            'ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY': 'ACTION_MAIN_MENU_CONFIG_CORPORATION_PROGRAM_ELIGIBILITY',
            'ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY': 'ACTION_MAIN_MENU_CONFIG_FACILITY_PROGRAM_ELIGIBILITY',
            'ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY': 'ACTION_MAIN_MENU_CONFIG_MEDICATION_PROGRAM_ELIGIBILITY',
            'ACTION_MAIN_MENU_CONFIG_BIN': 'ACTION_MAIN_MENU_CONFIG_BIN',
            'ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY': 'ACTION_MAIN_MENU_CONFIG_EMPLOYEE_PROGRAM_ELIGIBILITY',
            'ACTION_MAIN_MENU_CONFIG_LABORATORY_LOGO': 'ACTION_MAIN_MENU_CONFIG_LABORATORY_LOGO',
            'ACTION_MAIN_MENU_CONFIG_FACILITY_ICD10': 'ACTION_MAIN_MENU_CONFIG_FACILITY_ICD10',
            'ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY': 'ACTION_MAIN_MENU_CONFIG_FACILITY_PHARMACY',

            'PRO_CLAIM_CONFIG': 'PRO_CLAIM_CONFIG',
            'ACTION_ADD_PATIENT_ORDER_CREATE': 'ACTION_ADD_PATIENT_ORDER_CREATE',
            'ACTION_RC_UPLOAD_CHART': 'ACTION_RC_UPLOAD_CHART',
            'ACTION_DELETE_CARE_DELIVERY': 'ACTION_DELETE_CARE_DELIVERY'
        });
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$breadcrumbProvider', 'IdleProvider', 'IDLE'];

    function stateConfig($stateProvider, $breadcrumbProvider, IdleProvider, IDLE) {

        $breadcrumbProvider.setOptions({
            prefixStateName: 'home',
            templateUrl: 'app/components/tpl/breadcrumb.tpl.html'
        });

        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'globalmessage@': {
                        templateUrl: 'app/entities/global-message/notification/global-message-notification.html',
                        controller: 'GlobalMessageNotificationController',
                        controllerAs: 'vm'
                    },
                    'headBar@': {
                        templateUrl: 'app/layouts/header/header.tpl.html',
                        controller: 'HeaderController',
                        controllerAs: 'vm'
                    },
                    'sideBar@': {
                        templateUrl: 'app/layouts/sidebar/sidebar.tpl.html',
                        controller: 'SidebarController',
                        controllerAs: 'vm'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.tpl.html',
                        controller: 'FooterController',
                        controllerAs: 'vm'
                    },
                    'controlBar@': {
                        templateUrl: 'app/layouts/controlbar/controlsidebar.tpl.html',
                        controller: 'ControlBarController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    employee: ['Employee', function (Employee) {
                        return Employee.employeeAccount().$promise;
                    }],
                    authorize: ['Auth', function (Auth) {
                        return Auth.authorize();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name,
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };

                        return currentStateData;
                    }],
                    showNewChart: ['EmployeeNewChart', '$window', function (EmployeeNewChart, $window) {
                        if ($window.outerWidth > 1150) {
                            return {value: true};
                        } else {
                            return {value: false};
                        }
                    }],
                    dymo: ['DymoLabel', function (DymoLabel) {

                        return DymoLabel.get();
                    }]
                },
            });

        IdleProvider.idle(IDLE.idle);
        IdleProvider.timeout(IDLE.timeout);
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('bluebookApp')
        .constant('VERSION', "1.0")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('APP', {
	"APP_NAME": "Bluebook",
	"APP_SUFFIX_NAME": "X",
	"APP_SHORT_NAME": "DX"
})
        .constant('TAB', {
	"BASIC_INFORMATION": 0,
	"LAB_ORDERS": 1,
	"E_LAB": 2,
	"MEDICATIONS": 3,
	"GROUP_SESSION": 4,
	"EVALUATION": 5,
	"SUPER_BILL": 6,
	"CONCURRENT_REVIEW": 15,
	"RCOPIA": 16,
	"RCOPIA_MEDICATION": 17,
	"RCOPIA_PRESCRIPTION": 18,
	"RCOPIA_SSO_LOGS": 19
})
        .constant('GROUP_SESSION_DETAIL_PROGRESS', {
	"IN_PROCESS": "InProcess",
	"PENDING_REVIEW": "PendingReview",
	"COMPLETED": "Completed"
})
        .constant('DATA', {
	"SIGNATORIES": {
		"GUARANTOR": "GUARANTOR",
		"PATIENT": "PATIENT"
	},
	"RELATIONSHIP": {
		"GUARANTOR": "Guarantor",
		"GUARANTOR_ID": 5
	}
})
        .constant('IDLE', {
	"idle": 870,
	"timeout": 30
})
        .constant('FREQUENCIES', [
	{
		"value": "Week_Days_Only",
		"text": "Week Days Only"
	},
	{
		"value": "Daily",
		"text": "Daily"
	},
	{
		"value": "Three_Days",
		"text": "Three Days"
	},
	{
		"value": "Sessions",
		"text": "Sessions"
	}
])
        .constant('SERVICES', {
	"CHART": "Chart",
	"PATIENT": "Patient"
})
        .constant('BUSINESS_ROLES', {
	"NURSE": "NURSE",
	"PHYSICIAN": "PHYSICIAN",
	"THERAPIST": "THERAPIST",
	"SIGN_DIAGNOSES": "SIGN_DIAGNOSES",
	"GROUP_SESSION_REVIWER": "GROUP_SESSION_REVIWER",
	"REVIEW_DIAGNOSES": "REVIEW_DIAGNOSES",
	"DISCONTINUE_DIAGNOSES": "DISCONTINUE_DIAGNOSES",
	"ORDER_REVIEWER": "ORDER_REVIEWER",
	"SIGN_PATIENT_RESULT": "SIGN_PATIENT_RESULT"
})
        .constant('REPORT_TYPE', {
	"BASIC_INFORMATION": "BASIC_INFORMATION",
	"FACESHEET": "FACESHEET",
	"MEDICATION_TAKE": "MEDICATION_TAKE",
	"EVALUATION": "EVALUATION",
	"BILLING": "BILLING",
	"EVALUATION_TEMPLATE_FILE": "EVALUATION_TEMPLATE_FILE",
	"GROUP_SESSION_DETAIL": "GROUP_SESSION_DETAIL",
	"PATIENT_MEDICATION": "PATIENT_MEDICATION",
	"INCIDENT_REPORT": "INCIDENT_REPORT",
	"RCOPIA_PRESCRIPTION": "RCOPIA_PRESCRIPTION",
	"RCOPIA_MEDICATION": "RCOPIA_MEDICATION"
})
        .constant('RATIONALE_TYPE', {
	"MEDICATION": "MEDICATION",
	"LABORATORY": "LABORATORY"
})
        .constant('INCIDENT_REPORT_STATUS', {
	"PENDING": "PENDING",
	"INREVIEW": "INREVIEW",
	"FINALIZED": "FINALIZED"
})
;
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            ncyBreadcrumb: {
                label : 'Metrics'
            },
            data: {
                authorities: ['ROLE_SYSTEM_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            ncyBreadcrumb: {
                label : 'Logs'
            },
            data: {
                authorities: ['ROLE_SYSTEM_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            ncyBreadcrumb: {
                label : 'Health'
            },
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('bluebookApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity-audit', {
            parent: 'admin',
            url: '/entity-audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/entity-audit/entity-audits.html',
                    controller: 'EntityAuditController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('EntityAuditService', EntityAuditService);

    EntityAuditService.$inject = ['$http'];

    function EntityAuditService ($http) {

        var service = {
            findAllAudited: findAllAudited,
            findByEntity: findByEntity,
            getPrevVersion: getPrevVersion,
            updateToNewField: updateToNewField
        };

        return service;

        function findAllAudited() {
            return $http.get('api/audits/entity/all').then(function (response) {
                return response.data;
            });
        }

        function findByEntity(entityType, limit) {
            return $http.get('api/audits/entity/changes', {
                params: {
                    entityType: entityType,
                    limit: limit
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function getPrevVersion(qualifiedName, entityId, commitVersion) {
            return $http.get('api/audits/entity/changes/version/previous', {
                params: {
                    qualifiedName: qualifiedName,
                    entityId: entityId,
                    commitVersion: commitVersion
                }
            }).then(function (response) {
                return response.data;
            });
        }

        function updateToNewField() {
            return $http.get('api/audits/update-to-new-field').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuditDetailModalCtrl', AuditDetailModalCtrl);

    AuditDetailModalCtrl.$inject = ['$scope', '$uibModalInstance', 'ObjectDiff', 'diff', 'audit'];

    function AuditDetailModalCtrl($scope, $uibModalInstance, ObjectDiff, diff, audit) {
        var vm = this;
        
        vm.diffValue = ObjectDiff.toJsonView(diff);
        vm.diffValueChanges = ObjectDiff.toJsonDiffView(diff);
        vm.audit = audit;
        vm.cancel = cancel;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        };
    };
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('EntityAuditController', EntityAuditController);

    EntityAuditController.$inject = ['$scope', '$filter', '$uibModal', 'EntityAuditService', 'AlertService', 'ObjectDiff'];

    function EntityAuditController ($scope, $filter, $uibModal, EntityAuditService, AlertService, ObjectDiff) {
        var vm = this;

        vm.entities = [];
        vm.audits = [];
        vm.limits = [25, 50, 100, 200];
        vm.limit = 25;
        vm.loading = false;
        vm.loadChanges = loadChanges;
        vm.findAllAudited = findAllAudited;
        vm.getEntityName = getEntityName;
        vm.format = format;
        vm.isObject = isObject;
        vm.isDate = isDate;
        vm.openChange = openChange;

        vm.findAllAudited();

        function findAllAudited() {
            EntityAuditService.findAllAudited().then(function (data) {
                vm.entities = data;
            });
        }

        function loadChanges() {
            vm.loading = true;
            var entityType = vm.qualifiedName;
            EntityAuditService.findByEntity(entityType, vm.limit).then(function (data) {
                vm.audits = data.map(function(it){
                    it.entityValue = JSON.parse(it.entityValue);
                    return it;
                });
                vm.loading = false;
            }, function(){
                vm.loading = false;
            });
        };

        function getEntityName(qualifiedName) {
            if (qualifiedName) {
                var splits = qualifiedName.split(".");
                return splits[splits.length - 1];
            }
            else return null;
        };

        function format(val){
            if(val)
                return ObjectDiff.objToJsonView(val);
            else return '';
        };

        function isObject(val){
            return (val && (typeof val) == 'object');
        };

        function isDate(key){
            return (key && key.indexOf("Date") != -1);
        };

        function openChange(audit){

            if(audit.commitVersion < 2){
                AlertService.warning("There is no previous version available for this entry.\nThis is the first" +
                    " audit entry captured for this object");
            } else {
                EntityAuditService.getPrevVersion(audit.entityType, audit.entityId, audit.commitVersion).then(function (data) {
                    var previousVersion = JSON.parse(data.entityValue),
                        currentVersion = audit.entityValue;
                    // enable below to have the dates formatted
                    //previousVersion = convertDates(previousVersion);
                    //currentVersion = convertDates(currentVersion);
                    var diff = ObjectDiff.diffOwnProperties(previousVersion, currentVersion);

                    $uibModal.open({
                        templateUrl: 'app/admin/entity-audit/entity-audit.detail.html',
                        controller: 'AuditDetailModalCtrl',
                        controllerAs: 'vm',
                        size: 'lg',
                        resolve: {
                            diff: function () {
                                return diff;
                            },
                            audit: function () {
                                return audit;
                            }
                        }
                    });
                });
            }
        };

        function convertDates(obj) {
            for(var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key]) {
                    if (key.indexOf("Date") != -1 && (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === '[object Date]' || (new Date(obj[key]) !== "Invalid Date" && !isNaN(new Date(obj[key]))))) {
                        obj[key] = $filter('date')(obj[key]);
                    }
                }
            }
            return obj;
        }

        vm.updateToNewField = updateToNewField;
        function updateToNewField() {
            EntityAuditService.updateToNewField().then(function (data) {
                alert(data);
            }, function(data){
                alert(data);
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_SYSTEM_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_SYSTEM_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'md'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            ncyBreadcrumb: {
                label : 'Configuration'
            },
            data: {
                authorities: ['ROLE_SYSTEM_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter, JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            ncyBreadcrumb: {
                label: 'Audits'
            },
            data: {
                authorities: [ROLES.ROLE_USER],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SignatureChangeDialogController', SignatureChangeDialogController);

    SignatureChangeDialogController.$inject = ['$uibModalInstance', 'Employee'];

    function SignatureChangeDialogController($uibModalInstance, Employee) {
        var vm = this;

        vm.signature = "";

        vm.clear = clear;
        vm.replaceSignature = replaceSignature;

        vm.signatureOpts = {
            width: 620,
            height: 250,
            cssClass: 'signature-canvas',
            color: '#00008B',
            'background-color': '#fff'
        };

        function replaceSignature () {
            vm.isSaving = true;

            Employee.replaceSignature({signature: vm.signature}, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            ncyBreadcrumb: {
                label: 'Settings'
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PasswordChangeDialogController', PasswordChangeDialogController);

    PasswordChangeDialogController.$inject = ['$uibModalInstance', 'Auth', 'Principal'];

    function PasswordChangeDialogController($uibModalInstance, Auth, Principal) {
        var vm = this;


        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        vm.changePassword = changePassword;
        vm.clear = clear;

        Principal.identity().then(function(account){
           vm.account = account;
        });

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            ncyBreadcrumb: {
                label: 'Password'
            },
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app',
            ncyBreadcrumb: {
                label: 'Account'
            }
        });
    }
})();
(function(){angular.module('bluebookApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/dashboard2/dashboard.html','<section class="content"><!-- Jesus Code --><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 jr-dashboard"><div class="jr-card critical-results"><div ui-view="critical-results"></div></div><div class="jr-card abnormal-results"><div ui-view="abnormal-result"></div></div><div class="jr-card partial-results"><div ui-view="partial-result"></div></div><div class="jr-card unassigned-results"><div ui-view="unassigned-results"></div></div><div class="jr-card patient-requisition"><div ui-view="print-requisition"></div></div><div class="jr-card concurrent-reviews"><div ui-view="concurrent-reviews"></div></div><div class="jr-card late-care-delivery"><div ui-view="late-care-delivery"></div></div><div class="jr-card stay"><div ui-view="stay"></div></div><div class="jr-card empty-care-delivery"><div ui-view="empty-care-delivery-patient"></div></div><div class="jr-card care-delivery-pending-patient"><div ui-view="pending-by-patients"></div></div><div class="jr-card care-delivery-pending-staff"><div ui-view="pending-by-staff"></div></div><div class="jr-card care-delivery-pending-review"><div ui-view="pending-by-staff-review"></div></div><!--<div class="jr-card mars-mors">--><!--<div ui-view="mars-mors"></div>--><!--</div>--><div class="jr-card payer-mix"><div ui-view="payer-mix"></div></div><div class="jr-card chart-alerts"><div ui-view="chart-review"></div></div><!--\n            <div class="jr-card physician-review">\n                <div ui-view="physician-review"></div>\n            </div>\n            --><div class="jr-card discharge-type"><div ui-view="discharge-type"></div></div><!--\n            <div class="jr-card incident-reports">\n                <div ui-view="incident-report"></div>\n            </div>\n            --><div class="jr-card level-cares"><div ui-view="level-care"></div></div><div class="jr-card incoming-patients"><div ui-view="incoming-patients"></div></div><div class="jr-card discharging-patients"><div ui-view="discharging-patients"></div></div><div class="jr-card marketers"><div ui-view="marketers"></div></div><div class="jr-card referral-source"><div ui-view="referral-source"></div></div><div class="jr-card case-load"><div ui-view="case-load"></div></div><div class="jr-card beds"><div ui-view="beds"></div></div></div></div><!-- /Jesus Code --></section>');
$templateCache.put('app/home/home.html','');
$templateCache.put('app/layouts/content.tpl.html','<!-- Content Wrapper. Contains page content --><div class="content-wrapper"><!-- Content Header (Page header) --><section class="content-header"><h1>Dashboard <small>version 1.0</small></h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><!-- Info boxes --><div class="row"><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-aqua"><i class="ion ion-ios-gear-outline"></i></span><div class="info-box-content"><span class="info-box-text">Billed units</span> <span class="info-box-number">90<small></small></span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-red"><i class="fa fa-google-plus"></i></span><div class="info-box-content"><span class="info-box-text">Worked Patients</span> <span class="info-box-number">41,410</span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --><!-- fix for small devices only --><div class="clearfix visible-sm-block"></div><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-green"><i class="ion ion-ios-cart-outline"></i></span><div class="info-box-content"><span class="info-box-text">Sales</span> <span class="info-box-number">760</span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --><div class="col-md-3 col-sm-6 col-xs-12"><div class="info-box"><span class="info-box-icon bg-yellow"><i class="ion ion-ios-people-outline"></i></span><div class="info-box-content"><span class="info-box-text">New Members</span> <span class="info-box-number">2,000</span></div><!-- /.info-box-content --></div><!-- /.info-box --></div><!-- /.col --></div><!-- /.row --><div class="row"><div class="col-md-12"><div class="box"><div class="box-header with-border"><h3 class="box-title">Monthly Recap Report</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button><div class="btn-group"><button type="button" class="btn btn-box-tool dropdown-toggle" data-toggle="dropdown"><i class="fa fa-wrench"></i></button><ul class="dropdown-menu" role="menu"><li><a href="#">Action</a></li><li><a href="#">Another action</a></li><li><a href="#">Something else here</a></li><li class="divider"></li><li><a href="#">Separated link</a></li></ul></div><button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><div class="row"><div class="col-md-8"><p class="text-center"><strong>Sales: 1 Jan, 2014 - 30 Jul, 2014</strong></p><div class="chart"><!-- Sales Chart Canvas --><canvas id="salesChart" style="height: 177px; width: 651px;" width="651" height="177"></canvas></div><!-- /.chart-responsive --></div><!-- /.col --><div class="col-md-4"><p class="text-center"><strong>Goal Completion</strong></p><div class="progress-group"><span class="progress-text">Add Products to Cart</span> <span class="progress-number"><b>160</b>/200</span><div class="progress sm"><div class="progress-bar progress-bar-aqua" style="width: 80%"></div></div></div><!-- /.progress-group --><div class="progress-group"><span class="progress-text">Complete Purchase</span> <span class="progress-number"><b>310</b>/400</span><div class="progress sm"><div class="progress-bar progress-bar-red" style="width: 80%"></div></div></div><!-- /.progress-group --><div class="progress-group"><span class="progress-text">Visit Premium Page</span> <span class="progress-number"><b>480</b>/800</span><div class="progress sm"><div class="progress-bar progress-bar-green" style="width: 80%"></div></div></div><!-- /.progress-group --><div class="progress-group"><span class="progress-text">Send Inquiries</span> <span class="progress-number"><b>250</b>/500</span><div class="progress sm"><div class="progress-bar progress-bar-yellow" style="width: 80%"></div></div></div><!-- /.progress-group --></div><!-- /.col --></div><!-- /.row --></div><!-- ./box-body --><div class="box-footer"><div class="row"><div class="col-sm-3 col-xs-6"><div class="description-block border-right"><span class="description-percentage text-green"><i class="fa fa-caret-up"></i> 17%</span><h5 class="description-header">$35,210.43</h5><span class="description-text">TOTAL REVENUE</span></div><!-- /.description-block --></div><!-- /.col --><div class="col-sm-3 col-xs-6"><div class="description-block border-right"><span class="description-percentage text-yellow"><i class="fa fa-caret-left"></i> 0%</span><h5 class="description-header">$10,390.90</h5><span class="description-text">TOTAL COST</span></div><!-- /.description-block --></div><!-- /.col --><div class="col-sm-3 col-xs-6"><div class="description-block border-right"><span class="description-percentage text-green"><i class="fa fa-caret-up"></i> 20%</span><h5 class="description-header">$24,813.53</h5><span class="description-text">TOTAL PROFIT</span></div><!-- /.description-block --></div><!-- /.col --><div class="col-sm-3 col-xs-6"><div class="description-block"><span class="description-percentage text-red"><i class="fa fa-caret-down"></i> 18%</span><h5 class="description-header">1200</h5><span class="description-text">GOAL COMPLETIONS</span></div><!-- /.description-block --></div></div><!-- /.row --></div><!-- /.box-footer --></div><!-- /.box --></div><!-- /.col --></div><!-- /.row --><!-- Main row --><div class="row"><!-- Left col --><div class="col-md-8"><!-- MAP & BOX PANE --><div class="box box-success"><div class="box-header with-border"><h3 class="box-title">Visitors Report</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body no-padding"><div class="row"><div class="col-md-9 col-sm-8"><div class="pad"><!-- Map will be created here --><div id="world-map-markers" style="height: 325px;"><div class="jvectormap-container" style="width: 100%; height: 100%; position: relative; overflow: hidden; background-color: transparent;"><svg width="471" height="325"><g transform="scale(0.5233333333333333) translate(0, 90.15639876806087)"><path d="M652.71,228.85l-0.04,1.38l-0.46,-0.21l-0.42,0.3l0.05,0.65l-0.17,-1.37l-0.48,-1.26l-1.08,-1.6l-0.23,-0.13l-2.31,-0.11l-0.31,0.36l0.21,0.98l-0.6,1.11l-0.8,-0.4l-0.37,0.09l-0.23,0.3l-0.54,-0.21l-0.78,-0.19l-0.38,-2.04l-0.83,-1.89l0.4,-1.5l-0.16,-0.35l-1.24,-0.57l0.36,-0.62l1.5,-0.95l0.02,-0.49l-1.62,-1.26l0.64,-1.31l1.7,1.0l0.12,0.04l0.96,0.11l0.19,1.62l0.25,0.26l2.38,0.37l2.32,-0.04l1.06,0.33l-0.92,1.79l-0.97,0.13l-0.23,0.16l-0.77,1.51l0.05,0.35l1.37,1.37l0.5,-0.14l0.35,-1.46l0.24,-0.0l1.24,3.92Z" data-code="BD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M429.28,143.95l1.76,0.25l0.13,-0.01l2.16,-0.64l1.46,1.34l1.26,0.71l-0.23,1.8l-0.44,0.08l-0.24,0.25l-0.2,1.36l-1.8,-1.22l-0.23,-0.05l-1.14,0.23l-1.62,-1.43l-1.15,-1.31l-0.21,-0.1l-0.95,-0.04l-0.21,-0.68l1.66,-0.54Z" data-code="BE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M413.48,260.21l-1.22,-0.46l-0.13,-0.02l-1.17,0.1l-0.15,0.06l-0.73,0.53l-0.87,-0.41l-0.39,-0.75l-0.13,-0.13l-0.98,-0.48l-0.14,-1.2l0.63,-0.99l0.05,-0.18l-0.05,-0.73l1.9,-2.01l0.08,-0.14l0.35,-1.65l0.49,-0.44l1.05,0.3l0.21,-0.02l1.05,-0.52l0.13,-0.13l0.3,-0.58l1.87,-1.1l0.11,-0.1l0.43,-0.72l2.23,-1.01l1.21,-0.32l0.51,0.4l0.19,0.06l1.25,-0.01l-0.14,0.89l0.01,0.13l0.34,1.16l0.06,0.11l1.35,1.59l0.07,1.13l0.24,0.28l2.64,0.53l-0.05,1.39l-0.42,0.59l-1.11,0.21l-0.22,0.17l-0.46,0.99l-0.69,0.23l-2.12,-0.05l-1.14,-0.2l-0.19,0.03l-0.72,0.36l-1.07,-0.17l-4.35,0.12l-0.29,0.29l-0.06,1.44l0.25,1.45Z" data-code="BF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M477.63,166.84l0.51,0.9l0.33,0.14l0.9,-0.21l1.91,0.47l3.68,0.16l0.17,-0.05l1.2,-0.75l2.78,-0.67l1.72,1.05l1.02,0.24l-0.97,0.97l-0.91,2.17l0.0,0.24l0.56,1.19l-1.58,-0.3l-0.16,0.01l-2.55,0.95l-0.2,0.28l-0.02,1.23l-1.92,0.24l-1.68,-0.99l-0.27,-0.02l-1.94,0.8l-1.52,-0.07l-0.15,-1.72l-0.12,-0.21l-0.99,-0.76l0.18,-0.18l0.02,-0.39l-0.17,-0.22l0.33,-0.75l0.91,-0.91l0.01,-0.42l-1.16,-1.25l-0.18,-0.89l0.24,-0.27Z" data-code="BG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M468.39,164.66l0.16,0.04l0.43,-0.0l-0.43,0.93l0.06,0.34l1.08,1.06l-0.28,1.09l-0.5,0.13l-0.47,0.28l-0.86,0.74l-0.1,0.16l-0.28,1.29l-1.81,-0.94l-0.9,-1.22l-1.0,-0.73l-1.1,-1.1l-0.55,-0.96l-1.11,-1.3l0.3,-0.75l0.59,0.46l0.42,-0.04l0.46,-0.54l1.0,-0.06l2.11,0.5l1.72,-0.03l1.06,0.64Z" data-code="BA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M707.34,273.57l0.76,-0.72l1.59,-1.03l-0.18,1.93l-0.9,-0.06l-0.28,0.14l-0.31,0.51l-0.68,-0.78Z" data-code="BN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M263.83,340.79l-0.23,-0.12l-2.86,-0.11l-0.28,0.17l-0.77,1.67l-1.17,-1.51l-0.18,-0.11l-3.28,-0.64l-0.28,0.1l-2.02,2.3l-1.43,0.29l-0.91,-3.35l-1.31,-2.88l0.75,-2.41l-0.09,-0.32l-1.23,-1.03l-0.31,-1.76l-0.05,-0.12l-1.12,-1.6l1.49,-2.62l0.01,-0.28l-1.0,-2.0l0.48,-0.72l0.02,-0.29l-0.37,-0.78l0.87,-1.13l0.06,-0.18l0.05,-2.17l0.12,-1.71l0.5,-0.8l0.01,-0.3l-1.9,-3.58l1.3,0.15l1.34,-0.05l0.23,-0.12l0.51,-0.7l2.12,-0.99l1.31,-0.93l2.81,-0.37l-0.21,1.51l0.01,0.13l0.29,0.91l-0.19,1.64l0.11,0.27l2.72,2.27l0.15,0.07l2.71,0.41l0.92,0.88l0.12,0.07l1.64,0.49l1.0,0.71l0.18,0.06l1.5,-0.02l1.24,0.64l0.1,1.31l0.05,0.14l0.44,0.68l0.02,0.73l-0.44,0.03l-0.27,0.39l0.96,2.99l0.28,0.21l4.43,0.1l-0.28,1.12l0.0,0.15l0.27,1.02l0.15,0.19l1.27,0.67l0.52,1.42l-0.42,1.91l-0.66,1.1l-0.04,0.2l0.21,1.3l-0.19,0.13l-0.01,-0.27l-0.15,-0.24l-2.33,-1.33l-0.14,-0.04l-2.38,-0.03l-4.36,0.76l-0.21,0.16l-1.2,2.29l-0.03,0.13l-0.06,1.37l-0.79,2.53l-0.05,-0.08Z" data-code="BO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M781.17,166.78l1.8,0.67l0.28,-0.04l1.38,-1.01l0.43,2.67l-3.44,0.77l-0.18,0.12l-2.04,2.79l-3.71,-1.94l-0.42,0.15l-1.29,3.11l-2.32,0.04l-0.3,-2.63l1.12,-2.1l2.51,-0.16l0.28,-0.25l0.73,-4.22l0.58,-1.9l2.59,2.84l2.0,1.1ZM773.66,187.36l-0.92,2.24l-0.01,0.2l0.4,1.3l-1.18,1.81l-3.06,1.28l-4.35,0.17l-0.19,0.08l-3.4,3.06l-1.36,-0.87l-0.1,-1.95l-0.34,-0.28l-4.35,0.62l-2.99,1.33l-2.87,0.05l-0.28,0.2l0.09,0.33l2.37,1.93l-1.57,4.44l-1.35,0.97l-0.9,-0.79l0.57,-2.32l-0.15,-0.34l-1.5,-0.77l-0.81,-1.53l2.04,-0.75l0.14,-0.1l1.28,-1.72l2.47,-1.43l1.84,-1.92l4.83,-0.82l2.62,0.57l0.33,-0.16l2.45,-4.77l1.38,1.14l0.38,0.0l5.1,-4.02l0.09,-0.11l1.57,-3.57l0.02,-0.16l-0.42,-3.22l0.94,-1.67l2.27,-0.47l1.26,3.82l-0.07,2.23l-2.26,2.86l-0.06,0.19l0.04,2.93ZM757.85,196.18l0.22,0.66l-1.11,1.33l-0.8,-0.7l-0.33,-0.04l-1.28,0.65l-0.14,0.15l-0.54,1.34l-1.17,-0.57l0.02,-1.03l1.2,-1.45l1.24,0.28l0.29,-0.1l0.9,-1.03l1.51,0.5Z" data-code="JP" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M494.7,295.83l-0.14,-2.71l-0.04,-0.13l-0.34,-0.62l0.93,0.12l0.3,-0.16l0.67,-1.25l0.9,0.11l0.11,0.76l0.08,0.16l0.46,0.48l0.02,0.56l-0.55,0.48l-0.96,1.29l-0.82,0.82l-0.61,0.07Z" data-code="BI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M427.4,268.94l-1.58,0.22l-0.52,-1.45l0.11,-5.73l-0.08,-0.21l-0.43,-0.44l-0.09,-1.13l-0.09,-0.19l-1.52,-1.52l0.24,-1.01l0.7,-0.23l0.18,-0.16l0.45,-0.97l1.07,-0.21l0.19,-0.12l0.53,-0.73l0.73,-0.65l0.68,-0.0l1.69,1.3l-0.08,0.67l0.02,0.14l0.52,1.38l-0.44,0.9l-0.01,0.24l0.2,0.52l-1.1,1.42l-0.76,0.76l-0.08,0.13l-0.47,1.59l0.05,1.69l-0.13,3.79Z" data-code="BJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M650.38,213.78l0.88,0.75l-0.13,1.24l-1.77,0.07l-2.1,-0.18l-1.57,0.4l-2.02,-0.91l-0.02,-0.24l1.54,-1.87l1.18,-0.6l1.67,0.59l1.32,0.08l1.01,0.67Z" data-code="BT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M226.67,238.37l1.64,0.23l1.2,0.56l0.11,0.19l-1.25,0.03l-0.14,0.04l-0.65,0.37l-1.24,-0.37l-1.17,-0.77l0.11,-0.22l0.86,-0.15l0.52,0.08Z" data-code="JM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M484.91,331.96l0.53,0.52l0.82,1.53l2.83,2.86l0.14,0.08l0.85,0.22l0.03,0.81l0.74,1.66l0.21,0.17l1.87,0.39l1.17,0.87l-3.13,1.71l-2.3,2.01l-0.07,0.1l-0.82,1.74l-0.66,0.88l-1.24,0.19l-0.24,0.2l-0.65,1.98l-1.4,0.55l-1.9,-0.12l-1.2,-0.74l-1.06,-0.32l-0.22,0.02l-1.22,0.62l-0.14,0.14l-0.58,1.21l-1.16,0.79l-1.18,1.13l-1.5,0.23l-0.4,-0.68l0.22,-1.53l-0.04,-0.19l-1.48,-2.54l-0.11,-0.11l-0.53,-0.31l-0.0,-7.25l2.18,-0.08l0.29,-0.3l0.07,-9.0l1.63,-0.08l3.69,-0.86l0.84,0.93l0.38,0.05l1.53,-0.97l0.79,-0.03l1.3,-0.53l0.23,0.1l0.92,1.96Z" data-code="BW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M259.49,274.87l1.42,0.25l1.97,0.62l0.28,-0.05l0.67,-0.55l1.76,-0.38l2.8,-0.94l0.12,-0.08l0.92,-0.96l0.05,-0.33l-0.15,-0.32l0.73,-0.06l0.36,0.35l-0.27,0.93l0.17,0.36l0.76,0.34l0.44,0.9l-0.58,0.73l-0.06,0.13l-0.4,2.13l0.03,0.19l0.62,1.22l0.17,1.11l0.11,0.19l1.54,1.18l0.15,0.06l1.23,0.12l0.29,-0.15l0.2,-0.36l0.71,-0.11l1.13,-0.44l0.79,-0.63l1.25,0.19l0.65,-0.08l1.32,0.2l0.32,-0.18l0.23,-0.51l-0.05,-0.31l-0.31,-0.37l0.11,-0.31l0.75,0.17l0.13,0.0l1.1,-0.24l1.34,0.5l1.08,0.51l0.33,-0.05l0.67,-0.58l0.27,0.05l0.28,0.57l0.31,0.17l1.2,-0.18l0.17,-0.08l1.03,-1.05l0.76,-1.82l1.39,-2.16l0.49,-0.07l0.52,1.17l1.4,4.37l0.2,0.2l1.14,0.35l0.05,1.39l-1.8,1.97l0.01,0.42l0.78,0.75l0.18,0.08l4.16,0.37l0.08,2.25l0.5,0.22l1.78,-1.54l2.98,0.85l4.07,1.5l1.07,1.28l-0.37,1.23l0.36,0.38l2.83,-0.75l4.8,1.3l3.75,-0.09l3.6,2.02l3.27,2.84l1.93,0.72l2.13,0.11l0.76,0.66l1.22,4.56l-0.96,4.03l-1.22,1.58l-3.52,3.51l-1.63,2.91l-1.75,2.09l-0.5,0.04l-0.26,0.19l-0.72,1.99l0.18,4.76l-0.95,5.56l-0.74,0.96l-0.06,0.15l-0.43,3.39l-2.49,3.34l-0.06,0.13l-0.4,2.56l-1.9,1.07l-0.13,0.16l-0.51,1.38l-2.59,0.0l-3.94,1.01l-1.82,1.19l-2.85,0.81l-3.01,2.17l-2.12,2.65l-0.06,0.13l-0.36,2.0l0.01,0.13l0.4,1.42l-0.45,2.63l-0.53,1.23l-1.76,1.53l-2.76,4.79l-2.16,2.15l-1.69,1.29l-0.09,0.12l-1.12,2.6l-1.3,1.26l-0.45,-1.02l0.99,-1.18l0.01,-0.37l-1.5,-1.95l-1.98,-1.54l-2.58,-1.77l-0.2,-0.05l-0.81,0.07l-2.42,-2.05l-0.25,-0.07l-0.77,0.14l2.75,-3.07l2.8,-2.61l1.67,-1.09l2.11,-1.49l0.13,-0.24l0.05,-2.15l-0.07,-0.2l-1.26,-1.54l-0.35,-0.09l-0.64,0.27l0.3,-0.95l0.34,-1.57l0.01,-1.52l-0.16,-0.26l-0.9,-0.48l-0.27,-0.01l-0.86,0.39l-0.65,-0.08l-0.23,-0.8l-0.23,-2.39l-0.04,-0.12l-0.47,-0.79l-0.14,-0.12l-1.69,-0.71l-0.25,0.01l-0.93,0.47l-2.29,-0.44l0.15,-3.3l-0.03,-0.15l-0.62,-1.22l0.57,-0.39l0.13,-0.3l-0.22,-1.37l0.67,-1.13l0.44,-2.04l-0.01,-0.17l-0.59,-1.61l-0.14,-0.16l-1.25,-0.66l-0.22,-0.82l0.35,-1.41l-0.28,-0.37l-4.59,-0.1l-0.78,-2.41l0.34,-0.02l0.28,-0.31l-0.03,-1.1l-0.05,-0.16l-0.45,-0.68l-0.1,-1.4l-0.16,-0.24l-1.45,-0.76l-0.14,-0.03l-1.48,0.02l-1.04,-0.73l-1.62,-0.48l-0.93,-0.9l-0.16,-0.08l-2.72,-0.41l-2.53,-2.12l0.18,-1.54l-0.01,-0.13l-0.29,-0.91l0.26,-1.83l-0.34,-0.34l-3.28,0.43l-0.14,0.05l-1.3,0.93l-2.16,1.01l-0.12,0.09l-0.47,0.65l-1.12,0.05l-1.84,-0.21l-0.12,0.01l-1.33,0.41l-0.82,-0.21l0.16,-3.6l-0.48,-0.26l-1.97,1.43l-1.96,-0.06l-0.86,-1.23l-0.22,-0.13l-1.23,-0.11l0.34,-0.69l-0.05,-0.33l-1.36,-1.5l-0.92,-2.0l0.45,-0.32l0.13,-0.25l-0.0,-0.87l1.34,-0.64l0.17,-0.32l-0.23,-1.23l0.56,-0.77l0.05,-0.13l0.16,-1.03l2.7,-1.61l2.01,-0.47l0.16,-0.09l0.24,-0.27l2.11,0.11l0.31,-0.25l1.13,-6.87l0.06,-1.12l-0.4,-1.53l-0.1,-0.15l-1.0,-0.82l0.01,-1.45l1.08,-0.32l0.39,0.2l0.44,-0.24l0.08,-0.96l-0.25,-0.32l-1.22,-0.22l-0.02,-1.01l4.57,0.05l0.22,-0.09l0.6,-0.63l0.44,0.5l0.47,1.42l0.45,0.16l0.27,-0.18l1.21,1.16l0.23,0.08l1.95,-0.16l0.23,-0.14l0.43,-0.67l1.76,-0.55l1.05,-0.42l0.18,-0.2l0.25,-0.92l1.65,-0.66l0.18,-0.35l-0.14,-0.53l-0.26,-0.22l-1.91,-0.19l-0.29,-1.33l0.1,-1.64l-0.15,-0.28l-0.44,-0.25Z" data-code="BR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M227.51,216.69l0.3,0.18l-0.24,1.07l0.03,-1.04l-0.09,-0.21ZM226.5,224.03l-0.13,0.03l-0.54,-1.3l-0.09,-0.12l-0.78,-0.64l0.4,-1.26l0.33,0.05l0.79,2.0l0.01,1.24ZM225.76,216.5l-2.16,0.34l-0.07,-0.41l0.85,-0.16l1.36,0.07l0.02,0.16Z" data-code="BS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M480.08,135.28l2.09,0.02l0.13,-0.03l2.72,-1.3l0.16,-0.19l0.55,-1.83l1.94,-1.06l0.15,-0.31l-0.2,-1.33l1.33,-0.52l2.58,-1.3l2.39,0.8l0.3,0.75l0.37,0.17l1.22,-0.39l2.18,0.75l0.2,1.36l-0.48,0.85l0.01,0.32l1.57,2.26l0.92,0.6l-0.1,0.41l0.19,0.35l1.61,0.57l0.48,0.6l-0.64,0.49l-1.91,-0.11l-0.18,0.05l-0.48,0.32l-0.1,0.39l0.57,1.1l0.51,1.78l-1.79,0.17l-0.18,0.08l-0.77,0.73l-0.09,0.19l-0.13,1.31l-0.75,-0.22l-2.11,0.15l-0.56,-0.66l-0.39,-0.06l-0.8,0.49l-0.79,-0.4l-0.13,-0.03l-1.94,-0.07l-2.76,-0.79l-2.58,-0.27l-1.98,0.07l-0.15,0.05l-1.31,0.86l-0.8,0.09l-0.04,-1.16l-0.03,-0.12l-0.63,-1.28l1.22,-0.56l0.17,-0.27l0.01,-1.35l-0.04,-0.15l-0.66,-1.24l-0.08,-1.12Z" data-code="BY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M198.03,239.7l0.28,0.19l0.43,-0.1l0.82,-1.42l0.0,0.07l0.29,0.29l0.16,0.0l-0.02,0.35l-0.39,1.08l0.02,0.25l0.16,0.29l-0.23,0.8l0.04,0.24l0.09,0.14l-0.25,1.12l-0.38,0.53l-0.33,0.06l-0.21,0.15l-0.41,0.74l-0.25,0.0l0.17,-2.58l0.01,-2.2Z" data-code="BZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M688.57,38.85l0.63,2.39l0.44,0.19l2.22,-1.23l7.18,0.07l5.54,2.49l1.85,1.77l-0.55,2.34l-2.64,1.42l-6.57,2.76l-1.95,1.5l0.12,0.53l3.09,0.68l3.69,1.23l0.21,-0.01l1.98,-0.81l1.16,2.84l0.5,0.08l1.03,-1.18l3.86,-0.74l7.79,0.78l0.56,2.05l0.27,0.22l10.47,0.71l0.32,-0.29l0.13,-3.34l4.98,0.8l3.96,-0.02l3.88,2.43l1.06,2.79l-1.38,1.83l0.01,0.38l3.15,3.64l0.1,0.08l3.94,1.86l0.4,-0.14l2.28,-4.56l3.75,1.94l0.22,0.02l4.18,-1.22l4.76,1.4l0.26,-0.04l1.74,-1.23l3.98,0.63l0.32,-0.41l-1.71,-4.1l3.0,-1.86l22.39,3.04l2.06,2.67l0.1,0.08l6.55,3.51l0.17,0.03l10.08,-0.86l4.86,0.73l1.91,1.72l-0.29,3.13l0.18,0.31l3.08,1.26l0.19,0.01l3.32,-0.9l4.37,-0.11l4.78,0.87l4.61,-0.48l4.26,3.82l0.32,0.05l3.1,-1.4l0.12,-0.45l-1.91,-2.67l0.92,-1.64l7.78,1.22l5.22,-0.26l7.12,2.1l9.6,5.22l6.4,4.15l-0.2,2.44l0.14,0.28l1.69,1.04l0.45,-0.31l-0.51,-2.66l6.31,0.58l4.52,3.61l-2.1,1.52l-4.02,0.42l-0.27,0.29l-0.06,3.83l-0.81,0.67l-2.14,-0.11l-1.91,-1.39l-3.19,-1.13l-0.51,-1.63l-0.21,-0.2l-2.54,-0.67l-0.13,-0.0l-2.69,0.5l-1.12,-1.19l0.48,-1.36l-0.38,-0.39l-3.0,0.98l-0.17,0.44l1.02,1.76l-1.27,1.55l-3.09,1.71l-3.15,-0.29l-0.3,0.18l0.07,0.34l2.22,2.1l1.47,3.22l1.15,1.09l0.25,1.41l-0.48,0.76l-4.47,-0.81l-0.17,0.02l-6.97,2.9l-2.2,0.44l-0.11,0.05l-3.83,2.68l-3.63,2.32l-0.1,0.11l-0.76,1.4l-3.3,-2.4l-0.3,-0.03l-6.31,2.85l-0.99,-1.21l-0.4,-0.06l-2.32,1.54l-3.23,-0.49l-0.33,0.2l-0.79,2.39l-2.97,3.51l-0.07,0.21l0.09,1.47l0.22,0.27l2.62,0.74l-0.3,4.7l-2.06,0.12l-0.26,0.2l-1.07,2.94l0.04,0.27l0.83,1.19l-4.03,1.63l-0.18,0.21l-0.83,3.72l-3.55,0.79l-0.23,0.23l-0.73,3.32l-3.22,2.76l-0.76,-1.88l-1.07,-4.88l-1.39,-7.59l1.17,-4.76l2.05,-2.08l0.09,-0.19l0.11,-1.46l3.67,-0.77l0.15,-0.08l4.47,-4.61l4.29,-3.82l4.48,-3.01l0.11,-0.14l2.01,-5.43l-0.31,-0.4l-3.04,0.33l-0.24,0.17l-1.47,3.11l-5.98,3.94l-1.91,-4.36l-0.33,-0.17l-6.46,1.3l-0.15,0.08l-6.27,6.33l-0.01,0.41l1.7,1.87l-5.04,0.87l-3.51,0.34l0.16,-2.32l-0.26,-0.32l-3.89,-0.56l-0.19,0.04l-3.02,1.77l-7.63,-0.63l-8.24,1.1l-0.16,0.07l-8.11,7.09l-9.6,8.31l0.16,0.52l3.79,0.42l1.16,2.03l0.17,0.14l2.43,0.76l0.31,-0.08l1.5,-1.61l2.49,0.2l3.46,3.6l0.08,2.67l-1.91,3.26l-0.04,0.14l-0.21,3.91l-1.11,5.09l-3.73,4.55l-0.87,2.21l-6.73,7.14l-1.59,1.77l-3.23,1.72l-1.38,0.03l-1.48,-1.39l-0.37,-0.03l-3.36,2.22l-0.11,0.14l-0.16,0.42l-0.01,-1.09l1.0,-0.06l0.28,-0.27l0.36,-3.6l-0.61,-2.51l1.85,-0.94l2.94,0.53l0.32,-0.15l1.71,-3.1l0.84,-3.38l0.97,-1.18l1.32,-2.88l-0.34,-0.42l-4.14,0.95l-2.18,1.25l-3.51,-0.0l-0.95,-2.81l-0.1,-0.14l-2.97,-2.3l-0.11,-0.05l-4.19,-1.0l-0.89,-3.08l-0.87,-2.03l-0.95,-1.46l-1.54,-3.37l-0.12,-0.14l-2.27,-1.28l-3.83,-1.02l-3.37,0.1l-3.11,0.61l-0.13,0.06l-2.07,1.69l0.04,0.49l1.23,0.72l0.03,1.53l-1.34,1.05l-2.26,3.51l-0.05,0.17l0.02,1.27l-3.25,1.9l-2.87,-1.17l-0.14,-0.02l-2.86,0.26l-1.22,-1.02l-0.12,-0.06l-1.5,-0.35l-0.23,0.04l-3.62,2.27l-3.24,0.53l-2.28,0.79l-3.08,-0.51l-2.24,0.03l-1.49,-1.61l-2.45,-1.57l-0.11,-0.04l-2.6,-0.43l-3.17,0.43l-2.31,0.59l-3.31,-1.28l-0.45,-2.31l-0.21,-0.23l-2.94,-0.85l-2.26,-0.39l-2.77,-1.36l-0.37,0.09l-2.59,3.45l-0.03,0.32l0.91,1.74l-2.15,2.01l-3.47,-0.79l-2.44,-0.12l-1.59,-1.46l-0.2,-0.08l-2.55,-0.05l-2.12,-0.98l-0.24,-0.01l-3.85,1.57l-4.74,2.79l-2.59,0.55l-0.79,0.21l-1.21,-1.81l-0.29,-0.13l-3.05,0.41l-0.96,-1.25l-0.14,-0.1l-1.65,-0.6l-1.15,-1.82l-0.13,-0.12l-1.38,-0.6l-0.19,-0.02l-3.49,0.82l-3.35,-1.85l-0.38,0.08l-1.08,1.4l-5.36,-8.17l-3.02,-2.52l0.72,-0.85l0.01,-0.38l-0.37,-0.08l-6.22,3.21l-1.98,0.16l0.17,-1.51l-0.2,-0.31l-3.22,-1.17l-0.19,-0.0l-2.3,0.74l-0.72,-3.27l-0.24,-0.23l-4.5,-0.75l-0.21,0.04l-2.2,1.42l-6.21,1.27l-0.11,0.05l-1.16,0.81l-9.3,1.19l-0.18,0.09l-1.15,1.17l-0.02,0.39l1.56,2.01l-2.02,0.74l-0.16,0.42l0.35,0.68l-2.18,1.49l0.02,0.51l3.83,2.16l-0.45,1.13l-3.31,-0.13l-0.25,0.12l-0.57,0.77l-2.97,-1.59l-0.15,-0.04l-3.97,0.07l-0.13,0.03l-2.53,1.32l-2.84,-1.28l-5.52,-2.3l-0.12,-0.02l-3.91,0.09l-0.16,0.05l-5.17,3.6l-0.13,0.21l-0.25,1.89l-2.17,-1.6l-0.44,0.1l-2.0,3.59l0.06,0.37l0.55,0.5l-1.32,2.23l0.04,0.36l2.13,2.17l0.23,0.09l1.7,-0.08l1.42,1.89l-0.23,1.5l0.19,0.32l0.94,0.38l-0.89,1.44l-2.3,0.49l-0.17,0.11l-2.49,3.2l0.0,0.37l2.2,2.81l-0.23,1.93l0.06,0.22l2.56,3.32l-1.27,1.02l-0.4,0.66l-0.8,-0.15l-1.65,-1.75l-0.18,-0.09l-0.66,-0.09l-1.45,-0.64l-0.72,-1.16l-0.18,-0.13l-2.34,-0.63l-0.17,0.0l-1.32,0.41l-0.31,-0.4l-0.12,-0.09l-3.49,-1.48l-3.67,-0.49l-2.1,-0.52l-0.3,0.1l-0.12,0.14l-2.96,-2.4l-2.89,-1.19l-1.69,-1.42l1.27,-0.35l0.16,-0.1l2.08,-2.61l-0.04,-0.41l-1.02,-0.9l3.21,-1.12l0.2,-0.31l-0.07,-0.69l-0.37,-0.26l-1.86,0.42l0.05,-0.86l1.11,-0.76l2.35,-0.23l0.25,-0.19l0.39,-1.07l0.0,-0.19l-0.51,-1.64l0.95,-1.58l0.04,-0.16l-0.03,-0.95l-0.22,-0.28l-3.69,-1.06l-1.43,0.02l-1.45,-1.44l-0.29,-0.08l-1.83,0.49l-2.88,-1.04l0.04,-0.42l-0.04,-0.18l-0.89,-1.43l-0.23,-0.14l-1.77,-0.14l-0.13,-0.66l0.52,-0.56l0.01,-0.4l-1.6,-1.9l-0.27,-0.1l-2.55,0.32l-0.71,-0.16l-0.3,0.1l-0.53,0.63l-0.58,-0.08l-0.56,-1.97l-0.48,-0.94l0.17,-0.11l1.92,0.11l0.2,-0.06l0.97,-0.74l0.05,-0.42l-0.72,-0.91l-0.13,-0.1l-1.43,-0.51l0.09,-0.36l-0.13,-0.33l-0.97,-0.59l-1.43,-2.06l0.44,-0.77l0.04,-0.19l-0.25,-1.64l-0.2,-0.24l-2.45,-0.84l-0.19,-0.0l-1.05,0.34l-0.25,-0.62l-0.18,-0.17l-2.5,-0.84l-0.74,-1.93l-0.21,-1.7l-0.13,-0.21l-0.92,-0.63l0.83,-0.89l0.07,-0.27l-0.71,-3.26l1.69,-2.01l0.03,-0.34l-0.24,-0.41l2.63,-1.9l-0.01,-0.49l-2.31,-1.57l5.08,-4.61l2.33,-2.24l1.01,-2.08l-0.09,-0.37l-3.52,-2.56l0.94,-2.38l-0.04,-0.29l-2.14,-2.86l1.61,-3.35l-0.01,-0.29l-2.81,-4.58l2.19,-3.04l-0.06,-0.42l-3.7,-2.76l0.32,-2.67l1.87,-0.38l4.26,-1.77l2.46,-1.47l3.96,2.58l0.12,0.05l6.81,1.04l9.37,4.87l1.81,1.92l0.15,2.55l-2.61,2.06l-3.95,1.07l-11.1,-3.15l-0.17,0.0l-1.84,0.53l-0.1,0.53l3.97,2.97l0.15,1.77l0.16,4.14l0.19,0.27l3.21,1.22l1.94,1.03l0.44,-0.22l0.32,-1.94l-0.07,-0.25l-1.32,-1.52l1.25,-1.2l5.87,2.45l0.24,-0.01l2.11,-0.98l0.13,-0.42l-1.55,-2.75l5.52,-3.84l2.13,0.22l2.28,1.42l0.43,-0.12l1.46,-2.87l-0.04,-0.33l-1.97,-2.37l1.14,-2.38l-0.02,-0.3l-1.42,-2.07l6.15,1.22l1.14,1.92l-2.74,0.46l-0.25,0.3l0.02,2.36l0.12,0.24l1.97,1.44l0.25,0.05l3.87,-0.91l0.22,-0.23l0.58,-2.55l5.09,-1.98l8.67,-3.69l1.22,0.14l-2.06,2.2l0.18,0.5l3.11,0.45l0.23,-0.07l1.71,-1.41l4.59,-0.12l0.12,-0.03l3.53,-1.72l2.7,2.48l0.42,-0.01l2.85,-2.88l-0.0,-0.43l-2.42,-2.35l1.0,-1.13l7.2,1.31l3.42,1.36l9.06,4.97l0.39,-0.08l1.67,-2.27l-0.04,-0.4l-2.46,-2.23l-0.06,-0.82l-0.26,-0.27l-2.64,-0.38l0.69,-1.76l0.0,-0.22l-1.32,-3.47l-0.07,-1.27l4.52,-4.09l0.08,-0.11l1.6,-4.18l1.67,-0.84l6.33,1.2l0.46,2.31l-2.31,3.67l0.05,0.38l1.49,1.41l0.77,3.04l-0.56,6.05l0.09,0.24l2.62,2.54l-0.99,2.65l-4.87,5.96l0.17,0.48l2.86,0.61l0.31,-0.13l0.94,-1.42l2.67,-1.04l0.18,-0.19l0.64,-2.01l2.11,-1.98l0.05,-0.37l-1.38,-2.32l1.11,-2.74l-0.24,-0.41l-2.53,-0.33l-0.53,-2.16l1.96,-4.42l-0.05,-0.32l-3.03,-3.48l4.21,-2.94l0.12,-0.3l-0.52,-3.04l0.72,-0.06l1.18,2.35l-0.97,4.39l0.2,0.35l2.68,0.84l0.37,-0.38l-1.05,-3.07l3.89,-1.71l5.05,-0.24l4.55,2.62l0.36,-0.05l0.05,-0.36l-2.19,-3.84l-0.23,-4.78l4.07,-0.92l5.98,0.21l5.47,-0.64l0.2,-0.48l-1.88,-2.37l2.65,-2.99l2.75,-0.13l0.12,-0.03l4.82,-2.48l6.56,-0.67l0.23,-0.14l0.76,-1.27l6.33,-0.46l1.97,1.11l0.28,0.01l5.55,-2.71l4.53,0.08l0.29,-0.21l0.67,-2.18l2.29,-2.15l5.75,-2.13l3.48,1.4l-2.7,1.03l-0.19,0.31l0.26,0.26l5.47,0.78ZM871.83,65.73l0.25,-0.15l1.99,0.01l3.3,1.2l-0.08,0.22l-2.41,1.03l-5.73,0.49l-0.31,-1.0l2.99,-1.8ZM797.64,48.44l-2.22,1.51l-3.85,-0.43l-4.35,-1.85l0.42,-1.13l4.42,0.72l5.59,1.17ZM783.82,46.06l-1.71,3.25l-9.05,-0.14l-4.11,1.15l-4.64,-3.04l1.21,-3.13l3.11,-0.91l6.53,0.22l8.66,2.59ZM780.37,145.71l2.28,5.23l-3.09,-0.89l-0.37,0.19l-1.54,4.65l0.04,0.27l2.38,3.17l-0.05,1.4l-1.41,-1.41l-0.46,0.04l-1.23,1.81l-0.33,-1.86l0.28,-3.1l-0.28,-3.41l0.58,-2.46l0.11,-4.39l-0.03,-0.13l-1.44,-3.2l0.21,-4.39l2.19,-1.49l0.09,-0.41l-0.81,-1.3l0.48,-0.21l0.56,1.94l0.86,3.23l-0.05,3.36l1.03,3.35ZM780.16,57.18l-3.4,0.03l-5.06,-0.53l1.97,-1.59l2.95,-0.42l3.35,1.75l0.18,0.77ZM683.84,31.18l-13.29,1.97l4.16,-6.56l1.88,-0.58l1.77,0.34l6.08,3.02l-0.6,1.8ZM670.94,28.02l-5.18,0.65l-6.89,-1.58l-4.03,-2.07l-1.88,-3.98l-0.18,-0.16l-2.8,-0.93l5.91,-3.62l5.25,-1.29l4.73,2.88l5.63,5.44l-0.57,4.66ZM564.37,68.98l-0.85,0.23l-7.93,-0.57l-0.6,-1.84l-0.21,-0.2l-4.34,-1.18l-0.3,-2.08l2.34,-0.92l0.19,-0.29l-0.08,-2.43l4.85,-4.0l-0.12,-0.52l-1.68,-0.43l5.47,-3.94l0.11,-0.33l-0.6,-2.02l5.36,-2.55l8.22,-3.27l8.29,-0.96l4.34,-1.94l4.67,-0.65l1.45,1.72l-1.43,1.37l-8.8,2.52l-7.65,2.42l-7.92,4.84l-3.73,4.75l-3.92,4.58l-0.07,0.23l0.51,3.88l0.11,0.2l4.32,3.39ZM548.86,18.57l-3.28,0.75l-2.25,0.44l-0.22,0.19l-0.3,0.81l-2.67,0.86l-2.27,-1.14l1.2,-1.51l-0.23,-0.49l-3.14,-0.1l2.48,-0.54l3.55,-0.07l0.44,1.36l0.49,0.12l1.4,-1.35l2.2,-0.9l3.13,1.08l-0.54,0.49ZM477.5,133.25l-4.21,0.05l-2.69,-0.34l0.39,-1.03l3.24,-1.06l2.51,0.58l0.85,0.43l-0.2,0.71l-0.0,0.15l0.12,0.52Z" data-code="RU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M497.03,288.12l0.78,1.11l-0.12,1.19l-0.49,0.21l-1.25,-0.15l-0.3,0.16l-0.67,1.24l-1.01,-0.13l0.16,-0.92l0.22,-0.12l0.15,-0.24l0.09,-1.37l0.49,-0.48l0.42,0.18l0.25,-0.01l1.26,-0.65Z" data-code="RW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M469.75,168.65l0.21,-0.21l0.36,-1.44l-0.08,-0.29l-1.06,-1.03l0.54,-1.16l-0.28,-0.43l-0.26,0.0l0.55,-0.67l-0.01,-0.39l-0.77,-0.86l-0.45,-0.89l1.56,-0.67l1.39,0.12l1.22,1.1l0.26,0.91l0.16,0.19l1.38,0.66l0.17,1.12l0.14,0.21l1.46,0.9l0.35,-0.03l0.62,-0.54l0.09,0.06l-0.28,0.25l-0.03,0.42l0.29,0.34l-0.44,0.5l-0.07,0.26l0.22,1.12l0.07,0.14l1.02,1.1l-0.81,0.84l-0.42,0.96l0.04,0.3l0.12,0.15l-0.15,0.16l-1.04,0.04l-0.39,0.08l0.33,-0.81l-0.29,-0.41l-0.21,0.01l-0.39,-0.45l-0.13,-0.09l-0.32,-0.11l-0.27,-0.4l-0.14,-0.11l-0.4,-0.16l-0.31,-0.37l-0.34,-0.09l-0.45,0.17l-0.18,0.18l-0.29,0.84l-0.96,-0.65l-0.81,-0.33l-0.32,-0.37l-0.22,-0.18Z" data-code="RS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M478.13,133.31l-0.14,-0.63l0.25,-0.88l-0.15,-0.35l-1.17,-0.58l-2.43,-0.57l-0.45,-2.51l2.58,-0.97l4.14,0.22l2.3,-0.32l0.26,0.54l0.22,0.17l1.26,0.22l2.25,1.6l0.19,1.23l-1.87,1.01l-0.14,0.18l-0.54,1.83l-2.54,1.21l-2.18,-0.02l-0.52,-0.91l-0.18,-0.14l-1.11,-0.32Z" data-code="LT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M435.95,147.99l0.33,0.49l-0.11,1.07l-0.39,0.04l-0.29,-0.15l0.21,-1.4l0.25,-0.05Z" data-code="LU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M401.37,273.67l-0.32,0.01l-2.48,-1.15l-2.24,-1.89l-2.14,-1.38l-1.47,-1.42l0.44,-0.59l0.05,-0.13l0.12,-0.65l1.07,-1.3l1.08,-1.09l0.52,-0.07l0.43,-0.18l0.84,1.24l-0.15,0.89l0.07,0.25l0.49,0.54l0.22,0.1l0.71,0.01l0.27,-0.16l0.42,-0.83l0.19,0.02l-0.06,0.52l0.23,1.12l-0.5,1.03l0.06,0.35l0.73,0.69l0.14,0.08l0.71,0.15l0.92,0.91l0.06,0.76l-0.17,0.22l-0.06,0.15l-0.17,1.8Z" data-code="LR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M477.94,155.19l1.02,-0.64l1.49,0.33l1.52,0.01l1.09,0.73l0.32,0.01l0.81,-0.46l1.8,-0.3l0.18,-0.1l0.54,-0.64l0.86,0.0l0.64,0.26l0.71,0.87l0.8,1.35l1.39,1.81l0.07,1.25l-0.26,1.3l0.01,0.15l0.45,1.42l0.15,0.18l1.12,0.57l0.25,0.01l1.05,-0.45l0.86,0.4l0.03,0.43l-0.92,0.51l-0.63,-0.24l-0.4,0.22l-0.64,3.41l-1.12,-0.24l-1.78,-1.09l-0.23,-0.04l-2.95,0.71l-1.25,0.77l-3.55,-0.16l-1.89,-0.47l-0.14,-0.0l-0.75,0.17l-0.61,-1.07l-0.3,-0.36l0.36,-0.32l-0.04,-0.48l-0.62,-0.38l-0.36,0.03l-0.62,0.54l-1.15,-0.71l-0.18,-1.14l-0.17,-0.22l-1.4,-0.67l-0.24,-0.86l-0.09,-0.14l-0.96,-0.87l1.49,-0.44l0.16,-0.11l1.51,-2.14l1.15,-2.09l1.44,-0.63Z" data-code="RO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M383.03,256.73l-1.12,-0.88l-0.14,-0.06l-0.94,-0.15l-0.43,-0.54l0.01,-0.27l-0.13,-0.26l-0.68,-0.48l-0.05,-0.16l0.99,-0.31l0.77,0.08l0.15,-0.02l0.61,-0.26l4.25,0.1l-0.02,0.44l-0.19,0.18l-0.08,0.29l0.17,0.66l-0.17,0.14l-0.44,0.0l-0.16,0.05l-0.57,0.37l-0.66,-0.04l-0.24,0.1l-0.92,1.03Z" data-code="GW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M195.13,249.89l-1.05,-0.35l-1.5,-0.04l-1.06,-0.47l-1.19,-0.93l0.04,-0.53l0.27,-0.55l-0.03,-0.31l-0.24,-0.32l1.02,-1.77l3.04,-0.01l0.3,-0.28l0.06,-0.88l-0.19,-0.3l-0.3,-0.11l-0.23,-0.45l-0.11,-0.12l-0.9,-0.58l-0.35,-0.33l0.37,-0.0l0.3,-0.3l0.0,-1.15l4.05,0.02l-0.02,1.74l-0.2,2.89l0.3,0.32l0.67,-0.0l0.75,0.42l0.4,-0.11l-0.62,0.53l-1.17,0.7l-0.13,0.16l-0.18,0.49l0.0,0.21l0.14,0.34l-0.35,0.44l-0.49,0.13l-0.2,0.41l0.03,0.06l-0.27,0.16l-0.86,0.64l-0.12,0.22ZM199.35,245.38l0.07,-0.13l0.05,0.02l-0.13,0.11Z" data-code="GT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M487.2,174.55l-0.64,1.54l-0.43,0.24l-1.41,-0.08l-1.28,-0.28l-0.14,0.0l-3.03,0.77l-0.13,0.51l1.39,1.34l-0.78,0.29l-1.2,0.0l-1.23,-1.42l-0.47,0.02l-0.47,0.65l-0.04,0.27l0.56,1.76l0.06,0.11l1.02,1.12l-0.66,0.45l-0.04,0.46l1.39,1.35l1.15,0.79l0.02,1.06l-1.91,-0.63l-0.36,0.42l0.56,1.12l-1.2,0.23l-0.22,0.4l0.8,2.14l-1.15,0.02l-1.89,-1.15l-0.89,-2.19l-0.43,-1.91l-0.05,-0.11l-0.98,-1.35l-1.24,-1.62l-0.13,-0.63l1.07,-1.32l0.06,-0.14l0.13,-0.81l0.68,-0.36l0.16,-0.25l0.03,-0.54l1.4,-0.23l0.12,-0.05l0.87,-0.6l1.26,0.05l0.25,-0.11l0.34,-0.43l0.33,-0.07l1.81,0.08l0.13,-0.02l1.87,-0.77l1.64,0.97l0.19,0.04l2.28,-0.28l0.26,-0.29l0.02,-0.95l0.56,0.36ZM480.44,192.0l1.05,0.74l0.01,0.0l-1.26,-0.23l0.2,-0.51ZM481.76,192.79l1.86,-0.15l1.53,0.17l-0.02,0.19l0.34,0.3l-2.28,0.15l0.01,-0.13l-0.25,-0.31l-1.19,-0.22ZM485.65,193.28l0.65,-0.16l-0.05,0.12l-0.6,0.04Z" data-code="GR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.81,282.04l-0.21,-0.17l0.74,-2.4l3.56,0.05l0.02,2.42l-3.34,-0.02l-0.76,0.13Z" data-code="GQ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M271.34,264.25l1.43,0.81l1.44,1.53l0.06,1.19l0.28,0.28l0.84,0.05l2.13,1.92l-0.34,1.93l-1.37,0.59l-0.17,0.34l0.12,0.51l-0.43,1.21l0.03,0.26l1.11,1.82l0.26,0.14l0.56,0.0l0.32,1.29l1.25,1.78l-0.08,0.01l-1.34,-0.21l-0.24,0.06l-0.78,0.64l-1.06,0.41l-0.76,0.1l-0.22,0.15l-0.18,0.32l-0.95,-0.1l-1.38,-1.05l-0.19,-1.13l-0.6,-1.18l0.37,-1.96l0.65,-0.83l0.03,-0.32l-0.57,-1.17l-0.15,-0.14l-0.62,-0.27l0.25,-0.85l-0.08,-0.3l-0.58,-0.58l-0.24,-0.09l-1.15,0.1l-1.41,-1.58l0.48,-0.49l0.09,-0.22l-0.04,-0.92l1.31,-0.34l0.73,-0.52l0.04,-0.44l-0.75,-0.82l0.16,-0.66l1.74,-1.3Z" data-code="GY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M525.41,174.19l0.26,-0.88l-0.0,-0.17l-0.63,-2.06l-0.1,-0.15l-1.45,-1.12l-0.11,-0.05l-1.31,-0.33l-0.66,-0.69l1.97,0.48l3.65,0.49l3.3,1.41l0.39,0.5l0.33,0.1l1.43,-0.45l2.14,0.58l0.7,1.14l0.13,0.12l1.06,0.47l-0.18,0.11l-0.08,0.43l1.08,1.41l-0.06,0.06l-1.16,-0.15l-1.82,-0.84l-0.31,0.04l-0.55,0.44l-3.29,0.44l-2.32,-1.41l-0.17,-0.04l-2.25,0.12Z" data-code="GE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M412.82,118.6l-2.31,3.4l-0.0,0.33l0.31,0.13l2.52,-0.49l2.34,0.02l-0.56,2.51l-2.22,3.13l0.22,0.47l2.43,0.21l2.35,4.35l0.17,0.14l1.58,0.51l1.49,3.78l0.73,1.37l0.2,0.15l2.76,0.59l-0.25,1.75l-1.18,0.91l-0.08,0.39l0.87,1.49l-1.96,1.51l-3.31,-0.02l-4.15,0.88l-1.07,-0.59l-0.35,0.04l-1.55,1.44l-2.17,-0.35l-0.22,0.05l-1.61,1.15l-0.78,-0.38l3.31,-3.12l2.18,-0.7l0.21,-0.31l-0.26,-0.27l-3.78,-0.54l-0.48,-0.9l2.3,-0.92l0.13,-0.46l-1.29,-1.71l0.39,-1.83l3.46,0.29l0.32,-0.24l0.37,-1.99l-0.06,-0.24l-1.71,-2.17l-0.18,-0.11l-2.91,-0.58l-0.43,-0.68l0.82,-1.4l-0.03,-0.35l-0.82,-0.97l-0.46,0.01l-0.85,1.05l-0.11,-2.6l-0.05,-0.16l-1.19,-1.7l0.86,-3.53l1.81,-2.75l1.88,0.26l2.38,-0.24ZM406.39,132.84l-1.09,1.92l-1.65,-0.62l-1.26,0.02l0.41,-1.46l0.0,-0.16l-0.42,-1.51l1.62,-0.11l2.39,1.92Z" data-code="GB" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M448.76,294.47l-2.38,-2.34l-1.63,-2.04l-1.46,-2.48l0.06,-0.66l0.54,-0.81l0.61,-1.82l0.46,-1.69l0.63,-0.11l3.62,0.03l0.3,-0.3l-0.02,-2.75l0.88,-0.12l1.47,0.32l0.13,0.0l1.39,-0.3l-0.13,0.87l0.03,0.19l0.7,1.29l0.3,0.16l1.74,-0.19l0.36,0.29l-1.01,2.7l0.05,0.29l1.13,1.42l0.25,1.82l-0.3,1.56l-0.64,0.99l-1.93,-0.09l-1.26,-1.13l-0.5,0.17l-0.16,0.91l-1.48,0.27l-0.12,0.05l-0.86,0.63l-0.08,0.39l0.81,1.42l-1.48,1.08Z" data-code="GA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M399.83,265.31l-0.69,-0.06l-0.3,0.16l-0.43,0.85l-0.39,-0.01l-0.3,-0.33l0.14,-0.87l-0.05,-0.22l-1.05,-1.54l-0.37,-0.11l-0.61,0.27l-0.84,0.12l0.02,-0.54l-0.04,-0.17l-0.35,-0.57l0.07,-0.63l-0.03,-0.17l-0.57,-1.11l-0.7,-0.9l-0.24,-0.12l-2.0,-0.0l-0.19,0.07l-0.51,0.42l-0.6,0.05l-0.21,0.11l-0.43,0.55l-0.3,0.7l-1.04,0.86l-0.91,-1.24l-1.0,-1.02l-0.69,-0.37l-0.52,-0.42l-0.3,-1.11l-0.37,-0.56l-0.1,-0.1l-0.4,-0.23l0.77,-0.85l0.62,0.04l0.18,-0.05l0.58,-0.38l0.46,-0.0l0.19,-0.07l0.39,-0.34l0.1,-0.3l-0.17,-0.67l0.15,-0.14l0.09,-0.2l0.03,-0.57l0.87,0.02l1.76,0.6l0.13,0.01l0.55,-0.06l0.22,-0.13l0.08,-0.12l1.18,0.17l0.17,-0.02l0.09,0.56l0.3,0.25l0.4,-0.0l0.14,-0.03l0.56,-0.29l0.23,0.05l0.63,0.59l0.15,0.07l1.07,0.2l0.24,-0.06l0.65,-0.52l0.77,-0.32l0.55,-0.32l0.3,0.04l0.44,0.45l0.34,0.74l0.84,0.87l-0.35,0.45l-0.06,0.15l-0.1,0.82l0.42,0.31l0.35,-0.16l0.05,0.04l-0.1,0.59l0.09,0.27l0.42,0.4l-0.06,0.02l-0.18,0.21l-0.2,0.86l0.03,0.21l0.56,1.02l0.52,1.71l-0.65,0.21l-0.15,0.12l-0.24,0.35l-0.03,0.28l0.16,0.41l-0.1,0.76l-0.12,0.0Z" data-code="GN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M379.18,251.48l0.15,-0.55l2.51,-0.07l0.21,-0.09l0.48,-0.52l0.58,-0.03l0.91,0.58l0.16,0.05l0.78,0.01l0.14,-0.03l0.59,-0.31l0.16,0.24l-0.71,0.38l-0.94,-0.04l-1.02,-0.51l-0.3,0.01l-0.86,0.55l-0.37,0.02l-0.14,0.04l-0.53,0.31l-1.81,-0.04Z" data-code="GM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M304.13,6.6l8.19,-3.63l8.72,0.28l0.19,-0.06l3.12,-2.28l8.75,-0.61l19.94,0.8l14.93,4.75l-3.92,2.01l-9.52,0.27l-13.48,0.6l-0.27,0.2l0.09,0.33l1.26,1.09l0.22,0.07l8.81,-0.67l7.49,2.07l0.19,-0.01l4.68,-1.78l1.76,1.84l-2.59,3.26l-0.01,0.36l0.34,0.11l6.35,-2.2l12.09,-2.32l7.31,1.14l1.17,2.13l-9.9,4.05l-1.43,1.32l-7.91,0.98l-0.26,0.31l0.29,0.29l5.25,0.25l-2.63,3.72l-2.02,3.61l-0.04,0.15l0.08,6.05l0.07,0.19l2.61,3.0l-3.4,0.2l-4.12,1.66l-0.04,0.54l4.5,2.67l0.53,3.9l-2.39,0.42l-0.19,0.48l2.91,3.83l-5.0,0.32l-0.27,0.22l0.12,0.33l2.69,1.84l-0.65,1.35l-3.36,0.71l-3.46,0.01l-0.21,0.51l3.05,3.15l0.02,1.53l-4.54,-1.79l-0.32,0.06l-1.29,1.26l0.11,0.5l3.33,1.15l3.17,2.74l0.85,3.29l-4.0,0.78l-1.83,-1.66l-3.1,-2.64l-0.36,-0.02l-0.13,0.33l0.8,2.92l-2.76,2.26l-0.09,0.33l0.28,0.2l6.59,0.19l2.47,0.18l-5.86,3.38l-6.76,3.43l-7.26,1.48l-2.73,0.02l-0.16,0.05l-2.67,1.72l-3.44,4.42l-5.28,2.86l-1.73,0.18l-3.33,1.01l-3.59,0.96l-0.15,0.1l-2.15,2.52l-0.07,0.19l-0.03,2.76l-1.21,2.49l-4.03,3.1l-0.1,0.33l0.98,2.94l-2.31,6.57l-3.21,0.21l-3.6,-3.0l-0.19,-0.07l-4.9,-0.02l-2.29,-1.97l-1.69,-3.78l-4.31,-4.86l-1.23,-2.52l-0.34,-3.58l-0.08,-0.17l-3.35,-3.67l0.85,-2.92l-0.09,-0.31l-1.5,-1.34l2.33,-4.7l3.67,-1.57l0.15,-0.13l1.02,-1.93l0.52,-3.47l-0.44,-0.31l-2.85,1.57l-1.33,0.64l-2.12,0.59l-2.81,-1.32l-0.15,-2.79l0.88,-2.17l2.09,-0.06l5.07,1.2l0.34,-0.17l-0.11,-0.37l-4.3,-2.9l-2.24,-1.58l-0.25,-0.05l-2.38,0.62l-1.7,-0.93l2.62,-4.1l-0.03,-0.36l-1.51,-1.75l-1.97,-3.3l-3.01,-5.21l-0.1,-0.11l-3.04,-1.85l0.03,-1.94l-0.18,-0.28l-6.82,-3.01l-5.35,-0.38l-6.69,0.21l-6.03,0.37l-2.81,-1.59l-3.84,-2.9l5.94,-1.5l5.01,-0.28l0.28,-0.29l-0.26,-0.31l-10.68,-1.38l-5.38,-2.1l0.27,-1.68l9.3,-2.6l9.18,-2.68l0.19,-0.16l0.97,-2.05l-0.18,-0.42l-6.29,-1.91l1.81,-1.9l8.58,-4.05l3.6,-0.63l0.23,-0.4l-0.92,-2.37l5.59,-1.5l7.66,-0.95l7.58,-0.05l2.65,1.84l0.31,0.02l6.52,-3.29l5.85,2.24l3.55,0.49l5.17,1.95l0.38,-0.16l-0.13,-0.39l-5.77,-3.16l0.29,-2.26Z" data-code="GL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M540.87,207.81l0.41,0.94l-0.18,0.51l0.0,0.21l0.65,1.66l-1.15,0.05l-0.54,-1.12l-0.24,-0.17l-1.73,-0.2l1.44,-2.06l1.33,0.18Z" data-code="KW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M423.16,269.88l-3.58,1.34l-1.41,0.87l-2.13,0.69l-1.91,-0.61l0.09,-0.75l-0.03,-0.17l-1.04,-2.07l0.62,-2.7l1.04,-2.08l0.03,-0.19l-1.0,-5.46l0.05,-1.12l4.04,-0.11l1.08,0.18l0.18,-0.03l0.72,-0.36l0.75,0.13l-0.11,0.48l0.06,0.26l0.98,1.22l-0.0,1.77l0.24,1.99l0.05,0.13l0.55,0.81l-0.52,2.14l0.19,1.37l0.69,1.66l0.38,0.62Z" data-code="GH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M568.16,231.0l-0.08,0.1l-0.84,1.61l-0.93,-0.11l-0.27,0.11l-0.58,0.73l-0.4,1.32l-0.01,0.14l0.29,1.61l-0.07,0.09l-1.0,-0.01l-0.16,0.04l-1.56,0.97l-0.14,0.2l-0.23,1.17l-0.41,0.4l-1.44,-0.02l-0.17,0.05l-0.98,0.65l-0.13,0.25l0.01,0.87l-0.97,0.57l-1.27,-0.22l-0.19,0.03l-1.63,0.84l-0.88,0.11l-2.55,-5.57l7.2,-2.49l0.19,-0.19l1.67,-5.23l-0.03,-0.25l-1.1,-1.78l0.05,-0.89l0.68,-1.03l0.05,-0.16l0.01,-0.89l0.96,-0.44l0.07,-0.5l-0.32,-0.26l0.16,-1.31l0.85,-0.01l1.03,1.67l0.09,0.09l1.4,0.96l0.11,0.05l1.82,0.34l1.37,0.45l1.75,2.32l0.13,0.1l0.7,0.26l-0.0,0.3l-1.25,2.19l-1.01,0.8ZM561.88,218.47l-0.01,0.02l-0.15,-0.29l0.3,-0.38l-0.14,0.65Z" data-code="OM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M543.2,261.06l-1.07,1.46l-1.65,1.99l-1.91,0.01l-8.08,-2.95l-0.89,-0.84l-0.9,-1.19l-0.81,-1.23l0.44,-0.73l0.76,-1.12l0.49,0.28l0.52,1.05l1.13,1.06l0.2,0.08l1.24,0.01l2.42,-0.65l2.77,-0.31l2.17,-0.78l1.31,-0.19l0.84,-0.43l1.03,-0.06l-0.01,4.54Z" data-code="_3" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M384.23,230.37l0.07,-0.06l0.28,-0.89l0.99,-1.13l0.07,-0.13l0.8,-3.54l3.4,-2.8l0.09,-0.13l0.76,-2.17l0.07,5.5l-2.07,0.21l-0.24,0.17l-0.61,1.36l-0.02,0.16l0.43,3.46l-4.01,-0.01ZM391.82,218.2l0.07,-0.06l0.75,-1.93l1.86,-0.25l0.94,0.34l1.14,0.0l0.18,-0.06l0.73,-0.56l1.41,-0.08l-0.0,2.72l-7.08,-0.12Z" data-code="_2" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M472.71,172.84l-0.07,-0.43l-0.16,-0.22l-0.53,-0.27l-0.38,-0.58l0.3,-0.43l0.51,-0.19l0.18,-0.18l0.3,-0.87l0.12,-0.04l0.22,0.26l0.12,0.09l0.38,0.15l0.28,0.41l0.15,0.12l0.34,0.12l0.43,0.5l0.15,0.07l-0.12,0.3l-0.27,0.32l-0.03,0.18l-0.31,0.06l-1.48,0.47l-0.15,0.17Z" data-code="_1" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M503.54,192.92l0.09,-0.17l0.41,0.01l-0.08,0.01l-0.42,0.15ZM504.23,192.76l1.02,0.02l0.4,-0.13l-0.09,0.29l0.03,0.08l-0.35,0.16l-0.24,-0.04l-0.06,-0.1l-0.18,-0.17l-0.19,-0.08l-0.33,-0.02Z" data-code="_0" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M510.26,200.93l0.28,-0.57l2.53,1.0l0.27,-0.02l4.57,-2.77l0.84,2.84l-0.28,0.25l-4.95,1.37l-0.14,0.49l2.24,2.48l-0.5,0.28l-0.13,0.14l-0.35,0.78l-1.76,0.35l-0.2,0.14l-0.57,0.94l-0.94,0.73l-2.45,-0.38l-0.03,-0.12l1.23,-4.32l-0.04,-1.1l0.34,-0.75l0.03,-0.12l0.0,-1.63Z" data-code="JO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M455.49,162.73l1.53,0.09l0.24,-0.1l0.29,-0.34l0.64,0.38l0.14,0.04l0.98,0.06l0.32,-0.3l-0.01,-0.66l0.67,-0.25l0.19,-0.22l0.21,-1.11l1.72,-0.72l0.65,0.32l1.94,1.37l2.07,0.6l0.22,-0.02l0.67,-0.33l0.47,0.94l0.67,0.76l-0.63,0.77l-0.91,-0.55l-0.16,-0.04l-1.69,0.04l-2.2,-0.51l-1.17,0.07l-0.21,0.11l-0.36,0.42l-0.67,-0.53l-0.46,0.12l-0.52,1.29l0.05,0.31l1.21,1.42l0.58,0.99l1.15,1.14l0.95,0.68l0.92,1.23l0.1,0.09l1.75,0.91l-1.87,-0.89l-1.5,-1.11l-2.23,-0.88l-1.77,-1.9l0.12,-0.06l0.1,-0.47l-1.07,-1.22l-0.04,-0.94l-0.21,-0.27l-1.61,-0.49l-0.35,0.14l-0.53,0.93l-0.41,-0.57l0.04,-0.73Z" data-code="HR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M237.82,234.68l1.35,0.1l1.95,0.37l0.18,1.15l-0.16,0.83l-0.51,0.37l-0.06,0.44l0.57,0.68l-0.02,0.22l-1.31,-0.35l-1.26,0.17l-1.49,-0.18l-0.15,0.02l-1.03,0.43l-1.02,-0.61l0.09,-0.36l2.04,0.32l1.9,0.21l0.19,-0.05l0.9,-0.58l0.05,-0.47l-1.05,-1.03l0.02,-0.86l-0.23,-0.3l-1.13,-0.29l0.18,-0.23Z" data-code="HT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M461.96,157.92l0.68,-1.66l-0.03,-0.29l-0.15,-0.22l0.84,-0.0l0.3,-0.26l0.12,-0.84l0.88,0.57l0.98,0.38l0.16,0.01l2.1,-0.39l0.23,-0.21l0.14,-0.45l0.88,-0.1l1.06,-0.43l0.13,0.1l0.28,0.04l1.18,-0.4l0.14,-0.1l0.52,-0.67l0.63,-0.15l2.6,0.95l0.26,-0.03l0.38,-0.23l1.12,0.7l0.1,0.49l-1.31,0.57l-0.14,0.13l-1.18,2.14l-1.44,2.04l-1.85,0.55l-1.51,-0.13l-0.14,0.02l-1.92,0.82l-0.85,0.42l-1.91,-0.55l-1.83,-1.31l-0.74,-0.37l-0.44,-0.97l-0.26,-0.18Z" data-code="HU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M202.48,251.87l-0.33,-0.62l-0.18,-0.14l-0.5,-0.15l0.13,-0.76l-0.11,-0.28l-0.34,-0.28l-0.6,-0.23l-0.18,-0.01l-0.81,0.22l-0.16,-0.24l-0.72,-0.39l-0.51,-0.48l-0.12,-0.07l-0.31,-0.09l0.24,-0.3l0.04,-0.3l-0.16,-0.4l0.1,-0.28l1.14,-0.69l1.0,-0.86l0.09,0.04l0.3,-0.05l0.47,-0.39l0.49,-0.03l0.14,0.13l0.29,0.06l0.31,-0.1l1.16,0.22l1.24,-0.08l0.81,-0.28l0.29,-0.25l0.63,0.1l0.69,0.18l0.65,-0.06l0.49,-0.2l1.04,0.32l0.38,0.06l0.7,0.44l0.71,0.56l0.92,0.41l0.1,0.11l-0.11,-0.01l-0.23,0.09l-0.3,0.3l-0.76,0.29l-0.58,0.0l-0.15,0.04l-0.45,0.26l-0.31,-0.07l-0.37,-0.34l-0.28,-0.07l-0.26,0.07l-0.18,0.15l-0.23,0.43l-0.04,-0.0l-0.33,0.28l-0.03,0.4l-0.76,0.61l-0.45,0.3l-0.15,0.16l-0.51,-0.36l-0.41,0.06l-0.45,0.56l-0.41,-0.01l-0.59,0.06l-0.27,0.31l0.04,0.96l-0.07,0.0l-0.25,0.16l-0.24,0.45l-0.42,0.06Z" data-code="HN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M254.95,238.31l1.15,0.21l0.2,0.23l-0.36,0.36l-1.76,-0.01l-1.2,0.07l-0.09,-0.69l0.17,-0.18l1.89,0.01Z" data-code="PR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M509.66,201.06l-0.0,1.44l-0.29,0.63l-0.59,0.19l0.02,-0.11l0.52,-0.31l-0.02,-0.53l-0.41,-0.2l0.36,-1.28l0.41,0.17Z" data-code="PS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M398.65,173.6l0.75,-0.63l0.7,-0.3l0.51,1.2l0.28,0.18l1.48,-0.0l0.2,-0.08l0.33,-0.3l1.16,0.08l0.52,1.11l-0.95,0.66l-0.13,0.24l-0.03,2.2l-0.33,0.35l-0.08,0.18l-0.08,1.17l-0.86,0.19l-0.2,0.44l0.93,1.64l-0.64,1.79l0.07,0.31l0.72,0.72l-0.24,0.56l-0.9,1.05l-0.07,0.26l0.17,0.77l-0.73,0.54l-1.18,-0.36l-0.16,-0.0l-0.85,0.21l0.31,-1.81l-0.23,-1.87l-0.23,-0.25l-0.99,-0.24l-0.49,-0.91l0.18,-1.72l0.93,-0.99l0.08,-0.16l0.17,-1.17l0.52,-1.76l-0.04,-1.36l-0.51,-1.14l-0.09,-0.8Z" data-code="PT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M264.33,341.43l0.93,-2.96l0.07,-1.42l1.1,-2.1l4.19,-0.73l2.22,0.04l2.12,1.21l0.07,0.76l0.7,1.38l-0.16,3.48l0.24,0.31l2.64,0.5l0.19,-0.03l0.9,-0.45l1.47,0.62l0.38,0.64l0.23,2.35l0.3,1.07l0.25,0.21l0.93,0.12l0.16,-0.02l0.8,-0.37l0.61,0.33l-0.0,1.25l-0.33,1.53l-0.5,1.57l-0.39,2.26l-2.14,1.94l-1.85,0.4l-2.74,-0.4l-2.13,-0.62l2.26,-3.75l0.03,-0.24l-0.36,-1.18l-0.17,-0.19l-2.55,-1.03l-3.04,-1.95l-2.07,-0.43l-4.4,-4.12Z" data-code="PY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M213.65,263.79l0.18,-0.43l0.02,-0.18l-0.06,-0.28l0.23,-0.18l-0.01,-0.48l-0.4,-0.29l-0.01,-0.62l0.57,-0.13l0.68,0.69l-0.04,0.39l0.26,0.33l1.0,0.11l0.27,-0.1l0.49,0.44l0.24,0.07l1.34,-0.22l1.04,-0.62l1.49,-0.5l0.86,-0.73l0.99,0.11l0.18,0.28l1.35,0.08l1.02,0.4l0.78,0.72l0.71,0.53l-0.1,0.12l-0.05,0.3l0.53,1.34l-0.28,0.44l-0.6,-0.13l-0.36,0.22l-0.2,0.76l-0.41,-0.36l-0.44,-1.12l0.49,-0.53l-0.14,-0.49l-0.51,-0.14l-0.41,-0.72l-0.11,-0.11l-1.25,-0.7l-0.19,-0.04l-1.1,0.16l-0.22,0.15l-0.47,0.81l-0.9,0.56l-0.49,0.08l-0.22,0.17l-0.25,0.52l0.05,0.32l0.93,1.07l-0.41,0.21l-0.29,0.3l-0.81,0.09l-0.36,-1.26l-0.53,-0.1l-0.21,0.28l-0.5,-0.09l-0.44,-0.88l-0.22,-0.16l-0.99,-0.16l-0.61,-0.28l-0.13,-0.03l-1.0,0.0Z" data-code="PA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M808.4,298.6l0.62,0.46l1.19,1.56l1.04,0.77l-0.18,0.37l-0.42,0.15l-0.92,-0.82l-1.05,-1.53l-0.27,-0.96ZM804.09,296.06l-0.3,0.26l-0.36,-1.11l-0.66,-1.06l-2.55,-1.89l-1.42,-0.59l0.17,-0.15l1.16,0.6l0.85,0.55l1.01,0.58l0.97,1.02l0.9,0.76l0.24,1.03ZM796.71,297.99l0.15,0.82l0.34,0.24l1.43,-0.19l0.19,-0.11l0.68,-0.82l1.36,-0.87l0.13,-0.31l-0.21,-1.13l1.04,-0.03l0.3,0.25l-0.04,1.17l-0.74,1.34l-1.17,0.18l-0.22,0.15l-0.35,0.62l-2.51,1.13l-1.21,-0.0l-1.99,-0.71l-1.19,-0.58l0.07,-0.28l1.98,0.32l1.46,-0.2l0.24,-0.21l0.25,-0.79ZM789.24,303.52l0.11,0.15l2.19,1.62l1.6,2.62l0.27,0.14l1.09,-0.06l-0.07,0.77l0.23,0.32l1.23,0.27l-0.14,0.09l0.05,0.53l2.39,0.95l-0.11,0.28l-1.33,0.14l-0.51,-0.55l-0.18,-0.09l-4.59,-0.65l-1.87,-1.55l-1.38,-1.35l-1.28,-2.17l-0.16,-0.13l-3.27,-1.1l-0.19,0.0l-2.12,0.72l-1.58,0.85l-0.15,0.31l0.28,1.63l-1.65,0.73l-1.37,-0.4l-2.3,-0.09l-0.08,-15.65l3.95,1.57l4.58,1.42l1.67,1.25l1.32,1.19l0.36,1.39l0.19,0.21l4.06,1.51l0.39,0.85l-1.9,0.22l-0.25,0.39l0.55,1.68Z" data-code="PG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M246.44,329.21l-0.63,1.25l-1.05,0.54l-2.25,-1.33l-0.19,-0.93l-0.16,-0.21l-4.95,-2.58l-4.46,-2.79l-1.87,-1.52l-0.94,-1.91l0.33,-0.6l-0.01,-0.31l-2.11,-3.33l-2.46,-4.66l-2.36,-5.02l-1.04,-1.18l-0.77,-1.81l-0.08,-0.11l-1.95,-1.64l-1.54,-0.88l0.61,-0.85l0.02,-0.31l-1.15,-2.27l0.69,-1.56l1.59,-1.26l0.12,0.42l-0.56,0.47l-0.11,0.25l0.07,0.92l0.36,0.27l0.97,-0.19l0.85,0.23l0.99,1.19l0.41,0.05l1.42,-1.03l0.11,-0.16l0.46,-1.64l1.45,-2.06l2.92,-0.96l0.11,-0.07l2.73,-2.62l0.84,-1.72l0.02,-0.18l-0.3,-1.65l0.28,-0.1l1.49,1.06l0.77,1.14l0.1,0.09l1.08,0.6l1.43,2.55l0.21,0.15l1.86,0.31l0.18,-0.03l1.25,-0.6l0.77,0.37l0.17,0.03l1.4,-0.2l1.57,0.96l-1.45,2.29l0.23,0.46l0.63,0.05l0.66,0.7l-1.51,-0.08l-0.24,0.1l-0.27,0.31l-1.96,0.46l-2.95,1.74l-0.14,0.21l-0.17,1.1l-0.6,0.82l-0.05,0.23l0.21,1.13l-1.31,0.63l-0.17,0.27l0.0,0.91l-0.53,0.37l-0.1,0.37l1.04,2.27l1.31,1.46l-0.44,0.9l0.24,0.43l1.52,0.13l0.87,1.23l0.24,0.13l2.21,0.07l0.18,-0.06l1.55,-1.13l-0.14,3.22l0.23,0.3l1.14,0.29l0.16,-0.0l1.18,-0.36l1.97,3.71l-0.45,0.71l-0.04,0.14l-0.12,1.8l-0.05,2.07l-0.92,1.2l-0.03,0.31l0.38,0.8l-0.48,0.72l-0.02,0.3l1.01,2.02l-1.5,2.64Z" data-code="PE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M609.08,187.76l1.66,1.21l0.71,2.11l0.2,0.19l3.62,1.01l-1.98,1.95l-2.65,0.4l-3.75,-0.68l-0.26,0.08l-1.23,1.22l-0.07,0.31l0.89,2.46l0.88,1.92l0.1,0.12l1.67,1.14l-1.8,1.35l-0.12,0.25l0.04,1.85l-2.35,2.67l-1.59,2.79l-2.5,2.72l-2.76,-0.2l-0.24,0.09l-2.76,2.83l0.04,0.45l1.54,1.13l0.27,1.94l0.09,0.17l1.34,1.29l0.4,1.83l-5.14,-0.01l-0.22,0.09l-1.53,1.63l-1.52,-0.56l-0.76,-1.88l-1.93,-2.03l-0.25,-0.09l-4.6,0.5l-4.05,0.05l-3.1,0.33l0.77,-2.53l3.48,-1.33l0.19,-0.33l-0.21,-1.24l-0.19,-0.23l-1.01,-0.37l-0.06,-2.18l-0.17,-0.26l-2.32,-1.16l-0.96,-1.57l-0.56,-0.65l3.16,1.05l0.14,0.01l2.45,-0.4l1.44,0.33l0.3,-0.1l0.4,-0.47l1.58,0.22l0.14,-0.01l3.25,-1.14l0.2,-0.27l0.08,-2.23l1.23,-1.38l1.73,0.0l0.28,-0.2l0.22,-0.61l1.68,-0.32l0.86,0.24l0.27,-0.05l0.98,-0.78l0.11,-0.26l-0.13,-1.57l0.96,-1.52l1.51,-0.67l0.14,-0.41l-0.74,-1.4l1.86,0.07l0.26,-0.13l0.69,-1.01l0.05,-0.2l-0.09,-0.94l1.14,-1.09l0.09,-0.28l-0.29,-1.41l-0.51,-1.07l1.23,-1.05l2.6,-0.58l2.86,-0.33l1.33,-0.54l1.3,-0.29Z" data-code="PK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M737.11,263.82l0.25,1.66l0.14,1.34l-0.54,1.46l-0.64,-1.79l-0.5,-0.1l-1.17,1.28l-0.05,0.32l0.74,1.71l-0.49,0.81l-2.6,-1.28l-0.61,-1.57l0.68,-1.07l-0.07,-0.4l-1.59,-1.19l-0.42,0.06l-0.69,0.91l-1.01,-0.08l-0.21,0.06l-1.58,1.2l-0.17,-0.3l0.87,-1.88l1.48,-0.66l1.18,-0.81l0.71,0.92l0.34,0.1l1.9,-0.69l0.18,-0.18l0.34,-0.94l1.57,-0.06l0.29,-0.32l-0.1,-1.38l1.41,0.83l0.36,2.06ZM734.94,254.42l0.56,2.24l-1.41,-0.49l-0.4,0.3l0.07,0.94l0.51,1.3l-0.54,0.26l-0.08,-1.34l-0.25,-0.28l-0.56,-0.1l-0.23,-0.91l1.03,0.14l0.34,-0.31l-0.03,-0.96l-0.06,-0.18l-1.14,-1.44l1.62,0.04l0.57,0.78ZM724.68,238.33l1.48,0.71l0.33,-0.04l0.44,-0.38l0.05,0.13l-0.37,0.97l0.01,0.23l0.81,1.75l-0.59,1.92l-1.37,0.79l-0.14,0.2l-0.39,2.07l0.01,0.14l0.56,2.04l0.23,0.21l1.33,0.28l0.14,-0.0l1.0,-0.27l2.82,1.28l-0.2,1.16l0.12,0.29l0.66,0.5l-0.13,0.56l-1.54,-0.99l-0.89,-1.29l-0.49,0.0l-0.44,0.65l-1.34,-1.28l-0.26,-0.08l-2.18,0.36l-0.96,-0.44l0.09,-0.72l0.69,-0.57l-0.01,-0.47l-0.75,-0.59l-0.47,0.14l-0.15,0.43l-0.86,-1.02l-0.34,-1.02l-0.07,-1.74l0.49,0.41l0.49,-0.21l0.26,-3.99l0.73,-2.1l1.23,0.0ZM731.12,258.92l-0.82,0.75l-0.83,1.64l-0.52,0.5l-1.17,-1.33l0.36,-0.47l0.62,-0.7l0.07,-0.15l0.24,-1.35l0.73,-0.08l-0.31,1.29l0.16,0.34l0.37,-0.09l1.21,-1.6l-0.12,1.24ZM726.66,255.58l0.85,0.45l0.14,0.03l1.28,-0.0l-0.03,0.62l-1.04,0.96l-1.15,0.55l-0.05,-0.71l0.17,-1.26l-0.01,-0.13l-0.16,-0.51ZM724.92,252.06l-0.45,1.5l-0.7,-0.83l-0.95,-1.43l1.44,0.06l0.67,0.7ZM717.48,261.28l-1.87,1.35l0.21,-0.3l1.81,-1.57l1.5,-1.75l0.97,-1.84l0.23,1.08l-1.56,1.33l-1.29,1.7Z" data-code="PH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M458.8,144.25l-0.96,-1.98l0.18,-1.06l-0.01,-0.15l-0.62,-1.8l-0.82,-1.11l0.56,-0.73l0.05,-0.28l-0.51,-1.51l1.48,-0.87l3.88,-1.58l3.06,-1.14l2.23,0.52l0.15,0.66l0.29,0.23l2.4,0.04l3.11,0.39l4.56,-0.05l1.12,0.32l0.51,0.89l0.1,1.45l0.03,0.12l0.66,1.23l-0.01,1.08l-1.33,0.61l-0.14,0.41l0.74,1.5l0.07,1.53l1.22,2.79l-0.19,0.66l-1.09,0.33l-0.14,0.09l-2.27,2.72l-0.04,0.31l0.35,0.8l-2.22,-1.16l-0.21,-0.02l-1.72,0.44l-1.1,-0.31l-0.21,0.02l-1.3,0.61l-1.11,-1.02l-0.32,-0.05l-0.81,0.35l-1.15,-1.61l-0.21,-0.12l-1.65,-0.17l-0.19,-0.82l-0.23,-0.23l-1.72,-0.37l-0.34,0.17l-0.25,0.56l-0.88,-0.44l0.12,-0.69l-0.25,-0.35l-1.78,-0.27l-1.08,-0.97Z" data-code="PL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M502.81,308.32l1.09,1.04l0.58,1.94l-0.39,0.66l-0.5,2.05l-0.0,0.14l0.45,1.95l-0.69,0.77l-0.06,0.11l-0.76,2.37l0.15,0.36l0.62,0.31l-6.85,1.9l-0.22,0.33l0.2,1.54l-1.62,0.3l-0.12,0.05l-1.43,1.02l-0.11,0.15l-0.25,0.73l-0.73,0.17l-0.14,0.08l-2.18,2.12l-1.33,1.6l-0.65,0.05l-0.83,-0.29l-2.75,-0.28l-0.24,-0.1l-0.15,-0.27l-0.99,-0.58l-0.12,-0.04l-1.73,-0.14l-1.88,0.54l-1.5,-1.48l-1.61,-2.01l0.11,-7.73l4.92,0.03l0.29,-0.37l-0.19,-0.79l0.34,-0.86l0.0,-0.21l-0.41,-1.11l0.26,-1.14l-0.01,-0.16l-0.12,-0.36l0.18,0.01l0.1,0.56l0.31,0.25l1.14,-0.06l1.44,0.21l0.76,1.05l0.19,0.12l2.01,0.35l0.19,-0.03l1.24,-0.65l0.44,1.03l0.22,0.18l1.81,0.34l0.85,0.99l1.02,1.39l0.24,0.12l1.92,0.02l0.3,-0.32l-0.21,-2.74l-0.47,-0.23l-0.53,0.36l-1.58,-0.89l-0.51,-0.34l0.29,-2.36l0.44,-2.99l-0.03,-0.18l-0.5,-0.99l0.61,-1.38l0.53,-0.24l3.26,-0.41l0.89,0.23l1.01,0.62l1.04,0.44l1.6,0.43l1.35,0.72Z" data-code="ZM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M482.19,120.88l0.23,-1.68l-0.43,-0.31l-0.75,0.37l-1.34,-1.1l-0.18,-1.75l2.92,-0.95l3.07,-0.53l2.66,0.6l2.48,-0.1l0.18,0.31l-1.65,1.96l-0.06,0.26l0.71,3.25l-0.88,0.94l-1.85,-0.01l-2.08,-1.3l-1.14,-0.47l-0.2,-0.01l-1.69,0.51Z" data-code="EE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M508.07,208.8l-0.66,1.06l-0.53,2.03l-0.64,1.32l-0.32,0.26l-1.74,-1.85l-1.77,-3.86l-0.48,-0.09l-0.26,0.25l-0.07,0.32l1.04,2.88l1.55,2.76l1.89,4.18l0.94,1.48l0.83,1.54l2.08,2.73l-0.3,0.28l-0.1,0.23l0.08,1.72l0.11,0.22l2.91,2.37l-28.78,0.0l0.0,-19.06l-0.73,-2.2l0.61,-1.59l0.0,-0.2l-0.34,-1.04l0.73,-1.08l3.13,-0.04l2.36,0.72l2.48,0.81l1.15,0.43l0.23,-0.01l1.93,-0.87l1.02,-0.78l2.08,-0.21l1.59,0.31l0.62,1.24l0.52,0.03l0.46,-0.71l1.86,0.59l1.95,0.16l0.17,-0.04l0.92,-0.52l1.48,4.24Z" data-code="EG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M467.06,373.27l-0.13,-0.29l0.01,-1.58l-0.02,-0.12l-0.71,-1.64l0.59,-0.37l0.14,-0.26l-0.07,-2.13l-0.05,-0.15l-1.63,-2.58l-1.25,-2.31l-1.71,-3.37l0.88,-0.98l0.7,0.52l0.39,1.08l0.23,0.19l1.1,0.19l1.55,0.51l0.14,0.01l1.35,-0.2l0.11,-0.04l2.24,-1.39l0.14,-0.25l0.0,-9.4l0.16,0.09l1.39,2.38l-0.22,1.53l0.04,0.19l0.56,0.94l0.3,0.14l1.79,-0.27l0.16,-0.08l1.23,-1.18l1.17,-0.79l0.1,-0.12l0.57,-1.19l1.02,-0.52l0.9,0.28l1.16,0.73l0.14,0.05l2.04,0.13l0.13,-0.02l1.6,-0.62l0.18,-0.19l0.63,-1.93l1.18,-0.19l0.19,-0.12l0.78,-1.05l0.81,-1.71l2.18,-1.91l3.44,-1.88l0.89,0.02l1.17,0.43l0.21,-0.0l0.76,-0.29l1.07,0.21l1.15,3.55l0.63,1.82l-0.44,2.9l0.1,0.52l-0.74,-0.29l-0.18,-0.01l-0.72,0.19l-0.21,0.2l-0.22,0.74l-0.66,0.97l-0.05,0.18l0.02,0.93l0.09,0.21l1.49,1.46l0.27,0.08l1.47,-0.29l0.22,-0.18l0.43,-1.01l1.29,0.02l-0.51,1.63l-0.29,2.2l-0.59,1.12l-2.2,1.78l-1.06,1.39l-0.72,1.44l-1.39,1.93l-2.81,2.84l-1.75,1.65l-1.85,1.24l-2.55,1.06l-1.23,0.14l-0.24,0.18l-0.22,0.54l-1.27,-0.35l-0.2,0.01l-1.15,0.5l-2.62,-0.52l-0.12,0.0l-1.46,0.33l-0.98,-0.14l-0.16,0.02l-2.55,1.1l-2.11,0.44l-1.59,1.07l-0.93,0.06l-0.97,-0.92l-0.19,-0.08l-0.72,-0.04l-1.0,-1.16l-0.25,0.05ZM493.72,359.24l-1.12,-0.86l-0.31,-0.03l-1.23,0.59l-1.36,1.07l-1.39,1.78l0.01,0.38l1.88,2.11l0.31,0.09l0.9,-0.27l0.18,-0.15l0.4,-0.77l1.28,-0.39l0.18,-0.16l0.42,-0.88l0.76,-1.32l-0.05,-0.37l-0.87,-0.82Z" data-code="ZA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M220.2,293.48l1.25,-1.76l0.02,-0.31l-0.54,-1.09l-0.5,-0.06l-0.78,0.94l-1.03,-0.75l0.33,-0.46l0.05,-0.23l-0.38,-2.04l0.66,-0.28l0.17,-0.19l0.45,-1.52l0.93,-1.58l0.04,-0.2l-0.13,-0.78l1.19,-0.47l1.57,-0.91l2.35,1.34l0.17,0.04l0.28,-0.02l0.52,0.91l0.21,0.15l2.12,0.35l0.2,-0.03l0.55,-0.31l1.08,0.73l0.97,0.54l0.31,1.67l-0.71,1.49l-2.64,2.54l-2.95,0.97l-0.15,0.11l-1.53,2.18l-0.49,1.68l-1.1,0.8l-0.87,-1.05l-0.15,-0.1l-1.01,-0.27l-0.13,-0.0l-0.7,0.14l-0.03,-0.43l0.6,-0.5l0.1,-0.31l-0.26,-0.91Z" data-code="EC" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M470.27,171.7l0.38,0.19l0.45,-0.18l0.4,0.61l0.11,0.1l0.46,0.24l0.13,0.87l-0.3,0.95l-0.0,0.17l0.36,1.28l0.12,0.17l0.9,0.63l-0.03,0.44l-0.67,0.35l-0.16,0.22l-0.14,0.88l-0.96,1.18l-0.06,-0.03l-0.04,-0.48l-0.12,-0.22l-1.28,-0.92l-0.19,-1.25l0.2,-1.96l0.33,-0.89l-0.06,-0.3l-0.36,-0.41l-0.13,-0.75l0.66,-0.9Z" data-code="AL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M461.62,299.93l0.55,1.67l0.73,1.54l1.56,2.18l0.28,0.12l1.66,-0.2l0.81,-0.34l1.28,0.33l0.33,-0.14l0.39,-0.67l0.56,-1.3l1.37,-0.09l0.27,-0.21l0.07,-0.23l0.67,-0.01l-0.13,0.53l0.29,0.37l2.74,-0.02l0.04,1.29l0.03,0.13l0.46,0.87l-0.35,1.52l0.18,1.55l0.07,0.16l0.75,0.85l-0.13,2.89l0.41,0.29l0.56,-0.21l1.11,0.05l1.5,-0.37l0.9,0.12l0.18,0.53l-0.27,1.15l0.01,0.17l0.4,1.08l-0.33,0.85l-0.01,0.18l0.12,0.51l-4.83,-0.03l-0.3,0.3l-0.12,8.13l0.07,0.19l1.69,2.1l1.27,1.25l-4.03,0.92l-5.93,-0.36l-1.66,-1.19l-0.18,-0.06l-10.15,0.11l-0.34,0.13l-1.35,-1.05l-0.17,-0.06l-1.62,-0.08l-1.6,0.45l-0.88,0.36l-0.17,-1.2l0.34,-2.19l0.85,-2.32l0.14,-1.13l0.79,-2.24l0.57,-1.0l1.42,-1.64l0.82,-1.15l0.05,-0.13l0.26,-1.88l-0.13,-1.51l-0.07,-0.16l-0.72,-0.87l-1.23,-2.91l0.09,-0.37l0.73,-0.95l0.05,-0.27l-1.27,-4.12l-1.19,-1.54l0.1,-0.2l0.86,-0.28l0.78,0.03l0.83,-0.29l7.12,0.03ZM451.81,298.94l-0.17,0.07l-0.5,-1.42l0.85,-0.92l0.53,-0.29l0.48,0.44l-0.56,0.32l-0.1,0.1l-0.41,0.65l-0.05,0.14l-0.07,0.91Z" data-code="AO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M598.42,172.08l-1.37,0.54l-3.3,2.09l-0.11,0.12l-1.01,1.97l-0.56,0.01l-0.6,-1.24l-0.26,-0.17l-2.95,-0.09l-0.46,-2.22l-0.29,-0.24l-0.91,-0.02l0.17,-2.72l-0.12,-0.26l-3.0,-2.22l-0.2,-0.06l-4.29,0.24l-2.8,0.42l-2.36,-2.7l-6.4,-3.65l-0.23,-0.03l-6.45,1.83l-0.22,0.29l0.1,10.94l-0.84,0.1l-1.65,-2.21l-0.11,-0.09l-1.69,-0.84l-0.2,-0.02l-2.84,0.63l-0.14,0.07l-0.71,0.64l-0.02,-0.11l0.57,-1.17l0.0,-0.26l-0.48,-1.05l-0.17,-0.16l-2.78,-0.99l-1.08,-2.62l-0.13,-0.15l-1.24,-0.7l-0.04,-0.48l2.07,0.25l0.34,-0.29l0.09,-2.03l1.84,-0.44l2.12,0.45l0.36,-0.25l0.45,-3.04l-0.45,-2.06l-0.31,-0.23l-2.44,0.15l-2.07,-0.75l-0.23,0.01l-2.88,1.38l-2.21,0.62l-0.96,-0.38l0.22,-1.39l-0.06,-0.23l-1.6,-2.12l-0.25,-0.12l-1.72,0.08l-1.87,-1.91l1.33,-2.24l-0.06,-0.38l-0.55,-0.5l1.72,-3.08l2.3,1.7l0.48,-0.2l0.29,-2.26l4.99,-3.48l3.76,-0.08l5.46,2.27l2.96,1.33l0.26,-0.01l2.59,-1.36l3.82,-0.06l3.13,1.67l0.38,-0.09l0.63,-0.85l3.36,0.14l0.29,-0.19l0.63,-1.57l-0.13,-0.37l-3.64,-2.05l2.0,-1.36l0.1,-0.38l-0.32,-0.62l2.09,-0.76l0.13,-0.47l-1.65,-2.13l0.89,-0.91l9.27,-1.18l0.13,-0.05l1.17,-0.82l6.2,-1.27l2.26,-1.43l4.19,0.7l0.74,3.39l0.38,0.22l2.52,-0.81l2.9,1.06l-0.18,1.63l0.32,0.33l2.52,-0.23l5.0,-2.58l0.03,0.39l3.16,2.62l5.57,8.48l0.49,0.02l1.18,-1.53l3.22,1.78l0.21,0.03l3.5,-0.83l1.21,0.52l1.16,1.82l0.15,0.12l1.67,0.61l1.01,1.32l0.28,0.11l3.04,-0.41l1.1,1.64l-1.68,1.89l-1.97,0.28l-0.26,0.29l-0.12,3.09l-1.2,1.23l-4.81,-1.01l-0.35,0.2l-1.77,5.51l-1.14,0.62l-4.92,1.23l-0.2,0.41l2.14,5.06l-1.45,0.67l-0.17,0.31l0.15,1.28l-1.05,-0.3l-1.21,-1.04l-0.17,-0.07l-3.73,-0.32l-4.15,-0.08l-0.92,0.31l-3.46,-1.24l-0.22,0.01l-1.42,0.63l-0.17,0.21l-0.32,1.49l-3.82,-0.97l-0.15,0.0l-1.65,0.43l-0.2,0.17l-0.51,1.21Z" data-code="KZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M516.0,247.63l1.21,0.92l0.3,0.04l1.3,-0.53l0.46,0.41l0.19,0.08l1.65,0.03l2.05,0.96l0.67,0.88l1.07,0.79l1.0,1.45l0.7,0.68l-0.72,0.92l-0.85,1.19l-0.04,0.25l0.19,0.67l0.04,0.74l0.29,0.28l1.4,0.04l0.55,-0.15l0.23,0.19l-0.41,0.67l0.01,0.32l0.92,1.39l0.93,1.23l0.99,0.94l0.1,0.06l8.19,2.99l1.51,0.01l-6.51,6.95l-3.14,0.11l-0.18,0.06l-2.15,1.71l-1.51,0.04l-0.22,0.1l-0.6,0.69l-1.46,-0.0l-0.93,-0.78l-0.32,-0.04l-2.29,1.05l-0.12,0.1l-0.64,0.9l-1.44,-0.17l-0.51,-0.26l-0.17,-0.03l-0.56,0.07l-0.68,-0.02l-3.1,-2.08l-0.17,-0.05l-1.62,0.0l-0.68,-0.65l0.0,-1.28l-0.21,-0.29l-1.19,-0.38l-1.42,-2.63l-0.13,-0.12l-1.05,-0.53l-0.46,-1.0l-1.27,-1.23l-0.17,-0.08l-1.08,-0.13l0.53,-0.9l1.17,-0.05l0.26,-0.17l0.37,-0.77l0.03,-0.14l-0.03,-2.23l0.7,-2.49l1.08,-0.65l0.14,-0.19l0.24,-1.0l1.03,-1.85l1.47,-1.22l0.09,-0.12l1.02,-2.51l0.36,-1.96l2.62,0.48l0.33,-0.18l0.63,-1.55Z" data-code="ET" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M498.95,341.2l-1.16,-0.23l-0.16,0.01l-0.74,0.28l-1.11,-0.41l-1.02,-0.04l-1.52,-1.13l-0.12,-0.05l-1.79,-0.37l-0.65,-1.46l-0.01,-0.86l-0.22,-0.29l-0.99,-0.26l-2.74,-2.77l-0.77,-1.46l-0.52,-0.5l-0.72,-1.54l2.24,0.23l0.78,0.28l0.12,0.02l0.85,-0.06l0.21,-0.11l1.38,-1.66l2.11,-2.05l0.81,-0.18l0.22,-0.2l0.27,-0.8l1.29,-0.93l1.53,-0.28l0.11,0.66l0.3,0.25l2.02,-0.05l1.04,0.48l0.5,0.59l0.18,0.1l1.13,0.18l1.11,0.7l0.01,3.06l-0.49,1.82l-0.11,1.94l0.03,0.16l0.35,0.68l-0.24,1.3l-0.27,0.17l-0.12,0.15l-0.64,1.83l-2.49,2.8Z" data-code="ZW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M398.67,172.8l0.09,-1.45l-0.06,-0.2l-0.82,-1.05l3.16,-1.96l3.01,0.54l3.33,-0.02l2.64,0.52l2.14,-0.15l3.9,0.1l0.91,1.08l0.14,0.09l4.61,1.38l0.26,-0.04l0.77,-0.55l2.66,1.29l0.17,0.03l2.59,-0.35l0.1,1.28l-2.2,1.85l-3.13,0.62l-0.23,0.23l-0.21,0.92l-1.54,1.68l-0.97,2.4l0.02,0.26l0.85,1.46l-1.27,1.14l-0.09,0.14l-0.5,1.73l-1.73,0.53l-0.15,0.1l-1.68,2.1l-3.03,0.04l-2.38,-0.05l-0.17,0.05l-1.57,1.01l-0.9,1.01l-0.96,-0.19l-0.82,-0.86l-0.69,-1.6l-0.22,-0.18l-2.14,-0.41l-0.13,-0.62l0.83,-0.97l0.39,-0.86l-0.06,-0.33l-0.73,-0.73l0.63,-1.74l-0.02,-0.25l-0.8,-1.41l0.69,-0.15l0.23,-0.27l0.09,-1.29l0.33,-0.36l0.08,-0.2l0.03,-2.16l1.03,-0.72l0.1,-0.37l-0.7,-1.5l-0.25,-0.17l-1.46,-0.11l-0.22,0.07l-0.34,0.3l-1.17,0.0l-0.55,-1.29l-0.39,-0.16l-1.02,0.44l-0.45,0.36Z" data-code="ES" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M527.15,253.05l-0.77,-0.74l-1.01,-1.47l-1.14,-0.86l-0.62,-0.84l-0.11,-0.09l-2.18,-1.02l-0.12,-0.03l-1.61,-0.03l-0.52,-0.46l-0.31,-0.05l-1.31,0.54l-1.38,-1.06l-0.46,0.12l-0.69,1.68l-2.49,-0.46l-0.2,-0.76l1.06,-3.69l0.24,-1.65l0.66,-0.66l1.76,-0.4l0.16,-0.1l0.97,-1.13l1.24,2.55l0.68,2.34l0.09,0.14l1.4,1.27l3.39,2.4l1.37,1.43l2.14,2.34l0.94,0.6l-0.32,0.26l-0.85,-0.17Z" data-code="ER" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M469.05,172.9l-0.57,-0.8l-0.1,-0.09l-0.82,-0.46l0.16,-0.33l0.35,-1.57l0.72,-0.62l0.27,-0.16l0.48,0.38l0.35,0.4l0.12,0.08l0.79,0.32l0.66,0.43l-0.43,0.62l-0.28,0.11l-0.07,-0.25l-0.53,-0.1l-1.09,1.49l-0.05,0.23l0.06,0.32Z" data-code="ME" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M488.2,153.75l0.14,-0.11l1.49,-0.28l1.75,0.95l1.06,0.14l0.92,0.7l-0.15,0.9l0.15,0.31l0.8,0.46l0.33,1.2l0.09,0.14l0.72,0.66l-0.11,0.28l0.1,0.33l-0.06,0.02l-1.25,-0.08l-0.17,-0.29l-0.39,-0.12l-0.52,0.25l-0.16,0.36l0.13,0.42l-0.6,0.88l-0.43,1.03l-0.22,0.12l-0.32,-1.0l0.25,-1.34l-0.08,-1.38l-0.06,-0.17l-1.43,-1.87l-0.81,-1.36l-0.78,-0.95l-0.12,-0.09l-0.29,-0.12Z" data-code="MD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M544.77,316.45l0.64,1.04l0.6,1.62l0.4,3.04l0.63,1.21l-0.22,1.07l-0.15,0.26l-0.59,-1.05l-0.52,-0.01l-0.47,0.76l-0.04,0.23l0.46,1.84l-0.19,0.92l-0.61,0.53l-0.1,0.21l-0.16,2.15l-0.97,2.98l-1.24,3.59l-1.55,4.97l-0.96,3.67l-1.08,2.93l-1.94,0.61l-2.05,1.06l-3.2,-1.53l-0.62,-1.26l-0.18,-2.39l-0.87,-2.07l-0.22,-1.8l0.4,-1.69l1.01,-0.4l0.19,-0.28l0.01,-0.79l1.15,-1.91l0.04,-0.11l0.23,-1.66l-0.03,-0.17l-0.57,-1.21l-0.46,-1.58l-0.19,-2.25l0.82,-1.36l0.33,-1.51l1.11,-0.1l1.4,-0.53l0.9,-0.45l1.03,-0.03l0.21,-0.09l1.41,-1.45l2.12,-1.65l0.75,-1.29l0.03,-0.24l-0.17,-0.56l0.53,0.15l0.32,-0.1l1.38,-1.77l0.06,-0.18l0.04,-1.44l0.54,-0.74l0.62,0.77Z" data-code="MG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M378.66,230.13l0.07,-0.75l0.93,-0.72l0.82,-1.37l0.04,-0.21l-0.14,-0.8l0.8,-1.74l1.33,-1.61l0.79,-0.4l0.14,-0.15l0.66,-1.55l0.08,-1.46l0.83,-1.52l1.6,-0.94l0.11,-0.11l1.56,-2.71l1.2,-0.99l2.24,-0.29l0.17,-0.08l1.95,-1.83l1.3,-0.77l2.09,-2.28l0.07,-0.26l-0.61,-3.34l0.92,-2.3l0.33,-1.44l1.52,-1.79l2.48,-1.27l1.86,-1.16l0.1,-0.11l1.67,-2.93l0.72,-1.59l1.54,0.01l1.43,1.14l0.21,0.06l2.33,-0.19l2.55,0.62l0.97,0.03l0.83,1.6l0.15,1.71l0.86,2.96l0.09,0.14l0.5,0.45l-0.31,0.73l-3.11,0.44l-0.16,0.07l-1.07,0.97l-1.36,0.23l-0.25,0.28l-0.1,1.85l-2.74,1.02l-0.14,0.11l-0.9,1.3l-1.93,0.69l-2.56,0.44l-4.04,2.01l-0.17,0.27l0.02,2.91l-0.08,0.0l-0.3,0.31l0.05,1.15l-1.25,0.07l-0.16,0.06l-0.73,0.55l-0.98,0.0l-0.85,-0.33l-0.15,-0.02l-2.11,0.29l-0.24,0.19l-0.76,1.95l-0.63,0.16l-0.21,0.19l-1.15,3.29l-3.42,2.81l-0.1,0.17l-0.81,3.57l-0.98,1.12l-0.3,0.85l-5.13,0.19Z" data-code="MA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M587.83,186.48l0.06,-1.46l-0.19,-0.29l-3.31,-1.24l-2.57,-1.4l-1.63,-1.38l-2.79,-1.98l-1.2,-2.98l-0.12,-0.14l-0.84,-0.54l-0.18,-0.05l-2.61,0.13l-0.76,-0.48l-0.25,-2.25l-0.17,-0.24l-3.37,-1.6l-0.32,0.04l-2.08,1.73l-2.11,1.02l-0.16,0.35l0.31,1.14l-2.14,0.03l-0.09,-10.68l6.1,-1.74l6.25,3.57l2.36,2.72l0.27,0.1l2.92,-0.44l4.17,-0.23l2.78,2.06l-0.18,2.87l0.29,0.32l0.98,0.02l0.46,2.22l0.28,0.24l3.0,0.09l0.61,1.25l0.28,0.17l0.93,-0.02l0.26,-0.16l1.06,-2.06l3.21,-2.03l1.3,-0.5l0.19,0.08l-1.75,1.62l0.05,0.48l1.85,1.12l0.27,0.02l1.65,-0.69l2.4,1.27l-2.69,1.79l-1.79,-0.27l-0.89,0.06l-0.22,-0.52l0.48,-1.26l-0.34,-0.4l-3.35,0.69l-0.22,0.18l-0.78,1.87l-1.07,1.47l-1.93,-0.13l-0.29,0.16l-0.65,1.29l0.16,0.42l1.69,0.64l0.48,1.91l-1.25,2.6l-1.64,-0.53l-1.18,-0.03Z" data-code="UZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M670.1,233.39l-1.46,1.11l-1.68,0.11l-0.26,0.19l-1.1,2.7l-0.95,0.42l-0.14,0.42l1.21,2.27l1.61,1.92l0.94,1.55l-0.82,1.99l-0.77,0.42l-0.13,0.39l0.64,1.35l1.62,1.97l0.26,1.32l-0.04,1.15l0.02,0.13l0.92,2.18l-1.3,2.23l-0.79,1.69l-0.1,-0.77l0.74,-1.87l-0.02,-0.26l-0.8,-1.42l0.2,-2.68l-0.06,-0.2l-0.98,-1.27l-0.8,-2.98l-0.45,-3.22l-1.11,-2.22l-0.45,-0.1l-1.64,1.28l-2.74,1.76l-1.26,-0.2l-1.27,-0.49l0.79,-2.93l0.0,-0.14l-0.52,-2.42l-1.93,-2.97l0.26,-0.8l-0.22,-0.39l-1.37,-0.31l-1.65,-1.98l-0.12,-1.5l0.41,0.19l0.42,-0.26l0.05,-1.7l1.08,-0.54l0.16,-0.34l-0.24,-1.0l0.5,-0.79l0.05,-0.15l0.08,-2.35l1.58,0.49l0.36,-0.15l1.12,-2.19l0.15,-1.34l1.35,-2.18l0.04,-0.17l-0.07,-1.35l2.97,-1.71l1.67,0.45l0.38,-0.33l-0.18,-1.46l0.7,-0.4l0.15,-0.32l-0.13,-0.72l0.94,-0.13l0.74,1.41l0.11,0.12l0.95,0.56l0.07,1.89l-0.09,2.08l-2.28,2.15l-0.09,0.19l-0.3,3.15l0.35,0.32l2.37,-0.39l0.53,2.17l0.2,0.21l1.3,0.42l-0.63,1.9l0.14,0.36l1.86,0.99l1.1,0.49l0.24,0.0l1.45,-0.6l0.04,0.51l-2.01,1.6l-0.56,0.96l-1.34,0.56Z" data-code="MM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M390.79,248.2l0.67,-0.37l0.14,-0.18l0.36,-1.31l0.51,-0.04l1.68,0.69l0.21,0.0l1.34,-0.48l0.89,0.16l0.3,-0.13l0.29,-0.44l9.89,-0.04l0.29,-0.21l0.56,-1.8l-0.11,-0.33l-0.33,-0.24l-2.37,-22.1l3.41,-0.04l8.37,5.73l8.38,5.68l0.56,1.15l0.14,0.14l1.56,0.75l0.99,0.36l0.03,1.45l0.33,0.29l2.45,-0.22l0.01,5.52l-1.3,1.64l-0.06,0.15l-0.18,1.37l-1.99,0.36l-3.4,0.22l-0.19,0.09l-0.85,0.83l-1.48,0.09l-1.49,0.01l-0.54,-0.43l-0.26,-0.05l-1.38,0.36l-2.39,1.08l-0.13,0.12l-0.44,0.73l-1.88,1.11l-0.11,0.12l-0.3,0.57l-0.86,0.42l-1.1,-0.31l-0.28,0.07l-0.69,0.62l-0.09,0.16l-0.35,1.66l-1.93,2.04l-0.08,0.23l0.05,0.76l-0.63,0.99l-0.04,0.19l0.14,1.23l-0.81,0.29l-0.32,0.17l-0.27,-0.75l-0.39,-0.18l-0.65,0.26l-0.36,-0.04l-0.29,0.14l-0.37,0.6l-1.69,-0.02l-0.63,-0.34l-0.32,0.02l-0.12,0.09l-0.47,-0.45l0.1,-0.6l-0.09,-0.27l-0.31,-0.3l-0.33,-0.05l-0.05,0.02l0.02,-0.21l0.46,-0.59l-0.02,-0.39l-0.99,-1.02l-0.34,-0.74l-0.56,-0.56l-0.17,-0.09l-0.5,-0.07l-0.19,0.04l-0.58,0.35l-0.79,0.33l-0.65,0.51l-0.85,-0.16l-0.63,-0.59l-0.14,-0.07l-0.41,-0.08l-0.2,0.03l-0.59,0.31l-0.07,0.0l-0.1,-0.63l0.11,-0.85l-0.21,-0.98l-0.11,-0.17l-0.86,-0.66l-0.45,-1.34l-0.1,-1.36Z" data-code="ML" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M641.06,150.59l2.41,-0.53l4.76,-2.8l3.67,-1.49l2.06,0.96l0.12,0.03l2.5,0.05l1.59,1.45l0.19,0.08l2.47,0.12l3.59,0.81l0.27,-0.07l2.43,-2.28l0.06,-0.36l-0.93,-1.77l2.33,-3.1l2.66,1.3l2.26,0.39l2.75,0.8l0.44,2.3l0.19,0.22l3.56,1.38l0.18,0.01l2.35,-0.6l3.1,-0.42l2.4,0.41l2.37,1.52l1.49,1.63l0.23,0.1l2.29,-0.03l3.13,0.52l0.15,-0.01l2.28,-0.79l3.27,-0.53l0.11,-0.04l3.56,-2.23l1.31,0.31l1.26,1.05l0.22,0.07l2.45,-0.22l-0.98,1.96l-1.77,3.21l-0.01,0.28l0.64,1.31l0.35,0.16l1.35,-0.38l2.4,0.48l0.22,-0.04l1.78,-1.09l1.82,0.92l2.11,2.07l-0.17,0.68l-1.79,-0.31l-3.74,0.45l-1.85,0.96l-1.78,2.01l-3.74,1.18l-2.46,1.61l-2.45,-0.6l-1.42,-0.28l-0.31,0.13l-1.31,1.99l0.0,0.33l0.78,1.15l0.3,0.74l-1.58,0.93l-1.75,1.59l-2.83,1.03l-3.77,0.12l-4.05,1.05l-2.81,1.54l-0.95,-0.8l-0.19,-0.07l-2.96,0.0l-3.64,-1.8l-2.55,-0.48l-3.38,0.41l-5.13,-0.67l-2.66,0.06l-1.35,-1.65l-1.12,-2.78l-0.21,-0.18l-1.5,-0.33l-2.98,-1.89l-0.12,-0.04l-3.37,-0.43l-2.84,-0.51l-0.75,-1.13l0.93,-3.54l-0.04,-0.24l-1.73,-2.55l-0.15,-0.12l-3.52,-1.18l-1.99,-1.61l-0.54,-1.85Z" data-code="MN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M472.73,173.87l0.08,0.01l0.32,-0.25l0.08,-0.44l1.29,-0.41l1.37,-0.28l1.03,-0.04l1.06,0.82l0.14,1.59l-0.22,0.04l-0.17,0.11l-0.32,0.4l-1.2,-0.05l-0.18,0.05l-0.9,0.61l-1.45,0.23l-0.85,-0.59l-0.3,-1.09l0.22,-0.71Z" data-code="MK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M507.18,313.84l-0.67,1.85l-0.01,0.16l0.7,3.31l0.31,0.24l0.75,-0.03l0.78,0.71l0.99,1.75l0.2,3.03l-0.91,0.45l-0.14,0.15l-0.59,1.38l-1.24,-1.21l-0.17,-1.62l0.49,-1.12l0.02,-0.16l-0.15,-1.03l-0.13,-0.21l-0.99,-0.65l-0.26,-0.03l-0.53,0.18l-1.31,-1.12l-1.15,-0.59l0.66,-2.06l0.75,-0.84l0.07,-0.27l-0.47,-2.04l0.48,-1.94l0.4,-0.65l0.03,-0.24l-0.64,-2.15l-0.08,-0.13l-0.44,-0.42l1.34,0.26l1.25,1.73l0.67,3.3Z" data-code="MW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M390.54,247.66l-1.48,-1.58l-1.51,-1.88l-0.12,-0.09l-1.64,-0.67l-1.17,-0.74l-0.17,-0.05l-1.4,0.03l-0.12,0.03l-1.14,0.52l-1.15,-0.21l-0.26,0.08l-0.44,0.43l-0.11,-0.72l0.68,-1.29l0.31,-2.43l-0.28,-2.63l-0.29,-1.27l0.24,-1.24l-0.03,-0.2l-0.65,-1.24l-1.19,-1.05l0.32,-0.51l9.64,0.02l0.3,-0.34l-0.46,-3.71l0.51,-1.12l2.17,-0.22l0.27,-0.3l-0.08,-6.5l7.91,0.13l0.31,-0.3l0.01,-3.5l8.17,5.63l-2.89,0.04l-0.29,0.33l2.42,22.56l0.12,0.21l0.26,0.19l-0.43,1.38l-9.83,0.04l-0.25,0.13l-0.27,0.41l-0.77,-0.14l-0.15,0.01l-1.3,0.47l-1.64,-0.67l-0.14,-0.02l-0.79,0.06l-0.27,0.22l-0.39,1.39l-0.53,0.29Z" data-code="MR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M500.74,287.17l-2.84,-0.02l-0.92,0.32l-1.37,0.71l-0.29,-0.12l0.02,-1.6l0.54,-0.89l0.04,-0.13l0.14,-1.96l0.49,-1.09l0.91,-1.24l0.97,-0.68l0.8,-0.89l-0.13,-0.49l-0.79,-0.27l0.13,-2.55l0.78,-0.52l1.45,0.51l0.18,0.01l1.97,-0.57l1.72,0.01l0.18,-0.06l1.29,-0.97l0.98,1.44l0.29,1.24l1.05,2.75l-0.84,1.68l-1.94,2.66l-0.06,0.18l0.02,2.36l-4.8,0.18Z" data-code="UG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M717.6,273.52l-1.51,0.7l-2.13,-0.41l-2.88,-0.0l-0.29,0.21l-0.84,2.77l-0.9,0.82l-0.08,0.12l-1.23,3.34l-1.81,0.47l-2.29,-0.68l-0.14,-0.01l-1.2,0.22l-0.14,0.07l-1.36,1.18l-1.47,-0.17l-0.12,0.01l-1.46,0.46l-1.51,-1.25l-0.24,-0.97l1.26,0.59l0.2,0.02l1.93,-0.47l0.22,-0.22l0.47,-1.98l0.9,-0.4l2.97,-0.54l0.17,-0.09l1.8,-1.98l1.02,-1.32l0.9,1.03l0.48,-0.04l0.43,-0.7l1.02,0.07l0.32,-0.27l0.25,-2.72l1.84,-1.67l1.23,-1.89l0.73,-0.01l1.12,1.11l0.1,0.99l0.18,0.24l1.66,0.71l1.85,0.67l-0.09,0.51l-1.45,0.11l-0.26,0.4l0.35,0.97ZM673.78,269.53l0.17,1.14l0.35,0.25l1.65,-0.3l0.18,-0.11l0.68,-0.86l0.31,0.13l1.41,1.45l0.99,1.59l0.13,1.57l-0.26,1.09l0.0,0.15l0.24,0.84l0.18,1.46l0.11,0.2l0.82,0.64l0.92,2.08l-0.03,0.52l-1.4,0.13l-2.29,-1.79l-2.86,-1.92l-0.27,-1.16l-0.07,-0.13l-1.39,-1.61l-0.33,-1.99l-0.05,-0.12l-0.84,-1.27l0.26,-1.72l-0.03,-0.18l-0.45,-0.87l0.13,-0.13l1.71,0.92Z" data-code="MY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M133.41,213.83l0.61,0.09l0.27,-0.09l0.93,-1.01l0.08,-0.18l0.09,-1.22l-0.09,-0.23l-1.93,-1.94l-1.46,-0.77l-2.96,-5.62l-0.86,-2.1l2.44,-0.18l2.68,-0.25l-0.03,0.08l0.17,0.4l3.79,1.35l5.81,1.97l6.96,-0.02l0.3,-0.3l0.0,-0.84l3.91,0.0l0.87,0.93l1.27,0.87l1.44,1.17l0.79,1.37l0.62,1.49l0.12,0.14l1.35,0.85l2.08,0.82l0.35,-0.1l1.49,-2.04l1.81,-0.05l1.63,1.01l1.21,1.8l0.86,1.58l1.47,1.55l0.53,1.82l0.73,1.32l0.14,0.13l1.98,0.84l1.78,0.59l0.61,-0.03l-0.78,1.89l-0.45,1.96l-0.19,3.58l-0.24,1.27l0.01,0.14l0.43,1.43l0.78,1.31l0.49,1.98l0.06,0.12l1.63,1.9l0.61,1.51l0.98,1.28l0.16,0.11l2.58,0.67l0.98,1.02l0.31,0.08l2.17,-0.71l1.91,-0.26l1.87,-0.47l1.67,-0.49l1.59,-1.06l0.11,-0.14l0.6,-1.52l0.22,-2.21l0.35,-0.62l1.58,-0.64l2.59,-0.59l2.18,0.09l1.43,-0.2l0.39,0.36l-0.07,1.02l-1.28,1.48l-0.65,1.68l0.07,0.32l0.33,0.32l-0.79,2.49l-0.28,-0.3l-0.24,-0.09l-1.0,0.08l-0.24,0.15l-0.74,1.28l-0.19,-0.13l-0.28,-0.03l-0.3,0.12l-0.19,0.29l0.0,0.06l-4.34,-0.02l-0.3,0.3l-0.0,1.16l-0.83,0.0l-0.28,0.19l0.08,0.33l0.93,0.86l0.9,0.58l0.24,0.48l0.16,0.15l0.2,0.08l-0.03,0.38l-2.94,0.01l-0.26,0.15l-1.21,2.09l0.02,0.33l0.25,0.33l-0.21,0.44l-0.04,0.22l-2.42,-2.35l-1.36,-0.87l-2.04,-0.67l-0.13,-0.01l-1.4,0.19l-2.07,0.98l-1.14,0.23l-1.72,-0.66l-1.85,-0.48l-2.31,-1.16l-1.92,-0.38l-2.79,-1.18l-2.04,-1.2l-0.6,-0.66l-0.19,-0.1l-1.37,-0.15l-2.45,-0.78l-1.07,-1.18l-2.63,-1.44l-1.2,-1.56l-0.44,-0.93l0.5,-0.15l0.2,-0.39l-0.2,-0.58l0.46,-0.55l0.07,-0.19l0.01,-0.91l-0.06,-0.18l-0.81,-1.13l-0.25,-1.08l-0.86,-1.36l-2.21,-2.63l-2.53,-2.09l-1.2,-1.63l-0.11,-0.09l-2.08,-1.06l-0.34,-0.48l0.35,-1.53l-0.16,-0.34l-1.24,-0.61l-1.39,-1.23l-0.6,-1.81l-0.24,-0.2l-1.25,-0.2l-1.38,-1.35l-1.11,-1.25l-0.1,-0.76l-0.05,-0.13l-1.33,-2.04l-0.85,-2.02l0.04,-0.99l-0.14,-0.27l-1.81,-1.1l-0.2,-0.04l-0.74,0.11l-1.34,-0.72l-0.42,0.16l-0.4,1.12l-0.0,0.19l0.41,1.3l0.24,2.04l0.06,0.15l0.88,1.16l1.84,1.86l0.4,0.61l0.12,0.1l0.27,0.14l0.29,0.82l0.31,0.2l0.2,-0.02l0.43,1.51l0.09,0.14l0.72,0.65l0.51,0.91l1.58,1.4l0.8,2.42l0.77,1.23l0.66,1.19l0.13,1.34l0.28,0.27l1.08,0.08l0.92,1.1l0.83,1.08l-0.03,0.24l-0.88,0.81l-0.13,-0.0l-0.59,-1.42l-0.07,-0.11l-1.67,-1.53l-1.81,-1.28l-1.15,-0.61l0.07,-1.85l-0.38,-1.45l-0.12,-0.17l-2.91,-2.03l-0.39,0.04l-0.11,0.11l-0.42,-0.46l-0.11,-0.08l-1.49,-0.63l-1.09,-1.16Z" data-code="MX" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M839.92,325.66l0.78,0.73l-0.18,0.07l-0.6,-0.8ZM839.13,322.74l0.27,1.36l-0.13,-0.06l-0.21,-0.02l-0.29,0.08l-0.22,-0.43l-0.03,-1.32l0.61,0.4Z" data-code="VU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.58,172.63l-0.68,1.92l-0.72,-0.38l-0.51,-1.79l0.43,-0.95l1.15,-0.83l0.33,2.04ZM429.71,147.03l1.77,1.57l0.26,0.07l1.16,-0.23l2.12,1.44l0.56,0.28l0.16,0.03l0.61,-0.06l1.09,0.78l0.13,0.05l3.18,0.53l-1.09,1.94l-0.3,2.16l-0.48,0.38l-1.0,-0.26l-0.37,0.32l0.07,0.66l-1.73,1.68l-0.09,0.21l-0.04,1.42l0.41,0.29l0.96,-0.4l0.67,1.07l-0.09,0.78l0.04,0.19l0.61,0.97l-0.71,0.78l-0.07,0.28l0.65,2.39l0.21,0.21l1.09,0.31l-0.2,0.95l-2.08,1.58l-4.81,-0.8l-0.13,0.01l-3.65,0.99l-0.22,0.24l-0.25,1.6l-2.59,0.35l-2.74,-1.33l-0.31,0.03l-0.79,0.57l-4.38,-1.31l-0.79,-0.94l1.16,-1.64l0.05,-0.15l0.48,-6.17l-0.06,-0.21l-2.58,-3.3l-1.89,-1.65l-0.11,-0.06l-3.64,-1.17l-0.2,-1.88l2.92,-0.63l4.14,0.82l0.35,-0.36l-0.65,-3.0l1.77,1.05l0.27,0.02l5.83,-2.54l0.17,-0.19l0.71,-2.54l1.75,-0.53l0.27,0.88l0.27,0.21l1.04,0.05l1.08,1.23ZM289.1,278.45l-0.85,0.84l-0.88,0.13l-0.25,-0.51l-0.21,-0.16l-0.56,-0.1l-0.25,0.07l-0.63,0.55l-0.62,-0.29l0.5,-0.88l0.21,-1.11l0.42,-1.05l-0.03,-0.28l-0.93,-1.42l-0.18,-1.54l1.13,-1.87l2.42,0.78l2.55,2.04l0.33,0.81l-1.4,2.16l-0.77,1.84Z" data-code="FR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M492.26,76.42l-0.38,3.12l0.12,0.28l3.6,2.69l-2.14,2.96l-0.01,0.33l2.83,4.61l-1.61,3.36l0.03,0.31l2.15,2.87l-0.96,2.44l0.1,0.35l3.51,2.55l-0.81,1.72l-2.28,2.19l-5.28,4.79l-4.51,0.31l-4.39,1.37l-3.87,0.75l-1.34,-1.89l-0.11,-0.09l-2.23,-1.14l0.53,-3.54l-0.01,-0.14l-1.17,-3.37l1.12,-2.13l2.23,-2.44l5.69,-4.33l1.65,-0.84l0.16,-0.31l-0.26,-1.73l-0.15,-0.22l-3.4,-1.91l-0.77,-1.47l-0.07,-6.45l-0.12,-0.24l-3.91,-2.94l-3.0,-1.92l0.97,-0.76l2.6,2.17l0.21,0.07l3.2,-0.21l2.63,1.03l0.3,-0.05l2.39,-1.94l0.09,-0.13l1.18,-3.12l3.63,-1.42l2.87,1.59l-0.98,2.87Z" data-code="FI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M869.98,327.07l-1.31,0.44l-0.14,-0.41l0.96,-0.41l0.85,-0.17l1.43,-0.78l-0.16,0.65l-1.64,0.67ZM867.58,329.12l0.54,0.47l-0.31,1.0l-1.32,0.3l-1.13,-0.26l-0.17,-0.78l0.72,-0.66l0.98,0.27l0.25,-0.04l0.43,-0.29Z" data-code="FJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M268.15,427.89l2.6,-1.73l1.98,0.77l0.31,-0.05l1.32,-1.17l1.58,1.18l-0.54,0.84l-3.1,0.92l-1.0,-1.04l-0.39,-0.04l-1.9,1.35l-0.86,-1.04Z" data-code="FK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M202.1,252.6l0.23,-0.0l0.12,-0.11l0.68,-0.09l0.22,-0.15l0.23,-0.43l0.2,-0.01l0.28,-0.31l-0.04,-0.97l0.29,-0.03l0.5,0.02l0.25,-0.11l0.37,-0.46l0.51,0.35l0.4,-0.06l0.23,-0.28l0.45,-0.29l0.87,-0.7l0.11,-0.21l0.02,-0.26l0.23,-0.12l0.25,-0.48l0.29,0.27l0.14,0.07l0.5,0.12l0.22,-0.03l0.48,-0.28l0.66,-0.02l0.87,-0.33l0.36,-0.32l0.21,0.01l-0.11,0.48l0.0,0.14l0.22,0.8l-0.54,0.85l-0.27,1.03l-0.09,1.18l0.14,0.72l0.05,0.95l-0.24,0.15l-0.13,0.19l-0.23,1.09l0.0,0.14l0.14,0.53l-0.42,0.53l-0.06,0.24l0.12,0.69l0.08,0.15l0.18,0.19l-0.26,0.23l-0.49,-0.11l-0.35,-0.44l-0.16,-0.1l-0.79,-0.21l-0.23,0.03l-0.45,0.26l-1.51,-0.62l-0.31,0.05l-0.17,0.15l-1.81,-1.62l-0.6,-0.9l-1.04,-0.79l-0.77,-0.71Z" data-code="NI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M436.22,136.65l1.82,0.08l0.36,0.89l-0.6,2.96l-0.53,1.06l-1.32,0.0l-0.3,0.34l0.35,2.89l-0.83,-0.47l-1.56,-1.43l-0.29,-0.07l-2.26,0.67l-1.02,-0.15l0.68,-0.48l0.1,-0.12l2.14,-4.84l3.25,-1.35Z" data-code="NL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M491.45,67.31l7.06,3.0l-2.52,0.94l-0.11,0.49l2.43,2.49l-3.82,1.59l-1.48,0.3l0.89,-2.61l-0.14,-0.36l-3.21,-1.78l-0.25,-0.02l-3.89,1.52l-0.17,0.17l-1.2,3.17l-2.19,1.78l-2.53,-0.99l-0.13,-0.02l-3.15,0.21l-2.69,-2.25l-0.38,-0.01l-1.43,1.11l-1.47,0.17l-0.26,0.26l-0.33,2.57l-4.42,-0.65l-0.33,0.22l-0.6,2.19l-2.17,-0.01l-0.27,0.16l-4.15,7.68l-3.88,5.76l-0.0,0.33l0.81,1.23l-0.7,1.27l-2.3,-0.06l-0.28,0.18l-1.63,3.72l-0.02,0.13l0.15,5.17l0.07,0.18l1.51,1.84l-0.79,4.24l-2.04,2.5l-0.92,1.75l-1.39,-1.88l-0.44,-0.05l-4.89,4.21l-3.16,0.81l-3.24,-1.74l-0.86,-3.82l-0.78,-8.6l2.18,-2.36l6.56,-3.28l5.0,-4.16l4.63,-5.74l5.99,-8.09l4.17,-3.23l6.84,-5.49l5.39,-1.92l4.06,0.24l0.23,-0.09l3.72,-3.67l4.51,0.19l4.4,-0.89ZM484.58,19.95l4.42,1.82l-3.25,2.68l-7.14,0.65l-7.16,-0.91l-0.39,-1.37l-0.28,-0.22l-3.48,-0.1l-2.25,-2.15l7.09,-1.48l3.55,1.36l0.28,-0.03l2.42,-1.66l6.18,1.41ZM481.99,33.92l-4.73,1.85l-3.76,-1.06l1.27,-1.02l0.04,-0.43l-1.18,-1.35l4.46,-0.94l0.89,1.83l0.17,0.15l2.83,0.96ZM466.5,23.95l7.64,3.87l-5.63,1.94l-0.19,0.19l-1.35,3.88l-2.08,0.96l-0.16,0.19l-1.14,4.18l-2.71,0.18l-4.94,-2.95l1.95,-1.63l-0.08,-0.51l-3.7,-1.54l-4.79,-4.54l-1.78,-4.01l6.29,-1.88l1.25,1.81l0.25,0.13l3.57,-0.08l0.26,-0.17l0.87,-1.79l3.41,-0.18l3.08,1.94Z" data-code="NO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M461.88,357.98l-1.61,-1.77l-0.94,-1.9l-0.54,-2.58l-0.62,-1.95l-0.83,-4.05l-0.06,-3.13l-0.33,-1.5l-0.07,-0.14l-0.95,-1.06l-1.27,-2.12l-1.3,-3.1l-0.59,-1.71l-1.98,-2.46l-0.13,-1.67l0.99,-0.4l1.44,-0.42l1.48,0.07l1.42,1.11l0.31,0.03l0.32,-0.15l9.99,-0.11l1.66,1.18l0.16,0.06l6.06,0.37l4.69,-1.06l2.01,-0.57l1.5,0.14l0.63,0.37l-1.0,0.41l-0.7,0.01l-0.16,0.05l-1.38,0.88l-0.79,-0.88l-0.29,-0.09l-3.83,0.9l-1.84,0.08l-0.29,0.3l-0.07,8.99l-2.18,0.08l-0.29,0.3l-0.0,17.47l-2.04,1.27l-1.21,0.18l-1.51,-0.49l-0.99,-0.18l-0.36,-1.0l-0.1,-0.14l-0.99,-0.74l-0.4,0.04l-0.98,1.09Z" data-code="NA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M835.87,338.68l2.06,1.63l1.01,0.94l-0.49,0.32l-1.21,-0.62l-1.76,-1.16l-1.58,-1.36l-1.61,-1.79l-0.16,-0.41l0.54,0.02l1.32,0.83l1.08,0.87l0.79,0.73Z" data-code="NC" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M426.67,254.17l0.03,-1.04l-0.24,-0.3l-2.66,-0.53l-0.06,-1.0l-0.07,-0.17l-1.37,-1.62l-0.3,-1.04l0.15,-0.94l1.37,-0.09l0.19,-0.09l0.85,-0.83l3.34,-0.22l2.22,-0.41l0.24,-0.26l0.2,-1.5l1.32,-1.65l0.07,-0.19l-0.01,-5.74l3.4,-1.13l7.24,-5.12l8.46,-4.95l3.76,1.08l1.35,1.39l0.36,0.05l1.39,-0.77l0.55,3.66l0.12,0.2l0.82,0.6l0.03,0.69l0.1,0.21l0.87,0.74l-0.47,0.99l-0.96,5.26l-0.13,3.25l-3.08,2.34l-0.1,0.15l-1.08,3.37l0.08,0.31l0.94,0.86l-0.01,1.51l0.29,0.3l1.25,0.05l-0.14,0.66l-0.51,0.11l-0.24,0.26l-0.06,0.57l-0.04,0.0l-1.59,-2.62l-0.21,-0.14l-0.59,-0.1l-0.23,0.05l-1.83,1.33l-1.79,-0.68l-1.42,-0.17l-0.17,0.03l-0.65,0.32l-1.39,-0.07l-0.19,0.06l-1.4,1.03l-1.12,0.05l-2.97,-1.29l-0.26,0.01l-1.12,0.59l-1.08,-0.04l-0.85,-0.88l-0.11,-0.07l-2.51,-0.95l-0.14,-0.02l-2.69,0.3l-0.16,0.07l-0.65,0.55l-0.1,0.16l-0.34,1.41l-0.69,0.98l-0.05,0.15l-0.13,1.72l-1.47,-1.13l-0.18,-0.06l-0.9,0.01l-0.2,0.08l-0.32,0.28Z" data-code="NE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M442.0,272.7l-2.4,0.83l-0.88,-0.12l-0.19,0.04l-0.89,0.52l-1.78,-0.05l-1.23,-1.44l-0.88,-1.87l-1.77,-1.66l-0.21,-0.08l-3.78,0.03l0.13,-3.75l-0.06,-1.58l0.44,-1.47l0.74,-0.75l1.21,-1.56l0.04,-0.29l-0.22,-0.56l0.44,-0.9l0.01,-0.24l-0.54,-1.44l0.26,-2.97l0.72,-1.06l0.33,-1.37l0.51,-0.43l2.53,-0.28l2.38,0.9l0.89,0.91l0.2,0.09l1.28,0.04l0.15,-0.03l1.06,-0.56l2.9,1.26l0.13,0.02l1.28,-0.06l0.16,-0.06l1.39,-1.02l1.36,0.07l0.15,-0.03l0.64,-0.32l1.22,0.13l1.9,0.73l0.28,-0.04l1.86,-1.35l0.33,0.06l1.62,2.67l0.29,0.14l0.32,-0.04l0.73,0.74l-0.19,0.37l-0.12,0.74l-2.03,1.89l-0.07,0.11l-0.66,1.62l-0.35,1.28l-0.48,0.51l-0.07,0.12l-0.48,1.67l-1.26,0.98l-0.1,0.15l-0.38,1.24l-0.58,1.07l-0.2,0.91l-1.43,0.7l-1.26,-0.93l-0.19,-0.06l-0.95,0.04l-0.2,0.09l-1.41,1.39l-0.61,0.02l-0.26,0.17l-1.19,2.42l-0.61,1.67Z" data-code="NG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M857.9,379.62l1.85,3.1l0.33,0.14l0.22,-0.28l0.04,-1.41l0.57,0.4l0.35,2.06l0.17,0.22l2.02,0.94l1.78,0.26l0.22,-0.06l1.31,-1.01l0.84,0.22l-0.53,2.27l-0.67,1.5l-1.71,-0.05l-0.25,0.12l-0.67,0.89l-0.05,0.23l0.21,1.15l-0.31,0.46l-2.15,3.57l-1.6,0.99l-0.28,-0.51l-0.15,-0.13l-0.72,-0.3l1.27,-2.15l0.01,-0.29l-0.82,-1.63l-0.15,-0.14l-2.5,-1.09l0.05,-0.69l1.67,-0.94l0.15,-0.21l0.42,-2.24l-0.11,-1.95l-0.03,-0.12l-0.97,-1.85l0.05,-0.41l-0.09,-0.25l-1.18,-1.17l-1.94,-2.49l-0.86,-1.64l0.38,-0.09l1.24,1.43l0.12,0.08l1.81,0.68l0.67,2.39ZM853.93,393.55l0.57,1.24l0.44,0.12l1.51,-1.03l0.52,0.91l0.0,1.09l-0.88,1.31l-1.62,2.2l-1.26,1.2l-0.05,0.38l0.64,1.02l-1.4,0.03l-0.14,0.04l-2.14,1.16l-0.14,0.17l-0.67,2.0l-1.38,3.06l-3.07,2.19l-2.12,-0.06l-1.55,-0.99l-0.14,-0.05l-2.53,-0.2l-0.31,-0.84l1.25,-2.15l3.07,-2.97l1.62,-0.59l1.81,-1.17l2.18,-1.63l1.55,-1.65l1.08,-2.18l0.9,-0.72l0.11,-0.17l0.35,-1.56l1.37,-1.07l0.4,0.91Z" data-code="NZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M641.26,213.53l-0.14,0.95l0.32,1.64l-0.21,0.78l-1.83,0.04l-2.98,-0.62l-1.86,-0.25l-1.37,-1.3l-0.18,-0.08l-3.38,-0.34l-3.21,-1.49l-2.38,-1.34l-2.16,-0.92l0.84,-2.2l1.51,-1.18l0.89,-0.57l1.83,0.77l2.5,1.76l1.39,0.41l0.78,1.21l0.17,0.13l1.91,0.53l2.0,1.17l2.92,0.66l2.63,0.24Z" data-code="NP" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M413.53,272.08l-0.83,0.02l-1.79,-0.49l-1.64,0.03l-3.04,0.46l-1.73,0.72l-2.4,0.89l-0.12,-0.02l0.16,-1.7l0.19,-0.25l0.06,-0.2l-0.08,-0.99l-0.09,-0.19l-1.06,-1.05l-0.15,-0.08l-0.71,-0.15l-0.51,-0.48l0.45,-0.92l0.02,-0.19l-0.24,-1.16l0.07,-0.43l0.14,-0.0l0.3,-0.26l0.15,-1.1l-0.02,-0.15l-0.13,-0.34l0.09,-0.13l0.83,-0.27l0.19,-0.37l-0.62,-2.02l-0.55,-1.0l0.14,-0.59l0.35,-0.14l0.24,-0.16l0.53,0.29l0.14,0.04l1.93,0.02l0.26,-0.14l0.36,-0.58l0.39,0.01l0.43,-0.17l0.28,0.79l0.43,0.16l0.56,-0.31l0.89,-0.32l0.92,0.45l0.39,0.75l0.14,0.13l1.13,0.53l0.3,-0.03l0.81,-0.59l1.02,-0.08l1.49,0.57l0.62,3.33l-1.03,2.09l-0.65,2.84l0.02,0.2l1.05,2.08l-0.07,0.64Z" data-code="CI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.71,156.27l0.05,0.3l-0.34,0.69l0.13,0.4l1.13,0.58l1.07,0.1l-0.12,0.81l-0.87,0.42l-1.75,-0.37l-0.34,0.18l-0.47,1.1l-0.86,0.07l-0.33,-0.38l-0.41,-0.04l-1.34,1.01l-1.02,0.13l-0.93,-0.58l-0.82,-1.32l-0.37,-0.12l-0.77,0.32l0.02,-0.84l1.74,-1.69l0.09,-0.25l-0.04,-0.38l0.73,0.19l0.26,-0.06l0.6,-0.48l2.02,0.02l0.24,-0.12l0.38,-0.51l2.31,0.84Z" data-code="CH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M232.24,284.95l-0.94,-0.52l-1.22,-0.82l-0.31,-0.01l-0.62,0.35l-1.88,-0.31l-0.54,-0.95l-0.29,-0.15l-0.37,0.03l-2.34,-1.33l-0.15,-0.35l0.57,-0.11l0.24,-0.32l-0.1,-1.15l0.46,-0.71l1.11,-0.15l0.21,-0.13l1.05,-1.57l0.95,-1.31l-0.08,-0.43l-0.73,-0.47l0.4,-1.24l0.01,-0.16l-0.53,-2.15l0.44,-0.54l0.06,-0.24l-0.4,-2.13l-0.06,-0.13l-0.93,-1.22l0.21,-0.8l0.52,0.12l0.32,-0.13l0.47,-0.75l0.03,-0.27l-0.52,-1.32l0.09,-0.11l1.14,0.07l0.22,-0.08l1.82,-1.71l0.96,-0.25l0.22,-0.28l0.02,-0.81l0.43,-2.01l1.28,-1.04l1.48,-0.05l0.27,-0.19l0.12,-0.31l1.73,0.19l0.2,-0.05l1.96,-1.28l0.97,-0.56l1.16,-1.16l0.64,0.11l0.43,0.44l-0.31,0.55l-1.49,0.39l-0.19,0.16l-0.6,1.2l-0.97,0.74l-0.73,0.94l-0.06,0.13l-0.3,1.76l-0.68,1.44l0.23,0.43l1.1,0.14l0.27,0.97l0.08,0.13l0.49,0.49l0.17,0.85l-0.27,0.86l-0.01,0.14l0.09,0.53l0.2,0.23l0.52,0.18l0.54,0.79l0.27,0.13l3.18,-0.24l1.31,0.29l1.7,2.08l0.31,0.1l0.96,-0.26l1.75,0.13l1.41,-0.27l0.56,0.27l-0.36,1.07l-0.54,0.81l-0.05,0.13l-0.2,1.8l0.51,1.79l0.07,0.12l0.65,0.68l0.05,0.32l-1.16,1.14l0.05,0.47l0.86,0.52l0.6,0.79l0.31,1.01l-0.7,-0.81l-0.44,-0.01l-0.74,0.77l-4.75,-0.05l-0.3,0.31l0.03,1.57l0.25,0.29l1.2,0.21l-0.02,0.24l-0.1,-0.05l-0.22,-0.02l-1.41,0.41l-0.22,0.29l-0.01,1.82l0.11,0.23l1.04,0.85l0.35,1.3l-0.06,1.02l-1.02,6.26l-0.84,-0.89l-0.19,-0.09l-0.25,-0.02l1.35,-2.13l-0.1,-0.42l-1.92,-1.17l-0.2,-0.04l-1.41,0.2l-0.82,-0.39l-0.26,0.0l-1.29,0.62l-1.63,-0.27l-1.4,-2.5l-0.12,-0.12l-1.1,-0.61l-0.83,-1.2l-1.67,-1.19l-0.27,-0.04l-0.54,0.19Z" data-code="CO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M740.32,148.94l0.22,0.21l4.3,1.03l2.84,2.2l0.99,2.92l0.28,0.2l3.8,0.0l0.15,-0.04l2.13,-1.24l3.5,-0.8l-1.05,2.29l-0.95,1.13l-0.06,0.12l-0.85,3.41l-1.56,2.81l-2.83,-0.51l-0.19,0.03l-2.15,1.09l-0.15,0.34l0.65,2.59l-0.33,3.3l-1.03,0.07l-0.28,0.3l0.01,0.75l-1.09,-1.2l-0.48,0.05l-0.94,1.6l-3.76,1.26l-0.2,0.36l0.29,1.19l-1.67,-0.08l-1.11,-0.88l-0.42,0.05l-1.69,2.08l-2.71,1.57l-2.04,1.88l-3.42,0.84l-0.11,0.05l-1.8,1.34l-1.54,0.46l0.52,-0.53l0.06,-0.33l-0.44,-0.96l1.84,-1.84l0.02,-0.41l-1.32,-1.56l-0.36,-0.08l-2.23,1.08l-2.83,2.06l-1.52,1.85l-2.32,0.13l-0.2,0.09l-1.28,1.37l-0.03,0.37l1.32,1.97l0.18,0.13l1.83,0.43l0.07,1.08l0.18,0.26l1.98,0.84l0.3,-0.03l2.66,-1.96l2.06,1.04l0.12,0.03l1.4,0.07l0.27,1.0l-3.24,0.73l-0.17,0.11l-1.13,1.5l-2.38,1.4l-0.1,0.1l-1.29,1.99l0.1,0.42l2.6,1.5l0.97,2.72l1.52,2.56l1.66,2.08l-0.03,1.76l-1.4,0.67l-0.15,0.38l0.6,1.47l0.13,0.15l1.29,0.75l-0.35,2.0l-0.58,1.96l-1.22,0.21l-0.2,0.14l-1.83,2.93l-2.02,3.51l-2.29,3.13l-3.4,2.42l-3.42,2.18l-2.75,0.3l-0.15,0.06l-1.32,1.01l-0.68,-0.67l-0.41,-0.01l-1.37,1.27l-3.42,1.28l-2.62,0.4l-0.24,0.21l-0.8,2.57l-0.95,0.11l-0.53,-1.54l0.52,-0.89l-0.19,-0.44l-3.36,-0.84l-0.17,0.01l-1.09,0.4l-2.36,-0.64l-1.0,-0.9l0.35,-1.34l-0.23,-0.37l-2.22,-0.47l-1.15,-0.94l-0.36,-0.02l-2.08,1.37l-2.35,0.29l-1.98,-0.01l-0.13,0.03l-1.32,0.63l-1.28,0.38l-0.21,0.33l0.33,2.65l-0.78,-0.04l-0.14,-0.39l-0.07,-1.04l-0.41,-0.26l-1.72,0.71l-0.96,-0.43l-1.63,-0.86l0.65,-1.95l-0.19,-0.38l-1.43,-0.46l-0.56,-2.27l-0.34,-0.22l-2.26,0.38l0.25,-2.65l2.29,-2.15l0.09,-0.2l0.1,-2.21l-0.07,-2.09l-0.15,-0.25l-1.02,-0.6l-0.8,-1.52l-0.31,-0.16l-1.42,0.2l-2.16,-0.32l0.55,-0.74l0.01,-0.35l-1.17,-1.7l-0.41,-0.08l-1.67,1.07l-1.97,-0.63l-0.25,0.03l-2.89,1.73l-2.26,1.99l-1.82,0.3l-1.0,-0.66l-0.15,-0.05l-1.28,-0.06l-1.75,-0.61l-0.24,0.02l-1.35,0.69l-0.1,0.08l-1.2,1.45l-0.14,-1.41l-0.4,-0.25l-1.46,0.55l-2.83,-0.26l-2.77,-0.61l-1.99,-1.17l-1.91,-0.54l-0.78,-1.21l-0.17,-0.13l-1.36,-0.38l-2.54,-1.79l-2.01,-0.84l-0.28,0.02l-0.89,0.56l-3.31,-1.83l-2.35,-1.67l-0.57,-2.49l1.34,0.28l0.36,-0.28l0.08,-1.42l-0.05,-0.19l-0.93,-1.34l0.24,-2.18l-0.07,-0.22l-2.69,-3.32l-0.15,-0.1l-3.97,-1.11l-0.69,-2.05l-0.11,-0.15l-1.79,-1.3l-0.39,-0.73l-0.36,-1.57l0.08,-1.09l-0.18,-0.3l-1.52,-0.66l-0.22,-0.01l-0.51,0.18l-0.52,-2.21l0.59,-0.55l0.06,-0.35l-0.22,-0.44l2.12,-1.24l1.63,-0.55l2.58,0.39l0.31,-0.16l0.87,-1.75l3.05,-0.34l0.21,-0.12l0.84,-1.12l3.87,-1.59l0.15,-0.14l0.35,-0.68l0.03,-0.17l-0.17,-1.51l1.52,-0.7l0.15,-0.39l-2.12,-5.0l4.62,-1.15l1.35,-0.72l0.14,-0.17l1.72,-5.37l4.7,0.99l0.28,-0.08l1.39,-1.43l0.08,-0.2l0.11,-2.95l1.83,-0.26l0.18,-0.1l1.85,-2.08l0.61,-0.17l0.57,1.97l0.1,0.15l2.2,1.75l3.48,1.17l1.59,2.36l-0.93,3.53l0.04,0.24l0.9,1.35l0.2,0.13l2.98,0.53l3.32,0.43l2.97,1.89l1.49,0.35l1.08,2.67l1.52,1.88l0.24,0.11l2.74,-0.07l5.15,0.67l3.36,-0.41l2.39,0.43l3.67,1.81l0.13,0.03l2.92,-0.0l1.02,0.86l0.34,0.03l2.88,-1.59l3.98,-1.03l3.81,-0.13l3.02,-1.12l1.77,-1.61l1.73,-1.01l0.13,-0.37l-0.41,-1.01l-0.72,-1.07l1.09,-1.66l1.21,0.24l2.57,0.63l0.24,-0.04l2.46,-1.62l3.78,-1.19l0.13,-0.09l1.8,-2.03l1.66,-0.84l3.54,-0.41l1.93,0.35l0.34,-0.22l0.27,-1.12l-0.08,-0.29l-2.27,-2.22l-2.08,-1.07l-0.29,0.01l-1.82,1.12l-2.36,-0.47l-0.14,0.01l-1.18,0.34l-0.46,-0.94l1.69,-3.08l1.1,-2.21l2.75,1.12l0.26,-0.02l3.53,-2.06l0.15,-0.26l-0.02,-1.35l2.18,-3.39l1.35,-1.04l0.12,-0.24l-0.03,-1.85l-0.15,-0.25l-1.0,-0.58l1.68,-1.37l3.01,-0.59l3.25,-0.09l3.67,0.99l2.08,1.18l1.51,3.3l0.95,1.45l0.85,1.99l0.92,3.19ZM697.0,237.37l-1.95,1.12l-1.74,-0.68l-0.06,-1.9l1.08,-1.03l2.62,-0.7l1.23,0.05l0.37,0.65l-1.01,1.08l-0.54,1.4Z" data-code="CN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M453.76,278.92l-0.26,-0.11l-0.18,-0.02l-1.42,0.31l-1.56,-0.33l-1.17,0.16l-3.7,-0.05l0.3,-1.63l-0.04,-0.21l-0.98,-1.66l-0.15,-0.13l-1.03,-0.38l-0.46,-1.01l-0.13,-0.14l-0.48,-0.27l0.02,-0.46l0.62,-1.72l1.1,-2.25l0.54,-0.02l0.2,-0.09l1.41,-1.39l0.73,-0.03l1.32,0.97l0.31,0.03l1.72,-0.85l0.16,-0.2l0.22,-1.0l0.57,-1.03l0.36,-1.18l1.26,-0.98l0.1,-0.15l0.49,-1.7l0.48,-0.51l0.07,-0.13l0.35,-1.3l0.63,-1.54l2.06,-1.92l0.09,-0.17l0.12,-0.79l0.24,-0.41l-0.04,-0.36l-0.89,-0.91l0.04,-0.45l0.28,-0.06l0.85,1.39l0.16,1.59l-0.09,1.66l0.04,0.17l1.09,1.84l-0.86,-0.02l-0.72,0.17l-1.07,-0.24l-0.34,0.17l-0.54,1.19l0.06,0.34l1.48,1.47l1.06,0.44l0.32,0.94l0.73,1.6l-0.32,0.57l-1.23,2.49l-0.54,0.41l-0.12,0.21l-0.19,1.95l0.24,1.08l-0.18,0.67l0.07,0.28l1.13,1.25l0.24,0.93l0.92,1.29l1.1,0.8l0.1,1.01l0.26,0.73l-0.12,0.93l-1.65,-0.49l-2.02,-0.66l-3.19,-0.11Z" data-code="CM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M246.8,429.1l-1.14,0.78l-2.25,1.21l-0.16,0.23l-0.37,2.94l-0.75,0.06l-2.72,-1.07l-2.83,-2.34l-3.06,-1.9l-0.71,-1.92l0.67,-1.84l-0.02,-0.25l-1.22,-2.13l-0.31,-5.41l1.02,-2.95l2.59,-2.4l-0.13,-0.51l-3.32,-0.8l2.06,-2.4l0.07,-0.15l0.79,-4.77l2.44,0.95l0.4,-0.22l1.31,-6.31l-0.16,-0.33l-1.68,-0.8l-0.42,0.21l-0.72,3.47l-1.01,-0.27l0.74,-4.06l0.85,-5.46l1.12,-1.96l0.03,-0.22l-0.71,-2.82l-0.19,-2.94l0.76,-0.07l0.26,-0.2l1.53,-4.62l1.73,-4.52l1.07,-4.2l-0.56,-4.2l0.73,-2.2l0.01,-0.12l-0.29,-3.3l1.46,-3.34l0.45,-5.19l0.8,-5.52l0.78,-5.89l-0.18,-4.33l-0.49,-3.47l1.1,-0.56l0.13,-0.13l0.44,-0.88l0.9,1.29l0.32,1.8l0.1,0.18l1.16,0.97l-0.73,2.33l0.01,0.21l1.33,2.91l0.97,3.6l0.35,0.22l1.57,-0.31l0.16,0.34l-0.79,2.51l-2.61,1.25l-0.17,0.28l0.08,4.36l-0.48,0.79l0.01,0.33l0.6,0.84l-1.62,1.55l-1.67,2.6l-0.89,2.47l-0.02,0.13l0.23,2.56l-1.5,2.76l-0.03,0.21l1.15,4.8l0.11,0.17l0.54,0.42l-0.01,2.37l-1.4,2.7l-0.03,0.15l0.06,2.25l-1.8,1.78l-0.09,0.21l0.02,2.73l0.71,2.63l-1.33,0.94l-0.12,0.17l-0.67,2.64l-0.59,3.03l0.4,3.55l-0.84,0.51l-0.14,0.31l0.58,3.5l0.08,0.16l0.96,0.99l-0.7,1.08l0.11,0.43l1.04,0.55l0.19,0.8l-0.89,0.48l-0.16,0.31l0.26,1.77l-0.89,4.06l-1.31,2.67l-0.03,0.19l0.28,1.53l-0.73,1.88l-1.85,1.37l-0.12,0.26l0.22,3.46l0.06,0.16l0.88,1.19l0.28,0.12l1.32,-0.17l-0.04,2.13l0.04,0.15l1.04,1.95l0.24,0.16l5.94,0.44ZM248.79,430.71l0.0,7.41l0.3,0.3l2.67,0.0l1.01,0.06l-0.54,0.91l-1.99,1.01l-1.13,-0.1l-1.42,-0.27l-1.87,-1.06l-2.57,-0.49l-3.09,-1.9l-2.52,-1.83l-2.65,-2.93l0.93,0.32l3.54,2.29l3.32,1.23l0.34,-0.09l1.29,-1.57l0.83,-2.32l2.11,-1.28l1.43,0.32Z" data-code="CL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M280.14,145.66l-1.66,2.88l0.06,0.37l0.37,0.03l1.5,-1.01l1.17,0.49l-0.64,0.83l0.13,0.46l2.22,0.89l0.28,-0.03l1.02,-0.7l2.09,0.83l-0.69,2.1l0.37,0.38l1.43,-0.45l0.27,1.43l0.74,1.88l-0.95,2.5l-0.88,0.09l-1.34,-0.48l0.49,-2.34l-0.14,-0.32l-0.7,-0.4l-0.36,0.04l-2.81,2.66l-0.63,-0.05l1.2,-1.01l-0.1,-0.52l-2.4,-0.77l-2.79,0.18l-4.65,-0.09l-0.22,-0.54l1.37,-0.99l0.01,-0.48l-0.82,-0.65l1.91,-1.79l2.57,-5.17l1.49,-1.81l2.04,-1.07l0.63,0.08l-0.27,0.51l-1.33,2.07ZM193.92,74.85l-0.01,4.24l0.19,0.28l0.33,-0.07l3.14,-3.22l2.65,2.5l-0.71,3.04l0.06,0.26l2.42,2.88l0.46,0.0l2.66,-3.14l1.83,-3.74l0.03,-0.12l0.13,-4.53l3.23,0.31l3.63,0.64l3.18,2.08l0.13,1.91l-1.79,2.22l-0.0,0.37l1.69,2.2l-0.28,1.8l-4.74,2.84l-3.33,0.62l-2.5,-1.21l-0.41,0.17l-0.73,2.05l-2.39,3.44l-0.74,1.78l-2.78,2.61l-3.48,0.26l-0.17,0.07l-1.98,1.68l-0.1,0.21l-0.15,2.33l-2.68,0.45l-0.17,0.09l-3.1,3.2l-2.75,4.38l-0.99,3.06l-0.14,4.31l0.25,0.31l3.5,0.58l1.07,3.24l1.18,2.76l0.34,0.18l3.43,-0.69l4.55,1.52l2.45,1.32l1.76,1.65l0.12,0.07l3.11,0.96l2.63,1.46l0.13,0.04l4.12,0.2l2.41,0.3l-0.36,2.81l0.8,3.51l1.81,3.78l0.08,0.1l3.73,3.17l0.34,0.03l1.93,-1.08l0.13,-0.15l1.35,-3.44l0.01,-0.18l-1.31,-5.38l-0.08,-0.14l-1.46,-1.5l3.68,-1.51l2.84,-2.46l1.45,-2.55l0.04,-0.17l-0.2,-2.39l-0.04,-0.12l-1.7,-3.07l-2.9,-2.64l2.79,-3.66l0.05,-0.27l-1.08,-3.38l-0.8,-5.75l1.45,-0.75l4.18,1.03l2.6,0.38l0.18,-0.03l1.93,-0.95l2.18,1.23l3.01,2.18l0.73,1.42l0.25,0.16l4.18,0.27l-0.06,2.95l0.83,4.7l0.22,0.24l2.19,0.55l1.75,2.08l0.38,0.07l3.63,-2.03l0.11,-0.11l2.38,-4.06l1.36,-1.43l1.76,3.01l3.26,4.68l2.68,4.19l-0.94,2.09l0.12,0.38l3.31,1.98l2.23,1.98l0.13,0.07l3.94,0.89l1.48,1.02l0.96,2.82l0.22,0.2l1.85,0.43l0.88,1.13l0.17,3.53l-1.68,1.16l-1.76,1.14l-4.08,1.17l-0.11,0.06l-3.08,2.65l-4.11,0.52l-5.35,-0.69l-3.76,-0.02l-2.62,0.23l-0.2,0.1l-2.05,2.29l-3.13,1.41l-0.11,0.08l-3.6,4.24l-2.87,2.92l-0.05,0.36l0.33,0.14l2.13,-0.52l0.15,-0.08l3.98,-4.15l5.16,-2.63l3.58,-0.31l1.82,1.3l-2.09,1.91l-0.09,0.29l0.8,3.46l0.82,2.37l0.15,0.17l3.25,1.56l0.16,0.03l4.14,-0.45l0.21,-0.12l2.03,-2.86l0.11,1.46l0.13,0.22l1.26,0.88l-2.7,1.78l-5.51,1.83l-2.52,1.26l-2.75,2.16l-1.52,-0.18l-0.08,-2.16l4.19,-2.47l0.14,-0.34l-0.3,-0.22l-4.01,0.1l-2.66,0.36l-1.45,-1.56l0.0,-4.16l-0.11,-0.23l-1.11,-0.91l-0.28,-0.05l-1.5,0.48l-0.7,-0.7l-0.45,0.02l-1.91,2.39l-0.8,2.5l-0.82,1.31l-0.95,0.43l-0.77,0.15l-0.23,0.2l-0.18,0.56l-8.2,0.02l-0.13,0.03l-1.19,0.61l-2.95,2.45l-0.78,1.13l-4.6,0.01l-0.12,0.02l-1.13,0.48l-0.13,0.44l0.37,0.55l0.2,0.82l-0.01,0.09l-3.1,1.42l-2.63,0.5l-2.84,1.57l-0.47,0.0l-0.72,-0.4l-0.18,-0.27l0.03,-0.15l0.52,-1.0l1.2,-1.71l0.73,-1.8l0.02,-0.17l-1.03,-5.47l-0.15,-0.21l-2.35,-1.32l0.16,-0.29l-0.05,-0.35l-0.37,-0.38l-0.22,-0.09l-0.56,0.0l-0.35,-0.34l-0.11,-0.65l-0.46,-0.2l-0.39,0.26l-0.2,-0.03l-0.11,-0.33l-0.48,-0.25l-0.21,-0.71l-0.15,-0.18l-3.97,-2.07l-4.8,-2.39l-0.25,-0.01l-2.19,0.89l-0.72,0.03l-3.04,-0.82l-0.14,-0.0l-1.94,0.4l-2.4,-0.98l-2.56,-0.51l-1.7,-0.19l-0.62,-0.44l-0.42,-1.67l-0.3,-0.23l-0.85,0.02l-0.29,0.3l-0.01,0.95l-69.26,-0.01l-4.77,-3.14l-1.78,-1.41l-4.51,-1.38l-1.3,-2.73l0.34,-1.96l-0.17,-0.33l-3.06,-1.37l-0.41,-2.58l-0.11,-0.18l-2.92,-2.4l-0.05,-1.53l1.32,-1.59l0.07,-0.2l-0.07,-2.21l-0.16,-0.26l-4.19,-2.22l-2.52,-4.02l-1.56,-2.6l-0.08,-0.09l-2.28,-1.64l-1.65,-1.48l-1.31,-1.89l-0.38,-0.1l-2.51,1.21l-2.28,1.92l-2.03,-2.22l-1.85,-1.71l-2.44,-1.04l-2.28,-0.12l0.03,-37.72l4.27,0.98l4.0,2.13l2.61,0.4l0.24,-0.07l2.17,-1.81l2.92,-1.33l3.63,0.53l0.18,-0.03l3.72,-1.94l3.89,-1.06l1.6,1.72l0.37,0.06l1.87,-1.04l0.14,-0.19l0.48,-1.83l1.37,0.38l4.18,3.96l0.41,0.0l2.89,-2.62l0.28,2.79l0.37,0.26l3.08,-0.73l0.17,-0.12l0.85,-1.16l2.81,0.24l3.83,1.86l5.86,1.61l3.46,0.75l2.44,-0.26l2.89,1.89l-3.12,1.89l-0.14,0.31l0.24,0.24l4.53,0.92l6.84,-0.5l2.04,-0.71l2.54,2.44l0.39,0.02l2.72,-2.16l-0.01,-0.48l-2.26,-1.61l1.27,-1.16l2.94,-0.19l1.94,-0.42l1.89,0.97l2.49,2.32l0.24,0.08l2.71,-0.33l4.35,1.9l0.17,0.02l3.86,-0.67l3.62,0.1l0.31,-0.33l-0.26,-2.44l1.9,-0.65l3.58,1.36l-0.01,3.84l0.23,0.29l0.34,-0.17l1.51,-3.23l1.81,0.1l0.31,-0.22l1.13,-4.37l-0.08,-0.29l-2.68,-2.73l-2.83,-1.76l0.19,-4.73l2.77,-3.15l3.06,0.69l2.44,1.97l3.24,4.88l-2.05,2.02l0.15,0.51l4.41,0.85ZM265.85,150.7l-0.84,0.04l-3.15,-0.99l-1.77,-1.17l0.19,-0.06l3.17,0.79l2.39,1.27l0.01,0.12ZM249.41,3.71l6.68,0.49l5.34,0.79l4.34,1.6l-0.08,1.24l-5.91,2.56l-6.03,1.21l-2.36,1.38l-0.14,0.34l0.29,0.22l4.37,-0.02l-4.96,3.01l-4.06,1.64l-0.11,0.08l-4.21,4.62l-5.07,0.92l-0.12,0.05l-1.53,1.1l-7.5,0.59l-0.28,0.28l0.24,0.31l2.67,0.54l-1.04,0.6l-0.09,0.44l1.89,2.49l-2.11,1.66l-3.83,1.52l-0.15,0.13l-1.14,2.01l-3.41,1.55l-0.16,0.36l0.35,1.19l0.3,0.22l3.98,-0.19l0.03,0.78l-6.42,2.99l-6.44,-1.41l-7.41,0.79l-3.72,-0.62l-4.48,-0.26l-0.25,-2.0l4.37,-1.13l0.21,-0.38l-1.14,-3.55l1.13,-0.28l6.61,2.29l0.35,-0.12l-0.04,-0.37l-3.41,-3.45l-0.14,-0.08l-3.57,-0.92l1.62,-1.7l4.36,-1.3l0.2,-0.18l0.71,-1.94l-0.12,-0.36l-3.45,-2.15l-0.88,-2.43l6.36,0.23l1.94,0.61l0.23,-0.02l3.91,-2.1l0.15,-0.32l-0.26,-0.24l-5.69,-0.67l-8.69,0.37l-4.3,-1.92l-2.12,-2.39l-2.82,-1.68l-0.44,-1.65l3.41,-1.06l2.93,-0.2l4.91,-0.99l3.69,-2.28l2.93,0.31l2.64,1.68l0.42,-0.1l1.84,-3.23l3.17,-0.96l4.45,-0.69l7.56,-0.26l1.26,0.64l0.18,0.03l7.2,-1.06l10.81,0.8ZM203.94,57.59l0.01,0.32l1.97,2.97l0.51,-0.01l2.26,-3.75l6.05,-1.89l4.08,4.72l-0.36,2.95l0.38,0.33l4.95,-1.36l0.11,-0.05l2.23,-1.77l5.37,2.31l3.32,2.14l0.3,1.89l0.36,0.25l4.48,-1.01l2.49,2.8l0.14,0.09l5.99,1.78l2.09,1.74l2.18,3.83l-4.29,1.91l-0.01,0.54l5.9,2.83l3.95,0.94l3.54,3.84l0.2,0.1l3.58,0.25l-0.67,2.51l-4.18,4.54l-2.84,-1.61l-3.91,-3.95l-0.26,-0.09l-3.24,0.52l-0.25,0.26l-0.32,2.37l0.1,0.26l2.63,2.38l3.42,1.89l0.96,1.0l1.57,3.8l-0.74,2.43l-2.85,-0.96l-6.26,-3.15l-0.38,0.09l0.04,0.39l3.54,3.4l2.55,2.31l0.23,0.78l-6.26,-1.43l-5.33,-2.25l-2.73,-1.73l0.67,-0.86l-0.09,-0.45l-7.38,-4.01l-0.44,0.27l0.03,0.89l-6.85,0.61l-1.8,-1.17l1.43,-2.6l4.56,-0.07l5.15,-0.52l0.23,-0.45l-0.76,-1.34l0.8,-1.89l3.21,-4.06l0.05,-0.29l-0.72,-1.95l-0.97,-1.47l-0.11,-0.1l-3.84,-2.1l-4.53,-1.33l1.09,-0.75l0.05,-0.45l-2.65,-2.75l-0.18,-0.09l-2.12,-0.24l-1.91,-1.47l-0.39,0.02l-1.27,1.25l-4.4,0.56l-9.06,-0.99l-5.28,-1.31l-4.01,-0.67l-1.72,-1.31l2.32,-1.85l0.1,-0.33l-0.28,-0.2l-3.3,-0.02l-0.74,-4.36l1.86,-4.09l2.46,-1.88l5.74,-1.15l-1.5,2.55ZM261.28,159.28l0.19,0.14l1.82,0.42l1.66,-0.05l-0.66,0.68l-0.75,0.16l-3.0,-1.25l-0.46,-0.77l0.51,-0.52l0.68,1.19ZM230.87,84.48l-2.48,0.19l-0.52,-1.74l0.96,-2.17l2.03,-0.53l1.71,1.04l0.02,1.6l-0.22,0.46l-1.5,1.16ZM229.52,58.19l0.14,0.82l-4.99,-0.22l-2.73,0.63l-0.59,-0.23l-2.61,-2.4l0.08,-1.38l0.94,-0.25l5.61,0.51l4.14,2.54ZM222.12,105.0l-0.79,1.63l-0.75,-0.22l-0.52,-0.91l0.04,-0.09l0.84,-1.01l0.74,0.06l0.44,0.55ZM183.77,38.22l2.72,1.65l0.16,0.04l4.83,-0.01l1.92,1.52l-0.51,1.75l0.18,0.36l2.84,1.14l1.56,1.19l0.16,0.06l3.37,0.22l3.65,0.42l4.07,-1.1l5.05,-0.43l3.96,0.35l2.53,1.8l0.48,1.79l-1.37,1.16l-3.6,1.03l-3.22,-0.59l-7.17,0.76l-5.1,0.09l-4.0,-0.6l-6.48,-1.56l-0.81,-2.57l-0.3,-2.49l-0.1,-0.19l-2.51,-2.25l-0.16,-0.07l-5.12,-0.63l-2.61,-1.45l0.75,-1.71l4.88,0.32ZM207.46,91.26l0.42,1.62l0.42,0.19l1.12,-0.55l1.35,0.99l2.74,1.39l2.73,1.2l0.2,1.74l0.35,0.26l1.72,-0.29l1.31,0.97l-1.72,0.96l-3.68,-0.9l-1.34,-1.71l-0.43,-0.04l-2.46,2.1l-3.23,1.85l-0.74,-1.98l-0.31,-0.19l-2.47,0.28l1.49,-1.34l0.1,-0.19l0.32,-3.15l0.79,-3.45l1.34,0.25ZM215.59,102.66l-2.73,2.0l-1.49,-0.08l-0.37,-0.7l1.61,-1.56l3.0,0.03l-0.02,0.3ZM202.79,24.07l0.11,0.12l2.54,1.53l-3.01,1.47l-4.55,4.07l-4.3,0.38l-5.07,-0.68l-2.51,-2.09l0.03,-1.72l1.86,-1.4l0.1,-0.34l-0.29,-0.2l-4.49,0.04l-2.63,-1.79l-1.45,-2.36l1.61,-2.38l1.65,-1.69l2.47,-0.4l0.19,-0.48l-0.72,-0.89l5.1,-0.26l3.1,3.05l0.13,0.07l4.21,1.25l3.99,1.06l1.92,3.65ZM187.5,59.3l-0.15,0.1l-2.59,3.4l-2.5,-0.15l-1.47,-3.92l0.04,-2.24l1.22,-1.92l2.34,-1.26l5.11,0.17l4.28,1.06l-3.36,3.86l-2.9,0.9ZM186.19,48.8l-1.15,1.63l-3.42,-0.35l-2.68,-1.15l1.11,-1.88l3.34,-1.27l2.01,1.63l0.79,1.38ZM185.78,35.41l-0.95,0.13l-4.48,-0.33l-0.4,-0.91l4.5,0.07l1.45,0.82l-0.1,0.21ZM180.76,32.56l-3.43,1.03l-1.85,-1.14l-1.01,-1.92l-0.16,-1.87l2.87,0.2l1.39,0.35l2.75,1.75l-0.55,1.6ZM181.03,76.32l-1.21,1.2l-3.19,-1.26l-0.18,-0.01l-1.92,0.45l-2.88,-1.67l1.84,-1.16l1.6,-1.77l2.45,1.17l1.45,0.77l2.05,2.28ZM169.72,54.76l2.83,0.97l0.14,0.01l4.25,-0.58l0.47,1.01l-2.19,2.16l0.07,0.48l3.61,1.95l-0.41,3.84l-3.87,1.68l-2.23,-0.36l-1.73,-1.75l-6.07,-3.53l0.03,-1.01l4.79,0.55l0.3,-0.16l-0.04,-0.34l-2.55,-2.89l2.59,-2.05ZM174.44,40.56l1.49,1.87l0.07,2.48l-1.07,3.52l-3.87,0.48l-2.41,-0.72l0.05,-2.72l-0.33,-0.3l-3.79,0.36l-0.13,-3.31l2.36,0.14l0.15,-0.03l3.7,-1.74l3.44,0.29l0.31,-0.22l0.03,-0.12ZM170.14,31.5l0.75,1.74l-3.52,-0.52l-4.19,-1.77l-4.65,-0.17l1.65,-1.11l-0.05,-0.52l-2.86,-1.26l-0.13,-1.58l4.52,0.7l6.66,1.99l1.84,2.5ZM134.64,58.08l-1.08,1.93l0.34,0.44l5.44,-1.41l3.37,2.32l0.37,-0.02l2.66,-2.28l2.03,1.38l2.01,4.53l0.53,0.04l1.26,-1.93l0.03,-0.27l-1.67,-4.55l1.82,-0.58l2.36,0.73l2.69,1.84l1.53,4.46l0.77,3.24l0.15,0.19l4.22,2.26l4.32,2.04l-0.21,1.51l-3.87,0.34l-0.19,0.5l1.45,1.54l-0.65,1.23l-4.3,-0.65l-4.4,-1.19l-2.97,0.28l-4.67,1.48l-6.31,0.65l-4.27,0.39l-1.26,-1.91l-0.15,-0.12l-3.42,-1.2l-0.16,-0.01l-2.05,0.45l-2.66,-3.02l1.2,-0.34l3.82,-0.76l3.58,0.19l3.27,-0.78l0.23,-0.29l-0.24,-0.29l-4.84,-1.06l-5.42,0.35l-3.4,-0.09l-0.97,-1.22l5.39,-1.7l0.21,-0.33l-0.3,-0.25l-3.82,0.06l-3.95,-1.1l1.88,-3.13l1.68,-1.81l6.54,-2.84l2.11,0.77ZM158.85,56.58l-1.82,2.62l-3.38,-2.9l0.49,-0.39l3.17,-0.18l1.54,0.86ZM149.71,42.7l1.0,1.87l0.37,0.14l2.17,-0.83l2.33,0.2l0.38,2.16l-1.38,2.17l-8.33,0.76l-6.34,2.15l-3.51,0.1l-0.22,-1.13l4.98,-2.12l0.17,-0.34l-0.31,-0.23l-11.27,0.6l-3.04,-0.78l3.14,-4.57l2.2,-1.35l6.87,1.7l4.4,3.0l0.14,0.05l4.37,0.39l0.27,-0.48l-3.41,-4.68l1.96,-1.62l2.28,0.53l0.79,2.32ZM145.44,29.83l-2.18,0.77l-3.79,-0.0l0.02,-0.31l2.34,-1.5l1.2,0.23l2.42,0.83ZM144.83,34.5l-4.44,1.46l-3.18,-1.48l1.6,-1.36l3.51,-0.53l3.1,0.75l-0.6,1.16ZM119.02,65.87l-6.17,2.07l-1.19,-1.82l-0.13,-0.11l-5.48,-2.32l0.92,-1.7l1.73,-3.44l2.16,-3.15l-0.02,-0.36l-2.09,-2.56l7.84,-0.71l3.59,1.02l6.32,0.27l2.35,1.37l2.25,1.71l-2.68,1.04l-6.21,3.41l-3.1,3.28l-0.08,0.21l0.0,1.81ZM129.66,35.4l-0.3,3.55l-1.77,1.67l-2.34,0.27l-4.62,2.2l-3.89,0.76l-2.83,-0.93l3.85,-3.52l5.04,-3.36l3.75,0.07l3.11,-0.7ZM111.24,152.74l-0.82,0.29l-3.92,-1.39l-0.7,-1.06l-0.12,-0.1l-2.15,-1.09l-0.41,-0.84l-0.2,-0.16l-2.44,-0.56l-0.84,-1.56l0.1,-0.36l2.34,0.64l1.53,0.5l2.28,0.34l0.78,1.04l1.24,1.55l0.09,0.08l2.42,1.3l0.81,1.39ZM88.54,134.82l0.14,0.02l2.0,-0.23l-0.67,3.48l0.06,0.24l1.78,2.22l-0.24,-0.0l-1.4,-1.42l-0.91,-1.53l-1.26,-1.08l-0.42,-1.35l0.09,-0.66l0.82,0.31Z" data-code="CA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M453.66,296.61l-0.9,-0.82l-0.35,-0.04l-0.83,0.48l-0.77,0.83l-1.65,-2.13l1.66,-1.2l0.08,-0.39l-0.81,-1.43l0.59,-0.43l1.62,-0.29l0.24,-0.24l0.1,-0.58l0.94,0.84l0.19,0.08l2.21,0.11l0.27,-0.14l0.81,-1.29l0.32,-1.76l-0.27,-1.96l-0.06,-0.15l-1.08,-1.35l1.02,-2.74l-0.09,-0.34l-0.62,-0.5l-0.22,-0.06l-1.66,0.18l-0.55,-1.03l0.12,-0.73l2.85,0.09l1.98,0.65l2.0,0.59l0.38,-0.25l0.17,-1.3l1.26,-2.24l1.34,-1.19l1.54,0.38l1.35,0.12l-0.11,1.15l-0.74,1.34l-0.5,1.61l-0.31,2.22l0.12,1.41l-0.4,0.9l-0.06,0.88l-0.24,0.67l-1.57,1.15l-1.24,1.41l-1.09,2.43l-0.03,0.13l0.08,1.95l-0.55,0.69l-1.46,1.23l-1.32,1.41l-0.61,-0.29l-0.13,-0.57l-0.29,-0.23l-1.36,-0.02l-0.23,0.1l-0.72,0.81l-0.41,-0.16Z" data-code="CG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M459.41,266.56l1.9,-0.17l0.22,-0.12l0.36,-0.5l0.14,0.02l0.55,0.51l0.29,0.07l3.15,-0.96l0.12,-0.07l1.05,-0.97l1.29,-0.87l0.12,-0.33l-0.17,-0.61l0.38,-0.12l2.36,0.15l0.15,-0.03l2.36,-1.17l0.12,-0.1l1.78,-2.72l1.18,-0.96l1.23,-0.34l0.21,0.79l0.07,0.13l1.37,1.5l0.01,0.86l-0.39,1.0l-0.01,0.17l0.16,0.78l0.1,0.17l0.91,0.76l1.89,1.09l1.24,0.92l0.02,0.67l0.12,0.23l1.67,1.3l0.99,1.03l0.61,1.46l0.14,0.15l1.79,0.95l0.2,0.4l-0.44,0.14l-1.54,-0.06l-1.98,-0.26l-0.93,0.22l-0.19,0.14l-0.3,0.48l-0.57,0.05l-0.91,-0.49l-0.26,-0.01l-2.7,1.21l-1.04,-0.23l-0.21,0.03l-0.34,0.19l-0.12,0.13l-0.64,1.3l-1.67,-0.43l-1.77,-0.24l-1.58,-0.91l-2.06,-0.85l-0.27,0.02l-1.42,0.88l-0.97,1.27l-0.06,0.14l-0.19,1.46l-1.3,-0.11l-1.67,-0.42l-0.27,0.07l-1.55,1.41l-0.99,1.76l-0.14,-1.18l-0.13,-0.22l-1.1,-0.78l-0.86,-1.2l-0.2,-0.84l-0.07,-0.13l-1.07,-1.19l0.16,-0.59l0.0,-0.15l-0.24,-1.01l0.18,-1.77l0.5,-0.38l0.09,-0.11l1.18,-2.4Z" data-code="CF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M497.85,276.25l-0.14,2.77l0.2,0.3l0.57,0.19l-0.47,0.52l-1.0,0.71l-0.96,1.31l-0.56,1.22l-0.16,2.04l-0.54,0.89l-0.04,0.15l-0.02,1.76l-0.63,0.61l-0.09,0.2l-0.08,1.33l-0.2,0.11l-0.15,0.21l-0.23,1.37l0.03,0.2l0.6,1.08l0.16,2.96l0.44,2.29l-0.24,1.25l0.01,0.15l0.5,1.46l0.07,0.12l1.41,1.37l1.09,2.56l-0.51,-0.11l-3.45,0.45l-0.67,0.3l-0.15,0.15l-0.71,1.61l0.01,0.26l0.52,1.03l-0.43,2.9l-0.31,2.55l0.13,0.29l0.7,0.46l1.75,0.99l0.31,-0.01l0.26,-0.17l0.15,1.9l-1.44,-0.02l-0.94,-1.28l-0.94,-1.1l-0.17,-0.1l-1.76,-0.33l-0.5,-1.18l-0.42,-0.15l-1.44,0.75l-1.79,-0.32l-0.77,-1.05l-0.2,-0.12l-1.59,-0.23l-0.97,0.04l-0.1,-0.53l-0.27,-0.25l-0.86,-0.06l-1.13,-0.15l-1.62,0.37l-1.04,-0.06l-0.32,0.09l0.11,-2.56l-0.08,-0.21l-0.77,-0.87l-0.17,-1.41l0.36,-1.47l-0.03,-0.21l-0.48,-0.91l-0.04,-1.52l-0.3,-0.29l-2.65,0.02l0.13,-0.53l-0.29,-0.37l-1.28,0.01l-0.28,0.21l-0.07,0.24l-1.35,0.09l-0.26,0.18l-0.62,1.45l-0.25,0.42l-1.17,-0.3l-0.19,0.01l-0.79,0.34l-1.44,0.18l-1.41,-1.96l-0.7,-1.47l-0.61,-1.86l-0.28,-0.21l-7.39,-0.03l-0.92,0.3l-0.78,-0.03l-0.78,0.25l-0.11,-0.25l0.35,-0.15l0.18,-0.26l0.07,-1.02l0.33,-0.52l0.72,-0.42l0.52,0.2l0.33,-0.08l0.76,-0.86l0.99,0.02l0.11,0.48l0.16,0.2l0.94,0.44l0.35,-0.07l1.46,-1.56l1.44,-1.21l0.68,-0.85l0.06,-0.2l-0.08,-1.99l1.04,-2.33l1.1,-1.23l1.62,-1.19l0.11,-0.14l0.29,-0.8l0.08,-0.94l0.38,-0.82l0.03,-0.16l-0.13,-1.38l0.3,-2.16l0.47,-1.51l0.73,-1.31l0.04,-0.12l0.15,-1.51l0.21,-1.66l0.89,-1.16l1.16,-0.7l1.9,0.79l1.69,0.95l1.81,0.24l1.85,0.48l0.35,-0.16l0.71,-1.43l0.16,-0.09l1.03,0.23l0.19,-0.02l2.65,-1.19l0.86,0.46l0.17,0.03l0.81,-0.08l0.23,-0.14l0.31,-0.5l0.75,-0.17l1.83,0.26l1.64,0.06l0.72,-0.21l1.39,1.9l0.16,0.11l1.12,0.3l0.24,-0.04l0.58,-0.36l1.05,0.15l0.15,-0.02l1.15,-0.44l0.47,0.84l0.08,0.09l2.08,1.57Z" data-code="CD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M463.29,152.22l-0.88,-0.47l-0.18,-0.03l-1.08,0.15l-1.86,-0.94l-0.21,-0.02l-0.88,0.24l-0.13,0.07l-1.25,1.17l-1.63,-0.91l-1.38,-1.36l-1.22,-0.75l-0.24,-1.24l-0.33,-0.75l1.53,-0.6l0.98,-0.84l1.74,-0.62l0.11,-0.07l0.47,-0.47l0.46,0.27l0.24,0.03l0.96,-0.3l1.06,0.95l0.15,0.07l1.57,0.24l-0.1,0.6l0.16,0.32l1.36,0.68l0.41,-0.15l0.28,-0.62l1.29,0.28l0.19,0.84l0.26,0.23l1.73,0.18l0.74,1.02l-0.17,0.0l-0.25,0.13l-0.32,0.49l-0.46,0.11l-0.22,0.23l-0.13,0.57l-0.32,0.1l-0.2,0.22l-0.03,0.14l-0.65,0.25l-1.05,-0.05l-0.28,0.17l-0.22,0.43Z" data-code="CZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.03,193.75l-1.51,0.68l-1.0,-0.3l-0.32,-0.63l0.69,-0.06l0.41,0.13l0.19,-0.0l0.62,-0.22l0.31,0.02l0.06,0.22l0.49,0.17l0.06,-0.01Z" data-code="CY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M213.0,263.84l-0.98,-0.4l-0.3,-0.31l0.16,-0.24l0.05,-0.21l-0.09,-0.56l-0.1,-0.18l-0.76,-0.65l-0.99,-0.5l-0.74,-0.28l-0.13,-0.58l-0.12,-0.18l-0.66,-0.45l-0.34,-0.0l-0.13,0.31l0.13,0.59l-0.17,0.21l-0.34,-0.42l-0.14,-0.1l-0.7,-0.22l-0.23,-0.34l0.01,-0.62l0.31,-0.74l-0.14,-0.38l-0.3,-0.15l0.47,-0.4l1.48,0.6l0.26,-0.02l0.47,-0.27l0.58,0.15l0.35,0.44l0.17,0.11l0.74,0.17l0.27,-0.07l0.3,-0.27l0.52,1.09l0.97,1.02l0.77,0.71l-0.41,0.1l-0.23,0.3l0.01,1.02l0.12,0.24l0.2,0.14l-0.07,0.05l-0.11,0.3l0.08,0.37l-0.23,0.63Z" data-code="CR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M215.01,226.09l2.08,0.18l1.94,0.03l2.24,0.86l0.95,0.92l0.25,0.08l2.22,-0.28l0.79,0.55l3.68,2.81l0.19,0.06l0.77,-0.03l1.18,0.42l-0.12,0.47l0.27,0.37l1.78,0.1l1.59,0.9l-0.11,0.22l-1.5,0.3l-1.64,0.13l-1.75,-0.2l-2.69,0.19l1.0,-0.86l-0.03,-0.48l-1.02,-0.68l-0.13,-0.05l-1.52,-0.16l-0.74,-0.64l-0.57,-1.42l-0.3,-0.19l-1.36,0.1l-2.23,-0.67l-0.71,-0.52l-0.14,-0.06l-3.2,-0.4l-0.42,-0.25l0.56,-0.39l0.12,-0.33l-0.27,-0.22l-2.46,-0.13l-0.2,0.06l-1.72,1.31l-0.94,0.03l-0.25,0.15l-0.29,0.53l-1.04,0.24l-0.29,-0.07l0.7,-0.43l0.1,-0.11l0.5,-0.87l1.04,-0.54l1.23,-0.49l1.86,-0.25l0.62,-0.28Z" data-code="CU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M500.95,353.41l-0.41,0.97l-1.16,0.23l-1.29,-1.26l-0.02,-0.71l0.63,-0.93l0.23,-0.7l0.47,-0.12l1.04,0.4l0.32,1.05l0.2,1.08Z" data-code="SZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M510.84,199.83l0.09,-0.11l0.07,-0.2l-0.04,-1.08l0.56,-1.4l1.3,-1.01l0.1,-0.34l-0.41,-1.11l-0.24,-0.19l-0.89,-0.11l-0.2,-1.84l0.55,-1.05l1.3,-1.22l0.09,-0.19l0.09,-1.09l0.39,0.27l0.25,0.04l2.66,-0.77l1.35,0.52l2.06,-0.01l2.93,-1.08l1.35,0.04l2.14,-0.34l-0.83,1.16l-1.31,0.68l-0.16,0.3l0.23,2.03l-0.9,3.25l-5.43,2.87l-4.79,2.91l-2.32,-0.92Z" data-code="SY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M599.04,172.15l0.38,-0.9l1.43,-0.37l4.04,1.02l0.37,-0.23l0.36,-1.64l1.17,-0.52l3.45,1.24l0.2,-0.0l0.86,-0.31l4.09,0.08l3.61,0.31l1.18,1.02l0.11,0.06l1.19,0.34l-0.13,0.26l-3.84,1.58l-0.13,0.1l-0.81,1.08l-3.08,0.34l-0.24,0.16l-0.85,1.7l-2.43,-0.37l-0.14,0.01l-1.79,0.61l-2.39,1.4l-0.12,0.39l0.25,0.49l-0.48,0.45l-4.57,0.43l-3.04,-0.94l-2.45,0.18l0.14,-1.02l2.42,0.44l0.27,-0.08l0.81,-0.81l1.76,0.27l0.21,-0.05l3.21,-2.14l-0.03,-0.51l-2.97,-1.57l-0.26,-0.01l-1.64,0.69l-1.38,-0.84l1.81,-1.67l-0.09,-0.5l-0.46,-0.18Z" data-code="KG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M523.3,287.04l0.06,0.17l1.29,1.8l-1.46,0.84l-0.11,0.11l-0.55,0.93l-0.81,0.16l-0.24,0.24l-0.34,1.69l-0.81,1.06l-0.46,1.58l-0.76,0.63l-3.3,-2.3l-0.16,-1.32l-0.15,-0.23l-9.35,-5.28l-0.02,-2.4l1.92,-2.63l0.91,-1.83l0.01,-0.24l-1.09,-2.86l-0.29,-1.24l-1.09,-1.63l2.93,-2.85l0.92,0.3l0.0,1.19l0.09,0.22l0.86,0.83l0.21,0.08l1.65,0.0l3.09,2.08l0.16,0.05l0.79,0.03l0.54,-0.06l0.58,0.28l1.67,0.2l0.28,-0.12l0.69,-0.98l2.04,-0.94l0.86,0.73l0.19,0.07l1.1,0.0l-1.82,2.36l-0.06,0.18l0.03,9.12Z" data-code="KE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.7,261.39l0.02,1.64l-0.27,0.55l-1.15,0.05l-0.24,0.15l-0.85,1.44l0.22,0.45l1.44,0.17l1.15,1.12l0.42,0.95l0.14,0.15l1.06,0.54l1.33,2.45l-3.06,2.98l-1.44,1.08l-1.75,0.01l-1.92,0.56l-1.5,-0.53l-0.27,0.03l-0.85,0.57l-1.98,-1.5l-0.56,-1.02l-0.37,-0.13l-1.32,0.5l-1.08,-0.15l-0.2,0.04l-0.56,0.35l-0.9,-0.24l-1.44,-1.97l-0.39,-0.77l-0.13,-0.13l-1.78,-0.94l-0.65,-1.5l-1.08,-1.12l-1.57,-1.22l-0.02,-0.68l-0.12,-0.23l-1.37,-1.02l-1.17,-0.68l0.2,-0.08l0.86,-0.48l0.14,-0.18l0.63,-2.22l0.6,-1.02l1.47,-0.28l0.35,0.56l1.29,1.48l0.14,0.09l0.69,0.22l0.22,-0.02l0.83,-0.4l1.58,0.08l0.26,0.39l0.25,0.13l2.49,0.0l0.3,-0.25l0.06,-0.35l1.13,-0.42l0.18,-0.18l0.22,-0.63l0.68,-0.38l1.95,1.37l0.23,0.05l1.29,-0.26l0.19,-0.12l1.23,-1.8l1.36,-1.37l0.08,-0.25l-0.21,-1.52l-0.06,-0.15l-0.25,-0.3l0.94,-0.08l0.26,-0.21l0.1,-0.32l0.6,0.09l-0.25,1.67l0.3,1.83l0.11,0.19l1.22,0.94l0.25,0.73l-0.04,1.2l0.26,0.31l0.09,0.01Z" data-code="SS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M278.1,270.26l2.71,0.45l0.31,-0.14l0.19,-0.32l1.82,-0.16l2.25,0.56l-1.09,1.81l-0.04,0.19l0.2,1.72l0.05,0.13l0.9,1.35l-0.39,0.99l-0.21,1.09l-0.48,0.8l-1.2,-0.44l-0.17,-0.01l-1.12,0.24l-0.95,-0.21l-0.35,0.2l-0.25,0.73l0.05,0.29l0.3,0.35l-0.06,0.13l-1.01,-0.15l-1.42,-2.03l-0.32,-1.36l-0.29,-0.23l-0.63,-0.0l-0.95,-1.56l0.41,-1.16l0.01,-0.17l-0.08,-0.35l1.29,-0.56l0.18,-0.22l0.35,-1.97Z" data-code="SR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M680.28,257.89l-0.93,-1.2l-1.24,-2.56l-0.56,-2.9l1.45,-1.92l3.07,-0.46l2.26,0.35l2.03,0.98l0.38,-0.11l1.0,-1.55l1.86,0.79l0.52,1.51l-0.28,2.82l-4.05,1.88l-0.12,0.45l0.79,1.1l-2.2,0.17l-2.08,0.98l-1.89,-0.33Z" data-code="KH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M197.02,248.89l0.18,-0.05l0.59,0.17l0.55,0.51l0.64,0.35l0.06,0.22l0.37,0.21l1.01,-0.28l0.38,0.13l0.16,0.13l-0.14,0.81l-0.18,0.38l-1.22,-0.03l-0.84,-0.23l-1.11,-0.52l-1.31,-0.15l-0.49,-0.38l0.02,-0.08l0.76,-0.57l0.46,-0.27l0.11,-0.35Z" data-code="SV" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M468.01,150.02l0.05,0.07l0.36,0.1l0.85,-0.37l1.12,1.02l0.33,0.05l1.38,-0.65l1.07,0.3l0.16,0.0l1.69,-0.43l1.95,1.02l-0.51,0.64l-0.45,1.2l-0.32,0.2l-2.55,-0.93l-0.17,-0.01l-0.82,0.2l-0.17,0.11l-0.53,0.68l-0.94,0.32l-0.14,-0.11l-0.29,-0.04l-1.18,0.48l-0.95,0.09l-0.26,0.21l-0.15,0.47l-1.84,0.34l-0.82,-0.31l-1.14,-0.73l-0.2,-0.89l0.42,-0.84l0.91,0.05l0.12,-0.02l0.86,-0.33l0.18,-0.21l0.03,-0.13l0.32,-0.1l0.2,-0.22l0.12,-0.55l0.39,-0.1l0.18,-0.13l0.3,-0.45l0.43,-0.0Z" data-code="SK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M737.31,185.72l0.84,0.08l0.27,-0.12l0.89,-1.2l1.63,-0.13l1.1,-0.2l0.21,-0.16l0.12,-0.24l1.86,2.95l0.59,1.79l0.02,3.17l-0.84,1.38l-2.23,0.55l-1.95,1.14l-1.91,0.21l-0.22,-1.21l0.45,-2.07l-0.01,-0.17l-0.99,-2.67l1.54,-0.4l0.17,-0.46l-1.55,-2.24Z" data-code="KR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M455.77,159.59l1.79,0.21l0.18,-0.04l1.2,-0.68l2.12,-0.08l0.21,-0.1l0.38,-0.42l0.1,0.01l0.28,0.62l-1.71,0.71l-0.18,0.22l-0.21,1.1l-0.71,0.26l-0.2,0.28l0.01,0.55l-0.59,-0.04l-0.79,-0.47l-0.38,0.06l-0.36,0.41l-0.84,-0.05l0.05,-0.15l-0.56,-1.24l0.21,-1.17Z" data-code="SI" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M747.76,172.02l-0.23,-0.04l-0.26,0.08l-1.09,1.02l-0.78,1.06l-0.06,0.19l0.09,1.95l-1.12,0.57l-0.53,0.58l-0.88,0.82l-1.69,0.51l-1.09,0.79l-0.12,0.22l-0.07,1.17l-0.22,0.25l0.09,0.47l0.96,0.46l1.22,1.1l-0.19,0.37l-0.91,0.16l-1.75,0.14l-0.22,0.12l-0.87,1.18l-0.95,-0.09l-0.3,0.18l-0.97,-0.44l-0.39,0.13l-0.25,0.44l-0.29,0.09l-0.03,-0.2l-0.18,-0.23l-0.62,-0.25l-0.43,-0.29l0.52,-0.97l0.52,-0.3l0.13,-0.38l-0.18,-0.42l0.59,-1.47l0.01,-0.21l-0.16,-0.48l-0.22,-0.2l-1.41,-0.31l-0.82,-0.55l1.74,-1.62l2.73,-1.58l1.62,-1.96l0.96,0.76l0.17,0.06l2.17,0.11l0.31,-0.37l-0.32,-1.31l3.61,-1.21l0.16,-0.13l0.79,-1.34l1.25,1.38Z" data-code="KP" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M543.8,256.48l0.61,-0.05l1.14,-0.37l1.31,-0.25l0.12,-0.05l1.11,-0.81l0.57,-0.0l0.03,0.39l-0.23,1.49l0.01,1.25l-0.52,0.92l-0.7,2.71l-1.19,2.79l-1.54,3.2l-2.13,3.66l-2.12,2.79l-2.92,3.39l-2.47,2.0l-3.76,2.5l-2.33,1.9l-2.77,3.06l-0.61,1.35l-0.28,0.29l-1.22,-1.69l-0.03,-8.92l2.12,-2.76l0.59,-0.68l1.47,-0.04l0.18,-0.06l2.15,-1.71l3.16,-0.11l0.21,-0.09l7.08,-7.55l1.76,-2.12l1.14,-1.57l0.06,-0.18l0.01,-4.67Z" data-code="SO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M379.28,250.34l-0.95,-1.82l-0.09,-0.1l-0.83,-0.6l0.62,-0.28l0.13,-0.11l1.21,-1.8l0.6,-1.31l0.71,-0.68l1.09,0.2l0.18,-0.02l1.17,-0.53l1.25,-0.03l1.17,0.73l1.59,0.65l1.47,1.83l1.59,1.7l0.12,1.56l0.49,1.46l0.1,0.14l0.85,0.65l0.18,0.82l-0.08,0.57l-0.13,0.05l-1.29,-0.19l-0.29,0.13l-0.11,0.16l-0.35,0.04l-1.83,-0.61l-5.84,-0.13l-0.12,0.02l-0.6,0.26l-0.87,-0.06l-1.01,0.32l-0.26,-1.26l1.9,0.04l0.16,-0.04l0.54,-0.32l0.37,-0.02l0.15,-0.05l0.78,-0.5l0.92,0.46l0.12,0.03l1.09,0.04l0.15,-0.03l1.08,-0.57l0.11,-0.44l-0.51,-0.74l-0.39,-0.1l-0.76,0.39l-0.62,-0.01l-0.92,-0.58l-0.18,-0.05l-0.79,0.04l-0.2,0.09l-0.48,0.51l-2.41,0.06Z" data-code="SN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M392.19,267.53l-0.44,-0.12l-1.73,-0.97l-1.24,-1.28l-0.4,-0.84l-0.27,-1.65l1.21,-1.0l0.09,-0.12l0.27,-0.66l0.32,-0.41l0.56,-0.05l0.16,-0.07l0.5,-0.41l1.75,0.0l0.59,0.77l0.49,0.96l-0.07,0.64l0.04,0.19l0.36,0.58l-0.03,0.84l0.24,0.2l-0.64,0.65l-1.13,1.37l-0.06,0.14l-0.12,0.66l-0.43,0.58Z" data-code="SL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M826.74,311.51l0.23,0.29l-0.95,-0.01l-0.39,-0.63l0.65,0.27l0.45,0.09ZM825.01,308.52l-1.18,-1.39l-0.37,-1.06l0.24,0.0l0.82,1.84l0.49,0.6ZM823.21,309.42l-0.44,0.03l-1.43,-0.24l-0.32,-0.24l0.08,-0.5l1.29,0.31l0.72,0.47l0.11,0.18ZM817.9,303.81l2.59,1.44l0.3,0.41l-1.21,-0.66l-1.34,-0.89l-0.34,-0.3ZM813.77,302.4l0.48,0.34l0.1,0.08l-0.33,-0.17l-0.25,-0.25Z" data-code="SB" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M528.24,243.1l-0.2,-0.69l-0.07,-0.12l-0.69,-0.71l-0.18,-0.94l-0.12,-0.19l-1.24,-0.89l-1.28,-2.09l-0.7,-2.08l-0.07,-0.11l-1.73,-1.79l-0.11,-0.07l-1.03,-0.39l-1.57,-2.36l-0.27,-1.72l0.1,-1.53l-0.03,-0.15l-1.44,-2.93l-1.25,-1.13l-1.34,-0.56l-0.72,-1.33l0.11,-0.49l-0.02,-0.2l-0.7,-1.38l-0.08,-0.1l-0.68,-0.56l-0.97,-1.98l-2.8,-4.03l-0.25,-0.13l-0.85,0.01l0.29,-1.11l0.12,-0.97l0.23,-0.81l2.52,0.39l0.23,-0.06l1.08,-0.84l0.6,-0.95l1.78,-0.35l0.22,-0.17l0.37,-0.83l0.74,-0.42l0.08,-0.46l-2.17,-2.4l4.55,-1.26l0.12,-0.06l0.36,-0.32l2.83,0.71l3.67,1.91l7.04,5.5l0.17,0.06l4.64,0.22l2.06,0.24l0.55,1.15l0.28,0.17l1.56,-0.06l0.9,2.15l0.14,0.15l1.14,0.57l0.39,0.85l0.11,0.13l1.59,1.06l0.12,0.91l-0.23,0.83l0.01,0.18l0.32,0.9l0.07,0.11l0.68,0.7l0.33,0.86l0.37,0.65l0.09,0.1l0.76,0.53l0.25,0.04l0.45,-0.12l0.35,0.75l0.1,0.63l0.96,2.68l0.23,0.19l7.53,1.33l0.27,-0.09l0.24,-0.26l0.87,1.41l-1.58,4.96l-7.34,2.54l-7.28,1.02l-2.34,1.17l-0.12,0.1l-1.74,2.63l-0.86,0.32l-0.49,-0.68l-0.28,-0.12l-0.92,0.12l-2.32,-0.25l-0.41,-0.23l-0.15,-0.04l-2.89,0.06l-0.63,0.2l-0.91,-0.59l-0.43,0.11l-0.66,1.27l-0.03,0.21l0.21,0.89l-0.6,0.45Z" data-code="SA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M476.42,90.44l-0.15,0.1l-2.43,2.86l-0.07,0.24l0.36,2.31l-3.84,3.1l-4.83,3.38l-0.11,0.15l-1.82,5.45l0.03,0.26l1.78,2.68l2.27,1.99l-2.13,3.88l-2.49,0.82l-0.2,0.24l-0.95,6.05l-1.32,3.09l-2.82,-0.32l-0.3,0.16l-1.34,2.64l-2.48,0.14l-0.76,-3.15l-2.09,-4.04l-1.85,-5.01l1.03,-1.98l2.06,-2.53l0.06,-0.13l0.83,-4.45l-0.06,-0.25l-1.54,-1.86l-0.15,-5.0l1.52,-3.48l2.28,0.06l0.27,-0.16l0.87,-1.59l-0.01,-0.31l-0.8,-1.21l3.79,-5.63l4.07,-7.54l2.23,0.01l0.29,-0.22l0.59,-2.15l4.46,0.66l0.34,-0.26l0.34,-2.64l1.21,-0.14l3.24,2.08l3.78,2.85l0.06,6.37l0.03,0.14l0.67,1.29l-3.95,1.07Z" data-code="SE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.98,259.75l-0.31,-0.9l-0.1,-0.14l-1.2,-0.93l-0.27,-1.66l0.29,-1.83l-0.25,-0.34l-1.16,-0.17l-0.33,0.21l-0.11,0.37l-1.3,0.11l-0.21,0.49l0.55,0.68l0.18,1.29l-1.31,1.33l-1.18,1.72l-1.04,0.21l-2.0,-1.4l-0.32,-0.02l-0.95,0.52l-0.14,0.16l-0.21,0.6l-1.16,0.43l-0.19,0.23l-0.04,0.27l-2.08,0.0l-0.25,-0.39l-0.24,-0.13l-1.81,-0.09l-0.14,0.03l-0.8,0.38l-0.49,-0.16l-1.22,-1.39l-0.42,-0.67l-0.31,-0.14l-1.81,0.35l-0.2,0.14l-0.72,1.24l-0.61,2.14l-0.73,0.4l-0.62,0.22l-0.83,-0.68l-0.12,-0.6l0.38,-0.97l0.01,-1.14l-0.08,-0.2l-1.39,-1.53l-0.25,-0.97l0.03,-0.57l-0.11,-0.25l-0.81,-0.66l-0.03,-1.34l-0.04,-0.14l-0.52,-0.98l-0.31,-0.15l-0.42,0.07l0.12,-0.44l0.63,-1.03l0.03,-0.23l-0.24,-0.88l0.69,-0.66l0.02,-0.41l-0.4,-0.46l0.58,-1.39l1.04,-1.71l1.97,0.16l0.32,-0.3l-0.12,-10.24l0.02,-0.8l2.59,-0.01l0.3,-0.3l0.0,-4.92l29.19,0.0l0.68,2.17l-0.4,0.35l-0.1,0.27l0.36,2.69l0.93,3.15l0.12,0.16l2.05,1.4l-0.99,1.15l-1.75,0.4l-0.15,0.08l-0.79,0.79l-0.08,0.17l-0.24,1.69l-1.07,3.75l-0.0,0.16l0.25,0.96l-0.38,2.1l-0.98,2.41l-1.52,1.3l-1.07,1.94l-0.25,0.99l-1.08,0.64l-0.13,0.18l-0.46,1.65Z" data-code="SD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M241.7,234.97l0.15,-0.22l1.73,0.01l1.43,0.64l0.15,0.03l0.45,-0.04l0.36,0.74l0.28,0.17l1.02,-0.04l-0.04,0.43l0.27,0.33l1.03,0.09l0.91,0.7l-0.57,0.64l-0.99,-0.47l-0.16,-0.03l-1.11,0.11l-0.79,-0.12l-0.26,0.09l-0.38,0.4l-0.66,0.11l-0.28,-0.45l-0.38,-0.12l-0.83,0.37l-0.14,0.13l-0.85,1.49l-0.27,-0.17l-0.1,-0.58l0.05,-0.67l-0.07,-0.21l-0.44,-0.53l0.35,-0.25l0.12,-0.19l0.19,-1.0l-0.2,-1.4Z" data-code="DO" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M528.78,253.36l0.34,0.45l-0.06,0.76l-1.26,0.54l-0.05,0.53l0.82,0.53l-0.57,0.83l-0.3,-0.25l-0.27,-0.05l-0.56,0.17l-1.07,-0.03l-0.04,-0.56l-0.16,-0.56l0.76,-1.07l0.76,-0.97l0.89,0.18l0.25,-0.06l0.51,-0.42Z" data-code="DJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M452.4,129.07l-1.27,2.39l-2.25,-1.69l-0.26,-1.08l3.15,-1.0l0.63,1.39ZM447.87,126.25l-0.35,0.76l-0.47,-0.24l-0.38,0.09l-1.8,2.53l-0.03,0.29l0.56,1.4l-1.22,0.4l-1.68,-0.41l-0.92,-1.76l-0.07,-3.47l0.38,-0.88l0.62,-0.93l2.07,-0.21l0.19,-0.1l0.84,-0.95l1.5,-0.76l-0.06,1.26l-0.7,1.1l-0.03,0.25l0.3,1.0l0.18,0.19l1.06,0.42Z" data-code="DK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M445.51,131.69l0.03,0.94l0.21,0.28l2.32,0.74l-0.02,1.0l0.37,0.3l2.55,-0.65l1.36,-0.89l2.63,1.27l1.09,1.01l0.51,1.51l-0.6,0.78l-0.0,0.36l0.88,1.17l0.58,1.68l-0.18,1.08l0.03,0.18l0.87,1.81l-0.66,0.2l-0.55,-0.32l-0.36,0.05l-0.58,0.58l-1.73,0.62l-0.99,0.84l-1.77,0.7l-0.16,0.4l0.42,0.94l0.26,1.34l0.14,0.2l1.25,0.76l1.22,1.2l-0.71,1.2l-0.81,0.37l-0.17,0.32l0.34,1.99l-0.04,0.09l-0.47,-0.39l-0.17,-0.07l-1.2,-0.1l-1.85,0.57l-2.15,-0.13l-0.29,0.18l-0.21,0.5l-0.96,-0.67l-0.24,-0.05l-0.67,0.16l-2.6,-0.94l-0.34,0.1l-0.42,0.57l-1.64,-0.02l0.26,-1.88l1.24,-2.15l-0.21,-0.45l-3.54,-0.58l-0.98,-0.71l0.12,-1.26l-0.05,-0.2l-0.44,-0.64l0.27,-2.18l-0.38,-3.14l1.17,-0.0l0.27,-0.17l0.63,-1.26l0.65,-3.17l-0.02,-0.17l-0.41,-1.0l0.32,-0.47l1.77,-0.16l0.37,0.6l0.47,0.06l1.7,-1.69l0.06,-0.33l-0.55,-1.24l-0.09,-1.51l1.5,0.36l0.16,-0.01l1.22,-0.4Z" data-code="DE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M553.53,242.65l-1.51,0.58l-0.17,0.16l-0.48,1.14l-0.07,0.79l-2.31,1.0l-3.98,1.19l-2.28,1.8l-0.97,0.12l-0.7,-0.14l-0.23,0.05l-1.42,1.03l-1.51,0.47l-2.07,0.13l-0.68,0.15l-0.17,0.1l-0.49,0.6l-0.57,0.16l-0.18,0.13l-0.3,0.49l-1.06,-0.05l-0.13,0.02l-0.73,0.32l-1.48,-0.11l-0.55,-1.26l0.07,-1.32l-0.04,-0.16l-0.39,-0.72l-0.48,-1.85l-0.52,-0.79l0.08,-0.02l0.22,-0.36l-0.23,-1.05l0.24,-0.39l0.04,-0.19l-0.09,-0.95l0.96,-0.72l0.11,-0.31l-0.23,-0.98l0.46,-0.88l0.75,0.49l0.26,0.03l0.63,-0.22l2.76,-0.06l0.5,0.25l2.42,0.26l0.85,-0.11l0.52,0.71l0.35,0.1l1.17,-0.43l0.15,-0.12l1.75,-2.64l2.22,-1.11l6.95,-0.96l2.55,5.58Z" data-code="YE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M463.17,154.15l-0.14,0.99l-1.15,0.01l-0.24,0.47l0.39,0.56l-0.75,1.84l-0.36,0.4l-2.06,0.07l-0.14,0.04l-1.18,0.67l-1.96,-0.23l-3.43,-0.78l-0.5,-0.97l-0.33,-0.16l-2.47,0.55l-0.2,0.16l-0.18,0.37l-1.27,-0.38l-1.28,-0.09l-0.81,-0.41l0.25,-0.51l0.03,-0.18l-0.05,-0.28l0.35,-0.08l1.16,0.81l0.45,-0.13l0.27,-0.64l2.0,0.12l1.84,-0.57l1.05,0.09l0.71,0.59l0.47,-0.11l0.23,-0.54l0.02,-0.17l-0.32,-1.85l0.69,-0.31l0.13,-0.12l0.73,-1.23l1.61,0.89l0.35,-0.04l1.35,-1.27l0.7,-0.19l1.84,0.93l0.18,0.03l1.08,-0.15l0.81,0.43l-0.07,0.15l-0.02,0.2l0.24,1.06Z" data-code="AT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M450.58,224.94l-8.31,4.86l-7.23,5.12l-3.46,1.13l-2.42,0.22l-0.02,-1.33l-0.2,-0.28l-1.15,-0.42l-1.45,-0.69l-0.55,-1.13l-0.1,-0.12l-8.45,-5.72l-17.72,-12.17l0.03,-0.38l-0.02,-3.21l3.84,-1.91l2.46,-0.41l2.1,-0.75l0.14,-0.11l0.9,-1.3l2.84,-1.06l0.19,-0.27l0.09,-1.81l1.21,-0.2l0.15,-0.07l1.06,-0.96l3.19,-0.46l0.23,-0.18l0.46,-1.08l-0.08,-0.34l-0.6,-0.54l-0.83,-2.85l-0.18,-1.8l-0.82,-1.57l2.13,-1.37l2.65,-0.49l0.13,-0.05l1.55,-1.15l2.34,-0.85l4.2,-0.51l4.07,-0.23l1.21,0.41l0.23,-0.01l2.3,-1.11l2.52,-0.02l0.94,0.62l0.2,0.05l1.25,-0.13l-0.36,1.03l-0.01,0.14l0.39,2.66l-0.56,2.2l-1.49,1.52l-0.08,0.24l0.22,2.12l0.11,0.2l1.94,1.58l0.02,0.54l0.12,0.23l1.45,1.06l1.04,4.85l0.81,2.42l0.13,1.19l-0.43,2.17l0.17,1.28l-0.31,1.53l0.2,1.56l-0.9,1.02l-0.01,0.38l1.43,1.88l0.09,1.06l0.04,0.13l0.89,1.48l0.37,0.12l1.03,-0.43l1.79,1.12l0.89,1.34Z" data-code="DZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M892.64,99.05l1.16,0.57l0.21,0.02l1.45,-0.38l1.92,0.99l2.17,0.47l-1.65,0.72l-1.75,-0.79l-0.93,-0.7l-0.21,-0.06l-2.11,0.22l-0.35,-0.2l0.09,-0.87ZM183.29,150.37l0.39,1.54l0.12,0.17l0.78,0.55l0.14,0.05l1.74,0.2l2.52,0.5l2.4,0.98l0.17,0.02l1.96,-0.4l3.01,0.81l0.91,-0.02l2.22,-0.88l4.67,2.33l3.86,2.01l0.21,0.71l0.15,0.18l0.33,0.17l-0.02,0.05l0.23,0.43l0.67,0.1l0.21,-0.05l0.1,-0.07l0.05,0.29l0.09,0.16l0.5,0.5l0.21,0.09l0.56,0.0l0.13,0.13l-0.2,0.36l0.12,0.41l2.49,1.39l0.99,5.24l-0.69,1.68l-1.16,1.64l-0.6,1.18l-0.06,0.31l0.04,0.22l0.28,0.43l0.11,0.1l0.85,0.47l0.15,0.04l0.63,0.0l0.14,-0.04l2.87,-1.58l2.6,-0.49l3.28,-1.5l0.17,-0.23l0.04,-0.43l-0.23,-0.93l-0.24,-0.39l0.74,-0.32l4.7,-0.01l0.25,-0.13l0.77,-1.15l2.9,-2.41l1.04,-0.52l8.35,-0.02l0.28,-0.21l0.2,-0.6l0.7,-0.14l1.06,-0.48l0.13,-0.11l0.92,-1.49l0.75,-2.39l1.67,-2.08l0.59,0.6l0.3,0.07l1.52,-0.49l0.88,0.72l-0.0,4.14l0.08,0.2l1.6,1.72l0.31,0.72l-2.42,1.35l-2.55,1.05l-2.64,0.9l-0.14,0.11l-1.33,1.81l-0.44,0.7l-0.05,0.15l-0.03,1.6l0.03,0.14l0.83,1.59l0.24,0.16l0.78,0.06l-1.15,0.33l-1.25,-0.04l-1.83,0.52l-2.51,0.29l-2.17,0.88l-0.17,0.36l0.33,0.22l3.55,-0.54l0.15,0.11l-2.87,0.73l-1.19,0.0l-0.16,-0.33l-0.36,0.06l-0.76,0.82l0.17,0.5l0.42,0.08l-0.45,1.75l-1.4,1.74l-0.04,-0.17l-0.21,-0.22l-0.48,-0.13l-0.77,-0.69l-0.36,-0.03l-0.12,0.34l0.52,1.58l0.09,0.14l0.52,0.43l0.03,0.87l-0.74,1.05l-0.39,0.63l0.05,-0.12l-0.08,-0.34l-1.19,-1.03l-0.28,-2.31l-0.26,-0.26l-0.32,0.19l-0.48,1.27l-0.01,0.19l0.39,1.33l-1.14,-0.31l-0.36,0.18l0.14,0.38l1.57,0.85l0.1,2.58l0.22,0.28l0.55,0.15l0.21,0.81l0.33,2.72l-1.46,1.94l-2.5,0.81l-0.12,0.07l-1.58,1.58l-1.15,0.17l-0.15,0.06l-1.27,1.03l-0.09,0.13l-0.32,0.85l-2.71,1.79l-1.45,1.37l-1.18,1.64l-0.05,0.12l-0.39,1.96l0.0,0.13l0.44,1.91l0.85,2.37l1.1,1.91l0.03,1.2l1.16,3.07l-0.08,1.74l-0.1,0.99l-0.57,1.48l-0.54,0.24l-0.97,-0.26l-0.34,-1.02l-0.12,-0.16l-0.89,-0.58l-2.44,-4.28l-0.34,-0.94l0.49,-1.71l-0.02,-0.21l-0.7,-1.5l-2.0,-2.35l-0.11,-0.08l-0.98,-0.42l-0.25,0.01l-2.42,1.19l-0.26,-0.08l-1.26,-1.29l-1.57,-0.68l-0.16,-0.02l-2.79,0.34l-2.18,-0.3l-1.98,0.19l-1.12,0.45l-0.14,0.44l0.4,0.65l-0.04,1.02l0.09,0.22l0.29,0.3l-0.06,0.05l-0.77,-0.33l-0.26,0.01l-0.87,0.48l-1.64,-0.08l-1.79,-1.39l-0.23,-0.06l-2.11,0.33l-1.75,-0.61l-0.14,-0.01l-1.61,0.2l-2.11,0.64l-0.11,0.06l-2.25,1.99l-2.53,1.21l-1.43,1.38l-0.58,1.22l-0.03,0.12l-0.03,1.86l0.13,1.32l0.3,0.62l-0.46,0.04l-1.71,-0.57l-1.85,-0.79l-0.63,-1.14l-0.54,-1.85l-0.07,-0.12l-1.45,-1.51l-0.86,-1.58l-1.26,-1.87l-0.09,-0.09l-1.76,-1.09l-0.17,-0.04l-2.05,0.05l-0.23,0.12l-1.44,1.97l-1.84,-0.72l-1.19,-0.76l-0.6,-1.45l-0.9,-1.52l-1.49,-1.21l-1.27,-0.87l-0.89,-0.96l-0.22,-0.1l-4.34,-0.0l-0.3,0.3l-0.0,0.84l-6.62,0.02l-5.66,-1.93l-3.48,-1.24l0.11,-0.25l-0.3,-0.42l-3.18,0.3l-2.6,0.2l-0.35,-1.19l-0.08,-0.13l-1.62,-1.61l-0.13,-0.08l-1.02,-0.29l-0.22,-0.66l-0.25,-0.2l-1.31,-0.13l-0.82,-0.7l-0.16,-0.07l-2.25,-0.27l-0.48,-0.34l-0.28,-1.44l-0.07,-0.14l-2.41,-2.84l-2.03,-3.89l0.08,-0.58l-0.1,-0.27l-1.08,-0.94l-1.87,-2.36l-0.33,-2.31l-0.07,-0.15l-1.24,-1.5l0.52,-2.4l-0.09,-2.57l-0.78,-2.3l0.96,-2.83l0.61,-5.66l-0.46,-4.26l-0.79,-2.71l-0.68,-1.4l0.13,-0.26l3.24,0.97l1.28,2.88l0.52,0.06l0.62,-0.84l0.06,-0.22l-0.4,-2.61l-0.74,-2.29l68.9,-0.0l0.3,-0.3l0.01,-0.95l0.32,-0.01ZM32.5,67.43l1.75,1.99l0.41,0.04l1.02,-0.81l3.79,0.25l-0.1,0.72l0.24,0.34l3.83,0.77l2.6,-0.44l5.21,1.41l4.84,0.43l1.9,0.57l0.15,0.01l3.25,-0.71l3.72,1.32l2.52,0.58l-0.03,38.14l0.29,0.3l2.41,0.11l2.34,1.0l1.7,1.59l2.22,2.42l0.42,0.03l2.41,-2.04l2.25,-1.08l1.23,1.76l1.71,1.53l2.24,1.62l1.54,2.56l2.56,4.09l0.11,0.11l4.1,2.17l0.06,1.93l-1.12,1.35l-1.22,-1.14l-2.08,-1.05l-0.68,-2.94l-0.09,-0.16l-3.18,-2.84l-1.32,-3.35l-0.25,-0.19l-2.43,-0.24l-3.93,-0.09l-2.85,-1.02l-5.24,-3.85l-6.77,-2.04l-3.52,0.3l-4.84,-1.7l-2.96,-1.6l-0.23,-0.02l-2.78,0.8l-0.21,0.35l0.46,2.31l-1.11,0.19l-2.9,0.78l-2.24,1.26l-2.42,0.68l-0.29,-1.79l1.07,-3.49l2.54,-1.11l0.12,-0.45l-0.69,-0.96l-0.41,-0.07l-3.19,2.12l-1.76,2.54l-3.57,2.62l-0.03,0.46l1.63,1.59l-2.14,2.38l-2.64,1.49l-2.49,1.09l-0.16,0.17l-0.58,1.48l-3.8,1.79l-0.14,0.14l-0.75,1.57l-2.75,1.41l-1.62,-0.25l-0.16,0.02l-2.35,0.98l-2.54,1.19l-2.06,1.15l-4.05,0.93l-0.1,-0.15l2.45,-1.45l2.49,-1.1l2.61,-1.88l3.03,-0.39l0.19,-0.1l1.2,-1.41l3.43,-2.11l0.61,-0.75l1.81,-1.24l0.13,-0.2l0.42,-2.7l1.24,-2.12l-0.03,-0.35l-0.34,-0.09l-2.73,1.05l-0.67,-0.53l-0.39,0.02l-1.13,1.11l-1.43,-1.62l-0.49,0.06l-0.41,0.8l-0.67,-1.31l-0.42,-0.12l-2.43,1.43l-1.18,-0.0l-0.18,-1.86l0.43,-1.3l-0.09,-0.33l-1.61,-1.33l-0.26,-0.06l-3.11,0.68l-2.0,-1.66l-1.61,-0.85l-0.01,-1.97l-0.11,-0.23l-1.76,-1.48l0.86,-1.96l2.01,-2.13l0.88,-1.94l1.79,-0.25l1.65,0.6l0.31,-0.06l1.91,-1.8l1.67,0.31l0.22,-0.04l1.91,-1.23l0.13,-0.33l-0.47,-1.82l-0.15,-0.19l-1.0,-0.52l1.51,-1.27l0.09,-0.34l-0.29,-0.19l-1.62,0.06l-2.66,0.88l-0.13,0.09l-0.62,0.72l-1.77,-0.8l-0.16,-0.02l-3.48,0.44l-3.5,-0.92l-1.06,-1.61l-2.78,-2.09l3.07,-1.51l5.52,-2.01l1.65,0.0l-0.28,1.73l0.31,0.35l5.29,-0.16l0.23,-0.49l-2.03,-2.59l-0.1,-0.08l-3.03,-1.58l-1.79,-2.12l-2.4,-1.83l-3.18,-1.27l1.13,-1.84l4.28,-0.14l0.15,-0.05l3.16,-2.0l0.13,-0.17l0.57,-2.07l2.43,-2.02l2.42,-0.52l4.67,-1.98l2.22,0.29l0.2,-0.04l3.74,-2.37l3.57,0.91ZM37.66,123.49l-2.31,1.26l-1.04,-0.75l-0.31,-1.35l2.06,-1.16l1.24,-0.51l1.48,0.22l0.76,0.81l-1.89,1.49ZM30.89,233.84l1.2,0.57l0.35,0.3l0.48,0.69l-1.6,0.86l-0.3,0.31l-0.24,-0.14l0.05,-0.54l-0.02,-0.15l-0.36,-0.83l0.05,-0.12l0.39,-0.38l0.07,-0.31l-0.09,-0.27ZM29.06,231.89l0.5,0.14l0.31,0.19l-0.46,0.1l-0.34,-0.43ZM25.02,230.13l0.2,-0.11l0.4,0.47l-0.43,-0.05l-0.17,-0.31ZM21.29,228.68l0.1,-0.07l0.22,0.02l0.02,0.21l-0.02,0.02l-0.32,-0.18ZM6.0,113.33l-1.19,0.45l-1.5,-0.64l-0.94,-0.63l1.76,-0.46l1.71,0.29l0.16,0.98Z" data-code="US" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M473.99,127.16l0.07,-2.15l1.15,-2.11l2.05,-1.07l1.84,2.48l0.25,0.12l2.01,-0.07l0.29,-0.25l0.45,-2.58l1.85,-0.56l0.98,0.4l2.13,1.33l0.16,0.05l1.97,0.01l1.02,0.7l0.21,1.67l0.71,1.84l-2.44,1.23l-1.36,0.53l-2.28,-1.62l-0.12,-0.05l-1.18,-0.2l-0.28,-0.6l-0.31,-0.17l-2.43,0.35l-4.17,-0.23l-0.12,0.02l-2.45,0.93Z" data-code="LV" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M276.9,363.17l1.3,-0.23l2.4,2.04l0.22,0.07l0.82,-0.07l2.48,1.7l1.93,1.5l1.28,1.67l-0.95,1.14l-0.04,0.31l0.63,1.45l-0.96,1.57l-2.65,1.47l-1.73,-0.53l-0.15,-0.01l-1.25,0.28l-2.22,-1.16l-0.16,-0.03l-1.56,0.08l-1.33,-1.36l0.17,-1.58l0.48,-0.55l0.07,-0.2l-0.02,-2.74l0.66,-2.8l0.57,-2.02Z" data-code="UY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M510.44,198.11l-0.48,0.03l-0.26,0.17l-0.15,0.32l-0.21,-0.0l0.72,-1.85l1.19,-1.9l0.74,0.09l0.27,0.73l-1.19,0.93l-0.09,0.13l-0.54,1.36Z" data-code="LB" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M684.87,248.8l0.61,-0.86l0.05,-0.16l0.11,-2.17l-0.08,-0.22l-1.96,-2.16l-0.15,-2.44l-0.08,-0.18l-1.9,-2.1l-0.19,-0.1l-1.89,-0.18l-0.29,0.15l-0.42,0.76l-1.21,0.06l-0.67,-0.41l-0.31,-0.0l-2.2,1.29l-0.05,-1.77l0.61,-2.7l-0.27,-0.37l-1.44,-0.1l-0.12,-1.31l-0.12,-0.21l-0.87,-0.65l0.38,-0.68l1.76,-1.41l0.08,0.22l0.27,0.2l1.33,0.07l0.31,-0.34l-0.35,-2.75l0.85,-0.25l1.32,1.88l1.11,2.36l0.27,0.17l2.89,0.02l0.78,1.82l-1.32,0.56l-0.12,0.09l-0.72,0.93l0.1,0.45l2.93,1.52l3.62,5.27l1.88,1.78l0.58,1.67l-0.38,2.11l-1.87,-0.79l-0.37,0.11l-0.99,1.54l-1.51,-0.73Z" data-code="LA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M725.6,222.5l-1.5,4.22l-0.82,1.65l-1.01,-1.7l-0.26,-1.8l1.4,-2.48l1.8,-1.81l0.76,0.53l-0.38,1.39Z" data-code="TW" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M266.35,259.46l0.41,-0.39l0.09,-0.23l-0.04,-0.75l1.14,-0.26l0.2,0.03l-0.07,1.37l-1.73,0.23Z" data-code="TT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M513.25,175.38l3.63,1.17l0.14,0.01l2.88,-0.45l2.11,0.26l0.18,-0.03l2.9,-1.53l2.51,-0.13l2.25,1.37l0.36,0.88l-0.23,1.36l0.19,0.33l1.81,0.72l0.61,0.53l-1.31,0.64l-0.16,0.34l0.76,3.24l-0.44,0.8l0.01,0.3l1.19,2.02l-0.71,0.29l-0.74,-0.62l-0.15,-0.07l-2.91,-0.37l-0.15,0.02l-1.04,0.43l-2.78,0.44l-1.44,-0.03l-2.83,1.06l-1.95,0.01l-1.28,-0.52l-0.2,-0.01l-2.62,0.76l-0.7,-0.48l-0.47,0.22l-0.13,1.49l-1.01,0.94l-0.58,-0.82l0.79,-0.9l0.04,-0.34l-0.31,-0.15l-1.46,0.23l-2.03,-0.64l-0.3,0.07l-1.65,1.58l-3.58,0.3l-1.94,-1.47l-0.17,-0.06l-2.7,-0.1l-0.28,0.17l-0.51,1.06l-1.47,0.29l-2.32,-1.46l-0.17,-0.05l-2.55,0.05l-1.4,-2.7l-1.72,-1.54l1.11,-2.06l-0.07,-0.37l-1.35,-1.19l2.47,-2.51l3.74,-0.11l0.26,-0.17l0.96,-2.07l4.56,0.38l0.19,-0.05l2.97,-1.92l2.84,-0.83l4.03,-0.06l4.31,2.08ZM488.85,176.8l-1.81,1.38l-0.57,-1.01l0.02,-0.36l0.45,-0.25l0.13,-0.15l0.78,-1.87l-0.11,-0.37l-0.72,-0.47l1.91,-0.71l1.89,0.35l0.25,0.97l0.17,0.2l1.87,0.83l-0.19,0.31l-2.82,0.16l-0.18,0.07l-1.06,0.91Z" data-code="TR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M625.44,266.07l-0.35,2.4l-0.9,0.61l-1.91,0.5l-1.04,-1.75l-0.43,-3.5l1.0,-3.6l1.34,1.09l1.13,1.72l1.16,2.52Z" data-code="LK" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M444.91,206.18l-0.99,-4.57l-0.12,-0.18l-1.43,-1.04l-0.02,-0.53l-0.11,-0.22l-1.95,-1.59l-0.19,-1.85l1.44,-1.47l0.08,-0.14l0.59,-2.34l-0.38,-2.77l0.44,-1.28l2.52,-1.08l1.41,0.28l-0.06,1.2l0.43,0.28l1.81,-0.9l0.02,0.06l-1.14,1.28l-0.08,0.2l-0.02,1.32l0.11,0.24l0.74,0.6l-0.29,2.18l-1.56,1.35l-0.09,0.32l0.48,1.54l0.28,0.21l1.11,0.04l0.55,1.17l0.15,0.14l0.76,0.35l-0.12,1.79l-1.1,0.72l-0.8,0.91l-1.68,1.04l-0.13,0.32l0.25,1.08l-0.18,0.96l-0.74,0.39Z" data-code="TN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M734.21,307.22l0.17,-0.34l1.99,-0.52l1.72,-0.08l0.78,-0.3l0.29,0.1l-0.43,0.32l-2.57,1.09l-1.71,0.59l-0.05,-0.49l-0.19,-0.36Z" data-code="TL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M553.16,173.51l-0.12,1.0l-0.26,-0.65l0.38,-0.34ZM553.54,173.16l0.13,-0.12l0.43,-0.09l-0.56,0.21ZM555.68,172.6l0.65,-0.14l1.53,0.76l1.71,2.29l0.27,0.12l1.27,-0.14l2.81,-0.04l0.29,-0.38l-0.35,-1.27l1.98,-0.97l1.96,-1.63l3.05,1.44l0.25,2.23l0.14,0.22l0.96,0.61l0.18,0.05l2.61,-0.13l0.68,0.44l1.2,2.97l0.1,0.13l2.85,2.03l1.67,1.41l2.66,1.45l3.13,1.17l-0.05,1.23l-0.36,-0.04l-1.12,-0.73l-0.44,0.14l-0.34,0.89l-1.96,0.52l-0.22,0.23l-0.47,2.17l-1.26,0.78l-1.93,0.42l-0.21,0.18l-0.46,1.14l-1.64,0.33l-2.3,-0.97l-0.2,-2.23l-0.28,-0.27l-1.76,-0.1l-2.78,-2.48l-0.15,-0.07l-1.95,-0.31l-2.82,-1.48l-1.78,-0.27l-0.18,0.03l-1.03,0.51l-1.6,-0.08l-0.22,0.08l-1.72,1.6l-1.83,0.46l-0.39,-1.7l0.36,-3.0l-0.16,-0.3l-1.73,-0.88l0.57,-1.77l-0.25,-0.39l-1.33,-0.14l0.41,-1.85l2.05,0.63l0.21,-0.01l2.2,-0.95l0.09,-0.49l-1.78,-1.75l-0.69,-1.66l-0.07,-0.03Z" data-code="TM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M597.99,178.71l-0.23,0.23l-2.57,-0.47l-0.35,0.25l-0.24,1.7l0.32,0.34l2.66,-0.22l3.15,0.95l4.47,-0.42l0.58,2.45l0.39,0.21l0.71,-0.25l1.22,0.53l-0.06,1.01l0.29,1.28l-2.19,-0.0l-1.71,-0.21l-0.23,0.07l-1.51,1.25l-1.05,0.27l-0.77,0.51l-0.71,-0.67l0.22,-2.28l-0.24,-0.32l-0.43,-0.08l0.17,-0.57l-0.16,-0.36l-1.36,-0.66l-0.34,0.05l-1.08,1.01l-0.09,0.15l-0.25,1.09l-0.24,0.26l-1.36,-0.05l-0.27,0.14l-0.65,1.06l-0.58,-0.39l-0.3,-0.02l-1.68,0.86l-0.36,-0.16l1.28,-2.65l0.02,-0.2l-0.54,-2.17l-0.18,-0.21l-1.53,-0.58l0.41,-0.82l1.89,0.13l0.26,-0.12l1.19,-1.63l0.77,-1.82l2.66,-0.55l-0.33,0.87l0.01,0.23l0.36,0.82l0.3,0.18l0.23,-0.02Z" data-code="TJ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M493.32,359.69l0.69,0.65l-0.65,1.12l-0.38,0.8l-1.27,0.39l-0.18,0.15l-0.4,0.77l-0.59,0.18l-1.59,-1.78l1.16,-1.5l1.3,-1.02l0.97,-0.46l0.94,0.72Z" data-code="LS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M677.42,253.68l-1.7,-0.88l-0.14,-0.03l-1.77,0.04l0.3,-1.64l-0.3,-0.35l-2.21,0.01l-0.3,0.28l-0.2,2.76l-2.15,5.9l-0.02,0.13l0.17,1.83l0.28,0.27l1.45,0.07l0.93,2.1l0.44,2.15l0.08,0.15l1.4,1.44l0.16,0.09l1.43,0.27l1.04,1.05l-0.58,0.73l-1.24,0.22l-0.15,-0.99l-0.15,-0.22l-2.04,-1.1l-0.36,0.06l-0.23,0.23l-0.72,-0.71l-0.41,-1.18l-0.06,-0.11l-1.33,-1.42l-1.22,-1.2l-0.5,0.13l-0.15,0.54l-0.14,-0.41l0.26,-1.48l0.73,-2.38l1.2,-2.57l1.37,-2.35l0.02,-0.27l-0.95,-2.26l0.03,-1.19l-0.29,-1.42l-0.06,-0.13l-1.65,-2.0l-0.46,-0.99l0.62,-0.34l0.13,-0.15l0.92,-2.23l-0.02,-0.27l-1.05,-1.74l-1.57,-1.86l-1.04,-1.96l0.76,-0.34l0.16,-0.16l1.07,-2.63l1.58,-0.1l0.16,-0.06l1.43,-1.11l1.24,-0.52l0.84,0.62l0.13,1.43l0.28,0.27l1.34,0.09l-0.54,2.39l0.05,2.39l0.45,0.25l2.48,-1.45l0.6,0.36l0.17,0.04l1.47,-0.07l0.25,-0.15l0.41,-0.73l1.58,0.15l1.76,1.93l0.15,2.44l0.08,0.18l1.94,2.15l-0.1,1.96l-0.66,0.93l-2.25,-0.34l-3.24,0.49l-0.19,0.12l-1.6,2.12l-0.06,0.24l0.48,2.46Z" data-code="TH" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M593.76,417.73l1.38,0.84l2.15,0.37l0.04,0.31l-0.59,1.24l-3.36,0.19l-0.05,-1.38l0.43,-1.56Z" data-code="TF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M425.23,269.29l-1.49,0.4l-0.43,-0.68l-0.64,-1.54l-0.18,-1.16l0.54,-2.21l-0.04,-0.24l-0.59,-0.86l-0.23,-1.9l0.0,-1.82l-0.07,-0.19l-0.95,-1.19l0.1,-0.41l1.58,0.04l-0.23,0.97l0.08,0.28l1.55,1.55l0.09,1.13l0.08,0.19l0.42,0.43l-0.11,5.66l0.52,1.53Z" data-code="TG" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M457.57,252.46l0.23,-1.08l-0.28,-0.36l-1.32,-0.05l0.0,-1.35l-0.1,-0.22l-0.9,-0.82l0.99,-3.1l3.12,-2.37l0.12,-0.23l0.13,-3.33l0.95,-5.2l0.53,-1.09l-0.07,-0.36l-0.94,-0.81l-0.03,-0.7l-0.12,-0.23l-0.84,-0.61l-0.57,-3.76l2.21,-1.26l19.67,9.88l0.12,9.74l-1.83,-0.15l-0.28,0.14l-1.14,1.89l-0.68,1.62l0.05,0.31l0.33,0.38l-0.61,0.58l-0.08,0.3l0.25,0.93l-0.58,0.95l-0.29,1.01l0.34,0.37l0.67,-0.11l0.39,0.73l0.03,1.4l0.11,0.23l0.8,0.65l-0.01,0.24l-1.38,0.37l-0.11,0.06l-1.27,1.03l-1.83,2.76l-2.21,1.1l-2.34,-0.15l-0.82,0.25l-0.2,0.37l0.19,0.68l-1.16,0.79l-1.01,0.94l-2.92,0.89l-0.5,-0.46l-0.17,-0.08l-0.41,-0.05l-0.28,0.12l-0.38,0.54l-1.36,0.12l0.1,-0.18l0.01,-0.27l-0.78,-1.72l-0.35,-1.03l-0.17,-0.18l-1.03,-0.41l-1.29,-1.28l0.36,-0.78l0.9,0.2l0.14,-0.0l0.67,-0.17l1.36,0.02l0.26,-0.45l-1.32,-2.22l0.09,-1.64l-0.17,-1.68l-0.04,-0.13l-0.93,-1.53Z" data-code="TD" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M457.99,226.38l-1.57,0.87l-1.25,-1.28l-0.13,-0.08l-3.85,-1.11l-1.04,-1.57l-0.09,-0.09l-1.98,-1.23l-0.27,-0.02l-0.93,0.39l-0.72,-1.2l-0.09,-1.07l-0.06,-0.16l-1.33,-1.75l0.83,-0.94l0.07,-0.24l-0.21,-1.64l0.31,-1.43l-0.17,-1.29l0.43,-2.26l-0.15,-1.33l-0.73,-2.18l0.99,-0.52l0.16,-0.21l0.22,-1.16l-0.22,-1.06l1.54,-0.95l0.81,-0.92l1.19,-0.78l0.14,-0.23l0.12,-1.76l2.57,0.84l0.16,0.01l0.99,-0.23l2.01,0.45l3.19,1.2l1.12,2.36l0.2,0.16l2.24,0.53l3.5,1.14l2.65,1.36l0.29,-0.01l1.22,-0.71l1.27,-1.32l0.07,-0.29l-0.55,-2.0l0.69,-1.19l1.7,-1.23l1.61,-0.35l3.2,0.54l0.78,1.14l0.24,0.13l0.85,0.01l0.84,0.47l2.35,0.31l0.42,0.63l-0.79,1.16l-0.04,0.26l0.35,1.08l-0.61,1.6l-0.0,0.2l0.73,2.16l0.0,24.24l-2.58,0.01l-0.3,0.29l-0.02,0.62l-19.55,-9.83l-0.28,0.01l-2.53,1.44Z" data-code="LY" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M550.59,223.8l0.12,0.08l1.92,-0.41l3.54,0.15l0.23,-0.09l1.71,-1.79l1.86,-1.7l1.31,-1.36l0.26,0.5l0.28,1.72l-0.93,0.01l-0.3,0.26l-0.21,1.73l0.11,0.27l0.08,0.06l-0.7,0.32l-0.17,0.27l-0.01,0.99l-0.68,1.02l-0.05,0.15l-0.06,0.96l-0.32,0.36l-7.19,-1.27l-0.79,-2.22Z" data-code="AE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M240.66,256.5l0.65,0.91l-0.03,1.13l-1.05,1.39l-0.03,0.31l0.95,2.0l0.32,0.17l1.08,-0.16l0.24,-0.21l0.56,-1.83l-0.06,-0.29l-0.71,-0.81l-0.1,-1.58l2.9,-0.96l0.19,-0.37l-0.29,-1.02l0.45,-0.41l0.72,1.43l0.26,0.16l1.65,0.04l1.46,1.27l0.08,0.72l0.3,0.27l2.28,0.02l2.55,-0.25l1.34,1.06l0.14,0.06l1.92,0.31l0.2,-0.03l1.4,-0.79l0.15,-0.25l0.02,-0.36l2.82,-0.14l1.17,-0.01l-0.41,0.14l-0.14,0.46l0.86,1.19l0.22,0.12l1.93,0.18l1.73,1.13l0.37,1.9l0.31,0.24l1.21,-0.05l0.52,0.32l-1.63,1.21l-0.11,0.17l-0.22,0.92l0.07,0.27l0.63,0.69l-0.31,0.24l-1.48,0.39l-0.22,0.3l0.04,1.03l-0.59,0.6l-0.01,0.41l1.67,1.87l0.23,0.48l-0.72,0.76l-2.71,0.91l-1.78,0.39l-0.13,0.06l-0.6,0.49l-1.84,-0.58l-1.89,-0.33l-0.18,0.03l-0.47,0.23l-0.02,0.53l0.96,0.56l-0.08,1.58l0.35,1.58l0.26,0.23l1.91,0.19l0.02,0.07l-1.54,0.62l-0.18,0.2l-0.25,0.92l-0.88,0.35l-1.85,0.58l-0.16,0.13l-0.4,0.64l-1.66,0.14l-1.22,-1.18l-0.79,-2.52l-0.67,-0.88l-0.66,-0.43l0.99,-0.98l0.09,-0.26l-0.09,-0.56l-0.08,-0.16l-0.66,-0.69l-0.47,-1.54l0.18,-1.67l0.55,-0.85l0.45,-1.35l-0.15,-0.36l-0.89,-0.43l-0.19,-0.02l-1.39,0.28l-1.76,-0.13l-0.92,0.23l-1.64,-2.01l-0.17,-0.1l-1.54,-0.33l-3.05,0.23l-0.5,-0.73l-0.15,-0.12l-0.45,-0.15l-0.05,-0.28l0.28,-0.86l0.01,-0.15l-0.2,-1.01l-0.08,-0.15l-0.5,-0.5l-0.3,-1.08l-0.25,-0.22l-0.89,-0.12l0.54,-1.18l0.29,-1.73l0.66,-0.85l0.94,-0.7l0.09,-0.11l0.3,-0.6Z" data-code="VE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M574.42,192.1l2.24,0.95l0.18,0.02l1.89,-0.38l0.22,-0.18l0.46,-1.14l1.82,-0.4l1.5,-0.91l0.14,-0.19l0.46,-2.12l1.93,-0.51l0.2,-0.18l0.26,-0.68l0.87,0.57l0.13,0.05l0.79,0.09l1.35,0.02l1.83,0.59l0.75,0.34l0.26,-0.01l1.66,-0.85l0.7,0.46l0.42,-0.09l0.72,-1.17l1.32,0.05l0.23,-0.1l0.39,-0.43l0.07,-0.14l0.24,-1.08l0.86,-0.81l0.94,0.46l-0.2,0.64l0.23,0.38l0.49,0.09l-0.21,2.15l0.09,0.25l0.99,0.94l0.38,0.03l0.83,-0.57l1.06,-0.27l0.12,-0.06l1.46,-1.21l1.63,0.2l2.4,0.0l0.17,0.32l-1.12,0.25l-1.23,0.52l-2.86,0.33l-2.69,0.6l-0.13,0.06l-1.46,1.25l-0.07,0.36l0.58,1.18l0.25,1.21l-1.13,1.08l-0.09,0.25l0.09,0.98l-0.53,0.79l-2.22,-0.08l-0.28,0.44l0.83,1.57l-1.3,0.58l-0.13,0.11l-1.06,1.69l-0.05,0.18l0.13,1.51l-0.73,0.58l-0.78,-0.22l-0.14,-0.01l-1.91,0.36l-0.23,0.19l-0.2,0.57l-1.65,-0.0l-0.22,0.1l-1.4,1.56l-0.08,0.19l-0.08,2.13l-2.99,1.05l-1.67,-0.23l-0.27,0.1l-0.39,0.46l-1.43,-0.31l-2.43,0.4l-3.69,-1.23l1.96,-2.15l0.08,-0.24l-0.21,-1.78l-0.23,-0.26l-1.69,-0.42l-0.19,-1.62l-0.77,-2.08l0.98,-1.41l-0.14,-0.45l-0.82,-0.31l0.6,-1.79l0.93,-3.21Z" data-code="AF" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M534.42,190.89l0.13,0.14l1.5,0.78l0.15,1.34l-1.13,0.87l-0.11,0.16l-0.58,2.2l0.04,0.24l1.73,2.67l0.12,0.1l2.99,1.49l1.18,1.94l-0.39,1.89l0.29,0.36l0.5,-0.0l0.02,1.17l0.08,0.2l0.83,0.86l-2.36,-0.29l-0.29,0.13l-1.74,2.49l-4.4,-0.21l-7.03,-5.49l-3.73,-1.94l-2.92,-0.74l-0.89,-3.0l5.33,-2.81l0.15,-0.19l0.95,-3.43l-0.2,-2.0l1.19,-0.61l0.11,-0.09l1.23,-1.73l0.92,-0.38l2.75,0.35l0.81,0.68l0.31,0.05l0.94,-0.38l1.5,3.17Z" data-code="IQ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M384.26,87.96l-0.51,2.35l0.08,0.28l2.61,2.58l-2.99,2.83l-7.16,2.72l-2.08,0.7l-9.51,-1.71l1.89,-1.36l-0.07,-0.53l-4.4,-1.59l3.33,-0.59l0.25,-0.32l-0.11,-1.2l-0.25,-0.27l-4.82,-0.88l1.38,-2.2l3.54,-0.57l3.8,2.74l0.33,0.01l3.68,-2.18l3.02,1.12l0.25,-0.02l4.01,-2.18l3.72,0.27Z" data-code="IS" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M556.2,187.5l2.05,-0.52l0.13,-0.07l1.69,-1.57l1.55,0.08l0.15,-0.03l1.02,-0.5l1.64,0.25l2.82,1.48l1.91,0.3l2.8,2.49l0.18,0.08l1.61,0.09l0.19,2.09l-1.0,3.47l-0.69,2.04l0.18,0.38l0.73,0.28l-0.85,1.22l-0.04,0.28l0.81,2.19l0.19,1.72l0.23,0.26l1.69,0.42l0.17,1.43l-2.18,2.39l-0.01,0.4l1.22,1.42l1.0,1.62l0.12,0.11l2.23,1.11l0.06,2.2l0.2,0.27l1.03,0.38l0.14,0.83l-3.38,1.3l-0.18,0.19l-0.87,2.85l-4.44,-0.76l-2.75,-0.62l-2.64,-0.32l-1.01,-3.11l-0.17,-0.19l-1.2,-0.48l-0.18,-0.01l-1.99,0.51l-2.42,1.25l-2.89,-0.84l-2.48,-2.03l-2.41,-0.79l-1.61,-2.47l-1.84,-3.63l-0.36,-0.15l-1.22,0.4l-1.48,-0.84l-0.37,0.06l-0.72,0.82l-1.08,-1.12l-0.02,-1.35l-0.3,-0.29l-0.43,0.0l0.34,-1.64l-0.04,-0.22l-1.29,-2.11l-0.12,-0.11l-3.0,-1.49l-1.62,-2.49l0.52,-1.98l1.18,-0.92l0.11,-0.27l-0.19,-1.66l-0.16,-0.23l-1.55,-0.81l-1.58,-3.33l-1.3,-2.2l0.41,-0.75l0.03,-0.21l-0.73,-3.12l1.2,-0.59l0.35,0.9l1.26,1.35l0.15,0.09l1.81,0.39l0.91,-0.09l0.15,-0.06l2.9,-2.13l0.7,-0.16l0.48,0.56l-0.75,1.26l0.05,0.37l1.56,1.53l0.28,0.08l0.37,-0.09l0.7,1.89l0.21,0.19l2.31,0.59l1.69,1.4l0.15,0.07l3.66,0.49l3.91,-0.76l0.23,-0.19l0.19,-0.52Z" data-code="IR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M530.51,176.08l2.91,-0.39l0.41,0.63l0.11,0.1l0.66,0.36l-0.32,0.47l0.07,0.41l1.1,0.84l-0.53,0.7l0.06,0.42l1.06,0.8l1.01,0.44l0.04,1.56l-0.44,0.04l-0.88,-1.46l0.01,-0.37l-0.3,-0.31l-0.98,0.01l-0.65,-0.69l-0.26,-0.09l-0.38,0.06l-0.97,-0.82l-1.64,-0.65l0.2,-1.2l-0.02,-0.16l-0.28,-0.69Z" data-code="AM" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M451.68,158.58l0.2,0.16l3.3,0.75l-0.22,1.26l0.02,0.18l0.35,0.78l-1.4,-0.32l-0.21,0.03l-2.04,1.1l-0.16,0.29l0.13,1.47l-0.29,0.82l0.02,0.24l0.82,1.57l0.1,0.11l2.28,1.5l1.29,2.53l2.79,2.43l0.2,0.07l1.83,-0.02l0.31,0.34l-0.46,0.39l0.06,0.5l4.06,1.97l2.06,1.49l0.17,0.36l-0.24,0.53l-1.08,-1.07l-0.15,-0.08l-2.18,-0.49l-0.33,0.15l-1.05,1.91l0.11,0.4l1.63,0.98l-0.22,1.12l-0.84,0.14l-0.22,0.15l-1.27,2.38l-0.54,0.12l0.01,-0.47l0.48,-1.46l0.5,-0.58l0.03,-0.35l-0.97,-1.69l-0.76,-1.48l-0.17,-0.15l-0.94,-0.33l-0.68,-1.18l-0.16,-0.13l-1.53,-0.52l-1.03,-1.14l-0.19,-0.1l-1.78,-0.19l-1.88,-1.3l-2.27,-1.94l-1.64,-1.68l-0.76,-2.94l-0.21,-0.21l-1.22,-0.35l-2.01,-1.0l-0.24,-0.01l-1.15,0.42l-0.11,0.07l-1.38,1.36l-0.5,0.11l0.19,-0.87l-0.21,-0.35l-1.19,-0.34l-0.56,-2.06l0.76,-0.82l0.03,-0.36l-0.68,-1.08l0.04,-0.31l0.68,0.42l0.19,0.04l1.21,-0.15l0.14,-0.06l1.18,-0.89l0.25,0.29l0.25,0.1l1.19,-0.1l0.25,-0.18l0.45,-1.04l1.61,0.34l0.19,-0.02l1.1,-0.53l0.17,-0.22l0.15,-0.95l1.19,0.35l0.35,-0.16l0.23,-0.47l2.11,-0.47l0.45,0.89ZM459.35,184.63l-0.71,1.81l0.0,0.23l0.33,0.79l-0.37,1.03l-1.6,-0.91l-1.33,-0.34l-3.24,-1.36l0.23,-0.99l2.73,0.24l3.95,-0.5ZM443.95,175.91l1.26,1.77l-0.31,3.47l-0.82,-0.13l-0.26,0.08l-0.83,0.79l-0.64,-0.52l-0.1,-3.42l-0.44,-1.34l0.91,0.1l0.21,-0.06l1.01,-0.74Z" data-code="IT" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M690.8,230.21l-2.86,1.93l-2.09,2.46l-0.06,0.11l-0.55,1.8l0.04,0.26l4.26,6.1l2.31,1.63l1.46,1.97l1.12,4.62l-0.32,4.3l-1.97,1.57l-2.85,1.62l-2.09,2.14l-2.83,2.13l-0.67,-1.19l0.65,-1.58l-0.09,-0.35l-1.47,-1.14l1.67,-0.79l2.57,-0.18l0.22,-0.47l-0.89,-1.24l3.88,-1.8l0.17,-0.24l0.31,-3.05l-0.01,-0.13l-0.56,-1.63l0.44,-2.48l-0.01,-0.15l-0.63,-1.81l-0.08,-0.12l-1.87,-1.77l-3.64,-5.3l-0.11,-0.1l-2.68,-1.39l0.45,-0.59l1.53,-0.65l0.16,-0.39l-0.97,-2.27l-0.27,-0.18l-2.89,-0.02l-1.04,-2.21l-1.28,-1.83l0.96,-0.46l1.97,0.01l2.43,-0.3l0.13,-0.05l1.95,-1.29l1.04,0.85l0.13,0.06l1.98,0.42l-0.32,1.21l0.09,0.3l1.19,1.07l0.12,0.07l1.88,0.51Z" data-code="VN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M258.11,341.34l1.4,1.81l0.51,-0.06l0.89,-1.94l2.51,0.1l0.36,0.49l4.6,4.31l0.15,0.08l1.99,0.39l3.01,1.93l2.5,1.01l0.28,0.91l-2.4,3.97l0.17,0.44l2.57,0.74l2.81,0.41l2.09,-0.44l0.14,-0.07l2.27,-2.06l0.09,-0.17l0.38,-2.2l0.88,-0.36l1.05,1.29l-0.04,1.88l-1.98,1.4l-1.72,1.13l-2.84,2.65l-3.34,3.73l-0.07,0.12l-0.63,2.22l-0.67,2.85l0.02,2.73l-0.47,0.54l-0.07,0.17l-0.36,3.28l0.12,0.27l3.03,2.32l-0.31,1.78l0.11,0.29l1.44,1.15l-0.11,1.17l-2.32,3.57l-3.59,1.51l-4.95,0.6l-2.72,-0.29l-0.32,0.38l0.5,1.67l-0.49,2.13l0.01,0.16l0.4,1.29l-1.27,0.88l-2.41,0.39l-2.33,-1.05l-0.31,0.04l-0.97,0.78l-0.11,0.27l0.35,2.98l0.16,0.23l1.69,0.91l0.31,-0.02l1.08,-0.75l0.46,0.96l-2.1,0.88l-2.01,1.89l-0.09,0.18l-0.36,3.05l-0.51,1.42l-2.16,0.01l-0.19,0.07l-1.96,1.59l-0.1,0.15l-0.72,2.34l0.08,0.31l2.46,2.31l0.13,0.07l2.09,0.56l-0.74,2.45l-2.86,1.75l-0.12,0.14l-1.59,3.71l-2.2,1.24l-0.1,0.09l-1.03,1.54l-0.04,0.23l0.81,3.45l0.06,0.13l1.13,1.32l-2.59,-0.57l-5.89,-0.44l-0.92,-1.73l0.05,-2.4l-0.34,-0.3l-1.49,0.19l-0.72,-0.98l-0.2,-3.21l1.79,-1.33l0.1,-0.13l0.79,-2.04l0.02,-0.16l-0.27,-1.52l1.31,-2.69l0.91,-4.15l-0.23,-1.72l0.91,-0.49l0.15,-0.33l-0.27,-1.16l-0.15,-0.2l-0.87,-0.46l0.65,-1.01l-0.04,-0.37l-1.06,-1.09l-0.54,-3.2l0.83,-0.51l0.14,-0.29l-0.42,-3.6l0.58,-2.98l0.64,-2.5l1.41,-1.0l0.12,-0.32l-0.75,-2.8l-0.01,-2.48l1.81,-1.78l0.09,-0.22l-0.06,-2.3l1.39,-2.69l0.03,-0.14l0.01,-2.58l-0.11,-0.24l-0.57,-0.45l-1.1,-4.59l1.49,-2.73l0.04,-0.17l-0.23,-2.59l0.86,-2.38l1.6,-2.48l1.74,-1.65l0.04,-0.39l-0.64,-0.89l0.42,-0.7l0.04,-0.16l-0.08,-4.26l2.55,-1.23l0.16,-0.18l0.86,-2.75l-0.01,-0.22l-0.22,-0.48l1.84,-2.1l3.0,0.59ZM256.77,438.98l-2.1,0.15l-1.18,-1.14l-0.19,-0.08l-1.53,-0.09l-2.38,-0.0l-0.0,-6.28l0.4,0.65l1.25,2.55l0.11,0.12l3.26,2.07l3.19,0.8l-0.82,1.26Z" data-code="AR" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M705.55,353.06l0.09,0.09l0.37,0.05l0.13,-0.35l-0.57,-1.69l0.48,0.3l0.71,0.99l0.34,0.11l0.2,-0.29l-0.04,-1.37l-0.04,-0.14l-1.22,-2.07l-0.28,-0.9l-0.51,-0.69l0.24,-1.33l0.52,-0.7l0.34,-1.32l0.01,-0.13l-0.25,-1.44l0.51,-0.94l0.1,1.03l0.23,0.26l0.32,-0.14l1.01,-1.72l1.94,-0.84l1.27,-1.14l1.84,-0.92l1.0,-0.18l0.6,0.28l0.26,-0.0l1.94,-0.96l1.48,-0.28l0.19,-0.13l0.32,-0.49l0.51,-0.18l1.42,0.05l2.63,-0.76l0.11,-0.06l1.36,-1.15l0.08,-0.1l0.61,-1.33l1.42,-1.27l0.1,-0.19l0.11,-1.03l0.06,-1.32l1.39,-1.74l0.85,1.79l0.4,0.14l1.07,-0.51l0.11,-0.45l-0.77,-1.05l0.53,-0.84l0.86,0.43l0.43,-0.22l0.29,-1.85l1.29,-1.19l0.6,-0.98l1.16,-0.4l0.2,-0.27l0.02,-0.34l0.74,0.2l0.38,-0.27l0.03,-0.44l1.98,-0.61l1.7,1.08l1.36,1.48l0.22,0.1l1.55,0.02l1.57,0.24l0.33,-0.4l-0.48,-1.27l1.09,-1.86l1.06,-0.63l0.1,-0.42l-0.28,-0.46l0.93,-1.24l1.36,-0.8l1.16,0.27l0.14,0.0l2.1,-0.48l0.23,-0.3l-0.05,-1.3l-0.18,-0.26l-1.08,-0.49l0.44,-0.12l1.52,0.58l1.39,1.06l2.11,0.65l0.19,-0.0l0.59,-0.21l1.44,0.72l0.27,0.0l1.37,-0.68l0.84,0.2l0.26,-0.06l0.37,-0.3l0.82,0.89l-0.56,1.14l-0.84,0.91l-0.75,0.07l-0.26,0.38l0.26,0.9l-0.67,1.15l-0.88,1.24l-0.05,0.25l0.18,0.72l0.12,0.17l1.99,1.42l1.96,0.84l1.25,0.86l1.8,1.51l0.19,0.07l0.63,-0.0l1.15,0.58l0.34,0.7l0.17,0.15l2.39,0.88l0.24,-0.02l1.65,-0.88l0.14,-0.16l0.49,-1.37l0.52,-1.19l0.31,-1.39l0.75,-2.02l0.01,-0.19l-0.33,-1.16l0.16,-0.67l0.0,-0.13l-0.28,-1.41l0.3,-1.78l0.42,-0.45l0.05,-0.33l-0.33,-0.73l0.56,-1.25l0.48,-1.39l0.07,-0.69l0.58,-0.59l0.48,0.84l0.17,1.53l0.17,0.24l0.47,0.23l0.09,0.9l0.05,0.14l0.87,1.23l0.17,1.33l-0.09,0.89l0.03,0.15l0.9,2.0l0.43,0.13l1.38,-0.83l0.71,0.92l1.06,0.88l-0.22,0.96l0.0,0.14l0.53,2.2l0.38,1.3l0.15,0.18l0.52,0.26l0.62,2.01l-0.23,1.27l0.02,0.18l0.81,1.76l0.14,0.14l2.69,1.35l3.21,2.21l-0.2,0.4l0.04,0.34l1.39,1.6l0.95,2.78l0.43,0.16l0.79,-0.46l0.85,0.96l0.39,0.05l0.22,-0.15l0.36,2.33l0.09,0.18l1.78,1.63l1.16,1.01l1.9,2.1l0.67,2.05l0.06,1.47l-0.17,1.64l0.03,0.17l1.16,2.22l-0.14,2.28l-0.43,1.24l-0.68,2.44l0.04,1.63l-0.48,1.92l-1.06,2.43l-1.79,1.32l-0.1,0.12l-0.91,2.15l-0.82,1.37l-0.76,2.47l-0.98,1.46l-0.63,2.14l-0.33,2.02l0.1,0.82l-1.21,0.85l-2.71,0.1l-0.13,0.03l-2.31,1.19l-1.21,1.17l-1.34,1.11l-1.89,-1.18l-1.33,-0.46l0.32,-1.24l-0.4,-0.35l-1.46,0.61l-2.06,1.98l-1.99,-0.73l-1.43,-0.46l-1.45,-0.22l-2.32,-0.81l-1.51,-1.67l-0.45,-2.11l-0.6,-1.5l-0.07,-0.11l-1.23,-1.16l-0.16,-0.08l-1.96,-0.28l0.59,-0.99l0.03,-0.24l-0.61,-2.1l-0.54,-0.08l-1.16,1.85l-1.23,0.29l0.73,-0.88l0.06,-0.12l0.37,-1.57l0.93,-1.33l0.05,-0.2l-0.2,-2.07l-0.53,-0.17l-2.01,2.35l-1.52,0.94l-0.12,0.14l-0.82,1.93l-1.5,-0.9l0.07,-1.32l-0.06,-0.2l-1.57,-2.04l-1.15,-0.92l0.3,-0.41l-0.1,-0.44l-3.21,-1.69l-0.13,-0.03l-1.69,-0.08l-2.35,-1.31l-0.16,-0.04l-4.55,0.27l-3.24,0.99l-2.8,0.91l-2.33,-0.18l-0.17,0.03l-2.63,1.41l-2.14,0.64l-0.2,0.19l-0.47,1.42l-0.8,0.99l-1.99,0.06l-1.55,0.24l-2.27,-0.5l-1.79,0.3l-1.71,0.13l-0.19,0.09l-1.38,1.39l-0.58,-0.1l-0.21,0.04l-1.26,0.8l-1.13,0.85l-1.72,-0.1l-1.6,-0.0l-2.58,-1.76l-1.21,-0.49l0.04,-1.19l1.04,-0.32l0.16,-0.12l0.42,-0.64l0.05,-0.19l-0.09,-0.97l0.3,-2.0l-0.28,-1.64l-1.34,-2.84l-0.39,-1.49l0.1,-1.51l-0.04,-0.17l-0.96,-1.72l-0.06,-0.73l-0.09,-0.19l-1.04,-1.01l-0.3,-2.02l-0.05,-0.12l-1.23,-1.83ZM784.95,393.35l2.39,1.01l0.2,0.01l3.26,-0.96l1.19,0.16l0.16,3.19l-0.78,0.95l-0.07,0.16l-0.19,1.83l-0.43,-0.41l-0.44,0.03l-1.61,1.96l-0.4,-0.12l-1.38,-0.09l-1.43,-2.42l-0.37,-2.03l-1.4,-2.53l0.04,-0.94l1.27,0.2Z" data-code="AU" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M509.04,199.22l0.71,0.0l0.27,-0.17l0.15,-0.33l0.19,-0.01l0.02,0.73l-0.27,0.34l0.02,0.08l-0.32,0.62l-0.65,-0.27l-0.41,0.19l-0.52,1.85l0.16,0.35l0.14,0.07l-0.17,0.1l-0.14,0.21l-0.11,0.73l0.39,0.33l0.81,-0.26l0.03,0.64l-0.97,3.43l-1.28,-3.67l0.62,-0.78l-0.03,-0.41l0.58,-1.16l0.5,-2.07l0.27,-0.54Z" data-code="IL" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M615.84,192.58l2.4,2.97l-0.24,2.17l0.05,0.2l0.94,1.35l-0.06,0.97l-1.46,-0.3l-0.35,0.36l0.7,3.06l0.12,0.18l2.46,1.75l3.11,1.72l-1.23,0.96l-0.1,0.13l-0.97,2.55l0.16,0.38l2.41,1.02l2.37,1.33l3.27,1.52l3.43,0.37l1.37,1.3l0.17,0.08l1.92,0.25l3.0,0.62l2.15,-0.04l0.28,-0.22l0.29,-1.06l0.0,-0.13l-0.32,-1.66l0.16,-0.94l1.0,-0.37l0.23,2.28l0.18,0.24l2.28,1.02l0.2,0.02l1.52,-0.41l2.06,0.18l2.08,-0.08l0.29,-0.27l0.18,-1.66l-0.1,-0.26l-0.53,-0.44l1.38,-0.23l0.15,-0.07l2.26,-2.0l2.75,-1.65l1.97,0.63l0.25,-0.03l1.54,-0.99l0.89,1.28l-0.72,0.97l0.2,0.48l2.49,0.37l0.11,0.61l-0.69,0.39l-0.15,0.3l0.15,1.22l-1.36,-0.37l-0.23,0.03l-3.24,1.86l-0.15,0.28l0.07,1.44l-1.33,2.16l-0.04,0.13l-0.12,1.24l-0.98,1.91l-1.72,-0.53l-0.39,0.28l-0.09,2.66l-0.52,0.83l-0.04,0.23l0.21,0.89l-0.71,0.36l-1.21,-3.85l-0.29,-0.21l-0.69,0.01l-0.29,0.23l-0.28,1.17l-0.84,-0.84l0.6,-1.17l0.97,-0.13l0.23,-0.16l1.15,-2.25l-0.18,-0.42l-1.54,-0.47l-2.3,0.04l-2.13,-0.33l-0.19,-1.63l-0.26,-0.26l-1.13,-0.13l-1.93,-1.13l-0.42,0.13l-0.88,1.82l0.08,0.37l1.47,1.15l-1.21,0.77l-0.1,0.1l-0.56,0.97l0.13,0.42l1.31,0.61l-0.36,1.35l0.01,0.2l0.85,1.95l0.37,2.05l-0.26,0.68l-1.55,-0.02l-3.09,0.54l-0.25,0.32l0.13,1.84l-1.21,1.4l-3.64,1.79l-2.79,3.04l-1.86,1.61l-2.48,1.68l-0.13,0.25l-0.0,1.0l-1.07,0.55l-2.21,0.9l-1.13,0.13l-0.25,0.19l-0.75,1.96l-0.02,0.15l0.52,3.31l0.13,2.03l-1.03,2.35l-0.03,0.12l-0.01,4.03l-1.02,0.1l-0.23,0.15l-1.14,1.93l0.04,0.36l0.44,0.48l-1.83,0.57l-0.18,0.15l-0.81,1.65l-0.74,0.53l-2.14,-2.12l-1.14,-3.47l-0.96,-2.57l-0.9,-1.26l-1.3,-2.38l-0.61,-3.14l-0.44,-1.62l-2.29,-3.56l-1.03,-4.94l-0.74,-3.29l0.01,-3.12l-0.49,-2.51l-0.41,-0.22l-3.56,1.53l-1.59,-0.28l-2.96,-2.87l0.94,-0.74l0.06,-0.41l-0.74,-1.03l-2.73,-2.1l1.35,-1.43l5.38,0.01l0.29,-0.36l-0.5,-2.29l-0.09,-0.15l-1.33,-1.28l-0.27,-1.96l-0.12,-0.2l-1.36,-1.0l2.42,-2.48l2.77,0.2l0.24,-0.1l2.62,-2.85l1.59,-2.8l2.41,-2.74l0.07,-0.2l-0.04,-1.82l2.01,-1.51l-0.01,-0.49l-1.95,-1.33l-0.83,-1.81l-0.82,-2.27l0.98,-0.97l3.64,0.66l2.89,-0.42l0.17,-0.08l2.18,-2.15Z" data-code="IN" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M505.77,287.58l0.36,0.23l8.95,5.03l0.15,1.3l0.13,0.21l3.4,2.37l-1.07,2.88l-0.02,0.14l0.15,1.42l0.15,0.23l1.47,0.84l0.05,0.42l-0.66,1.44l-0.02,0.18l0.13,0.72l-0.16,1.16l0.03,0.19l0.87,1.57l1.03,2.48l0.12,0.14l0.53,0.32l-1.59,1.18l-2.64,0.95l-1.45,-0.04l-0.2,0.07l-0.81,0.69l-1.64,0.06l-0.68,0.3l-2.9,-0.69l-1.71,0.17l-0.65,-3.18l-0.05,-0.12l-1.35,-1.88l-0.19,-0.12l-2.41,-0.46l-1.38,-0.74l-1.63,-0.44l-0.96,-0.41l-0.95,-0.58l-1.31,-3.09l-1.47,-1.46l-0.45,-1.31l0.24,-1.34l-0.39,-1.99l0.71,-0.08l0.18,-0.09l0.91,-0.91l0.98,-1.31l0.59,-0.5l0.11,-0.24l-0.02,-0.81l-0.08,-0.2l-0.47,-0.5l-0.1,-0.67l0.51,-0.23l0.18,-0.25l0.14,-1.47l-0.05,-0.2l-0.76,-1.09l0.45,-0.15l2.71,0.03l5.01,-0.19Z" data-code="TZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M539.36,175.66l0.16,0.09l1.11,0.2l0.32,-0.15l0.4,-0.71l1.22,-0.99l1.11,1.33l1.26,2.09l0.22,0.14l1.06,0.13l0.28,0.29l-1.46,0.17l-0.26,0.24l-0.43,2.26l-0.39,0.92l-0.85,0.63l-0.12,0.25l0.06,1.2l-0.22,0.05l-1.28,-1.25l0.74,-1.25l-0.03,-0.35l-0.74,-0.86l-0.3,-0.1l-1.05,0.27l-2.49,1.82l-0.04,-1.46l-0.18,-0.27l-1.09,-0.47l-0.8,-0.6l0.53,-0.7l-0.06,-0.42l-1.11,-0.84l0.34,-0.51l-0.11,-0.43l-0.89,-0.48l-0.33,-0.49l0.25,-0.2l1.78,0.81l1.35,0.18l0.25,-0.09l0.34,-0.35l0.02,-0.39l-1.04,-1.36l0.28,-0.18l0.49,0.07l1.65,1.74ZM533.53,180.16l0.63,0.67l0.22,0.09l0.8,-0.0l0.04,0.31l0.66,1.09l-0.94,-0.21l-1.16,-1.24l-0.25,-0.71Z" data-code="AZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M405.17,135.35l0.36,2.16l-1.78,2.84l-4.28,1.91l-3.02,-0.43l1.81,-3.13l0.02,-0.26l-1.23,-3.26l3.24,-2.56l1.54,-1.32l0.37,1.33l-0.49,1.77l0.3,0.38l1.49,-0.05l1.68,0.63Z" data-code="IE" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M756.56,287.86l0.69,4.02l0.15,0.21l2.59,1.5l0.39,-0.07l2.05,-2.61l2.75,-1.45l2.09,-0.0l2.08,0.85l1.85,0.89l2.52,0.46l0.08,15.44l-1.72,-1.6l-0.15,-0.07l-2.54,-0.51l-0.29,0.1l-0.53,0.62l-2.53,0.06l0.78,-1.51l1.48,-0.66l0.17,-0.34l-0.65,-2.74l-1.23,-2.19l-0.14,-0.13l-4.85,-2.13l-2.09,-0.23l-3.7,-2.28l-0.41,0.1l-0.67,1.11l-0.63,0.14l-0.41,-0.67l-0.01,-1.01l-0.14,-0.25l-1.39,-0.89l2.05,-0.69l1.73,0.05l0.29,-0.39l-0.21,-0.66l-0.29,-0.21l-3.5,-0.0l-0.9,-1.36l-0.19,-0.13l-2.14,-0.44l-0.65,-0.76l2.86,-0.51l1.28,-0.79l3.75,0.96l0.32,0.76ZM758.01,300.37l-0.79,1.04l-0.14,-1.07l0.4,-0.81l0.29,-0.47l0.24,0.31l-0.0,1.0ZM747.45,292.9l0.48,1.02l-1.45,-0.69l-2.09,-0.21l-1.45,0.16l-1.28,-0.07l0.35,-0.81l2.86,-0.1l2.58,0.68ZM741.15,285.69l-0.16,-0.25l-0.72,-3.08l0.47,-1.86l0.35,-0.38l0.1,0.73l0.25,0.26l1.28,0.19l0.18,0.78l-0.11,1.8l-0.96,-0.18l-0.35,0.22l-0.38,1.52l0.05,0.24ZM741.19,285.75l0.76,0.97l-0.11,0.05l-0.65,-1.02ZM739.18,293.52l-0.61,0.54l-1.44,-0.38l-0.25,-0.55l1.93,-0.09l0.36,0.48ZM728.4,295.87l-0.27,-0.07l-2.26,0.89l-0.37,-0.41l0.27,-0.8l-0.09,-0.33l-1.68,-1.37l0.17,-2.29l-0.42,-0.3l-1.67,0.76l-0.17,0.29l0.21,2.92l0.09,3.34l-1.22,0.28l-0.78,-0.54l0.65,-2.1l0.01,-0.14l-0.39,-2.42l-0.29,-0.25l-0.86,-0.02l-0.63,-1.4l0.99,-1.61l0.35,-1.97l1.24,-3.73l0.49,-0.96l1.95,-1.7l1.86,0.69l3.16,0.35l2.92,-0.1l0.17,-0.06l2.24,-1.65l0.11,0.14l-1.8,2.22l-1.72,0.44l-2.41,-0.48l-4.21,0.13l-2.19,0.36l-0.25,0.24l-0.36,1.9l0.08,0.27l2.24,2.23l0.4,0.02l1.29,-1.08l3.19,-0.58l-0.19,0.06l-1.04,1.4l-2.13,0.94l-0.12,0.45l2.26,3.06l-0.37,0.69l0.03,0.32l1.51,1.95ZM728.48,295.97l0.59,0.76l-0.02,1.37l-1.0,0.55l-0.64,-0.58l1.09,-1.84l-0.02,-0.26ZM728.64,286.95l0.79,-0.14l-0.07,0.39l-0.72,-0.24ZM732.38,310.1l-1.89,0.49l-0.06,-0.06l0.17,-0.64l1.0,-1.42l2.14,-0.87l0.1,0.2l0.04,0.58l-1.49,1.72ZM728.26,305.71l-0.17,0.63l-3.53,0.67l-3.02,-0.28l-0.0,-0.42l1.66,-0.44l1.47,0.71l0.16,0.03l1.75,-0.21l1.69,-0.69ZM722.98,310.33l-0.74,0.03l-2.52,-1.35l1.42,-0.3l1.19,0.7l0.72,0.63l-0.06,0.28ZM716.24,305.63l0.66,0.49l0.22,0.06l1.35,-0.18l0.31,0.53l-4.18,0.77l-0.8,-0.01l0.51,-0.86l1.2,-0.02l0.24,-0.12l0.49,-0.65ZM715.84,280.21l0.09,0.34l2.25,1.86l-2.25,0.22l-0.24,0.17l-0.84,1.71l-0.03,0.15l0.1,2.11l-2.27,1.62l-0.13,0.24l-0.06,2.46l-0.74,2.92l-0.02,-0.05l-0.39,-0.16l-2.62,1.04l-0.86,-1.33l-0.23,-0.14l-1.71,-0.14l-1.19,-0.76l-0.25,-0.03l-2.78,0.84l-0.79,-1.05l-0.26,-0.12l-1.61,0.13l-1.8,-0.25l-0.36,-3.13l-0.15,-0.23l-1.18,-0.65l-1.13,-2.02l-0.33,-2.1l0.27,-2.19l1.05,-1.17l0.28,1.12l0.1,0.16l1.71,1.41l0.28,0.05l1.55,-0.49l1.54,0.17l0.23,-0.07l1.4,-1.21l1.05,-0.19l2.3,0.68l0.16,0.0l2.04,-0.53l0.21,-0.19l1.26,-3.41l0.91,-0.82l0.09,-0.14l0.8,-2.64l2.63,0.0l1.71,0.33l-1.19,1.89l0.02,0.34l1.74,2.24l-0.37,1.0ZM692.67,302.0l0.26,0.19l4.8,0.25l0.28,-0.16l0.44,-0.83l4.29,1.12l0.85,1.52l0.23,0.15l3.71,0.45l2.37,1.15l-2.06,0.69l-2.77,-1.0l-2.25,0.07l-2.57,-0.18l-2.31,-0.45l-2.94,-0.97l-1.84,-0.25l-0.13,0.01l-0.97,0.29l-4.34,-0.98l-0.38,-0.94l-0.25,-0.19l-1.76,-0.14l1.31,-1.84l2.81,0.14l1.97,0.96l0.95,0.19l0.28,0.74ZM685.63,299.27l-2.36,0.04l-2.07,-2.05l-3.17,-2.02l-1.06,-1.5l-1.88,-2.02l-1.22,-1.85l-1.9,-3.49l-2.2,-2.11l-0.71,-2.08l-0.94,-1.99l-0.1,-0.12l-2.21,-1.54l-1.35,-2.17l-1.86,-1.39l-2.53,-2.68l-0.14,-0.81l1.22,0.08l3.76,0.47l2.16,2.4l1.94,1.7l1.37,1.04l2.35,2.67l0.22,0.1l2.44,0.04l1.99,1.62l1.42,2.06l0.09,0.09l1.67,1.0l-0.88,1.8l0.11,0.39l1.44,0.87l0.13,0.04l0.68,0.05l0.41,1.62l0.87,1.4l0.22,0.14l1.71,0.21l1.06,1.38l-0.61,3.04l-0.09,3.6Z" data-code="ID" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M500.54,141.42l0.9,0.13l0.27,-0.11l0.52,-0.62l0.68,0.13l2.43,-0.3l1.32,1.57l-0.45,0.48l-0.07,0.26l0.21,1.03l0.27,0.24l1.85,0.15l0.76,1.22l-0.05,0.55l0.2,0.31l3.18,1.15l0.18,0.01l1.75,-0.47l1.42,1.41l0.22,0.09l1.42,-0.03l3.44,0.99l0.02,0.65l-0.97,1.62l-0.03,0.24l0.52,1.67l-0.29,0.79l-2.24,0.22l-0.14,0.05l-1.29,0.89l-0.13,0.23l-0.07,1.16l-1.75,0.22l-0.12,0.04l-1.6,0.98l-2.27,0.16l-0.12,0.04l-2.16,1.17l-0.16,0.29l0.15,1.94l0.14,0.23l1.23,0.75l0.18,0.04l2.06,-0.15l-0.22,0.51l-2.67,0.54l-3.27,1.72l-1.0,-0.45l0.45,-1.19l-0.19,-0.39l-2.34,-0.78l0.15,-0.2l2.32,-1.0l0.09,-0.49l-0.73,-0.72l-0.15,-0.08l-3.69,-0.75l-0.14,-0.96l-0.35,-0.25l-2.32,0.39l-0.21,0.15l-0.91,1.7l-1.77,2.1l-0.93,-0.44l-0.24,-0.0l-1.05,0.45l-0.48,-0.25l0.13,-0.07l0.14,-0.15l0.43,-1.04l0.67,-0.97l0.04,-0.26l-0.1,-0.31l0.04,-0.02l0.11,0.19l0.24,0.15l1.48,0.09l0.78,-0.25l0.07,-0.53l-0.27,-0.19l0.09,-0.25l-0.08,-0.33l-0.81,-0.74l-0.34,-1.24l-0.14,-0.18l-0.73,-0.42l0.15,-0.87l-0.11,-0.29l-1.13,-0.86l-0.15,-0.06l-0.97,-0.11l-1.79,-0.97l-0.2,-0.03l-1.66,0.32l-0.13,0.06l-0.52,0.41l-0.95,-0.0l-0.23,0.11l-0.56,0.66l-1.74,0.29l-0.79,0.43l-1.01,-0.68l-0.16,-0.05l-1.57,-0.01l-1.52,-0.35l-0.23,0.04l-0.71,0.45l-0.09,-0.43l-0.13,-0.19l-1.18,-0.74l0.38,-1.02l0.53,-0.64l0.35,0.12l0.37,-0.41l-0.57,-1.29l2.1,-2.5l1.16,-0.36l0.2,-0.2l0.27,-0.92l-0.01,-0.2l-1.1,-2.52l0.79,-0.09l0.13,-0.05l1.3,-0.86l1.83,-0.07l2.48,0.26l2.84,0.8l1.91,0.06l0.88,0.45l0.29,-0.01l0.72,-0.44l0.49,0.58l0.25,0.11l2.2,-0.16l0.94,0.3l0.39,-0.26l0.15,-1.57l0.61,-0.59l2.01,-0.19Z" data-code="UA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M548.47,221.47l-0.15,-1.72l0.59,-1.23l0.38,-0.16l0.54,0.6l0.04,1.4l-0.47,1.37l-0.41,0.11l-0.53,-0.37Z" data-code="QA" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path><path d="M507.71,314.14l1.65,-0.18l2.96,0.7l0.2,-0.02l0.6,-0.29l1.68,-0.06l0.18,-0.07l0.8,-0.69l1.5,0.02l2.74,-0.98l1.74,-1.27l0.25,0.7l-0.1,2.47l0.31,2.27l0.1,3.97l0.42,1.24l-0.7,1.71l-0.94,1.73l-1.52,1.52l-5.06,2.21l-2.88,2.8l-1.01,0.51l-1.72,1.81l-0.99,0.58l-0.15,0.23l-0.21,1.86l0.04,0.19l1.17,1.95l0.47,1.47l0.03,0.74l0.39,0.28l0.05,-0.01l-0.06,2.13l-0.39,1.19l0.1,0.33l0.42,0.32l-0.28,0.83l-0.95,0.86l-2.03,0.88l-3.08,1.49l-1.1,0.99l-0.09,0.28l0.21,1.13l0.21,0.23l0.38,0.11l-0.14,0.89l-1.39,-0.02l-0.17,-0.94l-0.38,-1.23l-0.2,-0.89l0.44,-2.91l-0.01,-0.14l-0.65,-1.88l-1.15,-3.55l2.52,-2.85l0.68,-1.89l0.29,-0.18l0.14,-0.2l0.28,-1.53l-0.03,-0.19l-0.36,-0.7l0.1,-1.83l0.49,-1.84l-0.01,-3.26l-0.14,-0.25l-1.3,-0.83l-0.11,-0.04l-1.08,-0.17l-0.47,-0.55l-0.1,-0.08l-1.16,-0.54l-0.13,-0.03l-1.83,0.04l-0.32,-2.25l7.19,-1.99l1.32,1.12l0.29,0.06l0.55,-0.19l0.75,0.49l0.11,0.81l-0.49,1.11l-0.02,0.15l0.19,1.81l0.09,0.18l1.63,1.59l0.48,-0.1l0.72,-1.68l0.99,-0.49l0.17,-0.29l-0.21,-3.29l-0.04,-0.13l-1.11,-1.92l-0.9,-0.82l-0.21,-0.08l-0.62,0.03l-0.63,-2.98l0.61,-1.67Z" data-code="MZ" fill="rgba(210, 214, 222, 1)" fill-opacity="1" stroke="none" stroke-width="0" stroke-opacity="1" fill-rule="evenodd" class="jvectormap-region jvectormap-element"></path></g><g><circle data-index="0" cx="236.61387413103213" cy="137.93820711383978" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="1" cx="230.00925391282925" cy="135.03678122512682" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="2" cx="439.0507255810284" cy="196.9571497231832" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="3" cx="455.14293516030045" cy="207.45389804037305" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="4" cx="236.62697853622697" cy="134.71657987971312" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="5" cx="232.7742834089419" cy="129.4876082272392" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="6" cx="444.46284492650017" cy="186.9431405942959" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="7" cx="138.09495587617246" cy="173.38135751459242" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="8" cx="316.2493445001173" cy="192.08090906110368" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="9" cx="239.30027719597572" cy="147.15713834518894" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="10" cx="139.37918758526746" cy="180.40987382129654" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="11" cx="140.06061665539954" cy="178.93244623113597" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="12" cx="142.26215672813382" cy="178.93244623113597" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="13" cx="139.248143533319" cy="173.63770250731525" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="14" cx="292.96281646887417" cy="202.3210213954843" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="15" cx="396.5007219133601" cy="186.62702534201094" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="16" cx="222.27765484786948" cy="136.9924595234069" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="17" cx="140.38822678527072" cy="177.7982215088912" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="18" cx="427.5843710355373" cy="187.20648923343165" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="19" cx="356.32261558595934" cy="194.572048435707" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="20" cx="447.044412749885" cy="194.3623389804743" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="21" cx="462.4682976642199" cy="224.37598896518043" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="22" cx="139.8640505774768" cy="176.07170954866515" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="23" cx="295.6492195338178" cy="223.1047160089049" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="24" cx="286.5416579233991" cy="161.40220391425788" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle><circle data-index="25" cx="229.11815435957962" cy="195.84326776433264" fill="#00a65a" stroke="#111" fill-opacity="1" stroke-width="1" stroke-opacity="1" r="5" class="jvectormap-marker jvectormap-element"></circle></g></svg><div class="jvectormap-zoomin">+</div><div class="jvectormap-zoomout">\u2212</div></div></div></div></div><!-- /.col --><div class="col-md-3 col-sm-4"><div class="pad box-pane-right bg-green" style="min-height: 280px"><div class="description-block margin-bottom"><div class="sparkbar pad" data-color="#fff"><canvas width="34" height="30" style="display: inline-block; width: 34px; height: 30px; vertical-align: top;"></canvas></div><h5 class="description-header">8390</h5><span class="description-text">Visits</span></div><!-- /.description-block --><div class="description-block margin-bottom"><div class="sparkbar pad" data-color="#fff"><canvas width="34" height="30" style="display: inline-block; width: 34px; height: 30px; vertical-align: top;"></canvas></div><h5 class="description-header">30%</h5><span class="description-text">Referrals</span></div><!-- /.description-block --><div class="description-block"><div class="sparkbar pad" data-color="#fff"><canvas width="34" height="30" style="display: inline-block; width: 34px; height: 30px; vertical-align: top;"></canvas></div><h5 class="description-header">70%</h5><span class="description-text">Organic</span></div><!-- /.description-block --></div></div><!-- /.col --></div><!-- /.row --></div><!-- /.box-body --></div><!-- /.box --><div class="row"><div class="col-md-6"></div><!-- /.col --><div class="col-md-6"><!-- USERS LIST --><div class="box box-danger"><div class="box-header with-border"><h3 class="box-title">Latest Members</h3><div class="box-tools pull-right"><span class="label label-danger">8 New Members</span> <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body no-padding"><ul class="users-list clearfix"><li><img src="dist/img/user1-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Alexander Pierce</a> <span class="users-list-date">Today</span></li><li><img src="dist/img/user8-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Norman</a> <span class="users-list-date">Yesterday</span></li><li><img src="dist/img/user7-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Jane</a> <span class="users-list-date">12 Jan</span></li><li><img src="dist/img/user6-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">John</a> <span class="users-list-date">12 Jan</span></li><li><img src="dist/img/user2-160x160.jpg" alt="User Image"> <a class="users-list-name" href="#">Alexander</a> <span class="users-list-date">13 Jan</span></li><li><img src="dist/img/user5-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Sarah</a> <span class="users-list-date">14 Jan</span></li><li><img src="dist/img/user4-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Nora</a> <span class="users-list-date">15 Jan</span></li><li><img src="dist/img/user3-128x128.jpg" alt="User Image"> <a class="users-list-name" href="#">Nadia</a> <span class="users-list-date">15 Jan</span></li></ul><!-- /.users-list --></div><!-- /.box-body --><div class="box-footer text-center"><a href="javascript:void(0)" class="uppercase">View All Users</a></div><!-- /.box-footer --></div><!--/.box --></div><!-- /.col --></div><!-- /.row --><!-- TABLE: LATEST ORDERS --><div class="box box-info"><div class="box-header with-border"><h3 class="box-title">Latest Orders</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><div class="table-responsive"><table class="table no-margin"><thead><tr><th>Order ID</th><th>Item</th><th>Status</th><th>Popularity</th></tr></thead><tbody><tr><td><a href="pages/examples/invoice.html">OR9842</a></td><td>Call of Duty IV</td><td><span class="label label-success">Shipped</span></td><td><div class="sparkbar" data-color="#00a65a" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR1848</a></td><td>Samsung Smart TV</td><td><span class="label label-warning">Pending</span></td><td><div class="sparkbar" data-color="#f39c12" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR7429</a></td><td>iPhone 6 Plus</td><td><span class="label label-danger">Delivered</span></td><td><div class="sparkbar" data-color="#f56954" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR7429</a></td><td>Samsung Smart TV</td><td><span class="label label-info">Processing</span></td><td><div class="sparkbar" data-color="#00c0ef" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR1848</a></td><td>Samsung Smart TV</td><td><span class="label label-warning">Pending</span></td><td><div class="sparkbar" data-color="#f39c12" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR7429</a></td><td>iPhone 6 Plus</td><td><span class="label label-danger">Delivered</span></td><td><div class="sparkbar" data-color="#f56954" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr><tr><td><a href="pages/examples/invoice.html">OR9842</a></td><td>Call of Duty IV</td><td><span class="label label-success">Shipped</span></td><td><div class="sparkbar" data-color="#00a65a" data-height="20"><canvas width="34" height="20" style="display: inline-block; width: 34px; height: 20px; vertical-align: top;"></canvas></div></td></tr></tbody></table></div><!-- /.table-responsive --></div><!-- /.box-body --><div class="box-footer clearfix"><a href="javascript:void(0)" class="btn btn-sm btn-info btn-flat pull-left">Place New Order</a> <a href="javascript:void(0)" class="btn btn-sm btn-default btn-flat pull-right">View All Orders</a></div><!-- /.box-footer --></div><!-- /.box --></div><!-- /.col --><div class="col-md-4"><!-- Info Boxes Style 2 --><div class="info-box bg-yellow"><span class="info-box-icon"><i class="ion ion-ios-pricetag-outline"></i></span><div class="info-box-content"><span class="info-box-text">Inventory</span> <span class="info-box-number">5,200</span><div class="progress"><div class="progress-bar" style="width: 50%"></div></div><span class="progress-description">50% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="info-box bg-green"><span class="info-box-icon"><i class="ion ion-ios-heart-outline"></i></span><div class="info-box-content"><span class="info-box-text">Mentions</span> <span class="info-box-number">92,050</span><div class="progress"><div class="progress-bar" style="width: 20%"></div></div><span class="progress-description">20% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="info-box bg-red"><span class="info-box-icon"><i class="ion ion-ios-cloud-download-outline"></i></span><div class="info-box-content"><span class="info-box-text">Downloads</span> <span class="info-box-number">114,381</span><div class="progress"><div class="progress-bar" style="width: 70%"></div></div><span class="progress-description">70% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="info-box bg-aqua"><span class="info-box-icon"><i class="ion-ios-chatbubble-outline"></i></span><div class="info-box-content"><span class="info-box-text">Direct Messages</span> <span class="info-box-number">163,921</span><div class="progress"><div class="progress-bar" style="width: 40%"></div></div><span class="progress-description">40% Increase in 30 Days</span></div><!-- /.info-box-content --></div><!-- /.info-box --><div class="box box-default"><div class="box-header with-border"><h3 class="box-title">Browser Usage</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><div class="row"><div class="col-md-8"><div class="chart-responsive"><canvas id="pieChart" height="160" width="188" style="width: 188px; height: 160px;"></canvas></div><!-- ./chart-responsive --></div><!-- /.col --><div class="col-md-4"><ul class="chart-legend clearfix"><li><i class="fa fa-circle-o text-red"></i> Chrome</li><li><i class="fa fa-circle-o text-green"></i> IE</li><li><i class="fa fa-circle-o text-yellow"></i> FireFox</li><li><i class="fa fa-circle-o text-aqua"></i> Safari</li><li><i class="fa fa-circle-o text-light-blue"></i> Opera</li><li><i class="fa fa-circle-o text-gray"></i> Navigator</li></ul></div><!-- /.col --></div><!-- /.row --></div><!-- /.box-body --><div class="box-footer no-padding"><ul class="nav nav-pills nav-stacked"><li><a href="#">United States of America <span class="pull-right text-red"><i class="fa fa-angle-down"></i> 12%</span></a></li><li><a href="#">India <span class="pull-right text-green"><i class="fa fa-angle-up"></i> 4%</span></a></li><li><a href="#">China <span class="pull-right text-yellow"><i class="fa fa-angle-left"></i> 0%</span></a></li></ul></div><!-- /.footer --></div><!-- /.box --><!-- PRODUCT LIST --><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Recently Added Products</h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button> <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button></div></div><!-- /.box-header --><div class="box-body"><ul class="products-list product-list-in-box"><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">Samsung TV <span class="label label-warning pull-right">$1800</span></a> <span class="product-description">Samsung 32" 1080p 60Hz LED Smart HDTV.</span></div></li><!-- /.item --><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">Bicycle <span class="label label-info pull-right">$700</span></a> <span class="product-description">26" Mongoose Dolomite Men\'s 7-speed, Navy Blue.</span></div></li><!-- /.item --><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">Xbox One <span class="label label-danger pull-right">$350</span></a> <span class="product-description">Xbox One Console Bundle with Halo Master Chief Collection.</span></div></li><!-- /.item --><li class="item"><div class="product-img"><img src="dist/img/default-50x50.gif" alt="Product Image"></div><div class="product-info"><a href="javascript:void(0)" class="product-title">PlayStation 4 <span class="label label-success pull-right">$399</span></a> <span class="product-description">PlayStation 4 500GB Console (PS4)</span></div></li><!-- /.item --></ul></div><!-- /.box-body --><div class="box-footer text-center"><a href="javascript:void(0)" class="uppercase">View All Products</a></div><!-- /.box-footer --></div><!-- /.box --></div><!-- /.col --></div><!-- /.row --></section><!-- /.content --></div><!-- /.content-wrapper -->');
$templateCache.put('app/layouts/footer.tpl.html','<!-- Main Footer --><footer class="main-footer"><!-- To the right --><div class="pull-right hidden-xs">Version v{{VERSION}}</div><!-- Default to the left --> <strong>Copyright &copy; 2016 <a href="#">United Development Team, LLC</a>.</strong> All rights reserved.</footer>');
$templateCache.put('app/layouts/layout.tpl.html','<div ng-if="vm.loading"><loader-widget></loader-widget></div><div class="wrapper"><div ui-view="headBar" id="headBar"></div><div ui-view="sideBar"></div><div ui-view="content"></div><div ui-view="footer"></div><div ui-view="controlBar"></div></div><!-- ./wrapper -->');
$templateCache.put('app/login/consent2.html','<section class="content consent-layout"><div class="setup-signature"><h1 class="text-center">In you first login you must define your signature.</h1><hr><div class=""><ods-signature ng-model="vm.signature.signature" bg-color="#EEEEEE" color="#00008B" options="vm.signatureOpts" name="consent_signature"></ods-signature></div><hr><footer class="text-center"><button type="button" class="btn btn-success btn-block" ng-disabled="(vm.signature.signature == null) || (vm.signature.signature == \'\') || vm.isSaving" ng-click="vm.next()"><i class="fa fa-pencil-square" aria-hidden="true"></i> Next</button></footer></div></section>');
$templateCache.put('app/login/finish.html','<div class="box-header"><div class="text-center"><h3>In you first login you must define your signature, please follow this wizard.</h3></div></div><div class="box-body"><p>Finish!!!</p></div><div class="box-footer"><button type="button" class="btn btn-default" ui-sref="sign.signature">Back</button> <button type="button" class="btn btn-info pull-right" ui-sref="home">Go Home</button></div>');
$templateCache.put('app/login/login.html','<!--<div class="app-logo">--><!--    <img src="content/images/logo-horizontal.svg" alt="BlueBook Logo">--><!--</div>--><div class="full-background"></div><!--<spinner name="loadSpinBig">--><!--<ng-include src="\'app/components/tpl/spinner.html\'"></ng-include>--><!--</spinner>--><div class="dark-overlay" ng-class="{\'active\': open}"></div><div class="terms-cond-text" ng-class="{\'opened\': open}"><a href="" class="tc-close-btn" ng-click="open = !open"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></a><h2 class="heading">Terms & Conditions</h2><hr><div class="text-wrapper well mb-0 text-justify"><ng-include src="\'app/login/terms-cond.html\'"></ng-include></div><hr><div class="text-right"><button class="btn btn-danger term-btn" ng-click="open = !open"><i class="fa fa-times" aria-hidden="true"></i> Close</button></div></div><div class="landing-login"><div class="login-form-wrapper"><!-- Logo --><div class="heading"><div class="form-logo"><img src="content/images/logo-horizontal.svg" alt="BlueBook Logo"></div><h2 class="sign-text">Sign In</h2></div><form method="post" name="loginForm" ng-submit="vm.login($event)"><div class="form-group"><div class="alert alert-danger fade in" uib-alert ng-repeat="alert in vm.alerts" close="vm.closeAlert($index)">{{alert.msg}}</div></div><!-- Username: --><div class="form-group has-feedback" ng-class="vm.username || loginForm.username.$valid?(loginForm.username.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="login-label" for="username">Username:</label><div class="login-controls"><span class="login-icon"><i class="fa fa-user-circle-o" aria-hidden="true"></i> </span><!--\n                        Regular expression to restring username format\n                        pattern="^[a-zA-Z]+(?:[._]?[a-zA-Z0-9])*$"\n                    --> <input type="text" id="username" class="form-control" name="username" placeholder="Your username..." maxlength="40" required ng-model="vm.username" ng-change="vm.closeAlert(0)"></div></div><!-- Password: --><div class="form-group has-feedback" ng-class="vm.password || loginForm.password.$valid?(loginForm.password.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="login-label" for="password">Password:</label><div class="login-controls"><span class="login-icon"><i class="fa fa-asterisk" aria-hidden="true"></i> </span><input type="password" id="password" class="form-control" name="password" placeholder="Your password..." maxlength="40" required autocomplete="new-password" ng-model="vm.password" ng-change="vm.closeAlert(0)"></div></div><hr><div class="form-group text-center mb-0"><button type="submit" class="btn btn-success btn-block" ng-disabled="loginForm.$error.required || vm.isSaving">Sign In <i class="fa fa-sign-in" aria-hidden="true"></i></button></div><div class="form-group mt-15"><p class="term-cond"><i class="fa fa-info-circle" aria-hidden="true"></i> By logging in, you accept the <a href="" ng-click="open = !open">Terms and Conditions <i class="fa fa-external-link" aria-hidden="true"></i></a></p></div><div class="text-center"><p>Version v{{appData.version + "." + appData.build + "_" + appData.instance + "-" + appData.branch}}</p></div></form></div></div>');
$templateCache.put('app/login/security-check.html','<div class="full-background"></div><div class="landing-login check-warning"><h2 class="sign-text text-center">Security Check</h2><hr><h3 class="mb-30">We don\'t recognize this browser</h3><p>To access your EHR, you will need to enter a code, which we will send to your phone.</p><p>Your security code will be sent to the phone number bellow. Standard rates apply.</p><div class="check-number text-center mt-30">{{vm.phoneNumberMasked}}</div><hr><div class="text-center mb-15"><button type="submit" class="btn btn-success btn-block btn-lg" ng-click="vm.sendCode()"><i class="fa fa-send" aria-hidden="true"></i> Send Code</button></div></div>');
$templateCache.put('app/login/security-code.html','<div class="full-background"></div><div class="landing-login check-code"><h2 class="sign-text text-center">Security Code</h2><hr><h4 class="mb-30">We don\'t recognize this browser</h4><p>We send a security code to:</p><h4 class="mt-15 mb-15">Phone: {{vm.phoneNumberMasked}}</h4><p class="mb-30">Enter the 6 digit security code from the message. If you haven\'t reviced the message, <a ui-sref="security-check">request another code <i class="fa fa-external-link" aria-hidden="true"></i></a>.</p><form class="form" name="form"><div class="form-group form-group-lg"><input type="text" class="form-control" name="code" id="field_code" required ng-model="vm.code" ui-mask="999999"></div><div class="form-group"><label for="field_rememberMe"><checkbox ng-model="vm.rememberMe" name="rememberMe" id="field_rememberMe"></checkbox>Always trust this browser.</label></div><button type="submit" class="btn btn-success btn-block btn-lg" ng-click="vm.verify()" ng-disabled="vm.isSaving || form.code.$invalid">Sign In <i class="fa fa-sign-in" aria-hidden="true"></i></button></form></div>');
$templateCache.put('app/login/sign.html','<section class="content-header"><h1>Signature Wizard</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box box-success"><div class="row"><div class="col-lg-1"></div><div class="col-lg-10"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-1"></div></div><!-- use ng-submit to catch the form submission and use our Angular function --><form id="signup-form" ng-submit="processForm()"><!-- our nested state views will be injected here --><div id="form-views" ui-view></div></form></div></div></div></section>');
$templateCache.put('app/login/signature.html','<div class="box-header"><div class="text-center"><h3>In this step you must sign and then press "Finish".</h3></div></div><div class="box-body"><!--<button class="btn btn-danger" ng-click="vm.getData()">Get Data</button>--><!--<button class="btn btn-danger" ng-click="vm.disable()">Disable</button>--><!--<button class="btn btn-danger" ng-click="vm.enable()">Enable</button>--><!--<img src="{{vm.hash}}" alt="signature image" />--><div class="row"><!--<div class="col-xs-12">--><!--<j-signature ng-model="customSignature" bg-color="#EEEEEE" color="#00008B"></j-signature>--><!--</div>--><div class="col-xs-12"><ods-signature ng-model="vm.employee.signature.signature" bg-color="#EEEEEE" color="#00008B" options="{height: 160}" name="custom_signature"></ods-signature></div></div></div><div class="box-footer"><button type="button" class="btn btn-default" ui-sref="consent">Back</button> <button type="button" class="btn btn-info pull-right" ng-disabled="!vm.employee.signature" ng-click="vm.save()">Finish</button></div>');
$templateCache.put('app/login/terms-cond.html','<p>The following Standard Terms of Service (the \u201CTOS\u201D) are made part of and incorporated into your UDT Software, LLC Service Agreement with UDT Software, LLC, a Florida limited liability company (together with its subsidiaries and affiliates, <span class="text-underline">\u201CUDT Software, LLC,\u201D</span> <span class="text-underline">\u201Cwe\u201D</span> or <span class="text-underline">\u201Cus\u201C</span>) and govern your and all users\u2019 rights and responsibilities in connection with use and access the Service provided by UDT Software, LLC thereunder. THESE TOS ARE LEGALLY BINDING on UDT Software, LLC and you as a \u201Cuser\u201D of the Service in any capacity for any reason whatsoever. EACH TIME YOU LOG IN AND/OR CLICK \u201CI AGREE,\u201D OR BY OTHERWISE ACCESSING OR USING THE SERVICE FOR ANY REASON, YOU ARE ENTERING INTO THESE TOS AND YOU AGREE TO BE BOUND BY THEM, BOTH ON YOUR OWN BEHALF AND AS AN AGENT OF YOUR EMPLOYER, ORGANIZATION, OR OTHER ENTITY ON BEHALF OF WHICH YOU ARE ACCESSING THE SERVICE. SUCH EMPLOYER, ORGANIZATION, OR OTHER ENTITY IS LIKEWISE BOUND TO ALL THESE TERMS TO WHICH YOU ARE ASSENTING. Please read these TOS carefully, and do not access or use the Service if you are unwilling or unable to be bound by these TOS. You and we are collectively referred to as the <span class="underline">\u201CParties.\u201D</span></p><h3 class="heading">1. Definitions</h3><p>For the purposes of these TOS, certain terms used in these TOS (whether or not capitalized) shall have the meanings assigned to them in Section 1 below. Terms not defined below or in the body of these TOS (whether or not capitalized) have the definitions given to them in the Service Agreement or HIPAA, as applicable.</p><p><span class="text-underline">\u201CAdministrative Rights\u201D</span> means the rights to administer and direct the use of a Client\u2019s account, including the authority to provide, request, issue, administer and limit the access rights to other User accounts issued to such Client\u2019s Authorized Workforce, as well as the rights to integrate, connect, or otherwise share Your Information with, or receive Protected Health Information from, third parties through the Service.</p><p><span class="text-underline">\u201CAuthorized Workforce\u201D</span> means those natural persons who are members of your Workforce who you have identified (by their legal names, and the legal names of their employers) in your account as authorized to access the Service on your behalf.</p><p><span class="text-underline">\u201CBAA\u201D</span> means the UDT Software, LLC Business Associate Agreement,</p><p><span class="underline">\u201CBeta Features\u201D</span> means any component of the Service not generally available to all Clients and clearly designated as beta, pilot, limited release, developer preview, non-production or by a notification or to you, whether contained in the Service or not, or description of similar import.</p><p><span class="underline">\u201CClient\u201D</span> means the legal organization that executed the Service Agreement.</p><p><span class="text-underline">\u201CClinical Data Exchange\u201D</span> means the exchange, with your Consent, of Protected Health Information (and Your Personal Information as necessary) between You and covered entities (and their business associates) for any permitted purpose, including, to the extent applicable, care coordination, performance or quality measurement programs, and risk adjustment, and other treatment, payment or health care operations purposes.</p><p><span class="text-underline">\u201CConfidential Information\u201D</span> means any information relating to our business, financial affairs, current or future products or technology, trade secrets, workforce, customers, or any other information that is treated or designated by us as confidential or proprietary, or would reasonably be viewed as confidential or as having value to our competitors. \u201CConfidential Information\u201D does not include information that we make publicly available or that becomes known to the general public other than as a result of a breach of an obligation by you. \u201CConfidential Information\u201D does not include individuals\u2019 health information.</p><p><span class="text-underline">\u201CConsent\u201D</span> means consent or authorization by a user of the Service allowing us to take actions described under these TOS, which the user of the Service may give in an electronic communication to us or by use of the features of the Service (such as \u201Cshare,\u201D \u201Ctransmit,\u201D \u201Crefer,\u201D \u201Cauthorize,\u201D \u201Copt-in,\u201D \u201Cagree\u201D or toggling or selecting an action through a settings or activation page located within the Service, and the like). Such Consent may apply to an individual case or situation, or may apply globally or programmatically based on variables that apply to an overall situation or circumstance (whether through a settings or preference page, a global \u201Copt-in\u201D or otherwise).</p><p><span class="text-underline">\u201CCredentials\u201D</span> means any unique identifier, password, token, credential, any combination thereof, or other means we may utilize from time to time for authorizing access to all, or any portion of, the Service.</p><p><span class="text-underline">\u201CDe-Identified Health Information\u201D</span> means health information that has been de-identified in accordance with the provisions of the Privacy Rule.</p><p><span class="text-underline">\u201CDe-Identified Information\u201D</span> means De-Identified Health Information and De-Identified Personal Information.</p><p><span class="text-underline">\u201CDe-Identified Personal Information\u201D</span> means Personal Information from which all identifiers that could reasonably be anticipated to identify an individual by an anticipated recipient \u2013 such an individual\u2019s name, contact information, or government identifiers \u2013 have been removed.</p><p><span class="text-underline">\u201CDe-Identify\u201D</span>, means (i) with respect to Personal Information, to make such information into De-Identified Personal Information, and (ii) with respect to health information, means to make such health information into De-Identified Health Information.</p><p><span class="text-underline">\u201CHIPAA\u201D</span> means the administrative simplification provisions of the Health Insurance Portability and Accountability Act of 1996, and the regulations promulgated thereunder, including the Privacy Rule and the Security Rule, as amended.</p><p><span class="text-underline">\u201CHITECH Act\u201D</span> means the Health Information Technology for Economic and Clinical Health Act of 2009, and regulations promulgated thereunder.</p><p><span class="text-underline">\u201CPersonal Information\u201D</span> means information that includes an individual\u2019s name, contact information, government identifiers, or includes identifiers that could reasonably be anticipated to identify an individual personally by an anticipated recipient.</p><p><span class="text-underline">\u201CPolicies and Procedures\u201D</span> means our rules, regulations, policies and procedures for access to and use of the Service, as changed from time to time.</p><p><span class="text-underline">\u201CPrivacy Rule\u201D</span> means the Standards for Privacy of Individually Identifiable Health Information at 45 CFR Part 160 and Part 164, Subparts A and E, as amended.</p><p><span class="text-underline">\u201CProtected Health Information\u201D</span> has the meaning given it in the Privacy Rule.</p><p><span class="text-underline">\u201CSecurity Rule\u201D</span> means the Security Standards for the Protection of electronic Protected Health Information at 45 CFR Part 160 and Part 164, Subparts A and C, as amended.</p><p><span class="text-underline">\u201CService\u201D</span> means our electronic health record services, including our electronic medical record services, practice management services, other operations workflow solutions and other services provided by us to you.</p><p><span class="text-underline">\u201CService Agreement\u201D</span> means these TOS together with (and as part of) your UDT Software, LLC Records Service Agreement with all exhibits and any signed or initialed addendum including the following:</p><ul><li>Negotiate Terms</li><li>Price List for the Services</li><li>SLA</li><li>BAA</li><li>TPTOS</li></ul><p><span class="text-underline">\u201CSLA\u201D</span> means the UDT Software, LLC Service Level Agreement</p><p><span class="text-underline">\u201CTerm\u201D</span> means the length of time the Service Agreement is in effect until otherwise terminated as provided in any exhibit or addendum to the Service Agreement.</p><p><span class="text-underline">\u201CTPTOS\u201D</span> the UDT Software, LLC Third Party Terms of Service available online at <a href="https://bluebookehr.com">https://bluebookehr.com</a>.</p><p><span class="text-underline">\u201CUser\u201D</span> (capitalized) means a natural person who has been authorized, pursuant to these TOS, to access the Service on your behalf; a \u201Cuser\u201D (un-capitalized) shall mean any user of the Service. As a \u201Cuser\u201D you are bound by these TOS, along with any employer, organization, or other entity for which you are acting as an agent.</p><p><span class="text-underline">\u201CWorkforce\u201D</span> means a Client\u2019s employees, agents, principals, volunteers, trainees, contractors, and other persons whose conduct, in the performance of work for Client, is under the direct control of such Client, whether or not they are paid by the Client. This includes third-party companies with which you may contract for services, including but not limited to third-party billers, information technology professionals, and any other service provider that performs services on your behalf.</p><p><span class="text-underline">\u201CYour Health Information\u201D</span> means Protected Health Information that you or your Workforce input or upload onto the Service, or that we otherwise receive from you or on your behalf from your patients, authorized service providers, or our third-party partners pursuant to these TOS (including Section 4.1.10).</p><p><span class="text-underline">\u201CYour Information\u201D</span> means information that you or your Workforce input or upload onto the Service, including Your Personal Information and Your Health Information.</p><p><span class="text-underline">\u201CYour Personal Information\u201D</span> means Personal Information that you or your Workforce enter or upload onto the Service.</p><p>In addition, the words \u201Cinclude,\u201D \u201Cincludes\u201D and \u201Cincluding\u201D shall be deemed to be followed by the phrase \u201Cwithout limitation.\u201D The word \u201Cwill\u201D shall be construed to have the same meaning and effect as the word \u201Cshall.\u201D The word \u201Cor\u201D shall be construed to have the same meaning and effect as \u201Cand/or.\u201D The words \u201Cherein,\u201D \u201Chereof\u201D and \u201Chereunder,\u201D and words of similar import, shall be construed to refer to these TOS. The headings used in these TOS are used for convenience only and are not to be considered in construing or interpreting these TOS.</p><h3 class="heading">2. Definitions</h3><p><strong>2.1</strong> We grant to you and you accept a non-exclusive, personal, non-transferable (except as expressly permitted in Section 20.2), limited right to access and use the Service during the Term, subject to your full compliance with the terms and conditions set forth in these TOS and with our Policies and Procedures. You will not: (a) use the Service for time-sharing, rental or service bureau purposes; (b) make the Service, in whole or in part, available to any other person, entity or business; (c) copy, reverse engineer, decompile or disassemble the Service, in whole or in part, or otherwise attempt to discover the source code to the software used by the Service; or (d) modify, combine, integrate, render interoperable, or otherwise access for purposes of automating data conversion or transfer, the Service or associated software with any other software or services not provided or approved by us. You will obtain no rights to the Service except for the limited rights to use the Service expressly granted by the Service Agreement and these TOS. You are bound by these TOS, along with any employer, organization, or other entity for which you are acting as an agent or accessing Service.</p><p><strong>2.2</strong> The Service may include access to certain third-party software, services, data or applications that require that you enter into separate agreements with third parties. Your access to such third-party software services shall be subject to the TPTOS at all times. We may also make available optional services, either directly or through integrations with the Service, provided by third parties, such as billing, electronic prescribing, clinical laboratory interfaces, reporting services and verification of benefit services, among others as further contemplated in Section 11 below. You consent to the TPTOS and will comply with and, upon request, execute, any agreements or acknowledgments that may be required for the use of such software or services, and hereby agree to comply with the terms of any terms of use, license or other agreement relating to third-party products included in the Service or made accessible to you through the Service. Additionally, your use of the Service or of such third-party products or services will constitute your agreement to be bound by the terms of all licensing, subscription and similar agreements relating to such use.</p><h3 class="heading"><strong>3.</strong> Access to the Service</h3><h4><strong>3.1</strong> <span class="text-underline">Access Rights of Clients and their Authorized Workforce.</span></h4><p><strong>3.1.1</strong> <span class="text-underline">Client</span>. We offer the Service to the Client and to natural persons who are members of the Client\u2019s Authorized Workforce, as more fully described in this Section 3.1. We treat the Client in whose name the Service Agreement was executed and Instance established as the owner of all User accounts associated with such Client. The Client is a party to these TOS for all purposes and shall be subject to all of the provisions that are applicable to the person addressed as \u201Cyou\u201D in these TOS. Although a member of a Client\u2019s Authorized Workforce may have logged into your Instance and accessed the Service and electronically consented to these TOS, or may continue to administer Administrative Rights on the Client\u2019s behalf, only the Client is entitled to any of the rights, remedies or benefits under these TOS and control over the Administrative Rights. The Client is likewise subject to, and we may enforce against it, all of the covenants, obligations, restrictions, limitations, acknowledgements, Consents, representations, warranties, waivers and releases included in these TOS. The Client may delegate Administrative Rights to one or more members of the Client\u2019s Authorized Workforce, but the Client remains responsible for all activity occurring thereunder.</p><p><strong>3.1.2</strong> <span class="text-underline">Authorized Representatives</span>. An authorized representative of a Client may have administrative privileges on a Client\u2019s Instance. We call the person(s) authorized to act on behalf of a Client the <span class="text-underline">\u201CAuthorized Representative(s)\u201D</span> of such Client. The Client and Authorized Representative may be the same person. If you are taking any action with respect to a Client\u2019s Instance, you represent and warrant that (a) you have the authority to act on such Client\u2019s behalf either as owner/principal or as a member of such Client\u2019s Authorized Workforce, (b) the information you submit to us is complete and accurate, and (c) you have the authority to enter into these TOS on behalf of such Client and bind such Client to the covenants, obligations, restrictions, limitations, acknowledgements, Consents, representations, warranties, grants, waivers and releases contained in these TOS. If you are an Authorized Representative, you recognize that you have no personal rights with respect to such Client\u2019s Instance, and that such Client may change the Authorized Representative at any time, for any or no reason, with or without notice. You are bound by these TOS, along with any employer, organization, or other entity for which you are acting as an agent.</p><p><strong>3.1.3</strong> <span class="text-underline">Authorized Workforce</span>. If you are a member of a Client\u2019s Authorized Workforce, and such Client has authorized you to access the Service on its behalf by authorizing a Credential for you, then you are authorized under these TOS to access the Service solely on behalf and at the direction of such Client. As such, you may log in in and use the functionality of the Service solely on behalf and at the direction of such Client. You consent to and authorize the disclosure to such Client any content related to, or otherwise generated by your use of the Service, including secure messages. You hereby agree and acknowledge that you are subject to, and we may enforce against you, all of the covenants, obligations, restrictions, limitations, acknowledgements, Consents, representations and warranties set forth in these TOS that are applicable to the person addressed as \u201Cyou\u201D in these TOS, and you hereby grant and make all rights, waivers and releases set forth in these TOS that are granted and made by the person addressed as \u201Cyou\u201D in these TOS, but you are entitled to none of, and hereby waive and agree not to exercise or assert any of, the rights, remedies or benefits under these TOS other than the limited, non-exclusive, non-transferable, personal right under this Section 3.1.3 to sign in and use the functionality of the Service solely on behalf and at the direction of such Client. Notwithstanding the applicable provisions at Section 16, you acknowledge that your access to the Service may be terminated by the Client or us at any time, for any reason or no reason at all, with or without notice. By (i) accessing any of the Service under a Client\u2019s account(s), or (ii) contacting us by any means and requesting or directing us to take any action with respect to any Client\u2019s account(s) or data held by such account(s), or (iii) asserting any right or authority with respect to such account(s) or data, you represent and warrant that you have the authority to act on such Client\u2019s behalf and that you are not using the Service, or otherwise engaging in the activities described in clauses (i) through (iii) above, for the benefit or at the direction of any person or entity other than such Client, including yourself.</p><p><strong>3.1.4</strong> All other \u201Cusers\u201D. If you are a \u201Cuser\u201D as defined herein, you hereby agree and acknowledge that you are subject to, and we may enforce against you, all of the covenants, obligations, restrictions, limitations, acknowledgements, Consents, representations and warranties set forth in these TOS that are applicable to the person addressed as \u201Cyou\u201D in these TOS, and you hereby grant and make all rights, waivers and releases set forth in these TOS that are granted and made by the person addressed as \u201Cyou\u201D in these TOS, but you are entitled to none of, and hereby waive and agree not to exercise or assert any of, the rights, remedies or benefits under these TOS. Nothing in this section authorizes or shall be deemed to authorize your use of the Service and if your use is not expressly permitted under these TOS, you may be held directly liable and required to pay damages to UDT Software, LLC for improperly accessing the Service.</p><h4><strong>3.2</strong> <span class="text-underline">Beta Features, Updates</span>.</h4><p><strong>3.2.1</strong> <span class="text-underline">Beta Features</span>. If you are invited to access any Beta Features of the Service or you access any Beta Features of the Service, you acknowledge that: (a) such features have not been made commercially available by UDT Software, LLC; (b) such features may not operate properly, be in final form or fully functional; (c) such features may contain errors, design flaws or other problems; (d) it may not be possible to make such features fully functional; (e) use of such features may result in unexpected results, corruption or loss of data, or other unpredictable damage or loss; (f) such features may change and may not become generally available; and (g) UDT Software, LLC is not obligated in any way to continue to provide or maintain such features for any purpose in providing the ongoing Service. These Beta Features are provided \u201CAS IS\u201D, with all faults. You assume all risk arising from use of such features, including, without limitation, the risk of damage to your computer system or the corruption or loss of data. We may in our sole discretion discontinue Beta Services at any time, and may never make them generally available.</p><p><strong>3.2.2</strong> <span class="text-underline">Updates</span>. We will be updating the service from time to time to add new features and fix bugs. These updates usually take a few seconds, but sometimes require a longer suspension of the Service. In such cases, we will notify you at least 48 hours in advance, and we will strive to schedule it so that your business is minimally impacted. We also provide software to support special features for tablets and other devices. If you use this software, it will automatically check if your version is current. If it is not, you may be required to install a newer version before access to the Service is allowed.</p><h4><strong>3.3</strong> <span class="text-underline">Verification</span>.</h4><p><strong>3.3.1</strong> You agree that your use of the Service, or certain features or functionality of the Service, may be subject to verification by us of your identity and credentials as a health care provider or health care professional under applicable law, and to your ongoing qualification as such. You agree that we may use and disclose Your Personal Information for such purposes, including making inquiry of third parties concerning your identity and professional and practice credentials. You authorize such third parties to disclose to us such information as we may request for such purposes, and you agree to hold them and us harmless from any claim or liability arising from the request for or disclosure of such information. Notwithstanding the applicable provisions at Section 16, you agree that we may terminate your access to or use of the Service at any time if we are unable at any time to determine or verify your identity, qualifications or credentials.</p><h4><strong>3.4</strong> <span class="text-underline">Permitted Uses</span>.</h4><p><strong>3.4.1</strong> Subject to the terms of these TOS, you may use Your Health Information for any purpose expressly permitted by applicable law, including treatment, payment and health care operations.</p><p><strong>3.4.2</strong> If you are granted access rights to another user of the Service\u2019s Protected Health Information through the Service, you may use such information for treatment and for obtaining payment for treatment; <span class="text-underline">provided that</span>, except as expressly authorized in our Policies and Procedures, (i) you may access only information pertaining to individuals with whom you have a treatment relationship or for whom a Client who has a treatment relationship with the individual has requested a professional consultation from you, or from whom you have received authorization to use their health information; and (ii) to the extent applicable to you, you may use only the minimum necessary information for performing billing any services.</p><p><strong>3.4.3</strong> You will not use the Service for any purposes other than those described in Section <strong>3.4.1</strong> or Section <strong>3.4.2</strong>. In particular, you will not:</p><ol type="a"><li>reproduce, publish, or distribute content in connection with the Service that infringes any third party\u2019s trademark, copyright, patent, trade secret, publicity, privacy, or other personal or proprietary right; nor</li><li>use the Service to transmit illegal, obscene, threatening, libelous, harassing, or offensive messages, or otherwise unlawful material.</li><li>duplicate, copy, sell, resell or exploit any portion of the Service, use of the Service, or allow any person that is not part of the Authorized Workforce to access the Service without the express written permission of UDT Software, LLC\u2019s Chief Executive Officer (\u201CCEO\u201D).</li><li>Except as expressly permitted in writing by UDT Software, LLC \u2018s CEO, you may not modify, port, adapt, make screen captures from or translate the Service.</li></ol><p>In addition, to further safeguard the confidentiality, integrity and availability of the information and other elements housed in the Service, as well as the stability of the Service, you agree you will not, nor attempt to, or authorize anyone to, or attempt to:</p><ol type="a" start="5"><li><strong>(i)</strong> abuse or misuse the Service, including gaining or attempting to gain unauthorized access to the Service, or altering or destroying information housed in the Service; (ii) use the Service in a manner that interferes with other users\u2019 use of the Service; (iii) use the Service in any manner that violates our Policies and Procedures; or (iv) use any ad blocking mechanism, device, or tool to prevent the placement of advertisements in the Service;</li><li>Circumvent any technical measures we have put in place to safeguard the Service or the confidentiality, integrity or accessibility of any information housed thereon, or any technical measures we have put in place to restrict access to the Service solely to the class of persons expressly so authorized pursuant to Sections <strong>3.1.1</strong> through <strong>3.1.3</strong>; and</li><li>Access any portion of the Service other than with a commercial browser (such as Internet Explorer, Mozilla Firefox, Chrome, Android or iOS) or through mobile applications developed and operated by us.</li><li>Use any macro, robot, spider, offline reader, site search/retrieval application, or other manual or automatic device, tool, or process to access, retrieve, index, data mine, or in any way reproduce or circumvent the navigational structure or presentation of the Service.</li></ol><h4><strong>3.5</strong> <span class="text-underline">Clinical Support Information; Information Exchange</span>.</h4><p>We may provide information to assist you in clinical decision-making. This may include information and reminders concerning drug interactions, allergies, dosages, as well as general health-care related information and resources. We may also provide forums for our users to exchange information. You agree that the information and materials available through the Service are for informational and educational purposes only and are not intended to constitute professional advice, diagnosis or treatment, or to substitute for your professional judgment. Information may be placed in the Service by us and by third parties beyond our control. We are not responsible for the accuracy or completeness of information available from or through the Service. You assume full risk and responsibility for the use of information you obtain from or through the Service, and neither we nor any of our licensors or data providers are responsible or liable for any claim, loss, or liability arising from use of the information. We do not recommend or endorse any provider of health care or health-related products, items or services, and the appearance of materials in the Service relating to any such products, items or services is not an endorsement or recommendation of them. You will review the definitions, functionality, and limitations of the Service, and to make an independent determination of their suitability for your use. We and our suppliers, partners and licensors disclaim all warranties, whether expressed or implied, including any warranty as to the quality, accuracy, and suitability of the information provided by the Service for any purpose.</p><h4><strong>3.6</strong> <span class="text-underline">Safeguards</span>.</h4><p><strong>3.6.1</strong> You will implement and maintain appropriate administrative, physical and technical safeguards to protect information within the Service. Such safeguards shall comply with federal, state, and local requirements, including the Privacy Rule and the Security Rule, whether or not you are otherwise subject to HIPAA. You will maintain appropriate security with regard to all personnel, systems, and administrative processes used by you or members of your Workforce to transmit, store and process electronic health information through the use of the Service.</p><p><strong>3.6.2</strong> You will immediately notify us of any breach or suspected breach of the security of the Service of which you become aware, or any unauthorized use or disclosure of information within or obtained from the Service, and you will take such actions to mitigate the breach, suspected breach, or unauthorized use or disclosure of information within or obtained from the Service as we may direct, and will cooperate with us in investigating and mitigating the same. You have consented to the terms and conditions of the BAA for the purposes of compliance with HIPAA.</p><h4><strong>3.7</strong> <span class="text-underline">User Identification</span>.</h4><p>We authorize you and your Authorized Workforce to use the Credentials uniquely assigned to, or selected by, each such individual User. You acquire no ownership rights in any such Credentials, and such Credentials may be revoked, reset or changed at any time in the discretion of us or the Client. You will adopt and maintain reasonable and appropriate security precautions for your Credentials to prevent their disclosure to or use by unauthorized persons. Each member of your Authorized Workforce shall have and use a unique identifier. You will ensure that no member of your Workforce uses Credentials assigned to another Workforce member.</p><h4><strong>3.8</strong> <span class="text-underline">No Third-Party Access</span>.</h4><p>Except as required by law, you will not permit any third party (other than persons who satisfy the definition of Authorized Workforce, and in all cases meet the requirements of Section 3.1.3) to use or access the Service without the prior written consent of UDT Software, LLC\u2019s CTO. Nor will you authorize or assist any person or entity in accessing, or attempting to access, any portion of the Service via any means other than a commercial browser (such as Internet Explorer, Mozilla Firefox, Chrome, iOS or Android) or a mobile app that we have authored and provided to you. You will promptly notify us of any order or demand for compulsory disclosure of health information if the disclosure requires access to or use of the Service. You will cooperate fully with us in connection with any such demand. You will also notify us if any person or entity, whether or not a member of your Authorized Workforce, (a) attempts to access the Service by any means other than a commercial browser, (b) claims to offer a service or system that \u201Cintegrates with\u201D our Service or (c) requests to use your Credentials or requests that you obtain Credentials in order to access the Service in a manner that would violate these TOS if you engaged in such activity.</p><h4><strong>3.9</strong> <span class="text-underline">Your workforce</span>.</h4><p>You may permit your Authorized Workforce to use the Service on your behalf, subject to the terms of these TOS. You will:</p><p><strong>3.9.1</strong> require each member of your Authorized Workforce to have unique Credentials, and will provide the legal name(s) of each such member for which you are seeking Credentials;</p><p><strong>3.9.2</strong> train all members of your Authorized Workforce in the requirements of these TOS and the Policies and Procedures relating to their access to and use of the Service, and ensure that they comply with such requirements;</p><p><strong>3.9.3</strong> take appropriate disciplinary action against any member of your Workforce who violates the terms of these TOS or the Policies and Procedures;</p><p><strong>3.9.4</strong> ensure that only the person to whom a specific set of Credentials have been assigned accesses the Service with such Credentials; and</p><p><strong>3.9.5</strong> be bound by these TOS, along with any employer, organization, or other entity for which you are acting as an agent.</p><h4><strong>3.10</strong> <span class="text-underline">Personal Health Record</span>.</h4><p>UDT Software, LLC may at some point enable the Service to make available to your patients portions of their medical records through a web-based personal health record portal that we would operate on your behalf (a \u201CPatient Portal\u201C). If and when the Patient Portal becomes available, you would be responsible for granting Patient Portal access privileges to your patients, either on an individual basis or for your entire patient population. You would also be solely responsible for the information that you make available through a Patient Portal. Health information included in Patient Portals, if and when they become offered as part of the Service, will be held and administered by us on your behalf subject to the terms of these TOS and our business associate obligations stated in Section 9.</p><h4><strong>3.11</strong> <span class="text-underline">Forums</span>.</h4><p>We may offer forums for the exchange of information among our users. You will comply with all applicable forum rules. In particular, you understand that we do not assure the accuracy, reliability, confidentiality or security of information made available through the use of such forums. You acknowledge that any information you post in a forum is available to the public, and may result in your receiving communications from others outside of our site. You are responsible for safeguarding the privacy of your and your patients\u2019 personal information when you participate in forums, discussion groups and the like. You agree not to disclose individually identifiable health information through such forums.</p><h4><strong>3.12</strong> <span class="text-underline">Compliance with Law</span>.</h4><p>You are solely responsible for ensuring that your use of the Service complies with applicable law, including laws relating to the maintenance of the privacy, security, and confidentiality of patient and other health information. You will not grant any user, including members of your Authorized Workforce, any rights to access or use our Service that they would not be allowed to have under applicable laws. We offer no assurance that your use of the Service under the terms of these TOS will not violate any law or regulation applicable to you. You acknowledge that we may share Your Information with third parties if we determine in good faith that disclosure of Your Information is necessary to (i) comply with a court order, warrant or other legal process, (ii) protect the rights, property or safety of UDT Software, LLC or others, (iii) investigate or enforce suspected breaches of these TOS, or (iv) allow our third-party partners to comply with their obligations under federal or state law.</p><h4><strong>3.13</strong> <span class="text-underline">Professional Responsibility</span>.</h4><p>You will be solely responsible for the professional and technical services you provide. We make no representations concerning the completeness, accuracy or utility of any information in the Service, or concerning the qualifications or competence of persons who placed it there. We have no liability for the consequences to you or your patients of your use of the Service.</p><h4><strong>3.14</strong> <span class="text-underline">Cooperation</span>.</h4><p>You will cooperate with us in the administration of the Service, including providing reasonable assistance in evaluating the Service and collecting and reporting data requested by us for purposes of administering the Service.</p><h4><strong>3.15</strong> <span class="text-underline">Indemnification</span>.</h4><p>You hereby agree to indemnify, defend, and hold harmless us and other users, and our and their respective affiliates, officers, directors, employees and agents, from and against any claim, cost or liability, including reasonable attorneys\u2019 fees, arising out of or relating to: (a) the use of the Service by you or your Workforce; (b) any breach by you or your Workforce of any representations, warranties or agreements contained in these TOS; (c) the actions of any person gaining access to the Service under Credentials assigned to you or a member of your Workforce; (d) the actions of anyone using Credentials assigned to you or any member of your Workforce that adversely affects the Service or any information accessed through the Service; and (e) your negligent or willful misconduct, or that of any member of your Workforce. Your indemnification obligations in these TOS (including this Section 3.15) are cumulative, and are not intended to, nor do they, limit your indemnification obligations elsewhere in these TOS or at law, even if such obligations arise or are occasioned or triggered by a single assertion, claim, circumstance, action, event or transaction.</p><h3 class="heading">4. Use of Information</h3><h4><strong>4.1</strong> <span class="text-underline">Purpose of Service</span>.</h4><p>The purpose of the Service is to store Your Health Information and (i) to make it available to you and your Authorized Workforce for any legal purpose, including treatment, payment and health care operations; (ii) to facilitate the sharing of individuals\u2019 health information among users and other parties with whom you or your Authorized Workforce members elect to share such information, and (iii) if and when a Patient Portal becomes available, to make health information available to your patients through the Patient Portal. You may make Your Health Information accessible to other users of the Service, other individuals and entities, or to your patients through the Service for these purposes. You authorize us, as your business associate under the BAA, to use and disclose Your Information as follows:</p><p><strong>4.1.1</strong> We will permit unrestricted access to Your Health Information to you and your Authorized Workforce. You are responsible for ensuring that your use of Your Health Information is consistent with the relevant legal restrictions.</p><p><strong>4.1.2</strong> We will permit access to Your Information by health care providers, covered entities and their business associates to whom you have Consented to provide access to the Service and who have otherwise agreed to integrate with our systems. We will obtain your Consent before we make Your Health Information available to other providers, covered entities and their respective business associates. You acknowledge that once we have granted access rights to another provider or covered entity (or their respective business associates), we have no control over the uses and disclosures that such person or entity makes of Your Health Information, and the recipient may be subject to its own legal or regulatory obligations (including HIPAA) to retain such information and make such information available to patients, governmental authorities and others as required by applicable law or regulation.</p><p><strong>4.1.3</strong> We may disclose or permit access to Your Information to entities such as, but not limited to, health plans, health care clearinghouses, medical groups, independent practice associations, your authorized service providers and other parties responsible for payment and their business associates for the purpose of obtaining (or confirming eligibility or authorization for) payment for services you provide, unless you advise us in writing that, with respect to a specific service provided to a specified patient, such patient has paid out of pocket in full for the service to which the health information relates, and has requested that it not be disclosed to his or her health plan.</p><p><strong>4.1.4</strong> We may De-Identify Your Information, and use and disclose De-Identified Information for any purpose whatsoever, including as provided by Section 5 and Section 7.2.</p><p><strong>4.1.5</strong> We may create limited data sets from Your Health Information, and disclose them for any purpose for which you may disclose a limited data set; and you hereby authorize us to enter into data use agreements on your behalf for the use of limited data sets, in accordance with applicable law and regulation.</p><p><strong>4.1.6</strong> We may use Your Information in order to prepare analyses and reports, such as activity or quality-metrics reports, or any other reports the Service makes available. Preparation of such analyses and reports may include the use of data aggregation services relating to your treatment and health care operations, which we may perform using Your Health Information. Such reporting will be done in a manner that does not make any disclosure of Your Health Information that you would not be permitted to make.</p><p><strong>4.1.7</strong> We may use Your Information for the proper management and administration of the Service and our business, and to carry out our legal responsibilities, which may include us disclosing such information to one of our business associates that has entered into a business associate agreement in accordance with Section 9.4 below. We may also disclose Your Information for such purposes if the disclosure is required by law (as such term is defined in 45 CFR \xA7164.103), or we obtain reasonable assurances (as such term is interpreted or applicable in connection with or under HIPAA) from the recipient that it will be held confidentially and used or further disclosed only (a) as required by law (as such term is defined in 45 CFR \xA7164.103), or (b) for the purpose for which it was disclosed to the recipient, and the recipient notifies us of any instances of which it is aware in which the confidentiality of the information has been breached. Without limiting the foregoing, we may permit access to the system by our contracted system developers under appropriate confidentiality agreements.</p><p><strong>4.1.8</strong> We may use Your Health Information and Directory Information (defined below) to contact your patients on your behalf for any purpose for which you would be permitted to contact them, including:</p><ol type="a"><li>For treatment and health care operations messages, including sending appointment notifications (such as appointment requests, confirmations, reminders, cancellations and the like) and messages about currently prescribed medications (including refill reminders), or post-visit treatment satisfaction surveys, invitations and administrative messages concerning Patient Portal access, and the like;</li><li>With your Consent, to request an authorization on your behalf from your patients to use or disclose their health information for any purpose for which use or disclosure may be made with an appropriate authorization, including research purposes. You agree that we may also use and disclose your patients\u2019 health information as permitted by any such authorization; and</li><li>To provide information about health-related products or services that you provide, or that we provide on your behalf as your business associate.</li></ol><p><strong>4.1.9</strong> From time to time we may incorporate information we receive from your authorized service providers (including Third-Party Applications as discussed in Section 11.2), our third-party partners, or covered entities (and their business associates) who are providing or paying for medical services for one or more of your patients, into the Service we provide to you. Such information may include, without limitation, clinical information such as lab results, imaging results, eligibility information, prior authorizations and prescription history; and shall, upon incorporation into the Service, be treated as \u201CYour Health Information\u201D for all purposes hereunder. You hereby authorize us to request and receive such information on your behalf from such authorized service providers or our third party partners.</p><p><strong>4.1.10</strong> We may use or disclose Your Health Information for other purposes, as from time to time described in our Policies and Procedures; provided that we will not make or permit any such use or disclosure that would violate applicable law or regulation if made by you or your business associate.</p><p><strong>4.1.11</strong> We may use Your Information to provide you with notifications regarding Your patients\u2019 potential eligibility for certain programs, including savings programs, coupons, sampling, educational, safety, adherence or treatment support materials or other programs which you may choose to share with your patients (\u201CPatient Support Programs\u201C) as well as to administer the Support and Assessment Resources more fully described in Section 6 below. These notifications and materials are not a substitute for your professional medical judgment pertaining to the appropriateness of any such program for a given patient and you should discuss any such programs or materials with your patients directly. We may receive remuneration from the funding sources or sponsors for presenting you with Support and Assessment Resources or displaying their advertisements. In connection with offering or operating such Patient Support Programs or Support and Assessment Resources, we may share personally identifiable information about you for the purposes of program administration, and for assessing program eligibility, effectiveness or performance. We will only share such information with partners who are subject to confidentiality obligations. Additionally, we may disclose Personal Information about you to administrators of the Patient Support Programs or Support and Assessment Resources for recordkeeping, corporate integrity or regulatory reporting purposes.</p><h4><strong>4.2</strong> <span class="text-underline">Responsibility for Misuse by Other Users</span>.</h4><p>You acknowledge that in granting access to the Service for the purposes set forth in Section 4.1, we will rely on the assurances of the recipients of the information as to (i) their identity and credentials, (ii) the purposes for which they are accessing the system, and (iii) the nature and extent of the information to which they will have access. You acknowledge that, while the Service will contain certain technical safeguards against misuse of the Service, it will rely to a substantial extent on the representations and undertakings of users of the Service. You agree that we will not be responsible for any unlawful access to or use of Your Health Information by any user resulting from the user\u2019s misrepresentation to us, or breach of the user\u2019s user agreement or our Policies and Procedures.</p><h4><strong>4.3</strong> <span class="text-underline">Specially Protected Information</span>.</h4><p>We apply the standards of the Privacy Rule in permitting access to the Service. You acknowledge that other federal and state laws impose additional restrictions on the use and disclosure of certain types of health information, or health information pertaining to certain classes of individuals. You agree that you are solely responsible for ensuring that Your Health Information may properly be disclosed for the purposes set forth in Section 4.1, subject to the restrictions of the Privacy Rule and applicable law, including those laws that may be more restrictive than the Privacy Rule. In particular, you will:</p><p><strong>4.3.1</strong> not make available to other users through the Service any information in violation of any restriction on use or disclosure (whether arising from your agreement with such users or under law);</p><p><strong>4.3.2</strong> obtain all necessary consents, authorizations or releases from individuals required for making their health information available through the Service for the purposes set forth in Section 4.1;</p><p><strong>4.3.3</strong> include such statements (if any) in your notice of privacy practices as may be required in connection with your use of the Service; and</p><p><strong>4.3.4</strong> not place in the Service any information that you know or have reason to believe is false or materially inaccurate.</p><h4><strong>4.4</strong> <span class="text-underline">Health Record Sharing</span>.</h4><p>With your Consent, we may make parts of your online heath record for any patient you designate accessible to any other user of the Service or any third party whom you approve, but subject to the technical limitations of the Service generally. You may revoke your Consent with respect to any other user at any time. While your Consent is in effect, an approved user may only view any health record you have designated for his or her access. If you revoke your Consent, the approved user will continue to have the ability to view the health record in the form in which it existed at the time you revoked your Consent, but will not be able to view changes made to the record thereafter. The same rules apply to your use of another user\u2019s record who approves access by you. You and your Workforce are fully responsible for the information in any chart that you share. You or your Workforce should not share patient information that violates any state or federal laws. In any event, but especially in cases of potential fraud, misuse or abuse of the Service, we reserve the right, in our sole judgment, to revoke, remove, cancel or deny any request to share online health records as part of the Service.</p><h4><strong>4.5</strong> <span class="text-underline">Client Directories</span>.</h4><p>We may include your Directory Information (defined below) in our (a) <span class="text-underline">\u201CPublic Client Directories,\u201D</span> which are electronic directories for patients and the general public; and (b) <span class="text-underline">\u201CProfessional Client Directories,\u201D</span> which are electronic directories for Clients and other members of the healthcare community ((a) and (b) collectively, <span class="text-underline">\u201CClient Directories\u201C</span>). Client Directories may be made available in various electronic formats, including searchable databases, Client landing pages, interactive reference tools, reference lists, ratings, and integrated look-up features, among others. They may also incorporate information designed to help users, such as integrated maps, and licensure confirmation tools, reviews, among other matters. Client Directories may include a \u201Ccontact\u201D feature that allows users to contact other users directly through the Service. Our Public Client Directory may be made available to public search engines to aid Client discovery. Listing in the Client Directories is subject to eligibility criteria, which may differ between the Public Client Directory and Professional Client Directory. A Client\u2019s <span class="text-underline">\u201CDirectory Information\u201D</span> includes the Client\u2019s name, name(s) of physicians or other healthcare professionals associated with a Client, associated specialties, Client\u2019s business telephone number(s) and physical address(es), National Client Identifiers (or NPI), and the Client\u2019s available appointment slots, as each is indicated from information a Client has inputted or imported into the Service. The Directory Information may include additional information you input or upload into profile tools we make available in the Service (such as a profile photograph, accepted insurance, available office hours, a front desk email address, and the like), as and when such tools are available.</p><h4><strong>4.6</strong> <span class="text-underline">Care Coordination and Clinical Data Exchange</span>.</h4><p>We will enable Clinical Data Exchange between You and your business associate(s) or those covered entities (and their respective business associates), including health systems, Accountable Care Organizations, payers, and laboratories who desire to transmit such data to you with respect to patients they have a treatment or payment relationship or with whom you have Consented to provide such data (all third parties collectively referred herein as <span class="text-underline">\u201CTransmission Partner\u201C</span>). While such transmission integrations are in effect, such Transmission Partner may send and receive clinical data to and from your account on a routine and recurring basis. You may disable an integration with any Transmission Partner by contacting us through one of the methods described at www.bluebookehr.com, but any clinical data already received by such Transmission Partner will remain in its possession, subject to the terms of your independent agreements with such Transmission Partner, if any. You are solely responsible for ensuring that You have all necessary consents from Your patients applicable to the sharing of any of Your Health Information under applicable law with respect to each Transmission Partner with whom you have Consented to share any information under this Section 4.6.</p><h3 class="heading">5. Providing Physician Data to Payers and Others</h3><p>Without limiting the provisions of Section 7.2, you agree that we may provide De-Identified Health Information and other information (including Your Personal Information and information concerning your practice) to any medical group, independent practice association of physicians, health plan or other organization with which you have a contract to provide medical services, or to whose members or enrollees you provide medical services. Such information may identify you, but will not identify any individual to whom you provide services. Such information may include aggregated data concerning your patients, diagnoses, procedures, orders and the like.</p><h3 class="heading">6. Support and Assessment Resources; Advertising</h3><p>We may also present to you, through the Service or through the use of Your Information, the opportunity to utilize or engage in clinical decision support or assessment resources or informational programs (<span class="text-underline">\u201CSupport and Assessment Resources,\u201D</span> which may also include, for the avoidance of doubt, Patient Support Programs (as previously described in Section 4.1.12)). We may also place advertisements concerning the products and services of third parties throughout the Service, so that you see them when you use the Service. Such Support or Assessment Resources or advertisements may be funded or sponsored by third parties, and may include branded or unbranded content about medical substance abuse related conditions, treatments and products, or safety and regulatory information resources. They may also include opportunities to participate in informational surveys or studies, or to discuss with your patients potential beta programs, trials or other research programs, which may be funded by government grants. We may receive remuneration from the funding sources or sponsors for presenting you with Support and Assessment Resources or displaying their advertisements. In connection with offering or operating such Support and Assessment Resources or delivering advertising, we may share personally identifiable information about you for the purposes of assessing program eligibility, effectiveness or performance with partners who are subject to confidentiality obligations. Additionally, if you choose to engage or utilize one of the Support and Assessment Resources, you may be asked to provide personal information that may be used to supplement Your Information as well as information gathered as part of the program itself (e.g., responses to surveys). This information will be used to provide the content or services described in the Support and Assessment Resources or provide you with any gift or honoraria associated with the program. If you receive remuneration for participating in a sponsored survey, for example, we may be required to provide the funding source or sponsor with information about you for its recordkeeping, regulatory reporting or measurement purposes. You acknowledge and agree that we or our authorized representatives may contact you via email, phone, or text message at any time for any reason.</p><h3 class="heading">7. Intellectual Property Rights</h3><h4><strong>7.1</strong> <span class="text-underline">Individually Identifiable Health Information</span>.</h4><p>You retain all rights with regard to Your Health Information so long as you keep your account current and all balances due and owing are paid, and we will only use such information as expressly permitted in these TOS.</p><h4><strong>7.2</strong> <span class="text-underline">De-Identified Information</span>.</h4><p>In consideration of our provision of the Service, you hereby transfer and assign to us all right, title and interest in and to all De-Identified Information that we make from Your Information pursuant to Section 4.1.5. You agree that we may use, disclose, market, license and sell such De-Identified Information for any purpose without restriction, and that you have no interest in such information, or in the proceeds of any sale, license, or other commercialization thereof. You acknowledge that the rights conferred by this Section are a principal consideration for the provision of the Service, without which we would not enter into these TOS.</p><h4><strong>7.3</strong> <span class="text-underline">Other Works and Information</span>.</h4><p>You hereby grant to us a nonexclusive, royalty-free, fully paid-up, perpetual, irrevocable, worldwide and fully sub-licensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, and display any information, material or work product \u2013 other than Your Information that has not been De-Identified \u2013 you provide to this site or the Service. You agree that we may use, disclose, market, license, and sell such information and works, including derivative products, without restriction. This includes, for example, custom templates that you create using the Service, and information (other than Your Information that has not been De-Identified) that you contribute to forums, discussion groups and the like. You may provide content or material to this site by uploading such content into the Service, participating in forums, discussion groups and the like, or by using the site to create custom templates and the like. Furthermore, you agree that we may use, disclose, market, license and sell such material or content, and that you have no interest in the information, or in the proceeds of any sale, license, or other commercialization thereof. You warrant and agree that any material you provide will not infringe or otherwise violate the intellectual property or other rights of others, and will not be otherwise unlawful, infringing, threatening, libelous, defamatory, obscene, pornographic, or in violation of any law.</p><h4><strong>7.4</strong> <span class="text-underline">Trade Secrets</span>.</h4><p>In order to protect our trade secrets herein, you affirm that neither you nor any of your employers, officers, executives, shareholders, partners, Workforce, or other business associates of any kind are currently or will become for a period of three (3) years after termination or expiration of any license granted to access or use the Service, either directly or indirectly, an officer, executive, shareholder, partner, employee, independent contractor, advisor, consultant, or any other business associate of any kind of any business entity who does currently operate in or intends to enter into competition with us during the period of time you are licensed to use the Service. If we come to know or have reasonable cause to believe that you are in violation of this affirmation, we reserve the right to immediately, permanently, and without notice terminate your access rights and privileges. Any such use shall subject you, as well as any of your officers, executives, shareholders, or partners, to legal action, which may include both civil and criminal penalties, as applicable. You acknowledge that any such civil action may include, but is not limited to, relief sought in the form of: injunctive relief; actual, punitive, statutory, or liquidated damages; any amount of unjust enrichment accrued as a result of such use; and attorney\u2019s fees.</p><p>You will not reverse engineer, decompile, disassemble, or otherwise attempt to discover or reduce to human readable form the source code of the Service, except to the extent allowed under any applicable law. Any attempt to do so must utilize a clean room design. If applicable law permits such activities, any information so discovered must be promptly disclosed to us, and shall be deemed to be our confidential proprietary information. You will not access the service for the purposes of copying the flow, process, or any other Intellectual Property belonging to us for the purposes of incorporating any such Intellectual Property into a competitive product. If you access the service on behalf of or for the benefit of a competitor or for any competitive purposes, you must immediately cease such access and report your unauthorized access to UDT Software, LLC at <a href="mailto:support@bluebookehr.com">support@bluebookehr.com</a>.</p><p>In the event that, at the conclusion of any resulting litigation, the Service is held to have been legitimately used in any manner to derive a new product, that derivative product may then only be used for noncommercial purposes and may not be marketed, distributed, or otherwise made available in any way. This provision shall not be read to authorize, explicitly or implicitly, use of the Service in such a manner.</p><h4><strong>7.5</strong> <span class="text-underline">Copyright and Ownership</span>.</h4><p>All content included in or made available through any UDT Software, LLC product or service, such as input screens and forms, charts, text, graphics, logos, button icons, images, audio clips, digital downloads, and data compilations is the property of UDT Software, LLC, or its content suppliers, and is protected by United States and international copyright laws. The compilation of all content included in or made available through the Service is the exclusive property of UDT Software, LLC, and is protected by U.S. and international copyright laws. All content posted on the Service by you must comply with U.S. copyright law.</p><p>The Service is the intellectual property of and is owned by UDT Software, LLC. The structure, organization, flows, processes, and source code of the Service (collectively, \u201CIntellectual Property\u201D) are the valuable trade secrets and confidential information of UDT Software, LLC. The Service is protected by law, including but not limited to the copyright laws of the United States and the Florida Uniform Trade Secrets Act, and by international treaty provisions. Except as expressly stated herein, this agreement does not grant you any intellectual property rights in the Service. All rights not expressly granted are reserved by UDT Software, LLC.</p><p>We shall have a royalty-free, worldwide, irrevocable, perpetual license to use and incorporate into the Service any suggestions, enhancement requests, recommendations, or other feedback provided by you relating to the operation of the Service. The look and feel of the Service, including the process and flows, are copyright \xA9 2018 UDT Software, LLC. All rights reserved. You may not duplicate, copy, or reuse any portion of the HTML/CSS or visual design elements without the express written permission of UDT Software, LLC\u2019s CEO. Portions may be Patent Pending.</p><h3 class="heading">8. Individual\'s Rights</h3><p>You are solely responsible for affording individuals their rights with respect to relevant portions of Your Health Information, such as the rights of access and amendment. You will not undertake to afford an individual any rights with respect to any information in the Service other than Your Health Information.</p><h3 class="heading">9. Business Associate Agreement</h3><p>You agree to be bound by the terms and conditions of the BAA, which is incorporated herein by reference.</p><h3 class="heading">10. Computer System</h3><p>You agree and acknowledge that you will be required to acquire, install, configure and maintain all hardware, software and communications systems necessary to access the Service and go through all necessary training (your \u201CComputer Systems\u201C). Your Computer Systems will comply with the specifications from time to time established by us. You will ensure that your Implementation is compatible with the Service. If we notify you that your Computer Systems are incompatible with the Service, you will eliminate the incompatibility, and we may suspend Service to you until you do so.</p><h3 class="heading">11. Third-Party Service</h3><p><strong>11.1</strong> We may also present to you, through the Service (including via emails, displays or advertisements) or through the use of Your Information, the opportunity to learn about, access, integrate with, or otherwise use services operated by third parties (each a \u201CThird-Party Service\u201C), some of which may be our affiliates. If you choose to sign-up for or utilize a Third-Party Service, that Third-Party Service may be able to access Your Information. Additionally, we may allow you to access the Third-Party Service, or integrate the Service you receive from us with such Third-Party Service using your Credentials that allow you to receive services or information from such Third-Party Service. Although we may receive remuneration from the operators or sponsors of these Third-Party Service, we do not endorse any Third-Party Service and you are responsible for evaluating any Third-Party Service prior to signing-up for, accessing, or integrating them (including any information) with the Service you receive from us.</p><p><strong>11.2</strong> We are not responsible for the quality or efficacy of any Third-Party Service, or their information privacy or security practices, and we have no responsibility for the information, goods or services offered or provided by the operators of such Third-Party Service, or for the manner in which they conduct their operations. Your use of Third-Party Service and the materials, information, goods and services offered by them is entirely at your own risk, and is subject to the terms of use of the third parties operating or providing them, if any. You should assume that any Internet page or other material that does not bear the official Bluebook logo is provided by a third party. You should review the applicable terms of any agreement, terms of use and privacy policies of any Third-Party Service, since they are subject only to the agreements you have with the operators of such Third-Party Service, and not covered by these TOS. Further, the Third-Party Service may use Your Information in a way that we would not. You further acknowledge that your use of any Third-Party Service is on an \u201Cas-is\u201D basis and is further subject to the TPTOS to which you consent by entering into these TOS.</p><h3 class="heading">12. Fees and Charges</h3><h4><strong>12.1</strong> <span class="text-underline">Service Fees</span>.</h4><p>You agree to pay all fees for the Service (the <span class="text-underline">\u201CService Fees\u201C</span>), as set forth in the Exhibit A and the Cover Sheet to the Service Agreement, to which you have access during the Term of these TOS. In light of the fact that we incur the expense of hosting your Instance immediately after the Contract Date, Maintenance Fees commence on the earlier of the Service Start Date or 60 days after Contract Date, even if your implementation is not then yet complete. You also agree to pay, at our then current rates, for all goods, services, or features that you utilize, or otherwise request from us and that are not included in our standard services on Exhibit A to the Service Agreement (<span class="text-underline">\u201CMiscellaneous Charges\u201C</span>). We will notify you of the applicable Miscellaneous Charges before performing services or enabling features to which a Miscellaneous Charge will apply. We reserve the right to change the Miscellaneous Charges at any time, or to add new fees or charges. Notwithstanding the terms of Exhibit D to the Service Agreement, the Early Termination Buyout Fee for all Service Agreements entered into on or before February 22, 2018 shall be the greater of (a) the total of all Patient Fees, Maintenance Fees, and Lab or API fees generated during the twelve (12) most recent full calendar months prior to termination; or (b) four (4) times all Patient Fees, Maintenance fees, and Lab or API fees generated during the three (3) most recent full calendar months prior to termination.</p><h4><strong>12.2</strong> <span class="text-underline">Implementation Fees</span>.</h4><p>The implementation of your Instance is considered complete and accepted by you, and Service Start Date deemed commenced, upon the generation of the first patient medical record number (\u201CMR Number\u201D). The Implementation Fee is considered fully earned by us on the Contract Date even if an installment payment plan for such fees is offered to you. Although this Service Agreement has no specified term, all remaining installments of the Implementation Fee remain due and payable if the Service Agreement is terminated for any reason after the Contract Date.</p><h4><strong>12.3</strong> <span class="text-underline">Payment</span>.</h4><p>The Service Fees and any Miscellaneous Charges shall be paid within fifteen (15) days of date of invoice at the address set forth in the invoice, or such other address as may be set forth in our Policies and Procedures. Payments are non-refundable.</p><h4><strong>12.4</strong> <span class="text-underline">Late Charges</span>.</h4><p>In the event payment is not made by the due date, we may discontinue your Service or charge the greater of $250 per month per invoice or a Five Percent (5%) late fee for each month each invoice remains unpaid, as allowed by law. A reconnection fee equal to one (1) month\u2019s Service Fee shall be assessed to re-establish connection after termination due to non-payment, in addition to all unpaid Service Fees.</p><h4><strong>12.5</strong> <span class="text-underline">Taxes</span>.</h4><p>All charges and fees shall be exclusive of all federal, state, municipal, or other government excise, sales, use, occupational, or like taxes now in force or enacted in the future, and you agree to pay any tax (excluding taxes on our net income) that we may be required to collect or pay now or at any time in the future and that are imposed upon the sale or delivery of items and services purchased under these TOS. The amount we charge you for a Service may include certain taxes or charges applicable thereto your purchase. If any tax or charge applicable is not charged by us, you acknowledge that you are solely responsible for paying such tax or other charge.</p><h4><strong>12.6</strong> <span class="text-underline">Other Charges</span>.</h4><p>You are responsible for any charges you incur to use the Service, such as telephone and equipment charges, and fees charged by third-party vendors of products and services.</p><h4><strong>12.7</strong> <span class="text-underline">Payment Information; Method of Payment</span>.</h4><p>By providing payment information to us, you hereby represent and warrant that you are authorized to use the payment method you provide, that such information is accurate, and that we are authorized to charge you for the applicable Service using the established payment method and the information you provided. You are solely responsible for notifying us of any changes to your payment information.</p><h3 class="heading">13. Confidential Information</h3><p><strong>13.1</strong> You may not disclose our Confidential Information to any other person, and you may not use any Confidential Information except for the purpose of these TOS. Except as otherwise provided in these TOS, you may not, without the prior written consent of UDT Software, LLC\u2019s CEO, at any time, during or after the Term of these TOS, directly or indirectly, divulge or disclose Confidential Information for any purpose. In addition, except for the purposes of using the Service, you will not use Confidential Information for any other purposes. You will hold all Confidential Information in strict confidence and take all measures necessary to prevent unauthorized copying, use, or disclosure of Confidential Information, and to keep the Confidential Information from falling into the public domain or into the possession of persons not bound to maintain its confidentiality. You will disclose Confidential Information only to members of your Authorized Workforce who have a need to use it for the purposes of these TOS. You will inform all such recipients of the confidential nature of Confidential Information and will instruct them to deal with Confidential Information in accordance with the terms of these TOS. You will promptly advise us in writing of any improper disclosure, misappropriation, or misuse of the Confidential Information by any person, which may come to your attention.</p><p><strong>13.2</strong> You agree that we will suffer irreparable harm if you fail to comply with your obligations set forth in Section 13.1, and you further agree that monetary damages will be inadequate to compensate us for any such breach. Accordingly, you agree that we will, in addition to any other remedies available to us at law or in equity, be entitled to the issuance of injunctive relief to enforce the provisions hereof, immediately and without the necessity of posting a bond.</p><h3 class="heading">14. Disclaimer, Exclusion of Warranties, and Limitation of Liability</h3><h4><strong>14.1</strong> <span class="text-underline">Carrier Lines</span>.</h4><p>YOU ACKNOWLEDGE THAT ACCESS TO THE SERVICES WILL BE PROVIDED OVER VARIOUS FACILITIES AND COMMUNICATIONS LINES, AND INFORMATION WILL BE TRANSMITTED OVER LOCAL EXCHANGE AND INTERNET BACKBONE CARRIER LINES AND THROUGH ROUTERS, SWITCHES, AND OTHER DEVICES (COLLECTIVELY, \u201CCARRIER LINES\u201C) OWNED, MAINTAINED, AND SERVICED BY THIRD-PARTY CARRIERS, UTILITIES, AND INTERNET SERVICE PROVIDERS, ALL OF WHICH ARE BEYOND OUR CONTROL. WE ASSUME NO LIABILITY FOR, OR RELATING TO, THE INTEGRITY, PRIVACY, SECURITY, CONFIDENTIALITY, OR USE OF ANY INFORMATION WHILE IT IS TRANSMITTED ON THE CARRIER LINES, OR ANY DELAY, FAILURE, INTERRUPTION, INTERCEPTION, LOSS, TRANSMISSION, OR CORRUPTION OF ANY DATA OR OTHER INFORMATION ATTRIBUTABLE TO TRANSMISSION ON THE CARRIER LINES. USE OF THE CARRIER LINES IS SOLELY AT YOUR RISK AND IS SUBJECT TO ALL APPLICABLE LOCAL, STATE, NATIONAL, AND INTERNATIONAL LAWS.</p><h4><strong>14.2</strong> <span class="text-underline">No Warranties</span>.</h4><p>ACCESS TO THE SERVICES AND THE INFORMATION CONTAINED ON THE SERVICES IS PROVIDED \u201CAS IS\u201D AND \u201CAS AVAILABLE\u201D WITHOUT ANY WARRANTY OF ANY KIND, AND WE DISCLAIM ALL WARRANTIES, EXPRESSED OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NONINFRINGEMENT AND TITLE. YOU ARE SOLELY RESPONSIBLE FOR ANY AND ALL ACTS OR OMISSIONS TAKEN OR MADE IN RELIANCE ON THE SERVICES OR THE INFORMATION IN THE SERVICES, INCLUDING INACCURATE OR INCOMPLETE INFORMATION. IT IS EXPRESSLY AGREED THAT IN NO EVENT SHALL WE BE LIABLE FOR ANY SPECIAL, INDIRECT, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO, LOSS OF PROFITS OR REVENUES, LOSS OF USE, LOSS OF GOODWILL, OR LOSS OF INFORMATION OR DATA, WHETHER A CLAIM FOR ANY SUCH LIABILITY OR DAMAGES IS PREMISED UPON BREACH OF CONTRACT, BREACH OF WARRANTY, NEGLIGENCE, STRICT LIABILITY, OR ANY OTHER THEORY OF LIABILITY, EVEN IF WE HAVE BEEN APPRISED OF THE POSSIBILITY OR LIKELIHOOD OF SUCH DAMAGES. WE DISCLAIM ANY AND ALL LIABILITY FOR ERRONEOUS TRANSMISSIONS AND LOSS OF SERVICE RESULTING FROM COMMUNICATION FAILURES BY TELECOMMUNICATION SERVICE PROVIDERS OR THE SERVICES. NO UDT SOFTWARE, LLC EMPLOYEE OR AGENT IS AUTHORIZED TO MAKE ANY STATEMENT THAT ADDS TO OR AMENDS THE WARRANTIES, CONDITIONS, OR LIMITATIONS CONTAINED IN YOUR SERVICE AGREEMENT OR THESE TOS.</p><h4><strong>14.3</strong> <span class="text-underline">Conditions for Breach</span>.</h4><p>We will not be deemed to be in violation of these TOS unless you have first given us written notice specifying the nature of the default, and we have failed within thirty (30) days of receipt of the notice either to cure the default or, if cure within such period is not practicable, to be diligently proceeding to cure the default.</p><h4><strong>14.4</strong> <span class="text-underline">Other Users</span>.</h4><p>YOU ACKNOWLEDGE THAT OTHER USERS HAVE ACCESS TO AND ARE USING OUR SERVICES AND THE ACTIONS OF SUCH OTHER USERS ARE BEYOND OUR CONTROL. ACCORDINGLY, WE DO NOT ASSUME ANY LIABILITY FOR OR RELATING TO ANY IMPAIRMENT OF THE PRIVACY, SECURITY, CONFIDENTIALITY, INTEGRITY, AVAILABILITY, OR RESTRICTED USE OF ANY INFORMATION ON THE SERVICES RESULTING FROM ANY USER\u2019S ACTIONS OR FAILURES TO ACT.</p><h4><strong>14.5</strong> <span class="text-underline">Unauthorized Access; Lost or Corrupt Data</span>.</h4><p>WE ARE NOT RESPONSIBLE FOR UNAUTHORIZED ACCESS TO YOUR DATA, FACILITIES OR EQUIPMENT BY PERSONS USING THE SERVICES OR FOR UNAUTHORIZED ACCESS TO, ALTERATION, THEFT, CORRUPTION, LOSS OR DESTRUCTION OF YOUR DATA FILES, PROGRAMS, PROCEDURES, OR INFORMATION THROUGH THE SERVICES, WHETHER BY ACCIDENT, FRAUDULENT MEANS OR DEVICES, OR ANY OTHER MEANS. YOU ARE SOLELY RESPONSIBLE FOR VALIDATING THE ACCURACY OF ALL OUTPUT AND REPORTS, AND FOR PROTECTING YOUR DATA AND PROGRAMS FROM LOSS BY IMPLEMENTING APPROPRIATE SECURITY MEASURES. YOU HEREBY WAIVE ANY DAMAGES OCCASIONED BY LOST OR CORRUPT DATA, INCORRECT REPORTS, OR INCORRECT DATA FILES RESULTING FROM PROGRAMMING ERROR, OPERATOR ERROR, EQUIPMENT OR SOFTWARE MALFUNCTION, SECURITY VIOLATIONS, OR THE USE OF THIRD-PARTY SOFTWARE. WE ARE NOT RESPONSIBLE FOR THE CONTENT OF ANY INFORMATION TRANSMITTED OR RECEIVED THROUGH OUR PROVISION OF THE SERVICES.</p><h4><strong>14.6</strong> <span class="text-underline">Limitation of Liability</span>.</h4><p>NOTWITHSTANDING ANYTHING IN THESE TOS OR THE SERVICE AGREEMENT TO THE CONTRARY, OUR AGGREGATE LIABILITY UNDER THE SERVICE AGREEMENT, REGARDLESS OF THEORY OF LIABILITY, SHALL BE LIMITED TO THE AGGREGATE FEES ACTUALLY PAID BY YOU UNDER THE SERVICE AGREEMENT FOR THE TWO (2) MONTH PERIOD PRECEDING THE EVENT FIRST GIVING RISE TO THE CLAIM, UP TO A LIMIT OF $10,000 IN THE AGGREGATE.</p><h3 class="heading">15. Insurance</h3><p>You will obtain and maintain such policies of general liability, errors and omissions, and professional liability insurance with reputable insurance companies as is usually carried by persons engaged in your business covering the term of these TOS.</p><h3 class="heading">16. Modification; Suspension; Termination.</h3><h4><strong>16.1</strong> <span class="text-underline">Termination upon Notice</span>.</h4><p>Absent any agreement to the contrary, you may terminate the Service Agreement in accordance with the terms thereof.</p><h4><strong>16.2</strong> <span class="text-underline">Modification</span>.</h4><p>We may update or change the Service or the terms set forth in these TOS from time to time. Accordingly, we recommend that you review the TOS on a regular basis. You understand and agree that your continued use of the Service after the TOS has been updated or changed constitutes your acceptance of the revised TOS. Without limiting the foregoing, if we make a change to the TOS that materially affects your use of the Service, we may post notice or notify you via email or our website(s) of any such change.</p><h4><strong>16.3</strong> <span class="text-underline">Termination, Suspension or Amendment as a Result of Government Regulation</span>.</h4><p>Notwithstanding anything to the contrary in these TOS, we have the right, on notice to you, immediately to terminate, suspend, or amend these TOS, without liability: (a) to comply with any order issued or proposed to be issued by any governmental agency; (b) to comply with any provision of law, any standard of participation in any reimbursement program, or any accreditation standard; (c) if performance of any term of these TOS by either Party would cause it to be in violation of law, or would jeopardize its tax-exempt status.</p><h4><strong>16.4</strong> <span class="text-underline">Judicial or Administrative Procedures; Credentialing</span>.</h4><p>We may terminate your Service Agreement and these TOS, and your access to the Service, immediately upon notice to you: (a) if you are named as a defendant in a criminal proceeding for a violation of federal or state law; (b) if a finding or stipulation is made or entered into that you have violated any standard or requirement of federal or state law relating to the privacy or security of health information in any administrative or civil proceeding; (c) you are excluded from participation in a federal or state health care program; (d) you cease to be qualified to provide services as a health care professional, or we are unable to verify your qualifications as such or (e) as otherwise set forth in the Service Agreement.</p><h4><strong>16.5</strong> <span class="text-underline">Suspension of Access</span>.</h4><p>We may suspend access to the Service by you or any member of your Workforce immediately pending your cure of any breach of these TOS, or in the event we determine in our sole discretion that access to or use of the Service by you or the member of your Workforce may jeopardize the Service or the confidentiality, privacy, security, integrity or availability of information within the Service, or that you or the member of your Workforce has violated or may violate these TOS or our Policies and Procedures, or has jeopardized or may jeopardize the rights of any third party, or that any person is or may be making unauthorized use of the Service with any Credentials assigned to you or a member of your Workforce. We may terminate the access of any member of your Authorized Workforce upon termination or change in status of his or her employment with you. Our election to suspend the Service shall not waive or affect our rights to terminate these TOS as permitted under these TOS.</p><h4><strong>16.6</strong> <span class="text-underline">Suspension and Termination for No-Use</span>.</h4><p>If your account does not show any new patients over the course of three (3) months, your account may be suspended in our sole discretion. User access to the Service will be denied and the data will be frozen. To reactivate a suspended account, you must contact <a href="mailto:support@bluebookehr.com">support@bluebookehr.com</a> or the help desk. There is no charge to reactivate an account in good standing with no past-due balance. If your account remains suspended for three (3) months and you have not contacted us to reactivate it, your account may be terminated in our sole discretion.</p><h4><strong>16.7</strong> <span class="text-underline">Obligation after Termination</span>.</h4><p>Upon termination of the Service Agreement for any reason, you will (i) cease all use of the Service and (ii) pay the outstanding balance of any fees due to us. All provisions of the TOS which, by their nature, should survive termination shall survive termination, including, but not limited to, Sections 1, 3.15, 5, 7, 9.10, 11.2, 12 through 15, 16.7, 17, 18, 19, 20.3, and 21 through 26.</p><h3 class="heading">17. No Solicit or Hire Clause</h3><p>You acknowledge that UDT Software, LLC invests considerable time and expense in the training of its employees and independent subcontractors in the services to be provided under the Service Agreement. You agree that for the full term of the Service Agreement, and for 2 years after its termination, you will not solicit or employ in any capacity, whether as a direct employee, independent contractor or as a representative of another company providing similar services to you as the Service provided by UDT Software, LLC, any person employed by UDT Software, LLC at any time during the term of the Service Agreement whose duties involve providing the Service, whether for yourself or other UDT Software, LLC customers. In addition to equitable remedies, you acknowledge and agree that actual damages in the event of a breach of this Section 17 are difficult to ascertain at present. You have reviewed and found the amount of one hundred thousand dollars ($100,000) to be a reasonable estimate of damages UDT Software, LLC would incur if you breach this Section 17. You have reviewed and will not challenge this amount as unreasonable, and you agree that you will not contest an order entering a judgment in this amount without delay and that you will not present any defenses or counterclaims.</p><h3 class="heading">18. Applicable Law</h3><p>The interpretation of the Service Agreement, including these TOS, and the resolution of any disputes arising out of or related to the Service Agreement, including these TOS shall be governed by the laws of the State of Florida, without regards to its conflicts of laws provisions. If any action or other proceeding is brought on or in connection with the Service Agreement, including these TOS, the venue of such action shall be exclusively in the applicable state or federal courts in and for Miami-Dade County, Florida.</p><h3 class="heading">Arbitration</h3><p><strong>19.1</strong> EXCEPT FOR CLAIMS BY EITHER PARTY UNDER ANY OF THE SECTIONS OF THESE TOS LISTED IN SECTION 19.2, ANY DISPUTE, CLAIM OR CONTROVERSY ARISING OUT OF OR RELATING TO THE SERVICE AGREEMENT INCLUDING THESE TOS OR THE BREACH, TERMINATION, ENFORCEMENT, INTERPRETATION OR VALIDITY THEREOF, INCLUDING THE DETERMINATION OF THE SCOPE OR APPLICABILITY OF THIS AGREEMENT TO ARBITRATE, SHALL BE SUBJECT TO FINAL AND BINDING ARBITRATION GOVERNED BY THE FEDERAL ARBITRATION ACT (9 U.S.C. \xA7\xA7 1 ET SEQ.). THE ARBITRATION SHALL BE CONDUCTED BEFORE A SINGLE ARBITRATOR IN ACCORDANCE WITH THE JAMS STREAMLINED ARBITRATION RULES & PROCEDURES THAT ARE IN EFFECT AT THE TIME ARBITRATION IS INITIATED, AS MODIFIED BY THESE TOS. JUDGMENT ON THE AWARD MAY BE ENTERED IN ANY COURT HAVING JURISDICTION. THIS CLAUSE SHALL NOT PRECLUDE EITHER PARTY FROM SEEKING TEMPORARY OR PRELIMINARY INJUNCTIVE RELIEF IN CONNECTION WITH AN ARBITRABLE CONTROVERSY, BUT ONLY UPON THE GROUND THAT THE AWARD TO WHICH THAT PARTY MAY BE ENTITLED MAY BE RENDERED INEFFECTUAL WITHOUT SUCH PROVISIONAL RELIEF.</p><p><strong>19.2</strong> THIS AGREEMENT TO ARBITRATE SHALL NOT APPLY TO INTELLECTUAL PROPERTY CLAIMS BROUGHT BY UDT SOFTWARE, LLC OR CLAIMS BY ANY PARTY BROUGHT UNDER AND TO ENFORCE ANY ONE OR MORE OF THE FOLLOWING SECTIONS OF THESE TOS: 2.1; 3.1.2; 3.1.3; 3.2; 3.4.3(c), (d), or (e); 3.8; 3.9; 17 or, TO THE EXTENT APPLICABLE TO THE FOREGOING SECTIONS, 16.6.</p><p><strong>19.3</strong> THE PARTIES AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN AN INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF, CLASS MEMBER, OR PRIVATE ATTORNEY GENERAL IN ANY PURPORTED CLASS, REPRESENTATIVE, OR PRIVATE-ATTORNEY-GENERAL PROCEEDING. BY ENTERING INTO THESE TOS, YOU AND WE ARE EACH WAIVING THE RIGHT TO A JURY TRIAL OR TO PARTICIPATE IN A CLASS ACTION. THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON\u2019S CLAIM WITH YOUR CLAIMS OR OUR CLAIMS AND MAY NOT OTHERWISE PRESIDE OVER ANY REPRESENTATIVE, CLASS, OR PRIVATE-ATTORNEY-GENERAL PROCEEDING. THE ARBITRATOR MAY AWARD DECLARATORY OR INJUNCTIVE RELIEF ONLY IN FAVOR OF THE INDIVIDUAL PARTY SEEKING RELIEF AND ONLY TO THE EXTENT NECESSARY TO PROVIDE RELIEF WARRANTED BY THAT PARTY\u2019S INDIVIDUAL CLAIM, IN ADDITION TO REASONABLE ATTORNEYS\u2019 FEES AND COSTS.</p><p><strong>19.4</strong> Any part of this agreement to arbitrate that shall prove to be invalid, void, or illegal shall in no way affect, impair, or invalidate any other provision of these TOS to arbitrate, and such other provisions shall remain in full force and effect.</p><h3 class="heading">20. Amending Client Information; Assignability of these TOS; Assurances</h3><h4><strong>20.1</strong> <span class="text-underline">Amending Client Information</span>.</h4><p>If you are a Client, you are required to submit to us all information necessary to confirm yourself as the Client, and maintain the accuracy of such information, in a timely fashion, during the term of these TOS. You are also required to maintain the accuracy of all information associated with each Credential. We shall be entitled to rely on all information you submit to us under these TOS, including pursuant to Section 3.1 or this Section 20.1. If you contact us and assert that you have authority to act on behalf of a Client or any of its account(s) or data, you hereby agree to submit to us such written certifications, assurances (which may include a written opinion of your counsel identifying us as beneficiaries entitled to rely on such opinion), instruments or judicial process as we, in our sole discretion, may request.</p><h4><strong>20.2</strong> <span class="text-underline">Assignments</span>.</h4><p>The Service Agreement, including these TOS, may be transferred in its entirety by a Client in connection with the sale, transfer or reorganization of all or substantially all of the practice or business to which the Service Agreement relates; <span class="text-underline">provided that</span> each of the following conditions are satisfied in full: (a) an authorized representative of the transferor or transferee notifies us in writing of the transfer, the legal name of the transferee, and date of transfer; (b) the transferor or transferee submits to us such written certifications, assurances (which may include a written opinion of your counsel identifying us as beneficiaries entitled to rely on such opinion) or instruments as we, in our sole discretion, may request; and (c) we are satisfied, in our sole discretion, of the validity of the certifications, assurances or instruments submitted pursuant to clause (b). Upon our recognition of a transfer by a Client, the Administrative Rights and all User accounts of such Client\u2019s Authorized Workforce shall automatically transfer to such Client\u2019s recognized transferee. Except as expressly set forth in this Section 20.2, you may not assign or transfer the Service Agreement, including these TOS, in whole or in part, without the prior written consent of UDT Software, LLC\u2019s CEO, which may be withheld at our sole discretion. We may freely assign the Service Agreement, including these TOS in connection with a merger, acquisition, or sale of assets, or by operation of law or otherwise. In the event that the Service Agreement is assigned or transferred by a Client in accordance with this Section 20.2, we may in our sole discretion update the Service Agreement to the pricing on our most recent Price List as of the date of such assignment or transfer.</p><h4><strong>20.3</strong> <span class="text-underline">Assurances</span>.</h4><p>By requesting or directing us to take any action described in Section 20.1 or Section 20.2 with respect to any Client or any account(s) or data held by such account(s), you represent and warrant that (i) you have the authority to act on such Client\u2019s behalf or to control such account(s) or data, and (ii) your request or direction is not in furtherance of any purpose or action that would violate any provision of these TOS, applicable law or the rights of any person or entity. YOU HEREBY WAIVE AND UNCONDITIONALLY RELEASE US, OUR AFFILIATES, AND OUR AND THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES AND AGENTS, FROM ANY AND ALL CLAIMS, DEMANDS, DAMAGES, DEBTS, LIABILITIES, EXPENSES, ACTIONS AND CAUSES OF ACTIONS OF EVERY KIND AND NATURE, WHETHER NOW KNOWN OR UNKNOWN, ARISING OUT OF OR IN CONNECTION WITH ANY ACTION WE TAKE OR DO NOT TAKE IN RESPONSE TO ANY REQUEST, DIRECTION, INFORMATION, CERTIFICATION, ASSURANCE OR INSTRUMENTS WE RECEIVE FROM YOU IN ACCORDANCE WITH SECTION 20.1 OR SECTION 20.2. ACCORDINGLY, YOU AGREE TO WAIVE THE BENEFIT OF ANY LAW, INCLUDING, TO THE EXTENT APPLICABLE, CALIFORNIA CIVIL CODE \xA7 1542 (OR SIMILAR PROVISIONS OF THE LAWS OF OTHER STATES), WHICH STATES.</p><p>A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR.</p><p>You hereby agree to indemnify, defend, and hold harmless us and other users, and our and their respective affiliates, officers, directors, employees and agents, from and against any claim, cost or liability, including reasonable attorneys\u2019 fees arising from: (a) any action we take in reliance on any information, certification, assurance or instrument you provide to us, or (b) any action we take that complies with any request or direction you at any time make or made.</p><h3 class="heading">21. Force Majeure</h3><p>No party to the Service Agreement, including these TOS, shall be deemed in violation if it is prevented from performing any of its the obligations thereunder by reason of: (a) severe weather and storms; (b) earthquakes or other natural occurrences; (c) strikes or other labor unrest; (d) power failures; (e) nuclear or other civil or military emergencies; (f) acts of legislative, judicial, executive, or administrative authorities; or (g) any other circumstances that are not within its reasonable control.</p><h3 class="heading">22. Severability</h3><p>Any provision of the Service Agreement, including these TOS that shall prove to be invalid, void, or illegal, shall in no way affect, impair, or invalidate any other provision of the Service Agreement. Such other provisions shall remain in full force and effect and the unenforceable term or provision shall be replaced by such enforceable term or provision as comes closest to the intention underlying the unenforceable term or provision.</p><h3 class="heading">23. Notices</h3><p>Any and all notices required or permitted under these TOS shall be sent by United States mail or fax transmission to the address provided below or to such other and different addresses as the Parties may designate in writing. If you supply us with an electronic mail address, we may give notice by email message addressed to such address; provided that if we receive notice that the email message was not delivered, we will give the notice by United States mail or fax.</p><address>To us:<br>UDT Software, LLC.<br>Attention: Chief Executive Officer<br>444 West Boynton Beach Blvd<br>Boynton Beach, FL 33435</address><p>To you, at the current contact information on file with us at the time notice is given.</p><h3 class="heading">24. No Third-Party Beneficiaries</h3><p>Except as expressly provided for in Sections 2.2, 3.15, 14 and 20.3, nothing express or implied in the Service Agreement, including these TOS, is intended to confer, nor shall confer, upon any person or entity other than the parties and their respective successors or assigns any rights, remedies, obligations, or liabilities whatsoever.</p><h3 class="heading">25. Electronics Transactions</h3><p>The Service gives you the ability to enter into agreements, authorizations, consents and applications; make referrals; order lab tests; prescribe medications; or engage in others transactions electronically. YOU ACKNOWLEDGE THAT YOUR ELECTRONIC SUBMISSIONS VIA THE SERVICES IN CONNECTION WITH SUCH ACTIVITIES CONSTITUTE YOUR ACKNOWLEDGMENT THEREOF AND YOUR AGREEMENT AND INTENT TO BE BOUND BY SUCH AGREEMENTS AND TRANSACTIONS, AND APPLIES TO ALL RECORDS RELATING TO SUCH TRANSACTIONS. You represent and warrant that you have the authority to take such actions.</p><h3 class="heading">26. Privacy Policy</h3><p>The Service is provided by us under these TOS on our website UDT Software, LLCemr.com Your use of our Service is subject to our Privacy Policy. By using the Service, you are consenting to the terms of the Privacy Policy and acknowledge that you have reviewed our Privacy Policy.</p>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Change Password for {{vm.account.login}}</h4></div><div class="modal-body"><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label for="password"><strong>New Password:</strong></label> <input type="password" class="form-control" id="password" name="password" placeholder="Type new password..." required ng-model="vm.password" ng-minlength="4" ng-maxlength="50"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword"><strong>New password confirmation:</strong></label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="form-group"><button type="submit" class="btn btn-success btn-block" ng-disabled="form.$invalid">Save</button></div></form></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/account/password/password.html','<section class="content"><div class="row"><div class="col-md-12"><!-- TABLE: LATEST ORDERS --><div class="box box-info"><div class="box-body"><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div></div><!-- /.box --></div></div></section><!-- /.content -->');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label> <input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p><div class="alert alert-warning">If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<!-- Content Header (Page header) --><section class="content-header"><h1>Settings</h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><div class="row"><div class="col-md-12"><!-- TABLE: LATEST ORDERS --><div class="box box-info"><div class="box-body"><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label> <input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label> <input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div></div><!-- /.box --></div></div></section><!-- /.content -->');
$templateCache.put('app/account/signature/signature-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">You can <strong>Replace</strong> your signature.</h4></div><div class="modal-body"><form name="vm.signatureForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><ods-signature ng-model="vm.signature" options="vm.signatureOpts" name="custom_signature"></ods-signature></div></div></div></form></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-disabled="vm.isSaving || vm.signature.length === 0" ng-click="vm.replaceSignature()"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/admin/audits/audits.html','<!-- Content Header (Page header) --><section class="content-header"><h1>Audits</h1><div ncy-breadcrumb></div></section><!-- Main content --><section class="content"><div class="row"><div class="col-md-12"><!-- TABLE: LATEST ORDERS --><div class="box"><div class="box-body"><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><ul uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></ul></div></div><!-- /.box-body --><div class="box-footer clearfix"><!--<a href="javascript:void(0)" class="btn btn-sm btn-info btn-flat pull-left">Place New Order</a>--><!--<a href="javascript:void(0)" class="btn btn-sm btn-default btn-flat pull-right">View All--><!--Orders</a>--></div><!-- /.box-footer --></div><!-- /.box --></div></div></section><!-- /.content -->');
$templateCache.put('app/admin/configuration/configuration.html','<section class="content-header"><h1>Configuration</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><div class="table-responsive"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/docs/docs.html','<section class="content"><div class="row"><div class="col-xs-12"><div class="box-body"><iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe></div></div></div></section>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span>Cancel</span></button> <button type="submit" class="btn btn-danger" ng-click="vm.confirmReindex()"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span>Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<section class="content-header" style="margin-right: 250px"><div class="clearfix"><h1>Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p>This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p>This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span>Go</span></button></div></section>');
$templateCache.put('app/admin/entity-audit/entity-audit.detail.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Audit Details</h4></div><div class="modal-body pad"><div><strong>{{vm.audit.action}} action was performed on below data</strong><br><br><del class="diff diff-key">Old/Removed value</del> &nbsp; <ins class="diff diff-key">New/Added value</ins></div><br><label>Changed Fields</label><pre id="resultChanges" ng-bind-html="vm.diffValueChanges"></pre><label>All Fields</label><pre id="result" ng-bind-html="vm.diffValue"></pre></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/entity-audit/entity-audits.html','<div ng-cloak class="pad"><div class="row"><h3 class="col-sm-10">Entity Audits</h3><!--<div class="col-lg-2">--><!--<button class="btn btn-primary pull-right" ng-click="vm.updateToNewField()">--><!--<i class="glyphicon glyphicon-cog"></i>&nbsp;Update to new Field--><!--</button>--><!--</div>--></div><jhi-alert></jhi-alert><div class="row"><div class="col-md-12 pad"><h4>Filter</h4><form name="auditForm" role="form" novalidate show-validation><div class="row"><div class="col-md-8 form-group"><label>Entity/Table</label> <select class="input-sm form-control" name="qualifiedName" id="qualifiedName" required ng-options="vm.getEntityName(entity) for entity in vm.entities" ng-model="vm.qualifiedName"></select><div ng-show="auditForm.qualifiedName.$invalid"><p class="help-block" ng-show="auditForm.qualifiedName.$error.required">This field is required</p></div></div><div class="col-md-4 form-group"><label>Limit to</label> <select class="input-sm form-control" name="limit" id="limit" required ng-options="option for option in vm.limits" ng-model="vm.limit"></select></div></div><div class="row pad"><button ng-disabled="auditForm.$invalid" class="btn btn-primary pull-right" ng-click="vm.loadChanges()"><i class="glyphicon glyphicon-import"></i>&nbsp;Load Change List</button></div></form></div></div><div ng-show="!vm.loading"><div class="table-responsive" ng-if="vm.audits.length > 0"><p ng-if="vm.qualifiedName">Last <strong>{{vm.limit}}</strong> Changes for <strong>{{vm.getEntityName(vm.qualifiedName)}}</strong></p><form class="form-inline"><div class="form-group"><label for="searchField">Filter:</label> <input type="text" class="form-control" id="searchField" ng-model="filter.$" placeholder="global filter"></div><div class="form-group"><input type="text" class="form-control" id="searchFieldEntityId" ng-model="filter.entityId" placeholder="entity id filter"></div></form><table class="table table-bordered table-hover table-striped"><thead><tr><th>Entity Id</th><th>Action</th><th>Version</th><th>Value</th><th>Modified Date</th><th>Modified By</th><th><i class="glyphicon glyphicon-eye-open"></i></th></tr></thead><tbody><tr ng-repeat="audit in vm.audits | filter:filter"><td>{{audit.entityId}}</td><td>{{audit.action}}</td><td>{{audit.commitVersion}}</td><td><pre class="audit-obj" ng-bind-html="vm.format(audit.entityValue)"></pre></td><!-- comment above line and uncomment below to have Table view of value --><!--td class="no-pad">\n                        <div class="audit-obj">\n                            <table class="table table-bordered table-hover no-margin">\n                                <tr>\n                                    <th>Field</th>\n                                    <th>Value</th>\n                                </tr>\n                                <tr ng-repeat="(k,v) in audit.entityValue" ng-if="!vm.isObject(v)">\n                                    <td>{{k}}</td>\n                                    <td>\n                                        <span ng-if="vm.isDate(k)">{{v | date:\'medium\'}}</span>\n                                        <span ng-if="!vm.isDate(k)">{{v}}</span>\n                                    </td>\n                                </tr>\n                            </table>\n                        </div>\n                    </td--><td>{{audit.modifiedDate | date:\'medium\'}}</td><td>{{audit.modifiedBy}}</td><td><button type="button" ng-click="vm.openChange(audit)" uib-tooltip="View Audit Change Details" uib-tooltip-placement="auto" class="btn btn-info btn-xs"><i class="glyphicon glyphicon-eye-open"></i></button></td></tr></tbody></table></div><p ng-if="vm.displayedChanges.length == 0">No Data found for the filters</p></div></div>');
$templateCache.put('app/admin/health/health.html','<section class="content-header"><h1>Health Checks</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><div class="table-responsive"><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<section class="content-header"><h1>Logs</h1><small>There are {{ vm.loggers.length }} loggers.</small><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><span>Filter</span> <input type="text" ng-model="filter" class="form-control"></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/metrics/metrics.html','<section class="content-header"><h1>Application Metrics</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-header"><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3>Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Objects</th><th class="text-right">Hits</th><th class="text-right">Misses</th><th class="text-right">Eviction count</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td></tr></tbody></table></div></div></div></div></div><div class="box-body"><div class="dataTables_wrapper form-inline dt-bootstrap"><div class="row"><div class="col-sm-6"></div><div class="col-sm-6"></div></div><div class="row"><div class="col-sm-12"><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/components/assistant/assistant-clipboard.html','<div class="assistant-wrapper"><a href="" class="clipboard-toggle" id="clipboard-toggle" uib-tooltip="Toggle Assistant" tooltip-placement="left"><span class="dots"></span> <span class="spin red"></span> <span class="spin yellow"></span> <span class="spin aqua"></span> <span class="spin green"></span></a><div class="list-unstyled clipboard-content"><div class="heading">Assistant Menu</div><div class="search-tool"><div class="input-group"><input type="text" class="form-control" placeholder="Search for..." ng-model="query"> <span class="input-group-btn"><button type="button" class="btn btn-success"><i class="fa fa-search"></i></button></span></div></div><div class="clip-grid well mb-0"><div class="item" ng-repeat="item in model | filter: query"><a href="" class="trigger" uib-tooltip="{{item.name}}" ng-click="copy(item)"><span class="icon"><i class="fa fa-angle-right" aria-hidden="true"></i></span> <span class="title">{{item.name}}</span> </a><span class="text" uib-tooltip="{{item.note}}"><i class="fa fa-file-text" aria-hidden="true"></i></span></div></div></div></div>');
$templateCache.put('app/components/confirmation/confirmation.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.config.title}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text" ng-bind-html="vm.config.message"></p></div><div class="modal-footer"><button class="{{vm.config.leftAction.color}}" style="margin-right: auto" type="button" ng-if="vm.config.leftAction" ng-click="vm.close(action.value)"><i class="{{vm.config.leftAction.icon}}" aria-hidden="true"></i> {{vm.config.leftAction.name}}</button> <button ng-repeat="action in vm.config.actions" class="{{action.color}}" type="button" ng-click="action.value === \'CANCEL\' ? vm.clear() : vm.close(action.value)"><i class="{{action.icon}}" aria-hidden="true"></i> {{action.name}}</button></div>');
$templateCache.put('app/components/delete-entity-dialog/delete-entity-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete {{vm.entity}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this {{vm.entity}} from the database. Are you sure you want to <strong>delete</strong> this {{vm.entity}}?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/components/generic-entity-datatable/generic-entity-datatable-action.tpl.html','<div ng-switch="actionGroup.type"><button ng-switch-when="group" type="button" class="btn btn-default" title="{{button.title}}" ng-repeat="button in actionGroup.buttons" ng-class="button.ngClass(filter)" ng-disabled="(button.disabledOnEmpty && !isSelected()) || (button.disabled && button.disabled(filter))" ng-click="executeAction(button)" ng-if="button.ngIf ? button.ngIf(filter) : true"><i class="{{button.iClass}}" aria-hidden="true"></i> <span class="hidden-xs">{{button.name}}</span></button><div ng-switch-when="split" class="btn-group" uib-dropdown style="display: flex"><button id="split-button" type="button" class="btn btn-success" ng-repeat="(index, button) in actionGroup.buttons" ng-class="button.ngClass(filter)" ng-disabled="button.disabledOnEmpty && !isSelected()" ng-click="executeAction(button)" ng-if="index === 0"><i class="{{button.iClass}}" aria-hidden="true"></i> <span class="hidden-xs">{{button.name}}</span></button> <button type="button" class="btn btn-success" uib-dropdown-toggle><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="split-button" ng-repeat="(index, button) in actionGroup.buttons" ng-if="index !== 0"><li role="menuitem"><a ng-click="executeAction(button)" ng-disabled="button.disabledOnEmpty !== undefined && isSelected()" ng-if="button.ngIf ? button.ngIf() : true"><i class="{{button.iClass}}" aria-hidden="true"></i> {{button.name}}</a></li></ul></div></div>');
$templateCache.put('app/components/generic-entity-datatable/generic-entity-datatable.tpl.html','<section class="content no-padding"><div class="content-heading"><div class="filters-box" style="position: relative; margin: 0 auto 0 0;"><div class="btn-group" ng-repeat="actionGroup in descriptor.leftActions"><ng-include src="\'app/components/generic-entity-datatable/generic-entity-datatable-action.tpl.html\'"></ng-include></div></div><div class="input-group"><input type="text" class="form-control" id="searchQuerysignature" style="min-width: 150px;" placeholder="Search..." ng-model="filter.searchQuery" ng-change="search()" ng-model-options="{ debounce: 500 }" ng-if="enableSearch"> <i class="fa fa-search form-control-feedback"></i> <span class="input-group-btn width-min" uib-dropdown ng-show="visibleFilterDescriptors && visibleFilterDescriptors.length > 0" auto-close="outsideClick"><button class="btn" ng-class="isFilterActive() ? \'btn-warning\' : \'btn-default\'" uib-dropdown-toggle><i class="fa fa-filter" aria-hidden="true"></i> <span class="caret"></span></button><div class="dropdown-menu dropdown-filters-menu" uib-dropdown-menu><form class="form filters-form" role="form"><div class="row"><div ng-repeat="filterDescriptor in visibleFilterDescriptors" ng-switch="filterDescriptor.type"><div ng-switch-when="string" class="form-group" ng-class="filterDescriptor.ngClass ? filterDescriptor.ngClass : \'col-xs-6 col-sm-6 col-md-6 col-lg-6\'"><label ng-if="filterDescriptor.title">{{filterDescriptor.title}}</label> <input type="text" class="form-control" ng-change="filter[filterDescriptor.name] = filter[filterDescriptor.name] === \'\' ? null : filter[filterDescriptor.name]" placeholder="{{filterDescriptor.placeholder}}" ng-model="filter[filterDescriptor.name]" ng-model-options="{ debounce: 500 }"></div><div ng-switch-when="number" class="form-group" ng-class="filterDescriptor.ngClass ? filterDescriptor.ngClass : \'col-xs-6 col-sm-6 col-md-6 col-lg-6\'"><label ng-if="filterDescriptor.title">{{filterDescriptor.title}}</label> <input type="number" class="form-control" ng-change="filter[filterDescriptor.name] = filter[filterDescriptor.name] === \'\' ? null : filter[filterDescriptor.name]" placeholder="{{filterDescriptor.placeholder}}" ng-model="filter[filterDescriptor.name]" min="0" ng-model-options="{ debounce: 500 }"></div><div ng-switch-when="date" class="form-group" ng-class="filterDescriptor.ngClass ? filterDescriptor.ngClass : \'col-xs-6 col-sm-6 col-md-6 col-lg-6\'"><label ng-if="filterDescriptor.title">{{filterDescriptor.title}}</label><div class="input-group"><input type="text" class="form-control" placeholder="{{filterDescriptor.placeholder}}" name="{{ filterDescriptor.name }}" ng-model="filter[filterDescriptor.name]" uib-datepicker-popup="{{filterDescriptor.format}}" is-open="datePickerOpenStatus[filterDescriptor.name]"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openCalendar(filterDescriptor.name)"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div ng-switch-when="select" style="" class="form-group" ng-class="filterDescriptor.ngClass ? filterDescriptor.ngClass : \'col-xs-6 col-sm-6 col-md-6 col-lg-6\'"><label ng-if="filterDescriptor.title">{{filterDescriptor.title}}</label><ui-select id="{{ filterDescriptor.name }}" name="{{ filterDescriptor.name }}" reset-search-input="true" ng-model="filter[filterDescriptor.name]" title="{{filterDescriptor.placeholder}}"><ui-select-match allow-clear="true" placeholder="{{filterDescriptor.placeholder}}">{{filterDescriptor.getDisplayValue($select.selected)}}</ui-select-match><ui-select-choices repeat="item in filterDescriptor.values | filter: $select.search" refresh="filterDescriptor.refresh($select.search, filterDescriptor.values)" refresh-delay="600"><div ng-bind-html="filterDescriptor.getDisplayValue(item)"></div><small ng-if="filterDescriptor.getSmallDisplayValue" ng-bind-html="filterDescriptor.getSmallDisplayValue(item)"></small></ui-select-choices></ui-select></div></div></div><hr style="margin-top: 0px"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><button type="button" class="btn btn-warning btn-block" ng-click="search()"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><button type="button" class="btn btn-danger btn-block" ng-click="clearFilter()"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form></div></span></div><div class="filters-box"><div class="btn-group" ng-repeat="actionGroup in descriptor.actions"><ng-include src="\'app/components/generic-entity-datatable/generic-entity-datatable-action.tpl.html\'"></ng-include></div></div><span class="input-group-btn width-min" uib-dropdown ng-show="visibleFilterDescriptors && visibleFilterDescriptors.length > 0 && getRmDatePicker()" auto-close="outsideClick"><button class="btn btn-default" uib-dropdown-toggle title="Calendar"><i class="fa fa-calendar" aria-hidden="true"></i></button><div class="dropdown-menu dropdown-calendar-menu" uib-dropdown-menu><form class="form filters-form" role="form"><div class="row"><div ng-repeat="filterDescriptor in visibleFilterDescriptors | filter: {type: \'rm2-datepicker\'}" ng-switch="filterDescriptor.type"><div ng-switch-when="rm2-datepicker" class="calendar-box" ng-class="filterDescriptor.ngClass ? filterDescriptor.ngClass : \'col-xs-6 col-sm-6 col-md-6 col-lg-6\'"><div rm2-datepicker ng-model="filter[filterDescriptor.name]" rm-config="filterDescriptor.rmConfig" ng-click="search()"></div></div></div></div></form></div></span><button type="button" class="btn btn-success" title="New {{descriptor.entityClassHumanized}}" ng-if="newAction" ui-sref="{{descriptor.entityStateName}}.new"><i class="fa fa-plus-circle" aria-hidden="true"></i> <span class="hidden-xs" ng-if="descriptor.newButtonTitle">{{descriptor.newButtonTitle}}</span></button></div><div class="box box-customized datatable-no-padding" style="background-color: #fff; padding: 20px; margin-bottom: 0;"><h2 class="head-text" style="margin-top: 5px" ng-if="descriptor.title">{{descriptor.title}}</h2><div class="table-responsive" ng-if="dtOptions && dtColumns && dtInstance"><table class="table table-hover table-striped table-condensed table-bordered" style="margin: 0; padding: 10px" datatable="" dt-options="dtOptions" dt-columns="dtColumns" dt-instance="dtInstanceCallback"></table></div></div></section>');
$templateCache.put('app/components/header-datatable/header-datatable.tpl.html','<div class="box-header with-border"><div class="navbar-form navbar-left" style="margin-left: -15px;"><div ng-transclude></div></div><div class="navbar-form navbar-right search-control"><div class="text-right"><div class="has-feedback input-group-sm"><input type="text" class="form-control" ng-model="vm.searchQuery" size="80" id="searchQueryrpt-metadata" placeholder="Query" ng-change="vm.search()"> <i class="fa fa-search form-control-feedback"></i></div></div></div></div>');
$templateCache.put('app/components/pagination/pagination.html','<div><ul class="pagination"><li class="page-item" ng-class="{disabled: noPrevious()}"><a class="page-link" ng-click="selectPrevious()"><i class="fa fa-angle-double-left"></i></a></li><li class="page-item" ng-repeat="page in pages" ng-class="{active: isActive(page)}"><a class="page-link" ng-click="selectPage(page)">{{page}}</a></li><li class="page-item" ng-class="{disabled: noNext()}"><a class="page-link" ng-click="selectNext()"><i class="fa fa-angle-double-right"></i></a></li></ul></div>');
$templateCache.put('app/components/tpl/breadcrumb.tpl.html','<ul class="breadcrumb"><li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract"><a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}"><i data-ng-show="$index===0" class="fa fa-home"></i>{{step.ncyBreadcrumbLabel}} </a><span ng-switch-when="true">{{step.ncyBreadcrumbLabel}}</span></li></ul>');
$templateCache.put('app/components/tpl/save-information.html','<div class="pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-click="vm.save()" ng-show="!vm.editing" ng-disabled="vm.form.formAllOrders_data.$invalid">Save Information</button></div></div>');
$templateCache.put('app/components/tpl/spinner-sm.html','<div class="spinner-layer sm"><div class="spinner-rings sm"></div></div>');
$templateCache.put('app/components/tpl/spinner.html','<div class="spinner-layer"><div class="spinner-rings"></div></div>');
$templateCache.put('app/components/udt/j-signature.html','<div class="row block-mb5"><div class="col-lg-12"><input type="hidden" name="signatureAction" ng-model="ngModel" ng-if="validators" validator="{{validators}}" message-id="{{messageContainer}}"><div id="{{jSignatureId}}" class="j-signature-pad"></div><button type="button" class="btn btn-sm btn-danger" ng-click="reset()"><span class="glyphicon glyphicon-erase"></span> <span>Clear</span></button></div></div>');
$templateCache.put('app/dashboard2/bht/bht-dashboard.html','<section class="content"><!-- Jesus Code --><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 bht-dashboard"><div class="bht-card incoming-patients"><div ui-view="incoming-patients"></div></div><div class="bht-card discharging-patients"><div ui-view="discharging-patients"></div></div><div class="bht-card beds"><div ui-view="beds"></div></div><div class="bht-card patient-requisition"><div ui-view="print-requisition"></div></div><div class="bht-card empty-care-delivery"><div ui-view="empty-care-delivery-patient"></div></div><div class="bht-card care-delivery-pending-patient"><div ui-view="pending-by-patients"></div></div><div class="bht-card care-delivery-pending-staff"><div ui-view="pending-by-staff"></div></div><div class="bht-card care-delivery-pending-review"><div ui-view="pending-by-staff-review"></div></div><!--            <div class="bht-card critical-results">--><!--                <div ui-view="critical-results"></div>--><!--            </div>--><!--            <div class="bht-card abnormal-results">--><!--                <div ui-view="abnormal-result"></div>--><!--            </div>--><!--            <div class="bht-card partial-results">--><!--                <div ui-view="partial-result"></div>--><!--            </div>--><!--            <div class="bht-card unassigned-results">--><!--                <div ui-view="unassigned-results"></div>--><!--            </div>--><!--            <div class="bht-card concurrent-reviews">--><!--                <div ui-view="concurrent-reviews"></div>--><!--            </div>--><!--            <div class="bht-card late-care-delivery">--><!--                <div ui-view="late-care-delivery"></div>--><!--            </div>--><!--            <div class="bht-card stay">--><!--                <div ui-view="stay"></div>--><!--            </div>--><!--            --><!--            <div class="bht-card care-delivery-pending-review">--><!--                <div ui-view="pending-by-staff-review"></div>--><!--            </div>--><!--            &lt;!&ndash;<div class="bht-card mars-mors">&ndash;&gt;--><!--                &lt;!&ndash;<div ui-view="mars-mors"></div>&ndash;&gt;--><!--            &lt;!&ndash;</div>&ndash;&gt;--><!--            <div class="bht-card payer-mix">--><!--                <div ui-view="payer-mix"></div>--><!--            </div>--><!--            <div class="bht-card chart-alerts">--><!--                <div ui-view="chart-review"></div>--><!--            </div>--><!--            &lt;!&ndash;--><!--            <div class="bht-card physician-review">--><!--                <div ui-view="physician-review"></div>--><!--            </div>--><!--            &ndash;&gt;--><!--            <div class="bht-card discharge-type">--><!--                <div ui-view="discharge-type"></div>--><!--            </div>--><!--            &lt;!&ndash;--><!--            <div class="bht-card incident-reports">--><!--                <div ui-view="incident-report"></div>--><!--            </div>--><!--            &ndash;&gt;--><!--            <div class="bht-card level-cares">--><!--                <div ui-view="level-care"></div>--><!--            </div>--><!--            <div class="bht-card marketers">--><!--                <div ui-view="marketers"></div>--><!--            </div>--><!--            <div class="bht-card referral-source">--><!--                <div ui-view="referral-source"></div>--><!--            </div>--><!--            <div class="bht-card case-load">--><!--                <div ui-view="case-load"></div>--><!--            </div>--></div></div><!-- /Jesus Code --></section>');
$templateCache.put('app/dashboard2/empty/dashboard-empty.html','');
$templateCache.put('app/entities/appointment-encounter/appointment-encounter.html','<section class="content no-padding"><div class="appointment-encounter-layout"><header class="content-heading"><button type="button" class="btn btn-default btn-sm"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Sign Provider</button> <button type="button" class="btn btn-default btn-sm"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Sign Patient</button> <a href="" class="btn-side-view" ng-class="{\'active\': vm.sideBySide}" ng-click="vm.toggleSideBySide()"><i class="fa fa-columns" aria-hidden="true"></i></a><div class="side-options" ng-if="vm.sideBySide"><h4 class="mt-0 text-center"><strong>Choose Previous Encounter</strong></h4><ul class="list-unstyled"><li><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..."> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></li><li><div class="radio"><label><input type="radio" name="formsRadio" value="form1"> Lorem Ipsum Form name</label></div></li><li><div class="radio"><label><input type="radio" name="formsRadio" value="form2"> LUbi est bi-color extum.</label></div></li><li><div class="radio"><label><input type="radio" name="formsRadio" value="form3"> Ubi est altus abaculus.</label></div></li><li><div class="radio"><label><input type="radio" name="formsRadio" value="form4"> Bromium, burgus, et gemna.</label></div></li><li><div class="radio disabled"><label><input type="radio" name="formsRadio" value="form5" disabled="disabled"> Est barbatus brabeuta, cesaris.</label></div></li><li><div class="radio"><label><input type="radio" name="formsRadio" value="form6"> Est nobilis calceus, cesaris.</label></div></li></ul><footer class="footer"><button type="button" class="btn btn-success btn-sm" ng-click="vm.openSideBySide()"><i class="fa fa-check-circle" aria-hidden="true"></i> Apply</button> <button type="button" class="btn btn-danger btn-sm"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></footer></div></header><div class="content-grid"><aside class="content-side" resizable r-directions="[\'right\']" r-flex="true"><section class="data-section with-pic"><div class="photo"><img src="content/images/avatar.png" alt="Opportunity Photo" class="img-thumbnail img-responsive"></div><div class="info"><h4 class="name mt-0">Teodor Smithwetsong</h4><p><strong>DOB:</strong> 20/20/2020</p><p><strong>Mr#:</strong> 2019-234</p><p><strong>P. Method:</strong> Private Pay</p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Diagnosis</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0"><strong>F11.2</strong> - <span>Opium dependency severe lorem ipsum dollor sit amet.</span></p><p class="mb-0"><strong>F12.1</strong> - <span>Opium dependency severe.</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Chief Complaint</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Allergies:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 inline-list"><span>Aspirin</span> <span>Lorem Medicum</span> <span>Benadrylmiun</span> <span>LoremIpsumAspertum</span> <span>Aspirin</span> <span>Lorem Medicum</span> <span>Benadrylmiun</span> <span>LoremIpsumAspertum</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Current Medications:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 inline-list"><span>Aspirin</span> <span>Lorem Medicum</span> <span>Benadrylmiun</span> <span>LoremIpsumAspertum</span> <span>Aspirin</span> <span>Lorem Medicum</span> <span>Benadrylmiun</span> <span>LoremIpsumAspertum</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Vitals:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>01/02/2021 13:00 PM</strong> -</p><p class="mb-0 inline-list"><span><strong>BP</strong> - 136/93</span> <span><strong>Temp:</strong> - 96.6<sup>o</sup>F</span> <span><strong>Pul:</strong> - 93</span> <span><strong>Resp:</strong> - 18</span> <span><strong>0<sup>2</sup></strong> - 18</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Glucose:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>01/02/2021 13:00 PM</strong> -</p><p class="mb-0 inline-list"><span><strong>Reading</strong> - 0.93</span> <span><strong>Type of Check:</strong> - Blood Check</span> <span><strong>Interventions:</strong> - Check in two hours</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Weight:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>01/02/2021 13:00 PM</strong> -</p><p class="mb-0 inline-list"><span><strong>Weight (Lb)</strong> - 160</span> <span><strong>Height (ft & in):</strong> - 5\' - 3\'\'</span> <span><strong>BMI:</strong> - 28.34</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Latest Lab Results:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0"><span><strong>HIV I</strong> - Positive</span> <span><strong>HIV II</strong> - Positive</span> <span><strong>Flu</strong> - Negative</span> <span><strong>HEP C</strong> - Positive</span></p></div></section></aside><div class="content-area"><a href="" class="form-btn previous" uib-tooltip="Previous Form" tooltip-placement="left-top"><i class="fa fa-chevron-left" aria-hidden="true"></i></a><div class="side-form" resizable r-directions="[\'right\']" r-flex="true" ng-if="vm.sideForm"><header class="header-form"><span class="title">- H & P Form</span> <span class="label label-danger" ng-if="vm.formIdentical">Identical Form</span> <a href="" class="close-side" ng-click="vm.sideForm = !vm.sideForm"><i class="fa fa-times-circle" aria-hidden="true"></i></a></header><a href="" class="btn-copy-all" ng-if="!vm.formIdentical"><i class="fa fa-angle-double-right"></i> </a><a href="" class="btn-copy-all identical" ng-if="vm.formIdentical"><i class="fa fa-exclamation" aria-hidden="true"></i></a></div><div class="main-form"><header class="header-form"><span class="title" uib-tooltip="Lorem New Form Ubernots Casuement">- Lorem New Form Ubernots Casuement</span><div class="forms-counter"><uib-progressbar max="13" value="5"><span style="color:white; white-space:nowrap;">5/13</span></uib-progressbar></div><a href="" class="steps-selector" ng-class="{\'active\': vm.openStepSelector}" ng-click="vm.toggleStepSelector()"><i class="fa fa-list-alt" aria-hidden="true"></i></a></header><div class="steps-list" ng-if="vm.openStepSelector"><ul class="list-unstyled"><li class="have-list"><h4 class="header-text">Header Text Lorem</h4><ul class="list-unstyled"><li><span class="status current"><i class="fa fa-arrow-circle-right" aria-hidden="true"></i></span> <span class="text">Step name ipsum dollor sit amet</span> <a href="" class="remove-step"><i class="fa fa-times"></i></a></li><li><span class="status done"><i class="fa fa-check-circle" aria-hidden="true"></i></span> <span class="text">Fortis de fidelis nixus, visum scutum!</span> <a href="" class="remove-step"><i class="fa fa-times"></i></a></li><li><span class="status inreview"><i class="fa fa-exclamation-circle" aria-hidden="true"></i></span> <span class="text">Dexter luna absolute attrahendams bulla est.</span> <a href="" class="remove-step"><i class="fa fa-times"></i></a></li><li><span class="status pending"><i class="fa fa-info-circle" aria-hidden="true"></i></span> <span class="text">Fortis de fidelis nixus, visum scutum!</span> <a href="" class="remove-step"><i class="fa fa-times"></i></a></li></ul></li><li class="divider"></li><li><button type="button" class="btn btn-success btn-block"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Form</button></li></ul></div><div ui-view="super-bill" class="form-container"></div></div><a href="" class="form-btn next" uib-tooltip="Next Form" tooltip-placement="left-top"><i class="fa fa-chevron-right" aria-hidden="true"></i></a></div></div></div></section>');
$templateCache.put('app/entities/appointment-type/appointment-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.appointmentType.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Appointment Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Appointment Type from the database. Are you sure you want to <strong>remove</strong> this Appointment Type?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/appointment-type/appointment-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAppointmentTypeLabel">Create or edit a Appointment Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.appointmentType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.appointmentType.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.appointmentType.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.appointmentType.name"> <span class="help-block" ng-show="!vm.appointmentType.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/appointment-type/appointment-types.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/appointments/appointments-new-dialog.html','<form action=""><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create Appointment</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><uib-tabset active="0" justified="true" id="appointmentsNew" class="simple-tabs"><uib-tab index="0" heading="Patient"><ng-include src="\'app/entities/appointments/tabs/appointment-patient-tab.html\'"></ng-include></uib-tab><uib-tab index="1" heading="Block Time"><ng-include src="\'app/entities/appointments/tabs/appointment-blocktime-tab.html\'"></ng-include></uib-tab></uib-tabset></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/appointments/appointments.html','<section class="content pt-0"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="appointments-header"><div class="filters"><button type="button" class="btn btn-default btn-sm" ng-model="vm.appointmentFilters.inLobby" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><span class="fa-stack"><i class="fa fa-square fa-stack-2x lightgreen" aria-hidden="true"></i> <i class="fa fa-check fa-stack-1x" aria-hidden="true" ng-if="vm.appointmentFilters.inLobby"></i> </span>In Lobby</button> <button type="button" class="btn btn-default btn-sm" ng-model="vm.appointmentFilters.inRoom" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><span class="fa-stack"><i class="fa fa-square fa-stack-2x orange" aria-hidden="true"></i> <i class="fa fa-check fa-stack-1x" aria-hidden="true" ng-if="vm.appointmentFilters.inRoom"></i> </span>In Room</button> <button type="button" class="btn btn-default btn-sm" ng-model="vm.appointmentFilters.cancelled" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><span class="fa-stack"><i class="fa fa-square fa-stack-2x red" aria-hidden="true"></i> <i class="fa fa-check fa-stack-1x" aria-hidden="true" ng-if="vm.appointmentFilters.cancelled"></i> </span>Cancelled</button> <button type="button" class="btn btn-default btn-sm" ng-model="vm.appointmentFilters.noShow" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><span class="fa-stack"><i class="fa fa-square fa-stack-2x pink" aria-hidden="true"></i> <i class="fa fa-check fa-stack-1x" aria-hidden="true" ng-if="vm.appointmentFilters.noShow"></i> </span>No Show</button> <button type="button" class="btn btn-default btn-sm" ng-model="vm.appointmentFilters.seen" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><span class="fa-stack"><i class="fa fa-square fa-stack-2x green" aria-hidden="true"></i> <i class="fa fa-check fa-stack-1x" aria-hidden="true" ng-if="vm.appointmentFilters.seen"></i> </span>Seen</button> <button type="button" class="btn btn-default btn-sm" ng-model="vm.appointmentFilters.pendingArrival" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><span class="fa-stack"><i class="fa fa-square fa-stack-2x aqua" aria-hidden="true"></i> <i class="fa fa-check fa-stack-1x" aria-hidden="true" ng-if="vm.appointmentFilters.pendingArrival"></i> </span>Pending Arrival</button></div><div class="controls"><div class="control-appointment-type"><select name="appointmentType" id="appointmentType" class="form-control input-sm"><option value="0">-Select Appointment Type-</option><option value="1">Appointment Type 01</option><option value="2">Appointment Type 02</option><option value="3">Appointment Type 03</option><option value="4">Appointment Type 04</option></select></div><div class="control-provider"><select name="selectProvider" id="selectProvider" class="form-control input-sm"><option value="0">-Select Provider-</option><option value="1">Provider 01</option><option value="2">Provider 02</option><option value="3">Provider 03</option></select></div><button type="button" class="btn btn-primary btn-sm" ng-click="vm.createAppointment()"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="appointments-calendar" id="appointmentsCalendar" ui-calendar="vm.calendarConfig.calendar" ng-model="vm.eventSources" calendar="appointmentsCalendar"></div></div></div></section>');
$templateCache.put('app/entities/auth-item/auth-item-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.authItem.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete {{vm.authItem.name}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this {{vm.authItem.name}} from the database. Are you sure you want to <strong>delete</strong> this {{vm.authItem.name}}?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/auth-item/resource-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAuthItemLabel">Create or edit a Resource</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.authItem.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.authItem.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.authItem.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.authItem.name" required ng-maxlength="255" ng-pattern="/^RESOURCE_[A-Z_]+$/"> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.pattern">Resource name not valid, name must start with "RESOURCE_" followed by letters uppercase, the only special character allowed is "_".</span> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.maxlength">This field cannot be longer than 255 characters.</span></div><div class="form-group"><label class="control-label" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.authItem.description"></div><div class="form-group"><label class="control-label" for="field_data">Data</label> <input type="text" class="form-control" name="data" id="field_data" ng-model="vm.authItem.data"></div><div class="form-group"><div class="row"><div class="col-lg-12 col-md-12 col-xs-12"><div class="box box-info"><div class="box-header"><h3 class="box-title">Actions</h3><div class="box-tools pull-right"><input type="text" class="form-control input-sm" id="actionFilter" placeholder="Actions Filter..." name="actionFilter" ng-model="vm.actionFilterText" ng-change="vm.actionFilter()"></div></div><div class="box-body"><table class="table"><thead><tr><th class="col-xs-1 text-center"><input type="checkbox" ng-model="vm.selectedAllActions" name="selectAll" ng-change="vm.selectAllActions()"></th><th class="col-xs-5">Name</th><th class="col-xs-6">Description</th></tr></thead><tbody><tr ng-repeat="action in vm.filteredActions"><td class="col-xs-1 text-center"><input type="checkbox" ng-model="action.checked" name="{{action.name}}"></td><td class="col-xs-5">{{action.name}}</td><td class="col-xs-6">{{action.description}}</td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/auth-item/resources.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable><!--<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include>--><!--<section class="content">--><!--    <div class="row">--><!--        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">--><!--            <div class="box box-customized">--><!--                <div class="box-header">--><!--                    <div class="dt-header">--><!--                        <button class="btn btn-primary btn-lg" ui-sref="{{vm.entityStateName}}.new"--><!--                                has-any-authority="{{vm.access}}">--><!--                            <i class="fa fa-plus-circle" aria-hidden="true"></i>--><!--                            <span>New {{vm.entityClassHumanized}}</span>--><!--                        </button>--><!--                        <form name="searchForm" class="form-inline">--><!--                            <div class="input-group input-group-lg pull-right">--><!--                                <input type="text" class="form-control" id="searchQuerysignature"--><!--                                       placeholder="Search..."--><!--                                       ng-model="vm.searchQuery"--><!--                                       ng-change="vm.filter()"/>--><!--                                <span class="input-group-btn width-min">--><!--                                    <button class="btn btn-primary">--><!--                                        <i class="fa fa-search" aria-hidden="true"></i>--><!--                                    </button>--><!--                                </span>--><!--                                <span class="input-group-btn width-min"--><!--                                      ng-if="vm.currentSearch">--><!--                                    <button class="btn btn-danger" ng-click="vm.clear()">--><!--                                        <i class="fa fa-trash" aria-hidden="true"></i>--><!--                                    </button>--><!--                                </span>--><!--                            </div>--><!--                        </form>--><!--                    </div>--><!--                </div>--><!--                <div class="box-body">--><!--                    <table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns"--><!--                           dt-instance="vm.dtInstance"--><!--                           class="table table-striped table-bordered">--><!--                    </table>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    </div>--><!--</section>-->');
$templateCache.put('app/entities/auth-item/role-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAuthItemLabel">Create or edit a Role</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--<div class="form-group" ng-show="vm.authItem.id">--><!--<label for="id">ID</label>--><!--<input type="text" class="form-control" id="id" name="id"--><!--ng-model="vm.authItem.id" readonly/>--><!--</div>--><div class="row"><div class="col-lg-4 col-md-12 col-xs-12"><div class="form-group has-feedback" ng-class="vm.authItem.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.authItem.name" required ng-maxlength="255" ng-pattern="/^ROLE_[A-Z_]+$/" ui-validate="{blacklist: \'vm.blacklist($value)\'}"> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.pattern">Resource name not valid, name must start with "ROLE_" followed by letters uppercase, the only special character allowed is "_".</span> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.maxlength">This field cannot be longer than 255 characters.</span> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.blacklist">This already ROLE exist.</span></div></div><div class="col-lg-4 col-md-12 col-xs-12"><div class="form-group"><label class="control-label" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.authItem.description"></div></div><div class="col-lg-4 col-md-12 col-xs-12"><div class="form-group"><label class="control-label" for="field_data">Data</label> <input type="text" class="form-control" name="data" id="field_data" ng-model="vm.authItem.data"></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-xs-12"><div class="box box-info"><div class="box-header"><h3 class="box-title">Other Roles</h3><div class="box-tools pull-right"><input type="text" class="form-control input-sm" id="roleFilter" placeholder="Roles Filter..." ng-model="vm.roleFilterText" ng-change="vm.roleFilter()"></div></div><div class="box-body"><table class="table"><thead><tr><th class="col-xs-1 text-center"><input type="checkbox" ng-disabled="true" ng-model="vm.selectedAllRoles" ng-change="vm.selectAllRoles()"></th><th class="col-xs-5">Name</th><th class="col-xs-6">Description</th></tr></thead><tbody><tr ng-repeat="role in vm.filteredRoles"><td class="col-xs-1 text-center"><input type="checkbox" ng-model="role.checked" ng-change="vm.selectRole(role)" ng-disabled="true"></td><td class="col-xs-5">{{role.name}}</td><td class="col-xs-6">{{role.description}}</td></tr></tbody></table></div></div></div><div class="col-lg-12 col-md-12 col-xs-12"><div class="box box-info"><div class="box-header"><h3 class="box-title">Resources</h3><div class="box-tools pull-right"><input type="text" class="form-control input-sm" id="resourceFilter" placeholder="Resources Filter..." ng-model="vm.resourceFilterText" ng-change="vm.resourceFilter()"></div></div><div class="box-body"><table class="table"><thead><tr><th class="col-xs-1 text-center"><input type="checkbox" ng-model="vm.selectedAllResources" ng-change="vm.selectAllResources()"></th><th class="col-xs-5">Name</th><th class="col-xs-6">Description</th></tr></thead><tbody><tr ng-repeat="resource in vm.filteredResources"><td class="col-xs-1 text-center"><input type="checkbox" ng-model="resource.checked" ng-change="vm.selectResource(resource)"></td><td class="col-xs-5">{{resource.name}}</td><td class="col-xs-6">{{resource.description}}</td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-lg-12 col-md-12 col-xs-12"><div class="box box-info"><div class="box-header"><h3 class="box-title">Actions</h3><div class="box-tools pull-right"><input type="text" class="form-control input-sm" id="actionFilter" placeholder="Actions Filter..." ng-model="vm.actionFilterText" ng-change="vm.actionFilter()"></div></div><div class="box-body"><table class="table"><thead><tr><th class="col-xs-1 text-center"><input type="checkbox" ng-model="vm.selectedAllActions" ng-change="vm.selectAllActions()"></th><th class="col-xs-5">Name</th><th class="col-xs-6">Description</th></tr></thead><tbody><tr ng-repeat="action in vm.filteredActions"><td class="col-xs-1 text-center"><input type="checkbox" ng-model="action.checked" ng-change="vm.selectAction(action)"></td><td class="col-xs-5">{{action.name}}</td><td class="col-xs-6">{{action.description}}</td></tr></tbody></table></div><!--<div class="box-footer">--><!--Footer--><!--</div>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/auth-item/roles.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable><!--<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include>--><!--<section class="content">--><!--    <div class="row">--><!--        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">--><!--            <div class="box box-customized">--><!--                <div class="box-header">--><!--                    <div class="dt-header">--><!--                        <button class="btn btn-primary btn-lg" ui-sref="{{vm.entityStateName}}.new"--><!--                                has-any-authority="{{vm.access}}">--><!--                            <i class="fa fa-plus-circle" aria-hidden="true"></i>--><!--                            <span>New {{vm.entityClassHumanized}}</span>--><!--                        </button>--><!--                        <form name="searchForm" class="form-inline">--><!--                            <div class="input-group input-group-lg pull-right">--><!--                                <input type="text" class="form-control" id="searchQuerysignature"--><!--                                       placeholder="Search..."--><!--                                       ng-model="vm.searchQuery"--><!--                                       ng-change="vm.search()"/>--><!--                                <span class="input-group-btn width-min">--><!--                                    <button class="btn btn-primary"--><!--                                            ng-click="vm.search(vm.searchQuery)">--><!--                                        <i class="fa fa-search" aria-hidden="true"></i>--><!--                                    </button>--><!--                                </span>--><!--                                <span class="input-group-btn width-min"--><!--                                      ng-if="vm.currentSearch">--><!--                                    <button class="btn btn-danger" ng-click="vm.clear()">--><!--                                        <i class="fa fa-trash" aria-hidden="true"></i>--><!--                                    </button>--><!--                                </span>--><!--                            </div>--><!--                        </form>--><!--                    </div>--><!--                </div>--><!--                <div class="box-body">--><!--                    <table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns"--><!--                           dt-instance="vm.dtInstance"--><!--                           class="table table-striped table-bordered">--><!--                    </table>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    </div>--><!--</section>-->');
$templateCache.put('app/entities/bin/bin-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.bin.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Bin</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Bin from the database. Are you sure you want to <strong>delete</strong> this Bin?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/bin/bin-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBinLabel">Create or edit a Bin</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.bin.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.bin.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.bin.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.bin.name"> <span class="help-block" ng-show="!vm.bin.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/bin/bins.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/blocked-time-reason/blocked-time-reason-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.blockedTimeReason.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Blocked Time Reason?</p><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Blocked Time Reason from the database. Are you sure you want to <strong>remove</strong> this Blocked Time Reason?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/blocked-time-reason/blocked-time-reason-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBlockedTimeReasonLabel">Create or edit a Blocked Time Reason</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.blockedTimeReason.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.blockedTimeReason.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.blockedTimeReason.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.blockedTimeReason.name"> <span class="help-block" ng-show="!vm.blockedTimeReason.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/blocked-time-reason/blocked-time-reasons.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/chart-export/chart-export-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myChartExportLabel">Create or edit a Chart Export</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.chartExport.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.chartExport.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.chartExport.name"><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label>Corporation</label> <select class="form-control" ng-model="vm.corporation" name="corporation" id="field_corporation" ng-change="vm.onCorporationSelect()" title="Corporation" ng-options="corporation as corporation.name for corporation in vm.corporations track by corporation.name"><option value=""></option></select></div><div class="form-group"><label>Facilities</label> <select class="form-control" ng-model="vm.facility" name="facility" id="facilities" ng-change="vm.onFacilitySelect()" ng-options="facility as facility.name for facility in vm.facilities track by facility.name"><option value=""></option></select></div><div class="form-group"><label for="field_facesheetTpl">Facesheet Tpl</label> <select class="form-control" id="field_facesheetTpl" name="facesheetTpl" ng-model="vm.chartExport.facesheetTpl" ng-options="facesheetTpl as (facesheetTpl.name + \' - (\' + facesheetTpl.id + \')\') for facesheetTpl in vm.facesheetTpls track by facesheetTpl.name" required><option value=""></option></select><div ng-show="editForm.facesheetTpl.$invalid"><p class="help-block" ng-show="editForm.facesheetTpl.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/chart-export/chart-exports.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart-status-history/chart-status-histories-dialog-close-tpl.html','<div class="form-group" ng-if="!vm.chartStatusHistory.chart.dischargeDate || vm.chartStatusHistory.chart.dischargeDate >= vm.date"><span>Discharge date adjusted to {{vm.date | amDateFormat: amDateFormat}}</span></div><div class="form-group form-group-sm" ng-if="vm.chartStatusHistory.chart.dischargeDate && vm.chartStatusHistory.chart.dischargeDate < vm.date"><label class="control-label" for="field_current">Current discharge date is {{vm.chartStatusHistory.chart.dischargeDate | amDateFormat: amDateFormat}}. Do you want adjust?<br>New Discharge Date</label><br><toggle id="field_current" ng-model="vm.current" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Change to Current Day" off="Keep Discharge Date"></toggle></div>');
$templateCache.put('app/entities/chart-status-history/chart-status-histories-dialog-current-tpl.html','<h4>Are you sure would you like to convert this patient?</h4>');
$templateCache.put('app/entities/chart-status-history/chart-status-histories-dialog-reopen-tpl.html','<div class="form-group"><label class="note" for="field_description">Comments</label> <textarea class="form-control" name="description" id="field_description" rows="5" ata-resize="disabled" ng-model="vm.chartStatusHistory.description"></textarea></div>');
$templateCache.put('app/entities/chart-status-history/chart-status-history-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Convert to "{{vm.getTitle(vm.chartStatusHistory.status)}}"</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><ng-include src="\'app/entities/chart-status-history/chart-status-histories-dialog-current-tpl.html\'" ng-if="vm.chartStatusHistory.status == \'CURRENT\'"></ng-include><ng-include src="\'app/entities/chart-status-history/chart-status-histories-dialog-close-tpl.html\'" ng-if="vm.chartStatusHistory.status == \'CLOSED\'"></ng-include><ng-include src="\'app/entities/chart-status-history/chart-status-histories-dialog-reopen-tpl.html\'" ng-if="vm.chartStatusHistory.status == \'REOPEN\'"></ng-include></div><div class="modal-footer"><button type="submit" class="btn btn-success" data-dismiss="modal"><i class="fa fa-save" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></form>');
$templateCache.put('app/entities/covid-facility/covid-facilities.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/covid-facility/covid-facility-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidFacility.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Facility Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Covid Facility from the database. Are you sure you want to <strong>delete</strong> this Covid Facility?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/covid-facility/covid-facility-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCovidFacilityLabel">Create or edit a Covid Facility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group" ng-show="vm.covidFacility.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.covidFacility.id" readonly="readonly"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.covidFacility.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.covidFacility.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.covidFacility.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.covidFacility.name">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_consentPcrEnabled">Enabled PCR Consent:</label><toggle id="field_consentPcrEnabled" ng-model="vm.covidFacility.consentPcrEnabled" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_consentPcrEnabled">PCR Lab Compendiums:</label><ui-select name="pcrLabCompendiums" id="field_pcrLabCompendiums" multiple="multiple" ng-model="vm.covidFacility.pcrLabCompendiums" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Test Codes...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.labCompendiums | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group"><label class="control-label" for="field_name">PCR Consent Title:</label> <input type="text" class="form-control" name="consentPcrTitle" id="field_consentPcrTitle" ng-model="vm.covidFacility.consentPcrTitle"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_consentPcr">PCR Consent:</label> <textarea class="form-control" id="field_consentPcr" rows="10" name="consentPcr" ng-model="vm.covidFacility.consentPcr"></textarea></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_consentRapidAntigenEnabled">Enabled Rapid Antigen Consent:</label><toggle id="field_consentRapidAntigenEnabled" ng-model="vm.covidFacility.consentRapidAntigenEnabled" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_consentPcrEnabled">Rapid Antigen Lab Compendiums:</label><ui-select name="rapidAntigenLabCompendiums" id="field_rapidAntigenLabCompendiums" multiple="multiple" ng-model="vm.covidFacility.rapidAntigenLabCompendiums" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Test Codes...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.labCompendiums | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group has-feedback"><label class="control-label" for="field_consentRapidAntigenTitle">Rapid Antigen Consent Title:</label> <input type="text" class="form-control" name="consentRapidAntigenTitle" id="field_consentRapidAntigenTitle" ng-model="vm.covidFacility.consentRapidAntigenTitle"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group"><label for="field_consentRapidAntigen">Rapid Antigen Consent:</label> <textarea class="form-control" id="field_consentRapidAntigen" rows="10" name="consentRapidAntigen" ng-model="vm.covidFacility.consentRapidAntigen"></textarea></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_consentKitEnabled">Enabled Home Test Kit Consent:</label><toggle id="field_consentKitEnabled" ng-model="vm.covidFacility.consentKitEnabled" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group has-feedback"><label class="control-label" for="field_consentKitTitle">Home Test Kit Consent Title:</label> <input type="text" class="form-control" name="consentKitTitle" id="field_consentKitTitle" ng-model="vm.covidFacility.consentKitTitle"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group has-feedback"><label class="control-label" for="field_pharmacistAssistanceQuestion">Pharmacist Assistance Question:</label> <input type="text" class="form-control" name="pharmacistAssistanceQuestion" id="field_pharmacistAssistanceQuestion" ng-model="vm.covidFacility.pharmacistAssistanceQuestion"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group has-feedback"><label class="control-label" for="field_individualsQuestion">Individuals Question:</label> <input type="text" class="form-control" name="field_individualsQuestion" id="field_individualsQuestion" ng-model="vm.covidFacility.individualsQuestion"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group"><label for="field_consentKit">Home Test Kit Consent:</label> <textarea class="form-control" id="field_consentKit" rows="10" name="consentKit" ng-model="vm.covidFacility.consentKit"></textarea></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group"><label for="field_consentKitContact">Home Test Kit Contact:</label> <textarea class="form-control" id="field_consentKitContact" rows="10" name="consentKitContact" ng-model="vm.covidFacility.consentKitContact"></textarea></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group has-feedback"><label class="control-label" for="field_pharmacyEmail">Pharmacy Email:</label> <input type="text" class="form-control" name="pharmacyEmail" id="field_pharmacyEmail" ng-model="vm.covidFacility.pharmacyEmail"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.covidFacility.id && vm.covidFacility.logo"><div class="form-group"><img src="../api/covid-facilities/logo/by-domain?domain={{vm.covidFacility.name}}" width="250px" height="100px"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><label for="id">Facility Logo</label> <button type="button" ng-class="(!vm.facilityLogo ? \'btn btn-warning btn-block\' : \'btn btn-success btn-block\')" ngf-select ngf-change="vm.handleFileSelect($event, $file)" accept="image/*"><i class="fa fa-image" aria-hidden="true"></i> {{!vm.facilityLogo ? \'Browse...\' : \'Loaded\'}}</button></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group"><label for="field_pharmacy_info">Pharmacy Info:</label> <textarea class="form-control" id="field_pharmacy_info" rows="5" name="pharmacy_info" ng-model="vm.covidFacility.pharmacyInfo"></textarea></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><label for="id">Pharmacy Logo</label> <button type="button" ng-class="(!vm.pharmacyLogo ? \'btn btn-warning btn-block\' : \'btn btn-success btn-block\')" ngf-select ngf-change="vm.handleFileSelectPharmacy($event, $file)" accept="image/*"><i class="fa fa-image" aria-hidden="true"></i> {{!vm.pharmacyLogo ? \'Browse...\' : \'Loaded\'}}</button></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/covid-facility-lab/covid-facility-lab-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidFacilityLab.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Covid Facility Lab</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Covid Facility Lab from the database. Are you sure you want to <strong>delete</strong> this Covid Phisician?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-facility-lab/covid-facility-lab-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCovidFacilityLabLabel">Create or edit a Covid Facility Lab</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.covidFacilityLab.facilityLab ? \'has-success\':\'has-error\'"><label for="field_facilityLab">Facility Lab</label> <select class="form-control" id="field_facilityLab" name="facilityLab" ng-model="vm.covidFacilityLab.facilityLab" ng-options="facilityLab as facilityLab.name for facilityLab in vm.facilitylabs track by facilityLab.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.covidFacilityLab"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.covidFacilityLab.facilityLab && editForm.facilityLab.$dirty"></span> <span class="help-block" ng-show="!vm.covidFacilityLab.facilityLab">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-facility-lab/covid-facility-labs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/covid-icd-10/covid-icd-10-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidIcd10.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times <svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Covid Icd 10</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Covid Icd 10 from the database. Are you sure you want to <strong>delete</strong> this Covid Icd 10?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-icd-10/covid-icd-10-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCovidIcd10Label">Create or edit a Covid Icd 10</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.covidIcd10.icd10?(vm.covidIcd10.icd10.$valid && vm.covidIcd10.icd10.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_icd10">ICD10</label><ui-select name="icd10" id="field_icd10" title="icd10" ng-model="vm.covidIcd10.icd10" reset-search-input="false" ng-required="true"><ui-select-match placeholder="ICD10...">{{$select.selected.code + ", " + $select.selected.description}}</ui-select-match><ui-select-choices repeat="item in vm.icd10" refresh="vm.getIcd10($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' - \' + item.description"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.covidIcd10.icd10"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.covidIcd10.icd10 && vm.covidIcd10.icd10.$dirty"></span> <span class="help-block" ng-show="!vm.covidIcd10.icd10">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-icd-10/covid-icd-10-s.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/covid-individual/covid-individual-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidIndividual.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Covid Individual?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/covid-individual/covid-individual-detail.html','<div><h2><span>Covid Individual</span> {{vm.covidIndividual.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>First Name</span></dt><dd><span>{{vm.covidIndividual.firstName}}</span></dd><dt><span>Last Name</span></dt><dd><span>{{vm.covidIndividual.lastName}}</span></dd><dt><span>Dob</span></dt><dd><span>{{vm.covidIndividual.dob | date:\'mediumDate\'}}</span></dd><dt><span>Covid Signature</span></dt><dd><a ui-sref="covid-signature-detail({id:vm.covidIndividual.covidSignature.id})">{{vm.covidIndividual.covidSignature.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="covid-individual-detail.edit({id:vm.covidIndividual.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/covid-individual/covid-individual-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCovidIndividualLabel">Create or edit a Covid Individual</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.covidIndividual.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.covidIndividual.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_firstName">First Name</label> <input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.covidIndividual.firstName"></div><div class="form-group"><label class="control-label" for="field_lastName">Last Name</label> <input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.covidIndividual.lastName"></div><div class="form-group"><label class="control-label" for="field_dob">Dob</label><div class="input-group"><input id="field_dob" type="text" class="form-control" name="dob" uib-datepicker-popup="{{dateformat}}" ng-model="vm.covidIndividual.dob" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label for="field_covidSignature">Covid Signature</label> <select class="form-control" id="field_covidSignature" name="covidSignature" ng-model="vm.covidIndividual.covidSignature" ng-options="covidSignature as covidSignature.id for covidSignature in vm.covidsignatures track by covidSignature.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/covid-individual/covid-individuals.html','<div><h2>Covid Individuals</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="covid-individual.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Covid Individual</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>First Name</span></th><th><span>Last Name</span></th><th><span>Dob</span></th><th><span>Covid Signature</span></th><th></th></tr></thead><tbody><tr ng-repeat="covidIndividual in vm.covidIndividuals track by covidIndividual.id"><td><a ui-sref="covid-individual-detail({id:covidIndividual.id})">{{covidIndividual.id}}</a></td><td>{{covidIndividual.firstName}}</td><td>{{covidIndividual.lastName}}</td><td>{{covidIndividual.dob | date:\'mediumDate\'}}</td><td><a ui-sref="covid-signature-detail({id:covidIndividual.covidSignature.id})">{{covidIndividual.covidSignature.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="covid-individual-detail({id:covidIndividual.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="covid-individual.edit({id:covidIndividual.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="covid-individual.delete({id:covidIndividual.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/covid-lab-compendium/covid-lab-compendium-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidLabCompendium.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Covid Lab Compendium</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Covid Lab Compendium from the database. Are you sure you want to <strong>delete</strong> this Covid Lab Compendium?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-lab-compendium/covid-lab-compendium-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCovidLabCompendiumLabel">Create or edit a Covid Lab Compendium</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.covidLabCompendium.labCompendium?(vm.covidLabCompendium.labCompendium.$valid && vm.covidLabCompendium.labCompendium.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_labCompendium">Lab Compendium</label><ui-select name="labCompendium" id="field_labCompendium" title="labCompendium" ng-disabled="!vm.covidFacilityLab" ng-required="true" ng-model="vm.covidLabCompendium.labCompendium"><ui-select-match placeholder="Enter Lab Compendium...">{{$select.selected.code + ($select.selected.description ? " - " + $select.selected.description : \'\')}}</ui-select-match><ui-select-choices repeat="labCompendium in vm.labCompendiums | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="labCompendium.code + (labCompendium.description ? \' - \' + labCompendium.description : \'\')"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.covidLabCompendium"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.covidLabCompendium.labCompendium && editForm.labCompendium.$dirty"></span> <span class="help-block" ng-show="!vm.covidLabCompendium.labCompendium">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-lab-compendium/covid-lab-compendiums.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/covid-physician/covid-physician-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidPhysician.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Covid Physician</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Covid Physician from the database. Are you sure you want to <strong>delete</strong> this Covid Physician?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-physician/covid-physician-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCovidPhysicianLabel">Create or edit a Covid Physician</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.covidPhysician.physician ? \'has-success\':\'has-error\'"><label for="covidPhysician">Physician</label><ui-select id="covidPhysician" name="covidPhysician" reset-search-input="false" required="" ng-model="vm.covidPhysician.physician" title="Physician..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Physician...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.covidPhysician.physician"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.covidPhysician.physician && editForm.doctorList.$dirty"></span> <span class="help-block" ng-show="!vm.covidPhysician.physician">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/covid-physician/covid-physicians.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/covid-question/covid-question-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.covidQuestion.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Covid Question from the database. Are you sure you want to <strong>remove</strong> this Covid Question?</p></div><div class="modal-footer"><button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/covid-question/covid-question-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCovidQuestionLabel">Create or edit a Covid Question</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-lg-12"><div class="form-group has-feedback" ng-class="vm.covidQuestion.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.covidQuestion.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.covidQuestion.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.covidQuestion.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.covidQuestion.name">This field is required</span></div></div><div class="col-lg-12"><div class="col-lg-2" style="padding:0 !important"><div class="form-group"><label><label for="field_enable">Enable</label><br><toggle id="field_enable" ng-model="vm.covidQuestion.enable" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></label></div></div><div class="col-lg-10" style="padding:0 !important"><div class="form-group"><label class="control-label" for="field_xorder">Order</label> <input type="number" class="form-control" name="xorder" id="field_xorder" ng-model="vm.covidQuestion.xorder"></div></div></div><div class="col-lg-12"><div class="form-group form-group-sm"><label for="field_diagnoses">ICD10:</label><ui-select id="field_diagnoses" name="diagnoses" multiple="multiple" ng-model="vm.covidQuestion.icd10s" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/covid-question/covid-questions.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/crm-activity/crm-activities.html','<div class="generic-activities"><h4 class="headline mt-0" ng-repeat-start="(key, value) in vm.groupedCrmActivities" ng-bind-html="key"></h4><div ng-repeat-end class="activity-item well well-sm" ng-repeat="activity in value"><header class="activity-header"><div class="type note">CRM Activity</div><div><span class="date">{{activity.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</span></div></header><div class="activity-body"><p>{{activity.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</p></div></div></div>');
$templateCache.put('app/entities/crm-activity/crm-activity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCrmActivityLabel">Create or edit a Crm Activity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.crmActivity.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.crmActivity.id" readonly="readonly"></div><div class="form-group"><label for="field_crmNote">Crm Note</label> <select class="form-control" id="field_crmNote" name="crmNote" ng-model="vm.crmActivity.crmNote" ng-options="crmNote as crmNote.id for crmNote in vm.crmnotes | orderBy:\'id\' track by crmNote.id"><option value=""></option></select></div><div class="form-group"><label for="field_crmCall">Crm Call</label> <select class="form-control" id="field_crmCall" name="crmCall" ng-model="vm.crmActivity.crmCall" ng-options="crmCall as crmCall.id for crmCall in vm.crmcalls | orderBy:\'id\' track by crmCall.id"><option value=""></option></select></div><div class="form-group"><label for="field_crmEmail">Crm Email</label> <select class="form-control" id="field_crmEmail" name="crmEmail" ng-model="vm.crmActivity.crmEmail" ng-options="crmEmail as crmEmail.id for crmEmail in vm.crmemails | orderBy:\'id\' track by crmEmail.id"><option value=""></option></select></div><div class="form-group"><label for="field_crmTask">Crm Task</label> <select class="form-control" id="field_crmTask" name="crmTask" ng-model="vm.crmActivity.crmTask" ng-options="crmTask as crmTask.id for crmTask in vm.crmtasks | orderBy:\'id\' track by crmTask.id"><option value=""></option></select></div><div class="form-group"><label for="field_corporation">Corporation</label> <select class="form-control" id="field_corporation" name="corporation" ng-model="vm.crmActivity.corporation" ng-options="corporation as corporation.id for corporation in vm.corporations track by corporation.id" required></select></div><div ng-show="editForm.corporation.$invalid"><p class="help-block" ng-show="editForm.corporation.$error.required">This field is required.</p></div><div class="form-group"><label for="field_crmOpportunity">Crm Opportunity</label> <select class="form-control" id="field_crmOpportunity" name="crmOpportunity" ng-model="vm.crmActivity.crmOpportunity" ng-options="crmOpportunity as crmOpportunity.id for crmOpportunity in vm.crmopportunities track by crmOpportunity.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/crm-call/crm-call-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmNote.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Call?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-call/crm-call-dialog.html','<form name="deleteForm" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create or edit a Call</h4></div><div class="modal-body"><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="dateCall">Date of Call:</label><div class="input-group"><input type="text" class="form-control" id="dateCall" name="date" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.crmCall.date" is-open="vm.datePickerOpenStatus.dateCall" datepicker-options="vm.DateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateCall\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="inputOutcome">Outcome:</label> <select name="outcome" ng-model="vm.crmCall.outcome" id="inputOutcome" class="form-control"><option value="CONECTED">CONECTED</option><option value="NO_ANSWER">NO_ANSWER</option><option value="BUSY">BUSY</option><option value="WRONG_NUMBER">WRONG_NUMBER</option><option value="LEFT_LIVE_MESSAGE">LEFT_LIVE_MESSAGE</option><option value="LEFT_VOICE_MAIL">LEFT_VOICE_MAIL</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label class="control-label" for="field_description">Description:</label><!--                    <ng-quill-editor ng-model="vm.crmCall.description"--><!--                                     id="field_description"--><!--                                     name="description"--><!--                                     on-editor-created="vm.editorCreated(editor, vm.crmCall.description)"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-call/crm-calls.html','<div class="generic-activities"><div class="activity-item" ng-repeat="call in data.calls.crmCalls"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>{{call.employee.firstName + " " + call.employee.lastName}}</strong></p><span class="date">{{call.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" ng-if="vm.isOwner(call)" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(call.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = call.id"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body" ng-bind-html="vm.trustAsHtml(call.description)"></div><footer class="activity-footer"><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>{{call.employee.firstName + " " + call.employee.lastName}}</strong></p></div><div class="credentials"><span class="small">Date of Call:</span><p class="name mb-0"><strong>{{call.date | date: inputDateTimeFormatA}}</strong></p></div><div class="credentials"><span class="small">Outcome:</span><p class="name mb-0"><strong>{{vm.replace(call.outcome)}}</strong></p></div><div class="btns-actions" ng-if="vm.isOwner(call)" ng-class="{\'overlayActive\': vm.confirmDelete == call.id}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Call?</p><div ng-if="vm.confirmDelete && vm.confirmDelete == call.id"><button type="button" class="btn btn-success btn-sm" ng-click="vm.del(call.id)"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = null"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-info btn-sm btn-toggle-pin" ng-click="vm.pinCrmCall(call)"><i class="{{call.pin ? \'fa fa-bookmark\' : \'fa fa-bookmark-o\'}}" aria-hidden="true"></i> {{call.pin ? \'Unpin\' : \'Pin\' }}</button></div></footer></div><div class="fright"><jhi-item-count page="data.calls.page" total="data.calls.totalItems" items-per-page="data.calls.size"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="data.calls.totalItems" items-per-page="data.calls.size" ng-model="data.calls.page" ng-change="vm.getUnpin()"></ul></div></div>');
$templateCache.put('app/entities/crm-campaign/crm-campaign-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmCampaign.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Crm Campaign</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Crm Campaign from the database. Are you sure you want to <strong>delete</strong> this Crm Campaign?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-campaign/crm-campaign-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myReactionLabel">Create or edit a Crm Campaign</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.crmCampaign.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.crmCampaign.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.crmCampaign.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_crmCampaign">Name:</label> <input type="text" class="form-control" name="name" id="field_crmCampaign" required ng-model="vm.crmCampaign.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmCampaign.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmCampaign.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.crmCampaign.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-campaign/crm-campaign.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div></div></div></section>');
$templateCache.put('app/entities/crm-email/crm-email-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmEmail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Crm Email?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/crm-email/crm-email-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Log Emails</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="dateLogEmail">Date of Email:</label><div class="input-group"><input type="text" class="form-control" id="dateLogEmail" name="dateLogEmail" placeholder="mm/dd/yyyy" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.crmEmail.date" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label for="field_description">Description:</label><!--                    <ng-quill-editor ng-model="vm.crmEmail.description"--><!--                                     id="field_description"--><!--                                     name="description"--><!--                                     on-editor-created="vm.editorCreated(editor, vm.crmEmail.description)"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-email/crm-emails.html','<div class="generic-activities"><div class="activity-item" ng-repeat="email in data.emails.crmEmails"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>{{email.employee.firstName + " " + email.employee.lastName}}</strong></p><span class="date">{{email.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" ng-if="vm.isOwner(email)" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(email.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit </a>p</li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = email.id"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body" ng-bind-html="vm.trustAsHtml(email.description)"></div><footer class="activity-footer"><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0">{{email.employee.firstName + " " + email.employee.lastName}}</p></div><div class="credentials"><span class="small">Date of email:</span><p class="name mb-0">{{email.date | date: inputDateTimeFormatA}}</p></div><div class="btns-actions" ng-if="vm.isOwner(email)" ng-class="{\'overlayActive\': vm.confirmDelete == email.id}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Log?</p><div ng-if="vm.confirmDelete && vm.confirmDelete == email.id"><button type="button" class="btn btn-success btn-sm" ng-click="vm.del(email.id)"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = null"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-info btn-sm btn-toggle-pin" ng-click="vm.pinCrmEmail(email)"><i class="{{email.pin ? \'fa fa-bookmark\' : \'fa fa-bookmark-o\'}}" aria-hidden="true"></i> {{email.pin ? \'Unpin\' : \'Pin\' }}</button></div></footer></div><div class="fright"><jhi-item-count page="data.emails.page" total="data.emails.totalItems" items-per-page="data.emails.size"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="data.emails.totalItems" items-per-page="data.emails.size" ng-model="data.emails.page" ng-change="vm.getUnpin()"><ul></ul></ul></div></div>');
$templateCache.put('app/entities/crm-insurance/crm-insurance-dialog.html','<form name="editform" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Insurance Information</h4></div><div class="modal-body"><div class="row"><fieldset><legend>{{vm.crmInsurance.insuranceOrder===\'PRIMARY\'?\'Primary:\':\'Secondary:\'}}</legend><div class="col-xs-4 col-sm-4 col-md-12 col-lg-12" ng-class="vm.crmInsurance.insuranceCarrier?(editform.insurance_carrier.$dirty || editform.insurance_carrier.$dirty?\'has-success\':\'\'):\'has-error\'"><div class="form-group has-feedback"><label for="field_insurance_carrier">Carrier:</label><ui-select ng-model="vm.crmInsurance.insuranceCarrier" name="insurance_carrier" id="field_insurance_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{ $select.selected.id? $select.selected.name: $select.selected.name + \'(new)\'}}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0">{{carrier.id? carrier.name: carrier.name + \'(new)\'}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editform.insurance_carrier.$error.required"></span> <span class="help-block" ng-show="editform.insurance_carrier.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.policyNumber?(editform.insurance_policyNumber.$dirty || editform.insurance_policyNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_policyNumber">Policy:</label> <input type="text" class="form-control" name="insurance_policyNumber" id="field_insurance_policyNumber" required ng-model="vm.crmInsurance.policyNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.policyNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.policyNumber && editform.insurance_policyNumber.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.policyNumber">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.groupNumber?(editform.insurance_groupNumber.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_insurance_groupNumber">Group Number:</label> <input type="text" class="form-control" name="insurance_groupNumber" id="field_insurance_groupNumber" ng-model="vm.crmInsurance.groupNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.groupNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.groupNumber && editform.insurance_groupNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.crmInsurance.groupNumber">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.preCertPhone?(editform.insurance_preCertPhone.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_preCertPhone">Pre-Cert Number:</label> <input type="text" class="form-control" name="insurance_preCertPhone" id="field_insurance_preCertPhone" ng-model="vm.crmInsurance.preCertPhone" ui-mask="(999) 999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.preCertPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.preCertPhone && editform.insurance_preCertPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.crmInsurance.preCertPhone">This field is suggested</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="form-group has-feedback" ng-class="vm.crmInsurance.address?(editform.insurance_address.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label> <input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.crmInsurance.address"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.address && editform.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.address">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.address2?(editform.insurance_address2.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2:</label> <input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.crmInsurance.address2"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.address2 && editform.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.crmInsurance.address2">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.city?(editform.insurance_city.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label> <input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.crmInsurance.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.city && editform.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.city">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.countryState?(editform.insurance_state.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label> <select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.crmInsurance.countryState" ng-options="item as item.state for item in vm.states track by item.id"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.countryState && editform.insurance_states.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.countryState">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.zipCode?(editform.insurance_zipCode.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label> <input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.crmInsurance.zipCode" ui-mask="99999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.zipCode && editform.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.zipCode">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.name?(editform.insurance_name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_name">Subscriber Name:</label> <input type="text" class="form-control" name="insurance_name" id="field_insurance_name" required ng-model="vm.crmInsurance.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.name && editform.insurance_name.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.name">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.phone?(editform.insurance_phone.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label> <input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.crmInsurance.phone" ui-mask="(999) 999-9999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.phone && editform.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.phone">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.dob?(editform.insurance_dob.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Suscriber D.O.B.:</label><div class="input-group"><input type="text" class="form-control" id="field_insurance_dob" name="suscriberDOB" required ng-model="vm.crmInsurance.dob" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button> </span><span class="help-block" ng-show="!vm.crmInsurance.dob">This field is required</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.insuranceRelation?(editform.insurance_insuranceRelation.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_insuranceRelation">Suscriber Relationship:</label> <select class="form-control" id="field_insurance_insuranceRelation" name="insurance_insuranceRelation" required ng-model="vm.crmInsurance.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insuranceRelations track by insuranceRelation.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.insuranceRelation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.insuranceRelation && editform.insurance_insuranceRelation.$dirty"></span> <span class="help-block" ng-show="!vm.crmInsurance.insuranceRelation">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.crmInsurance.socialSecurity?(editform.insurance_ssn.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_ssn">Subscriber SSN:</label> <input type="text" class="form-control" name="insurance_ssn" id="field_insurance_ssn" ng-model="vm.crmInsurance.socialSecurity" ui-mask="999-99-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.crmInsurance.socialSecurity"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmInsurance.socialSecurity && editform.insurance_ssn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.crmInsurance.socialSecurity">This field is suggested</span></div></div></fieldset></div><!-- ./row --></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editform.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-insurance/crm-insurances.html','<h4 class="headline mt-0"><strong>Insurance Details</strong></h4><div class="insurance-details"><ng-include src="\'app/entities/crm-insurance/tpl/primary.html\'"></ng-include><ng-include ng-if="vm.crmPrimaryInsurance" src="\'app/entities/crm-insurance/tpl/secondary.html\'"></ng-include></div>');
$templateCache.put('app/entities/crm-note/crm-note-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmNote.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Note?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-note/crm-note-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myChartNoteLabel">Create or edit a Note</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="!vm.crmNote.note || editForm.note.$error.required?\'has-error\':(editForm.note.$valid && editForm.note.$dirty?\'has-success\':\'\')"><!--                <ng-quill-editor ng-model="vm.crmNote.note"--><!--                                 id="field_note" name="note"--><!--                                 on-editor-created="vm.editorCreated(editor, vm.crmNote.note)"></ng-quill-editor>--> <span class="help-block" ng-show="!vm.crmNote.note || editForm.note.$error.required">This field is required.</span></div></div></fieldset><div class="modal-footer"><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button></fieldset><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-note/crm-notes.html','<div class="generic-activities"><div class="activity-item" ng-repeat="note in data.notes.crmNotes"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>{{note.employee.firstName + " " + note.employee.lastName}}</strong></p><span class="date">{{note.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" ng-if="vm.isOwner(note)" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(note.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = note.id"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body" ng-bind-html="vm.trustAsHtml(note.note)"></div><footer class="activity-footer"><!--\n            <div class="credentials">\n                <p class="name mb-0">\n                    <strong>{{note.employee.firstName + " " + note.employee.lastName}}</strong> <span class="small">Left a note</span>\n                </p>\n            </div>\n            --><div class="media-buttons"><button type="button" class="btn btn-default btn-sm"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> Like</button> <button type="button" class="btn btn-default btn-sm"><i class="fa fa-comments-o" aria-hidden="true"></i> Comment</button></div><div class="btns-actions" ng-if="vm.isOwner(note)" ng-class="{\'overlayActive\': vm.confirmDelete == note.id}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Note?</p><div ng-if="vm.confirmDelete && vm.confirmDelete == note.id"><button type="button" class="btn btn-success btn-sm" ng-click="vm.del(note.id)"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = null"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-default btn-sm btn-toggle-pin" ng-click="vm.pinCrmNote(note)"><i class="{{note.pin ? \'fa fa-bookmark\' : \'fa fa-bookmark-o\'}}" aria-hidden="true"></i> {{note.pin ? \'Unpin\' : \'Pin\' }}</button></div></footer><div class="comment-section"><header class="summary"><p class="mb-0">Liked by <strong class="username">Jesus Rodriguez</strong> and <strong>12 others</strong></p><p><strong>12 comments</strong></p></header><div class="comments"><div class="comment"><p><strong class="author">Jesus Rodriguez</strong>: <a href="" class="reference">@Maykel Wong</a> lorem ipsum dollor sit amet</p><a href="" class="like-btn"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i></a></div><div class="comment"><p><strong class="author">Maykel Wong</strong>: <a href="" class="reference">@Jesus Rodr\xEDguez</a> historias velum, tanquam velox deus. Lorem ipsum astrum</p><a href="" class="like-btn"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i></a></div></div><div class="add-comment"><div class="input-group"><input type="text" class="form-control"> <span class="input-group-btn"><button type="button" class="btn btn-default">Post <i class="fa fa-send" aria-hidden="true"></i></button></span></div></div></div></div><div class="fright"><jhi-item-count page="data.notes.page" total="data.notes.totalItems" items-per-page="data.notes.size"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="data.notes.totalItems" items-per-page="data.notes.size" ng-model="data.notes.page" ng-change="vm.getUnpin()"></ul></div></div>');
$templateCache.put('app/entities/crm-opportunity/crm-opportunities.html','<div class="floating-menu"><button type="button" class="ham-btn dots-layout" ng-model="vm.floatingMenuStatus" ng-click="vm.toggleFloatingMenu($event)" ng-class="{\'open\': vm.floatingMenuStatus, \'closed\': !vm.floatingMenuStatus}"><span class="dot"></span></button><div class="float-menu"><ul class="list-unstyled"><li class="l-item"><a href="" ng-click="vm.createCrmOpportunity()"><span class="text">New Opportunity</span> <span class="icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></span></a></li><!--\n            <li class="l-item">\n                <a ng-click="vm.addCrmNote()"\n                   ng-model="vm.toggleFullS"\n                   uib-btn-checkbox\n                   btn-checkbox-true="1"\n                   btn-checkbox-false="0">\n                    <span class="text">Toggle Full Screen</span>\n                    <span class="icon">\n                        <i class="fa" aria-hidden="true"\n                           ng-class="vm.toggleFullS?\'fa-compress\':\'fa-arrows-alt\'"></i>\n                    </span>\n                </a>\n            </li>\n            --><li class="l-item"><a ng-click="vm.layoutToggle = \'LIST\'" ng-model="vm.layoutToggle"><span class="text">List</span> <span class="icon"><i class="fa fa-list" aria-hidden="true"></i></span></a></li><li class="l-item"><a ng-click="vm.layoutToggle = \'DRAG\'" ng-model="vm.layoutToggle"><span class="text">Tiles</span> <span class="icon"><i class="fa fa-th-large" aria-hidden="true"></i></span></a></li></ul></div></div><section class="content pb-0 no-padding" ng-class="{\'fullscreen\': vm.toggleFullS,\n                    \'viewport\': vm.layoutToggle === \'DRAG\'}"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 no-padding"><div class="header-options" ng-class="{\'mb-15\': vm.layoutToggle === \'LIST\'}"><div class="opportunity-filters"><a href="" ng-click="vm.toggleFilters($event)" class="toggleBtn">Opportunities Filter <i class="fa fa-chevron-down" aria-hidden="true"></i></a><div class="filters-container"><form action=""><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_sort">Sort:</label> <select name="" id="field_sort" class="form-control input-sm"><option value="01">Sort Condition 01</option><option value="02">Sort Condition 02</option><option value="03">Sort Condition 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label>Direction:</label><div class="btn-group"><label class="btn btn-sm" ng-class="vm.radioDirection === \'ascending\'?\'btn-primary\':\'btn-default\'" ng-model="vm.radioDirection" uib-btn-radio="\'ascending\'"><i class="fa" aria-hidden="true" ng-class="vm.radioDirection === \'ascending\'?\'fa-check-circle\':\'fa-circle-o\'"></i> Ascending</label> <label class="btn btn-sm" ng-class="vm.radioDirection === \'descending\'?\'btn-primary\':\'btn-default\'" ng-model="vm.radioDirection" uib-btn-radio="\'descending\'"><i class="fa" aria-hidden="true" ng-class="vm.radioDirection === \'descending\'?\'fa-check-circle\':\'fa-circle-o\'"></i> Descending</label></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_selectedEmployee">Employee:</label><ui-select name="reaction" id="field_selectedEmployee" title="Select Employee" multiple="multiple" ng-model="vm.selectedEmployees" reset-search-input="true" close-on-select="false" ng-disabled="vm.disable"><ui-select-match allow-clear="true" placeholder="Select Employee...">{{$item.lastName + \', \' + $item.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | filter: $select.search" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-right"><button type="button" class="btn btn-warning btn-sm"><i class="fa fa-search" aria-hidden="true"></i> Search</button> <button type="button" class="btn btn-default btn-sm"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></form></div><div class="info"><p class="mb-0"><span class="total-items">267 Opportunities, </span>Sorted by <span class="active-filter">Opportunity Name</span>, <span class="order">Ascending</span> <a href="" class="reset-btn"><i class="fa fa-refresh" aria-hidden="true"></i> Reset</a></p></div></div><div class="search-material short"><div class="search-input"><input type="text" class="form-control" ng-change="vm.search()" ng-model="vm.searchQuery"> <button type="button" class="btn btn-default" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box box-customized mb-0"><div class="box-body no-shadow"><div class="lists-container" ng-show="vm.layoutToggle === \'DRAG\'"><div class="drag-list panel panel-default" ng-repeat="(listName, list) in vm.draglists"><div class="panel-heading"><h3 class="panel-title">Lorem Ipsum {{listName}} <span class="label label-danger pull-right">{{list.length}}</span></h3></div><div class="panel-body"><ul class="list-unstyled" dnd-list="list"><li class="drag-item" ng-repeat="item in list" dnd-draggable="item" dnd-moved="list.splice($index, 1)" dnd-effect-allowed="move" dnd-selected="vm.selected = item" ng-class="{\'selected\': vm.selected === item}" uib-tooltip="{{item.label}}"><header class="header"><div><h4 class="name mt-0 mb-0"><a ui-sref="opportunity-details">Kathy Johnson</a></h4><span class="small"><strong>D.O.B.:</strong> 08/10/2019</span></div><div class="assignee"><span uib-tooltip="Jesus Rodriguez" class="initials">JR</span></div></header><ul class="card-content list-unstyled mb-0"><li class="campaign"><p class="mb-0">Lorem Ipsum Dollor Sit Ametsium</p></li><li><span><strong>Admission Date:</strong> 08/10/2019</span></li><li><span><strong>Facility:</strong> Heaven Detox</span></li></ul></li></ul></div></div></div><div class="row" ng-show="vm.layoutToggle === \'LIST\'"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="opportunities-list"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th></th><th><strong>Opportunity</strong></th><th><strong>Priority</strong></th><th><strong>Insurance Carrier</strong></th><th><strong>Last Activity</strong></th><th><strong>T. Facility</strong></th><th><strong>Tags</strong></th></tr></thead><tbody><tr ng-repeat="item in vm.crmOpportunities" ng-click="vm.displayCrmOpportunity(item.id)"><td><div class="preview"><div class="photo"><img ng-src-auth="{{item.pictureRefId}}"></div></div></td><td><div class="preview"><div class="info"><p class="name"><strong>{{item.name}}</strong></p><p class="dob" ng-if="item.dob"><span class="small">{{item.dob | date: \'MMM d, y\'}}</span>, <span>({{vm.calculateAge(item.dob)}} Years)</span></p><p class="gender"><span class="small">{{item.gender}}</span></p></div></div></td><td><span class="label label-danger">{{item.priority}}</span></td><td><span>Blue Cross and Shield of Florida</span></td><td><span>June 2, 1952 at 7:52 PM</span></td><td><span class="facility-name">{{item.facilityName}}</span></td><td><span class="label label-default">Smartphone</span> <span class="label label-default">Spanish</span> <span class="label label-default">Therapy</span></td></tr></tbody></table></div><div class="text-center mb-15"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/crm-opportunity/crm-opportunity-detail.html','<div class="floating-menu"><button type="button" class="ham-btn dots-layout" ng-model="vm.floatingMenuStatus" ng-click="vm.toggleFloatingMenu($event)" ng-class="{\'open\': vm.floatingMenuStatus,\n                       \'closed\': !vm.floatingMenuStatus}"><span class="dot"></span></button><div class="float-menu"><ul class="list-unstyled"><li class="l-item"><a href=""><span class="text">Create Note</span> <span class="icon"><i class="fa fa-file-text" aria-hidden="true"></i></span></a></li><li class="l-item"><a href=""><span class="text">Create Task</span> <span class="icon"><i class="fa fa-calendar-check-o" aria-hidden="true"></i></span></a></li><li class="l-item"><a ng-click=""><span class="text">Create Emails</span> <span class="icon"><i class="fa fa-envelope" aria-hidden="true"></i></span></a></li><li class="l-item"><a ng-click=""><span class="text">Create Calls</span> <span class="icon"><i class="fa fa-phone" aria-hidden="true"></i></span></a></li></ul></div></div><section class="content no-padding"><section class="opportunity-list"><div class="oppo-item"><span class="header">Opportunity</span></div><div class="oppo-item active"><span class="header">Elenor Owen</span> <a href="" class="close-icon"><i class="fa fa-times" aria-hidden="true"></i></a></div><div class="oppo-item"><span class="header">Armand Benson</span> <a href="" class="close-icon"><i class="fa fa-times" aria-hidden="true"></i></a></div><div class="oppo-item"><span class="header">Libby Harrison</span> <a href="" class="close-icon"><i class="fa fa-times" aria-hidden="true"></i></a></div></section><div class="opportunity-grid"><div class="section-aside"><header class="selector"><select name="" id="" class="form-control input-sm"><option value="01">Latest Record on Account</option><option value="02">Ubi est alter species</option></select></header><section class="data-section op-photo-info"><div class="photo"><img src="content/images/avatar.png" alt="Opportunity Photo" class="img-thumbnail img-responsive"></div><div class="info"><h5 class="name mt-0 mb-0" style="margin-bottom: 5px"><strong>{{vm.crmOpportunity | patientName}}</strong> <span class="label label-danger text-uppercase">High</span></h5><p class="mb-0">{{vm.crmOpportunity.dob | date: \'MMMM d, y\'}}</p><p class="mb-0">{{vm.crmOpportunity.gender | empty}}</p><p class="mb-0">{{vm.crmOpportunity.status | empty : \'name\'}}</p><div class="tags"><span class="tag">Smartphone</span> <span class="tag">Ipsum</span></div></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-basic-info.html\'" popover-title="Basic Info" popover-placement="right-top" popover-trigger="\'focus\'"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>SSN:</label><p>{{vm.crmOpportunity.ssn | ssnFormat}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-ssn.html\'" popover-title="Social Security Number" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Address:</label><p>{{vm.crmOpportunity.address}} {{vm.crmOpportunity.address2}}</p><p>{{vm.crmOpportunity.city}}, {{vm.crmOpportunity.state.stateCode}} {{vm.crmOpportunity.zipCode}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-address.html\'" popover-title="Address Information:" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Comnunication:</label><p><strong>PHONE:</strong> {{vm.crmOpportunity.phone | phone}}</p><p><strong>ALT PHONE:</strong> {{vm.crmOpportunity.altPhone | phone}}</p><p><strong>EMAIL:</strong> {{vm.crmOpportunity.email}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-communication.html\'" popover-title="Communication:" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Targeted Information:</label><p><strong>Facility:</strong> {{vm.crmOpportunity.facility | empty : \'name\'}}</p><p><strong>Admission Date:</strong> {{vm.crmOpportunity.admissionDate | date: \'MMMM d, y\'}}</p><p><strong>Level of Care:</strong> {{vm.crmOpportunity.levelCare | empty : \'name\'}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-targeted-information.html\'" popover-title="Targeted Information:" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Lead Information:</label><p><strong>Referral Source:</strong> {{vm.crmOpportunity.referral | empty : \'name\'}}</p><p><strong>Campaign:</strong> {{vm.crmOpportunity.campaign | empty : \'name\'}}</p><p><strong>Outreach:</strong> {{vm.crmOpportunity.marketer | employeeName}}</p><p><strong>Admission Rep.:</strong> {{vm.crmOpportunity.assignee | employeeName}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-lead-information.html\'" popover-title="Lead Information:" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Additional Information:</label><p><strong>Ethnicity:</strong> {{vm.crmOpportunity.ethnicity | empty : \'name\'}}</p><p><strong>Race:</strong> {{vm.crmOpportunity.race | empty : \'name\'}}</p><p><strong>Marital Status:</strong> {{vm.crmOpportunity.maritalStatus | empty : \'name\'}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-additional-information.html\'" popover-title="Additional Information:" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>1<sup>st</sup> Contact:</label><p><strong>Name:</strong> {{vm.crmOpportunity.contactName | empty}}</p><p><strong>Relationship:</strong> {{vm.crmOpportunity.contactRelationship | empty}}</p><p><strong>Phone:</strong> {{vm.crmOpportunity.contactPhone | phone}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-contact.html\'" popover-title="Contact Information:" popover-placement="right-top"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Employer Information:</label><p><strong>Employer:</strong> {{vm.crmOpportunity.employer | empty}}</p><p><strong>Occupation:</strong> {{vm.crmOpportunity.occupation | empty}}</p><p><strong>Phone:</strong> {{vm.crmOpportunity.employerPhone | phone}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-employer-information.html\'" popover-title="Employer Information:" popover-placement="right"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Outbound Referral:</label><p><strong>Facility:</strong></p><p><strong>Outreach:</strong></p><p><strong>Referred To:</strong></p><p><strong>DOA To Facility:</strong></p><p><strong>Status:</strong></p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-outbound-referral.html\'" popover-title="Outbound Referral:" popover-placement="top-right"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Primary Insurance:</label><p><strong>Carrier:</strong> Blue Cross and Blue Shield of Florida</p><p><strong>Policy:</strong> BCBS122345678987</p><p><strong>Group Number:</strong> 12345678TG-RF33</p><p><strong>Pre-Cert Number:</strong> 123-123-1212</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-insurance-information.html\'" popover-title="Primary Insurance:" popover-placement="top-right"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Secondary Insurance</label><p><strong>Carrier:</strong> Florida Blue</p><p><strong>Policy:</strong> BCBS122345678987</p><p><strong>Group Number:</strong> 12345678TG-RF33</p><p><strong>Pre-Cert Number:</strong> 123-123-1212</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-insurance2-information.html\'" popover-title="Secondary Insurance:" popover-placement="top-right"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section></div><div class="section-activities"><div class="activities-content"><uib-tabset active="0" justified="true"><uib-tab index="0" heading="Activity"><ng-include src="\'app/entities/crm-opportunity/tabs/activity.html\'"></ng-include></uib-tab><uib-tab index="1" heading="Notes"><div ui-view="notes"></div></uib-tab><uib-tab index="2" heading="Tasks"><div ui-view="tasks"></div></uib-tab><uib-tab index="3" heading="Emails"><div ui-view="emails"></div></uib-tab><uib-tab index="4" heading="Calls"><div ui-view="calls"></div></uib-tab><uib-tab index="5" heading="Travels"><ng-include src="\'app/entities/crm-opportunity/tabs/travels.html\'"></ng-include></uib-tab><uib-tab index="6" heading="Documents"><ng-include src="\'app/entities/crm-opportunity/tabs/documents.html\'"></ng-include></uib-tab><uib-tab index="7" heading="Financial"><ng-include src="\'app/entities/crm-opportunity/tabs/financials.html\'"></ng-include></uib-tab><uib-tab index="8" heading="Activity"><div ui-view="crm-activity"></div></uib-tab><!--<uib-tab index="8" heading="Attachments">--><!--<ng-include src="\'app/entities/crm-opportunity/tabs/attachments.html\'"></ng-include>--><!--</uib-tab>--></uib-tabset></div></div><!-- ./section-activities --></div></section>');
$templateCache.put('app/entities/crm-opportunity/crm-opportunity-new-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Create an Opportunity</h4></div><div class="modal-body"><fieldset><legend>Opportunity Info</legend><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6"><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.opportunity.firstName?(editForm.firstName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="firstName">First Name:</label> <input type="text" class="form-control" id="firstName" name="firstName" required ng-model="vm.opportunity.firstName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.opportunity.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.opportunity.firstName && editForm.firstName.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.opportunity.firstName">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.middleName}"><label for="middleName">Middle Name:</label> <input type="text" class="form-control" id="middleName" name="middleName" ng-model="vm.opportunity.middleName"> <span class="help-block help-warning" ng-show="!vm.opportunity.middleName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.opportunity.lastName?(editForm.lastName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="lastName">Last Name:</label> <input type="text" class="form-control" id="lastName" name="lastName" required ng-model="vm.opportunity.lastName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.opportunity.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.opportunity.lastName && editForm.lastName.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.opportunity.lastName">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.preferredName}"><label for="preferredName">Preferred Name:</label> <input type="text" class="form-control" id="preferredName" name="preferredName" ng-model="vm.opportunity.preferredName"> <span class="help-block help-warning" ng-show="!vm.opportunity.preferredName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.opportunity.dob?(editForm.dob.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="dob">D.O.B.:</label><div class="input-group"><input type="text" class="form-control" id="dob" name="dob" placeholder="mm/dd/yyyy" required ng-model="vm.opportunity.dob" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dob" datepicker-options="bodOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.opportunity.dob"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.opportunity.dob && editForm.dob.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.opportunity.dob">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.ssn}"><label for="ssn">SSN:</label> <input type="text" class="form-control" id="ssn" name="ssn" ng-model="vm.opportunity.ssn" ui-mask="999-99-9999"> <span class="help-block help-warning" ng-show="!vm.opportunity.ssn">This field is suggested</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.sex}"><label for="sex">Gender:</label> <select class="form-control" id="sex" name="sex" ng-model="vm.opportunity.sex" ng-options="item as item for item in vm.gender track by item"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.sex">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.opportunity.admissionDate?(editForm.admissionDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="admissionDate">Admission Date:</label><div class="input-group"><input type="text" class="form-control" id="admissionDate" name="admissionDate" placeholder="mm/dd/yyyy" required ng-model="vm.opportunity.admissionDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.admissionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'admissionDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.opportunity.admissionDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.opportunity.admissionDate && editForm.admissionDate.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.opportunity.admissionDate">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.facility}"><label for="facility">Target Facility:</label> <select class="form-control" id="facility" name="facility" ng-model="vm.opportunity.facility" ng-options="item as item.name for item in vm.facilities track by item.name"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.facility">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.contactName}"><label for="contactName">Contact Name:</label> <input type="text" class="form-control" id="contactName" name="contactName" ng-model="vm.opportunity.contactName"> <span class="help-block help-warning" ng-show="!vm.opportunity.contactName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.contactRelationship}"><label for="contactRelationship">Contact Relationship:</label> <input type="text" class="form-control" id="contactRelationship" name="contactRelationship" ng-model="vm.opportunity.contactRelationship"> <span class="help-block help-warning" ng-show="!vm.opportunity.contactRelationship">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.contactPhone}"><label for="contactPhone">Contact Phone:</label> <input type="text" class="form-control" id="contactPhone" name="contactPhone" ng-model="vm.opportunity.contactPhone" ui-mask="(999) 999-9999"> <span class="help-block help-warning" ng-show="!vm.opportunity.contactPhone">This field is suggested</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.contactDate}"><label for="contactDate">Date 1<sup>st</sup> Contact:</label><div class="input-group"><input type="text" class="form-control" id="contactDate" name="contactDate" placeholder="mm/dd/yyyy" ng-model="vm.opportunity.contactDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.contactDate"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'contactDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><span class="help-block help-warning" ng-show="!vm.opportunity.contactDate">This field is suggested</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.levelCare}"><label for="levelCare">Target Level Of Care:</label> <select class="form-control" id="levelCare" name="levelCare" ng-model="vm.opportunity.levelCare" ng-options="item as item.name for item in vm.typeLevelCare track by item.name"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.levelCare">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.opportunity.status?(editForm.status.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="status">Status:</label> <select name="status" id="status" class="form-control" required ng-model="vm.opportunity.status" ng-options="item as item.name for item in vm.status track by item.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.opportunity.status"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.opportunity.status && editForm.status.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.opportunity.status">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.campaign}"><label for="field_campaign">Campaign:</label><ui-select ng-model="vm.opportunity.campaign" name="campaign" id="field_campaign" reset-search-input="true" close-on-select="true" title="Campaign" close-on-select="false"><ui-select-match placeholder="Select Campaign ..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="crmCampaign in vm.crmCampaigns" refresh="vm.getCrmCampaign($select.search)" refresh-delay="0"><div ng-bind-html="crmCampaign.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.opportunity.campaign">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.paymentMethod}"><label for="paymentMethod">Payment Method:</label> <select class="form-control" id="paymentMethod" name="paymentMethod" ng-model="vm.opportunity.paymentMethod" ng-options="item as item.name for item in vm.paymentMethod track by item.name"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.paymentMethod">This field is suggested</span></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-12 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.address}"><label for="address">Address:</label> <input type="text" class="form-control" id="address" name="address" ng-model="vm.opportunity.address"> <span class="help-block help-warning" ng-show="!vm.opportunity.address">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.address2}"><label for="address2">2<sup>nd</sup> Address:</label> <input type="text" class="form-control" id="address2" name="address2" ng-model="vm.opportunity.address2"> <span class="help-block help-warning" ng-show="!vm.opportunity.address2">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.city}"><label for="city">City:</label> <input type="text" class="form-control" id="city" name="city" ng-model="vm.opportunity.city"> <span class="help-block help-warning" ng-show="!vm.opportunity.city">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.state}"><label for="state">State:</label> <select class="form-control" id="state" name="state" ng-model="vm.opportunity.state" ng-options="item as item.state for item in vm.states track by item.id"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.state">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.zipCode}"><label for="zipCode">Zip Code:</label> <input type="text" class="form-control" id="zipCode" name="zipCode" ng-model="vm.opportunity.zipCode" ui-mask="99999"> <span class="help-block help-warning" ng-show="!vm.opportunity.zipCode">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-error\': vm.form.phone.$error.required}"><label for="phone">Phone:</label> <input type="text" class="form-control" id="phone" name="phone" required="" ng-model="vm.opportunity.phone" ui-mask="(999) 999-9999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.opportunity.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.opportunity.phone && editForm.phone.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.opportunity.phone">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.altPhone}"><label for="altPhone">Alt. Phone:</label> <input type="text" class="form-control" id="altPhone" name="altPhone" ng-model="vm.opportunity.altPhone" ui-mask="(999) 999-9999"> <span class="help-block help-warning" ng-show="!vm.opportunity.altPhone">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.email}"><label for="email">Email:</label> <input type="text" class="form-control" id="email" name="email" ng-model="vm.opportunity.email"> <span class="help-block help-warning" ng-show="!vm.opportunity.email">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.maritalStatus}"><label for="maritalStatus">Marital Status:</label> <select class="form-control" id="maritalStatus" name="maritalStatus" ng-model="vm.opportunity.maritalStatus" ng-options="item as item.name for item in vm.maritalStatus track by item.name"><option selected="selected"></option></select> <span class="help-block help-warning" ng-show="!vm.opportunity.maritalStatus">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.race}"><label for="race">Race:</label> <select class="form-control" id="race" name="race" ng-model="vm.opportunity.race" ng-options="item as item.name for item in vm.race track by item.name"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.race">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.ethnicity}"><label for="ethnicity">Ethnicity:</label> <select class="form-control" name="ethnicity" ng-model="vm.opportunity.ethnicity" id="ethnicity" ng-options="item as item.name for item in vm.ethnicity track by item.name"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.ethnicity">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.referral}"><label for="referral">Referral:</label> <select class="form-control" name="referral" ng-model="vm.opportunity.referral" id="referral" ng-options="item as item.name for item in vm.referrals track by item.name"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.referral">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.marketer}"><label for="marketer">Outreach:</label> <select type="text" class="form-control" id="marketer" name="marketer" ng-model="vm.opportunity.marketer" ng-options="item as item.firstName + \' \' + item.lastName for item in vm.marketer track by item.firstName + item.lastName"></select> <span class="help-block help-warning" ng-show="!vm.opportunity.marketer">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_assignReviewers">Assignee:</label><ui-select id="field_assignReviewers" name="assignReviewers" reset-search-input="false" ng-model="vm.opportunity.assignee" title="Assignee..."><ui-select-match allow-clear="true" placeholder="Assignee...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.occupation}"><label for="occupation">Occupation:</label> <input type="text" class="form-control" id="occupation" name="occupation" ng-model="vm.opportunity.occupation"> <span class="help-block help-warning" ng-show="!vm.opportunity.occupation">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.employer}"><label for="employer">Employer:</label> <input type="text" class="form-control" id="employer" name="employer" ng-model="vm.opportunity.employer"> <span class="help-block help-warning" ng-show="!vm.opportunity.employer">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="{\'has-warning\': !vm.opportunity.employerPhone}"><label for="employerPhone">Employer Phone:</label> <input type="text" class="form-control" id="employerPhone" name="employerPhone" ng-model="vm.opportunity.employerPhone" ui-mask="(999) 999-9999"> <span class="help-block help-warning" ng-show="!vm.opportunity.employerPhone">This field is suggested</span></div></div></div><!-- ./row --></div></div></fieldset></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/crm-opportunity-outbound-referral-dialog.html','<form action=""><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Outbound Referral</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="referralTo">Referral To:</label> <input type="text" id="referralTo" class="form-control" ng-model="vm.referralTo"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="statusOutboundReferral">Status:</label> <select name="statusOutboundReferral" id="statusOutboundReferral" class="form-control"><option value="01">Pending</option><option value="02">Heaven Detox</option><option value="03"></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="marketer">Outreach:</label> <input type="text" id="marketer" class="form-control" ng-model="vm.marketer"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="dateOfAdmission">D.O.A. to Facility:</label><div class="input-group"><input type="text" class="form-control" id="dateOfAdmission" name="dateOfAdmission" placeholder="mm/dd/yyyy" ng-model="vm.outbound.dateOfAdmission" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dateOfAdmission"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfAdmission\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="outboundFacility">Facility:</label> <select name="outboundFacility" id="outboundFacility" class="form-control"><option value="01">Facility 01</option><option value="02">Facility 02 Lorem Ipsum</option><option value="03">Exsul peritus torquis est.</option></select></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/crm-opportunity-private-pay-dialog.html','<form action=""><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Private Pay Information</h4></div><div class="modal-body"><div class="row"><fieldset><legend>Length of Days:</legend><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="detoxDays">Detox:</label> <input type="text" class="form-control" id="detoxDays" ng-model="vm.detoxDays" ui-mask="9?9?9?"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="residentialDays">Residentials:</label> <input type="text" class="form-control" id="residentialDays" ng-model="vm.residentialDays" ui-mask="9?9?9?"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="phpDays">Residentials:</label> <input type="text" class="form-control" id="phpDays" ng-model="vm.phpDays" ui-mask="9?9?9?"></div></div></fieldset><fieldset class="mb-30"><legend>Financial</legend><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="totalToPay">Total Agree To Pay:</label> <input type="number" class="form-control" id="totalToPay" min="0" ng-model="vm.totalToPay"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form group"><label for="depositToPay">Deposit:</label> <input type="number" class="form-control" id="depositToPay" min="0" ng-model="vm.depositToPay"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="detoxCost">Overall Detox Cost:</label> <input type="number" class="form-control" id="detoxCost" min="0" ng-model="vm.detoxCost"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="residentialCost">Overall Residential:</label> <input type="number" class="form-control" id="residentialCost" min="0" ng-model="vm.residentialCost"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="phpCost">Overall P.H.P.:</label> <input type="number" class="form-control" id="phpCost" min="0" ng-model="vm.phpCost"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="rentalHousingCost">Rental/Housing Cost:</label> <input type="number" class="form-control" id="rentalHousingCost" min="0" ng-model="vm.rentalHousingCost"></div></div></fieldset></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/crm-opportunity.html','<div class="floating-menu" ng-show="vm.activeTab > 0"><button type="button" class="ham-btn dots-layout" ng-model="vm.floatingMenuStatus" ng-click="vm.toggleFloatingMenu($event)" ng-class="{\'open\': vm.floatingMenuStatus, \'closed\': !vm.floatingMenuStatus}"><span class="dot"></span></button><div class="float-menu"><ul class="list-unstyled"><li class="l-item"><a ng-click="vm.addCrmNote()"><span class="text">Create Note</span> <span class="icon"><i class="fa fa-file-text" aria-hidden="true"></i></span></a></li><li class="l-item"><a ng-click="vm.addCrmTask()"><span class="text">Create Task</span> <span class="icon"><i class="fa fa-calendar-check-o" aria-hidden="true"></i></span></a></li><li class="l-item"><a ng-click="vm.addCrmEmail()"><span class="text">Create Emails</span> <span class="icon"><i class="fa fa-envelope" aria-hidden="true"></i></span></a></li><li class="l-item"><a ng-click="vm.addCrmCall()"><span class="text">Create Calls</span> <span class="icon"><i class="fa fa-phone" aria-hidden="true"></i></span></a></li></ul></div></div><section class="content no-padding"><uib-tabset active="vm.activeTab" class="simple-tabs no-tab-padding"><uib-tab index="0" heading="Opportunity"><div ui-view="opportunity"></div></uib-tab><uib-tab ng-repeat="($index, data) in vm.openCrmOpportunities" index="$index + 1"><uib-tab-heading>{{vm.getTabName(data)}} <span class="close-tab" aria-label="close" ng-click="vm.removeTab($index, $event)"><i class="fa fa-times" aria-hidden="true"></i></span></uib-tab-heading><div ng-if="data.crmOpportunity.id" class="opportunity-grid"><div class="section-aside"><header class="selector"><select name="previous_crmOpportunities" id="field_previous_crmOpportunities" class="form-control input-sm" ng-model="vm.crmOpportunityProj" ng-options="crmOpportunity as vm.format(crmOpportunity.createdDate) for crmOpportunity in data.crmOpportunities track by crmOpportunity.id"><option value=""></option></select></header><section class="data-section op-photo-info"><div class="photo"><!--Add here crop image directive. The old directive was deleted--></div><div class="info"><h5 class="name mt-0 mb-0" style="margin-bottom: 5px"><strong>{{data.crmOpportunity.crmAccount | patientName}}</strong> <span class="label label-danger text-uppercase">{{data.crmOpportunity.priority}}</span></h5><p class="mb-0">{{data.crmOpportunity.crmAccount.dob | date: \'MMMM d, y\'}}</p><p class="mb-0">{{data.crmOpportunity.crmAccount.gender | empty}}</p><p class="mb-0">{{data.crmOpportunity.status | empty : \'name\'}}</p><div class="tags" ng-if="data.tags && data.tags.length > 0"><span class="tag" ng-repeat="tag in data.tags">{{tag.name}}</span></div></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-basic-info.html\'" popover-title="Basic Info" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><div class="data-sections"><section class="data-section"><div class="info"><label>SSN:</label><p>{{data.crmOpportunity.ssn | ssnFormat}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-ssn.html\'" popover-title="Social Security Number" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Address:</label><p>{{data.crmOpportunity.address}} {{data.crmOpportunity.address2}}</p><p>{{data.crmOpportunity.city}}, {{data.crmOpportunity.state.stateCode}} {{data.crmOpportunity.zipCode}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-address.html\'" popover-title="Address Information:" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Comnunication:</label><p><strong>PHONE:</strong> {{data.crmOpportunity.phone | phone}}</p><p><strong>ALT PHONE:</strong> {{data.crmOpportunity.altPhone | phone}}</p><p><strong>EMAIL:</strong> {{data.crmOpportunity.email}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-communication.html\'" popover-title="Communication:" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Targeted Information:</label><p><strong>Facility:</strong> {{data.crmOpportunity.facility | empty : \'name\'}}</p><p><strong>Admission Date:</strong> {{data.crmOpportunity.admissionDate | date: \'MMMM d, y\'}}</p><p><strong>Level of Care:</strong> {{data.crmOpportunity.levelCare | empty : \'name\'}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-targeted-information.html\'" popover-title="Targeted Information:" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Lead Information:</label><p><strong>Referral Source:</strong> {{data.crmOpportunity.referral | empty : \'name\'}}</p><p><strong>Campaign:</strong> {{data.crmOpportunity.campaign | empty : \'name\'}}</p><p><strong>Outreach:</strong> {{data.crmOpportunity.marketer | employeeName}}</p><p><strong>Admission Rep.:</strong> {{data.crmOpportunity.assignee | employeeName}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-lead-information.html\'" popover-title="Lead Information:" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Additional Information:</label><p><strong>Ethnicity:</strong> {{data.crmOpportunity.ethnicity | empty : \'name\'}}</p><p><strong>Race:</strong> {{data.crmOpportunity.race | empty : \'name\'}}</p><p><strong>Marital Status:</strong> {{data.crmOpportunity.maritalStatus | empty : \'name\'}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-additional-information.html\'" popover-title="Additional Information:" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>1<sup>st</sup> Contact:</label><p><strong>Name:</strong> {{data.crmOpportunity.contactName | empty}}</p><p><strong>Relationship:</strong> {{data.crmOpportunity.contactRelationship | empty}}</p><p><strong>Phone:</strong> {{data.crmOpportunity.contactPhone | phone}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-contact.html\'" popover-title="Contact Information:" popover-placement="right-top" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Employer Information:</label><p><strong>Employer:</strong> {{data.crmOpportunity.employer | empty}}</p><p><strong>Occupation:</strong> {{data.crmOpportunity.occupation | empty}}</p><p><strong>Phone:</strong> {{data.crmOpportunity.employerPhone | phone}}</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-employer-information.html\'" popover-title="Employer Information:" popover-placement="right" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Outbound Referral:</label><p><strong>Facility:</strong></p><p><strong>Outreach:</strong></p><p><strong>Referred To:</strong></p><p><strong>DOA To Facility:</strong></p><p><strong>Status:</strong></p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-outbound-referral.html\'" popover-title="Outbound Referral:" popover-placement="top-right" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Primary Insurance:</label><p><strong>Carrier:</strong> Blue Cross and Blue Shield of Florida</p><p><strong>Policy:</strong> BCBS122345678987</p><p><strong>Group Number:</strong> 12345678TG-RF33</p><p><strong>Pre-Cert Number:</strong> 123-123-1212</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-insurance-information.html\'" popover-title="Primary Insurance:" popover-placement="top-right" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section><section class="data-section"><div class="info"><label>Secondary Insurance</label><p><strong>Carrier:</strong> Florida Blue</p><p><strong>Policy:</strong> BCBS122345678987</p><p><strong>Group Number:</strong> 12345678TG-RF33</p><p><strong>Pre-Cert Number:</strong> 123-123-1212</p></div><div class="edit"><a href="" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-insurance2-information.html\'" popover-title="Secondary Insurance:" popover-placement="top-right" popover-trigger="outsideClick"><i class="fa fa-pencil" aria-hidden="true"></i></a></div></section></div></div><div class="section-activities"><div class="activities-content"><uib-tabset active="0" justified="true"><uib-tab index="0" heading="Activity"><ng-include src="\'app/entities/crm-opportunity/tabs/activity.html\'"></ng-include></uib-tab><uib-tab index="1" heading="Notes"><ng-include src="\'app/entities/crm-note/crm-notes.html\'"></ng-include></uib-tab><uib-tab index="2" heading="Tasks"><ng-include src="\'app/entities/crm-task/crm-tasks.html\'"></ng-include></uib-tab><uib-tab index="3" heading="Emails"><ng-include src="\'app/entities/crm-email/crm-emails.html\'"></ng-include></uib-tab><uib-tab index="4" heading="Calls"><ng-include src="\'app/entities/crm-call/crm-calls.html\'"></ng-include></uib-tab><uib-tab index="5" heading="Travels"><ng-include src="\'app/entities/crm-opportunity/tabs/travels.html\'"></ng-include></uib-tab><uib-tab index="6" heading="Documents"><ng-include src="\'app/entities/crm-opportunity/tabs/documents.html\'"></ng-include></uib-tab><uib-tab index="7" heading="Financial"><ng-include src="\'app/entities/crm-opportunity/tabs/financials.html\'"></ng-include></uib-tab><!--<uib-tab index="8" heading="Attachments">--><!--<ng-include src="\'app/entities/crm-opportunity/tabs/attachments.html\'"></ng-include>--><!--</uib-tab>--></uib-tabset></div></div><!-- ./section-activities --></div><div ng-if="!data.crmOpportunity.id" class="opportunity-grid"><div class="section-aside"><header class="selector"><select name="" id="" class="form-control input-sm" disabled="disabled"><option value="01"></option></select></header><section class="data-section op-photo-info blurred" style="cursor: pointer;" uib-popover-template="\'app/entities/crm-opportunity/tpl/popup-create-basic-info.html\'" popover-title="Basic Info" popover-placement="right-top" popover-is-open="vm.activeTab == ($index + 1)"><div class="photo"><img src="content/images/avatar.png" alt="Opportunity Photo" class="img-thumbnail img-responsive"></div><div class="info"><h5 class="name mt-0 mb-0" style="margin-bottom: 5px"></h5><p class="mb-0"></p><p class="mb-0"></p><p class="mb-0"></p><div class="tags"><span class="tag"></span> <span class="tag"></span> <span class="tag"></span></div></div></section><section class="data-section blurred" ng-repeat="i in [1,2,3,4,5,6]"><p class="p"></p><p class="p"></p><p class="p"></p><p class="p"></p></section></div><div class="section-activities"><div class="activities-content"><uib-tabset active="0" justified="true" class="blurred"><uib-tab index="0"><div class="mockup-layout"><div class="head"><span class="blurred-control"></span> <span class="blurred-control"></span> <span class="blurred-control"></span></div><div class="top-graph"><div class="big"></div><div class="small"></div></div><div class="bottom-graph"><div class="blurred-card" ng-repeat="i in [1,2,3,4]"><div class="head"><span class="blurred-title"></span></div><div class="body"><span class="blurred-lines" ng-repeat="i in [1,2,3,4,5]"></span></div><div class="footer"><span class="blurred-control"></span> <span class="blurred-control"></span></div></div></div></div></uib-tab><uib-tab index="1" disable="true"></uib-tab><uib-tab index="2" disable="true"></uib-tab><uib-tab index="3" disable="true"></uib-tab><uib-tab index="4" disable="true"></uib-tab><uib-tab index="5" disable="true"></uib-tab><uib-tab index="6" disable="true"></uib-tab><uib-tab index="7" disable="true"></uib-tab></uib-tabset></div></div></div></uib-tab></uib-tabset></section>');
$templateCache.put('app/entities/crm-opportunity-status/crm-opportunity-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmOpportunityStatus.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Crm Opportunity Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Crm Opportunity Status from the database. Are you sure you want to <strong>delete</strong> this Crm Opportunity Status?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity-status/crm-opportunity-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCrmOpportunityStatusLabel">Create or edit a Crm Opportunity Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.crmOpportunityStatus.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.crmOpportunityStatus.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.crmOpportunityStatus.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_crmOpportunityStatus">Name:</label> <input type="text" class="form-control" name="name" id="field_crmOpportunityStatus" required ng-model="vm.crmOpportunityStatus.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmOpportunityStatus.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmOpportunityStatus.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.crmOpportunityStatus.name">This field is required</span></div><div class="form-group has-feedback" ng-class="vm.crmOpportunityStatus.xorder?(editForm.xorder.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_xOrder">Order</label> <input type="number" class="form-control" name="xorder" id="field_xOrder" required ng-model="vm.crmOpportunityStatus.xorder" min="0"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.crmOpportunityStatus.xorder"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.crmOpportunityStatus.xorder && editForm.xorder.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.crmOpportunityStatus.xorder">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity-status/crm-opportunity-status.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/crm-outbound-referral/crm-outbound-referral-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Outbound Referral</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_crm_referral_source">Facility:</label> <select class="form-control" id="field_crm_referral_source" name="crm_referral_source" ng-model="vm.crmOutboundReferral.crmReferralSource" ng-change="vm.changeCrmReferralSource()" ng-options="crmReferralSource as crmReferralSource.name for crmReferralSource in vm.crmReferralSources track by crmReferralSource.id"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_referralTo">Referral To:</label><ui-select ng-model="vm.crmOutboundReferral.crmReferralContact" name="referralTo" id="field_referralTo" reset-search-input="true" close-on-select="true" title="Referral Contact" close-on-select="false"><ui-select-match placeholder="Select Referral ..." allow-clear="true">{{$select.selected.firstName + " " + $select.selected.lastName}}</ui-select-match><ui-select-choices repeat="referralTo in vm.referralsTo" refresh="vm.getCrmReferralContacts($select.search)" refresh-delay="0"><div ng-bind-html="referralTo.firstName + \' \' + referralTo.lastName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_status">Status:</label> <select class="form-control" id="field_status" name="status" ng-model="vm.crmOutboundReferral.status" ng-options="crmOutBoundReferralStatus as crmOutBoundReferralStatus.name for crmOutBoundReferralStatus in vm.crmOutboundReferralStatuses track by crmOutBoundReferralStatus.id"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_marketer">Outreach:</label><ui-select id="field_marketer" name="marketer" reset-search-input="false" ng-model="vm.crmOutboundReferral.marketer" title="Outreach..."><ui-select-match allow-clear="true" placeholder="Assignee...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_doa">D.O.A. to Facility:</label><div class="input-group"><input type="text" class="form-control" id="field_doa" name="doa" ng-model="vm.crmOutboundReferral.doa" uib-datepicker-popup="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.doa"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'doa\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-outbound-referral-status/crm-outbound-referral-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmOutboundReferralStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Crm Outbound Referral Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/crm-outbound-referral-status/crm-outbound-referral-status-detail.html','<div><h2><span>Crm Outbound Referral Status</span> {{vm.crmOutboundReferralStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.crmOutboundReferralStatus.name}}</span></dd><dt><span>Del Status</span></dt><dd><span>{{vm.crmOutboundReferralStatus.delStatus}}</span></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.crmOutboundReferralStatus.corporation.id})">{{vm.crmOutboundReferralStatus.corporation.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="crm-outbound-referral-status-detail.edit({id:vm.crmOutboundReferralStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/crm-outbound-referral-status/crm-outbound-referral-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCrmOutboundReferralStatusLabel">Create or edit a Crm Outbound Referral Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.crmOutboundReferralStatus.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.crmOutboundReferralStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.crmOutboundReferralStatus.name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/crm-outbound-referral-status/crm-outbound-referral-statuses.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/crm-referral-contact/crm-referral-contact-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmReferralContact.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Crm Referral Contact?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-referral-contact/crm-referral-contact-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCrmReferralContactLabel">Create or edit a Crm Referral Contact</h4></div><div class="modal-body"><div class="row mb-30"><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><!--<div class="row">--><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.crmReferralContact.firstName|| editForm.firstName.$error.required?\'has-error\':(editForm.firstName.$valid && editForm.firstName.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_firstName">Name</label> <input type="text" class="form-control" required name="firstName" id="field_firstName" ng-model="vm.crmReferralContact.firstName"> <span class="help-block" ng-show="!vm.crmReferralContact.firstName || editForm.crmReferralContact.$error.required">This field is required.</span></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.crmReferralContact.lastName|| editForm.lastName.$error.required?\'has-error\':(editForm.lastName.$valid && editForm.lastName.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_lastName">LastName</label> <input type="text" class="form-control" required name="lastName" id="field_lastName" ng-model="vm.crmReferralContact.lastName"> <span class="help-block" ng-show="!vm.crmReferralContact.lastName || editForm.crmReferralContact.$error.required">This field is required.</span></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_dob">D.O.B</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_dob" name="dob" ng-model="vm.crmReferralContact.dob" placeholder="mm/dd/yyyy" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_department">Department</label> <input type="text" class="form-control" name="department" id="field_department" ng-model="vm.crmReferralContact.department"></div></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="phone">Phone:</label> <input type="text" class="form-control" id="phone" name="phone" ng-model="vm.crmReferralContact.phone" ui-mask="(999) 999-9999"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_mobile">Mobile</label> <input type="text" class="form-control" name="mobile" id="field_mobile" ui-mask="999-999-9999" ng-model="vm.crmReferralContact.mobile"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_fax">Fax</label> <input type="text" class="form-control" name="fax" id="field_fax" ui-mask="(999)-999-9999" ng-model="vm.crmReferralContact.fax"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_email">Email:</label> <input type="email" class="form-control" id="field_email" placeholder="Email" name="email" ng-model="vm.crmReferralContact.email"></div></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.crmReferralContact.crmReferralSource?(editForm.crmReferralSource.$dirty ?\'has-success\':\'\'):\'has-error\'"><label for="field_referralSource">Referral Source:</label> <select class="form-control" id="field_referralSource" name="crmReferralSource" ng-model="vm.crmReferralContact.crmReferralSource" ng-options="crmReferralSource as crmReferralSource.name for crmReferralSource in vm.crmreferralsources track by crmReferralSource.id" required><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.crmReferralSource.$error.required || editForm.crmReferralSource.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="editForm.crmReferralSource.$dirty && editForm.crmReferralSource.$valid"></span> <span class="help-block" ng-show="editForm.crmReferralSource.$error.required || editForm.crmReferralSource.$invalid">This field is required</span></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_note">Note</label> <textarea class="form-control" name="note" id="field_note" name="note" rows="5" data-resize="disabled" ng-model="vm.crmReferralContact.note"></textarea></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-referral-contact/crm-referral-contact.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/crm-referral-source/crm-referral-source-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmReferralSource.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Crm Referral Source?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-referral-source/crm-referral-source-detail.html','<div><h2><span>Crm Referral Source</span> {{vm.crmReferralSource.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Name</span></dt><dd><span>{{vm.crmReferralSource.name}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.crmReferralSource.description}}</span></dd><dt><span>Website</span></dt><dd><span>{{vm.crmReferralSource.website}}</span></dd><dt><span>Preferred</span></dt><dd><span>{{vm.crmReferralSource.preferred}}</span></dd><dt><span>In Network</span></dt><dd><span>{{vm.crmReferralSource.inNetwork}}</span></dd><dt><span>Address 1</span></dt><dd><span>{{vm.crmReferralSource.address1}}</span></dd><dt><span>Address 2</span></dt><dd><span>{{vm.crmReferralSource.address2}}</span></dd><dt><span>Zip Code</span></dt><dd><span>{{vm.crmReferralSource.zipCode}}</span></dd><dt><span>Primary Contact</span></dt><dd><span>{{vm.crmReferralSource.primaryContact}}</span></dd><dt><span>Phone</span></dt><dd><span>{{vm.crmReferralSource.phone}}</span></dd><dt><span>Status</span></dt><dd><span>{{vm.crmReferralSource.status}}</span></dd><dt><span>Del Status</span></dt><dd><span>{{vm.crmReferralSource.delStatus}}</span></dd><dt><span>State</span></dt><dd><a ui-sref="country-state-detail({id:vm.crmReferralSource.state.id})">{{vm.crmReferralSource.state.id}}</a></dd><dt><span>Account Owner</span></dt><dd><a ui-sref="employee-detail({id:vm.crmReferralSource.accountOwner.id})">{{vm.crmReferralSource.accountOwner.id}}</a></dd><dt><span>Type</span></dt><dd><a ui-sref="crm-referral-source-type-detail({id:vm.crmReferralSource.type.id})">{{vm.crmReferralSource.type.id}}</a></dd><dt><span>Corporation</span></dt><dd><a ui-sref="corporation-detail({id:vm.crmReferralSource.corporation.id})">{{vm.crmReferralSource.corporation.id}}</a></dd><dt><span>Levels Of Care</span></dt><dd><span ng-repeat="levelsOfCare in vm.crmReferralSource.levelsOfCares"><a ui-sref="type-level-care-detail({id: levelsOfCare.id})">{{levelsOfCare.id}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="crm-referral-source-detail.edit({id:vm.crmReferralSource.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/crm-referral-source/crm-referral-source-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCrmOutboudReferralLabel">Create or edit a Crm Referral Source</h4></div><div class="modal-body"><div class="row mb-30"><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><!--<div class="row">--><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.crmReferralSource.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" required name="name" id="field_name" ng-model="vm.crmReferralSource.name"> <span class="help-block" ng-show="!vm.crmReferralSource.name || editForm.crmReferralSource.$error.required">This field is required.</span></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_description">Description</label> <textarea type="text" class="form-control" name="description" id="field_description" ng-model="vm.crmReferralSource.description"></textarea></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_website">Website</label> <input type="text" class="form-control" name="website" id="field_website" ng-model="vm.crmReferralSource.website"></div></div><div class="col-xs-4 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label class="control-label" for="field_preferred">Preferred</label><toggle id="field_preferred" style="display: block;" ng-model="vm.crmReferralSource.preferred" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-4 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label class="control-label" for="field_inNetwork">In Network</label><toggle id="field_inNetwork" style="display: block;" ng-model="vm.crmReferralSource.inNetwork" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_address1">Address 1</label> <input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.crmReferralSource.address1"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_address2">Address 2</label> <input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.crmReferralSource.address2"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_state">State</label> <select class="form-control" id="field_state" name="state" ng-model="vm.crmReferralSource.state" ng-options="countryState as countryState.state for countryState in vm.countrystates track by countryState.id"><option value=""></option></select></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_zipCode">Zip Code</label> <input type="text" class="form-control" name="zipCode" id="field_zipCode" ng-model="vm.crmReferralSource.zipCode"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_typeLevelCare">Type Level Care:</label><ui-select id="field_typeLevelCare" multiple="multiple" name="typeLevelCare" title="Type Level Care" ng-model="vm.crmReferralSource.levelsOfCares" close-on-select="false"><ui-select-match placeholder="{{vm.typelevelcares.length?\'Select Level of cares...\':\'There is no LevelTypeCares to add...\'}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.typelevelcares | filter:$select.search" refresh="" refresh-delay="1"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_primaryContact">Primary Contact</label> <input type="text" class="form-control" name="primaryContact" id="field_primaryContact" ng-model="vm.crmReferralSource.primaryContact"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_phone">Phone</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.crmReferralSource.phone"></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_accountOwner">Account Owner</label><ui-select id="field_accountOwner" name="accountOwner" reset-search-input="false" ng-model="vm.crmReferralSource.accountOwner" title="Account Owner..." ng-required="true"><ui-select-match allow-clear="true" placeholder="Account Owner...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_type">Type</label> <select class="form-control" id="field_type" name="type" ng-model="vm.crmReferralSource.type" ng-options="crmReferralSourceType as crmReferralSourceType.name for crmReferralSourceType in vm.crmreferralsourcetypes track by crmReferralSourceType.id"><option value=""></option></select></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label" for="field_status">Status</label> <select class="form-control" id="field_status" name="state" ng-model="vm.crmReferralSource.status"><option value="true">Activo</option><option value="false">Inactivo</option></select><!--<input type="checkbox" class="form-control" name="status" id="field_status"--><!--ng-model="vm.crmReferralSource.status"--><!--/>--></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-referral-source/crm-referral-sources.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/crm-referral-source-type/crm-referral-source-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmReferralSourceType.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Crm Out Bound Referral Status?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-referral-source-type/crm-referral-source-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCrmOutBoundReferralStatusLabel">Create or edit a Crm Referral Source Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="!vm.crmReferralSourceType.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.crmReferralSourceType.name"> <span class="help-block" ng-show="!vm.crmReferralSourceType.name || editForm.crmReferralSourceType.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-referral-source-type/crm-referral-source-types.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/crm-tag/crm-tag-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmTag.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Crm Tag from the database. Are you sure you want to <strong>delete</strong> this Crm Tag?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-tag/crm-tag-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCrmTagLabel">Create or edit a Crm Tag</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><div class="form-group form-group-sm has-feedback" ng-class="!vm.crmTag.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" required name="name" id="field_name" ng-model="vm.crmTag.name"> <span class="help-block" ng-show="!vm.crmTag.name || editForm.crmTag.$error.required">This field is required.</span></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-tag/crm-tags.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/crm-task/crm-task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.crmTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Crm Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/crm-task/crm-task-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create or edit a Task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.crmTask.name?(vm.editForm.crmTask.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="inputTaskName">Task:</label> <input type="text" class="form-control" id="inputTaskName" name="name" required ng-model="vm.crmTask.name"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="editForm.assignedTo.$invalid ? \'has-error\' : (editForm.assignedTo.$touched || editForm.assignedTo.$dirty ? \'has-success\' : \'\')"><br><ui-select id="field_assignedTo" name="assignedTo" reset-search-input="true" ng-model="vm.crmTask.assignedTo" title="Assigned To" close-on-select="true" required><ui-select-match allow-clear="true" placeholder="Assigned To">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.assignedTo.$error.required"></span> <span class="help-block" ng-show="editForm.assignedTo.$error.required">This field is required</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="dateDueDateTask">Due Date:</label><div class="input-group"><input type="text" class="form-control" id="dateDueDateTask" name="dateDueDateTask" placeholder="mm/dd/yyyy" ng-model="vm.crmTask.dueDate" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dueDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dueDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="dateReminder">Reminder:</label><div class="input-group"><input type="text" class="form-control" id="dateReminder" name="dateReminder" placeholder="mm/dd/yyyy" ng-model="vm.crmTask.reminder" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.reminder"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reminder\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label class="control-label" for="field_description">Description:</label><!--                    <ng-quill-editor ng-model="vm.crmTask.description"--><!--                                     id="field_description"--><!--                                     name="description"--><!--                                     on-editor-created="vm.editorCreated(editor, vm.crmTask.description)"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-task/crm-tasks.html','<div class="generic-activities"><div class="pinned-items"><div class="activity-item" ng-repeat="task in vm.pinCrmTasks"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>{{task.createdBy}}</strong></p><span class="date">{{task.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" ng-if="vm.isOwner(task)" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(task.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = task.id"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body task"><h5 class="mt-0" ng-class="{\'strikeout\': task.completed}"><input type="checkbox" ng-click="vm.completed(task)" ng-model="task.completed"> <strong>{{task.name}}</strong> <span class="label label-danger text-uppercase">Overdue</span></h5><div class="text" ng-bind-html="vm.trustAsHtml(task.description)"></div></div><footer class="activity-footer"><div class="credentials"><span class="small">Assigned To:</span><p class="name mb-0">{{task.assignedTo.firstName + " " + task.assignedTo.lastName}}</p></div><div class="credentials"><span class="small">Due Date:</span><p class="name mb-0">{{task.dueDate | date: inputDateTimeFormatA}}</p></div><div class="credentials"><span class="small">Reminder:</span><p class="name mb-0">{{task.reminder | date: inputDateTimeFormatA}}</p></div><div class="btns-actions" ng-if="vm.isOwner(task)" ng-class="{\'overlayActive\': vm.confirmDelete == task.id}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Task?</p><div ng-if="vm.confirmDelete && vm.confirmDelete == task.id"><button type="button" class="btn btn-success btn-sm" ng-click="vm.del(task.id)"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = null"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-default btn-sm btn-toggle-pin" ng-click="vm.pin(task)"><i class="fa fa-bookmark" aria-hidden="true"></i> Pinned</button></div></footer></div></div><div class="activity-item" ng-repeat="task in data.tasks.crmTasks"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>{{task.employee.firstName + " " + task.employee.lastName}}</strong></p><span class="date">{{task.createdDate | date: "MMM dd, yyyy \'at\' hh:mm a"}}</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" ng-if="vm.isOwner(task)" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(task.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = task.id"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body task"><h5 class="mt-0" ng-class="{\'strikeout\': task.completed}"><input type="checkbox" ng-click="vm.completedCrmTask(task)" ng-model="task.completed"> <strong>{{task.name}}</strong> <span class="label label-danger text-uppercase">Overdue</span></h5><div class="text" ng-bind-html="vm.trustAsHtml(task.description)"></div></div><footer class="activity-footer"><div class="credentials"><span class="small">Assigned To:</span><p class="name mb-0">{{task.assignedTo.firstName + " " + task.assignedTo.lastName}}</p></div><div class="credentials"><span class="small">Due Date:</span><p class="name mb-0">{{task.dueDate | date: inputDateTimeFormatA}}</p></div><div class="credentials"><span class="small">Reminder:</span><p class="name mb-0">{{task.reminder | date: inputDateTimeFormatA}}</p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete == task.id}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Task?</p><div ng-if="vm.confirmDelete && vm.confirmDelete == task.id"><button type="button" class="btn btn-success btn-sm" ng-click="vm.del(task.id)"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = null"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-default btn-sm btn-toggle-pin" ng-click="vm.pinCrmTask(task)"><i class="{{task.pin ? \'fa fa-bookmark\' : \'fa fa-bookmark-o\'}}" aria-hidden="true"></i> {{task.pin ? \'Unpin\' : \'Pin\'}}</button></div></footer></div><div class="fright"><jhi-item-count page="data.tasks.page" total="data.tasks.totalItems" items-per-page="data.tasks.totalItems"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="data.tasks.totalItems" items-per-page="data.tasks.size" ng-model="data.tasks.page" ng-change="vm.getUnpin()"></ul></div></div>');
$templateCache.put('app/entities/employee-new-chart/new-chart-preview-dialog.html','<form name="inviteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Feature preview</h4></div><div class="modal-body"><p class="delete-text">Welcome to the new BlueBook Chart.</p><p class="delete-text">The option to switch back and forth of viewing the chart is available below.</p><p class="delete-text">Click the button and experience the difference.</p><div><img style="border: 2px solid #fff; box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);" id="imgPicture" alt="Feature picture" src="content/images/new-chart-preview.png"></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.change()"><i class="fa fa-random" aria-hidden="true"></i> Change</button></div></form>');
$templateCache.put('app/entities/icd-10/diagnosis-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDiagnosisLabel">List of diagnosis (ICD10)</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><table class="table table-bordered"><thead><tr><th style="width: 10px">#</th><th>ICD 10</th><th>Description</th></tr></thead><tbody><tr ng-repeat="diagnosis in vm.diagnoses"><td>{{$index + 1}}</td><td>{{diagnosis.code}}</td><td>{{diagnosis.description}}</td></tr></tbody></table><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div></div></form>');
$templateCache.put('app/entities/inst-claim-conf/inst-claim-conf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.instClaimConf.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Inst Claim Conf?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/inst-claim-conf/inst-claim-conf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInstClaimConfLabel">Create or edit a Inst Claim Conf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="orders-list"><div class="order-item" ng-repeat="($index, instClaimConf) in vm.instClaimConfs"><header class="order-header mb-15" ng-if="!instClaimConf.id"><h4 class="order-name"><button type="button" class="btn btn-default btn-sm" ng-click="instClaimConf.collapsed = !instClaimConf.collapsed"><i class="fa" aria-hidden="true" ng-class="instClaimConf.collapsed?\'fa-chevron-right\':\'fa-chevron-down\'"></i></button> <span>Institutional Claim Config {{$index + 1}}</span></h4><button type="button" class="btn btn-danger" ng-click="vm.deleteInstClaimConf($index)" ng-if="vm.instClaimConfs.length > 1"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button></header><div class="order-content well well-sm" uib-collapse="instClaimConf.collapsed"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-15"><div class="form-group form-group-sm has-feedback" ng-class="instClaimConf.minTime == null ? \'has-error\' : \'has-success\'"><label for="field_minTime{{$index}}">Min Time:</label> <input name="minTime{{$index}}" id="field_minTime{{$index}}" ng-model="instClaimConf.minTime" type="number" class="form-control input-sm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="1" min="0" placeholder="0.00" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="instClaimConf.minTime == null"></span> <span class="help-block" aria-hidden="true" ng-show="instClaimConf.minTime == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-15"><div class="form-group form-group-sm has-feedback" ng-class="instClaimConf.maxTime == null ? \'has-error\' : \'has-success\'"><label for="field_maxTime{{$index}}">Max Time:</label> <input name="maxTime{{$index}}" id="field_maxTime{{$index}}" ng-model="instClaimConf.maxTime" type="number" class="form-control input-sm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="1" min="0" placeholder="0.00" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="instClaimConf.maxTime == null"></span> <span class="help-block" aria-hidden="true" ng-show="instClaimConf.maxTime == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-15"><div class="form-group form-group-sm"><label for="field_default">Default:</label><br><toggle id="field_default" ng-model="instClaimConf.isDefault" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group has-feedback" ng-class="!instClaimConf.isDefault ? (instClaimConf.insuranceCarriers == null || instClaimConf.insuranceCarriers.length === 0) ? \'has-error\' : \'has-success\' : null"><label for="field_insuranceCarrier{{$index}}">Carriers:</label><ui-select multiple="multiple" name="insuranceCarrier{{$index}}" id="field_insuranceCarrier{{$index}}" title="Select insurance carrier" ng-required="!instClaimConf.isDefault" ng-model="instClaimConf.insuranceCarriers" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Insurance Carriers ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="insuranceCarrier in vm.insuranceCarriers | filter: $select.search" refresh="vm.getInsuranceCarriers($select.search)" refresh-delay="0"><div ng-bind-html="insuranceCarrier.name"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!instClaimConf.isDefault && (instClaimConf.insuranceCarriers == null || instClaimConf.insuranceCarriers.length === 0)"></span> <span class="help-block" ng-show="!instClaimConf.isDefault && (instClaimConf.insuranceCarriers == null || instClaimConf.insuranceCarriers.length === 0)">This field is required</span></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group has-feedback" ng-class="instClaimConf.levelOfCares == null ? \'has-error\' : \'has-success\'"><label for="field_typeLevelCare{{$index}}">Level of Care:</label><ui-select id="field_typeLevelCare{{$index}}" multiple="multiple" name="typeLevelCare{{$index}}" title="Type Level Care" ng-model="instClaimConf.levelOfCares" close-on-select="false"><ui-select-match placeholder="{{vm.typelevelcares.length?\'Select Level of cares...\':\'There is no LevelTypeCares to add...\'}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.typelevelcares | filter:$select.search" refresh="" refresh-delay="1"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="instClaimConf.levelOfCares == null"></span> <span class="help-block" ng-show="instClaimConf.levelOfCares == null">This field is required</span></div></div></div><fieldset><legend>Cpts</legend><div ng-repeat="($f_index, cptConfig) in instClaimConf.instCptConfs" class="frequency-day"><header style="flex-wrap: wrap; margin-bottom: 20px"><h4 class="day-number" style="width: 100%;"><strong>Cpt</strong></h4><div class="select-frequency form-group has-feedback" ng-class="cptConfig.cpt == null ? \'has-error\' : \'has-success\'" style="margin-left: 0"><ui-select name="cpt_{{$index}}{{$f_index}}" id="field_cpt_{{$index}}{{$f_index}}" title="Select cpt" ng-model="cptConfig.cpt" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="true" required style="min-width: 240px; background-color: white"><ui-select-match allow-clear="true" placeholder="Enter a Cpt...">{{$select.selected.code}} - {{$select.selected.shortDesc}}</ui-select-match><ui-select-choices repeat="cpt in vm.cpts | filter: $select.search" refresh="vm.getCpts($select.search)" refresh-delay="0"><div ng-bind-html="cpt.code"></div><small ng-bind-html="cpt.shortDesc | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="cptConfig.cpt == null"></span> <span class="help-block" aria-hidden="true" ng-show="cptConfig.cpt == null">This field is required</span></div><button type="button" class="btn btn-danger" ng-if="instClaimConf.instCptConfs.length > 1 && cptConfig.confirm == null" ng-click="cptConfig.confirm = true"><i class="fa fa-trash" aria-hidden="true"></i> Delete Cpt</button><div style="margin-left: auto" ng-if="cptConfig.confirm == true"><button type="button" class="btn btn-success" ng-click="vm.deleteInstCptConf(instClaimConf, $f_index)"><i class="fa fa-trash" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger" ng-click="cptConfig.confirm = null"><i class="fa fa-trash" aria-hidden="true"></i> No</button></div></header><header style="flex-wrap: wrap; margin-bottom: 20px"><h4 class="day-number" style="width: 100%;"><strong>Rev Code</strong></h4><div class="select-frequency form-group" style="margin-left: 0"><ui-select name="revCode_{{$index}}{{$f_index}}" id="field_revCode_{{$index}}{{$f_index}}" title="Select Rev Code" ng-model="cptConfig.revCode" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="true" style="min-width: 240px; background-color: white"><ui-select-match allow-clear="true" placeholder="Enter a Rev Code...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="revCode in vm.revCodes | filter: $select.search" refresh="vm.getRevCodes($select.search)" refresh-delay="0"><div ng-bind-html="revCode.code"></div></ui-select-choices></ui-select></div></header><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-15"><div class="form-group form-group-sm has-feedback" ng-class="cptConfig.rate == null ? \'has-error\' : \'has-success\'"><label for="field_rate{{$index}}{{$f_index}}">Rate:</label> <input name="rate{{$index}}{{$f_index}}" id="field_rate{{$index}}{{$f_index}}" ng-model="cptConfig.rate" type="number" class="form-control input-sm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="1" min="0" placeholder="0.00"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="cptConfig.rate == null"></span> <span class="help-block" aria-hidden="true" ng-show="cptConfig.rate == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-15"><div class="form-group form-group-sm has-feedback" ng-class="cptConfig.quantity == null ? \'has-error\' : \'has-success\'"><label for="field_quantity{{$index}}{{$f_index}}">Quantity:</label> <input name="quantity{{$index}}{{$f_index}}" id="field_quantity{{$index}}{{$f_index}}" ng-model="cptConfig.quantity" type="number" class="form-control input-sm" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="1" min="0" placeholder="0.00"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="cptConfig.quantity == null"></span> <span class="help-block" aria-hidden="true" ng-show="cptConfig.quantity == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-15"><div class="form-group form-group-sm has-feedback" ng-class="cptConfig.unit == null ? \'has-error\' : \'has-success\'"><label class="control-label" for="field_unit{{$index}}{{$f_index}}">Unit:</label> <select class="form-control" name="unit{{$index}}{{$f_index}}" ng-model="cptConfig.unit" id="field_unit{{$index}}{{$f_index}}" required><option value="UNITS">UNITS</option><option value="MINUTES">MINUTES</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="cptConfig.unit == null"></span> <span class="help-block" aria-hidden="true" ng-show="cptConfig.unit == null">This field is required</span></div></div></div><div class="schedule-times"><table class="table table-condensed"><thead><tr><th><strong>Modifiers:</strong></th></tr></thead><tbody><tr><td><ui-select multiple="multiple" name="modifier_{{$index}}_{{$f_index}}" id="field_modifier_{{$index}}_{{$f_index}}" title="Select modifiers" ng-model="cptConfig.modifiers" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Modifiers ...">{{$item.code}} - {{$item.shortDesc}}</ui-select-match><ui-select-choices repeat="modifier in vm.modifiers | filter: $select.search" refresh="vm.getModifiers($select.search)" refresh-delay="0"><div ng-bind-html="modifier.code"></div><small ng-bind-html="modifier.shortDesc | highlight: $select.search"></small></ui-select-choices></ui-select></td></tr></tbody></table></div></div><div class="text-right"><button type="button" class="btn btn-primary" ng-click="vm.addCpt(instClaimConf)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Cpt</button></div></fieldset></div></div></div><hr ng-if="!(vm.instClaimConfs.length == 1 && vm.instClaimConfs[0].id)"><div class="text-center mb-15" ng-if="!(vm.instClaimConfs.length == 1 && vm.instClaimConfs[0].id)"><button type="button" class="btn btn-warning" ng-click="vm.addConf()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Inst Claim Conf</button></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.instClaimConfs == null || vm.instClaimConfs.length == 0 || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/inst-claim-conf/inst-claim-confs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/insurance-carrier/insurance-carrier-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.insuranceCarrier.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Insurance Carrier?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/insurance-carrier/insurance-carrier-detail.html','<div><h2><span>Insurance Carrier</span> {{vm.insuranceCarrier.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Acctno</span></dt><dd><span>{{vm.insuranceCarrier.acctno}}</span></dd><dt><span>Name</span></dt><dd><span>{{vm.insuranceCarrier.name}}</span></dd><dt><span>Address</span></dt><dd><span>{{vm.insuranceCarrier.address}}</span></dd><dt><span>Address 2</span></dt><dd><span>{{vm.insuranceCarrier.address2}}</span></dd><dt><span>City</span></dt><dd><span>{{vm.insuranceCarrier.city}}</span></dd><dt><span>State</span></dt><dd><span>{{vm.insuranceCarrier.state}}</span></dd><dt><span>Zip</span></dt><dd><span>{{vm.insuranceCarrier.zip}}</span></dd><dt><span>Phone</span></dt><dd><span>{{vm.insuranceCarrier.phone}}</span></dd><dt><span>I Type</span></dt><dd><span>{{vm.insuranceCarrier.iType}}</span></dd><dt><span>Etin</span></dt><dd><span>{{vm.insuranceCarrier.etin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="insurance-carrier-detail.edit({id:vm.insuranceCarrier.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/insurance-carrier/insurance-carrier-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInsuranceCarrierLabel">Create or edit a Insurance Carrier</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceCarrier.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceCarrier.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_acctno">Acctno</label> <input type="text" class="form-control" name="acctno" id="field_acctno" ng-model="vm.insuranceCarrier.acctno" required><div ng-show="editForm.acctno.$invalid"><p class="help-block" ng-show="editForm.acctno.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceCarrier.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_address">Address</label> <input type="text" class="form-control" name="address" id="field_address" ng-model="vm.insuranceCarrier.address"></div><div class="form-group"><label class="control-label" for="field_address2">Address 2</label> <input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.insuranceCarrier.address2"></div><div class="form-group"><label class="control-label" for="field_city">City</label> <input type="text" class="form-control" name="city" id="field_city" ng-model="vm.insuranceCarrier.city"></div><div class="form-group"><label class="control-label" for="field_state">State</label> <input type="text" class="form-control" name="state" id="field_state" ng-model="vm.insuranceCarrier.state"></div><div class="form-group"><label class="control-label" for="field_zip">Zip</label> <input type="text" class="form-control" name="zip" id="field_zip" ng-model="vm.insuranceCarrier.zip"></div><div class="form-group"><label class="control-label" for="field_phone">Phone</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.insuranceCarrier.phone"></div><div class="form-group"><label class="control-label" for="field_iType">I Type</label> <input type="text" class="form-control" name="iType" id="field_iType" ng-model="vm.insuranceCarrier.iType"></div><div class="form-group"><label class="control-label" for="field_etin">Etin</label> <input type="text" class="form-control" name="etin" id="field_etin" ng-model="vm.insuranceCarrier.etin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/insurance-carrier/insurance-carriers.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div></div></div></section>');
$templateCache.put('app/entities/lab-log/lab-logs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/notifications/notifications-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.notifications.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Notifications?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/notifications/notifications-detail.html','<div><h2><span>Notifications</span> {{vm.notifications.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Title</span></dt><dd><span>{{vm.notifications.title}}</span></dd><dt><span>Description</span></dt><dd><span>{{vm.notifications.description}}</span></dd><dt><span>Priority Level</span></dt><dd><span>{{vm.notifications.priorityLevel}}</span></dd><dt><span>Viewed</span></dt><dd><span>{{vm.notifications.viewed}}</span></dd><dt><span>Reviewed Date</span></dt><dd><span>{{vm.notifications.reviewedDate | date:\'medium\'}}</span></dd><dt><span>State</span></dt><dd><span>{{vm.notifications.state}}</span></dd><dt><span>State Params</span></dt><dd><span>{{vm.notifications.stateParams}}</span></dd><dt><span>Employee</span></dt><dd><a ui-sref="employee-detail({id:vm.notifications.employee.id})">{{vm.notifications.employee.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="notifications-detail.edit({id:vm.notifications.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/notifications/notifications-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNotificationsLabel">Create or edit a Notifications {{vm.state}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.notifications.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.notifications.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_title">Title</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.notifications.title"></div><div class="form-group"><label class="control-label" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.notifications.description"></div><div class="form-group"><label class="control-label" for="field_priorityLevel">Priority Level</label> <select class="form-control" name="priorityLevel" ng-model="vm.notifications.priorityLevel" id="field_priorityLevel"><option value="HIGH">HIGH</option><option value="MEDIUM">MEDIUM</option><option value="LOW">LOW</option></select></div><div class="form-group"><label class="control-label" for="field_reviewedDate">Reviewed Date</label><div class="input-group"><input id="field_reviewedDate" type="text" class="form-control" name="reviewedDate" datetime-picker="{{dateformat}}" ng-model="vm.notifications.reviewedDate" is-open="vm.datePickerOpenStatus.reviewedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reviewedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_state">State</label> <input type="text" class="form-control" name="state" id="field_state" ng-model="vm.notifications.state"></div><div class="form-group"><label class="control-label" for="field_stateParams">State Params</label> <input type="text" class="form-control" name="stateParams" id="field_stateParams" ng-model="vm.notifications.stateParams"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/notifications/notifications.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12"><div class="box"><div class="box-body"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="notifications.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Notifications</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.reset()"><th jh-sort-by="title"><span>Title</span></th><th jh-sort-by="description"><span>Description</span></th><th jh-sort-by="priorityLevel" class="text-right"><span>Priority Level</span></th></tr></thead><tbody infinite-scroll="vm.loadPage(vm.page + 1)" infinite-scroll-disabled="vm.page >= vm.links[\'last\']"><tr ng-repeat="notifications in vm.notifications | orderBy: \'-createdDate\'" ng-click="vm.saveViewed(notifications)" ng-style="notifications.viewed && {\'background-color\':\'#ffffff\'} || {\'background-color\': \'#e6e6e6\'}"><td>{{notifications.title}}</td><td>{{notifications.description}}</td><td class="text-right">{{notifications.priorityLevel}}</td><!--                                <td class="text-right">\n                                    <div class="btn-group flex-btn-group-container">\n                                        <button type="submit"\n                                                ui-sref="notifications-detail({id:notifications.id})"\n                                                class="btn btn-info btn-sm">\n                                            <span class="glyphicon glyphicon-eye-open"></span>\n                                            <span class="hidden-xs hidden-sm"></span>\n                                        </button>\n                                        <button type="submit"\n                                                ui-sref="notifications.edit({id:notifications.id})"\n                                                class="btn btn-primary btn-sm">\n                                            <span class="glyphicon glyphicon-pencil"></span>\n                                            <span class="hidden-xs hidden-sm"></span>\n                                        </button>\n                                        <button type="submit"\n                                                ui-sref="notifications.delete({id:notifications.id})"\n                                                class="btn btn-danger btn-sm">\n                                            <span class="glyphicon glyphicon-remove-circle"></span>\n                                            <span class="hidden-xs hidden-sm"></span>\n                                        </button>\n                                    </div>\n                                </td>--></tr></tbody></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/pro-claim-conf/pro-claim-conf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.proClaimConf.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want to <strong class="text-uppercase">delete</strong> this Pro Claim Conf?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/pro-claim-conf/pro-claim-conf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRelationalLabel">{{vm.title}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="orders-list"><div class="order-item" ng-repeat="($index, proClaimConf) in vm.proClaimConfs"><header class="order-header mb-15"><h4 class="order-name"><button type="button" class="btn btn-default btn-sm" ng-click="proClaimConf.collapsed = !proClaimConf.collapsed"><i class="fa" aria-hidden="true" ng-class="proClaimConf.collapsed?\'fa-chevron-right\':\'fa-chevron-down\'"></i></button> <span>Professional Claim Configuration {{$index + 1}}</span></h4><button type="button" class="btn btn-danger" ng-click="vm.deleteProClaimConf($index)" ng-if="vm.proClaimConfs.length > 1"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button></header><div class="order-content well well-sm" uib-collapse="proClaimConf.collapsed"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-10"><div class="form-group has-feedback" ng-class="{\'has-error\': proClaimConf.minTime == null}"><label for="field_minTime{{$index}}">Min Time:</label> <input type="number" class="form-control" name="minTime{{$index}}" id="field_minTime{{$index}}" ng-model="proClaimConf.minTime" min="0" placeholder="0" required> <span class="help-block" ng-show="proClaimConf.minTime == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-10"><div class="form-group has-feedback" ng-class="{\'has-error\': proClaimConf.maxTime == null}"><label for="max_time{{$index}}">Max Time:</label> <input type="number" class="form-control" name="max_time{{$index}}" id="max_time{{$index}}" ng-model="proClaimConf.maxTime" min="0" placeholder="0" required> <span class="help-block" ng-show="proClaimConf.maxTime == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 mb-10"><div class="form-group"><label class="control-label" for="is_default{{$index}}">Default:</label><br><toggle id="is_default{{$index}}" ng-model="proClaimConf.isDefault" on="Yes" off="No" size="" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12 mb-10"><div class="form-group has-feedback" ng-class="{\'has-error\': !proClaimConf.isDefault&&(proClaimConf.insuranceCarriers==null||proClaimConf.insuranceCarriers.length==0)}"><label for="insuranceCarrier{{$index}}">Insurance Carrier</label><ui-select multiple="multiple" name="insuranceCarrier{{$index}}" id="insuranceCarrier{{$index}}" title="Select insurance carrier" ng-model="proClaimConf.insuranceCarriers" reset-search-input="true" close-on-select="false" ng-required="!proClaimConf.isDefault"><ui-select-match placeholder="Insurance Carriers ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="insuranceCarrier in vm.insuranceCarriers | filter: $select.search" refresh="vm.getInsuranceCarriers($select.search)" refresh-delay="0"><div ng-bind-html="insuranceCarrier.name"></div></ui-select-choices></ui-select><span class="help-block" ng-show="!proClaimConf.isDefault&&(proClaimConf.insuranceCarriers==null||proClaimConf.insuranceCarriers.length==0)">This field is required</span></div></div><div class="col-xs-4 col-sm-12 col-md-12 col-lg-12 mb-10"><div class="form-group has-feedback" ng-class="proClaimConf.levelOfCares == null || proClaimConf.levelOfCares.length == 0 ? \'has-error\' : \'has-success\'"><label for="field_typeLevelCare{{$index}}">Level of Care:</label><ui-select id="field_typeLevelCare{{$index}}" multiple="multiple" required name="typeLevelCare{{$index}}" title="Type Level Care" ng-model="proClaimConf.levelOfCares" close-on-select="false"><ui-select-match placeholder="{{vm.typelevelcares.length?\'Select Level of cares...\':\'There is no LevelTypeCares to add...\'}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.typelevelcares | filter:$select.search" refresh="" refresh-delay="1"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="proClaimConf.levelOfCares == null"></span> <span class="help-block" ng-show="proClaimConf.levelOfCares == null">This field is required</span></div></div></div><fieldset><legend>Cpts</legend><div ng-repeat="($f_index, proCptConf) in proClaimConf.proCptConfs" class="frequency-day"><header style="flex-wrap: wrap; margin-bottom: 10px"><h4 class="day-number" style="width: 100%;"><strong>Cpt</strong></h4><div class="select-frequency has-feedback" ng-class="(proCptConf.cpt==null || proCptConf.cpt.length==0) ? \'has-error\' : \'has-success\'" style="margin-left: 0"><ui-select name="cpt_{{$index}}{{$f_index}}" id="field_cpt_{{$index}}{{$f_index}}" title="Select cpt" ng-model="proCptConf.cpt" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="true" required style="min-width: 240px; background-color: white"><ui-select-match allow-clear="true" placeholder="Enter a Cpt...">{{$select.selected.code}} - {{$select.selected.shortDesc}}</ui-select-match><ui-select-choices repeat="cpt in vm.cpts | filter: $select.search" refresh="vm.getCpts($select.search)" refresh-delay="0"><div ng-bind-html="cpt.code"></div><small ng-bind-html="cpt.shortDesc | highlight: $select.search"></small></ui-select-choices></ui-select></div><button type="button" class="btn btn-danger" ng-if="proClaimConf.proCptConfs.length > 1 && proCptConf.confirm == null" ng-click="proCptConf.confirm = true"><i class="fa fa-trash" aria-hidden="true"></i> Delete Cpt</button><div style="margin-left: auto" ng-if="proCptConf.confirm == true"><button type="button" class="btn btn-success" ng-click="vm.deleteProCptConf(proClaimConf, $f_index)"><i class="fa fa-trash" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger" ng-click="proCptConf.confirm = null"><i class="fa fa-trash" aria-hidden="true"></i> No</button></div></header><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="{\'has-error\': proCptConf.rate == null}"><label class="control-label" for="rate{{$index}}{{$f_index}}">Rate:</label> <input type="number" class="form-control" name="rate{{$index}}{{$f_index}}" id="rate{{$index}}{{$f_index}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="proCptConf.rate" required> <span class="help-block" ng-show="proCptConf.rate == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback"><label class="control-label" for="quantity{{$index}}{{$f_index}}">Quantity:</label> <input type="number" class="form-control" name="quantity{{$index}}{{$f_index}}" id="quantity{{$index}}{{$f_index}}" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="proCptConf.quantity" required> <span class="help-block" ng-show="proCptConf.quantity == null">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="{\'has-error\': proCptConf.unit == null}"><label class="control-label" for="unit{{$index}}{{$f_index}}">Unit:</label> <select class="form-control" name="unit{{$index}}{{$f_index}}" ng-model="proCptConf.unit" id="unit{{$index}}{{$f_index}}" required><option value="UNITS">UNITS</option><option value="MINUTES">MINUTES</option></select> <span class="help-block" ng-show="proCptConf.unit == null">This field is required</span></div></div></div><div class="schedule-times"><table class="table table-condensed"><thead><tr><th><strong>Modifiers:</strong></th></tr></thead><tbody><tr><td><ui-select multiple="multiple" name="modifier_{{$index}}_{{$f_index}}" id="field_modifier_{{$index}}_{{$f_index}}" title="Select modifiers" ng-model="proCptConf.modifiers" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Modifiers ...">{{$item.code}} - {{$item.shortDesc}}</ui-select-match><ui-select-choices repeat="modifier in vm.modifiers | filter: $select.search" refresh="vm.getModifiers($select.search)" refresh-delay="0"><div ng-bind-html="modifier.code"></div><small ng-bind-html="modifier.shortDesc | highlight: $select.search"></small></ui-select-choices></ui-select></td></tr></tbody></table></div></div><div class="text-right"><button type="button" class="btn btn-primary" ng-click="vm.addCpt(proClaimConf)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Cpt</button></div></fieldset></div></div></div><hr ng-if="!(vm.proClaimConfs.length == 1 && vm.proClaimConfs[0].id)"><div class="text-center mb-15" ng-if="!(vm.proClaimConfs.length == 1 && vm.proClaimConfs[0].id)"><button type="button" class="btn btn-warning" ng-click="vm.addConf()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Professional Claim Configuration</button></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.proClaimConfs == null || vm.proClaimConfs.length == 0 || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/pro-claim-conf/pro-claim-confs.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><button class="btn btn-primary btn-lg" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i> <span>New Pro Claim Conf</span></button><form name="searchForm" class="form-inline"><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"></ul></div></div></div></div></section>');
$templateCache.put('app/entities/procedure/procedure-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.procedure.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Procedure</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Procedure from the database. Are you sure you want to <strong>delete</strong> this Procedure?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/procedure-diagnosis/procedure-diagnoses.html','<div><h2>Procedure Diagnoses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="procedure-diagnosis.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Procedure Diagnosis</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="rank"><span>Rank</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="procedure.id"><span>Procedure</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="icd10.id"><span>Icd 10</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="procedureDiagnosis in vm.procedureDiagnoses track by procedureDiagnosis.id"><td><a ui-sref="procedure-diagnosis-detail({id:procedureDiagnosis.id})">{{procedureDiagnosis.id}}</a></td><td>{{procedureDiagnosis.rank}}</td><td><a ui-sref="procedure-detail({id:procedureDiagnosis.procedure.id})">{{procedureDiagnosis.procedure.id}}</a></td><td><a ui-sref="icd-10-detail({id:procedureDiagnosis.icd10.id})">{{procedureDiagnosis.icd10.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="procedure-diagnosis-detail({id:procedureDiagnosis.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="procedure-diagnosis.edit({id:procedureDiagnosis.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="procedure-diagnosis.delete({id:procedureDiagnosis.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/entities/procedure-diagnosis/procedure-diagnosis-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.procedureDiagnosis.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Procedure Diagnosis?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/procedure-diagnosis/procedure-diagnosis-detail.html','<div><h2><span>Procedure Diagnosis</span> {{vm.procedureDiagnosis.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Rank</span></dt><dd><span>{{vm.procedureDiagnosis.rank}}</span></dd><dt><span>Procedure</span></dt><dd><a ui-sref="procedure-detail({id:vm.procedureDiagnosis.procedure.id})">{{vm.procedureDiagnosis.procedure.id}}</a></dd><dt><span>Icd 10</span></dt><dd><a ui-sref="icd-10-detail({id:vm.procedureDiagnosis.icd10.id})">{{vm.procedureDiagnosis.icd10.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="procedure-diagnosis-detail.edit({id:vm.procedureDiagnosis.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/procedure-diagnosis/procedure-diagnosis-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProcedureDiagnosisLabel">Create or edit a Procedure Diagnosis</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.procedureDiagnosis.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.procedureDiagnosis.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_rank">Rank</label> <select class="form-control" name="rank" ng-model="vm.procedureDiagnosis.rank" id="field_rank"><option value="a">a</option></select></div><div class="form-group"><label for="field_procedure">Procedure</label> <select class="form-control" id="field_procedure" name="procedure" ng-model="vm.procedureDiagnosis.procedure" ng-options="procedure as procedure.id for procedure in vm.procedures track by procedure.id"><option value=""></option></select></div><div class="form-group"><label for="field_icd10">Icd 10</label> <select class="form-control" id="field_icd10" name="icd10" ng-model="vm.procedureDiagnosis.icd10" ng-options="icd10 as icd10.id for icd10 in vm.icd10s track by icd10.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/procedure-modifier/procedure-modifier-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.procedureModifier.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Procedure Modifier?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/procedure-modifier/procedure-modifier-detail.html','<div><h2><span>Procedure Modifier</span> {{vm.procedureModifier.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Procedure</span></dt><dd><a ui-sref="procedure-detail({id:vm.procedureModifier.procedure.id})">{{vm.procedureModifier.procedure.id}}</a></dd><dt><span>Modifier</span></dt><dd><a ui-sref="modifier-detail({id:vm.procedureModifier.modifier.id})">{{vm.procedureModifier.modifier.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="procedure-modifier-detail.edit({id:vm.procedureModifier.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/procedure-modifier/procedure-modifier-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProcedureModifierLabel">Create or edit a Procedure Modifier</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.procedureModifier.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.procedureModifier.id" readonly="readonly"></div><div class="form-group"><label for="field_procedure">Procedure</label> <select class="form-control" id="field_procedure" name="procedure" ng-model="vm.procedureModifier.procedure" ng-options="procedure as procedure.id for procedure in vm.procedures track by procedure.id" required><option value=""></option></select></div><div ng-show="editForm.procedure.$invalid"><p class="help-block" ng-show="editForm.procedure.$error.required">This field is required.</p></div><div class="form-group"><label for="field_modifier">Modifier</label> <select class="form-control" id="field_modifier" name="modifier" ng-model="vm.procedureModifier.modifier" ng-options="modifier as modifier.id for modifier in vm.modifiers track by modifier.id" required><option value=""></option></select></div><div ng-show="editForm.modifier.$invalid"><p class="help-block" ng-show="editForm.modifier.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/procedure-modifier/procedure-modifiers.html','<div><h2>Procedure Modifiers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="procedure-modifier.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Procedure Modifier</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Procedure</span></th><th><span>Modifier</span></th><th></th></tr></thead><tbody><tr ng-repeat="procedureModifier in vm.procedureModifiers track by procedureModifier.id"><td><a ui-sref="procedure-modifier-detail({id:procedureModifier.id})">{{procedureModifier.id}}</a></td><td><a ui-sref="procedure-detail({id:procedureModifier.procedure.id})">{{procedureModifier.procedure.id}}</a></td><td><a ui-sref="modifier-detail({id:procedureModifier.modifier.id})">{{procedureModifier.modifier.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="procedure-modifier-detail({id:procedureModifier.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="procedure-modifier.edit({id:procedureModifier.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="procedure-modifier.delete({id:procedureModifier.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/prog-elig-corp/prog-elig-corp-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.progEligCorp.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Corporation Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Corporation Program Eligibility from the database. Are you sure you want to <strong>delete</strong> this Corporation Program Eligibility?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-elig-corp/prog-elig-corp-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myProgEligCorpLabel">Create or edit a Corporation Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.progEligCorp.startDate?(vm.form.editForm.startDate.$valid && vm.form.editForm.startDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.progEligCorp.startDate" required is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.progEligCorp.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progEligCorp.startDate && vm.form.editForm.startDate.$dirty"></span> <span class="help-block" ng-show="!vm.progEligCorp.startDate || vm.form.editForm.startDate.$invalid">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.progEligCorp.endDate?(vm.form.editForm.endDate.$valid && vm.form.editForm.endDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.progEligCorp.endDate" required is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.progEligCorp.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progEligCorp.endDate && vm.form.editForm.endDate.$dirty"></span> <span class="help-block" ng-show="!vm.progEligCorp.endDate || vm.form.editForm.endDate.$invalid">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-elig-corp/prog-elig-corps.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/prog-elig-employee/prog-elig-employee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.progEligEmployee.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Employee Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Employee Program Eligibility from the database. Are you sure you want to <strong>delete</strong> this Employee Program Eligibility?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-elig-employee/prog-elig-employee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myProgEligEmployeeLabel">Create or edit a Employee Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.progEligEmployee.employee?\'\':\'has-error\'"><label for="field_employee">Employee</label><ui-select ng-model="vm.progEligEmployee.employee" name="Employee" ng-required="true" title="Employee" id="field_employee"><ui-select-match placeholder="Enter the employee name...">{{($select.selected.firstName + \' \' + $select.selected.lastName)}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployee($select.search)" refresh-delay="0">{{(employee.firstName + \' \' + employee.lastName)}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.employee.$error.required"></span> <span class="help-block" ng-show="editForm.employee.$error.required">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.progEligEmployee.startDate?(vm.form.editForm.startDate.$valid && vm.form.editForm.startDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.progEligEmployee.startDate" required is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.progEligEmployee.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progEligEmployee.startDate && vm.form.editForm.startDate.$dirty"></span> <span class="help-block" ng-show="!vm.progEligEmployee.startDate || vm.form.editForm.startDate.$invalid">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.progEligEmployee.endDate?(vm.form.editForm.endDate.$valid && vm.form.editForm.endDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.progEligEmployee.endDate" required is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.progEligEmployee.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progEligEmployee.endDate && vm.form.editForm.endDate.$dirty"></span> <span class="help-block" ng-show="!vm.progEligEmployee.endDate || vm.form.editForm.endDate.$invalid">This field is required</span></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-elig-employee/prog-elig-employees.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/prog-elig-facility/prog-elig-facilities.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/prog-elig-facility/prog-elig-facility-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.progEligFacility.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Facility Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Facility Program Eligibility from the database. Are you sure you want to <strong>delete</strong> this Facility Program Eligibility?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="deleteForm.$invalid"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-elig-facility/prog-elig-facility-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myprogEligFacilityLabel">Create or edit a Facility Program Eligibility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.progEligFacility.startDate?(vm.form.editForm.startDate.$valid && vm.form.editForm.startDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.progEligFacility.startDate" required is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.progEligFacility.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progEligFacility.startDate && vm.form.editForm.startDate.$dirty"></span> <span class="help-block" ng-show="!vm.progEligFacility.startDate || vm.form.editForm.startDate.$invalid">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.progEligFacility.endDate?(vm.form.editForm.endDate.$valid && vm.form.editForm.endDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.progEligFacility.endDate" required is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.progEligFacility.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progEligFacility.endDate && vm.form.editForm.endDate.$dirty"></span> <span class="help-block" ng-show="!vm.progEligFacility.endDate || vm.form.editForm.endDate.$invalid">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-medication/prog-medication-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.progMedication.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Delete Program Eligibility Medication</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is <strong>final</strong> and will <strong>remove</strong> this Program Eligibility Medication from the database. Are you sure you want to <strong>remove</strong> this Program Eligibility Medication?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/prog-medication/prog-medication-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAbnormalAlertLabel">Create or edit a Program Eligibility Medication</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.progMedication.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.progMedication.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="vm.progMedication.medication ? \'has-success\':\'has-error\'"><label for="field_medication">Medication:</label><ui-select name="medication" id="field_medication" ng-model="vm.progMedication.medication" required reset-search-input="true" title="All Medications" close-on-select="true"><ui-select-match placeholder="Select medications ..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="medication in vm.medications | filter: $select.search" refresh="vm.getMedications($select.search)" refresh-delay="0"><div ng-bind-html="medication.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.progMedication.medication"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.progMedication.medication "></span> <span class="help-block" ng-show="!vm.progMedication.medication">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/prog-medication/prog-medications.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/tpl/list-box-header-tpl.html\'"></ng-include><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section>');
$templateCache.put('app/entities/rc-upload/rc-upload-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Upload Crew File</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">CSV Format <span style="color: #dd4b39">(Warning: This action can not be undone!)</span></p><p>CREW_ID,Crew,FIRSTNAME,LASTNAME,DOB,GENDER,VESSEL_NAME,VOYAGE_NO</p><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.file?\'has-success\':\'has-error\'"><i class="fa fa-paperclip" aria-hidden="true"></i> <label for="fileUploads">Choose files...</label> <input type="file" id="fileUploads" ngf-select ngf-change="vm.attachFile($files)" accept=".xlsx"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.date?\'has-success\':\'has-error\'"><label for="field_collection_date">Collected Date:</label><div class="input-group input-group-sm"><input id="field_collection_date" type="text" class="form-control" name="collection_date" ng-required="true" placeholder="Collection Date" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.date" is-open="vm.datePickerOpenStatus"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar()"><i class="fa fa-calendar" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.date"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.date && editForm.collection_date.$dirty"></span> <span class="help-block" ng-show="!vm.date">This field is required</span></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.attach()" ng-disabled="!vm.file || editForm.$invalid || vm.isSaving"><i class="fa fa-upload" aria-hidden="true"></i> Upload</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/rc-upload/rc-uploads.html','<section class="content no-padding"><div class="content-heading"><button class="btn btn-default" ng-click="vm.search()"><i class="fa fa-refresh" aria-hidden="true"></i> <span>Refresh</span></button> <button class="btn btn-primary" ui-sref="{{vm.entityStateName}}.new"><i class="fa fa-plus-circle" aria-hidden="true"></i> <span>New {{vm.entityClassHumanized}}</span></button></div><div class="box box-customized datatable-no-padding"><div class="table-responsive mb-30"><table class="table table-striped table-bordered table-condensed" style="margin: 0" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></section>');
$templateCache.put('app/entities/rcopia-dosage/rcopia-dosage-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rcopiaDosage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rcopia Dosage?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rcopia-dosage/rcopia-dosage-detail.html','<div><h2><span>Rcopia Dosage</span> {{vm.rcopiaDosage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Dosage Text</span></dt><dd><span>{{vm.rcopiaDosage.dosageText}}</span></dd><dt><span>Patient Notes</span></dt><dd><span>{{vm.rcopiaDosage.patientNotes}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rcopia-dosage-detail.edit({id:vm.rcopiaDosage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rcopia-dosage/rcopia-dosage-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRcopiaDosageLabel">Create or edit a Rcopia Dosage</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rcopiaDosage.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.rcopiaDosage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dosageText">Dosage Text</label> <input type="text" class="form-control" name="dosageText" id="field_dosageText" ng-model="vm.rcopiaDosage.dosageText"></div><div class="form-group"><label class="control-label" for="field_patientNotes">Patient Notes</label> <input type="text" class="form-control" name="patientNotes" id="field_patientNotes" ng-model="vm.rcopiaDosage.patientNotes"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rcopia-dosage/rcopia-dosages.html','<div><h2>Rcopia Dosages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rcopia-dosage.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Rcopia Dosage</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Dosage Text</span></th><th><span>Patient Notes</span></th><th></th></tr></thead><tbody><tr ng-repeat="rcopiaDosage in vm.rcopiaDosages track by rcopiaDosage.id"><td><a ui-sref="rcopia-dosage-detail({id:rcopiaDosage.id})">{{rcopiaDosage.id}}</a></td><td>{{rcopiaDosage.dosageText}}</td><td>{{rcopiaDosage.patientNotes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rcopia-dosage-detail({id:rcopiaDosage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="rcopia-dosage.edit({id:rcopiaDosage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="rcopia-dosage.delete({id:rcopiaDosage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rcopia-instruction/rcopia-instruction-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rcopiaInstruction.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rcopia Instruction?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rcopia-instruction/rcopia-instruction-detail.html','<div><h2><span>Rcopia Instruction</span> {{vm.rcopiaInstruction.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Clinical Instruction</span></dt><dd><span>{{vm.rcopiaInstruction.clinicalInstruction}}</span></dd><dt><span>Sequence</span></dt><dd><span>{{vm.rcopiaInstruction.sequence}}</span></dd><dt><span>Action</span></dt><dd><span>{{vm.rcopiaInstruction.action}}</span></dd><dt><span>Dose</span></dt><dd><span>{{vm.rcopiaInstruction.dose}}</span></dd><dt><span>Dose Unit</span></dt><dd><span>{{vm.rcopiaInstruction.doseUnit}}</span></dd><dt><span>Route</span></dt><dd><span>{{vm.rcopiaInstruction.route}}</span></dd><dt><span>Dose Timing</span></dt><dd><span>{{vm.rcopiaInstruction.doseTiming}}</span></dd><dt><span>As Needed</span></dt><dd><span>{{vm.rcopiaInstruction.asNeeded}}</span></dd><dt><span>Y</span></dt><dd><span>{{vm.rcopiaInstruction.y}}</span></dd><dt><span>Dose Other</span></dt><dd><span>{{vm.rcopiaInstruction.doseOther}}</span></dd><dt><span>Dose Duration</span></dt><dd><span>{{vm.rcopiaInstruction.doseDuration}}</span></dd><dt><span>Dose Duration Unit</span></dt><dd><span>{{vm.rcopiaInstruction.doseDurationUnit}}</span></dd><dt><span>Conjunction</span></dt><dd><span>{{vm.rcopiaInstruction.conjunction}}</span></dd><dt><span>Rcopia Dose</span></dt><dd><a ui-sref="rcopia-dose-detail({id:vm.rcopiaInstruction.rcopiaDose.id})">{{vm.rcopiaInstruction.rcopiaDose.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rcopia-instruction-detail.edit({id:vm.rcopiaInstruction.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rcopia-instruction/rcopia-instruction-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRcopiaInstructionLabel">Create or edit a Rcopia Instruction</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rcopiaInstruction.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.rcopiaInstruction.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_clinicalInstruction">Clinical Instruction</label> <input type="text" class="form-control" name="clinicalInstruction" id="field_clinicalInstruction" ng-model="vm.rcopiaInstruction.clinicalInstruction"></div><div class="form-group"><label class="control-label" for="field_sequence">Sequence</label> <input type="number" class="form-control" name="sequence" id="field_sequence" ng-model="vm.rcopiaInstruction.sequence"></div><div class="form-group"><label class="control-label" for="field_action">Action</label> <input type="text" class="form-control" name="action" id="field_action" ng-model="vm.rcopiaInstruction.action"></div><div class="form-group"><label class="control-label" for="field_dose">Dose</label> <input type="text" class="form-control" name="dose" id="field_dose" ng-model="vm.rcopiaInstruction.dose"></div><div class="form-group"><label class="control-label" for="field_doseUnit">Dose Unit</label> <input type="text" class="form-control" name="doseUnit" id="field_doseUnit" ng-model="vm.rcopiaInstruction.doseUnit"></div><div class="form-group"><label class="control-label" for="field_route">Route</label> <input type="text" class="form-control" name="route" id="field_route" ng-model="vm.rcopiaInstruction.route"></div><div class="form-group"><label class="control-label" for="field_doseTiming">Dose Timing</label> <input type="text" class="form-control" name="doseTiming" id="field_doseTiming" ng-model="vm.rcopiaInstruction.doseTiming"></div><div class="form-group"><label class="control-label" for="field_asNeeded">As Needed</label> <input type="text" class="form-control" name="asNeeded" id="field_asNeeded" ng-model="vm.rcopiaInstruction.asNeeded"></div><div class="form-group"><label class="control-label" for="field_y">Y</label> <input type="text" class="form-control" name="y" id="field_y" ng-model="vm.rcopiaInstruction.y"></div><div class="form-group"><label class="control-label" for="field_doseOther">Dose Other</label> <input type="text" class="form-control" name="doseOther" id="field_doseOther" ng-model="vm.rcopiaInstruction.doseOther"></div><div class="form-group"><label class="control-label" for="field_doseDuration">Dose Duration</label> <input type="number" class="form-control" name="doseDuration" id="field_doseDuration" ng-model="vm.rcopiaInstruction.doseDuration"></div><div class="form-group"><label class="control-label" for="field_doseDurationUnit">Dose Duration Unit</label> <input type="text" class="form-control" name="doseDurationUnit" id="field_doseDurationUnit" ng-model="vm.rcopiaInstruction.doseDurationUnit"></div><div class="form-group"><label class="control-label" for="field_conjunction">Conjunction</label> <input type="text" class="form-control" name="conjunction" id="field_conjunction" ng-model="vm.rcopiaInstruction.conjunction"></div><div class="form-group"><label for="field_rcopiaDose">Rcopia Dose</label> <select class="form-control" id="field_rcopiaDose" name="rcopiaDose" ng-model="vm.rcopiaInstruction.rcopiaDose" ng-options="rcopiaDose as rcopiaDose.id for rcopiaDose in vm.rcopiadoses track by rcopiaDose.id" required><option value=""></option></select></div><div ng-show="editForm.rcopiaDose.$invalid"><p class="help-block" ng-show="editForm.rcopiaDose.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rcopia-instruction/rcopia-instructions.html','<div><h2>Rcopia Instructions</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rcopia-instruction.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Rcopia Instruction</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Clinical Instruction</span></th><th><span>Sequence</span></th><th><span>Action</span></th><th><span>Dose</span></th><th><span>Dose Unit</span></th><th><span>Route</span></th><th><span>Dose Timing</span></th><th><span>As Needed</span></th><th><span>Y</span></th><th><span>Dose Other</span></th><th><span>Dose Duration</span></th><th><span>Dose Duration Unit</span></th><th><span>Conjunction</span></th><th><span>Rcopia Dose</span></th><th></th></tr></thead><tbody><tr ng-repeat="rcopiaInstruction in vm.rcopiaInstructions track by rcopiaInstruction.id"><td><a ui-sref="rcopia-instruction-detail({id:rcopiaInstruction.id})">{{rcopiaInstruction.id}}</a></td><td>{{rcopiaInstruction.clinicalInstruction}}</td><td>{{rcopiaInstruction.sequence}}</td><td>{{rcopiaInstruction.action}}</td><td>{{rcopiaInstruction.dose}}</td><td>{{rcopiaInstruction.doseUnit}}</td><td>{{rcopiaInstruction.route}}</td><td>{{rcopiaInstruction.doseTiming}}</td><td>{{rcopiaInstruction.asNeeded}}</td><td>{{rcopiaInstruction.y}}</td><td>{{rcopiaInstruction.doseOther}}</td><td>{{rcopiaInstruction.doseDuration}}</td><td>{{rcopiaInstruction.doseDurationUnit}}</td><td>{{rcopiaInstruction.conjunction}}</td><td><a ui-sref="rcopia-dose-detail({id:rcopiaInstruction.rcopiaDose.id})">{{rcopiaInstruction.rcopiaDose.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rcopia-instruction-detail({id:rcopiaInstruction.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="rcopia-instruction.edit({id:rcopiaInstruction.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="rcopia-instruction.delete({id:rcopiaInstruction.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rcopia-snomed/rcopia-snomed-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rcopiaSnomed.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Rcopia Snomed?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/rcopia-snomed/rcopia-snomed-detail.html','<div><h2><span>Rcopia Snomed</span> {{vm.rcopiaSnomed.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Description</span></dt><dd><span>{{vm.rcopiaSnomed.description}}</span></dd><dt><span>Ct Concept ID</span></dt><dd><span>{{vm.rcopiaSnomed.ctConceptID}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="rcopia-snomed-detail.edit({id:vm.rcopiaSnomed.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/rcopia-snomed/rcopia-snomed-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRcopiaSnomedLabel">Create or edit a Rcopia Snomed</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rcopiaSnomed.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.rcopiaSnomed.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.rcopiaSnomed.description"></div><div class="form-group"><label class="control-label" for="field_ctConceptID">Ct Concept ID</label> <input type="text" class="form-control" name="ctConceptID" id="field_ctConceptID" ng-model="vm.rcopiaSnomed.ctConceptID"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/rcopia-snomed/rcopia-snomeds.html','<div><h2>Rcopia Snomeds</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rcopia-snomed.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Rcopia Snomed</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Description</span></th><th><span>Ct Concept ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="rcopiaSnomed in vm.rcopiaSnomeds track by rcopiaSnomed.id"><td><a ui-sref="rcopia-snomed-detail({id:rcopiaSnomed.id})">{{rcopiaSnomed.id}}</a></td><td>{{rcopiaSnomed.description}}</td><td>{{rcopiaSnomed.ctConceptID}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rcopia-snomed-detail({id:rcopiaSnomed.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="rcopia-snomed.edit({id:rcopiaSnomed.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="rcopia-snomed.delete({id:rcopiaSnomed.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/report-execute/report-execute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reportExecute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Report Execute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/report-execute/report-execute-detail.html','<div><h2><span>Report Execute</span> {{vm.reportExecute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Report Field</span></dt><dd><span>{{vm.reportExecute.reportField}}</span></dd><dt><span>Report Condition</span></dt><dd><span>{{vm.reportExecute.reportCondition}}</span></dd><dt><span>Report Value</span></dt><dd><span>{{vm.reportExecute.reportValue}}</span></dd><dt><span>Report Value 2</span></dt><dd><span>{{vm.reportExecute.reportValue2}}</span></dd><dt><span>Report</span></dt><dd><a ui-sref="report-detail({id:vm.reportExecute.report.id})">{{vm.reportExecute.report.id}}</a></dd><dt><span>Report Condition Ref</span></dt><dd><a ui-sref="report-condition-detail({id:vm.reportExecute.reportConditionRef.id})">{{vm.reportExecute.reportConditionRef.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="report-execute-detail.edit({id:vm.reportExecute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/report-execute/report-execute-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReportExecuteLabel">Create or edit a Report Execute</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reportExecute.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.reportExecute.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_reportField">Report Field</label> <input type="text" class="form-control" name="reportField" id="field_reportField" ng-model="vm.reportExecute.reportField"></div><div class="form-group"><label class="control-label" for="field_reportCondition">Report Condition</label> <input type="text" class="form-control" name="reportCondition" id="field_reportCondition" ng-model="vm.reportExecute.reportCondition" required><div ng-show="editForm.reportCondition.$invalid"><p class="help-block" ng-show="editForm.reportCondition.$error.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_reportValue">Report Value</label> <input type="text" class="form-control" name="reportValue" id="field_reportValue" ng-model="vm.reportExecute.reportValue"></div><div class="form-group"><label class="control-label" for="field_reportValue2">Report Value 2</label> <input type="text" class="form-control" name="reportValue2" id="field_reportValue2" ng-model="vm.reportExecute.reportValue2"></div><div class="form-group"><label for="field_report">Report</label> <select class="form-control" id="field_report" name="report" ng-model="vm.reportExecute.report" ng-options="report as report.id for report in vm.reports track by report.id" required><option value=""></option></select></div><div ng-show="editForm.report.$invalid"><p class="help-block" ng-show="editForm.report.$error.required">This field is required.</p></div><div class="form-group"><label for="field_reportConditionRef">Report Condition Ref</label> <select class="form-control" id="field_reportConditionRef" name="reportConditionRef" ng-model="vm.reportExecute.reportConditionRef" ng-options="reportCondition as reportCondition.id for reportCondition in vm.reportconditions track by reportCondition.id" required><option value=""></option></select></div><div ng-show="editForm.reportConditionRef.$invalid"><p class="help-block" ng-show="editForm.reportConditionRef.$error.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/report-execute/report-executes.html','<div><h2>Report Executes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="report-execute.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Report Execute</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Report Field</span></th><th><span>Report Condition</span></th><th><span>Report Value</span></th><th><span>Report Value 2</span></th><th><span>Report</span></th><th><span>Report Condition Ref</span></th><th></th></tr></thead><tbody><tr ng-repeat="reportExecute in vm.reportExecutes track by reportExecute.id"><td><a ui-sref="report-execute-detail({id:reportExecute.id})">{{reportExecute.id}}</a></td><td>{{reportExecute.reportField}}</td><td>{{reportExecute.reportCondition}}</td><td>{{reportExecute.reportValue}}</td><td>{{reportExecute.reportValue2}}</td><td><a ui-sref="report-detail({id:reportExecute.report.id})">{{reportExecute.report.id}}</a></td><td><a ui-sref="report-condition-detail({id:reportExecute.reportConditionRef.id})">{{reportExecute.reportConditionRef.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="report-execute-detail({id:reportExecute.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="report-execute.edit({id:reportExecute.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="report-execute.delete({id:reportExecute.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sample-files/sample-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><p>Ridetis superbe ducunt ad magnum luba. Calcarias accelerare! Domesticus, fortis animaliss vix convertam de fatalis, neuter diatria. Cur epos ire? Barbatus, pius urias unus attrahendam de secundus, lotus demissio!</p></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/sample-files/sample-table-view.html','<section class="content-header"><h1 class="section-title">{{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header blue"><i class="fa fa-check-circle" aria-hidden="true"></i> + New</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div class="box"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped"></table></div></div></div></div></section>');
$templateCache.put('app/entities/super-bill/super-bill-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Create or edit a Super Bill</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.filter.start?(editForm.start.$valid && editForm.start.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="start" ng-model="vm.filter.start" required="true" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.start" datepicker-options="vm.startOptions"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'start\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.filter.start"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.filter.start && editForm.start.$dirty"></span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.filter.end?(editForm.end.$valid && editForm.end.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="end" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.filter.end" required="true" is-open="vm.datePickerOpenStatus.end" datepicker-options="vm.endOptions"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'end\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.filter.end"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.filter.end && editForm.end.$dirty"></span></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/super-bill/super-bill-provider-dialog.html','<form name="vm.form.provider" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Provider Info</h4></div><fieldset><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_renderingProvider">Rendering Provider</label> <select class="form-control" id="field_renderingProvider" name="renderingProvider" ng-model="vm.superBill.renderingProvider" ng-options="employee as employee.firstName + \' \' + employee.lastName for employee in vm.employees track by employee.id" ng-change="vm.renderingProviderChange(vm.superBill.renderingProvider)"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" for="field_providerNpi">NPI</label> <input type="text" class="form-control" name="npi" id="field_providerNpi" ng-model="vm.superBill.providerNpi"></div></div></div><!-- /row --><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_billingProvider">Billing Provider</label> <select class="form-control" id="field_billingProvider" name="billingProvider" ng-model="vm.superBill.billingProvider" ng-options="employee as employee.firstName + \' \' + employee.lastName for employee in vm.employees track by employee.id" ng-change="vm.billingProviderChange(vm.superBill.billingProvider)"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" for="field_billingProviderNpi">NPI</label> <input type="text" class="form-control" name="npi" id="field_billingProviderNpi" ng-model="vm.superBill.billingProviderNpi"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label class="control-label" for="field_placeOfSvc">Place Of Svc</label><ui-select ng-model="vm.superBill.placeOfSvc" name="placeOfService" id="field_placeOfSvc" close-on-select="true"><ui-select-match allow-clear="true" placeholder="Select place of service ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="placeOfService in vm.placeOfService | filter: $select.search"><div ng-bind-html="placeOfService.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.superBill.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.superBill.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label class="control-label" for="field_priorAuthorizationNumber">Prior Authorization Number</label> <input type="text" class="form-control" name="priorAuthorizationNumber" id="field_priorAuthorizationNumber" ng-model="vm.superBill.priorAuthorizationNumber"></div></div></div></div></fieldset><div class="modal-footer"><button class="btn btn-success" type="button" ng-click="vm.clear()"><i class="fa fa-save" aria-hidden="true"></i> Close</button></div></form>');
$templateCache.put('app/entities/super-bill/super-bill-view.html','<section class="content no-padding"><div class="chart-layout"><header class="content-heading"><a ui-sref="chart({id: vm.chart.id})" class="btn-back-link" style="margin-right: auto"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to patient\'s chart</a></header><div class="content-grid"><aside class="content-side" resizable r-directions="[\'right\']" r-flex="true"><section class="data-section with-pic" ng-if="vm.chart"><div class="photo"><img class="photo" id="imgPicture" alt="User profile picture" ng-src-auth="{{vm.chart.id}}"></div><div class="info"><h4 class="name mt-0">{{vm.chart.patient.firstName + \' \' + (vm.chart.patient.middleName?vm.chart.patient.middleName + \' \': \'\') + vm.chart.patient.lastName}}</h4><p><strong>DOB:</strong> {{(vm.chart.patient.dateBirth | date: inputDateFormat) + \' - (\' + vm.chart.patient.age + \' years old)\'}}</p><p><strong>A. Date:</strong> {{vm.chart.admissionDate | date: inputDateFormat}}</p><p><strong>Mr#:</strong> {{vm.chart.mrNo}}</p><p><strong>P. Method:</strong> {{vm.chart.typePaymentMethods ? vm.chart.typePaymentMethods.name: \'-\'}}</p><p><strong>Status:</strong> <span class="label" ng-class="{\'label-success\': vm.chart.status === \'CLOSED\',\n                                                                 \'label-warning\': vm.chart.status === \'WAITING\',\n                                                                 \'label-primary\': vm.chart.status === \'CURRENT\',\n                                                                 \'label-default\': vm.chart.status === \'ARCHIVE\'}">{{vm.chart.status}}</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Providers</strong> <a href="" class="btn-icon" ng-click="vm.editProvider()"><i class="fa fa-edit" aria-hidden="true"></i></a></h5><p class="mb-0"><strong>Rendering provider:</strong> {{vm.superBill.renderingProvider.firstName + \' \' + vm.superBill.renderingProvider.lastName }}</p><p class="mb-0"><strong>Billing provider:</strong> {{vm.superBill.billingProvider.firstName + \' \' + vm.superBill.billingProvider.lastName }}</p><p class="mb-0"><strong>Date Range:</strong> {{vm.superBill.startDate | date: inputDateFormat}} - {{vm.superBill.endDate | date: inputDateFormat}}</p><p class="mb-0"><strong>Place of SVC:</strong> {{vm.superBill.placeOfSvc.name}}</p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Billable Insurance:</strong></h5><p class="mb-0"><strong>Insurance Name:</strong> {{vm.superBill.insuranceCarrier.name}}</p><p class="mb-0"><strong>Policy Number:</strong> {{vm.superBill.insurancePolicyNumber}}</p><p class="mb-0"><strong>Group Number:</strong> {{vm.superBill.insuranceGroupName}}</p><p class="mb-0"><strong>Suscriber Name:</strong> {{vm.superBill.insuranceFirstName}} {{vm.superBill.insuranceLastName}}</p><p class="mb-0"><strong>Suscriber DOB:</strong> {{vm.superBill.insuranceDob | date: inputDateFormat}}</p></div></section><section class="data-section" ui-view="diagnoses" ng-if="vm.superBill.billingType == \'INSTITUTIONAL\'"></section></aside><div class="content-area"><div class="form-container"><div class="superbill-layout"><header class="superbill-header"><h5 class="mt-0 mb-0">Day of service: <strong style="margin-right: 30px">{{vm.superBill.dateOfService | date: inputDateFormat}}</strong> Bill Date: <strong style="margin-right: 30px">{{vm.superBill.billDate | date: inputDateFormat}}</strong> Bill ID: <strong>{{vm.superBill.id}}</strong></h5><div class="top-buttons"><button type="button" class="btn btn-default btn-sm"><i class="fa fa-print" aria-hidden="true"></i> Print</button> <select name="saveAsSelect" id="saveAsSelect" class="form-control input-sm" ng-model="vm.superBill.status"><option value="DRAFT">DRAFT</option><option value="READY_FOR_BILLER">READY FOR BILLER</option><option value="APPROVED">APPROVED</option><option value="DENIED">DENIED</option></select> <button type="button" class="btn btn-success btn-sm" ng-click="vm.save()"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></header><hr><div class="procedure panel panel-default"><div class="panel-body"><table class="table table-condensed table-hover"><thead><tr><th><strong>Procedure</strong></th><th width="150" ng-if="vm.isProfessional"><strong>Diagnoses</strong></th><th width="150"><strong>Modifiers</strong></th><th><strong>RATE</strong></th><th><strong>QTY</strong></th><th><strong>UNITS</strong></th><th ng-if="!vm.isProfessional"><strong>RevCode</strong></th><th></th></tr></thead><tbody><tr ng-repeat="procedure in vm.procedures"><td><strong>{{procedure.cpt.code}}</strong> - <span>{{procedure.cpt.fullDesc}}</span></td><td ng-if="vm.isProfessional"><span ng-repeat="diagnosis in procedure.diagnoses"><strong>{{diagnosis.icd10.code}}</strong>{{$last ? \'\' : \', \'}}</span></td><td><span ng-repeat="modifier in procedure.modifiers"><strong>{{modifier.modifier.code}}</strong>{{$last ? \'\' : \', \'}}</span></td><td>{{procedure.rate}}</td><td>{{procedure.quantity}}</td><td>{{procedure.unit}}</td><td ng-if="!vm.isProfessional">{{procedure.revCode.code}}</td><td style="width: 40px"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-click="vm.editProcedure(procedure.id)"><a title="Edit" class="dd-link orange" ui-sref="super-bill-view({id: superBill.id})"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-click="vm.delProcedure(procedure.id)"><a title="Delete" class="dd-link red" ng-click=""><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div></div><hr><div class="procedure-new text-center mb-15"><button type="button" class="btn btn-warning btn-lg" ng-click="vm.addProcedure()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Procedure</button></div><hr><div class="bottom-info"><div class="comments"><label for="field_comments"><strong>COMMENTS:</strong></label> <textarea name="" id="field_comments" name="comment" class="form-control" ng-model="vm.superBill.comment" data-resize="disabled"></textarea></div><div class="amount-balance"><div class="amount-paid"><label for="inputAmount"><strong>AMOUNT PAID:</strong></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-usd" aria-hidden="true"></i> </span><input type="number" id="inputAmount" min="0" step="0.01" class="form-control" value="1500.00"></div></div><div class="amount-paid"><label for="inputBalance"><strong>BALANCE:</strong></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-usd" aria-hidden="true"></i> </span><input type="number" id="inputBalance" class="form-control" value="10000.00" readonly="readonly"></div></div></div></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/super-bill/super-bill.html','<div class="box box-customized mb-0"><div class="box-body no-shadow tall-body"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th><strong>Bill Date</strong></th><th><strong>Date of Service</strong></th><th><strong>Details</strong></th><th><strong>CPTs</strong></th><th><strong>Minutes</strong></th><th><strong>Status</strong></th><th><strong>Total</strong></th><th></th></tr></thead><tbody><tr ng-repeat="superBill in vm.superBills"><td>{{superBill.billDate}}</td><td>{{superBill.dateOfService}}</td><td>{{superBill.name}}</td><td>{{superBill.cpts}}</td><td>{{superBill.minutes}}</td><td>{{superBill.status}}</td><td>{{superBill.total}}</td><td style="width: 40px"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a title="Edit" class="dd-link orange" ui-sref="super-bill-view({id: superBill.id})"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a title="Mark as completed" class="dd-link green" ng-click=""><i class="fa fa-check-circle-o" aria-hidden="true"></i> Mark as Completed</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.superBills.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.loadAll()"></ul></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add SuperBill</button><div class="btn-group dropup" uib-dropdown><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div></div></div>');
$templateCache.put('app/entities/superbill/super-bill-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.superBill.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this Superbill?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/entities/superbill/super-bill-detail.html','<div><h2><span>SuperBill</span> {{vm.superBill.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span>Date Of Service</span></dt><dd><span>{{vm.superBill.dateOfService | date:\'mediumDate\'}}</span></dd><dt><span>Bill Date</span></dt><dd><span>{{vm.superBill.billDate | date:\'mediumDate\'}}</span></dd><dt><span>Status</span></dt><dd><span>{{vm.superBill.status}}</span></dd><dt><span>Comment</span></dt><dd><span>{{vm.superBill.comment}}</span></dd><dt><span>Amount Paid</span></dt><dd><span>{{vm.superBill.amountPaid}}</span></dd><dt><span>Balance</span></dt><dd><span>{{vm.superBill.balance}}</span></dd><dt><span>Provider First Name</span></dt><dd><span>{{vm.superBill.providerFirstName}}</span></dd><dt><span>Provider Last Name</span></dt><dd><span>{{vm.superBill.providerLastName}}</span></dd><dt><span>Provider Npi</span></dt><dd><span>{{vm.superBill.providerNpi}}</span></dd><dt><span>Place Of Svc</span></dt><dd><span>{{vm.superBill.placeOfSvc}}</span></dd><dt><span>Prior Authorization Number</span></dt><dd><span>{{vm.superBill.priorAuthorizationNumber}}</span></dd><dt><span>Other Provider</span></dt><dd><span>{{vm.superBill.otherProvider}}</span></dd><dt><span>Insurance Address</span></dt><dd><span>{{vm.superBill.insuranceAddress}}</span></dd><dt><span>Insurance Address 2</span></dt><dd><span>{{vm.superBill.insuranceAddress2}}</span></dd><dt><span>Insurance Zip Code</span></dt><dd><span>{{vm.superBill.insuranceZipCode}}</span></dd><dt><span>Insurance City</span></dt><dd><span>{{vm.superBill.insuranceCity}}</span></dd><dt><span>Insurance Policy Number</span></dt><dd><span>{{vm.superBill.insurancePolicyNumber}}</span></dd><dt><span>Insurance Group Number</span></dt><dd><span>{{vm.superBill.insuranceGroupNumber}}</span></dd><dt><span>Insurance Group Name</span></dt><dd><span>{{vm.superBill.insuranceGroupName}}</span></dd><dt><span>Insurance Plan Number</span></dt><dd><span>{{vm.superBill.insurancePlanNumber}}</span></dd><dt><span>Insurance Last Name</span></dt><dd><span>{{vm.superBill.insuranceLastName}}</span></dd><dt><span>Insurance First Name</span></dt><dd><span>{{vm.superBill.insuranceFirstName}}</span></dd><dt><span>Insurance Middle Initial</span></dt><dd><span>{{vm.superBill.insuranceMiddleInitial}}</span></dd><dt><span>Insurance Dob</span></dt><dd><span>{{vm.superBill.insuranceDob | date:\'mediumDate\'}}</span></dd><dt><span>Insurance Gender</span></dt><dd><span>{{vm.superBill.insuranceGender}}</span></dd><dt><span>Insurance Phone</span></dt><dd><span>{{vm.superBill.insurancePhone}}</span></dd><dt><span>Insurance Employer</span></dt><dd><span>{{vm.superBill.insuranceEmployer}}</span></dd><dt><span>Insurance Order</span></dt><dd><span>{{vm.superBill.insuranceOrder}}</span></dd><dt><span>Insurance Social Security</span></dt><dd><span>{{vm.superBill.insuranceSocialSecurity}}</span></dd><dt><span>Insurance Pre Cert Phone</span></dt><dd><span>{{vm.superBill.insurancePreCertPhone}}</span></dd><dt><span>Insurance Country State Id</span></dt><dd><span>{{vm.superBill.insuranceCountryStateId}}</span></dd><dt><span>Insurance Front Picture Id</span></dt><dd><span>{{vm.superBill.insuranceFrontPictureId}}</span></dd><dt><span>Insurance Front Picture Original Id</span></dt><dd><span>{{vm.superBill.insuranceFrontPictureOriginalId}}</span></dd><dt><span>Insurance Back Picture Id</span></dt><dd><span>{{vm.superBill.insuranceBackPictureId}}</span></dd><dt><span>Insurance Back Picture Original Id</span></dt><dd><span>{{vm.superBill.insuranceBackPictureOriginalId}}</span></dd><dt><span>Insurance Rx Bin</span></dt><dd><span>{{vm.superBill.insuranceRxBin}}</span></dd><dt><span>Insurance Pcn</span></dt><dd><span>{{vm.superBill.insurancePcn}}</span></dd><dt><span>Insurance Member Id</span></dt><dd><span>{{vm.superBill.insuranceMemberId}}</span></dd><dt><span>N</span></dt><dd><span>{{vm.superBill.n}}</span></dd><dt><span>Nn</span></dt><dd><span>{{vm.superBill.nn}}</span></dd><dt><span>Evaluation</span></dt><dd><a ui-sref="evaluation-detail({id:vm.superBill.evaluation.id})">{{vm.superBill.evaluation.id}}</a></dd><dt><span>Rendering Provider</span></dt><dd><a ui-sref="employee-detail({id:vm.superBill.renderingProvider.id})">{{vm.superBill.renderingProvider.id}}</a></dd><dt><span>Billing Provider</span></dt><dd><a ui-sref="employee-detail({id:vm.superBill.billingProvider.id})">{{vm.superBill.billingProvider.id}}</a></dd><dt><span>Insurance Carrier</span></dt><dd><a ui-sref="insurance-carrier-detail({id:vm.superBill.insuranceCarrier.id})">{{vm.superBill.insuranceCarrier.id}}</a></dd><dt><span>Insurance Type</span></dt><dd><a ui-sref="insurance-type-detail({id:vm.superBill.insuranceType.id})">{{vm.superBill.insuranceType.id}}</a></dd><dt><span>Insurance Level</span></dt><dd><a ui-sref="insurance-level-detail({id:vm.superBill.insuranceLevel.id})">{{vm.superBill.insuranceLevel.id}}</a></dd><dt><span>Insurance Relation</span></dt><dd><a ui-sref="insurance-relation-detail({id:vm.superBill.insuranceRelation.id})">{{vm.superBill.insuranceRelation.id}}</a></dd><dt><span>Country State</span></dt><dd><a ui-sref="country-state-detail({id:vm.superBill.countryState.id})">{{vm.superBill.countryState.id}}</a></dd><dt><span>Chart</span></dt><dd><a ui-sref="chart-detail({id:vm.superBill.chart.id})">{{vm.superBill.chart.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button> <button type="button" ui-sref="superBill-detail.edit({id:vm.superBill.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm">Edit</span></button></div>');
$templateCache.put('app/entities/superbill/super-bill-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySuperbillLabel">Create or edit a Superbill</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.superBill.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.superBill.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_dateOfService">Date Of Service</label><div class="input-group"><input id="field_dateOfService" type="text" class="form-control" name="dateOfService" uib-datepicker-popup="{{dateformat}}" ng-model="vm.superBill.dateOfService" is-open="vm.datePickerOpenStatus.dateOfService"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfService\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_billDate">Bill Date</label><div class="input-group"><input id="field_billDate" type="text" class="form-control" name="billDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.superBill.billDate" is-open="vm.datePickerOpenStatus.billDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'billDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_status">Status</label> <input type="text" class="form-control" name="status" id="field_status" ng-model="vm.superBill.status"></div><div class="form-group"><label class="control-label" for="field_comment">Comment</label> <input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.superBill.comment"></div><div class="form-group"><label class="control-label" for="field_amountPaid">Amount Paid</label> <input type="number" class="form-control" name="amountPaid" id="field_amountPaid" ng-model="vm.superBill.amountPaid"></div><div class="form-group"><label class="control-label" for="field_balance">Balance</label> <input type="number" class="form-control" name="balance" id="field_balance" ng-model="vm.superBill.balance"></div><div class="form-group"><label class="control-label" for="field_providerFirstName">Provider First Name</label> <input type="text" class="form-control" name="providerFirstName" id="field_providerFirstName" ng-model="vm.superBill.providerFirstName"></div><div class="form-group"><label class="control-label" for="field_providerLastName">Provider Last Name</label> <input type="text" class="form-control" name="providerLastName" id="field_providerLastName" ng-model="vm.superBill.providerLastName"></div><div class="form-group"><label class="control-label" for="field_providerNpi">Provider Npi</label> <input type="text" class="form-control" name="providerNpi" id="field_providerNpi" ng-model="vm.superBill.providerNpi"></div><div class="form-group"><label class="control-label" for="field_placeOfSvc">Place Of Svc</label> <input type="text" class="form-control" name="placeOfSvc" id="field_placeOfSvc" ng-model="vm.superBill.placeOfSvc"></div><div class="form-group"><label class="control-label" for="field_priorAuthorizationNumber">Prior Authorization Number</label> <input type="text" class="form-control" name="priorAuthorizationNumber" id="field_priorAuthorizationNumber" ng-model="vm.superBill.priorAuthorizationNumber"></div><div class="form-group"><label class="control-label" for="field_otherProvider">Other Provider</label> <input type="text" class="form-control" name="otherProvider" id="field_otherProvider" ng-model="vm.superBill.otherProvider"></div><div class="form-group"><label class="control-label" for="field_insuranceAddress">Insurance Address</label> <input type="text" class="form-control" name="insuranceAddress" id="field_insuranceAddress" ng-model="vm.superBill.insuranceAddress"></div><div class="form-group"><label class="control-label" for="field_insuranceAddress2">Insurance Address 2</label> <input type="text" class="form-control" name="insuranceAddress2" id="field_insuranceAddress2" ng-model="vm.superBill.insuranceAddress2"></div><div class="form-group"><label class="control-label" for="field_insuranceZipCode">Insurance Zip Code</label> <input type="text" class="form-control" name="insuranceZipCode" id="field_insuranceZipCode" ng-model="vm.superBill.insuranceZipCode"></div><div class="form-group"><label class="control-label" for="field_insuranceCity">Insurance City</label> <input type="text" class="form-control" name="insuranceCity" id="field_insuranceCity" ng-model="vm.superBill.insuranceCity"></div><div class="form-group"><label class="control-label" for="field_insurancePolicyNumber">Insurance Policy Number</label> <input type="text" class="form-control" name="insurancePolicyNumber" id="field_insurancePolicyNumber" ng-model="vm.superBill.insurancePolicyNumber"></div><div class="form-group"><label class="control-label" for="field_insuranceGroupNumber">Insurance Group Number</label> <input type="text" class="form-control" name="insuranceGroupNumber" id="field_insuranceGroupNumber" ng-model="vm.superBill.insuranceGroupNumber"></div><div class="form-group"><label class="control-label" for="field_insuranceGroupName">Insurance Group Name</label> <input type="text" class="form-control" name="insuranceGroupName" id="field_insuranceGroupName" ng-model="vm.superBill.insuranceGroupName"></div><div class="form-group"><label class="control-label" for="field_insurancePlanNumber">Insurance Plan Number</label> <input type="text" class="form-control" name="insurancePlanNumber" id="field_insurancePlanNumber" ng-model="vm.superBill.insurancePlanNumber"></div><div class="form-group"><label class="control-label" for="field_insuranceLastName">Insurance Last Name</label> <input type="text" class="form-control" name="insuranceLastName" id="field_insuranceLastName" ng-model="vm.superBill.insuranceLastName"></div><div class="form-group"><label class="control-label" for="field_insuranceFirstName">Insurance First Name</label> <input type="text" class="form-control" name="insuranceFirstName" id="field_insuranceFirstName" ng-model="vm.superBill.insuranceFirstName"></div><div class="form-group"><label class="control-label" for="field_insuranceMiddleInitial">Insurance Middle Initial</label> <input type="text" class="form-control" name="insuranceMiddleInitial" id="field_insuranceMiddleInitial" ng-model="vm.superBill.insuranceMiddleInitial"></div><div class="form-group"><label class="control-label" for="field_insuranceDob">Insurance Dob</label><div class="input-group"><input id="field_insuranceDob" type="text" class="form-control" name="insuranceDob" uib-datepicker-popup="{{dateformat}}" ng-model="vm.superBill.insuranceDob" is-open="vm.datePickerOpenStatus.insuranceDob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'insuranceDob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_insuranceGender">Insurance Gender</label> <input type="text" class="form-control" name="insuranceGender" id="field_insuranceGender" ng-model="vm.superBill.insuranceGender"></div><div class="form-group"><label class="control-label" for="field_insurancePhone">Insurance Phone</label> <input type="text" class="form-control" name="insurancePhone" id="field_insurancePhone" ng-model="vm.superBill.insurancePhone"></div><div class="form-group"><label class="control-label" for="field_insuranceEmployer">Insurance Employer</label> <input type="text" class="form-control" name="insuranceEmployer" id="field_insuranceEmployer" ng-model="vm.superBill.insuranceEmployer"></div><div class="form-group"><label class="control-label" for="field_insuranceOrder">Insurance Order</label> <input type="number" class="form-control" name="insuranceOrder" id="field_insuranceOrder" ng-model="vm.superBill.insuranceOrder"></div><div class="form-group"><label class="control-label" for="field_insuranceSocialSecurity">Insurance Social Security</label> <input type="text" class="form-control" name="insuranceSocialSecurity" id="field_insuranceSocialSecurity" ng-model="vm.superBill.insuranceSocialSecurity"></div><div class="form-group"><label class="control-label" for="field_insurancePreCertPhone">Insurance Pre Cert Phone</label> <input type="text" class="form-control" name="insurancePreCertPhone" id="field_insurancePreCertPhone" ng-model="vm.superBill.insurancePreCertPhone"></div><div class="form-group"><label class="control-label" for="field_insuranceCountryStateId">Insurance Country State Id</label> <input type="number" class="form-control" name="insuranceCountryStateId" id="field_insuranceCountryStateId" ng-model="vm.superBill.insuranceCountryStateId"></div><div class="form-group"><label class="control-label" for="field_insuranceFrontPictureId">Insurance Front Picture Id</label> <input type="number" class="form-control" name="insuranceFrontPictureId" id="field_insuranceFrontPictureId" ng-model="vm.superBill.insuranceFrontPictureId"></div><div class="form-group"><label class="control-label" for="field_insuranceFrontPictureOriginalId">Insurance Front Picture Original Id</label> <input type="number" class="form-control" name="insuranceFrontPictureOriginalId" id="field_insuranceFrontPictureOriginalId" ng-model="vm.superBill.insuranceFrontPictureOriginalId"></div><div class="form-group"><label class="control-label" for="field_insuranceBackPictureId">Insurance Back Picture Id</label> <input type="number" class="form-control" name="insuranceBackPictureId" id="field_insuranceBackPictureId" ng-model="vm.superBill.insuranceBackPictureId"></div><div class="form-group"><label class="control-label" for="field_insuranceBackPictureOriginalId">Insurance Back Picture Original Id</label> <input type="number" class="form-control" name="insuranceBackPictureOriginalId" id="field_insuranceBackPictureOriginalId" ng-model="vm.superBill.insuranceBackPictureOriginalId"></div><div class="form-group"><label class="control-label" for="field_insuranceRxBin">Insurance Rx Bin</label> <input type="text" class="form-control" name="insuranceRxBin" id="field_insuranceRxBin" ng-model="vm.superBill.insuranceRxBin"></div><div class="form-group"><label class="control-label" for="field_insurancePcn">Insurance Pcn</label> <input type="text" class="form-control" name="insurancePcn" id="field_insurancePcn" ng-model="vm.superBill.insurancePcn"></div><div class="form-group"><label class="control-label" for="field_insuranceMemberId">Insurance Member Id</label> <input type="text" class="form-control" name="insuranceMemberId" id="field_insuranceMemberId" ng-model="vm.superBill.insuranceMemberId"></div><div class="form-group"><label class="control-label" for="field_n">N</label> <input type="text" class="form-control" name="n" id="field_n" ng-model="vm.superBill.n"></div><div class="form-group"><label class="control-label" for="field_nn">Nn</label> <input type="text" class="form-control" name="nn" id="field_nn" ng-model="vm.superBill.nn"></div><div class="form-group"><label for="field_evaluation">Evaluation</label> <select class="form-control" id="field_evaluation" name="evaluation" ng-model="vm.superBill.evaluation" ng-options="evaluation as evaluation.id for evaluation in vm.evaluations track by evaluation.id"><option value=""></option></select></div><div class="form-group"><label for="field_renderingProvider">Rendering Provider</label> <select class="form-control" id="field_renderingProvider" name="renderingProvider" ng-model="vm.superBill.renderingProvider" ng-options="employee as employee.id for employee in vm.employees track by employee.id"><option value=""></option></select></div><div class="form-group"><label for="field_billingProvider">Billing Provider</label> <select class="form-control" id="field_billingProvider" name="billingProvider" ng-model="vm.superBill.billingProvider" ng-options="employee as employee.id for employee in vm.employees track by employee.id"><option value=""></option></select></div><div class="form-group"><label for="field_insuranceCarrier">Insurance Carrier</label> <select class="form-control" id="field_insuranceCarrier" name="insuranceCarrier" ng-model="vm.superBill.insuranceCarrier" ng-options="insuranceCarrier as insuranceCarrier.id for insuranceCarrier in vm.insurancecarriers track by insuranceCarrier.id"><option value=""></option></select></div><div class="form-group"><label for="field_insuranceType">Insurance Type</label> <select class="form-control" id="field_insuranceType" name="insuranceType" ng-model="vm.superBill.insuranceType" ng-options="insuranceType as insuranceType.id for insuranceType in vm.insurancetypes track by insuranceType.id"><option value=""></option></select></div><div class="form-group"><label for="field_insuranceLevel">Insurance Level</label> <select class="form-control" id="field_insuranceLevel" name="insuranceLevel" ng-model="vm.superBill.insuranceLevel" ng-options="insuranceLevel as insuranceLevel.id for insuranceLevel in vm.insurancelevels track by insuranceLevel.id"><option value=""></option></select></div><div class="form-group"><label for="field_insuranceRelation">Insurance Relation</label> <select class="form-control" id="field_insuranceRelation" name="insuranceRelation" ng-model="vm.superBill.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.id for insuranceRelation in vm.insurancerelations track by insuranceRelation.id"><option value=""></option></select></div><div class="form-group"><label for="field_countryState">Country State</label> <select class="form-control" id="field_countryState" name="countryState" ng-model="vm.superBill.countryState" ng-options="countryState as countryState.id for countryState in vm.countrystates track by countryState.id"><option value=""></option></select></div><div class="form-group"><label for="field_chart">Chart</label> <select class="form-control" id="field_chart" name="chart" ng-model="vm.superBill.chart" ng-options="chart as chart.id for chart in vm.charts track by chart.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/superbill/super-bills.html','<div><h2>SuperBills</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="superBill.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs">Create new Superbill</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="Query"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>ID</span></th><th><span>Date Of Service</span></th><th><span>Bill Date</span></th><th><span>Status</span></th><th><span>Comment</span></th><th><span>Amount Paid</span></th><th><span>Balance</span></th><th><span>Provider First Name</span></th><th><span>Provider Last Name</span></th><th><span>Provider Npi</span></th><th><span>Place Of Svc</span></th><th><span>Prior Authorization Number</span></th><th><span>Other Provider</span></th><th><span>Insurance Address</span></th><th><span>Insurance Address 2</span></th><th><span>Insurance Zip Code</span></th><th><span>Insurance City</span></th><th><span>Insurance Policy Number</span></th><th><span>Insurance Group Number</span></th><th><span>Insurance Group Name</span></th><th><span>Insurance Plan Number</span></th><th><span>Insurance Last Name</span></th><th><span>Insurance First Name</span></th><th><span>Insurance Middle Initial</span></th><th><span>Insurance Dob</span></th><th><span>Insurance Gender</span></th><th><span>Insurance Phone</span></th><th><span>Insurance Employer</span></th><th><span>Insurance Order</span></th><th><span>Insurance Social Security</span></th><th><span>Insurance Pre Cert Phone</span></th><th><span>Insurance Country State Id</span></th><th><span>Insurance Front Picture Id</span></th><th><span>Insurance Front Picture Original Id</span></th><th><span>Insurance Back Picture Id</span></th><th><span>Insurance Back Picture Original Id</span></th><th><span>Insurance Rx Bin</span></th><th><span>Insurance Pcn</span></th><th><span>Insurance Member Id</span></th><th><span>N</span></th><th><span>Nn</span></th><th><span>Evaluation</span></th><th><span>Rendering Provider</span></th><th><span>Billing Provider</span></th><th><span>Insurance Carrier</span></th><th><span>Insurance Type</span></th><th><span>Insurance Level</span></th><th><span>Insurance Relation</span></th><th><span>Country State</span></th><th></th></tr></thead><tbody><tr ng-repeat="superBill in vm.superbills track by superBill.id"><td><a ui-sref="superBill-detail({id:superBill.id})">{{superBill.id}}</a></td><td>{{superBill.dateOfService | date:\'mediumDate\'}}</td><td>{{superBill.billDate | date:\'mediumDate\'}}</td><td>{{superBill.status}}</td><td>{{superBill.comment}}</td><td>{{superBill.amountPaid}}</td><td>{{superBill.balance}}</td><td>{{superBill.providerFirstName}}</td><td>{{superBill.providerLastName}}</td><td>{{superBill.providerNpi}}</td><td>{{superBill.placeOfSvc}}</td><td>{{superBill.priorAuthorizationNumber}}</td><td>{{superBill.otherProvider}}</td><td>{{superBill.insuranceAddress}}</td><td>{{superBill.insuranceAddress2}}</td><td>{{superBill.insuranceZipCode}}</td><td>{{superBill.insuranceCity}}</td><td>{{superBill.insurancePolicyNumber}}</td><td>{{superBill.insuranceGroupNumber}}</td><td>{{superBill.insuranceGroupName}}</td><td>{{superBill.insurancePlanNumber}}</td><td>{{superBill.insuranceLastName}}</td><td>{{superBill.insuranceFirstName}}</td><td>{{superBill.insuranceMiddleInitial}}</td><td>{{superBill.insuranceDob | date:\'mediumDate\'}}</td><td>{{superBill.insuranceGender}}</td><td>{{superBill.insurancePhone}}</td><td>{{superBill.insuranceEmployer}}</td><td>{{superBill.insuranceOrder}}</td><td>{{superBill.insuranceSocialSecurity}}</td><td>{{superBill.insurancePreCertPhone}}</td><td>{{superBill.insuranceCountryStateId}}</td><td>{{superBill.insuranceFrontPictureId}}</td><td>{{superBill.insuranceFrontPictureOriginalId}}</td><td>{{superBill.insuranceBackPictureId}}</td><td>{{superBill.insuranceBackPictureOriginalId}}</td><td>{{superBill.insuranceRxBin}}</td><td>{{superBill.insurancePcn}}</td><td>{{superBill.insuranceMemberId}}</td><td><a ui-sref="evaluation-detail({id:superBill.evaluation.id})">{{superBill.evaluation.id}}</a></td><td><a ui-sref="employee-detail({id:superBill.renderingProvider.id})">{{superBill.renderingProvider.id}}</a></td><td><a ui-sref="employee-detail({id:superBill.billingProvider.id})">{{superBill.billingProvider.id}}</a></td><td><a ui-sref="insurance-carrier-detail({id:superBill.insuranceCarrier.id})">{{superBill.insuranceCarrier.id}}</a></td><td><a ui-sref="insurance-type-detail({id:superBill.insuranceType.id})">{{superBill.insuranceType.id}}</a></td><td><a ui-sref="insurance-level-detail({id:superBill.insuranceLevel.id})">{{superBill.insuranceLevel.id}}</a></td><td><a ui-sref="insurance-relation-detail({id:superBill.insuranceRelation.id})">{{superBill.insuranceRelation.id}}</a></td><td><a ui-sref="country-state-detail({id:superBill.countryState.id})">{{superBill.countryState.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="superBill-detail({id:superBill.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="superBill.edit({id:superBill.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="superBill.delete({id:superBill.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tpl/btns-update-save.html','<div class="pull-right"><div class="col-lg-12"><div ng-show="vm.updating"><button type="button" class="btn btn-danger" ng-click="vm.cancel()">Cancel</button> <button type="button" class="btn btn-success" ng-disabled="!vm.form.insurance_form.$invalid" ng-click="vm.save()">Save</button></div><button type="button" class="btn btn-info" ng-click="vm.updateForm()" ng-show="!vm.updating">Update Information</button></div></div>');
$templateCache.put('app/entities/tpl/list-box-header-tpl.html','<div class="box-header"><div class="dt-header"><button class="btn btn-primary btn-lg" ui-sref="{{vm.entityStateName}}.new"><i class="fa fa-plus-circle" aria-hidden="true"></i> <span>New {{vm.entityClassHumanized}}</span></button><form name="searchForm" class="form-inline"><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div>');
$templateCache.put('app/entities/tpl/list-header-tpl.html','<section class="content-header"><h1>{{vm.title}}</h1><div ncy-breadcrumb class="breadcrumb"></div></section>');
$templateCache.put('app/entities/tpl/search-header-tpl.html','<div class="box-header"><div class="dt-header"><form name="searchForm" class="form-inline"><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div>');
$templateCache.put('app/entities/tpl/section-header-tpl.html','<!--\n<section class="content-header">\n  <h1 class="section-title">{{vm.title}}</h1>\n  <div ncy-breadcrumb class="breadcrumb"></div>\n</section>\n-->');
$templateCache.put('app/entities/window-picker/date-picker-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.accept()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRaceLabel">Select new draw day</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_date">Select date</label><div class="input-group"><input id="field_date" type="text" class="form-control" name="date" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.date.$invalid"><p class="help-block" ng-show="editForm.date.$error.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/layouts/controlbar/controlsidebar.tpl.html','<aside class="control-sidebar control-sidebar-dark" ng-class="{\'control-sidebar\': vm.isControlbarCollapsed , \'control-sidebar-open\': !vm.isControlbarCollapsed }"><h3 class="control-sidebar-heading">Administration</h3><ul class="control-sidebar-menu"><li><a ui-sref="user-management"><i class="menu-icon glyphicon glyphicon-user bg-red"></i><div class="menu-info"><h4 class="control-sidebar-subheading">User management</h4><p>User management options</p></div></a></li><li><a ui-sref="jhi-metrics"><i class="menu-icon glyphicon glyphicon-dashboard bg-yellow"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Metrics</h4><p>Site metrics options</p></div></a></li><li><a ui-sref="jhi-health"><i class="menu-icon fa fa-heartbeat bg-light-blue" aria-hidden="true"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Health</h4><p>Site health options</p></div></a></li><li><a ui-sref="jhi-configuration"><i class="menu-icon fa fa-cog bg-green"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Configuration</h4><p>Site configuration options</p></div></a></li><li><a ui-sref="audits"><i class="menu-icon fa fa-history bg-aqua"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Audits</h4><p>Site audits options</p></div></a></li><li><a ui-sref="logs"><i class="menu-icon glyphicon glyphicon-list-alt bg-danger"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Logs</h4><p>Site logs</p></div></a></li><li ng-show="vm.swaggerEnabled"><a ui-sref="docs"><i class="menu-icon fa fa-cogs bg-fuchsia"></i><div class="menu-info"><h4 class="control-sidebar-subheading">API</h4><p>Site apis</p></div></a></li><li><a ui-sref="entity-audit"><i class="menu-icon fa fa-search bg-gray"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Entity Audit</h4><p>Site entities audit</p></div></a></li><li><a ui-sref="elasticsearch-reindex"><i class="menu-icon fa fa-search bg-gray"></i><div class="menu-info"><h4 class="control-sidebar-subheading">Reindex Elasticsearch</h4><p>Be careful!!!!!!!</p></div></a></li></ul><!--    <div class="tab-content">--><!--        <div class="tab-pane active" id="control-sidebar-settings-tab">--><!--            --><!--        </div>--><!--    </div>--></aside>');
$templateCache.put('app/layouts/error/accessdenied.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="error-body"><div class="error-page"><div class="error-content"><div class="container"><h2 class="headline text-yellow">403</h2><h3 class="margin-top-0"><i class="fa fa-warning text-yellow"></i>&nbsp;&nbsp;ACCESS DENIED!</h3><p>IT SEEM YOU ARE TRYING TO ACCESS TO A FORBIDDEN RESOURCE, CONTACT YOUR ADMINISTRATOR IF THIS AN ERROR.</p><div class="text-center"><a ui-sref="home" class="btn btn-info btn-block btn-flat margin-top-10">Back to dashboard</a></div></div></div></div><!-- /.error-page --></div></section><!--<div ng-cloak>--><!--<div class="row">--><!--<div class="col-md-4">--><!--<span class="hipster img-responsive img-rounded"></span>--><!--</div>--><!--<div class="col-md-8">--><!--<h1 data-translate="error.title">Error Page!</h1>--><!--<div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.--><!--</div>--><!--</div>--><!--</div>--><!--</div>-->');
$templateCache.put('app/layouts/error/construction.html','<section class="content"><!-- Default box --><div class="box"><div class="box-header with-border"><h3 class="box-title">We are working on this functionality!</h3></div><div class="box-body"><div class="abs-center"><div class="text-center mv-lg"><h1 class="mb-lg"><sup><em class="fa fa-cog fa-2x text-muted fa-spin text-info"></em></sup> <em class="fa fa-cog fa-5x text-muted fa-spin text-purple"></em> <em class="fa fa-cog fa-lg text-muted fa-spin text-success"></em></h1><div class="text-bold text-lg mb-lg">THIS PAGE IS UNDER MAINTENANCE</div><p class="lead m0">We\'ll back online shortly!</p></div></div></div><!-- /.box-body --><div class="box-footer"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div><!-- /.box-footer--></div><!-- /.box --></section>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.tpl.html','<!-- Main Footer --><footer class="main-footer no-print"><!-- To the right --><div class="pull-right hidden-xs">Version v{{appData.version + "." + appData.build + "_" + appData.instance + "-" + appData.branch}}</div><!-- Default to the left --> <strong>Copyright &copy; 2018 <a href="#">UDT Software, LLC</a>.</strong> All rights reserved.</footer>');
$templateCache.put('app/layouts/header/header.tpl.html','<style>.navbar-nav > .notifications-menu > .dropdown-menu > li .menu, .navbar-nav > .messages-menu > .dropdown-menu > li .menu, .navbar-nav > .tasks-menu > .dropdown-menu > li .menu {\n        max-height: 400px;\n        margin: 0;\n        padding: 0;\n        list-style: none;\n        overflow-x: hidden;\n    }</style><ng-include src="\'app/layouts/header/tpl/idle-tpl.html\'"></ng-include><!-- Main Header --><header class="main-header"><!-- Header Navbar --><nav class="navbar navbar-static-top" id="navbar" role="navigation"><!-- Sidebar toggle button--> <a href="" class="sidebar-toggle" data-toggle="offcanvas" role="button" ng-class="{\'navbar-collapsed\': isCollapsed}" ng-click="isCollapsed = !isCollapsed"><span class="animated-icon"></span> <span class="sr-only">Toggle navigation</span></a><div class="global-filter"><div class="input-layout"><ui-select name="filterOption" title="Search Bluebook..." id="field_filterOption" ng-change="vm.openChart($select.selected.id)" ng-model="vm.searchQuery" ng-model-options="{ debounce: 500 }" close-on-select="true"><ui-select-match placeholder="Search Bluebook...">{{$select.selected.firstName + " " + $select.selected.lastName}}</ui-select-match><ui-select-choices repeat="chart in vm.charts" refresh="vm.globalfilter($select.search)" refresh-delay="0"><div class="thumb"><img ng-src-auth="{{chart}}"></div><div class="info"><h5 class="name"><strong>{{chart.firstName + " " + chart.lastName}}</strong></h5><div class="small"><strong>{{chart.admissionDate | date: inputDateFormat}} - Mro. {{chart.mrNo}}</strong> - Patient</div></div><div class="status-tag"><span class="label label-info">{{chart.status}}</span></div></ui-select-choices></ui-select></div></div><!-- Navbar Right Menu --><div class="navbar-custom-menu"><ul class="nav navbar-nav"><li class="dropdown notifications-menu" id="notifications-menu" uib-dropdown ng-if="vm.corporation.rcopiaIntegration"><!-- Menu toggle button --> <a href="" class="dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle><i class="fa fa-bell-o"></i> <span class="label label-warning">{{vm.rcopiaTotalNotifications}}</span></a><ul class="dropdown-menu no-padding notification-ul" uib-dropdown-menu><li class="header">You have &nbsp;<strong>{{vm.rcopiaTotalNotifications}}</strong>&nbsp; notification{{vm.rcopiaTotalNotifications > 1 ? \'s\' : \'\'}}</li><li class="header"><strong>Prescription Report</strong></li><li><ul class="menu"><li><a ng-click="vm.rcopiaPopup(\'rx_pending\')"><i class="fa fa-users text-aqua"></i>{{vm.getNotificationLabel(\'rx_pending\')}} <span class="number">{{vm.findValue(\'rx_pending\')}}</span></a></li><li><a ng-click="vm.rcopiaPopup(\'rx_need_signing\')"><i class="fa fa-users text-aqua"></i>{{vm.getNotificationLabel(\'rx_need_signing\')}} <span class="number">{{vm.findValue(\'rx_need_signing\')}}</span></a></li></ul></li><li class="header"><strong>Pharmacy Messages</strong></li><li><ul class="menu"><li><a ng-click="vm.rcopiaPopup(\'refill\')"><i class="fa fa-users text-aqua"></i>{{vm.getNotificationLabel(\'refill\')}} <span class="number">{{vm.findValue(\'refill\')}}</span></a></li><li><a ng-click="vm.rcopiaPopup(\'rxchange\')"><i class="fa fa-users text-aqua"></i>{{vm.getNotificationLabel(\'rxchange\')}} <span class="number">{{vm.findValue(\'rxchange\')}}</span></a></li></ul></li></ul></li><!-- Notifications Menu --><!--                <li class="dropdown notifications-menu" id="notifications-menu" uib-dropdown>--><!--                    &lt;!&ndash; Menu toggle button &ndash;&gt;--><!--                    <a href="" class="dropdown-toggle"--><!--                       ng-class="vm.countNoViewedMessages > 0?\'unread\':\'read\'"--><!--                       data-toggle="dropdown"--><!--                       uib-dropdown-toggle="">--><!--                        <i class="fa" aria-hidden="true"--><!--                           ng-class="vm.notificationsCount > 0?(vm.notificationsNewCount > 0?\'fa-bell\':\'fa-bell-o\'):\'fa-bell-slash-o\'"></i>--><!--                        <span class="badge"--><!--                              ng-if="vm.notificationsNewCount > 0">{{vm.notificationsNewCount}}</span>--><!--                    </a>--><!--                    <ul class="dropdown-menu" uib-dropdown-menu>--><!--                        <li class="header">--><!--                            <div class="menu-icon"--><!--                                 ng-class="vm.notificationsNewCount > 0?\'unread\':\'read\'">--><!--                                <i class="fa fa-bell" aria-hidden="true"></i>--><!--                            </div>--><!--                            <p>You have <span class="count"--><!--                                              ng-class="vm.notificationsNewCount> 0?\'unread\':\'read\'">{{vm.notificationsNewCount}}</span> new notifications</p>--><!--                        </li>--><!--                        <li id="container-infinite"--><!--                            infinite-scroll="vm.loadPage(vm.page + 1)"--><!--                            infinite-scroll-container="\'#container-infinite\'"--><!--                            infinite-scroll-immediate-check="true">--><!--                            &lt;!&ndash; Inner Menu: contains the notifications &ndash;&gt;--><!--                                &lt;!&ndash; start notification &ndash;&gt;--><!--                                <div><a href="" class="notification-item" title="{{notification.title}}"--><!--                                   ng-repeat="notification in vm.notifications | orderBy: \'-createdDate\'"--><!--                                   ng-click="vm.saveViewed(notification)"--><!--                                   ng-class="notification.viewed?\'viewed\':\'not-viewed\'">--><!--                                    <div class="text">--><!--                                        <p class="title">{{notification.title}}</p>--><!--                                        <span class="small"--><!--                                              ng-class="{\'low\': notification.priorityLevel === \'LOW\',--><!--                                                         \'medium\': notification.priorityLevel === \'MEDIUM\',--><!--                                                         \'high\': notification.priorityLevel === \'HIGH\'}">{{notification.priorityLevel}} Priority</span>--><!--                                    </div>--><!--                                    <div class="icon">--><!--                                        <i class="fa" ng-class="notification.viewed?\'fa-circle\':\'fa-circle-o\'" aria-hidden="true"></i>--><!--                                    </div>--><!--                                </a></div>--><!--                        </li>--><!--                        <li class="footer">--><!--                            &lt;!&ndash;<a ng-href="/#/notifications">View all <i class="fa fa-arrow-circle-right" aria-hidden="true"></i></a>&ndash;&gt;--><!--                            <a ng-href=""> </a>--><!--                        </li>--><!--                    </ul>--><!--                </li>--><!-- Tasks Menu --><li class="dropdown tasks-menu" uib-dropdown><!-- Menu Toggle Button --><ul class="dropdown-menu" uib-dropdown-menu><li class="header">You have 9 tasks</li><li><!-- Inner menu: contains the tasks --><ul class="menu"><li><!-- Task item --> <a href=""><!-- Task title and progress text --><h3>Design some buttons <small class="pull-right">20%</small></h3><!-- The progress bar --><div class="progress xs"><!-- Change the css width attribute to simulate progress --><div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"><span class="sr-only">20% Complete</span></div></div></a></li><!-- end task item --></ul></li><li class="footer"><a href="">View all tasks</a></li></ul></li><!-- Control Sidebar Toggle Button --><li has-authority="ROLE_SYSTEM_ADMIN"><a href="" data-toggle="control-sidebar" id="toggleControlSidebar"><i class="fa fa-gear" aria-hidden="true"></i></a></li><!-- User Account Menu --><li class="dropdown user user-menu" uib-dropdown><!-- Menu Toggle Button --> <a href="#" class="dropdown-toggle" data-toggle="dropdown" uib-dropdown-toggle><!-- The user image in the navbar--> <img src="content/adminLTE/img/avatar5.png" class="user-image" alt="User Image"><!-- hidden-xs hides the username on small devices so only the image appears. --> <span class="user-name hidden-xs">{{vm.account.firstName}} <i class="fa fa-angle-down" aria-hidden="true"></i></span> <span class="notify-badge" ng-if="!vm.isSmallDevice && !vm.showNewChart">New</span></a><ul class="dropdown-menu" uib-dropdown-menu><!-- The user image in the menu --><li class="user-header"><!--                            <img src="content/adminLTE/img/avatar5.png" class="user-thumb" alt="User Image">--> <a href="" class=""><i class="fa fa-user-circle" aria-hidden="true"></i> {{vm.employeeFullName()}}</a></li><!-- Menu Body --><li><a href="" class="" ng-click="vm.changePassModal()"><i class="fa fa-lock" aria-hidden="true"></i> Password</a></li><li><a href="" class="" ng-click="vm.replaceSignatureModal()"><i class="fa fa-pencil" aria-hidden="true"></i> Signature</a></li><li ng-if="!vm.isSmallDevice && !vm.showNewChart"><a href="" class="" ng-click="vm.showFeaturePreview()"><i class="fa fa-random" aria-hidden="true"></i> Feature Preview <span class="badge" style="background: #0073b7; border-radius: 4px; margin-left: 5px; font: bold 12px \'Roboto\', sans-serif;">New</span></a></li><!-- Menu Footer--><li class="user-footer"><button type="button" class="btn btn-danger btn-block" ng-click="vm.logout()">Log Out <i class="fa fa-sign-out" aria-hidden="true"></i></button></li></ul></li></ul></div></nav></header>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png"> <span data-translate="global.title">Dialysis</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="race" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.race">Race</span></a></li><li ui-sref-active="active"><a ui-sref="ethnicity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ethnicity">Ethnicity</span></a></li><li ui-sref-active="active"><a ui-sref="education-level" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.educationLevel">Education Level</span></a></li><li ui-sref-active="active"><a ui-sref="religion" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.religion">Religion</span></a></li><li ui-sref-active="active"><a ui-sref="language" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.language">Language</span></a></li><li ui-sref-active="active"><a ui-sref="employment-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.employmentStatus">Employment Status</span></a></li><li ui-sref-active="active"><a ui-sref="residential-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.residentialStatus">Residential Status</span></a></li><li ui-sref-active="active"><a ui-sref="legal-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.legalStatus">Legal Status</span></a></li><li ui-sref-active="active"><a ui-sref="provider" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.provider">Provider</span></a></li><li ui-sref-active="active"><a ui-sref="health-plan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.healthPlan">Health Plan</span></a></li><li ui-sref-active="active"><a ui-sref="psychiatrist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.psychiatrist">Psychiatrist</span></a></li><li ui-sref-active="active"><a ui-sref="physician" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.physician">Physician</span></a></li><li ui-sref-active="active"><a ui-sref="patient" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.patient">Patient</span></a></li><li ui-sref-active="active"><a ui-sref="diagnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.diagnosis">Diagnosis</span></a></li><li ui-sref-active="active"><a ui-sref="intake" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.intake">Intake</span></a></li><li ui-sref-active="active"><a ui-sref="company" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.company">Company</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Country</span></a></li><li ui-sref-active="active"><a ui-sref="state" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.state">State</span></a></li><li ui-sref-active="active"><a ui-sref="city" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.city">City</span></a></li><li ui-sref-active="active"><a ui-sref="department" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.department">Department</span></a></li><li ui-sref-active="active"><a ui-sref="gender" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.gender">Gender</span></a></li><li ui-sref-active="active"><a ui-sref="marital" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.marital">Marital</span></a></li><li ui-sref-active="active"><a ui-sref="employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.employee">Employee</span></a></li><li ui-sref-active="active"><a ui-sref="contract-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contractType">Contract Type</span></a></li><li ui-sref-active="active"><a ui-sref="working-hours" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.workingHours">Working Hours</span></a></li><li ui-sref-active="active"><a ui-sref="schedule-pay" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.schedulePay">Schedule Pay</span></a></li><li ui-sref-active="active"><a ui-sref="contract-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contractStatus">Contract Status</span></a></li><li ui-sref-active="active"><a ui-sref="pay-roll-struct" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.payRollStruct">Pay Roll Struct</span></a></li><li ui-sref-active="active"><a ui-sref="contract" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.contract">Contract</span></a></li><li ui-sref-active="active"><a ui-sref="job-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.jobStatus">Job Status</span></a></li><li ui-sref-active="active"><a ui-sref="job" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.job">Job</span></a></li><li ui-sref-active="active"><a ui-sref="health-plan-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.healthPlanType">Health Plan Type</span></a></li><li ui-sref-active="active"><a ui-sref="patient-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Template</span></a></li><li ui-sref-active="active"><a ui-sref="patient-transfer-history" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Transfer History</span></a></li><li ui-sref-active="active"><a ui-sref="care-team-specialty" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Care Team Specialty</span></a></li><li ui-sref-active="active"><a ui-sref="care-team" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Care Team</span></a></li><li ui-sref-active="active"><a ui-sref="renal-failure" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Renal Failure</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access Type</span></a></li><li ui-sref-active="active"><a ui-sref="vein-site" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Vein Site</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access-function" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access Function</span></a></li><li ui-sref-active="active"><a ui-sref="patient-access-physician" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Access Physician</span></a></li><li ui-sref-active="active"><a ui-sref="diangnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Diangnosis</span></a></li><li ui-sref-active="active"><a ui-sref="problem-list" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Problem List</span></a></li><li ui-sref-active="active"><a ui-sref="patient" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient</span></a></li><li ui-sref-active="active"><a ui-sref="draw-week" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Draw Week</span></a></li><li ui-sref-active="active"><a ui-sref="report-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Report Group</span></a></li><li ui-sref-active="active"><a ui-sref="country-state" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Country State</span></a></li><li ui-sref-active="active"><a ui-sref="city" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>City</span></a></li><li ui-sref-active="active"><a ui-sref="address" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Address</span></a></li><li ui-sref-active="active"><a ui-sref="hospitalization-discharge-to" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Hospitalization Discharge To</span></a></li><li ui-sref-active="active"><a ui-sref="hospitalization" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Hospitalization</span></a></li><li ui-sref-active="active"><a ui-sref="source" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Source</span></a></li><li ui-sref-active="active"><a ui-sref="infection-primary-access" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Infection Primary Access</span></a></li><li ui-sref-active="active"><a ui-sref="dialyser-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Dialyser Type</span></a></li><li ui-sref-active="active"><a ui-sref="sympthom" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Sympthom</span></a></li><li ui-sref-active="active"><a ui-sref="infection" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Infection</span></a></li><li ui-sref-active="active"><a ui-sref="patient-address-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Address Type</span></a></li><li ui-sref-active="active"><a ui-sref="patient-address" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Address</span></a></li><li ui-sref-active="active"><a ui-sref="corporation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Corporation</span></a></li><li ui-sref-active="active"><a ui-sref="clinic" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Clinic</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-carrier" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Carrier</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Type</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-level" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Level</span></a></li><li ui-sref-active="active"><a ui-sref="insurance-relation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance Relation</span></a></li><li ui-sref-active="active"><a ui-sref="insurance" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Insurance</span></a></li><li ui-sref-active="active"><a ui-sref="modality" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Modality</span></a></li><li ui-sref-active="active"><a ui-sref="physician" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Physician</span></a></li><li ui-sref-active="active"><a ui-sref="language" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Language</span></a></li><li ui-sref-active="active"><a ui-sref="race" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Race</span></a></li><li ui-sref-active="active"><a ui-sref="patient-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Type</span></a></li><li ui-sref-active="active"><a ui-sref="diagnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Diagnosis</span></a></li><li ui-sref-active="active"><a ui-sref="symptom" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Symptom</span></a></li><li ui-sref-active="active"><a ui-sref="employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Employee</span></a></li><li ui-sref-active="active"><a ui-sref="patient-result" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Result</span></a></li><li ui-sref-active="active"><a ui-sref="employee-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Employee Type</span></a></li><li ui-sref-active="active"><a ui-sref="specialist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Specialist</span></a></li><li ui-sref-active="active"><a ui-sref="test-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Test Type</span></a></li><li ui-sref-active="active"><a ui-sref="test" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Test</span></a></li><li ui-sref-active="active"><a ui-sref="patient-order-test" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Order Test</span></a></li><li ui-sref-active="active"><a ui-sref="bed" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Bed</span></a></li><li ui-sref-active="active"><a ui-sref="forms" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Forms</span></a></li><li ui-sref-active="active"><a ui-sref="building" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Building</span></a></li><li ui-sref-active="active"><a ui-sref="room" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Room</span></a></li><li ui-sref-active="active"><a ui-sref="facility" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Facility</span></a></li><li ui-sref-active="active"><a ui-sref="urgent-issues" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Urgent Issues</span></a></li><li ui-sref-active="active"><a ui-sref="type-patient-process" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Type Patient Process</span></a></li><li ui-sref-active="active"><a ui-sref="chart-to-form" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Chart To Form</span></a></li><li ui-sref-active="active"><a ui-sref="evaluation-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Evaluation Template</span></a></li><li ui-sref-active="active"><a ui-sref="patient-medication-pres" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Medication Pres</span></a></li><li ui-sref-active="active"><a ui-sref="signature-guarantor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Signature Guarantor</span></a></li><li ui-sref-active="active"><a ui-sref="signature-patient" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Signature Patient</span></a></li><li ui-sref-active="active"><a ui-sref="signature-employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Signature Employee</span></a></li><li ui-sref-active="active"><a ui-sref="signature" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Signature</span></a></li><li ui-sref-active="active"><a ui-sref="evaluation-signature" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Evaluation Signature</span></a></li><li ui-sref-active="active"><a ui-sref="evaluation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Evaluation</span></a></li><li ui-sref-active="active"><a ui-sref="contacts-facility" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Contacts Facility</span></a></li><li ui-sref-active="active"><a ui-sref="file" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>File</span></a></li><li ui-sref-active="active"><a ui-sref="severity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Severity</span></a></li><li ui-sref-active="active"><a ui-sref="reaction" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Reactions</span></a></li><li ui-sref-active="active"><a ui-sref="allergen" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Allergen</span></a></li><li ui-sref-active="active"><a ui-sref="diagnoses" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Diagnoses</span></a></li><li ui-sref-active="active"><a ui-sref="acuity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Acuity</span></a></li><li ui-sref-active="active"><a ui-sref="type-check" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Type Check</span></a></li><li ui-sref-active="active"><a ui-sref="group-session-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Group Session Template</span></a></li><li ui-sref-active="active"><a ui-sref="group-session-frequency" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Group Session Frequency</span></a></li><li ui-sref-active="active"><a ui-sref="session-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Session Type</span></a></li><li ui-sref-active="active"><a ui-sref="section" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Section</span></a></li><li ui-sref-active="active"><a ui-sref="assistant" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Assistant</span></a></li><li ui-sref-active="active"><a ui-sref="group-session-template-facility" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Group Session Template Facility</span></a></li><li ui-sref-active="active"><a ui-sref="group-session" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Group Session</span></a></li><li ui-sref-active="active"><a ui-sref="group-session-details" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Group Session Details</span></a></li><li ui-sref-active="active"><a ui-sref="care-coordination-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Care Coordination Template</span></a></li><li ui-sref-active="active"><a ui-sref="care-coordination" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Care Coordination</span></a></li><li ui-sref-active="active"><a ui-sref="group-session-facility" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Group Session Facility</span></a></li><li ui-sref-active="active"><a ui-sref="notifications" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Notifications</span></a></li><li ui-sref-active="active"><a ui-sref="occupancy-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Occupancy Template</span></a></li><li ui-sref-active="active"><a ui-sref="result-range" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Result Range</span></a></li><li ui-sref-active="active"><a ui-sref="laboratory" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Laboratory</span></a></li><li ui-sref-active="active"><a ui-sref="drug" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Drug</span></a></li><li ui-sref-active="active"><a ui-sref="alcohol" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Alcohol</span></a></li><li ui-sref-active="active"><a ui-sref="sftp-facility-laboratory" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Report Category</span></a></li><li ui-sref-active="active"><a ui-sref="scheduler-config" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Scheduler Config</span></a></li><li ui-sref-active="active"><a ui-sref="report-category" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Report Category</span></a></li><li ui-sref-active="active"><a ui-sref="report-tpl" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Report Tpl</span></a></li><li ui-sref-active="active"><a ui-sref="pdf-chart-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Pdf Chart Report</span></a></li><li ui-sref-active="active"><a ui-sref="patient-medication" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Medication</span></a></li><li ui-sref-active="active"><a ui-sref="admission-medication" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Admission Medication</span></a></li><li ui-sref-active="active"><a ui-sref="source-medication" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Source Medication</span></a></li><li ui-sref-active="active"><a ui-sref="admission-medication" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Admission Medication</span></a></li><li ui-sref-active="active"><a ui-sref="patient-medication-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Patient Medication Template</span></a></li><li ui-sref-active="active"><a ui-sref="incident-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Incident Type</span></a></li><li ui-sref-active="active"><a ui-sref="incident-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Incident Report</span></a></li><li ui-sref-active="active"><a ui-sref="incident-report-note-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Incident Report Note Template</span></a></li><li ui-sref-active="active"><a ui-sref="incident-report-note" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Incident Report Note</span></a></li><li ui-sref-active="active"><a ui-sref="incident-report-note-template" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Incident Report Note Template</span></a></li><li ui-sref-active="active"><a ui-sref="campaign" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Campaign</span></a></li><li ui-sref-active="active"><a ui-sref="crm-outbound-referral" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Crm Outbound Referral</span></a></li><li ui-sref-active="active"><a ui-sref="crm-outbound-referral-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Crm Outbound Referral Status</span></a></li><li ui-sref-active="active"><a ui-sref="crm-tag" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Crm Tag</span></a></li><li ui-sref-active="active"><a ui-sref="procedure-diagnosis" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Procedure Diagnosis</span></a></li><li ui-sref-active="active"><a ui-sref="prog-elig-facility" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Facility Program Eligibility</span></a></li><li ui-sref-active="active"><a ui-sref="prog-elig-employee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Employee Program Eligibility</span></a></li><li ui-sref-active="active"><a ui-sref="covid-facility-lab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Covid Facility Lab</span></a></li><li ui-sref-active="active"><a ui-sref="covid-lab-compendium" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Covid Lab Compendium</span></a></li><li ui-sref-active="active"><a ui-sref="facility-icd-10" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Facility Icd 10</span></a></li><li ui-sref-active="active"><a ui-sref="lab-compendium-comment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Lab Compendium Comment</span></a></li><li ui-sref-active="active"><a ui-sref="protocol-group" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Protocol Group</span></a></li><li ui-sref-active="active"><a ui-sref="evaluation-template-mars-mors" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Evaluation Template Mars Mors</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span data-translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.entity-audit">Entity Audit</span></a></li><li ui-sref-active="active"><a ui-sref="entity-audit" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span>Entity Audit</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span>Elasticsearch Reindex</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/layouts/sidebar/sidebar.tpl.html','<!-- Left side column. contains the logo and sidebar --><aside class="main-sidebar"><!-- sidebar: style can be found in sidebar.less --><section class="sidebar"><div class="sidebar-selector" id="sidebar-selector" ng-class="{\'blue-bg\':  (vm.corporations.length == 1) && (vm.facilities.length > 1)}"><a href="" class="m-selector" ng-class="{\'active\': vm.showSidebarForms}" ng-click="vm.showSidebarForms = !vm.showSidebarForms"><span class="dot"></span> <span class="dot"></span> <span class="dot"></span> <span class="dot"></span> <span class="dot"></span> <span class="dot"></span> <span class="dot"></span> <span class="dot"></span> <span class="dot"></span></a><div class="selector-forms" ng-class="{\'active\': vm.showSidebarForms}"><form class="sidebar-form" role="search" ng-if="vm.corporations && vm.corporations.length > 1"><select class="form-control input-sm" name="corporation" id="field_corporation" ng-model="vm.corporation" ng-change="vm.selectCorporation()" ng-options="corporation as corporation.name for corporation in vm.corporations track by corporation.id"></select></form><form class="sidebar-form" role="search" ng-if="vm.facilities && vm.facilities.length > 1"><select class="form-control input-sm" name="facility" id="field_facility" ng-model="vm.currentFacility" ng-change="vm.changeFacility()" ng-options="facility as facility.name for facility in vm.facilities track by facility.id"></select></form></div></div><ul class="sidebar-menu"><li class="header"><span>Main Menu</span></li><!-- Optionally, you can add icons to the links --><li class="treeview {{menu.state}}" ng-repeat="menu in vm.sideBarItems" ng-class="vm.showSidebarItem()"><a ng-if="menu.url != null" ui-sref="{{menu.url}}" has-any-authority="{{menu.access}}" ng-click="menu.function()"><i class="{{menu.icon}}"></i> <span>{{menu.displayName}}</span> <span class="pull-right-container" ng-if="menu.items.length > 0"><i class="fa fa-angle-left pull-right"></i> </span></a><a ng-if="menu.url == null" has-any-authority="{{menu.access}}"><i class="{{menu.icon}}"></i> <span>{{menu.displayName}}</span> <span class="pull-right-container" ng-if="menu.items.length > 0"><i class="fa fa-angle-left pull-right"></i></span></a><ul class="treeview-menu {{menu.open}}" style="{{menu.style}}" ng-if="menu.items.length > 0"><li class="{{item.state}}" ng-repeat="item in menu.items"><a ng-if="item.enable && item.items == null" ui-sref="{{item.url}}" has-any-authority="{{item.access}}"><i class="{{item.icon}}"></i>{{item.displayName}} </a><a href="" class="{{item.state}}" ng-if="item.enable && item.items != null" has-any-authority="{{item.access}}"><i class="{{item.icon}}"></i>{{item.displayName}} <span class="pull-right-container"><i class="fa fa-angle-left pull-right"></i></span></a><ul class="treeview-menu {{item.open}}" style="{{item.style}}" ng-if="item.items != null"><li data-ng-repeat="item2 in item.items" has-any-authority="{{item2.access}}"><a ui-sref="{{item2.url}}" ng-if="item2.enable"><i class="{{item2.icon}}"></i>{{item2.displayName}}</a></li></ul></li></ul></li></ul><!-- /.sidebar-menu --></section><!-- /.sidebar --><!--\n    <div class="bottom-buttons">\n        <ul class="buttons">\n            <li>\n                <a href="" class="sidebar-btn" role="button"\n                   uib-tooltip="Log Out"\n                   ng-click="vm.logout()">\n                    Sign Out <i class="fa fa-sign-out" aria-hidden="true"></i>\n                </a>\n            </li>\n        </ul>\n    </div>\n    --></aside>');
$templateCache.put('app/entities/super-bill-diagnosis/super-bill-diagnoses-dialog.html','<form name="editForm" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create/Edit a Diagnoses</h4></div><div class="modal-body"><div class="row"><div class="col-lg-12"><jhi-alert-error></jhi-alert-error></div></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.icd10Tmp.length > 0?(editForm.icd10.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_icd10">Diagnoses(ICD10):</label><ui-select name="icd10" id="field_icd10" title="icd10" multiple="multiple" ng-disabled="vm.superBillDiagnosis.id" ng-model="vm.icd10Tmp" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.icd10 | filter: $select.search" minimun-input-length="1" refresh="vm.getIcd10($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' - \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.icd10Tmp.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.icd10Tmp.length > 0 && editForm.icd10.$dirty"></span> <span class="help-block" ng-show="!vm.icd10Tmp.length > 0">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.superBillDiagnosis.startDate?(editForm.startDate.$dirty && editForm.startDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.superBillDiagnosis.startDate" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.superBillDiagnosis.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.superBillDiagnosis.startDate && editForm.startDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.superBillDiagnosis.startDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.superBillDiagnosis.endDate?(editForm.endDate.$dirty && editForm.endDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.superBillDiagnosis.endDate" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.superBillDiagnosis.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.superBillDiagnosis.endDate && editForm.endDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.superBillDiagnosis.endDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.superBillDiagnosis.comment?(editForm.comment.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_comment">Comment</label> <textarea rows="3" type="text" class="form-control" name="comment" id="field_comment" data-resize="disabled" ng-model="vm.superBillDiagnosis.comment"></textarea> <span class="help-block help-warning" ng-show="!vm.superBillDiagnosis.comment">This field is suggested</span></div></div></div></fieldset></div><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.superBillDiagnosis.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" ng-click="vm.save()" class="btn btn-success" ng-if="vm.chart.status != \'CLOSED\'" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Diagnoses from this patient\'s record. Are you sure you want to <strong>delete</strong> this Diagnoses?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/super-bill-diagnosis/super-bill-diagnoses.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Diagnosis</strong> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><div class="info no-padding" dnd-list="vm.superBillDiagnoses"><p class="mb-0" ng-repeat="($index, diagnosis) in vm.superBillDiagnoses" ng-click="vm.edit(diagnosis.id)" dnd-handle dnd-draggable="diagnosis" dnd-dragend="vm.onDragEnd(vm.superBillDiagnoses)" dnd-moved="vm.superBillDiagnoses.splice($index, 1)" dnd-effect-allowed="move"><strong>{{diagnosis.icd10.code}}</strong> - <span>{{diagnosis.icd10.description}}</span></p></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label> <input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label> <input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');
$templateCache.put('app/components/udt/search-icd10/search-icd10.html','<div class="text-right" uib-dropdown auto-close="always" is-open="isOpen"><a href="" class="" uib-dropdown-toggle style="color: #333333">Search <i class="fa" ng-class="isOpen?\'fa-angle-up\':\'fa-angle-down\'" aria-hidden="true"></i></a><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu><li role="menuitem"><div class="search-dropdown"><div class="search-options"><uib-tabset active="0" justified="true"><uib-tab><uib-tab-heading><i class="{{tab.icon}}" aria-hidden="true"></i> Chart related</uib-tab-heading><ul class="list-unstyled"><li class="checkbox" ng-repeat="($index, option) in activeIcd10" index="$index"><label><input type="checkbox" id="field_checkbox{{$index}}" name="checkbox_{{$index}}" ng-model="selected[option.id]" ng-change="check(option, selected[option.id])"> <span>{{option.code + " " + option.description}}</span></label></li></ul></uib-tab><uib-tab><uib-tab-heading><i class="{{tab.icon}}" aria-hidden="true"></i> Facility related</uib-tab-heading><ul class="list-unstyled"><li class="checkbox" ng-repeat="($index, option) in facilityIcd10"><label><input type="checkbox" id="field_checkbox_facility_{{$index}}" name="checkbox_facility_{{$index}}" ng-model="selected[option.id]" ng-change="check(option, selected[option.id])"> <span>{{option.code + " " + option.description}}</span></label></li></ul></uib-tab></uib-tabset></div></div></li></ul></div>');
$templateCache.put('app/components/udt/sign/sign-forms.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myImageLabel">Sign</h4></div><div class="modal-body"><div ng-if="!vm.guarantor.id && vm.jsonData.guarantorSignatureRequired" class="bg-yellow" style="padding: 20px 30px; z-index: 999999; font-size: 16px; font-weight: 600" aria-hidden="false"><div class="row"><span style="color: rgba(255, 255, 255, 0.901961); display: inline-block; margin-right: 10px; text-decoration: none">This patient doesn\'t have a Guarantor assigned.</span></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label class="control-label" for="signatory">Who signs *</label><br><select class="form-control" ng-model="vm.signForm.signatory" ng-options="item as item for item in vm.signatories track by item" id="signatory" name="signatory" required><!--<option value=""></option>--></select></div></div><div class="col-xs-12"><div class="form-group"><j-signature ng-model="customSignature" bg-color="#EEEEEE" color="#00008B" height="138px"></j-signature></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Accept</span></button></div></form>');
$templateCache.put('app/components/udt/signature/signature-contact-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Guarantor Signature</h4></div><div class="modal-body"><div class="row"><div class="col-lg-3"></div><div class="col-lg-6"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-3"></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group has-feedback centered drawer-sign" ng-class="vm.evaluation.guarantor?\'has-success\':\'has-error\'"><label for="field_guarantor">Guarantor:</label><ui-select ng-model="vm.guarantor" name="guarantor" ng-required="true" title="Guarantor" id="field_guarantor" ng-change="vm.clearForm()" reset-search-input="false" required="true"><ui-select-match placeholder="Select guarantor...">{{($select.selected.fullName)}}</ui-select-match><ui-select-choices repeat="guarantor in vm.guarantors | propsFilter: {fullName: $select.search}">{{(guarantor.fullName)}}</ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm has-feedback centered drawer-sign"><label>Sign Here:</label><ods-signature name="guarantor_signature-{{vm.odsGuarantorSignatureNameId}}" ng-model="vm.guarantorSignature" options="vm.signatureOpts" ng-change="vm.clear()"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_guarantorSignatureAgree"><input type="checkbox" name="guarantorSignatureAgree" id="field_guarantorSignatureAgree" ng-model="vm.guarantorSignatureAgree"> I, {{vm.guarantor.fullName}}, have reviewed, agree and understand the information contained here in the {{vm.evaluation.name + (vm.evaluation.title ? vm.evaluation.title : "")}}.</label></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.sign()" ng-disabled="!vm.guarantorSignatureAgree || !vm.guarantorSignature "><i class="fa fa-ban" aria-hidden="true"></i> Sign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/components/udt/signature/signature-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Collect Signature</h4></div><div class="modal-body"><div class="row"><div class="col-lg-3"></div><div class="col-lg-6"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-3"></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.employeeSignature"><div class="form-group form-group-sm centered drawer-sign"><label for="physicianPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="physicianPin" name="physicianPin" maxlength="4" pattern="\\d{4}" ng-model="vm.employeeSignaturePin" ng-required="vm.employeeSignature === null" ng-change="vm.employeeSignature = \'\'" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="vm.employeeSignaturePin === null || vm.employeeSignaturePin === \'\'"><div class="form-group form-group-sm centered drawer-sign"><label>Or Sign Here:</label><ods-signature ng-model="vm.employeeSignature" options="vm.signatureOpts" name="physician_signature-{{vm.odsSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_employeeSignatureAgree"><input type="checkbox" name="employeeSignatureAgree" id="field_employeeSignatureAgree" ng-model="vm.employeeSignatureAgree"> I, {{vm.employee.firstName + \' \' + vm.employee.lastName}}, have reviewed, agree and understand the information contained here.</label></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.sign()" ng-disabled="!vm.employeeSignatureAgree || !(vm.employeeSignature || vm.employeeSignaturePin)"><i class="fa fa-ban" aria-hidden="true"></i> Sign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/components/udt/signature/signature-patient-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Patient Signature</h4></div><div class="modal-body"><div class="row"><div class="col-lg-3"></div><div class="col-lg-6"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-3"></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature ng-model="vm.patientSignature" name="patient_signature-{{vm.odsSignatureNameId}}" options="vm.signatureOpts" ng-change="vm.clear()"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_patientSignatureAgree"><input type="checkbox" name="patientSignatureAgree" id="field_patientSignatureAgree" ng-model="vm.patientSignatureAgree"> I, {{vm.chart.firstName + \' \' + vm.chart.lastName}}, have reviewed, agree and understand the information contained here.</label></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.sign()" ng-disabled="!vm.patientSignatureAgree || !vm.patientSignature "><i class="fa fa-ban" aria-hidden="true"></i> Sign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/components/udt/udt-attach-evaluation-file/udt-attach-evaluation-file.html','<div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="custom-file-upload"><div class="input-wrapper"><label for="fileUploads"><i class="fa fa-paperclip" aria-hidden="true"></i> Choose files... <input type="file" id="fileUploads" ngf-select multiple="multiple" ngf-change="attachFile($files)" accept="image/png, image/jpeg , .txt, .pdf"></label></div><div class="file-list" id="fileList"><div style="display: flex; flex-wrap: wrap"><div ng-repeat="efile in files track by efile.id " style="position: relative; margin-bottom: 15px; width: 20%;"><div style="text-align: center" ng-click="getFileAttached(efile.id)"><figure><img style="width: 200px; height: 140px; padding: 10px; border: 1px solid white" ng-src-evaluation-auth="{{efile.id}}" ng-if="efile.preview"><div style="display: flex; justify-content: center; align-items: center; width: 200px; height: 140px; padding: 10px; border: 1px solid white" ng-if="efile.preview == null"><i class="fa fa-3x" ng-class="getIcon(efile.file.type)"></i></div><figcaption><span title="{{efile.file.name}}">{{efile.file.name}}</span></figcaption></figure></div><span style="position: absolute; top: 0; right:5px; cursor: hand" ng-click="$scope.showMessageConfirmDelete = true" uib-tooltip="Delete file"><i class="fa fa-times-circle" style="color: black; background: white; border: 1px solid white; border-radius: 50%; box-shadow: 1px 1px 2px black"></i></span><div ng ng-show="$scope.showMessageConfirmDelete" class="text-center" style="display: flex; justify-content: center; flex-direction: column; align-items: center; position: absolute; top: 10px; right: 10px; left: 10px; bottom: 30px; background: rgba(0,0,0,0.6);"><p style="color: white"><strong>Confirm Delete?</strong></p><div><button type="button" class="btn btn-success btn-sm" ng-click="deleteFile(efile.id)"><i class="fa fa-check" aria-hidden="true"></i></button> <button type="button" class="btn btn-danger btn-sm" ng-click="$scope.showMessageConfirmDelete = false"><i class="fa fa-ban" aria-hidden="true"></i></button></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/components/udt/udt-chart-header/udt-chart-header.html','<header class="basic-inf" ng-if="!sidebarLayout"><div class="photo"><img class="img-responsive img-thumbnail" alt="Patient Photo" ng-src-auth="{{chart}}"></div><div class="basic-data"><h3 class="name mb-15 mt-0"><strong>{{fullName}}</strong> [<span class="small"><strong>MR#: {{chart.mrNo}}</strong></span>]</h3><p class="mb-0"><strong>D.O.B.:</strong></p><td>{{chart.dateBirth | date: \'MM/dd/yyyy\'}}</td><p></p><p class="mb-0"><strong>D.O.A.:</strong></p><td>{{chart.admissionDate | date: \'MM/dd/yyyy\'}}</td><p></p></div><div class="allergies-list" ng-if="showAllergies"><h3 class="mt-0">Allergies:</h3><p><span class="allergy">{{allergiesStr}}</span></p></div></header><div ng-if="sidebarLayout"><section class="data-section with-pic"><div class="photo" style="width: 140px;"><img class="img-responsive img-thumbnail" alt="Patient Photo" ng-src-auth="{{chart}}"></div><div class="info"><h4 class="name mt-0">{{fullName}}</h4><p><strong>D.O.B.:</strong> {{chart.dateBirth | date: \'MM/dd/yyyy\'}}</p><p><strong>D.O.A.:</strong> {{chart.admissionDate | date: \'MM/dd/yyyy\'}}</p><p><strong>Mr#:</strong> {{chart.mrNo}}</p></div></section><section class="data-section"><div class="allergies"><h5 class="header-label mt-0" style="width: 100%"><strong>Allergies</strong> <a href="" class="btn-icon" uib-tooltip="Show History"><i class="fa fa-history"></i> </a><a href="" class="btn-icon" uib-tooltip="Add Allergies"><i class="fa fa-plus-circle"></i></a></h5><p>{{allergiesStr}}</p></div></section></div>');
$templateCache.put('app/components/udt/udt-crop-image/udt-crop-image-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myImageLabel">Change/Edit Image</h4></div><div class="modal-body"><udt-crop-image cropped-image="vm.croppedImage" image="vm.image" default-image="{{vm.defaultImage}}" area-type="{{vm.cropType}}"></udt-crop-image></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.upload.invalid.$error"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/components/udt/udt-crop-image/udt-crop-image.html','<div class="cropper-wrapper"><div class="crop-area" ng-class="!image?\'default-img\':\'\'"><ui-cropper image="image" area-type="{{areaType}}" chargement="\'Loading\'" result-image-size="resultImageSize" result-image="croppedImage" canvas-scalemode="true" result-image-format="image/jpeg" change-on-fly="true"></ui-cropper><img class="profile-user-img img-responsive {{class}}" id="imgPictureDefault" data-ng-src="{{defaultImageModel}}" ng-if="!image" style="cursor: pointer;min-height: 100px" alt="User profile picture"><div class="load-button"><button type="button" class="btn btn-warning btn-block" ngf-select ngf-change="handleFileSelect($event, $file)" accept="image/*"><i class="fa fa-image" aria-hidden="true"></i> Browse...</button></div></div><div class="cropped-image" ng-if="image"><img ng-src="{{croppedImage}}"></div></div>');
$templateCache.put('app/components/udt/udt-group-session-detail/udt-group-session-detail.html','<div class="attendee"><div class="info"><div class="p-photo"><img class="photo img-thumbnail" id="imgPicture" alt="User profile picture" ng-src-auth="{{groupSessionDetails.chart}}"></div><div><button type="button" class="btn btn-sm" ng-class="groupSessionDetails.present ? \'btn-success\' : \'btn-danger\'" ng-click="changePresentStatus()"><i class="fa fa-check-circle-o" aria-hidden="true"></i> <span>{{groupSessionDetails.present ? \'Present\' : \'No Present\'}}</span></button><div style="width: 100%"><div class="name"><span>{{groupSessionDetails.chart.firstName + \' \' + groupSessionDetails.chart.lastName}}</span></div><div class="mr-number"><span>{{groupSessionDetails.chart.mrNo}}</span></div><div class="timers" ng-if="groupSessionDetails.present"><div class="start-time"><label>Start:</label> <input type="time" ng-model="groupSessionDetails.start" class="form-control" ng-model-options="{debounce: 500}"></div><div class="start-end"><label>End:</label> <input type="time" ng-model="groupSessionDetails.stop" class="form-control"></div></div></div><!--            <div style="width: 100%" class="row">--><div class="row"><div class="col-lg-12"><div class="form-group"><div class="timers" ng-if="groupSessionDetails.present"><select class="form-control" id="field_levelCare" name="typeLevelCare" ng-model="groupSessionDetails.typeLevelCare" ng-options="item as item.name for item in typeLevelCare track by item.name"></select></div></div></div></div></div></div><div ng-if="json" class="annexed opened well well-sm"><form name="editForm" role="form" novalidate><ods-form schema="json"></ods-form></form></div></div>');
$templateCache.put('app/components/udt/udt-image/udt-img-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myImageLabel">Create or edit a Picture</h4></div><div class="modal-body"><div class="row"><div class="col-lg-12"><img data-ng-src="{{\'data:\' + vm.image.pictureContentType + \';base64,\' + vm.image.picture}}" class="img-responsive" ng-if="vm.image.picture"><div ng-if="vm.image.picture" class="help-block clearfix"><span class="pull-left">{{vm.image.pictureContentType}}, {{vm.byteSize(vm.image.picture)}}</span> <button type="button" ng-click="vm.resetUserPicture()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setPicture($file, vm.image)" accept="image/*">Browse...</button></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Accept</span></button></div></form>');
$templateCache.put('app/components/udt/udt-image/udt-img.html','<img class="profile-user-img img-responsive {{class}}" id="imgPicture" data-ng-src="{{\'data:\' + imageType + \';base64,\' + image}}" ng-click="openModal()" style="cursor: pointer;min-height: 100px" alt="User profile picture">');
$templateCache.put('app/components/udt/udt-loader/loader.html','<div class="loader-widget-mask"><div class="layout-mask"><div class="header"><div class="double-lines left"><div class="line"></div><div class="line thin"></div></div><div class="double-lines right"><div class="line"></div><div class="line thin"></div></div></div><div class="sidebar"><div class="user-outlines mb-30"><div class="avatar-outline"></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div><div class="double-lines"><div class="line"></div><div class="line thin"></div></div></div></div><div class="widget-container"><!--\n        <div style="width:100%;height:100%" class="lds-pacman">\n            <div>\n                <div></div>\n                <div></div>\n                <div></div>\n            </div>\n            <div>\n                <div></div>\n                <div></div>\n            </div>\n        </div>\n        --><!-- SQUARES --><div style="width:100%;height:100%" class="lds-square"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><h2 class="jumbo-text">Bluebook</h2></div></div>');
$templateCache.put('app/components/udt/udt-menu-options-bottom/udt-menu-options-bottom.html','<div class="btn-group dropup" uib-dropdown><button type="button" class="btn btn-default" style="border-top-left-radius: 0; border-bottom-left-radius: 0" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu"><li role="menuitem" ng-if="chartStatus !== \'CLOSED\'" has-any-authority="{{accessCloseChart}}"><a href="" ng-click="sendEvent(\'closeChart\')"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Close Chart</a></li><li role="menuitem" ng-if="chartStatus === \'WAITING\'"><a href="" ng-click="sendEvent(\'setToCurrent\')"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Set to current</a></li><li role="menuitem" ng-if="chartStatus === \'CLOSED\'"><a href="" ng-click="sendEvent(\'reopenChart\')"><i class="fa fa-repeat" aria-hidden="true"></i> Reopen Chart</a></li><li role="menuitem"><a href="" ng-click="sendEvent(\'copyChart\')"><i class="fa fa-file" aria-hidden="true"></i> Copy Chart</a></li><li role="menuitem" ng-if="chartStatus !== \'CLOSED\'"><a href="" ng-click="sendEvent(\'chartExport\')"><i class="fa fa-file" aria-hidden="true"></i> Chart Export</a></li><li role="menuitem"><a href="" ng-click="sendEvent(\'foodMemo\')"><i class="fa fa-cutlery" aria-hidden="true"></i> Food Memo</a></li><li role="menuitem"><a href="" ng-click="sendEvent(\'blueAlerts\')"><i class="fa fa-bell" aria-hidden="true"></i> Blue Alerts</a></li><li class="divider" has-any-authority="ROLE_SYSTEM_ADMIN"></li><li role="menuitem" has-any-authority="ROLE_SYSTEM_ADMIN"><a ng-click="sendEvent(\'deleteChart\')"><i class="fa fa-trash" aria-hidden="true"></i>DELETE CHART</a></li></ul></div>');
$templateCache.put('app/components/udt/udt-xeditable/udt-xeditable.html','<table class="table table-bordered table-hover table-condensed"><tr style="font-weight: bold" bgcolor="#fbfbfb"><td style="width:90%">Name</td><td style="width:10%">Edit</td></tr><tr ng-repeat="item in itemList"><td><!-- editable username (text with validation) --> <span editable-text="item.name" e-name="name" e-form="xeditableForm" onbeforesave="checkName($data, item.id)">{{ item.name || \'empty\' }}</span></td><!--<td>\n            &lt;!&ndash; editable status (select-local) &ndash;&gt;\n            <span editable-select="user.status" e-name="status" e-form="xeditableForm" e-ng-options="s.value as s.text for s in vm.statuses">{{ vm.showStatus(user) }}</span>\n        </td>\n        <td>\n            &lt;!&ndash; editable group (select-remote) &ndash;&gt;\n            <span editable-select="user.group" e-name="group" onshow="vm.loadGroups()" e-form="xeditableForm" e-ng-options="g.id as g.text for g in vm.groups">{{ vm.showGroup(user) }} </span>\n        </td>--><td style="white-space: nowrap"><!-- form --><form editable-form name="xeditableForm" onbeforesave="saveItem($data, item.id)" ng-show="xeditableForm.$visible" class="form-buttons form-inline" shown="inserted == item"><button type="submit" ng-disabled="xeditableForm.$waiting" class="btn btn-primary">save</button> <button type="button" ng-disabled="xeditableForm.$waiting" ng-click="xeditableForm.$cancel()" class="btn btn-default">cancel</button></form><div class="buttons" ng-show="!xeditableForm.$visible"><button type="button" class="btn btn-primary" ng-click="xeditableForm.$show()">edit</button> <button type="button" class="btn btn-danger" ng-click="removeItem($index)">del</button></div></td></tr></table><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="addItem()">Add row</button></div>');
$templateCache.put('app/dashboard2/layout/abnormal-result/abnormal-results-top-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big yellow"><i class="fa fa-flag-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.abnormal.value?vm.abnormal.value:\'0\'}}</span><p class="jr-card-label">Abnormal Results</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="abnormal-result">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/bed/bed-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big red"><i class="fa fa-bed" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Empty Beds</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Bed</th><th scope="col" style="text-align: right">Gender</th></tr></thead><tbody><tr dir-paginate="bed in vm.beds|itemsPerPage:4 track by $index" pagination-id="bed" ng-click="vm.assignBed(bed.bedId)" )><td><span>{{bed.buildingName + \' - \' + bed.bedName}}</span></td><td align="right"><span>{{bed.gender}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.count > 0"><div class="link"><div class="text-center"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="bed" max-size="5" direction-links="true" boundary-links="true"></dir-pagination-controls></div></div></div>');
$templateCache.put('app/dashboard2/layout/case-load/case-load-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big aqua"><i class="fa fa-users" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Case Load</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Case Load</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr dir-paginate="item in vm.countCaseLoad|itemsPerPage:4 track by $index" pagination-id="caseLoad" ng-click="vm.openCharts(item.employee)" )><td><span>{{item.employee.lastName + ", " + item.employee.firstName}}</span></td><td align="right"><span>{{item.count}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer"><div class="link"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="caseLoad" max-size="5" direction-links="true" boundary-links="true"></dir-pagination-controls></div></div>');
$templateCache.put('app/dashboard2/layout/chart-review/chart-review-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big aqua"><i class="fa fa-id-badge" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.total?vm.total:\'0\'}}</span><p class="jr-card-label">Chart Review</p></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="jr-progress-container"><span class="jr-progress-badge expired">Diagnosis Code</span><div class="progress jr"><div class="progress-bar expired" role="progressbar" aria-valuenow="{{vm.percentDiagnosis}}" aria-valuemin="0" aria-valuemax="100" style="width:{{vm.percentDiagnosis}}%"><span class="jr-progress-value expired">{{vm.percentDiagnosis}}%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge forty-eight">Care Team Member</span><div class="progress jr"><div class="progress-bar forty-eight" role="progressbar" aria-valuenow="{{vm.percentCareTeam}}" aria-valuemin="0" aria-valuemax="100" style="width:{{vm.percentCareTeam}}%"><span class="jr-progress-value forty-eight">{{vm.percentCareTeam}}%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge hundred-twenty">Insurance</span><div class="progress jr"><div class="progress-bar hundred-twenty" role="progressbar" aria-valuenow="{{vm.percentInsurance}}" aria-valuemin="0" aria-valuemax="100" style="width:{{vm.percentInsurance}}%"><span class="jr-progress-value hundred-twenty">{{vm.percentInsurance}}%</span></div></div></div></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="charts-review">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/concurrent-reviews/concurrent-reviews-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big red"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.total?vm.total:\'0\'}}</span><p class="jr-card-label">Concurrent Reviews</p></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="jr-progress-container"><span class="jr-progress-badge expired">Without Concurrent Reviews</span><div class="progress jr"><div class="progress-bar expired" role="progressbar" aria-valuenow="{{vm.percentWithout}}" aria-valuemin="" aria-valuemax="100" style="width:{{vm.percentWithout}}%"><span class="jr-progress-value expired">{{vm.percentWithout}}%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge forty-eight">Expired Concurrent Reviews</span><div class="progress jr"><div class="progress-bar forty-eight" role="progressbar" aria-valuenow="{{vm.percentExpired}}" aria-valuemin="" aria-valuemax="100" style="width:{{vm.percentExpired}}%"><span class="jr-progress-value forty-eight">{{vm.percentExpired}}%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge hundred-twenty">Expiring Concurrent Reviews</span><div class="progress jr"><div class="progress-bar hundred-twenty" role="progressbar" aria-valuenow="{{vm.percentExpiring}}" aria-valuemin="" aria-valuemax="100" style="width:{{vm.percentExpiring}}%"><span class="jr-progress-value hundred-twenty">{{vm.percentExpiring}}%</span></div></div></div></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="concurrent-reviews">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/discharge-type/discharge-type-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big aqua"><i class="fa fa-sign-out" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count ? vm.count : \'0\'}}</span><p class="jr-card-label">Discharge Type</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Type</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr dir-paginate="item in vm.dischargeType|itemsPerPage:4" pagination-id="dischargeType" ng-click="vm.openCharts(item.typeDischargeType)" )><td><span>{{vm.dischargeTypeAdjust(item.typeDischargeType.name)}}</span></td><td align="right"><span>{{item.count}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.count > 0"><div class="link"><div class="text-center"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="dischargeType" [max-size="5" ] [direction-links="true" ] [boundary-links="true" ]></dir-pagination-controls></div></div></div>');
$templateCache.put('app/dashboard2/layout/discharging-patients/discharging-patinets-box.html','<div class="jr-card-body"><div class="layout-full mb-30"><div class="search-group collapsed" ng-class="isExpanded?\'expanded\':\'\'"><button type="button" class="btn btn-lg btn-danger" ng-click="isExpanded = !isExpanded"><i class="fa fa-search" aria-hidden="true" ng-class="isExpanded?\'fa-search-minus\':\'fa-search-plus\'"></i></button> <input type="text" placeholder="Search query..." ng-model="vm.searchQuery" ng-change="vm.searchByQuery()"></div><div class="jr-numbers"><span class="jr-counter">{{vm.queryCount?vm.queryCount:\'0\'}}</span><p class="jr-card-label">Discharging Patients</p></div></div><div class="table-responsive m-row-fix"><table class="table table-hover"><thead class="jr-thead"><tr><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Patient Name</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Mr No</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Discharge Date</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Discharge to</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Referral S.</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Outreach</th></tr></thead><tbody><tr ng-repeat="item in vm.charts" ng-click="vm.openChart(item.id)"><td>{{item.firstName}} {{item.lastName}}.</td><td>{{item.mrNo}}</td><td>{{item.dischargeDate | date: inputDateFormat}}</td><td>{{vm.dischargeTo(item.dischargeTo)}}</td><td>{{vm.referral(item.referrer)}}</td><td>{{item.marketer | employeeName }}</td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.charts.length > 0"><div class="link"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/dashboard2/layout/empty-care-delivery/empty-care-delivery-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big aqua"><i class="fa fa-file-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Empty Care & Delivery</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="empty">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/incident-report/incident-report-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big red"><i class="fa fa-wheelchair-alt" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Incident Report</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Type</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr><td>Violent Altercation</td><td style="text-align: right">3</td></tr><tr><td>Police Involve</td><td style="text-align: right">3</td></tr><tr><td>Heated Argument</td><td style="text-align: right">10</td></tr><tr><td>Non-Violent Altercation</td><td style="text-align: right">10</td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.count > 0"><div class="link"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="incidentReport" [max-size="5" ] [direction-links="true" ] [boundary-links="true" ]></dir-pagination-controls></div></div>');
$templateCache.put('app/dashboard2/layout/incoming-patients/incoming-patients-box.html','<div class="jr-card-body"><div class="layout-full mb-30"><div class="big-btns btn-group btn-group-lg" role="group"><button type="button" class="btn btn-primary" ng-click="vm.showCreatePatientPopup()" uib-tooltip="Create"><i class="fa fa-plus" aria-hidden="true"></i></button></div><div class="search-group collapsed" ng-class="isExpanded?\'expanded\':\'\'"><button type="button" class="btn btn-lg btn-warning" ng-click="isExpanded = !isExpanded"><i class="fa fa-search" aria-hidden="true" ng-class="isExpanded?\'fa-search-minus\':\'fa-search-plus\'"></i></button> <input type="text" placeholder="Search query..." ng-model="vm.filter.searchQuery" ng-change="vm.searchByQuery()"></div><div class="jr-numbers"><span class="jr-counter">{{vm.queryCount?vm.queryCount:\'0\'}}</span><p class="jr-card-label">Incoming Patients</p></div></div><div class="table-responsive m-row-fix"><table class="table table-hover"><thead class="jr-thead"><tr><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Patient Name</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Mr No</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Admission Date</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">LOC</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Referral S.</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Outreach</th></tr></thead><tbody><tr ng-repeat="item in vm.charts" ng-click="vm.openChart(item.id)"><td>{{item.firstName}} {{item.lastName}}.</td><td>{{item.mrNo}}</td><td>{{item.admissionDate | date: inputDateFormat}}</td><td>{{vm.levelCare(item.typeLevelCare.name)}}</td><td>{{vm.referral(item.referrer)}}</td><td>{{item.marketer | employeeName }}</td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.charts.length > 0"><div class="link"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/dashboard2/layout/late-care-delivery/late-care-delivery-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big yellow"><i class="fa fa-clock-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.total}}</span><p class="jr-card-label">Late Care & Delivery</p></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="jr-progress-container"><span class="jr-progress-badge expired">Closed</span><div class="progress jr"><div class="progress-bar expired" role="progressbar" aria-valuenow="{{vm.percentClosed}}" aria-valuemin="0" aria-valuemax="100" style="width: {{vm.percentClosed}}%"><span class="jr-progress-value expired">{{vm.percentClosed}}%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge forty-eight">Archive</span><div class="progress jr"><div class="progress-bar forty-eight" role="progressbar" aria-valuenow="{{vm.percentArchive}}" aria-valuemin="0" aria-valuemax="100" style="width:{{vm.percentArchive}}%"><span class="jr-progress-value forty-eight">{{vm.percentArchive}}%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge hundred-twenty">Current</span><div class="progress jr"><div class="progress-bar hundred-twenty" role="progressbar" aria-valuenow="{{vm.percentCurrent}}" aria-valuemin="0" aria-valuemax="100" style="width:{{vm.percentCurrent}}%"><span class="jr-progress-value hundred-twenty">{{vm.percentCurrent}}%</span></div></div></div></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="late">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/level-care/level-care-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big green"><i class="fa fa-street-view" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Level of Care</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">LOC</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr dir-paginate="item in vm.countLevelOfCare|itemsPerPage:4" pagination-id="levelOfCare" ng-click="vm.openCharts(item.typeLevelCare)" )><td><span>{{item.typeLevelCare.name}}</span></td><td align="right"><span>{{item.count}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer"><div class="link"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="levelOfCare" [max-size="5" ] [direction-links="true" ] [boundary-links="true" ]></dir-pagination-controls></div></div><!--\n<div class="item-footer">\n    <div class="text-center">\n        <dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="levelOfCare"\n                                 [max-size="5" ]\n                                 [direction-links="true" ]\n                                 [boundary-links="true" ]>\n        </dir-pagination-controls>\n    </div>\n</div>\n-->');
$templateCache.put('app/dashboard2/layout/marketers/marketers-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big green"><i class="fa fa-address-book" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Outreach</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Outreach</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr dir-paginate="item in vm.countChartsMarketers|itemsPerPage:4 " pagination-id="marketer" ng-click="vm.openCharts(item.employee)" )><td><span>{{item.employee.lastName+", "+item.employee.firstName}}</span></td><td align="right"><span>{{item.count}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.count > 0"><div class="link"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="marketer" max-size="5" direction-links="true" boundary-links="true"></dir-pagination-controls></div></div>');
$templateCache.put('app/dashboard2/layout/mars-mors/mars-mors-box.html','<!-- Jesus Code --><div class="jr-card-body"><div class="layout-full mb-30"><div class="big-btns btn-group btn-group-lg" role="group"><button type="button" class="btn btn-warning" ng-click="vm.openAsNeededModal()" uib-tooltip="Create"><i class="fa fa-plus" aria-hidden="true"></i></button></div><div class="search-group collapsed" ng-class="isExpanded?\'expanded\':\'\'"><button type="button" class="btn btn-lg btn-success" ng-click="isExpanded = !isExpanded"><i class="fa fa-search" aria-hidden="true" ng-class="isExpanded?\'fa-search-minus\':\'fa-search-plus\'"></i></button> <input type="text" placeholder="Search query..." ng-model="search" ng-change="vm.searchByQuery()"></div><div class="jr-numbers"><span class="jr-counter">{{vm.totalItems?vm.totalItems:\'0\'}}</span><p class="jr-card-label">Current Medications</p></div></div><div class="table-responsive m-row-fix"><table class="table table-hover"><thead class="jr-thead"><tr><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Schedule</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">P. Name</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Date of Birth</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Medication</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Specifics</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;">Status</th><th style="border-top: 2px solid #E8ECEF; border-bottom: 2px solid #E8ECEF;"></th></tr></thead><tbody><tr dir-paginate="item in vm.takes|filter:search|itemsPerPage:12"><td>{{item.scheduleDate | amDateFormat:amDateFormat}}</td><td>{{item.firstName}} {{item.lastName}}</td><td>{{item.dob | date: \'MM-dd-yyyy\'}}</td><td>{{item.medicationName}}</td><td>{{item.dose}} x {{item.strength}} - {{item.routeName}}</td><td>{{item.medicationTakeStatus}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link green" ng-click="vm.administer(item.takeId)"><i class="fa fa-check" aria-hidden="true"></i> Administer</a></li><li role="menuitem"><a href="" class="dd-link blue" ng-click="vm.observe(item.takeId)"><i class="fa fa-eye" aria-hidden="true"></i> Observe</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.miss(item.takeId, item.chartId)"><i class="fa fa-trash-o" aria-hidden="true"></i> Miss</a></li><li role="menuitem" ng-if="item.medicationTakeStatus == \'HOLD\'"><a href="" class="dd-link orange" ng-click="vm.hold(item.takeId)"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Hold</a></li></ul></div></td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.takes > 0"><div class="link"><dir-pagination-controls class="dash-pagination pagination-sm" previous-text="&#xf0a8;" next-text="&#xf0a9;" [max-size="5" ] [direction-links="true" ] [boundary-links="true" ]></dir-pagination-controls></div></div>');
$templateCache.put('app/dashboard2/layout/partial-results/partial-results-top-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big aqua"><i class="fa fa-file-archive-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.partial.value?vm.partial.value:\'0\'}}</span><p class="jr-card-label">Partials Results</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="partial-result">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/payer-mix/payer-mix-box.html','<!-- Jesus Code --><div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big yellow"><i class="fa fa-dollar" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Payer Mix</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Payer</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr dir-paginate="item in vm.payers|itemsPerPage:4" pagination-id="payer" ng-click="vm.openCharts(item)" )><td><span>{{vm.payerAdjust(item.name)}}</span></td><td align="right"><span>{{item.count}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer" ng-if="vm.count > 0"><div class="link"><div class="text-center"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="payer" max-size="5" direction-links="true" boundary-links="true"></dir-pagination-controls></div></div></div>');
$templateCache.put('app/dashboard2/layout/pending-by-patient/pending-by-patient-box.html','<!-- Jesus Code --><div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big red"><i class="fa fa-file-text-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count}}</span><p class="jr-card-label">Pending Care & Delivery by Patient</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="pending-by-patient">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/pending-by-staff/pending-by-staff-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big yellow"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Pending Care & Delivery by Staff</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="pending-by-staff">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/pending-by-staff-review/pending-by-staff-review-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big green"><i class="fa fa-check-square-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Care & Delivery Pending Review</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="pending-by-staff-review">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/pending-requisition/pending-requisition-top-box.html','<header class="item-header"><div class="fancy-icon green small"><i class="fa fa-flask" aria-hidden="true"></i></div><h2 class="head-text small">Pending Requisition</h2></header><div class="item-body vertical-flow"><div class="empty-content"><div class="text"><span>Maintenance</span></div></div></div><div class="item-footer"><a href="" class="db-link">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div>');
$templateCache.put('app/dashboard2/layout/physician-review/physician-review-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big red"><i class="fa fa-stethoscope" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">0</span><p class="jr-card-label">Physician Review</p></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="jr-progress-container"><span class="jr-progress-badge expired">Medication Orders</span><div class="progress jr"><div class="progress-bar expired" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width:60%"><span class="jr-progress-value expired">60%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge forty-eight">Laboratory Orders</span><div class="progress jr"><div class="progress-bar forty-eight" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width:20%"><span class="jr-progress-value forty-eight">30%</span></div></div></div><div class="jr-progress-container"><span class="jr-progress-badge hundred-twenty">Laboratory Results</span><div class="progress jr"><div class="progress-bar hundred-twenty" role="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" style="width:10%"><span class="jr-progress-value hundred-twenty">10%</span></div></div></div></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="#">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/dashboard2/layout/print-requisition/print-requisition-box.html','<!-- Jesus Code --><div class="jr-card-body"><div class="layout-full mb-30"><div class="big-btns btn-group btn-group-lg" role="group" uib-dropdown><button type="button" class="btn btn-primary" ng-click="vm.create()" uib-tooltip="Create"><i class="fa fa-plus" aria-hidden="true"></i></button> <button id="split-button" type="button" class="btn btn-success" ng-click="vm.printLabels()"><i class="fa fa-print" aria-hidden="true"></i></button> <button type="button" class="btn btn-success" uib-dropdown-toggle style="border-radius: 0"><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" aria-labelledby="split-button"><li role="menuitem"><a ng-click="vm.printDYMOLabels()"><i class="fa fa-print" aria-hidden="true"></i> Print in DYMO Printer</a></li></ul><button type="button" class="btn btn-warning" ng-click="vm.manifest()" uib-tooltip="Manifest"><i class="fa fa-truck" aria-hidden="true"></i></button></div><div class="search-group collapsed" ng-class="isExpanded?\'expanded\':\'\'"><button type="button" class="btn btn-lg btn-danger" ng-click="isExpanded = !isExpanded"><i class="fa fa-search" aria-hidden="true" ng-class="isExpanded?\'fa-search-minus\':\'fa-search-plus\'"></i></button> <input type="text" placeholder="Search query..." ng-model="vm.filter.searchQuery" ng-change="vm.searchByQuery()"></div><div class="date-info"><div class="date"><span class="jumbo-date" name="selectedDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.date" ng-change="vm.dtInstance.reloadData()" is-open="vm.datePickerOpenStatus.selectedDate" datepicker-options="">{{vm.date | date: \'MM-dd-yyyy\'}} </span><span class="small">Selected Date</span></div><button type="button" class="btn btn-lg btn-primary" ng-click="vm.openCalendar(\'selectedDate\')"><i class="fa fa-calendar-check-o" aria-hidden="true"></i></button></div></div><div class="table-responsive m-row-fix"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div><div class="jr-card-footer" ng-if="vm.labRequisitions.length > 0"><div class="link"><dir-pagination-controls class="dash-pagination pagination-sm" previous-text="&#xf0a8;" next-text="&#xf0a9;" [max-size="5" ] [direction-links="true" ] [boundary-links="true" ]></dir-pagination-controls></div></div>');
$templateCache.put('app/dashboard2/layout/referral-source/referral-source-box.html','<div class="jr-card-body"><div class="layout-minimal mb-30"><div class="jr-icon-big yellow"><i class="fa fa-building-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count ? vm.count : \'0\'}}</span><p class="jr-card-label">Referral Source</p></div></div><div class="table-responsive"><table class="table table-hover"><thead><tr><th scope="col">Referral Source</th><th scope="col" style="text-align: right">Total</th></tr></thead><tbody><tr dir-paginate="item in vm.countReferrers |itemsPerPage:4 track by $index" pagination-id="referrer" ng-click="vm.openCharts(item.name)" )><td><span>{{item.name}}</span></td><td align="right"><span>{{item.count}}</span></td></tr></tbody></table></div></div><div class="jr-card-footer"><div class="text-center"><dir-pagination-controls class="dash-pagination pagination-sm" pagination-id="referrer" max-size="5" direction-links="true" boundary-links="true"></dir-pagination-controls></div></div>');
$templateCache.put('app/dashboard2/layout/stay/stay-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big green"><i class="fa fa-clock-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.count?vm.count:\'0\'}}</span><p class="jr-card-label">Average Length of Stay</p></div></div></div>');
$templateCache.put('app/dashboard2/layout/unassigned-results/unassigned-results-top-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big green"><i class="fa fa-question-circle-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.unassigned.value?vm.unassigned.value:\'0\'}}</span><p class="jr-card-label">Unassigned Results</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="unassigned-results">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/abnormal-alert/list/abnormal-alert.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/abnormal-alert/update/abnormal-alert-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAbnormalAlertLabel">Create or edit a Abnormal Alert</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendiums.length > 0 ?\'has-success\':\'has-error\'"><label>Lab Compendium:</label><ui-select name="testCode" id="testCode" required ng-disabled="vm.abnormalAlert.laboratory == null" multiple="multiple" ng-model="vm.labCompendiums " reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Test Codes...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.testCodes | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.code | highlight: $select.search"></div><small ng-bind-html="item.description | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendiums.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendiums.length > 0"></span> <span class="help-block" ng-show="!vm.labCompendiums.length > 0">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/acuity/list/acuity.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/acuity/update/acuity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Create or edit a Acuity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.acuity.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.acuity.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.acuity.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.acuity.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.acuity.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.acuity.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.acuity.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/admission-medication/detail/admission-medication-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Admission Medication Detail - {{vm.admissionMedication.medication.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td colspan="3"><label>Medication:</label><p>{{vm.admissionMedication.medication.name}}</p></td><td><label>Last Dose:</label><p>{{vm.admissionMedication.lastDate | date: inputDateTimeFormatA}}</p></td></tr><tr><td><label>Route:</label><p>{{vm.admissionMedication.route.name}}</p></td><td><label>Dosage Form:</label><p>{{vm.admissionMedication.doseForm.name}}</p></td><td><label>Amount:</label><p>{{vm.admissionMedication.amount ? vm.admissionMedication.amount : "-"}}</p></td><td><label>Duration in Days:</label><p>{{vm.admissionMedication.durationDays}}</p></td></tr><tr><td colspan="4"><label>Rationale:</label><p>{{vm.rationaleStr ? vm.rationaleStr : "-"}}</p></td></tr><tr><td colspan="4"><label>Instructions:</label><p>{{vm.admissionMedication.instruction ? vm.admissionMedication.instruction : "-"}}</p></td></tr></tbody></table></div><div class="table-responsive" ng-show="vm.frequencies.length > 0"><table class="table table-condensed"><thead><tr><th><strong>Frequencies</strong></th></tr></thead><tbody><tr ng-repeat="($index, frequency) in vm.frequencies"><td><div class="well well-sm mb-0"><table class="table table-condensed mb-0" style="background: transparent"><tbody><tr><td style="width: 190px" colspan="3"><label ng-if="vm.admissionMedication.type == \'TAPER\'">Day {{$index + 1}} -</label> <label ng-if="vm.admissionMedication.type != \'TAPER\'">Frequency:</label> {{frequency.frequency.description}}</td></tr><tr ng-repeat="schedule in frequency.schedules"><td style="width: 190px" ng-if="!frequency.hideDay"><label>At:</label><p>{{schedule.date | date:timeFormatA}}</p></td><td colspan="{{!frequency.hideDay ? 2 : 0}}"><label>Strength:</label><p>{{schedule.strength}}</p></td><td style="width: 60px"><label>Quantity:</label><p>{{schedule.quantity}}</p></td></tr></tbody></table></div></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.admissionMedication.verified"><table class="table table-condensed"><tbody><tr><td><label>Verified by:</label><p></p><p>{{vm.admissionMedication.verify.lastName + ", " + vm.admissionMedication.verify.firstName}}</p><p></p></td><td style="text-align: right"><label>Verified Date:</label><p>{{vm.admissionMedication.verifiedDate | date: inputDateTimeFormatA}}</p></td></tr></tbody></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.admissionMedication.signature"><div class="well well-sm signs-array"><div class="sign-item mb-15"><figure><img ng-src-sign="{{vm.admissionMedication.signatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Employee: {{vm.admissionMedication.verify.lastName + ", " + vm.admissionMedication.verify.firstName}},<br>Date: {{vm.admissionMedication.signature.createdDate | date: inputDateTimeFormatA}}</figcaption></figure></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/admission-medication/list/admission-medication.html','<section class="content no-padding"><div class="content-heading"><a ui-sref="chart({id: vm.chart.id, processId: vm.params.processId, tabId: vm.TAB.MEDICATIONS})" class="btn-back-link" style="margin-right: auto"><i class="fa fa-arrow-left" aria-hidden="true"></i>Back to patient\'s chart</a><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></div><div class="content-grid"><div class="content-side" resizable r-directions="[\'right\']" r-flex="true"><udt-chart-header chart="vm.chart" show-allergies="true" sidebar-layout="true"></udt-chart-header></div><div class="content-area"><div class="grid-flex"><div class="grid-item full"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th style="width: 40px"><input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)"></th><th><strong>Name</strong></th><th><strong>Amount</strong></th><th><strong>Logged By</strong></th><th><strong>Verify By</strong></th><th><strong>Verify Date</strong></th><th><strong>Signed</strong></th><th><strong>Action Taken</strong></th><th><strong>Witness</strong></th><th style="width: 40px"></th></tr></thead><tbody><tr ng-repeat="value in vm.admissionMedications"><td><label><input ng-if="!value.verified || !value.signed" type="checkbox" ng-model="vm.selected[value.id]" ng-click="vm.toggleOne(vm.selected, vm.selectAll)"></label></td><td>{{value.medicationName}}</td><td>{{value.amount}}</td><td>{{value.loggedFullName}}</td><td>{{value.verifyFullName}}</td><td>{{value.verifiedDate | date: inputDateFormat}}</td><td>{{value.signed ? "YES" : "NO"}}</td><td>{{value.admissionMedicationAction}}</td><td>{{value.witnessFullName}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="!value.verified && !value.signed"><a href="" title="Edit" class="dd-link orange" ng-click="vm.openModalEditMedication(value.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" title="View" class="dd-link blue" ng-click="vm.view(value.id)"><i class="fa fa-eye" aria-hidden="true"></i> View</a></li><li role="menuitem" ng-if="!value.verified"><a href="" title="Verify" class="dd-link blue" ng-click="vm.openModalVerify(value.id)"><i class="fa fa-check-circle" aria-hidden="true"></i> Verify</a></li><li role="menuitem" ng-if="value.verified && !value.signed"><a href="" title="Sign" class="dd-link green" ng-click="vm.sign(value.id)"><i class="fa fa-pencil-square" aria-hidden="true"></i> Sign</a></li><li role="menuitem" ng-if="!value.verified && !value.signed"><a href="" title="Delete" class="dd-link red" ng-click="vm.del(value.id)"><i class="fa fa-ban" aria-hidden="true"></i> Delete</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="buttons-toolbar btn-group"><button class="btn btn-default" ng-click="vm.openModalAddMedication()"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add Medication</button> <button type="button" class="btn btn-default" ng-click="vm.openModalVerify()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-check-circle" aria-hidden="true" style="color: #f39c12"></i> Verify Multiple</button> <button type="button" class="btn btn-default" ng-click="vm.sign()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-pencil-square" aria-hidden="true" style="color: #00a7d0"></i> Sign Multiple</button></div></div></div></section>');
$templateCache.put('app/entities/admission-medication/update/admission-medication-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Add Admission Medication</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="orders-list"><div class="order-item"><header class="order-header mb-15"><h4 class="order-name"><button type="button" class="btn btn-default btn-sm" ng-click="vm.admissionMedication.collapsed = !vm.admissionMedication.collapsed"><i class="fa" aria-hidden="true" ng-class="vm.admissionMedication.collapsed?\'fa-chevron-right\':\'fa-chevron-down\'"></i></button> - <span>{{vm.admissionMedication.medication.name}}</span></h4><div class="alert-text" ng-if="vm.admissionMedication.medication != null && vm.matches[vm.admissionMedication.medication.id] == true"><span class="text">Possible Medication Match</span></div></header><div class="order-content well well-sm" uib-collapse="vm.admissionMedication.collapsed"><fieldset><div class="col-xs-12 col-sm-12 col-md-8 col-lg-8"><div class="form-group has-feedback" ng-class="editForm.medication.$invalid ? \'has-error\' : (editForm.medication.$touched || editForm.medication.$dirty ? \'has-success\' : \'\')"><label for="selectMedications">Medications:</label><ui-select name="medication" id="selectMedications" ng-model="vm.admissionMedication.medication" required reset-search-input="true" title="All Medications" close-on-select="true"><ui-select-match placeholder="Select medications ..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="medication in vm.medications | filter: $select.search" refresh="vm.getMedications($select.search)" refresh-delay="0"><div ng-bind-html="medication.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.medication.$error.required"></span> <span class="help-block" ng-show="editForm.medication.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.admissionMedication.lastDate == null ? \'has-error\' : \'has-success\'"><label for="lastDose">Last Dose:</label> <input type="datetime-local" id="lastDose" name="field_lastDose" class="form-control" required ng-model="vm.admissionMedication.lastDate"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.admissionMedication.lastDate == null"></span> <span class="help-block" ng-show="vm.admissionMedication.lastDate == null">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.route.$invalid ? \'has-error\' : (editForm.route.$touched || editForm.route.$dirty ? \'has-success\' : \'\')"><label for="field_route">Route:</label><ui-select ng-model="vm.admissionMedication.route" name="route" id="field_route" reset-search-input="true" title="Select route for medication" close-on-select="true" required><ui-select-match placeholder="Select route ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="route in vm.routes | filter: $select.search"><div ng-bind-html="route.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.route.$error.required"></span> <span class="help-block" ng-show="editForm.route.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.dose_form.$invalid ? \'has-error\' : (editForm.dose_form.$touched || editForm.dose_form.$dirty ? \'has-success\' : \'\')"><label for="field_dose_form">Dosages Forms:</label><ui-select ng-model="vm.admissionMedication.doseForm" name="dose_form" id="field_dose_form" reset-search-input="true" title="Select dosages form for current medication" close-on-select="true" required><ui-select-match placeholder="Select dosages form ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="doseForm in vm.doseForms | filter: $select.search"><div ng-bind-html="doseForm.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.dose_form.$error.required"></span> <span class="help-block" ng-show="editForm.dose_form.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="rxNumber">Rx Numbers:</label> <input type="text" id="rxNumber" class="form-control" name="rxNumber" ng-model="vm.admissionMedication.rxNumber"></div></div><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group has-feedback" ng-class="editForm.relational.$invalid ? \'has-error\' : (editForm.relational.$touched || editForm.relational.$dirty ? \'has-success\' : \'\')"><label for="field_relational">Rationale:</label><ui-select ng-model="vm.admissionMedication.relationals" name="relational" id="field_relational" title="Rationale" required close-on-select="false" multiple="multiple"><ui-select-match placeholder="Select rationale...">{{$item.name}}</ui-select-match><ui-select-choices repeat="relational in vm.relationals | filter: $select.search"><div ng-bind-html="relational.name  | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.relational.$error.required"></span> <span class="help-block" ng-show="editForm.relational.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback"><label for="field_duration_days">Remaining Duration in Days:</label> <input type="number" id="field_duration_days" class="form-control" min="0" name="duration_days" ng-model="vm.admissionMedication.durationDays"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="editForm.expirationDate == null || editForm.expirationDate.length == 0 ? \'has-error\' : \'has-success\'"><label for="field_expirationDate">Expiration Date:</label><div class="input-group input-group-sm"><input id="field_expirationDate" type="text" class="form-control" name="expirationDate" uib-datepicker-popup="{{inputDateFormat}}" required ng-model="vm.admissionMedication.expirationDate" is-open="vm.datePickerOpenStatus.expirationDate" datepicker-options="vm.currentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expirationDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.expirationDate.$error.required"></span> <span class="help-block" ng-show="editForm.expirationDate.$error.required">This field is required</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="originalPrescriber">Original Prescriber:</label> <input type="text" id="originalPrescriber" class="form-control" name="originalPrescriber" ng-model="vm.admissionMedication.originalPrescriber"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="asNeeded">As Needed:</label><br><toggle id="asNeeded" ng-model="vm.admissionMedication.asNeeded" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="form-group"><label for="instructionsText">Instructions:</label> <textarea class="form-control" id="instructionsText" rows="4" data-resize="disabled" name="instructions" ng-model="vm.admissionMedication.instructions"></textarea></div></div></fieldset><fieldset><hr><div ng-repeat="($index, frequency) in vm.admissionMedication.admissionFrequencies" class="frequency-day"><header><h4 class="day-number"><strong>Frecuency:</strong></h4><div class="select-frequency" ng-class="frequency.frequency == null ? \'has-error\' : \'has-success\'"><select class="form-control has-feedback" ng-model="frequency.frequency" id="field_frequency_{{$index}}" name="frequency_{{$index}}" required ng-change="vm.changeFrequency(frequency)" ng-options="frequency as frequency.description for frequency in vm.frequencies track by frequency.id"></select></div></header><div class="schedule-times table-responsive" ng-if="frequency.schedules != null && frequency.schedules.length > 0" uib-collapse="frequency.isCollapsed"><table class="table table-condensed"><thead><tr><th ng-if="!frequency.hideDay"></th><th ng-if="!frequency.hideDay"><strong>At:</strong></th><th><strong>Strength:</strong></th><th><strong>Quantity:</strong></th></tr></thead><tbody><tr ng-repeat="($index, schedule) in frequency.schedules"><td style="width: 25px" ng-if="!frequency.hideDay"><span class="index">{{schedule.xorder}}</span></td><td style="width: 80px" ng-if="!frequency.hideDay"><div class="form-group mb-0" ng-class="schedule.date == null ? \'has-error\' : \'has-success\'"><input name="date{{$parent.$index}}{{$index}}" required type="time" class="time-control" ng-model="schedule.date"></div></td><td><div class="form-group mb-0" ng-class="vm.scheduleStrength == null || vm.scheduleStrength.length == 0 ? \'has-error\' : \'has-success\'"><input name="strength{{$parent.$index}}{{$index}}" required type="text" class="form-control input-sm" ng-model="vm.scheduleStrength"></div></td><td style="width: 100px"><div class="form-group mb-0" ng-class="schedule.quantity?(vm.form.schedule.quantity.$valid && vm.form.schedule.quantity.$dirty?\'has-success\':\'\'):\'has-error\'"><input name="quantity{{$parent.$index}}{{$index}}" type="number" class="form-control input-sm" required ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="schedule.quantity"></div></td></tr></tbody></table></div><hr><div class="amount-brought"><h4>Amount brought in:</h4><table class="table-responsive"><table class="table table-condensed"><thead><tr><th style="width: 90px"><strong>Amount</strong></th><th><strong></strong></th></tr></thead><tbody><tr><td><input type="number" min="0" class="form-control input-sm" ng-model="vm.admissionMedication.amount"></td><td><p class="mb-0">{{vm.scheduleStrength}}</p></td></tr></tbody></table></table></div><hr><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="editForm.actionsTaken.$invalid ? \'has-error\' : (editForm.actionsTaken.$touched || editForm.actionsTaken.$dirty ? \'has-success\' : \'\')"><label for="field_actionsTaken">Actions taken:</label> <select class="form-control" id="field_actionsTaken" name="actionsTaken" required ng-model="vm.admissionMedication.admissionMedicationAction" ng-options="item as item for item in vm.admissionMedicationActions track by item"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.actionsTaken.$error.required"></span> <span class="help-block" ng-show="editForm.actionsTaken.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="witnessBy">Witness:</label><ui-select id="witnessBy" name="witnessBy" reset-search-input="true" ng-model="vm.admissionMedication.witness" close-on-select="true" ng-model-options="{ debounce: 500 }"><ui-select-match>{{$select.selected.firstName + \' \' + $select.selected.lastName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | filter:$select.search" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></fieldset></div></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/alcohol/history/alcohol.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Alcohol - History</h4></div><div class="modal-body"><div class="table-wrapper"><table class="table table-bordered fixed-header" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/alcohol/update/alcohol-dialog.html','<form name="vm.form.alcohol" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAlcoholLabel">Create or edit a Alcohol</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.alcohol.date || vm.form.alcohol.date.$invalid?\'has-error\':(vm.alcohol.date && vm.form.alcohol.date.$dirty?\'has-success\':\'\')"><label for="field_date">Date:</label><div class="input-group input-group-sm"><input id="field_date" type="text" class="form-control" name="date" required ng-model="vm.alcohol.date" datetime-picker="{{inputDateTimeFormatA}}" datepicker-options="dateOptions" is-open="vm.datePickerOpenStatus.date" validator="required" message-id="msg-alcohol-date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.alcohol.date || vm.form.alcohol.date.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.alcohol.date && vm.form.alcohol.date.$dirty"></span> <span class="help-block" ng-show="!vm.alcohol.date || vm.form.alcohol.date.$invalid">This field is required</span></div><div id="msg-alcohol-date"></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.alcohol.value != null ? (vm.form.alcohol.value.$valid && vm.form.alcohol.value.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_value">Value</label> <input type="number" class="form-control" name="value" min="0" id="field_value" ng-pattern="/^[0-9]+(\\.[0-9]*)?$/" step="0.01" ng-model="vm.alcohol.value" required> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="vm.form.alcohol.value.$error"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.alcohol.value.$valid"></span> <span class="help-block" ng-show="vm.form.alcohol.value.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.alcohol.value.$error.min">This field is invalid</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.alcohol.description?(vm.form.alcohol.description.$valid && vm.form.alcohol.description.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_description">Notes</label> <textarea class="form-control" name="description" id="field_description" data-resize="disabled" rows="4" ng-model="vm.alcohol.description"></textarea> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.alcohol.description"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.alcohol.description && vm.form.alcohol.description.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.alcohol.description">This field is Suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.alcohol.$error.required || vm.isSaving || vm.from.alcohol.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/allergen/list/allergen.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/allergen/update/allergen-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergenLabel">Create or edit a Allergen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.allergen.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.allergen.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.allergen.name?(editForm.name?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.allergen.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.allergen.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.allergen.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.allergen.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/allergies/history/allergies-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Allergies History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Allergy</strong></th><th><strong>Allergen</strong></th><th><strong>Severity</strong></th></tr></thead><tbody><tr ng-repeat="allergy in vm.allergies"><td>{{allergy.name}}</td><td>{{allergy.allergen.name}}</td><td>{{allergy.severity.name}}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/allergies/update/allergies-dialog.html','<form name="vm.form.allergy" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Create/Edit an Allergy</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="help-block help-warning">WARNING: For Drug Allergies, please refer to the allergies located in RCOPIA.</div><hr ng-if="vm.allergies.id"><div class="row" ng-if="vm.allergies.id"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="field_name">Allergy:</label> <input type="text" class="form-control" name="allergyName" id="field_allergies_name" ng-model="vm.allergies.name" required ng-disabled="vm.allergies.id"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if=""><div class="form-group form-group-sm has-feedback"><label for="field_name">Allergen:</label> <input type="text" class="form-control" name="allergyName" id="field_allergen_name" ng-model="vm.allergies.allergies.name" required ng-disabled="vm.allergies.id"></div></div></div><hr ng-if="vm.allergies.id"><hr ng-if="!vm.allergies.id && ((!vm.allergies.rcopiaAllergyGroup && !vm.allergies.name) || vm.allergies.rcopiaAllergyGroup)"><div ng-if="!vm.allergies.id" class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="!vm.allergies.id && ((!vm.allergies.rcopiaAllergyGroup && !vm.allergies.name) || vm.allergies.rcopiaAllergyGroup)"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.rcopiaAllergyGroup?(vm.form.allergy.rcopiaAllergyGroup.$valid && vm.form.allergy.rcopiaAllergyGroup.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_rcopiaAllergyGroup">Allergy Group (Rcopia):</label><ui-select id="field_rcopiaAllergyGroup" name="rcopiaAllergyGroup" reset-search-input="true" ng-model="vm.allergies.rcopiaAllergyGroup" title="Allergy Group" ng-model-options="{ debounce: 100 }" close-on-select="true" required ng-disabled="vm.allergies.id"><ui-select-match allow-clear="true" placeholder="Allergen">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="rcopiaAllergyGroups in vm.rcopiaAllergyGroups" refresh="vm.getRcopiaAllergyGroups($select.search)" refresh-delay="0"><div ng-bind-html="rcopiaAllergyGroups.name"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.rcopiaAllergyGroup.$error.required || vm.form.allergy.rcopiaAllergyGroup.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.rcopiaAllergyGroup.$dirty && vm.form.allergy.rcopiaAllergyGroup.$valid"></span> <span class="help-block" ng-show="vm.form.allergy.rcopiaAllergyGroup.$error.required || vm.form.allergy.rcopiaAllergyGroup.$invalid">This field is required</span></div></div></div><hr ng-if="!vm.allergies.id"><div class="row" ng-if="!vm.allergies.id && ((!vm.allergies.rcopiaAllergyGroup && !vm.allergies.name) || vm.allergies.name)"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.name || !vm.form.allergy.allergyName.$invalid?(vm.form.allergy.allergyName.$dirty && vm.form.allergy.allergyName.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Allergy (Free Text):</label> <input type="text" class="form-control" name="allergyName" id="field_name" ng-model="vm.allergies.name" required ng-disabled="vm.allergies.id"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.allergyName.$error.required || vm.form.allergy.allergyName.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.allergyName.$dirty && vm.form.allergy.allergyName.$valid"></span> <span class="help-block" ng-show="vm.form.allergy.allergyName.$error.required || vm.form.allergy.allergyName.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.allergen?(vm.form.allergy.allergen.$valid && vm.form.allergy.allergen.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_allergen">Allergen:</label> <select class="form-control" id="field_allergen" name="allergen" required ng-model="vm.allergies.allergen" ng-options="item as item.name for item in vm.allergen track by item.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.allergen.$error.required || vm.form.allergy.allergen.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.allergen.$dirty && vm.form.allergy.allergen.$valid"></span> <span class="help-block" ng-show="vm.form.allergy.allergen.$error.required || vm.form.allergy.allergen.$invalid">This field is required</span></div></div></div><hr ng-if="!vm.allergies.id && ((!vm.allergies.rcopiaAllergyGroup && !vm.allergies.name) || vm.allergies.name)"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.severity?(vm.form.allergy.severity.$valid && vm.form.allergy.severity.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_severity">Severity:</label> <select class="form-control" id="field_severity" name="severity" ng-required="vm.allergies.id" ng-model="vm.allergies.severity" ng-options="item as item.name for item in vm.severities track by item.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.severity.$error.required || vm.form.allergy.severity.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.severity.$dirty && vm.form.allergy.severity.$valid"></span> <span class="help-block" ng-show="vm.form.allergy.severity.$error.required || vm.form.allergy.severity.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.allergies.id"><div class="form-group form-group-sm"><label class="control-label" for="field_active">Active</label><toggle id="field_active" style="display: block;" ng-model="vm.allergies.active" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" ng-disabled="vm.chart.status == \'CLOSED\'" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.onset?(vm.form.allergy.onset.$valid && vm.form.allergy.onset.$dirty?\'has-success\':\'\'):(vm.allergies.reactionDate?\'\':\'has-warning\')"><label class="control-label" for="field_onset">Onset:</label><br><select class="form-control" id="field_onset" name="onset" ng-model="vm.allergies.onset" ng-options="item as item for item in vm.onset track by item" ng-disabled="vm.allergies.reactionDate"><option value=""></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.allergies.onset && !vm.allergies.reactionDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.allergies.onset && vm.form.allergy.onset.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.allergies.onset && !vm.allergies.reactionDate">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.reactionDate?(vm.form.allergy.reactionDate.$valid && vm.form.allergy.reactionDate.$dirty?\'has-success\':\'\'):(vm.allergies.onset?\'\':\'has-warning\')"><label for="field_reaction_date">Reaction Date:</label><div class="input-group input-group-sm"><input id="field_reaction_date" type="text" class="form-control" name="reactionDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.allergies.reactionDate" is-open="vm.datePickerOpenStatus.reactionDate" ng-disabled="vm.allergies.onset" datepicker-options="vm.currentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reactionDate\')" ng-disabled="vm.allergies.onset != null"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.allergies.reactionDate && !vm.allergies.onset"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.allergies.reactionDate && vm.form.allergy.reactionDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.allergies.reactionDate && !vm.allergies.onset">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.allergies.reactions && vm.allergies.reactions.length>0?\'has-success\':\'has-error\'"><label for="field_reaction">Reactions</label><ui-select name="reaction" id="field_reaction" title="Select reaction" multiple="multiple" required ng-model="vm.allergies.reactions" reset-search-input="true" required close-on-select="false"><ui-select-match placeholder="Reactions ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.reaction | filter: $select.search">{{item.name}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.allergies.reactions || vm.allergies.reactions.length == 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.allergy.reaction.$dirty && vm.form.allergy.reaction.$valid"></span> <span class="help-block" ng-show="!vm.allergies.reactions || vm.allergies.reactions.length == 0">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.allergies.note?(vm.form.allergy.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="note">Note</label> <textarea id="note" class="form-control" rows="5" name="notes" data-resize="disabled" ng-model="vm.allergies.note"></textarea> <span class="help-block help-warning" ng-show="!vm.allergies.note">This field is suggested</span></div></div></div></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.allergies.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" class="btn btn-success" ng-disabled="vm.chart.status === \'CLOSED\' || vm.form.allergy.$error.required || vm.from.allergy.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Allergy from this patient\'s record. Are you sure you want to <strong>delete</strong> this Allergy?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/appointments/tabs/appointment-blocktime-tab.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentProvider">Provider:</label> <select name="appointmentProvider" id="appointmentProvider" class="form-control input-sm"><option value="01">Provider Name 01</option><option value="02">Provider Name 02</option><option value="03">Provider Name 03</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentReason">Reason:</label> <select name="appointmentReason" id="appointmentReason" class="form-control input-sm"><option value="01">Reason Name 01</option><option value="02">Reason Name 02</option><option value="03">Reason Name 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentStart">Start:</label> <input type="datetime-local" class="form-control input-sm" id="appointmentStart"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentEnd">End:</label> <input type="date" class="form-control input-sm" id="appointmentEnd"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="appointmentDescription">Description:</label> <textarea name="appointmentDescription" id="appointmentDescription" rows="4" class="form-control" data-resize="disabled" placeholder="Add a description here..."></textarea></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Recurrences:</label><br><div class="btn-group"><label class="btn btn-default" ng-class="radioModel === \'daily\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'daily\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'daily\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Daily</label> <label class="btn btn-default" ng-class="radioModel === \'weekly\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'weekly\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'weekly\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Weekly</label> <label class="btn" ng-class="radioModel === \'monthly\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'monthly\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'monthly\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Monthly</label> <label class="btn" ng-class="radioModel === \'custom\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'custom\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'custom\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Custom</label></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row recurrence-daily" ng-if="radioModel === \'daily\'"><div class="col-xs-6 col-sm-4 col-md-3 col-lg-3"><div class="form-group"><label for="recurrenceStart">Start Time:</label> <input type="time" id="recurrenceStart" class="form-control"></div></div><div class="col-xs-6 col-sm-4 col-md-3 col-lg-3"><div class="form-group"><label for="recurrenceEnd">End Time:</label> <input type="time" id="recurrenceEnd" class="form-control"></div></div></div><!-- /.row --><div class="row recurrence-weekly" ng-if="radioModel ===\'weekly\'"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label>Choose week days:</label><br><div class="btn-group"><label class="btn" ng-class="week.monday?\'btn-info\':\'btn-default\'" ng-model="week.monday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.monday?\'fa-check-square-o\':\'fa-square-o\'"></i> Monday</label> <label class="btn" ng-class="week.tuesday?\'btn-info\':\'btn-default\'" ng-model="week.tuesday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.tuesday?\'fa-check-square-o\':\'fa-square-o\'"></i> Tuesday</label> <label class="btn" ng-class="week.wednesday?\'btn-info\':\'btn-default\'" ng-model="week.wednesday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.wednesday?\'fa-check-square-o\':\'fa-square-o\'"></i> Wednesday</label> <label class="btn" ng-class="week.thursday?\'btn-info\':\'btn-default\'" ng-model="week.thursday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.thursday?\'fa-check-square-o\':\'fa-square-o\'"></i> Thursday</label> <label class="btn" ng-class="week.friday?\'btn-info\':\'btn-default\'" ng-model="week.friday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.friday?\'fa-check-square-o\':\'fa-square-o\'"></i> Friday</label> <label class="btn" ng-class="week.saturday?\'btn-info\':\'btn-default\'" ng-model="week.saturday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.saturday?\'fa-check-square-o\':\'fa-square-o\'"></i> Saturday</label> <label class="btn" ng-class="week.sunday?\'btn-info\':\'btn-default\'" ng-model="week.sunday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.sunday?\'fa-check-square-o\':\'fa-square-o\'"></i> Sunday</label></div></div></div></div><!-- /.row --><div class="row" ng-if="radioModel === \'monthly\'"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label>Choose a date: <strong>{{vm.recurrence.monthly | date:\'fullDate\'}}</strong></label><div class="static-datepicker" uib-datepicker datepicker-options="vm.calendarOpts" ng-model="vm.recurrence.monthly"></div></div></div></div><!-- /.row --><div class="row" ng-if="radioModel === \'custom\'"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Choose dates:</label><div class="static-datepicker" uib-datepicker datepicker-options="vm.calendarOptsCustom" ng-model="vm.datePicked"></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Date selected:</label><div class="input-group"><input type="text" class="form-control" id="inputDateSelected" value="{{vm.datePicked | date:\'fullDate\'}}" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-success" ng-click="vm.addCustomDate(vm.datePicked)"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></span></div></div><div class="form-group recurrences-list"><label>Dates List:</label><ul class="list-unstyled"><li role="listitem" ng-repeat="date in vm.customRecurrences"><span>{{date | date:\'fullDate\'}}</span> <a ng-click="vm.deleteCustomDate($index)"><i class="fa fa-times" aria-hidden="true"></i></a></li></ul></div></div></div><!-- /.row --></div></div>');
$templateCache.put('app/entities/appointments/tabs/appointment-patient-tab.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="appointmentPatient">Patient:</label> <select name="appointmentPatient" id="appointmentPatient" class="form-control input-sm"><option value="01">Patient Name 01</option><option value="02">Patient Name 02</option><option value="03">Patient Name 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentProvider">Provider:</label> <select name="appointmentProvider" id="appointmentProvider" class="form-control input-sm"><option value="01">Provider Name 01</option><option value="02">Provider Name 02</option><option value="03">Provider Name 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentType">Appointment Type:</label> <select name="appointmentType" id="appointmentType" class="form-control input-sm"><option value="01">Type Name 01</option><option value="02">Type Name 02</option><option value="03">Type Name 03</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="appointmentChiefComplaint">Chief Complaint:</label> <textarea name="appointmentChiefComplaint" id="appointmentChiefComplaint" rows="4" class="form-control" data-resize="disabled" placeholder="Add any problem or symptom here..."></textarea></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentStart">Start:</label> <input type="datetime-local" class="form-control input-sm" id="appointmentStart"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentEnd">End:</label> <input type="date" class="form-control input-sm" id="appointmentEnd"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Recurrences:</label><br><div class="btn-group"><label class="btn btn-default" ng-class="radioModel === \'daily\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'daily\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'daily\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Daily</label> <label class="btn btn-default" ng-class="radioModel === \'weekly\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'weekly\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'weekly\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Weekly</label> <label class="btn" ng-class="radioModel === \'monthly\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'monthly\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'monthly\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Monthly</label> <label class="btn" ng-class="radioModel === \'custom\'?\'btn-warning\':\'btn-default\'" ng-model="radioModel" uib-btn-radio="\'custom\'"><i class="fa" aria-hidden="true" ng-class="radioModel === \'custom\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Custom</label></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="appointmentStatus">Status:</label> <select name="appointmentStatus" id="appointmentStatus" class="form-control input-sm"><option value="01">Status 01</option><option value="02">Status 02</option><option value="03">Status 03</option></select></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row recurrence-daily" ng-if="radioModel === \'daily\'"><div class="col-xs-6 col-sm-4 col-md-3 col-lg-3"><div class="form-group"><label for="recurrenceStart">Start Time:</label> <input type="time" id="recurrenceStart" class="form-control"></div></div><div class="col-xs-6 col-sm-4 col-md-3 col-lg-3"><div class="form-group"><label for="recurrenceEnd">End Time:</label> <input type="time" id="recurrenceEnd" class="form-control"></div></div></div><!-- /.row --><div class="row recurrence-weekly" ng-if="radioModel ===\'weekly\'"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label>Choose week days:</label><br><div class="btn-group"><label class="btn" ng-class="week.monday?\'btn-info\':\'btn-default\'" ng-model="week.monday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.monday?\'fa-check-square-o\':\'fa-square-o\'"></i> Monday</label> <label class="btn" ng-class="week.tuesday?\'btn-info\':\'btn-default\'" ng-model="week.tuesday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.tuesday?\'fa-check-square-o\':\'fa-square-o\'"></i> Tuesday</label> <label class="btn" ng-class="week.wednesday?\'btn-info\':\'btn-default\'" ng-model="week.wednesday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.wednesday?\'fa-check-square-o\':\'fa-square-o\'"></i> Wednesday</label> <label class="btn" ng-class="week.thursday?\'btn-info\':\'btn-default\'" ng-model="week.thursday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.thursday?\'fa-check-square-o\':\'fa-square-o\'"></i> Thursday</label> <label class="btn" ng-class="week.friday?\'btn-info\':\'btn-default\'" ng-model="week.friday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.friday?\'fa-check-square-o\':\'fa-square-o\'"></i> Friday</label> <label class="btn" ng-class="week.saturday?\'btn-info\':\'btn-default\'" ng-model="week.saturday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.saturday?\'fa-check-square-o\':\'fa-square-o\'"></i> Saturday</label> <label class="btn" ng-class="week.sunday?\'btn-info\':\'btn-default\'" ng-model="week.sunday" uib-btn-checkbox><i class="fa" aria-hidden="true" ng-class="week.sunday?\'fa-check-square-o\':\'fa-square-o\'"></i> Sunday</label></div></div></div></div><!-- /.row --><div class="row" ng-if="radioModel === \'monthly\'"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label>Choose a date: <strong>{{vm.recurrence.monthly | date:\'fullDate\'}}</strong></label><div class="static-datepicker" uib-datepicker datepicker-options="vm.calendarOpts" ng-model="vm.recurrence.monthly"></div></div></div></div><!-- /.row --><div class="row" ng-if="radioModel === \'custom\'"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Choose dates:</label><div class="static-datepicker" uib-datepicker datepicker-options="vm.calendarOptsCustom" ng-model="vm.datePicked"></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Date selected:</label><div class="input-group"><input type="text" class="form-control" id="inputDateSelected" value="{{vm.datePicked | date:\'fullDate\'}}" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-success" ng-click="vm.addCustomDate(vm.datePicked)"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></span></div></div><div class="form-group recurrences-list"><label>Dates List:</label><ul class="list-unstyled"><li role="listitem" ng-repeat="date in vm.customRecurrences"><span>{{date | date:\'fullDate\'}}</span> <a ng-click="vm.deleteCustomDate($index)"><i class="fa fa-times" aria-hidden="true"></i></a></li></ul></div></div></div><!-- /.row --></div></div>');
$templateCache.put('app/entities/assistant/list/assistant.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/assistant/update/assistant-dialog.html','<form name="vm.form.assistant" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAssistantLabel">Create/Edit an Assistant</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-9 col-md-9 col-lg-10"><div class="form-group form-group-sm has-feedback" ng-class="vm.assistant.name?(vm.form.assistant.assistantName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="assistantName" id="field_name" ng-model="vm.assistant.name" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.assistant.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.assistant.name && vm.form.assistant.assistantName.$dirty"></span> <span class="help-block" ng-show="!vm.assistant.name">This field is required</span></div></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-2"><div class="form-group form-group-sm"><label for="field_active">Active:</label><br><toggle id="field_active" ng-model="vm.assistant.active" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.assistant.sections && vm.assistant.sections.length>0?\'has-success\':\'has-error\'"><label for="field_section">Sections:</label><ui-select ng-model="vm.assistant.sections" name="section" id="field_section" reset-search-input="true" title="Sections" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Select entries ...">{{$item}}</ui-select-match><ui-select-choices repeat="item in vm.sections"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.assistant.sections.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.assistant.sections.length && vm.assistant.sections.length>0"></span> <span class="help-block" ng-show="!vm.assistant.sections.length > 0">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.assistant.note || !vm.form.assistant.notes.$invalid?(vm.form.assistant.notes.$dirty && vm.form.assistant.notes.$valid?\'has-success\':\'\'):\'has-error\'"><label for="note">Note:</label> <textarea id="note" class="form-control" rows="5" name="notes" data-resize="disabled" ng-model="vm.assistant.note" required></textarea> <span class="help-block" ng-show="vm.form.assistant.notes.$error.required || vm.form.assistant.notes.$invalid">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.assistant.$error.required || vm.from.assistant.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/audit/detail/audit-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGlucoseLabel">{{vm.chart.fullName}} - Date: {{vm.date | amDateFormat: dateFormat}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h3 class="mb-0 bold-heading">Patient Information:</h3><hr><div class="pinfo well"><udt-chart-header chart="vm.chart"></udt-chart-header><!--                    <p class="mb-0">--><!--                        <span><strong>Name:</strong></span>--><!--                        <span>{{vm.chart.patient.firstName + " " + vm.chart.patient.lastName}}</span>--><!--                    </p>--><!--                    <p class="mb-0">--><!--                        <span><strong>Mr No:</strong></span>--><!--                        <span>{{vm.chart.mrNo}}</span>--><!--                    </p>--><div><p class="mb-5" ng-if="vm.levels"><span><strong>Level of Cares:</strong></span> <span>{{vm.levels}}</span></p><p class="mb-5"><span><strong>Date:</strong></span> <span>{{vm.date | amDateFormat: dateFormat}}</span></p><p class="mb-0" ng-if="vm.insurance.length > 0"><span><strong>Insurance Carrier:</strong></span> <span>{{vm.insurance}}</span></p></div></div><h3 class="mb-0 bold-heading">Cares and Deliveries</h3><hr><div class="audit-tables mb-15"><table class="table table-condensed table-striped"><thead><tr><th><strong>ID</strong></th><th><strong>Name</strong></th><th><strong>LOC</strong></th><th><strong>CR</strong></th><th><strong>Config</strong></th><th><strong>Status</strong></th><th class="text-center"><strong>Total Hours</strong></th><th></th></tr></thead><tbody><tr ng-repeat="cd in vm.cds"><td>{{cd.id}}</td><td>{{cd.name}}</td><td class="status">{{cd.typeLevelCareName}}</td><td ng-bind-html="vm.colorHtmlYesNo(gs.concurrentReviewsId)"></td><td ng-bind-html="vm.colorHtmlYesNo(gs.ibcInsuranceCarriersId)"></td><td class="status"><span class="yellow">{{cd.status}}</span></td><td class="text-center">{{cd._hours}}</td></tr></tbody></table></div><h3 class="mb-0 bold-heading">Total Hours</h3><hr><div class="audit-tables"><table class="table table-condensed table-striped table-centered"><thead><tr><th><strong>InReview</strong></th><th><strong>Pending</strong></th><th><strong>Finalized</strong></th></tr></thead><tbody><tr><td>{{vm.getHumanHours(vm.cdsCounter.InReview)}}</td><td>{{vm.getHumanHours(vm.cdsCounter.Pending)}}</td><td>{{vm.getHumanHours(vm.cdsCounter.Finalized)}}</td></tr></tbody></table></div><h3 class="mb-0 bold-heading">Group Sessions</h3><hr><div class="audit-tables mb-15"><table class="table table-condensed table-striped"><thead><tr><th><strong>ID</strong></th><th><strong>Name</strong></th><th><strong>LOC</strong></th><th><strong>CR</strong></th><th><strong>Config</strong></th><th><strong>Status</strong></th><th class="text-center"><strong>Total Hours</strong></th></tr></thead><tbody><tr ng-repeat="gs in vm.gss"><td>{{gs.id}}</td><td>{{gs.name}}</td><td class="status">{{gs.typeLevelCareName}}</td><td ng-bind-html="vm.colorHtmlYesNo(gs.concurrentReviewsId)"></td><td ng-bind-html="vm.colorHtmlYesNo(gs.ibcInsuranceCarriersId)"></td><td class="status"><span class="yellow">{{gs.status}}</span></td><td class="text-center">{{gs._hours}}</td></tr></tbody></table></div><h3 class="mb-0 bold-heading">Total Hours</h3><hr><div class="audit-tables"><table class="table table-condensed table-striped table-centered"><thead><tr><th><strong>Pending</strong></th><th><strong>Started</strong></th><th><strong>Review</strong></th><th><strong>Complete</strong></th><th><strong>Disabled</strong></th></tr></thead><tbody><tr><td>{{vm.getHumanHours(vm.gssCounter.PENDING)}}</td><td>{{vm.getHumanHours(vm.gssCounter.STARTED)}}</td><td>{{vm.getHumanHours(vm.gssCounter.REVIEW)}}</td><td>{{vm.getHumanHours(vm.gssCounter.COMPLETE)}}</td><td>{{vm.getHumanHours(vm.gssCounter.DISABLED)}}</td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/audit/list/audit-filter-tpl.html','<form class="form filters-form" name="editForm" novalidate><div class="row mb-15" ng-if="false"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><ui-select ng-model="vm.filter.carrier" name="carrier" id="field_carrier" reset-search-input="true" title="Carriers" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Select the Carriers ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0"><div ng-bind-html="carrier.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><ui-select ng-model="vm.filter.levels" name="levels" id="field_levels" reset-search-input="true" title="L.O.C" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Select the L.O.C s ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="level in vm.typeLevelCares | propsFilter: {name: $select.search}"><div ng-bind-html="level.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><ui-select id="field_charts" name="charts" title="Select patients..." multiple="multiple" required close-on-select="false" ng-model="vm.filter.charts"><ui-select-match placeholder="Select patient involve..."><div ng-bind-html="$item.firstName + \' \' + $item.lastName | highlight: $select.search"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + ($item.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + $item.mrNo"></small></ui-select-match><ui-select-choices repeat="chart in vm.filteredCharts | filter: $select.search" refresh="vm.getCharts($select.search)" refresh-delay="0"><div ng-bind-html="chart.firstName + \' \' + chart.lastName | highlight: $select.search"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + (chart.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + chart.mrNo"></small></ui-select-choices></ui-select></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="input-group"><input type="text" class="form-control" placeholder="Start Date" name="firstDate" ng-model="vm.filter.startDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.firstDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.openCalendar(\'firstDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="input-group"><input type="text" class="form-control" placeholder="End Date" name="lastDate" ng-model="vm.filter.endDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.lastDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button class="btn btn-default" ng-click="vm.openCalendar(\'lastDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><select name="show" ng-model="vm.filter.show" class="form-control" placeholder="By Hours"><option value="short" selected="selected">Short</option><option value="over">Over</option><option value="all">All</option></select></div></div><hr style="margin-top: 0"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></form>');
$templateCache.put('app/entities/audit/list/audit.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="header-options"><div class="search-material mb-30"><div class="search-input"><input type="text" class="form-control input-lg" ng-change="vm.search()" ng-model="vm.searchQuery"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div><button class="btn btn-default btn-lg red btn-header" ng-click="vm.showFilters()" uib-tooltip="Show Filters"><i class="fa fa-sliders" aria-hidden="true"></i> Filters</button><div class="filter-box"><ng-include src="\'app/entities/audit/list/audit-filter-tpl.html\'"></ng-include></div></div><div class="btn-group btn-group-lg main-filters"><!-- button class for colored backgrounds when the button is active: bg-green, bg-orange, bg-blue --> <button type="button" class="btn btn-default" ng-class="[{\'active bg-orange\': vm.filter.weekly}]" uib-tooltip="By weeks" ng-click="vm.week()"><i class="fa" aria-hidden="true" ng-class="vm.filter.weekly?\'fa-check-circle\':\'fa-circle-o\'"></i> <span class="hidden-xs">Current Week</span></button> <button type="button" class="btn btn-default" uib-tooltip="By Month" ng-class="[{\'active bg-orange\': !vm.filter.weekly}]" ng-click="vm.month()"><i class="fa" aria-hidden="true" ng-class="!vm.filter.weekly?\'fa-check-circle\':\'fa-circle-o\'"></i> <span class="hidden-xs">Current Month</span></button></div></div><div class="box-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="empty-content" ng-if="vm.dates.length == 0 && !vm.isLoading"><div class="text"><span>There is no data</span> <span></span></div></div><div class="empty-content" ng-if="vm.dates.length == 0 && vm.isLoading"><div class="text"><span>Loading data...</span> <span></span></div></div><div class="audit-table" ng-if="vm.dates.length != 0"><div class="table-small" id="table-small"><div class="table-small-header"><span class="text-center">Patients</span></div><div class="info-cell" ng-repeat="audit in vm.audits"><span class="p-name">{{audit.patient}}<br>{{audit.mrNo}}</span></div></div><div class="table-wide" id="table-wide" ng-if="vm.dates.length != 0"><div class="table-wide-header"><span class="text-center" ng-repeat="date in vm.dates">{{date | amDateFormat: dateFormat}}</span></div><div class="patient-audits" ng-repeat="audit in vm.audits"><div class="info-cell" ng-repeat="date in vm.dates"><div class="click-wrapper" ng-if="audit[date]" ng-click="vm.openDetails(date, audit)" uib-tooltip="Open Details" tooltip-placement="left"><div ng-repeat="detail in audit[date].details" ng-if="vm.filterByHours(detail)" ng-class="[{short: detail.availableHours > 0}, {over: detail.exceededHours > 0}, {no_billable: !detail.billable}]"><div><p class="" uib-tooltip="LOC: {{detail.typeLevelCare}}">LOC: {{detail.typeLevelCare}}</p><p><strong>Total:</strong> {{vm.splitTime(detail.billableHours)}} h</p><p ng-if="detail.availableHours > 0"><strong>Short:</strong> {{vm.splitTime(detail.availableHours)}} h</p><p ng-if="detail.exceededHours > 0"><strong>Over:</strong> {{vm.splitTime(detail.exceededHours)}} h</p></div></div><div ng-if="((audit[date].nobillableGsHours + audit[date].nobillableCdHours) > 0) && vm.filterByHours()"><p class="">Need Review!</p><p><strong>Total:</strong> {{vm.splitTime(audit[date].nobillableGsHours + audit[date].nobillableCdHours)}} h</p></div></div></div></div></div></div></div></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage" ng-if="vm.filter.charts.length === 0"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.charts.length > 0 && vm.filter.charts.length === 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.loadCharts()"></ul></div></div></section>');
$templateCache.put('app/entities/auto-fax/list/auto-fax.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/auto-fax/update/auto-fax-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAutoFaxLabel">Create or edit a Auto Fax</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.autoFax.contactAddress?(editForm.autoFax.contactAddress.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_contactAddress">Contact Address</label> <select class="form-control" id="field_contactAddress" name="contactAddress" required ng-model="vm.autoFax.contactAddress" ng-options="contactAddress as contactAddress.name for contactAddress in vm.contactAddresses track by contactAddress.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.autoFax.contactAddress"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.autoFax.contactAddress && editForm.contactAddress.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.autoFax.contactAddress">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/bed/bed-sheet/bed-sheet-assign.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedLabel">Assign Chart</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="text-center mb-15"><h3><strong>Bed:</strong> {{vm.bed.name}} | <strong>Gender:</strong> {{vm.bed.room.sex}}</h3></div><div class="header-options"><div class="search-material" style="margin: 0 auto"><div class="search-input"><input type="text" id="searchQueryPatient" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-instance="vm.dtInstance" dt-options="vm.dtOptions" dt-columns="vm.dtColumns"></table></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/bed/bed-sheet/bed-sheet-status.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedStatusLabel">Change Bed Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><label for="field_status">Room:</label> <select class="form-control" id="field_status" name="status" required ng-model="vm.bedStatus" ng-options="status as status for status in vm.status"></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-sm" ng-click="vm.save()"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/bed/bed-sheet/bed-sheet.html','<section class="content no-padding"><div class="content-heading" style="flex-wrap: wrap"><span style="margin-right: auto;">Occupied: <strong>{{vm.countAllOccupied?vm.countAllOccupied:\'0\'}}</strong> - Empty: <strong>{{vm.countAllEmpty?vm.countAllEmpty:\'0\'}}</strong></span><div class="filters-box"><select name="selectBuilding" id="selectBuildingControl" class="form-control ch-form-control" ng-model="vm.building" ng-options="item as item.name for item in vm.buildings track by item.id" ng-change="vm.updateCurrentBuilding()"></select><div class="btn-group"><button type="button" class="btn btn-default" title="All Beds" ng-class="{\'active\': !vm.filter.gender}" ng-click="vm.filterGender(null)"><i class="fa fa-users" aria-hidden="true"></i> <span class="hidden-xs">All</span></button> <button type="button" class="btn btn-default" title="Female Beds" ng-class="{\'active\': vm.filter.gender === \'FEMALE\'}" ng-click="vm.filterGender(\'FEMALE\')"><i class="fa fa-female" aria-hidden="true"></i> <span class="hidden-xs">Female</span></button> <button type="button" class="btn btn-default" title="Male Beds" ng-class="{\'active\': vm.filter.gender === \'MALE\'}" ng-click="vm.filterGender(\'MALE\')"><i class="fa fa-male" aria-hidden="true"></i> <span class="hidden-xs">Male</span></button></div><button type="button" class="btn btn-default" ng-click="vm.getBedSheetPdf()"><i class="fa fa-print" aria-hidden="true"></i></button></div></div><div class="table-responsive beds-layout"><table class="table table-condensed table-hover"><thead><tr><jhi-alert></jhi-alert></tr><tr><th></th><th><strong>Bed</strong></th><th><strong>Name</strong></th><th><strong>Mr Number</strong></th><th><strong>Admission</strong></th><th><strong>Discharge</strong></th><th><strong>Level of Care</strong></th><th><strong>Outreach</strong></th><th><strong>Referrer</strong></th><th></th></tr></thead><tbody><tr ng-repeat-start="room in vm.rooms | orderBy:\'roomName\' track by $index"><td colspan="10" class="room-name" ng-class="{\'room-female\' : room.beds[0].gender === \'FEMALE\',\n                                                   \'room-male\' : room.beds[0].gender === \'MALE\'}"><span>{{room.roomName}}</span></td></tr><tr class="bed" ng-repeat="bed in room.beds | orderBy:\'bed.name\'"><td ng-if="bed.chartId != null"><img class="img-responsive img-thumbnail" alt="Patient Photo" style="width: 70px;" ng-src-auth="{{ {id: bed.chartId, pictureRefId: bed.pictureRefId} }}"></td><td ng-if="bed.chartId != null"><span class="label label-default">{{bed.bed.name?bed.bed.name:\'-\'}}</span></td><td ng-if="bed.chartId != null">{{bed.lastName}}, {{bed.firstName}}</td><td ng-if="bed.chartId != null">{{bed.mrNo?bed.mrNo:\'-\'}}</td><td ng-if="bed.chartId != null">{{bed.admissionDate?(bed.admissionDate | date: inputDateTimeFormatA):\'-\'}}</td><td ng-if="bed.chartId != null">{{bed.dischargeDate?(bed.dischargeDate | date: inputDateTimeFormatA):\'-\'}}</td><td ng-if="bed.chartId != null">{{bed.typeLevelCare?(bed.typeLevelCare):\'-\'}}</td><td ng-if="bed.chartId != null">{{bed.firstNameMarketer?(bed.lastNameMarketer + \', \' + bed.firstNameMarketer):\'-\'}}</td><td ng-if="bed.chartId != null">{{bed.referrer?bed.referrer:\'-\'}}</td><td style="width: 45px" ng-if="bed.chartId != null"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.openChart(bed.chartId)"><i class="fa fa-bed" aria-hidden="true"></i> Patient Details</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.remove(bed.chartId)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td><td colspan="1" ng-if="bed.chartId === null"><span class="label label-info" ng-if="bed.bed.status == \'MAINTENANCE\' || bed.bed.status == \'CLEANING\'">{{bed.bed.status}}</span></td><td colspan="3" ng-if="bed.chartId === null"><span class="label label-default">{{bed.bed.name?bed.bed.name:\'-\'}}</span></td><td colspan="6" style="text-align: right;" ng-if="bed.chartId === null"><button type="button" class="btn btn-warning btn-sm" ng-if="bed.bed.status == \'ACTIVE\'" ng-click="vm.assignBed(bed.bed.id)"><i class="fa fa-bed" aria-hidden="true"></i> Assign Patient</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.changeStatusBed(bed.bed.id)"><i class="fa fa-exchange" aria-hidden="true"></i> Change Status</button></td></tr><tr ng-repeat-end><td colspan="10" class="blank-row"></td></tr></tbody></table></div></section>');
$templateCache.put('app/entities/bed/list/bed.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/bed/upload/bed-dialog.html','<form name="vm.form.bed" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedLabel">Create or edit a Bed</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.bed.name?(vm.form.bed.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.bed.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.bed.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.bed.name && vm.form.bed.name.$dirty"></span> <span class="help-block" ng-show="!vm.bed.name">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.bed.status?(vm.form.bed.status.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_status">Status:</label> <select class="form-control" id="field_status" name="status" required ng-model="vm.bed.status" ng-options="status for status in vm.status"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.bed.status"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.bed.status && vm.form.bed.status.$dirty"></span> <span class="help-block" ng-show="!vm.bed.status">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.bed.room?(vm.form.bed.room.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_room">Room:</label> <select class="form-control" id="field_room" name="room" required ng-model="vm.bed.room" ng-options="room as room.name for room in vm.rooms track by room.id"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.bed.room"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.bed.room && vm.form.bed.room.$dirty"></span> <span class="help-block" ng-show="!vm.bed.room">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.bed.notes?(vm.form.bed.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Notes</label> <textarea class="form-control" name="notes" id="field_notes" rows="5" data-resize="disabled" ng-model="vm.bed.notes"></textarea> <span class="help-block help-warning" ng-show="!vm.bed.notes">This field is suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="vm.form.bed.$invalid || vm.form.bed.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/billing-schedule/list/billing-schedule.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/billing-schedule/update/billing-schedule-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedLabel">Create or edit a Billing Schedule</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_notes">Emails: (| separator)</label> <textarea class="form-control" name="emails" id="field_notes" rows="5" data-resize="disabled" ng-model="vm.billingSchedule.emails"></textarea></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_employee">Employees</label><ui-select name="employee" id="field_employee" title="employee" multiple="multiple" ng-model="vm.billingSchedule.employees" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Select ...">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="item in vm.employees | propsFilter: {firstName: $select.search ,lastName: $select.search}" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="item.firstName + \' \' + item.lastName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/building/list/building.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/building/update/building-dialog.html','<form name="vm.form.building" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBuildingLabel">Create or edit a Building</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group has-feedback" ng-class="vm.building.name?(vm.form.building.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Building Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.building.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.building.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.building.name && vm.form.building.name.$dirty"></span> <span class="help-block" ng-show="!vm.building.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.building.$error.required || vm.form.building.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/business-credential/list/business-credential.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/business-credential/update/business-credential-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCareCoordinationTemplateLabel">Create or edit a Business Credential</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group has-feedback" ng-class="vm.businessCredential.businessRole?(editForm.role.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_role">Business Role</label> <select class="form-control" id="field_role" name="role" ng-model="vm.businessCredential.businessRole" ng-options="role as role for role in vm.roles track by role" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.businessCredential.businessRole"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.businessCredential.businessRole && editForm.role.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.businessCredential.businessRole">This field is required</span></div><div class="form-group has-feedback" ng-class="vm.businessCredential.credentials && vm.businessCredential.credentials.length > 0?(editForm.credential.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Credentials</label><ui-select ng-model="vm.businessCredential.credentials" name="credential" id="credential" reset-search-input="true" title="Roles" multiple="multiple" required close-on-select="false"><ui-select-match placeholder="Enter a credential ...">{{$item}}</ui-select-match><ui-select-choices repeat="item in vm.credentials | filter: $select.search"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.businessCredential.credentials"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.businessCredential.credentials && editForm.credential.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.businessCredential.credentials || vm.businessCredential.credentials.length == 0">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/campaign/list/campaign.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/campaign/outreach-campaign/message-all-check-dialog.html','<form name="form" ng-submit="vm.confirmSend()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm send message operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Are you sure you want send a message to the all charts ({{vm.totalCharts}}) for this campaign?</p></div><div class="modal-footer"><button type="submit" class="btn btn-danger" ng-disabled="form.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Accept</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/campaign/outreach-campaign/message-campaign-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Message</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_greeting">Greeting:</label> <select class="form-control" id="field_greeting" name="greeting" ng-model="vm.message.greeting" ng-options="greeting as greeting.name for greeting in vm.greetings track by greeting.id"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.message.facilityPhoneNumber?(form.facilityPhoneNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_status">From Phone Number:</label> <select class="form-control" id="field_status" name="facilityPhoneNumber" required ng-model="vm.message.facilityPhoneNumber" ng-options="facilityPhoneNumber as facilityPhoneNumber.phoneNumber\n                                        for facilityPhoneNumber in vm.facilitiesPhoneNumbers\n                                        track by facilityPhoneNumber.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.message.facilityPhoneNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.message.facilityPhoneNumber && form.facilityPhoneNumber.$dirty"></span> <span class="help-block" ng-show="!vm.message.facilityPhoneNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.message.message?(form.message.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_message">Message</label> <textarea class="form-control" name="notes" id="field_message" rows="5" data-resize="disabled" ng-model="vm.message.message" required></textarea> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.message.message"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.message.message && form.message.$dirty"></span> <span class="help-block" ng-show="!vm.message.message">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.sendMessage()" ng-disabled="form.$invalid ||\n                             form.$error.required ||\n                             vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Send</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/campaign/outreach-campaign/outreach-campaign-select-campaign-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Campaigns</h4></div><div class="modal-body"><div class="search-input"><input type="text" class="form-control" placeholder="Search..." id="searchQuerySelectCampaign" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div><div id="select-campaign-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.selectCampaign()" ng-disabled="!vm.campaignId || vm.campaignId == \'\'"><i class="fa fa-save" aria-hidden="true"></i> Select</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/campaign/outreach-campaign/outreach-campaign.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/campaign/update/campaign-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedLabel">Create or edit a Campaign</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.campaign.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.campaign.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.campaign.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.campaign.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.campaign.name">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label" for="field_gender">Gender</label> <select class="form-control" id="field_gender" name="gender" ng-model="vm.campaign.gender" ng-options="item as item for item in vm.gender track by item"><option value=""></option></select></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="!editForm.dischargeRangeStart.$invalid?(editForm.dischargeRangeStart.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_dischargeRangeStart">Discharge Range Start</label> <input type="number" class="form-control" name="dischargeRangeStart" id="field_dischargeRangeStart" min="0" ng-model="vm.campaign.dischargeRangeStart" ng-required="vm.campaign.dischargeRangeEnd != null"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.dischargeRangeStart.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!editForm.dischargeRangeStart.$invalid && editForm.dischargeRangeStart.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="editForm.dischargeRangeStart.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="!editForm.dischargeRangeEnd.$invalid?(editForm.dischargeRangeEnd.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_dischargeRangeEnd">Discharge Range End</label> <input type="number" class="form-control" name="dischargeRangeEnd" id="field_dischargeRangeEnd" min="0" ng-model="vm.campaign.dischargeRangeEnd" ng-required="vm.campaign.dischargeRangeStart != null"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.dischargeRangeEnd.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!editForm.dischargeRangeEnd.$invalid && editForm.dischargeRangeEnd.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="editForm.dischargeRangeEnd.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="!editForm.ageRangeStart.$invalid?(editForm.ageRangeStart.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_ageRangeStart">Age Range Start</label> <input type="number" class="form-control" name="ageRangeStart" id="field_ageRangeStart" min="0" ng-model="vm.campaign.ageRangeStart" ng-required="vm.campaign.ageRangeEnd"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.ageRangeStart.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!editForm.ageRangeStart.$invalid && editForm.ageRangeStart.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="editForm.ageRangeStart.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="!editForm.ageRangeEnd.$invalid?(editForm.ageRangeEnd.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_ageRangeEnd">Age Range End</label> <input type="number" class="form-control" name="ageRangeEnd" id="field_ageRangeEnd" min="0" ng-model="vm.campaign.ageRangeEnd" ng-required="vm.campaign.ageRangeStart"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.ageRangeEnd.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!editForm.ageRangeEnd.$invalid && editForm.ageRangeEnd.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="editForm.ageRangeEnd.$invalid">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_insuranceCarrier">Insurance Carrier</label><ui-select multiple="multiple" name="reaction" id="field_insuranceCarrier" title="Select insurance carrier" ng-model="vm.campaign.insuranceCarriers" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Insurance Carriers ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="insuranceCarrier in vm.insuranceCarriers | filter: $select.search" refresh="vm.getInsuranceCarriers($select.search)" refresh-delay="0"><div ng-bind-html="insuranceCarrier.name"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_typePaymentMethods">Type Payment Methods</label><ui-select multiple="multiple" name="reaction" id="field_typePaymentMethods" title="Select payment methods" ng-model="vm.campaign.typePaymentMethods" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Payment Methods ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.typePaymentMethods | filter: $select.search">{{item.name}}</ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_evaluationTemplate">Evaluation Template</label><ui-select multiple="multiple" name="reaction" id="field_evaluationTemplate" title="Select evaluation template" ng-model="vm.campaign.evaluationTemplates" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Evaluation Templates ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="evaluationTemplate in vm.evaluationTemplates | filter: $select.search" refresh="vm.getEvaluationTemplates($select.search)" refresh-delay="0"><div ng-bind-html="evaluationTemplate.name"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label class="control-label">Active</label><br><toggle ng-model="vm.campaign.active" on="Yes" off="No" id="field_enabled" selected="true"></toggle></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_campaignPolicyNumber">Policy Number</label><ui-select multiple="multiple" name="campaignPolicyNumbers" id="field_campaignPolicyNumber" title="Select campaign policy number" ng-model="vm.campaign.campaignPolicyNumbers" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Policy numbers ...">{{$item.policyNumber}}</ui-select-match><ui-select-choices repeat="campaignPolicyNumber in vm.campaign.campaignPolicyNumbers"></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-5 col-lg-5"><div class="form-group"><label class="control-label" for="field_campaignPolicyNumbersName">&nbsp;</label> <input type="text" class="form-control" name="name" id="field_campaignPolicyNumbersName" ng-model="vm.policyNumberName"></div></div><div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"><div class="form-group"><label>&nbsp;</label> <button type="button" class="btn btn-warning" ng-click="vm.setPolicyNumber(vm.policyNumberName)" ng-disabled="vm.policyNumberName == null || vm.policyNumberName == \'\' "><i class="fa fa-plus" aria-hidden="true"></i></button></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_campaignChartStatus">Chart Status</label><ui-select multiple="multiple" name="reaction" id="field_campaignChartStatus" title="Select chart status" ng-model="vm.campaign.campaignChartStatus" on-select="vm.checkCampaignChartStatus()" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Chart Status ...">{{$item.chartStatus}}</ui-select-match><ui-select-choices repeat="item in vm.campaignChartStatus | filter: $select.search">{{item.chartStatus}}</ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_campaignEvaluationStatus">Evaluation Status</label><ui-select multiple="multiple" name="evaluationStatus" id="field_campaignEvaluationStatus" title="Select evaluation status" ng-model="vm.campaign.campaignEvaluationStatus" on-select="vm.checkCampaignEvaluationStatus()" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Evaluation Status ...">{{$item.evaluationStatus}}</ui-select-match><ui-select-choices repeat="item in vm.campaignEvaluationStatus | filter: $select.search">{{item.evaluationStatus}}</ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/care-coordination/update/care-coordination-dialog.html','<form name="vm.form.careCoordination" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCareCoordinationLabel">Create or edit a Care Coordination</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row" ng-show="vm.careCoordination.id"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-4"><div class="form-group form-group-sm"><input type="hidden" class="form-control" id="id" name="id" value="{{vm.careCoordination.id}}" readonly="readonly" ng-model="vm.careCoordination.id"></div></div></div><div class="row"><div class="col-xs-12 col-sm-9 col-md-9 col-lg-9"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordination.title?(vm.form.careCoordination.title.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="name">Title:</label> <input type="text" class="form-control" name="name" id="name" required ng-model="vm.careCoordination.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordination.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordination.title && vm.form.title.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordination.title">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordination.days?(vm.form.careCoordination.days.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_days">Days</label> <input type="number" class="form-control" name="days" id="field_days" required ng-model="vm.careCoordination.days"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordination.days"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordination.days && vm.form.days.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordination.days">required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordination.description?(vm.form.careCoordination.description.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Description:</label> <textarea class="form-control" name="notes" id="field_description" rows="2" data-resize="disabled" ng-model="vm.careCoordination.description"></textarea> <span class="help-block help-warning" ng-show="!vm.careCoordination.description">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordination.note?(vm.form.careCoordination.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Notes:</label> <textarea class="form-control" name="notes" id="field_notes" rows="3" data-resize="disabled" ng-model="vm.careCoordination.note"></textarea> <span class="help-block help-warning" ng-show="!vm.careCoordination.note">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordination.typeAction?(vm.form.careCoordination.typeAction.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_typeAction">Type Action:</label> <select class="form-control" name="typeAction" ng-model="vm.careCoordination.typeAction" id="field_typeAction"><option value="CARE_TEAM_MEMBER">ASSIGN CARE TEAM MEMBER</option><option value="DIAGNOSE">DIAGNOSES</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordination.typeAction"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordination.typeAction && vm.form.careCoordination.typeAction.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.careCoordination.typeAction">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" ng-if="vm.careCoordination.typeAction == \'CARE_TEAM_MEMBER\'"><div class="form-group form-group-sm has-feedback" ng-class="vm.employeeTmp.length > 0?(vm.form.employees.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_employee">Employee</label><ui-select name="employee" id="field_employee" required title="employee" multiple="multiple" ng-model="vm.employeeTmp" ng-required="true" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Select ...">{{$item.firstName}}</ui-select-match><ui-select-choices repeat="item in vm.employees | propsFilter: {firstName: $select.search ,lastName: $select.search}" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="item.firstName + \' \' + item.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employeeTmp.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employeeTmp.length > 0 && vm.form.employees.$dirty"></span> <span class="help-block" ng-show="!vm.employeeTmp.length > 0">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" ng-if="vm.careCoordination.typeAction == \'DIAGNOSE\'"><div class="form-group form-group-sm has-feedback" ng-class="vm.icd10Tmp.length > 0?(vm.form.icd10S.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_icd10">Diagnoses(ICD10):</label><ui-select name="icd10" id="field_icd10" required title="icd10" multiple="multiple" ng-model="vm.icd10Tmp" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Type Icd10...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.icd10 | propsFilter: {code: $select.search ,description: $select.search}" minimun-input-length="3" refresh="vm.getIcd10($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.icd10Tmp.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.icd10Tmp.length > 0 && vm.form.icd10S.$dirty"></span> <span class="help-block" ng-show="!vm.icd10Tmp.length > 0">This field is required</span></div></div></div></div><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.careCoordination.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" class="btn btn-success" ng-disabled="vm.form.careCoordination.$error.required || vm.form.careCoordination.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Care Coordination from this patient\'s record. Are you sure you want to <strong>delete</strong> this Care Coordination?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/care-coordination-template/list/care-coordination-template.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/care-coordination-template/update/care-coordination-template-dialog.html','<form name="vm.form.careCoordinationTemplate" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCareCoordinationTemplateLabel">Create or edit a Care Coordination Template</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row" ng-show="vm.careCoordinationTemplate.id"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-4"><div class="form-group form-group-sm"><input type="hidden" class="form-control" id="id" name="id" value="{{vm.careCoordinationTemplate.id}}" readonly="readonly" ng-model="vm.careCoordinationTemplate.id"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.title?(vm.form.careCoordinationTemplate.title.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="name">Title:</label> <input type="text" class="form-control" name="name" id="name" required ng-model="vm.careCoordinationTemplate.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordinationTemplate.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordinationTemplate.title && vm.form.title.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordinationTemplate.title">This field is required</span></div></div><div class="col-xs-12 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.description?(vm.form.careCoordinationTemplate.description.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_description">Description:</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.careCoordinationTemplate.description"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.careCoordinationTemplate.description"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordinationTemplate.description && vm.form.description.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.careCoordinationTemplate.description">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.notes?(vm.form.careCoordinationTemplate.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Notes:</label> <textarea class="form-control" name="notes" id="field_notes" rows="5" data-resize="disabled" ng-model="vm.careCoordinationTemplate.notes"></textarea> <span class="help-block help-warning" ng-show="!vm.careCoordinationTemplate.notes">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.days?(vm.form.careCoordinationTemplate.days.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_days">Days</label> <input type="number" class="form-control" name="days" id="field_days" required ng-model="vm.careCoordinationTemplate.days"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordinationTemplate.days"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordinationTemplate.days && vm.form.days.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordinationTemplate.days">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.typeAction?(vm.form.careCoordinationTemplate.typeAction.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_typeAction">Type Action:</label> <select class="form-control" name="typeAction" id="field_typeAction" required ng-model="vm.careCoordinationTemplate.typeAction"><option value="CREATE_CHART">Create Patient</option><option value="ADMIT_CHART">Admitting Patient</option><option value="CARE_TEAM_MEMBER">Assign Care Team Member</option><option value="DIAGNOSE">Diagnoses</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordinationTemplate.typeAction"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordinationTemplate.typeAction && vm.form.careCoordinationTemplate.typeAction.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordinationTemplate.typeAction">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3"><div class="form-group form-group-sm"><label><label class="control-label" for="field_active">Active</label><br><toggle id="field_active" ng-model="vm.careCoordinationTemplate.active" on="Yes" off="No" size="btn-sm" onstyle="btn-success" offstyle="btn-danger"></toggle></label></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3" ng-if="vm.careCoordinationTemplate.typeAction === \'CARE_TEAM_MEMBER\'"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.employees.length > 0?(vm.form.careCoordinationTemplate.employee.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_employee">Employee</label><ui-select name="employee" id="field_employee" class="form-control" title="employees" multiple="multiple" ng-model="vm.careCoordinationTemplate.employees" reset-search-input="true" close-on-select="true"><ui-select-match placeholder="Select ...">{{$item.firstName}} {{$item.lastName}}</ui-select-match><ui-select-choices repeat="item in vm.employees | propsFilter: {firstName: $select.search ,lastName: $select.search}" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="item.firstName + \' \' + item.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordinationTemplate.employees.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordinationTemplate.employees.length > 0 && vm.form.careCoordinationTemplate.employee.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordinationTemplate.employees.length > 0">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3" ng-if="vm.careCoordinationTemplate.typeAction == \'DIAGNOSE\'"><div class="form-group form-group-sm has-feedback" ng-class="vm.careCoordinationTemplate.icd10S.length > 0?(vm.form.careCoordinationTemplate.icd10.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_icd10">Diagnoses(ICD10):</label><ui-select name="icd10" id="field_icd10" required title="icd10" multiple="multiple" ng-model="vm.careCoordinationTemplate.icd10S" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Type Icd10...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.icd10S | filter: $select.search" minimun-input-length="3" refresh="vm.getIcd10S($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.careCoordinationTemplate.icd10S.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.careCoordinationTemplate.icd10S.length > 0 && vm.form.careCoordinationTemplate.icd10.$dirty"></span> <span class="help-block" ng-show="!vm.careCoordinationTemplate.icd10S.length > 0">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.careCoordinationTemplate.$error.required || vm.form.careCoordinationTemplate.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/chart/copy/chart-copy-dialog.html','<form name="editForm" ng-submit="vm.copy(vm.chart.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Clone chart to new facility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><row><div class="col-xs-12"><div class="form-group"><label class="control-label">Select Facility:</label><ui-select ng-model="vm.facility" name="facility" id="field_facility" reset-search-input="true" title="Select Facility..."><ui-select-match placeholder="Select facilities...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.facilities"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></row></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Copy</span></button></div></form>');
$templateCache.put('app/entities/chart/create/chart-create-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create Patient</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="createChartWizard" on-finish="vm.finishedWizard()" on-cancel="vm.cancelledWizard()" indicators-position="top"><wz-step wz-title="Get Started" wz-disabled="{{vm.copyChart != null}}"><ng-include src="\'app/entities/chart/create/tpl/filter-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Basic Info"><h2 class="step-header">Basic Information</h2><hr><ng-include src="\'app/entities/chart/create/tpl/basic-info-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.basicInfo.$invalid"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Patient Photo"><h2 class="step-header">Upload Patient Photo</h2><hr><form action="" name="vm.form.patientPhoto" class="form mb-15"><udt-crop-image cropped-image="vm.chart.pictureRef" image="vm.chart.pictureRefOriginal"></udt-crop-image></form><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Patient ID"><h2 class="step-header">Upload Patient ID Photo</h2><hr><form action="" name="vm.form.patientID" class="form mb-15"><div class="id-card"><div class="front"><udt-crop-image cropped-image="vm.chart.patientLicense" image="vm.chart.patientLicenseOriginal" default-image="{{vm.genericCardImageFront.picture}}" area-type="rectangle"></udt-crop-image></div></div></form><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-if="!vm.disabled"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Primary Insurance Information" wz-disabled="{{vm.disabled}}"><ng-include src="\'app/entities/chart/create/tpl/insurance-primary-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.primaryInsurance.$error.required"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Primary Insurance Card" wz-disabled="{{vm.disabled}}"><h2 class="step-header">Upload Insurance Card Photo</h2><hr><form action="" name="vm.form.primaryInsuranceCard" class="form mb-15"><div class="id-card"><div class="front"><div class="text-center"><strong>Front:</strong></div><udt-crop-image cropped-image="vm.chart.primaryInsuranceFrontPicture" image="vm.chart.primaryInsuranceFrontPictureOriginal" default-image="{{vm.genericCardImageFront.picture}}" area-type="rectangle"></udt-crop-image></div><div class="back"><div class="text-center"><strong>Back:</strong></div><udt-crop-image cropped-image="vm.chart.primaryInsuranceBackPicture" image="vm.chart.primaryInsuranceBackPictureOriginal" default-image="{{vm.genericCardImageBack.picture}}" area-type="rectangle"></udt-crop-image></div></div></form><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.primaryInsurance.$error.required"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Secondary Insurance Information" wz-disabled="{{vm.disabled || vm.chart.secondary == null}}"><ng-include src="\'app/entities/chart/create/tpl/insurance-secondary-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.secondaryInsurance.$error.required"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Secondary Insurance Card" wz-disabled="{{vm.disabled || vm.chart.secondary == null}}"><h2 class="step-header">Upload Insurance Card Photo</h2><hr><form action="" name="vm.form.primaryInsuranceCard" class="form mb-15"><div class="id-card"><div class="front"><div class="text-center"><strong>Front:</strong></div><udt-crop-image cropped-image="vm.chart.secondaryInsuranceFrontPicture" image="vm.chart.secondaryInsuranceFrontPictureOriginal" default-image="{{vm.genericCardImageFront.picture}}" area-type="rectangle"></udt-crop-image></div><div class="back"><div class="text-center"><strong>Back:</strong></div><udt-crop-image cropped-image="vm.chart.secondaryInsuranceBackPicture" image="vm.chart.secondaryInsuranceBackPictureOriginal" default-image="{{vm.genericCardImageBack.picture}}" area-type="rectangle"></udt-crop-image></div></div></form><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button></wz-step></wizard></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.save()" ng-disabled="!vm.isLastStep() || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Create</button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/chart/dashboard/chart-review.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart/dashboard/charts-caseload.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart/dashboard/charts-discharge.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart/dashboard/charts-marketer.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart/dashboard/charts-payer-mix.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart/dashboard/charts-referrer.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart/list/chart.html','<section class="content no-padding"><header class="content-heading charts-page-heading"><div class="dropdown-filter" style="position:relative; margin-right: auto; padding: 5px 0"><a href="" class="btn-display-filter-link" ng-class="{\'active\': vm.filtersDropdown}" ng-click="vm.filtersDropdown=!vm.filtersDropdown">{{vm.totalItems}} Patients<span class="hidden-sm hidden-xs">, Sorted by {{vm.sorted}} , {{vm.sortDirection}} </span><i class="fa" aria-hidden="true" ng-class="vm.filtersDropdown?\'fa-times\':\'fa-chevron-down\'"></i></a><div class="side-options-jr" ng-if="vm.filtersDropdown"><form name="editForm" class="form filters-form" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><select class="form-control" name="sort" ng-model="vm.filter.sort" ng-change="vm.searchByFilter()" id="field_sort" required><option value="firstName">Patient First Name</option><option value="lastName">Patient Last Name</option><option value="admissionDate">Admission Date</option><option value="typeLevelCare.name">Level Of Care</option><option value="referrer">Referral Source</option><option value="dischargeDate">Discharge Date</option><option value="primary.insuranceCarrier.name">Insurance Carrier</option></select></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><select class="form-control" name="direction" ng-model="vm.filter.direction" ng-change="vm.searchByFilter()" id="field_direction" required><option value="ASC">Ascending</option><option value="DESC">Descending</option></select></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" placeholder="First Name..." name="firstName" ng-model="vm.filter.firstName"></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><input type="text" class="form-control input-sm" placeholder="Last Name..." name="lastName" ng-model="vm.filter.lastName"></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><input type="text" class="form-control input-sm" placeholder="Mr No." name="mrNo" ng-model="vm.filter.mrNo"></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 form-group"><input type="text" class="form-control input-sm" placeholder="External ID..." name="externalId" ng-model="vm.filter.externalId"></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><select class="form-control input-sm" id="lvl-care" name="levelOfCare" ng-model="vm.filter.typeLevelCare" ng-options="levelCare as levelCare.name for levelCare in vm.typeLevelCares track by levelCare.id"></select></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Admission from..." name="admissionDateFrom" ng-model="vm.filter.admissionDateFrom" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.admissionDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'admissionDateFrom\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Admission to..." name="admissionDateTo" ng-model="vm.filter.admissionDateTo" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.admissionDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'admissionDateTo\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Discharge from..." name="dischargeDateFrom" ng-model="vm.filter.dischargeDateFrom" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dischargeDateFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dischargeDateFrom\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group"><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Discharge to..." name="dischargeDateTo" ng-model="vm.filter.dischargeDateTo" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dischargeDateTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dischargeDateTo\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div></form><footer class="footer"><button type="button" class="btn btn-success btn-sm" ng-click="vm.searchByFilter()"><i class="fa fa-check-circle" aria-hidden="true"></i> Apply Filter</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.clear()"><i class="fa fa-eraser" aria-hidden="true"></i> Clear Filter</button></footer></div></div><div class="filters-box"><div class="btn-group"><button type="button" class="btn btn-default" title="All Patients" ng-click="vm.filterState(null)" ng-class="{\'active\': !vm.filter.status , \'bg-green\': !vm.filter.status}"><i class="fa fa-users" aria-hidden="true"></i> <span class="hidden-sm hidden-xs">All</span></button> <button type="button" class="btn btn-default" title="Waiting Patients" ng-click="vm.filterState(\'WAITING\')" ng-class="{\'active\': vm.filter.status === \'WAITING\', \'bg-orange\': vm.filter.status === \'WAITING\'}"><i class="fa fa-hourglass-2" aria-hidden="true"></i> <span class="hidden-sm hidden-xs">Waiting</span></button> <button type="button" class="btn btn-default" title="Current Patients" ng-click="vm.filterState(\'CURRENT\')" ng-class="{\'active\': vm.filter.status === \'CURRENT\', \'bg-blue\': vm.filter.status === \'CURRENT\'}"><i class="fa fa-dashboard" aria-hidden="true"></i> <span class="hidden-sm hidden-xs">Current</span></button> <button type="button" class="btn btn-default" title="Archive" ng-click="vm.filterState(\'ARCHIVE\')" ng-class="{\'active\': vm.filter.status === \'ARCHIVE\', \'bg-gray-active\': vm.filter.status === \'ARCHIVE\'}"><i class="fa fa-archive" aria-hidden="true"></i> <span class="hidden-sm hidden-xs">Archive</span></button></div><div class="btn-group"><button type="button" class="btn btn-default" title="Create Patient" ng-click="vm.showCreatePatientPopup()"><i class="fa fa-plus-circle" aria-hidden="true"></i></button> <button type="button" class="btn btn-default" title="Print Census" ng-click="vm.getCurrentCensusPdf()"><i class="fa fa-print" aria-hidden="true"></i></button> <button type="button" class="btn btn-default hidden-xs" title="Change Grid" ng-click="vm.changeToggleLayoutState()"><i class="fa" aria-hidden="true" ng-class="{\'fa-th-list\': vm.toggleLayout == false,\n                                  \'fa-th\': vm.toggleLayout == true}"></i></button></div></div></header><div class="grid-wrapper" ng-class="{\'no-padding\': vm.toggleLayout}"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-show="vm.charts.length == 0"><div id="currentChartEmpty" class="charts-empty"><div class="empty-text"><div class="empty-search"><div class="text-center"><span class="icon"><i class="fa fa-users" aria-hidden="true"></i></span></div><p><span>Unfortunately,</span><br>there are no patients matching<br>this criteria...</p></div></div></div></div><div class="patient-card" title="See Patient Details" ng-if="!vm.toggleLayout" ng-mouseenter="enableAnim = true" ng-mouseleave="enableAnim = false" ng-class="{\'list-layout\': vm.toggleLayout === true,\n                                    \'card-layout\': vm.toggleLayout === false,\n                                    \'hover-animation\': enableAnim === true}" ui-sref="chart({id: item.id})" ui-sref-opts="{\'#\' : \'basic-info\'}" ng-repeat="item in vm.charts"><div class="icon" ng-class="{\'bg-red\': item.urgentIssues > 0,\n                                        \'bg-blue\': item.urgentIssues == 0 && item.status === \'CURRENT\',\n                                        \'bg-gray-active\': item.urgentIssues == 0 && item.status === \'ARCHIVE\',\n                                        \'bg-orange\': item.urgentIssues == 0 && item.status === \'WAITING\',\n                                        \'bg-green\': item.urgentIssues == 0 && item.status === \'CLOSED\'}"></div><div class="patient-photo"><img ng-src-auth="{{item}}"></div><div class="patient-info1"><h3 class="pname mt-0 mb-0">{{item.firstName}} {{item.lastName[0]}}.</h3></div><div class="patient-info card-grid" ng-style="item.typeLevelCare.color?{\'background-color\': \'{{ item.typeLevelCare.color }}\'}:\'\'"><div class="insurance-type"><p class="mt-0 mb-0">Payment:</p><p class="mb-0" title="{{item.typePaymentMethods.name}}">{{item.typePaymentMethods ? (item.typePaymentMethods.name.split(\' \')[0] + \' \' + item.typePaymentMethods.name.split(\' \')[1]) : \'-\'}}</p></div><div class="patient-bed"><p class="mt-0 mb-0">Mr No:</p><p class="mb-0">{{item.mrNo}}</p></div></div></div><div class="table-layout" ng-if="vm.toggleLayout"><div class="table-responsive"><table class="table table-condensed table-hover charts-table mb-0"><thead><tr><th></th><th><strong>Name:</strong></th><th><strong>Mr Number:</strong></th><th><strong>D.O.A.:</strong></th><th><strong>Level of Care:</strong></th><th><strong>Referral Source:</strong></th><th><strong>Insurance Carrier:</strong></th><th><strong>Discharge Date:</strong></th><th><strong>Discharge To:</strong></th></tr></thead><tbody><tr ng-repeat="item in vm.charts" ui-sref="chart({id: item.id})" ui-sref-opts="{\'#\' : \'basic-info\'}"><td style="padding-left: 4px; width: 80px"><div style="width: 60px" class="photo"><div class="border-status" ng-class="{\'bg-red\': item.urgentIssues > 0,\n                                                    \'bg-blue\': item.urgentIssues == 0 && item.status === \'CURRENT\',\n                                                    \'bg-gray-active\': item.urgentIssues == 0 && item.status === \'ARCHIVE\',\n                                                    \'bg-orange\': item.urgentIssues == 0 && item.status === \'WAITING\',\n                                                    \'bg-green\': item.urgentIssues == 0 && item.status === \'CLOSED\'}"></div><img ng-src-auth="{{item}}" class="img-responsive"></div></td><td class="name">{{item.firstName}} {{item.lastName}}</td><td style="width: 90px"><span>{{item.mrNo}}</span></td><td style="width: 90px"><span>{{item.admissionDate | date: inputDateFormat}}</span></td><td ng-style="item.typeLevelCare.color?{\'background-color\': \'{{ item.typeLevelCare.color }}\'}:\'\'"><span class="lvl-care">{{item.typeLevelCare.name?item.typeLevelCare.name:\'-\'}}</span></td><td><span>{{item.referrer?item.referrer:\'-\'}} / {{item.marketer | employeeName }}</span></td><td><span>{{item.primary?item.primary.insuranceCarrier.name:\'-\'}}</span></td><td><span>{{item.dischargeDate?(item.dischargeDate | date: inputDateFormat):\'-\'}}</span></td><td><span>{{item.dischargeTo ? item.dischargeTo : \'-\'}}</span></td></tr></tbody></table></div></div></div><div class="row" ng-show="vm.charts.length > 0 && vm.searchQuery == null"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.charts.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.filter.page" ng-change="vm.transition()"><ul></ul></ul></div></div></div></section>');
$templateCache.put('app/entities/chart/preview/chart-preview-dialog.html','<form name="teamCareForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.chart.firstName + \' \' + vm.chart.lastName}} - Previous Admission(s)</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 chart-preview-grid"><div class="widget-user" ng-click="vm.goToChart(item.id)" title="See Patient Details" style="cursor: pointer" ng-repeat="item in vm.charts"><div class="widget-user-image"><img class="img-circle" id="imgPicture" alt="User profile picture" ng-src-auth="{{item}}"></div><div class="widget-user-header" ng-class="{\n                    \'bg-aqua-active\': item.status === \'CURRENT\',\n                    \'bg-gray-active\': item.status === \'ARCHIVE\',\n                    \'bg-orange\': item.status === \'WAITING\'}"><h3 class="widget-user-desc"><strong>Mr No: {{item.mrNo}}</strong></h3></div><div class="box-footer"><div class="description-block"><h5 class="description-header">{{item.admissionDate | amDateFormat: amDateFormat}}</h5><span class="description-text">Admission Date</span></div><div class="description-block"><h5 class="description-header">{{item.dischargeDate | amDateFormat: amDateFormat}}</h5><span class="description-text">Discharge Date</span></div></div></div></div></div></div></form>');
$templateCache.put('app/entities/chart/select-chart/select-chart-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Select Chart</h4></div><div class="modal-body"><div class="search-input"><input type="text" class="form-control" placeholder="Search..." id="searchQuerySelectCampaign" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div><div id="select-campaign-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.selectChart()" ng-disabled="!vm.chartId"><i class="fa fa-save" aria-hidden="true"></i> Select</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/chart/tpl/basic-info-form-tpl.html','<form action="" class="edit-info" class="form" name="vm.form.basicInfo"><div class="row mb-30"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.firstName)"><label for="first-name">First Name:</label> <input type="text" class="form-control" id="first-name" name="firstName" ng-model="vm.chart.firstName" required ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.firstName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.firstName.$invalid && vm.form.basicInfo.firstName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.firstName.$error.required">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.middleName?\'\':\'has-warning\'"><label for="mid-name">Middle Name:</label> <input type="text" class="form-control" id="mid-name" name="middleName" ng-disabled="!vm.allowEditBasicInfo" ng-model="vm.chart.middleName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.middleName"></span> <span class="help-block help-warning" ng-show="!vm.chart.middleName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.lastName)"><label for="second-name">Last Name:</label> <input type="text" class="form-control" id="second-name" name="lastName" ng-model="vm.chart.lastName" required ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.lastName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.lastName.$invalid && vm.form.basicInfo.lastName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.lastName.$error.required">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.preferredName?\'\':\'has-warning\'"><label for="pref-name">Preferred Name:</label> <input type="text" class="form-control" id="pref-name" ng-model="vm.chart.preferredName" ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.preferredName"></span> <span class="help-block help-warning" ng-show="!vm.chart.preferredName">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="mrno-number">Mr No:</label> <input type="text" class="form-control" ng-model="vm.chart.mrNo" id="mrno-number" disabled="disabled"></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.social?\'\':\'has-warning\'"><label for="ssn-number">SSN:</label> <input type="text" class="form-control" id="ssn-number" ui-mask="999-99-9999" ng-model="vm.chart.social" ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.social"></span> <span class="help-block help-warning" ng-show="!vm.chart.social">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dateBirth)"><label for="dob-date">DOB:</label><div class="input-group input-group-sm"><input id="dob-date" type="text" class="form-control" name="dateBirth" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateBirth" is-open="vm.datePickerOpenStatus.dateBirth" datepicker-options="birthDateOptions" ng-disabled="!vm.allowEditBasicInfo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateBirth\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dateBirth.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dateBirth.$invalid && vm.form.basicInfo.dateBirth.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$invalid && !vm.form.basicInfo.dateBirth.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.admissionDate)"><label for="admission-date">Admission:</label><div class="input-group input-group-sm"><input type="text" id="admission-date" class="form-control" name="admissionDate" placeholder="mm/dd/yyyy Hh:mm" required datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.chart.admissionDate" is-open="vm.datePickerOpenStatus.admissionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'admissionDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.admissionDate.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.admissionDate.$invalid && vm.form.basicInfo.admissionDate.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.admissionDate.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.admissionDate.$invalid && !vm.form.basicInfo.admissionDate.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'SOBRIETY_DATE\')"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.sobrietyDate?\'\':\'has-warning\'"><label for="sobriety-date">Sobriety Date:</label><div class="input-group input-group-sm"><input id="sobriety-date" type="text" class="form-control" name="sobrietyDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.sobrietyDate" is-open="vm.datePickerOpenStatus.sobrietyDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sobrietyDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.sobrietyDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.sobrietyDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_levelCare">Level of Care:</label> <select class="form-control" id="field_levelCare" name="typeLevelCare" ng-model="vm.chart.typeLevelCare" ng-options="item as item.name for item in vm.typeLevelCare track by item.name"></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="gender-type">Gender:</label> <select class="form-control" id="gender-type" name="gender" ng-model="vm.chart.sex" ng-options="item as item for item in vm.gender track by item" ng-disabled="!vm.allowEditBasicInfo"></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'BED\')"><div class="form-group form-group-sm"><label for="field_bed">Bed:</label> <select class="form-control" id="field_bed" name="bed" ng-model="vm.chart.bed" ng-options="item as item.name for item in vm.beds track by item.id"><option value=""></option></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_allowReadmit">Allow Readmit:</label> <select class="form-control" ng-model="vm.chart.allowReadmit" id="field_allowReadmit" name="allowReadmit" ng-change="vm.clearReadmitReason()" ng-disabled="vm.chart.id == null" ng-options="(item == null ? \'\' : item  ? \'Yes\' : \'No\') for item in [null, true, false]"></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="!vm.chart.allowReadmit"><div class="form-group has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.readmitReason)"><label for="field_readmitReason">Readmit Reason</label> <textarea class="form-control" name="readmitReason" id="field_readmitReason" rows="5" data-resize="disabled" ng-model="vm.chart.readmitReason" ng-required="!vm.chart.allowReadmit"></textarea> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.readmitReason.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.readmitReason.$invalid && vm.form.basicInfo.readmitReason.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.readmitReason.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'ADMISSION_REP\')"><div class="form-group form-group-sm"><label for="field_admission_rep">Admission Rep:</label><ui-select id="field_admission_rep" name="admissionRep" reset-search-input="false" ng-model="vm.chart.admissionRep" title="Admission Rep..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Admission Rep...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.admissionReps" refresh="vm.getAdmissionReps($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.dateFirstContact?\'\':\'has-warning\'"><label for="patient-first-contact-date">Date First Contact</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="patient-first-contact-date" placeholder="mm/dd/yyyy" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateFirstContact" is-open="vm.datePickerOpenStatus.dateFirstContact"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.openCalendar(\'dateFirstContact\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.dateFirstContact"></span> <span class="help-block help-warning" ng-show="!vm.chart.dateFirstContact">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactName?\'\':\'has-warning\'"><label for="patient-first-contact">1<sup>st</sup> Contact Name:</label> <input type="text" class="form-control" id="patient-first-contact" name="firstContactName" placeholder="First Contact Name" ng-model="vm.chart.firstContactName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactName"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactName">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactRelationship?\'\':\'has-warning\'"><label for="patient-first-rel">1<sup>st</sup> Contact Relationship:</label> <input type="text" class="form-control" id="patient-first-rel" name="firstContactRel" placeholder="First Contact Relationship" ng-model="vm.chart.firstContactRelationship"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactRelationship"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactRelationship">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactPhone?\'\':\'has-warning\'"><label for="patient-first-contact-phone">1<sup>st</sup> Contact Phone:</label> <input type="text" class="form-control" id="patient-first-contact-phone" placeholder="First Contact Phone" name="firstContactPhone" ng-model="vm.chart.firstContactPhone" ui-mask="(999) 999-9999" ui-mask-placeholder> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactPhone">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.externalId?\'\':\'has-warning\'"><label for="field_externalId">External Id:</label> <input type="text" class="form-control" id="field_externalId" name="externalId" placeholder="External Id" ng-model="vm.chart.externalId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.externalId"></span> <span class="help-block help-warning" ng-show="!vm.chart.externalId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="patient-first-rel">Track:</label><ui-select name="track" id="field_track" title="Select track" ng-model="vm.chart.track" reset-search-input="true" close-on-select="true" ng-change=""><ui-select-match allow-clear="true" placeholder="Enter a track...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="track in vm.tracks | filter: $select.search" refresh="vm.filterTracks($select.search)" refresh-delay="0"><div ng-bind-html="track.name"></div></ui-select-choices></ui-select></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-9 col-sm-9 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientAddress)"><label for="patient-address-1">Address:</label> <input type="text" class="form-control" id="patient-address-1" name="patientAddress" required ng-model="vm.chart.address" value="{{vm.chart.address}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientAddress.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientAddress.$invalid && vm.form.basicInfo.patientAddress.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientAddress.$error.required">This field is required</span></div></div><div class="col-xs-3 col-sm-3 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.addressTwo?\'\':\'has-warning\'"><label for="patient-address-2">Address Two:</label> <input type="text" class="form-control" id="patient-address-2" placeholder="Street Two" ng-model="vm.chart.addressTwo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.addressTwo"></span> <span class="help-block help-warning" ng-show="!vm.chart.addressTwo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientCity)"><label for="patient-city">City:</label> <input type="text" class="form-control" id="patient-city" name="patientCity" placeholder="City" required ng-model="vm.chart.city" value="{{vm.chart.city}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientCity.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientCity.$invalid && vm.form.basicInfo.patientCity.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientCity.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.state)"><label for="field_state">State:</label> <select class="form-control" ng-model="vm.chart.countryState" ng-options="item as item.state for item in vm.states track by item.id" required id="field_state" name="state"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.state.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.state.$invalid && vm.form.basicInfo.state.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.state.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientZipCode)"><label for="patient-zip-code">Zip Code:</label> <input type="text" class="form-control" id="patient-zip-code" name="patientZipCode" required value="{{vm.chart.zip}}" ui-mask="99999" ng-model="vm.chart.zip"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientZipCode.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientZipCode.$invalid && vm.form.basicInfo.patientZipCode.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientZipCode.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.phone)"><label for="patient-phone">Phone:</label> <input type="text" class="form-control" id="patient-phone" name="phone" ui-mask="(999) 999-9999" ng-model="vm.chart.phone" required><!--                        <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"--><!--                              ng-show="!vm.chart.phone"></span>--><!--                        <span class="help-block help-warning"--><!--                              ng-show="!vm.chart.phone">This field is suggested</span>--> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.phone.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.phone.$invalid && vm.form.basicInfo.phone.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.phone.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.altPhone?\'\':\'has-warning\'"><label for="patient-alt-phone">Alt. Phone:</label> <input type="text" class="form-control" id="patient-alt-phone" ui-mask="(999) 999-9999" ng-model="vm.chart.altPhone"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.altPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.altPhone">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.email)"><label for="patient-email">Email:</label> <input type="email" class="form-control" id="patient-email" placeholder="Email" name="email" ng-model="vm.chart.email" required><!--                        <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"--><!--                              ng-show="!vm.chart.email"></span>--><!--                        <span class="help-block help-warning"--><!--                              ng-show="!vm.chart.email">This field is suggested</span>--> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.email.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.email.$invalid && vm.form.basicInfo.email.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.email.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.paymentMethod)"><label for="patient-payment-method">Payment Method:</label> <select class="form-control" id="patient-payment-method" name="paymentMethod" ng-model="vm.chart.typePaymentMethods" ng-options="item as item.name for item in vm.paymentMethod track by item.name" ng-change="vm.disableWizard()" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.paymentMethod.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.paymentMethod.$invalid && vm.form.basicInfo.paymentMethod.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.paymentMethod.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeMaritalStatus?\'\':\'has-warning\'"><label for="patient-marital-status">Marital Status:</label> <select class="form-control" id="patient-marital-status" name="maritalStatus" ng-model="vm.chart.typeMaritalStatus" ng-options="item as item.name for item in vm.maritalStatus track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeMaritalStatus"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeMaritalStatus">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeRace?\'\':\'has-warning\'"><label for="patient-race">Race:</label> <select class="form-control" id="patient-race" name="race" ng-model="vm.chart.typeRace" ng-options="item as item.name for item in vm.race track by item.name" ng-disabled="!vm.allowEditBasicInfo"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeRace"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeRace">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeEthnicity?\'\':\'has-warning\'"><label for="patient-ethnicity">Ethnicity:</label> <select class="form-control" name="ethnicity" ng-model="vm.chart.typeEthnicity" id="patient-ethnicity" ng-options="item as item.name for item in vm.ethnicity track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeEthnicity"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeEthnicity">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.referrer?\'\':\'has-warning\'"><label for="patient-referrer">Referral Source:</label> <input type="text" id="patient-referrer" placeholder="Referrer" name="referrer" ng-model="vm.chart.referrer" uib-typeahead="item.name as item.name for item in vm.getContactsFacility($viewValue)" typeahead-editable="true" typeahead-loading="loadingContacts" typeahead-no-results="noResultsReferrer" class="form-control"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.referrer"></span> <span class="help-block help-warning" ng-show="!vm.chart.referrer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.dischargeDate?\'\':\'has-warning\'"><label for="patient-discharge-date">Discharge Date:</label><div class="input-group input-group-sm"><input id="patient-discharge-date" type="text" class="form-control" name="dischargeDate" ng-model="vm.chart.dischargeDate" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dischargeDate" datepicker-options="vm.dischargeDateOptions"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.openCalendar(\'dischargeDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.dischargeDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.dischargeDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dischargeTo)"><label for="patient-discharge-to">Discharge to:</label> <input type="text" class="form-control" id="patient-discharge-to" name="dischargeTo" ng-model="vm.chart.dischargeTo" typeahead-min-length="3" uib-typeahead="item.name as item.name for item in vm.getContactsFacility($viewValue)" typeahead-editable="true" typeahead-loading="loadingContacts" typeahead-no-results="noResultsDischargeTo" class="form-control" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dischargeTo.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dischargeTo.$invalid && vm.form.basicInfo.dischargeTo.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dischargeTo.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeDischargeType?\'\':\'has-warning\'"><label for="patient-discharge-type">Discharge Type:</label> <select type="text" class="form-control" id="patient-discharge-type" ng-model="vm.chart.typeDischargeType" ng-options="item as item.name for item in vm.typeDischargeType track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeDischargeType"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeDischargeType">This field is suggested</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" ng-if="vm.checkField(\'MARKETER\')"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.marketer?\'\':\'has-warning\'"><label for="patient-marketer">Outreach:</label><ui-select id="patient-marketer" name="marketer" reset-search-input="false" ng-model="vm.chart.marketer" title="Outreach..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Outreach...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.marketer" refresh="vm.getMarketers($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.marketer"></span> <span class="help-block help-warning" ng-show="!vm.chart.marketer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.occupation)"><label for="patient-occupation">Occupation:</label> <input type="text" class="form-control" id="patient-occupation" name="occupation" ng-model="vm.chart.occupancy" value="{{vm.chart.occupancy}}" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.occupation.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.occupation.$invalid && vm.form.basicInfo.occupation.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.occupation.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employer?\'\':\'has-warning\'"><label for="patient-employer-name">Employer Name:</label> <input type="text" class="form-control" id="patient-employer-name" ng-model="vm.chart.employer" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employer"></span> <span class="help-block help-warning" ng-show="!vm.chart.employer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employerPhone?\'\':\'has-warning\'"><label for="patient-employer-phone">Employer Phone:</label> <input type="text" class="form-control" id="patient-employer-phone" ng-model="vm.chart.employerPhone" ui-mask="(999) 999-9999" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employerPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.employerPhone">This field is suggested</span></div></div></div><div class="row" ng-if="vm.facility.facilityType == \'COVID_RC\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.vessel?\'\':\'has-warning\'"><label for="vessel">Vessel:</label> <select type="text" class="form-control" id="vessel" ng-model="vm.chart.vessel" ng-options="item as item.name for item in vm.vessels track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.vessel"></span> <span class="help-block help-warning" ng-show="!vm.chart.vessel">This field is suggested</span></div><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.vesselCode?\'\':\'has-warning\'"><label for="vessel_code">Vessel Code:</label> <input type="text" class="form-control" id="vessel_code" ng-model="vm.chart.vesselCode" value="{{vm.chart.vesselCode}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.vesselCode"></span> <span class="help-block help-warning" ng-show="!vm.chart.vesselCode">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.voyageNo?\'\':\'has-warning\'"><label for="voyage_no">Voyage No:</label> <input type="text" class="form-control" id="voyage_no" ng-model="vm.chart.voyageNo" value="{{vm.chart.voyageNo}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.voyageNo"></span> <span class="help-block help-warning" ng-show="!vm.chart.voyageNo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.crewId?\'\':\'has-warning\'"><label for="cabin">Crew Id:</label> <input type="text" class="form-control" id="crewId" ng-model="vm.chart.crewId" value="{{vm.chart.crewId}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.crewId"></span> <span class="help-block help-warning" ng-show="!vm.chart.crewId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.cabin?\'\':\'has-warning\'"><label for="cabin">Cabin:</label> <input type="text" class="form-control" id="cabin" ng-model="vm.chart.cabin" value="{{vm.chart.cabin}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.cabin"></span> <span class="help-block help-warning" ng-show="!vm.chart.cabin">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.passengerId?\'\':\'has-warning\'"><label for="cabin">Passenger Id:</label> <input type="text" class="form-control" id="passengerId" ng-model="vm.chart.passengerId" value="{{vm.chart.passengerId}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.passengerId"></span> <span class="help-block help-warning" ng-show="!vm.chart.passengerId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.sailingDate?\'\':\'has-warning\'"><label for="sailingDate">Sailing Date:</label><div class="input-group input-group-sm"><input id="sailingDate" type="text" class="form-control" name="sailingDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.sailingDate" is-open="vm.datePickerOpenStatus.sailingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sailingDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.sailingDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.sailingDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.port?\'\':\'has-warning\'"><label for="port">Port:</label> <select type="text" class="form-control" id="port" ng-model="vm.chart.port" ng-options="item as item.name for item in vm.ports track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.port"></span> <span class="help-block help-warning" ng-show="!vm.chart.port">This field is suggested</span></div></div></div><!-- /row --></div></div><!-- /row --></form>');
$templateCache.put('app/entities/chart/update/basic-info-form-tpl.html','<form action="" class="edit-info" class="form" name="vm.form.basicInfo"><div class="row mb-30"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.firstName)"><label for="first-name">First Name:</label>{{vm.form.basicInfo.firstName.$error.maxlength}} <input type="text" class="form-control" id="first-name" name="firstName" ng-model="vm.chart.firstName" required ng-disabled="!vm.allowEditBasicInfo" ng-maxlength="35"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.firstName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.firstName.$invalid && vm.form.basicInfo.firstName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.firstName.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.firstName.$error.maxlength">Max length 35 characters</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.middleName?\'\':\'has-warning\'"><label for="mid-name">Middle Name:</label> <input type="text" class="form-control" id="mid-name" name="middleName" ng-disabled="!vm.allowEditBasicInfo" ng-model="vm.chart.middleName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.middleName"></span> <span class="help-block help-warning" ng-show="!vm.chart.middleName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.lastName)"><label for="second-name">Last Name:</label> <input type="text" class="form-control" id="second-name" name="lastName" ng-model="vm.chart.lastName" required ng-disabled="!vm.allowEditBasicInfo" ng-maxlength="35"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.lastName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.lastName.$invalid && vm.form.basicInfo.lastName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.lastName.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.lastName.$error.maxlength">Max length 35 characters</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.preferredName?\'\':\'has-warning\'"><label for="pref-name">Preferred Name:</label> <input type="text" class="form-control" id="pref-name" ng-model="vm.chart.preferredName" ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.preferredName"></span> <span class="help-block help-warning" ng-show="!vm.chart.preferredName">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="mrno-number">Mr No:</label> <input type="text" class="form-control" ng-model="vm.chart.mrNo" id="mrno-number" disabled="disabled"></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.social?\'\':\'has-warning\'"><label for="ssn-number">SSN:</label> <input type="text" class="form-control" id="ssn-number" ui-mask="999-99-9999" ng-model="vm.chart.social" ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.social"></span> <span class="help-block help-warning" ng-show="!vm.chart.social">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dateBirth)"><label for="dob-date">DOB:</label><!--<input type="text" class="form-control" value="{{vm.chart.dateBirth | date:\'MM/dd/yyyy\'}}" id="dob-date">--><div class="input-group input-group-sm"><input id="dob-date" type="text" class="form-control" name="dateBirth" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateBirth" is-open="vm.datePickerOpenStatus.dateBirth" datepicker-options="birthDateOptions" ng-disabled="!vm.allowEditBasicInfo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateBirth\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dateBirth.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dateBirth.$invalid && vm.form.basicInfo.dateBirth.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$invalid && !vm.form.basicInfo.dateBirth.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.admissionDate)"><label for="admission-date">Admission:</label><div class="input-group input-group-sm"><input type="text" id="admission-date" class="form-control" name="admissionDate" placeholder="mm/dd/yyyy Hh:mm" required datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.chart.admissionDate" is-open="vm.datePickerOpenStatus.admissionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'admissionDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.admissionDate.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.admissionDate.$invalid && vm.form.basicInfo.admissionDate.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.admissionDate.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.admissionDate.$invalid && !vm.form.basicInfo.admissionDate.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'SOBRIETY_DATE\')"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.sobrietyDate?\'\':\'has-warning\'"><label for="sobriety-date">Sobriety Date:</label><div class="input-group input-group-sm"><input id="sobriety-date" type="text" class="form-control" name="sobrietyDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.sobrietyDate" is-open="vm.datePickerOpenStatus.sobrietyDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sobrietyDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.sobrietyDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.sobrietyDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_levelCare">Level of Care:</label> <select class="form-control" id="field_levelCare" name="typeLevelCare" ng-model="vm.chart.typeLevelCare" ng-options="item as item.name for item in vm.typeLevelCare track by item.name"></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="gender-type">Gender:</label> <select class="form-control" id="gender-type" name="gender" ng-model="vm.chart.sex" ng-options="item as item for item in vm.gender track by item" ng-disabled="!vm.allowEditBasicInfo"></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'BED\')"><div class="form-group form-group-sm"><label for="field_bed">Bed:</label> <select class="form-control" id="field_bed" name="bed" ng-model="vm.chart.bed" ng-options="item as item.name for item in vm.beds track by item.id"><option value=""></option></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_allowReadmit">Allow Readmit:</label> <select class="form-control" ng-model="vm.chart.allowReadmit" id="field_allowReadmit" name="allowReadmit" ng-change="vm.clearReadmitReason()" ng-disabled="vm.chart.id == null" ng-options="(item == null ? \'\' : item  ? \'Yes\' : \'No\') for item in [null, true, false]"></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="!vm.chart.allowReadmit"><div class="form-group has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.readmitReason)"><label for="field_readmitReason">Readmit Reason</label> <textarea class="form-control" name="readmitReason" id="field_readmitReason" rows="5" data-resize="disabled" ng-model="vm.chart.readmitReason" ng-required="!vm.chart.allowReadmit"></textarea> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.readmitReason.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.readmitReason.$invalid && vm.form.basicInfo.readmitReason.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.readmitReason.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'ADMISSION_REP\')"><div class="form-group form-group-sm"><label for="field_admission_rep">Admission Rep:</label><ui-select id="field_admission_rep" name="admissionRep" reset-search-input="false" ng-model="vm.chart.admissionRep" title="Admission Rep..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Admission Rep...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.admissionReps" refresh="vm.getAdmissionReps($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.dateFirstContact?\'\':\'has-warning\'"><label for="patient-first-contact-date">Date First Contact</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="patient-first-contact-date" placeholder="mm/dd/yyyy" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateFirstContact" is-open="vm.datePickerOpenStatus.dateFirstContact"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.openCalendar(\'dateFirstContact\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.dateFirstContact"></span> <span class="help-block help-warning" ng-show="!vm.chart.dateFirstContact">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactName?\'\':\'has-warning\'"><label for="patient-first-contact">1<sup>st</sup> Contact Name:</label> <input type="text" class="form-control" id="patient-first-contact" name="firstContactName" placeholder="First Contact Name" ng-model="vm.chart.firstContactName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactName"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactName">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactRelationship?\'\':\'has-warning\'"><label for="patient-first-rel">1<sup>st</sup> Contact Relationship:</label> <input type="text" class="form-control" id="patient-first-rel" name="firstContactRel" placeholder="First Contact Relationship" ng-model="vm.chart.firstContactRelationship"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactRelationship"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactRelationship">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactPhone?\'\':\'has-warning\'"><label for="patient-first-contact-phone">1<sup>st</sup> Contact Phone:</label> <input type="text" class="form-control" id="patient-first-contact-phone" placeholder="First Contact Phone" name="firstContactPhone" ng-model="vm.chart.firstContactPhone" ui-mask="(999) 999-9999" ui-mask-placeholder> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactPhone">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.externalId?\'\':\'has-warning\'"><label for="field_externalId">External Id:</label> <input type="text" class="form-control" id="field_externalId" name="externalId" placeholder="External Id" ng-model="vm.chart.externalId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.externalId"></span> <span class="help-block help-warning" ng-show="!vm.chart.externalId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="patient-first-rel">Track:</label><ui-select name="track" id="field_track" title="Select track" ng-model="vm.chart.track" reset-search-input="true" close-on-select="true" ng-change=""><ui-select-match allow-clear="true" placeholder="Enter a track...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="track in vm.tracks | filter: $select.search" refresh="vm.filterTracks($select.search)" refresh-delay="0"><div ng-bind-html="track.name"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.defaultPharmacy ? (vm.form.defaultPharmacy.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="field_pharmacy">Pharmacy</label><ui-select name="pharmacy" id="field_pharmacy" title="pharmacy" ng-model="vm.chart.defaultPharmacy" reset-search-input="false" ng-model-options="{ debounce: 500 }"><ui-select-match placeholder="Pharmacy...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.pharmacies" refresh="vm.getPharmacies($select.search)" refresh-delay="0"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-9 col-sm-9 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientAddress)"><label for="patient-address-1">Address:</label> <input type="text" class="form-control" id="patient-address-1" name="patientAddress" required ng-model="vm.chart.address" value="{{vm.chart.address}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientAddress.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientAddress.$invalid && vm.form.basicInfo.patientAddress.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientAddress.$error.required">This field is required</span></div></div><div class="col-xs-3 col-sm-3 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.addressTwo?\'\':\'has-warning\'"><label for="patient-address-2">Address Two:</label> <input type="text" class="form-control" id="patient-address-2" placeholder="Street Two" ng-model="vm.chart.addressTwo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.addressTwo"></span> <span class="help-block help-warning" ng-show="!vm.chart.addressTwo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientCity)"><label for="patient-city">City:</label> <input type="text" class="form-control" id="patient-city" name="patientCity" placeholder="City" required ng-model="vm.chart.city" value="{{vm.chart.city}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientCity.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientCity.$invalid && vm.form.basicInfo.patientCity.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientCity.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.state)"><label for="field_state">State:</label> <select class="form-control" ng-model="vm.chart.countryState" ng-options="item as item.state for item in vm.states track by item.id" required id="field_state" name="state"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.state.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.state.$invalid && vm.form.basicInfo.state.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.state.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientZipCode)"><label for="patient-zip-code">Zip Code:</label> <input type="text" class="form-control" id="patient-zip-code" name="patientZipCode" required value="{{vm.chart.zip}}" ui-mask="99999" ng-model="vm.chart.zip"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientZipCode.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientZipCode.$invalid && vm.form.basicInfo.patientZipCode.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientZipCode.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.phone)"><label for="patient-phone">Phone:</label> <input type="text" class="form-control" id="patient-phone" name="phone" ui-mask="(999) 999-9999" ng-model="vm.chart.phone" required><!--                        <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"--><!--                              ng-show="!vm.chart.phone"></span>--><!--                        <span class="help-block help-warning"--><!--                              ng-show="!vm.chart.phone">This field is suggested</span>--> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.phone.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.phone.$invalid && vm.form.basicInfo.phone.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.phone.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.altPhone?\'\':\'has-warning\'"><label for="patient-alt-phone">Alt. Phone:</label> <input type="text" class="form-control" id="patient-alt-phone" ui-mask="(999) 999-9999" ng-model="vm.chart.altPhone"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.altPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.altPhone">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.email)"><label for="patient-email">Email:</label> <input type="email" class="form-control" id="patient-email" placeholder="Email" name="email" ng-model="vm.chart.email" required><!--                        <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"--><!--                              ng-show="!vm.chart.email"></span>--><!--                        <span class="help-block help-warning"--><!--                              ng-show="!vm.chart.email">This field is suggested</span>--> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.email.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.email.$invalid && vm.form.basicInfo.email.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.email.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.paymentMethod)"><label for="patient-payment-method">Payment Method:</label> <select class="form-control" id="patient-payment-method" name="paymentMethod" ng-model="vm.chart.typePaymentMethods" ng-options="item as item.name for item in vm.paymentMethod track by item.name" ng-change="vm.disableWizard()" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.paymentMethod.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.paymentMethod.$invalid && vm.form.basicInfo.paymentMethod.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.paymentMethod.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeMaritalStatus?\'\':\'has-warning\'"><label for="patient-marital-status">Marital Status:</label> <select class="form-control" id="patient-marital-status" name="maritalStatus" ng-model="vm.chart.typeMaritalStatus" ng-options="item as item.name for item in vm.maritalStatus track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeMaritalStatus"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeMaritalStatus">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeRace?\'\':\'has-warning\'"><label for="patient-race">Race:</label> <select class="form-control" id="patient-race" name="race" ng-model="vm.chart.typeRace" ng-options="item as item.name for item in vm.race track by item.name" ng-disabled="!vm.allowEditBasicInfo"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeRace"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeRace">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeEthnicity?\'\':\'has-warning\'"><label for="patient-ethnicity">Ethnicity:</label> <select class="form-control" name="ethnicity" ng-model="vm.chart.typeEthnicity" id="patient-ethnicity" ng-options="item as item.name for item in vm.ethnicity track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeEthnicity"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeEthnicity">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.referrer?\'\':\'has-warning\'"><label for="patient-referrer">Referral Source:</label> <input type="text" id="patient-referrer" placeholder="Referrer" name="referrer" ng-model="vm.chart.referrer" uib-typeahead="item.name as item.name for item in vm.getContactsFacility($viewValue)" typeahead-editable="true" typeahead-loading="loadingContacts" typeahead-no-results="noResultsReferrer" class="form-control"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.referrer"></span> <span class="help-block help-warning" ng-show="!vm.chart.referrer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.dischargeDate?\'\':\'has-warning\'"><label for="patient-discharge-date">Discharge Date:</label><div class="input-group input-group-sm"><input id="patient-discharge-date" type="text" class="form-control" name="dischargeDate" ng-model="vm.chart.dischargeDate" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dischargeDate" datepicker-options="vm.dischargeDateOptions"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.openCalendar(\'dischargeDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.dischargeDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.dischargeDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dischargeTo)"><label for="patient-discharge-to">Discharge to:</label> <input type="text" class="form-control" id="patient-discharge-to" name="dischargeTo" ng-model="vm.chart.dischargeTo" typeahead-min-length="3" uib-typeahead="item.name as item.name for item in vm.getContactsFacility($viewValue)" typeahead-editable="true" typeahead-loading="loadingContacts" typeahead-no-results="noResultsDischargeTo" class="form-control" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dischargeTo.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dischargeTo.$invalid && vm.form.basicInfo.dischargeTo.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dischargeTo.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeDischargeType?\'\':\'has-warning\'"><label for="patient-discharge-type">Discharge Type:</label> <select type="text" class="form-control" id="patient-discharge-type" ng-model="vm.chart.typeDischargeType" ng-options="item as item.name for item in vm.typeDischargeType track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeDischargeType"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeDischargeType">This field is suggested</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" ng-if="vm.checkField(\'MARKETER\')"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.marketer?\'\':\'has-warning\'"><label for="patient-marketer">Outreach:</label><ui-select id="patient-marketer" name="marketer" reset-search-input="false" ng-model="vm.chart.marketer" title="Outreach..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Outreach...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.marketer" refresh="vm.getMarketers($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.marketer"></span> <span class="help-block help-warning" ng-show="!vm.chart.marketer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.occupation)"><label for="patient-occupation">Occupation:</label> <input type="text" class="form-control" id="patient-occupation" name="occupation" ng-model="vm.chart.occupancy" value="{{vm.chart.occupancy}}" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.occupation.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.occupation.$invalid && vm.form.basicInfo.occupation.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.occupation.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employer?\'\':\'has-warning\'"><label for="patient-employer-name">Employer Name:</label> <input type="text" class="form-control" id="patient-employer-name" ng-model="vm.chart.employer" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employer"></span> <span class="help-block help-warning" ng-show="!vm.chart.employer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employerPhone?\'\':\'has-warning\'"><label for="patient-employer-phone">Employer Phone:</label> <input type="text" class="form-control" id="patient-employer-phone" ng-model="vm.chart.employerPhone" ui-mask="(999) 999-9999" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employerPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.employerPhone">This field is suggested</span></div></div></div><div class="row" ng-if="vm.facility.facilityType == \'COVID_RC\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.vessel?\'\':\'has-warning\'"><label for="vessel">Vessel:</label> <select type="text" class="form-control" id="vessel" ng-model="vm.chart.vessel" ng-options="item as item.name for item in vm.vessels track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.vessel"></span> <span class="help-block help-warning" ng-show="!vm.chart.vessel">This field is suggested</span></div><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.vesselCode?\'\':\'has-warning\'"><label for="vessel_code">Vessel Code:</label> <input type="text" class="form-control" id="vessel_code" ng-model="vm.chart.vesselCode" value="{{vm.chart.vesselCode}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.vesselCode"></span> <span class="help-block help-warning" ng-show="!vm.chart.vesselCode">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.voyageNo?\'\':\'has-warning\'"><label for="voyage_no">Voyage No:</label> <input type="text" class="form-control" id="voyage_no" ng-model="vm.chart.voyageNo" value="{{vm.chart.voyageNo}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.voyageNo"></span> <span class="help-block help-warning" ng-show="!vm.chart.voyageNo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.crewId?\'\':\'has-warning\'"><label for="cabin">Crew Id:</label> <input type="text" class="form-control" id="crewId" ng-model="vm.chart.crewId" value="{{vm.chart.crewId}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.crewId"></span> <span class="help-block help-warning" ng-show="!vm.chart.crewId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.cabin?\'\':\'has-warning\'"><label for="cabin">Cabin:</label> <input type="text" class="form-control" id="cabin" ng-model="vm.chart.cabin" value="{{vm.chart.cabin}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.cabin"></span> <span class="help-block help-warning" ng-show="!vm.chart.cabin">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.passengerId?\'\':\'has-warning\'"><label for="cabin">Passenger Id:</label> <input type="text" class="form-control" id="passengerId" ng-model="vm.chart.passengerId" value="{{vm.chart.passengerId}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.passengerId"></span> <span class="help-block help-warning" ng-show="!vm.chart.passengerId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.sailingDate?\'\':\'has-warning\'"><label for="sailingDate">Sailing Date:</label><div class="input-group input-group-sm"><input id="sailingDate" type="text" class="form-control" name="sailingDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.sailingDate" is-open="vm.datePickerOpenStatus.sailingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sailingDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.sailingDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.sailingDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.port?\'\':\'has-warning\'"><label for="port">Port:</label> <select type="text" class="form-control" id="port" ng-model="vm.chart.port" ng-options="item as item.name for item in vm.ports track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.port"></span> <span class="help-block help-warning" ng-show="!vm.chart.port">This field is suggested</span></div></div></div><!-- /row --></div></div><!-- /row --></form>');
$templateCache.put('app/entities/chart/update/chart-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Edit Patient Info</h4></div><div class="modal-body"><ng-include src="\'app/entities/chart/update/basic-info-form-tpl.html\'"></ng-include></div><div class="modal-footer"><button class="btn btn-success" type="button" ng-click="vm.save()" ng-disabled="vm.form.basicInfo.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button class="btn btn-danger" type="button" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/chart-blocked/list/chart-blocked.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart-blocked/update/chart-blocked-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myChartBlockedLabel">Create or edit a Chart Blocked</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.chartBlocked.employee?(vm.chartBlocked.employee.$valid && vm.chartBlocked.employee.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_employee">Employee</label><ui-select id="field_employee" name="employee" reset-search-input="false" ng-disabled="vm.chartBlocked.id" ng-model="vm.chartBlocked.employee" title="Employee..." ng-required="true"><ui-select-match allow-clear="true" placeholder="Select Employee...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chartBlocked.employee"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chartBlocked.employee && vm.chartBlocked.employee.$dirty"></span> <span class="help-block" ng-show="!vm.chartBlocked.employee">This field is required</span></div><div class="form-group form-group-sm has-feedback" ng-class="vm.chartBlocked.charts && vm.chartBlocked.charts.length>0?\'has-success\':\'has-error\'"><label for="field_charts">Charts</label><ui-select ng-model="vm.chartBlocked.charts" name="charts" id="field_charts" title="Select chart" required close-on-select="false" ng-model-options="{ debounce: 500 }" multiple="multiple"><ui-select-match placeholder="Select chart..."><div ng-bind-html="$item.firstName + \' \' + $item.lastName | highlight: $select.search"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + ($item.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + $item.mrNo"></small></ui-select-match><ui-select-choices repeat="chart in vm.charts | filter: $select.search" refresh="vm.getCharts($select.search)" refresh-delay="0"><div ng-bind-html="chart.firstName + \' \' + chart.lastName | highlight: $select.search"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + (chart.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + chart.mrNo"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chartBlocked.charts.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chartBlocked.charts && vm.chartBlocked.charts.length>0"></span> <span class="help-block" ng-show="!vm.chartBlocked.charts.length > 0">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/chart-care-team/history/chart-care-team-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Care Team History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Speciality</strong></th><th><strong>Employee</strong></th></tr></thead><tbody><tr ng-repeat="careTeam in vm.careTeams"><td>{{ careTeam.typeSpeciality.name }}</td><td>{{ careTeam.employee | employeeName }}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/chart-care-team/update/chart-care-team-dialog.html','<form name="teamCareForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Add or Edit Care Team</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><div class="row"><div class="col-xs-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.charCareTeam.typeSpeciality?\'\':\'has-error\'"><label for="field_care_form_careTeamSpeciality">Care Team Speciality:</label><ui-select name="careFormCareTeamSpeciality" title="Care Team Employee" id="field_care_form_careTeamSpeciality" ng-required="true" ng-model="vm.charCareTeam.typeSpeciality"><ui-select-match placeholder="Enter Type Speciality">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="typeSpeciality in vm.typeSpecialities | filter: $select.search">{{typeSpeciality.name}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="teamCareForm.careFormCareTeamSpeciality.$error.required"></span> <span class="help-block" ng-show="teamCareForm.careFormCareTeamSpeciality.$error.required">This field is required</span></div><div class="form-group form-group-sm has-feedback" ng-class="vm.charCareTeam.employee?\'\':\'has-error\'"><label for="field_care_form_careTeamEmployee">Care Team Employee</label><ui-select ng-model="vm.charCareTeam.employee" name="care_form_Employee" ng-required="true" title="Care Team Employee" id="field_care_form_careTeamEmployee" ng-disabled="vm.charCareTeam.id"><ui-select-match placeholder="Enter the employee name...">{{($select.selected.firstName + \' \' + $select.selected.lastName)}}</ui-select-match><ui-select-choices repeat="employee in vm.careEmployees" refresh="vm.getCareTeamEmployee($select.search)" refresh-delay="0">{{(employee.firstName + \' \' + employee.lastName)}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="teamCareForm.care_form_Employee.$error.required"></span> <span class="help-block" ng-show="teamCareForm.care_form_Employee.$error.required">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.charCareTeam.startDate?(teamCareForm.startDate.$dirty && teamCareForm.startDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.charCareTeam.startDate" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.charCareTeam.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.charCareTeam.startDate && teamCareForm.startDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.charCareTeam.startDate || teamCareForm.startDate.$invalid">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.charCareTeam.endDate?(teamCareForm.endDate.$dirty && teamCareForm.endDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_end_date">End Date</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.charCareTeam.endDate" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.charCareTeam.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.charCareTeam.endDate && teamCareForm.endDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.charCareTeam.endDate || teamCareForm.endDate.$invalid">This field is suggested</span></div></div></div></div></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.charCareTeam.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" class="btn btn-success" ng-disabled="vm.chart.status === \'CLOSED\' || teamCareForm.$invalid || teamCareForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Care Team from this patient\'s record. Are you sure you want to <strong>delete</strong> this Care Team?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/chart-export-file/list/chart-export-files.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/chart-file/update/chart-file-dialog.html','<form name="editForm" role="form" novalidate><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myChartFileLabel">Create a Chart File</h4></div><div class="modal-body"><h2 class="step-header">Attach Files</h2><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="custom-file-upload"><div class="input-wrapper"><label for="fileUploads"><i class="fa fa-paperclip" aria-hidden="true"></i> Choose files... <input type="file" id="fileUploads" ngf-select multiple="multiple" ngf-change="vm.attachFile($files)" accept="image/png, image/jpeg , .txt, .pdf"></label></div></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/chart-note/history/chart-note-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myChartNoteLabel">Notes History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Note</strong></th><th><strong>Employee</strong></th><th><strong>Date</strong></th><th><strong>Deleted By</strong></th></tr></thead><tbody><tr ng-repeat="note in vm.notes"><td>{{note.note}}</td><td>{{note.employee.firstName + \' \' + note.employee.lastName}}</td><td>{{note.date | amDateFormat: amDateFormat}}</td><td>{{note.deletedBy.firstName + \' \' + note.deletedBy.lastName}}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/chart-note/update/chart-note-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myChartNoteLabel">Create or edit a Chart Note</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="!vm.chartNote.note || editForm.note.$error.required?\'has-error\':(editForm.note.$valid && editForm.note.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_note">Note:</label> <textarea rows="5" class="form-control" name="note" id="field_note" required data-resize="disabled" ng-model="vm.chartNote.note"></textarea> <span class="help-block" ng-show="!vm.chartNote.note || editForm.note.$error.required">This field is required.</span></div></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.chartNote.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" class="btn btn-success" ng-disabled="vm.chart.status === \'CLOSED\' || editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Note from this patient\'s record. Are you sure you want to <strong>delete</strong> this Note?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/chart-status-history/chart-new/chart-status-histories-dialog-close-new.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="reopenChart">Close Chart</h4></div><div class="modal-body"><div class="mb-15" ng-if="!vm.chartStatusHistory.chart.dischargeDate || vm.chartStatusHistory.chart.dischargeDate >= vm.date"><p class="text-center mt-15 mb-15">Discharge date adjusted to {{vm.date | amDateFormat: amDateFormat}}</p></div><div class="mb-15" ng-if="vm.chartStatusHistory.chart.dischargeDate && vm.chartStatusHistory.chart.dischargeDate < vm.date"><p class="mb-10">The current discharge date is: <strong>{{vm.chartStatusHistory.chart.dischargeDate | amDateFormat: amDateFormat}}</strong>. Do you want to adjust it?</p><p>New discharge date:</p><div class="radio"><label><input type="radio" name="optionRadio" ng-model="vm.current" ng-value="true"> Change to Now.</label></div><div class="radio"><label><input type="radio" name="optionRadio" ng-model="vm.current" ng-value="false"> Keep Discharge Date.</label></div></div><div class="text-center"><button type="button" class="btn btn-success btn-sm" ng-click="vm.save()"><i class="fa fa-check" aria-hidden="true"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/chart-status-history/chart-new/chart-status-histories-dialog-current-new.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="reopenChart">Convert To "Current"</h4></div><div class="modal-body"><div class="mb-15"><p class="text-center mt-15 mb-15">Are you sure would you like to convert this patient?</p></div><div class="text-center"><button type="button" class="btn btn-success btn-sm" ng-click="vm.save()"><i class="fa fa-check" aria-hidden="true"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/chart-status-history/chart-new/chart-status-histories-dialog-reopen-new.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="reopenChart">Reopen Chart</h4></div><div class="modal-body"><div class="mb-15"><p class="text-left mt-15">Comments:</p><textarea class="form-control mb-10" data-resize="disabled" rows="5" ng-model="vm.chartStatusHistory.description"></textarea></div><div class="text-center"><button type="button" class="btn btn-success btn-sm" ng-click="vm.save()"><i class="fa fa-check" aria-hidden="true"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/compendium-report-group/list/compendium-report-group.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/compendium-report-group/update/compendium-report-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySpecimeLabel">Create or edit a Compendium Report Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reportGroup.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.reportGroup.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.reportGroup.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.reportGroup.name"> <span class="help-block" ng-show="!vm.reportGroup.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/concurrent-review-frequency/list/concurrent-review-frequency.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/concurrent-review-frequency/update/concurrent-review-frequency-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myConcurrentReviewFrequencyLabel">Create or edit a Concurrent Review Frequency</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm" ng-show="vm.concurrentReviewFrequency.id"><label for="id">ID:</label> <input type="text" class="form-control" id="id" name="id" readonly="readonly" ng-model="vm.concurrentReviewFrequency.id"></div><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviewFrequency.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.concurrentReviewFrequency.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.concurrentReviewFrequency.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.concurrentReviewFrequency.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviewFrequency.name">This field is required</span></div><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviewFrequency.days2.length > 0?\'has-success\':\'has-error\'"><label for="field_day2">Days of the week:</label><ui-select id="field_day2" name="day2" multiple="multiple" title="Days of the week" required ng-model="vm.concurrentReviewFrequency.days2" close-on-select="false"><ui-select-match placeholder="Select Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search">{{day}}</ui-select-choices></ui-select><span class="help-block" aria-hidden="true" ng-show="!vm.concurrentReviewFrequency.days2 || vm.concurrentReviewFrequency.days2.length == 0">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/concurrent-reviews/dashboard/concurrent-reviews.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/concurrent-reviews/update/concurrent-reviews-dialog.html','<form name="concurrentReviewsForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Add Concurrent Review</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.startDate?(concurrentReviewsForm.startDate.$dirty && concurrentReviewsForm.startDate.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_startDate">Start Date:</label><div class="input-group input-group-sm" style="width: 100%"><input id="field_startDate" type="text" class="form-control" name="startDate" datepicker-options="vm.startOptions" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.concurrentReviews.startDate" is-open="vm.datePickerOpenStatus.startDate" ng-change="vm.changeStartDate()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.startDate && concurrentReviewsForm.startDate.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviews.startDate || concurrentReviewsForm.startDate.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.endDate?(concurrentReviewsForm.endDate.$dirty && concurrentReviewsForm.endDate.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_endDate">End Date:</label><div class="input-group input-group-sm"><input id="field_endDate" type="text" class="form-control" name="endDate" datepicker-options="vm.endOptions" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.concurrentReviews.endDate" is-open="vm.datePickerOpenStatus.endDate" ng-change="vm.changeEndDate()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.endDate && concurrentReviewsForm.endDate.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviews.endDate || concurrentReviewsForm.endDate.$invalid">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.concurrentReviewFrequency?\'\':\'has-error\'"><label for="field_frequency">Frequency:</label><ui-select name="frequency" title="Frequency" id="field_frequency" required ng-change="vm.updateDays()" ng-model="vm.concurrentReviews.concurrentReviewFrequency"><ui-select-match placeholder="Select frequency">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.frequencies">{{item.name}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.concurrentReviewFrequency"></span> <span class="help-block" ng-show="!vm.concurrentReviews.concurrentReviewFrequency">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.numberDates?(concurrentReviewsForm.numberDates.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_numberDates">Number Dates:</label> <input type="number" class="form-control" name="numberDates" id="field_numberDates" min="0" ng-model="vm.concurrentReviews.numberDates"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.numberDates"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.numberDates && concurrentReviewsForm.numberDates.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviews.numberDates">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.careManager?(concurrentReviewsForm.care_manager.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_care_manager">Care Manager:</label> <input type="text" class="form-control" id="field_care_manager" name="care_manager" required ng-model="vm.concurrentReviews.careManager"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.careManager"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.careManager && concurrentReviewsForm.care_manager.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviews.careManager">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.careManagerPhone?(concurrentReviewsForm.care_manager_phone.$dirty && concurrentReviewsForm.care_manager_phone.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_care_manager_phone">Care Manager Phone:</label> <input type="text" class="form-control" id="field_care_manager_phone" placeholder="Care Manager Phone" name="care_manager_phone" ng-model="vm.concurrentReviews.careManagerPhone" ui-mask="(999) 999-9999" ui-mask-placeholder> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.careManagerPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.careManagerPhone && concurrentReviewsForm.care_manager_phone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.concurrentReviews.careManagerPhone">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.insurance?\'\':\'has-error\'"><label for="field_insurance">Patient Insurance:</label><ui-select name="field_insurance" title="Patient Insurance" id="field_insurance" required ng-required="true" ng-model="vm.concurrentReviews.insurance"><ui-select-match placeholder="Select patient insurance">{{$select.selected.insuranceCarrier.name}}</ui-select-match><ui-select-choices repeat="item in vm.insurances">{{item.insuranceCarrier.name}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.insurance"></span> <span class="help-block" ng-show="!vm.concurrentReviews.insurance">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.typeLevelCare?(concurrentReviewsForm.typeLevelCare.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_typeLevelCare">Level of Care:</label> <select class="form-control" id="field_typeLevelCare" name="typeLevelCare" ng-model="vm.concurrentReviews.typeLevelCare" ng-options="item.name for item in vm.typeLevelCares track by item.id"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.typeLevelCare"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.typeLevelCare && concurrentReviewsForm.typeLevelCare.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviews.typeLevelCare">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.authorizationNumber?(concurrentReviewsForm.authorizationNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_authorizationNumber">Authorization Number:</label> <input type="text" class="form-control" name="authorizationNumber" id="field_authorizationNumber" ng-model="vm.concurrentReviews.authorizationNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.authorizationNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.authorizationNumber && concurrentReviewsForm.authorizationNumber.$dirty"></span> <span class="help-block" ng-show="!vm.concurrentReviews.authorizationNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.authorizationDate?(concurrentReviewsForm.authorizationDate.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_authorizationDate">Authorization Date:</label><div class="input-group input-group-sm"><input id="field_authorizationDate" type="text" class="form-control" name="authorizationDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.concurrentReviews.authorizationDate" is-open="vm.datePickerOpenStatus.authorizationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'authorizationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.authorizationDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.authorizationDate && concurrentReviewsForm.authorizationDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.concurrentReviews.authorizationDate">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.nextReviewDate?(concurrentReviewsForm.nextReviewDate.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_nextReviewDate">Next Review Date:</label><div class="input-group input-group-sm"><input id="field_nextReviewDate" type="text" class="form-control" name="nextReviewDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.concurrentReviews.nextReviewDate" is-open="vm.datePickerOpenStatus.nextReviewDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'nextReviewDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.concurrentReviews.nextReviewDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.concurrentReviews.nextReviewDate && concurrentReviewsForm.nextReviewDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.concurrentReviews.nextReviewDate">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_show_in_mars">Last Date of Coverage:</label><br><toggle id="field_show_in_mars" ng-model="vm.concurrentReviews.lastCoverageDate" on="Yes" off="No" size="btn-sm" onstyle="btn-success" ng-disabled="vm.chart.status == \'CLOSED\'" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.concurrentReviews.notes?(concurrentReviewsForm.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Notes:</label> <textarea type="text" class="form-control" name="notes" id="field_notes" rows="4" data-resize="disabled" ng-model="vm.concurrentReviews.notes">\n                    </textarea> <span class="help-block help-warning" ng-show="!vm.concurrentReviews.notes">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_notes">Status:</label> <select class="form-control" name="sort" ng-model="vm.concurrentReviews.status" id="field_sort"><option value="NEW">NEW</option><option value="PENDING">PENDING</option><option value="APPROVED">APPROVED</option><option value="DENIED">DENIED</option></select></div></div></div></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.concurrentReviews.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" class="btn btn-primary btn-success" ng-click="vm.save()" validation-submit="concurrentReviewsForm" ng-disabled="vm.chart.status === \'CLOSED\' || concurrentReviewsForm.$error.required"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Concurrent Review from this patient\'s record. Are you sure you want to <strong>delete</strong> this Concurrent Review?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/contact-address/list/contact-address.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/contact-address/pickup/contact-address-pickup-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="modal-icon"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div><h4 class="modal-title" id="myVitalsLabel">Fax Patient Order Medication</h4></div><div class="modal-body"><div id="urgent-issues-dtable"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.select()" ng-disabled="vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Fax to</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/contact-address/update/contact-address-dialog.html','<form name="editForm" role="form" validate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myContactAddressLabel">Create or edit a Contact Address</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.contactAddress.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.contactAddress.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactAddress.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactAddress.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.contactAddress.name">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_alias">Alias</label> <input type="text" class="form-control" name="alias" id="field_alias" ng-model="vm.contactAddress.alias"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_company">Company</label> <input type="text" class="form-control" name="company" id="field_company" ng-model="vm.contactAddress.company"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_cellphone">Cellphone</label> <input type="text" class="form-control" name="cellphone" id="field_cellphone" ui-mask="999-999-9999" ng-model="vm.contactAddress.cellphone"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_address">Address</label> <input type="text" class="form-control" name="address" id="field_address" ng-model="vm.contactAddress.address"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_address2">Address 2</label> <input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.contactAddress.address2"></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback"><label class="control-label" for="field_city">City</label> <input type="text" class="form-control" name="city" id="field_city" ng-model="vm.contactAddress.city"></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback"><label for="field_countryState">Country State</label> <select class="form-control" id="field_countryState" name="countryState" ng-model="vm.contactAddress.countryState" ng-options="countryState as countryState.state for countryState in vm.countrystates track by countryState.id"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback"><label class="control-label" for="field_zipCode">Zip Code</label> <input type="text" class="form-control" name="zipCode" id="field_zipCode" ui-mask="99999" ng-model="vm.contactAddress.zipCode"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_phone">Phone</label> <input type="text" class="form-control" name="phone" id="field_phone" ui-mask="(999) 999-9999" ng-model="vm.contactAddress.phone"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_fax">Fax</label> <input type="text" class="form-control" name="fax" id="field_fax" ui-mask="(999)-999-9999" ng-model="vm.contactAddress.fax"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_email">Email</label> <input type="email" class="form-control" name="email" id="field_email" ng-model="vm.contactAddress.email"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_website">Website</label> <input type="url" class="form-control" name="website" id="field_website" ng-model="vm.contactAddress.website"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback"><label for="field_note">Notes</label> <textarea class="form-control" name="note" id="field_note" ng-model="vm.contactAddress.note"></textarea></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/contacts/update/contacts-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myContactsLabel">Create or edit a Contacts</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><jhi-alert-error></jhi-alert-error><form name="contactForm" class="form" action=""><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="contactForm.fullName.$invalid || contactForm.fullName.$error.required?\'has-error\':(contactForm.fullName.$valid && contactForm.fullName.$dirty?\'has-success\':\'\')"><label for="field_fullName">Full Name:</label> <input type="text" class="form-control" name="fullName" id="field_fullName" required ng-model="vm.entity.fullName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="contactForm.fullName.$invalid || contactForm.fullName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="contactForm.fullName.$valid && contactForm.fullName.$dirty"></span> <span class="help-block" ng-show="contactForm.fullName.$invalid || contactForm.fullName.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.entity.typePatientContactTypes?(contactForm.typePatientContactType.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_relationship">Contact Type:</label> <select class="form-control" id="field_contactType" name="typePatientContactType" required ng-model="vm.entity.typePatientContactTypes" ng-options="item as item.name for item in vm.typeContacts track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.entity.typePatientContactTypes"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.entity.typePatientContactTypes && contactForm.typePatientContactType.$dirty"></span> <span class="help-block help-error" ng-show="!vm.entity.typePatientContactTypes">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.entity.typePatientContactsRelationship?(contactForm.typeRelationship.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_relationship">Relationship:</label> <select class="form-control" id="field_relationship" name="typeRelationship" required ng-model="vm.entity.typePatientContactsRelationship" ng-options="item as item.name for item in vm.typeRelationships track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.entity.typePatientContactsRelationship"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.entity.typePatientContactsRelationship && contactForm.typeRelationship.$dirty"></span> <span class="help-block help-error" ng-show="!vm.entity.typePatientContactsRelationship">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="contactForm.address.$invalid?\'has-error\':(contactForm.address.$dirty?\'has-success\':\'\')"><label for="field_address">Address:</label> <input type="text" class="form-control" name="address" id="field_address" required ng-model="vm.entity.address"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="contactForm.address.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!contactForm.address.$invalid && contactForm.address.$dirty"></span> <span class="help-block" ng-show="contactForm.address.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.entity.addressTwo?(contactForm.address_two.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_address_two">Address Two:</label> <input type="text" class="form-control" name="address_two" id="field_address_two" ng-model="vm.entity.addressTwo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.entity.addressTwo"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.entity.addressTwo && contactForm.address_two.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.entity.addressTwo">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="contactForm.city.$invalid || contactForm.city.$error.required?\'has-error\':(contactForm.city.$valid && contactForm.city.$dirty?\'has-success\':\'\')"><label for="field_city">City:</label> <input type="text" class="form-control" name="city" id="field_city" required ng-model="vm.entity.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="contactForm.city.$invalid || contactForm.city.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="contactForm.city.$valid && contactForm.city.$dirty"></span> <span class="help-block" ng-show="contactForm.city.$invalid || contactForm.city.$error.required">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.entity.countryState?(contactForm.state.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_state">State:</label> <select class="form-control" id="field_state" name="state" required ng-model="vm.entity.countryState" ng-options="item as item.state for item in vm.states track by item.state"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.entity.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.entity.countryState && contactForm.state.$dirty"></span> <span class="help-block help-error" ng-show="!vm.entity.countryState">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="contactForm.zipCode.$invalid || contactForm.zipCode.$error.required?\'has-error\':(contactForm.zipCode.$valid && contactForm.zipCode.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_zip">Zip Code:</label> <input type="text" class="form-control" name="zipCode" id="field_zip" required ui-mask="99999" ng-model="vm.entity.zip"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="contactForm.zipCode.$error.required || contactForm.zipCode.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="contactForm.zipCode.$valid && contactForm.zipCode.$dirty"></span> <span class="help-block" ng-show="contactForm.zipCode.$error.required">This field is required</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="contactForm.contactPhone.$invalid || contactForm.contactPhone.$error.required?\'has-error\':(contactForm.contactPhone.$valid && contactForm.contactPhone.$dirty?\'has-success\':\'\')"><label for="field_phone">Phone:</label> <input type="text" class="form-control" id="field_phone" name="contactPhone" required ui-mask="(999) 999-9999" ng-model="vm.entity.phone"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="contactForm.contactPhone.$error.required || contactForm.contactPhone.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="contactForm.contactPhone.$valid && contactForm.contactPhone.$dirty"></span> <span class="help-block" ng-show="contactForm.contactPhone.$error.required">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="!vm.entity.altPhone || contactForm.altPhone.$invalid?\'has-warning\':(contactForm.altPhone.$valid && contactForm.altPhone.$dirty?\'has-success\':\'\')"><label for="field_phone">Alternative Phone:</label> <input type="text" class="form-control" id="field_altPhone" name="altPhone" ui-mask="(999) 999-9999" ng-model="vm.entity.altPhone"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.entity.altPhone || contactForm.altPhone.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.entity.altPhone && contactForm.altPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.entity.altPhone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="!vm.entity.email || contactForm.email.$invalid?\'has-warning\':(contactForm.email.$valid && contactForm.email.$dirty?\'has-success\':\'\')"><label for="field_email">Email:</label> <input type="email" class="form-control" name="email" id="field_email" ng-model="vm.entity.email"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.entity.email || contactForm.email.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.entity.email && contactForm.email.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.entity.email">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_supportSystem">Support System:</label><br><toggle id="field_supportSystem" ng-model="vm.entity.supportSystem" on="Yes" off="No" size="btn-sm" onstyle="btn-success" ng-disabled="vm.chart.status == \'CLOSED\'" offstyle="btn-danger"></toggle></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_guarantor">Guarantor:</label><br><toggle id="field_guarantor" ng-model="vm.entity.guarantor" on="Yes" off="No" size="btn-sm" onstyle="btn-success" ng-disabled="vm.chart.status == \'CLOSED\'" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.entity.notes?(contactForm.notes.$valid && contactForm.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_conctact_notes">Notes:</label> <textarea type="text" class="form-control" name="notes" id="field_conctact_notes" data-resize="disabled" ng-model="vm.entity.notes"></textarea> <span class="help-block help-warning" ng-show="!vm.entity.notes">This field is suggested</span></div></div></div></form></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.entity.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="button" class="btn btn-success" ng-click="vm.save()" ng-disabled="vm.chart.status === \'CLOSED\' || contactForm.$error.required || contactForm.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Contact from this patient\'s record. Are you sure you want to <strong>delete</strong> this Contact?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/contacts-facility/list/contacts-facility.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/contacts-facility/update/contacts-facility-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myViaLabel">Create or edit Contact Facility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.name?(editForm.name.$dirty || editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Contact Name(Full Name):</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.contactsFacility.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.name">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.typeContactFacilityType?(editForm.typeContactFacilityType.$dirty || editForm.typeContactFacilityType.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_typeContactFacilityType">Contact Type:</label> <select class="form-control" id="field_typeContactFacilityType" name="typeContactFacilityType" ng-model="vm.contactsFacility.typeContactFacilityType" required ng-options="contactFacilityType as contactFacilityType.name for contactFacilityType in vm.typecontactfacilitytypes track by contactFacilityType.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.typeContactFacilityType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.typeContactFacilityType && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.typeContactFacilityType">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.street?(editForm.street.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_street">Address 1:</label> <input type="text" class="form-control" name="street" id="field_street" required ng-model="vm.contactsFacility.street"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.street"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.street && editForm.street.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.street">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.streetTwo?(editForm.streetTwo.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Address 2</label> <input type="text" class="form-control" name="insurance_address2" id="field_streetTwo" ng-model="vm.contactsFacility.streetTwo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.streetTwo"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.streetTwo && editForm.streetTwo.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.contactsFacility.streetTwo">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.city?(editForm.city.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_city">City:</label> <input type="text" class="form-control" id="field_city" name="city" required ng-model="vm.contactsFacility.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.city && editForm.city.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.city">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.countryState?(editForm.countryState.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">State:</label> <select class="form-control" id="field_countryState" name="countryState" required ng-model="vm.contactsFacility.countryState" ng-options="item.state for item in vm.countrystates track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.countryState && editForm.countryState.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.countryState">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.zip?(editForm.zip.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Zip Code:</label> <input type="text" name="zip" id="field_zip" class="form-control" required ng-model="vm.contactsFacility.zip" ui-mask="99999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.zip"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.zip && editForm.zip.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.zip">This field is required</span></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.cellphone?(editForm.cellphone.$dirty || editForm.cellphone.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Phone:</label> <input type="text" class="form-control" name="name" id="field_cellphone" required ng-model="vm.contactsFacility.cellphone" ui-mask="(999) 999-9999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.cellphone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.cellphone && editForm.cellphone.$dirty"></span> <span class="help-block" ng-show="!vm.contactsFacility.cellphone">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_name">Fax:</label> <input type="text" class="form-control" name="fax" id="field_fax" ui-mask="(999) 999-9999" ng-model="vm.contactsFacility.fax"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_name">Website:</label> <input type="text" class="form-control" name="website" id="field_website" ng-model="vm.contactsFacility.website"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.contactsFacility.email?(editForm.email.$dirty || editForm.email.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Email:</label> <input type="email" class="form-control" name="email" id="field_email" required ng-model="vm.contactsFacility.email"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.contactsFacility.email"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.contactsFacility.email && editForm.email.$dirty"></span> <span class="help-block" ng-show="editForm.email.$error.required">This field is required</span> <span class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_name">Notes:</label> <textarea type="text" class="form-control" name="name" id="field_notes" rows="5" ng-model="vm.contactsFacility.notes"></textarea></div></div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/corporation/create/corporation-wizard-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Corporation Setup</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="corporationWizard" hide-indicators="true"><wz-step wz-title="Form"><ng-include src="\'app/entities/corporation/create/tpl/form.html\'"></ng-include><div class="modal-footer"><button type="submit" class="btn btn-success" wz-next ng-click="vm.loadEntity(0)" ng-disabled="vm.editForm.$invalid">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></div></wz-step><wz-step wz-title="TEST1"><ng-include src="\'app/entities/corporation/create/tpl/entity.html\'"></ng-include><div class="modal-footer"><button type="button" class="btn btn-warning" style="margin-right: auto" wz-previous ng-if="vm.index == 0"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button> <button type="button" class="btn btn-warning" style="margin-right: auto" ng-click="vm.loadEntity(vm.index - 1)" ng-if="vm.index > 0"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button> <button type="button" class="btn btn-warning" ng-disabled="vm.editForm.$invalid || vm.isSaving" wz-next ng-click="vm.loadEntity(vm.index + 1)" ng-if="vm.index != (vm.entities.length - 1)">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button> <button type="button" class="btn btn-success" ng-disabled="vm.editForm.$invalid || vm.isSaving" wz-next ng-click="vm.save()" ng-if="vm.index == (vm.entities.length - 1)"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></wz-step></wizard></div></div></div>');
$templateCache.put('app/entities/corporation/list/corporation.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/corporation/update/corporation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCorporationLabel">Create or edit a Corporation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.corporation.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.corporation.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.corporation.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.corporation.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.corporation.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.corporation.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.corporation.name">This field is required</span></div><div class="form-group form-group-sm"><label for="field_active">Active:</label><br><toggle id="field_active" ng-model="vm.corporation.active" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="form-group form-group-sm"><label for="field_active">RCopia Integration:</label><br><toggle id="field_rcopia_integration" ng-model="vm.corporation.rcopiaIntegration" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-insurance/tpl/primary.html','<h4>Primary <button type="button" class="btn btn-default btn-sm button-link" ng-click="vm.edit(vm.crmPrimaryInsurance.id)" ng-if="vm.crmPrimaryInsurance"><span class="fa fa-edit" aria-hidden="true"></span></button></h4><div class="well well-sm" ng-if="vm.crmPrimaryInsurance"><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Carrier:</strong></span><p>{{vm.crmPrimaryInsurance.insuranceCarrier.name}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Policy:</strong></span><p>{{vm.crmPrimaryInsurance.policyNumber}}</p></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Group Number:</strong></span><p>{{vm.crmPrimaryInsurance.groupNumber}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Pre-Cert Phone:</strong></span><p>{{vm.crmPrimaryInsurance.preCertPhone | phone}}</p></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Subscriber Name:</strong></span><p>{{vm.crmPrimaryInsurance.name}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Subscriber Phone:</strong></span><p>{{vm.crmPrimaryInsurance.phone | phone}}</p></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-15"><span class="small"><strong>Subscriber D.O.B.:</strong></span><p>{{vm.crmPrimaryInsurance.dob | date: inputDateFormat}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-15"><span class="small"><strong>Subscriber Relationship:</strong></span><p>{{vm.crmPrimaryInsurance.insuranceRelation.name}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-15"><span class="small"><strong>Subscriber SSN:</strong></span><p>{{vm.crmPrimaryInsurance.socialSecurity | ssn}}</p></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><span class="small"><strong>Subscriber Address:</strong></span><p>{{vm.crmPrimaryInsurance.address + (vm.crmPrimaryInsurance.address2 ? " " + vm.crmPrimaryInsurance.address2 + \', \' : \', \') + vm.crmPrimaryInsurance.city + \', \' + vm.crmPrimaryInsurance.countryState.state + \' \' + vm.crmPrimaryInsurance.zipCode}}</p></div></div></div><div class="well well-sm" ng-if="!vm.crmPrimaryInsurance"><button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.add(\'PRIMARY\')"><i class="fa fa-edit" aria-hidden="true"></i> Create</button></div>');
$templateCache.put('app/entities/crm-insurance/tpl/secondary.html','<h4>Secondary <button type="button" class="btn btn-default btn-sm button-link" ng-click="vm.edit(vm.crmSecondaryInsurance.id)" ng-if="vm.crmSecondaryInsurance"><span class="fa fa-edit" aria-hidden="true"></span></button></h4><div class="well well-sm" ng-if="vm.crmSecondaryInsurance"><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Carrier:</strong></span><p>{{vm.crmSecondaryInsurance.insuranceCarrier.name}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Policy:</strong></span><p>{{vm.crmSecondaryInsurance.policyNumber}}</p></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Group Number:</strong></span><p>{{vm.crmSecondaryInsurance.groupNumber}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Pre-Cert Phone:</strong></span><p>{{vm.crmSecondaryInsurance.preCertPhone | phone}}</p></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Subscriber Name:</strong></span><p>{{vm.crmSecondaryInsurance.name}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><span class="small"><strong>Subscriber Phone:</strong></span><p>{{vm.crmSecondaryInsurance.phone | phone}}</p></div></div><div class="row mb-15"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-15"><span class="small"><strong>Subscriber D.O.B.:</strong></span><p>{{vm.crmSecondaryInsurance.dob | date: inputDateFormat}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-15"><span class="small"><strong>Subscriber Relationship:</strong></span><p>{{vm.crmSecondaryInsurance.insuranceRelation.name}}</p></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 mb-15"><span class="small"><strong>Subscriber SSN:</strong></span><p>{{vm.crmSecondaryInsurance.socialSecurity | ssn}}</p></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><span class="small"><strong>Subscriber Address:</strong></span><p>{{vm.crmSecondaryInsurance.address + (vm.crmSecondaryInsurance.address2 ? " " + vm.crmSecondaryInsurance.address2 + \', \': \', \') + vm.crmSecondaryInsurance.city + \', \' + vm.crmSecondaryInsurance.countryState.state + \' \' + vm.crmSecondaryInsurance.zipCode}}</p></div></div></div><div class="well well-sm" ng-if="vm.crmPrimaryInsurance && !vm.crmSecondaryInsurance"><button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.add(\'SECONDARY\')" ng-disabled="!vm.crmPrimaryInsurance"><i class="fa fa-edit" aria-hidden="true"></i> Create</button></div>');
$templateCache.put('app/entities/crm-opportunity/activities/log-calls-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Log Emails</h4></div><div class="modal-body"><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="dateLogCall">Date of Call:</label><div class="input-group"><input type="text" class="form-control" id="dateLogCall" name="dateLogCall" placeholder="mm/dd/yyyy" ng-model="vm.activity.dateLogCall" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dateLogCall"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateLogEmail\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="inputOutcome">Outcome:</label> <select name="inputOutcome" id="inputOutcome" class="form-control"><option value="01">Wrong Number</option><option value="02">Not Answer</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label for="taskTextEditor">Note:</label><!--                    <ng-quill-editor ng-model="vm.taskText" id="taskTextEditor"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/activities/log-email-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Log Emails</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="dateLogEmail">Date of Email:</label><div class="input-group"><input type="text" class="form-control" id="dateLogEmail" name="dateLogEmail" placeholder="mm/dd/yyyy" ng-model="vm.activity.dateLogEmail" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dateLogEmail"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateLogEmail\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label for="taskTextEditor">Note:</label><!--                    <ng-quill-editor ng-model="vm.taskText" id="taskTextEditor"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/activities/new-note-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Note</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="notes-editor"><!--                    <ng-quill-editor ng-model="vm.note"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/activities/new-task-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Task</h4></div><div class="modal-body"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="inputTaskName">Task:</label> <input type="text" class="form-control" id="inputTaskName" placeholder="John Doe"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="inputAssignedTo">Assigned To:</label> <select name="inputAssignedTo" id="inputAssignedTo" class="form-control"><option value="01">Jesus Rodriguez</option><option value="02">Maykel Wong</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="dateDueDateTask">Due Date:</label><div class="input-group"><input type="text" class="form-control" id="dateDueDateTask" name="dateDueDateTask" placeholder="mm/dd/yyyy" ng-model="vm.activity.dateDueDateTask" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dateDueDateTask"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateDueDateTask\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="dateReminder">Reminder:</label><div class="input-group"><input type="text" class="form-control" id="dateReminder" name="dateReminder" placeholder="mm/dd/yyyy" ng-model="vm.activity.dateReminder" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dateReminder"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateReminder\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label for="taskTextEditor">Note:</label><!--                    <ng-quill-editor ng-model="vm.taskText" id="taskTextEditor"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/activities/payment-plan-dialog.html','<form action="" name="ccForm" novalidate><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Note</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><fieldset><legend>Payment Plan</legend><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="paymentPlan">Payment Plan Type:</label> <select name="paymentPlan" id="paymentPlan" class="form-control"><option value="01">Payment Plan 01</option><option value="02">Payment Plan 02</option><option value="03">Payment Plan 03</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="billingFacility">Billing Facility:</label> <select name="billingFacility" id="billingFacility" class="form-control"><option value="01">Billing Facility 01</option><option value="02">Billing Facility 02</option><option value="03">Billing Facility 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="amountToPay">Amount:</label> <input type="number" min="0" class="form-control" id="amountToPay"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="startDate">Start Date:</label><div class="input-group"><input type="text" class="form-control" id="startDate" name="startDate" placeholder="mm/dd/yyyy" ng-model="vm.activity.startDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="paymentFrequency">Frequency:</label> <select name="paymentFrequency" id="paymentFrequency" class="form-control"><option value="01">Monthly</option><option value="02">Weekly</option><option value="03">Payment Cycle</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="durationMonth">Duration in Months:</label> <input type="number" min="0" class="form-control" id="durationMonth"></div></div><!-- Debug stuff\n                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">\n                            <p><strong>Number: </strong> {{card.number == 0}}</p>\n                            <p><strong>Valid Number:</strong> {{ccForm.ccNumber.$valid}} , <strong>Valid CVC:</strong> {{ccForm.ccCvc.$valid}}</p>\n                            <p><strong>Eager Type: </strong>{{ccForm.ccNumber.$ccEagerType || \'Unknown\'}}, <strong>Type: </strong>{{ccForm.ccNumber.$ccType || \'Unknown\'}}</p>\n                            <p><strong>Valid Month:</strong> {{ccForm.ccExpMonth.$valid}} , <strong>Valid Year: </strong> {{ccForm.ccExpYear.$valid}} , <strong>Valid Pair: </strong> {{!ccForm.$error.ccExp}}</p>\n                        </div>\n                        --></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="cardNumber">Card Number:</label> <input type="text" class="form-control" id="cardNumber" name="ccNumber" ng-model="card.number" cc-number cc-format cc-eager-type></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="cardName">Full Name:</label> <input type="text" class="form-control" id="cardName" placeholder="Name on card..." ng-model="card.fullName"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label>Expiration:</label><div class="row expiration-date" cc-exp><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><input type="text" class="form-control" id="expirationMonth" placeholder="MM" name="ccExpMonth" ng-model="card.expiration.month" cc-exp-month></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><input type="text" class="form-control" id="expirationYear" placeholder="YY" name="ccExpYear" ng-model="card.expiration.year" cc-exp-year></div></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="cvc">CVC:</label> <input type="text" class="form-control" id="cvc" name="ccCvc" ng-model="card.cvc" cc-cvc cc-type="ccForm.ccNumber.$ccType"></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group"><label for="zipCode">Zip Code:</label> <input type="text" class="form-control" name="zipCode" id="zipCode" ng-model="card.zipCode" ui-mask="99999"></div></div></div></fieldset></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><fieldset><legend>Card Type</legend><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="card-logo"><div class="card"><div class="cc-logo" ng-class="{\'invalid\': !ccForm.ccNumber.$valid || (card.number == 0) || ccForm.ccNumber.$pristine}"><img src="content/images/cc/visa.svg" alt="Visa Logo" ng-if="ccForm.ccNumber.$valid && ccForm.ccNumber.$ccType === \'Visa\'"> <img src="content/images/cc/mastercard.svg" alt="Mastercard Logo" ng-if="ccForm.ccNumber.$valid && ccForm.ccNumber.$ccType === \'Mastercard\'"> <img src="content/images/cc/amex.svg" alt="American Express Logo" ng-if="ccForm.ccNumber.$valid && ccForm.ccNumber.$ccType === \'American Express\'"> <img src="content/images/cc/visa.svg" alt="Discover Logo" ng-if="ccForm.ccNumber.$valid && ccForm.ccNumber.$ccType === \'Discover\'"> <img src="content/images/cc/default.svg" alt="Valid Logo" ng-if="ccForm.ccNumber.$valid && !([\'Visa\', \'Mastercard\', \'Discover\', \'American Express\'].indexOf(ccForm.ccNumber.$ccType)>=0) && !ccForm.ccNumber.$pristine && (card.number != 0)"> <img src="content/images/cc/default-mono.svg" alt="Invalid Logo" ng-if="!ccForm.ccNumber.$valid || (card.number == 0) || ccForm.ccNumber.$pristine"></div><div class="ship"></div><div class="number-cvc"><span>{{card.number? (card.number | ccNumberFormat) : \'XXXX XXXX XXXX XXXX\'}}</span> <span>{{card.cvc || \'CVC\'}}</span></div><div class="name-expiration"><span>{{card.fullName || \'John Doe\'}}</span> <span class="expiration"><strong>EXP: </strong>{{card.expiration.month || \'MM\'}}/{{card.expiration.year || \'YY\'}}</span></div></div></div></div></div></fieldset></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><fieldset><legend>Quotes set:</legend><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>#</strong></th><th><strong>Due Date</strong></th><th><strong>Amount</strong></th><th><strong>Paid</strong></th><th><strong>Balance</strong></th></tr></thead><tbody><tr><td>1234</td><td>09/10/2019</td><td>10,000</td><td>6,000</td><td>4,000</td></tr></tbody></table></div></fieldset></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/activities/travel-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Travel</h4></div><div class="modal-body"><div class="row"><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="selectTravelType">Travel Type:</label><!--<input type="text" class="form-control" id="inputTaskName" placeholder="John Doe">--> <select name="selectTravelType" id="selectTravelType" class="form-control"><option value="01">Incoming Patient</option><option value="02">Outgoing Patient</option></select></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="selectDriver">Driver:</label> <select name="selectDriver" id="selectDriver" class="form-control"><option value="01">Jesus Rodriguez</option><option value="02">Maykel Wong</option></select></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="selectReminder">Reminder:</label> <select name="selectReminder" id="selectReminder" class="form-control"><option value="01">Time Of pick up</option><option value="02">5 minutes before</option><option value="02">15 minutes before</option><option value="02">30 minutes before</option><option value="02">45 minutes before</option><option value="02">1 hour before</option><option value="02">2 hours before</option></select></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputFlightNumber">Flight Number:</label> <input type="text" class="form-control" id="inputFlightNumber" placeholder="AA1234"></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputDepartingAirport">Departing Airport:</label> <input type="text" class="form-control" id="inputDepartingAirport" placeholder="MIA"></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="inputArrivingAirport">Arriving Airport:</label> <input type="text" class="form-control" id="inputArrivingAirport" placeholder="MIA"></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="dateDeparting">Departing:</label><div class="input-group"><input type="text" class="form-control" id="dateDeparting" name="dateDeparting" placeholder="mm/dd/yyyy hh:mm" ng-model="vm.activity.dateDeparting" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dateDeparting"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateDeparting\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="dateArriving">Arriving:</label><div class="input-group"><input type="text" class="form-control" id="dateArriving" name="dateArriving" placeholder="mm/dd/yyyy hh:mm" ng-model="vm.activity.dateArriving" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dateArriving"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateArriving\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group notes-editor mb-0"><label for="taskTextEditor">Note:</label><!--                    <ng-quill-editor ng-model="vm.taskText" id="taskTextEditor"></ng-quill-editor>--></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/crm-opportunity/tabs/activity.html','<section class="activity-content"><div class="date-controls"><span class="table-title">Timeline</span><div class="date-start"><label>Start Date:</label> <input type="date" class="form-control input-sm" ng-model="data.activities.startDate"></div><div class="date-start"><label>End Date:</label> <input type="date" class="form-control input-sm" ng-model="data.activities.endDate"></div><button type="button" class="btn btn-primary btn-sm" ng-click="vm.updateGChart(data)">Apply <i class="fa fa-angle-double-right" aria-hidden="true"></i></button></div><div id="dashboard_div{{data.crmOpportunity.id}}"><!--Divs that will hold each control and chart--><div id="chart_div{{data.crmOpportunity.id}}"></div><div id="control_div{{data.crmOpportunity.id}}"></div></div></section>');
$templateCache.put('app/entities/crm-opportunity/tabs/attachments.html','<h4 class="headline mt-0"><strong>Attachments</strong> <button type="button" class="btn btn-default btn-sm button-link" ng-click=""><span class="fa fa-edit" aria-hidden="true"></span></button></h4>');
$templateCache.put('app/entities/crm-opportunity/tabs/calls.html','<div class="generic-activities"><h4 class="headline mt-0"><strong>Pinned</strong> <button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.openModalCallLog()"><i class="fa fa-edit" aria-hidden="true"></i> Log Call</button></h4><div class="pinned-items"><div class="activity-item well well-sm" ng-mouseenter="tooltipIsOpen = true" ng-mouseleave="tooltipIsOpen = false"><button class="btn btn-default btn-sm btn-toggle-pin pinned" uib-tooltip="Unpin Logged Call" tooltip-is-open="tooltipIsOpen" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type call">Logged Call</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Date of Call:</span><p class="name mb-0"><strong>08/28/2018 1:30 PM</strong></p></div><div class="credentials"><span class="small">Outcome:</span><p class="name mb-0"><strong>Wrong Number</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Log?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div><h4 class="headline mt-0"><strong>August</strong> <span>[2019]</span></h4><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Logged Call" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type call">Logged Call</div><div><span class="date">Aug 19, 2019 at 10:30 PM EDT</span></div></header><div class="activity-body"><p>No hay caf\xE9 para despertarse.</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Date of Call:</span><p class="name mb-0"><strong>08/28/2018 1:30 PM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Document?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Logged Call" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type call">Logged Call</div><div><span class="date">Aug 19, 2019 at 10:30 PM EDT</span></div></header><div class="activity-body"><p>No hay caf\xE9 para despertarse.</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Date of Call:</span><p class="name mb-0"><strong>08/28/2018 1:30 PM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Log?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Logged Call" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type call">Logged Call</div><div><span class="date">Aug 19, 2019 at 10:30 PM EDT</span></div></header><div class="activity-body"><p>No hay caf\xE9 para despertarse.</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Date of Call:</span><p class="name mb-0"><strong>08/28/2018 1:30 PM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Log?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div>');
$templateCache.put('app/entities/crm-opportunity/tabs/documents.html','<div class="generic-activities"><div class="activity-item"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>Jesus Rodriguez</strong></p><span class="date">Aug 22, 2019 8:30PM</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link blue" ng-click=""><i class="fa fa-file-text" aria-hidden="true"></i> Document File</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body"><div class="type document"><span><strong>Document</strong> [<span class="lighter">Pre-Admission Assessment</span>]</span> <span class="small">Aug 22, 2019 at 8:30PM</span></div></div><footer class="activity-footer"><div class="credentials"><span class="small">Signed By:</span><p class="name mb-0">Jesus Rodriguez</p></div><div class="credentials"><span class="small">Reviewed By:</span><p class="name mb-0">Maykel Wong</p></div><div class="credentials"><span class="small">Status:</span><p class="name mb-0"><span class="label label-success">Complete</span></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Document?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-default btn-sm btn-toggle-pin"><i class="fa fa-bookmark-o" aria-hidden="true"></i> Pin</button></div></footer></div><div class="activity-item"><header class="activity-header"><div class="header-data"><div class="thumb"><img src="content/adminLTE/img/avatar5.png" class="img-responsive" alt="User Avatar"></div><div><p class="name mb-0"><strong>Jesus Rodriguez</strong></p><span class="date">Aug 22, 2019 8:30PM</span></div></div><div style="margin-left: auto;"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link blue" ng-click=""><i class="fa fa-file-text" aria-hidden="true"></i> Document File</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div></header><div class="activity-body"><div class="type document"><span><strong>Document</strong> [<span class="lighter">Pre-Admission Assessment</span>]</span> <span class="small">Aug 22, 2019 at 8:30PM</span></div></div><footer class="activity-footer"><div class="credentials"><span class="small">Signed By:</span><p class="name mb-0">Jesus Rodriguez</p></div><div class="credentials"><span class="small">Reviewed By:</span><p class="name mb-0">Maykel Wong</p></div><div class="credentials"><span class="small">Status:</span><p class="name mb-0"><span class="label label-success">Complete</span></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><p class="delete-text">Are you sure you want to <strong>delete</strong> this Document?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div><div><button class="btn btn-default btn-sm btn-toggle-pin"><i class="fa fa-bookmark-o" aria-hidden="true"></i> Pin</button></div></footer></div></div>');
$templateCache.put('app/entities/crm-opportunity/tabs/emails.html','<div class="generic-activities"><h4 class="headline mt-0"><strong>Pinned</strong> <button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.openModalEmailLog()"><i class="fa fa-edit" aria-hidden="true"></i> Log Email</button></h4><div class="pinned-items"><div class="activity-item well well-sm" ng-mouseenter="tooltipIsOpen = true" ng-mouseleave="tooltipIsOpen = false"><button class="btn btn-default btn-sm btn-toggle-pin pinned" uib-tooltip="Unpin Logged Email" tooltip-is-open="tooltipIsOpen" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type email">Logged Email</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Date of email:</span><p class="name mb-0"><strong>08/28/2018 1:30 PM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Log?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div><h4 class="headline mt-0"><strong>August</strong> <span>[2019]</span></h4><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Logged Email" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type email">Logged Email</div><div><span class="date">Aug 19, 2019 at 10:30 PM EDT</span></div></header><div class="activity-body"><p>No hay caf\xE9 para despertarse.</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Logged By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Date of email:</span><p class="name mb-0"><strong>08/28/2018 1:30 PM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Log?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div>');
$templateCache.put('app/entities/crm-opportunity/tabs/financials.html','<h4>Verification of Benefits</h4><div class="verification-of-benefit"><div class="basic"><div><div class="inf"><span class="title text-uppercase"><strong>Coverage</strong></span><p class="mb-0">Active Coverage</p></div><div class="inf"><span class="title text-uppercase"><strong>Coverage Date</strong></span><p class="mb-0">Feb 2, 2018 - July 2, 2020</p></div><div class="inf"><span class="title text-uppercase"><strong>Insurance Type</strong></span><p class="mb-0">Preferred Provider Organization (PPO)</p></div><div class="inf"><span class="title text-uppercase"><strong>Insurance Company</strong></span><p class="mb-0">BCBS Of TX</p></div><div class="inf"><span class="title text-uppercase"><strong>Plan Sponsor</strong></span><p class="mb-0">Exelon Corporation</p></div><div class="inf"><span class="title text-uppercase"><strong>Group Num</strong></span><p class="mb-0">090010</p></div></div><hr><div class="payer-note"><span class="title text-uppercase"><strong>Payer Note</strong></span><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eu vulputate tortor, nec condimentum elit. Curabitur at consectetur leo, in volutpat orci. Pellentesque sit amet vehicula augue, in efficitur orci. Duis aliquam vel ex id finibus. Vivamus cursus pellentesque massa quis ornare. Aenean sed varius dolor. Nam et pulvinar nunc. Morbi porttitor quam nec ullamcorper bibendum.</p><p>Cur nixus assimilant? Spatiis crescere in teres quadrata! Scutum de barbatus clinias, promissio apolloniates! Nunquam convertam ausus. Sectam fatalis exemplar est. Plasmator volares, tanquam velox brabeuta. Pol, a bene cobaltum, ferox poeta! Barbatus, albus cobaltums mechanice dignus de castus, alter nuclear vexatum iacere. Brabeutas cantare in domesticus cirpi! Camerarius, clemens frondators sapienter prensionem de fidelis, secundus nomen.</p></div></div><div class="networks"><div class="well well-sm"><h5 class="text-center text-uppercase mt-0"><strong>In Network</strong></h5><div class="network-data"><span class="title text-uppercase"><strong>Co-Insurance (Individual)</strong></span><p class="mb-0">Client: <strong>30%</strong></p><p class="mb-0">Provider: <strong>70%</strong></p><div class="progress-chart mt-15"><uib-progress max="100" animate="true"><uib-bar value="70" type="success"><span>70%</span></uib-bar><uib-bar value="30" type="danger"><span>30%</span></uib-bar></uib-progress></div></div><div class="network-data"><span class="title text-uppercase"><strong>Co-Payment (Individual)</strong></span><p class="mb-0"><strong>$15.00</strong> a day</p></div><div class="network-data"><span class="title text-uppercase"><strong>Out Of Pocket (Individual)</strong></span><p class="mb-0">Calendar Year: <strong>$3000.00</strong></p><p class="mb-0">Year to Date: <strong>$2500.00</strong></p><p class="mb-0">Remaining: <strong>$500.00</strong></p><div class="progress-chart mt-15"><uib-progress max="3000"><uib-bar value="2500" type="success"><span>$2500</span></uib-bar><uib-bar value="500" type="danger"><span>$500</span></uib-bar></uib-progress></div></div><div class="network-data"><span class="title text-uppercase"><strong>Deductibles (Individual)</strong></span><p class="mb-0">Calendar Year: <strong>$3000.00</strong></p><p class="mb-0">Year to Date: <strong>$3000.00</strong></p><p class="mb-0">Remaining: <strong>$0.00</strong></p><div class="progress-chart mt-15"><uib-progress max="3000"><uib-bar value="3000" type="success"><span>$3000</span></uib-bar><uib-bar value="0" type="danger"><span>$0.00</span></uib-bar></uib-progress></div></div></div><div class="well well-sm"><h5 class="text-center text-uppercase mt-0"><strong>Out of Network</strong></h5><div class="network-data"><span class="title text-uppercase"><strong>Co-Insurance (Individual)</strong></span><p class="mb-0">Client: <strong>30%</strong></p><p class="mb-0">Provider: <strong>70%</strong></p><div class="progress-chart mt-15"><uib-progress max="100" animate="true"><uib-bar value="70" type="success"><span>70%</span></uib-bar><uib-bar value="30" type="danger"><span>30%</span></uib-bar></uib-progress></div></div><div class="network-data"><span class="title text-uppercase"><strong>Co-Payment (Individual)</strong></span><p class="mb-0"><strong>$15.00</strong> a day</p></div><div class="network-data"><span class="title text-uppercase"><strong>Out Of Pocket (Individual)</strong></span><p class="mb-0">Calendar Year: <strong>$3000.00</strong></p><p class="mb-0">Year to Date: <strong>$2500.00</strong></p><p class="mb-0">Remaining: <strong>$500.00</strong></p><div class="progress-chart mt-15"><uib-progress max="3000"><uib-bar value="2500" type="success"><span>$2500</span></uib-bar><uib-bar value="500" type="danger"><span>$500</span></uib-bar></uib-progress></div></div><div class="network-data"><span class="title text-uppercase"><strong>Deductibles (Individual)</strong></span><p class="mb-0">Calendar Year: <strong>$3000.00</strong></p><p class="mb-0">Year to Date: <strong>$3000.00</strong></p><p class="mb-0">Remaining: <strong>$0.00</strong></p><div class="progress-chart mt-15"><uib-progress max="3000"><uib-bar value="3000" type="success"><span>$3000</span></uib-bar><uib-bar value="0" type="danger"><span>$0.00</span></uib-bar></uib-progress></div></div></div></div></div><h4 class="mb-0" style="display: flex; justify-content: space-between; align-items: center"><strong>Payment Plan</strong> <button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.openModalPaymentPlan()"><i class="fa fa-credit-card" aria-hidden="true"></i> Payment Plan</button></h4><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 pay-info"><div class="info"><label>Type:</label><p>Payment Plan type 01</p></div><div class="info"><label>Billing Facility:</label><p>Indiana Rehabilitation Center, LLC</p></div><div class="info"><label>Amount:</label><p>$3000.00</p></div><div class="info"><label>Start Date:</label><p>June 01, 2019</p></div><div class="info"><label>Total Due:</label><p>$40.00</p></div><div class="info"><label>Frequency:</label><p>Bi-weekly</p></div><div class="info"><label>Duration:</label><p>36 Months</p></div><div class="info"><label>Zip Code:</label><p>33333</p></div></div><div class="col-xs-12 col-sm-12 col-md-5 col-lg-5"><div class="card-logo"><div class="card"><div class="cc-logo"><img src="content/images/cc/default-mono.svg" alt="Card Logo"></div><div class="ship"></div><div class="number-cvc"><span>1212 1212 1212 1212</span> <span>123</span></div><div class="name-expiration"><span>\'John Doe\'</span> <span class="expiration"><strong>EXP: </strong>\'04\'/\'22\'</span></div></div></div></div></div>');
$templateCache.put('app/entities/crm-opportunity/tabs/notes.html','<div class="generic-activities"><h4 class="headline mt-0"><strong>Pinned</strong> <button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Create Note</button></h4><div class="pinned-items"><div class="activity-item well well-sm" ng-mouseenter="tooltipIsOpen = true" ng-mouseleave="tooltipIsOpen = false"><button class="btn btn-default btn-sm btn-toggle-pin pinned" uib-tooltip="Unpin Note" tooltip-is-open="tooltipIsOpen" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type note">Note</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><p class="name mb-0"><strong>Jesus Rodriguez</strong> <span class="small">Left a note</span></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Note?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div><div class="activity-item well well-sm"><button class="btn btn-default btn-sm btn-toggle-pin pinned" uib-tooltip="Pin Note" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type note">Note</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div><footer class="activity-footer"><div class="initials">MW</div><div class="credentials"><p class="name mb-0"><strong>Maykel Wong</strong> <span class="small">Left a note</span></p></div></footer></div></div><h4 class="headline mt-0"><strong>August</strong> <span>[2019]</span></h4><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Note" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type note">Note</div><div><span class="date">Aug 19, 2019 at 10:30 PM EDT</span></div></header><div class="activity-body"><p>No hay caf\xE9 para despertarse.</p></div><footer class="activity-footer"><div class="initials">RS</div><div class="credentials"><p class="name mb-0"><strong>Raimel Santos</strong> <span class="small">Left a note</span></p></div></footer></div><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Note" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type note">Note</div><div><span class="date">Aug 16, 2019 at 9:30 PM EDT</span></div></header><div class="activity-body"><p>Se est\xE1 acabando el caf\xE9. Notificar a Jesus Rodriguez, Raimel va a peliar porque no hay caf\xE9.</p></div><footer class="activity-footer"><div class="initials">TB</div><div class="credentials"><p class="name mb-0"><strong>Tiago Boss</strong> <span class="small">Left a note</span></p></div></footer></div><h4 class="headline mt-0"><strong>July</strong> <span>[2019]</span></h4><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Note" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type note">Note</div><div><span class="date">July 26, 2019 at 9:30 PM EDT</span></div></header><div class="activity-body"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div><footer class="activity-footer"><div class="initials">TB</div><div class="credentials"><p class="name mb-0"><strong>Tiago Boss</strong> <span class="small">Left a note</span></p></div></footer></div><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Note" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type note">Note</div><div><span class="date">July 20, 2019 at 9:30 PM EDT</span></div></header><div class="activity-body"><p>Se est\xE1 acabando el caf\xE9. Notificar a Jesus Rodriguez, Raimel va a peliar porque no hay caf\xE9.</p></div><footer class="activity-footer"><div class="initials">TB</div><div class="credentials"><p class="name mb-0"><strong>Tiago Boss</strong> <span class="small">Left a note</span></p></div></footer></div></div>');
$templateCache.put('app/entities/crm-opportunity/tabs/task.html','<div class="generic-activities"><h4 class="headline mt-0"><strong>Pinned</strong> <button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.openModalNewTask()"><i class="fa fa-edit" aria-hidden="true"></i> Create Task</button></h4><div class="pinned-items"><div class="activity-item well well-sm" ng-mouseenter="tooltipIsOpen = true" ng-mouseleave="tooltipIsOpen = false"><button class="btn btn-default btn-sm btn-toggle-pin pinned" uib-tooltip="Unpin Task" tooltip-is-open="tooltipIsOpen" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type task">Task</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body task"><h5 class="mt-0" ng-class="{\'strikeout\': vm.taskChecked01}"><input type="checkbox" ng-model="vm.taskChecked01"> Lorem Ipsum Dollor Sit Amet</h5><div class="text" ng-if="!vm.taskChecked01"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Assigned To:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Due Date:</span><p class="name mb-0"><strong>28/08/2018 1:30 PM</strong></p></div><div class="credentials"><span class="small">Reminder:</span><p class="name mb-0"><strong>27/08/2018 8:00 AM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Task?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div><h4 class="headline mt-0"><strong>August</strong> <span>[2019]</span></h4><div class="activity-item well well-sm"><button class="btn btn-info btn-sm btn-toggle-pin" uib-tooltip="Pin Task" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type task">Task</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body task"><h5 class="mt-0" ng-class="{\'strikeout\': vm.taskChecked02}"><input type="checkbox" ng-model="vm.taskChecked02"> Lorem Ipsum Dollor Sit Amet</h5><div class="text" ng-if="!vm.taskChecked02"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident</p></div></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Assigned To:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Due Date:</span><p class="name mb-0"><strong>28/08/2018 1:30 PM</strong></p></div><div class="credentials"><span class="small">Reminder:</span><p class="name mb-0"><strong>27/08/2018 8:00 AM</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalNewNote()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Task?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div>');
$templateCache.put('app/entities/crm-opportunity/tabs/travels.html','<h4 class="headline mt-0"><strong>Pinned</strong> <button type="button" class="btn btn-primary btn-primary btn-sm" ng-click="vm.openModalTravel()"><i class="fa fa-plane" aria-hidden="true"></i> Flight</button></h4><div class="pinned-items"><div class="activity-item well well-sm" ng-mouseenter="tooltipIsOpen = true" ng-mouseleave="tooltipIsOpen = false"><button class="btn btn-default btn-sm btn-toggle-pin pinned" uib-tooltip="Unpin Flight" tooltip-is-open="tooltipIsOpen" tooltip-placement="left"><i class="fa fa-thumb-tack" aria-hidden="true"></i></button><header class="activity-header"><div class="type flight">Booked Flight [ <span class="lighter">AA4711</span> ]</div><div><span class="date">Aug 22, 2019 at 8:30 PM EDT</span></div></header><div class="activity-body"><div class="table-responsive"><table class="table table-condensed mb-0"><tbody><tr><td><span class="small"><strong>Departing:</strong></span><p>IND</p></td><td><span class="small"><strong>Arriving:</strong></span><p>MIA</p></td><td><span class="small"><strong>Expected Departure:</strong></span><p>01/01/2001 12:30PM</p></td><td><span class="small"><strong>Actual Departure:</strong></span><p>01/01/2001 12:28PM</p></td><td><span class="small"><strong>Expected Arrival:</strong></span><p>01/01/2001 03:30PM</p></td><td><span class="small"><strong>Actual Arrival:</strong></span><p>01/01/2001 03:28PM</p></td></tr></tbody></table><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p></div><footer class="activity-footer"><div class="initials">JR</div><div class="credentials"><span class="small">Booked By:</span><p class="name mb-0"><strong>Jesus Rodriguez</strong></p></div><div class="credentials"><span class="small">Status:</span><p class="name mb-0"><strong>Landed</strong></p></div><div class="credentials"><span class="small">Travel Type:</span><p class="name mb-0"><strong>Arriving at center</strong></p></div><div class="credentials"><span class="small">Driver:</span><p class="name mb-0"><strong>Ralph Johnson</strong></p></div><div class="credentials"><span class="small">Reminder:</span><p class="name mb-0"><strong>30 Minutes before</strong></p></div><div class="btns-actions" ng-class="{\'overlayActive\': vm.confirmDelete}"><button type="button" class="btn btn-warning btn-sm edit" ng-click="vm.openModalTravel()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-danger btn-sm delete" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button><p class="delete-text">Are you sure you want to <strong>delete</strong> this Flight?</p><div ng-if="vm.confirmDelete"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.confirmDelete = !vm.confirmDelete"><i class="fa fa-ban" aria-hidden="true"></i> No</button></div></div></footer></div></div></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/crm-opportunity-new.html','');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-additional-information.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_ethnicity">Ethnicity:</label> <select name="ethnicity" id="field_ethnicity" class="form-control input-sm"><option value="01">Caucasian</option><option value="02">Hispanic</option><option value="03">Asian</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_race">Race:</label> <select name="race" id="field_race" class="form-control input-sm"><option value="01">White</option><option value="02">Black</option><option value="03">Indian</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_maritalStatus">Marital Status:</label> <select name="maritalStatus" id="field_maritalStatus" class="form-control input-sm"><option value="01">Single</option><option value="02">Married</option><option value="03">Complicated</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-address.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_address">Address 1:</label> <input type="text" class="form-control input-sm" id="field_address" name="address"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_address2">Address 2:</label> <input type="text" class="form-control input-sm" id="field_address2" name="address2"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_city">City:</label> <input type="text" class="form-control input-sm" id="field_city" name="city"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_state">State:</label> <select class="form-control input-sm" id="field_state" name="state"><option value="01">Florida</option><option value="02">New York</option><option value="03">California</option><option value="04">Texas</option><option value="05">...</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_zipcode">Zip Code:</label> <input type="text" class="form-control input-sm" id="field_zipcode" name="zipcode" ui-mask="99999" ng-model="vm.opportunityZipCode"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-basic-info.html','<div class="popover-form"><form name="editForm" ng-submit="vm.save()"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><ui-select name="reaction" id="field_selectedOpportunity" title="Select Opportunity" ng-model="vm.crmAccountSelected" reset-search-input="true" close-on-select="true" ng-change="vm.changeAccount($select.selected)"><ui-select-match allow-clear="true" placeholder="Enter a account...">{{$select.selected.lastName + \', \' + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="account in vm.accounts | filter: $select.search" refresh="vm.filterCrmAccounts($select.search)" refresh-delay="0"><div ng-bind-html="account.lastName + \' \' + account.firstName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_name">First Name:</label> <input ng-disabled="vm.flag" type="text" name="name" ng-model="vm.crmAccount.firstName" required="true" id="field_name" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_middleName">Middle Name:</label> <input type="text" ng-disabled="vm.flag" ng-model="vm.crmAccount.middleName" id="field_middleName" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_lastName">Last Name:</label> <input ng-disabled="vm.flag" type="text" name="name" ng-model="vm.crmAccount.lastName" id="field_lastName" required="true" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="dob">D.O.B.:</label><div class="input-group input-group-sm"><input ng-disabled="vm.flag" type="text" required="true" class="form-control" id="dob" name="dob" placeholder="mm/dd/yyyy" required ng-model="vm.crmAccount.dob" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dob" datepicker-options="bodOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="sex">Gender:</label> <select ng-disabled="vm.flag" class="form-control" required="true" id="sex" name="sex" ng-model="vm.crmAccount.gender" ng-options="item as item for item in vm.gender track by item"></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="status">Status:</label> <select name="status" id="status" class="form-control" required ng-model="vm.state" ng-options="item as item.name for item in vm.status track by item.name"></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_priority">Priority:</label> <select name="priority" ng-model="vm.priority" id="field_priority" class="form-control input-sm" required><option value="HIGH">HIGH</option><option value="MID">MID</option><option value="LOW">LOW</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="tags">Tags:</label><ui-select required ng-model="vm.tags" name="tags" id="tags" reset-search-input="true" title="Tags" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a Tag ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.crmTags | filter: $select.search"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="submit" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-communication.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_phone">Phone:</label> <input type="text" class="form-control input-sm" id="field_phone" name="phone" ng-model="vm.opportunityPhone" ui-mask="(999)-999-9999"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_altPhone">Alt Phone:</label> <input type="text" class="form-control input-sm" id="field_altPhone" name="altphone" ng-model="vm.opportunityAltPhone" ui-mask="(999)-999-9999"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_email">Email:</label> <input type="email" class="form-control input-sm" id="field_email" name="email"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-contact.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_contactName">Name:</label> <input type="text" name="contactName" id="field_contactName" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_contactRelationship">Relationship:</label> <input type="text" id="field_contactRelationship" name="contactRelationship" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_contactPhone">Phone:</label> <input type="text" id="field_contactPhone" name="contactPhone" class="form-control input-sm" ng-model="vm.opportunityContactPhone" ui-mask="(999) 999-9999"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-create-basic-info.html','<div class="popover-form"><form name="editForm" ng-submit="vm.save(data)"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><ui-select name="account" id="field_selected_account" title="Select Opportunity" ng-model="data.crmAccount" reset-search-input="true" close-on-select="true" ng-change="vm.selectAccount(data, $select.selected)"><ui-select-match allow-clear="true" placeholder="Enter a account...">{{$select.selected.lastName + \', \' + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="account in vm.accounts | filter: $select.search" refresh="vm.filterCrmAccounts($select.search)" refresh-delay="0"><div ng-bind-html="account.lastName + \' \' + account.firstName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="data.crmOpportunity.crmAccount.firstName?(editForm.firstName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">First Name:</label> <input ng-disabled="data.crmOpportunity.crmAccount.id" type="text" name="name" ng-model="data.crmOpportunity.crmAccount.firstName" required id="field_name" class="form-control"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!data.crmOpportunity.crmAccount.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="data.crmOpportunity.crmAccount.firstName && editForm.firstName.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!data.crmOpportunity.crmAccount.firstName">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_middleName">Middle Name:</label> <input ng-disabled="data.crmOpportunity.crmAccount.id" type="text" ng-model="data.crmOpportunity.crmAccount.middleName" id="field_middleName" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="data.crmOpportunity.crmAccount.lastName?(editForm.lastName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_lastName">Last Name:</label> <input ng-disabled="data.crmOpportunity.crmAccount.id" type="text" name="name" ng-model="data.crmOpportunity.crmAccount.lastName" id="field_lastName" required="true" class="form-control input-sm"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!data.crmOpportunity.crmAccount.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="data.crmOpportunity.crmAccount.lastName && editForm.lastName.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!data.crmOpportunity.crmAccount.lastName">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="dob">D.O.B.:</label><div class="input-group input-group-sm"><input ng-disabled="data.crmOpportunity.crmAccount.id" type="text" class="form-control" id="dob" name="dob" placeholder="mm/dd/yyyy" ng-model="data.crmOpportunity.crmAccount.dob" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dob" datepicker-options="bodOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-sm" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="sex">Gender:</label> <select ng-disabled="data.crmOpportunity.crmAccount.id" class="form-control" id="sex" name="sex" ng-model="data.crmOpportunity.crmAccount.gender" ng-options="item as item for item in vm.gender track by item"></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="data.crmOpportunity.status?(editForm.status.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="status">Status:</label> <select name="status" id="status" class="form-control" required ng-model="data.crmOpportunity.status" ng-options="status as status.name for status in vm.status track by status.name"><option></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!data.crmOpportunity.status"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="data.crmOpportunity.status && editForm.status.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!data.crmOpportunity.status">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_priority">Priority:</label> <select name="priority" ng-model="data.crmOpportunity.priority" id="field_priority" class="form-control input-sm"><option value="HIGH">HIGH</option><option value="MID">MID</option><option value="LOW">LOW</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="tags">Tags:</label><ui-select ng-model="data.crmOpportunity.crmTags" name="tags" id="tags" reset-search-input="true" title="Tags" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a Tag ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="crmTag in vm.crmTags | filter: $select.search"><div ng-bind-html="crmTag.name"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="submit" class="btn btn-success btn-sm" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-employer-information.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_employer">Employer:</label> <input type="text" name="employer" id="field_employer" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_occupation">Occupation:</label> <input type="text" id="field_occupation" name="occupation" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_employerPhone">Phone:</label> <input type="text" id="field_employerPhone" name="employerPhone" class="form-control input-sm" ng-model="vm.opportunityEmployerPhone" ui-mask="(999) 999-9999"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-insurance-information.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_carrier">Carrier:</label> <select name="carrier" id="field_carrier" class="form-control input-sm"><option value="01">Carrier Name 01</option><option value="02">Carrier Name 02</option><option value="03">Carrier Name 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_policyNumber">Policy:</label> <input type="text" name="policyNumber" id="field_policyNumber" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_groupNumber">Group #:</label> <input type="text" name="groupNumber" id="field_groupNumber" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="field_preCertNumber">Pre-Cert #:</label> <input type="text" id="field_preCertNumber" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-7"><div class="form-group"><label for="field_subscriberAddress">Address:</label> <input type="text" class="form-control input-sm" id="field_subscriberAddress" name="subscriberAddress"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-5"><div class="form-group"><label for="field_subscriberAddress2">Address 2:</label> <input type="text" class="form-control input-sm" id="field_subscriberAddress2" name="subscriberAddress2"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_subscriberCity">City:</label> <input type="text" name="subscriberCity" id="field_subscriberCity" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_subscriberState">State:</label> <select name="subscriberState" id="field_subscriberState" class="form-control input-sm"><option value="01">Florida</option><option value="02">New York</option><option value="03">Arizona</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="field_subscriberZipcode">Zip Code:</label> <input type="text" class="form-control input-sm" id="field_subscriberZipcode" name="subscriberZipcode" ui-mask="99999" ng-model="vm.subscriberZipcode"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-insurance2-information.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_carrier">Carrier:</label> <select name="carrier" id="field_carrier" class="form-control input-sm"><option value="01">Carrier Name 01</option><option value="02">Carrier Name 02</option><option value="03">Carrier Name 03</option></select></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_policyNumber">Policy:</label> <input type="text" name="policyNumber" id="field_policyNumber" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_groupNumber">Group #:</label> <input type="text" name="groupNumber" id="field_groupNumber" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="field_preCertNumber">Pre-Cert #:</label> <input type="text" id="field_preCertNumber" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-7"><div class="form-group"><label for="field_subscriberAddress">Address:</label> <input type="text" class="form-control input-sm" id="field_subscriberAddress" name="subscriberAddress"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-5"><div class="form-group"><label for="field_subscriberAddress2">Address 2:</label> <input type="text" class="form-control input-sm" id="field_subscriberAddress2" name="subscriberAddress2"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_subscriberCity">City:</label> <input type="text" name="subscriberCity" id="field_subscriberCity" class="form-control input-sm"></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group"><label for="field_subscriberState">State:</label> <select name="subscriberState" id="field_subscriberState" class="form-control input-sm"><option value="01">Florida</option><option value="02">New York</option><option value="03">Arizona</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label for="field_subscriberZipcode">Zip Code:</label> <input type="text" class="form-control input-sm" id="field_subscriberZipcode" name="subscriberZipcode" ui-mask="99999" ng-model="vm.subscriberZipcode"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-lead-information.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_referralSrc">Referral Source:</label> <select name="referralSrc" id="field_referralSrc" class="form-control input-sm"><option value="01">Referral Name 01</option><option value="02">Referral Name 02</option><option value="03">Referral Name 03</option></select></div><div class="form-group"><label for="field_campaign">Campaign:</label> <select name="campaign" id="field_campaign" class="form-control input-sm"><option value="01">Campaign Name 01</option><option value="02">Campaign Name 02</option><option value="03">Campaign Name 03</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_marketer">Outreach:</label> <select name="marketer" id="field_marketer" class="form-control input-sm"><option value="01">Marketer Name 01</option><option value="02">Marketer Name 02</option><option value="03">Marketer Name 03</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_admissionRep">Admission Rep.:</label> <select name="admissionRep" id="field_admissionRep" class="form-control input-sm"><option value="01">Rep Name 01</option><option value="02">Rep Name 02</option><option value="03">Rep Name 03</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-outbound-referral.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_refFacility">Facility:</label> <select name="refFacility" id="field_refFacility" class="form-control input-sm"><option value="01">Referral Name 01</option><option value="02">Referral Name 02</option><option value="03">Referral Name 03</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_outboundMarketer">Outreach:</label> <select name="outboundMarketer" id="field_outboundMarketer" class="form-control input-sm"><option value="01">Marketer Name 01</option><option value="02">Marketer Name 02</option><option value="03">Marketer Name 03</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_referredTo">Referred To:</label> <select name="referredTo" id="field_referredTo" class="form-control input-sm"><option value="01">Referred Name 01</option><option value="02">Referred Name 02</option><option value="03">Referred Name 03</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><label for="field_doaToFacility">DOA To Facility:</label> <input type="date" name="doaToFacility" id="field_doaToFacility" class="form-control input-sm"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_outStatus">Status:</label> <select name="outStatus" id="field_outStatus" class="form-control input-sm"><option value="01">Outbound Status 01</option><option value="02">Outbound Status 02</option><option value="03">Outbound Status 03</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-ssn.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="">SSN:</label> <input type="text" class="form-control input-sm" ng-model="vm.opportunitySsn" ui-mask="999-99-9999"></div><div class="divider"></div><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/crm-opportunity/tpl/popup-targeted-information.html','<div class="popover-form"><form action=""><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_facility">Facility:</label> <select name="facility" id="field_facility" class="form-control input-sm"><option value="01">Awesome Facility Headcorp</option><option value="02">Cur mons persuadere</option><option value="03">Cur repressor messis</option></select></div><div class="form-group"><label for="field_admissionDate">Admission Date:</label> <input type="date" class="form-control input-sm" id="field_admissionDate" name="admissionDate"></div><div class="form-group"><label for="field_lvlOfCare">Level of Care:</label> <select name="levelOfCare" id="field_lvlOfCare" class="form-control input-sm"><option value="01">Cur devatio experimentum?</option><option value="02">Cur mons persuadere</option><option value="03">Cur repressor messis</option></select></div><div class="divider"></div><div class="form-group"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></div></form></div>');
$templateCache.put('app/entities/diagnoses/create/diagnoses-create-dialog.html','<form name="editForm" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create a Diagnoses</h4></div><div class="modal-body"><div class="row"><div class="col-lg-12"><jhi-alert-error></jhi-alert-error></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.icd10S.length > 0?(editForm.icd10.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_icd10">Diagnoses(ICD10):</label><ui-select name="icd10" id="field_icd10" title="icd10" multiple="multiple" ng-model="vm.diagnoses.icd10S" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.icd10 | filter: $select.search" minimun-input-length="1" refresh="vm.getIcd10($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' - \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.diagnoses.icd10S.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.diagnoses.icd10S.length > 0 && editForm.icd10.$dirty"></span> <span class="help-block" ng-show="!vm.diagnoses.icd10S.length > 0">This field is required</span></div><div class="text-right" style="margin-top: -20px"><search-icd10 chart="vm.chart.id" ng-model="vm.diagnoses.icd10S"></search-icd10></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.startDate?(editForm.startDate.$dirty && editForm.startDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.diagnoses.startDate" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.diagnoses.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.diagnoses.startDate && editForm.startDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.diagnoses.startDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.comment?(editForm.comment.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_comment">Comment</label> <textarea rows="3" type="text" class="form-control" name="comment" id="field_comment" data-resize="disabled" ng-model="vm.diagnoses.comment"></textarea> <span class="help-block help-warning" ng-show="!vm.diagnoses.comment">This field is suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" ng-click="vm.save()" class="btn btn-success" ng-if="vm.chart.status != \'CLOSED\' && !vm.diagnoses.signed" ng-disabled="editForm.$invalid || vm.form.signatureForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div></form>');
$templateCache.put('app/entities/diagnoses/discontinue/diagnoses-discontinue-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Discontinue Diagnoses</h4></div><div class="modal-body"><div class="row"><div class="col-lg-3"></div><div class="col-lg-6"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-3"></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6" style="padding-left: 105px;"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.endDate?(vm.form.diagnosesForm.endDate.$dirty && vm.form.diagnosesForm.endDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.diagnoses.endDate" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.diagnoses.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.diagnoses.endDate && vm.form.diagnosesForm.endDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.diagnoses.endDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.employeeSignature"><div class="form-group form-group-sm centered drawer-sign"><label for="physicianPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="physicianPin" name="physicianPin" maxlength="4" pattern="\\d{4}" ng-model="vm.employeeSignaturePin" ng-required="vm.employeeSignature === null" ng-change="vm.employeeSignature = \'\'" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="vm.employeeSignaturePin === null || vm.employeeSignaturePin === \'\'"><div class="form-group form-group-sm centered drawer-sign"><label>Or Sign Here:</label><ods-signature ng-model="vm.employeeSignature" options="vm.signatureOpts" name="physician_signature-{{vm.odsSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_employeeSignatureAgree"><input type="checkbox" name="employeeSignatureAgree" id="field_employeeSignatureAgree" ng-model="vm.employeeSignatureAgree"> I, {{vm.employee.firstName + \' \' + vm.employee.lastName}}, have reviewed, agree and understand the information contained here.</label></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.discontinue()" ng-disabled="!vm.employeeSignatureAgree || !(vm.employeeSignature || vm.employeeSignaturePin)"><i class="fa fa-ban" aria-hidden="true"></i> Discontinue</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/diagnoses/history/diagnoses-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Diagnoses History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Rank</strong></th><th><strong>Code</strong></th><th><strong>Description</strong></th><th></th></tr></thead><tbody><tr ng-repeat="diagnose in vm.diagnoses"><td>{{diagnose.rank}}</td><td>{{diagnose.code}}</td><td>{{diagnose.description}}</td><td><span ng-class="diagnose.signed ? \'label label-success\' : \'label label-danger\'">{{diagnose.signed ? \'Signed\' : \'Unsigned\'}}</span></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/diagnoses/update/diagnoses-dialog.html','<form name="editForm" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Edit Diagnoses</h4></div><div class="modal-body"><div class="row"><div class="col-lg-12"><jhi-alert-error></jhi-alert-error></div></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\' || vm.diagnoses.signed"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback"><label>{{vm.diagnoses.icd10.code}} - {{vm.diagnoses.icd10.description}}</label></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.startDate?(editForm.startDate.$dirty && editForm.startDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.diagnoses.startDate" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.diagnoses.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.diagnoses.startDate && editForm.startDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.diagnoses.startDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.endDate?(editForm.endDate.$dirty && editForm.endDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.diagnoses.endDate" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.diagnoses.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.diagnoses.endDate && editForm.endDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.diagnoses.endDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.diagnoses.comment?(editForm.comment.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_comment">Comment</label> <textarea rows="3" type="text" class="form-control" name="comment" id="field_comment" data-resize="disabled" ng-model="vm.diagnoses.comment"></textarea> <span class="help-block help-warning" ng-show="!vm.diagnoses.comment">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.diagnoses.signed"><label>Staff Signature</label><figure><img ng-src-sign="{{vm.diagnoses.signatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Provider: {{vm.diagnoses.signedBy.lastName + ", " + vm.diagnoses.signedBy.firstName}}, Date: {{vm.diagnoses.signature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div></div></fieldset></div><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.diagnoses.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" ng-click="vm.save()" class="btn btn-success" ng-if="vm.chart.status != \'CLOSED\' && !vm.diagnoses.signed" ng-disabled="editForm.$invalid || vm.form.signatureForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Diagnoses from this patient\'s record. Are you sure you want to <strong>delete</strong> this Diagnoses?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/diet/food-memo/diet-food-memo-dialog.html','<button type="button" class="pdf-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="25" height="25" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button> <object style="height: 90vh" type="application/pdf" data="{{vm.pdfBase64}}" width="100%" height="100%">');
$templateCache.put('app/entities/diet/history/diet-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Diets History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Food Diet Type</strong></th><th><strong>Start Date</strong></th><th><strong>End Date</strong></th></tr></thead><tbody><tr ng-repeat="diet in vm.diets"><td>{{diet.typeFoodDiets.name}}</td><td>{{diet.startDate | amDateFormat: amDateFormat}}</td><td>{{diet.endDate | amDateFormat: amDateFormat}}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/diet/update/diet-dialog.html','<form name="vm.form.dietForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myDietLabel">Create or Edit a Diet</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.diet.typeFoodDiets?(vm.form.dietForm.typeFoodDiets.$dirty ?\'has-success\':\'\'):\'has-error\'"><label for="field_typeFoodDiets">Food Diet Types:</label> <select class="form-control" id="field_typeFoodDiets" name="typeFoodDiets" required ng-model="vm.diet.typeFoodDiets" ng-options="typeFoodDiets as typeFoodDiets.name for typeFoodDiets in vm.typeFoodDiets track by typeFoodDiets.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.dietForm.typeFoodDiets.$error.required || vm.form.dietForm.typeFoodDiets.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.dietForm.typeFoodDiets.$dirty && vm.form.dietForm.typeFoodDiets.$valid"></span> <span class="help-block" ng-show="vm.form.dietForm.typeFoodDiets.$error.required || vm.form.dietForm.typeFoodDiets.$invalid">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.diet.startDate?(vm.form.dietForm.startDate.$valid && vm.form.dietForm.startDate.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" ng-model="vm.diet.startDate" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.diet.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.diet.startDate && vm.form.dietForm.startDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.diet.startDate || vm.form.dietForm.startDate.$invalid">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.diet.endDate?(vm.form.dietForm.endDate.$valid && vm.form.dietForm.endDate.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.diet.endDate" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.diet.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.diet.endDate && vm.form.dietForm.endDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.diet.endDate || vm.form.dietForm.endDate.$invalid">This field is suggested</span></div></div></div></div></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.diet.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button type="submit" class="btn btn-success" ng-disabled="vm.chart.status === \'CLOSED\' || vm.form.dietForm.$invalid || vm.form.dietForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Diet from this patient\'s record. Are you sure you want to <strong>delete</strong> this Diet?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/documo/list/documo.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/documo/update/documo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Create or edit a Documo</h4></div><div class="modal-body"><div class="row"><jhi-alert-error></jhi-alert-error></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.documo.token?(editForm.token.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_token">Token</label> <input type="text" class="form-control" name="token" id="field_token" required ng-model="vm.documo.token"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.documo.token"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.documo.token && editForm.token.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.documo.token">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/dose-form/list/dose-form.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/dose-form/update/dose-form-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myDoseFormLabel">Create or edit a Dose Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.doseForm.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.doseForm.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.doseForm.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.doseForm.name" required> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/drug/history/drug-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Drugs - History</h4></div><div class="modal-body"><div class="table-wrapper"><table class="table table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/drug/update/drug-dialog.html','<form name="vm.form.drug" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myDrugLabel">Create a new drug record</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.drug.date || vm.form.drug.date.$invalid?\'has-error\':(vm.drug.date && vm.form.drug.date.$dirty?\'has-success\':\'\')"><label for="field_date">Date:</label><div class="input-group input-group-sm"><input id="field_date" type="text" class="form-control" name="date" required ng-model="vm.drug.date" datetime-picker="{{inputDateTimeFormatA}}" datepicker-options="vm.dateOptions" is-open="vm.datePickerOpenStatus.date" validator="required" message-id="msg-drug-date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.drug.date || vm.form.drug.date.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.drug.date && vm.form.drug.date.$dirty"></span> <span class="help-block" ng-show="!vm.drug.date || vm.form.drug.date.$invalid">This field is required</span></div><div id="msg-drug-date"></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_barbiturate">Barbiturate (BAR):</label> <select name="barbiturate" class="form-control" required id="field_barbiturate" ng-model="vm.drug.barbiturate" ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_amphetamine">Amphetamine (AMP):</label> <select name="amphetamine" class="form-control" id="field_amphetamine" ng-model="vm.drug.amphetamine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_methadone">Methadone (MTD):</label> <select name="methadone" class="form-control" id="field_methadone" ng-model="vm.drug.methadone" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_opiates">Opiates (OPI):</label> <select name="opiates" class="form-control" id="field_opiates" ng-model="vm.drug.opiates" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_tetrahydrocannabinol">Tetrahydrocannabinol (THC):</label> <select name="tetrahydrocannabinol" class="form-control" id="field_tetrahydrocannabinol" ng-model="vm.drug.tetrahydrocannabinol" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_phencyclidine">Phencyclidine (PCP):</label> <select name="phencyclidine" class="form-control" id="field_phencyclidine" ng-model="vm.drug.phencyclidine" ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_benzodiazepine">Benzodiazepine (BZO):</label> <select name="benzodiazepine" class="form-control" id="field_benzodiazepine" ng-model="vm.drug.benzodiazepine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_oxycodone">Oxycodone (OXY):</label> <select name="oxycodone" class="form-control" id="field_oxycodone" ng-model="vm.drug.oxycodone" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_methamphetamine">Methamphetamine (MET):</label> <select name="methamphetamine" class="form-control" id="field_methamphetamine" ng-model="vm.drug.methamphetamine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_tricyclicAntidepressants">Tricyclic Antidepressants (TCA):</label> <select name="tricyclicAntidepressants" class="form-control" id="field_tricyclicAntidepressants" ng-model="vm.drug.tricyclicAntidepressants" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_buprenorphine">Buprenorphine (BUP):</label> <select name="buprenorphine" class="form-control" id="field_buprenorphine" ng-model="vm.drug.buprenorphine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_cocaine">Cocaine (COC):</label> <select name="cocaine" class="form-control" id="field_cocaine" ng-model="vm.drug.cocaine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_morphine">Morphine (MOP):</label> <select name="morphine" class="form-control" id="field_morphine" ng-model="vm.drug.morphine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_methylenedioxymethamphetamine">Methylenedioxymethamphetamine (MDMA):</label> <select name="methylenedioxymethamphetamine" class="form-control" id="field_methylenedioxymethamphetamine" ng-model="vm.drug.methylenedioxymethamphetamine" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_etg">Alcohol (ETG):</label> <select name="etg" class="form-control" id="field_etg" ng-model="vm.drug.etg" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_fyl">Fentanyl (FYL):</label> <select name="fyl" class="form-control" id="field_fyl" ng-model="vm.drug.fyl" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_fyl">K2 (K2):</label> <select name="k2" class="form-control" id="field_k2" ng-model="vm.drug.k2" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_ket">Ketamine (KET):</label> <select name="ket" class="form-control" id="field_ket" ng-model="vm.drug.ket" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_ket">Kratom (KRA):</label> <select name="kra" class="form-control" id="field_kra" ng-model="vm.drug.kra" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_ket">Tramadol (TML):</label> <select name="tml" class="form-control" id="field_tml" ng-model="vm.drug.tml" required ng-options="(item == null || item == 0 ? \'N/A\' : item  == 1 ? \'Positive\' : \'Negative\') for item in [-1, 0, 1]"></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.drug.description?(vm.form.drug.description.$valid && vm.form.drug.description.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_description">Description</label> <textarea class="form-control" name="description" id="field_description" data-resize="disabled" rows="4" ng-model="vm.drug.description"></textarea> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.drug.description"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.drug.description && vm.form.drug.description.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.drug.description">This field is Suggested</span></div></div></div><!-- /row --></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.drug.$error.required || vm.isSaving || vm.from.drug.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/employee/list/employee.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/employee/system/employee-system.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/employee/update/employee-dialog.html','<form name="vm.form.employee" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myEmployeeLabel">Create or edit a Employee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><fieldset><legend>Personal Info:</legend><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.title?(vm.form.employee.title.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_title">Title:</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.employee.title"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.title && vm.form.employee.title.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.employee.title">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.firstName?(vm.form.employee.firstName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_firstName">First Name:</label> <input type="text" class="form-control" name="firstName" id="field_firstName" required ng-model="vm.employee.firstName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.firstName && vm.form.employee.firstName.$dirty"></span> <span class="help-block" ng-show="!vm.employee.firstName">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.lastName?(vm.form.employee.lastName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_lastName">Last Name:</label> <input type="text" class="form-control" name="lastName" id="field_lastName" required ng-model="vm.employee.lastName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.lastName && vm.form.employee.lastName.$dirty"></span> <span class="help-block" ng-show="!vm.employee.lastName">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.gender?(vm.form.employee.gender.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_gender">Gender:</label> <select class="form-control" name="gender" id="field_gender" required ng-model="vm.employee.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.gender && vm.form.employee.gender.$dirty"></span> <span class="help-block" ng-show="!vm.employee.gender">This field es required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.mobile?(vm.form.employee.mobile.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_mobile">Mobile:</label> <input type="text" class="form-control" name="mobile" id="field_mobile" required ng-model="vm.employee.mobile" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.mobile"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.mobile && vm.form.employee.mobile.$dirty"></span> <span class="help-block" ng-show="!vm.employee.mobile">This field es required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.deaNumber?(vm.form.employee.deaNumber.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_deaNumber">DEA Number:</label> <input type="text" class="form-control" name="deaNumber" id="field_deaNumber" ng-model="vm.employee.deaNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.deaNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.deaNumber && vm.form.employee.deaNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.employee.deaNumber">This field es suggested</span></div></div><!--<span class="glyphicon glyphicon-ban-circle form-control-feedback"--><!--ng-show="!vm.employee.firstName"></span>--><!--<span class="glyphicon glyphicon-ok form-control-feedback"--><!--ng-show="vm.employee.firstName && vm.form.employee.firstName.$dirty"></span>--><!--<span class="help-block"--><!--ng-show="!vm.employee.firstName">This field is required</span>--><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.form.employee.pin.$error.required?\'has-error\':\'has-success\'"><label for="field_pin">Pin Number:</label> <input type="text" class="form-control" name="pin" id="field_pin" ng-model="vm.employee.pin" ng-required="!vm.employee.id" ui-mask="9999"><div ng-show="vm.form.employee.pin.$invalid && vm.form.employee.pin.$error.required"><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.pin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.pin && vm.form.employee.pin.$dirty"></span> <span class="help-block" ng-show="!vm.employee.pin">This field es required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.npiNumber?(vm.form.employee.npiNumber.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="npiNumber">NPI:</label> <input type="text" class="form-control" name="npiNumber" id="npiNumber" ng-model="vm.employee.npiNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.npiNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.npiNumber && vm.form.employee.npiNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.employee.npiNumber">This field es suggested</span></div></div></div><!-- /row --></fieldset><fieldset><legend>User Info</legend><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div class="row"><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.login?(vm.form.employee.login.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Login</label> <input type="text" class="form-control" name="login" ng-disabled="vm.employee.id" ng-model="vm.employee.login" ng-required="true" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-change="vm.searchUser(vm.employee.login)"> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.login.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.login.$error.maxlength">This field cannot be longer than 50 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.userExist">This username is already taken.</span></div></div><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.email?(vm.form.employee.email.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.employee.email" required ng-maxlength="100" ng-change="vm.searchEmail(vm.employee.email)"> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.email.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.email.$error.maxlength">This field cannot be longer than 100 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.email.$error.email">Your e-mail is invalid.</span> <span class="help-block" aria-hidden="true" ng-show="vm.emailExist">This email is already into the system.</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="vm.employee.password?(vm.form.employee.password.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="password">Password</label> <input type="password" class="form-control" id="password" name="password" placeholder="Password" ng-model="vm.employee.password" ng-required="vm.employee.id === null" ng-minlength="8" ng-maxlength="50" required> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.password.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.password.$error.minlength">Your password is required to be at least 8 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.password.$error.maxlength">Your password cannot be longer than 50 characters.</span><password-strength-bar password-to-check="vm.employee.password"></password-strength-bar></div></div><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.confirmPassword?(vm.form.employee.confirmPassword.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="confirmPassword">Password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the Password" ng-model="vm.employee.confirmPassword" ng-minlength="4" ng-maxlength="50" ng-required="vm.employee.id === null" compare-to="password"> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.notmatch">Your confirmation password not match.</span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.authorities.length > 0?(vm.form.employee.authorities.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Roles</label><ui-select ng-model="vm.employee.authorities" name="authority" id="authority" required reset-search-input="true" title="Roles" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a role name...">{{$item.name}}</ui-select-match><ui-select-choices repeat="authority in vm.authorities | filter: $select.search"><div ng-bind-html="authority.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block" aria-hidden="true" ng-show="vm.form.employee.authority.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.employee.authorities.length > 4">This field cannot have more than 4 roles.</span></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Credentials</label><ui-select ng-model="vm.employee.credentials" name="credential" id="credential" reset-search-input="true" title="Roles" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a credential ...">{{$item}}</ui-select-match><ui-select-choices repeat="item in vm.credentials | filter: $select.search"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Facilities</label><ui-select ng-model="vm.employee.facilities" name="facility" id="facilities" reset-search-input="true" title="Facilities" multiple="multiple" ng-disabled="vm.employee.corporation == null" close-on-select="false"><ui-select-match placeholder="Select facilities...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.facilities"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Physician Facilities</label><ui-select ng-model="vm.employee.pFacilities" name="pFacilities" id="pFacilities" reset-search-input="true" title="Facilities" multiple="multiple" ng-disabled="vm.employee.corporation == null" close-on-select="false"><ui-select-match placeholder="Select physician facilities...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.facilities"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="field_ip_address">Authorized Ips</label><ui-select multiple="multiple" name="ip_address" id="field_ip_address" title="Authorized Ips" ng-model="vm.employee.employeeInetAddresses" reset-search-input="true" close-on-select="false" tagging="vm.ipTagTransform" tagging-tokens="SPACE|,|/"><ui-select-match placeholder="Authorized Ips ...">{{$item.value}}</ui-select-match><ui-select-choices repeat="ip in vm.ips"><div ng-if="ip.isTag" ng-bind-html="(ip.value | highlight: $select.search) +\' (new)\'"></div><div ng-if="!ip.isTag" ng-bind-html="ip.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label><label for="field_activated">Active</label><br><toggle id="field_activated" ng-model="vm.employee.activated" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></label></div></div></div><div class="row"><div class="col-lg-12"><label>Signature:</label><ods-signature name="employee_signature-{{vm.odsSignatureNameId}}" id="field_employee_signature-{{vm.odsSignatureNameId}}" ng-model="vm.employeeSignature" options="vm.signatureOpts"></ods-signature></div></div></fieldset></div><div class="modal-footer"><button type="submit" ng-disabled="vm.form.employee.$invalid || vm.employee.authorities.length > 4 || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/employee/update-system/employee-dialog.html','<form name="vm.form.employee" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myEmployeeLabel">Create or edit a Employee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><fieldset><legend>Personal Info:</legend><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.title?(vm.form.employee.title.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_title">Title:</label> <input type="text" class="form-control" name="title" id="field_title" ng-model="vm.employee.title"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.title && vm.form.employee.title.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.employee.title">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.firstName?(vm.form.employee.firstName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_firstName">First Name:</label> <input type="text" class="form-control" name="firstName" id="field_firstName" required ng-model="vm.employee.firstName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.firstName && vm.form.employee.firstName.$dirty"></span> <span class="help-block" ng-show="!vm.employee.firstName">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.lastName?(vm.form.employee.lastName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_lastName">Last Name:</label> <input type="text" class="form-control" name="lastName" id="field_lastName" required ng-model="vm.employee.lastName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.lastName && vm.form.employee.lastName.$dirty"></span> <span class="help-block" ng-show="!vm.employee.lastName">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.gender?(vm.form.employee.gender.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_gender">Gender:</label> <select class="form-control" name="gender" id="field_gender" required ng-model="vm.employee.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.gender && vm.form.employee.gender.$dirty"></span> <span class="help-block" ng-show="!vm.employee.gender">This field es required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.mobile?(vm.form.employee.mobile.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_mobile">Mobile:</label> <input type="text" class="form-control" name="mobile" id="field_mobile" required ng-model="vm.employee.mobile" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.employee.mobile"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.mobile && vm.form.employee.mobile.$dirty"></span> <span class="help-block" ng-show="!vm.employee.mobile">This field es required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.deaNumber?(vm.form.employee.deaNumber.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_deaNumber">DEA Number:</label> <input type="text" class="form-control" name="deaNumber" id="field_deaNumber" ng-model="vm.employee.deaNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.deaNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.deaNumber && vm.form.employee.deaNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.employee.deaNumber">This field es suggested</span></div></div><!--<span class="glyphicon glyphicon-ban-circle form-control-feedback"--><!--ng-show="!vm.employee.firstName"></span>--><!--<span class="glyphicon glyphicon-ok form-control-feedback"--><!--ng-show="vm.employee.firstName && vm.form.employee.firstName.$dirty"></span>--><!--<span class="help-block"--><!--ng-show="!vm.employee.firstName">This field is required</span>--><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.form.employee.pin.$error.required?\'has-error\':\'has-success\'"><label for="field_pin">Pin Number:</label> <input type="text" class="form-control" name="pin" id="field_pin" ng-model="vm.employee.pin" ng-required="!vm.employee.id" ui-mask="9999"><div ng-show="vm.form.employee.pin.$invalid && vm.form.employee.pin.$error.required"><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.pin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.pin && vm.form.employee.pin.$dirty"></span> <span class="help-block" ng-show="!vm.employee.pin">This field es required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.employee.npiNumber?(vm.form.employee.npiNumber.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="npiNumber">NPI:</label> <input type="text" class="form-control" name="npiNumber" id="npiNumber" ng-model="vm.employee.npiNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.employee.npiNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.employee.npiNumber && vm.form.employee.npiNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.employee.npiNumber">This field es suggested</span></div></div></div><!-- /row --></fieldset><fieldset><legend>User Info</legend><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div class="row"><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.login?(vm.form.employee.login.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Login</label> <input type="text" class="form-control" name="login" ng-disabled="vm.employee.id" ng-model="vm.employee.login" ng-required="true" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" ng-change="vm.searchUser(vm.employee.login)"> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.login.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.login.$error.maxlength">This field cannot be longer than 50 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.userExist">This username is already taken.</span></div></div><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.email?(vm.form.employee.email.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Email</label> <input type="email" class="form-control" name="email" ng-model="vm.employee.email" required ng-maxlength="100" ng-change="vm.searchEmail(vm.employee.email)"> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.email.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.email.$error.maxlength">This field cannot be longer than 100 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.email.$error.email">Your e-mail is invalid.</span> <span class="help-block" aria-hidden="true" ng-show="vm.emailExist">This email is already into the system.</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="vm.employee.password?(vm.form.employee.password.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="password">Password</label> <input type="password" class="form-control" id="password" name="password" placeholder="Password" ng-model="vm.employee.password" ng-required="vm.employee.id === null" ng-minlength="8" ng-maxlength="50" required> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.password.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.password.$error.minlength">Your password is required to be at least 8 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.password.$error.maxlength">Your password cannot be longer than 50 characters.</span><password-strength-bar password-to-check="vm.employee.password"></password-strength-bar></div></div><div class="col-lg-6"><div class="form-group has-feedback" ng-class="vm.employee.confirmPassword?(vm.form.employee.confirmPassword.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="confirmPassword">Password confirmation</label> <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the Password" ng-model="vm.employee.confirmPassword" ng-minlength="4" ng-maxlength="50" ng-required="vm.employee.id === null" compare-to="password"> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</span> <span class="help-block" aria-hidden="true" ng-show="vm.form.employee.confirmPassword.$error.notmatch">Your confirmation password not match.</span></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Credentials</label><ui-select ng-model="vm.employee.credentials" name="credential" id="credential" reset-search-input="true" title="Roles" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a credential ...">{{$item}}</ui-select-match><ui-select-choices repeat="item in vm.credentials | filter: $select.search"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label><label for="field_activated">Active</label><br><toggle id="field_activated" ng-model="vm.employee.activated" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></label></div></div></div><div class="row"><div class="col-lg-12"><label>Signature:</label><ods-signature name="employee_signature-{{vm.odsSignatureNameId}}" id="field_employee_signature-{{vm.odsSignatureNameId}}" ng-model="vm.employeeSignature" options="vm.signatureOpts"></ods-signature></div></div></fieldset></div><div class="modal-footer"><button type="submit" ng-disabled="vm.form.employee.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation/billing-dates/evaluation-billing-dates.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Billing Intervals</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="!vm.evaluation.startBilling || editForm.startBilling.$error.required ? \'has-error\':(editForm.startBilling.$valid && editForm.startBilling.$dirty?\'has-success\':\'\')"><label for="field_startBilling">Service Date:</label><div class="input-group"><input type="text" class="form-control" name="startBilling" id="field_startBilling" ng-model="vm.evaluation.startBilling" ng-required="true" datetime-picker="{{inputDateTimeFormatA}}" datepicker-options="vm.startDateOptions" is-open="vm.datePickerOpenStatus.startBilling" ng-change="vm.changeStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startBilling\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div class="help-block" ng-show="editForm.startBilling.$error.required">This field is required</div></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.timeAmount.$error.min || editForm.timeAmount.$error.required?\n                             \'has-error\':(editForm.timeAmount.$valid && editForm.timeAmount.$dirty?\'has-success\':\'\')"><label for="field_timeAmount">Time Difference in minutes:</label> <input type="number" class="form-control" id="field_timeAmount" name="timeAmount" min="1" required ng-model="vm.dateDiff" ng-disabled="editForm.startBilling.$invalid" ng-model-options="{updateOn: \'blur\'}" ng-change="vm.calEndDate()"><div class="help-block" ng-show="editForm.timeAmount.$error.min">Invalid time difference</div><div class="help-block" ng-show="editForm.timeAmount.$error.required">This field is required</div></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="!vm.evaluation.endBilling || editForm.endBilling.$error.required ?\n                             \'has-error\':(editForm.endBilling.$valid && editForm.endBilling.$dirty?\'has-success\':\'\')"><label for="field_endBilling">End Date:</label><div class="input-group"><input type="text" class="form-control" name="endBilling" id="field_endBilling" ng-model="vm.evaluation.endBilling" ng-disabled="editForm.startBilling.$invalid" ng-required="true" datetime-picker="{{inputDateTimeFormatA}}" datepicker-options="vm.endDateOptions" is-open="vm.datePickerOpenStatus.endBilling" ng-change="vm.changeEndDate()"> <span class="input-group-btn"><button type="button" ng-disabled="editForm.startBilling.$invalid" class="btn btn-default" ng-click="vm.openCalendar(\'endBilling\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div class="help-block" ng-show="editForm.endBilling.$error.required">This field is required</div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation/day-of-service/evaluation-day-of-service.html','<form name="editform" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Date of Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="!vm.evaluation.dayOfService || editform.dayOfService.$error.required ? \'has-error\':(editform.dayOfService.$valid && editform.dayOfService.$dirty?\'has-success\':\'\')"><label for="field_dayOfService">Date of Service:</label><div class="input-group"><input type="text" class="form-control" name="dayOfService" id="field_dayOfService" ng-model="vm.evaluation.dayOfService" ng-required="true" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.dayOfService"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dayOfService\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div class="help-block" ng-show="editform.dayOfService.$error.required">This field is required</div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editform.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation/detail/evaluation-view.html','<section class="content no-padding"><div class="chart-layout"><header class="content-heading"><a ui-sref="chart({id: vm.evaluation.chartId, tabId: vm.TAB.EVALUATION})" class="btn-back-link" style="margin-right: auto"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to patient\'s chart </a><button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.chartSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Patient</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.guarantorSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Guarantor</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.staffSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Provider</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.staffReviewSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Reviewer</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.revokeChartSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Revoke</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.allowRevocation && !vm.evaluation.revokeChartSignatureId" ng-disabled="!vm.evaluation.chartSignatureId" ng-click="vm.showChartRevokeSignPopup()"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Sign Revoke</button><div class="btn-group btn-group-sm filters-box"><button type="button" class="btn btn-default" uib-tooltip="Fax" ng-click="vm.fax()"><i class="fa fa-fax" aria-hidden="true"></i></button> <button type="button" class="btn btn-default" style="border-radius: 0" uib-tooltip="Side by Side" ng-class="{\'active\': vm.sideBySide}" ng-click="vm.toggleSideBySide()"><i class="fa fa-columns" aria-hidden="true"></i></button> <button type="button" class="btn btn-default" style="border-radius: 0" uib-tooltip="Export PDF" ng-class="{\'active\': vm.pdfExport}" ng-click="vm.togglePdfExport()"><i class="fa fa-file-pdf-o" aria-hidden="true"></i></button> <button type="button" class="btn btn-default" uib-tooltip="Print" ng-click="vm.print()"><i class="fa fa-print" aria-hidden="true"></i></button></div><div class="side-options" ng-if="vm.sideBySide"><h4 class="text-center mt-0"><strong>Choose Previous Care & Deliveries</strong></h4><ul class="list-unstyled"><li><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-model-options="{ debounce: 300 }" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></li><li ng-repeat="evaluation in vm.evaluations"><div class="radio"><label><input type="radio" name="compare" id="field_compare" ng-model="vm.compareWith" ng-value="evaluation.id"> {{evaluation.name + (evaluation.title ? evaluation.title : "")}} {{evaluation.contactName != null ? \' (\' + evaluation.contactName + \')\' : \'\'}} <span class="date" ng-if="evaluation.dayOfService">{{evaluation.dayOfService | amDateFormat: dateFormat}}</span> <span class="date" ng-else-if="evaluation.startBilling">{{evaluation.startBilling | amDateFormat: amDateFormat}}</span></label></div></li></ul><footer class="footer"><button type="button" class="btn btn-success btn-sm" ng-disabled="!vm.compareWith || vm.isPrinting" ng-click="vm.open()"><i class="fa fa-check-circle" aria-hidden="true"></i> Open</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.sideBySide = false"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></footer></div><div class="side-options" ng-if="vm.pdfExport"><h4 class="text-center mt-0"><strong>Choose Pdf File</strong></h4><ul class="list-unstyled"><li><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.fileSearchQuery" ng-model-options="{ debounce: 300 }" ng-change="vm.getEvaluationFiles()"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></li><li ng-repeat="evaluationTemplateFile in vm.evaluationTemplateFiles"><div class="radio"><label><input type="radio" name="pdf_export_id" id="field_pdf_export_id" ng-model="vm.pdfExportId" ng-value="evaluationTemplateFile.id"> {{evaluationTemplateFile.file.name}}</label></div></li></ul><footer class="footer"><button type="button" class="btn btn-success btn-sm" ng-disabled="!vm.pdfExportId || vm.isPrinting" ng-click="vm.exportPdf()"><i class="fa fa-check-circle" aria-hidden="true"></i> Export</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.pdfExport = false"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></footer></div></header><div class="content-grid"><aside class="content-side" resizable r-directions="[\'right\']" r-flex="true"><section class="data-section with-pic"><div class="photo"><img class="photo" ng-src-auth="{{vm.chart}}" alt="Chart Photo"></div><div class="info"><h4 class="name mt-0">{{vm.chart.fullName}}</h4><p><strong>DOB:</strong> {{vm.chart.dateBirth | date: "MM/dd/yyyy"}}</p><p><strong>Mr#:</strong> {{vm.chart.mrNo}}</p><p><strong>P. Method:</strong> {{vm.chart.typePaymentMethods ? vm.chart.typePaymentMethods.name : \'-\'}}</p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Service Information</strong></h5><p class="mb-0" ng-if="!vm.evaluation.billable"><strong>Date of Service</strong> - <span>{{vm.evaluation.dayOfService | amDateFormat: dateFormat}}</span></p><p class="mb-0" ng-if="vm.evaluation.billable"><strong>Date</strong> - <span>{{vm.evaluation.startBilling | amDateFormat: amDateFormat}}</span> <span class="label label-warning" style="font-size: 11px">{{vm.dateDiff}} min</span></p><p class="mb-0" ng-if="vm.evaluation.billable"><strong>End Date</strong> - <span>{{vm.evaluation.endBilling | amDateFormat: amDateFormat}}</span></p></div></section><section class="data-section" has-any-authority="{{vm.accessCareCoordinationView}}"><div ui-view="chart-urgent-issue"></div></section><section class="data-section" ng-if="vm.evaluation.release"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Contact Information</strong> <a ng-click="vm.editContact(vm.contact.id)" class="btn-icon"><i class="fa fa-pencil" aria-hidden="true"></i></a></h5><p class="mb-0"><strong>Name</strong> - <span>{{vm.contact.fullName}}</span></p><p class="mb-0"><strong>Phone</strong> - <span>{{vm.contact.phone | phone}}</span></p><p class="mb-0"><strong>Alt Phone</strong> - <span>{{vm.contact.altPhone}}</span></p><p class="mb-0"><strong>Address</strong> - <span>{{vm.contact.address}} {{vm.contact.addressTwo}} {{vm.contact.city}}, {{vm.contact.countryState.state}} {{vm.contact.state}} {{vm.contact.zip}}</span></p><p class="mb-0"><strong>Relationship</strong> - <span>{{vm.contact.typePatientContactsRelationship.name}}</span></p></div></section><section class="data-section" ng-if="vm.evaluation.diagnosis"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Diagnosis</strong></h5><p class="mb-0" ng-repeat="diagnosis in vm.evaluationDiagnoses"><strong>{{diagnosis.icd10.code}}</strong> - <span>{{diagnosis.icd10.description}}</span></p></div></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Chief Complaint</strong></h5><p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p></div></section><section class="data-section" ng-if="vm.evaluation.allergies"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Allergies:</strong></h5><p class="mb-0 inline-list"><span ng-repeat="allergy in vm.evaluationAllergies">{{allergy.name}}</span></p></div></section><section class="data-section" ng-if="vm.evaluation.diets"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Diets:</strong></h5><p class="mb-0 inline-list"><span ng-repeat="diet in vm.evaluationDiets">{{diet.name}}</span></p></div></section><section class="data-section" ui-view="medications" ng-if="vm.evaluation.medications"></section><section class="data-section" ng-if="vm.evaluation.vital"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Vitals:</strong></h5><div ng-if="vm.evaluationVitals"><p class="text-center">- <strong>{{vm.evaluationVitals.date | amDateFormat: amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>BP</strong> - {{vm.evaluationVitals.bpSystolic}}/{{vm.evaluationVitals.bpDiastolic}}</span> <span><strong>Temp:</strong> - {{vm.evaluationVitals.temperature ? vm.evaluationVitals.temperature : \'-\'}}<sup>o</sup>F</span> <span><strong>Pul:</strong> - {{vm.evaluationVitals.pulse ? vm.evaluationVitals.pulse : \'-\'}}</span> <span><strong>Resp:</strong> - {{vm.evaluationVitals.respiration ? vm.evaluationVitals.respiration : \'-\'}}</span> <span><strong>0<sup>2</sup></strong> - {{vm.evaluationVitals.o2Saturation ? vm.evaluationVitals.o2Saturation : \'-\'}}</span></p></div></div></section><section class="data-section" ng-if="vm.evaluation.glucose"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Glucose:</strong></h5><p class="text-center" ng-if="vm.evaluationGlucose">- <strong>{{vm.evaluationGlucose.date | amDateFormat: amDateFormat}}</strong> -</p><p class="mb-0 inline-list" ng-if="vm.evaluationGlucose"><span><strong>Reading</strong> - {{vm.evaluationGlucose.reading}}</span> <span><strong>Type of Check:</strong> - {{vm.evaluationGlucose.typeCheck.name}}</span> <span><strong>Interventions:</strong> - {{vm.glucoseInterventions}}</span> <span><strong>Notes:</strong> - {{vm.evaluationGlucose.notes}}</span></p></div></section><section class="data-section" ng-if="vm.evaluation.weight"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Weight:</strong></h5><p class="text-center">- <strong>{{vm.evaluationWeight.date | amDateFormat:amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>Weight (Lb)</strong> - {{vm.evaluationWeight.weight}}</span> <span><strong>Height (ft & in):</strong> - {{vm.evaluationWeight.height ? vm.getHeightInchesToFeetInches(vm.evaluationWeight.height) : \'\'}}</span> <span><strong>BMI:</strong> - {{vm.evaluationWeight.bmi}}</span></p></div></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Latest Lab Results:</strong></h5><p class="mb-0"><span><strong>HIV I</strong> - Positive</span> <span><strong>HIV II</strong> - Positive</span> <span><strong>Flu</strong> - Negative</span> <span><strong>HEP C</strong> - Positive</span></p></div></section></aside><div class="content-area"><div class="main-form"><header class="header-form"><span class="title">{{vm.evaluation.name + (vm.evaluation.title ? vm.evaluation.title : "")}}</span></header><div class="evaluation-content"><div class="form-directive-wrapper"><ods-viewer schema="vm.jsonTemplate" config="vm.formCKEditorTokensConfig"></ods-viewer><div class="well signs-array"><div class="sign-item mb-15" ng-if="vm.evaluation.chartSignatureId"><figure><img ng-src-sign="{{vm.evaluation.chartSignatureId}}" id="chartSignatureId" alt="Chart Signature" width="300" class="img-responsive"><figcaption>Patient: {{vm.chart.fullName}}, Date: {{vm.evaluation.chartSignature.date | amDateFormat:amDateFormat}}</figcaption><figcaption ng-if="vm.evaluation.witnessEmployee">Witness By: {{vm.evaluation.witnessEmployee ? vm.evaluation.witnessEmployee.lastName +\', \'+ vm.evaluation.witnessEmployee.firstName : \'-\'}} {{vm.evaluation.witnessDate | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.guarantorSignatureId"><figure><img ng-src-sign="{{vm.evaluation.guarantorSignatureId}}" id="guarantorSignatureId" alt="Guarantor Signature" width="300" class="img-responsive"><figcaption>Guarantor: {{vm.evaluation.guarantor.fullName}}, Date: {{vm.evaluation.guarantorSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.staffSignatureId"><figure><img ng-src-sign="{{vm.evaluation.staffSignatureId}}" id="staffSignatureId" alt="Staff Signature" width="300" class="img-responsive"><figcaption>Staff: {{vm.evaluation.staffSignatureEmployee.firstName + \' \' + vm.evaluation.staffSignatureEmployee.lastName}}, Date: {{vm.evaluation.staffSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.staffReviewSignatureId && (vm.evaluation.staffReviewSignatureId != vm.evaluation.staffSignatureId)"><figure><img ng-src-sign="{{vm.evaluation.staffReviewSignatureId}}" id="staffReviewSignatureId" alt="Staff Review Signature" width="300" class="img-responsive"><figcaption>Staff Review: {{vm.evaluation.staffSignatureReviewEmployee.firstName + \' \' + vm.evaluation.staffSignatureReviewEmployee.lastName}}, Date: {{vm.evaluation.staffReviewSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.revokeChartSignatureId"><figure><img ng-src-sign="{{vm.evaluation.revokeChartSignatureId}}" id="revokeChartSignatureId" alt="Revoke Signature" width="300" class="img-responsive"><figcaption>Revoked By Patient: {{vm.chart.fullName}}, Date: {{vm.evaluation.revokeChartSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div></div><div class="attachments mb-15"><udt-attach-evaluation-file evaluation-id="{{vm.evaluation.id}}"></udt-attach-evaluation-file></div></div><div class="comment-section eval" ui-view="comments"></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/evaluation/edit-signature/evaluation-edit-signature.html','<form name="editform" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAllergiesLabel">Signature Date</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="!vm.signature.createdDate || editform.createdDate.$error.required ? \'has-error\':(editform.createdDate.$valid && editform.createdDate.$dirty?\'has-success\':\'\')"><label for="field_createdDate">Date:</label><div class="input-group"><input type="text" class="form-control" name="createdDate" id="field_createdDate" ng-model="vm.signature.createdDate" ng-required="true" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div><div class="help-block" ng-show="editform.createdDate.$error.required">This field is required</div></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editform.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation/history/evaluation-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Care & Deliveries History - ({{vm.process.name}})</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Name</strong></th><th><strong>Service Date</strong></th><th><strong>Deleted By</strong></th><th></th></tr></thead><tbody><tr ng-repeat="evaluationHistory in vm.evaluationsHistory"><td class="name">{{evaluationHistory.name}} {{evaluationHistory.contactName != null ? \' (\' + evaluationHistory.contactName + \')\' : \'\'}}</td><td class="created"><span class="date" ng-if="evaluationHistory.dayOfService">{{evaluationHistory.dayOfService | amDateFormat: dateFormat}}</span> <span class="date" ng-else-if="evaluationHistory.startBilling">{{evaluationHistory.startBilling | amDateFormat: amDateFormat}}</span></td><td>{{evaluationHistory.deletedByFirstName && evaluationHistory.deletedByLastName ? evaluationHistory.deletedByLastName + \', \' + evaluationHistory.deletedByFirstName : \'-\'}}</td><td><a class="dt-btn warning" ng-click="vm.retrieve(evaluationHistory.id)"><i class="fa fa-history"></i></a></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/evaluation/history-audit/evaluation-history-audit.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">{{vm.evaluation.name}} - Audit History</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Employee</strong></th><th><strong>Start Date</strong></th><th><strong>End Date</strong></th><th></th></tr></thead><tbody><tr ng-repeat="evaluationHistory in vm.evaluationsHistory"><td class="name">{{evaluationHistory.employee.firstName}} {{evaluationHistory.employee.lastName }}</td><td class="created"><span class="date" ng-if="evaluationHistory.startDate">{{evaluationHistory.startDate | date: inputDateTimeFormatA}}</span></td><td class="created"><span class="date" ng-if="evaluationHistory.endDate">{{evaluationHistory.endDate | date: inputDateTimeFormatA}}</span></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/evaluation/maintenance/evaluation-maintenance.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><form name="editForm" role="form" novalidate ng-submit="vm.updateCredentials()"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><button type="submit" class="btn btn-primary btn-lg" ng-disabled="editForm.$error.required || vm.isWorking || editForm.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Update Credentials</button><form name="searchForm" class="form"><div class="input-group input-group-lg"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div><div class="box-body"><div class="row"><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4 col-lg-offset-2"><div class="form-group form-group-sm has-feedback" ng-class="vm.filter.startDate?(editForm.startDate.$valid && editForm.startDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" ng-model="vm.filter.startDate" required="true" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.filter.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.filter.startDate && editForm.startDate.$dirty"></span><!--<span class="help-block help-warning"--><!--ng-show="!vm.filter.startDate || editForm.startDate.$invalid">This field is suggested</span>--></div></div></div><div class="col-xs-12 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.filter.endDate?(editForm.endDate.$valid && editForm.endDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.filter.endDate" required="true" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.filter.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.filter.endDate && editForm.endDate.$dirty"></span><!--<span class="help-block help-warning"--><!--ng-show="!vm.filter.endDate || editForm.endDate.$invalid">This field is suggested</span>--></div></div></div></div><table class="table table-hover" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div></div></form></section>');
$templateCache.put('app/entities/evaluation/master/evaluation-master.html','<assistant-menu ng-model="vm.assistants"></assistant-menu><section class="content no-padding"><div class="chart-layout"><header class="content-heading"><a ui-sref="chart({id: vm.evaluation.chartId, processId: vm.params.processId, processPage: 0, tabId: vm.TAB.EVALUATION})" class="btn-back-link" style="margin-right: auto"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to patient\'s chart </a><button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.chartSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Patient</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.guarantorSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Guarantor</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.staffSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Provider</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.staffReviewSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Reviewer</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.revokeChartSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Revoke</button> <a href="" class="btn-side-view" ng-class="{\'active\': vm.sideBySide}" ng-click="vm.toggleSideBySide()"><i class="fa fa-columns" aria-hidden="true"></i> </a><a href="" class="btn-print" ng-click="vm.print()"><i class="fa fa-print" aria-hidden="true"></i></a><div class="side-options" ng-if="vm.sideBySide"><h4 class="text-center mt-0"><strong>Choose Previous Care & Deliveries</strong></h4><ul class="list-unstyled"><li><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></li><li ng-repeat="evaluation in vm.evaluations"><div class="radio"><label><input type="radio" name="compare" id="field_compare" ng-model="vm.compareWith" ng-value="evaluation.id"> {{evaluation.name + (evaluation.title ? evaluation.title : "")}} {{evaluation.contactName != null ? \' (\' + evaluation.contactName + \')\' : \'\'}} <span class="date" ng-if="evaluation.dayOfService">{{evaluation.dayOfService | amDateFormat: dateFormat}}</span> <span class="date" ng-else-if="evaluation.startBilling">{{evaluation.startBilling | amDateFormat: amDateFormat}}</span></label></div></li></ul><footer class="footer"><button type="button" class="btn btn-success btn-sm" ng-click="vm.compare()"><i class="fa fa-check-circle" aria-hidden="true"></i> Compare</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.sideBySide = false"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></footer></div></header><div class="content-grid"><aside class="content-side" resizable r-directions="[\'right\']" r-flex="true"><section class="data-section with-pic"><div class="photo"><img class="photo" ng-src-auth="{{vm.chart}}" alt="Chart Photo"></div><div class="info"><h4 class="name mt-0">{{vm.chart.fullName}}</h4><p><strong>DOB:</strong> {{vm.chart.dateBirth | date: inputDateFormat}}</p><p><strong>Mr#:</strong> {{vm.chart.mrNo}}</p><p><strong>P. Method:</strong> {{vm.chart.typePaymentMethods ? vm.chart.typePaymentMethods.name : \'-\'}}</p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Service Information</strong> <a ng-if="vm.evaluation.billable" ng-click="vm.showBillingDatesPopup()" class="btn-icon"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a ng-if="!vm.evaluation.billable" ng-click="vm.showDateOfServicePopup()" class="btn-icon"><i class="fa fa-pencil" aria-hidden="true"></i></a></h5><p class="mb-0" ng-if="!vm.evaluation.billable"><strong>Date of Service</strong> - <span>{{vm.evaluation.dayOfService | amDateFormat: dateFormat}}</span></p><p class="mb-0" ng-if="vm.evaluation.billable"><strong>Date</strong> - <span>{{vm.evaluation.startBilling | amDateFormat: amDateFormat}}</span> <span class="label label-warning" style="font-size: 11px">{{vm.dateDiff}} min</span></p><p class="mb-0" ng-if="vm.evaluation.billable"><strong>End Date</strong> - <span>{{vm.evaluation.endBilling | amDateFormat: amDateFormat}}</span></p></div></section><section class="data-section" ng-if="vm.evaluation.release"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Contact Information</strong> <a ng-click="vm.editContact(vm.contact.id)" class="btn-icon"><i class="fa fa-pencil" aria-hidden="true"></i></a></h5><p class="mb-0"><strong>Name</strong> - <span>{{vm.contact.fullName}}</span></p><p class="mb-0"><strong>Phone</strong> - <span>{{vm.contact.phone | phone}}</span></p><p class="mb-0"><strong>Alt Phone</strong> - <span>{{vm.contact.altPhone}}</span></p><p class="mb-0"><strong>Address</strong> - <span>{{vm.contact.address}} {{vm.contact.addressTwo}} {{vm.contact.city}}, {{vm.contact.countryState.state}} {{vm.contact.state}} {{vm.contact.zip}}</span></p><p class="mb-0"><strong>Relationship</strong> - <span>{{vm.contact.typePatientContactsRelationship.name}}</span></p></div></section><section class="data-section" ui-view="diagnoses" ng-if="vm.evaluation.diagnosis"></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Chief Complaint</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p></div></section><section class="data-section" ui-view="allergies" ng-if="vm.evaluation.allergies"></section><section class="data-section" ui-view="diets" ng-if="vm.evaluation.diets"></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Current Medications:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 inline-list"><span>Aspirin</span> <span>Lorem Medicum</span> <span>Benadrylmiun</span> <span>LoremIpsumAspertum</span> <span>Aspirin</span> <span>Lorem Medicum</span> <span>Benadrylmiun</span> <span>LoremIpsumAspertum</span></p></div></section><section class="data-section" ui-view="vitals" ng-if="vm.evaluation.vital"></section><section class="data-section" ui-view="glucose" ng-if="vm.evaluation.glucose"></section><section class="data-section" ui-view="weight" ng-if="vm.evaluation.weight"></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Latest Lab Results:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0"><span><strong>HIV I</strong> - Positive</span> <span><strong>HIV II</strong> - Positive</span> <span><strong>Flu</strong> - Negative</span> <span><strong>HEP C</strong> - Positive</span></p></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Signatures:</strong></h5><p class="mb-0" ng-click="vm.editSignature(vm.evaluation.chartSignature)"><span ng-if="vm.evaluation.chartSignature"><strong>Chart Signature: </strong>{{vm.evaluation.chartSignature.date | amDateFormat:amDateFormat}}</span></p><p class="mb-0" ng-click="vm.editSignature(vm.evaluation.guarantorSignature)"><span ng-if="vm.evaluation.guarantorSignature"><strong>Guarantor Signature: </strong>{{vm.evaluation.guarantorSignature.date | amDateFormat:amDateFormat}}</span></p><p class="mb-0" ng-click="vm.editSignature(vm.evaluation.staffSignature)"><span ng-if="vm.evaluation.staffSignature"><strong>Provider Signature: </strong>{{vm.evaluation.staffSignature.date | amDateFormat:amDateFormat}}</span></p><p class="mb-0" ng-click="vm.editSignature(vm.evaluation.staffReviewSignature)"><span ng-if="vm.evaluation.staffReviewSignature"><strong>Reviewer Signature: </strong>{{vm.evaluation.staffReviewSignature.date | amDateFormat:amDateFormat}}</span></p><p class="mb-0" ng-click="vm.editSignature(vm.evaluation.revokeChartSignature)"><span ng-if="vm.evaluation.revokeChartSignature"><strong>Revoke Signature: </strong>{{vm.evaluation.revokeChartSignature.date | amDateFormat:amDateFormat}}</span></p></div></section></aside><div class="content-area"><div class="side-form" resizable r-directions="[\'right\']" r-flex="true" ng-if="vm.sideForm"><header class="header-form"><span class="title">{{vm.compareEvaluation.name + (vm.compareEvaluation.title ? vm.compareEvaluation.title : "")}}</span> <a href="" class="close-side" ng-click="vm.sideForm = !vm.sideForm"><i class="fa fa-times-circle" aria-hidden="true"></i></a></header><div class="evaluation-content"><div class="form-directive-wrapper"><ods-form schema="vm.compareJsonTemplate" config="vm.compareTokens"></ods-form></div><div class="comment-section eval" ui-view="comments"></div></div></div><div class="main-form"><header class="header-form"><span class="title" style="max-width: 100%;">{{vm.getHumanTitle()}}</span></header><div class="evaluation-content"><div class="form-directive-wrapper"><ods-form schema="vm.jsonTemplate" config="vm.formCKEditorTokensConfig"></ods-form><div class="well signs-array"><div class="sign-item mb-15" ng-if="vm.evaluation.chartSignatureId"><figure><img ng-src-sign="{{vm.evaluation.chartSignatureId}}" id="chartSignatureId" alt="Chart Signature" width="300" class="img-responsive"><figcaption>Patient: {{vm.chart.fullName}}, Date: {{vm.evaluation.chartSignature.date | amDateFormat:amDateFormat}}</figcaption><figcaption ng-if="vm.evaluation.witnessEmployee">Witness By: {{vm.evaluation.witnessEmployee ? vm.evaluation.witnessEmployee.lastName +\', \'+ vm.evaluation.witnessEmployee.firstName : \'-\'}} {{vm.evaluation.witnessDate | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.guarantorSignatureId"><figure><img ng-src-sign="{{vm.evaluation.guarantorSignatureId}}" id="guarantorSignatureId" alt="Guarantor Signature" width="300" class="img-responsive"><figcaption>Guarantor: {{vm.evaluation.guarantor.fullName}}, Date: {{vm.evaluation.guarantorSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.staffSignatureId"><figure><img ng-src-sign="{{vm.evaluation.staffSignatureId}}" id="staffSignatureId" alt="Staff Signature" width="300" class="img-responsive"><figcaption>Staff: {{vm.evaluation.staffSignatureEmployee.firstName + \' \' + vm.evaluation.staffSignatureEmployee.lastName}}, Date: {{vm.evaluation.staffSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.staffReviewSignatureId && (vm.evaluation.staffReviewSignatureId != vm.evaluation.staffSignatureId)"><figure><img ng-src-sign="{{vm.evaluation.staffReviewSignatureId}}" id="staffReviewSignatureId" alt="Staff Review Signature" width="300" class="img-responsive"><figcaption>Staff Review: {{vm.evaluation.staffSignatureReviewEmployee.firstName + \' \' + vm.evaluation.staffSignatureReviewEmployee.lastName}}, Date: {{vm.evaluation.staffReviewSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.revokeChartSignatureId"><figure><img ng-src-sign="{{vm.evaluation.revokeChartSignatureId}}" id="revokeChartSignatureId" alt="Revoke Signature" width="300" class="img-responsive"><figcaption>Revoked By Patient: {{vm.chart.fullName}}, Date: {{vm.evaluation.revokeChartSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div></div><div class="attachments mb-15"><udt-attach-evaluation-file evaluation-id="{{vm.evaluation.id}}"></udt-attach-evaluation-file></div><div class="comment-section eval" ui-view="comments"></div></div></div><!--                    <div ui-view="super-bill" class="form-container"></div>--></div></div></div></div></section><assistant-clipboard ng-model="assistantList" ng-if="showAssitant"></assistant-clipboard>');
$templateCache.put('app/entities/evaluation/update/evaluation-edit.html','<assistant-menu ng-model="vm.assistants"></assistant-menu><section class="content no-padding"><div class="chart-layout"><header class="content-heading"><a ui-sref="chart({id: vm.evaluation.chartId, processId: vm.params.processId, processPage: 0, tabId: vm.TAB.EVALUATION})" class="btn-back-link" style="margin-right: auto"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back to patient\'s chart </a><button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.chartSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Patient</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.requiredPatientSignature && !vm.evaluation.chartSignatureId" ng-disabled="(vm.evaluation.billable && (!vm.evaluation.startBilling || !vm.evaluation.endBilling)) ||\n                            (!vm.evaluation.billable && !vm.evaluation.dayOfService)" ng-click="vm.showChartSignPopup()"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Sign Patient</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.guarantorSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Guarantor</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.requiredGuarantorSignature && !vm.evaluation.guarantorSignatureId" ng-disabled="!vm.enableGuarantorSignature || (vm.evaluation.billable && (!vm.evaluation.startBilling || vm.evaluation.endBilling)) ||\n                            (!vm.evaluation.billable && !vm.evaluation.dayOfService)" ng-click="vm.showGuarantorSignPopup()"><i class="{{vm.guarantorSignatureButtonStyle}}" aria-hidden="true"></i> Sign Guarantor</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.staffSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Provider</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.forceStaffSignature && !vm.evaluation.staffSignatureId" ng-disabled="!vm.enableStaffSignature || (vm.evaluation.billable && (!vm.evaluation.startBilling || !vm.evaluation.endBilling)) ||\n                            (!vm.evaluation.billable && !vm.evaluation.dayOfService)" ng-click="vm.showStaffSignPopup()"><i class="{{vm.staffSignatureButtonStyle}}" aria-hidden="true"></i> Sign Provider</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.staffReviewSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Reviewer</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.forceStaffReviewSignature && !vm.evaluation.staffReviewSignatureId && vm.evaluation.status == \'InReview\'" ng-disabled="!vm.enableStaffReviewerSignature || (vm.evaluation.billable && (!vm.evaluation.startBilling || !vm.evaluation.endBilling)) ||\n                            (!vm.evaluation.billable && !vm.evaluation.dayOfService)" ng-click="vm.showStaffReviewSignPopup()"><i class="{{vm.staffReviewSignatureButtonStyle}}" aria-hidden="true"></i> Sign Reviewer</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.revokeChartSignatureId"><i class="fa fa-check-square-o" aria-hidden="true"></i> Sign Revoke</button> <button type="button" class="btn btn-default btn-sm" ng-if="vm.evaluation.allowRevocation && !vm.evaluation.revokeChartSignatureId" ng-disabled="!vm.evaluation.chartSignatureId" ng-click="vm.showChartRevokeSignPopup()"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Sign Revoke</button> <a href="" class="btn-side-view" ng-class="{\'active\': vm.sideBySide}" ng-click="vm.toggleSideBySide()" uib-tooltip="Compare"><i class="fa fa-columns" aria-hidden="true"></i> </a><a href="" class="btn-print" ng-click="vm.print()" uib-tooltip="Print"><i class="fa fa-print" aria-hidden="true"></i> </a><a href="" class="btn-print" ng-if="vm.evaluation.status == \'Pending\' || vm.evaluation.status == \'Late\'" ng-click="vm.restart()" uib-tooltip="Restart"><i class="fa fa-refresh" aria-hidden="true"></i></a><div class="side-options" ng-if="vm.sideBySide"><h4 class="text-center mt-0"><strong>Choose Previous Care & Deliveries</strong></h4><ul class="list-unstyled"><li><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></li><li ng-repeat="evaluation in vm.evaluations"><div class="radio"><label><input type="radio" name="compare" id="field_compare" ng-model="vm.compareWith" ng-value="evaluation.id"> {{evaluation.name + (evaluation.title ? evaluation.title : "")}} {{evaluation.contactName != null ? \' (\' + evaluation.contactName + \')\' : \'\'}} <span class="date" ng-if="evaluation.dayOfService">{{evaluation.dayOfService | amDateFormat: dateFormat}}</span> <span class="date" ng-else-if="evaluation.startBilling">{{evaluation.startBilling | amDateFormat: amDateFormat}}</span></label></div></li></ul><footer class="footer"><button type="button" class="btn btn-success btn-sm" ng-click="vm.compare()"><i class="fa fa-check-circle" aria-hidden="true"></i> Compare</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.sideBySide = false"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></footer></div></header><div class="content-grid"><aside class="content-side" resizable r-directions="[\'right\']" r-flex="true"><section class="data-section with-pic"><div class="photo"><img class="photo" ng-src-auth="{{vm.chart}}" alt="Chart Photo"></div><div class="info"><h4 class="name mt-0">{{vm.chart.fullName}}</h4><p><strong>DOB:</strong> {{vm.chart.dateBirth | date: inputDateFormat}}</p><p><strong>Mr#:</strong> {{vm.chart.mrNo}}</p><p><strong>P. Method:</strong> {{vm.chart.typePaymentMethods ? vm.chart.typePaymentMethods.name : \'-\'}}</p></div></section><section class="data-section" has-any-authority="{{vm.accessCareCoordinationView}}"><div ui-view="chart-urgent-issue"></div></section><section class="data-section"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Service Information</strong> <a ng-if="vm.evaluation.billable" ng-click="vm.showBillingDatesPopup()" class="btn-icon" uib-tooltip="Edit Service Information"><i class="fa fa-pencil" aria-hidden="true"></i> </a><a ng-if="!vm.evaluation.billable" ng-click="vm.showDateOfServicePopup()" uib-tooltip="Edit Service Information" class="btn-icon"><i class="fa fa-pencil" aria-hidden="true"></i></a></h5><p class="mb-0" ng-if="!vm.evaluation.billable"><strong>Date of Service</strong> - <span>{{vm.evaluation.dayOfService | amDateFormat: dateFormat}}</span></p><p class="mb-0" ng-if="vm.evaluation.billable"><strong>Date</strong> - <span>{{vm.evaluation.startBilling | amDateFormat: amDateFormat}}</span> <span class="label label-warning" style="font-size: 11px">{{vm.dateDiff}} min</span></p><p class="mb-0" ng-if="vm.evaluation.billable"><strong>End Date</strong> - <span>{{vm.evaluation.endBilling | amDateFormat: amDateFormat}}</span></p></div></section><section class="data-section" ng-if="vm.evaluation.billable"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Level of Care</strong></h5><p class="mb-0"><select class="form-control" id="field_levelCare" name="typeLevelCare" ng-model="vm.evaluation.typeLevelCare" ng-change="vm.autoSaveLoc()" ng-options="item as item.name for item in vm.typeLevelCare track by item.name"></select></p></div></section><section class="data-section" ng-if="vm.evaluation.release"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Contact Information</strong> <a ng-click="vm.editContact(vm.contact.id)" class="btn-icon"><i class="fa fa-pencil" aria-hidden="true"></i></a></h5><p class="mb-0"><strong>Name</strong> - <span>{{vm.contact.fullName}}</span></p><p class="mb-0"><strong>Phone</strong> - <span>{{vm.contact.phone | phone}}</span></p><p class="mb-0"><strong>Alt Phone</strong> - <span>{{vm.contact.altPhone}}</span></p><p class="mb-0"><strong>Address</strong> - <span>{{vm.contact.address}} {{vm.contact.addressTwo}} {{vm.contact.city}}, {{vm.contact.countryState.state}} {{vm.contact.state}} {{vm.contact.zip}}</span></p><p class="mb-0"><strong>Relationship</strong> - <span>{{vm.contact.typePatientContactsRelationship.name}}</span></p></div></section><section class="data-section" ui-view="diagnoses" ng-if="vm.evaluation.diagnosis"></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Chief Complaint</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo.</p></div></section><section class="data-section" ui-view="allergies" ng-if="vm.evaluation.allergies"></section><section class="data-section" ui-view="diets" ng-if="vm.evaluation.diets"></section><section class="data-section" ui-view="medications" ng-if="vm.evaluation.medications"></section><section class="data-section" ui-view="vitals" ng-if="vm.evaluation.vital"></section><section class="data-section" ui-view="glucose" ng-if="vm.evaluation.glucose"></section><section class="data-section" ui-view="weight" ng-if="vm.evaluation.weight"></section><section class="data-section" ng-if="false"><div class="info no-padding"><h5 class="header-label mt-0"><strong>Latest Lab Results:</strong> <a href="" class="btn-icon"><i class="fa fa-history" aria-hidden="true"></i></a> <a href="" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0"><span><strong>HIV I</strong> - Positive</span> <span><strong>HIV II</strong> - Positive</span> <span><strong>Flu</strong> - Negative</span> <span><strong>HEP C</strong> - Positive</span></p></div></section><section class="data-section" ng-if="vm.evaluation.forceStaffSignature && !vm.evaluation.staffSignatureId"><div class="info no-padding"><h5 class="header-label mt-0"><strong ng-if="vm.enableStaffSignature">Provider Credentials</strong> <strong ng-if="!vm.enableStaffSignature" class="label-danger" style="font-size: 11px">Provider Credentials </strong><span ng-if="!vm.enableStaffSignature"><strong>(no match)</strong></span></h5><p class="mb-0"><span><strong>{{ vm.getCredentials(vm.evaluation.staffSignatureCredentials) }}</strong></span></p></div></section><section class="data-section" ng-if="vm.evaluation.forceStaffReviewSignature && !vm.evaluation.staffReviewSignatureId"><div class="info no-padding"><h5 class="header-label mt-0"><strong ng-if="vm.enableStaffReviewerSignature">Reviewer Credentials</strong> <strong ng-if="!vm.enableStaffReviewerSignature" class="label label-danger" style="font-size: 11px">Reviewer Credentials </strong><span ng-if="!vm.enableStaffReviewerSignature"><strong>(no match)</strong></span></h5><p class="mb-0"><span><strong>{{ vm.getCredentials(vm.evaluation.staffReviewSignatureCredentials) }}</strong></span></p></div></section></aside><div class="content-area"><div class="side-form" resizable r-directions="[\'right\']" r-flex="true" ng-if="vm.sideForm"><header class="header-form"><span class="title">{{vm.compareEvaluation.name + (vm.compareEvaluation.title ? vm.compareEvaluation.title : "")}}</span> <a href="" class="close-side" ng-click="vm.sideForm = !vm.sideForm"><i class="fa fa-times-circle" aria-hidden="true"></i></a></header><div class="evaluation-content"><div class="form-directive-wrapper"><ods-form schema="vm.compareJsonTemplate" config="vm.compareTokens"></ods-form></div><div class="comment-section eval" ui-view="comments"></div></div></div><div class="main-form"><header class="header-req" ng-if="(vm.evaluation.billable && (!vm.evaluation.startBilling || !vm.evaluation.endBilling)) ||\n                            (!vm.evaluation.billable && !vm.evaluation.dayOfService)"><span class="title">Please provide start and end date before signing this care and delivery</span></header><header class="header-form"><span class="title" style="max-width: 100%;">{{vm.getHumanTitle()}}</span></header><div class="evaluation-content"><div class="form-directive-wrapper"><ods-form schema="vm.jsonTemplate" config="vm.formCKEditorTokensConfig"></ods-form><div class="well signs-array"><div class="sign-item mb-15" ng-if="vm.evaluation.chartSignatureId"><figure><img ng-src-sign="{{vm.evaluation.chartSignatureId}}" id="chartSignatureId" alt="Chart Signature" width="300" class="img-responsive"><figcaption>Patient: {{vm.chart.fullName}}, Date: {{vm.evaluation.chartSignature.date | amDateFormat:amDateFormat}}</figcaption><figcaption ng-if="vm.evaluation.witnessEmployee">Witness By: {{vm.evaluation.witnessEmployee ? vm.evaluation.witnessEmployee.lastName + \', \' + vm.evaluation.witnessEmployee.firstName : \'-\'}} {{vm.evaluation.witnessDate | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.guarantorSignatureId"><figure><img ng-src-sign="{{vm.evaluation.guarantorSignatureId}}" id="guarantorSignatureId" alt="Guarantor Signature" width="300" class="img-responsive"><figcaption>Guarantor: {{vm.evaluation.guarantor.fullName}}, Date: {{vm.evaluation.guarantorSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.staffSignatureId"><figure><img ng-src-sign="{{vm.evaluation.staffSignatureId}}" id="staffSignatureId" alt="Staff Signature" width="300" class="img-responsive"><figcaption>Staff: {{vm.evaluation.staffSignatureEmployee.firstName + \' \' + vm.evaluation.staffSignatureEmployee.lastName}}, Date: {{vm.evaluation.staffSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.staffReviewSignatureId && (vm.evaluation.staffReviewSignatureId != vm.evaluation.staffSignatureId)"><figure><img ng-src-sign="{{vm.evaluation.staffReviewSignatureId}}" id="staffReviewSignatureId" alt="Staff Review Signature" width="300" class="img-responsive"><figcaption>Staff Review: {{vm.evaluation.staffSignatureReviewEmployee.firstName + \' \' + vm.evaluation.staffSignatureReviewEmployee.lastName}}, Date: {{vm.evaluation.staffReviewSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.evaluation.revokeChartSignatureId"><figure><img ng-src-sign="{{vm.evaluation.revokeChartSignatureId}}" id="revokeChartSignatureId" alt="Revoke Signature" width="300" class="img-responsive"><figcaption>Revoked By Patient: {{vm.chart.fullName}}, Date: {{vm.evaluation.revokeChartSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div></div><div class="attachments mb-15"><udt-attach-evaluation-file evaluation-id="{{vm.evaluation.id}}"></udt-attach-evaluation-file></div><div class="comment-section eval" ui-view="comments"></div></div></div><!--                    <div ui-view="super-bill" class="form-container"></div>--></div></div></div></div></section><assistant-clipboard ng-model="assistantList" ng-if="showAssitant"></assistant-clipboard>');
$templateCache.put('app/entities/evaluation-allergy/history/evaluation-allergies-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Allergies History</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-hover"><thead><tr><th><strong>Name</strong></th><th><strong>Allergen</strong></th><th><strong>Severity</strong></th><th><strong>Reaction Date</strong></th><th width="30%"><strong>Reactions</strong></th></tr></thead><tbody><tr ng-repeat="allergy in vm.allergiesInactive"><td>{{allergy.name}}</td><td>{{allergy.allergen.name}}</td><td>{{allergy.severity.name}}</td><td>{{allergy.reactionDate | date : inputDateFormat}}</td><td width="30%">{{allergy.reaction}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/evaluation-allergy/list/evaluation-allergy.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Allergies:</strong> <a ng-click="vm.history()" class="btn-icon"><i class="fa fa-history" aria-hidden="true" uib-tooltip="History"></i></a> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true" uib-tooltip="Add Allergy"></i></a></h5><p class="mb-0 inline-list"><span ng-repeat="allergy in vm.evaluationAllergies" ng-click="vm.edit(allergy)">{{allergy.name}}</span></p></div>');
$templateCache.put('app/entities/evaluation-audit/list/evaluation-audit.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation-audit/update/evaluation-audit-dialog.html','<form name="vm.form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySpecimeLabel">Create or edit a Evaluation Audit</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.evaluationAudit.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.evaluationAudit.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.evaluationAudit.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.evaluationAudit.name"> <span class="help-block" ng-show="!vm.evaluationAudit.name || editForm.name.$error.required">This field is required.</span></div><div class="row condition-controls" id="report-condition" ng-repeat="evaluationAuditTemplate in vm.evaluationAuditTemplates"><div class="col-xs-10 col-sm-10 col-md-10 col-lg-11"><div class="row"><div class="col-xs-12 col-sm-12 col-md-10 col-lg-10"><div class="form-group form-group-sm has-feedback" ng-class="evaluationAuditTemplate.evaluationTemplates.length == 0 ? \'has-error\' : \'has-success\'"><label>Select Care & Delivery Template:</label><ui-select id="field_template{{$index}}" name="template{{$index}}" title="Select template..." reset-search-input="true" close-on-select="false" ng-model="evaluationAuditTemplate.evaluationTemplates" multiple="multiple"><ui-select-match placeholder="Select template...">{{$item.name}}</ui-select-match><ui-select-choices repeat="evaluationTemplate in vm.evaluationTemplates | filter: $select.search" refresh="vm.getEvaluationTemplates($select.search)" refresh-delay="0"><div ng-bind-html="evaluationTemplate.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block" ng-show="evaluationAuditTemplate.evaluationTemplates.length == 0">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-2 col-lg-2"><div class="form-group form-group-sm has-feedback" ng-class="evaluationAuditTemplate.quantity == null ? \'has-error\' : \'has-success\'"><label>Quantity:</label> <input type="number" name="quantity{{$index}}" id="field_quantity{{$index}}" class="form-control" ng-model="evaluationAuditTemplate.quantity"> <span class="help-block" ng-show="evaluationAuditTemplate.quantity == null">This field is required.</span></div></div></div></div><div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 text-right"><label class="blank hidden-xs">&nbsp;</label><br><button type="button" class="btn btn-danger btn-sm" ng-disabled="vm.evaluationAuditTemplates.length == 1" ng-click="vm.del($index)"><i class="fa fa-remove" aria-hidden="true"></i></button></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" style="margin-right: auto" ng-click="vm.add()"><i class="fa fa-plus" aria-hidden="true"></i> Add</button> <button type="submit" class="btn btn-success" ng-disabled="vm.form.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-comment/list/evaluation-comment.html','<div class="comments"><div class="comment" ng-repeat="comment in vm.comments"><div class="text"><p class="mb-0"><strong class="author">{{comment.employee | employeeName}}</strong> [ {{comment.createdDate | amDateFormat: amDateFormat}} ]:</p><p class="mb-0">{{comment.comment}}</p></div><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(comment.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.del(comment.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></div><div class="fright" ng-if="vm.totalItems > 0"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div><div class="comment" ng-if="vm.totalItems == 0"><div class="text"><p class="mb-0"><strong>There is no Care & Delivery comment yet</strong></p></div></div><div class="add-comment"><div class="input-group"><input type="text" class="form-control" ng-model="vm.comment" id="field_comment" name="comment"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.add()" ng-disabled="!vm.comment">Post <i class="fa fa-send" aria-hidden="true"></i></button></span></div></div>');
$templateCache.put('app/entities/evaluation-comment/update/evaluation-comment-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Edit a Evaluation Commment</h4></div><div class="modal-body"><div class="row"><div class="col-lg-12"><jhi-alert-error></jhi-alert-error></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="comments mb-30"><label for="commentText"></label> <textarea class="form-control mb-15" name="" id="commentText" rows="4" ng-model="vm.comments.comment" placeholder="Add comment..."></textarea></div></div></div><div class="modal-footer"><button type="submit" ng-click="vm.save()" class="btn btn-success" ng-disabled="vm.form.diagnosesForm.$invalid || vm.form.signatureForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/evaluation-diagnosis/history/evaluation-diagnoses-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Diagnoses History</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-hover"><thead><tr><th><strong>Rank</strong></th><th><strong>ICD10</strong></th><th><strong>Description</strong></th><th><strong>Status</strong></th></tr></thead><tbody><tr ng-repeat="diagnoses in vm.diagnosesInactive"><td>{{diagnoses.rank}}</td><td><strong>{{diagnoses.icd10.code}}</strong></td><td>{{diagnoses.icd10.description}}</td><td class="text-left"><span class="label label-success" ng-if="diagnoses.signed">Signed</span> <span class="label label-danger" ng-if="!diagnoses.signed">Unsigned</span></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/evaluation-diagnosis/list/evaluation-diagnosis.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Diagnosis</strong> <a ng-click="vm.history()" class="btn-icon"><i class="fa fa-history" aria-hidden="true" uib-tooltip="History"></i></a> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true" uib-tooltip="Add Diagnosis"></i></a></h5><div class="info no-padding" dnd-list="vm.evaluationDiagnoses"><p class="mb-0" ng-repeat="($index, diagnosis) in vm.evaluationDiagnoses" ng-click="vm.edit(diagnosis)" dnd-handle dnd-draggable="diagnosis" dnd-dragend="vm.onDragEnd(vm.evaluationDiagnoses)" dnd-moved="vm.evaluationDiagnoses.splice($index, 1)" dnd-effect-allowed="move"><strong>{{diagnosis.xorder}}. {{diagnosis.icd10.code}}</strong> - <span>{{diagnosis.icd10.description}}</span></p></div></div>');
$templateCache.put('app/entities/evaluation-diet/history/evaluation-diets-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Diets History</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-hover"><thead><tr><th><strong>Name</strong></th><th><strong>Start Date</strong></th><th><strong>End Date</strong></th></tr></thead><tbody><tr ng-repeat="diets in vm.dietsInactive"><td>{{diets.typeFoodDiets.name}}</td><td>{{diets.startDate | date: inputDateTimeFormatA}}</td><td>{{diets.endDate | date: inputDateTimeFormatA}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/evaluation-diet/list/evaluation-diets.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Diets:</strong> <a ng-click="vm.history()" class="btn-icon"><i class="fa fa-history" aria-hidden="true" uib-tooltip="History"></i></a> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true" uib-tooltip="Add Diet"></i></a></h5><p class="mb-0 inline-list"><span ng-repeat="diet in vm.evaluationDiets" ng-click="vm.edit(diet)">{{diet.name}}</span></p></div>');
$templateCache.put('app/entities/evaluation-glucose/list/evaluation-glucoses.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Glucose:</strong> <a ng-click="vm.history()" class="btn-icon"><i class="fa fa-history" aria-hidden="true" uib-tooltip="History"></i></a> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true" uib-tooltip="Add Glucose"></i></a></h5><p class="text-center" ng-if="vm.evaluationGlucose">- <strong>{{vm.evaluationGlucose.date | amDateFormat: amDateFormat}}</strong> -</p><p class="mb-0 inline-list" ng-if="vm.evaluationGlucose"><span><strong>Reading</strong> - {{vm.evaluationGlucose.reading}}</span> <span><strong>Type of Check:</strong> - {{vm.evaluationGlucose.typeCheck.name}}</span> <span><strong>Interventions:</strong> - {{vm.glucoseInterventions}}</span> <span><strong>Notes:</strong> - {{vm.evaluationGlucose.notes}}</span></p></div>');
$templateCache.put('app/entities/evaluation-medication/list/evaluation-medications-view.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Medications:</strong></h5><p ng-repeat="evaluationMedication in vm.evaluationMedications">{{evaluationMedication.name}} - {{evaluationMedication.durationDays + \' days\'}} - {{evaluationMedication.type | clearEnum}}</p></div>');
$templateCache.put('app/entities/evaluation-medication/list/evaluation-medications.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Medications:</strong> <a ng-click="vm.add()" uib-tooltip="Add Medication" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p ng-repeat="evaluationMedication in vm.evaluationMedications">{{evaluationMedication.name}} - {{evaluationMedication.durationDays + \' days\'}} - {{evaluationMedication.type | clearEnum}}</p></div>');
$templateCache.put('app/entities/evaluation-template/clone/evaluation-template-clone-dialog.html','<form name="copyForm" ng-submit="vm.confirmClone(vm.evaluationTemplate.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Clone Evaluation Template</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is will <strong>clone</strong> this Evaluation Template. Are you sure you want to <strong>clone</strong> this Evaluation Template?</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-disabled="copyForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Clone</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-template/clone-to-facility/evaluation-template-clone-to-facility-dialog.html','<form name="copyForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Clone Evaluation Template to Facility</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label">Facilities</label><ui-select ng-model="vm.selectedFacility" name="facility" id="facilities" reset-search-input="true" title="Facilities" close-on-select="true" required><ui-select-match placeholder="Select facilities...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.facilities"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-disabled="copyForm.$invalid" ng-click="vm.showDelete = true"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Clone</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.8); z-index: 10; border-radius: 5px"><div class="text-center"><p class="delete-text" style="color: white">This action is will <strong>clone</strong> this Evaluation Template to <strong>{{vm.selectedFacility.name}}</strong>. Are you sure you want to <strong>clone</strong> this Evaluation Template?</p><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmClone()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/evaluation-template/contact-assign/evaluation-template-contact-assign-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="modal-icon"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div><h4 class="modal-title" id="myVitalsLabel">Release Care & Delivery for Contact: {{vm.contact.fullName}}</h4></div><div class="modal-body"><div id="urgent-issues-dtable" ng-if="vm.chart.typeLevelCare != null"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="empty-content" ng-if="vm.chart.typeLevelCare == null"><div class="text"><span>There is no</span> <span>Level Of Care</span></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.assign()" ng-disabled="vm.isSaving || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-save" aria-hidden="true"></i> Assign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-template/list/evaluation-template.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation-template/mars-assign/evaluation-template-mars-assign-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="modal-icon"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div><h4 class="modal-title" id="myVitalsLabel">Assign Care & Delivery - {{vm.typePatientProcess.name}}</h4></div><div class="modal-body"><div id="urgent-issues-dtable" ng-if="vm.chart.typeLevelCare != null"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="empty-content" ng-if="vm.chart.typeLevelCare == null"><div class="text"><span>There is no</span> <span>Level Of Care</span></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.assign()" ng-disabled="vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Assign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-template/update/evaluation-template-edit.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Template</h3><div class="row pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-disabled="vm.form.info_form.$invalid || vm.isSaving" ng-click="vm.save()">Save Information</button></div></div></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" heading="Configuration"><fieldset><ng-include src="\'app/entities/evaluation-template/update/tpl/metadata-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" heading="Form Schema"><div class="row"><div class="col-md-3"><ods-form-toolbar></ods-form-toolbar></div><div class="col-md-9"><ods-schema schema="vm.evaluationTemplate.jsonTemplate" config="vm.formCKEditorConfig" debug-mode="vm.debugMode"></ods-schema></div></div></uib-tab><uib-tab index="3" heading="Form Preview"><ods-form schema="vm.evaluationTemplate.jsonTemplate" on-save="saveForm(vm.schema)"></ods-form></uib-tab><uib-tab index="4" heading="Form Model" ng-show="vm.debugMode"><ods-model model="vm.evaluationTemplate.jsonTemplate" css-class="fixed-height"></ods-model></uib-tab><uib-tab index="5" heading="Files" ng-if="vm.evaluationTemplate.id != null"><div ui-view="files"></div></uib-tab><uib-tab index="6" heading="Professional Claim Config" ng-show="vm.evaluationTemplate.id"><div ui-view="pro-claim-conf"></div></uib-tab></uib-tabset></div><div class="box-footer"><div class="row pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-disabled="vm.form.info_form.$invalid ||\n                            (vm.evaluationTemplate.forceStaffSignature && vm.evaluationTemplate.staffSignatureAuthority.length==0) ||\n                            (vm.evaluationTemplate.forceStaffReviewSignature && vm.evaluationTemplate.staffReviewSignatureAuthorities.length==0) || vm.isSaving" ng-click="vm.save()">Save Information</button></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/evaluation-template-file/list/evaluation-template-file.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">Tags: patientSignature, chartSignatureDate, guarantor, guarantorSignature, guarantorSignatureDate, witnessName, staffName, staffSignature, staffSignatureDate, staffReviewerSignature, staffReviewerSignatureDate, staffReviewerName, revokeSignature, revokeSignatureDate, patientFirstName, patientLastName, patientMiddleInitial, patientAddress1, patientAddress2, patientCity, patientState, patientZipCode, patientLast4Ssn, patientFullName, patientDOB, patientAge, patientGender, patientSSN, patientAdmissionDate, patientDischargeDate, patientDischargeTo, patientEmail, patientPhone, patientBed, patientReferrer, patientLevel, Insurance, diagnosis, patientPolice, patientAddress, facility, facilityFax, facilityAddress, facilityAddress1_2, facilityAddress1, facilityAddress2, facilityCity, facilityState, facilityZipCode, facilityTaxId, facilityStateLicence, facilityNpi</div></div><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add File <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="row"><section class="content"><div class="row"></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-body"><table class="table table-hover" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"><ul></ul></ul></div></div></div></section></div>');
$templateCache.put('app/entities/evaluation-template-file/update/evaluation-template-file-dialog.html','<form name="editForm" role="form" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myChartFileLabel">Create a Evaluation Template File</h4></div><div class="modal-body"><h2 class="step-header">Attach Files</h2><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="custom-file-upload"><div class="input-wrapper"><label for="fileUploads"><i class="fa fa-paperclip" aria-hidden="true"></i> Choose files... <input type="file" id="fileUploads" ngf-select multiple="multiple" ngf-change="vm.attachFile($files)" accept="image/png, image/jpeg , .txt, .pdf"></label></div></div></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-template-mars-mors/list/evaluation-template-mars-mors.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation-template-mars-mors/update/evaluation-template-mars-mors-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="evaluationTemplateMarsMorsLabel">Create or edit a Evaluation Template Mars Mors</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.evaluationTemplateMarsMors.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.evaluationTemplateMarsMors.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="vm.evaluationTemplates.length > 0?(editForm.evaluationTemplate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_evaluation">Evaluation Templates</label><ui-select ng-model="vm.evaluationTemplateMarsMors.evaluationTemplate" name="evaluationTemplate" id="field_evaluation" required reset-search-input="true" close-on-select="true"><ui-select-match placeholder="Select ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.evaluationTemplates | propsFilter: {name: $select.search}" refresh="vm.getEvaluationTemplates($select.search)" refresh-delay="0"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.evaluationTemplateMarsMors.evaluationTemplate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.evaluationTemplateMarsMors.evaluationTemplate && vm.form.evaluationTemplateMarsMors.evaluationTemplate.$dirty"></span> <span class="help-block" ng-show="!vm.evaluationTemplateMarsMors.evaluationTemplate">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-vital/list/evaluation-vital.html','<div class="info no-padding" ng-if="vm.evaluation.vital"><h5 class="header-label mt-0"><strong>Vitals:</strong> <a ng-click="vm.history()" class="btn-icon"><i class="fa fa-history" aria-hidden="true" uib-tooltip="History"></i></a> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true" uib-tooltip="Add Vitals"></i></a></h5><div ng-if="vm.lastVitals"><p class="text-center"><span class="label label-danger">- <strong>{{vm.lastVitals.date | amDateFormat: amDateFormat}}</strong> -</span> <i class="fa fa-info-circle danger" aria-hidden="true" title="Vital is older than 24 hour. Please add a new vital, if you would like it to appear in this care and delivery"></i></p><p class="mb-0 inline-list"><span><strong>BP</strong> - {{vm.lastVitals.bpSystolic}}/{{vm.lastVitals.bpDiastolic}}</span> <span><strong>Temp:</strong> - {{vm.lastVitals.temperature ? vm.lastVitals.temperature : \'-\'}}<sup>o</sup>F</span> <span><strong>Pul:</strong> - {{vm.lastVitals.pulse ? vm.lastVitals.pulse : \'-\'}}</span> <span><strong>Resp:</strong> - {{vm.lastVitals.respiration ? vm.lastVitals.respiration : \'-\'}}</span> <span><strong>0<sup>2</sup></strong> - {{vm.lastVitals.o2Saturation ? vm.lastVitals.o2Saturation : \'-\'}}</span></p></div><div ng-if="vm.evaluationVitals"><p class="text-center">- <strong>{{vm.evaluationVitals.date | amDateFormat: amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>BP</strong> - {{vm.evaluationVitals.bpSystolic}}/{{vm.evaluationVitals.bpDiastolic}}</span> <span><strong>Temp:</strong> - {{vm.evaluationVitals.temperature ? vm.evaluationVitals.temperature : \'-\'}}<sup>o</sup>F</span> <span><strong>Pul:</strong> - {{vm.evaluationVitals.pulse ? vm.evaluationVitals.pulse : \'-\'}}</span> <span><strong>Resp:</strong> - {{vm.evaluationVitals.respiration ? vm.evaluationVitals.respiration : \'-\'}}</span> <span><strong>0<sup>2</sup></strong> - {{vm.evaluationVitals.o2Saturation ? vm.evaluationVitals.o2Saturation : \'-\'}}</span></p></div></div>');
$templateCache.put('app/entities/evaluation-weight/list/evaluation-weights.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Weight:</strong> <a ng-click="vm.history()" class="btn-icon"><i class="fa fa-history" aria-hidden="true" uib-tooltip="History"></i></a> <a ng-click="vm.add()" class="btn-icon"><i class="fa fa-plus-circle" aria-hidden="true" uib-tooltip="Add Weight"></i></a></h5><p class="text-center">- <strong>{{vm.evaluationWeight.date | amDateFormat:amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>Weight (Lb)</strong> - {{vm.evaluationWeight.weight}}</span> <span><strong>Height (ft & in):</strong> - {{vm.evaluationWeight.height ? vm.getHeightInchesToFeetInches(vm.evaluationWeight.height) : \'\'}}</span> <span><strong>BMI:</strong> - {{vm.evaluationWeight.bmi}}</span></p></div>');
$templateCache.put('app/entities/facesheet-section/list/facesheet-section.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facesheet-section/update/facesheet-section-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFacesheetSectionLabel">Create or edit a Facesheet Section</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.facesheetSection.title?(editForm.title.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_title">Title</label> <input type="text" class="form-control" name="title" id="field_title" required ng-model="vm.facesheetSection.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facesheetSection.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facesheetSection.title && editForm.title.$dirty"></span> <span class="help-block" ng-show="!vm.facesheetSection.title">This field is required</span></div></div><div class="col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.facesheetSection.facesheetSectionType?(editForm.facesheetSectionType.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_facesheetSectionType">Facesheet Section Type</label> <select class="form-control" name="facesheetSectionType" ng-model="vm.facesheetSection.facesheetSectionType" id="field_facesheetSectionType"><option value="MAIN">MAIN</option><option value="DEMOGRAPHIC_INFO">DEMOGRAPHIC_INFO</option><option value="REFERRAL_INFO">REFERRAL_INFO</option><option value="CARE_TEAMS">CARE_TEAMS</option><option value="ACTIVE_CARE_TEAMS">ACTIVE_CARE_TEAMS</option><option value="INACTIVE_CARE_TEAMS">INACTIVE_CARE_TEAMS</option><option value="ALLERGIES">ALLERGIES</option><option value="ACTIVE_ALLERGIES">ACTIVE_ALLERGIES</option><option value="INACTIVE_ALLERGIES">INACTIVE_ALLERGIES</option><option value="DIAGNOSES">DIAGNOSES</option><option value="ACTIVE_DIAGNOSES">ACTIVE_DIAGNOSES</option><option value="INACTIVE_DIAGNOSES">INACTIVE_DIAGNOSES</option><option value="DIETS">DIETS</option><option value="ACTIVE_DIETS">ACTIVE_DIETS</option><option value="INACTIVE_DIETS">INACTIVE_DIETS</option><option value="EMERGENCY_CONTACTS">EMERGENCY_CONTACTS</option><option value="PAYMENT_INFO">PAYMENT_INFO</option><option value="LAST_RECORDED_VITALS">LAST_RECORDED_VITALS</option><option value="MONITORING">MONITORING</option><option value="CONCURRENT_REVIEWS">CONCURRENT_REVIEWS</option><option value="MEDICATIONS">MEDICATIONS</option><option value="ACTIVE_MEDICATIONS">ACTIVE_MEDICATIONS</option><option value="INACTIVE_MEDICATIONS">INACTIVE_MEDICATIONS</option><option value="AS_NEEDED_MEDICATIONS">AS_NEEDED_MEDICATIONS</option><option value="TAKE_MEDICATIONS">TAKE_MEDICATIONS</option><option value="LAB_ORDERS">LAB_ORDERS</option><option value="ACTIVE_LAB_ORDERS">ACTIVE_LAB_ORDERS</option><option value="INACTIVE_LAB_ORDERS">INACTIVE_LAB_ORDERS</option><option value="RESULTS">RESULTS</option><option value="GROUP_SESSION">GROUP_SESSION</option><option value="EVALUATIONS">EVALUATIONS</option><option value="RCOPIA_ACTIVE_MEDICATION">RCOPIA_ACTIVE_MEDICATION</option><option value="RCOPIA_INACTIVE_MEDICATION">RCOPIA_INACTIVE_MEDICATION</option><option value="RCOPIA_PENDING_PRESCRIPTIONS">RCOPIA_PENDING_PRESCRIPTIONS</option><option value="RCOPIA_ALL_PRESCRIPTIONS">RCOPIA_ALL_PRESCRIPTIONS</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facesheetSection.facesheetSectionType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facesheetSection.facesheetSectionType && editForm.facesheetSectionType.$dirty"></span> <span class="help-block" ng-show="!vm.facesheetSection.facesheetSectionType">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facesheet-tpl/list/facesheet-tpl.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facesheet-tpl/update/facesheet-tpl-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFaceSheetTplLabel">Create or edit a Facesheet Tpl</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.facesheetTpl.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.facesheetTpl.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facesheetTpl.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facesheetTpl.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.facesheetTpl.name">This field is required</span></div></div><div class="col-lg-6"><div class="form-group"><label><label for="field_enable">Enable</label><br><toggle id="field_enable" ng-model="vm.facesheetTpl.enable" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></label></div></div></div><!-- /row --><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Group Session Status</label><ui-select ng-model="vm.facesheetTpl.groupSessionStatuses" name="groupSessionStatuses" id="groupSessionStatuses" reset-search-input="true" title="Group Session Status" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a Group Session Status ...">{{$item}}</ui-select-match><ui-select-choices repeat="item in vm.groupSessionStatuses | filter: $select.search"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Evaluation Status</label><ui-select ng-model="vm.facesheetTpl.evaluationStatuses" name="evaluationStatuses" id="evaluationStatuses" reset-search-input="true" title="Evaluation Status" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter a Evaluation Status ...">{{$item}}</ui-select-match><ui-select-choices repeat="item in vm.evaluationStatuses | filter: $select.search"><div ng-bind-html="item | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><label class="control-label">Select Sections</label></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptionsFacesheetSections" dt-columns="vm.dtColumnsFacesheetSections" dt-instance="vm.dtInstanceFacesheetSections" class="table table-striped table-bordered"></table></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><label class="control-label">Select Evaluation Templates</label><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptionsEvaluationTemplates" dt-columns="vm.dtColumnsEvaluationTemplates" dt-instance="vm.dtInstanceEvaluationTemplates" class="table table-striped table-bordered"></table></div></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.getSelectedIds(vm.selectedFacesheetSections) == 0" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facility/create/facility-wizard-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Facility Setup</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="corporationWizard" hide-indicators="true"><wz-step wz-title="Form"><ng-include src="\'app/entities/facility/create/tpl/form.html\'"></ng-include><div class="modal-footer"><button type="submit" class="btn btn-success" wz-next ng-click="vm.loadEntity(0)" ng-disabled="vm.form.$invalid">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></div></wz-step><wz-step wz-title="TEST1"><ng-include src="\'app/entities/facility/create/tpl/entity.html\'"></ng-include><div class="modal-footer"><button type="button" class="btn btn-warning" style="margin-right: auto" wz-previous ng-if="vm.index == 0"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button> <button type="button" class="btn btn-warning" style="margin-right: auto" ng-click="vm.loadEntity(vm.index - 1)" ng-if="vm.index > 0"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button> <button type="submit" class="btn btn-warning" ng-disabled="vm.form.$invalid || vm.isSaving || vm.accountExist" wz-next ng-click="vm.loadEntity(vm.index + 1)" ng-if="vm.index != (vm.entities.length - 1)">Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button> <button type="submit" class="btn btn-success" ng-disabled="vm.form.$invalid || vm.isSaving || vm.accountExist" wz-next ng-click="vm.save()" ng-if="vm.index == (vm.entities.length - 1)"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></wz-step></wizard></div></div></div>');
$templateCache.put('app/entities/facility/list/facility.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility/update/facility-dialog.html','<form name="vm.form" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFacilityLabel">Create or edit a Facility</h4></div><div class="modal-body"><div class="row"><jhi-alert-error></jhi-alert-error></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.name?(vm.form.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="name">Name:</label> <input type="text" class="form-control" name="name" id="name" required ng-model="vm.facility.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.name && vm.form.name.$dirty"></span> <span class="help-block" ng-show="!vm.facility.name">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.street?(vm.form.street.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_street">Street:</label> <input type="text" class="form-control" name="street" id="field_street" required ng-model="vm.facility.street"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.street"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.street && vm.form.street.$dirty"></span> <span class="help-block" ng-show="!vm.facility.street">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.street_two?(vm.form.street_two.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_street_two">2<sup>nd</sup> Street:</label> <input type="text" class="form-control" name="street_two" id="field_street_two" ng-model="vm.facility.street_two"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.street_two"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.street_two && vm.form.street_two.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.street_two">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.city?(vm.form.city.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_city">City</label> <input type="text" class="form-control" name="city" id="field_city" required ng-model="vm.facility.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.city && vm.form.city.$dirty"></span> <span class="help-block" ng-show="!vm.facility.city">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.countryState ?(vm.form.state.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_state">State:</label> <select class="form-control" id="field_state" name="state" required ng-model="vm.facility.countryState" ng-options="item as item.state for item in vm.states track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.countryState && vm.form.state.$dirty"></span> <span class="help-block" ng-show="!vm.facility.countryState">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.zip?(vm.form.zip.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_zip">Zip Code:</label> <input type="text" class="form-control" name="zip" id="field_zip" required ng-model="vm.facility.zip" ui-mask="99999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.zip"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.zip && vm.form.zip.$dirty"></span> <span class="help-block" ng-show="!vm.facility.zip">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.county?(vm.form.county.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_county">County:</label> <input type="text" class="form-control" name="county" id="field_county" ng-model="vm.facility.county"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.county"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.county && vm.form.county.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.county">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.phone?(vm.form.phone.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_phone">Phone:</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.facility.phone" ui-mask="(999)-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.phone && vm.form.phone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.phone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.fax?(vm.form.fax.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_fax">Fax:</label> <input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.facility.fax" ui-mask="(999)-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.fax"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.fax && vm.form.fax.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.fax">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.website?(vm.form.website.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">Website:</label> <input type="url" class="form-control" name="website" id="field_website" ng-model="vm.facility.website" list="urlExamples"><datalist id="urlExamples"><option value="http://www.example.com"></option><option value="https://www.example.com"></option><option value="http://www.example.org"></option><option value="https://www.example.org"></option></datalist><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.website"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.website && vm.form.website.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.website">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.corporation?(vm.form.corporation.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Corporation</label><ui-select ng-model="vm.facility.corporation" name="corporation" id="field_corporation" required reset-search-input="true" title="Corporation" close-on-select="true" ng-disabled="true"><ui-select-match placeholder="Enter a corporation..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="corporation in vm.corporations | filter: $select.search"><div ng-bind-html="corporation.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.corporation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.corporation && vm.form.corporation.$dirty"></span> <span class="help-block" ng-show="!vm.facility.corporation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.zoneId?(vm.form.zoneId.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Time Zone</label><ui-select ng-model="vm.zoneId" name="timezone" id="field_timezone" required close-on-select="true"><ui-select-match placeholder="Select time zone ...">{{$select.selected.zoneId + \' \' + $select.selected.offset}}</ui-select-match><ui-select-choices repeat="zoneId in vm.timeZones | filter: $select.search"><div ng-bind-html="zoneId.zoneId + \' \' +  zoneId.offset | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.zoneId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.zoneId && vm.form.zoneId.$dirty"></span> <span class="help-block" ng-show="!vm.zoneId">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.taxId?(vm.form.taxId.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">Tax Id:</label> <input type="text" class="form-control" name="taxId" id="field_taxId" ng-model="vm.facility.taxId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.taxId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.taxId && vm.form.taxId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.taxId">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.stateLicence?(vm.form.stateLicence.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">State Licence:</label> <input type="text" class="form-control" name="stateLicence" id="field_stateLicence" ng-model="vm.facility.stateLicence"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.stateLicence"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.stateLicence && vm.form.stateLicence.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.stateLicence">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.npi?(vm.form.npi.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">NPI:</label> <input type="text" class="form-control" name="npi" id="field_npi" ng-model="vm.facility.npi"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.npi"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.npi && vm.form.npi.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.npi">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_website">Send Results:</label><br><toggle id="field_sendResults" name="sendResults" ng-model="vm.facility.sendResults" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.placeOfService ? (vm.form.placeOfService.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="control-label">Place of Service</label><ui-select ng-model="vm.facility.placeOfService" name="placeOfService" id="field_place" close-on-select="true"><ui-select-match allow-clear="true" placeholder="Select place of service ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="placeOfService in vm.placeOfService | filter: $select.search"><div ng-bind-html="placeOfService.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.placeOfService"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.placeOfService && vm.form.placeOfService.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.placeOfService">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.facilityType ? (vm.form.facilityType.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="control-label">Facility Type</label> <select name="facilityType" id="field_facilityType" class="form-control input-sm" ng-model="vm.facility.facilityType"><option value="">Select type</option><option value="HIV">HIV</option><option value="COVID_RC">COVID_RC</option></select></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_reconnect_care">Reconnect Care:</label><br><toggle id="field_reconnect_care" name="reconnect_care" ng-model="vm.facility.reconnectCare" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_auto_sign_medication">Auto Sign Medication:</label><br><toggle id="field_auto_sign_medication" name="auto_sign_medication" ng-model="vm.facility.autoSignMedication" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_auto_sign_medication">Auto Sign Patient Order:</label><br><toggle id="field_auto_sign_patient_order" name="auto_sign_patient_order" ng-model="vm.facility.autoSignPatientOrder" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.defaultPharmacy ? (vm.form.defaultPharmacy.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="field_pharmacy">Pharmacy</label><ui-select name="pharmacy" id="field_pharmacy" title="pharmacy" ng-model="vm.facility.defaultPharmacy" reset-search-input="false" ng-model-options="{ debounce: 500 }"><ui-select-match placeholder="Pharmacy...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.pharmacy | filter: $select.search" refresh="vm.getPharmacies($select.search)" refresh-delay="0"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.$error.required || vm.form.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facility-billing/list/facility-billing.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility-billing/update/facility-billing-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFacilityBillingLabel">Create Facility Billing</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.facilityBilling.date?(editForm.date.$valid && editForm.date.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="date" ng-model="vm.facilityBilling.date" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.facilityBilling.date"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.facilityBilling.date && editForm.date.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facilityBilling.date || editForm.date.$invalid">This field is suggested</span></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form>');
$templateCache.put('app/entities/facility-billing-config/list/facility-billing-config.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility-billing-config/update/facility-billing-config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFacilityBillingConfigLabel">Create or edit a Facility Billing Config</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" for="field_price">Price</label> <input type="number" class="form-control" name="price" id="field_price" ng-model="vm.facilityBillingConfig.price" required><div ng-show="editForm.price.$invalid"><p class="help-block" ng-show="editForm.price.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.price.$error.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/facility-icd-10/list/facility-icd-10.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility-icd-10/update/facility-icd-10-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFacilityIcd10Label">Create or edit a Facility Icd 10</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.facilityIcd10.icd10?(vm.facilityIcd10.icd10.$valid && vm.facilityIcd10.icd10.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_icd10">ICD10</label><ui-select name="icd10" id="field_icd10" title="icd10" ng-model="vm.facilityIcd10.icd10" reset-search-input="false" ng-model-options="{ debounce: 500 }" ng-required="true"><ui-select-match placeholder="ICD10...">{{$select.selected.code + ", " + $select.selected.description}}</ui-select-match><ui-select-choices repeat="item in vm.icd10" refresh="vm.getIcd10($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' - \' + item.description"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.facilityIcd10.icd10"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.facilityIcd10.icd10 && vm.facilityIcd10.icd10.$dirty"></span> <span class="help-block" ng-show="!vm.facilityIcd10.icd10">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/facility-pharmacy/list/facility-pharmacy.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility-pharmacy/update/facility-pharmacy-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFacilityPharmacyLabel">Create or edit a Facility Pharmacy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.facilityPharmacy.pharmacy?(vm.facilityPharmacy.pharmacy.$valid && vm.facilityPharmacy.pharmacy.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_pharmacy">Pharmacy</label><ui-select name="pharmacy" id="field_pharmacy" title="pharmacy" ng-model="vm.facilityPharmacy.pharmacy" reset-search-input="false" ng-model-options="{ debounce: 500 }" ng-required="true"><ui-select-match placeholder="Pharmacy...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.pharmacy" refresh="vm.getPharmacy($select.search)" refresh-delay="0"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.facilityPharmacy.pharmacy"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.facilityPharmacy.pharmacy && vm.facilityPharmacy.pharmacy.$dirty"></span> <span class="help-block" ng-show="!vm.facilityPharmacy.pharmacy">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></form>');
$templateCache.put('app/entities/facility-phone-number/list/facility-phone-number.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility-phone-number/order/facility-phone-number-dialog.html','<form name="editForm" role="form" novalidate><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Create or edit a Order Phone Number</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group"><label for="pattern_name">Pattern number:</label> <input type="text" class="form-control" name="phoneNumber" id="pattern_name" ng-model="vm.phoneNumber.pattern"></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="editForm.areaCode?(!editForm.areaCode.$invalid?\'\':\'has-error\'):\'\'"><label for="area_code_name">Area Code:</label> <input type="text" class="form-control" name="areaCode" id="area_code_name" ng-model="vm.phoneNumber.areaCode" minlength="3" maxlength="3"> <span class="help-block" aria-hidden="true" ng-show="editForm.areaCode.$invalid">This field is invalid</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group"><label for="state_name">State:</label> <select class="form-control" id="state_name" name="state" ng-model="vm.phoneNumber.state" ng-options="item.stateCode as item.state for item in vm.countryState track by item.id"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"><div class="form-group"><label>&nbsp;</label> <button type="button" class="btn btn-warning" ng-click="vm.getAvailablePhoneNumbers()" ng-disabled="editForm.areaCode.$invalid"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div id="phone-numbers-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.orderPhoneNumber()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0 || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Order</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/fax-number/list/fax-number.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/fax-number/order/fax-number-dialog.html','<form name="editForm" role="form" novalidate><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Order Fax Number</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group"><label for="pattern_name">Pattern number:</label> <input type="text" class="form-control" name="faxNumber" id="pattern_name" ng-model="vm.faxNumber.pattern"></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="editForm.areaCode?(!editForm.areaCode.$invalid?\'\':\'has-error\'):\'\'"><label for="area_code_name">Area Code:</label> <input type="text" class="form-control" name="areaCode" id="area_code_name" ng-model="vm.faxNumber.areaCode" minlength="3" maxlength="3"> <span class="help-block" aria-hidden="true" ng-show="editForm.areaCode.$invalid">This field is invalid</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group"><label for="state_name">State:</label> <select class="form-control" id="state_name" name="state" ng-model="vm.faxNumber.state" ng-options="item.stateCode as item.state for item in vm.countryState track by item.id"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"><div class="form-group"><label>&nbsp;</label> <button type="button" class="btn btn-warning" ng-click="vm.getAvailablePhoneNumbers()" ng-disabled="editForm.areaCode.$invalid"><i class="fa fa-search" aria-hidden="true"></i></button></div></div></div><div id="phone-numbers-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.orderPhoneNumber()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0 || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Order</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/global-message/list/global-messages.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/global-message/notification/global-message-notification.html','<div class="global-message-container" ng-if="vm.globalMessages.length > 0"><div class="alert alert-{{ globalMessage.priority.toLowerCase() }} global-message" ng-repeat="($index, globalMessage) in vm.globalMessages"><button type="button" class="close" data-dismiss="alert" ng-if="globalMessage.closeable" ng-click="vm.close(globalMessage.id)">&times;</button> <strong>{{ globalMessage.title }}</strong> {{ globalMessage.description }}</div></div>');
$templateCache.put('app/entities/global-message/update/global-message-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create or edit a Global Message</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.globalMessage.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.globalMessage.id" readonly="readonly"></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.globalMessage.title?(editForm.title?\'has-success\':\'\'):\'has-error\'"><label for="field_title">Title:</label> <input type="text" class="form-control" name="title" id="field_title" required ng-model="vm.globalMessage.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.globalMessage.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.globalMessage.title && editForm.title.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.globalMessage.title">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.globalMessage.description?(editForm.description?\'has-success\':\'\'):\'has-error\'"><label for="field_title">Description:</label> <input type="text" class="form-control" name="description" id="field_description" required ng-model="vm.globalMessage.description"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.globalMessage.description"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.globalMessage.description && editForm.description.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.globalMessage.description">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="field_title">Comment:</label> <input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.globalMessage.comment"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.globalMessage.priority?(editForm.priority?\'has-success\':\'\'):\'has-error\'"><label for="field_priority">Priority:</label> <select id="field_priority" name="priority" ng-model="vm.globalMessage.priority" class="form-control alert-{{ vm.globalMessage.priority.toLowerCase() }}" required><option value="ERROR" class="alert-error">ERROR</option><option value="SUCCESS" class="alert-success">SUCCESS</option><option value="INFO" class="alert-info" selected="selected">INFO</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.globalMessage.priority"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.globalMessage.priority && editForm.priority.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.globalMessage.priority">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.globalMessage.startDate?(editForm.startDate.$dirty && editForm.startDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_start_date">Start Date:</label><div class="input-group input-group-sm"><input id="field_start_date" type="text" class="form-control" name="startDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.globalMessage.startDate" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.globalMessage.startDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.globalMessage.startDate && editForm.startDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.globalMessage.startDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.globalMessage.endDate?(editForm.endDate.$dirty && editForm.endDate.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="endDate" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.globalMessage.endDate" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.globalMessage.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.globalMessage.endDate && editForm.endDate.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.globalMessage.endDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label">Active</label><br><toggle ng-model="vm.globalMessage.active" on="Yes" off="No" id="field_active"></toggle></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label class="control-label">Closeable</label><br><toggle ng-model="vm.globalMessage.closeable" on="Yes" off="No" id="field_closeable"></toggle></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label class="control-label">Corporation</label><ui-select ng-model="vm.globalMessage.corporation" name="corporation" id="field_corporation" reset-search-input="true" title="Corporation" close-on-select="true"><ui-select-match placeholder="Enter a corporation..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="corporation in vm.corporations | filter: $select.search"><div ng-bind-html="corporation.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/glucose/history/glucose-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Glucose - History</h4></div><div class="modal-body"><div class="table-wrapper"><div class="table-responsive"><table class="table table-bordered fixed-header" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center" ng-if="vm.glucoses.length > 0"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"></ul></div></div></div><div class="modal-footer"><!--<button type="submit" class="btn btn-success" ng-click="vm.save()">\n        <i class="fa fa-print" aria-hidden="true"></i> Print\n    </button>--> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/glucose/update/glucose-dialog.html','<form name="vm.form.glucose" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGlucoseLabel">Create or edit a Glucose</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.glucose.date || vm.form.glucose.date.$invalid?\'has-error\':(vm.glucose.date && vm.form.glucose.date.$dirty?\'has-success\':\'\')"><label for="field_date">Date:</label><div class="input-group input-group-sm"><input id="field_date" type="text" class="form-control" name="date" required ng-model="vm.glucose.date" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.date" validator="required" message-id="msg-glucose-date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.glucose.date || vm.form.glucose.date.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.glucose.date && vm.form.glucose.date.$dirty"></span> <span class="help-block" ng-show="!vm.glucose.date || vm.form.glucose.date.$invalid">This field is required</span></div><div id="msg-glucose-date"></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.glucose.reading?(vm.form.glucose.reading.$valid && vm.form.glucose.reading.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_reading">Reading:</label> <input type="number" class="form-control" name="reading" id="field_reading" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="vm.glucose.reading" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.glucose.reading.$error.required || vm.form.glucose.reading.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.form.glucose.reading.$dirty && vm.form.glucose.reading.$valid"></span> <span class="help-block" ng-show="vm.form.glucose.reading.$error.required || vm.form.glucose.reading.$invalid">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm"><label for="field_typeCheck">Type Of Check</label> <select class="form-control" name="typeCheck" ng-model="vm.glucose.typeCheck" id="field_typeCheck" ng-options="item as item.name for item in vm.typeCheck track by item.name"></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.glucose.glucoseInterventions?(vm.form.glucose.glucoseIntervention.$dirty && vm.form.glucose.glucoseIntervention.$valid?\'has-success\':\'\'):\'has-warning\'"><label for="glucoseIntervention">Glucose Intervention:</label><ui-select id="glucoseIntervention" name="glucoseIntervention" multiple="multiple" ng-model="vm.glucose.glucoseInterventions" title="Interventions"><ui-select-match placeholder="Select Interventions...">{{$item.name}}</ui-select-match><ui-select-choices repeat="glucoseIntervention in vm.glucoseinterventions | filter:$select.search">{{glucoseIntervention.name}}</ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.glucose.notes?(vm.form.glucose.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Notes:</label> <textarea rows="3" class="form-control" name="notes" id="field_notes" data-resize="disabled" ng-model="vm.glucose.notes"></textarea> <span class="help-block help-warning" ng-show="!vm.glucose.notes">This field is suggested</span></div></div></div><!-- /row --></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.glucose.$error.required || vm.isSaving || vm.from.glucose.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/glucose-intervention/list/glucose-interventions.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/glucose-intervention/update/glucose-intervention-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGlucoseIntervention">Create or edit a Glucose Intervention</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.glucoseIntervention.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.glucoseIntervention.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.glucoseIntervention.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.glucoseIntervention.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.glucoseIntervention.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.glucoseIntervention.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.glucoseIntervention.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/greeting/list/greeting.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/greeting/update/greeting-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGreetingLabel">Create or edit a Greeting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.greeting.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.greeting.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.greeting.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.greeting.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.greeting.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.greeting.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.greeting.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/group-session/calendar/group-sessions.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="calendar-wrapper" ng-class="{\'side-open\': vm.toggleSidebar}"><button type="button" class="btn btn-default btn-sm" id="toggleCalendarSidebar" ng-model="vm.toggleSidebar" uib-btn-checkbox btn-checkbox-true="1" btn-checkbox-false="0"><i class="fa fa-chevron-left" aria-hidden="true" ng-class="{\'rotated\': vm.toggleSidebar}"></i></button><div class="group-sessions-calendar" id="groupSessionsCalendar" ui-calendar="vm.calendarConfig.calendar" ng-model="vm.eventSources" calendar="myCalendar"></div><aside class="calendar-sidebar" ng-class="{\'opened\': vm.toggleSidebar}"><header class="header dark"><span>Calendar Actions</span> <a href="" ng-click="vm.toggleSidebar = 0"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></a></header><header class="header"><span>Quick Search</span></header><div class="quick-filter"><form name=""><div class="form-group"><div class="input-group input-group-sm"><input type="text" class="form-control input-sm" placeholder="Search..." ng-model="vm.filterRes.searchQuery"> <span class="input-group-btn"><button type="submit" class="btn btn-primary btn-sm" ng-click="vm.reloadCalendar()"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></div></form></div><header class="header"><span>Buildings</span></header><div class="buildings"><ul class="list-unstyled mb-0"><li role="listitem" ng-repeat="item in vm.buildings"><label>{{item.name}} <input id="{{item.name}}" type="checkbox" value="{{item.name}}" ng-checked="vm.checkedBuilding(item.id)" ng-click="vm.toggleSelection(item.id)"></label></li></ul></div><header class="header"><span>Employees</span></header><div class="employees-list"><form><div class="form-group"><div class="input-group input-group-sm"><ui-select id="employee" name="employee" class="input-medium" reset-search-input="false" ng-model="vm.employee" title="Select employee..."><ui-select-match allow-clear="true" placeholder="Select employee...">{{$select.selected.lastName + \', \' + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="input-group-btn"><button type="button" class="btn btn-warning btn-medium" ng-click="vm.addEmployee()"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></span></div></div></form><ul class="list-unstyled"><li role="menuitem" class="employee-item" ng-repeat="employee in vm.filterRes.employeesSelection"><span class="name">{{employee | employeeName}}</span> <a ng-click="vm.delEmployee(employee)" class="close"><i class="fa fa-times" aria-hidden="true"></i></a></li></ul></div><header class="header"><span>Legend</span></header><div class="calendar-legend"><div ng-repeat="item in vm.groupSessionStatuses"><div class="action-checkbox"><p class="{{item.nameClass}}"><label for="{{item.value}}"></label> {{item.label}} <input id="{{item.value}}" type="checkbox" value="{{item.value}}" ng-checked="vm.checkedStatus(item.value)" ng-click="vm.toggleStatusSelection(item.value)"></p></div></div></div></aside></div></div></div></section>');
$templateCache.put('app/entities/group-session/edit/group-session-edit.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><ng-include src="\'app/entities/group-session/edit/group-session-tpl.html\'"></ng-include><div class="box-body mb-15"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-3"><div class="form-group"><label for="field_building">Building:</label> <select class="form-control" id="field_building" name="building" ng-model="vm.building" ng-change="vm.getCharts()" ng-options="building as building.name for building in vm.buildings"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-9 col-lg-7"><div class="form-group"><label for="field_charts">Patients:</label><ui-select ng-model="vm.selectedCharts" name="charts" id="field_charts" title="Select chart" close-on-select="false" multiple="multiple"><ui-select-match placeholder="Select chart..."><div ng-bind-html="$item.firstName + \' \' + $item.lastName"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + ($item.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + $item.mrNo"></small></ui-select-match><ui-select-choices repeat="chart in vm.charts | filter: $select.search" refresh="vm.getCharts($select.search)" refresh-delay="0"><div ng-bind-html="chart.firstName + \' \' + chart.lastName"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + (chart.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + chart.mrNo"></small></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-2"><div class="form-group"><label class="hidden-xs hidden-sm">&nbsp</label> <button type="button" class="btn btn-warning btn-block" ng-disabled="vm.selectedCharts.length == 0" ng-click="vm.addCharts()"><i class="fa fa-plus-circle"></i> Add Patients</button></div></div></div></div><!-- ./box-body --><div class="box-body mb-15"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h4 class="heading">Attendees:</h4><div ng-repeat="item in vm.groupSessionDetails" class="attendees-list"><udt-group-session-detail group-session-details="item" group-session="vm.groupSession"></udt-group-session-detail></div></div></div></div><!-- ./box-body --><div class="box-body mb-15" has-any-authority="{{vm.edit}}"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-3"><div class="form-group"><div><strong>Signatures:</strong></div><br><div ng-if="vm.leaderSignature" ng-click="vm.editSignature(vm.leaderSignature)"><strong>Leader signature:</strong> {{vm.leaderSignature.date | amDateFormat:amDateFormat}} <i class="fa fa-pencil" aria-hidden="true"></i><br></div><div ng-if="vm.reviewerSignature" ng-click="vm.editSignature(vm.reviewerSignature)"><strong>Reviewer signature:</strong> {{vm.reviewerSignature.date | amDateFormat:amDateFormat}}<br></div></div></div></div><div class="box-body mb-15" ng-if="vm.leaderSignature || vm.allowSign || vm.reviewerSignature || (vm.groupSession.status2 == \'REVIEW\' && vm.allowReview)"><h4 class="heading">Signature:</h4><div class="signs-array well well-sm"><div class="sign-item sign-blank mb-15" ng-if="!vm.leaderSignature"><figure ng-click="vm.leaderSign()"><div class="icon"><i class="fa fa-edit fa-2x" aria-hidden="true"></i></div><figcaption><strong>Click to sign</strong></figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.leaderSignature && vm.groupSession.leaderSignatureId"><figure><img ng-src-sign="{{vm.groupSession.leaderSignatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><br><figcaption>Leader: {{vm.groupSession.leader | employeeName}}, Date: {{vm.leaderSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item sign-blank mb-15" ng-if="vm.groupSession.status2 == \'REVIEW\' && !vm.reviewerSignature"><figure ng-click="vm.reviewerSign()"><div class="icon"><i class="fa fa-edit fa-2x" aria-hidden="true"></i></div><figcaption><strong>Click to sign</strong></figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.groupSession.reviewerSignatureId"><figure><img ng-src-sign="{{vm.groupSession.reviewerSignatureId}}" id="reviewerSignatureId" alt="Reviewer Signature" width="300" class="img-responsive"><br><figcaption>Reviewer: {{vm.groupSession.reviewer | employeeName}}, Date: {{vm.reviewerSignature.date | amDateFormat:amDateFormat}}</figcaption></figure></div></div></div></div></div></div></section><assistant-clipboard ng-model="assistantList" ng-if="showAssitant"></assistant-clipboard>');
$templateCache.put('app/entities/group-session/edit/group-session-tpl.html','<form name="editForm" role="form"><div class="box-body mb-15"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-9 col-md-9 col-lg-9"><div class="form-group has-feedback" ng-class="vm.groupSession.title?(editForm.title.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_title">Title:</label> <input type="text" class="form-control" name="title" id="field_title" required ng-model="vm.groupSession.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.groupSession.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSession.title && editForm.title.$dirty"></span> <span class="help-block" ng-show="!vm.groupSession.title">This field is required</span></div></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="eventStart">Date:</label> <input type="date" ng-model="vm.groupSession.startDate" disabled="disabled" class="form-control" id="field_startDate" name="startDate"></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSession.ageBegin?(editForm.eventAgeBegin.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="eventAgeBegin">Age Begin:</label> <input type="number" class="form-control" name="eventAgeBegin" id="eventAgeBegin" min="5" max="110" ng-model="vm.groupSession.ageBegin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.groupSession.ageBegin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSession.ageBegin && editForm.ageBegin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.groupSession.ageBegin">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSession.ageEnd?(editForm.eventAgeEnd.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="eventAgeEnd">Age End:</label> <input type="number" class="form-control" name="eventAgeEnd" min="5" max="110" id="eventAgeEnd" ng-model="vm.groupSession.ageEnd"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.groupSession.ageEnd"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSession.ageEnd && editForm.ageEnd.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.groupSession.ageEnd">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSession.sessionType?(editForm.eventSessionType.$dirty?\'has-success\':\'\'):\'has-warning\'"><div class="form-group"><label for="eventSessionType">Session Type:</label> <select class="form-control" id="eventSessionType" name="eventSessionType" ng-model="vm.groupSession.sessionType" ng-options="sessionType as sessionType.name for sessionType in vm.sessionTypes track by sessionType.id"></select> <span class="help-block help-warning" ng-show="!vm.groupSession.sessionType">This field is suggested</span></div></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="form-group has-feedback col-xs-6 col-sm-6 col-md-3 col-lg-3" ng-class="vm.groupSession.start?(vm.editForm.eventStart.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="eventStart">Event Start:</label> <input type="time" style="padding: 6px 12px;" ng-model="vm.groupSession.start" class="form-control" id="eventStart" name="eventStart" required> <span class="help-block" ng-show="!vm.groupSession.start">This field is required</span></div><div class="form-group has-feedback col-xs-6 col-sm-6 col-md-3 col-lg-3" ng-class="vm.groupSession.stop?(vm.editForm.eventStop.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="eventStop">Event Stop:</label> <input type="time" style="padding: 6px 12px;" ng-model="vm.groupSession.stop" class="form-control" id="eventStop" name="eventStop" required> <span class="help-block" ng-show="!vm.groupSession.stop">This field is required</span></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="eventBillable">Billable:</label><br><button type="button" class="btn btn-block" id="eventBillable" ng-class="{\'btn-success\': vm.groupSession.billable,\n                                                                    \'btn-danger\': !vm.groupSession.billable}" ng-model="vm.event.billable" uib-btn-checkbox ng-click="vm.groupSession.billable = !vm.groupSession.billable"><span ng-if="vm.groupSession.billable">Billable</span> <span ng-if="!vm.groupSession.billable">No Billable</span></button></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSession.employees && vm.groupSession.employees.length > 0 ?\'has-success\':\'has-warning\'"><label for="eventRepresentatives">Representatives:</label><ui-select id="eventRepresentatives" name="eventRepresentatives" multiple="multiple" ng-model="vm.groupSession.employees" close-on-select="false" title="Select employees..."><ui-select-match placeholder="Select Employees...">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSession.employees || (vm.groupSession.employees.length < 1 )">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSession.reviewer?\'has-success\':\'has-warning\'"><label for="eventReviewers">Reviewer:</label><ui-select id="eventReviewers" name="eventReviewers" reset-search-input="false" ng-model="vm.groupSession.reviewer" title="Select Employee..."><ui-select-match allow-clear="true" placeholder="Select Employee...">{{$select.selected.firstName + " " + $select.selected.lastName}}</ui-select-match><ui-select-choices repeat="employee in vm.reviewers" refresh="vm.getReviewers($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \', \' + employee.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSession.reviewer">This field is suggested</span></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.groupSession.description?(editForm.eventDescription.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="eventDescription">Description:</label> <textarea type="text" class="form-control" name="eventDescription" id="eventDescription" data-resize="disabled" rows="4" ng-model="vm.groupSession.description">\n                        </textarea> <span class="help-block" ng-show="!vm.groupSession.description">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr><div class="text-right"><button type="button" class="btn btn-success btn-sm pull-right" ng-disabled="editForm.$error.required || vm.isSaving" ng-click="vm.save()"><i class="fa fa-save"></i> Save</button></div></div></div></div><!-- ./box-body --></form>');
$templateCache.put('app/entities/group-session/history-audit/group-session-history-audit.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">{{vm.groupSession.title}} - Audit History</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Employee</strong></th><th><strong>Start Date</strong></th><th><strong>End Date</strong></th><th></th></tr></thead><tbody><tr ng-repeat="groupSessionsDetailsHistory in vm.groupSessionsDetailsHistory"><td class="name">{{groupSessionsDetailsHistory.employee.firstName}} {{groupSessionsDetailsHistory.employee.lastName }}</td><td class="created"><span class="date" ng-if="groupSessionsDetailsHistory.startDate">{{groupSessionsDetailsHistory.startDate | date: inputDateTimeFormatA}}</span></td><td class="created"><span class="date" ng-if="groupSessionsDetailsHistory.endDate">{{groupSessionsDetailsHistory.endDate | date: inputDateTimeFormatA}}</span></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/group-session/init/group-session-init-tpl.html','<form name="vm.editForm" role="form"><div class="box-body mb-15"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-9 col-md-9 col-lg-9"><div class="form-group has-feedback" ng-class="vm.groupSession.title?(vm.editForm.title.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_title">Title:</label> <input type="text" class="form-control" name="title" id="field_title" required ng-model="vm.groupSession.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.groupSession.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSession.title && vm.editForm.title.$dirty"></span> <span class="help-block" ng-show="!vm.groupSession.title">This field is required</span></div></div><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3"><div class="form-group"><label for="eventStart">Date:</label> <input type="date" ng-model="vm.groupSession.startDate" disabled="disabled" class="form-control" id="field_startDate" name="startDate"></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSession.ageBegin?(vm.editForm.eventAgeBegin.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="eventAgeBegin">Age Begin:</label> <input type="number" class="form-control" name="eventAgeBegin" id="eventAgeBegin" min="5" max="110" ng-model="vm.groupSession.ageBegin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.groupSession.ageBegin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSession.ageBegin && vm.editForm.ageBegin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.groupSession.ageBegin">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSession.ageEnd?(vm.editForm.eventAgeEnd.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="eventAgeEnd">Age End:</label> <input type="number" class="form-control" name="eventAgeEnd" min="5" max="110" id="eventAgeEnd" ng-model="vm.groupSession.ageEnd"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.groupSession.ageEnd"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSession.ageEnd && vm.editForm.ageEnd.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.groupSession.ageEnd">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSession.sessionType?(vm.editForm.eventSessionType.$dirty?\'has-success\':\'\'):\'has-warning\'"><div class="form-group"><label for="eventSessionType">Session Type:</label> <select class="form-control" id="eventSessionType" name="eventSessionType" ng-model="vm.groupSession.sessionType" ng-options="sessionType as sessionType.name for sessionType in vm.sessionTypes track by sessionType.id"></select> <span class="help-block help-warning" ng-show="!vm.groupSession.sessionType">This field is suggested</span></div></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSession.start?(vm.editForm.eventStart.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="eventStart">Event Start:</label> <input type="time" style="padding: 6px 12px;" ng-model="vm.groupSession.start" class="form-control" id="eventStart" name="eventStart" required> <span class="help-block" ng-show="!vm.groupSession.start">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSession.stop?(vm.editForm.eventStop.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="eventStop">Event Stop:</label> <input type="time" style="padding: 6px 12px;" ng-model="vm.groupSession.stop" class="form-control" id="eventStop" name="eventStop" required> <span class="help-block" ng-show="!vm.groupSession.stop">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label for="eventBillable">Billable:</label><br><button type="button" class="btn btn-block" id="eventBillable" ng-class="{\'btn-success\': vm.groupSession.billable,\n                                                                    \'btn-danger\': !vm.groupSession.billable}" ng-model="vm.event.billable" uib-btn-checkbox ng-click="vm.groupSession.billable = !vm.groupSession.billable"><span ng-if="vm.groupSession.billable">Billable</span> <span ng-if="!vm.groupSession.billable">No Billable</span></button></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSession.employees && vm.groupSession.employees.length > 0 ?\'has-success\':\'has-warning\'"><label for="eventRepresentatives">Representatives:</label><ui-select id="eventRepresentatives" name="eventRepresentatives" multiple="multiple" ng-disabled="vm.groupSession.status2 == \'REVIEW\' || vm.groupSession.status2 == \'COMPLETE\'" ng-model="vm.groupSession.employees" close-on-select="false" title="Select employees..."><ui-select-match placeholder="Select Employees...">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSession.employees || (vm.groupSession.employees.length < 1 )">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSession.reviewer?\'has-success\':\'has-warning\'"><label for="eventReviewers">Reviewer:</label><ui-select id="eventReviewers" name="eventReviewers" reset-search-input="false" ng-disabled="vm.groupSession.status2 == \'COMPLETE\'" ng-model="vm.groupSession.reviewer" title="Select Employee..."><ui-select-match allow-clear="true" placeholder="Select Employee...">{{$select.selected.firstName + " " + $select.selected.lastName}}</ui-select-match><ui-select-choices repeat="employee in vm.reviewers" refresh="vm.getReviewers($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSession.reviewer">This field is suggested</span></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.groupSession.description?(vm.editForm.eventDescription.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="eventDescription">Description:</label> <textarea type="text" class="form-control" name="eventDescription" id="eventDescription" data-resize="disabled" rows="4" ng-model="vm.groupSession.description">\n                        </textarea> <span class="help-block" ng-show="!vm.groupSession.description">This field is required</span></div></div></div></div><!-- ./box-body --></form>');
$templateCache.put('app/entities/group-session/init/group-session-init.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGreetingLabel">Start New Group Session</h4></div><div class="modal-body"><ng-include src="\'app/entities/group-session/init/group-session-init-tpl.html\'"></ng-include></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.editForm.$error.required || vm.editForm.$invalid || vm.isSaving" ng-click="vm.save()"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/group-session-details/detail/group-session-details-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGroupSessionDetailsLabel">Group Session Details</h4></div><div class="modal-body group-sessions-modal"><jhi-alert-error></jhi-alert-error><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><udt-chart-header chart="vm.chart"></udt-chart-header></div><h3>Basic Information:</h3><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h5 class="mb-0"><strong>Title:</strong></h5><p>{{vm.groupSession.title}}</p></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Event Start:</strong></h5><p>{{vm.formatDateNew(vm.groupSessionDetails.start)}}</p></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Event Stop:</strong></h5><p>{{vm.formatDateNew(vm.groupSessionDetails.stop)}}</p></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Billable:</strong></h5><p ng-if="vm.groupSessionDetails.vm.groupSession.billable">Billable</p><p ng-if="!vm.groupSessionDetails.vm.groupSession.billable">No Billable</p></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Age Begin:</strong></h5><p>{{vm.groupSession.ageBegin?vm.groupSession.ageBegin:\'-\'}}</p></div><div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Age End:</strong></h5><p>{{vm.groupSession.ageEnd?vm.groupSession.ageEnd:\'-\'}}</p></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Session Type:</strong></h5><p>{{vm.groupSession.sessionType?vm.groupSession.sessionType.name:\'-\'}}</p></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Employee:</strong></h5><p>{{vm.groupSession.leader | employeeName}}</p></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><h5 class="mb-0"><strong>Reviewer:</strong></h5><p>{{vm.groupSession.reviewer | employeeName}}</p></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h5 class="mb-0"><strong>Description:</strong></h5><p class="text-justify">{{vm.groupSession.description}}</p></div></div><div class="box-body mb-15" ng-if="vm.jsonTemplate"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h3 class="heading">Notes:</h3><div class="attendees-list"><div class="attendee"><div class="annexed opened well well-sm"><form name="editForm" role="form" novalidate><ods-form schema="vm.jsonTemplate"></ods-form></form></div></div></div></div></div></div><div ng-if="(vm.groupSession.leaderSignatureId) || (vm.groupSession.reviewerSignatureId)"><h3>Signatures:</h3><hr><div class="well signs-array"><div class="sign-item mb-15" ng-if="vm.groupSession.leaderSignatureId"><figure><img ng-src-sign="{{vm.groupSession.leaderSignatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Leader: {{vm.groupSession.leader | employeeName}} Date: {{vm.leaderSignature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.groupSession.reviewerSignatureId"><figure><img ng-src-sign="{{vm.groupSession.reviewerSignatureId}}" id="reviewerSignatureId" alt="Reviewer Signature" width="300" class="img-responsive"><figcaption>Reviewer: {{vm.groupSession.reviewer | employeeName}} Date: {{vm.reviewerSignature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div>');
$templateCache.put('app/entities/group-session-form-tpl/clone/group-session-form-tpl-clone-dialog.html','<form name="copyForm" ng-submit="vm.confirmClone(vm.evaluationTemplate.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Clone Evaluation Template</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is will <strong>clone</strong> this Evaluation Template. Are you sure you want to <strong>clone</strong> this Evaluation Template?</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-disabled="copyForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Clone</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/group-session-form-tpl/list/group-session-form-tpl.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/group-session-form-tpl/update/group-session-form-tpl-edit.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Template</h3><div class="row pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-disabled="vm.form.patient_info_form.$invalid" ng-click="vm.save()" ng-show="!vm.edit">Save Information</button></div></div></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" heading="Configuration"><fieldset><ng-include src="\'app/entities/group-session-form-tpl/update/tpl/metadata-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" heading="Form Schema"><div class="row"><div class="col-md-3"><ods-form-toolbar></ods-form-toolbar></div><div class="col-md-9"><ods-schema schema="vm.groupSessionFormTpl.jsonTemplate" debug-mode="vm.debugMode"></ods-schema></div></div></uib-tab><uib-tab index="3" heading="Form Preview"><ods-form schema="vm.groupSessionFormTpl.jsonTemplate" on-save="saveForm(vm.schema)"></ods-form></uib-tab><uib-tab index="4" heading="Form Model" ng-show="vm.debugMode"><ods-model model="vm.groupSessionFormTpl.jsonTemplate" css-class="fixed-height"></ods-model></uib-tab></uib-tabset></div><div class="box-footer"><div class="row pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-disabled="form.$invalid" ng-click="vm.save()" ng-show="!vm.edit">Save Information</button></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/group-session-template/list/group-session-template.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/group-session-template/update/group-session-template-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myGroupSessionTemplateLabel">Create or edit a Group Session Template</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.title?(editForm.title.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_title">Title:</label> <input type="text" class="form-control" name="title" id="field_title" required ng-model="vm.groupSessionTemplate.title"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.groupSessionTemplate.title"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSessionTemplate.title && editForm.title.$dirty"></span> <span class="help-block" ng-show="!vm.groupSessionTemplate.title">This field is required</span></div><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.description?(editForm.description.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_description">Description:</label> <textarea type="text" class="form-control" name="description" id="field_description" data-resize="disabled" rows="2" ng-model="vm.groupSessionTemplate.description">\n                    </textarea> <span class="help-block" ng-show="!vm.groupSessionTemplate.description">This field is required</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.start?(editForm.start.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_start">Start:</label><div class="input-group"><div uib-timepicker name="start" ng-model="vm.groupSessionTemplate.start" show-meridian="true" id="field_start" required></div><span class="help-block" ng-show="!vm.groupSessionTemplate.start || editForm.start.$error.required">This field is required.</span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.stop?(editForm.stop.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_stop">Stop:</label><div class="input-group"><div uib-timepicker name="stop" ng-model="vm.groupSessionTemplate.stop" show-meridian="true" id="field_stop" required></div><span class="help-block" ng-show="!vm.groupSessionTemplate.stop || editForm.stop.$error.required">This field is required.</span></div></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.ageBegin?(editForm.ageBegin.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_ageBegin">Age Begin:</label> <input type="number" class="form-control" name="ageBegin" id="field_ageBegin" min="10" max="90" ng-model="vm.groupSessionTemplate.ageBegin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.groupSessionTemplate.ageBegin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSessionTemplate.ageBegin && editForm.ageBegin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.groupSessionTemplate.ageBegin">This field is suggested</span></div></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.ageEnd?(editForm.ageEnd.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_ageEnd">Age End:</label> <input type="number" class="form-control" name="ageEnd" min="10" max="90" id="field_ageEnd" ng-model="vm.groupSessionTemplate.ageEnd"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.groupSessionTemplate.ageEnd"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.groupSessionTemplate.ageEnd && editForm.ageEnd.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.groupSessionTemplate.ageEnd">This field is suggested</span></div></div><div class="col-xs-6 col-sm-2 col-md-2 col-lg-2"><div class="form-group"><label for="field_enabled">Enabled:</label><br><toggle id="field_enabled" ng-model="vm.groupSessionTemplate.enabled" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div><div class="col-xs-6 col-sm-2 col-md-2 col-lg-2"><div class="form-group"><label for="field_billable">Billable:</label><br><toggle id="field_billable" ng-model="vm.groupSessionTemplate.billable" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.daysWeek?(vm.daysWeek.length > 0?\'has-success\':\'has-error\'):\'has-error\'"><label for="field_daysWeek">Week Days:</label><ui-select id="field_daysWeek" name="daysWeek" multiple="multiple" required ng-model="vm.daysWeek" close-on-select="false" title="Days of the week"><ui-select-match placeholder="Select Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search">{{day}}</ui-select-choices></ui-select><span class="help-block" ng-show="!vm.daysWeek || (vm.daysWeek.length === 0)">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.sessionType?(editForm.sessionType.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_sessionType">Session Type:</label> <select class="form-control" id="field_sessionType" name="sessionType" ng-model="vm.groupSessionTemplate.sessionType" ng-options="sessionType as sessionType.name for sessionType in vm.sessionTypes track by sessionType.id"></select> <span class="help-block help-warning" ng-show="!vm.groupSessionTemplate.sessionType">This field is suggested</span></div></div></div><hr><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.buildings?(vm.groupSessionTemplate.buildings.length > 0?\'has-success\':\'has-warning\'):\'has-warning\'"><label for="field_building">Buildings:</label><ui-select id="field_building" name="buildings" multiple="multiple" ng-model="vm.groupSessionTemplate.buildings" close-on-select="false" title="Select buildings..."><ui-select-match placeholder="Select Buildings...">{{$item.name}}</ui-select-match><ui-select-choices repeat="building in vm.buildings" refresh="vm.getBuildings($select.search)" refresh-delay="0"><div ng-bind-html="building.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSessionTemplate.buildings || (vm.groupSessionTemplate.buildings.length === 0)">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.groupSessionFormTpl?(vm.groupSessionTemplate.groupSessionFormTpl?\'has-success\':\'has-error\'):\'has-error\'"><label for="field_groupSessionFormTpl">Group Session Form Tpl:</label><ui-select id="field_groupSessionFormTpl" name="groupSessionFormTpl" required ng-model="vm.groupSessionTemplate.groupSessionFormTpl" close-on-select="true" title="Group Session Form Tpl"><ui-select-match allow-clear="true" placeholder="Select Group Session Form Tpl...">{{$select.selected.name + ($select.selected.description ? \' - \' + $select.selected.description : \'\')}}</ui-select-match><ui-select-choices repeat="groupSessionFormTpl in vm.groupSessionFormTpls | filter: $select.search" refresh="vm.getGroupSessionFormTpls($select.search)" refresh-delay="0"><div ng-bind-html=" groupSessionFormTpl.name + ($select.selected.description ? \' - \' + $select.selected.description : \'\') | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block" ng-show="!vm.groupSessionTemplate.groupSessionFormTpl">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.employees?(vm.groupSessionTemplate.employees.length > 0?\'has-success\':\'has-warning\'):\'has-warning\'"><label for="field_employee">Representatives:</label><ui-select id="field_employee" name="employees" multiple="multiple" ng-model="vm.groupSessionTemplate.employees" close-on-select="false" title="Select employees..."><ui-select-match placeholder="Select Employees...">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSessionTemplate.employees || (vm.groupSessionTemplate.employees.length === 0)">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.groupSessionTemplate.reviewer?\'has-success\':\'has-warning\'"><label for="field_reviewer">Reviewer:</label><ui-select id="field_reviewer" name="reviewer" reset-search-input="false" ng-model="vm.groupSessionTemplate.reviewer" title="Select Employee..."><ui-select-match allow-clear="true" placeholder="Select Employee...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.reviewers" refresh="vm.getReviewers($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.groupSessionTemplate.reviewer">This field is suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/incident-department/list/incident-department.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/incident-department/update/incident-department-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Create or edit a Incident Department</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.incidentDepartment.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.incidentDepartment.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.incidentDepartment.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.incidentDepartment.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.incidentDepartment.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.incidentDepartment.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.incidentDepartment.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/incident-report/list/incident-report.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/incident-report-note/detail/incident-report-note-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="incidentReportNoteLabel"><span>{{vm.incidentReportNote.name}}</span></h4></div><div class="modal-body" id="print-wrapper"><jhi-alert-error></jhi-alert-error><ods-viewer schema="vm.jsonTemplate"></ods-viewer><!--    <div class="form-directive-wrapper">--><!--        <ods-viewer schema="vm.jsonTemplate" config="vm.formCKEditorTokensConfig"></ods-viewer>--><!--        <div class="well signs-array">--><div class="sign-item mb-15" ng-if="vm.incidentReportNote.signature"><figure><img ng-src-sign="{{vm.incidentReportNote.signature.id}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Staff: {{vm.incidentReportNote.employee.firstName + \' \' + vm.incidentReportNote.employee.lastName}}, Date: {{vm.incidentReportNote.signature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div></div>');
$templateCache.put('app/entities/incident-report-note/update/incident-report-note-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Edit Note</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><form name="editForm" role="form" novalidate><ods-form schema="vm.jsonTemplate"></ods-form></form></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-disabled="vm.isSaving" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/incident-report-note-template/assign/incident-report-note-template-assign-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Incident Report Notes</h4></div><div class="modal-body"><div class="search-input"><input type="text" class="form-control" placeholder="Search..." id="searchQueryIncidentReportNoteTemplates" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><div id="incident-report-note-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.assign()" ng-disabled="vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Assign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/incident-report-note-template/clone/incident-report-note-template-clone-dialog.html','<form name="copyForm" ng-submit="vm.confirmClone(vm.incidentReportTemplate.id)"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Clone Incident Report Note Template</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">This action is will <strong>clone</strong> this Incident Report Note Template. Are you sure you want to <strong>clone</strong> this Incident Report Note Template?</p></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-disabled="copyForm.$invalid"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Clone</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/incident-report-note-template/list/incident-report-note-template.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/incident-report-note-template/update/incident-report-note-template-edit.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="row"><div class="col-md-12"><div class="box box-primary"><div class="box-header with-border"><h3 class="box-title">Template</h3><div class="row pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-disabled="vm.form.metadata.$invalid" ng-click="vm.save()" ng-show="!vm.edit">Save Information</button></div></div></div><jhi-alert-error></jhi-alert-error><div class="box-body"><uib-tabset class="nav-tabs-custom" active="vm.activeTab"><uib-tab index="0" heading="Configuration"><fieldset><ng-include src="\'app/entities/incident-report-note-template/update/tpl/metadata-tpl.html\'"></ng-include></fieldset></uib-tab><uib-tab index="2" heading="Form Schema"><div class="row"><div class="col-md-3"><ods-form-toolbar></ods-form-toolbar></div><div class="col-md-9"><ods-schema schema="vm.incidentReportTemplate.jsonTemplate"></ods-schema></div></div></uib-tab><uib-tab index="3" heading="Form Preview"></uib-tab><uib-tab index="4" heading="Form Model" ng-show="vm.debugMode"><ods-model model="vm.incidentReportTemplate.jsonTemplate" css-class="fixed-height"></ods-model></uib-tab></uib-tabset></div><div class="box-footer"><div class="row pull-right"><div class="col-lg-12"><button type="button" class="btn btn-success" ng-disabled="vm.form.metadata.$invalid" ng-click="vm.save()" ng-show="!vm.edit">Save Information</button></div></div></div></div></div></div></section>');
$templateCache.put('app/entities/incident-severity/list/incident-severity.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/incident-severity/update/incident-severity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySeverityLabel">Create or edit a Incident Severity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.incidentSeverity.id"><label for="id">ID:</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.incidentSeverity.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.incidentSeverity.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.incidentSeverity.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.incidentSeverity.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.incidentSeverity.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.incidentSeverity.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/incident-type/list/incident-type.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/incident-type/update/incident-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myIncidentTypeLabel">Create or edit a Incident Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.incidentType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.incidentType.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.incidentType.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.incidentType.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.incidentType.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.incidentType.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.incidentType.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/init-value/list/init-value.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/init-value/update/init-value-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInitValueLabel">Create or edit a Init Value</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.initValue.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.initValue.id" readonly="readonly"></div><div class="form-grouphas-feedback" ng-class="vm.initValue.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.initValue.name" required> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span></div><div class="form-group"><label class="control-label" for="field_entity">Entity</label> <select class="form-control" name="entity" ng-model="vm.initValue.entity" id="field_entity"><option value="Acuity">Acuity</option><option value="Via">Via</option><option value="TypeFoodDiets">TypeFoodDiets</option><option value="Severity">Severity</option><option value="TypeCheck">TypeCheck</option><option value="InsuranceType">InsuranceType</option><option value="GlucoseIntervention">GlucoseIntervention</option><option value="TypeMaritalStatus">TypeMaritalStatus</option><option value="TypeSpeciality">TypeSpeciality</option><option value="SessionType">SessionType</option><option value="TypeEthnicity">TypeEthnicity</option><option value="TypeDischargeType">TypeDischargeType</option><option value="ShiftType">ShiftType</option><option value="Greeting">Greeting</option><option value="CrmOutboundReferralStatus">CrmOutboundReferralStatus</option><option value="Reaction">Reaction</option><option value="TypePatientContactTypes">TypePatientContactTypes</option><option value="CrmTag">CrmTag</option><option value="Allergen">Allergen</option><option value="TypePatientContactsRelationship">TypePatientContactsRelationship</option><option value="InsuranceLevel">InsuranceLevel</option><option value="DoseForm">DoseForm</option><option value="PatientMedicationTakeMissedReason">PatientMedicationTakeMissedReason</option><option value="TypePatientPropertyCondition">TypePatientPropertyCondition</option><option value="BlockedTimeReason">BlockedTimeReason</option><option value="TypeLevelCare">TypeLevelCare</option><option value="AppointmentType">AppointmentType</option><option value="InsuranceRelation">InsuranceRelation</option><option value="TypeRace">TypeRace</option></select></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/insurance/update/insurance-dialog.html','<form name="vm.form.insurance" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Insurance Info</h4></div><fieldset ng-disabled="vm.chart.status == \'CLOSED\'"><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.insuranceCarrier?(vm.form.insurance.insurance_carrier.$dirty || vm.form.insurance.insurance_carrier.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_carrier">Insurance Carrier:</label><ui-select ng-model="vm.insurance.insuranceCarrier" name="insurance_carrier" id="field_insurance_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{ $select.selected.id? $select.selected.name: $select.selected.name + \'(new)\'}}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0">{{carrier.id? carrier.name: (carrier.name + \'(new)\')}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.insurance.insurance_carrier.$error.required"></span> <span class="help-block" ng-show="vm.form.insurance.insurance_carrier.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.policyNumber?(vm.form.insurance.insurance_policyNumber.$dirty || vm.form.insurance.insurance_policyNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_policyNumber">Policy Number:</label> <input type="text" class="form-control" name="insurance_policyNumber" id="field_insurance_policyNumber" required ng-model="vm.insurance.policyNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.policyNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.policyNumber && vm.form.insurance.insurance_policyNumber.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.policyNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.preCertPhone?(vm.form.insurance.insurance_preCertPhone.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_preCertPhone">Pre-Cert Number:</label> <input type="text" class="form-control" name="insurance_preCertPhone" id="field_insurance_preCertPhone" ng-model="vm.insurance.preCertPhone" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.preCertPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.preCertPhone && vm.form.insurance.insurance_preCertPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.preCertPhone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.groupNumber?(vm.form.insurance.insurance_groupNumber.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_insurance_groupNumber">Group Number:</label> <input type="text" class="form-control" name="insurance_groupNumber" id="field_insurance_groupNumber" ng-model="vm.insurance.groupNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.groupNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.groupNumber && vm.form.insurance.insurance_groupNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.groupNumber">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.insuranceType?(vm.form.insurance.insurance_type.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_insuranceType">Insurance Type:</label> <select class="form-control" id="field_insurance_insuranceType" name="insurance_type" ng-model="vm.insurance.insuranceType" ng-options="insuranceType as insuranceType.name for insuranceType in vm.insuranceTypes track by insuranceType.id"><option value=""></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.insuranceType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.insuranceType && vm.form.insurance.insurance_type.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.insuranceType">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.rxBin?(vm.form.insurance.insurance_rxBin.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_rxbin">RxBin:</label> <input type="text" class="form-control" name="insurance_rxBin" id="field_insurance_rxBin" ng-model="vm.insurance.rxBin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.rxBin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.rxBin && vm.form.insurance.insurance_rxBin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.rxBin">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.pcn?(vm.form.insurance.insurance_pcn.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_pcn">RxPCN:</label> <input type="text" class="form-control" name="insurance_pcn" id="field_insurance_pcn" ng-model="vm.insurance.pcn"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.pcn"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.pcn && vm.form.insurance.insurance_pcn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.pcn">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.memberId?(vm.form.insurance.insurance_memberId.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_memberId">Member</label> <input type="text" class="form-control" name="insurance_memberId" id="field_insurance_memberId" ng-model="vm.insurance.memberId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.memberId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.memberId && vm.form.insurance.insurance_memberId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.memberId">This field is suggested</span></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.firstName?(vm.form.insurance.insurance_firstName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_firstName">Subscriber First Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_firstName" id="field_insurance_firstName" required ng-model="vm.insurance.firstName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.insurance.firstName = vm.chart.firstName"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.firstName && vm.form.insurance.insurance_firstName.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.firstName">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.firstName?(vm.form.insurance.insurance_firstName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_firstName">Subscriber First Name:</label> <input type="text" class="form-control" name="insurance_firstName" id="field_insurance_firstName" required ng-model="vm.insurance.firstName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.firstName && vm.form.insurance.insurance_firstName.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.firstName">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.lastName?(vm.form.insurance.insurance_lastName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_lastName">Subscriber Last Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_lastName" id="field_insurance_lastName" required ng-model="vm.insurance.lastName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.insurance.lastName = vm.chart.lastName"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.lastName && vm.form.insurance.insurance_lastName.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.lastName">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.lastName?(vm.form.insurance.insurance_lastName.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_lastName">Subscriber Last Name:</label> <input type="text" class="form-control" name="insurance_lastName" id="field_insurance_lastName" required ng-model="vm.insurance.lastName"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.lastName && vm.form.insurance.insurance_lastName.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.lastName">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.dob?(vm.form.insurance.insurance_dob.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Subscriber DOB:</label><div class="input-group input-group-sm"><input id="field_insurance_dob" type="text" class="form-control" name="insurance_dob" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.insurance.dob" is-open="vm.datePickerOpenStatus.insuranceDob[$index]"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openInsuranceCalendar($index)"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-default" title="Import" ng-click="vm.insurance.dob = vm.chart.dateBirth"><i class="glyphicon glyphicon-copy"></i></button></div><span class="help-block" ng-show="!vm.insurance.dob">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.dob?(vm.form.insurance.insurance_dob.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Subscriber DOB:</label><div class="input-group input-group-sm"><input id="field_insurance_dob" type="text" class="form-control" name="insurance_dob" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.insurance.dob" is-open="vm.datePickerOpenStatus.insuranceDob[$index]"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openInsuranceCalendar($index)"><i class="glyphicon glyphicon-calendar"></i></button></div><span class="help-block" ng-show="!vm.insurance.dob">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.socialSecurity?(vm.form.insurance.insurance_ssn.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_ssn">Subscriber SSN:</label> <input type="text" class="form-control" name="insurance_ssn" id="field_insurance_ssn" ng-model="vm.insurance.socialSecurity" ui-mask="999-99-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.socialSecurity"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.socialSecurity && vm.form.insurance.insurance_ssn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.socialSecurity">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.insuranceRelation?(vm.form.insurance.insurance_insuranceRelation.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_insuranceRelation">Relationship:</label> <select class="form-control" id="field_insurance_insuranceRelation" name="insurance_insuranceRelation" required ng-model="vm.insurance.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insuranceRelations track by insuranceRelation.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.insuranceRelation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.insuranceRelation && vm.form.insurance.insurance_insuranceRelation.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.insuranceRelation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.insurance.gender?(vm.form.insurance.gender?\'has-success\':\'\'):\'has-error\'"><label for="gender">Subscriber Gender:</label><div class="input-group input-group-sm"><select class="form-control" id="gender" name="gender" required ng-model="vm.insurance.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.insurance.gender = vm.chart.sex"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.insurance.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.insurance.gender && vm.form.insurance.gender.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.gender">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.phone?(vm.form.insurance.insurance_phone.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.insurance.phone" ui-mask="(999) 999-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.insurance.phone = vm.chart.phone"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.phone && vm.form.insurance.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.phone">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.phone?(vm.form.insurance.insurance_phone.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label> <input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.insurance.phone" ui-mask="(999) 999-9999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.phone && vm.form.insurance.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.phone">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.address?(vm.form.insurance.insurance_address.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.insurance.address"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.insurance.address = vm.chart.address"><i class="glyphicon glyphicon-copy" title="asda"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.address && vm.form.insurance.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.address">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.address?(vm.form.insurance.insurance_address.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label> <input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.insurance.address"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.address && vm.form.insurance.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.address">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.address2?(vm.form.insurance.insurance_address2.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.insurance.address2"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.insurance.address2 = vm.chart.addressTwo"><i class="glyphicon glyphicon-copy" title="asda"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.address2 && vm.form.insurance.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.address2">This field is suggested</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.address2?(vm.form.insurance.insurance_address2.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2</label> <input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.insurance.address2"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.address2 && vm.form.insurance.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.insurance.address2">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.city?(vm.form.insurance.insurance_city.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.insurance.city"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.insurance.city = vm.chart.city"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.city && vm.form.insurance.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.city">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.city?(vm.form.insurance.insurance_city.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label> <input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.insurance.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.city && vm.form.insurance.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.city">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.countryState?(vm.form.insurance.insurance_state.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label><div class="input-group input-group-sm"><select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.insurance.countryState" ng-options="item as item.state for item in vm.states track by item.id"></select> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.insurance.countryState = vm.chart.countryState"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.countryState && vm.form.insurance.insurance_state.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.countryState">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.state?(vm.form.insurance.insurance_state.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label> <select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.insurance.state" ng-options="item.stateCode as item.state for item in vm.countryStates track by item.stateCode"><option value="">{{vm.insurance.state}}</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.state"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.state && vm.form.insurance.insurance_states.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.state">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.insurance.zipCode?(vm.form.insurance.insurance_zipCode.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.insurance.zipCode" ui-mask="99999"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.insurance.zipCode = vm.chart.zip"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.zipCode && vm.form.insurance.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.zipCode">This field is required</span></div></div><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState === \'insurance-edit\'" ng-class="vm.insurance.zipCode?(vm.form.insurance.insurance_zipCode.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label> <input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.insurance.zipCode" ui-mask="99999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insurance.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insurance.zipCode && vm.form.insurance.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.insurance.zipCode">This field is required</span></div></div></div></div></div></div></fieldset><div class="modal-footer"><button class="btn btn-danger" style="margin-right: auto" type="button" ng-if="vm.insurance.id" ng-click="vm.showDelete = true" ng-disabled="vm.chart.status === \'CLOSED\'"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button> <button class="btn btn-success" type="button" ng-disabled="vm.chart.status === \'CLOSED\' || vm.form.insurance.$invalid" ng-click="vm.save()"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button class="btn btn-danger" type="button" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div><div class="overlay-delete" ng-if="vm.showDelete" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action is <strong>final</strong> and will <strong>remove</strong> this Insurance from this patient\'s record. Are you sure you want to <strong>delete</strong> this Insurance?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDelete()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDelete = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/insurance-billing-config/list/insurance-billing-config.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/insurance-billing-config/update/insurance-billing-config-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInsuranceBillingConfigLabel">Create or edit a Insurance Billing Config</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceBillingConfig.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceBillingConfig.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.insuranceBillingConfig.hours?(editForm.hours.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_hours">Hours</label> <input type="number" class="form-control" name="hours" id="field_hours" ng-model="vm.insuranceBillingConfig.hours" required> <span class="help-block" ng-show="!vm.insuranceBillingConfig.hours">This field is required</span> <span class="help-block" ng-show="editForm.hours.$error.number">This field should be a number.</span></div><div class="form-group form-group-sm"><label for="field_insuranceCarrier">Insurance Carrier</label><ui-select id="field_insuranceCarrier" name="insuranceCarrier" multiple="multiple" ng-model="vm.insuranceBillingConfig.insuranceCarriers" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Insurance Carriers...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.insuranceCarriers | filter: $select.search" refresh="vm.getInsuranceCarriers($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><div class="form-group has-feedback" ng-class="vm.insuranceBillingConfig.typeLevelCares && vm.insuranceBillingConfig.typeLevelCares.length > 0?(editForm.typeLevelCare.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_typeLevelCare">Levels Of Care</label> <select class="form-control" id="field_typeLevelCare" multiple="multiple" name="typeLevelCare" ng-model="vm.insuranceBillingConfig.typeLevelCares" ng-options="typeLevelCare as typeLevelCare.name for typeLevelCare in vm.typelevelcares track by typeLevelCare.id" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insuranceBillingConfig.typeLevelCares"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insuranceBillingConfig.typeLevelCares && editForm.typeLevelCare.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.insuranceBillingConfig.typeLevelCares || vm.insuranceBillingConfig.typeLevelCares.length == 0">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/insurance-level/list/insurance-level.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/insurance-level/update/insurance-level-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInsuranceLevelLabel">Create or edit a Insurance Level</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceLevel.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceLevel.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.insuranceLevel.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceLevel.name" required> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/insurance-relation/list/insurance-relation.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/insurance-relation/update/insurance-relation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInsuranceRelationLabel">Create or edit a Insurance Relation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceRelation.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceRelation.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.insuranceRelation.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.insuranceRelation.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.insuranceRelation.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.insuranceRelation.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.insuranceRelation.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/insurance-type/list/insurance-type.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/insurance-type/update/insurance-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInsuranceTypeLabel">Create or edit a Insurance Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.insuranceType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.insuranceType.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.insuranceType.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.insuranceType.name" required> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/lab-compendium/list/lab-compendium.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/lab-compendium/update/lab-compendium-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myLabCompendiumLabel">Create or Edit a Lab Compendium</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.code ?(editForm.code ?\'has-success\':\'\'):\'has-error\'"><label for="field_code">Code</label> <input type="text" class="form-control" name="code" id="field_code" ng-model="vm.labCompendium.code" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.code"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.code && editForm.code.$dirty"></span> <span class="help-block" ng-show="!vm.labCompendium.code">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.laboratory?(editForm.laboratory?\'has-success\':\'\'):\'has-error\'"><label for="field_laboratory">Laboratory</label> <select class="form-control" id="field_laboratory" name="laboratory" ng-disabled="true" ng-model="vm.labCompendium.laboratory" required ng-options="item as item.name for item in vm.laboratories track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.laboratory"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.laboratory"></span> <span class="help-block" ng-show="!vm.labCompendium.laboratory> 0">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.abbr ?(editForm.abbr ?\'has-success\':\'\'):\'has-warning\'"><label for="field_abbr">Abbr</label> <input type="text" class="form-control" name="abbr" id="field_abbr" ng-model="vm.labCompendium.abbr"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.abbr"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.abbr && editForm.abbr.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.abbr">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.units ?(editForm.units ?\'has-success\':\'\'):\'has-warning \'"><label for="field_units">Units</label> <input type="text" class="form-control" name="units" id="field_units" ng-model="vm.labCompendium.units"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.units"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.units && editForm.units.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.units">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.rptMetadata ? (editForm.intCode ?\'has-success\':\'\'):\'has-warning\'"><label for="field_intCode">Internal Code</label><ui-select ng-model="vm.labCompendium.rptMetadata" close-on-select="true" id="field_intCode" name="intCode"><ui-select-match>{{$select.selected.intCode + \', \'+ $select.selected.code}}</ui-select-match><ui-select-choices repeat="rptMetadata in vm.rptMetadatas | filter: $select.search"><div ng-bind-html=" rptMetadata.intCode + \', \' + rptMetadata.code | highlight: $select.search"></div><small ng-bind-html="rptMetadata.description | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.labCompendium.rptMetadata"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.labCompendium.rptMetadata"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.rptMetadata">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.description ?(editForm.description ?\'has-success\':\'\'):\'has-warning\'"><label for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.labCompendium.description"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.description"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.description && editForm.description.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.description">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.cutOff ?(editForm.cutOff ?\'has-success\':\'\'):\'has-warning\'"><label for="field_abbr">Cut Off</label> <input type="text" class="form-control" name="cutOff" id="field_cutOff" ng-model="vm.labCompendium.cutOff"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.cutOff"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.cutOff && editForm.cutOff.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.cutOff">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.wGroup ?(editForm.wGroup ?\'has-success\':\'\'):\'has-warning \'"><label for="field_units">W Group</label> <input type="text" class="form-control" name="wGroup" id="field_wGroup" ng-model="vm.labCompendium.wGroup"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.wGroup"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.wGroup && editForm.wGroup.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.wGroup">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.compendiumReportGroup ?(editForm.compendiumReportGroup ?\'has-success\':\'\'):\'has-error\'"><label for="field_compendiumReportGroup">Report Group</label> <select class="form-control" id="field_compendiumReportGroup" name="compendiumReportGroup" required ng-model="vm.labCompendium.compendiumReportGroup" ng-options="item as item.name for item in vm.compendiumReportGroups track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.labCompendium.compendiumReportGroup"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.labCompendium.compendiumReportGroup && editForm.compendiumReportGroup.$dirty"></span> <span class="help-block" ng-show="!vm.labCompendium.compendiumReportGroup">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.specimen ?(editForm.specimen ?\'has-success\':\'\'):\'has-error\'"><label for="field_specimen">Specimen</label> <select class="form-control" id="field_specimen" name="specimen" required ng-model="vm.labCompendium.specimen" ng-options="item as item.name for item in vm.specimens track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.labCompendium.specimen"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.labCompendium.specimen && editForm.Specimen.$dirty"></span> <span class="help-block" ng-show="!vm.labCompendium.specimen">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.tubes?(editForm.tubes?\'has-success\':\'\'):\'has-error\'"><label for="field_tubes">Tubes</label><ui-select id="field_tubes" name="tube" multiple="multiple" ng-model="vm.labCompendium.tubes" required reset-search-input="true"><ui-select-match placeholder="Select tubes...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.tubes | filter: $select.search">{{item.name}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.tubes.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.tubes && vm.labCompendium.tubes.length>0"></span> <span class="help-block" ng-show="!vm.labCompendium.tubes.length > 0">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.loincCode ?(editForm.loincCode ?\'has-success\':\'\'):\'has-warning \'"><label for="field_units">LOINC</label> <input type="text" class="form-control" name="loincCode" id="field_loincCode" ng-model="vm.labCompendium.loincCode"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.loincCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.loincCode && editForm.loincCode.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.loincCode">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendium.loincDescription ?(editForm.loincDescription ?\'has-success\':\'\'):\'has-warning \'"><label for="field_units">LOINC Description</label> <input type="text" class="form-control" name="loincDescription" id="field_loincDescription" ng-model="vm.labCompendium.loincDescription"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendium.loincDescription"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendium.loincDescription && editForm.loincDescription.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.labCompendium.loincDescription">This field is suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/lab-compendium-comment/list/lab-compendium-comments.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">LabCompendium Comments</h4></div><div class="modal-body"><div class="table-wrapper"><div class="table-responsive"><table class="table table-bordered fixed-header" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div><div class="modal-footer"><!--<button type="submit" class="btn btn-success" ng-click="vm.save()">\n        <i class="fa fa-print" aria-hidden="true"></i> Print\n    </button>--> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/lab-compendium-comment/update/lab-compendium-comment-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id=" i-close\n        " viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Comment Lab Compendium</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendiumComment.facility ?(editForm.facility ?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Select Facility:</label><ui-select ng-model="vm.labCompendiumComment.facility" name="facility" id="field_facility" reset-search-input="true" title="Select Facility..."><ui-select-match placeholder="Select facilities...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.facilities"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendiumComment.comment ?(editForm.comment ?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_comment">Comment:</label> <textarea rows="5" class="form-control" name="comment" id="field_comment" data-resize="disabled" ng-model="vm.labCompendiumComment.comment"></textarea> <span class="help-block" ng-show="!vm.labCompendiumComment.comment">This field is required</span></div></div></div><div class="modal-footer"><button ng-click="vm.save()" class="btn btn-success"><i class="fa fa-comment" aria-hidden="true"></i> Comment</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/lab-compendium-restriction/list/lab-compendium-restriction.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/lab-compendium-restriction/update/lab-compendium-restriction-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myCovidFacilityLabLabel">Create or edit a Lab Compendium Restriction</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendiumRestriction.labCompendium?(vm.labCompendiumRestriction.labCompendium.$valid && vm.labCompendiumRestriction.labCompendium.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_labCompendium">Lab Compendium</label><ui-select name="labCompendium" id="field_labCompendium" title="labCompendium" ng-model-options="{ debounce: 500 }" ng-disabled="!vm.labCompendiumRestriction.laboratory" ng-required="true" ng-model="vm.labCompendiumRestriction.labCompendium"><ui-select-match placeholder="Enter Lab Compendium...">{{$select.selected.code + ($select.selected.description ? " - " + $select.selected.description : \'\')}}</ui-select-match><ui-select-choices repeat="item in vm.labCompendiums | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.code | highlight: $select.search"></div><small ng-bind-html="item.description | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendiumRestriction"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendiumRestriction.labCompendium && editForm.labCompendium.$dirty"></span> <span class="help-block" ng-show="!vm.labCompendiumRestriction.labCompendium">This field is required</span></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button></div></div></form>');
$templateCache.put('app/entities/lab-requisition-consent/list/lab-requisition-consent.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/lab-requisition-consent/update/lab-requisition-consent-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myLaboratoryLabel">Create or Edit Lab Requisition Consent</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labRequisitionConsent.consentTitle?(editForm.consentTitle.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="consentTitle">Consent Title:</label> <input type="text" class="form-control" name="consentTitle" id="consentTitle" ng-model="vm.labRequisitionConsent.consentTitle"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labRequisitionConsent.consentTitle"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labRequisitionConsent.consentTitle && editForm.consentTitle.$dirty"></span> <span class="help-block" ng-show="!vm.labRequisitionConsent.consentTitle">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labRequisitionConsent.consent?(editForm.consent.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_consent">Consent</label> <textarea class="form-control" name="consent" id="field_consent" data-resize="disabled" rows="4" ng-model="vm.labRequisitionConsent.consent"></textarea> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labRequisitionConsent.consent"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labRequisitionConsent.consent && editForm.consent.$dirty"></span> <span class="help-block" ng-show="!vm.labRequisitionConsent.consent">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labRequisitionConsent.notice?(editForm.notice.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_consent">Notice</label> <textarea class="form-control" name="notice" id="field_notice" data-resize="disabled" rows="4" ng-model="vm.labRequisitionConsent.notice"></textarea> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labRequisitionConsent.notice"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labRequisitionConsent.notice && editForm.notice.$dirty"></span> <span class="help-block" ng-show="!vm.labRequisitionConsent.notice">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.labRequisitionConsent.laboratory?(editForm.laboratory.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_laboratory">Laboratory</label> <select class="form-control" id="field_laboratory" name="laboratory" ng-model="vm.labRequisitionConsent.laboratory" ng-options="laboratory as laboratory.name for laboratory in vm.laboratories track by laboratory.name" required><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labRequisitionConsent.laboratory"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labRequisitionConsent.laboratory"></span> <span class="help-block" ng-show="!vm.labRequisitionConsent.laboratory> 0">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/laboratory/list/laboratory.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/laboratory/logo/laboratory-logo-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myLaboratoryLabel">Add Logo to Laboratory</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="name">Laboratory:</label> <input ng-disabled="true" type="text" class="form-control" name="name" id="name" ng-model="vm.laboratory.name"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="input-group"><input ng-disabled="true" ng-model="vm.file.name" type="text" class="form-control"> <span class="input-group-btn"><button class="btn btn-primary" type="button" ngf-select ngf-change="vm.handleFileSelect($event, $file)" accept="image/*">Select Logo</button></span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.isSaving || !vm.image" type="submit"><i class="fa fa-save" aria-hidden="true"></i> Add Logo</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/laboratory/select/select-laboratory-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Select laboratory...</h4></div><div class="modal-body"><div class="search-input"><input type="text" class="form-control" placeholder="Search..." id="searchQuerySelectCampaign" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div><div id="select-campaign-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.selectLaboratory()" ng-disabled="!vm.laboratory"><i class="fa fa-save" aria-hidden="true"></i> Select</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/laboratory/update/laboratory-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myLaboratoryLabel">Create or edit a Laboratory</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.name ?(editForm.name?\'has-success\':\'\'):\'has-error\'"><label for="name">Name:</label> <input type="text" class="form-control" name="name" id="name" required ng-model="vm.laboratory.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.name && vm.form.name.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.name">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback"><label for="field_address1">Name to print:</label> <input type="text" class="form-control" name="nameToPrint" id="field_name_to_print" ng-model="vm.laboratory.nameToPrint"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="note">Notes:</label> <textarea name="note" id="note" rows="2" class="form-control" ng-model="vm.laboratory.note" data-resize="disabled" placeholder="Add a note here..."></textarea></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.address1 ?(editForm.address1 ?\'has-success\':\'\'):\'has-error\'"><label for="field_address1">Address:</label> <input type="text" class="form-control" name="address1" id="field_address1" required ng-model="vm.laboratory.address1"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.address1"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.address1 && editForm.address1.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.address1">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_address1">Address2:</label> <input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.laboratory.address2"></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.city ?(editForm.city?\'has-success\':\'\'):\'has-error\'"><label for="field_city">City</label> <input type="text" class="form-control" name="city" id="field_city" required ng-model="vm.laboratory.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.city && editForm.city.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.city">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.countryState ? (editForm.state?\'has-success\':\'\'):\'has-error\'"><label for="field_state">State:</label> <select class="form-control" id="field_state" name="state" required ng-model="vm.laboratory.countryState" ng-options="item as item.state for item in vm.countryState track by item.id"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.countryState && editForm.state.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.countryState">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.zip?(editForm.zip?\'has-success\':\'\'):\'has-error\'"><label for="field_zip">Zip Code:</label> <input type="text" class="form-control" name="zip" id="field_zip" required ng-model="vm.laboratory.zip" ui-mask="99999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.zip"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.zip && editForm.zip.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.zip">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_active">Active:</label><br><toggle id="field_active" ng-model="vm.laboratory.active" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_is_dev">Is Dev:</label><br><toggle id="field_is_dev" ng-model="vm.laboratory.isDev" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.phone?(editForm.phone?\'has-success\':\'\'):\'has-warning\'"><label for="field_phone">Phone:</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.laboratory.phone" ui-mask="(999)-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.laboratory.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.phone && editForm.phone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.laboratory.phone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.fax?(editForm.fax ?\'has-success\':\'\'):\'has-warning\'"><label for="field_fax">Fax:</label> <input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.laboratory.fax" ui-mask="(999)-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.laboratory.fax"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.fax && editForm.fax.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.laboratory.fax">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.email ? (editForm.email ?\'has-success\':\'\'):\'has-warning\'"><label for="field_email">Email:</label> <input type="email" class="form-control" name="email" id="field_email" ng-model="vm.laboratory.email"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.laboratory.email"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.email && vm.form.email.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.laboratory.email">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.sftpUser ?(editForm.sftpUser ?\'has-success\':\'\'):\'has-error\'"><label for="field_sftpUser">Sftp User:</label> <input type="text" class="form-control" name="sftpUser" id="field_sftpUser" required ng-model="vm.laboratory.sftpUser"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.sftpUser"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.sftpUser && editForm.sftpUser.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.sftpUser">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.sftpPassword || vm.laboratory.id ?(editForm.sftpPassword ?\'has-success\':\'\'):\'has-error\'"><label for="field_sftpPassword">Sftp Password:</label> <input type="password" class="form-control" name="sftpPassword" id="field_sftpPassword" ng-required="!vm.laboratory.id" ng-model="vm.laboratory.sftpPassword"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.id && !vm.laboratory.sftpPassword"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="!vm.laboratory.id && vm.laboratory.sftpPassword && editForm.sftpPassword.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.id && !vm.laboratory.sftpPassword">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.clia ? (editForm.clia ?\'has-success\':\'\'):\'has-warning\'"><label for="field_clia">Clia:</label> <input type="clia" class="form-control" name="clia" id="field_clia" ng-model="vm.laboratory.clia"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.laboratory.clia"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.clia && vm.form.clia.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.laboratory.clia">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_status">Hl7 version</label> <select class="form-control" id="field_status" name="hl7Version" ng-model="vm.laboratory.hl7Version" ng-options="versions for versions in vm.hl7Versions"><option value=""></option></select></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.sftpHost ?(editForm.sftpHost ?\'has-success\':\'\'):\'has-error\'"><label for="field_sftpHost">Sftp Host:</label> <input type="text" class="form-control" name="sftpHost" id="field_sftpHost" required ng-model="vm.laboratory.sftpHost"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.sftpHost"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.sftpHost && editForm.sftpHost.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.sftpHost">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.path ?(editForm.path ?\'has-success\':\'\'):\'has-error\'"><label for="field_path">Path (www/):</label> <input type="text" class="form-control" name="path" id="field_path" required ng-model="vm.laboratory.path"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.path"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.path && editForm.path.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.path">This field is required</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.ordersPath ?(editForm.ordersPath ?\'has-success\':\'\'):\'has-error\'"><label for="field_ordersPath">Orders Path (orders/):</label> <input type="text" class="form-control" name="ordersPath" id="field_ordersPath" required ng-model="vm.laboratory.ordersPath"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.ordersPath"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.ordersPath && editForm.ordersPath.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.ordersPath">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratory.resultsPath ?(editForm.resultsPath ?\'has-success\':\'\'):\'has-error\'"><label for="field_resultsPath">Results Path (results/):</label> <input type="text" class="form-control" name="resultsPath" id="field_resultsPath" required ng-model="vm.laboratory.resultsPath"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.laboratory.resultsPath"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.laboratory.resultsPath && editForm.resultsPath.$dirty"></span> <span class="help-block" ng-show="!vm.laboratory.resultsPath">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_address1">Order Path: sftp://{{vm.laboratory.sftpUser}}:****@{{vm.laboratory.sftpHost}}/{{vm.laboratory.path}}{{vm.laboratory.ordersPath}}</label></div><div class="form-group form-group-sm"><label for="field_address1">Result Path: sftp://{{vm.laboratory.sftpUser}}:****@{{vm.laboratory.sftpHost}}/{{vm.laboratory.path}}{{vm.laboratory.resultsPath}}</label></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving" type="submit"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/medication/list/medication.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/medication/update/medication-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Create or edit a Medication</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.medication.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.medication.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.medication.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.medication.name"> <span class="help-block" ng-show="!vm.medication.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/message-history/detail/message-history-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><jhi-alert-error></jhi-alert-error><h4 class="modal-title">Message History Details</h4></div><div class="modal-body"><wizard name="messageHistoryDetails" hide-indicators="true"><div class="row"><div class="col-md-5"><table class="table"><tr><td><strong>Employee:</strong></td><td>{{vm.messageHistory.employee.lastName + \', \' + vm.messageHistory.employee.firstName}}</td></tr></table></div><div class="col-md-5"><table class="table"><tr><td><strong>Facility Phone Number:</strong></td><td>{{vm.messageHistory.facilityPhoneNumber.phoneNumber}}</td></tr></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="filter-query"><div class="filter-input"><input type="text" class="form-control" id="searchMessage" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <button class="btn btn-default" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div></wizard></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/message-history/list/message-history.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/incident-report/update/incident-report-edit.html','<ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="content"><div class="box box-customized"><div class="box-body"><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate show-validation><fieldset ng-disabled="!vm.canSave()"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.date?(vm.incidentReport.date.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_date">Date on Incident:</label><div class="input-group input-group-sm"><input id="field_date" type="text" class="form-control" name="date" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.incidentReport.date" is-open="vm.datePickerOpenStatus.date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button></span></div><span class="help-block" ng-show="form.date.$invalid">This field is required</span></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.charts && vm.incidentReport.charts.length > 0?\'has-success\':\'has-error\'"><label for="field_charts">Patients involved:</label><ui-select id="field_charts" name="charts" title="Select patient involve..." ng-disabled="!vm.canSave()" multiple="multiple" required ng-model="vm.incidentReport.charts" reset-search-input="true" close-on-select="false"><ui-select-match allow-clear="true" placeholder="Select patient involve...">{{$item.mrNo}}</ui-select-match><ui-select-choices repeat="chart in vm.charts | filter: $select.search" refresh="vm.getCharts($select.search)" refresh-delay="0"><div ng-bind-html="chart.firstName + \' \' + chart.lastName | highlight: $select.search"></div><small ng-bind-html="\'<strong>DOB: </strong>\' + (chart.dateBirth | date: inputDateFormat) + \' <strong>MrNo:</strong> \' + chart.mrNo"></small></ui-select-choices></ui-select><span class="help-block" ng-show="form.charts.$invalid">This field is required</span></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.typeLevelCare?\'has-success\':\'has-error\'"><label for="field_typeLevelCare">Level Of Care:</label><ui-select name="typeLevelCare" id="field_typeLevelCare" title="Select Level of Care" ng-model="vm.incidentReport.typeLevelCare" required><ui-select-match placeholder="Level of Care ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.typeLevelCares | filter: $select.search">{{item.name}}</ui-select-choices></ui-select><span class="help-block" ng-show="form.typeLevelCare.$invalid">This field is required</span></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.incidentDepartments && vm.incidentReport.incidentDepartments.length?\'has-success\':\'has-error\'"><label for="field_incidentDepartments">Department(s) Involved:</label><ui-select multiple="multiple" name="incidentDepartments" id="field_incidentDepartments" ng-disabled="!vm.canSave()" title="Select department" ng-model="vm.incidentReport.incidentDepartments" reset-search-input="true" close-on-select="false" required><ui-select-match placeholder="Incident Departments ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.incidentDepartments | filter: $select.search">{{item.name}}</ui-select-choices></ui-select><span class="help-block" ng-show="form.incidentDepartments.$invalid">This field is required</span></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.assignReviewers && vm.incidentReport.assignReviewers.length > 0?\'has-success\':\'has-error\'"><label for="field_assignReviewers">Incident Completed By:</label><ui-select name="assignReviewers" id="field_assignReviewers" title="Select assign reviewer" ng-disabled="!vm.canSave()" multiple="multiple" required ng-model="vm.incidentReport.assignReviewers" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Assign Reviewers ...">{{$item.lastName + \', \' + $item.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.assignReviewers | filter: $select.search" refresh="vm.getAssignReviewers($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="help-block" ng-show="form.assignReviewers.$invalid">This field is required</span></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.incidentTypes && vm.incidentReport.incidentTypes.length?\'has-success\':\'has-error\'"><label for="field_incidentType">Type of Incident:</label><ui-select multiple="multiple" name="incidentTypes" id="field_incidentType" ng-disabled="!vm.canSave()" title="Select type of incident" ng-model="vm.incidentReport.incidentTypes" reset-search-input="true" close-on-select="false" required><ui-select-match placeholder="Incident Types ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.incidentTypes | filter: $select.search">{{item.name}}</ui-select-choices></ui-select><span class="help-block" ng-show="form.incidentTypes.$invalid">This field is required</span></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.incidentSeverity?\'has-success\':\'has-error\'"><label for="field_incidentSeverity">Severity of Incident:</label><ui-select name="incidentSeverity" id="field_incidentSeverity" title="Select severity" ng-model="vm.incidentReport.incidentSeverity" required><ui-select-match placeholder="Incident Severity ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.incidentSeverities | filter: $select.search">{{item.name}}</ui-select-choices></ui-select><span class="help-block" ng-show="form.incidentSeverity.$invalid">This field is required</span></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-2"><div class="form-group"><label><label for="field_injury">With Injury</label><br><toggle id="field_injury" ng-model="vm.incidentReport.injury" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-4"><div class="form-group"><label><label for="field_reachClient">If incident is a med error, did it reach the client?</label><br><toggle id="field_reachClient" ng-model="vm.incidentReport.reachClient" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></label></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback"><label for="field_location">Location of the incident (specific area):</label> <input class="form-control" name="location" id="field_location" ng-model="vm.incidentReport.location"> <span class="help-block" ng-show="form.location.$invalid">This field is required</span></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback"><label for="field_building">Building:</label><ui-select name="field_building" id="field_building" title="Select building" multiple="multiple" ng-disabled="!vm.canSave()" ng-model="vm.incidentReport.buildings" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Buildings ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="building in vm.buildings | filter: $select.search "><div ng-bind-html="building.name"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.employees && vm.incidentReport.employees.length?\'has-success\':\'has-error\'"><label for="field_employees">List all employees that witnessed or were involved in the incident:</label><ui-select name="employees" id="field_employees" title="Select staff involve" multiple="multiple" required ng-disabled="!vm.canSave()" ng-model="vm.incidentReport.employees" reset-search-input="true" close-on-select="false"><ui-select-match allow-clear="true" placeholder="Select staff involve...">{{$item.lastName + \', \' + $item.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | filter: $select.search" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="help-block" ng-show="form.employees.$invalid">This field is required</span></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="vm.incidentReport.onDutySupervisors && vm.incidentReport.onDutySupervisors.length?\'has-success\':\'has-error\'"><label for="field_onDutySupervisors">Supervisor(s) on duty at the time of incident:</label><ui-select name="onDutySupervisors" id="field_onDutySupervisors" ng-disabled="!vm.canSave()" title="Select Supervisor on Duty" multiple="multiple" required ng-model="vm.incidentReport.onDutySupervisors" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Supervisor(s) on Duty ...">{{$item.lastName + \', \' + $item.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.onDutySupervisors | filter: $select.search" refresh="vm.getOnDutySupervisors($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="help-block" ng-show="form.onDutySupervisors.$invalid">This field is required</span></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label><label for="field_notified">Were all appropriate Directors and Supervisors notified, either during the incident or immediately following the incident as required?</label><br><toggle id="field_notified" ng-model="vm.incidentReport.notified" onstyle="btn-success" offstyle="btn-danger" ng-change="vm.incidentReport.notifiedSupervisors = []" on="Yes" off="No"></toggle></label></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 form-group has-feedback" ng-class="!form.notifiedSupervisors.$invalid?\'has-success\':\'has-error\'"><label for="field_assignReviewers">If yes, list all supervisors contacted:</label><ui-select name="notifiedSupervisors" id="field_notifiedSupervisors" ng-disabled="!vm.canSave()" title="Select Notified Supervisors" multiple="multiple" ng-required="vm.incidentReport.notified" ng-model="vm.incidentReport.notifiedSupervisors" reset-search-input="true" ng-disabled="!vm.incidentReport.notified" close-on-select="false"><ui-select-match placeholder="Notified Supervisor ...">{{$item.lastName + \', \' + $item.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.notifiedSupervisors | filter: $select.search" refresh="vm.getNotifiedSupervisors($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="help-block" ng-show="form.notifiedSupervisors.$invalid">This field is required</span></div></div></fieldset><hr ng-if="!vm.isFinalized() && (vm.canSave() || vm.canAddIncidentReportNote())"><div class="row" ng-if="!vm.isFinalized() && (vm.canSave() || vm.canAddIncidentReportNote())"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group" style="display: flex; justify-content: space-between"><button type="button" class="btn btn-warning" ng-click="vm.addIncidentReportNotes()" ng-disabled="!vm.canAddIncidentReportNote() || form.$error.required || vm.changes"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Notes</button> <button type="submit" class="btn btn-success" ng-disabled="form.$invalid || vm.isSaving || !vm.canSave() || !vm.changes" ng-click="vm.save()"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div></div></form><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.incidentReport.id && !vm.allIncidentReportNotesSigned() && !vm.changes"><div class="table-responsive"><p class="label label-danger">Required Signature Needed:</p><span ng-repeat="incidentReportNotes in vm.incidentReportNotes" ng-if="!incidentReportNotes.signed">{{incidentReportNotes.name}} ({{incidentReportNotes.employee.firstName + \' \' + incidentReportNotes.employee.lastName}}),</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.incidentReport.id && !vm.isFullIncidentReportNotesbyEmployees() && !vm.changes"><div class="table-responsive"><p class="label label-danger">Missing Witness Notes:</p><span ng-repeat="employee in vm.incidentReport.employees" ng-if="vm.isEmployeeWithoutIncidentReportNote(employee)">{{employee.firstName + \' \' + employee.lastName}},</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.incidentReport.id && !vm.isFullIncidentReportNotesbyAssignedReviewers() && !vm.changes"><div class="table-responsive"><p class="label label-danger">Missing Reviewers Notes:</p><span ng-repeat="employee in vm.incidentReport.assignReviewers" ng-if="vm.isEmployeeWithoutIncidentReportNote(employee)">{{employee.firstName + \' \' + employee.lastName}},</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group" ng-if="vm.incidentReport.id && !vm.changes"><div class="table-responsive"><table class="table table-striped table-condensed" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" ng-disabled="form.$error.required"></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group text-center" ng-if="!vm.changes"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div><hr ng-if="vm.incidentReport.id"><div class="well signs-array" ng-if="vm.incidentReport.id && !vm.changes && (vm.isAssignReviewer() || vm.incidentReportSignatures.length > 0) "><div class="sign-item sign-blank mb-15" ng-if="vm.isAssignReviewer() && !vm.alreadySigned() && !form.$error.required"><figure ng-click="vm.openSingDialog()" ng-if="vm.allowSign()"><div class="icon"><i class="fa fa-edit fa-2x" aria-hidden="true"></i></div><figcaption><strong>Click to sign</strong></figcaption></figure><figure ng-if="!vm.allowSign()"><div class="icon"><i class="fa fa-edit fa-2x" aria-hidden="true"></i></div><figcaption><strong>All notes must be completed in it\'s entirety in order to enable signature panel</strong></figcaption></figure></div><div class="sign-item mb-15" ng-repeat="incidentReportSignature in vm.incidentReportSignatures"><figure><img ng-src-sign="{{incidentReportSignature.signature.id}}" id="signature{{incidentReportSignature.id}}" alt="Signature" width="300" class="img-responsive"><figcaption>Signed by: {{incidentReportSignature.employee.firstName + \' \' + incidentReportSignature.employee.lastName}},<br>Date: {{incidentReportSignature.incidentReport.date | amDateFormat:amDateFormat}}</figcaption></figure></div></div></div></div></section>');
$templateCache.put('app/entities/patient-medication/create/patient-medication-chart2-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Order Medication</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><hr><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="MedicationsWizard" indicators-position="top"><wz-step wz-title="Protocols" wz-disabled="{{(vm.admissionMedications && vm.admissionMedications.ids && vm.admissionMedications.ids.length > 0) || vm.patientMedication !== null}}"><ng-include src="\'app/entities/patient-medication/create/tpl/protocol-list-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Orders"><ng-include src="\'app/entities/patient-medication/create/tpl/orders-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Doctors Signatures"><ng-include src="\'app/entities/patient-medication/create/tpl/signature-tpl.html\'"></ng-include></wz-step></wizard></div></div></div>');
$templateCache.put('app/entities/patient-medication/detail/patient-medication-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Patient Medication Detail - {{vm.patientMedication.medication.name}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="patientMedicationObserveWizard" indicators-position="top" hide-indicators="true"><wz-step wz-title="Details"><ng-include src="\'app/entities/patient-medication/detail/tpl/form-tpl.html\'"></ng-include></wz-step><span ng-if="(vm.isEnabledToSign && !vm.patientMedication.signed) || vm.patientMedication.signed"><wz-step wz-title="Physician Signature"><ng-include src="\'app/entities/patient-medication/detail/tpl/signature-tpl.html\'"></ng-include></wz-step></span><span ng-if="vm.checkDiscontinueAccess()"><wz-step wz-title="Discontinue Physician Signature"><ng-include src="\'app/entities/patient-medication/detail/tpl/discontinue-signature-tpl.html\'"></ng-include></wz-step></span></wizard></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/patient-medication/wizard/steps.html','<button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication-fax-log/list/patient-medication-fax-logs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-medication-take-missed-reason/list/patient-medication-take-missed-reason.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-order/create/patient-order-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id=" i-close\n        " viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.activateSign ? \'Add Sign\' : \'Add Order\'}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="evaluationWizard" hide-indicators="true"><wz-step wz-title="Order Information"><form name="editForm"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.facilityLab ? \'has-success\':\'has-error\'"><label for="order-type">Laboratory:</label> <select name="laboratory" id="field_facilityLab" class="form-control" required ng-model="vm.patientOrder.facilityLab" ng-change="vm.changeLaboratory()" ng-model-options="{ debounce: 500 }" ng-options="facilityLab as facilityLab.name for facilityLab in vm.facilityLabs track by facilityLab.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.facilityLab"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.facilityLab "></span> <span class="help-block" ng-show="!vm.patientOrder.facilityLab">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.orderType ? \'has-success\':\'has-error\'"><label for="order-type">Order Type:</label> <select name="orderType" id="order-type" class="form-control" required ng-model="vm.patientOrder.orderType" ng-change="vm.changeOrderType()"><option value=""></option><option value="ONE_TIME">ONE TIME</option><option value="STANDING">STANDING</option><option value="RECURRING">RECURRING</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.orderType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.orderType "></span> <span class="help-block" ng-show="!vm.patientOrder.orderType">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.via ? \'has-success\':\'has-error\'"><label for="obtainedList">Obtained:</label> <select name="obtained" id="obtainedList" class="form-control" required ng-model="vm.patientOrder.via" ng-options="item as item.name for item in vm.via track by item.name"><option value=""></option></select> {{vm.credential}} <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.via"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.via"></span> <span class="help-block" ng-show="!vm.patientOrder.via">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.signedBy ? \'has-success\':\'has-error\'"><label for="doctors-list">Physician:</label> <select name="doctorList" id="doctors-list" class="form-control" required ng-model="vm.patientOrder.signedBy" ng-disabled="vm.itHasCredentials" ng-options="item as item.firstName + \' \' + item.lastName for item in vm.employees track by item.firstName + item.lastName"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.signedBy"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.signedBy && editForm.doctorList.$dirty"></span> <span class="help-block" ng-show="!vm.patientOrder.signedBy">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.instruction ? \'has-success\': \'has-warning\'"><label class="control-label" for="field_note">Instructions:</label> <textarea rows="5" class="form-control" name="note" id="field_note" data-resize="disabled" ng-model="vm.patientOrder.instruction"></textarea> <span class="help-block help-warning" ng-show="!vm.patientOrder.instruction">This field is suggested.</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div></form><form name="editForm1"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendiums.length > 0 ?\'has-success\':\'has-error\'"><label>Test Code:</label><ui-select name="testCode" id="testCode" required ng-disabled="vm.patientOrder.facilityLab == null" multiple="multiple" ng-model="vm.labCompendiums" ng-model-options="{ debounce: 300 }" close-on-select="false"><ui-select-match placeholder="Test Codes...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.testCodes" refresh="vm.getLabCompendium($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendiums.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendiums.length > 0"></span> <span class="help-block" ng-show="!vm.labCompendiums.length > 0">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.icd10s.length > 0 ? \'has-success\':\'has-error\'"><label for="field_diagnoses">ICD10:</label><ui-select id="field_diagnoses" name="diagnoses" multiple="multiple" required ng-model="vm.patientOrderTest.icd10s" ng-model-options="{ debounce: 300 }" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.icd10s.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.icd10s.length > 0"></span> <span class="help-block" ng-show="!vm.patientOrderTest.icd10s.length > 0">This field is required</span></div><div class="text-right" style="margin-top: -20px"><search-icd10 chart="vm.patientOrder.chart.id" ng-model="vm.patientOrderTest.icd10s"></search-icd10></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label style="display: block">&nbsp;</label> <button type="button" class="btn btn-success" ng-click="vm.selectRelational(vm.patientOrderTest)"><i class="fa fa-save" aria-hidden="true"></i> Edit Rationale List</button></div></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.orderFrequency ? \'has-success\':\'has-warning\'"><label for="obtainedList">Frequency:</label> <select name="freqName" class="form-control input-sm" ng-model="vm.patientOrderTest.orderFrequency" ng-options="item as item.description for item in vm.orderFrequencies track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.orderFrequency"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.orderFrequency"></span> <span class="help-block help-warning" ng-show="!vm.patientOrderTest.orderFrequency">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.staringDate?\'has-success\':\'has-warning\'"><label for="field_staring_date">{{vm.patientOrder.orderType == \'ONE_TIME\' ? \'Collected Date:\' : \'Start Date:\'}}</label><div class="input-group input-group-sm"><input id="field_staring_date" type="text" class="form-control" name="staringDate" placeholder="mm/dd/yyyy" ng-model="vm.patientOrderTest.staringDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.staringDate" datepicker-options="vm.staringDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.staringDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.staringDate"></span> <span class="help-block help-warning" ng-show="!vm.patientOrderTest.staringDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.patientOrder.orderType != \'ONE_TIME\'"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.endDate?\'has-success\':\'has-warning\'"><label for="field_end_date">End Date:</label><div class="input-group input-group-sm"><input id="field_end_date" type="text" class="form-control" name="end_Date" placeholder="mm/dd/yyyy" ng-model="vm.patientOrderTest.endDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.endDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.endDate"></span> <span class="help-block help-warning" ng-show="!vm.patientOrderTest.endDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr><h4>Rationales</h4><ul class="list-unstyled"><li ng-repeat="($index, rational) in vm.patientOrderTest.relationals" style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 5px 30px"><span style="padding-right: 10px;">{{rational.name}}</span> <a ng-click="vm.removeRelational(vm.patientOrderTest.relationals, $index)" style="color: red;"><i class="fa fa-times-circle"></i></a></li></ul><hr></div></div><div class="row"><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group"><button type="button" class="btn btn-primary" ng-click="vm.generateTest()" ng-disabled="editForm.$error.required || editForm1.$error.required"><i class="fa fa-plus-circle" aria-hidden="true"></i> Generate Tests</button></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div></form><form name="editForm2"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrder.patientOrderTests.length > 0"><table class="table table-striped table-test-codes"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Frequency:</strong></th><th><strong>{{vm.patientOrder.orderType == \'ONE_TIME\' ? \'Collected Date:\' : \'Start Date:\'}}</strong></th><th ng-if="vm.patientOrder.orderType != \'ONE_TIME\'"><strong>End Date:</strong></th><th><strong>ICD10:</strong></th><th><strong>Rationale:</strong></th></tr></thead><tbody><tr ng-repeat-start="item in vm.patientOrder.patientOrderTests"><td class="description"><span>{{item.labCompendium.code + " "+ item.labCompendium.description}}</span></td><td><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.orderFrequency ? \'has-success\':\'has-error\'"><select name="freqName" class="form-control input-sm" required ng-model="item.orderFrequency" ng-options="item as item.description for item in vm.orderFrequencies track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.orderFrequency"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.orderFrequency"></span> <span class="help-block" ng-show="!item.orderFrequency">Required</span></div></td><td style="width: 160px"><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.staringDate?\'has-success\':\'has-error\'"><div class="input-group input-group-sm"><input id="field_staringDate + {{$index}}" type="text" class="form-control" type="text" class="form-control" required name="staringDate" placeholder="mm/dd/yyyy" ng-model="item.staringDate" is-open="isOpenStart[item.code]" uib-datepicker-popup="{{inputDateFormat}}" datepicker-options="vm.staringDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isOpenStart[item.code] = !isOpenStart[item.code]"><i class="glyphicon glyphicon-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.staringDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.staringDate"></span> <span class="help-block" ng-show="!item.staringDate">Required</span></div></div></td><td style="width: 160px" ng-if="vm.patientOrder.orderType != \'ONE_TIME\'"><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.endDate ? \'has-success\':\'has-error\'"><div class="input-group input-group-sm"><input id="field_endDate + {{$index}}" type="text" class="form-control" ng-disabled="vm.patientOrder.orderType == \'ONE_TIME\'" required name="endDate" ng-model="item.endDate" placeholder="mm/dd/yyyy" is-open="isOpenEnd[item.code]" datepicker-options="vm.endDateOptions" uib-datepicker-popup="{{inputDateFormat}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isOpenEnd[item.code] = !isOpenEnd[item.code]"><i class="glyphicon glyphicon-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.endDate && vm.patientOrder.orderType != \'ONE_TIME\'"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.endDate"></span> <span class="help-block" ng-show="!item.endDate && vm.patientOrder.orderType != \'ONE_TIME\'">Required</span></div></div></td><td class="icd-codes"><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.icd10s.length > 0 ? \'has-success\':\'has-error\'"><ui-select name="icd10" multiple="multiple" required ng-model="item.icd10s" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.icd10s.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.icd10s.length > 0"></span> <span class="help-block" ng-show="!item.icd10s.length > 0">This field is required</span></div></td><td class="relational"><button type="button" class="btn btn-success" ng-click="vm.selectRelational(item)"><i class="fa fa-save" aria-hidden="true"></i> Edit Rationale List</button></td></tr><tr ng-repeat-end><td colspan="5"><div><h4>Rationales</h4><ul class="list-unstyled"><li ng-repeat="($index, rational) in item.relationals" style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 5px 30px"><span style="padding-right: 10px;">{{rational.name}}</span> <a ng-click="vm.removeRelational(item.relationals, $index)" style="color: red;"><i class="fa fa-times-circle"></i></a></li></ul></div></td></tr></tbody></table></div></form><button type="submit" class="btn btn-warning move-btn next-btn" ng-click="vm.activateSign = true" ng-if="vm.itHasCredentials && !vm.activateSign" ng-disabled="!vm.patientOrder.patientOrderTests.length > 0 || editForm2.$error.required" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-order/tpl/patient-order-signature-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button ng-click="vm.save()" class="btn btn-success" ng-disabled="!vm.patientOrder.patientOrderTests.length > 0 || vm.isSaving" ng-if="!vm.itHasCredentials"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button ng-click="vm.save()" class="btn btn-success" ng-if="vm.activateSign" ng-disabled="(!vm.signature && !vm.pin) || !vm.agree || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-order/detail/patient-order-detail.html','<form name="detailForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id=" i-close\n        " viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.activateSign ? \'Add Sign\' : \'Details Order #\' + \' \' + vm.patientOrder.id}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="evaluationWizard" hide-indicators="true"><wz-step wz-title="Order details"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm"><label class="control-label">This order was created by: {{vm.patientOrder.employee.firstName + " " + vm.patientOrder.employee.lastName}}.</label></div></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="order-type">Order Type:</label> <select name="orderType" id="order-type" class="form-control" ng-model="vm.patientOrder.orderType" ng-disabled="true"><option value=""></option><option value="ONE_TIME">ONE TIME</option><option value="STANDING">STANDING</option><option value="RECURRING">RECURRING</option></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="obtainedList">Obtained:</label> <select name="obtained" id="obtainedList" class="form-control" ng-model="vm.patientOrder.via.name" ng-disabled="true" ng-options="item as item for item in vm.selectOptionVia track by\n                                        item"><option value=""></option></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="doctors-list">Physician:</label> <select name="doctorList" id="doctors-list" class="form-control" readonly="readonly" ng-model="vm.physician" ng-disabled="true" ng-options="item as item for item in vm.selectOptionPhysician track by\n                                        item"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrderTests.length > 0"><table class="table table-striped table-test-codes"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Name:</strong></th><th><strong>Frequency:</strong></th><th><strong>Start Date:</strong></th><th><strong>End Date:</strong></th><th><strong>Actions:</strong></th></tr></thead><tbody><tr ng-repeat="item in vm.patientOrderTests"><td>{{item.labCompendium.code}}</td><td>{{item.labCompendium.description}}</td><td>{{item.orderFrequency.description}}</td><td>{{item.staringDate | date: inputDateFormat}}</td><td>{{item.endDate | date: inputDateFormat}}</td><td class="action-buttons" align="center"><a id="eye " class="info-btn" ng-click="vm.loadItems(item.id)" uib-tooltip="Info"><i class="fa fa-eye" aria-hidden="true"></i></a></td></tr></tbody></table><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalTests" items-per-page="vm.testsPerPage" ng-model="vm.pageTest" ng-change="vm.transitionTest()"></ul></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.selectedTetsId"><div class="box"><div class="box-header with-border"><h3 class="box-title"><h3 class="box-title">Test "{{vm.testCode + " " + vm.testDescription}}"</h3></h3><div class="box-tools pull-right"><button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button></div></div><div class="box-body"><table class="table table-condensed table-striped table-bordered"><thead><tr><th><strong>Rationale:</strong></th></tr></thead><tbody><tr><td ng-repeat="item in vm.relationals" class="text-left"><span ng-class="\'label label-warning\'">{{item.name + " "}}</span></td></tr></tbody></table></div><div class="box-body"><table class="table table-condensed table-striped table-bordered"><thead><tr><th><strong>ICD 10:</strong></th><th><strong>Description:</strong></th></tr></thead><tbody><tr ng-repeat="item in vm.icd10s"><td class="text-left"><span ng-class="\'label label-warning\'">{{item.code}}</span></td><td class="text-left">{{item.description}}</td></tr></tbody></table></div><div class="box-body" ng-if="vm.patientOrderItems.length > 0"><table class="table table-condensed table-striped table-bordered"><thead><tr><th style="width: 10px"><strong>#</strong></th><th><strong>Scheduled Day</strong></th><th><strong>Collected</strong></th><th><strong>Collected Day</strong></th><th><strong>Discontinued</strong></th></tr></thead><tbody><tr ng-repeat="item in vm.patientOrderItems"><td>{{$index}}.</td><td>{{item.scheduleDate | date: inputDateFormat}}</td><td><span ng-class="item.collected ? \'label label-success\' : \'label label-danger\'">{{item.collected ? \'Yes\' : \'No\'}}</span></td><td>{{item.collectedDate | date: inputDateFormat}}</td><td><span ng-class="item.canceled ? \'label label-danger\' : \'label label-success\'">{{item.canceled ? \'Yes\' : \'No\'}}</span></td></tr></tbody></table><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.pageItem" ng-change="vm.transitionItem()"></ul></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrder.instruction"><h3>Instruction:</h3><hr><div class="form-group form-group-sm has-feedback"><textarea rows="10" class="form-control" name="note" id="field_note" ng-readonly="true" data-resize="disabled" ng-model="vm.patientOrder.instruction"></textarea></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrder.signed"><h3>Signature:</h3><hr><div class="well signs-array"><div class="sign-item mb-15"><figure><img ng-src-sign="{{vm.patientOrder.patientOrderSignatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Physician: {{vm.patientOrder.signedBy.firstName + \' \' + vm.patientOrder.signedBy.lastName}}, Date: {{vm.patientOrder.signatureDate | date: inputDateFormat}}, Credentials: {{vm.credentials}}</figcaption></figure></div></div></div></div><div class="row" ng-if="vm.patientOrder.orderStatus==\'DISCONTINUED\'"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm"><label class="control-label">This order was discontinued by: {{vm.patientOrder.discontinueBy.firstName + " " + vm.patientOrder.discontinueBy.lastName}}.</label></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="obtainedListDiscontinued">Obtained:</label> <select name="obtainedDiscontinued" id="obtainedListDiscontinued" class="form-control" ng-model="vm.patientOrder.discontinueVia.name" ng-disabled="true" ng-options="item as item for item in vm.selectOptionViaDiscontinued track by\n                                        item"><option value=""></option></select></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="doctorslistDiscontinued">Physician:</label> <select name="doctorListDiscontinued" id="doctorslistDiscontinued" class="form-control" readonly="readonly" ng-model="vm.discontinueByPhysician" ng-disabled="true" ng-options="item as item for item in vm.selectOptionDiscontinueByPhysician track by\n                                        item"><option value=""></option></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrder.discontinueCause"><h3>Discontinue cause:</h3><hr><div class="form-group form-group-sm has-feedback"><textarea rows="10" class="form-control" name="note" id="fieldNoteDiscontinued" ng-readonly="true" data-resize="disabled" ng-model="vm.patientOrder.discontinueCause"></textarea></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrder.discontinueSignatureId"><h3>Signature:</h3><hr><div class="well signs-array"><div class="sign-item mb-15"><figure><img ng-src-sign="{{vm.patientOrder.discontinueSignatureId}}" id="discontinueSignatureId" alt="Discontinue Signature" width="300" class="img-responsive"><figcaption>Physician: {{vm.patientOrder.discontinueByPhysician.firstName + \' \' + vm.patientOrder.discontinueByPhysician.lastName}}, Date: {{vm.patientOrder.discontinueSignatureDate | date: inputDateFormat}}, Credentials: {{vm.credentials}}</figcaption></figure></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div><button type="submit" class="btn btn-warning move-btn next-btn" ng-if="vm.itHasCredentials && !vm.patientOrder.patientOrderSignatureId && vm.patientOrder.orderStatus !== \'DISCONTINUED\' " wz-next ng-click="vm.activateSign = true"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-order/tpl/patient-order-signature-tpl.html\'"></ng-include></wz-step></wizard></div><div class="modal-footer"><button ng-click="vm.save()" class="btn btn-success" ng-if="vm.activateSign" ng-disabled="(!vm.signature && !vm.pin) || !vm.agree"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div></div></div></form>');
$templateCache.put('app/entities/patient-order/discontinue/patient-order-discontinue-dialog.html','<form name="deleteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id=" i-close\n        " viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.activateSign ? \'Add Sign\' : \'Cancel Order #\' + \' \' + vm.patientOrder.id}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="evaluationWizard" hide-indicators="true"><wz-step wz-title="Order Information"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.discontinueVia ? \'has-success\':\'has-error\'"><label for="obtainedList">Discontinue Via:</label> <select name="obtained" id="obtainedList" class="form-control" required ng-model="vm.patientOrder.discontinueVia" ng-options="item as item.name for item in vm.via track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.discontinueVia"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.discontinueVia"></span> <span class="help-block" ng-show="!vm.patientOrder.discontinueVia">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.discontinueByPhysician ? \'has-success\':\'has-error\'"><label for="physician">Physician:</label><ui-select id="physician" name="physician" reset-search-input="false" ng-disabled="vm.itHasCredentials" required ng-model="vm.patientOrder.discontinueByPhysician" title="Physician..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Physician...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.discontinueByPhysician"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.discontinueByPhysician"></span> <span class="help-block" ng-show="!vm.patientOrder.discontinueByPhysician">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.discontinueCause ? \'has-success\': \'has-warning\'"><label class="control-label" for="field_note">Discontinue Cause:</label> <textarea rows="5" class="form-control" name="note" id="field_note" data-resize="disabled" ng-model="vm.patientOrder.discontinueCause"></textarea> <span class="help-block help-warning" ng-show="!vm.patientOrder.discontinueCause">This field is suggested.</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div><button type="submit" class="btn btn-warning move-btn next-btn" ng-click="vm.activateSign = true" ng-if="vm.itHasCredentials && !vm.activateSign" ng-disabled="deleteForm.$error.required" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-order/tpl/patient-order-signature-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button ng-click="vm.save()" class="btn btn-warning" ng-disabled="deleteForm.$error.required" ng-if="!vm.itHasCredentials"><i class="fa fa-ban" aria-hidden="true"></i> Discontinue</button> <button ng-click="vm.save()" class="btn btn-warning" ng-if="vm.activateSign" ng-disabled="(!vm.signature && !vm.pin) || !vm.agree "><i class="fa fa-ban" aria-hidden="true"></i> Discontinue</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/patient-order/tpl/patient-order-signature-tpl.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.signature"><div class="form-group form-group-sm centered drawer-sign"><label for="orderPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="orderPin" name="orderPin" maxlength="4" pattern="\\d{4}" placeholder="PIN" ng-model="vm.pin" ng-change="vm.signature = \'\'" ng-required="vm.signature === null"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign" ng-if="vm.pin === null || vm.pin === \'\' || vm.signature"><label>Or Sign Here:</label><ods-signature ng-change="vm.clear()" options="vm.signatureOpts" name="patient_order_signature" ng-model="vm.signature"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_SignatureAgree"><input type="checkbox" name="SignatureAgree" id="field_SignatureAgree" ng-model="vm.agree" ng-disabled="!vm.signature && !vm.pin">{{vm.patientOrder.discontinueByPhysician ? \'I, \' + vm.patientOrder.discontinueByPhysician.firstName + \' \' + vm.patientOrder.discontinueByPhysician.lastName +\', have reviewed, agree the discontinue of the order # \' + vm.patientOrder.id : \'I, \' + vm.patientOrder.signedBy.firstName + \' \' + vm.patientOrder.signedBy.lastName +\', have reviewed, agree and understand the information contained here in the lab order.\' }}</label></div></div></div><button type="button" class="btn btn-warning move-btn previous-btn" ng-click="vm.activateSign = false" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/patient-result/abnormal/patient-result-abnormal.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable><section class="content" ng-if="false"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.acknowledge()"><i class="fa fa-check-circle" aria-hidden="true"></i> Acknowledge Selected</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="btn-group btn-group-lg main-filters"><button type="button" title="All Results" ng-click="vm.updateAcknowledgeButtonFilter(\'All\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active bg-green\': vm.acknowledgeFilter == \'All\'}]"><i class="fa fa-flask" aria-hidden="true"></i> <span class="hidden-xs">All Results</span></button> <button type="button" class="btn btn-default btn-flat" title="Acknowledge" ng-click="vm.updateAcknowledgeButtonFilter(\'Acknowledge\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active bg-green\': vm.acknowledgeFilter == \'Acknowledge\'}]"><i class="fa fa-spinner" aria-hidden="true"></i> <span class="hidden-xs">Acknowledge</span></button> <button type="button" class="btn btn-default" title="Unacknowledged" ng-click="vm.updateAcknowledgeButtonFilter(\'Unacknowledged\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active bg-green\': vm.acknowledgeFilter == \'Unacknowledged\'}]"><i class="fa fa-circle-o" aria-hidden="true"></i> <span class="hidden-xs">Unacknowledged</span></button></div></div><div class="box"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-result/list/patient-result.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-result/partial/patient-result-partial.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-result/sent-lab/sent-lab-result.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-result/unassigned/patient-result-unassigned.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-result-det/detail/patient-result-det-signature-tpl.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.signature"><div class="form-group form-group-sm centered drawer-sign"><label for="orderPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="orderPin" name="orderPin" maxlength="4" pattern="\\d{4}" placeholder="PIN" ng-model="vm.pin" ng-change="vm.signature = \'\'" ng-required="vm.signature === null"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign" ng-if="vm.pin === null || vm.pin === \'\' || vm.signature"><label>Or Sign Here:</label><ods-signature ng-change="vm.clear()" options="vm.signatureOpts" name="patient_order_signature" ng-model="vm.signature"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_SignatureAgree"><input type="checkbox" name="SignatureAgree" id="field_SignatureAgree" ng-model="vm.agree" ng-disabled="!vm.signature && !vm.pin">{{\'I, \' + vm.patientResult.signedBy.firstName + \' \' + vm.patientResult.signedBy.lastName +\', have reviewed, agree and understand the information contained here in the patient result.\' }}</label></div></div></div><button type="button" class="btn btn-warning move-btn previous-btn" ng-click="vm.activateSign = false" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/patient-result-det/detail/patient-result-det.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><jhi-alert-error></jhi-alert-error><h4 class="modal-title">Result Details</h4></div><div class="modal-body"><wizard name="evaluationWizard" hide-indicators="true"><wz-step wz-title="result details"><div class="row"><div class="col-md-4"><img class="img-responsive max-width=75%" aslt="Patient Photo" ng-src-auth="{{vm.chart}}"></div><div class="col-md-4"><table class="table"><tr><td><strong>Patient Name:</strong></td><td>{{vm.patientResult.patientName}}</td></tr><tr><td><strong>Order #:</strong></td><td>{{vm.patientResult.accessionNumber}}</td></tr><tr><td><strong>Collected:</strong></td><td>{{vm.patientResult.collectionDate | date:inputDateFormat}}</td></tr><tr><td><strong>Doctor\'s Name:</strong></td><td colspan="2">{{vm.physician == null ? \'Not Specified\' : vm.physician.lastName + " " + vm.physician.firstName}}</td></tr></table></div><div class="col-md-4"><table class="table"><tr><td><strong>Gender:</strong></td><td>{{vm.chart.sex != null ? vm.chart.sex : \'Not Specified\'}}</td></tr><tr><td><strong>D.O.B:</strong></td><td>{{vm.patientResult.dob | date:inputDateFormat}}</td></tr><tr><td><strong>Received:</strong></td><td>{{vm.patientResult.createdDate | date:inputDateFormat}}</td></tr></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><form autocomplete="off"><div class="filter-query"><div class="filter-input"><input type="text" class="form-control" id="searchQuery" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" autocomplete="off"> <button class="btn btn-default" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button></div><button type="button" class="btn btn-danger show-filters" ng-click="vm.toggleFilters()"><i class="fa fa-sliders"></i> Filter</button><div class="filters-wrapper well"><div class="filter-group"><div class="name"><span><strong>Groups:</strong></span></div><div class="checkboxs"><!-- The filters ID must be the same as the label\'s FOR attribute --> <span class="filter-item"><input type="checkbox" name="filter-groups-all" id="filter-groups-all" ng-model="vm.groupsAll.value" ng-click="vm.groupCheckAll()"> <label for="filter-groups-all">{{vm.groupsAll.name}}</label> </span><span class="filter-item" ng-repeat="($index, group) in vm.groups | orderBy : \'name\'"><input type="checkbox" name="filter-{{$index}}" id="filter-{{$index}}" ng-model="group.value" ng-click="vm.groupsCheck()"> <label for="filter-{{$index}}">{{group.name}}</label></span></div></div><div class="filter-group"><div class="name"><span><strong>Status:</strong></span></div><div class="checkboxs"><!-- The filters ID must be the same as the label\'s FOR attribute --> <span class="filter-item"><input type="checkbox" name="filter-all" id="filter-all" ng-model="vm.levels.all" ng-click="vm.levelAll()"> <label for="filter-all">All</label> </span><span class="filter-item"><input type="checkbox" name="filter-abnormals" id="filter-abnormals" ng-model="vm.levels.abnormals" ng-click="vm.abnormals()"> <label for="filter-abnormals">Abnormals</label> </span><span class="filter-item"><input type="checkbox" name="filter-criticals" id="filter-criticals" ng-model="vm.levels.criticals" ng-click="vm.criticals()"> <label for="filter-criticals">Criticals</label> </span><span class="filter-item"><input type="checkbox" name="filter-ll" id="filter-ll" ng-model="vm.levels.LL" ng-click="vm.notNormal()"> <label for="filter-ll">Critical Low</label> </span><span class="filter-item"><input type="checkbox" name="filter-l" id="filter-l" ng-model="vm.levels.L" ng-click="vm.notNormal()"> <label for="filter-l">Low</label> </span><span class="filter-item"><input type="checkbox" name="filter-n" id="filter-n" ng-model="vm.levels.N" ng-click="vm.normal()"> <label for="filter-n">Normal</label> </span><span class="filter-item"><input type="checkbox" name="filter-h" id="filter-h" ng-model="vm.levels.H" ng-click="vm.notNormal()"> <label for="filter-h">High</label> </span><span class="filter-item"><input type="checkbox" name="filter-hh" id="filter-hh" ng-model="vm.levels.HH" ng-click="vm.notNormal()"> <label for="filter-hh">Critical High</label></span></div></div></div></div></form></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientResult.signed"><h3>Signature:</h3><hr><div class="well signs-array"><div class="sign-item mb-15"><figure><img ng-src-sign="{{vm.patientResult.patientResultSignatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Physician: {{vm.patientResult.signedBy.firstName + \' \' + vm.patientResult.signedBy.lastName}}, Date: {{vm.patientResult.signatureDate | date: inputDateFormat}}, Credentials: {{vm.physicianCredentials()}}</figcaption></figure></div></div></div></div><button type="submit" class="btn btn-warning move-btn next-btn" ng-if="vm.itHasCredentials && !vm.patientResult.signed && vm.patientResult.status == \'FINAL\'" wz-next ng-click="vm.activateSign = true"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-result-det/detail/patient-result-det-signature-tpl.html\'"></ng-include></wz-step></wizard></div><div class="modal-footer"><button ng-click="vm.save()" class="btn btn-success" ng-if="vm.activateSign" ng-disabled="(!vm.signature && !vm.pin) || !vm.agree"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/pdf-chart-report/download/pdf-chart-report-download-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.pdfChartReport.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Downloading</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="delete-text">Please wait, downloading <strong>{{vm.pdfChartReport.name}} </strong>Report</p></div></form>');
$templateCache.put('app/entities/pdf-chart-report/list/pdf-chart-report.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/pharmacy/list/pharmacy.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/pharmacy/update/pharmacy-dialog.html','<form name="editForm" role="form" validate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myContactAddressLabel">Create or edit a Pharmacy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.pharmacy.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.pharmacy.id" readonly="readonly"></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_rcopiaID">RcopiaID</label> <input type="text" class="form-control" name="rcopiaID" id="field_rcopiaID" ng-model="vm.pharmacy.rcopiaID"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_rcopiaMasterID">RcopiaMasterID</label> <input type="text" class="form-control" name="rcopiaMasterID" id="field_rcopiaMasterID" ng-model="vm.pharmacy.rcopiaMasterID"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_deleted">Deleted</label> <input type="text" class="form-control" name="deleted" id="field_deleted" ng-model="vm.pharmacy.deleted"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_ncpdpid">Ncpdpid</label> <input type="text" class="form-control" name="ncpdpid" id="field_ncpdpid" ng-model="vm.pharmacy.ncpdpid"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_npi">NPI</label> <input type="text" class="form-control" name="npi" id="field_npi" ng-model="vm.pharmacy.npi"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.pharmacy.name"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_address1">Address1</label> <input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.pharmacy.address1"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_address2">Address2</label> <input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.pharmacy.address2"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_crossStreet">CrossStreet</label> <input type="text" class="form-control" name="crossStreet" id="field_crossStreet" ng-model="vm.pharmacy.crossStreet"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_city">City</label> <input type="text" class="form-control" name="city" id="field_city" ng-model="vm.pharmacy.city"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_crossStreet">State</label> <input type="text" class="form-control" name="state" id="field_state" ng-model="vm.pharmacy.state"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_zip">Zip</label> <input type="text" class="form-control" name="zip" id="field_zip" ng-model="vm.pharmacy.zip"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_phone">Phone</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.pharmacy.phone"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_fax">Fax</label> <input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.pharmacy.fax"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_is24Hour">Is 24 Hour</label> <input type="text" class="form-control" name="is24Hour" id="field_is24Hour" ng-model="vm.pharmacy.is24Hour"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_level3">Level3</label> <input type="text" class="form-control" name="level3" id="field_level3" ng-model="vm.pharmacy.level3"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_electronic">Electronic</label> <input type="text" class="form-control" name="electronic" id="field_electronic" ng-model="vm.pharmacy.electronic"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_mailOrder">Mail Order</label> <input type="text" class="form-control" name="mailOrder" id="field_mailOrder" ng-model="vm.pharmacy.mailOrder"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_retail">Retail</label> <input type="text" class="form-control" name="retail" id="field_retail" ng-model="vm.pharmacy.retail"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_longTermCare">Long Term Care</label> <input type="text" class="form-control" name="longTermCare" id="field_longTermCare" ng-model="vm.pharmacy.longTermCare"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_specialty">Specialty</label> <input type="text" class="form-control" name="specialty" id="field_specialty" ng-model="vm.pharmacy.specialty"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_canReceiveControlledSubstance">Can Receive Controlled Substance</label> <input type="text" class="form-control" name="canReceiveControlledSubstance" id="field_canReceiveControlledSubstance" ng-model="vm.pharmacy.canReceiveControlledSubstance"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_scriptVersion">Script Version</label> <input type="text" class="form-control" name="scriptVersion" id="field_scriptVersion" ng-model="vm.pharmacy.scriptVersion"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_inHouseDispensing">In House Dispensing</label> <input type="text" class="form-control" name="inHouseDispensing" id="field_inHouseDispensing" ng-model="vm.pharmacy.inHouseDispensing"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_compounding">Compounding</label> <input type="text" class="form-control" name="compounding" id="field_compounding" ng-model="vm.pharmacy.compounding"></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_durableMedicalEquipment">Durable Medical Equipment</label> <input type="text" class="form-control" name="durableMedicalEquipment" id="field_durableMedicalEquipment" ng-model="vm.pharmacy.durableMedicalEquipment"></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback"><label class="control-label" for="field_kiosk">Kiosk</label> <input type="text" class="form-control" name="kiosk" id="field_kiosk" ng-model="vm.pharmacy.kiosk"></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$error.required || editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/physician-review/diagnoses/physician-review-diagnoses.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/physician-review/e-labs/physician-review-e-labs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/physician-review/lab-orders/physician-review-lab-orders.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/physician-review/list/physician-review.html','<section class="content no-padding full-height"><uib-tabset class="simple-tabs2 no-tab-padding"><uib-tab index="0" heading="Medications" select="vm.emitReload(\'Medications\')"><div ui-view="medications "></div></uib-tab><uib-tab index="1" heading="Lab Orders" select="vm.emitReload(\'LabOrders\')"><div ui-view="lab-orders"></div></uib-tab><uib-tab index="2" heading="eLabs" select="vm.emitReload(\'ELabs\')"><div ui-view="e-labs"></div></uib-tab><uib-tab index="3" heading="Diagnoses" select="vm.emitReload(\'Diagnoses\')"><div ui-view="diagnoses"></div></uib-tab></uib-tabset><div class="row"><div class="col-lg-3"></div><div class="col-lg-6"><jhi-alert-error></jhi-alert-error></div><div class="col-lg-3"></div></div></section>');
$templateCache.put('app/entities/physician-review/medications/physician-review-medications.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/port/list/port.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/port/update/port-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myPortLabel">Create or edit a Port</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.port.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.port.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.port.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.port.name"> <span class="help-block" ng-show="!vm.port.name || editForm.name.$error.required">This field is required.</span></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.port.xorder || editForm.xorder.$error.required?\'has-error\':(editForm.xorder.$valid && editForm.xorder.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_xorder">Order</label> <input type="number" class="form-control" name="xorder" id="field_xorder" value="1" ng-model="vm.port.xorder"> <span class="help-block" ng-show="!vm.port.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/pr-det-employee-comment/update/pr-det-employee-comment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="prDetEmployeeCommentLabel">Add Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="comment">Comment</label> <textarea class="form-control" id="comment" name="comment" rows="4" ng-model="vm.prDetEmployeeComment.comment" required> </textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/entities/patient-medication-take-missed-reason/update/patient-medication-take-missed-reason-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myPatientMedicationTakeMissedReasonLabel">Create or edit a Patient Medication Take Missed Reason</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.patientMedicationTakeMissedReason.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.patientMedicationTakeMissedReason.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.patientMedicationTakeMissedReason.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.patientMedicationTakeMissedReason.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientMedicationTakeMissedReason.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientMedicationTakeMissedReason.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.patientMedicationTakeMissedReason.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/procedure/tpl/procedure-form-institutional.html','<form name="editform" novalidate ng-submit="vm.save()" show-validation role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create or edit a Procedure</h4></div><fieldset><div class="modal-body"><div class="row mb-20" style="margin-bottom: 20px !important;"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h5 class="text-uppercase"><strong>HCPCS (*)</strong></h5><div ng-show="vm.procedure.cpt" class="inputs row"><div class="identifier col-xs-12 col-sm-1 col-md-1 col-lg-1"><strong>{{vm.procedure.cpt.code}}</strong></div><div class="description col-xs-12 col-sm-10 col-md-10 col-lg-10">{{vm.procedure.cpt.fullDesc}}</div><div class="remove col-xs-12 col-sm-1 col-md-1 col-lg-1" style="margin: 0 !important; padding: 0 !important;" ng-click="vm.removeCpt()"><a href=""><i class="fa fa-times-circle" aria-hidden="true"></i></a></div></div><div ng-hide="vm.procedure.cpt" class="inputs has-feedback" ng-class="vm.procedure.cpt?(editform.cpt.selected?\'has-success\':\'\'):\'has-error\'"><ui-select name="cpt" id="field_cpt" title="Select cpt" ng-model="vm.procedure.cpt" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="true" on-select="vm.selectCpt($model)" required style="min-width: 240px; width: 100%; background-color: white"><ui-select-match allow-clear="true" placeholder="Enter a Cpt...">{{$select.selected.code}} - {{$select.selected.shortDesc}}</ui-select-match><ui-select-choices repeat="cpt in vm.cpts | filter: $select.search" refresh="vm.getCpts($select.search)" refresh-delay="0"><div ng-bind-html="cpt.code"></div><small ng-bind-html="cpt.shortDesc | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.procedure.cpt"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.procedure.cpt && editform.field_cpt.$dirty"></span> <span class="help-block" ng-show="!vm.procedure.cpt">This field is required</span></div></div></div><div class="row mb-30"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 mb-15"><h5 class="text-uppercase"><strong>RevCode</strong></h5><div class="inputs"><ui-select name="field_revCode" id="field_revCode" title="Select revCode" ng-model="vm.procedure.revCode" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="true" on-select="vm.selectRevCode($model)" style="min-width: 240px; width: 100%; background-color: white"><ui-select-match allow-clear="true" placeholder="Enter a RevCode...">{{$select.selected.code}} - {{$select.selected.version}}</ui-select-match><ui-select-choices repeat="revCode in vm.revCodes | filter: $select.search" refresh="vm.getRevCode($select.search)" refresh-delay="0"><div ng-bind-html="revCode.code"></div><small ng-bind-html="revCode.version | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div class="input-modifier col-xs-12 col-sm-6 col-md-6 col-lg-6"><h5 class="text-uppercase"><strong>Modifiers</strong></h5><ul class="list-unstyled modifiers-list col-lg-12 col-sm-12" dnd-list="vm.modifiers"><li class="modifiers-item row" ng-repeat="modifier in vm.modifiers" dnd-draggable="modifier" dnd-dragend="vm.onDragEnd(vm.modifiers)" dnd-moved="vm.modifiers.splice($index, 1)" dnd-effect-allowed="move"><div class="inputs"><div class="list-handle col-sm-1" style="margin-right: 10px" dnd-handle>:::</div><div class="identifier col-sm-2" style="margin: 0 !important; padding: 0 !important;"><span>{{modifier.xorder}} - </span><strong>{{modifier.modifier.code}}</strong></div><div class="description col-sm-7" style="margin: 0 !important; padding: 0 !important;"><p>{{modifier.modifier.fullDesc}}</p></div><div class="remove col-sm-1" style="margin: 0 !important; padding: 0 !important;" ng-click="vm.removeProcedureModifier($index)"><a href=""><i class="fa fa-times-circle" aria-hidden="true"></i></a></div></div></li></ul><div class="input-new mt-15"><search-select ng-model="vm.modifierSelected" compare-property="\'id\'" placeholder="Search modifier by code or description..." tabs-conf="vm.modifierTabsConf" on-select="vm.onSelectModifier()" render="vm.renderModifier"></search-select></div></div></div><div class="row mb-30"><div class="rate col-xs-12 col-sm-4 col-md-4 col-lg-4"><label for="field_rate"><strong>RATE:</strong></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-usd" aria-hidden="true"></i> </span><input type="number" name="rate" id="field_rate" ng-model="vm.procedure.rate" class="form-control" min="0" step="0.01" placeholder="0.00"></div></div><div class="qty col-xs-12 col-sm-4 col-md-4 col-lg-4"><label for="field_quantity"><strong>QTY:</strong></label> <input type="number" name="quantity" id="field_quantity" class="form-control input-sm" min="0" step="1" ng-model="vm.procedure.quantity"></div><div class="units col-xs-12 col-sm-4 col-md-4 col-lg-4"><label for="field_unit"><strong>UNITS:</strong></label> <select name="unit" id="field_unit" readonly="true" ng-disabled="true" class="form-control input-sm" ng-model="vm.procedure.unit"><option ng-selected="true" value="UNITS">UNITS</option><option value="MINUTES">MINUTES</option></select></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabledm="vm.isSaving || editform.$error.required || editform.$invalid || !vm.procedure.cpt"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></fieldset><div class="overlay-delete" ng-if="vm.showDeleteDiagnose" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action will <strong>remove</strong> this Diagnose. Are you sure you want to continue?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDeleteDiagnose()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDeleteDiagnose = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div><div class="overlay-delete" ng-if="vm.showDeleteModifiers" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action will <strong>remove</strong> this Modifier. Are you sure you want to continue?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDeleteModifier()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDeleteModifiers = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/procedure/tpl/procedure-form-professional.html','<form name="editform" novalidate ng-submit="vm.save()" show-validation role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create or edit a Procedure</h4></div><fieldset><div class="modal-body"><div class="row mb-20" style="margin-bottom: 20px !important;"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h5 class="text-uppercase"><strong>Cpt (*)</strong></h5><div ng-show="vm.procedure.cpt" class="inputs row"><div class="identifier col-xs-12 col-sm-1 col-md-1 col-lg-1"><strong>{{vm.procedure.cpt.code}}</strong></div><div class="description col-xs-12 col-sm-10 col-md-10 col-lg-10">{{vm.procedure.cpt.fullDesc}}</div><div class="remove col-xs-12 col-sm-1 col-md-1 col-lg-1" style="margin: 0 !important; padding: 0 !important;" ng-click="vm.removeCpt()"><a href=""><i class="fa fa-times-circle" aria-hidden="true"></i></a></div></div><div ng-hide="vm.procedure.cpt" class="inputs has-feedback" ng-class="vm.procedure.cpt?(editform.cpt.selected?\'has-success\':\'\'):\'has-error\'"><ui-select name="cpt" id="field_cpt" title="Select cpt" ng-model="vm.procedure.cpt" ng-model-options="{ debounce: 500 }" reset-search-input="true" close-on-select="true" on-select="vm.selectCpt($model)" required style="min-width: 240px; width: 100%; background-color: white"><ui-select-match allow-clear="true" placeholder="Enter a Cpt...">{{$select.selected.code}} - {{$select.selected.shortDesc}}</ui-select-match><ui-select-choices repeat="cpt in vm.cpts | filter: $select.search" refresh="vm.getCpts($select.search)" refresh-delay="0"><div ng-bind-html="cpt.code"></div><small ng-bind-html="cpt.shortDesc | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.procedure.cpt"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.procedure.cpt && editform.field_cpt.$dirty"></span> <span class="help-block" ng-show="!vm.procedure.cpt">This field is required</span></div></div></div><div class="row mb-30"><div class="input-diagnoses col-xs-12 col-sm-6 col-md-6 col-lg-6"><h5 class="text-uppercase"><strong>Diagnoses[ICD-10] (*)</strong></h5><ul class="list-unstyled diagnoses-list col-lg-12 col-sm-12" dnd-list="vm.diagnoses"><li class="diagnose-item" ng-repeat="diagnose in vm.diagnoses" dnd-draggable="diagnose" dnd-dragend="vm.onDragEnd(vm.diagnoses)" dnd-moved="vm.diagnoses.splice($index, 1)" dnd-effect-allowed="move"><div class="inputs"><div class="list-handle col-sm-1" style="margin-right: 10px" dnd-handle>:::</div><div class="identifier col-sm-2" style="margin: 0 !important; padding: 0 !important;"><span>{{diagnose.xorder}} - </span><strong>{{diagnose.icd10.code}}</strong></div><div class="description col-sm-7" style="margin: 0 !important; padding: 0 !important;">{{diagnose.icd10.description}}</div><div class="remove col-sm-1" style="margin: 0 !important; padding: 0 !important;" ng-click="vm.removeProcedureDiagnoses($index)"><a href=""><i class="fa fa-times-circle" aria-hidden="true"></i></a></div></div></li></ul><div class="input-new mt-15"><search-select ng-model="vm.icd10Selected" compare-property="\'id\'" placeholder="Search by CPT, code or description..." tabs-conf="vm.icd10TabsConf" on-select="vm.onSelectIcd10()" render="vm.renderIcd10"></search-select></div></div><div class="input-modifier col-xs-12 col-sm-6 col-md-6 col-lg-6"><h5 class="text-uppercase"><strong>Modifiers</strong></h5><ul class="list-unstyled modifiers-list col-lg-12 col-sm-12" dnd-list="vm.modifiers"><li class="modifiers-item row" ng-repeat="modifier in vm.modifiers" dnd-draggable="modifier" dnd-dragend="vm.onDragEnd(vm.modifiers)" dnd-moved="vm.modifiers.splice($index, 1)" dnd-effect-allowed="move"><div class="inputs"><div class="list-handle col-sm-1" style="margin-right: 10px" dnd-handle>:::</div><div class="identifier col-sm-2" style="margin: 0 !important; padding: 0 !important;"><span>{{modifier.xorder}} - </span><strong>{{modifier.modifier.code}}</strong></div><div class="description col-sm-7" style="margin: 0 !important; padding: 0 !important;"><p>{{modifier.modifier.fullDesc}}</p></div><div class="remove col-sm-1" style="margin: 0 !important; padding: 0 !important;" ng-click="vm.removeProcedureModifier($index)"><a href=""><i class="fa fa-times-circle" aria-hidden="true"></i></a></div></div></li></ul><div class="input-new mt-15"><search-select ng-model="vm.modifierSelected" compare-property="\'id\'" placeholder="Search modifier by code or description..." tabs-conf="vm.modifierTabsConf" on-select="vm.onSelectModifier()" render="vm.renderModifier"></search-select></div></div></div><div class="row mb-30"><div class="rate col-xs-12 col-sm-4 col-md-4 col-lg-4"><label for="field_rate"><strong>RATE:</strong></label><div class="input-group input-group-sm"><span class="input-group-addon"><i class="fa fa-usd" aria-hidden="true"></i> </span><input type="number" name="rate" id="field_rate" ng-model="vm.procedure.rate" class="form-control" min="0" step="0.01" placeholder="0.00"></div></div><div class="qty col-xs-12 col-sm-4 col-md-4 col-lg-4"><label for="field_quantity"><strong>QTY:</strong></label> <input type="number" name="quantity" id="field_quantity" class="form-control input-sm" min="0" step="1" ng-model="vm.procedure.quantity"></div><div class="units col-xs-12 col-sm-4 col-md-4 col-lg-4"><label for="field_unit"><strong>UNITS:</strong></label> <select name="unit" id="field_unit" class="form-control input-sm" ng-model="vm.procedure.unit"><option value="UNITS">UNITS</option><option value="MINUTES">MINUTES</option></select></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.isSaving || editform.$error.required || editform.$invalid || !vm.procedure.cpt"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></fieldset><div class="overlay-delete" ng-if="vm.showDeleteDiagnose" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action will <strong>remove</strong> this Diagnose. Are you sure you want to continue?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDeleteDiagnose()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDeleteDiagnose = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div><div class="overlay-delete" ng-if="vm.showDeleteModifiers" style="position: absolute; top: 55px; right: 10px; bottom: 10px; left: 10px; display: flex; justify-content: center; align-items: center; background-color: rgba(0,0,0,0.6); z-index: 10; border-radius: 5px"><div class="text-center"><h4 class="text-center" style="color: white">This action will <strong>remove</strong> this Modifier. Are you sure you want to continue?</h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.confirmDeleteModifier()" style="margin: 0 5px;"><i class="fa fa-check"></i> Confirm</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.showDeleteModifiers = false" style="margin: 0 5px;"><i class="fa fa-ban"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/processed-scheduler-item/list/processed-scheduler-item.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/processed-patient-result/list/processed-patient-result.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/protocol/list/protocol.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/protocol/update/protocol-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRelationalLabel">Create New Protocol</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.name.$invalid ? \'has-error\' : (editForm.name.$touched || editForm.name.$dirty ? \'has-success\' : \'\')"><label for="field_name">Name:</label> <input type="text" id="field_name" class="form-control" placeholder="Protocol name..." ng-model="vm.protocol.name" name="name" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.name.$error.required"></span> <span class="help-block" ng-show="editForm.name.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.type.$invalid ? \'has-error\' : (editForm.type.$touched || editForm.type.$dirty ? \'has-success\' : \'\')"><label for="field_type">Category:</label> <select id="field_type" class="form-control" ng-model="vm.protocol.type" name="type" ng-change="vm.changeCategory()" required><option value="AS_NEEDED">AS NEEDED</option><option value="TAPER">TAPER</option><option value="CONSISTENT_DOSE">CONSISTENT DOSE</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.type.$error.required"></span> <span class="help-block" ng-show="editForm.type.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group"><label for="field_enable">Enable:</label><br><toggle id="field_enable" name="enable" ng-change="" ng-model="vm.protocol.enable" on="Yes" off="No" size="" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="editForm.medication.$invalid ? \'has-error\' : (editForm.medication.$touched || editForm.medication.$dirty ? \'has-success\' : \'\')"><label for="field_medication">Medication:</label><ui-select name="medication" id="field_medication" ng-model="vm.protocol.medication" required reset-search-input="true" title="All Medications" close-on-select="true"><ui-select-match placeholder="Select medications ..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="medication in vm.medications | filter: $select.search" refresh="vm.getMedications($select.search)" refresh-delay="0"><div ng-bind-html="medication.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.medication.$error.required"></span> <span class="help-block" ng-show="editForm.medication.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="editForm.route.$invalid ? \'has-error\' : (editForm.route.$touched || editForm.route.$dirty ? \'has-success\' : \'\')"><label for="field_route">Route:</label><ui-select ng-model="vm.protocol.route" name="route" id="field_route" reset-search-input="true" title="Select route for current medication" close-on-select="true" required><ui-select-match placeholder="Select route ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="route in vm.routes | filter: $select.search"><div ng-bind-html="route.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.route.$error.required"></span> <span class="help-block" ng-show="editForm.route.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="editForm.dose_form.$invalid ? \'has-error\' : (editForm.dose_form.$touched || editForm.dose_form.$dirty ? \'has-success\' : \'\')"><label for="field_dose_form">Dosages Form:</label><ui-select ng-model="vm.protocol.doseForm" name="dose_form" id="field_dose_form" reset-search-input="true" title="Select dosages form for current medication" close-on-select="true" required><ui-select-match placeholder="Select dosages form ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="doseForm in vm.doseForms | filter: $select.search"><div ng-bind-html="doseForm.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.dose_form.$error.required"></span> <span class="help-block" ng-show="editForm.dose_form.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback"><label for="field_refill">Refills Count:</label> <input type="number" id="field_refill" name="refill" class="form-control" min="0" ng-model="vm.protocol.refills"></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback"><label for="field_dispense">Dispense:</label> <input type="number" id="field_dispense" name="dispense" class="form-control" min="0" ng-model="vm.protocol.dispense"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.relational.$invalid ? \'has-error\' : (editForm.relational.$touched || editForm.relational.$dirty ? \'has-success\' : \'\')"><label for="field_relational">Rationale:</label><ui-select ng-model="vm.protocol.relationals" name="relational" id="field_relational" title="Rationale" required close-on-select="false" multiple="multiple"><ui-select-match placeholder="Select rationale...">{{$item.name}}</ui-select-match><ui-select-choices repeat="relational in vm.relationals | filter: $select.search"><div ng-bind-html="relational.name  | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.relational.$error.required"></span> <span class="help-block" ng-show="editForm.relational.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.duration_days.$invalid ? \'has-error\' : (editForm.duration_days.$touched || editForm.duration_days.$dirty ? \'has-success\' : \'\')"><label for="field_duration_days">Duration in Days:</label> <input type="number" id="field_duration_days" class="form-control" min="0" max="365" name="duration_days" ng-disabled="vm.protocol.type == \'TAPER\'" ng-model="vm.protocol.durationDays" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.duration_days.$error.required"></span> <span class="help-block" ng-show="editForm.duration_days.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="editForm.duration_days.$error.min">This field must be greater than 0</span> <span class="help-block" aria-hidden="true" ng-show="editForm.duration_days.$error.max">This field must be less than 365</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.route.$invalid ? \'has-error\' : (editForm.protocolGroup.$touched || editForm.protocolGroup.$dirty ? \'has-success\' : \'\')"><label for="field_protocolGroup">Group Protocol:</label><ui-select ng-model="vm.protocol.protocolGroup " name="protocolGroup" id="field_protocolGroup" reset-search-input="true" title="Select protocol group" close-on-select="true"><ui-select-match placeholder="Select group ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="protocolGroup in vm.protocolGroup | filter: $select.search"><div ng-bind-html="protocolGroup.name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_instructions">Instructions:</label> <textarea class="form-control" id="field_instructions" rows="4" data-resize="disabled" name="instructions" ng-model="vm.protocol.instructions"></textarea></div></div><fieldset><legend>Frequencies</legend><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div ng-repeat="($index, frequency) in vm.protocol.protocolFrequencies" class="frequency-day"><header><h4 class="day-number" ng-if="vm.protocol.type == \'TAPER\'"><button type="button" class="btn btn-default btn-sm" ng-disabled="frequency.schedules == null || frequency.schedules.length == 0" ng-click="frequency.isCollapsed = !frequency.isCollapsed"><i class="fa" aria-hidden="true" ng-class="frequency.isCollapsed?\'fa-chevron-right\':\'fa-chevron-down\'"></i></button> - <strong>Day {{frequency.xorder + 1}}</strong></h4><h4 class="day-number" ng-if="vm.protocol.type != \'TAPER\'"><button type="button" class="btn btn-default btn-sm" ng-disabled="frequency.schedules == null || frequency.schedules.length == 0" ng-click="frequency.isCollapsed = !frequency.isCollapsed"><i class="fa" aria-hidden="true" ng-class="frequency.isCollapsed?\'fa-chevron-right\':\'fa-chevron-down\'"></i></button> - <strong>Frequency</strong></h4><div class="select-frequency" ng-class="frequency.frequency == null ? \'has-error\' : \'has-success\'"><select class="form-control has-feedback" ng-model="frequency.frequency" id="field_frequency_{{$index}}" name="frequency_{{$index}}" required ng-change="vm.changeFrequency(frequency)" ng-options="frequency as frequency.description for frequency in vm.frequencies track by frequency.id"></select></div><button type="button" class="btn btn-danger" ng-if="vm.protocol.type == \'TAPER\' && vm.protocol.protocolFrequencies.length > 1" ng-click="vm.deleteDay($index)"><i class="fa fa-trash" aria-hidden="true"></i> Delete Day</button></header><div class="schedule-times well well-sm" ng-if="frequency.schedules != null && frequency.schedules.length > 0" uib-collapse="frequency.isCollapsed"><table class="table table-condensed"><thead><tr><th ng-if="!frequency.hideDay"></th><th ng-if="!frequency.hideDay"><strong>At:</strong></th><th><strong>Strength:</strong></th><th><strong>Quantity:</strong></th></tr></thead><tbody><tr ng-repeat="($index, schedule) in frequency.schedules"><td style="width: 25px" ng-if="!frequency.hideDay"><span class="index">{{schedule.xorder}}</span></td><td style="width: 80px" ng-if="!frequency.hideDay"><div class="form-group mb-0" ng-class="schedule.date == null ? \'has-error\' : \'has-success\'"><input name="date{{$parent.$index}}{{$index}}" required type="time" class="time-control" ng-model="schedule.date"></div></td><td><div class="form-group mb-0" ng-class="schedule.strength == null || schedule.strength.length == 0 ? \'has-error\' : \'has-success\'"><input name="strength{{$parent.$index}}{{$index}}" required type="text" class="form-control input-sm" ng-model="schedule.strength"></div></td><td style="width: 100px"><div class="form-group mb-0" ng-class="schedule.quantity?(vm.form.schedule.quantity.$valid && vm.form.schedule.quantity.$dirty?\'has-success\':\'\'):\'has-error\'"><input name="quantity{{$parent.$index}}{{$index}}" type="number" class="form-control input-sm" required ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="schedule.quantity"></div></td></tr></tbody></table></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center mt-15 mb-15" ng-if="vm.protocol.type == \'TAPER\'"><button type="button" class="btn btn-primary" ng-click="vm.addDay()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Day {{vm.protocol.type}}</button></div></div></fieldset></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/protocol-group/list/protocol-group.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/protocol-group/update/protocol-group-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Create or edit a Protocol Group</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.protocolGroup.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.protocolGroup.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.protocolGroup.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.protocolGroup.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.protocolGroup.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.protocolGroup.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.protocolGroup.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/rcopia/popup/rcopia-popup.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Rcopia</h4></div><div class="modal-body"><div><iframe width="100%" height="600" ng-src="{{vm.rcopiaToken}}" id="rcopia" name="rcopia"></iframe></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/rcopia-account/list/rcopia-account.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-account/update/rcopia-account-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myDrfAccountLabel">Create or edit a Rcopia Account</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rcopiaAccount.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.rcopiaAccount.id" readonly="readonly"></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaAccount.employee?(editForm.employee.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_employee">Employee:</label><ui-select id="field_employee" name="employee" reset-search-input="false" ng-model="vm.rcopiaAccount.employee" title="Employee..." ng-model-options="{ debounce: 300 }" ng-disabled="vm.rcopiaAccount.id" required><ui-select-match allow-clear="true" placeholder="Employee...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.rcopiaAccount.employee"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.rcopiaAccount.employee && editForm.employee.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.rcopiaAccount.employee">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaAccount.username?(editForm.username.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_username">Username</label> <input type="text" class="form-control" name="username" id="field_username" required ng-model="vm.rcopiaAccount.username"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.rcopiaAccount.username"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.rcopiaAccount.username && editForm.username.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.rcopiaAccount.username">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaAccount.rcopiaAccountType?(editForm.rcopiaAccountType.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_rcopiaAccountType">Account Type</label> <select class="form-control" id="field_rcopiaAccountType" name="rcopiaAccountType" required ng-model="vm.rcopiaAccount.rcopiaAccountType" ng-options="types for types in vm.accountTypes"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.rcopiaAccount.rcopiaAccountType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.rcopiaAccount.rcopiaAccountType && editForm.rcopiaAccountType.$dirty"></span> <span class="help-block" ng-show="!vm.rcopiaAccount.rcopiaAccountType">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/rcopia-allergy-group/list/rcopia-allergy-groups.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-ap-i/list/rcopia-ap-i.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-drug/list/rcopia-drug.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-last-update-date/list/rcopia-last-update-dates.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-last-update-date/update/rcopia-last-update-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myReactionLabel">Create or edit a Rcopia Last Update Date</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rcopiaLastUpdateDate.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.rcopiaLastUpdateDate.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.rcopiaLastUpdateDate.lastUpdateDate?(editForm.lastUpdateDate.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_lastUpdateDate">Last Update Date:</label> <input type="text" class="form-control" name="rcopiaLastUpdateDate" id="field_lastUpdateDate" required ng-model="vm.rcopiaLastUpdateDate.lastUpdateDate"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.rcopiaLastUpdateDate.lastUpdateDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.rcopiaLastUpdateDate.lastUpdateDate && editForm.lastUpdateDate.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.rcopiaLastUpdateDate.lastUpdateDate">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/rcopia-medication/create-takes/rcopia-medication-create-takes-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.rcopiaMedication.sig.drug.drugDescription}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td colspan="2"><span><strong>{{vm.rcopiaMedication.sig.drug.drugDescription}}</strong></span></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td><label>Directions:</label></td><td><label>{{vm.rcopiaMedication.sig.dosage.dosageText}}</label></td></tr><tr><td><label>Quantity:</label></td><td><label>{{vm.getQuantity(vm.rcopiaMedication)}}</label></td></tr><tr><td><label>Refills:</label></td><td><label>{{vm.getRefills(vm.rcopiaMedication)}}</label></td></tr><tr><td><label></label></td><td><label>Substitution Permitted</label></td></tr><tr ng-if="vm.rcopiaMedication.duration"><td><label>Days Supply</label></td><td><label>{{vm.getDaysSupply(vm.rcopiaMedication)}}</label></td></tr><tr ng-if="vm.rcopiaMedication.sig.otherNotes"><td><label>Dir. To Pharmacy</label></td><td><label>{{vm.dirToPharmacy(vm.rcopiaMedication)}}</label></td></tr><tr ng-if="vm.rcopiaMedication.sig.effectiveDate"><td><label>Do Not Fill Before</label></td><td><label>{{vm.doNotFillBefore(vm.rcopiaMedication)}}</label></td></tr><tr><td><label>Start</label></td><td><label>{{vm.rcopiaMedication.startDate | date: inputDateFormat}}</label></td></tr><tr><td><label>Stop</label></td><td><label>{{vm.rcopiaMedication.stopDate | date: inputDateFormat}}</label></td></tr><tr ng-if="vm.rcopiaMedication.comments"><td><label>Comments For Office Use Only</label></td><td><label>{{vm.rcopiaMedication.comments}}</label></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="table-responsive"><table class="table table-condensed"><tbody><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Pharmacy</label></td><td><label><strong>{{vm.rcopiaMedication.pharmacy.name}}</strong></label><br><label>{{vm.rcopiaMedication.pharmacy.address1}}</label><br><label ng-if="vm.rcopiaMedication.pharmacy.address2">{{vm.rcopiaMedication.pharmacy.address2}}<br></label> <label>{{vm.rcopiaMedication.pharmacy.city}}, {{vm.rcopiaMedication.pharmacy.state}} {{vm.rcopiaMedication.pharmacy.zip}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Phone</label></td><td><label>{{vm.rcopiaMedication.pharmacy.phone}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Fax</label></td><td><label>{{vm.rcopiaMedication.pharmacy.fax}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>NCPDPID</label></td><td><label>{{vm.rcopiaMedication.pharmacy.ncpdpid}}</label></td></tr><tr><td><label>Provider</label></td><td><label><strong>{{ vm.rcopiaMedication.provider | employeeName }}</strong></label></td></tr><tr><td><label>Created By</label></td><td><label><strong>{{ vm.rcopiaMedication.preparer | employeeName }}</strong></label></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/rcopia-medication/detail/rcopia-medication-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.rcopiaMedication.sig.drug.drugDescription}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td colspan="2"><span><strong>{{vm.rcopiaMedication.sig.drug.drugDescription}}</strong></span></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td><label>Directions:</label></td><td><label>{{vm.rcopiaMedication.sig.dosage.dosageText}}</label></td></tr><tr><td><label>Quantity:</label></td><td><label>{{vm.getQuantity(vm.rcopiaMedication)}}</label></td></tr><tr><td><label>Refills:</label></td><td><label>{{vm.getRefills(vm.rcopiaMedication)}}</label></td></tr><tr><td><label></label></td><td><label>Substitution Permitted</label></td></tr><tr ng-if="vm.rcopiaMedication.duration"><td><label>Days Supply</label></td><td><label>{{vm.getDaysSupply(vm.rcopiaMedication)}}</label></td></tr><tr ng-if="vm.rcopiaMedication.sig.otherNotes"><td><label>Dir. To Pharmacy</label></td><td><label>{{vm.dirToPharmacy(vm.rcopiaMedication)}}</label></td></tr><tr ng-if="vm.rcopiaMedication.sig.effectiveDate"><td><label>Do Not Fill Before</label></td><td><label>{{vm.doNotFillBefore(vm.rcopiaMedication)}}</label></td></tr><tr><td><label>Start</label></td><td><label>{{vm.rcopiaMedication.startDate | date: inputDateFormat}}</label></td></tr><tr><td><label>Stop</label></td><td><label>{{vm.rcopiaMedication.stopDate | date: inputDateFormat}}</label></td></tr><tr ng-if="vm.rcopiaMedication.comments"><td><label>Comments For Office Use Only</label></td><td><label>{{vm.rcopiaMedication.comments}}</label></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="table-responsive"><table class="table table-condensed"><tbody><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Pharmacy</label></td><td><label><strong>{{vm.rcopiaMedication.pharmacy.name}}</strong></label><br><label>{{vm.rcopiaMedication.pharmacy.address1}}</label><br><label ng-if="vm.rcopiaMedication.pharmacy.address2">{{vm.rcopiaMedication.pharmacy.address2}}<br></label> <label>{{vm.rcopiaMedication.pharmacy.city}}, {{vm.rcopiaMedication.pharmacy.state}} {{vm.rcopiaMedication.pharmacy.zip}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Phone</label></td><td><label>{{vm.rcopiaMedication.pharmacy.phone}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Fax</label></td><td><label>{{vm.rcopiaMedication.pharmacy.fax}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>NCPDPID</label></td><td><label>{{vm.rcopiaMedication.pharmacy.ncpdpid}}</label></td></tr><tr><td><label>Provider</label></td><td><label><strong>{{ vm.rcopiaMedication.provider | employeeName }}</strong></label></td></tr><tr><td><label>Created By</label></td><td><label><strong>{{ vm.rcopiaMedication.preparer | employeeName }}</strong></label></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/rcopia-medication/history/rcopia-medication-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Rcopia Medication History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Drug</strong></th><th><strong>Direction</strong></th><th><strong>Qty</strong></th><th><strong>Refill</strong></th><th><strong>Start</strong></th><th><strong>End</strong></th><th><strong>Reason Stopped</strong></th><th><strong>Enter</strong></th><th><strong>Provider</strong></th></tr></thead><tbody><tr ng-repeat="patientMedication in vm.patientMedications"><td class="order-name"><p><i class="fa fa-exclamation-triangle warning" style="font-size: 14px; cursor: help; vertical-align: middle; color: #ffbe4f" ng-if="patientMedication.status === \'SCHEDULED\' && patientMedication.warning > 0 && patientMedication.warning <= 5" uib-tooltip="Warning: within 5 days of end date."></i> {{ patientMedication.drug.drugDescription }}</p></td><td><p>{{ vm.getDirections(patientMedication) }}</p><p ng-if="patientMedication.comments"><strong>OFFICE COMMENTS:</strong></p><p ng-if="patientMedication.comments">{{ patientMedication.comments }}</p></td><td>{{ vm.getQuantity(patientMedication) }}</td><td>{{ vm.getRefills(patientMedication) }}</td><td><p>{{patientMedication.startDate | date: inputDateFormat}}</p></td><td><p>{{patientMedication.stopDate | date: inputDateFormat}}</p></td><td><p>{{ patientMedication.stopReason }}</p></td><td><p>{{patientMedication.preparer | employeeName}}</p><p><span class="small">{{patientMedication.fillDate | date: inputDateFormat}}</span></p></td><td><p><span>{{ patientMedication.provider | employeeName }}</span> <span class="small" ng-if="patientMedication.signedDate">- {{ patientMedication.signedDate | date: inputDateFormat }}</span></p></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/rcopia-medication/list/rcopia-medications.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px"><h4 class="header-line mt-0 mb-10 pb-10" style="border-bottom: 1px solid #d2d6de"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-medkit" aria-hidden="true" ng-click="vm.launchRcopia()">&nbsp; Launch Rcopia</i></button><div class="input-group input-group-sm" style="margin-left: auto"><select class="form-control" id="field_status" name="status" ng-model="vm.filter.status" ng-change="vm.loadAll()"><option value="active" selected="selected">Active</option><option value="inactive">Inactive</option></select></div><div class="input-group input-group-sm search" style="margin-left: 1em"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="patient-medications"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><!--                        <th>--><!--                            <input type="checkbox" ng-model="vm.selectAll"--><!--                                   ng-change="vm.toggleAll(vm.selected, vm.selectAll)">--><!--                        </th>--><th><strong>Drug</strong></th><th><strong>Direction</strong></th><th><strong>Qty</strong></th><th><strong>Refill</strong></th><th><strong>Start</strong></th><th><strong>End</strong></th><th><strong>Enter</strong></th><th><strong>Provider</strong></th><th><strong>Pharmacy</strong></th><th></th></tr></thead><tbody><tr class="item-order" ng-repeat="patientMedication in vm.patientMedications"><!--                        <td>--><!--                            <input type="checkbox" ng-model="vm.selected[patientMedication.id]"--><!--                                   ng-click="vm.toggleOne(vm.selected, vm.selectAll)">--><!--                        </td>--><td class="order-name"><p><i class="fa fa-exclamation-triangle warning" style="font-size: 14px; cursor: help; vertical-align: middle; color: #ffbe4f" ng-if="patientMedication.status === \'SCHEDULED\' && patientMedication.warning > 0 && patientMedication.warning <= 5" uib-tooltip="Warning: within 5 days of end date."></i> {{ patientMedication.sig.drug.drugDescription }} {{ patientMedication.durationDays ? \'-\' + patientMedication.durationDays + \' days\' : \'\' }} {{ patientMedication.type ? \'-\' + (patientMedication.type | clearEnum) : \'\' }}</p></td><td>{{ patientMedication.sig.dosage.dosageText }}</td><td>{{ vm.getQuantity(patientMedication) }}</td><td>{{ vm.getRefills(patientMedication) }}</td><td><p>{{patientMedication.startDate | date: inputDateFormat}}</p></td><td><p>{{patientMedication.stopDate | date: inputDateFormat}}</p></td><td><p>{{patientMedication.preparer | employeeName}}</p><p><span class="small">{{patientMedication.fillDate | date: inputDateFormat}}</span></p></td><td><div ng-if="patientMedication.discontinueBy"><p><span class="label label-danger">Discontinue by:</span> {{patientMedication.discontinueBy | employeeName}} - <span class="small">{{patientMedication.discontinueDate | amDateFormat: amDateFormat}}</span></p></div><div ng-if="!patientMedication.discontinueBy"><p><span ng-class="patientMedication.signed?\'label label-success\':\'label label-info\'"></span> {{patientMedication.provider | employeeName}}<span ng-if="patientMedication.signed"> - </span><span class="small">{{patientMedication.signedDate | amDateFormat: amDateFormat}}</span></p></div></td><td><div><p>{{ patientMedication.pharmacy ? patientMedication.pharmacy.name : "-" }}</p></div></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" title="See Details" class="dd-link orange" ng-click="vm.view(patientMedication.id)"><i class="fa fa-list-alt" aria-hidden="true"></i>See Details</a></li><!--                                    <li role="menuitem">--><!--                                        <a href="" title="Edit" class="dd-link orange"--><!--                                           ng-click="vm.edit(patientMedication.id)">--><!--                                            <i class="fa fa-pencil" aria-hidden="true"></i> Edit--><!--                                        </a>--><!--                                    </li>--><li role="menuitem"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.print(patientMedication.id)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li><li role="menuitem" ng-if="false"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.createTakes(patientMedication.id)"><i class="fa fa-print" aria-hidden="true"></i> Plan</a></li><!--                                    <li role="menuitem">--><!--                                        <a href="" title="Fax to" class="dd-link blue"--><!--                                           ng-click="vm.fax(patientMedication.id)">--><!--                                            <i class="fa fa-fax" aria-hidden="true"></i> Fax to--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem" ng-if="!patientMedication.rcopiaPrescription">--><!--                                        <a href="" title="See Details" class="dd-link orange"--><!--                                           ng-click="vm.view(patientMedication.id)">--><!--                                            <i class="fa fa-list-alt" aria-hidden="true"></i>See Details--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem" ng-if="patientMedication.rcopiaPrescription">--><!--                                        <a href="" title="See Details" class="dd-link orange"--><!--                                           ng-click="vm.viewRcopia(patientMedication.id)">--><!--                                            <i class="fa fa-list-alt" aria-hidden="true"></i>See Details--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem">--><!--                                        <a href="" title="See Details" class="dd-link red"--><!--                                           ng-if="patientMedication.status === \'SCHEDULED\'"--><!--                                           ng-click="vm.discontinue(patientMedication.id)">--><!--                                            <i class="fa fa-ban" aria-hidden="true"></i>Discontinue--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem">--><!--                                        <a href="" title="See Details" class="dd-link blue"--><!--                                           ng-click="vm.changeOnlyChart(patientMedication.id)">--><!--                                            <i class="fa fa-exchange" aria-hidden="true"></i>--><!--                                            {{ patientMedication.onlyInChart ? \'Show in Mars\' : \'Only in Chart\' }}--><!--                                        </a>--><!--                                    </li>--></ul></div><!-- /dropdown--></td></tr><!-- /item-order --></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.patientMedications.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><!--    <div class="buttons-toolbar btn-group">--><!--        <button type="button" class="btn btn-default"--><!--                ng-click="vm.add()">--><!--            <i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add Medication--><!--        </button>--><!--        <button type="button" class="btn btn-default"--><!--                ng-disabled="vm.getSelectedIds(vm.selected).length == 0"--><!--                ng-click="vm.discontinue()">--><!--            <i class="fa fa-ban" aria-hidden="true" style="color: #dd4b39"></i> Discontinue Multiple--><!--        </button>--><!--        <button type="button" class="btn btn-default"--><!--                ui-sref="admission-medication({id: vm.chart.id})">--><!--            <i class="fa fa-sign-in" aria-hidden="true" style="color: #00a7d0"></i> Admission Medications--><!--        </button>--><!--        <button type="button" class="btn btn-default"--><!--                ng-disabled="vm.getSelectedIds(vm.selected).length == 0"--><!--                ng-click="vm.fax()">--><!--            <i class="fa fa-edit" aria-hidden="true" style="color: #f39c12"></i> Fax Multiple--><!--        </button>--><!--        <button type="button" class="btn btn-default" ng-click="vm.history()">--><!--            <i class="fa fa-history" aria-hidden="true" style="color: #dd4b39"></i> History--><!--        </button>--><!--        <div class="btn-group dropup" uib-dropdown>--><!--            <udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom>--><!--        </div>--><!--    </div>--></div>');
$templateCache.put('app/entities/rcopia-practice-info/list/rcopia-practice-info.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-practice-info/update/rcopia-practice-info-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()" autocomplete="off"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRcopiaPracticeInfoLabel">Create or edit a RcopiaPracticeInfo</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaPracticeInfo.name ?(editForm.name?\'has-success\':\'\'):\'has-error\'"><label for="name">Name:</label> <input type="text" class="form-control" name="name" id="name" required ng-model="vm.rcopiaPracticeInfo.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.rcopiaPracticeInfo.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.rcopiaPracticeInfo.name"></span> <span class="help-block" ng-show="!vm.rcopiaPracticeInfo.name">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaPracticeInfo.username ?(editForm.username?\'has-success\':\'\'):\'has-error\'"><label for="name">Username:</label> <input type="text" class="form-control" name="username" id="username" required ng-model="vm.rcopiaPracticeInfo.username"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.rcopiaPracticeInfo.username"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.rcopiaPracticeInfo.username"></span> <span class="help-block" ng-show="!vm.rcopiaPracticeInfo.username">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaPracticeInfo.region ?(editForm.region?\'has-success\':\'\'):\'has-error\'"><label for="name">Region:</label> <input type="text" class="form-control" name="region" id="region" required ng-model="vm.rcopiaPracticeInfo.region"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.rcopiaPracticeInfo.region"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.rcopiaPracticeInfo.region"></span> <span class="help-block" ng-show="!vm.rcopiaPracticeInfo.region">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaPracticeInfo.vendorUsername ?(editForm.vendorUsername?\'has-success\':\'\'):\'has-error\'"><label for="name">Vendor Username:</label> <input type="text" class="form-control" name="vendorUsername" id="vendorUsername" required ng-model="vm.rcopiaPracticeInfo.vendorUsername"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.rcopiaPracticeInfo.vendorUsername"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.rcopiaPracticeInfo.vendorUsername"></span> <span class="help-block" ng-show="!vm.rcopiaPracticeInfo.vendorUsername">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.rcopiaPracticeInfo.vendorPassword ?(editForm.vendorPassword?\'has-success\':\'\'):\'has-error\'"><label for="name">Vendor Password:</label> <input type="text" class="form-control" name="vendorPassword" id="vendorPassword" required ng-model="vm.rcopiaPracticeInfo.vendorPassword"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.rcopiaPracticeInfo.vendorPassword"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.rcopiaPracticeInfo.vendorPassword"></span> <span class="help-block" ng-show="!vm.rcopiaPracticeInfo.vendorPassword">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving" type="submit"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/rcopia-prescription/detail/rcopia-prescription-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.rcopiaPrescription.sig.drug.drugDescription}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td colspan="2"><span><strong>{{vm.rcopiaPrescription.sig.drug.drugDescription}}</strong></span></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td><label>Directions:</label></td><td><label>{{vm.rcopiaPrescription.sig.dosage.dosageText}}</label></td></tr><tr><td><label>Quantity:</label></td><td><label>{{vm.getQuantity(vm.rcopiaPrescription)}}</label></td></tr><tr><td><label>Refills:</label></td><td><label>{{vm.getRefills(vm.rcopiaPrescription)}}</label></td></tr><tr><td><label></label></td><td><label>Substitution Permitted</label></td></tr><tr ng-if="vm.rcopiaPrescription.duration"><td><label>Days Supply</label></td><td><label>{{vm.getDaysSupply(vm.rcopiaPrescription)}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.sig.otherNotes"><td><label>Dir. To Pharmacy</label></td><td><label>{{vm.dirToPharmacy(vm.rcopiaPrescription)}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.sig.effectiveDate"><td><label>Do Not Fill Before</label></td><td><label>{{vm.doNotFillBefore(vm.rcopiaPrescription)}}</label></td></tr><tr><td><label>Order #</label></td><td><label>{{vm.rcopiaPrescription.rcopiaId}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.sig.comments"><td><label>Comments For Office Use Only</label></td><td><label>{{vm.rcopiaPrescription.sig.comments}}</label></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="table-responsive"><table class="table table-condensed"><tbody><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Pharmacy</label></td><td><label><strong>{{vm.rcopiaPrescription.pharmacy.name}}</strong></label><br><label>{{vm.rcopiaPrescription.pharmacy.address1}}</label><br><label ng-if="vm.rcopiaPrescription.pharmacy.address2">{{vm.rcopiaPrescription.pharmacy.address2}}<br></label> <label>{{vm.rcopiaPrescription.pharmacy.city}}, {{vm.rcopiaPrescription.pharmacy.state}} {{vm.rcopiaPrescription.pharmacy.zip}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Phone</label></td><td><label>{{vm.rcopiaPrescription.pharmacy.phone}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>Fax</label></td><td><label>{{vm.rcopiaPrescription.pharmacy.fax}}</label></td></tr><tr ng-if="vm.rcopiaPrescription.pharmacy"><td><label>NCPDPID</label></td><td><label>{{vm.rcopiaPrescription.pharmacy.ncpdpid}}</label></td></tr><tr><td><label>Provider</label></td><td><label><strong>{{ vm.rcopiaPrescription.provider | employeeName }}</strong></label></td></tr><tr><td><label>Created By</label></td><td><label><strong>{{ vm.rcopiaPrescription.preparer | employeeName }}</strong></label></td></tr></tbody></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/rcopia-prescription/history/rcopia-prescription-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Rcopia Prescription History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Drug</strong></th><th><strong>Direction</strong></th><th><strong>Qty</strong></th><th><strong>Refill</strong></th><th><strong>Notes</strong></th><th><strong>Enter</strong></th><th><strong>Provider</strong></th><th><strong>Pharmacy</strong></th><th><strong>Serial #</strong></th><th><strong>Status</strong></th></tr></thead><tbody><tr ng-repeat="patientMedication in vm.patientMedications"><td class="order-name"><p><i class="fa fa-exclamation-triangle warning" style="font-size: 14px; cursor: help; vertical-align: middle; color: #ffbe4f" ng-if="patientMedication.status === \'SCHEDULED\' && patientMedication.warning > 0 && patientMedication.warning <= 5" uib-tooltip="Warning: within 5 days of end date."></i> {{ patientMedication.drug.drugDescription }}</p></td><td>{{ vm.getDirections(patientMedication) }}</td><td>{{ vm.getQuantity(patientMedication) }}</td><td>{{ vm.getRefills(patientMedication) }}</td><td><i class="fa fa-comments" ng-if="patientMedication.comments" uib-tooltip="{{ patientMedication.comments }}"></i></td><td><p>{{ patientMedication.preparer | employeeName }}</p><p><span class="small">{{patientMedication.createdDate | date: inputDateFormat}}</span></p></td><td><p><span>{{ patientMedication.provider | employeeName }}</span></p><p><span class="small" ng-if="patientMedication.signedDate">{{ patientMedication.signedDate | date: inputDateFormat }}</span></p></td><td><div><p>{{ patientMedication.pharmacy ? patientMedication.pharmacy.name : "-" }}</p></div></td><td><p>{{ patientMedication.rcopiaId }}</p></td><td><p>{{ patientMedication.completionAction }}</p></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/rcopia-prescription/list/rcopia-prescriptions.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px"><h4 class="header-line mt-0 mb-10 pb-10" style="border-bottom: 1px solid #d2d6de"><button type="button" class="btn btn-success btn-sm"><i class="fa fa-medkit" aria-hidden="true" ng-click="vm.launchRcopia()">&nbsp; Launch Rcopia</i></button><div class="input-group input-group-sm" style="margin-left: auto"><select class="form-control" id="field_status" name="status" ng-model="vm.filter.status" ng-change="vm.loadAll()"><option value="PENDING" selected="selected">Pending</option><option value="COMPLETED">Completed</option><option value="ALL">All</option></select></div><div class="input-group input-group-sm search" style="margin-left: 1em"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="patient-medications"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><!--                        <th>--><!--                            <input type="checkbox" ng-model="vm.selectAll"--><!--                                   ng-change="vm.toggleAll(vm.selected, vm.selectAll)">--><!--                        </th>--><th><strong>Drug</strong></th><th><strong>Direction</strong></th><th><strong>Qty</strong></th><th><strong>Refill</strong></th><th><strong>Notes</strong></th><th><strong>Enter</strong></th><th><strong>Provider</strong></th><th><strong>Pharmacy</strong></th><th><strong>Serial #</strong></th><th><strong>Status</strong></th><th></th></tr></thead><tbody><tr class="item-order" ng-repeat="patientMedication in vm.patientMedications"><!--                        <td>--><!--                            <input type="checkbox" ng-model="vm.selected[patientMedication.id]"--><!--                                   ng-click="vm.toggleOne(vm.selected, vm.selectAll)">--><!--                        </td>--><td class="order-name"><p><i class="fa fa-exclamation-triangle warning" style="font-size: 14px; cursor: help; vertical-align: middle; color: #ffbe4f" ng-if="patientMedication.status === \'SCHEDULED\' && patientMedication.warning > 0 && patientMedication.warning <= 5" uib-tooltip="Warning: within 5 days of end date."></i> {{ patientMedication.sig.drug.drugDescription }}</p></td><td>{{ patientMedication.sig.dosage.dosageText }}</td><td>{{ vm.getQuantity(patientMedication) }}</td><td>{{ vm.getRefills(patientMedication) }}</td><td><i class="fa fa-comments" ng-if="patientMedication.comments" uib-tooltip="{{ patientMedication.comments }}"></i></td><td><p>{{ patientMedication.preparer | employeeName }}</p><p><span class="small">{{patientMedication.createdDate | date: inputDateFormat}}</span></p></td><td><p><span>{{ patientMedication.provider | employeeName }}</span></p></td><td><div><p>{{ patientMedication.pharmacy ? patientMedication.pharmacy.name : "-" }}</p></div></td><td><p>{{ patientMedication.rcopiaId }}</p></td><td><p>{{ patientMedication.completedDate ? \'COMPLETED\' : \'PENDING\' }}</p></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><!--                                    <li role="menuitem">--><!--                                        <a href="" title="Edit" class="dd-link orange"--><!--                                           ng-click="vm.edit(patientMedication.id)">--><!--                                            <i class="fa fa-pencil" aria-hidden="true"></i> Edit--><!--                                        </a>--><!--                                    </li>--><li role="menuitem"><a href="" title="See Details" class="dd-link orange" ng-click="vm.view(patientMedication.id)"><i class="fa fa-list-alt" aria-hidden="true"></i>See Details</a></li><li role="menuitem"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.print(patientMedication.id)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li><!--                                    <li role="menuitem">--><!--                                        <a href="" title="Fax to" class="dd-link blue"--><!--                                           ng-click="vm.fax(patientMedication.id)">--><!--                                            <i class="fa fa-fax" aria-hidden="true"></i> Fax to--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem" ng-if="!patientMedication.rcopiaPrescription">--><!--                                        <a href="" title="See Details" class="dd-link orange"--><!--                                           ng-click="vm.view(patientMedication.id)">--><!--                                            <i class="fa fa-list-alt" aria-hidden="true"></i>See Details--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem">--><!--                                        <a href="" title="See Details" class="dd-link red"--><!--                                           ng-if="patientMedication.status === \'SCHEDULED\'"--><!--                                           ng-click="vm.discontinue(patientMedication.id)">--><!--                                            <i class="fa fa-ban" aria-hidden="true"></i>Discontinue--><!--                                        </a>--><!--                                    </li>--><!--                                    <li role="menuitem">--><!--                                        <a href="" title="See Details" class="dd-link blue"--><!--                                           ng-click="vm.changeOnlyChart(patientMedication.id)">--><!--                                            <i class="fa fa-exchange" aria-hidden="true"></i>--><!--                                            {{ patientMedication.onlyInChart ? \'Show in Mars\' : \'Only in Chart\' }}--><!--                                        </a>--><!--                                    </li>--></ul></div><!-- /dropdown--></td></tr><!-- /item-order --></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.patientMedications.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><!--    <div class="buttons-toolbar btn-group">--><!--        <button type="button" class="btn btn-default"--><!--                ng-click="vm.add()">--><!--            <i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add Medication--><!--        </button>--><!--        <button type="button" class="btn btn-default"--><!--                ng-disabled="vm.getSelectedIds(vm.selected).length == 0"--><!--                ng-click="vm.discontinue()">--><!--            <i class="fa fa-ban" aria-hidden="true" style="color: #dd4b39"></i> Discontinue Multiple--><!--        </button>--><!--        <button type="button" class="btn btn-default"--><!--                ui-sref="admission-medication({id: vm.chart.id})">--><!--            <i class="fa fa-sign-in" aria-hidden="true" style="color: #00a7d0"></i> Admission Medications--><!--        </button>--><!--        <button type="button" class="btn btn-default"--><!--                ng-disabled="vm.getSelectedIds(vm.selected).length == 0"--><!--                ng-click="vm.fax()">--><!--            <i class="fa fa-edit" aria-hidden="true" style="color: #f39c12"></i> Fax Multiple--><!--        </button>--><!--        <button type="button" class="btn btn-default" ng-click="vm.history()">--><!--            <i class="fa fa-history" aria-hidden="true" style="color: #dd4b39"></i> History--><!--        </button>--><!--        <div class="btn-group dropup" uib-dropdown>--><!--            <udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom>--><!--        </div>--><!--    </div>--></div>');
$templateCache.put('app/entities/rcopia-sso-log/chart/rcopia-sso-log-chart.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-sso-log/detail/rcopia-sso-log-detail.html','<form name="vm.form.alcohol" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAlcoholLabel">{{vm.data.title}}</h4></div><div class="modal-body"><pre>{{vm.beautifiedXmlText}}</pre></div></form>');
$templateCache.put('app/entities/rcopia-sso-log/list/rcopia-sso-logs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-sso-url-log/list/rcopia-sso-url-logs.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/rcopia-sso-url-log/url/rcopia-sso-url-log-detail.html','<form role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAlcoholLabel">View</h4></div><div class="modal-body"><pre>{{vm.entity.data}}</pre></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div></form>');
$templateCache.put('app/entities/reaction/list/reaction.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/reaction/update/reaction-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myReactionLabel">Create or edit a Reaction</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reaction.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.reaction.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.reaction.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_reaction">Name:</label> <input type="text" class="form-control" name="name" id="field_reaction" required ng-model="vm.reaction.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.reaction.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.reaction.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.reaction.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/reconnect-care-credential/list/reconnect-care-credential.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/reconnect-care-credential/update/reconnect-care-credential-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myReconnectCareCredentialLabel">Create or edit a Reconnect Care Credential</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.reconnectCareCredential.username?(editForm.username.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_username">Username</label> <input type="text" class="form-control" name="username" id="field_username" required ng-model="vm.reconnectCareCredential.username"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.reconnectCareCredential.username"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.reconnectCareCredential.username && editForm.username.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.reconnectCareCredential.username">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.reconnectCareCredential.password?(editForm.password.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_password">Password</label> <input type="text" class="form-control" name="password" id="field_password" required ng-model="vm.reconnectCareCredential.password"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.reconnectCareCredential.password"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.reconnectCareCredential.password && editForm.password.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.reconnectCareCredential.password">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/relational/list/relational.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/relational/select/relational-select-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRelationalLabel">Select Rationale</h4></div><div class="modal-body"><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div></div></section></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/relational/update/relational-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRelationalLabel">Create or edit a Rationale</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.relational.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.relational.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.relational.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.relational.name"> <span class="help-block" ng-show="!vm.relational.name || editForm.name.$error.required">This field is required.</span></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.relational.relationalType || editForm.relationalType.$error.required?\'has-error\':(editForm.relationalType.$valid && editForm.relationalType.$dirty?\'has-success\':\'\')"><label class="control-label">Relational Type</label><br><select ng-model="vm.relational.relationalType" name="relationalType" id="relationalType" class="form-control" required><option value="MEDICATION">MEDICATION</option><option value="LABORATORY">LABORATORY</option></select> <span class="help-block" ng-show="!vm.relational.relationalType || editForm.relationalType.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/report/execute/report-execute-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Execute Report "{{vm.report.name}}"</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row condition-controls" id="report-condition" ng-repeat="item in vm.conditions"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="item.reportField !== null? (vm.form.reportCondition.$dirty?\'has-success\':\'\'):\'has-error\'"><label>Field:</label> <input type="text" class="form-control input-sm" disabled="disabled" ng-model="item.reportField.description"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label>Condition:</label> <select name="reportCondition{{$index}}" id="field_reportCondition{{$index}}" class="form-control input-sm" ng-model="item.reportCondition" disabled="disabled"><option></option><option value="BETWEEN" ng-if="item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Between</option><option value="EQUAL_TO" selected="selected">Equal to</option><option value="NOT_EQUAL_TO">Not equal to</option><option value="CONTAINS" ng-if="item.reportField.type === \'STRING\'">Contains</option><option value="LESSER_THAN" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Lesser than</option><option value="LESSER_THAN_OR_EQUAL_TO" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Lesser than or equal to</option><option value="GREATER_THAN" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Greater than</option><option value="GREATER_THAN_OR_EQUAL_TO" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Greater than or equal to</option><option value="IS_NULL">Is null</option><option value="IS_NOT_NULL">Is not null</option></select></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label>Value:</label> <select name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" class="form-control input-sm" ng-if="item.reportField.type === \'VALUE\' || item.reportField.type === \'ENUM\'" ng-model="item.reportValueObject" ng-options="i as i.value for i in vm.conditionValues[item.reportField.id] track by i.id" ng-disabled="item.reportField === null || item.reportCondition === null"><option value=""></option></select> <select name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" class="form-control input-sm" ng-if="item.reportField.type === \'BOOLEAN\'" ng-model="item.reportValue" ng-disabled="item.reportField === null || item.reportCondition === null"><option value="TRUE" ng-if="item.reportField.id !== \'ALLERGIES\' && item.reportField.id !== \'DIETS\' && item.reportField.id !== \'DIAGNOSES\'">TRUE</option><option value="FALSE" ng-if="item.reportField.id !== \'ALLERGIES\' && item.reportField.id !== \'DIETS\' && item.reportField.id !== \'DIAGNOSES\'">FALSE</option><option value="TRUE" ng-if="item.reportField.id === \'ALLERGIES\' || item.reportField.id === \'DIETS\' || item.reportField.id === \'DIAGNOSES\'">ACTIVE</option><option value="FALSE" ng-if="item.reportField.id === \'ALLERGIES\' || item.reportField.id === \'DIETS\' || item.reportField.id === \'DIAGNOSES\'">INACTIVE</option></select><div class="input-group input-group-sm pb-10" ng-if="item.reportField.type === \'DATETIME\'"><input name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" type="text" class="form-control" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.datetime[$index]" ng-model="item.reportValue"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datetime\', $index)"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm has-feedback pb-10" ng-if="item.reportField.type === \'DATE\'"><input name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" type="text" class="form-control" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.date[$index]" ng-model="item.reportValue"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\', $index)"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm has-feedback" ng-if="item.reportField.type === \'DATE\' && item.reportCondition === \'BETWEEN\'"><input name="{{vm.getFieldName($index)}}_2" id="{{vm.getFieldId($index)}}_2" type="text" class="form-control" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.date2[$index]" ng-model="item.reportValue2"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date2\', $index)"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm has-feedback pb-10" ng-if="item.reportField.type === \'DATETIME\' && item.reportCondition === \'BETWEEN\'"><input name="{{vm.getFieldName($index)}}_2" id="{{vm.getFieldId($index)}}_2" type="text" class="form-control" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.datetime2[$index]" ng-model="item.reportValue2" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock" required ng-class="item.reportValue2 ? (vm.form.reportCondition[vm.getFieldName($index) + \'_2\'].$dirty ? \'has-success\' : \'\') : \'has-error\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datetime2\', $index)"><i class="fa fa-calendar"></i></button></span></div><input name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" type="text" class="form-control input-sm has-feedback" ng-if="(item.reportField === null) || item.reportField.type === \'STRING\' || item.reportField.type === \'NUMERIC\'" ng-model="item.reportValue" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock"><ui-select name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" ng-if="item.reportField.type === \'VALUE_SEARCH\'" ng-model="item.reportValueObject" reset-search-input="true" close-on-select="true"><ui-select-match placeholder="Select ..." allow-clear="true">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="i in vm.conditionValues[item.reportField.id][$index] | filter: $select.search" refresh="vm.searchValuesByService(item, $index, $select.search)" refresh-delay="0"><div ng-bind-html="i.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div></div></div></div></div><div class="modal-footer"><!--                <button type="button" class="btn btn-danger btn-sm" wz-previous style="margin-right: auto"--><!--                        ng-disabled="vm.form.reportCondition.$invalid">--><!--                    <i class="fa fa-angle-left" aria-hidden="true"></i> Previous--><!--                </button>--> <button type="submit" class="btn btn-success btn-sm" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Execute</button></div></form>');
$templateCache.put('app/entities/report/list/report.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/report/update/report-edit-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.closeWizard()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create or Edit a Report</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="reportsWizard" on-finish="vm.finishedWizard()" indicators-position="top"><wz-step wz-title="Get Started"><ng-include src="\'app/entities/report/update/tpl/report-information-tpl.html\'"></ng-include><div class="modal-footer"><button type="submit" class="btn btn-success btn-sm" ng-disabled="vm.form.reportInformation.$invalid" wz-next>Next <i class="fa fa-angle-right" aria-hidden="true"></i></button></div></wz-step><wz-step wz-title="Columns"><ng-include src="\'app/entities/report/update/tpl/report-columns-tpl.html\'"></ng-include><div class="modal-footer"><button type="submit" class="btn btn-danger btn-sm" wz-previous style="margin-right: auto"><i class="fa fa-angle-left" aria-hidden="true"></i> Previous</button> <button type="button" class="btn btn-success btn-sm" ng-click="vm.nextToConditions()" ng-disabled="!vm.report.category.allowEmpty && vm.columns[1].items.length === 0" wz-next>Next <i class="fa fa-angle-right" aria-hidden="true"></i></button></div></wz-step><wz-step wz-title="Conditions"><ng-include src="\'app/entities/report/update/tpl/report-conditions-tpl.html\'"></ng-include><div class="modal-footer"><button type="button" class="btn btn-danger btn-sm" wz-previous style="margin-right: auto" ng-disabled="vm.form.reportCondition.$invalid"><i class="fa fa-angle-left" aria-hidden="true"></i> Previous</button> <button type="button" class="btn btn-success btn-sm" ng-disabled="vm.form.reportCondition.$invalid || (!vm.report.category.allowEmpty && vm.conditions.length === 0)" wz-finish><i class="fa fa-save" aria-hidden="true"></i> Finish</button></div></wz-step></wizard></div></div></div>');
$templateCache.put('app/entities/room/list/room.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/room/update/room-dialog.html','<form name="vm.form.room" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myRoomLabel">Create or edit a Room</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.room.name?(vm.form.room.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.room.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.room.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.room.name && vm.form.room.name.$dirty"></span> <span class="help-block" ng-show="!vm.room.name">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.room.sex?(vm.form.room.gender.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_gender">Gender:</label> <select class="form-control" id="field_gender" name="gender" required ng-model="vm.room.sex" ng-options="item as item for item in vm.gender track by item" ng-disabled="vm.patientLoaded"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.room.sex"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.room.sex && vm.form.room.gender.$dirty"></span> <span class="help-block" ng-show="!vm.room.sex">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.room.building?(vm.form.room.building.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_building">Building:</label> <select class="form-control" id="field_building" name="building" required ng-model="vm.room.building" ng-options="building as building.name for building in vm.buildings track by building.id"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.room.building"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.room.building && vm.form.room.building.$dirty"></span> <span class="help-block" ng-show="!vm.room.building">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.room.notes?(vm.form.room.notes.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_notes">Notes:</label> <textarea class="form-control" name="notes" id="field_notes" rows="5" data-resize="disabled" ng-model="vm.room.notes"></textarea> <span class="help-block help-warning" ng-show="!vm.room.notes">This field is suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.room.$invalid || vm.form.room.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/route/list/route.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/route/update/route-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Create or edit a Route</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.route.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.route.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.route.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.route.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.route.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.route.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.route.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/send-lab-compendium/list/send-lab-compendium.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/send-lab-compendium/update/send-lab-compendium-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Select Lab Compendium</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.sendLabCompendium.labCompendium?(editForm.labCompendium.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_labCompendium">Lab Compendium</label><ui-select name="labCompendium" id="field_labCompendium" required ng-model-options="{ debounce: 500 }" ng-disabled="!vm.sendLabCompendium.laboratory" ng-model="vm.sendLabCompendium.labCompendium" reset-search-input="true" close-on-select="true"><ui-select-match placeholder="LabCompendium...">{{$select.selected.code + \' \' + $select.selected.description}}</ui-select-match><ui-select-choices repeat="item in vm.labCompendiums | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.code | highlight: $select.search"></div><small ng-bind-html="item.description | highlight: $select.search"></small></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.sendLabCompendium.labCompendium"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.sendLabCompendium.labCompendium.name && editForm.labCompendium.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.sendLabCompendium.labCompendium">This field is required</span></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/session-type/list/session-type.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/session-type/update/session-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySessionTypeLabel">Create or edit a Session Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sessionType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.sessionType.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.sessionType.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.sessionType.name"> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/severity/list/severity.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/severity/update/severity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySeverityLabel">Create or edit a Severity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.severity.id"><label for="id">ID:</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.severity.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.severity.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.severity.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.severity.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.severity.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.severity.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/shift/detail/shift-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="shiftLabel">Viewing Shift</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="mb-15"><p class="mb-0 gtitle"><strong>Description:</strong></p><p class="mb-0 gtitle">{{vm.shift.description}}</p></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="row mb-15"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><p class="mb-0 gtitle"><strong>Shift Date:</strong></p><p class="mb-0 gtitle">{{vm.shift.dateCreated | amDateFormat: \'MM/DD/YYYY\'}}</p></div></div><div class="row mb-15"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><p class="mb-0 gtitle"><strong>Start:</strong></p><p class="mb-0 gtitle">{{vm.shift.startTime | amDateFormat: \'HH:MM:SS\'}}</p></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><p class="mb-0 gtitle"><strong>End:</strong></p><p class="mb-0 gtitle">{{vm.shift.endTime | amDateFormat: \'HH:MM:SS\'}}</p></div></div><div class="row mb-15"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><p class="mb-0 gtitle"><strong>Shift Type:</strong></p><p class="mb-0 gtitle">{{vm.shift.shiftType.name?vm.entity.shiftType.name:\'-\'}}</p></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><p class="mb-0 gtitle"><strong>Building:</strong></p><p class="mb-0 gtitle">{{vm.shift.building.name?vm.entity.building.name:\'-\'}}</p></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h3 class="mb-0"><strong>Employees:</strong></h3><hr></div></div><!--ng-include for employees view--><ng-include src="\'app/entities/shift/tpl/employees-view.html\'"></ng-include><div class="row" ng-hide="vm.visibilityToggleTable"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h3 class="mb-0"><strong>Patients:</strong></h3><hr></div></div><!--ng-include for patients view--><ng-include src="\'app/entities/shift/tpl/attendees-view.html\'"></ng-include><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div><div class="well signs-array"><div class="sign-item mb-15" ng-if="vm.shift.shiftEmployeeSignature"><figure><img ng-src-sign="{{vm.shift.shiftEmployeeSignatureId}}" id="signatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Employee: {{vm.shift.shiftEmployee.firstName + \' \' + vm.shift.shiftEmployee.lastName}}, Date: {{vm.shift.shiftEmployeeSignature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.shift.shiftReviewerSignature"><figure><img ng-src-sign="{{vm.shift.shiftReviewerSignatureId}}" id="shiftReviewerSignatureId" alt="Reviewer Signature" width="300" class="img-responsive"><figcaption>Reviewer: {{vm.shift.shiftReviewerSignature.createdBy}}, Date: {{vm.shift.shiftReviewerSignature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button></div>');
$templateCache.put('app/entities/shift/list/shift.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/shift/tpl/add-patient.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><label>Patients to Add:</label><ui-select id="field_patients" name="patients" multiple="multiple" title="Patients" ng-model="vm.addedPatients" close-on-select="false"><ui-select-match placeholder="{{vm.newPatientsConverted.length?\'Click to select patients...\':\'There is no patients to add...\'}}">{{$item.chart.firstName + \' \' + $item.chart.lastName}}</ui-select-match><ui-select-choices repeat="item in vm.newPatientsConverted | filter:$select.search" refresh="" refresh-delay="1"><div ng-bind-html="item.chart.mrNo + \' - \' +item.chart.firstName + \' \' + item.chart.lastName"></div></ui-select-choices></ui-select></div><div class="col-xs-12 col-sm-12 col-md-9 col-lg-9 mb-15"><button type="button" id="addPatient" class="btn btn-info btn-block" ng-click="vm.addPatients()" ng-disabled="!(vm.addedPatients.length > 0)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Patients</button></div><div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 mb-15"><button type="button" ng-if="vm.addPatient" class="btn btn-danger btn-block" ng-click="vm.addPatient = !vm.addPatient;vm.addedPatients = [];" title="Cancel"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/shift/tpl/assign-reviewer.html','<button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button><form id="assign-reviewer"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="field_reviewers">Please, select a reviewer:</label><ui-select id="field_reviewers" name="reviewers" multiple="multiple" title="Reviewers" ng-model="vm.shift.shiftReviewers" close-on-select="false" required="true"><ui-select-match placeholder="Reviewers...">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="item in vm.reviewers | filter:$select.search">{{item.firstName +\' \'+ item.lastName}}</ui-select-choices></ui-select><span class="help-block" ng-show="!(vm.shift.shiftReviewers.length > 0)">This field is required</span></div></div></form><div ng-include="\'app/entities/shift/tpl/steps.html\'"></div><button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-click="vm.save()" ng-if="vm.isShiftReviewer"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.saveReviewers()" ng-disabled="!vm.shift.shiftReviewers"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/shift/tpl/attendees-view.html','<div class="box-body" ng-hide="vm.visibilityToggleTable"><table class="table align-cells-vertical"><thead><tr><!--<th>ID</th>--><th>Mr No.</th><th>Name</th><th>Head Count</th><th>Notes</th></tr></thead><tbody><tr ng-if="!vm.shift.shiftCharts.length"><td class="text-center">There is not patients assigned ...</td></tr><tr ng-repeat="item in vm.shift.shiftCharts track by item.id"><!--<td class="icon"><p><strong>{{item.id}}</i></strong></p></td>--><td class="icon">{{item.chart.mrNo}}</td><td class="text-left">{{item.chart.firstName + \' \' + item.chart.lastName}}</td><td class="text-left"><small ng-if="item.headCount" class="label label-success">Yes</small> <small ng-if="!item.headCount" class="label label-danger">No</small></td><td class="text-left"><p ng-repeat="value in item.shiftNotes track by value.id">{{value.note}}</p><p ng-if="!item.shiftNotes[0].note">No notes added</p></td></tr></tbody></table><div class="text-center" ng-hide="vm.visibilityToggleTable"><ul uib-pagination class="dash-pagination pagination-sm pt-15 pb-15" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.loadPage()"></ul></div></div>');
$templateCache.put('app/entities/shift/tpl/attendees.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15 text-center"><button type="button" class="btn btn-success" ng-if="!vm.addPatient && !vm.savedWithSign" ng-click="vm.patientsForm()" ng-hide="vm.visibilityToggleTable" uib-tooltip="Add Patient to Shift" title="Add Patient"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Patients to Shift</button></div></div><ng-include src="\'app/entities/shift/tpl/add-patient.html\'" ng-show="vm.addPatient"></ng-include><div class="box-body" ng-hide="vm.visibilityToggleTable"><table class="table table-striped align-cells-vertical"><thead><tr><!--<th>ID</th>--><th>Mr No.</th><th>Name</th><th>Present</th><th>Last Added Note</th><th>Actions</th></tr></thead><tbody><tr ng-if="!vm.shiftChartPatients.length"><td colspan="6"><p ng-if="!vm.shiftChartPatients.length">No patients added</p></td></tr><tr ng-repeat="item in vm.shiftChartPatients track by item.chart.id "><td class="col-mrnumber">{{item.chart.mrNo}}</td><td class="text-left col-name">{{item.chart.firstName + \' \' + item.chart.lastName}}</td><td class="text-left col-present"><toggle id="field_headCount" ng-model="item.headCount" ng-disabled="vm.savedWithSign" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No" ng-change="vm.present(item, false)"></toggle></td><td class="text-left col-notes"><div class="shift-notes" ng-class="{\'has-footer\': (item.shiftNotes.length > 0) && vm.checkEditableNotes(item) && !item.closeCustomNote}"><p class="note-preview" ng-if="(item.shiftNotes.length > 0) && vm.checkEditableNotes(item)" ng-show="item.addCustomNote">{{vm.showLastEditableNote(item)}}</p><p ng-if="!vm.checkEditableNotes(item)" ng-show="item.addCustomNote" ng-click="vm.newNoteCreation(item)">Add a note...</p><textarea class="form-control" ng-show="item.closeCustomNote" data-resize="disabled" ng-model="item.note">\n                        </textarea><div class="small-footer" ng-if="item.addCustomNote && vm.checkEditableNotes(item)"><span class="notes-count">{{vm.getEditableNotes(item)}} <strong>Notes</strong></span> <span class="view-all" uib-tooltip="View All Notes" ng-click="vm.crudNote(item)">View All <i class="fa fa-angle-right" aria-hidden="true"></i></span></div></div></td><td class="col-btns"><button type="button" class="btn btn-default new" uib-tooltip="Create a new Note" ng-show="item.addCustomNote" ng-click="vm.newNoteCreation(item)" ng-disabled="vm.savedWithSign"><i class="fa fa-plus" aria-hidden="true"></i></button> <button type="button" class="btn btn-default edit" uib-tooltip="Edit a saved note" ng-click="vm.crudNote(item);" ng-if="vm.checkEditableNotes(item) && !item.closeCustomNote" ng-disabled="vm.savedWithSign"><i class="fa fa-edit" aria-hidden="true"></i></button> <button type="button" class="btn btn-default save" uib-tooltip="Save note" ng-show="item.closeCustomNote" ng-click="vm.newNoteCreation(item)" ng-disabled="vm.savedWithSign"><i class="fa fa-save" aria-hidden="true"></i></button> <button type="button" class="btn btn-default cancel" uib-tooltip="Cancel New Note" ng-show="item.closeCustomNote" ng-click="vm.cancelNewNote(item)"><i class="fa fa-ban" aria-hidden="true"></i></button> <button type="button" class="btn btn-default delete" uib-tooltip="Delete Patient" ng-click="vm.deletePatient(item)" ng-disabled="vm.savedWithSign"><i class="fa fa-trash" aria-hidden="true"></i></button></td></tr></tbody></table><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm pb-15" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.loadPage()"></ul></div></div><div ng-include="\'app/entities/shift/tpl/steps.html\'"></div><div ng-include="\'app/entities/shift/tpl/notes.html\'" ng-show="vm.visibilityToggleTable"></div><button type="submit" ng-if="(vm.isShiftEmployee || vm.isShiftReviewer)" class="btn btn-warning move-btn next-btn" ng-click="vm.closeAllNotes();vm.load();" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button><div class="modal-footer"><button type="submit" class="btn btn-success" ng-hide="vm.visibilityToggleTable" ng-click="vm.saveClose()"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-hide="vm.visibilityToggleTable" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/shift/tpl/basic-info.html','<fieldset ng-disabled="vm.savedWithSign"><form name="vm.form" id="basic-info-shift-creation"><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.shift.description?(vm.form.description.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_description">Description:</label> <textarea class="form-control" name="description" id="field_description" rows="8" required data-resize="disabled" ng-model="vm.shift.description">\n                    </textarea> <span class="help-block" ng-show="!vm.shift.description">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="!vm.shift.dateCreated || vm.form.shift.dateCreated.$invalid?\'has-error\':(vm.shift.dateCreated && vm.form.shift.dateCreated.$dirty?\'has-success\':\'\')"><label for="field_dateCreated">Date of Shift:</label><div class="input-group input-group-sm"><input id="field_dateCreated" type="text" class="form-control" name="date" required ng-model="vm.shift.dateCreated" uib-datepicker-popup="{{inputDateFormat}}" datepicker-options="dateOptions" is-open="vm.datePickerOpenStatus.date" validator="required" message-id="msg-shift-date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button></span></div><!--<span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true"--><!--ng-show="!vm.shift.dateCreated || vm.form.shift.dateCreated.$invalid"></span>--><!--<span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true"--><!--ng-show="vm.shift.dateCreated && vm.form.shift.dateCreated.$dirty"></span>--> <span class="help-block" ng-show="!vm.shift.dateCreated || vm.form.shift.dateCreated.$invalid">This field is required</span></div><div class="row"><div class="col-md-6 col-lg-6 form-group has-feedback" ng-class="!vm.shift.startTime || vm.form.shift.startTime.$invalid?\'has-error\':(vm.shift.startTime && vm.form.shift.startTime.$dirty?\'has-success\':\'\')"><label for="field_startTime">Start Time:</label><div uib-timepicker name="start" required ng-model="vm.shift.startTime" show-meridian="true" id="field_startTime"></div><span class="help-block" ng-show="!vm.shift.startTime">This field is required</span></div><div class="col-md-6 col-lg-6 form-group has-feedback" ng-class="!vm.shift.endTime || vm.form.shift.endTime.$invalid?\'has-error\':(vm.shift.endTime && vm.form.shift.endTime.$dirty?\'has-success\':\'\')"><label for="field_endTime">End Time:</label><div uib-timepicker name="stop" required min="vm.shift.startTime+1" ng-model="vm.shift.endTime" show-meridian="true" id="field_endTime"></div><span class="help-block" ng-show="!vm.shift.endTime">This field is required</span></div></div></div></div><!--/row --><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.shift.building?\'has-success\':\'has-error\'"><label for="field_building">Building:</label> <select class="form-control" id="field_building" name="building" ng-model="vm.shift.building" ng-options="building as building.name for building in vm.buildings track by building.id" required><option value=""></option></select> <span class="help-block" aria-hidden="true" ng-show="!vm.shift.building">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.shift.shiftType?\'has-success\':\'has-error\'"><label for="field_shiftType">Shift Type:</label> <select class="form-control" id="field_shiftType" name="shiftType" ng-model="vm.shift.shiftType" ng-options="shiftType as shiftType.name for shiftType in vm.shifttypes track by shiftType.id" required><option value=""></option></select> <span class="help-block" aria-hidden="true" ng-show="!vm.shift.shiftType">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.shift.typeLevelCares.length > 0?\'has-success\':\'has-error\'"><label for="field_typeLevelCare">Type Level Care:</label><ui-select id="field_typeLevelCare" multiple="multiple" required name="typeLevelCare" title="Type Level Care" ng-model="vm.shift.typeLevelCares" close-on-select="false"><ui-select-match placeholder="{{vm.typelevelcares.length?\'Select Level of cares...\':\'There is no LevelTypeCares to add...\'}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.typelevelcares | filter:$select.search" refresh="" refresh-delay="1"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select><span class="help-block" ng-show="!(vm.shift.typeLevelCares.length > 0)">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group has-feedback" ng-class="vm.shift.employees.length > 0?\'has-success\':\'has-error\'"><label for="field_employee">Employees:</label><ui-select id="field_employee" multiple="multiple" required name="employee" title="Employees" ng-model="vm.shift.employees" close-on-select="false" ng-model-options="{ debounce: 300 }"><ui-select-match placeholder="{{vm.employees.length?\'Select Employees...\':\'There is no Employees to add...\'}}">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="item in vm.employees | filter:$select.search" refresh="vm.getEmployees($select.search)" refresh-delay="1"><div ng-bind-html="item.firstName + \' \' + item.lastName"></div></ui-select-choices></ui-select><span class="help-block" ng-show="!(vm.shift.employees.length > 0)">This field is required</span></div></div></div></form></fieldset><!--ng-disabled="vm.shift.description || !vm.shift.startTime || !vm.shift.endTime || !(vm.shift.employees.length > 0)"--> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-click="vm.save()" ng-disabled="vm.form.$error.required || !vm.shift.startTime || !vm.shift.endTime"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.saveClose()" ng-disabled="vm.form.$error.required || !vm.shift.startTime || !vm.shift.endTime"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/shift/tpl/employee-signature.html','<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.shiftEmployeeSignature"><!--ng-class="vm.staffReviewSignature.sig == null && vm.staffReviewSignature.pin == null ? \'has-error\' : \'has-success\'"--><div class="form-group form-group-sm centered drawer-sign"><label for="shiftEmployeeSignaturePin">Please, enter your personal PIN:</label> <input type="password" maxlength="4" minlength="4" id="shiftEmployeeSignaturePin" name="shiftEmployeeSignaturePin" class="form-control" placeholder="PIN" pattern="\\d{4}" ng-model="vm.shiftEmployeeSignaturePin" ng-required="vm.shift.shiftEmployee == null" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.shiftEmployeeSignaturePin"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature name="shiftEmployee_signature" ng-model="vm.shiftEmployeeSignature" options="vm.signatureOpts" ng-disabled="vm.shift.shiftEmployeeSignature?true:false"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_chartSignatureAgree"><input type="checkbox" name="chartSignatureAgree" id="field_chartSignatureAgree" ng-model="vm.shiftEmployeeSignatureAgree" ng-disabled="vm.shift.shiftEmployeeSignature"> I, {{vm.shift.shiftEmployee.firstName + \' \' + vm.shift.shiftEmployee.lastName}}, have reviewed, agree and understand the information contained here in the {{vm.shift.description}}.</label></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30" ng-if="!vm.shift.shiftEmployeeSignature"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-click="vm.isPinCorrect()" ng-disabled="(!vm.shiftEmployeeSignatureAgree || !vm.shiftEmployeeSignature || vm.shiftEmployeeSignature.length == 0) && (!vm.shiftEmployeeSignatureAgree || !vm.shiftEmployeeSignaturePin)"><i class="fa fa-check"></i> Sign</button></div></div><div ng-include="\'app/entities/shift/tpl/steps.html\'"></div><button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-if="(vm.shift.shiftEmployee && vm.shift.shiftEmployeeSignature)" ng-click="vm.removeFromReviewers()"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/shift/tpl/employees-view.html','<div class="box-body"><table class="table table-striped align-cells-vertical"><thead><tr><!--<th>ID</th>--><th class="text-center">First Name</th><th class="text-center">Last Name</th><!--<th class="text-center">Phone Number</th>--><th class="text-center">Email</th></tr></thead><tbody><tr ng-if="!vm.shift.employees.length"><td class="text-center">There is not employees ...</td></tr><tr ng-repeat="item in vm.shift.employees"><!--<td class="icon"><p><strong>{{item.id}}</i></strong></p></td>--><td class="text-center">{{item.firstName}}</td><td class="text-center">{{item.lastName}}</td><!--<td class="text-center">--><!--{{item.mobile}}--><!--</td>--><td class="text-center">{{item.email}}</td></tr></tbody></table></div>');
$templateCache.put('app/entities/shift/tpl/notes.html','<!--CODE TO ADD PREDEFINED NOTES--><!--<button type="button"--><!--ng-if="!vm.addNotes"--><!--class="btn btn-success"--><!--ng-click="vm.notesForm()"--><!--title="Add Notes">--><!--<i class="fa fa-plus-circle"></i>--><!--</button>--><!--<button type="button"--><!--ng-if="vm.addNotes"--><!--class="btn btn-danger"--><!--ng-click="vm.addNotes = !vm.addNotes; vm.newNotes = []"--><!--title="Cancel">--><!--<i class="fa fa-minus-circle"></i>--><!--</button>--><!--<ng-include src="\'app/entities/shift/tpl/add-notes.html\'"--><!--ng-show="vm.addNotes">--><!--</ng-include>--><div class="box-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table class="table align-cells-vertical"><thead><tr><!--<th>ID</th>--><th>Note</th><th>Created Date</th><th>Actions</th></tr></thead><tbody><tr ng-if="!vm.thisChartNotes.length"><td colspan="6"><p ng-if="!vm.thisChartNotes.length">No Notes added</p></td></tr><tr ng-repeat="item in vm.thisChartNotes track by item.id " ng-if="!item.delStatus"><!--<td class="icon"><p><strong>{{item.id}}</i></strong></p></td>--><td class=""><p ng-hide="item.editVisibility">{{item.note}}</p><textarea class="form-control" ng-show="item.editVisibility" data-resize="disabled" ng-model="item.note">\n                            </textarea></td><td class="col-dates">{{item.createdDate | date:\'MM/dd/yyyy hh:mm a\'}}</td><td class="col-btns"><button type="button" class="btn btn-default edit" uib-tooltip="Edit note" ng-show="!item.editVisibility" ng-click="vm.editNote(item)"><i class="fa fa-edit"></i></button> <button type="button" class="btn btn-default save" uib-tooltip="Save note" ng-show="item.editVisibility" ng-click="vm.saveChangedNote(item)"><i class="fa fa-floppy-o"></i></button> <button type="button" class="btn btn-default cancel" uib-tooltip="Cancel note edition" ng-show="item.editVisibility" ng-click="vm.cancelNewNote(item)"><i class="fa fa-ban" aria-hidden="true"></i></button> <button type="button" class="btn btn-default delete" uib-tooltip="Delete note" ng-click="vm.deleteNote(item)"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div></div><!-- /row --><hr><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><h4><strong>Add a Note:</strong></h4><textarea id="Custom_Note" name="customNote" class="form-control mb-15" placeholder="Add new note here..." rows="4" data-resize="disabled" ng-model="vm.customNote">\n         </textarea> <button type="button" class="btn btn-success btn-block save-note-btn" ng-click="vm.addNotesToPatients()"><i class="fa fa-save" aria-hidden="true"></i> Save</button></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"></div></div><!-- box-body --><div class="modal-footer"><button type="submit" class="btn btn-warning" ng-click="vm.switchingBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Go back</button></div>');
$templateCache.put('app/entities/shift/tpl/reviewer-signature.html','<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.shiftReviewerSignature"><div class="form-group form-group-sm centered drawer-sign"><label for="reviewerSignaturePin">Please, enter your personal PIN:</label> <input type="password" maxlength="4" minlength="4" id="reviewerSignaturePin" name="reviewerSignaturePin" class="form-control" placeholder="PIN" pattern="\\d{4}" ng-model="vm.shiftReviewerSignaturePin" ng-required="vm.shift.shiftReviewerSignature == null" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.shiftReviewerSignaturePin"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature name="reviewer_signature" ng-model="vm.shiftReviewerSignature" options="vm.signatureOpts" ng-disabled="vm.entity.reviewerSignature"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_reviewerSignatureAgree"><input type="checkbox" name="field_reviewerSignatureAgree" id="field_reviewerSignatureAgree" ng-disabled="vm.shift.shiftReviewerSignature" ng-model="vm.shiftReviewerSignatureAgree"> I, {{vm.employee.firstName + \' \' + vm.employee.lastName}} , have reviewed, agree and understand the information contained here in the {{vm.shift.description}}.</label></div></div><div ng-include="\'app/entities/shift/tpl/steps.html\'"></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30" wz-next ng-hide="vm.entity.reviewerSignature"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-click="vm.isPinCorrect()" ng-disabled="(!vm.shiftReviewerSignatureAgree || !vm.shiftReviewerSignature || vm.shiftReviewerSignature.length == 0) && (!vm.shiftReviewerSignatureAgree || !vm.shiftReviewerSignaturePin)"><i class="fa fa-check"></i> Sign</button></div></div>');
$templateCache.put('app/entities/shift/tpl/steps.html','<button type="button" class="btn btn-warning move-btn previous-btn" wz-previous ng-click="vm.visibilityToggleTable = false;vm.addPatient = false;vm.closeAllNotes();"><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/shift-type/list/shift-type.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/shift/update/shift-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Event Wizard</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="gsWizard" on-finish="vm.finishedWizard()" on-cancel="vm.cancelledWizard()" indicators-position="top"><wz-step wz-title="Get Started"><ng-include src="\'app/entities/shift/tpl/basic-info.html\'"></ng-include></wz-step><wz-step wz-title="Attendees"><ng-include src="\'app/entities/shift/tpl/attendees.html\'"></ng-include></wz-step><wz-step wz-title="Employee Signature" ng-if="(vm.isShiftEmployee || vm.isShiftReviewer)"><ng-include src="\'app/entities/shift/tpl/employee-signature.html\'"></ng-include></wz-step><wz-step wz-title="Assign Reviewer" ng-if="vm.showPages"><ng-include src="\'app/entities/shift/tpl/assign-reviewer.html\'"></ng-include></wz-step><wz-step wz-title="Reviewer Signature" ng-if="vm.isShiftReviewer"><ng-include src="\'app/entities/shift/tpl/reviewer-signature.html\'"></ng-include></wz-step></wizard></div></div></div>');
$templateCache.put('app/entities/shift-type/update/shift-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myShiftTypeLabel">Create or edit a Shift Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.shiftType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.shiftType.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="vm.shiftType.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.shiftType.name" required> <span class="help-block" ng-show="editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/specimen/list/specimen.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/specimen/update/specimen-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySpecimeLabel">Create or edit a Specimen</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.specimen.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.specimen.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.specimen.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.specimen.name"> <span class="help-block" ng-show="!vm.specimen.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/super-bill/search-select/search-select.html','<div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="{{placeholder}}" ng-model="searchQuery" ng-focus="$scope.isOpen = true" ng-model-options="{ debounce: 300 }"> <span class="input-group-btn" uib-dropdown auto-close="disabled" is-open="$scope.isOpen"><button type="button" class="btn btn-primary" uib-dropdown-toggle><i class="fa fa-angle-down" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu><li role="menuitem"><div class="search-dropdown"><div class="search-options"><uib-tabset active="0" justified="true"><uib-tab ng-repeat="($index, tab) in tabsConf" index="$index" select="getOptions(tab)"><uib-tab-heading><i class="{{tab.icon}}" aria-hidden="true"></i> {{tab.name}}</uib-tab-heading><ul class="list-unstyled"><li class="checkbox" ng-repeat="($index, option) in tab.options" index="$index"><label><input type="checkbox" id="field_checkbox{{$index}}" name="checkbox{{$index}}" ng-model="selected.value[option.id]" ng-change="check(option, selected.value[option.id])"> <span ng-bind-html="getSelectTitleValue(option)"></span></label></li></ul></uib-tab></uib-tabset></div><footer class="dropdown-footer"><button type="button" class="btn btn-success btn-sm" ng-click="onSelectFn()">Add Selected</button></footer></div></li></ul></span></div>');
$templateCache.put('app/entities/telehealth/choose/telehealth-meeting-choose-edit-dialog.html','<form name="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Confirm edit operation</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><input type="radio" id="meeting" name="meeting" value="meeting" ng-model="vm.value"> <label style="font-size: 16px;" for="meeting">This Meeting</label></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><input type="radio" id="allMeetings" name="allMeetings" value="allMeetings" ng-model="vm.value"> <label style="font-size: 16px;" for="allMeetings">This Meeting and recurrence</label></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.edit()"><i class="fa fa-edit" aria-hidden="true"></i> Edit</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/telehealth/create/telehealth-meeting-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTrackLabel">Schedule Meeting</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.topic?(editForm.topic.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_input_topic">Topic:</label> <input type="text" id="field_input_topic" class="form-control" placeholder="Enter Topic..." name="topic" ng-model="vm.telehealthMeeting.topic" required> <span class="help-block" ng-show="!vm.telehealthMeeting.topic || editForm.topic.$error.required">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="field_input_description">Description:</label> <textarea id="field_input_description" class="form-control" placeholder="Description..." rows="4" name="description" data-resize="disabled" ng-model="vm.telehealthMeeting.description"></textarea></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.startDate?\'has-success\':\'has-error\'"><label for="field_input_start_date">Start Date:</label><div class="input-group"><input id="field_input_start_date" type="text" class="form-control" name="startDateTime" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.telehealthMeeting.startDate" is-open="vm.datePickerOpenStatus.startDateTime" datepicker-options="vm.datePickerOptions.startDateTime" ng-change="vm.startDateChanged()" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDateTime\')"><i class="fa fa-calendar"></i></button> </span><span class="help-block" ng-show="!vm.telehealthMeeting.startDate || editForm.startDateTime.$error.required">This field is required.</span></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.timeZone?(editForm.timeZone.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_input_timezone">Time Zone:</label><ui-select ng-model="vm.telehealthMeeting.timeZone" name="timeZone" id="field_input_timezone" close-on-select="true" required><ui-select-match placeholder="Select time zone ...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="timeZone in vm.timeZones | filter: $select.search"><div ng-bind-html="timeZone | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block" ng-show="!vm.telehealthMeeting.timeZone || editForm.timeZone.$error.required">This field is required.</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.duration?\'has-success\':\'has-error\'"><label for="field_input_duration">Duration minutes:</label> <input type="number" id="field_input_duration" class="form-control" min="1" name="duration" ng-model="vm.telehealthMeeting.duration" required> <span class="help-block" ng-show="!vm.telehealthMeeting.duration || editForm.duration.$error.required">This field is required.</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.host?(editForm.host.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_input_host">Host:</label><ui-select name="host" id="field_input_host" title="Select host..." ng-model="vm.telehealthMeeting.host" reset-search-input="true" close-on-select="true" required><ui-select-match allow-clear="true" placeholder="Select host...">{{$select.selected.lastName + \', \' + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | filter: $select.search" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="help-block" ng-show="!vm.telehealthMeeting.host || editForm.host.$error.required">This field is required.</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback"><label for="field_input_password">Password:</label><div class="input-group"><input ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" id="field_input_password" class="form-control" name="password" placeholder="Meeting password..." ng-model="vm.telehealthMeeting.password" autocomplete="new-password"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.showPassword = !vm.showPassword"><i class="fa" aria-hidden="true" ng-class="vm.showPassword?\'fa-eye\':\'fa-eye-slash\'"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Recurrences:</label><br><div class="btn-group"><label class="btn btn-default" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'NONE\'?\'btn-warning\':\'btn-default\'" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency" uib-btn-radio="\'NONE\'"><i class="fa" aria-hidden="true" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'NONE\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> None</label> <label class="btn btn-default" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'DAILY\'?\'btn-warning\':\'btn-default\'" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency" uib-btn-radio="\'DAILY\'" ng-click="vm.recurrenceChanged(\'days\')"><i class="fa" aria-hidden="true" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'DAILY\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Daily</label> <label class="btn btn-default" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'WEEKLY\'?\'btn-warning\':\'btn-default\'" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency" uib-btn-radio="\'WEEKLY\'" ng-click="vm.recurrenceChanged(\'weeks\')"><i class="fa" aria-hidden="true" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'WEEKLY\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Weekly</label> <label class="btn" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'MONTHLY\'?\'btn-warning\':\'btn-default\'" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency" uib-btn-radio="\'MONTHLY\'" ng-click="vm.recurrenceChanged(\'months\')"><i class="fa" aria-hidden="true" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'MONTHLY\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Monthly</label> <label class="btn" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'CUSTOM\'?\'btn-warning\':\'btn-default\'" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency" uib-btn-radio="\'CUSTOM\'"><i class="fa" aria-hidden="true" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'CUSTOM\'?\'fa-check-circle-o\':\'fa-circle-o\'"></i> Custom</label></div></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'DAILY\' || vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'WEEKLY\' || vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'MONTHLY\'"><label for="field_input_recurrence_end">End Recurrence:</label><div class="form-group has-feedback"><select class="form-control" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.end" id="field_input_recurrence_end" name="recurrenceEnd"><option value="RECURRENCE">Recurrence</option><option value="DATE">Date</option></select></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.end === \'RECURRENCE\' && (vm.telehealthMeeting.telehealthMeetingRecurrence.frequency ===\'DAILY\' ||\n                        vm.telehealthMeeting.telehealthMeetingRecurrence.frequency ===\'WEEKLY\' ||\n                        vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'MONTHLY\')"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.repeat ? \'has-success\' : \'has-error\'"><label for="field_input_recurrence_repeat">Repeat every:</label> <input type="number" id="field_input_recurrence_repeat" class="form-control" min="1" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.repeat" name="recurrenceRepeat" required> <span class="help-block" ng-show="!vm.telehealthMeeting.telehealthMeetingRecurrence.repeat || editForm.recurrenceRepeat.$error.required">This field is required.</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.end === \'DATE\' && (vm.telehealthMeeting.telehealthMeetingRecurrence.frequency ===\'DAILY\' ||\n                        vm.telehealthMeeting.telehealthMeetingRecurrence.frequency ===\'WEEKLY\' ||\n                        vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'MONTHLY\')"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.telehealthMeetingRecurrence.endDate ? \'has-success\' : \'has-error\'"><label for="field_input_recurrence_end_date">End Date:</label><div class="input-group"><input id="field_input_recurrence_end_date" type="text" class="form-control" name="recurrenceEndDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.telehealthMeeting.telehealthMeetingRecurrence.endDate" is-open="vm.datePickerOpenStatus.recurrenceEndDate" datepicker-options="vm.datePickerOptions.recurrenceEndDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'recurrenceEndDate\')"><i class="fa fa-calendar"></i></button> </span><span class="help-block" ng-show="!vm.telehealthMeeting.telehealthMeetingRecurrence.endDate || editForm.recurrenceEndDate.$error.required">This field is required.</span></div></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency ===\'WEEKLY\'"><div class="form-group has-feedback" ng-class="vm.weekDays.length !== 0 ? \'has-success\' : \'has-error\'"><label for="field_input_weekdays">Choose week days:</label><br><ui-select id="field_input_weekdays" name="weekDays" multiple="multiple" required ng-model="vm.weekDays" close-on-select="false" title="Schedule"><ui-select-match placeholder="Select week days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search">{{day}}</ui-select-choices></ui-select><span class="help-block" ng-show="vm.weekDays.length === 0">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'CUSTOM\'"><label for="field_input_custom_date_time">Choose dates:</label><div class="input-group"><input id="field_input_custom_date_time" type="text" class="form-control" name="customDateTime" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.customDatePicked" is-open="vm.datePickerOpenStatus.customDateTime" datepicker-options="vm.datePickerOptions.customDateTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'customDateTime\')"><i class="fa fa-calendar"></i></button></span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'CUSTOM\'"><div class="form-group"><label for="field_input_custom_selected_date_time">Date selected:</label><div class="input-group"><input type="text" class="form-control" id="field_input_custom_selected_date_time" name="customSelectedDateTime" value="{{vm.customDatePicked | date: \'MM/dd/yyyy hh:mm a\' }}" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-success" ng-disabled="!vm.customDatePicked" ng-click="vm.addCustomDate(vm.customDatePicked)"><i class="fa fa-plus-circle" aria-hidden="true"></i></button></span></div></div><div class="form-group recurrences-list" ng-if="vm.telehealthMeeting.telehealthMeetingRecurrence.frequency === \'CUSTOM\'"><label>Dates List:</label><ul class="list-unstyled"><li role="listitem" ng-repeat="date in vm.customRecurrences"><span>{{date | date: \'MM/dd/yyyy hh:mm a\' }}</span> <a ng-click="vm.deleteCustomDate($index)"><i class="fa fa-times" aria-hidden="true"></i></a></li></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Schedule</button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/telehealth/detail/telehealth-meeting-detail-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTrackLabel">Meeting Details</h4></div><div class="modal-body tele-participants"><div class="table-responsive table-small-font"><table class="table table-condensed table-bordered"><thead><tr class="active"><th><strong>Meeting Id</strong></th><th><strong>Topic</strong></th><th><strong>Host</strong></th><th><strong>Start Dates</strong></th><th ng-if="vm.telehealthMeeting.status === \'IN_PROGRESS\'"><strong>Password</strong></th><th ng-if="vm.telehealthMeeting.status === \'COMPLETED\'"><strong>End Date</strong></th><th ng-if="vm.telehealthMeeting.status === \'COMPLETED\'"><strong>Duration</strong></th><th><strong>Participants</strong></th></tr></thead><tbody><tr><td>{{vm.telehealthMeeting.twilioRoomName}}</td><td>{{vm.telehealthMeeting.topic}}</td><td>{{vm.telehealthMeeting.host.lastName + \', \' + vm.telehealthMeeting.host.firstName}}</td><td>{{vm.telehealthMeeting.startDate | date: inputDateTimeFormatA}}</td><td ng-if="vm.telehealthMeeting.status === \'IN_PROGRESS\'">{{vm.telehealthMeeting.password ? vm.telehealthMeeting.password : \'-\'}}</td><td ng-if="vm.telehealthMeeting.status === \'COMPLETED\'">{{vm.telehealthMeeting.endDate | date: inputDateTimeFormatA}}</td><td ng-if="vm.telehealthMeeting.status === \'COMPLETED\'">{{vm.telehealthMeeting.duration}}</td><td>{{vm.telehealthMeeting.participants}}</td></tr></tbody></table></div><hr><div class="tele-participants-header"><div class="control-search"><div class="input-group"><input type="text" class="form-control" placeholder="Search Participants..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></div></div><div class="table-responsive table-small-font"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered table-condensed"></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.close()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/telehealth/edit/telehealth-meeting-edit-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTrackLabel">Edit Meeting</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.topic?(editForm.topic.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_input_topic">Topic:</label> <input type="text" id="field_input_topic" class="form-control" placeholder="Enter Topic..." name="topic" ng-model="vm.telehealthMeeting.topic" required> <span class="help-block" ng-show="!vm.telehealthMeeting.topic || editForm.topic.$error.required">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="field_input_description">Description:</label> <textarea id="field_input_description" class="form-control" placeholder="Description..." rows="4" name="description" data-resize="disabled" ng-model="vm.telehealthMeeting.description"></textarea></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.startDate?\'has-success\':\'has-error\'"><label for="field_input_start_date">Start Date:</label><div class="input-group"><input id="field_input_start_date" type="text" class="form-control" name="startDateTime" datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.telehealthMeeting.startDate" is-open="vm.datePickerOpenStatus.startDateTime" datepicker-options="vm.datePickerOptions.startDateTime" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDateTime\')"><i class="fa fa-calendar"></i></button> </span><span class="help-block" ng-show="!vm.telehealthMeeting.startDate || editForm.startDateTime.$error.required">This field is required.</span></div></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.timeZone?(editForm.timeZone.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_input_timezone">Time Zone:</label><ui-select ng-model="vm.telehealthMeeting.timeZone" name="timeZone" id="field_input_timezone" close-on-select="true" required><ui-select-match placeholder="Select time zone ...">{{$select.selected}}</ui-select-match><ui-select-choices repeat="timeZone in vm.timeZones | filter: $select.search"><div ng-bind-html="timeZone | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block" ng-show="!vm.telehealthMeeting.timeZone || editForm.timeZone.$error.required">This field is required.</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.duration?\'has-success\':\'has-error\'"><label for="field_input_duration">Duration minutes:</label> <input type="number" id="field_input_duration" class="form-control" min="1" name="duration" ng-model="vm.telehealthMeeting.duration" required> <span class="help-block" ng-show="!vm.telehealthMeeting.duration || editForm.duration.$error.required">This field is required.</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8"><div class="form-group has-feedback" ng-class="vm.telehealthMeeting.host?(editForm.host.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_input_host">Host:</label><ui-select name="host" id="field_input_host" title="Select host..." ng-model="vm.telehealthMeeting.host" reset-search-input="true" close-on-select="true" required><ui-select-match allow-clear="true" placeholder="Select host...">{{$select.selected.lastName + \', \' + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | filter: $select.search" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select><span class="help-block" ng-show="!vm.telehealthMeeting.host || editForm.host.$error.required">This field is required.</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group has-feedback"><label for="field_input_password">Password:</label><div class="input-group"><input ng-attr-type="{{ vm.showPassword ? \'text\' : \'password\' }}" id="field_input_password" class="form-control" name="password" placeholder="Meeting password..." ng-model="vm.telehealthMeeting.password" autocomplete="new-password"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.showPassword = !vm.showPassword"><i class="fa" aria-hidden="true" ng-class="vm.showPassword?\'fa-eye\':\'fa-eye-slash\'"></i></button></span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Schedule</button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/telehealth/list/telehealth-meeting.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/telehealth/tabs/audio.html','<div class="table-responsive table-small-font"><table class="table table-condensed table-bordered"><thead><tr class="active"><th colspan="2"></th><th colspan="4" class="text-center">Receiving</th><th colspan="4" class="text-center">Sending</th></tr><tr><th colspan="2"><strong>Participants</strong></th><th><strong>Bitrate</strong></th><th><strong>Latency</strong></th><th><strong>Jitter</strong></th><th><strong>Packet Loss-Avg(Max)</strong></th><th><strong>Bitrate</strong></th><th><strong>Latency</strong></th><th><strong>Jitter</strong></th><th><strong>Packet Loss-Avg(Max)</strong></th></tr></thead><tbody><tr><td class="text-center"><i class="fa fa-mobile-phone" aria-hidden="true"></i></td><td>Rebeka George</td><td>45kbps</td><td>77ms</td><td>10ms</td><td>0%(0%)</td><td>31kbps</td><td>136ms</td><td>38ms</td><td>9.1%(26.9%)</td></tr><tr><td class="text-center"><i class="fa fa-laptop" aria-hidden="true"></i></td><td>Gary Holdman</td><td>21kbps</td><td>92ms</td><td>4ms</td><td>0%(0%)</td><td>60kbps</td><td>87ms</td><td>18ms</td><td>3.1%(2.6%)</td></tr></tbody></table></div>');
$templateCache.put('app/entities/telehealth/tabs/overall.html','<div class="table-responsive table-small-font"><table class="table table-condensed table-bordered"><thead><tr class="active"><th colspan="2"><strong>Participant</strong></th><th><strong>Device</strong></th><th><strong>IP Address</strong></th><th><strong>Location</strong></th><th><strong>Network Type</strong></th><th><strong>Microphone</strong></th><th><strong>Speaker</strong></th><th><strong>Camera</strong></th><th><strong>Data Center</strong></th><th><strong>Connection Type</strong></th><th><strong>Join Time</strong></th><th><strong>Leave Time</strong></th></tr></thead><tbody><tr ng-repeat="participant in vm.participants"><td class="text-center"><i class="fa fa-mobile-phone" aria-hidden="true"></i></td><td>{{participant.identity}}</td><td>{{participant.device}}</td><td><span class="ip-address">{{participant.ip}}</span> <a href="" class="info-btn"><i class="fa fa-info-circle" aria-hidden="true"></i></a></td><td>{{participant.location}}</td><td>{{participant.networkType}}</td><td>{{participant.microphone}}</td><td>{{participant.speaker}}</td><td>{{participant.camera}}</td><td>{{participant.dataCenter}}</td><td>{{participant.connectionType}}</td><td>{{participant.startDate | amDateFormat: amDateFormat}}</td><td><span>{{participant.endDate | amDateFormat: amDateFormat}}</span> <a href="" class="info-btn"><i class="fa fa-info-circle" aria-hidden="true"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/entities/telehealth/tabs/screen-sharing.html','<div class="table-responsive table-small-font"><table class="table table-condensed table-bordered"><thead><tr class="active"><th colspan="2"></th><th colspan="4" class="text-center">Receiving</th><th colspan="4" class="text-center">Sending</th></tr><tr><th colspan="2"><strong>Participants</strong></th><th><strong>Bitrate</strong></th><th><strong>Latency</strong></th><th><strong>Jitter</strong></th><th><strong>Packet Loss-Avg(Max)</strong></th><th><strong>Bitrate</strong></th><th><strong>Latency</strong></th><th><strong>Jitter</strong></th><th><strong>Packet Loss-Avg(Max)</strong></th></tr></thead><tbody><tr><td class="text-center"><i class="fa fa-mobile-phone" aria-hidden="true"></i></td><td>Rebeka George</td><td>45kbps</td><td>77ms</td><td>10ms</td><td>0%(0%)</td><td>31kbps</td><td>136ms</td><td>38ms</td><td>9.1%(26.9%)</td></tr><tr><td class="text-center"><i class="fa fa-laptop" aria-hidden="true"></i></td><td>Gary Holdman</td><td>21kbps</td><td>92ms</td><td>4ms</td><td>0%(0%)</td><td>60kbps</td><td>87ms</td><td>18ms</td><td>3.1%(2.6%)</td></tr></tbody></table></div>');
$templateCache.put('app/entities/telehealth/tabs/video.html','<div class="table-responsive table-small-font"><table class="table table-condensed table-bordered"><thead><tr class="active"><th colspan="2"></th><th colspan="4" class="text-center">Receiving</th><th colspan="4" class="text-center">Sending</th></tr><tr><th colspan="2"><strong>Participants</strong></th><th><strong>Bitrate</strong></th><th><strong>Latency</strong></th><th><strong>Jitter</strong></th><th><strong>Packet Loss-Avg(Max)</strong></th><th><strong>Bitrate</strong></th><th><strong>Latency</strong></th><th><strong>Jitter</strong></th><th><strong>Packet Loss-Avg(Max)</strong></th></tr></thead><tbody><tr><td class="text-center"><i class="fa fa-mobile-phone" aria-hidden="true"></i></td><td>Rebeka George</td><td>45kbps</td><td>77ms</td><td>10ms</td><td>0%(0%)</td><td>31kbps</td><td>136ms</td><td>38ms</td><td>9.1%(26.9%)</td></tr><tr><td class="text-center"><i class="fa fa-laptop" aria-hidden="true"></i></td><td>Gary Holdman</td><td>21kbps</td><td>92ms</td><td>4ms</td><td>0%(0%)</td><td>60kbps</td><td>87ms</td><td>18ms</td><td>3.1%(2.6%)</td></tr></tbody></table></div>');
$templateCache.put('app/entities/track/list/track.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/track/update/track-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTrackLabel">Create or edit a Track</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.track.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.track.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.track.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.track.name" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.track.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.track.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.track.name">This field is required</span></div><div class="form-group has-feedback" ng-class="vm.track.description?(editForm.description.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_description">Description</label> <textarea type="text" class="form-control" name="description" id="field_description" data-resize="disabled" rows="2" ng-model="vm.track.description">\n            </textarea> <span class="help-block" ng-show="!vm.track.description">This field is required</span></div><div class="form-group"><label for="field_enabled">Enabled</label><br><toggle id="field_enabled" ng-model="vm.track.enabled" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div><div class="form-group has-feedback" ng-class="vm.track.groupSessionTemplates?(vm.track.groupSessionTemplates.length > 0?\'has-success\':\'has-warning\'):\'has-warning\'"><label for="field_groupSessionTemplate">Group Session Templates</label><ui-select id="field_groupSessionTemplate" name="groupSessionTemplate" multiple="multiple" ng-model="vm.track.groupSessionTemplates" close-on-select="false" title="Select Group Session Templates..."><ui-select-match placeholder="Select Group Session Templates...">{{$item.title}}</ui-select-match><ui-select-choices repeat="groupSessionTemplates in vm.groupSessionTemplates" refresh-delay="0"><div ng-bind-html="groupSessionTemplates.title | highlight: $select.search"></div></ui-select-choices></ui-select><span class="help-block help-warning" ng-show="!vm.track.groupSessionTemplates || (vm.track.groupSessionTemplates.length === 0)">This field is suggested</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()" data-dismiss="modal"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/tube/list/tube.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/tube/update/tube-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTubeLabel">Create or edit a Tube</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tube.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.tube.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.tube.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.tube.name"> <span class="help-block" ng-show="!vm.tube.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-check/list/type-check.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-check/update/type-check-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTypeCheckLabel">Create or edit a Type of Check</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeCheck.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeCheck.id" readonly="readonly"></div><div class="form-group has-feedback" \\ ng-class="vm.typeCheck.name?(editForm.name?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.typeCheck.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.typeCheck.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.typeCheck.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.typeCheck.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-contact-facility-type/list/type-contact-facility-type.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-contact-facility-type/update/type-contact-facility-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myShiftTypeLabel">Create or edit a Type Contact Facility Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeContactFacilityType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeContactFacilityType.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.typeContactFacilityType.name?(editForm.name?\'has-success\':\'\'):\'has-error\'"><label for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.typeContactFacilityType.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.typeContactFacilityType.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.typeContactFacilityType.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.typeContactFacilityType.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-discharge-type/list/type-discharge-type.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-discharge-type/update/type-discharge-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myShiftTypeLabel">Create or edit a Discharge Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeDischargeType.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeDischargeType.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.typeDischargeType.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.typeDischargeType.name" required> <span class="help-block" aria-hidden="true" ng-show="editForm.name.$error.required">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-ethnicity/list/type-ethnicity.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-ethnicity/update/type-ethnicity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myEthnicityTypeLabel">Create or edit a Ethnicity Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeEthnicity.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeEthnicity.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.typeEthnicity.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.typeEthnicity.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.typeEthnicity.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.typeEthnicity.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.typeEthnicity.name">This field is required</span></div><div class="form-group"><label class="control-label" for="field_code">Code:</label> <select class="form-control input-sm" id="field_code" name="code" ng-model="vm.typeEthnicity.code"><option value="H">H - Hispanic or Latino</option><option value="N">N - Not Hispanic or Latino</option><option value="U">U - Unknown</option></select></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-food-diets/list/type-food-diets.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-food-diets/update/type-food-diets-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myReactionLabel">Create or edit a Food Diet</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeFoodDiets.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeFoodDiets.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.typeFoodDiets.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_typeFoodDiets">Name:</label> <input type="text" class="form-control" name="name" id="field_typeFoodDiets" required ng-model="vm.typeFoodDiets.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.typeFoodDiets.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.typeFoodDiets.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.typeFoodDiets.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-level-care/list/type-level-care.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-level-care/update/type-level-care-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySpecimeLabel">Create or edit a Type Level Care</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeLevelCare.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeLevelCare.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.typeLevelCare.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.typeLevelCare.name"> <span class="help-block" ng-show="!vm.typeLevelCare.name || editForm.name.$error.required">This field is required.</span></div><div class="form-group form-group-sm has-feedback"><label class="control-label" for="name">Color:</label> <input class="form-control" name="color" id="color" color-picker color-picker-model="vm.typeLevelCare.color" color-picker-position="bottom" style="background-color: {{vm.typeLevelCare.color}}"></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form><script type="stylesheet"></script>');
$templateCache.put('app/entities/type-marital-status/list/type-marital-status.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-marital-status/update/type-marital-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="mySessionTypeLabel">Create or edit a Marital Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group" ng-show="vm.typeMaritalStatus.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" readonly="readonly" ng-model="vm.typeMaritalStatus.id"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group has-feedback" ng-class="vm.typeMaritalStatus.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.typeMaritalStatus.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.typeMaritalStatus.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.typeMaritalStatus.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.typeMaritalStatus.name">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-patient-contact-types/list/type-patient-contact-types.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-patient-contact-types/update/type-patient-contact-types-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myShiftTypeLabel">Create or edit a Type Patient Contact Types</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typePatientContactTypes.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typePatientContactTypes.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="vm.typePatientContactTypes.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.typePatientContactTypes.name" required> <span class="help-block" ng-show="editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-patient-contacts-relationship/list/type-patient-contacts-relationships.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-patient-contacts-relationship/update/type-patient-contacts-relationship-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Create or edit a Type Patient Contacts Relationship</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typePatientContactsRelationship.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typePatientContactsRelationship.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.typePatientContactsRelationship.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.typePatientContactsRelationship.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.typePatientContactsRelationship.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.typePatientContactsRelationship.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.typePatientContactsRelationship.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-patient-process/list/type-patient-process.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-patient-process/update/type-patient-process-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTypePatientProcessLabel">Create or edit a Type Patient Process</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typePatientProcess.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" readonly="readonly" ng-model="vm.typePatientProcess.id"></div><div class="form-group has-feedback" ng-class="vm.typePatientProcess.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name:</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.typePatientProcess.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.typePatientProcess.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.typePatientProcess.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.typePatientProcess.name">This field is required</span></div><div class="form-group"><label class="control-label" for="field_durationDays">Order</label> <input type="number" class="form-control" name="xrder" id="field_durationDays" ng-model="vm.typePatientProcess.xrder" min="0"></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-payment-methods/list/type-payment-methods.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-payment-methods/update/type-payment-methods-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTypePaymentMethodsLabel">Create or edit a Payment Methods</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typePaymentMethods.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typePaymentMethods.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.typePaymentMethods.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.typePaymentMethods.name"> <span class="help-block" ng-show="!vm.typePaymentMethods.name || editForm.name.$error.required">This field is required.</span></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.typePaymentMethods.category || editForm.category.$error.required?\'has-error\':(editForm.category.$valid && editForm.category.$dirty?\'has-success\':\'\')"><label class="control-label" for="field_category">Category</label> <select class="form-control" name="category" ng-model="vm.typePaymentMethods.category" id="field_category" required><option value="Insurance">Insurance</option><option value="No">No Insurance</option></select> <span class="help-block" ng-show="!vm.typePaymentMethods.category || editForm.category.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-race/list/type-race.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-race/update/type-race-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myTypeRaceLabel">Create or edit a Type Race</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeRace.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeRace.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.typeRace.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.typeRace.name"> <span class="help-block" ng-show="!vm.typeRace.name || editForm.name.$error.required">This field is required.</span></div><div class="form-group"><label class="control-label" for="field_code">Code:</label> <select class="form-control input-sm" id="field_code" name="code" ng-model="vm.typeRace.code"><option value="1002-5">1002-5 - American Indian or Alaska Native</option><option value="2028-9">2028-9 - Asian</option><option value="2054-5">2054-5 - Black or African American</option><option value="2076-8">2076-8 - Native Hawaiian or Other Pacific Islander</option><option value="2106-3">2106-3 - White</option><option value="2131-1">2131-1 - Other Race</option></select></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-speciality/list/type-speciality.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/type-speciality/update/type-speciality-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myShiftTypeLabel">Create or edit a Type Speciality</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.typeSpecialitys.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.typeSpecialitys.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="vm.typeSpecialitys.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-model="vm.typeSpecialitys.name" required> <span class="help-block" ng-show="editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/urgent-issues/alert/urgent-issue-alerts.html','<section class="content no-padding"><div class="content-heading" style="flex-wrap: wrap"><div class="filters-box"><input type="text" class="form-control" placeholder="Search..." ng-model-options="{ debounce: 500 }" id="searchQuerySelectCampaign" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="table-responsive beds-layout"><table class="table table-condensed table-hover"><thead><tr><jhi-alert></jhi-alert></tr><tr><th></th><th><strong>Name</strong></th><th><strong>Mr Number</strong></th><th><strong>Level of Care</strong></th><th><strong>Blue Alert</strong></th></tr></thead><tbody><tr ng-repeat="urgentIssues in vm.urgentIssues"><td><img class="img-responsive img-thumbnail" alt="Patient Photo" style="width: 70px;" ng-src-auth="{{urgentIssues.chart}}"></td><td>{{urgentIssues.chart.firstName}} {{urgentIssues.chart.lastName}}</td><td>{{urgentIssues.chart.mrNo}}</td><td>{{urgentIssues.chart.typeLevelCare ? urgentIssues.chart.typeLevelCare.name : \'\'}}</td><td><ul><li ng-repeat="_urgentIssues in urgentIssues.urgentIssues">{{_urgentIssues.description}}</li></ul></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a class="dd-link orange" ui-sref="chart({id: urgentIssues.chartId})"><i class="fa fa-user" aria-hidden="true"></i> Patient Details</a></li></ul></div></td></tr></tbody></table></div></section>');
$templateCache.put('app/entities/verifytx/create/verifytx-new-dialog.html','<form name="form" role="form" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">New Verification of Benefits</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="field_facility">Facility:</label><ui-select name="facility" id="field_facility" title="Select facility" ng-model="vm.facility" reset-search-input="true" ng-required="true" close-on-select="true"><ui-select-match placeholder="Select facility...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="facility in vm.facilities | filter: $select.search"><div ng-bind-html="facility.name"></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="field_payer">Payer:</label><ui-select name="payer" id="field_payer" title="Select payer" ng-model="vm.payer" reset-search-input="true" ng-required="true" close-on-select="true"><ui-select-match placeholder="Select payer...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="payer in vm.payers | filter: $select.search" refresh="vm.getPayers($select.search)" refresh-delay="3"><div ng-bind-html="payer.name"></div></ui-select-choices></ui-select></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="form.$invalid || form.$error.required || vm.isSaving" ng-click="vm.newVerifytx()"><i class="fa fa-save" aria-hidden="true"></i> New</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i>&nbsp;Cancel</button></div></form>');
$templateCache.put('app/entities/verifytx-credential/list/verifytx-credential.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/verifytx-credential/update/verifytx-credential-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedLabel">Create or edit a VerifyTX Credential</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.verifytxCredential.clientId?(editForm.clientId.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_client_id">Client Id</label> <input type="text" class="form-control" name="clientId" id="field_client_id" required ng-model="vm.verifytxCredential.clientId"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.verifytxCredential.clientId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.verifytxCredential.clientId && editForm.clientId.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.verifytxCredential.clientId">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.verifytxCredential.clientSecret?(editForm.clientSecret.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_client_secret">Client Secret</label> <input type="text" class="form-control" name="clientSecret" id="field_client_secret" required ng-model="vm.verifytxCredential.clientSecret"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.verifytxCredential.clientSecret"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.verifytxCredential.clientSecret && editForm.clientSecret.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.verifytxCredential.clientSecret">This field is required</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.verifytxCredential.username?(editForm.username.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_username">Username</label> <input type="text" class="form-control" name="username" id="field_username" required ng-model="vm.verifytxCredential.username"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.verifytxCredential.username"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.verifytxCredential.username && editForm.username.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.verifytxCredential.username">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.verifytxCredential.password?(editForm.password.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_password">Password</label> <input type="text" class="form-control" name="password" id="field_password" required ng-model="vm.verifytxCredential.password"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.verifytxCredential.password"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.verifytxCredential.password && editForm.password.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.verifytxCredential.password">This field is required</span></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/verifytx-schedule/list/verifytx-schedule.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/verifytx-schedule/update/verifytx-schedule-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myBedLabel">Create or edit a VerifyTX Schedule</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.schedule.length !== 0 ? \'has-success\' : \'has-error\'"><label class="control-label" for="field_schedule_id">Days</label><ui-select id="field_schedule_id" name="schedule" multiple="multiple" ng-model="vm.schedule" close-on-select="false" title="Schedule" required><ui-select-match placeholder="Select Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search">{{day}}</ui-select-choices></ui-select><span class="help-block" aria-hidden="true" ng-show="vm.schedule.length === 0">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm"><label for="field_employee">Employees</label><ui-select name="employee" id="field_employee" title="employee" multiple="multiple" ng-model="vm.verifytxSchedule.employees" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Select ...">{{$item.firstName + \' \' + $item.lastName}}</ui-select-match><ui-select-choices repeat="item in vm.employees | propsFilter: {firstName: $select.search ,lastName: $select.search}" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="item.firstName + \' \' + item.lastName | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/vessel/list/vessel.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/vessel/update/vessel-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVesselLabel">Create or edit a Vessel</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.vessel.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.vessel.id" readonly="readonly"></div><div class="form-group has-feedback" ng-class="vm.vessel.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.vessel.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.vessel.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vessel.name && editForm.name.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!vm.vessel.name">This field is required</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/via/list/via.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/via/update/via-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myViaLabel">Create or edit a Via</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.via.id"><label for="id">ID</label> <input type="text" class="form-control" id="id" name="id" ng-model="vm.via.id" readonly="readonly"></div><div class="form-group form-group-sm has-feedback" ng-class="!vm.via.name || editForm.name.$error.required?\'has-error\':(editForm.name.$valid && editForm.name.$dirty?\'has-success\':\'\')"><label class="control-label" for="name">Name:</label> <input class="form-control" name="name" id="name" required ng-model="vm.via.name"> <span class="help-block" ng-show="!vm.via.name || editForm.name.$error.required">This field is required.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/vitals/history/vitals.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Vitals - History</h4></div><div class="modal-body"><div class="table-wrapper"><table class="table table-bordered fixed-header" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/vitals/update/vitals-dialog.html','<form name="vm.form.vitals" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Create or edit a Vitals</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.vitals.date || vm.form.vitals.date.$invalid?\'has-error\':(vm.vitals.date && vm.form.vitals.date.$dirty?\'has-success\':\'\')"><label for="field_date">Date:</label><div class="input-group input-group-sm"><input id="field_date" type="text" class="form-control" name="date" required ng-model="vm.vitals.date" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.date" message-id="msg-vital-date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.date || vm.form.vitals.date.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.date && vm.form.vitals.date.$dirty"></span> <span class="help-block" ng-show="!vm.vitals.date || vm.form.vitals.date.$invalid">This field is required</span></div><div id="msg-vital-date"></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.vitals.bpSystolic?(vm.form.vitals.bp_systolic.$valid && vm.form.vitals.bp_systolic.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_bp_systolic">Bp Systolic</label> <input type="number" class="form-control" name="bp_systolic" id="field_bp_systolic" ng-model="vm.vitals.bpSystolic" ng-maxlength="3"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.bpSystolic"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.bpSystolic && vm.form.vitals.bp_systolic.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.vitals.bpSystolic">Suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.vitals.bpDiastolic?(vm.form.vitals.bp_diastolic.$valid && vm.form.vitals.bp_diastolic.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_bp_diastolic">Bp Diastolic</label> <input type="number" class="form-control" name="bp_diastolic" id="field_bp_diastolic" ng-model="vm.vitals.bpDiastolic" ng-maxlength="3"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.bpDiastolic"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.bpDiastolic && vm.form.vitals.bp_diastolic.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.vitals.bpDiastolic">Suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.vitals.temperature?(vm.form.vitals.temperature.$valid && vm.form.vitals.temperature.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_temperature">Temperature</label> <input type="number" class="form-control" name="temperature" id="field_temperature" ng-model="vm.vitals.temperature" ng-maxlength="6"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.temperature"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.temperature && vm.form.vitals.temperature.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.vitals.temperature">Suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.vitals.pulse?(vm.form.vitals.pulse.$valid && vm.form.vitals.pulse.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_pulse">Pulse</label> <input type="number" class="form-control" name="pulse" id="field_pulse" ng-model="vm.vitals.pulse" ng-maxlength="6"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.pulse"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.pulse && vm.form.vitals.pulse.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.vitals.pulse">Suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.vitals.respiration?(vm.form.vitals.respiration.$valid && vm.form.vitals.respiration.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_respiration">Respiration</label> <input type="number" class="form-control" name="respiration" id="field_respiration" ng-model="vm.vitals.respiration"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.respiration"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.respiration && vm.form.vitals.respiration.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.vitals.respiration">Suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.vitals.o2Saturation?(vm.form.vitals.o2Saturation.$valid && vm.form.vitals.o2Saturation.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_o2_saturation">O<sup>2</sup> Saturation</label> <input type="number" class="form-control" name="o2_saturation" id="field_o2_saturation" ng-model="vm.vitals.o2Saturation"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.vitals.o2Saturation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.vitals.o2Saturation && vm.form.vitals.o2Saturation.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.vitals.o2Saturation">Suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.vitals.$error.required || vm.isSaving || vm.from.vitals.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/weight/history/weight.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Weight - History</h4></div><div class="modal-body"><div class="table-wrapper"><table class="table table-bordered fixed-header" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.search()"><ul></ul></ul></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/weight/update/weight-dialog.html','<form name="vm.form.weight" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myWeightLabel">Create or edit a Weight</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="!vm.weight.date || vm.form.weight.date.$invalid?\'has-error\':(vm.weight.date && vm.form.weight.date.$dirty?\'has-success\':\'\')"><label for="field_date">Date:</label><div class="input-group input-group-sm"><input id="field_date" type="text" class="form-control" name="date" required ng-model="vm.weight.date" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.date" message-id="msg-weight-date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.weight.date || vm.form.weight.date.$invalid"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.weight.date && vm.form.weight.date.$dirty"></span> <span class="help-block" ng-show="!vm.weight.date || vm.form.weight.date.$invalid">This field is required</span></div><div id="msg-weight-date"></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.weight.weight?(vm.form.weight.weight.$valid && vm.form.weight.weight.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_weight">Weight (Lb)</label> <input type="number" class="form-control" name="weight" id="field_weight" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="vm.weight.weight"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.weight.weight"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.weight.weight && vm.form.weight.weight.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.weight.weight">Suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.height.feet?(vm.form.heightFeet.$valid && vm.form.heightFeet.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_height_feet">Height (Feet)</label> <input type="number" class="form-control" name="height" id="field_height_feet" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="1" ng-model="vm.height.feet"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.height.feet"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.height.feet && vm.form.heightFeet.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.height.feet">Suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.height.inches?(vm.form.heightInches.$valid && vm.form.heightInches.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_height_in">Height (In)</label> <input type="number" class="form-control" name="height" id="field_height_in" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="vm.height.inches"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.height.inches"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.height.inches && vm.form.heightInches.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.height.inches">Suggested</span></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.weight.$error.required || vm.isSaving || vm.from.weight.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/layouts/header/tpl/idle-tpl.html','<script type="text/ng-template" id="warning-dialog.html"><div class="modal-header">\n        <h3>You\'re Idle. Do Something!</h3>\n    </div>\n    <div idle-countdown="vm.countdown" class="modal-body">\n        <p>You\'ll be logged out in <span class="label label-warning">{{vm.countdown}}</span>\n            <span ng-pluralize="" count="vm.countdown" when="{\'one\': \'second\', \'other\': \'seconds\' }"></span>.</p>\n        <uib-progressbar max="30" value="vm.countdown" animate="true" class="progress-striped active"></uib-progressbar>\n    </div></script>');
$templateCache.put('app/entities/telehealth/invitation/telehealth-meeting-invitation-dialog.html','<form name="inviteForm"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Invitation</h4></div><div class="modal-body"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><textarea class="form-control" id="textarea_field" name="invitation" rows="10" data-resize="disabled" readonly="readonly" style="margin: 0 0 10px">\n                {{vm.invitation}}\n            </textarea></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.copy()"><i class="fa fa-copy" aria-hidden="true"></i> Copy</button></div></form>');
$templateCache.put('app/entities/facility-lab/create/facility-lab-new-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myFacilityLab">Create Facility Lab Request</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group form-group-sm has-feedback" ng-class="vm.laboratoriesSelected.length?(editForm.laboratories.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_laboratories">Laboratory</label><ui-select ng-model="vm.laboratoriesSelected" name="laboratories" id="field_laboratories" ng-required="true" reset-search-input="true" title="Select laboratories" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Select Laboratories">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.laboratories"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.laboratoriesSelected > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.laboratoriesSelected.length > 0 && editForm.laboratoriesSelected.$dirty"></span> <span class="help-block" ng-show="!vm.laboratoriesSelected.length > 0">This field is required</span></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$error.required || vm.isSaving" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facility-lab/list/facility-lab.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/facility-lab/select/select-facility-lab-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel">Select Lab Integration...</h4></div><div class="modal-body"><div class="search-input"><input type="text" class="form-control" placeholder="Search..." id="searchQuerySelectCampaign" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></div><div id="select-campaign-dtable" class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.selectLaboratory()" ng-disabled="!vm.laboratory"><i class="fa fa-save" aria-hidden="true"></i> Select</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facility-lab/update/facility-lab-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myInsuranceLevelLabel">Create or edit a Facility Lab</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.facilityLab.enabled ? (vm.facilityLab.account ? (editForm.account.$dirty ? \'has-success\' : \'\') : \'has-error\') : \'\'"><label class="control-label" for="field_account">Account (letters(a-z), numbers(0-9), _ or -)</label> <input type="text" class="form-control" name="account" id="field_account" ng-required="vm.facilityLab.enabled" ng-model="vm.facilityLab.account" ng-pattern="vm.pattern" ng-change="vm.searchAccount(vm.facilityLab.account)"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="vm.facilityLab.enabled && !vm.facilityLab.account"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facilityLab.enabled && vm.facilityLab.account && editForm.account.$dirty"></span><div ng-show="editForm.account.$invalid || vm.accountExist"><p class="help-block" ng-show="editForm.account.$error.required">This field is required</p><p class="help-block" ng-show="editForm.account.$error.pattern">Invalid value field</p><span class="help-block" aria-hidden="true" ng-show="vm.accountExist">This account is already taken.</span></div></div></div><div class="col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.facilityLab.laboratory?(vm.facilityLab.laboratory.$valid && vm.facilityLab.laboratory.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_laboratory">Laboratory</label><ui-select id="field_laboratory" name="laboratory" ng-disabled="true" ng-model="vm.facilityLab.laboratory" title="Laboratory..." ng-required="true"><ui-select-match placeholder="Laboratory...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="laboratory in vm.laboratories"><div ng-bind-html="laboratory.name"></div></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group form-group-sm"><label class="control-label" for="field_enabled">Enabled</label><toggle id="field_enabled" style="display: block;" ng-model="vm.facilityLab.enabled" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="field_status">Hl7 version</label> <select class="form-control" id="field_status" name="hl7Version" ng-model="vm.facilityLab.hl7Version" ng-options="versions for versions in vm.hl7Versions"><option value=""></option></select></div></div><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_sms_template">Sms Template</label><br><label class="control-label" for="field_sms_template">Tags: @patient_first_name, @patient_last_name, @facility_name, @facility_phone, @laboratory_name, @laboratory_phone</label> <textarea class="form-control" name="sms_template" id="field_sms_template" ng-model="vm.facilityLab.smsTemplate"></textarea></div></div><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_call_template">Call Template</label><br><label class="control-label" for="field_sms_template">Tags: @patient_first_name, @patient_last_name, @facility_name, @facility_phone, @laboratory_name, @laboratory_phone</label> <textarea class="form-control" name="call_template" id="field_call_template" ng-model="vm.facilityLab.callTemplate"></textarea></div></div><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_email_subject_template">Email Subject Template</label><br><label class="control-label" for="field_sms_template">Tags: @patient_first_name, @patient_last_name, @facility_name, @facility_phone, @laboratory_name, @laboratory_phone</label> <textarea class="form-control" name="email_subject_template" id="field_email_subject_template" ng-model="vm.facilityLab.emailSubjectTemplate"></textarea></div></div><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_email_template">Email Template</label><br><label class="control-label" for="field_sms_template">Tags: @patient_first_name, @patient_last_name, @facility_name, @facility_phone, @laboratory_name, @laboratory_phone</label> <textarea class="form-control" name="email_template" id="field_email_template" rows="10" ng-model="vm.facilityLab.emailTemplate"></textarea></div></div><div class="col-lg-12"><div class="form-group"><label class="control-label" for="field_email_password_subject_template">Email Password Subject Template</label><br><label class="control-label" for="field_sms_template">Tags: @patient_first_name, @patient_last_name, @facility_name, @facility_phone, @laboratory_name, @laboratory_phone</label> <textarea class="form-control" name="email_password_subject_template" id="field_email_password_subject_template" ng-model="vm.facilityLab.emailPasswordSubjectTemplate"></textarea></div></div><div class="col-lg-12"><div class="form-group"><label class="control-label" for="email_password_template">Email Password Template</label><br><label class="control-label" for="field_sms_template">Tags: @patient_first_name, @patient_last_name, @facility_name, @facility_phone, @laboratory_name, @laboratory_phone, @password</label> <textarea class="form-control" name="email_password_template" id="email_password_template" rows="10" ng-model="vm.facilityLab.emailPasswordTemplate"></textarea></div></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || (!vm.facilityLab.account && vm.facilityLab.enabled) || vm.accountExist" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/dashboard2/layout/critical-results/alert/patient-result-critical-alert-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Critical Results</h3></div><div class="modal-body"><div class="well well-lg jumbotron"><h1 class="text-center"><strong>{{vm.critical.value}}</strong></h1><p class="text-center small">Critical Results</p></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.clear()" ui-sref="critical-result"><i class="fa fa-external-link" aria-hidden="true"></i> View Details</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/dashboard2/layout/critical-results/box/critical-results-top-box.html','<div class="jr-card-body"><div class="layout-minimal"><div class="jr-icon-big red"><i class="fa fa-hospital-o" aria-hidden="true"></i></div><div class="jr-numbers"><span class="jr-counter">{{vm.critical.value}}</span><p class="jr-card-label">Critical Results</p></div></div></div><div class="jr-card-footer"><div class="link"><a href="" class="db-link" ui-sref="critical-result">View Details <i class="fa fa-external-link" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/alcohol/chart/new/alcohol.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Alcohol:</strong> <a href="" class="btn-icon" uib-tooltip="Add New Data" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>{{vm.alcohol.date | amDateFormat:amDateFormat}}</strong> -</p><p class="mb-0 inline-list text-center"><span><strong>Value</strong> - {{vm.alcohol.value}}</span></p></div>');
$templateCache.put('app/entities/alcohol/chart/old/alcohol.html','<div class="item-body"><table class="table"><tbody><tr><td><strong>Date:</strong></td><td>{{vm.alcohol.date | amDateFormat:amDateFormat}}</td></tr><tr><td><strong>Value:</strong></td><td>{{vm.alcohol.value}}</td></tr><tr><td><strong>Notes:</strong></td><td>{{vm.alcohol.description ? vm.alcohol.description : \'-\'}}</td></tr></tbody></table></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add New <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><a ng-click="vm.history()" class="footer-link">History <i class="fa fa-file-text-o" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/allergies/chart/new/allergies.html','<p class="info no-padding"></p><h5 class="header-label mt-0"><strong>Allergies:</strong> <a href="" class="btn-icon" uib-tooltip="Launch Rcopia" ng-if="vm.chart.status !== \'CLOSED\' && vm.corporation.rcopiaIntegration && vm.rcopiaAccount && vm.chart.rcopiaId" ng-click="vm.launchRcopia()"><i class="fa fa-medkit" aria-hidden="true"></i></a> <a href="" class="btn-icon" uib-tooltip="Add Allergy" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0" ng-if="vm.allergies.length > 0"><span class="click-layer" ng-repeat="($index, allergen) in vm.allergies" ng-click="vm.edit(allergen.id)" ng-if="allergen.active"><span style="line-height: 1.4"><b>{{$index + 1}}.- {{ vm.trim(allergen.name) }}</b> {{ vm.severity(allergen) }}</span><br></span></p>');
$templateCache.put('app/entities/allergies/chart/old/allergies.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon yellow small"><i class="fa fa-medkit fa-inverse" aria-hidden="true"></i></div><h2 class="head-text small">Allergies</h2></header><div class="item-body vertical-flow"><uib-tabset active="vm.activeTab" justified="true" class="justified-tabs header-tabs"><uib-tab index="0" heading="Active" select="vm.keepActiveTab(0)"><table class="table"><tbody><tr ng-repeat="allergen in vm.allergies" ng-if="allergen.active"><td class="text-left">{{allergen.rcopiaAllergyGroup ? allergen.rcopiaAllergyGroup.name : allergen.name}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(allergen.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(allergen.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></uib-tab><uib-tab index="1" heading="Inactive" select="vm.keepActiveTab(1)"><table class="table"><tbody><tr ng-repeat="allergen in vm.allergies" ng-if="!allergen.active"><td class="text-left">{{allergen.name}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(allergen.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(allergen.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></uib-tab></uib-tabset></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Allergy <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div></div>');
$templateCache.put('app/entities/chart/create/tpl/basic-info-form-tpl.html','<form action="" class="edit-info" class="form" name="vm.form.basicInfo"><div class="row mb-30"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.firstName)"><label for="first-name">First Name:</label> <input type="text" class="form-control" id="first-name" name="firstName" ng-model="vm.chart.firstName" required ng-disabled="!vm.allowEditBasicInfo" ng-maxlength="35"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.firstName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.firstName.$invalid && vm.form.basicInfo.firstName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.firstName.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.firstName.$error.maxlength">Max length 35 characters</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.middleName?\'\':\'has-warning\'"><label for="mid-name">Middle Name:</label> <input type="text" class="form-control" id="mid-name" name="middleName" ng-disabled="!vm.allowEditBasicInfo" ng-model="vm.chart.middleName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.middleName"></span> <span class="help-block help-warning" ng-show="!vm.chart.middleName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.lastName)"><label for="second-name">Last Name:</label> <input type="text" class="form-control" id="second-name" name="lastName" ng-model="vm.chart.lastName" required ng-disabled="!vm.allowEditBasicInfo" ng-maxlength="35"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.lastName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.lastName.$invalid && vm.form.basicInfo.lastName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.lastName.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.lastName.$error.maxlength">Max length 35 characters</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.preferredName?\'\':\'has-warning\'"><label for="pref-name">Preferred Name:</label> <input type="text" class="form-control" id="pref-name" ng-model="vm.chart.preferredName" ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.preferredName"></span> <span class="help-block help-warning" ng-show="!vm.chart.preferredName">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="mrno-number">Mr No:</label> <input type="text" class="form-control" ng-model="vm.chart.mrNo" id="mrno-number" disabled="disabled"></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.social?\'\':\'has-warning\'"><label for="ssn-number">SSN:</label> <input type="text" class="form-control" id="ssn-number" ui-mask="999-99-9999" ng-model="vm.chart.social" ng-disabled="!vm.allowEditBasicInfo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.social"></span> <span class="help-block help-warning" ng-show="!vm.chart.social">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dateBirth)"><label for="dob-date">DOB:</label><!--<input type="text" class="form-control" value="{{vm.chart.dateBirth | date:\'MM/dd/yyyy\'}}" id="dob-date">--><div class="input-group input-group-sm"><input id="dob-date" type="text" class="form-control" name="dateBirth" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateBirth" is-open="vm.datePickerOpenStatus.dateBirth" datepicker-options="birthDateOptions" ng-disabled="!vm.allowEditBasicInfo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateBirth\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dateBirth.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dateBirth.$invalid && vm.form.basicInfo.dateBirth.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$invalid && !vm.form.basicInfo.dateBirth.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.admissionDate)"><label for="admission-date">Admission:</label><div class="input-group input-group-sm"><input type="text" id="admission-date" class="form-control" name="admissionDate" placeholder="mm/dd/yyyy Hh:mm" required datetime-picker="{{inputDateTimeFormatA}}" ng-model="vm.chart.admissionDate" is-open="vm.datePickerOpenStatus.admissionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'admissionDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.admissionDate.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.admissionDate.$invalid && vm.form.basicInfo.admissionDate.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.admissionDate.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.admissionDate.$invalid && !vm.form.basicInfo.admissionDate.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'SOBRIETY_DATE\')"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.sobrietyDate?\'\':\'has-warning\'"><label for="sobriety-date">Sobriety Date:</label><div class="input-group input-group-sm"><input id="sobriety-date" type="text" class="form-control" name="sobrietyDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.sobrietyDate" is-open="vm.datePickerOpenStatus.sobrietyDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sobrietyDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.sobrietyDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.sobrietyDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_levelCare">Level of Care:</label> <select class="form-control" id="field_levelCare" name="typeLevelCare" ng-model="vm.chart.typeLevelCare" ng-options="item as item.name for item in vm.typeLevelCare track by item.name"></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.gender)"><label for="gender-type">Gender:</label> <select class="form-control" id="gender-type" name="gender" required ng-model="vm.chart.sex" ng-options="item as item for item in vm.gender track by item" ng-disabled="!vm.allowEditBasicInfo && vm.data.sex"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.gender.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.gender.$invalid && vm.form.basicInfo.gender.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.gender.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'BED\')"><div class="form-group form-group-sm"><label for="field_bed">Bed:</label> <select class="form-control" id="field_bed" name="bed" ng-model="vm.chart.bed" ng-options="item as item.name for item in vm.beds track by item.id"><option value=""></option></select></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_allowReadmit">Allow Readmit:</label> <select class="form-control" ng-model="vm.chart.allowReadmit" id="field_allowReadmit" name="allowReadmit" ng-change="vm.clearReadmitReason()" ng-disabled="vm.chart.id == null" ng-options="(item == null ? \'\' : item  ? \'Yes\' : \'No\') for item in [null, true, false]"></select></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="!vm.chart.allowReadmit"><div class="form-group has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.readmitReason)"><label for="field_readmitReason">Readmit Reason</label> <textarea class="form-control" name="readmitReason" id="field_readmitReason" rows="5" data-resize="disabled" ng-model="vm.chart.readmitReason" ng-required="!vm.chart.allowReadmit"></textarea> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.readmitReason.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.readmitReason.$invalid && vm.form.basicInfo.readmitReason.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.readmitReason.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4" ng-if="vm.checkField(\'ADMISSION_REP\')"><div class="form-group form-group-sm"><label for="field_admission_rep">Admission Rep:</label><ui-select id="field_admission_rep" name="admissionRep" reset-search-input="false" ng-model="vm.chart.admissionRep" title="Admission Rep..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Admission Rep...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.admissionReps" refresh="vm.getAdmissionReps($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.dateFirstContact?\'\':\'has-warning\'"><label for="patient-first-contact-date">Date First Contact</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="patient-first-contact-date" placeholder="mm/dd/yyyy" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateFirstContact" is-open="vm.datePickerOpenStatus.dateFirstContact"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.openCalendar(\'dateFirstContact\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.dateFirstContact"></span> <span class="help-block help-warning" ng-show="!vm.chart.dateFirstContact">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactName?\'\':\'has-warning\'"><label for="patient-first-contact">1<sup>st</sup> Contact Name:</label> <input type="text" class="form-control" id="patient-first-contact" name="firstContactName" placeholder="First Contact Name" ng-model="vm.chart.firstContactName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactName"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactName">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactRelationship?\'\':\'has-warning\'"><label for="patient-first-rel">1<sup>st</sup> Contact Relationship:</label> <input type="text" class="form-control" id="patient-first-rel" name="firstContactRel" placeholder="First Contact Relationship" ng-model="vm.chart.firstContactRelationship"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactRelationship"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactRelationship">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.firstContactPhone?\'\':\'has-warning\'"><label for="patient-first-contact-phone">1<sup>st</sup> Contact Phone:</label> <input type="text" class="form-control" id="patient-first-contact-phone" placeholder="First Contact Phone" name="firstContactPhone" ng-model="vm.chart.firstContactPhone" ui-mask="(999) 999-9999" ui-mask-placeholder> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.firstContactPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.firstContactPhone">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.externalId?\'\':\'has-warning\'"><label for="field_externalId">External Id:</label> <input type="text" class="form-control" id="field_externalId" name="externalId" placeholder="External Id" ng-model="vm.chart.externalId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.externalId"></span> <span class="help-block help-warning" ng-show="!vm.chart.externalId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="patient-first-rel">Track:</label><ui-select name="track" id="field_track" title="Select track" ng-model="vm.chart.track" reset-search-input="true" close-on-select="true" ng-change=""><ui-select-match allow-clear="true" placeholder="Enter a track...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="track in vm.tracks | filter: $select.search" refresh="vm.filterTracks($select.search)" refresh-delay="0"><div ng-bind-html="track.name"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.defaultPharmacy ? (vm.form.defaultPharmacy.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="field_pharmacy">Pharmacy</label><ui-select name="pharmacy" id="field_pharmacy" title="pharmacy" ng-model="vm.chart.defaultPharmacy" reset-search-input="false" ng-model-options="{ debounce: 500 }"><ui-select-match placeholder="Pharmacy...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.pharmacies" refresh="vm.getPharmacies($select.search)" refresh-delay="0"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-9 col-sm-9 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientAddress)"><label for="patient-address-1">Address:</label> <input type="text" class="form-control" id="patient-address-1" name="patientAddress" required ng-model="vm.chart.address" value="{{vm.chart.address}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientAddress.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientAddress.$invalid && vm.form.basicInfo.patientAddress.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientAddress.$error.required">This field is required</span></div></div><div class="col-xs-3 col-sm-3 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.addressTwo?\'\':\'has-warning\'"><label for="patient-address-2">Address Two:</label> <input type="text" class="form-control" id="patient-address-2" placeholder="Street Two" ng-model="vm.chart.addressTwo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.addressTwo"></span> <span class="help-block help-warning" ng-show="!vm.chart.addressTwo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientCity)"><label for="patient-city">City:</label> <input type="text" class="form-control" id="patient-city" name="patientCity" placeholder="City" required ng-model="vm.chart.city" value="{{vm.chart.city}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientCity.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientCity.$invalid && vm.form.basicInfo.patientCity.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientCity.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.state)"><label for="field_state">State:</label> <select class="form-control" ng-model="vm.chart.countryState" ng-options="item as item.state for item in vm.states track by item.id" required id="field_state" name="state"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.state.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.state.$invalid && vm.form.basicInfo.state.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.state.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientZipCode)"><label for="patient-zip-code">Zip Code:</label> <input type="text" class="form-control" id="patient-zip-code" name="patientZipCode" required value="{{vm.chart.zip}}" ui-mask="99999" ng-model="vm.chart.zip"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientZipCode.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientZipCode.$invalid && vm.form.basicInfo.patientZipCode.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientZipCode.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.phone)"><label for="patient-phone">Phone:</label> <input type="text" class="form-control" id="patient-phone" name="phone" ui-mask="(999) 999-9999" ng-model="vm.chart.phone" required><!--                        <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"--><!--                              ng-show="!vm.chart.phone"></span>--><!--                        <span class="help-block help-warning"--><!--                              ng-show="!vm.chart.phone">This field is suggested</span>--> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.phone.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.phone.$invalid && vm.form.basicInfo.phone.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.phone.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.altPhone?\'\':\'has-warning\'"><label for="patient-alt-phone">Alt. Phone:</label> <input type="text" class="form-control" id="patient-alt-phone" ui-mask="(999) 999-9999" ng-model="vm.chart.altPhone"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.altPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.altPhone">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.email)"><label for="patient-email">Email:</label> <input type="email" class="form-control" id="patient-email" placeholder="Email" name="email" ng-model="vm.chart.email" required><!--                        <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true"--><!--                              ng-show="!vm.chart.email"></span>--><!--                        <span class="help-block help-warning"--><!--                              ng-show="!vm.chart.email">This field is suggested</span>--> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.email.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.email.$invalid && vm.form.basicInfo.email.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.email.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.paymentMethod)"><label for="patient-payment-method">Payment Method:</label> <select class="form-control" id="patient-payment-method" name="paymentMethod" ng-model="vm.chart.typePaymentMethods" ng-options="item as item.name for item in vm.paymentMethod track by item.name" ng-change="vm.disableWizard()" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.paymentMethod.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.paymentMethod.$invalid && vm.form.basicInfo.paymentMethod.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.paymentMethod.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeMaritalStatus?\'\':\'has-warning\'"><label for="patient-marital-status">Marital Status:</label> <select class="form-control" id="patient-marital-status" name="maritalStatus" ng-model="vm.chart.typeMaritalStatus" ng-options="item as item.name for item in vm.maritalStatus track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeMaritalStatus"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeMaritalStatus">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeRace?\'\':\'has-warning\'"><label for="patient-race">Race:</label> <select class="form-control" id="patient-race" name="race" ng-model="vm.chart.typeRace" ng-options="item as item.name for item in vm.race track by item.name" ng-disabled="!vm.allowEditBasicInfo"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeRace"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeRace">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeEthnicity?\'\':\'has-warning\'"><label for="patient-ethnicity">Ethnicity:</label> <select class="form-control" name="ethnicity" ng-model="vm.chart.typeEthnicity" id="patient-ethnicity" ng-options="item as item.name for item in vm.ethnicity track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeEthnicity"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeEthnicity">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.referrer?\'\':\'has-warning\'"><label for="patient-referrer">Referral Source:</label> <input type="text" id="patient-referrer" placeholder="Referrer" name="referrer" ng-model="vm.chart.referrer" uib-typeahead="item.name as item.name for item in vm.getContactsFacility($viewValue)" typeahead-editable="true" typeahead-loading="loadingContacts" typeahead-no-results="noResultsReferrer" class="form-control"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.referrer"></span> <span class="help-block help-warning" ng-show="!vm.chart.referrer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.dischargeDate?\'\':\'has-warning\'"><label for="patient-discharge-date">Discharge Date:</label><div class="input-group input-group-sm"><input id="patient-discharge-date" type="text" class="form-control" name="dischargeDate" ng-model="vm.chart.dischargeDate" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.dischargeDate" datepicker-options="vm.dischargeDateOptions"> <span class="input-group-btn"><button class="btn btn-default" type="button" ng-click="vm.openCalendar(\'dischargeDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.dischargeDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.dischargeDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dischargeTo)"><label for="patient-discharge-to">Discharge to:</label> <input type="text" class="form-control" id="patient-discharge-to" name="dischargeTo" ng-model="vm.chart.dischargeTo" typeahead-min-length="3" uib-typeahead="item.name as item.name for item in vm.getContactsFacility($viewValue)" typeahead-editable="true" typeahead-loading="loadingContacts" typeahead-no-results="noResultsDischargeTo" class="form-control" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dischargeTo.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dischargeTo.$invalid && vm.form.basicInfo.dischargeTo.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dischargeTo.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.typeDischargeType?\'\':\'has-warning\'"><label for="patient-discharge-type">Discharge Type:</label> <select type="text" class="form-control" id="patient-discharge-type" ng-model="vm.chart.typeDischargeType" ng-options="item as item.name for item in vm.typeDischargeType track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.typeDischargeType"></span> <span class="help-block help-warning" ng-show="!vm.chart.typeDischargeType">This field is suggested</span></div></div><div class="col-xs-8 col-sm-8 col-md-8 col-lg-8" ng-if="vm.checkField(\'MARKETER\')"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.marketer?\'\':\'has-warning\'"><label for="patient-marketer">Outreach:</label><ui-select id="patient-marketer" name="marketer" reset-search-input="false" ng-model="vm.chart.marketer" title="Outreach..." ng-model-options="{ debounce: 300 }"><ui-select-match allow-clear="true" placeholder="Outreach...">{{$select.selected.lastName + ", " + $select.selected.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.marketer" refresh="vm.getMarketers($select.search)" refresh-delay="0"><div ng-bind-html="employee.firstName + \' \' + employee.lastName"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.marketer"></span> <span class="help-block help-warning" ng-show="!vm.chart.marketer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.occupation)"><label for="patient-occupation">Occupation:</label> <input type="text" class="form-control" id="patient-occupation" name="occupation" ng-model="vm.chart.occupancy" value="{{vm.chart.occupancy}}" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.occupation.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.occupation.$invalid && vm.form.basicInfo.occupation.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.occupation.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employer?\'\':\'has-warning\'"><label for="patient-employer-name">Employer Name:</label> <input type="text" class="form-control" id="patient-employer-name" ng-model="vm.chart.employer" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employer"></span> <span class="help-block help-warning" ng-show="!vm.chart.employer">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employerPhone?\'\':\'has-warning\'"><label for="patient-employer-phone">Employer Phone:</label> <input type="text" class="form-control" id="patient-employer-phone" ng-model="vm.chart.employerPhone" ui-mask="(999) 999-9999" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employerPhone"></span> <span class="help-block help-warning" ng-show="!vm.chart.employerPhone">This field is suggested</span></div></div></div><div class="row" ng-if="vm.facility.facilityType == \'COVID_RC\'"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.vessel?\'\':\'has-warning\'"><label for="vessel">Vessel:</label> <select type="text" class="form-control" id="vessel" ng-model="vm.chart.vessel" ng-options="item as item.name for item in vm.vessels track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.vessel"></span> <span class="help-block help-warning" ng-show="!vm.chart.vessel">This field is suggested</span></div><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.vesselCode?\'\':\'has-warning\'"><label for="vessel_code">Vessel Code:</label> <input type="text" class="form-control" id="vessel_code" ng-model="vm.chart.vesselCode" value="{{vm.chart.vesselCode}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.vesselCode"></span> <span class="help-block help-warning" ng-show="!vm.chart.vesselCode">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.voyageNo?\'\':\'has-warning\'"><label for="voyage_no">Voyage No:</label> <input type="text" class="form-control" id="voyage_no" ng-model="vm.chart.voyageNo" value="{{vm.chart.voyageNo}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.voyageNo"></span> <span class="help-block help-warning" ng-show="!vm.chart.voyageNo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.crewId?\'\':\'has-warning\'"><label for="cabin">Crew Id:</label> <input type="text" class="form-control" id="crewId" ng-model="vm.chart.crewId" value="{{vm.chart.crewId}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.crewId"></span> <span class="help-block help-warning" ng-show="!vm.chart.crewId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.cabin?\'\':\'has-warning\'"><label for="cabin">Cabin:</label> <input type="text" class="form-control" id="cabin" ng-model="vm.chart.cabin" value="{{vm.chart.cabin}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.cabin"></span> <span class="help-block help-warning" ng-show="!vm.chart.cabin">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.passengerId?\'\':\'has-warning\'"><label for="cabin">Passenger Id:</label> <input type="text" class="form-control" id="passengerId" ng-model="vm.chart.passengerId" value="{{vm.chart.passengerId}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.passengerId"></span> <span class="help-block help-warning" ng-show="!vm.chart.passengerId">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.sailingDate?\'\':\'has-warning\'"><label for="sailingDate">Sailing Date:</label><div class="input-group input-group-sm"><input id="sailingDate" type="text" class="form-control" name="sailingDate" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.sailingDate" is-open="vm.datePickerOpenStatus.sailingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'sailingDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.sailingDate"></span> <span class="help-block help-warning" ng-show="!vm.chart.sailingDate">This field is suggested</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.port?\'\':\'has-warning\'"><label for="port">Port:</label> <select type="text" class="form-control" id="port" ng-model="vm.chart.port" ng-options="item as item.name for item in vm.ports track by item.name"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.port"></span> <span class="help-block help-warning" ng-show="!vm.chart.port">This field is suggested</span></div></div></div><!-- /row --></div></div><!-- /row --></form>');
$templateCache.put('app/entities/chart/create/tpl/filter-tpl.html','<h2 class="step-header">Search patient:</h2><div class="chart-filters"><form name="searchFilters"><fieldset><legend>Search Filters:</legend><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyFirstName" placeholder="First Name" ng-model="vm.filter.firstName "></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyMiddleName" placeholder="Middle Name" ng-model="vm.filter.middleName"></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyLastName" placeholder="Last Name" ng-model="vm.filter.lastName "></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyPrefName" placeholder="Preferred Name" ng-model="vm.filter.preferredName"></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keySN" placeholder="Social Number" ng-model="vm.filter.social"></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><div class="input-group input-group-sm"><input id="field_dob" type="text" class="form-control" name="dob" placeholder="DOB" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.filter.dob" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block" tabindex="1" ng-click="vm.searchByFilter()"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" tabindex="2" ng-click="vm.clearFilter()"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></fieldset><fieldset ng-if="vm.showChartList"><legend>Results:</legend><p style="color: #ff2940" ng-if="vm.countFilterStr != \'\'"><strong>{{vm.countFilterStr}}</strong></p><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 box-wrapper mb-30"><button type="button" class="previous" ng-click="vm.next()" ng-show="vm.page != 1"><svg id="i-arrow-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M10 6 L2 16 10 26 M2 16 L30 16"/></svg></button><div class="box box-widget widget-user new-patient" ng-click="vm.activateStep()"><div class="hover-icon"><svg id="i-plus" viewBox="0 0 32 32" width="50" height="50" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M16 2 L16 30 M2 16 L30 16"/></svg></div><div class="widget-user-image"><img src="content/images/avatar.png" alt=""></div><div class="widget-user-header"><h3 class="widget-user-username">Create New</h3><h3 class="widget-user-username">Patient</h3></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-show="vm.charts.length == 0"><div id="currentChartEmpty" class="charts-empty"><div class="empty-text"><div class="empty-search"><div class="text-center"><span class="icon"><i class="fa fa-users" aria-hidden="true"></i></span></div><p><span>Unfortunately,</span><br>there are no patients matching<br>this criteria...</p></div></div></div></div><div class="box box-widget widget-user" title="See Patient Details" ng-click="vm.activateStep(item)" style="cursor: pointer" ng-repeat="item in vm.charts"><div class="widget-user-image"><img class="img-circle" id="imgPicture" alt="User profile picture" ng-src-auth="{{item}}"></div><div class="widget-user-header" ng-class="{\n                                            \'bg-gray-active\': item.status === \'ARCHIVE\',\n                                            \'bg-red\': item.status === \'CLOSED\'}"><h3 class="widget-user-username">{{item.firstName}} {{item.lastName}}</h3><h5 class="widget-user-desc"><strong>Mr No:</strong> {{item.mrNo}}</h5></div><div class="box-footer"><div class="insurance-type"><h4 class="mt-0 mb-0"><strong>Payment:</strong></h4><p class="mb-0">{{item.typePaymentMethods ? item.typePaymentMethods.name : \'-\'}}</p></div><div class="patient-bed"><h4 class="mt-0 mb-0"><strong>Bed:</strong></h4><p class="mb-0">{{item.bed?item.bed.name:\'No Bed\'}}</p></div></div></div><button type="button" class="next" ng-click="vm.next(0)" ng-show="vm.activateLeftArrow()"><svg id="i-arrow-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M22 6 L30 16 22 26 M30 16 L2 16"/></svg></button></div></fieldset></form></div>');
$templateCache.put('app/entities/chart/create/tpl/insurance-primary-form-tpl.html','<h2 class="step-header">Insurance Information</h2><hr><form action="" name="vm.form.primaryInsurance" class="form mb-15"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.insuranceCarrier?(vm.form.primaryInsurance.insurance_carrier.$dirty || vm.form.primaryInsurance.insurance_carrier.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_carrier">Insurance Carrier:</label><ui-select ng-model="vm.chart.primary.insuranceCarrier" name="insurance_carrier" id="field_insurance_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{ $select.selected.id? $select.selected.name: $select.selected.name + \'(new)\' }}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0">{{carrier.id? carrier.name: carrier.name + \'(new)\' }}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.primaryInsurance.insurance_carrier.$error.required"></span> <span class="help-block" ng-show="vm.form.primaryInsurance.insurance_carrier.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.policyNumber?(vm.form.primaryInsurance.insurance_policyNumber.$valid || vm.form.primaryInsurance.insurance_policyNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_policyNumber">Policy Number:</label> <input type="text" class="form-control" name="insurance_policyNumber" id="field_insurance_policyNumber" required ng-model="vm.chart.primary.policyNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.policyNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.policyNumber && vm.form.primaryInsurance.insurance_policyNumber.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.policyNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.preCertPhone?(vm.form.primaryInsurance.insurance_preCertPhone?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_preCertPhone">Pre-Cert Phone:</label> <input type="text" class="form-control" name="insurance_preCertPhone" id="field_insurance_preCertPhone" ng-model="vm.chart.primary.preCertPhone" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.preCertPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.preCertPhone && vm.form.primaryInsurance.insurance_preCertPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.preCertPhone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.groupNumber?(vm.form.primaryInsurance.insurance_groupNumber?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_insurance_groupNumber">Group Number:</label> <input type="text" class="form-control" name="insurance_groupNumber" id="field_insurance_groupNumber" ng-model="vm.chart.primary.groupNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.groupNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.groupNumber && vm.form.primaryInsurance.insurance_groupNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.groupNumber">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.insuranceType?(vm.form.primaryInsurance.insurance_type?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_insuranceType">Insurance Type:</label> <select class="form-control" id="field_insurance_insuranceType" name="insurance_type" ng-model="vm.chart.primary.insuranceType" ng-options="insuranceType as insuranceType.name for insuranceType in vm.insuranceTypes track by insuranceType.id"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.insuranceType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.insuranceType && vm.form.primaryInsurance.insurance_type.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.insuranceType">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.rxBin?(vm.form.primaryInsurance.insurance_rxBin?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_rxbin">RxBin:</label> <input type="text" class="form-control" name="insurance_rxBin" id="field_insurance_rxBin" ng-model="vm.chart.primary.rxBin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.rxBin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.rxBin && vm.form.primaryInsurance.insurance_rxBin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.rxBin">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.pcn?(vm.form.primaryInsurance.insurance_pcn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_pcn">RxPCN:</label> <input type="text" class="form-control" name="insurance_pcn" id="field_insurance_pcn" ng-model="vm.chart.primary.pcn"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.pcn"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.pcn && vm.form.primaryInsurance.insurance_pcn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.pcn">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.memberId?(vm.chart.form.primaryInsurance.insurance_memberId?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_memberId">Member:</label> <input type="text" class="form-control" name="insurance_memberId" id="field_insurance_memberId" ng-model="vm.chart.primary.memberId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.memberId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vvm.chart.primary.memberId && vm.form.primaryInsurance.insurance_memberId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.memberId">This field is suggested</span></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.firstName?(vm.form.primaryInsurance.insurance_firstName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_firstName">Subscriber First Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_firstName" id="field_insurance_firstName" required ng-model="vm.chart.primary.firstName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.firstName = vm.chart.firstName"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.firstName && vm.form.primaryInsurance.insurance_firstName.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.firstName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.lastName?(vm.form.primaryInsurance.insurance_lastName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_lastName">Subscriber Last Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_lastName" id="field_insurance_lastName" required ng-model="vm.chart.primary.lastName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.lastName = vm.chart.lastName"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.lastName && vm.form.primaryInsurance.insurance_lastName.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.lastName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.dob?(vm.form.primaryInsurance.insurance_dob?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Subscriber DOB:</label><div class="input-group input-group-sm"><input id="field_insurance_dob" type="text" class="form-control" name="insurance_dob" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.primary.dob" is-open="vm.datePickerOpenStatus.insuranceDob"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'insuranceDob\')"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.dob = vm.chart.dateBirth"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button></div><span class="help-block" ng-show="!vm.chart.primary.dob">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.socialSecurity?(vm.form.primaryInsurance.insurance_ssn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_ssn">Subscriber SSN:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_ssn" id="field_insurance_ssn" ng-model="vm.chart.primary.socialSecurity" ui-mask="999-99-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.socialSecurity = vm.chart.social"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.socialSecurity"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.socialSecurity && vm.form.primaryInsurance.insurance_ssn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.socialSecurity">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.insuranceRelation?(vm.form.primaryInsurance.insurance_insuranceRelation?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_insuranceRelation">Relationship:</label> <select class="form-control" id="field_insurance_insuranceRelation" name="insurance_insuranceRelation" required ng-model="vm.chart.primary.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insuranceRelations track by insuranceRelation.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.insuranceRelation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.insuranceRelation && vm.form.primaryInsurance.insurance_insuranceRelation.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.insuranceRelation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.gender?(vm.form.primaryInsurance.gender?\'has-success\':\'\'):\'has-error\'"><label for="gender">Subscriber Gender:</label><div class="input-group input-group-sm"><select class="form-control" id="gender" name="gender" required ng-model="vm.chart.primary.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.gender = vm.chart.sex"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.chart.primary.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.chart.primary.gender && vm.form.primaryInsurance.gender.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.gender">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.phone?(vm.form.primaryInsurance.insurance_phone?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.chart.primary.phone" ui-mask="(999) 999-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.phone = vm.chart.phone"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.phone && vm.form.primaryInsurance.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.phone">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.address?(vm.form.primaryInsurance.insurance_address?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.chart.primary.address"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.address = vm.chart.address"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.address && vm.form.primaryInsurance.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.address">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.address2?(vm.form.primaryInsurance.insurance_address2?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.chart.primary.address2"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.address2 = vm.chart.addressTwo"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.address2 && vm.form.primaryInsurance.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.primary.address2">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.city?(vm.form.primaryInsurance.insurance_city?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.chart.primary.city"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.city = vm.chart.city"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.city && vm.form.primaryInsurance.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.city">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.primary.countryState?(vm.form.primaryInsurance.insurance_state?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label><div class="input-group input-group-sm"><select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.chart.primary.countryState" ng-options="item as item.state for item in vm.states track by item.id"><option value="">{{vm.chart.primary.countryState.state}}</option></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.primary.countryState = vm.chart.countryState"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.countryState && vm.form.primaryInsurance.insurance_states.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.countryState">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.chart.primary.zipCode?(vm.form.primaryInsurance.insurance_zipCode?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.chart.primary.zipCode" ui-mask="99999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="true" ng-click="vm.chart.primary.zipCode = vm.chart.zip"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.primary.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.primary.zipCode && vm.form.primaryInsurance.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.chart.primary.zipCode">This field is required</span></div></div></div></div></div></div><button type="button" class="btn btn-success" ng-click="vm.addSecondaryInsurance()" ng-if="vm.secondaryInsurance == null"><i class="fa fa-save" aria-hidden="true"></i> Add Secondary</button> <button type="button" class="btn btn-danger" ng-click="vm.clearPrimaryInsurance()"><i class="fa fa-save" aria-hidden="true"></i> Clear</button></form>');
$templateCache.put('app/entities/chart/create/tpl/insurance-secondary-form-tpl.html','<h2 class="step-header">Insurance Information</h2><hr><form action="" name="vm.form.secondaryInsurance" class="form mb-15"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.insuranceCarrier?(vm.form.secondaryInsurance.insurance_carrier.$dirty || vm.form.secondaryInsurance.insurance_carrier.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_carrier">Insurance Carrier:</label><ui-select ng-model="vm.chart.secondary.insuranceCarrier" name="insurance_carrier" id="field_insurance_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{ $select.selected.id? $select.selected.name: $select.selected.name + \'(new)\'}}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0">{{carrier.id? carrier.name: carrier.name + \'(new)\' }}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.secondaryInsurance.insurance_carrier.$error.required"></span> <span class="help-block" ng-show="vm.form.secondaryInsurance.insurance_carrier.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.policyNumber?(vm.form.secondaryInsurance.insurance_policyNumber.$valid || vm.form.secondaryInsurance.insurance_policyNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_policyNumber">Policy Number:</label> <input type="text" class="form-control" name="insurance_policyNumber" id="field_insurance_policyNumber" required ng-model="vm.chart.secondary.policyNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.policyNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.policyNumber && vm.form.secondaryInsurance.insurance_policyNumber.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.policyNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.preCertPhone?(vm.form.secondaryInsurance.insurance_preCertPhone?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_preCertPhone">Pre-Cert Phone:</label> <input type="text" class="form-control" name="insurance_preCertPhone" id="field_insurance_preCertPhone" ng-model="vm.chart.secondary.preCertPhone" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.preCertPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.preCertPhone && vm.form.secondaryInsurance.insurance_preCertPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.preCertPhone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.groupNumber?(vm.form.secondaryInsurance.insurance_groupNumber?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_insurance_groupNumber">Group Number:</label> <input type="text" class="form-control" name="insurance_groupNumber" id="field_insurance_groupNumber" ng-model="vm.chart.secondary.groupNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.groupNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.groupNumber && vm.form.secondaryInsurance.insurance_groupNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.groupNumber">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.insuranceType?(vm.form.secondaryInsurance.insurance_type?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_insuranceType">Insurance Type:</label> <select class="form-control" id="field_insurance_insuranceType" name="insurance_type" ng-model="vm.chart.secondary.insuranceType" ng-options="insuranceType as insuranceType.name for insuranceType in vm.insuranceTypes track by insuranceType.id"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.insuranceType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.insuranceType && vm.form.secondaryInsurance.insurance_type.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.insuranceType">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.rxBin?(vm.form.secondaryInsurance.insurance_rxBin?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_rxbin">RxBin:</label> <input type="text" class="form-control" name="insurance_rxBin" id="field_insurance_rxBin" ng-model="vm.chart.secondary.rxBin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.rxBin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.rxBin && vm.form.secondaryInsurance.insurance_rxBin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.rxBin">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.pcn?(vm.form.secondaryInsurance.insurance_pcn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_pcn">RxPCN:</label> <input type="text" class="form-control" name="insurance_pcn" id="field_insurance_pcn" ng-model="vm.chart.secondary.pcn"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.pcn"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.pcn && vm.form.secondaryInsurance.insurance_pcn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.pcn">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.memberId?(vm.form.secondaryInsurance.insurance_memberId?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_memberId">Member:</label> <input type="text" class="form-control" name="insurance_memberId" id="field_insurance_memberId" ng-model="vm.chart.secondary.memberId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.memberId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vvm.chart.secondary.memberId && vm.form.secondaryInsurance.insurance_memberId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.memberId">This field is suggested</span></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.firstName?(vm.form.secondaryInsurance.insurance_firstName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_firstName">Subscriber First Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_firstName" id="field_insurance_firstName" required ng-model="vm.chart.secondary.firstName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.firstName = vm.chart.firstName"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.firstName && vm.form.secondaryInsurance.insurance_firstName.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.firstName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.lastName?(vm.form.secondaryInsurance.insurance_lastName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_lastName">Subscriber Last Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_lastName" id="field_insurance_lastName" required ng-model="vm.chart.secondary.lastName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.lastName = vm.chart.lastName"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.lastName && vm.form.secondaryInsurance.insurance_lastName.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.lastName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.dob?(vm.form.secondaryInsurance.insurance_dob?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Subscriber DOB:</label><div class="input-group input-group-sm"><input id="field_insurance_dob" type="text" class="form-control" name="insurance_dob" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.secondary.dob" is-open="vm.datePickerOpenStatus.insuranceDob"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'insuranceDob\')"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.dob = vm.chart.dateBirth"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button></div><span class="help-block" ng-show="!vm.chart.secondary.dob">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.socialSecurity?(vm.form.secondaryInsurance.insurance_ssn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_ssn">Subscriber SSN:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_ssn" id="field_insurance_ssn" ng-model="vm.chart.secondary.socialSecurity" ui-mask="999-99-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.socialSecurity = vm.chart.social"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.socialSecurity"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.socialSecurity && vm.form.secondaryInsurance.insurance_ssn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.socialSecurity">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.insuranceRelation?(vm.form.secondaryInsurance.insurance_insuranceRelation?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_insuranceRelation">Relationship:</label> <select class="form-control" id="field_insurance_insuranceRelation" name="insurance_insuranceRelation" required ng-model="vm.chart.secondary.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insuranceRelations track by insuranceRelation.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.insuranceRelation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.insuranceRelation && vm.form.secondaryInsurance.insurance_insuranceRelation.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.insuranceRelation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.gender?(vm.form.secondaryInsurance.gender?\'has-success\':\'\'):\'has-error\'"><label for="gender">Subscriber Gender:</label><div class="input-group input-group-sm"><select class="form-control" id="gender" name="gender" required ng-model="vm.chart.secondary.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.gender = vm.chart.sex"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.chart.secondary.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.chart.secondary.gender && vm.form.secondaryInsurance.gender.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.gender">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.phone?(vm.form.secondaryInsurance.insurance_phone?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.chart.secondary.phone" ui-mask="(999) 999-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.phone = vm.chart.phone"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.phone && vm.form.secondaryInsurance.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.phone">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.address?(vm.form.secondaryInsurance.insurance_address?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.chart.secondary.address"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.address = vm.chart.address"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.address && vm.form.secondaryInsurance.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.address">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.address2?(vm.form.secondaryInsurance.insurance_address2?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.chart.secondary.address2"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.address2 = vm.chart.addressTwo"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.address2 && vm.form.secondaryInsurance.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.chart.secondary.address2">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.city?(vm.form.secondaryInsurance.insurance_city?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.chart.secondary.city"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.city = vm.chart.city"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.city && vm.form.secondaryInsurance.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.city">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.secondary.countryState?(vm.form.secondaryInsurance.insurance_state?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label><div class="input-group input-group-sm"><select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.chart.secondary.countryState" ng-options="item as item.state for item in vm.states track by item.id"><option value="">{{vm.chart.secondary.countryState.state}}</option></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.chart.secondary.countryState = vm.chart.countryState"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.countryState && vm.form.secondaryInsurance.insurance_states.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.countryState">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.chart.secondary.zipCode?(vm.form.secondaryInsurance.insurance_zipCode?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.chart.secondary.zipCode" ui-mask="99999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="true" ng-click="vm.chart.secondary.zipCode = vm.chart.zip"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.chart.secondary.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.chart.secondary.zipCode && vm.form.secondaryInsurance.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.chart.secondary.zipCode">This field is required</span></div></div></div></div></div></div><button type="button" class="btn btn-success" ng-click="vm.removeSecondaryInsurance()"><i class="fa fa-save" aria-hidden="true"></i> Remove</button></form>');
$templateCache.put('app/entities/care-coordination/chart/new/care-coordination.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Care Coordination</strong> <a href="" class="btn-icon" uib-tooltip="Add Care Coordination" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0" ng-repeat="careCoordination in vm.careCoordinations"><span><input type="checkbox" style="margin: 0; vertical-align: middle" ng-checked="careCoordination.excecuted" ng-change="vm.saveExcecuted(careCoordination)" ng-model="careCoordination.excecuted"></span><span class="click-layer" ng-class="{\'checked\':careCoordination.excecuted}" ng-click="vm.edit(careCoordination.id)"><strong style="text-transform: capitalize">{{careCoordination.title}}</strong> - <span>{{vm.plusDays(careCoordination) | date }}</span></span></p></div>');
$templateCache.put('app/entities/care-coordination/chart/old/care-coordination.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon red small"><i class="fa fa-user-md fa-inverse" aria-hidden="true"></i></div><h2 class="head-text small">Care Coordination</h2></header><div class="item-body vertical-flow"><div class="table-responsive"><table class="table table-condensed table-striped"><thead><tr><th>Complete</th><th>Title</th><th>Due Date</th><th></th></tr></thead><tbody><tr ng-repeat="careCoordination in vm.careCoordinations" ng-if="careCoordination.active" ng-class="{checked:careCoordination.excecuted}"><td><div class="checkbox text-center"><label><input type="checkbox" title="Complete" ng-checked="careCoordination.excecuted" ng-model="careCoordination.excecuted" ng-change="vm.saveExcecuted(careCoordination)"></label></div></td><td class="text-left"><span>{{careCoordination.title}}</span></td><td class="text-left">{{vm.plusDays(careCoordination) | date }}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link blue" ng-click="vm.edit(careCoordination.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.del(careCoordination.id)"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></div></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Care Coordination <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"><ul></ul></ul></div></div>');
$templateCache.put('app/entities/chart/detail/new/chart-detail.html','<div class="content no-padding"><div class="chart-layout"><header class="content-heading"></header><div class="content-grid"><aside class="content-side" ng-class="{\'not-allowed\': !vm.chart.allowReadmit}" resizable r-directions="[\'right\']" r-flex="true"><header class="selector"><select name="previousAdmission" id="field_previous_admission" class="form-control input-sm" ng-model="vm.chartSelected" ng-change="vm.changedChart()" ng-options="item as item.field for item in vm.previousCharts track by item.id"></select></header><section class="data-section with-pic"><div class="photo"><img class="photo" id="imgPicture" alt="User profile picture" ng-src-auth="{{vm.chart}}" ng-click="vm.editImage()"></div><div class="info"><h4 class="name mt-0">{{vm.chart.firstName + \' \' + (vm.chart.middleName ? vm.chart.middleName + \' \' : \'\') + vm.chart.lastName}}</h4><p><strong>DOB:</strong> {{(vm.chart.dateBirth | date: inputDateFormat) + \' - (\' + vm.chart.age + \' years old)\'}}</p><p><strong>A. Date:</strong> {{vm.chart.admissionDate | date: inputDateFormat}}</p><p><strong>Mr#:</strong> {{vm.chart.mrNo}}</p><p><strong>P. Method:</strong> {{vm.chart.typePaymentMethods ? vm.chart.typePaymentMethods.name : \'-\'}}</p><p><strong>Status:</strong> <span class="label" ng-class="{\'label-success\': vm.chart.status === \'CLOSED\',\n                                                                     \'label-warning\': vm.chart.status === \'WAITING\',\n                                                                     \'label-primary\': vm.chart.status === \'CURRENT\',\n                                                                     \'label-default\': vm.chart.status === \'ARCHIVE\'}">{{vm.chart.status}}</span></p></div></section><section class="data-section" has-any-authority="{{vm.accessCareCoordinationView}}"><div ui-view="chart-urgent-issue"></div></section><section class="data-section" has-any-authority="{{vm.accessInsuranceView}}" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\'"><div ui-view="chart-insurance"></div></section><section class="data-section" has-any-authority="{{vm.accessContactsView}}"><div ui-view="chart-contacts"></div></section><section class="data-section" has-any-authority="{{vm.accessDiagnosesView}}"><div ui-view="chart-diagnoses"></div></section><section class="data-section" has-any-authority="{{vm.accessCareTeamView}}"><div ui-view="chart-care-team"></div></section><section class="data-section" has-any-authority="{{vm.accessCareCoordinationView}}"><div ui-view="chart-care-coordination"></div></section><section class="data-section" has-any-authority="{{vm.accessAllergiesView}}"><div ui-view="chart-allergies"></div></section><section class="data-section" has-any-authority="{{vm.accessDietsView}}"><div ui-view="chart-diets"></div></section><section class="data-section" has-any-authority="{{vm.accessVitalsView}}"><div ui-view="chart-vitals"></div></section><section class="data-section" has-any-authority="{{vm.accessGlucoseView}}"><div ui-view="chart-glucose"></div></section><section class="data-section" has-any-authority="{{vm.accessWeightView}}"><div ui-view="chart-weight"></div></section><section class="data-section" has-any-authority="{{vm.accessAlcoholView}}"><div ui-view="chart-alcohol"></div></section><section class="data-section" has-any-authority="{{vm.accessDrugsView}}"><div ui-view="chart-drug"></div></section><section class="data-section" has-any-authority="{{vm.accessFileView}}"><div ui-view="chart-files"></div></section><section class="data-section" has-any-authority="{{vm.accessChartNoteView}}"><div ui-view="chart-notes"></div></section></aside><div class="content-area"><div class="chart-classic" style="width: 100%"><uib-tabset active="vm.activeTab" class="chart-navs simple-tabs no-tab-padding" justified="true"><uib-tab index="vm.TAB.BASIC_INFORMATION" heading="Demographic" select="vm.select(vm.TAB.BASIC_INFORMATION)"><ng-include src="\'app/entities/chart/detail/new/tabs/tab-basic-info.html\'"></ng-include></uib-tab><uib-tab index="vm.TAB.LAB_ORDERS" heading="Labs Orders" select="vm.select(vm.TAB.LAB_ORDERS)" has-any-authority="{{vm.accessLabOrdersView}}"><div class="tab-lab-orders"><div ui-view="chart-lab-orders"></div></div></uib-tab><uib-tab index="vm.TAB.E_LAB" heading="eLabs" select="vm.select(vm.TAB.E_LAB)" has-any-authority="{{vm.accessELabsView}}"><div class="tab-e-labs"><div ui-view="chart-e-labs"></div></div></uib-tab><uib-tab index="vm.TAB.MEDICATIONS" heading="Medications" select="vm.select(vm.TAB.MEDICATIONS)" has-any-authority="{{vm.accessMedicationView}}"><div class="tab-medications"><div ui-view="chart-patient-medications"></div></div></uib-tab><uib-tab index="vm.TAB.RCOPIA_PRESCRIPTION" heading="Rcopia Prescriptions" select="vm.select(vm.TAB.RCOPIA_PRESCRIPTION)" has-any-authority="{{vm.accessMedicationView}}" ng-if="(vm.corporation.rcopiaIntegration && vm.chart.rcopiaId) || vm.chart.rcopiaId"><div class="tab-medications"><div ui-view="chart-patient-rcopia-prescription"></div></div></uib-tab><uib-tab index="vm.TAB.RCOPIA_MEDICATION" heading="Rcopia Medications" select="vm.select(vm.TAB.RCOPIA_MEDICATION)" has-any-authority="{{vm.accessMedicationView}}" ng-if="(vm.corporation.rcopiaIntegration && vm.chart.rcopiaId) || vm.chart.rcopiaId"><div class="tab-medications"><div ui-view="chart-patient-rcopia-medications"></div></div></uib-tab><uib-tab index="vm.TAB.GROUP_SESSION" heading="Group Sessions" select="vm.select(vm.TAB.GROUP_SESSION)" has-any-authority="{{vm.accessGroupSessionView}}"><div class="tab-group-sessions"><div ui-view="chart-group-sessions"></div></div></uib-tab><uib-tab index="vm.TAB.EVALUATION" heading="Care & Deliveries" select="vm.select(vm.TAB.EVALUATION)" has-any-authority="{{vm.accessEvaluationView}}"><div class="tab-care-deliveries"><div ui-view="chart-evaluation"></div></div></uib-tab><uib-tab index="vm.TAB.SUPER_BILL" heading="SuperBill" select="vm.select(vm.TAB.SUPER_BILL)" has-any-authority="ROLE_SYSTEM,ROLE_SYSTEM_ADMIN" ng-if="false"><div class="tab-medications"><div ui-view="chart-super-bill"></div></div></uib-tab><uib-tab index="vm.TAB.RCOPIA" heading="Rcopia" select="vm.select(vm.TAB.RCOPIA)" ng-if="vm.corporation.rcopiaIntegration && vm.rcopiaAccount && vm.chart.status != \'CLOSED\' && !vm.chart.rcopiaId"><div class="tab-medications"><div ui-view="rcopia"></div></div></uib-tab><uib-tab index="vm.TAB.RCOPIA_SSO_LOGS" heading="Rcopia SSO Logs" select="vm.select(vm.TAB.RCOPIA_SSO_LOGS)" has-any-authority="ROLE_SYSTEM,ROLE_SYSTEM_ADMIN" ng-if="vm.corporation.rcopiaIntegration && vm.chart.rcopiaId"><div class="tab-medications"><div ui-view="rcopia-sso-logs"></div></div></uib-tab></uib-tabset></div></div></div></div></div>');
$templateCache.put('app/entities/chart/detail/old/chart-detail.html','<div class="menu-actions" ng-class="{\'active\':check}"><div class="icon" ng-click="check=!check" ng-mouseenter="hovering=true" ng-mouseleave="hovering=false"><i class="fa fa-2x" ng-class="check?\'fa-times\':\'fa-ellipsis-h\'"></i></div><ul class="list-unstyled"><li><h5 class="heading">Actions</h5></li><li class="action-link" ng-if="vm.chart.status == \'WAITING\'"><a ng-click="vm.openChangeStatusChart(\'CURRENT\')"><i class="fa fa-chevron-circle-right"></i>Set to Current</a></li><li class="action-link" ng-if="vm.chart.status != \'CLOSED\'" has-any-authority="{{vm.accessCloseChart}}"><a ng-click="vm.openChangeStatusChart(\'CLOSED\')"><i class="fa fa-chevron-circle-right"></i>Close Chart</a></li><li class="action-link" ng-if="vm.chart.status == \'CLOSED\'"><a ng-click="vm.openChangeStatusChart(\'REOPEN\')"><i class="fa fa-chevron-circle-right"></i>Reopen Chart</a></li><li class="action-link" ng-if="vm.chart.status != \'CLOSED\'"><a ng-click="vm.showFacesheetTpl()"><i class="fa fa-file"></i>Chart Export</a></li><li class="action-link"><a ng-click="vm.copyChart()"><i class="fa fa-file"></i>Copy Chart</a></li><li class="action-link"><a ng-click="vm.executePrint()"><i class="fa fa-cutlery"></i>Food memo</a></li><li class="action-link"><a ng-click="vm.showPreviousCharts()"><i class="fa fa-chevron-circle-right"></i>Previous Admission(s)</a></li><li class="action-link"><a ng-click="vm.showBlueAlertPopup()"><i class="fa fa-bell"></i>Blue Alerts</a></li><li><h5 class="heading">Panels</h5><ul class="list-unstyled hidden-items"><li class="list-item" ng-repeat="(attr, item) in vm.menu"><a class="item-toggler" ng-click="vm.toggleItem(attr)"><i class="fa" aria-hidden="true" ng-class="item.value?\'fa-eye\':\'fa-eye-slash\'"></i> </a><a class="info-item" ng-click="vm.goToItem(attr)">{{item.name}}</a></li></ul></li></ul></div><ng-include src="\'app/entities/tpl/section-header-tpl.html\'"></ng-include><section class="patient-dashboard"><!--Basic Info--><div class="dash-item size-half basic-info" id="basic-info"><div data-watermark="{{vm.chart.status == \'CURRENT\' ? \'\' : vm.chart.status}}"><div class="item-body"><div class="left"><div class="patient-picture"><img class="photo" id="imgPicture" alt="User profile picture" ng-src-auth="{{vm.chart}}" ng-click="vm.editImage()"></div><h4 class="patient-name">{{vm.chart.firstName + \' \' + (vm.chart.middleName?vm.chart.middleName + \' \': \'\') + vm.chart.lastName}}</h4><table class="table"><tbody><tr><td class="tab-label">P. Name:</td><td>{{vm.chart.preferredName ? vm.chart.preferredName : \'-\'}}</td></tr><tr><td class="tab-label">Mr No:</td><td><strong>{{vm.chart.mrNo}}</strong></td></tr><tr><td class="tab-label">Social No:</td><td>{{vm.chart.social ? (vm.chart.social | ssnFormat): \'-\'}}</td></tr><tr><td class="tab-label">DOB:</td><td>{{vm.chart.dateBirth | date: inputDateFormat}}</td></tr><tr><td class="tab-label">Admission:</td><td>{{vm.chart.admissionDate ? (vm.chart.admissionDate | date: inputDateTimeFormatA) : \'-\'}}</td></tr><tr ng-if="vm.checkField(\'SOBRIETY_DATE\')"><td class="tab-label">Sobriety Date:</td><td>{{vm.chart.sobrietyDate ? (vm.chart.sobrietyDate | date: inputDateFormat): \'-\'}}</td></tr><tr><td class="tab-label">Level of Care:</td><td><strong>{{vm.chart.typeLevelCare ? vm.chart.typeLevelCare.name : \'-\'}}</strong> <i class="fa fa-eye" aria-hidden="true" title="View history" ng-click="vm.showLevelCareHistory()"></i></td></tr><tr><td class="tab-label">Gender:</td><td>{{vm.chart.sex}}</td></tr><tr ng-if="vm.checkField(\'BED\')"><td class="tab-label">Bed:</td><td>{{vm.chart.bed ? vm.chart.bed.name : \'-\'}}</td></tr><tr><td class="tab-label">Allow Readmit:</td><td>{{vm.chart.allowReadmit ? \'YES\' : \'NO\'}}</td></tr><tr><td class="tab-label">Eternal ID:</td><td>{{vm.chart.externalId ? vm.chart.externalId : \'-\'}}</td></tr></tbody></table></div><!-- /left --><div class="right"><table class="table"><tbody><tr><td class="tab-label"><i class="fa fa-map-marker" aria-hidden="true"></i>Address:</td><td>{{vm.chart.address + \', \' + vm.chart.city + \', \' + (vm.chart.countryState ? vm.chart.countryState.state : \'\') + \' \' + vm.chart.zip}}</td></tr><tr><td class="tab-label">Phone:</td><td>{{(vm.chart.phone && !isNaN(vm.chart.phone)) ? (vm.chart.phone | phone) : \'-\'}}</td></tr><tr><td class="tab-label">Alt. Phone:</td><td>{{(vm.chart.altPhone && !isNaN(vm.chart.altPhone)) ? (vm.chart.altPhone | phone) : \'-\'}}</td></tr><tr><td class="tab-label">Email:</td><td>{{vm.chart.email ? vm.chart.email: \'-\'}}</td></tr><tr><td class="table-divider"></td></tr><tr><td class="tab-label"><i class="fa fa-usd" aria-hidden="true"></i> Payment Method:</td><td>{{vm.chart.typePaymentMethods ? vm.chart.typePaymentMethods.name : \'-\'}}</td></tr><tr><td class="tab-label">Marital Status:</td><td>{{vm.chart.typeMaritalStatus ? vm.chart.typeMaritalStatus.name : \'-\'}}</td></tr><tr><td class="tab-label">Race:</td><td>{{vm.chart.typeRace ? vm.chart.typeRace.name : \'-\'}}</td></tr><tr><td class="tab-label">Ethnicity:</td><td>{{vm.chart.typeEthnicity ? vm.chart.typeEthnicity.name : \'-\'}}</td></tr><tr><td class="table-divider"></td></tr><tr><td class="tab-label">Date First Contact:</td><td>{{vm.chart.dateFirstContact ? (vm.chart.dateFirstContact | date: inputDateFormat): \'-\'}}</td></tr><tr><td class="tab-label">1st contact name:</td><td>{{vm.chart.firstContactName ? vm.chart.firstContactName : \'-\'}}</td></tr><tr><td class="tab-label">1st contact Phone:</td><td>{{(vm.chart.firstContactPhone && !isNaN(vm.chart.firstContactPhone)) ? (vm.chart.firstContactPhone | phone) : \'-\'}}</td></tr><tr><td class="tab-label">1st contact relationship:</td><td>{{vm.chart.firstContactRelationship?vm.chart.firstContactRelationship:\'-\'}}</td></tr><tr><td class="table-divider"></td></tr><tr><td class="tab-label"><i class="fa fa-user" aria-hidden="true"></i> Referral Source:</td><td>{{vm.chart.referrer ? vm.chart.referrer : \'-\'}}</td></tr><tr><td class="tab-label">Discharge Date:</td><td>{{vm.chart.dischargeDate ? (vm.chart.dischargeDate | date: inputDateTimeFormatA) : \'-\'}} <i class="fa fa-eye" aria-hidden="true" title="View history" ng-click="vm.showDischargeDateHistory()"></i></td></tr><tr><td class="tab-label">Discharge to:</td><td>{{vm.chart.dischargeTo ? vm.chart.dischargeTo : \'-\'}}</td></tr><tr><td class="tab-label">Discharge type:</td><td>{{vm.chart.typeDischargeType ? vm.chart.typeDischargeType.name : \'-\'}}</td></tr><tr ng-if="vm.checkField(\'MARKETER\')"><td class="tab-label">Outreach:</td><td>{{vm.chart.marketer?vm.chart.marketer.firstName + \' \' +vm.chart.marketer.lastName:\'-\'}}</td></tr><tr ng-if="vm.checkField(\'ADMISSION_REP\')"><td class="tab-label">Admission Rep:</td><td>{{vm.chart.admissionRep?vm.chart.admissionRep.firstName + \' \' +vm.chart.admissionRep.lastName:\'-\'}}</td></tr><tr><td class="table-divider"></td></tr><tr><td class="tab-label">Occupation:</td><td>{{vm.chart.occupancy ? vm.chart.occupancy : \'-\'}}</td></tr><tr><td class="tab-label">Employer Name:</td><td>{{vm.chart.employer?vm.chart.employer: \'-\'}}</td></tr><tr><td class="tab-label">Employer Phone:</td><td>{{(vm.chart.employerPhone && !isNaN(vm.chart.employerPhone)) ? (vm.chart.employerPhone | phone) : \'-\'}}</td></tr><tr><td class="table-divider"></td></tr><tr><td class="tab-label">Track:</td><td>{{vm.chart.track ? vm.chart.track.name : \'-\'}} <i class="fa fa-eye" aria-hidden="true" title="View history" ng-click="vm.showTrackHistory()"></i></td></tr></tbody></table></div><!-- /left --></div><!-- /item-body --><footer class="item-footer"><div class="fleft" ng-if="vm.chartPictureLicense"><a href="" class="footer-link" ng-click="vm.viewImageLicense();">View ID <i class="fa fa-id-card" aria-hidden="true"></i></a></div><div class="fleft" ng-if="vm.chart.status != \'CLOSED\'" has-any-authority="{{vm.accessEditId}}"><a href="" class="footer-link" ng-click="vm.editImageLicense();">{{vm.chartPictureLicense ? \'Edit ID \' : \'Add ID \'}} <i ng-class="vm.chartPictureLicense ? \'fa fa-id-card-o\' : \'fa fa-plus-circle\'" aria-hidden="true"></i></a></div><div class="fright" has-any-authority="{{vm.accessEditInfo}}"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.editInfo(vm.chart.id)">Edit Information <i class="fa fa-edit" aria-hidden="true"></i></button></div></footer></div></div><!-- /Basic Info --><!-- Urgent Issues --><!--\n    <div class="dash-item size-half urgent-issues" ng-class="vm.isHidden(\'.urgent-issues\')?\'item-hidden\':\'\'">\n        <div>\n            <button type="button" class="dash-close-btn"\n                    ng-click="vm.toggleItem(\'.urgent-issues\')">\n                <svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor"\n                     stroke-linecap="round" stroke-linejoin="round" stroke-width="4">\n                    <path d="M2 30 L30 2 M30 30 L2 2"/>\n                </svg>\n            </button>\n\n            <header class="item-header">\n                <div class="fancy-icon red big"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div>\n                <h2 class="head-text">Care Coordination</h2>\n            </header>\n            <div class="item-body">\n\n            </div>\n            &lt;!&ndash; /item-body &ndash;&gt;\n\n            <footer class="item-footer">\n                <div class="fleft">\n                    <a href="" class="footer-link">Add <i class="fa fa-plus-circle" aria-hidden="true"></i></a>\n                </div>\n                <div class="fright">\n                    <nav aria-label="Page navigation" class="dash-pagination">\n                        <ul class="pagination pagination-sm">\n                            <li class="disabled">\n                                <a href="#" aria-label="Previous">\n                                    <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>\n                                </a>\n                            </li>\n                            <li class="active"><a href="#">1</a></li>\n                            <li><a href="#">2</a></li>\n                            <li>\n                                <a href="#" aria-label="Next">\n                                    <i class="fa fa-arrow-circle-right" aria-hidden="true"></i>\n                                </a>\n                            </li>\n                        </ul>\n                    </nav>\n                </div>\n            </footer>\n        </div>\n    </div>\n--><!-- diagnoses --><div class="dash-item size-half diagnoses" id="diagnoses" ng-show="vm.menu.diagnoses.value" has-any-authority="{{vm.accessDiagnosesView}}"><div ui-view="diagnoses"></div></div><!-- /diagnoses --><!-- care-coordination --><div class="dash-item size-small care-coordination" id="careCoordination" ng-show="vm.menu.careCoordination.value" has-any-authority="{{vm.accessCareCoordinationView}}"><div ui-view="care-coordination"></div></div><!-- /care-coordination --><!-- care-team --><div class="dash-item size-small care-team" id="careTeam" ng-show="vm.menu.careTeam.value" has-any-authority="{{vm.accessCareTeamView}}"><div ui-view="care-team"></div></div><!-- /care-team --><!-- allergies --><div class="dash-item size-small allergies" id="allergies" ng-show="vm.menu.allergies.value" has-any-authority="{{vm.accessAllergiesView}}"><div ui-view="allergies"></div></div><!-- /allergies --><!-- diet --><div class="dash-item size-small diet" id="diet" ng-show="vm.menu.diet.value" has-any-authority="{{vm.accessDietsView}}"><div ui-view="diet"></div></div><!-- /diet --><div class="dash-item size-half insurance-board" id="insurance" ng-show="vm.menu.insurance.value" has-any-authority="{{vm.accessInsuranceView}}"><div ui-view="insurances"></div></div><div class="dash-item size-half patient-contacts" ng-show="vm.menu.contacts.value" id="contacts" has-any-authority="{{vm.accessContactsView}}"><div ui-view="contacts"></div></div><div class="dash-item size-full verification" id="verificationBenefits" ng-show="vm.menu.verificationBenefits.value" has-any-authority="{{vm.accessVerifytxView}}"><div ui-view="verifytx"></div></div><!-- Concurrent Reviews --><div class="dash-item size-full concurrent-reviews" ng-show="vm.menu.cReviews.value" id="cReviews" has-any-authority="{{vm.accessConcurrentReviewView}}"><div ui-view="concurrent"></div></div><!-- /concurrent-reviews --><div class="dash-item size-full patient-medications" id="patientMeds" ng-show="vm.menu.patientMeds.value" has-any-authority="{{vm.accessMedicationView}}"><div ui-view="patient-medications"></div></div><!--lab-orders--><div class="dash-item size-half patient-orders" ng-show="vm.menu.orders.value" id="orders" has-any-authority="{{vm.accessLabOrdersView}}"><div ui-view="lab-orders"></div></div><!--/lab-orders--><!--e-labs--><div class="dash-item size-half patient-orders" ng-show="vm.menu.eLabs.value" id="eLabs" has-any-authority="{{vm.accessELabsView}}"><div ui-view="e-labs"></div></div><!--/e-labs--><!--    <div class="dash-item size-small patient-meds" ng-show="vm.menu.mars.value" id="mars">\n        <div ui-view="mars"></div>\n    </div> &lt;!&ndash; /patient-meds &ndash;&gt;--><div class="dash-item size-full forms-tabs" ng-show="vm.menu.evaluation.value" id="evaluation" has-any-authority="{{vm.accessEvaluationView}}"><div ui-view="evaluation"></div></div><div class="dash-item size-small patient-vitals" data-charts="true" ng-show="vm.menu.vitals.value" id="vitals" has-any-authority="{{vm.accessVitalsView}}"><div ui-view="vitals"></div></div><!-- /patient-vitals --><div class="dash-item size-small patient-glucose" data-charts="true" ng-show="vm.menu.glucose.value" id="glucose" has-any-authority="{{vm.accessGlucoseView}}"><div ui-view="glucose"></div></div><!-- /patient-glucose --><div class="dash-item size-small patient-weight" data-charts="true" ng-show="vm.menu.weight.value" id="weight" has-any-authority="{{vm.accessWeightView}}"><div ui-view="weight"></div></div><!-- /patient-weight --><!-- Alcohol --><div class="dash-item size-small drug" data-charts="true" ng-show="vm.menu.drugs.value" id="drugs" has-any-authority="{{vm.accessAlcoholAndDrugsView}}"><div ui-view="drug"></div></div><!--    <div class="dash-item size-third alcohol" ng-show="vm.menu.alcohol.value" id="alcohol">\n        <div ui-view="alcohol"></div>\n    </div> &lt;!&ndash; /patient-Alcohol &ndash;&gt;--><div class="dash-item size-full group-sessions" ng-show="vm.menu.gSessions.value" id="gSessions" has-any-authority="{{vm.accessGroupSessionView}}"><div ui-view="gSessionsDetails"></div></div><!-- /group-sessions --><div class="dash-item size-half patient-notes" ng-show="vm.menu.notes.value" id="notes" has-any-authority="{{vm.accessChartNoteView}}"><div ui-view="notes"></div></div><div class="dash-item size-half patient-files" id="files" has-any-authority="{{vm.accessFileView}}"><div ui-view="files"></div></div><!--<div class="dash-item size-half patient-files" ng-show="vm.menu.files.value" id="files">\n        <div ui-view="files"></div>\n    </div>--><assistant-clipboard ng-model="assistantList" ng-if="showAssitant"></assistant-clipboard></section>');
$templateCache.put('app/entities/chart/discharge-date-history/new/chart-discharge-date-history-new.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Discharge Date History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15" ng-if="false"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Discharge Date</strong></th><th><strong>Employee</strong></th></tr></thead><tbody><tr ng-repeat="dischargeDate in vm.dischargeDates"><td>{{dischargeDate.dischargeDate | amDateFormat: amDateFormat}}</td><td>{{dischargeDate.employee | employeeName}}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div>');
$templateCache.put('app/entities/chart/discharge-date-history/old/chart-discharge-date-history.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Discharge Date History</h4></div><div class="modal-body"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.print()" ng-disabled="vm.isPrinting || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-save" aria-hidden="true"></i> Print</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/chart-care-team/chart/new/chart-care-team.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Care Team</strong> <a href="" class="btn-icon" uib-tooltip="Add Member" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 click-layer" ng-repeat="careTeam in vm.careTeamsActive" ng-click="vm.edit(careTeam.id)"><strong style="text-transform: capitalize">{{careTeam.typeSpeciality.name}}:</strong> <span>{{careTeam.employee.lastName}}, {{careTeam.employee.firstName}}</span></p></div>');
$templateCache.put('app/entities/chart-care-team/chart/old/chart-care-team.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon blue small"><i class="fa fa-users fa-inverse" aria-hidden="true"></i></div><h2 class="head-text small">Care Team</h2></header><div class="item-body vertical-flow"><uib-tabset active="vm.activeTab" justified="true" class="justified-tabs header-tabs"><uib-tab index="0" heading="Active" select="vm.keepActiveTab(0)"><table class="table"><tbody><tr ng-repeat="careTeam in vm.careTeamsActive"><td><p class="small mb-0"><strong>{{careTeam.typeSpeciality.name}}:</strong></p><p class="mb-0">{{careTeam.employee.lastName}}, {{careTeam.employee.firstName}}</p></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(careTeam.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(careTeam.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></uib-tab><uib-tab index="1" heading="Inactive" select="vm.keepActiveTab(1)"><table class="table"><tbody><tr ng-repeat="careTeam in vm.careTeamsInactive"><td><p class="small mb-0"><strong>{{careTeam.typeSpeciality.name}}:</strong></p><p class="mb-0">{{careTeam.employee.lastName}}, {{careTeam.employee.firstName}}</p></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link orange" ng-click="vm.edit(careTeam.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(careTeam.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></uib-tab></uib-tabset></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Member <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div></div>');
$templateCache.put('app/entities/chart-file/chart/new/chart-file.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Files:</strong> <a href="" class="btn-icon" uib-tooltip="Add Files" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><div ng-repeat="chartFile in vm.chartFile" style="display: flex; justify-content: flex-start; align-items: flex-start;"><p class="mb-0 click-layer" ng-click="vm.getFileAttached(chartFile)"><strong>{{chartFile.name}}</strong> <span>[{{chartFile.size}}]</span> - <span>{{chartFile.createdDate | amDateFormat: amDateFormat}}</span></p><a href="" class="btn-icon" uib-tooltip="Delete" style="margin-left: auto; padding: 0 5px; color: #dd4b39;" ng-click="vm.del(chartFile.id)"><i class="fa fa-trash" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/chart-file/chart/old/chart-file.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header"><div class="fancy-icon green big"><i class="fa fa-file-zip-o" aria-hidden="true"></i></div><h2 class="head-text">Files</h2></div><div class="item-body"><ul class="list-unstyled notes-list"><li class="note-item" ng-repeat="chartFile in vm.chartFile"><div class="note-content"><h4 class="note-title">{{chartFile.name}} - {{chartFile.createdDate | amDateFormat: amDateFormat}}</h4><div class="note-text text-justify"><p>{{chartFile.size}}</p></div></div><div class="actions"><a class="details-btn" title="See details" ng-click="vm.getFileAttached(chartFile)"><i class="fa fa-list-alt" aria-hidden="true"></i></a> <a class="remove-btn" title="Remove file" ng-click="vm.del(chartFile.id)"><i class="fa fa-trash" aria-hidden="true"></i></a></div></li></ul></div><footer class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add File <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></footer>');
$templateCache.put('app/entities/chart-note/chart/new/chart-note.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Notes:</strong> <a href="" class="btn-icon" uib-tooltip="Add Notes" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 click-layer" ng-repeat="note in vm.chartNotesActive" ng-click="vm.edit(note.id)"><strong style="text-transform: capitalize">{{note.employee.firstName + \' \' + note.employee.lastName}}</strong> - <span>{{note.date | amDateFormat: amDateFormat}}</span> <span style="display: block; margin: 5px 0 0">{{note.note}}</span></p></div>');
$templateCache.put('app/entities/chart-note/chart/old/chart-note.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header blank-border"><div class="fancy-icon green big"><i class="fa fa-hospital-o fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Notes</h2></header><div class="item-body"><uib-tabset active="0" class="header-tabs has-content-tabs"><uib-tab heading="Active"><div class="tab-wrapper"><div class="empty-content" ng-if="vm.chartNotesActive.length == 0"><div class="notice-text well well-lg"><span>There are no</span> <span class="big">ACTIVE</span> <span>Notes</span></div></div><ul class="list-unstyled reviews-list mb-15" ng-if="vm.chartNotesActive.length > 0"><li class="note-item" ng-repeat="note in vm.chartNotesActive"><div class="note-content"><h4 class="note-title">{{note.employee.firstName + \' \' + note.employee.lastName}} - {{note.date | amDateFormat: amDateFormat}}</h4><div class="note-text text-justify"><p>{{note.note}}</p></div></div><div class="actions"><a class="edit-btn" title="Edit Note" ng-click="vm.edit(note.id)"><i class="fa fa-edit" aria-hidden="true"></i></a> <a class="remove-btn" ng-if="vm.chart.status != \'CLOSED\'" title="Remove note" ng-click="vm.del(note.id)"><i class="fa fa-trash" aria-hidden="true"></i></a></div></li></ul><footer class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Note <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.chartNotesActive.length > 0"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItemsActive" items-per-page="vm.itemsPerPage" ng-model="vm.pageActive" ng-change="vm.transitionActive()"></ul></div></footer></div></uib-tab><uib-tab heading="Inactive"><div class="tab-wrapper"><div class="empty-content" ng-if="vm.chartNotesInactive.length == 0"><div class="notice-text well well-lg"><span>There are no</span> <span class="big">INACTIVE</span> <span>Notes</span></div></div><ul class="list-unstyled reviews-list" ng-if="vm.chartNotesInactive.length > 0"><li class="note-item" ng-repeat="note in vm.chartNotesInactive"><div class="note-content"><h4 class="note-title">{{note.employee.firstName + \' \' + note.employee.lastName}} - {{note.date | amDateFormat: amDateFormat}}</h4><div class="note-text text-justify"><p>{{note.note}}</p></div><div class="note-text text-justify" ng-if="note.deletedBy"><h6 class="note-title">Deleted By:</h6><p>{{note.deletedBy.firstName + \' \' + note.deletedBy.lastName}}</p></div></div></li></ul><footer class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Note <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.chartNotesInactive.length > 0"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItemsInactive" items-per-page="vm.itemsPerPage" ng-model="vm.pageInactive" ng-change="vm.transitionInactive()"></ul></div></footer></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/entities/concurrent-reviews/chart/new/concurrent-reviews-new.html','<h4 class="header-line" ng-if="vm.concurrentReviews.length > 0">Concurrent Reviews</h4><div class="chart-patient-info" ng-if="vm.concurrentReviews.length > 0"><div class="info-group full" style="padding: 15px 10px"><ul class="list-unstyled reviews-list mb-15 no-padding"><li class="review-item" ng-repeat="concurrent in vm.concurrentReviews"><div class="table-responsive"><table class="table table-condensed table-click" ng-click="vm.edit(concurrent.id)"><tbody><tr><td><strong>Start Date:</strong></td><td><strong>End Date:</strong></td><td><strong><i class="fa fa-hashtag" aria-hidden="true"></i> of days:</strong></td><td><strong>Frequency:</strong></td><td><strong>Level of Care:</strong></td><td><strong>LCD:</strong></td><td><strong>Auth Date:</strong></td><td><strong>Auth <i class="fa fa-hashtag" aria-hidden="true"></i>:</strong></td></tr><tr><td>{{concurrent.startDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.endDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.numberDates}}</td><td>{{concurrent.concurrentReviewFrequency ? concurrent.concurrentReviewFrequency.name : \'\'}}</td><td>{{concurrent.typeLevelCare ? concurrent.typeLevelCare.name : \'\'}}</td><td>{{concurrent.lastCoverageDate ? "Yes" : "No"}}</td><td>{{concurrent.authorizationDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.authorizationNumber}}</td></tr><tr><td><strong>Next Review:</strong></td><td><strong>Care Manager:</strong></td><td><strong>Care Manager Phone:</strong></td><td colspan="3"><strong>Insurance:</strong></td><td colspan="2"><strong>Created by:</strong></td></tr><tr><td>{{concurrent.nextReviewDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.careManager}}</td><td>{{concurrent.careManagerPhone | phone : \'-\'}}</td><td colspan="3">{{concurrent.insurance.insuranceCarrier.name}}</td><td colspan="2">{{concurrent.employee.firstName + \' \' + concurrent.employee.lastName}}</td></tr><tr><td colspan="8"><strong>Status:</strong></td></tr><tr><td colspan="8">{{concurrent.status}}</td></tr><tr><td colspan="8"><strong>Notes:</strong></td></tr><tr><td colspan="8">{{concurrent.notes}}</td></tr></tbody></table></div></li></ul><div class="text-center" ng-if="(vm.chart.typePaymentMethods.category === \'Insurance\') || (vm.concurrentReviews.length > 0)"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div>');
$templateCache.put('app/entities/concurrent-reviews/chart/old/concurrent-reviews.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header blank-border"><div class="fancy-icon green big"><i class="fa fa-hospital-o fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Concurrent Reviews</h2></header><div class="item-body"><uib-tabset active="0" class="header-tabs has-content-tabs"><uib-tab heading="Active"><div class="tab-wrapper" ui-view="concurrent-active"><div class="empty-content" ng-if="vm.concurrentReviewsActive.length == 0"><div class="notice-text well well-lg"><span>There are no</span> <span class="big">ACTIVE</span> <span>Concurrent Reviews</span></div></div><ul class="list-unstyled reviews-list mb-15" ng-if="vm.concurrentReviewsActive.length > 0"><li class="review-item" ng-repeat="concurrent in vm.concurrentReviewsActive"><ng-include src="\'app/entities/concurrent-reviews/chart/old/tpl/concurrent-reviews.html\'"></ng-include></li></ul><footer class="item-footer" ng-if="(vm.chart.typePaymentMethods.category === \'Insurance\') || (vm.concurrentReviewsActive.length > 0)"><div class="fleft" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\'"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Concurrent Review <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.concurrentReviewsActive.length > 0"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItemsActive" items-per-page="vm.itemsPerPage" ng-model="vm.pageActive" ng-change="vm.transitionActive()"></ul></div></footer></div></uib-tab><uib-tab heading="Inactive"><div class="tab-wrapper" ui-view="concurrent-inactive"><div class="empty-content" ng-if="vm.concurrentReviewsInactive.length == 0"><div class="notice-text well well-lg"><span>There are no</span> <span class="big">INACTIVE</span> <span>Concurrent Reviews</span></div></div><ul class="list-unstyled reviews-list" ng-if="vm.concurrentReviewsInactive.length > 0"><li class="review-item" ng-repeat="concurrent in vm.concurrentReviewsInactive"><ng-include src="\'app/entities/concurrent-reviews/chart/old/tpl/concurrent-reviews.html\'"></ng-include></li></ul><footer class="item-footer" ng-if="(vm.chart.typePaymentMethods.category === \'Insurance\') || (vm.concurrentReviewsInactive.length > 0)"><div class="fleft" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\'"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Concurrent Review <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.concurrentReviewsInactive.length > 0"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItemsInactive" items-per-page="vm.itemsPerPage" ng-model="vm.pageInactive" ng-change="vm.transitionInactive()"></ul></div></footer></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/entities/contacts/chart/new/contacts.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Contacts</strong> <a href="" class="btn-icon" uib-tooltip="Add Contacts" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 click-layer" ng-repeat="contact in vm.contacts" ng-click="vm.edit(contact.id)"><strong style="text-transform: capitalize">{{contact.fullName}}</strong> - <span>{{contact.phone | phone}}</span> <span ng-class="contact.countRelease === 0 ? \'label label-danger pull-right\' : \'label label-success pull-right\'" style="padding: 1px 3px;">{{contact.countRelease}}</span></p></div>');
$templateCache.put('app/entities/contacts/chart/old/contacts.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon yellow big"><i class="fa fa-address-book-o fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Contacts</h2></header><!-- item-body --><div class="item-body"><div class="contacts-layout"><header class="contacts-header"><h4 class="mb-0 mt-0"></h4><h4 class="mb-0 mt-0">Name</h4><h4 class="mb-0 mt-0">Type</h4><h4 class="mb-0 mt-0">Relationship</h4><h4 class="mb-0 mt-0">Phone</h4><h4 class="mb-0 mt-0"></h4></header><div class="contacts" ng-repeat="contact in vm.contacts"><div class="contact"><div class="main-info"><div style="padding: 0 5px 0 0"><button type="button" class="btn btn-default btn-sm" ng-if="contact.id != vm.contactSelected" ng-click="vm.openEvaluationPanel(contact.id)"><i class="fa fa-plus-circle" aria-hidden="true"></i></button> <button type="button" class="btn btn-default btn-sm" ng-if="contact.id == vm.contactSelected" ng-click="vm.closeEvaluationPanel()"><i class="fa fa-minus-circle" aria-hidden="true"></i></button></div><div class="name">{{contact.fullName}}</div><div class="type">{{contact.typePatientContactType.name.length != 0 ? contact.typePatientContactTypes.name : \'-\'}}</div><div class="relationship">{{contact.typePatientContactsRelationship ? contact.typePatientContactsRelationship.name : \'-\'}}</div><div class="phone">{{contact.phone ? (contact.phone | phone) : \'-\'}}</div><div class="actions"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(contact.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" class="dd-link red" ng-click="vm.del(contact.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div><!-- /dropdown--></div><!-- /actions--></div><div class="dropdown-info expanded" ng-if="contact.id == vm.contactSelected"><h4 class="title"><span>Release Care & Delivery for {{contact.fullName}}</span> <button type="button" class="btn btn-success btn-sm" ng-click="vm.assign(contact.id)"><i class="fa fa-plus" aria-hidden="true"></i> Add Form</button></h4><div class="release-info well well-sm"><div class="table-responsive"><table class="table table-condensed table-striped"><thead><tr><th><strong>Name</strong></th><th><strong>Status</strong></th><th><strong>Created By</strong></th><th><strong>Created Date</strong></th><th><strong>Last Modified</strong></th><th></th></tr></thead><tbody><tr ng-repeat="evaluation in vm.evaluations"><td>{{evaluation.name + (evaluation.title ? evaluation.title : "")}}</td><td class="text-left"><span class="label" ng-class="{\'label-primary\' : evaluation.status === \'Pending\',\n                                                            \'label-success\': evaluation.status === \'Finalized\',\n                                                            \'label-danger\': evaluation.status === \'Late\',\n                                                            \'label-warning\': evaluation.status === \'InReview\'}">{{evaluation.status}}</span></td><td class="text-left">{{evaluation.createdByEmployee.firstName + \' \' + evaluation.createdByEmployee.lastName}}</td><td class="text-left">{{evaluation.createdDate | amDateFormat: \'MM/DD/YYYY\'}}</td><td class="text-left">{{evaluation.lastModifiedDate | amDateFormat: \'MM/DD/YYYY\'}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="(evaluation.status != \'Pending\' && evaluation.status != \'Late\') || vm.chart.status == \'CLOSED\'"><a class="dd-link green" ui-sref="care-delivery-view({id: evaluation.id})"><i class="fa fa-list-alt" aria-hidden="true"></i> See Details</a></li><li role="menuitem" ng-if="(evaluation.status == \'Pending\' || evaluation.status == \'Late\' || evaluation.status == \'InReview\') && vm.chart.status != \'CLOSED\'"><a class="dd-link orange" ui-sref="care-delivery({id: evaluation.id})"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="(evaluation.status == \'Pending\' || evaluation.status == \'Late\') && vm.chart.status != \'CLOSED\'"><a ng-click="vm.evaluationDel(evaluation)" title="Delete" class="dd-link red"><i class="fa fa-trash" aria-hidden="true"></i>Delete</a></li><li role="menuitem" ng-if="(evaluation.addemdums && (evaluation.status == \'InReview\' || evaluation.status == \'Finalized\')) && vm.chart.status != \'CLOSED\'"><a ng-click="vm.evaluationAmended(evaluation.id)" title="Amended" class="dd-link green"><i class="fa fa-plus" aria-hidden="true"></i>Amended</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div><div class="text-center" ng-if="!vm.evaluations.length"><div class="text"><span>No data available in table</span></div></div></div><div class="text-center mb-15"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.evaluationTotalItems" items-per-page="vm.evaluationPerPage" ng-model="vm.evaluationPage" ng-change="vm.evaluationTransition()"></ul></div></div></div></div></div></div><!-- /item-body --><footer class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Contact <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></footer>');
$templateCache.put('app/entities/corporation/create/tpl/entity.html','<uib-progressbar max="vm.entities.length" value="vm.index + 1"><span style="color:white; white-space:nowrap;">{{vm.index + 1}} / {{vm.entities.length}}</span></uib-progressbar><h2 class="step-header">{{vm.entities[vm.index]}}</h2><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="table-responsive"><table class="table table-hover table-condensed" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div>');
$templateCache.put('app/entities/corporation/create/tpl/form.html','<h2 class="step-header">Corporation Setup</h2><hr><form name="vm.editForm" role="form"><jhi-alert-error></jhi-alert-error><div class="form-group has-feedback" ng-class="vm.corporation.name?(editForm.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" required ng-model="vm.corporation.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.corporation.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.corporation.name && editForm.name.$dirty"></span> <span class="help-block" ng-show="!vm.corporation.name">This field is required</span></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label for="field_active">Active:</label><br><toggle id="field_active" ng-model="vm.corporation.active" on="Yes" off="No" onstyle="btn-success" offstyle="btn-danger"></toggle></div></div></form>');
$templateCache.put('app/entities/diagnoses/chart/new/diagnoses.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Diagnoses</strong> <a href="" class="btn-icon" uib-tooltip="Add Diagnoses" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><div class="info no-padding" dnd-list="vm.diagnosesActive" dnd-disable-if="vm.chart.status == \'CLOSE\'" ng-if="vm.diagnosesActive.length > 0"><p class="mb-0 click-layer" ng-repeat="($index, diagnoses) in vm.diagnosesActive" ng-click="vm.edit(diagnoses.id)" dnd-handle dnd-draggable="diagnoses" dnd-dragend="vm.onDragEnd(vm.diagnosesActive)" dnd-moved="vm.diagnosesActive.splice($index, 1)" dnd-effect-allowed="move"><strong>{{diagnoses.xorder}}. {{diagnoses.icd10.code}}</strong> - <span>{{diagnoses.icd10.description}}</span></p></div></div>');
$templateCache.put('app/entities/diagnoses/chart/old/diagnoses.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header blank-border"><div class="fancy-icon green big"><i class="fa fa-bell-o" aria-hidden="true"></i></div><h2 class="head-text big">Diagnoses</h2></header><div class="item-body vertical-flow" style="padding-top: 5px"><uib-tabset active="vm.activeTab" class="header-tabs has-content-tabs"><uib-tab index="0" heading="Active" select="vm.keepActiveTab(0)"><div class="table-responsive"><table class="table table-condensed"><tbody><tr ng-repeat="diagnoses in vm.diagnosesActive"><td class="text-left">{{diagnoses.rank}}</td><td class="text-left"><strong>{{diagnoses.icd10.code}}</strong></td><td class="text-left">{{diagnoses.icd10.description}}</td><td class="text-left"><span class="label label-success" ng-if="diagnoses.signed">Signed</span> <span class="label label-danger" ng-if="!diagnoses.signed">Unsigned</span></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(diagnoses.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(diagnoses.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li><li role="menuitem" ng-if="vm.itHasCredentials"><a href="" class="dd-link red" ng-click="vm.discontinue(diagnoses.id)"><i class="fa fa-ban" aria-hidden="true"></i>Discontinue</a></li></ul></div></td></tr></tbody></table></div></uib-tab><uib-tab index="1" heading="Inactive" select="vm.keepActiveTab(1)"><table class="table"><tbody><tr ng-repeat="diagnoses in vm.diagnosesInactive"><td class="text-left">{{diagnoses.rank}}</td><td class="text-left"><strong>{{diagnoses.icd10.code}}</strong></td><td class="text-left">{{diagnoses.icd10.description}}</td><td class="text-left"><span class="label label-success" ng-if="diagnoses.signed">Signed</span> <span class="label label-danger" ng-if="!diagnoses.signed">Unsigned</span></td></tr></tbody></table></uib-tab></uib-tabset></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Diagnosis <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.diagnosesActive.length || vm.diagnosesInactive.length"><a href="" class="footer-link" ng-click="vm.loadDiagnoses()">Print <i class="fa fa-print" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/diet/chart/new/diet.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Diets:</strong> <a href="" class="btn-icon" uib-tooltip="Add Diets" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0 inline-list"><span class="click-layer" ng-repeat="diet in vm.dietsActive" ng-click="vm.edit(diet.id)">{{diet.typeFoodDiets.name}}</span></p></div>');
$templateCache.put('app/entities/diet/chart/old/diet.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon green small"><i class="fa fa-cutlery fa-inverse" aria-hidden="true"></i></div><h2 class="head-text small">Diets</h2></header><div class="item-body vertical-flow"><uib-tabset active="vm.activeTab" justified="true" class="justified-tabs header-tabs"><uib-tab index="0" heading="Active" select="vm.keepActiveTab(0)"><table class="table"><tbody><tr ng-repeat="diet in vm.dietsActive"><td class="text-left">{{diet.typeFoodDiets.name}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(diet.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(diet.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></uib-tab><uib-tab index="1" heading="Inactive" select="vm.keepActiveTab(1)"><table class="table"><tbody><tr ng-repeat="diet in vm.dietsInactive"><td class="text-left">{{diet.typeFoodDiets.name}}</td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(diet.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(diet.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table></uib-tab></uib-tabset></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add Diet <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div></div>');
$templateCache.put('app/entities/drug/chart/new/drug.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Drugs:</strong> <a href="" class="btn-icon" uib-tooltip="Add Drugs" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>{{vm.drug.date | amDateFormat: amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>BAR</strong> - {{(vm.drug.barbiturate == 1)? \'Positive\':(vm.drug.barbiturate == -1)? \'Negative\':(vm.drug.barbiturate == 0)? \'N/A\':\'-\'}}</span> <span><strong>MTD:</strong> - {{(vm.drug.methadone == 1)? \'Positive\':(vm.drug.methadone == -1)? \'Negative\':(vm.drug.methadone == 0)? \'N/A\':\'-\'}}</span> <span><strong>THC:</strong> - {{(vm.drug.tetrahydrocannabinol == 1)? \'Positive\':(vm.drug.tetrahydrocannabinol == -1)? \'Negative\':(vm.drug.tetrahydrocannabinol == 0)? \'N/A\':\'-\'}}</span> <span><strong>BZO:</strong> - {{(vm.drug.benzodiazepine == 1)? \'Positive\':(vm.drug.benzodiazepine == -1)? \'Negative\':(vm.drug.benzodiazepine == 0)? \'N/A\':\'-\'}}</span> <span><strong>MET</strong> - {{(vm.drug.methamphetamine == 1)? \'Positive\':(vm.drug.methamphetamine == -1)? \'Negative\':(vm.drug.methamphetamine == 0)? \'N/A\':\'-\'}}</span> <span><strong>BUP</strong> - {{(vm.drug.buprenorphine == 1)? \'Positive\':(vm.drug.buprenorphine == -1)? \'Negative\':(vm.drug.buprenorphine == 0)? \'N/A\':\'-\'}}</span> <span><strong>MOP</strong> - {{(vm.drug.morphine == 1)? \'Positive\':(vm.drug.morphine == -1)? \'Negative\':(vm.drug.morphine == 0)? \'N/A\':\'-\'}}</span> <span><strong>AMP</strong> - {{(vm.drug.amphetamine == 1)? \'Positive\':(vm.drug.amphetamine == -1)? \'Negative\':(vm.drug.amphetamine == 0)? \'N/A\':\'-\'}}</span> <span><strong>OPI</strong> - {{(vm.drug.opiates == 1)? \'Positive\':(vm.drug.opiates == -1)? \'Negative\':(vm.drug.opiates == 0)? \'N/A\':\'-\'}}</span> <span><strong>PCP</strong> - {{(vm.drug.phencyclidine == 1)? \'Positive\':(vm.drug.phencyclidine == -1)? \'Negative\':(vm.drug.phencyclidine == 0)? \'N/A\':\'-\'}}</span> <span><strong>OXT</strong> - {{(vm.drug.oxycodone == 1)? \'Positive\':(vm.drug.oxycodone == -1)? \'Negative\':(vm.drug.oxycodone == 0)? \'N/A\':\'-\'}}</span> <span><strong>TCA</strong> - {{(vm.drug.tricyclicAntidepressants == 1)? \'Positive\':(vm.drug.tricyclicAntidepressants == -1)? \'Negative\':(vm.drug.tricyclicAntidepressants == 0)? \'N/A\':\'-\'}}</span> <span><strong>COC</strong> - {{(vm.drug.cocaine == 1)? \'Positive\':(vm.drug.cocaine == -1)? \'Negative\':(vm.drug.cocaine == 0)? \'N/A\':\'-\'}}</span> <span><strong>MDMA</strong> - {{(vm.drug.methylenedioxymethamphetamine == 1)? \'Positive\':(vm.drug.methylenedioxymethamphetamine == -1)? \'Negative\':(vm.drug.methylenedioxymethamphetamine == 0)? \'N/A\':\'-\'}}</span></p></div>');
$templateCache.put('app/entities/drug/chart/old/drug-tpl.html','<table class="table"><tbody><tr><td><label><strong>Date</strong></label></td><td>{{vm.drug.date | amDateFormat: amDateFormat}}</td></tr><tr><td><label><strong>Barbiturate (BAR)</strong></label></td><td>{{(vm.drug.barbiturate == 1)? \'Positive\':(vm.drug.barbiturate == -1)? \'Negative\':(vm.drug.barbiturate == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Amphetamine (AMP)</strong></label></td><td>{{(vm.drug.amphetamine == 1)? \'Positive\':(vm.drug.amphetamine == -1)? \'Negative\':(vm.drug.amphetamine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Methadone (MTD)</strong></label></td><td>{{(vm.drug.methadone == 1)? \'Positive\':(vm.drug.methadone == -1)? \'Negative\':(vm.drug.methadone == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Opiates (OPI)</strong></label></td><td>{{(vm.drug.opiates == 1)? \'Positive\':(vm.drug.opiates == -1)? \'Negative\':(vm.drug.opiates == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Tetrahydrocannabinol (THC)</strong></label></td><td>{{(vm.drug.tetrahydrocannabinol == 1)? \'Positive\':(vm.drug.tetrahydrocannabinol == -1)? \'Negative\':(vm.drug.tetrahydrocannabinol == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Phencyclidine (PCP)</strong></label></td><td>{{(vm.drug.phencyclidine == 1)? \'Positive\':(vm.drug.phencyclidine == -1)? \'Negative\':(vm.drug.phencyclidine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Benzodiazepine (BZO)</strong></label></td><td>{{(vm.drug.benzodiazepine == 1)? \'Positive\':(vm.drug.benzodiazepine == -1)? \'Negative\':(vm.drug.benzodiazepine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Oxycodone (OXT)</strong></label></td><td>{{(vm.drug.oxycodone == 1)? \'Positive\':(vm.drug.oxycodone == -1)? \'Negative\':(vm.drug.oxycodone == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Methamphetamine (MET)</strong></label></td><td>{{(vm.drug.methamphetamine == 1)? \'Positive\':(vm.drug.methamphetamine == -1)? \'Negative\':(vm.drug.methamphetamine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Tricyclic Antidepressants (TCA)</strong></label></td><td>{{(vm.drug.tricyclicAntidepressants == 1)? \'Positive\':(vm.drug.tricyclicAntidepressants == -1)? \'Negative\':(vm.drug.tricyclicAntidepressants == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Buprenorphine (BUP)</strong></label></td><td>{{(vm.drug.buprenorphine == 1)? \'Positive\':(vm.drug.buprenorphine == -1)? \'Negative\':(vm.drug.buprenorphine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Cocaine (COC)</strong></label></td><td>{{(vm.drug.cocaine == 1)? \'Positive\':(vm.drug.cocaine == -1)? \'Negative\':(vm.drug.cocaine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Morphine (MOP)</strong></label></td><td>{{(vm.drug.morphine == 1)? \'Positive\':(vm.drug.morphine == -1)? \'Negative\':(vm.drug.morphine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Methylenedioxymethamphetamine (MDMA)</strong></label></td><td>{{(vm.drug.methylenedioxymethamphetamine == 1)? \'Positive\':(vm.drug.methylenedioxymethamphetamine == -1)? \'Negative\':(vm.drug.methylenedioxymethamphetamine == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Alcohol (ETG)</strong></label></td><td>{{(vm.drug.etg == 1)? \'Positive\':(vm.drug.etg == -1)? \'Negative\':(vm.drug.etg == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Fentanyl (FYL)</strong></label></td><td>{{(vm.drug.fyl == 1)? \'Positive\':(vm.drug.fyl == -1)? \'Negative\':(vm.drug.fyl == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>K2</strong></label></td><td>{{(vm.drug.k2 == 1)? \'Positive\':(vm.drug.k2 == -1)? \'Negative\':(vm.drug.k2 == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Ketamine (KET)</strong></label></td><td>{{(vm.drug.ket == 1)? \'Positive\':(vm.drug.ket == -1)? \'Negative\':(vm.drug.ket == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Kratom (KRA)</strong></label></td><td>{{(vm.drug.kra == 1)? \'Positive\':(vm.drug.kra == -1)? \'Negative\':(vm.drug.kra == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Tramadol (TML)</strong></label></td><td>{{(vm.drug.tml == 1)? \'Positive\':(vm.drug.tml == -1)? \'Negative\':(vm.drug.tml == 0)? \'N/A\':\'-\'}}</td></tr><tr><td><label><strong>Description</strong></label></td><td>{{vm.drug.description == null ? \'-\' : vm.drug.description}}</td></tr></tbody></table>');
$templateCache.put('app/entities/drug/chart/old/drug.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header has-chart"><nvd3 class="patient-chart p-drug" options="vm.activeTab == 0 ? vm.alcoholGraphOpt : vm.drugsGraphOpt" data="vm.activeTab == 0 ? vm.dataAlcohol : vm.dataDrug"></nvd3><h2 class="head-text small text-center">Alcohol & Drugs</h2></header><div class="item-body vertical-flow pb-0"><uib-tabset active="vm.activeTab" justified="true" class="justified-tabs header-tabs"><uib-tab index="0" heading="Alcohol" select="vm.keepActiveTab(0)" has-any-authority="{{vm.accessAlcoholView}}"><div class="tab-wrapper" ui-view="alcohol"></div></uib-tab><uib-tab index="1" heading="Drug" select="vm.keepActiveTab(1)" has-any-authority="{{vm.accessDrugsView}}"><ng-include src="\'app/entities/drug/chart/old/drug-tpl.html\'"></ng-include><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add New <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><a ng-click="vm.history()" class="footer-link">History <i class="fa fa-file-text-o" aria-hidden="true"></i></a></div></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/entities/evaluation/chart/new/evaluation.html','<div class="grid-flex"><div class="grid-item full no-padding" style="padding-top: 10px !important"><uib-tabset active="vm.activeTab" vertical="true" class="forms-tabs"><uib-tab index="$index" heading="{{process.name}}" class="table-item" ng-repeat="process in vm.patientProcesses" select="vm.select(process)"><div class="tab-wrapper"><!-- class: evaluation-table --><h4 class="header-line mt-0 pb-10" style="border-bottom: 1px solid #d2d6de"><strong>{{process.name}}</strong><div class="input-group input-group-sm search"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search(process)" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th>ID</th><th>Name</th><th>Service Date</th><th>Status</th><th>Created By</th><th></th></tr></thead><tbody><tr ng-repeat="evaluation in process.evaluations" class=""><td>{{ evaluation.id }}</td><td class="name status">{{evaluation.name + (evaluation.title ? evaluation.title : "")}} {{evaluation.contactName != null ? \' (\' + evaluation.contactName + \')\' : \'\'}} <span ng-if="evaluation.review" class="yellow">REVIEW</span></td><td class="created"><span class="date" ng-if="evaluation.dayOfService">{{evaluation.dayOfService | amDateFormat: dateFormat}}</span> <span class="date" ng-else-if="evaluation.startBilling">{{evaluation.startBilling | amDateFormat: amDateFormat}}</span></td><td class="status"><span class="{{vm.getStatusClass(evaluation)}}">{{evaluation.status}}</span></td><td class=""><span class="">{{evaluation.createdByFirstName + \' \' + evaluation.createdByLastName}}</span></td><td style="width: 45px;"><!--Pending, InReview, Revoked, Expired, Late, Finalized, Amended--><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="(evaluation.status != \'Pending\' && evaluation.status != \'Late\') || vm.chart.status == \'CLOSED\'"><a class="dd-link green" ng-click="vm.detail(process, evaluation)"><i class="fa fa-list-alt" aria-hidden="true"></i> See Details</a></li><li role="menuitem" ng-if="(evaluation.addemdums && (evaluation.status == \'InReview\' || evaluation.status == \'Finalized\')) && vm.chart.status != \'CLOSED\'"><a class="dd-link blue" ng-click="vm.amended(process, evaluation)"><i class="fa fa-plus" aria-hidden="true"></i> Amended</a></li><li role="menuitem" ng-if="(evaluation.status == \'InReview\' || evaluation.status == \'Finalized\') && vm.chart.status != \'CLOSED\'"><a class="dd-link white" ng-click="vm.review(process, evaluation)"><i class="fa fa-clone" aria-hidden="true"></i> Review</a></li><li role="menuitem" ng-if="(evaluation.status == \'Pending\' || evaluation.status == \'Late\' || evaluation.status == \'InReview\') && vm.chart.status != \'CLOSED\'"><a class="dd-link orange" ng-click="vm.edit(process, evaluation)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" has-any-authority="{{vm.masterEdit}}" ng-if="evaluation.status == \'InReview\' || evaluation.status == \'Finalized\'"><a class="dd-link orange" ui-sref="master-edit({id: evaluation.id})"><i class="fa fa-edit" aria-hidden="true"></i> Master Edit</a></li><li role="menuitem" ng-if="(evaluation.status == \'Pending\' || evaluation.status == \'Late\') && vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(process, evaluation)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li><li role="menuitem" has-any-authority="{{vm.accessDeleteCareDelivery}}" ng-if="evaluation.status == \'InReview\' || evaluation.status == \'Finalized\'"><a href="" class="dd-link red" ng-click="vm.del(process, evaluation)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li><li role="menuitem" has-any-authority="ROLE_SYSTEM,ROLE_SYSTEM_ADMIN"><a href="" class="dd-link orange" ng-click="vm.audit(evaluation)"><i class="fa fa-warning" aria-hidden="true"></i> Audit</a></li></ul></div></td></tr></tbody></table></div><div class="text-center" ng-if="process.page && process.totalItems"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="process.totalItems" items-per-page="vm.itemsPerPage" ng-model="process.page" ng-change="vm.transition(process)"></ul></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.assignNew(vm.patientProcesses[vm.activeTab])"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add Form</button> <button type="button" class="btn btn-default" ng-if="vm.chart.typeLevelCare && vm.patientProcesses[vm.activeTab].evaluations == 0" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.loadCareAndDelivery(process)"><i class="fa fa-cog" aria-hidden="true" style="color: #dd4b39"></i> Pre Load Form</button> <button type="button" class="btn btn-default" ng-click="vm.openConsentBoost(process)"><i class="fa fa-bolt" aria-hidden="true" style="color: #00a7d0"></i> Boost</button> <button type="button" class="btn btn-default" ng-click="vm.generateConsent(process)"><i class="fa fa-user-circle" aria-hidden="true" style="color: #f39c12"></i> Generate Consent</button> <button type="button" class="btn btn-default" ng-click="vm.history(process)"><i class="fa fa-history" aria-hidden="true" style="color: #dd4b39"></i> History</button><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div><!-- /tab-wrapper --></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/entities/evaluation/chart/old/evaluation.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header"><div class="fancy-icon yellow big"><i class="fa fa-file-text-o fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Care & Delivery</h2></div><div class="item-body"><uib-tabset active="vm.activeTab" vertical="true" class="forms-tabs"><uib-tab index="$index" heading="{{process.name}}" class="table-item" ng-repeat="process in vm.patientProcesses" select="vm.select(process)"><div class="tab-wrapper"><!-- class: evaluation-table --><table class="table table-condensed table-hover"><thead><tr><th>Name</th><th>Service Date</th><th>Status</th><th>Created By</th><th></th></tr></thead><tbody><tr ng-repeat="evaluation in process.evaluations" class=""><td class="name">{{evaluation.name + (evaluation.title ? evaluation.title : "")}} {{evaluation.contactName != null ? \' (\' + evaluation.contactName + \')\' : \'\'}} <span ng-if="evaluation.review" class="yellow">REVIEW</span></td><td class="created"><span class="date" ng-if="evaluation.dayOfService">{{evaluation.dayOfService | amDateFormat: dateFormat}}</span> <span class="date" ng-else-if="evaluation.startBilling">{{evaluation.startBilling | amDateFormat: amDateFormat}}</span></td><td class="status"><span class="{{vm.getStatusClass(evaluation)}}">{{evaluation.status}}</span></td><td class=""><span class="">{{evaluation.createdByFirstName + \' \' + evaluation.createdByLastName}}</span></td><td style="width: 45px;"><!--Pending, InReview, Revoked, Expired, Late, Finalized, Amended--><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="(evaluation.status != \'Pending\' && evaluation.status != \'Late\') || vm.chart.status == \'CLOSED\'"><a class="dd-link green" ui-sref="care-delivery-view({id: evaluation.id})"><i class="fa fa-list-alt" aria-hidden="true"></i> See Details</a></li><li role="menuitem" ng-if="(evaluation.addemdums && (evaluation.status == \'InReview\' || evaluation.status == \'Finalized\')) && vm.chart.status != \'CLOSED\'"><a class="dd-link blue" ng-click="vm.amended(process, evaluation)"><i class="fa fa-plus" aria-hidden="true"></i> Amended</a></li><li role="menuitem" ng-if="(evaluation.status == \'InReview\' || evaluation.status == \'Finalized\') && vm.chart.status != \'CLOSED\'"><a class="dd-link white" ng-click="vm.review(process, evaluation)"><i class="fa fa-clone" aria-hidden="true"></i> Review</a></li><li role="menuitem" ng-if="(evaluation.status == \'Pending\' || evaluation.status == \'Late\' || evaluation.status == \'InReview\') && vm.chart.status != \'CLOSED\'"><a class="dd-link orange" ng-click="vm.edit(process, evaluation)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" has-any-authority="{{vm.masterEdit}}" ng-if="evaluation.status == \'InReview\' || evaluation.status == \'Finalized\'"><a class="dd-link orange" ui-sref="master-edit({id: evaluation.id})"><i class="fa fa-edit" aria-hidden="true"></i> Master Edit</a></li><li role="menuitem" ng-if="(evaluation.status == \'Pending\' || evaluation.status == \'Late\') && vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(process, evaluation)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li><li role="menuitem" has-any-authority="{{vm.accessDeleteCareDelivery}}" ng-if="evaluation.status == \'InReview\' || evaluation.status == \'Finalized\'"><a href="" class="dd-link red" ng-click="vm.del(process, evaluation)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr></tbody></table><footer class="item-footer"><div class="fleft" ng-if="vm.chart.typeLevelCare && vm.patientProcesses[vm.activeTab].evaluations == 0"><button type="button" class="button-link" ng-click="vm.loadCareAndDelivery(process)">Pre Load Form <i class="fa fa-cog" aria-hidden="true"></i></button></div><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.assign(vm.patientProcesses[vm.activeTab])">Add Form <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fleft"><button type="button" class="button-link" ng-click="vm.openConsentBoost(process)">Boost <i class="fa fa-bolt" aria-hidden="true"></i></button></div><div class="fright"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="process.page && process.totalItems" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="process.totalItems" items-per-page="vm.itemsPerPage" ng-model="process.page" ng-change="vm.transition(process)"></ul></div></footer></div><!-- /tab-wrapper --></uib-tab></uib-tabset></div>');
$templateCache.put('app/entities/evaluation/consent-boost/attachment/consent-boost-attachment-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Add Attachments</h4></div><udt-attach-evaluation-file evaluation-id="{{vm.evaluationId}}"></udt-attach-evaluation-file><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/evaluation/consent-boost/generate-consent/consent-boost-generate-consent-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Generate Consent</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="text-center"><button type="button" class="btn btn-success btn-sm" ng-click="vm.assign()" ng-disabled="vm.isSaving || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-check" aria-hidden="true"></i> Assign</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/evaluation/consent-boost/list/consent-boost.html','<section class="content no-padding"><div class="content-heading"><a ui-sref="chart({id: vm.chart.id, processId: vm.params.processId, tabId: vm.TAB.EVALUATION})" class="btn-back-link" style="margin-right: auto"><i class="fa fa-arrow-left" aria-hidden="true"></i>Back to patient\'s chart</a><div class="input-group input-group-sm"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn"><button type="button" class="btn btn-default" id="btnSearch" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></div><div class="content-grid"><div class="content-side" resizable r-directions="[\'right\']" r-flex="true"><udt-chart-header chart="vm.chart" show-allergies="true" sidebar-layout="true"></udt-chart-header></div><div class="content-area"><div class="grid-flex"><div class="grid-item full"><div class="empty-content" ng-if="vm.evaluations.length == 0"><div class="notice-text well well-lg"><span>There are no</span> <span class="big">FORMS</span> <span>in care and delivery for pending</span></div></div><div class="table-responsive" ng-if="vm.evaluations.length != 0"><table class="table table-condensed"><thead><tr><th style="width: 50px"><input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)"></th><th><strong>Form Name</strong></th><th style="width: 60px"></th></tr></thead><tbody><tr ng-repeat="evaluation in vm.evaluations track by $index"><td><input type="checkbox" ng-model="vm.selected[evaluation.id]" ng-click="vm.toggleOne(vm.selected, vm.selectAll)"></td><td><p class="name"><strong>{{evaluation.name + (evaluation.title ? evaluation.title : "")}}{{evaluation.contactName != null ? \' - \' +evaluation.contactName: \'\'}}</strong></p><div class="mb-15" style="padding: 10px; border: 1px solid #d2d6de; border-radius: 4px;"><p style="white-space: pre-wrap">{{evaluation.summary != null? evaluation.summary: \'-\'}}</p></div></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" title="Edit" class="dd-link orange" ui-sref="care-delivery({id: evaluation.id})"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" title="Add Multiple" class="dd-link blue" ng-click="vm.openModalAttachments(evaluation.id)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Attachments</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div></div></div><div class="buttons-toolbar btn-group"><button class="btn btn-default" ng-click="vm.openModalSignature()"><i class="fa fa-pencil-square" aria-hidden="true" style="color: #00a65a"></i> Patient Signature</button> <button type="button" class="btn btn-default" ng-click="vm.generateConsent()"><i class="fa fa-file-text" aria-hidden="true" style="color: #f39c12"></i> Generate Consent</button></div></div></div></section>');
$templateCache.put('app/entities/evaluation/dashboard/empty/empty.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation/dashboard/late/late.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation/dashboard/patient/pending-by-patient.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation/dashboard/review/review.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation/dashboard/staff/pending-by-staff.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/evaluation-template/assign-chart/new/evaluation-template-assign-new-dialog.html','<!--<form name="form" role="form">--><!--    <div class="modal-header">--><!--        <button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true"--><!--                ng-click="vm.clear()">--><!--            <svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">--><!--                <path d="M2 30 L30 2 M30 30 L2 2" />--><!--            </svg>--><!--        </button>--><!--        <div class="modal-icon">--><!--            <i class="fa fa-bell fa-inverse" aria-hidden="true"></i>--><!--        </div>--><!--        <h4 class="modal-title" id="myVitalsLabel">Assign Care & Delivery - {{vm.typePatientProcess.name}}</h4>--><!--    </div>--><!--    <div class="modal-body">--><!--        <div id="urgent-issues-dtable" ng-if="vm.chart.typeLevelCare != null">--><!--            <table class="table"--><!--                   datatable=""--><!--                   dt-options="vm.dtOptions"--><!--                   dt-columns="vm.dtColumns"--><!--                   dt-instance="vm.dtInstance">--><!--            </table>--><!--        </div>--><!--        <div class="empty-content" ng-if="vm.chart.typeLevelCare == null">--><!--            <div class="text">--><!--                <span>There is no</span>--><!--                <span>Level Of Care</span>--><!--            </div>--><!--        </div>--><!--    </div>--><!--    <div class="modal-footer">--><!--        <button type="submit" class="btn btn-success"  ng-click="vm.assign()" ng-disabled="vm.isSaving || vm.getSelectedIds(vm.selected).length == 0">--><!--            <i class="fa fa-save" aria-hidden="true"></i> Assign--><!--        </button>--><!--        <button type="button" class="btn btn-danger" ng-click="vm.clear()">--><!--            <i class="fa fa-ban" aria-hidden="true"></i> Cancel--><!--        </button>--><!--    </div>--><!--</form>--><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Assign Care & Delivery - {{vm.typePatientProcess.name}}</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" ng-if="vm.chart.typeLevelCare"></table><div class="empty-content" ng-if="!vm.chart.typeLevelCare"><div class="notice-text well well-lg"><span>There are no active</span> <span>level of care</span></div></div></div><div class="text-center"><button type="button" class="btn btn-success btn-sm" ng-click="vm.assign()" ng-disabled="vm.isSaving || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-check" aria-hidden="true"></i> Assign</button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div>');
$templateCache.put('app/entities/evaluation-template/assign-chart/old/evaluation-template-assign-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="modal-icon"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div><h4 class="modal-title" id="myVitalsLabel">Assign Care & Delivery - {{vm.typePatientProcess.name}}</h4></div><div class="modal-body"><div id="urgent-issues-dtable" ng-if="vm.chart.typeLevelCare != null"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="empty-content" ng-if="vm.chart.typeLevelCare == null"><div class="text"><span>There is no</span> <span>Level Of Care</span></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.assign()" ng-disabled="vm.isSaving || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-save" aria-hidden="true"></i> Assign</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/evaluation-template/update/tpl/metadata-tpl.html','<form name="vm.form.info_form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-change="vm.updateTitle()" ng-model="vm.evaluationTemplate.name" required><div ng-show="vm.form.info_form.name.$invalid"><p class="help-block" ng-show="vm.form.info_form.name.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_add_title">Add Title ({field###})</label> <input type="text" class="form-control" name="field_add_title" id="field_add_title" ng-model="vm.evaluationTemplate.addTitle" ng-trim="false"></div></div></div><div class="row"><div class="col-lg-12"><div class="form-group"><label for="field_resume">Summary</label> <textarea class="form-control" name="summary" id="field_resume" rows="5" data-resize="disabled" ng-model="vm.evaluationTemplate.summary"></textarea></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Patient Process</label><ui-select ng-model="vm.evaluationTemplate.typePatientProcess" name="typePatientProcess" id="field_typePatientProcess" ng-required="true" reset-search-input="true" title="Select Patient Process" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Select Patient Process">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.typePatientProcesses"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.form.info_form.typePatientProcess.$invalid"><p class="help-block" ng-show="vm.form.info_form.typePatientProcess.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label">Level of Care</label><ui-select ng-model="vm.evaluationTemplate.typeLevelCares" name="levelCare" id="field_levelCare" ng-required="true" reset-search-input="true" title="Select level of care" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Enter the name of the Level of Care ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.levelCares" refresh="vm.getLevelCare($select.search)" refresh-delay="0"><div ng-bind-html="item.name | highlight: $select.search"></div><!--<small ng-bind-html="item.description | highlight: $select.search"></small>--></ui-select-choices></ui-select><div ng-show="vm.form.info_form.levelCare.$invalid"><p class="help-block" ng-show="vm.form.info_form.levelCare.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Enable</label><br><toggle ng-model="vm.evaluationTemplate.enabled" on="Yes" off="No" id="field_enabled"></toggle></div></div><div class="col-lg-2"><div class="form-group"><label class="control-label">Billable</label><br><toggle ng-model="vm.evaluationTemplate.billable" on="Yes" off="No" id="field_billable"></toggle></div></div><div class="col-lg-2"><div class="form-group"><label class="control-label">Billing Type</label><br><select name="show" ng-model="vm.evaluationTemplate.billingType" class="form-control"><option></option><option value="PROFESSIONAL">PROFESSIONAL</option><option value="INSTITUTIONAL">INSTITUTIONAL</option></select></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Only One</label><br><toggle ng-model="vm.evaluationTemplate.onlyOne" on="Yes" off="No" id="field_only_one"></toggle></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Required Patient Signature</label><br><toggle ng-model="vm.evaluationTemplate.requiredPatientSignature" on="Yes" off="No" id="field_required_patient_signature" ng-change="vm.patientSignatureChange()"></toggle></div><div class="form-group"><label class="control-label">Required Guarantor Signature</label><br><toggle ng-model="vm.evaluationTemplate.requiredGuarantorSignature" on="Yes" off="No" id="field_requiredGuarantorSignature" ng-disabled="!vm.evaluationTemplate.requiredPatientSignature"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Required Staff Signature</label><br><toggle ng-model="vm.evaluationTemplate.forceStaffSignature" on="Yes" off="No" id="field_force_staff_signature" ng-change="vm.staffSignatureChange()"></toggle></div><div class="form-group"><label class="control-label">Staff Signature Credentials</label><ui-select id="field_staff_signature_authorities" name="staffSignatureCredentials" multiple="multiple" ng-model="vm.evaluationTemplate.staffSignatureCredentials" close-on-select="false" title="" ng-disabled="!vm.evaluationTemplate.forceStaffSignature"><ui-select-match placeholder="Select Credentials...">{{$item.name || $item}}</ui-select-match><ui-select-choices repeat="credential in vm.credentials | filter:$select.search">{{credential}}</ui-select-choices></ui-select></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Required Staff Review Signature</label><br><toggle ng-model="vm.evaluationTemplate.forceStaffReviewSignature" on="Yes" off="No" id="field_force_staff_review_signature" ng-change="vm.staffReviewSignatureChange()" ng-disabled="!vm.evaluationTemplate.forceStaffSignature"></toggle></div><div class="form-group"><label class="control-label">Staff Review Signature Credentials</label><ui-select id="field_staff_review_signature_credentials" name="staffReviewSignatureCredentials" multiple="multiple" ng-model="vm.evaluationTemplate.staffReviewSignatureCredentials" close-on-select="false" title="Treatment Days" ng-disabled="!vm.evaluationTemplate.forceStaffReviewSignature"><ui-select-match placeholder="Select Credentials...">{{$item.name || $item}}</ui-select-match><ui-select-choices repeat="credential in vm.credentials | filter:$select.search">{{credential}}</ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Required Filled By Days</label><br><input type="number" class="form-control" ng-model="vm.evaluationTemplate.requiredFilledByDays" id="field_requiredFilledByDays" name="requiredFilledByDays"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Expires in</label><br><input type="number" class="form-control" ng-model="vm.evaluationTemplate.validForDays" id="field_validForDays" name="validForDays"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Readmission Days</label><br><input type="number" class="form-control" ng-model="vm.evaluationTemplate.readmissionDays" id="field_readmissionDays" name="readmissionDays"></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Allow Revocation</label><br><toggle ng-model="vm.evaluationTemplate.allowRevocation" on="Yes" off="No" id="field_allowRevocation"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Amended</label><br><toggle ng-model="vm.evaluationTemplate.addemdums" on="Yes" off="No" id="field_addemdums"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_readmissionBasedOn">Readmission based on</label><br><select class="form-control" id="field_readmissionBasedOn" name="readmissionBasedOn" ng-required="vm.evaluationTemplate.readmissionDays" ng-model="vm.evaluationTemplate.readmissionBasedOn" ng-disabled="!vm.evaluationTemplate.readmissionDays || vm.evaluationTemplate.readmissionDays == 0" ng-options="item for item in vm.readmissionBasedOn track by item"><option></option></select><div ng-show="vm.form.info_form.readmissionBasedOn.$invalid"><p class="help-block" ng-show="vm.form.info_form.readmissionBasedOn.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_LoadAutomatic">Load Automatic</label><br><toggle ng-model="vm.evaluationTemplate.loadAutomatic" on="Yes" off="No" id="field_LoadAutomatic"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_release">Contact Release</label><br><toggle ng-model="vm.evaluationTemplate.release" on="Yes" off="No" id="field_release"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_consent">Consent</label><br><toggle ng-model="vm.evaluationTemplate.consent" on="Yes" off="No" id="field_consent"></toggle></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_mars">Mars</label><br><toggle ng-model="vm.evaluationTemplate.mars" on="Yes" off="No" id="field_mars"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_vital">Vital</label><br><toggle ng-model="vm.evaluationTemplate.vital" on="Yes" off="No" id="field_vital"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_diagnosis">Diagnosis</label><br><toggle ng-model="vm.evaluationTemplate.diagnosis" on="Yes" off="No" id="field_diagnosis"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_glucose">Glucose</label><br><toggle ng-model="vm.evaluationTemplate.glucose" on="Yes" off="No" id="field_glucose"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_allergies">Allergies</label><br><toggle ng-model="vm.evaluationTemplate.allergies" on="Yes" off="No" id="field_allergies"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_weight">Weight</label><br><toggle ng-model="vm.evaluationTemplate.weight" on="Yes" off="No" id="field_weight"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_weight">Diets</label><br><toggle ng-model="vm.evaluationTemplate.diets" on="Yes" off="No" id="field_diets"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_outcome_measurements">Outcome Measurements</label><br><toggle ng-model="vm.evaluationTemplate.outcomeMeasurements" on="Yes" off="No" id="field_outcome_measurements"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label">Suggested Minutes</label><br><input type="number" class="form-control" ng-model="vm.evaluationTemplate.suggestedMinutes" id="field_suggestedMinutes" name="suggestedMinutes"></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_weight">Medications</label><br><toggle ng-model="vm.evaluationTemplate.medications" on="Yes" off="No" id="field_medications"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_std_audit">STD Audit</label><br><toggle ng-model="vm.evaluationTemplate.stdAudit" on="Yes" off="No" id="field_std_audit"></toggle></div></div><div class="col-lg-4"><div class="form-group"><label class="control-label" for="field_landscape">Print in landscape</label><br><toggle ng-model="vm.evaluationTemplate.landscape" on="Yes" off="No" id="field_landscape"></toggle></div></div></div></div></form>');
$templateCache.put('app/entities/facesheet-tpl/chart-report/new/facesheet-tpl-report.html','<form name="vm.form" role="form" novalidate show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Chart Export</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="start_date">Start date:</label><div class="input-group input-group-sm"><input id="start_date" name="startDate" type="text" class="form-control" placeholder="mm/dd/yyyy" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.startDate" class="form-control" is-open="vm.datePickerOpenStatus.startDate" datepicker-options="vm.startDateOptions" ng-change="vm.validateEndDate()" ng-required="vm.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.startDate.$error.required"></span> <span class="help-block" ng-show="vm.form.startDate.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.startDate.$invalid && !vm.form.startDate.$error.required">This field is invalid</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label for="end_date">End date:</label><div class="input-group input-group-sm"><input id="end_date" name="endDate" type="text" class="form-control" placeholder="mm/dd/yyyy" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.endDate" class="form-control" is-open="vm.datePickerOpenStatus.endDate" datepicker-options="vm.endDateOptions" ng-change="vm.validateStartDate()" ng-required="vm.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.endDate.$error.required"></span> <span class="help-block" ng-show="vm.form.endDate.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.endDate.$invalid && !vm.form.endDate.$error.required">This field is invalid</span></div></div></div></div><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.print()" ng-disabled="vm.isPrinting || vm.getSelectedIds(vm.selected).length == 0 || vm.form.$invalid"><i class="fa fa-save" aria-hidden="true"></i> Print</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facesheet-tpl/chart-report/old/facesheet-tpl-report.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="modal-icon"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div><h4 class="modal-title" id="myVitalsLabel">Facesheet Tpl</h4></div><div class="modal-body"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><form name="searchForm" class="form-inline"><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.print()" ng-disabled="vm.isPrinting || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-save" aria-hidden="true"></i> Print</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/facility/create/tpl/entity.html','<uib-progressbar max="vm.entities.length" value="vm.index + 1"><span style="color:white; white-space:nowrap;">{{vm.index + 1}} / {{vm.entities.length}}</span></uib-progressbar><h2 class="step-header">{{vm.entities[vm.index]}}</h2><hr><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="table-responsive"><table class="table table-hover table-condensed" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div></div>');
$templateCache.put('app/entities/facility/create/tpl/form.html','<h2 class="step-header">Facility Setup</h2><hr><form name="vm.form" role="form"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.name?(vm.form.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="name">Name:</label> <input type="text" class="form-control" name="name" id="name" required ng-model="vm.facility.name"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.name"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.name && vm.form.name.$dirty"></span> <span class="help-block" ng-show="!vm.facility.name">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.street?(vm.form.street.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_street">Street:</label> <input type="text" class="form-control" name="street" id="field_street" required ng-model="vm.facility.street"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.street"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.street && vm.form.street.$dirty"></span> <span class="help-block" ng-show="!vm.facility.street">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.street_two?(vm.form.street_two.$dirty?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_street_two">2<sup>nd</sup> Street:</label> <input type="text" class="form-control" name="street_two" id="field_street_two" ng-model="vm.facility.street_two"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.street_two"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.street_two && vm.form.street_two.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.street_two">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.city?(vm.form.city.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_city">City</label> <input type="text" class="form-control" name="city" id="field_city" required ng-model="vm.facility.city"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.city && vm.form.city.$dirty"></span> <span class="help-block" ng-show="!vm.facility.city">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.countryState ?(vm.form.state.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_state">State:</label> <select class="form-control" id="field_state" name="state" required ng-model="vm.facility.countryState" ng-options="item as item.state for item in vm.states track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.countryState && vm.form.state.$dirty"></span> <span class="help-block" ng-show="!vm.facility.countryState">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.zip?(vm.form.zip.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_zip">Zip Code:</label> <input type="text" class="form-control" name="zip" id="field_zip" required ng-model="vm.facility.zip" ui-mask="99999"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.zip"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.zip && vm.form.zip.$dirty"></span> <span class="help-block" ng-show="!vm.facility.zip">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.county?(vm.form.county.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_county">County:</label> <input type="text" class="form-control" name="county" id="field_county" ng-model="vm.facility.county"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.county"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.county && vm.form.county.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.county">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.phone?(vm.form.phone.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_phone">Phone:</label> <input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.facility.phone" ui-mask="(999)-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.phone && vm.form.phone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.phone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.fax?(vm.form.fax.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_fax">Fax:</label> <input type="text" class="form-control" name="fax" id="field_fax" ng-model="vm.facility.fax" ui-mask="(999)-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.fax"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.fax && vm.form.fax.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.fax">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.website?(vm.form.website.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">Website:</label> <input type="url" class="form-control" name="website" id="field_website" ng-model="vm.facility.website" list="urlExamples"><datalist id="urlExamples"><option value="http://www.example.com"></option><option value="https://www.example.com"></option><option value="http://www.example.org"></option><option value="https://www.example.org"></option></datalist><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.website"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.website && vm.form.website.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.website">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.corporation?(vm.form.corporation.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Corporation</label><ui-select ng-model="vm.facility.corporation" name="corporation" id="field_corporation" required reset-search-input="true" title="Corporation" close-on-select="true" ng-disabled="true"><ui-select-match placeholder="Enter a corporation..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="corporation in vm.corporations | filter: $select.search"><div ng-bind-html="corporation.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.facility.corporation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.corporation && vm.form.corporation.$dirty"></span> <span class="help-block" ng-show="!vm.facility.corporation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.zoneId ?\'has-success\':\'has-error\'"><label class="control-label">Time Zone</label><ui-select ng-model="vm.zoneId" name="timezone" id="field_timezone" required close-on-select="true"><ui-select-match placeholder="Select time zone ...">{{$select.selected.zoneId + \' \' + $select.selected.offset}}</ui-select-match><ui-select-choices repeat="zoneId in vm.timeZones | filter: $select.search"><div ng-bind-html="zoneId.zoneId + \' \' +  zoneId.offset | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.zoneId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.zoneId"></span> <span class="help-block" ng-show="!vm.zoneId">This field is required</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.taxId?(vm.form.taxId.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">Tax Id:</label> <input type="text" class="form-control" name="taxId" id="field_taxId" ng-model="vm.facility.taxId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.taxId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.taxId && vm.form.taxId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.taxId">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.stateLicence?(vm.form.stateLicence.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">State Licence:</label> <input type="text" class="form-control" name="stateLicence" id="field_stateLicence" ng-model="vm.facility.stateLicence"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.stateLicence"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.stateLicence && vm.form.stateLicence.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.stateLicence">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.npi?(vm.form.npi.$dirty?\'has-success\':\'\'):\'has-warning\'"><label for="field_website">NPI:</label> <input type="text" class="form-control" name="npi" id="field_npi" ng-model="vm.facility.npi"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.npi"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.npi && vm.form.npi.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.npi">This field is suggested</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_website">Send Results:</label><br><toggle id="field_sendResults" name="sendResults" ng-model="vm.facility.sendResults" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.placeOfService ? (vm.form.placeOfService.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="control-label">Place of Service</label><ui-select ng-model="vm.facility.placeOfService" name="placeOfService" id="field_place" close-on-select="true"><ui-select-match allow-clear="true" placeholder="Select place of service ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="placeOfService in vm.placeOfService | filter: $select.search"><div ng-bind-html="placeOfService.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-warning-sign form-control-feedback" ng-show="!vm.facility.placeOfService"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.facility.placeOfService && vm.form.placeOfService.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.facility.placeOfService">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.facilityType ? (vm.form.facilityType.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="control-label">Facility Type</label> <select name="facilityType" id="field_facilityType" class="form-control input-sm" ng-model="vm.facility.facilityType"><option value="">Select type</option><option value="HIV">HIV</option><option value="COVID_RC">COVID_RC</option></select></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_reconnect_care">Reconnect Care:</label><br><toggle id="field_reconnect_care" name="reconnect_care" ng-model="vm.facility.reconnectCare" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_auto_sign_medication">Auto Sign Medication:</label><br><toggle id="field_auto_sign_medication" name="auto_sign_medication" ng-model="vm.facility.autoSignMedication" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback"><label for="field_auto_sign_medication">Auto Sign Patient Order:</label><br><toggle id="field_auto_sign_patient_order" name="auto_sign_patient_order" ng-model="vm.facility.autoSignPatientOrder" size="btn-sm" onstyle="btn-success" offstyle="btn-danger" on="Yes" off="No"></toggle></div></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.facility.defaultPharmacy ? (vm.form.defaultPharmacy.$dirty ? \'has-success\' : \'\'):\'has-warning\'"><label class="field_pharmacy">Pharmacy</label><ui-select name="pharmacy" id="field_pharmacy" title="pharmacy" ng-model="vm.facility.defaultPharmacy" reset-search-input="false" ng-model-options="{ debounce: 500 }"><ui-select-match placeholder="Pharmacy...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in vm.pharmacy | filter: $select.search" refresh="vm.getPharmacy($select.search)" refresh-delay="0"><div ng-bind-html="item.name"></div></ui-select-choices></ui-select></div></div></div></form>');
$templateCache.put('app/entities/glucose/chart/new/glucose.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Glucose:</strong> <a href="" class="btn-icon" uib-tooltip="Add New Data" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>{{vm.glucose.date | amDateFormat:amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>Reading</strong> - {{vm.glucose.reading}}</span> <span><strong>Type of Check:</strong> - {{vm.glucose.typeCheck.name}}</span> <span><strong>Interventions:</strong> - {{vm.glucoseInterventions}}</span></p></div>');
$templateCache.put('app/entities/glucose/chart/old/glucose.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header has-chart"><nvd3 class="patient-chart p-glucose" options="vm.optionsGlu" data="vm.dataGlu"></nvd3><h2 class="head-text small text-center">Glucose</h2></div><div class="item-body"><table class="table"><tbody><tr><td><strong>Date</strong></td><td>{{vm.glucose.date | amDateFormat:amDateFormat}}</td></tr><tr><td><strong>Reading</strong></td><td>{{vm.glucose.reading ? vm.glucose.reading : \'-\'}}</td></tr><tr><td><strong>Type of Check</strong></td><td>{{vm.glucose.typeCheck ? vm.glucose.typeCheck.name : \'-\'}}</td></tr><tr><td><strong>Interventions</strong></td><td>{{vm.glucose.glucoseInterventions ? vm.glucoseInterventions : \'-\'}}</td></tr><tr><td><strong>Notes</strong></td><td>{{vm.glucose.notes ? vm.glucose.notes : \'-\'}}</td></tr></tbody></table></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add New <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><a ng-click="vm.history()" class="footer-link">History <i class="fa fa-file-text-o" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/group-session-details/chart/new/group-session-details.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px"><h4 class="header-line mt-0 mb-10 pb-10" style="border-bottom: 1px solid #d2d6de"><div class="input-group input-group-sm search"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th><button type="button" class="btn btn-default btn-xs" style="margin: 0 auto 0 0;" uib-tooltip="Expand/Collapse All" ng-click="vm.toggleAllRow()"><i class="fa" aria-hidden="true" ng-class="{\'fa-plus-circle\': !vm.toggleAllRows, \'fa-minus-circle\': vm.toggleAllRows}"></i></button></th><th><strong>Title</strong></th><th><strong>Start Date</strong></th><th><strong>Start Time</strong></th><th><strong>End Time</strong></th><th><strong>Employee</strong></th><th><strong>Status</strong></th><th></th></tr></thead><tbody><tr ng-repeat-start="item in vm.groupSessionDetails"><td style="width: 25px; text-align: center"><a href="" uib-tooltip="See Details" style="color: #222d32;" ng-if="item.description" ng-click="vm.toggleRow(item)"><i class="fa" ng-class="{\'fa-plus-circle\': !item.active,\'fa-minus-circle\': item.active}"></i></a></td><td>{{item.title}}</td><td>{{item.startDate | amDateFormat: dateFormat}}</td><td>{{item.start?(item.start | amDateFormat: timeFormatA):\'-\'}}</td><td>{{item.stop?(item.stop | amDateFormat: timeFormatA):\'-\'}}</td><td>{{item.leader ? (item.leader.firstName + \' \' + item.leader.lastName) : \'\'}}</td><td><span class="label" ng-class="{\'label-success\': vm.statusClass(item.status) == \'complete\', \'label-warning\': vm.statusClass(item.status) == \'review\', \'label-primary\': vm.statusClass(item.status) == \'started\'}">{{item.status}}</span></td><td style="width: 50px"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link blue" ng-click="vm.view(item)"><i class="fa fa-list-alt" aria-hidden="true"></i> See Details</a></li><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.print(item)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li><li role="menuitem" has-any-authority="ROLE_SYSTEM,ROLE_SYSTEM_ADMIN"><a href="" class="dd-link orange" ng-click="vm.audit(item)"><i class="fa fa-warning" aria-hidden="true"></i> Audit</a></li></ul></div><!-- /dropdown--></td></tr><tr ng-show="item.active"><td></td><td colspan="7"><strong>Description</strong></td></tr><tr ng-show="item.active"><td></td><td colspan="7">{{item.description?item.description:\'-\'}}</td></tr><tr ng-repeat-end ng-if="item.active"><td></td><td colspan="7"><form name="editForm" role="form" novalidate><ods-viewer schema="item.jsonTemplate"></ods-viewer></form></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.groupSessionDetails.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.loadAll()"></ul></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default shadow" disabled="disabled"><span class="dummy">&nbsp;</span></button><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div></div>');
$templateCache.put('app/entities/group-session-details/chart/old/group-session-details.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header"><div class="fancy-icon blue big"><i class="fa fa-list-ul fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Group Sessions</h2></div><div class="item-body"><div class="session-item" ng-repeat="item in vm.groupSessionDetails"><div class="data-section"><table class="table"><tbody><tr><td class="theading"><strong>Title:</strong></td><td class="tdata">{{item.title}}</td><td class="theading"><strong>Employee:</strong></td><td class="tdata">{{item.leader ? (item.leader.firstName + \' \' + item.leader.lastName) : \'\'}}</td></tr><tr><td class="theading"><strong>Start Date:</strong></td><td class="tdata">{{item.startDate | amDateFormat: dateFormat}}</td><td class="theading stripped-status" ng-class="vm.statusClass(item.status)"><strong>Status:</strong></td><td class="tdata stripped-status" ng-class="vm.statusClass(item.status)"><span>{{item.status}}</span></td></tr><tr><td class="theading"><strong>Start:</strong></td><td class="tdata">{{item.start?(item.start | amDateFormat: timeFormatA):\'-\'}}</td><td class="theading"><strong>Stop:</strong></td><td class="tdata">{{item.stop?(item.stop | amDateFormat: timeFormatA):\'-\'}}</td></tr></tbody></table></div><div class="actions"><a href="" ng-click="vm.view(item)" class="see-details" title="See Details"><i class="fa fa-list-alt" aria-hidden="true"></i> </a><a href="" ng-click="vm.print(item)" class="see-details" title="See Details"><i class="fa fa-print" aria-hidden="true"></i></a></div><div class="notes" ng-if="item.description"><h5>Description:</h5><p class="text-justify">{{item.description?item.description:\'-\'}}</p></div></div></div><div class="item-footer"><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.loadAll()"><ul></ul></ul></div></div>');
$templateCache.put('app/entities/group-session-form-tpl/update/tpl/metadata-tpl.html','<form name="form" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-change="vm.updateTitle()" ng-model="vm.groupSessionFormTpl.name" required><div ng-show="form.name.$invalid"><p class="help-block" ng-show="form.name.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_description">Description</label> <input type="text" class="form-control" name="description" id="field_description" ng-model="vm.groupSessionFormTpl.description"></div></div></div></div></form>');
$templateCache.put('app/entities/incident-report-note-template/update/tpl/metadata-tpl.html','<form name="vm.form.metadata" role="form" show-validation><div class="box-body"><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_name">Name</label> <input type="text" class="form-control" name="name" id="field_name" ng-change="vm.updateTitle()" ng-model="vm.incidentReportTemplate.name" required><div ng-show="vm.form.metadata.name.$invalid"><p class="help-block" ng-show="vm.form.metadata.name.$error.required">This field is required.</p></div></div></div><div class="col-lg-6"><div class="form-group"><label class="control-label" for="field_label">Title</label> <input type="text" class="form-control" name="field_label" id="field_label" ng-model="vm.incidentReportTemplate.jsonTemplate.label" required><div ng-show="vm.form.metadata.field_label.$invalid"><p class="help-block" ng-show="vm.form.metadata.field_label.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-6"><div class="form-group"><label class="control-label">Incident Type</label><ui-select ng-model="vm.incidentReportTemplate.incidentTypes" name="incidentType" id="field_incidentType" ng-required="true" reset-search-input="true" title="Select Incident Type" multiple="multiple" close-on-select="false"><ui-select-match placeholder="Select Incident Type">{{$item.name}}</ui-select-match><ui-select-choices repeat="item in vm.incidentTypes | filter: $select.search"><div ng-bind-html="item.name | highlight: $select.search"></div></ui-select-choices></ui-select><div ng-show="vm.form.metadata.incidentType.$invalid"><p class="help-block" ng-show="vm.form.metadata.incidentType.$error.required">This field is required.</p></div></div></div></div><div class="row"><div class="col-lg-4"><div class="form-group"><label class="control-label">Enable</label><br><toggle ng-model="vm.incidentReportTemplate.enabled" on="Yes" off="No" id="field_enabled"></toggle></div></div></div></div></form>');
$templateCache.put('app/entities/insurance/chart/new/insurance.html','<div class="info no-padding mb-15"><h5 class="header-label mt-0"><strong>Primary Insurance</strong> <span ng-if="vm.primary"><a href="" class="btn-icon" uib-tooltip="Card Front" ng-click="vm.editFrontImageInsurance(vm.primary.id)"><i class="fa fa-id-card" aria-hidden="true"></i></a> <a href="" class="btn-icon" uib-tooltip="Card Back" ng-click="vm.editBackImageInsurance(vm.primary.id)"><i class="fa fa-id-card" aria-hidden="true"></i></a> </span><a href="" class="btn-icon" uib-tooltip="Add Primary Insurance" ng-if="!vm.primary" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><div class="click-layer" ng-if="vm.primary" ng-click="vm.edit(vm.primary.id)"><p class="mb-10"><strong style="text-transform: capitalize">Carrier</strong> - <span>{{vm.primary.insuranceCarrier.name}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Policy</strong> - <span>{{vm.primary.policyNumber}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Group Number</strong> - <span>{{vm.primary.groupNumber}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Pre-Cert Number</strong> - <span>{{vm.primary.preCertPhone | phone}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Insurance Type</strong> - <span>{{vm.primary.insuranceType.name}}</span></p></div></div><div class="info no-padding mb-15" ng-if="vm.primary"><h5 class="header-label mt-0"><strong>Secondary Insurance</strong> <span ng-if="vm.secondary"><a href="" class="btn-icon" uib-tooltip="Card Front" ng-click="vm.editFrontImageInsurance(vm.secondary.id)"><i class="fa fa-id-card" aria-hidden="true"></i></a> <a href="" class="btn-icon" uib-tooltip="Card Back" ng-click="vm.editBackImageInsurance(vm.secondary.id)"><i class="fa fa-id-card" aria-hidden="true"></i></a> </span><!-- Show this if there no second Insurance --> <a href="" class="btn-icon" uib-tooltip="Add Second Insurance" ng-if="vm.primary && !vm.secondary" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><div class="click-layer" ng-if="vm.secondary" ng-click="vm.edit(vm.secondary.id)"><p class="mb-10"><strong style="text-transform: capitalize">Carrier</strong> - <span>{{vm.secondary.insuranceCarrier.name}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Policy</strong> - <span>{{vm.secondary.policyNumber}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Group Number</strong> - <span>{{vm.secondary.groupNumber}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Pre-Cert Number</strong> - <span>{{vm.secondary.preCertPhone | phone}}</span></p><p class="mb-10"><strong style="text-transform: capitalize">Insurance Type</strong> - <span>{{vm.secondary.insuranceType.name}}</span></p></div></div>');
$templateCache.put('app/entities/insurance/chart/old/insurance.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header blank-border"><div class="fancy-icon red big"><i class="fa fa-address-card-o fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Insurance</h2></header><div class="item-body"><div class="empty-content" ng-if="vm.chart.typePaymentMethods.category !== \'Insurance\'"><div class="notice-text well well-lg"><span>The patient is</span> <span class="big">Under</span> <span>{{vm.chart.typePaymentMethods.name}}</span></div></div><div class="empty-content" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\' && !(vm.primary || vm.secondary)"><div class="notice-text well well-lg"><span>Please</span> <span>add</span> <span>an Insurance</span></div></div><uib-tabset active="vm.activeTab" class="header-tabs" ng-class="vm.primary || vm.secondary ? \'has-content-tabs\' : \'\'" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\' && (vm.primary || vm.secondary)"><uib-tab index="0" select="vm.keepActiveTab(0)" heading="Primary"><div class="tab-wrapper"><div class="insurance-info"><div class="info"><table class="table"><tbody><tr><td><strong>Insurance Carrier:</strong></td><td>{{vm.primary.insuranceCarrier?vm.primary.insuranceCarrier.name:\'-\'}}</td></tr><tr><td><strong>Policy Number:</strong></td><td>{{vm.primary.policyNumber?vm.primary.policyNumber:\'-\'}}</td></tr><tr><td><strong>Pre-Cert Number:</strong></td><td>{{vm.primary.preCertPhone?vm.primary.preCertPhone:\'-\'}}</td></tr><tr><td><strong>Group Number:</strong></td><td>{{vm.primary.groupNumber?vm.primary.groupNumber:\'-\'}}</td></tr><tr><td><strong>Insurance Type:</strong></td><td>{{vm.primary.insuranceType?vm.primary.insuranceType.name:\'-\'}}</td></tr><tr><td><strong>Rx Bin:</strong></td><td>{{vm.primary.rxBin?vm.primary.rxBin:\'-\'}}</td></tr><tr><td><strong>Rx PCN:</strong></td><td>{{vm.primary.pcn?vm.primary.pcn:\'-\'}}</td></tr><tr><td><strong>Member ID:</strong></td><td>{{vm.primary.memberId?vm.primary.memberId:\'-\'}}</td></tr></tbody></table></div><div class="subscriber-info"><table class="table"><tbody><tr><td><strong>Subscriber</strong></td></tr><tr><td><strong>Name:</strong></td><td>{{vm.primary.firstName + \' \' + vm.primary.lastName}}</td></tr><tr><td><strong>DOB:</strong></td><td>{{vm.primary.dob | date:inputDateFormat}}</td></tr><tr><td><strong>SSN:</strong></td><td>{{vm.primary.socialSecurity?vm.primary.socialSecurity:\'-\'}}</td></tr><tr><td><strong>Relationship:</strong></td><td>{{vm.primary.insuranceRelation?vm.primary.insuranceRelation.name:\'-\'}}</td></tr><tr><td><strong>Phone:</strong></td><td>{{vm.primary.phone | phone}}</td></tr><tr><td><strong>Address:</strong></td><td>{{vm.primary.address + \', \' + (vm.primary.address2?vm.primary.address2 + \', \':\'\') + vm.primary.city + \', \' + vm.primary.countryState.state + \' \' + vm.primary.zipCode}}</td></tr></tbody></table></div><!-- /subscriber-info --></div><!-- /insurance-info --><div class="insurance-card"><div class="front"><div class="text-center"><strong>Front:</strong></div><div class="card-picture"><img class="photo" id="img_picture_primary" alt="User profile picture" ng-src-auth-insurance-front="{{vm.primary.id}}" ng-click="vm.editFrontImageInsurance(vm.primary.id)"></div></div><div class="back"><div class="text-center"><strong>Back:</strong></div><div class="card-picture"><img class="photo" id="img_back_picture_primary" alt="User profile picture" ng-src-auth-insurance-back="{{vm.primary.id}}" ng-click="vm.editBackImageInsurance(vm.primary.id)"></div></div></div><div class="insurance-remove text-center" ng-if="vm.chart.status != \'CLOSED\' && vm.insurances.length > 1"><a type="button" class="btn btn-danger btn-lg" ng-click="vm.del(vm.insurances[vm.activeTab])"><i class="fa fa-trash" aria-hidden="true"></i> Delete Insurance</a></div></div></uib-tab><uib-tab index="1" select="vm.keepActiveTab(1)" heading="Second" ng-if="vm.secondary"><div class="tab-wrapper"><div class="insurance-info"><div class="info"><table class="table"><tbody><tr><td><strong>Insurance Carrier:</strong></td><td>{{vm.secondary.insuranceCarrier?vm.secondary.insuranceCarrier.name:\'-\'}}</td></tr><tr><td><strong>Policy Number:</strong></td><td>{{vm.secondary.policyNumber?vm.secondary.policyNumber:\'-\'}}</td></tr><tr><td><strong>Pre-Cert Number:</strong></td><td>{{vm.secondary.preCertPhone?vm.secondary.preCertPhone:\'-\'}}</td></tr><tr><td><strong>Group Number:</strong></td><td>{{vm.secondary.groupNumber?vm.secondary.groupNumber:\'-\'}}</td></tr><tr><td><strong>Insurance Type:</strong></td><td>{{vm.secondary.insuranceType?vm.secondary.insuranceType.name:\'-\'}}</td></tr><tr><td><strong>Rx Bin:</strong></td><td>{{vm.secondary.rxBin?vm.secondary.rxBin:\'-\'}}</td></tr><tr><td><strong>Rx PCN:</strong></td><td>{{vm.secondary.pcn?vm.secondary.pcn:\'-\'}}</td></tr><tr><td><strong>Member ID:</strong></td><td>{{vm.secondary.memberId?vm.secondary.memberId:\'-\'}}</td></tr></tbody></table></div><div class="subscriber-info"><table class="table"><tbody><tr><td><strong>Subscriber</strong></td></tr><tr><td><strong>Name:</strong></td><td>{{vm.secondary.firstName + \' \' + vm.secondary.lastName}}</td></tr><tr><td><strong>DOB:</strong></td><td>{{vm.secondary.dob | date:inputDateFormat}}</td></tr><tr><td><strong>SSN:</strong></td><td>{{vm.secondary.socialSecurity?vm.secondary.socialSecurity:\'-\'}}</td></tr><tr><td><strong>Relationship:</strong></td><td>{{vm.secondary.insuranceRelation?vm.secondary.insuranceRelation.name:\'-\'}}</td></tr><tr><td><strong>Phone:</strong></td><td>{{vm.secondary.phone | phone}}</td></tr><tr><td><strong>Address:</strong></td><td>{{vm.secondary.address + \', \' + (vm.secondary.address2?vm.secondary.address2 + \', \':\'\') + vm.secondary.city + \', \' + vm.secondary.countryState.state + \' \' + vm.secondary.zipCode}}</td></tr></tbody></table></div><!-- /subscriber-info --></div><!-- /insurance-info --><div class="insurance-card"><div class="front"><div class="text-center"><strong>Front:</strong></div><div class="card-picture"><img class="photo" id="img_picture_secondary" alt="User profile picture" ng-src-auth-insurance-front="{{vm.secondary.id}}" ng-click="vm.editFrontImageInsurance(vm.secondary.id)"></div></div><div class="back"><div class="text-center"><strong>Back:</strong></div><div class="card-picture"><img class="photo" id="img_back_picture_secondary" alt="User profile picture" ng-src-auth-insurance-back="{{vm.secondary.id}}" ng-click="vm.editBackImageInsurance(vm.secondary.id)"></div></div></div><div class="insurance-remove text-center" ng-if="vm.chart.status != \'CLOSED\' && vm.insurances.length > 1"><a type="button" class="btn btn-danger btn-lg" ng-click="vm.del(vm.insurances[vm.activeTab])"><i class="fa fa-trash" aria-hidden="true"></i> Delete Insurance</a></div></div></uib-tab></uib-tabset></div><footer class="item-footer" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\'"><div class="fleft" ng-if="!vm.primary || !vm.secondary"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">{{!vm.primary ? \'Add Insurance\' : \'Add Second Insurance\'}} <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.primary || vm.secondary"><a class="footer-link" ng-click="vm.activeTab == 0 ? vm.edit(vm.primary.id) : vm.edit(vm.secondary.id)">{{vm.chart.status == \'CLOSED\' ? \'View Information\' : \'Edit Information\'}} <i class="fa fa-edit" aria-hidden="true"></i></a></div></footer>');
$templateCache.put('app/entities/patient-medication/create/tpl/orders-tpl.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><h3 class="text-center"><strong>Orders</strong></h3><hr><div class="orders-list"><div class="order-item" ng-repeat="($pm_index, pmedication) in vm.pmedications"><header class="order-header mb-15"><h4 class="order-name"><button type="button" class="btn btn-default btn-sm" ng-click="pmedication.collapsed = !pmedication.collapsed"><i class="fa" aria-hidden="true" ng-class="pmedication.collapsed?\'fa-chevron-right\':\'fa-chevron-down\'"></i></button> <span>{{pmedication.name ? (pmedication.name + " - " + pmedication.medication.name) : pmedication.medication.name}}</span></h4><button type="button" class="btn btn-danger" ng-click="vm.deleteMedication($pm_index)"><i class="fa fa-trash" aria-hidden="true"></i> Delete Medication</button><div class="alert-text" ng-if="pmedication.medication != null && vm.matches[pmedication.medication.id] == true"><span class="text">Possible Medication Match</span></div></header><div class="order-content well well-sm" uib-collapse="pmedication.collapsed"><div class="row"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="pmedication.medication == null ? \'has-error\' : \'has-success\'"><label for="field_medication{{$pm_index}}">Medication:</label><ui-select name="medication{{$pm_index}}" id="field_medication{{$pm_index}}" ng-model="pmedication.medication" required ng-disabled="pmedication.protocolId || vm.patientMedication" reset-search-input="true" title="All Medications" close-on-select="true"><ui-select-match placeholder="Select medications ..." allow-clear="true">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="medication in vm.medications | filter: $select.search" refresh="vm.getMedications($select.search)" refresh-delay="0"><div ng-bind-html="medication.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="pmedication.medication == null"></span> <span class="help-block" ng-show="pmedication.medication == null">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><label for="field_onlyInChart">Show only in chart:</label><br><toggle ng-model="pmedication.onlyInChart" on="Yes" off="No" id="field_onlyInChart" selected="false"></toggle></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="pmedication.startDate == null ? \'has-error\' : \'has-success\'"><label for="field_start_day{{$pm_index}}">Start Day:</label> <input type="datetime-local" id="field_start_day{{$pm_index}}" name="field_start_day{{$pm_index}}" class="form-control" required ng-model="pmedication.startDate"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="pmedication.startDate == null"></span> <span class="help-block" ng-show="pmedication.startDate == null">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="pmedication.route == null ? \'has-error\' : \'has-success\'"><label for="field_route{{$pm_index}}">Route:</label><ui-select ng-model="pmedication.route" name="route{{$pm_index}}" id="field_route{{$pm_index}}" reset-search-input="true" title="Select route for current medication" close-on-select="true" required><ui-select-match placeholder="Select route ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="route in vm.routes | filter: $select.search"><div ng-bind-html="route.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="pmedication.route == null"></span> <span class="help-block" ng-show="pmedication.route == null">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="pmedication.doseForm == null ? \'has-error\' : \'has-success\'"><label for="field_dose_form{{$pm_index}}">Dosages Form:</label><ui-select ng-model="pmedication.doseForm" name="dose_form{{$pm_index}}" id="field_dose_form{{$pm_index}}" reset-search-input="true" title="Select dosages form for current medication" close-on-select="true" required><ui-select-match placeholder="Select dosages form ...">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="doseForm in vm.doseForms | filter: $select.search"><div ng-bind-html="doseForm.name | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="pmedication.doseForm == null"></span> <span class="help-block" ng-show="pmedication.doseForm == null">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-2 col-lg-2"><div class="form-group"><label for="refill{{$pm_index}}">Refills Count:</label> <input type="number" id="refill{{$pm_index}}" name="refill{{$pm_index}}" class="form-control" min="0" ng-model="pmedication.refills"></div></div><div class="col-xs-12 col-sm-12 col-md-2 col-lg-2"><div class="form-group"><label for="dispense{{$pm_index}}">Dispense Amount:</label> <input type="number" id="dispense{{$pm_index}}" name="dispense{{$pm_index}}" class="form-control" min="0" ng-model="pmedication.dispense"></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 form-group"><div class="form-group"><label for="field_relational{{$pm_index}}">Rationale:</label><ui-select ng-model="pmedication.relational" name="relational{{$pm_index}}" id="field_relational{{$pm_index}}" title="Rationale" close-on-select="false" multiple="multiple"><ui-select-match placeholder="Select rationale...">{{$item.name}}</ui-select-match><ui-select-choices repeat="relational in vm.relationals | filter: $select.search"><div ng-bind-html="relational.name  | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="pmedication.type == null ? \'has-error\' : \'has-success\'"><label for="field_type{{$pm_index}}">Category:</label> <select id="field_type{{$pm_index}}" class="form-control" ng-model="pmedication.type" name="type" ng-change="vm.changeCategory(pmedication)" ng-disabled="pmedication.protocolId" required><option value="AS_NEEDED">AS NEEDED</option><option value="TAPER">TAPER</option><option value="CONSISTENT_DOSE">CONSISTENT DOSE</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="pmedication.type == null"></span> <span class="help-block" ng-show="pmedication.type == null">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="editForm.duration_days{{$pm_index}}.$invalid ? \'has-error\' : (editForm.duration_days{{$pm_index}}.$touched || editForm.duration_days{{$pm_index}}.$dirty ? \'has-success\' : \'\')"><label for="field_duration_days{{$pm_index}}">Duration in Days:</label> <input type="number" id="field_duration_days{{$pm_index}}" name="duration_days{{$pm_index}}" class="form-control" min="0" max="365" ng-disabled="pmedication.type == \'TAPER\'" required ng-model="pmedication.durationDays"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="editForm.duration_days{{$pm_index}}.$error.required"></span> <span class="help-block" ng-show="editForm.duration_days{{$pm_index}}.$error.required">This field is required</span> <span class="help-block" aria-hidden="true" ng-show="editForm.duration_days{{$pm_index}}.$error.min">This field must be greater than 0</span> <span class="help-block" aria-hidden="true" ng-show="editForm.duration_days{{$pm_index}}.$error.max">This field must be less than 365</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><label for="field_instruction{{$pm_index}}">Instructions:</label> <textarea class="form-control" id="field_instruction{{$pm_index}}" name="instruction{{$pm_index}}" rows="4" data-resize="disabled" ng-model="pmedication.instruction"></textarea></div></div><fieldset ng-if="pmedication.frequencies != null && pmedication.frequencies.length > 0"><legend>Frequencies</legend><div ng-repeat="($f_index, frequency) in pmedication.frequencies" class="frequency-day"><header><h4 class="day-number" ng-if="pmedication.type == \'TAPER\'"><strong>Day {{frequency.xorder + 1}} -</strong></h4><h4 class="day-number" ng-if="pmedication.type != \'TAPER\'"><strong>Frequency</strong></h4><div class="select-frequency" ng-class="frequency.frequency == null ? \'has-error\' : \'has-success\'"><select class="form-control" ng-model="frequency.frequency" id="field_frequency_{{$pm_index}}{{$f_index}}" name="frequency_{{$pm_index}}{{$f_index}}" required ng-change="vm.changeFrequency(frequency)" ng-options="frequency as frequency.description for frequency in vm.frequencies track by frequency.id"></select></div><button type="button" class="btn btn-warning" ng-click="vm.addDay(pmedication, $f_index)" ng-if="pmedication.type == \'TAPER\'"><span class="fa fa-plus-circle" aria-hidden="true"></span> Add Before</button> <button type="button" class="btn btn-danger" ng-if="pmedication.type == \'TAPER\' && pmedication.frequencies.length > 1 && frequency.confirm == null" ng-click="frequency.confirm = true"><i class="fa fa-trash" aria-hidden="true"></i> Delete Day</button><div style="margin-left: auto" ng-if="pmedication.type == \'TAPER\' && pmedication.frequencies.length > 1 && frequency.confirm == true"><button type="button" class="btn btn-success" ng-click="vm.deleteDay(pmedication, $f_index)"><i class="fa fa-trash" aria-hidden="true"></i> Yes</button> <button type="button" class="btn btn-danger" ng-click="frequency.confirm = null"><i class="fa fa-trash" aria-hidden="true"></i> No</button></div></header><div class="schedule-times table-responsive" ng-if="frequency.schedules != null && frequency.schedules.length > 0"><table class="table table-condensed"><thead><tr><th ng-if="!frequency.hideDay"></th><th ng-if="!frequency.hideDay"><strong>At:</strong></th><th><strong>Strength:</strong></th><th><strong>Quantity:</strong></th></tr></thead><tbody><tr ng-repeat="($sch_index, schedule) in frequency.schedules"><td style="width: 25px" ng-if="!frequency.hideDay"><span class="index">{{schedule.xorder}}</span></td><td style="width: 80px" ng-if="!frequency.hideDay"><div class="form-group mb-0" ng-class="schedule.date == null ? \'has-error\' : \'has-success\'"><input name="date{{$pm_index}}{{$f_index}}{{$sch_index}}" required type="time" class="time-control" ng-model="schedule.date"></div></td><td><div class="form-group mb-0" ng-class="schedule.strength == null || schedule.strength.length == 0 ? \'has-error\' : \'has-success\'"><input name="strength{{$pm_index}}{{$f_index}}{{$sch_index}}" required type="text" class="form-control input-sm" ng-model="schedule.strength"></div></td><td style="width: 100px"><div class="form-group mb-0" ng-class="schedule.quantity?(vm.form.schedule.quantity.$valid && vm.form.schedule.quantity.$dirty?\'has-success\':\'\'):\'has-error\'"><input name="quantity{{$pm_index}}{{$f_index}}{{$sch_index}}" type="number" class="form-control input-sm" required ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" step="0.01" ng-model="schedule.quantity"></div></td></tr></tbody></table></div></div><div class="text-right" ng-if="pmedication.type == \'TAPER\'"><button type="button" class="btn btn-primary" ng-click="vm.addDay(pmedication)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Day</button></div></fieldset></div></div></div><hr><div class="text-center mb-15"><button type="button" class="btn btn-warning" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Medication</button></div><hr><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 ordered-obtained"><div class="form-group has-feedback"><div ng-class="vm.physician == null ? \'has-error\' : \'has-success\'"><label for="field_physician">Ordered By:</label><ui-select ng-model="vm.physician" name="physician" required title="Order By" id="field_physician" ng-disabled="vm.itHasCredentials" reset-search-input="false"><ui-select-match placeholder="Order by...">{{($select.selected.firstName + \' \' + $select.selected.lastName)}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | propsFilter: {firstName: $select.search ,lastName: $select.search, fullName: $select.search}" refresh="vm.getEmployee($select.search)" refresh-delay="0">{{(employee.firstName + \' \' + employee.lastName)}}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.physician == null"></span> <span class="help-block" ng-show="vm.physician == null">This field is required</span></div></div><div class="form-group has-feedback"><div ng-class="vm.via == null ? \'has-error\' : \'has-success\'"><label for="field_via">Obtained:</label> <select class="form-control" id="field_via" name="via" ng-model="vm.via" ng-options="item as item.name for item in vm.vias track by item.name" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.via == null"></span> <span class="help-block" ng-show="vm.via == null">This field is required</span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" style="margin-right: auto" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button> <button type="button" class="btn btn-success" ng-if="vm.itHasCredentials" ng-disabled="editForm.$invalid || vm.pmedications == null || vm.pmedications.length == 0" wz-next>Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button> <button type="button" class="btn btn-success" ng-if="!vm.itHasCredentials" ng-disabled="editForm.$invalid || vm.pmedications == null || vm.pmedications.length == 0 || vm.isSaving" ng-click="vm.save()">Save <i class="fa fa-chevron-right" aria-hidden="true"></i></button></div></form>');
$templateCache.put('app/entities/patient-medication/create/tpl/protocol-list-tpl.html','<form autocomplete="off"><div class="protocol-list"><div class="header-options mb-30"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="charts-search" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default btn-lg" tabindex="0" id="btnSearch" ng-click="vm.getProtocols()"><i class="fa fa-search" aria-hidden="true"></i></button></div><div class="btn-group btn-group-lg main-filters"><button class="btn btn-default btn-lg" ng-class="{\'bg-aqua\' : vm.protocolType === \'ALL\'}" ng-model="vm.protocolType" ng-click="vm.changeProtocolType()" uib-btn-radio="\'ALL\'"><i class="fa" aria-hidden="true" ng-class="vm.protocolType === \'ALL\'?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>All</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-green\' : vm.protocolType === \'AS_NEEDED\'}" ng-model="vm.protocolType" ng-click="vm.changeProtocolType()" uib-btn-radio="\'AS_NEEDED\'"><i class="fa" aria-hidden="true" ng-class="vm.protocolType === \'AS_NEEDED\'?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>As Needed</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-blue\' : vm.protocolType === \'TAPER\'}" ng-model="vm.protocolType" ng-click="vm.changeProtocolType()" uib-btn-radio="\'TAPER\'"><i class="fa" aria-hidden="true" ng-class="vm.protocolType === \'TAPER\'?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Taper</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-orange\' : vm.protocolType === \'CONSISTENT_DOSE\'}" ng-model="vm.protocolType" ng-click="vm.changeProtocolType()" uib-btn-radio="\'CONSISTENT_DOSE\'"><i class="fa" aria-hidden="true" ng-class="vm.protocolType === \'CONSISTENT_DOSE\'?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Consistent Dose</span></button></div></div><h3 class="text-center"><strong>Protocol List</strong></h3><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th style="width: 80px"><button type="button" class="btn btn-default btn-sm" ng-click="vm.checkAll()" uib-tooltip="Check All"><i class="fa fa-check-square-o" aria-hidden="true"></i></button> <button type="button" class="btn btn-default btn-sm" ng-click="vm.unCheckAll()" uib-tooltip="Uncheck All"><i class="fa fa-square-o" aria-hidden="true"></i></button></th><th><strong>Name</strong></th><th><strong>Group</strong></th></tr></thead><tbody><tr ng-repeat="protocol in vm.protocols"><td style="text-align: center"><input type="checkbox" ng-model="vm.selected[protocol.id]" ng-click="vm.toggleOne(vm.selected, vm.selectAll)"></td><td><span>{{protocol.name}}</span></td><td><span>{{protocol.protocolGroupName}}</span></td></tr></tbody></table></div><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.getProtocols()"></ul></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" style="margin-right: auto" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button> <button type="submit" class="btn btn-success" ng-click="vm.deployProtocols()" wz-next>Next <i class="fa fa-chevron-right" aria-hidden="true"></i></button></div></div></form>');
$templateCache.put('app/entities/patient-medication/create/tpl/signature-tpl.html','<h3 class="text-center mb-30"><strong>Doctor Signature</strong></h3><div class=""><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="field_employee_signature_pin">Please, enter your personal PIN:</label> <input type="password" maxlength="4" ng-disabled="vm.employeeSignature" ng-change="vm.employeeSignature = \'\'" ng-required="vm.employeeSignature === null" minlength="4" id="field_employee_signature_pin" name="employee_signature_pin" class="form-control" placeholder="PIN" pattern="\\d{4}" ng-model="vm.employeeSignaturePin" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature name="physician_signature-{{vm.odsSignatureNameId}}" id="field_physician_signature-{{vm.odsSignatureNameId}}" ng-disabled="vm.employeeSignaturePin != null && vm.employeeSignaturePin.length > 0" ng-model="vm.employeeSignature" options="vm.signatureOpts"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="signature_agree"><input type="checkbox" name="field_signature_agree" id="signature_agree" ng-model="vm.employeeSignatureAgree"> I, {{vm.physician.firstName + \' \' + vm.physician.lastName}}, have reviewed, agree and understand the information contained here in the Form.</label></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-disabled="!vm.employeeSignatureAgree || !(vm.employeeSignature || vm.employeeSignaturePin) || vm.isSaving" ng-click="vm.save()"><i class="fa fa-check"></i> Sign</button></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" style="margin-right: auto" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-medication/detail/tpl/discontinue-signature-tpl.html','<h2 class="step-header">Discontinued Physician Signature</h2><hr><div ng-if="vm.patientMedication.discontinueSignature == null"><form name="vm.signatureForm2" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="staffPin2">Please enter your personal PIN:</label> <input type="password" class="form-control" id="staffPin2" name="staffPin2" maxlength="4" pattern="\\d{4}" ng-model="vm.pin" ng-required="vm.pin == null && (vm.signatureDiscontinue == null || vm.signatureDiscontinue == \'\')" ng-change="vm.signatureDiscontinue = \'\'" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.pin"><div class="form-group form-group-sm centered drawer-sign"><label>Or Sign Here:</label><ods-signature ng-model="vm.signatureDiscontinue" options="vm.signatureOpts" ng-required="vm.pin == null && (vm.signatureDiscontinue == null || vm.signatureDiscontinue == \'\')" name="signature-{{vm.odsDiscontinueSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_signatureAgree2"><input type="checkbox" name="signatureAgree2" id="field_signatureAgree2" required ng-model="vm.signatureDiscontinueAgree"> I, {{vm.patientMedication.discontinueByPhysician.lastName + \' \' + vm.patientMedication.discontinueByPhysician.firstName}}, have reviewed, agree and understand the information contained here.</label></div></div><div class="modal-footer"><button type="button" ng-disabled="vm.isSaving || !vm.signatureDiscontinue || vm.signatureForm2.$invalid || !vm.signatureDiscontinueAgree" class="btn btn-success" data-dismiss="modal" ng-click="vm.discontinueSign()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Sign</span></button></div></div></form></div><div ng-if="vm.patientMedication.discontinueSignatureId != null"><label>Discontinued Physician Signature</label><figure><img ng-src-sign="{{vm.patientMedication.discontinueSignatureId}}" id="discontinueSignatureId" alt="Signature" width="300" class="img-responsive"><figcaption>Physician: {{vm.patientMedication.discontinueByPhysician.lastName + ", " + vm.patientMedication.discontinueByPhysician.firstName}}, Date: {{vm.patientMedication.discontinueSignature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div><ng-include src="\'app/entities/patient-medication/wizard/steps.html\'"></ng-include>');
$templateCache.put('app/entities/patient-medication/detail/tpl/form-tpl.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><udt-chart-header chart="vm.chart" show-allergies="true"></udt-chart-header></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive"><table class="table table-condensed"><tbody><tr><td colspan="2"><label>Medication:</label><p>{{vm.patientMedication.medication.name}}</p></td><td><label>Show only in chart:</label><p>{{vm.patientMedication.onlyInChart ? \'Yes\' : \'No\'}}</p></td><td><label>Start Day:</label><p>{{vm.patientMedication.startDate | date: inputDateTimeFormatA}}</p></td></tr><tr><td><label>Route:</label><p>{{vm.patientMedication.route.name}}</p></td><td><label>Dosage Form:</label><p>{{vm.patientMedication.doseForm.name}}</p></td><td><label>Refills Count:</label><p>{{vm.patientMedication.refills ? vm.patientMedication.refills : "-"}}</p></td><td><label>Duration in Days:</label><p>{{vm.patientMedication.durationDays}}</p></td></tr><tr><td colspan="4"><label>Rationale:</label><p>{{vm.rationaleStr ? vm.rationaleStr : "-"}}</p></td></tr><tr><td colspan="4"><label>Instructions:</label><p>{{vm.patientMedication.instruction ? vm.patientMedication.instruction : "-"}}</p></td></tr></tbody></table></div><div class="table-responsive" ng-show="vm.frequencies.length > 0"><table class="table table-condensed"><thead><tr><th><strong>Frequencies</strong></th></tr></thead><tbody><tr ng-repeat="($index, frequency) in vm.frequencies"><td><div class="well well-sm mb-0"><table class="table table-condensed mb-0" style="background: transparent"><tbody><tr><td style="width: 190px" colspan="3"><label ng-if="vm.patientMedication.type == \'TAPER\'">Day {{$index + 1}} -</label> <label ng-if="vm.patientMedication.type != \'TAPER\'">Frequency:</label> {{frequency.frequency.description}}</td></tr><tr ng-repeat="schedule in frequency.schedules"><td style="width: 190px" ng-if="!frequency.hideDay"><label>At:</label><p>{{schedule.date | date:timeFormatA}}</p></td><td colspan="{{!frequency.hideDay ? 2 : 0}}"><label>Strength:</label><p>{{schedule.strength}}</p></td><td style="width: 60px"><label>Quantity:</label><p>{{schedule.quantity}}</p></td></tr></tbody></table></div></td></tr></tbody></table></div><div class="table-responsive" ng-show="vm.takes.length > 0"><table class="table table-condensed"><thead><tr><th><strong>Takes</strong></th></tr></thead><tbody><tr ng-repeat="($index, take) in vm.takes"><td><label>Schedule Date:</label><p>{{take.scheduleDate | date:inputDateTimeFormatA}}</p></td><td style="width: 190px"><label>Status:</label><p>{{take.medicationTakeStatus}}</p></td></tr></tbody></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table class="table table-condensed"><tbody><tr><td><label>Ordered by:</label><p></p><p>{{vm.patientMedication.signedBy.lastName + ", " + vm.patientMedication.signedBy.firstName}}</p><p></p></td><td style="text-align: right"><label>Obtained:</label><p>{{vm.patientMedication.via.name}}</p></td></tr></tbody></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive" ng-if="vm.patientMedication.medicationStatus == \'DISCONTINUED\'"><table class="table table-condensed"><tbody><tr><td><label>Discontinued by:</label><p>{{vm.patientMedication.discontinueBy.lastName + ", " + vm.patientMedication.discontinueBy.firstName}}</p></td><td style="text-align: right"><label>Dicontinue Date:</label><p>{{vm.patientMedication.discontinueDate | date: inputDateTimeFormatA}}</p></td></tr><tr><td colspan="2"><label>Discontinued Reason:</label><p>{{vm.patientMedication.discontinueCause ? vm.patientMedication.discontinueCause : " - "}}</p></td></tr></tbody></table></div><div class="well well-sm signs-array" ng-if="vm.patientMedication.signature || vm.patientMedication.discontinueSignature"><div class="sign-item mb-15" ng-if="vm.patientMedication.signature"><figure><img ng-src-sign="{{vm.patientMedication.signatureId}}" id="signatureId" alt="Signature" width="200" class="img-responsive"><figcaption>Employee: {{vm.patientMedication.signedBy.lastName + ", " + vm.patientMedication.signedBy.firstName}},<br>Date: {{vm.patientMedication.signature.createdDate | date: inputDateTimeFormatA}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.patientMedication.discontinueSignatureId"><figure><img ng-src-sign="{{vm.patientMedication.discontinueSignatureId}}" id="discontinueSignatureId" alt="Discontinue Signature" width="200" class="img-responsive"><figcaption>Employee: {{vm.patientMedication.discontinueByPhysician.lastName + ", " + vm.patientMedication.discontinueByPhysician.firstName}},<br>Date: {{vm.patientMedication.discontinueSignature.createdDate | date: inputDateTimeFormatA}}</figcaption></figure></div></div></div></div><button type="submit" class="btn btn-warning move-btn next-btn" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication/detail/tpl/signature-tpl.html','<h2 class="step-header">Physician Signature</h2><hr><div ng-if="!vm.patientMedication.signed"><form name="vm.signatureForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="staffPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="staffPin" name="staffPin" maxlength="4" pattern="\\d{4}" ng-model="vm.pin" ng-required="vm.pin == null && (vm.signature == null || vm.signature == \'\')" ng-change="vm.signature = \'\'" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.pin"><div class="form-group form-group-sm centered drawer-sign"><label>Or Sign Here:</label><ods-signature ng-model="vm.signature" options="vm.signatureOpts" ng-required="vm.pin == null && (vm.signature == null || vm.signature == \'\')" name="signature-{{vm.odsSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_signatureAgree"><input type="checkbox" name="signatureAgree" id="field_signatureAgree" required ng-model="vm.signatureAgree"> I, {{vm.patientMedication.signedBy.firstName + \' \' + vm.patientMedication.signedBy.lastName}}, have reviewed, agree and understand the information contained here.</label></div></div><div class="modal-footer"><button type="button" ng-disabled="vm.isSaving || (!vm.pin && !vm.signature)  || vm.signatureForm.$invalid || !vm.signatureAgree" class="btn btn-success" data-dismiss="modal" ng-click="vm.physicianSign()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Sign</span></button></div></div></form></div><div ng-if="vm.patientMedication.signed == true"><label>Physician Signature</label><figure><img ng-src-sign="{{vm.patientMedication.signatureId}}" id="signatureId" alt="Signature" width="1000" class="img-responsive"><figcaption>Physician: {{vm.patientMedication.signedBy.lastName + ", " + vm.patientMedication.signedBy.firstName}}, Date: {{vm.patientMedication.signature.createdDate | amDateFormat:amDateFormat}}</figcaption></figure></div><ng-include src="\'app/entities/patient-medication/wizard/steps.html\'"></ng-include><button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-if="vm.checkDiscontinueAccess()"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication/chart/discontinue/discontinue-form-tpl.html','<form name="vm.discontinueForm" role="form"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.discontinueVia ? \'has-success\':\'has-error\'"><label for="obtainedList">Discontinue Via:</label> <select name="obtained" id="obtainedList" class="form-control" required ng-model="vm.discontinueVia" ng-options="item as item.name for item in vm.vias track by item.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.discontinueVia"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.discontinueVia"></span> <span class="help-block" ng-show="!vm.discontinueVia">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.discontinueByPhysician ? \'has-success\':\'has-error\'"><label for="doctors-list">Physician:</label> <select name="doctorList" id="doctors-list" class="form-control" required ng-model="vm.discontinueByPhysician" ng-disabled="vm.itHasCredentials" ng-options="item as item.firstName + \' \' + item.lastName for item in vm.employees track by item.firstName + item.lastName"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.discontinueByPhysician"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.discontinueByPhysician"></span> <span class="help-block" ng-show="!vm.discontinueByPhysician">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.discontinueCause ? \'has-success\': \'has-warning\'"><label class="control-label" for="field_note">Discontinue Cause:</label> <textarea rows="5" class="form-control" name="note" id="field_note" data-resize="disabled" ng-model="vm.discontinueCause"></textarea> <span class="help-block help-warning" ng-show="!vm.discontinueCause">This field is suggested.</span></div></div></div></form><button type="submit" class="btn btn-warning move-btn next-btn" ng-if="vm.itHasCredentials" ng-disabled="vm.discontinueForm.$invalid" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication/chart/discontinue/discontinue-signature-tpl.html','<form name="vm.signatureForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="staffPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="staffPin" name="staffPin" maxlength="4" pattern="\\d{4}" ng-model="vm.pin" ng-required="!vm.pin && !vm.signature" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-show="!vm.pin"><div class="form-group form-group-sm centered drawer-sign"><label>Or Sign Here:</label><ods-signature ng-model="vm.signature" options="vm.signatureOpts" ng-required="!vm.pin && !vm.signature" name="signature-{{vm.odsSignatureNameId}}" id="field_signature-{{vm.odsSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_signatureAgree"><input type="checkbox" name="signatureAgree" id="field_signatureAgree" required ng-model="vm.signatureAgree"> I, {{ vm.employee | employeeName }}, have reviewed, agree and understand the information contained here.</label></div></div></div></form><button type="button" class="btn btn-warning move-btn previous-btn" ng-click="vm.activateSign = false" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication/chart/discontinue/patient-medication-discontinue-wizard-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{\'Discontinue Medication or Protocol\'}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="evaluationWizard" hide-indicators="true"><wz-step wz-title="Order Information"><ng-include src="\'app/entities/patient-medication/chart/discontinue/discontinue-form-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Employee Signature" canenter="vm.discontinueForm.$valid"><ng-include src="\'app/entities/patient-medication/chart/discontinue/discontinue-signature-tpl.html\'"></ng-include></wz-step></wizard></div></div></div>{{vm.hasCredentials}}<div class="modal-footer"><button ng-click="vm.discontinue()" class="btn btn-warning" ng-disabled="vm.discontinueForm.$invalid || (vm.itHasCredentials && vm.signatureForm.$invalid)"><i class="fa fa-ban" aria-hidden="true"></i> Discontinue</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-medication/chart/history/patient-medication-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Medications History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Name</strong></th><th><strong>Start Date</strong></th><th><strong>End Date</strong></th><th><strong>Discontinue by</strong></th><th></th></tr></thead><tbody><tr ng-repeat="patientMedication in vm.patientMedications"><td>{{patientMedication.medication.name}} - {{patientMedication.durationDays + \' days\'}} - {{patientMedication.type | clearEnum}}</td><td>{{patientMedication.startDate | amDateFormat: amDateFormat}}</td><td>{{patientMedication.endDate | amDateFormat: amDateFormat}}</td><td>{{patientMedication.discontinueBy | employeeName }} - <span class="small">{{patientMedication.discontinueDate | amDateFormat: amDateFormat}}</span></td><td><a class="dt-btn warning" ng-click="vm.addMedicationFromHistory(patientMedication.id)"><i class="fa fa-history"></i></a></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/patient-medication/mars/comment/patient-medication-mars-comment-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive" ng-if="vm.takes.ids.length == 1"><table class="table table-condensed table-striped"><thead><tr><th><strong>Employee</strong></th><th><strong>Date</strong></th><th><strong>Comments</strong></th></tr></thead><tbody><tr ng-repeat="comment in vm.comments"><td>{{comment.employee.lastName + ", " + comment.employee.firstName}}</td><td>{{comment.createdDate | amDateFormat: amDateFormat}}</td><td>{{comment.name}}</td></tr></tbody></table></div><div class="fright" ng-if="vm.takes.ids.length == 1"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div><hr ng-if="vm.takes.ids.length == 1"></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="comments mb-30"><label for="commentText"></label> <textarea class="form-control mb-15" name="" id="commentText" rows="4" ng-model="vm.message" placeholder="Add comment..."></textarea><div class="text-center"><button type="button" class="btn btn-warning" uib-tooltip="Add Comment" ng-click="vm.addComment()" ng-disabled="vm.message == null || vm.message.length == 0"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Comment</button></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/patient-medication/mars/first-dose-side-effect/first-dose-side-effect.dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="table-responsive" ng-if="vm.takes.ids.length == 1"><table class="table table-condensed table-striped"><thead><tr><th><strong>Employee</strong></th><th><strong>Date</strong></th><th><strong>Reaction</strong></th></tr></thead><tbody><tr ng-repeat="reaction in vm.reactions"><td>{{reaction.employee.lastName + ", " + reaction.employee.firstName}}</td><td>{{reaction.createdDate | amDateFormat: amDateFormat}}</td><td>{{reaction.name}}</td></tr></tbody></table></div><div class="fright" ng-if="vm.takes.ids.length == 1"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div><hr ng-if="vm.takes.ids.length == 1"></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="comments mb-30"><label for="reactionText"></label> <textarea class="form-control mb-15" name="" id="reactionText" rows="4" placeholder="Add First Dose/Side effect..." ng-model="vm.message"></textarea><div class="text-center"><button type="button" class="btn btn-warning" uib-tooltip="Add Reaction" ng-click="vm.add()" ng-disabled="vm.message == null || vm.message.length == 0"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add First Dose/Side effect</button></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/patient-medication/mars/list/patient-medication-mars-new.html','<section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="header-options mb-30"><button class="btn btn-default btn-lg btn-header green" ng-click="vm.openNotingDialog()" ng-if="vm.itHasNotingCredentials"><i class="fa fa-edit" aria-hidden="true"></i> Noting</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="charts-search" ng-model="vm.searchQuery"> <button type="button" class="btn btn-default btn-lg" tabindex="0" ng-click="vm.changeFilter()"><i class="fa fa-search" aria-hidden="true"></i></button> <button type="button" class="btn btn-default btn-lg" tabindex="0" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></div></div><div class="btn-group btn-group-lg main-filters"><button class="btn btn-default btn-lg" ng-class="{\'bg-green\' : vm.filter.filterStatus == vm.filterStatus.CURRENT}" ng-click="vm.changeFilter(\'filterStatus\', vm.filterStatus.CURRENT)"><i class="fa" aria-hidden="true" ng-class="vm.filter.filterStatus == vm.filterStatus.CURRENT?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Current Meds</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-blue\' : vm.filter.filterStatus == vm.filterStatus.ADMINISTER}" ng-click="vm.changeFilter(\'filterStatus\', vm.filterStatus.ADMINISTER)"><i class="fa" aria-hidden="true" ng-class="vm.filter.filterStatus == vm.filterStatus.ADMINISTER?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Admin/Obsvd</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-orange\' : vm.filter.filterStatus == vm.filterStatus.TODAY}" ng-click="vm.changeFilter(\'filterStatus\', vm.filterStatus.TODAY)"><i class="fa" aria-hidden="true" ng-class="vm.filter.filterStatus == vm.filterStatus.TODAY?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Today\'s Meds</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-red\' : vm.filter.filterStatus == vm.filterStatus.MISSED}" ng-click="vm.changeFilter(\'filterStatus\', vm.filterStatus.MISSED)"><i class="fa" aria-hidden="true" ng-class="vm.filter.filterStatus == vm.filterStatus.MISSED?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Missed Meds</span></button> <button class="btn btn-default btn-lg" ng-class="{\'bg-aqua\' : vm.filter.filterStatus == vm.filterStatus.PATIENT_REFUSE}" ng-click="vm.changeFilter(\'filterStatus\', vm.filterStatus.PATIENT_REFUSE)"><i class="fa" aria-hidden="true" ng-class="vm.filter.filterStatus == vm.filterStatus.PATIENT_REFUSE?\'fa-check-square-o\':\'fa-square-o\'"></i> <span>Patient Refuse</span></button></div></div><div class="box-body"><div class="empty-content" ng-if="vm.charts.length == 0"><div class="notice-text well well-lg"><span>There are no</span> <span class="big">Patients</span> <span>with prescription</span></div></div><div class="table-responsive forms-tabs" ng-if="vm.charts.length > 0"><table class="table table-condensed custom-table"><thead><tr><th></th><th><strong>Name</strong></th><th><strong>MR#</strong></th><th><strong>Day of Birth</strong></th><th><strong>Level of Care</strong></th><th ng-if="vm.filter.filterStatus != vm.filterStatus.ADMINISTER"><strong>Pending</strong></th><th ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER"><strong>Administered</strong></th><th><strong>BlueAlerts</strong></th></tr></thead><tbody><tr ng-repeat-start="chartProj in vm.charts"><td><button type="button" class="btn btn-default btn-sm btn-icon" ng-click="vm.toggleRow(chartProj)"><i class="fa" aria-hidden="true" ng-class="{\'fa-minus-circle\' : chartProj.active, \'fa-plus-circle\': !chartProj.active}"></i></button></td><td>{{chartProj.firstName}} {{chartProj.middleName}} {{chartProj.lastName}}</td><td>{{chartProj.mrNo}}</td><td>{{chartProj.dob | date: inputDateFormat}}</td><td>{{chartProj.levelCare}}</td><td>{{chartProj.pending}}</td><td>{{chartProj.urgentIssues ? chartProj.urgentIssues : \'-\'}}</td><td></td></tr><tr class="annexed-row" ng-if="chartProj.active" ng-class="{\'hidden-row\' : !chartProj.active}" ng-repeat-end><td colspan="7"><div class="well well-sm"><div class="table-responsive"><table class="table table-condensed mb-0"><thead><tr><th class="text-center"><strong>Patient</strong></th><th class="text-center"><strong>Vitals</strong></th><th class="text-center"><strong>Glucose</strong> <button type="button" class="btn btn-success btn-sm pull-right" ng-click="vm.showGlucosePopup(chartProj)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Glucose</button></th></tr></thead><tbody><tr class="pm-tables-container"><td class="table-basic-info" style="vertical-align: top"><header class="meds-header"><div class="photo"><img class="img-responsive img-thumbnail" ng-src-auth="{{chartProj.chart}}" ng-if="chartProj.chart"></div><div class="basic-data"><h3 class="name mb-15 mt-0" ng-click="vm.openChart(chartProj.chart.id)"><strong>{{chartProj.firstName}} {{chartProj.middleName}} {{chartProj.lastName}}</strong></h3><p><strong>MR#</strong> - {{chartProj.mrNo}}</p><p><strong>D.O.B. - </strong>{{chartProj.dob | date: inputDateFormat}}</p><p><strong>D.O.A. - </strong>{{chartProj.chart.admissionDate | date: inputDateFormat}}</p><p><strong>Allergies - </strong>{{chartProj.allergies}}</p><p ng-if="chartProj.pendingNoting.count > 0" ng-class="\'label label-danger\'" ng-click="vm.openNotingDialog(chartProj)">{{chartProj.pendingNoting.count}} Pending noting</p></div></header></td><td class="table-vitals"><table class="table table-condensed" style="vertical-align: top"><tbody><tr><td><strong>Date</strong></td><td><span ng-class="{\'label label-danger\': !vm.isToday(chartProj.vitals.date)}">{{chartProj.vitals.date | amDateFormat:amDateFormat}}</span></td></tr><tr><td><strong>Blood Pressure</strong></td><td>{{chartProj.vitals.bpSystolic}}/{{chartProj.vitals.bpDiastolic}}</td></tr><tr><td><strong>Temperature</strong></td><td>{{chartProj.vitals.temperature ? chartProj.vitals.temperature : \'-\'}} F</td></tr><tr><td><strong>Pulse</strong></td><td>{{chartProj.vitals.pulse ? chartProj.vitals.pulse : \'-\'}}</td></tr><tr><td><strong>Respiration</strong></td><td>{{chartProj.vitals.respiration ? chartProj.vitals.respiration : \'-\'}}</td></tr><tr><td><strong>O<sup>2</sup> Saturation</strong></td><td>{{chartProj.vitals.o2Saturation ? chartProj.vitals.o2Saturation : \'-\'}}</td></tr></tbody></table></td><td class="table-glucose" style="vertical-align: top"><table class="table table-condensed"><tbody><tr><td><strong>Date:</strong></td><td><span ng-class="{\'label label-danger\': !vm.isToday(chartProj.glucose.date)}">{{chartProj.glucose.date | amDateFormat:amDateFormat}}</span></td></tr><tr><td><strong>Reading:</strong></td><td>{{chartProj.glucose.reading ? chartProj.glucose.reading : \'-\'}}</td></tr><tr><td><strong>Type of Check:</strong></td><td>{{chartProj.glucose.typeCheck ? chartProj.glucose.typeCheck.name : \'-\'}}</td></tr><tr><td colspan="2"><strong>Notes:</strong></td></tr><tr><td colspan="2"><div style="white-space:pre-wrap;" ng-bind-html="chartProj.glucose.notes ? chartProj.glucose.notes : \'-\'"></div></td></tr><tr ng-if="chartProj.measurements && chartProj.measurements.length"><td><strong>Measurements:</strong></td><td></td></tr><tr ng-repeat="data in chartProj.measurements"><td>{{data.name + ": "}}</td><td>{{data.measurements ? data.measurements : \'-\'}}</td></tr></tbody></table></td></tr></tbody></table></div><hr><div class="table-name"><h4 class="name"><strong>Care & Deliveries</strong></h4><button type="button" class="btn btn-success btn-sm" ng-click="vm.assignEvaluation(chartProj)"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add New Form</button></div><div class="table-responsive"><table class="table table-condensed table-striped custom-table mb-0"><thead><tr><th><strong>Name</strong></th><th><strong>Dates</strong></th><th><strong>Score</strong></th><th><strong>Status</strong></th><th></th></tr></thead><tbody><tr ng-repeat="evaluation in chartProj.evaluations"><td>{{evaluation.name + (evaluation.title ? evaluation.title : "")}}</td><td>{{evaluation.createdDate | amDateFormat:amDateFormat}}</td><td>{{evaluation.measurements}}</td><td class="status"><span class="{{vm.getEvaluationStatusClass(evaluation)}}">{{evaluation.status}}</span></td><td><div class="dd-buttons btn-group" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="evaluation.status == \'Pending\' || evaluation.status == \'Late\' || evaluation.status == \'InReview\'"><a class="dd-link orange" ui-sref="care-delivery({id: evaluation.id })"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="evaluation.status != \'Pending\' && evaluation.status != \'Late\'"><a class="dd-link aqua" ui-sref="care-delivery-view({id: evaluation.id })"><i class="fa fa-list-alt" aria-hidden="true"></i> See Details</a></li><li role="menuitem" ng-if="evaluation.status == \'Pending\' || evaluation.status == \'Late\'"><a class="dd-link red" ng-click="vm.del(chartProj, evaluation)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li><li role="menuitem" ng-if="evaluation.addemdums && (evaluation.status == \'InReview\' || evaluation.status == \'Finalized\')"><a class="dd-link blue" ng-click="vm.amended(chartProj, evaluation)"><i class="fa fa-plus" aria-hidden="true"></i> Amended</a></li></ul></div></td></tr></tbody></table></div><hr><div class="table-name"><h4 class="name" ng-if="vm.filter.filterStatus != vm.filterStatus.ADMINISTER"><strong>Schedule Medications</strong></h4><h4 class="name" ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER"><strong>Administered/Observed Medications</strong></h4><div><button type="button" class="btn btn-primary btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER || vm.filter.filterStatus == vm.filterStatus.MISSED" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.sign(chartProj)"><i class="fa fa-pencil" aria-hidden="true"></i> Sign</button> <button type="button" class="btn btn-success btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.firstDoseSideEffect(chartProj)"><i class="fa fa-user-md" aria-hidden="true"></i> First Dose Side Effect</button> <button type="button" class="btn btn-dark btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER || vm.filter.filterStatus == vm.filterStatus.MISSED || vm.filter.filterStatus == vm.filterStatus.PATIENT_REFUSE" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.addComment(chartProj)"><i class="fa fa-commenting-o" aria-hidden="true"></i> Comments</button> <button type="button" class="btn btn-success btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT || vm.filter.filterStatus == vm.filterStatus.MISSED" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.administer(chartProj, vm.status.ADMINISTERED)"><i class="fa fa-check-square-o" aria-hidden="true"></i> Administer</button> <button type="button" class="btn btn-primary btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT || vm.filter.filterStatus == vm.filterStatus.MISSED" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.administer(chartProj, vm.status.OBSERVED)"><i class="fa fa-eye" aria-hidden="true"></i> Observe</button> <button type="button" class="btn btn-warning btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT || vm.filter.filterStatus == vm.filterStatus.MISSED || vm.filter.filterStatus == vm.filterStatus.TODAY" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.administer(chartProj, vm.status.MISSED)"><i class="fa fa-eye-slash" aria-hidden="true"></i> Miss</button> <button type="button" class="btn btn-danger btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT || vm.filter.filterStatus == vm.filterStatus.TODAY" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.administer(chartProj, vm.status.HOLD)"><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Hold</button> <button type="button" class="btn btn-aqua btn-sm" ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT" ng-disabled="vm.getSelectedIds(chartProj.selected).length == 0" ng-click="vm.administer(chartProj, vm.status.PATIENT_REFUSE)"><i class="fa fa-close" aria-hidden="true"></i> Patient Refuse</button></div></div><div class="table-responsive" ng-if="chartProj.takes.length > 0"><table class="table table-condensed table-striped custom-table mb-0"><thead><tr><th></th><th><strong>Date & Time</strong></th><th ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER"><strong>Actual</strong></th><th><strong>Medication</strong></th><th><strong>Type</strong></th><th><strong>Frequency</strong></th><th><strong>Route</strong></th><th><strong>Dose</strong></th><th><strong>Strength</strong></th><th><strong>Status</strong></th><th ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER || vm.filter.filterStatus == vm.filterStatus.PATIENT_REFUSE"><strong>Employee</strong></th><th ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER"><strong>Comments</strong></th><th></th></tr></thead><tbody><tr ng-repeat="take in chartProj.takes"><td><label><input type="checkbox" ng-model="chartProj.selected[take.takeId]" ng-click="vm.toggleOne(chartProj.selected, chartProj.selectAll)"></label></td><td>{{take.scheduleDate | date: inputDateTimeFormatA}}</td><td ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER">{{take.administerDate | date: inputDateTimeFormatA}}</td><td>{{take.medicationName}}</td><td>{{take.type | clearEnum}}</td><td>{{take.frequency.description}}</td><td>{{take.routeName}}</td><td>{{take.quantity}}</td><td>{{take.strength}} <i class="fa fa-info-circle danger" aria-hidden="true" ng-if="take.instruction && take.instruction.length > 0" title="{{take.instruction}}" ng-click="vm.view(take.pmId)"></i></td><td><span class="label {{vm.getTakeStatusClass(take)}}">{{take.medicationTakeStatus}}</span> <i class="fa fa-info-circle danger" aria-hidden="true" title="{{take.missedReasons}}" ng-if="take.medicationTakeStatus == \'MISSED\'" ng-mouseover="vm.showMissingReasons(take)" ng-click="vm.getMissingReasons(take)"></i></td><td ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER || vm.filterStatus.PATIENT_REFUSE">{{(take.administerBy ? take.administerBy : take.observedBy) | employeeName}}</td><td ng-if="vm.filter.filterStatus == vm.filterStatus.ADMINISTER">{{take.commentsCount > 0 ? \'Yes(\' + take.commentsCount + \')\' : \'No\'}}</td><td><div class="dd-buttons btn-group" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a class="dd-link orange" ng-click="vm.print(take.pmId, chartProj)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li></ul></div></td></tr></tbody></table><jhi-item-count page="chartProj.takesPage" total="chartProj.takesTotalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="chartProj.takesTotalItems" items-per-page="vm.itemsPerPage" ng-model="chartProj.takesPage" ng-change="vm.getTakes(chartProj)"></ul></div><hr><div ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT"><div class="table-name"><h4 class="name"><strong>As Needed Medications</strong></h4><div><button type="button" class="btn btn-success btn-sm" ng-disabled="vm.getSelectedIds(chartProj.selectedAsNeeded).length == 0" ng-click="vm.addAsNeeded(chartProj, vm.status.ADMINISTERED)"><i class="fa fa-check-square-o" aria-hidden="true"></i> Administer</button> <button type="button" class="btn btn-primary btn-sm" ng-disabled="vm.getSelectedIds(chartProj.selectedAsNeeded).length == 0" ng-click="vm.addAsNeeded(chartProj, vm.status.OBSERVED)"><i class="fa fa-eye" aria-hidden="true"></i> Observe</button></div></div><div class="table-responsive" ng-if="vm.filter.filterStatus == vm.filterStatus.CURRENT && chartProj.asNeeded.length > 0"><table class="table table-condensed table-striped custom-table mb-0"><thead><tr><th></th><th><strong>Medications</strong></th><th><strong>Frequency</strong></th><th><strong>Route</strong></th><th><strong>Dose</strong></th><th><strong>Strength</strong></th><th><strong>Last Take</strong></th><th><strong>Available Next Take</strong></th><th></th></tr></thead><tbody><tr ng-repeat="take in chartProj.asNeeded"><td><label><input type="checkbox" ng-model="chartProj.selectedAsNeeded[take.pmId]" ng-click="vm.toggleOne(chartProj.selectedAsNeeded, chartProj.selectAllAsNeeded)"></label></td><td>{{take.medicationName}}</td><td>{{take.frequency.description}}</td><td>{{take.routeName}}</td><td>{{take.quantity}}</td><td>{{take.strength}} &nbsp; <i class="fa fa-info-circle danger" aria-hidden="true" title="{{take.instruction}}" ng-if="take.instruction && take.instruction.length > 0" ng-click="vm.view(take.pmId)"></i></td><td>{{take.lastScheduleDate | date: inputDateTimeFormatA}}</td><td><span class="label {{vm.getTakeAsNeededAvailableClass(take)}}">{{take.untilDate | date: inputDateTimeFormatA}}</span></td><td><div class="dd-buttons btn-group" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a class="dd-link orange" ng-click="vm.print(take.pmId, chartProj)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li></ul></div></td></tr></tbody></table><jhi-item-count page="chartProj.takesAsNeededPage" total="chartProj.takesAsNeededTotalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="chartProj.takesAsNeededTotalItems" items-per-page="vm.itemsPerPage" ng-model="chartProj.takesAsNeededPage" ng-change="vm.getAsNeededTakes(chartProj)"></ul></div></div></div></td></tr></tbody></table></div><div class="fright"><jhi-item-count page="vm.filter.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.filter.page" ng-change="vm.loadAll()"><ul></ul></ul></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-medication/mars/missed/patient-medication-mars-missed-wizard-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="patientMedicationMissWizard" indicators-position="top" hide-indicators="true"><span ng-if="vm.showReasons"><wz-step wz-title="Miss reasons"><ng-include src="\'app/entities/patient-medication/mars/missed/tpl/missed-reason-tpl.html\'"></ng-include></wz-step></span><span ng-if="!vm.isPatientSigned"><wz-step wz-title="Patient Signature"><ng-include src="\'app/entities/patient-medication/mars/missed/tpl/patient-signature-tpl.html\'"></ng-include></wz-step></span><span ng-if="!vm.isEmployeeSigned"><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-medication/mars/missed/tpl/employee-signature-tpl.html\'"></ng-include></wz-step></span></wizard></div></div></div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="vm.addReasons()" ng-disabled="vm.missedReasons == null || vm.missedReasons.length == 0 || vm.isSaving" ng-if="vm.showReasons"><i class="fa fa-ban" aria-hidden="true"></i> Set as Missed and Add Reasons</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/patient-medication/mars/sign/patient-medication-mars-sign-wizard-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="patientMedicationObservedWizard" indicators-position="top" hide-indicators="true"><span ng-if="!vm.isPatientSigned"><wz-step wz-title="Patient Signature"><ng-include src="\'app/entities/patient-medication/mars/sign/tpl/patient-signature-tpl.html\'"></ng-include></wz-step></span><span ng-if="!vm.isEmployeeSigned"><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-medication/mars/sign/tpl/employee-signature-tpl.html\'"></ng-include></wz-step></span><span ng-if="vm.isPatientSigned && vm.isEmployeeSigned"><wz-step wz-title="Employee Signature"><ng-include src="\'app/entities/patient-medication/mars/sign/tpl/signatures-tpl.html\'"></ng-include></wz-step></span></wizard></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/patient-medication/mars/system-miss/patient-medication-mars-system-miss-reason-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.title}}</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="comments mb-30"><label for="reactionText"></label> <textarea class="form-control mb-15" name="" id="reactionText" rows="4" placeholder="Add reason..." ng-model="vm.systemMissReason"></textarea></div></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.addReason()" ng-disabled="vm.systemMissReason == null || vm.systemMissReason.length == 0 || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-warning" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-order/lab-requisition/add-result/add-lab-requisition-result-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Add result</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row condition-controls" ng-repeat="($index, result) in vm.results"><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="result.labCompendium?(editForm.test_code{{$index}}.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_test_code{{$index}}">Test Code</label><ui-select name="field_test_code{{$index}}" id="field_test_code{{$index}}" required ng-model="result.labCompendium" reset-search-input="true"><ui-select-match allow-clear="true" placeholder="Test Codes...">{{$select.selected.code}}</ui-select-match><ui-select-choices repeat="item in vm.labCompendiums | filter: $select.search" refresh="vm.getLabCompendium($select.search)" minimun-input-length="1" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!result.labCompendium"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="result.labCompendium && editForm.test_code{{$index}}.$dirty"></span> <span class="help-block" aria-hidden="true" ng-show="!result.labCompendium">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group has-feedback" ng-class="result.result?(editForm.result{{$index}}.$dirty?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_result{{$index}}">Result</label><div class="input-group"><input type="text" class="form-control" name="result{{$index}}" id="field_result{{$index}}" required ng-model="result.result"> <span class="input-group-btn"><button type="button" class="btn btn-danger" ng-click="vm.remove($index)"><i class="fa fa-remove" aria-hidden="true"></i></button></span></div><span class="help-block" aria-hidden="true" ng-show="!result.result">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-4 col-lg-4"><div class="form-group"><label class="control-label" for="field_abnormal{{$index}}">Abnormal</label><br><toggle ng-model="result.abnormal" on="Yes" off="No" id="field_abnormal{{$index}}"></toggle></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center pb-15"><hr><button type="button" class="btn btn-warning btn-sm" ng-click="vm.addOther()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Other Result</button></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="editForm.$error.required || vm.isSaving || vm.results.length == 0"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/create/lab-requisition-dialog.html','<form name="editForm" role="form" novalidate><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myLabRequisitionLabel">Create Lab Requisition</h4></div><div class="modal-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table><div class="modal-footer"><button type="submit" ng-click="vm.create()" class="btn btn-success"><i class="fa fa-save" aria-hidden="true"></i> Create</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></div></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/lab-order-create-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Create Lab Order</h4></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><wizard name="createLabOrderWizard" indicators-position="top"><wz-step wz-title="{{vm.getStaredTitle}}"><ng-include src="\'app/entities/patient-order/lab-requisition/create-order/tpl/filter-tpl.html\'"></ng-include></wz-step><wz-step wz-title="Basic Info" wz-disabled="{{vm.chartSelected}}"><ng-include src="\'app/entities/patient-order/lab-requisition/create-order/tpl/basic-info-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.basicInfo.$invalid"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Primary Insurance Information" wz-disabled="{{vm.disabledInsuranceSteps || vm.chartSelected}}"><ng-include src="\'app/entities/patient-order/lab-requisition/create-order/tpl/insurance-primary-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.primaryInsurance.$error.required"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Secondary Insurance Information" wz-disabled="{{vm.disabledInsuranceSteps || vm.secondaryInsurance == null || vm.chartSelected}}"><ng-include src="\'app/entities/patient-order/lab-requisition/create-order/tpl/insurance-secondary-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-disabled="vm.form.secondaryInsurance.$error.required"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="{{vm.labOrderTitle}}"><ng-include src="\'app/entities/patient-order/lab-requisition/create-order/tpl/lab-order-form-tpl.html\'"></ng-include><button type="button" class="btn btn-warning move-btn previous-btn" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button> <button type="submit" class="btn btn-warning move-btn next-btn" ng-click="vm.activateSign = true" ng-if="vm.itHasCredentials && !vm.activateSign" ng-disabled="!vm.patientOrder.patientOrderTests.length > 0 || vm.form.editForm2.$error.required" wz-next><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button></wz-step><wz-step wz-title="Employee Signature" wz-disabled="{{!vm.itHasCredentials}}"><ng-include src="\'app/entities/patient-order/lab-requisition/create-order/tpl/patient-order-signature-tpl.html\'"></ng-include></wz-step></wizard></div></div></div><div class="modal-footer"><button ng-click="vm.save()" class="btn btn-success" ng-disabled="!vm.patientOrder.patientOrderTests.length > 0 || vm.isSaving" ng-if="!vm.itHasCredentials"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button ng-click="vm.save()" class="btn btn-success" ng-if="vm.activateSign" ng-disabled="(!vm.signature && !vm.pin) || !vm.agree || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" ng-click="vm.cancel()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-order/lab-requisition/detail/lab-requisition-detail.html','<form name="editForm" role="form" novalidate><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myLabRequisitionDetailLabel">Lab Requisition Details</h4></div><div class="modal-body"><div class="row"><div class="col-md-4" ng-if="vm.chart"><img class="img-responsive max-width=75%" alt="Patient Photo" ng-src-auth="{{vm.chart}}"></div><div class="col-md-4"><table class="table"><tr><td><strong>Patient Name:</strong></td><td>{{vm.chart.firstName + (vm.chart.middleName == null ? " " : " " + vm.chart.middleName + " ") + vm.chart.lastName}}</td></tr><tr><td><strong>MRN:</strong></td><td>{{vm.chart.mrNo}}</td></tr><tr><td><strong>D.O.B:</strong></td><td>{{vm.chart.dateBirth | date:inputDateFormat}}</td></tr><tr><td><strong>Schedule Day:</strong></td><td>{{vm.date | date:inputDateFormat}}</td></tr><tr><td><strong>Barcode:</strong></td><td>{{vm.barcode == \'null\' ? \'-\' : vm.barcode}}</td></tr></table></div><div class="col-md-4"><table class="table"><tr><td><strong>Gender:</strong></td><td>{{vm.chart.sex ? vm.chart.sex : \'-\'}}</td></tr><tr><td><strong>Payment:</strong></td><td>{{vm.insurances.length ? \'Insurance\' : \'No\'}}</td></tr><tr><td><strong>Phone:</strong></td><td>{{vm.chart.phone ? vm.chart.phone : \'-\'}}</td></tr><tr><td><strong>Address:</strong></td><td>{{vm.chart.address + \', \' + vm.chart.city + \', \' + (vm.chart.countryState ? vm.chart.countryState.state : \'\') + \' \' + vm.chart.zip}}</td></tr></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h3><span>Request Medical Test Order</span></h3></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table datatable="" dt-options="vm.dtOptions1" dt-columns="vm.dtColumns1" dt-instance="vm.dtInstance1" class="table table-striped table-bordered"></table></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h3><span>Patient Testing Insurances</span></h3></div><div class="empty-content" ng-if="vm.chart.typePaymentMethods.category !== \'Insurance\'"><div class="text"><span>The patient is</span> <span>Under</span> <span>{{vm.chart.typePaymentMethods.name}}</span></div></div><div class="row" ng-if="vm.chart.typePaymentMethods.category === \'Insurance\' && vm.primary"><div class="col-md-4"><table class="table"><tr><td><strong>Plan No.:</strong></td><td>{{vm.primary.planNumber}}</td></tr><tr><td><strong>Group No.:</strong></td><td>{{vm.primary.groupNumber}}</td></tr><tr><td><strong>Policy No.:</strong></td><td>{{vm.primary.policyNumber}}</td></tr></table></div><div class="col-md-4"><table class="table"><tr><td><strong>Group Name:</strong></td><td>{{vm.primary.groupName}}</td></tr><tr><td><strong>Type:</strong></td><td>{{vm.primary.insuranceType.name}}</td></tr><tr><td><strong>Relation:</strong></td><td>{{vm.primary.insuranceRelation.name}}</td></tr></table></div><div class="col-md-4"><table class="table"><tr><td><strong>RXBIN:</strong></td><td>{{vm.primary.rxBin}}</td></tr><tr><td><strong>PCN:</strong></td><td>{{vm.primary.pcn}}</td><td></td></tr><tr><td><strong>SSN:</strong></td><td>{{vm.primary.socialSecurity}}</td><td></td></tr></table></div><div class="col-md-12"><table class="table"><tr><td><strong>Company:</strong></td><td>{{vm.primary.insuranceCarrier.name}}</td><td><strong>Address:</strong></td><td>{{vm.primary.address + ", " + vm.primary.city + ". " + vm.primary.countryState.stateCode + ". " + vm.primary.zipCode}}</td></tr></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/list/lab-requisition.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable>');
$templateCache.put('app/entities/patient-result/critical/chart/patient-result-critical-chart-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Patient Results Chart - 6 Month - {{vm.criticalResult.testName}}</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="top-info"><div class="basic-details"><h4 class="mb-0 mt-0">{{vm.criticalResult.patientName}}</h4><p class="small mb-0">Specimen ID: <strong>{{vm.criticalResult.barcode}}</strong></p><p class="small mb-0">Collection Date: <strong>{{vm.criticalResult.collectionDate | amDateFormat: displayDateformat}}</strong></p><p class="small mb-0">Test Performed: <strong>{{vm.criticalResult.testName}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge By: <strong>{{vm.acknowledgeBy}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge Date: <strong>{{vm.criticalResult.date | amDateFormat: displayDateformat}}</strong></p></div><div class="result-label"><span class="highlighted-label red big">{{vm.testResult}}</span></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><h1 class="text-center"><div class="row"><div class="col-md-12"><canvas id="line" class="chart chart-line" chart-data="vm.data" chart-labels="vm.labels" chart-series="vm.series" chart-options="vm.options" chart-dataset-override="vm.datasetOverride" chart-colors="vm.colors"></canvas></div></div></h1><h4><li style="color:red"><span style="color:black">LL/HH</span></li><li style="color:blue"><span style="color:black">L/H</span></li><li style="color:green"><span style="color:black">Normal</span></li></h4></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="vm.acknowledge()" ng-if="!vm.criticalResult.isAcknowledge"><i class="fa fa-check" aria-hidden="true"></i> Acknowledge</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/critical/detail/patient-result-critical-dialog.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h3 class="modal-title">Critical Results</h3></div><div class="modal-body"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="top-info"><div class="basic-details"><h4 class="mb-0 mt-0">{{vm.criticalResult.patientName}}</h4><p class="small mb-0">Specimen ID: <strong>{{vm.criticalResult.barcode}}</strong></p><p class="small mb-0">Collection Date: <strong>{{vm.criticalResult.collectionDate | amDateFormat: dateFormat}}</strong></p><p class="small mb-0">Test Performed: <strong>{{vm.criticalResult.testName}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge By: <strong>{{vm.acknowledgeBy}}</strong></p><p ng-if="vm.criticalResult.date" class="small mb-0">Acknowledge Date: <strong>{{vm.criticalResult.date | amDateFormat: dateFormat}}</strong></p></div><div class="result-label"><span class="highlighted-label red big">{{vm.testResult}}</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label>Lab Comments</label><div class="well well-lg"><div class="text"><p ng-repeat="comment in vm.comments">{{comment.resultComment}}</p><p ng-if="vm.comments.length == 0">No Lab Comments</p></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label>Employee Comments</label><table class="table table-bordered"><tbody><tr><th>Employee</th><th>Date/Time</th><th>Comment</th></tr><tr ng-repeat="ecomment in vm.prDetEmployeeComments"><td>{{ecomment.employeeFirstName}} {{ecomment.employeeLastName}}</td><td>{{ecomment.createdDate | amDateFormat: amDateFormat}}</td><td>{{ecomment.comment}}</td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.acknowledge()" ng-if="!vm.criticalResult.isAcknowledge"><i class="fa fa-check" aria-hidden="true"></i> Acknowledge</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div>');
$templateCache.put('app/entities/patient-result/critical/list/patient-result-critical.html','<generic-entity-datatable descriptor="vm.descriptor"></generic-entity-datatable><section class="content" ng-if="false"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="header-options mb-30"><button type="button" class="btn btn-default btn-lg btn-header green" ng-click="vm.acknowledge()"><i class="fa fa-check-circle" aria-hidden="true"></i> Acknowledge Selected</button><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search query..." ng-model="vm.searchQuery" popover-class="" ng-change="vm.search()" id="searchQueryPatient"> <button type="button" class="btn btn-default btn-lg" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div></div><div class="btn-group btn-group-lg main-filters"><button type="button" title="All Results" ng-click="vm.updateAcknowledgeButtonFilter(\'All\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active bg-green\': vm.acknowledgeFilter == \'All\'}]"><i class="fa fa-flask" aria-hidden="true"></i> <span class="hidden-xs">All Results</span></button> <button type="button" class="btn btn-default btn-flat" title="Acknowledge" ng-click="vm.updateAcknowledgeButtonFilter(\'Acknowledge\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active bg-green\': vm.acknowledgeFilter == \'Acknowledge\'}]"><i class="fa fa-spinner" aria-hidden="true"></i> <span class="hidden-xs">Acknowledge</span></button> <button type="button" class="btn btn-default" title="Unacknowledged" ng-click="vm.updateAcknowledgeButtonFilter(\'Unacknowledged\');" ng-class="[\'btn\',\'btn-default\', \'btn-lg\', {\'active bg-green\': vm.acknowledgeFilter == \'Unacknowledged\'}]"><i class="fa fa-circle-o" aria-hidden="true"></i> <span class="hidden-xs">Unacknowledged</span></button></div></div><div class="box"><div class="box-body"><div class="table-responsive"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-condensed table-striped custom-table"></table></div></div></div></div></div></section>');
$templateCache.put('app/entities/patient-order/chart/new/patient-order.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px"><h4 class="header-line mt-0 mb-10 pb-10" style="border-bottom: 1px solid #d2d6de"><div class="input-group input-group-sm search"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th><strong>Order Number:</strong></th><th><strong>Start Date:</strong></th><th><strong>Signed:</strong></th><th><strong>Order Type:</strong></th><th><strong>Status:</strong></th><th></th></tr></thead><tbody><tr class="item-order" ng-repeat="item in vm.patientOrder" ng-class="(item.orderStatus != \'DISCONTINUED\') ? ((item.signed) ? \'\' : \'bg-warning\') : \'bg-canceled\' "><td><span>{{item.id}}</span></td><td><span class="date">{{item.startDate | date: inputDateFormat}}</span></td><td><small class="label" ng-class="{\'label-success\': item.signed, \'label-danger\': !item.signed}">{{item.signed ? \'Yes\' : \'No\'}}</small></td><td><span class="blue light">{{item.orderType.replace("_"," ")}}</span></td><td><span>{{item.orderStatus}}</span></td><td width="45px"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" title="See Details" class="dd-link blue" ng-click="vm.detail(item.id)"><i class="fa fa-fax" aria-hidden="true"></i> See Details</a></li><li role="menuitem" ng-if="item.orderStatus != \'DISCONTINUED\' && item.orderStatus != \'FINISHED\'"><a href="" title="Cancel" class="dd-link orange" ng-click="vm.del(item.id)"><i class="fa fa-list-alt" aria-hidden="true"></i>Cancel</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div><!-- ./table-responsive --><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.patientOrder.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default shadow" disabled="disabled"><span class="dummy">&nbsp;</span></button> <button type="button" class="btn btn-default" has-any-authority="{{vm.accessCreate}}" ng-disabled="vm.chart.status== \'CLOSED\' || vm.chart.status== \'WAITING\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add Order</button><div class="btn-group dropup" uib-dropdown><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div></div></div>');
$templateCache.put('app/entities/patient-order/chart/old/patient-order.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header"><div class="fancy-icon blue big"><i class="fa fa-stethoscope fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Lab Orders</h2></div><div class="item-body"><div class="patient-medications"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th><strong>Order Number:</strong></th><th><strong>Start Date:</strong></th><th><strong>Signed:</strong></th><th><strong>Order Type:</strong></th><th><strong>Status:</strong></th><th></th></tr></thead><tbody><tr class="item-order" ng-repeat="item in vm.patientOrder" ng-class="(item.orderStatus != \'DISCONTINUED\') ? (item.signed) ? \'\' : \'bg-warning\' : \'bg-canceled\' "><td><span>{{item.id}}</span></td><td><span class="date">{{item.startDate | date: inputDateFormat}}</span></td><td><small class="label" ng-class="{\'label-success\': item.signed, \'label-danger\': !item.signed}">{{item.signed ? \'Yes\' : \'No\'}}</small></td><td><span class="blue light">{{item.orderType.replace("_"," ")}}</span></td><td><span>{{item.orderStatus}}</span></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" title="See Details" class="dd-link blue" ng-click="vm.detail(item.id)"><i class="fa fa-fax" aria-hidden="true"></i> See Details</a></li><li role="menuitem" ng-if="item.orderStatus != \'DISCONTINUED\' && item.orderStatus != \'FINISHED\'"><a href="" title="Cancel" class="dd-link orange" ng-click="vm.del(item.id)"><i class="fa fa-list-alt" aria-hidden="true"></i>Cancel</a></li></ul></div><!-- /dropdown--></td></tr></tbody></table></div></div></div><div class="item-footer"><div class="fleft"><button type="button" has-any-authority="{{vm.accessCreate}}" ng-disabled="vm.chart.status== \'CLOSED\' || vm.chart.status== \'WAITING\'" class="button-link" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Order</button></div><div class="fright"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/rcopia/chart/new/rcopia-chart.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px"><section class="content no-padding" ng-if="!vm.rcopiaAccount"><div class="grid-wrapper" ng-class="{\'no-padding\': vm.toggleLayout}"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div id="currentChartEmpty" class="charts-empty"><div class="empty-text"><div class="empty-search"><div class="text-center"><span class="icon"><i class="fa fa-users" aria-hidden="true"></i></span></div><p><span>Unfortunately,</span><br>you do not have a credential to access</p></div></div></div></div></div></section><section class="content no-padding" ng-if="vm.rcopiaAccount && !vm.chart.rcopiaId"><div class="grid-wrapper" ng-class="{\'no-padding\': vm.toggleLayout}"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div id="currentChartEmpty" class="charts-empty"><div class="empty-text"><div class="empty-search"><p><span>Transfer</span><br>to Rcopia server to start prescribing</p></div></div></div></div></div></section></div><div class="buttons-toolbar btn-group" ng-if="vm.corporation.rcopiaIntegration && !vm.chart.rcopiaId && vm.rcopiaAccount"><button type="button" class="btn btn-default" ng-disabled="vm.loading" ng-click="vm.transfer()"><i class="fa fa-exchange" aria-hidden="true" style="color: #00a65a"></i> Transfer to Rcopia Server</button><div class="btn-group dropup" uib-dropdown><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div></div>');
$templateCache.put('app/entities/track/chart/new/track-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Track History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Start Date</strong></th><th><strong>End Date</strong></th><th><strong>Track</strong></th><th><strong>Employee</strong></th></tr></thead><tbody><tr ng-repeat="track in vm.tracks"><td>{{track.startDate | amDateFormat: amDateFormat}}</td><td>{{track.endDate | amDateFormat: amDateFormat}}</td><td>{{track.track.name}}</td><td>{{track.employee.firstName + " " + data.employee.lastName}}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div>');
$templateCache.put('app/entities/report/update/tpl/report-columns-tpl.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="columns-drag-layout"><div class="panel panel-default column-list" ng-repeat="column in vm.columns"><div class="panel-heading"><h4 class="panel-title"><strong>{{column.name}}</strong></h4></div><div class="panel-body"><ul class="list-unstyled" dnd-list dnd-drop="vm.onDrop(column, item, index)"><li ng-repeat="item in column.items" ng-class="{\'selected\': item.selected}" dnd-draggable="vm.getSelectedItemsIncluding(column, item)" dnd-dragstart="vm.onDragStart(column, event)" dnd-moved="vm.onMoved(column)" dnd-dragend="column.dragging = false" dnd-selected="item.selected = !item.selected" ng-hide="column.dragging && item.selected"><span class="column-name">{{item.description}}</span></li></ul></div></div></div></div></div>');
$templateCache.put('app/entities/report/update/tpl/report-conditions-tpl.html','<form name="vm.form.reportCondition" role="form" novalidate><div class="row condition-controls" id="report-condition" ng-repeat="($index, item) in vm.conditions"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="row"><div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"><div class="form-group"><label class="blank hidden-xs">&nbsp;</label><br><button type="button" class="btn btn-danger btn-sm" ng-if="!item.reportField.required" ng-click="vm.removeCondition($index, item)"><i class="fa fa-remove" aria-hidden="true"></i></button></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback" ng-class="item.reportField !== null ? (vm.form.reportCondition.$dirty ? \'has-success\' : \'\') : \'has-error\'"><label>Field:</label> <select name="field{{$index}}" class="form-control input-sm" ng-if="item.reportField.required" ng-model="item.reportField" ng-options="option as option.description for option in vm.requiredFields track by option.id" ng-change="vm.getValuesByFieldType(item, $index)" required ng-disabled="item.reportField.required"></select> <select name="field{{$index}}" class="form-control input-sm" ng-if="!item.reportField.required" ng-model="item.reportField" ng-options="option as option.description for option in vm.fields | filter: vm.filterFields track by option.id" ng-change="vm.getValuesByFieldType(item, $index)" required></select> <span class="help-block" ng-show="item.reportField === null">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group form-group-sm has-feedback"><label>Condition:</label> <select name="reportCondition{{$index}}" id="field_reportCondition{{$index}}" class="form-control input-sm" ng-model="item.reportCondition" required><option></option><option value="BETWEEN" ng-if="item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Between</option><option value="EQUAL_TO" selected="selected">Equal to</option><option value="NOT_EQUAL_TO">Not equal to</option><option value="CONTAINS" ng-if="item.reportField.type === \'STRING\'">Contains</option><option value="LESSER_THAN" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Lesser than</option><option value="LESSER_THAN_OR_EQUAL_TO" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Lesser than or equal to</option><option value="GREATER_THAN" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Greater than</option><option value="GREATER_THAN_OR_EQUAL_TO" ng-if="item.reportField.type === \'NUMERIC\' || item.reportField.type === \'DATE\' || item.reportField.type === \'DATETIME\'">Greater than or equal to</option><option value="IS_NULL">Is null</option><option value="IS_NOT_NULL">Is not null</option></select> <span class="help-block" ng-show="vm.form.reportCondition[\'reportCondition\' + $index].$error.required">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-3 col-lg-3"><div class="form-group has-feedback"><label>Value:</label> <select name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" class="form-control input-sm" ng-if="item.reportField.type === \'VALUE\' || item.reportField.type === \'ENUM\'" ng-model="item.reportValueObject" ng-options="i as i.value for i in vm.conditionValues[item.reportField.id] track by i.id" ng-disabled="item.reportField === null || item.reportCondition === null"><option value=""></option></select> <select name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" class="form-control input-sm" ng-if="item.reportField.type === \'BOOLEAN\'" ng-model="item.reportValue" ng-disabled="item.reportField === null || item.reportCondition === null"><option value="TRUE" ng-if="item.reportField.id !== \'ALLERGIES\' && item.reportField.id !== \'DIETS\' && item.reportField.id !== \'DIAGNOSES\'">TRUE</option><option value="FALSE" ng-if="item.reportField.id !== \'ALLERGIES\' && item.reportField.id !== \'DIETS\' && item.reportField.id !== \'DIAGNOSES\'">FALSE</option><option value="TRUE" ng-if="item.reportField.id === \'ALLERGIES\' || item.reportField.id === \'DIETS\' || item.reportField.id === \'DIAGNOSES\'">ACTIVE</option><option value="FALSE" ng-if="item.reportField.id === \'ALLERGIES\' || item.reportField.id === \'DIETS\' || item.reportField.id === \'DIAGNOSES\'">INACTIVE</option></select><div class="input-group input-group-sm has-feedback pb-10" ng-if="item.reportField.type === \'DATETIME\'"><input name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" type="text" class="form-control" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.datetime[$index]" ng-model="item.reportValue" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datetime\', $index)"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm has-feedback pb-10" ng-if="item.reportField.type === \'DATE\'"><input name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" type="text" class="form-control" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.date[$index]" ng-model="item.reportValue" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date\', $index)"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm has-feedback" ng-if="item.reportField.type === \'DATE\' && item.reportCondition === \'BETWEEN\'"><input name="{{vm.getFieldName($index)}}_2" id="{{vm.getFieldId($index)}}_2" type="text" class="form-control" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.date2[$index]" ng-model="item.reportValue2" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock" required ng-class="item.reportValue2 ? (vm.form.reportCondition[vm.getFieldName($index) + \'_2\'].$dirty ? \'has-success\' : \'\') : \'has-error\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'date2\', $index)"><i class="fa fa-calendar"></i></button></span></div><div class="input-group input-group-sm has-feedback pb-10" ng-if="item.reportField.type === \'DATETIME\' && item.reportCondition === \'BETWEEN\'"><input name="{{vm.getFieldName($index)}}_2" id="{{vm.getFieldId($index)}}_2" type="text" class="form-control" datetime-picker="{{inputDateTimeFormatA}}" is-open="vm.datePickerOpenStatus.datetime2[$index]" ng-model="item.reportValue2" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock" required ng-class="item.reportValue2 ? (vm.form.reportCondition[vm.getFieldName($index) + \'_2\'].$dirty ? \'has-success\' : \'\') : \'has-error\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datetime2\', $index)"><i class="fa fa-calendar"></i></button></span></div><input name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" type="text" class="form-control input-sm has-feedback" ng-if="(item.reportField === null) || item.reportField.type === \'STRING\' || item.reportField.type === \'NUMERIC\'" ng-model="item.reportValue" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock"><ui-select name="{{vm.getFieldName($index)}}" id="{{vm.getFieldId($index)}}" ng-if="item.reportField.type === \'VALUE_SEARCH\'" ng-model="item.reportValueObject" reset-search-input="true" close-on-select="true" ng-disabled="item.reportField === null || item.reportCondition === null || item.lock" class="{{item.lock ? (item.reportValue ? (vm.form.reportCondition[vm.getFieldName($index)].$dirty ? \'has-success\' : \'\') : \'has-error\') : \'\'}}"><ui-select-match placeholder="Select ..." allow-clear="true">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat="i in vm.conditionValues[item.reportField.id][$index] | filter: $select.search" refresh="vm.searchValuesByService(item, $index, $select.search)" refresh-delay="0"><div ng-bind-html="i.value | highlight: $select.search"></div></ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-1 col-lg-1"><div class="form-group"><label class="control-label">Lock:</label><br><toggle ng-model="item.lock" on="Yes" off="No" id="reportLock{{$index}}" ng-disabled="(item.reportField.type !== \'VALUE_SEARCH\' && !item.reportValue) || (item.reportField.type === \'VALUE_SEARCH\' && !item.reportValueObject)"></toggle></div></div></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center pb-15"><hr><button type="button" class="btn btn-warning btn-sm" ng-click="vm.addCondition()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add Condition</button></div></div></form>');
$templateCache.put('app/entities/report/update/tpl/report-information-tpl.html','<form name="vm.form.reportInformation" role="form" novalidate><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.report.name?(vm.form.reportInformation.name.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="reportName">Name:</label> <input type="text" id="reportName" name="name" class="form-control input-sm" ng-model="vm.report.name" required> <span class="help-block" ng-show="!vm.report.name || vm.form.reportInformation.name.$error.required">This field is required.</span></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.report.category?(vm.form.reportInformation.category.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="reportCategory">Category:</label> <select name="category" id="reportCategory" class="form-control input-sm" required ng-model="vm.report.category" ng-options="item as vm.getCategoryLabel(item.id) for item in vm.reportCategories track by item.id" ng-change="vm.getReportFields()"></select> <span class="help-block" ng-show="!vm.report.category || vm.form.reportInformation.category.$error.required">This field is required.</span></div></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback"><label class="control-label" for="field_schedule_id">Schedule Days</label><ui-select id="field_schedule_id" name="schedule" multiple="multiple" ng-model="vm.schedule" close-on-select="false" title="Schedule"><ui-select-match placeholder="Select Days...">{{$item}}</ui-select-match><ui-select-choices repeat="day in vm.days | filter:$select.search">{{day}}</ui-select-choices></ui-select></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><label for="field_employees">Employees:</label><ui-select name="reaction" id="field_employees" title="Employees" multiple="multiple" ng-model="vm.report.employees" reset-search-input="true" close-on-select="false"><ui-select-match allow-clear="true" placeholder="Employees...">{{$item.lastName + \', \' + $item.firstName}}</ui-select-match><ui-select-choices repeat="employee in vm.employees | filter: $select.search" refresh="vm.getEmployees($select.search)" refresh-delay="0"><div ng-bind-html="employee.lastName + \', \' + employee.firstName "></div></ui-select-choices></ui-select></div></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Enable:</label> <button type="button" class="btn btn-block btn-sm" ng-class="vm.report.enable ? \'btn-success\' : \'btn-danger\'" ng-model="vm.report.enable" uib-btn-checkbox btn-checkbox-true="true" btn-checkbox-false="false"><i class="fa" aria-hidden="true" ng-class="vm.report.enable ? \'fa-check-square-o\' : \'fa-square-o\'"></i> <span ng-if="vm.report.enable">Enable</span> <span ng-if="!vm.report.enable">Disable</span></button></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"><div class="form-group"><label>Only mine:</label> <button type="button" class="btn btn-block btn-sm" ng-class="vm.report.onlyMine ? \'btn-success\' : \'btn-danger\'" ng-model="vm.report.onlyMine" uib-btn-checkbox btn-checkbox-true="true" btn-checkbox-false="false"><i class="fa" aria-hidden="true" ng-class="vm.report.onlyMine ? \'fa-check-square-o\' : \'fa-square-o\'"></i> <span ng-if="vm.report.onlyMine">Yes</span> <span ng-if="!vm.report.onlyMine">No</span></button></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group"><label for="reportDescription">Description:</label> <textarea name="reportDescription" id="reportDescription" class="form-control" rows="4" data-resize="disabled" ng-model="vm.report.description"></textarea></div></div></form>');
$templateCache.put('app/entities/track/chart/old/track-history.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Track History</h4></div><div class="modal-body"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><form name="searchForm" class="form-inline"><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.print()" ng-disabled="vm.isPrinting || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-save" aria-hidden="true"></i> Print</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/type-level-care/chart/new/type-level-care-history.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Level Care History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Start Date</strong></th><th><strong>End Date</strong></th><th><strong>Level of Care</strong></th><th><strong>Employee</strong></th></tr></thead><tbody><tr ng-repeat="levelCare in vm.levelCares"><td>{{levelCare.startDate | amDateFormat: amDateFormat}}</td><td>{{levelCare.endDate | amDateFormat: amDateFormat}}</td><td>{{levelCare.typeLevelCare.name}}</td><td>{{levelCare.employee.firstName + " " + levelCare.employee.lastName}}</td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div>');
$templateCache.put('app/entities/type-level-care/chart/old/type-level-care-history.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Level Care History</h4></div><div class="modal-body"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="box-header"><div class="dt-header"><form name="searchForm" class="form-inline"><div class="input-group input-group-lg pull-right"><input type="text" class="form-control" id="searchQuerysignature" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()"> <span class="input-group-btn width-min"><button class="btn btn-primary" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></span></div></form></div></div><div class="box-body"><table datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance" class="table table-striped table-bordered"></table></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"></ul></div></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.print()" ng-disabled="vm.isPrinting || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-save" aria-hidden="true"></i> Print</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/vitals/chart/old/vitals.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem(\'.patient-vitals\')"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header has-chart"><nvd3 class="patient-chart p-vitals" options="vm.optionsVitals" data="vm.dataVitals"></nvd3><h2 class="head-text small text-center" ng-click="">Vitals</h2></div><div class="item-body"><table class="table"><tbody><tr><td><label><strong>Date</strong></label></td><td>{{vm.vitals.date | amDateFormat: amDateFormat}}</td></tr><tr><td><label><input type="radio" name="graph-selector-vitals" id="blood-graph" value="" checked="checked" ng-click="vm.selectGraphData(\'blood\')"> <strong>Blood Presure</strong></label></td><td>{{vm.vitals.bpSystolic}}/{{vm.vitals.bpDiastolic}}</td></tr><tr><td><label><input type="radio" name="graph-selector-vitals" id="temperature-graph" ng-click="vm.selectGraphData(\'temp\')"> <strong>Temperature</strong></label></td><td>{{vm.vitals.temperature ? vm.vitals.temperature : \'-\'}}<sup>&compfn;</sup> F</td></tr><tr><td><label><input type="radio" name="graph-selector-vitals" id="pulse-graph" ng-click="vm.selectGraphData(\'pulse\')"> <strong>Pulse</strong></label></td><td>{{vm.vitals.pulse ? vm.vitals.pulse : \'-\'}}</td></tr><tr><td><label><input type="radio" name="graph-selector-vitals" id="respiration-graph" ng-click="vm.selectGraphData(\'respiration\')"> <strong>Respiration</strong></label></td><td>{{vm.vitals.respiration ? vm.vitals.respiration : \'-\'}}</td></tr><tr><td><label><input type="radio" name="graph-selector-vitals" id="saturation-graph" ng-click="vm.selectGraphData(\'o2\')"> <strong>O<sup>2</sup> Saturation</strong></label></td><td>{{vm.vitals.o2Saturation ? vm.vitals.o2Saturation : \'-\'}}</td></tr></tbody></table></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add New <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><a ng-click="vm.history()" class="footer-link">History <i class="fa fa-file-text-o" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/vitals/chart/new/vitals.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Vitals:</strong> <a href="" class="btn-icon" uib-tooltip="Add New Data" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong><span ng-class="{\'label label-danger\': vm.isVitalsDayOld}">{{vm.vitals.date | date:inputDateTimeFormatA}}</span> </strong><i class="fa fa-info-circle danger" style="font-size: 14px; cursor: help; vertical-align: middle" ng-if="vm.isVitalsDayOld" uib-tooltip="Vital is older than 24 hour. Please add a new vital."></i> -</p><p class="mb-0 inline-list"><span><strong>BP</strong> - {{vm.vitals.bpSystolic}}/{{vm.vitals.bpDiastolic}}</span> <span><strong>Temp:</strong> - {{vm.vitals.temperature ? vm.vitals.temperature : \'-\'}}<sup>o</sup>F</span> <span><strong>Pul:</strong> - {{vm.vitals.pulse ? vm.vitals.pulse : \'-\'}}</span> <span><strong>Resp:</strong> - {{vm.vitals.respiration ? vm.vitals.respiration : \'-\'}}</span> <span><strong>0<sup>2</sup></strong> - {{vm.vitals.o2Saturation ? vm.vitals.o2Saturation : \'-\'}}</span></p></div>');
$templateCache.put('app/entities/weight/chart/new/weight.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Weight:</strong> <a href="" class="btn-icon" uib-tooltip="Add New Data" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="text-center">- <strong>{{vm.weight.date | amDateFormat:amDateFormat}}</strong> -</p><p class="mb-0 inline-list"><span><strong>Weight (Lb)</strong> - {{vm.weight.weight}}</span> <span><strong>Height (ft & in):</strong> - {{vm.getHeightInchesToFeetInches(vm.weight.height)}}</span> <span><strong>BMI:</strong> - {{vm.weight.bmi}}</span></p></div>');
$templateCache.put('app/entities/weight/chart/old/weight.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header has-chart"><nvd3 class="patient-chart p-weight" options="vm.optionsW" data="vm.dataW"></nvd3><h2 class="head-text small text-center">Weight</h2></div><div class="item-body"><table class="table"><tbody><tr><td><label><strong>Date</strong></label></td><td>{{vm.weight.date | amDateFormat:amDateFormat}}</td></tr><tr><td><label><input type="radio" name="graph-selector-weight" id="weight-graph" ng-click="vm.selectGraphData(\'weight\')"> <strong>Weight (Lb)</strong></label></td><td>{{vm.weight.weight ? vm.weight.weight : \'-\'}}</td></tr><tr><td><label><input type="radio" name="graph-selector-height" id="height-graph" ng-disabled="true"> <strong>Height (ft & in)</strong></label></td><td>{{vm.weight.height ? vm.getHeightInchesToFeetInches(vm.weight.height) : \'-\'}}</td></tr><tr><td><label><input type="radio" name="graph-selector-weight" id="bmi-graph" ng-click="vm.selectGraphData(\'bmi\')"> <strong>BMI</strong></label></td><td>{{vm.weight.bmi ? vm.weight.bmi : \'-\'}}</td></tr></tbody></table></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-disabled="vm.chart.status == \'CLOSED\'" ng-click="vm.add()">Add New <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fright"><a ng-click="vm.history()" class="footer-link">History <i class="fa fa-file-text-o" aria-hidden="true"></i></a></div></div>');
$templateCache.put('app/entities/chart/detail/new/sections/basic-information.html','<h4 class="header-line"><span>Basic Information</span><div class="header-line-btns"><button type="button" class="btn btn-default btn-xs" ng-click="vm.viewImageLicense()" ng-if="vm.chartPictureLicense"><i class="fa fa-id-card"></i> View ID</button> <button type="button" class="btn btn-default btn-xs" ng-click="vm.editImageLicense()" ng-if="vm.chart.status !== \'CLOSED\'"><i ng-class="vm.chartPictureLicense ? \'fa fa-id-card\' : \'fa fa-plus-circle\'"></i>{{vm.chartPictureLicense ? \' Edit ID\' : \' Add ID\'}}</button></div></h4><div class="chart-patient-info"><div class="info-group half"><div class="table-responsive"><table class="table table-condensed mb-0 table-borderless"><tbody><tr class="labels"><td><strong>Level Of Care:</strong></td><td><strong>SSN:</strong></td><td><strong>Admission Date:</strong></td><td ng-if="vm.checkField(\'SOBRIETY_DATE\')"><strong>Sobriety Date:</strong></td></tr><tr><td>{{vm.chart.typeLevelCare ? vm.chart.typeLevelCare.name : \'-\'}}</td><td>{{vm.chart.social ? (vm.chart.social | ssnFormat): \'-\'}}</td><td>{{vm.chart.admissionDate ? (vm.chart.admissionDate | date: inputDateTimeFormatA) : \'-\'}}</td><td ng-if="vm.checkField(\'SOBRIETY_DATE\')">{{vm.chart.sobrietyDate ? (vm.chart.sobrietyDate | date: inputDateFormat): \'-\'}}</td></tr><tr class="labels"><td colspan="2"><strong>Address:</strong></td><td colspan="2"><strong>Discharge Type:</strong></td></tr><tr><td colspan="2">{{vm.chart.address + \', \' + vm.chart.city + \', \' + (vm.chart.countryState ? vm.chart.countryState.state : \'\') + \' \' + vm.chart.zip}}</td><td colspan="2">{{vm.chart.typeDischargeType ? vm.chart.typeDischargeType.name : \'-\'}}</td></tr><tr class="labels"><td><strong>Track:</strong></td><td ng-if="vm.checkField(\'MARKETER\')"><strong>Outreach:</strong></td><td><strong>Discharge to:</strong></td><td><strong>Discharge Date:</strong></td></tr><tr><td>{{vm.chart.track ? vm.chart.track.name : \'-\'}}</td><td ng-if="vm.checkField(\'MARKETER\')">{{vm.chart.marketer?vm.chart.marketer.firstName + \' \' +vm.chart.marketer.lastName:\'-\'}}</td><td>{{vm.chart.dischargeTo ? vm.chart.dischargeTo : \'-\'}}</td><td>{{vm.chart.dischargeDate ? (vm.chart.dischargeDate | date: inputDateTimeFormatA) : \'-\'}}</td></tr><tr class="labels"><td><strong>Phone:</strong></td><td><strong>Gender:</strong></td><td><strong>Alt. Phone:</strong></td><td ng-if="vm.checkField(\'BED\')"><strong>Bed:</strong></td></tr><tr><td>{{(vm.chart.phone && !isNaN(vm.chart.phone)) ? (vm.chart.phone | phone) : \'-\'}}</td><td>{{vm.chart.sex}}</td><td>{{(vm.chart.altPhone && !isNaN(vm.chart.altPhone)) ? (vm.chart.altPhone | phone) :\'-\'}}</td><td ng-if="vm.checkField(\'BED\')">{{vm.chart.bed ? vm.chart.bed.name : \'-\'}}</td></tr><tr class="labels"><td><strong>Pharmacy:</strong></td></tr><tr class="labels"><td>{{vm.chart.defaultPharmacy ? vm.chart.defaultPharmacy.name: \'\'}}</td></tr><tr class="labels" ng-if="!vm.chart.allowReadmit"><td colspan="4"><strong>Reason why patient is not allowed to readmit:</strong></td></tr><tr ng-if="!vm.chart.allowReadmit"><td colspan="4">{{vm.chart.readmitReason}}</td></tr><tr class="labels" ng-if="vm.chart.facility.facilityType == \'COVID_RC\'"><td><strong>Vessel:</strong></td><td><strong>Vessel Code:</strong></td><td><strong>Voyage No:</strong></td><td><strong>Cabin:</strong></td></tr><tr ng-if="vm.chart.facility.facilityType == \'COVID_RC\'"><td>{{vm.chart.vessel ? vm.chart.vessel.name :\'-\'}}</td><td>{{vm.chart.vesselCode ? vm.chart.vesselCode : \'-\'}}</td><td>{{vm.chart.voyageNo ? vm.chart.voyageNo : \'-\'}}</td><td>{{vm.chart.cabin ? vm.chart.cabin : \'-\'}}</td></tr><tr class="labels" ng-if="vm.chart.facility.facilityType == \'COVID_RC\'"><td><strong>Crew Id:</strong></td><td><strong>Passenger Id:</strong></td><td><strong>Sailing Date:</strong></td><td><strong>Port:</strong></td></tr><tr ng-if="vm.chart.facility.facilityType == \'COVID_RC\'"><td>{{vm.chart.crewId ? vm.chart.crewId : \'-\'}}</td><td>{{vm.chart.passengerId ? vm.chart.passengerId : \'-\'}}</td><td>{{vm.chart.sailingDate ? (vm.chart.sailingDate | date: inputDateFormat) : \'-\'}}</td><td>{{vm.chart.port ? vm.chart.port.name :\'-\'}}</td></tr></tbody></table></div></div><div class="info-group half"><div class="table-responsive"><table class="table table-condensed mb-0"><tbody><tr class="labels"><td><strong>Race:</strong></td><td><strong>Marital Status:</strong></td><td><strong>Ethnicity:</strong></td><td><strong>Occupation:</strong></td></tr><tr><td>{{vm.chart.typeRace ? vm.chart.typeRace.name :\'-\'}}</td><td>{{vm.chart.typeMaritalStatus ? vm.chart.typeMaritalStatus.name : \'-\'}}</td><td>{{vm.chart.typeEthnicity ? vm.chart.typeEthnicity.name : \'-\'}}</td><td>{{vm.chart.occupancy ? vm.chart.occupancy : \'-\'}}</td></tr><tr class="labels"><td><strong>Preferred Name:</strong></td><td><strong>External ID:</strong></td><td ng-if="vm.checkField(\'ADMISSION_REP\')"><strong>Admission Rep.:</strong></td></tr><tr><td>{{vm.chart.preferredName?vm.chart.preferredName: \'-\'}}</td><td>{{vm.chart.externalId?vm.chart.externalId: \'-\'}}</td><td ng-if="vm.checkField(\'ADMISSION_REP\')">{{vm.chart.admissionRep?vm.chart.admissionRep.firstName + \' \' +vm.chart.admissionRep.lastName:\'-\'}}</td></tr><tr class="labels"><td><strong>Employer:</strong></td><td><strong>Employer Phone:</strong></td><td colspan="2"><strong>Referral Source:</strong></td></tr><tr><td>{{vm.chart.employer?vm.chart.employer: \'-\'}}</td><td>{{(vm.chart.employerPhone && !isNaN(vm.chart.employerPhone)) ? (vm.chart.employerPhone | phone) : \'-\'}}</td><td colspan="2">{{vm.chart.referrer ? vm.chart.referrer : \'-\'}}</td></tr><tr class="labels"><td><strong>Date 1<sup>st</sup> Contact:</strong></td><td><strong>1<sup>st</sup> Contact Phone:</strong></td><td><strong>1<sup>st</sup> Contact Name:</strong></td><td><strong>1<sup>st</sup> Contact Relationship:</strong></td></tr><tr><td>{{vm.chart.dateFirstContact ? (vm.chart.dateFirstContact | date: inputDateFormat): \'-\'}}</td><td>{{(vm.chart.firstContactPhone && !isNaN(vm.chart.firstContactPhone)) ? (vm.chart.firstContactPhone | phone) : \'-\'}}</td><td>{{vm.chart.firstContactName ? vm.chart.firstContactName : \'-\'}}</td><td>{{vm.chart.firstContactRelationship?vm.chart.firstContactRelationship:\'-\'}}</td></tr><tr class="labels"><td colspan="3"><strong>Email:</strong></td></tr><tr><td colspan="3">{{vm.chart.email}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/chart/detail/new/tabs/tab-basic-info.html','<div class="demographics grid-flex"><div class="grid-item full"><ng-include src="\'app/entities/chart/detail/new/sections/basic-information.html\'"></ng-include></div><div class="grid-item full"><div ui-view="chart-concurrent-reviews" has-any-authority="{{vm.accessConcurrentReviewView}}"></div></div><div class="grid-item full"><div ui-view="chart-verifytx" has-any-authority="{{vm.accessVerifytxView}}"></div></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default" ng-click="vm.edit()"><i class="fa fa-edit" aria-hidden="true" style="color: #f39c12"></i> Basic Information</button> <button type="button" class="btn btn-default" ng-click="vm.addConcurrentReview()"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> New Concurrent Review</button> <button type="button" class="btn btn-default" ng-click="vm.verify()"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a7d0"></i> New Verification</button><div class="btn-group dropup" uib-dropdown><button type="button" class="btn btn-default" uib-dropdown-toggle><i class="fa fa-history" aria-hidden="true" style="color: #dd4b39"></i> History <span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu role="menu"><li role="menuitem"><a ng-click="vm.showAlcoholHistory()" has-any-authority="{{vm.accessAlcoholView}}">Alcohol History</a></li><li role="menuitem"><a ng-click="vm.showAllergiesHistory()" has-any-authority="{{vm.accessAllergiesView}}">Allergies History</a></li><li role="menuitem"><a ng-click="vm.showCareTeamHistory()" has-any-authority="{{vm.accessCareTeamView}}">Care Team History</a></li><li role="menuitem"><a ng-click="vm.showDiagnosesHistory()" has-any-authority="{{vm.accessDiagnosesView}}">Diagnoses History</a></li><li role="menuitem"><a ng-click="vm.showDietsHistory()" has-any-authority="{{vm.accessDietsView}}">Diets History</a></li><li role="menuitem"><a ng-click="vm.showDischargeDateHistory()" has-any-authority="{{vm.accessDischargeHistory}}">Discharge History</a></li><li role="menuitem"><a ng-click="vm.showDrugsHistory()" has-any-authority="{{vm.accessDrugsView}}">Drugs History</a></li><li role="menuitem"><a ng-click="vm.showGlucoseHistory()" has-any-authority="{{vm.accessGlucoseView}}">Glucose History</a></li><li role="menuitem"><a ng-click="vm.showLevelCareHistory()" has-any-authority="{{vm.accessLevelCareHistory}}">Level of Care History</a></li><li role="menuitem"><a ng-click="vm.showNotesHistory()" has-any-authority="{{vm.accessChartNoteView}}">Notes History</a></li><li role="menuitem"><a ng-click="vm.showTrackHistory()" has-any-authority="{{vm.accessTrackHistory}}">Track History</a></li><li role="menuitem"><a ng-click="vm.showVerifyTxHistory()" has-any-authority="{{vm.accessVerifytxView}}">Verification of Benefits History</a></li><li role="menuitem"><a ng-click="vm.showVitalsHistory()" has-any-authority="{{vm.accessVitalsView}}">Vitals History</a></li><li role="menuitem"><a ng-click="vm.showWeightHistory()" has-any-authority="{{vm.accessWeightView}}">Weight History</a></li></ul></div><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div>');
$templateCache.put('app/entities/concurrent-reviews/chart/old/tpl/concurrent-reviews.html','<div class="well well-sm mb-0"><div class="table-responsive"><table class="table table-condensed"><tr><td><strong><i class="fa fa-calendar-check-o" aria-hidden="true"></i> Start Date:</strong></td><td><strong><i class="fa fa-calendar-times-o" aria-hidden="true"></i> End Date:</strong></td><td><strong><i class="fa fa-hashtag" aria-hidden="true"></i> of days:</strong></td><td><strong>Frequency:</strong></td><td><strong>Level of Care:</strong></td><td><strong>LCD:</strong></td><td><strong><i class="fa fa-calendar" aria-hidden="true"></i> Auth Date:</strong></td><td><strong>Auth <i class="fa fa-hashtag" aria-hidden="true"></i>:</strong></td><td rowspan="6" style="width: 45px; vertical-align: top"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" class="dd-link orange" ng-click="vm.edit(concurrent.id)"><i class="fa fa-edit" aria-hidden="true"></i> Edit</a></li><li role="menuitem" ng-if="vm.chart.status != \'CLOSED\'"><a href="" class="dd-link red" ng-click="vm.del(concurrent.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</a></li></ul></div></td></tr><tr><td>{{concurrent.startDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.endDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.numberDates}}</td><td>{{concurrent.concurrentReviewFrequency ? concurrent.concurrentReviewFrequency.name : \'\'}}</td><td>{{concurrent.typeLevelCare ? concurrent.typeLevelCare.name : \'\'}}</td><td>{{concurrent.lastCoverageDate ? "Yes" : "No"}}</td><td>{{concurrent.authorizationDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.authorizationNumber}}</td></tr><tr><td><strong>Next Review:</strong></td><td><strong>Care Manager:</strong></td><td><strong><i class="fa fa-calendar" aria-hidden="true"></i> Care Manager Phone:</strong></td><td colspan="3"><strong>Insurance:</strong></td><td colspan="2"><strong><i class="fa fa-user" aria-hidden="true"></i> Created by:</strong></td></tr><tr><td>{{concurrent.nextReviewDate | date:\'MM/dd/yy\'}}</td><td>{{concurrent.careManager}}</td><td>{{concurrent.careManagerPhone | phone : \'-\'}}</td><td colspan="3">{{concurrent.insurance.insuranceCarrier.name}}</td><td colspan="2">{{concurrent.employee.firstName + \' \' + concurrent.employee.lastName}}</td></tr><tr><td colspan="8"><strong><i class="fa fa-file-text" aria-hidden="true"></i> Notes:</strong></td></tr><tr><td colspan="8">{{concurrent.notes}}</td></tr></table></div></div>');
$templateCache.put('app/entities/patient-medication/chart/list/new/patient-medication-chart2.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px"><h4 class="header-line mt-0 mb-10 pb-10" style="border-bottom: 1px solid #d2d6de"><div class="input-group input-group-sm search"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="patient-medications"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th><input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)"></th><th><strong>Name:</strong></th><th><strong>Only In Chart:</strong></th><th><strong>Start Date:</strong></th><th><strong>End Date:</strong></th><th><strong>Enter:</strong></th><th><strong>Status:</strong></th><th><strong>Faxed To:</strong></th><th></th></tr></thead><tbody><tr class="item-order" ng-repeat="patientMedication in vm.patientMedications"><td><input type="checkbox" ng-model="vm.selected[patientMedication.id]" ng-click="vm.toggleOne(vm.selected, vm.selectAll)"></td><td class="order-name"><p><i class="fa fa-exclamation-triangle warning" style="font-size: 14px; cursor: help; vertical-align: middle; color: #ffbe4f" ng-if="patientMedication.medicationStatus === \'SCHEDULED\' && patientMedication.warning > 0 && patientMedication.warning <= 5" uib-tooltip="Warning: within 5 days of end date."></i> {{patientMedication.medication.name}} - {{patientMedication.durationDays + \' days\'}} - {{patientMedication.type | clearEnum}}</p></td><td><p><span class="label {{ patientMedication.onlyInChart ? \'label-danger\' : \'label-success\'}}">{{ patientMedication.onlyInChart ? \'Yes\' : \'No\'}}</span></p></td><td><p>{{patientMedication.startDate | amDateFormat: amDateFormat}}</p></td><td><p>{{patientMedication.endDate | amDateFormat: amDateFormat}}</p></td><td><p>{{patientMedication.employee | employeeName}} - <span class="small">{{patientMedication.createdDate | amDateFormat: amDateFormat}}</span></p></td><td><div ng-if="patientMedication.discontinueBy"><p><span class="label label-danger">Discontinue by:</span> {{ patientMedication.discontinueBy | employeeName }} - <span class="small">{{patientMedication.discontinueDate | amDateFormat: amDateFormat}}</span></p></div><div ng-if="!patientMedication.discontinueBy"><p><span ng-class="patientMedication.signed?\'label label-success\':\'label label-info\'">{{patientMedication.signed ? "Signed by" : "Ordered by"}}:</span> {{ patientMedication.signedBy | employeeName }}<span ng-if="patientMedication.signed"> - </span><span class="small">{{patientMedication.signedDate | amDateFormat: amDateFormat}}</span></p></div></td><td><div ng-if="patientMedication.faxedTo"><p>{{patientMedication.faxedTo.name}} - <span class="small">{{patientMedication.faxedTo.createdDate | amDateFormat: amDateFormat}}</span></p></div><div ng-if="!patientMedication.faxedTo"><p>-</p></div></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" title="Edit" class="dd-link orange" ng-click="vm.edit(patientMedication.id)"><i class="fa fa-pencil" aria-hidden="true"></i> Edit</a></li><li role="menuitem"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.print(patientMedication.id)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li><li role="menuitem"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.fax(patientMedication.id)"><i class="fa fa-fax" aria-hidden="true"></i> Fax to</a></li><li role="menuitem"><a href="" title="See Details" class="dd-link orange" ng-click="vm.view(patientMedication.id)"><i class="fa fa-list-alt" aria-hidden="true"></i>See Details</a></li><li role="menuitem"><a href="" title="See Details" class="dd-link red" ng-if="patientMedication.medicationStatus === \'SCHEDULED\'" ng-click="vm.discontinue(patientMedication.id)"><i class="fa fa-ban" aria-hidden="true"></i>Discontinue</a></li><li role="menuitem"><a href="" title="See Details" class="dd-link blue" ng-click="vm.changeOnlyChart(patientMedication.id)"><i class="fa fa-exchange" aria-hidden="true"></i> {{ patientMedication.onlyInChart ? \'Show in Mars\' : \'Only in Chart\' }}</a></li></ul></div><!-- /dropdown--></td></tr><!-- /item-order --></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.patientMedications.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true" style="color: #00a65a"></i> Add Medication</button> <button type="button" class="btn btn-default" ng-disabled="vm.getSelectedIds(vm.selected).length == 0" ng-click="vm.discontinue()"><i class="fa fa-ban" aria-hidden="true" style="color: #dd4b39"></i> Discontinue Multiple</button> <button type="button" class="btn btn-default" ui-sref="admission-medication({id: vm.chart.id})"><i class="fa fa-sign-in" aria-hidden="true" style="color: #00a7d0"></i> Admission Medications</button> <button type="button" class="btn btn-default" ng-disabled="vm.getSelectedIds(vm.selected).length == 0" ng-click="vm.fax()"><i class="fa fa-edit" aria-hidden="true" style="color: #f39c12"></i> Fax Multiple</button> <button type="button" class="btn btn-default" ng-click="vm.history()"><i class="fa fa-history" aria-hidden="true" style="color: #dd4b39"></i> History</button><div class="btn-group dropup" uib-dropdown><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div></div>');
$templateCache.put('app/entities/patient-medication/chart/list/old/patient-medication-chart2.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon yellow big"><i class="fa fa-medkit fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Medications Orders</h2></header><div class="item-body"><div class="patient-medications"><div class="table-responsive"><table class="table table-condensed table-hover"><thead><tr><th><input type="checkbox" ng-model="vm.selectAll" ng-change="vm.toggleAll(vm.selected, vm.selectAll)"></th><th><strong>Name:</strong></th><th><strong>Start Date:</strong></th><th><strong>End Date:</strong></th><th><strong>Enter:</strong></th><th><strong>Status:</strong></th><th><strong>Faxed To:</strong></th><th></th></tr></thead><tbody><tr class="item-order" ng-repeat="patientMedication in vm.patientMedications"><td><input type="checkbox" ng-model="vm.selected[patientMedication.id]" ng-click="vm.toggleOne(vm.selected, vm.selectAll)"></td><td class="order-name"><p><i class="fa fa-exclamation-triangle warning" style="font-size: 14px; cursor: help; vertical-align: middle; color: #ffbe4f" ng-if="patientMedication.medicationStatus === \'SCHEDULED\' && patientMedication.warning > 0 && patientMedication.warning <= 5" uib-tooltip="Warning: within 5 days of end date."></i> {{patientMedication.medication.name}} - {{patientMedication.durationDays + \' days\'}} - {{patientMedication.type | clearEnum}}</p></td><td><p>{{patientMedication.startDate | amDateFormat: amDateFormat}}</p></td><td><p>{{patientMedication.endDate | amDateFormat: amDateFormat}}</p></td><td><p>{{patientMedication.employee | employeeName}} - <span class="small">{{patientMedication.createdDate | amDateFormat: amDateFormat}}</span></p></td><td><div ng-if="patientMedication.discontinueBy"><p><span class="label label-danger">Discontinue by:</span> {{ patientMedication.discontinueBy | employeeName }} - <span class="small">{{patientMedication.discontinueDate | amDateFormat: amDateFormat}}</span></p></div><div ng-if="!patientMedication.discontinueBy"><p><span ng-class="patientMedication.signed?\'label label-success\':\'label label-info\'">{{patientMedication.signed ? "Signed by" : "Ordered by"}}:</span> {{ patientMedication.signedBy | employeeName }}<span ng-if="patientMedication.signed"> - </span><span class="small">{{patientMedication.signedDate | amDateFormat: amDateFormat}}</span></p></div></td><td><div ng-if="patientMedication.faxedTo"><p>{{patientMedication.faxedTo.name}} - <span class="small">{{patientMedication.faxedTo.createdDate | amDateFormat: amDateFormat}}</span></p></div><div ng-if="!patientMedication.faxedTo"><p>-</p></div></td><td><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.print(patientMedication.id)"><i class="fa fa-print" aria-hidden="true"></i> Print</a></li><li role="menuitem"><a href="" title="Fax to" class="dd-link blue" ng-click="vm.fax(patientMedication.id)"><i class="fa fa-fax" aria-hidden="true"></i> Fax to</a></li><li role="menuitem"><a href="" title="See Details" class="dd-link orange" ng-click="vm.view(patientMedication.id)"><i class="fa fa-list-alt" aria-hidden="true"></i>See Details</a></li><li role="menuitem"><a href="" title="See Details" class="dd-link red" ng-if="patientMedication.medicationStatus === \'SCHEDULED\'" ng-click="vm.discontinue(patientMedication.id)"><i class="fa fa-ban" aria-hidden="true"></i>Discontinue</a></li></ul></div><!-- /dropdown--></td></tr><!-- /item-order --></tbody></table></div></div></div><div class="item-footer"><div class="fleft"><button type="button" class="button-link" ng-click="vm.add()">Add Medication <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div><div class="fleft"><button type="button" class="button-link" ng-click="vm.discontinue()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0">Discontinue Multiple <i class="fa fa-ban" aria-hidden="true"></i></button></div><div class="fleft"><button type="button" class="button-link" ui-sref="admission-medication({id: vm.chart.id})">Admission Medications <i class="fa fa-sign-in" aria-hidden="true"></i></button></div><div class="fright"><button type="button" class="button-link" ng-click="vm.fax()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0">Fax Multiple <i class="fa fa-fax" aria-hidden="true"></i></button></div><div class="fright"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/patient-medication/mars/missed/tpl/employee-signature-tpl.html','<h2 class="step-header">Employee Signature</h2><hr><form name="vm.signatureEmployeeForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="field_employee_signature_pin">Please, enter your personal PIN:</label> <input type="password" maxlength="4" ng-disabled="vm.employeeSignature" ng-change="vm.employeeSignature = \'\'" ng-required="vm.employeeSignature === null" minlength="4" id="field_employee_signature_pin" name="employee_signature_pin" class="form-control" placeholder="PIN" pattern="\\d{4}" ng-model="vm.employeeSignaturePin" ng-required="vm.employeeSignature === null" ng-change="vm.employeeSignature = \'\'" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature name="physician_signature-{{vm.odsEmployeeSignatureNameId}}" id="field_physician_signature-{{vm.odsEmployeeSignatureNameId}}" ng-disabled="vm.employeeSignaturePin != null && vm.employeeSignaturePin.length > 0" ng-model="vm.employeeSignature" options="vm.signatureOpts"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="signature_agree"><input type="checkbox" name="field_signature_agree" id="signature_agree" ng-model="vm.employeeSignatureAgree"> I, {{vm.employee.firstName + \' \' + vm.employee.lastName}}, have reviewed, agree and understand the information contained here.</label></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-disabled="!vm.employeeSignatureAgree || !(vm.employeeSignature || vm.employeeSignaturePin)" ng-click="vm.signTakeByEmployee()"><i class="fa fa-check"></i> Sign</button></div></div></div></form><ng-include src="\'app/entities/patient-medication/wizard/steps.html\'" ng-if="!vm.isPatientSigned"></ng-include>');
$templateCache.put('app/entities/patient-medication/mars/missed/tpl/missed-reason-tpl.html','<form name="vm.signatureEmployeeForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><label for="field_reason">Select reasons of miss</label><ui-select ng-model="vm.missedReasons" name="reason" id="field_reason" reset-search-input="true" title="All Reasons" multiple="multiple" required><ui-select-match placeholder="Select reasons ...">{{$item.name}}</ui-select-match><ui-select-choices repeat="reason in vm.reasons"><div ng-bind-html="reason.name  | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></form>');
$templateCache.put('app/entities/patient-medication/mars/missed/tpl/patient-signature-tpl.html','<h2 class="step-header">Patient Signature</h2><hr><form name="vm.signaturePatientForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature ng-model="vm.patientSignature" options="vm.signatureOpts" ng-required="true" name="signature-{{vm.odsPatientSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_patientSignatureAgree"><input type="checkbox" name="patientSignatureAgree" id="field_patientSignatureAgree" required ng-model="vm.patientSignatureAgree"> I, {{vm.chart.fullName}}, verify that I have taken this medication and will report any side effects to the appropriate staff.</label></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-disabled="!vm.patientSignatureAgree || !vm.patientSignature" ng-click="vm.signTakeByPatient()"><i class="fa fa-check"></i> Sign</button></div></div></form><button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-if="!vm.isEmployeeSigned"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication/mars/sign/tpl/employee-signature-tpl.html','<h2 class="step-header">Employee Signature</h2><hr><form name="vm.signatureEmployeeForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label for="field_employee_signature_pin">Please, enter your personal PIN:</label> <input type="password" maxlength="4" ng-disabled="vm.employeeSignature" ng-change="vm.employeeSignature = \'\'" ng-required="vm.employeeSignature === null" minlength="4" id="field_employee_signature_pin" name="employee_signature_pin" class="form-control" placeholder="PIN" pattern="\\d{4}" ng-model="vm.employeeSignaturePin" ng-required="vm.employeeSignature === null" ng-change="vm.employeeSignature = \'\'" placeholder="PIN"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature name="physician_signature-{{vm.odsEmployeeSignatureNameId}}" id="field_physician_signature-{{vm.odsEmployeeSignatureNameId}}" ng-disabled="vm.employeeSignaturePin != null && vm.employeeSignaturePin.length > 0" ng-model="vm.employeeSignature" options="vm.signatureOpts"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="signature_agree"><input type="checkbox" name="field_signature_agree" id="signature_agree" ng-model="vm.employeeSignatureAgree"> I, {{vm.employee.firstName + \' \' + vm.employee.lastName}}, have reviewed, agree and understand the information contained here.</label></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-disabled="!vm.employeeSignatureAgree || !(vm.employeeSignature || vm.employeeSignaturePin)" ng-click="vm.signTakeByEmployee()"><i class="fa fa-check"></i> Sign</button></div></div></div></form><ng-include src="\'app/entities/patient-medication/wizard/steps.html\'" ng-if="\n            !vm.isPatientSigned &&\n            !((vm.employeeSignature && vm.employeeSignature.length > 0) ||\n            vm.employeeSignatureAgree ||\n            (vm.employeeSignaturePin && vm.employeeSignaturePin.length > 0))"></ng-include>');
$templateCache.put('app/entities/patient-medication/mars/sign/tpl/patient-signature-tpl.html','<h2 class="step-header">Patient Signature</h2><hr><form name="vm.signaturePatientForm" role="form"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label>Sign Here:</label><ods-signature ng-model="vm.patientSignature" options="vm.signatureOpts" ng-required="true" name="signature-{{vm.odsPatientSignatureNameId}}"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_patientSignatureAgree"><input type="checkbox" name="patientSignatureAgree" id="field_patientSignatureAgree" required ng-model="vm.patientSignatureAgree"> I, {{vm.chart.fullName}}, verify that I have taken this medication and will report any side effects to the appropriate staff.</label></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-30"><div class="form-group form-group-sm centered drawer-sign"><button type="submit" class="btn btn-success btn-lg btn-block" ng-disabled="!vm.patientSignatureAgree || !vm.patientSignature" ng-click="vm.signTakeByPatient()"><i class="fa fa-check"></i> Sign</button></div></div></form><button type="submit" class="btn btn-warning move-btn next-btn" wz-next ng-if="!vm.isEmployeeSigned && !((vm.patientSignature && vm.patientSignature.length > 0) || vm.patientSignatureAgree)"><svg id="i-chevron-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M12 30 L24 16 12 2"/></svg></button>');
$templateCache.put('app/entities/patient-medication/mars/sign/tpl/signatures-tpl.html','<div class="well well-sm signs-array"><div class="sign-item mb-15" ng-if="vm.take.patientSignatureId"><figure><img ng-src-sign="{{vm.take.patientSignatureId}}" id="signatureId" alt="Signature" width="200" class="img-responsive"><figcaption>Patient: {{vm.chart | patientName}},<br>Date: {{vm.take.patientSignature.createdDate | date: inputDateTimeFormatA}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.take.observedSignatureId"><figure><img ng-src-sign="{{vm.take.observedSignatureId}}" id="observedSignatureId" alt="Observed Signature" width="300" class="img-responsive"><figcaption>Employee: {{vm.take.observedBy | employeeName}},<br>Date: {{vm.take.observedSignature.createdDate | date: inputDateTimeFormatA}}</figcaption></figure></div><div class="sign-item mb-15" ng-if="vm.take.missedSignatureId"><figure><img ng-src-sign="{{vm.take.missedSignatureId}}" id="missedSignatureId" alt="Missed Signature" width="300" class="img-responsive"><figcaption>Employee: {{vm.take.missedBy | employeeName}},<br>Date: {{vm.take.missedSignature.createdDate | date: inputDateTimeFormatA}}</figcaption></figure></div></div>');
$templateCache.put('app/entities/patient-medication/mars/noting/list/noting-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.close()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">{{vm.entityClassHumanized}}</h4></div><div class="modal-body"><section class="content"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="box box-customized"><div class="header-options mb-30"><div class="search-material"><div class="search-input"><input type="text" class="form-control input-lg" placeholder="Search..." id="charts-search" ng-model="vm.searchQuery"> <button type="button" class="btn btn-default btn-lg" tabindex="0" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i></button> <button type="button" class="btn btn-default btn-lg" tabindex="0" ng-click="vm.clear()"><i class="fa fa-trash" aria-hidden="true"></i></button></div></div></div><div class="box-body"><table class="table table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.reload()"><ul></ul></ul></div></div></div></div></section></div><div class="modal-footer"><button class="btn btn-warning" ng-click="vm.fax()" ng-disabled="vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-fax" aria-hidden="true"></i> Fax</button> <button class="btn btn-success" ng-click="vm.openConfirmationModal()" ng-disabled="!vm.itHasCredentials || vm.getSelectedIds(vm.selected).length == 0"><i class="fa fa-edit" aria-hidden="true"></i> Note</button></div>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/tpl/basic-info-form-tpl.html','<h2 class="step-header">Basic Information</h2><hr><form action="" class="edit-info" class="form" name="vm.form.basicInfo"><div class="row mb-30"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.firstName)"><label for="first-name">First Name:</label> <input type="text" class="form-control" id="first-name" name="firstName" ng-model="vm.chart.firstName" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.firstName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.firstName.$invalid && vm.form.basicInfo.firstName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.firstName.$error.required">This field is required</span></div></div><div class="col-xs-6 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.middleName?\'\':\'has-warning\'"><label for="mid-name">Middle Name:</label> <input type="text" class="form-control" id="mid-name" name="middleName" ng-model="vm.chart.middleName"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.middleName"></span> <span class="help-block help-warning" ng-show="!vm.chart.middleName">This field is suggested</span></div></div><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.lastName)"><label for="second-name">Last Name:</label> <input type="text" class="form-control" id="second-name" name="lastName" ng-model="vm.chart.lastName" required> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.lastName.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.lastName.$invalid && vm.form.basicInfo.lastName.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.lastName.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.social)"><label for="ssn-number">SSN:</label> <input type="text" class="form-control" id="ssn-number" name="social" required ui-mask="999-99-9999" ng-model="vm.chart.social"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.social.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.social.$invalid && vm.form.basicInfo.social.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.social.$error.required">This field is required</span></div></div><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.dateBirth)"><label for="dob-date">Day of Birth:</label><!--<input type="text" class="form-control" value="{{vm.chart.dateBirth | date:\'MM/dd/yyyy\'}}" id="dob-date">--><div class="input-group input-group-sm"><input id="dob-date" type="text" class="form-control" name="dateBirth" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.chart.dateBirth" is-open="vm.datePickerOpenStatus.dateBirth" datepicker-options="birthDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateBirth\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.dateBirth.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.dateBirth.$invalid && vm.form.basicInfo.dateBirth.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$error.required">This field is required</span> <span class="help-block" ng-show="vm.form.basicInfo.dateBirth.$invalid && !vm.form.basicInfo.dateBirth.$error.required">This field is invalid</span></div></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.gender)"><label for="gender-type">Gender:</label> <select class="form-control" id="gender-type" name="gender" required ng-model="vm.chart.sex" ng-options="item as item for item in vm.gender track by item"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.gender.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.gender.$invalid && vm.form.basicInfo.gender.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.gender.$error.required">This field is required</span></div></div></div><!-- /row --><div class="row"><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.race)"><label for="patient-race">Race:</label> <select class="form-control" id="patient-race" name="race" required ng-model="vm.chart.typeRace" ng-options="item as item.name for item in vm.race track by item.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.race.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.race.$invalid && vm.form.basicInfo.race.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.race.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.ethnicity)"><label for="patient-ethnicity">Ethnicity:</label> <select class="form-control" name="ethnicity" required ng-model="vm.chart.typeEthnicity" id="patient-ethnicity" ng-disabled="vm.chart.typeEthnicity && vm.chart.id" ng-options="item as item.name for item in vm.ethnicity track by item.name"><option selected="selected"></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.ethnicity.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.ethnicity.$invalid && vm.form.basicInfo.ethnicity.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.ethnicity.$error.required">This field is required</span></div></div></div><div class="row"><div class="col-xs-6 col-sm-8 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.driverLicense?\'\':\'has-warning\'"><label for="first-name">Driver License:</label> <input type="text" class="form-control" id="field_driver_license" name="driver_license" ng-model="vm.chart.driverLicense"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.driverLicense"></span> <span class="help-block help-warning" ng-show="!vm.chart.driverLicense">This field is suggested</span></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-9 col-sm-9 col-md-8 col-lg-8"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientAddress)"><label for="patient-address-1">Address:</label> <input type="text" class="form-control" id="patient-address-1" name="patientAddress" required ng-model="vm.chart.address" value="{{vm.chart.address}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientAddress.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientAddress.$invalid && vm.form.basicInfo.patientAddress.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientAddress.$error.required">This field is required</span></div></div><div class="col-xs-3 col-sm-3 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.addressTwo?\'\':\'has-warning\'"><label for="patient-address-2">Address Two:</label> <input type="text" class="form-control" id="patient-address-2" placeholder="Street Two" ng-model="vm.chart.addressTwo"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.addressTwo"></span> <span class="help-block help-warning" ng-show="!vm.chart.addressTwo">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientCity)"><label for="patient-city">City:</label> <input type="text" class="form-control" id="patient-city" name="patientCity" placeholder="City" required ng-model="vm.chart.city" value="{{vm.chart.city}}"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientCity.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientCity.$invalid && vm.form.basicInfo.patientCity.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientCity.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.state)"><label for="field_state">State:</label> <select class="form-control" ng-model="vm.chart.countryState" ng-options="item as item.state for item in vm.states track by item.id" required id="field_state" name="state"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.state.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.state.$invalid && vm.form.basicInfo.state.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.state.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.patientZipCode)"><label for="patient-zip-code">Zip Code:</label> <input type="text" class="form-control" id="patient-zip-code" name="patientZipCode" required value="{{vm.chart.zip}}" ui-mask="99999" ng-model="vm.chart.zip"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.patientZipCode.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.patientZipCode.$invalid && vm.form.basicInfo.patientZipCode.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.patientZipCode.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.cellPhone)"><label for="patient-phone">Cell Phone:</label> <input type="text" class="form-control" id="patient-phone" name="cellPhone" required ui-mask="(999) 999-9999" ng-model="vm.chart.phone"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.cellPhone.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.cellPhone.$invalid && vm.form.basicInfo.cellPhone.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.cellPhone.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.email)"><label for="patient-email">Email:</label> <input type="email" class="form-control" id="patient-email" placeholder="Email" name="email" required ng-model="vm.chart.email"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.email.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.email.$invalid && vm.form.basicInfo.email.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.email.$error.required">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.chart.employer?\'\':\'has-warning\'"><label for="patient-employer-name">Employer:</label> <input type="text" class="form-control" id="patient-employer-name" ng-model="vm.chart.employer" value="{{vm.chart.employer}}"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.chart.employer"></span> <span class="help-block help-warning" ng-show="!vm.chart.employer">This field is suggested</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.setValidationClass(vm.form.basicInfo.paymentMethod)"><label for="patient-payment-method">Payment Method:</label> <select class="form-control" id="patient-payment-method" name="paymentMethod" ng-model="vm.chart.typePaymentMethods" ng-options="item as item.name for item in vm.paymentMethod track by item.name" ng-change="vm.disableInsuranceSteps()" required></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.basicInfo.paymentMethod.$error.required"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="!vm.form.basicInfo.paymentMethod.$invalid && vm.form.basicInfo.paymentMethod.$dirty"></span> <span class="help-block" ng-show="vm.form.basicInfo.paymentMethod.$error.required">This field is required</span></div></div></div><!-- /row --></div></div><!-- /row --></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/tpl/filter-tpl.html','<h2 class="step-header">Search patient:</h2><div class="chart-filters"><form name="searchFilters"><fieldset><legend>Search Filters:</legend><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group"><div class="row"><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyFirstName" placeholder="First Name" ng-model="vm.filter.firstName "></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyMiddleName" placeholder="Middle Name" ng-model="vm.filter.middleName"></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyLastName" placeholder="Last Name" ng-model="vm.filter.lastName "></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keyPrefName" placeholder="Preferred Name" ng-model="vm.filter.preferredName"></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><input type="text" class="form-control" id="keySN" placeholder="Social Number" ng-model="vm.filter.social"></div><div class="col-xs-12 col-sm-6 col-md-4 col-lg-4 form-group form-group-sm"><div class="input-group input-group-sm"><input id="field_dob" type="text" class="form-control" name="dob" placeholder="DOB" uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.filter.dob" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="fa fa-calendar" aria-hidden="true"></i></button></span></div></div></div></div><div class="row"><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-lg-offset-6"><button class="btn btn-warning btn-block" tabindex="1" ng-click="vm.search()"><i class="fa fa-search" aria-hidden="true"></i> Search</button></div><div class="col-xs-6 col-sm-6 col-md-3 col-lg-3"><button class="btn btn-default btn-block" tabindex="2" ng-click="vm.clearFilter()"><i class="fa fa-trash" aria-hidden="true"></i> Clear</button></div></div></fieldset><fieldset ng-if="vm.showChartList"><legend>Results:</legend><!--<p style="color: #ff2940" ng-if="vm.countFilterStr != \'\'"><strong>{{vm.countFilterStr}}</strong></p>--><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 box-wrapper mb-30"><button type="button" class="previous" ng-click="vm.getChartsPage()" ng-show="vm.page != 1"><svg id="i-arrow-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M10 6 L2 16 10 26 M2 16 L30 16"/></svg></button><div class="box box-widget widget-user new-patient" ng-click="vm.filterNextStep()"><div class="hover-icon"><svg id="i-plus" viewBox="0 0 32 32" width="50" height="50" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M16 2 L16 30 M2 16 L30 16"/></svg></div><div class="widget-user-image"><img src="content/images/avatar.png" alt=""></div><div class="widget-user-header"><h3 class="widget-user-username">Create New</h3><h3 class="widget-user-username">Patient</h3></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6" ng-show="vm.charts.length == 0"><div id="currentChartEmpty" class="charts-empty"><div class="empty-text"><div class="empty-search"><div class="text-center"><span class="icon"><i class="fa fa-users" aria-hidden="true"></i></span></div><p><span>Unfortunately,</span><br>there are no patients matching<br>this criteria...</p></div></div></div></div><div class="box box-widget widget-user" title="See Patient Details" ng-click="vm.filterNextStep(item)" style="cursor: pointer" ng-repeat="item in vm.charts"><div class="widget-user-image"><img class="img-circle" id="imgPicture" alt="User profile picture" ng-src-auth="{{item}}"></div><div class="widget-user-header bg-blue"><h3 class="widget-user-username">{{item.firstName}} {{item.lastName}}</h3><h5 class="widget-user-desc"><strong>Mr No:</strong> {{item.mrNo}}</h5></div><div class="box-footer"><div class="insurance-type"><h4 class="mt-0 mb-0"><strong>Payment:</strong></h4><p class="mb-0">{{item.typePaymentMethods ? item.typePaymentMethods.name : \'-\'}}</p></div><div class="patient-bed"><h4 class="mt-0 mb-0"><strong>Bed:</strong></h4><p class="mb-0">{{item.bed?item.bed.name:\'No Bed\'}}</p></div></div></div><button type="button" class="next" ng-click="vm.getChartsPage(0)" ng-show="vm.activateLeftArrow()"><svg id="i-arrow-right" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M22 6 L30 16 22 26 M30 16 L2 16"/></svg></button></div></fieldset></form></div>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/tpl/insurance-primary-form-tpl.html','<h2 class="step-header">Insurance Information</h2><hr><form action="" name="vm.form.primaryInsurance" class="form mb-15"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.insuranceCarrier?(vm.form.primaryInsurance.insurance_carrier.$dirty || vm.form.primaryInsurance.insurance_carrier.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_carrier">Insurance Carrier:</label><ui-select ng-model="vm.primaryInsurance.insuranceCarrier" name="insurance_carrier" id="field_insurance_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{ $select.selected.id? $select.selected.name: $select.selected.name + \'(new)\' }}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0">{{carrier.id? carrier.name: carrier.name + \'(new)\' }}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.primaryInsurance.insurance_carrier.$error.required"></span> <span class="help-block" ng-show="vm.form.primaryInsurance.insurance_carrier.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.policyNumber?(vm.form.primaryInsurance.insurance_policyNumber.$valid || vm.form.primaryInsurance.insurance_policyNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_policyNumber">Policy Number:</label> <input type="text" class="form-control" name="insurance_policyNumber" id="field_insurance_policyNumber" required ng-model="vm.primaryInsurance.policyNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.policyNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.policyNumber && vm.form.primaryInsurance.insurance_policyNumber.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.policyNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.preCertPhone?(vm.form.primaryInsurance.insurance_preCertPhone?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_preCertPhone">Pre-Cert Phone:</label> <input type="text" class="form-control" name="insurance_preCertPhone" id="field_insurance_preCertPhone" ng-model="vm.primaryInsurance.preCertPhone" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.preCertPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.preCertPhone && vm.form.primaryInsurance.insurance_preCertPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.preCertPhone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.groupNumber?(vm.form.primaryInsurance.insurance_groupNumber?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_insurance_groupNumber">Group Number:</label> <input type="text" class="form-control" name="insurance_groupNumber" id="field_insurance_groupNumber" ng-model="vm.primaryInsurance.groupNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.groupNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.groupNumber && vm.form.primaryInsurance.insurance_groupNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.groupNumber">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.insuranceType?(vm.form.primaryInsurance.insurance_type?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_insuranceType">Insurance Type:</label> <select class="form-control" id="field_insurance_insuranceType" name="insurance_type" ng-model="vm.primaryInsurance.insuranceType" ng-options="insuranceType as insuranceType.name for insuranceType in vm.insuranceTypes track by insuranceType.id"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.insuranceType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.insuranceType && vm.form.primaryInsurance.insurance_type.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.insuranceType">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.rxBin?(vm.form.primaryInsurance.insurance_rxBin?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_rxbin">RxBin:</label> <input type="text" class="form-control" name="insurance_rxBin" id="field_insurance_rxBin" ng-model="vm.primaryInsurance.rxBin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.rxBin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.rxBin && vm.form.primaryInsurance.insurance_rxBin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.rxBin">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.pcn?(vm.form.primaryInsurance.insurance_pcn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_pcn">RxPCN:</label> <input type="text" class="form-control" name="insurance_pcn" id="field_insurance_pcn" ng-model="vm.primaryInsurance.pcn"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.pcn"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.pcn && vm.form.primaryInsurance.insurance_pcn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.pcn">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.memberId?(vm.form.primaryInsurance.insurance_memberId?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_memberId">Member:</label> <input type="text" class="form-control" name="insurance_memberId" id="field_insurance_memberId" ng-model="vm.primaryInsurance.memberId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.memberId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vvm.primaryInsurance.memberId && vm.form.primaryInsurance.insurance_memberId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.memberId">This field is suggested</span></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.firstName?(vm.form.primaryInsurance.insurance_firstName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_firstName">Subscriber First Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_firstName" id="field_insurance_firstName" required ng-model="vm.primaryInsurance.firstName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.firstName = vm.chart.firstName"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.firstName && vm.form.primaryInsurance.insurance_firstName.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.firstName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.lastName?(vm.form.primaryInsurance.insurance_lastName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_lastName">Subscriber Last Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_lastName" id="field_insurance_lastName" required ng-model="vm.primaryInsurance.lastName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.lastName = vm.chart.lastName"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.lastName && vm.form.primaryInsurance.insurance_lastName.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.lastName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.dob?(vm.form.primaryInsurance.insurance_dob?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Subscriber DOB:</label><div class="input-group input-group-sm"><input id="field_insurance_dob" type="text" class="form-control" name="insurance_dob" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.primaryInsurance.dob" is-open="vm.datePickerOpenStatus.insuranceDob"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'insuranceDob\')"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.dob = vm.chart.dateBirth"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button></div><span class="help-block" ng-show="!vm.primaryInsurance.dob">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.socialSecurity?(vm.form.primaryInsurance.insurance_ssn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_ssn">Subscriber SSN:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_ssn" id="field_insurance_ssn" ng-model="vm.primaryInsurance.socialSecurity" ui-mask="999-99-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.socialSecurity = vm.chart.social"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.socialSecurity"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.socialSecurity && vm.form.primaryInsurance.insurance_ssn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.socialSecurity">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.insuranceRelation?(vm.form.primaryInsurance.insurance_insuranceRelation?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_insuranceRelation">Relationship:</label> <select class="form-control" id="field_insurance_insuranceRelation" name="insurance_insuranceRelation" required ng-model="vm.primaryInsurance.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insuranceRelations track by insuranceRelation.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.insuranceRelation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.insuranceRelation && vm.form.primaryInsurance.insurance_insuranceRelation.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.insuranceRelation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.gender?(vm.form.primaryInsurance.gender?\'has-success\':\'\'):\'has-error\'"><label for="gender">Subscriber Gender:</label><div class="input-group input-group-sm"><select class="form-control" id="gender" name="gender" required ng-model="vm.primaryInsurance.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.gender = vm.chart.sex"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.primaryInsurance.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.primaryInsurance.gender && vm.form.primaryInsurance.gender.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.gender">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.phone?(vm.form.primaryInsurance.insurance_phone?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.primaryInsurance.phone" ui-mask="(999) 999-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.phone = vm.chart.phone"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.phone && vm.form.primaryInsurance.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.phone">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.address?(vm.form.primaryInsurance.insurance_address?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.primaryInsurance.address"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.address = vm.chart.address"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.address && vm.form.primaryInsurance.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.address">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.address2?(vm.form.primaryInsurance.insurance_address2?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.primaryInsurance.address2"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.address2 = vm.chart.addressTwo"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.address2 && vm.form.primaryInsurance.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.primaryInsurance.address2">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.city?(vm.form.primaryInsurance.insurance_city?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.primaryInsurance.city"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.city = vm.chart.city"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.city && vm.form.primaryInsurance.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.city">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.primaryInsurance.countryState?(vm.form.primaryInsurance.insurance_state?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label><div class="input-group input-group-sm"><select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.primaryInsurance.countryState" ng-options="item as item.state for item in vm.states track by item.id"><option value="">{{vm.primaryInsurance.countryState.state}}</option></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.primaryInsurance.countryState = vm.chart.countryState"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.countryState && vm.form.primaryInsurance.insurance_states.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.countryState">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.primaryInsurance.zipCode?(vm.form.primaryInsurance.insurance_zipCode?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.primaryInsurance.zipCode" ui-mask="99999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="true" ng-click="vm.primaryInsurance.zipCode = vm.chart.zip"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.primaryInsurance.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.primaryInsurance.zipCode && vm.form.primaryInsurance.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.primaryInsurance.zipCode">This field is required</span></div></div></div></div></div></div><button type="button" class="btn btn-success" ng-click="vm.addSecondaryInsurance()" ng-if="vm.secondaryInsurance == null"><i class="fa fa-save" aria-hidden="true"></i> Add Secondary</button> <button type="button" class="btn btn-danger" ng-click="vm.clearPrimaryInsurance()"><i class="fa fa-save" aria-hidden="true"></i> Clear</button></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/tpl/insurance-secondary-form-tpl.html','<h2 class="step-header">Insurance Information</h2><hr><form action="" name="vm.form.secondaryInsurance" class="form mb-15"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.insuranceCarrier?(vm.form.secondaryInsurance.insurance_carrier.$dirty || vm.form.secondaryInsurance.insurance_carrier.$valid?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_carrier">Insurance Carrier:</label><ui-select ng-model="vm.secondaryInsurance.insuranceCarrier" name="insurance_carrier" id="field_insurance_carrier" reset-search-input="false" ng-required="true" title="Insurance Carrier"><ui-select-match placeholder="Enter an insurance carrier...">{{ $select.selected.id? $select.selected.name: $select.selected.name + \'(new)\'}}</ui-select-match><ui-select-choices repeat="carrier in vm.carriers | filter: $select.search" refresh="vm.getInsuranceCarrier($select.search)" refresh-delay="0">{{carrier.id? carrier.name: carrier.name + \'(new)\' }}</ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="vm.form.secondaryInsurance.insurance_carrier.$error.required"></span> <span class="help-block" ng-show="vm.form.secondaryInsurance.insurance_carrier.$error.required">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.policyNumber?(vm.form.secondaryInsurance.insurance_policyNumber.$valid || vm.form.secondaryInsurance.insurance_policyNumber.$dirty?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_policyNumber">Policy Number:</label> <input type="text" class="form-control" name="insurance_policyNumber" id="field_insurance_policyNumber" required ng-model="vm.secondaryInsurance.policyNumber"> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.policyNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.policyNumber && vm.form.secondaryInsurance.insurance_policyNumber.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.policyNumber">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.preCertPhone?(vm.form.secondaryInsurance.insurance_preCertPhone?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_preCertPhone">Pre-Cert Phone:</label> <input type="text" class="form-control" name="insurance_preCertPhone" id="field_insurance_preCertPhone" ng-model="vm.secondaryInsurance.preCertPhone" ui-mask="999-999-9999"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.preCertPhone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.preCertPhone && vm.form.secondaryInsurance.insurance_preCertPhone.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.preCertPhone">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.groupNumber?(vm.form.secondaryInsurance.insurance_groupNumber?\'has-success\':\'\'):\'has-warning\'"><label class="control-label" for="field_insurance_groupNumber">Group Number:</label> <input type="text" class="form-control" name="insurance_groupNumber" id="field_insurance_groupNumber" ng-model="vm.secondaryInsurance.groupNumber"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.groupNumber"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.groupNumber && vm.form.secondaryInsurance.insurance_groupNumber.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.groupNumber">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.insuranceType?(vm.form.secondaryInsurance.insurance_type?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_insuranceType">Insurance Type:</label> <select class="form-control" id="field_insurance_insuranceType" name="insurance_type" ng-model="vm.secondaryInsurance.insuranceType" ng-options="insuranceType as insuranceType.name for insuranceType in vm.insuranceTypes track by insuranceType.id"></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.insuranceType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.insuranceType && vm.form.secondaryInsurance.insurance_type.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.insuranceType">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.rxBin?(vm.form.secondaryInsurance.insurance_rxBin?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_rxbin">RxBin:</label> <input type="text" class="form-control" name="insurance_rxBin" id="field_insurance_rxBin" ng-model="vm.secondaryInsurance.rxBin"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.rxBin"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.rxBin && vm.form.secondaryInsurance.insurance_rxBin.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.rxBin">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.pcn?(vm.form.secondaryInsurance.insurance_pcn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_pcn">RxPCN:</label> <input type="text" class="form-control" name="insurance_pcn" id="field_insurance_pcn" ng-model="vm.secondaryInsurance.pcn"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.pcn"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.pcn && vm.form.secondaryInsurance.insurance_pcn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.pcn">This field is suggested</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.memberId?(vm.form.secondaryInsurance.insurance_memberId?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_memberId">Member:</label> <input type="text" class="form-control" name="insurance_memberId" id="field_insurance_memberId" ng-model="vm.secondaryInsurance.memberId"> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.memberId"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vvm.secondaryInsurance.memberId && vm.form.secondaryInsurance.insurance_memberId.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.memberId">This field is suggested</span></div></div></div><!-- /row --></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 border-left"><div class="row"><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.firstName?(vm.form.secondaryInsurance.insurance_firstName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_firstName">Subscriber First Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_firstName" id="field_insurance_firstName" required ng-model="vm.secondaryInsurance.firstName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.firstName = vm.chart.firstName"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.firstName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.firstName && vm.form.secondaryInsurance.insurance_firstName.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.firstName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.lastName?(vm.form.secondaryInsurance.insurance_lastName?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_lastName">Subscriber Last Name:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_lastName" id="field_insurance_lastName" required ng-model="vm.secondaryInsurance.lastName"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.lastName = vm.chart.lastName"><i class="glyphicon glyphicon-copy"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.lastName"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.lastName && vm.form.secondaryInsurance.insurance_lastName.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.lastName">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.dob?(vm.form.secondaryInsurance.insurance_dob?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_dob">Subscriber DOB:</label><div class="input-group input-group-sm"><input id="field_insurance_dob" type="text" class="form-control" name="insurance_dob" placeholder="mm/dd/yyyy" required uib-datepicker-popup="{{inputDateFormat}}" ng-model="vm.secondaryInsurance.dob" is-open="vm.datePickerOpenStatus.insuranceDob"><div class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'insuranceDob\')"><i class="glyphicon glyphicon-calendar"></i></button> <button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.dob = vm.chart.dateBirth"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button></div><span class="help-block" ng-show="!vm.secondaryInsurance.dob">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.socialSecurity?(vm.form.secondaryInsurance.insurance_ssn?\'has-success\':\'\'):\'has-warning\'"><label for="field_insurance_ssn">Subscriber SSN:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_ssn" id="field_insurance_ssn" ng-model="vm.secondaryInsurance.socialSecurity" ui-mask="999-99-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.socialSecurity = vm.chart.social"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.socialSecurity"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.socialSecurity && vm.form.secondaryInsurance.insurance_ssn.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.socialSecurity">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.insuranceRelation?(vm.form.secondaryInsurance.insurance_insuranceRelation?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_insuranceRelation">Relationship:</label> <select class="form-control" id="field_insurance_insuranceRelation" name="insurance_insuranceRelation" required ng-model="vm.secondaryInsurance.insuranceRelation" ng-options="insuranceRelation as insuranceRelation.name for insuranceRelation in vm.insuranceRelations track by insuranceRelation.name"></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.insuranceRelation"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.insuranceRelation && vm.form.secondaryInsurance.insurance_insuranceRelation.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.insuranceRelation">This field is required</span></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.gender?(vm.form.secondaryInsurance.gender?\'has-success\':\'\'):\'has-error\'"><label for="gender">Subscriber Gender:</label><div class="input-group input-group-sm"><select class="form-control" id="gender" name="gender" required ng-model="vm.secondaryInsurance.gender" ng-options="item as item for item in vm.gender track by item"></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.gender = vm.chart.sex"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" ng-show="!vm.secondaryInsurance.gender"></span> <span class="glyphicon glyphicon-ok form-control-feedback" ng-show="vm.secondaryInsurance.gender && vm.form.secondaryInsurance.gender.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.gender">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.phone?(vm.form.secondaryInsurance.insurance_phone?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_phone">Subscriber Phone:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_phone" id="field_insurance_phone" required ng-model="vm.secondaryInsurance.phone" ui-mask="(999) 999-9999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.phone = vm.chart.phone"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.phone"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.phone && vm.form.secondaryInsurance.insurance_phone.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.phone">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.address?(vm.form.secondaryInsurance.insurance_address?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_address">Subscriber Address:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address" id="field_insurance_address" required ng-model="vm.secondaryInsurance.address"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.address = vm.chart.address"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.address"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.address && vm.form.secondaryInsurance.insurance_address.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.address">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.address2?(vm.form.secondaryInsurance.insurance_address2?\'has-success\':\'\'):\'has-warning\'"><label class="control-label">Subscriber Address 2:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_address2" id="field_insurance_address2" ng-model="vm.secondaryInsurance.address2"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.address2 = vm.chart.addressTwo"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.address2"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.address2 && vm.form.secondaryInsurance.insurance_address2.$dirty"></span> <span class="help-block help-warning" ng-show="!vm.secondaryInsurance.address2">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.city?(vm.form.secondaryInsurance.insurance_city?\'has-success\':\'\'):\'has-error\'"><label for="field_insurance_city">Subscriber City:</label><div class="input-group input-group-sm"><input type="text" class="form-control" id="field_insurance_city" name="insurance_city" required ng-model="vm.secondaryInsurance.city"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.city = vm.chart.city"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.city"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.city && vm.form.secondaryInsurance.insurance_city.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.city">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.secondaryInsurance.countryState?(vm.form.secondaryInsurance.insurance_state?\'has-success\':\'\'):\'has-error\'"><label class="control-label">Subscriber State:</label><div class="input-group input-group-sm"><select class="form-control" id="field_insurance_state" name="insurance_state" required ng-model="vm.secondaryInsurance.countryState" ng-options="item as item.state for item in vm.states track by item.id"><option value="">{{vm.secondaryInsurance.countryState.state}}</option></select> <span class="input-group-btn"><button type="button" class="btn btn-default" title="Import" ng-click="vm.secondaryInsurance.countryState = vm.chart.countryState"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.countryState"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.countryState && vm.form.secondaryInsurance.insurance_states.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.countryState">This field is required</span></div></div></div><div class="col-xs-12 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-if="vm.currentState !== \'insurance-edit\'" ng-class="vm.secondaryInsurance.zipCode?(vm.form.secondaryInsurance.insurance_zipCode?\'has-success\':\'\'):\'has-error\'"><label class="control-label" for="field_insurance_zipCode">Subscriber Zip Code:</label><div class="input-group input-group-sm"><input type="text" class="form-control" name="insurance_zipCode" id="field_insurance_zipCode" required ng-model="vm.secondaryInsurance.zipCode" ui-mask="99999"> <span class="input-group-btn"><button type="button" class="btn btn-default" title="true" ng-click="vm.secondaryInsurance.zipCode = vm.chart.zip"><i class="glyphicon glyphicon-copy" aria-hidden="true"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.secondaryInsurance.zipCode"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.secondaryInsurance.zipCode && vm.form.secondaryInsurance.insurance_zipCode.$dirty"></span> <span class="help-block" ng-show="!vm.secondaryInsurance.zipCode">This field is required</span></div></div></div></div></div></div><button type="button" class="btn btn-success" ng-click="vm.removeSecondaryInsurance()"><i class="fa fa-save" aria-hidden="true"></i> Remove</button></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/tpl/lab-order-form-tpl.html','<h2 class="step-header">Add Order</h2><hr><form name="editForm"><div class="row"><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.facilityLab ? \'has-success\':\'has-error\'"><label for="order-type">Laboratory:</label> <select name="laboratory" id="field_facilityLab" class="form-control" required ng-model="vm.patientOrder.facilityLab" ng-change="vm.changeLaboratory()" ng-options="facilityLab as facilityLab.name for facilityLab in vm.facilityLabs track by facilityLab.name"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.facilityLab"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.facilityLab "></span> <span class="help-block" ng-show="!vm.patientOrder.facilityLab">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.orderType ? \'has-success\':\'has-error\'"><label for="order-type">Order Type:</label> <select name="orderType" id="order-type" class="form-control" required ng-model="vm.patientOrder.orderType" ng-change="vm.changeOrderType()"><option value=""></option><option value="ONE_TIME">ONE TIME</option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.orderType"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.orderType "></span> <span class="help-block" ng-show="!vm.patientOrder.orderType">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.via ? \'has-success\':\'has-error\'"><label for="obtainedList">Obtained:</label> <select name="obtained" id="obtainedList" class="form-control" required ng-model="vm.patientOrder.via" ng-options="item as item.name for item in vm.via track by item.name"><option value=""></option></select> {{vm.credential}} <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.via"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.via"></span> <span class="help-block" ng-show="!vm.patientOrder.via">This field is required</span></div></div><div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.signedBy ? \'has-success\':\'has-error\'"><label for="doctors-list">Physician:</label> <select name="doctorList" id="doctors-list" class="form-control" required ng-model="vm.patientOrder.signedBy" ng-disabled="vm.itHasCredentials" ng-options="item as item.firstName + \' \' + item.lastName for item in vm.employees track by item.firstName + item.lastName"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrder.signedBy"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrder.signedBy && editForm.doctorList.$dirty"></span> <span class="help-block" ng-show="!vm.patientOrder.signedBy">This field is required</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrder.instruction ? \'has-success\': \'has-warning\'"><label class="control-label" for="field_note">Instructions:</label> <textarea rows="5" class="form-control" name="note" id="field_note" data-resize="disabled" ng-model="vm.patientOrder.instruction"></textarea> <span class="help-block help-warning" ng-show="!vm.patientOrder.instruction">This field is suggested.</span></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div></form><form name="editForm1"><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.labCompendiums.length > 0 ?\'has-success\':\'has-error\'"><label>Test Code:</label><ui-select name="testCode" id="testCode" required ng-disabled="vm.patientOrder.facilityLab == null" multiple="multiple" ng-model="vm.labCompendiums" ng-model-options="{ debounce: 300 }" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="Test Codes...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.testCodes" refresh="vm.getLabCompendium($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.labCompendiums.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.labCompendiums.length > 0"></span> <span class="help-block" ng-show="!vm.labCompendiums.length > 0">This field is required</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.icd10s.length > 0 ? \'has-success\':\'has-error\'"><label for="field_diagnoses">ICD10:</label><ui-select id="field_diagnoses" name="diagnoses" multiple="multiple" required ng-model="vm.patientOrderTest.icd10s" ng-model-options="{ debounce: 300 }" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.icd10s.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.icd10s.length > 0"></span> <span class="help-block" ng-show="!vm.patientOrderTest.icd10s.length > 0">This field is required</span></div><div class="text-right" style="margin-top: -20px"><search-icd10 chart="vm.chart.id" ng-model="vm.patientOrderTest.icd10s"></search-icd10></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm"><label style="display: block">&nbsp;</label> <button type="button" class="btn btn-success" ng-click="vm.selectRelational(vm.patientOrderTest)"><i class="fa fa-save" aria-hidden="true"></i> Edit Rationale List</button></div></div></div><div class="row"><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.orderFrequency ? \'has-success\':\'has-warning\'"><label for="obtainedList">Frequency:</label> <select name="freqName" class="form-control input-sm" ng-model="vm.patientOrderTest.orderFrequency" ng-options="item as item.description for item in vm.orderFrequencies track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.orderFrequency"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.orderFrequency"></span> <span class="help-block help-warning" ng-show="!vm.patientOrderTest.orderFrequency">This field is suggested</span></div></div><div class="col-xs-4 col-sm-4 col-md-4 col-lg-4"><div class="form-group form-group-sm has-feedback" ng-class="vm.patientOrderTest.staringDate?\'has-success\':\'has-warning\'"><label for="field_staring_date">{{vm.patientOrder.orderType == \'ONE_TIME\' ? \'Collected Date:\' : \'Start Date:\'}}</label><div class="input-group input-group-sm"><input id="field_staring_date" type="text" class="form-control" name="staringDate" placeholder="mm/dd/yyyy" ng-model="vm.patientOrderTest.staringDate" uib-datepicker-popup="{{inputDateFormat}}" is-open="vm.datePickerOpenStatus.staringDate" datepicker-options="vm.staringDateOptions" ng-change="vm.validateEndDate()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'staringDate\')"><i class="fa fa-calendar"></i></button> </span><span class="glyphicon glyphicon-warning-sign form-control-feedback" aria-hidden="true" ng-show="!vm.patientOrderTest.staringDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="vm.patientOrderTest.staringDate"></span> <span class="help-block help-warning" ng-show="!vm.patientOrderTest.staringDate">This field is suggested</span></div></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr><h4>Rationales</h4><ul class="list-unstyled"><li ng-repeat="($index, rational) in vm.patientOrderTest.relationals" style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 5px 30px"><span style="padding-right: 10px;">{{rational.name}}</span> <a ng-click="vm.removeRelational(vm.patientOrderTest.relationals, $index)" style="color: red;"><i class="fa fa-times-circle"></i></a></li></ul><hr></div></div><div class="row"><div class="col-xs-12 col-sm-3 col-md-3 col-lg-3 form-group"><button type="button" class="btn btn-primary" ng-click="vm.generateTest()" ng-disabled="editForm.$error.required || editForm1.$error.required"><i class="fa fa-plus-circle" aria-hidden="true"></i> Generate Tests</button></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12"><hr></div></div></form><form name="vm.form.editForm2"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" ng-if="vm.patientOrder.patientOrderTests.length > 0"><table class="table table-striped table-test-codes"><thead><tr><th><strong>Test Code:</strong></th><th><strong>Frequency:</strong></th><th><strong>{{vm.patientOrder.orderType == \'ONE_TIME\' ? \'Collected Date:\' : \'Start Date:\'}}</strong></th><th ng-if="vm.patientOrder.orderType != \'ONE_TIME\'"><strong>End Date:</strong></th><th><strong>ICD10:</strong></th><th><strong>Rationale:</strong></th></tr></thead><tbody><tr ng-repeat-start="item in vm.patientOrder.patientOrderTests"><td class="description"><span>{{item.labCompendium.code + " "+ item.labCompendium.description}}</span></td><td><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.orderFrequency ? \'has-success\':\'has-error\'"><select name="freqName" class="form-control input-sm" required ng-model="item.orderFrequency" ng-options="item as item.description for item in vm.orderFrequencies track by item.id"><option value=""></option></select> <span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.orderFrequency"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.orderFrequency"></span> <span class="help-block" ng-show="!item.orderFrequency">Required</span></div></td><td style="width: 160px"><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.staringDate?\'has-success\':\'has-error\'"><div class="input-group input-group-sm"><input id="field_staringDate + {{$index}}" type="text" class="form-control" type="text" class="form-control" required name="staringDate" placeholder="mm/dd/yyyy" ng-model="item.staringDate" is-open="isOpenStart[item.code]" uib-datepicker-popup="{{inputDateFormat}}" datepicker-options="vm.staringDateOptions"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="isOpenStart[item.code] = !isOpenStart[item.code]"><i class="glyphicon glyphicon-calendar"></i></button> </span><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.staringDate"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.staringDate"></span> <span class="help-block" ng-show="!item.staringDate">Required</span></div></div></td><td class="icd-codes"><div class="form-group form-group-sm has-feedback mb-0" ng-class="item.icd10s.length > 0 ? \'has-success\':\'has-error\'"><ui-select name="icd10" multiple="multiple" required ng-model="item.icd10s" reset-search-input="true" close-on-select="false"><ui-select-match placeholder="ICD10 code...">{{$item.code}}</ui-select-match><ui-select-choices repeat="item in vm.diagnoses" refresh="vm.getDiagnoses($select.search)" refresh-delay="0"><div ng-bind-html="item.code + \' \' + item.description | highlight: $select.search"></div></ui-select-choices></ui-select><span class="glyphicon glyphicon-ban-circle form-control-feedback" aria-hidden="true" ng-show="!item.icd10s.length > 0"></span> <span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true" ng-show="item.icd10s.length > 0"></span> <span class="help-block" ng-show="!item.icd10s.length > 0">This field is required</span></div></td><td class="relational"><button type="button" class="btn btn-success" ng-click="vm.selectRelational(item)"><i class="fa fa-save" aria-hidden="true"></i> Edit Rationale List</button></td></tr><tr ng-repeat-end><td colspan="5"><div><h4>Rationales</h4><ul class="list-unstyled"><li ng-repeat="($index, rational) in item.relationals" style="display: flex; justify-content: space-between; align-items: center; padding: 5px 0 5px 30px"><span style="padding-right: 10px;">{{rational.name}}</span> <a ng-click="vm.removeRelational(item.relationals, $index)" style="color: red;"><i class="fa fa-times-circle"></i></a></li></ul></div></td></tr></tbody></table></div></form>');
$templateCache.put('app/entities/patient-order/lab-requisition/create-order/tpl/patient-order-signature-tpl.html','<div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15" ng-if="!vm.signature"><div class="form-group form-group-sm centered drawer-sign"><label for="orderPin">Please enter your personal PIN:</label> <input type="password" class="form-control" id="orderPin" name="orderPin" maxlength="4" pattern="\\d{4}" placeholder="PIN" ng-model="vm.pin" ng-change="vm.signature = \'\'" ng-required="vm.signature === null"></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign" ng-if="vm.pin === null || vm.pin === \'\' || vm.signature"><label>Or Sign Here:</label><ods-signature ng-change="vm.clear()" options="vm.signatureOpts" name="patient_order_signature" ng-model="vm.signature"></ods-signature></div></div><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mb-15"><div class="form-group form-group-sm centered drawer-sign"><label class="control-label" for="field_SignatureAgree"><input type="checkbox" name="SignatureAgree" id="field_SignatureAgree" ng-model="vm.agree" ng-disabled="!vm.signature && !vm.pin">{{vm.patientOrder.discontinueByPhysician ? \'I, \' + vm.patientOrder.discontinueByPhysician.firstName + \' \' + vm.patientOrder.discontinueByPhysician.lastName +\', have reviewed, agree the discontinue of the order # \' + vm.patientOrder.id : \'I, \' + vm.patientOrder.signedBy.firstName + \' \' + vm.patientOrder.signedBy.lastName +\', have reviewed, agree and understand the information contained here in the lab order.\' }}</label></div></div></div><button type="button" class="btn btn-warning move-btn previous-btn" ng-click="vm.activateSign = false" wz-previous><svg id="i-chevron-left" viewBox="0 0 32 32" width="32" height="32" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="5"><path d="M20 30 L8 16 20 2"/></svg></button>');
$templateCache.put('app/entities/patient-result/chart/e-labs/old/e-labs.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="item-header"><div class="fancy-icon red big"><i class="fa fa-flask fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">eLabs</h2></div><div class="item-body"><!--<div class="item-body" ng-repeat="item in vm.result">--><div class="table-responsive" style="width: 100%"><table class="table table-condensed"><thead><tr><th><strong>Barcode</strong></th><th><strong>Collected</strong></th><th><strong>Completed</strong></th><th><strong>Status</strong></th><th><strong>Alert</strong></th><th><strong>Signed</strong></th><th></th></tr></thead><tbody><tr ng-repeat="item in vm.result"><td>{{item.accessionNumber}}</td><td>{{item.collectionDate | date: inputDateFormat}}</td><td>{{item.lastModifiedDate | date: inputDateFormat}}</td><td>{{item.status}}</td><td><small class="label" ng-class="{\'label-success\': !item.abnormalRange, \'label-danger\': item.abnormalRange}">{{item.abnormalRange ? \'Abnormal\' : \'Normal\'}}</small></td><td><small class="label" ng-class="{\'label-success\': item.signed, \'label-danger\': !item.signed}">{{item.signed ? \'Yes\' : \'No\'}}</small></td><td style="width: 45px"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem" ng-if="item.accessionNumber"><a class="dd-link green" title="View Requisition" ng-click="vm.requisition(item)"><i class="fa fa-file-text-o" aria-hidden="true"></i> View Requisition</a></li><li role="menuitem"><a class="dd-link red" title="View PDF" ng-click="vm.printRangePDFs(item.id)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> View PDF</a></li><li role="menuitem"><a class="dd-link blue" title="See Details" ng-click="vm.details(item.id)"><i class="fa fa-list-alt" aria-hidden="true"></i> See Details</a></li></ul></div></td></tr></tbody></table></div><!--\n    <div class="{{item.abnormalRange ? \'lab-requisition highlighted\' : \'lab-requisition\'}} ">\n        <div class="section">\n            <table class="table">\n                <tbody>\n                <tr>\n                    <td><strong>Barcode:</strong></td>\n                    <td>{{item.accessionNumber}}</td>\n                </tr>\n                <tr>\n                    <td><strong>Status:</strong></td>\n                    <td>{{item.status}}</td>\n                </tr>\n                <tr>\n                    <td><strong>Alert:</strong></td>\n                    <td><small class="label" ng-class="{\'label-success\': !item.abnormalRange, \'label-danger\': item.abnormalRange}">{{item.abnormalRange ? \'Abnormal\' : \'Normal\'}}</small></td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class="section">\n            <table class="table">\n                <tbody>\n                <tr>\n                    <td><strong>Collected:</strong></td>\n                    <td>{{item.collectionDate | date: \'MM/dd/yyyy\'}}</td>\n                </tr>\n                <tr>\n                    <td><strong>Completed:</strong></td>\n                    <td>{{item.lastModifiedDate | date: \'MM/dd/yyyy\'}}</td>\n                </tr>\n                <tr>\n                    <td><strong>Signed:</strong></td>\n                    <td><small class="label" ng-class="{\'label-success\': item.signed, \'label-danger\': !item.signed}">{{item.signed ? \'Yes\' : \'No\'}}</small></td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n        <div class="actions">\n            <a ng-click="vm.requisition(item)" class="view-req" title="View Requisition"><i\n                class="fa fa-file-text-o"\n                aria-hidden="true"></i></a>\n            <a ng-click="vm.printRangePDFs(item.id)" class="view-pdf" title="View PDF"><i class="fa fa-file-pdf-o"\n                                                                                          aria-hidden="true"></i></a>\n            <a ng-click="vm.details(item.id)" class="see-details" title="See Details"><i class="fa fa-list-alt"\n                                                                                        aria-hidden="true"></i></a>\n        </div>\n    </div>\n    --></div><div class="item-footer"><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div>');
$templateCache.put('app/entities/patient-result/chart/e-labs/new/e-labs.html','<div class="grid-flex"><div class="grid-item full" style="padding-top: 15px;"><h4 class="header-line mt-0 mb-10 pb-10" style="border-bottom: 1px solid #d2d6de"><div class="input-group input-group-sm search"><input type="text" class="form-control" placeholder="Search..." ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-default"><i class="fa fa-search" aria-hidden="true"></i></button></span></div></h4><div class="tab-empty-view well well-sm" ng-if="vm.result.length === 0"><div class="icon red"><i class="fa fa-info-circle" aria-hidden="true"></i></div><div class="text"><p class="mb-0">There are no</p><p class="mb-0"><strong>eLabs</strong></p></div></div><div ng-if="vm.result.length != 0"><div class="table-responsive mb-15"><table class="table table-condensed table-hover"><thead><tr><th><button type="button" class="btn btn-default btn-xs" style="margin: 0 auto 0 0;" uib-tooltip="Expand/Collapse All" ng-click="vm.toggleAllRow()"><i class="fa" aria-hidden="true" ng-class="{\'fa-plus-circle\': !vm.toggleAllRows, \'fa-minus-circle\': vm.toggleAllRows}"></i></button></th><th><strong>Barcode</strong></th><th><strong>Collected</strong></th><th><strong>Completed</strong></th><th><strong>Status</strong></th><th><strong>Alert</strong></th><th><strong>Signed</strong></th><th></th></tr></thead><tbody><tr ng-repeat-start="item in vm.result"><td style="width: 25px; text-align: center"><a href="" uib-tooltip="See Test codes" style="color: #222d32;" ng-click="vm.toggleRow(item)"><i class="fa" ng-class="{\'fa-plus-circle\': !item.active,\'fa-minus-circle\': item.active}"></i></a></td><td>{{item.accessionNumber}}</td><td>{{item.collectionDate | date: inputDateFormat}}</td><td>{{item.lastModifiedDate | date: inputDateFormat}}</td><td>{{item.status}}</td><td><small class="label" ng-class="{\'label-success\': !item.abnormalRange, \'label-danger\': item.abnormalRange}">{{item.abnormalRange ? \'Abnormal\' : \'Normal\'}}</small></td><td><small class="label" ng-class="{\'label-success\': item.signed, \'label-danger\': !item.signed}">{{item.signed ? \'Yes\' : \'No\'}}</small></td><td style="width: 45px"><div class="btn-group dd-buttons" uib-dropdown dropdown-append-to-body><button type="button" class="btn btn-default btn-sm dd-toggle" uib-dropdown-toggle><i class="fa fa-ellipsis-v" aria-hidden="true"></i></button><ul class="dropdown-menu dropdown-menu-right buttons-menu" uib-dropdown-menu><li role="menuitem"><a class="dd-link green" title="View Requisition" ng-click="vm.requisition(item)"><i class="fa fa-file-text-o" aria-hidden="true"></i> View Requisition</a></li><li role="menuitem"><a class="dd-link red" title="View PDF" ng-click="vm.printRangePDFs(item.id)"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> View PDF</a></li><li role="menuitem"><a class="dd-link blue" title="See Details" ng-click="vm.details(item.id)"><i class="fa fa-list-alt" aria-hidden="true"></i> See details</a></li></ul></div></td></tr><tr ng-repeat-end ng-show="item.active && item.accessionNumber"><td></td><td colspan="7"><strong>Test codes: </strong>{{item.codes}}</td></tr></tbody></table></div><!-- ./table-responsive --><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" ng-if="vm.result.length > 0" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div><div class="buttons-toolbar btn-group"><button type="button" class="btn btn-default shadow" disabled="disabled"><span class="dummy">&nbsp;</span></button><udt-menu-options-bottom chart="vm.chart" access="vm.access"></udt-menu-options-bottom></div></div></div>');
$templateCache.put('app/entities/urgent-issues/chart/new/detail/urgent-issues-detail.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myUrgentIssueLabel">Blue Alert</h4></div><div class="modal-body"><p><strong>Description:</strong></p><p>{{vm.urgentIssues.description}}</p><div id="urgent-issues-dtable"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Close</button></div>');
$templateCache.put('app/entities/urgent-issues/chart/new/history/urgent-issues-history-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i> Blue Alerts</h4></div><div class="modal-body"><div id="urgent-issues-dtable" ng-if="!vm.showDetails"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="" ng-if="vm.showDetails"><table class="table employee-subtable"><thead><tr class="warning"><th colspan="4" class="text-center"><strong>Employee</strong></th></tr><tr><th class="first-col">#</th><th><strong>Full Name</strong></th><th><strong>Phone</strong></th><th><strong>Email</strong></th></tr></thead><tbody><tr class="odd"><td valign="top" colspan="4" ng-if="!vm.employees.length">No data available in table</td></tr><tr ng-repeat="item in vm.employees"><td class="first-col">{{$index + 1}}</td><td>{{item.firstName + \' \' + item.lastName}}</td><td>{{item.mobile | phone}}</td><td>{{item.email}}</td></tr></tbody></table></div></div><div class="modal-footer" ng-if="vm.showDetails"><button type="submit" class="btn btn-warning" ng-click="vm.showDetails = !vm.showDetails"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button></div>');
$templateCache.put('app/entities/urgent-issues/chart/new/list/urgent-issues.html','<div class="info no-padding"><h5 class="header-label mt-0"><strong>Blue Alerts</strong> <a href="" class="btn-icon" uib-tooltip="Add Blue Alert" ng-if="vm.chart.status !== \'CLOSED\'" ng-click="vm.add()"><i class="fa fa-plus-circle" aria-hidden="true"></i></a></h5><p class="mb-0" ng-repeat="urgentIssue in vm.urgentIssues"><span><input type="checkbox" style="margin: 0; vertical-align: middle" ng-checked="urgentIssue.checked" ng-disabled="urgentIssue.checked" ng-change="vm.check(urgentIssue)" ng-model="urgentIssue.ngmodel"> </span><span class="click-layer" ng-class="{\'checked\': urgentIssue.checked && urgentIssue.employeeId != vm.employee.id}" ng-click="vm.details(urgentIssue.id)"><strong style="text-transform: capitalize">{{urgentIssue.description}}</strong> </span><a href="" class="btn-icon" uib-tooltip="Edit Blue Alert" ng-if="vm.chart.status !== \'CLOSED\' && urgentIssue.employeeId == vm.employee.id && urgentIssue.urgentIssueEmployeeCount == 1" ng-click="vm.edit(urgentIssue.id)"><i class="fa fa-pencil" aria-hidden="true"></i></a> <a href="" class="btn-icon" uib-tooltip="Delete Blue Alert" ng-if="vm.chart.status !== \'CLOSED\' && urgentIssue.employeeId == vm.employee.id && urgentIssue.urgentIssueEmployeeCount == 1" ng-click="vm.del(urgentIssue.id)"><i class="fa fa-minus-circle danger" aria-hidden="true"></i></a></p></div>');
$templateCache.put('app/entities/urgent-issues/chart/new/update/urgent-issues-dialog.html','<form name="vm.form.urgentIssue" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myUrgentIssueLabel">Create Alert</h4></div><div class="modal-body"><div class="form-group issue-description"><label for="field_description">Description:</label> <textarea class="form-control" id="field_description" name="description" rows="10" data-resize="disabled" ng-model="vm.urgentIssues.description" required></textarea></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="vm.form.urgentIssue.$error.required || vm.form.urgentIssue.$invalid || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel</button></div></form>');
$templateCache.put('app/entities/urgent-issues/chart/old/list/urgent-issues-dialog.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myVitalsLabel"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i> Blue Alerts</h4></div><div class="modal-body"><div ng-if="vm.saveUrgentIssue"><div class="form-group issue-description"><label for="field_description">Description:</label> <textarea class="form-control" id="field_description" name="description" rows="10" data-resize="disabled" ng-model="vm.urgentIssues.description" required></textarea></div></div><div id="urgent-issues-dtable" ng-if="!vm.saveUrgentIssue && !vm.showDetails"><table class="table" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="" ng-if="vm.showDetails && !vm.saveUrgentIssue"><table class="table employee-subtable"><thead><tr class="warning"><th colspan="4" class="text-center"><strong>Employee</strong></th></tr><tr><th class="first-col">#</th><th><strong>Full Name</strong></th><th><strong>Phone</strong></th><th><strong>Email</strong></th></tr></thead><tbody><tr class="odd"><td valign="top" colspan="4" ng-if="!vm.employees.length">No data available in table</td></tr><tr ng-repeat="item in vm.employees"><td class="first-col">{{$index + 1}}</td><td>{{item.firstName + \' \' + item.lastName}}</td><td>{{item.mobile | phone}}</td><td>{{item.email}}</td></tr></tbody></table></div></div><div class="modal-footer" ng-if="vm.showDetails && !vm.saveUrgentIssue"><button type="submit" class="btn btn-warning" ng-click="vm.showDetails = !vm.showDetails"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button></div><div class="modal-footer" ng-if="vm.saveUrgentIssue && !vm.showDetails"><button type="submit" class="btn btn-success" ng-click="vm.save()" ng-disabled="form.$error.required || vm.isSaving"><i class="fa fa-save" aria-hidden="true"></i> Save</button> <button type="button" class="btn btn-warning" ng-click="vm.clearDescription()"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button></div><div class="modal-footer" ng-if="!vm.saveUrgentIssue && !vm.showDetails"><button type="button" class="btn btn-warning" id="addUrgentIssues" ng-if="!vm.saveUrgentIssue && !vm.showDetails" ng-click="vm.saveUrgentIssue = !vm.saveUrgentIssue">Add Alert <i class="fa fa-plus-circle" aria-hidden="true"></i></button></div></form>');
$templateCache.put('app/entities/urgent-issues/chart/old/unknown/urgent-issue-unknown.html','<form name="form" role="form"><div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><div class="modal-icon"><i class="fa fa-bell fa-inverse" aria-hidden="true"></i></div><h4 class="modal-title" id="myVitalsLabel">Blue Alerts</h4></div><div class="modal-body"><div id="urgent-issues-dtable"><table class="table table-hover"><thead><tr><th>#</th><th><strong>Description</strong></th><th></th></tr></thead><tbody><tr ng-repeat="urgentIssue in vm.urgentIssues"><td class="first-col">{{$index + 1}}</td><td style="text-align: justify">{{urgentIssue.description}}</td><td><span><input type="checkbox" style="margin: 0; vertical-align: middle" ng-checked="urgentIssue.checked" ng-disabled="urgentIssue.checked" ng-change="vm.check(urgentIssue)" ng-model="urgentIssue.ngmodel"></span></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="vm.clear()">Cancel <i class="fa fa-ban" aria-hidden="true"></i></button></div></form>');
$templateCache.put('app/entities/verifytx/chart/history/new/verifytx-history-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title" id="myAcuityLabel">Verification of Benefit History</h4></div><div class="modal-body"><div class="input-group input-group-sm mb-15"><input type="text" class="form-control" placeholder="Search" ng-model="vm.searchQuery" ng-change="vm.search()" ng-model-options="{ debounce: 500 }"> <span class="input-group-btn"><button type="button" class="btn btn-primary"><i class="fa fa-search" aria-hidden="true"></i></button></span></div><div class="table-responsive"><table class="table table-condensed"><thead><tr><th><strong>Coverage</strong></th><th><strong>Insurance Company</strong></th><th><strong>Reference</strong></th><th><strong>Request Date</strong></th><th><strong>Failed</strong></th><th><strong>Message</strong></th></tr></thead><tbody><tr ng-repeat="verifytx in vm.verifytxHistories"><td>{{verifytx.coverage}}</td><td>{{verifytx.insuranceCompany}}</td><td>{{verifytx.reference}}</td><td>{{verifytx.createdDate | amDateFormat: amDateFormat}}</td><td><span class="label" ng-class="verifytx.failed ? \'label-danger\' : \'label-success\'">{{verifytx.failed ? \'Yes\' : \'No\'}}</span></td><td class="message" uib-tooltip="{{verifytx.failedMessage}}" tooltip-placement="left"><span style="width:120px;white-space:nowrap; text-overflow:ellipsis; overflow:hidden; display: inline-block">{{verifytx.failedMessage}}</span></td></tr></tbody></table></div><div class="text-center"><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"><ul></ul></ul></div></div>');
$templateCache.put('app/entities/verifytx/chart/history/old/verifytx-history-dialog.html','<div class="modal-header"><button type="button" class="dash-close-btn" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><h4 class="modal-title">Verification of Benefits History</h4></div><div class="modal-body"><div class="search-input"><input type="text" class="form-control" placeholder="Search..." id="searchQueryIncidentReportNoteTemplates" ng-model="vm.searchQuery" ng-change="vm.search()"> <button type="button" class="btn btn-default" tabindex="0" id="btnSearch" ng-click="vm.search(vm.searchQuery)"><i class="fa fa-search" aria-hidden="true"></i></button></div><div class="table-responsive"><table class="table table-condensed table-striped" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns" dt-instance="vm.dtInstance"></table></div><div class="row"><div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center"><div class="text-center mb-15"><jhi-item-count page="vm.page" total="vm.totalItems" items-per-page="vm.itemsPerPage"></jhi-item-count><ul uib-pagination class="dash-pagination pagination-sm" first-text="&#xf100;" previous-text="&#xf0a8;" next-text="&#xf0a9;" last-text="&#xf101;" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></ul></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()"><i class="fa fa-ban" aria-hidden="true"></i>&nbsp;Cancel</button></div>');
$templateCache.put('app/entities/verifytx/chart/list/new/verifytx.html','<h4 ng-if="vm.isApplicable === true && vm.verifytxVob !== null">Verification of Benefits</h4><div class="verification-of-benefit" ng-if="vm.isApplicable === true && vm.verifytxVob !== null"><div class="basic"><div><div class="inf"><span class="title text-uppercase"><strong>Coverage</strong></span><p class="mb-0"><span ng-class="vm.verifytxVob.coverage === \'Inactive\' ? \'label label-danger\' : \'label label-success\'">{{vm.verifytxVob.coverage !== null ? vm.verifytxVob.coverage : \'-\'}}</span></p></div><div class="inf"><span class="title text-uppercase"><strong>Coverage Date</strong></span><p class="mb-0">{{vm.verifytxVob.coverageStart !== null ? (vm.verifytxVob.coverageStart | date: inputDateFormat) : \'-\'}} - {{vm.verifytxVob.coverageEnd !== null ? (vm.verifytxVob.coverageEnd | date: inputDateFormat) : \'-\'}}</p></div><div class="inf"><span class="title text-uppercase"><strong>Insurance Type</strong></span><p class="mb-0">{{vm.verifytxVob.insuranceType !== null ? vm.verifytxVob.insuranceType : \'-\'}}</p></div><div class="inf"><span class="title text-uppercase"><strong>Insurance Company</strong></span><p class="mb-0">{{vm.verifytxVob.insuranceCompany !== null ? vm.verifytxVob.insuranceCompany : \'-\'}}</p></div><div class="inf"><span class="title text-uppercase"><strong>Plan Sponsor</strong></span><p class="mb-0">{{vm.verifytxVob.planSponsor !== null ? vm.verifytxVob.planSponsor : \'-\'}}</p></div><div class="inf"><span class="title text-uppercase"><strong>Group Number</strong></span><p class="mb-0">{{vm.verifytxVob.groupNumber !== null ? vm.verifytxVob.groupNumber : \'-\'}}</p></div></div><hr><div class="payer-note" ng-if="vm.verifytxVob.notes.length > 0"><span class="title text-uppercase"><strong>Payer Note</strong></span><p ng-repeat="note in vm.verifytxVob.notes">- {{note.note}}</p></div></div><div class="networks"><div class="well well-sm"><h5 class="text-center text-uppercase mt-0"><strong>In Network</strong></h5><div class="network-data"><span class="title text-uppercase"><strong>Co-Insurance {{vm.verifytxVob.inNetwork.coInsuranceLevel !== null ? \'(\' + vm.verifytxVob.inNetwork.coInsuranceLevel + \')\' : \'\'}}</strong></span><p class="mb-0" ng-if="vm.verifytxVob.inNetwork.coInsuranceValue !== null">Client: <strong>{{vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}}</strong></p><p class="mb-0" ng-if="vm.verifytxVob.inNetwork.coInsuranceValue !== null">Provider: <strong>{{100 - vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}}</strong></p><div class="progress-chart mt-15" ng-if="vm.verifytxVob.inNetwork.coInsuranceValue !== null"><uib-progress max="100" animate="true"><uib-bar value="100 - vm.verifytxVob.inNetwork.coInsuranceValue" type="success"><span>{{100 - vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}}</span></uib-bar><uib-bar value="vm.verifytxVob.inNetwork.coInsuranceValue" type="danger"><span>{{vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}}</span></uib-bar></uib-progress></div><div ng-if="vm.verifytxVob.inNetwork.coInsuranceValue === null"><p>Not Available</p></div></div><div class="network-data"><span class="title text-uppercase"><strong>Co-Payment</strong></span><p class="mb-0" ng-if="vm.verifytxVob.inNetwork.coPaymentAmount !== null && vm.verifytxVob.inNetwork.coPaymentTimePeriod !== null"><strong>{{vm.verifytxVob.inNetwork.coPaymentAmount | currency}}</strong> <span>{{vm.verifytxVob.inNetwork.coPaymentTimePeriod}}</span></p><p class="mb-0" ng-if="vm.verifytxVob.inNetwork.coPaymentAmount === null || vm.verifytxVob.inNetwork.coPaymentTimePeriod === null">Not Available</p></div><div class="network-data"><span class="title text-uppercase"><strong>Out Of Pocket {{vm.verifytxVob.inNetwork.outPocketLevel !== null ? \'(\' + vm.verifytxVob.inNetwork.outPocketLevel + \')\': \'\'}}</strong></span><div ng-if="vm.verifytxVob.inNetwork.outPocketCalendarYear !== null ||\n                            vm.verifytxVob.inNetwork.outPocketYearToDate !== null ||\n                            vm.verifytxVob.inNetwork.outPocketRemaining !== null"><p class="mb-0">{{vm.verifytxVob.inNetwork.outPocketTotalName}}: <strong>{{vm.verifytxVob.inNetwork.outPocketTotalName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.outPocketCalendarYear | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.inNetwork.outPocketAmountName}}: <strong>{{vm.verifytxVob.inNetwork.outPocketAmountName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.outPocketYearToDate | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.inNetwork.outPocketRemainingName}}: <strong>{{vm.verifytxVob.inNetwork.outPocketRemainingName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.outPocketRemaining | currency) : \'-\'}}</strong></p><div class="progress-chart mt-15"><uib-progress max="vm.verifytxVob.inNetwork.outPocketCalendarYear"><uib-bar value="vm.verifytxVob.inNetwork.outPocketYearToDate" type="success"><span>{{(vm.verifytxVob.inNetwork.outPocketYearToDate | currency)}}</span></uib-bar><uib-bar value="vm.verifytxVob.inNetwork.outPocketRemaining" type="danger"><span>{{(vm.verifytxVob.inNetwork.outPocketRemaining | currency)}}</span></uib-bar></uib-progress></div></div><div ng-if="vm.verifytxVob.inNetwork.outPocketCalendarYear === null &&\n                            vm.verifytxVob.inNetwork.outPocketYearToDate === null &&\n                            vm.verifytxVob.inNetwork.outPocketRemaining === null"><p class="mb-0"></p></div></div><div class="network-data"><span class="title text-uppercase"><strong>Deductibles {{vm.verifytxVob.inNetwork.deductibleLevel !== null ? \'(\' + vm.verifytxVob.inNetwork.deductibleLevel + \')\': \'\'}}</strong></span><div ng-if="vm.verifytxVob.inNetwork.deductibleCalendarYear !== null ||\n                            vm.verifytxVob.inNetwork.deductibleYearToDate !== null ||\n                            vm.verifytxVob.inNetwork.deductibleRemaining !== null"><p class="mb-0">{{vm.verifytxVob.inNetwork.deductibleTotalName}}: <strong>{{vm.verifytxVob.inNetwork.deductibleTotalName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.deductibleCalendarYear | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.inNetwork.deductibleAmountName}}: <strong>{{vm.verifytxVob.inNetwork.deductibleAmountName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.deductibleYearToDate | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.inNetwork.deductibleRemainingName}}: <strong>{{vm.verifytxVob.inNetwork.deductibleRemainingName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.deductibleRemaining | currency) : \'-\'}}</strong></p><div class="progress-chart mt-15"><uib-progress max="vm.verifytxVob.inNetwork.deductibleCalendarYear"><uib-bar value="vm.verifytxVob.inNetwork.deductibleYearToDate" type="success"><span>{{(vm.verifytxVob.inNetwork.deductibleYearToDate | currency)}}</span></uib-bar><uib-bar value="vm.verifytxVob.inNetwork.deductibleRemaining" type="danger"><span>{{(vm.verifytxVob.inNetwork.deductibleRemaining | currency)}}</span></uib-bar></uib-progress></div></div><div ng-if="vm.verifytxVob.inNetwork.deductibleCalendarYear === null &&\n                            vm.verifytxVob.inNetwork.deductibleYearToDate === null &&\n                            vm.verifytxVob.inNetwork.deductibleRemaining === null"><p class="mb-0">Not Avialable</p></div></div></div><div class="well well-sm"><h5 class="text-center text-uppercase mt-0"><strong>Out of Network</strong></h5><div class="network-data"><span class="title text-uppercase"><strong>Co-Insurance {{vm.verifytxVob.outNetwork.coInsuranceLevel !== null ? \'(\' + vm.verifytxVob.outNetwork.coInsuranceLevel + \')\' : \'\'}}</strong></span><p class="mb-0" ng-if="vm.verifytxVob.outNetwork.coInsuranceValue !== null">Client: <strong>{{vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}}</strong></p><p class="mb-0" ng-if="vm.verifytxVob.outNetwork.coInsuranceValue !== null">Provider: <strong>{{100 - vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}}</strong></p><div class="progress-chart mt-15" ng-if="vm.verifytxVob.outNetwork.coInsuranceValue !== null"><uib-progress max="100" animate="true"><uib-bar value="100 - vm.verifytxVob.outNetwork.coInsuranceValue" type="success"><span>{{100 - vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}}</span></uib-bar><uib-bar value="vm.verifytxVob.outNetwork.coInsuranceValue" type="danger"><span>{{vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}}</span></uib-bar></uib-progress></div><div ng-if="vm.verifytxVob.outNetwork.coInsuranceValue === null"><p class="mb-0">Not Available</p></div></div><div class="network-data"><span class="title text-uppercase"><strong>Co-Payment</strong></span><p class="mb-0" ng-if="vm.verifytxVob.outNetwork.coPaymentAmount !== null && vm.verifytxVob.outNetwork.coPaymentTimePeriod !== null"><strong>{{vm.verifytxVob.outNetwork.coPaymentAmount | currency}}</strong> <span>{{vm.verifytxVob.outNetwork.coPaymentTimePeriod}}</span></p><p class="mb-0" ng-if="vm.verifytxVob.outNetwork.coPaymentAmount === null || vm.verifytxVob.outNetwork.coPaymentTimePeriod === null">Not Available</p></div><div class="network-data"><span class="title text-uppercase"><strong>Out Of Pocket {{vm.verifytxVob.outNetwork.outPocketLevel !== null ? \'(\' + vm.verifytxVob.outNetwork.outPocketLevel + \')\': \'\'}}</strong></span><div ng-if="vm.verifytxVob.outNetwork.outPocketCalendarYear !== null ||\n                            vm.verifytxVob.outNetwork.outPocketYearToDate !== null ||\n                            vm.verifytxVob.outNetwork.outPocketRemaining !== null"><p class="mb-0">{{vm.verifytxVob.outNetwork.outPocketTotalName}}: <strong>{{vm.verifytxVob.outNetwork.outPocketTotalName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.outPocketCalendarYear | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.outNetwork.outPocketAmountName}}: <strong>{{vm.verifytxVob.outNetwork.outPocketAmountName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.outPocketYearToDate | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.outNetwork.outPocketRemainingName}}: <strong>{{vm.verifytxVob.outNetwork.outPocketRemainingName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.outPocketRemaining | currency) : \'-\'}}</strong></p><div class="progress-chart mt-15"><uib-progress max="vm.verifytxVob.outNetwork.outPocketCalendarYear"><uib-bar value="vm.verifytxVob.outNetwork.outPocketYearToDate" type="success"><span>{{(vm.verifytxVob.outNetwork.outPocketYearToDate | currency)}}</span></uib-bar><uib-bar value="vm.verifytxVob.outNetwork.outPocketRemaining" type="danger"><span>{{(vm.verifytxVob.outNetwork.outPocketRemaining | currency)}}</span></uib-bar></uib-progress></div></div><div ng-if="vm.verifytxVob.outNetwork.outPocketCalendarYear === null &&\n                            vm.verifytxVob.outNetwork.outPocketYearToDate === null &&\n                            vm.verifytxVob.outNetwork.outPocketRemaining === null"><p class="mb-0">Not Available</p></div></div><div class="network-data"><span class="title text-uppercase"><strong>Deductibles {{vm.verifytxVob.outNetwork.deductibleLevel !== null ? \'(\' + vm.verifytxVob.outNetwork.deductibleLevel + \')\': \'\'}}</strong></span><div ng-if="vm.verifytxVob.outNetwork.deductibleCalendarYear !== null ||\n                            vm.verifytxVob.outNetwork.deductibleYearToDate !== null ||\n                            vm.verifytxVob.outNetwork.deductibleRemaining !== null"><p class="mb-0">{{vm.verifytxVob.outNetwork.deductibleTotalName}}: <strong>{{vm.verifytxVob.outNetwork.deductibleTotalName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.deductibleCalendarYear | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.outNetwork.deductibleAmountName}}: <strong>{{vm.verifytxVob.outNetwork.deductibleAmountName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.deductibleYearToDate | currency) : \'-\'}}</strong></p><p class="mb-0">{{vm.verifytxVob.outNetwork.deductibleRemainingName}}: <strong>{{vm.verifytxVob.outNetwork.deductibleRemainingName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.deductibleRemaining | currency) : \'-\'}}</strong></p><div class="progress-chart mt-15"><uib-progress max="vm.verifytxVob.outNetwork.deductibleCalendarYear"><uib-bar value="vm.verifytxVob.outNetwork.deductibleYearToDate" type="success"><span>{{(vm.verifytxVob.outNetwork.deductibleYearToDate | currency)}}</span></uib-bar><uib-bar value="vm.verifytxVob.outNetwork.deductibleRemaining" type="danger"><span>{{(vm.verifytxVob.outNetwork.deductibleRemaining | currency)}}</span></uib-bar></uib-progress></div></div><div ng-if="vm.verifytxVob.outNetwork.deductibleCalendarYear === null &&\n                            vm.verifytxVob.outNetwork.deductibleYearToDate === null &&\n                            vm.verifytxVob.outNetwork.deductibleRemaining === null"><p class="mb-0">Not Available</p></div></div></div></div></div>');
$templateCache.put('app/entities/verifytx/chart/list/old/verifytx.html','<button type="button" class="dash-close-btn" ng-click="vm.toggleItem()"><svg id="i-close" viewBox="0 0 32 32" width="15" height="15" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path d="M2 30 L30 2 M30 30 L2 2"/></svg></button><header class="item-header"><div class="fancy-icon blue big"><i class="fa fa-check-square-o fa-inverse" aria-hidden="true"></i></div><h2 class="head-text">Verification of Benefits</h2><span style="margin-left: auto; align-self: center" ng-if="vm.verifytxVob !== null"><span style="font-weight: bold" ng-class="vm.verifytxVob.lastFailed === true ? \'label label-danger\' : \'\'">verified date {{vm.verifytxVob.date | date: inputDateTimeFormatA}}</span></span></header><div class="item-body"><div class="empty-content" ng-if="vm.isApplicable === true && vm.verifytxVob === null"><div class="notice-text well well-lg"><span>There is no</span> <span>Verification of Benefits</span></div></div><div class="empty-content" ng-if="vm.isApplicable === false"><div class="notice-text well well-lg"><span>No Applicable</span></div></div><div class="verification-benefits" ng-if="vm.isApplicable === true && vm.verifytxVob !== null"><div class="company-details mb-30"><header>Insurance Company Details</header><div class="details"><div class="detail"><h5>Coverage:</h5><p><span ng-class="vm.verifytxVob.coverage === \'Inactive\' ? \'label label-danger\' : \'label label-success\'">{{vm.verifytxVob.coverage !== null ? vm.verifytxVob.coverage : \'-\'}}</span></p></div><div class="detail"><h5>Coverage Date:</h5><p>{{vm.verifytxVob.coverageStart !== null ? (vm.verifytxVob.coverageStart | date: inputDateFormat) : \'-\'}} - {{vm.verifytxVob.coverageEnd !== null ? (vm.verifytxVob.coverageEnd | date: inputDateFormat) : \'-\'}}</p></div><div class="detail"><h5>Insurance Type:</h5><p>{{vm.verifytxVob.insuranceType !== null ? vm.verifytxVob.insuranceType : \'-\'}}</p></div><div class="detail"><h5>Insurance Company:</h5><p>{{vm.verifytxVob.insuranceCompany !== null ? vm.verifytxVob.insuranceCompany : \'-\'}}</p></div><div class="detail"><h5>Plan Sponsor:</h5><p>{{vm.verifytxVob.planSponsor !== null ? vm.verifytxVob.planSponsor : \'-\'}}</p></div><div class="detail"><h5>Group Number:</h5><p>{{vm.verifytxVob.groupNumber !== null ? vm.verifytxVob.groupNumber : \'-\'}}</p></div><div class="detail" ng-if="vm.verifytxVob.notes.length > 0"><h5>Payer Note:</h5><p ng-repeat="note in vm.verifytxVob.notes">- {{note.note}}</p></div></div></div><div class="network-details"><header>Out of Network</header><div class="section"><h5>Co-Insurance {{vm.verifytxVob.outNetwork.coInsuranceLevel !== null ? \'(\' + vm.verifytxVob.outNetwork.coInsuranceLevel + \')\' : \'\'}}</h5><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.coInsuranceValue !== null"><div class="graph-bars"><div class="bars mb-15"><div class="client" ng-style="{\'width\' : vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}"></div><div class="provider" ng-style="{\'width\' : 100 - vm.verifytxVob.outNetwork.coInsuranceValue + \'%\' }"></div></div><div class="legend"><span class="value">Client: <strong>{{vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}}</strong></span> <span class="value">Provider: <strong>{{100 - vm.verifytxVob.outNetwork.coInsuranceValue + \'%\'}}</strong></span></div></div></div><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.coInsuranceValue === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div><div class="section"><h5>Deductibles {{vm.verifytxVob.outNetwork.deductibleLevel !== null ? \'(\' + vm.verifytxVob.outNetwork.deductibleLevel + \')\': \'\'}}</h5><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.deductibleCalendarYear !== null ||\n                                                    vm.verifytxVob.outNetwork.deductibleYearToDate !== null ||\n                                                    vm.verifytxVob.outNetwork.deductibleRemaining !== null"><div class="graph-pie"><div class="graph"><nvd3 style="display: block" options="vm.chartOptsOutDeductibles" data="vm.chartDataOutDeductibles"></nvd3></div><div class="custom-legend"><ul class="list-unstyled legend-list"><li class="legend-item"><span class="text">{{vm.verifytxVob.outNetwork.deductibleTotalName}}: </span><span class="number">{{vm.verifytxVob.outNetwork.deductibleTotalName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.deductibleCalendarYear | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.outNetwork.deductibleAmountName}}: </span><span class="number">{{vm.verifytxVob.outNetwork.deductibleAmountName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.deductibleYearToDate | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.outNetwork.deductibleRemainingName}}: </span><span class="number">{{vm.verifytxVob.outNetwork.deductibleRemainingName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.deductibleRemaining | currency) : \'-\'}}</span></li></ul></div></div></div><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.deductibleCalendarYear === null &&\n                                                    vm.verifytxVob.outNetwork.deductibleYearToDate === null &&\n                                                    vm.verifytxVob.outNetwork.deductibleRemaining === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div><div class="section"><h5>Out of Pocket {{vm.verifytxVob.outNetwork.outPocketLevel !== null ? \'(\' + vm.verifytxVob.outNetwork.outPocketLevel + \')\': \'\'}}</h5><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.outPocketCalendarYear !== null ||\n                                                    vm.verifytxVob.outNetwork.outPocketYearToDate !== null ||\n                                                    vm.verifytxVob.outNetwork.outPocketRemaining !== null"><div class="graph-pie"><div class="graph"><nvd3 style="display: block" options="vm.chartOptsOutPocket" data="vm.chartDataOutPocket"></nvd3></div><div class="custom-legend"><ul class="list-unstyled legend-list"><li class="legend-item"><span class="text">{{vm.verifytxVob.outNetwork.outPocketTotalName}}: </span><span class="number">{{vm.verifytxVob.outNetwork.outPocketTotalName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.outPocketCalendarYear | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.outNetwork.outPocketAmountName}}: </span><span class="number">{{vm.verifytxVob.outNetwork.outPocketAmountName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.outPocketYearToDate | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.outNetwork.outPocketRemainingName}}: </span><span class="number">{{vm.verifytxVob.outNetwork.outPocketRemainingName !== \'Not Available\' ? (vm.verifytxVob.outNetwork.outPocketRemaining | currency) : \'-\'}}</span></li></ul></div></div></div><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.outPocketCalendarYear === null &&\n                                                    vm.verifytxVob.outNetwork.outPocketYearToDate === null &&\n                                                    vm.verifytxVob.outNetwork.outPocketRemaining === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div><div class="section"><h5>Co-Payment</h5><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.coPaymentAmount !== null && vm.verifytxVob.outNetwork.coPaymentTimePeriod !== null"><h4 class="text-center"><strong>{{vm.verifytxVob.outNetwork.coPaymentAmount | currency}}</strong> {{vm.verifytxVob.outNetwork.coPaymentTimePeriod}}</h4></div><div class="content-graph" ng-if="vm.verifytxVob.outNetwork.coPaymentAmount === null || vm.verifytxVob.outNetwork.coPaymentTimePeriod === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div></div><div class="network-details"><header>In Network</header><div class="section"><h5>Co-Insurance {{vm.verifytxVob.inNetwork.coInsuranceLevel !== null ? \'(\' + vm.verifytxVob.inNetwork.coInsuranceLevel + \')\' : \'\'}}</h5><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.coInsuranceValue !== null"><div class="graph-bars"><div class="bars mb-15"><div class="client" ng-style="{\'width\' : vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}"></div><div class="provider" ng-style="{\'width\' : 100 - vm.verifytxVob.inNetwork.coInsuranceValue + \'%\' }"></div></div><div class="legend"><span class="value">Client: <strong>{{vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}}</strong></span> <span class="value">Provider: <strong>{{100 - vm.verifytxVob.inNetwork.coInsuranceValue + \'%\'}}</strong></span></div></div></div><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.coInsuranceValue === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div><div class="section"><h5>Deductibles {{vm.verifytxVob.inNetwork.deductibleLevel !== null ? \'(\' + vm.verifytxVob.inNetwork.deductibleLevel + \')\': \'\'}}</h5><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.deductibleCalendarYear !== null ||\n                                                    vm.verifytxVob.inNetwork.deductibleYearToDate !== null ||\n                                                    vm.verifytxVob.inNetwork.deductibleRemaining !== null"><div class="graph-pie"><div class="graph"><nvd3 style="display: block" options="vm.chartOptsInDeductibles" data="vm.chartDataInDeductibles"></nvd3></div><div class="custom-legend"><ul class="list-unstyled legend-list"><li class="legend-item"><span class="text">{{vm.verifytxVob.inNetwork.deductibleTotalName}}: </span><span class="number">{{vm.verifytxVob.inNetwork.deductibleTotalName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.deductibleCalendarYear | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.inNetwork.deductibleAmountName}}: </span><span class="number">{{vm.verifytxVob.inNetwork.deductibleAmountName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.deductibleYearToDate | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.inNetwork.deductibleRemainingName}}: </span><span class="number">{{vm.verifytxVob.inNetwork.deductibleRemainingName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.deductibleRemaining | currency) : \'-\'}}</span></li></ul></div></div></div><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.deductibleCalendarYear === null &&\n                                                    vm.verifytxVob.inNetwork.deductibleYearToDate === null &&\n                                                    vm.verifytxVob.inNetwork.deductibleRemaining === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div><div class="section"><h5>Out of Pocket {{vm.verifytxVob.inNetwork.outPocketLevel !== null ? \'(\' + vm.verifytxVob.inNetwork.outPocketLevel + \')\': \'\'}}</h5><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.outPocketCalendarYear !== null ||\n                                                    vm.verifytxVob.inNetwork.outPocketYearToDate !== null ||\n                                                    vm.verifytxVob.inNetwork.outPocketRemaining !== null"><div class="graph-pie"><div class="graph"><nvd3 style="display: block" options="vm.chartOptsInPocket" data="vm.chartDataInPocket"></nvd3></div><div class="custom-legend"><ul class="list-unstyled legend-list"><li class="legend-item"><span class="text">{{vm.verifytxVob.inNetwork.outPocketTotalName}}: </span><span class="number">{{vm.verifytxVob.inNetwork.outPocketTotalName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.outPocketCalendarYear | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.inNetwork.outPocketAmountName}}: </span><span class="number">{{vm.verifytxVob.inNetwork.outPocketAmountName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.outPocketYearToDate | currency) : \'-\'}}</span></li><li class="legend-item"><span class="text">{{vm.verifytxVob.inNetwork.outPocketRemainingName}}: </span><span class="number">{{vm.verifytxVob.inNetwork.outPocketRemainingName !== \'Not Available\' ? (vm.verifytxVob.inNetwork.outPocketRemaining | currency) : \'-\'}}</span></li></ul></div></div></div><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.outPocketCalendarYear === null &&\n                                                    vm.verifytxVob.inNetwork.outPocketYearToDate === null &&\n                                                    vm.verifytxVob.inNetwork.outPocketRemaining === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div><div class="section"><h5>Co-Payment</h5><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.coPaymentAmount !== null && vm.verifytxVob.inNetwork.coPaymentTimePeriod !== null"><h4 class="text-center"><strong>{{vm.verifytxVob.inNetwork.coPaymentAmount | currency}}</strong> {{vm.verifytxVob.inNetwork.coPaymentTimePeriod}}</h4></div><div class="content-graph" ng-if="vm.verifytxVob.inNetwork.coPaymentAmount === null || vm.verifytxVob.inNetwork.coPaymentTimePeriod === null"><h4 class="text-center">NOT AVAILABLE</h4></div></div></div></div></div><footer class="item-footer" ng-if="vm.isApplicable === true"><div class="fleft"><button type="button" class="button-link" ng-if="vm.verifytxVob === null" ng-click="vm.newVerify()">New <i class="fa fa-plus-circle" aria-hidden="true"></i></button> <button type="button" class="button-link" ng-if="vm.verifytxVob !== null" ng-disabled="vm.isSaving" ng-click="vm.verify()">Verify <i class="fa fa-refresh" aria-hidden="true"></i></button></div><div class="fright" ng-if="vm.verifytxVob !== null"><button type="button" class="button-link" ng-click="vm.showHistory()">History <i class="fa fa-list" aria-hidden="true"></i></button></div></footer>');}]);})();